var doe = Object.defineProperty;
var uoe = (e, t, i) => t in e ? doe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var Qi = (e, t, i) => (uoe(e, typeof t != "symbol" ? t + "" : t, i), i), gL = (e, t, i) => {
  if (!t.has(e))
    throw TypeError("Cannot " + i);
};
var oL = (e, t, i) => (gL(e, t, "read from private field"), i ? i.call(e) : t.get(e)), lL = (e, t, i) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, i);
}, aL = (e, t, i, n) => (gL(e, t, "write to private field"), n ? n.call(e, i) : t.set(e, i), i);
import "./style.css";
import * as Bf from "react/jsx-runtime";
import ro, { jsx as ee, jsxs as Ri } from "react/jsx-runtime";
import * as X from "react";
import De, { forwardRef as dl, useContext as Vn, Children as p4, isValidElement as KB, cloneElement as Jd, createElement as PC, createContext as Ua, useState as wt, useRef as ot, useEffect as lt, useCallback as Gt, useMemo as Oe, Component as Coe, useLayoutEffect as lZ, memo as Bm, lazy as _o, Suspense as fm, useReducer as aZ } from "react";
import Aoe from "@emotion/styled";
import { CacheProvider as boe, Global as hoe, ThemeContext as SD, css as Od, keyframes as Ds, ThemeProvider as moe, createElement as B4 } from "@emotion/react";
import * as f4 from "react-dom";
import ZB, { createPortal as Z4, unstable_batchedUpdates as Vh } from "react-dom";
import * as ir from "three";
import { Vector3 as ye, MeshStandardMaterial as o2, Box3 as fg, Plane as xC, Line3 as Nl, Quaternion as G4, Euler as VD, BufferAttribute as sZ, Vector2 as fc, Triangle as Fl, Sphere as poe, Matrix4 as ks, BackSide as Boe, DoubleSide as wD, FrontSide as sL, Ray as y4, Vector4 as cA, Mesh as foe, Matrix3 as Zoe, BufferGeometry as Goe, PerspectiveCamera as W4, OrthographicCamera as Ix, MathUtils as GB, Box3Helper as yoe, Color as Woe, LineBasicMaterial as Soe } from "three";
import * as Voe from "@react-three/drei";
import { RoundedBox as woe, Box as voe, Line as iV, Text as Roe, useGLTF as Xoe, PivotControls as Hoe, useContextBridge as koe, useBounds as Yoe, useProgress as S4, Html as Foe } from "@react-three/drei";
import * as xoe from "@react-three/fiber";
import { useThree as RI, useFrame as dA, extend as Doe, Canvas as V4 } from "@react-three/fiber";
import * as Joe from "@react-three/postprocessing";
function Eoe(e, t) {
  for (var i = 0; i < t.length; i++) {
    const n = t[i];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const r in n)
        if (r !== "default" && !(r in e)) {
          const g = Object.getOwnPropertyDescriptor(n, r);
          g && Object.defineProperty(e, r, g.get ? g : {
            enumerable: !0,
            get: () => n[r]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
const Noe = "10.3.4", w7t = "3.20.5", hs = (e) => {
  var t, i;
  return (
    // @ts-ignore
    ((t = import.meta.env) == null ? void 0 : t[`VITE_${e}`]) || ((i = process.env) == null ? void 0 : i[`REACT_APP_${e}`])
  );
}, yW = (e) => {
  throw new Error(`environment variable ${e} not provided.`);
}, sl = {
  /** The URL of the API */
  apiUrl: hs("API_URL") || yW("API_URL"),
  /** The Analytics key for the Admin Analytics. Only provide this in Frontend */
  adminAnalytics: hs("ADMIN_ANALYTICS") || null,
  /** The URL of the docs */
  helpUrl: hs("HELP_URL") || yW("HELP_URL"),
  /** The URL of the default topic in the help documentation */
  defaultHelpTopicUrl: hs("DEFAULT_HELP_TOPIC_URL") ?? "/docs/user",
  /** The URL of assets not shipped by the API */
  docUrl: hs("DOC_URL") || yW("DOC_URL"),
  /* Key for bugsnag exception tracking or null */
  bugsnagKey: hs("BUGSNAG_KEY") || null,
  /** The Draco compression lib url */
  libsUrl: hs("LIBS_URL") || yW("LIBS_URL"),
  disable3D: hs("DISABLE_3D") || !1,
  originalDomain: hs("ORIGINAL_DOMAIN") || "k3.objectcode.de",
  enableReduxDevChecks: hs("ENABLE_REDUX_DEV_CHECKS") || !1,
  shopifyLinkId: hs("SHOPIFY_K3_LINK_ID") || null
}, Ut = {
  id: "",
  instance: {
    id: "",
    isInstanceLauncher: !0,
    belongsToInstanceId: "",
    belongsToVariableId: null,
    hierarchyLevel: 0
  },
  variableId: null,
  valueId: 0
};
function Loe(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Koe(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Toe = /* @__PURE__ */ function() {
  function e(i) {
    var n = this;
    this._insertTag = function(r) {
      var g;
      n.tags.length === 0 ? n.insertionPoint ? g = n.insertionPoint.nextSibling : n.prepend ? g = n.container.firstChild : g = n.before : g = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(r, g), n.tags.push(r);
    }, this.isSpeedy = i.speedy === void 0 ? !0 : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Koe(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var g = Loe(r);
      try {
        g.insertRule(n, g.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), $g = "-ms-", xV = "-moz-", un = "-webkit-", w4 = "comm", vD = "rule", RD = "decl", Moe = "@import", v4 = "@keyframes", Poe = "@layer", Uoe = Math.abs, l2 = String.fromCharCode, zoe = Object.assign;
function Ooe(e, t) {
  return Lg(e, 0) ^ 45 ? (((t << 2 ^ Lg(e, 0)) << 2 ^ Lg(e, 1)) << 2 ^ Lg(e, 2)) << 2 ^ Lg(e, 3) : 0;
}
function R4(e) {
  return e.trim();
}
function Qoe(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Cn(e, t, i) {
  return e.replace(t, i);
}
function cx(e, t) {
  return e.indexOf(t);
}
function Lg(e, t) {
  return e.charCodeAt(t) | 0;
}
function ff(e, t, i) {
  return e.slice(t, i);
}
function aI(e) {
  return e.length;
}
function XD(e) {
  return e.length;
}
function WW(e, t) {
  return t.push(e), e;
}
function joe(e, t) {
  return e.map(t).join("");
}
var a2 = 1, $h = 1, X4 = 0, Il = 0, xr = 0, Zm = "";
function s2(e, t, i, n, r, g, o) {
  return { value: e, root: t, parent: i, type: n, props: r, children: g, line: a2, column: $h, length: o, return: "" };
}
function T0(e, t) {
  return zoe(s2("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function qoe() {
  return xr;
}
function _oe() {
  return xr = Il > 0 ? Lg(Zm, --Il) : 0, $h--, xr === 10 && ($h = 1, a2--), xr;
}
function Ll() {
  return xr = Il < X4 ? Lg(Zm, Il++) : 0, $h++, xr === 10 && ($h = 1, a2++), xr;
}
function hI() {
  return Lg(Zm, Il);
}
function nV() {
  return Il;
}
function IZ(e, t) {
  return ff(Zm, e, t);
}
function Zf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function H4(e) {
  return a2 = $h = 1, X4 = aI(Zm = e), Il = 0, [];
}
function k4(e) {
  return Zm = "", e;
}
function rV(e) {
  return R4(IZ(Il - 1, dx(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $oe(e) {
  for (; (xr = hI()) && xr < 33; )
    Ll();
  return Zf(e) > 2 || Zf(xr) > 3 ? "" : " ";
}
function ele(e, t) {
  for (; --t && Ll() && !(xr < 48 || xr > 102 || xr > 57 && xr < 65 || xr > 70 && xr < 97); )
    ;
  return IZ(e, nV() + (t < 6 && hI() == 32 && Ll() == 32));
}
function dx(e) {
  for (; Ll(); )
    switch (xr) {
      case e:
        return Il;
      case 34:
      case 39:
        e !== 34 && e !== 39 && dx(xr);
        break;
      case 40:
        e === 41 && dx(e);
        break;
      case 92:
        Ll();
        break;
    }
  return Il;
}
function tle(e, t) {
  for (; Ll() && e + xr !== 57; )
    if (e + xr === 84 && hI() === 47)
      break;
  return "/*" + IZ(t, Il - 1) + "*" + l2(e === 47 ? e : Ll());
}
function ile(e) {
  for (; !Zf(hI()); )
    Ll();
  return IZ(e, Il);
}
function nle(e) {
  return k4(gV("", null, null, null, [""], e = H4(e), 0, [0], e));
}
function gV(e, t, i, n, r, g, o, l, a) {
  for (var I = 0, c = 0, d = o, C = 0, A = 0, b = 0, m = 1, p = 1, B = 1, f = 0, Z = "", y = r, W = g, V = n, w = Z; p; )
    switch (b = f, f = Ll()) {
      case 40:
        if (b != 108 && Lg(w, d - 1) == 58) {
          cx(w += Cn(rV(f), "&", "&\f"), "&\f") != -1 && (B = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        w += rV(f);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        w += $oe(b);
        break;
      case 92:
        w += ele(nV() - 1, 7);
        continue;
      case 47:
        switch (hI()) {
          case 42:
          case 47:
            WW(rle(tle(Ll(), nV()), t, i), a);
            break;
          default:
            w += "/";
        }
        break;
      case 123 * m:
        l[I++] = aI(w) * B;
      case 125 * m:
      case 59:
      case 0:
        switch (f) {
          case 0:
          case 125:
            p = 0;
          case 59 + c:
            B == -1 && (w = Cn(w, /\f/g, "")), A > 0 && aI(w) - d && WW(A > 32 ? cL(w + ";", n, i, d - 1) : cL(Cn(w, " ", "") + ";", n, i, d - 2), a);
            break;
          case 59:
            w += ";";
          default:
            if (WW(V = IL(w, t, i, I, c, r, l, Z, y = [], W = [], d), g), f === 123)
              if (c === 0)
                gV(w, t, V, V, y, g, d, l, W);
              else
                switch (C === 99 && Lg(w, 3) === 110 ? 100 : C) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    gV(e, V, V, n && WW(IL(e, V, V, 0, 0, r, l, Z, r, y = [], d), W), r, W, d, l, n ? y : W);
                    break;
                  default:
                    gV(w, V, V, V, [""], W, 0, l, W);
                }
        }
        I = c = A = 0, m = B = 1, Z = w = "", d = o;
        break;
      case 58:
        d = 1 + aI(w), A = b;
      default:
        if (m < 1) {
          if (f == 123)
            --m;
          else if (f == 125 && m++ == 0 && _oe() == 125)
            continue;
        }
        switch (w += l2(f), f * m) {
          case 38:
            B = c > 0 ? 1 : (w += "\f", -1);
            break;
          case 44:
            l[I++] = (aI(w) - 1) * B, B = 1;
            break;
          case 64:
            hI() === 45 && (w += rV(Ll())), C = hI(), c = d = aI(Z = w += ile(nV())), f++;
            break;
          case 45:
            b === 45 && aI(w) == 2 && (m = 0);
        }
    }
  return g;
}
function IL(e, t, i, n, r, g, o, l, a, I, c) {
  for (var d = r - 1, C = r === 0 ? g : [""], A = XD(C), b = 0, m = 0, p = 0; b < n; ++b)
    for (var B = 0, f = ff(e, d + 1, d = Uoe(m = o[b])), Z = e; B < A; ++B)
      (Z = R4(m > 0 ? C[B] + " " + f : Cn(f, /&\f/g, C[B]))) && (a[p++] = Z);
  return s2(e, t, i, r === 0 ? vD : l, a, I, c);
}
function rle(e, t, i) {
  return s2(e, t, i, w4, l2(qoe()), ff(e, 2, -2), 0);
}
function cL(e, t, i, n) {
  return s2(e, t, i, RD, ff(e, 0, n), ff(e, n + 1, -1), n);
}
function Mh(e, t) {
  for (var i = "", n = XD(e), r = 0; r < n; r++)
    i += t(e[r], r, e, t) || "";
  return i;
}
function gle(e, t, i, n) {
  switch (e.type) {
    case Poe:
      if (e.children.length)
        break;
    case Moe:
    case RD:
      return e.return = e.return || e.value;
    case w4:
      return "";
    case v4:
      return e.return = e.value + "{" + Mh(e.children, n) + "}";
    case vD:
      e.value = e.props.join(",");
  }
  return aI(i = Mh(e.children, n)) ? e.return = e.value + "{" + i + "}" : "";
}
function ole(e) {
  var t = XD(e);
  return function(i, n, r, g) {
    for (var o = "", l = 0; l < t; l++)
      o += e[l](i, n, r, g) || "";
    return o;
  };
}
function lle(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function ale(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return t[i] === void 0 && (t[i] = e(i)), t[i];
  };
}
var sle = function(t, i, n) {
  for (var r = 0, g = 0; r = g, g = hI(), r === 38 && g === 12 && (i[n] = 1), !Zf(g); )
    Ll();
  return IZ(t, Il);
}, Ile = function(t, i) {
  var n = -1, r = 44;
  do
    switch (Zf(r)) {
      case 0:
        r === 38 && hI() === 12 && (i[n] = 1), t[n] += sle(Il - 1, i, n);
        break;
      case 2:
        t[n] += rV(r);
        break;
      case 4:
        if (r === 44) {
          t[++n] = hI() === 58 ? "&\f" : "", i[n] = t[n].length;
          break;
        }
      default:
        t[n] += l2(r);
    }
  while (r = Ll());
  return t;
}, cle = function(t, i) {
  return k4(Ile(H4(t), i));
}, dL = /* @__PURE__ */ new WeakMap(), dle = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var i = t.value, n = t.parent, r = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(t.props.length === 1 && i.charCodeAt(0) !== 58 && !dL.get(n)) && !r) {
      dL.set(t, !0);
      for (var g = [], o = cle(i, g), l = n.props, a = 0, I = 0; a < o.length; a++)
        for (var c = 0; c < l.length; c++, I++)
          t.props[I] = g[a] ? o[a].replace(/&\f/g, l[c]) : l[c] + " " + o[a];
    }
  }
}, ule = function(t) {
  if (t.type === "decl") {
    var i = t.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Y4(e, t) {
  switch (Ooe(e, t)) {
    case 5103:
      return un + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return un + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return un + e + xV + e + $g + e + e;
    case 6828:
    case 4268:
      return un + e + $g + e + e;
    case 6165:
      return un + e + $g + "flex-" + e + e;
    case 5187:
      return un + e + Cn(e, /(\w+).+(:[^]+)/, un + "box-$1$2" + $g + "flex-$1$2") + e;
    case 5443:
      return un + e + $g + "flex-item-" + Cn(e, /flex-|-self/, "") + e;
    case 4675:
      return un + e + $g + "flex-line-pack" + Cn(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return un + e + $g + Cn(e, "shrink", "negative") + e;
    case 5292:
      return un + e + $g + Cn(e, "basis", "preferred-size") + e;
    case 6060:
      return un + "box-" + Cn(e, "-grow", "") + un + e + $g + Cn(e, "grow", "positive") + e;
    case 4554:
      return un + Cn(e, /([^-])(transform)/g, "$1" + un + "$2") + e;
    case 6187:
      return Cn(Cn(Cn(e, /(zoom-|grab)/, un + "$1"), /(image-set)/, un + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Cn(e, /(image-set\([^]*)/, un + "$1$`$1");
    case 4968:
      return Cn(Cn(e, /(.+:)(flex-)?(.*)/, un + "box-pack:$3" + $g + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + un + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Cn(e, /(.+)-inline(.+)/, un + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (aI(e) - 1 - t > 6)
        switch (Lg(e, t + 1)) {
          case 109:
            if (Lg(e, t + 4) !== 45)
              break;
          case 102:
            return Cn(e, /(.+:)(.+)-([^]+)/, "$1" + un + "$2-$3$1" + xV + (Lg(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~cx(e, "stretch") ? Y4(Cn(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Lg(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Lg(e, aI(e) - 3 - (~cx(e, "!important") && 10))) {
        case 107:
          return Cn(e, ":", ":" + un) + e;
        case 101:
          return Cn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + un + (Lg(e, 14) === 45 ? "inline-" : "") + "box$3$1" + un + "$2$3$1" + $g + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Lg(e, t + 11)) {
        case 114:
          return un + e + $g + Cn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return un + e + $g + Cn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return un + e + $g + Cn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return un + e + $g + e + e;
  }
  return e;
}
var Cle = function(t, i, n, r) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case RD:
        t.return = Y4(t.value, t.length);
        break;
      case v4:
        return Mh([T0(t, {
          value: Cn(t.value, "@", "@" + un)
        })], r);
      case vD:
        if (t.length)
          return joe(t.props, function(g) {
            switch (Qoe(g, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Mh([T0(t, {
                  props: [Cn(g, /:(read-\w+)/, ":" + xV + "$1")]
                })], r);
              case "::placeholder":
                return Mh([T0(t, {
                  props: [Cn(g, /:(plac\w+)/, ":" + un + "input-$1")]
                }), T0(t, {
                  props: [Cn(g, /:(plac\w+)/, ":" + xV + "$1")]
                }), T0(t, {
                  props: [Cn(g, /:(plac\w+)/, $g + "input-$1")]
                })], r);
            }
            return "";
          });
    }
}, Ale = [Cle], F4 = function(t) {
  var i = t.key;
  if (i === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(m) {
      var p = m.getAttribute("data-emotion");
      p.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || Ale, g = {}, o, l = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(m) {
      for (var p = m.getAttribute("data-emotion").split(" "), B = 1; B < p.length; B++)
        g[p[B]] = !0;
      l.push(m);
    }
  );
  var a, I = [dle, ule];
  {
    var c, d = [gle, lle(function(m) {
      c.insert(m);
    })], C = ole(I.concat(r, d)), A = function(p) {
      return Mh(nle(p), C);
    };
    a = function(p, B, f, Z) {
      c = f, A(p ? p + "{" + B.styles + "}" : B.styles), Z && (b.inserted[B.name] = !0);
    };
  }
  var b = {
    key: i,
    sheet: new Toe({
      key: i,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: g,
    registered: {},
    insert: a
  };
  return b.sheet.hydrate(l), b;
};
function et() {
  return et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        ({}).hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, et.apply(null, arguments);
}
var Or = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function go(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function wc(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var i = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var r = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(i, n, r.get ? r : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), i;
}
var x4 = { exports: {} }, wn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gg = typeof Symbol == "function" && Symbol.for, HD = Gg ? Symbol.for("react.element") : 60103, kD = Gg ? Symbol.for("react.portal") : 60106, I2 = Gg ? Symbol.for("react.fragment") : 60107, c2 = Gg ? Symbol.for("react.strict_mode") : 60108, d2 = Gg ? Symbol.for("react.profiler") : 60114, u2 = Gg ? Symbol.for("react.provider") : 60109, C2 = Gg ? Symbol.for("react.context") : 60110, YD = Gg ? Symbol.for("react.async_mode") : 60111, A2 = Gg ? Symbol.for("react.concurrent_mode") : 60111, b2 = Gg ? Symbol.for("react.forward_ref") : 60112, h2 = Gg ? Symbol.for("react.suspense") : 60113, ble = Gg ? Symbol.for("react.suspense_list") : 60120, m2 = Gg ? Symbol.for("react.memo") : 60115, p2 = Gg ? Symbol.for("react.lazy") : 60116, hle = Gg ? Symbol.for("react.block") : 60121, mle = Gg ? Symbol.for("react.fundamental") : 60117, ple = Gg ? Symbol.for("react.responder") : 60118, Ble = Gg ? Symbol.for("react.scope") : 60119;
function jl(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case HD:
        switch (e = e.type, e) {
          case YD:
          case A2:
          case I2:
          case d2:
          case c2:
          case h2:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case C2:
              case b2:
              case p2:
              case m2:
              case u2:
                return e;
              default:
                return t;
            }
        }
      case kD:
        return t;
    }
  }
}
function D4(e) {
  return jl(e) === A2;
}
wn.AsyncMode = YD;
wn.ConcurrentMode = A2;
wn.ContextConsumer = C2;
wn.ContextProvider = u2;
wn.Element = HD;
wn.ForwardRef = b2;
wn.Fragment = I2;
wn.Lazy = p2;
wn.Memo = m2;
wn.Portal = kD;
wn.Profiler = d2;
wn.StrictMode = c2;
wn.Suspense = h2;
wn.isAsyncMode = function(e) {
  return D4(e) || jl(e) === YD;
};
wn.isConcurrentMode = D4;
wn.isContextConsumer = function(e) {
  return jl(e) === C2;
};
wn.isContextProvider = function(e) {
  return jl(e) === u2;
};
wn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === HD;
};
wn.isForwardRef = function(e) {
  return jl(e) === b2;
};
wn.isFragment = function(e) {
  return jl(e) === I2;
};
wn.isLazy = function(e) {
  return jl(e) === p2;
};
wn.isMemo = function(e) {
  return jl(e) === m2;
};
wn.isPortal = function(e) {
  return jl(e) === kD;
};
wn.isProfiler = function(e) {
  return jl(e) === d2;
};
wn.isStrictMode = function(e) {
  return jl(e) === c2;
};
wn.isSuspense = function(e) {
  return jl(e) === h2;
};
wn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === I2 || e === A2 || e === d2 || e === c2 || e === h2 || e === ble || typeof e == "object" && e !== null && (e.$$typeof === p2 || e.$$typeof === m2 || e.$$typeof === u2 || e.$$typeof === C2 || e.$$typeof === b2 || e.$$typeof === mle || e.$$typeof === ple || e.$$typeof === Ble || e.$$typeof === hle);
};
wn.typeOf = jl;
x4.exports = wn;
var fle = x4.exports, FD = fle, Zle = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Gle = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, yle = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, J4 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, xD = {};
xD[FD.ForwardRef] = yle;
xD[FD.Memo] = J4;
function uL(e) {
  return FD.isMemo(e) ? J4 : xD[e.$$typeof] || Zle;
}
var Wle = Object.defineProperty, Sle = Object.getOwnPropertyNames, CL = Object.getOwnPropertySymbols, Vle = Object.getOwnPropertyDescriptor, wle = Object.getPrototypeOf, AL = Object.prototype;
function E4(e, t, i) {
  if (typeof t != "string") {
    if (AL) {
      var n = wle(t);
      n && n !== AL && E4(e, n, i);
    }
    var r = Sle(t);
    CL && (r = r.concat(CL(t)));
    for (var g = uL(e), o = uL(t), l = 0; l < r.length; ++l) {
      var a = r[l];
      if (!Gle[a] && !(i && i[a]) && !(o && o[a]) && !(g && g[a])) {
        var I = Vle(t, a);
        try {
          Wle(e, a, I);
        } catch {
        }
      }
    }
  }
  return e;
}
var vle = E4;
const bL = /* @__PURE__ */ go(vle);
var Rle = !0;
function Xle(e, t, i) {
  var n = "";
  return i.split(" ").forEach(function(r) {
    e[r] !== void 0 ? t.push(e[r] + ";") : n += r + " ";
  }), n;
}
var N4 = function(t, i, n) {
  var r = t.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Rle === !1) && t.registered[r] === void 0 && (t.registered[r] = i.styles);
}, Hle = function(t, i, n) {
  N4(t, i, n);
  var r = t.key + "-" + i.name;
  if (t.inserted[i.name] === void 0) {
    var g = i;
    do
      t.insert(i === g ? "." + r : "", g, t.sheet, !0), g = g.next;
    while (g !== void 0);
  }
};
function kle(e) {
  for (var t = 0, i, n = 0, r = e.length; r >= 4; ++n, r -= 4)
    i = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, t = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (r) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Yle = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Fle = /[A-Z]|^ms/g, xle = /_EMO_([^_]+?)_([^]*?)_EMO_/g, L4 = function(t) {
  return t.charCodeAt(1) === 45;
}, hL = function(t) {
  return t != null && typeof t != "boolean";
}, _k = /* @__PURE__ */ ale(function(e) {
  return L4(e) ? e : e.replace(Fle, "-$&").toLowerCase();
}), mL = function(t, i) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(xle, function(n, r, g) {
          return sI = {
            name: r,
            styles: g,
            next: sI
          }, r;
        });
  }
  return Yle[t] !== 1 && !L4(t) && typeof i == "number" && i !== 0 ? i + "px" : i;
};
function Gf(e, t, i) {
  if (i == null)
    return "";
  if (i.__emotion_styles !== void 0)
    return i;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      if (i.anim === 1)
        return sI = {
          name: i.name,
          styles: i.styles,
          next: sI
        }, i.name;
      if (i.styles !== void 0) {
        var n = i.next;
        if (n !== void 0)
          for (; n !== void 0; )
            sI = {
              name: n.name,
              styles: n.styles,
              next: sI
            }, n = n.next;
        var r = i.styles + ";";
        return r;
      }
      return Dle(e, t, i);
    }
    case "function": {
      if (e !== void 0) {
        var g = sI, o = i(e);
        return sI = g, Gf(e, t, o);
      }
      break;
    }
  }
  return i;
}
function Dle(e, t, i) {
  var n = "";
  if (Array.isArray(i))
    for (var r = 0; r < i.length; r++)
      n += Gf(e, t, i[r]) + ";";
  else
    for (var g in i) {
      var o = i[g];
      if (typeof o != "object")
        hL(o) && (n += _k(g) + ":" + mL(g, o) + ";");
      else if (Array.isArray(o) && typeof o[0] == "string" && t == null)
        for (var l = 0; l < o.length; l++)
          hL(o[l]) && (n += _k(g) + ":" + mL(g, o[l]) + ";");
      else {
        var a = Gf(e, t, o);
        switch (g) {
          case "animation":
          case "animationName": {
            n += _k(g) + ":" + a + ";";
            break;
          }
          default:
            n += g + "{" + a + "}";
        }
      }
    }
  return n;
}
var pL = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sI, Jle = function(t, i, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var r = !0, g = "";
  sI = void 0;
  var o = t[0];
  o == null || o.raw === void 0 ? (r = !1, g += Gf(n, i, o)) : g += o[0];
  for (var l = 1; l < t.length; l++)
    g += Gf(n, i, t[l]), r && (g += o[l]);
  pL.lastIndex = 0;
  for (var a = "", I; (I = pL.exec(g)) !== null; )
    a += "-" + // $FlowFixMe we know it's not null
    I[1];
  var c = kle(g) + a;
  return {
    name: c,
    styles: g,
    next: sI
  };
}, Ele = function(t) {
  return t();
}, Nle = X.useInsertionEffect ? X.useInsertionEffect : !1, Lle = Nle || Ele, B2 = {}.hasOwnProperty, K4 = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ F4({
    key: "css"
  }) : null
);
K4.Provider;
var Kle = function(t) {
  return /* @__PURE__ */ dl(function(i, n) {
    var r = Vn(K4);
    return t(i, r, n);
  });
}, Tle = /* @__PURE__ */ X.createContext({}), ux = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", T4 = function(t, i) {
  var n = {};
  for (var r in i)
    B2.call(i, r) && (n[r] = i[r]);
  return n[ux] = t, n;
}, Mle = function(t) {
  var i = t.cache, n = t.serialized, r = t.isStringTag;
  return N4(i, n, r), Lle(function() {
    return Hle(i, n, r);
  }), null;
}, Ple = /* @__PURE__ */ Kle(function(e, t, i) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var r = e[ux], g = [n], o = "";
  typeof e.className == "string" ? o = Xle(t.registered, g, e.className) : e.className != null && (o = e.className + " ");
  var l = Jle(g, void 0, X.useContext(Tle));
  o += t.key + "-" + l.name;
  var a = {};
  for (var I in e)
    B2.call(e, I) && I !== "css" && I !== ux && (a[I] = e[I]);
  return a.ref = i, a.className = o, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Mle, {
    cache: t,
    serialized: l,
    isStringTag: typeof r == "string"
  }), /* @__PURE__ */ X.createElement(r, a));
}), M4 = Ple, li = Bf.Fragment;
function S(e, t, i) {
  return B2.call(t, "css") ? Bf.jsx(M4, T4(e, t), i) : Bf.jsx(e, t, i);
}
function Ie(e, t, i) {
  return B2.call(t, "css") ? Bf.jsxs(M4, T4(e, t), i) : Bf.jsxs(e, t, i);
}
function Rs(e) {
  "@babel/helpers - typeof";
  return Rs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Rs(e);
}
function Js(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ule(e, t) {
  if (Rs(e) != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t || "default");
    if (Rs(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function P4(e) {
  var t = Ule(e, "string");
  return Rs(t) == "symbol" ? t : t + "";
}
function BL(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P4(n.key), n);
  }
}
function Es(e, t, i) {
  return t && BL(e.prototype, t), i && BL(e, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ed(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DV(e, t) {
  return DV = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, DV(e, t);
}
function f2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && DV(e, t);
}
function cZ(e, t) {
  if (t && (Rs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ed(e);
}
function GI(e) {
  return GI = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, GI(e);
}
function XI(e, t, i) {
  return t = P4(t), t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function U4(e) {
  if (Array.isArray(e))
    return e;
}
function zle(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function fL(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = new Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function z4(e, t) {
  if (e) {
    if (typeof e == "string")
      return fL(e, t);
    var i = Object.prototype.toString.call(e).slice(8, -1);
    if (i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set")
      return Array.from(e);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
      return fL(e, t);
  }
}
function O4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ole(e) {
  return U4(e) || zle(e) || z4(e) || O4();
}
function ZL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function GL(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ZL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : ZL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var Qle = {
  type: "logger",
  log: function(t) {
    this.output("log", t);
  },
  warn: function(t) {
    this.output("warn", t);
  },
  error: function(t) {
    this.output("error", t);
  },
  output: function(t, i) {
    console && console[t] && console[t].apply(console, i);
  }
}, jle = function() {
  function e(t) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Js(this, e), this.init(t, i);
  }
  return Es(e, [{
    key: "init",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      this.prefix = n.prefix || "i18next:", this.logger = i || Qle, this.options = n, this.debug = n.debug;
    }
  }, {
    key: "setDebug",
    value: function(i) {
      this.debug = i;
    }
  }, {
    key: "log",
    value: function() {
      for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
        n[r] = arguments[r];
      return this.forward(n, "log", "", !0);
    }
  }, {
    key: "warn",
    value: function() {
      for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
        n[r] = arguments[r];
      return this.forward(n, "warn", "", !0);
    }
  }, {
    key: "error",
    value: function() {
      for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
        n[r] = arguments[r];
      return this.forward(n, "error", "");
    }
  }, {
    key: "deprecate",
    value: function() {
      for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
        n[r] = arguments[r];
      return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
    }
  }, {
    key: "forward",
    value: function(i, n, r, g) {
      return g && !this.debug ? null : (typeof i[0] == "string" && (i[0] = "".concat(r).concat(this.prefix, " ").concat(i[0])), this.logger[n](i));
    }
  }, {
    key: "create",
    value: function(i) {
      return new e(this.logger, GL(GL({}, {
        prefix: "".concat(this.prefix, ":").concat(i, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function(i) {
      return i = i || this.options, i.prefix = i.prefix || this.prefix, new e(this.logger, i);
    }
  }]), e;
}(), dI = new jle(), Qd = function() {
  function e() {
    Js(this, e), this.observers = {};
  }
  return Es(e, [{
    key: "on",
    value: function(i, n) {
      var r = this;
      return i.split(" ").forEach(function(g) {
        r.observers[g] = r.observers[g] || [], r.observers[g].push(n);
      }), this;
    }
  }, {
    key: "off",
    value: function(i, n) {
      if (this.observers[i]) {
        if (!n) {
          delete this.observers[i];
          return;
        }
        this.observers[i] = this.observers[i].filter(function(r) {
          return r !== n;
        });
      }
    }
  }, {
    key: "emit",
    value: function(i) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), g = 1; g < n; g++)
        r[g - 1] = arguments[g];
      if (this.observers[i]) {
        var o = [].concat(this.observers[i]);
        o.forEach(function(a) {
          a.apply(void 0, r);
        });
      }
      if (this.observers["*"]) {
        var l = [].concat(this.observers["*"]);
        l.forEach(function(a) {
          a.apply(a, [i].concat(r));
        });
      }
    }
  }]), e;
}();
function M0() {
  var e, t, i = new Promise(function(n, r) {
    e = n, t = r;
  });
  return i.resolve = e, i.reject = t, i;
}
function yL(e) {
  return e == null ? "" : "" + e;
}
function qle(e, t, i) {
  e.forEach(function(n) {
    t[n] && (i[n] = t[n]);
  });
}
function DD(e, t, i) {
  function n(l) {
    return l && l.indexOf("###") > -1 ? l.replace(/###/g, ".") : l;
  }
  function r() {
    return !e || typeof e == "string";
  }
  for (var g = typeof t != "string" ? [].concat(t) : t.split("."); g.length > 1; ) {
    if (r())
      return {};
    var o = n(g.shift());
    !e[o] && i && (e[o] = new i()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {};
  }
  return r() ? {} : {
    obj: e,
    k: n(g.shift())
  };
}
function WL(e, t, i) {
  var n = DD(e, t, Object), r = n.obj, g = n.k;
  r[g] = i;
}
function _le(e, t, i, n) {
  var r = DD(e, t, Object), g = r.obj, o = r.k;
  g[o] = g[o] || [], g[o].push(i);
}
function JV(e, t) {
  var i = DD(e, t), n = i.obj, r = i.k;
  if (n)
    return n[r];
}
function SL(e, t, i) {
  var n = JV(e, i);
  return n !== void 0 ? n : JV(t, i);
}
function Q4(e, t, i) {
  for (var n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? typeof e[n] == "string" || e[n] instanceof String || typeof t[n] == "string" || t[n] instanceof String ? i && (e[n] = t[n]) : Q4(e[n], t[n], i) : e[n] = t[n]);
  return e;
}
function jb(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $le = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function eae(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, function(t) {
    return $le[t];
  }) : e;
}
var Z2 = typeof window < "u" && window.navigator && typeof window.navigator.userAgentData > "u" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1, tae = [" ", ",", "?", "!", ";"];
function iae(e, t, i) {
  t = t || "", i = i || "";
  var n = tae.filter(function(l) {
    return t.indexOf(l) < 0 && i.indexOf(l) < 0;
  });
  if (n.length === 0)
    return !0;
  var r = new RegExp("(".concat(n.map(function(l) {
    return l === "?" ? "\\?" : l;
  }).join("|"), ")")), g = !r.test(e);
  if (!g) {
    var o = e.indexOf(i);
    o > 0 && !r.test(e.substring(0, o)) && (g = !0);
  }
  return g;
}
function VL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function SW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : VL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function nae(e) {
  var t = rae();
  return function() {
    var n = GI(e), r;
    if (t) {
      var g = GI(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return cZ(this, r);
  };
}
function rae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function j4(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (e) {
    if (e[t])
      return e[t];
    for (var n = t.split(i), r = e, g = 0; g < n.length; ++g) {
      if (!r || typeof r[n[g]] == "string" && g + 1 < n.length)
        return;
      if (r[n[g]] === void 0) {
        for (var o = 2, l = n.slice(g, g + o).join(i), a = r[l]; a === void 0 && n.length > g + o; )
          o++, l = n.slice(g, g + o).join(i), a = r[l];
        if (a === void 0)
          return;
        if (a === null)
          return null;
        if (t.endsWith(l)) {
          if (typeof a == "string")
            return a;
          if (l && typeof a[l] == "string")
            return a[l];
        }
        var I = n.slice(g + o).join(i);
        return I ? j4(a, I, i) : void 0;
      }
      r = r[n[g]];
    }
    return r;
  }
}
var gae = function(e) {
  f2(i, e);
  var t = nae(i);
  function i(n) {
    var r, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    return Js(this, i), r = t.call(this), Z2 && Qd.call(Ed(r)), r.data = n || {}, r.options = g, r.options.keySeparator === void 0 && (r.options.keySeparator = "."), r.options.ignoreJSONStructure === void 0 && (r.options.ignoreJSONStructure = !0), r;
  }
  return Es(i, [{
    key: "addNamespaces",
    value: function(r) {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }
  }, {
    key: "removeNamespaces",
    value: function(r) {
      var g = this.options.ns.indexOf(r);
      g > -1 && this.options.ns.splice(g, 1);
    }
  }, {
    key: "getResource",
    value: function(r, g, o) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = l.keySeparator !== void 0 ? l.keySeparator : this.options.keySeparator, I = l.ignoreJSONStructure !== void 0 ? l.ignoreJSONStructure : this.options.ignoreJSONStructure, c = [r, g];
      o && typeof o != "string" && (c = c.concat(o)), o && typeof o == "string" && (c = c.concat(a ? o.split(a) : o)), r.indexOf(".") > -1 && (c = r.split("."));
      var d = JV(this.data, c);
      return d || !I || typeof o != "string" ? d : j4(this.data && this.data[r] && this.data[r][g], o, a);
    }
  }, {
    key: "addResource",
    value: function(r, g, o, l) {
      var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        silent: !1
      }, I = this.options.keySeparator;
      I === void 0 && (I = ".");
      var c = [r, g];
      o && (c = c.concat(I ? o.split(I) : o)), r.indexOf(".") > -1 && (c = r.split("."), l = g, g = c[1]), this.addNamespaces(g), WL(this.data, c, l), a.silent || this.emit("added", r, g, o, l);
    }
  }, {
    key: "addResources",
    value: function(r, g, o) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        silent: !1
      };
      for (var a in o)
        (typeof o[a] == "string" || Object.prototype.toString.apply(o[a]) === "[object Array]") && this.addResource(r, g, a, o[a], {
          silent: !0
        });
      l.silent || this.emit("added", r, g, o);
    }
  }, {
    key: "addResourceBundle",
    value: function(r, g, o, l, a) {
      var I = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
        silent: !1
      }, c = [r, g];
      r.indexOf(".") > -1 && (c = r.split("."), l = o, o = g, g = c[1]), this.addNamespaces(g);
      var d = JV(this.data, c) || {};
      l ? Q4(d, o, a) : d = SW(SW({}, d), o), WL(this.data, c, d), I.silent || this.emit("added", r, g, o);
    }
  }, {
    key: "removeResourceBundle",
    value: function(r, g) {
      this.hasResourceBundle(r, g) && delete this.data[r][g], this.removeNamespaces(g), this.emit("removed", r, g);
    }
  }, {
    key: "hasResourceBundle",
    value: function(r, g) {
      return this.getResource(r, g) !== void 0;
    }
  }, {
    key: "getResourceBundle",
    value: function(r, g) {
      return g || (g = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? SW(SW({}, {}), this.getResource(r, g)) : this.getResource(r, g);
    }
  }, {
    key: "getDataByLanguage",
    value: function(r) {
      return this.data[r];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function(r) {
      var g = this.getDataByLanguage(r), o = g && Object.keys(g) || [];
      return !!o.find(function(l) {
        return g[l] && Object.keys(g[l]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      return this.data;
    }
  }]), i;
}(Qd), q4 = {
  processors: {},
  addPostProcessor: function(t) {
    this.processors[t.name] = t;
  },
  handle: function(t, i, n, r, g) {
    var o = this;
    return t.forEach(function(l) {
      o.processors[l] && (i = o.processors[l].process(i, n, r, g));
    }), i;
  }
};
function wL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function mo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : wL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function oae(e) {
  var t = lae();
  return function() {
    var n = GI(e), r;
    if (t) {
      var g = GI(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return cZ(this, r);
  };
}
function lae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var vL = {}, RL = function(e) {
  f2(i, e);
  var t = oae(i);
  function i(n) {
    var r, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Js(this, i), r = t.call(this), Z2 && Qd.call(Ed(r)), qle(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], n, Ed(r)), r.options = g, r.options.keySeparator === void 0 && (r.options.keySeparator = "."), r.logger = dI.create("translator"), r;
  }
  return Es(i, [{
    key: "changeLanguage",
    value: function(r) {
      r && (this.language = r);
    }
  }, {
    key: "exists",
    value: function(r) {
      var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      };
      if (r == null)
        return !1;
      var o = this.resolve(r, g);
      return o && o.res !== void 0;
    }
  }, {
    key: "extractFromKey",
    value: function(r, g) {
      var o = g.nsSeparator !== void 0 ? g.nsSeparator : this.options.nsSeparator;
      o === void 0 && (o = ":");
      var l = g.keySeparator !== void 0 ? g.keySeparator : this.options.keySeparator, a = g.ns || this.options.defaultNS || [], I = o && r.indexOf(o) > -1, c = !this.options.userDefinedKeySeparator && !g.keySeparator && !this.options.userDefinedNsSeparator && !g.nsSeparator && !iae(r, o, l);
      if (I && !c) {
        var d = r.match(this.interpolator.nestingRegexp);
        if (d && d.length > 0)
          return {
            key: r,
            namespaces: a
          };
        var C = r.split(o);
        (o !== l || o === l && this.options.ns.indexOf(C[0]) > -1) && (a = C.shift()), r = C.join(l);
      }
      return typeof a == "string" && (a = [a]), {
        key: r,
        namespaces: a
      };
    }
  }, {
    key: "translate",
    value: function(r, g, o) {
      var l = this;
      if (Rs(g) !== "object" && this.options.overloadTranslationOptionHandler && (g = this.options.overloadTranslationOptionHandler(arguments)), g || (g = {}), r == null)
        return "";
      Array.isArray(r) || (r = [String(r)]);
      var a = g.returnDetails !== void 0 ? g.returnDetails : this.options.returnDetails, I = g.keySeparator !== void 0 ? g.keySeparator : this.options.keySeparator, c = this.extractFromKey(r[r.length - 1], g), d = c.key, C = c.namespaces, A = C[C.length - 1], b = g.lng || this.language, m = g.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (b && b.toLowerCase() === "cimode") {
        if (m) {
          var p = g.nsSeparator || this.options.nsSeparator;
          return a ? (B.res = "".concat(A).concat(p).concat(d), B) : "".concat(A).concat(p).concat(d);
        }
        return a ? (B.res = d, B) : d;
      }
      var B = this.resolve(r, g), f = B && B.res, Z = B && B.usedKey || d, y = B && B.exactUsedKey || d, W = Object.prototype.toString.apply(f), V = ["[object Number]", "[object Function]", "[object RegExp]"], w = g.joinArrays !== void 0 ? g.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, H = typeof f != "string" && typeof f != "boolean" && typeof f != "number";
      if (v && f && H && V.indexOf(W) < 0 && !(typeof w == "string" && W === "[object Array]")) {
        if (!g.returnObjects && !this.options.returnObjects) {
          this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
          var x = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(Z, f, mo(mo({}, g), {}, {
            ns: C
          })) : "key '".concat(d, " (").concat(this.language, ")' returned an object instead of string.");
          return a ? (B.res = x, B) : x;
        }
        if (I) {
          var J = W === "[object Array]", K = J ? [] : {}, M = J ? y : Z;
          for (var L in f)
            if (Object.prototype.hasOwnProperty.call(f, L)) {
              var N = "".concat(M).concat(I).concat(L);
              K[L] = this.translate(N, mo(mo({}, g), {
                joinArrays: !1,
                ns: C
              })), K[L] === N && (K[L] = f[L]);
            }
          f = K;
        }
      } else if (v && typeof w == "string" && W === "[object Array]")
        f = f.join(w), f && (f = this.extendTranslation(f, r, g, o));
      else {
        var U = !1, O = !1, $ = g.count !== void 0 && typeof g.count != "string", ne = i.hasDefaultValue(g), be = $ ? this.pluralResolver.getSuffix(b, g.count, g) : "", Ve = g["defaultValue".concat(be)] || g.defaultValue;
        !this.isValidLookup(f) && ne && (U = !0, f = Ve), this.isValidLookup(f) || (O = !0, f = d);
        var He = g.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey, Je = He && O ? void 0 : f, ke = ne && Ve !== f && this.options.updateMissing;
        if (O || U || ke) {
          if (this.logger.log(ke ? "updateKey" : "missingKey", b, A, d, ke ? Ve : f), I) {
            var we = this.resolve(d, mo(mo({}, g), {}, {
              keySeparator: !1
            }));
            we && we.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
          }
          var ue = [], Xe = this.languageUtils.getFallbackCodes(this.options.fallbackLng, g.lng || this.language);
          if (this.options.saveMissingTo === "fallback" && Xe && Xe[0])
            for (var Ze = 0; Ze < Xe.length; Ze++)
              ue.push(Xe[Ze]);
          else
            this.options.saveMissingTo === "all" ? ue = this.languageUtils.toResolveHierarchy(g.lng || this.language) : ue.push(g.lng || this.language);
          var xe = function(st, bt, it) {
            var Qe = ne && it !== f ? it : Je;
            l.options.missingKeyHandler ? l.options.missingKeyHandler(st, A, bt, Qe, ke, g) : l.backendConnector && l.backendConnector.saveMissing && l.backendConnector.saveMissing(st, A, bt, Qe, ke, g), l.emit("missingKey", st, A, bt, f);
          };
          this.options.saveMissing && (this.options.saveMissingPlurals && $ ? ue.forEach(function(Pe) {
            l.pluralResolver.getSuffixes(Pe, g).forEach(function(st) {
              xe([Pe], d + st, g["defaultValue".concat(st)] || Ve);
            });
          }) : xe(ue, d, Ve));
        }
        f = this.extendTranslation(f, r, g, B, o), O && f === d && this.options.appendNamespaceToMissingKey && (f = "".concat(A, ":").concat(d)), (O || U) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(A, ":").concat(d) : d, U ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
      }
      return a ? (B.res = f, B) : f;
    }
  }, {
    key: "extendTranslation",
    value: function(r, g, o, l, a) {
      var I = this;
      if (this.i18nFormat && this.i18nFormat.parse)
        r = this.i18nFormat.parse(r, mo(mo({}, this.options.interpolation.defaultVariables), o), l.usedLng, l.usedNS, l.usedKey, {
          resolved: l
        });
      else if (!o.skipInterpolation) {
        o.interpolation && this.interpolator.init(mo(mo({}, o), {
          interpolation: mo(mo({}, this.options.interpolation), o.interpolation)
        }));
        var c = typeof r == "string" && (o && o.interpolation && o.interpolation.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables), d;
        if (c) {
          var C = r.match(this.interpolator.nestingRegexp);
          d = C && C.length;
        }
        var A = o.replace && typeof o.replace != "string" ? o.replace : o;
        if (this.options.interpolation.defaultVariables && (A = mo(mo({}, this.options.interpolation.defaultVariables), A)), r = this.interpolator.interpolate(r, A, o.lng || this.language, o), c) {
          var b = r.match(this.interpolator.nestingRegexp), m = b && b.length;
          d < m && (o.nest = !1);
        }
        o.nest !== !1 && (r = this.interpolator.nest(r, function() {
          for (var f = arguments.length, Z = new Array(f), y = 0; y < f; y++)
            Z[y] = arguments[y];
          return a && a[0] === Z[0] && !o.context ? (I.logger.warn("It seems you are nesting recursively key: ".concat(Z[0], " in key: ").concat(g[0])), null) : I.translate.apply(I, Z.concat([g]));
        }, o)), o.interpolation && this.interpolator.reset();
      }
      var p = o.postProcess || this.options.postProcess, B = typeof p == "string" ? [p] : p;
      return r != null && B && B.length && o.applyPostProcessor !== !1 && (r = q4.handle(B, r, g, this.options && this.options.postProcessPassResolved ? mo({
        i18nResolved: l
      }, o) : o, this)), r;
    }
  }, {
    key: "resolve",
    value: function(r) {
      var g = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l, a, I, c, d;
      return typeof r == "string" && (r = [r]), r.forEach(function(C) {
        if (!g.isValidLookup(l)) {
          var A = g.extractFromKey(C, o), b = A.key;
          a = b;
          var m = A.namespaces;
          g.options.fallbackNS && (m = m.concat(g.options.fallbackNS));
          var p = o.count !== void 0 && typeof o.count != "string", B = p && !o.ordinal && o.count === 0 && g.pluralResolver.shouldUseIntlApi(), f = o.context !== void 0 && (typeof o.context == "string" || typeof o.context == "number") && o.context !== "", Z = o.lngs ? o.lngs : g.languageUtils.toResolveHierarchy(o.lng || g.language, o.fallbackLng);
          m.forEach(function(y) {
            g.isValidLookup(l) || (d = y, !vL["".concat(Z[0], "-").concat(y)] && g.utils && g.utils.hasLoadedNamespace && !g.utils.hasLoadedNamespace(d) && (vL["".concat(Z[0], "-").concat(y)] = !0, g.logger.warn('key "'.concat(a, '" for languages "').concat(Z.join(", "), `" won't get resolved as namespace "`).concat(d, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), Z.forEach(function(W) {
              if (!g.isValidLookup(l)) {
                c = W;
                var V = [b];
                if (g.i18nFormat && g.i18nFormat.addLookupKeys)
                  g.i18nFormat.addLookupKeys(V, b, W, y, o);
                else {
                  var w;
                  p && (w = g.pluralResolver.getSuffix(W, o.count, o));
                  var v = "".concat(g.options.pluralSeparator, "zero");
                  if (p && (V.push(b + w), B && V.push(b + v)), f) {
                    var H = "".concat(b).concat(g.options.contextSeparator).concat(o.context);
                    V.push(H), p && (V.push(H + w), B && V.push(H + v));
                  }
                }
                for (var x; x = V.pop(); )
                  g.isValidLookup(l) || (I = x, l = g.getResource(W, y, x, o));
              }
            }));
          });
        }
      }), {
        res: l,
        usedKey: a,
        exactUsedKey: I,
        usedLng: c,
        usedNS: d
      };
    }
  }, {
    key: "isValidLookup",
    value: function(r) {
      return r !== void 0 && !(!this.options.returnNull && r === null) && !(!this.options.returnEmptyString && r === "");
    }
  }, {
    key: "getResource",
    value: function(r, g, o) {
      var l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(r, g, o, l) : this.resourceStore.getResource(r, g, o, l);
    }
  }], [{
    key: "hasDefaultValue",
    value: function(r) {
      var g = "defaultValue";
      for (var o in r)
        if (Object.prototype.hasOwnProperty.call(r, o) && g === o.substring(0, g.length) && r[o] !== void 0)
          return !0;
      return !1;
    }
  }]), i;
}(Qd);
function $k(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
var aae = function() {
  function e(t) {
    Js(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = dI.create("languageUtils");
  }
  return Es(e, [{
    key: "getScriptPartFromCode",
    value: function(i) {
      if (!i || i.indexOf("-") < 0)
        return null;
      var n = i.split("-");
      return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function(i) {
      if (!i || i.indexOf("-") < 0)
        return i;
      var n = i.split("-");
      return this.formatLanguageCode(n[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function(i) {
      if (typeof i == "string" && i.indexOf("-") > -1) {
        var n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"], r = i.split("-");
        return this.options.lowerCaseLng ? r = r.map(function(g) {
          return g.toLowerCase();
        }) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $k(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = $k(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = $k(r[2].toLowerCase()))), r.join("-");
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? i.toLowerCase() : i;
    }
  }, {
    key: "isSupportedCode",
    value: function(i) {
      return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (i = this.getLanguagePartFromCode(i)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(i) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function(i) {
      var n = this;
      if (!i)
        return null;
      var r;
      return i.forEach(function(g) {
        if (!r) {
          var o = n.formatLanguageCode(g);
          (!n.options.supportedLngs || n.isSupportedCode(o)) && (r = o);
        }
      }), !r && this.options.supportedLngs && i.forEach(function(g) {
        if (!r) {
          var o = n.getLanguagePartFromCode(g);
          if (n.isSupportedCode(o))
            return r = o;
          r = n.options.supportedLngs.find(function(l) {
            if (l.indexOf(o) === 0)
              return l;
          });
        }
      }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
    }
  }, {
    key: "getFallbackCodes",
    value: function(i, n) {
      if (!i)
        return [];
      if (typeof i == "function" && (i = i(n)), typeof i == "string" && (i = [i]), Object.prototype.toString.apply(i) === "[object Array]")
        return i;
      if (!n)
        return i.default || [];
      var r = i[n];
      return r || (r = i[this.getScriptPartFromCode(n)]), r || (r = i[this.formatLanguageCode(n)]), r || (r = i[this.getLanguagePartFromCode(n)]), r || (r = i.default), r || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function(i, n) {
      var r = this, g = this.getFallbackCodes(n || this.options.fallbackLng || [], i), o = [], l = function(I) {
        I && (r.isSupportedCode(I) ? o.push(I) : r.logger.warn("rejecting language code not found in supportedLngs: ".concat(I)));
      };
      return typeof i == "string" && i.indexOf("-") > -1 ? (this.options.load !== "languageOnly" && l(this.formatLanguageCode(i)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && l(this.getScriptPartFromCode(i)), this.options.load !== "currentOnly" && l(this.getLanguagePartFromCode(i))) : typeof i == "string" && l(this.formatLanguageCode(i)), g.forEach(function(a) {
        o.indexOf(a) < 0 && l(r.formatLanguageCode(a));
      }), o;
    }
  }]), e;
}(), sae = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Iae = {
  1: function(t) {
    return +(t > 1);
  },
  2: function(t) {
    return +(t != 1);
  },
  3: function(t) {
    return 0;
  },
  4: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  5: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5;
  },
  6: function(t) {
    return t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2;
  },
  7: function(t) {
    return t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  8: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3;
  },
  9: function(t) {
    return +(t >= 2);
  },
  10: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4;
  },
  11: function(t) {
    return t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3;
  },
  12: function(t) {
    return +(t % 10 != 1 || t % 100 == 11);
  },
  13: function(t) {
    return +(t !== 0);
  },
  14: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3;
  },
  15: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2;
  },
  16: function(t) {
    return t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2;
  },
  17: function(t) {
    return t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1;
  },
  18: function(t) {
    return t == 0 ? 0 : t == 1 ? 1 : 2;
  },
  19: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3;
  },
  20: function(t) {
    return t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2;
  },
  21: function(t) {
    return t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0;
  },
  22: function(t) {
    return t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3;
  }
}, cae = ["v1", "v2", "v3"], XL = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function dae() {
  var e = {};
  return sae.forEach(function(t) {
    t.lngs.forEach(function(i) {
      e[i] = {
        numbers: t.nr,
        plurals: Iae[t.fc]
      };
    });
  }), e;
}
var uae = function() {
  function e(t) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Js(this, e), this.languageUtils = t, this.options = i, this.logger = dI.create("pluralResolver"), (!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = dae();
  }
  return Es(e, [{
    key: "addRule",
    value: function(i, n) {
      this.rules[i] = n;
    }
  }, {
    key: "getRule",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.shouldUseIntlApi())
        try {
          return new Intl.PluralRules(i, {
            type: n.ordinal ? "ordinal" : "cardinal"
          });
        } catch {
          return;
        }
      return this.rules[i] || this.rules[this.languageUtils.getLanguagePartFromCode(i)];
    }
  }, {
    key: "needsPlural",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = this.getRule(i, n);
      return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function(i, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this.getSuffixes(i, r).map(function(g) {
        return "".concat(n).concat(g);
      });
    }
  }, {
    key: "getSuffixes",
    value: function(i) {
      var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = this.getRule(i, r);
      return g ? this.shouldUseIntlApi() ? g.resolvedOptions().pluralCategories.sort(function(o, l) {
        return XL[o] - XL[l];
      }).map(function(o) {
        return "".concat(n.options.prepend).concat(o);
      }) : g.numbers.map(function(o) {
        return n.getSuffix(i, o, r);
      }) : [];
    }
  }, {
    key: "getSuffix",
    value: function(i, n) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, g = this.getRule(i, r);
      return g ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(g.select(n)) : this.getSuffixRetroCompatible(g, n) : (this.logger.warn("no plural rule found for: ".concat(i)), "");
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function(i, n) {
      var r = this, g = i.noAbs ? i.plurals(n) : i.plurals(Math.abs(n)), o = i.numbers[g];
      this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 && (o === 2 ? o = "plural" : o === 1 && (o = ""));
      var l = function() {
        return r.options.prepend && o.toString() ? r.options.prepend + o.toString() : o.toString();
      };
      return this.options.compatibilityJSON === "v1" ? o === 1 ? "" : typeof o == "number" ? "_plural_".concat(o.toString()) : l() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && i.numbers.length === 2 && i.numbers[0] === 1 ? l() : this.options.prepend && g.toString() ? this.options.prepend + g.toString() : g.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function() {
      return !cae.includes(this.options.compatibilityJSON);
    }
  }]), e;
}();
function HL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ms(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? HL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : HL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var Cae = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Js(this, e), this.logger = dI.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function(i) {
      return i;
    }, this.init(t);
  }
  return Es(e, [{
    key: "init",
    value: function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      i.interpolation || (i.interpolation = {
        escapeValue: !0
      });
      var n = i.interpolation;
      this.escape = n.escape !== void 0 ? n.escape : eae, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? jb(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? jb(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? jb(n.nestingPrefix) : n.nestingPrefixEscaped || jb("$t("), this.nestingSuffix = n.nestingSuffix ? jb(n.nestingSuffix) : n.nestingSuffixEscaped || jb(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function() {
      this.options && this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function() {
      var i = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(i, "g");
      var n = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(n, "g");
      var r = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(r, "g");
    }
  }, {
    key: "interpolate",
    value: function(i, n, r, g) {
      var o = this, l, a, I, c = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function d(p) {
        return p.replace(/\$/g, "$$$$");
      }
      var C = function(B) {
        if (B.indexOf(o.formatSeparator) < 0) {
          var f = SL(n, c, B);
          return o.alwaysFormat ? o.format(f, void 0, r, ms(ms(ms({}, g), n), {}, {
            interpolationkey: B
          })) : f;
        }
        var Z = B.split(o.formatSeparator), y = Z.shift().trim(), W = Z.join(o.formatSeparator).trim();
        return o.format(SL(n, c, y), W, r, ms(ms(ms({}, g), n), {}, {
          interpolationkey: y
        }));
      };
      this.resetRegExp();
      var A = g && g.missingInterpolationHandler || this.options.missingInterpolationHandler, b = g && g.interpolation && g.interpolation.skipOnVariables !== void 0 ? g.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, m = [{
        regex: this.regexpUnescape,
        safeValue: function(B) {
          return d(B);
        }
      }, {
        regex: this.regexp,
        safeValue: function(B) {
          return o.escapeValue ? d(o.escape(B)) : d(B);
        }
      }];
      return m.forEach(function(p) {
        for (I = 0; l = p.regex.exec(i); ) {
          var B = l[1].trim();
          if (a = C(B), a === void 0)
            if (typeof A == "function") {
              var f = A(i, l, g);
              a = typeof f == "string" ? f : "";
            } else if (g && g.hasOwnProperty(B))
              a = "";
            else if (b) {
              a = l[0];
              continue;
            } else
              o.logger.warn("missed to pass in variable ".concat(B, " for interpolating ").concat(i)), a = "";
          else
            typeof a != "string" && !o.useRawValueToEscape && (a = yL(a));
          var Z = p.safeValue(a);
          if (i = i.replace(l[0], Z), b ? (p.regex.lastIndex += a.length, p.regex.lastIndex -= l[0].length) : p.regex.lastIndex = 0, I++, I >= o.maxReplaces)
            break;
        }
      }), i;
    }
  }, {
    key: "nest",
    value: function(i, n) {
      var r = this, g = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o, l, a = ms({}, g);
      a.applyPostProcessor = !1, delete a.defaultValue;
      function I(A, b) {
        var m = this.nestingOptionsSeparator;
        if (A.indexOf(m) < 0)
          return A;
        var p = A.split(new RegExp("".concat(m, "[ ]*{"))), B = "{".concat(p[1]);
        A = p[0], B = this.interpolate(B, a);
        var f = B.match(/'/g), Z = B.match(/"/g);
        (f && f.length % 2 === 0 && !Z || Z.length % 2 !== 0) && (B = B.replace(/'/g, '"'));
        try {
          a = JSON.parse(B), b && (a = ms(ms({}, b), a));
        } catch (y) {
          return this.logger.warn("failed parsing options string in nesting for key ".concat(A), y), "".concat(A).concat(m).concat(B);
        }
        return delete a.defaultValue, A;
      }
      for (; o = this.nestingRegexp.exec(i); ) {
        var c = [], d = !1;
        if (o[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(o[1])) {
          var C = o[1].split(this.formatSeparator).map(function(A) {
            return A.trim();
          });
          o[1] = C.shift(), c = C, d = !0;
        }
        if (l = n(I.call(this, o[1].trim(), a), a), l && o[0] === i && typeof l != "string")
          return l;
        typeof l != "string" && (l = yL(l)), l || (this.logger.warn("missed to resolve ".concat(o[1], " for nesting ").concat(i)), l = ""), d && (l = c.reduce(function(A, b) {
          return r.format(A, b, g.lng, ms(ms({}, g), {}, {
            interpolationkey: o[1].trim()
          }));
        }, l.trim())), i = i.replace(o[0], l), this.regexp.lastIndex = 0;
      }
      return i;
    }
  }]), e;
}();
function kL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function ud(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : kL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Aae(e) {
  var t = e.toLowerCase().trim(), i = {};
  if (e.indexOf("(") > -1) {
    var n = e.split("(");
    t = n[0].toLowerCase().trim();
    var r = n[1].substring(0, n[1].length - 1);
    if (t === "currency" && r.indexOf(":") < 0)
      i.currency || (i.currency = r.trim());
    else if (t === "relativetime" && r.indexOf(":") < 0)
      i.range || (i.range = r.trim());
    else {
      var g = r.split(";");
      g.forEach(function(o) {
        if (o) {
          var l = o.split(":"), a = Ole(l), I = a[0], c = a.slice(1), d = c.join(":").trim().replace(/^'+|'+$/g, "");
          i[I.trim()] || (i[I.trim()] = d), d === "false" && (i[I.trim()] = !1), d === "true" && (i[I.trim()] = !0), isNaN(d) || (i[I.trim()] = parseInt(d, 10));
        }
      });
    }
  }
  return {
    formatName: t,
    formatOptions: i
  };
}
function qb(e) {
  var t = {};
  return function(n, r, g) {
    var o = r + JSON.stringify(g), l = t[o];
    return l || (l = e(r, g), t[o] = l), l(n);
  };
}
var bae = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Js(this, e), this.logger = dI.create("formatter"), this.options = t, this.formats = {
      number: qb(function(i, n) {
        var r = new Intl.NumberFormat(i, n);
        return function(g) {
          return r.format(g);
        };
      }),
      currency: qb(function(i, n) {
        var r = new Intl.NumberFormat(i, ud(ud({}, n), {}, {
          style: "currency"
        }));
        return function(g) {
          return r.format(g);
        };
      }),
      datetime: qb(function(i, n) {
        var r = new Intl.DateTimeFormat(i, ud({}, n));
        return function(g) {
          return r.format(g);
        };
      }),
      relativetime: qb(function(i, n) {
        var r = new Intl.RelativeTimeFormat(i, ud({}, n));
        return function(g) {
          return r.format(g, n.range || "day");
        };
      }),
      list: qb(function(i, n) {
        var r = new Intl.ListFormat(i, ud({}, n));
        return function(g) {
          return r.format(g);
        };
      })
    }, this.init(t);
  }
  return Es(e, [{
    key: "init",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        interpolation: {}
      }, r = n.interpolation;
      this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
    }
  }, {
    key: "add",
    value: function(i, n) {
      this.formats[i.toLowerCase().trim()] = n;
    }
  }, {
    key: "addCached",
    value: function(i, n) {
      this.formats[i.toLowerCase().trim()] = qb(n);
    }
  }, {
    key: "format",
    value: function(i, n, r, g) {
      var o = this, l = n.split(this.formatSeparator), a = l.reduce(function(I, c) {
        var d = Aae(c), C = d.formatName, A = d.formatOptions;
        if (o.formats[C]) {
          var b = I;
          try {
            var m = g && g.formatParams && g.formatParams[g.interpolationkey] || {}, p = m.locale || m.lng || g.locale || g.lng || r;
            b = o.formats[C](I, p, ud(ud(ud({}, A), g), m));
          } catch (B) {
            o.logger.warn(B);
          }
          return b;
        } else
          o.logger.warn("there was no format function for ".concat(C));
        return I;
      }, i);
      return a;
    }
  }]), e;
}();
function YL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function FL(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : YL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function hae(e) {
  var t = mae();
  return function() {
    var n = GI(e), r;
    if (t) {
      var g = GI(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return cZ(this, r);
  };
}
function mae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function pae(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
var Bae = function(e) {
  f2(i, e);
  var t = hae(i);
  function i(n, r, g) {
    var o, l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return Js(this, i), o = t.call(this), Z2 && Qd.call(Ed(o)), o.backend = n, o.store = r, o.services = g, o.languageUtils = g.languageUtils, o.options = l, o.logger = dI.create("backendConnector"), o.waitingReads = [], o.maxParallelReads = l.maxParallelReads || 10, o.readingCalls = 0, o.maxRetries = l.maxRetries >= 0 ? l.maxRetries : 5, o.retryTimeout = l.retryTimeout >= 1 ? l.retryTimeout : 350, o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(g, l.backend, l), o;
  }
  return Es(i, [{
    key: "queueLoad",
    value: function(r, g, o, l) {
      var a = this, I = {}, c = {}, d = {}, C = {};
      return r.forEach(function(A) {
        var b = !0;
        g.forEach(function(m) {
          var p = "".concat(A, "|").concat(m);
          !o.reload && a.store.hasResourceBundle(A, m) ? a.state[p] = 2 : a.state[p] < 0 || (a.state[p] === 1 ? c[p] === void 0 && (c[p] = !0) : (a.state[p] = 1, b = !1, c[p] === void 0 && (c[p] = !0), I[p] === void 0 && (I[p] = !0), C[m] === void 0 && (C[m] = !0)));
        }), b || (d[A] = !0);
      }), (Object.keys(I).length || Object.keys(c).length) && this.queue.push({
        pending: c,
        pendingCount: Object.keys(c).length,
        loaded: {},
        errors: [],
        callback: l
      }), {
        toLoad: Object.keys(I),
        pending: Object.keys(c),
        toLoadLanguages: Object.keys(d),
        toLoadNamespaces: Object.keys(C)
      };
    }
  }, {
    key: "loaded",
    value: function(r, g, o) {
      var l = r.split("|"), a = l[0], I = l[1];
      g && this.emit("failedLoading", a, I, g), o && this.store.addResourceBundle(a, I, o), this.state[r] = g ? -1 : 2;
      var c = {};
      this.queue.forEach(function(d) {
        _le(d.loaded, [a], I), pae(d, r), g && d.errors.push(g), d.pendingCount === 0 && !d.done && (Object.keys(d.loaded).forEach(function(C) {
          c[C] || (c[C] = {});
          var A = d.loaded[C];
          A.length && A.forEach(function(b) {
            c[C][b] === void 0 && (c[C][b] = !0);
          });
        }), d.done = !0, d.errors.length ? d.callback(d.errors) : d.callback());
      }), this.emit("loaded", c), this.queue = this.queue.filter(function(d) {
        return !d.done;
      });
    }
  }, {
    key: "read",
    value: function(r, g, o) {
      var l = this, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, I = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, c = arguments.length > 5 ? arguments[5] : void 0;
      if (!r.length)
        return c(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: r,
          ns: g,
          fcName: o,
          tried: a,
          wait: I,
          callback: c
        });
        return;
      }
      return this.readingCalls++, this.backend[o](r, g, function(d, C) {
        if (l.readingCalls--, l.waitingReads.length > 0) {
          var A = l.waitingReads.shift();
          l.read(A.lng, A.ns, A.fcName, A.tried, A.wait, A.callback);
        }
        if (d && C && a < l.maxRetries) {
          setTimeout(function() {
            l.read.call(l, r, g, o, a + 1, I * 2, c);
          }, I);
          return;
        }
        c(d, C);
      });
    }
  }, {
    key: "prepareLoading",
    value: function(r, g) {
      var o = this, l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
      if (!this.backend)
        return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
      typeof r == "string" && (r = this.languageUtils.toResolveHierarchy(r)), typeof g == "string" && (g = [g]);
      var I = this.queueLoad(r, g, l, a);
      if (!I.toLoad.length)
        return I.pending.length || a(), null;
      I.toLoad.forEach(function(c) {
        o.loadOne(c);
      });
    }
  }, {
    key: "load",
    value: function(r, g, o) {
      this.prepareLoading(r, g, {}, o);
    }
  }, {
    key: "reload",
    value: function(r, g, o) {
      this.prepareLoading(r, g, {
        reload: !0
      }, o);
    }
  }, {
    key: "loadOne",
    value: function(r) {
      var g = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", l = r.split("|"), a = l[0], I = l[1];
      this.read(a, I, "read", void 0, void 0, function(c, d) {
        c && g.logger.warn("".concat(o, "loading namespace ").concat(I, " for language ").concat(a, " failed"), c), !c && d && g.logger.log("".concat(o, "loaded namespace ").concat(I, " for language ").concat(a), d), g.loaded(r, c, d);
      });
    }
  }, {
    key: "saveMissing",
    value: function(r, g, o, l, a) {
      var I = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(g)) {
        this.logger.warn('did not save key "'.concat(o, '" as the namespace "').concat(g, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        return;
      }
      o == null || o === "" || (this.backend && this.backend.create && this.backend.create(r, g, o, l, null, FL(FL({}, I), {}, {
        isUpdate: a
      })), !(!r || !r[0]) && this.store.addResource(r[0], g, o, l));
    }
  }]), i;
}(Qd);
function fae() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !0,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      var i = {};
      if (Rs(t[1]) === "object" && (i = t[1]), typeof t[1] == "string" && (i.defaultValue = t[1]), typeof t[2] == "string" && (i.tDescription = t[2]), Rs(t[2]) === "object" || Rs(t[3]) === "object") {
        var n = t[3] || t[2];
        Object.keys(n).forEach(function(r) {
          i[r] = n[r];
        });
      }
      return i;
    },
    interpolation: {
      escapeValue: !0,
      format: function(t, i, n, r) {
        return t;
      },
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function xL(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function DL(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function nI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DL(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : DL(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Zae(e) {
  var t = Gae();
  return function() {
    var n = GI(e), r;
    if (t) {
      var g = GI(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return cZ(this, r);
  };
}
function Gae() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function VW() {
}
function yae(e) {
  var t = Object.getOwnPropertyNames(Object.getPrototypeOf(e));
  t.forEach(function(i) {
    typeof e[i] == "function" && (e[i] = e[i].bind(e));
  });
}
var EV = function(e) {
  f2(i, e);
  var t = Zae(i);
  function i() {
    var n, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = arguments.length > 1 ? arguments[1] : void 0;
    if (Js(this, i), n = t.call(this), Z2 && Qd.call(Ed(n)), n.options = xL(r), n.services = {}, n.logger = dI, n.modules = {
      external: []
    }, yae(Ed(n)), g && !n.isInitialized && !r.isClone) {
      if (!n.options.initImmediate)
        return n.init(r, g), cZ(n, Ed(n));
      setTimeout(function() {
        n.init(r, g);
      }, 0);
    }
    return n;
  }
  return Es(i, [{
    key: "init",
    value: function() {
      var r = this, g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
      typeof g == "function" && (o = g, g = {}), !g.defaultNS && g.defaultNS !== !1 && g.ns && (typeof g.ns == "string" ? g.defaultNS = g.ns : g.ns.indexOf("translation") < 0 && (g.defaultNS = g.ns[0]));
      var l = fae();
      this.options = nI(nI(nI({}, l), this.options), xL(g)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = nI(nI({}, l.interpolation), this.options.interpolation)), g.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = g.keySeparator), g.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = g.nsSeparator);
      function a(B) {
        return B ? typeof B == "function" ? new B() : B : null;
      }
      if (!this.options.isClone) {
        this.modules.logger ? dI.init(a(this.modules.logger), this.options) : dI.init(null, this.options);
        var I;
        this.modules.formatter ? I = this.modules.formatter : typeof Intl < "u" && (I = bae);
        var c = new aae(this.options);
        this.store = new gae(this.options.resources, this.options);
        var d = this.services;
        d.logger = dI, d.resourceStore = this.store, d.languageUtils = c, d.pluralResolver = new uae(c, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        }), I && (!this.options.interpolation.format || this.options.interpolation.format === l.interpolation.format) && (d.formatter = a(I), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Cae(this.options), d.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        }, d.backendConnector = new Bae(a(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(B) {
          for (var f = arguments.length, Z = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
            Z[y - 1] = arguments[y];
          r.emit.apply(r, [B].concat(Z));
        }), this.modules.languageDetector && (d.languageDetector = a(this.modules.languageDetector), d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = a(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new RL(this.services, this.options), this.translator.on("*", function(B) {
          for (var f = arguments.length, Z = new Array(f > 1 ? f - 1 : 0), y = 1; y < f; y++)
            Z[y - 1] = arguments[y];
          r.emit.apply(r, [B].concat(Z));
        }), this.modules.external.forEach(function(B) {
          B.init && B.init(r);
        });
      }
      if (this.format = this.options.interpolation.format, o || (o = VW), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var C = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        C.length > 0 && C[0] !== "dev" && (this.options.lng = C[0]);
      }
      !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined");
      var A = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
      A.forEach(function(B) {
        r[B] = function() {
          var f;
          return (f = r.store)[B].apply(f, arguments);
        };
      });
      var b = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
      b.forEach(function(B) {
        r[B] = function() {
          var f;
          return (f = r.store)[B].apply(f, arguments), r;
        };
      });
      var m = M0(), p = function() {
        var f = function(y, W) {
          r.isInitialized && !r.initializedStoreOnce && r.logger.warn("init: i18next is already initialized. You should call init just once!"), r.isInitialized = !0, r.options.isClone || r.logger.log("initialized", r.options), r.emit("initialized", r.options), m.resolve(W), o(y, W);
        };
        if (r.languages && r.options.compatibilityAPI !== "v1" && !r.isInitialized)
          return f(null, r.t.bind(r));
        r.changeLanguage(r.options.lng, f);
      };
      return this.options.resources || !this.options.initImmediate ? p() : setTimeout(p, 0), m;
    }
  }, {
    key: "loadResources",
    value: function(r) {
      var g = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : VW, l = o, a = typeof r == "string" ? r : this.language;
      if (typeof r == "function" && (l = r), !this.options.resources || this.options.partialBundledLanguages) {
        if (a && a.toLowerCase() === "cimode")
          return l();
        var I = [], c = function(A) {
          if (A) {
            var b = g.services.languageUtils.toResolveHierarchy(A);
            b.forEach(function(m) {
              I.indexOf(m) < 0 && I.push(m);
            });
          }
        };
        if (a)
          c(a);
        else {
          var d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          d.forEach(function(C) {
            return c(C);
          });
        }
        this.options.preload && this.options.preload.forEach(function(C) {
          return c(C);
        }), this.services.backendConnector.load(I, this.options.ns, function(C) {
          !C && !g.resolvedLanguage && g.language && g.setResolvedLanguage(g.language), l(C);
        });
      } else
        l(null);
    }
  }, {
    key: "reloadResources",
    value: function(r, g, o) {
      var l = M0();
      return r || (r = this.languages), g || (g = this.options.ns), o || (o = VW), this.services.backendConnector.reload(r, g, function(a) {
        l.resolve(), o(a);
      }), l;
    }
  }, {
    key: "use",
    value: function(r) {
      if (!r)
        throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
      if (!r.type)
        throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
      return r.type === "backend" && (this.modules.backend = r), (r.type === "logger" || r.log && r.warn && r.error) && (this.modules.logger = r), r.type === "languageDetector" && (this.modules.languageDetector = r), r.type === "i18nFormat" && (this.modules.i18nFormat = r), r.type === "postProcessor" && q4.addPostProcessor(r), r.type === "formatter" && (this.modules.formatter = r), r.type === "3rdParty" && this.modules.external.push(r), this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function(r) {
      if (!(!r || !this.languages) && !(["cimode", "dev"].indexOf(r) > -1))
        for (var g = 0; g < this.languages.length; g++) {
          var o = this.languages[g];
          if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
            this.resolvedLanguage = o;
            break;
          }
        }
    }
  }, {
    key: "changeLanguage",
    value: function(r, g) {
      var o = this;
      this.isLanguageChangingTo = r;
      var l = M0();
      this.emit("languageChanging", r);
      var a = function(C) {
        o.language = C, o.languages = o.services.languageUtils.toResolveHierarchy(C), o.resolvedLanguage = void 0, o.setResolvedLanguage(C);
      }, I = function(C, A) {
        A ? (a(A), o.translator.changeLanguage(A), o.isLanguageChangingTo = void 0, o.emit("languageChanged", A), o.logger.log("languageChanged", A)) : o.isLanguageChangingTo = void 0, l.resolve(function() {
          return o.t.apply(o, arguments);
        }), g && g(C, function() {
          return o.t.apply(o, arguments);
        });
      }, c = function(C) {
        !r && !C && o.services.languageDetector && (C = []);
        var A = typeof C == "string" ? C : o.services.languageUtils.getBestMatchFromCodes(C);
        A && (o.language || a(A), o.translator.language || o.translator.changeLanguage(A), o.services.languageDetector && o.services.languageDetector.cacheUserLanguage(A)), o.loadResources(A, function(b) {
          I(b, A);
        });
      };
      return !r && this.services.languageDetector && !this.services.languageDetector.async ? c(this.services.languageDetector.detect()) : !r && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(c) : c(r), l;
    }
  }, {
    key: "getFixedT",
    value: function(r, g, o) {
      var l = this, a = function I(c, d) {
        var C;
        if (Rs(d) !== "object") {
          for (var A = arguments.length, b = new Array(A > 2 ? A - 2 : 0), m = 2; m < A; m++)
            b[m - 2] = arguments[m];
          C = l.options.overloadTranslationOptionHandler([c, d].concat(b));
        } else
          C = nI({}, d);
        C.lng = C.lng || I.lng, C.lngs = C.lngs || I.lngs, C.ns = C.ns || I.ns, C.keyPrefix = C.keyPrefix || o || I.keyPrefix;
        var p = l.options.keySeparator || ".", B = C.keyPrefix ? "".concat(C.keyPrefix).concat(p).concat(c) : c;
        return l.t(B, C);
      };
      return typeof r == "string" ? a.lng = r : a.lngs = r, a.ns = g, a.keyPrefix = o, a;
    }
  }, {
    key: "t",
    value: function() {
      var r;
      return this.translator && (r = this.translator).translate.apply(r, arguments);
    }
  }, {
    key: "exists",
    value: function() {
      var r;
      return this.translator && (r = this.translator).exists.apply(r, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function(r) {
      this.options.defaultNS = r;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function(r) {
      var g = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.isInitialized)
        return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
      if (!this.languages || !this.languages.length)
        return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
      var l = this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, I = this.languages[this.languages.length - 1];
      if (l.toLowerCase() === "cimode")
        return !0;
      var c = function(A, b) {
        var m = g.services.backendConnector.state["".concat(A, "|").concat(b)];
        return m === -1 || m === 2;
      };
      if (o.precheck) {
        var d = o.precheck(this, c);
        if (d !== void 0)
          return d;
      }
      return !!(this.hasResourceBundle(l, r) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || c(l, r) && (!a || c(I, r)));
    }
  }, {
    key: "loadNamespaces",
    value: function(r, g) {
      var o = this, l = M0();
      return this.options.ns ? (typeof r == "string" && (r = [r]), r.forEach(function(a) {
        o.options.ns.indexOf(a) < 0 && o.options.ns.push(a);
      }), this.loadResources(function(a) {
        l.resolve(), g && g(a);
      }), l) : (g && g(), Promise.resolve());
    }
  }, {
    key: "loadLanguages",
    value: function(r, g) {
      var o = M0();
      typeof r == "string" && (r = [r]);
      var l = this.options.preload || [], a = r.filter(function(I) {
        return l.indexOf(I) < 0;
      });
      return a.length ? (this.options.preload = l.concat(a), this.loadResources(function(I) {
        o.resolve(), g && g(I);
      }), o) : (g && g(), Promise.resolve());
    }
  }, {
    key: "dir",
    value: function(r) {
      if (r || (r = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !r)
        return "rtl";
      var g = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
      return g.indexOf(this.services.languageUtils.getLanguagePartFromCode(r)) > -1 || r.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
  }, {
    key: "cloneInstance",
    value: function() {
      var r = this, g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : VW, l = nI(nI(nI({}, this.options), g), {
        isClone: !0
      }), a = new i(l);
      (g.debug !== void 0 || g.prefix !== void 0) && (a.logger = a.logger.clone(g));
      var I = ["store", "services", "language"];
      return I.forEach(function(c) {
        a[c] = r[c];
      }), a.services = nI({}, this.services), a.services.utils = {
        hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
      }, a.translator = new RL(a.services, a.options), a.translator.on("*", function(c) {
        for (var d = arguments.length, C = new Array(d > 1 ? d - 1 : 0), A = 1; A < d; A++)
          C[A - 1] = arguments[A];
        a.emit.apply(a, [c].concat(C));
      }), a.init(l, o), a.translator.options = a.options, a.translator.backendConnector.services.utils = {
        hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
      }, a;
    }
  }, {
    key: "toJSON",
    value: function() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]), i;
}(Qd);
XI(EV, "createInstance", function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
  return new EV(e, t);
});
var $i = EV.createInstance();
$i.createInstance = EV.createInstance;
$i.createInstance;
$i.init;
$i.loadResources;
$i.reloadResources;
$i.use;
$i.changeLanguage;
$i.getFixedT;
var Ug = $i.t;
$i.exists;
$i.setDefaultNamespace;
$i.hasLoadedNamespace;
$i.loadNamespaces;
$i.loadLanguages;
const yf = {
  black: "#000",
  white: "#fff"
}, _b = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, $b = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, eh = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, th = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, ih = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, P0 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, _4 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function yI(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let i = 1; i < arguments.length; i += 1)
    t += "&args[]=" + encodeURIComponent(arguments[i]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const Wae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yI
}, Symbol.toStringTag, { value: "Module" })), _C = "$$material";
function F() {
  return F = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, F.apply(this, arguments);
}
function tt(e, t) {
  if (e == null)
    return {};
  var i = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0)
        continue;
      i[n] = e[n];
    }
  return i;
}
var $4 = { exports: {} }, Sae = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Vae = Sae, wae = Vae;
function eQ() {
}
function tQ() {
}
tQ.resetWarningCache = eQ;
var vae = function() {
  function e(n, r, g, o, l, a) {
    if (a !== wae) {
      var I = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw I.name = "Invariant Violation", I;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var i = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: tQ,
    resetWarningCache: eQ
  };
  return i.PropTypes = i, i;
};
$4.exports = vae();
var iQ = $4.exports;
const JL = /* @__PURE__ */ go(iQ);
let Cx;
typeof document == "object" && (Cx = F4({
  key: "css",
  prepend: !0
}));
function Rae(e) {
  const {
    injectFirst: t,
    children: i
  } = e;
  return t && Cx ? /* @__PURE__ */ ee(boe, {
    value: Cx,
    children: i
  }) : i;
}
function Xae(e) {
  return e == null || Object.keys(e).length === 0;
}
function nQ(e) {
  const {
    styles: t,
    defaultTheme: i = {}
  } = e;
  return /* @__PURE__ */ ee(hoe, {
    styles: typeof t == "function" ? (r) => t(Xae(r) ? i : r) : t
  });
}
function JD(e, t) {
  return Aoe(e, t);
}
const rQ = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, Hae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: nQ,
  StyledEngineProvider: Rae,
  ThemeContext: SD,
  css: Od,
  default: JD,
  internal_processStyles: rQ,
  keyframes: Ds
}, Symbol.toStringTag, { value: "Module" }));
function pc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function gQ(e) {
  if (!pc(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((i) => {
    t[i] = gQ(e[i]);
  }), t;
}
function pg(e, t, i = {
  clone: !0
}) {
  const n = i.clone ? F({}, e) : e;
  return pc(e) && pc(t) && Object.keys(t).forEach((r) => {
    r !== "__proto__" && (pc(t[r]) && r in e && pc(e[r]) ? n[r] = pg(e[r], t[r], i) : i.clone ? n[r] = pc(t[r]) ? gQ(t[r]) : t[r] : n[r] = t[r]);
  }), n;
}
const kae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pg,
  isPlainObject: pc
}, Symbol.toStringTag, { value: "Module" })), Yae = ["values", "unit", "step"], Fae = (e) => {
  const t = Object.keys(e).map((i) => ({
    key: i,
    val: e[i]
  })) || [];
  return t.sort((i, n) => i.val - n.val), t.reduce((i, n) => F({}, i, {
    [n.key]: n.val
  }), {});
};
function oQ(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: i = "px",
    step: n = 5
  } = e, r = tt(e, Yae), g = Fae(t), o = Object.keys(g);
  function l(C) {
    return `@media (min-width:${typeof t[C] == "number" ? t[C] : C}${i})`;
  }
  function a(C) {
    return `@media (max-width:${(typeof t[C] == "number" ? t[C] : C) - n / 100}${i})`;
  }
  function I(C, A) {
    const b = o.indexOf(A);
    return `@media (min-width:${typeof t[C] == "number" ? t[C] : C}${i}) and (max-width:${(b !== -1 && typeof t[o[b]] == "number" ? t[o[b]] : A) - n / 100}${i})`;
  }
  function c(C) {
    return o.indexOf(C) + 1 < o.length ? I(C, o[o.indexOf(C) + 1]) : l(C);
  }
  function d(C) {
    const A = o.indexOf(C);
    return A === 0 ? l(o[1]) : A === o.length - 1 ? a(o[A]) : I(C, o[o.indexOf(C) + 1]).replace("@media", "@media not all and");
  }
  return F({
    keys: o,
    values: g,
    up: l,
    down: a,
    between: I,
    only: c,
    not: d,
    unit: i
  }, r);
}
const xae = {
  borderRadius: 4
};
function TB(e, t) {
  return t ? pg(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const ED = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, EL = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${ED[e]}px)`
};
function Ys(e, t, i) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const g = n.breakpoints || EL;
    return t.reduce((o, l, a) => (o[g.up(g.keys[a])] = i(t[a]), o), {});
  }
  if (typeof t == "object") {
    const g = n.breakpoints || EL;
    return Object.keys(t).reduce((o, l) => {
      if (Object.keys(g.values || ED).indexOf(l) !== -1) {
        const a = g.up(l);
        o[a] = i(t[l], l);
      } else {
        const a = l;
        o[a] = t[a];
      }
      return o;
    }, {});
  }
  return i(t);
}
function lQ(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, r) => {
    const g = e.up(r);
    return n[g] = {}, n;
  }, {})) || {};
}
function aQ(e, t) {
  return e.reduce((i, n) => {
    const r = i[n];
    return (!r || Object.keys(r).length === 0) && delete i[n], i;
  }, t);
}
function Dae(e, ...t) {
  const i = lQ(e), n = [i, ...t].reduce((r, g) => pg(r, g), {});
  return aQ(Object.keys(i), n);
}
function Jae(e, t) {
  if (typeof e != "object")
    return {};
  const i = {}, n = Object.keys(t);
  return Array.isArray(e) ? n.forEach((r, g) => {
    g < e.length && (i[r] = !0);
  }) : n.forEach((r) => {
    e[r] != null && (i[r] = !0);
  }), i;
}
function eY({
  values: e,
  breakpoints: t,
  base: i
}) {
  const n = i || Jae(e, t), r = Object.keys(n);
  if (r.length === 0)
    return e;
  let g;
  return r.reduce((o, l, a) => (Array.isArray(e) ? (o[l] = e[a] != null ? e[a] : e[g], g = a) : typeof e == "object" ? (o[l] = e[l] != null ? e[l] : e[g], g = l) : o[l] = e, o), {});
}
function ve(e) {
  if (typeof e != "string")
    throw new Error(yI(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Eae = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ve
}, Symbol.toStringTag, { value: "Module" }));
function em(e, t, i = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && i) {
    const n = `vars.${t}`.split(".").reduce((r, g) => r && r[g] ? r[g] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, r) => n && n[r] != null ? n[r] : null, e);
}
function NV(e, t, i, n = i) {
  let r;
  return typeof e == "function" ? r = e(i) : Array.isArray(e) ? r = e[i] || n : r = em(e, i) || n, t && (r = t(r, n, e)), r;
}
function vr(e) {
  const {
    prop: t,
    cssProperty: i = e.prop,
    themeKey: n,
    transform: r
  } = e, g = (o) => {
    if (o[t] == null)
      return null;
    const l = o[t], a = o.theme, I = em(a, n) || {};
    return Ys(o, l, (d) => {
      let C = NV(I, r, d);
      return d === C && typeof d == "string" && (C = NV(I, r, `${t}${d === "default" ? "" : ve(d)}`, d)), i === !1 ? C : {
        [i]: C
      };
    });
  };
  return g.propTypes = {}, g.filterProps = [t], g;
}
function Nae(e) {
  const t = {};
  return (i) => (t[i] === void 0 && (t[i] = e(i)), t[i]);
}
const Lae = {
  m: "margin",
  p: "padding"
}, Kae = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, NL = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Tae = Nae((e) => {
  if (e.length > 2)
    if (NL[e])
      e = NL[e];
    else
      return [e];
  const [t, i] = e.split(""), n = Lae[t], r = Kae[i] || "";
  return Array.isArray(r) ? r.map((g) => n + g) : [n + r];
}), ND = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], LD = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...ND, ...LD];
function dZ(e, t, i, n) {
  var r;
  const g = (r = em(e, t, !1)) != null ? r : i;
  return typeof g == "number" ? (o) => typeof o == "string" ? o : g * o : Array.isArray(g) ? (o) => typeof o == "string" ? o : g[o] : typeof g == "function" ? g : () => {
  };
}
function KD(e) {
  return dZ(e, "spacing", 8);
}
function $C(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const i = Math.abs(t), n = e(i);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function Mae(e, t) {
  return (i) => e.reduce((n, r) => (n[r] = $C(t, i), n), {});
}
function Pae(e, t, i, n) {
  if (t.indexOf(i) === -1)
    return null;
  const r = Tae(i), g = Mae(r, n), o = e[i];
  return Ys(e, o, g);
}
function sQ(e, t) {
  const i = KD(e.theme);
  return Object.keys(e).map((n) => Pae(e, t, n, i)).reduce(TB, {});
}
function Ar(e) {
  return sQ(e, ND);
}
Ar.propTypes = {};
Ar.filterProps = ND;
function br(e) {
  return sQ(e, LD);
}
br.propTypes = {};
br.filterProps = LD;
function Uae(e = 8) {
  if (e.mui)
    return e;
  const t = KD({
    spacing: e
  }), i = (...n) => (n.length === 0 ? [1] : n).map((g) => {
    const o = t(g);
    return typeof o == "number" ? `${o}px` : o;
  }).join(" ");
  return i.mui = !0, i;
}
function G2(...e) {
  const t = e.reduce((n, r) => (r.filterProps.forEach((g) => {
    n[g] = r;
  }), n), {}), i = (n) => Object.keys(n).reduce((r, g) => t[g] ? TB(r, t[g](n)) : r, {});
  return i.propTypes = {}, i.filterProps = e.reduce((n, r) => n.concat(r.filterProps), []), i;
}
function Sa(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function za(e, t) {
  return vr({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const zae = za("border", Sa), Oae = za("borderTop", Sa), Qae = za("borderRight", Sa), jae = za("borderBottom", Sa), qae = za("borderLeft", Sa), _ae = za("borderColor"), $ae = za("borderTopColor"), ese = za("borderRightColor"), tse = za("borderBottomColor"), ise = za("borderLeftColor"), nse = za("outline", Sa), rse = za("outlineColor"), y2 = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = dZ(e.theme, "shape.borderRadius", 4), i = (n) => ({
      borderRadius: $C(t, n)
    });
    return Ys(e, e.borderRadius, i);
  }
  return null;
};
y2.propTypes = {};
y2.filterProps = ["borderRadius"];
G2(zae, Oae, Qae, jae, qae, _ae, $ae, ese, tse, ise, y2, nse, rse);
const W2 = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = dZ(e.theme, "spacing", 8), i = (n) => ({
      gap: $C(t, n)
    });
    return Ys(e, e.gap, i);
  }
  return null;
};
W2.propTypes = {};
W2.filterProps = ["gap"];
const S2 = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = dZ(e.theme, "spacing", 8), i = (n) => ({
      columnGap: $C(t, n)
    });
    return Ys(e, e.columnGap, i);
  }
  return null;
};
S2.propTypes = {};
S2.filterProps = ["columnGap"];
const V2 = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = dZ(e.theme, "spacing", 8), i = (n) => ({
      rowGap: $C(t, n)
    });
    return Ys(e, e.rowGap, i);
  }
  return null;
};
V2.propTypes = {};
V2.filterProps = ["rowGap"];
const gse = vr({
  prop: "gridColumn"
}), ose = vr({
  prop: "gridRow"
}), lse = vr({
  prop: "gridAutoFlow"
}), ase = vr({
  prop: "gridAutoColumns"
}), sse = vr({
  prop: "gridAutoRows"
}), Ise = vr({
  prop: "gridTemplateColumns"
}), cse = vr({
  prop: "gridTemplateRows"
}), dse = vr({
  prop: "gridTemplateAreas"
}), use = vr({
  prop: "gridArea"
});
G2(W2, S2, V2, gse, ose, lse, ase, sse, Ise, cse, dse, use);
function Ph(e, t) {
  return t === "grey" ? t : e;
}
const Cse = vr({
  prop: "color",
  themeKey: "palette",
  transform: Ph
}), Ase = vr({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ph
}), bse = vr({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ph
});
G2(Cse, Ase, bse);
function Xl(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const hse = vr({
  prop: "width",
  transform: Xl
}), TD = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (i) => {
      var n, r;
      const g = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[i]) || ED[i];
      return g ? ((r = e.theme) == null || (r = r.breakpoints) == null ? void 0 : r.unit) !== "px" ? {
        maxWidth: `${g}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: g
      } : {
        maxWidth: Xl(i)
      };
    };
    return Ys(e, e.maxWidth, t);
  }
  return null;
};
TD.filterProps = ["maxWidth"];
const mse = vr({
  prop: "minWidth",
  transform: Xl
}), pse = vr({
  prop: "height",
  transform: Xl
}), Bse = vr({
  prop: "maxHeight",
  transform: Xl
}), fse = vr({
  prop: "minHeight",
  transform: Xl
});
vr({
  prop: "size",
  cssProperty: "width",
  transform: Xl
});
vr({
  prop: "size",
  cssProperty: "height",
  transform: Xl
});
const Zse = vr({
  prop: "boxSizing"
});
G2(hse, TD, mse, pse, Bse, fse, Zse);
const uZ = {
  // borders
  border: {
    themeKey: "borders",
    transform: Sa
  },
  borderTop: {
    themeKey: "borders",
    transform: Sa
  },
  borderRight: {
    themeKey: "borders",
    transform: Sa
  },
  borderBottom: {
    themeKey: "borders",
    transform: Sa
  },
  borderLeft: {
    themeKey: "borders",
    transform: Sa
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Sa
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: y2
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ph
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ph
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ph
  },
  // spacing
  p: {
    style: br
  },
  pt: {
    style: br
  },
  pr: {
    style: br
  },
  pb: {
    style: br
  },
  pl: {
    style: br
  },
  px: {
    style: br
  },
  py: {
    style: br
  },
  padding: {
    style: br
  },
  paddingTop: {
    style: br
  },
  paddingRight: {
    style: br
  },
  paddingBottom: {
    style: br
  },
  paddingLeft: {
    style: br
  },
  paddingX: {
    style: br
  },
  paddingY: {
    style: br
  },
  paddingInline: {
    style: br
  },
  paddingInlineStart: {
    style: br
  },
  paddingInlineEnd: {
    style: br
  },
  paddingBlock: {
    style: br
  },
  paddingBlockStart: {
    style: br
  },
  paddingBlockEnd: {
    style: br
  },
  m: {
    style: Ar
  },
  mt: {
    style: Ar
  },
  mr: {
    style: Ar
  },
  mb: {
    style: Ar
  },
  ml: {
    style: Ar
  },
  mx: {
    style: Ar
  },
  my: {
    style: Ar
  },
  margin: {
    style: Ar
  },
  marginTop: {
    style: Ar
  },
  marginRight: {
    style: Ar
  },
  marginBottom: {
    style: Ar
  },
  marginLeft: {
    style: Ar
  },
  marginX: {
    style: Ar
  },
  marginY: {
    style: Ar
  },
  marginInline: {
    style: Ar
  },
  marginInlineStart: {
    style: Ar
  },
  marginInlineEnd: {
    style: Ar
  },
  marginBlock: {
    style: Ar
  },
  marginBlockStart: {
    style: Ar
  },
  marginBlockEnd: {
    style: Ar
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: W2
  },
  rowGap: {
    style: V2
  },
  columnGap: {
    style: S2
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Xl
  },
  maxWidth: {
    style: TD
  },
  minWidth: {
    transform: Xl
  },
  height: {
    transform: Xl
  },
  maxHeight: {
    transform: Xl
  },
  minHeight: {
    transform: Xl
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function Gse(...e) {
  const t = e.reduce((n, r) => n.concat(Object.keys(r)), []), i = new Set(t);
  return e.every((n) => i.size === Object.keys(n).length);
}
function yse(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function IQ() {
  function e(i, n, r, g) {
    const o = {
      [i]: n,
      theme: r
    }, l = g[i];
    if (!l)
      return {
        [i]: n
      };
    const {
      cssProperty: a = i,
      themeKey: I,
      transform: c,
      style: d
    } = l;
    if (n == null)
      return null;
    if (I === "typography" && n === "inherit")
      return {
        [i]: n
      };
    const C = em(r, I) || {};
    return d ? d(o) : Ys(o, n, (b) => {
      let m = NV(C, c, b);
      return b === m && typeof b == "string" && (m = NV(C, c, `${i}${b === "default" ? "" : ve(b)}`, b)), a === !1 ? m : {
        [a]: m
      };
    });
  }
  function t(i) {
    var n;
    const {
      sx: r,
      theme: g = {}
    } = i || {};
    if (!r)
      return null;
    const o = (n = g.unstable_sxConfig) != null ? n : uZ;
    function l(a) {
      let I = a;
      if (typeof a == "function")
        I = a(g);
      else if (typeof a != "object")
        return a;
      if (!I)
        return null;
      const c = lQ(g.breakpoints), d = Object.keys(c);
      let C = c;
      return Object.keys(I).forEach((A) => {
        const b = yse(I[A], g);
        if (b != null)
          if (typeof b == "object")
            if (o[A])
              C = TB(C, e(A, b, g, o));
            else {
              const m = Ys({
                theme: g
              }, b, (p) => ({
                [A]: p
              }));
              Gse(m, b) ? C[A] = t({
                sx: b,
                theme: g
              }) : C = TB(C, m);
            }
          else
            C = TB(C, e(A, b, g, o));
      }), aQ(d, C);
    }
    return Array.isArray(r) ? r.map(l) : l(r);
  }
  return t;
}
const Gm = IQ();
Gm.filterProps = ["sx"];
function cQ(e, t) {
  const i = this;
  return i.vars && typeof i.getColorSchemeSelector == "function" ? {
    [i.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : i.palette.mode === e ? t : {};
}
const Wse = ["breakpoints", "palette", "spacing", "shape"];
function CZ(e = {}, ...t) {
  const {
    breakpoints: i = {},
    palette: n = {},
    spacing: r,
    shape: g = {}
  } = e, o = tt(e, Wse), l = oQ(i), a = Uae(r);
  let I = pg({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: F({
      mode: "light"
    }, n),
    spacing: a,
    shape: F({}, xae, g)
  }, o);
  return I.applyStyles = cQ, I = t.reduce((c, d) => pg(c, d), I), I.unstable_sxConfig = F({}, uZ, o == null ? void 0 : o.unstable_sxConfig), I.unstable_sx = function(d) {
    return Gm({
      sx: d,
      theme: this
    });
  }, I;
}
const Sse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CZ,
  private_createBreakpoints: oQ,
  unstable_applyStyles: cQ
}, Symbol.toStringTag, { value: "Module" }));
function Vse(e) {
  return Object.keys(e).length === 0;
}
function MD(e = null) {
  const t = X.useContext(SD);
  return !t || Vse(t) ? e : t;
}
const wse = CZ();
function AZ(e = wse) {
  return MD(e);
}
function vse({
  styles: e,
  themeId: t,
  defaultTheme: i = {}
}) {
  const n = AZ(i), r = typeof e == "function" ? e(t && n[t] || n) : e;
  return /* @__PURE__ */ ee(nQ, {
    styles: r
  });
}
const Rse = ["sx"], Xse = (e) => {
  var t, i;
  const n = {
    systemProps: {},
    otherProps: {}
  }, r = (t = e == null || (i = e.theme) == null ? void 0 : i.unstable_sxConfig) != null ? t : uZ;
  return Object.keys(e).forEach((g) => {
    r[g] ? n.systemProps[g] = e[g] : n.otherProps[g] = e[g];
  }), n;
};
function w2(e) {
  const {
    sx: t
  } = e, i = tt(e, Rse), {
    systemProps: n,
    otherProps: r
  } = Xse(i);
  let g;
  return Array.isArray(t) ? g = [n, ...t] : typeof t == "function" ? g = (...o) => {
    const l = t(...o);
    return pc(l) ? F({}, n, l) : n;
  } : g = F({}, n, t), F({}, r, {
    sx: g
  });
}
const Hse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gm,
  extendSxProp: w2,
  unstable_createStyleFunctionSx: IQ,
  unstable_defaultSxConfig: uZ
}, Symbol.toStringTag, { value: "Module" })), LL = (e) => e, kse = () => {
  let e = LL;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = LL;
    }
  };
}, v2 = kse();
function dQ(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var r = e.length;
      for (t = 0; t < r; t++)
        e[t] && (i = dQ(e[t])) && (n && (n += " "), n += i);
    } else
      for (i in e)
        e[i] && (n && (n += " "), n += i);
  return n;
}
function Re() {
  for (var e, t, i = 0, n = "", r = arguments.length; i < r; i++)
    (e = arguments[i]) && (t = dQ(e)) && (n && (n += " "), n += t);
  return n;
}
const Yse = ["className", "component"];
function uQ(e = {}) {
  const {
    themeId: t,
    defaultTheme: i,
    defaultClassName: n = "MuiBox-root",
    generateClassName: r
  } = e, g = JD("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(Gm);
  return /* @__PURE__ */ X.forwardRef(function(a, I) {
    const c = AZ(i), d = w2(a), {
      className: C,
      component: A = "div"
    } = d, b = tt(d, Yse);
    return /* @__PURE__ */ ee(g, F({
      as: A,
      ref: I,
      className: Re(C, r ? r(n) : n),
      theme: t && c[t] || c
    }, b));
  });
}
const CQ = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Lt(e, t, i = "Mui") {
  const n = CQ[t];
  return n ? `${i}-${n}` : `${v2.generate(e)}-${t}`;
}
function Dt(e, t, i = "Mui") {
  const n = {};
  return t.forEach((r) => {
    n[r] = Lt(e, r, i);
  }), n;
}
const Fse = Dt("MuiBox", ["root"]), vo = uQ({
  defaultClassName: Fse.root,
  generateClassName: v2.generate
});
var AQ = { exports: {} }, vn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var PD = Symbol.for("react.element"), UD = Symbol.for("react.portal"), R2 = Symbol.for("react.fragment"), X2 = Symbol.for("react.strict_mode"), H2 = Symbol.for("react.profiler"), k2 = Symbol.for("react.provider"), Y2 = Symbol.for("react.context"), xse = Symbol.for("react.server_context"), F2 = Symbol.for("react.forward_ref"), x2 = Symbol.for("react.suspense"), D2 = Symbol.for("react.suspense_list"), J2 = Symbol.for("react.memo"), E2 = Symbol.for("react.lazy"), Dse = Symbol.for("react.offscreen"), bQ;
bQ = Symbol.for("react.module.reference");
function Oa(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case PD:
        switch (e = e.type, e) {
          case R2:
          case H2:
          case X2:
          case x2:
          case D2:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case xse:
              case Y2:
              case F2:
              case E2:
              case J2:
              case k2:
                return e;
              default:
                return t;
            }
        }
      case UD:
        return t;
    }
  }
}
vn.ContextConsumer = Y2;
vn.ContextProvider = k2;
vn.Element = PD;
vn.ForwardRef = F2;
vn.Fragment = R2;
vn.Lazy = E2;
vn.Memo = J2;
vn.Portal = UD;
vn.Profiler = H2;
vn.StrictMode = X2;
vn.Suspense = x2;
vn.SuspenseList = D2;
vn.isAsyncMode = function() {
  return !1;
};
vn.isConcurrentMode = function() {
  return !1;
};
vn.isContextConsumer = function(e) {
  return Oa(e) === Y2;
};
vn.isContextProvider = function(e) {
  return Oa(e) === k2;
};
vn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === PD;
};
vn.isForwardRef = function(e) {
  return Oa(e) === F2;
};
vn.isFragment = function(e) {
  return Oa(e) === R2;
};
vn.isLazy = function(e) {
  return Oa(e) === E2;
};
vn.isMemo = function(e) {
  return Oa(e) === J2;
};
vn.isPortal = function(e) {
  return Oa(e) === UD;
};
vn.isProfiler = function(e) {
  return Oa(e) === H2;
};
vn.isStrictMode = function(e) {
  return Oa(e) === X2;
};
vn.isSuspense = function(e) {
  return Oa(e) === x2;
};
vn.isSuspenseList = function(e) {
  return Oa(e) === D2;
};
vn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === R2 || e === H2 || e === X2 || e === x2 || e === D2 || e === Dse || typeof e == "object" && e !== null && (e.$$typeof === E2 || e.$$typeof === J2 || e.$$typeof === k2 || e.$$typeof === Y2 || e.$$typeof === F2 || e.$$typeof === bQ || e.getModuleId !== void 0);
};
vn.typeOf = Oa;
AQ.exports = vn;
var KL = AQ.exports;
const Jse = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function hQ(e) {
  const t = `${e}`.match(Jse);
  return t && t[1] || "";
}
function mQ(e, t = "") {
  return e.displayName || e.name || hQ(e) || t;
}
function TL(e, t, i) {
  const n = mQ(t);
  return e.displayName || (n !== "" ? `${i}(${n})` : i);
}
function Ese(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return mQ(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case KL.ForwardRef:
          return TL(e, e.render, "ForwardRef");
        case KL.Memo:
          return TL(e, e.type, "memo");
        default:
          return;
      }
  }
}
const Nse = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ese,
  getFunctionName: hQ
}, Symbol.toStringTag, { value: "Module" })), Lse = ["ownerState"], Kse = ["variants"], Tse = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function Mse(e) {
  return Object.keys(e).length === 0;
}
function Pse(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function oV(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Use = CZ(), zse = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function wW({
  defaultTheme: e,
  theme: t,
  themeId: i
}) {
  return Mse(t) ? e : t[i] || t;
}
function Ose(e) {
  return e ? (t, i) => i[e] : null;
}
function lV(e, t) {
  let {
    ownerState: i
  } = t, n = tt(t, Lse);
  const r = typeof e == "function" ? e(F({
    ownerState: i
  }, n)) : e;
  if (Array.isArray(r))
    return r.flatMap((g) => lV(g, F({
      ownerState: i
    }, n)));
  if (r && typeof r == "object" && Array.isArray(r.variants)) {
    const {
      variants: g = []
    } = r;
    let l = tt(r, Kse);
    return g.forEach((a) => {
      let I = !0;
      typeof a.props == "function" ? I = a.props(F({
        ownerState: i
      }, n, i)) : Object.keys(a.props).forEach((c) => {
        (i == null ? void 0 : i[c]) !== a.props[c] && n[c] !== a.props[c] && (I = !1);
      }), I && (Array.isArray(l) || (l = [l]), l.push(typeof a.style == "function" ? a.style(F({
        ownerState: i
      }, n, i)) : a.style));
    }), l;
  }
  return r;
}
function Qse(e = {}) {
  const {
    themeId: t,
    defaultTheme: i = Use,
    rootShouldForwardProp: n = oV,
    slotShouldForwardProp: r = oV
  } = e, g = (o) => Gm(F({}, o, {
    theme: wW(F({}, o, {
      defaultTheme: i,
      themeId: t
    }))
  }));
  return g.__mui_systemSx = !0, (o, l = {}) => {
    rQ(o, (W) => W.filter((V) => !(V != null && V.__mui_systemSx)));
    const {
      name: a,
      slot: I,
      skipVariantsResolver: c,
      skipSx: d,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: C = Ose(zse(I))
    } = l, A = tt(l, Tse), b = c !== void 0 ? c : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      I && I !== "Root" && I !== "root" || !1
    ), m = d || !1;
    let p, B = oV;
    I === "Root" || I === "root" ? B = n : I ? B = r : Pse(o) && (B = void 0);
    const f = JD(o, F({
      shouldForwardProp: B,
      label: p
    }, A)), Z = (W) => typeof W == "function" && W.__emotion_real !== W || pc(W) ? (V) => lV(W, F({}, V, {
      theme: wW({
        theme: V.theme,
        defaultTheme: i,
        themeId: t
      })
    })) : W, y = (W, ...V) => {
      let w = Z(W);
      const v = V ? V.map(Z) : [];
      a && C && v.push((J) => {
        const K = wW(F({}, J, {
          defaultTheme: i,
          themeId: t
        }));
        if (!K.components || !K.components[a] || !K.components[a].styleOverrides)
          return null;
        const M = K.components[a].styleOverrides, L = {};
        return Object.entries(M).forEach(([N, U]) => {
          L[N] = lV(U, F({}, J, {
            theme: K
          }));
        }), C(J, L);
      }), a && !b && v.push((J) => {
        var K;
        const M = wW(F({}, J, {
          defaultTheme: i,
          themeId: t
        })), L = M == null || (K = M.components) == null || (K = K[a]) == null ? void 0 : K.variants;
        return lV({
          variants: L
        }, F({}, J, {
          theme: M
        }));
      }), m || v.push(g);
      const H = v.length - V.length;
      if (Array.isArray(W) && H > 0) {
        const J = new Array(H).fill("");
        w = [...W, ...J], w.raw = [...W.raw, ...J];
      }
      const x = f(w, ...v);
      return o.muiName && (x.muiName = o.muiName), x;
    };
    return f.withConfig && (y.withConfig = f.withConfig), y;
  };
}
const jse = Qse();
function N2(e, t) {
  const i = F({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      i[n] = F({}, e[n], i[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const r = e[n] || {}, g = t[n];
      i[n] = {}, !g || !Object.keys(g) ? i[n] = r : !r || !Object.keys(r) ? i[n] = g : (i[n] = F({}, g), Object.keys(r).forEach((o) => {
        i[n][o] = N2(r[o], g[o]);
      }));
    } else
      i[n] === void 0 && (i[n] = e[n]);
  }), i;
}
function pQ(e) {
  const {
    theme: t,
    name: i,
    props: n
  } = e;
  return !t || !t.components || !t.components[i] || !t.components[i].defaultProps ? n : N2(t.components[i].defaultProps, n);
}
function BQ({
  props: e,
  name: t,
  defaultTheme: i,
  themeId: n
}) {
  let r = AZ(i);
  return n && (r = r[n] || r), pQ({
    theme: r,
    name: t,
    props: e
  });
}
const no = typeof window < "u" ? X.useLayoutEffect : X.useEffect;
function qse(e, t, i, n, r) {
  const [g, o] = X.useState(() => r && i ? i(e).matches : n ? n(e).matches : t);
  return no(() => {
    let l = !0;
    if (!i)
      return;
    const a = i(e), I = () => {
      l && o(a.matches);
    };
    return I(), a.addListener(I), () => {
      l = !1, a.removeListener(I);
    };
  }, [e, i]), g;
}
const fQ = X.useSyncExternalStore;
function _se(e, t, i, n, r) {
  const g = X.useCallback(() => t, [t]), o = X.useMemo(() => {
    if (r && i)
      return () => i(e).matches;
    if (n !== null) {
      const {
        matches: c
      } = n(e);
      return () => c;
    }
    return g;
  }, [g, e, n, r, i]), [l, a] = X.useMemo(() => {
    if (i === null)
      return [g, () => () => {
      }];
    const c = i(e);
    return [() => c.matches, (d) => (c.addListener(d), () => {
      c.removeListener(d);
    })];
  }, [g, i, e]);
  return fQ(a, l, o);
}
function $se(e, t = {}) {
  const i = MD(), n = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: r = !1,
    matchMedia: g = n ? window.matchMedia : null,
    ssrMatchMedia: o = null,
    noSsr: l = !1
  } = pQ({
    name: "MuiUseMediaQuery",
    props: t,
    theme: i
  });
  let a = typeof e == "function" ? e(i) : e;
  return a = a.replace(/^@media( ?)/m, ""), (fQ !== void 0 ? _se : qse)(a, r, g, o, l);
}
function vC(e, t = Number.MIN_SAFE_INTEGER, i = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, i));
}
const eIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vC
}, Symbol.toStringTag, { value: "Module" }));
function zD(e, t = 0, i = 1) {
  return vC(e, t, i);
}
function tIe(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(t);
  return i && i[0].length === 1 && (i = i.map((n) => n + n)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((n, r) => r < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function L2(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return L2(tIe(e));
  const t = e.indexOf("("), i = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error(yI(9, e));
  let n = e.substring(t + 1, e.length - 1), r;
  if (i === "color") {
    if (n = n.split(" "), r = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(r) === -1)
      throw new Error(yI(10, r));
  } else
    n = n.split(",");
  return n = n.map((g) => parseFloat(g)), {
    type: i,
    values: n,
    colorSpace: r
  };
}
function OD(e) {
  const {
    type: t,
    colorSpace: i
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((r, g) => g < 3 ? parseInt(r, 10) : r) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${i} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function uI(e, t) {
  return e = L2(e), t = zD(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, OD(e);
}
function v7t(e, t) {
  if (e = L2(e), t = zD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - t;
  return OD(e);
}
function R7t(e, t) {
  if (e = L2(e), t = zD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * t;
  return OD(e);
}
const Ax = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
function LV(...e) {
  return e.reduce((t, i) => i == null ? t : function(...r) {
    t.apply(this, r), i.apply(this, r);
  }, () => {
  });
}
function ym(e, t = 166) {
  let i;
  function n(...r) {
    const g = () => {
      e.apply(this, r);
    };
    clearTimeout(i), i = setTimeout(g, t);
  }
  return n.clear = () => {
    clearTimeout(i);
  }, n;
}
function iIe(e, t) {
  return () => null;
}
function MB(e, t) {
  var i, n;
  return /* @__PURE__ */ X.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (i = e.type.muiName) != null ? i : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function Vr(e) {
  return e && e.ownerDocument || document;
}
function Ja(e) {
  return Vr(e).defaultView || window;
}
function nIe(e, t) {
  return () => null;
}
function Wf(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let ML = 0;
function rIe(e) {
  const [t, i] = X.useState(e), n = e || t;
  return X.useEffect(() => {
    t == null && (ML += 1, i(`mui-${ML}`));
  }, [t]), n;
}
const PL = X.useId;
function uA(e) {
  if (PL !== void 0) {
    const t = PL();
    return e ?? t;
  }
  return rIe(e);
}
function gIe(e, t, i, n, r) {
  return null;
}
function Xs({
  controlled: e,
  default: t,
  name: i,
  state: n = "value"
}) {
  const {
    current: r
  } = X.useRef(e !== void 0), [g, o] = X.useState(t), l = r ? e : g, a = X.useCallback((I) => {
    r || o(I);
  }, []);
  return [l, a];
}
function Qr(e) {
  const t = X.useRef(e);
  return no(() => {
    t.current = e;
  }), X.useRef((...i) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...i)
  )).current;
}
function Zn(...e) {
  return X.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((i) => {
      Wf(i, t);
    });
  }, e);
}
const UL = {};
function oIe(e, t) {
  const i = X.useRef(UL);
  return i.current === UL && (i.current = e(t)), i;
}
const lIe = [];
function aIe(e) {
  X.useEffect(e, lIe);
}
class bZ {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new bZ();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, i) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, i();
    }, t);
  }
}
function DC() {
  const e = oIe(bZ.create).current;
  return aIe(e.disposeEffect), e;
}
let K2 = !0, bx = !1;
const sIe = new bZ(), IIe = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function cIe(e) {
  const {
    type: t,
    tagName: i
  } = e;
  return !!(i === "INPUT" && IIe[t] && !e.readOnly || i === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function dIe(e) {
  e.metaKey || e.altKey || e.ctrlKey || (K2 = !0);
}
function tY() {
  K2 = !1;
}
function uIe() {
  this.visibilityState === "hidden" && bx && (K2 = !0);
}
function CIe(e) {
  e.addEventListener("keydown", dIe, !0), e.addEventListener("mousedown", tY, !0), e.addEventListener("pointerdown", tY, !0), e.addEventListener("touchstart", tY, !0), e.addEventListener("visibilitychange", uIe, !0);
}
function AIe(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return K2 || cIe(t);
}
function hZ() {
  const e = X.useCallback((r) => {
    r != null && CIe(r.ownerDocument);
  }, []), t = X.useRef(!1);
  function i() {
    return t.current ? (bx = !0, sIe.start(100, () => {
      bx = !1;
    }), t.current = !1, !0) : !1;
  }
  function n(r) {
    return AIe(r) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: i,
    ref: e
  };
}
function ZQ(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let nh;
function GQ() {
  if (nh)
    return nh;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), nh = "reverse", e.scrollLeft > 0 ? nh = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (nh = "negative")), document.body.removeChild(e), nh;
}
function bIe(e, t) {
  const i = e.scrollLeft;
  if (t !== "rtl")
    return i;
  switch (GQ()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + i;
    case "reverse":
      return e.scrollWidth - e.clientWidth - i;
    default:
      return i;
  }
}
const hIe = (e) => {
  const t = X.useRef({});
  return X.useEffect(() => {
    t.current = e;
  }), t.current;
};
function yQ(e) {
  return X.Children.toArray(e).filter((t) => /* @__PURE__ */ X.isValidElement(t));
}
const mIe = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function Mt(e, t, i = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (r) => {
      n[r] = e[r].reduce((g, o) => {
        if (o) {
          const l = t(o);
          l !== "" && g.push(l), i && i[o] && g.push(i[o]);
        }
        return g;
      }, []).join(" ");
    }
  ), n;
}
const WQ = /* @__PURE__ */ X.createContext(null);
function SQ() {
  return X.useContext(WQ);
}
const pIe = typeof Symbol == "function" && Symbol.for, BIe = pIe ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function fIe(e, t) {
  return typeof t == "function" ? t(e) : F({}, e, t);
}
function ZIe(e) {
  const {
    children: t,
    theme: i
  } = e, n = SQ(), r = X.useMemo(() => {
    const g = n === null ? i : fIe(n, i);
    return g != null && (g[BIe] = n !== null), g;
  }, [i, n]);
  return /* @__PURE__ */ ee(WQ.Provider, {
    value: r,
    children: t
  });
}
const GIe = ["value"], VQ = /* @__PURE__ */ X.createContext();
function yIe(e) {
  let {
    value: t
  } = e, i = tt(e, GIe);
  return /* @__PURE__ */ ee(VQ.Provider, F({
    value: t ?? !0
  }, i));
}
const CA = () => {
  const e = X.useContext(VQ);
  return e ?? !1;
}, zL = {};
function OL(e, t, i, n = !1) {
  return X.useMemo(() => {
    const r = e && t[e] || t;
    if (typeof i == "function") {
      const g = i(r), o = e ? F({}, t, {
        [e]: g
      }) : g;
      return n ? () => o : o;
    }
    return e ? F({}, t, {
      [e]: i
    }) : F({}, t, i);
  }, [e, t, i, n]);
}
function WIe(e) {
  const {
    children: t,
    theme: i,
    themeId: n
  } = e, r = MD(zL), g = SQ() || zL, o = OL(n, r, i), l = OL(n, g, i, !0), a = o.direction === "rtl";
  return /* @__PURE__ */ ee(ZIe, {
    theme: l,
    children: /* @__PURE__ */ ee(SD.Provider, {
      value: o,
      children: /* @__PURE__ */ ee(yIe, {
        value: a,
        children: t
      })
    })
  });
}
const SIe = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], VIe = CZ(), wIe = jse("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function vIe(e) {
  return BQ({
    props: e,
    name: "MuiStack",
    defaultTheme: VIe
  });
}
function RIe(e, t) {
  const i = X.Children.toArray(e).filter(Boolean);
  return i.reduce((n, r, g) => (n.push(r), g < i.length - 1 && n.push(/* @__PURE__ */ X.cloneElement(t, {
    key: `separator-${g}`
  })), n), []);
}
const XIe = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], HIe = ({
  ownerState: e,
  theme: t
}) => {
  let i = F({
    display: "flex",
    flexDirection: "column"
  }, Ys({
    theme: t
  }, eY({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (n) => ({
    flexDirection: n
  })));
  if (e.spacing) {
    const n = KD(t), r = Object.keys(t.breakpoints.values).reduce((a, I) => ((typeof e.spacing == "object" && e.spacing[I] != null || typeof e.direction == "object" && e.direction[I] != null) && (a[I] = !0), a), {}), g = eY({
      values: e.direction,
      base: r
    }), o = eY({
      values: e.spacing,
      base: r
    });
    typeof g == "object" && Object.keys(g).forEach((a, I, c) => {
      if (!g[a]) {
        const C = I > 0 ? g[c[I - 1]] : "column";
        g[a] = C;
      }
    }), i = pg(i, Ys({
      theme: t
    }, o, (a, I) => e.useFlexGap ? {
      gap: $C(n, a)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${XIe(I ? g[I] : e.direction)}`]: $C(n, a)
      }
    }));
  }
  return i = Dae(t.breakpoints, i), i;
};
function wQ(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = wIe,
    useThemeProps: i = vIe,
    componentName: n = "MuiStack"
  } = e, r = () => Mt({
    root: ["root"]
  }, (a) => Lt(n, a), {}), g = t(HIe);
  return /* @__PURE__ */ X.forwardRef(function(a, I) {
    const c = i(a), d = w2(c), {
      component: C = "div",
      direction: A = "column",
      spacing: b = 0,
      divider: m,
      children: p,
      className: B,
      useFlexGap: f = !1
    } = d, Z = tt(d, SIe), y = {
      direction: A,
      spacing: b,
      useFlexGap: f
    }, W = r();
    return /* @__PURE__ */ ee(g, F({
      as: C,
      ownerState: y,
      ref: I,
      className: Re(W.root, B)
    }, Z, {
      children: m ? RIe(p, m) : p
    }));
  });
}
const kIe = wQ();
function YIe(e, t) {
  return F({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Rr = {}, vQ = { exports: {} };
(function(e) {
  function t(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(vQ);
var yg = vQ.exports;
const FIe = /* @__PURE__ */ wc(Wae), xIe = /* @__PURE__ */ wc(eIe);
var RQ = yg;
Object.defineProperty(Rr, "__esModule", {
  value: !0
});
var Wi = Rr.alpha = YQ;
Rr.blend = zIe;
Rr.colorChannel = void 0;
var jd = Rr.darken = jD;
Rr.decomposeColor = Ea;
var QL = Rr.emphasize = FQ, DIe = Rr.getContrastRatio = KIe;
Rr.getLuminance = KV;
Rr.hexToRgb = XQ;
Rr.hslToRgb = kQ;
var qd = Rr.lighten = qD;
Rr.private_safeAlpha = TIe;
Rr.private_safeColorChannel = void 0;
Rr.private_safeDarken = MIe;
Rr.private_safeEmphasize = UIe;
Rr.private_safeLighten = PIe;
Rr.recomposeColor = Wm;
Rr.rgbToHex = LIe;
var jL = RQ(FIe), JIe = RQ(xIe);
function QD(e, t = 0, i = 1) {
  return (0, JIe.default)(e, t, i);
}
function XQ(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let i = e.match(t);
  return i && i[0].length === 1 && (i = i.map((n) => n + n)), i ? `rgb${i.length === 4 ? "a" : ""}(${i.map((n, r) => r < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function EIe(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Ea(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ea(XQ(e));
  const t = e.indexOf("("), i = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(i) === -1)
    throw new Error((0, jL.default)(9, e));
  let n = e.substring(t + 1, e.length - 1), r;
  if (i === "color") {
    if (n = n.split(" "), r = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(r) === -1)
      throw new Error((0, jL.default)(10, r));
  } else
    n = n.split(",");
  return n = n.map((g) => parseFloat(g)), {
    type: i,
    values: n,
    colorSpace: r
  };
}
const HQ = (e) => {
  const t = Ea(e);
  return t.values.slice(0, 3).map((i, n) => t.type.indexOf("hsl") !== -1 && n !== 0 ? `${i}%` : i).join(" ");
};
Rr.colorChannel = HQ;
const NIe = (e, t) => {
  try {
    return HQ(e);
  } catch {
    return e;
  }
};
Rr.private_safeColorChannel = NIe;
function Wm(e) {
  const {
    type: t,
    colorSpace: i
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((r, g) => g < 3 ? parseInt(r, 10) : r) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${i} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function LIe(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = Ea(e);
  return `#${t.map((i, n) => EIe(n === 3 ? Math.round(255 * i) : i)).join("")}`;
}
function kQ(e) {
  e = Ea(e);
  const {
    values: t
  } = e, i = t[0], n = t[1] / 100, r = t[2] / 100, g = n * Math.min(r, 1 - r), o = (I, c = (I + i / 30) % 12) => r - g * Math.max(Math.min(c - 3, 9 - c, 1), -1);
  let l = "rgb";
  const a = [Math.round(o(0) * 255), Math.round(o(8) * 255), Math.round(o(4) * 255)];
  return e.type === "hsla" && (l += "a", a.push(t[3])), Wm({
    type: l,
    values: a
  });
}
function KV(e) {
  e = Ea(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Ea(kQ(e)).values : e.values;
  return t = t.map((i) => (e.type !== "color" && (i /= 255), i <= 0.03928 ? i / 12.92 : ((i + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function KIe(e, t) {
  const i = KV(e), n = KV(t);
  return (Math.max(i, n) + 0.05) / (Math.min(i, n) + 0.05);
}
function YQ(e, t) {
  return e = Ea(e), t = QD(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Wm(e);
}
function TIe(e, t, i) {
  try {
    return YQ(e, t);
  } catch {
    return e;
  }
}
function jD(e, t) {
  if (e = Ea(e), t = QD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] *= 1 - t;
  return Wm(e);
}
function MIe(e, t, i) {
  try {
    return jD(e, t);
  } catch {
    return e;
  }
}
function qD(e, t) {
  if (e = Ea(e), t = QD(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (255 - e.values[i]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let i = 0; i < 3; i += 1)
      e.values[i] += (1 - e.values[i]) * t;
  return Wm(e);
}
function PIe(e, t, i) {
  try {
    return qD(e, t);
  } catch {
    return e;
  }
}
function FQ(e, t = 0.15) {
  return KV(e) > 0.5 ? jD(e, t) : qD(e, t);
}
function UIe(e, t, i) {
  try {
    return FQ(e, t);
  } catch {
    return e;
  }
}
function zIe(e, t, i, n = 1) {
  const r = (a, I) => Math.round((a ** (1 / n) * (1 - i) + I ** (1 / n) * i) ** n), g = Ea(e), o = Ea(t), l = [r(g.values[0], o.values[0]), r(g.values[1], o.values[1]), r(g.values[2], o.values[2])];
  return Wm({
    type: "rgb",
    values: l
  });
}
const OIe = ["mode", "contrastThreshold", "tonalOffset"], qL = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: yf.white,
    default: yf.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, iY = {
  text: {
    primary: yf.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: yf.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function _L(e, t, i, n) {
  const r = n.light || n, g = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(i) ? e[t] = e[i] : t === "light" ? e.light = qd(e.main, r) : t === "dark" && (e.dark = jd(e.main, g)));
}
function QIe(e = "light") {
  return e === "dark" ? {
    main: eh[200],
    light: eh[50],
    dark: eh[400]
  } : {
    main: eh[700],
    light: eh[400],
    dark: eh[800]
  };
}
function jIe(e = "light") {
  return e === "dark" ? {
    main: $b[200],
    light: $b[50],
    dark: $b[400]
  } : {
    main: $b[500],
    light: $b[300],
    dark: $b[700]
  };
}
function qIe(e = "light") {
  return e === "dark" ? {
    main: _b[500],
    light: _b[300],
    dark: _b[700]
  } : {
    main: _b[700],
    light: _b[400],
    dark: _b[800]
  };
}
function _Ie(e = "light") {
  return e === "dark" ? {
    main: th[400],
    light: th[300],
    dark: th[700]
  } : {
    main: th[700],
    light: th[500],
    dark: th[900]
  };
}
function $Ie(e = "light") {
  return e === "dark" ? {
    main: ih[400],
    light: ih[300],
    dark: ih[700]
  } : {
    main: ih[800],
    light: ih[500],
    dark: ih[900]
  };
}
function ece(e = "light") {
  return e === "dark" ? {
    main: P0[400],
    light: P0[300],
    dark: P0[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: P0[500],
    dark: P0[900]
  };
}
function tce(e) {
  const {
    mode: t = "light",
    contrastThreshold: i = 3,
    tonalOffset: n = 0.2
  } = e, r = tt(e, OIe), g = e.primary || QIe(t), o = e.secondary || jIe(t), l = e.error || qIe(t), a = e.info || _Ie(t), I = e.success || $Ie(t), c = e.warning || ece(t);
  function d(m) {
    return DIe(m, iY.text.primary) >= i ? iY.text.primary : qL.text.primary;
  }
  const C = ({
    color: m,
    name: p,
    mainShade: B = 500,
    lightShade: f = 300,
    darkShade: Z = 700
  }) => {
    if (m = F({}, m), !m.main && m[B] && (m.main = m[B]), !m.hasOwnProperty("main"))
      throw new Error(yI(11, p ? ` (${p})` : "", B));
    if (typeof m.main != "string")
      throw new Error(yI(12, p ? ` (${p})` : "", JSON.stringify(m.main)));
    return _L(m, "light", f, n), _L(m, "dark", Z, n), m.contrastText || (m.contrastText = d(m.main)), m;
  }, A = {
    dark: iY,
    light: qL
  };
  return pg(F({
    // A collection of common colors.
    common: F({}, yf),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: C({
      color: g,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: C({
      color: o,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: C({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: C({
      color: c,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: C({
      color: a,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: C({
      color: I,
      name: "success"
    }),
    // The grey colors.
    grey: _4,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: i,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: C,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, A[t]), r);
}
const ice = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function nce(e) {
  return Math.round(e * 1e5) / 1e5;
}
const $L = {
  textTransform: "uppercase"
}, eK = '"Roboto", "Helvetica", "Arial", sans-serif';
function rce(e, t) {
  const i = typeof t == "function" ? t(e) : t, {
    fontFamily: n = eK,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: g = 300,
    fontWeightRegular: o = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: a = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: I = 16,
    // Apply the CSS properties to all the variants.
    allVariants: c,
    pxToRem: d
  } = i, C = tt(i, ice), A = r / 14, b = d || ((B) => `${B / I * A}rem`), m = (B, f, Z, y, W) => F({
    fontFamily: n,
    fontWeight: B,
    fontSize: b(f),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Z
  }, n === eK ? {
    letterSpacing: `${nce(y / f)}em`
  } : {}, W, c), p = {
    h1: m(g, 96, 1.167, -1.5),
    h2: m(g, 60, 1.2, -0.5),
    h3: m(o, 48, 1.167, 0),
    h4: m(o, 34, 1.235, 0.25),
    h5: m(o, 24, 1.334, 0),
    h6: m(l, 20, 1.6, 0.15),
    subtitle1: m(o, 16, 1.75, 0.15),
    subtitle2: m(l, 14, 1.57, 0.1),
    body1: m(o, 16, 1.5, 0.15),
    body2: m(o, 14, 1.43, 0.15),
    button: m(l, 14, 1.75, 0.4, $L),
    caption: m(o, 12, 1.66, 0.4),
    overline: m(o, 12, 2.66, 1, $L),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return pg(F({
    htmlFontSize: I,
    pxToRem: b,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: g,
    fontWeightRegular: o,
    fontWeightMedium: l,
    fontWeightBold: a
  }, p), C, {
    clone: !1
    // No need to clone deep
  });
}
const gce = 0.2, oce = 0.14, lce = 0.12;
function _n(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${gce})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${oce})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${lce})`].join(",");
}
const ace = ["none", _n(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), _n(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), _n(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), _n(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), _n(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), _n(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), _n(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), _n(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), _n(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), _n(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), _n(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), _n(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), _n(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), _n(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), _n(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), _n(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), _n(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), _n(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), _n(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), _n(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), _n(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), _n(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), _n(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), _n(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], sce = ["duration", "easing", "delay"], Ice = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, xQ = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function tK(e) {
  return `${Math.round(e)}ms`;
}
function cce(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function dce(e) {
  const t = F({}, Ice, e.easing), i = F({}, xQ, e.duration);
  return F({
    getAutoHeightDuration: cce,
    create: (r = ["all"], g = {}) => {
      const {
        duration: o = i.standard,
        easing: l = t.easeInOut,
        delay: a = 0
      } = g;
      return tt(g, sce), (Array.isArray(r) ? r : [r]).map((I) => `${I} ${typeof o == "string" ? o : tK(o)} ${l} ${typeof a == "string" ? a : tK(a)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: i
  });
}
const uce = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Cce = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Sm(e = {}, ...t) {
  const {
    mixins: i = {},
    palette: n = {},
    transitions: r = {},
    typography: g = {}
  } = e, o = tt(e, Cce);
  if (e.vars)
    throw new Error(yI(18));
  const l = tce(n), a = CZ(e);
  let I = pg(a, {
    mixins: YIe(a.breakpoints, i),
    palette: l,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: ace.slice(),
    typography: rce(l, g),
    transitions: dce(r),
    zIndex: F({}, uce)
  });
  return I = pg(I, o), I = t.reduce((c, d) => pg(c, d), I), I.unstable_sxConfig = F({}, uZ, o == null ? void 0 : o.unstable_sxConfig), I.unstable_sx = function(d) {
    return Gm({
      sx: d,
      theme: this
    });
  }, I;
}
function iK(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function DQ(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function pd(e) {
  return parseFloat(e);
}
function Ace(e) {
  return (t, i) => {
    const n = DQ(t);
    if (n === i)
      return t;
    let r = pd(t);
    n !== "px" && (n === "em" || n === "rem") && (r = pd(t) * pd(e));
    let g = r;
    if (i !== "px")
      if (i === "em")
        g = r / pd(e);
      else if (i === "rem")
        g = r / pd(e);
      else
        return t;
    return parseFloat(g.toFixed(5)) + i;
  };
}
function bce({
  size: e,
  grid: t
}) {
  const i = e - e % t, n = i + t;
  return e - i < n - e ? i : n;
}
function hce({
  lineHeight: e,
  pixels: t,
  htmlFontSize: i
}) {
  return t / (e * i);
}
function mce({
  cssProperty: e,
  min: t,
  max: i,
  unit: n = "rem",
  breakpoints: r = [600, 900, 1200],
  transform: g = null
}) {
  const o = {
    [e]: `${t}${n}`
  }, l = (i - t) / r[r.length - 1];
  return r.forEach((a) => {
    let I = t + l * a;
    g !== null && (I = g(I)), o[`@media (min-width:${a}px)`] = {
      [e]: `${Math.round(I * 1e4) / 1e4}${n}`
    };
  }), o;
}
function _D(e, t = {}) {
  const {
    breakpoints: i = ["sm", "md", "lg"],
    disableAlign: n = !1,
    factor: r = 2,
    variants: g = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, o = F({}, e);
  o.typography = F({}, o.typography);
  const l = o.typography, a = Ace(l.htmlFontSize), I = i.map((c) => o.breakpoints.values[c]);
  return g.forEach((c) => {
    const d = l[c], C = parseFloat(a(d.fontSize, "rem"));
    if (C <= 1)
      return;
    const A = C, b = 1 + (A - 1) / r;
    let {
      lineHeight: m
    } = d;
    if (!iK(m) && !n)
      throw new Error(yI(6));
    iK(m) || (m = parseFloat(a(m, "rem")) / parseFloat(C));
    let p = null;
    n || (p = (B) => bce({
      size: B,
      grid: hce({
        pixels: 4,
        lineHeight: m,
        htmlFontSize: l.htmlFontSize
      })
    })), l[c] = F({}, d, mce({
      cssProperty: "fontSize",
      min: b,
      max: A,
      unit: "rem",
      breakpoints: I,
      transform: p
    }));
  }), o;
}
const T2 = Sm();
function ql() {
  const e = AZ(T2);
  return e[_C] || e;
}
function _t({
  props: e,
  name: t
}) {
  return BQ({
    props: e,
    name: t,
    defaultTheme: T2,
    themeId: _C
  });
}
var mZ = {}, nY = { exports: {} }, nK;
function pce() {
  return nK || (nK = 1, function(e) {
    function t() {
      return e.exports = t = Object.assign ? Object.assign.bind() : function(i) {
        for (var n = 1; n < arguments.length; n++) {
          var r = arguments[n];
          for (var g in r)
            Object.prototype.hasOwnProperty.call(r, g) && (i[g] = r[g]);
        }
        return i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(nY)), nY.exports;
}
var rY = { exports: {} }, rK;
function Bce() {
  return rK || (rK = 1, function(e) {
    function t(i, n) {
      if (i == null)
        return {};
      var r = {};
      for (var g in i)
        if (Object.prototype.hasOwnProperty.call(i, g)) {
          if (n.indexOf(g) >= 0)
            continue;
          r[g] = i[g];
        }
      return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(rY)), rY.exports;
}
const JQ = /* @__PURE__ */ wc(Hae), fce = /* @__PURE__ */ wc(kae), Zce = /* @__PURE__ */ wc(Eae), Gce = /* @__PURE__ */ wc(Nse), yce = /* @__PURE__ */ wc(Sse), Wce = /* @__PURE__ */ wc(Hse);
var Vm = yg;
Object.defineProperty(mZ, "__esModule", {
  value: !0
});
var Sce = mZ.default = Ece, EQ = mZ.shouldForwardProp = aV;
mZ.systemDefaultTheme = void 0;
var Ba = Vm(pce()), hx = Vm(Bce()), gK = kce(JQ), Vce = fce;
Vm(Zce);
Vm(Gce);
var wce = Vm(yce), vce = Vm(Wce);
const Rce = ["ownerState"], Xce = ["variants"], Hce = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function NQ(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (NQ = function(n) {
    return n ? i : t;
  })(e);
}
function kce(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var i = NQ(t);
  if (i && i.has(e))
    return i.get(e);
  var n = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e)
    if (g !== "default" && Object.prototype.hasOwnProperty.call(e, g)) {
      var o = r ? Object.getOwnPropertyDescriptor(e, g) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, g, o) : n[g] = e[g];
    }
  return n.default = e, i && i.set(e, n), n;
}
function Yce(e) {
  return Object.keys(e).length === 0;
}
function Fce(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function aV(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const xce = mZ.systemDefaultTheme = (0, wce.default)(), Dce = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function vW({
  defaultTheme: e,
  theme: t,
  themeId: i
}) {
  return Yce(t) ? e : t[i] || t;
}
function Jce(e) {
  return e ? (t, i) => i[e] : null;
}
function sV(e, t) {
  let {
    ownerState: i
  } = t, n = (0, hx.default)(t, Rce);
  const r = typeof e == "function" ? e((0, Ba.default)({
    ownerState: i
  }, n)) : e;
  if (Array.isArray(r))
    return r.flatMap((g) => sV(g, (0, Ba.default)({
      ownerState: i
    }, n)));
  if (r && typeof r == "object" && Array.isArray(r.variants)) {
    const {
      variants: g = []
    } = r;
    let l = (0, hx.default)(r, Xce);
    return g.forEach((a) => {
      let I = !0;
      typeof a.props == "function" ? I = a.props((0, Ba.default)({
        ownerState: i
      }, n, i)) : Object.keys(a.props).forEach((c) => {
        (i == null ? void 0 : i[c]) !== a.props[c] && n[c] !== a.props[c] && (I = !1);
      }), I && (Array.isArray(l) || (l = [l]), l.push(typeof a.style == "function" ? a.style((0, Ba.default)({
        ownerState: i
      }, n, i)) : a.style));
    }), l;
  }
  return r;
}
function Ece(e = {}) {
  const {
    themeId: t,
    defaultTheme: i = xce,
    rootShouldForwardProp: n = aV,
    slotShouldForwardProp: r = aV
  } = e, g = (o) => (0, vce.default)((0, Ba.default)({}, o, {
    theme: vW((0, Ba.default)({}, o, {
      defaultTheme: i,
      themeId: t
    }))
  }));
  return g.__mui_systemSx = !0, (o, l = {}) => {
    (0, gK.internal_processStyles)(o, (W) => W.filter((V) => !(V != null && V.__mui_systemSx)));
    const {
      name: a,
      slot: I,
      skipVariantsResolver: c,
      skipSx: d,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: C = Jce(Dce(I))
    } = l, A = (0, hx.default)(l, Hce), b = c !== void 0 ? c : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      I && I !== "Root" && I !== "root" || !1
    ), m = d || !1;
    let p, B = aV;
    I === "Root" || I === "root" ? B = n : I ? B = r : Fce(o) && (B = void 0);
    const f = (0, gK.default)(o, (0, Ba.default)({
      shouldForwardProp: B,
      label: p
    }, A)), Z = (W) => typeof W == "function" && W.__emotion_real !== W || (0, Vce.isPlainObject)(W) ? (V) => sV(W, (0, Ba.default)({}, V, {
      theme: vW({
        theme: V.theme,
        defaultTheme: i,
        themeId: t
      })
    })) : W, y = (W, ...V) => {
      let w = Z(W);
      const v = V ? V.map(Z) : [];
      a && C && v.push((J) => {
        const K = vW((0, Ba.default)({}, J, {
          defaultTheme: i,
          themeId: t
        }));
        if (!K.components || !K.components[a] || !K.components[a].styleOverrides)
          return null;
        const M = K.components[a].styleOverrides, L = {};
        return Object.entries(M).forEach(([N, U]) => {
          L[N] = sV(U, (0, Ba.default)({}, J, {
            theme: K
          }));
        }), C(J, L);
      }), a && !b && v.push((J) => {
        var K;
        const M = vW((0, Ba.default)({}, J, {
          defaultTheme: i,
          themeId: t
        })), L = M == null || (K = M.components) == null || (K = K[a]) == null ? void 0 : K.variants;
        return sV({
          variants: L
        }, (0, Ba.default)({}, J, {
          theme: M
        }));
      }), m || v.push(g);
      const H = v.length - V.length;
      if (Array.isArray(W) && H > 0) {
        const J = new Array(H).fill("");
        w = [...W, ...J], w.raw = [...W.raw, ...J];
      }
      const x = f(w, ...v);
      return o.muiName && (x.muiName = o.muiName), x;
    };
    return f.withConfig && (y.withConfig = f.withConfig), y;
  };
}
function M2(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Wg = (e) => M2(e) && e !== "classes", Se = Sce({
  themeId: _C,
  defaultTheme: T2,
  rootShouldForwardProp: Wg
}), Nce = ["theme"];
function LQ(e) {
  let {
    theme: t
  } = e, i = tt(e, Nce);
  const n = t[_C];
  return /* @__PURE__ */ ee(WIe, F({}, i, {
    themeId: n ? _C : void 0,
    theme: n || t
  }));
}
const oK = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
};
function Lce(e) {
  return Lt("MuiSvgIcon", e);
}
Dt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Kce = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], Tce = (e) => {
  const {
    color: t,
    fontSize: i,
    classes: n
  } = e, r = {
    root: ["root", t !== "inherit" && `color${ve(t)}`, `fontSize${ve(i)}`]
  };
  return Mt(r, Lce, n);
}, Mce = Se("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "inherit" && t[`color${ve(i.color)}`], t[`fontSize${ve(i.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i, n, r, g, o, l, a, I, c, d, C, A, b;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (i = e.transitions) == null || (n = i.create) == null ? void 0 : n.call(i, "fill", {
      duration: (r = e.transitions) == null || (r = r.duration) == null ? void 0 : r.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((g = e.typography) == null || (o = g.pxToRem) == null ? void 0 : o.call(g, 20)) || "1.25rem",
      medium: ((l = e.typography) == null || (a = l.pxToRem) == null ? void 0 : a.call(l, 24)) || "1.5rem",
      large: ((I = e.typography) == null || (c = I.pxToRem) == null ? void 0 : c.call(I, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (d = (C = (e.vars || e).palette) == null || (C = C[t.color]) == null ? void 0 : C.main) != null ? d : {
      action: (A = (e.vars || e).palette) == null || (A = A.action) == null ? void 0 : A.active,
      disabled: (b = (e.vars || e).palette) == null || (b = b.action) == null ? void 0 : b.disabled,
      inherit: void 0
    }[t.color]
  };
}), mx = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: r,
    className: g,
    color: o = "inherit",
    component: l = "svg",
    fontSize: a = "medium",
    htmlColor: I,
    inheritViewBox: c = !1,
    titleAccess: d,
    viewBox: C = "0 0 24 24"
  } = n, A = tt(n, Kce), b = /* @__PURE__ */ X.isValidElement(r) && r.type === "svg", m = F({}, n, {
    color: o,
    component: l,
    fontSize: a,
    instanceFontSize: t.fontSize,
    inheritViewBox: c,
    viewBox: C,
    hasSvgAsChild: b
  }), p = {};
  c || (p.viewBox = C);
  const B = Tce(m);
  return /* @__PURE__ */ Ri(Mce, F({
    as: l,
    className: Re(B.root, g),
    focusable: "false",
    color: I,
    "aria-hidden": d ? void 0 : !0,
    role: d ? "img" : void 0,
    ref: i
  }, p, A, b && r.props, {
    ownerState: m,
    children: [b ? r.props.children : r, d ? /* @__PURE__ */ ee("title", {
      children: d
    }) : null]
  }));
});
mx.muiName = "SvgIcon";
function ai(e, t) {
  function i(n, r) {
    return /* @__PURE__ */ ee(mx, F({
      "data-testid": `${t}Icon`,
      ref: r
    }, n, {
      children: e
    }));
  }
  return i.muiName = mx.muiName, /* @__PURE__ */ X.memo(/* @__PURE__ */ X.forwardRef(i));
}
const Pce = {
  configure: (e) => {
    v2.configure(e);
  }
}, Uce = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: ve,
  createChainedFunction: LV,
  createSvgIcon: ai,
  debounce: ym,
  deprecatedPropType: iIe,
  isMuiElement: MB,
  ownerDocument: Vr,
  ownerWindow: Ja,
  requirePropFactory: nIe,
  setRef: Wf,
  unstable_ClassNameGenerator: Pce,
  unstable_useEnhancedEffect: no,
  unstable_useId: uA,
  unsupportedProp: gIe,
  useControlled: Xs,
  useEventCallback: Qr,
  useForkRef: Zn,
  useIsFocusVisible: hZ
}, Symbol.toStringTag, { value: "Module" }));
function ou(e) {
  return _t;
}
function jr(e, t) {
  if (e == null)
    return {};
  var i = {};
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) !== -1)
        continue;
      i[n] = e[n];
    }
  return i;
}
function TV(e, t) {
  return TV = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, TV(e, t);
}
function KQ(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, TV(e, t);
}
const lK = {
  disabled: !1
}, MV = De.createContext(null);
var zce = function(t) {
  return t.scrollTop;
}, yB = "unmounted", pC = "exited", BC = "entering", wh = "entered", px = "exiting", Qa = /* @__PURE__ */ function(e) {
  KQ(t, e);
  function t(n, r) {
    var g;
    g = e.call(this, n, r) || this;
    var o = r, l = o && !o.isMounting ? n.enter : n.appear, a;
    return g.appearStatus = null, n.in ? l ? (a = pC, g.appearStatus = BC) : a = wh : n.unmountOnExit || n.mountOnEnter ? a = yB : a = pC, g.state = {
      status: a
    }, g.nextCallback = null, g;
  }
  t.getDerivedStateFromProps = function(r, g) {
    var o = r.in;
    return o && g.status === yB ? {
      status: pC
    } : null;
  };
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(r) {
    var g = null;
    if (r !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== BC && o !== wh && (g = BC) : (o === BC || o === wh) && (g = px);
    }
    this.updateStatus(!1, g);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var r = this.props.timeout, g, o, l;
    return g = o = l = r, r != null && typeof r != "number" && (g = r.exit, o = r.enter, l = r.appear !== void 0 ? r.appear : o), {
      exit: g,
      enter: o,
      appear: l
    };
  }, i.updateStatus = function(r, g) {
    if (r === void 0 && (r = !1), g !== null)
      if (this.cancelNextCallback(), g === BC) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var o = this.props.nodeRef ? this.props.nodeRef.current : ZB.findDOMNode(this);
          o && zce(o);
        }
        this.performEnter(r);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === pC && this.setState({
        status: yB
      });
  }, i.performEnter = function(r) {
    var g = this, o = this.props.enter, l = this.context ? this.context.isMounting : r, a = this.props.nodeRef ? [l] : [ZB.findDOMNode(this), l], I = a[0], c = a[1], d = this.getTimeouts(), C = l ? d.appear : d.enter;
    if (!r && !o || lK.disabled) {
      this.safeSetState({
        status: wh
      }, function() {
        g.props.onEntered(I);
      });
      return;
    }
    this.props.onEnter(I, c), this.safeSetState({
      status: BC
    }, function() {
      g.props.onEntering(I, c), g.onTransitionEnd(C, function() {
        g.safeSetState({
          status: wh
        }, function() {
          g.props.onEntered(I, c);
        });
      });
    });
  }, i.performExit = function() {
    var r = this, g = this.props.exit, o = this.getTimeouts(), l = this.props.nodeRef ? void 0 : ZB.findDOMNode(this);
    if (!g || lK.disabled) {
      this.safeSetState({
        status: pC
      }, function() {
        r.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: px
    }, function() {
      r.props.onExiting(l), r.onTransitionEnd(o.exit, function() {
        r.safeSetState({
          status: pC
        }, function() {
          r.props.onExited(l);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(r, g) {
    g = this.setNextCallback(g), this.setState(r, g);
  }, i.setNextCallback = function(r) {
    var g = this, o = !0;
    return this.nextCallback = function(l) {
      o && (o = !1, g.nextCallback = null, r(l));
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(r, g) {
    this.setNextCallback(g);
    var o = this.props.nodeRef ? this.props.nodeRef.current : ZB.findDOMNode(this), l = r == null && !this.props.addEndListener;
    if (!o || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var a = this.props.nodeRef ? [this.nextCallback] : [o, this.nextCallback], I = a[0], c = a[1];
      this.props.addEndListener(I, c);
    }
    r != null && setTimeout(this.nextCallback, r);
  }, i.render = function() {
    var r = this.state.status;
    if (r === yB)
      return null;
    var g = this.props, o = g.children;
    g.in, g.mountOnEnter, g.unmountOnExit, g.appear, g.enter, g.exit, g.timeout, g.addEndListener, g.onEnter, g.onEntering, g.onEntered, g.onExit, g.onExiting, g.onExited, g.nodeRef;
    var l = jr(g, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ De.createElement(MV.Provider, {
        value: null
      }, typeof o == "function" ? o(r, l) : De.cloneElement(De.Children.only(o), l))
    );
  }, t;
}(De.Component);
Qa.contextType = MV;
Qa.propTypes = {};
function rh() {
}
Qa.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: rh,
  onEntering: rh,
  onEntered: rh,
  onExit: rh,
  onExiting: rh,
  onExited: rh
};
Qa.UNMOUNTED = yB;
Qa.EXITED = pC;
Qa.ENTERING = BC;
Qa.ENTERED = wh;
Qa.EXITING = px;
function TQ(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $D(e, t) {
  var i = function(g) {
    return t && KB(g) ? t(g) : g;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && p4.map(e, function(r) {
    return r;
  }).forEach(function(r) {
    n[r.key] = i(r);
  }), n;
}
function Oce(e, t) {
  e = e || {}, t = t || {};
  function i(c) {
    return c in t ? t[c] : e[c];
  }
  var n = /* @__PURE__ */ Object.create(null), r = [];
  for (var g in e)
    g in t ? r.length && (n[g] = r, r = []) : r.push(g);
  var o, l = {};
  for (var a in t) {
    if (n[a])
      for (o = 0; o < n[a].length; o++) {
        var I = n[a][o];
        l[n[a][o]] = i(I);
      }
    l[a] = i(a);
  }
  for (o = 0; o < r.length; o++)
    l[r[o]] = i(r[o]);
  return l;
}
function JC(e, t, i) {
  return i[t] != null ? i[t] : e.props[t];
}
function Qce(e, t) {
  return $D(e.children, function(i) {
    return Jd(i, {
      onExited: t.bind(null, i),
      in: !0,
      appear: JC(i, "appear", e),
      enter: JC(i, "enter", e),
      exit: JC(i, "exit", e)
    });
  });
}
function jce(e, t, i) {
  var n = $D(e.children), r = Oce(t, n);
  return Object.keys(r).forEach(function(g) {
    var o = r[g];
    if (KB(o)) {
      var l = g in t, a = g in n, I = t[g], c = KB(I) && !I.props.in;
      a && (!l || c) ? r[g] = Jd(o, {
        onExited: i.bind(null, o),
        in: !0,
        exit: JC(o, "exit", e),
        enter: JC(o, "enter", e)
      }) : !a && l && !c ? r[g] = Jd(o, {
        in: !1
      }) : a && l && KB(I) && (r[g] = Jd(o, {
        onExited: i.bind(null, o),
        in: I.props.in,
        exit: JC(o, "exit", e),
        enter: JC(o, "enter", e)
      }));
    }
  }), r;
}
var qce = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, _ce = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, eJ = /* @__PURE__ */ function(e) {
  KQ(t, e);
  function t(n, r) {
    var g;
    g = e.call(this, n, r) || this;
    var o = g.handleExited.bind(TQ(g));
    return g.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: o,
      firstRender: !0
    }, g;
  }
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, i.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(r, g) {
    var o = g.children, l = g.handleExited, a = g.firstRender;
    return {
      children: a ? Qce(r, l) : jce(r, o, l),
      firstRender: !1
    };
  }, i.handleExited = function(r, g) {
    var o = $D(this.props.children);
    r.key in o || (r.props.onExited && r.props.onExited(g), this.mounted && this.setState(function(l) {
      var a = et({}, l.children);
      return delete a[r.key], {
        children: a
      };
    }));
  }, i.render = function() {
    var r = this.props, g = r.component, o = r.childFactory, l = jr(r, ["component", "childFactory"]), a = this.state.contextValue, I = qce(this.state.children).map(o);
    return delete l.appear, delete l.enter, delete l.exit, g === null ? /* @__PURE__ */ De.createElement(MV.Provider, {
      value: a
    }, I) : /* @__PURE__ */ De.createElement(MV.Provider, {
      value: a
    }, /* @__PURE__ */ De.createElement(g, l, I));
  }, t;
}(De.Component);
eJ.propTypes = {};
eJ.defaultProps = _ce;
const tJ = (e) => e.scrollTop;
function _d(e, t) {
  var i, n;
  const {
    timeout: r,
    easing: g,
    style: o = {}
  } = e;
  return {
    duration: (i = o.transitionDuration) != null ? i : typeof r == "number" ? r : r[t.mode] || 0,
    easing: (n = o.transitionTimingFunction) != null ? n : typeof g == "object" ? g[t.mode] : g,
    delay: o.transitionDelay
  };
}
function $ce(e) {
  return Lt("MuiCollapse", e);
}
Dt("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const ede = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], tde = (e) => {
  const {
    orientation: t,
    classes: i
  } = e, n = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return Mt(n, $ce, i);
}, ide = Se("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.orientation], i.state === "entered" && t.entered, i.state === "exited" && !i.in && i.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && F({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), nde = Se("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => F({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), rde = Se("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => F({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), P2 = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: r,
    children: g,
    className: o,
    collapsedSize: l = "0px",
    component: a,
    easing: I,
    in: c,
    onEnter: d,
    onEntered: C,
    onEntering: A,
    onExit: b,
    onExited: m,
    onExiting: p,
    orientation: B = "vertical",
    style: f,
    timeout: Z = xQ.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: y = Qa
  } = n, W = tt(n, ede), V = F({}, n, {
    orientation: B,
    collapsedSize: l
  }), w = tde(V), v = ql(), H = DC(), x = X.useRef(null), J = X.useRef(), K = typeof l == "number" ? `${l}px` : l, M = B === "horizontal", L = M ? "width" : "height", N = X.useRef(null), U = Zn(i, N), O = (ue) => (Xe) => {
    if (ue) {
      const Ze = N.current;
      Xe === void 0 ? ue(Ze) : ue(Ze, Xe);
    }
  }, $ = () => x.current ? x.current[M ? "clientWidth" : "clientHeight"] : 0, ne = O((ue, Xe) => {
    x.current && M && (x.current.style.position = "absolute"), ue.style[L] = K, d && d(ue, Xe);
  }), be = O((ue, Xe) => {
    const Ze = $();
    x.current && M && (x.current.style.position = "");
    const {
      duration: xe,
      easing: Pe
    } = _d({
      style: f,
      timeout: Z,
      easing: I
    }, {
      mode: "enter"
    });
    if (Z === "auto") {
      const st = v.transitions.getAutoHeightDuration(Ze);
      ue.style.transitionDuration = `${st}ms`, J.current = st;
    } else
      ue.style.transitionDuration = typeof xe == "string" ? xe : `${xe}ms`;
    ue.style[L] = `${Ze}px`, ue.style.transitionTimingFunction = Pe, A && A(ue, Xe);
  }), Ve = O((ue, Xe) => {
    ue.style[L] = "auto", C && C(ue, Xe);
  }), He = O((ue) => {
    ue.style[L] = `${$()}px`, b && b(ue);
  }), Je = O(m), ke = O((ue) => {
    const Xe = $(), {
      duration: Ze,
      easing: xe
    } = _d({
      style: f,
      timeout: Z,
      easing: I
    }, {
      mode: "exit"
    });
    if (Z === "auto") {
      const Pe = v.transitions.getAutoHeightDuration(Xe);
      ue.style.transitionDuration = `${Pe}ms`, J.current = Pe;
    } else
      ue.style.transitionDuration = typeof Ze == "string" ? Ze : `${Ze}ms`;
    ue.style[L] = K, ue.style.transitionTimingFunction = xe, p && p(ue);
  });
  return /* @__PURE__ */ ee(y, F({
    in: c,
    onEnter: ne,
    onEntered: Ve,
    onEntering: be,
    onExit: He,
    onExited: Je,
    onExiting: ke,
    addEndListener: (ue) => {
      Z === "auto" && H.start(J.current || 0, ue), r && r(N.current, ue);
    },
    nodeRef: N,
    timeout: Z === "auto" ? null : Z
  }, W, {
    children: (ue, Xe) => /* @__PURE__ */ ee(ide, F({
      as: a,
      className: Re(w.root, o, {
        entered: w.entered,
        exited: !c && K === "0px" && w.hidden
      }[ue]),
      style: F({
        [M ? "minWidth" : "minHeight"]: K
      }, f),
      ref: U
    }, Xe, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: F({}, V, {
        state: ue
      }),
      children: /* @__PURE__ */ ee(nde, {
        ownerState: F({}, V, {
          state: ue
        }),
        className: w.wrapper,
        ref: x,
        children: /* @__PURE__ */ ee(rde, {
          ownerState: F({}, V, {
            state: ue
          }),
          className: w.wrapperInner,
          children: g
        })
      })
    }))
  }));
});
P2.muiSupportAuto = !0;
function gde(e) {
  return Lt("MuiPaper", e);
}
Dt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const ode = ["className", "component", "elevation", "square", "variant"], lde = (e) => {
  const {
    square: t,
    elevation: i,
    variant: n,
    classes: r
  } = e, g = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${i}`]
  };
  return Mt(g, gde, r);
}, ade = Se("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], !i.square && t.rounded, i.variant === "elevation" && t[`elevation${i.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i;
  return F({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && F({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Wi("#fff", oK(t.elevation))}, ${Wi("#fff", oK(t.elevation))})`
  }, e.vars && {
    backgroundImage: (i = e.vars.overlays) == null ? void 0 : i[t.elevation]
  }));
}), ul = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiPaper"
  }), {
    className: r,
    component: g = "div",
    elevation: o = 1,
    square: l = !1,
    variant: a = "elevation"
  } = n, I = tt(n, ode), c = F({}, n, {
    component: g,
    elevation: o,
    square: l,
    variant: a
  }), d = lde(c);
  return /* @__PURE__ */ ee(ade, F({
    as: g,
    ownerState: c,
    className: Re(d.root, r),
    ref: i
  }, I));
}), MQ = /* @__PURE__ */ X.createContext({});
function mI(e) {
  return typeof e == "string";
}
function xh(e, t, i) {
  return e === void 0 || mI(e) ? t : et({}, t, {
    ownerState: et({}, t.ownerState, i)
  });
}
function sde(e, t, i = (n, r) => n === r) {
  return e.length === t.length && e.every((n, r) => i(n, t[r]));
}
const Ide = {
  disableDefaultClasses: !1
}, cde = /* @__PURE__ */ X.createContext(Ide);
function dde(e) {
  const {
    disableDefaultClasses: t
  } = X.useContext(cde);
  return (i) => t ? "" : e(i);
}
function PB(e, t = []) {
  if (e === void 0)
    return {};
  const i = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    i[n] = e[n];
  }), i;
}
function PQ(e, t, i) {
  return typeof e == "function" ? e(t, i) : e;
}
function aK(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((i) => !(i.match(/^on[A-Z]/) && typeof e[i] == "function")).forEach((i) => {
    t[i] = e[i];
  }), t;
}
function UQ(e) {
  const {
    getSlotProps: t,
    additionalProps: i,
    externalSlotProps: n,
    externalForwardedProps: r,
    className: g
  } = e;
  if (!t) {
    const A = Re(i == null ? void 0 : i.className, g, r == null ? void 0 : r.className, n == null ? void 0 : n.className), b = et({}, i == null ? void 0 : i.style, r == null ? void 0 : r.style, n == null ? void 0 : n.style), m = et({}, i, r, n);
    return A.length > 0 && (m.className = A), Object.keys(b).length > 0 && (m.style = b), {
      props: m,
      internalRef: void 0
    };
  }
  const o = PB(et({}, r, n)), l = aK(n), a = aK(r), I = t(o), c = Re(I == null ? void 0 : I.className, i == null ? void 0 : i.className, g, r == null ? void 0 : r.className, n == null ? void 0 : n.className), d = et({}, I == null ? void 0 : I.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style, n == null ? void 0 : n.style), C = et({}, I, i, a, l);
  return c.length > 0 && (C.className = c), Object.keys(d).length > 0 && (C.style = d), {
    props: C,
    internalRef: I.ref
  };
}
const ude = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Fr(e) {
  var t;
  const {
    elementType: i,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: g = !1
  } = e, o = jr(e, ude), l = g ? {} : PQ(n, r), {
    props: a,
    internalRef: I
  } = UQ(et({}, o, {
    externalSlotProps: l
  })), c = Zn(I, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return xh(i, et({}, a, {
    ref: c
  }), r);
}
const Cde = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], Ade = ["component", "slots", "slotProps"], bde = ["component"];
function PV(e, t) {
  const {
    className: i,
    elementType: n,
    ownerState: r,
    externalForwardedProps: g,
    getSlotOwnerState: o,
    internalForwardedProps: l
  } = t, a = tt(t, Cde), {
    component: I,
    slots: c = {
      [e]: void 0
    },
    slotProps: d = {
      [e]: void 0
    }
  } = g, C = tt(g, Ade), A = c[e] || n, b = PQ(d[e], r), m = UQ(F({
    className: i
  }, a, {
    externalForwardedProps: e === "root" ? C : void 0,
    externalSlotProps: b
  })), {
    props: {
      component: p
    },
    internalRef: B
  } = m, f = tt(m.props, bde), Z = Zn(B, b == null ? void 0 : b.ref, t.ref), y = o ? o(f) : {}, W = F({}, r, y), V = e === "root" ? p || I : p, w = xh(A, F({}, e === "root" && !I && !c[e] && l, e !== "root" && !c[e] && l, f, V && {
    as: V
  }, {
    ref: Z
  }), W);
  return Object.keys(y).forEach((v) => {
    delete w[v];
  }), [A, w];
}
function hde(e) {
  return Lt("MuiAccordion", e);
}
const RW = Dt("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), mde = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], pde = ou(), Bde = (e) => {
  const {
    classes: t,
    square: i,
    expanded: n,
    disabled: r,
    disableGutters: g
  } = e;
  return Mt({
    root: ["root", !i && "rounded", n && "expanded", r && "disabled", !g && "gutters"],
    region: ["region"]
  }, hde, t);
}, fde = Se(ul, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${RW.region}`]: t.region
    }, t.root, !i.square && t.rounded, !i.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${RW.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${RW.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${RW.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})), iJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = pde({
    props: t,
    name: "MuiAccordion"
  }), {
    children: r,
    className: g,
    defaultExpanded: o = !1,
    disabled: l = !1,
    disableGutters: a = !1,
    expanded: I,
    onChange: c,
    square: d = !1,
    slots: C = {},
    slotProps: A = {},
    TransitionComponent: b,
    TransitionProps: m
  } = n, p = tt(n, mde), [B, f] = Xs({
    controlled: I,
    default: o,
    name: "Accordion",
    state: "expanded"
  }), Z = X.useCallback((M) => {
    f(!B), c && c(M, !B);
  }, [B, c, f]), [y, ...W] = X.Children.toArray(r), V = X.useMemo(() => ({
    expanded: B,
    disabled: l,
    disableGutters: a,
    toggle: Z
  }), [B, l, a, Z]), w = F({}, n, {
    square: d,
    disabled: l,
    disableGutters: a,
    expanded: B
  }), v = Bde(w), H = F({
    transition: b
  }, C), x = F({
    transition: m
  }, A), [J, K] = PV("transition", {
    elementType: P2,
    externalForwardedProps: {
      slots: H,
      slotProps: x
    },
    ownerState: w
  });
  return /* @__PURE__ */ Ri(fde, F({
    className: Re(v.root, g),
    ref: i,
    ownerState: w,
    square: d
  }, p, {
    children: [/* @__PURE__ */ ee(MQ.Provider, {
      value: V,
      children: y
    }), /* @__PURE__ */ ee(J, F({
      in: B,
      timeout: "auto"
    }, K, {
      children: /* @__PURE__ */ ee("div", {
        "aria-labelledby": y.props.id,
        id: y.props["aria-controls"],
        role: "region",
        className: v.region,
        children: W
      })
    }))]
  }));
});
function Zde(e) {
  return Lt("MuiAccordionDetails", e);
}
Dt("MuiAccordionDetails", ["root"]);
const Gde = ["className"], yde = ou(), Wde = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, Zde, t);
}, Sde = Se("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), nJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = yde({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: r
  } = n, g = tt(n, Gde), o = n, l = Wde(o);
  return /* @__PURE__ */ ee(Sde, F({
    className: Re(l.root, r),
    ref: i,
    ownerState: o
  }, g));
});
function Vde(e) {
  const {
    className: t,
    classes: i,
    pulsate: n = !1,
    rippleX: r,
    rippleY: g,
    rippleSize: o,
    in: l,
    onExited: a,
    timeout: I
  } = e, [c, d] = X.useState(!1), C = Re(t, i.ripple, i.rippleVisible, n && i.ripplePulsate), A = {
    width: o,
    height: o,
    top: -(o / 2) + g,
    left: -(o / 2) + r
  }, b = Re(i.child, c && i.childLeaving, n && i.childPulsate);
  return !l && !c && d(!0), X.useEffect(() => {
    if (!l && a != null) {
      const m = setTimeout(a, I);
      return () => {
        clearTimeout(m);
      };
    }
  }, [a, l, I]), /* @__PURE__ */ ee("span", {
    className: C,
    style: A,
    children: /* @__PURE__ */ ee("span", {
      className: b
    })
  });
}
const ya = Dt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), wde = ["center", "classes", "className"];
let U2 = (e) => e, sK, IK, cK, dK;
const Bx = 550, vde = 80, Rde = Ds(sK || (sK = U2`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), Xde = Ds(IK || (IK = U2`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Hde = Ds(cK || (cK = U2`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), kde = Se("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Yde = Se(Vde, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(dK || (dK = U2`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ya.rippleVisible, Rde, Bx, ({
  theme: e
}) => e.transitions.easing.easeInOut, ya.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, ya.child, ya.childLeaving, Xde, Bx, ({
  theme: e
}) => e.transitions.easing.easeInOut, ya.childPulsate, Hde, ({
  theme: e
}) => e.transitions.easing.easeInOut), Fde = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: r = !1,
    classes: g = {},
    className: o
  } = n, l = tt(n, wde), [a, I] = X.useState([]), c = X.useRef(0), d = X.useRef(null);
  X.useEffect(() => {
    d.current && (d.current(), d.current = null);
  }, [a]);
  const C = X.useRef(!1), A = DC(), b = X.useRef(null), m = X.useRef(null), p = X.useCallback((y) => {
    const {
      pulsate: W,
      rippleX: V,
      rippleY: w,
      rippleSize: v,
      cb: H
    } = y;
    I((x) => [...x, /* @__PURE__ */ ee(Yde, {
      classes: {
        ripple: Re(g.ripple, ya.ripple),
        rippleVisible: Re(g.rippleVisible, ya.rippleVisible),
        ripplePulsate: Re(g.ripplePulsate, ya.ripplePulsate),
        child: Re(g.child, ya.child),
        childLeaving: Re(g.childLeaving, ya.childLeaving),
        childPulsate: Re(g.childPulsate, ya.childPulsate)
      },
      timeout: Bx,
      pulsate: W,
      rippleX: V,
      rippleY: w,
      rippleSize: v
    }, c.current)]), c.current += 1, d.current = H;
  }, [g]), B = X.useCallback((y = {}, W = {}, V = () => {
  }) => {
    const {
      pulsate: w = !1,
      center: v = r || W.pulsate,
      fakeElement: H = !1
      // For test purposes
    } = W;
    if ((y == null ? void 0 : y.type) === "mousedown" && C.current) {
      C.current = !1;
      return;
    }
    (y == null ? void 0 : y.type) === "touchstart" && (C.current = !0);
    const x = H ? null : m.current, J = x ? x.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let K, M, L;
    if (v || y === void 0 || y.clientX === 0 && y.clientY === 0 || !y.clientX && !y.touches)
      K = Math.round(J.width / 2), M = Math.round(J.height / 2);
    else {
      const {
        clientX: N,
        clientY: U
      } = y.touches && y.touches.length > 0 ? y.touches[0] : y;
      K = Math.round(N - J.left), M = Math.round(U - J.top);
    }
    if (v)
      L = Math.sqrt((2 * J.width ** 2 + J.height ** 2) / 3), L % 2 === 0 && (L += 1);
    else {
      const N = Math.max(Math.abs((x ? x.clientWidth : 0) - K), K) * 2 + 2, U = Math.max(Math.abs((x ? x.clientHeight : 0) - M), M) * 2 + 2;
      L = Math.sqrt(N ** 2 + U ** 2);
    }
    y != null && y.touches ? b.current === null && (b.current = () => {
      p({
        pulsate: w,
        rippleX: K,
        rippleY: M,
        rippleSize: L,
        cb: V
      });
    }, A.start(vde, () => {
      b.current && (b.current(), b.current = null);
    })) : p({
      pulsate: w,
      rippleX: K,
      rippleY: M,
      rippleSize: L,
      cb: V
    });
  }, [r, p, A]), f = X.useCallback(() => {
    B({}, {
      pulsate: !0
    });
  }, [B]), Z = X.useCallback((y, W) => {
    if (A.clear(), (y == null ? void 0 : y.type) === "touchend" && b.current) {
      b.current(), b.current = null, A.start(0, () => {
        Z(y, W);
      });
      return;
    }
    b.current = null, I((V) => V.length > 0 ? V.slice(1) : V), d.current = W;
  }, [A]);
  return X.useImperativeHandle(i, () => ({
    pulsate: f,
    start: B,
    stop: Z
  }), [f, B, Z]), /* @__PURE__ */ ee(kde, F({
    className: Re(ya.root, g.root, o),
    ref: m
  }, l, {
    children: /* @__PURE__ */ ee(eJ, {
      component: null,
      exit: !0,
      children: a
    })
  }));
});
function xde(e) {
  return Lt("MuiButtonBase", e);
}
const Dde = Dt("MuiButtonBase", ["root", "disabled", "focusVisible"]), Jde = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], Ede = (e) => {
  const {
    disabled: t,
    focusVisible: i,
    focusVisibleClassName: n,
    classes: r
  } = e, o = Mt({
    root: ["root", t && "disabled", i && "focusVisible"]
  }, xde, r);
  return i && n && (o.root += ` ${n}`), o;
}, Nde = Se("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Dde.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Xo = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: r,
    centerRipple: g = !1,
    children: o,
    className: l,
    component: a = "button",
    disabled: I = !1,
    disableRipple: c = !1,
    disableTouchRipple: d = !1,
    focusRipple: C = !1,
    LinkComponent: A = "a",
    onBlur: b,
    onClick: m,
    onContextMenu: p,
    onDragLeave: B,
    onFocus: f,
    onFocusVisible: Z,
    onKeyDown: y,
    onKeyUp: W,
    onMouseDown: V,
    onMouseLeave: w,
    onMouseUp: v,
    onTouchEnd: H,
    onTouchMove: x,
    onTouchStart: J,
    tabIndex: K = 0,
    TouchRippleProps: M,
    touchRippleRef: L,
    type: N
  } = n, U = tt(n, Jde), O = X.useRef(null), $ = X.useRef(null), ne = Zn($, L), {
    isFocusVisibleRef: be,
    onFocus: Ve,
    onBlur: He,
    ref: Je
  } = hZ(), [ke, we] = X.useState(!1);
  I && ke && we(!1), X.useImperativeHandle(r, () => ({
    focusVisible: () => {
      we(!0), O.current.focus();
    }
  }), []);
  const [ue, Xe] = X.useState(!1);
  X.useEffect(() => {
    Xe(!0);
  }, []);
  const Ze = ue && !c && !I;
  X.useEffect(() => {
    ke && C && !c && ue && $.current.pulsate();
  }, [c, C, ke, ue]);
  function xe(Be, qe, vt = d) {
    return Qr((Kt) => (qe && qe(Kt), !vt && $.current && $.current[Be](Kt), !0));
  }
  const Pe = xe("start", V), st = xe("stop", p), bt = xe("stop", B), it = xe("stop", v), Qe = xe("stop", (Be) => {
    ke && Be.preventDefault(), w && w(Be);
  }), $e = xe("start", J), It = xe("stop", H), jt = xe("stop", x), Bt = xe("stop", (Be) => {
    He(Be), be.current === !1 && we(!1), b && b(Be);
  }, !1), te = Qr((Be) => {
    O.current || (O.current = Be.currentTarget), Ve(Be), be.current === !0 && (we(!0), Z && Z(Be)), f && f(Be);
  }), Xt = () => {
    const Be = O.current;
    return a && a !== "button" && !(Be.tagName === "A" && Be.href);
  }, Ht = X.useRef(!1), ii = Qr((Be) => {
    C && !Ht.current && ke && $.current && Be.key === " " && (Ht.current = !0, $.current.stop(Be, () => {
      $.current.start(Be);
    })), Be.target === Be.currentTarget && Xt() && Be.key === " " && Be.preventDefault(), y && y(Be), Be.target === Be.currentTarget && Xt() && Be.key === "Enter" && !I && (Be.preventDefault(), m && m(Be));
  }), $t = Qr((Be) => {
    C && Be.key === " " && $.current && ke && !Be.defaultPrevented && (Ht.current = !1, $.current.stop(Be, () => {
      $.current.pulsate(Be);
    })), W && W(Be), m && Be.target === Be.currentTarget && Xt() && Be.key === " " && !Be.defaultPrevented && m(Be);
  });
  let ni = a;
  ni === "button" && (U.href || U.to) && (ni = A);
  const mi = {};
  ni === "button" ? (mi.type = N === void 0 ? "button" : N, mi.disabled = I) : (!U.href && !U.to && (mi.role = "button"), I && (mi["aria-disabled"] = I));
  const Bi = Zn(i, Je, O), ci = F({}, n, {
    centerRipple: g,
    component: a,
    disabled: I,
    disableRipple: c,
    disableTouchRipple: d,
    focusRipple: C,
    tabIndex: K,
    focusVisible: ke
  }), Ge = Ede(ci);
  return /* @__PURE__ */ Ri(Nde, F({
    as: ni,
    className: Re(Ge.root, l),
    ownerState: ci,
    onBlur: Bt,
    onClick: m,
    onContextMenu: st,
    onFocus: te,
    onKeyDown: ii,
    onKeyUp: $t,
    onMouseDown: Pe,
    onMouseLeave: Qe,
    onMouseUp: it,
    onDragLeave: bt,
    onTouchEnd: It,
    onTouchMove: jt,
    onTouchStart: $e,
    ref: Bi,
    tabIndex: I ? -1 : K,
    type: N
  }, mi, U, {
    children: [o, Ze ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ ee(Fde, F({
        ref: ne,
        center: g
      }, M))
    ) : null]
  }));
});
function Lde(e) {
  return Lt("MuiAccordionSummary", e);
}
const Dh = Dt("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), Kde = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], Tde = ou(), Mde = (e) => {
  const {
    classes: t,
    expanded: i,
    disabled: n,
    disableGutters: r
  } = e;
  return Mt({
    root: ["root", i && "expanded", n && "disabled", !r && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", i && "expanded", !r && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", i && "expanded"]
  }, Lde, t);
}, Pde = Se(Xo, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${Dh.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${Dh.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${Dh.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (i) => !i.disableGutters,
      style: {
        [`&.${Dh.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}), Ude = Se("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${Dh.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})), zde = Se("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Dh.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), rJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = Tde({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: r,
    className: g,
    expandIcon: o,
    focusVisibleClassName: l,
    onClick: a
  } = n, I = tt(n, Kde), {
    disabled: c = !1,
    disableGutters: d,
    expanded: C,
    toggle: A
  } = X.useContext(MQ), b = (B) => {
    A && A(B), a && a(B);
  }, m = F({}, n, {
    expanded: C,
    disabled: c,
    disableGutters: d
  }), p = Mde(m);
  return /* @__PURE__ */ Ri(Pde, F({
    focusRipple: !1,
    disableRipple: !0,
    disabled: c,
    component: "div",
    "aria-expanded": C,
    className: Re(p.root, g),
    focusVisibleClassName: Re(p.focusVisible, l),
    onClick: b,
    ref: i,
    ownerState: m
  }, I, {
    children: [/* @__PURE__ */ ee(Ude, {
      className: p.content,
      ownerState: m,
      children: r
    }), o && /* @__PURE__ */ ee(zde, {
      className: p.expandIconWrapper,
      ownerState: m,
      children: o
    })]
  }));
});
function Ode(e) {
  return Lt("MuiAlert", e);
}
const uK = Dt("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function Qde(e) {
  return Lt("MuiIconButton", e);
}
const jde = Dt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), qde = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], _de = (e) => {
  const {
    classes: t,
    disabled: i,
    color: n,
    edge: r,
    size: g
  } = e, o = {
    root: ["root", i && "disabled", n !== "default" && `color${ve(n)}`, r && `edge${ve(r)}`, `size${ve(g)}`]
  };
  return Mt(o, Qde, t);
}, $de = Se(Xo, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "default" && t[`color${ve(i.color)}`], i.edge && t[`edge${ve(i.edge)}`], t[`size${ve(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var i;
  const n = (i = (e.vars || e).palette) == null ? void 0 : i[t.color];
  return F({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && F({
    color: n == null ? void 0 : n.main
  }, !t.disableRipple && {
    "&:hover": F({}, n && {
      backgroundColor: e.vars ? `rgba(${n.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(n.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${jde.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), Ni = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: r = !1,
    children: g,
    className: o,
    color: l = "default",
    disabled: a = !1,
    disableFocusRipple: I = !1,
    size: c = "medium"
  } = n, d = tt(n, qde), C = F({}, n, {
    edge: r,
    color: l,
    disabled: a,
    disableFocusRipple: I,
    size: c
  }), A = _de(C);
  return /* @__PURE__ */ ee($de, F({
    className: Re(A.root, o),
    centerRipple: !0,
    focusRipple: !I,
    disabled: a,
    ref: i
  }, d, {
    ownerState: C,
    children: g
  }));
}), eue = ai(/* @__PURE__ */ ee("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), tue = ai(/* @__PURE__ */ ee("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), iue = ai(/* @__PURE__ */ ee("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), nue = ai(/* @__PURE__ */ ee("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), zQ = ai(/* @__PURE__ */ ee("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), rue = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], gue = ou(), oue = (e) => {
  const {
    variant: t,
    color: i,
    severity: n,
    classes: r
  } = e, g = {
    root: ["root", `color${ve(i || n)}`, `${t}${ve(i || n)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return Mt(g, Ode, r);
}, lue = Se(ul, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`${i.variant}${ve(i.color || i.severity)}`]];
  }
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? jd : qd, i = e.palette.mode === "light" ? qd : jd;
  return F({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(([, n]) => n.main && n.light).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${n}Color`] : t(e.palette[n].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${n}StandardBg`] : i(e.palette[n].light, 0.9),
        [`& .${uK.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${n}IconColor`]
        } : {
          color: e.palette[n].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, n]) => n.main && n.light).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${n}Color`] : t(e.palette[n].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[n].light}`,
        [`& .${uK.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${n}IconColor`]
        } : {
          color: e.palette[n].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, n]) => n.main && n.dark).map(([n]) => ({
      props: {
        colorSeverity: n,
        variant: "filled"
      },
      style: F({
        fontWeight: e.typography.fontWeightMedium
      }, e.vars ? {
        color: e.vars.palette.Alert[`${n}FilledColor`],
        backgroundColor: e.vars.palette.Alert[`${n}FilledBg`]
      } : {
        backgroundColor: e.palette.mode === "dark" ? e.palette[n].dark : e.palette[n].main,
        color: e.palette.getContrastText(e.palette[n].main)
      })
    }))]
  });
}), aue = Se("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), sue = Se("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), CK = Se("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), AK = {
  success: /* @__PURE__ */ ee(eue, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ ee(tue, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ ee(iue, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ ee(nue, {
    fontSize: "inherit"
  })
}, Iue = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = gue({
    props: t,
    name: "MuiAlert"
  }), {
    action: r,
    children: g,
    className: o,
    closeText: l = "Close",
    color: a,
    components: I = {},
    componentsProps: c = {},
    icon: d,
    iconMapping: C = AK,
    onClose: A,
    role: b = "alert",
    severity: m = "success",
    slotProps: p = {},
    slots: B = {},
    variant: f = "standard"
  } = n, Z = tt(n, rue), y = F({}, n, {
    color: a,
    severity: m,
    variant: f,
    colorSeverity: a || m
  }), W = oue(y), V = {
    slots: F({
      closeButton: I.CloseButton,
      closeIcon: I.CloseIcon
    }, B),
    slotProps: F({}, c, p)
  }, [w, v] = PV("closeButton", {
    elementType: Ni,
    externalForwardedProps: V,
    ownerState: y
  }), [H, x] = PV("closeIcon", {
    elementType: zQ,
    externalForwardedProps: V,
    ownerState: y
  });
  return /* @__PURE__ */ Ri(lue, F({
    role: b,
    elevation: 0,
    ownerState: y,
    className: Re(W.root, o),
    ref: i
  }, Z, {
    children: [d !== !1 ? /* @__PURE__ */ ee(aue, {
      ownerState: y,
      className: W.icon,
      children: d || C[m] || AK[m]
    }) : null, /* @__PURE__ */ ee(sue, {
      ownerState: y,
      className: W.message,
      children: g
    }), r != null ? /* @__PURE__ */ ee(CK, {
      ownerState: y,
      className: W.action,
      children: r
    }) : null, r == null && A ? /* @__PURE__ */ ee(CK, {
      ownerState: y,
      className: W.action,
      children: /* @__PURE__ */ ee(w, F({
        size: "small",
        "aria-label": l,
        title: l,
        color: "inherit",
        onClick: A
      }, v, {
        children: /* @__PURE__ */ ee(H, F({
          fontSize: "small"
        }, x))
      }))
    }) : null]
  }));
});
function cue(e) {
  return Lt("MuiTypography", e);
}
const due = Dt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), X7t = due, uue = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], Cue = (e) => {
  const {
    align: t,
    gutterBottom: i,
    noWrap: n,
    paragraph: r,
    variant: g,
    classes: o
  } = e, l = {
    root: ["root", g, e.align !== "inherit" && `align${ve(t)}`, i && "gutterBottom", n && "noWrap", r && "paragraph"]
  };
  return Mt(l, cue, o);
}, Aue = Se("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.variant && t[i.variant], i.align !== "inherit" && t[`align${ve(i.align)}`], i.noWrap && t.noWrap, i.gutterBottom && t.gutterBottom, i.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), bK = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, bue = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, hue = (e) => bue[e] || e, Ct = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTypography"
  }), r = hue(n.color), g = w2(F({}, n, {
    color: r
  })), {
    align: o = "inherit",
    className: l,
    component: a,
    gutterBottom: I = !1,
    noWrap: c = !1,
    paragraph: d = !1,
    variant: C = "body1",
    variantMapping: A = bK
  } = g, b = tt(g, uue), m = F({}, g, {
    align: o,
    color: r,
    className: l,
    component: a,
    gutterBottom: I,
    noWrap: c,
    paragraph: d,
    variant: C,
    variantMapping: A
  }), p = a || (d ? "p" : A[C] || bK[C]) || "span", B = Cue(m);
  return /* @__PURE__ */ ee(Aue, F({
    as: p,
    ref: i,
    ownerState: m,
    className: Re(B.root, l)
  }, b));
});
function mue(e) {
  return Lt("MuiAppBar", e);
}
Dt("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const pue = ["className", "color", "enableColorOnDark", "position"], Bue = (e) => {
  const {
    color: t,
    position: i,
    classes: n
  } = e, r = {
    root: ["root", `color${ve(t)}`, `position${ve(i)}`]
  };
  return Mt(r, mue, n);
}, XW = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, fue = Se(ul, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`position${ve(i.position)}`], t[`color${ve(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[900];
  return F({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, t.position === "fixed" && {
    position: "fixed",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0,
    "@media print": {
      // Prevent the app bar to be visible on each printed page.
      position: "absolute"
    }
  }, t.position === "absolute" && {
    position: "absolute",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "sticky" && {
    // ⚠️ sticky is not supported by IE11.
    position: "sticky",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "static" && {
    position: "static"
  }, t.position === "relative" && {
    position: "relative"
  }, !e.vars && F({}, t.color === "default" && {
    backgroundColor: i,
    color: e.palette.getContrastText(i)
  }, t.color && t.color !== "default" && t.color !== "inherit" && t.color !== "transparent" && {
    backgroundColor: e.palette[t.color].main,
    color: e.palette[t.color].contrastText
  }, t.color === "inherit" && {
    color: "inherit"
  }, e.palette.mode === "dark" && !t.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, t.color === "transparent" && F({
    backgroundColor: "transparent",
    color: "inherit"
  }, e.palette.mode === "dark" && {
    backgroundImage: "none"
  })), e.vars && F({}, t.color === "default" && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette.AppBar.defaultBg : XW(e.vars.palette.AppBar.darkBg, e.vars.palette.AppBar.defaultBg),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette.text.primary : XW(e.vars.palette.AppBar.darkColor, e.vars.palette.text.primary)
  }, t.color && !t.color.match(/^(default|inherit|transparent)$/) && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette[t.color].main : XW(e.vars.palette.AppBar.darkBg, e.vars.palette[t.color].main),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette[t.color].contrastText : XW(e.vars.palette.AppBar.darkColor, e.vars.palette[t.color].contrastText)
  }, {
    backgroundColor: "var(--AppBar-background)",
    color: t.color === "inherit" ? "inherit" : "var(--AppBar-color)"
  }, t.color === "transparent" && {
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "inherit"
  }));
}), Zue = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiAppBar"
  }), {
    className: r,
    color: g = "primary",
    enableColorOnDark: o = !1,
    position: l = "fixed"
  } = n, a = tt(n, pue), I = F({}, n, {
    color: g,
    position: l,
    enableColorOnDark: o
  }), c = Bue(I);
  return /* @__PURE__ */ ee(fue, F({
    square: !0,
    component: "header",
    ownerState: I,
    elevation: 4,
    className: Re(c.root, r, l === "fixed" && "mui-fixed"),
    ref: i
  }, a));
}), OQ = "base";
function Gue(e) {
  return `${OQ}--${e}`;
}
function yue(e, t) {
  return `${OQ}-${e}-${t}`;
}
function QQ(e, t) {
  const i = CQ[t];
  return i ? Gue(i) : yue(e, t);
}
function Wue(e, t) {
  const i = {};
  return t.forEach((n) => {
    i[n] = QQ(e, n);
  }), i;
}
const Sue = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Vue(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function wue(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let i = t(`[name="${e.name}"]:checked`);
  return i || (i = t(`[name="${e.name}"]`)), i !== e;
}
function vue(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || wue(e));
}
function Rue(e) {
  const t = [], i = [];
  return Array.from(e.querySelectorAll(Sue)).forEach((n, r) => {
    const g = Vue(n);
    g === -1 || !vue(n) || (g === 0 ? t.push(n) : i.push({
      documentOrder: r,
      tabIndex: g,
      node: n
    }));
  }), i.sort((n, r) => n.tabIndex === r.tabIndex ? n.documentOrder - r.documentOrder : n.tabIndex - r.tabIndex).map((n) => n.node).concat(t);
}
function Xue() {
  return !0;
}
function Hue(e) {
  const {
    children: t,
    disableAutoFocus: i = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: r = !1,
    getTabbable: g = Rue,
    isEnabled: o = Xue,
    open: l
  } = e, a = X.useRef(!1), I = X.useRef(null), c = X.useRef(null), d = X.useRef(null), C = X.useRef(null), A = X.useRef(!1), b = X.useRef(null), m = Zn(t.ref, b), p = X.useRef(null);
  X.useEffect(() => {
    !l || !b.current || (A.current = !i);
  }, [i, l]), X.useEffect(() => {
    if (!l || !b.current)
      return;
    const Z = Vr(b.current);
    return b.current.contains(Z.activeElement) || (b.current.hasAttribute("tabIndex") || b.current.setAttribute("tabIndex", "-1"), A.current && b.current.focus()), () => {
      r || (d.current && d.current.focus && (a.current = !0, d.current.focus()), d.current = null);
    };
  }, [l]), X.useEffect(() => {
    if (!l || !b.current)
      return;
    const Z = Vr(b.current), y = (w) => {
      p.current = w, !(n || !o() || w.key !== "Tab") && Z.activeElement === b.current && w.shiftKey && (a.current = !0, c.current && c.current.focus());
    }, W = () => {
      const w = b.current;
      if (w === null)
        return;
      if (!Z.hasFocus() || !o() || a.current) {
        a.current = !1;
        return;
      }
      if (w.contains(Z.activeElement) || n && Z.activeElement !== I.current && Z.activeElement !== c.current)
        return;
      if (Z.activeElement !== C.current)
        C.current = null;
      else if (C.current !== null)
        return;
      if (!A.current)
        return;
      let v = [];
      if ((Z.activeElement === I.current || Z.activeElement === c.current) && (v = g(b.current)), v.length > 0) {
        var H, x;
        const J = !!((H = p.current) != null && H.shiftKey && ((x = p.current) == null ? void 0 : x.key) === "Tab"), K = v[0], M = v[v.length - 1];
        typeof K != "string" && typeof M != "string" && (J ? M.focus() : K.focus());
      } else
        w.focus();
    };
    Z.addEventListener("focusin", W), Z.addEventListener("keydown", y, !0);
    const V = setInterval(() => {
      Z.activeElement && Z.activeElement.tagName === "BODY" && W();
    }, 50);
    return () => {
      clearInterval(V), Z.removeEventListener("focusin", W), Z.removeEventListener("keydown", y, !0);
    };
  }, [i, n, r, o, l, g]);
  const B = (Z) => {
    d.current === null && (d.current = Z.relatedTarget), A.current = !0, C.current = Z.target;
    const y = t.props.onFocus;
    y && y(Z);
  }, f = (Z) => {
    d.current === null && (d.current = Z.relatedTarget), A.current = !0;
  };
  return /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ ee("div", {
      tabIndex: l ? 0 : -1,
      onFocus: f,
      ref: I,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ X.cloneElement(t, {
      ref: m,
      onFocus: B
    }), /* @__PURE__ */ ee("div", {
      tabIndex: l ? 0 : -1,
      onFocus: f,
      ref: c,
      "data-testid": "sentinelEnd"
    })]
  });
}
function kue(e) {
  return typeof e == "function" ? e() : e;
}
const jQ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    children: n,
    container: r,
    disablePortal: g = !1
  } = t, [o, l] = X.useState(null), a = Zn(/* @__PURE__ */ X.isValidElement(n) ? n.ref : null, i);
  if (no(() => {
    g || l(kue(r) || document.body);
  }, [r, g]), no(() => {
    if (o && !g)
      return Wf(i, o), () => {
        Wf(i, null);
      };
  }, [i, o, g]), g) {
    if (/* @__PURE__ */ X.isValidElement(n)) {
      const I = {
        ref: a
      };
      return /* @__PURE__ */ X.cloneElement(n, I);
    }
    return /* @__PURE__ */ ee(X.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ ee(X.Fragment, {
    children: o && /* @__PURE__ */ f4.createPortal(n, o)
  });
});
function Yue(e) {
  const t = Vr(e);
  return t.body === e ? Ja(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function UB(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function hK(e) {
  return parseInt(Ja(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Fue(e) {
  const i = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return i || n;
}
function mK(e, t, i, n, r) {
  const g = [t, i, ...n];
  [].forEach.call(e.children, (o) => {
    const l = g.indexOf(o) === -1, a = !Fue(o);
    l && a && UB(o, r);
  });
}
function gY(e, t) {
  let i = -1;
  return e.some((n, r) => t(n) ? (i = r, !0) : !1), i;
}
function xue(e, t) {
  const i = [], n = e.container;
  if (!t.disableScrollLock) {
    if (Yue(n)) {
      const o = ZQ(Vr(n));
      i.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${hK(n) + o}px`;
      const l = Vr(n).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (a) => {
        i.push({
          value: a.style.paddingRight,
          property: "padding-right",
          el: a
        }), a.style.paddingRight = `${hK(a) + o}px`;
      });
    }
    let g;
    if (n.parentNode instanceof DocumentFragment)
      g = Vr(n).body;
    else {
      const o = n.parentElement, l = Ja(n);
      g = (o == null ? void 0 : o.nodeName) === "HTML" && l.getComputedStyle(o).overflowY === "scroll" ? o : n;
    }
    i.push({
      value: g.style.overflow,
      property: "overflow",
      el: g
    }, {
      value: g.style.overflowX,
      property: "overflow-x",
      el: g
    }, {
      value: g.style.overflowY,
      property: "overflow-y",
      el: g
    }), g.style.overflow = "hidden";
  }
  return () => {
    i.forEach(({
      value: g,
      el: o,
      property: l
    }) => {
      g ? o.style.setProperty(l, g) : o.style.removeProperty(l);
    });
  };
}
function Due(e) {
  const t = [];
  return [].forEach.call(e.children, (i) => {
    i.getAttribute("aria-hidden") === "true" && t.push(i);
  }), t;
}
class Jue {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, i) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && UB(t.modalRef, !1);
    const r = Due(i);
    mK(i, t.mount, t.modalRef, r, !0);
    const g = gY(this.containers, (o) => o.container === i);
    return g !== -1 ? (this.containers[g].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: i,
      restore: null,
      hiddenSiblings: r
    }), n);
  }
  mount(t, i) {
    const n = gY(this.containers, (g) => g.modals.indexOf(t) !== -1), r = this.containers[n];
    r.restore || (r.restore = xue(r, i));
  }
  remove(t, i = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const r = gY(this.containers, (o) => o.modals.indexOf(t) !== -1), g = this.containers[r];
    if (g.modals.splice(g.modals.indexOf(t), 1), this.modals.splice(n, 1), g.modals.length === 0)
      g.restore && g.restore(), t.modalRef && UB(t.modalRef, i), mK(g.container, t.mount, t.modalRef, g.hiddenSiblings, !1), this.containers.splice(r, 1);
    else {
      const o = g.modals[g.modals.length - 1];
      o.modalRef && UB(o.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Eue(e) {
  return typeof e == "function" ? e() : e;
}
function Nue(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Lue = new Jue();
function Kue(e) {
  const {
    container: t,
    disableEscapeKeyDown: i = !1,
    disableScrollLock: n = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: r = Lue,
    closeAfterTransition: g = !1,
    onTransitionEnter: o,
    onTransitionExited: l,
    children: a,
    onClose: I,
    open: c,
    rootRef: d
  } = e, C = X.useRef({}), A = X.useRef(null), b = X.useRef(null), m = Zn(b, d), [p, B] = X.useState(!c), f = Nue(a);
  let Z = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (Z = !1);
  const y = () => Vr(A.current), W = () => (C.current.modalRef = b.current, C.current.mount = A.current, C.current), V = () => {
    r.mount(W(), {
      disableScrollLock: n
    }), b.current && (b.current.scrollTop = 0);
  }, w = Qr(() => {
    const U = Eue(t) || y().body;
    r.add(W(), U), b.current && V();
  }), v = X.useCallback(() => r.isTopModal(W()), [r]), H = Qr((U) => {
    A.current = U, U && (c && v() ? V() : b.current && UB(b.current, Z));
  }), x = X.useCallback(() => {
    r.remove(W(), Z);
  }, [Z, r]);
  X.useEffect(() => () => {
    x();
  }, [x]), X.useEffect(() => {
    c ? w() : (!f || !g) && x();
  }, [c, x, f, g, w]);
  const J = (U) => (O) => {
    var $;
    ($ = U.onKeyDown) == null || $.call(U, O), !(O.key !== "Escape" || O.which === 229 || // Wait until IME is settled.
    !v()) && (i || (O.stopPropagation(), I && I(O, "escapeKeyDown")));
  }, K = (U) => (O) => {
    var $;
    ($ = U.onClick) == null || $.call(U, O), O.target === O.currentTarget && I && I(O, "backdropClick");
  };
  return {
    getRootProps: (U = {}) => {
      const O = PB(e);
      delete O.onTransitionEnter, delete O.onTransitionExited;
      const $ = et({}, O, U);
      return et({
        role: "presentation"
      }, $, {
        onKeyDown: J($),
        ref: m
      });
    },
    getBackdropProps: (U = {}) => {
      const O = U;
      return et({
        "aria-hidden": !0
      }, O, {
        onClick: K(O),
        open: c
      });
    },
    getTransitionProps: () => {
      const U = () => {
        B(!1), o && o();
      }, O = () => {
        B(!0), l && l(), g && x();
      };
      return {
        onEnter: LV(U, a == null ? void 0 : a.props.onEnter),
        onExited: LV(O, a == null ? void 0 : a.props.onExited)
      };
    },
    rootRef: m,
    portalRef: H,
    isTopModal: v,
    exited: p,
    hasTransition: f
  };
}
var gl = "top", Na = "bottom", La = "right", ol = "left", gJ = "auto", pZ = [gl, Na, La, ol], tm = "start", Sf = "end", Tue = "clippingParents", qQ = "viewport", U0 = "popper", Mue = "reference", pK = /* @__PURE__ */ pZ.reduce(function(e, t) {
  return e.concat([t + "-" + tm, t + "-" + Sf]);
}, []), _Q = /* @__PURE__ */ [].concat(pZ, [gJ]).reduce(function(e, t) {
  return e.concat([t, t + "-" + tm, t + "-" + Sf]);
}, []), Pue = "beforeRead", Uue = "read", zue = "afterRead", Oue = "beforeMain", Que = "main", jue = "afterMain", que = "beforeWrite", _ue = "write", $ue = "afterWrite", eCe = [Pue, Uue, zue, Oue, Que, jue, que, _ue, $ue];
function WI(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ul(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function eA(e) {
  var t = Ul(e).Element;
  return e instanceof t || e instanceof Element;
}
function xa(e) {
  var t = Ul(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function oJ(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ul(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function tCe(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(i) {
    var n = t.styles[i] || {}, r = t.attributes[i] || {}, g = t.elements[i];
    !xa(g) || !WI(g) || (Object.assign(g.style, n), Object.keys(r).forEach(function(o) {
      var l = r[o];
      l === !1 ? g.removeAttribute(o) : g.setAttribute(o, l === !0 ? "" : l);
    }));
  });
}
function iCe(e) {
  var t = e.state, i = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var r = t.elements[n], g = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : i[n]), l = o.reduce(function(a, I) {
        return a[I] = "", a;
      }, {});
      !xa(r) || !WI(r) || (Object.assign(r.style, l), Object.keys(g).forEach(function(a) {
        r.removeAttribute(a);
      }));
    });
  };
}
const nCe = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: tCe,
  effect: iCe,
  requires: ["computeStyles"]
};
function pI(e) {
  return e.split("-")[0];
}
var UC = Math.max, UV = Math.min, im = Math.round;
function fx() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function $Q() {
  return !/^((?!chrome|android).)*safari/i.test(fx());
}
function nm(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  var n = e.getBoundingClientRect(), r = 1, g = 1;
  t && xa(e) && (r = e.offsetWidth > 0 && im(n.width) / e.offsetWidth || 1, g = e.offsetHeight > 0 && im(n.height) / e.offsetHeight || 1);
  var o = eA(e) ? Ul(e) : window, l = o.visualViewport, a = !$Q() && i, I = (n.left + (a && l ? l.offsetLeft : 0)) / r, c = (n.top + (a && l ? l.offsetTop : 0)) / g, d = n.width / r, C = n.height / g;
  return {
    width: d,
    height: C,
    top: c,
    right: I + d,
    bottom: c + C,
    left: I,
    x: I,
    y: c
  };
}
function lJ(e) {
  var t = nm(e), i = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: i,
    height: n
  };
}
function ej(e, t) {
  var i = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (i && oJ(i)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Zc(e) {
  return Ul(e).getComputedStyle(e);
}
function rCe(e) {
  return ["table", "td", "th"].indexOf(WI(e)) >= 0;
}
function lu(e) {
  return ((eA(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function z2(e) {
  return WI(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (oJ(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    lu(e)
  );
}
function BK(e) {
  return !xa(e) || // https://github.com/popperjs/popper-core/issues/837
  Zc(e).position === "fixed" ? null : e.offsetParent;
}
function gCe(e) {
  var t = /firefox/i.test(fx()), i = /Trident/i.test(fx());
  if (i && xa(e)) {
    var n = Zc(e);
    if (n.position === "fixed")
      return null;
  }
  var r = z2(e);
  for (oJ(r) && (r = r.host); xa(r) && ["html", "body"].indexOf(WI(r)) < 0; ) {
    var g = Zc(r);
    if (g.transform !== "none" || g.perspective !== "none" || g.contain === "paint" || ["transform", "perspective"].indexOf(g.willChange) !== -1 || t && g.willChange === "filter" || t && g.filter && g.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function BZ(e) {
  for (var t = Ul(e), i = BK(e); i && rCe(i) && Zc(i).position === "static"; )
    i = BK(i);
  return i && (WI(i) === "html" || WI(i) === "body" && Zc(i).position === "static") ? t : i || gCe(e) || t;
}
function aJ(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function zB(e, t, i) {
  return UC(e, UV(t, i));
}
function oCe(e, t, i) {
  var n = zB(e, t, i);
  return n > i ? i : n;
}
function tj() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ij(e) {
  return Object.assign({}, tj(), e);
}
function nj(e, t) {
  return t.reduce(function(i, n) {
    return i[n] = e, i;
  }, {});
}
var lCe = function(t, i) {
  return t = typeof t == "function" ? t(Object.assign({}, i.rects, {
    placement: i.placement
  })) : t, ij(typeof t != "number" ? t : nj(t, pZ));
};
function aCe(e) {
  var t, i = e.state, n = e.name, r = e.options, g = i.elements.arrow, o = i.modifiersData.popperOffsets, l = pI(i.placement), a = aJ(l), I = [ol, La].indexOf(l) >= 0, c = I ? "height" : "width";
  if (!(!g || !o)) {
    var d = lCe(r.padding, i), C = lJ(g), A = a === "y" ? gl : ol, b = a === "y" ? Na : La, m = i.rects.reference[c] + i.rects.reference[a] - o[a] - i.rects.popper[c], p = o[a] - i.rects.reference[a], B = BZ(g), f = B ? a === "y" ? B.clientHeight || 0 : B.clientWidth || 0 : 0, Z = m / 2 - p / 2, y = d[A], W = f - C[c] - d[b], V = f / 2 - C[c] / 2 + Z, w = zB(y, V, W), v = a;
    i.modifiersData[n] = (t = {}, t[v] = w, t.centerOffset = w - V, t);
  }
}
function sCe(e) {
  var t = e.state, i = e.options, n = i.element, r = n === void 0 ? "[data-popper-arrow]" : n;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || ej(t.elements.popper, r) && (t.elements.arrow = r));
}
const ICe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: aCe,
  effect: sCe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function rm(e) {
  return e.split("-")[1];
}
var cCe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function dCe(e, t) {
  var i = e.x, n = e.y, r = t.devicePixelRatio || 1;
  return {
    x: im(i * r) / r || 0,
    y: im(n * r) / r || 0
  };
}
function fK(e) {
  var t, i = e.popper, n = e.popperRect, r = e.placement, g = e.variation, o = e.offsets, l = e.position, a = e.gpuAcceleration, I = e.adaptive, c = e.roundOffsets, d = e.isFixed, C = o.x, A = C === void 0 ? 0 : C, b = o.y, m = b === void 0 ? 0 : b, p = typeof c == "function" ? c({
    x: A,
    y: m
  }) : {
    x: A,
    y: m
  };
  A = p.x, m = p.y;
  var B = o.hasOwnProperty("x"), f = o.hasOwnProperty("y"), Z = ol, y = gl, W = window;
  if (I) {
    var V = BZ(i), w = "clientHeight", v = "clientWidth";
    if (V === Ul(i) && (V = lu(i), Zc(V).position !== "static" && l === "absolute" && (w = "scrollHeight", v = "scrollWidth")), V = V, r === gl || (r === ol || r === La) && g === Sf) {
      y = Na;
      var H = d && V === W && W.visualViewport ? W.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        V[w]
      );
      m -= H - n.height, m *= a ? 1 : -1;
    }
    if (r === ol || (r === gl || r === Na) && g === Sf) {
      Z = La;
      var x = d && V === W && W.visualViewport ? W.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        V[v]
      );
      A -= x - n.width, A *= a ? 1 : -1;
    }
  }
  var J = Object.assign({
    position: l
  }, I && cCe), K = c === !0 ? dCe({
    x: A,
    y: m
  }, Ul(i)) : {
    x: A,
    y: m
  };
  if (A = K.x, m = K.y, a) {
    var M;
    return Object.assign({}, J, (M = {}, M[y] = f ? "0" : "", M[Z] = B ? "0" : "", M.transform = (W.devicePixelRatio || 1) <= 1 ? "translate(" + A + "px, " + m + "px)" : "translate3d(" + A + "px, " + m + "px, 0)", M));
  }
  return Object.assign({}, J, (t = {}, t[y] = f ? m + "px" : "", t[Z] = B ? A + "px" : "", t.transform = "", t));
}
function uCe(e) {
  var t = e.state, i = e.options, n = i.gpuAcceleration, r = n === void 0 ? !0 : n, g = i.adaptive, o = g === void 0 ? !0 : g, l = i.roundOffsets, a = l === void 0 ? !0 : l, I = {
    placement: pI(t.placement),
    variation: rm(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, fK(Object.assign({}, I, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: a
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, fK(Object.assign({}, I, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: a
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const CCe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: uCe,
  data: {}
};
var HW = {
  passive: !0
};
function ACe(e) {
  var t = e.state, i = e.instance, n = e.options, r = n.scroll, g = r === void 0 ? !0 : r, o = n.resize, l = o === void 0 ? !0 : o, a = Ul(t.elements.popper), I = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return g && I.forEach(function(c) {
    c.addEventListener("scroll", i.update, HW);
  }), l && a.addEventListener("resize", i.update, HW), function() {
    g && I.forEach(function(c) {
      c.removeEventListener("scroll", i.update, HW);
    }), l && a.removeEventListener("resize", i.update, HW);
  };
}
const bCe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ACe,
  data: {}
};
var hCe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function IV(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return hCe[t];
  });
}
var mCe = {
  start: "end",
  end: "start"
};
function ZK(e) {
  return e.replace(/start|end/g, function(t) {
    return mCe[t];
  });
}
function sJ(e) {
  var t = Ul(e), i = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: n
  };
}
function IJ(e) {
  return nm(lu(e)).left + sJ(e).scrollLeft;
}
function pCe(e, t) {
  var i = Ul(e), n = lu(e), r = i.visualViewport, g = n.clientWidth, o = n.clientHeight, l = 0, a = 0;
  if (r) {
    g = r.width, o = r.height;
    var I = $Q();
    (I || !I && t === "fixed") && (l = r.offsetLeft, a = r.offsetTop);
  }
  return {
    width: g,
    height: o,
    x: l + IJ(e),
    y: a
  };
}
function BCe(e) {
  var t, i = lu(e), n = sJ(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, g = UC(i.scrollWidth, i.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = UC(i.scrollHeight, i.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), l = -n.scrollLeft + IJ(e), a = -n.scrollTop;
  return Zc(r || i).direction === "rtl" && (l += UC(i.clientWidth, r ? r.clientWidth : 0) - g), {
    width: g,
    height: o,
    x: l,
    y: a
  };
}
function cJ(e) {
  var t = Zc(e), i = t.overflow, n = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + r + n);
}
function rj(e) {
  return ["html", "body", "#document"].indexOf(WI(e)) >= 0 ? e.ownerDocument.body : xa(e) && cJ(e) ? e : rj(z2(e));
}
function OB(e, t) {
  var i;
  t === void 0 && (t = []);
  var n = rj(e), r = n === ((i = e.ownerDocument) == null ? void 0 : i.body), g = Ul(n), o = r ? [g].concat(g.visualViewport || [], cJ(n) ? n : []) : n, l = t.concat(o);
  return r ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(OB(z2(o)))
  );
}
function Zx(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function fCe(e, t) {
  var i = nm(e, !1, t === "fixed");
  return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
}
function GK(e, t, i) {
  return t === qQ ? Zx(pCe(e, i)) : eA(t) ? fCe(t, i) : Zx(BCe(lu(e)));
}
function ZCe(e) {
  var t = OB(z2(e)), i = ["absolute", "fixed"].indexOf(Zc(e).position) >= 0, n = i && xa(e) ? BZ(e) : e;
  return eA(n) ? t.filter(function(r) {
    return eA(r) && ej(r, n) && WI(r) !== "body";
  }) : [];
}
function GCe(e, t, i, n) {
  var r = t === "clippingParents" ? ZCe(e) : [].concat(t), g = [].concat(r, [i]), o = g[0], l = g.reduce(function(a, I) {
    var c = GK(e, I, n);
    return a.top = UC(c.top, a.top), a.right = UV(c.right, a.right), a.bottom = UV(c.bottom, a.bottom), a.left = UC(c.left, a.left), a;
  }, GK(e, o, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function gj(e) {
  var t = e.reference, i = e.element, n = e.placement, r = n ? pI(n) : null, g = n ? rm(n) : null, o = t.x + t.width / 2 - i.width / 2, l = t.y + t.height / 2 - i.height / 2, a;
  switch (r) {
    case gl:
      a = {
        x: o,
        y: t.y - i.height
      };
      break;
    case Na:
      a = {
        x: o,
        y: t.y + t.height
      };
      break;
    case La:
      a = {
        x: t.x + t.width,
        y: l
      };
      break;
    case ol:
      a = {
        x: t.x - i.width,
        y: l
      };
      break;
    default:
      a = {
        x: t.x,
        y: t.y
      };
  }
  var I = r ? aJ(r) : null;
  if (I != null) {
    var c = I === "y" ? "height" : "width";
    switch (g) {
      case tm:
        a[I] = a[I] - (t[c] / 2 - i[c] / 2);
        break;
      case Sf:
        a[I] = a[I] + (t[c] / 2 - i[c] / 2);
        break;
    }
  }
  return a;
}
function Vf(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.placement, r = n === void 0 ? e.placement : n, g = i.strategy, o = g === void 0 ? e.strategy : g, l = i.boundary, a = l === void 0 ? Tue : l, I = i.rootBoundary, c = I === void 0 ? qQ : I, d = i.elementContext, C = d === void 0 ? U0 : d, A = i.altBoundary, b = A === void 0 ? !1 : A, m = i.padding, p = m === void 0 ? 0 : m, B = ij(typeof p != "number" ? p : nj(p, pZ)), f = C === U0 ? Mue : U0, Z = e.rects.popper, y = e.elements[b ? f : C], W = GCe(eA(y) ? y : y.contextElement || lu(e.elements.popper), a, c, o), V = nm(e.elements.reference), w = gj({
    reference: V,
    element: Z,
    strategy: "absolute",
    placement: r
  }), v = Zx(Object.assign({}, Z, w)), H = C === U0 ? v : V, x = {
    top: W.top - H.top + B.top,
    bottom: H.bottom - W.bottom + B.bottom,
    left: W.left - H.left + B.left,
    right: H.right - W.right + B.right
  }, J = e.modifiersData.offset;
  if (C === U0 && J) {
    var K = J[r];
    Object.keys(x).forEach(function(M) {
      var L = [La, Na].indexOf(M) >= 0 ? 1 : -1, N = [gl, Na].indexOf(M) >= 0 ? "y" : "x";
      x[M] += K[N] * L;
    });
  }
  return x;
}
function yCe(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.placement, r = i.boundary, g = i.rootBoundary, o = i.padding, l = i.flipVariations, a = i.allowedAutoPlacements, I = a === void 0 ? _Q : a, c = rm(n), d = c ? l ? pK : pK.filter(function(b) {
    return rm(b) === c;
  }) : pZ, C = d.filter(function(b) {
    return I.indexOf(b) >= 0;
  });
  C.length === 0 && (C = d);
  var A = C.reduce(function(b, m) {
    return b[m] = Vf(e, {
      placement: m,
      boundary: r,
      rootBoundary: g,
      padding: o
    })[pI(m)], b;
  }, {});
  return Object.keys(A).sort(function(b, m) {
    return A[b] - A[m];
  });
}
function WCe(e) {
  if (pI(e) === gJ)
    return [];
  var t = IV(e);
  return [ZK(e), t, ZK(t)];
}
function SCe(e) {
  var t = e.state, i = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var r = i.mainAxis, g = r === void 0 ? !0 : r, o = i.altAxis, l = o === void 0 ? !0 : o, a = i.fallbackPlacements, I = i.padding, c = i.boundary, d = i.rootBoundary, C = i.altBoundary, A = i.flipVariations, b = A === void 0 ? !0 : A, m = i.allowedAutoPlacements, p = t.options.placement, B = pI(p), f = B === p, Z = a || (f || !b ? [IV(p)] : WCe(p)), y = [p].concat(Z).reduce(function(ke, we) {
      return ke.concat(pI(we) === gJ ? yCe(t, {
        placement: we,
        boundary: c,
        rootBoundary: d,
        padding: I,
        flipVariations: b,
        allowedAutoPlacements: m
      }) : we);
    }, []), W = t.rects.reference, V = t.rects.popper, w = /* @__PURE__ */ new Map(), v = !0, H = y[0], x = 0; x < y.length; x++) {
      var J = y[x], K = pI(J), M = rm(J) === tm, L = [gl, Na].indexOf(K) >= 0, N = L ? "width" : "height", U = Vf(t, {
        placement: J,
        boundary: c,
        rootBoundary: d,
        altBoundary: C,
        padding: I
      }), O = L ? M ? La : ol : M ? Na : gl;
      W[N] > V[N] && (O = IV(O));
      var $ = IV(O), ne = [];
      if (g && ne.push(U[K] <= 0), l && ne.push(U[O] <= 0, U[$] <= 0), ne.every(function(ke) {
        return ke;
      })) {
        H = J, v = !1;
        break;
      }
      w.set(J, ne);
    }
    if (v)
      for (var be = b ? 3 : 1, Ve = function(we) {
        var ue = y.find(function(Xe) {
          var Ze = w.get(Xe);
          if (Ze)
            return Ze.slice(0, we).every(function(xe) {
              return xe;
            });
        });
        if (ue)
          return H = ue, "break";
      }, He = be; He > 0; He--) {
        var Je = Ve(He);
        if (Je === "break")
          break;
      }
    t.placement !== H && (t.modifiersData[n]._skip = !0, t.placement = H, t.reset = !0);
  }
}
const VCe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: SCe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function yK(e, t, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - i.y,
    right: e.right - t.width + i.x,
    bottom: e.bottom - t.height + i.y,
    left: e.left - t.width - i.x
  };
}
function WK(e) {
  return [gl, La, Na, ol].some(function(t) {
    return e[t] >= 0;
  });
}
function wCe(e) {
  var t = e.state, i = e.name, n = t.rects.reference, r = t.rects.popper, g = t.modifiersData.preventOverflow, o = Vf(t, {
    elementContext: "reference"
  }), l = Vf(t, {
    altBoundary: !0
  }), a = yK(o, n), I = yK(l, r, g), c = WK(a), d = WK(I);
  t.modifiersData[i] = {
    referenceClippingOffsets: a,
    popperEscapeOffsets: I,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const vCe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: wCe
};
function RCe(e, t, i) {
  var n = pI(e), r = [ol, gl].indexOf(n) >= 0 ? -1 : 1, g = typeof i == "function" ? i(Object.assign({}, t, {
    placement: e
  })) : i, o = g[0], l = g[1];
  return o = o || 0, l = (l || 0) * r, [ol, La].indexOf(n) >= 0 ? {
    x: l,
    y: o
  } : {
    x: o,
    y: l
  };
}
function XCe(e) {
  var t = e.state, i = e.options, n = e.name, r = i.offset, g = r === void 0 ? [0, 0] : r, o = _Q.reduce(function(c, d) {
    return c[d] = RCe(d, t.rects, g), c;
  }, {}), l = o[t.placement], a = l.x, I = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += a, t.modifiersData.popperOffsets.y += I), t.modifiersData[n] = o;
}
const HCe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: XCe
};
function kCe(e) {
  var t = e.state, i = e.name;
  t.modifiersData[i] = gj({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const YCe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: kCe,
  data: {}
};
function FCe(e) {
  return e === "x" ? "y" : "x";
}
function xCe(e) {
  var t = e.state, i = e.options, n = e.name, r = i.mainAxis, g = r === void 0 ? !0 : r, o = i.altAxis, l = o === void 0 ? !1 : o, a = i.boundary, I = i.rootBoundary, c = i.altBoundary, d = i.padding, C = i.tether, A = C === void 0 ? !0 : C, b = i.tetherOffset, m = b === void 0 ? 0 : b, p = Vf(t, {
    boundary: a,
    rootBoundary: I,
    padding: d,
    altBoundary: c
  }), B = pI(t.placement), f = rm(t.placement), Z = !f, y = aJ(B), W = FCe(y), V = t.modifiersData.popperOffsets, w = t.rects.reference, v = t.rects.popper, H = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, x = typeof H == "number" ? {
    mainAxis: H,
    altAxis: H
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, H), J = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, K = {
    x: 0,
    y: 0
  };
  if (V) {
    if (g) {
      var M, L = y === "y" ? gl : ol, N = y === "y" ? Na : La, U = y === "y" ? "height" : "width", O = V[y], $ = O + p[L], ne = O - p[N], be = A ? -v[U] / 2 : 0, Ve = f === tm ? w[U] : v[U], He = f === tm ? -v[U] : -w[U], Je = t.elements.arrow, ke = A && Je ? lJ(Je) : {
        width: 0,
        height: 0
      }, we = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : tj(), ue = we[L], Xe = we[N], Ze = zB(0, w[U], ke[U]), xe = Z ? w[U] / 2 - be - Ze - ue - x.mainAxis : Ve - Ze - ue - x.mainAxis, Pe = Z ? -w[U] / 2 + be + Ze + Xe + x.mainAxis : He + Ze + Xe + x.mainAxis, st = t.elements.arrow && BZ(t.elements.arrow), bt = st ? y === "y" ? st.clientTop || 0 : st.clientLeft || 0 : 0, it = (M = J == null ? void 0 : J[y]) != null ? M : 0, Qe = O + xe - it - bt, $e = O + Pe - it, It = zB(A ? UV($, Qe) : $, O, A ? UC(ne, $e) : ne);
      V[y] = It, K[y] = It - O;
    }
    if (l) {
      var jt, Bt = y === "x" ? gl : ol, te = y === "x" ? Na : La, Xt = V[W], Ht = W === "y" ? "height" : "width", ii = Xt + p[Bt], $t = Xt - p[te], ni = [gl, ol].indexOf(B) !== -1, mi = (jt = J == null ? void 0 : J[W]) != null ? jt : 0, Bi = ni ? ii : Xt - w[Ht] - v[Ht] - mi + x.altAxis, ci = ni ? Xt + w[Ht] + v[Ht] - mi - x.altAxis : $t, Ge = A && ni ? oCe(Bi, Xt, ci) : zB(A ? Bi : ii, Xt, A ? ci : $t);
      V[W] = Ge, K[W] = Ge - Xt;
    }
    t.modifiersData[n] = K;
  }
}
const DCe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: xCe,
  requiresIfExists: ["offset"]
};
function JCe(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ECe(e) {
  return e === Ul(e) || !xa(e) ? sJ(e) : JCe(e);
}
function NCe(e) {
  var t = e.getBoundingClientRect(), i = im(t.width) / e.offsetWidth || 1, n = im(t.height) / e.offsetHeight || 1;
  return i !== 1 || n !== 1;
}
function LCe(e, t, i) {
  i === void 0 && (i = !1);
  var n = xa(t), r = xa(t) && NCe(t), g = lu(t), o = nm(e, r, i), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = {
    x: 0,
    y: 0
  };
  return (n || !n && !i) && ((WI(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  cJ(g)) && (l = ECe(t)), xa(t) ? (a = nm(t, !0), a.x += t.clientLeft, a.y += t.clientTop) : g && (a.x = IJ(g))), {
    x: o.left + l.scrollLeft - a.x,
    y: o.top + l.scrollTop - a.y,
    width: o.width,
    height: o.height
  };
}
function KCe(e) {
  var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(g) {
    t.set(g.name, g);
  });
  function r(g) {
    i.add(g.name);
    var o = [].concat(g.requires || [], g.requiresIfExists || []);
    o.forEach(function(l) {
      if (!i.has(l)) {
        var a = t.get(l);
        a && r(a);
      }
    }), n.push(g);
  }
  return e.forEach(function(g) {
    i.has(g.name) || r(g);
  }), n;
}
function TCe(e) {
  var t = KCe(e);
  return eCe.reduce(function(i, n) {
    return i.concat(t.filter(function(r) {
      return r.phase === n;
    }));
  }, []);
}
function MCe(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(i) {
      Promise.resolve().then(function() {
        t = void 0, i(e());
      });
    })), t;
  };
}
function PCe(e) {
  var t = e.reduce(function(i, n) {
    var r = i[n.name];
    return i[n.name] = r ? Object.assign({}, r, n, {
      options: Object.assign({}, r.options, n.options),
      data: Object.assign({}, r.data, n.data)
    }) : n, i;
  }, {});
  return Object.keys(t).map(function(i) {
    return t[i];
  });
}
var SK = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function VK() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function UCe(e) {
  e === void 0 && (e = {});
  var t = e, i = t.defaultModifiers, n = i === void 0 ? [] : i, r = t.defaultOptions, g = r === void 0 ? SK : r;
  return function(l, a, I) {
    I === void 0 && (I = g);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, SK, g),
      modifiersData: {},
      elements: {
        reference: l,
        popper: a
      },
      attributes: {},
      styles: {}
    }, d = [], C = !1, A = {
      state: c,
      setOptions: function(B) {
        var f = typeof B == "function" ? B(c.options) : B;
        m(), c.options = Object.assign({}, g, c.options, f), c.scrollParents = {
          reference: eA(l) ? OB(l) : l.contextElement ? OB(l.contextElement) : [],
          popper: OB(a)
        };
        var Z = TCe(PCe([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = Z.filter(function(y) {
          return y.enabled;
        }), b(), A.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!C) {
          var B = c.elements, f = B.reference, Z = B.popper;
          if (VK(f, Z)) {
            c.rects = {
              reference: LCe(f, BZ(Z), c.options.strategy === "fixed"),
              popper: lJ(Z)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(x) {
              return c.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var y = 0; y < c.orderedModifiers.length; y++) {
              if (c.reset === !0) {
                c.reset = !1, y = -1;
                continue;
              }
              var W = c.orderedModifiers[y], V = W.fn, w = W.options, v = w === void 0 ? {} : w, H = W.name;
              typeof V == "function" && (c = V({
                state: c,
                options: v,
                name: H,
                instance: A
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: MCe(function() {
        return new Promise(function(p) {
          A.forceUpdate(), p(c);
        });
      }),
      destroy: function() {
        m(), C = !0;
      }
    };
    if (!VK(l, a))
      return A;
    A.setOptions(I).then(function(p) {
      !C && I.onFirstUpdate && I.onFirstUpdate(p);
    });
    function b() {
      c.orderedModifiers.forEach(function(p) {
        var B = p.name, f = p.options, Z = f === void 0 ? {} : f, y = p.effect;
        if (typeof y == "function") {
          var W = y({
            state: c,
            name: B,
            instance: A,
            options: Z
          }), V = function() {
          };
          d.push(W || V);
        }
      });
    }
    function m() {
      d.forEach(function(p) {
        return p();
      }), d = [];
    }
    return A;
  };
}
var zCe = [bCe, YCe, CCe, nCe, HCe, VCe, DCe, ICe, vCe], OCe = /* @__PURE__ */ UCe({
  defaultModifiers: zCe
});
const oj = "Popper";
function QCe(e) {
  return QQ(oj, e);
}
Wue(oj, ["root"]);
const jCe = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], qCe = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function _Ce(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Gx(e) {
  return typeof e == "function" ? e() : e;
}
function $Ce(e) {
  return e.nodeType !== void 0;
}
const eAe = () => Mt({
  root: ["root"]
}, dde(QCe)), tAe = {}, iAe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n;
  const {
    anchorEl: r,
    children: g,
    direction: o,
    disablePortal: l,
    modifiers: a,
    open: I,
    placement: c,
    popperOptions: d,
    popperRef: C,
    slotProps: A = {},
    slots: b = {},
    TransitionProps: m
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, p = jr(t, jCe), B = X.useRef(null), f = Zn(B, i), Z = X.useRef(null), y = Zn(Z, C), W = X.useRef(y);
  no(() => {
    W.current = y;
  }, [y]), X.useImperativeHandle(C, () => Z.current, []);
  const V = _Ce(c, o), [w, v] = X.useState(V), [H, x] = X.useState(Gx(r));
  X.useEffect(() => {
    Z.current && Z.current.forceUpdate();
  }), X.useEffect(() => {
    r && x(Gx(r));
  }, [r]), no(() => {
    if (!H || !I)
      return;
    const N = ($) => {
      v($.placement);
    };
    let U = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: $
      }) => {
        N($);
      }
    }];
    a != null && (U = U.concat(a)), d && d.modifiers != null && (U = U.concat(d.modifiers));
    const O = OCe(H, B.current, et({
      placement: V
    }, d, {
      modifiers: U
    }));
    return W.current(O), () => {
      O.destroy(), W.current(null);
    };
  }, [H, l, a, I, d, V]);
  const J = {
    placement: w
  };
  m !== null && (J.TransitionProps = m);
  const K = eAe(), M = (n = b.root) != null ? n : "div", L = Fr({
    elementType: M,
    externalSlotProps: A.root,
    externalForwardedProps: p,
    additionalProps: {
      role: "tooltip",
      ref: f
    },
    ownerState: t,
    className: K.root
  });
  return /* @__PURE__ */ ee(M, et({}, L, {
    children: typeof g == "function" ? g(J) : g
  }));
}), nAe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    anchorEl: n,
    children: r,
    container: g,
    direction: o = "ltr",
    disablePortal: l = !1,
    keepMounted: a = !1,
    modifiers: I,
    open: c,
    placement: d = "bottom",
    popperOptions: C = tAe,
    popperRef: A,
    style: b,
    transition: m = !1,
    slotProps: p = {},
    slots: B = {}
  } = t, f = jr(t, qCe), [Z, y] = X.useState(!0), W = () => {
    y(!1);
  }, V = () => {
    y(!0);
  };
  if (!a && !c && (!m || Z))
    return null;
  let w;
  if (g)
    w = g;
  else if (n) {
    const x = Gx(n);
    w = x && $Ce(x) ? Vr(x).body : Vr(null).body;
  }
  const v = !c && a && (!m || Z) ? "none" : void 0, H = m ? {
    in: c,
    onEnter: W,
    onExited: V
  } : void 0;
  return /* @__PURE__ */ ee(jQ, {
    disablePortal: l,
    container: w,
    children: /* @__PURE__ */ ee(iAe, et({
      anchorEl: n,
      direction: o,
      disablePortal: l,
      modifiers: I,
      ref: i,
      open: m ? !Z : c,
      placement: d,
      popperOptions: C,
      popperRef: A,
      slotProps: p,
      slots: B
    }, f, {
      style: et({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: v
      }, b),
      TransitionProps: H,
      children: r
    }))
  });
}), rAe = 2;
function lj(e, t) {
  return e - t;
}
function wK(e, t) {
  var i;
  const {
    index: n
  } = (i = e.reduce((r, g, o) => {
    const l = Math.abs(t - g);
    return r === null || l < r.distance || l === r.distance ? {
      distance: l,
      index: o
    } : r;
  }, null)) != null ? i : {};
  return n;
}
function kW(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const i = e;
    for (let n = 0; n < i.changedTouches.length; n += 1) {
      const r = i.changedTouches[n];
      if (r.identifier === t.current)
        return {
          x: r.clientX,
          y: r.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function zV(e, t, i) {
  return (e - t) * 100 / (i - t);
}
function gAe(e, t, i) {
  return (i - t) * e + t;
}
function oAe(e) {
  if (Math.abs(e) < 1) {
    const i = e.toExponential().split("e-"), n = i[0].split(".")[1];
    return (n ? n.length : 0) + parseInt(i[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function lAe(e, t, i) {
  const n = Math.round((e - i) / t) * t + i;
  return Number(n.toFixed(oAe(t)));
}
function vK({
  values: e,
  newValue: t,
  index: i
}) {
  const n = e.slice();
  return n[i] = t, n.sort(lj);
}
function YW({
  sliderRef: e,
  activeIndex: t,
  setActive: i
}) {
  var n, r;
  const g = Vr(e.current);
  if (!((n = e.current) != null && n.contains(g.activeElement)) || Number(g == null || (r = g.activeElement) == null ? void 0 : r.getAttribute("data-index")) !== t) {
    var o;
    (o = e.current) == null || o.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  i && i(t);
}
function FW(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? sde(e, t) : !1;
}
const aAe = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, sAe = (e) => e;
let xW;
function RK() {
  return xW === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? xW = CSS.supports("touch-action", "none") : xW = !0), xW;
}
function IAe(e) {
  const {
    "aria-labelledby": t,
    defaultValue: i,
    disabled: n = !1,
    disableSwap: r = !1,
    isRtl: g = !1,
    marks: o = !1,
    max: l = 100,
    min: a = 0,
    name: I,
    onChange: c,
    onChangeCommitted: d,
    orientation: C = "horizontal",
    rootRef: A,
    scale: b = sAe,
    step: m = 1,
    shiftStep: p = 10,
    tabIndex: B,
    value: f
  } = e, Z = X.useRef(), [y, W] = X.useState(-1), [V, w] = X.useState(-1), [v, H] = X.useState(!1), x = X.useRef(0), [J, K] = Xs({
    controlled: f,
    default: i ?? a,
    name: "Slider"
  }), M = c && ((Ge, Be, qe) => {
    const vt = Ge.nativeEvent || Ge, Kt = new vt.constructor(vt.type, vt);
    Object.defineProperty(Kt, "target", {
      writable: !0,
      value: {
        value: Be,
        name: I
      }
    }), c(Kt, Be, qe);
  }), L = Array.isArray(J);
  let N = L ? J.slice().sort(lj) : [J];
  N = N.map((Ge) => Ge == null ? a : vC(Ge, a, l));
  const U = o === !0 && m !== null ? [...Array(Math.floor((l - a) / m) + 1)].map((Ge, Be) => ({
    value: a + m * Be
  })) : o || [], O = U.map((Ge) => Ge.value), {
    isFocusVisibleRef: $,
    onBlur: ne,
    onFocus: be,
    ref: Ve
  } = hZ(), [He, Je] = X.useState(-1), ke = X.useRef(), we = Zn(Ve, ke), ue = Zn(A, we), Xe = (Ge) => (Be) => {
    var qe;
    const vt = Number(Be.currentTarget.getAttribute("data-index"));
    be(Be), $.current === !0 && Je(vt), w(vt), Ge == null || (qe = Ge.onFocus) == null || qe.call(Ge, Be);
  }, Ze = (Ge) => (Be) => {
    var qe;
    ne(Be), $.current === !1 && Je(-1), w(-1), Ge == null || (qe = Ge.onBlur) == null || qe.call(Ge, Be);
  }, xe = (Ge, Be) => {
    const qe = Number(Ge.currentTarget.getAttribute("data-index")), vt = N[qe], Kt = O.indexOf(vt);
    let Te = Be;
    if (U && m == null) {
      const Tt = O[O.length - 1];
      Te > Tt ? Te = Tt : Te < O[0] ? Te = O[0] : Te = Te < vt ? O[Kt - 1] : O[Kt + 1];
    }
    if (Te = vC(Te, a, l), L) {
      r && (Te = vC(Te, N[qe - 1] || -1 / 0, N[qe + 1] || 1 / 0));
      const Tt = Te;
      Te = vK({
        values: N,
        newValue: Te,
        index: qe
      });
      let Ue = qe;
      r || (Ue = Te.indexOf(Tt)), YW({
        sliderRef: ke,
        activeIndex: Ue
      });
    }
    K(Te), Je(qe), M && !FW(Te, J) && M(Ge, Te, qe), d && d(Ge, Te);
  }, Pe = (Ge) => (Be) => {
    var qe;
    if (m !== null) {
      const vt = Number(Be.currentTarget.getAttribute("data-index")), Kt = N[vt];
      let Te = null;
      (Be.key === "ArrowLeft" || Be.key === "ArrowDown") && Be.shiftKey || Be.key === "PageDown" ? Te = Math.max(Kt - p, a) : ((Be.key === "ArrowRight" || Be.key === "ArrowUp") && Be.shiftKey || Be.key === "PageUp") && (Te = Math.min(Kt + p, l)), Te !== null && (xe(Be, Te), Be.preventDefault());
    }
    Ge == null || (qe = Ge.onKeyDown) == null || qe.call(Ge, Be);
  };
  no(() => {
    if (n && ke.current.contains(document.activeElement)) {
      var Ge;
      (Ge = document.activeElement) == null || Ge.blur();
    }
  }, [n]), n && y !== -1 && W(-1), n && He !== -1 && Je(-1);
  const st = (Ge) => (Be) => {
    var qe;
    (qe = Ge.onChange) == null || qe.call(Ge, Be), xe(Be, Be.target.valueAsNumber);
  }, bt = X.useRef();
  let it = C;
  g && C === "horizontal" && (it += "-reverse");
  const Qe = ({
    finger: Ge,
    move: Be = !1
  }) => {
    const {
      current: qe
    } = ke, {
      width: vt,
      height: Kt,
      bottom: Te,
      left: Tt
    } = qe.getBoundingClientRect();
    let Ue;
    it.indexOf("vertical") === 0 ? Ue = (Te - Ge.y) / Kt : Ue = (Ge.x - Tt) / vt, it.indexOf("-reverse") !== -1 && (Ue = 1 - Ue);
    let Me;
    if (Me = gAe(Ue, a, l), m)
      Me = lAe(Me, m, a);
    else {
      const zt = wK(O, Me);
      Me = O[zt];
    }
    Me = vC(Me, a, l);
    let Yt = 0;
    if (L) {
      Be ? Yt = bt.current : Yt = wK(N, Me), r && (Me = vC(Me, N[Yt - 1] || -1 / 0, N[Yt + 1] || 1 / 0));
      const zt = Me;
      Me = vK({
        values: N,
        newValue: Me,
        index: Yt
      }), r && Be || (Yt = Me.indexOf(zt), bt.current = Yt);
    }
    return {
      newValue: Me,
      activeIndex: Yt
    };
  }, $e = Qr((Ge) => {
    const Be = kW(Ge, Z);
    if (!Be)
      return;
    if (x.current += 1, Ge.type === "mousemove" && Ge.buttons === 0) {
      It(Ge);
      return;
    }
    const {
      newValue: qe,
      activeIndex: vt
    } = Qe({
      finger: Be,
      move: !0
    });
    YW({
      sliderRef: ke,
      activeIndex: vt,
      setActive: W
    }), K(qe), !v && x.current > rAe && H(!0), M && !FW(qe, J) && M(Ge, qe, vt);
  }), It = Qr((Ge) => {
    const Be = kW(Ge, Z);
    if (H(!1), !Be)
      return;
    const {
      newValue: qe
    } = Qe({
      finger: Be,
      move: !0
    });
    W(-1), Ge.type === "touchend" && w(-1), d && d(Ge, qe), Z.current = void 0, Bt();
  }), jt = Qr((Ge) => {
    if (n)
      return;
    RK() || Ge.preventDefault();
    const Be = Ge.changedTouches[0];
    Be != null && (Z.current = Be.identifier);
    const qe = kW(Ge, Z);
    if (qe !== !1) {
      const {
        newValue: Kt,
        activeIndex: Te
      } = Qe({
        finger: qe
      });
      YW({
        sliderRef: ke,
        activeIndex: Te,
        setActive: W
      }), K(Kt), M && !FW(Kt, J) && M(Ge, Kt, Te);
    }
    x.current = 0;
    const vt = Vr(ke.current);
    vt.addEventListener("touchmove", $e, {
      passive: !0
    }), vt.addEventListener("touchend", It, {
      passive: !0
    });
  }), Bt = X.useCallback(() => {
    const Ge = Vr(ke.current);
    Ge.removeEventListener("mousemove", $e), Ge.removeEventListener("mouseup", It), Ge.removeEventListener("touchmove", $e), Ge.removeEventListener("touchend", It);
  }, [It, $e]);
  X.useEffect(() => {
    const {
      current: Ge
    } = ke;
    return Ge.addEventListener("touchstart", jt, {
      passive: RK()
    }), () => {
      Ge.removeEventListener("touchstart", jt), Bt();
    };
  }, [Bt, jt]), X.useEffect(() => {
    n && Bt();
  }, [n, Bt]);
  const te = (Ge) => (Be) => {
    var qe;
    if ((qe = Ge.onMouseDown) == null || qe.call(Ge, Be), n || Be.defaultPrevented || Be.button !== 0)
      return;
    Be.preventDefault();
    const vt = kW(Be, Z);
    if (vt !== !1) {
      const {
        newValue: Te,
        activeIndex: Tt
      } = Qe({
        finger: vt
      });
      YW({
        sliderRef: ke,
        activeIndex: Tt,
        setActive: W
      }), K(Te), M && !FW(Te, J) && M(Be, Te, Tt);
    }
    x.current = 0;
    const Kt = Vr(ke.current);
    Kt.addEventListener("mousemove", $e, {
      passive: !0
    }), Kt.addEventListener("mouseup", It);
  }, Xt = zV(L ? N[0] : a, a, l), Ht = zV(N[N.length - 1], a, l) - Xt, ii = (Ge = {}) => {
    const Be = PB(Ge), qe = {
      onMouseDown: te(Be || {})
    }, vt = et({}, Be, qe);
    return et({}, Ge, {
      ref: ue
    }, vt);
  }, $t = (Ge) => (Be) => {
    var qe;
    (qe = Ge.onMouseOver) == null || qe.call(Ge, Be);
    const vt = Number(Be.currentTarget.getAttribute("data-index"));
    w(vt);
  }, ni = (Ge) => (Be) => {
    var qe;
    (qe = Ge.onMouseLeave) == null || qe.call(Ge, Be), w(-1);
  };
  return {
    active: y,
    axis: it,
    axisProps: aAe,
    dragging: v,
    focusedThumbIndex: He,
    getHiddenInputProps: (Ge = {}) => {
      var Be;
      const qe = PB(Ge), vt = {
        onChange: st(qe || {}),
        onFocus: Xe(qe || {}),
        onBlur: Ze(qe || {}),
        onKeyDown: Pe(qe || {})
      }, Kt = et({}, qe, vt);
      return et({
        tabIndex: B,
        "aria-labelledby": t,
        "aria-orientation": C,
        "aria-valuemax": b(l),
        "aria-valuemin": b(a),
        name: I,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (Be = e.step) != null ? Be : void 0,
        disabled: n
      }, Ge, Kt, {
        style: et({}, mIe, {
          direction: g ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: ii,
    getThumbProps: (Ge = {}) => {
      const Be = PB(Ge), qe = {
        onMouseOver: $t(Be || {}),
        onMouseLeave: ni(Be || {})
      };
      return et({}, Ge, Be, qe);
    },
    marks: U,
    open: V,
    range: L,
    rootRef: ue,
    trackLeap: Ht,
    trackOffset: Xt,
    values: N,
    getThumbStyle: (Ge) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: y !== -1 && y !== Ge ? "none" : void 0
    })
  };
}
const cAe = ["onChange", "maxRows", "minRows", "style", "value"];
function DW(e) {
  return parseInt(e, 10) || 0;
}
const dAe = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function uAe(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const CAe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    onChange: n,
    maxRows: r,
    minRows: g = 1,
    style: o,
    value: l
  } = t, a = jr(t, cAe), {
    current: I
  } = X.useRef(l != null), c = X.useRef(null), d = Zn(i, c), C = X.useRef(null), A = X.useCallback(() => {
    const p = c.current, f = Ja(p).getComputedStyle(p);
    if (f.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const Z = C.current;
    Z.style.width = f.width, Z.value = p.value || t.placeholder || "x", Z.value.slice(-1) === `
` && (Z.value += " ");
    const y = f.boxSizing, W = DW(f.paddingBottom) + DW(f.paddingTop), V = DW(f.borderBottomWidth) + DW(f.borderTopWidth), w = Z.scrollHeight;
    Z.value = "x";
    const v = Z.scrollHeight;
    let H = w;
    g && (H = Math.max(Number(g) * v, H)), r && (H = Math.min(Number(r) * v, H)), H = Math.max(H, v);
    const x = H + (y === "border-box" ? W + V : 0), J = Math.abs(H - w) <= 1;
    return {
      outerHeightStyle: x,
      overflowing: J
    };
  }, [r, g, t.placeholder]), b = X.useCallback(() => {
    const p = A();
    if (uAe(p))
      return;
    const B = c.current;
    B.style.height = `${p.outerHeightStyle}px`, B.style.overflow = p.overflowing ? "hidden" : "";
  }, [A]);
  no(() => {
    const p = () => {
      b();
    };
    let B;
    const f = ym(p), Z = c.current, y = Ja(Z);
    y.addEventListener("resize", f);
    let W;
    return typeof ResizeObserver < "u" && (W = new ResizeObserver(p), W.observe(Z)), () => {
      f.clear(), cancelAnimationFrame(B), y.removeEventListener("resize", f), W && W.disconnect();
    };
  }, [A, b]), no(() => {
    b();
  });
  const m = (p) => {
    I || b(), n && n(p);
  };
  return /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ ee("textarea", et({
      value: l,
      onChange: m,
      ref: d,
      rows: g,
      style: o
    }, a)), /* @__PURE__ */ ee("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: C,
      tabIndex: -1,
      style: et({}, dAe.shadow, o, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
function XK(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function AAe(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: i = !0,
    limit: n,
    matchFrom: r = "any",
    stringify: g,
    trim: o = !1
  } = e;
  return (l, {
    inputValue: a,
    getOptionLabel: I
  }) => {
    let c = o ? a.trim() : a;
    i && (c = c.toLowerCase()), t && (c = XK(c));
    const d = c ? l.filter((C) => {
      let A = (g || I)(C);
      return i && (A = A.toLowerCase()), t && (A = XK(A)), r === "start" ? A.indexOf(c) === 0 : A.indexOf(c) > -1;
    }) : l;
    return typeof n == "number" ? d.slice(0, n) : d;
  };
}
function JW(e, t) {
  for (let i = 0; i < e.length; i += 1)
    if (t(e[i]))
      return i;
  return -1;
}
const bAe = AAe(), HK = 5, hAe = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
};
function mAe(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = hAe,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: i = "Mui",
    autoComplete: n = !1,
    autoHighlight: r = !1,
    autoSelect: g = !1,
    blurOnSelect: o = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: a = !1,
    componentName: I = "useAutocomplete",
    defaultValue: c = e.multiple ? [] : null,
    disableClearable: d = !1,
    disableCloseOnSelect: C = !1,
    disabled: A,
    disabledItemsFocusable: b = !1,
    disableListWrap: m = !1,
    filterOptions: p = bAe,
    filterSelectedOptions: B = !1,
    freeSolo: f = !1,
    getOptionDisabled: Z,
    getOptionKey: y,
    getOptionLabel: W = (fe) => {
      var Ae;
      return (Ae = fe.label) != null ? Ae : fe;
    },
    groupBy: V,
    handleHomeEndKeys: w = !e.freeSolo,
    id: v,
    includeInputInList: H = !1,
    inputValue: x,
    isOptionEqualToValue: J = (fe, Ae) => fe === Ae,
    multiple: K = !1,
    onChange: M,
    onClose: L,
    onHighlightChange: N,
    onInputChange: U,
    onOpen: O,
    open: $,
    openOnFocus: ne = !1,
    options: be,
    readOnly: Ve = !1,
    selectOnFocus: He = !e.freeSolo,
    value: Je
  } = e, ke = uA(v);
  let we = W;
  we = (fe) => {
    const Ae = W(fe);
    return typeof Ae != "string" ? String(Ae) : Ae;
  };
  const ue = X.useRef(!1), Xe = X.useRef(!0), Ze = X.useRef(null), xe = X.useRef(null), [Pe, st] = X.useState(null), [bt, it] = X.useState(-1), Qe = r ? 0 : -1, $e = X.useRef(Qe), [It, jt] = Xs({
    controlled: Je,
    default: c,
    name: I
  }), [Bt, te] = Xs({
    controlled: x,
    default: "",
    name: I,
    state: "inputValue"
  }), [Xt, Ht] = X.useState(!1), ii = X.useCallback((fe, Ae) => {
    if (!(K ? It.length < Ae.length : Ae !== null) && !l)
      return;
    let _e;
    if (K)
      _e = "";
    else if (Ae == null)
      _e = "";
    else {
      const Qt = we(Ae);
      _e = typeof Qt == "string" ? Qt : "";
    }
    Bt !== _e && (te(_e), U && U(fe, _e, "reset"));
  }, [we, Bt, K, U, te, l, It]), [$t, ni] = Xs({
    controlled: $,
    default: !1,
    name: I,
    state: "open"
  }), [mi, Bi] = X.useState(!0), ci = !K && It != null && Bt === we(It), Ge = $t && !Ve, Be = Ge ? p(
    be.filter((fe) => !(B && (K ? It : [It]).some((Ae) => Ae !== null && J(fe, Ae)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: ci && mi ? "" : Bt,
      getOptionLabel: we
    }
  ) : [], qe = hIe({
    filteredOptions: Be,
    value: It,
    inputValue: Bt
  });
  X.useEffect(() => {
    const fe = It !== qe.value;
    Xt && !fe || f && !fe || ii(null, It);
  }, [It, ii, Xt, qe.value, f]);
  const vt = $t && Be.length > 0 && !Ve, Kt = Qr((fe) => {
    fe === -1 ? Ze.current.focus() : Pe.querySelector(`[data-tag-index="${fe}"]`).focus();
  });
  X.useEffect(() => {
    K && bt > It.length - 1 && (it(-1), Kt(-1));
  }, [It, K, bt, Kt]);
  function Te(fe, Ae) {
    if (!xe.current || fe < 0 || fe >= Be.length)
      return -1;
    let gt = fe;
    for (; ; ) {
      const _e = xe.current.querySelector(`[data-option-index="${gt}"]`), Qt = b ? !1 : !_e || _e.disabled || _e.getAttribute("aria-disabled") === "true";
      if (_e && _e.hasAttribute("tabindex") && !Qt)
        return gt;
      if (Ae === "next" ? gt = (gt + 1) % Be.length : gt = (gt - 1 + Be.length) % Be.length, gt === fe)
        return -1;
    }
  }
  const Tt = Qr(({
    event: fe,
    index: Ae,
    reason: gt = "auto"
  }) => {
    if ($e.current = Ae, Ae === -1 ? Ze.current.removeAttribute("aria-activedescendant") : Ze.current.setAttribute("aria-activedescendant", `${ke}-option-${Ae}`), N && N(fe, Ae === -1 ? null : Be[Ae], gt), !xe.current)
      return;
    const _e = xe.current.querySelector(`[role="option"].${i}-focused`);
    _e && (_e.classList.remove(`${i}-focused`), _e.classList.remove(`${i}-focusVisible`));
    let Qt = xe.current;
    if (xe.current.getAttribute("role") !== "listbox" && (Qt = xe.current.parentElement.querySelector('[role="listbox"]')), !Qt)
      return;
    if (Ae === -1) {
      Qt.scrollTop = 0;
      return;
    }
    const kt = xe.current.querySelector(`[data-option-index="${Ae}"]`);
    if (kt && (kt.classList.add(`${i}-focused`), gt === "keyboard" && kt.classList.add(`${i}-focusVisible`), Qt.scrollHeight > Qt.clientHeight && gt !== "mouse" && gt !== "touch")) {
      const ti = kt, tn = Qt.clientHeight + Qt.scrollTop, ao = ti.offsetTop + ti.offsetHeight;
      ao > tn ? Qt.scrollTop = ao - Qt.clientHeight : ti.offsetTop - ti.offsetHeight * (V ? 1.3 : 0) < Qt.scrollTop && (Qt.scrollTop = ti.offsetTop - ti.offsetHeight * (V ? 1.3 : 0));
    }
  }), Ue = Qr(({
    event: fe,
    diff: Ae,
    direction: gt = "next",
    reason: _e = "auto"
  }) => {
    if (!Ge)
      return;
    const kt = Te((() => {
      const ti = Be.length - 1;
      if (Ae === "reset")
        return Qe;
      if (Ae === "start")
        return 0;
      if (Ae === "end")
        return ti;
      const tn = $e.current + Ae;
      return tn < 0 ? tn === -1 && H ? -1 : m && $e.current !== -1 || Math.abs(Ae) > 1 ? 0 : ti : tn > ti ? tn === ti + 1 && H ? -1 : m || Math.abs(Ae) > 1 ? ti : 0 : tn;
    })(), gt);
    if (Tt({
      index: kt,
      reason: _e,
      event: fe
    }), n && Ae !== "reset")
      if (kt === -1)
        Ze.current.value = Bt;
      else {
        const ti = we(Be[kt]);
        Ze.current.value = ti, ti.toLowerCase().indexOf(Bt.toLowerCase()) === 0 && Bt.length > 0 && Ze.current.setSelectionRange(Bt.length, ti.length);
      }
  }), Me = () => {
    const fe = (Ae, gt) => {
      const _e = Ae ? we(Ae) : "", Qt = gt ? we(gt) : "";
      return _e === Qt;
    };
    if ($e.current !== -1 && qe.filteredOptions && qe.filteredOptions.length !== Be.length && qe.inputValue === Bt && (K ? It.length === qe.value.length && qe.value.every((Ae, gt) => we(It[gt]) === we(Ae)) : fe(qe.value, It))) {
      const Ae = qe.filteredOptions[$e.current];
      if (Ae)
        return JW(Be, (gt) => we(gt) === we(Ae));
    }
    return -1;
  }, Yt = X.useCallback(() => {
    if (!Ge)
      return;
    const fe = Me();
    if (fe !== -1) {
      $e.current = fe;
      return;
    }
    const Ae = K ? It[0] : It;
    if (Be.length === 0 || Ae == null) {
      Ue({
        diff: "reset"
      });
      return;
    }
    if (xe.current) {
      if (Ae != null) {
        const gt = Be[$e.current];
        if (K && gt && JW(It, (Qt) => J(gt, Qt)) !== -1)
          return;
        const _e = JW(Be, (Qt) => J(Qt, Ae));
        _e === -1 ? Ue({
          diff: "reset"
        }) : Tt({
          index: _e
        });
        return;
      }
      if ($e.current >= Be.length - 1) {
        Tt({
          index: Be.length - 1
        });
        return;
      }
      Tt({
        index: $e.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Be.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    K ? !1 : It,
    B,
    Ue,
    Tt,
    Ge,
    Bt,
    K
  ]), zt = Qr((fe) => {
    Wf(xe, fe), fe && Yt();
  });
  X.useEffect(() => {
    Yt();
  }, [Yt]);
  const ri = (fe) => {
    $t || (ni(!0), Bi(!0), O && O(fe));
  }, di = (fe, Ae) => {
    $t && (ni(!1), L && L(fe, Ae));
  }, mt = (fe, Ae, gt, _e) => {
    if (K) {
      if (It.length === Ae.length && It.every((Qt, kt) => Qt === Ae[kt]))
        return;
    } else if (It === Ae)
      return;
    M && M(fe, Ae, gt, _e), jt(Ae);
  }, Ai = X.useRef(!1), ui = (fe, Ae, gt = "selectOption", _e = "options") => {
    let Qt = gt, kt = Ae;
    if (K) {
      kt = Array.isArray(It) ? It.slice() : [];
      const ti = JW(kt, (tn) => J(Ae, tn));
      ti === -1 ? kt.push(Ae) : _e !== "freeSolo" && (kt.splice(ti, 1), Qt = "removeOption");
    }
    ii(fe, kt), mt(fe, kt, Qt, {
      option: Ae
    }), !C && (!fe || !fe.ctrlKey && !fe.metaKey) && di(fe, Qt), (o === !0 || o === "touch" && Ai.current || o === "mouse" && !Ai.current) && Ze.current.blur();
  };
  function Ui(fe, Ae) {
    if (fe === -1)
      return -1;
    let gt = fe;
    for (; ; ) {
      if (Ae === "next" && gt === It.length || Ae === "previous" && gt === -1)
        return -1;
      const _e = Pe.querySelector(`[data-tag-index="${gt}"]`);
      if (!_e || !_e.hasAttribute("tabindex") || _e.disabled || _e.getAttribute("aria-disabled") === "true")
        gt += Ae === "next" ? 1 : -1;
      else
        return gt;
    }
  }
  const Oi = (fe, Ae) => {
    if (!K)
      return;
    Bt === "" && di(fe, "toggleInput");
    let gt = bt;
    bt === -1 ? Bt === "" && Ae === "previous" && (gt = It.length - 1) : (gt += Ae === "next" ? 1 : -1, gt < 0 && (gt = 0), gt === It.length && (gt = -1)), gt = Ui(gt, Ae), it(gt), Kt(gt);
  }, Rn = (fe) => {
    ue.current = !0, te(""), U && U(fe, "", "clear"), mt(fe, K ? [] : null, "clear");
  }, le = (fe) => (Ae) => {
    if (fe.onKeyDown && fe.onKeyDown(Ae), !Ae.defaultMuiPrevented && (bt !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(Ae.key) === -1 && (it(-1), Kt(-1)), Ae.which !== 229))
      switch (Ae.key) {
        case "Home":
          Ge && w && (Ae.preventDefault(), Ue({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Ae
          }));
          break;
        case "End":
          Ge && w && (Ae.preventDefault(), Ue({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Ae
          }));
          break;
        case "PageUp":
          Ae.preventDefault(), Ue({
            diff: -HK,
            direction: "previous",
            reason: "keyboard",
            event: Ae
          }), ri(Ae);
          break;
        case "PageDown":
          Ae.preventDefault(), Ue({
            diff: HK,
            direction: "next",
            reason: "keyboard",
            event: Ae
          }), ri(Ae);
          break;
        case "ArrowDown":
          Ae.preventDefault(), Ue({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Ae
          }), ri(Ae);
          break;
        case "ArrowUp":
          Ae.preventDefault(), Ue({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Ae
          }), ri(Ae);
          break;
        case "ArrowLeft":
          Oi(Ae, "previous");
          break;
        case "ArrowRight":
          Oi(Ae, "next");
          break;
        case "Enter":
          if ($e.current !== -1 && Ge) {
            const gt = Be[$e.current], _e = Z ? Z(gt) : !1;
            if (Ae.preventDefault(), _e)
              return;
            ui(Ae, gt, "selectOption"), n && Ze.current.setSelectionRange(Ze.current.value.length, Ze.current.value.length);
          } else
            f && Bt !== "" && ci === !1 && (K && Ae.preventDefault(), ui(Ae, Bt, "createOption", "freeSolo"));
          break;
        case "Escape":
          Ge ? (Ae.preventDefault(), Ae.stopPropagation(), di(Ae, "escape")) : a && (Bt !== "" || K && It.length > 0) && (Ae.preventDefault(), Ae.stopPropagation(), Rn(Ae));
          break;
        case "Backspace":
          if (K && !Ve && Bt === "" && It.length > 0) {
            const gt = bt === -1 ? It.length - 1 : bt, _e = It.slice();
            _e.splice(gt, 1), mt(Ae, _e, "removeOption", {
              option: It[gt]
            });
          }
          break;
        case "Delete":
          if (K && !Ve && Bt === "" && It.length > 0 && bt !== -1) {
            const gt = bt, _e = It.slice();
            _e.splice(gt, 1), mt(Ae, _e, "removeOption", {
              option: It[gt]
            });
          }
          break;
      }
  }, Ce = (fe) => {
    Ht(!0), ne && !ue.current && ri(fe);
  }, pe = (fe) => {
    if (t(xe)) {
      Ze.current.focus();
      return;
    }
    Ht(!1), Xe.current = !0, ue.current = !1, g && $e.current !== -1 && Ge ? ui(fe, Be[$e.current], "blur") : g && f && Bt !== "" ? ui(fe, Bt, "blur", "freeSolo") : l && ii(fe, It), di(fe, "blur");
  }, Ne = (fe) => {
    const Ae = fe.target.value;
    Bt !== Ae && (te(Ae), Bi(!1), U && U(fe, Ae, "input")), Ae === "" ? !d && !K && mt(fe, null, "clear") : ri(fe);
  }, Ke = (fe) => {
    const Ae = Number(fe.currentTarget.getAttribute("data-option-index"));
    $e.current !== Ae && Tt({
      event: fe,
      index: Ae,
      reason: "mouse"
    });
  }, Jt = (fe) => {
    Tt({
      event: fe,
      index: Number(fe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Ai.current = !0;
  }, Rt = (fe) => {
    const Ae = Number(fe.currentTarget.getAttribute("data-option-index"));
    ui(fe, Be[Ae], "selectOption"), Ai.current = !1;
  }, Zt = (fe) => (Ae) => {
    const gt = It.slice();
    gt.splice(fe, 1), mt(Ae, gt, "removeOption", {
      option: It[fe]
    });
  }, Et = (fe) => {
    $t ? di(fe, "toggleInput") : ri(fe);
  }, dt = (fe) => {
    fe.currentTarget.contains(fe.target) && fe.target.getAttribute("id") !== ke && fe.preventDefault();
  }, xt = (fe) => {
    fe.currentTarget.contains(fe.target) && (Ze.current.focus(), He && Xe.current && Ze.current.selectionEnd - Ze.current.selectionStart === 0 && Ze.current.select(), Xe.current = !1);
  }, Ot = (fe) => {
    !A && (Bt === "" || !$t) && Et(fe);
  };
  let si = f && Bt.length > 0;
  si = si || (K ? It.length > 0 : It !== null);
  let Li = Be;
  return V && (Li = Be.reduce((fe, Ae, gt) => {
    const _e = V(Ae);
    return fe.length > 0 && fe[fe.length - 1].group === _e ? fe[fe.length - 1].options.push(Ae) : fe.push({
      key: gt,
      index: gt,
      group: _e,
      options: [Ae]
    }), fe;
  }, [])), A && Xt && pe(), {
    getRootProps: (fe = {}) => et({
      "aria-owns": vt ? `${ke}-listbox` : null
    }, fe, {
      onKeyDown: le(fe),
      onMouseDown: dt,
      onClick: xt
    }),
    getInputLabelProps: () => ({
      id: `${ke}-label`,
      htmlFor: ke
    }),
    getInputProps: () => ({
      id: ke,
      value: Bt,
      onBlur: pe,
      onFocus: Ce,
      onChange: Ne,
      onMouseDown: Ot,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Ge ? "" : null,
      "aria-autocomplete": n ? "both" : "list",
      "aria-controls": vt ? `${ke}-listbox` : void 0,
      "aria-expanded": vt,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Ze,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: A
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Rn
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Et
    }),
    getTagProps: ({
      index: fe
    }) => et({
      key: fe,
      "data-tag-index": fe,
      tabIndex: -1
    }, !Ve && {
      onDelete: Zt(fe)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${ke}-listbox`,
      "aria-labelledby": `${ke}-label`,
      ref: zt,
      onMouseDown: (fe) => {
        fe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: fe,
      option: Ae
    }) => {
      var gt;
      const _e = (K ? It : [It]).some((kt) => kt != null && J(Ae, kt)), Qt = Z ? Z(Ae) : !1;
      return {
        key: (gt = y == null ? void 0 : y(Ae)) != null ? gt : we(Ae),
        tabIndex: -1,
        role: "option",
        id: `${ke}-option-${fe}`,
        onMouseMove: Ke,
        onClick: Rt,
        onTouchStart: Jt,
        "data-option-index": fe,
        "aria-disabled": Qt,
        "aria-selected": _e
      };
    },
    id: ke,
    inputValue: Bt,
    value: It,
    dirty: si,
    expanded: Ge && Pe,
    popupOpen: Ge,
    focused: Xt || bt !== -1,
    anchorEl: Pe,
    setAnchorEl: st,
    focusedTag: bt,
    groupedOptions: Li
  };
}
var dJ = {};
Object.defineProperty(dJ, "__esModule", {
  value: !0
});
var aj = dJ.default = void 0, pAe = fAe(De), BAe = JQ;
function sj(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
  return (sj = function(n) {
    return n ? i : t;
  })(e);
}
function fAe(e, t) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var i = sj(t);
  if (i && i.has(e))
    return i.get(e);
  var n = { __proto__: null }, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var g in e)
    if (g !== "default" && Object.prototype.hasOwnProperty.call(e, g)) {
      var o = r ? Object.getOwnPropertyDescriptor(e, g) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, g, o) : n[g] = e[g];
    }
  return n.default = e, i && i.set(e, n), n;
}
function ZAe(e) {
  return Object.keys(e).length === 0;
}
function GAe(e = null) {
  const t = pAe.useContext(BAe.ThemeContext);
  return !t || ZAe(t) ? e : t;
}
aj = dJ.default = GAe;
const yAe = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], WAe = Se(nAe, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), O2 = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n;
  const r = aj(), g = _t({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: o,
    component: l,
    components: a,
    componentsProps: I,
    container: c,
    disablePortal: d,
    keepMounted: C,
    modifiers: A,
    open: b,
    placement: m,
    popperOptions: p,
    popperRef: B,
    transition: f,
    slots: Z,
    slotProps: y
  } = g, W = tt(g, yAe), V = (n = Z == null ? void 0 : Z.root) != null ? n : a == null ? void 0 : a.Root, w = F({
    anchorEl: o,
    container: c,
    disablePortal: d,
    keepMounted: C,
    modifiers: A,
    open: b,
    placement: m,
    popperOptions: p,
    popperRef: B,
    transition: f
  }, W);
  return /* @__PURE__ */ ee(WAe, F({
    as: l,
    direction: r == null ? void 0 : r.direction,
    slots: {
      root: V
    },
    slotProps: y ?? I
  }, w, {
    ref: i
  }));
});
function SAe(e) {
  return Lt("MuiListSubheader", e);
}
Dt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const VAe = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], wAe = (e) => {
  const {
    classes: t,
    color: i,
    disableGutters: n,
    inset: r,
    disableSticky: g
  } = e, o = {
    root: ["root", i !== "default" && `color${ve(i)}`, !n && "gutters", r && "inset", !g && "sticky"]
  };
  return Mt(o, SAe, t);
}, vAe = Se("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.color !== "default" && t[`color${ve(i.color)}`], !i.disableGutters && t.gutters, i.inset && t.inset, !i.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), Ij = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: r,
    color: g = "default",
    component: o = "li",
    disableGutters: l = !1,
    disableSticky: a = !1,
    inset: I = !1
  } = n, c = tt(n, VAe), d = F({}, n, {
    color: g,
    component: o,
    disableGutters: l,
    disableSticky: a,
    inset: I
  }), C = wAe(d);
  return /* @__PURE__ */ ee(vAe, F({
    as: o,
    className: Re(C.root, r),
    ref: i,
    ownerState: d
  }, c));
});
Ij.muiSkipListHighlight = !0;
const RAe = ai(/* @__PURE__ */ ee("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function XAe(e) {
  return Lt("MuiChip", e);
}
const on = Dt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), HAe = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], kAe = (e) => {
  const {
    classes: t,
    disabled: i,
    size: n,
    color: r,
    iconColor: g,
    onDelete: o,
    clickable: l,
    variant: a
  } = e, I = {
    root: ["root", a, i && "disabled", `size${ve(n)}`, `color${ve(r)}`, l && "clickable", l && `clickableColor${ve(r)}`, o && "deletable", o && `deletableColor${ve(r)}`, `${a}${ve(r)}`],
    label: ["label", `label${ve(n)}`],
    avatar: ["avatar", `avatar${ve(n)}`, `avatarColor${ve(r)}`],
    icon: ["icon", `icon${ve(n)}`, `iconColor${ve(g)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ve(n)}`, `deleteIconColor${ve(r)}`, `deleteIcon${ve(a)}Color${ve(r)}`]
  };
  return Mt(I, XAe, t);
}, YAe = Se("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      color: n,
      iconColor: r,
      clickable: g,
      onDelete: o,
      size: l,
      variant: a
    } = i;
    return [{
      [`& .${on.avatar}`]: t.avatar
    }, {
      [`& .${on.avatar}`]: t[`avatar${ve(l)}`]
    }, {
      [`& .${on.avatar}`]: t[`avatarColor${ve(n)}`]
    }, {
      [`& .${on.icon}`]: t.icon
    }, {
      [`& .${on.icon}`]: t[`icon${ve(l)}`]
    }, {
      [`& .${on.icon}`]: t[`iconColor${ve(r)}`]
    }, {
      [`& .${on.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIcon${ve(l)}`]
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIconColor${ve(n)}`]
    }, {
      [`& .${on.deleteIcon}`]: t[`deleteIcon${ve(a)}Color${ve(n)}`]
    }, t.root, t[`size${ve(l)}`], t[`color${ve(n)}`], g && t.clickable, g && n !== "default" && t[`clickableColor${ve(n)})`], o && t.deletable, o && n !== "default" && t[`deletableColor${ve(n)}`], t[a], t[`${a}${ve(n)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return F({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${on.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${on.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : i,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${on.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${on.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${on.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${on.icon}`]: F({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && F({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : i
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${on.deleteIcon}`]: F({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Wi(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Wi(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : Wi(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${on.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${on.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => F({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${on.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${on.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => F({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${on.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${on.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${on.avatar}`]: {
    marginLeft: 4
  },
  [`& .${on.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${on.icon}`]: {
    marginLeft: 4
  },
  [`& .${on.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${on.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${on.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Wi(e.palette[t.color].main, 0.7)}`,
  [`&.${on.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${on.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Wi(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${on.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Wi(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), FAe = Se("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      size: n
    } = i;
    return [t.label, t[`label${ve(n)}`]];
  }
})(({
  ownerState: e
}) => F({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function kK(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const xAe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiChip"
  }), {
    avatar: r,
    className: g,
    clickable: o,
    color: l = "default",
    component: a,
    deleteIcon: I,
    disabled: c = !1,
    icon: d,
    label: C,
    onClick: A,
    onDelete: b,
    onKeyDown: m,
    onKeyUp: p,
    size: B = "medium",
    variant: f = "filled",
    tabIndex: Z,
    skipFocusWhenDisabled: y = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = n, W = tt(n, HAe), V = X.useRef(null), w = Zn(V, i), v = (ne) => {
    ne.stopPropagation(), b && b(ne);
  }, H = (ne) => {
    ne.currentTarget === ne.target && kK(ne) && ne.preventDefault(), m && m(ne);
  }, x = (ne) => {
    ne.currentTarget === ne.target && (b && kK(ne) ? b(ne) : ne.key === "Escape" && V.current && V.current.blur()), p && p(ne);
  }, J = o !== !1 && A ? !0 : o, K = J || b ? Xo : a || "div", M = F({}, n, {
    component: K,
    disabled: c,
    size: B,
    color: l,
    iconColor: /* @__PURE__ */ X.isValidElement(d) && d.props.color || l,
    onDelete: !!b,
    clickable: J,
    variant: f
  }), L = kAe(M), N = K === Xo ? F({
    component: a || "div",
    focusVisibleClassName: L.focusVisible
  }, b && {
    disableRipple: !0
  }) : {};
  let U = null;
  b && (U = I && /* @__PURE__ */ X.isValidElement(I) ? /* @__PURE__ */ X.cloneElement(I, {
    className: Re(I.props.className, L.deleteIcon),
    onClick: v
  }) : /* @__PURE__ */ ee(RAe, {
    className: Re(L.deleteIcon),
    onClick: v
  }));
  let O = null;
  r && /* @__PURE__ */ X.isValidElement(r) && (O = /* @__PURE__ */ X.cloneElement(r, {
    className: Re(L.avatar, r.props.className)
  }));
  let $ = null;
  return d && /* @__PURE__ */ X.isValidElement(d) && ($ = /* @__PURE__ */ X.cloneElement(d, {
    className: Re(L.icon, d.props.className)
  })), /* @__PURE__ */ Ri(YAe, F({
    as: K,
    className: Re(L.root, g),
    disabled: J && c ? !0 : void 0,
    onClick: A,
    onKeyDown: H,
    onKeyUp: x,
    ref: w,
    tabIndex: y && c ? -1 : Z,
    ownerState: M
  }, N, W, {
    children: [O || $, /* @__PURE__ */ ee(FAe, {
      className: Re(L.label),
      ownerState: M,
      children: C
    }), U]
  }));
});
function au({
  props: e,
  states: t,
  muiFormControl: i
}) {
  return t.reduce((n, r) => (n[r] = e[r], i && typeof e[r] > "u" && (n[r] = i[r]), n), {});
}
const Q2 = /* @__PURE__ */ X.createContext(void 0);
function HI() {
  return X.useContext(Q2);
}
function uJ(e) {
  return /* @__PURE__ */ ee(vse, F({}, e, {
    defaultTheme: T2,
    themeId: _C
  }));
}
function YK(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function OV(e, t = !1) {
  return e && (YK(e.value) && e.value !== "" || t && YK(e.defaultValue) && e.defaultValue !== "");
}
function DAe(e) {
  return e.startAdornment;
}
function JAe(e) {
  return Lt("MuiInputBase", e);
}
const Sl = Dt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), EAe = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], j2 = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.formControl && t.formControl, i.startAdornment && t.adornedStart, i.endAdornment && t.adornedEnd, i.error && t.error, i.size === "small" && t.sizeSmall, i.multiline && t.multiline, i.color && t[`color${ve(i.color)}`], i.fullWidth && t.fullWidth, i.hiddenLabel && t.hiddenLabel];
}, q2 = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.input, i.size === "small" && t.inputSizeSmall, i.multiline && t.inputMultiline, i.type === "search" && t.inputTypeSearch, i.startAdornment && t.inputAdornedStart, i.endAdornment && t.inputAdornedEnd, i.hiddenLabel && t.inputHiddenLabel];
}, NAe = (e) => {
  const {
    classes: t,
    color: i,
    disabled: n,
    error: r,
    endAdornment: g,
    focused: o,
    formControl: l,
    fullWidth: a,
    hiddenLabel: I,
    multiline: c,
    readOnly: d,
    size: C,
    startAdornment: A,
    type: b
  } = e, m = {
    root: ["root", `color${ve(i)}`, n && "disabled", r && "error", a && "fullWidth", o && "focused", l && "formControl", C && C !== "medium" && `size${ve(C)}`, c && "multiline", A && "adornedStart", g && "adornedEnd", I && "hiddenLabel", d && "readOnly"],
    input: ["input", n && "disabled", b === "search" && "inputTypeSearch", c && "inputMultiline", C === "small" && "inputSizeSmall", I && "inputHiddenLabel", A && "inputAdornedStart", g && "inputAdornedEnd", d && "readOnly"]
  };
  return Mt(m, JAe, t);
}, _2 = Se("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: j2
})(({
  theme: e,
  ownerState: t
}) => F({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Sl.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && F({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), $2 = Se("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: q2
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light", n = F({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: i ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), r = {
    opacity: "0 !important"
  }, g = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: i ? 0.42 : 0.5
  };
  return F({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&:-ms-input-placeholder": n,
    // IE11
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Sl.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&:-ms-input-placeholder": r,
      // IE11
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": g,
      "&:focus::-moz-placeholder": g,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": g,
      // IE11
      "&:focus::-ms-input-placeholder": g
      // Edge
    },
    [`&.${Sl.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), LAe = /* @__PURE__ */ ee(uJ, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), ev = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n;
  const r = _t({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": g,
    autoComplete: o,
    autoFocus: l,
    className: a,
    components: I = {},
    componentsProps: c = {},
    defaultValue: d,
    disabled: C,
    disableInjectingGlobalStyles: A,
    endAdornment: b,
    fullWidth: m = !1,
    id: p,
    inputComponent: B = "input",
    inputProps: f = {},
    inputRef: Z,
    maxRows: y,
    minRows: W,
    multiline: V = !1,
    name: w,
    onBlur: v,
    onChange: H,
    onClick: x,
    onFocus: J,
    onKeyDown: K,
    onKeyUp: M,
    placeholder: L,
    readOnly: N,
    renderSuffix: U,
    rows: O,
    slotProps: $ = {},
    slots: ne = {},
    startAdornment: be,
    type: Ve = "text",
    value: He
  } = r, Je = tt(r, EAe), ke = f.value != null ? f.value : He, {
    current: we
  } = X.useRef(ke != null), ue = X.useRef(), Xe = X.useCallback((Ge) => {
  }, []), Ze = Zn(ue, Z, f.ref, Xe), [xe, Pe] = X.useState(!1), st = HI(), bt = au({
    props: r,
    muiFormControl: st,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  bt.focused = st ? st.focused : xe, X.useEffect(() => {
    !st && C && xe && (Pe(!1), v && v());
  }, [st, C, xe, v]);
  const it = st && st.onFilled, Qe = st && st.onEmpty, $e = X.useCallback((Ge) => {
    OV(Ge) ? it && it() : Qe && Qe();
  }, [it, Qe]);
  no(() => {
    we && $e({
      value: ke
    });
  }, [ke, $e, we]);
  const It = (Ge) => {
    if (bt.disabled) {
      Ge.stopPropagation();
      return;
    }
    J && J(Ge), f.onFocus && f.onFocus(Ge), st && st.onFocus ? st.onFocus(Ge) : Pe(!0);
  }, jt = (Ge) => {
    v && v(Ge), f.onBlur && f.onBlur(Ge), st && st.onBlur ? st.onBlur(Ge) : Pe(!1);
  }, Bt = (Ge, ...Be) => {
    if (!we) {
      const qe = Ge.target || ue.current;
      if (qe == null)
        throw new Error(yI(1));
      $e({
        value: qe.value
      });
    }
    f.onChange && f.onChange(Ge, ...Be), H && H(Ge, ...Be);
  };
  X.useEffect(() => {
    $e(ue.current);
  }, []);
  const te = (Ge) => {
    ue.current && Ge.currentTarget === Ge.target && ue.current.focus(), x && x(Ge);
  };
  let Xt = B, Ht = f;
  V && Xt === "input" && (O ? Ht = F({
    type: void 0,
    minRows: O,
    maxRows: O
  }, Ht) : Ht = F({
    type: void 0,
    maxRows: y,
    minRows: W
  }, Ht), Xt = CAe);
  const ii = (Ge) => {
    $e(Ge.animationName === "mui-auto-fill-cancel" ? ue.current : {
      value: "x"
    });
  };
  X.useEffect(() => {
    st && st.setAdornedStart(!!be);
  }, [st, be]);
  const $t = F({}, r, {
    color: bt.color || "primary",
    disabled: bt.disabled,
    endAdornment: b,
    error: bt.error,
    focused: bt.focused,
    formControl: st,
    fullWidth: m,
    hiddenLabel: bt.hiddenLabel,
    multiline: V,
    size: bt.size,
    startAdornment: be,
    type: Ve
  }), ni = NAe($t), mi = ne.root || I.Root || _2, Bi = $.root || c.root || {}, ci = ne.input || I.Input || $2;
  return Ht = F({}, Ht, (n = $.input) != null ? n : c.input), /* @__PURE__ */ Ri(X.Fragment, {
    children: [!A && LAe, /* @__PURE__ */ Ri(mi, F({}, Bi, !mI(mi) && {
      ownerState: F({}, $t, Bi.ownerState)
    }, {
      ref: i,
      onClick: te
    }, Je, {
      className: Re(ni.root, Bi.className, a, N && "MuiInputBase-readOnly"),
      children: [be, /* @__PURE__ */ ee(Q2.Provider, {
        value: null,
        children: /* @__PURE__ */ ee(ci, F({
          ownerState: $t,
          "aria-invalid": bt.error,
          "aria-describedby": g,
          autoComplete: o,
          autoFocus: l,
          defaultValue: d,
          disabled: bt.disabled,
          id: p,
          onAnimationStart: ii,
          name: w,
          placeholder: L,
          readOnly: N,
          required: bt.required,
          rows: O,
          value: ke,
          onKeyDown: K,
          onKeyUp: M,
          type: Ve
        }, Ht, !mI(ci) && {
          as: Xt,
          ownerState: F({}, $t, Ht.ownerState)
        }, {
          ref: Ze,
          className: Re(ni.input, Ht.className, N && "MuiInputBase-readOnly"),
          onBlur: jt,
          onChange: Bt,
          onFocus: It
        }))
      }), b, U ? U(F({}, bt, {
        startAdornment: be
      })) : null]
    }))]
  });
});
function KAe(e) {
  return Lt("MuiInput", e);
}
const wd = F({}, Sl, Dt("MuiInput", ["root", "underline", "input"]));
function TAe(e) {
  return Lt("MuiOutlinedInput", e);
}
const lI = F({}, Sl, Dt("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function MAe(e) {
  return Lt("MuiFilledInput", e);
}
const Vl = F({}, Sl, Dt("MuiFilledInput", ["root", "underline", "input"])), cj = ai(/* @__PURE__ */ ee("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function PAe(e) {
  return Lt("MuiAutocomplete", e);
}
const Ti = Dt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var FK, xK;
const UAe = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], zAe = ["ref"], OAe = ou(), QAe = (e) => {
  const {
    classes: t,
    disablePortal: i,
    expanded: n,
    focused: r,
    fullWidth: g,
    hasClearIcon: o,
    hasPopupIcon: l,
    inputFocused: a,
    popupOpen: I,
    size: c
  } = e, d = {
    root: ["root", n && "expanded", r && "focused", g && "fullWidth", o && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", a && "inputFocused"],
    tag: ["tag", `tagSize${ve(c)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", I && "popupIndicatorOpen"],
    popper: ["popper", i && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return Mt(d, PAe, t);
}, jAe = Se("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e, {
      fullWidth: n,
      hasClearIcon: r,
      hasPopupIcon: g,
      inputFocused: o,
      size: l
    } = i;
    return [{
      [`& .${Ti.tag}`]: t.tag
    }, {
      [`& .${Ti.tag}`]: t[`tagSize${ve(l)}`]
    }, {
      [`& .${Ti.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Ti.input}`]: t.input
    }, {
      [`& .${Ti.input}`]: o && t.inputFocused
    }, t.root, n && t.fullWidth, g && t.hasPopupIcon, r && t.hasClearIcon];
  }
})({
  [`&.${Ti.focused} .${Ti.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Ti.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Ti.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Ti.inputRoot}`]: {
    flexWrap: "wrap",
    [`.${Ti.hasPopupIcon}&, .${Ti.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Ti.hasPopupIcon}.${Ti.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Ti.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${wd.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${wd.root}.${Sl.sizeSmall}`]: {
    [`& .${wd.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${lI.root}`]: {
    padding: 9,
    [`.${Ti.hasPopupIcon}&, .${Ti.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ti.hasPopupIcon}.${Ti.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Ti.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Ti.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${lI.root}.${Sl.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Ti.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Vl.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Ti.hasPopupIcon}&, .${Ti.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Ti.hasPopupIcon}.${Ti.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Vl.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Ti.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Vl.root}.${Sl.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Vl.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Sl.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Vl.root}.${Sl.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Ti.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Vl.root}.${Sl.hiddenLabel}.${Sl.sizeSmall}`]: {
    [`& .${Ti.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Ti.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Ti.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Ti.input}`]: {
        opacity: 1
      }
    }
  }]
}), qAe = Se("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), _Ae = Se(Ni, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), $Ae = Se(Ni, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => F({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), ebe = Se(O2, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${Ti.option}`]: t.option
    }, t.popper, i.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), tbe = Se(ul, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => F({}, e.typography.body1, {
  overflow: "auto"
})), ibe = Se("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), nbe = Se("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), rbe = Se("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Ti.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Ti.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Ti.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Ti.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Ti.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), gbe = Se(Ij, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), obe = Se("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Ti.option}`]: {
    paddingLeft: 24
  }
}), dj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o;
  const l = OAe({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: a = !1,
    autoHighlight: I = !1,
    autoSelect: c = !1,
    blurOnSelect: d = !1,
    ChipProps: C,
    className: A,
    clearIcon: b = FK || (FK = /* @__PURE__ */ ee(zQ, {
      fontSize: "small"
    })),
    clearOnBlur: m = !l.freeSolo,
    clearOnEscape: p = !1,
    clearText: B = "Clear",
    closeText: f = "Close",
    componentsProps: Z = {},
    defaultValue: y = l.multiple ? [] : null,
    disableClearable: W = !1,
    disableCloseOnSelect: V = !1,
    disabled: w = !1,
    disabledItemsFocusable: v = !1,
    disableListWrap: H = !1,
    disablePortal: x = !1,
    filterSelectedOptions: J = !1,
    forcePopupIcon: K = "auto",
    freeSolo: M = !1,
    fullWidth: L = !1,
    getLimitTagsText: N = (_e) => `+${_e}`,
    getOptionLabel: U,
    groupBy: O,
    handleHomeEndKeys: $ = !l.freeSolo,
    includeInputInList: ne = !1,
    limitTags: be = -1,
    ListboxComponent: Ve = "ul",
    ListboxProps: He,
    loading: Je = !1,
    loadingText: ke = "Loading…",
    multiple: we = !1,
    noOptionsText: ue = "No options",
    openOnFocus: Xe = !1,
    openText: Ze = "Open",
    PaperComponent: xe = ul,
    PopperComponent: Pe = O2,
    popupIcon: st = xK || (xK = /* @__PURE__ */ ee(cj, {})),
    readOnly: bt = !1,
    renderGroup: it,
    renderInput: Qe,
    renderOption: $e,
    renderTags: It,
    selectOnFocus: jt = !l.freeSolo,
    size: Bt = "medium",
    slotProps: te = {}
  } = l, Xt = tt(l, UAe), {
    getRootProps: Ht,
    getInputProps: ii,
    getInputLabelProps: $t,
    getPopupIndicatorProps: ni,
    getClearProps: mi,
    getTagProps: Bi,
    getListboxProps: ci,
    getOptionProps: Ge,
    value: Be,
    dirty: qe,
    expanded: vt,
    id: Kt,
    popupOpen: Te,
    focused: Tt,
    focusedTag: Ue,
    anchorEl: Me,
    setAnchorEl: Yt,
    inputValue: zt,
    groupedOptions: ri
  } = mAe(F({}, l, {
    componentName: "Autocomplete"
  })), di = !W && !w && qe && !bt, mt = (!M || K === !0) && K !== !1, {
    onMouseDown: Ai
  } = ii(), {
    ref: ui
  } = He ?? {}, Ui = ci(), {
    ref: Oi
  } = Ui, Rn = tt(Ui, zAe), le = Zn(Oi, ui), pe = U || ((_e) => {
    var Qt;
    return (Qt = _e.label) != null ? Qt : _e;
  }), Ne = F({}, l, {
    disablePortal: x,
    expanded: vt,
    focused: Tt,
    fullWidth: L,
    getOptionLabel: pe,
    hasClearIcon: di,
    hasPopupIcon: mt,
    inputFocused: Ue === -1,
    popupOpen: Te,
    size: Bt
  }), Ke = QAe(Ne);
  let Jt;
  if (we && Be.length > 0) {
    const _e = (Qt) => F({
      className: Ke.tag,
      disabled: w
    }, Bi(Qt));
    It ? Jt = It(Be, _e, Ne) : Jt = Be.map((Qt, kt) => /* @__PURE__ */ ee(xAe, F({
      label: pe(Qt),
      size: Bt
    }, _e({
      index: kt
    }), C)));
  }
  if (be > -1 && Array.isArray(Jt)) {
    const _e = Jt.length - be;
    !Tt && _e > 0 && (Jt = Jt.splice(0, be), Jt.push(/* @__PURE__ */ ee("span", {
      className: Ke.tag,
      children: N(_e)
    }, Jt.length)));
  }
  const Zt = it || ((_e) => /* @__PURE__ */ Ri("li", {
    children: [/* @__PURE__ */ ee(gbe, {
      className: Ke.groupLabel,
      ownerState: Ne,
      component: "div",
      children: _e.group
    }), /* @__PURE__ */ ee(obe, {
      className: Ke.groupUl,
      ownerState: Ne,
      children: _e.children
    })]
  }, _e.key)), dt = $e || ((_e, Qt) => /* @__PURE__ */ PC("li", F({}, _e, {
    key: _e.key
  }), pe(Qt))), xt = (_e, Qt) => {
    const kt = Ge({
      option: _e,
      index: Qt
    });
    return dt(F({}, kt, {
      className: Ke.option
    }), _e, {
      selected: kt["aria-selected"],
      index: Qt,
      inputValue: zt
    }, Ne);
  }, Ot = (n = te.clearIndicator) != null ? n : Z.clearIndicator, si = (r = te.paper) != null ? r : Z.paper, Li = (g = te.popper) != null ? g : Z.popper, fe = (o = te.popupIndicator) != null ? o : Z.popupIndicator, Ae = (_e) => /* @__PURE__ */ ee(ebe, F({
    as: Pe,
    disablePortal: x,
    style: {
      width: Me ? Me.clientWidth : null
    },
    ownerState: Ne,
    role: "presentation",
    anchorEl: Me,
    open: Te
  }, Li, {
    className: Re(Ke.popper, Li == null ? void 0 : Li.className),
    children: /* @__PURE__ */ ee(tbe, F({
      ownerState: Ne,
      as: xe
    }, si, {
      className: Re(Ke.paper, si == null ? void 0 : si.className),
      children: _e
    }))
  }));
  let gt = null;
  return ri.length > 0 ? gt = Ae(/* @__PURE__ */ ee(rbe, F({
    as: Ve,
    className: Ke.listbox,
    ownerState: Ne
  }, Rn, He, {
    ref: le,
    children: ri.map((_e, Qt) => O ? Zt({
      key: _e.key,
      group: _e.group,
      children: _e.options.map((kt, ti) => xt(kt, _e.index + ti))
    }) : xt(_e, Qt))
  }))) : Je && ri.length === 0 ? gt = Ae(/* @__PURE__ */ ee(ibe, {
    className: Ke.loading,
    ownerState: Ne,
    children: ke
  })) : ri.length === 0 && !M && !Je && (gt = Ae(/* @__PURE__ */ ee(nbe, {
    className: Ke.noOptions,
    ownerState: Ne,
    role: "presentation",
    onMouseDown: (_e) => {
      _e.preventDefault();
    },
    children: ue
  }))), /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ ee(jAe, F({
      ref: i,
      className: Re(Ke.root, A),
      ownerState: Ne
    }, Ht(Xt), {
      children: Qe({
        id: Kt,
        disabled: w,
        fullWidth: !0,
        size: Bt === "small" ? "small" : void 0,
        InputLabelProps: $t(),
        InputProps: F({
          ref: Yt,
          className: Ke.inputRoot,
          startAdornment: Jt,
          onClick: (_e) => {
            _e.target === _e.currentTarget && Ai(_e);
          }
        }, (di || mt) && {
          endAdornment: /* @__PURE__ */ Ri(qAe, {
            className: Ke.endAdornment,
            ownerState: Ne,
            children: [di ? /* @__PURE__ */ ee(_Ae, F({}, mi(), {
              "aria-label": B,
              title: B,
              ownerState: Ne
            }, Ot, {
              className: Re(Ke.clearIndicator, Ot == null ? void 0 : Ot.className),
              children: b
            })) : null, mt ? /* @__PURE__ */ ee($Ae, F({}, ni(), {
              disabled: w,
              "aria-label": Te ? f : Ze,
              title: Te ? f : Ze,
              ownerState: Ne
            }, fe, {
              className: Re(Ke.popupIndicator, fe == null ? void 0 : fe.className),
              children: st
            })) : null]
          })
        }),
        inputProps: F({
          className: Ke.input,
          disabled: w,
          readOnly: bt
        }, ii())
      })
    })), Me ? gt : null]
  });
}), lbe = ai(/* @__PURE__ */ ee("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function abe(e) {
  return Lt("MuiAvatar", e);
}
Dt("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const sbe = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"], Ibe = ou(), cbe = (e) => {
  const {
    classes: t,
    variant: i,
    colorDefault: n
  } = e;
  return Mt({
    root: ["root", i, n && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, abe, t);
}, dbe = Se("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], i.colorDefault && t.colorDefault];
  }
})(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: F({
      color: (e.vars || e).palette.background.default
    }, e.vars ? {
      backgroundColor: e.vars.palette.Avatar.defaultBg
    } : F({
      backgroundColor: e.palette.grey[400]
    }, e.applyStyles("dark", {
      backgroundColor: e.palette.grey[600]
    })))
  }]
})), ube = Se("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Cbe = Se(lbe, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function Abe({
  crossOrigin: e,
  referrerPolicy: t,
  src: i,
  srcSet: n
}) {
  const [r, g] = X.useState(!1);
  return X.useEffect(() => {
    if (!i && !n)
      return;
    g(!1);
    let o = !0;
    const l = new Image();
    return l.onload = () => {
      o && g("loaded");
    }, l.onerror = () => {
      o && g("error");
    }, l.crossOrigin = e, l.referrerPolicy = t, l.src = i, n && (l.srcset = n), () => {
      o = !1;
    };
  }, [e, t, i, n]), r;
}
const bbe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = Ibe({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: r,
    children: g,
    className: o,
    component: l = "div",
    slots: a = {},
    slotProps: I = {},
    imgProps: c,
    sizes: d,
    src: C,
    srcSet: A,
    variant: b = "circular"
  } = n, m = tt(n, sbe);
  let p = null;
  const B = Abe(F({}, c, {
    src: C,
    srcSet: A
  })), f = C || A, Z = f && B !== "error", y = F({}, n, {
    colorDefault: !Z,
    component: l,
    variant: b
  }), W = cbe(y), [V, w] = PV("img", {
    className: W.img,
    elementType: ube,
    externalForwardedProps: {
      slots: a,
      slotProps: {
        img: F({}, c, I.img)
      }
    },
    additionalProps: {
      alt: r,
      src: C,
      srcSet: A,
      sizes: d
    },
    ownerState: y
  });
  return Z ? p = /* @__PURE__ */ ee(V, F({}, w)) : g || g === 0 ? p = g : f && r ? p = r[0] : p = /* @__PURE__ */ ee(Cbe, {
    ownerState: y,
    className: W.fallback
  }), /* @__PURE__ */ ee(dbe, F({
    as: l,
    ownerState: y,
    className: Re(W.root, o),
    ref: i
  }, m, {
    children: p
  }));
}), hbe = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], mbe = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, tv = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = ql(), r = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: g,
    appear: o = !0,
    children: l,
    easing: a,
    in: I,
    onEnter: c,
    onEntered: d,
    onEntering: C,
    onExit: A,
    onExited: b,
    onExiting: m,
    style: p,
    timeout: B = r,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: f = Qa
  } = t, Z = tt(t, hbe), y = X.useRef(null), W = Zn(y, l.ref, i), V = (L) => (N) => {
    if (L) {
      const U = y.current;
      N === void 0 ? L(U) : L(U, N);
    }
  }, w = V(C), v = V((L, N) => {
    tJ(L);
    const U = _d({
      style: p,
      timeout: B,
      easing: a
    }, {
      mode: "enter"
    });
    L.style.webkitTransition = n.transitions.create("opacity", U), L.style.transition = n.transitions.create("opacity", U), c && c(L, N);
  }), H = V(d), x = V(m), J = V((L) => {
    const N = _d({
      style: p,
      timeout: B,
      easing: a
    }, {
      mode: "exit"
    });
    L.style.webkitTransition = n.transitions.create("opacity", N), L.style.transition = n.transitions.create("opacity", N), A && A(L);
  }), K = V(b);
  return /* @__PURE__ */ ee(f, F({
    appear: o,
    in: I,
    nodeRef: y,
    onEnter: v,
    onEntered: H,
    onEntering: w,
    onExit: J,
    onExited: K,
    onExiting: x,
    addEndListener: (L) => {
      g && g(y.current, L);
    },
    timeout: B
  }, Z, {
    children: (L, N) => /* @__PURE__ */ X.cloneElement(l, F({
      style: F({
        opacity: 0,
        visibility: L === "exited" && !I ? "hidden" : void 0
      }, mbe[L], p, l.props.style),
      ref: W
    }, N))
  }));
});
function pbe(e) {
  return Lt("MuiBackdrop", e);
}
Dt("MuiBackdrop", ["root", "invisible"]);
const Bbe = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], fbe = (e) => {
  const {
    classes: t,
    invisible: i
  } = e;
  return Mt({
    root: ["root", i && "invisible"]
  }, pbe, t);
}, Zbe = Se("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => F({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), iv = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g;
  const o = _t({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: l,
    className: a,
    component: I = "div",
    components: c = {},
    componentsProps: d = {},
    invisible: C = !1,
    open: A,
    slotProps: b = {},
    slots: m = {},
    TransitionComponent: p = tv,
    transitionDuration: B
  } = o, f = tt(o, Bbe), Z = F({}, o, {
    component: I,
    invisible: C
  }), y = fbe(Z), W = (n = b.root) != null ? n : d.root;
  return /* @__PURE__ */ ee(p, F({
    in: A,
    timeout: B
  }, f, {
    children: /* @__PURE__ */ ee(Zbe, F({
      "aria-hidden": !0
    }, W, {
      as: (r = (g = m.root) != null ? g : c.Root) != null ? r : I,
      className: Re(y.root, a, W == null ? void 0 : W.className),
      ownerState: F({}, Z, W == null ? void 0 : W.ownerState),
      classes: y,
      ref: i,
      children: l
    }))
  }));
}), Gbe = Dt("MuiBox", ["root"]), ybe = Gbe, Wbe = Sm(), ht = uQ({
  themeId: _C,
  defaultTheme: Wbe,
  defaultClassName: ybe.root,
  generateClassName: v2.generate
}), Sbe = ai(/* @__PURE__ */ ee("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), Vbe = ["slots", "slotProps"], wbe = Se(Xo)(({
  theme: e
}) => F({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`
}, e.palette.mode === "light" ? {
  backgroundColor: e.palette.grey[100],
  color: e.palette.grey[700]
} : {
  backgroundColor: e.palette.grey[700],
  color: e.palette.grey[100]
}, {
  borderRadius: 2,
  "&:hover, &:focus": F({}, e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[200]
  } : {
    backgroundColor: e.palette.grey[600]
  }),
  "&:active": F({
    boxShadow: e.shadows[0]
  }, e.palette.mode === "light" ? {
    backgroundColor: QL(e.palette.grey[200], 0.12)
  } : {
    backgroundColor: QL(e.palette.grey[600], 0.12)
  })
})), vbe = Se(Sbe)({
  width: 24,
  height: 16
});
function Rbe(e) {
  const {
    slots: t = {},
    slotProps: i = {}
  } = e, n = tt(e, Vbe), r = e;
  return /* @__PURE__ */ ee("li", {
    children: /* @__PURE__ */ ee(wbe, F({
      focusRipple: !0
    }, n, {
      ownerState: r,
      children: /* @__PURE__ */ ee(vbe, F({
        as: t.CollapsedIcon,
        ownerState: r
      }, i.collapsedIcon))
    }))
  });
}
function Xbe(e) {
  return Lt("MuiBreadcrumbs", e);
}
const Hbe = Dt("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), kbe = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"], Ybe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, Xbe, t);
}, Fbe = Se(Ct, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${Hbe.li}`]: t.li
  }, t.root]
})({}), xbe = Se("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), Dbe = Se("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function Jbe(e, t, i, n) {
  return e.reduce((r, g, o) => (o < e.length - 1 ? r = r.concat(g, /* @__PURE__ */ ee(Dbe, {
    "aria-hidden": !0,
    className: t,
    ownerState: n,
    children: i
  }, `separator-${o}`)) : r.push(g), r), []);
}
const uj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: r,
    className: g,
    component: o = "nav",
    slots: l = {},
    slotProps: a = {},
    expandText: I = "Show path",
    itemsAfterCollapse: c = 1,
    itemsBeforeCollapse: d = 1,
    maxItems: C = 8,
    separator: A = "/"
  } = n, b = tt(n, kbe), [m, p] = X.useState(!1), B = F({}, n, {
    component: o,
    expanded: m,
    expandText: I,
    itemsAfterCollapse: c,
    itemsBeforeCollapse: d,
    maxItems: C,
    separator: A
  }), f = Ybe(B), Z = Fr({
    elementType: l.CollapsedIcon,
    externalSlotProps: a.collapsedIcon,
    ownerState: B
  }), y = X.useRef(null), W = (w) => {
    const v = () => {
      p(!0);
      const H = y.current.querySelector("a[href],button,[tabindex]");
      H && H.focus();
    };
    return d + c >= w.length ? w : [...w.slice(0, d), /* @__PURE__ */ ee(Rbe, {
      "aria-label": I,
      slots: {
        CollapsedIcon: l.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: Z
      },
      onClick: v
    }, "ellipsis"), ...w.slice(w.length - c, w.length)];
  }, V = X.Children.toArray(r).filter((w) => /* @__PURE__ */ X.isValidElement(w)).map((w, v) => /* @__PURE__ */ ee("li", {
    className: f.li,
    children: w
  }, `child-${v}`));
  return /* @__PURE__ */ ee(Fbe, F({
    ref: i,
    component: o,
    color: "text.secondary",
    className: Re(f.root, g),
    ownerState: B
  }, b, {
    children: /* @__PURE__ */ ee(xbe, {
      className: f.ol,
      ref: y,
      ownerState: B,
      children: Jbe(m || C && V.length <= C ? V : W(V), f.separator, A, B)
    })
  }));
});
function Ebe(e) {
  return Lt("MuiButton", e);
}
const Nbe = Dt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), EW = Nbe, Cj = /* @__PURE__ */ X.createContext({}), Aj = /* @__PURE__ */ X.createContext(void 0), Lbe = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], Kbe = (e) => {
  const {
    color: t,
    disableElevation: i,
    fullWidth: n,
    size: r,
    variant: g,
    classes: o
  } = e, l = {
    root: ["root", g, `${g}${ve(t)}`, `size${ve(r)}`, `${g}Size${ve(r)}`, `color${ve(t)}`, i && "disableElevation", n && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${ve(r)}`],
    endIcon: ["icon", "endIcon", `iconSize${ve(r)}`]
  }, a = Mt(l, Ebe, o);
  return F({}, o, a);
}, bj = (e) => F({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), Tbe = Se(Xo, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`${i.variant}${ve(i.color)}`], t[`size${ve(i.size)}`], t[`${i.variant}Size${ve(i.size)}`], i.color === "inherit" && t.colorInherit, i.disableElevation && t.disableElevation, i.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i, n;
  const r = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], g = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return F({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": F({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : g,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": F({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${EW.focusVisible}`]: F({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${EW.disabled}`]: F({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${Wi(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (i = (n = e.palette).getContrastText) == null ? void 0 : i.call(n, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : r,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${EW.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${EW.disabled}`]: {
    boxShadow: "none"
  }
}), Mbe = Se("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.startIcon, t[`iconSize${ve(i.size)}`]];
  }
})(({
  ownerState: e
}) => F({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, bj(e))), Pbe = Se("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.endIcon, t[`iconSize${ve(i.size)}`]];
  }
})(({
  ownerState: e
}) => F({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, bj(e))), fn = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = X.useContext(Cj), r = X.useContext(Aj), g = N2(n, t), o = _t({
    props: g,
    name: "MuiButton"
  }), {
    children: l,
    color: a = "primary",
    component: I = "button",
    className: c,
    disabled: d = !1,
    disableElevation: C = !1,
    disableFocusRipple: A = !1,
    endIcon: b,
    focusVisibleClassName: m,
    fullWidth: p = !1,
    size: B = "medium",
    startIcon: f,
    type: Z,
    variant: y = "text"
  } = o, W = tt(o, Lbe), V = F({}, o, {
    color: a,
    component: I,
    disabled: d,
    disableElevation: C,
    disableFocusRipple: A,
    fullWidth: p,
    size: B,
    type: Z,
    variant: y
  }), w = Kbe(V), v = f && /* @__PURE__ */ ee(Mbe, {
    className: w.startIcon,
    ownerState: V,
    children: f
  }), H = b && /* @__PURE__ */ ee(Pbe, {
    className: w.endIcon,
    ownerState: V,
    children: b
  }), x = r || "";
  return /* @__PURE__ */ Ri(Tbe, F({
    ownerState: V,
    className: Re(n.className, w.root, c, x),
    component: I,
    disabled: d,
    focusRipple: !A,
    focusVisibleClassName: Re(w.focusVisible, m),
    ref: i,
    type: Z
  }, W, {
    classes: w,
    children: [v, l, H]
  }));
});
function Ube(e) {
  return Lt("MuiButtonGroup", e);
}
const Ng = Dt("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "vertical", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), zbe = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"], Obe = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [{
    [`& .${Ng.grouped}`]: t.grouped
  }, {
    [`& .${Ng.grouped}`]: t[`grouped${ve(i.orientation)}`]
  }, {
    [`& .${Ng.grouped}`]: t[`grouped${ve(i.variant)}`]
  }, {
    [`& .${Ng.grouped}`]: t[`grouped${ve(i.variant)}${ve(i.orientation)}`]
  }, {
    [`& .${Ng.grouped}`]: t[`grouped${ve(i.variant)}${ve(i.color)}`]
  }, {
    [`& .${Ng.firstButton}`]: t.firstButton
  }, {
    [`& .${Ng.lastButton}`]: t.lastButton
  }, {
    [`& .${Ng.middleButton}`]: t.middleButton
  }, t.root, t[i.variant], i.disableElevation === !0 && t.disableElevation, i.fullWidth && t.fullWidth, i.orientation === "vertical" && t.vertical];
}, Qbe = (e) => {
  const {
    classes: t,
    color: i,
    disabled: n,
    disableElevation: r,
    fullWidth: g,
    orientation: o,
    variant: l
  } = e, a = {
    root: ["root", l, o === "vertical" && "vertical", g && "fullWidth", r && "disableElevation"],
    grouped: ["grouped", `grouped${ve(o)}`, `grouped${ve(l)}`, `grouped${ve(l)}${ve(o)}`, `grouped${ve(l)}${ve(i)}`, n && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Mt(a, Ube, t);
}, jbe = Se("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: Obe
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius
}, t.variant === "contained" && {
  boxShadow: (e.vars || e).shadows[2]
}, t.disableElevation && {
  boxShadow: "none"
}, t.fullWidth && {
  width: "100%"
}, t.orientation === "vertical" && {
  flexDirection: "column"
}, {
  [`& .${Ng.grouped}`]: F({
    minWidth: 40,
    "&:hover": F({}, t.variant === "contained" && {
      boxShadow: "none"
    })
  }, t.variant === "contained" && {
    boxShadow: "none"
  }),
  [`& .${Ng.firstButton},& .${Ng.middleButton}`]: F({}, t.orientation === "horizontal" && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, t.orientation === "vertical" && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, t.variant === "text" && t.orientation === "horizontal" && {
    borderRight: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Ng.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.orientation === "vertical" && {
    borderBottom: e.vars ? `1px solid rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
    [`&.${Ng.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "text" && t.color !== "inherit" && {
    borderColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : Wi(e.palette[t.color].main, 0.5)
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    borderRightColor: "transparent"
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    borderBottomColor: "transparent"
  }, t.variant === "contained" && t.orientation === "horizontal" && {
    borderRight: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Ng.disabled}`]: {
      borderRight: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.orientation === "vertical" && {
    borderBottom: `1px solid ${(e.vars || e).palette.grey[400]}`,
    [`&.${Ng.disabled}`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.action.disabled}`
    }
  }, t.variant === "contained" && t.color !== "inherit" && {
    borderColor: (e.vars || e).palette[t.color].dark
  }, {
    "&:hover": F({}, t.variant === "outlined" && t.orientation === "horizontal" && {
      borderRightColor: "currentColor"
    }, t.variant === "outlined" && t.orientation === "vertical" && {
      borderBottomColor: "currentColor"
    })
  }),
  [`& .${Ng.lastButton},& .${Ng.middleButton}`]: F({}, t.orientation === "horizontal" && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, t.orientation === "vertical" && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, t.variant === "outlined" && t.orientation === "horizontal" && {
    marginLeft: -1
  }, t.variant === "outlined" && t.orientation === "vertical" && {
    marginTop: -1
  })
})), qbe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiButtonGroup"
  }), {
    children: r,
    className: g,
    color: o = "primary",
    component: l = "div",
    disabled: a = !1,
    disableElevation: I = !1,
    disableFocusRipple: c = !1,
    disableRipple: d = !1,
    fullWidth: C = !1,
    orientation: A = "horizontal",
    size: b = "medium",
    variant: m = "outlined"
  } = n, p = tt(n, zbe), B = F({}, n, {
    color: o,
    component: l,
    disabled: a,
    disableElevation: I,
    disableFocusRipple: c,
    disableRipple: d,
    fullWidth: C,
    orientation: A,
    size: b,
    variant: m
  }), f = Qbe(B), Z = X.useMemo(() => ({
    className: f.grouped,
    color: o,
    disabled: a,
    disableElevation: I,
    disableFocusRipple: c,
    disableRipple: d,
    fullWidth: C,
    size: b,
    variant: m
  }), [o, a, I, c, d, C, b, m, f.grouped]), y = yQ(r), W = y.length, V = (w) => {
    const v = w === 0, H = w === W - 1;
    return v && H ? "" : v ? f.firstButton : H ? f.lastButton : f.middleButton;
  };
  return /* @__PURE__ */ ee(jbe, F({
    as: l,
    role: "group",
    className: Re(f.root, g),
    ref: i,
    ownerState: B
  }, p, {
    children: /* @__PURE__ */ ee(Cj.Provider, {
      value: Z,
      children: y.map((w, v) => /* @__PURE__ */ ee(Aj.Provider, {
        value: V(v),
        children: w
      }, v))
    })
  }));
});
function _be(e) {
  return Lt("PrivateSwitchBase", e);
}
Dt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const $be = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], ehe = (e) => {
  const {
    classes: t,
    checked: i,
    disabled: n,
    edge: r
  } = e, g = {
    root: ["root", i && "checked", n && "disabled", r && `edge${ve(r)}`],
    input: ["input"]
  };
  return Mt(g, _be, t);
}, the = Se(Xo)(({
  ownerState: e
}) => F({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), ihe = Se("input", {
  shouldForwardProp: Wg
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), CJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    autoFocus: n,
    checked: r,
    checkedIcon: g,
    className: o,
    defaultChecked: l,
    disabled: a,
    disableFocusRipple: I = !1,
    edge: c = !1,
    icon: d,
    id: C,
    inputProps: A,
    inputRef: b,
    name: m,
    onBlur: p,
    onChange: B,
    onFocus: f,
    readOnly: Z,
    required: y = !1,
    tabIndex: W,
    type: V,
    value: w
  } = t, v = tt(t, $be), [H, x] = Xs({
    controlled: r,
    default: !!l,
    name: "SwitchBase",
    state: "checked"
  }), J = HI(), K = (ne) => {
    f && f(ne), J && J.onFocus && J.onFocus(ne);
  }, M = (ne) => {
    p && p(ne), J && J.onBlur && J.onBlur(ne);
  }, L = (ne) => {
    if (ne.nativeEvent.defaultPrevented)
      return;
    const be = ne.target.checked;
    x(be), B && B(ne, be);
  };
  let N = a;
  J && typeof N > "u" && (N = J.disabled);
  const U = V === "checkbox" || V === "radio", O = F({}, t, {
    checked: H,
    disabled: N,
    disableFocusRipple: I,
    edge: c
  }), $ = ehe(O);
  return /* @__PURE__ */ Ri(the, F({
    component: "span",
    className: Re($.root, o),
    centerRipple: !0,
    focusRipple: !I,
    disabled: N,
    tabIndex: null,
    role: void 0,
    onFocus: K,
    onBlur: M,
    ownerState: O,
    ref: i
  }, v, {
    children: [/* @__PURE__ */ ee(ihe, F({
      autoFocus: n,
      checked: r,
      defaultChecked: l,
      className: $.input,
      disabled: N,
      id: U ? C : void 0,
      name: m,
      onChange: L,
      readOnly: Z,
      ref: b,
      required: y,
      ownerState: O,
      tabIndex: W,
      type: V
    }, V === "checkbox" && w === void 0 ? {} : {
      value: w
    }, A)), H ? g : d]
  }));
}), nhe = ai(/* @__PURE__ */ ee("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), rhe = ai(/* @__PURE__ */ ee("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), ghe = ai(/* @__PURE__ */ ee("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function ohe(e) {
  return Lt("MuiCheckbox", e);
}
const oY = Dt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), lhe = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], ahe = (e) => {
  const {
    classes: t,
    indeterminate: i,
    color: n,
    size: r
  } = e, g = {
    root: ["root", i && "indeterminate", `color${ve(n)}`, `size${ve(r)}`]
  }, o = Mt(g, ohe, t);
  return F({}, t, o);
}, she = Se(CJ, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.indeterminate && t.indeterminate, t[`size${ve(i.size)}`], i.color !== "default" && t[`color${ve(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${oY.checked}, &.${oY.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${oY.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), Ihe = /* @__PURE__ */ ee(rhe, {}), che = /* @__PURE__ */ ee(nhe, {}), dhe = /* @__PURE__ */ ee(ghe, {}), fZ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r;
  const g = _t({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: o = Ihe,
    color: l = "primary",
    icon: a = che,
    indeterminate: I = !1,
    indeterminateIcon: c = dhe,
    inputProps: d,
    size: C = "medium",
    className: A
  } = g, b = tt(g, lhe), m = I ? c : a, p = I ? c : o, B = F({}, g, {
    color: l,
    indeterminate: I,
    size: C
  }), f = ahe(B);
  return /* @__PURE__ */ ee(she, F({
    type: "checkbox",
    inputProps: F({
      "data-indeterminate": I
    }, d),
    icon: /* @__PURE__ */ X.cloneElement(m, {
      fontSize: (n = m.props.fontSize) != null ? n : C
    }),
    checkedIcon: /* @__PURE__ */ X.cloneElement(p, {
      fontSize: (r = p.props.fontSize) != null ? r : C
    }),
    ownerState: B,
    ref: i,
    className: Re(f.root, A)
  }, b, {
    classes: f
  }));
});
function uhe(e) {
  return Lt("MuiCircularProgress", e);
}
Dt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const Che = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let nv = (e) => e, DK, JK, EK, NK;
const Cd = 44, Ahe = Ds(DK || (DK = nv`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)), bhe = Ds(JK || (JK = nv`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)), hhe = (e) => {
  const {
    classes: t,
    variant: i,
    color: n,
    disableShrink: r
  } = e, g = {
    root: ["root", i, `color${ve(n)}`],
    svg: ["svg"],
    circle: ["circle", `circle${ve(i)}`, r && "circleDisableShrink"]
  };
  return Mt(g, uhe, t);
}, mhe = Se("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`color${ve(i.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  display: "inline-block"
}, e.variant === "determinate" && {
  transition: t.transitions.create("transform")
}, e.color !== "inherit" && {
  color: (t.vars || t).palette[e.color].main
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && Od(EK || (EK = nv`
      animation: ${0} 1.4s linear infinite;
    `), Ahe)), phe = Se("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), Bhe = Se("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.circle, t[`circle${ve(i.variant)}`], i.disableShrink && t.circleDisableShrink];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  stroke: "currentColor"
}, e.variant === "determinate" && {
  transition: t.transitions.create("stroke-dashoffset")
}, e.variant === "indeterminate" && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: "80px, 200px",
  strokeDashoffset: 0
  // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState: e
}) => e.variant === "indeterminate" && !e.disableShrink && Od(NK || (NK = nv`
      animation: ${0} 1.4s ease-in-out infinite;
    `), bhe)), hj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: r,
    color: g = "primary",
    disableShrink: o = !1,
    size: l = 40,
    style: a,
    thickness: I = 3.6,
    value: c = 0,
    variant: d = "indeterminate"
  } = n, C = tt(n, Che), A = F({}, n, {
    color: g,
    disableShrink: o,
    size: l,
    thickness: I,
    value: c,
    variant: d
  }), b = hhe(A), m = {}, p = {}, B = {};
  if (d === "determinate") {
    const f = 2 * Math.PI * ((Cd - I) / 2);
    m.strokeDasharray = f.toFixed(3), B["aria-valuenow"] = Math.round(c), m.strokeDashoffset = `${((100 - c) / 100 * f).toFixed(3)}px`, p.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ ee(mhe, F({
    className: Re(b.root, r),
    style: F({
      width: l,
      height: l
    }, p, a),
    ownerState: A,
    ref: i,
    role: "progressbar"
  }, B, C, {
    children: /* @__PURE__ */ ee(phe, {
      className: b.svg,
      ownerState: A,
      viewBox: `${Cd / 2} ${Cd / 2} ${Cd} ${Cd}`,
      children: /* @__PURE__ */ ee(Bhe, {
        className: b.circle,
        style: m,
        ownerState: A,
        cx: Cd,
        cy: Cd,
        r: (Cd - I) / 2,
        fill: "none",
        strokeWidth: I
      })
    })
  }));
}), fhe = (e, t) => F({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, t && !e.vars && {
  colorScheme: e.palette.mode
}), Zhe = (e) => F({
  color: (e.vars || e).palette.text.primary
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
});
function Ghe(e) {
  return Lt("MuiModal", e);
}
Dt("MuiModal", ["root", "hidden", "backdrop"]);
const yhe = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], Whe = (e) => {
  const {
    open: t,
    exited: i,
    classes: n
  } = e;
  return Mt({
    root: ["root", !t && i && "hidden"],
    backdrop: ["backdrop"]
  }, Ghe, n);
}, She = Se("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.open && i.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), Vhe = Se(iv, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), mj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o, l, a;
  const I = _t({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: c = Vhe,
    BackdropProps: d,
    className: C,
    closeAfterTransition: A = !1,
    children: b,
    container: m,
    component: p,
    components: B = {},
    componentsProps: f = {},
    disableAutoFocus: Z = !1,
    disableEnforceFocus: y = !1,
    disableEscapeKeyDown: W = !1,
    disablePortal: V = !1,
    disableRestoreFocus: w = !1,
    disableScrollLock: v = !1,
    hideBackdrop: H = !1,
    keepMounted: x = !1,
    onBackdropClick: J,
    open: K,
    slotProps: M,
    slots: L
    // eslint-disable-next-line react/prop-types
  } = I, N = tt(I, yhe), U = F({}, I, {
    closeAfterTransition: A,
    disableAutoFocus: Z,
    disableEnforceFocus: y,
    disableEscapeKeyDown: W,
    disablePortal: V,
    disableRestoreFocus: w,
    disableScrollLock: v,
    hideBackdrop: H,
    keepMounted: x
  }), {
    getRootProps: O,
    getBackdropProps: $,
    getTransitionProps: ne,
    portalRef: be,
    isTopModal: Ve,
    exited: He,
    hasTransition: Je
  } = Kue(F({}, U, {
    rootRef: i
  })), ke = F({}, U, {
    exited: He
  }), we = Whe(ke), ue = {};
  if (b.props.tabIndex === void 0 && (ue.tabIndex = "-1"), Je) {
    const {
      onEnter: it,
      onExited: Qe
    } = ne();
    ue.onEnter = it, ue.onExited = Qe;
  }
  const Xe = (n = (r = L == null ? void 0 : L.root) != null ? r : B.Root) != null ? n : She, Ze = (g = (o = L == null ? void 0 : L.backdrop) != null ? o : B.Backdrop) != null ? g : c, xe = (l = M == null ? void 0 : M.root) != null ? l : f.root, Pe = (a = M == null ? void 0 : M.backdrop) != null ? a : f.backdrop, st = Fr({
    elementType: Xe,
    externalSlotProps: xe,
    externalForwardedProps: N,
    getSlotProps: O,
    additionalProps: {
      ref: i,
      as: p
    },
    ownerState: ke,
    className: Re(C, xe == null ? void 0 : xe.className, we == null ? void 0 : we.root, !ke.open && ke.exited && (we == null ? void 0 : we.hidden))
  }), bt = Fr({
    elementType: Ze,
    externalSlotProps: Pe,
    additionalProps: d,
    getSlotProps: (it) => $(F({}, it, {
      onClick: (Qe) => {
        J && J(Qe), it != null && it.onClick && it.onClick(Qe);
      }
    })),
    className: Re(Pe == null ? void 0 : Pe.className, d == null ? void 0 : d.className, we == null ? void 0 : we.backdrop),
    ownerState: ke
  });
  return !x && !K && (!Je || He) ? null : /* @__PURE__ */ ee(jQ, {
    ref: be,
    container: m,
    disablePortal: V,
    children: /* @__PURE__ */ Ri(Xe, F({}, st, {
      children: [!H && c ? /* @__PURE__ */ ee(Ze, F({}, bt)) : null, /* @__PURE__ */ ee(Hue, {
        disableEnforceFocus: y,
        disableAutoFocus: Z,
        disableRestoreFocus: w,
        isEnabled: Ve,
        open: K,
        children: /* @__PURE__ */ X.cloneElement(b, ue)
      })]
    }))
  });
});
function whe(e) {
  return Lt("MuiDialog", e);
}
const lY = Dt("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), pj = /* @__PURE__ */ X.createContext({}), vhe = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], Rhe = Se(iv, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), Xhe = (e) => {
  const {
    classes: t,
    scroll: i,
    maxWidth: n,
    fullWidth: r,
    fullScreen: g
  } = e, o = {
    root: ["root"],
    container: ["container", `scroll${ve(i)}`],
    paper: ["paper", `paperScroll${ve(i)}`, `paperWidth${ve(String(n))}`, r && "paperFullWidth", g && "paperFullScreen"]
  };
  return Mt(o, whe, t);
}, Hhe = Se(mj, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), khe = Se("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.container, t[`scroll${ve(i.scroll)}`]];
  }
})(({
  ownerState: e
}) => F({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), Yhe = Se(ul, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.paper, t[`scrollPaper${ve(i.scroll)}`], t[`paperWidth${ve(String(i.maxWidth))}`], i.fullWidth && t.paperFullWidth, i.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${lY.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${lY.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${lY.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), wf = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDialog"
  }), r = ql(), g = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    "aria-describedby": o,
    "aria-labelledby": l,
    BackdropComponent: a,
    BackdropProps: I,
    children: c,
    className: d,
    disableEscapeKeyDown: C = !1,
    fullScreen: A = !1,
    fullWidth: b = !1,
    maxWidth: m = "sm",
    onBackdropClick: p,
    onClick: B,
    onClose: f,
    open: Z,
    PaperComponent: y = ul,
    PaperProps: W = {},
    scroll: V = "paper",
    TransitionComponent: w = tv,
    transitionDuration: v = g,
    TransitionProps: H
  } = n, x = tt(n, vhe), J = F({}, n, {
    disableEscapeKeyDown: C,
    fullScreen: A,
    fullWidth: b,
    maxWidth: m,
    scroll: V
  }), K = Xhe(J), M = X.useRef(), L = ($) => {
    M.current = $.target === $.currentTarget;
  }, N = ($) => {
    B && B($), M.current && (M.current = null, p && p($), f && f($, "backdropClick"));
  }, U = uA(l), O = X.useMemo(() => ({
    titleId: U
  }), [U]);
  return /* @__PURE__ */ ee(Hhe, F({
    className: Re(K.root, d),
    closeAfterTransition: !0,
    components: {
      Backdrop: Rhe
    },
    componentsProps: {
      backdrop: F({
        transitionDuration: v,
        as: a
      }, I)
    },
    disableEscapeKeyDown: C,
    onClose: f,
    open: Z,
    ref: i,
    onClick: N,
    ownerState: J
  }, x, {
    children: /* @__PURE__ */ ee(w, F({
      appear: !0,
      in: Z,
      timeout: v,
      role: "presentation"
    }, H, {
      children: /* @__PURE__ */ ee(khe, {
        className: Re(K.container),
        onMouseDown: L,
        ownerState: J,
        children: /* @__PURE__ */ ee(Yhe, F({
          as: y,
          elevation: 24,
          role: "dialog",
          "aria-describedby": o,
          "aria-labelledby": U
        }, W, {
          className: Re(K.paper, W.className),
          ownerState: J,
          children: /* @__PURE__ */ ee(pj.Provider, {
            value: O,
            children: c
          })
        }))
      })
    }))
  }));
});
function Fhe(e) {
  return Lt("MuiDialogActions", e);
}
Dt("MuiDialogActions", ["root", "spacing"]);
const xhe = ["className", "disableSpacing"], Dhe = (e) => {
  const {
    classes: t,
    disableSpacing: i
  } = e;
  return Mt({
    root: ["root", !i && "spacing"]
  }, Fhe, t);
}, Jhe = Se("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => F({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), vf = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: r,
    disableSpacing: g = !1
  } = n, o = tt(n, xhe), l = F({}, n, {
    disableSpacing: g
  }), a = Dhe(l);
  return /* @__PURE__ */ ee(Jhe, F({
    className: Re(a.root, r),
    ownerState: l,
    ref: i
  }, o));
});
function Ehe(e) {
  return Lt("MuiDialogContent", e);
}
Dt("MuiDialogContent", ["root", "dividers"]);
function Nhe(e) {
  return Lt("MuiDialogTitle", e);
}
const Lhe = Dt("MuiDialogTitle", ["root"]), Khe = ["className", "dividers"], The = (e) => {
  const {
    classes: t,
    dividers: i
  } = e;
  return Mt({
    root: ["root", i && "dividers"]
  }, Ehe, t);
}, Mhe = Se("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${Lhe.root} + &`]: {
    paddingTop: 0
  }
})), Rf = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: r,
    dividers: g = !1
  } = n, o = tt(n, Khe), l = F({}, n, {
    dividers: g
  }), a = The(l);
  return /* @__PURE__ */ ee(Mhe, F({
    className: Re(a.root, r),
    ownerState: l,
    ref: i
  }, o));
});
function Phe(e) {
  return Lt("MuiDialogContentText", e);
}
Dt("MuiDialogContentText", ["root"]);
const Uhe = ["children", "className"], zhe = (e) => {
  const {
    classes: t
  } = e, n = Mt({
    root: ["root"]
  }, Phe, t);
  return F({}, t, n);
}, Ohe = Se(Ct, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), BI = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDialogContentText"
  }), {
    className: r
  } = n, g = tt(n, Uhe), o = zhe(g);
  return /* @__PURE__ */ ee(Ohe, F({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: i,
    ownerState: g,
    className: Re(o.root, r)
  }, n, {
    classes: o
  }));
}), Qhe = ["className", "id"], jhe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, Nhe, t);
}, qhe = Se(Ct, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), Xf = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: r,
    id: g
  } = n, o = tt(n, Qhe), l = n, a = jhe(l), {
    titleId: I = g
  } = X.useContext(pj);
  return /* @__PURE__ */ ee(qhe, F({
    component: "h2",
    className: Re(a.root, r),
    ownerState: l,
    ref: i,
    variant: "h6",
    id: g ?? I
  }, o));
});
function _he(e) {
  return Lt("MuiDivider", e);
}
const $he = Dt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), LK = $he, eme = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], tme = (e) => {
  const {
    absolute: t,
    children: i,
    classes: n,
    flexItem: r,
    light: g,
    orientation: o,
    textAlign: l,
    variant: a
  } = e;
  return Mt({
    root: ["root", t && "absolute", a, g && "light", o === "vertical" && "vertical", r && "flexItem", i && "withChildren", i && o === "vertical" && "withChildrenVertical", l === "right" && o !== "vertical" && "textAlignRight", l === "left" && o !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", o === "vertical" && "wrapperVertical"]
  }, _he, n);
}, ime = Se("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.absolute && t.absolute, t[i.variant], i.light && t.light, i.orientation === "vertical" && t.vertical, i.flexItem && t.flexItem, i.children && t.withChildren, i.children && i.orientation === "vertical" && t.withChildrenVertical, i.textAlign === "right" && i.orientation !== "vertical" && t.textAlignRight, i.textAlign === "left" && i.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Wi(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => F({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => F({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  theme: e,
  ownerState: t
}) => F({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`
  }
}), ({
  ownerState: e
}) => F({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), nme = Se("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.wrapper, i.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), Bj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: r = !1,
    children: g,
    className: o,
    component: l = g ? "div" : "hr",
    flexItem: a = !1,
    light: I = !1,
    orientation: c = "horizontal",
    role: d = l !== "hr" ? "separator" : void 0,
    textAlign: C = "center",
    variant: A = "fullWidth"
  } = n, b = tt(n, eme), m = F({}, n, {
    absolute: r,
    component: l,
    flexItem: a,
    light: I,
    orientation: c,
    role: d,
    textAlign: C,
    variant: A
  }), p = tme(m);
  return /* @__PURE__ */ ee(ime, F({
    as: l,
    className: Re(p.root, o),
    role: d,
    ref: i,
    ownerState: m
  }, b, {
    children: g ? /* @__PURE__ */ ee(nme, {
      className: p.wrapper,
      ownerState: m,
      children: g
    }) : null
  }));
});
Bj.muiSkipListHighlight = !0;
const SI = Bj, rme = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function gme(e, t, i) {
  const n = t.getBoundingClientRect(), r = i && i.getBoundingClientRect(), g = Ja(t);
  let o;
  if (t.fakeTransform)
    o = t.fakeTransform;
  else {
    const I = g.getComputedStyle(t);
    o = I.getPropertyValue("-webkit-transform") || I.getPropertyValue("transform");
  }
  let l = 0, a = 0;
  if (o && o !== "none" && typeof o == "string") {
    const I = o.split("(")[1].split(")")[0].split(",");
    l = parseInt(I[4], 10), a = parseInt(I[5], 10);
  }
  return e === "left" ? r ? `translateX(${r.right + l - n.left}px)` : `translateX(${g.innerWidth + l - n.left}px)` : e === "right" ? r ? `translateX(-${n.right - r.left - l}px)` : `translateX(-${n.left + n.width - l}px)` : e === "up" ? r ? `translateY(${r.bottom + a - n.top}px)` : `translateY(${g.innerHeight + a - n.top}px)` : r ? `translateY(-${n.top - r.top + n.height - a}px)` : `translateY(-${n.top + n.height - a}px)`;
}
function ome(e) {
  return typeof e == "function" ? e() : e;
}
function NW(e, t, i) {
  const n = ome(i), r = gme(e, t, n);
  r && (t.style.webkitTransform = r, t.style.transform = r);
}
const fj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = ql(), r = {
    enter: n.transitions.easing.easeOut,
    exit: n.transitions.easing.sharp
  }, g = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: o,
    appear: l = !0,
    children: a,
    container: I,
    direction: c = "down",
    easing: d = r,
    in: C,
    onEnter: A,
    onEntered: b,
    onEntering: m,
    onExit: p,
    onExited: B,
    onExiting: f,
    style: Z,
    timeout: y = g,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: W = Qa
  } = t, V = tt(t, rme), w = X.useRef(null), v = Zn(a.ref, w, i), H = ($) => (ne) => {
    $ && (ne === void 0 ? $(w.current) : $(w.current, ne));
  }, x = H(($, ne) => {
    NW(c, $, I), tJ($), A && A($, ne);
  }), J = H(($, ne) => {
    const be = _d({
      timeout: y,
      style: Z,
      easing: d
    }, {
      mode: "enter"
    });
    $.style.webkitTransition = n.transitions.create("-webkit-transform", F({}, be)), $.style.transition = n.transitions.create("transform", F({}, be)), $.style.webkitTransform = "none", $.style.transform = "none", m && m($, ne);
  }), K = H(b), M = H(f), L = H(($) => {
    const ne = _d({
      timeout: y,
      style: Z,
      easing: d
    }, {
      mode: "exit"
    });
    $.style.webkitTransition = n.transitions.create("-webkit-transform", ne), $.style.transition = n.transitions.create("transform", ne), NW(c, $, I), p && p($);
  }), N = H(($) => {
    $.style.webkitTransition = "", $.style.transition = "", B && B($);
  }), U = ($) => {
    o && o(w.current, $);
  }, O = X.useCallback(() => {
    w.current && NW(c, w.current, I);
  }, [c, I]);
  return X.useEffect(() => {
    if (C || c === "down" || c === "right")
      return;
    const $ = ym(() => {
      w.current && NW(c, w.current, I);
    }), ne = Ja(w.current);
    return ne.addEventListener("resize", $), () => {
      $.clear(), ne.removeEventListener("resize", $);
    };
  }, [c, C, I]), X.useEffect(() => {
    C || O();
  }, [C, O]), /* @__PURE__ */ ee(W, F({
    nodeRef: w,
    onEnter: x,
    onEntered: K,
    onEntering: J,
    onExit: L,
    onExited: N,
    onExiting: M,
    addEndListener: U,
    appear: l,
    in: C,
    timeout: y
  }, V, {
    children: ($, ne) => /* @__PURE__ */ X.cloneElement(a, F({
      ref: v,
      style: F({
        visibility: $ === "exited" && !C ? "hidden" : void 0
      }, Z, a.props.style)
    }, ne))
  }));
}), lme = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], ame = (e) => {
  const {
    classes: t,
    disableUnderline: i
  } = e, r = Mt({
    root: ["root", !i && "underline"],
    input: ["input"]
  }, MAe, t);
  return F({}, t, r);
}, sme = Se(_2, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [...j2(e, t), !i.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var i;
  const n = e.palette.mode === "light", r = n ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", g = n ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = n ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", l = n ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return F({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : g,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : g
      }
    },
    [`&.${Vl.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : g
    },
    [`&.${Vl.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : l
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(i = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : i.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Vl.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Vl.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : r}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Vl.disabled}, .${Vl.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${Vl.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && F({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), Ime = Se($2, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: q2
})(({
  theme: e,
  ownerState: t
}) => F({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), AJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o;
  const l = _t({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: a = {},
    componentsProps: I,
    fullWidth: c = !1,
    // declare here to prevent spreading to DOM
    inputComponent: d = "input",
    multiline: C = !1,
    slotProps: A,
    slots: b = {},
    type: m = "text"
  } = l, p = tt(l, lme), B = F({}, l, {
    fullWidth: c,
    inputComponent: d,
    multiline: C,
    type: m
  }), f = ame(l), Z = {
    root: {
      ownerState: B
    },
    input: {
      ownerState: B
    }
  }, y = A ?? I ? pg(Z, A ?? I) : Z, W = (n = (r = b.root) != null ? r : a.Root) != null ? n : sme, V = (g = (o = b.input) != null ? o : a.Input) != null ? g : Ime;
  return /* @__PURE__ */ ee(ev, F({
    slots: {
      root: W,
      input: V
    },
    componentsProps: y,
    fullWidth: c,
    inputComponent: d,
    multiline: C,
    ref: i,
    type: m
  }, p, {
    classes: f
  }));
});
AJ.muiName = "Input";
function cme(e) {
  return Lt("MuiFormControl", e);
}
Dt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const dme = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], ume = (e) => {
  const {
    classes: t,
    margin: i,
    fullWidth: n
  } = e, r = {
    root: ["root", i !== "none" && `margin${ve(i)}`, n && "fullWidth"]
  };
  return Mt(r, cme, t);
}, Cme = Se("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => F({}, t.root, t[`margin${ve(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => F({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), ja = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiFormControl"
  }), {
    children: r,
    className: g,
    color: o = "primary",
    component: l = "div",
    disabled: a = !1,
    error: I = !1,
    focused: c,
    fullWidth: d = !1,
    hiddenLabel: C = !1,
    margin: A = "none",
    required: b = !1,
    size: m = "medium",
    variant: p = "outlined"
  } = n, B = tt(n, dme), f = F({}, n, {
    color: o,
    component: l,
    disabled: a,
    error: I,
    fullWidth: d,
    hiddenLabel: C,
    margin: A,
    required: b,
    size: m,
    variant: p
  }), Z = ume(f), [y, W] = X.useState(() => {
    let M = !1;
    return r && X.Children.forEach(r, (L) => {
      if (!MB(L, ["Input", "Select"]))
        return;
      const N = MB(L, ["Select"]) ? L.props.input : L;
      N && DAe(N.props) && (M = !0);
    }), M;
  }), [V, w] = X.useState(() => {
    let M = !1;
    return r && X.Children.forEach(r, (L) => {
      MB(L, ["Input", "Select"]) && (OV(L.props, !0) || OV(L.props.inputProps, !0)) && (M = !0);
    }), M;
  }), [v, H] = X.useState(!1);
  a && v && H(!1);
  const x = c !== void 0 && !a ? c : v;
  let J;
  const K = X.useMemo(() => ({
    adornedStart: y,
    setAdornedStart: W,
    color: o,
    disabled: a,
    error: I,
    filled: V,
    focused: x,
    fullWidth: d,
    hiddenLabel: C,
    size: m,
    onBlur: () => {
      H(!1);
    },
    onEmpty: () => {
      w(!1);
    },
    onFilled: () => {
      w(!0);
    },
    onFocus: () => {
      H(!0);
    },
    registerEffect: J,
    required: b,
    variant: p
  }), [y, o, a, I, V, x, d, C, J, b, m, p]);
  return /* @__PURE__ */ ee(Q2.Provider, {
    value: K,
    children: /* @__PURE__ */ ee(Cme, F({
      as: l,
      ownerState: f,
      className: Re(Z.root, g),
      ref: i
    }, B, {
      children: r
    }))
  });
}), Ame = wQ({
  createStyledComponent: Se("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => _t({
    props: e,
    name: "MuiStack"
  })
}), pi = Ame;
function bme(e) {
  return Lt("MuiFormControlLabel", e);
}
const WB = Dt("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), hme = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], mme = (e) => {
  const {
    classes: t,
    disabled: i,
    labelPlacement: n,
    error: r,
    required: g
  } = e, o = {
    root: ["root", i && "disabled", `labelPlacement${ve(n)}`, r && "error", g && "required"],
    label: ["label", i && "disabled"],
    asterisk: ["asterisk", r && "error"]
  };
  return Mt(o, bme, t);
}, pme = Se("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${WB.label}`]: t.label
    }, t.root, t[`labelPlacement${ve(i.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${WB.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${WB.label}`]: {
    [`&.${WB.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), Bme = Se("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${WB.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), rv = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r;
  const g = _t({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: o,
    componentsProps: l = {},
    control: a,
    disabled: I,
    disableTypography: c,
    label: d,
    labelPlacement: C = "end",
    required: A,
    slotProps: b = {}
  } = g, m = tt(g, hme), p = HI(), B = (n = I ?? a.props.disabled) != null ? n : p == null ? void 0 : p.disabled, f = A ?? a.props.required, Z = {
    disabled: B,
    required: f
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((H) => {
    typeof a.props[H] > "u" && typeof g[H] < "u" && (Z[H] = g[H]);
  });
  const y = au({
    props: g,
    muiFormControl: p,
    states: ["error"]
  }), W = F({}, g, {
    disabled: B,
    labelPlacement: C,
    required: f,
    error: y.error
  }), V = mme(W), w = (r = b.typography) != null ? r : l.typography;
  let v = d;
  return v != null && v.type !== Ct && !c && (v = /* @__PURE__ */ ee(Ct, F({
    component: "span"
  }, w, {
    className: Re(V.label, w == null ? void 0 : w.className),
    children: v
  }))), /* @__PURE__ */ Ri(pme, F({
    className: Re(V.root, o),
    ownerState: W,
    ref: i
  }, m, {
    children: [/* @__PURE__ */ X.cloneElement(a, Z), f ? /* @__PURE__ */ Ri(pi, {
      display: "block",
      children: [v, /* @__PURE__ */ Ri(Bme, {
        ownerState: W,
        "aria-hidden": !0,
        className: V.asterisk,
        children: [" ", "*"]
      })]
    }) : v]
  }));
});
function fme(e) {
  return Lt("MuiFormGroup", e);
}
Dt("MuiFormGroup", ["root", "row", "error"]);
const Zme = ["className", "row"], Gme = (e) => {
  const {
    classes: t,
    row: i,
    error: n
  } = e;
  return Mt({
    root: ["root", i && "row", n && "error"]
  }, fme, t);
}, yme = Se("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.row && t.row];
  }
})(({
  ownerState: e
}) => F({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), Wme = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: r,
    row: g = !1
  } = n, o = tt(n, Zme), l = HI(), a = au({
    props: n,
    muiFormControl: l,
    states: ["error"]
  }), I = F({}, n, {
    row: g,
    error: a.error
  }), c = Gme(I);
  return /* @__PURE__ */ ee(yme, F({
    className: Re(c.root, r),
    ownerState: I,
    ref: i
  }, o));
});
function Sme(e) {
  return Lt("MuiFormHelperText", e);
}
const KK = Dt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var TK;
const Vme = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], wme = (e) => {
  const {
    classes: t,
    contained: i,
    size: n,
    disabled: r,
    error: g,
    filled: o,
    focused: l,
    required: a
  } = e, I = {
    root: ["root", r && "disabled", g && "error", n && `size${ve(n)}`, i && "contained", l && "focused", o && "filled", a && "required"]
  };
  return Mt(I, Sme, t);
}, vme = Se("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.size && t[`size${ve(i.size)}`], i.contained && t.contained, i.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${KK.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${KK.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), Hf = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: r,
    className: g,
    component: o = "p"
  } = n, l = tt(n, Vme), a = HI(), I = au({
    props: n,
    muiFormControl: a,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), c = F({}, n, {
    component: o,
    contained: I.variant === "filled" || I.variant === "outlined",
    variant: I.variant,
    size: I.size,
    disabled: I.disabled,
    error: I.error,
    filled: I.filled,
    focused: I.focused,
    required: I.required
  }), d = wme(c);
  return /* @__PURE__ */ ee(vme, F({
    as: o,
    ownerState: c,
    className: Re(d.root, g),
    ref: i
  }, l, {
    children: r === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      TK || (TK = /* @__PURE__ */ ee("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : r
  }));
});
function Rme(e) {
  return Lt("MuiFormLabel", e);
}
const QB = Dt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Xme = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], Hme = (e) => {
  const {
    classes: t,
    color: i,
    focused: n,
    disabled: r,
    error: g,
    filled: o,
    required: l
  } = e, a = {
    root: ["root", `color${ve(i)}`, r && "disabled", g && "error", o && "filled", n && "focused", l && "required"],
    asterisk: ["asterisk", g && "error"]
  };
  return Mt(a, Rme, t);
}, kme = Se("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => F({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => F({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${QB.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${QB.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${QB.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Yme = Se("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${QB.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Fme = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: r,
    className: g,
    component: o = "label"
  } = n, l = tt(n, Xme), a = HI(), I = au({
    props: n,
    muiFormControl: a,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), c = F({}, n, {
    color: I.color || "primary",
    component: o,
    disabled: I.disabled,
    error: I.error,
    filled: I.filled,
    focused: I.focused,
    required: I.required
  }), d = Hme(c);
  return /* @__PURE__ */ Ri(kme, F({
    as: o,
    ownerState: c,
    className: Re(d.root, g),
    ref: i
  }, l, {
    children: [r, I.required && /* @__PURE__ */ Ri(Yme, {
      ownerState: c,
      "aria-hidden": !0,
      className: d.asterisk,
      children: [" ", "*"]
    })]
  }));
}), xme = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function yx(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Dme = {
  entering: {
    opacity: 1,
    transform: yx(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, aY = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), QV = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    addEndListener: n,
    appear: r = !0,
    children: g,
    easing: o,
    in: l,
    onEnter: a,
    onEntered: I,
    onEntering: c,
    onExit: d,
    onExited: C,
    onExiting: A,
    style: b,
    timeout: m = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: p = Qa
  } = t, B = tt(t, xme), f = DC(), Z = X.useRef(), y = ql(), W = X.useRef(null), V = Zn(W, g.ref, i), w = (N) => (U) => {
    if (N) {
      const O = W.current;
      U === void 0 ? N(O) : N(O, U);
    }
  }, v = w(c), H = w((N, U) => {
    tJ(N);
    const {
      duration: O,
      delay: $,
      easing: ne
    } = _d({
      style: b,
      timeout: m,
      easing: o
    }, {
      mode: "enter"
    });
    let be;
    m === "auto" ? (be = y.transitions.getAutoHeightDuration(N.clientHeight), Z.current = be) : be = O, N.style.transition = [y.transitions.create("opacity", {
      duration: be,
      delay: $
    }), y.transitions.create("transform", {
      duration: aY ? be : be * 0.666,
      delay: $,
      easing: ne
    })].join(","), a && a(N, U);
  }), x = w(I), J = w(A), K = w((N) => {
    const {
      duration: U,
      delay: O,
      easing: $
    } = _d({
      style: b,
      timeout: m,
      easing: o
    }, {
      mode: "exit"
    });
    let ne;
    m === "auto" ? (ne = y.transitions.getAutoHeightDuration(N.clientHeight), Z.current = ne) : ne = U, N.style.transition = [y.transitions.create("opacity", {
      duration: ne,
      delay: O
    }), y.transitions.create("transform", {
      duration: aY ? ne : ne * 0.666,
      delay: aY ? O : O || ne * 0.333,
      easing: $
    })].join(","), N.style.opacity = 0, N.style.transform = yx(0.75), d && d(N);
  }), M = w(C);
  return /* @__PURE__ */ ee(p, F({
    appear: r,
    in: l,
    nodeRef: W,
    onEnter: H,
    onEntered: x,
    onEntering: v,
    onExit: K,
    onExited: M,
    onExiting: J,
    addEndListener: (N) => {
      m === "auto" && f.start(Z.current || 0, N), n && n(W.current, N);
    },
    timeout: m === "auto" ? null : m
  }, B, {
    children: (N, U) => /* @__PURE__ */ X.cloneElement(g, F({
      style: F({
        opacity: 0,
        transform: yx(0.75),
        visibility: N === "exited" && !l ? "hidden" : void 0
      }, Dme[N], b, g.props.style),
      ref: V
    }, U))
  }));
});
QV.muiSupportAuto = !0;
const Jme = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], Eme = (e) => {
  const {
    classes: t,
    disableUnderline: i
  } = e, r = Mt({
    root: ["root", !i && "underline"],
    input: ["input"]
  }, KAe, t);
  return F({}, t, r);
}, Nme = Se(_2, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [...j2(e, t), !i.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), F({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${wd.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${wd.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${n}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${wd.disabled}, .${wd.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${n}`
      }
    },
    [`&.${wd.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), Lme = Se($2, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: q2
})({}), gv = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o;
  const l = _t({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: a,
    components: I = {},
    componentsProps: c,
    fullWidth: d = !1,
    inputComponent: C = "input",
    multiline: A = !1,
    slotProps: b,
    slots: m = {},
    type: p = "text"
  } = l, B = tt(l, Jme), f = Eme(l), y = {
    root: {
      ownerState: {
        disableUnderline: a
      }
    }
  }, W = b ?? c ? pg(b ?? c, y) : y, V = (n = (r = m.root) != null ? r : I.Root) != null ? n : Nme, w = (g = (o = m.input) != null ? o : I.Input) != null ? g : Lme;
  return /* @__PURE__ */ ee(ev, F({
    slots: {
      root: V,
      input: w
    },
    slotProps: W,
    fullWidth: d,
    inputComponent: C,
    multiline: A,
    ref: i,
    type: p
  }, B, {
    classes: f
  }));
});
gv.muiName = "Input";
function Kme(e) {
  return Lt("MuiInputAdornment", e);
}
const MK = Dt("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var PK;
const Tme = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], Mme = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, t[`position${ve(i.position)}`], i.disablePointerEvents === !0 && t.disablePointerEvents, t[i.variant]];
}, Pme = (e) => {
  const {
    classes: t,
    disablePointerEvents: i,
    hiddenLabel: n,
    position: r,
    size: g,
    variant: o
  } = e, l = {
    root: ["root", i && "disablePointerEvents", r && `position${ve(r)}`, o, n && "hiddenLabel", g && `size${ve(g)}`]
  };
  return Mt(l, Kme, t);
}, Ume = Se("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: Mme
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${MK.positionStart}&:not(.${MK.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), Uh = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: r,
    className: g,
    component: o = "div",
    disablePointerEvents: l = !1,
    disableTypography: a = !1,
    position: I,
    variant: c
  } = n, d = tt(n, Tme), C = HI() || {};
  let A = c;
  c && C.variant, C && !A && (A = C.variant);
  const b = F({}, n, {
    hiddenLabel: C.hiddenLabel,
    size: C.size,
    disablePointerEvents: l,
    position: I,
    variant: A
  }), m = Pme(b);
  return /* @__PURE__ */ ee(Q2.Provider, {
    value: null,
    children: /* @__PURE__ */ ee(Ume, F({
      as: o,
      ownerState: b,
      className: Re(m.root, g),
      ref: i
    }, d, {
      children: typeof r == "string" && !a ? /* @__PURE__ */ ee(Ct, {
        color: "text.secondary",
        children: r
      }) : /* @__PURE__ */ Ri(X.Fragment, {
        children: [I === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          PK || (PK = /* @__PURE__ */ ee("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, r]
      })
    }))
  });
});
function zme(e) {
  return Lt("MuiInputLabel", e);
}
Dt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const Ome = ["disableAnimation", "margin", "shrink", "variant", "className"], Qme = (e) => {
  const {
    classes: t,
    formControl: i,
    size: n,
    shrink: r,
    disableAnimation: g,
    variant: o,
    required: l
  } = e, a = {
    root: ["root", i && "formControl", !g && "animated", r && "shrink", n && n !== "normal" && `size${ve(n)}`, o],
    asterisk: [l && "asterisk"]
  }, I = Mt(a, zme, t);
  return F({}, t, I);
}, jme = Se(Fme, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${QB.asterisk}`]: t.asterisk
    }, t.root, i.formControl && t.formControl, i.size === "small" && t.sizeSmall, i.shrink && t.shrink, !i.disableAnimation && t.animated, i.focused && t.focused, t[i.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && F({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && F({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && F({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), Zj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: r = !1,
    shrink: g,
    className: o
  } = n, l = tt(n, Ome), a = HI();
  let I = g;
  typeof I > "u" && a && (I = a.filled || a.focused || a.adornedStart);
  const c = au({
    props: n,
    muiFormControl: a,
    states: ["size", "variant", "required", "focused"]
  }), d = F({}, n, {
    disableAnimation: r,
    formControl: a,
    shrink: I,
    size: c.size,
    variant: c.variant,
    required: c.required,
    focused: c.focused
  }), C = Qme(d);
  return /* @__PURE__ */ ee(jme, F({
    "data-shrink": I,
    ownerState: d,
    ref: i,
    className: Re(C.root, o)
  }, l, {
    classes: C
  }));
});
function qme(e) {
  return Lt("MuiLinearProgress", e);
}
Dt("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const _me = ["className", "color", "value", "valueBuffer", "variant"];
let wm = (e) => e, UK, zK, OK, QK, jK, qK;
const Wx = 4, $me = Ds(UK || (UK = wm`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), epe = Ds(zK || (zK = wm`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), tpe = Ds(OK || (OK = wm`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), ipe = (e) => {
  const {
    classes: t,
    variant: i,
    color: n
  } = e, r = {
    root: ["root", `color${ve(n)}`, i],
    dashed: ["dashed", `dashedColor${ve(n)}`],
    bar1: ["bar", `barColor${ve(n)}`, (i === "indeterminate" || i === "query") && "bar1Indeterminate", i === "determinate" && "bar1Determinate", i === "buffer" && "bar1Buffer"],
    bar2: ["bar", i !== "buffer" && `barColor${ve(n)}`, i === "buffer" && `color${ve(n)}`, (i === "indeterminate" || i === "query") && "bar2Indeterminate", i === "buffer" && "bar2Buffer"]
  };
  return Mt(r, qme, t);
}, bJ = (e, t) => t === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? qd(e.palette[t].main, 0.62) : jd(e.palette[t].main, 0.5), npe = Se("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`color${ve(i.color)}`], t[i.variant]];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: bJ(t, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), rpe = Se("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.dashed, t[`dashedColor${ve(i.color)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const i = bJ(t, e.color);
  return F({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${i} 0%, ${i} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, Od(QK || (QK = wm`
    animation: ${0} 3s infinite linear;
  `), tpe)), gpe = Se("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.bar, t[`barColor${ve(i.color)}`], (i.variant === "indeterminate" || i.variant === "query") && t.bar1Indeterminate, i.variant === "determinate" && t.bar1Determinate, i.variant === "buffer" && t.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${Wx}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${Wx}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Od(jK || (jK = wm`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $me)), ope = Se("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.bar, t[`barColor${ve(i.color)}`], (i.variant === "indeterminate" || i.variant === "query") && t.bar2Indeterminate, i.variant === "buffer" && t.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (t.vars || t).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: bJ(t, e.color),
  transition: `transform .${Wx}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && Od(qK || (qK = wm`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), epe)), Gj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: r,
    color: g = "primary",
    value: o,
    valueBuffer: l,
    variant: a = "indeterminate"
  } = n, I = tt(n, _me), c = F({}, n, {
    color: g,
    variant: a
  }), d = ipe(c), C = CA(), A = {}, b = {
    bar1: {},
    bar2: {}
  };
  if ((a === "determinate" || a === "buffer") && o !== void 0) {
    A["aria-valuenow"] = Math.round(o), A["aria-valuemin"] = 0, A["aria-valuemax"] = 100;
    let m = o - 100;
    C && (m = -m), b.bar1.transform = `translateX(${m}%)`;
  }
  if (a === "buffer" && l !== void 0) {
    let m = (l || 0) - 100;
    C && (m = -m), b.bar2.transform = `translateX(${m}%)`;
  }
  return /* @__PURE__ */ Ri(npe, F({
    className: Re(d.root, r),
    ownerState: c,
    role: "progressbar"
  }, A, {
    ref: i
  }, I, {
    children: [a === "buffer" ? /* @__PURE__ */ ee(rpe, {
      className: d.dashed,
      ownerState: c
    }) : null, /* @__PURE__ */ ee(gpe, {
      className: d.bar1,
      ownerState: c,
      style: b.bar1
    }), a === "determinate" ? null : /* @__PURE__ */ ee(ope, {
      className: d.bar2,
      ownerState: c,
      style: b.bar2
    })]
  }));
});
function lpe(e) {
  return Lt("MuiLink", e);
}
const ape = Dt("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), spe = ape, yj = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Ipe = (e) => yj[e] || e, cpe = ({
  theme: e,
  ownerState: t
}) => {
  const i = Ipe(t.color), n = em(e, `palette.${i}`, !1) || t.color, r = em(e, `palette.${i}Channel`);
  return "vars" in e && r ? `rgba(${r} / 0.4)` : Wi(n, 0.4);
}, dpe = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], upe = (e) => {
  const {
    classes: t,
    component: i,
    focusVisible: n,
    underline: r
  } = e, g = {
    root: ["root", `underline${ve(r)}`, i === "button" && "button", n && "focusVisible"]
  };
  return Mt(g, lpe, t);
}, Cpe = Se(Ct, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`underline${ve(i.underline)}`], i.component === "button" && t.button];
  }
})(({
  theme: e,
  ownerState: t
}) => F({}, t.underline === "none" && {
  textDecoration: "none"
}, t.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, t.underline === "always" && F({
  textDecoration: "underline"
}, t.color !== "inherit" && {
  textDecorationColor: cpe({
    theme: e,
    ownerState: t
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), t.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${spe.focusVisible}`]: {
    outline: "auto"
  }
})), Ape = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiLink"
  }), {
    className: r,
    color: g = "primary",
    component: o = "a",
    onBlur: l,
    onFocus: a,
    TypographyClasses: I,
    underline: c = "always",
    variant: d = "inherit",
    sx: C
  } = n, A = tt(n, dpe), {
    isFocusVisibleRef: b,
    onBlur: m,
    onFocus: p,
    ref: B
  } = hZ(), [f, Z] = X.useState(!1), y = Zn(i, B), W = (H) => {
    m(H), b.current === !1 && Z(!1), l && l(H);
  }, V = (H) => {
    p(H), b.current === !0 && Z(!0), a && a(H);
  }, w = F({}, n, {
    color: g,
    component: o,
    focusVisible: f,
    underline: c,
    variant: d
  }), v = upe(w);
  return /* @__PURE__ */ ee(Cpe, F({
    color: g,
    className: Re(v.root, r),
    classes: I,
    component: o,
    onBlur: W,
    onFocus: V,
    ref: y,
    ownerState: w,
    variant: d,
    sx: [...Object.keys(yj).includes(g) ? [] : [{
      color: g
    }], ...Array.isArray(C) ? C : [C]]
  }, A));
}), Xd = Ape, Hs = /* @__PURE__ */ X.createContext({});
function bpe(e) {
  return Lt("MuiList", e);
}
Dt("MuiList", ["root", "padding", "dense", "subheader"]);
const hpe = ["children", "className", "component", "dense", "disablePadding", "subheader"], mpe = (e) => {
  const {
    classes: t,
    disablePadding: i,
    dense: n,
    subheader: r
  } = e;
  return Mt({
    root: ["root", !i && "padding", n && "dense", r && "subheader"]
  }, bpe, t);
}, ppe = Se("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disablePadding && t.padding, i.dense && t.dense, i.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => F({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), jV = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiList"
  }), {
    children: r,
    className: g,
    component: o = "ul",
    dense: l = !1,
    disablePadding: a = !1,
    subheader: I
  } = n, c = tt(n, hpe), d = X.useMemo(() => ({
    dense: l
  }), [l]), C = F({}, n, {
    component: o,
    dense: l,
    disablePadding: a
  }), A = mpe(C);
  return /* @__PURE__ */ ee(Hs.Provider, {
    value: d,
    children: /* @__PURE__ */ Ri(ppe, F({
      as: o,
      className: Re(A.root, g),
      ref: i,
      ownerState: C
    }, c, {
      children: [I, r]
    }))
  });
});
function Bpe(e) {
  return Lt("MuiListItem", e);
}
const vh = Dt("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]);
function fpe(e) {
  return Lt("MuiListItemButton", e);
}
const Rh = Dt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), Zpe = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], Gpe = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.alignItems === "flex-start" && t.alignItemsFlexStart, i.divider && t.divider, !i.disableGutters && t.gutters];
}, ype = (e) => {
  const {
    alignItems: t,
    classes: i,
    dense: n,
    disabled: r,
    disableGutters: g,
    divider: o,
    selected: l
  } = e, I = Mt({
    root: ["root", n && "dense", !g && "gutters", o && "divider", r && "disabled", t === "flex-start" && "alignItemsFlexStart", l && "selected"]
  }, fpe, i);
  return F({}, i, I);
}, Wpe = Se(Xo, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: Gpe
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Rh.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Rh.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Rh.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Rh.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Rh.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), Spe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: r = "center",
    autoFocus: g = !1,
    component: o = "div",
    children: l,
    dense: a = !1,
    disableGutters: I = !1,
    divider: c = !1,
    focusVisibleClassName: d,
    selected: C = !1,
    className: A
  } = n, b = tt(n, Zpe), m = X.useContext(Hs), p = X.useMemo(() => ({
    dense: a || m.dense || !1,
    alignItems: r,
    disableGutters: I
  }), [r, m.dense, a, I]), B = X.useRef(null);
  no(() => {
    g && B.current && B.current.focus();
  }, [g]);
  const f = F({}, n, {
    alignItems: r,
    dense: p.dense,
    disableGutters: I,
    divider: c,
    selected: C
  }), Z = ype(f), y = Zn(B, i);
  return /* @__PURE__ */ ee(Hs.Provider, {
    value: p,
    children: /* @__PURE__ */ ee(Wpe, F({
      ref: y,
      href: b.href || b.to,
      component: (b.href || b.to) && o === "div" ? "button" : o,
      focusVisibleClassName: Re(Z.focusVisible, d),
      ownerState: f,
      className: Re(Z.root, A)
    }, b, {
      classes: Z,
      children: l
    }))
  });
});
function Vpe(e) {
  return Lt("MuiListItemSecondaryAction", e);
}
Dt("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const wpe = ["className"], vpe = (e) => {
  const {
    disableGutters: t,
    classes: i
  } = e;
  return Mt({
    root: ["root", t && "disableGutters"]
  }, Vpe, i);
}, Rpe = Se("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => F({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), Wj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: r
  } = n, g = tt(n, wpe), o = X.useContext(Hs), l = F({}, n, {
    disableGutters: o.disableGutters
  }), a = vpe(l);
  return /* @__PURE__ */ ee(Rpe, F({
    className: Re(a.root, r),
    ownerState: l,
    ref: i
  }, g));
});
Wj.muiName = "ListItemSecondaryAction";
const Xpe = ["className"], Hpe = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], kpe = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.alignItems === "flex-start" && t.alignItemsFlexStart, i.divider && t.divider, !i.disableGutters && t.gutters, !i.disablePadding && t.padding, i.button && t.button, i.hasSecondaryAction && t.secondaryAction];
}, Ype = (e) => {
  const {
    alignItems: t,
    button: i,
    classes: n,
    dense: r,
    disabled: g,
    disableGutters: o,
    disablePadding: l,
    divider: a,
    hasSecondaryAction: I,
    selected: c
  } = e;
  return Mt({
    root: ["root", r && "dense", !o && "gutters", !l && "padding", a && "divider", g && "disabled", i && "button", t === "flex-start" && "alignItemsFlexStart", I && "secondaryAction", c && "selected"],
    container: ["container"]
  }, Bpe, n);
}, Fpe = Se("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: kpe
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && F({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${Rh.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${vh.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${vh.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${vh.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${vh.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${vh.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), xpe = Se("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), Dpe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: r = "center",
    autoFocus: g = !1,
    button: o = !1,
    children: l,
    className: a,
    component: I,
    components: c = {},
    componentsProps: d = {},
    ContainerComponent: C = "li",
    ContainerProps: {
      className: A
    } = {},
    dense: b = !1,
    disabled: m = !1,
    disableGutters: p = !1,
    disablePadding: B = !1,
    divider: f = !1,
    focusVisibleClassName: Z,
    secondaryAction: y,
    selected: W = !1,
    slotProps: V = {},
    slots: w = {}
  } = n, v = tt(n.ContainerProps, Xpe), H = tt(n, Hpe), x = X.useContext(Hs), J = X.useMemo(() => ({
    dense: b || x.dense || !1,
    alignItems: r,
    disableGutters: p
  }), [r, x.dense, b, p]), K = X.useRef(null);
  no(() => {
    g && K.current && K.current.focus();
  }, [g]);
  const M = X.Children.toArray(l), L = M.length && MB(M[M.length - 1], ["ListItemSecondaryAction"]), N = F({}, n, {
    alignItems: r,
    autoFocus: g,
    button: o,
    dense: J.dense,
    disabled: m,
    disableGutters: p,
    disablePadding: B,
    divider: f,
    hasSecondaryAction: L,
    selected: W
  }), U = Ype(N), O = Zn(K, i), $ = w.root || c.Root || Fpe, ne = V.root || d.root || {}, be = F({
    className: Re(U.root, ne.className, a),
    disabled: m
  }, H);
  let Ve = I || "li";
  return o && (be.component = I || "div", be.focusVisibleClassName = Re(vh.focusVisible, Z), Ve = Xo), L ? (Ve = !be.component && !I ? "div" : Ve, C === "li" && (Ve === "li" ? Ve = "div" : be.component === "li" && (be.component = "div")), /* @__PURE__ */ ee(Hs.Provider, {
    value: J,
    children: /* @__PURE__ */ Ri(xpe, F({
      as: C,
      className: Re(U.container, A),
      ref: O,
      ownerState: N
    }, v, {
      children: [/* @__PURE__ */ ee($, F({}, ne, !mI($) && {
        as: Ve,
        ownerState: F({}, N, ne.ownerState)
      }, be, {
        children: M
      })), M.pop()]
    }))
  })) : /* @__PURE__ */ ee(Hs.Provider, {
    value: J,
    children: /* @__PURE__ */ Ri($, F({}, ne, {
      as: Ve,
      ref: O
    }, !mI($) && {
      ownerState: F({}, N, ne.ownerState)
    }, be, {
      children: [M, y && /* @__PURE__ */ ee(Wj, {
        children: y
      })]
    }))
  });
});
function Jpe(e) {
  return Lt("MuiListItemAvatar", e);
}
Dt("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const Epe = ["className"], Npe = (e) => {
  const {
    alignItems: t,
    classes: i
  } = e;
  return Mt({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, Jpe, i);
}, Lpe = Se("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  ownerState: e
}) => F({
  minWidth: 56,
  flexShrink: 0
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), Kpe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: r
  } = n, g = tt(n, Epe), o = X.useContext(Hs), l = F({}, n, {
    alignItems: o.alignItems
  }), a = Npe(l);
  return /* @__PURE__ */ ee(Lpe, F({
    className: Re(a.root, r),
    ownerState: l,
    ref: i
  }, g));
});
function H7t(e) {
  return Lt("MuiListItemIcon", e);
}
const _K = Dt("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function Tpe(e) {
  return Lt("MuiListItemText", e);
}
const qV = Dt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), Mpe = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], Ppe = (e) => {
  const {
    classes: t,
    inset: i,
    primary: n,
    secondary: r,
    dense: g
  } = e;
  return Mt({
    root: ["root", i && "inset", g && "dense", n && r && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, Tpe, t);
}, Upe = Se("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${qV.primary}`]: t.primary
    }, {
      [`& .${qV.secondary}`]: t.secondary
    }, t.root, i.inset && t.inset, i.primary && i.secondary && t.multiline, i.dense && t.dense];
  }
})(({
  ownerState: e
}) => F({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), Sj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiListItemText"
  }), {
    children: r,
    className: g,
    disableTypography: o = !1,
    inset: l = !1,
    primary: a,
    primaryTypographyProps: I,
    secondary: c,
    secondaryTypographyProps: d
  } = n, C = tt(n, Mpe), {
    dense: A
  } = X.useContext(Hs);
  let b = a ?? r, m = c;
  const p = F({}, n, {
    disableTypography: o,
    inset: l,
    primary: !!b,
    secondary: !!m,
    dense: A
  }), B = Ppe(p);
  return b != null && b.type !== Ct && !o && (b = /* @__PURE__ */ ee(Ct, F({
    variant: A ? "body2" : "body1",
    className: B.primary,
    component: I != null && I.variant ? void 0 : "span",
    display: "block"
  }, I, {
    children: b
  }))), m != null && m.type !== Ct && !o && (m = /* @__PURE__ */ ee(Ct, F({
    variant: "body2",
    className: B.secondary,
    color: "text.secondary",
    display: "block"
  }, d, {
    children: m
  }))), /* @__PURE__ */ Ri(Upe, F({
    className: Re(B.root, g),
    ownerState: p,
    ref: i
  }, C, {
    children: [b, m]
  }));
}), zpe = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function sY(e, t, i) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : i ? null : e.firstChild;
}
function $K(e, t, i) {
  return e === t ? i ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : i ? null : e.lastChild;
}
function Vj(e, t) {
  if (t === void 0)
    return !0;
  let i = e.innerText;
  return i === void 0 && (i = e.textContent), i = i.trim().toLowerCase(), i.length === 0 ? !1 : t.repeating ? i[0] === t.keys[0] : i.indexOf(t.keys.join("")) === 0;
}
function z0(e, t, i, n, r, g) {
  let o = !1, l = r(e, t, t ? i : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (o)
        return !1;
      o = !0;
    }
    const a = n ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !Vj(l, g) || a)
      l = r(e, l, i);
    else
      return l.focus(), !0;
  }
  return !1;
}
const Ope = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: r = !1,
    autoFocusItem: g = !1,
    children: o,
    className: l,
    disabledItemsFocusable: a = !1,
    disableListWrap: I = !1,
    onKeyDown: c,
    variant: d = "selectedMenu"
  } = t, C = tt(t, zpe), A = X.useRef(null), b = X.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  no(() => {
    r && A.current.focus();
  }, [r]), X.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (Z, {
      direction: y
    }) => {
      const W = !A.current.style.width;
      if (Z.clientHeight < A.current.clientHeight && W) {
        const V = `${ZQ(Vr(Z))}px`;
        A.current.style[y === "rtl" ? "paddingLeft" : "paddingRight"] = V, A.current.style.width = `calc(100% + ${V})`;
      }
      return A.current;
    }
  }), []);
  const m = (Z) => {
    const y = A.current, W = Z.key, V = Vr(y).activeElement;
    if (W === "ArrowDown")
      Z.preventDefault(), z0(y, V, I, a, sY);
    else if (W === "ArrowUp")
      Z.preventDefault(), z0(y, V, I, a, $K);
    else if (W === "Home")
      Z.preventDefault(), z0(y, null, I, a, sY);
    else if (W === "End")
      Z.preventDefault(), z0(y, null, I, a, $K);
    else if (W.length === 1) {
      const w = b.current, v = W.toLowerCase(), H = performance.now();
      w.keys.length > 0 && (H - w.lastTime > 500 ? (w.keys = [], w.repeating = !0, w.previousKeyMatched = !0) : w.repeating && v !== w.keys[0] && (w.repeating = !1)), w.lastTime = H, w.keys.push(v);
      const x = V && !w.repeating && Vj(V, w);
      w.previousKeyMatched && (x || z0(y, V, !1, a, sY, w)) ? Z.preventDefault() : w.previousKeyMatched = !1;
    }
    c && c(Z);
  }, p = Zn(A, i);
  let B = -1;
  X.Children.forEach(o, (Z, y) => {
    if (!/* @__PURE__ */ X.isValidElement(Z)) {
      B === y && (B += 1, B >= o.length && (B = -1));
      return;
    }
    Z.props.disabled || (d === "selectedMenu" && Z.props.selected || B === -1) && (B = y), B === y && (Z.props.disabled || Z.props.muiSkipListHighlight || Z.type.muiSkipListHighlight) && (B += 1, B >= o.length && (B = -1));
  });
  const f = X.Children.map(o, (Z, y) => {
    if (y === B) {
      const W = {};
      return g && (W.autoFocus = !0), Z.props.tabIndex === void 0 && d === "selectedMenu" && (W.tabIndex = 0), /* @__PURE__ */ X.cloneElement(Z, W);
    }
    return Z;
  });
  return /* @__PURE__ */ ee(jV, F({
    role: "menu",
    ref: p,
    className: l,
    onKeyDown: m,
    tabIndex: r ? 0 : -1
  }, C, {
    children: f
  }));
});
function Qpe(e) {
  return Lt("MuiPopover", e);
}
Dt("MuiPopover", ["root", "paper"]);
const jpe = ["onEntering"], qpe = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], _pe = ["slotProps"];
function e3(e, t) {
  let i = 0;
  return typeof t == "number" ? i = t : t === "center" ? i = e.height / 2 : t === "bottom" && (i = e.height), i;
}
function t3(e, t) {
  let i = 0;
  return typeof t == "number" ? i = t : t === "center" ? i = e.width / 2 : t === "right" && (i = e.width), i;
}
function i3(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function IY(e) {
  return typeof e == "function" ? e() : e;
}
const $pe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"],
    paper: ["paper"]
  }, Qpe, t);
}, e0e = Se(mj, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), wj = Se(ul, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), vj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g;
  const o = _t({
    props: t,
    name: "MuiPopover"
  }), {
    action: l,
    anchorEl: a,
    anchorOrigin: I = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: c,
    anchorReference: d = "anchorEl",
    children: C,
    className: A,
    container: b,
    elevation: m = 8,
    marginThreshold: p = 16,
    open: B,
    PaperProps: f = {},
    slots: Z,
    slotProps: y,
    transformOrigin: W = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: V = QV,
    transitionDuration: w = "auto",
    TransitionProps: {
      onEntering: v
    } = {},
    disableScrollLock: H = !1
  } = o, x = tt(o.TransitionProps, jpe), J = tt(o, qpe), K = (n = y == null ? void 0 : y.paper) != null ? n : f, M = X.useRef(), L = Zn(M, K.ref), N = F({}, o, {
    anchorOrigin: I,
    anchorReference: d,
    elevation: m,
    marginThreshold: p,
    externalPaperSlotProps: K,
    transformOrigin: W,
    TransitionComponent: V,
    transitionDuration: w,
    TransitionProps: x
  }), U = $pe(N), O = X.useCallback(() => {
    if (d === "anchorPosition")
      return c;
    const it = IY(a), $e = (it && it.nodeType === 1 ? it : Vr(M.current).body).getBoundingClientRect();
    return {
      top: $e.top + e3($e, I.vertical),
      left: $e.left + t3($e, I.horizontal)
    };
  }, [a, I.horizontal, I.vertical, c, d]), $ = X.useCallback((it) => ({
    vertical: e3(it, W.vertical),
    horizontal: t3(it, W.horizontal)
  }), [W.horizontal, W.vertical]), ne = X.useCallback((it) => {
    const Qe = {
      width: it.offsetWidth,
      height: it.offsetHeight
    }, $e = $(Qe);
    if (d === "none")
      return {
        top: null,
        left: null,
        transformOrigin: i3($e)
      };
    const It = O();
    let jt = It.top - $e.vertical, Bt = It.left - $e.horizontal;
    const te = jt + Qe.height, Xt = Bt + Qe.width, Ht = Ja(IY(a)), ii = Ht.innerHeight - p, $t = Ht.innerWidth - p;
    if (p !== null && jt < p) {
      const ni = jt - p;
      jt -= ni, $e.vertical += ni;
    } else if (p !== null && te > ii) {
      const ni = te - ii;
      jt -= ni, $e.vertical += ni;
    }
    if (p !== null && Bt < p) {
      const ni = Bt - p;
      Bt -= ni, $e.horizontal += ni;
    } else if (Xt > $t) {
      const ni = Xt - $t;
      Bt -= ni, $e.horizontal += ni;
    }
    return {
      top: `${Math.round(jt)}px`,
      left: `${Math.round(Bt)}px`,
      transformOrigin: i3($e)
    };
  }, [a, d, O, $, p]), [be, Ve] = X.useState(B), He = X.useCallback(() => {
    const it = M.current;
    if (!it)
      return;
    const Qe = ne(it);
    Qe.top !== null && (it.style.top = Qe.top), Qe.left !== null && (it.style.left = Qe.left), it.style.transformOrigin = Qe.transformOrigin, Ve(!0);
  }, [ne]);
  X.useEffect(() => (H && window.addEventListener("scroll", He), () => window.removeEventListener("scroll", He)), [a, H, He]);
  const Je = (it, Qe) => {
    v && v(it, Qe), He();
  }, ke = () => {
    Ve(!1);
  };
  X.useEffect(() => {
    B && He();
  }), X.useImperativeHandle(l, () => B ? {
    updatePosition: () => {
      He();
    }
  } : null, [B, He]), X.useEffect(() => {
    if (!B)
      return;
    const it = ym(() => {
      He();
    }), Qe = Ja(a);
    return Qe.addEventListener("resize", it), () => {
      it.clear(), Qe.removeEventListener("resize", it);
    };
  }, [a, B, He]);
  let we = w;
  w === "auto" && !V.muiSupportAuto && (we = void 0);
  const ue = b || (a ? Vr(IY(a)).body : void 0), Xe = (r = Z == null ? void 0 : Z.root) != null ? r : e0e, Ze = (g = Z == null ? void 0 : Z.paper) != null ? g : wj, xe = Fr({
    elementType: Ze,
    externalSlotProps: F({}, K, {
      style: be ? K.style : F({}, K.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: m,
      ref: L
    },
    ownerState: N,
    className: Re(U.paper, K == null ? void 0 : K.className)
  }), Pe = Fr({
    elementType: Xe,
    externalSlotProps: (y == null ? void 0 : y.root) || {},
    externalForwardedProps: J,
    additionalProps: {
      ref: i,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: ue,
      open: B
    },
    ownerState: N,
    className: Re(U.root, A)
  }), {
    slotProps: st
  } = Pe, bt = tt(Pe, _pe);
  return /* @__PURE__ */ ee(Xe, F({}, bt, !mI(Xe) && {
    slotProps: st,
    disableScrollLock: H
  }, {
    children: /* @__PURE__ */ ee(V, F({
      appear: !0,
      in: B,
      onEntering: Je,
      onExited: ke,
      timeout: we
    }, x, {
      children: /* @__PURE__ */ ee(Ze, F({}, xe, {
        children: C
      }))
    }))
  }));
});
function t0e(e) {
  return Lt("MuiMenu", e);
}
Dt("MuiMenu", ["root", "paper", "list"]);
const i0e = ["onEntering"], n0e = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], r0e = {
  vertical: "top",
  horizontal: "right"
}, g0e = {
  vertical: "top",
  horizontal: "left"
}, o0e = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, t0e, t);
}, l0e = Se(vj, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), a0e = Se(wj, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), s0e = Se(Ope, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), I0e = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r;
  const g = _t({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: l,
    className: a,
    disableAutoFocusItem: I = !1,
    MenuListProps: c = {},
    onClose: d,
    open: C,
    PaperProps: A = {},
    PopoverClasses: b,
    transitionDuration: m = "auto",
    TransitionProps: {
      onEntering: p
    } = {},
    variant: B = "selectedMenu",
    slots: f = {},
    slotProps: Z = {}
  } = g, y = tt(g.TransitionProps, i0e), W = tt(g, n0e), V = CA(), w = F({}, g, {
    autoFocus: o,
    disableAutoFocusItem: I,
    MenuListProps: c,
    onEntering: p,
    PaperProps: A,
    transitionDuration: m,
    TransitionProps: y,
    variant: B
  }), v = o0e(w), H = o && !I && C, x = X.useRef(null), J = ($, ne) => {
    x.current && x.current.adjustStyleForScrollbar($, {
      direction: V ? "rtl" : "ltr"
    }), p && p($, ne);
  }, K = ($) => {
    $.key === "Tab" && ($.preventDefault(), d && d($, "tabKeyDown"));
  };
  let M = -1;
  X.Children.map(l, ($, ne) => {
    /* @__PURE__ */ X.isValidElement($) && ($.props.disabled || (B === "selectedMenu" && $.props.selected || M === -1) && (M = ne));
  });
  const L = (n = f.paper) != null ? n : a0e, N = (r = Z.paper) != null ? r : A, U = Fr({
    elementType: f.root,
    externalSlotProps: Z.root,
    ownerState: w,
    className: [v.root, a]
  }), O = Fr({
    elementType: L,
    externalSlotProps: N,
    ownerState: w,
    className: v.paper
  });
  return /* @__PURE__ */ ee(l0e, F({
    onClose: d,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: V ? "right" : "left"
    },
    transformOrigin: V ? r0e : g0e,
    slots: {
      paper: L,
      root: f.root
    },
    slotProps: {
      root: U,
      paper: O
    },
    open: C,
    ref: i,
    transitionDuration: m,
    TransitionProps: F({
      onEntering: J
    }, y),
    ownerState: w
  }, W, {
    classes: b,
    children: /* @__PURE__ */ ee(s0e, F({
      onKeyDown: K,
      actions: x,
      autoFocus: o && (M === -1 || I),
      autoFocusItem: H,
      variant: B
    }, c, {
      className: Re(v.list, c.className),
      children: l
    }))
  }));
});
function c0e(e) {
  return Lt("MuiMenuItem", e);
}
const O0 = Dt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), d0e = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], u0e = (e, t) => {
  const {
    ownerState: i
  } = e;
  return [t.root, i.dense && t.dense, i.divider && t.divider, !i.disableGutters && t.gutters];
}, C0e = (e) => {
  const {
    disabled: t,
    dense: i,
    divider: n,
    disableGutters: r,
    selected: g,
    classes: o
  } = e, a = Mt({
    root: ["root", i && "dense", t && "disabled", !r && "gutters", n && "divider", g && "selected"]
  }, c0e, o);
  return F({}, o, a);
}, A0e = Se(Xo, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: u0e
})(({
  theme: e,
  ownerState: t
}) => F({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${O0.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${O0.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${O0.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${O0.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${O0.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${LK.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${LK.inset}`]: {
    marginLeft: 52
  },
  [`& .${qV.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${qV.inset}`]: {
    paddingLeft: 36
  },
  [`& .${_K.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && F({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${_K.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), yo = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: r = !1,
    component: g = "li",
    dense: o = !1,
    divider: l = !1,
    disableGutters: a = !1,
    focusVisibleClassName: I,
    role: c = "menuitem",
    tabIndex: d,
    className: C
  } = n, A = tt(n, d0e), b = X.useContext(Hs), m = X.useMemo(() => ({
    dense: o || b.dense || !1,
    disableGutters: a
  }), [b.dense, o, a]), p = X.useRef(null);
  no(() => {
    r && p.current && p.current.focus();
  }, [r]);
  const B = F({}, n, {
    dense: m.dense,
    divider: l,
    disableGutters: a
  }), f = C0e(n), Z = Zn(p, i);
  let y;
  return n.disabled || (y = d !== void 0 ? d : -1), /* @__PURE__ */ ee(Hs.Provider, {
    value: m,
    children: /* @__PURE__ */ ee(A0e, F({
      ref: Z,
      role: c,
      tabIndex: y,
      component: g,
      focusVisibleClassName: Re(f.focusVisible, I),
      className: Re(f.root, C)
    }, A, {
      ownerState: B,
      classes: f
    }))
  });
});
function b0e(e) {
  return Lt("MuiNativeSelect", e);
}
const hJ = Dt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), h0e = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], m0e = (e) => {
  const {
    classes: t,
    variant: i,
    disabled: n,
    multiple: r,
    open: g,
    error: o
  } = e, l = {
    select: ["select", i, n && "disabled", r && "multiple", o && "error"],
    icon: ["icon", `icon${ve(i)}`, g && "iconOpen", n && "disabled"]
  };
  return Mt(l, b0e, t);
}, Rj = ({
  ownerState: e,
  theme: t
}) => F({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": F({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${hJ.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), p0e = Se("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Wg,
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.select, t[i.variant], i.error && t.error, {
      [`&.${hJ.multiple}`]: t.multiple
    }];
  }
})(Rj), Xj = ({
  ownerState: e,
  theme: t
}) => F({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${hJ.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), B0e = Se("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.icon, i.variant && t[`icon${ve(i.variant)}`], i.open && t.iconOpen];
  }
})(Xj), f0e = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    className: n,
    disabled: r,
    error: g,
    IconComponent: o,
    inputRef: l,
    variant: a = "standard"
  } = t, I = tt(t, h0e), c = F({}, t, {
    disabled: r,
    variant: a,
    error: g
  }), d = m0e(c);
  return /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ ee(p0e, F({
      ownerState: c,
      className: Re(d.select, n),
      disabled: r,
      ref: l || i
    }, I)), t.multiple ? null : /* @__PURE__ */ ee(B0e, {
      as: o,
      ownerState: c,
      className: d.icon
    })]
  });
});
var n3;
const Z0e = ["children", "classes", "className", "label", "notched"], G0e = Se("fieldset", {
  shouldForwardProp: Wg
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), y0e = Se("legend", {
  shouldForwardProp: Wg
})(({
  ownerState: e,
  theme: t
}) => F({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && F({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function W0e(e) {
  const {
    className: t,
    label: i,
    notched: n
  } = e, r = tt(e, Z0e), g = i != null && i !== "", o = F({}, e, {
    notched: n,
    withLabel: g
  });
  return /* @__PURE__ */ ee(G0e, F({
    "aria-hidden": !0,
    className: t,
    ownerState: o
  }, r, {
    children: /* @__PURE__ */ ee(y0e, {
      ownerState: o,
      children: g ? /* @__PURE__ */ ee("span", {
        children: i
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        n3 || (n3 = /* @__PURE__ */ ee("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
const S0e = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], V0e = (e) => {
  const {
    classes: t
  } = e, n = Mt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, TAe, t);
  return F({}, t, n);
}, w0e = Se(_2, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: j2
})(({
  theme: e,
  ownerState: t
}) => {
  const i = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return F({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${lI.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${lI.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : i
      }
    },
    [`&.${lI.focused} .${lI.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${lI.error} .${lI.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${lI.disabled} .${lI.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && F({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), v0e = Se(W0e, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), R0e = Se($2, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: q2
})(({
  theme: e,
  ownerState: t
}) => F({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), mJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o, l;
  const a = _t({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: I = {},
    fullWidth: c = !1,
    inputComponent: d = "input",
    label: C,
    multiline: A = !1,
    notched: b,
    slots: m = {},
    type: p = "text"
  } = a, B = tt(a, S0e), f = V0e(a), Z = HI(), y = au({
    props: a,
    muiFormControl: Z,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), W = F({}, a, {
    color: y.color || "primary",
    disabled: y.disabled,
    error: y.error,
    focused: y.focused,
    formControl: Z,
    fullWidth: c,
    hiddenLabel: y.hiddenLabel,
    multiline: A,
    size: y.size,
    type: p
  }), V = (n = (r = m.root) != null ? r : I.Root) != null ? n : w0e, w = (g = (o = m.input) != null ? o : I.Input) != null ? g : R0e;
  return /* @__PURE__ */ ee(ev, F({
    slots: {
      root: V,
      input: w
    },
    renderSuffix: (v) => /* @__PURE__ */ ee(v0e, {
      ownerState: W,
      className: f.notchedOutline,
      label: C != null && C !== "" && y.required ? l || (l = /* @__PURE__ */ Ri(X.Fragment, {
        children: [C, " ", "*"]
      })) : C,
      notched: typeof b < "u" ? b : !!(v.startAdornment || v.filled || v.focused)
    }),
    fullWidth: c,
    inputComponent: d,
    multiline: A,
    ref: i,
    type: p
  }, B, {
    classes: F({}, f, {
      notchedOutline: null
    })
  }));
});
mJ.muiName = "Input";
const X0e = ai(/* @__PURE__ */ ee("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), H0e = ai(/* @__PURE__ */ ee("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), k0e = Se("span", {
  shouldForwardProp: Wg
})({
  position: "relative",
  display: "flex"
}), Y0e = Se(X0e)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), F0e = Se(H0e)(({
  theme: e,
  ownerState: t
}) => F({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function Hj(e) {
  const {
    checked: t = !1,
    classes: i = {},
    fontSize: n
  } = e, r = F({}, e, {
    checked: t
  });
  return /* @__PURE__ */ Ri(k0e, {
    className: i.root,
    ownerState: r,
    children: [/* @__PURE__ */ ee(Y0e, {
      fontSize: n,
      className: i.background,
      ownerState: r
    }), /* @__PURE__ */ ee(F0e, {
      fontSize: n,
      className: i.dot,
      ownerState: r
    })]
  });
}
const kj = /* @__PURE__ */ X.createContext(void 0);
function x0e() {
  return X.useContext(kj);
}
function D0e(e) {
  return Lt("MuiRadio", e);
}
const r3 = Dt("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), J0e = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], E0e = (e) => {
  const {
    classes: t,
    color: i,
    size: n
  } = e, r = {
    root: ["root", `color${ve(i)}`, n !== "medium" && `size${ve(n)}`]
  };
  return F({}, t, Mt(r, D0e, t));
}, N0e = Se(CJ, {
  shouldForwardProp: (e) => Wg(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.size !== "medium" && t[`size${ve(i.size)}`], t[`color${ve(i.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${r3.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${r3.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function L0e(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const g3 = /* @__PURE__ */ ee(Hj, {
  checked: !0
}), o3 = /* @__PURE__ */ ee(Hj, {}), K0e = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r;
  const g = _t({
    props: t,
    name: "MuiRadio"
  }), {
    checked: o,
    checkedIcon: l = g3,
    color: a = "primary",
    icon: I = o3,
    name: c,
    onChange: d,
    size: C = "medium",
    className: A
  } = g, b = tt(g, J0e), m = F({}, g, {
    color: a,
    size: C
  }), p = E0e(m), B = x0e();
  let f = o;
  const Z = LV(d, B && B.onChange);
  let y = c;
  return B && (typeof f > "u" && (f = L0e(B.value, g.value)), typeof y > "u" && (y = B.name)), /* @__PURE__ */ ee(N0e, F({
    type: "radio",
    icon: /* @__PURE__ */ X.cloneElement(I, {
      fontSize: (n = o3.props.fontSize) != null ? n : C
    }),
    checkedIcon: /* @__PURE__ */ X.cloneElement(l, {
      fontSize: (r = g3.props.fontSize) != null ? r : C
    }),
    ownerState: m,
    classes: p,
    name: y,
    checked: f,
    onChange: Z,
    ref: i,
    className: Re(p.root, A)
  }, b));
});
function T0e(e) {
  return Lt("MuiRadioGroup", e);
}
Dt("MuiRadioGroup", ["root", "row", "error"]);
const M0e = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"], P0e = (e) => {
  const {
    classes: t,
    row: i,
    error: n
  } = e;
  return Mt({
    root: ["root", i && "row", n && "error"]
  }, T0e, t);
}, U0e = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    children: r,
    className: g,
    defaultValue: o,
    name: l,
    onChange: a,
    value: I
  } = t, c = tt(t, M0e), d = X.useRef(null), C = P0e(t), [A, b] = Xs({
    controlled: I,
    default: o,
    name: "RadioGroup"
  });
  X.useImperativeHandle(n, () => ({
    focus: () => {
      let f = d.current.querySelector("input:not(:disabled):checked");
      f || (f = d.current.querySelector("input:not(:disabled)")), f && f.focus();
    }
  }), []);
  const m = Zn(i, d), p = uA(l), B = X.useMemo(() => ({
    name: p,
    onChange(f) {
      b(f.target.value), a && a(f, f.target.value);
    },
    value: A
  }), [p, a, b, A]);
  return /* @__PURE__ */ ee(kj.Provider, {
    value: B,
    children: /* @__PURE__ */ ee(Wme, F({
      role: "radiogroup",
      ref: m,
      className: Re(C.root, g)
    }, c, {
      children: r
    }))
  });
});
function z0e(e) {
  return Lt("MuiScopedCssBaseline", e);
}
Dt("MuiScopedCssBaseline", ["root"]);
const O0e = ["className", "component", "enableColorScheme"], Q0e = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, z0e, t);
}, j0e = Se("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  const i = {};
  return t.enableColorScheme && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([n, r]) => {
    var g;
    i[`&${e.getColorSchemeSelector(n).replace(/\s*&/, "")}`] = {
      colorScheme: (g = r.palette) == null ? void 0 : g.mode
    };
  }), F({}, fhe(e, t.enableColorScheme), Zhe(e), {
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    }
  }, i);
}), q0e = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: r,
    component: g = "div"
  } = n, o = tt(n, O0e), l = F({}, n, {
    component: g
  }), a = Q0e(l);
  return /* @__PURE__ */ ee(j0e, F({
    as: g,
    className: Re(a.root, r),
    ref: i,
    ownerState: l
  }, o));
});
function _0e(e) {
  return Lt("MuiSelect", e);
}
const Q0 = Dt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var l3;
const $0e = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], eBe = Se("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Q0.select}`]: t.select
      },
      {
        [`&.${Q0.select}`]: t[i.variant]
      },
      {
        [`&.${Q0.error}`]: t.error
      },
      {
        [`&.${Q0.multiple}`]: t.multiple
      }
    ];
  }
})(Rj, {
  // Win specificity over the input base
  [`&.${Q0.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), tBe = Se("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.icon, i.variant && t[`icon${ve(i.variant)}`], i.open && t.iconOpen];
  }
})(Xj), iBe = Se("input", {
  shouldForwardProp: (e) => M2(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function a3(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function nBe(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const rBe = (e) => {
  const {
    classes: t,
    variant: i,
    disabled: n,
    multiple: r,
    open: g,
    error: o
  } = e, l = {
    select: ["select", i, n && "disabled", r && "multiple", o && "error"],
    icon: ["icon", `icon${ve(i)}`, g && "iconOpen", n && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return Mt(l, _0e, t);
}, gBe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n;
  const {
    "aria-describedby": r,
    "aria-label": g,
    autoFocus: o,
    autoWidth: l,
    children: a,
    className: I,
    defaultOpen: c,
    defaultValue: d,
    disabled: C,
    displayEmpty: A,
    error: b = !1,
    IconComponent: m,
    inputRef: p,
    labelId: B,
    MenuProps: f = {},
    multiple: Z,
    name: y,
    onBlur: W,
    onChange: V,
    onClose: w,
    onFocus: v,
    onOpen: H,
    open: x,
    readOnly: J,
    renderValue: K,
    SelectDisplayProps: M = {},
    tabIndex: L,
    value: N,
    variant: U = "standard"
  } = t, O = tt(t, $0e), [$, ne] = Xs({
    controlled: N,
    default: d,
    name: "Select"
  }), [be, Ve] = Xs({
    controlled: x,
    default: c,
    name: "Select"
  }), He = X.useRef(null), Je = X.useRef(null), [ke, we] = X.useState(null), {
    current: ue
  } = X.useRef(x != null), [Xe, Ze] = X.useState(), xe = Zn(i, p), Pe = X.useCallback((Te) => {
    Je.current = Te, Te && we(Te);
  }, []), st = ke == null ? void 0 : ke.parentNode;
  X.useImperativeHandle(xe, () => ({
    focus: () => {
      Je.current.focus();
    },
    node: He.current,
    value: $
  }), [$]), X.useEffect(() => {
    c && be && ke && !ue && (Ze(l ? null : st.clientWidth), Je.current.focus());
  }, [ke, l]), X.useEffect(() => {
    o && Je.current.focus();
  }, [o]), X.useEffect(() => {
    if (!B)
      return;
    const Te = Vr(Je.current).getElementById(B);
    if (Te) {
      const Tt = () => {
        getSelection().isCollapsed && Je.current.focus();
      };
      return Te.addEventListener("click", Tt), () => {
        Te.removeEventListener("click", Tt);
      };
    }
  }, [B]);
  const bt = (Te, Tt) => {
    Te ? H && H(Tt) : w && w(Tt), ue || (Ze(l ? null : st.clientWidth), Ve(Te));
  }, it = (Te) => {
    Te.button === 0 && (Te.preventDefault(), Je.current.focus(), bt(!0, Te));
  }, Qe = (Te) => {
    bt(!1, Te);
  }, $e = X.Children.toArray(a), It = (Te) => {
    const Tt = $e.find((Ue) => Ue.props.value === Te.target.value);
    Tt !== void 0 && (ne(Tt.props.value), V && V(Te, Tt));
  }, jt = (Te) => (Tt) => {
    let Ue;
    if (Tt.currentTarget.hasAttribute("tabindex")) {
      if (Z) {
        Ue = Array.isArray($) ? $.slice() : [];
        const Me = $.indexOf(Te.props.value);
        Me === -1 ? Ue.push(Te.props.value) : Ue.splice(Me, 1);
      } else
        Ue = Te.props.value;
      if (Te.props.onClick && Te.props.onClick(Tt), $ !== Ue && (ne(Ue), V)) {
        const Me = Tt.nativeEvent || Tt, Yt = new Me.constructor(Me.type, Me);
        Object.defineProperty(Yt, "target", {
          writable: !0,
          value: {
            value: Ue,
            name: y
          }
        }), V(Yt, Te);
      }
      Z || bt(!1, Tt);
    }
  }, Bt = (Te) => {
    J || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Te.key) !== -1 && (Te.preventDefault(), bt(!0, Te));
  }, te = ke !== null && be, Xt = (Te) => {
    !te && W && (Object.defineProperty(Te, "target", {
      writable: !0,
      value: {
        value: $,
        name: y
      }
    }), W(Te));
  };
  delete O["aria-invalid"];
  let Ht, ii;
  const $t = [];
  let ni = !1;
  (OV({
    value: $
  }) || A) && (K ? Ht = K($) : ni = !0);
  const mi = $e.map((Te) => {
    if (!/* @__PURE__ */ X.isValidElement(Te))
      return null;
    let Tt;
    if (Z) {
      if (!Array.isArray($))
        throw new Error(yI(2));
      Tt = $.some((Ue) => a3(Ue, Te.props.value)), Tt && ni && $t.push(Te.props.children);
    } else
      Tt = a3($, Te.props.value), Tt && ni && (ii = Te.props.children);
    return /* @__PURE__ */ X.cloneElement(Te, {
      "aria-selected": Tt ? "true" : "false",
      onClick: jt(Te),
      onKeyUp: (Ue) => {
        Ue.key === " " && Ue.preventDefault(), Te.props.onKeyUp && Te.props.onKeyUp(Ue);
      },
      role: "option",
      selected: Tt,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Te.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  ni && (Z ? $t.length === 0 ? Ht = null : Ht = $t.reduce((Te, Tt, Ue) => (Te.push(Tt), Ue < $t.length - 1 && Te.push(", "), Te), []) : Ht = ii);
  let Bi = Xe;
  !l && ue && ke && (Bi = st.clientWidth);
  let ci;
  typeof L < "u" ? ci = L : ci = C ? null : 0;
  const Ge = M.id || (y ? `mui-component-select-${y}` : void 0), Be = F({}, t, {
    variant: U,
    value: $,
    open: te,
    error: b
  }), qe = rBe(Be), vt = F({}, f.PaperProps, (n = f.slotProps) == null ? void 0 : n.paper), Kt = uA();
  return /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ ee(eBe, F({
      ref: Pe,
      tabIndex: ci,
      role: "combobox",
      "aria-controls": Kt,
      "aria-disabled": C ? "true" : void 0,
      "aria-expanded": te ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": g,
      "aria-labelledby": [B, Ge].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      onKeyDown: Bt,
      onMouseDown: C || J ? null : it,
      onBlur: Xt,
      onFocus: v
    }, M, {
      ownerState: Be,
      className: Re(M.className, qe.select, I),
      id: Ge,
      children: nBe(Ht) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        l3 || (l3 = /* @__PURE__ */ ee("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Ht
    })), /* @__PURE__ */ ee(iBe, F({
      "aria-invalid": b,
      value: Array.isArray($) ? $.join(",") : $,
      name: y,
      ref: He,
      "aria-hidden": !0,
      onChange: It,
      tabIndex: -1,
      disabled: C,
      className: qe.nativeInput,
      autoFocus: o,
      ownerState: Be
    }, O)), /* @__PURE__ */ ee(tBe, {
      as: m,
      className: qe.icon,
      ownerState: Be
    }), /* @__PURE__ */ ee(I0e, F({
      id: `menu-${y || ""}`,
      anchorEl: st,
      open: te,
      onClose: Qe,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, f, {
      MenuListProps: F({
        "aria-labelledby": B,
        role: "listbox",
        "aria-multiselectable": Z ? "true" : void 0,
        disableListWrap: !0,
        id: Kt
      }, f.MenuListProps),
      slotProps: F({}, f.slotProps, {
        paper: F({}, vt, {
          style: F({
            minWidth: Bi
          }, vt != null ? vt.style : null)
        })
      }),
      children: mi
    }))]
  });
}), oBe = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], lBe = ["root"], aBe = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, pJ = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Wg(e) && e !== "variant",
  slot: "Root"
}, sBe = Se(gv, pJ)(""), IBe = Se(mJ, pJ)(""), cBe = Se(AJ, pJ)(""), ZZ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: r = !1,
    children: g,
    classes: o = {},
    className: l,
    defaultOpen: a = !1,
    displayEmpty: I = !1,
    IconComponent: c = cj,
    id: d,
    input: C,
    inputProps: A,
    label: b,
    labelId: m,
    MenuProps: p,
    multiple: B = !1,
    native: f = !1,
    onClose: Z,
    onOpen: y,
    open: W,
    renderValue: V,
    SelectDisplayProps: w,
    variant: v = "outlined"
  } = n, H = tt(n, oBe), x = f ? f0e : gBe, J = HI(), K = au({
    props: n,
    muiFormControl: J,
    states: ["variant", "error"]
  }), M = K.variant || v, L = F({}, n, {
    variant: M,
    classes: o
  }), N = aBe(L), U = tt(N, lBe), O = C || {
    standard: /* @__PURE__ */ ee(sBe, {
      ownerState: L
    }),
    outlined: /* @__PURE__ */ ee(IBe, {
      label: b,
      ownerState: L
    }),
    filled: /* @__PURE__ */ ee(cBe, {
      ownerState: L
    })
  }[M], $ = Zn(i, O.ref);
  return /* @__PURE__ */ ee(X.Fragment, {
    children: /* @__PURE__ */ X.cloneElement(O, F({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: x,
      inputProps: F({
        children: g,
        error: K.error,
        IconComponent: c,
        variant: M,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: B
      }, f ? {
        id: d
      } : {
        autoWidth: r,
        defaultOpen: a,
        displayEmpty: I,
        labelId: m,
        MenuProps: p,
        onClose: Z,
        onOpen: y,
        open: W,
        renderValue: V,
        SelectDisplayProps: F({
          id: d
        }, w)
      }, A, {
        classes: A ? pg(U, A.classes) : U
      }, C ? C.props.inputProps : {})
    }, (B && f || I) && M === "outlined" ? {
      notched: !0
    } : {}, {
      ref: $,
      className: Re(O.props.className, l, N.root)
    }, !C && {
      variant: M
    }, H))
  });
});
ZZ.muiName = "Select";
function dBe(e) {
  return Lt("MuiSkeleton", e);
}
Dt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const uBe = ["animation", "className", "component", "height", "style", "variant", "width"];
let _V = (e) => e, s3, I3, c3, d3;
const CBe = (e) => {
  const {
    classes: t,
    variant: i,
    animation: n,
    hasChildren: r,
    width: g,
    height: o
  } = e;
  return Mt({
    root: ["root", i, n, r && "withChildren", r && !g && "fitContent", r && !o && "heightAuto"]
  }, dBe, t);
}, ABe = Ds(s3 || (s3 = _V`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), bBe = Ds(I3 || (I3 = _V`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), hBe = Se("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], i.animation !== !1 && t[i.animation], i.hasChildren && t.withChildren, i.hasChildren && !i.width && t.fitContent, i.hasChildren && !i.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const i = DQ(e.shape.borderRadius) || "px", n = pd(e.shape.borderRadius);
  return F({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : uI(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${n}${i}/${Math.round(n / 0.6 * 10) / 10}${i}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && Od(c3 || (c3 = _V`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), ABe), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && Od(d3 || (d3 = _V`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), bBe, (t.vars || t).palette.action.hover)), Yj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: r = "pulse",
    className: g,
    component: o = "span",
    height: l,
    style: a,
    variant: I = "text",
    width: c
  } = n, d = tt(n, uBe), C = F({}, n, {
    animation: r,
    component: o,
    variant: I,
    hasChildren: !!d.children
  }), A = CBe(C);
  return /* @__PURE__ */ ee(hBe, F({
    as: o,
    ref: i,
    className: Re(A.root, g),
    ownerState: C
  }, d, {
    style: F({
      width: c,
      height: l
    }, a)
  }));
}), mBe = (e) => !e || !mI(e);
function pBe(e) {
  return Lt("MuiSlider", e);
}
const wa = Dt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), BBe = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: Re(t && wa.valueLabelOpen),
    circle: wa.valueLabelCircle,
    label: wa.valueLabelLabel
  };
};
function fBe(e) {
  const {
    children: t,
    className: i,
    value: n
  } = e, r = BBe(e);
  return t ? /* @__PURE__ */ X.cloneElement(t, {
    className: Re(t.props.className)
  }, /* @__PURE__ */ Ri(X.Fragment, {
    children: [t.props.children, /* @__PURE__ */ ee("span", {
      className: Re(r.offset, i),
      "aria-hidden": !0,
      children: /* @__PURE__ */ ee("span", {
        className: r.circle,
        children: /* @__PURE__ */ ee("span", {
          className: r.label,
          children: n
        })
      })
    })]
  })) : null;
}
const ZBe = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"], GBe = ou();
function u3(e) {
  return e;
}
const yBe = Se("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`color${ve(i.color)}`], i.size !== "medium" && t[`size${ve(i.size)}`], i.marked && t.marked, i.orientation === "vertical" && t.vertical, i.track === "inverted" && t.trackInverted, i.track === !1 && t.trackFalse];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    borderRadius: 12,
    boxSizing: "content-box",
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    touchAction: "none",
    WebkitTapHighlightColor: "transparent",
    "@media print": {
      colorAdjust: "exact"
    },
    [`&.${wa.disabled}`]: {
      pointerEvents: "none",
      cursor: "default",
      color: (e.vars || e).palette.grey[400]
    },
    [`&.${wa.dragging}`]: {
      [`& .${wa.thumb}, & .${wa.track}`]: {
        transition: "none"
      }
    },
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i
      },
      style: {
        color: (e.vars || e).palette[i].main
      }
    })), {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "20px 0"
        }
      }
    }, {
      props: {
        orientation: "horizontal",
        size: "small"
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: "horizontal",
        marked: !0
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "0 20px"
        }
      }
    }, {
      props: {
        orientation: "vertical",
        size: "small"
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: "vertical",
        marked: !0
      },
      style: {
        marginRight: 44
      }
    }]
  };
}), WBe = Se("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), SBe = Se("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => {
  var t;
  return {
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: "small"
      },
      style: {
        border: "none"
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
      }
    }, {
      props: {
        track: !1
      },
      style: {
        display: "none"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i,
        track: "inverted"
      },
      style: F({}, e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${i}Track`],
        borderColor: e.vars.palette.Slider[`${i}Track`]
      } : F({
        backgroundColor: qd(e.palette[i].main, 0.62),
        borderColor: qd(e.palette[i].main, 0.62)
      }, e.applyStyles("dark", {
        backgroundColor: jd(e.palette[i].main, 0.5)
      }), e.applyStyles("dark", {
        borderColor: jd(e.palette[i].main, 0.5)
      })))
    }))]
  };
}), VBe = Se("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.thumb, t[`thumbColor${ve(i.color)}`], i.size !== "medium" && t[`thumbSize${ve(i.size)}`]];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    position: "absolute",
    width: 20,
    height: 20,
    boxSizing: "border-box",
    borderRadius: "50%",
    outline: 0,
    backgroundColor: "currentColor",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: e.transitions.create(["box-shadow", "left", "bottom"], {
      duration: e.transitions.duration.shortest
    }),
    "&::before": {
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      width: "100%",
      height: "100%",
      boxShadow: (e.vars || e).shadows[2]
    },
    "&::after": {
      position: "absolute",
      content: '""',
      borderRadius: "50%",
      // 42px is the hit target
      width: 42,
      height: 42,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    [`&.${wa.disabled}`]: {
      "&:hover": {
        boxShadow: "none"
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 12,
        height: 12,
        "&::before": {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        top: "50%",
        transform: "translate(-50%, -50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        left: "50%",
        transform: "translate(-50%, 50%)"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((i) => {
      var n;
      return ((n = e.vars) != null ? n : e).palette[i].main;
    }).map((i) => ({
      props: {
        color: i
      },
      style: {
        [`&:hover, &.${wa.focusVisible}`]: F({}, e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[i].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${Wi(e.palette[i].main, 0.16)}`
        }, {
          "@media (hover: none)": {
            boxShadow: "none"
          }
        }),
        [`&.${wa.active}`]: F({}, e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[i].mainChannel} / 0.16)}`
        } : {
          boxShadow: `0px 0px 0px 14px ${Wi(e.palette[i].main, 0.16)}`
        })
      }
    }))]
  };
}), wBe = Se(fBe, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e
}) => F({
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${wa.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${wa.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})), vBe = Se("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => M2(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: i
    } = e;
    return [t.mark, i && t.markActive];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
})), RBe = Se("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => M2(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e
}) => F({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
})), XBe = (e) => {
  const {
    disabled: t,
    dragging: i,
    marked: n,
    orientation: r,
    track: g,
    classes: o,
    color: l,
    size: a
  } = e, I = {
    root: ["root", t && "disabled", i && "dragging", n && "marked", r === "vertical" && "vertical", g === "inverted" && "trackInverted", g === !1 && "trackFalse", l && `color${ve(l)}`, a && `size${ve(a)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", a && `thumbSize${ve(a)}`, l && `thumbColor${ve(l)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return Mt(I, pBe, o);
}, HBe = ({
  children: e
}) => e, kBe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o, l, a, I, c, d, C, A, b, m, p, B, f, Z, y, W, V, w, v, H, x;
  const J = GBe({
    props: t,
    name: "MuiSlider"
  }), K = CA(), {
    "aria-label": M,
    "aria-valuetext": L,
    "aria-labelledby": N,
    // eslint-disable-next-line react/prop-types
    component: U = "span",
    components: O = {},
    componentsProps: $ = {},
    color: ne = "primary",
    classes: be,
    className: Ve,
    disableSwap: He = !1,
    disabled: Je = !1,
    getAriaLabel: ke,
    getAriaValueText: we,
    marks: ue = !1,
    max: Xe = 100,
    min: Ze = 0,
    orientation: xe = "horizontal",
    shiftStep: Pe = 10,
    size: st = "medium",
    step: bt = 1,
    scale: it = u3,
    slotProps: Qe,
    slots: $e,
    track: It = "normal",
    valueLabelDisplay: jt = "off",
    valueLabelFormat: Bt = u3
  } = J, te = tt(J, ZBe), Xt = F({}, J, {
    isRtl: K,
    max: Xe,
    min: Ze,
    classes: be,
    disabled: Je,
    disableSwap: He,
    orientation: xe,
    marks: ue,
    color: ne,
    size: st,
    step: bt,
    shiftStep: Pe,
    scale: it,
    track: It,
    valueLabelDisplay: jt,
    valueLabelFormat: Bt
  }), {
    axisProps: Ht,
    getRootProps: ii,
    getHiddenInputProps: $t,
    getThumbProps: ni,
    open: mi,
    active: Bi,
    axis: ci,
    focusedThumbIndex: Ge,
    range: Be,
    dragging: qe,
    marks: vt,
    values: Kt,
    trackOffset: Te,
    trackLeap: Tt,
    getThumbStyle: Ue
  } = IAe(F({}, Xt, {
    rootRef: i
  }));
  Xt.marked = vt.length > 0 && vt.some((fe) => fe.label), Xt.dragging = qe, Xt.focusedThumbIndex = Ge;
  const Me = XBe(Xt), Yt = (n = (r = $e == null ? void 0 : $e.root) != null ? r : O.Root) != null ? n : yBe, zt = (g = (o = $e == null ? void 0 : $e.rail) != null ? o : O.Rail) != null ? g : WBe, ri = (l = (a = $e == null ? void 0 : $e.track) != null ? a : O.Track) != null ? l : SBe, di = (I = (c = $e == null ? void 0 : $e.thumb) != null ? c : O.Thumb) != null ? I : VBe, mt = (d = (C = $e == null ? void 0 : $e.valueLabel) != null ? C : O.ValueLabel) != null ? d : wBe, Ai = (A = (b = $e == null ? void 0 : $e.mark) != null ? b : O.Mark) != null ? A : vBe, ui = (m = (p = $e == null ? void 0 : $e.markLabel) != null ? p : O.MarkLabel) != null ? m : RBe, Ui = (B = (f = $e == null ? void 0 : $e.input) != null ? f : O.Input) != null ? B : "input", Oi = (Z = Qe == null ? void 0 : Qe.root) != null ? Z : $.root, Rn = (y = Qe == null ? void 0 : Qe.rail) != null ? y : $.rail, le = (W = Qe == null ? void 0 : Qe.track) != null ? W : $.track, Ce = (V = Qe == null ? void 0 : Qe.thumb) != null ? V : $.thumb, pe = (w = Qe == null ? void 0 : Qe.valueLabel) != null ? w : $.valueLabel, Ne = (v = Qe == null ? void 0 : Qe.mark) != null ? v : $.mark, Ke = (H = Qe == null ? void 0 : Qe.markLabel) != null ? H : $.markLabel, Jt = (x = Qe == null ? void 0 : Qe.input) != null ? x : $.input, Rt = Fr({
    elementType: Yt,
    getSlotProps: ii,
    externalSlotProps: Oi,
    externalForwardedProps: te,
    additionalProps: F({}, mBe(Yt) && {
      as: U
    }),
    ownerState: F({}, Xt, Oi == null ? void 0 : Oi.ownerState),
    className: [Me.root, Ve]
  }), Zt = Fr({
    elementType: zt,
    externalSlotProps: Rn,
    ownerState: Xt,
    className: Me.rail
  }), Et = Fr({
    elementType: ri,
    externalSlotProps: le,
    additionalProps: {
      style: F({}, Ht[ci].offset(Te), Ht[ci].leap(Tt))
    },
    ownerState: F({}, Xt, le == null ? void 0 : le.ownerState),
    className: Me.track
  }), dt = Fr({
    elementType: di,
    getSlotProps: ni,
    externalSlotProps: Ce,
    ownerState: F({}, Xt, Ce == null ? void 0 : Ce.ownerState),
    className: Me.thumb
  }), xt = Fr({
    elementType: mt,
    externalSlotProps: pe,
    ownerState: F({}, Xt, pe == null ? void 0 : pe.ownerState),
    className: Me.valueLabel
  }), Ot = Fr({
    elementType: Ai,
    externalSlotProps: Ne,
    ownerState: Xt,
    className: Me.mark
  }), si = Fr({
    elementType: ui,
    externalSlotProps: Ke,
    ownerState: Xt,
    className: Me.markLabel
  }), Li = Fr({
    elementType: Ui,
    getSlotProps: $t,
    externalSlotProps: Jt,
    ownerState: Xt
  });
  return /* @__PURE__ */ Ri(Yt, F({}, Rt, {
    children: [/* @__PURE__ */ ee(zt, F({}, Zt)), /* @__PURE__ */ ee(ri, F({}, Et)), vt.filter((fe) => fe.value >= Ze && fe.value <= Xe).map((fe, Ae) => {
      const gt = zV(fe.value, Ze, Xe), _e = Ht[ci].offset(gt);
      let Qt;
      return It === !1 ? Qt = Kt.indexOf(fe.value) !== -1 : Qt = It === "normal" && (Be ? fe.value >= Kt[0] && fe.value <= Kt[Kt.length - 1] : fe.value <= Kt[0]) || It === "inverted" && (Be ? fe.value <= Kt[0] || fe.value >= Kt[Kt.length - 1] : fe.value >= Kt[0]), /* @__PURE__ */ Ri(X.Fragment, {
        children: [/* @__PURE__ */ ee(Ai, F({
          "data-index": Ae
        }, Ot, !mI(Ai) && {
          markActive: Qt
        }, {
          style: F({}, _e, Ot.style),
          className: Re(Ot.className, Qt && Me.markActive)
        })), fe.label != null ? /* @__PURE__ */ ee(ui, F({
          "aria-hidden": !0,
          "data-index": Ae
        }, si, !mI(ui) && {
          markLabelActive: Qt
        }, {
          style: F({}, _e, si.style),
          className: Re(Me.markLabel, si.className, Qt && Me.markLabelActive),
          children: fe.label
        })) : null]
      }, Ae);
    }), Kt.map((fe, Ae) => {
      const gt = zV(fe, Ze, Xe), _e = Ht[ci].offset(gt), Qt = jt === "off" ? HBe : mt;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ ee(Qt, F({}, !mI(Qt) && {
          valueLabelFormat: Bt,
          valueLabelDisplay: jt,
          value: typeof Bt == "function" ? Bt(it(fe), Ae) : Bt,
          index: Ae,
          open: mi === Ae || Bi === Ae || jt === "on",
          disabled: Je
        }, xt, {
          children: /* @__PURE__ */ ee(di, F({
            "data-index": Ae
          }, dt, {
            className: Re(Me.thumb, dt.className, Bi === Ae && Me.active, Ge === Ae && Me.focusVisible),
            style: F({}, _e, Ue(Ae), dt.style),
            children: /* @__PURE__ */ ee(Ui, F({
              "data-index": Ae,
              "aria-label": ke ? ke(Ae) : M,
              "aria-valuenow": it(fe),
              "aria-labelledby": N,
              "aria-valuetext": we ? we(it(fe), Ae) : L,
              value: Kt[Ae]
            }, Li))
          }))
        }), Ae)
      );
    })]
  }));
});
function YBe(e) {
  return Lt("MuiTooltip", e);
}
const Hd = Dt("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), FBe = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function xBe(e) {
  return Math.round(e * 1e5) / 1e5;
}
const DBe = (e) => {
  const {
    classes: t,
    disableInteractive: i,
    arrow: n,
    touch: r,
    placement: g
  } = e, o = {
    popper: ["popper", !i && "popperInteractive", n && "popperArrow"],
    tooltip: ["tooltip", n && "tooltipArrow", r && "touch", `tooltipPlacement${ve(g.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return Mt(o, YBe, t);
}, JBe = Se(O2, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.popper, !i.disableInteractive && t.popperInteractive, i.arrow && t.popperArrow, !i.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: i
}) => F({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !i && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${Hd.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${Hd.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${Hd.arrow}`]: F({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${Hd.arrow}`]: F({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), EBe = Se("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.tooltip, i.touch && t.touch, i.arrow && t.tooltipArrow, t[`tooltipPlacement${ve(i.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Wi(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${xBe(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${Hd.popper}[data-popper-placement*="left"] &`]: F({
    transformOrigin: "right center"
  }, t.isRtl ? F({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : F({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${Hd.popper}[data-popper-placement*="right"] &`]: F({
    transformOrigin: "left center"
  }, t.isRtl ? F({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : F({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${Hd.popper}[data-popper-placement*="top"] &`]: F({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${Hd.popper}[data-popper-placement*="bottom"] &`]: F({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), NBe = Se("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Wi(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let LW = !1;
const C3 = new bZ();
let j0 = {
  x: 0,
  y: 0
};
function KW(e, t) {
  return (i, ...n) => {
    t && t(i, ...n), e(i, ...n);
  };
}
const Tn = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r, g, o, l, a, I, c, d, C, A, b, m, p, B, f, Z, y, W;
  const V = _t({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: w = !1,
    children: v,
    components: H = {},
    componentsProps: x = {},
    describeChild: J = !1,
    disableFocusListener: K = !1,
    disableHoverListener: M = !1,
    disableInteractive: L = !1,
    disableTouchListener: N = !1,
    enterDelay: U = 100,
    enterNextDelay: O = 0,
    enterTouchDelay: $ = 700,
    followCursor: ne = !1,
    id: be,
    leaveDelay: Ve = 0,
    leaveTouchDelay: He = 1500,
    onClose: Je,
    onOpen: ke,
    open: we,
    placement: ue = "bottom",
    PopperComponent: Xe,
    PopperProps: Ze = {},
    slotProps: xe = {},
    slots: Pe = {},
    title: st,
    TransitionComponent: bt = QV,
    TransitionProps: it
  } = V, Qe = tt(V, FBe), $e = /* @__PURE__ */ X.isValidElement(v) ? v : /* @__PURE__ */ ee("span", {
    children: v
  }), It = ql(), jt = CA(), [Bt, te] = X.useState(), [Xt, Ht] = X.useState(null), ii = X.useRef(!1), $t = L || ne, ni = DC(), mi = DC(), Bi = DC(), ci = DC(), [Ge, Be] = Xs({
    controlled: we,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let qe = Ge;
  const vt = uA(be), Kt = X.useRef(), Te = Qr(() => {
    Kt.current !== void 0 && (document.body.style.WebkitUserSelect = Kt.current, Kt.current = void 0), ci.clear();
  });
  X.useEffect(() => Te, [Te]);
  const Tt = (kt) => {
    C3.clear(), LW = !0, Be(!0), ke && !qe && ke(kt);
  }, Ue = Qr(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (kt) => {
      C3.start(800 + Ve, () => {
        LW = !1;
      }), Be(!1), Je && qe && Je(kt), ni.start(It.transitions.duration.shortest, () => {
        ii.current = !1;
      });
    }
  ), Me = (kt) => {
    ii.current && kt.type !== "touchstart" || (Bt && Bt.removeAttribute("title"), mi.clear(), Bi.clear(), U || LW && O ? mi.start(LW ? O : U, () => {
      Tt(kt);
    }) : Tt(kt));
  }, Yt = (kt) => {
    mi.clear(), Bi.start(Ve, () => {
      Ue(kt);
    });
  }, {
    isFocusVisibleRef: zt,
    onBlur: ri,
    onFocus: di,
    ref: mt
  } = hZ(), [, Ai] = X.useState(!1), ui = (kt) => {
    ri(kt), zt.current === !1 && (Ai(!1), Yt(kt));
  }, Ui = (kt) => {
    Bt || te(kt.currentTarget), di(kt), zt.current === !0 && (Ai(!0), Me(kt));
  }, Oi = (kt) => {
    ii.current = !0;
    const ti = $e.props;
    ti.onTouchStart && ti.onTouchStart(kt);
  }, Rn = (kt) => {
    Oi(kt), Bi.clear(), ni.clear(), Te(), Kt.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", ci.start($, () => {
      document.body.style.WebkitUserSelect = Kt.current, Me(kt);
    });
  }, le = (kt) => {
    $e.props.onTouchEnd && $e.props.onTouchEnd(kt), Te(), Bi.start(He, () => {
      Ue(kt);
    });
  };
  X.useEffect(() => {
    if (!qe)
      return;
    function kt(ti) {
      (ti.key === "Escape" || ti.key === "Esc") && Ue(ti);
    }
    return document.addEventListener("keydown", kt), () => {
      document.removeEventListener("keydown", kt);
    };
  }, [Ue, qe]);
  const Ce = Zn($e.ref, mt, te, i);
  !st && st !== 0 && (qe = !1);
  const pe = X.useRef(), Ne = (kt) => {
    const ti = $e.props;
    ti.onMouseMove && ti.onMouseMove(kt), j0 = {
      x: kt.clientX,
      y: kt.clientY
    }, pe.current && pe.current.update();
  }, Ke = {}, Jt = typeof st == "string";
  J ? (Ke.title = !qe && Jt && !M ? st : null, Ke["aria-describedby"] = qe ? vt : null) : (Ke["aria-label"] = Jt ? st : null, Ke["aria-labelledby"] = qe && !Jt ? vt : null);
  const Rt = F({}, Ke, Qe, $e.props, {
    className: Re(Qe.className, $e.props.className),
    onTouchStart: Oi,
    ref: Ce
  }, ne ? {
    onMouseMove: Ne
  } : {}), Zt = {};
  N || (Rt.onTouchStart = Rn, Rt.onTouchEnd = le), M || (Rt.onMouseOver = KW(Me, Rt.onMouseOver), Rt.onMouseLeave = KW(Yt, Rt.onMouseLeave), $t || (Zt.onMouseOver = Me, Zt.onMouseLeave = Yt)), K || (Rt.onFocus = KW(Ui, Rt.onFocus), Rt.onBlur = KW(ui, Rt.onBlur), $t || (Zt.onFocus = Ui, Zt.onBlur = ui));
  const Et = X.useMemo(() => {
    var kt;
    let ti = [{
      name: "arrow",
      enabled: !!Xt,
      options: {
        element: Xt,
        padding: 4
      }
    }];
    return (kt = Ze.popperOptions) != null && kt.modifiers && (ti = ti.concat(Ze.popperOptions.modifiers)), F({}, Ze.popperOptions, {
      modifiers: ti
    });
  }, [Xt, Ze]), dt = F({}, V, {
    isRtl: jt,
    arrow: w,
    disableInteractive: $t,
    placement: ue,
    PopperComponentProp: Xe,
    touch: ii.current
  }), xt = DBe(dt), Ot = (n = (r = Pe.popper) != null ? r : H.Popper) != null ? n : JBe, si = (g = (o = (l = Pe.transition) != null ? l : H.Transition) != null ? o : bt) != null ? g : QV, Li = (a = (I = Pe.tooltip) != null ? I : H.Tooltip) != null ? a : EBe, fe = (c = (d = Pe.arrow) != null ? d : H.Arrow) != null ? c : NBe, Ae = xh(Ot, F({}, Ze, (C = xe.popper) != null ? C : x.popper, {
    className: Re(xt.popper, Ze == null ? void 0 : Ze.className, (A = (b = xe.popper) != null ? b : x.popper) == null ? void 0 : A.className)
  }), dt), gt = xh(si, F({}, it, (m = xe.transition) != null ? m : x.transition), dt), _e = xh(Li, F({}, (p = xe.tooltip) != null ? p : x.tooltip, {
    className: Re(xt.tooltip, (B = (f = xe.tooltip) != null ? f : x.tooltip) == null ? void 0 : B.className)
  }), dt), Qt = xh(fe, F({}, (Z = xe.arrow) != null ? Z : x.arrow, {
    className: Re(xt.arrow, (y = (W = xe.arrow) != null ? W : x.arrow) == null ? void 0 : y.className)
  }), dt);
  return /* @__PURE__ */ Ri(X.Fragment, {
    children: [/* @__PURE__ */ X.cloneElement($e, Rt), /* @__PURE__ */ ee(Ot, F({
      as: Xe ?? O2,
      placement: ue,
      anchorEl: ne ? {
        getBoundingClientRect: () => ({
          top: j0.y,
          left: j0.x,
          right: j0.x,
          bottom: j0.y,
          width: 0,
          height: 0
        })
      } : Bt,
      popperRef: pe,
      open: Bt ? qe : !1,
      id: vt,
      transition: !0
    }, Zt, Ae, {
      popperOptions: Et,
      children: ({
        TransitionProps: kt
      }) => /* @__PURE__ */ ee(si, F({
        timeout: It.transitions.duration.shorter
      }, kt, gt, {
        children: /* @__PURE__ */ Ri(Li, F({}, _e, {
          children: [st, w ? /* @__PURE__ */ ee(fe, F({}, Qt, {
            ref: Ht
          })) : null]
        }))
      }))
    }))]
  });
});
function LBe(e) {
  return Lt("MuiSwitch", e);
}
const KBe = Dt("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), Zo = KBe, TBe = ["className", "color", "edge", "size", "sx"], MBe = ou(), PBe = (e) => {
  const {
    classes: t,
    edge: i,
    size: n,
    color: r,
    checked: g,
    disabled: o
  } = e, l = {
    root: ["root", i && `edge${ve(i)}`, `size${ve(n)}`],
    switchBase: ["switchBase", `color${ve(r)}`, g && "checked", o && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, a = Mt(l, LBe, t);
  return F({}, t, a);
}, UBe = Se("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.edge && t[`edge${ve(i.edge)}`], t[`size${ve(i.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Zo.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Zo.switchBase}`]: {
        padding: 4,
        [`&.${Zo.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), zBe = Se(CJ, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.switchBase, {
      [`& .${Zo.input}`]: t.input
    }, i.color !== "default" && t[`color${ve(i.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Zo.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Zo.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${Zo.checked} + .${Zo.track}`]: {
    opacity: 0.5
  },
  [`&.${Zo.disabled} + .${Zo.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Zo.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(([, t]) => t.main && t.light).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Zo.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Wi(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Zo.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? qd(e.palette[t].main, 0.62) : jd(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${Zo.checked} + .${Zo.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
})), OBe = Se("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), QBe = Se("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), jBe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = MBe({
    props: t,
    name: "MuiSwitch"
  }), {
    className: r,
    color: g = "primary",
    edge: o = !1,
    size: l = "medium",
    sx: a
  } = n, I = tt(n, TBe), c = F({}, n, {
    color: g,
    edge: o,
    size: l
  }), d = PBe(c), C = /* @__PURE__ */ ee(QBe, {
    className: d.thumb,
    ownerState: c
  });
  return /* @__PURE__ */ Ri(UBe, {
    className: Re(d.root, r),
    sx: a,
    ownerState: c,
    children: [/* @__PURE__ */ ee(zBe, F({
      type: "checkbox",
      icon: C,
      checkedIcon: C,
      ref: i,
      ownerState: c
    }, I, {
      classes: F({}, d, {
        root: d.switchBase
      })
    })), /* @__PURE__ */ ee(OBe, {
      className: d.track,
      ownerState: c
    })]
  });
}), Fj = jBe;
function qBe(e) {
  return Lt("MuiTab", e);
}
const dC = Dt("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), _Be = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], $Be = (e) => {
  const {
    classes: t,
    textColor: i,
    fullWidth: n,
    wrapped: r,
    icon: g,
    label: o,
    selected: l,
    disabled: a
  } = e, I = {
    root: ["root", g && o && "labelIcon", `textColor${ve(i)}`, n && "fullWidth", r && "wrapped", l && "selected", a && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return Mt(I, qBe, t);
}, efe = Se(Xo, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.label && i.icon && t.labelIcon, t[`textColor${ve(i.textColor)}`], i.fullWidth && t.fullWidth, i.wrapped && t.wrapped];
  }
})(({
  theme: e,
  ownerState: t
}) => F({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${dC.iconWrapper}`]: F({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${dC.selected}`]: {
    opacity: 1
  },
  [`&.${dC.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${dC.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${dC.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${dC.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${dC.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), tfe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTab"
  }), {
    className: r,
    disabled: g = !1,
    disableFocusRipple: o = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: l,
    icon: a,
    iconPosition: I = "top",
    // eslint-disable-next-line react/prop-types
    indicator: c,
    label: d,
    onChange: C,
    onClick: A,
    onFocus: b,
    // eslint-disable-next-line react/prop-types
    selected: m,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: p,
    // eslint-disable-next-line react/prop-types
    textColor: B = "inherit",
    value: f,
    wrapped: Z = !1
  } = n, y = tt(n, _Be), W = F({}, n, {
    disabled: g,
    disableFocusRipple: o,
    selected: m,
    icon: !!a,
    iconPosition: I,
    label: !!d,
    fullWidth: l,
    textColor: B,
    wrapped: Z
  }), V = $Be(W), w = a && d && /* @__PURE__ */ X.isValidElement(a) ? /* @__PURE__ */ X.cloneElement(a, {
    className: Re(V.iconWrapper, a.props.className)
  }) : a, v = (x) => {
    !m && C && C(x, f), A && A(x);
  }, H = (x) => {
    p && !m && C && C(x, f), b && b(x);
  };
  return /* @__PURE__ */ Ri(efe, F({
    focusRipple: !o,
    className: Re(V.root, r),
    ref: i,
    role: "tab",
    "aria-selected": m,
    disabled: g,
    onClick: v,
    onFocus: H,
    ownerState: W,
    tabIndex: m ? 0 : -1
  }, y, {
    children: [I === "top" || I === "start" ? /* @__PURE__ */ Ri(X.Fragment, {
      children: [w, d]
    }) : /* @__PURE__ */ Ri(X.Fragment, {
      children: [d, w]
    }), c]
  }));
}), xj = /* @__PURE__ */ X.createContext();
function ife(e) {
  return Lt("MuiTable", e);
}
Dt("MuiTable", ["root", "stickyHeader"]);
const nfe = ["className", "component", "padding", "size", "stickyHeader"], rfe = (e) => {
  const {
    classes: t,
    stickyHeader: i
  } = e;
  return Mt({
    root: ["root", i && "stickyHeader"]
  }, ife, t);
}, gfe = Se("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": F({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), A3 = "table", Dj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTable"
  }), {
    className: r,
    component: g = A3,
    padding: o = "normal",
    size: l = "medium",
    stickyHeader: a = !1
  } = n, I = tt(n, nfe), c = F({}, n, {
    component: g,
    padding: o,
    size: l,
    stickyHeader: a
  }), d = rfe(c), C = X.useMemo(() => ({
    padding: o,
    size: l,
    stickyHeader: a
  }), [o, l, a]);
  return /* @__PURE__ */ ee(xj.Provider, {
    value: C,
    children: /* @__PURE__ */ ee(gfe, F({
      as: g,
      role: g === A3 ? null : "table",
      ref: i,
      className: Re(d.root, r),
      ownerState: c
    }, I))
  });
}), ov = /* @__PURE__ */ X.createContext();
function ofe(e) {
  return Lt("MuiTableBody", e);
}
Dt("MuiTableBody", ["root"]);
const lfe = ["className", "component"], afe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, ofe, t);
}, sfe = Se("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), Ife = {
  variant: "body"
}, b3 = "tbody", Jj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTableBody"
  }), {
    className: r,
    component: g = b3
  } = n, o = tt(n, lfe), l = F({}, n, {
    component: g
  }), a = afe(l);
  return /* @__PURE__ */ ee(ov.Provider, {
    value: Ife,
    children: /* @__PURE__ */ ee(sfe, F({
      className: Re(a.root, r),
      as: g,
      ref: i,
      role: g === b3 ? null : "rowgroup",
      ownerState: l
    }, o))
  });
});
function cfe(e) {
  return Lt("MuiTableCell", e);
}
const Ej = Dt("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), dfe = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], ufe = (e) => {
  const {
    classes: t,
    variant: i,
    align: n,
    padding: r,
    size: g,
    stickyHeader: o
  } = e, l = {
    root: ["root", i, o && "stickyHeader", n !== "inherit" && `align${ve(n)}`, r !== "normal" && `padding${ve(r)}`, `size${ve(g)}`]
  };
  return Mt(l, cfe, t);
}, Cfe = Se("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[i.variant], t[`size${ve(i.size)}`], i.padding !== "normal" && t[`padding${ve(i.padding)}`], i.align !== "inherit" && t[`align${ve(i.align)}`], i.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => F({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? qd(Wi(e.palette.divider, 1), 0.88) : jd(Wi(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${Ej.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), Ur = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTableCell"
  }), {
    align: r = "inherit",
    className: g,
    component: o,
    padding: l,
    scope: a,
    size: I,
    sortDirection: c,
    variant: d
  } = n, C = tt(n, dfe), A = X.useContext(xj), b = X.useContext(ov), m = b && b.variant === "head";
  let p;
  o ? p = o : p = m ? "th" : "td";
  let B = a;
  p === "td" ? B = void 0 : !B && m && (B = "col");
  const f = d || b && b.variant, Z = F({}, n, {
    align: r,
    component: p,
    padding: l || (A && A.padding ? A.padding : "normal"),
    size: I || (A && A.size ? A.size : "medium"),
    sortDirection: c,
    stickyHeader: f === "head" && A && A.stickyHeader,
    variant: f
  }), y = ufe(Z);
  let W = null;
  return c && (W = c === "asc" ? "ascending" : "descending"), /* @__PURE__ */ ee(Cfe, F({
    as: p,
    ref: i,
    className: Re(y.root, g),
    "aria-sort": W,
    scope: B,
    ownerState: Z
  }, C));
});
function Afe(e) {
  return Lt("MuiTableContainer", e);
}
Dt("MuiTableContainer", ["root"]);
const bfe = ["className", "component"], hfe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, Afe, t);
}, mfe = Se("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), pfe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: r,
    component: g = "div"
  } = n, o = tt(n, bfe), l = F({}, n, {
    component: g
  }), a = hfe(l);
  return /* @__PURE__ */ ee(mfe, F({
    ref: i,
    as: g,
    className: Re(a.root, r),
    ownerState: l
  }, o));
});
function Bfe(e) {
  return Lt("MuiTableHead", e);
}
Dt("MuiTableHead", ["root"]);
const ffe = ["className", "component"], Zfe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, Bfe, t);
}, Gfe = Se("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), yfe = {
  variant: "head"
}, h3 = "thead", Wfe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTableHead"
  }), {
    className: r,
    component: g = h3
  } = n, o = tt(n, ffe), l = F({}, n, {
    component: g
  }), a = Zfe(l);
  return /* @__PURE__ */ ee(ov.Provider, {
    value: yfe,
    children: /* @__PURE__ */ ee(Gfe, F({
      as: g,
      className: Re(a.root, r),
      ref: i,
      role: g === h3 ? null : "rowgroup",
      ownerState: l
    }, o))
  });
});
function Sfe(e) {
  return Lt("MuiToolbar", e);
}
Dt("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const Vfe = ["className", "component", "disableGutters", "variant"], wfe = (e) => {
  const {
    classes: t,
    disableGutters: i,
    variant: n
  } = e;
  return Mt({
    root: ["root", !i && "gutters", n]
  }, Sfe, t);
}, vfe = Se("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, !i.disableGutters && t.gutters, t[i.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => F({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), Nj = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiToolbar"
  }), {
    className: r,
    component: g = "div",
    disableGutters: o = !1,
    variant: l = "regular"
  } = n, a = tt(n, Vfe), I = F({}, n, {
    component: g,
    disableGutters: o,
    variant: l
  }), c = wfe(I);
  return /* @__PURE__ */ ee(vfe, F({
    as: g,
    className: Re(c.root, r),
    ref: i,
    ownerState: I
  }, a));
}), Rfe = ai(/* @__PURE__ */ ee("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), Xfe = ai(/* @__PURE__ */ ee("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function Hfe(e) {
  return Lt("MuiTableRow", e);
}
const m3 = Dt("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), kfe = ["className", "component", "hover", "selected"], Yfe = (e) => {
  const {
    classes: t,
    selected: i,
    hover: n,
    head: r,
    footer: g
  } = e;
  return Mt({
    root: ["root", i && "selected", n && "hover", r && "head", g && "footer"]
  }, Hfe, t);
}, Ffe = Se("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.head && t.head, i.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${m3.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${m3.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Wi(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), p3 = "tr", $V = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTableRow"
  }), {
    className: r,
    component: g = p3,
    hover: o = !1,
    selected: l = !1
  } = n, a = tt(n, kfe), I = X.useContext(ov), c = F({}, n, {
    component: g,
    hover: o,
    selected: l,
    head: I && I.variant === "head",
    footer: I && I.variant === "footer"
  }), d = Yfe(c);
  return /* @__PURE__ */ ee(Ffe, F({
    as: g,
    ref: i,
    className: Re(d.root, r),
    role: g === p3 ? null : "row",
    ownerState: c
  }, a));
});
function xfe(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function Dfe(e, t, i, n = {}, r = () => {
}) {
  const {
    ease: g = xfe,
    duration: o = 300
    // standard
  } = n;
  let l = null;
  const a = t[e];
  let I = !1;
  const c = () => {
    I = !0;
  }, d = (C) => {
    if (I) {
      r(new Error("Animation cancelled"));
      return;
    }
    l === null && (l = C);
    const A = Math.min(1, (C - l) / o);
    if (t[e] = g(A) * (i - a) + a, A >= 1) {
      requestAnimationFrame(() => {
        r(null);
      });
      return;
    }
    requestAnimationFrame(d);
  };
  return a === i ? (r(new Error("Element already at target position")), c) : (requestAnimationFrame(d), c);
}
const Jfe = ["onChange"], Efe = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function Nfe(e) {
  const {
    onChange: t
  } = e, i = tt(e, Jfe), n = X.useRef(), r = X.useRef(null), g = () => {
    n.current = r.current.offsetHeight - r.current.clientHeight;
  };
  return no(() => {
    const o = ym(() => {
      const a = n.current;
      g(), a !== n.current && t(n.current);
    }), l = Ja(r.current);
    return l.addEventListener("resize", o), () => {
      o.clear(), l.removeEventListener("resize", o);
    };
  }, [t]), X.useEffect(() => {
    g(), t(n.current);
  }, [t]), /* @__PURE__ */ ee("div", F({
    style: Efe,
    ref: r
  }, i));
}
function Lfe(e) {
  return Lt("MuiTabScrollButton", e);
}
const Kfe = Dt("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), Tfe = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], Mfe = (e) => {
  const {
    classes: t,
    orientation: i,
    disabled: n
  } = e;
  return Mt({
    root: ["root", i, n && "disabled"]
  }, Lfe, t);
}, Pfe = Se(Xo, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, i.orientation && t[i.orientation]];
  }
})(({
  ownerState: e
}) => F({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${Kfe.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), Ufe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var n, r;
  const g = _t({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: o,
    slots: l = {},
    slotProps: a = {},
    direction: I
  } = g, c = tt(g, Tfe), d = CA(), C = F({
    isRtl: d
  }, g), A = Mfe(C), b = (n = l.StartScrollButtonIcon) != null ? n : Rfe, m = (r = l.EndScrollButtonIcon) != null ? r : Xfe, p = Fr({
    elementType: b,
    externalSlotProps: a.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: C
  }), B = Fr({
    elementType: m,
    externalSlotProps: a.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: C
  });
  return /* @__PURE__ */ ee(Pfe, F({
    component: "div",
    className: Re(A.root, o),
    ref: i,
    role: null,
    ownerState: C,
    tabIndex: null
  }, c, {
    children: I === "left" ? /* @__PURE__ */ ee(b, F({}, p)) : /* @__PURE__ */ ee(m, F({}, B))
  }));
});
function zfe(e) {
  return Lt("MuiTabs", e);
}
const cY = Dt("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), Ofe = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], B3 = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, f3 = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, TW = (e, t, i) => {
  let n = !1, r = i(e, t);
  for (; r; ) {
    if (r === e.firstChild) {
      if (n)
        return;
      n = !0;
    }
    const g = r.disabled || r.getAttribute("aria-disabled") === "true";
    if (!r.hasAttribute("tabindex") || g)
      r = i(e, r);
    else {
      r.focus();
      return;
    }
  }
}, Qfe = (e) => {
  const {
    vertical: t,
    fixed: i,
    hideScrollbar: n,
    scrollableX: r,
    scrollableY: g,
    centered: o,
    scrollButtonsHideMobile: l,
    classes: a
  } = e;
  return Mt({
    root: ["root", t && "vertical"],
    scroller: ["scroller", i && "fixed", n && "hideScrollbar", r && "scrollableX", g && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", o && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", l && "scrollButtonsHideMobile"],
    scrollableX: [r && "scrollableX"],
    hideScrollbar: [n && "hideScrollbar"]
  }, zfe, a);
}, jfe = Se("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${cY.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${cY.scrollButtons}`]: i.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, i.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${cY.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), qfe = Se("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.scroller, i.fixed && t.fixed, i.hideScrollbar && t.hideScrollbar, i.scrollableX && t.scrollableX, i.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => F({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), _fe = Se("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.flexContainer, i.vertical && t.flexContainerVertical, i.centered && t.centered];
  }
})(({
  ownerState: e
}) => F({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), $fe = Se("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => F({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), eZe = Se(Nfe)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), Z3 = {}, tZe = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTabs"
  }), r = ql(), g = CA(), {
    "aria-label": o,
    "aria-labelledby": l,
    action: a,
    centered: I = !1,
    children: c,
    className: d,
    component: C = "div",
    allowScrollButtonsMobile: A = !1,
    indicatorColor: b = "primary",
    onChange: m,
    orientation: p = "horizontal",
    ScrollButtonComponent: B = Ufe,
    scrollButtons: f = "auto",
    selectionFollowsFocus: Z,
    slots: y = {},
    slotProps: W = {},
    TabIndicatorProps: V = {},
    TabScrollButtonProps: w = {},
    textColor: v = "primary",
    value: H,
    variant: x = "standard",
    visibleScrollbar: J = !1
  } = n, K = tt(n, Ofe), M = x === "scrollable", L = p === "vertical", N = L ? "scrollTop" : "scrollLeft", U = L ? "top" : "left", O = L ? "bottom" : "right", $ = L ? "clientHeight" : "clientWidth", ne = L ? "height" : "width", be = F({}, n, {
    component: C,
    allowScrollButtonsMobile: A,
    indicatorColor: b,
    orientation: p,
    vertical: L,
    scrollButtons: f,
    textColor: v,
    variant: x,
    visibleScrollbar: J,
    fixed: !M,
    hideScrollbar: M && !J,
    scrollableX: M && !L,
    scrollableY: M && L,
    centered: I && !M,
    scrollButtonsHideMobile: !A
  }), Ve = Qfe(be), He = Fr({
    elementType: y.StartScrollButtonIcon,
    externalSlotProps: W.startScrollButtonIcon,
    ownerState: be
  }), Je = Fr({
    elementType: y.EndScrollButtonIcon,
    externalSlotProps: W.endScrollButtonIcon,
    ownerState: be
  }), [ke, we] = X.useState(!1), [ue, Xe] = X.useState(Z3), [Ze, xe] = X.useState(!1), [Pe, st] = X.useState(!1), [bt, it] = X.useState(!1), [Qe, $e] = X.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), It = /* @__PURE__ */ new Map(), jt = X.useRef(null), Bt = X.useRef(null), te = () => {
    const Ue = jt.current;
    let Me;
    if (Ue) {
      const zt = Ue.getBoundingClientRect();
      Me = {
        clientWidth: Ue.clientWidth,
        scrollLeft: Ue.scrollLeft,
        scrollTop: Ue.scrollTop,
        scrollLeftNormalized: bIe(Ue, g ? "rtl" : "ltr"),
        scrollWidth: Ue.scrollWidth,
        top: zt.top,
        bottom: zt.bottom,
        left: zt.left,
        right: zt.right
      };
    }
    let Yt;
    if (Ue && H !== !1) {
      const zt = Bt.current.children;
      if (zt.length > 0) {
        const ri = zt[It.get(H)];
        Yt = ri ? ri.getBoundingClientRect() : null;
      }
    }
    return {
      tabsMeta: Me,
      tabMeta: Yt
    };
  }, Xt = Qr(() => {
    const {
      tabsMeta: Ue,
      tabMeta: Me
    } = te();
    let Yt = 0, zt;
    if (L)
      zt = "top", Me && Ue && (Yt = Me.top - Ue.top + Ue.scrollTop);
    else if (zt = g ? "right" : "left", Me && Ue) {
      const di = g ? Ue.scrollLeftNormalized + Ue.clientWidth - Ue.scrollWidth : Ue.scrollLeft;
      Yt = (g ? -1 : 1) * (Me[zt] - Ue[zt] + di);
    }
    const ri = {
      [zt]: Yt,
      // May be wrong until the font is loaded.
      [ne]: Me ? Me[ne] : 0
    };
    if (isNaN(ue[zt]) || isNaN(ue[ne]))
      Xe(ri);
    else {
      const di = Math.abs(ue[zt] - ri[zt]), mt = Math.abs(ue[ne] - ri[ne]);
      (di >= 1 || mt >= 1) && Xe(ri);
    }
  }), Ht = (Ue, {
    animation: Me = !0
  } = {}) => {
    Me ? Dfe(N, jt.current, Ue, {
      duration: r.transitions.duration.standard
    }) : jt.current[N] = Ue;
  }, ii = (Ue) => {
    let Me = jt.current[N];
    L ? Me += Ue : (Me += Ue * (g ? -1 : 1), Me *= g && GQ() === "reverse" ? -1 : 1), Ht(Me);
  }, $t = () => {
    const Ue = jt.current[$];
    let Me = 0;
    const Yt = Array.from(Bt.current.children);
    for (let zt = 0; zt < Yt.length; zt += 1) {
      const ri = Yt[zt];
      if (Me + ri[$] > Ue) {
        zt === 0 && (Me = Ue);
        break;
      }
      Me += ri[$];
    }
    return Me;
  }, ni = () => {
    ii(-1 * $t());
  }, mi = () => {
    ii($t());
  }, Bi = X.useCallback((Ue) => {
    $e({
      overflow: null,
      scrollbarWidth: Ue
    });
  }, []), ci = () => {
    const Ue = {};
    Ue.scrollbarSizeListener = M ? /* @__PURE__ */ ee(eZe, {
      onChange: Bi,
      className: Re(Ve.scrollableX, Ve.hideScrollbar)
    }) : null;
    const Yt = M && (f === "auto" && (Ze || Pe) || f === !0);
    return Ue.scrollButtonStart = Yt ? /* @__PURE__ */ ee(B, F({
      slots: {
        StartScrollButtonIcon: y.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: He
      },
      orientation: p,
      direction: g ? "right" : "left",
      onClick: ni,
      disabled: !Ze
    }, w, {
      className: Re(Ve.scrollButtons, w.className)
    })) : null, Ue.scrollButtonEnd = Yt ? /* @__PURE__ */ ee(B, F({
      slots: {
        EndScrollButtonIcon: y.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: Je
      },
      orientation: p,
      direction: g ? "left" : "right",
      onClick: mi,
      disabled: !Pe
    }, w, {
      className: Re(Ve.scrollButtons, w.className)
    })) : null, Ue;
  }, Ge = Qr((Ue) => {
    const {
      tabsMeta: Me,
      tabMeta: Yt
    } = te();
    if (!(!Yt || !Me)) {
      if (Yt[U] < Me[U]) {
        const zt = Me[N] + (Yt[U] - Me[U]);
        Ht(zt, {
          animation: Ue
        });
      } else if (Yt[O] > Me[O]) {
        const zt = Me[N] + (Yt[O] - Me[O]);
        Ht(zt, {
          animation: Ue
        });
      }
    }
  }), Be = Qr(() => {
    M && f !== !1 && it(!bt);
  });
  X.useEffect(() => {
    const Ue = ym(() => {
      jt.current && Xt();
    });
    let Me;
    const Yt = (di) => {
      di.forEach((mt) => {
        mt.removedNodes.forEach((Ai) => {
          var ui;
          (ui = Me) == null || ui.unobserve(Ai);
        }), mt.addedNodes.forEach((Ai) => {
          var ui;
          (ui = Me) == null || ui.observe(Ai);
        });
      }), Ue(), Be();
    }, zt = Ja(jt.current);
    zt.addEventListener("resize", Ue);
    let ri;
    return typeof ResizeObserver < "u" && (Me = new ResizeObserver(Ue), Array.from(Bt.current.children).forEach((di) => {
      Me.observe(di);
    })), typeof MutationObserver < "u" && (ri = new MutationObserver(Yt), ri.observe(Bt.current, {
      childList: !0
    })), () => {
      var di, mt;
      Ue.clear(), zt.removeEventListener("resize", Ue), (di = ri) == null || di.disconnect(), (mt = Me) == null || mt.disconnect();
    };
  }, [Xt, Be]), X.useEffect(() => {
    const Ue = Array.from(Bt.current.children), Me = Ue.length;
    if (typeof IntersectionObserver < "u" && Me > 0 && M && f !== !1) {
      const Yt = Ue[0], zt = Ue[Me - 1], ri = {
        root: jt.current,
        threshold: 0.99
      }, di = (Ui) => {
        xe(!Ui[0].isIntersecting);
      }, mt = new IntersectionObserver(di, ri);
      mt.observe(Yt);
      const Ai = (Ui) => {
        st(!Ui[0].isIntersecting);
      }, ui = new IntersectionObserver(Ai, ri);
      return ui.observe(zt), () => {
        mt.disconnect(), ui.disconnect();
      };
    }
  }, [M, f, bt, c == null ? void 0 : c.length]), X.useEffect(() => {
    we(!0);
  }, []), X.useEffect(() => {
    Xt();
  }), X.useEffect(() => {
    Ge(Z3 !== ue);
  }, [Ge, ue]), X.useImperativeHandle(a, () => ({
    updateIndicator: Xt,
    updateScrollButtons: Be
  }), [Xt, Be]);
  const qe = /* @__PURE__ */ ee($fe, F({}, V, {
    className: Re(Ve.indicator, V.className),
    ownerState: be,
    style: F({}, ue, V.style)
  }));
  let vt = 0;
  const Kt = X.Children.map(c, (Ue) => {
    if (!/* @__PURE__ */ X.isValidElement(Ue))
      return null;
    const Me = Ue.props.value === void 0 ? vt : Ue.props.value;
    It.set(Me, vt);
    const Yt = Me === H;
    return vt += 1, /* @__PURE__ */ X.cloneElement(Ue, F({
      fullWidth: x === "fullWidth",
      indicator: Yt && !ke && qe,
      selected: Yt,
      selectionFollowsFocus: Z,
      onChange: m,
      textColor: v,
      value: Me
    }, vt === 1 && H === !1 && !Ue.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), Te = (Ue) => {
    const Me = Bt.current, Yt = Vr(Me).activeElement;
    if (Yt.getAttribute("role") !== "tab")
      return;
    let ri = p === "horizontal" ? "ArrowLeft" : "ArrowUp", di = p === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (p === "horizontal" && g && (ri = "ArrowRight", di = "ArrowLeft"), Ue.key) {
      case ri:
        Ue.preventDefault(), TW(Me, Yt, f3);
        break;
      case di:
        Ue.preventDefault(), TW(Me, Yt, B3);
        break;
      case "Home":
        Ue.preventDefault(), TW(Me, null, B3);
        break;
      case "End":
        Ue.preventDefault(), TW(Me, null, f3);
        break;
    }
  }, Tt = ci();
  return /* @__PURE__ */ Ri(jfe, F({
    className: Re(Ve.root, d),
    ownerState: be,
    ref: i,
    as: C
  }, K, {
    children: [Tt.scrollButtonStart, Tt.scrollbarSizeListener, /* @__PURE__ */ Ri(qfe, {
      className: Ve.scroller,
      ownerState: be,
      style: {
        overflow: Qe.overflow,
        [L ? `margin${g ? "Left" : "Right"}` : "marginBottom"]: J ? void 0 : -Qe.scrollbarWidth
      },
      ref: jt,
      children: [/* @__PURE__ */ ee(_fe, {
        "aria-label": o,
        "aria-labelledby": l,
        "aria-orientation": p === "vertical" ? "vertical" : null,
        className: Ve.flexContainer,
        ownerState: be,
        onKeyDown: Te,
        ref: Bt,
        role: "tablist",
        children: Kt
      }), ke && qe]
    }), Tt.scrollButtonEnd]
  }));
});
function iZe(e) {
  return Lt("MuiTextField", e);
}
Dt("MuiTextField", ["root"]);
const nZe = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], rZe = {
  standard: gv,
  filled: AJ,
  outlined: mJ
}, gZe = (e) => {
  const {
    classes: t
  } = e;
  return Mt({
    root: ["root"]
  }, iZe, t);
}, oZe = Se(ja, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), kd = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: r,
    autoFocus: g = !1,
    children: o,
    className: l,
    color: a = "primary",
    defaultValue: I,
    disabled: c = !1,
    error: d = !1,
    FormHelperTextProps: C,
    fullWidth: A = !1,
    helperText: b,
    id: m,
    InputLabelProps: p,
    inputProps: B,
    InputProps: f,
    inputRef: Z,
    label: y,
    maxRows: W,
    minRows: V,
    multiline: w = !1,
    name: v,
    onBlur: H,
    onChange: x,
    onFocus: J,
    placeholder: K,
    required: M = !1,
    rows: L,
    select: N = !1,
    SelectProps: U,
    type: O,
    value: $,
    variant: ne = "outlined"
  } = n, be = tt(n, nZe), Ve = F({}, n, {
    autoFocus: g,
    color: a,
    disabled: c,
    error: d,
    fullWidth: A,
    multiline: w,
    required: M,
    select: N,
    variant: ne
  }), He = gZe(Ve), Je = {};
  ne === "outlined" && (p && typeof p.shrink < "u" && (Je.notched = p.shrink), Je.label = y), N && ((!U || !U.native) && (Je.id = void 0), Je["aria-describedby"] = void 0);
  const ke = uA(m), we = b && ke ? `${ke}-helper-text` : void 0, ue = y && ke ? `${ke}-label` : void 0, Xe = rZe[ne], Ze = /* @__PURE__ */ ee(Xe, F({
    "aria-describedby": we,
    autoComplete: r,
    autoFocus: g,
    defaultValue: I,
    fullWidth: A,
    multiline: w,
    name: v,
    rows: L,
    maxRows: W,
    minRows: V,
    type: O,
    value: $,
    id: ke,
    inputRef: Z,
    onBlur: H,
    onChange: x,
    onFocus: J,
    placeholder: K,
    inputProps: B
  }, Je, f));
  return /* @__PURE__ */ Ri(oZe, F({
    className: Re(He.root, l),
    disabled: c,
    error: d,
    fullWidth: A,
    ref: i,
    required: M,
    color: a,
    variant: ne,
    ownerState: Ve
  }, be, {
    children: [y != null && y !== "" && /* @__PURE__ */ ee(Zj, F({
      htmlFor: ke,
      id: ue
    }, p, {
      children: y
    })), N ? /* @__PURE__ */ ee(ZZ, F({
      "aria-describedby": we,
      id: ke,
      labelId: ue,
      value: $,
      input: Ze
    }, U, {
      children: o
    })) : Ze, b && /* @__PURE__ */ ee(Hf, F({
      id: we
    }, C, {
      children: b
    }))]
  }));
});
function lZe(e) {
  return Lt("MuiToggleButton", e);
}
const Jh = Dt("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), Lj = /* @__PURE__ */ X.createContext({}), Kj = /* @__PURE__ */ X.createContext(void 0);
function aZe(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.indexOf(e) >= 0 : e === t;
}
const sZe = ["value"], IZe = ["children", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "onChange", "onClick", "selected", "size", "value"], cZe = (e) => {
  const {
    classes: t,
    fullWidth: i,
    selected: n,
    disabled: r,
    size: g,
    color: o
  } = e, l = {
    root: ["root", n && "selected", r && "disabled", i && "fullWidth", `size${ve(g)}`, o]
  };
  return Mt(l, lZe, t);
}, dZe = Se(Xo, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [t.root, t[`size${ve(i.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let i = t.color === "standard" ? e.palette.text.primary : e.palette[t.color].main, n;
  return e.vars && (i = t.color === "standard" ? e.vars.palette.text.primary : e.vars.palette[t.color].main, n = t.color === "standard" ? e.vars.palette.text.primaryChannel : e.vars.palette[t.color].mainChannel), F({}, e.typography.button, {
    borderRadius: (e.vars || e).shape.borderRadius,
    padding: 11,
    border: `1px solid ${(e.vars || e).palette.divider}`,
    color: (e.vars || e).palette.action.active
  }, t.fullWidth && {
    width: "100%"
  }, {
    [`&.${Jh.disabled}`]: {
      color: (e.vars || e).palette.action.disabled,
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    },
    "&:hover": {
      textDecoration: "none",
      // Reset on mouse devices
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : uI(e.palette.text.primary, e.palette.action.hoverOpacity),
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    [`&.${Jh.selected}`]: {
      color: i,
      backgroundColor: e.vars ? `rgba(${n} / ${e.vars.palette.action.selectedOpacity})` : uI(i, e.palette.action.selectedOpacity),
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${n} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : uI(i, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: e.vars ? `rgba(${n} / ${e.vars.palette.action.selectedOpacity})` : uI(i, e.palette.action.selectedOpacity)
        }
      }
    }
  }, t.size === "small" && {
    padding: 7,
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && {
    padding: 15,
    fontSize: e.typography.pxToRem(15)
  });
}), lv = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = X.useContext(Lj), {
    value: r
  } = n, g = tt(n, sZe), o = X.useContext(Kj), l = N2(F({}, g, {
    selected: aZe(t.value, r)
  }), t), a = _t({
    props: l,
    name: "MuiToggleButton"
  }), {
    children: I,
    className: c,
    color: d = "standard",
    disabled: C = !1,
    disableFocusRipple: A = !1,
    fullWidth: b = !1,
    onChange: m,
    onClick: p,
    selected: B,
    size: f = "medium",
    value: Z
  } = a, y = tt(a, IZe), W = F({}, a, {
    color: d,
    disabled: C,
    disableFocusRipple: A,
    fullWidth: b,
    size: f
  }), V = cZe(W), w = (H) => {
    p && (p(H, Z), H.defaultPrevented) || m && m(H, Z);
  }, v = o || "";
  return /* @__PURE__ */ ee(dZe, F({
    className: Re(g.className, V.root, c, v),
    disabled: C,
    focusRipple: !A,
    ref: i,
    onClick: w,
    onChange: m,
    value: Z,
    ownerState: W,
    "aria-pressed": B
  }, y, {
    children: I
  }));
});
function uZe(e) {
  return Lt("MuiToggleButtonGroup", e);
}
const $n = Dt("MuiToggleButtonGroup", ["root", "selected", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical", "fullWidth", "firstButton", "lastButton", "middleButton"]), CZe = ["children", "className", "color", "disabled", "exclusive", "fullWidth", "onChange", "orientation", "size", "value"], AZe = (e) => {
  const {
    classes: t,
    orientation: i,
    fullWidth: n,
    disabled: r
  } = e, g = {
    root: ["root", i === "vertical" && "vertical", n && "fullWidth"],
    grouped: ["grouped", `grouped${ve(i)}`, r && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return Mt(g, uZe, t);
}, bZe = Se("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: i
    } = e;
    return [{
      [`& .${$n.grouped}`]: t.grouped
    }, {
      [`& .${$n.grouped}`]: t[`grouped${ve(i.orientation)}`]
    }, {
      [`& .${$n.firstButton}`]: t.firstButton
    }, {
      [`& .${$n.lastButton}`]: t.lastButton
    }, {
      [`& .${$n.middleButton}`]: t.middleButton
    }, t.root, i.orientation === "vertical" && t.vertical, i.fullWidth && t.fullWidth];
  }
})(({
  ownerState: e,
  theme: t
}) => F({
  display: "inline-flex",
  borderRadius: (t.vars || t).shape.borderRadius
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.fullWidth && {
  width: "100%"
}, {
  [`& .${$n.grouped}`]: F({}, e.orientation === "horizontal" ? {
    [`&.${$n.selected} + .${$n.grouped}.${$n.selected}`]: {
      borderLeft: 0,
      marginLeft: 0
    }
  } : {
    [`&.${$n.selected} + .${$n.grouped}.${$n.selected}`]: {
      borderTop: 0,
      marginTop: 0
    }
  })
}, e.orientation === "horizontal" ? {
  [`& .${$n.firstButton},& .${$n.middleButton}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${$n.lastButton},& .${$n.middleButton}`]: {
    marginLeft: -1,
    borderLeft: "1px solid transparent",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
} : {
  [`& .${$n.firstButton},& .${$n.middleButton}`]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${$n.lastButton},& .${$n.middleButton}`]: {
    marginTop: -1,
    borderTop: "1px solid transparent",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }
}, e.orientation === "horizontal" ? {
  [`& .${$n.lastButton}.${Jh.disabled},& .${$n.middleButton}.${Jh.disabled}`]: {
    borderLeft: "1px solid transparent"
  }
} : {
  [`& .${$n.lastButton}.${Jh.disabled},& .${$n.middleButton}.${Jh.disabled}`]: {
    borderTop: "1px solid transparent"
  }
})), BJ = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = _t({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: r,
    className: g,
    color: o = "standard",
    disabled: l = !1,
    exclusive: a = !1,
    fullWidth: I = !1,
    onChange: c,
    orientation: d = "horizontal",
    size: C = "medium",
    value: A
  } = n, b = tt(n, CZe), m = F({}, n, {
    disabled: l,
    fullWidth: I,
    orientation: d,
    size: C
  }), p = AZe(m), B = X.useCallback((w, v) => {
    if (!c)
      return;
    const H = A && A.indexOf(v);
    let x;
    A && H >= 0 ? (x = A.slice(), x.splice(H, 1)) : x = A ? A.concat(v) : [v], c(w, x);
  }, [c, A]), f = X.useCallback((w, v) => {
    c && c(w, A === v ? null : v);
  }, [c, A]), Z = X.useMemo(() => ({
    className: p.grouped,
    onChange: a ? f : B,
    value: A,
    size: C,
    fullWidth: I,
    color: o,
    disabled: l
  }), [p.grouped, a, f, B, A, C, I, o, l]), y = yQ(r), W = y.length, V = (w) => {
    const v = w === 0, H = w === W - 1;
    return v && H ? "" : v ? p.firstButton : H ? p.lastButton : p.middleButton;
  };
  return /* @__PURE__ */ ee(bZe, F({
    role: "group",
    className: Re(p.root, g),
    ref: i,
    ownerState: m
  }, b, {
    children: /* @__PURE__ */ ee(Lj.Provider, {
      value: Z,
      children: y.map((w, v) => /* @__PURE__ */ ee(Kj.Provider, {
        value: V(v),
        children: w
      }, v))
    })
  }));
});
var hZe = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, mZe = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, pZe = function(t) {
  return mZe[t];
}, BZe = function(t) {
  return t.replace(hZe, pZe);
};
function G3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function y3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G3(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : G3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var Sx = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: BZe
}, Tj, fZe = Ua();
function ZZe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Sx = y3(y3({}, Sx), e);
}
function GZe() {
  return Sx;
}
var yZe = function() {
  function e() {
    Js(this, e), this.usedNamespaces = {};
  }
  return Es(e, [{
    key: "addUsedNamespaces",
    value: function(i) {
      var n = this;
      i.forEach(function(r) {
        n.usedNamespaces[r] || (n.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}();
function WZe(e) {
  Tj = e;
}
function SZe() {
  return Tj;
}
var VZe = {
  type: "3rdParty",
  init: function(t) {
    ZZe(t.options.react), WZe(t);
  }
};
function wZe() {
  if (console && console.warn) {
    for (var e, t = arguments.length, i = new Array(t), n = 0; n < t; n++)
      i[n] = arguments[n];
    typeof i[0] == "string" && (i[0] = "react-i18next:: ".concat(i[0])), (e = console).warn.apply(e, i);
  }
}
var W3 = {};
function Vx() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  typeof t[0] == "string" && W3[t[0]] || (typeof t[0] == "string" && (W3[t[0]] = /* @__PURE__ */ new Date()), wZe.apply(void 0, t));
}
function S3(e, t, i) {
  e.loadNamespaces(t, function() {
    if (e.isInitialized)
      i();
    else {
      var n = function r() {
        setTimeout(function() {
          e.off("initialized", r);
        }, 0), i();
      };
      e.on("initialized", n);
    }
  });
}
function vZe(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = t.languages[0], r = t.options ? t.options.fallbackLng : !1, g = t.languages[t.languages.length - 1];
  if (n.toLowerCase() === "cimode")
    return !0;
  var o = function(a, I) {
    var c = t.services.backendConnector.state["".concat(a, "|").concat(I)];
    return c === -1 || c === 2;
  };
  return i.bindI18n && i.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !o(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(n, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || o(n, e) && (!r || o(g, e)));
}
function RZe(e, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return Vx("i18n.languages were undefined or empty", t.languages), !0;
  var n = t.options.ignoreJSONStructure !== void 0;
  return n ? t.hasLoadedNamespace(e, {
    precheck: function(g, o) {
      if (i.bindI18n && i.bindI18n.indexOf("languageChanging") > -1 && g.services.backendConnector.backend && g.isLanguageChangingTo && !o(g.isLanguageChangingTo, e))
        return !1;
    }
  }) : vZe(e, t, i);
}
function XZe(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n, r, g, o, l = [], a = !0, I = !1;
    try {
      if (g = (i = i.call(e)).next, t !== 0)
        for (; !(a = (n = g.call(i)).done) && (l.push(n.value), l.length !== t); a = !0)
          ;
    } catch (c) {
      I = !0, r = c;
    } finally {
      try {
        if (!a && i.return != null && (o = i.return(), Object(o) !== o))
          return;
      } finally {
        if (I)
          throw r;
      }
    }
    return l;
  }
}
function HZe(e, t) {
  return U4(e) || XZe(e, t) || z4(e, t) || O4();
}
function V3(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function dY(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? V3(Object(i), !0).forEach(function(n) {
      XI(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : V3(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
var kZe = function(t, i) {
  var n = ot();
  return lt(function() {
    n.current = t;
  }, [t, i]), n.current;
};
function Gi(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = t.i18n, n = Vn(fZe) || {}, r = n.i18n, g = n.defaultNS, o = i || r || SZe();
  if (o && !o.reportNamespaces && (o.reportNamespaces = new yZe()), !o) {
    Vx("You will need to pass in an i18next instance by using initReactI18next");
    var l = function(H) {
      return Array.isArray(H) ? H[H.length - 1] : H;
    }, a = [l, {}, !1];
    return a.t = l, a.i18n = {}, a.ready = !1, a;
  }
  o.options.react && o.options.react.wait !== void 0 && Vx("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var I = dY(dY(dY({}, GZe()), o.options.react), t), c = I.useSuspense, d = I.keyPrefix, C = g || o.options && o.options.defaultNS;
  C = typeof C == "string" ? [C] : C || ["translation"], o.reportNamespaces.addUsedNamespaces && o.reportNamespaces.addUsedNamespaces(C);
  var A = (o.isInitialized || o.initializedStoreOnce) && C.every(function(v) {
    return RZe(v, o, I);
  });
  function b() {
    return o.getFixedT(null, I.nsMode === "fallback" ? C : C[0], d);
  }
  var m = wt(b), p = HZe(m, 2), B = p[0], f = p[1], Z = C.join(), y = kZe(Z), W = ot(!0);
  lt(function() {
    var v = I.bindI18n, H = I.bindI18nStore;
    W.current = !0, !A && !c && S3(o, C, function() {
      W.current && f(b);
    }), A && y && y !== Z && W.current && f(b);
    function x() {
      W.current && f(b);
    }
    return v && o && o.on(v, x), H && o && o.store.on(H, x), function() {
      W.current = !1, v && o && v.split(" ").forEach(function(J) {
        return o.off(J, x);
      }), H && o && H.split(" ").forEach(function(J) {
        return o.store.off(J, x);
      });
    };
  }, [o, Z]);
  var V = ot(!0);
  lt(function() {
    W.current && !V.current && f(b), V.current = !1;
  }, [o, d]);
  var w = [B, o, A];
  if (w.t = B, w.i18n = o, w.ready = A, A || !A && !c)
    return w;
  throw new Promise(function(v) {
    S3(o, C, function() {
      v();
    });
  });
}
function fJ() {
  const {
    t: e
  } = Gi();
  return /* @__PURE__ */ S(Xd, { "data-cy": "supportForm", href: "mailto:support@objectcode.de", target: "_blank", children: /* @__PURE__ */ S(Ct, { children: e("Sie können uns den Vorfall hier melden!") }) });
}
Ax.__MUI_LICENSE_INFO__ = Ax.__MUI_LICENSE_INFO__ || {
  key: void 0
};
class ew {
  static getLicenseInfo() {
    return Ax.__MUI_LICENSE_INFO__;
  }
  static getLicenseKey() {
    return ew.getLicenseInfo().key;
  }
  static setLicenseKey(t) {
    const i = ew.getLicenseInfo();
    i.key = t;
  }
}
function Mj(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (i = Mj(e[t])) && (n && (n += " "), n += i);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function Ag() {
  for (var e, t, i = 0, n = ""; i < arguments.length; )
    (e = arguments[i++]) && (t = Mj(e)) && (n && (n += " "), n += t);
  return n;
}
const YZe = {
  components: {
    MuiBreadcrumbs: {
      defaultProps: {
        expandText: "Pfad anzeigen"
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (e) => e === "first" ? "Zur ersten Seite" : e === "last" ? "Zur letzten Seite" : e === "next" ? "Zur nächsten Seite" : "Zur vorherigen Seite",
        labelRowsPerPage: "Zeilen pro Seite:",
        labelDisplayedRows: ({
          from: e,
          to: t,
          count: i
        }) => `${e}–${t} von ${i !== -1 ? i : `mehr als ${t}`}`
      }
    },
    MuiRating: {
      defaultProps: {
        getLabelText: (e) => `${e} ${e !== 1 ? "Sterne" : "Stern"}`,
        emptyLabelText: "Keine Wertung"
      }
    },
    MuiAutocomplete: {
      defaultProps: {
        clearText: "Leeren",
        closeText: "Schließen",
        loadingText: "Wird geladen…",
        noOptionsText: "Keine Optionen",
        openText: "Öffnen"
      }
    },
    MuiAlert: {
      defaultProps: {
        closeText: "Schließen"
      }
    },
    MuiPagination: {
      defaultProps: {
        "aria-label": "Navigation via Seitennummerierung",
        getItemAriaLabel: (e, t, i) => e === "page" ? `${i ? "" : "Gehe zu "}Seite ${t}` : e === "first" ? "Zur ersten Seite" : e === "last" ? "Zur letzten Seite" : e === "next" ? "Zur nächsten Seite" : "Zur vorherigen Seite"
      }
    }
  }
}, k7t = {
  /*
  components: {
    MuiBreadcrumbs: { defaultProps: {
      expandText: 'Show path',
    }},
    MuiTablePagination: { defaultProps: {
      getItemAriaLabel: (type) => {
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
      labelRowsPerPage: 'Rows per page:',
      labelDisplayedRows: ({ from, to, count }) =>
  `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
    }},
    MuiRating: { defaultProps: {
      getLabelText: value => `${value} Star${value !== 1 ? 's' : ''}`,
      emptyLabelText: 'Empty',
    }},
    MuiAutocomplete: { defaultProps: {
      clearText: 'Clear',
      closeText: 'Close',
      loadingText: 'Loading…',
      noOptionsText: 'No options',
      openText: 'Open',
    }},
    MuiAlert: { defaultProps: {
      closeText: 'Close',
    }},
    MuiPagination: {  defaultProps: {
      'aria-label': 'Pagination navigation',
      getItemAriaLabel: (type, page, selected) => {
        if (type === 'page') {
          return `${selected ? '' : 'Go to '}page ${page}`;
        }
        if (type === 'first') {
          return 'Go to first page';
        }
        if (type === 'last') {
          return 'Go to last page';
        }
        if (type === 'next') {
          return 'Go to next page';
        }
        // if (type === 'previous') {
        return 'Go to previous page';
      },
    }},
  },
  */
}, FZe = (e, t) => {
  var i, n;
  return {
    components: {
      MuiDataGrid: {
        defaultProps: {
          localeText: et({}, e, {
            MuiTablePagination: (t == null || (i = t.components) == null || (n = i.MuiTablePagination) == null ? void 0 : n.defaultProps) || {}
          })
        }
      }
    }
  };
}, xZe = {
  // Root
  noRowsLabel: "Keine Einträge",
  noResultsOverlayLabel: "Keine Ergebnisse gefunden.",
  errorOverlayDefaultLabel: "Ein unerwarteter Fehler ist aufgetreten.",
  // Density selector toolbar button text
  toolbarDensity: "Zeilenhöhe",
  toolbarDensityLabel: "Zeilenhöhe",
  toolbarDensityCompact: "Kompakt",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Breit",
  // Columns selector toolbar button text
  toolbarColumns: "Spalten",
  toolbarColumnsLabel: "Zeige Spaltenauswahl",
  // Filters toolbar button text
  toolbarFilters: "Filter",
  toolbarFiltersLabel: "Zeige Filter",
  toolbarFiltersTooltipHide: "Verberge Filter",
  toolbarFiltersTooltipShow: "Zeige Filter",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} aktive Filter` : `${e} aktiver Filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Suchen…",
  toolbarQuickFilterLabel: "Suchen",
  toolbarQuickFilterDeleteIconLabel: "Löschen",
  // Export selector toolbar button text
  toolbarExport: "Exportieren",
  toolbarExportLabel: "Exportieren",
  toolbarExportCSV: "Download als CSV",
  toolbarExportPrint: "Drucken",
  toolbarExportExcel: "Download als Excel",
  // Columns panel text
  columnsPanelTextFieldLabel: "Finde Spalte",
  columnsPanelTextFieldPlaceholder: "Spaltenüberschrift",
  columnsPanelDragIconLabel: "Spalte umsortieren",
  columnsPanelShowAllButton: "Zeige alle",
  columnsPanelHideAllButton: "Verberge alle",
  // Filter panel text
  filterPanelAddFilter: "Filter hinzufügen",
  filterPanelDeleteIconLabel: "Löschen",
  filterPanelLinkOperator: "Logische Operatoren",
  filterPanelOperators: "Operatoren",
  // TODO v6: rename to filterPanelOperator
  filterPanelOperatorAnd: "Und",
  filterPanelOperatorOr: "Oder",
  filterPanelColumns: "Spalten",
  filterPanelInputLabel: "Wert",
  filterPanelInputPlaceholder: "Wert filtern",
  // Filter operators text
  filterOperatorContains: "enthält",
  filterOperatorEquals: "ist gleich",
  filterOperatorStartsWith: "beginnt mit",
  filterOperatorEndsWith: "endet mit",
  filterOperatorIs: "ist",
  filterOperatorNot: "ist nicht",
  filterOperatorAfter: "ist nach",
  filterOperatorOnOrAfter: "ist am oder nach",
  filterOperatorBefore: "ist vor",
  filterOperatorOnOrBefore: "ist am oder vor",
  filterOperatorIsEmpty: "ist leer",
  filterOperatorIsNotEmpty: "ist nicht leer",
  filterOperatorIsAnyOf: "ist einer der Werte",
  // Filter values text
  filterValueAny: "Beliebig",
  filterValueTrue: "Ja",
  filterValueFalse: "Nein",
  // Column menu text
  columnMenuLabel: "Menü",
  columnMenuShowColumns: "Zeige alle Spalten",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Verbergen",
  columnMenuUnsort: "Sortierung deaktivieren",
  columnMenuSortAsc: "Sortiere aufsteigend",
  columnMenuSortDesc: "Sortiere absteigend",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} aktive Filter` : `${e} aktiver Filter`,
  columnHeaderFiltersLabel: "Zeige Filter",
  columnHeaderSortIconLabel: "Sortieren",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} Einträge ausgewählt` : `${e.toLocaleString()} Eintrag ausgewählt`,
  // Total row amount footer text
  footerTotalRows: "Gesamt:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} von ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox Auswahl",
  checkboxSelectionSelectAllRows: "Alle Zeilen auswählen",
  checkboxSelectionUnselectAllRows: "Alle Zeilen abwählen",
  checkboxSelectionSelectRow: "Zeile auswählen",
  checkboxSelectionUnselectRow: "Zeile abwählen",
  // Boolean cell text
  booleanCellTrueLabel: "Ja",
  booleanCellFalseLabel: "Nein",
  // Actions cell more text
  actionsCellMore: "Mehr",
  // Column pinning text
  pinToLeft: "Links anheften",
  pinToRight: "Rechts anheften",
  unpin: "Loslösen",
  // Tree Data
  treeDataGroupingHeaderName: "Gruppe",
  treeDataExpand: "Kinder einblenden",
  treeDataCollapse: "Kinder ausblenden",
  // Grouping columns
  groupingColumnHeaderName: "Gruppierung",
  groupColumn: (e) => `Gruppieren nach ${e}`,
  unGroupColumn: (e) => `Gruppierung nach ${e} aufheben`,
  // Master/detail
  detailPanelToggle: "Detailansicht Kippschalter",
  expandDetailPanel: "Aufklappen",
  collapseDetailPanel: "Zuklappen",
  // Row reordering text
  rowReorderingHeaderName: "Reihen neu ordnen",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "Summe",
  aggregationFunctionLabelAvg: "Mittelwert",
  aggregationFunctionLabelMin: "Minimum",
  aggregationFunctionLabelMax: "Maximum",
  aggregationFunctionLabelSize: "Anzahl"
}, ZJ = FZe(xZe, YZe);
function tA(e) {
  "@babel/helpers - typeof";
  return tA = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, tA(e);
}
function DZe(e, t) {
  if (tA(e) != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t || "default");
    if (tA(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Pj(e) {
  var t = DZe(e, "string");
  return tA(t) == "symbol" ? t : t + "";
}
const {
  palette: JZe,
  shape: {
    borderRadius: w3
  }
} = Sm(), GJ = {
  // all corners are softer
  shape: {
    borderRadius: w3 * 2
  },
  // Darkblue #041F4E, yellow #F3FA0A, purple #A800DD
  palette: {
    primary: {
      main: "#00A4DD",
      contrastText: "#FFF"
    },
    secondary: {
      main: "#EE7373",
      contrastText: "#FFF"
    },
    warning: {
      main: "#FFC113",
      contrastText: "#FFF"
    },
    error: {
      main: "#EE7373",
      contrastText: "#FFF"
    },
    info: {
      main: "#00A4DD",
      contrastText: "#FFF"
    },
    //73EEEE
    text: {
      primary: "#000",
      secondary: "#555"
    },
    success: {
      main: "#36DD00",
      contrastText: "#FFF"
    },
    mode: "light",
    editor: {
      main: _4[800],
      contrastText: "#fff"
    },
    // background: {default: "#FFF", paper: "#00A4DD"},
    content: {
      main: "#ffffff"
    },
    scrollbar: {
      default: "lightgrey"
    }
    // contrastThreshold: 2.7, <= This causes MUI contrast console errors. But fixed contrast Text removes Auto Update Options on Custom Theme Col Change
  },
  components: {
    MuiTooltip: {
      defaultProps: {
        disableInteractive: !0
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
        // disable ripple in entire app 💣!
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "auto",
          borderRadius: w3
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none"
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          height: "100%",
          alignItems: "start"
        },
        content: {
          width: "100%"
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          justifyContent: "space-between"
        }
      }
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          color: JZe.primary.main
        }
      }
    },
    MuiCard: {
      defaultProps: {
        raised: !0
      }
    }
  },
  typography: {
    fontFamily: ["Nunito Sans", "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"].join(",")
  }
}, EZe = Sm(pg(GJ, {
  palette: {
    primary: {
      main: "#00A4DD"
    }
  }
}), ZJ), NZe = Sm(pg(GJ, {
  palette: {
    mode: "dark"
  },
  text: {
    primary: "#FFF",
    secondary: "#AFAFAF"
  }
}), ZJ), Uj = _D(EZe);
_D(NZe);
class $d extends De.Component {
  constructor(i) {
    super(i);
    // E.g. API Calls that fail
    Qi(this, "onUnhandledRejection", (i) => {
      i.promise.catch((n) => {
        console.error(this.name + ": Unhandled Rejection occured:", n), this.setState($d.getDerivedStateFromError(n, "unhandledRejection"));
      }), i.stopImmediatePropagation(), i.stopPropagation();
    });
    this.state = {
      error: null,
      errorType: void 0
    }, this.handleCloseError = this.handleCloseError.bind(this);
  }
  // Can be automatically called by React without a default Error Type
  static getDerivedStateFromError(i, n = "childComponent") {
    return {
      error: i,
      errorType: n
    };
  }
  get name() {
    return this.constructor.name || $d.name;
  }
  componentDidMount() {
    this.catchUnhandledRejectionErrors && window.addEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentWillUnmount() {
    this.catchUnhandledRejectionErrors && window.removeEventListener("unhandledrejection", this.onUnhandledRejection);
  }
  componentDidCatch(i, n) {
    console.error(this.name + ": Unexpected component error occurred:", i, n);
  }
  handleCloseError() {
    this.setState({
      error: null,
      errorType: void 0
    });
  }
  render() {
    return this.state.error ? this.renderError(this.state.error, this.state.errorType) : this.props.children;
  }
}
class LZe extends $d {
  constructor() {
    super(...arguments);
    // Should be handled by TopLevel and FrontendTopLevel Boundaries. If these fail, it will be a component Type Error
    Qi(this, "catchUnhandledRejectionErrors", !1);
  }
  renderError() {
    const i = document.location.href.includes("/admin/") || document.location.href.endsWith("/admin"), n = i ? document.location.protocol + document.location.hostname + document.location.pathname + "#/admin/apps" : "";
    return /* @__PURE__ */ S("div", { id: "k3-global-error-container", style: {
      width: "100%",
      height: "100%"
    }, children: /* @__PURE__ */ S(LQ, { theme: Uj, children: /* @__PURE__ */ Ie("div", { style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    }, children: [
      /* @__PURE__ */ Ie("div", { style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ S("a", { "aria-label": "Home-Link", "data-cy": "Error-GoHome", href: "https://www.objectcode.de/", children: /* @__PURE__ */ S("img", { alt: "k3 Logo", style: {
          height: "140px",
          width: "auto"
        }, src: "https://www.objectcode.de/wp-content/uploads/2024/03/logo_blue-1174x1536.png" }) }),
        /* @__PURE__ */ Ie("div", { style: {
          paddingLeft: "24px"
        }, children: [
          /* @__PURE__ */ S(Ct, { variant: "h3", color: "error", children: Ug("Fatal_Error") }),
          /* @__PURE__ */ Ie("div", { children: [
            /* @__PURE__ */ S(Ct, { variant: "subtitle1", children: Ug("Fatal_Error_Text") }),
            /* @__PURE__ */ S(fJ, {})
          ] })
        ] })
      ] }),
      i && /* @__PURE__ */ S("div", { style: {
        display: "flex",
        justifyContent: "end"
      }, children: /* @__PURE__ */ S(fn, { onClick: () => document.location.href = n, "data-cy": "errorGoStart", variant: "contained", children: Ug("Zur Startseite") }) })
    ] }) }) });
  }
}
const KZe = {
  zIndex: (e) => {
    var t;
    return (((t = e.zIndex) == null ? void 0 : t.modal) ?? 0) + 1;
  },
  color: "#fff",
  display: "flex",
  flexDirection: "column"
};
function zj({
  loading: e,
  delay: t = 500
}) {
  const [i, n] = wt(!1);
  return lt(() => {
    if (!e)
      return;
    const r = setTimeout(() => n(!0), t);
    return () => {
      clearTimeout(r), n(!1);
    };
  }, [e, t]), e && i ? /* @__PURE__ */ S(iv, { sx: KZe, open: e, "data-cy": "CircularProgress", children: /* @__PURE__ */ S(hj, { color: "inherit", size: 200 }) }) : null;
}
const GZ = (e) => e.instance.isInstanceLauncher === !1 && e.id !== e.instance.id, mg = (e) => e.instance.isInstanceLauncher === !0 && e.id === e.instance.id, TZe = (e) => e.instance.belongsToVariableId === null, Oj = (e, t) => GZ(t) ? e.id === t.instance.id : mg(t) ? e.id === t.instance.belongsToInstanceId : !1, qa = (e) => {
  if (e)
    return GZ(e) ? e.instance.id : mg(e) ? e.instance.belongsToInstanceId : void 0;
}, iA = (e, t) => GZ(t) ? e.find((i) => i.id === t.instance.id) : mg(t) ? e.find((i) => i.id === t.instance.belongsToInstanceId) : void 0, MZe = (e, t) => GZ(t) ? e[t.instance.id] : mg(t) ? e[t.instance.belongsToInstanceId] : void 0, PZe = (e, t) => {
  let i = t;
  const n = [];
  for (; i; )
    i = MZe(e, i), i && n.push(i);
  return n;
}, yZ = (e) => [Ut, ...e.filter((t) => t.instance.isInstanceLauncher)], vm = (e, t, i) => {
  const n = [];
  let r = t;
  for (; r; )
    r = (i || e).find((g) => g.instance.isInstanceLauncher && (r && mg(r) ? g.instance.id === (r == null ? void 0 : r.instance.belongsToInstanceId) : g.instance.id === (r == null ? void 0 : r.instance.id)) && g.id !== (r == null ? void 0 : r.id)), r && n.push(r);
  return t.id && n.push(Ut), n;
}, nA = (e, t, i) => {
  const n = i || e.filter((o) => o.instance.isInstanceLauncher), r = [...t ? [t] : [Ut]], g = [];
  for (; r.length > 0; ) {
    const o = r.pop();
    for (const l of n)
      l.instance.belongsToInstanceId === o.instance.id && l.id !== o.id && (g.push(l), r.push(l));
  }
  return g;
}, WZ = (e, t, i) => {
  const n = (t.instance.isInstanceLauncher ? t : (i || e).find((o) => o.instance.isInstanceLauncher && o.instance.id === t.instance.id)) || Ut, r = nA(e, n, i);
  return [...vm(e, n, i), n, ...r];
};
var tw = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
tw.exports;
(function(e, t) {
  (function() {
    var i, n = "4.17.21", r = 200, g = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", l = "Invalid `variable` option passed into `_.template`", a = "__lodash_hash_undefined__", I = 500, c = "__lodash_placeholder__", d = 1, C = 2, A = 4, b = 1, m = 2, p = 1, B = 2, f = 4, Z = 8, y = 16, W = 32, V = 64, w = 128, v = 256, H = 512, x = 30, J = "...", K = 800, M = 16, L = 1, N = 2, U = 3, O = 1 / 0, $ = 9007199254740991, ne = 17976931348623157e292, be = NaN, Ve = 4294967295, He = Ve - 1, Je = Ve >>> 1, ke = [
      ["ary", w],
      ["bind", p],
      ["bindKey", B],
      ["curry", Z],
      ["curryRight", y],
      ["flip", H],
      ["partial", W],
      ["partialRight", V],
      ["rearg", v]
    ], we = "[object Arguments]", ue = "[object Array]", Xe = "[object AsyncFunction]", Ze = "[object Boolean]", xe = "[object Date]", Pe = "[object DOMException]", st = "[object Error]", bt = "[object Function]", it = "[object GeneratorFunction]", Qe = "[object Map]", $e = "[object Number]", It = "[object Null]", jt = "[object Object]", Bt = "[object Promise]", te = "[object Proxy]", Xt = "[object RegExp]", Ht = "[object Set]", ii = "[object String]", $t = "[object Symbol]", ni = "[object Undefined]", mi = "[object WeakMap]", Bi = "[object WeakSet]", ci = "[object ArrayBuffer]", Ge = "[object DataView]", Be = "[object Float32Array]", qe = "[object Float64Array]", vt = "[object Int8Array]", Kt = "[object Int16Array]", Te = "[object Int32Array]", Tt = "[object Uint8Array]", Ue = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", Yt = "[object Uint32Array]", zt = /\b__p \+= '';/g, ri = /\b(__p \+=) '' \+/g, di = /(__e\(.*?\)|\b__t\)) \+\n'';/g, mt = /&(?:amp|lt|gt|quot|#39);/g, Ai = /[&<>"']/g, ui = RegExp(mt.source), Ui = RegExp(Ai.source), Oi = /<%-([\s\S]+?)%>/g, Rn = /<%([\s\S]+?)%>/g, le = /<%=([\s\S]+?)%>/g, Ce = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pe = /^\w*$/, Ne = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ke = /[\\^$.*+?()[\]{}|]/g, Jt = RegExp(Ke.source), Rt = /^\s+/, Zt = /\s/, Et = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, dt = /\{\n\/\* \[wrapped with (.+)\] \*/, xt = /,? & /, Ot = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, si = /[()=,{}\[\]\/\s]/, Li = /\\(\\)?/g, fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ae = /\w*$/, gt = /^[-+]0x[0-9a-f]+$/i, _e = /^0b[01]+$/i, Qt = /^\[object .+?Constructor\]$/, kt = /^0o[0-7]+$/i, ti = /^(?:0|[1-9]\d*)$/, tn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ao = /($^)/, Nr = /['\n\r\u2028\u2029\\]/g, vg = "\\ud800-\\udfff", es = "\\u0300-\\u036f", tg = "\\ufe20-\\ufe2f", Xi = "\\u20d0-\\u20ff", bn = es + tg + Xi, so = "\\u2700-\\u27bf", bl = "a-z\\xdf-\\xf6\\xf8-\\xff", hn = "\\xac\\xb1\\xd7\\xf7", hl = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ia = "\\u2000-\\u206f", ml = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", xc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Dc = "\\ufe0e\\ufe0f", NI = hn + hl + ia + ml, LI = "['’]", Gu = "[" + vg + "]", Jc = "[" + NI + "]", Ps = "[" + bn + "]", KI = "\\d+", yu = "[" + so + "]", Wu = "[" + bl + "]", Su = "[^" + vg + NI + KI + so + bl + xc + "]", Vu = "\\ud83c[\\udffb-\\udfff]", Ec = "(?:" + Ps + "|" + Vu + ")", Nc = "[^" + vg + "]", wu = "(?:\\ud83c[\\udde6-\\uddff]){2}", vu = "[\\ud800-\\udbff][\\udc00-\\udfff]", Us = "[" + xc + "]", Ru = "\\u200d", Lc = "(?:" + Wu + "|" + Su + ")", Kc = "(?:" + Us + "|" + Su + ")", xA = "(?:" + LI + "(?:d|ll|m|re|s|t|ve))?", Xu = "(?:" + LI + "(?:D|LL|M|RE|S|T|VE))?", TI = Ec + "?", ts = "[" + Dc + "]?", Hu = "(?:" + Ru + "(?:" + [Nc, wu, vu].join("|") + ")" + ts + TI + ")*", op = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ku = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", DA = ts + TI + Hu, lp = "(?:" + [yu, wu, vu].join("|") + ")" + DA, JA = "(?:" + [Nc + Ps + "?", Ps, wu, vu, Gu].join("|") + ")", Yu = RegExp(LI, "g"), ap = RegExp(Ps, "g"), Fu = RegExp(Vu + "(?=" + Vu + ")|" + JA + DA, "g"), na = RegExp([
      Us + "?" + Wu + "+" + xA + "(?=" + [Jc, Us, "$"].join("|") + ")",
      Kc + "+" + Xu + "(?=" + [Jc, Us + Lc, "$"].join("|") + ")",
      Us + "?" + Lc + "+" + xA,
      Us + "+" + Xu,
      ku,
      op,
      KI,
      lp
    ].join("|"), "g"), sp = RegExp("[" + Ru + vg + bn + Dc + "]"), Ip = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, cp = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], dp = -1, ki = {};
    ki[Be] = ki[qe] = ki[vt] = ki[Kt] = ki[Te] = ki[Tt] = ki[Ue] = ki[Me] = ki[Yt] = !0, ki[we] = ki[ue] = ki[ci] = ki[Ze] = ki[Ge] = ki[xe] = ki[st] = ki[bt] = ki[Qe] = ki[$e] = ki[jt] = ki[Xt] = ki[Ht] = ki[ii] = ki[mi] = !1;
    var D = {};
    D[we] = D[ue] = D[ci] = D[Ge] = D[Ze] = D[xe] = D[Be] = D[qe] = D[vt] = D[Kt] = D[Te] = D[Qe] = D[$e] = D[jt] = D[Xt] = D[Ht] = D[ii] = D[$t] = D[Tt] = D[Ue] = D[Me] = D[Yt] = !0, D[st] = D[bt] = D[mi] = !1;
    var z = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _ = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, q = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, se = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, he = parseFloat, Ye = parseInt, at = typeof Or == "object" && Or && Or.Object === Object && Or, je = typeof self == "object" && self && self.Object === Object && self, pt = at || je || Function("return this")(), Ft = t && !t.nodeType && t, qt = Ft && !0 && e && !e.nodeType && e, Wt = qt && qt.exports === Ft, yi = Wt && at.process, Zi = function() {
      try {
        var P = qt && qt.require && qt.require("util").types;
        return P || yi && yi.binding && yi.binding("util");
      } catch {
      }
    }(), Yn = Zi && Zi.isArrayBuffer, gi = Zi && Zi.isDate, Yi = Zi && Zi.isMap, dr = Zi && Zi.isRegExp, On = Zi && Zi.isSet, ur = Zi && Zi.isTypedArray;
    function nn(P, re, Y) {
      switch (Y.length) {
        case 0:
          return P.call(re);
        case 1:
          return P.call(re, Y[0]);
        case 2:
          return P.call(re, Y[0], Y[1]);
        case 3:
          return P.call(re, Y[0], Y[1], Y[2]);
      }
      return P.apply(re, Y);
    }
    function MI(P, re, Y, Ee) {
      for (var ct = -1, ut = P == null ? 0 : P.length; ++ct < ut; ) {
        var qi = P[ct];
        re(Ee, qi, Y(qi), P);
      }
      return Ee;
    }
    function Lr(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee && re(P[Y], Y, P) !== !1; )
        ;
      return P;
    }
    function EA(P, re) {
      for (var Y = P == null ? 0 : P.length; Y-- && re(P[Y], Y, P) !== !1; )
        ;
      return P;
    }
    function NA(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee; )
        if (!re(P[Y], Y, P))
          return !1;
      return !0;
    }
    function zs(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length, ct = 0, ut = []; ++Y < Ee; ) {
        var qi = P[Y];
        re(qi, Y, P) && (ut[ct++] = qi);
      }
      return ut;
    }
    function xu(P, re) {
      var Y = P == null ? 0 : P.length;
      return !!Y && Tc(P, re, 0) > -1;
    }
    function Du(P, re, Y) {
      for (var Ee = -1, ct = P == null ? 0 : P.length; ++Ee < ct; )
        if (Y(re, P[Ee]))
          return !0;
      return !1;
    }
    function Xn(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length, ct = Array(Ee); ++Y < Ee; )
        ct[Y] = re(P[Y], Y, P);
      return ct;
    }
    function Io(P, re) {
      for (var Y = -1, Ee = re.length, ct = P.length; ++Y < Ee; )
        P[ct + Y] = re[Y];
      return P;
    }
    function LA(P, re, Y, Ee) {
      var ct = -1, ut = P == null ? 0 : P.length;
      for (Ee && ut && (Y = P[++ct]); ++ct < ut; )
        Y = re(Y, P[ct], ct, P);
      return Y;
    }
    function VG(P, re, Y, Ee) {
      var ct = P == null ? 0 : P.length;
      for (Ee && ct && (Y = P[--ct]); ct--; )
        Y = re(Y, P[ct], ct, P);
      return Y;
    }
    function up(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee; )
        if (re(P[Y], Y, P))
          return !0;
      return !1;
    }
    var wG = bp("length");
    function vG(P) {
      return P.split("");
    }
    function RG(P) {
      return P.match(Ot) || [];
    }
    function Cp(P, re, Y) {
      var Ee;
      return Y(P, function(ct, ut, qi) {
        if (re(ct, ut, qi))
          return Ee = ut, !1;
      }), Ee;
    }
    function KA(P, re, Y, Ee) {
      for (var ct = P.length, ut = Y + (Ee ? 1 : -1); Ee ? ut-- : ++ut < ct; )
        if (re(P[ut], ut, P))
          return ut;
      return -1;
    }
    function Tc(P, re, Y) {
      return re === re ? JG(P, re, Y) : KA(P, Ap, Y);
    }
    function rR(P, re, Y, Ee) {
      for (var ct = Y - 1, ut = P.length; ++ct < ut; )
        if (Ee(P[ct], re))
          return ct;
      return -1;
    }
    function Ap(P) {
      return P !== P;
    }
    function XG(P, re) {
      var Y = P == null ? 0 : P.length;
      return Y ? pp(P, re) / Y : be;
    }
    function bp(P) {
      return function(re) {
        return re == null ? i : re[P];
      };
    }
    function hp(P) {
      return function(re) {
        return P == null ? i : P[re];
      };
    }
    function HG(P, re, Y, Ee, ct) {
      return ct(P, function(ut, qi, sn) {
        Y = Ee ? (Ee = !1, ut) : re(Y, ut, qi, sn);
      }), Y;
    }
    function mp(P, re) {
      var Y = P.length;
      for (P.sort(re); Y--; )
        P[Y] = P[Y].value;
      return P;
    }
    function pp(P, re) {
      for (var Y, Ee = -1, ct = P.length; ++Ee < ct; ) {
        var ut = re(P[Ee]);
        ut !== i && (Y = Y === i ? ut : Y + ut);
      }
      return Y;
    }
    function Bp(P, re) {
      for (var Y = -1, Ee = Array(P); ++Y < P; )
        Ee[Y] = re(Y);
      return Ee;
    }
    function gR(P, re) {
      return Xn(re, function(Y) {
        return [Y, P[Y]];
      });
    }
    function kG(P) {
      return P && P.slice(0, Gp(P) + 1).replace(Rt, "");
    }
    function co(P) {
      return function(re) {
        return P(re);
      };
    }
    function yn(P, re) {
      return Xn(re, function(Y) {
        return P[Y];
      });
    }
    function rn(P, re) {
      return P.has(re);
    }
    function YG(P, re) {
      for (var Y = -1, Ee = P.length; ++Y < Ee && Tc(re, P[Y], 0) > -1; )
        ;
      return Y;
    }
    function FG(P, re) {
      for (var Y = P.length; Y-- && Tc(re, P[Y], 0) > -1; )
        ;
      return Y;
    }
    function oR(P, re) {
      for (var Y = P.length, Ee = 0; Y--; )
        P[Y] === re && ++Ee;
      return Ee;
    }
    var lR = hp(z), aR = hp(_);
    function sR(P) {
      return "\\" + se[P];
    }
    function xG(P, re) {
      return P == null ? i : P[re];
    }
    function Mc(P) {
      return sp.test(P);
    }
    function Kr(P) {
      return Ip.test(P);
    }
    function fp(P) {
      for (var re, Y = []; !(re = P.next()).done; )
        Y.push(re.value);
      return Y;
    }
    function is(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee, ct) {
        Y[++re] = [ct, Ee];
      }), Y;
    }
    function Zp(P, re) {
      return function(Y) {
        return P(re(Y));
      };
    }
    function ra(P, re) {
      for (var Y = -1, Ee = P.length, ct = 0, ut = []; ++Y < Ee; ) {
        var qi = P[Y];
        (qi === re || qi === c) && (P[Y] = c, ut[ct++] = Y);
      }
      return ut;
    }
    function Rg(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee) {
        Y[++re] = Ee;
      }), Y;
    }
    function DG(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee) {
        Y[++re] = [Ee, Ee];
      }), Y;
    }
    function JG(P, re, Y) {
      for (var Ee = Y - 1, ct = P.length; ++Ee < ct; )
        if (P[Ee] === re)
          return Ee;
      return -1;
    }
    function EG(P, re, Y) {
      for (var Ee = Y + 1; Ee--; )
        if (P[Ee] === re)
          return Ee;
      return Ee;
    }
    function PI(P) {
      return Mc(P) ? cR(P) : wG(P);
    }
    function No(P) {
      return Mc(P) ? dR(P) : vG(P);
    }
    function Gp(P) {
      for (var re = P.length; re-- && Zt.test(P.charAt(re)); )
        ;
      return re;
    }
    var IR = hp(q);
    function cR(P) {
      for (var re = Fu.lastIndex = 0; Fu.test(P); )
        ++re;
      return re;
    }
    function dR(P) {
      return P.match(Fu) || [];
    }
    function uR(P) {
      return P.match(na) || [];
    }
    var CR = function P(re) {
      re = re == null ? pt : pl.defaults(pt.Object(), re, pl.pick(pt, cp));
      var Y = re.Array, Ee = re.Date, ct = re.Error, ut = re.Function, qi = re.Math, sn = re.Object, yp = re.RegExp, UI = re.String, Lo = re.TypeError, TA = Y.prototype, AR = ut.prototype, Pc = sn.prototype, MA = re["__core-js_shared__"], Ko = AR.toString, In = Pc.hasOwnProperty, bR = 0, NG = function() {
        var s = /[^.]+$/.exec(MA && MA.keys && MA.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), PA = Pc.toString, hR = Ko.call(sn), ns = pt._, mR = yp(
        "^" + Ko.call(In).replace(Ke, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), UA = Wt ? re.Buffer : i, Os = re.Symbol, zA = re.Uint8Array, LG = UA ? UA.allocUnsafe : i, ga = Zp(sn.getPrototypeOf, sn), KG = sn.create, TG = Pc.propertyIsEnumerable, Qg = TA.splice, MG = Os ? Os.isConcatSpreadable : i, Ju = Os ? Os.iterator : i, zI = Os ? Os.toStringTag : i, OA = function() {
        try {
          var s = ic(sn, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), pR = re.clearTimeout !== pt.clearTimeout && re.clearTimeout, PG = Ee && Ee.now !== pt.Date.now && Ee.now, UG = re.setTimeout !== pt.setTimeout && re.setTimeout, QA = qi.ceil, jA = qi.floor, Eu = sn.getOwnPropertySymbols, Nu = UA ? UA.isBuffer : i, Lu = re.isFinite, BR = TA.join, zG = Zp(sn.keys, sn), Gr = qi.max, Ln = qi.min, Wp = Ee.now, OI = re.parseInt, uo = qi.random, fR = TA.reverse, qA = ic(re, "DataView"), Uc = ic(re, "Map"), QI = ic(re, "Promise"), zc = ic(re, "Set"), Qs = ic(re, "WeakMap"), Ku = ic(sn, "create"), Tu = Qs && new Qs(), Qn = {}, oa = nc(qA), Sp = nc(Uc), _A = nc(QI), jI = nc(zc), OG = nc(Qs), Xr = Os ? Os.prototype : i, qI = Xr ? Xr.valueOf : i, QG = Xr ? Xr.toString : i;
      function Q(s) {
        if (xn(s) && !fi(s) && !(s instanceof Di)) {
          if (s instanceof To)
            return s;
          if (In.call(s, "__wrapped__"))
            return nC(s);
        }
        return new To(s);
      }
      var Oc = /* @__PURE__ */ function() {
        function s() {
        }
        return function(u) {
          if (!Pn(u))
            return {};
          if (KG)
            return KG(u);
          s.prototype = u;
          var h = new s();
          return s.prototype = i, h;
        };
      }();
      function Qc() {
      }
      function To(s, u) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = i;
      }
      Q.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Oi,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Rn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: le,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Q
        }
      }, Q.prototype = Qc.prototype, Q.prototype.constructor = Q, To.prototype = Oc(Qc.prototype), To.prototype.constructor = To;
      function Di(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ve, this.__views__ = [];
      }
      function jG() {
        var s = new Di(this.__wrapped__);
        return s.__actions__ = Hg(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = Hg(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = Hg(this.__views__), s;
      }
      function ZR() {
        if (this.__filtered__) {
          var s = new Di(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function GR() {
        var s = this.__wrapped__.value(), u = this.__dir__, h = fi(s), G = u < 0, R = h ? s.length : 0, k = Vy(0, R, this.__views__), E = k.start, T = k.end, j = T - E, ae = G ? T : E - 1, ge = this.__iteratees__, ce = ge.length, Fe = 0, ze = Ln(j, this.__takeCount__);
        if (!h || !G && R == j && ze == j)
          return bb(s, this.__actions__);
        var nt = [];
        e:
          for (; j-- && Fe < ze; ) {
            ae += u;
            for (var Vt = -1, rt = s[ae]; ++Vt < ce; ) {
              var Nt = ge[Vt], Pt = Nt.iteratee, mn = Nt.type, pn = Pt(rt);
              if (mn == N)
                rt = pn;
              else if (!pn) {
                if (mn == L)
                  continue e;
                break e;
              }
            }
            nt[Fe++] = rt;
          }
        return nt;
      }
      Di.prototype = Oc(Qc.prototype), Di.prototype.constructor = Di;
      function Bl(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function yR() {
        this.__data__ = Ku ? Ku(null) : {}, this.size = 0;
      }
      function WR(s) {
        var u = this.has(s) && delete this.__data__[s];
        return this.size -= u ? 1 : 0, u;
      }
      function Vp(s) {
        var u = this.__data__;
        if (Ku) {
          var h = u[s];
          return h === a ? i : h;
        }
        return In.call(u, s) ? u[s] : i;
      }
      function qG(s) {
        var u = this.__data__;
        return Ku ? u[s] !== i : In.call(u, s);
      }
      function SR(s, u) {
        var h = this.__data__;
        return this.size += this.has(s) ? 0 : 1, h[s] = Ku && u === i ? a : u, this;
      }
      Bl.prototype.clear = yR, Bl.prototype.delete = WR, Bl.prototype.get = Vp, Bl.prototype.has = qG, Bl.prototype.set = SR;
      function rs(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function VR() {
        this.__data__ = [], this.size = 0;
      }
      function _G(s) {
        var u = this.__data__, h = eb(u, s);
        if (h < 0)
          return !1;
        var G = u.length - 1;
        return h == G ? u.pop() : Qg.call(u, h, 1), --this.size, !0;
      }
      function wp(s) {
        var u = this.__data__, h = eb(u, s);
        return h < 0 ? i : u[h][1];
      }
      function wR(s) {
        return eb(this.__data__, s) > -1;
      }
      function vp(s, u) {
        var h = this.__data__, G = eb(h, s);
        return G < 0 ? (++this.size, h.push([s, u])) : h[G][1] = u, this;
      }
      rs.prototype.clear = VR, rs.prototype.delete = _G, rs.prototype.get = wp, rs.prototype.has = wR, rs.prototype.set = vp;
      function la(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function $G() {
        this.size = 0, this.__data__ = {
          hash: new Bl(),
          map: new (Uc || rs)(),
          string: new Bl()
        };
      }
      function ey(s) {
        var u = yb(this, s).delete(s);
        return this.size -= u ? 1 : 0, u;
      }
      function $A(s) {
        return yb(this, s).get(s);
      }
      function vR(s) {
        return yb(this, s).has(s);
      }
      function ty(s, u) {
        var h = yb(this, s), G = h.size;
        return h.set(s, u), this.size += h.size == G ? 0 : 1, this;
      }
      la.prototype.clear = $G, la.prototype.delete = ey, la.prototype.get = $A, la.prototype.has = vR, la.prototype.set = ty;
      function js(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.__data__ = new la(); ++u < h; )
          this.add(s[u]);
      }
      function RR(s) {
        return this.__data__.set(s, a), this;
      }
      function iy(s) {
        return this.__data__.has(s);
      }
      js.prototype.add = js.prototype.push = RR, js.prototype.has = iy;
      function fl(s) {
        var u = this.__data__ = new rs(s);
        this.size = u.size;
      }
      function Rp() {
        this.__data__ = new rs(), this.size = 0;
      }
      function ny(s) {
        var u = this.__data__, h = u.delete(s);
        return this.size = u.size, h;
      }
      function Xp(s) {
        return this.__data__.get(s);
      }
      function XR(s) {
        return this.__data__.has(s);
      }
      function Hp(s, u) {
        var h = this.__data__;
        if (h instanceof rs) {
          var G = h.__data__;
          if (!Uc || G.length < r - 1)
            return G.push([s, u]), this.size = ++h.size, this;
          h = this.__data__ = new la(G);
        }
        return h.set(s, u), this.size = h.size, this;
      }
      fl.prototype.clear = Rp, fl.prototype.delete = ny, fl.prototype.get = Xp, fl.prototype.has = XR, fl.prototype.set = Hp;
      function Ji(s, u) {
        var h = fi(s), G = !h && iI(s), R = !h && !G && yl(s), k = !h && !G && !R && As(s), E = h || G || R || k, T = E ? Bp(s.length, UI) : [], j = T.length;
        for (var ae in s)
          (u || In.call(s, ae)) && !(E && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ae == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          R && (ae == "offset" || ae == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          k && (ae == "buffer" || ae == "byteLength" || ae == "byteOffset") || // Skip index properties.
          ss(ae, j))) && T.push(ae);
        return T;
      }
      function ry(s) {
        var u = s.length;
        return u ? s[ju(0, u - 1)] : i;
      }
      function HR(s, u) {
        return iC(Hg(s), jg(u, 0, s.length));
      }
      function Mu(s) {
        return iC(Hg(s));
      }
      function kp(s, u, h) {
        (h !== i && !cn(s[u], h) || h === i && !(u in s)) && aa(s, u, h);
      }
      function ig(s, u, h) {
        var G = s[u];
        (!(In.call(s, u) && cn(G, h)) || h === i && !(u in s)) && aa(s, u, h);
      }
      function eb(s, u) {
        for (var h = s.length; h--; )
          if (cn(s[h][0], u))
            return h;
        return -1;
      }
      function tb(s, u, h, G) {
        return gs(s, function(R, k, E) {
          u(G, R, h(R), E);
        }), G;
      }
      function ib(s, u) {
        return s && Ca(u, kr(u), s);
      }
      function gy(s, u) {
        return s && Ca(u, Dg(u), s);
      }
      function aa(s, u, h) {
        u == "__proto__" && OA ? OA(s, u, {
          configurable: !0,
          enumerable: !0,
          value: h,
          writable: !0
        }) : s[u] = h;
      }
      function Xg(s, u) {
        for (var h = -1, G = u.length, R = Y(G), k = s == null; ++h < G; )
          R[h] = k ? i : Aa(s, u[h]);
        return R;
      }
      function jg(s, u, h) {
        return s === s && (h !== i && (s = s <= h ? s : h), u !== i && (s = s >= u ? s : u)), s;
      }
      function qg(s, u, h, G, R, k) {
        var E, T = u & d, j = u & C, ae = u & A;
        if (h && (E = R ? h(s, G, R, k) : h(s)), E !== i)
          return E;
        if (!Pn(s))
          return s;
        var ge = fi(s);
        if (ge) {
          if (E = eX(s), !T)
            return Hg(s, E);
        } else {
          var ce = og(s), Fe = ce == bt || ce == it;
          if (yl(s))
            return Op(s, T);
          if (ce == jt || ce == we || Fe && !R) {
            if (E = j || Fe ? {} : wy(s), !T)
              return j ? PR(s, gy(E, s)) : MR(s, ib(E, s));
          } else {
            if (!D[ce])
              return R ? s : {};
            E = tX(s, ce, T);
          }
        }
        k || (k = new fl());
        var ze = k.get(s);
        if (ze)
          return ze;
        k.set(s, E), iW(s) ? s.forEach(function(rt) {
          E.add(qg(rt, u, h, rt, s, k));
        }) : ds(s) && s.forEach(function(rt, Nt) {
          E.set(Nt, qg(rt, u, h, Nt, s, k));
        });
        var nt = ae ? j ? t0 : e0 : j ? Dg : kr, Vt = ge ? i : nt(s);
        return Lr(Vt || s, function(rt, Nt) {
          Vt && (Nt = rt, rt = s[Nt]), ig(E, Nt, qg(rt, u, h, Nt, s, k));
        }), E;
      }
      function oy(s) {
        var u = kr(s);
        return function(h) {
          return Pu(h, s, u);
        };
      }
      function Pu(s, u, h) {
        var G = h.length;
        if (s == null)
          return !G;
        for (s = sn(s); G--; ) {
          var R = h[G], k = u[R], E = s[R];
          if (E === i && !(R in s) || !k(E))
            return !1;
        }
        return !0;
      }
      function Yp(s, u, h) {
        if (typeof s != "function")
          throw new Lo(o);
        return tC(function() {
          s.apply(i, h);
        }, u);
      }
      function _I(s, u, h, G) {
        var R = -1, k = xu, E = !0, T = s.length, j = [], ae = u.length;
        if (!T)
          return j;
        h && (u = Xn(u, co(h))), G ? (k = Du, E = !1) : u.length >= r && (k = rn, E = !1, u = new js(u));
        e:
          for (; ++R < T; ) {
            var ge = s[R], ce = h == null ? ge : h(ge);
            if (ge = G || ge !== 0 ? ge : 0, E && ce === ce) {
              for (var Fe = ae; Fe--; )
                if (u[Fe] === ce)
                  continue e;
              j.push(ge);
            } else
              k(u, ce, G) || j.push(ge);
          }
        return j;
      }
      var gs = by(sa), nb = by(rb, !0);
      function Fp(s, u) {
        var h = !0;
        return gs(s, function(G, R, k) {
          return h = !!u(G, R, k), h;
        }), h;
      }
      function Zl(s, u, h) {
        for (var G = -1, R = s.length; ++G < R; ) {
          var k = s[G], E = u(k);
          if (E != null && (T === i ? E === E && !bo(E) : h(E, T)))
            var T = E, j = k;
        }
        return j;
      }
      function qs(s, u, h, G) {
        var R = s.length;
        for (h = oi(h), h < 0 && (h = -h > R ? 0 : R + h), G = G === i || G > R ? R : oi(G), G < 0 && (G += R), G = h > G ? 0 : gW(G); h < G; )
          s[h++] = u;
        return s;
      }
      function xp(s, u) {
        var h = [];
        return gs(s, function(G, R, k) {
          u(G, R, k) && h.push(G);
        }), h;
      }
      function yr(s, u, h, G, R) {
        var k = -1, E = s.length;
        for (h || (h = nX), R || (R = []); ++k < E; ) {
          var T = s[k];
          u > 0 && h(T) ? u > 1 ? yr(T, u - 1, h, G, R) : Io(R, T) : G || (R[R.length] = T);
        }
        return R;
      }
      var Dp = hy(), ly = hy(!0);
      function sa(s, u) {
        return s && Dp(s, u, kr);
      }
      function rb(s, u) {
        return s && ly(s, u, kr);
      }
      function Uu(s, u) {
        return zs(u, function(h) {
          return Oo(s[h]);
        });
      }
      function $I(s, u) {
        u = $s(u, s);
        for (var h = 0, G = u.length; s != null && h < G; )
          s = s[Gl(u[h++])];
        return h && h == G ? s : i;
      }
      function Jp(s, u, h) {
        var G = u(s);
        return fi(s) ? G : Io(G, h(s));
      }
      function ng(s) {
        return s == null ? s === i ? ni : It : zI && zI in sn(s) ? r0(s) : sX(s);
      }
      function rg(s, u) {
        return s > u;
      }
      function Ia(s, u) {
        return s != null && In.call(s, u);
      }
      function kR(s, u) {
        return s != null && u in sn(s);
      }
      function YR(s, u, h) {
        return s >= Ln(u, h) && s < Gr(u, h);
      }
      function jc(s, u, h) {
        for (var G = h ? Du : xu, R = s[0].length, k = s.length, E = k, T = Y(k), j = 1 / 0, ae = []; E--; ) {
          var ge = s[E];
          E && u && (ge = Xn(ge, co(u))), j = Ln(ge.length, j), T[E] = !h && (u || R >= 120 && ge.length >= 120) ? new js(E && ge) : i;
        }
        ge = s[0];
        var ce = -1, Fe = T[0];
        e:
          for (; ++ce < R && ae.length < j; ) {
            var ze = ge[ce], nt = u ? u(ze) : ze;
            if (ze = h || ze !== 0 ? ze : 0, !(Fe ? rn(Fe, nt) : G(ae, nt, h))) {
              for (E = k; --E; ) {
                var Vt = T[E];
                if (!(Vt ? rn(Vt, nt) : G(s[E], nt, h)))
                  continue e;
              }
              Fe && Fe.push(nt), ae.push(ze);
            }
          }
        return ae;
      }
      function qc(s, u, h, G) {
        return sa(s, function(R, k, E) {
          u(G, h(R), k, E);
        }), G;
      }
      function _c(s, u, h) {
        u = $s(u, s), s = Xy(s, u);
        var G = s == null ? s : s[Gl(xg(u))];
        return G == null ? i : nn(G, s, h);
      }
      function Ep(s) {
        return xn(s) && ng(s) == we;
      }
      function FR(s) {
        return xn(s) && ng(s) == ci;
      }
      function ay(s) {
        return xn(s) && ng(s) == xe;
      }
      function ca(s, u, h, G, R) {
        return s === u ? !0 : s == null || u == null || !xn(s) && !xn(u) ? s !== s && u !== u : zu(s, u, h, G, ca, R);
      }
      function zu(s, u, h, G, R, k) {
        var E = fi(s), T = fi(u), j = E ? ue : og(s), ae = T ? ue : og(u);
        j = j == we ? jt : j, ae = ae == we ? jt : ae;
        var ge = j == jt, ce = ae == jt, Fe = j == ae;
        if (Fe && yl(s)) {
          if (!yl(u))
            return !1;
          E = !0, ge = !1;
        }
        if (Fe && !ge)
          return k || (k = new fl()), E || As(s) ? Wy(s, u, h, G, R, k) : qR(s, u, j, h, G, R, k);
        if (!(h & b)) {
          var ze = ge && In.call(s, "__wrapped__"), nt = ce && In.call(u, "__wrapped__");
          if (ze || nt) {
            var Vt = ze ? s.value() : s, rt = nt ? u.value() : u;
            return k || (k = new fl()), R(Vt, rt, h, G, k);
          }
        }
        return Fe ? (k || (k = new fl()), _R(s, u, h, G, R, k)) : !1;
      }
      function xR(s) {
        return xn(s) && og(s) == Qe;
      }
      function gb(s, u, h, G) {
        var R = h.length, k = R, E = !G;
        if (s == null)
          return !k;
        for (s = sn(s); R--; ) {
          var T = h[R];
          if (E && T[2] ? T[1] !== s[T[0]] : !(T[0] in s))
            return !1;
        }
        for (; ++R < k; ) {
          T = h[R];
          var j = T[0], ae = s[j], ge = T[1];
          if (E && T[2]) {
            if (ae === i && !(j in s))
              return !1;
          } else {
            var ce = new fl();
            if (G)
              var Fe = G(ae, ge, j, s, u, ce);
            if (!(Fe === i ? ca(ge, ae, b | m, G, ce) : Fe))
              return !1;
          }
        }
        return !0;
      }
      function Np(s) {
        if (!Pn(s) || gX(s))
          return !1;
        var u = Oo(s) ? mR : Qt;
        return u.test(nc(s));
      }
      function ob(s) {
        return xn(s) && ng(s) == Xt;
      }
      function sy(s) {
        return xn(s) && og(s) == Ht;
      }
      function lb(s) {
        return xn(s) && Eb(s.length) && !!ki[ng(s)];
      }
      function ab(s) {
        return typeof s == "function" ? s : s == null ? Mr : typeof s == "object" ? fi(s) ? Ib(s[0], s[1]) : Lp(s) : J0(s);
      }
      function $c(s) {
        if (!gd(s))
          return zG(s);
        var u = [];
        for (var h in sn(s))
          In.call(s, h) && h != "constructor" && u.push(h);
        return u;
      }
      function DR(s) {
        if (!Pn(s))
          return aX(s);
        var u = gd(s), h = [];
        for (var G in s)
          G == "constructor" && (u || !In.call(s, G)) || h.push(G);
        return h;
      }
      function sb(s, u) {
        return s < u;
      }
      function Ou(s, u) {
        var h = -1, G = ag(s) ? Y(s.length) : [];
        return gs(s, function(R, k, E) {
          G[++h] = u(R, k, E);
        }), G;
      }
      function Lp(s) {
        var u = n0(s);
        return u.length == 1 && u[0][2] ? vy(u[0][0], u[0][1]) : function(h) {
          return h === s || gb(h, s, u);
        };
      }
      function Ib(s, u) {
        return g0(s) && l0(u) ? vy(Gl(s), u) : function(h) {
          var G = Aa(h, s);
          return G === i && G === u ? cC(h, s) : ca(u, G, b | m);
        };
      }
      function Qu(s, u, h, G, R) {
        s !== u && Dp(u, function(k, E) {
          if (R || (R = new fl()), Pn(k))
            os(s, u, E, h, Qu, G, R);
          else {
            var T = G ? G(a0(s, E), k, E + "", s, u, R) : i;
            T === i && (T = k), kp(s, E, T);
          }
        }, Dg);
      }
      function os(s, u, h, G, R, k, E) {
        var T = a0(s, h), j = a0(u, h), ae = E.get(j);
        if (ae) {
          kp(s, h, ae);
          return;
        }
        var ge = k ? k(T, j, h + "", s, u, E) : i, ce = ge === i;
        if (ce) {
          var Fe = fi(j), ze = !Fe && yl(j), nt = !Fe && !ze && As(j);
          ge = j, Fe || ze || nt ? fi(T) ? ge = T : lr(T) ? ge = Hg(T) : ze ? (ce = !1, ge = Op(j, !0)) : nt ? (ce = !1, ge = jp(j, !0)) : ge = [] : us(j) || iI(j) ? (ge = T, iI(T) ? ge = W0(T) : (!Pn(T) || Oo(T)) && (ge = wy(j))) : ce = !1;
        }
        ce && (E.set(j, ge), R(ge, j, G, k, E), E.delete(j)), kp(s, h, ge);
      }
      function Kp(s, u) {
        var h = s.length;
        if (h)
          return u += u < 0 ? h : 0, ss(u, h) ? s[u] : i;
      }
      function Tp(s, u, h) {
        u.length ? u = Xn(u, function(k) {
          return fi(k) ? function(E) {
            return $I(E, k.length === 1 ? k[0] : k);
          } : k;
        }) : u = [Mr];
        var G = -1;
        u = Xn(u, co(hi()));
        var R = Ou(s, function(k, E, T) {
          var j = Xn(u, function(ae) {
            return ae(k);
          });
          return { criteria: j, index: ++G, value: k };
        });
        return mp(R, function(k, E) {
          return ua(k, E, h);
        });
      }
      function JR(s, u) {
        return Mp(s, u, function(h, G) {
          return cC(s, G);
        });
      }
      function Mp(s, u, h) {
        for (var G = -1, R = u.length, k = {}; ++G < R; ) {
          var E = u[G], T = $I(s, E);
          h(T, E) && ec(k, $s(E, s), T);
        }
        return k;
      }
      function ER(s) {
        return function(u) {
          return $I(u, s);
        };
      }
      function Pp(s, u, h, G) {
        var R = G ? rR : Tc, k = -1, E = u.length, T = s;
        for (s === u && (u = Hg(u)), h && (T = Xn(s, co(h))); ++k < E; )
          for (var j = 0, ae = u[k], ge = h ? h(ae) : ae; (j = R(T, ge, j, G)) > -1; )
            T !== s && Qg.call(T, j, 1), Qg.call(s, j, 1);
        return s;
      }
      function da(s, u) {
        for (var h = s ? u.length : 0, G = h - 1; h--; ) {
          var R = u[h];
          if (h == G || R !== k) {
            var k = R;
            ss(R) ? Qg.call(s, R, 1) : Tr(s, R);
          }
        }
        return s;
      }
      function ju(s, u) {
        return s + jA(uo() * (u - s + 1));
      }
      function Up(s, u, h, G) {
        for (var R = -1, k = Gr(QA((u - s) / (h || 1)), 0), E = Y(k); k--; )
          E[G ? k : ++R] = s, s += h;
        return E;
      }
      function ed(s, u) {
        var h = "";
        if (!s || u < 1 || u > $)
          return h;
        do
          u % 2 && (h += s), u = jA(u / 2), u && (s += s);
        while (u);
        return h;
      }
      function Si(s, u) {
        return s0(Ry(s, u, Mr), s + "");
      }
      function bi(s) {
        return ry(cd(s));
      }
      function cb(s, u) {
        var h = cd(s);
        return iC(h, jg(u, 0, h.length));
      }
      function ec(s, u, h, G) {
        if (!Pn(s))
          return s;
        u = $s(u, s);
        for (var R = -1, k = u.length, E = k - 1, T = s; T != null && ++R < k; ) {
          var j = Gl(u[R]), ae = h;
          if (j === "__proto__" || j === "constructor" || j === "prototype")
            return s;
          if (R != E) {
            var ge = T[j];
            ae = G ? G(ge, j, T) : i, ae === i && (ae = Pn(ge) ? ge : ss(u[R + 1]) ? [] : {});
          }
          ig(T, j, ae), T = T[j];
        }
        return s;
      }
      var _s = Tu ? function(s, u) {
        return Tu.set(s, u), s;
      } : Mr, NR = OA ? function(s, u) {
        return OA(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Y0(u),
          writable: !0
        });
      } : Mr;
      function LR(s) {
        return iC(cd(s));
      }
      function Mo(s, u, h) {
        var G = -1, R = s.length;
        u < 0 && (u = -u > R ? 0 : R + u), h = h > R ? R : h, h < 0 && (h += R), R = u > h ? 0 : h - u >>> 0, u >>>= 0;
        for (var k = Y(R); ++G < R; )
          k[G] = s[G + u];
        return k;
      }
      function Iy(s, u) {
        var h;
        return gs(s, function(G, R, k) {
          return h = u(G, R, k), !h;
        }), !!h;
      }
      function db(s, u, h) {
        var G = 0, R = s == null ? G : s.length;
        if (typeof u == "number" && u === u && R <= Je) {
          for (; G < R; ) {
            var k = G + R >>> 1, E = s[k];
            E !== null && !bo(E) && (h ? E <= u : E < u) ? G = k + 1 : R = k;
          }
          return R;
        }
        return ub(s, u, Mr, h);
      }
      function ub(s, u, h, G) {
        var R = 0, k = s == null ? 0 : s.length;
        if (k === 0)
          return 0;
        u = h(u);
        for (var E = u !== u, T = u === null, j = bo(u), ae = u === i; R < k; ) {
          var ge = jA((R + k) / 2), ce = h(s[ge]), Fe = ce !== i, ze = ce === null, nt = ce === ce, Vt = bo(ce);
          if (E)
            var rt = G || nt;
          else
            ae ? rt = nt && (G || Fe) : T ? rt = nt && Fe && (G || !ze) : j ? rt = nt && Fe && !ze && (G || !Vt) : ze || Vt ? rt = !1 : rt = G ? ce <= u : ce < u;
          rt ? R = ge + 1 : k = ge;
        }
        return Ln(k, He);
      }
      function cy(s, u) {
        for (var h = -1, G = s.length, R = 0, k = []; ++h < G; ) {
          var E = s[h], T = u ? u(E) : E;
          if (!h || !cn(T, j)) {
            var j = T;
            k[R++] = E === 0 ? 0 : E;
          }
        }
        return k;
      }
      function dy(s) {
        return typeof s == "number" ? s : bo(s) ? be : +s;
      }
      function Co(s) {
        if (typeof s == "string")
          return s;
        if (fi(s))
          return Xn(s, Co) + "";
        if (bo(s))
          return QG ? QG.call(s) : "";
        var u = s + "";
        return u == "0" && 1 / s == -O ? "-0" : u;
      }
      function gg(s, u, h) {
        var G = -1, R = xu, k = s.length, E = !0, T = [], j = T;
        if (h)
          E = !1, R = Du;
        else if (k >= r) {
          var ae = u ? null : QR(s);
          if (ae)
            return Rg(ae);
          E = !1, R = rn, j = new js();
        } else
          j = u ? [] : T;
        e:
          for (; ++G < k; ) {
            var ge = s[G], ce = u ? u(ge) : ge;
            if (ge = h || ge !== 0 ? ge : 0, E && ce === ce) {
              for (var Fe = j.length; Fe--; )
                if (j[Fe] === ce)
                  continue e;
              u && j.push(ce), T.push(ge);
            } else
              R(j, ce, h) || (j !== T && j.push(ce), T.push(ge));
          }
        return T;
      }
      function Tr(s, u) {
        return u = $s(u, s), s = Xy(s, u), s == null || delete s[Gl(xg(u))];
      }
      function Cb(s, u, h, G) {
        return ec(s, u, h($I(s, u)), G);
      }
      function Ab(s, u, h, G) {
        for (var R = s.length, k = G ? R : -1; (G ? k-- : ++k < R) && u(s[k], k, s); )
          ;
        return h ? Mo(s, G ? 0 : k, G ? k + 1 : R) : Mo(s, G ? k + 1 : 0, G ? R : k);
      }
      function bb(s, u) {
        var h = s;
        return h instanceof Di && (h = h.value()), LA(u, function(G, R) {
          return R.func.apply(R.thisArg, Io([G], R.args));
        }, h);
      }
      function zp(s, u, h) {
        var G = s.length;
        if (G < 2)
          return G ? gg(s[0]) : [];
        for (var R = -1, k = Y(G); ++R < G; )
          for (var E = s[R], T = -1; ++T < G; )
            T != R && (k[R] = _I(k[R] || E, s[T], u, h));
        return gg(yr(k, 1), u, h);
      }
      function td(s, u, h) {
        for (var G = -1, R = s.length, k = u.length, E = {}; ++G < R; ) {
          var T = G < k ? u[G] : i;
          h(E, s[G], T);
        }
        return E;
      }
      function hb(s) {
        return lr(s) ? s : [];
      }
      function mb(s) {
        return typeof s == "function" ? s : Mr;
      }
      function $s(s, u) {
        return fi(s) ? s : g0(s, u) ? [s] : d0(_i(s));
      }
      var KR = Si;
      function eI(s, u, h) {
        var G = s.length;
        return h = h === i ? G : h, !u && h >= G ? s : Mo(s, u, h);
      }
      var uy = pR || function(s) {
        return pt.clearTimeout(s);
      };
      function Op(s, u) {
        if (u)
          return s.slice();
        var h = s.length, G = LG ? LG(h) : new s.constructor(h);
        return s.copy(G), G;
      }
      function pb(s) {
        var u = new s.constructor(s.byteLength);
        return new zA(u).set(new zA(s)), u;
      }
      function TR(s, u) {
        var h = u ? pb(s.buffer) : s.buffer;
        return new s.constructor(h, s.byteOffset, s.byteLength);
      }
      function Qp(s) {
        var u = new s.constructor(s.source, Ae.exec(s));
        return u.lastIndex = s.lastIndex, u;
      }
      function Cy(s) {
        return qI ? sn(qI.call(s)) : {};
      }
      function jp(s, u) {
        var h = u ? pb(s.buffer) : s.buffer;
        return new s.constructor(h, s.byteOffset, s.length);
      }
      function qu(s, u) {
        if (s !== u) {
          var h = s !== i, G = s === null, R = s === s, k = bo(s), E = u !== i, T = u === null, j = u === u, ae = bo(u);
          if (!T && !ae && !k && s > u || k && E && j && !T && !ae || G && E && j || !h && j || !R)
            return 1;
          if (!G && !k && !ae && s < u || ae && h && R && !G && !k || T && h && R || !E && R || !j)
            return -1;
        }
        return 0;
      }
      function ua(s, u, h) {
        for (var G = -1, R = s.criteria, k = u.criteria, E = R.length, T = h.length; ++G < E; ) {
          var j = qu(R[G], k[G]);
          if (j) {
            if (G >= T)
              return j;
            var ae = h[G];
            return j * (ae == "desc" ? -1 : 1);
          }
        }
        return s.index - u.index;
      }
      function tI(s, u, h, G) {
        for (var R = -1, k = s.length, E = h.length, T = -1, j = u.length, ae = Gr(k - E, 0), ge = Y(j + ae), ce = !G; ++T < j; )
          ge[T] = u[T];
        for (; ++R < E; )
          (ce || R < k) && (ge[h[R]] = s[R]);
        for (; ae--; )
          ge[T++] = s[R++];
        return ge;
      }
      function Ay(s, u, h, G) {
        for (var R = -1, k = s.length, E = -1, T = h.length, j = -1, ae = u.length, ge = Gr(k - T, 0), ce = Y(ge + ae), Fe = !G; ++R < ge; )
          ce[R] = s[R];
        for (var ze = R; ++j < ae; )
          ce[ze + j] = u[j];
        for (; ++E < T; )
          (Fe || R < k) && (ce[ze + h[E]] = s[R++]);
        return ce;
      }
      function Hg(s, u) {
        var h = -1, G = s.length;
        for (u || (u = Y(G)); ++h < G; )
          u[h] = s[h];
        return u;
      }
      function Ca(s, u, h, G) {
        var R = !h;
        h || (h = {});
        for (var k = -1, E = u.length; ++k < E; ) {
          var T = u[k], j = G ? G(h[T], s[T], T, h, s) : i;
          j === i && (j = s[T]), R ? aa(h, T, j) : ig(h, T, j);
        }
        return h;
      }
      function MR(s, u) {
        return Ca(s, Wb(s), u);
      }
      function PR(s, u) {
        return Ca(s, Sy(s), u);
      }
      function Bb(s, u) {
        return function(h, G) {
          var R = fi(h) ? MI : tb, k = u ? u() : {};
          return R(h, s, hi(G, 2), k);
        };
      }
      function id(s) {
        return Si(function(u, h) {
          var G = -1, R = h.length, k = R > 1 ? h[R - 1] : i, E = R > 2 ? h[2] : i;
          for (k = s.length > 3 && typeof k == "function" ? (R--, k) : i, E && Yg(h[0], h[1], E) && (k = R < 3 ? i : k, R = 1), u = sn(u); ++G < R; ) {
            var T = h[G];
            T && s(u, T, G, k);
          }
          return u;
        });
      }
      function by(s, u) {
        return function(h, G) {
          if (h == null)
            return h;
          if (!ag(h))
            return s(h, G);
          for (var R = h.length, k = u ? R : -1, E = sn(h); (u ? k-- : ++k < R) && G(E[k], k, E) !== !1; )
            ;
          return h;
        };
      }
      function hy(s) {
        return function(u, h, G) {
          for (var R = -1, k = sn(u), E = G(u), T = E.length; T--; ) {
            var j = E[s ? T : ++R];
            if (h(k[j], j, k) === !1)
              break;
          }
          return u;
        };
      }
      function UR(s, u, h) {
        var G = u & p, R = nd(s);
        function k() {
          var E = this && this !== pt && this instanceof k ? R : s;
          return E.apply(G ? h : this, arguments);
        }
        return k;
      }
      function qp(s) {
        return function(u) {
          u = _i(u);
          var h = Mc(u) ? No(u) : i, G = h ? h[0] : u.charAt(0), R = h ? eI(h, 1).join("") : u.slice(1);
          return G[s]() + R;
        };
      }
      function tc(s) {
        return function(u) {
          return LA(mW(AW(u).replace(Yu, "")), s, "");
        };
      }
      function nd(s) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new s();
            case 1:
              return new s(u[0]);
            case 2:
              return new s(u[0], u[1]);
            case 3:
              return new s(u[0], u[1], u[2]);
            case 4:
              return new s(u[0], u[1], u[2], u[3]);
            case 5:
              return new s(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new s(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new s(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var h = Oc(s.prototype), G = s.apply(h, u);
          return Pn(G) ? G : h;
        };
      }
      function zR(s, u, h) {
        var G = nd(s);
        function R() {
          for (var k = arguments.length, E = Y(k), T = k, j = rd(R); T--; )
            E[T] = arguments[T];
          var ae = k < 3 && E[0] !== j && E[k - 1] !== j ? [] : ra(E, j);
          if (k -= ae.length, k < h)
            return Zy(
              s,
              u,
              _u,
              R.placeholder,
              i,
              E,
              ae,
              i,
              i,
              h - k
            );
          var ge = this && this !== pt && this instanceof R ? G : s;
          return nn(ge, this, E);
        }
        return R;
      }
      function my(s) {
        return function(u, h, G) {
          var R = sn(u);
          if (!ag(u)) {
            var k = hi(h, 3);
            u = kr(u), h = function(T) {
              return k(R[T], T, R);
            };
          }
          var E = s(u, h, G);
          return E > -1 ? R[k ? u[E] : E] : i;
        };
      }
      function py(s) {
        return as(function(u) {
          var h = u.length, G = h, R = To.prototype.thru;
          for (s && u.reverse(); G--; ) {
            var k = u[G];
            if (typeof k != "function")
              throw new Lo(o);
            if (R && !E && Gb(k) == "wrapper")
              var E = new To([], !0);
          }
          for (G = E ? G : h; ++G < h; ) {
            k = u[G];
            var T = Gb(k), j = T == "wrapper" ? i0(k) : i;
            j && o0(j[0]) && j[1] == (w | Z | W | v) && !j[4].length && j[9] == 1 ? E = E[Gb(j[0])].apply(E, j[3]) : E = k.length == 1 && o0(k) ? E[T]() : E.thru(k);
          }
          return function() {
            var ae = arguments, ge = ae[0];
            if (E && ae.length == 1 && fi(ge))
              return E.plant(ge).value();
            for (var ce = 0, Fe = h ? u[ce].apply(this, ae) : ge; ++ce < h; )
              Fe = u[ce].call(this, Fe);
            return Fe;
          };
        });
      }
      function _u(s, u, h, G, R, k, E, T, j, ae) {
        var ge = u & w, ce = u & p, Fe = u & B, ze = u & (Z | y), nt = u & H, Vt = Fe ? i : nd(s);
        function rt() {
          for (var Nt = arguments.length, Pt = Y(Nt), mn = Nt; mn--; )
            Pt[mn] = arguments[mn];
          if (ze)
            var pn = rd(rt), Cr = oR(Pt, pn);
          if (G && (Pt = tI(Pt, G, R, ze)), k && (Pt = Ay(Pt, k, E, ze)), Nt -= Cr, ze && Nt < ae) {
            var Hi = ra(Pt, pn);
            return Zy(
              s,
              u,
              _u,
              rt.placeholder,
              h,
              Pt,
              Hi,
              T,
              j,
              ae - Nt
            );
          }
          var qn = ce ? h : this, ho = Fe ? qn[s] : s;
          return Nt = Pt.length, T ? Pt = IX(Pt, T) : nt && Nt > 1 && Pt.reverse(), ge && j < Nt && (Pt.length = j), this && this !== pt && this instanceof rt && (ho = Vt || nd(ho)), ho.apply(qn, Pt);
        }
        return rt;
      }
      function By(s, u) {
        return function(h, G) {
          return qc(h, s, u(G), {});
        };
      }
      function fb(s, u) {
        return function(h, G) {
          var R;
          if (h === i && G === i)
            return u;
          if (h !== i && (R = h), G !== i) {
            if (R === i)
              return G;
            typeof h == "string" || typeof G == "string" ? (h = Co(h), G = Co(G)) : (h = dy(h), G = dy(G)), R = s(h, G);
          }
          return R;
        };
      }
      function _p(s) {
        return as(function(u) {
          return u = Xn(u, co(hi())), Si(function(h) {
            var G = this;
            return s(u, function(R) {
              return nn(R, G, h);
            });
          });
        });
      }
      function kg(s, u) {
        u = u === i ? " " : Co(u);
        var h = u.length;
        if (h < 2)
          return h ? ed(u, s) : u;
        var G = ed(u, QA(s / PI(u)));
        return Mc(u) ? eI(No(G), 0, s).join("") : G.slice(0, s);
      }
      function OR(s, u, h, G) {
        var R = u & p, k = nd(s);
        function E() {
          for (var T = -1, j = arguments.length, ae = -1, ge = G.length, ce = Y(ge + j), Fe = this && this !== pt && this instanceof E ? k : s; ++ae < ge; )
            ce[ae] = G[ae];
          for (; j--; )
            ce[ae++] = arguments[++T];
          return nn(Fe, R ? h : this, ce);
        }
        return E;
      }
      function fy(s) {
        return function(u, h, G) {
          return G && typeof G != "number" && Yg(u, h, G) && (h = G = i), u = Wn(u), h === i ? (h = u, u = 0) : h = Wn(h), G = G === i ? u < h ? 1 : -1 : Wn(G), Up(u, h, G, s);
        };
      }
      function $u(s) {
        return function(u, h) {
          return typeof u == "string" && typeof h == "string" || (u = Qo(u), h = Qo(h)), s(u, h);
        };
      }
      function Zy(s, u, h, G, R, k, E, T, j, ae) {
        var ge = u & Z, ce = ge ? E : i, Fe = ge ? i : E, ze = ge ? k : i, nt = ge ? i : k;
        u |= ge ? W : V, u &= ~(ge ? V : W), u & f || (u &= ~(p | B));
        var Vt = [
          s,
          u,
          R,
          ze,
          ce,
          nt,
          Fe,
          T,
          j,
          ae
        ], rt = h.apply(i, Vt);
        return o0(s) && Hy(rt, Vt), rt.placeholder = G, I0(rt, s, u);
      }
      function $p(s) {
        var u = qi[s];
        return function(h, G) {
          if (h = Qo(h), G = G == null ? 0 : Ln(oi(G), 292), G && Lu(h)) {
            var R = (_i(h) + "e").split("e"), k = u(R[0] + "e" + (+R[1] + G));
            return R = (_i(k) + "e").split("e"), +(R[0] + "e" + (+R[1] - G));
          }
          return u(h);
        };
      }
      var QR = zc && 1 / Rg(new zc([, -0]))[1] == O ? function(s) {
        return new zc(s);
      } : D0;
      function Zb(s) {
        return function(u) {
          var h = og(u);
          return h == Qe ? is(u) : h == Ht ? DG(u) : gR(u, s(u));
        };
      }
      function ls(s, u, h, G, R, k, E, T) {
        var j = u & B;
        if (!j && typeof s != "function")
          throw new Lo(o);
        var ae = G ? G.length : 0;
        if (ae || (u &= ~(W | V), G = R = i), E = E === i ? E : Gr(oi(E), 0), T = T === i ? T : oi(T), ae -= R ? R.length : 0, u & V) {
          var ge = G, ce = R;
          G = R = i;
        }
        var Fe = j ? i : i0(s), ze = [
          s,
          u,
          h,
          G,
          R,
          ge,
          ce,
          k,
          E,
          T
        ];
        if (Fe && lX(ze, Fe), s = ze[0], u = ze[1], h = ze[2], G = ze[3], R = ze[4], T = ze[9] = ze[9] === i ? j ? 0 : s.length : Gr(ze[9] - ae, 0), !T && u & (Z | y) && (u &= ~(Z | y)), !u || u == p)
          var nt = UR(s, u, h);
        else
          u == Z || u == y ? nt = zR(s, u, T) : (u == W || u == (p | W)) && !R.length ? nt = OR(s, u, h, G) : nt = _u.apply(i, ze);
        var Vt = Fe ? _s : Hy;
        return I0(Vt(nt, ze), s, u);
      }
      function Gy(s, u, h, G) {
        return s === i || cn(s, Pc[h]) && !In.call(G, h) ? u : s;
      }
      function yy(s, u, h, G, R, k) {
        return Pn(s) && Pn(u) && (k.set(u, s), Qu(s, u, i, yy, k), k.delete(u)), s;
      }
      function jR(s) {
        return us(s) ? i : s;
      }
      function Wy(s, u, h, G, R, k) {
        var E = h & b, T = s.length, j = u.length;
        if (T != j && !(E && j > T))
          return !1;
        var ae = k.get(s), ge = k.get(u);
        if (ae && ge)
          return ae == u && ge == s;
        var ce = -1, Fe = !0, ze = h & m ? new js() : i;
        for (k.set(s, u), k.set(u, s); ++ce < T; ) {
          var nt = s[ce], Vt = u[ce];
          if (G)
            var rt = E ? G(Vt, nt, ce, u, s, k) : G(nt, Vt, ce, s, u, k);
          if (rt !== i) {
            if (rt)
              continue;
            Fe = !1;
            break;
          }
          if (ze) {
            if (!up(u, function(Nt, Pt) {
              if (!rn(ze, Pt) && (nt === Nt || R(nt, Nt, h, G, k)))
                return ze.push(Pt);
            })) {
              Fe = !1;
              break;
            }
          } else if (!(nt === Vt || R(nt, Vt, h, G, k))) {
            Fe = !1;
            break;
          }
        }
        return k.delete(s), k.delete(u), Fe;
      }
      function qR(s, u, h, G, R, k, E) {
        switch (h) {
          case Ge:
            if (s.byteLength != u.byteLength || s.byteOffset != u.byteOffset)
              return !1;
            s = s.buffer, u = u.buffer;
          case ci:
            return !(s.byteLength != u.byteLength || !k(new zA(s), new zA(u)));
          case Ze:
          case xe:
          case $e:
            return cn(+s, +u);
          case st:
            return s.name == u.name && s.message == u.message;
          case Xt:
          case ii:
            return s == u + "";
          case Qe:
            var T = is;
          case Ht:
            var j = G & b;
            if (T || (T = Rg), s.size != u.size && !j)
              return !1;
            var ae = E.get(s);
            if (ae)
              return ae == u;
            G |= m, E.set(s, u);
            var ge = Wy(T(s), T(u), G, R, k, E);
            return E.delete(s), ge;
          case $t:
            if (qI)
              return qI.call(s) == qI.call(u);
        }
        return !1;
      }
      function _R(s, u, h, G, R, k) {
        var E = h & b, T = e0(s), j = T.length, ae = e0(u), ge = ae.length;
        if (j != ge && !E)
          return !1;
        for (var ce = j; ce--; ) {
          var Fe = T[ce];
          if (!(E ? Fe in u : In.call(u, Fe)))
            return !1;
        }
        var ze = k.get(s), nt = k.get(u);
        if (ze && nt)
          return ze == u && nt == s;
        var Vt = !0;
        k.set(s, u), k.set(u, s);
        for (var rt = E; ++ce < j; ) {
          Fe = T[ce];
          var Nt = s[Fe], Pt = u[Fe];
          if (G)
            var mn = E ? G(Pt, Nt, Fe, u, s, k) : G(Nt, Pt, Fe, s, u, k);
          if (!(mn === i ? Nt === Pt || R(Nt, Pt, h, G, k) : mn)) {
            Vt = !1;
            break;
          }
          rt || (rt = Fe == "constructor");
        }
        if (Vt && !rt) {
          var pn = s.constructor, Cr = u.constructor;
          pn != Cr && "constructor" in s && "constructor" in u && !(typeof pn == "function" && pn instanceof pn && typeof Cr == "function" && Cr instanceof Cr) && (Vt = !1);
        }
        return k.delete(s), k.delete(u), Vt;
      }
      function as(s) {
        return s0(Ry(s, i, Fg), s + "");
      }
      function e0(s) {
        return Jp(s, kr, Wb);
      }
      function t0(s) {
        return Jp(s, Dg, Sy);
      }
      var i0 = Tu ? function(s) {
        return Tu.get(s);
      } : D0;
      function Gb(s) {
        for (var u = s.name + "", h = Qn[u], G = In.call(Qn, u) ? h.length : 0; G--; ) {
          var R = h[G], k = R.func;
          if (k == null || k == s)
            return R.name;
        }
        return u;
      }
      function rd(s) {
        var u = In.call(Q, "placeholder") ? Q : s;
        return u.placeholder;
      }
      function hi() {
        var s = Q.iteratee || F0;
        return s = s === F0 ? ab : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function yb(s, u) {
        var h = s.__data__;
        return rX(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
      }
      function n0(s) {
        for (var u = kr(s), h = u.length; h--; ) {
          var G = u[h], R = s[G];
          u[h] = [G, R, l0(R)];
        }
        return u;
      }
      function ic(s, u) {
        var h = xG(s, u);
        return Np(h) ? h : i;
      }
      function r0(s) {
        var u = In.call(s, zI), h = s[zI];
        try {
          s[zI] = i;
          var G = !0;
        } catch {
        }
        var R = PA.call(s);
        return G && (u ? s[zI] = h : delete s[zI]), R;
      }
      var Wb = Eu ? function(s) {
        return s == null ? [] : (s = sn(s), zs(Eu(s), function(u) {
          return TG.call(s, u);
        }));
      } : E0, Sy = Eu ? function(s) {
        for (var u = []; s; )
          Io(u, Wb(s)), s = ga(s);
        return u;
      } : E0, og = ng;
      (qA && og(new qA(new ArrayBuffer(1))) != Ge || Uc && og(new Uc()) != Qe || QI && og(QI.resolve()) != Bt || zc && og(new zc()) != Ht || Qs && og(new Qs()) != mi) && (og = function(s) {
        var u = ng(s), h = u == jt ? s.constructor : i, G = h ? nc(h) : "";
        if (G)
          switch (G) {
            case oa:
              return Ge;
            case Sp:
              return Qe;
            case _A:
              return Bt;
            case jI:
              return Ht;
            case OG:
              return mi;
          }
        return u;
      });
      function Vy(s, u, h) {
        for (var G = -1, R = h.length; ++G < R; ) {
          var k = h[G], E = k.size;
          switch (k.type) {
            case "drop":
              s += E;
              break;
            case "dropRight":
              u -= E;
              break;
            case "take":
              u = Ln(u, s + E);
              break;
            case "takeRight":
              s = Gr(s, u - E);
              break;
          }
        }
        return { start: s, end: u };
      }
      function $R(s) {
        var u = s.match(dt);
        return u ? u[1].split(xt) : [];
      }
      function eC(s, u, h) {
        u = $s(u, s);
        for (var G = -1, R = u.length, k = !1; ++G < R; ) {
          var E = Gl(u[G]);
          if (!(k = s != null && h(s, E)))
            break;
          s = s[E];
        }
        return k || ++G != R ? k : (R = s == null ? 0 : s.length, !!R && Eb(R) && ss(E, R) && (fi(s) || iI(s)));
      }
      function eX(s) {
        var u = s.length, h = new s.constructor(u);
        return u && typeof s[0] == "string" && In.call(s, "index") && (h.index = s.index, h.input = s.input), h;
      }
      function wy(s) {
        return typeof s.constructor == "function" && !gd(s) ? Oc(ga(s)) : {};
      }
      function tX(s, u, h) {
        var G = s.constructor;
        switch (u) {
          case ci:
            return pb(s);
          case Ze:
          case xe:
            return new G(+s);
          case Ge:
            return TR(s, h);
          case Be:
          case qe:
          case vt:
          case Kt:
          case Te:
          case Tt:
          case Ue:
          case Me:
          case Yt:
            return jp(s, h);
          case Qe:
            return new G();
          case $e:
          case ii:
            return new G(s);
          case Xt:
            return Qp(s);
          case Ht:
            return new G();
          case $t:
            return Cy(s);
        }
      }
      function iX(s, u) {
        var h = u.length;
        if (!h)
          return s;
        var G = h - 1;
        return u[G] = (h > 1 ? "& " : "") + u[G], u = u.join(h > 2 ? ", " : " "), s.replace(Et, `{
/* [wrapped with ` + u + `] */
`);
      }
      function nX(s) {
        return fi(s) || iI(s) || !!(MG && s && s[MG]);
      }
      function ss(s, u) {
        var h = typeof s;
        return u = u ?? $, !!u && (h == "number" || h != "symbol" && ti.test(s)) && s > -1 && s % 1 == 0 && s < u;
      }
      function Yg(s, u, h) {
        if (!Pn(h))
          return !1;
        var G = typeof u;
        return (G == "number" ? ag(h) && ss(u, h.length) : G == "string" && u in h) ? cn(h[u], s) : !1;
      }
      function g0(s, u) {
        if (fi(s))
          return !1;
        var h = typeof s;
        return h == "number" || h == "symbol" || h == "boolean" || s == null || bo(s) ? !0 : pe.test(s) || !Ce.test(s) || u != null && s in sn(u);
      }
      function rX(s) {
        var u = typeof s;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? s !== "__proto__" : s === null;
      }
      function o0(s) {
        var u = Gb(s), h = Q[u];
        if (typeof h != "function" || !(u in Di.prototype))
          return !1;
        if (s === h)
          return !0;
        var G = i0(h);
        return !!G && s === G[0];
      }
      function gX(s) {
        return !!NG && NG in s;
      }
      var oX = MA ? Oo : N0;
      function gd(s) {
        var u = s && s.constructor, h = typeof u == "function" && u.prototype || Pc;
        return s === h;
      }
      function l0(s) {
        return s === s && !Pn(s);
      }
      function vy(s, u) {
        return function(h) {
          return h == null ? !1 : h[s] === u && (u !== i || s in sn(h));
        };
      }
      function Sb(s) {
        var u = oC(s, function(G) {
          return h.size === I && h.clear(), G;
        }), h = u.cache;
        return u;
      }
      function lX(s, u) {
        var h = s[1], G = u[1], R = h | G, k = R < (p | B | w), E = G == w && h == Z || G == w && h == v && s[7].length <= u[8] || G == (w | v) && u[7].length <= u[8] && h == Z;
        if (!(k || E))
          return s;
        G & p && (s[2] = u[2], R |= h & p ? 0 : f);
        var T = u[3];
        if (T) {
          var j = s[3];
          s[3] = j ? tI(j, T, u[4]) : T, s[4] = j ? ra(s[3], c) : u[4];
        }
        return T = u[5], T && (j = s[5], s[5] = j ? Ay(j, T, u[6]) : T, s[6] = j ? ra(s[5], c) : u[6]), T = u[7], T && (s[7] = T), G & w && (s[8] = s[8] == null ? u[8] : Ln(s[8], u[8])), s[9] == null && (s[9] = u[9]), s[0] = u[0], s[1] = R, s;
      }
      function aX(s) {
        var u = [];
        if (s != null)
          for (var h in sn(s))
            u.push(h);
        return u;
      }
      function sX(s) {
        return PA.call(s);
      }
      function Ry(s, u, h) {
        return u = Gr(u === i ? s.length - 1 : u, 0), function() {
          for (var G = arguments, R = -1, k = Gr(G.length - u, 0), E = Y(k); ++R < k; )
            E[R] = G[u + R];
          R = -1;
          for (var T = Y(u + 1); ++R < u; )
            T[R] = G[R];
          return T[u] = h(E), nn(s, this, T);
        };
      }
      function Xy(s, u) {
        return u.length < 2 ? s : $I(s, Mo(u, 0, -1));
      }
      function IX(s, u) {
        for (var h = s.length, G = Ln(u.length, h), R = Hg(s); G--; ) {
          var k = u[G];
          s[G] = ss(k, h) ? R[k] : i;
        }
        return s;
      }
      function a0(s, u) {
        if (!(u === "constructor" && typeof s[u] == "function") && u != "__proto__")
          return s[u];
      }
      var Hy = c0(_s), tC = UG || function(s, u) {
        return pt.setTimeout(s, u);
      }, s0 = c0(NR);
      function I0(s, u, h) {
        var G = u + "";
        return s0(s, iX(G, Vb($R(G), h)));
      }
      function c0(s) {
        var u = 0, h = 0;
        return function() {
          var G = Wp(), R = M - (G - h);
          if (h = G, R > 0) {
            if (++u >= K)
              return arguments[0];
          } else
            u = 0;
          return s.apply(i, arguments);
        };
      }
      function iC(s, u) {
        var h = -1, G = s.length, R = G - 1;
        for (u = u === i ? G : u; ++h < u; ) {
          var k = ju(h, R), E = s[k];
          s[k] = s[h], s[h] = E;
        }
        return s.length = u, s;
      }
      var d0 = Sb(function(s) {
        var u = [];
        return s.charCodeAt(0) === 46 && u.push(""), s.replace(Ne, function(h, G, R, k) {
          u.push(R ? k.replace(Li, "$1") : G || h);
        }), u;
      });
      function Gl(s) {
        if (typeof s == "string" || bo(s))
          return s;
        var u = s + "";
        return u == "0" && 1 / s == -O ? "-0" : u;
      }
      function nc(s) {
        if (s != null) {
          try {
            return Ko.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function Vb(s, u) {
        return Lr(ke, function(h) {
          var G = "_." + h[0];
          u & h[1] && !xu(s, G) && s.push(G);
        }), s.sort();
      }
      function nC(s) {
        if (s instanceof Di)
          return s.clone();
        var u = new To(s.__wrapped__, s.__chain__);
        return u.__actions__ = Hg(s.__actions__), u.__index__ = s.__index__, u.__values__ = s.__values__, u;
      }
      function cX(s, u, h) {
        (h ? Yg(s, u, h) : u === i) ? u = 1 : u = Gr(oi(u), 0);
        var G = s == null ? 0 : s.length;
        if (!G || u < 1)
          return [];
        for (var R = 0, k = 0, E = Y(QA(G / u)); R < G; )
          E[k++] = Mo(s, R, R += u);
        return E;
      }
      function dX(s) {
        for (var u = -1, h = s == null ? 0 : s.length, G = 0, R = []; ++u < h; ) {
          var k = s[u];
          k && (R[G++] = k);
        }
        return R;
      }
      function uX() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var u = Y(s - 1), h = arguments[0], G = s; G--; )
          u[G - 1] = arguments[G];
        return Io(fi(h) ? Hg(h) : [h], yr(u, 1));
      }
      var CX = Si(function(s, u) {
        return lr(s) ? _I(s, yr(u, 1, lr, !0)) : [];
      }), AX = Si(function(s, u) {
        var h = xg(u);
        return lr(h) && (h = i), lr(s) ? _I(s, yr(u, 1, lr, !0), hi(h, 2)) : [];
      }), bX = Si(function(s, u) {
        var h = xg(u);
        return lr(h) && (h = i), lr(s) ? _I(s, yr(u, 1, lr, !0), i, h) : [];
      });
      function hX(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === i ? 1 : oi(u), Mo(s, u < 0 ? 0 : u, G)) : [];
      }
      function mX(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === i ? 1 : oi(u), u = G - u, Mo(s, 0, u < 0 ? 0 : u)) : [];
      }
      function pX(s, u) {
        return s && s.length ? Ab(s, hi(u, 3), !0, !0) : [];
      }
      function BX(s, u) {
        return s && s.length ? Ab(s, hi(u, 3), !0) : [];
      }
      function fX(s, u, h, G) {
        var R = s == null ? 0 : s.length;
        return R ? (h && typeof h != "number" && Yg(s, u, h) && (h = 0, G = R), qs(s, u, h, G)) : [];
      }
      function ky(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = h == null ? 0 : oi(h);
        return R < 0 && (R = Gr(G + R, 0)), KA(s, hi(u, 3), R);
      }
      function Po(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = G - 1;
        return h !== i && (R = oi(h), R = h < 0 ? Gr(G + R, 0) : Ln(R, G - 1)), KA(s, hi(u, 3), R, !0);
      }
      function Fg(s) {
        var u = s == null ? 0 : s.length;
        return u ? yr(s, 1) : [];
      }
      function or(s) {
        var u = s == null ? 0 : s.length;
        return u ? yr(s, O) : [];
      }
      function ZX(s, u) {
        var h = s == null ? 0 : s.length;
        return h ? (u = u === i ? 1 : oi(u), yr(s, u)) : [];
      }
      function GX(s) {
        for (var u = -1, h = s == null ? 0 : s.length, G = {}; ++u < h; ) {
          var R = s[u];
          G[R[0]] = R[1];
        }
        return G;
      }
      function Yy(s) {
        return s && s.length ? s[0] : i;
      }
      function yX(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = h == null ? 0 : oi(h);
        return R < 0 && (R = Gr(G + R, 0)), Tc(s, u, R);
      }
      function WX(s) {
        var u = s == null ? 0 : s.length;
        return u ? Mo(s, 0, -1) : [];
      }
      var u0 = Si(function(s) {
        var u = Xn(s, hb);
        return u.length && u[0] === s[0] ? jc(u) : [];
      }), SX = Si(function(s) {
        var u = xg(s), h = Xn(s, hb);
        return u === xg(h) ? u = i : h.pop(), h.length && h[0] === s[0] ? jc(h, hi(u, 2)) : [];
      }), Is = Si(function(s) {
        var u = xg(s), h = Xn(s, hb);
        return u = typeof u == "function" ? u : i, u && h.pop(), h.length && h[0] === s[0] ? jc(h, i, u) : [];
      });
      function Fy(s, u) {
        return s == null ? "" : BR.call(s, u);
      }
      function xg(s) {
        var u = s == null ? 0 : s.length;
        return u ? s[u - 1] : i;
      }
      function Mn(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = G;
        return h !== i && (R = oi(h), R = R < 0 ? Gr(G + R, 0) : Ln(R, G - 1)), u === u ? EG(s, u, R) : KA(s, Ap, R, !0);
      }
      function jn(s, u) {
        return s && s.length ? Kp(s, oi(u)) : i;
      }
      var VX = Si(xy);
      function xy(s, u) {
        return s && s.length && u && u.length ? Pp(s, u) : s;
      }
      function wX(s, u, h) {
        return s && s.length && u && u.length ? Pp(s, u, hi(h, 2)) : s;
      }
      function vX(s, u, h) {
        return s && s.length && u && u.length ? Pp(s, u, i, h) : s;
      }
      var RX = as(function(s, u) {
        var h = s == null ? 0 : s.length, G = Xg(s, u);
        return da(s, Xn(u, function(R) {
          return ss(R, h) ? +R : R;
        }).sort(qu)), G;
      });
      function XX(s, u) {
        var h = [];
        if (!(s && s.length))
          return h;
        var G = -1, R = [], k = s.length;
        for (u = hi(u, 3); ++G < k; ) {
          var E = s[G];
          u(E, G, s) && (h.push(E), R.push(G));
        }
        return da(s, R), h;
      }
      function wb(s) {
        return s == null ? s : fR.call(s);
      }
      function rC(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (h && typeof h != "number" && Yg(s, u, h) ? (u = 0, h = G) : (u = u == null ? 0 : oi(u), h = h === i ? G : oi(h)), Mo(s, u, h)) : [];
      }
      function HX(s, u) {
        return db(s, u);
      }
      function vb(s, u, h) {
        return ub(s, u, hi(h, 2));
      }
      function Ao(s, u) {
        var h = s == null ? 0 : s.length;
        if (h) {
          var G = db(s, u);
          if (G < h && cn(s[G], u))
            return G;
        }
        return -1;
      }
      function kX(s, u) {
        return db(s, u, !0);
      }
      function YX(s, u, h) {
        return ub(s, u, hi(h, 2), !0);
      }
      function FX(s, u) {
        var h = s == null ? 0 : s.length;
        if (h) {
          var G = db(s, u, !0) - 1;
          if (cn(s[G], u))
            return G;
        }
        return -1;
      }
      function Dy(s) {
        return s && s.length ? cy(s) : [];
      }
      function cs(s, u) {
        return s && s.length ? cy(s, hi(u, 2)) : [];
      }
      function Fi(s) {
        var u = s == null ? 0 : s.length;
        return u ? Mo(s, 1, u) : [];
      }
      function Jy(s, u, h) {
        return s && s.length ? (u = h || u === i ? 1 : oi(u), Mo(s, 0, u < 0 ? 0 : u)) : [];
      }
      function Uo(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === i ? 1 : oi(u), u = G - u, Mo(s, u < 0 ? 0 : u, G)) : [];
      }
      function Ey(s, u) {
        return s && s.length ? Ab(s, hi(u, 3), !1, !0) : [];
      }
      function xX(s, u) {
        return s && s.length ? Ab(s, hi(u, 3)) : [];
      }
      var gn = Si(function(s) {
        return gg(yr(s, 1, lr, !0));
      }), DX = Si(function(s) {
        var u = xg(s);
        return lr(u) && (u = i), gg(yr(s, 1, lr, !0), hi(u, 2));
      }), JX = Si(function(s) {
        var u = xg(s);
        return u = typeof u == "function" ? u : i, gg(yr(s, 1, lr, !0), i, u);
      });
      function EX(s) {
        return s && s.length ? gg(s) : [];
      }
      function NX(s, u) {
        return s && s.length ? gg(s, hi(u, 2)) : [];
      }
      function LX(s, u) {
        return u = typeof u == "function" ? u : i, s && s.length ? gg(s, i, u) : [];
      }
      function C0(s) {
        if (!(s && s.length))
          return [];
        var u = 0;
        return s = zs(s, function(h) {
          if (lr(h))
            return u = Gr(h.length, u), !0;
        }), Bp(u, function(h) {
          return Xn(s, bp(h));
        });
      }
      function Ny(s, u) {
        if (!(s && s.length))
          return [];
        var h = C0(s);
        return u == null ? h : Xn(h, function(G) {
          return nn(u, i, G);
        });
      }
      var KX = Si(function(s, u) {
        return lr(s) ? _I(s, u) : [];
      }), TX = Si(function(s) {
        return zp(zs(s, lr));
      }), A0 = Si(function(s) {
        var u = xg(s);
        return lr(u) && (u = i), zp(zs(s, lr), hi(u, 2));
      }), MX = Si(function(s) {
        var u = xg(s);
        return u = typeof u == "function" ? u : i, zp(zs(s, lr), i, u);
      }), b0 = Si(C0);
      function Hr(s, u) {
        return td(s || [], u || [], ig);
      }
      function _g(s, u) {
        return td(s || [], u || [], ec);
      }
      var PX = Si(function(s) {
        var u = s.length, h = u > 1 ? s[u - 1] : i;
        return h = typeof h == "function" ? (s.pop(), h) : i, Ny(s, h);
      });
      function Ly(s) {
        var u = Q(s);
        return u.__chain__ = !0, u;
      }
      function UX(s, u) {
        return u(s), s;
      }
      function gC(s, u) {
        return u(s);
      }
      var zX = as(function(s) {
        var u = s.length, h = u ? s[0] : 0, G = this.__wrapped__, R = function(k) {
          return Xg(k, s);
        };
        return u > 1 || this.__actions__.length || !(G instanceof Di) || !ss(h) ? this.thru(R) : (G = G.slice(h, +h + (u ? 1 : 0)), G.__actions__.push({
          func: gC,
          args: [R],
          thisArg: i
        }), new To(G, this.__chain__).thru(function(k) {
          return u && !k.length && k.push(i), k;
        }));
      });
      function OX() {
        return Ly(this);
      }
      function QX() {
        return new To(this.value(), this.__chain__);
      }
      function jX() {
        this.__values__ === i && (this.__values__ = rW(this.value()));
        var s = this.__index__ >= this.__values__.length, u = s ? i : this.__values__[this.__index__++];
        return { done: s, value: u };
      }
      function qX() {
        return this;
      }
      function _X(s) {
        for (var u, h = this; h instanceof Qc; ) {
          var G = nC(h);
          G.__index__ = 0, G.__values__ = i, u ? R.__wrapped__ = G : u = G;
          var R = G;
          h = h.__wrapped__;
        }
        return R.__wrapped__ = s, u;
      }
      function $X() {
        var s = this.__wrapped__;
        if (s instanceof Di) {
          var u = s;
          return this.__actions__.length && (u = new Di(this)), u = u.reverse(), u.__actions__.push({
            func: gC,
            args: [wb],
            thisArg: i
          }), new To(u, this.__chain__);
        }
        return this.thru(wb);
      }
      function od() {
        return bb(this.__wrapped__, this.__actions__);
      }
      var eH = Bb(function(s, u, h) {
        In.call(s, h) ? ++s[h] : aa(s, h, 1);
      });
      function tH(s, u, h) {
        var G = fi(s) ? NA : Fp;
        return h && Yg(s, u, h) && (u = i), G(s, hi(u, 3));
      }
      function iH(s, u) {
        var h = fi(s) ? zs : xp;
        return h(s, hi(u, 3));
      }
      var nH = my(ky), Ky = my(Po);
      function Ty(s, u) {
        return yr(Rb(s, u), 1);
      }
      function rH(s, u) {
        return yr(Rb(s, u), O);
      }
      function gH(s, u, h) {
        return h = h === i ? 1 : oi(h), yr(Rb(s, u), h);
      }
      function My(s, u) {
        var h = fi(s) ? Lr : gs;
        return h(s, hi(u, 3));
      }
      function Py(s, u) {
        var h = fi(s) ? EA : nb;
        return h(s, hi(u, 3));
      }
      var oH = Bb(function(s, u, h) {
        In.call(s, h) ? s[h].push(u) : aa(s, h, [u]);
      });
      function lH(s, u, h, G) {
        s = ag(s) ? s : cd(s), h = h && !G ? oi(h) : 0;
        var R = s.length;
        return h < 0 && (h = Gr(R + h, 0)), Mb(s) ? h <= R && s.indexOf(u, h) > -1 : !!R && Tc(s, u, h) > -1;
      }
      var aH = Si(function(s, u, h) {
        var G = -1, R = typeof u == "function", k = ag(s) ? Y(s.length) : [];
        return gs(s, function(E) {
          k[++G] = R ? nn(u, E, h) : _c(E, u, h);
        }), k;
      }), sH = Bb(function(s, u, h) {
        aa(s, h, u);
      });
      function Rb(s, u) {
        var h = fi(s) ? Xn : Ou;
        return h(s, hi(u, 3));
      }
      function IH(s, u, h, G) {
        return s == null ? [] : (fi(u) || (u = u == null ? [] : [u]), h = G ? i : h, fi(h) || (h = h == null ? [] : [h]), Tp(s, u, h));
      }
      var cH = Bb(function(s, u, h) {
        s[h ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      });
      function dH(s, u, h) {
        var G = fi(s) ? LA : HG, R = arguments.length < 3;
        return G(s, hi(u, 4), h, R, gs);
      }
      function uH(s, u, h) {
        var G = fi(s) ? VG : HG, R = arguments.length < 3;
        return G(s, hi(u, 4), h, R, nb);
      }
      function CH(s, u) {
        var h = fi(s) ? zs : xp;
        return h(s, Fb(hi(u, 3)));
      }
      function AH(s) {
        var u = fi(s) ? ry : bi;
        return u(s);
      }
      function bH(s, u, h) {
        (h ? Yg(s, u, h) : u === i) ? u = 1 : u = oi(u);
        var G = fi(s) ? HR : cb;
        return G(s, u);
      }
      function hH(s) {
        var u = fi(s) ? Mu : LR;
        return u(s);
      }
      function mH(s) {
        if (s == null)
          return 0;
        if (ag(s))
          return Mb(s) ? PI(s) : s.length;
        var u = og(s);
        return u == Qe || u == Ht ? s.size : $c(s).length;
      }
      function pH(s, u, h) {
        var G = fi(s) ? up : Iy;
        return h && Yg(s, u, h) && (u = i), G(s, hi(u, 3));
      }
      var Uy = Si(function(s, u) {
        if (s == null)
          return [];
        var h = u.length;
        return h > 1 && Yg(s, u[0], u[1]) ? u = [] : h > 2 && Yg(u[0], u[1], u[2]) && (u = [u[0]]), Tp(s, yr(u, 1), []);
      }), Xb = PG || function() {
        return pt.Date.now();
      };
      function BH(s, u) {
        if (typeof u != "function")
          throw new Lo(o);
        return s = oi(s), function() {
          if (--s < 1)
            return u.apply(this, arguments);
        };
      }
      function Hb(s, u, h) {
        return u = h ? i : u, u = s && u == null ? s.length : u, ls(s, w, i, i, i, i, u);
      }
      function zy(s, u) {
        var h;
        if (typeof u != "function")
          throw new Lo(o);
        return s = oi(s), function() {
          return --s > 0 && (h = u.apply(this, arguments)), s <= 1 && (u = i), h;
        };
      }
      var lg = Si(function(s, u, h) {
        var G = p;
        if (h.length) {
          var R = ra(h, rd(lg));
          G |= W;
        }
        return ls(s, G, u, h, R);
      }), kb = Si(function(s, u, h) {
        var G = p | B;
        if (h.length) {
          var R = ra(h, rd(kb));
          G |= W;
        }
        return ls(u, G, s, h, R);
      });
      function Oy(s, u, h) {
        u = h ? i : u;
        var G = ls(s, Z, i, i, i, i, i, u);
        return G.placeholder = Oy.placeholder, G;
      }
      function Qy(s, u, h) {
        u = h ? i : u;
        var G = ls(s, y, i, i, i, i, i, u);
        return G.placeholder = Qy.placeholder, G;
      }
      function Yb(s, u, h) {
        var G, R, k, E, T, j, ae = 0, ge = !1, ce = !1, Fe = !0;
        if (typeof s != "function")
          throw new Lo(o);
        u = Qo(u) || 0, Pn(h) && (ge = !!h.leading, ce = "maxWait" in h, k = ce ? Gr(Qo(h.maxWait) || 0, u) : k, Fe = "trailing" in h ? !!h.trailing : Fe);
        function ze(Hi) {
          var qn = G, ho = R;
          return G = R = i, ae = Hi, E = s.apply(ho, qn), E;
        }
        function nt(Hi) {
          return ae = Hi, T = tC(Nt, u), ge ? ze(Hi) : E;
        }
        function Vt(Hi) {
          var qn = Hi - j, ho = Hi - ae, K0 = u - qn;
          return ce ? Ln(K0, k - ho) : K0;
        }
        function rt(Hi) {
          var qn = Hi - j, ho = Hi - ae;
          return j === i || qn >= u || qn < 0 || ce && ho >= k;
        }
        function Nt() {
          var Hi = Xb();
          if (rt(Hi))
            return Pt(Hi);
          T = tC(Nt, Vt(Hi));
        }
        function Pt(Hi) {
          return T = i, Fe && G ? ze(Hi) : (G = R = i, E);
        }
        function mn() {
          T !== i && uy(T), ae = 0, G = j = R = T = i;
        }
        function pn() {
          return T === i ? E : Pt(Xb());
        }
        function Cr() {
          var Hi = Xb(), qn = rt(Hi);
          if (G = arguments, R = this, j = Hi, qn) {
            if (T === i)
              return nt(j);
            if (ce)
              return uy(T), T = tC(Nt, u), ze(j);
          }
          return T === i && (T = tC(Nt, u)), E;
        }
        return Cr.cancel = mn, Cr.flush = pn, Cr;
      }
      var fH = Si(function(s, u) {
        return Yp(s, 1, u);
      }), h0 = Si(function(s, u, h) {
        return Yp(s, Qo(u) || 0, h);
      });
      function ZH(s) {
        return ls(s, H);
      }
      function oC(s, u) {
        if (typeof s != "function" || u != null && typeof u != "function")
          throw new Lo(o);
        var h = function() {
          var G = arguments, R = u ? u.apply(this, G) : G[0], k = h.cache;
          if (k.has(R))
            return k.get(R);
          var E = s.apply(this, G);
          return h.cache = k.set(R, E) || k, E;
        };
        return h.cache = new (oC.Cache || la)(), h;
      }
      oC.Cache = la;
      function Fb(s) {
        if (typeof s != "function")
          throw new Lo(o);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, u[0]);
            case 2:
              return !s.call(this, u[0], u[1]);
            case 3:
              return !s.call(this, u[0], u[1], u[2]);
          }
          return !s.apply(this, u);
        };
      }
      function m0(s) {
        return zy(2, s);
      }
      var p0 = KR(function(s, u) {
        u = u.length == 1 && fi(u[0]) ? Xn(u[0], co(hi())) : Xn(yr(u, 1), co(hi()));
        var h = u.length;
        return Si(function(G) {
          for (var R = -1, k = Ln(G.length, h); ++R < k; )
            G[R] = u[R].call(this, G[R]);
          return nn(s, this, G);
        });
      }), B0 = Si(function(s, u) {
        var h = ra(u, rd(B0));
        return ls(s, W, i, u, h);
      }), jy = Si(function(s, u) {
        var h = ra(u, rd(jy));
        return ls(s, V, i, u, h);
      }), GH = as(function(s, u) {
        return ls(s, v, i, i, i, u);
      });
      function yH(s, u) {
        if (typeof s != "function")
          throw new Lo(o);
        return u = u === i ? u : oi(u), Si(s, u);
      }
      function WH(s, u) {
        if (typeof s != "function")
          throw new Lo(o);
        return u = u == null ? 0 : Gr(oi(u), 0), Si(function(h) {
          var G = h[u], R = eI(h, 0, u);
          return G && Io(R, G), nn(s, this, R);
        });
      }
      function SH(s, u, h) {
        var G = !0, R = !0;
        if (typeof s != "function")
          throw new Lo(o);
        return Pn(h) && (G = "leading" in h ? !!h.leading : G, R = "trailing" in h ? !!h.trailing : R), Yb(s, u, {
          leading: G,
          maxWait: u,
          trailing: R
        });
      }
      function VH(s) {
        return Hb(s, 1);
      }
      function wH(s, u) {
        return B0(mb(u), s);
      }
      function vH() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return fi(s) ? s : [s];
      }
      function RH(s) {
        return qg(s, A);
      }
      function XH(s, u) {
        return u = typeof u == "function" ? u : i, qg(s, A, u);
      }
      function HH(s) {
        return qg(s, d | A);
      }
      function kH(s, u) {
        return u = typeof u == "function" ? u : i, qg(s, d | A, u);
      }
      function YH(s, u) {
        return u == null || Pu(s, u, kr(u));
      }
      function cn(s, u) {
        return s === u || s !== s && u !== u;
      }
      var xb = $u(rg), f0 = $u(function(s, u) {
        return s >= u;
      }), iI = Ep(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ep : function(s) {
        return xn(s) && In.call(s, "callee") && !TG.call(s, "callee");
      }, fi = Y.isArray, Fn = Yn ? co(Yn) : FR;
      function ag(s) {
        return s != null && Eb(s.length) && !Oo(s);
      }
      function lr(s) {
        return xn(s) && ag(s);
      }
      function zo(s) {
        return s === !0 || s === !1 || xn(s) && ng(s) == Ze;
      }
      var yl = Nu || N0, FH = gi ? co(gi) : ay;
      function ld(s) {
        return xn(s) && s.nodeType === 1 && !us(s);
      }
      function Db(s) {
        if (s == null)
          return !0;
        if (ag(s) && (fi(s) || typeof s == "string" || typeof s.splice == "function" || yl(s) || As(s) || iI(s)))
          return !s.length;
        var u = og(s);
        if (u == Qe || u == Ht)
          return !s.size;
        if (gd(s))
          return !$c(s).length;
        for (var h in s)
          if (In.call(s, h))
            return !1;
        return !0;
      }
      function Jb(s, u) {
        return ca(s, u);
      }
      function dn(s, u, h) {
        h = typeof h == "function" ? h : i;
        var G = h ? h(s, u) : i;
        return G === i ? ca(s, u, i, h) : !!G;
      }
      function Z0(s) {
        if (!xn(s))
          return !1;
        var u = ng(s);
        return u == st || u == Pe || typeof s.message == "string" && typeof s.name == "string" && !us(s);
      }
      function qy(s) {
        return typeof s == "number" && Lu(s);
      }
      function Oo(s) {
        if (!Pn(s))
          return !1;
        var u = ng(s);
        return u == bt || u == it || u == Xe || u == te;
      }
      function _y(s) {
        return typeof s == "number" && s == oi(s);
      }
      function Eb(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= $;
      }
      function Pn(s) {
        var u = typeof s;
        return s != null && (u == "object" || u == "function");
      }
      function xn(s) {
        return s != null && typeof s == "object";
      }
      var ds = Yi ? co(Yi) : xR;
      function Nb(s, u) {
        return s === u || gb(s, u, n0(u));
      }
      function $y(s, u, h) {
        return h = typeof h == "function" ? h : i, gb(s, u, n0(u), h);
      }
      function Lb(s) {
        return G0(s) && s != +s;
      }
      function eW(s) {
        if (oX(s))
          throw new ct(g);
        return Np(s);
      }
      function tW(s) {
        return s === null;
      }
      function Kb(s) {
        return s == null;
      }
      function G0(s) {
        return typeof s == "number" || xn(s) && ng(s) == $e;
      }
      function us(s) {
        if (!xn(s) || ng(s) != jt)
          return !1;
        var u = ga(s);
        if (u === null)
          return !0;
        var h = In.call(u, "constructor") && u.constructor;
        return typeof h == "function" && h instanceof h && Ko.call(h) == hR;
      }
      var Cs = dr ? co(dr) : ob;
      function Tb(s) {
        return _y(s) && s >= -$ && s <= $;
      }
      var iW = On ? co(On) : sy;
      function Mb(s) {
        return typeof s == "string" || !fi(s) && xn(s) && ng(s) == ii;
      }
      function bo(s) {
        return typeof s == "symbol" || xn(s) && ng(s) == $t;
      }
      var As = ur ? co(ur) : lb;
      function Pb(s) {
        return s === i;
      }
      function y0(s) {
        return xn(s) && og(s) == mi;
      }
      function xH(s) {
        return xn(s) && ng(s) == Bi;
      }
      var nW = $u(sb), DH = $u(function(s, u) {
        return s <= u;
      });
      function rW(s) {
        if (!s)
          return [];
        if (ag(s))
          return Mb(s) ? No(s) : Hg(s);
        if (Ju && s[Ju])
          return fp(s[Ju]());
        var u = og(s), h = u == Qe ? is : u == Ht ? Rg : cd;
        return h(s);
      }
      function Wn(s) {
        if (!s)
          return s === 0 ? s : 0;
        if (s = Qo(s), s === O || s === -O) {
          var u = s < 0 ? -1 : 1;
          return u * ne;
        }
        return s === s ? s : 0;
      }
      function oi(s) {
        var u = Wn(s), h = u % 1;
        return u === u ? h ? u - h : u : 0;
      }
      function gW(s) {
        return s ? jg(oi(s), 0, Ve) : 0;
      }
      function Qo(s) {
        if (typeof s == "number")
          return s;
        if (bo(s))
          return be;
        if (Pn(s)) {
          var u = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Pn(u) ? u + "" : u;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = kG(s);
        var h = _e.test(s);
        return h || kt.test(s) ? Ye(s.slice(2), h ? 2 : 8) : gt.test(s) ? be : +s;
      }
      function W0(s) {
        return Ca(s, Dg(s));
      }
      function JH(s) {
        return s ? jg(oi(s), -$, $) : s === 0 ? s : 0;
      }
      function _i(s) {
        return s == null ? "" : Co(s);
      }
      var lC = id(function(s, u) {
        if (gd(u) || ag(u)) {
          Ca(u, kr(u), s);
          return;
        }
        for (var h in u)
          In.call(u, h) && ig(s, h, u[h]);
      }), Ub = id(function(s, u) {
        Ca(u, Dg(u), s);
      }), bs = id(function(s, u, h, G) {
        Ca(u, Dg(u), s, G);
      }), aC = id(function(s, u, h, G) {
        Ca(u, kr(u), s, G);
      }), sC = as(Xg);
      function zb(s, u) {
        var h = Oc(s);
        return u == null ? h : ib(h, u);
      }
      var ad = Si(function(s, u) {
        s = sn(s);
        var h = -1, G = u.length, R = G > 2 ? u[2] : i;
        for (R && Yg(u[0], u[1], R) && (G = 1); ++h < G; )
          for (var k = u[h], E = Dg(k), T = -1, j = E.length; ++T < j; ) {
            var ae = E[T], ge = s[ae];
            (ge === i || cn(ge, Pc[ae]) && !In.call(s, ae)) && (s[ae] = k[ae]);
          }
        return s;
      }), EH = Si(function(s) {
        return s.push(i, yy), nn(w0, i, s);
      });
      function NH(s, u) {
        return Cp(s, hi(u, 3), sa);
      }
      function LH(s, u) {
        return Cp(s, hi(u, 3), rb);
      }
      function KH(s, u) {
        return s == null ? s : Dp(s, hi(u, 3), Dg);
      }
      function TH(s, u) {
        return s == null ? s : ly(s, hi(u, 3), Dg);
      }
      function Ob(s, u) {
        return s && sa(s, hi(u, 3));
      }
      function IC(s, u) {
        return s && rb(s, hi(u, 3));
      }
      function oW(s) {
        return s == null ? [] : Uu(s, kr(s));
      }
      function sd(s) {
        return s == null ? [] : Uu(s, Dg(s));
      }
      function Aa(s, u, h) {
        var G = s == null ? i : $I(s, u);
        return G === i ? h : G;
      }
      function lW(s, u) {
        return s != null && eC(s, u, Ia);
      }
      function cC(s, u) {
        return s != null && eC(s, u, kR);
      }
      var aW = By(function(s, u, h) {
        u != null && typeof u.toString != "function" && (u = PA.call(u)), s[u] = h;
      }, Y0(Mr)), sW = By(function(s, u, h) {
        u != null && typeof u.toString != "function" && (u = PA.call(u)), In.call(s, u) ? s[u].push(h) : s[u] = [h];
      }, hi), MH = Si(_c);
      function kr(s) {
        return ag(s) ? Ji(s) : $c(s);
      }
      function Dg(s) {
        return ag(s) ? Ji(s, !0) : DR(s);
      }
      function PH(s, u) {
        var h = {};
        return u = hi(u, 3), sa(s, function(G, R, k) {
          aa(h, u(G, R, k), G);
        }), h;
      }
      function S0(s, u) {
        var h = {};
        return u = hi(u, 3), sa(s, function(G, R, k) {
          aa(h, R, u(G, R, k));
        }), h;
      }
      var V0 = id(function(s, u, h) {
        Qu(s, u, h);
      }), w0 = id(function(s, u, h, G) {
        Qu(s, u, h, G);
      }), sg = as(function(s, u) {
        var h = {};
        if (s == null)
          return h;
        var G = !1;
        u = Xn(u, function(k) {
          return k = $s(k, s), G || (G = k.length > 1), k;
        }), Ca(s, t0(s), h), G && (h = qg(h, d | C | A, jR));
        for (var R = u.length; R--; )
          Tr(h, u[R]);
        return h;
      });
      function UH(s, u) {
        return Id(s, Fb(hi(u)));
      }
      var IW = as(function(s, u) {
        return s == null ? {} : JR(s, u);
      });
      function Id(s, u) {
        if (s == null)
          return {};
        var h = Xn(t0(s), function(G) {
          return [G];
        });
        return u = hi(u), Mp(s, h, function(G, R) {
          return u(G, R[0]);
        });
      }
      function v0(s, u, h) {
        u = $s(u, s);
        var G = -1, R = u.length;
        for (R || (R = 1, s = i); ++G < R; ) {
          var k = s == null ? i : s[Gl(u[G])];
          k === i && (G = R, k = h), s = Oo(k) ? k.call(s) : k;
        }
        return s;
      }
      function cW(s, u, h) {
        return s == null ? s : ec(s, u, h);
      }
      function zH(s, u, h, G) {
        return G = typeof G == "function" ? G : i, s == null ? s : ec(s, u, h, G);
      }
      var dW = Zb(kr), uW = Zb(Dg);
      function OH(s, u, h) {
        var G = fi(s), R = G || yl(s) || As(s);
        if (u = hi(u, 4), h == null) {
          var k = s && s.constructor;
          R ? h = G ? new k() : [] : Pn(s) ? h = Oo(k) ? Oc(ga(s)) : {} : h = {};
        }
        return (R ? Lr : sa)(s, function(E, T, j) {
          return u(h, E, T, j);
        }), h;
      }
      function QH(s, u) {
        return s == null ? !0 : Tr(s, u);
      }
      function jH(s, u, h) {
        return s == null ? s : Cb(s, u, mb(h));
      }
      function qH(s, u, h, G) {
        return G = typeof G == "function" ? G : i, s == null ? s : Cb(s, u, mb(h), G);
      }
      function cd(s) {
        return s == null ? [] : yn(s, kr(s));
      }
      function _H(s) {
        return s == null ? [] : yn(s, Dg(s));
      }
      function $H(s, u, h) {
        return h === i && (h = u, u = i), h !== i && (h = Qo(h), h = h === h ? h : 0), u !== i && (u = Qo(u), u = u === u ? u : 0), jg(Qo(s), u, h);
      }
      function ek(s, u, h) {
        return u = Wn(u), h === i ? (h = u, u = 0) : h = Wn(h), s = Qo(s), YR(s, u, h);
      }
      function tk(s, u, h) {
        if (h && typeof h != "boolean" && Yg(s, u, h) && (u = h = i), h === i && (typeof u == "boolean" ? (h = u, u = i) : typeof s == "boolean" && (h = s, s = i)), s === i && u === i ? (s = 0, u = 1) : (s = Wn(s), u === i ? (u = s, s = 0) : u = Wn(u)), s > u) {
          var G = s;
          s = u, u = G;
        }
        if (h || s % 1 || u % 1) {
          var R = uo();
          return Ln(s + R * (u - s + he("1e-" + ((R + "").length - 1))), u);
        }
        return ju(s, u);
      }
      var ik = tc(function(s, u, h) {
        return u = u.toLowerCase(), s + (h ? CW(u) : u);
      });
      function CW(s) {
        return ba(_i(s).toLowerCase());
      }
      function AW(s) {
        return s = _i(s), s && s.replace(tn, lR).replace(ap, "");
      }
      function nk(s, u, h) {
        s = _i(s), u = Co(u);
        var G = s.length;
        h = h === i ? G : jg(oi(h), 0, G);
        var R = h;
        return h -= u.length, h >= 0 && s.slice(h, R) == u;
      }
      function rk(s) {
        return s = _i(s), s && Ui.test(s) ? s.replace(Ai, aR) : s;
      }
      function gk(s) {
        return s = _i(s), s && Jt.test(s) ? s.replace(Ke, "\\$&") : s;
      }
      var ok = tc(function(s, u, h) {
        return s + (h ? "-" : "") + u.toLowerCase();
      }), lk = tc(function(s, u, h) {
        return s + (h ? " " : "") + u.toLowerCase();
      }), ak = qp("toLowerCase");
      function sk(s, u, h) {
        s = _i(s), u = oi(u);
        var G = u ? PI(s) : 0;
        if (!u || G >= u)
          return s;
        var R = (u - G) / 2;
        return kg(jA(R), h) + s + kg(QA(R), h);
      }
      function Ik(s, u, h) {
        s = _i(s), u = oi(u);
        var G = u ? PI(s) : 0;
        return u && G < u ? s + kg(u - G, h) : s;
      }
      function ck(s, u, h) {
        s = _i(s), u = oi(u);
        var G = u ? PI(s) : 0;
        return u && G < u ? kg(u - G, h) + s : s;
      }
      function dk(s, u, h) {
        return h || u == null ? u = 0 : u && (u = +u), OI(_i(s).replace(Rt, ""), u || 0);
      }
      function uk(s, u, h) {
        return (h ? Yg(s, u, h) : u === i) ? u = 1 : u = oi(u), ed(_i(s), u);
      }
      function Qb() {
        var s = arguments, u = _i(s[0]);
        return s.length < 3 ? u : u.replace(s[1], s[2]);
      }
      var R0 = tc(function(s, u, h) {
        return s + (h ? "_" : "") + u.toLowerCase();
      });
      function bW(s, u, h) {
        return h && typeof h != "number" && Yg(s, u, h) && (u = h = i), h = h === i ? Ve : h >>> 0, h ? (s = _i(s), s && (typeof u == "string" || u != null && !Cs(u)) && (u = Co(u), !u && Mc(s)) ? eI(No(s), 0, h) : s.split(u, h)) : [];
      }
      var Ck = tc(function(s, u, h) {
        return s + (h ? " " : "") + ba(u);
      });
      function Ak(s, u, h) {
        return s = _i(s), h = h == null ? 0 : jg(oi(h), 0, s.length), u = Co(u), s.slice(h, h + u.length) == u;
      }
      function bk(s, u, h) {
        var G = Q.templateSettings;
        h && Yg(s, u, h) && (u = i), s = _i(s), u = bs({}, u, G, Gy);
        var R = bs({}, u.imports, G.imports, Gy), k = kr(R), E = yn(R, k), T, j, ae = 0, ge = u.interpolate || ao, ce = "__p += '", Fe = yp(
          (u.escape || ao).source + "|" + ge.source + "|" + (ge === le ? fe : ao).source + "|" + (u.evaluate || ao).source + "|$",
          "g"
        ), ze = "//# sourceURL=" + (In.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++dp + "]") + `
`;
        s.replace(Fe, function(rt, Nt, Pt, mn, pn, Cr) {
          return Pt || (Pt = mn), ce += s.slice(ae, Cr).replace(Nr, sR), Nt && (T = !0, ce += `' +
__e(` + Nt + `) +
'`), pn && (j = !0, ce += `';
` + pn + `;
__p += '`), Pt && (ce += `' +
((__t = (` + Pt + `)) == null ? '' : __t) +
'`), ae = Cr + rt.length, rt;
        }), ce += `';
`;
        var nt = In.call(u, "variable") && u.variable;
        if (!nt)
          ce = `with (obj) {
` + ce + `
}
`;
        else if (si.test(nt))
          throw new ct(l);
        ce = (j ? ce.replace(zt, "") : ce).replace(ri, "$1").replace(di, "$1;"), ce = "function(" + (nt || "obj") + `) {
` + (nt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (T ? ", __e = _.escape" : "") + (j ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ce + `return __p
}`;
        var Vt = H0(function() {
          return ut(k, ze + "return " + ce).apply(i, E);
        });
        if (Vt.source = ce, Z0(Vt))
          throw Vt;
        return Vt;
      }
      function X0(s) {
        return _i(s).toLowerCase();
      }
      function hW(s) {
        return _i(s).toUpperCase();
      }
      function hk(s, u, h) {
        if (s = _i(s), s && (h || u === i))
          return kG(s);
        if (!s || !(u = Co(u)))
          return s;
        var G = No(s), R = No(u), k = YG(G, R), E = FG(G, R) + 1;
        return eI(G, k, E).join("");
      }
      function mk(s, u, h) {
        if (s = _i(s), s && (h || u === i))
          return s.slice(0, Gp(s) + 1);
        if (!s || !(u = Co(u)))
          return s;
        var G = No(s), R = FG(G, No(u)) + 1;
        return eI(G, 0, R).join("");
      }
      function pk(s, u, h) {
        if (s = _i(s), s && (h || u === i))
          return s.replace(Rt, "");
        if (!s || !(u = Co(u)))
          return s;
        var G = No(s), R = YG(G, No(u));
        return eI(G, R).join("");
      }
      function rc(s, u) {
        var h = x, G = J;
        if (Pn(u)) {
          var R = "separator" in u ? u.separator : R;
          h = "length" in u ? oi(u.length) : h, G = "omission" in u ? Co(u.omission) : G;
        }
        s = _i(s);
        var k = s.length;
        if (Mc(s)) {
          var E = No(s);
          k = E.length;
        }
        if (h >= k)
          return s;
        var T = h - PI(G);
        if (T < 1)
          return G;
        var j = E ? eI(E, 0, T).join("") : s.slice(0, T);
        if (R === i)
          return j + G;
        if (E && (T += j.length - T), Cs(R)) {
          if (s.slice(T).search(R)) {
            var ae, ge = j;
            for (R.global || (R = yp(R.source, _i(Ae.exec(R)) + "g")), R.lastIndex = 0; ae = R.exec(ge); )
              var ce = ae.index;
            j = j.slice(0, ce === i ? T : ce);
          }
        } else if (s.indexOf(Co(R), T) != T) {
          var Fe = j.lastIndexOf(R);
          Fe > -1 && (j = j.slice(0, Fe));
        }
        return j + G;
      }
      function vi(s) {
        return s = _i(s), s && ui.test(s) ? s.replace(mt, IR) : s;
      }
      var Bk = tc(function(s, u, h) {
        return s + (h ? " " : "") + u.toUpperCase();
      }), ba = qp("toUpperCase");
      function mW(s, u, h) {
        return s = _i(s), u = h ? i : u, u === i ? Kr(s) ? uR(s) : RG(s) : s.match(u) || [];
      }
      var H0 = Si(function(s, u) {
        try {
          return nn(s, i, u);
        } catch (h) {
          return Z0(h) ? h : new ct(h);
        }
      }), k0 = as(function(s, u) {
        return Lr(u, function(h) {
          h = Gl(h), aa(s, h, lg(s[h], s));
        }), s;
      });
      function pW(s) {
        var u = s == null ? 0 : s.length, h = hi();
        return s = u ? Xn(s, function(G) {
          if (typeof G[1] != "function")
            throw new Lo(o);
          return [h(G[0]), G[1]];
        }) : [], Si(function(G) {
          for (var R = -1; ++R < u; ) {
            var k = s[R];
            if (nn(k[0], this, G))
              return nn(k[1], this, G);
          }
        });
      }
      function dd(s) {
        return oy(qg(s, d));
      }
      function Y0(s) {
        return function() {
          return s;
        };
      }
      function fk(s, u) {
        return s == null || s !== s ? u : s;
      }
      var Zk = py(), BW = py(!0);
      function Mr(s) {
        return s;
      }
      function F0(s) {
        return ab(typeof s == "function" ? s : qg(s, d));
      }
      function Gk(s) {
        return Lp(qg(s, d));
      }
      function yk(s, u) {
        return Ib(s, qg(u, d));
      }
      var Wk = Si(function(s, u) {
        return function(h) {
          return _c(h, s, u);
        };
      }), Sk = Si(function(s, u) {
        return function(h) {
          return _c(s, h, u);
        };
      });
      function x0(s, u, h) {
        var G = kr(u), R = Uu(u, G);
        h == null && !(Pn(u) && (R.length || !G.length)) && (h = u, u = s, s = this, R = Uu(u, kr(u)));
        var k = !(Pn(h) && "chain" in h) || !!h.chain, E = Oo(s);
        return Lr(R, function(T) {
          var j = u[T];
          s[T] = j, E && (s.prototype[T] = function() {
            var ae = this.__chain__;
            if (k || ae) {
              var ge = s(this.__wrapped__), ce = ge.__actions__ = Hg(this.__actions__);
              return ce.push({ func: j, args: arguments, thisArg: s }), ge.__chain__ = ae, ge;
            }
            return j.apply(s, Io([this.value()], arguments));
          });
        }), s;
      }
      function Vk() {
        return pt._ === this && (pt._ = ns), this;
      }
      function D0() {
      }
      function fW(s) {
        return s = oi(s), Si(function(u) {
          return Kp(u, s);
        });
      }
      var wk = _p(Xn), vk = _p(NA), ZW = _p(up);
      function J0(s) {
        return g0(s) ? bp(Gl(s)) : ER(s);
      }
      function Rk(s) {
        return function(u) {
          return s == null ? i : $I(s, u);
        };
      }
      var Xk = fy(), Hk = fy(!0);
      function E0() {
        return [];
      }
      function N0() {
        return !1;
      }
      function kk() {
        return {};
      }
      function Yk() {
        return "";
      }
      function L0() {
        return !0;
      }
      function GW(s, u) {
        if (s = oi(s), s < 1 || s > $)
          return [];
        var h = Ve, G = Ln(s, Ve);
        u = hi(u), s -= Ve;
        for (var R = Bp(G, u); ++h < s; )
          u(h);
        return R;
      }
      function Fk(s) {
        return fi(s) ? Xn(s, Gl) : bo(s) ? [s] : Hg(d0(_i(s)));
      }
      function xk(s) {
        var u = ++bR;
        return _i(s) + u;
      }
      var Dk = fb(function(s, u) {
        return s + u;
      }, 0), Jk = $p("ceil"), Ek = fb(function(s, u) {
        return s / u;
      }, 1), Nk = $p("floor");
      function Lk(s) {
        return s && s.length ? Zl(s, Mr, rg) : i;
      }
      function Kk(s, u) {
        return s && s.length ? Zl(s, hi(u, 2), rg) : i;
      }
      function Tk(s) {
        return XG(s, Mr);
      }
      function Mk(s, u) {
        return XG(s, hi(u, 2));
      }
      function Pk(s) {
        return s && s.length ? Zl(s, Mr, sb) : i;
      }
      function Uk(s, u) {
        return s && s.length ? Zl(s, hi(u, 2), sb) : i;
      }
      var zk = fb(function(s, u) {
        return s * u;
      }, 1), Ok = $p("round"), Qk = fb(function(s, u) {
        return s - u;
      }, 0);
      function jk(s) {
        return s && s.length ? pp(s, Mr) : 0;
      }
      function qk(s, u) {
        return s && s.length ? pp(s, hi(u, 2)) : 0;
      }
      return Q.after = BH, Q.ary = Hb, Q.assign = lC, Q.assignIn = Ub, Q.assignInWith = bs, Q.assignWith = aC, Q.at = sC, Q.before = zy, Q.bind = lg, Q.bindAll = k0, Q.bindKey = kb, Q.castArray = vH, Q.chain = Ly, Q.chunk = cX, Q.compact = dX, Q.concat = uX, Q.cond = pW, Q.conforms = dd, Q.constant = Y0, Q.countBy = eH, Q.create = zb, Q.curry = Oy, Q.curryRight = Qy, Q.debounce = Yb, Q.defaults = ad, Q.defaultsDeep = EH, Q.defer = fH, Q.delay = h0, Q.difference = CX, Q.differenceBy = AX, Q.differenceWith = bX, Q.drop = hX, Q.dropRight = mX, Q.dropRightWhile = pX, Q.dropWhile = BX, Q.fill = fX, Q.filter = iH, Q.flatMap = Ty, Q.flatMapDeep = rH, Q.flatMapDepth = gH, Q.flatten = Fg, Q.flattenDeep = or, Q.flattenDepth = ZX, Q.flip = ZH, Q.flow = Zk, Q.flowRight = BW, Q.fromPairs = GX, Q.functions = oW, Q.functionsIn = sd, Q.groupBy = oH, Q.initial = WX, Q.intersection = u0, Q.intersectionBy = SX, Q.intersectionWith = Is, Q.invert = aW, Q.invertBy = sW, Q.invokeMap = aH, Q.iteratee = F0, Q.keyBy = sH, Q.keys = kr, Q.keysIn = Dg, Q.map = Rb, Q.mapKeys = PH, Q.mapValues = S0, Q.matches = Gk, Q.matchesProperty = yk, Q.memoize = oC, Q.merge = V0, Q.mergeWith = w0, Q.method = Wk, Q.methodOf = Sk, Q.mixin = x0, Q.negate = Fb, Q.nthArg = fW, Q.omit = sg, Q.omitBy = UH, Q.once = m0, Q.orderBy = IH, Q.over = wk, Q.overArgs = p0, Q.overEvery = vk, Q.overSome = ZW, Q.partial = B0, Q.partialRight = jy, Q.partition = cH, Q.pick = IW, Q.pickBy = Id, Q.property = J0, Q.propertyOf = Rk, Q.pull = VX, Q.pullAll = xy, Q.pullAllBy = wX, Q.pullAllWith = vX, Q.pullAt = RX, Q.range = Xk, Q.rangeRight = Hk, Q.rearg = GH, Q.reject = CH, Q.remove = XX, Q.rest = yH, Q.reverse = wb, Q.sampleSize = bH, Q.set = cW, Q.setWith = zH, Q.shuffle = hH, Q.slice = rC, Q.sortBy = Uy, Q.sortedUniq = Dy, Q.sortedUniqBy = cs, Q.split = bW, Q.spread = WH, Q.tail = Fi, Q.take = Jy, Q.takeRight = Uo, Q.takeRightWhile = Ey, Q.takeWhile = xX, Q.tap = UX, Q.throttle = SH, Q.thru = gC, Q.toArray = rW, Q.toPairs = dW, Q.toPairsIn = uW, Q.toPath = Fk, Q.toPlainObject = W0, Q.transform = OH, Q.unary = VH, Q.union = gn, Q.unionBy = DX, Q.unionWith = JX, Q.uniq = EX, Q.uniqBy = NX, Q.uniqWith = LX, Q.unset = QH, Q.unzip = C0, Q.unzipWith = Ny, Q.update = jH, Q.updateWith = qH, Q.values = cd, Q.valuesIn = _H, Q.without = KX, Q.words = mW, Q.wrap = wH, Q.xor = TX, Q.xorBy = A0, Q.xorWith = MX, Q.zip = b0, Q.zipObject = Hr, Q.zipObjectDeep = _g, Q.zipWith = PX, Q.entries = dW, Q.entriesIn = uW, Q.extend = Ub, Q.extendWith = bs, x0(Q, Q), Q.add = Dk, Q.attempt = H0, Q.camelCase = ik, Q.capitalize = CW, Q.ceil = Jk, Q.clamp = $H, Q.clone = RH, Q.cloneDeep = HH, Q.cloneDeepWith = kH, Q.cloneWith = XH, Q.conformsTo = YH, Q.deburr = AW, Q.defaultTo = fk, Q.divide = Ek, Q.endsWith = nk, Q.eq = cn, Q.escape = rk, Q.escapeRegExp = gk, Q.every = tH, Q.find = nH, Q.findIndex = ky, Q.findKey = NH, Q.findLast = Ky, Q.findLastIndex = Po, Q.findLastKey = LH, Q.floor = Nk, Q.forEach = My, Q.forEachRight = Py, Q.forIn = KH, Q.forInRight = TH, Q.forOwn = Ob, Q.forOwnRight = IC, Q.get = Aa, Q.gt = xb, Q.gte = f0, Q.has = lW, Q.hasIn = cC, Q.head = Yy, Q.identity = Mr, Q.includes = lH, Q.indexOf = yX, Q.inRange = ek, Q.invoke = MH, Q.isArguments = iI, Q.isArray = fi, Q.isArrayBuffer = Fn, Q.isArrayLike = ag, Q.isArrayLikeObject = lr, Q.isBoolean = zo, Q.isBuffer = yl, Q.isDate = FH, Q.isElement = ld, Q.isEmpty = Db, Q.isEqual = Jb, Q.isEqualWith = dn, Q.isError = Z0, Q.isFinite = qy, Q.isFunction = Oo, Q.isInteger = _y, Q.isLength = Eb, Q.isMap = ds, Q.isMatch = Nb, Q.isMatchWith = $y, Q.isNaN = Lb, Q.isNative = eW, Q.isNil = Kb, Q.isNull = tW, Q.isNumber = G0, Q.isObject = Pn, Q.isObjectLike = xn, Q.isPlainObject = us, Q.isRegExp = Cs, Q.isSafeInteger = Tb, Q.isSet = iW, Q.isString = Mb, Q.isSymbol = bo, Q.isTypedArray = As, Q.isUndefined = Pb, Q.isWeakMap = y0, Q.isWeakSet = xH, Q.join = Fy, Q.kebabCase = ok, Q.last = xg, Q.lastIndexOf = Mn, Q.lowerCase = lk, Q.lowerFirst = ak, Q.lt = nW, Q.lte = DH, Q.max = Lk, Q.maxBy = Kk, Q.mean = Tk, Q.meanBy = Mk, Q.min = Pk, Q.minBy = Uk, Q.stubArray = E0, Q.stubFalse = N0, Q.stubObject = kk, Q.stubString = Yk, Q.stubTrue = L0, Q.multiply = zk, Q.nth = jn, Q.noConflict = Vk, Q.noop = D0, Q.now = Xb, Q.pad = sk, Q.padEnd = Ik, Q.padStart = ck, Q.parseInt = dk, Q.random = tk, Q.reduce = dH, Q.reduceRight = uH, Q.repeat = uk, Q.replace = Qb, Q.result = v0, Q.round = Ok, Q.runInContext = P, Q.sample = AH, Q.size = mH, Q.snakeCase = R0, Q.some = pH, Q.sortedIndex = HX, Q.sortedIndexBy = vb, Q.sortedIndexOf = Ao, Q.sortedLastIndex = kX, Q.sortedLastIndexBy = YX, Q.sortedLastIndexOf = FX, Q.startCase = Ck, Q.startsWith = Ak, Q.subtract = Qk, Q.sum = jk, Q.sumBy = qk, Q.template = bk, Q.times = GW, Q.toFinite = Wn, Q.toInteger = oi, Q.toLength = gW, Q.toLower = X0, Q.toNumber = Qo, Q.toSafeInteger = JH, Q.toString = _i, Q.toUpper = hW, Q.trim = hk, Q.trimEnd = mk, Q.trimStart = pk, Q.truncate = rc, Q.unescape = vi, Q.uniqueId = xk, Q.upperCase = Bk, Q.upperFirst = ba, Q.each = My, Q.eachRight = Py, Q.first = Yy, x0(Q, function() {
        var s = {};
        return sa(Q, function(u, h) {
          In.call(Q.prototype, h) || (s[h] = u);
        }), s;
      }(), { chain: !1 }), Q.VERSION = n, Lr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        Q[s].placeholder = Q;
      }), Lr(["drop", "take"], function(s, u) {
        Di.prototype[s] = function(h) {
          h = h === i ? 1 : Gr(oi(h), 0);
          var G = this.__filtered__ && !u ? new Di(this) : this.clone();
          return G.__filtered__ ? G.__takeCount__ = Ln(h, G.__takeCount__) : G.__views__.push({
            size: Ln(h, Ve),
            type: s + (G.__dir__ < 0 ? "Right" : "")
          }), G;
        }, Di.prototype[s + "Right"] = function(h) {
          return this.reverse()[s](h).reverse();
        };
      }), Lr(["filter", "map", "takeWhile"], function(s, u) {
        var h = u + 1, G = h == L || h == U;
        Di.prototype[s] = function(R) {
          var k = this.clone();
          return k.__iteratees__.push({
            iteratee: hi(R, 3),
            type: h
          }), k.__filtered__ = k.__filtered__ || G, k;
        };
      }), Lr(["head", "last"], function(s, u) {
        var h = "take" + (u ? "Right" : "");
        Di.prototype[s] = function() {
          return this[h](1).value()[0];
        };
      }), Lr(["initial", "tail"], function(s, u) {
        var h = "drop" + (u ? "" : "Right");
        Di.prototype[s] = function() {
          return this.__filtered__ ? new Di(this) : this[h](1);
        };
      }), Di.prototype.compact = function() {
        return this.filter(Mr);
      }, Di.prototype.find = function(s) {
        return this.filter(s).head();
      }, Di.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, Di.prototype.invokeMap = Si(function(s, u) {
        return typeof s == "function" ? new Di(this) : this.map(function(h) {
          return _c(h, s, u);
        });
      }), Di.prototype.reject = function(s) {
        return this.filter(Fb(hi(s)));
      }, Di.prototype.slice = function(s, u) {
        s = oi(s);
        var h = this;
        return h.__filtered__ && (s > 0 || u < 0) ? new Di(h) : (s < 0 ? h = h.takeRight(-s) : s && (h = h.drop(s)), u !== i && (u = oi(u), h = u < 0 ? h.dropRight(-u) : h.take(u - s)), h);
      }, Di.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, Di.prototype.toArray = function() {
        return this.take(Ve);
      }, sa(Di.prototype, function(s, u) {
        var h = /^(?:filter|find|map|reject)|While$/.test(u), G = /^(?:head|last)$/.test(u), R = Q[G ? "take" + (u == "last" ? "Right" : "") : u], k = G || /^find/.test(u);
        R && (Q.prototype[u] = function() {
          var E = this.__wrapped__, T = G ? [1] : arguments, j = E instanceof Di, ae = T[0], ge = j || fi(E), ce = function(Nt) {
            var Pt = R.apply(Q, Io([Nt], T));
            return G && Fe ? Pt[0] : Pt;
          };
          ge && h && typeof ae == "function" && ae.length != 1 && (j = ge = !1);
          var Fe = this.__chain__, ze = !!this.__actions__.length, nt = k && !Fe, Vt = j && !ze;
          if (!k && ge) {
            E = Vt ? E : new Di(this);
            var rt = s.apply(E, T);
            return rt.__actions__.push({ func: gC, args: [ce], thisArg: i }), new To(rt, Fe);
          }
          return nt && Vt ? s.apply(this, T) : (rt = this.thru(ce), nt ? G ? rt.value()[0] : rt.value() : rt);
        });
      }), Lr(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var u = TA[s], h = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", G = /^(?:pop|shift)$/.test(s);
        Q.prototype[s] = function() {
          var R = arguments;
          if (G && !this.__chain__) {
            var k = this.value();
            return u.apply(fi(k) ? k : [], R);
          }
          return this[h](function(E) {
            return u.apply(fi(E) ? E : [], R);
          });
        };
      }), sa(Di.prototype, function(s, u) {
        var h = Q[u];
        if (h) {
          var G = h.name + "";
          In.call(Qn, G) || (Qn[G] = []), Qn[G].push({ name: u, func: h });
        }
      }), Qn[_u(i, B).name] = [{
        name: "wrapper",
        func: i
      }], Di.prototype.clone = jG, Di.prototype.reverse = ZR, Di.prototype.value = GR, Q.prototype.at = zX, Q.prototype.chain = OX, Q.prototype.commit = QX, Q.prototype.next = jX, Q.prototype.plant = _X, Q.prototype.reverse = $X, Q.prototype.toJSON = Q.prototype.valueOf = Q.prototype.value = od, Q.prototype.first = Q.prototype.head, Ju && (Q.prototype[Ju] = qX), Q;
    }, pl = CR();
    qt ? ((qt.exports = pl)._ = pl, Ft._ = pl) : pt._ = pl;
  }).call(Or);
})(tw, tw.exports);
var de = tw.exports;
const av = /* @__PURE__ */ go(de);
function yJ(e) {
  return /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/.test(e);
}
const UZe = (e) => e !== null && typeof e == "object", AA = (e) => UZe(e) && !zZe(e), zZe = (e) => e !== null && Array.isArray(e), gm = (e) => e == null, v3 = (e) => Math.max(0, gm(e) ? 1 : e), OZe = (e) => typeof e == "string";
Array.prototype.OC_reduceBy = function(e, t) {
  return this != null && this.length ? this.reduce((i, n, r) => {
    const g = i.findIndex((o) => e(o, n, r));
    return g >= 0 ? (i[g] = t(i[g], n, r), i) : (i.push({
      ...n
    }), i);
  }, []) : [];
};
String.prototype.OC_isCapitalized = function() {
  return this.length ? new RegExp("^\\p{Lu}", "u").test(this) : !1;
};
String.prototype.OC_addIfGiven = function(e) {
  return this + (e ? ` ${e}` : "");
};
String.prototype.OC_replaceAll = function(e, t) {
  if (!this)
    return "";
  const i = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return this.replace(new RegExp(i, "g"), () => t);
};
String.prototype.OC_removeAll = function(e) {
  return (this == null ? void 0 : this.OC_replaceAll(e, "")) || "";
};
Number.prototype.OC_roundTo = function(e) {
  return de.round(this, e);
};
const iw = (e, t, i, n = "hiddenVariablesMap") => {
  const r = e == null ? void 0 : e[n][t], g = r === !0, o = AA(r) && r[i];
  return g || o;
};
var nw = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
nw.exports;
(function(e, t) {
  (function() {
    function i(P, re, Y) {
      switch (Y.length) {
        case 0:
          return P.call(re);
        case 1:
          return P.call(re, Y[0]);
        case 2:
          return P.call(re, Y[0], Y[1]);
        case 3:
          return P.call(re, Y[0], Y[1], Y[2]);
      }
      return P.apply(re, Y);
    }
    function n(P, re, Y, Ee) {
      for (var ct = -1, ut = P == null ? 0 : P.length; ++ct < ut; ) {
        var qi = P[ct];
        re(Ee, qi, Y(qi), P);
      }
      return Ee;
    }
    function r(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee && re(P[Y], Y, P) !== !1; )
        ;
      return P;
    }
    function g(P, re) {
      for (var Y = P == null ? 0 : P.length; Y-- && re(P[Y], Y, P) !== !1; )
        ;
      return P;
    }
    function o(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee; )
        if (!re(P[Y], Y, P))
          return !1;
      return !0;
    }
    function l(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length, ct = 0, ut = []; ++Y < Ee; ) {
        var qi = P[Y];
        re(qi, Y, P) && (ut[ct++] = qi);
      }
      return ut;
    }
    function a(P, re) {
      return !!(P != null && P.length) && Z(P, re, 0) > -1;
    }
    function I(P, re, Y) {
      for (var Ee = -1, ct = P == null ? 0 : P.length; ++Ee < ct; )
        if (Y(re, P[Ee]))
          return !0;
      return !1;
    }
    function c(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length, ct = Array(Ee); ++Y < Ee; )
        ct[Y] = re(P[Y], Y, P);
      return ct;
    }
    function d(P, re) {
      for (var Y = -1, Ee = re.length, ct = P.length; ++Y < Ee; )
        P[ct + Y] = re[Y];
      return P;
    }
    function C(P, re, Y, Ee) {
      var ct = -1, ut = P == null ? 0 : P.length;
      for (Ee && ut && (Y = P[++ct]); ++ct < ut; )
        Y = re(Y, P[ct], ct, P);
      return Y;
    }
    function A(P, re, Y, Ee) {
      var ct = P == null ? 0 : P.length;
      for (Ee && ct && (Y = P[--ct]); ct--; )
        Y = re(Y, P[ct], ct, P);
      return Y;
    }
    function b(P, re) {
      for (var Y = -1, Ee = P == null ? 0 : P.length; ++Y < Ee; )
        if (re(P[Y], Y, P))
          return !0;
      return !1;
    }
    function m(P) {
      return P.split("");
    }
    function p(P) {
      return P.match(JA) || [];
    }
    function B(P, re, Y) {
      var Ee;
      return Y(P, function(ct, ut, qi) {
        if (re(ct, ut, qi))
          return Ee = ut, !1;
      }), Ee;
    }
    function f(P, re, Y, Ee) {
      for (var ct = P.length, ut = Y + (Ee ? 1 : -1); Ee ? ut-- : ++ut < ct; )
        if (re(P[ut], ut, P))
          return ut;
      return -1;
    }
    function Z(P, re, Y) {
      return re === re ? st(P, re, Y) : f(P, W, Y);
    }
    function y(P, re, Y, Ee) {
      for (var ct = Y - 1, ut = P.length; ++ct < ut; )
        if (Ee(P[ct], re))
          return ct;
      return -1;
    }
    function W(P) {
      return P !== P;
    }
    function V(P, re) {
      var Y = P == null ? 0 : P.length;
      return Y ? J(P, re) / Y : Rt;
    }
    function w(P) {
      return function(re) {
        return re == null ? te : re[P];
      };
    }
    function v(P) {
      return function(re) {
        return P == null ? te : P[re];
      };
    }
    function H(P, re, Y, Ee, ct) {
      return ct(P, function(ut, qi, sn) {
        Y = Ee ? (Ee = !1, ut) : re(Y, ut, qi, sn);
      }), Y;
    }
    function x(P, re) {
      var Y = P.length;
      for (P.sort(re); Y--; )
        P[Y] = P[Y].value;
      return P;
    }
    function J(P, re) {
      for (var Y, Ee = -1, ct = P.length; ++Ee < ct; ) {
        var ut = re(P[Ee]);
        ut !== te && (Y = Y === te ? ut : Y + ut);
      }
      return Y;
    }
    function K(P, re) {
      for (var Y = -1, Ee = Array(P); ++Y < P; )
        Ee[Y] = re(Y);
      return Ee;
    }
    function M(P, re) {
      return c(re, function(Y) {
        return [Y, P[Y]];
      });
    }
    function L(P) {
      return P && P.slice(0, $e(P) + 1).replace(Hu, "");
    }
    function N(P) {
      return function(re) {
        return P(re);
      };
    }
    function U(P, re) {
      return c(re, function(Y) {
        return P[Y];
      });
    }
    function O(P, re) {
      return P.has(re);
    }
    function $(P, re) {
      for (var Y = -1, Ee = P.length; ++Y < Ee && Z(re, P[Y], 0) > -1; )
        ;
      return Y;
    }
    function ne(P, re) {
      for (var Y = P.length; Y-- && Z(re, P[Y], 0) > -1; )
        ;
      return Y;
    }
    function be(P, re) {
      for (var Y = P.length, Ee = 0; Y--; )
        P[Y] === re && ++Ee;
      return Ee;
    }
    function Ve(P) {
      return "\\" + lR[P];
    }
    function He(P, re) {
      return P == null ? te : P[re];
    }
    function Je(P) {
      return Bp.test(P);
    }
    function ke(P) {
      return gR.test(P);
    }
    function we(P) {
      for (var re, Y = []; !(re = P.next()).done; )
        Y.push(re.value);
      return Y;
    }
    function ue(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee, ct) {
        Y[++re] = [ct, Ee];
      }), Y;
    }
    function Xe(P, re) {
      return function(Y) {
        return P(re(Y));
      };
    }
    function Ze(P, re) {
      for (var Y = -1, Ee = P.length, ct = 0, ut = []; ++Y < Ee; ) {
        var qi = P[Y];
        qi !== re && qi !== ci || (P[Y] = ci, ut[ct++] = Y);
      }
      return ut;
    }
    function xe(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee) {
        Y[++re] = Ee;
      }), Y;
    }
    function Pe(P) {
      var re = -1, Y = Array(P.size);
      return P.forEach(function(Ee) {
        Y[++re] = [Ee, Ee];
      }), Y;
    }
    function st(P, re, Y) {
      for (var Ee = Y - 1, ct = P.length; ++Ee < ct; )
        if (P[Ee] === re)
          return Ee;
      return -1;
    }
    function bt(P, re, Y) {
      for (var Ee = Y + 1; Ee--; )
        if (P[Ee] === re)
          return Ee;
      return Ee;
    }
    function it(P) {
      return Je(P) ? It(P) : IR(P);
    }
    function Qe(P) {
      return Je(P) ? jt(P) : m(P);
    }
    function $e(P) {
      for (var re = P.length; re-- && op.test(P.charAt(re)); )
        ;
      return re;
    }
    function It(P) {
      for (var re = mp.lastIndex = 0; mp.test(P); )
        ++re;
      return re;
    }
    function jt(P) {
      return P.match(mp) || [];
    }
    function Bt(P) {
      return P.match(pp) || [];
    }
    var te, Xt = "4.17.21", Ht = 200, ii = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", $t = "Expected a function", ni = "Invalid `variable` option passed into `_.template`", mi = "__lodash_hash_undefined__", Bi = 500, ci = "__lodash_placeholder__", Ge = 1, Be = 2, qe = 4, vt = 1, Kt = 2, Te = 1, Tt = 2, Ue = 4, Me = 8, Yt = 16, zt = 32, ri = 64, di = 128, mt = 256, Ai = 512, ui = 30, Ui = "...", Oi = 800, Rn = 16, le = 1, Ce = 2, pe = 3, Ne = 1 / 0, Ke = 9007199254740991, Jt = 17976931348623157e292, Rt = NaN, Zt = 4294967295, Et = Zt - 1, dt = Zt >>> 1, xt = [["ary", di], ["bind", Te], ["bindKey", Tt], ["curry", Me], ["curryRight", Yt], ["flip", Ai], ["partial", zt], ["partialRight", ri], ["rearg", mt]], Ot = "[object Arguments]", si = "[object Array]", Li = "[object AsyncFunction]", fe = "[object Boolean]", Ae = "[object Date]", gt = "[object DOMException]", _e = "[object Error]", Qt = "[object Function]", kt = "[object GeneratorFunction]", ti = "[object Map]", tn = "[object Number]", ao = "[object Null]", Nr = "[object Object]", vg = "[object Promise]", es = "[object Proxy]", tg = "[object RegExp]", Xi = "[object Set]", bn = "[object String]", so = "[object Symbol]", bl = "[object Undefined]", hn = "[object WeakMap]", hl = "[object WeakSet]", ia = "[object ArrayBuffer]", ml = "[object DataView]", xc = "[object Float32Array]", Dc = "[object Float64Array]", NI = "[object Int8Array]", LI = "[object Int16Array]", Gu = "[object Int32Array]", Jc = "[object Uint8Array]", Ps = "[object Uint8ClampedArray]", KI = "[object Uint16Array]", yu = "[object Uint32Array]", Wu = /\b__p \+= '';/g, Su = /\b(__p \+=) '' \+/g, Vu = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ec = /&(?:amp|lt|gt|quot|#39);/g, Nc = /[&<>"']/g, wu = RegExp(Ec.source), vu = RegExp(Nc.source), Us = /<%-([\s\S]+?)%>/g, Ru = /<%([\s\S]+?)%>/g, Lc = /<%=([\s\S]+?)%>/g, Kc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xA = /^\w*$/, Xu = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, TI = /[\\^$.*+?()[\]{}|]/g, ts = RegExp(TI.source), Hu = /^\s+/, op = /\s/, ku = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, DA = /\{\n\/\* \[wrapped with (.+)\] \*/, lp = /,? & /, JA = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Yu = /[()=,{}\[\]\/\s]/, ap = /\\(\\)?/g, Fu = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, na = /\w*$/, sp = /^[-+]0x[0-9a-f]+$/i, Ip = /^0b[01]+$/i, cp = /^\[object .+?Constructor\]$/, dp = /^0o[0-7]+$/i, ki = /^(?:0|[1-9]\d*)$/, D = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, z = /($^)/, _ = /['\n\r\u2028\u2029\\]/g, q = "\\ud800-\\udfff", se = "\\u0300-\\u036f", he = "\\ufe20-\\ufe2f", Ye = "\\u20d0-\\u20ff", at = se + he + Ye, je = "\\u2700-\\u27bf", pt = "a-z\\xdf-\\xf6\\xf8-\\xff", Ft = "\\xac\\xb1\\xd7\\xf7", qt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Wt = "\\u2000-\\u206f", yi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Zi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Yn = "\\ufe0e\\ufe0f", gi = Ft + qt + Wt + yi, Yi = "['’]", dr = "[" + q + "]", On = "[" + gi + "]", ur = "[" + at + "]", nn = "\\d+", MI = "[" + je + "]", Lr = "[" + pt + "]", EA = "[^" + q + gi + nn + je + pt + Zi + "]", NA = "\\ud83c[\\udffb-\\udfff]", zs = "(?:" + ur + "|" + NA + ")", xu = "[^" + q + "]", Du = "(?:\\ud83c[\\udde6-\\uddff]){2}", Xn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Io = "[" + Zi + "]", LA = "\\u200d", VG = "(?:" + Lr + "|" + EA + ")", up = "(?:" + Io + "|" + EA + ")", wG = "(?:" + Yi + "(?:d|ll|m|re|s|t|ve))?", vG = "(?:" + Yi + "(?:D|LL|M|RE|S|T|VE))?", RG = zs + "?", Cp = "[" + Yn + "]?", KA = "(?:" + LA + "(?:" + [xu, Du, Xn].join("|") + ")" + Cp + RG + ")*", Tc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rR = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ap = Cp + RG + KA, XG = "(?:" + [MI, Du, Xn].join("|") + ")" + Ap, bp = "(?:" + [xu + ur + "?", ur, Du, Xn, dr].join("|") + ")", hp = RegExp(Yi, "g"), HG = RegExp(ur, "g"), mp = RegExp(NA + "(?=" + NA + ")|" + bp + Ap, "g"), pp = RegExp([Io + "?" + Lr + "+" + wG + "(?=" + [On, Io, "$"].join("|") + ")", up + "+" + vG + "(?=" + [On, Io + VG, "$"].join("|") + ")", Io + "?" + VG + "+" + wG, Io + "+" + vG, rR, Tc, nn, XG].join("|"), "g"), Bp = RegExp("[" + LA + q + at + Yn + "]"), gR = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, kG = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], co = -1, yn = {};
    yn[xc] = yn[Dc] = yn[NI] = yn[LI] = yn[Gu] = yn[Jc] = yn[Ps] = yn[KI] = yn[yu] = !0, yn[Ot] = yn[si] = yn[ia] = yn[fe] = yn[ml] = yn[Ae] = yn[_e] = yn[Qt] = yn[ti] = yn[tn] = yn[Nr] = yn[tg] = yn[Xi] = yn[bn] = yn[hn] = !1;
    var rn = {};
    rn[Ot] = rn[si] = rn[ia] = rn[ml] = rn[fe] = rn[Ae] = rn[xc] = rn[Dc] = rn[NI] = rn[LI] = rn[Gu] = rn[ti] = rn[tn] = rn[Nr] = rn[tg] = rn[Xi] = rn[bn] = rn[so] = rn[Jc] = rn[Ps] = rn[KI] = rn[yu] = !0, rn[_e] = rn[Qt] = rn[hn] = !1;
    var YG = {
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, FG = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, oR = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, lR = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, aR = parseFloat, sR = parseInt, xG = typeof Or == "object" && Or && Or.Object === Object && Or, Mc = typeof self == "object" && self && self.Object === Object && self, Kr = xG || Mc || Function("return this")(), fp = t && !t.nodeType && t, is = fp && !0 && e && !e.nodeType && e, Zp = is && is.exports === fp, ra = Zp && xG.process, Rg = function() {
      try {
        var P = is && is.require && is.require("util").types;
        return P || ra && ra.binding && ra.binding("util");
      } catch {
      }
    }(), DG = Rg && Rg.isArrayBuffer, JG = Rg && Rg.isDate, EG = Rg && Rg.isMap, PI = Rg && Rg.isRegExp, No = Rg && Rg.isSet, Gp = Rg && Rg.isTypedArray, IR = w("length"), cR = v(YG), dR = v(FG), uR = v(oR), CR = function P(re) {
      function Y(s) {
        if (jn(s) && !vi(s) && !(s instanceof ut)) {
          if (s instanceof ct)
            return s;
          if (dn.call(s, "__wrapped__"))
            return Hg(s);
        }
        return new ct(s);
      }
      function Ee() {
      }
      function ct(s, u) {
        this.__wrapped__ = s, this.__actions__ = [], this.__chain__ = !!u, this.__index__ = 0, this.__values__ = te;
      }
      function ut(s) {
        this.__wrapped__ = s, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Zt, this.__views__ = [];
      }
      function qi() {
        var s = new ut(this.__wrapped__);
        return s.__actions__ = rg(this.__actions__), s.__dir__ = this.__dir__, s.__filtered__ = this.__filtered__, s.__iteratees__ = rg(this.__iteratees__), s.__takeCount__ = this.__takeCount__, s.__views__ = rg(this.__views__), s;
      }
      function sn() {
        if (this.__filtered__) {
          var s = new ut(this);
          s.__dir__ = -1, s.__filtered__ = !0;
        } else
          s = this.clone(), s.__dir__ *= -1;
        return s;
      }
      function yp() {
        var s = this.__wrapped__.value(), u = this.__dir__, h = vi(s), G = u < 0, R = h ? s.length : 0, k = LR(0, R, this.__views__), E = k.start, T = k.end, j = T - E, ae = G ? T : E - 1, ge = this.__iteratees__, ce = ge.length, Fe = 0, ze = oi(j, this.__takeCount__);
        if (!h || !G && R == j && ze == j)
          return Yp(s, this.__actions__);
        var nt = [];
        e:
          for (; j-- && Fe < ze; ) {
            ae += u;
            for (var Vt = -1, rt = s[ae]; ++Vt < ce; ) {
              var Nt = ge[Vt], Pt = Nt.iteratee, mn = Nt.type, pn = Pt(rt);
              if (mn == Ce)
                rt = pn;
              else if (!pn) {
                if (mn == le)
                  continue e;
                break e;
              }
            }
            nt[Fe++] = rt;
          }
        return nt;
      }
      function UI(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function Lo() {
        this.__data__ = sC ? sC(null) : {}, this.size = 0;
      }
      function TA(s) {
        var u = this.has(s) && delete this.__data__[s];
        return this.size -= u ? 1 : 0, u;
      }
      function AR(s) {
        var u = this.__data__;
        if (sC) {
          var h = u[s];
          return h === mi ? te : h;
        }
        return dn.call(u, s) ? u[s] : te;
      }
      function Pc(s) {
        var u = this.__data__;
        return sC ? u[s] !== te : dn.call(u, s);
      }
      function MA(s, u) {
        var h = this.__data__;
        return this.size += this.has(s) ? 0 : 1, h[s] = sC && u === te ? mi : u, this;
      }
      function Ko(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function In() {
        this.__data__ = [], this.size = 0;
      }
      function bR(s) {
        var u = this.__data__, h = Lu(u, s);
        return !(h < 0) && (h == u.length - 1 ? u.pop() : Kb.call(u, h, 1), --this.size, !0);
      }
      function NG(s) {
        var u = this.__data__, h = Lu(u, s);
        return h < 0 ? te : u[h][1];
      }
      function PA(s) {
        return Lu(this.__data__, s) > -1;
      }
      function hR(s, u) {
        var h = this.__data__, G = Lu(h, s);
        return G < 0 ? (++this.size, h.push([s, u])) : h[G][1] = u, this;
      }
      function ns(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.clear(); ++u < h; ) {
          var G = s[u];
          this.set(G[0], G[1]);
        }
      }
      function mR() {
        this.size = 0, this.__data__ = { hash: new UI(), map: new (lC || Ko)(), string: new UI() };
      }
      function UA(s) {
        var u = cb(this, s).delete(s);
        return this.size -= u ? 1 : 0, u;
      }
      function Os(s) {
        return cb(this, s).get(s);
      }
      function zA(s) {
        return cb(this, s).has(s);
      }
      function LG(s, u) {
        var h = cb(this, s), G = h.size;
        return h.set(s, u), this.size += h.size == G ? 0 : 1, this;
      }
      function ga(s) {
        var u = -1, h = s == null ? 0 : s.length;
        for (this.__data__ = new ns(); ++u < h; )
          this.add(s[u]);
      }
      function KG(s) {
        return this.__data__.set(s, mi), this;
      }
      function TG(s) {
        return this.__data__.has(s);
      }
      function Qg(s) {
        this.size = (this.__data__ = new Ko(s)).size;
      }
      function MG() {
        this.__data__ = new Ko(), this.size = 0;
      }
      function Ju(s) {
        var u = this.__data__, h = u.delete(s);
        return this.size = u.size, h;
      }
      function zI(s) {
        return this.__data__.get(s);
      }
      function OA(s) {
        return this.__data__.has(s);
      }
      function pR(s, u) {
        var h = this.__data__;
        if (h instanceof Ko) {
          var G = h.__data__;
          if (!lC || G.length < Ht - 1)
            return G.push([s, u]), this.size = ++h.size, this;
          h = this.__data__ = new ns(G);
        }
        return h.set(s, u), this.size = h.size, this;
      }
      function PG(s, u) {
        var h = vi(s), G = !h && rc(s), R = !h && !G && ba(s), k = !h && !G && !R && dd(s), E = h || G || R || k, T = E ? K(s.length, lr) : [], j = T.length;
        for (var ae in s)
          !u && !dn.call(s, ae) || E && (ae == "length" || R && (ae == "offset" || ae == "parent") || k && (ae == "buffer" || ae == "byteLength" || ae == "byteOffset") || gg(ae, j)) || T.push(ae);
        return T;
      }
      function UG(s) {
        var u = s.length;
        return u ? s[Xp(0, u - 1)] : te;
      }
      function QA(s, u) {
        return qu(rg(s), OI(u, 0, s.length));
      }
      function jA(s) {
        return qu(rg(s));
      }
      function Eu(s, u, h) {
        (h === te || Po(s[u], h)) && (h !== te || u in s) || Ln(s, u, h);
      }
      function Nu(s, u, h) {
        var G = s[u];
        dn.call(s, u) && Po(G, h) && (h !== te || u in s) || Ln(s, u, h);
      }
      function Lu(s, u) {
        for (var h = s.length; h--; )
          if (Po(s[h][0], u))
            return h;
        return -1;
      }
      function BR(s, u, h, G) {
        return Aa(s, function(R, k, E) {
          u(G, R, h(R), E);
        }), G;
      }
      function zG(s, u) {
        return s && Ia(u, Hr(u), s);
      }
      function Gr(s, u) {
        return s && Ia(u, _g(u), s);
      }
      function Ln(s, u, h) {
        u == "__proto__" && Tb ? Tb(s, u, { configurable: !0, enumerable: !0, value: h, writable: !0 }) : s[u] = h;
      }
      function Wp(s, u) {
        for (var h = -1, G = u.length, R = cn(G), k = s == null; ++h < G; )
          R[h] = k ? te : A0(s, u[h]);
        return R;
      }
      function OI(s, u, h) {
        return s === s && (h !== te && (s = s <= h ? s : h), u !== te && (s = s >= u ? s : u)), s;
      }
      function uo(s, u, h, G, R, k) {
        var E, T = u & Ge, j = u & Be, ae = u & qe;
        if (h && (E = R ? h(s, G, R, k) : h(s)), E !== te)
          return E;
        if (!Mn(s))
          return s;
        var ge = vi(s);
        if (ge) {
          if (E = db(s), !T)
            return rg(s, E);
        } else {
          var ce = sg(s), Fe = ce == Qt || ce == kt;
          if (ba(s))
            return xp(s, T);
          if (ce == Nr || ce == Ot || Fe && !R) {
            if (E = j || Fe ? {} : ub(s), !T)
              return j ? YR(s, Gr(E, s)) : kR(s, zG(E, s));
          } else {
            if (!rn[ce])
              return R ? s : {};
            E = cy(s, ce, T);
          }
        }
        k || (k = new Qg());
        var ze = k.get(s);
        if (ze)
          return ze;
        k.set(s, E), pW(s) ? s.forEach(function(rt) {
          E.add(uo(rt, u, h, rt, s, k));
        }) : H0(s) && s.forEach(function(rt, Nt) {
          E.set(Nt, uo(rt, u, h, Nt, s, k));
        });
        var nt = ae ? j ? Up : ju : j ? _g : Hr, Vt = ge ? te : nt(s);
        return r(Vt || s, function(rt, Nt) {
          Vt && (Nt = rt, rt = s[Nt]), Nu(E, Nt, uo(rt, u, h, Nt, s, k));
        }), E;
      }
      function fR(s) {
        var u = Hr(s);
        return function(h) {
          return qA(h, s, u);
        };
      }
      function qA(s, u, h) {
        var G = h.length;
        if (s == null)
          return !G;
        for (s = Fn(s); G--; ) {
          var R = h[G], k = u[R], E = s[R];
          if (E === te && !(R in s) || !k(E))
            return !1;
        }
        return !0;
      }
      function Uc(s, u, h) {
        if (typeof s != "function")
          throw new zo($t);
        return Id(function() {
          s.apply(te, h);
        }, u);
      }
      function QI(s, u, h, G) {
        var R = -1, k = a, E = !0, T = s.length, j = [], ae = u.length;
        if (!T)
          return j;
        h && (u = c(u, N(h))), G ? (k = I, E = !1) : u.length >= Ht && (k = O, E = !1, u = new ga(u));
        e:
          for (; ++R < T; ) {
            var ge = s[R], ce = h == null ? ge : h(ge);
            if (ge = G || ge !== 0 ? ge : 0, E && ce === ce) {
              for (var Fe = ae; Fe--; )
                if (u[Fe] === ce)
                  continue e;
              j.push(ge);
            } else
              k(u, ce, G) || j.push(ge);
          }
        return j;
      }
      function zc(s, u) {
        var h = !0;
        return Aa(s, function(G, R, k) {
          return h = !!u(G, R, k);
        }), h;
      }
      function Qs(s, u, h) {
        for (var G = -1, R = s.length; ++G < R; ) {
          var k = s[G], E = u(k);
          if (E != null && (T === te ? E === E && !Ao(E) : h(E, T)))
            var T = E, j = k;
        }
        return j;
      }
      function Ku(s, u, h, G) {
        var R = s.length;
        for (h = Fi(h), h < 0 && (h = -h > R ? 0 : R + h), G = G === te || G > R ? R : Fi(G), G < 0 && (G += R), G = h > G ? 0 : Jy(G); h < G; )
          s[h++] = u;
        return s;
      }
      function Tu(s, u) {
        var h = [];
        return Aa(s, function(G, R, k) {
          u(G, R, k) && h.push(G);
        }), h;
      }
      function Qn(s, u, h, G, R) {
        var k = -1, E = s.length;
        for (h || (h = Co), R || (R = []); ++k < E; ) {
          var T = s[k];
          u > 0 && h(T) ? u > 1 ? Qn(T, u - 1, h, G, R) : d(R, T) : G || (R[R.length] = T);
        }
        return R;
      }
      function oa(s, u) {
        return s && cC(s, u, Hr);
      }
      function Sp(s, u) {
        return s && aW(s, u, Hr);
      }
      function _A(s, u) {
        return l(u, function(h) {
          return Is(s[h]);
        });
      }
      function jI(s, u) {
        u = Zl(u, s);
        for (var h = 0, G = u.length; s != null && h < G; )
          s = s[ua(u[h++])];
        return h && h == G ? s : te;
      }
      function OG(s, u, h) {
        var G = u(s);
        return vi(s) ? G : d(G, h(s));
      }
      function Xr(s) {
        return s == null ? s === te ? bl : ao : Cs && Cs in Fn(s) ? NR(s) : uy(s);
      }
      function qI(s, u) {
        return s > u;
      }
      function QG(s, u) {
        return s != null && dn.call(s, u);
      }
      function Q(s, u) {
        return s != null && u in Fn(s);
      }
      function Oc(s, u, h) {
        return s >= oi(u, h) && s < Wn(u, h);
      }
      function Qc(s, u, h) {
        for (var G = h ? I : a, R = s[0].length, k = s.length, E = k, T = cn(k), j = 1 / 0, ae = []; E--; ) {
          var ge = s[E];
          E && u && (ge = c(ge, N(u))), j = oi(ge.length, j), T[E] = !h && (u || R >= 120 && ge.length >= 120) ? new ga(E && ge) : te;
        }
        ge = s[0];
        var ce = -1, Fe = T[0];
        e:
          for (; ++ce < R && ae.length < j; ) {
            var ze = ge[ce], nt = u ? u(ze) : ze;
            if (ze = h || ze !== 0 ? ze : 0, !(Fe ? O(Fe, nt) : G(ae, nt, h))) {
              for (E = k; --E; ) {
                var Vt = T[E];
                if (!(Vt ? O(Vt, nt) : G(s[E], nt, h)))
                  continue e;
              }
              Fe && Fe.push(nt), ae.push(ze);
            }
          }
        return ae;
      }
      function To(s, u, h, G) {
        return oa(s, function(R, k, E) {
          u(G, h(R), k, E);
        }), G;
      }
      function Di(s, u, h) {
        u = Zl(u, s), s = pb(s, u);
        var G = s == null ? s : s[ua(kg(u))];
        return G == null ? te : i(G, s, h);
      }
      function jG(s) {
        return jn(s) && Xr(s) == Ot;
      }
      function ZR(s) {
        return jn(s) && Xr(s) == ia;
      }
      function GR(s) {
        return jn(s) && Xr(s) == Ae;
      }
      function Bl(s, u, h, G, R) {
        return s === u || (s == null || u == null || !jn(s) && !jn(u) ? s !== s && u !== u : yR(s, u, h, G, Bl, R));
      }
      function yR(s, u, h, G, R, k) {
        var E = vi(s), T = vi(u), j = E ? si : sg(s), ae = T ? si : sg(u);
        j = j == Ot ? Nr : j, ae = ae == Ot ? Nr : ae;
        var ge = j == Nr, ce = ae == Nr, Fe = j == ae;
        if (Fe && ba(s)) {
          if (!ba(u))
            return !1;
          E = !0, ge = !1;
        }
        if (Fe && !ge)
          return k || (k = new Qg()), E || dd(s) ? Mp(s, u, h, G, R, k) : ER(s, u, j, h, G, R, k);
        if (!(h & vt)) {
          var ze = ge && dn.call(s, "__wrapped__"), nt = ce && dn.call(u, "__wrapped__");
          if (ze || nt) {
            var Vt = ze ? s.value() : s, rt = nt ? u.value() : u;
            return k || (k = new Qg()), R(Vt, rt, h, G, k);
          }
        }
        return !!Fe && (k || (k = new Qg()), Pp(s, u, h, G, R, k));
      }
      function WR(s) {
        return jn(s) && sg(s) == ti;
      }
      function Vp(s, u, h, G) {
        var R = h.length, k = R, E = !G;
        if (s == null)
          return !k;
        for (s = Fn(s); R--; ) {
          var T = h[R];
          if (E && T[2] ? T[1] !== s[T[0]] : !(T[0] in s))
            return !1;
        }
        for (; ++R < k; ) {
          T = h[R];
          var j = T[0], ae = s[j], ge = T[1];
          if (E && T[2]) {
            if (ae === te && !(j in s))
              return !1;
          } else {
            var ce = new Qg();
            if (G)
              var Fe = G(ae, ge, j, s, u, ce);
            if (!(Fe === te ? Bl(ge, ae, vt | Kt, G, ce) : Fe))
              return !1;
          }
        }
        return !0;
      }
      function qG(s) {
        return !(!Mn(s) || zp(s)) && (Is(s) ? Pn : cp).test(tI(s));
      }
      function SR(s) {
        return jn(s) && Xr(s) == tg;
      }
      function rs(s) {
        return jn(s) && sg(s) == Xi;
      }
      function VR(s) {
        return jn(s) && xg(s.length) && !!yn[Xr(s)];
      }
      function _G(s) {
        return typeof s == "function" ? s : s == null ? lg : typeof s == "object" ? vi(s) ? ey(s[0], s[1]) : $G(s) : oC(s);
      }
      function wp(s) {
        if (!td(s))
          return rW(s);
        var u = [];
        for (var h in Fn(s))
          dn.call(s, h) && h != "constructor" && u.push(h);
        return u;
      }
      function wR(s) {
        if (!Mn(s))
          return eI(s);
        var u = td(s), h = [];
        for (var G in s)
          (G != "constructor" || !u && dn.call(s, G)) && h.push(G);
        return h;
      }
      function vp(s, u) {
        return s < u;
      }
      function la(s, u) {
        var h = -1, G = Fg(s) ? cn(s.length) : [];
        return Aa(s, function(R, k, E) {
          G[++h] = u(R, k, E);
        }), G;
      }
      function $G(s) {
        var u = ec(s);
        return u.length == 1 && u[0][2] ? mb(u[0][0], u[0][1]) : function(h) {
          return h === s || Vp(h, s, u);
        };
      }
      function ey(s, u) {
        return Cb(s) && hb(u) ? mb(ua(s), u) : function(h) {
          var G = A0(h, s);
          return G === te && G === u ? b0(h, s) : Bl(u, G, vt | Kt);
        };
      }
      function $A(s, u, h, G, R) {
        s !== u && cC(u, function(k, E) {
          if (R || (R = new Qg()), Mn(k))
            vR(s, u, E, h, $A, G, R);
          else {
            var T = G ? G(Qp(s, E), k, E + "", s, u, R) : te;
            T === te && (T = k), Eu(s, E, T);
          }
        }, _g);
      }
      function vR(s, u, h, G, R, k, E) {
        var T = Qp(s, h), j = Qp(u, h), ae = E.get(j);
        if (ae)
          return Eu(s, h, ae), te;
        var ge = k ? k(T, j, h + "", s, u, E) : te, ce = ge === te;
        if (ce) {
          var Fe = vi(j), ze = !Fe && ba(j), nt = !Fe && !ze && dd(j);
          ge = j, Fe || ze || nt ? vi(T) ? ge = T : or(T) ? ge = rg(T) : ze ? (ce = !1, ge = xp(j, !0)) : nt ? (ce = !1, ge = rb(j, !0)) : ge = [] : rC(j) || rc(j) ? (ge = T, rc(T) ? ge = Ey(T) : Mn(T) && !Is(T) || (ge = ub(j))) : ce = !1;
        }
        ce && (E.set(j, ge), R(ge, j, G, k, E), E.delete(j)), Eu(s, h, ge);
      }
      function ty(s, u) {
        var h = s.length;
        if (h)
          return u += u < 0 ? h : 0, gg(u, h) ? s[u] : te;
      }
      function js(s, u, h) {
        u = u.length ? c(u, function(R) {
          return vi(R) ? function(k) {
            return jI(k, R.length === 1 ? R[0] : R);
          } : R;
        }) : [lg];
        var G = -1;
        return u = c(u, N(bi())), x(la(s, function(R, k, E) {
          return { criteria: c(u, function(T) {
            return T(R);
          }), index: ++G, value: R };
        }), function(R, k) {
          return $I(R, k, h);
        });
      }
      function RR(s, u) {
        return iy(s, u, function(h, G) {
          return b0(s, G);
        });
      }
      function iy(s, u, h) {
        for (var G = -1, R = u.length, k = {}; ++G < R; ) {
          var E = u[G], T = jI(s, E);
          h(T, E) && Mu(k, Zl(E, s), T);
        }
        return k;
      }
      function fl(s) {
        return function(u) {
          return jI(u, s);
        };
      }
      function Rp(s, u, h, G) {
        var R = G ? y : Z, k = -1, E = u.length, T = s;
        for (s === u && (u = rg(u)), h && (T = c(s, N(h))); ++k < E; )
          for (var j = 0, ae = u[k], ge = h ? h(ae) : ae; (j = R(T, ge, j, G)) > -1; )
            T !== s && Kb.call(T, j, 1), Kb.call(s, j, 1);
        return s;
      }
      function ny(s, u) {
        for (var h = s ? u.length : 0, G = h - 1; h--; ) {
          var R = u[h];
          if (h == G || R !== k) {
            var k = R;
            gg(R) ? Kb.call(s, R, 1) : qg(s, R);
          }
        }
        return s;
      }
      function Xp(s, u) {
        return s + Pb(W0() * (u - s + 1));
      }
      function XR(s, u, h, G) {
        for (var R = -1, k = Wn(As((u - s) / (h || 1)), 0), E = cn(k); k--; )
          E[G ? k : ++R] = s, s += h;
        return E;
      }
      function Hp(s, u) {
        var h = "";
        if (!s || u < 1 || u > Ke)
          return h;
        do
          u % 2 && (h += s), u = Pb(u / 2), u && (s += s);
        while (u);
        return h;
      }
      function Ji(s, u) {
        return v0(Op(s, u, lg), s + "");
      }
      function ry(s) {
        return UG(od(s));
      }
      function HR(s, u) {
        var h = od(s);
        return qu(h, OI(u, 0, h.length));
      }
      function Mu(s, u, h, G) {
        if (!Mn(s))
          return s;
        u = Zl(u, s);
        for (var R = -1, k = u.length, E = k - 1, T = s; T != null && ++R < k; ) {
          var j = ua(u[R]), ae = h;
          if (j === "__proto__" || j === "constructor" || j === "prototype")
            return s;
          if (R != E) {
            var ge = T[j];
            ae = G ? G(ge, j, T) : te, ae === te && (ae = Mn(ge) ? ge : gg(u[R + 1]) ? [] : {});
          }
          Nu(T, j, ae), T = T[j];
        }
        return s;
      }
      function kp(s) {
        return qu(od(s));
      }
      function ig(s, u, h) {
        var G = -1, R = s.length;
        u < 0 && (u = -u > R ? 0 : R + u), h = h > R ? R : h, h < 0 && (h += R), R = u > h ? 0 : h - u >>> 0, u >>>= 0;
        for (var k = cn(R); ++G < R; )
          k[G] = s[G + u];
        return k;
      }
      function eb(s, u) {
        var h;
        return Aa(s, function(G, R, k) {
          return h = u(G, R, k), !h;
        }), !!h;
      }
      function tb(s, u, h) {
        var G = 0, R = s == null ? G : s.length;
        if (typeof u == "number" && u === u && R <= dt) {
          for (; G < R; ) {
            var k = G + R >>> 1, E = s[k];
            E !== null && !Ao(E) && (h ? E <= u : E < u) ? G = k + 1 : R = k;
          }
          return R;
        }
        return ib(s, u, lg, h);
      }
      function ib(s, u, h, G) {
        var R = 0, k = s == null ? 0 : s.length;
        if (k === 0)
          return 0;
        u = h(u);
        for (var E = u !== u, T = u === null, j = Ao(u), ae = u === te; R < k; ) {
          var ge = Pb((R + k) / 2), ce = h(s[ge]), Fe = ce !== te, ze = ce === null, nt = ce === ce, Vt = Ao(ce);
          if (E)
            var rt = G || nt;
          else
            rt = ae ? nt && (G || Fe) : T ? nt && Fe && (G || !ze) : j ? nt && Fe && !ze && (G || !Vt) : !ze && !Vt && (G ? ce <= u : ce < u);
          rt ? R = ge + 1 : k = ge;
        }
        return oi(k, Et);
      }
      function gy(s, u) {
        for (var h = -1, G = s.length, R = 0, k = []; ++h < G; ) {
          var E = s[h], T = u ? u(E) : E;
          if (!h || !Po(T, j)) {
            var j = T;
            k[R++] = E === 0 ? 0 : E;
          }
        }
        return k;
      }
      function aa(s) {
        return typeof s == "number" ? s : Ao(s) ? Rt : +s;
      }
      function Xg(s) {
        if (typeof s == "string")
          return s;
        if (vi(s))
          return c(s, Xg) + "";
        if (Ao(s))
          return oW ? oW.call(s) : "";
        var u = s + "";
        return u == "0" && 1 / s == -Ne ? "-0" : u;
      }
      function jg(s, u, h) {
        var G = -1, R = a, k = s.length, E = !0, T = [], j = T;
        if (h)
          E = !1, R = I;
        else if (k >= Ht) {
          var ae = u ? null : PH(s);
          if (ae)
            return xe(ae);
          E = !1, R = O, j = new ga();
        } else
          j = u ? [] : T;
        e:
          for (; ++G < k; ) {
            var ge = s[G], ce = u ? u(ge) : ge;
            if (ge = h || ge !== 0 ? ge : 0, E && ce === ce) {
              for (var Fe = j.length; Fe--; )
                if (j[Fe] === ce)
                  continue e;
              u && j.push(ce), T.push(ge);
            } else
              R(j, ce, h) || (j !== T && j.push(ce), T.push(ge));
          }
        return T;
      }
      function qg(s, u) {
        return u = Zl(u, s), s = pb(s, u), s == null || delete s[ua(kg(u))];
      }
      function oy(s, u, h, G) {
        return Mu(s, u, h(jI(s, u)), G);
      }
      function Pu(s, u, h, G) {
        for (var R = s.length, k = G ? R : -1; (G ? k-- : ++k < R) && u(s[k], k, s); )
          ;
        return h ? ig(s, G ? 0 : k, G ? k + 1 : R) : ig(s, G ? k + 1 : 0, G ? R : k);
      }
      function Yp(s, u) {
        var h = s;
        return h instanceof ut && (h = h.value()), C(u, function(G, R) {
          return R.func.apply(R.thisArg, d([G], R.args));
        }, h);
      }
      function _I(s, u, h) {
        var G = s.length;
        if (G < 2)
          return G ? jg(s[0]) : [];
        for (var R = -1, k = cn(G); ++R < G; )
          for (var E = s[R], T = -1; ++T < G; )
            T != R && (k[R] = QI(k[R] || E, s[T], u, h));
        return jg(Qn(k, 1), u, h);
      }
      function gs(s, u, h) {
        for (var G = -1, R = s.length, k = u.length, E = {}; ++G < R; )
          h(E, s[G], G < k ? u[G] : te);
        return E;
      }
      function nb(s) {
        return or(s) ? s : [];
      }
      function Fp(s) {
        return typeof s == "function" ? s : lg;
      }
      function Zl(s, u) {
        return vi(s) ? s : Cb(s, u) ? [s] : cW(gn(s));
      }
      function qs(s, u, h) {
        var G = s.length;
        return h = h === te ? G : h, !u && h >= G ? s : ig(s, u, h);
      }
      function xp(s, u) {
        if (u)
          return s.slice();
        var h = s.length, G = $y ? $y(h) : new s.constructor(h);
        return s.copy(G), G;
      }
      function yr(s) {
        var u = new s.constructor(s.byteLength);
        return new Nb(u).set(new Nb(s)), u;
      }
      function Dp(s, u) {
        return new s.constructor(u ? yr(s.buffer) : s.buffer, s.byteOffset, s.byteLength);
      }
      function ly(s) {
        var u = new s.constructor(s.source, na.exec(s));
        return u.lastIndex = s.lastIndex, u;
      }
      function sa(s) {
        return IC ? Fn(IC.call(s)) : {};
      }
      function rb(s, u) {
        return new s.constructor(u ? yr(s.buffer) : s.buffer, s.byteOffset, s.length);
      }
      function Uu(s, u) {
        if (s !== u) {
          var h = s !== te, G = s === null, R = s === s, k = Ao(s), E = u !== te, T = u === null, j = u === u, ae = Ao(u);
          if (!T && !ae && !k && s > u || k && E && j && !T && !ae || G && E && j || !h && j || !R)
            return 1;
          if (!G && !k && !ae && s < u || ae && h && R && !G && !k || T && h && R || !E && R || !j)
            return -1;
        }
        return 0;
      }
      function $I(s, u, h) {
        for (var G = -1, R = s.criteria, k = u.criteria, E = R.length, T = h.length; ++G < E; ) {
          var j = Uu(R[G], k[G]);
          if (j)
            return G >= T ? j : j * (h[G] == "desc" ? -1 : 1);
        }
        return s.index - u.index;
      }
      function Jp(s, u, h, G) {
        for (var R = -1, k = s.length, E = h.length, T = -1, j = u.length, ae = Wn(k - E, 0), ge = cn(j + ae), ce = !G; ++T < j; )
          ge[T] = u[T];
        for (; ++R < E; )
          (ce || R < k) && (ge[h[R]] = s[R]);
        for (; ae--; )
          ge[T++] = s[R++];
        return ge;
      }
      function ng(s, u, h, G) {
        for (var R = -1, k = s.length, E = -1, T = h.length, j = -1, ae = u.length, ge = Wn(k - T, 0), ce = cn(ge + ae), Fe = !G; ++R < ge; )
          ce[R] = s[R];
        for (var ze = R; ++j < ae; )
          ce[ze + j] = u[j];
        for (; ++E < T; )
          (Fe || R < k) && (ce[ze + h[E]] = s[R++]);
        return ce;
      }
      function rg(s, u) {
        var h = -1, G = s.length;
        for (u || (u = cn(G)); ++h < G; )
          u[h] = s[h];
        return u;
      }
      function Ia(s, u, h, G) {
        var R = !h;
        h || (h = {});
        for (var k = -1, E = u.length; ++k < E; ) {
          var T = u[k], j = G ? G(h[T], s[T], T, h, s) : te;
          j === te && (j = s[T]), R ? Ln(h, T, j) : Nu(h, T, j);
        }
        return h;
      }
      function kR(s, u) {
        return Ia(s, V0(s), u);
      }
      function YR(s, u) {
        return Ia(s, w0(s), u);
      }
      function jc(s, u) {
        return function(h, G) {
          var R = vi(h) ? n : BR, k = u ? u() : {};
          return R(h, s, bi(G, 2), k);
        };
      }
      function qc(s) {
        return Ji(function(u, h) {
          var G = -1, R = h.length, k = R > 1 ? h[R - 1] : te, E = R > 2 ? h[2] : te;
          for (k = s.length > 3 && typeof k == "function" ? (R--, k) : te, E && Tr(h[0], h[1], E) && (k = R < 3 ? te : k, R = 1), u = Fn(u); ++G < R; ) {
            var T = h[G];
            T && s(u, T, G, k);
          }
          return u;
        });
      }
      function _c(s, u) {
        return function(h, G) {
          if (h == null)
            return h;
          if (!Fg(h))
            return s(h, G);
          for (var R = h.length, k = u ? R : -1, E = Fn(h); (u ? k-- : ++k < R) && G(E[k], k, E) !== !1; )
            ;
          return h;
        };
      }
      function Ep(s) {
        return function(u, h, G) {
          for (var R = -1, k = Fn(u), E = G(u), T = E.length; T--; ) {
            var j = E[s ? T : ++R];
            if (h(k[j], j, k) === !1)
              break;
          }
          return u;
        };
      }
      function FR(s, u, h) {
        function G() {
          return (this && this !== Kr && this instanceof G ? k : s).apply(R ? h : this, arguments);
        }
        var R = u & Te, k = zu(s);
        return G;
      }
      function ay(s) {
        return function(u) {
          u = gn(u);
          var h = Je(u) ? Qe(u) : te, G = h ? h[0] : u.charAt(0), R = h ? qs(h, 1).join("") : u.slice(1);
          return G[s]() + R;
        };
      }
      function ca(s) {
        return function(u) {
          return C(Uy(Ty(u).replace(hp, "")), s, "");
        };
      }
      function zu(s) {
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return new s();
            case 1:
              return new s(u[0]);
            case 2:
              return new s(u[0], u[1]);
            case 3:
              return new s(u[0], u[1], u[2]);
            case 4:
              return new s(u[0], u[1], u[2], u[3]);
            case 5:
              return new s(u[0], u[1], u[2], u[3], u[4]);
            case 6:
              return new s(u[0], u[1], u[2], u[3], u[4], u[5]);
            case 7:
              return new s(u[0], u[1], u[2], u[3], u[4], u[5], u[6]);
          }
          var h = sd(s.prototype), G = s.apply(h, u);
          return Mn(G) ? G : h;
        };
      }
      function xR(s, u, h) {
        function G() {
          for (var k = arguments.length, E = cn(k), T = k, j = Si(G); T--; )
            E[T] = arguments[T];
          var ae = k < 3 && E[0] !== j && E[k - 1] !== j ? [] : Ze(E, j);
          return k -= ae.length, k < h ? Lp(s, u, ob, G.placeholder, te, E, ae, te, te, h - k) : i(this && this !== Kr && this instanceof G ? R : s, this, E);
        }
        var R = zu(s);
        return G;
      }
      function gb(s) {
        return function(u, h, G) {
          var R = Fn(u);
          if (!Fg(u)) {
            var k = bi(h, 3);
            u = Hr(u), h = function(T) {
              return k(R[T], T, R);
            };
          }
          var E = s(u, h, G);
          return E > -1 ? R[k ? u[E] : E] : te;
        };
      }
      function Np(s) {
        return da(function(u) {
          var h = u.length, G = h, R = ct.prototype.thru;
          for (s && u.reverse(); G--; ) {
            var k = u[G];
            if (typeof k != "function")
              throw new zo($t);
            if (R && !E && ed(k) == "wrapper")
              var E = new ct([], !0);
          }
          for (G = E ? G : h; ++G < h; ) {
            k = u[G];
            var T = ed(k), j = T == "wrapper" ? S0(k) : te;
            E = j && bb(j[0]) && j[1] == (di | Me | zt | mt) && !j[4].length && j[9] == 1 ? E[ed(j[0])].apply(E, j[3]) : k.length == 1 && bb(k) ? E[T]() : E.thru(k);
          }
          return function() {
            var ae = arguments, ge = ae[0];
            if (E && ae.length == 1 && vi(ge))
              return E.plant(ge).value();
            for (var ce = 0, Fe = h ? u[ce].apply(this, ae) : ge; ++ce < h; )
              Fe = u[ce].call(this, Fe);
            return Fe;
          };
        });
      }
      function ob(s, u, h, G, R, k, E, T, j, ae) {
        function ge() {
          for (var Nt = arguments.length, Pt = cn(Nt), mn = Nt; mn--; )
            Pt[mn] = arguments[mn];
          if (nt)
            var pn = Si(ge), Cr = be(Pt, pn);
          if (G && (Pt = Jp(Pt, G, R, nt)), k && (Pt = ng(Pt, k, E, nt)), Nt -= Cr, nt && Nt < ae)
            return Lp(s, u, ob, ge.placeholder, h, Pt, Ze(Pt, pn), T, j, ae - Nt);
          var Hi = Fe ? h : this, qn = ze ? Hi[s] : s;
          return Nt = Pt.length, T ? Pt = TR(Pt, T) : Vt && Nt > 1 && Pt.reverse(), ce && j < Nt && (Pt.length = j), this && this !== Kr && this instanceof ge && (qn = rt || zu(qn)), qn.apply(Hi, Pt);
        }
        var ce = u & di, Fe = u & Te, ze = u & Tt, nt = u & (Me | Yt), Vt = u & Ai, rt = ze ? te : zu(s);
        return ge;
      }
      function sy(s, u) {
        return function(h, G) {
          return To(h, s, u(G), {});
        };
      }
      function lb(s, u) {
        return function(h, G) {
          var R;
          if (h === te && G === te)
            return u;
          if (h !== te && (R = h), G !== te) {
            if (R === te)
              return G;
            typeof h == "string" || typeof G == "string" ? (h = Xg(h), G = Xg(G)) : (h = aa(h), G = aa(G)), R = s(h, G);
          }
          return R;
        };
      }
      function ab(s) {
        return da(function(u) {
          return u = c(u, N(bi())), Ji(function(h) {
            var G = this;
            return s(u, function(R) {
              return i(R, G, h);
            });
          });
        });
      }
      function $c(s, u) {
        u = u === te ? " " : Xg(u);
        var h = u.length;
        if (h < 2)
          return h ? Hp(u, s) : u;
        var G = Hp(u, As(s / it(u)));
        return Je(u) ? qs(Qe(G), 0, s).join("") : G.slice(0, s);
      }
      function DR(s, u, h, G) {
        function R() {
          for (var T = -1, j = arguments.length, ae = -1, ge = G.length, ce = cn(ge + j), Fe = this && this !== Kr && this instanceof R ? E : s; ++ae < ge; )
            ce[ae] = G[ae];
          for (; j--; )
            ce[ae++] = arguments[++T];
          return i(Fe, k ? h : this, ce);
        }
        var k = u & Te, E = zu(s);
        return R;
      }
      function sb(s) {
        return function(u, h, G) {
          return G && typeof G != "number" && Tr(u, h, G) && (h = G = te), u = cs(u), h === te ? (h = u, u = 0) : h = cs(h), G = G === te ? u < h ? 1 : -1 : cs(G), XR(u, h, G, s);
        };
      }
      function Ou(s) {
        return function(u, h) {
          return typeof u == "string" && typeof h == "string" || (u = Uo(u), h = Uo(h)), s(u, h);
        };
      }
      function Lp(s, u, h, G, R, k, E, T, j, ae) {
        var ge = u & Me, ce = ge ? E : te, Fe = ge ? te : E, ze = ge ? k : te, nt = ge ? te : k;
        u |= ge ? zt : ri, u &= ~(ge ? ri : zt), u & Ue || (u &= ~(Te | Tt));
        var Vt = [s, u, R, ze, ce, nt, Fe, T, j, ae], rt = h.apply(te, Vt);
        return bb(s) && IW(rt, Vt), rt.placeholder = G, Cy(rt, s, u);
      }
      function Ib(s) {
        var u = fi[s];
        return function(h, G) {
          if (h = Uo(h), G = G == null ? 0 : oi(Fi(G), 292), G && nW(h)) {
            var R = (gn(h) + "e").split("e");
            return R = (gn(u(R[0] + "e" + (+R[1] + G))) + "e").split("e"), +(R[0] + "e" + (+R[1] - G));
          }
          return u(h);
        };
      }
      function Qu(s) {
        return function(u) {
          var h = sg(u);
          return h == ti ? ue(u) : h == Xi ? Pe(u) : M(u, s(u));
        };
      }
      function os(s, u, h, G, R, k, E, T) {
        var j = u & Tt;
        if (!j && typeof s != "function")
          throw new zo($t);
        var ae = G ? G.length : 0;
        if (ae || (u &= ~(zt | ri), G = R = te), E = E === te ? E : Wn(Fi(E), 0), T = T === te ? T : Fi(T), ae -= R ? R.length : 0, u & ri) {
          var ge = G, ce = R;
          G = R = te;
        }
        var Fe = j ? te : S0(s), ze = [s, u, h, G, R, ge, ce, k, E, T];
        if (Fe && KR(ze, Fe), s = ze[0], u = ze[1], h = ze[2], G = ze[3], R = ze[4], T = ze[9] = ze[9] === te ? j ? 0 : s.length : Wn(ze[9] - ae, 0), !T && u & (Me | Yt) && (u &= ~(Me | Yt)), u && u != Te)
          nt = u == Me || u == Yt ? xR(s, u, T) : u != zt && u != (Te | zt) || R.length ? ob.apply(te, ze) : DR(s, u, h, G);
        else
          var nt = FR(s, u, h);
        return Cy((Fe ? sW : IW)(nt, ze), s, u);
      }
      function Kp(s, u, h, G) {
        return s === te || Po(s, ld[h]) && !dn.call(G, h) ? u : s;
      }
      function Tp(s, u, h, G, R, k) {
        return Mn(s) && Mn(u) && (k.set(u, s), $A(s, u, te, Tp, k), k.delete(u)), s;
      }
      function JR(s) {
        return rC(s) ? te : s;
      }
      function Mp(s, u, h, G, R, k) {
        var E = h & vt, T = s.length, j = u.length;
        if (T != j && !(E && j > T))
          return !1;
        var ae = k.get(s), ge = k.get(u);
        if (ae && ge)
          return ae == u && ge == s;
        var ce = -1, Fe = !0, ze = h & Kt ? new ga() : te;
        for (k.set(s, u), k.set(u, s); ++ce < T; ) {
          var nt = s[ce], Vt = u[ce];
          if (G)
            var rt = E ? G(Vt, nt, ce, u, s, k) : G(nt, Vt, ce, s, u, k);
          if (rt !== te) {
            if (rt)
              continue;
            Fe = !1;
            break;
          }
          if (ze) {
            if (!b(u, function(Nt, Pt) {
              if (!O(ze, Pt) && (nt === Nt || R(nt, Nt, h, G, k)))
                return ze.push(Pt);
            })) {
              Fe = !1;
              break;
            }
          } else if (nt !== Vt && !R(nt, Vt, h, G, k)) {
            Fe = !1;
            break;
          }
        }
        return k.delete(s), k.delete(u), Fe;
      }
      function ER(s, u, h, G, R, k, E) {
        switch (h) {
          case ml:
            if (s.byteLength != u.byteLength || s.byteOffset != u.byteOffset)
              return !1;
            s = s.buffer, u = u.buffer;
          case ia:
            return !(s.byteLength != u.byteLength || !k(new Nb(s), new Nb(u)));
          case fe:
          case Ae:
          case tn:
            return Po(+s, +u);
          case _e:
            return s.name == u.name && s.message == u.message;
          case tg:
          case bn:
            return s == u + "";
          case ti:
            var T = ue;
          case Xi:
            var j = G & vt;
            if (T || (T = xe), s.size != u.size && !j)
              return !1;
            var ae = E.get(s);
            if (ae)
              return ae == u;
            G |= Kt, E.set(s, u);
            var ge = Mp(T(s), T(u), G, R, k, E);
            return E.delete(s), ge;
          case so:
            if (IC)
              return IC.call(s) == IC.call(u);
        }
        return !1;
      }
      function Pp(s, u, h, G, R, k) {
        var E = h & vt, T = ju(s), j = T.length;
        if (j != ju(u).length && !E)
          return !1;
        for (var ae = j; ae--; ) {
          var ge = T[ae];
          if (!(E ? ge in u : dn.call(u, ge)))
            return !1;
        }
        var ce = k.get(s), Fe = k.get(u);
        if (ce && Fe)
          return ce == u && Fe == s;
        var ze = !0;
        k.set(s, u), k.set(u, s);
        for (var nt = E; ++ae < j; ) {
          ge = T[ae];
          var Vt = s[ge], rt = u[ge];
          if (G)
            var Nt = E ? G(rt, Vt, ge, u, s, k) : G(Vt, rt, ge, s, u, k);
          if (!(Nt === te ? Vt === rt || R(Vt, rt, h, G, k) : Nt)) {
            ze = !1;
            break;
          }
          nt || (nt = ge == "constructor");
        }
        if (ze && !nt) {
          var Pt = s.constructor, mn = u.constructor;
          Pt != mn && "constructor" in s && "constructor" in u && !(typeof Pt == "function" && Pt instanceof Pt && typeof mn == "function" && mn instanceof mn) && (ze = !1);
        }
        return k.delete(s), k.delete(u), ze;
      }
      function da(s) {
        return v0(Op(s, te, nd), s + "");
      }
      function ju(s) {
        return OG(s, Hr, V0);
      }
      function Up(s) {
        return OG(s, _g, w0);
      }
      function ed(s) {
        for (var u = s.name + "", h = ad[u], G = dn.call(ad, u) ? h.length : 0; G--; ) {
          var R = h[G], k = R.func;
          if (k == null || k == s)
            return R.name;
        }
        return u;
      }
      function Si(s) {
        return (dn.call(Y, "placeholder") ? Y : s).placeholder;
      }
      function bi() {
        var s = Y.iteratee || kb;
        return s = s === kb ? _G : s, arguments.length ? s(arguments[0], arguments[1]) : s;
      }
      function cb(s, u) {
        var h = s.__data__;
        return Ab(u) ? h[typeof u == "string" ? "string" : "hash"] : h.map;
      }
      function ec(s) {
        for (var u = Hr(s), h = u.length; h--; ) {
          var G = u[h], R = s[G];
          u[h] = [G, R, hb(R)];
        }
        return u;
      }
      function _s(s, u) {
        var h = He(s, u);
        return qG(h) ? h : te;
      }
      function NR(s) {
        var u = dn.call(s, Cs), h = s[Cs];
        try {
          s[Cs] = te;
          var G = !0;
        } catch {
        }
        var R = Oo.call(s);
        return G && (u ? s[Cs] = h : delete s[Cs]), R;
      }
      function LR(s, u, h) {
        for (var G = -1, R = h.length; ++G < R; ) {
          var k = h[G], E = k.size;
          switch (k.type) {
            case "drop":
              s += E;
              break;
            case "dropRight":
              u -= E;
              break;
            case "take":
              u = oi(u, s + E);
              break;
            case "takeRight":
              s = Wn(s, u - E);
          }
        }
        return { start: s, end: u };
      }
      function Mo(s) {
        var u = s.match(DA);
        return u ? u[1].split(lp) : [];
      }
      function Iy(s, u, h) {
        u = Zl(u, s);
        for (var G = -1, R = u.length, k = !1; ++G < R; ) {
          var E = ua(u[G]);
          if (!(k = s != null && h(s, E)))
            break;
          s = s[E];
        }
        return k || ++G != R ? k : (R = s == null ? 0 : s.length, !!R && xg(R) && gg(E, R) && (vi(s) || rc(s)));
      }
      function db(s) {
        var u = s.length, h = new s.constructor(u);
        return u && typeof s[0] == "string" && dn.call(s, "index") && (h.index = s.index, h.input = s.input), h;
      }
      function ub(s) {
        return typeof s.constructor != "function" || td(s) ? {} : sd(Lb(s));
      }
      function cy(s, u, h) {
        var G = s.constructor;
        switch (u) {
          case ia:
            return yr(s);
          case fe:
          case Ae:
            return new G(+s);
          case ml:
            return Dp(s, h);
          case xc:
          case Dc:
          case NI:
          case LI:
          case Gu:
          case Jc:
          case Ps:
          case KI:
          case yu:
            return rb(s, h);
          case ti:
            return new G();
          case tn:
          case bn:
            return new G(s);
          case tg:
            return ly(s);
          case Xi:
            return new G();
          case so:
            return sa(s);
        }
      }
      function dy(s, u) {
        var h = u.length;
        if (!h)
          return s;
        var G = h - 1;
        return u[G] = (h > 1 ? "& " : "") + u[G], u = u.join(h > 2 ? ", " : " "), s.replace(ku, `{
/* [wrapped with ` + u + `] */
`);
      }
      function Co(s) {
        return vi(s) || rc(s) || !!(G0 && s && s[G0]);
      }
      function gg(s, u) {
        var h = typeof s;
        return u = u ?? Ke, !!u && (h == "number" || h != "symbol" && ki.test(s)) && s > -1 && s % 1 == 0 && s < u;
      }
      function Tr(s, u, h) {
        if (!Mn(h))
          return !1;
        var G = typeof u;
        return !!(G == "number" ? Fg(h) && gg(u, h.length) : G == "string" && u in h) && Po(h[u], s);
      }
      function Cb(s, u) {
        if (vi(s))
          return !1;
        var h = typeof s;
        return !(h != "number" && h != "symbol" && h != "boolean" && s != null && !Ao(s)) || xA.test(s) || !Kc.test(s) || u != null && s in Fn(u);
      }
      function Ab(s) {
        var u = typeof s;
        return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? s !== "__proto__" : s === null;
      }
      function bb(s) {
        var u = ed(s), h = Y[u];
        if (typeof h != "function" || !(u in ut.prototype))
          return !1;
        if (s === h)
          return !0;
        var G = S0(h);
        return !!G && s === G[0];
      }
      function zp(s) {
        return !!qy && qy in s;
      }
      function td(s) {
        var u = s && s.constructor;
        return s === (typeof u == "function" && u.prototype || ld);
      }
      function hb(s) {
        return s === s && !Mn(s);
      }
      function mb(s, u) {
        return function(h) {
          return h != null && h[s] === u && (u !== te || s in Fn(h));
        };
      }
      function $s(s) {
        var u = Vb(s, function(G) {
          return h.size === Bi && h.clear(), G;
        }), h = u.cache;
        return u;
      }
      function KR(s, u) {
        var h = s[1], G = u[1], R = h | G, k = R < (Te | Tt | di), E = G == di && h == Me || G == di && h == mt && s[7].length <= u[8] || G == (di | mt) && u[7].length <= u[8] && h == Me;
        if (!k && !E)
          return s;
        G & Te && (s[2] = u[2], R |= h & Te ? 0 : Ue);
        var T = u[3];
        if (T) {
          var j = s[3];
          s[3] = j ? Jp(j, T, u[4]) : T, s[4] = j ? Ze(s[3], ci) : u[4];
        }
        return T = u[5], T && (j = s[5], s[5] = j ? ng(j, T, u[6]) : T, s[6] = j ? Ze(s[5], ci) : u[6]), T = u[7], T && (s[7] = T), G & di && (s[8] = s[8] == null ? u[8] : oi(s[8], u[8])), s[9] == null && (s[9] = u[9]), s[0] = u[0], s[1] = R, s;
      }
      function eI(s) {
        var u = [];
        if (s != null)
          for (var h in Fn(s))
            u.push(h);
        return u;
      }
      function uy(s) {
        return Oo.call(s);
      }
      function Op(s, u, h) {
        return u = Wn(u === te ? s.length - 1 : u, 0), function() {
          for (var G = arguments, R = -1, k = Wn(G.length - u, 0), E = cn(k); ++R < k; )
            E[R] = G[u + R];
          R = -1;
          for (var T = cn(u + 1); ++R < u; )
            T[R] = G[R];
          return T[u] = h(E), i(s, this, T);
        };
      }
      function pb(s, u) {
        return u.length < 2 ? s : jI(s, ig(u, 0, -1));
      }
      function TR(s, u) {
        for (var h = s.length, G = oi(u.length, h), R = rg(s); G--; ) {
          var k = u[G];
          s[G] = gg(k, h) ? R[k] : te;
        }
        return s;
      }
      function Qp(s, u) {
        if ((u !== "constructor" || typeof s[u] != "function") && u != "__proto__")
          return s[u];
      }
      function Cy(s, u, h) {
        var G = u + "";
        return v0(s, dy(G, Ay(Mo(G), h)));
      }
      function jp(s) {
        var u = 0, h = 0;
        return function() {
          var G = gW(), R = Rn - (G - h);
          if (h = G, R > 0) {
            if (++u >= Oi)
              return arguments[0];
          } else
            u = 0;
          return s.apply(te, arguments);
        };
      }
      function qu(s, u) {
        var h = -1, G = s.length, R = G - 1;
        for (u = u === te ? G : u; ++h < u; ) {
          var k = Xp(h, R), E = s[k];
          s[k] = s[h], s[h] = E;
        }
        return s.length = u, s;
      }
      function ua(s) {
        if (typeof s == "string" || Ao(s))
          return s;
        var u = s + "";
        return u == "0" && 1 / s == -Ne ? "-0" : u;
      }
      function tI(s) {
        if (s != null) {
          try {
            return Jb.call(s);
          } catch {
          }
          try {
            return s + "";
          } catch {
          }
        }
        return "";
      }
      function Ay(s, u) {
        return r(xt, function(h) {
          var G = "_." + h[0];
          u & h[1] && !a(s, G) && s.push(G);
        }), s.sort();
      }
      function Hg(s) {
        if (s instanceof ut)
          return s.clone();
        var u = new ct(s.__wrapped__, s.__chain__);
        return u.__actions__ = rg(s.__actions__), u.__index__ = s.__index__, u.__values__ = s.__values__, u;
      }
      function Ca(s, u, h) {
        u = (h ? Tr(s, u, h) : u === te) ? 1 : Wn(Fi(u), 0);
        var G = s == null ? 0 : s.length;
        if (!G || u < 1)
          return [];
        for (var R = 0, k = 0, E = cn(As(G / u)); R < G; )
          E[k++] = ig(s, R, R += u);
        return E;
      }
      function MR(s) {
        for (var u = -1, h = s == null ? 0 : s.length, G = 0, R = []; ++u < h; ) {
          var k = s[u];
          k && (R[G++] = k);
        }
        return R;
      }
      function PR() {
        var s = arguments.length;
        if (!s)
          return [];
        for (var u = cn(s - 1), h = arguments[0], G = s; G--; )
          u[G - 1] = arguments[G];
        return d(vi(h) ? rg(h) : [h], Qn(u, 1));
      }
      function Bb(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === te ? 1 : Fi(u), ig(s, u < 0 ? 0 : u, G)) : [];
      }
      function id(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === te ? 1 : Fi(u), u = G - u, ig(s, 0, u < 0 ? 0 : u)) : [];
      }
      function by(s, u) {
        return s && s.length ? Pu(s, bi(u, 3), !0, !0) : [];
      }
      function hy(s, u) {
        return s && s.length ? Pu(s, bi(u, 3), !0) : [];
      }
      function UR(s, u, h, G) {
        var R = s == null ? 0 : s.length;
        return R ? (h && typeof h != "number" && Tr(s, u, h) && (h = 0, G = R), Ku(s, u, h, G)) : [];
      }
      function qp(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = h == null ? 0 : Fi(h);
        return R < 0 && (R = Wn(G + R, 0)), f(s, bi(u, 3), R);
      }
      function tc(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = G - 1;
        return h !== te && (R = Fi(h), R = h < 0 ? Wn(G + R, 0) : oi(R, G - 1)), f(s, bi(u, 3), R, !0);
      }
      function nd(s) {
        return s != null && s.length ? Qn(s, 1) : [];
      }
      function zR(s) {
        return s != null && s.length ? Qn(s, Ne) : [];
      }
      function my(s, u) {
        return s != null && s.length ? (u = u === te ? 1 : Fi(u), Qn(s, u)) : [];
      }
      function py(s) {
        for (var u = -1, h = s == null ? 0 : s.length, G = {}; ++u < h; ) {
          var R = s[u];
          G[R[0]] = R[1];
        }
        return G;
      }
      function _u(s) {
        return s && s.length ? s[0] : te;
      }
      function By(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = h == null ? 0 : Fi(h);
        return R < 0 && (R = Wn(G + R, 0)), Z(s, u, R);
      }
      function fb(s) {
        return s != null && s.length ? ig(s, 0, -1) : [];
      }
      function _p(s, u) {
        return s == null ? "" : DH.call(s, u);
      }
      function kg(s) {
        var u = s == null ? 0 : s.length;
        return u ? s[u - 1] : te;
      }
      function OR(s, u, h) {
        var G = s == null ? 0 : s.length;
        if (!G)
          return -1;
        var R = G;
        return h !== te && (R = Fi(h), R = R < 0 ? Wn(G + R, 0) : oi(R, G - 1)), u === u ? bt(s, u, R) : f(s, W, R, !0);
      }
      function fy(s, u) {
        return s && s.length ? ty(s, Fi(u)) : te;
      }
      function $u(s, u) {
        return s && s.length && u && u.length ? Rp(s, u) : s;
      }
      function Zy(s, u, h) {
        return s && s.length && u && u.length ? Rp(s, u, bi(h, 2)) : s;
      }
      function $p(s, u, h) {
        return s && s.length && u && u.length ? Rp(s, u, te, h) : s;
      }
      function QR(s, u) {
        var h = [];
        if (!s || !s.length)
          return h;
        var G = -1, R = [], k = s.length;
        for (u = bi(u, 3); ++G < k; ) {
          var E = s[G];
          u(E, G, s) && (h.push(E), R.push(G));
        }
        return ny(s, R), h;
      }
      function Zb(s) {
        return s == null ? s : JH.call(s);
      }
      function ls(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (h && typeof h != "number" && Tr(s, u, h) ? (u = 0, h = G) : (u = u == null ? 0 : Fi(u), h = h === te ? G : Fi(h)), ig(s, u, h)) : [];
      }
      function Gy(s, u) {
        return tb(s, u);
      }
      function yy(s, u, h) {
        return ib(s, u, bi(h, 2));
      }
      function jR(s, u) {
        var h = s == null ? 0 : s.length;
        if (h) {
          var G = tb(s, u);
          if (G < h && Po(s[G], u))
            return G;
        }
        return -1;
      }
      function Wy(s, u) {
        return tb(s, u, !0);
      }
      function qR(s, u, h) {
        return ib(s, u, bi(h, 2), !0);
      }
      function _R(s, u) {
        if (s != null && s.length) {
          var h = tb(s, u, !0) - 1;
          if (Po(s[h], u))
            return h;
        }
        return -1;
      }
      function as(s) {
        return s && s.length ? gy(s) : [];
      }
      function e0(s, u) {
        return s && s.length ? gy(s, bi(u, 2)) : [];
      }
      function t0(s) {
        var u = s == null ? 0 : s.length;
        return u ? ig(s, 1, u) : [];
      }
      function i0(s, u, h) {
        return s && s.length ? (u = h || u === te ? 1 : Fi(u), ig(s, 0, u < 0 ? 0 : u)) : [];
      }
      function Gb(s, u, h) {
        var G = s == null ? 0 : s.length;
        return G ? (u = h || u === te ? 1 : Fi(u), u = G - u, ig(s, u < 0 ? 0 : u, G)) : [];
      }
      function rd(s, u) {
        return s && s.length ? Pu(s, bi(u, 3), !1, !0) : [];
      }
      function hi(s, u) {
        return s && s.length ? Pu(s, bi(u, 3)) : [];
      }
      function yb(s) {
        return s && s.length ? jg(s) : [];
      }
      function n0(s, u) {
        return s && s.length ? jg(s, bi(u, 2)) : [];
      }
      function ic(s, u) {
        return u = typeof u == "function" ? u : te, s && s.length ? jg(s, te, u) : [];
      }
      function r0(s) {
        if (!s || !s.length)
          return [];
        var u = 0;
        return s = l(s, function(h) {
          if (or(h))
            return u = Wn(h.length, u), !0;
        }), K(u, function(h) {
          return c(s, w(h));
        });
      }
      function Wb(s, u) {
        if (!s || !s.length)
          return [];
        var h = r0(s);
        return u == null ? h : c(h, function(G) {
          return i(u, te, G);
        });
      }
      function Sy(s, u) {
        return gs(s || [], u || [], Nu);
      }
      function og(s, u) {
        return gs(s || [], u || [], Mu);
      }
      function Vy(s) {
        var u = Y(s);
        return u.__chain__ = !0, u;
      }
      function $R(s, u) {
        return u(s), s;
      }
      function eC(s, u) {
        return u(s);
      }
      function eX() {
        return Vy(this);
      }
      function wy() {
        return new ct(this.value(), this.__chain__);
      }
      function tX() {
        this.__values__ === te && (this.__values__ = Dy(this.value()));
        var s = this.__index__ >= this.__values__.length;
        return { done: s, value: s ? te : this.__values__[this.__index__++] };
      }
      function iX() {
        return this;
      }
      function nX(s) {
        for (var u, h = this; h instanceof Ee; ) {
          var G = Hg(h);
          G.__index__ = 0, G.__values__ = te, u ? R.__wrapped__ = G : u = G;
          var R = G;
          h = h.__wrapped__;
        }
        return R.__wrapped__ = s, u;
      }
      function ss() {
        var s = this.__wrapped__;
        if (s instanceof ut) {
          var u = s;
          return this.__actions__.length && (u = new ut(this)), u = u.reverse(), u.__actions__.push({ func: eC, args: [Zb], thisArg: te }), new ct(u, this.__chain__);
        }
        return this.thru(Zb);
      }
      function Yg() {
        return Yp(this.__wrapped__, this.__actions__);
      }
      function g0(s, u, h) {
        var G = vi(s) ? o : zc;
        return h && Tr(s, u, h) && (u = te), G(s, bi(u, 3));
      }
      function rX(s, u) {
        return (vi(s) ? l : Tu)(s, bi(u, 3));
      }
      function o0(s, u) {
        return Qn(Sb(s, u), 1);
      }
      function gX(s, u) {
        return Qn(Sb(s, u), Ne);
      }
      function oX(s, u, h) {
        return h = h === te ? 1 : Fi(h), Qn(Sb(s, u), h);
      }
      function gd(s, u) {
        return (vi(s) ? r : Aa)(s, bi(u, 3));
      }
      function l0(s, u) {
        return (vi(s) ? g : lW)(s, bi(u, 3));
      }
      function vy(s, u, h, G) {
        s = Fg(s) ? s : od(s), h = h && !G ? Fi(h) : 0;
        var R = s.length;
        return h < 0 && (h = Wn(R + h, 0)), vb(s) ? h <= R && s.indexOf(u, h) > -1 : !!R && Z(s, u, h) > -1;
      }
      function Sb(s, u) {
        return (vi(s) ? c : la)(s, bi(u, 3));
      }
      function lX(s, u, h, G) {
        return s == null ? [] : (vi(u) || (u = u == null ? [] : [u]), h = G ? te : h, vi(h) || (h = h == null ? [] : [h]), js(s, u, h));
      }
      function aX(s, u, h) {
        var G = vi(s) ? C : H, R = arguments.length < 3;
        return G(s, bi(u, 4), h, R, Aa);
      }
      function sX(s, u, h) {
        var G = vi(s) ? A : H, R = arguments.length < 3;
        return G(s, bi(u, 4), h, R, lW);
      }
      function Ry(s, u) {
        return (vi(s) ? l : Tu)(s, nC(bi(u, 3)));
      }
      function Xy(s) {
        return (vi(s) ? UG : ry)(s);
      }
      function IX(s, u, h) {
        return u = (h ? Tr(s, u, h) : u === te) ? 1 : Fi(u), (vi(s) ? QA : HR)(s, u);
      }
      function a0(s) {
        return (vi(s) ? jA : kp)(s);
      }
      function Hy(s) {
        if (s == null)
          return 0;
        if (Fg(s))
          return vb(s) ? it(s) : s.length;
        var u = sg(s);
        return u == ti || u == Xi ? s.size : wp(s).length;
      }
      function tC(s, u, h) {
        var G = vi(s) ? b : eb;
        return h && Tr(s, u, h) && (u = te), G(s, bi(u, 3));
      }
      function s0(s, u) {
        if (typeof u != "function")
          throw new zo($t);
        return s = Fi(s), function() {
          if (--s < 1)
            return u.apply(this, arguments);
        };
      }
      function I0(s, u, h) {
        return u = h ? te : u, u = s && u == null ? s.length : u, os(s, di, te, te, te, te, u);
      }
      function c0(s, u) {
        var h;
        if (typeof u != "function")
          throw new zo($t);
        return s = Fi(s), function() {
          return --s > 0 && (h = u.apply(this, arguments)), s <= 1 && (u = te), h;
        };
      }
      function iC(s, u, h) {
        u = h ? te : u;
        var G = os(s, Me, te, te, te, te, te, u);
        return G.placeholder = iC.placeholder, G;
      }
      function d0(s, u, h) {
        u = h ? te : u;
        var G = os(s, Yt, te, te, te, te, te, u);
        return G.placeholder = d0.placeholder, G;
      }
      function Gl(s, u, h) {
        function G(Hi) {
          var qn = Fe, ho = ze;
          return Fe = ze = te, Pt = Hi, Vt = s.apply(ho, qn);
        }
        function R(Hi) {
          return Pt = Hi, rt = Id(T, u), mn ? G(Hi) : Vt;
        }
        function k(Hi) {
          var qn = Hi - Nt, ho = Hi - Pt, K0 = u - qn;
          return pn ? oi(K0, nt - ho) : K0;
        }
        function E(Hi) {
          var qn = Hi - Nt, ho = Hi - Pt;
          return Nt === te || qn >= u || qn < 0 || pn && ho >= nt;
        }
        function T() {
          var Hi = Qb();
          return E(Hi) ? j(Hi) : (rt = Id(T, k(Hi)), te);
        }
        function j(Hi) {
          return rt = te, Cr && Fe ? G(Hi) : (Fe = ze = te, Vt);
        }
        function ae() {
          rt !== te && Dg(rt), Pt = 0, Fe = Nt = ze = rt = te;
        }
        function ge() {
          return rt === te ? Vt : j(Qb());
        }
        function ce() {
          var Hi = Qb(), qn = E(Hi);
          if (Fe = arguments, ze = this, Nt = Hi, qn) {
            if (rt === te)
              return R(Nt);
            if (pn)
              return Dg(rt), rt = Id(T, u), G(Nt);
          }
          return rt === te && (rt = Id(T, u)), Vt;
        }
        var Fe, ze, nt, Vt, rt, Nt, Pt = 0, mn = !1, pn = !1, Cr = !0;
        if (typeof s != "function")
          throw new zo($t);
        return u = Uo(u) || 0, Mn(h) && (mn = !!h.leading, pn = "maxWait" in h, nt = pn ? Wn(Uo(h.maxWait) || 0, u) : nt, Cr = "trailing" in h ? !!h.trailing : Cr), ce.cancel = ae, ce.flush = ge, ce;
      }
      function nc(s) {
        return os(s, Ai);
      }
      function Vb(s, u) {
        if (typeof s != "function" || u != null && typeof u != "function")
          throw new zo($t);
        var h = function() {
          var G = arguments, R = u ? u.apply(this, G) : G[0], k = h.cache;
          if (k.has(R))
            return k.get(R);
          var E = s.apply(this, G);
          return h.cache = k.set(R, E) || k, E;
        };
        return h.cache = new (Vb.Cache || ns)(), h;
      }
      function nC(s) {
        if (typeof s != "function")
          throw new zo($t);
        return function() {
          var u = arguments;
          switch (u.length) {
            case 0:
              return !s.call(this);
            case 1:
              return !s.call(this, u[0]);
            case 2:
              return !s.call(this, u[0], u[1]);
            case 3:
              return !s.call(this, u[0], u[1], u[2]);
          }
          return !s.apply(this, u);
        };
      }
      function cX(s) {
        return c0(2, s);
      }
      function dX(s, u) {
        if (typeof s != "function")
          throw new zo($t);
        return u = u === te ? u : Fi(u), Ji(s, u);
      }
      function uX(s, u) {
        if (typeof s != "function")
          throw new zo($t);
        return u = u == null ? 0 : Wn(Fi(u), 0), Ji(function(h) {
          var G = h[u], R = qs(h, 0, u);
          return G && d(R, G), i(s, this, R);
        });
      }
      function CX(s, u, h) {
        var G = !0, R = !0;
        if (typeof s != "function")
          throw new zo($t);
        return Mn(h) && (G = "leading" in h ? !!h.leading : G, R = "trailing" in h ? !!h.trailing : R), Gl(s, u, { leading: G, maxWait: u, trailing: R });
      }
      function AX(s) {
        return I0(s, 1);
      }
      function bX(s, u) {
        return X0(Fp(u), s);
      }
      function hX() {
        if (!arguments.length)
          return [];
        var s = arguments[0];
        return vi(s) ? s : [s];
      }
      function mX(s) {
        return uo(s, qe);
      }
      function pX(s, u) {
        return u = typeof u == "function" ? u : te, uo(s, qe, u);
      }
      function BX(s) {
        return uo(s, Ge | qe);
      }
      function fX(s, u) {
        return u = typeof u == "function" ? u : te, uo(s, Ge | qe, u);
      }
      function ky(s, u) {
        return u == null || qA(s, u, Hr(u));
      }
      function Po(s, u) {
        return s === u || s !== s && u !== u;
      }
      function Fg(s) {
        return s != null && xg(s.length) && !Is(s);
      }
      function or(s) {
        return jn(s) && Fg(s);
      }
      function ZX(s) {
        return s === !0 || s === !1 || jn(s) && Xr(s) == fe;
      }
      function GX(s) {
        return jn(s) && s.nodeType === 1 && !rC(s);
      }
      function Yy(s) {
        if (s == null)
          return !0;
        if (Fg(s) && (vi(s) || typeof s == "string" || typeof s.splice == "function" || ba(s) || dd(s) || rc(s)))
          return !s.length;
        var u = sg(s);
        if (u == ti || u == Xi)
          return !s.size;
        if (td(s))
          return !wp(s).length;
        for (var h in s)
          if (dn.call(s, h))
            return !1;
        return !0;
      }
      function yX(s, u) {
        return Bl(s, u);
      }
      function WX(s, u, h) {
        h = typeof h == "function" ? h : te;
        var G = h ? h(s, u) : te;
        return G === te ? Bl(s, u, te, h) : !!G;
      }
      function u0(s) {
        if (!jn(s))
          return !1;
        var u = Xr(s);
        return u == _e || u == gt || typeof s.message == "string" && typeof s.name == "string" && !rC(s);
      }
      function SX(s) {
        return typeof s == "number" && nW(s);
      }
      function Is(s) {
        if (!Mn(s))
          return !1;
        var u = Xr(s);
        return u == Qt || u == kt || u == Li || u == es;
      }
      function Fy(s) {
        return typeof s == "number" && s == Fi(s);
      }
      function xg(s) {
        return typeof s == "number" && s > -1 && s % 1 == 0 && s <= Ke;
      }
      function Mn(s) {
        var u = typeof s;
        return s != null && (u == "object" || u == "function");
      }
      function jn(s) {
        return s != null && typeof s == "object";
      }
      function VX(s, u) {
        return s === u || Vp(s, u, ec(u));
      }
      function xy(s, u, h) {
        return h = typeof h == "function" ? h : te, Vp(s, u, ec(u), h);
      }
      function wX(s) {
        return wb(s) && s != +s;
      }
      function vX(s) {
        if (UH(s))
          throw new f0(ii);
        return qG(s);
      }
      function RX(s) {
        return s === null;
      }
      function XX(s) {
        return s == null;
      }
      function wb(s) {
        return typeof s == "number" || jn(s) && Xr(s) == tn;
      }
      function rC(s) {
        if (!jn(s) || Xr(s) != Nr)
          return !1;
        var u = Lb(s);
        if (u === null)
          return !0;
        var h = dn.call(u, "constructor") && u.constructor;
        return typeof h == "function" && h instanceof h && Jb.call(h) == _y;
      }
      function HX(s) {
        return Fy(s) && s >= -Ke && s <= Ke;
      }
      function vb(s) {
        return typeof s == "string" || !vi(s) && jn(s) && Xr(s) == bn;
      }
      function Ao(s) {
        return typeof s == "symbol" || jn(s) && Xr(s) == so;
      }
      function kX(s) {
        return s === te;
      }
      function YX(s) {
        return jn(s) && sg(s) == hn;
      }
      function FX(s) {
        return jn(s) && Xr(s) == hl;
      }
      function Dy(s) {
        if (!s)
          return [];
        if (Fg(s))
          return vb(s) ? Qe(s) : rg(s);
        if (us && s[us])
          return we(s[us]());
        var u = sg(s);
        return (u == ti ? ue : u == Xi ? xe : od)(s);
      }
      function cs(s) {
        return s ? (s = Uo(s), s === Ne || s === -Ne ? (s < 0 ? -1 : 1) * Jt : s === s ? s : 0) : s === 0 ? s : 0;
      }
      function Fi(s) {
        var u = cs(s), h = u % 1;
        return u === u ? h ? u - h : u : 0;
      }
      function Jy(s) {
        return s ? OI(Fi(s), 0, Zt) : 0;
      }
      function Uo(s) {
        if (typeof s == "number")
          return s;
        if (Ao(s))
          return Rt;
        if (Mn(s)) {
          var u = typeof s.valueOf == "function" ? s.valueOf() : s;
          s = Mn(u) ? u + "" : u;
        }
        if (typeof s != "string")
          return s === 0 ? s : +s;
        s = L(s);
        var h = Ip.test(s);
        return h || dp.test(s) ? sR(s.slice(2), h ? 2 : 8) : sp.test(s) ? Rt : +s;
      }
      function Ey(s) {
        return Ia(s, _g(s));
      }
      function xX(s) {
        return s ? OI(Fi(s), -Ke, Ke) : s === 0 ? s : 0;
      }
      function gn(s) {
        return s == null ? "" : Xg(s);
      }
      function DX(s, u) {
        var h = sd(s);
        return u == null ? h : zG(h, u);
      }
      function JX(s, u) {
        return B(s, bi(u, 3), oa);
      }
      function EX(s, u) {
        return B(s, bi(u, 3), Sp);
      }
      function NX(s, u) {
        return s == null ? s : cC(s, bi(u, 3), _g);
      }
      function LX(s, u) {
        return s == null ? s : aW(s, bi(u, 3), _g);
      }
      function C0(s, u) {
        return s && oa(s, bi(u, 3));
      }
      function Ny(s, u) {
        return s && Sp(s, bi(u, 3));
      }
      function KX(s) {
        return s == null ? [] : _A(s, Hr(s));
      }
      function TX(s) {
        return s == null ? [] : _A(s, _g(s));
      }
      function A0(s, u, h) {
        var G = s == null ? te : jI(s, u);
        return G === te ? h : G;
      }
      function MX(s, u) {
        return s != null && Iy(s, u, QG);
      }
      function b0(s, u) {
        return s != null && Iy(s, u, Q);
      }
      function Hr(s) {
        return Fg(s) ? PG(s) : wp(s);
      }
      function _g(s) {
        return Fg(s) ? PG(s, !0) : wR(s);
      }
      function PX(s, u) {
        var h = {};
        return u = bi(u, 3), oa(s, function(G, R, k) {
          Ln(h, u(G, R, k), G);
        }), h;
      }
      function Ly(s, u) {
        var h = {};
        return u = bi(u, 3), oa(s, function(G, R, k) {
          Ln(h, R, u(G, R, k));
        }), h;
      }
      function UX(s, u) {
        return gC(s, nC(bi(u)));
      }
      function gC(s, u) {
        if (s == null)
          return {};
        var h = c(Up(s), function(G) {
          return [G];
        });
        return u = bi(u), iy(s, h, function(G, R) {
          return u(G, R[0]);
        });
      }
      function zX(s, u, h) {
        u = Zl(u, s);
        var G = -1, R = u.length;
        for (R || (R = 1, s = te); ++G < R; ) {
          var k = s == null ? te : s[ua(u[G])];
          k === te && (G = R, k = h), s = Is(k) ? k.call(s) : k;
        }
        return s;
      }
      function OX(s, u, h) {
        return s == null ? s : Mu(s, u, h);
      }
      function QX(s, u, h, G) {
        return G = typeof G == "function" ? G : te, s == null ? s : Mu(s, u, h, G);
      }
      function jX(s, u, h) {
        var G = vi(s), R = G || ba(s) || dd(s);
        if (u = bi(u, 4), h == null) {
          var k = s && s.constructor;
          h = R ? G ? new k() : [] : Mn(s) && Is(k) ? sd(Lb(s)) : {};
        }
        return (R ? r : oa)(s, function(E, T, j) {
          return u(h, E, T, j);
        }), h;
      }
      function qX(s, u) {
        return s == null || qg(s, u);
      }
      function _X(s, u, h) {
        return s == null ? s : oy(s, u, Fp(h));
      }
      function $X(s, u, h, G) {
        return G = typeof G == "function" ? G : te, s == null ? s : oy(s, u, Fp(h), G);
      }
      function od(s) {
        return s == null ? [] : U(s, Hr(s));
      }
      function eH(s) {
        return s == null ? [] : U(s, _g(s));
      }
      function tH(s, u, h) {
        return h === te && (h = u, u = te), h !== te && (h = Uo(h), h = h === h ? h : 0), u !== te && (u = Uo(u), u = u === u ? u : 0), OI(Uo(s), u, h);
      }
      function iH(s, u, h) {
        return u = cs(u), h === te ? (h = u, u = 0) : h = cs(h), s = Uo(s), Oc(s, u, h);
      }
      function nH(s, u, h) {
        if (h && typeof h != "boolean" && Tr(s, u, h) && (u = h = te), h === te && (typeof u == "boolean" ? (h = u, u = te) : typeof s == "boolean" && (h = s, s = te)), s === te && u === te ? (s = 0, u = 1) : (s = cs(s), u === te ? (u = s, s = 0) : u = cs(u)), s > u) {
          var G = s;
          s = u, u = G;
        }
        if (h || s % 1 || u % 1) {
          var R = W0();
          return oi(s + R * (u - s + aR("1e-" + ((R + "").length - 1))), u);
        }
        return Xp(s, u);
      }
      function Ky(s) {
        return L0(gn(s).toLowerCase());
      }
      function Ty(s) {
        return s = gn(s), s && s.replace(D, cR).replace(HG, "");
      }
      function rH(s, u, h) {
        s = gn(s), u = Xg(u);
        var G = s.length;
        h = h === te ? G : OI(Fi(h), 0, G);
        var R = h;
        return h -= u.length, h >= 0 && s.slice(h, R) == u;
      }
      function gH(s) {
        return s = gn(s), s && vu.test(s) ? s.replace(Nc, dR) : s;
      }
      function My(s) {
        return s = gn(s), s && ts.test(s) ? s.replace(TI, "\\$&") : s;
      }
      function Py(s, u, h) {
        s = gn(s), u = Fi(u);
        var G = u ? it(s) : 0;
        if (!u || G >= u)
          return s;
        var R = (u - G) / 2;
        return $c(Pb(R), h) + s + $c(As(R), h);
      }
      function oH(s, u, h) {
        s = gn(s), u = Fi(u);
        var G = u ? it(s) : 0;
        return u && G < u ? s + $c(u - G, h) : s;
      }
      function lH(s, u, h) {
        s = gn(s), u = Fi(u);
        var G = u ? it(s) : 0;
        return u && G < u ? $c(u - G, h) + s : s;
      }
      function aH(s, u, h) {
        return h || u == null ? u = 0 : u && (u = +u), Qo(gn(s).replace(Hu, ""), u || 0);
      }
      function sH(s, u, h) {
        return u = (h ? Tr(s, u, h) : u === te) ? 1 : Fi(u), Hp(gn(s), u);
      }
      function Rb() {
        var s = arguments, u = gn(s[0]);
        return s.length < 3 ? u : u.replace(s[1], s[2]);
      }
      function IH(s, u, h) {
        return h && typeof h != "number" && Tr(s, u, h) && (u = h = te), (h = h === te ? Zt : h >>> 0) ? (s = gn(s), s && (typeof u == "string" || u != null && !k0(u)) && (u = Xg(u), !u && Je(s)) ? qs(Qe(s), 0, h) : s.split(u, h)) : [];
      }
      function cH(s, u, h) {
        return s = gn(s), h = h == null ? 0 : OI(Fi(h), 0, s.length), u = Xg(u), s.slice(h, h + u.length) == u;
      }
      function dH(s, u, h) {
        var G = Y.templateSettings;
        h && Tr(s, u, h) && (u = te), s = gn(s), u = Mr({}, u, G, Kp);
        var R, k, E = Mr({}, u.imports, G.imports, Kp), T = Hr(E), j = U(E, T), ae = 0, ge = u.interpolate || z, ce = "__p += '", Fe = ag((u.escape || z).source + "|" + ge.source + "|" + (ge === Lc ? Fu : z).source + "|" + (u.evaluate || z).source + "|$", "g"), ze = "//# sourceURL=" + (dn.call(u, "sourceURL") ? (u.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++co + "]") + `
`;
        s.replace(Fe, function(rt, Nt, Pt, mn, pn, Cr) {
          return Pt || (Pt = mn), ce += s.slice(ae, Cr).replace(_, Ve), Nt && (R = !0, ce += `' +
__e(` + Nt + `) +
'`), pn && (k = !0, ce += `';
` + pn + `;
__p += '`), Pt && (ce += `' +
((__t = (` + Pt + `)) == null ? '' : __t) +
'`), ae = Cr + rt.length, rt;
        }), ce += `';
`;
        var nt = dn.call(u, "variable") && u.variable;
        if (nt) {
          if (Yu.test(nt))
            throw new f0(ni);
        } else
          ce = `with (obj) {
` + ce + `
}
`;
        ce = (k ? ce.replace(Wu, "") : ce).replace(Su, "$1").replace(Vu, "$1;"), ce = "function(" + (nt || "obj") + `) {
` + (nt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (R ? ", __e = _.escape" : "") + (k ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ce + `return __p
}`;
        var Vt = GW(function() {
          return iI(T, ze + "return " + ce).apply(te, j);
        });
        if (Vt.source = ce, u0(Vt))
          throw Vt;
        return Vt;
      }
      function uH(s) {
        return gn(s).toLowerCase();
      }
      function CH(s) {
        return gn(s).toUpperCase();
      }
      function AH(s, u, h) {
        if (s = gn(s), s && (h || u === te))
          return L(s);
        if (!s || !(u = Xg(u)))
          return s;
        var G = Qe(s), R = Qe(u);
        return qs(G, $(G, R), ne(G, R) + 1).join("");
      }
      function bH(s, u, h) {
        if (s = gn(s), s && (h || u === te))
          return s.slice(0, $e(s) + 1);
        if (!s || !(u = Xg(u)))
          return s;
        var G = Qe(s);
        return qs(G, 0, ne(G, Qe(u)) + 1).join("");
      }
      function hH(s, u, h) {
        if (s = gn(s), s && (h || u === te))
          return s.replace(Hu, "");
        if (!s || !(u = Xg(u)))
          return s;
        var G = Qe(s);
        return qs(G, $(G, Qe(u))).join("");
      }
      function mH(s, u) {
        var h = ui, G = Ui;
        if (Mn(u)) {
          var R = "separator" in u ? u.separator : R;
          h = "length" in u ? Fi(u.length) : h, G = "omission" in u ? Xg(u.omission) : G;
        }
        s = gn(s);
        var k = s.length;
        if (Je(s)) {
          var E = Qe(s);
          k = E.length;
        }
        if (h >= k)
          return s;
        var T = h - it(G);
        if (T < 1)
          return G;
        var j = E ? qs(E, 0, T).join("") : s.slice(0, T);
        if (R === te)
          return j + G;
        if (E && (T += j.length - T), k0(R)) {
          if (s.slice(T).search(R)) {
            var ae, ge = j;
            for (R.global || (R = ag(R.source, gn(na.exec(R)) + "g")), R.lastIndex = 0; ae = R.exec(ge); )
              var ce = ae.index;
            j = j.slice(0, ce === te ? T : ce);
          }
        } else if (s.indexOf(Xg(R), T) != T) {
          var Fe = j.lastIndexOf(R);
          Fe > -1 && (j = j.slice(0, Fe));
        }
        return j + G;
      }
      function pH(s) {
        return s = gn(s), s && wu.test(s) ? s.replace(Ec, uR) : s;
      }
      function Uy(s, u, h) {
        return s = gn(s), u = h ? te : u, u === te ? ke(s) ? Bt(s) : p(s) : s.match(u) || [];
      }
      function Xb(s) {
        var u = s == null ? 0 : s.length, h = bi();
        return s = u ? c(s, function(G) {
          if (typeof G[1] != "function")
            throw new zo($t);
          return [h(G[0]), G[1]];
        }) : [], Ji(function(G) {
          for (var R = -1; ++R < u; ) {
            var k = s[R];
            if (i(k[0], this, G))
              return i(k[1], this, G);
          }
        });
      }
      function BH(s) {
        return fR(uo(s, Ge));
      }
      function Hb(s) {
        return function() {
          return s;
        };
      }
      function zy(s, u) {
        return s == null || s !== s ? u : s;
      }
      function lg(s) {
        return s;
      }
      function kb(s) {
        return _G(typeof s == "function" ? s : uo(s, Ge));
      }
      function Oy(s) {
        return $G(uo(s, Ge));
      }
      function Qy(s, u) {
        return ey(s, uo(u, Ge));
      }
      function Yb(s, u, h) {
        var G = Hr(u), R = _A(u, G);
        h != null || Mn(u) && (R.length || !G.length) || (h = u, u = s, s = this, R = _A(u, Hr(u)));
        var k = !(Mn(h) && "chain" in h && !h.chain), E = Is(s);
        return r(R, function(T) {
          var j = u[T];
          s[T] = j, E && (s.prototype[T] = function() {
            var ae = this.__chain__;
            if (k || ae) {
              var ge = s(this.__wrapped__);
              return (ge.__actions__ = rg(this.__actions__)).push({ func: j, args: arguments, thisArg: s }), ge.__chain__ = ae, ge;
            }
            return j.apply(s, d([this.value()], arguments));
          });
        }), s;
      }
      function fH() {
        return Kr._ === this && (Kr._ = Eb), this;
      }
      function h0() {
      }
      function ZH(s) {
        return s = Fi(s), Ji(function(u) {
          return ty(u, s);
        });
      }
      function oC(s) {
        return Cb(s) ? w(ua(s)) : fl(s);
      }
      function Fb(s) {
        return function(u) {
          return s == null ? te : jI(s, u);
        };
      }
      function m0() {
        return [];
      }
      function p0() {
        return !1;
      }
      function B0() {
        return {};
      }
      function jy() {
        return "";
      }
      function GH() {
        return !0;
      }
      function yH(s, u) {
        if (s = Fi(s), s < 1 || s > Ke)
          return [];
        var h = Zt, G = oi(s, Zt);
        u = bi(u), s -= Zt;
        for (var R = K(G, u); ++h < s; )
          u(h);
        return R;
      }
      function WH(s) {
        return vi(s) ? c(s, ua) : Ao(s) ? [s] : rg(cW(gn(s)));
      }
      function SH(s) {
        var u = ++Z0;
        return gn(s) + u;
      }
      function VH(s) {
        return s && s.length ? Qs(s, lg, qI) : te;
      }
      function wH(s, u) {
        return s && s.length ? Qs(s, bi(u, 2), qI) : te;
      }
      function vH(s) {
        return V(s, lg);
      }
      function RH(s, u) {
        return V(s, bi(u, 2));
      }
      function XH(s) {
        return s && s.length ? Qs(s, lg, vp) : te;
      }
      function HH(s, u) {
        return s && s.length ? Qs(s, bi(u, 2), vp) : te;
      }
      function kH(s) {
        return s && s.length ? J(s, lg) : 0;
      }
      function YH(s, u) {
        return s && s.length ? J(s, bi(u, 2)) : 0;
      }
      re = re == null ? Kr : pl.defaults(Kr.Object(), re, pl.pick(Kr, kG));
      var cn = re.Array, xb = re.Date, f0 = re.Error, iI = re.Function, fi = re.Math, Fn = re.Object, ag = re.RegExp, lr = re.String, zo = re.TypeError, yl = cn.prototype, FH = iI.prototype, ld = Fn.prototype, Db = re["__core-js_shared__"], Jb = FH.toString, dn = ld.hasOwnProperty, Z0 = 0, qy = function() {
        var s = /[^.]+$/.exec(Db && Db.keys && Db.keys.IE_PROTO || "");
        return s ? "Symbol(src)_1." + s : "";
      }(), Oo = ld.toString, _y = Jb.call(Fn), Eb = Kr._, Pn = ag("^" + Jb.call(dn).replace(TI, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), xn = Zp ? re.Buffer : te, ds = re.Symbol, Nb = re.Uint8Array, $y = xn ? xn.allocUnsafe : te, Lb = Xe(Fn.getPrototypeOf, Fn), eW = Fn.create, tW = ld.propertyIsEnumerable, Kb = yl.splice, G0 = ds ? ds.isConcatSpreadable : te, us = ds ? ds.iterator : te, Cs = ds ? ds.toStringTag : te, Tb = function() {
        try {
          var s = _s(Fn, "defineProperty");
          return s({}, "", {}), s;
        } catch {
        }
      }(), iW = re.clearTimeout !== Kr.clearTimeout && re.clearTimeout, Mb = xb && xb.now !== Kr.Date.now && xb.now, bo = re.setTimeout !== Kr.setTimeout && re.setTimeout, As = fi.ceil, Pb = fi.floor, y0 = Fn.getOwnPropertySymbols, xH = xn ? xn.isBuffer : te, nW = re.isFinite, DH = yl.join, rW = Xe(Fn.keys, Fn), Wn = fi.max, oi = fi.min, gW = xb.now, Qo = re.parseInt, W0 = fi.random, JH = yl.reverse, _i = _s(re, "DataView"), lC = _s(re, "Map"), Ub = _s(re, "Promise"), bs = _s(re, "Set"), aC = _s(re, "WeakMap"), sC = _s(Fn, "create"), zb = aC && new aC(), ad = {}, EH = tI(_i), NH = tI(lC), LH = tI(Ub), KH = tI(bs), TH = tI(aC), Ob = ds ? ds.prototype : te, IC = Ob ? Ob.valueOf : te, oW = Ob ? Ob.toString : te, sd = /* @__PURE__ */ function() {
        function s() {
        }
        return function(u) {
          if (!Mn(u))
            return {};
          if (eW)
            return eW(u);
          s.prototype = u;
          var h = new s();
          return s.prototype = te, h;
        };
      }();
      Y.templateSettings = { escape: Us, evaluate: Ru, interpolate: Lc, variable: "", imports: { _: Y } }, Y.prototype = Ee.prototype, Y.prototype.constructor = Y, ct.prototype = sd(Ee.prototype), ct.prototype.constructor = ct, ut.prototype = sd(Ee.prototype), ut.prototype.constructor = ut, UI.prototype.clear = Lo, UI.prototype.delete = TA, UI.prototype.get = AR, UI.prototype.has = Pc, UI.prototype.set = MA, Ko.prototype.clear = In, Ko.prototype.delete = bR, Ko.prototype.get = NG, Ko.prototype.has = PA, Ko.prototype.set = hR, ns.prototype.clear = mR, ns.prototype.delete = UA, ns.prototype.get = Os, ns.prototype.has = zA, ns.prototype.set = LG, ga.prototype.add = ga.prototype.push = KG, ga.prototype.has = TG, Qg.prototype.clear = MG, Qg.prototype.delete = Ju, Qg.prototype.get = zI, Qg.prototype.has = OA, Qg.prototype.set = pR;
      var Aa = _c(oa), lW = _c(Sp, !0), cC = Ep(), aW = Ep(!0), sW = zb ? function(s, u) {
        return zb.set(s, u), s;
      } : lg, MH = Tb ? function(s, u) {
        return Tb(s, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Hb(u),
          writable: !0
        });
      } : lg, kr = Ji, Dg = iW || function(s) {
        return Kr.clearTimeout(s);
      }, PH = bs && 1 / xe(new bs([, -0]))[1] == Ne ? function(s) {
        return new bs(s);
      } : h0, S0 = zb ? function(s) {
        return zb.get(s);
      } : h0, V0 = y0 ? function(s) {
        return s == null ? [] : (s = Fn(s), l(y0(s), function(u) {
          return tW.call(s, u);
        }));
      } : m0, w0 = y0 ? function(s) {
        for (var u = []; s; )
          d(u, V0(s)), s = Lb(s);
        return u;
      } : m0, sg = Xr;
      (_i && sg(new _i(new ArrayBuffer(1))) != ml || lC && sg(new lC()) != ti || Ub && sg(Ub.resolve()) != vg || bs && sg(new bs()) != Xi || aC && sg(new aC()) != hn) && (sg = function(s) {
        var u = Xr(s), h = u == Nr ? s.constructor : te, G = h ? tI(h) : "";
        if (G)
          switch (G) {
            case EH:
              return ml;
            case NH:
              return ti;
            case LH:
              return vg;
            case KH:
              return Xi;
            case TH:
              return hn;
          }
        return u;
      });
      var UH = Db ? Is : p0, IW = jp(sW), Id = bo || function(s, u) {
        return Kr.setTimeout(s, u);
      }, v0 = jp(MH), cW = $s(function(s) {
        var u = [];
        return s.charCodeAt(0) === 46 && u.push(""), s.replace(Xu, function(h, G, R, k) {
          u.push(R ? k.replace(ap, "$1") : G || h);
        }), u;
      }), zH = Ji(function(s, u) {
        return or(s) ? QI(s, Qn(u, 1, or, !0)) : [];
      }), dW = Ji(function(s, u) {
        var h = kg(u);
        return or(h) && (h = te), or(s) ? QI(s, Qn(u, 1, or, !0), bi(h, 2)) : [];
      }), uW = Ji(function(s, u) {
        var h = kg(u);
        return or(h) && (h = te), or(s) ? QI(s, Qn(u, 1, or, !0), te, h) : [];
      }), OH = Ji(function(s) {
        var u = c(s, nb);
        return u.length && u[0] === s[0] ? Qc(u) : [];
      }), QH = Ji(function(s) {
        var u = kg(s), h = c(s, nb);
        return u === kg(h) ? u = te : h.pop(), h.length && h[0] === s[0] ? Qc(h, bi(u, 2)) : [];
      }), jH = Ji(function(s) {
        var u = kg(s), h = c(s, nb);
        return u = typeof u == "function" ? u : te, u && h.pop(), h.length && h[0] === s[0] ? Qc(h, te, u) : [];
      }), qH = Ji($u), cd = da(function(s, u) {
        var h = s == null ? 0 : s.length, G = Wp(s, u);
        return ny(s, c(u, function(R) {
          return gg(R, h) ? +R : R;
        }).sort(Uu)), G;
      }), _H = Ji(function(s) {
        return jg(Qn(s, 1, or, !0));
      }), $H = Ji(function(s) {
        var u = kg(s);
        return or(u) && (u = te), jg(Qn(s, 1, or, !0), bi(u, 2));
      }), ek = Ji(function(s) {
        var u = kg(s);
        return u = typeof u == "function" ? u : te, jg(Qn(s, 1, or, !0), te, u);
      }), tk = Ji(function(s, u) {
        return or(s) ? QI(s, u) : [];
      }), ik = Ji(function(s) {
        return _I(l(s, or));
      }), CW = Ji(function(s) {
        var u = kg(s);
        return or(u) && (u = te), _I(l(s, or), bi(u, 2));
      }), AW = Ji(function(s) {
        var u = kg(s);
        return u = typeof u == "function" ? u : te, _I(l(s, or), te, u);
      }), nk = Ji(r0), rk = Ji(function(s) {
        var u = s.length, h = u > 1 ? s[u - 1] : te;
        return h = typeof h == "function" ? (s.pop(), h) : te, Wb(s, h);
      }), gk = da(function(s) {
        var u = s.length, h = u ? s[0] : 0, G = this.__wrapped__, R = function(k) {
          return Wp(k, s);
        };
        return !(u > 1 || this.__actions__.length) && G instanceof ut && gg(h) ? (G = G.slice(h, +h + (u ? 1 : 0)), G.__actions__.push({ func: eC, args: [R], thisArg: te }), new ct(G, this.__chain__).thru(function(k) {
          return u && !k.length && k.push(te), k;
        })) : this.thru(R);
      }), ok = jc(function(s, u, h) {
        dn.call(s, h) ? ++s[h] : Ln(s, h, 1);
      }), lk = gb(qp), ak = gb(tc), sk = jc(function(s, u, h) {
        dn.call(s, h) ? s[h].push(u) : Ln(s, h, [u]);
      }), Ik = Ji(function(s, u, h) {
        var G = -1, R = typeof u == "function", k = Fg(s) ? cn(s.length) : [];
        return Aa(s, function(E) {
          k[++G] = R ? i(u, E, h) : Di(E, u, h);
        }), k;
      }), ck = jc(function(s, u, h) {
        Ln(s, h, u);
      }), dk = jc(function(s, u, h) {
        s[h ? 0 : 1].push(u);
      }, function() {
        return [[], []];
      }), uk = Ji(function(s, u) {
        if (s == null)
          return [];
        var h = u.length;
        return h > 1 && Tr(s, u[0], u[1]) ? u = [] : h > 2 && Tr(u[0], u[1], u[2]) && (u = [u[0]]), js(s, Qn(u, 1), []);
      }), Qb = Mb || function() {
        return Kr.Date.now();
      }, R0 = Ji(function(s, u, h) {
        var G = Te;
        if (h.length) {
          var R = Ze(h, Si(R0));
          G |= zt;
        }
        return os(s, G, u, h, R);
      }), bW = Ji(function(s, u, h) {
        var G = Te | Tt;
        if (h.length) {
          var R = Ze(h, Si(bW));
          G |= zt;
        }
        return os(u, G, s, h, R);
      }), Ck = Ji(function(s, u) {
        return Uc(s, 1, u);
      }), Ak = Ji(function(s, u, h) {
        return Uc(s, Uo(u) || 0, h);
      });
      Vb.Cache = ns;
      var bk = kr(function(s, u) {
        u = u.length == 1 && vi(u[0]) ? c(u[0], N(bi())) : c(Qn(u, 1), N(bi()));
        var h = u.length;
        return Ji(function(G) {
          for (var R = -1, k = oi(G.length, h); ++R < k; )
            G[R] = u[R].call(this, G[R]);
          return i(s, this, G);
        });
      }), X0 = Ji(function(s, u) {
        return os(s, zt, te, u, Ze(u, Si(X0)));
      }), hW = Ji(function(s, u) {
        return os(s, ri, te, u, Ze(u, Si(hW)));
      }), hk = da(function(s, u) {
        return os(s, mt, te, te, te, u);
      }), mk = Ou(qI), pk = Ou(function(s, u) {
        return s >= u;
      }), rc = jG(/* @__PURE__ */ function() {
        return arguments;
      }()) ? jG : function(s) {
        return jn(s) && dn.call(s, "callee") && !tW.call(s, "callee");
      }, vi = cn.isArray, Bk = DG ? N(DG) : ZR, ba = xH || p0, mW = JG ? N(JG) : GR, H0 = EG ? N(EG) : WR, k0 = PI ? N(PI) : SR, pW = No ? N(No) : rs, dd = Gp ? N(Gp) : VR, Y0 = Ou(vp), fk = Ou(function(s, u) {
        return s <= u;
      }), Zk = qc(function(s, u) {
        if (td(u) || Fg(u))
          return Ia(u, Hr(u), s), te;
        for (var h in u)
          dn.call(u, h) && Nu(s, h, u[h]);
      }), BW = qc(function(s, u) {
        Ia(u, _g(u), s);
      }), Mr = qc(function(s, u, h, G) {
        Ia(u, _g(u), s, G);
      }), F0 = qc(function(s, u, h, G) {
        Ia(u, Hr(u), s, G);
      }), Gk = da(Wp), yk = Ji(function(s, u) {
        s = Fn(s);
        var h = -1, G = u.length, R = G > 2 ? u[2] : te;
        for (R && Tr(u[0], u[1], R) && (G = 1); ++h < G; )
          for (var k = u[h], E = _g(k), T = -1, j = E.length; ++T < j; ) {
            var ae = E[T], ge = s[ae];
            (ge === te || Po(ge, ld[ae]) && !dn.call(s, ae)) && (s[ae] = k[ae]);
          }
        return s;
      }), Wk = Ji(function(s) {
        return s.push(te, Tp), i(fW, te, s);
      }), Sk = sy(function(s, u, h) {
        u != null && typeof u.toString != "function" && (u = Oo.call(u)), s[u] = h;
      }, Hb(lg)), x0 = sy(function(s, u, h) {
        u != null && typeof u.toString != "function" && (u = Oo.call(u)), dn.call(s, u) ? s[u].push(h) : s[u] = [h];
      }, bi), Vk = Ji(Di), D0 = qc(function(s, u, h) {
        $A(s, u, h);
      }), fW = qc(function(s, u, h, G) {
        $A(s, u, h, G);
      }), wk = da(function(s, u) {
        var h = {};
        if (s == null)
          return h;
        var G = !1;
        u = c(u, function(k) {
          return k = Zl(k, s), G || (G = k.length > 1), k;
        }), Ia(s, Up(s), h), G && (h = uo(h, Ge | Be | qe, JR));
        for (var R = u.length; R--; )
          qg(h, u[R]);
        return h;
      }), vk = da(function(s, u) {
        return s == null ? {} : RR(s, u);
      }), ZW = Qu(Hr), J0 = Qu(_g), Rk = ca(function(s, u, h) {
        return u = u.toLowerCase(), s + (h ? Ky(u) : u);
      }), Xk = ca(function(s, u, h) {
        return s + (h ? "-" : "") + u.toLowerCase();
      }), Hk = ca(function(s, u, h) {
        return s + (h ? " " : "") + u.toLowerCase();
      }), E0 = ay("toLowerCase"), N0 = ca(function(s, u, h) {
        return s + (h ? "_" : "") + u.toLowerCase();
      }), kk = ca(function(s, u, h) {
        return s + (h ? " " : "") + L0(u);
      }), Yk = ca(function(s, u, h) {
        return s + (h ? " " : "") + u.toUpperCase();
      }), L0 = ay("toUpperCase"), GW = Ji(function(s, u) {
        try {
          return i(s, te, u);
        } catch (h) {
          return u0(h) ? h : new f0(h);
        }
      }), Fk = da(function(s, u) {
        return r(u, function(h) {
          h = ua(h), Ln(s, h, R0(s[h], s));
        }), s;
      }), xk = Np(), Dk = Np(!0), Jk = Ji(function(s, u) {
        return function(h) {
          return Di(h, s, u);
        };
      }), Ek = Ji(function(s, u) {
        return function(h) {
          return Di(s, h, u);
        };
      }), Nk = ab(c), Lk = ab(o), Kk = ab(b), Tk = sb(), Mk = sb(!0), Pk = lb(function(s, u) {
        return s + u;
      }, 0), Uk = Ib("ceil"), zk = lb(function(s, u) {
        return s / u;
      }, 1), Ok = Ib("floor"), Qk = lb(function(s, u) {
        return s * u;
      }, 1), jk = Ib("round"), qk = lb(function(s, u) {
        return s - u;
      }, 0);
      return Y.after = s0, Y.ary = I0, Y.assign = Zk, Y.assignIn = BW, Y.assignInWith = Mr, Y.assignWith = F0, Y.at = Gk, Y.before = c0, Y.bind = R0, Y.bindAll = Fk, Y.bindKey = bW, Y.castArray = hX, Y.chain = Vy, Y.chunk = Ca, Y.compact = MR, Y.concat = PR, Y.cond = Xb, Y.conforms = BH, Y.constant = Hb, Y.countBy = ok, Y.create = DX, Y.curry = iC, Y.curryRight = d0, Y.debounce = Gl, Y.defaults = yk, Y.defaultsDeep = Wk, Y.defer = Ck, Y.delay = Ak, Y.difference = zH, Y.differenceBy = dW, Y.differenceWith = uW, Y.drop = Bb, Y.dropRight = id, Y.dropRightWhile = by, Y.dropWhile = hy, Y.fill = UR, Y.filter = rX, Y.flatMap = o0, Y.flatMapDeep = gX, Y.flatMapDepth = oX, Y.flatten = nd, Y.flattenDeep = zR, Y.flattenDepth = my, Y.flip = nc, Y.flow = xk, Y.flowRight = Dk, Y.fromPairs = py, Y.functions = KX, Y.functionsIn = TX, Y.groupBy = sk, Y.initial = fb, Y.intersection = OH, Y.intersectionBy = QH, Y.intersectionWith = jH, Y.invert = Sk, Y.invertBy = x0, Y.invokeMap = Ik, Y.iteratee = kb, Y.keyBy = ck, Y.keys = Hr, Y.keysIn = _g, Y.map = Sb, Y.mapKeys = PX, Y.mapValues = Ly, Y.matches = Oy, Y.matchesProperty = Qy, Y.memoize = Vb, Y.merge = D0, Y.mergeWith = fW, Y.method = Jk, Y.methodOf = Ek, Y.mixin = Yb, Y.negate = nC, Y.nthArg = ZH, Y.omit = wk, Y.omitBy = UX, Y.once = cX, Y.orderBy = lX, Y.over = Nk, Y.overArgs = bk, Y.overEvery = Lk, Y.overSome = Kk, Y.partial = X0, Y.partialRight = hW, Y.partition = dk, Y.pick = vk, Y.pickBy = gC, Y.property = oC, Y.propertyOf = Fb, Y.pull = qH, Y.pullAll = $u, Y.pullAllBy = Zy, Y.pullAllWith = $p, Y.pullAt = cd, Y.range = Tk, Y.rangeRight = Mk, Y.rearg = hk, Y.reject = Ry, Y.remove = QR, Y.rest = dX, Y.reverse = Zb, Y.sampleSize = IX, Y.set = OX, Y.setWith = QX, Y.shuffle = a0, Y.slice = ls, Y.sortBy = uk, Y.sortedUniq = as, Y.sortedUniqBy = e0, Y.split = IH, Y.spread = uX, Y.tail = t0, Y.take = i0, Y.takeRight = Gb, Y.takeRightWhile = rd, Y.takeWhile = hi, Y.tap = $R, Y.throttle = CX, Y.thru = eC, Y.toArray = Dy, Y.toPairs = ZW, Y.toPairsIn = J0, Y.toPath = WH, Y.toPlainObject = Ey, Y.transform = jX, Y.unary = AX, Y.union = _H, Y.unionBy = $H, Y.unionWith = ek, Y.uniq = yb, Y.uniqBy = n0, Y.uniqWith = ic, Y.unset = qX, Y.unzip = r0, Y.unzipWith = Wb, Y.update = _X, Y.updateWith = $X, Y.values = od, Y.valuesIn = eH, Y.without = tk, Y.words = Uy, Y.wrap = bX, Y.xor = ik, Y.xorBy = CW, Y.xorWith = AW, Y.zip = nk, Y.zipObject = Sy, Y.zipObjectDeep = og, Y.zipWith = rk, Y.entries = ZW, Y.entriesIn = J0, Y.extend = BW, Y.extendWith = Mr, Yb(Y, Y), Y.add = Pk, Y.attempt = GW, Y.camelCase = Rk, Y.capitalize = Ky, Y.ceil = Uk, Y.clamp = tH, Y.clone = mX, Y.cloneDeep = BX, Y.cloneDeepWith = fX, Y.cloneWith = pX, Y.conformsTo = ky, Y.deburr = Ty, Y.defaultTo = zy, Y.divide = zk, Y.endsWith = rH, Y.eq = Po, Y.escape = gH, Y.escapeRegExp = My, Y.every = g0, Y.find = lk, Y.findIndex = qp, Y.findKey = JX, Y.findLast = ak, Y.findLastIndex = tc, Y.findLastKey = EX, Y.floor = Ok, Y.forEach = gd, Y.forEachRight = l0, Y.forIn = NX, Y.forInRight = LX, Y.forOwn = C0, Y.forOwnRight = Ny, Y.get = A0, Y.gt = mk, Y.gte = pk, Y.has = MX, Y.hasIn = b0, Y.head = _u, Y.identity = lg, Y.includes = vy, Y.indexOf = By, Y.inRange = iH, Y.invoke = Vk, Y.isArguments = rc, Y.isArray = vi, Y.isArrayBuffer = Bk, Y.isArrayLike = Fg, Y.isArrayLikeObject = or, Y.isBoolean = ZX, Y.isBuffer = ba, Y.isDate = mW, Y.isElement = GX, Y.isEmpty = Yy, Y.isEqual = yX, Y.isEqualWith = WX, Y.isError = u0, Y.isFinite = SX, Y.isFunction = Is, Y.isInteger = Fy, Y.isLength = xg, Y.isMap = H0, Y.isMatch = VX, Y.isMatchWith = xy, Y.isNaN = wX, Y.isNative = vX, Y.isNil = XX, Y.isNull = RX, Y.isNumber = wb, Y.isObject = Mn, Y.isObjectLike = jn, Y.isPlainObject = rC, Y.isRegExp = k0, Y.isSafeInteger = HX, Y.isSet = pW, Y.isString = vb, Y.isSymbol = Ao, Y.isTypedArray = dd, Y.isUndefined = kX, Y.isWeakMap = YX, Y.isWeakSet = FX, Y.join = _p, Y.kebabCase = Xk, Y.last = kg, Y.lastIndexOf = OR, Y.lowerCase = Hk, Y.lowerFirst = E0, Y.lt = Y0, Y.lte = fk, Y.max = VH, Y.maxBy = wH, Y.mean = vH, Y.meanBy = RH, Y.min = XH, Y.minBy = HH, Y.stubArray = m0, Y.stubFalse = p0, Y.stubObject = B0, Y.stubString = jy, Y.stubTrue = GH, Y.multiply = Qk, Y.nth = fy, Y.noConflict = fH, Y.noop = h0, Y.now = Qb, Y.pad = Py, Y.padEnd = oH, Y.padStart = lH, Y.parseInt = aH, Y.random = nH, Y.reduce = aX, Y.reduceRight = sX, Y.repeat = sH, Y.replace = Rb, Y.result = zX, Y.round = jk, Y.runInContext = P, Y.sample = Xy, Y.size = Hy, Y.snakeCase = N0, Y.some = tC, Y.sortedIndex = Gy, Y.sortedIndexBy = yy, Y.sortedIndexOf = jR, Y.sortedLastIndex = Wy, Y.sortedLastIndexBy = qR, Y.sortedLastIndexOf = _R, Y.startCase = kk, Y.startsWith = cH, Y.subtract = qk, Y.sum = kH, Y.sumBy = YH, Y.template = dH, Y.times = yH, Y.toFinite = cs, Y.toInteger = Fi, Y.toLength = Jy, Y.toLower = uH, Y.toNumber = Uo, Y.toSafeInteger = xX, Y.toString = gn, Y.toUpper = CH, Y.trim = AH, Y.trimEnd = bH, Y.trimStart = hH, Y.truncate = mH, Y.unescape = pH, Y.uniqueId = SH, Y.upperCase = Yk, Y.upperFirst = L0, Y.each = gd, Y.eachRight = l0, Y.first = _u, Yb(Y, function() {
        var s = {};
        return oa(Y, function(u, h) {
          dn.call(Y.prototype, h) || (s[h] = u);
        }), s;
      }(), { chain: !1 }), Y.VERSION = Xt, r(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(s) {
        Y[s].placeholder = Y;
      }), r(["drop", "take"], function(s, u) {
        ut.prototype[s] = function(h) {
          h = h === te ? 1 : Wn(Fi(h), 0);
          var G = this.__filtered__ && !u ? new ut(this) : this.clone();
          return G.__filtered__ ? G.__takeCount__ = oi(h, G.__takeCount__) : G.__views__.push({ size: oi(h, Zt), type: s + (G.__dir__ < 0 ? "Right" : "") }), G;
        }, ut.prototype[s + "Right"] = function(h) {
          return this.reverse()[s](h).reverse();
        };
      }), r(["filter", "map", "takeWhile"], function(s, u) {
        var h = u + 1, G = h == le || h == pe;
        ut.prototype[s] = function(R) {
          var k = this.clone();
          return k.__iteratees__.push({ iteratee: bi(R, 3), type: h }), k.__filtered__ = k.__filtered__ || G, k;
        };
      }), r(["head", "last"], function(s, u) {
        var h = "take" + (u ? "Right" : "");
        ut.prototype[s] = function() {
          return this[h](1).value()[0];
        };
      }), r(["initial", "tail"], function(s, u) {
        var h = "drop" + (u ? "" : "Right");
        ut.prototype[s] = function() {
          return this.__filtered__ ? new ut(this) : this[h](1);
        };
      }), ut.prototype.compact = function() {
        return this.filter(lg);
      }, ut.prototype.find = function(s) {
        return this.filter(s).head();
      }, ut.prototype.findLast = function(s) {
        return this.reverse().find(s);
      }, ut.prototype.invokeMap = Ji(function(s, u) {
        return typeof s == "function" ? new ut(this) : this.map(function(h) {
          return Di(h, s, u);
        });
      }), ut.prototype.reject = function(s) {
        return this.filter(nC(bi(s)));
      }, ut.prototype.slice = function(s, u) {
        s = Fi(s);
        var h = this;
        return h.__filtered__ && (s > 0 || u < 0) ? new ut(h) : (s < 0 ? h = h.takeRight(-s) : s && (h = h.drop(s)), u !== te && (u = Fi(u), h = u < 0 ? h.dropRight(-u) : h.take(u - s)), h);
      }, ut.prototype.takeRightWhile = function(s) {
        return this.reverse().takeWhile(s).reverse();
      }, ut.prototype.toArray = function() {
        return this.take(Zt);
      }, oa(ut.prototype, function(s, u) {
        var h = /^(?:filter|find|map|reject)|While$/.test(u), G = /^(?:head|last)$/.test(u), R = Y[G ? "take" + (u == "last" ? "Right" : "") : u], k = G || /^find/.test(u);
        R && (Y.prototype[u] = function() {
          var E = this.__wrapped__, T = G ? [1] : arguments, j = E instanceof ut, ae = T[0], ge = j || vi(E), ce = function(Nt) {
            var Pt = R.apply(Y, d([Nt], T));
            return G && Fe ? Pt[0] : Pt;
          };
          ge && h && typeof ae == "function" && ae.length != 1 && (j = ge = !1);
          var Fe = this.__chain__, ze = !!this.__actions__.length, nt = k && !Fe, Vt = j && !ze;
          if (!k && ge) {
            E = Vt ? E : new ut(this);
            var rt = s.apply(E, T);
            return rt.__actions__.push({ func: eC, args: [ce], thisArg: te }), new ct(rt, Fe);
          }
          return nt && Vt ? s.apply(this, T) : (rt = this.thru(ce), nt ? G ? rt.value()[0] : rt.value() : rt);
        });
      }), r(["pop", "push", "shift", "sort", "splice", "unshift"], function(s) {
        var u = yl[s], h = /^(?:push|sort|unshift)$/.test(s) ? "tap" : "thru", G = /^(?:pop|shift)$/.test(s);
        Y.prototype[s] = function() {
          var R = arguments;
          if (G && !this.__chain__) {
            var k = this.value();
            return u.apply(vi(k) ? k : [], R);
          }
          return this[h](function(E) {
            return u.apply(vi(E) ? E : [], R);
          });
        };
      }), oa(ut.prototype, function(s, u) {
        var h = Y[u];
        if (h) {
          var G = h.name + "";
          dn.call(ad, G) || (ad[G] = []), ad[G].push({ name: u, func: h });
        }
      }), ad[ob(te, Tt).name] = [{ name: "wrapper", func: te }], ut.prototype.clone = qi, ut.prototype.reverse = sn, ut.prototype.value = yp, Y.prototype.at = gk, Y.prototype.chain = eX, Y.prototype.commit = wy, Y.prototype.next = tX, Y.prototype.plant = nX, Y.prototype.reverse = ss, Y.prototype.toJSON = Y.prototype.valueOf = Y.prototype.value = Yg, Y.prototype.first = Y.prototype.head, us && (Y.prototype[us] = iX), Y;
    }, pl = CR();
    is ? ((is.exports = pl)._ = pl, fp._ = pl) : Kr._ = pl;
  }).call(Or);
})(nw, nw.exports);
var QZe = nw.exports, Qj = {};
(function(e) {
  e.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, e.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, e.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, e.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, e.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, e.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, e.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, e.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, e.realToAlias = function() {
    var t = Object.prototype.hasOwnProperty, i = e.aliasToReal, n = {};
    for (var r in i) {
      var g = i[r];
      t.call(n, g) ? n[g].push(r) : n[g] = [r];
    }
    return n;
  }(), e.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, e.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, e.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(Qj);
var jZe = {}, Pr = Qj, qZe = jZe, R3 = Array.prototype.push;
function _Ze(e, t) {
  return t == 2 ? function(i, n) {
    return e.apply(void 0, arguments);
  } : function(i) {
    return e.apply(void 0, arguments);
  };
}
function uY(e, t) {
  return t == 2 ? function(i, n) {
    return e(i, n);
  } : function(i) {
    return e(i);
  };
}
function X3(e) {
  for (var t = e ? e.length : 0, i = Array(t); t--; )
    i[t] = e[t];
  return i;
}
function $Ze(e) {
  return function(t) {
    return e({}, t);
  };
}
function eGe(e, t) {
  return function() {
    for (var i = arguments.length, n = i - 1, r = Array(i); i--; )
      r[i] = arguments[i];
    var g = r[t], o = r.slice(0, t);
    return g && R3.apply(o, g), t != n && R3.apply(o, r.slice(t + 1)), e.apply(this, o);
  };
}
function CY(e, t) {
  return function() {
    var i = arguments.length;
    if (i) {
      for (var n = Array(i); i--; )
        n[i] = arguments[i];
      var r = n[0] = t.apply(void 0, n);
      return e.apply(void 0, n), r;
    }
  };
}
function wx(e, t, i, n) {
  var r = typeof t == "function", g = t === Object(t);
  if (g && (n = i, i = t, t = void 0), i == null)
    throw new TypeError();
  n || (n = {});
  var o = {
    cap: "cap" in n ? n.cap : !0,
    curry: "curry" in n ? n.curry : !0,
    fixed: "fixed" in n ? n.fixed : !0,
    immutable: "immutable" in n ? n.immutable : !0,
    rearg: "rearg" in n ? n.rearg : !0
  }, l = r ? i : qZe, a = "curry" in n && n.curry, I = "fixed" in n && n.fixed, c = "rearg" in n && n.rearg, d = r ? i.runInContext() : void 0, C = r ? i : {
    ary: e.ary,
    assign: e.assign,
    clone: e.clone,
    curry: e.curry,
    forEach: e.forEach,
    isArray: e.isArray,
    isError: e.isError,
    isFunction: e.isFunction,
    isWeakMap: e.isWeakMap,
    iteratee: e.iteratee,
    keys: e.keys,
    rearg: e.rearg,
    toInteger: e.toInteger,
    toPath: e.toPath
  }, A = C.ary, b = C.assign, m = C.clone, p = C.curry, B = C.forEach, f = C.isArray, Z = C.isError, y = C.isFunction, W = C.isWeakMap, V = C.keys, w = C.rearg, v = C.toInteger, H = C.toPath, x = V(Pr.aryMethod), J = {
    castArray: function(we) {
      return function() {
        var ue = arguments[0];
        return f(ue) ? we(X3(ue)) : we.apply(void 0, arguments);
      };
    },
    iteratee: function(we) {
      return function() {
        var ue = arguments[0], Xe = arguments[1], Ze = we(ue, Xe), xe = Ze.length;
        return o.cap && typeof Xe == "number" ? (Xe = Xe > 2 ? Xe - 2 : 1, xe && xe <= Xe ? Ze : uY(Ze, Xe)) : Ze;
      };
    },
    mixin: function(we) {
      return function(ue) {
        var Xe = this;
        if (!y(Xe))
          return we(Xe, Object(ue));
        var Ze = [];
        return B(V(ue), function(xe) {
          y(ue[xe]) && Ze.push([xe, Xe.prototype[xe]]);
        }), we(Xe, Object(ue)), B(Ze, function(xe) {
          var Pe = xe[1];
          y(Pe) ? Xe.prototype[xe[0]] = Pe : delete Xe.prototype[xe[0]];
        }), Xe;
      };
    },
    nthArg: function(we) {
      return function(ue) {
        var Xe = ue < 0 ? 1 : v(ue) + 1;
        return p(we(ue), Xe);
      };
    },
    rearg: function(we) {
      return function(ue, Xe) {
        var Ze = Xe ? Xe.length : 0;
        return p(we(ue, Xe), Ze);
      };
    },
    runInContext: function(we) {
      return function(ue) {
        return wx(e, we(ue), n);
      };
    }
  };
  function K(we, ue) {
    if (o.cap) {
      var Xe = Pr.iterateeRearg[we];
      if (Xe)
        return be(ue, Xe);
      var Ze = !r && Pr.iterateeAry[we];
      if (Ze)
        return ne(ue, Ze);
    }
    return ue;
  }
  function M(we, ue, Xe) {
    return a || o.curry && Xe > 1 ? p(ue, Xe) : ue;
  }
  function L(we, ue, Xe) {
    if (o.fixed && (I || !Pr.skipFixed[we])) {
      var Ze = Pr.methodSpread[we], xe = Ze && Ze.start;
      return xe === void 0 ? A(ue, Xe) : eGe(ue, xe);
    }
    return ue;
  }
  function N(we, ue, Xe) {
    return o.rearg && Xe > 1 && (c || !Pr.skipRearg[we]) ? w(ue, Pr.methodRearg[we] || Pr.aryRearg[Xe]) : ue;
  }
  function U(we, ue) {
    ue = H(ue);
    for (var Xe = -1, Ze = ue.length, xe = Ze - 1, Pe = m(Object(we)), st = Pe; st != null && ++Xe < Ze; ) {
      var bt = ue[Xe], it = st[bt];
      it != null && !(y(it) || Z(it) || W(it)) && (st[bt] = m(Xe == xe ? it : Object(it))), st = st[bt];
    }
    return Pe;
  }
  function O(we) {
    return Je.runInContext.convert(we)(void 0);
  }
  function $(we, ue) {
    var Xe = Pr.aliasToReal[we] || we, Ze = Pr.remap[Xe] || Xe, xe = n;
    return function(Pe) {
      var st = r ? d : C, bt = r ? d[Ze] : ue, it = b(b({}, xe), Pe);
      return wx(st, Xe, bt, it);
    };
  }
  function ne(we, ue) {
    return Ve(we, function(Xe) {
      return typeof Xe == "function" ? uY(Xe, ue) : Xe;
    });
  }
  function be(we, ue) {
    return Ve(we, function(Xe) {
      var Ze = ue.length;
      return _Ze(w(uY(Xe, Ze), ue), Ze);
    });
  }
  function Ve(we, ue) {
    return function() {
      var Xe = arguments.length;
      if (!Xe)
        return we();
      for (var Ze = Array(Xe); Xe--; )
        Ze[Xe] = arguments[Xe];
      var xe = o.rearg ? 0 : Xe - 1;
      return Ze[xe] = ue(Ze[xe]), we.apply(void 0, Ze);
    };
  }
  function He(we, ue, Xe) {
    var Ze, xe = Pr.aliasToReal[we] || we, Pe = ue, st = J[xe];
    return st ? Pe = st(ue) : o.immutable && (Pr.mutate.array[xe] ? Pe = CY(ue, X3) : Pr.mutate.object[xe] ? Pe = CY(ue, $Ze(ue)) : Pr.mutate.set[xe] && (Pe = CY(ue, U))), B(x, function(bt) {
      return B(Pr.aryMethod[bt], function(it) {
        if (xe == it) {
          var Qe = Pr.methodSpread[xe], $e = Qe && Qe.afterRearg;
          return Ze = $e ? L(xe, N(xe, Pe, bt), bt) : N(xe, L(xe, Pe, bt), bt), Ze = K(xe, Ze), Ze = M(xe, Ze, bt), !1;
        }
      }), !Ze;
    }), Ze || (Ze = Pe), Ze == ue && (Ze = a ? p(Ze, 1) : function() {
      return ue.apply(this, arguments);
    }), Ze.convert = $(xe, ue), Ze.placeholder = ue.placeholder = Xe, Ze;
  }
  if (!g)
    return He(t, i, l);
  var Je = i, ke = [];
  return B(x, function(we) {
    B(Pr.aryMethod[we], function(ue) {
      var Xe = Je[Pr.remap[ue] || ue];
      Xe && ke.push([ue, He(ue, Xe, Je)]);
    });
  }), B(V(Je), function(we) {
    var ue = Je[we];
    if (typeof ue == "function") {
      for (var Xe = ke.length; Xe--; )
        if (ke[Xe][0] == we)
          return;
      ue.convert = $(we, ue), ke.push([we, ue]);
    }
  }), B(ke, function(we) {
    Je[we[0]] = we[1];
  }), Je.convert = O, Je.placeholder = Je, B(V(Je), function(we) {
    B(Pr.realToAlias[we] || [], function(ue) {
      Je[ue] = Je[we];
    });
  }), Je;
}
var tGe = wx, H3 = QZe.runInContext(), Le = tGe(H3, H3);
const Yr = {
  ArticleAction: "articleAction",
  ColorAction: "colorAction",
  Image2DAction: "image2DAction",
  ImageAction: "imageAction",
  LabelAction: "labelAction",
  PopupAction: "popupAction",
  MaterialAction: "materialAction",
  InstanceAction: "instanceAction",
  ModelAction: "modelAction",
  Variable: "variable",
  ConcealVariableAction: "concealVariableAction",
  ConcealGroupAction: "concealGroupAction",
  HideVariableAction: "hideVariableAction",
  HideGroupAction: "hideGroupAction",
  HideValuesAction: "hideValuesAction",
  FocusedGroup: "focusedGroup",
  ExitButtonsAction: "exitButtonsAction"
}, Y7t = (e) => (e == null ? void 0 : e.targetModelId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, F7t = (e) => (e == null ? void 0 : e.isGlobalChange) === !0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, x7t = (e) => Le.includes(e.type, [Yr.FocusedGroup]), iGe = (e) => Le.includes(e.type, [Yr.ArticleAction, Yr.InstanceAction, Yr.ColorAction, Yr.Image2DAction, Yr.ImageAction, Yr.LabelAction, Yr.PopupAction, Yr.MaterialAction, Yr.ModelAction, Yr.ConcealVariableAction, Yr.ConcealGroupAction, Yr.HideVariableAction, Yr.HideGroupAction, Yr.HideValuesAction, Yr.ExitButtonsAction]), Gc = (e) => e.type === Yr.Variable, D7t = (e) => e.type === Yr.MaterialAction, jj = (e) => e.type === Yr.ImageAction, nGe = (e) => e.type === Yr.FocusedGroup, rGe = (e, t, i, n, r = !0) => {
  const g = av.groupBy(t, (l) => l.ruleId), o = e.map((l) => gGe(l, g[l.id] || [], i, n, r));
  return {
    nested: o,
    flat: {
      rules: o.map((l) => l.rule),
      ruleItems: o.flatMap((l) => l.items)
    }
  };
};
function gGe(e, t, i, n, r = !0) {
  const [g, o] = de.partition(e.columns, (I) => !Gc(I) || n.find((c) => c.id == I.targetId)), l = g.filter((I) => Gc(I) || I.type === "popupAction" || I.type === "instanceAction"), a = t.map((I) => {
    const c = {};
    return l.forEach((d) => {
      const C = d.targetId;
      c[C] = I.values[C] || !0;
    }), r || Object.keys(I.values).forEach((d) => {
      yJ(d) && (c[d] = I.values[d]);
    }), {
      ...I,
      values: c
    };
  });
  return {
    rule: {
      ...e,
      columns: r ? l : g
    },
    items: a
  };
}
const sv = (e, t = []) => t.filter((i) => !iw(e, i.variableId, i.instance.id, "hiddenVariablesMap")), oGe = (e) => {
  var t;
  return !((t = e.settings.priceOptions) != null && t.hidePrice);
}, qj = (e) => e == null ? void 0 : e.settings, WJ = {};
function J7t(e) {
  de.forEach(e, (t, i) => WJ[i] = t);
}
function _j(e) {
  return !!WJ[e];
}
const E7t = (e) => (
  // @ts-ignore
  e.forEach((t) => e[t] = void 0)
), VI = (e, t) => {
  const i = WJ[e];
  return i ? i(t) : t;
};
Le.curry(VI);
const Iv = (e) => {
  var r, g, o;
  const t = (o = (g = (r = e == null ? void 0 : e.env) == null ? void 0 : r.template) == null ? void 0 : g.children) == null ? void 0 : o.find((l) => l.component === "Bounds"), i = t == null ? void 0 : t.props;
  return (i == null ? void 0 : i.margin) ?? 0;
};
function Eg(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var lGe = typeof Symbol == "function" && Symbol.observable || "@@observable", k3 = lGe, AY = () => Math.random().toString(36).substring(7).split("").join("."), aGe = {
  INIT: `@@redux/INIT${/* @__PURE__ */ AY()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ AY()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${AY()}`
}, rw = aGe;
function SJ(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function $j(e, t, i) {
  if (typeof e != "function")
    throw new Error(Eg(2));
  if (typeof t == "function" && typeof i == "function" || typeof i == "function" && typeof arguments[3] == "function")
    throw new Error(Eg(0));
  if (typeof t == "function" && typeof i > "u" && (i = t, t = void 0), typeof i < "u") {
    if (typeof i != "function")
      throw new Error(Eg(1));
    return i($j)(e, t);
  }
  let n = e, r = t, g = /* @__PURE__ */ new Map(), o = g, l = 0, a = !1;
  function I() {
    o === g && (o = /* @__PURE__ */ new Map(), g.forEach((p, B) => {
      o.set(B, p);
    }));
  }
  function c() {
    if (a)
      throw new Error(Eg(3));
    return r;
  }
  function d(p) {
    if (typeof p != "function")
      throw new Error(Eg(4));
    if (a)
      throw new Error(Eg(5));
    let B = !0;
    I();
    const f = l++;
    return o.set(f, p), function() {
      if (B) {
        if (a)
          throw new Error(Eg(6));
        B = !1, I(), o.delete(f), g = null;
      }
    };
  }
  function C(p) {
    if (!SJ(p))
      throw new Error(Eg(7));
    if (typeof p.type > "u")
      throw new Error(Eg(8));
    if (typeof p.type != "string")
      throw new Error(Eg(17));
    if (a)
      throw new Error(Eg(9));
    try {
      a = !0, r = n(r, p);
    } finally {
      a = !1;
    }
    return (g = o).forEach((f) => {
      f();
    }), p;
  }
  function A(p) {
    if (typeof p != "function")
      throw new Error(Eg(10));
    n = p, C({
      type: rw.REPLACE
    });
  }
  function b() {
    const p = d;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(B) {
        if (typeof B != "object" || B === null)
          throw new Error(Eg(11));
        function f() {
          const y = B;
          y.next && y.next(c());
        }
        return f(), {
          unsubscribe: p(f)
        };
      },
      [k3]() {
        return this;
      }
    };
  }
  return C({
    type: rw.INIT
  }), {
    dispatch: C,
    subscribe: d,
    getState: c,
    replaceReducer: A,
    [k3]: b
  };
}
function sGe(e) {
  Object.keys(e).forEach((t) => {
    const i = e[t];
    if (typeof i(void 0, {
      type: rw.INIT
    }) > "u")
      throw new Error(Eg(12));
    if (typeof i(void 0, {
      type: rw.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(Eg(13));
  });
}
function e6(e) {
  const t = Object.keys(e), i = {};
  for (let g = 0; g < t.length; g++) {
    const o = t[g];
    typeof e[o] == "function" && (i[o] = e[o]);
  }
  const n = Object.keys(i);
  let r;
  try {
    sGe(i);
  } catch (g) {
    r = g;
  }
  return function(o = {}, l) {
    if (r)
      throw r;
    let a = !1;
    const I = {};
    for (let c = 0; c < n.length; c++) {
      const d = n[c], C = i[d], A = o[d], b = C(A, l);
      if (typeof b > "u")
        throw l && l.type, new Error(Eg(14));
      I[d] = b, a = a || b !== A;
    }
    return a = a || n.length !== Object.keys(o).length, a ? I : o;
  };
}
function gw(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, i) => (...n) => t(i(...n)));
}
function IGe(...e) {
  return (t) => (i, n) => {
    const r = t(i, n);
    let g = () => {
      throw new Error(Eg(15));
    };
    const o = {
      getState: r.getState,
      dispatch: (a, ...I) => g(a, ...I)
    }, l = e.map((a) => a(o));
    return g = gw(...l)(r.dispatch), {
      ...r,
      dispatch: g
    };
  };
}
function cGe(e) {
  return SJ(e) && "type" in e && typeof e.type == "string";
}
var t6 = Symbol.for("immer-nothing"), Y3 = Symbol.for("immer-draftable"), zl = Symbol.for("immer-state");
function Vs(e, ...t) {
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var om = Object.getPrototypeOf;
function eu(e) {
  return !!e && !!e[zl];
}
function yc(e) {
  var t;
  return e ? i6(e) || Array.isArray(e) || !!e[Y3] || !!((t = e.constructor) != null && t[Y3]) || dv(e) || uv(e) : !1;
}
var dGe = Object.prototype.constructor.toString();
function i6(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = om(e);
  if (t === null)
    return !0;
  const i = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return i === Object ? !0 : typeof i == "function" && Function.toString.call(i) === dGe;
}
function ow(e, t) {
  cv(e) === 0 ? Reflect.ownKeys(e).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((i, n) => t(n, i, e));
}
function cv(e) {
  const t = e[zl];
  return t ? t.type_ : Array.isArray(e) ? 1 : dv(e) ? 2 : uv(e) ? 3 : 0;
}
function vx(e, t) {
  return cv(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function n6(e, t, i) {
  const n = cv(e);
  n === 2 ? e.set(t, i) : n === 3 ? e.add(i) : e[t] = i;
}
function uGe(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function dv(e) {
  return e instanceof Map;
}
function uv(e) {
  return e instanceof Set;
}
function fC(e) {
  return e.copy_ || e.base_;
}
function Rx(e, t) {
  if (dv(e))
    return new Map(e);
  if (uv(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const i = i6(e);
  if (t === !0 || t === "class_only" && !i) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[zl];
    let r = Reflect.ownKeys(n);
    for (let g = 0; g < r.length; g++) {
      const o = r[g], l = n[o];
      l.writable === !1 && (l.writable = !0, l.configurable = !0), (l.get || l.set) && (n[o] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: l.enumerable,
        value: e[o]
      });
    }
    return Object.create(om(e), n);
  } else {
    const n = om(e);
    if (n !== null && i)
      return { ...e };
    const r = Object.create(n);
    return Object.assign(r, e);
  }
}
function VJ(e, t = !1) {
  return Cv(e) || eu(e) || !yc(e) || (cv(e) > 1 && (e.set = e.add = e.clear = e.delete = CGe), Object.freeze(e), t && Object.entries(e).forEach(([i, n]) => VJ(n, !0))), e;
}
function CGe() {
  Vs(2);
}
function Cv(e) {
  return Object.isFrozen(e);
}
var AGe = {};
function rA(e) {
  const t = AGe[e];
  return t || Vs(0, e), t;
}
var kf;
function r6() {
  return kf;
}
function bGe(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function F3(e, t) {
  t && (rA("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Xx(e) {
  Hx(e), e.drafts_.forEach(hGe), e.drafts_ = null;
}
function Hx(e) {
  e === kf && (kf = e.parent_);
}
function x3(e) {
  return kf = bGe(kf, e);
}
function hGe(e) {
  const t = e[zl];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function D3(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const i = t.drafts_[0];
  return e !== void 0 && e !== i ? (i[zl].modified_ && (Xx(t), Vs(4)), yc(e) && (e = lw(t, e), t.parent_ || aw(t, e)), t.patches_ && rA("Patches").generateReplacementPatches_(
    i[zl].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = lw(t, i, []), Xx(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== t6 ? e : void 0;
}
function lw(e, t, i) {
  if (Cv(t))
    return t;
  const n = t[zl];
  if (!n)
    return ow(
      t,
      (r, g) => J3(e, n, t, r, g, i)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return aw(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const r = n.copy_;
    let g = r, o = !1;
    n.type_ === 3 && (g = new Set(r), r.clear(), o = !0), ow(
      g,
      (l, a) => J3(e, n, r, l, a, i, o)
    ), aw(e, r, !1), i && e.patches_ && rA("Patches").generatePatches_(
      n,
      i,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function J3(e, t, i, n, r, g, o) {
  if (eu(r)) {
    const l = g && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !vx(t.assigned_, n) ? g.concat(n) : void 0, a = lw(e, r, l);
    if (n6(i, n, a), eu(a))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    o && i.add(r);
  if (yc(r) && !Cv(r)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    lw(e, r), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(i, n) && aw(e, r);
  }
}
function aw(e, t, i = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && VJ(t, i);
}
function mGe(e, t) {
  const i = Array.isArray(e), n = {
    type_: i ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : r6(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let r = n, g = wJ;
  i && (r = [n], g = Yf);
  const { revoke: o, proxy: l } = Proxy.revocable(r, g);
  return n.draft_ = l, n.revoke_ = o, l;
}
var wJ = {
  get(e, t) {
    if (t === zl)
      return e;
    const i = fC(e);
    if (!vx(i, t))
      return pGe(e, i, t);
    const n = i[t];
    return e.finalized_ || !yc(n) ? n : n === bY(e.base_, t) ? (hY(e), e.copy_[t] = Yx(n, e)) : n;
  },
  has(e, t) {
    return t in fC(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(fC(e));
  },
  set(e, t, i) {
    const n = g6(fC(e), t);
    if (n != null && n.set)
      return n.set.call(e.draft_, i), !0;
    if (!e.modified_) {
      const r = bY(fC(e), t), g = r == null ? void 0 : r[zl];
      if (g && g.base_ === i)
        return e.copy_[t] = i, e.assigned_[t] = !1, !0;
      if (uGe(i, r) && (i !== void 0 || vx(e.base_, t)))
        return !0;
      hY(e), kx(e);
    }
    return e.copy_[t] === i && // special case: handle new props with value 'undefined'
    (i !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(i) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = i, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return bY(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, hY(e), kx(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const i = fC(e), n = Reflect.getOwnPropertyDescriptor(i, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: i[t]
    };
  },
  defineProperty() {
    Vs(11);
  },
  getPrototypeOf(e) {
    return om(e.base_);
  },
  setPrototypeOf() {
    Vs(12);
  }
}, Yf = {};
ow(wJ, (e, t) => {
  Yf[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Yf.deleteProperty = function(e, t) {
  return Yf.set.call(this, e, t, void 0);
};
Yf.set = function(e, t, i) {
  return wJ.set.call(this, e[0], t, i, e[0]);
};
function bY(e, t) {
  const i = e[zl];
  return (i ? fC(i) : e)[t];
}
function pGe(e, t, i) {
  var r;
  const n = g6(t, i);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (r = n.get) == null ? void 0 : r.call(e.draft_)
  ) : void 0;
}
function g6(e, t) {
  if (!(t in e))
    return;
  let i = om(e);
  for (; i; ) {
    const n = Object.getOwnPropertyDescriptor(i, t);
    if (n)
      return n;
    i = om(i);
  }
}
function kx(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && kx(e.parent_));
}
function hY(e) {
  e.copy_ || (e.copy_ = Rx(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var BGe = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, i, n) => {
      if (typeof t == "function" && typeof i != "function") {
        const g = i;
        i = t;
        const o = this;
        return function(a = g, ...I) {
          return o.produce(a, (c) => i.call(this, c, ...I));
        };
      }
      typeof i != "function" && Vs(6), n !== void 0 && typeof n != "function" && Vs(7);
      let r;
      if (yc(t)) {
        const g = x3(this), o = Yx(t, void 0);
        let l = !0;
        try {
          r = i(o), l = !1;
        } finally {
          l ? Xx(g) : Hx(g);
        }
        return F3(g, n), D3(r, g);
      } else if (!t || typeof t != "object") {
        if (r = i(t), r === void 0 && (r = t), r === t6 && (r = void 0), this.autoFreeze_ && VJ(r, !0), n) {
          const g = [], o = [];
          rA("Patches").generateReplacementPatches_(t, r, g, o), n(g, o);
        }
        return r;
      } else
        Vs(1, t);
    }, this.produceWithPatches = (t, i) => {
      if (typeof t == "function")
        return (o, ...l) => this.produceWithPatches(o, (a) => t(a, ...l));
      let n, r;
      return [this.produce(t, i, (o, l) => {
        n = o, r = l;
      }), n, r];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    yc(e) || Vs(8), eu(e) && (e = o6(e));
    const t = x3(this), i = Yx(e, void 0);
    return i[zl].isManual_ = !0, Hx(t), i;
  }
  finishDraft(e, t) {
    const i = e && e[zl];
    (!i || !i.isManual_) && Vs(9);
    const { scope_: n } = i;
    return F3(n, t), D3(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let i;
    for (i = t.length - 1; i >= 0; i--) {
      const r = t[i];
      if (r.path.length === 0 && r.op === "replace") {
        e = r.value;
        break;
      }
    }
    i > -1 && (t = t.slice(i + 1));
    const n = rA("Patches").applyPatches_;
    return eu(e) ? n(e, t) : this.produce(
      e,
      (r) => n(r, t)
    );
  }
};
function Yx(e, t) {
  const i = dv(e) ? rA("MapSet").proxyMap_(e, t) : uv(e) ? rA("MapSet").proxySet_(e, t) : mGe(e, t);
  return (t ? t.scope_ : r6()).drafts_.push(i), i;
}
function o6(e) {
  return eu(e) || Vs(10, e), l6(e);
}
function l6(e) {
  if (!yc(e) || Cv(e))
    return e;
  const t = e[zl];
  let i;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, i = Rx(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    i = Rx(e, !0);
  return ow(i, (n, r) => {
    n6(i, n, l6(r));
  }), t && (t.finalized_ = !1), i;
}
var Ol = new BGe(), Av = Ol.produce;
Ol.produceWithPatches.bind(
  Ol
);
var sw = Ol.setAutoFreeze.bind(Ol);
Ol.setUseStrictShallowCopy.bind(Ol);
Ol.applyPatches.bind(Ol);
Ol.createDraft.bind(Ol);
Ol.finishDraft.bind(Ol);
function fGe(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function ZGe(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function GGe(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((i) => typeof i == "function")) {
    const i = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${i}]`);
  }
}
var E3 = (e) => Array.isArray(e) ? e : [e];
function yGe(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return GGe(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function WGe(e, t) {
  const i = [], { length: n } = e;
  for (let r = 0; r < n; r++)
    i.push(e[r].apply(null, t));
  return i;
}
var SGe = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, VGe = typeof WeakRef < "u" ? WeakRef : SGe, wGe = 0, N3 = 1;
function MW() {
  return {
    s: wGe,
    v: void 0,
    o: null,
    p: null
  };
}
function vJ(e, t = {}) {
  let i = MW();
  const { resultEqualityCheck: n } = t;
  let r, g = 0;
  function o() {
    var d;
    let l = i;
    const { length: a } = arguments;
    for (let C = 0, A = a; C < A; C++) {
      const b = arguments[C];
      if (typeof b == "function" || typeof b == "object" && b !== null) {
        let m = l.o;
        m === null && (l.o = m = /* @__PURE__ */ new WeakMap());
        const p = m.get(b);
        p === void 0 ? (l = MW(), m.set(b, l)) : l = p;
      } else {
        let m = l.p;
        m === null && (l.p = m = /* @__PURE__ */ new Map());
        const p = m.get(b);
        p === void 0 ? (l = MW(), m.set(b, l)) : l = p;
      }
    }
    const I = l;
    let c;
    if (l.s === N3 ? c = l.v : (c = e.apply(null, arguments), g++), I.s = N3, n) {
      const C = ((d = r == null ? void 0 : r.deref) == null ? void 0 : d.call(r)) ?? r;
      C != null && n(C, c) && (c = C, g !== 0 && g--), r = typeof c == "object" && c !== null || typeof c == "function" ? new VGe(c) : c;
    }
    return I.v = c, c;
  }
  return o.clearCache = () => {
    i = MW(), o.resetResultsCount();
  }, o.resultsCount = () => g, o.resetResultsCount = () => {
    g = 0;
  }, o;
}
function a6(e, ...t) {
  const i = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...r) => {
    let g = 0, o = 0, l, a = {}, I = r.pop();
    typeof I == "object" && (a = I, I = r.pop()), fGe(
      I,
      `createSelector expects an output function after the inputs, but received: [${typeof I}]`
    );
    const c = {
      ...i,
      ...a
    }, {
      memoize: d,
      memoizeOptions: C = [],
      argsMemoize: A = vJ,
      argsMemoizeOptions: b = [],
      devModeChecks: m = {}
    } = c, p = E3(C), B = E3(b), f = yGe(r), Z = d(function() {
      return g++, I.apply(
        null,
        arguments
      );
    }, ...p), y = A(function() {
      o++;
      const V = WGe(
        f,
        arguments
      );
      return l = Z.apply(null, V), l;
    }, ...B);
    return Object.assign(y, {
      resultFunc: I,
      memoizedResultFunc: Z,
      dependencies: f,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => l,
      recomputations: () => g,
      resetRecomputations: () => {
        g = 0;
      },
      memoize: d,
      argsMemoize: A
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Ci = /* @__PURE__ */ a6(vJ), vGe = Object.assign(
  (e, t = Ci) => {
    ZGe(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const i = Object.keys(e), n = i.map(
      (g) => e[g]
    );
    return t(
      n,
      (...g) => g.reduce((o, l, a) => (o[i[a]] = l, o), {})
    );
  },
  { withTypes: () => vGe }
);
function s6(e) {
  return ({ dispatch: i, getState: n }) => (r) => (g) => typeof g == "function" ? g(i, n, e) : r(g);
}
var RGe = s6(), XGe = s6, HGe = (...e) => {
  const t = a6(...e), i = Object.assign((...n) => {
    const r = t(...n), g = (o, ...l) => r(eu(o) ? o6(o) : o, ...l);
    return Object.assign(g, r), g;
  }, {
    withTypes: () => i
  });
  return i;
};
HGe(vJ);
var kGe = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? gw : gw.apply(null, arguments);
};
function lm(e, t) {
  function i(...n) {
    if (t) {
      let r = t(...n);
      if (!r)
        throw new Error(ll(0));
      return {
        type: e,
        payload: r.payload,
        ..."meta" in r && {
          meta: r.meta
        },
        ..."error" in r && {
          error: r.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return i.toString = () => `${e}`, i.type = e, i.match = (n) => cGe(n) && n.type === e, i;
}
var I6 = class SB extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, SB.prototype);
  }
  static get [Symbol.species]() {
    return SB;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new SB(...t[0].concat(this)) : new SB(...t.concat(this));
  }
};
function L3(e) {
  return yc(e) ? Av(e, () => {
  }) : e;
}
function K3(e, t, i) {
  if (e.has(t)) {
    let r = e.get(t);
    return i.update && (r = i.update(r, t, e), e.set(t, r)), r;
  }
  if (!i.insert)
    throw new Error(ll(10));
  const n = i.insert(t, e);
  return e.set(t, n), n;
}
function YGe(e) {
  return typeof e == "boolean";
}
var FGe = () => function(t) {
  const {
    thunk: i = !0,
    immutableCheck: n = !0,
    serializableCheck: r = !0,
    actionCreatorCheck: g = !0
  } = t ?? {};
  let o = new I6();
  return i && (YGe(i) ? o.push(RGe) : o.push(XGe(i.extraArgument))), o;
}, xGe = "RTK_autoBatch", c6 = (e) => (t) => {
  setTimeout(t, e);
}, DGe = typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : c6(10), JGe = (e = {
  type: "raf"
}) => (t) => (...i) => {
  const n = t(...i);
  let r = !0, g = !1, o = !1;
  const l = /* @__PURE__ */ new Set(), a = e.type === "tick" ? queueMicrotask : e.type === "raf" ? DGe : e.type === "callback" ? e.queueNotification : c6(e.timeout), I = () => {
    o = !1, g && (g = !1, l.forEach((c) => c()));
  };
  return Object.assign({}, n, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(c) {
      const d = () => r && c(), C = n.subscribe(d);
      return l.add(c), () => {
        C(), l.delete(c);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(c) {
      var d;
      try {
        return r = !((d = c == null ? void 0 : c.meta) != null && d[xGe]), g = !r, g && (o || (o = !0, a(I))), n.dispatch(c);
      } finally {
        r = !0;
      }
    }
  });
}, EGe = (e) => function(i) {
  const {
    autoBatch: n = !0
  } = i ?? {};
  let r = new I6(e);
  return n && r.push(JGe(typeof n == "object" ? n : void 0)), r;
}, NGe = !0;
function LGe(e) {
  const t = FGe(), {
    reducer: i = void 0,
    middleware: n,
    devTools: r = !0,
    preloadedState: g = void 0,
    enhancers: o = void 0
  } = e || {};
  let l;
  if (typeof i == "function")
    l = i;
  else if (SJ(i))
    l = e6(i);
  else
    throw new Error(ll(1));
  let a;
  typeof n == "function" ? a = n(t) : a = t();
  let I = gw;
  r && (I = kGe({
    // Enable capture of stack traces for dispatched Redux actions
    trace: !NGe,
    ...typeof r == "object" && r
  }));
  const c = IGe(...a), d = EGe(c);
  let C = typeof o == "function" ? o(d) : d();
  const A = I(...C);
  return $j(l, g, A);
}
function d6(e) {
  const t = {}, i = [];
  let n;
  const r = {
    addCase(g, o) {
      const l = typeof g == "string" ? g : g.type;
      if (!l)
        throw new Error(ll(28));
      if (l in t)
        throw new Error(ll(29));
      return t[l] = o, r;
    },
    addMatcher(g, o) {
      return i.push({
        matcher: g,
        reducer: o
      }), r;
    },
    addDefaultCase(g) {
      return n = g, r;
    }
  };
  return e(r), [t, i, n];
}
function KGe(e) {
  return typeof e == "function";
}
function TGe(e, t) {
  let [i, n, r] = d6(t), g;
  if (KGe(e))
    g = () => L3(e());
  else {
    const l = L3(e);
    g = () => l;
  }
  function o(l = g(), a) {
    let I = [i[a.type], ...n.filter(({
      matcher: c
    }) => c(a)).map(({
      reducer: c
    }) => c)];
    return I.filter((c) => !!c).length === 0 && (I = [r]), I.reduce((c, d) => {
      if (d)
        if (eu(c)) {
          const A = d(c, a);
          return A === void 0 ? c : A;
        } else {
          if (yc(c))
            return Av(c, (C) => d(C, a));
          {
            const C = d(c, a);
            if (C === void 0) {
              if (c === null)
                return c;
              throw new Error(ll(9));
            }
            return C;
          }
        }
      return c;
    }, l);
  }
  return o.getInitialState = g, o;
}
var MGe = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", u6 = (e = 21) => {
  let t = "", i = e;
  for (; i--; )
    t += MGe[Math.random() * 64 | 0];
  return t;
}, PGe = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function UGe(e, t) {
  return `${e}/${t}`;
}
function zGe({
  creators: e
} = {}) {
  var i;
  const t = (i = e == null ? void 0 : e.asyncThunk) == null ? void 0 : i[PGe];
  return function(r) {
    const {
      name: g,
      reducerPath: o = g
    } = r;
    if (!g)
      throw new Error(ll(11));
    typeof process < "u";
    const l = (typeof r.reducers == "function" ? r.reducers(QGe()) : r.reducers) || {}, a = Object.keys(l), I = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, c = {
      addCase(Z, y) {
        const W = typeof Z == "string" ? Z : Z.type;
        if (!W)
          throw new Error(ll(12));
        if (W in I.sliceCaseReducersByType)
          throw new Error(ll(13));
        return I.sliceCaseReducersByType[W] = y, c;
      },
      addMatcher(Z, y) {
        return I.sliceMatchers.push({
          matcher: Z,
          reducer: y
        }), c;
      },
      exposeAction(Z, y) {
        return I.actionCreators[Z] = y, c;
      },
      exposeCaseReducer(Z, y) {
        return I.sliceCaseReducersByName[Z] = y, c;
      }
    };
    a.forEach((Z) => {
      const y = l[Z], W = {
        reducerName: Z,
        type: UGe(g, Z),
        createNotation: typeof r.reducers == "function"
      };
      qGe(y) ? $Ge(W, y, c, t) : jGe(W, y, c);
    });
    function d() {
      const [Z = {}, y = [], W = void 0] = typeof r.extraReducers == "function" ? d6(r.extraReducers) : [r.extraReducers], V = {
        ...Z,
        ...I.sliceCaseReducersByType
      };
      return TGe(r.initialState, (w) => {
        for (let v in V)
          w.addCase(v, V[v]);
        for (let v of I.sliceMatchers)
          w.addMatcher(v.matcher, v.reducer);
        for (let v of y)
          w.addMatcher(v.matcher, v.reducer);
        W && w.addDefaultCase(W);
      });
    }
    const C = (Z) => Z, A = /* @__PURE__ */ new Map();
    let b;
    function m(Z, y) {
      return b || (b = d()), b(Z, y);
    }
    function p() {
      return b || (b = d()), b.getInitialState();
    }
    function B(Z, y = !1) {
      function W(w) {
        let v = w[Z];
        return typeof v > "u" && y && (v = p()), v;
      }
      function V(w = C) {
        const v = K3(A, y, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return K3(v, w, {
          insert: () => {
            const H = {};
            for (const [x, J] of Object.entries(r.selectors ?? {}))
              H[x] = OGe(J, w, p, y);
            return H;
          }
        });
      }
      return {
        reducerPath: Z,
        getSelectors: V,
        get selectors() {
          return V(W);
        },
        selectSlice: W
      };
    }
    const f = {
      name: g,
      reducer: m,
      actions: I.actionCreators,
      caseReducers: I.sliceCaseReducersByName,
      getInitialState: p,
      ...B(o),
      injectInto(Z, {
        reducerPath: y,
        ...W
      } = {}) {
        const V = y ?? o;
        return Z.inject({
          reducerPath: V,
          reducer: m
        }, W), {
          ...f,
          ...B(V, !0)
        };
      }
    };
    return f;
  };
}
function OGe(e, t, i, n) {
  function r(g, ...o) {
    let l = t(g);
    return typeof l > "u" && n && (l = i()), e(l, ...o);
  }
  return r.unwrapped = e, r;
}
var pr = /* @__PURE__ */ zGe();
function QGe() {
  function e(t, i) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...i
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...i) {
          return t(...i);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, i) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: i
      };
    },
    asyncThunk: e
  };
}
function jGe({
  type: e,
  reducerName: t,
  createNotation: i
}, n, r) {
  let g, o;
  if ("reducer" in n) {
    if (i && !_Ge(n))
      throw new Error(ll(17));
    g = n.reducer, o = n.prepare;
  } else
    g = n;
  r.addCase(e, g).exposeCaseReducer(t, g).exposeAction(t, o ? lm(e, o) : lm(e));
}
function qGe(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function _Ge(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function $Ge({
  type: e,
  reducerName: t
}, i, n, r) {
  if (!r)
    throw new Error(ll(18));
  const {
    payloadCreator: g,
    fulfilled: o,
    pending: l,
    rejected: a,
    settled: I,
    options: c
  } = i, d = r(e, g, c);
  n.exposeAction(t, d), o && n.addCase(d.fulfilled, o), l && n.addCase(d.pending, l), a && n.addCase(d.rejected, a), I && n.addMatcher(d.settled, I), n.exposeCaseReducer(t, {
    fulfilled: o || PW,
    pending: l || PW,
    rejected: a || PW,
    settled: I || PW
  });
}
function PW() {
}
var eye = (e, t) => {
  if (typeof e != "function")
    throw new Error(ll(32));
}, RJ = "listenerMiddleware", tye = (e) => {
  let {
    type: t,
    actionCreator: i,
    matcher: n,
    predicate: r,
    effect: g
  } = e;
  if (t)
    r = lm(t).match;
  else if (i)
    t = i.type, r = i.match;
  else if (n)
    r = n;
  else if (!r)
    throw new Error(ll(21));
  return eye(g), {
    predicate: r,
    type: t,
    effect: g
  };
}, iye = Object.assign((e) => {
  const {
    type: t,
    predicate: i,
    effect: n
  } = tye(e);
  return {
    id: u6(),
    effect: n,
    type: t,
    predicate: i,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(ll(22));
    }
  };
}, {
  withTypes: () => iye
}), nye = Object.assign(lm(`${RJ}/add`), {
  withTypes: () => nye
});
lm(`${RJ}/removeAll`);
var rye = Object.assign(lm(`${RJ}/remove`), {
  withTypes: () => rye
});
function ll(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const T3 = (e) => e.actionEngine.actionEngineInput, zh = (e) => e.actionEngine.actionEngineState, gye = Ci(zh, (e) => Object.values(e ?? {}).flat()), su = [], oye = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.articles) ?? su;
}, C6 = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.colors) ?? su;
}, Rm = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.models) ?? su;
};
Ci(Rm, (e) => e.map((t) => t.modelId));
const A6 = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.prints) ?? su;
}, lye = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.images) ?? su;
}, aye = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.labels) ?? su;
}, b6 = (e) => {
  var t;
  return ((t = e.actionEngine.actionEngineState) == null ? void 0 : t.materials) ?? su;
}, bv = (e) => (t) => {
  var i;
  return ((i = t.actionEngine.actionEngineState) == null ? void 0 : i[e]) ?? su;
};
function N7t(e) {
  return de.isObject(e) && Le.has("id", e);
}
const An = (e) => de.keyBy(e, "id"), L7t = Le.mapValues.convert({
  cap: !1
}), sye = Le.map.convert({
  cap: !1
}), XJ = Le.reduce.convert({
  cap: !1
}), K7t = Le.pickBy.convert({
  cap: !1
}), T7t = Le.forEach.convert({
  cap: !1
}), M3 = Le.curry((e, t, i) => e ? t(i) : i);
Le.curry((e, t, i) => e(i) ? t(i) : i);
const wI = (e) => (t) => Le.mergeWith((i, n) => {
  if (n === void 0)
    return i;
  if (de.isFunction(n))
    return n(i);
  if (Le.isArray(i)) {
    if (de.isFunction(n))
      return Le.map(n, i);
    if (Le.flow(Le.first, Le.has("id"))(i)) {
      const r = An(n);
      return Le.map((g) => r[g.id] ? Le.assign(g, r[g.id]) : g, i);
    }
    return n;
  }
}, t, e), Iye = (e) => de.isString(e) ? e.includes("Infinity") ? parseFloat(e) : parseInt(e) : e, M7t = (e, t) => XJ((i, n, r, g) => r === e ? i : r === t ? e < t ? [...i, n, g[e]] : [...i, g[e], n] : [...i, n], []), P7t = (e, t) => (t % e + e) % e;
function U7t(e, t, i) {
  const n = [...e], r = n.find((l) => l.id == t.id), g = n.indexOf(r);
  return g + i < 0 || g + i > n.length ? e : (n.splice(g, 1), n.splice(g + i, 0, r), n.map((l, a) => ({
    ...l,
    sort: a
  })));
}
const z7t = (e, t) => (e.sort ?? 0) - (t.sort ?? 0) + 1, gA = (e, t) => (e.sort || 0) - (t.sort || 0), h6 = (e, t) => (e.sort ?? 0) - (t.sort ?? 0) || e.id - t.id, Wc = (e, t) => !e || !t ? !1 : (e.left > t.left || e.left === t.left && (t.leftInclude || !e.leftInclude)) && (e.right < t.right || e.right === t.right && (t.rightInclude || !e.rightInclude)), Iw = (e) => AA(e) && "left" in e, cye = (e) => Iw(e) && e.left === e.right, oA = (e) => ({
  left: e,
  leftInclude: !0,
  right: e,
  rightInclude: !0
}), P3 = (e, t) => ({
  left: e,
  right: t,
  leftInclude: !1,
  rightInclude: !1
}), U3 = (e) => e.left === e.right ? e.left.toString() : `${e.leftInclude ? "" : "("}${e.left}-${e.right}${e.rightInclude ? "" : ")"}`, z3 = (e) => {
  const t = e[e.length - 1];
  return {
    ...e[0],
    right: t.right,
    rightInclude: t.rightInclude
  };
}, dye = ({
  left: e,
  leftInclude: t,
  right: i,
  rightInclude: n
}) => ({
  left: e ?? -1 / 0,
  right: i ?? 1 / 0,
  leftInclude: t,
  rightInclude: n
}), uye = (e, t) => t.find((i) => Wc(oA(e), i.data)), UW = (e, t, i) => e ? e[`${i}Include`] ? e[i] : e[i] + t * (i === "left" ? 1 : -1) : void 0, Cye = (e, t, i) => {
  if (t.length === 0)
    return;
  const n = t.findIndex((r) => {
    var g;
    return (((g = r.data) == null ? void 0 : g.left) ?? -1 / 0) >= e;
  });
  if (n < 0) {
    const r = t[t.length - 1], g = UW(r.data, i, "right");
    return g != null ? {
      value: r,
      input: g
    } : void 0;
  } else if (n === 0) {
    const r = t[0], g = UW(r.data, i, "left");
    return g ? {
      value: r,
      input: g
    } : void 0;
  } else {
    const r = t[n], g = t[n - 1], o = UW(r.data, i, "left"), l = UW(r.data, i, "right");
    return o === void 0 || l === void 0 ? void 0 : Math.abs(e - o) < Math.abs(e - l) ? {
      value: r,
      input: o
    } : {
      value: g,
      input: l
    };
  }
}, Xm = (e, t, i) => {
  const n = uye(e, t);
  return n ? {
    value: n,
    input: e
  } : Cye(e, t, i);
}, Aye = (e) => {
  const t = e.replace(/\s/g, "");
  return t.includes(";") ? t.split(";") : t.includes("-") ? t.split("-") : [];
}, bye = (e, t) => {
  if (t === "left")
    return ["]", "("].includes(e[0]) ? [e.slice(1), !1] : [e.slice(e[0] === "[" ? 1 : 0), !0];
  {
    const i = e.length - 1, n = e[i];
    return ["[", ")"].includes(n) ? [e.slice(0, i), !1] : [e.slice(0, n === "]" ? i : i + 1), !0];
  }
}, O3 = (e, t) => {
  const [i, n] = bye(e, t);
  if (i === "")
    return [t === "left" ? -1 / 0 : 1 / 0, !1];
  const r = Number(i);
  if (isNaN(r))
    throw new Error(`Unable to parse ${e} to number`);
  return [r, n];
}, O7t = (e) => {
  const t = Number(e);
  if (t || t === 0)
    return {
      left: t,
      leftInclude: !0,
      right: t,
      rightInclude: !0
    };
  const i = Aye(e);
  if (i.length !== 2)
    throw new Error(`Unable to parse interval ${e}`);
  const [n, r] = O3(i[0], "left"), [g, o] = O3(i[1], "right");
  return {
    left: n,
    leftInclude: r,
    right: g,
    rightInclude: o
  };
}, m6 = (e) => cye(e.data), Ff = "$noSelection", Ho = {
  List: "list",
  Color: "color",
  Number: "number",
  Text: "text",
  MultiSelect: "multiSelect",
  Boolean: "boolean",
  Image: "image",
  Components: "components",
  Information: "information"
}, p6 = de.values(Ho), Kn = {
  Checkbox: "checkbox",
  Hidden: "hidden",
  Information: "information",
  RadioCard: "radioCard",
  Radio: "radio",
  Select: "select",
  SelectThumbs: "selectThumbs",
  Text: "text",
  Textarea: "textarea",
  Number: "number",
  Switch: "switch",
  SwitchCard: "switchCard",
  ColorSelect: "colorSelect",
  ColorDropdown: "colorDropdown",
  ColorRadio: "colorRadio",
  ColorRadioCard: "colorRadioCard",
  RALColorSelect: "ralColorSelect",
  ImageUpload: "imageUpload",
  ComponentList: "componentList",
  ComponentListPopup: "componentListPopup",
  ComponentValueCards: "componentValueCards"
}, Q7t = ["always", "never", "auto"];
var hye = /* @__PURE__ */ ((e) => (e.PNG = "PNG", e.JPG = "JPG", e))(hye || {});
function mye(e) {
  const t = e, i = (t == null ? void 0 : t.id) !== void 0, n = p6.includes(t == null ? void 0 : t.type);
  return i && n;
}
function j7t(e) {
  const t = e, i = (t == null ? void 0 : t.id) === void 0, n = p6.includes(t == null ? void 0 : t.type);
  return i && n;
}
const q7t = (e) => e.type === Ho.Color, B6 = (e) => e.type === Ho.Image, Sg = (e) => (e == null ? void 0 : e.type) === Ho.Number, _7t = (e) => !(Sg(e) || Hm(e)), pye = (e) => (e == null ? void 0 : e.type) === Ho.Boolean, hv = (e) => (e == null ? void 0 : e.type) === Ho.Information, Hm = (e) => (e == null ? void 0 : e.type) === Ho.Text || hv(e), bA = (e) => e == null ? void 0 : e.settings.template, Vi = (e) => e == null ? void 0 : e.settings.templateOptions, Iu = (e) => {
  const {
    step: t,
    roundToStep: i,
    digits: n
  } = Vi(e), r = Number(t || 0);
  return r && i ? r : n ? 1 / 10 ** n : 1;
}, Bye = (e) => {
  var t, i;
  return {
    min: ((t = Vi(e)) == null ? void 0 : t.min) || -1 / 0,
    max: ((i = Vi(e)) == null ? void 0 : i.max) || 1 / 0
  };
}, fye = (e) => (e == null ? void 0 : e.attrs) || [], Zye = (e, t) => (
  // @ts-ignore
  fye(t).find((i) => i.key === e)
), $7t = Le.flow(bA, Le.equals(Kn.RALColorSelect)), Gye = (e) => {
  var t;
  return ((t = Vi(e)) == null ? void 0 : t.hideAlways) || bA(e) === Kn.Hidden;
}, yye = (e) => !Gye(e), e8t = (e) => bA(e) === "textarea";
Le.curry((e, t) => wI({
  label: e
})(t));
Le.curry((e, t) => wI({
  description: e
})(t));
const t8t = Le.curry((e, t) => wI({
  settings: {
    template: e
  }
})(t)), i8t = Le.curry((e, t) => wI({
  settings: {
    templateOptions: e
  }
})(t)), n8t = Le.curry((e, t) => wI({
  type: e
})(t));
var Oh = /* @__PURE__ */ ((e) => (e[e.HideAction = 0] = "HideAction", e[e.ConcealAction = 1] = "ConcealAction", e[e.OneValidValue = 2] = "OneValidValue", e[e.NoValidValue = 3] = "NoValidValue", e[e.AlwaysHidden = 4] = "AlwaysHidden", e))(Oh || {});
const mv = (e, t, i, n, r) => {
  var l, a, I, c, d;
  const g = Vi(e);
  if (g.hideAlways)
    return {
      reason: 4,
      text: "Dieses Merkmal ist versteckt."
    };
  if (iw(t, e.id, n, "concealedVariablesMap"))
    return {
      reason: 1,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar, da es per Regel versteckt wurde."
    };
  if (iw(t, e.id, n))
    return {
      reason: 0,
      text: `Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: 
 1. Es wurde per Regel entfernt. 
 2. Der zugehörige Schritt wurde entfernt.`
    };
  if (hv(e))
    return null;
  if (!((a = (l = t == null ? void 0 : t.values) == null ? void 0 : l.byVarId) != null && a.all[e.id]))
    return {
      reason: 0,
      text: "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen."
    };
  const o = r || ((c = (I = i == null ? void 0 : i.all) == null ? void 0 : I.validOptions[n]) == null ? void 0 : c[e.id]);
  if (g != null && g.hideIfNoOptions && (o == null ? void 0 : o.length) === 0)
    return {
      reason: 3,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!"
    };
  if (g != null && g.hideIfSingleOption && (o == null ? void 0 : o.length) === 1) {
    if (Sg(e)) {
      const C = (d = o[0]) == null ? void 0 : d.value;
      if (C && !m6(C))
        return null;
    }
    return {
      reason: 2,
      text: "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!"
    };
  }
  return null;
}, f6 = (e, t, i, n) => {
  var o, l;
  const {
    showSelection: r,
    hideIfNoSelection: g
  } = Vi(e);
  if (r == "always")
    return !0;
  if (r == "never")
    return !1;
  if (g) {
    if (pye(e)) {
      const a = Z6(t, n);
      if (!(a != null && a.value) || (a == null ? void 0 : a.value) == "0")
        return !1;
    } else if (e.type == Ho.Text) {
      if (!((o = n == null ? void 0 : n.data) != null && o.inputText))
        return !1;
    } else if (Sg(e)) {
      if (!((l = n.data) != null && l.inputValue))
        return !1;
    } else if (Wye(t, n) || e.type === Ho.Image && !Sye(e, t, n.valueId))
      return !1;
  }
  switch (r) {
    case "auto":
    default:
      return !mv(e, t, i, n.instance.id);
  }
}, Z6 = (e, t) => {
  var i;
  return (i = e.values.byVarId.all[t.variableId]) == null ? void 0 : i.find((n) => n.id === t.valueId);
}, Wye = (e, t) => {
  var i;
  return ((i = Z6(e, t)) == null ? void 0 : i.key) === Ff;
}, Sye = (e, t, i) => {
  var n;
  return ((n = t.values.byVarId.all[e.id].find((r) => r.id === i)) == null ? void 0 : n.value) === "1";
}, km = (e) => (e == null ? void 0 : e.type) === "components", to = (e, t) => e.variableId === t.variableId && e.instance.id === t.instance.id && e.instance.belongsToInstanceId === t.instance.belongsToInstanceId, Vye = (e, t) => (i) => i.variableId === e && i.instance.id === t.id, wye = (e, t) => [...t, ...e.filter((i) => !t.some((n) => (n == null ? void 0 : n.value.id) === i.value.id))], vye = (e, t, i) => {
  if (!i.instance.belongsToInstanceId)
    return null;
  const n = t.locked.selections.find((a) => a.id === i.instance.belongsToInstanceId);
  if (!n)
    return null;
  const g = t.locked.selections.filter((a) => a.variableId === n.variableId && a.valueId === n.valueId).findIndex((a) => a.id === n.id), o = e.values.byVarId.locked[n.variableId].find((a) => a.id === n.valueId);
  return {
    variable: e.variables.byVarId.locked[n.variableId].label,
    value: (o == null ? void 0 : o.label) || "",
    index: g
  };
}, pv = (e) => e.interval, G6 = (e, t) => {
  var i;
  return ((i = e[t.variableId]) == null ? void 0 : i.type) === "number";
}, Rye = (e, t, i) => {
  var o, l, a;
  const n = e.variables.byVarId.all[i.variableId], r = Sg(n) ? W6(i, n) || "" : ((o = e.values.byVarId.all[i.variableId].find((I) => I.id === i.valueId)) == null ? void 0 : o.label) ?? "", g = vye(e, t, i);
  return {
    value: r,
    variable: n.label,
    instance: g,
    error: (l = i.data) == null ? void 0 : l.error,
    unsolvable: !!((a = i.data) != null && a.error)
  };
}, r8t = (e) => Number.isInteger(parseInt(e)) && !yJ(e), HJ = (e, t) => {
  const [i, n] = de.partition(t, (r) => e.variables.byVarId.locked[r.variableId]);
  return {
    locked: i,
    free: n
  };
}, Xye = (e, t) => t.map((i) => ({
  selection: i,
  variable: e.variables.byVarId.all[i.variableId]
})).sort((i, n) => i.variable.sort - n.variable.sort || (i.selection.sort || 0) - (n.selection.sort || 0)).map((i) => i.selection), Hye = Le.curry((e, t, i) => i.variableId === e && i.instance.belongsToInstanceId === t), kye = (e, t, i) => Math.max(0, ...i.filter(Hye(e, t)).map((n) => n.sort || 0));
function Yye(e, t) {
  const i = e.filter((g) => g.parentId === Ut.variableId), n = de.groupBy(e, (g) => g.parentId);
  let r = [...i];
  for (; r.length > 0; ) {
    const g = r.pop(), o = n[g.id] || [];
    r = t(g, o, r);
  }
}
const y6 = (e) => {
  const t = {}, i = Ut.instance.hierarchyLevel + 1;
  return Yye(e, (n, r, g) => (t[n.id] = n.parentId ? t[n.parentId] + 1 : i, [...g, ...r])), t;
}, lA = (e, t) => e.instance.hierarchyLevel - t.instance.hierarchyLevel, am = (e, t, i, n, r) => {
  if (TZe(i))
    return t;
  const g = r || t.filter(mg), o = de.uniqBy(WZ(g, i, r), (C) => C.id), l = n || de.groupBy(t, (C) => qa(C)), a = o.map((C) => C.variableId), I = /* @__PURE__ */ new Set();
  I.add(Ut);
  for (const C of o) {
    C.id !== Ut.id && I.add(C);
    const A = l[C.id];
    if (A)
      for (let b = 0; b < A.length; b++) {
        const m = A[b];
        a.includes(m.variableId) || I.add(m);
      }
  }
  const c = e[i.variableId], d = new Set(c);
  for (let C = 0; C < g.length; C++) {
    const A = g[C];
    if (!d.has(A.variableId) && !d.has(A.instance.belongsToVariableId)) {
      const b = l[A.id];
      b == null || b.forEach((m) => I.add(m)), I.add(A);
    }
  }
  return Array.from(I);
}, tu = (e, t) => (e.sort ?? 0) - (t.sort ?? 0), W6 = (e, t, i = !0) => {
  var r;
  if (!e || !Sg(t))
    return;
  const n = ((r = e == null ? void 0 : e.data) == null ? void 0 : r.inputValue) ?? 0;
  return t ? S6(n, t, i) : n.toFixed(0);
}, S6 = (e, t, i = !0) => {
  if (!t)
    return e == null ? void 0 : e.toString();
  const n = Vi(t);
  return (e ? e.OC_roundTo(n.digits || 0) : 0).toString().OC_addIfGiven(i ? n.unit : void 0);
}, Fye = (e) => {
  if (Le.isArray(e))
    return !1;
  const t = Number(e);
  return !isNaN(t);
}, xye = (e) => Array.isArray(e), xf = (e) => AA(e) && "interval" in e && "originalString" in e, Dye = (e) => (e == null ? void 0 : e.id) !== void 0, zg = {
  SetArticle: "setArticle",
  SetInstance: "setInstance",
  SetColor: "setColorByVariable",
  SetImage2D: "setImage2D",
  SetLabel: "setLabel",
  SetPopup: "setPopup",
  SetMaterial: "setMaterial",
  SetMaterialTexture: "setMaterialTexture",
  SetModel: "setModel",
  SetConcealVariable: "setConcealVariable",
  SetConcealGroup: "setConcealGroup",
  SetHideVariable: "setHideVariable",
  SetHideGroup: "setHideGroup",
  SetHideValues: "setHideValues",
  SetFocusGroup: "setFocusGroup",
  SetExitButtons: "setExitButtons"
}, cw = (e) => (e == null ? void 0 : e.id) == zg.SetModel && (e == null ? void 0 : e.modelId) !== void 0, Jye = (e) => (e == null ? void 0 : e.id) == zg.SetLabel && (e == null ? void 0 : e.label) !== void 0, Eye = (e) => (e == null ? void 0 : e.id) == zg.SetPopup, Nye = (e) => (e == null ? void 0 : e.id) == zg.SetConcealGroup, Lye = (e) => (e == null ? void 0 : e.id) == zg.SetConcealVariable, Kye = (e) => (e == null ? void 0 : e.id) == zg.SetHideVariable, Tye = (e) => (e == null ? void 0 : e.id) == zg.SetHideGroup, Mye = (e) => (e == null ? void 0 : e.id) == zg.SetExitButtons, Pye = (e) => AA(e) && e.id === zg.SetHideValues, Uye = (e) => (e == null ? void 0 : e.id) === zg.SetArticle && (e == null ? void 0 : e.articleId) !== void 0, kJ = (e) => (e == null ? void 0 : e.id) === zg.SetInstance && (e == null ? void 0 : e.valueId) !== void 0, zye = (e) => (e == null ? void 0 : e.id) === zg.SetColor && (e == null ? void 0 : e.variableId) !== void 0, Oye = (e) => (e == null ? void 0 : e.id) === zg.SetMaterial && (e == null ? void 0 : e.materialId) !== void 0, Qye = (e) => (e == null ? void 0 : e.id) === zg.SetImage2D && (e == null ? void 0 : e.path) !== void 0, YJ = (e) => (e == null ? void 0 : e.id) === zg.SetMaterialTexture && (e == null ? void 0 : e.variableId) !== void 0, g8t = (e) => AA(e) && "id" in e, jye = (e) => typeof e == "number", qye = (e) => Le.isArray(e), o8t = (e) => Le.anyPass([jye, qye])(e), FJ = (e, t) => {
  const i = e.values[t.variableId];
  if (i === !0)
    return !0;
  if (xf(i) && pv(t))
    return Wc(t.interval, i.interval);
  try {
    return i.includes(t.valueId);
  } catch (n) {
    return console.error("Failed to compare selection & value", n, t, i), !1;
  }
};
function _ye(e, t) {
  const i = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of n.columns)
      r.type === "variable" && i.add(Number(r.targetId));
  return i.delete(t.variableId), i;
}
const Bv = (e, t, i, n) => {
  if (!t.length)
    return {
      isValid: !0
    };
  const r = e.ruleItems.rulesByTargetIdMap[i.variableId] || [], g = /* @__PURE__ */ new Set();
  WZ(t, i).forEach((c) => g.add(c.id));
  const o = _ye(r, i), l = t.filter(
    (c) => o.has(c.variableId) && g.has(c.instance.id) && c.variableId !== i.variableId
    //siblings should be filtered out
  );
  l.sort(lA);
  const a = de.groupBy(l, (c) => c.variableId), I = [];
  for (const c of r) {
    const d = (e.ruleItems.byRuleId[c.id] || []).filter((A) => FJ(A, i));
    if (!d.length)
      continue;
    if (!l.every((A) => {
      const b = a[A.variableId] || [];
      a[A.variableId] = [A];
      const m = d.some((p) => $ye(o, a, p));
      return a[A.variableId] = b, m;
    })) {
      const A = l.filter((b) => c.columns.some((m) => m.targetId == b.variableId));
      if (I.push(...A), n)
        break;
    }
  }
  return {
    isValid: !I.length,
    conflicts: de.uniqBy(I, (c) => c.id).map((c) => [i, c])
  };
}, $ye = (e, t, i) => Object.entries(i.values).every(([n, r]) => {
  if (r === !0)
    return !0;
  const g = +n;
  if (!e.has(g))
    return !0;
  const o = t[g];
  return o != null && o.length ? o.some((l) => FJ(i, l)) : !0;
}), eWe = (e, t, i) => {
  t.sort(lA), i.sort(lA);
  for (let n = 0; n < i.length; n++) {
    const r = n === 0 ? [] : i.slice(0, n), g = Bv(e, [...t, ...r], i[n], !1);
    if (!g.isValid)
      return g;
  }
  return {
    isValid: !0
  };
}, tWe = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let fv = (e = 21) => {
  let t = "", i = crypto.getRandomValues(new Uint8Array(e));
  for (; e--; )
    t += tWe[i[e] & 63];
  return t;
};
const SZ = (e, t, i, n, r, g) => {
  const o = fv(), l = typeof e == "number" ? e : e.id, a = typeof e == "number" ? !!(t != null && t.data) && "leftInclude" in t.data : Sg(e);
  return {
    id: o,
    variableId: l,
    valueId: (t == null ? void 0 : t.id) || 0,
    instance: n ? {
      id: o,
      belongsToInstanceId: i.id,
      belongsToVariableId: l,
      isInstanceLauncher: !0,
      hierarchyLevel: i.hierarchyLevel + 1
    } : {
      ...i,
      isInstanceLauncher: !1,
      hierarchyLevel: i.hierarchyLevel + 1
    },
    debuggingValue: (t == null ? void 0 : t.label) || `Empty selection for variable ${typeof e == "number" ? e : e.label}`,
    data: r,
    interval: a ? t == null ? void 0 : t.data : void 0,
    sort: g
  };
}, Fx = (e) => e.settings.templateOptions.suppressConflictDialogVariableIds ?? [], iWe = (e) => {
  var i;
  const t = Vi(e);
  return t.suppressConflictDialog && (((i = t == null ? void 0 : t.suppressConflictDialogVariableIds) == null ? void 0 : i.length) ?? 0) > 0;
}, nWe = (e) => {
  const t = e.ruleEngineState, i = e.ruleEngineInput;
  if (t.onlyUntouched || !t.lastManualChange)
    return t.onlyUntouched;
  const n = i.variables.flat.all.filter((l) => iWe(l));
  if (n.length === 0)
    return t.onlyUntouched;
  const r = t.lastManualChange;
  return !t.touchedChanges.some(([l]) => {
    const a = n.find((I) => I.id === l.variableId);
    return !(a && Fx(a).includes(r == null ? void 0 : r.variableId));
  });
};
function rWe(e, t) {
  var i;
  return (i = e.conflicts) == null ? void 0 : i.filter(([n, r]) => {
    const g = Fx(t.variables.byVarId.all[n.variableId]);
    if (g.length && g.includes(r.variableId))
      return !1;
    const o = Fx(t.variables.byVarId.all[r.variableId]);
    return !(o.length && o.includes(n.variableId));
  });
}
const gWe = (e, t, i, n, r) => {
  var d;
  const g = SZ(n.variableId, n, r.instance, !1), o = e.filter((C) => !to(C, g)), l = t.variables.dependentVariablesById[g.variableId] ?? [], a = am(t.variables.variableHierarchies, i.state.all.selections, g).filter((C) => l.includes(C.variableId) && C.variableId !== g.variableId && C.instance.id !== g.instance.id), I = eWe(t, [g], de.uniqBy([...o, ...a], (C) => C.id));
  if (I.isValid)
    return;
  const c = (d = rWe(I, t)) == null ? void 0 : d.filter((C) => o.some((A) => A.id === C[0].id || A.id === C[1].id));
  if ((c == null ? void 0 : c.length) !== 0)
    return {
      value: n,
      conflicts: (c == null ? void 0 : c.map(([, C]) => C)) ?? []
    };
};
function Zv(e) {
  return (e == null ? void 0 : e.type) === "components";
}
const oWe = [], hA = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.rules) ?? oWe;
}, V6 = Ci(hA, (e) => An(e)), xJ = (e) => (t) => V6(t)[e], lWe = Ci([hA, (e, t) => t], (e, t) => e.filter((i) => i.appId == t)), l8t = (e) => (t) => e ? hA(t).filter((i) => de.includes(Le.map((n) => n.targetId, i.columns), e)) : [], a8t = (e, t) => (i) => {
  var n, r;
  return (
    //@ts-ignore
    (r = (n = xJ(e)(i)) == null ? void 0 : n.columns) == null ? void 0 : r.find((g) => g.id == t)
  );
}, aWe = [], sWe = [], w6 = {}, IWe = {}, nr = (e) => e.ruleEngine.ruleEngineInput, Jr = (e) => e.ruleEngine.ruleEngineState, DJ = (e) => e.ruleEngine.ruleEngineConflict, cWe = [], Ns = (e) => e.ruleEngine.openInstances ?? cWe, v6 = (e, t) => Ns(e).find((i) => i.instance.belongsToInstanceId === t.id && i !== t), VZ = (e) => Ns(e).slice().sort(lA)[0], JJ = (e, t) => {
  const i = kI(t)(e);
  return !i || i.parentId === Ut.variableId ? Ut : Ns(e).find((n) => n.variableId === i.parentId);
}, Gv = (e, t) => {
  const i = qr(t)(e), n = Zv(i) ? i.id : i.parentId;
  return Ns(e).find((r) => r.variableId === n);
}, wZ = Ci([nr, Jr, VZ], (e, t, i) => ({
  ruleEngineInput: e,
  ruleEngineState: t,
  openInstance: i
})), dWe = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jr(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.validOptions) ?? w6;
}, uWe = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jr(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.invalidOptions) ?? w6;
}, R6 = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jr(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.touched) ?? IWe;
}, CWe = (e) => (t) => {
  var n;
  const i = Gv(t, e);
  return i ? (n = R6(t)[i == null ? void 0 : i.id]) == null ? void 0 : n.includes(e) : !0;
}, s8t = (e) => (t) => {
  var n, r;
  const i = Gv(t, e);
  return i ? ((r = (n = dWe(t)[i.id]) == null ? void 0 : n[e]) == null ? void 0 : r.map((g) => g.value)) || [] : [];
}, AWe = (e) => (t) => {
  var n, r;
  const i = Gv(t, e.variableId);
  if (i)
    return (r = (n = uWe(t)[i.id]) == null ? void 0 : n[e.variableId]) == null ? void 0 : r.find((g) => g.value.id === e.id);
}, bWe = (e) => (t) => {
  var i, n, r;
  return (((r = (n = (i = nr(t)) == null ? void 0 : i.values) == null ? void 0 : n.flat) == null ? void 0 : r.all) ?? []).find((g) => g.id === e);
}, X6 = (e) => (t) => {
  const i = bWe(e)(t);
  if (!i)
    return;
  const n = AWe(i)(t);
  if (!n)
    return n;
  const r = n.conflicts.filter((a) => CWe(a.variableId)(t)), g = nr(t), o = Jr(t);
  if (!g || !o)
    return;
  const l = Gv(t, i.variableId);
  if (l)
    return gWe(r, g, o, i, l);
}, hWe = (e) => (t) => {
  const i = nr(t), n = Jr(t);
  return !i || !n ? sWe : e.map((r) => Rye(i, n.state, r));
}, I8t = (e) => e.ruleEngine.ruleEngineError, Q3 = [], EJ = Ci([VZ, wZ, (e, t) => t, (e, t, i) => i, (e, t, i, n) => n, (e, t, i, n, r) => r], (e, {
  ruleEngineInput: t,
  ruleEngineState: i
}, n, r, g, o) => {
  var I, c, d;
  const l = n ?? e;
  if (!r)
    return [];
  const a = (d = (c = (I = i == null ? void 0 : i.state) == null ? void 0 : I.all) == null ? void 0 : c.selections) == null ? void 0 : d.filter((C) => C.variableId === r.id && C.instance.belongsToInstanceId === l.id).sort((C, A) => C.sort - A.sort).reduce((C, A) => {
    const b = t == null ? void 0 : t.values.byVarId.locked[r.id].find((m) => m.id === A.valueId);
    return b && C.push({
      selection: A,
      value: b
    }), C;
  }, []);
  return o && (a == null || a.reverse()), g ? (a == null ? void 0 : a.slice().sort((C, A) => (
    // @ts-ignore
    C.value.sort - A.value.sort || C.selection.sort - A.selection.sort
  ))) ?? Q3 : a ?? Q3;
}), mWe = Ci([hA], (e) => e.some((t) => t.columns.some(nGe))), pWe = [], Og = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.variables) ?? pWe;
}, vc = Ci(Og, (e) => An(e)), qr = (e) => (t) => {
  var i;
  return (i = vc(t)) == null ? void 0 : i[e];
}, vZ = (e) => (t) => Og(t).find((i) => i.key === e), H6 = (e) => (t) => {
  const i = An(Og(t));
  return de.compact(e == null ? void 0 : e.map((n) => i[n]));
}, BWe = Ci([Og, (e, t) => t], (e, t) => e.filter((i) => i.appId === t)), NJ = (e, t, i) => (n) => {
  var o;
  const r = nr(n), g = (o = Jr(n)) == null ? void 0 : o.state;
  return !r || !g ? (console.warn("Rule engine not initialized!"), null) : mv(e, r, g, t, i);
}, fWe = (e, t) => (i) => {
  var g;
  const n = nr(i), r = (g = Jr(i)) == null ? void 0 : g.state;
  return !n || !r ? (console.warn("Rule engine not initialized!"), null) : f6(e, n, r, t);
}, ZWe = (e) => e.metadata.groups, _l = Ci(ZWe, (e) => e.slice().sort(gA)), c8t = Ci(_l, (e) => An(e)), k6 = Ci(_l, (e) => de.groupBy(e, (t) => t.appId)), GWe = [];
Ci([(e, t) => t, k6], (e, t) => t[e] || GWe);
const kI = (e) => (t) => _l(t).find((i) => i.id == e), yWe = (e) => (t) => _l(t).find((i) => i.key == e), WWe = (e) => (t) => _l(t).find((i) => i.parentId == e), d8t = (e) => (t) => _l(t).filter((i) => i.parentId === e), SWe = Ci([_l, Og, (e, t) => t, (e, t, i) => i, (e, t, i, n) => n], (e, t, i, n, r) => {
  const g = (o, l) => {
    const a = l != null && l.onlyVars ? [] : [o];
    if (o != null && o.parentId) {
      const I = t.find((C) => C.id == o.parentId);
      if (!I)
        return a;
      const c = e.find((C) => C.id == I.groupId);
      if (!c)
        return a;
      const d = g(c, l);
      return l != null && l.onlyGroups || d.push(I), l != null && l.onlyVars || d.push(o), d;
    } else
      return a;
  };
  return g(i, {
    onlyVars: n,
    onlyGroups: r
  });
});
function u8t(e, t, i) {
  let n = t;
  return i && (n = kI(i == null ? void 0 : i.groupId)(e)), n ? SWe(e, n, !!i, !!t) : [];
}
function VWe(e) {
  return Le.overEvery([Le.has("id")])(e);
}
const wWe = {
  Right: "right",
  Left: "left"
}, vWe = ["de", "en", "nl", "fr"], dw = (e) => {
  var t;
  return (t = e.settings.langs) != null && t.length ? e.settings.langs : vWe;
}, C8t = {
  topmenu: "topmenu",
  accordion: "accordion",
  onlysidebar: "onlysidebar",
  backgroungGroup: "backgroungGroup",
  individuell: "individuell"
}, A8t = {
  Configurator: "configurator",
  ArticleList: "articleList"
}, Df = {
  NONE: "NONE",
  STACK: "STACK",
  GALLERY: "TURNTABLE",
  _3D: "3D",
  PLANER: "PLANER"
}, RWe = {
  DE: "de",
  EN: "en",
  NL: "nl",
  FR: "fr"
}, b8t = Object.values(RWe), h8t = () => {
  const {
    t: e
  } = Gi();
  return {
    ab: e("Abkhazian"),
    aa: e("Afar"),
    af: e("Afrikaans"),
    ak: e("Akan"),
    sq: e("Albanian"),
    am: e("Amharic"),
    ar: e("Arabic"),
    an: e("Aragonese"),
    hy: e("Armenian"),
    as: e("Assamese"),
    av: e("Avaric"),
    ae: e("Avestan"),
    ay: e("Aymara"),
    az: e("Azerbaijani"),
    bm: e("Bambara"),
    ba: e("Bashkir"),
    eu: e("Basque"),
    be: e("Belarusian"),
    bn: e("Bengali"),
    bi: e("Bislama"),
    bs: e("Bosnian"),
    br: e("Breton"),
    bg: e("Bulgarian"),
    my: e("Burmese"),
    ca: e("Catalan, Valencian"),
    ch: e("Chamorro"),
    ce: e("Chechen"),
    ny: e("Chichewa, Chewa, Nyanja"),
    zh: e("Chinese"),
    cu: e("Church Slavonic, Old Slavonic, Old Church Slavonic"),
    cv: e("Chuvash"),
    kw: e("Cornish"),
    co: e("Corsican"),
    cr: e("Cree"),
    hr: e("Croatian"),
    cs: e("Czech"),
    da: e("Danish"),
    dv: e("Divehi, Dhivehi, Maldivian"),
    nl: e("Dutch, Flemish"),
    dz: e("Dzongkha"),
    en: e("English"),
    eo: e("Esperanto"),
    et: e("Estonian"),
    ee: e("Ewe"),
    fo: e("Faroese"),
    fj: e("Fijian"),
    fi: e("Finnish"),
    fr: e("French"),
    fy: e("Western Frisian"),
    ff: e("Fulah"),
    gd: e("Gaelic, Scottish Gaelic"),
    gl: e("Galician"),
    lg: e("Ganda"),
    ka: e("Georgian"),
    de: e("German"),
    el: e("Greek, Modern (1453-)"),
    kl: e("Kalaallisut, Greenlandic"),
    gn: e("Guarani"),
    gu: e("Gujarati"),
    ht: e("Haitian, Haitian Creole"),
    ha: e("Hausa"),
    he: e("Hebrew"),
    hz: e("Herero"),
    hi: e("Hindi"),
    ho: e("Hiri Motu"),
    hu: e("Hungarian"),
    is: e("Icelandic"),
    io: e("Ido"),
    ig: e("Igbo"),
    id: e("Indonesian"),
    ia: e("Interlingua (International Auxiliary Language Association)"),
    ie: e("Interlingue, Occidental"),
    iu: e("Inuktitut"),
    ik: e("Inupiaq"),
    ga: e("Irish"),
    it: e("Italian"),
    ja: e("Japanese"),
    jv: e("Javanese"),
    kn: e("Kannada"),
    kr: e("Kanuri"),
    ks: e("Kashmiri"),
    kk: e("Kazakh"),
    km: e("Central Khmer"),
    ki: e("Kikuyu, Gikuyu"),
    rw: e("Kinyarwanda"),
    ky: e("Kirghiz, Kyrgyz"),
    kv: e("Komi"),
    kg: e("Kongo"),
    ko: e("Korean"),
    kj: e("Kuanyama, Kwanyama"),
    ku: e("Kurdish"),
    lo: e("Lao"),
    la: e("Latin"),
    lv: e("Latvian"),
    li: e("Limburgan, Limburger, Limburgish"),
    ln: e("Lingala"),
    lt: e("Lithuanian"),
    lu: e("Luba-Katanga"),
    lb: e("Luxembourgish, Letzeburgesch"),
    mk: e("Macedonian"),
    mg: e("Malagasy"),
    ms: e("Malay"),
    ml: e("Malayalam"),
    mt: e("Maltese"),
    gv: e("Manx"),
    mi: e("Maori"),
    mr: e("Marathi"),
    mh: e("Marshallese"),
    mn: e("Mongolian"),
    na: e("Nauru"),
    nv: e("Navajo, Navaho"),
    nd: e("North Ndebele"),
    nr: e("South Ndebele"),
    ng: e("Ndonga"),
    ne: e("Nepali"),
    no: e("Norwegian"),
    nb: e("Norwegian Bokmål"),
    nn: e("Norwegian Nynorsk"),
    ii: e("Sichuan Yi, Nuosu"),
    oc: e("Occitan"),
    oj: e("Ojibwa"),
    or: e("Oriya"),
    om: e("Oromo"),
    os: e("Ossetian, Ossetic"),
    pi: e("Pali"),
    ps: e("Pashto, Pushto"),
    fa: e("Persian"),
    pl: e("Polish"),
    pt: e("Portuguese"),
    pa: e("Punjabi, Panjabi"),
    qu: e("Quechua"),
    ro: e("Romanian, Moldavian, Moldovan"),
    rm: e("Romansh"),
    rn: e("Rundi"),
    ru: e("Russian"),
    se: e("Northern Sami"),
    sm: e("Samoan"),
    sg: e("Sango"),
    sa: e("Sanskrit"),
    sc: e("Sardinian"),
    sr: e("Serbian"),
    sn: e("Shona"),
    sd: e("Sindhi"),
    si: e("Sinhala, Sinhalese"),
    sk: e("Slovak"),
    sl: e("Slovenian"),
    so: e("Somali"),
    st: e("Southern Sotho"),
    es: e("Spanish, Castilian"),
    su: e("Sundanese"),
    sw: e("Swahili"),
    ss: e("Swati"),
    sv: e("Swedish"),
    tl: e("Tagalog"),
    ty: e("Tahitian"),
    tg: e("Tajik"),
    ta: e("Tamil"),
    tt: e("Tatar"),
    te: e("Telugu"),
    th: e("Thai"),
    bo: e("Tibetan"),
    ti: e("Tigrinya"),
    to: e("Tonga (Tonga Islands)"),
    ts: e("Tsonga"),
    tn: e("Tswana"),
    tr: e("Turkish"),
    tk: e("Turkmen"),
    tw: e("Twi"),
    ug: e("Uighur, Uyghur"),
    uk: e("Ukrainian"),
    ur: e("Urdu"),
    uz: e("Uzbek"),
    ve: e("Venda"),
    vi: e("Vietnamese"),
    vo: e("Volapük"),
    wa: e("Walloon"),
    cy: e("Welsh"),
    wo: e("Wolof"),
    xh: e("Xhosa"),
    yi: e("Yiddish"),
    yo: e("Yoruba"),
    za: e("Zhuang, Chuang"),
    zu: e("Zulu")
  };
}, m8t = ["variablesAndArticles", "variablesOnly", "articlesOnly", "noOverview"], XWe = (e) => !e || !("type" in e), Br = (e) => {
  var t, i, n;
  return ((n = (i = (t = Jr(e)) == null ? void 0 : t.state) == null ? void 0 : i.all) == null ? void 0 : n.selections) || [];
}, Y6 = Ci([Br], (e) => ({
  [Ut.id]: Ut,
  ...de.keyBy(e, (t) => t.id)
})), LJ = (e) => (t) => Y6(t)[e], HWe = (e, t) => (i) => {
  const n = qr(e)(i);
  return Br(i).find((o) => o.variableId === (n == null ? void 0 : n.id) && o.instance.id === t);
}, kWe = Ci([Br, vc], (e, t) => e.filter((n) => n.instance.isInstanceLauncher).map((n) => ({
  selection: n,
  variable: t[n.variableId]
}))), p8t = (e) => (t) => e ? iA([Ut, ...Br(t)], e) : void 0, YWe = (e) => {
  const t = nr(e), i = Br(e);
  return t ? sv(t, i) : aWe;
}, FWe = (e) => (t) => Le.flow(Br, Le.filter((i) => i.variableId == e))(t), B8t = (e) => (t) => FWe(e)(t).map((n) => ({
  value: t.metadata.values.find((r) => r.id == +n.valueId),
  selection: n
})), yv = (e) => (t) => Br(t).find((i) => i.variableId == e), Ym = Ci([Br, (e, t) => t, (e, t, i) => i], (e, t, i) => {
  if (!t)
    return [];
  let n = t;
  const r = [];
  for (i && t.instance.isInstanceLauncher && r.push(t); n; ) {
    const g = e.find((o) => o.id == qa(n));
    g ? (r.push(g), n = g) : n = void 0;
  }
  return r;
}), Wv = (e) => oGe(Pi(e)), Pi = (e) => {
  var t, i;
  return ((t = e == null ? void 0 : e.frontend) == null ? void 0 : t.app) || ((i = e == null ? void 0 : e.configurator) == null ? void 0 : i.app) || void 0;
}, f8t = (e) => {
  var i;
  const t = Pi(e);
  return t ? ((i = qj(t)) == null ? void 0 : i.actions) || [] : [];
}, xWe = (e) => Iv(Pi(e)), F6 = (e) => {
  var t, i, n;
  return (n = (i = (t = Pi(e)) == null ? void 0 : t.settings) == null ? void 0 : i.themeMobile) == null ? void 0 : n.selected;
}, x6 = Ci([Pi, k6], (e, t) => t[e == null ? void 0 : e.id] ?? []), DWe = (e) => {
  var t;
  return (t = Pi(e)) == null ? void 0 : t.productDetails;
}, Z8t = (e) => {
  var t;
  return ((t = DWe(e)) == null ? void 0 : t.branding) ?? !0;
}, G8t = (e) => (t) => {
  const i = e || Pi(t);
  return (i == null ? void 0 : i.stage) == Df._3D;
}, JWe = (e) => (t) => {
  const i = e || Pi(t);
  return (i == null ? void 0 : i.stage) == Df.GALLERY || (i == null ? void 0 : i.stage) == Df.STACK;
}, D6 = (e) => {
  var t, i;
  return ((i = (t = Pi(e)) == null ? void 0 : t.settings) == null ? void 0 : i.dynamicSettings) || {};
}, EWe = [], NWe = (e) => {
  var t, i;
  return ((i = (t = Pi(e)) == null ? void 0 : t.settings) == null ? void 0 : i.dynamicTranslationKeys) || EWe;
}, Sv = Ci([Pi], (e) => VI("setCameraList", (e == null ? void 0 : e.settings.cameras) || [])), y8t = (e) => (t) => Sv(t).find((i) => i.id === e), W8t = Ci([Sv, (e, t) => t], (e, t) => KJ(t, e)), LWe = Ci([Sv], (e) => {
  const t = KJ({
    type: "general"
  }, e);
  return VI("setScreenshotCameras", t);
}), KJ = (e, t) => t.filter((i) => {
  var n, r;
  return e.type === "general" && (!i.scope || i.scope.type === "general") || e.type === ((n = i.scope) == null ? void 0 : n.type) && e.id === ((r = i.scope) == null ? void 0 : r.id);
}), KWe = (e) => e.frontend.configurationInitialization, TWe = (e) => e.frontend.configuration, mA = (e, t) => (i) => {
  let n = [Ut];
  const r = Rm(i);
  if (e) {
    const g = r.filter((o) => {
      var l, a;
      return ((l = o == null ? void 0 : o.ruleItem) == null ? void 0 : l.id) === e && ((a = o.ruleColumn) == null ? void 0 : a.id) === t;
    });
    g && (n = g.map((o) => o.anchoringSelection));
  }
  return n;
}, S8t = (e) => e.frontend.arDialog, MWe = (e) => XWe(e.frontend.currentAction) ? e.frontend.currentAction : null, PWe = (e) => e.frontend.currentAction, J6 = (e) => e.common.language, Er = (e) => e.common.contentLanguage, Vv = (e) => e.common.dealerData, V8t = (e) => e.common.selectedVariableId, UWe = (e) => e.common.hasVersionMismatch, E6 = (e) => e.common.focusGroupIdByInstanceId, cu = (e, t) => e.common.focusGroupIdByInstanceId[t.id], zWe = (e, t) => {
  var r;
  if (t.id === Ut.id) {
    const g = cu(e, t);
    if (g)
      return g;
  }
  const i = Br(e), n = Ns(e);
  for (const g of n) {
    const l = [...vm(i, g), g].find((a) => a.id !== Ut.id && a.instance.belongsToInstanceId === Ut.id);
    if (l)
      return (r = qr(l == null ? void 0 : l.variableId)(e)) == null ? void 0 : r.groupId;
  }
}, OWe = (e) => e.common.callIds, QWe = (e) => OWe(e).length > 0, N6 = (e) => e.common.fullScreen3DView, w8t = (e) => e.common.urlQuery;
var L6 = { exports: {} }, K6 = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RZ = De;
function jWe(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var qWe = typeof Object.is == "function" ? Object.is : jWe, _We = RZ.useSyncExternalStore, $We = RZ.useRef, eSe = RZ.useEffect, tSe = RZ.useMemo, iSe = RZ.useDebugValue;
K6.useSyncExternalStoreWithSelector = function(e, t, i, n, r) {
  var g = $We(null);
  if (g.current === null) {
    var o = { hasValue: !1, value: null };
    g.current = o;
  } else
    o = g.current;
  g = tSe(function() {
    function a(A) {
      if (!I) {
        if (I = !0, c = A, A = n(A), r !== void 0 && o.hasValue) {
          var b = o.value;
          if (r(b, A))
            return d = b;
        }
        return d = A;
      }
      if (b = d, qWe(c, A))
        return b;
      var m = n(A);
      return r !== void 0 && r(b, m) ? b : (c = A, d = m);
    }
    var I = !1, c, d, C = i === void 0 ? null : i;
    return [function() {
      return a(t());
    }, C === null ? void 0 : function() {
      return a(C());
    }];
  }, [t, i, n, r]);
  var l = _We(e, g[0], g[1]);
  return eSe(function() {
    o.hasValue = !0, o.value = l;
  }, [l]), iSe(l), l;
};
L6.exports = K6;
var nSe = L6.exports, xl = (
  // prettier-ignore
  // @ts-ignore
  "default" in X ? X.default : X
), j3 = Symbol.for("react-redux-context"), q3 = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function rSe() {
  if (!xl.createContext)
    return {};
  const e = q3[j3] ?? (q3[j3] = /* @__PURE__ */ new Map());
  let t = e.get(xl.createContext);
  return t || (t = xl.createContext(
    null
  ), e.set(xl.createContext, t)), t;
}
var iu = /* @__PURE__ */ rSe(), gSe = () => {
  throw new Error("uSES not initialized!");
};
function TJ(e = iu) {
  return function() {
    return xl.useContext(e);
  };
}
var T6 = /* @__PURE__ */ TJ(), M6 = gSe, oSe = (e) => {
  M6 = e;
}, lSe = (e, t) => e === t;
function aSe(e = iu) {
  const t = e === iu ? T6 : TJ(e), i = (n, r = {}) => {
    const { equalityFn: g = lSe, devModeChecks: o = {} } = typeof r == "function" ? { equalityFn: r } : r, {
      store: l,
      subscription: a,
      getServerState: I,
      stabilityCheck: c,
      identityFunctionCheck: d
    } = t();
    xl.useRef(!0);
    const C = xl.useCallback(
      {
        [n.name](b) {
          return n(b);
        }
      }[n.name],
      [n, c, o.stabilityCheck]
    ), A = M6(
      a.addNestedSub,
      l.getState,
      I || l.getState,
      C,
      g
    );
    return xl.useDebugValue(A), A;
  };
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
function P6(e) {
  e();
}
function sSe() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      P6(() => {
        let i = e;
        for (; i; )
          i.callback(), i = i.next;
      });
    },
    get() {
      const i = [];
      let n = e;
      for (; n; )
        i.push(n), n = n.next;
      return i;
    },
    subscribe(i) {
      let n = !0;
      const r = t = {
        callback: i,
        next: null,
        prev: t
      };
      return r.prev ? r.prev.next = r : e = r, function() {
        !n || e === null || (n = !1, r.next ? r.next.prev = r.prev : t = r.prev, r.prev ? r.prev.next = r.next : e = r.next);
      };
    }
  };
}
var _3 = {
  notify() {
  },
  get: () => []
};
function ISe(e, t) {
  let i, n = _3, r = 0, g = !1;
  function o(m) {
    c();
    const p = n.subscribe(m);
    let B = !1;
    return () => {
      B || (B = !0, p(), d());
    };
  }
  function l() {
    n.notify();
  }
  function a() {
    b.onStateChange && b.onStateChange();
  }
  function I() {
    return g;
  }
  function c() {
    r++, i || (i = e.subscribe(a), n = sSe());
  }
  function d() {
    r--, i && r === 0 && (i(), i = void 0, n.clear(), n = _3);
  }
  function C() {
    g || (g = !0, c());
  }
  function A() {
    g && (g = !1, d());
  }
  const b = {
    addNestedSub: o,
    notifyNestedSubs: l,
    handleChangeWrapper: a,
    isSubscribed: I,
    trySubscribe: C,
    tryUnsubscribe: A,
    getListeners: () => n
  };
  return b;
}
var cSe = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", dSe = typeof navigator < "u" && navigator.product === "ReactNative", uSe = cSe || dSe ? xl.useLayoutEffect : xl.useEffect;
function CSe({
  store: e,
  context: t,
  children: i,
  serverState: n,
  stabilityCheck: r = "once",
  identityFunctionCheck: g = "once"
}) {
  const o = xl.useMemo(() => {
    const I = ISe(e);
    return {
      store: e,
      subscription: I,
      getServerState: n ? () => n : void 0,
      stabilityCheck: r,
      identityFunctionCheck: g
    };
  }, [e, n, r, g]), l = xl.useMemo(() => e.getState(), [e]);
  uSe(() => {
    const { subscription: I } = o;
    return I.onStateChange = I.notifyNestedSubs, I.trySubscribe(), l !== e.getState() && I.notifyNestedSubs(), () => {
      I.tryUnsubscribe(), I.onStateChange = void 0;
    };
  }, [o, l]);
  const a = t || iu;
  return /* @__PURE__ */ xl.createElement(a.Provider, { value: o }, i);
}
var ASe = CSe;
function U6(e = iu) {
  const t = e === iu ? T6 : (
    // @ts-ignore
    TJ(e)
  ), i = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
var bSe = /* @__PURE__ */ U6();
function hSe(e = iu) {
  const t = e === iu ? bSe : U6(e), i = () => t().dispatch;
  return Object.assign(i, {
    withTypes: () => i
  }), i;
}
var v8t = P6;
oSe(nSe.useSyncExternalStoreWithSelector);
const MJ = Ua({}), Ei = hSe(MJ), mSe = aSe(MJ), ie = (e) => mSe(e, sl.enableReduxDevChecks ? void 0 : {
  devModeChecks: {
    stabilityCheck: "never",
    identityFunctionCheck: "never"
  }
});
function pSe() {
  const e = ie(QWe);
  return /* @__PURE__ */ S(zj, { loading: e });
}
var wv = {}, mY = {};
const BSe = /* @__PURE__ */ wc(Uce);
var $3;
function oo() {
  return $3 || ($3 = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = BSe;
  }(mY)), mY;
}
var fSe = yg;
Object.defineProperty(wv, "__esModule", {
  value: !0
});
var vv = wv.default = void 0, ZSe = fSe(oo()), GSe = ro;
vv = wv.default = (0, ZSe.default)(/* @__PURE__ */ (0, GSe.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
const ySe = /* @__PURE__ */ Eoe({
  __proto__: null,
  get default() {
    return vv;
  }
}, [wv]);
let WSe = { data: "" }, SSe = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || WSe, VSe = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, wSe = /\/\*[^]*?\*\/|  +/g, eT = /\n+/g, RC = (e, t) => {
  let i = "", n = "", r = "";
  for (let g in e) {
    let o = e[g];
    g[0] == "@" ? g[1] == "i" ? i = g + " " + o + ";" : n += g[1] == "f" ? RC(o, g) : g + "{" + RC(o, g[1] == "k" ? "" : t) + "}" : typeof o == "object" ? n += RC(o, t ? t.replace(/([^,])+/g, (l) => g.replace(/(^:.*)|([^,])+/g, (a) => /&/.test(a) ? a.replace(/&/g, l) : l ? l + " " + a : a)) : g) : o != null && (g = /^--/.test(g) ? g : g.replace(/[A-Z]/g, "-$&").toLowerCase(), r += RC.p ? RC.p(g, o) : g + ":" + o + ";");
  }
  return i + (t && r ? t + "{" + r + "}" : r) + n;
}, gc = {}, z6 = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let i in e)
      t += i + z6(e[i]);
    return t;
  }
  return e;
}, vSe = (e, t, i, n, r) => {
  let g = z6(e), o = gc[g] || (gc[g] = ((a) => {
    let I = 0, c = 11;
    for (; I < a.length; )
      c = 101 * c + a.charCodeAt(I++) >>> 0;
    return "go" + c;
  })(g));
  if (!gc[o]) {
    let a = g !== e ? e : ((I) => {
      let c, d, C = [{}];
      for (; c = VSe.exec(I.replace(wSe, "")); )
        c[4] ? C.shift() : c[3] ? (d = c[3].replace(eT, " ").trim(), C.unshift(C[0][d] = C[0][d] || {})) : C[0][c[1]] = c[2].replace(eT, " ").trim();
      return C[0];
    })(e);
    gc[o] = RC(r ? { ["@keyframes " + o]: a } : a, i ? "" : "." + o);
  }
  let l = i && gc.g ? gc.g : null;
  return i && (gc.g = gc[o]), ((a, I, c, d) => {
    d ? I.data = I.data.replace(d, a) : I.data.indexOf(a) === -1 && (I.data = c ? a + I.data : I.data + a);
  })(gc[o], t, n, l), o;
}, RSe = (e, t, i) => e.reduce((n, r, g) => {
  let o = t[g];
  if (o && o.call) {
    let l = o(i), a = l && l.props && l.props.className || /^go/.test(l) && l;
    o = a ? "." + a : l && typeof l == "object" ? l.props ? "" : RC(l, "") : l === !1 ? "" : l;
  }
  return n + r + (o ?? "");
}, "");
function PJ(e) {
  let t = this || {}, i = e.call ? e(t.p) : e;
  return vSe(i.unshift ? i.raw ? RSe(i, [].slice.call(arguments, 1), t.p) : i.reduce((n, r) => Object.assign(n, r && r.call ? r(t.p) : r), {}) : i, SSe(t.target), t.g, t.o, t.k);
}
PJ.bind({ g: 1 });
PJ.bind({ k: 1 });
function XSe(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function O6(e, t, i) {
  return t && XSe(e.prototype, t), e;
}
function Hn() {
  return Hn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Hn.apply(this, arguments);
}
function Q6(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function XZ(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), r, g;
  for (g = 0; g < n.length; g++)
    r = n[g], !(t.indexOf(r) >= 0) && (i[r] = e[r]);
  return i;
}
function tT(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var iT = function() {
  return "";
}, j6 = /* @__PURE__ */ De.createContext({
  enqueueSnackbar: iT,
  closeSnackbar: iT
}), ZC = {
  downXs: "@media (max-width:599.95px)",
  upSm: "@media (min-width:600px)"
}, nT = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, UJ = function(t) {
  return "" + nT(t.vertical) + nT(t.horizontal);
}, zW = function(t) {
  return !!t || t === 0;
}, OW = "unmounted", gh = "exited", oh = "entering", q0 = "entered", rT = "exiting", zJ = /* @__PURE__ */ function(e) {
  Q6(t, e);
  function t(n) {
    var r;
    r = e.call(this, n) || this;
    var g = n.appear, o;
    return r.appearStatus = null, n.in ? g ? (o = gh, r.appearStatus = oh) : o = q0 : n.unmountOnExit || n.mountOnEnter ? o = OW : o = gh, r.state = {
      status: o
    }, r.nextCallback = null, r;
  }
  t.getDerivedStateFromProps = function(r, g) {
    var o = r.in;
    return o && g.status === OW ? {
      status: gh
    } : null;
  };
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, i.componentDidUpdate = function(r) {
    var g = null;
    if (r !== this.props) {
      var o = this.state.status;
      this.props.in ? o !== oh && o !== q0 && (g = oh) : (o === oh || o === q0) && (g = rT);
    }
    this.updateStatus(!1, g);
  }, i.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, i.getTimeouts = function() {
    var r = this.props.timeout, g = r, o = r;
    return r != null && typeof r != "number" && typeof r != "string" && (o = r.exit, g = r.enter), {
      exit: o,
      enter: g
    };
  }, i.updateStatus = function(r, g) {
    r === void 0 && (r = !1), g !== null ? (this.cancelNextCallback(), g === oh ? this.performEnter(r) : this.performExit()) : this.props.unmountOnExit && this.state.status === gh && this.setState({
      status: OW
    });
  }, i.performEnter = function(r) {
    var g = this, o = this.props.enter, l = r, a = this.getTimeouts();
    if (!r && !o) {
      this.safeSetState({
        status: q0
      }, function() {
        g.props.onEntered && g.props.onEntered(g.node, l);
      });
      return;
    }
    this.props.onEnter && this.props.onEnter(this.node, l), this.safeSetState({
      status: oh
    }, function() {
      g.props.onEntering && g.props.onEntering(g.node, l), g.onTransitionEnd(a.enter, function() {
        g.safeSetState({
          status: q0
        }, function() {
          g.props.onEntered && g.props.onEntered(g.node, l);
        });
      });
    });
  }, i.performExit = function() {
    var r = this, g = this.props.exit, o = this.getTimeouts();
    if (!g) {
      this.safeSetState({
        status: gh
      }, function() {
        r.props.onExited && r.props.onExited(r.node);
      });
      return;
    }
    this.props.onExit && this.props.onExit(this.node), this.safeSetState({
      status: rT
    }, function() {
      r.props.onExiting && r.props.onExiting(r.node), r.onTransitionEnd(o.exit, function() {
        r.safeSetState({
          status: gh
        }, function() {
          r.props.onExited && r.props.onExited(r.node);
        });
      });
    });
  }, i.cancelNextCallback = function() {
    this.nextCallback !== null && this.nextCallback.cancel && (this.nextCallback.cancel(), this.nextCallback = null);
  }, i.safeSetState = function(r, g) {
    g = this.setNextCallback(g), this.setState(r, g);
  }, i.setNextCallback = function(r) {
    var g = this, o = !0;
    return this.nextCallback = function() {
      o && (o = !1, g.nextCallback = null, r());
    }, this.nextCallback.cancel = function() {
      o = !1;
    }, this.nextCallback;
  }, i.onTransitionEnd = function(r, g) {
    this.setNextCallback(g);
    var o = r == null && !this.props.addEndListener;
    if (!this.node || o) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    this.props.addEndListener && this.props.addEndListener(this.node, this.nextCallback), r != null && setTimeout(this.nextCallback, r);
  }, i.render = function() {
    var r = this.state.status;
    if (r === OW)
      return null;
    var g = this.props, o = g.children, l = XZ(g, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return o(r, l);
  }, O6(t, [{
    key: "node",
    get: function() {
      var r, g = (r = this.props.nodeRef) === null || r === void 0 ? void 0 : r.current;
      if (!g)
        throw new Error("notistack - Custom snackbar is not refForwarding");
      return g;
    }
  }]), t;
}(De.Component);
function lh() {
}
zJ.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: lh,
  onEntering: lh,
  onEntered: lh,
  onExit: lh,
  onExiting: lh,
  onExited: lh
};
function gT(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function xx(e, t) {
  return Oe(function() {
    return e == null && t == null ? null : function(i) {
      gT(e, i), gT(t, i);
    };
  }, [e, t]);
}
function uw(e) {
  var t = e.timeout, i = e.style, n = i === void 0 ? {} : i, r = e.mode;
  return {
    duration: typeof t == "object" ? t[r] || 0 : t,
    easing: n.transitionTimingFunction,
    delay: n.transitionDelay
  };
}
var Dx = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, q6 = function(t) {
  t.scrollTop = t.scrollTop;
}, oT = function(t) {
  return Math.round(t) + "ms";
};
function Eh(e, t) {
  e === void 0 && (e = ["all"]);
  var i = t || {}, n = i.duration, r = n === void 0 ? 300 : n, g = i.easing, o = g === void 0 ? Dx.easeInOut : g, l = i.delay, a = l === void 0 ? 0 : l, I = Array.isArray(e) ? e : [e];
  return I.map(function(c) {
    var d = typeof r == "string" ? r : oT(r), C = typeof a == "string" ? a : oT(a);
    return c + " " + d + " " + o + " " + C;
  }).join(",");
}
function HSe(e) {
  return e && e.ownerDocument || document;
}
function _6(e) {
  var t = HSe(e);
  return t.defaultView || window;
}
function kSe(e, t) {
  t === void 0 && (t = 166);
  var i;
  function n() {
    for (var r = this, g = arguments.length, o = new Array(g), l = 0; l < g; l++)
      o[l] = arguments[l];
    var a = function() {
      e.apply(r, o);
    };
    clearTimeout(i), i = setTimeout(a, t);
  }
  return n.clear = function() {
    clearTimeout(i);
  }, n;
}
function YSe(e, t) {
  var i = t.getBoundingClientRect(), n = _6(t), r;
  if (t.fakeTransform)
    r = t.fakeTransform;
  else {
    var g = n.getComputedStyle(t);
    r = g.getPropertyValue("-webkit-transform") || g.getPropertyValue("transform");
  }
  var o = 0, l = 0;
  if (r && r !== "none" && typeof r == "string") {
    var a = r.split("(")[1].split(")")[0].split(",");
    o = parseInt(a[4], 10), l = parseInt(a[5], 10);
  }
  switch (e) {
    case "left":
      return "translateX(" + (n.innerWidth + o - i.left) + "px)";
    case "right":
      return "translateX(-" + (i.left + i.width - o) + "px)";
    case "up":
      return "translateY(" + (n.innerHeight + l - i.top) + "px)";
    default:
      return "translateY(-" + (i.top + i.height - l) + "px)";
  }
}
function QW(e, t) {
  if (t) {
    var i = YSe(e, t);
    i && (t.style.webkitTransform = i, t.style.transform = i);
  }
}
var $6 = /* @__PURE__ */ dl(function(e, t) {
  var i = e.children, n = e.direction, r = n === void 0 ? "down" : n, g = e.in, o = e.style, l = e.timeout, a = l === void 0 ? 0 : l, I = e.onEnter, c = e.onEntered, d = e.onExit, C = e.onExited, A = XZ(e, ["children", "direction", "in", "style", "timeout", "onEnter", "onEntered", "onExit", "onExited"]), b = ot(null), m = xx(i.ref, b), p = xx(m, t), B = function(w, v) {
    QW(r, w), q6(w), I && I(w, v);
  }, f = function(w) {
    var v = (o == null ? void 0 : o.transitionTimingFunction) || Dx.easeOut, H = uw({
      timeout: a,
      mode: "enter",
      style: Hn({}, o, {
        transitionTimingFunction: v
      })
    });
    w.style.webkitTransition = Eh("-webkit-transform", H), w.style.transition = Eh("transform", H), w.style.webkitTransform = "none", w.style.transform = "none";
  }, Z = function(w) {
    var v = (o == null ? void 0 : o.transitionTimingFunction) || Dx.sharp, H = uw({
      timeout: a,
      mode: "exit",
      style: Hn({}, o, {
        transitionTimingFunction: v
      })
    });
    w.style.webkitTransition = Eh("-webkit-transform", H), w.style.transition = Eh("transform", H), QW(r, w), d && d(w);
  }, y = function(w) {
    w.style.webkitTransition = "", w.style.transition = "", C && C(w);
  }, W = Gt(function() {
    b.current && QW(r, b.current);
  }, [r]);
  return lt(function() {
    if (!(g || r === "down" || r === "right")) {
      var V = kSe(function() {
        b.current && QW(r, b.current);
      }), w = _6(b.current);
      return w.addEventListener("resize", V), function() {
        V.clear(), w.removeEventListener("resize", V);
      };
    }
  }, [r, g]), lt(function() {
    g || W();
  }, [g, W]), PC(zJ, Object.assign({
    appear: !0,
    nodeRef: b,
    onEnter: B,
    onEntered: c,
    onEntering: f,
    onExit: Z,
    onExited: y,
    in: g,
    timeout: a
  }, A), function(V, w) {
    return Jd(i, Hn({
      ref: p,
      style: Hn({
        visibility: V === "exited" && !g ? "hidden" : void 0
      }, o, {}, i.props.style)
    }, w));
  });
});
$6.displayName = "Slide";
var Rv = function(t) {
  return De.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    focusable: "false",
    style: {
      fontSize: 20,
      marginInlineEnd: 8,
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0
    }
  }, t));
}, FSe = function() {
  return De.createElement(Rv, null, De.createElement("path", {
    d: `M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41
        10.59L10 14.17L17.59 6.58L19 8L10 17Z`
  }));
}, xSe = function() {
  return De.createElement(Rv, null, De.createElement("path", {
    d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
  }));
}, DSe = function() {
  return De.createElement(Rv, null, De.createElement("path", {
    d: `M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,
        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,
        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z`
  }));
}, JSe = function() {
  return De.createElement(Rv, null, De.createElement("path", {
    d: `M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,
        0 22,12A10,10 0 0,0 12,2Z`
  }));
}, ESe = {
  default: void 0,
  success: /* @__PURE__ */ De.createElement(FSe, null),
  warning: /* @__PURE__ */ De.createElement(xSe, null),
  error: /* @__PURE__ */ De.createElement(DSe, null),
  info: /* @__PURE__ */ De.createElement(JSe, null)
}, zC = {
  maxSnack: 3,
  persist: !1,
  hideIconVariant: !1,
  disableWindowBlurListener: !1,
  variant: "default",
  autoHideDuration: 5e3,
  iconVariant: ESe,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  TransitionComponent: $6,
  transitionDuration: {
    enter: 225,
    exit: 195
  }
}, NSe = function(t, i) {
  var n = function(g) {
    return typeof g == "number" || g === null;
  };
  return n(t) ? t : n(i) ? i : zC.autoHideDuration;
}, LSe = function(t, i) {
  var n = function(g, o) {
    return o.some(function(l) {
      return typeof g === l;
    });
  };
  return n(t, ["string", "number"]) ? t : n(t, ["object"]) ? Hn({}, zC.transitionDuration, {}, n(i, ["object"]) && i, {}, t) : n(i, ["string", "number"]) ? i : n(i, ["object"]) ? Hn({}, zC.transitionDuration, {}, i) : zC.transitionDuration;
}, KSe = function(t, i) {
  return function(n, r) {
    return r === void 0 && (r = !1), r ? Hn({}, zC[n], {}, i[n], {}, t[n]) : n === "autoHideDuration" ? NSe(t.autoHideDuration, i.autoHideDuration) : n === "transitionDuration" ? LSe(t.transitionDuration, i.transitionDuration) : t[n] || i[n] || zC[n];
  };
};
function HZ(e) {
  return Object.entries(e).reduce(function(t, i) {
    var n, r = i[0], g = i[1];
    return Hn({}, t, (n = {}, n[r] = PJ(g), n));
  }, {});
}
var sm = {
  SnackbarContainer: "notistack-SnackbarContainer",
  Snackbar: "notistack-Snackbar",
  CollapseWrapper: "notistack-CollapseWrapper",
  MuiContent: "notistack-MuiContent",
  MuiContentVariant: function(t) {
    return "notistack-MuiContent-" + t;
  }
}, lT = /* @__PURE__ */ HZ({
  root: {
    height: 0
  },
  entered: {
    height: "auto"
  }
}), pY = "0px", BY = 175, e7 = /* @__PURE__ */ dl(function(e, t) {
  var i = e.children, n = e.in, r = e.onExited, g = ot(null), o = ot(null), l = xx(t, o), a = function() {
    return g.current ? g.current.clientHeight : 0;
  }, I = function(m) {
    m.style.height = pY;
  }, c = function(m) {
    var p = a(), B = uw({
      timeout: BY,
      mode: "enter"
    }), f = B.duration, Z = B.easing;
    m.style.transitionDuration = typeof f == "string" ? f : f + "ms", m.style.height = p + "px", m.style.transitionTimingFunction = Z || "";
  }, d = function(m) {
    m.style.height = "auto";
  }, C = function(m) {
    m.style.height = a() + "px";
  }, A = function(m) {
    q6(m);
    var p = uw({
      timeout: BY,
      mode: "exit"
    }), B = p.duration, f = p.easing;
    m.style.transitionDuration = typeof B == "string" ? B : B + "ms", m.style.height = pY, m.style.transitionTimingFunction = f || "";
  };
  return PC(zJ, {
    in: n,
    unmountOnExit: !0,
    onEnter: I,
    onEntered: d,
    onEntering: c,
    onExit: C,
    onExited: r,
    onExiting: A,
    nodeRef: o,
    timeout: BY
  }, function(b, m) {
    return PC("div", Object.assign({
      ref: l,
      className: Ag(lT.root, b === "entered" && lT.entered),
      style: Hn({
        pointerEvents: "all",
        overflow: "hidden",
        minHeight: pY,
        transition: Eh("height")
      }, b === "entered" && {
        overflow: "visible"
      }, {}, b === "exited" && !n && {
        visibility: "hidden"
      })
    }, m), PC("div", {
      ref: g,
      className: sm.CollapseWrapper,
      // Hack to get children with a negative margin to not falsify the height computation.
      style: {
        display: "flex",
        width: "100%"
      }
    }, i));
  });
});
e7.displayName = "Collapse";
var aT = {
  right: "left",
  left: "right",
  bottom: "up",
  top: "down"
}, TSe = function(t) {
  return t.horizontal !== "center" ? aT[t.horizontal] : aT[t.vertical];
}, MSe = function(t) {
  return "anchorOrigin" + UJ(t);
}, PSe = function(t) {
  t === void 0 && (t = {});
  var i = {
    containerRoot: !0,
    containerAnchorOriginTopCenter: !0,
    containerAnchorOriginBottomCenter: !0,
    containerAnchorOriginTopRight: !0,
    containerAnchorOriginBottomRight: !0,
    containerAnchorOriginTopLeft: !0,
    containerAnchorOriginBottomLeft: !0
  };
  return Object.keys(t).filter(function(n) {
    return !i[n];
  }).reduce(function(n, r) {
    var g;
    return Hn({}, n, (g = {}, g[r] = t[r], g));
  }, {});
}, USe = function() {
};
function jB(e, t) {
  return e.reduce(function(i, n) {
    return n == null ? i : function() {
      for (var g = arguments.length, o = new Array(g), l = 0; l < g; l++)
        o[l] = arguments[l];
      var a = [].concat(o);
      t && a.indexOf(t) === -1 && a.push(t), i.apply(this, a), n.apply(this, a);
    };
  }, USe);
}
var zSe = typeof window < "u" ? lZ : lt;
function sT(e) {
  var t = ot(e);
  return zSe(function() {
    t.current = e;
  }), Gt(function() {
    return (
      // @ts-expect-error hide `this`
      t.current.apply(void 0, arguments)
    );
  }, []);
}
var t7 = /* @__PURE__ */ dl(function(e, t) {
  var i = e.children, n = e.className, r = e.autoHideDuration, g = e.disableWindowBlurListener, o = g === void 0 ? !1 : g, l = e.onClose, a = e.id, I = e.open, c = e.SnackbarProps, d = c === void 0 ? {} : c, C = ot(), A = sT(function() {
    l && l.apply(void 0, arguments);
  }), b = sT(function(Z) {
    !l || Z == null || (C.current && clearTimeout(C.current), C.current = setTimeout(function() {
      A(null, "timeout", a);
    }, Z));
  });
  lt(function() {
    return I && b(r), function() {
      C.current && clearTimeout(C.current);
    };
  }, [I, r, b]);
  var m = function() {
    C.current && clearTimeout(C.current);
  }, p = Gt(function() {
    r != null && b(r * 0.5);
  }, [r, b]), B = function(y) {
    d.onMouseEnter && d.onMouseEnter(y), m();
  }, f = function(y) {
    d.onMouseLeave && d.onMouseLeave(y), p();
  };
  return lt(function() {
    if (!o && I)
      return window.addEventListener("focus", p), window.addEventListener("blur", m), function() {
        window.removeEventListener("focus", p), window.removeEventListener("blur", m);
      };
  }, [o, p, I]), PC("div", Object.assign({
    ref: t
  }, d, {
    className: Ag(sm.Snackbar, n),
    onMouseEnter: B,
    onMouseLeave: f
  }), i);
});
t7.displayName = "Snackbar";
var fY, OSe = /* @__PURE__ */ HZ({
  root: (fY = {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1
  }, fY[ZC.upSm] = {
    flexGrow: "initial",
    minWidth: "288px"
  }, fY)
}), i7 = /* @__PURE__ */ dl(function(e, t) {
  var i = e.className, n = XZ(e, ["className"]);
  return De.createElement("div", Object.assign({
    ref: t,
    className: Ag(OSe.root, i)
  }, n));
});
i7.displayName = "SnackbarContent";
var _0 = /* @__PURE__ */ HZ({
  root: {
    backgroundColor: "#313131",
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
  },
  lessPadding: {
    paddingLeft: 8 * 2.5 + "px"
  },
  default: {
    backgroundColor: "#313131"
  },
  success: {
    backgroundColor: "#43a047"
  },
  error: {
    backgroundColor: "#d32f2f"
  },
  warning: {
    backgroundColor: "#ff9800"
  },
  info: {
    backgroundColor: "#2196f3"
  },
  message: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0"
  },
  action: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: "16px",
    marginRight: "-8px"
  }
}), IT = "notistack-snackbar", n7 = /* @__PURE__ */ dl(function(e, t) {
  var i = e.id, n = e.message, r = e.action, g = e.iconVariant, o = e.variant, l = e.hideIconVariant, a = e.style, I = e.className, c = g[o], d = r;
  return typeof d == "function" && (d = d(i)), De.createElement(i7, {
    ref: t,
    role: "alert",
    "aria-describedby": IT,
    style: a,
    className: Ag(sm.MuiContent, sm.MuiContentVariant(o), _0.root, _0[o], I, !l && c && _0.lessPadding)
  }, De.createElement("div", {
    id: IT,
    className: _0.message
  }, l ? null : c, n), d && De.createElement("div", {
    className: _0.action
  }, d));
});
n7.displayName = "MaterialDesignContent";
var QSe = /* @__PURE__ */ Bm(n7), jSe = /* @__PURE__ */ HZ({
  wrappedRoot: {
    width: "100%",
    position: "relative",
    transform: "translateX(0)",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    minWidth: "288px"
  }
}), qSe = function(t) {
  var i = ot(), n = wt(!0), r = n[0], g = n[1], o = jB([t.snack.onClose, t.onClose]), l = function() {
    t.snack.requestClose && o(null, "instructed", t.snack.id);
  }, a = Gt(function() {
    i.current = setTimeout(function() {
      g(function(H) {
        return !H;
      });
    }, 125);
  }, []);
  lt(function() {
    return function() {
      i.current && clearTimeout(i.current);
    };
  }, []);
  var I = t.snack, c = t.classes, d = t.Component, C = d === void 0 ? QSe : d, A = Oe(function() {
    return PSe(c);
  }, [c]), b = I.open, m = I.SnackbarProps, p = I.TransitionComponent, B = I.TransitionProps, f = I.transitionDuration, Z = I.disableWindowBlurListener, y = I.content, W = XZ(I, ["open", "SnackbarProps", "TransitionComponent", "TransitionProps", "transitionDuration", "disableWindowBlurListener", "content", "entered", "requestClose", "onEnter", "onEntered", "onExit", "onExited"]), V = Hn({
    direction: TSe(W.anchorOrigin),
    timeout: f
  }, B), w = y;
  typeof w == "function" && (w = w(W.id, W.message));
  var v = ["onEnter", "onEntered", "onExit", "onExited"].reduce(function(H, x) {
    var J;
    return Hn({}, H, (J = {}, J[x] = jB([t.snack[x], t[x]], W.id), J));
  }, {});
  return De.createElement(e7, {
    in: r,
    onExited: v.onExited
  }, De.createElement(t7, {
    open: b,
    id: W.id,
    disableWindowBlurListener: Z,
    autoHideDuration: W.autoHideDuration,
    className: Ag(jSe.wrappedRoot, A.root, A[MSe(W.anchorOrigin)]),
    SnackbarProps: m,
    onClose: o
  }, De.createElement(p, Object.assign({}, V, {
    appear: !0,
    in: b,
    onExit: v.onExit,
    onExited: a,
    onEnter: v.onEnter,
    // order matters. first callbacks.onEntered to set entered: true,
    // then handleEntered to check if there's a request for closing
    onEntered: jB([v.onEntered, l], W.id)
  }), w || De.createElement(C, Object.assign({}, W)))));
}, $0, ZY, jW, qW, GY, oc = {
  view: {
    default: 20,
    dense: 4
  },
  snackbar: {
    default: 6,
    dense: 2
  }
}, cT = "." + sm.CollapseWrapper, yY = 16, _W = /* @__PURE__ */ HZ({
  root: ($0 = {
    boxSizing: "border-box",
    display: "flex",
    maxHeight: "100%",
    position: "fixed",
    zIndex: 1400,
    height: "auto",
    width: "auto",
    transition: /* @__PURE__ */ Eh(["top", "right", "bottom", "left", "max-width"], {
      duration: 300,
      easing: "ease"
    }),
    // container itself is invisible and should not block clicks, clicks should be passed to its children
    // a pointerEvents: all is applied in the collapse component
    pointerEvents: "none"
  }, $0[cT] = {
    padding: oc.snackbar.default + "px 0px",
    transition: "padding 300ms ease 0ms"
  }, $0.maxWidth = "calc(100% - " + oc.view.default * 2 + "px)", $0[ZC.downXs] = {
    width: "100%",
    maxWidth: "calc(100% - " + yY * 2 + "px)"
  }, $0),
  rootDense: (ZY = {}, ZY[cT] = {
    padding: oc.snackbar.dense + "px 0px"
  }, ZY),
  top: {
    top: oc.view.default - oc.snackbar.default + "px",
    flexDirection: "column"
  },
  bottom: {
    bottom: oc.view.default - oc.snackbar.default + "px",
    flexDirection: "column-reverse"
  },
  left: (jW = {
    left: oc.view.default + "px"
  }, jW[ZC.upSm] = {
    alignItems: "flex-start"
  }, jW[ZC.downXs] = {
    left: yY + "px"
  }, jW),
  right: (qW = {
    right: oc.view.default + "px"
  }, qW[ZC.upSm] = {
    alignItems: "flex-end"
  }, qW[ZC.downXs] = {
    right: yY + "px"
  }, qW),
  center: (GY = {
    left: "50%",
    transform: "translateX(-50%)"
  }, GY[ZC.upSm] = {
    alignItems: "center"
  }, GY)
}), _Se = function(t) {
  var i = t.classes, n = i === void 0 ? {} : i, r = t.anchorOrigin, g = t.dense, o = t.children, l = Ag(
    sm.SnackbarContainer,
    _W[r.vertical],
    _W[r.horizontal],
    _W.root,
    // root should come after others to override maxWidth
    n.containerRoot,
    n["containerAnchorOrigin" + UJ(r)],
    g && _W.rootDense
  );
  return De.createElement("div", {
    className: l
  }, o);
}, $Se = /* @__PURE__ */ Bm(_Se), dT = function(t) {
  var i = typeof t == "string" || KB(t);
  return !i;
}, kZ, OJ, eVe = /* @__PURE__ */ function(e) {
  Q6(t, e);
  function t(n) {
    var r;
    return r = e.call(this, n) || this, r.enqueueSnackbar = function(g, o) {
      if (o === void 0 && (o = {}), g == null)
        throw new Error("enqueueSnackbar called with invalid argument");
      var l = dT(g) ? g : o, a = dT(g) ? g.message : g, I = l.key, c = l.preventDuplicate, d = XZ(l, ["key", "preventDuplicate"]), C = zW(I), A = C ? I : (/* @__PURE__ */ new Date()).getTime() + Math.random(), b = KSe(d, r.props), m = Hn({
        id: A
      }, d, {
        message: a,
        open: !0,
        entered: !1,
        requestClose: !1,
        persist: b("persist"),
        action: b("action"),
        content: b("content"),
        variant: b("variant"),
        anchorOrigin: b("anchorOrigin"),
        disableWindowBlurListener: b("disableWindowBlurListener"),
        autoHideDuration: b("autoHideDuration"),
        hideIconVariant: b("hideIconVariant"),
        TransitionComponent: b("TransitionComponent"),
        transitionDuration: b("transitionDuration"),
        TransitionProps: b("TransitionProps", !0),
        iconVariant: b("iconVariant", !0),
        style: b("style", !0),
        SnackbarProps: b("SnackbarProps", !0),
        className: Ag(r.props.className, d.className)
      });
      return m.persist && (m.autoHideDuration = void 0), r.setState(function(p) {
        if (c === void 0 && r.props.preventDuplicate || c) {
          var B = function(W) {
            return C ? W.id === A : W.message === a;
          }, f = p.queue.findIndex(B) > -1, Z = p.snacks.findIndex(B) > -1;
          if (f || Z)
            return p;
        }
        return r.handleDisplaySnack(Hn({}, p, {
          queue: [].concat(p.queue, [m])
        }));
      }), A;
    }, r.handleDisplaySnack = function(g) {
      var o = g.snacks;
      return o.length >= r.maxSnack ? r.handleDismissOldest(g) : r.processQueue(g);
    }, r.processQueue = function(g) {
      var o = g.queue, l = g.snacks;
      return o.length > 0 ? Hn({}, g, {
        snacks: [].concat(l, [o[0]]),
        queue: o.slice(1, o.length)
      }) : g;
    }, r.handleDismissOldest = function(g) {
      if (g.snacks.some(function(c) {
        return !c.open || c.requestClose;
      }))
        return g;
      var o = !1, l = !1, a = g.snacks.reduce(function(c, d) {
        return c + (d.open && d.persist ? 1 : 0);
      }, 0);
      a === r.maxSnack && (l = !0);
      var I = g.snacks.map(function(c) {
        return !o && (!c.persist || l) ? (o = !0, c.entered ? (c.onClose && c.onClose(null, "maxsnack", c.id), r.props.onClose && r.props.onClose(null, "maxsnack", c.id), Hn({}, c, {
          open: !1
        })) : Hn({}, c, {
          requestClose: !0
        })) : Hn({}, c);
      });
      return Hn({}, g, {
        snacks: I
      });
    }, r.handleEnteredSnack = function(g, o, l) {
      if (!zW(l))
        throw new Error("handleEnteredSnack Cannot be called with undefined key");
      r.setState(function(a) {
        var I = a.snacks;
        return {
          snacks: I.map(function(c) {
            return c.id === l ? Hn({}, c, {
              entered: !0
            }) : Hn({}, c);
          })
        };
      });
    }, r.handleCloseSnack = function(g, o, l) {
      r.props.onClose && r.props.onClose(g, o, l);
      var a = l === void 0;
      r.setState(function(I) {
        var c = I.snacks, d = I.queue;
        return {
          snacks: c.map(function(C) {
            return !a && C.id !== l ? Hn({}, C) : C.entered ? Hn({}, C, {
              open: !1
            }) : Hn({}, C, {
              requestClose: !0
            });
          }),
          queue: d.filter(function(C) {
            return C.id !== l;
          })
        };
      });
    }, r.closeSnackbar = function(g) {
      var o = r.state.snacks.find(function(l) {
        return l.id === g;
      });
      zW(g) && o && o.onClose && o.onClose(null, "instructed", g), r.handleCloseSnack(null, "instructed", g);
    }, r.handleExitedSnack = function(g, o) {
      if (!zW(o))
        throw new Error("handleExitedSnack Cannot be called with undefined key");
      r.setState(function(l) {
        var a = r.processQueue(Hn({}, l, {
          snacks: l.snacks.filter(function(I) {
            return I.id !== o;
          })
        }));
        return a.queue.length === 0 ? a : r.handleDismissOldest(a);
      });
    }, kZ = r.enqueueSnackbar, OJ = r.closeSnackbar, r.state = {
      snacks: [],
      queue: [],
      contextValue: {
        enqueueSnackbar: r.enqueueSnackbar.bind(tT(r)),
        closeSnackbar: r.closeSnackbar.bind(tT(r))
      }
    }, r;
  }
  var i = t.prototype;
  return i.render = function() {
    var r = this, g = this.state.contextValue, o = this.props, l = o.domRoot, a = o.children, I = o.dense, c = I === void 0 ? !1 : I, d = o.Components, C = d === void 0 ? {} : d, A = o.classes, b = this.state.snacks.reduce(function(p, B) {
      var f, Z = UJ(B.anchorOrigin), y = p[Z] || [];
      return Hn({}, p, (f = {}, f[Z] = [].concat(y, [B]), f));
    }, {}), m = Object.keys(b).map(function(p) {
      var B = b[p], f = B[0];
      return De.createElement($Se, {
        key: p,
        dense: c,
        anchorOrigin: f.anchorOrigin,
        classes: A
      }, B.map(function(Z) {
        return De.createElement(qSe, {
          key: Z.id,
          snack: Z,
          classes: A,
          Component: C[Z.variant],
          onClose: r.handleCloseSnack,
          onEnter: r.props.onEnter,
          onExit: r.props.onExit,
          onExited: jB([r.handleExitedSnack, r.props.onExited], Z.id),
          onEntered: jB([r.handleEnteredSnack, r.props.onEntered], Z.id)
        });
      }));
    });
    return De.createElement(j6.Provider, {
      value: g
    }, a, l ? Z4(m, l) : m);
  }, O6(t, [{
    key: "maxSnack",
    get: function() {
      return this.props.maxSnack || zC.maxSnack;
    }
  }]), t;
}(Coe), tVe = function() {
  return Vn(j6);
};
const r7 = ({
  messageKey: e,
  onClose: t
}) => /* @__PURE__ */ S(Ni, { size: "small", "aria-label": "Close", color: "inherit", "data-cy": "close-snackbar", onClick: () => {
  OJ(e), t == null || t();
}, children: /* @__PURE__ */ S(vv, { fontSize: "small" }) }), R8t = (e) => {
  const {
    enqueueSnackbar: t,
    closeSnackbar: i
  } = tVe();
  return lt(() => {
    e.open ? t(e.message ? /* @__PURE__ */ S(Ct, { children: e.message }) : e.children, {
      variant: e.variant,
      autoHideDuration: e.autoHideDuration || null,
      preventDuplicate: e.preventDuplicate || !0,
      key: e.messageKey,
      action: (n) => /* @__PURE__ */ Ie(li, { children: [
        e.action,
        e.canClose && /* @__PURE__ */ S(r7, { messageKey: n, onClose: () => {
          var r;
          return (r = e.onClose) == null ? void 0 : r.call(e);
        } })
      ] })
    }) : i(e.messageKey);
  }, [e.open]), /* @__PURE__ */ S(li, {});
}, QJ = De.createContext({
  extensions: {},
  contexts: []
}), Xv = () => Vn(QJ), X8t = (e) => /* @__PURE__ */ S(QJ.Provider, { value: {
  extensions: e.extensions,
  additionalDynamicSettings: e.additionalDynamicSettings,
  contexts: e.contexts || []
}, children: e.children }), iVe = "Mandant", nVe = "Produkt", rVe = "Bezahlzustand", gVe = "Mandanten", oVe = "Admin", lVe = "Konfiguratoren", aVe = "Erstellen", sVe = "Importieren", IVe = "Benutzer", cVe = "Support", dVe = "Logs", uVe = "Systemstatus", CVe = "Papierkorb", AVe = "Abonnement", bVe = "Ausgelaufen", hVe = "Profil", mVe = "Konfigurationen", pVe = "Konfiguratoren", BVe = "Support", fVe = "Händler", ZVe = "Benutzer", GVe = "Papierkorb", yVe = "Hilfe", WVe = "Abonnement", SVe = "Profil", VVe = "Abmelden", wVe = "Template", vVe = "Aufrufen", RVe = "PDF", XVe = "Code", HVe = "Preis", kVe = "Inspiration", YVe = "Aktion", FVe = "Sprache", xVe = "Kunde", DVe = "Inhalt", JVe = "Konfiguratorversion", EVe = "Abbrechen", NVe = "Schliessen", LVe = "Feld", KVe = "Bearbeiten", TVe = "Adresse", MVe = "Datenschutz", PVe = "Name", UVe = "Email", zVe = "Telefon", OVe = "Bemerkung", QVe = "Firma", jVe = "Akzeptiert", qVe = "Stadt", _Ve = "Postleitzahl", $Ve = "Land", ewe = "Datum", twe = "Händler", iwe = "json", nwe = "Preis", rwe = "Optionen", gwe = "Bestellaktion", owe = "Typ", lwe = "Konfiguration", awe = "AR", swe = "Geteilt", Iwe = "anzeigen", cwe = "Sortierung", dwe = "Artikelnummer", uwe = "Beschreibung", Cwe = "Kategorie", Awe = "Preise", bwe = "Artikel", hwe = "Wechseln", mwe = "Upload", pwe = "Keine", Bwe = "Alle", fwe = "Bilder", Zwe = "Rauheit", Gwe = "Metallhaltigkeit", ywe = "Transparenz", Wwe = "Deckkraft", Swe = "Farbe", Vwe = "Emission", wwe = "Seite", vwe = "Vorderseite", Rwe = "Hinterseite", Xwe = "Beidseitig", Hwe = "Transmission", kwe = "Reflektivität", Ywe = "Klarlack", Fwe = "Optionen", xwe = "Bezeichnung", Dwe = "Physikalisch basiertes Rendering (PBR)", Jwe = "Physikalisch", Ewe = "Key", Nwe = "Model", Lwe = "Erweitert", Kwe = "Editieren", Twe = "Kopieren", Mwe = "Export", Pwe = "Produktdarstellung", Uwe = "Hauptmodell", zwe = "Upgrade", Owe = "Vorlage", Qwe = "Tutorial", jwe = "Tracking", qwe = "share", _we = "Merkmale", $we = "Abschlag", e2e = "Aufschlag", t2e = "Speichern", i2e = "Einbetten", n2e = "Referenzsprache", r2e = "Sprachen", g2e = "Schriftart", o2e = "Helvetica", l2e = "Courier", a2e = "Interstate", s2e = "Montserrat", I2e = "Links", c2e = "Rechts", d2e = "Oben", u2e = "Unten", C2e = "Kopfzeile", A2e = "Allgemein", b2e = "Mail", h2e = "Shop", m2e = "Verlassen", p2e = "Senden", B2e = "Bestellungen", f2e = "Datum", Z2e = "Tage", G2e = "Artikel Name", y2e = "Artikel", W2e = "Konfigurator", S2e = "Partner", V2e = "Provision", w2e = "Name", v2e = "E-Mail", R2e = "Nutzerkonto", X2e = "Nutzername", H2e = "Kennwort", k2e = "Anmelden", Y2e = "Registrierung", F2e = "Datenschutzbestimmungen", x2e = "AGB", D2e = "Passwort", J2e = "Editor", E2e = "Standard", N2e = "Von", L2e = "Version", K2e = "Buchungen", T2e = "Plattform", M2e = "Intervall", P2e = "Subscription", U2e = "CustomerID", z2e = "Aktiv", O2e = "Seit", Q2e = "Query", j2e = "Aktionen", q2e = "Buchung", _2e = "Monat", $2e = "Jahr", eve = "Bis", tve = "Parameter", ive = "Kunden", nve = "ID", rve = "Rechnungen", gve = "Leer", ove = "Nutzer", lve = "Rolle", ave = "Schritte", sve = "Werte", Ive = "Regeln", cve = "Regelzeilen", dve = "Modelle", uve = "Materialien", Cve = "Merkmal", Ave = "Regel", bve = "Nummer", hve = "Status", mve = "Erstellt", pve = "Kennwort", Bve = "Neu", fve = "Eingabe", Zve = "Einladen", Gve = "Download", yve = "Hintergrundmodell", Wve = "Favoriten", Sve = "Anlegen", Vve = "Preiseinstellungen", wve = "Hauptaktion", vve = "Kontaktformular", Rve = "Pflichtfeld", Xve = "Aktionsname", Hve = "Anzahl", kve = "Anzahlberechnung", Yve = "Mengenberechnung", Fve = "Artikelaktion", xve = "Zahl", Dve = "Einheit", Jve = "Kamera", Eve = "Schritt", Nve = "Kameraansicht", Lve = "Kameratyp", Kve = "Perspektive", Tve = "Orthographisch", Mve = "Fokustyp", Pve = "Duplizieren", Uve = "Entfernen", zve = "Kameras", Ove = "Schnittstellen", Qve = "Kostenfrei", jve = "pro", qve = "Downgrade", _ve = "Monatlich", $ve = "Home", e1e = "Hilfe", t1e = "Abbrechen", i1e = "DSGVO", n1e = "Icon", r1e = "Logo", g1e = "Farben", o1e = "CSS", l1e = "Einstellungen", a1e = "Vorschau", s1e = "Artikel", I1e = "Bestellungen", c1e = "Statistics", d1e = "Fehler", u1e = "Leider ist ein unbekannter Fehler aufgetreten. Falls sich das Problem mit einem Neuladen der Seite nicht beheben lässt, kontaktieren Sie uns bitte.", C1e = "Unbekannter Fehler", A1e = "Fehlernachricht:", b1e = "Hauptabschluss", h1e = "Abschluss", m1e = "Bestelloptionen", p1e = "Dieser Schritt ist aktuell nur im Admin-Panel sichtbar, da er keine Merkmale mit wählbaren Werten enthält.", B1e = "Text", f1e = "Hintergrundfarbe", Z1e = "Info", G1e = "Warnfarbe", y1e = "Fehlerfarbe", W1e = "Basiseinstellungen", S1e = "Deckkraft", V1e = "Materialaktion", w1e = "Farbaktion", v1e = "Bildaktion", R1e = "Hinweis", X1e = "Achtung", H1e = "Fortfahren", k1e = "Plus", Y1e = "Minus", F1e = "Versteckt", x1e = "Artikelnummer", D1e = "Name", J1e = "Währung", E1e = "Wert", N1e = "Seitenleiste", L1e = "Startdatum", K1e = "Enddatum", T1e = "Startanzahl", M1e = "Endanzahl", P1e = "Suchen", U1e = "Titel", z1e = "OK", O1e = "Hervorhebung", Q1e = "Expression", j1e = "Ergebnis", q1e = "Mindestwert", _1e = "Maximalwert", $1e = "Nachkommastellen", eRe = "Schrittweite", tRe = "Berechnet", iRe = "Farbauswahl", nRe = "Komponentenliste", rRe = "Komponentenkarten", gRe = "Bildauswahl", oRe = "Informationen", lRe = "Zahleneingabe", aRe = "Dropdown", sRe = "Thumbnails", IRe = "Schalter", cRe = "Texteingabe", dRe = "Beispieltext", uRe = "Optional", CRe = "Bedingungen", ARe = "Materialnamen", bRe = "Labelaktion", hRe = "Fehlermeldung", mRe = "Modelaktion", pRe = "Position", BRe = "Scale", fRe = "Komponentenmerkmale", ZRe = "Herunterladen", GRe = "Verbinden", yRe = "Farbwert", WRe = "Anzeige", SRe = "RAL", VRe = "Ansicht", wRe = "URL", vRe = "Auswahlwerte", RRe = "Auswahlpreise", XRe = "Auswahl", HRe = "Gesamtpreis", kRe = "Weiter", YRe = "Vollbildmodus", FRe = "Komponenten", xRe = "xl", DRe = "Konfliktmeldung", JRe = "Positionszeile", ERe = "Menge", NRe = "Positionspreis", LRe = "Bild", KRe = "Information", TRe = "Mehrfachauswahl", MRe = "Liste", PRe = "Eckenrundung", URe = "Abmessungen", zRe = "Breite", ORe = "Tiefe", QRe = "Operation", jRe = "Segmente", qRe = "Pfad", _Re = "Startpunkt", $Re = "Endpunkt", eXe = "Startanker", tXe = "Ohne", iXe = "Endanker", nXe = "Texttyp", rXe = "Zahlenwert", gXe = "Offsets", oXe = "Blau", lXe = "Gelb", aXe = "Rot", sXe = "Purpur", IXe = "Abchasisch", cXe = "Afar", dXe = "Afrikaans", uXe = "Akan", CXe = "Albanisch", AXe = "Amharisch", bXe = "Arabisch", hXe = "Aragonesisch", mXe = "Armenisch", pXe = "Assamesisch", BXe = "Awarisch", fXe = "Avestisch", ZXe = "Aymara", GXe = "Aserbaidschanisch", yXe = "Bambara", WXe = "Baschkirisch", SXe = "Baskisch", VXe = "Weißrussisch", wXe = "Bengalisch", vXe = "Bislama", RXe = "Bosnisch", XXe = "Bretonisch", HXe = "Bulgarisch", kXe = "Birmanisch", YXe = "Chamorro", FXe = "Tschetschenisch", xXe = "Chinesisch", DXe = "Tschuwaschisch", JXe = "Kornisch", EXe = "Korsisch", NXe = "Cree", LXe = "Kroatisch", KXe = "Tschechisch", TXe = "Dänisch", MXe = "Dzongkha", PXe = "Englisch", UXe = "Esperanto", zXe = "Estnisch", OXe = "Ewe", QXe = "Färöisch", jXe = "Fidschianisch", qXe = "Finnisch", _Xe = "Französisch", $Xe = "Fulfulde", eHe = "Galicisch", tHe = "Ganda", iHe = "Georgisch", nHe = "Deutsch", rHe = "Guarani", gHe = "Gujarati", oHe = "Hausa", lHe = "Hebräisch", aHe = "Herero", sHe = "Hindi", IHe = "Ungarisch", cHe = "Isländisch", dHe = "Ido", uHe = "Igbo", CHe = "Indonesisch", AHe = "Inuktitut", bHe = "Inupiaq", hHe = "Irisch", mHe = "Italienisch", pHe = "Japanisch", BHe = "Javanisch", fHe = "Kannada", ZHe = "Kanuri", GHe = "Kaschmirisch", yHe = "Kasachisch", WHe = "Kinyarwanda", SHe = "Komi", VHe = "Kongo", wHe = "Koreanisch", vHe = "Kurdisch", RHe = "Laotisch", XHe = "Lateinisch", HHe = "Lettisch", kHe = "Lingala", YHe = "Litauisch", FHe = "Mazedonisch", xHe = "Malagasy", DHe = "Malaiisch", JHe = "Malayalam", EHe = "Maltesisch", NHe = "Manx", LHe = "Maori", KHe = "Marathi", THe = "Marschallesisch", MHe = "Mongolisch", PHe = "Nauruisch", UHe = "Ndonga", zHe = "Nepalesisch", OHe = "Norwegisch", QHe = "Okzitanisch", jHe = "Ojibwa", qHe = "Oriya", _He = "Oromo", $He = "Pali", eke = "Persisch", tke = "Polnisch", ike = "Portugiesisch", nke = "Quechua", rke = "Rätoromanisch", gke = "Rundi", oke = "Russisch", lke = "Samoanisch", ake = "Sango", ske = "Sanskrit", Ike = "Sardisch", cke = "Serbisch", dke = "Shona", uke = "Sindhi", Cke = "Slowakisch", Ake = "Slowenisch", bke = "Somalisch", hke = "Sundanesisch", mke = "Swahili", pke = "Swasi", Bke = "Schwedisch", fke = "Tagalog", Zke = "Tahitisch", Gke = "Tadschikisch", yke = "Tamil", Wke = "Tatarisch", Ske = "Telugu", Vke = "Thailändisch", wke = "Tibetisch", vke = "Tigrinya", Rke = "Tsonga", Xke = "Tswana", Hke = "Türkisch", kke = "Turkmenisch", Yke = "Twi", Fke = "Ukrainisch", xke = "Urdu", Dke = "Usbekisch", Jke = "Venda", Eke = "Vietnamesisch", Nke = "Wallonisch", Lke = "Walisisch", Kke = "Wolof", Tke = "Xhosa", Mke = "Jiddisch", Pke = "Yoruba", Uke = "Zulu", zke = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.",
  Mandant: iVe,
  Produkt: nVe,
  Bezahlzustand: rVe,
  Mandanten: gVe,
  Admin: oVe,
  Konfiguratoren: lVe,
  Erstellen: aVe,
  Importieren: sVe,
  Benutzer: IVe,
  Support: cVe,
  Logs: dVe,
  Systemstatus: uVe,
  Papierkorb: CVe,
  Abonnement: AVe,
  Ausgelaufen: bVe,
  Profil: hVe,
  Konfigurationen: mVe,
  Händler: "Händler",
  apps: pVe,
  support: BVe,
  "dealer-profile": "Händlerprofil",
  dealers: fVe,
  users: ZVe,
  trash: GVe,
  help: yVe,
  subscription: WVe,
  profile: SVe,
  logout: VVe,
  "Neuer Konfigurator": "Neuer Konfigurator",
  Template: wVe,
  Zurück: "Zurück",
  Aufrufen: vVe,
  PDF: RVe,
  Code: XVe,
  Preis: HVe,
  Inspiration: kVe,
  Aktion: YVe,
  Sprache: FVe,
  "Sie möchten die Daten dieses Kunden einsehen?": "Sie möchten die Daten dieses Kunden einsehen?",
  Kunde: xVe,
  Inhalt: DVe,
  "Shop-API": "Shop-API",
  "Gespeichert am": "Gespeichert am",
  Konfiguratorversion: JVe,
  Abbrechen: EVe,
  "Ergebnis der Shop API": "Ergebnis der Shop API",
  Schliessen: NVe,
  Feld: LVe,
  Bearbeiten: KVe,
  Adresse: TVe,
  Datenschutz: MVe,
  Name: PVe,
  Email: UVe,
  Telefon: zVe,
  Bemerkung: OVe,
  Firma: QVe,
  "Steuer-ID": "Steuer-ID",
  Akzeptiert: jVe,
  Stadt: qVe,
  PLZ: _Ve,
  Land: $Ve,
  Datum: ewe,
  "exit-action": "Bestellaktion",
  dealer: twe,
  "order-status": "Status",
  json: iwe,
  price: nwe,
  options: rwe,
  Bestellaktion: gwe,
  Typ: owe,
  Konfiguration: lwe,
  AR: awe,
  Geteilt: swe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Sie möchten die Daten Ihrer Kunden einsehen?",
  "Preise anlegen": "Preise anlegen",
  anzeigen: Iwe,
  "Artikel und Preise erfolgreich importiert.": "Artikel und Preise erfolgreich importiert.",
  Sortierung: cwe,
  Artikelnummer: dwe,
  "Artikelnummer eingeben": "Artikelnummer eingeben",
  "Namen eingeben": "Namen eingeben",
  Beschreibung: uwe,
  "Beschreibung eingeben": "Beschreibung eingeben",
  Kategorie: Cwe,
  "Kategorien eingeben": "Kategorien eingeben",
  Preise: Awe,
  "Sortierung erfolgreich angewendet.": "Sortierung erfolgreich angewendet.",
  "Fehler beim Anwenden der Sortierung: ": "Fehler beim Anwenden der Sortierung: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Artikel und Preise erfolgreich veröffentlicht.",
  "Fehler beim Veröffentlichen: ": "Fehler beim Veröffentlichen: ",
  "Sie möchten Preise anzeigen?": "Sie möchten Preise anzeigen?",
  "Neuer Artikel": "Neuer Artikel",
  Löschen: "Löschen",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.",
  "Artikel und Preise veröffentlichen": "Artikel und Preise veröffentlichen",
  Artikel: bwe,
  "Preise für Artikel nr.": "Preise für Artikel nr.",
  Schließen: "Schließen",
  "Preise werden automatisch importiert. Änderungen sind nicht möglich.": "Preise werden automatisch importiert. Änderungen sind nicht möglich.",
  "Sie verwenden nicht die aktuelle Release des K3. Das kann zu technischen Problemen führen. Bitte wechseln Sie sobald möglich auf die aktuelle Release und veröffentlichen Sie.": "Sie verwenden nicht die aktuelle Release des K3. Das kann zu technischen Problemen führen. Bitte wechseln Sie sobald möglich auf die aktuelle Release und veröffentlichen Sie.",
  Wechseln: hwe,
  Upload: mwe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.",
  "Ordner *": "Ordner *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".',
  Keine: pwe,
  Alle: Bwe,
  Bilder: fwe,
  Roughness: Zwe,
  Metalness: Gwe,
  Transparent: ywe,
  Opacity: Wwe,
  Farbe: Swe,
  Emissive: Vwe,
  "Color Map": "Farbtextur",
  "Normal Map": "Normalentextur",
  "Roughness Map": "Rauheitstextur",
  "Metalness Map": "Metallhaltigkeitstextur",
  "Alpha Map": "Transparenztextur",
  Seite: wwe,
  Vorderseite: vwe,
  Hinterseite: Rwe,
  Beidseitig: Xwe,
  "Texture repeat": "Texturwiederholung",
  "Depth Write": "Schreibe in den Tiefenpuffer",
  Transmission: Hwe,
  Reflectivity: kwe,
  ClearCoat: Ywe,
  "Clearcoat Roughness": "Rauheit des Klarlacks",
  "new-material": "Neues Material",
  Optionen: Fwe,
  Bezeichnung: xwe,
  Pbr: Dwe,
  Physikalisch: Jwe,
  Key: Ewe,
  "AR Fallback Material": "AR Fallback Material",
  "Nicht ausgewählt": "Nicht ausgewählt",
  Model: Nwe,
  Erweitert: Lwe,
  "Nur in Regeln verwendete Materialien anzeigen": "Nur in Regeln verwendete Materialien anzeigen",
  "extract-materials": "Materialien aus Modell extrahieren",
  Editieren: Kwe,
  Kopieren: Twe,
  "Neues Modell": "Neues Modell",
  "Dynamisches Modell": "Dynamisches Modell",
  "Neue Regel Erstellen": "Neue Regel Erstellen",
  "Regel erstellen": "Regel erstellen",
  Gültigkeit: "Gültigkeit",
  "Neue Regel": "Neue Regel",
  Export: Mwe,
  "app-code-duplicate": "App Code wird schon benutzt",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.",
  "screenshot-quality": "Screenshot Qualität",
  Produktdarstellung: Pwe,
  "3D-Modell": "3D-Modell",
  "Bilder-Konfigurator": "Bilder-Konfigurator",
  Hauptmodell: Uwe,
  "Hauptmodell entfernen": "Hauptmodell entfernen",
  "Link zum Konfigurator": "Link zum Konfigurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.",
  "Die Beschreibung dieses Konfigurators": "Die Beschreibung dieses Konfigurators",
  "Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Sie möchten Ihr Analytics-Konto verbinden?",
  Upgrade: zwe,
  Vorlage: Owe,
  "Dieser Konfigurator dient als Vorlage": "Dieser Konfigurator dient als Vorlage",
  Tutorial: Qwe,
  "Standard übernehmen": "Standard übernehmen",
  Tracking: jwe,
  share: qwe,
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).",
  "Preis & Info Service": "Preis & Info Service",
  "Hilfe dazu finden Sie hier.": "Hilfe dazu finden Sie hier.",
  "URL für den Service, der die Daten verarbeitet": "URL für den Service, der die Daten verarbeitet",
  "Debounce in ms": "Debounce in ms",
  Merkmale: _we,
  "Merkmale und ihre aktuelle Auswahlen senden": "Merkmale und ihre aktuelle Auswahlen senden",
  "Optionale Merkmalbeschränkung": "Optionale Merkmalbeschränkung",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Beschränken Sie optional die Merkmale, die gesendet werden.",
  "Artikel & Preis": "Artikel & Preis",
  "Aktuell ausgewählte Artikel senden": "Aktuell ausgewählte Artikel senden",
  "Aktuellen Preis senden": "Aktuellen Preis senden",
  "to dealer app": "Zur Händler-App",
  "Händler hat Zugriff": "Händler hat Zugriff",
  "Händler hat keinen Zugriff": "Händler hat keinen Zugriff",
  "dealer query": "Voreinstellungen",
  "Händler legt Aufschlag fest": "Händler legt Aufschlag fest",
  discount: $we,
  surcharge: e2e,
  "Um diesem Händler Zugriff zu geben oder ihn zu entziehen, ": "Um diesem Händler Zugriff zu geben oder ihn zu entziehen, ",
  "wenden Sie sich bitte an uns": "wenden Sie sich bitte an uns",
  Speichern: t2e,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Ihre Händler sollen Ihren Konfigurator nutzen können?",
  "Keine Händler vorhanden": "Keine Händler vorhanden",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.",
  "Jetzt Händler anlegen": "Jetzt Händler anlegen",
  Einbetten: i2e,
  "Als Link": "Als Link",
  "Als IFrame": "Als IFrame",
  "Meldungen beim Laden anpassen": "Meldungen beim Laden anpassen",
  "Bitte Auth0 Zugangsdaten angeben": "Bitte Auth0 Zugangsdaten angeben",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.",
  "Konfigurator-Zugang": "Konfigurator-Zugang",
  "Anmeldung für Konfigurator verlangen.": "Anmeldung für Konfigurator verlangen.",
  "Auth0 Domain": "Auth0 Domain",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
  "Info ": "Info ",
  "Sprache: ": "Sprache: ",
  "Referenzsprache: ": "Referenzsprache: ",
  Referenzsprache: n2e,
  "Anzahl Sprachen: ": "Anzahl Sprachen: ",
  "Anzahl übersetzbarer Texte: ": "Anzahl übersetzbarer Texte: ",
  Sprachen: r2e,
  "Die erste Sprache gilt als Standard.": "Die erste Sprache gilt als Standard.",
  Übersetzungen: "Übersetzungen",
  "Versteckte Merkmale": "Versteckte Merkmale",
  "Unbenutzte Sprachen": "Unbenutzte Sprachen",
  "Importiere XLSX": "Importiere XLSX",
  "Exportiere XLSX": "Exportiere XLSX",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?",
  "Mail Texte": "Mail Texte",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.",
  Schriftart: g2e,
  Helvetica: o2e,
  "Times Roman": "Times Roman",
  Courier: l2e,
  Interstate: a2e,
  Montserrat: s2e,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "Schriftgröße",
  Links: I2e,
  Rechts: c2e,
  Oben: d2e,
  Unten: u2e,
  Kopfzeile: C2e,
  Fußzeile: "Fußzeile",
  "Neue PDF Vorlage auswählen": "Neue PDF Vorlage auswählen",
  "Vorhandene PDF Vorlage löschen": "Vorhandene PDF Vorlage löschen",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Sie möchten Bestätigungen oder Angebote als PDF senden?",
  "PDF Einstellungen": "PDF Einstellungen",
  Seitenränder: "Seitenränder",
  "Voransicht mit dieser Konfiguration:": "Voransicht mit dieser Konfiguration:",
  "und diesem Template:": "und diesem Template:",
  "Speichern und drucken": "Speichern und drucken",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.",
  Allgemein: A2e,
  Mail: b2e,
  Shop: h2e,
  "Ungespeicherte Änderungen": "Ungespeicherte Änderungen",
  "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?": "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?",
  Verlassen: m2e,
  "Immer aktuellste Version verwenden": "Immer aktuellste Version verwenden",
  "K3 Version": "K3 Version",
  "Wir helfen gern!": "Wir helfen gern!",
  "Ihre Telefonnummer": "Ihre Telefonnummer",
  "Ihre Nachricht": "Ihre Nachricht",
  Senden: p2e,
  "Nachricht senden": "Nachricht senden",
  "Rückruf erbitten": "Rückruf erbitten",
  orders: B2e,
  date: f2e,
  "Preise wurden in den Einstellungen deaktiviert": "Preise wurden in den Einstellungen deaktiviert",
  "Keine Einnahmen vorliegend": "Keine Einnahmen vorliegend",
  "total-earnings": "Gesamteinnahmen",
  Tage: Z2e,
  articlename: G2e,
  articles: y2e,
  "Erfolgreich importiert": "Erfolgreich importiert",
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.',
  "JSON Export Datei": "JSON Export Datei",
  "Leerer Konfigurator": "Leerer Konfigurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.",
  "Konfigurator importieren": "Konfigurator importieren",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importieren sie einen Konfigurator anhand einer exportierten Datei.",
  Veröffentlicht: "Veröffentlicht",
  "Mandant hat noch keinen Konfigurator": "Mandant hat noch keinen Konfigurator",
  Konfigurator: W2e,
  "Link kopiert": "Link kopiert",
  "E-Mail": "E-Mail",
  "Werben Sie K3 Kunden!": "Werben Sie K3 Kunden!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.",
  Partner: S2e,
  Provision: V2e,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.",
  "Meine Kunden": "Meine Kunden",
  "Vielen Dank für Ihre Bestätigung...": "Vielen Dank für Ihre Bestätigung...",
  "E-Mail Bestätigung": "E-Mail Bestätigung",
  "Zur Anmeldung": "Zur Anmeldung",
  Händlerprofil: "Händlerprofil",
  name: w2e,
  email: v2e,
  "E-Mail ist ungültig!": "E-Mail ist ungültig!",
  Nutzerkonto: R2e,
  Nutzername: X2e,
  "Mail ist schon vergeben": "Mail ist schon vergeben",
  "code-duplicate": "Dieser Code ist schon vergeben",
  "dealer code helper text": "Zum Aufrufen des Händler-Konfigurators.",
  "default discount": "Standard-Abschlag",
  "Kann pro Konfigurator überschrieben werden.": "Kann pro Konfigurator überschrieben werden.",
  "default surcharge": "Standard-Aufschlag",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ",
  "Fehlendes Produkt": "Fehlendes Produkt",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Bitte buchen Sie dort zunächst ein anderes Produkt.",
  "new dealer": "Neuer Händler",
  "Login screen": "Anmeldung",
  "Bitte am Desktop öffnen": "Bitte am Desktop öffnen",
  Password: H2e,
  Login: k2e,
  "Passwort vergessen?": "Passwort vergessen?",
  "Noch kein Konto?": "Noch kein Konto?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.",
  "Mail senden": "Mail senden",
  "K3 - die Konfiguratorplattform": "K3 - die Konfiguratorplattform",
  "Ich habe den Konfigurator innerhalb von drei Wochen fertiggestellt und er hat sich bereits mehr als rentiert.": "Ich habe den Konfigurator innerhalb von drei Wochen fertiggestellt und er hat sich bereits mehr als rentiert.",
  "Die Eingabe ist zu kurz.": "Die Eingabe ist zu kurz.",
  "Die Eingabe ist zu lang.": "Die Eingabe ist zu lang.",
  "Die Eingabe wird benötigt.": "Die Eingabe wird benötigt.",
  "Email Adresse ist ungültig.": "Email Adresse ist ungültig.",
  "Dieser Wert wird bereits benutzt.": "Dieser Wert wird bereits benutzt.",
  "Das Kennwort muss mindestens 8 Zeichen lang sein und Buchstaben, Großbuchstaben und Zahlen enthalten.": "Das Kennwort muss mindestens 8 Zeichen lang sein und Buchstaben, Großbuchstaben und Zahlen enthalten.",
  "Die Eingabe fehlt.": "Die Eingabe fehlt.",
  "Leider ": "Leider ",
  "Bitte geben Sie eine E-Mail-Adresse an": "Bitte geben Sie eine E-Mail-Adresse an",
  "Die angegebene E-Mail-Adresse hat ein ungültiges Format": "Die angegebene E-Mail-Adresse hat ein ungültiges Format",
  "Bitte geben Sie ein Passwort an": "Bitte geben Sie ein Passwort an",
  "Bitte geben Sie eine Telefonnummer an": "Bitte geben Sie eine Telefonnummer an",
  "Die eingegebene Telefonnummer hat ein ungültiges Format": "Die eingegebene Telefonnummer hat ein ungültiges Format",
  "Bitte stimmen Sie unseren Datenschutzhinweisen und Geschäftsbedigungen zu": "Bitte stimmen Sie unseren Datenschutzhinweisen und Geschäftsbedigungen zu",
  Registrierung: Y2e,
  "Ihre E-Mail-Adresse": "Ihre E-Mail-Adresse",
  "Bitte wählen Sie ein Kennwort": "Bitte wählen Sie ein Kennwort",
  "Direkt starten - ohne Zahlungsangaben.": "Direkt starten - ohne Zahlungsangaben.",
  "Bitte bestätigen Sie unsere ": "Bitte bestätigen Sie unsere ",
  Datenschutzbestimmungen: F2e,
  " und unsere ": " und unsere ",
  AGB: x2e,
  "Jetzt registrieren": "Jetzt registrieren",
  "Die Registrierung war leider nicht möglich.": "Die Registrierung war leider nicht möglich.",
  "Herzlich willkommen!": "Herzlich willkommen!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:",
  "Wir haben Ihr Kennwort neu gesetzt.": "Wir haben Ihr Kennwort neu gesetzt.",
  "Passwort setzen": "Passwort setzen",
  Passwort: D2e,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen",
  Bestätigung: "Bestätigung",
  "Bestätigung stimmt nicht überein": "Bestätigung stimmt nicht überein",
  "Kennwort setzen": "Kennwort setzen",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - der 3D-Produktkonfigurator für Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:",
  "Registrieren Sie sich am K3.": "Registrieren Sie sich am K3.",
  "Legen Sie einen Konfigurator an.": "Legen Sie einen Konfigurator an.",
  "Jetzt starten": "Jetzt starten",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Gestalten Sie den Konfigurator für Ihr Produkt.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Fügen Sie den Konfigurator in Ihren Shop ein.",
  Editor: J2e,
  "Mandant: ": "Mandant: ",
  "Erstellt am: ": "Erstellt am: ",
  "Veröffentlicht am: ": "Veröffentlicht am: ",
  "Noch nicht veröffentlicht": "Noch nicht veröffentlicht",
  "Version: ": "Version: ",
  "Artikel-Version: ": "Artikel-Version: ",
  "Code: ": "Code: ",
  "Typ: ": "Typ: ",
  Standard: E2e,
  "Shop: ": "Shop: ",
  "Nicht verbunden": "Nicht verbunden",
  "Bestellungen insgesamt": "Bestellungen insgesamt",
  Veröffentlichungen: "Veröffentlichungen",
  Von: N2e,
  Version: L2e,
  "Artikel-Version": "Artikel-Version",
  Buchungen: K2e,
  Plattform: T2e,
  Intervall: M2e,
  Subscription: P2e,
  CustomerID: U2e,
  Aktiv: z2e,
  Seit: O2e,
  "Abschlag [%]": "Abschlag [%]",
  "Aufschlag [%]": "Aufschlag [%]",
  Query: Q2e,
  Aktionen: j2e,
  "Mandanten wechseln": "Mandanten wechseln",
  "Konnte nicht gespeichert werden: ": "Konnte nicht gespeichert werden: ",
  Buchung: q2e,
  "Angelegt am": "Angelegt am",
  "Zum AdminPanel": "Zum AdminPanel",
  "App editieren": "App editieren",
  Monat: _2e,
  Jahr: $2e,
  "Bezahlt?": "Bezahlt?",
  Bis: eve,
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.",
  "Einstiegs-Produkt": "Einstiegs-Produkt",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Stripe ID",
  Parameter: tve,
  "Partner?": "Partner?",
  Kunden: ive,
  ID: nve,
  Rechnungen: rve,
  Leer: gve,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?",
  "Mandant unwiderruflich löschen": "Mandant unwiderruflich löschen",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:",
  Nutzer: ove,
  "Mandant erfolgreich gelöscht": "Mandant erfolgreich gelöscht",
  "Mandanten editieren": "Mandanten editieren",
  Rolle: lve,
  Schritte: ave,
  Werte: sve,
  Regeln: Ive,
  Regelzeilen: cve,
  Modelle: dve,
  Materialien: uve,
  Gelöscht: "Gelöscht",
  Merkmal: Cve,
  Regel: Ave,
  Nummer: bve,
  Status: hve,
  Erstellt: mve,
  Zurücklegen: "Zurücklegen",
  Mindestlänge: "Mindestlänge {{chars}} Zeichen",
  "Email Adresse ist ungültig": "Email Adresse ist ungültig",
  Kennwort: pve,
  "Test stimmt nicht überein": "Test stimmt nicht überein",
  "Telefonnummer ist ungültig": "Telefonnummer ist ungültig",
  "Entwickler Modus": "Entwickler Modus",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.",
  "Sie können das Token im Shop-Plugin eintragen.": "Sie können das Token im Shop-Plugin eintragen.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.",
  Neu: Bve,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.",
  "Sie möchten über die API auf den K3 zugreifen?": "Sie möchten über die API auf den K3 zugreifen?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.",
  "Neuen Nutzer anlegen": "Neuen Nutzer anlegen",
  Eingabe: fve,
  "E-Mail nicht valide!": "E-Mail nicht valide!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.",
  "Nutzer einladen": "Nutzer einladen",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "Der Nutzer erhält Zugang zu Ihrem Mandanten.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Bitte überprüfen Sie die von Ihnen gemachten Angaben:",
  Einladen: Zve,
  "Benutzer einladen": "Benutzer einladen",
  "new user": "Neuer Benutzer",
  "Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.": "Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.",
  "CSS-Datei auswählen": "CSS-Datei auswählen",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.",
  "3D-Modell auswählen": "3D-Modell auswählen",
  Download: Gve,
  Hintergrundmodell: yve,
  "material-upload": "material-upload",
  Favoriten: Wve,
  "main-model": "Hauptmodell",
  "Wirft Schatten": "Wirft Schatten",
  "Wird schattiert": "Wird schattiert",
  "Bilder Galerie": "Bilder Galerie",
  Anlegen: Sve,
  "Neue Aktion": "Neue Aktion",
  Preiseinstellungen: Vve,
  "Preise im Konfigurator ausblenden?": "Preise im Konfigurator ausblenden?",
  Hauptaktion: wve,
  Kontaktformular: vve,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.",
  Pflichtfeld: Rve,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.',
  "Shop verbinden": "Shop verbinden",
  Aktionsname: Xve,
  "Überschrift Bestätigung": "Überschrift Bestätigung",
  "Text Bestätigung": "Text Bestätigung",
  "Link zur Konfiguration zeigen?": "Link zur Konfiguration zeigen?",
  "Thumbnail des Konfigurators": "Thumbnail des Konfigurators",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel hat keinen Namen und keine Nummer!",
  "Kein Artikel ausgewählt!": "Kein Artikel ausgewählt!",
  "Artikel auswählen": "Artikel auswählen",
  "Artikelanzahl und Menge": "Artikelanzahl und Menge",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Wie oft der entsprechende Artikel hinzugefügt werden soll",
  Anzahl: Hve,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens",
  "Menge (optional)": "Menge (optional)",
  Anzahlberechnung: kve,
  Mengenberechnung: Yve,
  Artikelaktion: Fve,
  "Wert eingeben": "Wert eingeben",
  "Neue Spalte": "Neue Spalte",
  "Wert-Eigenschaft": "Wert-Eigenschaft",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.",
  "Eigenschaft wird dem Nutzer angezeigt": "Eigenschaft wird dem Nutzer angezeigt",
  "mehrsprachiger Text": "mehrsprachiger Text",
  "nicht übersetzter Text": "nicht übersetzter Text",
  Zahl: xve,
  Einheit: Dve,
  "Buchen Sie jetzt Ihre Lizenz!": "Buchen Sie jetzt Ihre Lizenz!",
  "Denken Sie daran, den Konfigurator zu veröffentlichen, damit er für Ihre Kunden freigegeben wird.": "Denken Sie daran, den Konfigurator zu veröffentlichen, damit er für Ihre Kunden freigegeben wird.",
  "Fokus auf Modelle": "Fokus auf Modelle",
  "Alle Modelle": "Alle Modelle",
  "Fokus über Objektnamen": "Fokus über Objektnamen",
  Kamera: Jve,
  Schritt: Eve,
  Kameraansicht: Nve,
  Kameratyp: Lve,
  Perspektive: Kve,
  Orthographisch: Tve,
  Fokustyp: Mve,
  "Dynamischer Fokus": "Dynamischer Fokus",
  "Statischer Fokus": "Statischer Fokus",
  "Screenshot Auflösung": "Screenshot Auflösung",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Notwendiger Unterschied zur aktuellen Ansicht",
  "Noch keine Kamera gespeichert": "Noch keine Kamera gespeichert",
  "Kamera erstellen": "Kamera erstellen",
  "Bitte auswählen": "Bitte auswählen",
  Ausgewählt: "Ausgewählt",
  "Merkmal setzen: ": "Merkmal setzen: ",
  "Keine Farbe ausgewählt!": "Keine Farbe ausgewählt!",
  "Farbe auswählen": "Farbe auswählen",
  "Farbmerkmal auswählen:": "Farbmerkmal auswählen:",
  "Keine Auswahl": "Keine Auswahl",
  "Hoch schieben": "Hoch schieben",
  "Runter schieben": "Runter schieben",
  Duplizieren: Pve,
  "Löschen des aktiven Elements nicht möglich": "Löschen des aktiven Elements nicht möglich",
  "Komponente hinzufügen": "Komponente hinzufügen",
  Entfernen: Uve,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Ihre Konfiguration konnte nicht gespeichert werden.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.",
  "technische Information:": "technische Information:",
  "Preis: ": "Preis: ",
  "Kamera bearbeiten": "Kamera bearbeiten",
  "Neue Kamera für Bestellungsbilder": "Neue Kamera für Bestellungsbilder",
  "Ansicht übernehmen und Speichern": "Ansicht übernehmen und Speichern",
  "Kameras für Bestellungsbilder": "Kameras für Bestellungsbilder",
  Kameras: zve,
  "Anfrage erhalten": "Anfrage erhalten",
  "Buchung erfolgreich": "Buchung erfolgreich",
  "Für das neue Produkt melden wir uns bei Ihnen.": "Für das neue Produkt melden wir uns bei Ihnen.",
  "Ihre Subskription wurde angepasst.": "Ihre Subskription wurde angepasst.",
  "Ihre Subskription wurde beendet.": "Ihre Subskription wurde beendet.",
  "Das Produkt wurde gebucht.": "Das Produkt wurde gebucht.",
  "3D-Konfigurator mit beliebig komplexer Logik": "3D-Konfigurator mit beliebig komplexer Logik",
  "E-Mail mit PDF erhalten": "E-Mail mit PDF erhalten",
  "Shop-Anbindung": "Shop-Anbindung",
  Schnittstellen: Ove,
  "Auf Anfrage": "Auf Anfrage",
  Kostenfrei: Qve,
  pro: jve,
  "Meine Rechnungen": "Meine Rechnungen",
  "Derzeit gebucht.": "Derzeit gebucht.",
  "Änderung Ihrer Buchung": "Änderung Ihrer Buchung",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?",
  "Jetzt buchen": "Jetzt buchen",
  Downgrade: qve,
  "Zahlungsplan ändern": "Zahlungsplan ändern",
  Monatlich: _ve,
  Jährlich: "Jährlich",
  "In neuem Tab öffnen": "In neuem Tab öffnen",
  "Konfigurator anpassen": "Konfigurator anpassen",
  "main drawer": "Sie sehen eine Vorschau Ihres Konfigurators, die Sie wie üblich bedienen können. Klicken Sie auf ein Stift-Symbol, um etwas zu ändern oder:",
  "Ändern Sie die Bestelloptionen": "Ändern Sie die Bestelloptionen",
  "Ändern Sie das Design": "Ändern Sie das Design",
  "Passen sie die 3D Szene an": "Passen sie die 3D Szene an",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Speichern Sie die aktuelle Kamera für Bestellungsbilder",
  "Merkmale verwalten": "Merkmale verwalten",
  "Ihre Lizenz": "Ihre Lizenz",
  "So richten Sie Ihren Konfigurator ein:": "So richten Sie Ihren Konfigurator ein:",
  Home: $ve,
  Hilfe: e1e,
  "dealer sidebar": "Hier können sie ihren Händler Konfigurator einstellen",
  "Ändern Sie das Logo": "Ändern Sie das Logo",
  "Ändern Sie die DSGVO": "Ändern Sie die DSGVO",
  "Ändern Sie den Preis": "Ändern Sie den Preis",
  "Ändern Sie die PDF Vorlage": "Ändern Sie die PDF Vorlage",
  "PDF Gestaltung": "PDF Gestaltung",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Laden Sie ein PDF als Vorlage für den Druck hoch.",
  cancel: t1e,
  "app surcharge": "Aufschlag festlegen",
  "you can change your surcharge here": "Hier können Sie Ihren Aufpreis ändern",
  DSGVO: i1e,
  "Hier können Sie den Text für die DSGVO ändern": "Hier können Sie den Text für die DSGVO ändern",
  "Neuer Schritt": "Neuer Schritt",
  Icon: n1e,
  "Icon Bilddatei": "Icon Bilddatei",
  "Icon position": "Icon position",
  "Icon Größe": "Icon Größe",
  "Ersetze Weiter mit Aktionsauswahl": "Ersetze Weiter mit Aktionsauswahl",
  "Aktionsnamen überschreiben": "Aktionsnamen überschreiben",
  "Individuelles Design": "Individuelles Design in einem Schritt",
  "Angepasstes Layout speichern": "Angepasstes Layout speichern",
  "Merkmale editieren": "Merkmale editieren",
  "Keine Ergebnisse": "Keine Ergebnisse",
  "Desktop Layout": "Desktop Layout",
  "Mobile Layout": "Mobile Layout",
  "Schritte nacheinander einblenden": "Schritte nacheinander einblenden",
  "Besuchte Schritte abhaken": "Besuchte Schritte abhaken",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.",
  "Dieses Layout selbst anpassen": "Dieses Layout selbst anpassen",
  "Eigenes Layout erstellen": "Eigenes Layout erstellen",
  "Angepasstes Layout anwenden": "Angepasstes Layout anwenden",
  Logo: r1e,
  "Konfigurator-Abschluss": "Konfigurator-Abschluss",
  "3D Szene": "3D Szene",
  "Manuelle Einstellung erstellen": "Manuelle Einstellung erstellen",
  "Design & Theme": "Design & Theme",
  Farben: g1e,
  "Farbanpassungen zurücksetzten": "Farbanpassungen zurücksetzten",
  CSS: o1e,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:",
  "Link zur CSS-Datei": "Link zur CSS-Datei",
  "Oder laden Sie eine CSS Datei hoch:": "Oder laden Sie eine CSS Datei hoch:",
  "Neues Merkmal": "Neues Merkmal",
  "Merkmal kopieren": "Merkmal kopieren",
  Zurücksetzen: "Zurücksetzen",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "Sie setzen den Konfigurator auf die gewählte Version zurück.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Dadurch werden alle Daten dieses Konfigurators ersetzt.",
  "Auch der Papierkorb wird gelöscht.": "Auch der Papierkorb wird gelöscht.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Diese Operation kann nicht rückgängig gemacht werden.",
  "Sind Sie sicher?": "Sind Sie sicher?",
  Einstellungen: l1e,
  "Dynamische Texte": "Dynamische Texte",
  "Texte und Einstellungen anpassen": "Texte und Einstellungen anpassen",
  "Sie verwenden diesen Konfigurator mit einer Testlizenz.": "Sie verwenden diesen Konfigurator mit einer Testlizenz.",
  "Ihr Testzeitraum ist abgelaufen.": "Ihr Testzeitraum ist abgelaufen.",
  "Ihr Testzeitraum ist seit {{days}} Tagen abgelaufen.": "Ihr Testzeitraum ist seit {{days}} Tagen abgelaufen.",
  "Sie können diesen Konfigurator noch {{days}} Tage testen.": "Sie können diesen Konfigurator noch {{days}} Tage testen.",
  "Sie haben diesen Konfigurator storniert.": "Sie haben diesen Konfigurator storniert.",
  "Jetzt buchen!": "Jetzt buchen!",
  Vorschau: a1e,
  Articles: s1e,
  Bestellungen: I1e,
  Statistics: c1e,
  "Fragen? Wir helfen gern!": "Fragen? Wir helfen gern!",
  "Inhalte: ": "Inhalte: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.',
  "Live Version": "Live Version",
  Veröffentlichen: "Veröffentlichen",
  "Erstelle Option: ": "Erstelle Option: ",
  Fehler: d1e,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Beim Rendern des Inhalts ist ein Fehler aufgetreten.",
  Fatal_Error_Text: u1e,
  Fatal_Error: C1e,
  "Fehlermeldung:": "Fehlermeldung:",
  "Zur Startseite": "Zur Startseite",
  "Neu Laden": "Neu Laden",
  "Cleanup und Neu Laden": "Cleanup und Neu Laden",
  "You may need to reload the page": "Neu laden der Seite könnte notwendig sein",
  Error_Message: A1e,
  "(SU) Client wechseln": "(SU) Client wechseln",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?",
  "Kein Hauptabschluss": "Kein Hauptabschluss",
  "Label eingeben": "Label eingeben",
  "Abschlüsse verbergen": "Abschlüsse verbergen",
  "Abschlüsse deaktivieren": "Abschlüsse deaktivieren",
  Hauptabschluss: b1e,
  "Abschlüsse festlegen": "Abschlüsse festlegen",
  "Hier können Sie festlegen, welche Abschlüsse für die Benutzer sichtbar oder deaktiviert sind.": "Hier können Sie festlegen, welche Abschlüsse für die Benutzer sichtbar oder deaktiviert sind.",
  "Die unterschiedlichen Farben der Abschlüsse repräsentieren unterschiedliche Zustände:": "Die unterschiedlichen Farben der Abschlüsse repräsentieren unterschiedliche Zustände:",
  Abschluss: h1e,
  "In Schwarz werden verborgene Abschlüsse repräsentiert.": "In Schwarz werden verborgene Abschlüsse repräsentiert.",
  "In Grau werden deaktivierte Abschlüsse repräsentiert.": "In Grau werden deaktivierte Abschlüsse repräsentiert.",
  "In Blau bezeichnet welcher Abschluss am Ende der Reiter Navigation angezeigt wird. Davon kann es nur einen geben.": "In Blau bezeichnet welcher Abschluss am Ende der Reiter Navigation angezeigt wird. Davon kann es nur einen geben.",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Element löschen",
  "Selektierte Elemente löschen": "Selektierte Elemente löschen",
  "Alle selektierte Elemente löschen": "Alle selektierte Elemente löschen",
  "Lösch-Konflikte anzeigen": "Lösch-Konflikte anzeigen",
  "Das Element": "Das Element",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Möchten Sie dieses Element wirklich unwiderruflich löschen?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "Die folgenden Gründe sprechen gegen eine Löschung:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} wird noch an anderen Stellen verwendet:",
  "{{label}} wird noch verwendet in ": "{{label}} wird noch verwendet in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.",
  "der Definition der Regel": "der Definition der Regel",
  "einem Eintrag in Regel": "einem Eintrag in Regel",
  "einer berechneten Eigenschaft des Modells": "einer berechneten Eigenschaft des Modells",
  "der Formel von": "der Formel von",
  "der Kamera": "der Kamera",
  "des Merkmals": "des Merkmals",
  "des Schrittes": "des Schrittes",
  "der globalen Kamera": "der globalen Kamera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Löschen Sie bitte zunächst die anderen Referenzen.",
  "Neuen Schritt hinzufügen": "Neuen Schritt hinzufügen",
  "Bitte legen Sie einen Schritt an!": "Bitte legen Sie einen Schritt an!",
  "Schritt editieren": "Schritt editieren",
  Bestelloptionen: m1e,
  "Merkmal editieren": "Merkmal editieren",
  "Mehr Informationen anzeigen": "Mehr Informationen anzeigen",
  "Nicht Aktiv": "Nicht Aktiv",
  "Keine Angabe": "Keine Angabe",
  "Fokus:": "Fokus:",
  "Fokus: ": "Fokus: ",
  hiddenGroup: p1e,
  "Bilder auswählen": "Bilder auswählen",
  "Ordner auswählen:": "Ordner auswählen:",
  "Bildmerkmal: ": "Bildmerkmal: ",
  "Kein Bild ausgewählt": "Kein Bild ausgewählt",
  "Bild auswählen": "Bild auswählen",
  "Bildmerkmal auswählen:": "Bildmerkmal auswählen:",
  Befüllt: "Befüllt",
  "Zustand auswählen": "Zustand auswählen",
  "Kein Komponente ausgewählt!": "Kein Komponente ausgewählt!",
  "Komponente auswählen": "Komponente auswählen",
  "Intervall eingeben": "Intervall eingeben",
  "Zum Dashboard": "Zum Dashboard",
  Primärfarbe: "Primärfarbe",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)",
  Sekundärfarbe: "Sekundärfarbe",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)",
  Text: B1e,
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)",
  Hintergrundfarbe: f1e,
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)",
  Info: Z1e,
  "Setzt die Farbe der Info-Icons": "Setzt die Farbe der Info-Icons",
  Warnfarbe: G1e,
  "Setzt die Farbe der Warnhinweise": "Setzt die Farbe der Warnhinweise",
  Fehlerfarbe: y1e,
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Setzt die Farbe für Fehlermeldungen und -hinweise",
  Basiseinstellungen: W1e,
  "Helles Theme": "Helles Theme",
  "Erweiterte Einstellungen": "Erweiterte Einstellungen",
  "Label hinzufügen: ": "Label hinzufügen: ",
  "Kein Label ausgewählt!": "Kein Label ausgewählt!",
  "Was soll angezeigt werden?": "Was soll angezeigt werden?",
  Maximalgröße: "Maximalgröße",
  Deckkraft: S1e,
  "Kein Material ausgewählt!": "Kein Material ausgewählt!",
  "Material auswählen": "Material auswählen",
  "Material auswählen:": "Material auswählen:",
  Materialaktion: V1e,
  Farbaktion: w1e,
  Bildaktion: v1e,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Beschränkung der Auswirkungen auf bestimmte Modelle",
  "Die Option 'Titel ausblenden' ist aktiviert.": "Die Option 'Titel ausblenden' ist aktiviert.",
  Hinzufügen: "Hinzufügen",
  "Welches Teil soll hinzugefügt werden?": "Welches Teil soll hinzugefügt werden?",
  Hinweis: R1e,
  Achtung: X1e,
  Fortfahren: H1e,
  "Kein Modell ausgewählt!": "Kein Modell ausgewählt!",
  "Modell auswählen": "Modell auswählen",
  "Modell hinzufügen:": "Modell hinzufügen:",
  "Globale Änderung": "Globale Änderung",
  Oberflächen: "Oberflächen",
  "Ausgewählte Oberflächen": "Ausgewählte Oberflächen",
  "Eintrag darf nicht leer sein.": "Eintrag darf nicht leer sein.",
  "Alle Werte": "Alle Werte",
  "Werte auswählen": "Werte auswählen",
  "Sortierung anwenden": "Sortierung anwenden",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.",
  "Erlaubte Formate:": "Erlaubte Formate:",
  "Keine Datei gewählt.": "Keine Datei gewählt.",
  "Datei konnte nicht hochgeladen werden.": "Datei konnte nicht hochgeladen werden.",
  "Bild hochladen": "Bild hochladen",
  Plus: k1e,
  Minus: Y1e,
  "Dieses Merkmal ist nicht erlaubt.": "Dieses Merkmal ist nicht erlaubt.",
  "Merkmal-Optionen": "Merkmal-Optionen",
  "Merkmal Beschreibung editieren": "Beschreibung editieren",
  "Merkmal-Info editieren": "Info editieren",
  Versteckt: F1e,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Aus Schritt verstecken",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.",
  "Kamera-Optionen": "Kamera-Optionen",
  "Vorlage wählen": "Vorlage wählen",
  "Konfigurator erstellen": "Konfigurator erstellen",
  "Willkommen in Ihrem neuen K3 Konto!": "Willkommen in Ihrem neuen K3 Konto!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Richten Sie gleich Ihren ersten Konfigurator ein:",
  "Sie können alle Daten natürlich später noch ändern.": "Sie können alle Daten natürlich später noch ändern.",
  "Nicht veröffentlicht": "Nicht veröffentlicht",
  "Ladevorgang fehlgeschlagen": "Ladevorgang fehlgeschlagen",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!",
  "Keine Optionen": "Keine Optionen",
  "Neuen Artikel anlegen": "Neuen Artikel anlegen",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Hier können sie einen neuen Artikel mit Preis anlegen.",
  articleNo: x1e,
  articleName: D1e,
  currency: J1e,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Positionen ändern",
  "Abbrechen durch Klick": "Abbrechen durch Klick",
  Wert: E1e,
  Seitenleiste: N1e,
  "Preis eingeben": "Preis eingeben",
  Währung: "Währung",
  "Währung eingeben": "Währung eingeben",
  "Einheit eingeben": "Einheit eingeben",
  Startdatum: L1e,
  "Startdatum eingeben": "Startdatum eingeben",
  Enddatum: K1e,
  "Enddatum eingeben": "Enddatum eingeben",
  Startanzahl: T1e,
  "Startanzahl eingeben": "Startanzahl eingeben",
  Endanzahl: M1e,
  "Endanzahl eingeben": "Endanzahl eingeben",
  Priorität: "Priorität",
  "Priorität eingeben": "Priorität eingeben",
  "Aufschlag?": "Aufschlag?",
  "Preistyp eingeben": "Preistyp eingeben",
  "Neuer Preis": "Neuer Preis",
  "Erweiterter Modus": "Erweiterter Modus",
  Suchen: P1e,
  Auswählen: "Auswählen",
  "Wählen Sie eine Vorlage aus:": "Wählen Sie eine Vorlage aus:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Sollen wir Ihren Konfigurator jetzt anlegen?",
  "Wir bringen Sie danach direkt in den Editor.": "Wir bringen Sie danach direkt in den Editor.",
  "Anlegen & zum Konfigurator": "Anlegen & zum Konfigurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: U1e,
  OK: z1e,
  "Farbenanzahl im Fenster": "Farbenanzahl im Fenster",
  "Farbkachel Rundung": "Farbkachel Rundung",
  Opazität: "Opazität",
  Hervorhebung: O1e,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Ungültig gewordene Instanzen entfernen (statt ersetzen)",
  "Drag & Drop erlauben": "Drag & Drop erlauben",
  "Anzeige der Sortierungsschaltflächen": "Anzeige der Sortierungsschaltflächen",
  "Sortierung umkehren": "Sortierung umkehren",
  "Duplizierung erlauben": "Duplizierung erlauben",
  "Zeige Werte aus inneren Merkmalen an": "Zeige Werte aus inneren Merkmalen an",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt",
  "Innere Merkmalsnamen ausblenden": "Innere Merkmalsnamen ausblenden",
  "Als Warenkorb setzen?": "Als Warenkorb setzen?",
  "Gruppieren nach": "Gruppieren nach",
  "Komponenten direkt unter der Liste anzeigen": "Komponenten direkt unter der Liste anzeigen",
  Expression: Q1e,
  "Erfolgreich gespeichert": "Erfolgreich gespeichert",
  "Formel Editor": "Formel Editor",
  "Geben Sie Formeln von Merkmalen ein.": "Geben Sie Formeln von Merkmalen ein.",
  " Schreiben Sie z.B. Länge * Breite.": " Schreiben Sie z.B. Länge * Breite.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.",
  Ergebnis: j1e,
  "Keine Formel eingegeben": "Keine Formel eingegeben",
  "Formel: ": "Formel: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.",
  "Ergebnis: ": "Ergebnis: ",
  "Titel ausblenden": "Titel ausblenden",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Ausblenden der originalen Textur, wenn bedruckt wird?",
  "Erlaube Bildformate": "Erlaube Bildformate",
  "Minimum Horizontale Positionierung": "Minimum Horizontale Positionierung",
  "Maximum Horizontale Positionierung": "Maximum Horizontale Positionierung",
  "Minimum Vertikale Positionierung": "Minimum Vertikale Positionierung",
  "Maximum Vertikale Positionierung": "Maximum Vertikale Positionierung",
  "Minimale Skalierung": "Minimale Skalierung",
  "Maximale Skalierung": "Maximale Skalierung",
  "Optionaler Standardwert": "Optionaler Standardwert",
  Mindestwert: q1e,
  Maximalwert: _1e,
  Nachkommastellen: $1e,
  Schrittweite: eRe,
  "Zeige Knöpfe an": "Zeige Knöpfe an",
  "Benutze Vielfaches der Schrittweite": "Benutze Vielfaches der Schrittweite",
  Berechnet: tRe,
  "Zyklus Erkennung deaktivieren": "Zyklus Erkennung deaktivieren",
  Ändern: "Ändern",
  "Beispielhafte Beschreibung eines Wertes.": "Beispielhafte Beschreibung eines Wertes.",
  "Dies ist nur eine Info": "Dies ist nur eine Info",
  "Color Dropdown": "Farbauswahl Dropdown",
  "Color Radio": "Farbauswahl Radio",
  "Color Radio Cards": "Color Radio Cards",
  Farbauswahl: iRe,
  Komponentenliste: nRe,
  "Komponentenliste mit Popup": "Komponentenliste mit Popup",
  Komponentenkarten: rRe,
  Bildauswahl: gRe,
  Informationen: oRe,
  Zahleneingabe: lRe,
  "Radio Buttons": "Radio Buttons",
  "Radio Cards": "Radio Cards",
  "RAL-Farbauswahl": "RAL-Farbauswahl",
  Dropdown: aRe,
  Thumbnails: sRe,
  Schalter: IRe,
  "Schalter Card": "Schalter Card",
  Texteingabe: cRe,
  Beispieltext: dRe,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren",
  "Übergeordnete Merkmale": "Übergeordnete Merkmale",
  "Darstellungs-Optionen": "Darstellungs-Optionen",
  Optional: uRe,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Auswahl nur anzeigen, wenn ausgewählt",
  "Konfigurator erfolgreich veröffentlicht.": "Konfigurator erfolgreich veröffentlicht.",
  "Folgende Änderungen werden veröffentlicht:": "Folgende Änderungen werden veröffentlicht:",
  "Konfigurator veröffentlichen": "Konfigurator veröffentlichen",
  "Sie möchten den Konfigurator veröffentlichen?": "Sie möchten den Konfigurator veröffentlichen?",
  "Wertebereich angeben": "Wertebereich angeben",
  "Merkmale: ": "Merkmale: ",
  "Aktionen: ": "Aktionen: ",
  "Diese Regel ist aktuell deaktiviert.": "Diese Regel ist aktuell deaktiviert.",
  "Neue Spalten Hinzufügen": "Neue Spalten Hinzufügen",
  Bedingungen: CRe,
  "Merkmale ausblenden": "Merkmale ausblenden",
  "Schritt ausblenden": "Schritt ausblenden",
  "Werte ausblenden": "Werte ausblenden",
  "Konfigurator-Abschluss festlegen": "Konfigurator-Abschluss festlegen",
  "Befüllen von Komponentenmerkmalen": "Befüllen von Komponentenmerkmalen",
  "Bilder auf Oberflächen drucken": "Bilder auf Oberflächen drucken",
  "Anzeige von Bildern": "Anzeige von Bildern",
  "Ändern der Farbe": "Ändern der Farbe",
  "Austauschen von Oberflächen": "Austauschen von Oberflächen",
  "Anzeige von Informationen": "Anzeige von Informationen",
  "Anzeige von Fehlermeldungen": "Anzeige von Fehlermeldungen",
  "Anzeige von 3D-Modellen": "Anzeige von 3D-Modellen",
  "Artikel zur Stückliste hinzufügen": "Artikel zur Stückliste hinzufügen",
  "Ein oder mehrere Merkmal Spalten hinzufügen": "Ein oder mehrere Merkmal Spalten hinzufügen",
  "Ein oder mehrere Komponenten Spalten hinzufügen": "Ein oder mehrere Komponenten Spalten hinzufügen",
  "Ein oder mehrere Schritte hinzufügen": "Ein oder mehrere Schritte hinzufügen",
  "Ein oder mehrere Artikel Spalten hinzufügen": "Ein oder mehrere Artikel Spalten hinzufügen",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen.": "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen.",
  Materialnamen: ARe,
  "Wählen Sie Materialnamen aus, worauf Bilder gedruckt werden sollen in Abhängigkeit von Bild Merkmalen.": "Wählen Sie Materialnamen aus, worauf Bilder gedruckt werden sollen in Abhängigkeit von Bild Merkmalen.",
  "Modell Eigenschaften anpassen": "Modell Eigenschaften anpassen",
  Labelaktion: bRe,
  Fehlermeldung: hRe,
  "Merkmale entfernen": "Merkmale entfernen (veraltet)",
  "Schritt entfernen": "Schritt entfernen",
  Modelaktion: mRe,
  "Bitte fügen Sie neue Spalten hinzu.": "Bitte fügen Sie neue Spalten hinzu.",
  "Sie brauchen mindestens eine Spalte.": "Sie brauchen mindestens eine Spalte.",
  "Nr.": "Nr.",
  "Gültigkeit prüfen": "Gültigkeit prüfen",
  "Keine Warnungen": "Keine Warnungen",
  "Alle Regeln ansehen": "Alle Regeln ansehen",
  Position: pRe,
  "Rotation (in radiant)": "Rotation (in radiant)",
  Scale: BRe,
  "Kein Label angegeben!": "Kein Label angegeben!",
  "Regel Validierung": "Regel Validierung",
  "Fehlende Werte": "Fehlende Werte",
  "Zugeordnete Merkmale": "Zugeordnete Merkmale",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen",
  Komponentenmerkmale: fRe,
  "Wählen Sie Komponentenmerkmale aus.": "Wählen Sie Komponentenmerkmale aus.",
  "Oberflächenaktion hinzufügen": "Oberflächenaktion hinzufügen",
  "Alle auswählen": "Alle auswählen",
  "Alle abwählen": "Alle abwählen",
  "Auswahl umkehren": "Auswahl umkehren",
  Herunterladen: ZRe,
  "Jetzt verbinden": "Jetzt verbinden",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Das flexible Shopsystem für Ihr E-Commerce-Projekt.",
  "Jetzt Installieren": "Jetzt Installieren",
  "Die globale Commerce-Plattform.": "Die globale Commerce-Plattform.",
  "Die E-Commerce-Plattform für WordPress.": "Die E-Commerce-Plattform für WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Die eine europäische Open-Source-E-Commerce-Plattform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Jetzt Adobe Commerce: E-Commerce leicht gemacht.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.",
  "Individuelle Entwicklung": "Individuelle Entwicklung",
  "Shop mit einer individuellen Entwicklung anbinden.": "Shop mit einer individuellen Entwicklung anbinden.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:",
  "Verbinde Shop": "Verbinde Shop",
  " und importiere Artikel": " und importiere Artikel",
  "Fehler beim Verbinden:": "Fehler beim Verbinden:",
  "Shop erfolgreich verbunden.": "Shop erfolgreich verbunden.",
  "Fehler beim Verbinden: ": "Fehler beim Verbinden: ",
  "Web-Adresse des Shops": "Web-Adresse des Shops",
  "Sollen die Artikel aus dem Shop importiert werden?": "Sollen die Artikel aus dem Shop importiert werden?",
  "Filter für Artikel": "Filter für Artikel",
  "Sollen die Artikel regelmäßig importiert werden?": "Sollen die Artikel regelmäßig importiert werden?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Soll die Artikelnummer der Shop-SKU entnommen werden?",
  "Wenn Sie diese Einstellung ändern, wird der nächste Artikel-Import die Artikel duplizieren.": "Wenn Sie diese Einstellung ändern, wird der nächste Artikel-Import die Artikel duplizieren.",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Sollen die Artikel bei der Bestellung zusammengefasst werden?",
  "Basis-Name für kombinierte Artikel": "Basis-Name für kombinierte Artikel",
  "Ihre Bestellung {code}": "Ihre Bestellung {code}",
  "Shop-Anbindung aufheben": "Shop-Anbindung aufheben",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Fügen Sie den Konfigurator Ihrem Shop hinzu",
  Verbinden: GRe,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.",
  "Der eingegebe Wert ist nicht gültig: ": "Der eingegebe Wert ist nicht gültig: ",
  "Ungültiges HTML-Format": "Ungültiges HTML-Format",
  "Sie können uns den Vorfall hier melden!": "Sie können uns den Vorfall hier melden!",
  "Das Template konnte nicht geladen werden.": "Das Template konnte nicht geladen werden.",
  "Templat auf Voreinstellung zurücksetzen": "Templat auf Voreinstellung zurücksetzen",
  "Eingaben zurücksetzen": "Eingaben zurücksetzen",
  "Templat bearbeiten": "Templat bearbeiten",
  "Templat Name": "Templat Name",
  "Templat wählen": "Templat wählen",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.",
  "Templat hinzufügen": "Templat hinzufügen",
  "Ansicht auswählen": "Ansicht auswählen",
  "Datei hochladen": "Datei hochladen",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Bitte buchen Sie zunächst ein anderes Produkt:",
  "Bitte wählen": "Bitte wählen",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):",
  "Automatisch angelegt": "Automatisch angelegt",
  "Aktionen verknüpfen": "Aktionen verknüpfen",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Werte von diesem Merkmal sollen folgende Aktionen auslösen:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.",
  "Zu den Regeln": "Zu den Regeln",
  "Artikel bestellen": "Artikel bestellen",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.",
  "Oberfläche ändern": "Oberfläche ändern",
  "Welche Oberflächen sollen geändert werden? ": "Welche Oberflächen sollen geändert werden? ",
  "3D-Modell anzeigen": "3D-Modell anzeigen",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.",
  "Bild anzeigen": "Bild anzeigen",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.",
  "Farbe ändern": "Farbe ändern",
  "Welche Oberflächen sollen eingefärbt werden? ": "Welche Oberflächen sollen eingefärbt werden? ",
  "Bild aufdrucken": "Bild aufdrucken",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ",
  "Der Wert wird noch in Regeln verwendet:": "Der Wert wird noch in Regeln verwendet:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde",
  "Dieser Wert ist nicht erlaubt.": "Dieser Wert ist nicht erlaubt.",
  "Maximale Anzahl an Werten ist erreicht.": "Maximale Anzahl an Werten ist erreicht.",
  Farbwert: yRe,
  Anzeige: WRe,
  RAL: SRe,
  "keine RAL Farbe": "keine RAL Farbe",
  Ansicht: VRe,
  "Key eingeben": "Key eingeben",
  URL: wRe,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Info-Content",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Dieser Merkmalstyp unterstützt keine Werte.",
  "Fehlende RAL Farben hinzufügen": "Fehlende RAL Farben hinzufügen",
  Auswahlwerte: vRe,
  "Typ des Merkmals": "Typ des Merkmals",
  "Merkmal {{label}} nicht gefunden!": "Merkmal {{label}} nicht gefunden!",
  "Attribut {{label}} nicht gefunden!": "Attribut {{label}} nicht gefunden!",
  "Syntaxfehler in der Expression!": "Syntaxfehler in der Expression!",
  "es gibt keine Merkmale mit {{identificator}}": "es gibt keine Merkmale mit {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "es gibt kein Attribut mit {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "es gibt keine Selection mit {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "es gibt mehr als eine Selection mit {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "Wert {{paramName}} der Funktion {{functionName}} ist null",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Es gibt einen Zyklus in den berechneten Merkmalen.",
  Übersicht: "Übersicht",
  Auswahlpreise: RRe,
  Auswahl: XRe,
  Gesamtpreis: HRe,
  "Preis Information": "Preis Information",
  "Persönliche Daten": "Persönliche Daten",
  "Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise": "Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise",
  "Bestätigen-Hinweistext bei invalidem Kontaktformular": "Bestätigen-Hinweistext bei invalidem Kontaktformular",
  Weiter: kRe,
  "Sie verwenden eine veraltete Version des Konfigurators.": "Sie verwenden eine veraltete Version des Konfigurators.",
  "Bestell-Warnhinweis bei veralteter Version": "Bestell-Warnhinweis bei veralteter Version",
  "In AR ansehen": "In AR ansehen",
  Vollbildmodus: YRe,
  "Komponenten suchen": "Komponenten suchen",
  "Nicht Gruppiert": "Nicht Gruppiert",
  Komponenten: FRe,
  "Komponenten hinzufügen": "Komponenten hinzufügen",
  xl: xRe,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:",
  "Bei Auswahl wird eine Alternative berechnet!": "Bei Auswahl wird eine Alternative berechnet!",
  Bestätigen: "Bestätigen",
  "Produkt hinzufügen": "Produkt hinzufügen",
  "Produkt erfolgreich konfiguriert": "Produkt erfolgreich konfiguriert",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?",
  "Neues Produkt auswählen": "Neues Produkt auswählen",
  "Neues Produkt hinzufügen": "Neues Produkt hinzufügen",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Meldung bei Zurücksetzen einer ungültigen Auswahl",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Meldung bei Auftreten eines Konflikts",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Meldung bei Auftreten von zwei Konflikten",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Meldung bei Auftreten von drei oder mehr Konflikten",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.',
  Konfliktmeldung: DRe,
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen.": "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen.",
  "Anpassung nötig": "Anpassung",
  "Stattdessen werden folgende Auswahlen angepasst:": "Stattdessen werden folgende Auswahlen angepasst:",
  "wird zu": "wird zu",
  "wird entfernt": "wird entfernt",
  "Optionaler weiterer Hinweistext:": "Optionaler weiterer Hinweistext:",
  "Auf Facebook teilen": "Auf Facebook teilen",
  "Auf Twitter teilen": "Auf Twitter teilen",
  "Auf LinkedIn teilen": "Auf LinkedIn teilen",
  "Modal Titel": "Modal Titel",
  "Desktop Gerät erkannt": "Desktop Gerät erkannt",
  "Modal Text": "Modal Text",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:",
  "Mobiles {{device}}-Gerät erkannt": "Mobiles {{device}}-Gerät erkannt",
  "Fortschrittsanzeige 3D-Objekt": "Fortschrittsanzeige 3D-Objekt",
  "Export des 3D-Objekts": "Export des 3D-Objekts",
  "Fortschrittsanzeige AR-Datei": "Fortschrittsanzeige AR-Datei",
  "Bereitstellen der AR-Datei": "Bereitstellen der AR-Datei",
  "Fortschrittsanzeige System": "Fortschrittsanzeige System",
  "{{device}}-AR-System einrichten": "{{device}}-AR-System einrichten",
  Positionszeile: JRe,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Artikelnummer Spalte",
  "Artikel Spalte": "Artikel Spalte",
  "Artikelpreis Spalte": "Artikelpreis Spalte",
  "Artikelmenge Spalte": "Artikelmenge Spalte",
  Menge: ERe,
  "Artikelanzahl Spalte": "Artikelanzahl Spalte",
  "Positionspreis Spalte": "Positionspreis Spalte",
  Positionspreis: NRe,
  "Hilfetext Preisdetails": "Hilfetext Preisdetails",
  "Preisdetails anzeigen": "Preisdetails anzeigen",
  "Titel bei Versions-Konflikt": "Titel bei Versions-Konflikt",
  "Konfigurator wurde aktualisiert": "Konfigurator wurde aktualisiert",
  "Text bei Versions-Konflikt": "Text bei Versions-Konflikt",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?",
  "Hilfetext Auswahl Ändern": "Hilfetext Auswahl Ändern",
  "Merkmal ändern": "Merkmal ändern",
  "Hilfetext Auswahl Entfernen": "Hilfetext Auswahl Entfernen",
  "Auswahl entfernen": "Auswahl entfernen",
  "Alte Version": "Alte Version",
  "Aktuelle Version": "Aktuelle Version",
  "Zeige Namen": "Zeige Namen",
  "Zeige Beschreibung": "Zeige Beschreibung",
  "Zeige Thumbnail": "Zeige Thumbnail",
  "Zeige Preis an Merkmal": "Zeige Preis an Merkmal",
  "Zeige Preise an Werten": "Zeige Preise an Werten",
  "Zeige URL": "Zeige URL",
  "Zeige Info-Button für Werte": "Zeige Info-Button für Werte",
  "Zeige HTML Content für Werte": "Zeige HTML Content für Werte",
  "Kamerafahrt beim scrollen": "Kamerafahrt beim scrollen",
  "Alle ungültigen Werte ausblenden": "Alle ungültigen Werte ausblenden",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Ungültige, aktiv geänderte, Werte ausblenden",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Ausblenden wenn nur eine Auswahl möglich ist",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Deaktivieren wenn nur eine Auswahl möglich ist",
  "Komponente hervorheben": "Komponente hervorheben",
  Bild: LRe,
  "Ja/ Nein": "Ja/ Nein",
  Information: KRe,
  Mehrfachauswahl: TRe,
  Liste: MRe,
  Eckenrundung: PRe,
  "Anzahl der Eckenrundungsschritte": "Anzahl der Eckenrundungsschritte",
  "Dieses Material existiert bereits": "Dieses Material existiert bereits",
  "Material hinzufügen": "Material hinzufügen",
  "Materialname eingeben": "Materialname eingeben",
  Abmessungen: URe,
  Breite: zRe,
  Höhe: "Höhe",
  Tiefe: ORe,
  Operation: QRe,
  Segmente: jRe,
  Pfad: qRe,
  Startpunkt: _Re,
  Endpunkt: $Re,
  Linienstärke: "Linienstärke",
  Startanker: eXe,
  Maßkette: "Maßkette",
  Ohne: tXe,
  Endanker: iXe,
  Texttyp: nXe,
  "Kein Text": "Kein Text",
  Zahlenwert: rXe,
  "Statischer Text": "Statischer Text",
  "Automatisches Maß überschreiben": "Automatisches Maß überschreiben",
  "Neues Maß": "Neues Maß",
  "Textgröße als Faktor. 1 ist Standard.": "Textgröße als Faktor. 1 ist Standard.",
  Offsets: gXe,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.",
  Blau: oXe,
  Grün: "Grün",
  Gelb: lXe,
  Rot: aXe,
  Purpur: sXe,
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.",
  "Nicht Befüllt": "Nicht Befüllt",
  Abkhazian: IXe,
  Afar: cXe,
  Afrikaans: dXe,
  Akan: uXe,
  Albanian: CXe,
  Amharic: AXe,
  Arabic: bXe,
  Aragonese: hXe,
  Armenian: mXe,
  Assamese: pXe,
  Avaric: BXe,
  Avestan: fXe,
  Aymara: ZXe,
  Azerbaijani: GXe,
  Bambara: yXe,
  Bashkir: WXe,
  Basque: SXe,
  Belarusian: VXe,
  Bengali: wXe,
  Bislama: vXe,
  Bosnian: RXe,
  Breton: XXe,
  Bulgarian: HXe,
  Burmese: kXe,
  "Catalan, Valencian": "Katalanisch, Valencianisch",
  Chamorro: YXe,
  Chechen: FXe,
  "Chichewa, Chewa, Nyanja": "Chichewa, Chewa, Nyanja",
  Chinese: xXe,
  "Church Slavonic, Old Slavonic, Old Church Slavonic": "Kirchenslawisch, Altslawisch, Altkirchenslawisch",
  Chuvash: DXe,
  Cornish: JXe,
  Corsican: EXe,
  Cree: NXe,
  Croatian: LXe,
  Czech: KXe,
  Danish: TXe,
  "Divehi, Dhivehi, Maldivian": "Dhivehi, Maledivisch",
  "Dutch, Flemish": "Niederländisch, Flämisch",
  Dzongkha: MXe,
  English: PXe,
  Esperanto: UXe,
  Estonian: zXe,
  Ewe: OXe,
  Faroese: QXe,
  Fijian: jXe,
  Finnish: qXe,
  French: _Xe,
  "Western Frisian": "Westfriesisch",
  Fulah: $Xe,
  "Gaelic, Scottish Gaelic": "Gälisch, Schottisch-Gälisch",
  Galician: eHe,
  Ganda: tHe,
  Georgian: iHe,
  German: nHe,
  "Greek, Modern (1453-)": "Griechisch, Modern (1453-)",
  "Kalaallisut, Greenlandic": "Kalaallisut, Grönländisch",
  Guarani: rHe,
  Gujarati: gHe,
  "Haitian, Haitian Creole": "Haitianisch, Haitianisches Kreolisch",
  Hausa: oHe,
  Hebrew: lHe,
  Herero: aHe,
  Hindi: sHe,
  "Hiri Motu": "Hiri Motu",
  Hungarian: IHe,
  Icelandic: cHe,
  Ido: dHe,
  Igbo: uHe,
  Indonesian: CHe,
  "Interlingua (International Auxiliary Language Association)": "Interlingua (Internationale Hilfssprache)",
  "Interlingue, Occidental": "Interlingue, Occidental",
  Inuktitut: AHe,
  Inupiaq: bHe,
  Irish: hHe,
  Italian: mHe,
  Japanese: pHe,
  Javanese: BHe,
  Kannada: fHe,
  Kanuri: ZHe,
  Kashmiri: GHe,
  Kazakh: yHe,
  "Central Khmer": "Zentral-Khmer",
  "Kikuyu, Gikuyu": "Kikuyu, Gikuyu",
  Kinyarwanda: WHe,
  "Kirghiz, Kyrgyz": "Kirgisisch",
  Komi: SHe,
  Kongo: VHe,
  Korean: wHe,
  "Kuanyama, Kwanyama": "Kuanyama, Kwanyama",
  Kurdish: vHe,
  Lao: RHe,
  Latin: XHe,
  Latvian: HHe,
  "Limburgan, Limburger, Limburgish": "Limburgisch",
  Lingala: kHe,
  Lithuanian: YHe,
  "Luba-Katanga": "Luba-Katanga",
  "Luxembourgish, Letzeburgesch": "Luxemburgisch",
  Macedonian: FHe,
  Malagasy: xHe,
  Malay: DHe,
  Malayalam: JHe,
  Maltese: EHe,
  Manx: NHe,
  Maori: LHe,
  Marathi: KHe,
  Marshallese: THe,
  Mongolian: MHe,
  Nauru: PHe,
  "Navajo, Navaho": "Navajo, Navaho",
  "North Ndebele": "Nord-Ndebele",
  "South Ndebele": "Süd-Ndebele",
  Ndonga: UHe,
  Nepali: zHe,
  Norwegian: OHe,
  "Norwegian Bokmål": "Norwegisch Bokmål",
  "Norwegian Nynorsk": "Norwegisch Nynorsk",
  "Sichuan Yi, Nuosu": "Sichuan Yi, Nuosu",
  Occitan: QHe,
  Ojibwa: jHe,
  Oriya: qHe,
  Oromo: _He,
  "Ossetian, Ossetic": "Ossetisch",
  Pali: $He,
  "Pashto, Pushto": "Paschtu",
  Persian: eke,
  Polish: tke,
  Portuguese: ike,
  "Punjabi, Panjabi": "Pandschabi",
  Quechua: nke,
  "Romanian, Moldavian, Moldovan": "Rumänisch",
  Romansh: rke,
  Rundi: gke,
  Russian: oke,
  "Northern Sami": "Nordsamisch",
  Samoan: lke,
  Sango: ake,
  Sanskrit: ske,
  Sardinian: Ike,
  Serbian: cke,
  Shona: dke,
  Sindhi: uke,
  "Sinhala, Sinhalese": "Singhalesisch",
  Slovak: Cke,
  Slovenian: Ake,
  Somali: bke,
  "Southern Sotho": "Süd-Sotho",
  "Spanish, Castilian": "Spanisch",
  Sundanese: hke,
  Swahili: mke,
  Swati: pke,
  Swedish: Bke,
  Tagalog: fke,
  Tahitian: Zke,
  Tajik: Gke,
  Tamil: yke,
  Tatar: Wke,
  Telugu: Ske,
  Thai: Vke,
  Tibetan: wke,
  Tigrinya: vke,
  "Tonga (Tonga Islands)": "Tonga (Tonga-Inseln)",
  Tsonga: Rke,
  Tswana: Xke,
  Turkish: Hke,
  Turkmen: kke,
  Twi: Yke,
  "Uighur, Uyghur": "Uigurisch",
  Ukrainian: Fke,
  Urdu: xke,
  Uzbek: Dke,
  Venda: Jke,
  Vietnamese: Eke,
  Volapük: "Volapük",
  Walloon: Nke,
  Welsh: Lke,
  Wolof: Kke,
  Xhosa: Tke,
  Yiddish: Mke,
  Yoruba: Pke,
  "Zhuang, Chuang": "Zhuang, Chuang",
  Zulu: Uke
}, Oke = "Liste", Qke = "Farben", jke = "Text", qke = "Ja/ Nein", _ke = "Information", $ke = "Bild", eYe = "Komponenten", tYe = "Darstellung", iYe = "Aktionen", nYe = "Werte", rYe = "Regeln", gYe = "Optionen", oYe = "Bilder", lYe = "Konfiguratoren", aYe = "Straße", sYe = "Postleitzahl", IYe = "Stadt", cYe = "Land", dYe = "Extrahieren", uYe = "Telefon", CYe = "Nutzername", AYe = "MATERIAL", bYe = "Import", hYe = "Manuell", mYe = "Rotation", pYe = "Allgemeines", BYe = "Beschaffenheit", fYe = "Roughness", ZYe = "Metallness", GYe = "Bilderstapel", yYe = "Szeneneinstellungen", WYe = "Themes", SYe = "Anpassung", VYe = "Wertebereich", wYe = "Darstellung", vYe = "Werte", RYe = "Anfragen", XYe = "Zeitpunkt", HYe = "Anfrage", kYe = "URI", YYe = "Parameter", FYe = "Dauer", xYe = "Server", DYe = "Anzahl", JYe = "Artikel", EYe = "Vollbildmodus", NYe = {
  always: "Immer",
  never: "Nie",
  auto: "Wie im Konfigurator",
  label: "Anzeige in Bestätigung, PDF und Shop"
}, LYe = "Aktivieren", KYe = "Deaktivieren", TYe = "Merkmale und Artikel", MYe = "Nur Merkmale", PYe = "Nur Artikel", UYe = "Keine Übersicht", zYe = "Allgemein", OYe = "PDF", QYe = "Mail", jYe = "Einbetten", qYe = "Shop", _Ye = "Artikel", $Ye = "Vorschau", eFe = "Editor", tFe = "Bilder", iFe = "Materialien", nFe = "Modelle", rFe = "Regeln", gFe = "Optionen", oFe = "Admin", lFe = "extract", aFe = "Konfiguratoren", sFe = "Erstellen", IFe = "Importieren", cFe = "Benutzer", dFe = "Support", uFe = "Logs", CFe = "Systemstatus", AFe = "Papierkorb", bFe = "Abonnement", hFe = "Ausgelaufen", mFe = "Profil", pFe = "Editor", BFe = "Konfigurationen", fFe = "Schritte", ZFe = "Merkmale", GFe = "Design", yFe = "Szene", WFe = "Darstellung", SFe = "Optionen", VFe = "Aktionen", wFe = "Werte", vFe = "Primärfarbe", RFe = "Sekundärfarbe", XFe = "Hintergrundfarbe", HFe = "Warnfarbe", kFe = "Standard", YFe = "Heller", FFe = "Dunkler", xFe = "Hervorgehoben", DFe = "Standard", JFe = "Ausgegraut", EFe = "Monat", NFe = "Jahr", LFe = "STRG", KFe = "Ersetzen", TFe = "Bestellen", MFe = "Deutschland", PFe = "Schweiz", UFe = "Andorra", zFe = "Belgien", OFe = "Belarus", QFe = "Bulgarien", jFe = "Tschechien", qFe = "Vatikanstadt", _Fe = "Montenegro", $Fe = "Estland", exe = "Spanien", txe = "Frankreich", ixe = "Guernsey", nxe = "Kroatien", rxe = "Irland", gxe = "Island", oxe = "Italien", lxe = "Jersey", axe = "Albanien", sxe = "Kosovo", Ixe = "Lettland", cxe = "Lithauen", dxe = "Luxemburg", uxe = "Ungarn", Cxe = "Monaco", Axe = "Niederlande", bxe = "Norwegen", hxe = "Polen", mxe = "Portugal", pxe = "Kasachstan", Bxe = "Malta", fxe = "Moldau", Zxe = "Russland", Gxe = "Slowenien", yxe = "Slowakei", Wxe = "Serbien", Sxe = "Finnland", Vxe = "Schweden", wxe = "Ukraine", vxe = "Zypern", Rxe = "Griechenland", Xxe = "Nordmazedonien", Hxe = {
  list: Oke,
  color: Qke,
  text: jke,
  boolean: qke,
  information: _ke,
  image: $ke,
  components: eYe,
  presentation: tYe,
  usage: iYe,
  values: nYe,
  rules: rYe,
  settings: gYe,
  images: oYe,
  configurators: lYe,
  street: aYe,
  zip: sYe,
  city: IYe,
  country: cYe,
  extract: dYe,
  phone: uYe,
  username: CYe,
  "duplicate-entry": "Es existieren bereits Konten mit diesen Daten",
  "create new dealer": "Neuen Händler anlegen",
  "Artikel Anzahl": "Artikel Anzahl",
  "Farb auswählen": "Farb auswählen",
  "< Zurück": "< Zurück",
  "Merkmal auswählen": "Merkmal auswählen",
  MATERIAL: AYe,
  Import: bYe,
  "Materialien für den Import auswählen:": "Materialien für den Import auswählen:",
  "Wie möchten Sie ein Material erstellen?": "Wie möchten Sie ein Material erstellen?",
  "Import einer .glb und export der enthaltenen Materialien": "Import einer .glb und export der enthaltenen Materialien",
  Manuell: hYe,
  "Eigenständiges Anlegen eines PBR-Materials": "Eigenständiges Anlegen eines PBR-Materials",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Löschen Sie bitte zunächst dort die entsprechende Spalte.",
  "Design & Layout": "Design & Layout",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!",
  "Theme wählen": "Theme wählen",
  "Komponente löschen": "Komponente löschen",
  "Mehrfach Regelzeilen Bearbeitung": "Mehrfach Regelzeilen Bearbeitung",
  "Anzahl ausgewählte Regel-Zeilen:": "Anzahl ausgewählte Regel-Zeilen:",
  "Modelaktions-Positionierung": "Modelaktions-Positionierung",
  Rotation: mYe,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Keine Aktionen für die Mehrfachbearbeitung vorhanden.",
  Allgemeines: pYe,
  "Farben und Lichtinteraktion": "Farben und Lichtinteraktion",
  "Color-Map Upload": "Color-Map Upload",
  "Material interagiert mit Licht in der Szene": "Material interagiert mit Licht in der Szene",
  Beschaffenheit: BYe,
  "Roughness-Map Upload": "Roughness-Map Upload",
  Roughness: fYe,
  "Metallness-Map Upload": "Metallness-Map Upload",
  Metallness: ZYe,
  "Normalen-Map Upload": "Normalen-Map Upload",
  "Normalen-Skalierung": "Normalen-Skalierung",
  "Anwendung auf 3D-Modell": "Anwendung auf 3D-Modell",
  "Displacement-Map Upload": "Displacement-Map Upload",
  "Displacement-Skalierung": "Displacement-Skalierung",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat-Faktor der Textur in X- und Y-Richtung",
  "Alpha-Werte": "Alpha-Werte",
  "Alpha-Map Upload": "Alpha-Map Upload",
  "Ambient Occlusion": "Ambient Occlusion",
  "Ambient-Occlusion-Map Upload": "Ambient-Occlusion-Map Upload",
  "Info editieren": "Info editieren",
  "Zeige Info-Button": "Zeige Info-Button",
  Abhängigkeitsschleifen: "Abhängigkeitsschleifen",
  Bilderstapel: GYe,
  "Google Analytics Property ID": "Google Analytics Property ID",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Die eine europäische Open-Source-E-Commerce-Plattform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Jetzt Adobe Commerce: E-Commerce leicht gemacht.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.",
  "Individuelle Entwicklung": "Individuelle Entwicklung",
  "Shop mit einer individuellen Entwicklung anbinden.": "Shop mit einer individuellen Entwicklung anbinden.",
  Szeneneinstellungen: yYe,
  Themes: WYe,
  Anpassung: SYe,
  "Gewähltes Theme übernehmen": "Gewähltes Theme übernehmen",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Legen Sie einen neuen Konfigurationsschritt an.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.",
  "Konfigurationsschritt erstellen": "Konfigurationsschritt erstellen",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.",
  "Neuer Konfigurator wählen": "Neuer Konfigurator wählen",
  "Bitte geben Sie einen Namen ein.": "Bitte geben Sie einen Namen ein.",
  "Bitte geben Sie eine Beschreibung ein.": "Bitte geben Sie eine Beschreibung ein.",
  "Bitte klicken Sie hier.": "Bitte klicken Sie hier.",
  "Konfigurator Dialog aufrufen": "Konfigurator Dialog aufrufen",
  "Konfigurationsschritt benennen": "Konfigurationsschritt benennen",
  "Hier können Sie neue Werte hinzufügen.": "Hier können Sie neue Werte hinzufügen.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Klicken Sie hier um einen neuen Wert zu erstellen.",
  "Wenn Sie fertig sind klicken Sie hier.": "Wenn Sie fertig sind klicken Sie hier.",
  "Werte erstellen": "Werte erstellen",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Bitte geben Sie einen Namen für das neue Merkmal ein.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.",
  "Präsentation definieren": "Präsentation definieren",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.",
  "Produktmerkmal erstellen": "Produktmerkmal erstellen",
  "Was für ein Merkmal wollen Sie anlegen?": "Was für ein Merkmal wollen Sie anlegen?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.",
  "Produktmerkmaltyp auswählen": "Produktmerkmaltyp auswählen",
  "Wählen sie den eben erstellten Konfigurator.": "Wählen sie den eben erstellten Konfigurator.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Steuerung des Konfigurators durch das neue Merkmal.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.",
  "Merkmal verwenden": "Merkmal verwenden",
  Wertebereich: VYe,
  Darstellung: wYe,
  Werte: vYe,
  Anfragen: RYe,
  Zeitpunkt: XYe,
  Anfrage: HYe,
  URI: kYe,
  Parameter: YYe,
  Dauer: FYe,
  Server: xYe,
  "Modell bearbeiten": "Modell bearbeiten",
  "Korrekte Mail-Adresse": "Korrekte Mail-Adresse",
  "Statistik (30 Tage)": "Statistik (30 Tage)",
  amount: DYe,
  article: JYe,
  "Datum eingeben": "Datum eingeben",
  "Nach hause ": "Nach hause ",
  "Mandant anlegen": "Mandant anlegen",
  "Nutzer hinzufügen": "Nutzer hinzufügen",
  Fullscreen: EYe,
  showSelection: NYe,
  "Kamera überschreiben": "Kamera überschreiben",
  Aktivieren: LYe,
  Deaktivieren: KYe,
  Übersichtsseite: "Übersichtsseite",
  variablesAndArticles: TYe,
  variablesOnly: MYe,
  articlesOnly: PYe,
  noOverview: UYe,
  breadcrumb_app: zYe,
  breadcrumb_pdf: OYe,
  breadcrumb_mail: QYe,
  breadcrumb_embed: jYe,
  breadcrumb_shop: qYe,
  breadcrumb_articles: _Ye,
  breadcrumb_preview: $Ye,
  breadcrumb_edit: eFe,
  breadcrumb_images: tFe,
  breadcrumb_materials: iFe,
  breadcrumb_models: nFe,
  breadcrumb_rules: rFe,
  breadcrumb_settings: gFe,
  breadcrumb_admin: oFe,
  breadcrumb_extract: lFe,
  breadcrumb_apps: aFe,
  breadcrumb_create: sFe,
  breadcrumb_import: IFe,
  breadcrumb_users: cFe,
  breadcrumb_support: dFe,
  breadcrumb_logs: uFe,
  breadcrumb_systemStatus: CFe,
  breadcrumb_trash: AFe,
  breadcrumb_abonnement: bFe,
  breadcrumb_expired: hFe,
  breadcrumb_profile: mFe,
  breadcrumb_configurator: pFe,
  breadcrumb_configurations: BFe,
  breadcrumb_groups: fFe,
  breadcrumb_variables: ZFe,
  breadcrumb_design: GFe,
  breadcrumb_scene: yFe,
  breadcrumb_presentation: WFe,
  breadcrumb_options: SFe,
  breadcrumb_usage: VFe,
  breadcrumb_values: wFe,
  Primary: vFe,
  Secondary: RFe,
  Background: XFe,
  Warning: HFe,
  Error: "Fehlerfarbe",
  Main: kFe,
  Light: YFe,
  Dark: FFe,
  "Contrast Text": "(Kontast-)Textfarbe",
  Paper: xFe,
  Default: DFe,
  Disabled: JFe,
  "Content Main": "Canvas Hintergrundfarbe",
  "Scrollbar Default": "Scrollbar Farbe",
  "Letzter Schritt kann nicht gelöscht werden.": "Letzter Schritt kann nicht gelöscht werden.",
  "Dieses Merkmal ist versteckt.": "Dieses Merkmal ist versteckt.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: 
 1. Es wurde per Regel ausgeblendet. 
 2. Der zugehörige Schritt wurde entfernt.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!",
  "Vertikale Platzierung zulassen?": "Vertikale Platzierung zulassen?",
  "Suchfeld ausblenden?": "Suchfeld ausblenden?",
  Modalgröße: "Modalgröße",
  "Anzahl an Komponenten pro Zeile": "Anzahl an Komponenten pro Zeile",
  month: EFe,
  year: NFe,
  "Weitere Preisauswirkungen dieser Selektion": "Weitere Preisauswirkungen dieser Selektion",
  "Aktion verstecken": "Aktion verstecken",
  Ctrl: LFe,
  Ersetzen: KFe,
  "Bild hochladen": "Bild hochladen",
  "Das Dateiformat ist nicht erlaubt!": "Das Dateiformat ist nicht erlaubt!",
  Bestellen: TFe,
  "UST-ID": "Umsatzsteuer-Identifikationsnummer",
  Deutschland: MFe,
  Österreich: "Österreich",
  Schweiz: PFe,
  "Åland Inseln": "Åland Inseln",
  Andorra: UFe,
  Belgien: zFe,
  Belarus: OFe,
  "Bosnien und Herzegowina": "Bosnien und Herzegowina",
  Bulgarien: QFe,
  Tschechien: jFe,
  Vatikanstadt: qFe,
  Montenegro: _Fe,
  Dänemark: "Dänemark",
  Estland: $Fe,
  Spanien: exe,
  Färöer: "Färöer",
  Frankreich: txe,
  Guernsey: ixe,
  Kroatien: nxe,
  Irland: rxe,
  Island: gxe,
  "Isle of Man": "Isle of Man",
  Italien: oxe,
  Jersey: lxe,
  Albanien: axe,
  Kosovo: sxe,
  Lettland: Ixe,
  "Fürstentum Liechtenstein": "Fürstentum Liechtenstein",
  Lithauen: cxe,
  Luxemburg: dxe,
  Ungarn: uxe,
  Monaco: Cxe,
  Niederlande: Axe,
  Norwegen: bxe,
  Polen: hxe,
  Portugal: mxe,
  Kasachstan: pxe,
  Malta: Bxe,
  Moldau: fxe,
  Rumänien: "Rumänien",
  Russland: Zxe,
  "San Marino": "San Marino",
  Slowenien: Gxe,
  Slowakei: yxe,
  Serbien: Wxe,
  Finnland: Sxe,
  "Spitzbergen und Jan Mayen": "Spitzbergen und Jan Mayen",
  Schweden: Vxe,
  Türkei: "Türkei",
  Ukraine: wxe,
  "Vereinigtes Königreich": "Vereinigtes Königreich",
  Zypern: vxe,
  Griechenland: Rxe,
  Nordmazedonien: Xxe
}, kxe = {
  ...zke,
  ...Hxe
}, Yxe = "Client", Fxe = "Product", xxe = "Payment status", Dxe = "Clients", Jxe = "Admin", Exe = "Configurators", Nxe = "Create", Lxe = "Import", Kxe = "User", Txe = "Support", Mxe = "Logs", Pxe = "System Status", Uxe = "Trash", zxe = "Subscription", Oxe = "Expired", Qxe = "Profile", jxe = "Configurations", qxe = "Configurators", _xe = "Support", $xe = "Dealers", e5e = "Users", t5e = "Trash", i5e = "Help", n5e = "Subscription", r5e = "Profile", g5e = "Log out", o5e = "Template", l5e = "Invoke", a5e = "PDF", s5e = "Code", I5e = "Price", c5e = "Inspiration", d5e = "Action", u5e = "Language", C5e = "Customer", A5e = "Content", b5e = "Configurator version", h5e = "Cancel", m5e = "Close", p5e = "Field", B5e = "Edit", f5e = "Address", Z5e = "Privacy policy", G5e = "Name", y5e = "Email", W5e = "Phone", S5e = "Remark", V5e = "Company", w5e = "Accepted", v5e = "City", R5e = "ZIP Code", X5e = "Country", H5e = "Date", k5e = "Dealer", Y5e = "json", F5e = "Price", x5e = "Options", D5e = "Order Action", J5e = "Type", E5e = "Configuration", N5e = "AR", L5e = "Shared", K5e = "Display", T5e = "Sort", M5e = "Article number", P5e = "Description", U5e = "Category", z5e = "Prices", O5e = "Article", Q5e = "Switch", j5e = "Upload", q5e = "None", _5e = "All", $5e = "Images", eDe = "Roughness", tDe = "Metalness", iDe = "Transparent", nDe = "Opacity", rDe = "Color", gDe = "Emissive", oDe = "Surface", lDe = "Front", aDe = "Back", sDe = "Both sides", IDe = "Transmission", cDe = "Reflectivity", dDe = "Clear Coat", uDe = "Options", CDe = "Designation", ADe = "Physically based rendering (PBR)", bDe = "Physical", hDe = "Key", mDe = "Model", pDe = "Advanced", BDe = "Edit", fDe = "Copy", ZDe = "Export", GDe = "Product visualization", yDe = "Main Model", WDe = "Upgrade", SDe = "Template", VDe = "Tutorial", wDe = "Tracking", vDe = "share", RDe = "Characteristics", XDe = "Discount", HDe = "Surcharge", kDe = "Save", YDe = "Embed", FDe = "Reference language", xDe = "Languages", DDe = "Font", JDe = "Helvetica", EDe = "Courier", NDe = "Interstate", LDe = "Montserrat", KDe = "Left", TDe = "Right", MDe = "Top", PDe = "Bottom", UDe = "Header", zDe = "General", ODe = "Mail", QDe = "Shop", jDe = "Leave", qDe = "Send", _De = "Orders", $De = "Date", eJe = "Days", tJe = "Article Name", iJe = "Articles", nJe = "Configurator", rJe = "Partner", gJe = "Provision", oJe = "name", lJe = "email", aJe = "User account", sJe = "Userame", IJe = "Password", cJe = "Login", dJe = "Registration", uJe = "Privacy Statement", CJe = "Terms", AJe = "Password", bJe = "Editor", hJe = "Default", mJe = "From", pJe = "Version", BJe = "Bookings", fJe = "Platform", ZJe = "Interval", GJe = "Subscription", yJe = "CustomerID", WJe = "Active", SJe = "Since", VJe = "Query", wJe = "Actions", vJe = "Booking", RJe = "Month", XJe = "Year", HJe = "Until", kJe = "Parameters", YJe = "Customers", FJe = "ID", xJe = "Invoices", DJe = "Blank", JJe = "Users", EJe = "Role", NJe = "Steps", LJe = "Values", KJe = "Rules", TJe = "Rule Entries", MJe = "Models", PJe = "Materials", UJe = "Characteristics", zJe = "Rule", OJe = "Number", QJe = "Status", jJe = "Created", qJe = "Password", _Je = "New", $Je = "Input", e9e = "Invite", t9e = "Download", i9e = "Background model", n9e = "Favorites", r9e = "Create", g9e = "Pricing settings", o9e = "Main action", l9e = "Contact form", a9e = "Mandatory field", s9e = "Action name", I9e = "Count", c9e = "Number calculation", d9e = "Quantity calculation", u9e = "Article action", C9e = "Number", A9e = "Unit", b9e = "Camera", h9e = "Step", m9e = "Camera view", p9e = "Camera type", B9e = "Perspective", f9e = "Orthographic", Z9e = "Focus type", G9e = "Duplicate", y9e = "Entfernen", W9e = "Cameras", S9e = "Interfaces", V9e = "free", w9e = "pro", v9e = "Downgrade", R9e = "Monthly", X9e = "Home", H9e = "Help", k9e = "cancel", Y9e = "GDPR", F9e = "Icon", x9e = "Logo", D9e = "Colors", J9e = "CSS", E9e = "Settings", N9e = "Preview", L9e = "Articles", K9e = "Orders", T9e = "Statistics", M9e = "Error", P9e = "Unknown Error", U9e = "An unknown error occured. If the error persists after reloading the page, please contact us:", z9e = "An Error occured", O9e = "Main completion", Q9e = "Completion", j9e = "Order options", q9e = "This step is currently only visible here (in admin-panel), because it contains only characteristics with no selectable options", _9e = "Text", $9e = "Background color", eEe = "Info", tEe = "Warning color", iEe = "Error color", nEe = "Basic settings", rEe = "Opacity", gEe = "Material action", oEe = "Colour action", lEe = "Image action", aEe = "Note", sEe = "Warning", IEe = "Continue", cEe = "Plus", dEe = "Minus", uEe = "Hidden", CEe = "ArticleNo", AEe = "ArticleName", bEe = "Currency", hEe = "Value", mEe = "Sidebar", pEe = "Start date", BEe = "End date", fEe = "Start number", ZEe = "End count", GEe = "Search", yEe = "Titel", WEe = "OK", SEe = "Highlight", VEe = "Expression", wEe = "Result", vEe = "Minimum value", REe = "Maximum value", XEe = "Decimal places", HEe = "Step size", kEe = "Calculate", YEe = "Color Selection", FEe = "Component List", xEe = "Component cards", DEe = "Image Selection", JEe = "Informationen", EEe = "Number input", NEe = "Dropdown", LEe = "Thumbnails", KEe = "Switch", TEe = "Text input", MEe = "Sample text", PEe = "Optional", UEe = "Conditions", zEe = "Material names", OEe = "Label action", QEe = "Error message", jEe = "Model action", qEe = "Position", _Ee = "Scale", $Ee = "Component proper", eNe = "Download", tNe = "Connect", iNe = "Colour value", nNe = "Label", rNe = "RAL", gNe = "View", oNe = "URL", lNe = "Values", aNe = "Selection prices", sNe = "Selection", INe = "Total price", cNe = "Next", dNe = "Fullscreen", uNe = "Components", CNe = "xl", ANe = "Conflict Message", bNe = "Item row", hNe = "Quantity", mNe = "Item Price", pNe = "Image", BNe = "Information", fNe = "Multiple choice", ZNe = "List", GNe = "Bevel", yNe = "Dimensions", WNe = "Width", SNe = "Depth", VNe = "Operation", wNe = "Segments", vNe = "Path", RNe = "Start point", XNe = "End point", HNe = "Starting anchor", kNe = "Without", YNe = "Ending anchor", FNe = "Text type", xNe = "Numberic value", DNe = "Offsets", JNe = "Blue", ENe = "Yellow", NNe = "Red", LNe = "Purple", KNe = "Abkhazian", TNe = "Afar", MNe = "Afrikaans", PNe = "Akan", UNe = "Albanian", zNe = "Amharic", ONe = "Arabic", QNe = "Aragonese", jNe = "Armenian", qNe = "Assamese", _Ne = "Avaric", $Ne = "Avestan", eLe = "Aymara", tLe = "Azerbaijani", iLe = "Bambara", nLe = "Bashkir", rLe = "Basque", gLe = "Belarusian", oLe = "Bengali", lLe = "Bislama", aLe = "Bosnian", sLe = "Breton", ILe = "Bulgarian", cLe = "Burmese", dLe = "Chamorro", uLe = "Chechen", CLe = "Chinese", ALe = "Chuvash", bLe = "Cornish", hLe = "Corsican", mLe = "Cree", pLe = "Croatian", BLe = "Czech", fLe = "Danish", ZLe = "Dzongkha", GLe = "English", yLe = "Esperanto", WLe = "Estonian", SLe = "Ewe", VLe = "Faroese", wLe = "Fijian", vLe = "Finnish", RLe = "French", XLe = "Fulah", HLe = "Galician", kLe = "Ganda", YLe = "Georgian", FLe = "German", xLe = "Guarani", DLe = "Gujarati", JLe = "Hausa", ELe = "Hebrew", NLe = "Herero", LLe = "Hindi", KLe = "Hungarian", TLe = "Icelandic", MLe = "Ido", PLe = "Igbo", ULe = "Indonesian", zLe = "Inuktitut", OLe = "Inupiaq", QLe = "Irish", jLe = "Italian", qLe = "Japanese", _Le = "Javanese", $Le = "Kannada", eKe = "Kanuri", tKe = "Kashmiri", iKe = "Kazakh", nKe = "Kinyarwanda", rKe = "Komi", gKe = "Kongo", oKe = "Korean", lKe = "Kurdish", aKe = "Lao", sKe = "Latin", IKe = "Latvian", cKe = "Lingala", dKe = "Lithuanian", uKe = "Macedonian", CKe = "Malagasy", AKe = "Malay", bKe = "Malayalam", hKe = "Maltese", mKe = "Manx", pKe = "Maori", BKe = "Marathi", fKe = "Marshallese", ZKe = "Mongolian", GKe = "Nauru", yKe = "Ndonga", WKe = "Nepali", SKe = "Norwegian", VKe = "Occitan", wKe = "Ojibwa", vKe = "Oriya", RKe = "Oromo", XKe = "Pali", HKe = "Persian", kKe = "Polish", YKe = "Portuguese", FKe = "Quechua", xKe = "Romansh", DKe = "Rundi", JKe = "Russian", EKe = "Samoan", NKe = "Sango", LKe = "Sanskrit", KKe = "Sardinian", TKe = "Serbian", MKe = "Shona", PKe = "Sindhi", UKe = "Slovak", zKe = "Slovenian", OKe = "Somali", QKe = "Sundanese", jKe = "Swahili", qKe = "Swati", _Ke = "Swedish", $Ke = "Tagalog", e3e = "Tahitian", t3e = "Tajik", i3e = "Tamil", n3e = "Tatar", r3e = "Telugu", g3e = "Thai", o3e = "Tibetan", l3e = "Tigrinya", a3e = "Tsonga", s3e = "Tswana", I3e = "Turkish", c3e = "Turkmen", d3e = "Twi", u3e = "Ukrainian", C3e = "Urdu", A3e = "Uzbek", b3e = "Venda", h3e = "Vietnamese", m3e = "Walloon", p3e = "Welsh", B3e = "Wolof", f3e = "Xhosa", Z3e = "Yiddish", G3e = "Yoruba", y3e = "Zulu", W3e = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "You do not pay online. Please contact the employee in your company who has signed the contract with ObjectCode..",
  Mandant: Yxe,
  Produkt: Fxe,
  Bezahlzustand: xxe,
  Mandanten: Dxe,
  Admin: Jxe,
  Konfiguratoren: Exe,
  Erstellen: Nxe,
  Importieren: Lxe,
  Benutzer: Kxe,
  Support: Txe,
  Logs: Mxe,
  Systemstatus: Pxe,
  Papierkorb: Uxe,
  Abonnement: zxe,
  Ausgelaufen: Oxe,
  Profil: Qxe,
  Konfigurationen: jxe,
  Händler: "Dealers",
  apps: qxe,
  support: _xe,
  "dealer-profile": "Dealer Profile",
  dealers: $xe,
  users: e5e,
  trash: t5e,
  help: i5e,
  subscription: n5e,
  profile: r5e,
  logout: g5e,
  "Neuer Konfigurator": "New configurator",
  Template: o5e,
  Zurück: "Back",
  Aufrufen: l5e,
  PDF: a5e,
  Code: s5e,
  Preis: I5e,
  Inspiration: c5e,
  Aktion: d5e,
  Sprache: u5e,
  "Sie möchten die Daten dieses Kunden einsehen?": "Would you like to view this customer's data?",
  Kunde: C5e,
  Inhalt: A5e,
  "Shop-API": "Store API",
  "Gespeichert am": "Saved on",
  Konfiguratorversion: b5e,
  Abbrechen: h5e,
  "Ergebnis der Shop API": "Store API result",
  Schliessen: m5e,
  Feld: p5e,
  Bearbeiten: B5e,
  Adresse: f5e,
  Datenschutz: Z5e,
  Name: G5e,
  Email: y5e,
  Telefon: W5e,
  Bemerkung: S5e,
  Firma: V5e,
  "Steuer-ID": "Tax ID",
  Akzeptiert: w5e,
  Stadt: v5e,
  PLZ: R5e,
  Land: X5e,
  Datum: H5e,
  "exit-action": "Exit action",
  dealer: k5e,
  "order-status": "Order status",
  json: Y5e,
  price: F5e,
  options: x5e,
  Bestellaktion: D5e,
  Typ: J5e,
  Konfiguration: E5e,
  AR: N5e,
  Geteilt: L5e,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Would you like to view your customers' data and requests?",
  "Preise anlegen": "Create prices",
  anzeigen: K5e,
  "Artikel und Preise erfolgreich importiert.": "Items and prices imported successfully.",
  Sortierung: T5e,
  Artikelnummer: M5e,
  "Artikelnummer eingeben": "Enter article number",
  "Namen eingeben": "Enter names",
  Beschreibung: P5e,
  "Beschreibung eingeben": "Enter description",
  Kategorie: U5e,
  "Kategorien eingeben": "Enter categories",
  Preise: z5e,
  "Sortierung erfolgreich angewendet.": "Sorting successfully applied.",
  "Fehler beim Anwenden der Sortierung: ": "Error when applying the sorting: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Articles and prices successfully published.",
  "Fehler beim Veröffentlichen: ": "Publishing errors: ",
  "Sie möchten Preise anzeigen?": "Would you like to display prices?",
  "Neuer Artikel": "New article",
  Löschen: "Delete",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publish the app in order to publish articles and prices.",
  "Artikel und Preise veröffentlichen": "Publish articles and prices",
  Artikel: O5e,
  "Preise für Artikel nr.": "Prices for article no.",
  Schließen: "Close",
  "Preise werden automatisch importiert. Änderungen sind nicht möglich.": "Prices are imported automatically. Changes are not possible.",
  "Sie verwenden nicht die aktuelle Release des K3. Das kann zu technischen Problemen führen. Bitte wechseln Sie sobald möglich auf die aktuelle Release und veröffentlichen Sie.": "You are not using the current release of K3. This can lead to technical problems. Please switch to the current release as soon as possible and publish.",
  Wechseln: Q5e,
  Upload: j5e,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Upload one or more images to the specified folder. They can use the slash (/) to create deeper folders...",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Alternatively, you can upload a ZIP archive with a folder structure..",
  "Ordner *": "folder *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Note: All images in a folder are grouped, sorted by name. So use file names like "image_001".',
  Keine: q5e,
  Alle: _5e,
  Bilder: $5e,
  Roughness: eDe,
  Metalness: tDe,
  Transparent: iDe,
  Opacity: nDe,
  Farbe: rDe,
  Emissive: gDe,
  "Color Map": "Color Map",
  "Normal Map": "Normal Map",
  "Roughness Map": "Roughness Map",
  "Metalness Map": "Metalness Map",
  "Alpha Map": "Alpha Map",
  Seite: oDe,
  Vorderseite: lDe,
  Hinterseite: aDe,
  Beidseitig: sDe,
  "Texture repeat": "Texture repeat",
  "Depth Write": "Depth Write",
  Transmission: IDe,
  Reflectivity: cDe,
  ClearCoat: dDe,
  "Clearcoat Roughness": "Clear Coat Roughness",
  "new-material": "New Material",
  Optionen: uDe,
  Bezeichnung: CDe,
  Pbr: ADe,
  Physikalisch: bDe,
  Key: hDe,
  "AR Fallback Material": "AR Fallback Material",
  "Nicht ausgewählt": "Not Selected",
  Model: mDe,
  Erweitert: pDe,
  "Nur in Regeln verwendete Materialien anzeigen": "Show only materials used in rules",
  "extract-materials": "extract-materials",
  Editieren: BDe,
  Kopieren: fDe,
  "Neues Modell": "New model",
  "Dynamisches Modell": "Dynamic model",
  "Neue Regel Erstellen": "Create new rule",
  "Regel erstellen": "Create Rule",
  Gültigkeit: "Validity",
  "Neue Regel": "New Rule",
  Export: ZDe,
  "app-code-duplicate": "App code already in use",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App settings could not be saved. The code is already in use.",
  "screenshot-quality": "Screenshot quality",
  Produktdarstellung: GDe,
  "3D-Modell": "3D-Model",
  "Bilder-Konfigurator": "Image configurator",
  Hauptmodell: yDe,
  "Hauptmodell entfernen": "Remove Main Model",
  "Link zum Konfigurator": "Link to the configurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "If you use an extension, enter here where your developer provides it...",
  "Die Beschreibung dieses Konfigurators": "The description of this configurator",
  "Google Analytics 4 Property ID": "Google Analytics 4 Property ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "You must obtain the user's consent for the Google cookie. This does not happen within the K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Would you like to connect your Analytics-account?",
  Upgrade: WDe,
  Vorlage: SDe,
  "Dieser Konfigurator dient als Vorlage": "This configurator is a template",
  Tutorial: VDe,
  "Standard übernehmen": "Apply default",
  Tracking: wDe,
  share: vDe,
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Here you can specify a URL to which various data is sent as soon as the user makes a selection. This allows you to use the CustomData component in the Layout Designer to display special information (e.g. to indicate shipping costs etc.).",
  "Preis & Info Service": "Price & Info Service",
  "Hilfe dazu finden Sie hier.": "You can find help here.",
  "URL für den Service, der die Daten verarbeitet": "URL for the service that processes the data",
  "Debounce in ms": "Debounce in ms",
  Merkmale: RDe,
  "Merkmale und ihre aktuelle Auswahlen senden": "Send features and their current selections",
  "Optionale Merkmalbeschränkung": "Optional feature restriction",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Optionally restrict the features that are sent.",
  "Artikel & Preis": "Article & Price",
  "Aktuell ausgewählte Artikel senden": "Send currently selected articles",
  "Aktuellen Preis senden": "Send current price",
  "to dealer app": "to dealer app",
  "Händler hat Zugriff": "Dealer has access",
  "Händler hat keinen Zugriff": "Dealer has no access",
  "dealer query": "Input presets",
  "Händler legt Aufschlag fest": "Dealer defines surcharge",
  discount: XDe,
  surcharge: HDe,
  "Um diesem Händler Zugriff zu geben oder ihn zu entziehen, ": "To grant or revoke access to this dealer, ",
  "wenden Sie sich bitte an uns": "please contact us",
  Speichern: kDe,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Would you like your deals to use your configurator?",
  "Keine Händler vorhanden": "No existing dealers",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "First create a dealer - then authorize them to the app here.",
  "Jetzt Händler anlegen": "Create dealer now",
  Einbetten: YDe,
  "Als Link": "As Link",
  "Als IFrame": "As IFrame",
  "Meldungen beim Laden anpassen": "Customize loading messages",
  "Bitte Auth0 Zugangsdaten angeben": "Please enter Auth0 access data",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "You want to release the configurator only for specific users? Then you can use the Auth0 service.",
  "Konfigurator-Zugang": "Configurator access",
  "Anmeldung für Konfigurator verlangen.": "Require login for configurator.",
  "Auth0 Domain": "Auth0 Domain",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Reference language. The entries must match the reference column in the imported file in order to be taken into account.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.",
  "Info ": "Info ",
  "Sprache: ": "Language: ",
  "Referenzsprache: ": "Reference language: ",
  Referenzsprache: FDe,
  "Anzahl Sprachen: ": "Number of languages: ",
  "Anzahl übersetzbarer Texte: ": "Number of translatable texts: ",
  Sprachen: xDe,
  "Die erste Sprache gilt als Standard.": "The first language is the default.",
  Übersetzungen: "Translations",
  "Versteckte Merkmale": "Hidden characteristics",
  "Unbenutzte Sprachen": "Unused languages",
  "Importiere XLSX": "Import XLSX",
  "Exportiere XLSX": "Export XLSX",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Would you like to forward requests to the customer or yourself?",
  "Mail Texte": "Mail texts",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Here you can customize the content of the sent mails. Read the section in the documentation beforehand...",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Please note: you must always publish the configurator before using the modified texts.",
  Schriftart: DDe,
  Helvetica: JDe,
  "Times Roman": "Times Roman",
  Courier: EDe,
  Interstate: NDe,
  Montserrat: LDe,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "font size",
  Links: KDe,
  Rechts: TDe,
  Oben: MDe,
  Unten: PDe,
  Kopfzeile: UDe,
  Fußzeile: "Footer",
  "Neue PDF Vorlage auswählen": "Select new PDF template",
  "Vorhandene PDF Vorlage löschen": "Delete existing PDF template",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Would you like to send a PDF of confirmations or offers?",
  "PDF Einstellungen": "PDF Settings",
  Seitenränder: "Margins",
  "Voransicht mit dieser Konfiguration:": "Preview with this configuration:",
  "und diesem Template:": "and the template:",
  "Speichern und drucken": "Save and print",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "To preview the PDF, an existing configuration is required",
  Allgemein: zDe,
  Mail: ODe,
  Shop: QDe,
  "Ungespeicherte Änderungen": "Unsaved changes",
  "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?": "You have unsaved changes. Are you sure you want to leave without saving?",
  Verlassen: jDe,
  "Immer aktuellste Version verwenden": "Always use the latest version",
  "K3 Version": "K3 Version",
  "Wir helfen gern!": "We're here for you!",
  "Ihre Telefonnummer": "Your phone number",
  "Ihre Nachricht": "Your message",
  Senden: qDe,
  "Nachricht senden": "Send message",
  "Rückruf erbitten": "Request callback",
  orders: _De,
  date: $De,
  "Preise wurden in den Einstellungen deaktiviert": "Prices have been disabled in the settings",
  "Keine Einnahmen vorliegend": "No revenue present",
  "total-earnings": "Total earnings",
  Tage: eJe,
  articlename: tJe,
  articles: iJe,
  "Erfolgreich importiert": "Import successful",
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'You can export a configurator under "Settings". You can import the resulting file back here.',
  "JSON Export Datei": "JSON export file",
  "Leerer Konfigurator": "Empty configurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Start with an empty configurator and set it up according to your wishes.",
  "Konfigurator importieren": "Import configurator",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Import a configurator based on an exported file.",
  Veröffentlicht: "Published",
  "Mandant hat noch keinen Konfigurator": "Client does not have a configurator yet",
  Konfigurator: nJe,
  "Link kopiert": "Link copied",
  "E-Mail": "E-Mail",
  "Werben Sie K3 Kunden!": "Refer new K3 customers!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Pass on the link below. You'll receive commission for each configurator booked by your contact.",
  Partner: rJe,
  Provision: gJe,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Please note that any affiliate links issued will become invalid once you change the code.",
  "Meine Kunden": "My customers",
  "Vielen Dank für Ihre Bestätigung...": "Thank you for your confirmation..",
  "E-Mail Bestätigung": "Email confirmation",
  "Zur Anmeldung": "To login",
  Händlerprofil: "Dealer profile",
  name: oJe,
  email: lJe,
  "E-Mail ist ungültig!": "Email is invalid!",
  Nutzerkonto: aJe,
  Nutzername: sJe,
  "Mail ist schon vergeben": "Email is already taken",
  "code-duplicate": "code-duplicate",
  "dealer code helper text": "To open the dealer configurator.",
  "default discount": "Default discount",
  "Kann pro Konfigurator überschrieben werden.": "Can be overwritten per configurator.",
  "default surcharge": "Default surcharge",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Please check the information you have provided:",
  "Fehlendes Produkt": "Missing product",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Do you want your dealers to use one of your configurators?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Please book another product there first.",
  "new dealer": "New Dealer",
  "Login screen": "Login",
  "Bitte am Desktop öffnen": "Please open on desktop",
  Password: IJe,
  Login: cJe,
  "Passwort vergessen?": "Forgot password?",
  "Noch kein Konto?": "No account yet?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Failed to login. Email and/or password are invalid",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Failed to login. Please enable cookies in your browser settings",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "If the mail does not arrive in the next few minutes, please also check your SPAM folder and check your address...",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We will send you a mail with instructions on how to set a new password.,",
  "Mail senden": "Send mail",
  "K3 - die Konfiguratorplattform": "K3 - the configurator platform",
  "Ich habe den Konfigurator innerhalb von drei Wochen fertiggestellt und er hat sich bereits mehr als rentiert.": "I completed the configurator within three weeks, and it has already paid off more than enough.",
  "Die Eingabe ist zu kurz.": "The input is too short.",
  "Die Eingabe ist zu lang.": "The input is too long.",
  "Die Eingabe wird benötigt.": "The input is required.",
  "Email Adresse ist ungültig.": "Email address is invalid.",
  "Dieser Wert wird bereits benutzt.": "This value is already in use.",
  "Das Kennwort muss mindestens 8 Zeichen lang sein und Buchstaben, Großbuchstaben und Zahlen enthalten.": "The password must be at least 8 characters long and contain letters, capital letters and numbers.",
  "Die Eingabe fehlt.": "The input is missing.",
  "Leider ": "Sorry, ",
  "Bitte geben Sie eine E-Mail-Adresse an": "Please enter an e-mail address",
  "Die angegebene E-Mail-Adresse hat ein ungültiges Format": "The entered e-mail address has an invalid format",
  "Bitte geben Sie ein Passwort an": "Please enter a password",
  "Bitte geben Sie eine Telefonnummer an": "Please enter a phone number",
  "Die eingegebene Telefonnummer hat ein ungültiges Format": "The entered phone number has an invalid format",
  "Bitte stimmen Sie unseren Datenschutzhinweisen und Geschäftsbedigungen zu": "Please agree to our privacy policy and terms of service",
  Registrierung: dJe,
  "Ihre E-Mail-Adresse": "Your e-mail address",
  "Bitte wählen Sie ein Kennwort": "Please choose a password",
  "Direkt starten - ohne Zahlungsangaben.": "Start directly - no payment information required.",
  "Bitte bestätigen Sie unsere ": "Please confirm our ",
  Datenschutzbestimmungen: uJe,
  " und unsere ": " and our ",
  AGB: CJe,
  "Jetzt registrieren": "Register now",
  "Die Registrierung war leider nicht möglich.": "Sorry, registration was not possible",
  "Herzlich willkommen!": "Welcome!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We have sent you an e-mail - please also check your spam folder..",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "You can also register right now with your data:",
  "Wir haben Ihr Kennwort neu gesetzt.": "We have reset your password",
  "Passwort setzen": "Set password",
  Passwort: AJe,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "At least 8 characters, upper, lower case letters and numbers",
  Bestätigung: "Confirmation",
  "Bestätigung stimmt nicht überein": "Confirmation does not match",
  "Kennwort setzen": "Set password",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - the 3D product configurator for Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "You have successfully installed the Shopify app for the K3 configurator. These are the next steps:",
  "Registrieren Sie sich am K3.": "Register at K3.",
  "Legen Sie einen Konfigurator an.": "Create a configurator.",
  "Jetzt starten": "Start now",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Connect the configurator to your shop and import your Shopify items.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Design the configurator for your product.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Add the configurator to your shop.",
  Editor: bJe,
  "Mandant: ": "Client: ",
  "Erstellt am: ": "Created at: ",
  "Veröffentlicht am: ": "Published at: ",
  "Noch nicht veröffentlicht": "Not yet published",
  "Version: ": "Version: ",
  "Artikel-Version: ": "Article-Version: ",
  "Code: ": "Code: ",
  "Typ: ": "Type: ",
  Standard: hJe,
  "Shop: ": "Shop: ",
  "Nicht verbunden": "Not connected",
  "Bestellungen insgesamt": "Total orders",
  Veröffentlichungen: "Publications",
  Von: mJe,
  Version: pJe,
  "Artikel-Version": "Article-Version",
  Buchungen: BJe,
  Plattform: fJe,
  Intervall: ZJe,
  Subscription: GJe,
  CustomerID: yJe,
  Aktiv: WJe,
  Seit: SJe,
  "Abschlag [%]": "Discount [%]",
  "Aufschlag [%]": "Surcharge [%]",
  Query: VJe,
  Aktionen: wJe,
  "Mandanten wechseln": "Change client",
  "Konnte nicht gespeichert werden: ": "Could not be saved: ",
  Buchung: vJe,
  "Angelegt am": "Created on",
  "Zum AdminPanel": "To the Admin Panel",
  "App editieren": "Edit app",
  Monat: RJe,
  Jahr: XJe,
  "Bezahlt?": "Paid?",
  Bis: HJe,
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Confirmation failed. The entered names do not match.",
  "Einstiegs-Produkt": "Initial product",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Stripe ID",
  Parameter: kJe,
  "Partner?": "Partner?",
  Kunden: YJe,
  ID: FJe,
  Rechnungen: xJe,
  Leer: DJe,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "The complete client will be exported - including all assets. Continue?",
  "Mandant unwiderruflich löschen": "Delete client irrevocably",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "The complete client will be deledted irrevocably - including all assets. Did you export it?. Continue?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Please confirm the name of the client to be deleted:",
  Nutzer: JJe,
  "Mandant erfolgreich gelöscht": "Client deleted successfully",
  "Mandanten editieren": "Edit client",
  Rolle: EJe,
  Schritte: NJe,
  Werte: LJe,
  Regeln: KJe,
  Regelzeilen: TJe,
  Modelle: MJe,
  Materialien: PJe,
  Gelöscht: "Deleted",
  Merkmal: UJe,
  Regel: zJe,
  Nummer: OJe,
  Status: QJe,
  Erstellt: jJe,
  Zurücklegen: "Put back",
  Mindestlänge: "Min {{chars}} chars required",
  "Email Adresse ist ungültig": "Email address is invalid",
  Kennwort: qJe,
  "Test stimmt nicht überein": "Test does not match",
  "Telefonnummer ist ungültig": "Phone number is invalid",
  "Entwickler Modus": "Developer Mode",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Gives developers access to advanced capabilities",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "On creation of a new token, all others are deleted.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Thus all shops get disconnected.",
  "Sie können das Token im Shop-Plugin eintragen.": "Put the token into the shop plugin.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Please take a note of the token, it is only displayed once.",
  Neu: _Je,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "The ApiToken gives a store or your custom development access to your configurators data...",
  "Sie möchten über die API auf den K3 zugreifen?": "Would you like to access the K3 via the API?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Then you must book a corresponding product for at least one of your configurators.",
  "Neuen Nutzer anlegen": "Create new user",
  Eingabe: $Je,
  "E-Mail nicht valide!": "Email not valid!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We will send the new user an e-mail with a link. There he can set his password and then he will get access to your configurator..",
  "Nutzer einladen": "Invite User",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "This user will gain access to your client.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Please check the information you have provided:",
  Einladen: e9e,
  "Benutzer einladen": "Invite users",
  "new user": "New User",
  "Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.": "This configurator currently does not have a valid license.",
  "CSS-Datei auswählen": "Choose CSS file",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Do you want to use dynamic models to sell customised products?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "The model with {{curr}} triangles is exceeding the recommended amount of {{max}} triangles. This may lead to problems in AR mode.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "The model's file size of {{curr}}MB is exceeding the recommended file size of {{max}}MB.",
  "3D-Modell auswählen": "Choose 3D-Model",
  Download: t9e,
  Hintergrundmodell: i9e,
  "material-upload": "material-upload",
  Favoriten: n9e,
  "main-model": "main-model",
  "Wirft Schatten": "Casts shadows",
  "Wird schattiert": "Receives shadows",
  "Bilder Galerie": "Image Gallery",
  Anlegen: r9e,
  "Neue Aktion": "New Action",
  Preiseinstellungen: g9e,
  "Preise im Konfigurator ausblenden?": "Hide prices?",
  Hauptaktion: o9e,
  Kontaktformular: l9e,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "You may receive notifications about but not actually view customer orders",
  Pflichtfeld: a9e,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'You may include links as <a href="https://your-domain.com/privacy.html" target="_blank">Privacy</a>.',
  "Shop verbinden": "Connect shop",
  Aktionsname: s9e,
  "Überschrift Bestätigung": "Confirmation title",
  "Text Bestätigung": "Confirmation text",
  "Link zur Konfiguration zeigen?": "Show link to configuration?",
  "Thumbnail des Konfigurators": "Configurator Thumbnail",
  "Artikel hat keinen Namen und keine Nummer!": "Article has no name and no number!",
  "Kein Artikel ausgewählt!": "No item selected!",
  "Artikel auswählen": "Select article",
  "Artikelanzahl und Menge": "Number of items and quantity",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "How often the corresponding item should be added",
  Anzahl: I9e,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Bill of materials relevant, for example for the length of a post",
  "Menge (optional)": "Quantity (optional)",
  Anzahlberechnung: c9e,
  Mengenberechnung: d9e,
  Artikelaktion: u9e,
  "Wert eingeben": "Enter value",
  "Neue Spalte": "New column",
  "Wert-Eigenschaft": "Value property",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "You can give properties to the values of this characteristic, for example, weight or grade or power. You can enter these properties separately for each value and then output them to the user. But you can also use these properties to make rules and calculations much simpler..",
  "Eigenschaft wird dem Nutzer angezeigt": "property is displayed to the user",
  "mehrsprachiger Text": "multilingual text",
  "nicht übersetzter Text": "untranslated text",
  Zahl: C9e,
  Einheit: A9e,
  "Buchen Sie jetzt Ihre Lizenz!": "Book your license now!",
  "Denken Sie daran, den Konfigurator zu veröffentlichen, damit er für Ihre Kunden freigegeben wird.": "Remember to publish the configurator so that it is available to your customers.",
  "Fokus auf Modelle": "Focus on models",
  "Alle Modelle": "All models",
  "Fokus über Objektnamen": "Focus on object names",
  Kamera: b9e,
  Schritt: h9e,
  Kameraansicht: m9e,
  Kameratyp: p9e,
  Perspektive: B9e,
  Orthographisch: f9e,
  Fokustyp: Z9e,
  "Dynamischer Fokus": "Dynamic focus",
  "Statischer Fokus": "Static focus",
  "Screenshot Auflösung": "Screenshot resolution",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Necessary difference to the current view",
  "Noch keine Kamera gespeichert": "No camera saved yet",
  "Kamera erstellen": "Create camera",
  "Bitte auswählen": "Please select",
  Ausgewählt: "Selected",
  "Merkmal setzen: ": "Set characteristic: ",
  "Keine Farbe ausgewählt!": "No color selected!",
  "Farbe auswählen": "Select colour",
  "Farbmerkmal auswählen:": "Select color feature:",
  "Keine Auswahl": "No selection",
  "Hoch schieben": "Move up",
  "Runter schieben": "Move down",
  Duplizieren: G9e,
  "Löschen des aktiven Elements nicht möglich": "The currently active element cannot be deleted",
  "Komponente hinzufügen": "Add component",
  Entfernen: y9e,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Your configuration could not be saved.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Please excuse. We have saved the configuration in this browser. Please come back later.",
  "technische Information:": "technical information:",
  "Preis: ": "Price: ",
  "Kamera bearbeiten": "Edit camera",
  "Neue Kamera für Bestellungsbilder": "New camera for order images",
  "Ansicht übernehmen und Speichern": "Apply current view and save",
  "Kameras für Bestellungsbilder": "Cameras for order images",
  Kameras: W9e,
  "Anfrage erhalten": "Request received",
  "Buchung erfolgreich": "Booking successful",
  "Für das neue Produkt melden wir uns bei Ihnen.": "We will contact you regarding the new product.",
  "Ihre Subskription wurde angepasst.": "Your subscription has been updated.",
  "Ihre Subskription wurde beendet.": "Your subscription was cancelled.",
  "Das Produkt wurde gebucht.": "The product has been booked.",
  "3D-Konfigurator mit beliebig komplexer Logik": "3D configurator with arbitrarily complex logic",
  "E-Mail mit PDF erhalten": "Receive an email with PDF",
  "Shop-Anbindung": "Shop connection",
  Schnittstellen: S9e,
  "Auf Anfrage": "On request",
  Kostenfrei: V9e,
  pro: w9e,
  "Meine Rechnungen": "My invoices",
  "Derzeit gebucht.": "Now booked.",
  "Änderung Ihrer Buchung": "Booking update",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "You are booking a new product. Continue?",
  "Jetzt buchen": "Book now",
  Downgrade: v9e,
  "Zahlungsplan ändern": "Change payment plan",
  Monatlich: R9e,
  Jährlich: "Yearly",
  "In neuem Tab öffnen": "Open in new tab",
  "Konfigurator anpassen": "Customize Configurator",
  "main drawer": "This is a preview of your configurator. Click on an edit icon to change something, or:",
  "Ändern Sie die Bestelloptionen": "Change the order options",
  "Ändern Sie das Design": "Change the design",
  "Passen sie die 3D Szene an": "Customize the 3D scene",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Save the current camera for order images",
  "Merkmale verwalten": "Manage features",
  "Ihre Lizenz": "Your license",
  "So richten Sie Ihren Konfigurator ein:": "This is how you set up the configurator:",
  Home: X9e,
  Hilfe: H9e,
  "dealer sidebar": "Dealer sidebar",
  "Ändern Sie das Logo": "Change the logo",
  "Ändern Sie die DSGVO": "Update the GDPR",
  "Ändern Sie den Preis": "Change the price",
  "Ändern Sie die PDF Vorlage": "Change the PDF template",
  "PDF Gestaltung": "PDF Design",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Upload a PDF as a template for printing.",
  cancel: k9e,
  "app surcharge": "Set price surcharge",
  "you can change your surcharge here": "you can change your surcharge here",
  DSGVO: Y9e,
  "Hier können Sie den Text für die DSGVO ändern": "Here you can change the text for the GDPR",
  "Neuer Schritt": "New step",
  Icon: F9e,
  "Icon Bilddatei": "Icon image file",
  "Icon position": "Icon position",
  "Icon Größe": "Icon size",
  "Ersetze Weiter mit Aktionsauswahl": "Replace Next with Action Selection",
  "Aktionsnamen überschreiben": "Override action name",
  "Individuelles Design": "Custom design",
  "Angepasstes Layout speichern": "Save customized layout",
  "Merkmale editieren": "Edit characteristics",
  "Keine Ergebnisse": "No results",
  "Desktop Layout": "Desktop Layout",
  "Mobile Layout": "Mobile Layout",
  "Schritte nacheinander einblenden": "Show steps sequentially",
  "Besuchte Schritte abhaken": "Check off visited steps",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "You are currently using a no longer supported layout. Please select a new one.",
  "Dieses Layout selbst anpassen": "Customize this layout",
  "Eigenes Layout erstellen": "Customized Layout",
  "Angepasstes Layout anwenden": "Use customized layout",
  Logo: x9e,
  "Konfigurator-Abschluss": "Configurator Finalisation",
  "3D Szene": "3D Scene",
  "Manuelle Einstellung erstellen": "Create manual setting",
  "Design & Theme": "Design & Theme",
  Farben: D9e,
  "Farbanpassungen zurücksetzten": "Reset color adjustments",
  CSS: J9e,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "You can also customize the look of your configurator using CSS:",
  "Link zur CSS-Datei": "Link to CSS file",
  "Oder laden Sie eine CSS Datei hoch:": "Or upload a CSS file:",
  "Neues Merkmal": "New Feature",
  "Merkmal kopieren": "Copy feature",
  Zurücksetzen: "Reset",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "You are resetting the configurator to the chosen version.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "This will replace all data of this configurator.",
  "Auch der Papierkorb wird gelöscht.": "The recycle bin will also be cleared.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "This operation cannot be undone.",
  "Sind Sie sicher?": "Are you sure?",
  Einstellungen: E9e,
  "Dynamische Texte": "Dynamic texts",
  "Texte und Einstellungen anpassen": "Update labels and settings",
  "Sie verwenden diesen Konfigurator mit einer Testlizenz.": "You are using this configurator with a trial license.",
  "Ihr Testzeitraum ist abgelaufen.": "Your trial period has expired.",
  "Ihr Testzeitraum ist seit {{days}} Tagen abgelaufen.": "Your trial period has expired since {{days}} days.",
  "Sie können diesen Konfigurator noch {{days}} Tage testen.": "You can still test this configurator for {{days}} days.",
  "Sie haben diesen Konfigurator storniert.": "You have cancelled this configurator.",
  "Jetzt buchen!": "Book now!",
  Vorschau: N9e,
  Articles: L9e,
  Bestellungen: K9e,
  Statistics: T9e,
  "Fragen? Wir helfen gern!": "Questions? We’re happy to help!",
  "Inhalte: ": "Contents: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Before the configurator can be used, they must press the button "Publish". If you make changes after that, they will also take effect after the next publication.',
  "Live Version": "Live Version",
  Veröffentlichen: "Publish",
  "Erstelle Option: ": "Create option: ",
  Fehler: M9e,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "An error occured when rendering content.",
  Fatal_Error_Text: P9e,
  Fatal_Error: U9e,
  "Fehlermeldung:": "Error message:",
  "Zur Startseite": "To the home page",
  "Neu Laden": "Reload",
  "Cleanup und Neu Laden": "Cleanup and Reload",
  "You may need to reload the page": "You may need to reload the page",
  Error_Message: z9e,
  "(SU) Client wechseln": "(SU) Change client",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "The app has not been published. Accessing this configuration may lead to errors. Continue?",
  "Kein Hauptabschluss": "No main completion",
  "Label eingeben": "Enter label",
  "Abschlüsse verbergen": "Hide completions",
  "Abschlüsse deaktivieren": "Deactivate completions",
  Hauptabschluss: O9e,
  "Abschlüsse festlegen": "Set completions",
  "Hier können Sie festlegen, welche Abschlüsse für die Benutzer sichtbar oder deaktiviert sind.": "Here you can specify which completions are visible or disabled to users.",
  "Die unterschiedlichen Farben der Abschlüsse repräsentieren unterschiedliche Zustände:": "The different colors of the completions represent different states:",
  Abschluss: Q9e,
  "In Schwarz werden verborgene Abschlüsse repräsentiert.": "In black, hidden completions are represented.",
  "In Grau werden deaktivierte Abschlüsse repräsentiert.": "In gray, disabled completions are represented.",
  "In Blau bezeichnet welcher Abschluss am Ende der Reiter Navigation angezeigt wird. Davon kann es nur einen geben.": "In blue, it indicates which completion is displayed at the end of the tab navigation. There can only be one.",
  "Elemente löschen": "Delete elements",
  "Element löschen": "Delete element",
  "Selektierte Elemente löschen": "Delete selected elements",
  "Alle selektierte Elemente löschen": "Delete all selected elements",
  "Lösch-Konflikte anzeigen": "Display deletion conflicts",
  "Das Element": "The item",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Do you really want to delete the selected items irreversibly?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Do you really want to delete this item irreversibly?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "The following reasons speak against deletion:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Some items are still used in other places:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} is still used in other places:",
  "{{label}} wird noch verwendet in ": "{{label}} is still used in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "of an extension. Ask the developer to remove the usage and then delete the key.",
  "der Definition der Regel": "the definition of the rule",
  "einem Eintrag in Regel": "an entry in rule",
  "einer berechneten Eigenschaft des Modells": "a calculated property of the model",
  "der Formel von": "the formula of",
  "der Kamera": "the camera",
  "des Merkmals": "the feature",
  "des Schrittes": "the step",
  "der globalen Kamera": "the global camera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Please delete the other references first.",
  "Neuen Schritt hinzufügen": "Create a new step",
  "Bitte legen Sie einen Schritt an!": "Please create a step!",
  "Schritt editieren": "Edit step",
  Bestelloptionen: j9e,
  "Merkmal editieren": "Edit feature",
  "Mehr Informationen anzeigen": "Show more information",
  "Nicht Aktiv": "Not active",
  "Keine Angabe": "No information",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: q9e,
  "Bilder auswählen": "Select images",
  "Ordner auswählen:": "Select folder:",
  "Bildmerkmal: ": "Image Feature: ",
  "Kein Bild ausgewählt": "No image selected",
  "Bild auswählen": "Select image",
  "Bildmerkmal auswählen:": "Select image feature:",
  Befüllt: "Filled",
  "Zustand auswählen": "Select State",
  "Kein Komponente ausgewählt!": "No component selected!",
  "Komponente auswählen": "Select component",
  "Intervall eingeben": "Enter Interval",
  "Zum Dashboard": "Go to dashboard",
  Primärfarbe: "Primary color",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Sets the primary colour (for tabs, buttons, etc.) and the contrast colour (button text)",
  Sekundärfarbe: "Secondary color",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Sets the secondary colour (secondary buttons) and the contrast colour (button text)",
  Text: _9e,
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Sets the regular text colour and the secondary colour (e.g. for descriptions)",
  Hintergrundfarbe: $9e,
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Sets the regular background colour and that of the slightly highlighted areas (e.g. product properties)",
  Info: eEe,
  "Setzt die Farbe der Info-Icons": "Sets the info icon colour",
  Warnfarbe: tEe,
  "Setzt die Farbe der Warnhinweise": "Sets the warning alert colour",
  Fehlerfarbe: iEe,
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Sets the error message and alert colour",
  Basiseinstellungen: nEe,
  "Helles Theme": "Bright Theme",
  "Erweiterte Einstellungen": "Advanced Settings",
  "Label hinzufügen: ": "Add Label: ",
  "Kein Label ausgewählt!": "No label selected!",
  "Was soll angezeigt werden?": "What should be displayed?",
  Maximalgröße: "Max size",
  Deckkraft: rEe,
  "Kein Material ausgewählt!": "No material selected!",
  "Material auswählen": "Select material",
  "Material auswählen:": "Select material:",
  Materialaktion: gEe,
  Farbaktion: oEe,
  Bildaktion: lEe,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Restricting the effects to specific models",
  "Die Option 'Titel ausblenden' ist aktiviert.": "The 'Hide title' option is activated",
  Hinzufügen: "Add",
  "Welches Teil soll hinzugefügt werden?": "Which part should be added?",
  Hinweis: aEe,
  Achtung: sEe,
  Fortfahren: IEe,
  "Kein Modell ausgewählt!": "No model selected!",
  "Modell auswählen": "Select model",
  "Modell hinzufügen:": "Add Model:",
  "Globale Änderung": "Global Change",
  Oberflächen: "Surfaces",
  "Ausgewählte Oberflächen": "Selected surfaces",
  "Eintrag darf nicht leer sein.": "Entry must not be empty.",
  "Alle Werte": "All values",
  "Werte auswählen": "Select values",
  "Sortierung anwenden": "Apply sorting",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "The file format is not allowed! No file selected.",
  "Erlaubte Formate:": "Allowed formats:",
  "Keine Datei gewählt.": "No file selected.",
  "Datei konnte nicht hochgeladen werden.": "File could not be uploaded.",
  "Bild hochladen": "Upload image",
  Plus: cEe,
  Minus: dEe,
  "Dieses Merkmal ist nicht erlaubt.": "This characteristics is not permitted.",
  "Merkmal-Optionen": "Variable options",
  "Merkmal Beschreibung editieren": "Edit description",
  "Merkmal-Info editieren": "Edit Info",
  Versteckt: uEe,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "This characteristics is not displayed. However, its value can be used in rules and calculations.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Hide from step",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "This option only makes sense if the characteristic is shown or hidden at a different position via a custom layout. Even if it is hidden from the group in this way, it will still be assigned to it in summaries.",
  "Kamera-Optionen": "Camera options",
  "Vorlage wählen": "Choose template",
  "Konfigurator erstellen": "Create configurator",
  "Willkommen in Ihrem neuen K3 Konto!": "Welcome to your new K3 account!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Set up your first configurator right away:",
  "Sie können alle Daten natürlich später noch ändern.": "You may change all data later again if necessary.",
  "Nicht veröffentlicht": "Not published",
  "Ladevorgang fehlgeschlagen": "Charging process failed",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "The configuration could not be loaded! Please try again later!",
  "Keine Optionen": "No options",
  "Neuen Artikel anlegen": "Create new article",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Create a new article with price",
  articleNo: CEe,
  articleName: AEe,
  currency: bEe,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Change positions",
  "Abbrechen durch Klick": "Click to cancel.",
  Wert: hEe,
  Seitenleiste: mEe,
  "Preis eingeben": "Enter price",
  Währung: "Currency",
  "Währung eingeben": "Enter currency",
  "Einheit eingeben": "Enter unit",
  Startdatum: pEe,
  "Startdatum eingeben": "Enter start date",
  Enddatum: BEe,
  "Enddatum eingeben": "Enter end date",
  Startanzahl: fEe,
  "Startanzahl eingeben": "Enter start count",
  Endanzahl: ZEe,
  "Endanzahl eingeben": "Enter end number",
  Priorität: "Priority",
  "Priorität eingeben": "Enter priority",
  "Aufschlag?": "Markup?",
  "Preistyp eingeben": "Enter price type",
  "Neuer Preis": "New price",
  "Erweiterter Modus": "Advanced mode",
  Suchen: GEe,
  Auswählen: "Auswählen",
  "Wählen Sie eine Vorlage aus:": "Choose a template:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Or create a new configurator without a template: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Do you want to create your configurator now?",
  "Wir bringen Sie danach direkt in den Editor.": "We will redirect you to the editor afterwards.",
  "Anlegen & zum Konfigurator": "Create & open Configurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: yEe,
  OK: WEe,
  "Farbenanzahl im Fenster": "Visible Colors",
  "Farbkachel Rundung": "Color tile rounding",
  Opazität: "Opacity",
  Hervorhebung: SEe,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Remove invalid instanced (instead of replacing them)",
  "Drag & Drop erlauben": "Allow drag & drop",
  "Anzeige der Sortierungsschaltflächen": "Display of sorting buttons",
  "Sortierung umkehren": "Reverse sorting",
  "Duplizierung erlauben": "Allow duplication",
  "Zeige Werte aus inneren Merkmalen an": "Display values from inner characteristics",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Always hide characteristic name from inner value preview, even if multiple selections exist",
  "Innere Merkmalsnamen ausblenden": "Hide characteristic name from inner value preview",
  "Als Warenkorb setzen?": "Set as shopping cart?",
  "Gruppieren nach": "Group by",
  "Komponenten direkt unter der Liste anzeigen": "Show components directly below the list",
  Expression: VEe,
  "Erfolgreich gespeichert": "Saved successfully",
  "Formel Editor": "Formula Editor",
  "Geben Sie Formeln von Merkmalen ein.": "Enter formulas of characteristics",
  " Schreiben Sie z.B. Länge * Breite.": "Write, for example, length * width..",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "For an attribute, use for example Motor.Power, if Motor is its attribute and Power is the corresponding attribute...",
  Ergebnis: wEe,
  "Keine Formel eingegeben": "No formula entered",
  "Formel: ": "Formula: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "There are not yet enough selections to display a preview.",
  "Ergebnis: ": "Result:",
  "Titel ausblenden": "Hide title",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Hide original texture when printed?",
  "Erlaube Bildformate": "Allow image formats",
  "Minimum Horizontale Positionierung": "Minimum horizontal positioning",
  "Maximum Horizontale Positionierung": "Maximum horizontal positioning",
  "Minimum Vertikale Positionierung": "Minimum vertical positioning",
  "Maximum Vertikale Positionierung": "Maximum vertical positioning",
  "Minimale Skalierung": "Minimal scaling",
  "Maximale Skalierung": "Maximal scaling",
  "Optionaler Standardwert": "Optional default value",
  Mindestwert: vEe,
  Maximalwert: REe,
  Nachkommastellen: XEe,
  Schrittweite: HEe,
  "Zeige Knöpfe an": "Show buttons",
  "Benutze Vielfaches der Schrittweite": "Use multiples of the step size",
  Berechnet: kEe,
  "Zyklus Erkennung deaktivieren": "Deactivate cycle detection",
  Ändern: "Change",
  "Beispielhafte Beschreibung eines Wertes.": "Exemplary description of a value",
  "Dies ist nur eine Info": "This is just an info",
  "Color Dropdown": "Color Dropdown",
  "Color Radio": "Color Radio",
  "Color Radio Cards": "Color Radio Cards",
  Farbauswahl: YEe,
  Komponentenliste: FEe,
  "Komponentenliste mit Popup": "Component list with popup",
  Komponentenkarten: xEe,
  Bildauswahl: DEe,
  Informationen: JEe,
  Zahleneingabe: EEe,
  "Radio Buttons": "Radio Buttons",
  "Radio Cards": "Radio Cards",
  "RAL-Farbauswahl": "RAL color selection",
  Dropdown: NEe,
  Thumbnails: LEe,
  Schalter: KEe,
  "Schalter Card": "Switch Card",
  Texteingabe: TEe,
  Beispieltext: MEe,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Automatically accept conflict resolution with individual features",
  "Übergeordnete Merkmale": "Parent features",
  "Darstellungs-Optionen": "Visualisation options",
  Optional: PEe,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Under "Values" you will then find the special entry "no specification". Here you can still customize what should be displayed to the user if they have not selected anything.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "The selection will not be displayed in the confirmation, PDF or in the shop if not selected.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Show selection only if selected",
  "Konfigurator erfolgreich veröffentlicht.": "Configurator published successfully",
  "Folgende Änderungen werden veröffentlicht:": "The following changes will be published:",
  "Konfigurator veröffentlichen": "Publish configurator",
  "Sie möchten den Konfigurator veröffentlichen?": "Would you like to publish the configurator?",
  "Wertebereich angeben": "Specify value range",
  "Merkmale: ": "Features: ",
  "Aktionen: ": "Actions: ",
  "Diese Regel ist aktuell deaktiviert.": "This rule is currently deactivated.",
  "Neue Spalten Hinzufügen": "New columns to add",
  Bedingungen: UEe,
  "Merkmale ausblenden": "Hide characteristics",
  "Schritt ausblenden": "Hide step",
  "Werte ausblenden": "Hide values",
  "Konfigurator-Abschluss festlegen": "Set configurator completion",
  "Befüllen von Komponentenmerkmalen": "Fill component characteristics",
  "Bilder auf Oberflächen drucken": "Print images on surfaces",
  "Anzeige von Bildern": "Display images",
  "Ändern der Farbe": "Change the color",
  "Austauschen von Oberflächen": "Replace surfaces",
  "Anzeige von Informationen": "Display information",
  "Anzeige von Fehlermeldungen": "Display error messages",
  "Anzeige von 3D-Modellen": "Display 3D models",
  "Artikel zur Stückliste hinzufügen": "Add items to the bill of materials",
  "Ein oder mehrere Merkmal Spalten hinzufügen": "One or more feature columns to add",
  "Ein oder mehrere Komponenten Spalten hinzufügen": "One or more component columns to add",
  "Ein oder mehrere Schritte hinzufügen": "One or more steps to add",
  "Ein oder mehrere Artikel Spalten hinzufügen": "One or more article columns to add",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen.": "Choose the features to which the items should be assigned.",
  Materialnamen: zEe,
  "Wählen Sie Materialnamen aus, worauf Bilder gedruckt werden sollen in Abhängigkeit von Bild Merkmalen.": "Choose material names on which images should be applied depending on image features.",
  "Modell Eigenschaften anpassen": "Customise model properties",
  Labelaktion: OEe,
  Fehlermeldung: QEe,
  "Merkmale entfernen": "Remove characteristics",
  "Schritt entfernen": "Remove step",
  Modelaktion: jEe,
  "Bitte fügen Sie neue Spalten hinzu.": "Please add new columns.",
  "Sie brauchen mindestens eine Spalte.": "You need at least one column.",
  "Nr.": "Nr.",
  "Gültigkeit prüfen": "Check validity",
  "Keine Warnungen": "No warnings",
  "Alle Regeln ansehen": "View all rules",
  Position: qEe,
  "Rotation (in radiant)": "Rotation (in radian)",
  Scale: _Ee,
  "Kein Label angegeben!": "No label given!",
  "Regel Validierung": "Rule Validation",
  "Fehlende Werte": "Missing values",
  "Zugeordnete Merkmale": "Assigned characteristics",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Select the characteristics to be assigned to the articles",
  Komponentenmerkmale: $Ee,
  "Wählen Sie Komponentenmerkmale aus.": "Select component features.",
  "Oberflächenaktion hinzufügen": "Add surface action",
  "Alle auswählen": "Select all",
  "Alle abwählen": "Select none",
  "Auswahl umkehren": "Reverse selection",
  Herunterladen: eNe,
  "Jetzt verbinden": "Connect Now",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "The flexible shop system for your e-commerce project.",
  "Jetzt Installieren": "Install now",
  "Die globale Commerce-Plattform.": "The global commerce platform.",
  "Die E-Commerce-Plattform für WordPress.": "The e-commerce platform for WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "The one European open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Now Adobe Commerce: E-commerce made easy.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "First class in digital sales with the Oxid esales store.,",
  "Individuelle Entwicklung": "Custom development",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connect shop with custom development...",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "First download one of our plugins and install it in your store:",
  "Verbinde Shop": "Connect Shop",
  " und importiere Artikel": "and import articles",
  "Fehler beim Verbinden:": "Error connecting:",
  "Shop erfolgreich verbunden.": "Store successfully connected.",
  "Fehler beim Verbinden: ": "Error connecting: ",
  "Web-Adresse des Shops": "Web address of the store",
  "Sollen die Artikel aus dem Shop importiert werden?": "Should the items be imported from the store?",
  "Filter für Artikel": "Filter for articles",
  "Sollen die Artikel regelmäßig importiert werden?": "Should the items be imported regularly?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Should the item number be taken from the shop SKU?",
  "Wenn Sie diese Einstellung ändern, wird der nächste Artikel-Import die Artikel duplizieren.": "If you change this setting, the next item import will duplicate the items.",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Should the items be grouped together when ordering?",
  "Basis-Name für kombinierte Artikel": "Base name for combined articles",
  "Ihre Bestellung {code}": "Your order {code}",
  "Shop-Anbindung aufheben": "Unlink the store",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Add the configurator to your store",
  Verbinden: tNe,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "The HTML Content could not be rendered. Please check your entered input.",
  "Der eingegebe Wert ist nicht gültig: ": "The entered value is not valid: ",
  "Ungültiges HTML-Format": "Invalid HTML format",
  "Sie können uns den Vorfall hier melden!": "You can report the incident here!",
  "Das Template konnte nicht geladen werden.": "Unable to load the template.",
  "Templat auf Voreinstellung zurücksetzen": "Reset Template to default",
  "Eingaben zurücksetzen": "Reset changes",
  "Templat bearbeiten": "Edit template",
  "Templat Name": "Template name",
  "Templat wählen": "Choose template",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Choose a template from the list to customize it. Or enter a custom name to create an individual template for later use.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "You have not created an individual template yet. To do so, choose a default template from the list and make your required changes.",
  "Templat hinzufügen": "Add template",
  "Ansicht auswählen": "Select view",
  "Datei hochladen": "Upload file",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Please book another product first:",
  "Bitte wählen": "Please select",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "This action combines several features and therefore cannot be changed here. Change the following rule(s) directly for this:",
  "Automatisch angelegt": "Automatically created",
  "Aktionen verknüpfen": "Link actions",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Values from this characteristic should trigger the following actions:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "This characteristic cannot be used to control other operations. Please use the rules directly for this",
  "Zu den Regeln": "To the rules",
  "Artikel bestellen": "Order articles",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Depending on the selection, different articles will be added to the parts list.,",
  "Oberfläche ändern": "Change surface",
  "Welche Oberflächen sollen geändert werden? ": "Which surfaces should be changed? ",
  "3D-Modell anzeigen": "Show 3D model",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Depending on the selection, different 3D models will be displayed...",
  "Bild anzeigen": "Show image",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Depending on the selection different images are displayed",
  "Farbe ändern": "Change color",
  "Welche Oberflächen sollen eingefärbt werden? ": "Which surfaces should be colored? ",
  "Bild aufdrucken": "Print image",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "On which surfaces should the uploaded image be printed? ",
  "Der Wert wird noch in Regeln verwendet:": "The value is still used in rules:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "First, please delete the corresponding line(s) there...",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Here you can set what should be displayed if no value has been selected yet",
  "Dieser Wert ist nicht erlaubt.": "This value is invalid.",
  "Maximale Anzahl an Werten ist erreicht.": "Maximum number of values reached.",
  Farbwert: iNe,
  Anzeige: nNe,
  RAL: rNe,
  "keine RAL Farbe": "no RAL colour",
  Ansicht: gNe,
  "Key eingeben": "Enter Key",
  URL: oNe,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Info-Content",
  "Dieser Merkmalstyp unterstützt keine Werte.": "This characteristics type does not support values.",
  "Fehlende RAL Farben hinzufügen": "Add missing RAL colours",
  Auswahlwerte: lNe,
  "Typ des Merkmals": "Type of characteristic",
  "Merkmal {{label}} nicht gefunden!": "Characteristic {{label}} not found!",
  "Attribut {{label}} nicht gefunden!": "Attribute {{label}} not found!",
  "Syntaxfehler in der Expression!": "Syntax error in the expression!",
  "es gibt keine Merkmale mit {{identificator}}": "No characteristic {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "No attribute {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "No selection {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "there is more than one selection with {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "There is a cycle in the calculated characteristics: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "the result of the formula must be a numerical value, instead it is {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "value {{paramName}} of the function {{functionName}} is zero",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "The characteristics {{variableLabel}} is a component list. You must access it with an index such as {{variableLabel2}}[0] for the 1st element or with an array function such as map(), find(), reduce() or first()",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "There is a cycle in the calculated characteristics.",
  Übersicht: "Overview",
  Auswahlpreise: aNe,
  Auswahl: sNe,
  Gesamtpreis: INe,
  "Preis Information": "Price Details",
  "Persönliche Daten": "Personal Data",
  "Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise": "Please fill in all required fields correctly and accept the data protection information",
  "Bestätigen-Hinweistext bei invalidem Kontaktformular": "Displayed tooltip for an invalid contact form",
  Weiter: cNe,
  "Sie verwenden eine veraltete Version des Konfigurators.": "You are using an outdated configurator version.",
  "Bestell-Warnhinweis bei veralteter Version": "Order warning for outdated version",
  "In AR ansehen": "View in AR",
  Vollbildmodus: dNe,
  "Komponenten suchen": "Search for components",
  "Nicht Gruppiert": "Not grouped",
  Komponenten: uNe,
  "Komponenten hinzufügen": "Add components",
  xl: CNe,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Unfortunately, your input was not possible and was reset to the next possible value: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "This value cannot be combined with the following selections:",
  "Bei Auswahl wird eine Alternative berechnet!": "If selected, an alternative will be calculated!",
  Bestätigen: "Confirm",
  "Produkt hinzufügen": "Add product",
  "Produkt erfolgreich konfiguriert": "Product has been configured successfully",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "The configuration is complete. Which product would you like to add to your shopping cart now?",
  "Neues Produkt auswählen": "Select new product",
  "Neues Produkt hinzufügen": "Add new product",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'The selection "{{value}}" ({{variable}}) leads to the invalid value "{{conflictValue0}}" ({{conflictVariable0}}) and is therefore reset.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Message when resetting an invalid selection",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Message when one conflict occured",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}) and the selection "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Message when two conflicts occured",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Message for occurence of three or more conflicts",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'The selection "{{value}}" ({{variable}}) does not match the selection "{{conflictValue0}}" ({{conflictVariable0}}), the selection "{{conflictValue1}}" ({{conflictVariable1}}) and the selection "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'The selection "{{value}}" ({{variable}}) does not match other selections.',
  Konfliktmeldung: ANe,
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen.": "This selection can undo selections that have already been made.",
  "Anpassung nötig": "Adjustment",
  "Stattdessen werden folgende Auswahlen angepasst:": "Instead the following selections will be adapted:",
  "wird zu": "is becoming",
  "wird entfernt": "will be removed",
  "Optionaler weiterer Hinweistext:": "Optional additional information text:",
  "Auf Facebook teilen": "Share on Facebook",
  "Auf Twitter teilen": "Share on Twitter",
  "Auf LinkedIn teilen": "Share on LinkedIn",
  "Modal Titel": "Modal Title",
  "Desktop Gerät erkannt": "Desktop device detected",
  "Modal Text": "Modal Body",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented reality is currently only available on current iOS or androidOS smartphones. Therefore, simply scan this QR code with the camera app of your smartphone:",
  "Mobiles {{device}}-Gerät erkannt": "Mobile {{device}}-Device detected",
  "Fortschrittsanzeige 3D-Objekt": "Progress info 3D Object",
  "Export des 3D-Objekts": "Exporting the 3D object",
  "Fortschrittsanzeige AR-Datei": "Progress info AR file",
  "Bereitstellen der AR-Datei": "Deploying the AR file",
  "Fortschrittsanzeige System": "Progress info System",
  "{{device}}-AR-System einrichten": "Setting up {{device}} AR system",
  Positionszeile: bNe,
  "Pos.": "Item",
  "Artikelnummer Spalte": "Articlenumber column",
  "Artikel Spalte": "Article column",
  "Artikelpreis Spalte": "Article price column",
  "Artikelmenge Spalte": "Article amount column",
  Menge: hNe,
  "Artikelanzahl Spalte": "Article count column",
  "Positionspreis Spalte": "Item price column",
  Positionspreis: mNe,
  "Hilfetext Preisdetails": "Help text for price details",
  "Preisdetails anzeigen": "Display price details",
  "Titel bei Versions-Konflikt": "Title in case of version conflict",
  "Konfigurator wurde aktualisiert": "Configurator has been updated",
  "Text bei Versions-Konflikt": "Text in case of version conflict",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Since you saved this configuration, the configurator has been upgraded. Do you want to use the current version and continue working or open the old version for viewing only?.",
  "Hilfetext Auswahl Ändern": "Help text for selection change icon",
  "Merkmal ändern": "Change characteristic",
  "Hilfetext Auswahl Entfernen": "Help text for selection removal icon",
  "Auswahl entfernen": "Remove selection",
  "Alte Version": "Old version",
  "Aktuelle Version": "Current version",
  "Zeige Namen": "Show Name",
  "Zeige Beschreibung": "Show Description",
  "Zeige Thumbnail": "Show Thumbnail",
  "Zeige Preis an Merkmal": "Show characteristic price",
  "Zeige Preise an Werten": "Show value prices",
  "Zeige URL": "Show URL",
  "Zeige Info-Button für Werte": "Show Info Button for Values",
  "Zeige HTML Content für Werte": "Show HTML Content for all values",
  "Kamerafahrt beim scrollen": "Camera change when scrolling",
  "Alle ungültigen Werte ausblenden": "Hide all invalid values",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Hide invalid, actively changed, values",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Hide if only one selection is possible",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Disable if only one selection is possible",
  "Komponente hervorheben": "Emphasise component",
  Bild: pNe,
  "Ja/ Nein": "Yes/ No",
  Information: BNe,
  Mehrfachauswahl: fNe,
  Liste: ZNe,
  Eckenrundung: GNe,
  "Anzahl der Eckenrundungsschritte": "Bevel steps",
  "Dieses Material existiert bereits": "This material already exists",
  "Material hinzufügen": "Add material",
  "Materialname eingeben": "Enter material name",
  Abmessungen: yNe,
  Breite: WNe,
  Höhe: "Height",
  Tiefe: SNe,
  Operation: VNe,
  Segmente: wNe,
  Pfad: vNe,
  Startpunkt: RNe,
  Endpunkt: XNe,
  Linienstärke: "Line thickness",
  Startanker: HNe,
  Maßkette: "Dimensional chain",
  Ohne: kNe,
  Endanker: YNe,
  Texttyp: FNe,
  "Kein Text": "No text",
  Zahlenwert: xNe,
  "Statischer Text": "Static text",
  "Automatisches Maß überschreiben": "Override automatic dimension",
  "Neues Maß": "New dimension",
  "Textgröße als Faktor. 1 ist Standard.": "Text size as a factor. 1 is standard.",
  Offsets: DNe,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Here, deviations from position and rotation, which normally result from start and end point, can be defined. For this purpose, the 3D positioning tool can be used.",
  Blau: JNe,
  Grün: "Green",
  Gelb: ENe,
  Rot: NNe,
  Purpur: LNe,
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximum number of iterations for the expression engine reached! There are too complex cycles in the calculated features.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximum number of iterations reached! The rule conflicts cannot be resolved.",
  "Nicht Befüllt": "Not assigned",
  Abkhazian: KNe,
  Afar: TNe,
  Afrikaans: MNe,
  Akan: PNe,
  Albanian: UNe,
  Amharic: zNe,
  Arabic: ONe,
  Aragonese: QNe,
  Armenian: jNe,
  Assamese: qNe,
  Avaric: _Ne,
  Avestan: $Ne,
  Aymara: eLe,
  Azerbaijani: tLe,
  Bambara: iLe,
  Bashkir: nLe,
  Basque: rLe,
  Belarusian: gLe,
  Bengali: oLe,
  Bislama: lLe,
  Bosnian: aLe,
  Breton: sLe,
  Bulgarian: ILe,
  Burmese: cLe,
  "Catalan, Valencian": "Catalan, Valencian",
  Chamorro: dLe,
  Chechen: uLe,
  "Chichewa, Chewa, Nyanja": "Chichewa, Chewa, Nyanja",
  Chinese: CLe,
  "Church Slavonic, Old Slavonic, Old Church Slavonic": "Church Slavonic, Old Slavonic, Old Church Slavonic",
  Chuvash: ALe,
  Cornish: bLe,
  Corsican: hLe,
  Cree: mLe,
  Croatian: pLe,
  Czech: BLe,
  Danish: fLe,
  "Divehi, Dhivehi, Maldivian": "Divehi, Dhivehi, Maldivian",
  "Dutch, Flemish": "Dutch, Flemish",
  Dzongkha: ZLe,
  English: GLe,
  Esperanto: yLe,
  Estonian: WLe,
  Ewe: SLe,
  Faroese: VLe,
  Fijian: wLe,
  Finnish: vLe,
  French: RLe,
  "Western Frisian": "Western Frisian",
  Fulah: XLe,
  "Gaelic, Scottish Gaelic": "Gaelic, Scottish Gaelic",
  Galician: HLe,
  Ganda: kLe,
  Georgian: YLe,
  German: FLe,
  "Greek, Modern (1453-)": "Greek, Modern (1453-)",
  "Kalaallisut, Greenlandic": "Kalaallisut, Greenlandic",
  Guarani: xLe,
  Gujarati: DLe,
  "Haitian, Haitian Creole": "Haitian, Haitian Creole",
  Hausa: JLe,
  Hebrew: ELe,
  Herero: NLe,
  Hindi: LLe,
  "Hiri Motu": "Hiri Motu",
  Hungarian: KLe,
  Icelandic: TLe,
  Ido: MLe,
  Igbo: PLe,
  Indonesian: ULe,
  "Interlingua (International Auxiliary Language Association)": "Interlingua (International Auxiliary Language Association)",
  "Interlingue, Occidental": "Interlingue, Occidental",
  Inuktitut: zLe,
  Inupiaq: OLe,
  Irish: QLe,
  Italian: jLe,
  Japanese: qLe,
  Javanese: _Le,
  Kannada: $Le,
  Kanuri: eKe,
  Kashmiri: tKe,
  Kazakh: iKe,
  "Central Khmer": "Central Khmer",
  "Kikuyu, Gikuyu": "Kikuyu, Gikuyu",
  Kinyarwanda: nKe,
  "Kirghiz, Kyrgyz": "Kirghiz, Kyrgyz",
  Komi: rKe,
  Kongo: gKe,
  Korean: oKe,
  "Kuanyama, Kwanyama": "Kuanyama, Kwanyama",
  Kurdish: lKe,
  Lao: aKe,
  Latin: sKe,
  Latvian: IKe,
  "Limburgan, Limburger, Limburgish": "Limburgan, Limburger, Limburgish",
  Lingala: cKe,
  Lithuanian: dKe,
  "Luba-Katanga": "Luba-Katanga",
  "Luxembourgish, Letzeburgesch": "Luxembourgish, Letzeburgesch",
  Macedonian: uKe,
  Malagasy: CKe,
  Malay: AKe,
  Malayalam: bKe,
  Maltese: hKe,
  Manx: mKe,
  Maori: pKe,
  Marathi: BKe,
  Marshallese: fKe,
  Mongolian: ZKe,
  Nauru: GKe,
  "Navajo, Navaho": "Navajo, Navaho",
  "North Ndebele": "North Ndebele",
  "South Ndebele": "South Ndebele",
  Ndonga: yKe,
  Nepali: WKe,
  Norwegian: SKe,
  "Norwegian Bokmål": "Norwegian Bokmål",
  "Norwegian Nynorsk": "Norwegian Nynorsk",
  "Sichuan Yi, Nuosu": "Sichuan Yi, Nuosu",
  Occitan: VKe,
  Ojibwa: wKe,
  Oriya: vKe,
  Oromo: RKe,
  "Ossetian, Ossetic": "Ossetian, Ossetic",
  Pali: XKe,
  "Pashto, Pushto": "Pashto, Pushto",
  Persian: HKe,
  Polish: kKe,
  Portuguese: YKe,
  "Punjabi, Panjabi": "Punjabi, Panjabi",
  Quechua: FKe,
  "Romanian, Moldavian, Moldovan": "Romanian, Moldavian, Moldovan",
  Romansh: xKe,
  Rundi: DKe,
  Russian: JKe,
  "Northern Sami": "Northern Sami",
  Samoan: EKe,
  Sango: NKe,
  Sanskrit: LKe,
  Sardinian: KKe,
  Serbian: TKe,
  Shona: MKe,
  Sindhi: PKe,
  "Sinhala, Sinhalese": "Sinhala, Sinhalese",
  Slovak: UKe,
  Slovenian: zKe,
  Somali: OKe,
  "Southern Sotho": "Southern Sotho",
  "Spanish, Castilian": "Spanish, Castilian",
  Sundanese: QKe,
  Swahili: jKe,
  Swati: qKe,
  Swedish: _Ke,
  Tagalog: $Ke,
  Tahitian: e3e,
  Tajik: t3e,
  Tamil: i3e,
  Tatar: n3e,
  Telugu: r3e,
  Thai: g3e,
  Tibetan: o3e,
  Tigrinya: l3e,
  "Tonga (Tonga Islands)": "Tonga (Tonga Islands)",
  Tsonga: a3e,
  Tswana: s3e,
  Turkish: I3e,
  Turkmen: c3e,
  Twi: d3e,
  "Uighur, Uyghur": "Uighur, Uyghur",
  Ukrainian: u3e,
  Urdu: C3e,
  Uzbek: A3e,
  Venda: b3e,
  Vietnamese: h3e,
  Volapük: "Volapük",
  Walloon: m3e,
  Welsh: p3e,
  Wolof: B3e,
  Xhosa: f3e,
  Yiddish: Z3e,
  Yoruba: G3e,
  "Zhuang, Chuang": "Zhuang, Chuang",
  Zulu: y3e
}, S3e = "List", V3e = "Colors", w3e = "Text", v3e = "Yes/No", R3e = "Information", X3e = "Image", H3e = "Components", k3e = "Presentation", Y3e = "Actions", F3e = "Values", x3e = "Rules", D3e = "Options", J3e = "Images", E3e = "Configurators", N3e = "Article", L3e = "Front", K3e = "Clockwise", T3e = "MATERIAL", M3e = "Import", P3e = "Manual", U3e = "Accept", z3e = "Rotation", O3e = "General", Q3e = "Texture", j3e = "Roughness", q3e = "Metallness", _3e = "Image stack", $3e = "Scene settings", eTe = "Themes", tTe = "Customization", iTe = "Value range", nTe = "Presentation", rTe = "Values", gTe = "Requests", oTe = "Time", lTe = "Request", aTe = "URI", sTe = "Parameters", ITe = "Duration", cTe = "Server", dTe = "Users", uTe = "Support", CTe = "System Status", ATe = "Others", bTe = "Help", hTe = "Consulting", mTe = "Subscription", pTe = "Profile", BTe = "Trash", fTe = "Log Out", ZTe = "Fullscreen", GTe = {
  always: "Always",
  never: "Never",
  auto: "Like in the configurator",
  label: "Display in confirmation, pdf and shop"
}, yTe = "Activate", WTe = "Deactivate", STe = "Characteristics and Articles", VTe = "Characteristics only", wTe = "Articles only", vTe = "No Overview", RTe = "Rule Entries", XTe = "General", HTe = "PDF", kTe = "Mail", YTe = "Embed", FTe = "Shop", xTe = "Articles", DTe = "Preview", JTe = "Editor", ETe = "Images", NTe = "Materials", LTe = "Models", KTe = "Rules", TTe = "Options", MTe = "Admin", PTe = "Extract", UTe = "Configurators", zTe = "Create", OTe = "Import", QTe = "Users", jTe = "Support", qTe = "Logs", _Te = "System Status", $Te = "Trash", eMe = "Subscription", tMe = "Expired", iMe = "Profile", nMe = "Editor", rMe = "Configurations", gMe = "Tabs", oMe = "Features", lMe = "Design", aMe = "Scene", sMe = "Presentation", IMe = "Options", cMe = "Actions", dMe = "Values", uMe = "Highlighted", CMe = "Ctrl", AMe = "Replace", bMe = "Order", hMe = "Germany", mMe = "Switzerland", pMe = "Andorra", BMe = "Belgium", fMe = "Belarus", ZMe = "Bulgaria", GMe = "Czechia", yMe = "Vatican City State", WMe = "Montenegro", SMe = "Estonia", VMe = "Spain", wMe = "France", vMe = "Guernsey", RMe = "Croatia", XMe = "Ireland", HMe = "Iceland", kMe = "Italy", YMe = "Jersey", FMe = "Albania", xMe = "Kosovo", DMe = "Latvia", JMe = "Lithuania", EMe = "Luxembourg", NMe = "Hungary", LMe = "Monaco", KMe = "Netherlands", TMe = "Norway", MMe = "Poland", PMe = "Portugal", UMe = "Kazakhstan", zMe = "Malta", OMe = "Moldova, Republic of", QMe = "Russian Federation", jMe = "Slovenia", qMe = "Slovakia", _Me = "Serbia", $Me = "Finland", ePe = "Sweden", tPe = "Ukraine", iPe = "Cyprus", nPe = "Greece", rPe = "Macedonia, The Former Yugoslav Republic of", gPe = {
  list: S3e,
  color: V3e,
  text: w3e,
  boolean: v3e,
  information: R3e,
  image: X3e,
  components: H3e,
  presentation: k3e,
  usage: Y3e,
  values: F3e,
  rules: x3e,
  settings: D3e,
  images: J3e,
  configurators: E3e,
  article: N3e,
  "create new dealer": "Create New Dealer",
  Vorne: L3e,
  Uhrzeiger: K3e,
  "Artikel Anzahl": "Article Quantity",
  "Farb auswählen": "Select color",
  "< Zurück": "< Back",
  "Reiter - Rechts": "Tabs - Right",
  "Reiter - Links": "Tabs - Left",
  "Flyaway Reiter - Links": "Flyaway Tabs - Left",
  "Einfach - Links": "Simple - Left",
  "Akkordeons - Rechts": "Accordions - Right",
  "Fullscreen Formular": "Fullscreen Form",
  "Merkmal auswählen": "Choose feature",
  MATERIAL: T3e,
  Import: M3e,
  "Materialien für den Import auswählen:": "Choose materials to import:",
  "Wie möchten Sie ein Material erstellen?": "How do you like to create a material?",
  "Import einer .glb und export der enthaltenen Materialien": "Import of a .glb und export of contained materials",
  Manuell: P3e,
  "Eigenständiges Anlegen eines PBR-Materials": "Manually create a PBR-Material",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Please delete the corresponding column there first",
  Akzeptieren: U3e,
  "Design & Layout": "Design & Layout",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Only visible in preview mode or published configurator!",
  "Theme wählen": "Choose Theme",
  "Komponente löschen": "Delete component",
  "Mehrfach Regelzeilen Bearbeitung": "Multiple rule lines editing",
  "Anzahl ausgewählte Regel-Zeilen:": "Number of selected rule lines:",
  "Modelaktions-Positionierung": "Model action positioning",
  Rotation: z3e,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "No actions available for multiple editing",
  Allgemeines: O3e,
  "Farben und Lichtinteraktion": "Colors and light interaction",
  "Color-Map Upload": "Color map upload",
  "Material interagiert mit Licht in der Szene": "Material interacts with light in the scene",
  Beschaffenheit: Q3e,
  "Roughness-Map Upload": "Roughness map upload",
  Roughness: j3e,
  "Metallness-Map Upload": "Metallness Map Upload",
  Metallness: q3e,
  "Normalen-Map Upload": "Normality Map Upload",
  "Normalen-Skalierung": "Normality Scaling",
  "Anwendung auf 3D-Modell": "Application to 3D model",
  "Displacement-Map Upload": "Displacement Map Upload",
  "Displacement-Skalierung": "Displacement Scaling",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Repeat factor of texture in X and Y direction",
  "Alpha-Werte": "Alpha values",
  "Alpha-Map Upload": "Alpha map upload",
  "Ambient Occlusion": "Ambient Occlusion",
  "Ambient-Occlusion-Map Upload": "Ambient Occlusion Map Upload",
  "Info editieren": "Edit Info",
  "Zeige Info-Button": "Show Info Button",
  "An Shop senden": "Send to shop",
  "Javascript Event senden": "Send javascript event",
  "PDF herunterladen oder versenden": "Save or send PDF",
  "PDF Dokument (optional)": "PDF document (optional)",
  "Interne E-Mail-Adresse": "Internal email address",
  "Interne E-Mail senden": "Send internal email",
  "PDF an interne E-Mail anhängen": "Attach PDF to internal email",
  "PDF Dokument für interne E-Mail (optional)": "PDF document for internal email (optional)",
  "Kunden-Email senden": "Send Customer Email",
  "PDF an Kunden-Email anhängen": "Attach PDF to customer Email",
  "PDF Dokument für Kunden-Email (optional)": "PDF document for customer email (optional)",
  "UST-ID": "Sales tax identification number",
  "Datenschutz-Hinweis": "Privacy",
  "E-mail": "Email",
  Abhängigkeitsschleifen: "Dependency Loops",
  Bilderstapel: _3e,
  "Google Analytics Property ID": "Google Analytics Property ID",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "The flexible store system for your e-commerce project...",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "The one European open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Now Adobe Commerce: E-commerce made easy",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "First class in digital sales with the Oxid esales store.,",
  "Individuelle Entwicklung": "Custom development",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connect shop with custom development...",
  Szeneneinstellungen: $3e,
  Themes: eTe,
  Anpassung: tTe,
  "Gewähltes Theme übernehmen": "Apply selected theme",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Create a new configuration step.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "A configuration is done in several steps. In each step, several product properties can be specified if necessary. Here you create the first step",
  "Konfigurationsschritt erstellen": "Create configuration step",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Please click here first, to create a new configurator",
  "Neuer Konfigurator wählen": "Select new configurator",
  "Bitte geben Sie einen Namen ein.": "Please enter a name",
  "Bitte geben Sie eine Beschreibung ein.": "Please enter a description",
  "Bitte klicken Sie hier.": "Please click here",
  "Konfigurator Dialog aufrufen": "Call configurator dialog",
  "Konfigurationsschritt benennen": "Name configuration step",
  "Hier können Sie neue Werte hinzufügen.": "Here you can add new values",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Characteristics that are a list (or color, material, model) show several values for selection. You can enter these values here",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Click here to create a new value",
  "Wenn Sie fertig sind klicken Sie hier.": "When you are done click here",
  "Werte erstellen": "Create values",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Please enter a name for the new feature",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Please select a presentation that matches the feature's capabilities.,",
  "Präsentation definieren": "Define presentation",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "In one step your customer can customize several features of his product. Insert the first feature here...",
  "Produktmerkmal erstellen": "Create product feature",
  "Was für ein Merkmal wollen Sie anlegen?": "What kind of feature do you want to create?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "A feature can be a selection (e.g. sizes S, M, L and XL), a text or a number (e.g. for a width or height) or even a color or material of your product or a 3D model representing a part of your product",
  "Produktmerkmaltyp auswählen": "Select product feature type",
  "Wählen sie den eben erstellten Konfigurator.": "Select the configurator you just created.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Control the configurator by the new feature.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Features can e.g. cause 3D models or images to be displayed or surfaces to be changed or colored. You can also create a parts list of items, which then determines the price and can be placed in the shopping cart of your store..",
  "Merkmal verwenden": "Use feature",
  Wertebereich: iTe,
  Darstellung: nTe,
  Werte: rTe,
  Anfragen: gTe,
  Zeitpunkt: oTe,
  Anfrage: lTe,
  URI: aTe,
  Parameter: sTe,
  Dauer: ITe,
  Server: cTe,
  "Modell bearbeiten": "Update model",
  "Korrekte Mail-Adresse": "Correct mail address",
  "Statistik (30 Tage)": "Statistics (30 days)",
  "Datum eingeben": "Enter date",
  "Nach hause ": "Home ",
  "Mandant anlegen": "Create client",
  "Nutzer hinzufügen": "Add user",
  Benutzerkonten: dTe,
  Support: uTe,
  Systemstatus: CTe,
  Andere: ATe,
  Dokumentation: bTe,
  Beratung: hTe,
  Abonnement: mTe,
  "Jetzt K3 buchen": "Book K3 now",
  Profil: pTe,
  Papierkorb: BTe,
  Logout: fTe,
  "Die globale Commerce-Plattform": "The global ecommerce platform",
  Fullscreen: ZTe,
  showSelection: GTe,
  "Kamera überschreiben": "Override camera",
  Aktivieren: yTe,
  Deaktivieren: WTe,
  Übersichtsseite: "Overview Page",
  variablesAndArticles: STe,
  variablesOnly: VTe,
  articlesOnly: wTe,
  noOverview: vTe,
  Regelzeilen: RTe,
  "Händler: Bestellung weiterleiten": "Dealer: Forward order",
  "Wird nicht im Konfigurator angezeigt": "not shown in frontend",
  "Dateiname des Pdfs (optional)": "Filename of the pdf (optional)",
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "I have read and accept the privacy policy.",
  "Die Mail-Adresse muss zum Senden freigeschaltet werden - bitte melden Sie sich bei uns.": "The email address must be activated for sending - please contact us.",
  breadcrumb_app: XTe,
  breadcrumb_pdf: HTe,
  breadcrumb_mail: kTe,
  breadcrumb_embed: YTe,
  breadcrumb_shop: FTe,
  breadcrumb_articles: xTe,
  breadcrumb_preview: DTe,
  breadcrumb_edit: JTe,
  breadcrumb_images: ETe,
  breadcrumb_materials: NTe,
  breadcrumb_models: LTe,
  breadcrumb_rules: KTe,
  breadcrumb_settings: TTe,
  breadcrumb_admin: MTe,
  breadcrumb_extract: PTe,
  breadcrumb_apps: UTe,
  breadcrumb_create: zTe,
  breadcrumb_import: OTe,
  breadcrumb_users: QTe,
  breadcrumb_support: jTe,
  breadcrumb_logs: qTe,
  breadcrumb_systemStatus: _Te,
  breadcrumb_trash: $Te,
  breadcrumb_abonnement: eMe,
  breadcrumb_expired: tMe,
  breadcrumb_profile: iMe,
  breadcrumb_configurator: nMe,
  breadcrumb_configurations: rMe,
  breadcrumb_groups: gMe,
  breadcrumb_variables: oMe,
  breadcrumb_design: lMe,
  breadcrumb_scene: aMe,
  breadcrumb_presentation: sMe,
  breadcrumb_options: IMe,
  breadcrumb_usage: cMe,
  breadcrumb_values: dMe,
  "Letzter Schritt kann nicht gelöscht werden.": "Last step cannot be deleted.",
  "Dieses Merkmal ist versteckt.": "This feature is hidden.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `This feature is only visible in the admin panel. This can have several causes: 
 1. It was removed by rule. 
 2. The associated step was removed.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "This feature is only visible in the admin panel: The feature has no selection options.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "This feature is no longer visible because it has no valid selection!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "This feature is no longer visible because it has only one valid selection!",
  "Vertikale Platzierung zulassen?": "Allow vertical placement?",
  Paper: uMe,
  "Content Main": "Canvas Background",
  "Scrollbar Default": "Scrollbar Color",
  "Suchfeld ausblenden?": "Hide searchbar?",
  Modalgröße: "Modal size",
  "Anzahl an Komponenten pro Zeile": "Number of components per row",
  "Weitere Preisauswirkungen dieser Selektion": "Additional price adjustments by this selection",
  "Aktion verstecken": "Hide Action",
  Ctrl: CMe,
  Ersetzen: AMe,
  "Bild hochladen": "Upload image",
  "Das Dateiformat ist nicht erlaubt!": "The file format is not allowed!",
  Bestellen: bMe,
  "Straße und Hausnummer": "Street and number",
  Deutschland: hMe,
  Österreich: "Austria",
  Schweiz: mMe,
  "Åland Inseln": "Åland Islands",
  Andorra: pMe,
  Belgien: BMe,
  Belarus: fMe,
  "Bosnien und Herzegowina": "Bosnia and Herzegovina",
  Bulgarien: ZMe,
  Tschechien: GMe,
  Vatikanstadt: yMe,
  Montenegro: WMe,
  Dänemark: "Denmark",
  Estland: SMe,
  Spanien: VMe,
  Färöer: "Faroe Islands",
  Frankreich: wMe,
  Guernsey: vMe,
  Kroatien: RMe,
  Irland: XMe,
  Island: HMe,
  "Isle of Man": "Isle of Man",
  Italien: kMe,
  Jersey: YMe,
  Albanien: FMe,
  Kosovo: xMe,
  Lettland: DMe,
  "Fürstentum Liechtenstein": "Liechtenstein",
  Lithauen: JMe,
  Luxemburg: EMe,
  Ungarn: NMe,
  Monaco: LMe,
  Niederlande: KMe,
  Norwegen: TMe,
  Polen: MMe,
  Portugal: PMe,
  Kasachstan: UMe,
  Malta: zMe,
  Moldau: OMe,
  Rumänien: "Romania",
  Russland: QMe,
  "San Marino": "San Marino",
  Slowenien: jMe,
  Slowakei: qMe,
  Serbien: _Me,
  Finnland: $Me,
  "Spitzbergen und Jan Mayen": "Svalbard and Jan Mayen",
  Schweden: ePe,
  Türkei: "Turkey",
  Ukraine: tPe,
  "Vereinigtes Königreich": "United Kingdom",
  Zypern: iPe,
  Griechenland: nPe,
  Nordmazedonien: rPe
}, oPe = {
  ...W3e,
  ...gPe
}, lPe = "Client", aPe = "Produit", sPe = "Condition de paiement", IPe = "Clients", cPe = "Admin", dPe = "Configurateurs", uPe = "Créer", CPe = "Importer", APe = "Utilisateur", bPe = "Support", hPe = "Logs", mPe = "Statut du système", pPe = "Corbeille à papier", BPe = "Abonnement", fPe = "Expiré", ZPe = "Profil", GPe = "Configurations", yPe = "Configurateurs", WPe = "Support", SPe = "Revendeur", VPe = "Utilisateur", wPe = "Corbeille à papier", vPe = "Aide", RPe = "Abonnement", XPe = "Profil", HPe = "Déconnexion", kPe = "Template", YPe = "Appeler", FPe = "PDF", xPe = "Code", DPe = "Prix", JPe = "Inspiration", EPe = "Action", NPe = "Langue", LPe = "Client", KPe = "Contenu", TPe = "Version du configurateur", MPe = "Annuler", PPe = "Fermer", UPe = "Champ", zPe = "Éditer", OPe = "Adresse", QPe = "Protection des données", jPe = "Nom", qPe = "Email", _Pe = "Téléphone", $Pe = "Remarque", eUe = "Société", tUe = "Accepte", iUe = "Ville", nUe = "Code Postal", rUe = "Pays", gUe = "Date", oUe = "Revendeur", lUe = "json", aUe = "Prix", sUe = "Options", IUe = "Action de commande", cUe = "Type", dUe = "Configuration", uUe = "AR", CUe = "Partagé", AUe = "afficher", bUe = "Triage", hUe = "Numéro d'article", mUe = "Description", pUe = "Catégorie", BUe = "Prix", fUe = "Article", ZUe = "Changer", GUe = "Téléchargement", yUe = "Pas de", WUe = "Tous les", SUe = "Images", VUe = "Rugosité", wUe = "Métallique", vUe = "Transparent", RUe = "Opacité", XUe = "Couleur", HUe = "Emissif", kUe = "Page", YUe = "Page d'accueil", FUe = "Face arrière", xUe = "Les deux côtés", DUe = "Transmission", JUe = "Réflectivité", EUe = "Couche claire", NUe = "Options", LUe = "Désignation", KUe = "Rendu basé sur la physique (PBR)", TUe = "Physique", MUe = "Clé", PUe = "Modèle", UUe = "Élargi", zUe = "Éditer", OUe = "Copier", QUe = "Exportation", jUe = "Présentation du produit", qUe = "Modèle principal", _Ue = "Mise à niveau", $Ue = "Modèle", eze = "Tutoriel", tze = "Tracking", ize = "share", nze = "Caractéristiques", rze = "Réduction", gze = "Service", oze = "Enregistrer", lze = "Intégrer", aze = "Langue de référence", sze = "Langues", Ize = "Police de caractères", cze = "Helvetica", dze = "Courrier", uze = "Interstate", Cze = "Montserrat", Aze = "Liens", bze = "A droite", hze = "En haut", mze = "En bas", pze = "En-tête", Bze = "Généralités", fze = "Mail", Zze = "Boutique", Gze = "Quitter", yze = "Envoyer", Wze = "Commandes", Sze = "Date", Vze = "Jours", wze = "Nom de l'article", vze = "Article", Rze = "Configurateur", Xze = "Partner", Hze = "Provision", kze = "Nom", Yze = "E-mail", Fze = "Compte d'utilisateur", xze = "Nom d'utilisateur", Dze = "Mot de passe", Jze = "S'inscrire", Eze = "Enregistrement", Nze = "Politique de confidentialité", Lze = "CGV", Kze = "Mot de passe", Tze = "Éditeur", Mze = "Standard", Pze = "De", Uze = "Version", zze = "Réservations", Oze = "Plate-forme", Qze = "Intervalle", jze = "Abonnement", qze = "ID du client", _ze = "Actif", $ze = "Depuis", eOe = "Question", tOe = "Actions", iOe = "Réservation", nOe = "Mois", rOe = "Année", gOe = "Jusqu'à", oOe = "Paramètres", lOe = "Clients", aOe = "ID", sOe = "Factures", IOe = "Vide", cOe = "Utilisateur", dOe = "Rôle", uOe = "Étapes", COe = "Valeurs", AOe = "Règles", bOe = "Lignes de règles", hOe = "Modèles", mOe = "Matériaux", pOe = "Caractéristique", BOe = "Règle", fOe = "Numéro", ZOe = "Statut", GOe = "Créé", yOe = "Mot de passe", WOe = "Nouveau", SOe = "Entrée", VOe = "Inviter", wOe = "Télécharger", vOe = "Modèle de fond", ROe = "Favoris", XOe = "Créer", HOe = "Paramètres de prix", kOe = "Action principale", YOe = "Formulaire de contact", FOe = "Champ obligatoire", xOe = "Nom de l'action", DOe = "Nombre", JOe = "Calcul du nombre", EOe = "Calcul de la quantité", NOe = "Action d'articles", LOe = "Nombre", KOe = "Unité", TOe = "Caméra", MOe = "Étape", POe = "Vue de la caméra", UOe = "Type de caméra", zOe = "Perspective", OOe = "Orthographique", QOe = "Type de mise au point", jOe = "Dupliquer", qOe = "Supprimer", _Oe = "Caméras", $Oe = "Interfaces", e4e = "Gratuit", t4e = "pro", i4e = "Mise à niveau vers le bas", n4e = "Mensuel", r4e = "Accueil", g4e = "Aide", o4e = "Annuler", l4e = "RGPD", a4e = "Icône", s4e = "Logo", I4e = "Couleurs", c4e = "CSS", d4e = "Paramètres", u4e = "Aperçu", C4e = "Article", A4e = "Commandes", b4e = "Statistiques", h4e = "Erreur", m4e = "Malheureusement, une erreur inconnue s'est produite. Si un nouveau chargement de la page ne résout pas le problème, contacte-nous.", p4e = "Erreur inconnue", B4e = "Message d'erreur :", f4e = "Conclusion principale", Z4e = "Conclusion", G4e = "Options de commande", y4e = "Cette étape n'est actuellement visible que dans le panneau d'administration, car elle ne contient pas de caractéristiques avec des valeurs sélectionnables.", W4e = "Texte", S4e = "Couleur de fond", V4e = "Info", w4e = "Couleur d'avertissement", v4e = "Couleur d'erreur", R4e = "Paramètres de base", X4e = "Opacité", H4e = "Action matérielle", k4e = "Action couleur", Y4e = "Action photo", F4e = "Note", x4e = "Attention", D4e = "Continuer", J4e = "Plus", E4e = "Minus", N4e = "Caché", L4e = "Numéro d'article", K4e = "Nom", T4e = "Monnaie", M4e = "Valeur", P4e = "Barre latérale", U4e = "Date de début", z4e = "Date de fin", O4e = "Nombre de départs", Q4e = "Nombre final", j4e = "Rechercher", q4e = "Titel", _4e = "OK", $4e = "Mise en évidence", eQe = "Expression", tQe = "Résultat", iQe = "Valeur minimale", nQe = "Valeur maximale", rQe = "Chiffres après la virgule", gQe = "Pas à pas", oQe = "Calcule", lQe = "Choix de la couleur", aQe = "Liste des composants", sQe = "Cartes de composants", IQe = "Sélection d'images", cQe = "Informations", dQe = "Saisie de chiffres", uQe = "Dropdown", CQe = "Vignettes", AQe = "Interrupteur", bQe = "Saisie de texte", hQe = "Exemple de texte", mQe = "En option", pQe = "Conditions", BQe = "Noms des matériaux", fQe = "Action de labellisation", ZQe = "Message d'erreur", GQe = "Action de modélisation", yQe = "Position", WQe = "Scale", SQe = "Caractéristiques des composants", VQe = "Télécharger", wQe = "Connecter", vQe = "Valeur de la couleur", RQe = "Annonce", XQe = "RAL", HQe = "Vue", kQe = "URL", YQe = "Valeurs de sélection", FQe = "Prix de sélection", xQe = "Sélection", DQe = "Prix total", JQe = "Continue", EQe = "Plein écran", NQe = "Composants", LQe = "xl", KQe = "Déclaration de conflit", TQe = "Ligne de position", MQe = "Quantité", PQe = "Prix par poste", UQe = "Image", zQe = "Information", OQe = "Sélection multiple", QQe = "Liste", jQe = "Arrondissement des angles", qQe = "Dimensions", _Qe = "Large", $Qe = "Profondeur", eje = "Opération", tje = "Segments", ije = "Chemin", nje = "Point de départ", rje = "Point final", gje = "Ancre de démarrage", oje = "Sans", lje = "Ancrage d'extrémité", aje = "Type de texte", sje = "Valeur numérique", Ije = "Offsets", cje = "Bleu", dje = "Jaune", uje = "Rouge", Cje = "Pourpre", Aje = "Abkhaze", bje = "Afar", hje = "Afrikaans", mje = "Akan", pje = "Albanais", Bje = "Amharique", fje = "Arabe", Zje = "Aragonais", Gje = "Arménien", yje = "Assamais", Wje = "Avar", Sje = "Avestique", Vje = "Aymara", wje = "Azerbaïdjanais", vje = "Bambara", Rje = "Bachkir", Xje = "Basque", Hje = "Biélorusse", kje = "Bengali", Yje = "Bichlamar", Fje = "Bosnien", xje = "Breton", Dje = "Bulgare", Jje = "Birman", Eje = "Chamorro", Nje = "Tchétchène", Lje = "Chinois", Kje = "Tchouvache", Tje = "Cornique", Mje = "Corse", Pje = "Cris", Uje = "Croate", zje = "Tchèque", Oje = "Danois", Qje = "Dzongkha", jje = "Anglais", qje = "Espéranto", _je = "Estonien", $je = "Éwé", e6e = "Féroïen", t6e = "Fidjien", i6e = "Finnois", n6e = "Français", r6e = "Peul", g6e = "Galicien", o6e = "Ganda", l6e = "Géorgien", a6e = "Allemand", s6e = "Guarani", I6e = "Gujarati", c6e = "Haoussa", d6e = "Hébreu", u6e = "Herero", C6e = "Hindi", A6e = "Hongrois", b6e = "Islandais", h6e = "Ido", m6e = "Igbo", p6e = "Indonésien", B6e = "Inuktitut", f6e = "Inupiaq", Z6e = "Irlandais", G6e = "Italien", y6e = "Japonais", W6e = "Javanais", S6e = "Kannada", V6e = "Kanouri", w6e = "Cachemiri", v6e = "Kazakh", R6e = "Kinyarwanda", X6e = "Komi", H6e = "Kongo", k6e = "Coréen", Y6e = "Kurde", F6e = "Lao", x6e = "Latin", D6e = "Letton", J6e = "Lingala", E6e = "Lituanien", N6e = "Macédonien", L6e = "Malgache", K6e = "Malais", T6e = "Malayalam", M6e = "Maltais", P6e = "Mannois", U6e = "Maori", z6e = "Marathi", O6e = "Marshallais", Q6e = "Mongol", j6e = "Nauruan", q6e = "Ndonga", _6e = "Népalais", $6e = "Norvégien", e7e = "Occitan", t7e = "Ojibwa", i7e = "Oriya", n7e = "Oromo", r7e = "Pali", g7e = "Persan", o7e = "Polonais", l7e = "Portugais", a7e = "Quechua", s7e = "Romanche", I7e = "Rundi", c7e = "Russe", d7e = "Samoan", u7e = "Sango", C7e = "Sanskrit", A7e = "Sarde", b7e = "Serbe", h7e = "Shona", m7e = "Sindhi", p7e = "Slovaque", B7e = "Slovène", f7e = "Somali", Z7e = "Soundanais", G7e = "Swahili", y7e = "Swati", W7e = "Suédois", S7e = "Tagalog", V7e = "Tahitien", w7e = "Tadjik", v7e = "Tamoul", R7e = "Tatar", X7e = "Télougou", H7e = "Thaï", k7e = "Tibétain", Y7e = "Tigrigna", F7e = "Tsonga", x7e = "Tswana", D7e = "Turc", J7e = "Turkmène", E7e = "Twi", N7e = "Ukrainien", L7e = "Ourdou", K7e = "Ouzbek", T7e = "Venda", M7e = "Vietnamien", P7e = "Wallon", U7e = "Gallois", z7e = "Wolof", O7e = "Xhosa", Q7e = "Yiddish", j7e = "Yoruba", q7e = "Zoulou", _7e = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Tu ne paies pas en ligne. Contacte la personne de ton entreprise qui a conclu le contrat avec ObjectCode.",
  Mandant: lPe,
  Produkt: aPe,
  Bezahlzustand: sPe,
  Mandanten: IPe,
  Admin: cPe,
  Konfiguratoren: dPe,
  Erstellen: uPe,
  Importieren: CPe,
  Benutzer: APe,
  Support: bPe,
  Logs: hPe,
  Systemstatus: mPe,
  Papierkorb: pPe,
  Abonnement: BPe,
  Ausgelaufen: fPe,
  Profil: ZPe,
  Konfigurationen: GPe,
  Händler: "Revendeur",
  apps: yPe,
  support: WPe,
  "dealer-profile": "Profil du revendeur",
  dealers: SPe,
  users: VPe,
  trash: wPe,
  help: vPe,
  subscription: RPe,
  profile: XPe,
  logout: HPe,
  "Neuer Konfigurator": "Nouveau configurateur",
  Template: kPe,
  Zurück: "Retour",
  Aufrufen: YPe,
  PDF: FPe,
  Code: xPe,
  Preis: DPe,
  Inspiration: JPe,
  Aktion: EPe,
  Sprache: NPe,
  "Sie möchten die Daten dieses Kunden einsehen?": "Tu souhaites consulter les données de ce client ?",
  Kunde: LPe,
  Inhalt: KPe,
  "Shop-API": "API de la boutique",
  "Gespeichert am": "Sauvé le",
  Konfiguratorversion: TPe,
  Abbrechen: MPe,
  "Ergebnis der Shop API": "Résultat de l'API de la boutique",
  Schliessen: PPe,
  Feld: UPe,
  Bearbeiten: zPe,
  Adresse: OPe,
  Datenschutz: QPe,
  Name: jPe,
  Email: qPe,
  Telefon: _Pe,
  Bemerkung: $Pe,
  Firma: eUe,
  "Steuer-ID": "Numéro d'identification fiscale",
  Akzeptiert: tUe,
  Stadt: iUe,
  PLZ: nUe,
  Land: rUe,
  Datum: gUe,
  "exit-action": "Action de commande",
  dealer: oUe,
  "order-status": "Statut",
  json: lUe,
  price: aUe,
  options: sUe,
  Bestellaktion: IUe,
  Typ: cUe,
  Konfiguration: dUe,
  AR: uUe,
  Geteilt: CUe,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Tu souhaites consulter les données de tes clients ?",
  "Preise anlegen": "Créer des prix",
  anzeigen: AUe,
  "Artikel und Preise erfolgreich importiert.": "Articles et prix importés avec succès.",
  Sortierung: bUe,
  Artikelnummer: hUe,
  "Artikelnummer eingeben": "Saisir le numéro de l'article",
  "Namen eingeben": "Saisir le nom",
  Beschreibung: mUe,
  "Beschreibung eingeben": "Entrer la description",
  Kategorie: pUe,
  "Kategorien eingeben": "Saisir les catégories",
  Preise: BUe,
  "Sortierung erfolgreich angewendet.": "Tri appliqué avec succès.",
  "Fehler beim Anwenden der Sortierung: ": "Erreur lors de l'application du tri : ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Article et prix publiés avec succès.",
  "Fehler beim Veröffentlichen: ": "Erreur lors de la publication: ",
  "Sie möchten Preise anzeigen?": "Tu veux afficher les prix ?",
  "Neuer Artikel": "Nouvel article",
  Löschen: "Supprimer",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publie l'application pour pouvoir publier des articles et des prix.",
  "Artikel und Preise veröffentlichen": "Publier des articles et des prix",
  Artikel: fUe,
  "Preise für Artikel nr.": "Prix pour l'article n°",
  Schließen: "Fermer",
  "Preise werden automatisch importiert. Änderungen sind nicht möglich.": "Les prix sont importés automatiquement. Les modifications ne sont pas possibles.",
  "Sie verwenden nicht die aktuelle Release des K3. Das kann zu technischen Problemen führen. Bitte wechseln Sie sobald möglich auf die aktuelle Release und veröffentlichen Sie.": "Tu n'utilises pas la version actuelle de K3. Cela peut entraîner des problèmes techniques. Veuillez passer à la version actuelle dès que possible et publier.",
  Wechseln: ZUe,
  Upload: GUe,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Télécharge une ou plusieurs images dans le dossier indiqué. Tu peux utiliser la barre oblique (/) pour créer des dossiers plus profonds.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Sinon, tu peux télécharger une archive ZIP avec une structure de dossier.",
  "Ordner *": "Dossier *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': `N'oublie pas : toutes les images dans un dossier sont regroupées en tant que galerie, triées par nom. Utilise donc des noms de fichiers comme "image_001".`,
  Keine: yUe,
  Alle: WUe,
  Bilder: SUe,
  Roughness: VUe,
  Metalness: wUe,
  Transparent: vUe,
  Opacity: RUe,
  Farbe: XUe,
  Emissive: HUe,
  "Color Map": "Couleur Texture",
  "Normal Map": "Texture normale",
  "Roughness Map": "Rugosité Texture",
  "Metalness Map": "Texture métallique",
  "Alpha Map": "Texture Alpha",
  Seite: kUe,
  Vorderseite: YUe,
  Hinterseite: FUe,
  Beidseitig: xUe,
  "Texture repeat": "Répétition de la texture",
  "Depth Write": "Depth Write",
  Transmission: DUe,
  Reflectivity: JUe,
  ClearCoat: EUe,
  "Clearcoat Roughness": "Rugosité du vernis",
  "new-material": "Nouveau matériel",
  Optionen: NUe,
  Bezeichnung: LUe,
  Pbr: KUe,
  Physikalisch: TUe,
  Key: MUe,
  "AR Fallback Material": "Matériel de retombée AR",
  "Nicht ausgewählt": "Non sélectionné",
  Model: PUe,
  Erweitert: UUe,
  "Nur in Regeln verwendete Materialien anzeigen": "Afficher uniquement les matériaux utilisés dans les règles",
  "extract-materials": "Extraire les matériaux du modèle",
  Editieren: zUe,
  Kopieren: OUe,
  "Neues Modell": "Nouveau modèle",
  "Dynamisches Modell": "Modèle dynamique",
  "Neue Regel Erstellen": "Créer une nouvelle règle",
  "Regel erstellen": "Créer une règle",
  Gültigkeit: "Validité",
  "Neue Regel": "Nouvelle règle",
  Export: QUe,
  "app-code-duplicate": "Le code de l'application est déjà utilisé",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "Les paramètres de l'application n'ont pas pu être enregistrés. Le code est déjà utilisé.",
  "screenshot-quality": "Capture d'écran Qualité",
  Produktdarstellung: jUe,
  "3D-Modell": "Modèle 3D",
  "Bilder-Konfigurator": "Configurateur d'images",
  Hauptmodell: qUe,
  "Hauptmodell entfernen": "Supprimer le modèle principal",
  "Link zum Konfigurator": "Lien vers le configurateur",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Si tu utilises une extension, indique ici où ton développeur la met à disposition.",
  "Die Beschreibung dieses Konfigurators": "La description de ce configurateur",
  "Google Analytics 4 Property ID": "Google Analytics 4 ID de propriété",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Tu dois obtenir l'accord de l'utilisateur pour le cookie Google. Cela ne se passe pas à l'intérieur de K3 !",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Tu veux connecter ton compte Analytics ?",
  Upgrade: _Ue,
  Vorlage: $Ue,
  "Dieser Konfigurator dient als Vorlage": "Ce configurateur sert de modèle",
  Tutorial: eze,
  "Standard übernehmen": "Adopter le standard",
  Tracking: tze,
  share: ize,
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Vous pouvez indiquer ici une URL vers laquelle différentes données sont envoyées dès que l'utilisateur effectue une sélection. Vous avez ainsi la possibilité d'afficher des informations spéciales à l'aide du composant CustomData dans le Layout Designer (par ex. indiquer les frais de livraison, etc.).",
  "Preis & Info Service": "Service Prix & Info",
  "Hilfe dazu finden Sie hier.": "Vous trouverez de l'aide ici.",
  "URL für den Service, der die Daten verarbeitet": "URL du service qui traite les données",
  "Debounce in ms": "Débattement en ms",
  Merkmale: nze,
  "Merkmale und ihre aktuelle Auswahlen senden": "Envoyer les caractéristiques et leurs sélections actuelles",
  "Optionale Merkmalbeschränkung": "Limitation facultative des caractéristiques",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "En option, limitez les caractéristiques qui seront envoyées.",
  "Artikel & Preis": "Article & prix",
  "Aktuell ausgewählte Artikel senden": "Envoyer les articles actuellement sélectionnés",
  "Aktuellen Preis senden": "Envoyer le prix actuel",
  "to dealer app": "Vers l'application pour les commerçants",
  "Händler hat Zugriff": "Le commerçant a accès",
  "Händler hat keinen Zugriff": "Le commerçant n'a pas accès",
  "dealer query": "Préférences",
  "Händler legt Aufschlag fest": "Le commerçant fixe la majoration",
  discount: rze,
  surcharge: gze,
  "Um diesem Händler Zugriff zu geben oder ihn zu entziehen, ": "Pour donner ou retirer l'accès à ce commerçant, ",
  "wenden Sie sich bitte an uns": "contacte-nous",
  Speichern: oze,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Tu veux que tes distributeurs puissent utiliser ton configurateur ?",
  "Keine Händler vorhanden": "Aucun revendeur disponible",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Crée d'abord un revendeur - puis donne-lui accès à l'application ici.",
  "Jetzt Händler anlegen": "Créer des commerçants maintenant",
  Einbetten: lze,
  "Als Link": "En tant que lien",
  "Als IFrame": "Comme IFrame",
  "Meldungen beim Laden anpassen": "Personnaliser les messages de chargement",
  "Bitte Auth0 Zugangsdaten angeben": "Veuillez indiquer les données d'accès Auth0",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Vous souhaitez n'autoriser l'accès au configurateur qu'à certains utilisateurs ? Dans ce cas, vous pouvez utiliser le service Auth0.",
  "Konfigurator-Zugang": "Accès au configurateur",
  "Anmeldung für Konfigurator verlangen.": "Demander une connexion pour le configurateur.",
  "Auth0 Domain": "Domaine Auth0",
  "Auth0 ClientId": "ClientId Auth0",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Langue de référence. Les entrées doivent correspondre à la colonne de référence dans le fichier importé pour être prises en compte.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Mauvais format de fichier, assure-toi d'utiliser le format du fichier exporté pour la langue de référence actuellement sélectionnée.",
  "Info ": "Info ",
  "Sprache: ": "Langue: ",
  "Referenzsprache: ": "Langue de référence: ",
  Referenzsprache: aze,
  "Anzahl Sprachen: ": "Nombre de langues: ",
  "Anzahl übersetzbarer Texte: ": "Nombre de textes traduisibles: ",
  Sprachen: sze,
  "Die erste Sprache gilt als Standard.": "La première langue est considérée comme standard.",
  Übersetzungen: "Traductions",
  "Versteckte Merkmale": "Caractéristiques cachées",
  "Unbenutzte Sprachen": "Langues inutilisées",
  "Importiere XLSX": "Importer XLSX",
  "Exportiere XLSX": "Exporter XLSX",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Tu souhaites envoyer des demandes par e-mail à tes clients et/ou à toi-même ?",
  "Mail Texte": "Textes de mail",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Ici, tu peux adapter le contenu des mails envoyés. Lis au préalable la section dans la documentation.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Attention : tu dois toujours publier le configurateur avant d'utiliser les textes modifiés.",
  Schriftart: Ize,
  Helvetica: cze,
  "Times Roman": "Times Roman",
  Courier: dze,
  Interstate: uze,
  Montserrat: Cze,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Bold",
  Schriftgröße: "Taille de la police",
  Links: Aze,
  Rechts: bze,
  Oben: hze,
  Unten: mze,
  Kopfzeile: pze,
  Fußzeile: "Pied de page",
  "Neue PDF Vorlage auswählen": "Choisir un nouveau modèle PDF",
  "Vorhandene PDF Vorlage löschen": "Supprimer un modèle PDF existant",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Tu souhaites envoyer des confirmations ou des offres au format PDF?",
  "PDF Einstellungen": "Paramètres PDF",
  Seitenränder: "Marges",
  "Voransicht mit dieser Konfiguration:": "Prévisualisation avec cette configuration :",
  "und diesem Template:": "et ce modèle :",
  "Speichern und drucken": "Enregistrer et imprimer",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Pour pouvoir imprimer un aperçu, il faut disposer d'une configuration enregistrée.",
  Allgemein: Bze,
  Mail: fze,
  Shop: Zze,
  "Ungespeicherte Änderungen": "Modifications non enregistrées",
  "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?": "Tu as des modifications non enregistrées. Es-tu sûr de vouloir quitter sans enregistrer?",
  Verlassen: Gze,
  "Immer aktuellste Version verwenden": "Utiliser toujours la version la plus récente",
  "K3 Version": "K3 Version",
  "Wir helfen gern!": "Nous sommes heureux de t'aider !",
  "Ihre Telefonnummer": "Ton numéro de téléphone",
  "Ihre Nachricht": "Ton message",
  Senden: yze,
  "Nachricht senden": "Envoyer un message",
  "Rückruf erbitten": "Demander à être rappelé",
  orders: Wze,
  date: Sze,
  "Preise wurden in den Einstellungen deaktiviert": "Les prix ont été désactivés dans les paramètres",
  "Keine Einnahmen vorliegend": "Pas de recettes en jeu",
  "total-earnings": "Recettes totales",
  Tage: Vze,
  articlename: wze,
  articles: vze,
  "Erfolgreich importiert": "Importé avec succès",
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Tu peux exporter un configurateur sous "Paramètres". Tu peux réimporter le fichier obtenu ici.',
  "JSON Export Datei": "Fichier d'exportation JSON",
  "Leerer Konfigurator": "Configurateur vide",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Commence avec un configurateur vide et configure-le comme tu le souhaites.",
  "Konfigurator importieren": "Importer le configurateur",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importe un configurateur à partir d'un fichier exporté.",
  Veröffentlicht: "Publié",
  "Mandant hat noch keinen Konfigurator": "Le client n'a pas encore de configurateur",
  Konfigurator: Rze,
  "Link kopiert": "lien copié",
  "E-Mail": "E-mail",
  "Werben Sie K3 Kunden!": "Parrainez des clients K3!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Transmettez le lien ci-dessous. Si votre contact réserve un configurateur, vous recevrez une commission.",
  Partner: Xze,
  Provision: Hze,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Veuillez noter que tout lien d'affiliation émis deviendra invalide une fois que vous aurez modifié le code.",
  "Meine Kunden": "Mes clients",
  "Vielen Dank für Ihre Bestätigung...": "Merci beaucoup pour ta confirmation...",
  "E-Mail Bestätigung": "Confirmation par e-mail",
  "Zur Anmeldung": "Vers l'inscription",
  Händlerprofil: "Profil du revendeur",
  name: kze,
  email: Yze,
  "E-Mail ist ungültig!": "L'e-mail n'est pas valide !",
  Nutzerkonto: Fze,
  Nutzername: xze,
  "Mail ist schon vergeben": "Mail est déjà pris",
  "code-duplicate": "Ce code est déjà pris",
  "dealer code helper text": "Pour accéder au configurateur du revendeur.",
  "default discount": "remise par défaut",
  "Kann pro Konfigurator überschrieben werden.": "Peut être écrasé par configurateur.",
  "default surcharge": "surcharge par défaut",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Merci de vérifier les informations que tu as fournies : ",
  "Fehlendes Produkt": "Produit manquant",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Tu veux que tes distributeurs puissent utiliser un de tes configurateurs ?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Réserve d'abord un autre produit.",
  "new dealer": "Nouveau distributeur",
  "Login screen": "Inscription",
  "Bitte am Desktop öffnen": "Ouvrir sur le bureau",
  Password: Dze,
  Login: Jze,
  "Passwort vergessen?": "Mot de passe oublié ?",
  "Noch kein Konto?": "Pas encore de compte ?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Une connexion n'a malheureusement pas été possible. La combinaison de l'e-mail et du mot de passe n'est pas valide.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Une connexion n'a malheureusement pas été possible. Veuillez autoriser les cookies du site web dans les paramètres de votre navigateur.",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Si le mail n'arrive pas dans les minutes qui suivent, regarde aussi dans ton dossier SPAM et vérifie ton adresse.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "Nous t'enverrons un e-mail avec des instructions pour mettre en place un nouveau mot de passe.",
  "Mail senden": "Envoyer un mail",
  "K3 - die Konfiguratorplattform": "K3 - la plateforme de configurateur",
  "Ich habe den Konfigurator innerhalb von drei Wochen fertiggestellt und er hat sich bereits mehr als rentiert.": "J'ai terminé le configurateur en trois semaines, et il a déjà été largement rentable.",
  "Die Eingabe ist zu kurz.": "La saisie est trop courte.",
  "Die Eingabe ist zu lang.": "La saisie est trop longue.",
  "Die Eingabe wird benötigt.": "La saisie est requise.",
  "Email Adresse ist ungültig.": "L'adresse e-mail n'est pas valide.",
  "Dieser Wert wird bereits benutzt.": "Cette valeur est déjà utilisée.",
  "Das Kennwort muss mindestens 8 Zeichen lang sein und Buchstaben, Großbuchstaben und Zahlen enthalten.": "Le mot de passe doit comporter au moins 8 caractères et contenir des lettres, des majuscules et des chiffres.",
  "Die Eingabe fehlt.": "La saisie manque.",
  "Leider ": "Malheureusement ",
  "Bitte geben Sie eine E-Mail-Adresse an": "Veuillez indiquer une adresse e-mail",
  "Die angegebene E-Mail-Adresse hat ein ungültiges Format": "Le format de l'adresse e-mail indiquée est invalide",
  "Bitte geben Sie ein Passwort an": "Veuillez indiquer un mot de passe",
  "Bitte geben Sie eine Telefonnummer an": "Veuillez indiquer un numéro de téléphone",
  "Die eingegebene Telefonnummer hat ein ungültiges Format": "Le format du numéro de téléphone saisi est invalide",
  "Bitte stimmen Sie unseren Datenschutzhinweisen und Geschäftsbedigungen zu": "Veuillez accepter notre politique de confidentialité et nos conditions générales",
  Registrierung: Eze,
  "Ihre E-Mail-Adresse": "Ton adresse e-mail",
  "Bitte wählen Sie ein Kennwort": "Choisis un mot de passe",
  "Direkt starten - ohne Zahlungsangaben.": "Démarrez directement - aucune information de paiement requise.",
  "Bitte bestätigen Sie unsere ": "Merci de confirmer notre ",
  Datenschutzbestimmungen: Nze,
  " und unsere ": " et nos ",
  AGB: Lze,
  "Jetzt registrieren": "S'inscrire maintenant",
  "Die Registrierung war leider nicht möglich.": "Malheureusement, l'inscription n'a pas été possible.",
  "Herzlich willkommen!": "Bienvenue à toi !",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "Nous t'avons envoyé un e-mail - regarde aussi dans ton dossier spam.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Mais tu peux aussi t'inscrire dès maintenant avec tes données :",
  "Wir haben Ihr Kennwort neu gesetzt.": "Nous avons réinitialisé ton mot de passe.",
  "Passwort setzen": "Définir un mot de passe",
  Passwort: Kze,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Au moins 8 caractères, majuscules, minuscules et chiffres",
  Bestätigung: "Confirmation",
  "Bestätigung stimmt nicht überein": "La confirmation ne correspond pas",
  "Kennwort setzen": "Définir un mot de passe",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - le configurateur de produits 3D pour Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "Vous avez installé avec succès l'application Shopify pour le configurateur K3. Voici les prochaines étapes:",
  "Registrieren Sie sich am K3.": "Enregistrez-vous sur K3.",
  "Legen Sie einen Konfigurator an.": "Créez un configurateur.",
  "Jetzt starten": "Commencez maintenant",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Connectez le configurateur à votre boutique et importez vos articles Shopify.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Concevez le configurateur pour votre produit.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Ajoutez le configurateur à votre boutique.",
  Editor: Tze,
  "Mandant: ": "Client ",
  "Erstellt am: ": "Créé le ",
  "Veröffentlicht am: ": "Publié le ",
  "Noch nicht veröffentlicht": "Pas encore publié",
  "Version: ": "version : ",
  "Artikel-Version: ": "Version de l'article : ",
  "Code: ": "Code : ",
  "Typ: ": "Type : ",
  Standard: Mze,
  "Shop: ": "Boutique : ",
  "Nicht verbunden": "Non connecté",
  "Bestellungen insgesamt": "Total des commandes",
  Veröffentlichungen: "Publications",
  Von: Pze,
  Version: Uze,
  "Artikel-Version": "Version de l'article",
  Buchungen: zze,
  Plattform: Oze,
  Intervall: Qze,
  Subscription: jze,
  CustomerID: qze,
  Aktiv: _ze,
  Seit: $ze,
  "Abschlag [%]": "Réduction [%]",
  "Aufschlag [%]": "Supplément [%]",
  Query: eOe,
  Aktionen: tOe,
  "Mandanten wechseln": "Changer de client",
  "Konnte nicht gespeichert werden: ": "N'a pas pu être enregistré : ",
  Buchung: iOe,
  "Angelegt am": "Créé le",
  "Zum AdminPanel": "Vers l'AdminPanel",
  "App editieren": "Éditer l'app",
  Monat: nOe,
  Jahr: rOe,
  "Bezahlt?": "Payé ?",
  Bis: gOe,
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Échec de la confirmation. Les noms ne correspondent pas.",
  "Einstiegs-Produkt": "Produit d'entrée de gamme",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "ID de bande",
  Parameter: oOe,
  "Partner?": "Partenaire?",
  Kunden: lOe,
  ID: aOe,
  Rechnungen: sOe,
  Leer: IOe,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "Le mandant complet est exporté - y compris tous les actifs. Continuer?",
  "Mandant unwiderruflich löschen": "Supprimer le mandant de manière irrévocable",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "Le mandant complet est irrévocablement supprimé - y compris tous les actifs. Avez-vous réalisé une exportation? Continuer?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Veuillez confirmer le nom du mandant à supprimer:",
  Nutzer: cOe,
  "Mandant erfolgreich gelöscht": "Mandant supprimé avec succès",
  "Mandanten editieren": "Éditer des mandants",
  Rolle: dOe,
  Schritte: uOe,
  Werte: COe,
  Regeln: AOe,
  Regelzeilen: bOe,
  Modelle: hOe,
  Materialien: mOe,
  Gelöscht: "Supprimé",
  Merkmal: pOe,
  Regel: BOe,
  Nummer: fOe,
  Status: ZOe,
  Erstellt: GOe,
  Zurücklegen: "Remettre",
  Mindestlänge: "Longueur minimale {{chars}} Caractères",
  "Email Adresse ist ungültig": "L'adresse e-mail n'est pas valide",
  Kennwort: yOe,
  "Test stimmt nicht überein": "Le test ne correspond pas",
  "Telefonnummer ist ungültig": "Le numéro de téléphone n'est pas valide",
  "Entwickler Modus": "Mode développeur",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Donne aux développeurs l'accès à des possibilités avancées.",
  "API Token": "Jeton API",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Si tu crées un nouveau jeton API, tous les précédents seront supprimés.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Ainsi, toutes les boutiques que tu as connectées perdent également l'accès au configurateur.",
  "Sie können das Token im Shop-Plugin eintragen.": "Tu peux inscrire le jeton dans le plugin de la boutique.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Note le nouveau jeton, il ne sera affiché ici qu'une seule fois.",
  Neu: WOe,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "Grâce à l'ApiToken, une boutique ou ton développement individuel a accès aux données de tes configurateurs.",
  "Sie möchten über die API auf den K3 zugreifen?": "Vous souhaitez accéder au K3 via l'API ?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dans ce cas, vous devez réserver un produit correspondant pour au moins un de vos configurateurs.",
  "Neuen Nutzer anlegen": "Créer un nouvel utilisateur",
  Eingabe: SOe,
  "E-Mail nicht valide!": "E-mail non valide !",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "Nous envoyons un e-mail au nouvel utilisateur avec un lien. Il pourra y définir son mot de passe et aura alors accès à ton configurateur.",
  "Nutzer einladen": "Inviter un utilisateur",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "L'utilisateur a accès à votre client.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Merci de vérifier les informations que tu as fournies :",
  Einladen: VOe,
  "Benutzer einladen": "Inviter des utilisateurs",
  "new user": "Nouvel utilisateur",
  "Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.": "Ce configurateur n'a actuellement pas de licence valide.",
  "CSS-Datei auswählen": "Sélectionner le fichier CSS",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Tu souhaites utiliser des modèles dynamiques et les utiliser pour vendre des produits sur mesure, par exemple ?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Le modèle dépasse avec {{curr}} le nombre recommandé de {{max}} Triangles. Il se peut que tu aies des problèmes en mode AR.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Le modèle dépasse avec {{curr}}MB la taille de fichier recommandée de {{max}}MB",
  "3D-Modell auswählen": "Sélectionner un modèle 3D",
  Download: wOe,
  Hintergrundmodell: vOe,
  "material-upload": "material-upload",
  Favoriten: ROe,
  "main-model": "Modèle principal",
  "Wirft Schatten": "Jette des ombres",
  "Wird schattiert": "Est ombragé",
  "Bilder Galerie": "Galerie d'images",
  Anlegen: XOe,
  "Neue Aktion": "Nouvelle action",
  Preiseinstellungen: HOe,
  "Preise im Konfigurator ausblenden?": "Masquer les prix dans le configurateur ?",
  Hauptaktion: kOe,
  Kontaktformular: YOe,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Tu peux certes saisir ces données clients, mais tu ne peux pas les consulter.",
  Pflichtfeld: FOe,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Tu peux inclure des liens vers tes propres documents avec <a href=N https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Informations sur la protection des données</a>.',
  "Shop verbinden": "Connecter la boutique",
  Aktionsname: xOe,
  "Überschrift Bestätigung": "Titre confirmation",
  "Text Bestätigung": "Texte confirmation",
  "Link zur Konfiguration zeigen?": "Montrer le lien vers la configuration ?",
  "Thumbnail des Konfigurators": "Vignette du configurateur",
  "Artikel hat keinen Namen und keine Nummer!": "L'article n'a ni de nom ni de numéro !",
  "Kein Artikel ausgewählt!": "Pas d'article sélectionné !",
  "Artikel auswählen": "Choisir un article",
  "Artikelanzahl und Menge": "Nombre et quantité d'articles",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Combien de fois l'article correspondant doit être ajouté",
  Anzahl: DOe,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Pertinent pour la nomenclature, par exemple pour la longueur d'un poteau",
  "Menge (optional)": "Quantité (optionnel)",
  Anzahlberechnung: JOe,
  Mengenberechnung: EOe,
  Artikelaktion: NOe,
  "Wert eingeben": "Entrer la valeur",
  "Neue Spalte": "Nouvelle colonne",
  "Wert-Eigenschaft": "Propriété de la valeur",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Tu peux donner des propriétés aux valeurs de cette caractéristique, par exemple le poids ou la classe de qualité ou la performance. Tu peux saisir ces propriétés séparément pour chaque valeur et les afficher ensuite à l'utilisateur. Mais tu peux aussi utiliser ces propriétés pour rendre les règles et les calculs beaucoup plus simples.",
  "Eigenschaft wird dem Nutzer angezeigt": "La propriété est affichée à l'utilisateur",
  "mehrsprachiger Text": "Texte multilingue",
  "nicht übersetzter Text": "Texte non traduit",
  Zahl: LOe,
  Einheit: KOe,
  "Buchen Sie jetzt Ihre Lizenz!": "Réservez maintenant votre licence !",
  "Denken Sie daran, den Konfigurator zu veröffentlichen, damit er für Ihre Kunden freigegeben wird.": "N'oublie pas de publier le configurateur pour qu'il soit accessible à tes clients.",
  "Fokus auf Modelle": "Focus sur les modèles",
  "Alle Modelle": "Tous les modèles",
  "Fokus über Objektnamen": "Focus sur les noms d'objets",
  Kamera: TOe,
  Schritt: MOe,
  Kameraansicht: POe,
  Kameratyp: UOe,
  Perspektive: zOe,
  Orthographisch: OOe,
  Fokustyp: QOe,
  "Dynamischer Fokus": "Mise au point dynamique",
  "Statischer Fokus": "Mise au point statique",
  "Screenshot Auflösung": "Capture d'écran Résolution",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Différence nécessaire par rapport à la vue actuelle",
  "Noch keine Kamera gespeichert": "Pas encore de caméra enregistrée",
  "Kamera erstellen": "Créer une caméra",
  "Bitte auswählen": "Choisir s'il te plaît",
  Ausgewählt: "Choisi",
  "Merkmal setzen: ": "Mettre une caractéristique : ",
  "Keine Farbe ausgewählt!": "Pas de couleur choisie !",
  "Farbe auswählen": "Choisir la couleur",
  "Farbmerkmal auswählen:": "Sélectionner une caractéristique de couleur :",
  "Keine Auswahl": "Pas de sélection",
  "Hoch schieben": "Pousser vers le haut",
  "Runter schieben": "Pousser vers le bas",
  Duplizieren: jOe,
  "Löschen des aktiven Elements nicht möglich": "Impossible de supprimer l'élément actif",
  "Komponente hinzufügen": "Ajouter un composant",
  Entfernen: qOe,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Ta configuration n'a pas pu être enregistrée.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Veuillez nous excuser. Nous avons sauvegardé la configuration dans ce navigateur. Merci de revenir plus tard.",
  "technische Information:": "information technique :",
  "Preis: ": "Le prix : ",
  "Kamera bearbeiten": "Modifier la caméra",
  "Neue Kamera für Bestellungsbilder": "Nouvel appareil photo pour les photos de commande",
  "Ansicht übernehmen und Speichern": "Prendre la vue et enregistrer",
  "Kameras für Bestellungsbilder": "Caméras pour les photos de commande",
  Kameras: _Oe,
  "Anfrage erhalten": "Recevoir une demande",
  "Buchung erfolgreich": "Réservation réussie",
  "Für das neue Produkt melden wir uns bei Ihnen.": "Pour le nouveau produit, nous te contacterons.",
  "Ihre Subskription wurde angepasst.": "Ta souscription a été adaptée.",
  "Ihre Subskription wurde beendet.": "Ta souscription est terminée.",
  "Das Produkt wurde gebucht.": "Le produit a été réservé.",
  "3D-Konfigurator mit beliebig komplexer Logik": "Configurateur 3D avec une logique aussi complexe que vous le souhaitez",
  "E-Mail mit PDF erhalten": "Recevoir un e-mail avec un PDF",
  "Shop-Anbindung": "Connexion à la boutique",
  Schnittstellen: $Oe,
  "Auf Anfrage": "Sur demande",
  Kostenfrei: e4e,
  pro: t4e,
  "Meine Rechnungen": "Mes factures",
  "Derzeit gebucht.": "Actuellement réservé.",
  "Änderung Ihrer Buchung": "Modification de votre réservation",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Tu vas maintenant réserver un nouveau produit. Tu veux continuer?",
  "Jetzt buchen": "Réserver maintenant",
  Downgrade: i4e,
  "Zahlungsplan ändern": "Modifier le plan de paiement",
  Monatlich: n4e,
  Jährlich: "Annuellement",
  "In neuem Tab öffnen": "Ouvrir dans un nouvel onglet",
  "Konfigurator anpassen": "Personnaliser le configurateur",
  "main drawer": "Tu vois un aperçu de ton configurateur que tu peux utiliser comme d'habitude. Clique sur une icône de crayon pour modifier quelque chose ou :",
  "Ändern Sie die Bestelloptionen": "Modifie les options de commande",
  "Ändern Sie das Design": "Modifie le design",
  "Passen sie die 3D Szene an": "Ajuste la scène 3D",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "Enregistre la caméra actuelle pour les images de commande",
  "Merkmale verwalten": "Gérer les caractéristiques",
  "Ihre Lizenz": "Ta licence",
  "So richten Sie Ihren Konfigurator ein:": "Voici comment configurer ton configurateur :",
  Home: r4e,
  Hilfe: g4e,
  "dealer sidebar": "Ici, tu peux configurer ton distributeur",
  "Ändern Sie das Logo": "Modifie le logo",
  "Ändern Sie die DSGVO": "Modifie le RGPD",
  "Ändern Sie den Preis": "Modifie le prix",
  "Ändern Sie die PDF Vorlage": "Modifie le modèle PDF",
  "PDF Gestaltung": "Conception du PDF",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Télécharge un PDF comme modèle pour l'impression.",
  cancel: o4e,
  "app surcharge": "Définir la majoration",
  "you can change your surcharge here": "Ici, tu peux modifier ton supplément",
  DSGVO: l4e,
  "Hier können Sie den Text für die DSGVO ändern": "Ici, tu peux modifier le texte pour le RGPD",
  "Neuer Schritt": "Nouvelle étape",
  Icon: a4e,
  "Icon Bilddatei": "Icône fichier image",
  "Icon position": "Position de l'icône",
  "Icon Größe": "Taille de l'icône",
  "Ersetze Weiter mit Aktionsauswahl": "Remplace Continue par Sélection d'action",
  "Aktionsnamen überschreiben": "Remplacer le nom de l'action",
  "Individuelles Design": "Design personnalisé en une seule étape",
  "Angepasstes Layout speichern": "Enregistrer la mise en page personnalisée",
  "Merkmale editieren": "Éditer les caractéristiques",
  "Keine Ergebnisse": "Aucun résultat",
  "Desktop Layout": "Mise en page du bureau",
  "Mobile Layout": "Mise en page mobile",
  "Schritte nacheinander einblenden": "Afficher les étapes une par une",
  "Besuchte Schritte abhaken": "Cocher les étapes visitées",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "Vous utilisez actuellement une mise en page qui n'est plus prise en charge. Veuillez en choisir une nouvelle.",
  "Dieses Layout selbst anpassen": "Adapter cette mise en page soi-même",
  "Eigenes Layout erstellen": "Créer sa propre mise en page",
  "Angepasstes Layout anwenden": "Appliquer une mise en page adaptée",
  Logo: s4e,
  "Konfigurator-Abschluss": "Finalisation du configurateur",
  "3D Szene": "Scène 3D",
  "Manuelle Einstellung erstellen": "Créer un réglage manuel",
  "Design & Theme": "Design & thème",
  Farben: I4e,
  "Farbanpassungen zurücksetzten": "Réinitialiser les ajustements de couleurs",
  CSS: c4e,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Tu peux également personnaliser l'apparence de ton configurateur à l'aide de CSS :",
  "Link zur CSS-Datei": "Lien vers le fichier CSS",
  "Oder laden Sie eine CSS Datei hoch:": "Ou télécharge un fichier CSS :",
  "Neues Merkmal": "Nouvelle caractéristique",
  "Merkmal kopieren": "Copier la caractéristique",
  Zurücksetzen: "Réinitialiser",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "Vous réinitialisez le configurateur à la version choisie.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Cela remplacera toutes les données de ce configurateur.",
  "Auch der Papierkorb wird gelöscht.": "La corbeille sera également vidée.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Cette opération ne peut pas être annulée.",
  "Sind Sie sicher?": "Tu es sûr ?",
  Einstellungen: d4e,
  "Dynamische Texte": "Textes dynamiques",
  "Texte und Einstellungen anpassen": "Adapter les textes et les paramètres",
  "Sie verwenden diesen Konfigurator mit einer Testlizenz.": "Vous utilisez ce configurateur avec une licence d'essai.",
  "Ihr Testzeitraum ist abgelaufen.": "Votre période d'essai est écoulée.",
  "Ihr Testzeitraum ist seit {{days}} Tagen abgelaufen.": "Votre période d'essai est écoulée depuis {{days}} jours.",
  "Sie können diesen Konfigurator noch {{days}} Tage testen.": "Vous pouvez tester ce configurateur encore {{days}} jours.",
  "Sie haben diesen Konfigurator storniert.": "Vous avez annulé ce configurateur.",
  "Jetzt buchen!": "Réserver maintenant !",
  Vorschau: u4e,
  Articles: C4e,
  Bestellungen: A4e,
  Statistics: b4e,
  "Fragen? Wir helfen gern!": "Des questions ? Nous sommes heureux de vous aider !",
  "Inhalte: ": "Contenu : ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': `Avant de pouvoir utiliser le configurateur, tu dois cliquer sur le bouton "Publier". Si tu fais des modifications après cela, elles ne prendront effet qu'après la prochaine publication.`,
  "Live Version": "Version live",
  Veröffentlichen: "Publier",
  "Erstelle Option: ": "Créer une option : ",
  Fehler: h4e,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Une erreur est survenue lors du rendu du contenu.",
  Fatal_Error_Text: m4e,
  Fatal_Error: p4e,
  "Fehlermeldung:": "Message d'erreur :",
  "Zur Startseite": "Vers la page d'accueil",
  "Neu Laden": "Nouveau magasin",
  "Cleanup und Neu Laden": "Nettoyer et recharger",
  "You may need to reload the page": "Recharger la page peut être nécessaire",
  Error_Message: B4e,
  "(SU) Client wechseln": "(SU) Changer de client",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "L'application n'a pas encore été publiée. Des erreurs peuvent donc se produire en ouvrant cette configuration. Continuer ?",
  "Kein Hauptabschluss": "Pas de conclusion principale",
  "Label eingeben": "Entrer l'étiquette",
  "Abschlüsse verbergen": "Cacher les conclusions",
  "Abschlüsse deaktivieren": "Désactiver les conclusions",
  Hauptabschluss: f4e,
  "Abschlüsse festlegen": "Définir les conclusions",
  "Hier können Sie festlegen, welche Abschlüsse für die Benutzer sichtbar oder deaktiviert sind.": "Ici, tu peux définir quels sont les conclusions visibles ou désactivées pour les utilisateurs.",
  "Die unterschiedlichen Farben der Abschlüsse repräsentieren unterschiedliche Zustände:": "Les différentes couleurs des conclusions représentent différents états :",
  Abschluss: Z4e,
  "In Schwarz werden verborgene Abschlüsse repräsentiert.": "En noir, les conclusions cachées sont représentées.",
  "In Grau werden deaktivierte Abschlüsse repräsentiert.": "En gris, les conclusions désactivées sont représentées.",
  "In Blau bezeichnet welcher Abschluss am Ende der Reiter Navigation angezeigt wird. Davon kann es nur einen geben.": "En bleu, cela désigne quelle conclusion sera affichée à la fin de la navigation par onglets. Il ne peut y en avoir qu'une seule.",
  "Elemente löschen": "Elemente löschen",
  "Element löschen": "Supprimer un élément",
  "Selektierte Elemente löschen": "Sélectionner les éléments à supprimer",
  "Alle selektierte Elemente löschen": "Supprimer tous les éléments sélectionnés",
  "Lösch-Konflikte anzeigen": "Afficher les conflits de suppression",
  "Das Element": "L'élément",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Voulez-vous vraiment supprimer de manière irréversible les éléments sélectionnés ?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Tu veux vraiment supprimer cet élément de manière irréversible ?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "Les raisons suivantes s'opposent à la suppression :",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Certains éléments sont encore utilisés à d'autres endroits :",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} est utilisé à d'autres endroits :",
  "{{label}} wird noch verwendet in ": "{{label}} est encore utilisé dans ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "d'une extension. Demande au développeur de supprimer l'utilisation et supprime ensuite la clé.",
  "der Definition der Regel": "la définition de la règle",
  "einem Eintrag in Regel": "une entrée dans Règle",
  "einer berechneten Eigenschaft des Modells": "une propriété calculée du modèle",
  "der Formel von": "de la formule de",
  "der Kamera": "La caméra",
  "des Merkmals": "de la caractéristique",
  "des Schrittes": "du pas",
  "der globalen Kamera": "La caméra globale",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Supprime d'abord les autres références, s'il te plaît.",
  "Neuen Schritt hinzufügen": "Ajouter une nouvelle étape",
  "Bitte legen Sie einen Schritt an!": "Crée une étape, s'il te plaît !",
  "Schritt editieren": "Éditer l'étape",
  Bestelloptionen: G4e,
  "Merkmal editieren": "Éditer la caractéristique",
  "Mehr Informationen anzeigen": "Voir plus d'informations",
  "Nicht Aktiv": "Non actif",
  "Keine Angabe": "Aucune indication",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: y4e,
  "Bilder auswählen": "Choisir des images",
  "Ordner auswählen:": "Sélectionner un dossier :",
  "Bildmerkmal: ": "Caractéristique de l'image : ",
  "Kein Bild ausgewählt": "Pas d'image sélectionnée",
  "Bild auswählen": "Choisir une image",
  "Bildmerkmal auswählen:": "Sélectionner une caractéristique de l'image :",
  Befüllt: "Rempli",
  "Zustand auswählen": "Sélectionner l'état",
  "Kein Komponente ausgewählt!": "Aucun composant sélectionné !",
  "Komponente auswählen": "Sélectionner un composant",
  "Intervall eingeben": "Entrer l'intervalle",
  "Zum Dashboard": "Vers le tableau de bord",
  Primärfarbe: "Couleur primaire",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Définit la couleur primaire (pour les onglets, les boutons...) ainsi que la couleur de contraste (texte des boutons)",
  Sekundärfarbe: "Couleur secondaire",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Définit la couleur secondaire (boutons secondaires) ainsi que la couleur de contraste (texte du bouton)",
  Text: W4e,
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Définit la couleur régulière du texte ainsi que la deuxième couleur (par exemple pour les descriptions).",
  Hintergrundfarbe: S4e,
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Définit la couleur de fond régulière ainsi que celle des zones légèrement mises en évidence (par exemple les caractéristiques)",
  Info: V4e,
  "Setzt die Farbe der Info-Icons": "Définit la couleur des icônes d'information",
  Warnfarbe: w4e,
  "Setzt die Farbe der Warnhinweise": "Définit la couleur des avertissements",
  Fehlerfarbe: v4e,
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Définit la couleur des messages et des indications d'erreur",
  Basiseinstellungen: R4e,
  "Helles Theme": "Thème clair",
  "Erweiterte Einstellungen": "Paramètres avancés",
  "Label hinzufügen: ": "Ajouter une étiquette : ",
  "Kein Label ausgewählt!": "Pas de label sélectionné !",
  "Was soll angezeigt werden?": "Qu'est-ce qui doit être affiché ?",
  Maximalgröße: "Taille maximale",
  Deckkraft: X4e,
  "Kein Material ausgewählt!": "Pas de matériel sélectionné !",
  "Material auswählen": "Choisir le matériel",
  "Material auswählen:": "Choisir le matériel",
  Materialaktion: H4e,
  Farbaktion: k4e,
  Bildaktion: Y4e,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Limiter l'impact à certains modèles",
  "Die Option 'Titel ausblenden' ist aktiviert.": "L'option 'Masquer le titre' est activée.",
  Hinzufügen: "Ajouter",
  "Welches Teil soll hinzugefügt werden?": "Quelle partie ajouter ?",
  Hinweis: F4e,
  Achtung: x4e,
  Fortfahren: D4e,
  "Kein Modell ausgewählt!": "Pas de modèle sélectionné !",
  "Modell auswählen": "Choisir un modèle",
  "Modell hinzufügen:": "Ajouter un modèle :",
  "Globale Änderung": "Changement global",
  Oberflächen: "Surfaces",
  "Ausgewählte Oberflächen": "Finitions sélectionnées",
  "Eintrag darf nicht leer sein.": "L'entrée ne doit pas être vide.",
  "Alle Werte": "Toutes les valeurs",
  "Werte auswählen": "Sélectionner des valeurs",
  "Sortierung anwenden": "Appliquer le tri",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Le format de fichier n'est pas autorisé ! Aucun fichier sélectionné.",
  "Erlaubte Formate:": "Formats autorisés:",
  "Keine Datei gewählt.": "Aucun fichier sélectionné.",
  "Datei konnte nicht hochgeladen werden.": "Le fichier n'a pas pu être téléchargé.",
  "Bild hochladen": "Télécharger l'image",
  Plus: J4e,
  Minus: E4e,
  "Dieses Merkmal ist nicht erlaubt.": "Cette caractéristique n'est pas autorisée.",
  "Merkmal-Optionen": "Options des fonctionnalités",
  "Merkmal Beschreibung editieren": "Éditer la description",
  "Merkmal-Info editieren": "Éditer les infos",
  Versteckt: N4e,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Cette caractéristique n'est pas affichée. Mais la valeur peut être utilisée dans les règles et les calculs.",
  "showSelection.label": "showSelection.label",
  "Aus Schritt verstecken": "Cacher de l'étape",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Cette option n'a de sens que si la caractéristique est affichée ou masquée à un autre endroit via un custom layout. Même si elle est cachée de l'étape, elle sera toujours associée à celle-ci dans les résumés.",
  "Kamera-Optionen": "Options de la caméra",
  "Vorlage wählen": "Choisir un modèle",
  "Konfigurator erstellen": "Créer un configurateur",
  "Willkommen in Ihrem neuen K3 Konto!": "Bienvenue dans ton nouveau compte K3 !",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Configure tout de suite ton premier configurateur :",
  "Sie können alle Daten natürlich später noch ändern.": "Tu peux bien sûr modifier toutes les données plus tard.",
  "Nicht veröffentlicht": "Non publié",
  "Ladevorgang fehlgeschlagen": "Échec du chargement",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "La configuration n'a pas pu être chargée ! Merci de réessayer plus tard !",
  "Keine Optionen": "Pas d'options",
  "Neuen Artikel anlegen": "Créer un nouvel article",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Ici, vous pouvez créer un nouvel article avec un prix.",
  articleNo: L4e,
  articleName: K4e,
  currency: T4e,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Changer les positions",
  "Abbrechen durch Klick": "Cliquer pour annuler.",
  Wert: M4e,
  Seitenleiste: P4e,
  "Preis eingeben": "Saisir le prix",
  Währung: "Monnaie",
  "Währung eingeben": "Saisir la monnaie",
  "Einheit eingeben": "Entrer l'unité",
  Startdatum: U4e,
  "Startdatum eingeben": "Entrer la date de début",
  Enddatum: z4e,
  "Enddatum eingeben": "Entrer la date de fin",
  Startanzahl: O4e,
  "Startanzahl eingeben": "Saisir le nombre de départs",
  Endanzahl: Q4e,
  "Endanzahl eingeben": "Entrer le nombre final",
  Priorität: "Priorité",
  "Priorität eingeben": "Entrer la priorité",
  "Aufschlag?": "Le service ?",
  "Preistyp eingeben": "Saisir le type de prix",
  "Neuer Preis": "Nouveau prix",
  "Erweiterter Modus": "Mode avancé",
  Suchen: j4e,
  Auswählen: "Sélectionner",
  "Wählen Sie eine Vorlage aus:": "Choisis un modèle :",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Ou crée un nouveau configurateur sans modèle : ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Devons-nous créer ton configurateur maintenant ?",
  "Wir bringen Sie danach direkt in den Editor.": "Nous t'emmènerons ensuite directement dans l'éditeur.",
  "Anlegen & zum Konfigurator": "Créer & vers le configurateur",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: q4e,
  OK: _4e,
  "Farbenanzahl im Fenster": "Nombre de couleurs dans la fenêtre",
  "Farbkachel Rundung": "Carreau de couleur arrondi",
  Opazität: "Opacité",
  Hervorhebung: $4e,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Supprimer les instances devenues invalides (au lieu de les remplacer)",
  "Drag & Drop erlauben": "Autoriser le glisser-déposer",
  "Anzeige der Sortierungsschaltflächen": "Affichage des boutons de tri",
  "Sortierung umkehren": "Inverser le tri",
  "Duplizierung erlauben": "Autoriser la duplication",
  "Zeige Werte aus inneren Merkmalen an": "Affiche les valeurs des caractéristiques internes",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Toujours masquer le nom de la caractéristique des valeurs internes, même s'il y a plusieurs valeurs.",
  "Innere Merkmalsnamen ausblenden": "Masquer les noms de caractéristiques internes",
  "Als Warenkorb setzen?": "Mettre dans le panier ?",
  "Gruppieren nach": "Regrouper par",
  "Komponenten direkt unter der Liste anzeigen": "Afficher les composants directement sous la liste",
  Expression: eQe,
  "Erfolgreich gespeichert": "Enregistré avec succès",
  "Formel Editor": "Éditeur de la formule",
  "Geben Sie Formeln von Merkmalen ein.": "Saisis des formules de caractéristiques.",
  " Schreiben Sie z.B. Länge * Breite.": " Écris par exemple longueur * largeur.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Par exemple, pour un attribut, utilise Moteur.Puissance si Moteur est sa caractéristique et Puissance l'attribut correspondant.",
  Ergebnis: tQe,
  "Keine Formel eingegeben": "Aucune formule saisie",
  "Formel: ": "Formule : ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Il n'y a pas encore assez de sélections pour afficher un aperçu.",
  "Ergebnis: ": "Résultat : ",
  "Titel ausblenden": "Masquer le titre",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "Masquer la texture originale lors de l'impression ?",
  "Erlaube Bildformate": "Autoriser les formats d'image",
  "Minimum Horizontale Positionierung": "Positionnement horizontal minimum",
  "Maximum Horizontale Positionierung": "Positionnement horizontal maximal",
  "Minimum Vertikale Positionierung": "Positionnement vertical minimum",
  "Maximum Vertikale Positionierung": "Positionnement vertical maximal",
  "Minimale Skalierung": "Mise à l'échelle minimale",
  "Maximale Skalierung": "Mise à l'échelle maximale",
  "Optionaler Standardwert": "Valeur par défaut optionnelle",
  Mindestwert: iQe,
  Maximalwert: nQe,
  Nachkommastellen: rQe,
  Schrittweite: gQe,
  "Zeige Knöpfe an": "Affiche les boutons",
  "Benutze Vielfaches der Schrittweite": "Utilise des multiples de pas",
  Berechnet: oQe,
  "Zyklus Erkennung deaktivieren": "Désactiver la détection de cycle",
  Ändern: "Changer",
  "Beispielhafte Beschreibung eines Wertes.": "Exemple de description d'une valeur.",
  "Dies ist nur eine Info": "Ceci n'est qu'une information",
  "Color Dropdown": "Sélection de couleur Dropdown",
  "Color Radio": "Choix de la couleur radio",
  "Color Radio Cards": "Cartes radio couleur",
  Farbauswahl: lQe,
  Komponentenliste: aQe,
  "Komponentenliste mit Popup": "Liste de composants avec popup",
  Komponentenkarten: sQe,
  Bildauswahl: IQe,
  Informationen: cQe,
  Zahleneingabe: dQe,
  "Radio Buttons": "Boutons radio",
  "Radio Cards": "Cartes radio",
  "RAL-Farbauswahl": "Choix de la couleur RAL",
  Dropdown: uQe,
  Thumbnails: CQe,
  Schalter: AQe,
  "Schalter Card": "Interrupteur Card",
  Texteingabe: bQe,
  Beispieltext: hQe,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Accepter automatiquement la résolution des conflits avec des caractéristiques individuelles",
  "Übergeordnete Merkmale": "Caractéristiques parentales",
  "Darstellungs-Optionen": "Options d'affichage",
  Optional: mQe,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': `Sous Nvaleurs", tu trouveras l'entrée spéciale Npas d'indication". Ici, tu peux encore adapter ce que l'utilisateur doit voir s'il n'a rien sélectionné.`,
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "La sélection ne sera pas affichée dans la confirmation, le PDF ou la boutique si rien n'a été sélectionné.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Afficher la sélection uniquement si elle est sélectionnée",
  "Konfigurator erfolgreich veröffentlicht.": "Configurateur publié avec succès.",
  "Folgende Änderungen werden veröffentlicht:": "Les changements suivants sont publiés :",
  "Konfigurator veröffentlichen": "Publier le configurateur",
  "Sie möchten den Konfigurator veröffentlichen?": "Tu veux publier le configurateur ?",
  "Wertebereich angeben": "Indiquer la plage de valeurs",
  "Merkmale: ": "Caractéristiques : ",
  "Aktionen: ": "Actions : ",
  "Diese Regel ist aktuell deaktiviert.": "Cette règle est actuellement désactivée.",
  "Neue Spalten Hinzufügen": "Ajouter de nouvelles colonnes",
  Bedingungen: pQe,
  "Merkmale ausblenden": "Masquer les caractéristiques",
  "Schritt ausblenden": "Masquer l'étape",
  "Werte ausblenden": "Masquer les valeurs",
  "Konfigurator-Abschluss festlegen": "Définir la conclusion du configurateur",
  "Befüllen von Komponentenmerkmalen": "Remplir les caractéristiques des composants",
  "Bilder auf Oberflächen drucken": "Imprimer des images sur des surfaces",
  "Anzeige von Bildern": "Affichage d'images",
  "Ändern der Farbe": "Changer la couleur",
  "Austauschen von Oberflächen": "Remplacer les surfaces",
  "Anzeige von Informationen": "Affichage d'informations",
  "Anzeige von Fehlermeldungen": "Affichage des messages d'erreur",
  "Anzeige von 3D-Modellen": "Affichage de modèles 3D",
  "Artikel zur Stückliste hinzufügen": "Ajouter un article à la liste de pièces",
  "Ein oder mehrere Merkmal Spalten hinzufügen": "Ajouter une ou plusieurs colonnes de caractéristiques",
  "Ein oder mehrere Komponenten Spalten hinzufügen": "Ajouter une ou plusieurs colonnes de composants",
  "Ein oder mehrere Schritte hinzufügen": "Ajouter une ou plusieurs étapes",
  "Ein oder mehrere Artikel Spalten hinzufügen": "Ajouter une ou plusieurs colonnes d'articles",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen.": "Sélectionne les caractéristiques auxquelles les articles doivent être attribués.",
  Materialnamen: BQe,
  "Wählen Sie Materialnamen aus, worauf Bilder gedruckt werden sollen in Abhängigkeit von Bild Merkmalen.": "Sélectionne les noms de matériaux sur lesquels les images doivent être imprimées en fonction des caractéristiques d'image.",
  "Modell Eigenschaften anpassen": "Adapter les caractéristiques du modèle",
  Labelaktion: fQe,
  Fehlermeldung: ZQe,
  "Merkmale entfernen": "Supprimer les caractéristiques",
  "Schritt entfernen": "Supprimer l'étape",
  Modelaktion: GQe,
  "Bitte fügen Sie neue Spalten hinzu.": "Veuillez ajouter de nouvelles colonnes.",
  "Sie brauchen mindestens eine Spalte.": "Tu as besoin d'au moins une colonne.",
  "Nr.": "Nr.",
  "Gültigkeit prüfen": "Vérifier la validité",
  "Keine Warnungen": "Pas d'avertissements",
  "Alle Regeln ansehen": "Voir toutes les règles",
  Position: yQe,
  "Rotation (in radiant)": "Rotation (en radian)",
  Scale: WQe,
  "Kein Label angegeben!": "Pas de label indiqué !",
  "Regel Validierung": "Règle Validation",
  "Fehlende Werte": "Valeurs manquantes",
  "Zugeordnete Merkmale": "Caractéristiques attribuées",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Sélectionne les caractéristiques auxquelles les articles doivent être attribués",
  Komponentenmerkmale: SQe,
  "Wählen Sie Komponentenmerkmale aus.": "Sélectionne les caractéristiques du composant.",
  "Oberflächenaktion hinzufügen": "Ajouter une action de surface",
  "Alle auswählen": "Sélectionner tout",
  "Alle abwählen": "Tout désélectionner",
  "Auswahl umkehren": "Inverser la sélection",
  Herunterladen: VQe,
  "Jetzt verbinden": "Connecte-toi maintenant",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Le système de boutique flexible pour votre projet de commerce électronique.",
  "Jetzt Installieren": "Installer maintenant",
  "Die globale Commerce-Plattform.": "La plateforme de commerce mondiale.",
  "Die E-Commerce-Plattform für WordPress.": "La plateforme de commerce électronique pour WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "L'une des plateformes européennes de commerce électronique open source. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Maintenant Adobe Commerce : le e-commerce en toute simplicité.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Première classe dans la vente numérique avec la boutique Oxid esales.",
  "Individuelle Entwicklung": "Développement individuel",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connecter la boutique avec un développement personnalisé.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Télécharge d'abord l'un de nos plugins et installe-le dans ta boutique :",
  "Verbinde Shop": "Relie la boutique",
  " und importiere Artikel": " et importer des articles",
  "Fehler beim Verbinden:": "Erreur de connexion :",
  "Shop erfolgreich verbunden.": "Boutique connectée avec succès.",
  "Fehler beim Verbinden: ": "Erreur de connexion : ",
  "Web-Adresse des Shops": "Adresse web de la boutique",
  "Sollen die Artikel aus dem Shop importiert werden?": "Les articles doivent-ils être importés de la boutique ?",
  "Filter für Artikel": "Filtre pour les articles",
  "Sollen die Artikel regelmäßig importiert werden?": "Les articles doivent-ils être importés régulièrement?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Le numéro d'article doit-il être pris à partir du SKU du magasin?",
  "Wenn Sie diese Einstellung ändern, wird der nächste Artikel-Import die Artikel duplizieren.": "Si vous modifiez ce paramètre, la prochaine importation d'articles dupliquera les articles.",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Les articles doivent-ils être regroupés lors de la commande ?",
  "Basis-Name für kombinierte Artikel": "Nom de base pour les articles combinés",
  "Ihre Bestellung {code}": "Votre commande {code}",
  "Shop-Anbindung aufheben": "Supprimer le lien avec la boutique",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Ajoute le configurateur à ta boutique",
  Verbinden: wQe,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "Le contenu HTML n'a pas pu être rendu. Veuillez nettoyer votre saisie.",
  "Der eingegebe Wert ist nicht gültig: ": "La valeur saisie n'est pas valable: ",
  "Ungültiges HTML-Format": "Format HTML non valide",
  "Sie können uns den Vorfall hier melden!": "Tu peux nous signaler l'incident ici !",
  "Das Template konnte nicht geladen werden.": "Le modèle n'a pas pu être chargé.",
  "Templat auf Voreinstellung zurücksetzen": "Rétablir le modèle par défaut",
  "Eingaben zurücksetzen": "Réinitialiser les entrées",
  "Templat bearbeiten": "Modifier le modèle",
  "Templat Name": "Nom du modèle",
  "Templat wählen": "Choisir un modèle",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Choisissez un modèle standard pour le personnaliser. Ou attribuez votre propre nom pour préparer un modèle personnalisé.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Vous n'avez pas encore créé de template personnalisé. Ajoutez-en un en sélectionnant un modèle standard dans la liste et en l'adaptant à vos besoins.",
  "Templat hinzufügen": "Ajouter un template",
  "Ansicht auswählen": "Sélectionner une vue",
  "Datei hochladen": "Télécharger le fichier",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Réserve d'abord un autre produit, s'il te plaît :",
  "Bitte wählen": "Choisir s'il te plaît",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Cette action combine plusieurs caractéristiques et ne peut donc pas être modifiée ici. Pour cela, modifie directement la ou les règles suivantes :",
  "Automatisch angelegt": "Créé automatiquement",
  "Aktionen verknüpfen": "Lier les actions",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Les valeurs de cette caractéristique doivent déclencher les actions suivantes :",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Cette caractéristique ne peut pas être utilisée pour contrôler d'autres processus. Pour cela, utilise directement les règles.",
  "Zu den Regeln": "Vers les règles",
  "Artikel bestellen": "Commander l'article",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "En fonction de la sélection, différents articles seront ajoutés à la liste de pièces.",
  "Oberfläche ändern": "Modifier la surface",
  "Welche Oberflächen sollen geändert werden? ": "Quelles sont les surfaces qui doivent être modifiées ? ",
  "3D-Modell anzeigen": "Afficher le modèle 3D",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "En fonction de la sélection, différents modèles 3D s'affichent.",
  "Bild anzeigen": "Afficher l'image",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "En fonction de la sélection, différentes images s'affichent.",
  "Farbe ändern": "Changer de couleur",
  "Welche Oberflächen sollen eingefärbt werden? ": "Quelles surfaces doivent être colorées ? ",
  "Bild aufdrucken": "Imprimer l'image",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Sur quelles surfaces l'image téléchargée doit-elle être imprimée ? ",
  "Der Wert wird noch in Regeln verwendet:": "Cette valeur est encore utilisée dans les règles :",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Commence par supprimer la ou les lignes correspondantes.",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Ici, tu peux définir ce qui doit être affiché lorsqu'aucune valeur n'a encore été sélectionnée.",
  "Dieser Wert ist nicht erlaubt.": "Cette valeur n'est pas autorisée.",
  "Maximale Anzahl an Werten ist erreicht.": "Le nombre maximal de valeurs est atteint",
  Farbwert: vQe,
  Anzeige: RQe,
  RAL: XQe,
  "keine RAL Farbe": "pas de couleur RAL",
  Ansicht: HQe,
  "Key eingeben": "Saisir la clé",
  URL: kQe,
  "Info-Modal": "Info-Modal",
  "Info-Content": "Contenu d'information",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Ce type de caractéristique ne prend pas en charge les valeurs.",
  "Fehlende RAL Farben hinzufügen": "Ajouter des couleurs RAL manquantes",
  Auswahlwerte: YQe,
  "Typ des Merkmals": "Type de caractéristique",
  "Merkmal {{label}} nicht gefunden!": "Caractéristique {{label}} non trouvée !",
  "Attribut {{label}} nicht gefunden!": "Attribut {{label}} non trouvé !",
  "Syntaxfehler in der Expression!": "Erreur de syntaxe dans l'expression !",
  "es gibt keine Merkmale mit {{identificator}}": "il n'y a pas de caractéristiques avec {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "il n'y a pas d'attribut avec {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "il n'y a pas de sélection avec {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "il y a plus d'une sélection avec {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Il y a un cycle dans les caractéristiques calculées : {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "le résultat de la formule doit être une valeur numérique, au lieu de cela, c'est {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "Valeur {{paramName}} de la fonction {{functionName}} est égal à zéro",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "La caractéristique {{variableLabel}} est une liste de composants. Tu dois utiliser un index comme {{variableLabel2}}[0] pour le 1er élément ou avec une fonction de tableau comme map(), find(), reduce() ou first() pour y accéder.",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Il y a un cycle dans les caractéristiques calculées.",
  Übersicht: "Aperçu",
  Auswahlpreise: FQe,
  Auswahl: xQe,
  Gesamtpreis: DQe,
  "Preis Information": "Information sur le prix",
  "Persönliche Daten": "Données personnelles",
  "Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise": "Veuillez remplir tous les champs requis de manière appropriée et accepter les informations relatives à la protection des données.",
  "Bestätigen-Hinweistext bei invalidem Kontaktformular": "Texte d'avertissement de confirmation en cas de formulaire de contact invalide",
  Weiter: JQe,
  "Sie verwenden eine veraltete Version des Konfigurators.": "Vous utilisez une version obsolète du configurateur.",
  "Bestell-Warnhinweis bei veralteter Version": "Avertissement de commande en cas de version obsolète",
  "In AR ansehen": "Voir en AR",
  Vollbildmodus: EQe,
  "Komponenten suchen": "Chercher des composants",
  "Nicht Gruppiert": "Non groupé",
  Komponenten: NQe,
  "Komponenten hinzufügen": "Ajouter des composants",
  xl: LQe,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "Ta saisie n'a malheureusement pas été possible et a été réinitialisée à la valeur la plus proche possible : ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Cette valeur ne peut pas être combinée avec les sélections suivantes :",
  "Bei Auswahl wird eine Alternative berechnet!": "En cas de sélection, une alternative sera facturée !",
  Bestätigen: "Confirmer",
  "Produkt hinzufügen": "Ajouter un produit",
  "Produkt erfolgreich konfiguriert": "Produit configuré avec succès",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "La configuration est terminée. Quel est le prochain produit que tu souhaites ajouter à ton panier ?",
  "Neues Produkt auswählen": "Choisir un nouveau produit",
  "Neues Produkt hinzufügen": "Ajouter un nouveau produit",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'La sélection "{{value}}" ({{variable}}) donne la valeur invalide "{{conflictValue0}}" ({{conflictVariable0}}) et est donc réinitialisée.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Message en cas de réinitialisation d'une sélection non valide",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Signaler l'apparition d'un conflit",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}) et la sélection "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Déclaration en cas d'apparition de deux conflits",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Déclaration en cas d'apparition de trois conflits ou plus",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'La sélection "{{value}}" ({{variable}}) ne correspond pas à la sélection "{{conflictValue0}}" ({{conflictVariable0}}), la sélection "{{conflictValue1}}" ({{conflictVariable1}}) et la sélection "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': `La sélection "{{value}}" ({{variable}}) ne correspond pas à d'autres sélections.`,
  Konfliktmeldung: KQe,
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen.": "Cette sélection peut annuler les sélections déjà effectuées.",
  "Anpassung nötig": "Adaptation",
  "Stattdessen werden folgende Auswahlen angepasst:": "Au lieu de cela, les sélections suivantes sont adaptées :",
  "wird zu": "devient",
  "wird entfernt": "est supprimé",
  "Optionaler weiterer Hinweistext:": "Texte d'information supplémentaire en option:",
  "Auf Facebook teilen": "Partager sur Facebook",
  "Auf Twitter teilen": "Partager sur Twitter",
  "Auf LinkedIn teilen": "Partager sur LinkedIn",
  "Modal Titel": "Titre modal",
  "Desktop Gerät erkannt": "Appareil de bureau détecté",
  "Modal Text": "Texte modal",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "La réalité augmentée n'est actuellement disponible que sur les smartphones iOS ou androidOS actuels. Il te suffit donc de scanner ce code QR avec l'application caméra de ton smartphone :",
  "Mobiles {{device}}-Gerät erkannt": "Dispositif mobile {{device}} détecté",
  "Fortschrittsanzeige 3D-Objekt": "Fortschrittsanzeige 3D-Objekt",
  "Export des 3D-Objekts": "Exportation de l'objet 3D",
  "Fortschrittsanzeige AR-Datei": "Indicateur de progression du fichier AR",
  "Bereitstellen der AR-Datei": "Mise à disposition du fichier AR",
  "Fortschrittsanzeige System": "Indicateur de progression du système",
  "{{device}}-AR-System einrichten": "Configurer le système AR de {{device}}.",
  Positionszeile: TQe,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Numéro d'article Colonne",
  "Artikel Spalte": "Article Colonne",
  "Artikelpreis Spalte": "Prix de l'article Colonne",
  "Artikelmenge Spalte": "Quantité d'articles Colonne",
  Menge: MQe,
  "Artikelanzahl Spalte": "Nombre d'articles Colonne",
  "Positionspreis Spalte": "Prix par poste Colonne",
  Positionspreis: PQe,
  "Hilfetext Preisdetails": "Texte d'aide pour les détails des prix",
  "Preisdetails anzeigen": "Afficher le détail des prix",
  "Titel bei Versions-Konflikt": "Titre en cas de conflit de version",
  "Konfigurator wurde aktualisiert": "Le configurateur a été mis à jour",
  "Text bei Versions-Konflikt": "Texte en cas de conflit de version",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "Depuis que tu as enregistré cette configuration, le configurateur a été développé. Tu veux utiliser la version actuelle et continuer à travailler ou ouvrir l'ancienne version uniquement pour la consulter ?",
  "Hilfetext Auswahl Ändern": "Hilfetext Auswahl Ändern",
  "Merkmal ändern": "Merkmal ändern",
  "Hilfetext Auswahl Entfernen": "Hilfetext Auswahl Entfernen",
  "Auswahl entfernen": "Auswahl entfernen",
  "Alte Version": "Ancienne version",
  "Aktuelle Version": "Version actuelle",
  "Zeige Namen": "Afficher les noms",
  "Zeige Beschreibung": "Afficher la description",
  "Zeige Thumbnail": "Afficher la vignette",
  "Zeige Preis an Merkmal": "Afficher le prix Caractéristique",
  "Zeige Preise an Werten": "Afficher les prix aux valeurs",
  "Zeige URL": "Afficher l'URL",
  "Zeige Info-Button für Werte": "Afficher le bouton d'information pour les valeurs",
  "Zeige HTML Content für Werte": "Afficher le contenu HTML pour les valeurs",
  "Kamerafahrt beim scrollen": "Déplacement de la caméra pendant le défilement",
  "Alle ungültigen Werte ausblenden": "Masquer toutes les valeurs non valides",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Masquer les valeurs non valides, modifiées activement",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Masquer si seulement une sélection est possible",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Désactiver si une seule sélection est possible",
  "Komponente hervorheben": "Mettre en valeur le composant",
  Bild: UQe,
  "Ja/ Nein": "Oui/Non",
  Information: zQe,
  Mehrfachauswahl: OQe,
  Liste: QQe,
  Eckenrundung: jQe,
  "Anzahl der Eckenrundungsschritte": "Nombre d'étapes d'arrondissement des angles",
  "Dieses Material existiert bereits": "Ce matériel existe déjà",
  "Material hinzufügen": "Ajouter du matériel",
  "Materialname eingeben": "Saisir le nom du matériau",
  Abmessungen: qQe,
  Breite: _Qe,
  Höhe: "Hauteur",
  Tiefe: $Qe,
  Operation: eje,
  Segmente: tje,
  Pfad: ije,
  Startpunkt: nje,
  Endpunkt: rje,
  Linienstärke: "Épaisseur de la ligne",
  Startanker: gje,
  Maßkette: "Chaîne de mesure",
  Ohne: oje,
  Endanker: lje,
  Texttyp: aje,
  "Kein Text": "Pas de texte",
  Zahlenwert: sje,
  "Statischer Text": "Texte statique",
  "Automatisches Maß überschreiben": "Écraser la mesure automatique",
  "Neues Maß": "Nouvelle mesure",
  "Textgröße als Faktor. 1 ist Standard.": "Taille du texte comme facteur. 1 est la valeur par défaut.",
  Offsets: Ije,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Ici, il est possible de définir les écarts de position et de rotation qui résultent normalement du point de départ et du point final. Pour cela, tu peux utiliser l'outil de positionnement 3D.",
  Blau: cje,
  Grün: "Vert",
  Gelb: dje,
  Rot: uje,
  Purpur: Cje,
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Le nombre maximal d'itérations pour le moteur d'expression est atteint ! Il y a trop de cycles complexes dans les caractéristiques calculées.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Nombre maximum d'itérations atteint ! Les conflits de règles ne peuvent pas être résolus.",
  "Nicht Befüllt": "Non rempli",
  Abkhazian: Aje,
  Afar: bje,
  Afrikaans: hje,
  Akan: mje,
  Albanian: pje,
  Amharic: Bje,
  Arabic: fje,
  Aragonese: Zje,
  Armenian: Gje,
  Assamese: yje,
  Avaric: Wje,
  Avestan: Sje,
  Aymara: Vje,
  Azerbaijani: wje,
  Bambara: vje,
  Bashkir: Rje,
  Basque: Xje,
  Belarusian: Hje,
  Bengali: kje,
  Bislama: Yje,
  Bosnian: Fje,
  Breton: xje,
  Bulgarian: Dje,
  Burmese: Jje,
  "Catalan, Valencian": "Catalan, Valencien",
  Chamorro: Eje,
  Chechen: Nje,
  "Chichewa, Chewa, Nyanja": "Chichewa, Chewa, Nyanja",
  Chinese: Lje,
  "Church Slavonic, Old Slavonic, Old Church Slavonic": "Slavon d'église, vieux slavon, vieux slavon d'église",
  Chuvash: Kje,
  Cornish: Tje,
  Corsican: Mje,
  Cree: Pje,
  Croatian: Uje,
  Czech: zje,
  Danish: Oje,
  "Divehi, Dhivehi, Maldivian": "Divehi, Dhivehi, Maldivien",
  "Dutch, Flemish": "Néerlandais, Flamand",
  Dzongkha: Qje,
  English: jje,
  Esperanto: qje,
  Estonian: _je,
  Ewe: $je,
  Faroese: e6e,
  Fijian: t6e,
  Finnish: i6e,
  French: n6e,
  "Western Frisian": "Frison occidental",
  Fulah: r6e,
  "Gaelic, Scottish Gaelic": "Gaélique, Gaélique écossais",
  Galician: g6e,
  Ganda: o6e,
  Georgian: l6e,
  German: a6e,
  "Greek, Modern (1453-)": "Grec, Moderne (1453-)",
  "Kalaallisut, Greenlandic": "Kalaallisut, Groenlandais",
  Guarani: s6e,
  Gujarati: I6e,
  "Haitian, Haitian Creole": "Haïtien, Créole haïtien",
  Hausa: c6e,
  Hebrew: d6e,
  Herero: u6e,
  Hindi: C6e,
  "Hiri Motu": "Hiri Motu",
  Hungarian: A6e,
  Icelandic: b6e,
  Ido: h6e,
  Igbo: m6e,
  Indonesian: p6e,
  "Interlingua (International Auxiliary Language Association)": "Interlingua (Association internationale de langue auxiliaire)",
  "Interlingue, Occidental": "Interlingue, Occidental",
  Inuktitut: B6e,
  Inupiaq: f6e,
  Irish: Z6e,
  Italian: G6e,
  Japanese: y6e,
  Javanese: W6e,
  Kannada: S6e,
  Kanuri: V6e,
  Kashmiri: w6e,
  Kazakh: v6e,
  "Central Khmer": "Khmer central",
  "Kikuyu, Gikuyu": "Kikuyu, Gikuyu",
  Kinyarwanda: R6e,
  "Kirghiz, Kyrgyz": "Kirghiz, Kirghize",
  Komi: X6e,
  Kongo: H6e,
  Korean: k6e,
  "Kuanyama, Kwanyama": "Kuanyama, Kwanyama",
  Kurdish: Y6e,
  Lao: F6e,
  Latin: x6e,
  Latvian: D6e,
  "Limburgan, Limburger, Limburgish": "Limbourgeois, Limbourgeois, Limbourgeois",
  Lingala: J6e,
  Lithuanian: E6e,
  "Luba-Katanga": "Luba-Katanga",
  "Luxembourgish, Letzeburgesch": "Luxembourgeois, Letzeburgesch",
  Macedonian: N6e,
  Malagasy: L6e,
  Malay: K6e,
  Malayalam: T6e,
  Maltese: M6e,
  Manx: P6e,
  Maori: U6e,
  Marathi: z6e,
  Marshallese: O6e,
  Mongolian: Q6e,
  Nauru: j6e,
  "Navajo, Navaho": "Navajo, Navaho",
  "North Ndebele": "Ndebele du Nord",
  "South Ndebele": "Ndebele du Sud",
  Ndonga: q6e,
  Nepali: _6e,
  Norwegian: $6e,
  "Norwegian Bokmål": "Norvégien Bokmål",
  "Norwegian Nynorsk": "Norvégien Nynorsk",
  "Sichuan Yi, Nuosu": "Sichuan Yi, Nuosu",
  Occitan: e7e,
  Ojibwa: t7e,
  Oriya: i7e,
  Oromo: n7e,
  "Ossetian, Ossetic": "Ossète, Ossétique",
  Pali: r7e,
  "Pashto, Pushto": "Pachto, Pachto",
  Persian: g7e,
  Polish: o7e,
  Portuguese: l7e,
  "Punjabi, Panjabi": "Pendjabi, Panjabi",
  Quechua: a7e,
  "Romanian, Moldavian, Moldovan": "Roumain, Moldave, Moldave",
  Romansh: s7e,
  Rundi: I7e,
  Russian: c7e,
  "Northern Sami": "Sami du Nord",
  Samoan: d7e,
  Sango: u7e,
  Sanskrit: C7e,
  Sardinian: A7e,
  Serbian: b7e,
  Shona: h7e,
  Sindhi: m7e,
  "Sinhala, Sinhalese": "Singhalais, Cinghalais",
  Slovak: p7e,
  Slovenian: B7e,
  Somali: f7e,
  "Southern Sotho": "Sotho du Sud",
  "Spanish, Castilian": "Espagnol, Castillan",
  Sundanese: Z7e,
  Swahili: G7e,
  Swati: y7e,
  Swedish: W7e,
  Tagalog: S7e,
  Tahitian: V7e,
  Tajik: w7e,
  Tamil: v7e,
  Tatar: R7e,
  Telugu: X7e,
  Thai: H7e,
  Tibetan: k7e,
  Tigrinya: Y7e,
  "Tonga (Tonga Islands)": "Tonga (Îles Tonga)",
  Tsonga: F7e,
  Tswana: x7e,
  Turkish: D7e,
  Turkmen: J7e,
  Twi: E7e,
  "Uighur, Uyghur": "Ouïghour, Ouïghour",
  Ukrainian: N7e,
  Urdu: L7e,
  Uzbek: K7e,
  Venda: T7e,
  Vietnamese: M7e,
  Volapük: "Volapük",
  Walloon: P7e,
  Welsh: U7e,
  Wolof: z7e,
  Xhosa: O7e,
  Yiddish: Q7e,
  Yoruba: j7e,
  "Zhuang, Chuang": "Zhuang, Chuang",
  Zulu: q7e
}, $7e = "Liste", e8e = "Couleurs", t8e = "Texte", i8e = "Oui/ Non", n8e = "Information", r8e = "Image", g8e = "Composants", o8e = "Présentation", l8e = "Actions", a8e = "Valeurs", s8e = "Règles", I8e = "Options", c8e = "Images", d8e = "Configurateurs", u8e = "Rue", C8e = "Code Postal", A8e = "Ville", b8e = "Pays", h8e = "Extraire", m8e = "Téléphone", p8e = "Nom d'utilisateur", B8e = "MATÉRIEL", f8e = "Importation", Z8e = "Manuel", G8e = "Rotation", y8e = "Généralités", W8e = "Caractéristiques", S8e = "Roughness", V8e = "Métallicité", w8e = "Pile d'images", v8e = "Paramètres de scène", R8e = "Thèmes", X8e = "Adaptation", H8e = "Plage de valeurs", k8e = "Présentation", Y8e = "Valeurs", F8e = "Demandes", x8e = "Moment", D8e = "Demande", J8e = "URI", E8e = "Paramètres", N8e = "Durée", L8e = "Serveur", K8e = "Nombre", T8e = "Article", M8e = "Mode plein écran", P8e = {
  always: "Toujours",
  never: "Jamais",
  auto: "Comme dans le configurateur",
  label: "Affichage dans la confirmation, le PDF et la boutique"
}, U8e = "Activer", z8e = "Désactiver", O8e = "Caractéristiques et articles", Q8e = "Seulement des caractéristiques", j8e = "Seulement des articles", q8e = "Pas d'aperçu", _8e = "Généralités", $8e = "PDF", eqe = "Mail", tqe = "Intégrer", iqe = "Boutique", nqe = "Article", rqe = "Aperçu", gqe = "Éditeur", oqe = "Images", lqe = "Matériaux", aqe = "Modèles", sqe = "Règles", Iqe = "Options", cqe = "Admin", dqe = "extract", uqe = "Configurateurs", Cqe = "Créer", Aqe = "Importer", bqe = "Utilisateur", hqe = "Support", mqe = "Logs", pqe = "État du système", Bqe = "Corbeille à papier", fqe = "Abonnement", Zqe = "Expiré", Gqe = "Profil", yqe = "Éditeur", Wqe = "Configurations", Sqe = "Cavalier", Vqe = "Caractéristiques", wqe = "Design", vqe = "Scène", Rqe = "Présentation", Xqe = "Options", Hqe = "Actions", kqe = "Valeurs", Yqe = "couleur primaire", Fqe = "Couleur secondaire", xqe = "Couleur de fond", Dqe = "Couleur d'avertissement", Jqe = "Standard", Eqe = "Plus clair", Nqe = "Sombre", Lqe = "Souligné", Kqe = "Standard", Tqe = "Grisé", Mqe = "CTRL", Pqe = "Remplacer", Uqe = "Commander", zqe = "Allemagne", Oqe = "Suisse", Qqe = "Andorre", jqe = "Belgique", qqe = "Biélorussie", _qe = "Bulgarie", $qe = "République tchèque", e_e = "Cité du Vatican", t_e = "Monténégro", i_e = "Estonie", n_e = "Espagne", r_e = "France", g_e = "Guernesey", o_e = "Croatie", l_e = "Irlande", a_e = "Islande", s_e = "Italie", I_e = "Jersey", c_e = "Albanie", d_e = "Kosovo", u_e = "Lettonie", C_e = "Lithuanie", A_e = "Luxembourg", b_e = "Hongrie", h_e = "Monaco", m_e = "Pays-Bas", p_e = "Norvège", B_e = "Pologne", f_e = "Portugal", Z_e = "Kasachstan", G_e = "Malte", y_e = "Moldavie", W_e = "Russie", S_e = "Slovénie", V_e = "Slovaquie", w_e = "Serbie", v_e = "Finlande", R_e = "Suède", X_e = "Ukraine", H_e = "Chypre", k_e = "Grèce", Y_e = "Macédoine du Nord", F_e = {
  list: $7e,
  color: e8e,
  text: t8e,
  boolean: i8e,
  information: n8e,
  image: r8e,
  components: g8e,
  presentation: o8e,
  usage: l8e,
  values: a8e,
  rules: s8e,
  settings: I8e,
  images: c8e,
  configurators: d8e,
  street: u8e,
  zip: C8e,
  city: A8e,
  country: b8e,
  extract: h8e,
  phone: m8e,
  username: p8e,
  "duplicate-entry": "Il existe déjà des comptes avec ces données",
  "create new dealer": "Créer un nouveau commerçant",
  "Artikel Anzahl": "Article Nombre",
  "Farb auswählen": "Choisir une couleur",
  "< Zurück": "< Retour",
  "Merkmal auswählen": "Sélectionner une caractéristique",
  MATERIAL: B8e,
  Import: f8e,
  "Materialien für den Import auswählen:": "Sélectionner les matériaux pour l'importation :",
  "Wie möchten Sie ein Material erstellen?": "Comment souhaites-tu créer un matériel ?",
  "Import einer .glb und export der enthaltenen Materialien": "Importer un .glb et exporter les matériaux qu'il contient",
  Manuell: Z8e,
  "Eigenständiges Anlegen eines PBR-Materials": "Création autonome d'un matériau PBR",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Commence par supprimer la colonne correspondante.",
  "Design & Layout": "Design & mise en page",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Visible uniquement en mode prévisualisation ou configurateur publié !",
  "Theme wählen": "Choisir un thème",
  "Komponente löschen": "Supprimer un composant",
  "Mehrfach Regelzeilen Bearbeitung": "Edition de lignes de règles multiples",
  "Anzahl ausgewählte Regel-Zeilen:": "Nombre de lignes de règles sélectionnées :",
  "Modelaktions-Positionierung": "Positionnement de la modélisation",
  Rotation: G8e,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Aucune action disponible pour le traitement multiple",
  Allgemeines: y8e,
  "Farben und Lichtinteraktion": "Couleurs et interaction avec la lumière",
  "Color-Map Upload": "Téléchargement de la carte des couleurs",
  "Material interagiert mit Licht in der Szene": "La matière interagit avec la lumière dans la scène",
  Beschaffenheit: W8e,
  "Roughness-Map Upload": "Télécharger la carte de la rugosité",
  Roughness: S8e,
  "Metallness-Map Upload": "Télécharger la carte de Metallness",
  Metallness: V8e,
  "Normalen-Map Upload": "Téléchargement de la carte normale",
  "Normalen-Skalierung": "Échelle normale",
  "Anwendung auf 3D-Modell": "Application sur modèle 3D",
  "Displacement-Map Upload": "Téléchargement de la carte de déplacement",
  "Displacement-Skalierung": "Échelle de déplacement",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Facteur de répétition de la texture dans les directions X et Y",
  "Alpha-Werte": "Valeurs alpha",
  "Alpha-Map Upload": "Téléchargement de la carte alpha",
  "Ambient Occlusion": "Occlusion d'ambiance",
  "Ambient-Occlusion-Map Upload": "Téléchargement de la carte d'occlusion d'ambiance",
  "Info editieren": "Éditer l'info",
  "Zeige Info-Button": "Afficher le bouton d'information",
  Abhängigkeitsschleifen: "Boucles de dépendance",
  Bilderstapel: w8e,
  "Google Analytics Property ID": "ID de propriété Google Analytics",
  "Sans Serif": "Sans Serif",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Le système de boutique flexible pour ton projet de commerce électronique.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "L'une des plateformes européennes de commerce électronique open source. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Maintenant Adobe Commerce : le e-commerce en toute simplicité.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Première classe dans la vente numérique avec la boutique Oxid esales.",
  "Individuelle Entwicklung": "Développement individuel",
  "Shop mit einer individuellen Entwicklung anbinden.": "Connecter la boutique avec un développement personnalisé.",
  Szeneneinstellungen: v8e,
  Themes: R8e,
  Anpassung: X8e,
  "Gewähltes Theme übernehmen": "Reprendre le thème choisi",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Crée une nouvelle étape de configuration.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Une configuration se fait en plusieurs étapes. Dans chaque étape, il est possible d'indiquer plusieurs propriétés du produit, le cas échéant. Ici, tu crées la première étape.",
  "Konfigurationsschritt erstellen": "Créer une étape de configuration",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Commence par cliquer ici pour créer un nouveau configurateur.",
  "Neuer Konfigurator wählen": "Choisir le nouveau configurateur",
  "Bitte geben Sie einen Namen ein.": "Saisis un nom, s'il te plaît.",
  "Bitte geben Sie eine Beschreibung ein.": "Saisis une description.",
  "Bitte klicken Sie hier.": "Clique ici s'il te plaît.",
  "Konfigurator Dialog aufrufen": "Ouvrir la boîte de dialogue du configurateur",
  "Konfigurationsschritt benennen": "Nommer l'étape de configuration",
  "Hier können Sie neue Werte hinzufügen.": "Ici, tu peux ajouter de nouvelles valeurs.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Les caractéristiques qui sont une liste (ou couleur, matériau, modèle) affichent plusieurs valeurs à choisir. Tu peux saisir ces valeurs ici.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Clique ici pour créer une nouvelle valeur.",
  "Wenn Sie fertig sind klicken Sie hier.": "Quand tu as terminé, clique ici.",
  "Werte erstellen": "Créer des valeurs",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Saisis un nom pour la nouvelle caractéristique.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Choisis une présentation qui correspond aux possibilités de la caractéristique.",
  "Präsentation definieren": "Définir la présentation",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "En une seule étape, ton client peut personnaliser plusieurs caractéristiques de son produit. Insère ici la première caractéristique.",
  "Produktmerkmal erstellen": "Créer une caractéristique de produit",
  "Was für ein Merkmal wollen Sie anlegen?": "Quel type de caractéristique veux-tu créer ?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Une caractéristique peut être une sélection (par exemple les tailles S, M, L et XL), un texte ou un chiffre (par exemple pour une largeur ou une hauteur) ou encore une couleur ou une matière de ton produit ou un modèle 3D qui représente une partie de ton produit.",
  "Produktmerkmaltyp auswählen": "Sélectionner le type de caractéristique du produit",
  "Wählen sie den eben erstellten Konfigurator.": "Choisis le configurateur que tu viens de créer.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Contrôle du configurateur par la nouvelle caractéristique.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Les caractéristiques peuvent, par exemple, faire en sorte que les modèles 3D ou les images soient affichés ou que les surfaces soient modifiées ou colorées. Tu peux aussi créer une nomenclature d'articles qui détermine ensuite le prix et qui peut être placée dans le panier de ta boutique.",
  "Merkmal verwenden": "Utiliser la caractéristique",
  Wertebereich: H8e,
  Darstellung: k8e,
  Werte: Y8e,
  Anfragen: F8e,
  Zeitpunkt: x8e,
  Anfrage: D8e,
  URI: J8e,
  Parameter: E8e,
  Dauer: N8e,
  Server: L8e,
  "Modell bearbeiten": "Modifier le modèle",
  "Korrekte Mail-Adresse": "Adresse e-mail correcte",
  "Statistik (30 Tage)": "Statistiques (30 jours)",
  amount: K8e,
  article: T8e,
  "Datum eingeben": "Entrer la date",
  "Nach hause ": "A la maison ",
  "Mandant anlegen": "Créer un client",
  "Nutzer hinzufügen": "Ajouter des utilisateurs",
  Fullscreen: M8e,
  showSelection: P8e,
  "Kamera überschreiben": "Écraser la caméra",
  Aktivieren: U8e,
  Deaktivieren: z8e,
  Übersichtsseite: "Page d'accueil",
  variablesAndArticles: O8e,
  variablesOnly: Q8e,
  articlesOnly: j8e,
  noOverview: q8e,
  breadcrumb_app: _8e,
  breadcrumb_pdf: $8e,
  breadcrumb_mail: eqe,
  breadcrumb_embed: tqe,
  breadcrumb_shop: iqe,
  breadcrumb_articles: nqe,
  breadcrumb_preview: rqe,
  breadcrumb_edit: gqe,
  breadcrumb_images: oqe,
  breadcrumb_materials: lqe,
  breadcrumb_models: aqe,
  breadcrumb_rules: sqe,
  breadcrumb_settings: Iqe,
  breadcrumb_admin: cqe,
  breadcrumb_extract: dqe,
  breadcrumb_apps: uqe,
  breadcrumb_create: Cqe,
  breadcrumb_import: Aqe,
  breadcrumb_users: bqe,
  breadcrumb_support: hqe,
  breadcrumb_logs: mqe,
  breadcrumb_systemStatus: pqe,
  breadcrumb_trash: Bqe,
  breadcrumb_abonnement: fqe,
  breadcrumb_expired: Zqe,
  breadcrumb_profile: Gqe,
  breadcrumb_configurator: yqe,
  breadcrumb_configurations: Wqe,
  breadcrumb_groups: Sqe,
  breadcrumb_variables: Vqe,
  breadcrumb_design: wqe,
  breadcrumb_scene: vqe,
  breadcrumb_presentation: Rqe,
  breadcrumb_options: Xqe,
  breadcrumb_usage: Hqe,
  breadcrumb_values: kqe,
  Primary: Yqe,
  Secondary: Fqe,
  Background: xqe,
  Warning: Dqe,
  Error: "Couleur de l'erreur",
  Main: Jqe,
  Light: Eqe,
  Dark: Nqe,
  "Contrast Text": "Couleur du texte (de contour)",
  Paper: Lqe,
  Default: Kqe,
  Disabled: Tqe,
  "Content Main": "Couleur de fond Canvas",
  "Scrollbar Default": "Couleur de la barre de défilement",
  "Letzter Schritt kann nicht gelöscht werden.": "Le dernier groupe ne peut pas être supprimé.",
  "Dieses Merkmal ist versteckt.": "Cette caractéristique est cachée.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Cette caractéristique n'est visible que dans le panneau d'administration. Il peut y avoir plusieurs raisons à cela : 
 1. elle a été masquée par une règle. 
 2. l'étape associée a été supprimée.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Cette caractéristique n'est visible que dans le panneau d'administration : La caractéristique n'a pas d'options de sélection.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Cette caractéristique n'est plus visible, car elle n'a pas de sélection valide!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Cette caractéristique n'est plus visible, car elle n'a qu'une seule sélection valide!",
  "Vertikale Platzierung zulassen?": "Autoriser le placement vertical?",
  "Suchfeld ausblenden?": "Masquer le champ de recherche?",
  Modalgröße: "Taille modale",
  "Anzahl an Komponenten pro Zeile": "Nombre de composants par ligne",
  "Weitere Preisauswirkungen dieser Selektion": "Autres conséquences de cette sélection sur les prix",
  "Aktion verstecken": "Cacher l'action",
  Ctrl: Mqe,
  Ersetzen: Pqe,
  "Bild hochladen": "Télécharger l'image",
  "Das Dateiformat ist nicht erlaubt!": "Le format de fichier n'est pas autorisé!",
  Bestellen: Uqe,
  "Straße und Hausnummer": "Rue et numéro",
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "J'ai pris connaissance des informations sur la protection des données et je les accepte.",
  "UST-ID": "Numéro d'identification de la taxe sur le chiffre d'affaires",
  Deutschland: zqe,
  Österreich: "Autriche",
  Schweiz: Oqe,
  "Åland Inseln": "Îles d'Åland",
  Andorra: Qqe,
  Belgien: jqe,
  Belarus: qqe,
  "Bosnien und Herzegowina": "Bosnie-Herzégovine",
  Bulgarien: _qe,
  Tschechien: $qe,
  Vatikanstadt: e_e,
  Montenegro: t_e,
  Dänemark: "Danemark",
  Estland: i_e,
  Spanien: n_e,
  Färöer: "Îles Féroé",
  Frankreich: r_e,
  Guernsey: g_e,
  Kroatien: o_e,
  Irland: l_e,
  Island: a_e,
  "Isle of Man": "Île de Man",
  Italien: s_e,
  Jersey: I_e,
  Albanien: c_e,
  Kosovo: d_e,
  Lettland: u_e,
  "Fürstentum Liechtenstein": "Fürstentum Liechtenstein",
  Lithauen: C_e,
  Luxemburg: A_e,
  Ungarn: b_e,
  Monaco: h_e,
  Niederlande: m_e,
  Norwegen: p_e,
  Polen: B_e,
  Portugal: f_e,
  Kasachstan: Z_e,
  Malta: G_e,
  Moldau: y_e,
  Rumänien: "Roumanie",
  Russland: W_e,
  "San Marino": "Saint-Marin",
  Slowenien: S_e,
  Slowakei: V_e,
  Serbien: w_e,
  Finnland: v_e,
  "Spitzbergen und Jan Mayen": "Svalbard et Jan Mayen",
  Schweden: R_e,
  Türkei: "Turkey",
  Ukraine: X_e,
  "Vereinigtes Königreich": "Royaume-Uni",
  Zypern: H_e,
  Griechenland: k_e,
  Nordmazedonien: Y_e
}, x_e = {
  ..._7e,
  ...F_e
}, D_e = "Klant", J_e = "Product", E_e = "Betalingsstatus", N_e = "Klanten", L_e = "Admin", K_e = "Configuratoren", T_e = "Maak", M_e = "Importeren", P_e = "Gebruikers", U_e = "Ondersteuning", z_e = "Logs", O_e = "Systeemstatus", Q_e = "Prullenbak", j_e = "Abonnement", q_e = "Verlopen", __e = "Profiel", $_e = "Configuraties", e$e = "Configurators", t$e = "Ondersteuning", i$e = "Verkoper", n$e = "Gebruikers", r$e = "Prullenmand", g$e = "Help", o$e = "Abonnement", l$e = "Profiel", a$e = "Afmelden", s$e = "Sjabloon", I$e = "Oproepen", c$e = "PDF", d$e = "Code", u$e = "Prijs", C$e = "Inspiratie", A$e = "Profiel dealer", b$e = "Taal", h$e = "Klant", m$e = "Inhoud", p$e = "Configurator-versie", B$e = "Annuleren", f$e = "Sluit", Z$e = "Veld", G$e = "Bewerk", y$e = "Adres", W$e = "Gegevensbescherming", S$e = "Naam", V$e = "e-mail", w$e = "Telefoon", v$e = "Opmerking", R$e = "Bedrijf", X$e = "Geaccepteerd", H$e = "Stad", k$e = "Postcode", Y$e = "Land", F$e = "datum", x$e = "Verkoper", D$e = "json", J$e = "Prijs", E$e = "Opties", N$e = "Bestel campagne", L$e = "Type", K$e = "Configuratie", T$e = "AR", M$e = "Gedeelde", P$e = "Toon", U$e = "Sorteren", z$e = "Artikelnummer", O$e = "Beschrijving van de", Q$e = "Categorie", j$e = "Prijzen", q$e = "Artikel", _$e = "Verander", $$e = "uploaden", eet = "Geen", tet = "Alle", iet = "Foto's", net = "Ruwheid", ret = "Metaalachtigheid", get = "Transparant", oet = "Opaciteit", aet = "Kleur", set = "Emissive", Iet = "Pagina", cet = "Voorpagina", det = "Achterkant", uet = "Dubbelzijdig", Cet = "Transmissie", Aet = "Reflectie", bet = "Blanke lak", het = "Opties", met = "Aanwijzing", pet = "Pbr", Bet = "Fysiek", fet = "Sleutel", Zet = "Model", Get = "Uitgebreid", yet = "Bewerk", Wet = "Kopie", Vet = "Exporteer", wet = "Productpresentatie", vet = "Hoofdmodel", Ret = "Upgrade", Xet = "Sjabloon", Het = "Les", ket = "Tracking", Yet = "share", Fet = "Kenmerken", xet = "Korting", Det = "Impact", Jet = "Sla", Eet = "inbedden", Net = "Referentietaal", Let = "Talen", Ket = "Lettertype", Tet = "Helvetica", Met = "Koerier", Pet = "Interstate", Uet = "Montserrat", zet = "Links", Oet = "Rechts", Qet = "Top", jet = "Onder", qet = "Kop", _et = "Algemeen", $et = "Mail", ett = "Winkel op", ttt = "Verlaten", itt = "Stuur", ntt = "Bestellingen", rtt = "datum", gtt = "Dagen", ott = "Naam artikel", ltt = "Artikel", att = "Configurator", stt = "Partner", Itt = "Provision", ctt = "Naam", dtt = "e-mail", utt = "Gebruikersaccount", Ctt = "Gebruikersnaam", Att = "Wachtwoord", btt = "Inloggen", htt = "Registratie", mtt = "Regelgeving gegevensbescherming", ptt = "GTC", Btt = "Wachtwoord", ftt = "Redacteur", Ztt = "Standaard", Gtt = "Van", ytt = "Versie", Wtt = "Boekingen", Stt = "Platform", Vtt = "Interval", wtt = "Abonnement", vtt = "KlantID", Rtt = "Actief", Xtt = "Sinds", Htt = "Vraag", ktt = "Acties", Ytt = "Boek", Ftt = "Maand", xtt = "Jaar", Dtt = "Tot", Jtt = "Parameters", Ett = "Klanten", Ntt = "ID", Ltt = "rekeningen", Ktt = "Leeg", Ttt = "Gebruikers", Mtt = "Rol", Ptt = "Staps", Utt = "Waarden", ztt = "Regels", Ott = "Regelregels", Qtt = "Modellen", jtt = "Materialen", qtt = "Functie", _tt = "Regel", $tt = "Aantal", eit = "Status", tit = "Gemaakt", iit = "Wachtwoord", nit = "Nieuw", rit = "Ingang", git = "Uitnodigen", oit = "download", lit = "Achtergrondmodel", ait = "Favorieten", sit = "Maak", Iit = "Prijsinstellingen", cit = "Hoofdactie", dit = "Contactformulier", uit = "Verplicht veld", Cit = "Actie naam", Ait = "Hoeveelheid", bit = "Aantalberekening", hit = "Hoeveelheidsberekening", mit = "Artikel promotie", pit = "Aantal", Bit = "Eenheid", fit = "Camera", Zit = "Stap", Git = "Cameraweergave", yit = "Cameratype", Wit = "Perspectief", Sit = "Orthografisch", Vit = "Type focus", wit = "Dubbele", vit = "Verwijderen", Rit = "Camera's", Xit = "Interfaces", Hit = "Gratis", kit = "pro", Yit = "Downgrade", Fit = "Maandelijks", xit = "Home", Dit = "Help", Jit = "Annuleren", Eit = "GDPR", Nit = "Icoon", Lit = "Logo", Kit = "Kleuren", Tit = "CSS", Mit = "Instellingen", Pit = "Voorbeeld", Uit = "Artikel", zit = "Bestellingen", Oit = "Statistieken", Qit = "Fout", jit = "Helaas is er een onbekende fout opgetreden. Als het probleem niet kan worden opgelost door de pagina opnieuw te laden, neem dan contact met ons op.", qit = "Onbekende fout", _it = "Foutmelding:", $it = "Hoofdafsluiting", ent = "Afsluiting", tnt = "Bestelopties", int = "Deze stap is momenteel alleen zichtbaar in het beheerderspaneel, omdat het geen functies bevat met selecteerbare waarden.", nnt = "Tekst", rnt = "Achtergrondkleur", gnt = "Info", ont = "Waarschuwingskleur", lnt = "Foutkleur", ant = "Basisinstellingen", snt = "Opaciteit", Int = "Materiële actie", cnt = "Kleuren actie", dnt = "Afbeelding actie", unt = "Tip", Cnt = "Attentie", Ant = "Ga verder", bnt = "Plus", hnt = "Minus", mnt = "Verborgen", pnt = "Artikelnummer", Bnt = "Naam", fnt = "Valuta", Znt = "Waarde", Gnt = "Zijbalk", ynt = "Begindatum", Wnt = "Einddatum", Snt = "Aantal starts", Vnt = "Uiteindelijk aantal", wnt = "Zoek op", vnt = "Titel", Rnt = "OK", Xnt = "Nadruk", Hnt = "Expressie", knt = "Resultaat", Ynt = "Minimumwaarde", Fnt = "Maximale waarde", xnt = "Decimale plaatsen", Dnt = "Stapgrootte", Jnt = "Berekend", Ent = "Kleurselectie", Nnt = "Onderdelenlijst", Lnt = "Component kaarten", Knt = "Afbeelding selecteren", Tnt = "Informatie over", Mnt = "Aantal invoer", Pnt = "Dropdown", Unt = "Miniaturen", znt = "Schakelaars", Ont = "Tekstinvoer", Qnt = "Voorbeeldtekst", jnt = "Optioneel", qnt = "Bepalingen", _nt = "Namen van materialen", $nt = "Label actie", ert = "Foutmelding", trt = "Modellen actie", irt = "Positie", nrt = "Schaal", rrt = "Componenten", grt = "Download", ort = "Maak verbinding met", lrt = "Kleurwaarde", art = "Weergave", srt = "RAL", Irt = "Bekijk", crt = "URL", drt = "Selectiewaarden", urt = "Selectie prijzen", Crt = "Sélection", Art = "Totale prijs", brt = "Verder", hrt = "Volledig scherm", mrt = "Onderdelen", prt = "xl", Brt = "Conflictrapport", frt = "Positielijn", Zrt = "Hoeveelheid", Grt = "Prijs artikel", yrt = "Afbeelding", Wrt = "Informatie", Srt = "Meervoudige selectie", Vrt = "Lijst", wrt = "Hoekafronding", vrt = "Afmetingen", Rrt = "Breedte", Xrt = "Diepte", Hrt = "Operatie", krt = "Segmenten", Yrt = "Pad", Frt = "Startpunt", xrt = "Eindpunt", Drt = "Begin anker", Jrt = "Zonder", Ert = "Eindanker", Nrt = "Type tekst", Lrt = "Numerieke waarde", Krt = "Offsets", Trt = "Blauw", Mrt = "Geel", Prt = "Rood", Urt = "Paars", zrt = "Abchazisch", Ort = "Afar", Qrt = "Afrikaans", jrt = "Akan", qrt = "Albanees", _rt = "Amhaars", $rt = "Arabisch", egt = "Aragonees", tgt = "Armeens", igt = "Assamees", ngt = "Avarisch", rgt = "Avestisch", ggt = "Aymara", ogt = "Azerbeidzjaans", lgt = "Bambara", agt = "Basjkiers", sgt = "Baskisch", Igt = "Wit-Russisch", cgt = "Bengaals", dgt = "Bislama", ugt = "Bosnisch", Cgt = "Bretons", Agt = "Bulgaars", bgt = "Birmaans", hgt = "Chamorro", mgt = "Tsjetsjeens", pgt = "Chinees", Bgt = "Tsjoevasjisch", fgt = "Cornisch", Zgt = "Corsicaans", Ggt = "Cree", ygt = "Kroatisch", Wgt = "Tsjechisch", Sgt = "Deens", Vgt = "Dzongkha", wgt = "Engels", vgt = "Esperanto", Rgt = "Ests", Xgt = "Ewe", Hgt = "Faeröers", kgt = "Fijisch", Ygt = "Fins", Fgt = "Frans", xgt = "Fulah", Dgt = "Galicisch", Jgt = "Ganda", Egt = "Georgisch", Ngt = "Duits", Lgt = "Guarani", Kgt = "Gujarati", Tgt = "Hausa", Mgt = "Hebreeuws", Pgt = "Herero", Ugt = "Hindi", zgt = "Hongaars", Ogt = "IJslands", Qgt = "Ido", jgt = "Igbo", qgt = "Indonesisch", _gt = "Inuktitut", $gt = "Inupiaq", eot = "Iers", tot = "Italiaans", iot = "Japans", not = "Javaans", rot = "Kannada", got = "Kanuri", oot = "Kasjmiri", lot = "Kazachs", aot = "Kinyarwanda", sot = "Komi", Iot = "Kongo", cot = "Koreaans", dot = "Koerdisch", uot = "Lao", Cot = "Latijn", Aot = "Lets", bot = "Lingala", hot = "Litouws", mot = "Macedonisch", pot = "Malagassisch", Bot = "Maleis", fot = "Malayalam", Zot = "Maltees", Got = "Manx", yot = "Maori", Wot = "Marathi", Sot = "Marshallees", Vot = "Mongools", wot = "Nauruaans", vot = "Ndonga", Rot = "Nepalees", Xot = "Noors", Hot = "Occitaans", kot = "Ojibwa", Yot = "Oriya", Fot = "Oromo", xot = "Pali", Dot = "Perzisch", Jot = "Pools", Eot = "Portugees", Not = "Quechua", Lot = "Reto-Romaans", Kot = "Rundi", Tot = "Russisch", Mot = "Samoaans", Pot = "Sango", Uot = "Sanskriet", zot = "Sardijns", Oot = "Servisch", Qot = "Shona", jot = "Sindhi", qot = "Slowaaks", _ot = "Sloveens", $ot = "Somalisch", elt = "Soendanees", tlt = "Swahili", ilt = "Swazi", nlt = "Zweeds", rlt = "Tagalog", glt = "Tahitiaans", olt = "Tadzjieks", llt = "Tamil", alt = "Tataars", slt = "Telugu", Ilt = "Thais", clt = "Tibetaans", dlt = "Tigrinya", ult = "Tsonga", Clt = "Tswana", Alt = "Turks", blt = "Turkmeens", hlt = "Twi", mlt = "Oekraïens", plt = "Urdu", Blt = "Oezbeeks", flt = "Venda", Zlt = "Vietnamees", Glt = "Waals", ylt = "Welsh", Wlt = "Wolof", Slt = "Xhosa", Vlt = "Jiddisch", wlt = "Yoruba", vlt = "Zoeloe", Rlt = {
  "Sie zahlen nicht online. Bitte wenden Sie sich an den Mitarbeiter in Ihrem Unternehmen, der den Vertrag mit ObjectCode geschlossen hat.": "Je betaalt niet online. Neem contact op met de medewerker in uw bedrijf die het contract met ObjectCode heeft afgesloten.",
  Mandant: D_e,
  Produkt: J_e,
  Bezahlzustand: E_e,
  Mandanten: N_e,
  Admin: L_e,
  Konfiguratoren: K_e,
  Erstellen: T_e,
  Importieren: M_e,
  Benutzer: P_e,
  Support: U_e,
  Logs: z_e,
  Systemstatus: O_e,
  Papierkorb: Q_e,
  Abonnement: j_e,
  Ausgelaufen: q_e,
  Profil: __e,
  Konfigurationen: $_e,
  Händler: "Verkoper",
  apps: e$e,
  support: t$e,
  "dealer-profile": "Profiel dealer",
  dealers: i$e,
  users: n$e,
  trash: r$e,
  help: g$e,
  subscription: o$e,
  profile: l$e,
  logout: a$e,
  "Neuer Konfigurator": "Nieuwe configurator",
  Template: s$e,
  Zurück: "Terug",
  Aufrufen: I$e,
  PDF: c$e,
  Code: d$e,
  Preis: u$e,
  Inspiration: C$e,
  Aktion: A$e,
  Sprache: b$e,
  "Sie möchten die Daten dieses Kunden einsehen?": "Wil je de gegevens van deze klant bekijken?",
  Kunde: h$e,
  Inhalt: m$e,
  "Shop-API": "API winkel",
  "Gespeichert am": "Opgeslagen op",
  Konfiguratorversion: p$e,
  Abbrechen: B$e,
  "Ergebnis der Shop API": "Resultaat van de Shop API",
  Schliessen: f$e,
  Feld: Z$e,
  Bearbeiten: G$e,
  Adresse: y$e,
  Datenschutz: W$e,
  Name: S$e,
  Email: V$e,
  Telefon: w$e,
  Bemerkung: v$e,
  Firma: R$e,
  "Steuer-ID": "Belasting ID",
  Akzeptiert: X$e,
  Stadt: H$e,
  PLZ: k$e,
  Land: Y$e,
  Datum: F$e,
  "exit-action": "Bestel campagne",
  dealer: x$e,
  "order-status": "Status",
  json: D$e,
  price: J$e,
  options: E$e,
  Bestellaktion: N$e,
  Typ: L$e,
  Konfiguration: K$e,
  AR: T$e,
  Geteilt: M$e,
  "Sie möchten die Daten Ihrer Kunden einsehen?": "Wil je de gegevens van je klanten bekijken?",
  "Preise anlegen": "Prijzen maken",
  anzeigen: P$e,
  "Artikel und Preise erfolgreich importiert.": "Artikelen en prijzen zijn succesvol geïmporteerd.",
  Sortierung: U$e,
  Artikelnummer: z$e,
  "Artikelnummer eingeben": "Voer artikelnummer in",
  "Namen eingeben": "Naam invoeren",
  Beschreibung: O$e,
  "Beschreibung eingeben": "Beschrijving invoeren",
  Kategorie: Q$e,
  "Kategorien eingeben": "Categorieën invoeren",
  Preise: j$e,
  "Sortierung erfolgreich angewendet.": "Sortierung erfolgreich angewendet.",
  "Fehler beim Anwenden der Sortierung: ": "Fout bij het toepassen van de sortering: ",
  "Artikel und Preise erfolgreich veröffentlicht.": "Artikelen en prijzen succesvol gepubliceerd.",
  "Fehler beim Veröffentlichen: ": "Fout bij publicatie: ",
  "Sie möchten Preise anzeigen?": "Wil je prijzen weergeven?",
  "Neuer Artikel": "Nieuw artikel",
  Löschen: "Verwijder",
  "Veröffentlichen Sie die App, um Artikel und Preise veröffentlichen zu können.": "Publiceer de app om artikelen en prijzen te kunnen publiceren.",
  "Artikel und Preise veröffentlichen": "Artikelen en prijzen publiceren",
  Artikel: q$e,
  "Preise für Artikel nr.": "Prijzen voor artikel nr.",
  Schließen: "Sluit",
  "Preise werden automatisch importiert. Änderungen sind nicht möglich.": "Prijzen worden automatisch geïmporteerd. Wijzigingen zijn niet mogelijk.",
  "Sie verwenden nicht die aktuelle Release des K3. Das kann zu technischen Problemen führen. Bitte wechseln Sie sobald möglich auf die aktuelle Release und veröffentlichen Sie.": "Je gebruikt niet de huidige release van K3. Dit kan technische problemen veroorzaken. Schakel zo snel mogelijk over naar de huidige release en publiceer.",
  Wechseln: _$e,
  Upload: $$e,
  "Laden Sie ein oder mehrere Bilder in den angegeben Ordner hoch. Die können den Schrägstrich (/) verwenden, um tiefere Ordner zu erzeugen.": "Upload een of meer afbeeldingen naar de opgegeven map. Je kunt de forward slash (/) gebruiken om diepere mappen te maken.",
  "Alternativ können Sie ein ZIP-Archiv mit einer Ordnerstruktur hochladen.": "Je kunt ook een ZIP-archief met een mappenstructuur uploaden.",
  "Ordner *": "Map *",
  'Beachten Sie: Alle Bilder in einem Ordner werden als Galerie gruppiert, nach Name sortiert. Verwenden Sie also Dateinamen wie "Bild_001".': 'Let op: Alle afbeeldingen in een map worden gegroepeerd als een galerij, gesorteerd op naam. Gebruik dus bestandsnamen zoals "Image_001".',
  Keine: eet,
  Alle: tet,
  Bilder: iet,
  Roughness: net,
  Metalness: ret,
  Transparent: get,
  Opacity: oet,
  Farbe: aet,
  Emissive: set,
  "Color Map": "Kleur Textuur",
  "Normal Map": "Normale textuur",
  "Roughness Map": "Ruwheid Textur",
  "Metalness Map": "Metaalstructuur",
  "Alpha Map": "Alpha Textur",
  Seite: Iet,
  Vorderseite: cet,
  Hinterseite: det,
  Beidseitig: uet,
  "Texture repeat": "Texture repeat",
  "Depth Write": "Schrijf in de dieptebuffer",
  Transmission: Cet,
  Reflectivity: Aet,
  ClearCoat: bet,
  "Clearcoat Roughness": "Ruwheid blanke lak",
  "new-material": "Nieuw materiaal",
  Optionen: het,
  Bezeichnung: met,
  Pbr: pet,
  Physikalisch: Bet,
  Key: fet,
  "AR Fallback Material": "AR terugvalmateriaal",
  "Nicht ausgewählt": "Niet geselecteerd",
  Model: Zet,
  Erweitert: Get,
  "Nur in Regeln verwendete Materialien anzeigen": "Toon alleen materialen die in de regels worden gebruikt",
  "extract-materials": "Materialen uit het model halen",
  Editieren: yet,
  Kopieren: Wet,
  "Neues Modell": "Nieuw model",
  "Dynamisches Modell": "Dynamisch model",
  "Neue Regel Erstellen": "Nieuwe regel maken",
  "Regel erstellen": "Regel aanmaken",
  Gültigkeit: "Geldigheid",
  "Neue Regel": "Nieuwe regel",
  Export: Vet,
  "app-code-duplicate": "App-code is al in gebruik",
  "App Einstellungen konnten nicht gespeichert werden. Der Code ist bereits vergeben.": "App-instellingen konden niet worden opgeslagen. De code is al in gebruik.",
  "screenshot-quality": "Screenshot kwaliteit",
  Produktdarstellung: wet,
  "3D-Modell": "3D model",
  "Bilder-Konfigurator": "Afbeeldingsconfigurator",
  Hauptmodell: vet,
  "Hauptmodell entfernen": "Hoofdmodel verwijderen",
  "Link zum Konfigurator": "Link naar de configurator",
  "Falls Sie eine Erweiertung nutzen, tragen Sie hier ein, wo Ihr Entwickler sie zur Verfügung stellt.": "Als je een extensie gebruikt, voer dan hier in waar je ontwikkelaar deze beschikbaar maakt.",
  "Die Beschreibung dieses Konfigurators": "De beschrijving van deze configurator",
  "Google Analytics 4 Property ID": "Google Analytics 4 Eigendom-ID",
  "Sie müssen für den Google Cookie die Einverständnis des Nutzers einholen. Das passiert nicht innerhalb des K3!": "Je moet toestemming van de gebruiker krijgen voor de Google-cookie. Dit gebeurt niet binnen de K3!",
  "Sie möchten Ihr Analytics-Konto verbinden?": "Wil je je Analytics-account koppelen?",
  Upgrade: Ret,
  Vorlage: Xet,
  "Dieser Konfigurator dient als Vorlage": "Deze configurator dient als sjabloon",
  Tutorial: Het,
  "Standard übernehmen": "Standaard aannemen",
  Tracking: ket,
  share: Yet,
  "Hier können Sie eine URL angeben, an die verschiedene Daten gesendet werden, sobald der Nutzer eine Auswahl trifft. Damit haben Sie die Möglichkeit, mithilfe der CustomData Komponente im Layout Designer spezielle Informationen anzuzeigen (z.B. auf Versandkosten etc. hinzuweisen).": "Prijs & Info ServiceHier kun je een URL opgeven waar verschillende gegevens naartoe worden gestuurd zodra de gebruiker een selectie maakt. Hierdoor kun je de component CustomData in de Layout Designer gebruiken om speciale informatie weer te geven (bijvoorbeeld verzendkosten etc.).",
  "Preis & Info Service": "Prijs & Info Service",
  "Hilfe dazu finden Sie hier.": "Hulp is hier te vinden.",
  "URL für den Service, der die Daten verarbeitet": "URL voor de service die de gegevens verwerkt",
  "Debounce in ms": "Debounce in ms",
  Merkmale: Fet,
  "Merkmale und ihre aktuelle Auswahlen senden": "Functies verzenden en hun huidige selecties",
  "Optionale Merkmalbeschränkung": "Optionele functiebeperking",
  "Beschränken Sie optional die Merkmale, die gesendet werden.": "Beperk optioneel de kenmerken die worden verzonden.",
  "Artikel & Preis": "Artikel & prijs",
  "Aktuell ausgewählte Artikel senden": "Momenteel geselecteerde artikelen verzenden",
  "Aktuellen Preis senden": "Huidige prijs verzenden",
  "to dealer app": "Naar de dealer app",
  "Händler hat Zugriff": "Winkelier heeft toegang",
  "Händler hat keinen Zugriff": "Dealer heeft geen toegang",
  "dealer query": "Standaardinstellingen",
  "Händler legt Aufschlag fest": "Winkelier bepaalt winstmarge",
  discount: xet,
  surcharge: Det,
  "Um diesem Händler Zugriff zu geben oder ihn zu entziehen, ": "Om deze dealer toegang te geven of te ontnemen, ",
  "wenden Sie sich bitte an uns": "Neem alstublieft contact met ons op",
  Speichern: Jet,
  "Ihre Händler sollen Ihren Konfigurator nutzen können?": "Wil je dat je dealers je configurator kunnen gebruiken?",
  "Keine Händler vorhanden": "Geen dealers beschikbaar",
  "Legen Sie zuerst einen Händler an - dann geben Sie ihm hier Zugriff auf die App.": "Maak eerst een winkelier aan en geef deze hier toegang tot de app.",
  "Jetzt Händler anlegen": "Nu dealer aanmaken",
  Einbetten: Eet,
  "Als Link": "Als link",
  "Als IFrame": "Als IFrame",
  "Meldungen beim Laden anpassen": "Berichten bij het laden aanpassen",
  "Bitte Auth0 Zugangsdaten angeben": "Voer Auth0 toegangsgegevens in",
  "Sie wollen den Konfigurator nur für bestimmte Nutzer freigeben? Dann können Sie den Dienst Auth0 verwenden.": "Wilt u de configurator alleen voor specifieke gebruikers vrijgeven? Dan kunt u de Auth0-service gebruiken.",
  "Konfigurator-Zugang": "Toegang configurator",
  "Anmeldung für Konfigurator verlangen.": "Aanmelding voor configurator vereisen.",
  "Auth0 Domain": "Auth0 Domein",
  "Auth0 ClientId": "Auth0 ClientId",
  "Referenzsprache. Die Einträge müssen mit der Referenzspalte in der importierten Datei übereinstimmen, um berücksichtigt zu werden.": "Referentietaal. De invoer moet overeenkomen met de referentiekolom in het geïmporteerde bestand om in aanmerking te worden genomen.",
  "Wrong file format, be sure to use the format of the exported file for the currently selected reference language.": "Verkeerd bestandsformaat, gebruik het formaat van het geëxporteerde bestand voor de huidige geselecteerde referentietaal.",
  "Info ": "Info ",
  "Sprache: ": "Taal: ",
  "Referenzsprache: ": "Referentietaal: ",
  Referenzsprache: Net,
  "Anzahl Sprachen: ": "Aantal talen: ",
  "Anzahl übersetzbarer Texte: ": "Aantal vertaalbare teksten: ",
  Sprachen: Let,
  "Die erste Sprache gilt als Standard.": "De eerste taal is de standaardtaal.",
  Übersetzungen: "Übersetzingen",
  "Versteckte Merkmale": "Verborgen functies",
  "Unbenutzte Sprachen": "Ongebruikte talen",
  "Importiere XLSX": "XLSX importeren",
  "Exportiere XLSX": "XLSX exporteren",
  "Sie möchten Ihren Kunden und/oder sich selbst Anfragen per E-Mail senden?": "Wil je je klanten en/of jezelf vragen per e-mail sturen?",
  "Mail Texte": "Mail teksten",
  "Hier können Sie den Inhalt der versendeten Mails anpassen. Lesen Sie vorab den Abschnitt in der Dokumentation.": "Je kunt hier de inhoud van de verzonden e-mails aanpassen. Lees vooraf het gedeelte in de documentatie.",
  "Bitte beachten Sie: Sie müssen immer den Konfigurator veröffentlichen, bevor die geänderten Texte verwendet werden.": "Let op: Je moet de configurator altijd publiceren voordat de gewijzigde teksten worden gebruikt.",
  Schriftart: Ket,
  Helvetica: Tet,
  "Times Roman": "Times Roman",
  Courier: Met,
  Interstate: Pet,
  Montserrat: Uet,
  "Nunito Sans": "Nunito Sans",
  "Poppins Bold": "Poppins Vet",
  Schriftgröße: "Lettergrootte",
  Links: zet,
  Rechts: Oet,
  Oben: Qet,
  Unten: jet,
  Kopfzeile: qet,
  Fußzeile: "Voettekst",
  "Neue PDF Vorlage auswählen": "Selecteer een nieuwe PDF-sjabloon",
  "Vorhandene PDF Vorlage löschen": "Bestaande PDF-sjabloon verwijderen",
  "Sie möchten Bestätigungen oder Angebote als PDF senden?": "Wil je bevestigingen of aanbiedingen als PDF versturen?",
  "PDF Einstellungen": "PDF-instellingen",
  Seitenränder: "Marges",
  "Voransicht mit dieser Konfiguration:": "Voorbeeld met deze configuratie:",
  "und diesem Template:": "en deze sjabloon:",
  "Speichern und drucken": "Opslaan en afdrukken",
  "Um eine Voransicht drucken zu können, muss eine gespeicherte Konfiguration vorliegen.": "Om een afdrukvoorbeeld te kunnen afdrukken, moet er een opgeslagen configuratie beschikbaar zijn.",
  Allgemein: _et,
  Mail: $et,
  Shop: ett,
  "Ungespeicherte Änderungen": "Niet-opgeslagen wijzigingen",
  "Sie haben ungespeicherte Änderungen. Sind Sie sicher, dass Sie ohne Speichern verlassen möchten?": "Je hebt niet-opgeslagen wijzigingen. Weet je zeker dat je wilt verlaten zonder op te slaan?",
  Verlassen: ttt,
  "Immer aktuellste Version verwenden": "Altijd de meest actuele versie gebruiken",
  "K3 Version": "K3 Version",
  "Wir helfen gern!": "We helpen je graag!",
  "Ihre Telefonnummer": "Je telefoonnummer",
  "Ihre Nachricht": "Jouw bericht",
  Senden: itt,
  "Nachricht senden": "Verstuur bericht",
  "Rückruf erbitten": "Terugbellen",
  orders: ntt,
  date: rtt,
  "Preise wurden in den Einstellungen deaktiviert": "Prijzen zijn gedeactiveerd in de instellingen",
  "Keine Einnahmen vorliegend": "Geen inkomsten beschikbaar",
  "total-earnings": "Totale inkomsten",
  Tage: gtt,
  articlename: ott,
  articles: ltt,
  "Erfolgreich importiert": "Succesvol geïmporteerd",
  'Sie können einen Konfigurator unter "Einstellungen" exportieren. Die entstandene Datei können Sie hier wieder importieren.': 'Je kunt een configurator exporteren onder "Instellingen". Je kunt het resulterende bestand hier importeren.',
  "JSON Export Datei": "JSON exportbestand",
  "Leerer Konfigurator": "Lege configurator",
  "Starten Sie mit einem leeren Konfigurator und richten Sie ihn nach Ihren Wünschen ein.": "Begin met een lege configurator en stel deze in volgens jouw wensen.",
  "Konfigurator importieren": "Configurator importeren",
  "Importieren sie einen Konfigurator anhand einer exportierten Datei.": "Importeer een configurator met behulp van een geëxporteerd bestand.",
  Veröffentlicht: "Gepubliceerd",
  "Mandant hat noch keinen Konfigurator": "De klant heeft nog geen configurator",
  Konfigurator: att,
  "Link kopiert": "link gekopieerd",
  "E-Mail": "e-mail",
  "Werben Sie K3 Kunden!": "K3-klanten werven!",
  "Geben Sie den Link unten weiter. Bucht Ihr Kontakt einen Konfigurator, erhalten Sie eine Provision.": "Deel de link hieronder. Als uw contactpersoon een configurator boekt, ontvangt u een commissie.",
  Partner: stt,
  Provision: Itt,
  "Beachten Sie, dass alle herausgegebenen Partnerlinks ungültig werden, sobald Sie den Code ändern.": "Houd er rekening mee dat eventuele uitgegeven affiliate-links ongeldig worden zodra u de code wijzigt.",
  "Meine Kunden": "Mijn klanten",
  "Vielen Dank für Ihre Bestätigung...": "Bedankt voor je bevestiging...",
  "E-Mail Bestätigung": "Bevestiging per e-mail",
  "Zur Anmeldung": "Naar de registratie",
  Händlerprofil: "Profiel dealer",
  name: ctt,
  email: dtt,
  "E-Mail ist ungültig!": "E-mail is ongeldig!",
  Nutzerkonto: utt,
  Nutzername: Ctt,
  "Mail ist schon vergeben": "Mail is al bezet",
  "code-duplicate": "Deze code is al bezet",
  "dealer code helper text": "Om de dealerconfigurator op te roepen.",
  "default discount": "standaard korting",
  "Kann pro Konfigurator überschrieben werden.": "Kan worden overschreven per configurator.",
  "default surcharge": "standaardtoeslag",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben: ": "Controleer de informatie die je hebt verstrekt: ",
  "Fehlendes Produkt": "Ontbrekend product",
  "Ihre Händler sollen einen Ihrer Konfiguratoren nutzen können?": "Wil je dat je dealers een van je configurators kunnen gebruiken?",
  "Bitte buchen Sie dort zunächst ein anderes Produkt.": "Boek daar eerst een ander product.",
  "new dealer": "Nieuwe dealer",
  "Login screen": "Registratie",
  "Bitte am Desktop öffnen": "Openen op bureaublad",
  Password: Att,
  Login: btt,
  "Passwort vergessen?": "Wachtwoord vergeten?",
  "Noch kein Konto?": "Nog geen account?",
  "Ein Login war leider nicht möglich. Die Kombination aus E-Mail und Passwort ist ungültig.": "Helaas was het niet mogelijk om in te loggen. De combinatie van e-mail en wachtwoord is ongeldig.",
  "Ein Login war leider nicht möglich. Bitte erlauben Sie Website Cookies in Ihren Browser-Einstellungen": "Helaas was het niet mogelijk om in te loggen. Sta websitecookies toe in uw browserinstellingen",
  "Falls die Mail in den nächsten Minuten nicht ankommt, schauen Sie bitte auch in Ihrem SPAM-Ordner nach und kontrollieren Sie Ihre Adresse.": "Als de mail niet binnen een paar minuten aankomt, controleer dan je SPAM-map en controleer je adres.",
  "Wir senden Ihnen eine Mail mit Hinweisen zum Setzen eines neuen Kennwortes.": "We sturen je een e-mail met instructies voor het instellen van een nieuw wachtwoord.",
  "Mail senden": "Mail sturen",
  "K3 - die Konfiguratorplattform": "K3 - het configuratorplatform",
  "Ich habe den Konfigurator innerhalb von drei Wochen fertiggestellt und er hat sich bereits mehr als rentiert.": "Ik heb de configurator binnen drie weken afgerond, en hij heeft zichzelf al meer dan terugverdiend.",
  "Die Eingabe ist zu kurz.": "De invoer is te kort.",
  "Die Eingabe ist zu lang.": "De invoer is te lang.",
  "Die Eingabe wird benötigt.": "De invoer is vereist.",
  "Email Adresse ist ungültig.": "E-mailadres is ongeldig.",
  "Dieser Wert wird bereits benutzt.": "Deze waarde wordt al gebruikt.",
  "Das Kennwort muss mindestens 8 Zeichen lang sein und Buchstaben, Großbuchstaben und Zahlen enthalten.": "Het wachtwoord moet minimaal 8 tekens lang zijn en letters, hoofdletters en cijfers bevatten.",
  "Die Eingabe fehlt.": "De invoer ontbreekt.",
  "Leider ": "Helaas ",
  "Bitte geben Sie eine E-Mail-Adresse an": "Voer een e-mailadres in",
  "Die angegebene E-Mail-Adresse hat ein ungültiges Format": "Het opgegeven e-mailadres heeft een ongeldig formaat",
  "Bitte geben Sie ein Passwort an": "Voer een wachtwoord in",
  "Bitte geben Sie eine Telefonnummer an": "Voer een telefoonnummer in",
  "Die eingegebene Telefonnummer hat ein ungültiges Format": "Het ingevoerde telefoonnummer heeft een ongeldig formaat",
  "Bitte stimmen Sie unseren Datenschutzhinweisen und Geschäftsbedigungen zu": "Bevestig onze privacyverklaring en algemene voorwaarden",
  Registrierung: htt,
  "Ihre E-Mail-Adresse": "Je e-mailadres",
  "Bitte wählen Sie ein Kennwort": "Kies een wachtwoord",
  "Direkt starten - ohne Zahlungsangaben.": "Direct starten - geen betalingsgegevens vereist.",
  "Bitte bestätigen Sie unsere ": "Bevestig onze ",
  Datenschutzbestimmungen: mtt,
  " und unsere ": " en onze ",
  AGB: ptt,
  "Jetzt registrieren": "Nu registreren",
  "Die Registrierung war leider nicht möglich.": "Helaas was registratie niet mogelijk.",
  "Herzlich willkommen!": "Een warm welkom!",
  "Wir haben Ihnen eine E-Mail gesendet - schauen Sie auch in Ihren Spam-Ordner.": "We hebben je een e-mail gestuurd - controleer ook je spamfolder.",
  "Sie können sich aber auch jetzt gleich mit Ihren Daten anmelden:": "Je kunt je nu ook registreren met je gegevens:",
  "Wir haben Ihr Kennwort neu gesetzt.": "We hebben je wachtwoord opnieuw ingesteld.",
  "Passwort setzen": "Wachtwoord instellen",
  Passwort: Btt,
  "Mindestens 8 Zeichen, Groß-, Kleinbuchstaben und Zahlen": "Minimaal 8 tekens, hoofdletters, kleine letters en cijfers",
  Bestätigung: "Bevestiging",
  "Bestätigung stimmt nicht überein": "Bevestiging komt niet overeen",
  "Kennwort setzen": "Wachtwoord instellen",
  "K3 - der 3D-Produktkonfigurator für Shopify": "K3 - de 3D-productconfigurator voor Shopify",
  "Sie haben die Shopify App für den K3 Konfigurator erfolgreich installiert. Das sind die nächsten Schritte:": "U heeft de Shopify-app voor de K3-configurator succesvol geïnstalleerd. Dit zijn de volgende stappen:",
  "Registrieren Sie sich am K3.": "Registreer bij K3.",
  "Legen Sie einen Konfigurator an.": "Maak een configurator.",
  "Jetzt starten": "Nu starten",
  "Verbinden Sie den Konfigurator mit Ihrem Shop und importieren Sie Ihre Shopify-Artikel.": "Verbind de configurator met uw winkel en importeer uw Shopify-artikelen.",
  "Gestalten Sie den Konfigurator für Ihr Produkt.": "Ontwerp de configurator voor uw product.",
  "Fügen Sie den Konfigurator in Ihren Shop ein.": "Voeg de configurator toe aan uw winkel.",
  Editor: ftt,
  "Mandant: ": "Klant: ",
  "Erstellt am: ": "Gemaakt op: ",
  "Veröffentlicht am: ": "Gepubliceerd op: ",
  "Noch nicht veröffentlicht": "Nog niet gepubliceerd",
  "Version: ": "Versie: ",
  "Artikel-Version: ": "Artikelversie: ",
  "Code: ": "Code: ",
  "Typ: ": "Type: ",
  Standard: Ztt,
  "Shop: ": "Winkelen: ",
  "Nicht verbunden": "Niet aangesloten",
  "Bestellungen insgesamt": "Totaal bestellingen",
  Veröffentlichungen: "Publicaties",
  Von: Gtt,
  Version: ytt,
  "Artikel-Version": "Artikel versie",
  Buchungen: Wtt,
  Plattform: Stt,
  Intervall: Vtt,
  Subscription: wtt,
  CustomerID: vtt,
  Aktiv: Rtt,
  Seit: Xtt,
  "Abschlag [%]": "Korting [%]",
  "Aufschlag [%]": "Toeslag [%]",
  Query: Htt,
  Aktionen: ktt,
  "Mandanten wechseln": "Klanten veranderen",
  "Konnte nicht gespeichert werden: ": "Kon niet worden opgeslagen: ",
  Buchung: Ytt,
  "Angelegt am": "Gemaakt op",
  "Zum AdminPanel": "Naar het beheerpaneel",
  "App editieren": "Bewerk app",
  Monat: Ftt,
  Jahr: xtt,
  "Bezahlt?": "Betaald?",
  Bis: Dtt,
  "Bestätigung fehlgeschlagen. Die Namen stimmen nicht überein.": "Bevestiging mislukt. De namen komen niet overeen.",
  "Einstiegs-Produkt": "Instapproduct",
  "Shopify Shop": "Shopify Shop",
  "Stripe ID": "Streep ID",
  Parameter: Jtt,
  "Partner?": "Partner?",
  Kunden: Ett,
  ID: Ntt,
  Rechnungen: Ltt,
  Leer: Ktt,
  "Der vollständige Mandant wird exportiert - inklusive aller Assets. Fortfahren?": "De volledige client wordt geëxporteerd, inclusief alle onderdelen. Ga verder?",
  "Mandant unwiderruflich löschen": "Klant onherroepelijk verwijderen",
  "Der vollständige Mandant wird unwiderruflich gelöscht - inklusive aller Assets. Haben Sie einen Export gemacht?. Fortfahren?": "De hele client wordt onherroepelijk verwijderd - inclusief alle activa. Heeft u een export gemaakt? Doorgaan?",
  "Bitte bestätigen Sie den Namen des zu löschenden Mandanten:": "Bevestig de naam van de klant die verwijderd moet worden:",
  Nutzer: Ttt,
  "Mandant erfolgreich gelöscht": "Client succesvol verwijderd",
  "Mandanten editieren": "Klanten bewerken",
  Rolle: Mtt,
  Schritte: Ptt,
  Werte: Utt,
  Regeln: ztt,
  Regelzeilen: Ott,
  Modelle: Qtt,
  Materialien: jtt,
  Gelöscht: "Verwijderd",
  Merkmal: qtt,
  Regel: _tt,
  Nummer: $tt,
  Status: eit,
  Erstellt: tit,
  Zurücklegen: "Terugzetten",
  Mindestlänge: "Minimale lengte {{chars}} tekens",
  "Email Adresse ist ungültig": "E-mailadres is ongeldig",
  Kennwort: iit,
  "Test stimmt nicht überein": "Test komt niet overeen",
  "Telefonnummer ist ungültig": "Telefoonnummer is ongeldig",
  "Entwickler Modus": "Ontwikkelaarsmodus",
  "Gibt Entwicklern Zugriff auf erweiterte Möglichkeiten.": "Geeft ontwikkelaars toegang tot uitgebreide mogelijkheden.",
  "API Token": "API Token",
  "Wenn Sie ein neues API Token erzeugen, werden alle bisherigen gelöscht.": "Als je een nieuw API token aanmaakt, worden alle vorige token verwijderd.",
  "Damit verlieren auch alle von Ihnen verbundenen Shops Zugriff auf den Konfigurator.": "Dit betekent dat al je aangesloten winkels ook geen toegang meer hebben tot de configurator.",
  "Sie können das Token im Shop-Plugin eintragen.": "Je kunt het token invoeren in de winkelplugin.",
  "Notieren Sie sich das neue Token, es wird hier nur einmalig angezeigt.": "Noteer het nieuwe token, het wordt hier maar één keer weergegeven.",
  Neu: nit,
  "Mit dem ApiToken erhält ein Shop oder Ihre individuelle Entwicklung Zugriff auf die Daten Ihrer Konfiguratoren.": "De ApiToken geeft een winkel of je eigen ontwikkeling toegang tot je configuratorgegevens.",
  "Sie möchten über die API auf den K3 zugreifen?": "Wilt u toegang tot de K3 via de API?",
  "Dann müssen Sie für mindestens einen Ihrer Konfiguratoren ein entsprechendes Produkt buchen.": "Dan moet u een overeenkomstig product boeken voor ten minste één van uw configurators.",
  "Neuen Nutzer anlegen": "Nieuwe gebruiker aanmaken",
  Eingabe: rit,
  "E-Mail nicht valide!": "E-mail niet geldig!",
  "Wir senden dem neuen Nutzer eine E-Mail mit einem Link. Dort kann er sein Kennwort setzen und erhält dann Zugang zu Ihrem Konfigurator.": "We sturen de nieuwe gebruiker een e-mail met een link. Daar kunnen ze hun wachtwoord instellen en vervolgens toegang krijgen tot je configurator.",
  "Nutzer einladen": "Nodig gebruiker uit",
  "Der Nutzer erhält Zugang zu Ihrem Mandanten.": "De gebruiker krijgt toegang tot je klant.",
  "Bitte überprüfen Sie die von Ihnen gemachten Angaben:": "Controleer de informatie die je hebt verstrekt:",
  Einladen: git,
  "Benutzer einladen": "Nodig gebruikers uit",
  "new user": "Nieuwe gebruiker",
  "Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.": "Deze configurator heeft momenteel geen geldige licentie.",
  "CSS-Datei auswählen": "Selecteer CSS-bestand",
  "Sie möchten dynamische Modelle nutzen und damit z.B. Produkte auf Maß verkaufen?": "Wil je dynamische modellen gebruiken om bijvoorbeeld producten op maat te verkopen?",
  "Das Modell überschreitet mit {{curr}} die empfohlene Anzahl von {{max}} Dreiecken. Eventuell kann es zu Problemen im AR Modus kommen.": "Het model overschrijdt met {{curr}} het aanbevolen aantal {{max}} driehoeken. Er kunnen problemen zijn in de AR-modus.",
  "Das Modell überschreitet mit {{curr}}MB die empfohlene Dateigröße von {{max}}MB.": "Het model overschrijdt de aanbevolen bestandsgrootte van {{curr}}MB, het model overschrijdt de aanbevolen bestandsgrootte van {{max}}MB.",
  "3D-Modell auswählen": "Selecteer 3D-model",
  Download: oit,
  Hintergrundmodell: lit,
  "material-upload": "materiaal-upload",
  Favoriten: ait,
  "main-model": "Hoofdmodel",
  "Wirft Schatten": "Werpt schaduwen",
  "Wird schattiert": "Wordt gearceerd",
  "Bilder Galerie": "Afbeeldingen galerij",
  Anlegen: sit,
  "Neue Aktion": "Nieuwe actie",
  Preiseinstellungen: Iit,
  "Preise im Konfigurator ausblenden?": "Prijzen verbergen in de configurator?",
  Hauptaktion: cit,
  Kontaktformular: dit,
  "Sie können diese Kundendaten zwar erfassen, aber nicht einsehen.": "Je kunt deze klantgegevens wel vastleggen, maar niet bekijken.",
  Pflichtfeld: uit,
  'Sie können Links zu Ihren eigenen Dokumenten mit <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">Datenschutzhinweise</a> einbauen.': 'Je kunt links naar je eigen documenten opnemen met <a href="https://ihre-domain.de/ihre-datenschutzbestimmungen.html" target="_blank">privacyverklaringen</a>.',
  "Shop verbinden": "Winkel aansluiten",
  Aktionsname: Cit,
  "Überschrift Bestätigung": "Rubriek Bevestiging",
  "Text Bestätigung": "Tekstbevestiging",
  "Link zur Konfiguration zeigen?": "Link naar configuratie weergeven?",
  "Thumbnail des Konfigurators": "Miniatuurafbeelding van de configurator",
  "Artikel hat keinen Namen und keine Nummer!": "Artikel heeft geen naam en geen nummer!",
  "Kein Artikel ausgewählt!": "Geen item geselecteerd!",
  "Artikel auswählen": "Selecteer artikel",
  "Artikelanzahl und Menge": "Aantal artikelen en hoeveelheid",
  "Wie oft der entsprechende Artikel hinzugefügt werden soll": "Hoe vaak het overeenkomstige artikel moet worden toegevoegd",
  Anzahl: Ait,
  "Stücklistenrelevant, beispielsweise für die Länge eines Pfostens": "Relevant voor de stuklijst, bijvoorbeeld voor de lengte van een paal",
  "Menge (optional)": "Hoeveelheid (optioneel)",
  Anzahlberechnung: bit,
  Mengenberechnung: hit,
  Artikelaktion: mit,
  "Wert eingeben": "Waarde invoeren",
  "Neue Spalte": "Nieuwe column",
  "Wert-Eigenschaft": "Waarde eigenschap",
  "Sie können den Werten dieses Merkmals Eigenschaften geben, z.B.             Gewicht oder Güteklasse oder Leistung. Diese Eigenschaften können             Sie für jeden Wert getrennt erfassen und dann dem Benutzer ausgeben. Sie             können mit diesen Eigenschaften aber auch Regeln und Berechnungen             deutlich einfacher machen.": "Je kunt eigenschappen toekennen aan de waarden van dit kenmerk, bijvoorbeeld gewicht of kwaliteitsklasse of prestatie. Je kunt deze eigenschappen voor elke waarde apart invoeren en ze vervolgens uitvoeren naar de gebruiker. Je kunt deze eigenschappen ook gebruiken om regels en berekeningen veel eenvoudiger te maken.",
  "Eigenschaft wird dem Nutzer angezeigt": "Eigenschap wordt weergegeven aan de gebruiker",
  "mehrsprachiger Text": "meertalige tekst",
  "nicht übersetzter Text": "onvertaalde tekst",
  Zahl: pit,
  Einheit: Bit,
  "Buchen Sie jetzt Ihre Lizenz!": "Boek nu uw licentie!",
  "Denken Sie daran, den Konfigurator zu veröffentlichen, damit er für Ihre Kunden freigegeben wird.": "Vergeet niet de configurator te publiceren, zodat deze voor uw klanten beschikbaar is.",
  "Fokus auf Modelle": "Focus op modellen",
  "Alle Modelle": "Alle modellen",
  "Fokus über Objektnamen": "Focus via objectnamen",
  Kamera: fit,
  Schritt: Zit,
  Kameraansicht: Git,
  Kameratyp: yit,
  Perspektive: Wit,
  Orthographisch: Sit,
  Fokustyp: Vit,
  "Dynamischer Fokus": "Dynamische focus",
  "Statischer Fokus": "Statische focus",
  "Screenshot Auflösung": "Resolutie schermafbeelding",
  "Notwendiger Unterschied zur aktuellen Ansicht": "Noodzakelijk verschil met de huidige weergave",
  "Noch keine Kamera gespeichert": "Nog geen camera opgeslagen",
  "Kamera erstellen": "Camera maken",
  "Bitte auswählen": "Selecteer",
  Ausgewählt: "Geselecteerd",
  "Merkmal setzen: ": "Functie instellen: ",
  "Keine Farbe ausgewählt!": "Geen kleur geselecteerd!",
  "Farbe auswählen": "Selecteer kleur",
  "Farbmerkmal auswählen:": "Selecteer kleurkenmerk:",
  "Keine Auswahl": "Geen selectie",
  "Hoch schieben": "Opdrukken",
  "Runter schieben": "Druk omlaag",
  Duplizieren: wit,
  "Löschen des aktiven Elements nicht möglich": "Verwijderen van het actieve element niet mogelijk",
  "Komponente hinzufügen": "Component toevoegen",
  Entfernen: vit,
  "Ihre Konfiguration konnte nicht gespeichert werden.": "Je configuratie kon niet worden opgeslagen.",
  "Bitte entschuldigen Sie. Wir haben die Konfiguration in diesem Browser gesichert. Bitte kommen Sie später noch einmal wieder.": "Neem het ons niet kwalijk. We hebben de configuratie opgeslagen in deze browser. Kom later nog eens terug.",
  "technische Information:": "technische informatie:",
  "Preis: ": "Prijs: ",
  "Kamera bearbeiten": "Camera bewerken",
  "Neue Kamera für Bestellungsbilder": "Nieuwe camera voor bestelafbeeldingen",
  "Ansicht übernehmen und Speichern": "Weergave overnemen en opslaan",
  "Kameras für Bestellungsbilder": "Camera's voor bestelbeelden",
  Kameras: Rit,
  "Anfrage erhalten": "Verzoek ontvangen",
  "Buchung erfolgreich": "Succesvol boeken",
  "Für das neue Produkt melden wir uns bei Ihnen.": "We nemen contact met je op voor het nieuwe product.",
  "Ihre Subskription wurde angepasst.": "Je abonnement is aangepast.",
  "Ihre Subskription wurde beendet.": "Je abonnement is geannuleerd.",
  "Das Produkt wurde gebucht.": "Het product is geboekt.",
  "3D-Konfigurator mit beliebig komplexer Logik": "3D-configurator met willekeurig complexe logica",
  "E-Mail mit PDF erhalten": "E-mail met PDF ontvangen",
  "Shop-Anbindung": "Winkelaansluiting",
  Schnittstellen: Xit,
  "Auf Anfrage": "Op aanvraag",
  Kostenfrei: Hit,
  pro: kit,
  "Meine Rechnungen": "Mijn facturen",
  "Derzeit gebucht.": "Momenteel geboekt.",
  "Änderung Ihrer Buchung": "Je boeking wijzigen",
  "Sie buchen nun ein neues Produkt. Möchten Sie fortfahren?": "Je bent nu een nieuw product aan het boeken. Wil je doorgaan?",
  "Jetzt buchen": "Boek nu",
  Downgrade: Yit,
  "Zahlungsplan ändern": "Betalingsplan wijzigen",
  Monatlich: Fit,
  Jährlich: "Jaarlijks",
  "In neuem Tab öffnen": "In nieuw tabblad openen",
  "Konfigurator anpassen": "Configurator aanpassen",
  "main drawer": "Je ziet een voorbeeld van je configurator, die je zoals gewoonlijk kunt bedienen. Klik op een potloodpictogram om iets te wijzigen of:",
  "Ändern Sie die Bestelloptionen": "De bestelopties wijzigen",
  "Ändern Sie das Design": "Verander het ontwerp",
  "Passen sie die 3D Szene an": "De 3D-scène aanpassen",
  "Speichern Sie die aktuelle Kamera für Bestellungsbilder": "De huidige camera opslaan voor bestelafbeeldingen",
  "Merkmale verwalten": "Functies beheren",
  "Ihre Lizenz": "Uw licentie",
  "So richten Sie Ihren Konfigurator ein:": "Hoe je je configurator instelt:",
  Home: xit,
  Hilfe: Dit,
  "dealer sidebar": "Je kunt je dealerconfigurator hier instellen",
  "Ändern Sie das Logo": "Wijzig het logo",
  "Ändern Sie die DSGVO": "Wijzig DSGVO",
  "Ändern Sie den Preis": "Wijzig de prijs",
  "Ändern Sie die PDF Vorlage": "Wijzig de PDF-sjabloon",
  "PDF Gestaltung": "PDF Ontwerp",
  "Laden Sie ein PDF als Vorlage für den Druck hoch.": "Upload een PDF als sjabloon om af te drukken.",
  cancel: Jit,
  "app surcharge": "Winst instellen",
  "you can change your surcharge here": "Je kunt je toeslag hier wijzigen",
  DSGVO: Eit,
  "Hier können Sie den Text für die DSGVO ändern": "Hier kunt u de tekst voor de GDPR wijzigen",
  "Neuer Schritt": "Nieuwe stap",
  Icon: Nit,
  "Icon Bilddatei": "Pictogram afbeeldingsbestand",
  "Icon position": "Positie pictogram",
  "Icon Größe": "Pictogramgrootte",
  "Ersetze Weiter mit Aktionsauswahl": "Vervang Volgende door Actieselectie",
  "Aktionsnamen überschreiben": "Actienamen overschrijven",
  "Individuelles Design": "Ontwerp op maat in één stap",
  "Angepasstes Layout speichern": "Aangepaste lay-out opslaan",
  "Merkmale editieren": "Functies bewerken",
  "Keine Ergebnisse": "Geen resultaten",
  "Desktop Layout": "Bureaubladindeling",
  "Mobile Layout": "Mobiele lay-out",
  "Schritte nacheinander einblenden": "Laat de stappen na elkaar zien",
  "Besuchte Schritte abhaken": "Bezochte stappen afvinken",
  "Sie verwenden derzeit ein nicht mehr unterstütztes Layout. Bitte wählen Sie ein neues aus.": "U gebruikt momenteel een niet langer ondersteund layout. Kies alstublieft een nieuw layout.",
  "Dieses Layout selbst anpassen": "Pas deze lay-out zelf aan",
  "Eigenes Layout erstellen": "Maak je eigen lay-out",
  "Angepasstes Layout anwenden": "Aangepaste lay-out toepassen",
  Logo: Lit,
  "Konfigurator-Abschluss": "Configurator voltooien",
  "3D Szene": "3D Scène",
  "Manuelle Einstellung erstellen": "Handmatige instelling maken",
  "Design & Theme": "Ontwerp en thema",
  Farben: Kit,
  "Farbanpassungen zurücksetzten": "Kleuraanpassingen resetten",
  CSS: Tit,
  "Sie können das Aussehen Ihres Konfigurators auch mittels CSS individuell anpassen:": "Je kunt het uiterlijk van je configurator ook aanpassen met CSS:",
  "Link zur CSS-Datei": "Link naar het CSS-bestand",
  "Oder laden Sie eine CSS Datei hoch:": "Of upload een CSS-bestand:",
  "Neues Merkmal": "Nieuwe functie",
  "Merkmal kopieren": "Kenmerk kopiëren",
  Zurücksetzen: "Resetten",
  "Sie setzen den Konfigurator auf die gewählte Version zurück.": "U reset de configurator naar de gekozen versie.",
  "Dadurch werden alle Daten dieses Konfigurators ersetzt.": "Hierdoor worden alle gegevens van deze configurator vervangen.",
  "Auch der Papierkorb wird gelöscht.": "Ook de prullenbak wordt geleegd.",
  "Diese Operation kann nicht rückgängig gemacht werden.": "Deze bewerking kan niet ongedaan gemaakt worden.",
  "Sind Sie sicher?": "Weet je het zeker?",
  Einstellungen: Mit,
  "Dynamische Texte": "Dynamische teksten",
  "Texte und Einstellungen anpassen": "Teksten en instellingen aanpassen",
  "Sie verwenden diesen Konfigurator mit einer Testlizenz.": "U gebruikt momenteel deze configurator met een testlicentie.",
  "Ihr Testzeitraum ist abgelaufen.": "Uw testperiode is verlopen.",
  "Ihr Testzeitraum ist seit {{days}} Tagen abgelaufen.": "Uw testperiode is verlopen sinds {{days}} dagen.",
  "Sie können diesen Konfigurator noch {{days}} Tage testen.": "U kunt deze configurator nog {{days}} dagen testen.",
  "Sie haben diesen Konfigurator storniert.": "U heeft deze configurator geannuleerd.",
  "Jetzt buchen!": "Nu boeken!",
  Vorschau: Pit,
  Articles: Uit,
  Bestellungen: zit,
  Statistics: Oit,
  "Fragen? Wir helfen gern!": "Vragen? We helpen graag!",
  "Inhalte: ": "Inhoud: ",
  'Bevor der Konfigurator genutzt werden kann, müssen sie den Knopf "Veröffentlichen" betätigen. Wenn Sie danach Änderungen vornehmen, werden diese auch erst nach der nächsten Veröffentlichung wirksam.': 'Voordat de configurator gebruikt kan worden, moet je op de knop "Publish" drukken. Als je dan wijzigingen aanbrengt, worden deze pas van kracht na de volgende publicatie.',
  "Live Version": "Live versie",
  Veröffentlichen: "Publiceer",
  "Erstelle Option: ": "Maak optie: ",
  Fehler: Qit,
  "Beim Rendern des Inhalts ist ein Fehler aufgetreten.": "Er is een fout opgetreden tijdens het renderen van de inhoud.",
  Fatal_Error_Text: jit,
  Fatal_Error: qit,
  "Fehlermeldung:": "Foutmelding:",
  "Zur Startseite": "Naar de homepage",
  "Neu Laden": "Nieuwe winkel",
  "Cleanup und Neu Laden": "Opruimen en opnieuw laden",
  "You may need to reload the page": "Het opnieuw laden van de pagina kan nodig zijn",
  Error_Message: _it,
  "(SU) Client wechseln": "(SU) Klant wijzigen",
  "Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?": "De app is nog niet gepubliceerd. Daarom kunnen er fouten optreden bij het openen van deze configuratie. Hoe nu verder?",
  "Kein Hauptabschluss": "Geen hoofdafsluiting",
  "Label eingeben": "Label invoeren",
  "Abschlüsse verbergen": "Afsluitingen verbergen",
  "Abschlüsse deaktivieren": "Afsluitingen deactiveren",
  Hauptabschluss: $it,
  "Abschlüsse festlegen": "Afsluitingen vaststellen",
  "Hier können Sie festlegen, welche Abschlüsse für die Benutzer sichtbar oder deaktiviert sind.": "Hier kunt u instellen welke afsluitingen zichtbaar of gedeactiveerd zijn voor de gebruikers.",
  "Die unterschiedlichen Farben der Abschlüsse repräsentieren unterschiedliche Zustände:": "De verschillende kleuren van de afsluitingen vertegenwoordigen verschillende toestanden:",
  Abschluss: ent,
  "In Schwarz werden verborgene Abschlüsse repräsentiert.": "In zwart worden verborgen afsluitingen weergegeven.",
  "In Grau werden deaktivierte Abschlüsse repräsentiert.": "In grijs worden gedeactiveerde afsluitingen weergegeven.",
  "In Blau bezeichnet welcher Abschluss am Ende der Reiter Navigation angezeigt wird. Davon kann es nur einen geben.": "In blauw wordt aangegeven welke afsluiting aan het einde van de tabbladnavigatie wordt weergegeven. Er kan er maar één van zijn.",
  "Elemente löschen": "Elementen verwijderen",
  "Element löschen": "Element verwijderen",
  "Selektierte Elemente löschen": "Geselecteerde elementen verwijderen",
  "Alle selektierte Elemente löschen": "Alle geselecteerde elementen verwijderen",
  "Lösch-Konflikte anzeigen": "Verwijderingsconflicten weergeven",
  "Das Element": "Het element",
  "Möchten Sie die selektierten Elemente wirklich unwiderruflich löschen?": "Wilt u de geselecteerde elementen echt onherroepelijk verwijderen?",
  "Möchten Sie dieses Element wirklich unwiderruflich löschen?": "Wil je dit element echt permanent verwijderen?",
  "Die folgenden Gründe sprechen gegen eine Löschung:": "De volgende redenen spreken tegen annulering:",
  "Einige Elemente werden noch an anderen Stellen verwendet:": "Einige Elemente werden noch an anderen Stellen verwendet:",
  "{{label}} wird noch an anderen Stellen verwendet:": "{{label}} wordt ook op andere plaatsen gebruikt:",
  "{{label}} wird noch verwendet in ": "{{label}} wordt nog steeds gebruikt in ",
  "einer Erweiterung. Bitten Sie den Entwickler die Nutzung zu entfernen und löschen Sie dann den Key.": "van een extensie. Vraag de ontwikkelaar om het gebruik te verwijderen en verwijder vervolgens de sleutel.",
  "der Definition der Regel": "de definitie van de regel",
  "einem Eintrag in Regel": "een vermelding in regel",
  "einer berechneten Eigenschaft des Modells": "een berekende eigenschap van het model",
  "der Formel von": "de formule uit",
  "der Kamera": "de camera",
  "des Merkmals": "van de karakteristieke",
  "des Schrittes": "van de stap",
  "der globalen Kamera": "de wereldwijde camera",
  "Löschen Sie bitte zunächst die anderen Referenzen.": "Verwijder eerst de andere verwijzingen.",
  "Neuen Schritt hinzufügen": "Nieuwe stap toevoegen",
  "Bitte legen Sie einen Schritt an!": "Maak alsjeblieft een stap!",
  "Schritt editieren": "Bewerk stap",
  Bestelloptionen: tnt,
  "Merkmal editieren": "Functie bewerken",
  "Mehr Informationen anzeigen": "Meer informatie tonen",
  "Nicht Aktiv": "Niet actief",
  "Keine Angabe": "Niet gespecificeerd",
  "Fokus:": "Focus:",
  "Fokus: ": "Focus: ",
  hiddenGroup: int,
  "Bilder auswählen": "Afbeeldingen selecteren",
  "Ordner auswählen:": "Selecteer map:",
  "Bildmerkmal: ": "Afbeelding: ",
  "Kein Bild ausgewählt": "Geen afbeelding geselecteerd",
  "Bild auswählen": "Afbeelding selecteren",
  "Bildmerkmal auswählen:": "Selecteer afbeeldingsfunctie:",
  Befüllt: "Gevuld",
  "Zustand auswählen": "Selecteer status",
  "Kein Komponente ausgewählt!": "Geen component geselecteerd!",
  "Komponente auswählen": "Selecteer component",
  "Intervall eingeben": "Interval invoeren",
  "Zum Dashboard": "Naar het dashboard",
  Primärfarbe: "Primaire kleur",
  "Setzt die Primärfarbe (für Tabs, Buttons..) sowie die Kontrastfarbe (Button-Text)": "Stelt de primaire kleur (voor tabbladen, knoppen enz.) en de contrastkleur (voor knoptekst) in.",
  Sekundärfarbe: "Secundaire kleur",
  "Setzt die Sekundärfarbe (sekundäre Buttons) sowie die Kontrastfarbe (Button-Text)": "Stelt de secundaire kleur (secundaire knoppen) en de contrastkleur (knop tekst) in.",
  Text: nnt,
  "Setzt die reguläre Textfarbe sowie die Zweitfarbe (beispielsweise für Beschreibungen)": "Stelt de gewone tekstkleur en de secundaire kleur in (bijvoorbeeld voor beschrijvingen)",
  Hintergrundfarbe: rnt,
  "Setzt die reguläre Hintergrundfarbe sowie die der leicht hervorgehobene Flächen (beispielsweise Merkmale)": "Stelt de gewone achtergrondkleur in en die van de licht gemarkeerde gebieden (bijv. kenmerken)",
  Info: gnt,
  "Setzt die Farbe der Info-Icons": "Stelt de kleur van de info-pictogrammen in",
  Warnfarbe: ont,
  "Setzt die Farbe der Warnhinweise": "Stelt de kleur van de waarschuwingsberichten in",
  Fehlerfarbe: lnt,
  "Setzt die Farbe für Fehlermeldungen und -hinweise": "Stelt de kleur in voor foutmeldingen en notities",
  Basiseinstellungen: ant,
  "Helles Theme": "Licht thema",
  "Erweiterte Einstellungen": "Geavanceerde instellingen",
  "Label hinzufügen: ": "Label toevoegen: ",
  "Kein Label ausgewählt!": "Geen label geselecteerd!",
  "Was soll angezeigt werden?": "Wat moet er worden weergegeven?",
  Maximalgröße: "Maximale grootte",
  Deckkraft: snt,
  "Kein Material ausgewählt!": "Geen materiaal geselecteerd!",
  "Material auswählen": "Materiaal kiezen",
  "Material auswählen:": "Selecteer materiaal:",
  Materialaktion: Int,
  Farbaktion: cnt,
  Bildaktion: dnt,
  "Beschränkung der Auswirkungen auf bestimmte Modelle": "Beperking van effecten tot bepaalde modellen",
  "Die Option 'Titel ausblenden' ist aktiviert.": "De optie 'Titel verbergen' is ingeschakeld.",
  Hinzufügen: "Voeg  toe",
  "Welches Teil soll hinzugefügt werden?": "Welk deel moet worden toegevoegd?",
  Hinweis: unt,
  Achtung: Cnt,
  Fortfahren: Ant,
  "Kein Modell ausgewählt!": "Geen model geselecteerd!",
  "Modell auswählen": "Model kiezen",
  "Modell hinzufügen:": "Model toevoegen:",
  "Globale Änderung": "Wereldwijde verandering",
  Oberflächen: "Oppervlakken",
  "Ausgewählte Oberflächen": "Geselecteerde oppervlakken",
  "Eintrag darf nicht leer sein.": "De invoer mag niet leeg zijn.",
  "Alle Werte": "Alle waarden",
  "Werte auswählen": "Selecteer waarden",
  "Sortierung anwenden": "Sorteren toepassen",
  "Das Dateiformat ist nicht erlaubt! Keine Datei gewählt.": "Het bestandsformaat is niet toegestaan! Geen bestand geselecteerd.",
  "Erlaubte Formate:": "Toegestane formaten:",
  "Keine Datei gewählt.": "Geen bestand geselecteerd.",
  "Datei konnte nicht hochgeladen werden.": "Bestand kon niet worden geüpload.",
  "Bild hochladen": "Afbeelding uploaden",
  Plus: bnt,
  Minus: hnt,
  "Dieses Merkmal ist nicht erlaubt.": "Deze functie is niet toegestaan.",
  "Merkmal-Optionen": "Functieopties",
  "Merkmal Beschreibung editieren": "Bewerken Beschrijving",
  "Merkmal-Info editieren": "Info bewerken",
  Versteckt: mnt,
  "Dieses Merkmal wird nicht angezeigt. Der Wert kann aber in Regeln und Berechnungen genutzt werden.": "Dit kenmerk wordt niet weergegeven. De waarde kan echter wel worden gebruikt in regels en berekeningen.",
  "showSelection.label": "showSelectie.label",
  "Aus Schritt verstecken": "Verstop je in je kruis",
  "Diese Option ergibt nur Sinn, wenn das Merkmal über ein custom Layout an einer anderen Stelle ein- oder ausgeblendet wird. Auch wenn sie hierrüber aus dem Schritt versteckt wird, wird sie trotzdem weiterhin in Zusammenfassungen diesem zugeordnet.": "Deze optie heeft alleen zin als het kenmerk op een andere locatie wordt getoond of verborgen via een aangepaste lay-out. Zelfs als het verborgen is voor de stap, wordt het er nog steeds aan toegewezen in samenvattingen.",
  "Kamera-Optionen": "Camera-opties",
  "Vorlage wählen": "Selecteer sjabloon",
  "Konfigurator erstellen": "Configurator maken",
  "Willkommen in Ihrem neuen K3 Konto!": "Welkom op je nieuwe K3 account!",
  "Richten Sie gleich Ihren ersten Konfigurator ein:": "Stel meteen je eerste configurator in:",
  "Sie können alle Daten natürlich später noch ändern.": "Je kunt natuurlijk alle gegevens later wijzigen.",
  "Nicht veröffentlicht": "Niet gepubliceerd",
  "Ladevorgang fehlgeschlagen": "Oplaadproces mislukt",
  "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!": "De configuratie kon niet worden geladen! Probeer het later nog eens!",
  "Keine Optionen": "Geen opties",
  "Neuen Artikel anlegen": "Nieuw artikel maken",
  "Hier können sie einen neuen Artikel mit Preis anlegen.": "Hier kun je een nieuw artikel maken met prijs.",
  articleNo: pnt,
  articleName: Bnt,
  currency: fnt,
  "CustomData: No path provided!": "CustomData: No path provided!",
  "Positionen ändern": "Posities veranderen",
  "Abbrechen durch Klick": "Klik om te annuleren.",
  Wert: Znt,
  Seitenleiste: Gnt,
  "Preis eingeben": "Prijs invoeren",
  Währung: "Valuta",
  "Währung eingeben": "Valuta invoeren",
  "Einheit eingeben": "Eenheid invoeren",
  Startdatum: ynt,
  "Startdatum eingeben": "Startdatum invoeren",
  Enddatum: Wnt,
  "Enddatum eingeben": "Einddatum invoeren",
  Startanzahl: Snt,
  "Startanzahl eingeben": "Aantal starts invoeren",
  Endanzahl: Vnt,
  "Endanzahl eingeben": "Voer het uiteindelijke nummer in",
  Priorität: "Prioriteit",
  "Priorität eingeben": "Prioriteit invoeren",
  "Aufschlag?": "Serveren?",
  "Preistyp eingeben": "Prijstype invoeren",
  "Neuer Preis": "Nieuwe prijs",
  "Erweiterter Modus": "Uitgebreide modus",
  Suchen: wnt,
  Auswählen: "Selecteer",
  "Wählen Sie eine Vorlage aus:": "Selecteer een sjabloon:",
  "Oder erstellen Sie einen neuen Konfigurator ohne Vorlage: ": "Of maak een nieuwe configurator zonder sjabloon: ",
  "Sollen wir Ihren Konfigurator jetzt anlegen?": "Moeten we nu je configurator maken?",
  "Wir bringen Sie danach direkt in den Editor.": "We brengen je dan rechtstreeks naar de redacteur.",
  "Anlegen & zum Konfigurator": "Maken & naar de configurator",
  "Meldung hinzufügen": "Meldung hinzufügen",
  Titel: vnt,
  OK: Rnt,
  "Farbenanzahl im Fenster": "Aantal kleuren in het venster",
  "Farbkachel Rundung": "Kleur tegelafronding",
  Opazität: "Opaciteit",
  Hervorhebung: Xnt,
  "Ungültig gewordene Instanzen entfernen (statt ersetzen)": "Ongeldig geworden instanties verwijderen (in plaats van ze te vervangen)",
  "Drag & Drop erlauben": "Slepen en neerzetten toestaan",
  "Anzeige der Sortierungsschaltflächen": "Weergave van de sorteerknoppen",
  "Sortierung umkehren": "Omgekeerd sorteren",
  "Duplizierung erlauben": "Duplicatie toestaan",
  "Zeige Werte aus inneren Merkmalen an": "Waarden van interne kenmerken weergeven",
  "Den Merkmal-Namen der inneren Werte immer ausblenden, auch wenn es mehrere Werte gibt": "Verberg altijd de karakteristieke naam van de binnenste waarden, zelfs als er meerdere waarden zijn",
  "Innere Merkmalsnamen ausblenden": "Namen van interne kenmerken verbergen",
  "Als Warenkorb setzen?": "Instellen als winkelmand?",
  "Gruppieren nach": "Groep door",
  "Komponenten direkt unter der Liste anzeigen": "Komponenten direkt unter der Liste anzeigen",
  Expression: Hnt,
  "Erfolgreich gespeichert": "Succesvol opgeslagen",
  "Formel Editor": "Formule-editor",
  "Geben Sie Formeln von Merkmalen ein.": "Formules invoeren voor kenmerken.",
  " Schreiben Sie z.B. Länge * Breite.": " Schrijf bijvoorbeeld lengte * breedte.",
  "Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.": "Gebruik voor een attribuut bijvoorbeeld Motor.power als Motor je kenmerk is en Power het bijbehorende attribuut.",
  Ergebnis: knt,
  "Keine Formel eingegeben": "Geen formule ingevoerd",
  "Formel: ": "Formule: ",
  "Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.": "Er zijn nog niet genoeg selecties om een voorbeeld weer te geven.",
  "Ergebnis: ": "Resultaat: ",
  "Titel ausblenden": "Titel verbergen",
  "Ausblenden der originalen Textur, wenn bedruckt wird?": "De originele textuur vervagen bij het afdrukken?",
  "Erlaube Bildformate": "Afbeeldingsformaten toestaan",
  "Minimum Horizontale Positionierung": "Minimale horizontale positionering",
  "Maximum Horizontale Positionierung": "Maximale horizontale positionering",
  "Minimum Vertikale Positionierung": "Minimale verticale positionering",
  "Maximum Vertikale Positionierung": "Maximale verticale positionering",
  "Minimale Skalierung": "Minimale schaling",
  "Maximale Skalierung": "Maximaal schalen",
  "Optionaler Standardwert": "Optionele standaardwaarde",
  Mindestwert: Ynt,
  Maximalwert: Fnt,
  Nachkommastellen: xnt,
  Schrittweite: Dnt,
  "Zeige Knöpfe an": "Knoppen weergeven",
  "Benutze Vielfaches der Schrittweite": "Gebruik veelvouden van de increment",
  Berechnet: Jnt,
  "Zyklus Erkennung deaktivieren": "Cyclusdetectie uitschakelen",
  Ändern: "Verander",
  "Beispielhafte Beschreibung eines Wertes.": "Voorbeeldbeschrijving van een waarde.",
  "Dies ist nur eine Info": "Dit is slechts een info",
  "Color Dropdown": "Kleur selectie dropdown",
  "Color Radio": "Kleurselectie radio",
  "Color Radio Cards": "Radio kleurenkaarten",
  Farbauswahl: Ent,
  Komponentenliste: Nnt,
  "Komponentenliste mit Popup": "Onderdelenlijst met popup",
  Komponentenkarten: Lnt,
  Bildauswahl: Knt,
  Informationen: Tnt,
  Zahleneingabe: Mnt,
  "Radio Buttons": "Radioknoppen",
  "Radio Cards": "Radiokaarten",
  "RAL-Farbauswahl": "RAL-kleurselectie",
  Dropdown: Pnt,
  Thumbnails: Unt,
  Schalter: znt,
  "Schalter Card": "Schakelkaart",
  Texteingabe: Ont,
  Beispieltext: Qnt,
  "Konfliktauflösung mit einzelnen Merkmalen automatisch akzeptieren": "Conflictoplossing met individuele kenmerken automatisch accepteren",
  "Übergeordnete Merkmale": "Bovenliggende kenmerken",
  "Darstellungs-Optionen": "Weergaveopties",
  Optional: jnt,
  'Unter "Werte" finden Sie dann den speziellen Eintrag "keine Angabe". Hier können Sie noch anpassen, was dem Nutzer angezeigt werden soll, wenn er nichts ausgewählt hat.': 'Onder "Waarden" vind je dan het speciale item "Geen specificatie". Hier kun je nog aanpassen wat de gebruiker te zien krijgt als hij niets heeft geselecteerd.',
  "Die Auswahl wird nicht in der Bestätigung, PDF oder im Shop angezeigt, wenn nichts ausgewählt wurde.": "De selectie wordt niet weergegeven in de bevestiging, PDF of in de winkel als er niets is geselecteerd.",
  "Auswahl nur anzeigen, wenn ausgewählt": "Selectie alleen tonen als geselecteerd",
  "Konfigurator erfolgreich veröffentlicht.": "Configurator succesvol gepubliceerd.",
  "Folgende Änderungen werden veröffentlicht:": "De volgende wijzigingen worden gepubliceerd:",
  "Konfigurator veröffentlichen": "Configurator publiceren",
  "Sie möchten den Konfigurator veröffentlichen?": "Wil je de configurator publiceren?",
  "Wertebereich angeben": "Geef waardebereik op",
  "Merkmale: ": "Kenmerken: ",
  "Aktionen: ": "Acties: ",
  "Diese Regel ist aktuell deaktiviert.": "Deze regel is momenteel gedeactiveerd.",
  "Neue Spalten Hinzufügen": "Nieuwe kolommen toevoegen",
  Bedingungen: qnt,
  "Merkmale ausblenden": "Functies verbergen",
  "Schritt ausblenden": "Stap verbergen",
  "Werte ausblenden": "Waarden verbergen",
  "Konfigurator-Abschluss festlegen": "Configurator voltooien instellen",
  "Befüllen von Komponentenmerkmalen": "Kenmerken vulcomponent",
  "Bilder auf Oberflächen drucken": "Afbeeldingen afdrukken op oppervlakken",
  "Anzeige von Bildern": "Afbeeldingen weergeven",
  "Ändern der Farbe": "De kleur veranderen",
  "Austauschen von Oberflächen": "Oppervlakken vervangen",
  "Anzeige von Informationen": "Informatie weergeven",
  "Anzeige von Fehlermeldungen": "Foutmeldingen weergeven",
  "Anzeige von 3D-Modellen": "3D-modellen weergeven",
  "Artikel zur Stückliste hinzufügen": "Item toevoegen aan stuklijst",
  "Ein oder mehrere Merkmal Spalten hinzufügen": "Enen of meerdere kenmerken kolommen toevoegen",
  "Ein oder mehrere Komponenten Spalten hinzufügen": "Enen of meerdere componenten kolommen toevoegen",
  "Ein oder mehrere Schritte hinzufügen": "Enen of meerdere stappen toevoegen",
  "Ein oder mehrere Artikel Spalten hinzufügen": "Enen of meerdere artikelen kolommen toevoegen",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen.": "Selecteer de kenmerken waaraan de artikelen moeten worden toegewezen.",
  Materialnamen: _nt,
  "Wählen Sie Materialnamen aus, worauf Bilder gedruckt werden sollen in Abhängigkeit von Bild Merkmalen.": "Selecteer materiaalnamen waarop afbeeldingen moeten worden afgedrukt, afhankelijk van afbeeldingskenmerken.",
  "Modell Eigenschaften anpassen": "Modeleigenschappen aanpassen",
  Labelaktion: $nt,
  Fehlermeldung: ert,
  "Merkmale entfernen": "Functies verwijderen",
  "Schritt entfernen": "Stap verwijderen",
  Modelaktion: trt,
  "Bitte fügen Sie neue Spalten hinzu.": "Voeg nieuwe kolommen toe.",
  "Sie brauchen mindestens eine Spalte.": "Je hebt minstens één kolom nodig.",
  "Nr.": "Nr.",
  "Gültigkeit prüfen": "Geldigheid controleren",
  "Keine Warnungen": "Geen waarschuwingen",
  "Alle Regeln ansehen": "Bekijk alle regels",
  Position: irt,
  "Rotation (in radiant)": "Rotatie (in radialen)",
  Scale: nrt,
  "Kein Label angegeben!": "Geen label gespecificeerd!",
  "Regel Validierung": "Regelvalidatie",
  "Fehlende Werte": "Ontbrekende waarden",
  "Zugeordnete Merkmale": "Toegewezen kenmerken",
  "Wählen Sie die Merkmale aus, denen die Artikel zugeordnet werden sollen": "Selecteer de kenmerken waaraan de artikelen moeten worden toegewezen",
  Komponentenmerkmale: rrt,
  "Wählen Sie Komponentenmerkmale aus.": "Selecteer componentfuncties.",
  "Oberflächenaktion hinzufügen": "Oppervlakte-actie toevoegen",
  "Alle auswählen": "Alles selecteren",
  "Alle abwählen": "Alles deselecteren",
  "Auswahl umkehren": "Selectie omkeren",
  Herunterladen: grt,
  "Jetzt verbinden": "Nu aansluiten",
  "Das flexible Shopsystem für Ihr E-Commerce-Projekt.": "Het flexibele winkelsysteem voor uw e-commerceproject.",
  "Jetzt Installieren": "Nu installeren",
  "Die globale Commerce-Plattform.": "Het wereldwijde e-commerceplatform.",
  "Die E-Commerce-Plattform für WordPress.": "Het e-commerceplatform voor WordPress.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Het enige Europese open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Nu Adobe Commerce: E-commerce gemakkelijk gemaakt.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Eersteklas digitale verkoop met de Oxid esales shop.",
  "Individuelle Entwicklung": "Individuele ontwikkeling",
  "Shop mit einer individuellen Entwicklung anbinden.": "Winkel met ontwikkeling op maat.",
  "Laden Sie zunächst eines unserer Plugins herunter und installieren Sie es in Ihrem Shop:": "Download eerst een van onze plugins en installeer deze in je shop:",
  "Verbinde Shop": "Winkel aansluiten",
  " und importiere Artikel": " en importartikelen",
  "Fehler beim Verbinden:": "Fout bij verbinden:",
  "Shop erfolgreich verbunden.": "Winkel succesvol aangesloten.",
  "Fehler beim Verbinden: ": "Fout bij verbinden: ",
  "Web-Adresse des Shops": "Webadres van de winkel",
  "Sollen die Artikel aus dem Shop importiert werden?": "Moeten de artikelen uit de winkel worden geïmporteerd?",
  "Filter für Artikel": "Filteren op artikelen",
  "Sollen die Artikel regelmäßig importiert werden?": "Moeten de artikelen regelmatig worden geïmporteerd?",
  "Soll die Artikelnummer der Shop-SKU entnommen werden?": "Moet het artikelnummer worden overgenomen van de winkel-SKU?",
  "Wenn Sie diese Einstellung ändern, wird der nächste Artikel-Import die Artikel duplizieren.": "Als u deze instelling wijzigt, zal de volgende artikelimport de artikelen dupliceren.",
  "Sollen die Artikel bei der Bestellung zusammengefasst werden?": "Moeten de artikelen bij het bestellen worden gegroepeerd?",
  "Basis-Name für kombinierte Artikel": "Basisnaam voor gecombineerde artikelen",
  "Ihre Bestellung {code}": "Jouw bestelling {code}",
  "Shop-Anbindung aufheben": "Winkelverbinding annuleren",
  "Fügen Sie den Konfigurator Ihrem Shop hinzu": "Voeg de configurator toe aan je winkel",
  Verbinden: ort,
  "Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.": "De HTML-inhoud kon niet worden weergegeven. Maak uw invoer schoon.",
  "Der eingegebe Wert ist nicht gültig: ": "De ingevoerde waarde is ongeldig: ",
  "Ungültiges HTML-Format": "Ongeldig HTML-formaat",
  "Sie können uns den Vorfall hier melden!": "Je kunt het incident hier aan ons melden!",
  "Das Template konnte nicht geladen werden.": "De sjabloon kon niet worden geladen.",
  "Templat auf Voreinstellung zurücksetzen": "Sjabloon terugzetten naar standaardinstelling",
  "Eingaben zurücksetzen": "Invoer opnieuw instellen",
  "Templat bearbeiten": "Sjabloon bewerken",
  "Templat Name": "Naam sjabloon",
  "Templat wählen": "Selecteer sjabloon",
  "Wählen Sie ein Standardtemplat aus, um dieses anzupassen. Oder vergeben Sie einen eigenen Namen, um ein indivuelles Templat vorzubereiten.": "Selecteer een standaardsjabloon om deze aan te passen. Of wijs je eigen naam toe om een aangepaste sjabloon te maken.",
  "Sie haben noch kein individuelles Templat erstellt. Fügen Sie eines hinzu, indem Sie ein Standardtemplat aus der Liste auswählen und dieses nach Ihren Wünschen anpassen.": "Je hebt nog geen aangepaste sjabloon gemaakt. Voeg er een toe door een standaardsjabloon uit de lijst te selecteren en deze naar wens aan te passen.",
  "Templat hinzufügen": "Sjabloon toevoegen",
  "Ansicht auswählen": "Weergave selecteren",
  "Datei hochladen": "Bestand uploaden",
  "Bitte buchen Sie zunächst ein anderes Produkt:": "Reserveer eerst een ander product:",
  "Bitte wählen": "Selecteer",
  "Diese Aktion verbindet mehrere Merkmale und kann daher hier nicht geändert werden. Ändern Sie dafür direkt die folgende(n) Regel(n):": "Deze actie combineert verschillende kenmerken en kan daarom hier niet worden gewijzigd. Wijzig hiervoor direct de volgende regel(s):",
  "Automatisch angelegt": "Automatisch aangemaakt",
  "Aktionen verknüpfen": "Link acties",
  "Werte von diesem Merkmal sollen folgende Aktionen auslösen:": "Waarden van dit kenmerk moeten de volgende acties triggeren:",
  "Dieses Merkmal kann nicht verwendet werden, um weitere Vorgänge zu steuern. Nutzen Sie dafür bitte direkt die Regeln.": "Deze functie kan niet worden gebruikt om andere processen te besturen. Gebruik hiervoor rechtstreeks de regels.",
  "Zu den Regeln": "Naar de regels",
  "Artikel bestellen": "Bestel artikel",
  "Abhängig von der Auswahl werden verschiedene Artikel zur Stückliste hinzugefügt.": "Afhankelijk van de selectie worden er verschillende items toegevoegd aan de stuklijst.",
  "Oberfläche ändern": "Verander oppervlak",
  "Welche Oberflächen sollen geändert werden? ": "Welke oppervlakken moeten worden vervangen? ",
  "3D-Modell anzeigen": "3D-model weergeven",
  "Abhängig von der Auswahl werden verschiedene 3D-Modelle angezeigt.": "Afhankelijk van de selectie worden verschillende 3D-modellen weergegeven.",
  "Bild anzeigen": "Afbeelding tonen",
  "Abhängig von der Auswahl werden verschiedene Bilder angezeigt.": "Afhankelijk van de selectie worden verschillende afbeeldingen weergegeven.",
  "Farbe ändern": "Kleur veranderen",
  "Welche Oberflächen sollen eingefärbt werden? ": "Welke oppervlakken moeten worden gekleurd? ",
  "Bild aufdrucken": "Afbeelding afdrukken",
  "Auf welchen Oberflächen soll das hochgeladene Bild aufgedruckt werden? ": "Op welke oppervlakken moet de geüploade afbeelding worden afgedrukt? ",
  "Der Wert wird noch in Regeln verwendet:": "De waarde wordt nog steeds gebruikt in regels:",
  "Löschen Sie bitte zunächst dort die entsprechende(n) Zeile(n).": "Verwijder daar eerst de bijbehorende regel(s).",
  "Hier können Sie einstellen, was angezeigt werden soll, wenn noch kein Wert gewählt wurde": "Hier kun je instellen wat er moet worden weergegeven als er nog geen waarde is geselecteerd",
  "Dieser Wert ist nicht erlaubt.": "Deze waarde is niet toegestaan.",
  "Maximale Anzahl an Werten ist erreicht.": "Het maximum aantal waarden is bereikt.",
  Farbwert: lrt,
  Anzeige: art,
  RAL: srt,
  "keine RAL Farbe": "Geen RAL-kleur",
  Ansicht: Irt,
  "Key eingeben": "Enter toets",
  URL: crt,
  "Info-Modal": "Info-Modaal",
  "Info-Content": "Info-inhoud",
  "Dieser Merkmalstyp unterstützt keine Werte.": "Dit kenmerktype ondersteunt geen waarden.",
  "Fehlende RAL Farben hinzufügen": "Ontbrekende RAL-kleuren toevoegen",
  Auswahlwerte: drt,
  "Typ des Merkmals": "Type kenmerk",
  "Merkmal {{label}} nicht gefunden!": "Kenmerk {{label}} niet gevonden!",
  "Attribut {{label}} nicht gefunden!": "Attribuut {{label}} niet gevonden!",
  "Syntaxfehler in der Expression!": "Syntaxfout in de expressie!",
  "es gibt keine Merkmale mit {{identificator}}": "er zijn geen functies met {{identificator}}",
  "es gibt kein Attribut mit {{identificator}}": "Er is geen attribuut met {{identificator}}",
  "es gibt keine Selection mit {{identificator}}": "er is geen selectie met {{identificator}}",
  "es gibt mehr als eine Selection mit {{identificator}}": "Er is meer dan één selectie met {{identificator}}",
  "Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}": "Er zit een cyclus in de berekende karakteristieken: {{cycleText}}",
  "das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}": "het resultaat van de formule een numerieke waarde moet zijn, is het in plaats daarvan {{type}}",
  "Wert {{paramName}} der Funktion {{functionName}} ist null": "waarde {{paramName}} van de functie {{functionName}} nul is",
  "Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen": "De eigenschap {{variableLabel}} is een componentenlijst. Je moet het benaderen met een index zoals {{variableLabel2}}[0] voor het 1e element of met een arrayfunctie zoals map(), find(), reduce() of first()",
  "Es gibt einen Zyklus in den berechneten Merkmalen.": "Er zit een cyclus in de berekende kenmerken.",
  Übersicht: "Rekening-courant",
  Auswahlpreise: urt,
  Auswahl: Crt,
  Gesamtpreis: Art,
  "Preis Information": "Prijsinformatie",
  "Persönliche Daten": "Persoonlijke gegevens",
  "Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise": "Vul alle verplichte velden correct in en accepteer de informatie over gegevensbescherming",
  "Bestätigen-Hinweistext bei invalidem Kontaktformular": "Hinttekst voor ongeldig contactformulier bevestigen",
  Weiter: brt,
  "Sie verwenden eine veraltete Version des Konfigurators.": "U gebruikt een verouderde versie van de configurator.",
  "Bestell-Warnhinweis bei veralteter Version": "Bestelwaarschuwing voor verouderde versie",
  "In AR ansehen": "Bekijk in AR",
  Vollbildmodus: hrt,
  "Komponenten suchen": "Zoeken naar onderdelen",
  "Nicht Gruppiert": "Niet gegroepeerd",
  Komponenten: mrt,
  "Komponenten hinzufügen": "Componenten toevoegen",
  xl: prt,
  "Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ": "De factuur was echter niet mogelijk en is teruggezet naar de eerst beschikbare optie: ",
  "Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:": "Deze waarde kan niet worden gecombineerd met de volgende selecties:",
  "Bei Auswahl wird eine Alternative berechnet!": "Indien geselecteerd, wordt een alternatief berekend!",
  Bestätigen: "Bevestig",
  "Produkt hinzufügen": "Product toevoegen",
  "Produkt erfolgreich konfiguriert": "Product succesvol geconfigureerd",
  "Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?": "De configuratie is voltooid. Welk product wil je als volgt toevoegen aan het winkelmandje?",
  "Neues Produkt auswählen": "Een nieuw product kiezen",
  "Neues Produkt hinzufügen": "Een nieuw product toevoegen",
  'Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.': 'De selectie "{{value}}" ({{variable}}) leidt tot de ongeldige waarde "{{conflictValue0}}" ({{conflictVariable0}}) en wordt daarom gereset.',
  "Meldung bei Zurücksetzen einer ungültigen Auswahl": "Bericht bij het resetten van een ongeldige selectie",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}).',
  "Meldung bei Auftreten eines Konflikts": "Kennisgeving in geval van een conflict",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}) en de selectie "{{conflictValue1}}" ({{conflictVariable1}}).',
  "Meldung bei Auftreten von zwei Konflikten": "Bericht wanneer twee conflicten voorkomen",
  "Meldung bei Auftreten von drei oder mehr Konflikten": "Kennisgeving bij drie of meer conflicten",
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).': 'De selectie "{{value}}" ({{variable}}) komt niet overeen met de selectie "{{conflictValue0}}" ({{conflictVariable0}}), de selectie "{{conflictValue1}}" ({{conflictVariable1}}) en de selectie "{{conflictValue2}}" ({{conflictVariable2}}).',
  'Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.': 'De selectie "{{value}}" ({{variable}}) interfereert niet met andere selecties.',
  Konfliktmeldung: Brt,
  "Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen.": "Deze selectie kan eerdere selecties ongedaan maken.",
  "Anpassung nötig": "Aanpassing",
  "Stattdessen werden folgende Auswahlen angepasst:": "In plaats daarvan worden de volgende selecties aangepast:",
  "wird zu": "wordt",
  "wird entfernt": "zal worden verwijderd",
  "Optionaler weiterer Hinweistext:": "Optionele tekst voor extra informatie:",
  "Auf Facebook teilen": "Deel op Facebook",
  "Auf Twitter teilen": "Deel op Twitter",
  "Auf LinkedIn teilen": "Deel op LinkedIn",
  "Modal Titel": "Modale titel",
  "Desktop Gerät erkannt": "Desktopapparaat herkend",
  "Modal Text": "Modale tekst",
  "Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:": "Augmented reality is momenteel alleen beschikbaar op de nieuwste iOS- of AndroidOS-smartphones. Scan gewoon deze QR-code met de camera-app op je smartphone:",
  "Mobiles {{device}}-Gerät erkannt": "Mobiel {{device}} apparaat herkend",
  "Fortschrittsanzeige 3D-Objekt": "Voortgangsindicator 3D-object",
  "Export des 3D-Objekts": "Exporteren van het 3D-object",
  "Fortschrittsanzeige AR-Datei": "Fortschrittsanzeige AR-Datei",
  "Bereitstellen der AR-Datei": "Het AR-bestand aanleveren",
  "Fortschrittsanzeige System": "Systeem voor voortgangsindicatoren",
  "{{device}}-AR-System einrichten": "{{apparaat}}-AR systeem instellen",
  Positionszeile: frt,
  "Pos.": "Pos.",
  "Artikelnummer Spalte": "Artikelnummer Kolom",
  "Artikel Spalte": "Artikel Kolom",
  "Artikelpreis Spalte": "Artikel prijs kolom",
  "Artikelmenge Spalte": "Kolom aantal items",
  Menge: Zrt,
  "Artikelanzahl Spalte": "Aantal items Kolom",
  "Positionspreis Spalte": "Item prijs kolom",
  Positionspreis: Grt,
  "Hilfetext Preisdetails": "Help-tekst Prijsinformatie",
  "Preisdetails anzeigen": "Toon prijsdetails",
  "Titel bei Versions-Konflikt": "Titel bij versieconflict",
  "Konfigurator wurde aktualisiert": "Configurator is bijgewerkt",
  "Text bei Versions-Konflikt": "Tekst bij versieconflict",
  "Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?": "De configurator is verder ontwikkeld sinds je deze configuratie hebt opgeslagen. Wil je de huidige versie gebruiken en verder werken of alleen de oude versie openen om te bekijken?",
  "Hilfetext Auswahl Ändern": "Hilfetext Auswahl Ändern",
  "Merkmal ändern": "Merkmal ändern",
  "Hilfetext Auswahl Entfernen": "Hilfetext Auswahl Entfernen",
  "Auswahl entfernen": "Auswahl entfernen",
  "Alte Version": "Oude versie",
  "Aktuelle Version": "Huidige versie",
  "Zeige Namen": "Namen tonen",
  "Zeige Beschreibung": "Beschrijving tonen",
  "Zeige Thumbnail": "Toon miniatuur",
  "Zeige Preis an Merkmal": "Toon prijs op functie",
  "Zeige Preise an Werten": "Toon prijzen bij waarden",
  "Zeige URL": "URL tonen",
  "Zeige Info-Button für Werte": "Infoknop tonen voor waarden",
  "Zeige HTML Content für Werte": "Toon HTML-inhoud voor waarden",
  "Kamerafahrt beim scrollen": "Camerabeweging tijdens scrollen",
  "Alle ungültigen Werte ausblenden": "Alle ongeldige waarden verbergen",
  "Ungültige, aktiv geänderte, Werte ausblenden": "Verberg ongeldige, actief gewijzigde waarden",
  "Ausblenden wenn nur eine Auswahl möglich ist": "Verberg als er maar één selectie mogelijk is",
  "Deaktivieren wenn nur eine Auswahl möglich ist": "Deactiveren als slechts één selectie mogelijk is",
  "Komponente hervorheben": "Component benadrukken",
  Bild: yrt,
  "Ja/ Nein": "Ja/ Nee",
  Information: Wrt,
  Mehrfachauswahl: Srt,
  Liste: Vrt,
  Eckenrundung: wrt,
  "Anzahl der Eckenrundungsschritte": "Anzahl der Eckenrundungsschritte",
  "Dieses Material existiert bereits": "Dit materiaal bestaat al",
  "Material hinzufügen": "Materiaal toevoegen",
  "Materialname eingeben": "Voer materiaalnaam in",
  Abmessungen: vrt,
  Breite: Rrt,
  Höhe: "Hoogte",
  Tiefe: Xrt,
  Operation: Hrt,
  Segmente: krt,
  Pfad: Yrt,
  Startpunkt: Frt,
  Endpunkt: xrt,
  Linienstärke: "Lijndikte",
  Startanker: Drt,
  Maßkette: "Maatketen",
  Ohne: Jrt,
  Endanker: Ert,
  Texttyp: Nrt,
  "Kein Text": "Geen tekst",
  Zahlenwert: Lrt,
  "Statischer Text": "Statische tekst",
  "Automatisches Maß überschreiben": "Automatische dimensie overschrijven",
  "Neues Maß": "Nieuwe dimensie",
  "Textgröße als Faktor. 1 ist Standard.": "Tekstgrootte als factor. 1 is standaard.",
  Offsets: Krt,
  "Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.": "Afwijkingen in positie en rotatie, die normaal gesproken het gevolg zijn van het begin- en eindpunt, kunnen hier worden gedefinieerd. Hiervoor kan het 3D positioneringsgereedschap worden gebruikt.",
  Blau: Trt,
  Grün: "Groen",
  Gelb: Mrt,
  Rot: Prt,
  Purpur: Urt,
  "Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen.": "Maximum aantal iteraties voor de expressie engine bereikt! Er zijn te complexe cycli in de berekende kenmerken.",
  "Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden.": "Maximum aantal iteraties bereikt! De regelconflicten kunnen niet worden opgelost.",
  "Nicht Befüllt": "Niet gevuld",
  Abkhazian: zrt,
  Afar: Ort,
  Afrikaans: Qrt,
  Akan: jrt,
  Albanian: qrt,
  Amharic: _rt,
  Arabic: $rt,
  Aragonese: egt,
  Armenian: tgt,
  Assamese: igt,
  Avaric: ngt,
  Avestan: rgt,
  Aymara: ggt,
  Azerbaijani: ogt,
  Bambara: lgt,
  Bashkir: agt,
  Basque: sgt,
  Belarusian: Igt,
  Bengali: cgt,
  Bislama: dgt,
  Bosnian: ugt,
  Breton: Cgt,
  Bulgarian: Agt,
  Burmese: bgt,
  "Catalan, Valencian": "Catalaans, Valenciaans",
  Chamorro: hgt,
  Chechen: mgt,
  "Chichewa, Chewa, Nyanja": "Chichewa, Chewa, Nyanja",
  Chinese: pgt,
  "Church Slavonic, Old Slavonic, Old Church Slavonic": "Kerkslavisch, Oudslavisch, Oudkerkslavisch",
  Chuvash: Bgt,
  Cornish: fgt,
  Corsican: Zgt,
  Cree: Ggt,
  Croatian: ygt,
  Czech: Wgt,
  Danish: Sgt,
  "Divehi, Dhivehi, Maldivian": "Divehi, Dhivehi, Maldivisch",
  "Dutch, Flemish": "Nederlands, Vlaams",
  Dzongkha: Vgt,
  English: wgt,
  Esperanto: vgt,
  Estonian: Rgt,
  Ewe: Xgt,
  Faroese: Hgt,
  Fijian: kgt,
  Finnish: Ygt,
  French: Fgt,
  "Western Frisian": "West-Fries",
  Fulah: xgt,
  "Gaelic, Scottish Gaelic": "Gaelisch, Schots Gaelisch",
  Galician: Dgt,
  Ganda: Jgt,
  Georgian: Egt,
  German: Ngt,
  "Greek, Modern (1453-)": "Grieks, Modern (1453-)",
  "Kalaallisut, Greenlandic": "Kalaallisut, Groenlands",
  Guarani: Lgt,
  Gujarati: Kgt,
  "Haitian, Haitian Creole": "Haïtiaans, Haïtiaans Creools",
  Hausa: Tgt,
  Hebrew: Mgt,
  Herero: Pgt,
  Hindi: Ugt,
  "Hiri Motu": "Hiri Motu",
  Hungarian: zgt,
  Icelandic: Ogt,
  Ido: Qgt,
  Igbo: jgt,
  Indonesian: qgt,
  "Interlingua (International Auxiliary Language Association)": "Interlingua (Internationale Hulptaalvereniging)",
  "Interlingue, Occidental": "Interlingue, Occidental",
  Inuktitut: _gt,
  Inupiaq: $gt,
  Irish: eot,
  Italian: tot,
  Japanese: iot,
  Javanese: not,
  Kannada: rot,
  Kanuri: got,
  Kashmiri: oot,
  Kazakh: lot,
  "Central Khmer": "Centraal Khmer",
  "Kikuyu, Gikuyu": "Kikuyu, Gikuyu",
  Kinyarwanda: aot,
  "Kirghiz, Kyrgyz": "Kirgizisch, Kirgizisch",
  Komi: sot,
  Kongo: Iot,
  Korean: cot,
  "Kuanyama, Kwanyama": "Kuanyama, Kwanyama",
  Kurdish: dot,
  Lao: uot,
  Latin: Cot,
  Latvian: Aot,
  "Limburgan, Limburger, Limburgish": "Limburgs",
  Lingala: bot,
  Lithuanian: hot,
  "Luba-Katanga": "Luba-Katanga",
  "Luxembourgish, Letzeburgesch": "Luxemburgs, Letzeburgesch",
  Macedonian: mot,
  Malagasy: pot,
  Malay: Bot,
  Malayalam: fot,
  Maltese: Zot,
  Manx: Got,
  Maori: yot,
  Marathi: Wot,
  Marshallese: Sot,
  Mongolian: Vot,
  Nauru: wot,
  "Navajo, Navaho": "Navajo, Navaho",
  "North Ndebele": "Noord-Ndebele",
  "South Ndebele": "Zuid-Ndebele",
  Ndonga: vot,
  Nepali: Rot,
  Norwegian: Xot,
  "Norwegian Bokmål": "Noors Bokmål",
  "Norwegian Nynorsk": "Noors Nynorsk",
  "Sichuan Yi, Nuosu": "Sichuan Yi, Nuosu",
  Occitan: Hot,
  Ojibwa: kot,
  Oriya: Yot,
  Oromo: Fot,
  "Ossetian, Ossetic": "Ossetisch",
  Pali: xot,
  "Pashto, Pushto": "Pasjtoe, Pusjtoe",
  Persian: Dot,
  Polish: Jot,
  Portuguese: Eot,
  "Punjabi, Panjabi": "Punjabi, Panjabi",
  Quechua: Not,
  "Romanian, Moldavian, Moldovan": "Roemeens, Moldavisch, Moldavisch",
  Romansh: Lot,
  Rundi: Kot,
  Russian: Tot,
  "Northern Sami": "Noord-Samisch",
  Samoan: Mot,
  Sango: Pot,
  Sanskrit: Uot,
  Sardinian: zot,
  Serbian: Oot,
  Shona: Qot,
  Sindhi: jot,
  "Sinhala, Sinhalese": "Singalees",
  Slovak: qot,
  Slovenian: _ot,
  Somali: $ot,
  "Southern Sotho": "Zuid-Sotho",
  "Spanish, Castilian": "Spaans, Castiliaans",
  Sundanese: elt,
  Swahili: tlt,
  Swati: ilt,
  Swedish: nlt,
  Tagalog: rlt,
  Tahitian: glt,
  Tajik: olt,
  Tamil: llt,
  Tatar: alt,
  Telugu: slt,
  Thai: Ilt,
  Tibetan: clt,
  Tigrinya: dlt,
  "Tonga (Tonga Islands)": "Tonga (Tonga-eilanden)",
  Tsonga: ult,
  Tswana: Clt,
  Turkish: Alt,
  Turkmen: blt,
  Twi: hlt,
  "Uighur, Uyghur": "Oeigoers",
  Ukrainian: mlt,
  Urdu: plt,
  Uzbek: Blt,
  Venda: flt,
  Vietnamese: Zlt,
  Volapük: "Volapük",
  Walloon: Glt,
  Welsh: ylt,
  Wolof: Wlt,
  Xhosa: Slt,
  Yiddish: Vlt,
  Yoruba: wlt,
  "Zhuang, Chuang": "Zhuang, Chuang",
  Zulu: vlt
}, Xlt = "Lijst", Hlt = "Kleuren", klt = "Tekst", Ylt = "Ja/ Nee", Flt = "Informatie", xlt = "Afbeelding", Dlt = "Onderdelen", Jlt = "Vertegenwoordiging", Elt = "Acties", Nlt = "Waarden", Llt = "Regels", Klt = "Opties", Tlt = "Foto's", Mlt = "Configurators", Plt = "Straat", Ult = "Postcode", zlt = "Stad", Olt = "Land", Qlt = "Uittreksel", jlt = "Telefoon", qlt = "Gebruikersnaam", _lt = "MATERIAAL", $lt = "Importeren", eat = "Handmatig", tat = "Rotatie", iat = "Algemene informatie", nat = "Kenmerken", rat = "Ruwheid", gat = "Metallness", oat = "Stapel foto's", lat = "Scène-instellingen", aat = "Thema's", sat = "Aanpassing", Iat = "Waardebereik", cat = "Vertegenwoordiging", dat = "Waarden", uat = "Vragen", Cat = "Timing", Aat = "Aanvraag", bat = "URI", hat = "Parameters", mat = "Duur", pat = "Server", Bat = "Hoeveelheid", fat = "Artikel", Zat = "Modus Volledig scherm", Gat = {
  always: "Altijd",
  never: "Nooit",
  auto: "Zoals in de configurator",
  label: "Weergave in bevestiging, PDF en winkel"
}, yat = "Activeer", Wat = "Deactiveer", Sat = "Artikelen", Vat = "Alleen functies", wat = "Alleen artikel", vat = "Geen overzicht", Rat = "Algemeen", Xat = "PDF", Hat = "Mail", kat = "inbedden", Yat = "Winkel op", Fat = "Artikel", xat = "Voorbeeld", Dat = "Redacteur", Jat = "Foto's", Eat = "Materialen", Nat = "Modellen", Lat = "Regels", Kat = "Opties", Tat = "Admin", Mat = "extract", Pat = "Configurators", Uat = "Maak", zat = "Importeren", Oat = "Gebruikers", Qat = "Ondersteuning", jat = "Logboeken", qat = "Systeemstatus", _at = "Prullenmand", $at = "Abonnement", est = "Verlopen", tst = "Profiel", ist = "Redacteur", nst = "Configuraties", rst = "Ruiter", gst = "Kenmerken", ost = "Ontwerp", lst = "Scène", ast = "Vertegenwoordiging", sst = "Opties", Ist = "Acties", cst = "Waarden", dst = "hoofdkleur", ust = "Secundaire kleur", Cst = "Achtergrondkleur", Ast = "Waarschuwingskleur", bst = "Standaard", hst = "Heller", mst = "Donkerder", pst = "Uitgelicht", Bst = "Standaard", fst = "Grijs", Zst = "CTRL", Gst = "Vervangen", yst = "Bestel", Wst = "Duitsland", Sst = "Zwitserland", Vst = "Andorra", wst = "België", vst = "Wit-Rusland", Rst = "Bulgarije", Xst = "Tsjechië", Hst = "Vaticaanstad", kst = "Montenegro", Yst = "Estland", Fst = "Spanje", xst = "Frankrijk", Dst = "Guernsey", Jst = "Kroatië", Est = "Ierland", Nst = "IJsland", Lst = "Italië", Kst = "Jersey", Tst = "Albanië", Mst = "Kosovo", Pst = "Letland", Ust = "Litouwen", zst = "Luxemburg", Ost = "Hongarije", Qst = "Monaco", jst = "Nederland", qst = "Noorwegen", _st = "Polen", $st = "Portugal", eIt = "Kasachstan", tIt = "Malta", iIt = "Moldavië", nIt = "Rusland", rIt = "Slovenië", gIt = "Slowakije", oIt = "Servië", lIt = "Finland", aIt = "Zweden", sIt = "Oekraïne", IIt = "Cyprus", cIt = "Griekenland", dIt = "Noord-Macedonië", uIt = {
  list: Xlt,
  color: Hlt,
  text: klt,
  boolean: Ylt,
  information: Flt,
  image: xlt,
  components: Dlt,
  presentation: Jlt,
  usage: Elt,
  values: Nlt,
  rules: Llt,
  settings: Klt,
  images: Tlt,
  configurators: Mlt,
  street: Plt,
  zip: Ult,
  city: zlt,
  country: Olt,
  extract: Qlt,
  phone: jlt,
  username: qlt,
  "duplicate-entry": "Accounts met deze gegevens bestaan al",
  "create new dealer": "Nieuwe verkoper maken",
  "Artikel Anzahl": "Artikel Aantal",
  "Farb auswählen": "Selecteer kleur",
  "< Zurück": "< Terug",
  "Merkmal auswählen": "Functie selecteren",
  MATERIAL: _lt,
  Import: $lt,
  "Materialien für den Import auswählen:": "Selecteer materialen om te importeren:",
  "Wie möchten Sie ein Material erstellen?": "Hoe wil je materiaal maken?",
  "Import einer .glb und export der enthaltenen Materialien": "Een .glb importeren en de materialen exporteren",
  Manuell: eat,
  "Eigenständiges Anlegen eines PBR-Materials": "Onafhankelijk aanmaken van een PBR-materiaal",
  "Löschen Sie bitte zunächst dort die entsprechende Spalte.": "Verwijder daar eerst de bijbehorende kolom.",
  "Design & Layout": "Ontwerp en lay-out",
  "Nur sichtbar im Vorschaumodus oder veröffentlichtem Konfigurator!": "Alleen zichtbaar in voorbeeldmodus of gepubliceerde configurator!",
  "Theme wählen": "Selecteer thema",
  "Komponente löschen": "Component verwijderen",
  "Mehrfach Regelzeilen Bearbeitung": "Meerdere regels bewerken",
  "Anzahl ausgewählte Regel-Zeilen:": "Aantal geselecteerde regels:",
  "Modelaktions-Positionierung": "Actie positioneren modelleren",
  Rotation: tat,
  "Keine Aktionen für die Mehrfachbearbeitung vorhanden.": "Geen acties beschikbaar voor meervoudige verwerking.",
  Allgemeines: iat,
  "Farben und Lichtinteraktion": "Kleuren en lichtinteractie",
  "Color-Map Upload": "Kleurkaart uploaden",
  "Material interagiert mit Licht in der Szene": "Materiaal interageert met licht in de scène",
  Beschaffenheit: nat,
  "Roughness-Map Upload": "Ruwheidskaart uploaden",
  Roughness: rat,
  "Metallness-Map Upload": "Metallness-kaart uploaden",
  Metallness: gat,
  "Normalen-Map Upload": "Normale kaart uploaden",
  "Normalen-Skalierung": "Normaal schalen",
  "Anwendung auf 3D-Modell": "Toepassing op 3D-model",
  "Displacement-Map Upload": "Verplaatsingskaart uploaden",
  "Displacement-Skalierung": "Verplaatsingsschaal",
  "Repeat-Faktor der Textur in X- und Y-Richtung": "Herhalingsfactor van de textuur in X- en Y-richting",
  "Alpha-Werte": "Alfa-waarden",
  "Alpha-Map Upload": "Alpha-kaart uploaden",
  "Ambient Occlusion": "Omgevingsverloop",
  "Ambient-Occlusion-Map Upload": "Omgeving-Occlusie-Kaart uploaden",
  "Info editieren": "Info bewerken",
  "Zeige Info-Button": "Toon info knop",
  Abhängigkeitsschleifen: "Lussen van afhankelijkheid",
  Bilderstapel: oat,
  "Google Analytics Property ID": "Google Analytics-eigendom-ID",
  "Sans Serif": "schreefloos",
  "Das flexibles Shopsystem für Ihr E-Commerce-Projekt.": "Het flexibele shopsysteem voor je e-commerce project.",
  "Die eine europäische Open-Source-E-Commerce-Plattform. ": "Het enige Europese open source e-commerce platform. ",
  "Jetzt Adobe Commerce: E-Commerce leicht gemacht.": "Nu Adobe Commerce: E-commerce gemakkelijk gemaakt.",
  "Erstklassig im digitalen Vertrieb mit dem Oxid esales Shop.": "Eersteklas digitale verkoop met de Oxid esales shop.",
  "Individuelle Entwicklung": "Individuele ontwikkeling",
  "Shop mit einer individuellen Entwicklung anbinden.": "Winkel met ontwikkeling op maat.",
  Szeneneinstellungen: lat,
  Themes: aat,
  Anpassung: sat,
  "Gewähltes Theme übernehmen": "Kies een thema",
  "Legen Sie einen neuen Konfigurationsschritt an.": "Maak een nieuwe configuratiestap.",
  "Eine Konfiguration erfolgt in mehreren Schritten. In jedem Schritt können ggf. mehrere Produkt-Eigenschaften angegeben werden. Hier legen Sie den ersten Schritt an.": "Configuratie vindt plaats in verschillende stappen. In elke stap kunnen verschillende producteigenschappen worden opgegeven. Maak hier de eerste stap.",
  "Konfigurationsschritt erstellen": "Configuratiestap maken",
  "Bitte klicken Sie zunächst hier, um einen neuen Konfigurator zu erstellen.": "Klik eerst hier om een nieuwe configurator te maken.",
  "Neuer Konfigurator wählen": "Selecteer nieuwe configurator",
  "Bitte geben Sie einen Namen ein.": "Voer een naam in.",
  "Bitte geben Sie eine Beschreibung ein.": "Voer een beschrijving in.",
  "Bitte klicken Sie hier.": "Klik hier.",
  "Konfigurator Dialog aufrufen": "Dialoog configurator oproepen",
  "Konfigurationsschritt benennen": "Naam configuratiestap",
  "Hier können Sie neue Werte hinzufügen.": "Je kunt hier nieuwe waarden toevoegen.",
  "Merkmale, die eine Liste (oder Farbe, Material, Modell) sind, zeigen mehrere Werte zur Auwahl an. Diese Werte können Sie hier eingeben.": "Kenmerken die een lijst zijn (of kleur, materiaal, model) geven verschillende waarden weer voor selectie. Je kunt deze waarden hier invoeren.",
  "Klicken Sie hier um einen neuen Wert zu erstellen.": "Klik hier om een nieuwe waarde te creëren.",
  "Wenn Sie fertig sind klicken Sie hier.": "Klik hier als je klaar bent.",
  "Werte erstellen": "Waarden creëren",
  "Bitte geben Sie einen Namen für das neue Merkmal ein.": "Voer een naam in voor de nieuwe functie.",
  "Bitte wählen Sie eine Darstellung, die den Möglichkeiten des Merkmals entspricht.": "Selecteer een weergave die overeenkomt met de mogelijkheden van de functie.",
  "Präsentation definieren": "Presentatie definiëren",
  "In einem Schritt kann Ihr Kunde mehrere Merkmale seines Produktes anpassen. Fügen Sie hier das erste Merkmal ein.": "Je klant kan in één stap verschillende functies van zijn product aanpassen. Voer hier de eerste functie in.",
  "Produktmerkmal erstellen": "Productkenmerk maken",
  "Was für ein Merkmal wollen Sie anlegen?": "Welk kenmerk wil je creëren?",
  "Ein Merkmal kann eine Auswahl sein (z.B. die Größen S, M, L und XL), ein Text oder eine Zahl (z.B. für eine Breite oder Höhe) oder auch eine Farbe oder Material Ihres Produktes oder ein 3D-Modell, dass einen Teil Ihres Produktes darstellt.": "Een kenmerk kan een selectie zijn (bijvoorbeeld de maten S, M, L en XL), een tekst of een getal (bijvoorbeeld voor een breedte of hoogte) of zelfs een kleur of materiaal van je product of een 3D-model dat een onderdeel van je product voorstelt.",
  "Produktmerkmaltyp auswählen": "Selecteer type productkenmerk",
  "Wählen sie den eben erstellten Konfigurator.": "Selecteer de configurator die je zojuist hebt gemaakt.",
  "Steuerung des Konfigurators durch das neue Merkmal.": "Bediening van de configurator met de nieuwe functie.",
  "Merkmale können z.B. dafür sorgen, dass 3D-Modelle oder Bilder angezeigt werden oder das Oberflächen geändert oder eingefärbt werden. Sie können auch eine Stückliste von Artikel erzeugen, die dann den Preis bestimmt und in den Warenkorb Ihres Shops gelegt werden kann.": "Functies kunnen er bijvoorbeeld voor zorgen dat 3D-modellen of afbeeldingen worden weergegeven of dat oppervlakken worden veranderd of gekleurd. Je kunt ook een onderdelenlijst van artikelen maken, die vervolgens de prijs bepaalt en in het winkelmandje van je winkel geplaatst kan worden.",
  "Merkmal verwenden": "Functie gebruiken",
  Wertebereich: Iat,
  Darstellung: cat,
  Werte: dat,
  Anfragen: uat,
  Zeitpunkt: Cat,
  Anfrage: Aat,
  URI: bat,
  Parameter: hat,
  Dauer: mat,
  Server: pat,
  "Modell bearbeiten": "Model bewerken",
  "Korrekte Mail-Adresse": "Juist e-mailadres",
  "Statistik (30 Tage)": "Statistieken (30 dagen)",
  amount: Bat,
  article: fat,
  "Datum eingeben": "Datum invoeren",
  "Nach hause ": "Home ",
  "Mandant anlegen": "Klant maken",
  "Nutzer hinzufügen": "Gebruiker toevoegen",
  Fullscreen: Zat,
  showSelection: Gat,
  "Kamera überschreiben": "Camera overschrijven",
  Aktivieren: yat,
  Deaktivieren: Wat,
  Übersichtsseite: "Overzichtspagina",
  variablesAndArticles: Sat,
  variablesOnly: Vat,
  articlesOnly: wat,
  noOverview: vat,
  breadcrumb_app: Rat,
  breadcrumb_pdf: Xat,
  breadcrumb_mail: Hat,
  breadcrumb_embed: kat,
  breadcrumb_shop: Yat,
  breadcrumb_articles: Fat,
  breadcrumb_preview: xat,
  breadcrumb_edit: Dat,
  breadcrumb_images: Jat,
  breadcrumb_materials: Eat,
  breadcrumb_models: Nat,
  breadcrumb_rules: Lat,
  breadcrumb_settings: Kat,
  breadcrumb_admin: Tat,
  breadcrumb_extract: Mat,
  breadcrumb_apps: Pat,
  breadcrumb_create: Uat,
  breadcrumb_import: zat,
  breadcrumb_users: Oat,
  breadcrumb_support: Qat,
  breadcrumb_logs: jat,
  breadcrumb_systemStatus: qat,
  breadcrumb_trash: _at,
  breadcrumb_abonnement: $at,
  breadcrumb_expired: est,
  breadcrumb_profile: tst,
  breadcrumb_configurator: ist,
  breadcrumb_configurations: nst,
  breadcrumb_groups: rst,
  breadcrumb_variables: gst,
  breadcrumb_design: ost,
  breadcrumb_scene: lst,
  breadcrumb_presentation: ast,
  breadcrumb_options: sst,
  breadcrumb_usage: Ist,
  breadcrumb_values: cst,
  Primary: dst,
  Secondary: ust,
  Background: Cst,
  Warning: Ast,
  Error: "Foutkleur",
  Main: bst,
  Light: hst,
  Dark: mst,
  "Contrast Text": "(Contast) tekstkleur",
  Paper: pst,
  Default: Bst,
  Disabled: fst,
  "Content Main": "Achtergrondkleur canvas",
  "Scrollbar Default": "Kleur schuifbalk",
  "Letzter Schritt kann nicht gelöscht werden.": "Laatste groep kan niet worden verwijderd.",
  "Dieses Merkmal ist versteckt.": "Deze functie is verborgen.",
  "Dieses Merkmal ist nur im Admin-Panel sichtbar. Das kann mehrere Ursachen haben: \n 1. Es wurde per Regel ausgeblendet. \n 2. Der zugehörige Schritt wurde entfernt.": `Deze functie is alleen zichtbaar in het beheerpaneel. Dit kan verschillende oorzaken hebben: 
 1. het was verborgen door een regel. 
 2. de bijbehorende stap is verwijderd.`,
  "Dieses Merkmal ist nur im Admin-Panel sichtbar : Das Merkmal besitzt keine Auswahloptionen.": "Deze functie is alleen zichtbaar in het beheerderspaneel: De functie heeft geen selectieopties.",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es keine valide Auswahl hat!": "Dit kenmerk is niet langer zichtbaar omdat het geen geldige selectie heeft!",
  "Dieses Merkmal ist nicht mehr sichtbar, weil es nur eine valide Auswahl hat!": "Dit kenmerk is niet langer zichtbaar omdat het slechts één geldige selectie heeft!",
  "Vertikale Platzierung zulassen?": "Verticale plaatsing toestaan?",
  "Suchfeld ausblenden?": "Zoekveld verbergen?",
  Modalgröße: "Modale grootte",
  "Anzahl an Komponenten pro Zeile": "Aantal componenten per regel",
  "Weitere Preisauswirkungen dieser Selektion": "Verdere prijseffecten van deze selectie",
  "Aktion verstecken": "Actie verbergen",
  Ctrl: Zst,
  Ersetzen: Gst,
  "Bild hochladen": "Afbeelding uploaden",
  "Das Dateiformat ist nicht erlaubt!": "Het bestandsformaat is niet toegestaan!",
  Bestellen: yst,
  "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie.": "Ik heb de informatie over gegevensbescherming gelezen en accepteer deze.",
  "Straße und Hausnummer": "Straat en huisnummer",
  "UST-ID": "Omzetbelasting identificatienummer",
  Deutschland: Wst,
  Österreich: "Oostenrijk",
  Schweiz: Sst,
  "Åland Inseln": "Åland-eilanden",
  Andorra: Vst,
  Belgien: wst,
  Belarus: vst,
  "Bosnien und Herzegowina": "Bosnië en Herzegovina",
  Bulgarien: Rst,
  Tschechien: Xst,
  Vatikanstadt: Hst,
  Montenegro: kst,
  Dänemark: "Denemarken",
  Estland: Yst,
  Spanien: Fst,
  Färöer: "Faeröer",
  Frankreich: xst,
  Guernsey: Dst,
  Kroatien: Jst,
  Irland: Est,
  Island: Nst,
  "Isle of Man": "Eiland Man",
  Italien: Lst,
  Jersey: Kst,
  Albanien: Tst,
  Kosovo: Mst,
  Lettland: Pst,
  "Fürstentum Liechtenstein": "Vorstendom Liechtenstein",
  Lithauen: Ust,
  Luxemburg: zst,
  Ungarn: Ost,
  Monaco: Qst,
  Niederlande: jst,
  Norwegen: qst,
  Polen: _st,
  Portugal: $st,
  Kasachstan: eIt,
  Malta: tIt,
  Moldau: iIt,
  Rumänien: "Roemenië",
  Russland: nIt,
  "San Marino": "San Marino",
  Slowenien: rIt,
  Slowakei: gIt,
  Serbien: oIt,
  Finnland: lIt,
  "Spitzbergen und Jan Mayen": "Spitsbergen en Jan Mayen",
  Schweden: aIt,
  Türkei: "Turkey",
  Ukraine: sIt,
  "Vereinigtes Königreich": "Verenigd Koninkrijk",
  Zypern: IIt,
  Griechenland: cIt,
  Nordmazedonien: dIt
}, CIt = {
  ...Rlt,
  ...uIt
}, AIt = {
  de: {
    translation: kxe
  },
  en: {
    translation: oPe
  },
  nl: {
    translation: CIt
  },
  fr: {
    translation: x_e
  }
};
$i.use(VZe).init({
  resources: AIt,
  lng: "de",
  // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  fallbackLng: "de",
  interpolation: {
    escapeValue: !1
    // react already safes from xss
  }
});
class Fm {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    const i = {
      listener: t
    };
    return this.listeners.add(i), this.onSubscribe(), () => {
      this.listeners.delete(i), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const Jf = typeof window > "u" || "Deno" in window;
function fa() {
}
function bIt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Jx(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function H8t(e, t) {
  return e.filter((i) => !t.includes(i));
}
function k8t(e, t, i) {
  const n = e.slice(0);
  return n[t] = i, n;
}
function g7(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function VB(e, t, i) {
  return xm(e) ? typeof t == "function" ? {
    ...i,
    queryKey: e,
    queryFn: t
  } : {
    ...t,
    queryKey: e
  } : e;
}
function hIt(e, t, i) {
  return xm(e) ? typeof t == "function" ? {
    ...i,
    mutationKey: e,
    mutationFn: t
  } : {
    ...t,
    mutationKey: e
  } : typeof e == "function" ? {
    ...t,
    mutationFn: e
  } : {
    ...e
  };
}
function Zd(e, t, i) {
  return xm(e) ? [{
    ...t,
    queryKey: e
  }, i] : [e || {}, t];
}
function Y8t(e, t, i) {
  return xm(e) ? [{
    ...t,
    mutationKey: e
  }, i] : [{}, t];
}
function uT(e, t) {
  const {
    type: i = "all",
    exact: n,
    fetchStatus: r,
    predicate: g,
    queryKey: o,
    stale: l
  } = e;
  if (xm(o)) {
    if (n) {
      if (t.queryHash !== jJ(o, t.options))
        return !1;
    } else if (!Cw(t.queryKey, o))
      return !1;
  }
  if (i !== "all") {
    const a = t.isActive();
    if (i === "active" && !a || i === "inactive" && a)
      return !1;
  }
  return !(typeof l == "boolean" && t.isStale() !== l || typeof r < "u" && r !== t.state.fetchStatus || g && !g(t));
}
function CT(e, t) {
  const {
    exact: i,
    fetching: n,
    predicate: r,
    mutationKey: g
  } = e;
  if (xm(g)) {
    if (!t.options.mutationKey)
      return !1;
    if (i) {
      if (EC(t.options.mutationKey) !== EC(g))
        return !1;
    } else if (!Cw(t.options.mutationKey, g))
      return !1;
  }
  return !(typeof n == "boolean" && t.state.status === "loading" !== n || r && !r(t));
}
function jJ(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || EC)(e);
}
function EC(e) {
  return JSON.stringify(e, (t, i) => Ex(i) ? Object.keys(i).sort().reduce((n, r) => (n[r] = i[r], n), {}) : i);
}
function Cw(e, t) {
  return o7(e, t);
}
function o7(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((i) => !o7(e[i], t[i])) : !1;
}
function l7(e, t) {
  if (e === t)
    return e;
  const i = AT(e) && AT(t);
  if (i || Ex(e) && Ex(t)) {
    const n = i ? e.length : Object.keys(e).length, r = i ? t : Object.keys(t), g = r.length, o = i ? [] : {};
    let l = 0;
    for (let a = 0; a < g; a++) {
      const I = i ? a : r[a];
      o[I] = l7(e[I], t[I]), o[I] === e[I] && l++;
    }
    return n === g && l === n ? e : o;
  }
  return t;
}
function Aw(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (const i in e)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function AT(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function Ex(e) {
  if (!bT(e))
    return !1;
  const t = e.constructor;
  if (typeof t > "u")
    return !0;
  const i = t.prototype;
  return !(!bT(i) || !i.hasOwnProperty("isPrototypeOf"));
}
function bT(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function xm(e) {
  return Array.isArray(e);
}
function a7(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function hT(e) {
  a7(0).then(e);
}
function mIt() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Nx(e, t, i) {
  return i.isDataEqual != null && i.isDataEqual(e, t) ? e : typeof i.structuralSharing == "function" ? i.structuralSharing(e, t) : i.structuralSharing !== !1 ? l7(e, t) : t;
}
class pIt extends Fm {
  constructor() {
    super(), this.setup = (t) => {
      if (!Jf && window.addEventListener) {
        const i = () => t();
        return window.addEventListener("visibilitychange", i, !1), window.addEventListener("focus", i, !1), () => {
          window.removeEventListener("visibilitychange", i), window.removeEventListener("focus", i);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var i;
    this.setup = t, (i = this.cleanup) == null || i.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    });
  }
  setFocused(t) {
    this.focused !== t && (this.focused = t, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const bw = new pIt(), mT = ["online", "offline"];
class BIt extends Fm {
  constructor() {
    super(), this.setup = (t) => {
      if (!Jf && window.addEventListener) {
        const i = () => t();
        return mT.forEach((n) => {
          window.addEventListener(n, i, !1);
        }), () => {
          mT.forEach((n) => {
            window.removeEventListener(n, i);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.cleanup) == null || t.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(t) {
    var i;
    this.setup = t, (i = this.cleanup) == null || i.call(this), this.cleanup = t((n) => {
      typeof n == "boolean" ? this.setOnline(n) : this.onOnline();
    });
  }
  setOnline(t) {
    this.online !== t && (this.online = t, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: t
    }) => {
      t();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const hw = new BIt();
function fIt(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function Hv(e) {
  return (e ?? "online") === "online" ? hw.isOnline() : !0;
}
class s7 {
  constructor(t) {
    this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
}
function cV(e) {
  return e instanceof s7;
}
function I7(e) {
  let t = !1, i = 0, n = !1, r, g, o;
  const l = new Promise((p, B) => {
    g = p, o = B;
  }), a = (p) => {
    n || (A(new s7(p)), e.abort == null || e.abort());
  }, I = () => {
    t = !0;
  }, c = () => {
    t = !1;
  }, d = () => !bw.isFocused() || e.networkMode !== "always" && !hw.isOnline(), C = (p) => {
    n || (n = !0, e.onSuccess == null || e.onSuccess(p), r == null || r(), g(p));
  }, A = (p) => {
    n || (n = !0, e.onError == null || e.onError(p), r == null || r(), o(p));
  }, b = () => new Promise((p) => {
    r = (B) => {
      const f = n || !d();
      return f && p(B), f;
    }, e.onPause == null || e.onPause();
  }).then(() => {
    r = void 0, n || e.onContinue == null || e.onContinue();
  }), m = () => {
    if (n)
      return;
    let p;
    try {
      p = e.fn();
    } catch (B) {
      p = Promise.reject(B);
    }
    Promise.resolve(p).then(C).catch((B) => {
      var f, Z;
      if (n)
        return;
      const y = (f = e.retry) != null ? f : 3, W = (Z = e.retryDelay) != null ? Z : fIt, V = typeof W == "function" ? W(i, B) : W, w = y === !0 || typeof y == "number" && i < y || typeof y == "function" && y(i, B);
      if (t || !w) {
        A(B);
        return;
      }
      i++, e.onFail == null || e.onFail(i, B), a7(V).then(() => {
        if (d())
          return b();
      }).then(() => {
        t ? A(B) : m();
      });
    });
  };
  return Hv(e.networkMode) ? m() : b().then(m), {
    promise: l,
    cancel: a,
    continue: () => (r == null ? void 0 : r()) ? l : Promise.resolve(),
    cancelRetry: I,
    continueRetry: c
  };
}
const qJ = console;
function ZIt() {
  let e = [], t = 0, i = (c) => {
    c();
  }, n = (c) => {
    c();
  };
  const r = (c) => {
    let d;
    t++;
    try {
      d = c();
    } finally {
      t--, t || l();
    }
    return d;
  }, g = (c) => {
    t ? e.push(c) : hT(() => {
      i(c);
    });
  }, o = (c) => (...d) => {
    g(() => {
      c(...d);
    });
  }, l = () => {
    const c = e;
    e = [], c.length && hT(() => {
      n(() => {
        c.forEach((d) => {
          i(d);
        });
      });
    });
  };
  return {
    batch: r,
    batchCalls: o,
    schedule: g,
    setNotifyFunction: (c) => {
      i = c;
    },
    setBatchNotifyFunction: (c) => {
      n = c;
    }
  };
}
const hr = ZIt();
class c7 {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), Jx(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(t) {
    this.cacheTime = Math.max(this.cacheTime || 0, t ?? (Jf ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class GIt extends c7 {
  constructor(t) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = t.defaultOptions, this.setOptions(t.options), this.observers = [], this.cache = t.cache, this.logger = t.logger || qJ, this.queryKey = t.queryKey, this.queryHash = t.queryHash, this.initialState = t.state || yIt(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(t, i) {
    const n = Nx(this.state.data, t, this.options);
    return this.dispatch({
      data: n,
      type: "success",
      dataUpdatedAt: i == null ? void 0 : i.updatedAt,
      manual: i == null ? void 0 : i.manual
    }), n;
  }
  setState(t, i) {
    this.dispatch({
      type: "setState",
      state: t,
      setStateOptions: i
    });
  }
  cancel(t) {
    var i;
    const n = this.promise;
    return (i = this.retryer) == null || i.cancel(t), n ? n.then(fa).catch(fa) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((t) => t.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((t) => t.getCurrentResult().isStale);
  }
  isStaleByTime(t = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !g7(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    i && i.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  onOnline() {
    var t;
    const i = this.observers.find((n) => n.shouldFetchOnReconnect());
    i && i.refetch({
      cancelRefetch: !1
    }), (t = this.retryer) == null || t.continue();
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers.includes(t) && (this.observers = this.observers.filter((i) => i !== t), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: t
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(t, i) {
    var n, r;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && i != null && i.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var g;
        return (g = this.retryer) == null || g.continueRetry(), this.promise;
      }
    }
    if (t && this.setOptions(t), !this.options.queryFn) {
      const A = this.observers.find((b) => b.options.queryFn);
      A && this.setOptions(A.options);
    }
    const o = mIt(), l = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, a = (A) => {
      Object.defineProperty(A, "signal", {
        enumerable: !0,
        get: () => {
          if (o)
            return this.abortSignalConsumed = !0, o.signal;
        }
      });
    };
    a(l);
    const I = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(l)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), c = {
      fetchOptions: i,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: I
    };
    if (a(c), (n = this.options.behavior) == null || n.onFetch(c), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((r = c.fetchOptions) == null ? void 0 : r.meta)) {
      var d;
      this.dispatch({
        type: "fetch",
        meta: (d = c.fetchOptions) == null ? void 0 : d.meta
      });
    }
    const C = (A) => {
      if (cV(A) && A.silent || this.dispatch({
        type: "error",
        error: A
      }), !cV(A)) {
        var b, m, p, B;
        (b = (m = this.cache.config).onError) == null || b.call(m, A, this), (p = (B = this.cache.config).onSettled) == null || p.call(B, this.state.data, A, this);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = I7({
      fn: c.fetchFn,
      abort: o == null ? void 0 : o.abort.bind(o),
      onSuccess: (A) => {
        var b, m, p, B;
        if (typeof A > "u") {
          C(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(A), (b = (m = this.cache.config).onSuccess) == null || b.call(m, A, this), (p = (B = this.cache.config).onSettled) == null || p.call(B, A, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: C,
      onFail: (A, b) => {
        this.dispatch({
          type: "failed",
          failureCount: A,
          error: b
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: c.options.retry,
      retryDelay: c.options.retryDelay,
      networkMode: c.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(t) {
    const i = (n) => {
      var r, g;
      switch (t.type) {
        case "failed":
          return {
            ...n,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error
          };
        case "pause":
          return {
            ...n,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...n,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...n,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (r = t.meta) != null ? r : null,
            fetchStatus: Hv(this.options.networkMode) ? "fetching" : "paused",
            ...!n.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...n,
            data: t.data,
            dataUpdateCount: n.dataUpdateCount + 1,
            dataUpdatedAt: (g = t.dataUpdatedAt) != null ? g : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const o = t.error;
          return cV(o) && o.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...n,
            error: o,
            errorUpdateCount: n.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: n.fetchFailureCount + 1,
            fetchFailureReason: o,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...n,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = i(this.state), hr.batch(() => {
      this.observers.forEach((n) => {
        n.onQueryUpdate(t);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: t
      });
    });
  }
}
function yIt(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, i = typeof t < "u", n = i ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: i ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: i ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class WIt extends Fm {
  constructor(t) {
    super(), this.config = t || {}, this.queries = [], this.queriesMap = {};
  }
  build(t, i, n) {
    var r;
    const g = i.queryKey, o = (r = i.queryHash) != null ? r : jJ(g, i);
    let l = this.get(o);
    return l || (l = new GIt({
      cache: this,
      logger: t.getLogger(),
      queryKey: g,
      queryHash: o,
      options: t.defaultQueryOptions(i),
      state: n,
      defaultOptions: t.getQueryDefaults(g)
    }), this.add(l)), l;
  }
  add(t) {
    this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
      type: "added",
      query: t
    }));
  }
  remove(t) {
    const i = this.queriesMap[t.queryHash];
    i && (t.destroy(), this.queries = this.queries.filter((n) => n !== t), i === t && delete this.queriesMap[t.queryHash], this.notify({
      type: "removed",
      query: t
    }));
  }
  clear() {
    hr.batch(() => {
      this.queries.forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.queriesMap[t];
  }
  getAll() {
    return this.queries;
  }
  find(t, i) {
    const [n] = Zd(t, i);
    return typeof n.exact > "u" && (n.exact = !0), this.queries.find((r) => uT(n, r));
  }
  findAll(t, i) {
    const [n] = Zd(t, i);
    return Object.keys(n).length > 0 ? this.queries.filter((r) => uT(n, r)) : this.queries;
  }
  notify(t) {
    hr.batch(() => {
      this.listeners.forEach(({
        listener: i
      }) => {
        i(t);
      });
    });
  }
  onFocus() {
    hr.batch(() => {
      this.queries.forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    hr.batch(() => {
      this.queries.forEach((t) => {
        t.onOnline();
      });
    });
  }
}
class SIt extends c7 {
  constructor(t) {
    super(), this.defaultOptions = t.defaultOptions, this.mutationId = t.mutationId, this.mutationCache = t.mutationCache, this.logger = t.logger || qJ, this.observers = [], this.state = t.state || d7(), this.setOptions(t.options), this.scheduleGc();
  }
  setOptions(t) {
    this.options = {
      ...this.defaultOptions,
      ...t
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(t) {
    this.dispatch({
      type: "setState",
      state: t
    });
  }
  addObserver(t) {
    this.observers.includes(t) || (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: t
    }));
  }
  removeObserver(t) {
    this.observers = this.observers.filter((i) => i !== t), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: t
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var t, i;
    return (t = (i = this.retryer) == null ? void 0 : i.continue()) != null ? t : this.execute();
  }
  async execute() {
    const t = () => {
      var w;
      return this.retryer = I7({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (v, H) => {
          this.dispatch({
            type: "failed",
            failureCount: v,
            error: H
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (w = this.options.retry) != null ? w : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, i = this.state.status === "loading";
    try {
      var n, r, g, o, l, a, I, c;
      if (!i) {
        var d, C, A, b;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((d = (C = this.mutationCache.config).onMutate) == null ? void 0 : d.call(C, this.state.variables, this));
        const v = await ((A = (b = this.options).onMutate) == null ? void 0 : A.call(b, this.state.variables));
        v !== this.state.context && this.dispatch({
          type: "loading",
          context: v,
          variables: this.state.variables
        });
      }
      const w = await t();
      return await ((n = (r = this.mutationCache.config).onSuccess) == null ? void 0 : n.call(r, w, this.state.variables, this.state.context, this)), await ((g = (o = this.options).onSuccess) == null ? void 0 : g.call(o, w, this.state.variables, this.state.context)), await ((l = (a = this.mutationCache.config).onSettled) == null ? void 0 : l.call(a, w, null, this.state.variables, this.state.context, this)), await ((I = (c = this.options).onSettled) == null ? void 0 : I.call(c, w, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: w
      }), w;
    } catch (w) {
      try {
        var m, p, B, f, Z, y, W, V;
        throw await ((m = (p = this.mutationCache.config).onError) == null ? void 0 : m.call(p, w, this.state.variables, this.state.context, this)), await ((B = (f = this.options).onError) == null ? void 0 : B.call(f, w, this.state.variables, this.state.context)), await ((Z = (y = this.mutationCache.config).onSettled) == null ? void 0 : Z.call(y, void 0, w, this.state.variables, this.state.context, this)), await ((W = (V = this.options).onSettled) == null ? void 0 : W.call(V, void 0, w, this.state.variables, this.state.context)), w;
      } finally {
        this.dispatch({
          type: "error",
          error: w
        });
      }
    }
  }
  dispatch(t) {
    const i = (n) => {
      switch (t.type) {
        case "failed":
          return {
            ...n,
            failureCount: t.failureCount,
            failureReason: t.error
          };
        case "pause":
          return {
            ...n,
            isPaused: !0
          };
        case "continue":
          return {
            ...n,
            isPaused: !1
          };
        case "loading":
          return {
            ...n,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !Hv(this.options.networkMode),
            status: "loading",
            variables: t.variables
          };
        case "success":
          return {
            ...n,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...n,
            data: void 0,
            error: t.error,
            failureCount: n.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...n,
            ...t.state
          };
      }
    };
    this.state = i(this.state), hr.batch(() => {
      this.observers.forEach((n) => {
        n.onMutationUpdate(t);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: t
      });
    });
  }
}
function d7() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class VIt extends Fm {
  constructor(t) {
    super(), this.config = t || {}, this.mutations = [], this.mutationId = 0;
  }
  build(t, i, n) {
    const r = new SIt({
      mutationCache: this,
      logger: t.getLogger(),
      mutationId: ++this.mutationId,
      options: t.defaultMutationOptions(i),
      state: n,
      defaultOptions: i.mutationKey ? t.getMutationDefaults(i.mutationKey) : void 0
    });
    return this.add(r), r;
  }
  add(t) {
    this.mutations.push(t), this.notify({
      type: "added",
      mutation: t
    });
  }
  remove(t) {
    this.mutations = this.mutations.filter((i) => i !== t), this.notify({
      type: "removed",
      mutation: t
    });
  }
  clear() {
    hr.batch(() => {
      this.mutations.forEach((t) => {
        this.remove(t);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(t) {
    return typeof t.exact > "u" && (t.exact = !0), this.mutations.find((i) => CT(t, i));
  }
  findAll(t) {
    return this.mutations.filter((i) => CT(t, i));
  }
  notify(t) {
    hr.batch(() => {
      this.listeners.forEach(({
        listener: i
      }) => {
        i(t);
      });
    });
  }
  resumePausedMutations() {
    var t;
    return this.resuming = ((t = this.resuming) != null ? t : Promise.resolve()).then(() => {
      const i = this.mutations.filter((n) => n.state.isPaused);
      return hr.batch(() => i.reduce((n, r) => n.then(() => r.continue().catch(fa)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function wIt() {
  return {
    onFetch: (e) => {
      e.fetchFn = () => {
        var t, i, n, r, g, o;
        const l = (t = e.fetchOptions) == null || (i = t.meta) == null ? void 0 : i.refetchPage, a = (n = e.fetchOptions) == null || (r = n.meta) == null ? void 0 : r.fetchMore, I = a == null ? void 0 : a.pageParam, c = (a == null ? void 0 : a.direction) === "forward", d = (a == null ? void 0 : a.direction) === "backward", C = ((g = e.state.data) == null ? void 0 : g.pages) || [], A = ((o = e.state.data) == null ? void 0 : o.pageParams) || [];
        let b = A, m = !1;
        const p = (V) => {
          Object.defineProperty(V, "signal", {
            enumerable: !0,
            get: () => {
              var w;
              if ((w = e.signal) != null && w.aborted)
                m = !0;
              else {
                var v;
                (v = e.signal) == null || v.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return e.signal;
            }
          });
        }, B = e.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + e.options.queryHash + "'")), f = (V, w, v, H) => (b = H ? [w, ...b] : [...b, w], H ? [v, ...V] : [...V, v]), Z = (V, w, v, H) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof v > "u" && !w && V.length)
            return Promise.resolve(V);
          const x = {
            queryKey: e.queryKey,
            pageParam: v,
            meta: e.options.meta
          };
          p(x);
          const J = B(x);
          return Promise.resolve(J).then((M) => f(V, v, M, H));
        };
        let y;
        if (!C.length)
          y = Z([]);
        else if (c) {
          const V = typeof I < "u", w = V ? I : pT(e.options, C);
          y = Z(C, V, w);
        } else if (d) {
          const V = typeof I < "u", w = V ? I : vIt(e.options, C);
          y = Z(C, V, w, !0);
        } else {
          b = [];
          const V = typeof e.options.getNextPageParam > "u";
          y = (l && C[0] ? l(C[0], 0, C) : !0) ? Z([], V, A[0]) : Promise.resolve(f([], A[0], C[0]));
          for (let v = 1; v < C.length; v++)
            y = y.then((H) => {
              if (l && C[v] ? l(C[v], v, C) : !0) {
                const J = V ? A[v] : pT(e.options, H);
                return Z(H, V, J);
              }
              return Promise.resolve(f(H, A[v], C[v]));
            });
        }
        return y.then((V) => ({
          pages: V,
          pageParams: b
        }));
      };
    }
  };
}
function pT(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function vIt(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
class RIt {
  constructor(t = {}) {
    this.queryCache = t.queryCache || new WIt(), this.mutationCache = t.mutationCache || new VIt(), this.logger = t.logger || qJ, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0;
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = bw.subscribe(() => {
      bw.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = hw.subscribe(() => {
      hw.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var t, i;
    this.mountCount--, this.mountCount === 0 && ((t = this.unsubscribeFocus) == null || t.call(this), this.unsubscribeFocus = void 0, (i = this.unsubscribeOnline) == null || i.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(t, i) {
    const [n] = Zd(t, i);
    return n.fetchStatus = "fetching", this.queryCache.findAll(n).length;
  }
  isMutating(t) {
    return this.mutationCache.findAll({
      ...t,
      fetching: !0
    }).length;
  }
  getQueryData(t, i) {
    var n;
    return (n = this.queryCache.find(t, i)) == null ? void 0 : n.state.data;
  }
  ensureQueryData(t, i, n) {
    const r = VB(t, i, n), g = this.getQueryData(r.queryKey);
    return g ? Promise.resolve(g) : this.fetchQuery(r);
  }
  getQueriesData(t) {
    return this.getQueryCache().findAll(t).map(({
      queryKey: i,
      state: n
    }) => {
      const r = n.data;
      return [i, r];
    });
  }
  setQueryData(t, i, n) {
    const r = this.queryCache.find(t), g = r == null ? void 0 : r.state.data, o = bIt(i, g);
    if (typeof o > "u")
      return;
    const l = VB(t), a = this.defaultQueryOptions(l);
    return this.queryCache.build(this, a).setData(o, {
      ...n,
      manual: !0
    });
  }
  setQueriesData(t, i, n) {
    return hr.batch(() => this.getQueryCache().findAll(t).map(({
      queryKey: r
    }) => [r, this.setQueryData(r, i, n)]));
  }
  getQueryState(t, i) {
    var n;
    return (n = this.queryCache.find(t, i)) == null ? void 0 : n.state;
  }
  removeQueries(t, i) {
    const [n] = Zd(t, i), r = this.queryCache;
    hr.batch(() => {
      r.findAll(n).forEach((g) => {
        r.remove(g);
      });
    });
  }
  resetQueries(t, i, n) {
    const [r, g] = Zd(t, i, n), o = this.queryCache, l = {
      type: "active",
      ...r
    };
    return hr.batch(() => (o.findAll(r).forEach((a) => {
      a.reset();
    }), this.refetchQueries(l, g)));
  }
  cancelQueries(t, i, n) {
    const [r, g = {}] = Zd(t, i, n);
    typeof g.revert > "u" && (g.revert = !0);
    const o = hr.batch(() => this.queryCache.findAll(r).map((l) => l.cancel(g)));
    return Promise.all(o).then(fa).catch(fa);
  }
  invalidateQueries(t, i, n) {
    const [r, g] = Zd(t, i, n);
    return hr.batch(() => {
      var o, l;
      if (this.queryCache.findAll(r).forEach((I) => {
        I.invalidate();
      }), r.refetchType === "none")
        return Promise.resolve();
      const a = {
        ...r,
        type: (o = (l = r.refetchType) != null ? l : r.type) != null ? o : "active"
      };
      return this.refetchQueries(a, g);
    });
  }
  refetchQueries(t, i, n) {
    const [r, g] = Zd(t, i, n), o = hr.batch(() => this.queryCache.findAll(r).filter((a) => !a.isDisabled()).map((a) => {
      var I;
      return a.fetch(void 0, {
        ...g,
        cancelRefetch: (I = g == null ? void 0 : g.cancelRefetch) != null ? I : !0,
        meta: {
          refetchPage: r.refetchPage
        }
      });
    }));
    let l = Promise.all(o).then(fa);
    return g != null && g.throwOnError || (l = l.catch(fa)), l;
  }
  fetchQuery(t, i, n) {
    const r = VB(t, i, n), g = this.defaultQueryOptions(r);
    typeof g.retry > "u" && (g.retry = !1);
    const o = this.queryCache.build(this, g);
    return o.isStaleByTime(g.staleTime) ? o.fetch(g) : Promise.resolve(o.state.data);
  }
  prefetchQuery(t, i, n) {
    return this.fetchQuery(t, i, n).then(fa).catch(fa);
  }
  fetchInfiniteQuery(t, i, n) {
    const r = VB(t, i, n);
    return r.behavior = wIt(), this.fetchQuery(r);
  }
  prefetchInfiniteQuery(t, i, n) {
    return this.fetchInfiniteQuery(t, i, n).then(fa).catch(fa);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(t) {
    this.defaultOptions = t;
  }
  setQueryDefaults(t, i) {
    const n = this.queryDefaults.find((r) => EC(t) === EC(r.queryKey));
    n ? n.defaultOptions = i : this.queryDefaults.push({
      queryKey: t,
      defaultOptions: i
    });
  }
  getQueryDefaults(t) {
    if (!t)
      return;
    const i = this.queryDefaults.find((n) => Cw(t, n.queryKey));
    return i == null ? void 0 : i.defaultOptions;
  }
  setMutationDefaults(t, i) {
    const n = this.mutationDefaults.find((r) => EC(t) === EC(r.mutationKey));
    n ? n.defaultOptions = i : this.mutationDefaults.push({
      mutationKey: t,
      defaultOptions: i
    });
  }
  getMutationDefaults(t) {
    if (!t)
      return;
    const i = this.mutationDefaults.find((n) => Cw(t, n.mutationKey));
    return i == null ? void 0 : i.defaultOptions;
  }
  defaultQueryOptions(t) {
    if (t != null && t._defaulted)
      return t;
    const i = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(t == null ? void 0 : t.queryKey),
      ...t,
      _defaulted: !0
    };
    return !i.queryHash && i.queryKey && (i.queryHash = jJ(i.queryKey, i)), typeof i.refetchOnReconnect > "u" && (i.refetchOnReconnect = i.networkMode !== "always"), typeof i.useErrorBoundary > "u" && (i.useErrorBoundary = !!i.suspense), i;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(t == null ? void 0 : t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class XIt extends Fm {
  constructor(t, i) {
    super(), this.client = t, this.options = i, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(i);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), BT(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Lx(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return Lx(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(t, i) {
    const n = this.options, r = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(t), Aw(n, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = n.queryKey), this.updateQuery();
    const g = this.hasListeners();
    g && fT(this.currentQuery, r, this.options, n) && this.executeFetch(), this.updateResult(i), g && (this.currentQuery !== r || this.options.enabled !== n.enabled || this.options.staleTime !== n.staleTime) && this.updateStaleTimeout();
    const o = this.computeRefetchInterval();
    g && (this.currentQuery !== r || this.options.enabled !== n.enabled || o !== this.currentRefetchInterval) && this.updateRefetchInterval(o);
  }
  getOptimisticResult(t) {
    const i = this.client.getQueryCache().build(this.client, t), n = this.createResult(i, t);
    return kIt(this, n, t) && (this.currentResult = n, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), n;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(t) {
    const i = {};
    return Object.keys(t).forEach((n) => {
      Object.defineProperty(i, n, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(n), t[n])
      });
    }), i;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: t,
    ...i
  } = {}) {
    return this.fetch({
      ...i,
      meta: {
        refetchPage: t
      }
    });
  }
  fetchOptimistic(t) {
    const i = this.client.defaultQueryOptions(t), n = this.client.getQueryCache().build(this.client, i);
    return n.isFetchingOptimistic = !0, n.fetch().then(() => this.createResult(n, i));
  }
  fetch(t) {
    var i;
    return this.executeFetch({
      ...t,
      cancelRefetch: (i = t.cancelRefetch) != null ? i : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(t) {
    this.updateQuery();
    let i = this.currentQuery.fetch(this.options, t);
    return t != null && t.throwOnError || (i = i.catch(fa)), i;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), Jf || this.currentResult.isStale || !Jx(this.options.staleTime))
      return;
    const i = g7(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, i);
  }
  computeRefetchInterval() {
    var t;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (t = this.options.refetchInterval) != null ? t : !1;
  }
  updateRefetchInterval(t) {
    this.clearRefetchInterval(), this.currentRefetchInterval = t, !(Jf || this.options.enabled === !1 || !Jx(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || bw.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(t, i) {
    const n = this.currentQuery, r = this.options, g = this.currentResult, o = this.currentResultState, l = this.currentResultOptions, a = t !== n, I = a ? t.state : this.currentQueryInitialState, c = a ? this.currentResult : this.previousQueryResult, {
      state: d
    } = t;
    let {
      dataUpdatedAt: C,
      error: A,
      errorUpdatedAt: b,
      fetchStatus: m,
      status: p
    } = d, B = !1, f = !1, Z;
    if (i._optimisticResults) {
      const v = this.hasListeners(), H = !v && BT(t, i), x = v && fT(t, n, i, r);
      (H || x) && (m = Hv(t.options.networkMode) ? "fetching" : "paused", C || (p = "loading")), i._optimisticResults === "isRestoring" && (m = "idle");
    }
    if (i.keepPreviousData && !d.dataUpdatedAt && c != null && c.isSuccess && p !== "error")
      Z = c.data, C = c.dataUpdatedAt, p = c.status, B = !0;
    else if (i.select && typeof d.data < "u")
      if (g && d.data === (o == null ? void 0 : o.data) && i.select === this.selectFn)
        Z = this.selectResult;
      else
        try {
          this.selectFn = i.select, Z = i.select(d.data), Z = Nx(g == null ? void 0 : g.data, Z, i), this.selectResult = Z, this.selectError = null;
        } catch (v) {
          this.selectError = v;
        }
    else
      Z = d.data;
    if (typeof i.placeholderData < "u" && typeof Z > "u" && p === "loading") {
      let v;
      if (g != null && g.isPlaceholderData && i.placeholderData === (l == null ? void 0 : l.placeholderData))
        v = g.data;
      else if (v = typeof i.placeholderData == "function" ? i.placeholderData() : i.placeholderData, i.select && typeof v < "u")
        try {
          v = i.select(v), this.selectError = null;
        } catch (H) {
          this.selectError = H;
        }
      typeof v < "u" && (p = "success", Z = Nx(g == null ? void 0 : g.data, v, i), f = !0);
    }
    this.selectError && (A = this.selectError, Z = this.selectResult, b = Date.now(), p = "error");
    const y = m === "fetching", W = p === "loading", V = p === "error";
    return {
      status: p,
      fetchStatus: m,
      isLoading: W,
      isSuccess: p === "success",
      isError: V,
      isInitialLoading: W && y,
      data: Z,
      dataUpdatedAt: C,
      error: A,
      errorUpdatedAt: b,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > I.dataUpdateCount || d.errorUpdateCount > I.errorUpdateCount,
      isFetching: y,
      isRefetching: y && !W,
      isLoadingError: V && d.dataUpdatedAt === 0,
      isPaused: m === "paused",
      isPlaceholderData: f,
      isPreviousData: B,
      isRefetchError: V && d.dataUpdatedAt !== 0,
      isStale: _J(t, i),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(t) {
    const i = this.currentResult, n = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, Aw(n, i))
      return;
    this.currentResult = n;
    const r = {
      cache: !0
    }, g = () => {
      if (!i)
        return !0;
      const {
        notifyOnChangeProps: o
      } = this.options, l = typeof o == "function" ? o() : o;
      if (l === "all" || !l && !this.trackedProps.size)
        return !0;
      const a = new Set(l ?? this.trackedProps);
      return this.options.useErrorBoundary && a.add("error"), Object.keys(this.currentResult).some((I) => {
        const c = I;
        return this.currentResult[c] !== i[c] && a.has(c);
      });
    };
    (t == null ? void 0 : t.listeners) !== !1 && g() && (r.listeners = !0), this.notify({
      ...r,
      ...t
    });
  }
  updateQuery() {
    const t = this.client.getQueryCache().build(this.client, this.options);
    if (t === this.currentQuery)
      return;
    const i = this.currentQuery;
    this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (i == null || i.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate(t) {
    const i = {};
    t.type === "success" ? i.onSuccess = !t.manual : t.type === "error" && !cV(t.error) && (i.onError = !0), this.updateResult(i), this.hasListeners() && this.updateTimers();
  }
  notify(t) {
    hr.batch(() => {
      if (t.onSuccess) {
        var i, n, r, g;
        (i = (n = this.options).onSuccess) == null || i.call(n, this.currentResult.data), (r = (g = this.options).onSettled) == null || r.call(g, this.currentResult.data, null);
      } else if (t.onError) {
        var o, l, a, I;
        (o = (l = this.options).onError) == null || o.call(l, this.currentResult.error), (a = (I = this.options).onSettled) == null || a.call(I, void 0, this.currentResult.error);
      }
      t.listeners && this.listeners.forEach(({
        listener: c
      }) => {
        c(this.currentResult);
      }), t.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function HIt(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function BT(e, t) {
  return HIt(e, t) || e.state.dataUpdatedAt > 0 && Lx(e, t, t.refetchOnMount);
}
function Lx(e, t, i) {
  if (t.enabled !== !1) {
    const n = typeof i == "function" ? i(e) : i;
    return n === "always" || n !== !1 && _J(e, t);
  }
  return !1;
}
function fT(e, t, i, n) {
  return i.enabled !== !1 && (e !== t || n.enabled === !1) && (!i.suspense || e.state.status !== "error") && _J(e, i);
}
function _J(e, t) {
  return e.isStaleByTime(t.staleTime);
}
function kIt(e, t, i) {
  return i.keepPreviousData ? !1 : i.placeholderData !== void 0 ? t.isPlaceholderData : !Aw(e.getCurrentResult(), t);
}
let YIt = class extends Fm {
  constructor(t, i) {
    super(), this.client = t, this.setOptions(i), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    var i;
    const n = this.options;
    this.options = this.client.defaultMutationOptions(t), Aw(n, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    }), (i = this.currentMutation) == null || i.setOptions(this.options);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var t;
      (t = this.currentMutation) == null || t.removeObserver(this);
    }
  }
  onMutationUpdate(t) {
    this.updateResult();
    const i = {
      listeners: !0
    };
    t.type === "success" ? i.onSuccess = !0 : t.type === "error" && (i.onError = !0), this.notify(i);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(t, i) {
    return this.mutateOptions = i, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof t < "u" ? t : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const t = this.currentMutation ? this.currentMutation.state : d7(), i = {
      ...t,
      isLoading: t.status === "loading",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = i;
  }
  notify(t) {
    hr.batch(() => {
      if (this.mutateOptions && this.hasListeners()) {
        if (t.onSuccess) {
          var i, n, r, g;
          (i = (n = this.mutateOptions).onSuccess) == null || i.call(n, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (r = (g = this.mutateOptions).onSettled) == null || r.call(g, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (t.onError) {
          var o, l, a, I;
          (o = (l = this.mutateOptions).onError) == null || o.call(l, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (a = (I = this.mutateOptions).onSettled) == null || a.call(I, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      t.listeners && this.listeners.forEach(({
        listener: c
      }) => {
        c(this.currentResult);
      });
    });
  }
};
var u7 = { exports: {} }, C7 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Im = De;
function FIt(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var xIt = typeof Object.is == "function" ? Object.is : FIt, DIt = Im.useState, JIt = Im.useEffect, EIt = Im.useLayoutEffect, NIt = Im.useDebugValue;
function LIt(e, t) {
  var i = t(), n = DIt({ inst: { value: i, getSnapshot: t } }), r = n[0].inst, g = n[1];
  return EIt(function() {
    r.value = i, r.getSnapshot = t, WY(r) && g({ inst: r });
  }, [e, i, t]), JIt(function() {
    return WY(r) && g({ inst: r }), e(function() {
      WY(r) && g({ inst: r });
    });
  }, [e]), NIt(i), i;
}
function WY(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var i = t();
    return !xIt(e, i);
  } catch {
    return !0;
  }
}
function KIt(e, t) {
  return t();
}
var TIt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? KIt : LIt;
C7.useSyncExternalStore = Im.useSyncExternalStore !== void 0 ? Im.useSyncExternalStore : TIt;
u7.exports = C7;
var MIt = u7.exports;
const A7 = MIt.useSyncExternalStore, ZT = /* @__PURE__ */ X.createContext(void 0), b7 = /* @__PURE__ */ X.createContext(!1);
function h7(e, t) {
  return e || (t && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = ZT), window.ReactQueryClientContext) : ZT);
}
const Dm = ({
  context: e
} = {}) => {
  const t = X.useContext(h7(e, X.useContext(b7)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, PIt = ({
  client: e,
  children: t,
  context: i,
  contextSharing: n = !1
}) => {
  X.useEffect(() => (e.mount(), () => {
    e.unmount();
  }), [e]);
  const r = h7(i, n);
  return /* @__PURE__ */ X.createElement(b7.Provider, {
    value: !i && n
  }, /* @__PURE__ */ X.createElement(r.Provider, {
    value: e
  }, t));
}, m7 = /* @__PURE__ */ X.createContext(!1), UIt = () => X.useContext(m7);
m7.Provider;
function zIt() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
const OIt = /* @__PURE__ */ X.createContext(zIt()), QIt = () => X.useContext(OIt);
function p7(e, t) {
  return typeof e == "function" ? e(...t) : !!e;
}
const jIt = (e, t) => {
  (e.suspense || e.useErrorBoundary) && (t.isReset() || (e.retryOnMount = !1));
}, qIt = (e) => {
  X.useEffect(() => {
    e.clearReset();
  }, [e]);
}, _It = ({
  result: e,
  errorResetBoundary: t,
  useErrorBoundary: i,
  query: n
}) => e.isError && !t.isReset() && !e.isFetching && p7(i, [e.error, n]), $It = (e) => {
  e.suspense && typeof e.staleTime != "number" && (e.staleTime = 1e3);
}, ect = (e, t) => e.isLoading && e.isFetching && !t, tct = (e, t, i) => (e == null ? void 0 : e.suspense) && ect(t, i), ict = (e, t, i) => t.fetchOptimistic(e).then(({
  data: n
}) => {
  e.onSuccess == null || e.onSuccess(n), e.onSettled == null || e.onSettled(n, null);
}).catch((n) => {
  i.clearReset(), e.onError == null || e.onError(n), e.onSettled == null || e.onSettled(void 0, n);
});
function nct(e, t) {
  const i = Dm({
    context: e.context
  }), n = UIt(), r = QIt(), g = i.defaultQueryOptions(e);
  g._optimisticResults = n ? "isRestoring" : "optimistic", g.onError && (g.onError = hr.batchCalls(g.onError)), g.onSuccess && (g.onSuccess = hr.batchCalls(g.onSuccess)), g.onSettled && (g.onSettled = hr.batchCalls(g.onSettled)), $It(g), jIt(g, r), qIt(r);
  const [o] = X.useState(() => new t(i, g)), l = o.getOptimisticResult(g);
  if (A7(X.useCallback((a) => {
    const I = n ? () => {
    } : o.subscribe(hr.batchCalls(a));
    return o.updateResult(), I;
  }, [o, n]), () => o.getCurrentResult(), () => o.getCurrentResult()), X.useEffect(() => {
    o.setOptions(g, {
      listeners: !1
    });
  }, [g, o]), tct(g, l, n))
    throw ict(g, o, r);
  if (_It({
    result: l,
    errorResetBoundary: r,
    useErrorBoundary: g.useErrorBoundary,
    query: o.getCurrentQuery()
  }))
    throw l.error;
  return g.notifyOnChangeProps ? l : o.trackResult(l);
}
function B7(e, t, i) {
  const n = VB(e, t, i);
  return nct(n, XIt);
}
function $J(e, t, i) {
  const n = hIt(e, t, i), r = Dm({
    context: n.context
  }), [g] = X.useState(() => new YIt(r, n));
  X.useEffect(() => {
    g.setOptions(n);
  }, [g, n]);
  const o = A7(X.useCallback((a) => g.subscribe(hr.batchCalls(a)), [g]), () => g.getCurrentResult(), () => g.getCurrentResult()), l = X.useCallback((a, I) => {
    g.mutate(a, I).catch(rct);
  }, [g]);
  if (o.error && p7(g.options.useErrorBoundary, [o.error]))
    throw o.error;
  return {
    ...o,
    mutate: l,
    mutateAsync: o.mutate
  };
}
function rct() {
}
const gct = new RIt({
  defaultOptions: {
    queries: {
      // cacheTime,
      // enabled,
      // initialData,
      // initialDataUpdatedAt,
      // isDataEqual,
      // keepPreviousData,
      // meta,
      // networkMode,
      // notifyOnChangeProps,
      // onError,
      // onSettled,
      // onSuccess,
      // placeholderData,
      // queryKeyHashFn,
      // refetchInterval,
      // refetchIntervalInBackground,
      // refetchOnMount,
      // refetchOnReconnect,
      // refetchOnWindowFocus: false,
      retry: !1,
      // retryDelay,
      // retryOnMount,
      // select,
      // staleTime: Infinity,
      // structuralSharing,
      suspense: !0,
      useErrorBoundary: !0
    },
    mutations: {
      // cacheTime,
      // meta,
      // mutationKey,
      // networkMode,
      // onError,
      // onMutate,
      // onSettled,
      // onSuccess,
      // retry,
      // retryDelay,
      // useErrorBoundary: true,
    }
  }
}), f7 = {
  articles: [],
  colors: [],
  hideGroups: [],
  hideValues: [],
  hideVariables: [],
  concealVariables: [],
  concealGroups: [],
  images: [],
  instances: [],
  labels: [],
  popups: [],
  materials: [],
  models: [],
  prints: [],
  exitButtons: []
}, oct = {
  actionEngineInput: null,
  actionEngineState: f7
}, Z7 = pr({
  name: "common",
  initialState: oct,
  reducers: {
    setActionEngineInput: (e, t) => {
      e.actionEngineInput = t.payload;
    },
    setActionEngineState: (e, t) => {
      e.actionEngineState = t.payload;
    }
  }
}), {
  setActionEngineInput: lct,
  setActionEngineState: G7
} = Z7.actions, act = Z7.reducer, sct = {
  bom: []
}, y7 = pr({
  name: "bom",
  initialState: sct,
  reducers: {
    setBom: (e, t) => {
      e.bom = t.payload;
    }
  }
}), {
  setBom: Ict
} = y7.actions, cct = y7.reducer, dct = {
  cameraPreviewData: void 0
}, W7 = pr({
  name: "cameraPreview",
  initialState: dct,
  reducers: {
    setCameraPreviewData: (e, t) => {
      e.cameraPreviewData = t.payload;
    },
    resetCameraPreviewData: (e) => {
      e.cameraPreviewData = void 0;
    }
  }
}), {
  setCameraPreviewData: x8t,
  resetCameraPreviewData: D8t
} = W7.actions, uct = W7.reducer, Cct = {
  language: "de",
  contentLanguage: null,
  dark: null,
  callIds: [],
  appLoadCounter: 0,
  selectedVariableId: void 0,
  focusGroupIdByInstanceId: {},
  fullScreen3DView: !1,
  dealerData: {
    discount: 0,
    surcharge: 0,
    apps: []
  },
  hasVersionMismatch: !1
}, S7 = pr({
  name: "common",
  initialState: Cct,
  reducers: {
    setLanguage: (e, t) => {
      $i.changeLanguage(t.payload, () => e.language = t.payload);
    },
    setContentLanguage: (e, t) => {
      e.contentLanguage = t.payload;
    },
    setDarkMode: (e, t) => {
      e.dark = t.payload;
    },
    setDealerData: (e, {
      payload: t
    }) => {
      e.dealerData = {
        ...t,
        discount: t != null && t.discount ? t.discount : 0,
        surcharge: t != null && t.surcharge ? t.surcharge : 0
      };
    },
    overwriteDealerApp: (e, {
      payload: t
    }) => {
      const i = [...(e.dealerData.apps ?? []).filter((n) => n.id !== t.id), t];
      e.dealerData = wI({
        apps: i
      })(e.dealerData);
    },
    incAppLoadCounter: (e) => {
      e.appLoadCounter++;
    },
    setSelectedVariableId: (e, t) => {
      e.selectedVariableId = t.payload;
    },
    setFocusGroupId: (e, t) => {
      if (!t.payload.focusGroupId || e.focusGroupIdByInstanceId[t.payload.instanceId] === t.payload.focusGroupId)
        return e;
      e.focusGroupIdByInstanceId[t.payload.instanceId] = t.payload.focusGroupId;
    },
    setFocusGroupIds: (e, t) => {
      e.focusGroupIdByInstanceId = t.payload;
    },
    startLoading: (e, t) => {
      e.callIds.push(t.payload);
    },
    finishLoading: (e, t) => {
      e.callIds = e.callIds.filter((i) => i !== t.payload);
    },
    toggleFullScreen3DView: (e) => {
      e.fullScreen3DView = !e.fullScreen3DView;
    },
    mergeUrlQuery: (e, t) => {
      e.urlQuery = {
        ...e.urlQuery,
        ...t.payload
      };
    },
    setHasVersionMismatch: (e, t) => {
      e.hasVersionMismatch = t.payload;
    }
  }
}), {
  finishLoading: e9,
  incAppLoadCounter: J8t,
  setDealerData: Act,
  overwriteDealerApp: E8t,
  setDarkMode: N8t,
  setFocusGroupId: bct,
  setFocusGroupIds: hct,
  setLanguage: L8t,
  setContentLanguage: mct,
  setSelectedVariableId: pct,
  startLoading: Bct,
  toggleFullScreen3DView: GT,
  mergeUrlQuery: K8t,
  setHasVersionMismatch: yT
} = S7.actions, fct = S7.reducer, Zct = {
  Presentation: "presentation",
  Options: "options",
  Usage: "usage",
  Values: "values",
  Rules: "rules"
}, Gct = {
  app: void 0,
  group: void 0,
  variable: void 0,
  variableStep: Zct.Options,
  showEditorUi: !1,
  devmode: 0,
  helpTopic: void 0,
  device: "desktop",
  showThemeDialog: !1,
  showMobileThemeDialog: !1,
  searchString: "",
  dynamicSettingsEditing: void 0,
  popupAction: void 0
}, V7 = pr({
  name: "configurator",
  initialState: Gct,
  reducers: {
    setConfiguratorApp: (e, t) => {
      e.app = t.payload;
    },
    setDynamicSettings: (e, t) => {
      e.dynamicSettingsEditing = t.payload;
    },
    setConfiguratorGroup: (e, t) => {
      e.group = t.payload;
    },
    setConfiguratorVariable: (e, t) => {
      e.variable = t.payload;
    },
    setPreviewDevice: (e, t) => {
      e.device = t.payload;
    },
    setShowEditorUi: (e, t) => {
      e.showEditorUi = t.payload;
    },
    setSearchString: (e, t) => {
      e.searchString = t.payload;
    },
    setShowThemeDialog: (e, t) => {
      e.showThemeDialog = t.payload;
    },
    setShowMobileThemeDialog: (e, t) => {
      e.showMobileThemeDialog = t.payload;
    },
    setDevmode: (e, t) => {
      e.devmode = t.payload;
    },
    setHelpTopic: (e, t) => {
      e.helpTopic = t.payload;
    },
    setOpenPopupAction: (e, t) => {
      e.popupAction = t.payload;
    }
  }
}), {
  setConfiguratorApp: w7,
  setConfiguratorGroup: T8t,
  setConfiguratorVariable: M8t,
  setShowEditorUi: P8t,
  setSearchString: U8t,
  setDynamicSettings: yct,
  setDevmode: z8t,
  setHelpTopic: O8t,
  setPreviewDevice: Wct,
  setShowThemeDialog: Q8t,
  setShowMobileThemeDialog: j8t,
  setOpenPopupAction: Sct
} = V7.actions, Vct = V7.reducer, wct = {
  customData: null
}, v7 = pr({
  name: "customData",
  initialState: wct,
  reducers: {
    setCustomData: (e, t) => {
      e.customData = t.payload;
    }
  }
}), {
  setCustomData: q8t
} = v7.actions, vct = v7.reducer, Rct = {
  app: void 0,
  arDialog: !1,
  currentAction: null,
  configurationInitialization: null,
  configuration: null,
  componentsInitialLoadingStates: {
    K3DSceneLoaded: !1,
    K3AppLoaded: !1,
    K3ValiditiesLoaded: !1
  }
}, R7 = pr({
  name: "frontend",
  initialState: Rct,
  reducers: {
    setFrontendApp: (e, t) => {
      e.app = t.payload;
    },
    setConfigurationInitialization: (e, t) => {
      e.configurationInitialization = t.payload;
    },
    setConfiguration: (e, t) => {
      e.configuration = t.payload;
    },
    setArDialog: (e, t) => {
      e.arDialog = t.payload;
    },
    setCurrentAction: (e, t) => {
      e.currentAction = t.payload;
    },
    setComponentLoadingStateForComponent: (e, t) => {
      var i, n;
      e.componentsInitialLoadingStates[t.payload.component] !== t.payload.value && (e.componentsInitialLoadingStates[t.payload.component] = t.payload.value, t.payload.value && ((i = window.top) == null || i.postMessage({
        type: t.payload.component
      }, "*")), e.componentsInitialLoadingStates.K3DSceneLoaded && e.componentsInitialLoadingStates.K3AppLoaded && e.componentsInitialLoadingStates.K3ValiditiesLoaded && ((n = window.top) == null || n.postMessage({
        type: "K3FullyLoaded"
      }, "*")));
    }
  }
}), {
  setFrontendApp: Xct,
  setConfigurationInitialization: X7,
  setConfiguration: Hct,
  setArDialog: kct,
  setCurrentAction: aA,
  setComponentLoadingStateForComponent: H7
} = R7.actions, Yct = R7.reducer, Fct = {
  isSceneLoading: !0,
  loadedModelIds: void 0,
  screenshotting: null,
  isScreenshottingPossible: !1,
  nextCameraPosition: null,
  forceNextCameraPosition: void 0,
  modelRuleData: {},
  editMode: !1,
  usedByDynamic: [],
  loadingStatus: {},
  sceneContext: {}
}, k7 = pr({
  name: "k3d",
  initialState: Fct,
  reducers: {
    setModelRuleData: (e, t) => {
      e.modelRuleData[t.payload.ruleItemId] = t.payload;
    },
    clearModelRuleData: (e) => {
      e.modelRuleData = {};
    },
    setEditMode: (e, {
      payload: t
    }) => {
      e.editMode = t;
    },
    setUsedByDynamic: (e, {
      payload: t
    }) => {
      e.usedByDynamic = Array.from(/* @__PURE__ */ new Set([...e.usedByDynamic, ...t]));
    },
    setSceneContext: (e, t) => {
      e.sceneContext = t.payload;
    },
    setIsRenderingScreenshot: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isRenderingScreenshot: t.payload
      };
    },
    setIsAR: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isAR: t.payload
      };
    },
    setIsVR: (e, t) => {
      e.sceneContext = {
        ...e.sceneContext,
        isVR: t.payload
      };
    },
    setScreenshotting: (e, t) => {
      t.payload === "creating" && (e.sceneContext.isRenderingScreenshot = !0), e.screenshotting = t.payload;
    },
    setIsScreenshottingPossible: (e, t) => {
      e.isScreenshottingPossible = t.payload;
    },
    resetScreenshotting: (e) => {
      const {
        screenshotting: t
      } = e;
      de.isArray(t) && t.forEach((i) => URL.revokeObjectURL(i.file)), e.screenshotting = null, e.sceneContext.isRenderingScreenshot = !1;
    },
    setNextCameraPosition: (e, t) => {
      e.nextCameraPosition = t.payload;
    },
    forceNextCameraPosition: (e) => {
      e.forceNextCameraPosition = de.uniqueId("forceNextCameraPosition_");
    },
    setIsSceneLoading: (e, t) => {
      e.isSceneLoading = t.payload;
    },
    setLoadedModelIds: (e, t) => {
      e.loadedModelIds = t.payload;
    }
  }
}), {
  setModelRuleData: xct,
  clearModelRuleData: WT,
  setEditMode: SY,
  setUsedByDynamic: Kx,
  setScreenshotting: Tx,
  setIsScreenshottingPossible: ST,
  resetScreenshotting: Dct,
  setNextCameraPosition: Y7,
  forceNextCameraPosition: _8t,
  setSceneContext: $8t,
  setIsRenderingScreenshot: eqt,
  setIsAR: tqt,
  setIsVR: iqt,
  setIsSceneLoading: F7,
  setLoadedModelIds: Jct
} = k7.actions, Ect = k7.reducer, Nct = {
  switchVariables: {}
}, x7 = pr({
  name: "layoutDesigner",
  initialState: Nct,
  reducers: {
    setSwitchVariable: (e, t) => {
      e.switchVariables[t.payload.key] = t.payload.value;
    }
  }
}), {
  setSwitchVariable: nqt
} = x7.actions, Lct = x7.reducer, D7 = pr({
  name: "articles",
  initialState: [],
  reducers: {
    createArticle: (e, t) => [...e, t.payload],
    deleteArticle: (e, t) => e.filter((i) => i.id !== t.payload),
    deleteArticles: (e, t) => e.filter((i) => !t.payload.includes(i.id)),
    setArticles: (e, t) => t.payload,
    updateArticle: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateArticles: (e, t) => {
      const i = de.keyBy(t.payload, (n) => n.id);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createArticle: rqt,
  deleteArticle: gqt,
  deleteArticles: oqt,
  setArticles: J7,
  updateArticle: lqt,
  updateArticles: aqt
} = D7.actions, Kct = D7.reducer, Tct = {
  client: null
}, E7 = pr({
  name: "client",
  initialState: Tct,
  reducers: {
    setClient: (e, t) => {
      e.client = t.payload;
    }
  }
}), {
  setClient: Mct
} = E7.actions, Pct = E7.reducer, N7 = pr({
  name: "groups",
  initialState: [],
  reducers: {
    setGroups: (e, t) => t.payload || [],
    createGroup: (e, t) => [...e, t.payload],
    deleteGroup: (e, t) => e.filter((i) => i.id !== t.payload.id),
    updateGroup: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateGroups: (e, t) => {
      const i = An(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createGroup: sqt,
  deleteGroup: Iqt,
  updateGroup: cqt,
  updateGroups: dqt,
  setGroups: L7
} = N7.actions, Uct = N7.reducer, K7 = pr({
  name: "images",
  initialState: [],
  reducers: {
    createImage: (e, t) => [...e, t.payload],
    deleteImage: (e, t) => e.filter((i) => i.id !== t.payload),
    setImages: (e, t) => t.payload,
    updateImage: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createImage: uqt,
  deleteImage: Cqt,
  setImages: T7,
  updateImage: Aqt
} = K7.actions, zct = K7.reducer, M7 = pr({
  name: "materials",
  initialState: [],
  reducers: {
    createMaterial: (e, t) => [...e, t.payload],
    deleteMaterial: (e, t) => e.filter((i) => i.id !== t.payload),
    setMaterials: (e, t) => t.payload,
    updateMaterial: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createMaterial: bqt,
  deleteMaterial: hqt,
  setMaterials: P7,
  updateMaterial: mqt
} = M7.actions, Oct = M7.reducer, U7 = pr({
  name: "models",
  initialState: [],
  reducers: {
    createModel: (e, t) => [...e, t.payload],
    deleteModel: (e, t) => e.filter((i) => i.id !== t.payload),
    setModels: (e, t) => t.payload,
    updateModel: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i)
  }
}), {
  createModel: pqt,
  deleteModel: Bqt,
  setModels: z7,
  updateModel: Qct
} = U7.actions, jct = U7.reducer, O7 = pr({
  name: "prices",
  initialState: [],
  reducers: {
    createPrice: (e, t) => [...e, t.payload],
    deletePrice: (e, t) => e.filter((i) => i.id !== t.payload),
    setPrices: (e, t) => t.payload,
    updatePrice: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    setBOM: (e, t) => t.payload
  }
}), {
  createPrice: fqt,
  deletePrice: Zqt,
  setPrices: Q7,
  updatePrice: Gqt
} = O7.actions, qct = O7.reducer, j7 = pr({
  name: "ruleItems",
  initialState: [],
  reducers: {
    setRuleItems: (e, t) => t.payload,
    createRuleItem: (e, t) => [...e, t.payload],
    deleteRuleItem: (e, t) => e.filter((i) => i.id !== t.payload),
    updateRuleItem: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateRuleItems: (e, t) => {
      const i = An(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createRuleItem: yqt,
  deleteRuleItem: Wqt,
  updateRuleItem: _ct,
  updateRuleItems: Sqt,
  setRuleItems: q7
} = j7.actions, $ct = j7.reducer, _7 = pr({
  name: "rules",
  initialState: [],
  reducers: {
    setRules: (e, t) => t.payload,
    createRule: (e, t) => [...e, t.payload],
    deleteRule: (e, t) => e.filter((i) => i.id !== t.payload),
    updateRule: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateRules: (e, t) => {
      const i = An(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createRule: Vqt,
  updateRule: wqt,
  deleteRule: vqt,
  setRules: $7
} = _7.actions, edt = _7.reducer, e8 = pr({
  name: "values",
  initialState: [],
  reducers: {
    setValues: (e, t) => t.payload,
    createValue: (e, t) => [...e, t.payload],
    deleteValue: (e, t) => e.filter((i) => i.id !== t.payload),
    updateValue: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateValues: (e, t) => {
      const i = t.payload;
      return e.map((n) => i.find((r) => r.id == n.id) || n);
    }
  }
}), {
  createValue: t8,
  deleteValue: tdt,
  updateValue: Rqt,
  updateValues: Xqt,
  setValues: i8
} = e8.actions, idt = e8.reducer, n8 = pr({
  name: "variables",
  initialState: [],
  reducers: {
    setVariables: (e, t) => t.payload,
    createVariable: (e, t) => [...e, t.payload],
    deleteVariable: (e, t) => e.filter((i) => i.id !== t.payload),
    updateVariable: (e, t) => e.map((i) => i.id == t.payload.id ? t.payload : i),
    updateVariables: (e, t) => {
      const i = An(t.payload);
      return e.map((n) => i[n.id] || n);
    }
  }
}), {
  createVariable: Hqt,
  deleteVariable: kqt,
  updateVariable: Yqt,
  updateVariables: Fqt,
  setVariables: r8
} = n8.actions, ndt = n8.reducer, VT = {
  privateData: {
    name: "",
    email: "",
    phone: "",
    address: "",
    remark: "",
    company: "",
    taxID: "",
    checkbox: !1,
    city: "",
    zip: "",
    country: ""
  },
  privateDataText: "Die Datenschutzhinweise habe ich zur Kenntnis genommen und akzeptiere sie."
}, g8 = pr({
  name: "order",
  initialState: VT,
  reducers: {
    updatePrivateData: (e, t) => {
      e.privateData = t.payload;
    },
    resetPrivateData: (e) => {
      e.privateData = VT.privateData;
    }
  }
}), {
  updatePrivateData: xqt,
  resetPrivateData: rdt
} = g8.actions, gdt = g8.reducer, o8 = [], Rc = (e) => e.metadata.ruleItems ?? o8;
Ci(Rc, (e) => An(e));
const odt = Ci([Rc], (e) => de.mapValues(de.groupBy(e, (t) => t.ruleId), (t) => t.sort(gA))), Dqt = (e) => (t) => {
  var i;
  return ((i = odt(t)) == null ? void 0 : i[e]) ?? o8;
}, ldt = (e) => (t) => Rc(t).filter((i) => de.some(i.values, (n) => Fye(n) ? n === e : xye(n) ? n.includes(e) : cw(n) ? n.modelId == e : (Dye(n), !1))), adt = Ci(Rc, (e) => e.filter((t) => Object.values(t.values).find(YJ)));
Ci(adt, V6, (e, t) => e.map((i) => t[i.ruleId].columns.filter((r) => jj(r)).map((r) => r.targetId)).flat());
const sdt = (e) => (t) => ldt(e)(t).flatMap((i) => {
  if (Object.values(i.values).find(YJ))
    return xJ(i.ruleId)(t).columns.filter(jj).map((o) => o.targetId);
}).filter(Boolean), l8 = Ci(Rc, (e) => e.flatMap((t) => Object.values(t.values).filter(kJ))), Idt = [], $l = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.metadata) == null ? void 0 : t.values) ?? Idt;
}, t9 = Ci($l, (e) => An(e)), i9 = Ci([$l], (e) => de.groupBy(e, (t) => t.variableId)), kv = Le.curry((e, t) => e ? $l(t).filter((i) => i.variableId == e).slice().sort(h6) : []), pA = (e) => (t) => e ? $l(t).find((i) => i.id == e) : void 0, cdt = (e) => (t) => $l(t).find((i) => i.key == e), Jqt = Ci([$l, (e, t) => t], (e, t) => e.filter((i) => i.appId == t)), n9 = Ci([(e, t) => t, i9, l8], (e, t, i) => {
  const n = t[e], r = An(n);
  return i.some((g) => r[g.valueId]);
}), ddt = (e) => ({
  free: e.free,
  locked: {
    ...e.locked,
    touched: {}
  },
  all: {
    ...e.all,
    touched: {}
  }
}), Yv = (e, t, i, n = !1) => {
  const r = de.cloneDeep(t.all.touched);
  return i.forEach((g) => {
    const o = e.variables.byVarId.all[g.variableId];
    o && (!n && mv(o, e, t, g.instanceId) || (r[g.instanceId] || (r[g.instanceId] = []), r[g.instanceId].includes(g.variableId) || r[g.instanceId].push(g.variableId)));
  }), {
    free: t.free,
    locked: {
      ...t.locked,
      touched: r
    },
    all: {
      ...t.all,
      touched: r
    }
  };
}, udt = (e, t, i) => {
  const n = t.state.locked.selections.filter((r) => r.instance.isInstanceLauncher && !n9(i, r.variableId)).map((r) => ({
    instanceId: r.instance.id,
    variableId: r.variableId
  }));
  return {
    ...t,
    state: Yv(e, t.state, n)
  };
}, Cdt = {
  openInstances: [Ut],
  ruleEngineInput: null,
  ruleEngineState: null,
  ruleEngineConflict: null,
  ruleEngineError: void 0
}, a8 = pr({
  name: "common",
  initialState: Cdt,
  reducers: {
    setRuleEngineInput: (e, t) => {
      e.ruleEngineInput = t.payload;
    },
    setRuleEngineState: (e, t) => {
      e.ruleEngineState = t.payload;
    },
    setRuleEngineConflict: (e, t) => {
      e.ruleEngineConflict = t.payload;
    },
    addOpenInstance: (e, t) => {
      e.openInstances = de.uniqBy([...e.openInstances.filter((i) => i.id === Ut.id || i.instance.belongsToInstanceId !== t.payload.instance.belongsToInstanceId), t.payload], (i) => i.id);
    },
    setOpenInstance: (e, t) => {
      e.openInstances = de.uniqBy([t.payload], (i) => i.id);
    },
    setOpenInstances: (e, t) => {
      e.openInstances = de.uniqBy(t.payload, (i) => i.id);
    },
    removeOpenInstance: (e, t) => {
      e.openInstances = e.openInstances.filter((i) => i.id !== t.payload.id);
    },
    resetTouched: (e) => {
      e.ruleEngineState && (e.ruleEngineState.state = ddt(e.ruleEngineState.state));
    },
    setRuleEngineError: (e, t) => {
      e.ruleEngineError = t.payload;
    }
  }
}), {
  setRuleEngineInput: Adt,
  setRuleEngineState: s8,
  setRuleEngineConflict: mw,
  addOpenInstance: Eqt,
  setOpenInstance: Nqt,
  setOpenInstances: I8,
  removeOpenInstance: Lqt,
  resetTouched: bdt,
  setRuleEngineError: wT
} = a8.actions, hdt = a8.reducer, mdt = () => LGe({
  reducer: {
    actionEngine: act,
    bom: cct,
    common: fct,
    configurator: Vct,
    customData: vct,
    frontend: Yct,
    k3d: Ect,
    cameraPreview: uct,
    layoutDesigner: Lct,
    metadata: e6({
      articles: Kct,
      client: Pct,
      groups: Uct,
      images: zct,
      materials: Oct,
      models: jct,
      prices: qct,
      ruleItems: $ct,
      rules: edt,
      values: idt,
      variables: ndt
    }),
    order: gdt,
    ruleEngine: hdt
  },
  middleware: (e) => {
    const t = sl.enableReduxDevChecks;
    return e({
      immutableCheck: t,
      serializableCheck: t ? {
        ignoredPaths: ["ruleEngine.ruleEngineInput.variables", "ruleEngine.ruleEngineConflict.ruleEngineInput.variables"],
        ignoredActionPaths: ["payload.variables", "payload.ruleEngineInput.variables"]
      } : !1,
      actionCreatorCheck: t,
      thunk: !0
    });
  }
}), r9 = mdt(), g9 = (e) => e, c8 = (...e) => Object.assign(e), pdt = {
  "html, body, #root": {
    margin: 0,
    height: "100%"
  }
}, Bdt = {
  ...pdt,
  a: {
    textDecoration: "none",
    color: "rgba(0, 0, 0, 0.6)"
  },
  canvas: {
    border: "none",
    outline: "none"
  }
};
function fdt() {
  Zdt() || document.body.classList.add("force-show-scrollbars");
}
function Zdt() {
  const e = document.createElement("div"), t = document.createElement("div");
  e.style.width = "30px", e.style.height = "30px", e.style.overflow = "scroll", e.style.borderWidth = "0", t.style.width = "30px", t.style.height = "60px", e.appendChild(t), document.body.appendChild(e);
  const i = e.offsetWidth - e.clientWidth;
  return document.body.removeChild(e), i > 0;
}
const Gdt = (e) => ({
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: `${e} transparent`
  },
  "*::-webkit-scrollbar": {
    width: "5px"
  },
  "*::-webkit-scrollbar-track": {
    backgroundColor: "transparent"
  },
  "*::-webkit-scrollbar-thumb": {
    background: `${e}`,
    borderRadius: "2px"
  },
  "*::-webkit-scrollbar-thumb:hover": {
    background: `linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1)) ${e}`
  }
}), ydt = {
  ".force-show-scrollbars ::-webkit-scrollbar": {
    webkitAppearance: "none"
    // "background-color": "#FAFAFA",
  },
  ".force-show-scrollbars ::-webkit-scrollbar-thumb": {
    backgroundClip: "padding-box",
    borderColor: "transparent",
    borderStyle: "solid",
    borderWidth: "1px 0px 1px 0px"
    /* Workaround because margins aren't supported */
  }
};
var d8 = { exports: {} };
(function(e, t) {
  (function(i) {
    e.exports = i();
  })(function() {
    var i = ["navigation", "request", "process", "log", "user", "state", "error", "manual"], n = function(D, z, _) {
      for (var q = _, se = 0, he = D.length; se < he; se++)
        q = z(q, D[se], se, D);
      return q;
    }, r = function(D, z) {
      return n(D, function(_, q, se, he) {
        return z(q, se, he) ? _.concat(q) : _;
      }, []);
    }, g = function(D, z) {
      return n(D, function(_, q, se, he) {
        return _ === !0 || q === z;
      }, !1);
    }, o = function(D) {
      return Object.prototype.toString.call(D) === "[object Array]";
    }, l = !{
      toString: null
    }.propertyIsEnumerable("toString"), a = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], I = function(D) {
      var z = [], _;
      for (_ in D)
        Object.prototype.hasOwnProperty.call(D, _) && z.push(_);
      if (!l)
        return z;
      for (var q = 0, se = a.length; q < se; q++)
        Object.prototype.hasOwnProperty.call(D, a[q]) && z.push(a[q]);
      return z;
    }, c = function(D, z) {
      return D === void 0 && (D = 1), function(_) {
        return typeof _ == "number" && parseInt("" + _, 10) === _ && _ >= D && _ <= z;
      };
    }, d = function(D) {
      return typeof D == "function" || o(D) && r(D, function(z) {
        return typeof z == "function";
      }).length === D.length;
    }, C = function(D) {
      return typeof D == "string" && !!D.length;
    }, A = {}, b = function() {
      return {
        unhandledExceptions: !0,
        unhandledRejections: !0
      };
    };
    A.schema = {
      apiKey: {
        defaultValue: function() {
          return null;
        },
        message: "is required",
        validate: C
      },
      appVersion: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(D) {
          return D === void 0 || C(D);
        }
      },
      appType: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(D) {
          return D === void 0 || C(D);
        }
      },
      autoDetectErrors: {
        defaultValue: function() {
          return !0;
        },
        message: "should be true|false",
        validate: function(D) {
          return D === !0 || D === !1;
        }
      },
      enabledErrorTypes: {
        defaultValue: function() {
          return b();
        },
        message: "should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }",
        allowPartialObject: !0,
        validate: function(D) {
          if (typeof D != "object" || !D)
            return !1;
          var z = I(D), _ = I(b());
          return !(r(z, function(q) {
            return g(_, q);
          }).length < z.length || r(I(D), function(q) {
            return typeof D[q] != "boolean";
          }).length > 0);
        }
      },
      onError: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: d
      },
      onSession: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: d
      },
      onBreadcrumb: {
        defaultValue: function() {
          return [];
        },
        message: "should be a function or array of functions",
        validate: d
      },
      endpoints: {
        defaultValue: function() {
          return {
            notify: "https://notify.bugsnag.com",
            sessions: "https://sessions.bugsnag.com"
          };
        },
        message: "should be an object containing endpoint URLs { notify, sessions }",
        validate: function(D) {
          return (
            // first, ensure it's an object
            D && typeof D == "object" && // notify and sessions must always be set
            C(D.notify) && C(D.sessions) && // ensure no keys other than notify/session are set on endpoints object
            r(I(D), function(z) {
              return !g(["notify", "sessions"], z);
            }).length === 0
          );
        }
      },
      autoTrackSessions: {
        defaultValue: function(D) {
          return !0;
        },
        message: "should be true|false",
        validate: function(D) {
          return D === !0 || D === !1;
        }
      },
      enabledReleaseStages: {
        defaultValue: function() {
          return null;
        },
        message: "should be an array of strings",
        validate: function(D) {
          return D === null || o(D) && r(D, function(z) {
            return typeof z == "string";
          }).length === D.length;
        }
      },
      releaseStage: {
        defaultValue: function() {
          return "production";
        },
        message: "should be a string",
        validate: function(D) {
          return typeof D == "string" && D.length;
        }
      },
      maxBreadcrumbs: {
        defaultValue: function() {
          return 25;
        },
        message: "should be a number ≤100",
        validate: function(D) {
          return c(0, 100)(D);
        }
      },
      enabledBreadcrumbTypes: {
        defaultValue: function() {
          return i;
        },
        message: "should be null or a list of available breadcrumb types (" + i.join(",") + ")",
        validate: function(D) {
          return D === null || o(D) && n(D, function(z, _) {
            return z === !1 ? z : g(i, _);
          }, !0);
        }
      },
      context: {
        defaultValue: function() {
        },
        message: "should be a string",
        validate: function(D) {
          return D === void 0 || typeof D == "string";
        }
      },
      user: {
        defaultValue: function() {
          return {};
        },
        message: "should be an object with { id, email, name } properties",
        validate: function(D) {
          return D === null || D && n(I(D), function(z, _) {
            return z && g(["id", "email", "name"], _);
          }, !0);
        }
      },
      metadata: {
        defaultValue: function() {
          return {};
        },
        message: "should be an object",
        validate: function(D) {
          return typeof D == "object" && D !== null;
        }
      },
      logger: {
        defaultValue: function() {
        },
        message: "should be null or an object with methods { debug, info, warn, error }",
        validate: function(D) {
          return !D || D && n(["debug", "info", "warn", "error"], function(z, _) {
            return z && typeof D[_] == "function";
          }, !0);
        }
      },
      redactedKeys: {
        defaultValue: function() {
          return ["password"];
        },
        message: "should be an array of strings|regexes",
        validate: function(D) {
          return o(D) && D.length === r(D, function(z) {
            return typeof z == "string" || z && typeof z.test == "function";
          }).length;
        }
      },
      plugins: {
        defaultValue: function() {
          return [];
        },
        message: "should be an array of plugin objects",
        validate: function(D) {
          return o(D) && D.length === r(D, function(z) {
            return z && typeof z == "object" && typeof z.load == "function";
          }).length;
        }
      },
      featureFlags: {
        defaultValue: function() {
          return [];
        },
        message: 'should be an array of objects that have a "name" property',
        validate: function(D) {
          return o(D) && D.length === r(D, function(z) {
            return z && typeof z == "object" && typeof z.name == "string";
          }).length;
        }
      }
    };
    var m = function(D) {
      for (var z = 1; z < arguments.length; z++) {
        var _ = arguments[z];
        for (var q in _)
          Object.prototype.hasOwnProperty.call(_, q) && (D[q] = _[q]);
      }
      return D;
    }, p = function(D, z) {
      return n(D, function(_, q, se, he) {
        return _.concat(z(q, se, he));
      }, []);
    };
    function B() {
      return B = Object.assign ? Object.assign.bind() : function(D) {
        for (var z = 1; z < arguments.length; z++) {
          var _ = arguments[z];
          for (var q in _)
            Object.prototype.hasOwnProperty.call(_, q) && (D[q] = _[q]);
        }
        return D;
      }, B.apply(this, arguments);
    }
    var f = A.schema, Z = {
      releaseStage: m({}, f.releaseStage, {
        defaultValue: function() {
          return /^localhost(:\d+)?$/.test(window.location.host) ? "development" : "production";
        }
      }),
      appType: B({}, f.appType, {
        defaultValue: function() {
          return "browser";
        }
      }),
      logger: m({}, f.logger, {
        defaultValue: function() {
          return (
            // set logger based on browser capability
            typeof console < "u" && typeof console.debug == "function" ? y() : void 0
          );
        }
      })
    }, y = function() {
      var D = {}, z = console.log;
      return p(["debug", "info", "warn", "error"], function(_) {
        var q = console[_];
        D[_] = typeof q == "function" ? q.bind(console, "[bugsnag]") : z.bind(console, "[bugsnag]");
      }), D;
    }, W = /* @__PURE__ */ function() {
      function D(_, q, se, he) {
        he === void 0 && (he = /* @__PURE__ */ new Date()), this.type = se, this.message = _, this.metadata = q, this.timestamp = he;
      }
      var z = D.prototype;
      return z.toJSON = function() {
        return {
          type: this.type,
          name: this.message,
          timestamp: this.timestamp,
          metaData: this.metadata
        };
      }, D;
    }(), V = W, w = {};
    (function(D, z) {
      typeof w == "object" ? w = z() : D.StackFrame = z();
    })(this, function() {
      function D(Wt) {
        return !isNaN(parseFloat(Wt)) && isFinite(Wt);
      }
      function z(Wt) {
        return Wt.charAt(0).toUpperCase() + Wt.substring(1);
      }
      function _(Wt) {
        return function() {
          return this[Wt];
        };
      }
      var q = ["isConstructor", "isEval", "isNative", "isToplevel"], se = ["columnNumber", "lineNumber"], he = ["fileName", "functionName", "source"], Ye = ["args"], at = q.concat(se, he, Ye);
      function je(Wt) {
        if (Wt instanceof Object)
          for (var yi = 0; yi < at.length; yi++)
            Wt.hasOwnProperty(at[yi]) && Wt[at[yi]] !== void 0 && this["set" + z(at[yi])](Wt[at[yi]]);
      }
      je.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(Wt) {
          if (Object.prototype.toString.call(Wt) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = Wt;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(Wt) {
          if (Wt instanceof je)
            this.evalOrigin = Wt;
          else if (Wt instanceof Object)
            this.evalOrigin = new je(Wt);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var Wt = this.getFunctionName() || "{anonymous}", yi = "(" + (this.getArgs() || []).join(",") + ")", Zi = this.getFileName() ? "@" + this.getFileName() : "", Yn = D(this.getLineNumber()) ? ":" + this.getLineNumber() : "", gi = D(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";
          return Wt + yi + Zi + Yn + gi;
        }
      };
      for (var pt = 0; pt < q.length; pt++)
        je.prototype["get" + z(q[pt])] = _(q[pt]), je.prototype["set" + z(q[pt])] = /* @__PURE__ */ function(Wt) {
          return function(yi) {
            this[Wt] = !!yi;
          };
        }(q[pt]);
      for (var Ft = 0; Ft < se.length; Ft++)
        je.prototype["get" + z(se[Ft])] = _(se[Ft]), je.prototype["set" + z(se[Ft])] = /* @__PURE__ */ function(Wt) {
          return function(yi) {
            if (!D(yi))
              throw new TypeError(Wt + " must be a Number");
            this[Wt] = Number(yi);
          };
        }(se[Ft]);
      for (var qt = 0; qt < he.length; qt++)
        je.prototype["get" + z(he[qt])] = _(he[qt]), je.prototype["set" + z(he[qt])] = /* @__PURE__ */ function(Wt) {
          return function(yi) {
            this[Wt] = String(yi);
          };
        }(he[qt]);
      return je;
    });
    var v = {};
    (function(D, z) {
      typeof v == "object" ? v = z(w) : D.ErrorStackParser = z(D.StackFrame);
    })(this, function(z) {
      var _ = /(^|@)\S+\:\d+/, q = /^\s*at .*(\S+\:\d+|\(native\))/m, se = /^(eval@)?(\[native code\])?$/;
      return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function(Ye) {
          if (typeof Ye.stacktrace < "u" || typeof Ye["opera#sourceloc"] < "u")
            return this.parseOpera(Ye);
          if (Ye.stack && Ye.stack.match(q))
            return this.parseV8OrIE(Ye);
          if (Ye.stack)
            return this.parseFFOrSafari(Ye);
          throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function(Ye) {
          if (Ye.indexOf(":") === -1)
            return [Ye];
          var at = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/, je = at.exec(Ye.replace(/[\(\)]/g, ""));
          return [je[1], je[2] || void 0, je[3] || void 0];
        },
        parseV8OrIE: function(Ye) {
          var at = Ye.stack.split(`
`).filter(function(je) {
            return !!je.match(q);
          }, this);
          return at.map(function(je) {
            je.indexOf("(eval ") > -1 && (je = je.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, ""));
            var pt = je.replace(/^\s+/, "").replace(/\(eval code/g, "("), Ft = pt.match(/ (\((.+):(\d+):(\d+)\)$)/);
            pt = Ft ? pt.replace(Ft[0], "") : pt;
            var qt = pt.split(/\s+/).slice(1), Wt = this.extractLocation(Ft ? Ft[1] : qt.pop()), yi = qt.join(" ") || void 0, Zi = ["eval", "<anonymous>"].indexOf(Wt[0]) > -1 ? void 0 : Wt[0];
            return new z({
              functionName: yi,
              fileName: Zi,
              lineNumber: Wt[1],
              columnNumber: Wt[2],
              source: je
            });
          }, this);
        },
        parseFFOrSafari: function(Ye) {
          var at = Ye.stack.split(`
`).filter(function(je) {
            return !je.match(se);
          }, this);
          return at.map(function(je) {
            if (je.indexOf(" > eval") > -1 && (je = je.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1")), je.indexOf("@") === -1 && je.indexOf(":") === -1)
              return new z({
                functionName: je
              });
            var pt = /((.*".+"[^@]*)?[^@]*)(?:@)/, Ft = je.match(pt), qt = Ft && Ft[1] ? Ft[1] : void 0, Wt = this.extractLocation(je.replace(pt, ""));
            return new z({
              functionName: qt,
              fileName: Wt[0],
              lineNumber: Wt[1],
              columnNumber: Wt[2],
              source: je
            });
          }, this);
        },
        parseOpera: function(Ye) {
          return !Ye.stacktrace || Ye.message.indexOf(`
`) > -1 && Ye.message.split(`
`).length > Ye.stacktrace.split(`
`).length ? this.parseOpera9(Ye) : Ye.stack ? this.parseOpera11(Ye) : this.parseOpera10(Ye);
        },
        parseOpera9: function(Ye) {
          for (var at = /Line (\d+).*script (?:in )?(\S+)/i, je = Ye.message.split(`
`), pt = [], Ft = 2, qt = je.length; Ft < qt; Ft += 2) {
            var Wt = at.exec(je[Ft]);
            Wt && pt.push(new z({
              fileName: Wt[2],
              lineNumber: Wt[1],
              source: je[Ft]
            }));
          }
          return pt;
        },
        parseOpera10: function(Ye) {
          for (var at = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, je = Ye.stacktrace.split(`
`), pt = [], Ft = 0, qt = je.length; Ft < qt; Ft += 2) {
            var Wt = at.exec(je[Ft]);
            Wt && pt.push(new z({
              functionName: Wt[3] || void 0,
              fileName: Wt[2],
              lineNumber: Wt[1],
              source: je[Ft]
            }));
          }
          return pt;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function(Ye) {
          var at = Ye.stack.split(`
`).filter(function(je) {
            return !!je.match(_) && !je.match(/^Error created at/);
          }, this);
          return at.map(function(je) {
            var pt = je.split("@"), Ft = this.extractLocation(pt.pop()), qt = pt.shift() || "", Wt = qt.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || void 0, yi;
            qt.match(/\(([^\)]*)\)/) && (yi = qt.replace(/^[^\(]+\(([^\)]*)\)$/, "$1"));
            var Zi = yi === void 0 || yi === "[arguments not available]" ? void 0 : yi.split(",");
            return new z({
              functionName: Wt,
              args: Zi,
              fileName: Ft[0],
              lineNumber: Ft[1],
              columnNumber: Ft[2],
              source: je
            });
          }, this);
        }
      };
    });
    var H = v, x = function(D, z, _, q) {
      var se = q && q.redactedKeys ? q.redactedKeys : [], he = q && q.redactedPaths ? q.redactedPaths : [];
      return JSON.stringify(He(D, se, he), z, _);
    }, J = 20, K = 25e3, M = 8, L = "...";
    function N(D) {
      return D instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(D));
    }
    function U(D) {
      return "[Throws: " + (D ? D.message : "?") + "]";
    }
    function O(D, z) {
      for (var _ = 0, q = D.length; _ < q; _++)
        if (D[_] === z)
          return !0;
      return !1;
    }
    function $(D, z) {
      for (var _ = 0, q = D.length; _ < q; _++)
        if (z.indexOf(D[_]) === 0)
          return !0;
      return !1;
    }
    function ne(D, z) {
      for (var _ = 0, q = D.length; _ < q; _++)
        if (typeof D[_] == "string" && D[_].toLowerCase() === z.toLowerCase() || D[_] && typeof D[_].test == "function" && D[_].test(z))
          return !0;
      return !1;
    }
    function be(D) {
      return Object.prototype.toString.call(D) === "[object Array]";
    }
    function Ve(D, z) {
      try {
        return D[z];
      } catch (_) {
        return U(_);
      }
    }
    function He(D, z, _) {
      var q = [], se = 0;
      function he(Ye, at) {
        function je() {
          return at.length > M && se > K;
        }
        if (se++, at.length > J || je())
          return L;
        if (Ye === null || typeof Ye != "object")
          return Ye;
        if (O(q, Ye))
          return "[Circular]";
        if (q.push(Ye), typeof Ye.toJSON == "function")
          try {
            se--;
            var pt = he(Ye.toJSON(), at);
            return q.pop(), pt;
          } catch (Yi) {
            return U(Yi);
          }
        var Ft = N(Ye);
        if (Ft) {
          se--;
          var qt = he({
            name: Ye.name,
            message: Ye.message
          }, at);
          return q.pop(), qt;
        }
        if (be(Ye)) {
          for (var Wt = [], yi = 0, Zi = Ye.length; yi < Zi; yi++) {
            if (je()) {
              Wt.push(L);
              break;
            }
            Wt.push(he(Ye[yi], at.concat("[]")));
          }
          return q.pop(), Wt;
        }
        var Yn = {};
        try {
          for (var gi in Ye)
            if (Object.prototype.hasOwnProperty.call(Ye, gi)) {
              if ($(_, at.join(".")) && ne(z, gi)) {
                Yn[gi] = "[REDACTED]";
                continue;
              }
              if (je()) {
                Yn[gi] = L;
                break;
              }
              Yn[gi] = he(Ve(Ye, gi), at.concat(gi));
            }
        } catch {
        }
        return q.pop(), Yn;
      }
      return he(D, []);
    }
    function Je(D, z, _, q) {
      if (typeof _ == "string") {
        q === void 0 ? q = null : q !== null && typeof q != "string" && (q = x(q));
        var se = z[_];
        if (typeof se == "number") {
          D[se] = {
            name: _,
            variant: q
          };
          return;
        }
        D.push({
          name: _,
          variant: q
        }), z[_] = D.length - 1;
      }
    }
    function ke(D, z, _) {
      if (o(z)) {
        for (var q = 0; q < z.length; ++q) {
          var se = z[q];
          se === null || typeof se != "object" || Je(D, _, se.name, se.variant);
        }
        return D;
      }
    }
    function we(D) {
      return p(r(D, Boolean), function(z) {
        var _ = z.name, q = z.variant, se = {
          featureFlag: _
        };
        return typeof q == "string" && (se.variant = q), se;
      });
    }
    function ue(D, z, _) {
      var q = z[_];
      typeof q == "number" && (D[q] = null, delete z[_]);
    }
    var Xe = {
      add: Je,
      clear: ue,
      merge: ke,
      toEventApi: we
    }, Ze = function(D) {
      return !!D && (!!D.stack || !!D.stacktrace || !!D["opera#sourceloc"]) && typeof (D.stack || D.stacktrace || D["opera#sourceloc"]) == "string" && D.stack !== D.name + ": " + D.message;
    }, xe = Pe;
    function Pe(D) {
      switch (Object.prototype.toString.call(D)) {
        case "[object Error]":
          return !0;
        case "[object Exception]":
          return !0;
        case "[object DOMException]":
          return !0;
        default:
          return D instanceof Error;
      }
    }
    var st = xe, bt = function(D, z, _, q) {
      var se;
      if (z) {
        var he;
        if (_ === null)
          return Qe(D, z);
        typeof _ == "object" && (he = _), typeof _ == "string" && (he = (se = {}, se[_] = q, se)), he && (z === "__proto__" || z === "constructor" || z === "prototype" || (D[z] || (D[z] = {}), D[z] = m({}, D[z], he)));
      }
    }, it = function(D, z, _) {
      if (typeof z == "string") {
        if (!_)
          return D[z];
        if (D[z])
          return D[z][_];
      }
    }, Qe = function(D, z, _) {
      if (typeof z == "string") {
        if (!_) {
          delete D[z];
          return;
        }
        z === "__proto__" || z === "constructor" || z === "prototype" || D[z] && delete D[z][_];
      }
    }, $e = {
      add: bt,
      get: it,
      clear: Qe
    }, It = {};
    (function(D, z) {
      typeof It == "object" ? It = z(w) : D.StackGenerator = z(D.StackFrame);
    })(this, function(D) {
      return {
        backtrace: function(_) {
          var q = [], se = 10;
          typeof _ == "object" && typeof _.maxStackSize == "number" && (se = _.maxStackSize);
          for (var he = arguments.callee; he && q.length < se && he.arguments; ) {
            for (var Ye = new Array(he.arguments.length), at = 0; at < Ye.length; ++at)
              Ye[at] = he.arguments[at];
            /function(?:\s+([\w$]+))+\s*\(/.test(he.toString()) ? q.push(new D({
              functionName: RegExp.$1 || void 0,
              args: Ye
            })) : q.push(new D({
              args: Ye
            }));
            try {
              he = he.caller;
            } catch {
              break;
            }
          }
          return q;
        }
      };
    });
    var jt = /* @__PURE__ */ function() {
      function D(_, q, se, he, Ye) {
        se === void 0 && (se = []), he === void 0 && (he = Xt()), this.apiKey = void 0, this.context = void 0, this.groupingHash = void 0, this.originalError = Ye, this._handledState = he, this.severity = this._handledState.severity, this.unhandled = this._handledState.unhandled, this.app = {}, this.device = {}, this.request = {}, this.breadcrumbs = [], this.threads = [], this._metadata = {}, this._features = [], this._featuresIndex = {}, this._user = {}, this._session = void 0, this.errors = [ii(_, q, D.__type, se)];
      }
      var z = D.prototype;
      return z.addMetadata = function(q, se, he) {
        return $e.add(this._metadata, q, se, he);
      }, z.getMetadata = function(q, se) {
        return $e.get(this._metadata, q, se);
      }, z.clearMetadata = function(q, se) {
        return $e.clear(this._metadata, q, se);
      }, z.addFeatureFlag = function(q, se) {
        se === void 0 && (se = null), Xe.add(this._features, this._featuresIndex, q, se);
      }, z.addFeatureFlags = function(q) {
        Xe.merge(this._features, q, this._featuresIndex);
      }, z.getFeatureFlags = function() {
        return Xe.toEventApi(this._features);
      }, z.clearFeatureFlag = function(q) {
        Xe.clear(this._features, this._featuresIndex, q);
      }, z.clearFeatureFlags = function() {
        this._features = [], this._featuresIndex = {};
      }, z.getUser = function() {
        return this._user;
      }, z.setUser = function(q, se, he) {
        this._user = {
          id: q,
          email: se,
          name: he
        };
      }, z.toJSON = function() {
        return {
          payloadVersion: "4",
          exceptions: p(this.errors, function(q) {
            return m({}, q, {
              message: q.errorMessage
            });
          }),
          severity: this.severity,
          unhandled: this._handledState.unhandled,
          severityReason: this._handledState.severityReason,
          app: this.app,
          device: this.device,
          request: this.request,
          breadcrumbs: this.breadcrumbs,
          context: this.context,
          groupingHash: this.groupingHash,
          metaData: this._metadata,
          user: this._user,
          session: this._session,
          featureFlags: this.getFeatureFlags()
        };
      }, D;
    }(), Bt = function(D) {
      var z = {
        file: D.fileName,
        method: te(D.functionName),
        lineNumber: D.lineNumber,
        columnNumber: D.columnNumber,
        code: void 0,
        inProject: void 0
      };
      return z.lineNumber > -1 && !z.file && !z.method && (z.file = "global code"), z;
    }, te = function(D) {
      return /^global code$/i.test(D) ? "global code" : D;
    }, Xt = function() {
      return {
        unhandled: !1,
        severity: "warning",
        severityReason: {
          type: "handledException"
        }
      };
    }, Ht = function(D) {
      return typeof D == "string" ? D : "";
    };
    function ii(D, z, _, q) {
      return {
        errorClass: Ht(D),
        errorMessage: Ht(z),
        type: _,
        stacktrace: n(q, function(se, he) {
          var Ye = Bt(he);
          try {
            return JSON.stringify(Ye) === "{}" ? se : se.concat(Ye);
          } catch {
            return se;
          }
        }, [])
      };
    }
    function $t(D) {
      return D.cause ? [D].concat($t(D.cause)) : [D];
    }
    jt.getStacktrace = function(D, z, _) {
      if (Ze(D))
        return H.parse(D).slice(z);
      try {
        return r(It.backtrace(), function(q) {
          return (q.functionName || "").indexOf("StackGenerator$$") === -1;
        }).slice(1 + _);
      } catch {
        return [];
      }
    }, jt.create = function(D, z, _, q, se, he) {
      se === void 0 && (se = 0);
      var Ye = mi(D, z, q, he), at = Ye[0], je = Ye[1], pt;
      try {
        var Ft = jt.getStacktrace(
          at,
          // if an error was created/throw in the normaliseError() function, we need to
          // tell the getStacktrace() function to skip the number of frames we know will
          // be from our own functions. This is added to the number of frames deep we
          // were told about
          je > 0 ? 1 + je + se : 0,
          // if there's no stacktrace, the callstack may be walked to generated one.
          // this is how many frames should be removed because they come from our library
          1 + se
        );
        pt = new jt(at.name, at.message, Ft, _, D);
      } catch {
        pt = new jt(at.name, at.message, [], _, D);
      }
      if (at.name === "InvalidError" && pt.addMetadata("" + q, "non-error parameter", ni(D)), at.cause) {
        var qt, Wt = $t(at).slice(1), yi = p(Wt, function(Zi) {
          var Yn = st(Zi) && Ze(Zi) ? H.parse(Zi) : [], gi = mi(Zi, !0, "error cause"), Yi = gi[0];
          return Yi.name === "InvalidError" && pt.addMetadata("error cause", ni(Zi)), ii(Yi.name, Yi.message, jt.__type, Yn);
        });
        (qt = pt.errors).push.apply(qt, yi);
      }
      return pt;
    };
    var ni = function(D) {
      return D === null ? "null" : D === void 0 ? "undefined" : D;
    }, mi = function(D, z, _, q) {
      var se, he = 0, Ye = function(at) {
        var je = _ === "error cause" ? "was" : "received";
        q && q.warn(_ + " " + je + ' a non-error: "' + at + '"');
        var pt = new Error(_ + " " + je + ' a non-error. See "' + _ + '" tab for more detail.');
        return pt.name = "InvalidError", pt;
      };
      if (!z)
        st(D) ? se = D : (se = Ye(typeof D), he += 2);
      else
        switch (typeof D) {
          case "string":
          case "number":
          case "boolean":
            se = new Error(String(D)), he += 1;
            break;
          case "function":
            se = Ye("function"), he += 2;
            break;
          case "object":
            D !== null && st(D) ? se = D : D !== null && Bi(D) ? (se = new Error(D.message || D.errorMessage), se.name = D.name || D.errorClass, he += 1) : (se = Ye(D === null ? "null" : "unsupported object"), he += 2);
            break;
          default:
            se = Ye("nothing"), he += 2;
        }
      if (!Ze(se))
        try {
          throw se;
        } catch (at) {
          Ze(at) && (se = at, he = 1);
        }
      return [se, he];
    };
    jt.__type = "browserjs";
    var Bi = function(D) {
      return (typeof D.name == "string" || typeof D.errorClass == "string") && (typeof D.message == "string" || typeof D.errorMessage == "string");
    }, ci = jt, Ge = function(D, z, _) {
      var q = 0, se = function() {
        if (q >= D.length)
          return _(null, !0);
        z(D[q], function(he, Ye) {
          if (he)
            return _(he);
          if (Ye === !1)
            return _(null, !1);
          q++, se();
        });
      };
      se();
    }, Be = function(D, z, _, q) {
      var se = function(he, Ye) {
        if (typeof he != "function")
          return Ye(null);
        try {
          if (he.length !== 2) {
            var at = he(z);
            return at && typeof at.then == "function" ? at.then(
              // resolve
              function(je) {
                return setTimeout(function() {
                  return Ye(null, je);
                });
              },
              // reject
              function(je) {
                setTimeout(function() {
                  return _(je), Ye(null, !0);
                });
              }
            ) : Ye(null, at);
          }
          he(z, function(je, pt) {
            if (je)
              return _(je), Ye(null);
            Ye(null, pt);
          });
        } catch (je) {
          _(je), Ye(null);
        }
      };
      Ge(D, se, q);
    }, qe = function(D, z, _, q) {
      for (var se = !1, he = D.slice(); !se && he.length; )
        try {
          se = he.pop()(z) === !1;
        } catch (Ye) {
          q.error("Error occurred in " + _ + " callback, continuing anyway…"), q.error(Ye);
        }
      return se;
    }, vt = function(z, _) {
      var q = "000000000" + z;
      return q.substr(q.length - _);
    }, Kt = typeof window == "object" ? window : self, Te = 0;
    for (var Tt in Kt)
      Object.hasOwnProperty.call(Kt, Tt) && Te++;
    var Ue = navigator.mimeTypes ? navigator.mimeTypes.length : 0, Me = vt((Ue + navigator.userAgent.length).toString(36) + Te.toString(36), 4), Yt = function() {
      return Me;
    }, zt = 0, ri = 4, di = 36, mt = Math.pow(di, ri);
    function Ai() {
      return vt((Math.random() * mt << 0).toString(di), ri);
    }
    function ui() {
      return zt = zt < mt ? zt : 0, zt++, zt - 1;
    }
    function Ui() {
      var D = "c", z = (/* @__PURE__ */ new Date()).getTime().toString(di), _ = vt(ui().toString(di), ri), q = Yt(), se = Ai() + Ai();
      return D + z + _ + q + se;
    }
    Ui.fingerprint = Yt;
    var Oi = Ui, Rn = /* @__PURE__ */ function() {
      function D() {
        this.id = Oi(), this.startedAt = /* @__PURE__ */ new Date(), this._handled = 0, this._unhandled = 0, this._user = {}, this.app = {}, this.device = {};
      }
      var z = D.prototype;
      return z.getUser = function() {
        return this._user;
      }, z.setUser = function(q, se, he) {
        this._user = {
          id: q,
          email: se,
          name: he
        };
      }, z.toJSON = function() {
        return {
          id: this.id,
          startedAt: this.startedAt,
          events: {
            handled: this._handled,
            unhandled: this._unhandled
          }
        };
      }, z._track = function(q) {
        this[q._handledState.unhandled ? "_unhandled" : "_handled"] += 1;
      }, D;
    }(), le = Rn, Ce = Xe.add, pe = Xe.clear, Ne = Xe.merge, Ke = function() {
    }, Jt = /* @__PURE__ */ function() {
      function D(_, q, se, he) {
        var Ye = this;
        q === void 0 && (q = A.schema), se === void 0 && (se = []), this._notifier = he, this._config = {}, this._schema = q, this._delivery = {
          sendSession: Ke,
          sendEvent: Ke
        }, this._logger = {
          debug: Ke,
          info: Ke,
          warn: Ke,
          error: Ke
        }, this._plugins = {}, this._breadcrumbs = [], this._session = null, this._metadata = {}, this._featuresIndex = {}, this._features = [], this._context = void 0, this._user = {}, this._cbs = {
          e: [],
          s: [],
          sp: [],
          b: []
        }, this.Client = D, this.Event = ci, this.Breadcrumb = V, this.Session = le, this._config = this._configure(_, se), p(se.concat(this._config.plugins), function(pt) {
          pt && Ye._loadPlugin(pt);
        }), this._depth = 1;
        var at = this, je = this.notify;
        this.notify = function() {
          return je.apply(at, arguments);
        };
      }
      var z = D.prototype;
      return z.addMetadata = function(q, se, he) {
        return $e.add(this._metadata, q, se, he);
      }, z.getMetadata = function(q, se) {
        return $e.get(this._metadata, q, se);
      }, z.clearMetadata = function(q, se) {
        return $e.clear(this._metadata, q, se);
      }, z.addFeatureFlag = function(q, se) {
        se === void 0 && (se = null), Ce(this._features, this._featuresIndex, q, se);
      }, z.addFeatureFlags = function(q) {
        Ne(this._features, q, this._featuresIndex);
      }, z.clearFeatureFlag = function(q) {
        pe(this._features, this._featuresIndex, q);
      }, z.clearFeatureFlags = function() {
        this._features = [], this._featuresIndex = {};
      }, z.getContext = function() {
        return this._context;
      }, z.setContext = function(q) {
        this._context = q;
      }, z._configure = function(q, se) {
        var he = n(se, function(pt, Ft) {
          return Ft && Ft.configSchema ? m({}, pt, Ft.configSchema) : pt;
        }, this._schema), Ye = n(I(he), function(pt, Ft) {
          var qt = he[Ft].defaultValue(q[Ft]);
          if (q[Ft] !== void 0) {
            var Wt = he[Ft].validate(q[Ft]);
            Wt ? he[Ft].allowPartialObject ? pt.config[Ft] = m(qt, q[Ft]) : pt.config[Ft] = q[Ft] : (pt.errors[Ft] = he[Ft].message, pt.config[Ft] = qt);
          } else
            pt.config[Ft] = qt;
          return pt;
        }, {
          errors: {},
          config: {}
        }), at = Ye.errors, je = Ye.config;
        if (he.apiKey) {
          if (!je.apiKey)
            throw new Error("No Bugsnag API Key set");
          /^[0-9a-f]{32}$/i.test(je.apiKey) || (at.apiKey = "should be a string of 32 hexadecimal characters");
        }
        return this._metadata = m({}, je.metadata), Ne(this._features, je.featureFlags, this._featuresIndex), this._user = m({}, je.user), this._context = je.context, je.logger && (this._logger = je.logger), je.onError && (this._cbs.e = this._cbs.e.concat(je.onError)), je.onBreadcrumb && (this._cbs.b = this._cbs.b.concat(je.onBreadcrumb)), je.onSession && (this._cbs.s = this._cbs.s.concat(je.onSession)), I(at).length && this._logger.warn(Rt(at, q)), je;
      }, z.getUser = function() {
        return this._user;
      }, z.setUser = function(q, se, he) {
        this._user = {
          id: q,
          email: se,
          name: he
        };
      }, z._loadPlugin = function(q) {
        var se = q.load(this);
        return q.name && (this._plugins["~" + q.name + "~"] = se), this;
      }, z.getPlugin = function(q) {
        return this._plugins["~" + q + "~"];
      }, z._setDelivery = function(q) {
        this._delivery = q(this);
      }, z.startSession = function() {
        var q = new le();
        q.app.releaseStage = this._config.releaseStage, q.app.version = this._config.appVersion, q.app.type = this._config.appType, q._user = m({}, this._user);
        var se = qe(this._cbs.s, q, "onSession", this._logger);
        return se ? (this._logger.debug("Session not started due to onSession callback"), this) : this._sessionDelegate.startSession(this, q);
      }, z.addOnError = function(q, se) {
        se === void 0 && (se = !1), this._cbs.e[se ? "unshift" : "push"](q);
      }, z.removeOnError = function(q) {
        this._cbs.e = r(this._cbs.e, function(se) {
          return se !== q;
        });
      }, z._addOnSessionPayload = function(q) {
        this._cbs.sp.push(q);
      }, z.addOnSession = function(q) {
        this._cbs.s.push(q);
      }, z.removeOnSession = function(q) {
        this._cbs.s = r(this._cbs.s, function(se) {
          return se !== q;
        });
      }, z.addOnBreadcrumb = function(q, se) {
        se === void 0 && (se = !1), this._cbs.b[se ? "unshift" : "push"](q);
      }, z.removeOnBreadcrumb = function(q) {
        this._cbs.b = r(this._cbs.b, function(se) {
          return se !== q;
        });
      }, z.pauseSession = function() {
        return this._sessionDelegate.pauseSession(this);
      }, z.resumeSession = function() {
        return this._sessionDelegate.resumeSession(this);
      }, z.leaveBreadcrumb = function(q, se, he) {
        if (q = typeof q == "string" ? q : "", he = typeof he == "string" && g(i, he) ? he : "manual", se = typeof se == "object" && se !== null ? se : {}, !!q) {
          var Ye = new V(q, se, he), at = qe(this._cbs.b, Ye, "onBreadcrumb", this._logger);
          if (at) {
            this._logger.debug("Breadcrumb not attached due to onBreadcrumb callback");
            return;
          }
          this._breadcrumbs.push(Ye), this._breadcrumbs.length > this._config.maxBreadcrumbs && (this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs));
        }
      }, z._isBreadcrumbTypeEnabled = function(q) {
        var se = this._config.enabledBreadcrumbTypes;
        return se === null || g(se, q);
      }, z.notify = function(q, se, he) {
        he === void 0 && (he = Ke);
        var Ye = ci.create(q, !0, void 0, "notify()", this._depth + 1, this._logger);
        this._notify(Ye, se, he);
      }, z._notify = function(q, se, he) {
        var Ye = this;
        if (he === void 0 && (he = Ke), q.app = m({}, q.app, {
          releaseStage: this._config.releaseStage,
          version: this._config.appVersion,
          type: this._config.appType
        }), q.context = q.context || this._context, q._metadata = m({}, q._metadata, this._metadata), q._user = m({}, q._user, this._user), q.breadcrumbs = this._breadcrumbs.slice(), Ne(q._features, this._features, q._featuresIndex), this._config.enabledReleaseStages !== null && !g(this._config.enabledReleaseStages, this._config.releaseStage))
          return this._logger.warn("Event not sent due to releaseStage/enabledReleaseStages configuration"), he(null, q);
        var at = q.severity, je = function(Ft) {
          Ye._logger.error("Error occurred in onError callback, continuing anyway…"), Ye._logger.error(Ft);
        }, pt = [].concat(this._cbs.e).concat(se);
        Be(pt, q, je, function(Ft, qt) {
          if (Ft && je(Ft), !qt)
            return Ye._logger.debug("Event not sent due to onError callback"), he(null, q);
          Ye._isBreadcrumbTypeEnabled("error") && D.prototype.leaveBreadcrumb.call(Ye, q.errors[0].errorClass, {
            errorClass: q.errors[0].errorClass,
            errorMessage: q.errors[0].errorMessage,
            severity: q.severity
          }, "error"), at !== q.severity && (q._handledState.severityReason = {
            type: "userCallbackSetSeverity"
          }), q.unhandled !== q._handledState.unhandled && (q._handledState.severityReason.unhandledOverridden = !0, q._handledState.unhandled = q.unhandled), Ye._session && (Ye._session._track(q), q._session = Ye._session), Ye._delivery.sendEvent({
            apiKey: q.apiKey || Ye._config.apiKey,
            notifier: Ye._notifier,
            events: [q]
          }, function(Wt) {
            return he(Wt, q);
          });
        });
      }, D;
    }(), Rt = function(D, z) {
      var _ = new Error(`Invalid configuration
` + p(I(D), function(q) {
        return "  - " + q + " " + D[q] + ", got " + Zt(z[q]);
      }).join(`

`));
      return _;
    }, Zt = function(D) {
      switch (typeof D) {
        case "string":
        case "number":
        case "object":
          return JSON.stringify(D);
        default:
          return String(D);
      }
    }, Et = Jt, dt = {}, xt = ["events.[].metaData", "events.[].breadcrumbs.[].metaData", "events.[].request"];
    dt.event = function(D, z) {
      var _ = x(D, null, null, {
        redactedPaths: xt,
        redactedKeys: z
      });
      return _.length > 1e6 && (D.events[0]._metadata = {
        notifier: `WARNING!
Serialized payload was ` + _.length / 1e6 + `MB (limit = 1MB)
metadata was removed`
      }, _ = x(D, null, null, {
        redactedPaths: xt,
        redactedKeys: z
      })), _;
    }, dt.session = function(D, z) {
      var _ = x(D, null, null);
      return _;
    };
    var Ot = {};
    Ot = function(D, z) {
      return z === void 0 && (z = window), {
        sendEvent: function(_, q) {
          q === void 0 && (q = function() {
          });
          var se = si(D._config, "notify", "4", z), he = dt.event(_, D._config.redactedKeys), Ye = new z.XDomainRequest();
          Ye.onload = function() {
            q(null);
          }, Ye.onerror = function() {
            var at = new Error("Event failed to send");
            D._logger.error("Event failed to send…", at), he.length > 1e6 && D._logger.warn("Event oversized (" + (he.length / 1e6).toFixed(2) + " MB)"), q(at);
          }, Ye.open("POST", se), setTimeout(function() {
            try {
              Ye.send(he);
            } catch (at) {
              D._logger.error(at), q(at);
            }
          }, 0);
        },
        sendSession: function(_, q) {
          q === void 0 && (q = function() {
          });
          var se = si(D._config, "sessions", "1", z), he = new z.XDomainRequest();
          he.onload = function() {
            q(null);
          }, he.open("POST", se), setTimeout(function() {
            try {
              he.send(dt.session(_, D._config.redactedKeys));
            } catch (Ye) {
              D._logger.error(Ye), q(Ye);
            }
          }, 0);
        }
      };
    };
    var si = function(D, z, _, q) {
      var se = JSON.parse(JSON.stringify(/* @__PURE__ */ new Date())), he = Li(D.endpoints[z], q.location.protocol);
      return he + "?apiKey=" + encodeURIComponent(D.apiKey) + "&payloadVersion=" + _ + "&sentAt=" + encodeURIComponent(se);
    }, Li = Ot._matchPageProtocol = function(D, z) {
      return z === "http:" ? D.replace(/^https:/, "http:") : D;
    }, fe = function(D, z) {
      return z === void 0 && (z = window), {
        sendEvent: function(_, q) {
          q === void 0 && (q = function() {
          });
          try {
            var se = D._config.endpoints.notify, he = new z.XMLHttpRequest(), Ye = dt.event(_, D._config.redactedKeys);
            he.onreadystatechange = function() {
              if (he.readyState === z.XMLHttpRequest.DONE) {
                var at = he.status;
                if (at === 0 || at >= 400) {
                  var je = new Error("Request failed with status " + at);
                  D._logger.error("Event failed to send…", je), Ye.length > 1e6 && D._logger.warn("Event oversized (" + (Ye.length / 1e6).toFixed(2) + " MB)"), q(je);
                } else
                  q(null);
              }
            }, he.open("POST", se), he.setRequestHeader("Content-Type", "application/json"), he.setRequestHeader("Bugsnag-Api-Key", _.apiKey || D._config.apiKey), he.setRequestHeader("Bugsnag-Payload-Version", "4"), he.setRequestHeader("Bugsnag-Sent-At", (/* @__PURE__ */ new Date()).toISOString()), he.send(Ye);
          } catch (at) {
            D._logger.error(at);
          }
        },
        sendSession: function(_, q) {
          q === void 0 && (q = function() {
          });
          try {
            var se = D._config.endpoints.sessions, he = new z.XMLHttpRequest();
            he.onreadystatechange = function() {
              if (he.readyState === z.XMLHttpRequest.DONE) {
                var Ye = he.status;
                if (Ye === 0 || Ye >= 400) {
                  var at = new Error("Request failed with status " + Ye);
                  D._logger.error("Session failed to send…", at), q(at);
                } else
                  q(null);
              }
            }, he.open("POST", se), he.setRequestHeader("Content-Type", "application/json"), he.setRequestHeader("Bugsnag-Api-Key", D._config.apiKey), he.setRequestHeader("Bugsnag-Payload-Version", "1"), he.setRequestHeader("Bugsnag-Sent-At", (/* @__PURE__ */ new Date()).toISOString()), he.send(dt.session(_, D._config.redactedKeys));
          } catch (Ye) {
            D._logger.error(Ye);
          }
        }
      };
    }, Ae = /* @__PURE__ */ new Date(), gt = function() {
      Ae = /* @__PURE__ */ new Date();
    }, _e = {
      name: "appDuration",
      load: function(D) {
        return D.addOnError(function(z) {
          var _ = /* @__PURE__ */ new Date();
          z.app.duration = _ - Ae;
        }, !0), {
          reset: gt
        };
      }
    }, Qt = function(D) {
      return D === void 0 && (D = window), {
        load: function(z) {
          z.addOnError(function(_) {
            _.context === void 0 && (_.context = D.location.pathname);
          }, !0);
        }
      };
    }, kt = function(z, _) {
      var q = "000000000" + z;
      return q.substr(q.length - _);
    }, ti = typeof window == "object" ? window : self, tn = 0;
    for (var ao in ti)
      Object.hasOwnProperty.call(ti, ao) && tn++;
    var Nr = navigator.mimeTypes ? navigator.mimeTypes.length : 0, vg = kt((Nr + navigator.userAgent.length).toString(36) + tn.toString(36), 4), es = function() {
      return vg;
    }, tg = 0, Xi = 4, bn = 36, so = Math.pow(bn, Xi);
    function bl() {
      return kt((Math.random() * so << 0).toString(bn), Xi);
    }
    function hn() {
      return tg = tg < so ? tg : 0, tg++, tg - 1;
    }
    function hl() {
      var D = "c", z = (/* @__PURE__ */ new Date()).getTime().toString(bn), _ = kt(hn().toString(bn), Xi), q = es(), se = bl() + bl();
      return D + z + _ + q + se;
    }
    hl.fingerprint = es;
    var ia = hl, ml = "bugsnag-anonymous-id", xc = function(D) {
      try {
        var z = D.localStorage, _ = z.getItem(ml);
        return _ && /^c[a-z0-9]{20,32}$/.test(_) || (_ = ia(), z.setItem(ml, _)), _;
      } catch {
      }
    }, Dc = function(D, z) {
      return D === void 0 && (D = navigator), z === void 0 && (z = window), {
        load: function(_) {
          var q = {
            locale: D.browserLanguage || D.systemLanguage || D.userLanguage || D.language,
            userAgent: D.userAgent
          };
          z && z.screen && z.screen.orientation && z.screen.orientation.type ? q.orientation = z.screen.orientation.type : z && z.document && (q.orientation = z.document.documentElement.clientWidth > z.document.documentElement.clientHeight ? "landscape" : "portrait"), _._config.generateAnonymousId && (q.id = xc(z)), _.addOnSession(function(se) {
            se.device = m({}, se.device, q), _._config.collectUserIp || NI(se);
          }), _.addOnError(function(se) {
            se.device = m({}, se.device, q, {
              time: /* @__PURE__ */ new Date()
            }), _._config.collectUserIp || NI(se);
          }, !0);
        },
        configSchema: {
          generateAnonymousId: {
            validate: function(_) {
              return _ === !0 || _ === !1;
            },
            defaultValue: function() {
              return !0;
            },
            message: "should be true|false"
          }
        }
      };
    }, NI = function(D) {
      var z = D.getUser();
      (!z || !z.id) && D.setUser(D.device.id);
    }, LI = function(D) {
      return D === void 0 && (D = window), {
        load: function(z) {
          z.addOnError(function(_) {
            _.request && _.request.url || (_.request = m({}, _.request, {
              url: D.location.href
            }));
          }, !0);
        }
      };
    }, Gu = {
      load: function(D) {
        D._sessionDelegate = Jc;
      }
    }, Jc = {
      startSession: function(D, z) {
        var _ = D;
        return _._session = z, _._pausedSession = null, _._config.enabledReleaseStages !== null && !g(_._config.enabledReleaseStages, _._config.releaseStage) ? (_._logger.warn("Session not sent due to releaseStage/enabledReleaseStages configuration"), _) : (_._delivery.sendSession({
          notifier: _._notifier,
          device: z.device,
          app: z.app,
          sessions: [{
            id: z.id,
            startedAt: z.startedAt,
            user: z._user
          }]
        }), _);
      },
      resumeSession: function(D) {
        return D._session ? D : D._pausedSession ? (D._session = D._pausedSession, D._pausedSession = null, D) : D.startSession();
      },
      pauseSession: function(D) {
        D._pausedSession = D._session, D._session = null;
      }
    }, Ps = {
      load: function(D) {
        D._config.collectUserIp || D.addOnError(function(z) {
          z._user && typeof z._user.id > "u" && delete z._user.id, z._user = m({
            id: "[REDACTED]"
          }, z._user), z.request = m({
            clientIp: "[REDACTED]"
          }, z.request);
        });
      },
      configSchema: {
        collectUserIp: {
          defaultValue: function() {
            return !0;
          },
          message: "should be true|false",
          validate: function(D) {
            return D === !0 || D === !1;
          }
        }
      }
    }, KI = {};
    KI.load = function(D) {
      var z = /^(local-)?dev(elopment)?$/.test(D._config.releaseStage);
      z || !D._isBreadcrumbTypeEnabled("log") || p(yu, function(_) {
        var q = console[_];
        console[_] = function() {
          for (var se = arguments.length, he = new Array(se), Ye = 0; Ye < se; Ye++)
            he[Ye] = arguments[Ye];
          D.leaveBreadcrumb("Console output", n(he, function(at, je, pt) {
            var Ft = "[Unknown value]";
            try {
              Ft = String(je);
            } catch {
            }
            if (Ft === "[object Object]")
              try {
                Ft = JSON.stringify(je);
              } catch {
              }
            return at["[" + pt + "]"] = Ft, at;
          }, {
            severity: _.indexOf("group") === 0 ? "log" : _
          }), "log"), q.apply(console, he);
        }, console[_]._restore = function() {
          console[_] = q;
        };
      });
    };
    var yu = r(["log", "debug", "info", "warn", "error"], function(D) {
      return typeof console < "u" && typeof console[D] == "function";
    }), Wu = 200, Su = 5e5, Vu = function(D, z) {
      return D === void 0 && (D = document), z === void 0 && (z = window), {
        load: function(_) {
          if (!_._config.trackInlineScripts)
            return;
          var q = z.location.href, se = "", he = !!D.attachEvent, Ye = he ? D.readyState === "complete" : D.readyState !== "loading", at = function() {
            return D.documentElement.outerHTML;
          };
          se = at();
          var je = D.onreadystatechange;
          D.onreadystatechange = function() {
            D.readyState === "interactive" && (se = at(), Ye = !0);
            try {
              je.apply(this, arguments);
            } catch {
            }
          };
          var pt = null, Ft = function(gi) {
            pt = gi;
          }, qt = function() {
            var gi = D.currentScript || pt;
            if (!gi && !Ye) {
              var Yi = D.scripts || D.getElementsByTagName("script");
              gi = Yi[Yi.length - 1];
            }
            return gi;
          }, Wt = function(gi) {
            (!Ye || !se) && (se = at());
            var Yi = ["<!-- DOC START -->"].concat(se.split(`
`)), dr = gi - 1, On = Math.max(dr - 3, 0), ur = Math.min(dr + 3, Yi.length);
            return n(Yi.slice(On, ur), function(nn, MI, Lr) {
              return nn[On + 1 + Lr] = MI.length <= Wu ? MI : MI.substr(0, Wu), nn;
            }, {});
          };
          _.addOnError(function(gi) {
            gi.errors[0].stacktrace = r(gi.errors[0].stacktrace, function(nn) {
              return !/__trace__$/.test(nn.method);
            });
            var Yi = gi.errors[0].stacktrace[0], dr = function(nn) {
              return nn.replace(/#.*$/, "").replace(/\?.*$/, "");
            };
            if (!(Yi && Yi.file && dr(Yi.file) !== dr(q))) {
              var On = qt();
              if (On) {
                var ur = On.innerHTML;
                gi.addMetadata("script", "content", ur.length <= Su ? ur : ur.substr(0, Su)), Yi && Yi.lineNumber && (Yi.code = Wt(Yi.lineNumber));
              }
            }
          }, !0);
          var yi = p(["setTimeout", "setInterval", "setImmediate", "requestAnimationFrame"], function(gi) {
            return Ec(z, gi, function(Yi) {
              return Yn(Yi, function(dr) {
                return {
                  get: function() {
                    return dr[0];
                  },
                  replace: function(On) {
                    dr[0] = On;
                  }
                };
              });
            });
          }), Zi = yi[0];
          p(["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"], function(gi) {
            !z[gi] || !z[gi].prototype || !Object.prototype.hasOwnProperty.call(z[gi].prototype, "addEventListener") || (Ec(z[gi].prototype, "addEventListener", function(Yi) {
              return Yn(Yi, Nc);
            }), Ec(z[gi].prototype, "removeEventListener", function(Yi) {
              return Yn(Yi, Nc, !0);
            }));
          });
          function Yn(gi, Yi, dr) {
            return dr === void 0 && (dr = !1), function() {
              var On = [].slice.call(arguments);
              try {
                var ur = Yi(On), nn = ur.get();
                if (dr && gi.apply(this, On), typeof nn != "function")
                  return gi.apply(this, On);
                if (nn.__trace__)
                  ur.replace(nn.__trace__);
                else {
                  var MI = qt();
                  nn.__trace__ = function() {
                    Ft(MI), Zi(function() {
                      Ft(null);
                    }, 0);
                    var EA = nn.apply(this, arguments);
                    return Ft(null), EA;
                  }, nn.__trace__.__trace__ = nn.__trace__, ur.replace(nn.__trace__);
                }
              } catch {
              }
              if (gi.apply)
                return gi.apply(this, On);
              switch (On.length) {
                case 1:
                  return gi(On[0]);
                case 2:
                  return gi(On[0], On[1]);
                default:
                  return gi();
              }
            };
          }
        },
        configSchema: {
          trackInlineScripts: {
            validate: function(_) {
              return _ === !0 || _ === !1;
            },
            defaultValue: function() {
              return !0;
            },
            message: "should be true|false"
          }
        }
      };
    };
    function Ec(D, z, _) {
      var q = D[z];
      if (!q)
        return q;
      var se = _(q);
      return D[z] = se, q;
    }
    function Nc(D) {
      var z = !!D[1] && typeof D[1].handleEvent == "function";
      return {
        get: function() {
          return z ? D[1].handleEvent : D[1];
        },
        replace: function(_) {
          z ? D[1].handleEvent = _ : D[1] = _;
        }
      };
    }
    var wu = function(D) {
      return D === void 0 && (D = window), {
        load: function(z) {
          "addEventListener" in D && z._isBreadcrumbTypeEnabled("user") && D.addEventListener("click", function(_) {
            var q, se;
            try {
              q = Us(_.target), se = Ru(_.target, D);
            } catch {
              q = "[hidden]", se = "[hidden]", z._logger.error("Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z");
            }
            z.leaveBreadcrumb("UI click", {
              targetText: q,
              targetSelector: se
            }, "user");
          }, !0);
        }
      };
    }, vu = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
    function Us(D) {
      var z = D.textContent || D.innerText || "";
      return !z && (D.type === "submit" || D.type === "button") && (z = D.value), z = z.replace(vu, "$1"), z.length > 140 ? z.slice(0, 135) + "(...)" : z;
    }
    function Ru(D, z) {
      var _ = [D.tagName];
      if (D.id && _.push("#" + D.id), D.className && D.className.length && _.push("." + D.className.split(" ").join(".")), !z.document.querySelectorAll || !Array.prototype.indexOf)
        return _.join("");
      try {
        if (z.document.querySelectorAll(_.join("")).length === 1)
          return _.join("");
      } catch {
        return _.join("");
      }
      if (D.parentNode.childNodes.length > 1) {
        var q = Array.prototype.indexOf.call(D.parentNode.childNodes, D) + 1;
        _.push(":nth-child(" + q + ")");
      }
      return z.document.querySelectorAll(_.join("")).length === 1 ? _.join("") : D.parentNode ? Ru(D.parentNode, z) + " > " + _.join("") : _.join("");
    }
    var Lc = {};
    Lc = function(D) {
      D === void 0 && (D = window);
      var z = {
        load: function(_) {
          if ("addEventListener" in D && _._isBreadcrumbTypeEnabled("navigation")) {
            var q = function(se) {
              return function() {
                return _.leaveBreadcrumb(se, {}, "navigation");
              };
            };
            D.addEventListener("pagehide", q("Page hidden"), !0), D.addEventListener("pageshow", q("Page shown"), !0), D.addEventListener("load", q("Page loaded"), !0), D.document.addEventListener("DOMContentLoaded", q("DOMContentLoaded"), !0), D.addEventListener("load", function() {
              return D.addEventListener("popstate", q("Navigated back"), !0);
            }), D.addEventListener("hashchange", function(se) {
              var he = se.oldURL ? {
                from: Kc(se.oldURL, D),
                to: Kc(se.newURL, D),
                state: TI(D)
              } : {
                to: Kc(D.location.href, D)
              };
              _.leaveBreadcrumb("Hash changed", he, "navigation");
            }, !0), D.history.replaceState && Xu(_, D.history, "replaceState", D), D.history.pushState && Xu(_, D.history, "pushState", D);
          }
        }
      };
      return z;
    };
    var Kc = function(D, z) {
      var _ = z.document.createElement("A");
      return _.href = D, "" + _.pathname + _.search + _.hash;
    }, xA = function(D, z, _, q) {
      var se = Kc(D.location.href, D);
      return {
        title: _,
        state: z,
        prevState: TI(D),
        to: q || se,
        from: se
      };
    }, Xu = function(D, z, _, q) {
      var se = z[_];
      z[_] = function(he, Ye, at) {
        D.leaveBreadcrumb("History " + _, xA(q, he, Ye, at), "navigation"), typeof D.resetEventCount == "function" && D.resetEventCount(), D._config.autoTrackSessions && D.startSession(), se.apply(z, [he, Ye].concat(at !== void 0 ? at : []));
      };
    }, TI = function(D) {
      try {
        return D.history.state;
      } catch {
      }
    }, ts = "request", Hu = function(D, z) {
      D === void 0 && (D = []), z === void 0 && (z = window);
      var _ = {
        load: function(q) {
          if (!q._isBreadcrumbTypeEnabled("request"))
            return;
          var se = [q._config.endpoints.notify, q._config.endpoints.sessions].concat(D);
          he(), je();
          function he() {
            if ("addEventListener" in z.XMLHttpRequest.prototype) {
              var qt = z.XMLHttpRequest.prototype.open;
              z.XMLHttpRequest.prototype.open = function(yi, Zi) {
                var Yn = this, gi = !1, Yi = function() {
                  return at(yi, Zi);
                }, dr = function() {
                  return Ye(yi, Zi, Yn.status);
                };
                gi && (this.removeEventListener("load", dr), this.removeEventListener("error", Yi)), this.addEventListener("load", dr), this.addEventListener("error", Yi), gi = !0, qt.apply(this, arguments);
              };
            }
          }
          function Ye(qt, Wt, yi) {
            if (Wt === void 0) {
              q._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
              return;
            }
            if (!(typeof Wt == "string" && g(se, Wt.replace(/\?.*$/, "")))) {
              var Zi = {
                status: yi,
                request: qt + " " + Wt
              };
              yi >= 400 ? q.leaveBreadcrumb("XMLHttpRequest failed", Zi, ts) : q.leaveBreadcrumb("XMLHttpRequest succeeded", Zi, ts);
            }
          }
          function at(qt, Wt) {
            if (Wt === void 0) {
              q._logger.warn("The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.");
              return;
            }
            typeof Wt == "string" && g(se, Wt.replace(/\?.*$/, "")) || q.leaveBreadcrumb("XMLHttpRequest error", {
              request: qt + " " + Wt
            }, ts);
          }
          function je() {
            if (!(!("fetch" in z) || z.fetch.polyfill)) {
              var qt = z.fetch;
              z.fetch = function() {
                var yi = arguments, Zi = arguments[0], Yn = arguments[1], gi, Yi = null;
                return Zi && typeof Zi == "object" ? (Yi = Zi.url, Yn && "method" in Yn ? gi = Yn.method : Zi && "method" in Zi && (gi = Zi.method)) : (Yi = Zi, Yn && "method" in Yn && (gi = Yn.method)), gi === void 0 && (gi = "GET"), new Promise(function(dr, On) {
                  qt.apply(void 0, yi).then(function(ur) {
                    pt(ur, gi, Yi), dr(ur);
                  }).catch(function(ur) {
                    Ft(gi, Yi), On(ur);
                  });
                });
              };
            }
          }
          var pt = function(qt, Wt, yi) {
            var Zi = {
              status: qt.status,
              request: Wt + " " + yi
            };
            qt.status >= 400 ? q.leaveBreadcrumb("fetch() failed", Zi, ts) : q.leaveBreadcrumb("fetch() succeeded", Zi, ts);
          }, Ft = function(qt, Wt) {
            q.leaveBreadcrumb("fetch() error", {
              request: qt + " " + Wt
            }, ts);
          };
        }
      };
      return _;
    }, op = {
      load: function(D) {
        var z = 0;
        D.addOnError(function(_) {
          if (z >= D._config.maxEvents)
            return D._logger.warn("Cancelling event send due to maxEvents per session limit of " + D._config.maxEvents + " being reached"), !1;
          z++;
        }), D.resetEventCount = function() {
          z = 0;
        };
      },
      configSchema: {
        maxEvents: {
          defaultValue: function() {
            return 10;
          },
          message: "should be a positive integer ≤100",
          validate: function(D) {
            return c(1, 100)(D);
          }
        }
      }
    }, ku = {};
    ku = {
      load: function(D) {
        D.addOnError(function(z) {
          var _ = n(z.errors, function(q, se) {
            return q.concat(se.stacktrace);
          }, []);
          p(_, function(q) {
            q.file = DA(q.file);
          });
        });
      }
    };
    var DA = ku._strip = function(D) {
      return typeof D == "string" ? D.replace(/\?.*$/, "").replace(/#.*$/, "") : D;
    }, lp = function(D, z) {
      return D === void 0 && (D = window), z === void 0 && (z = "window onerror"), {
        load: function(_) {
          if (!_._config.autoDetectErrors || !_._config.enabledErrorTypes.unhandledExceptions)
            return;
          function q(he, Ye, at, je, pt) {
            if (at === 0 && /Script error\.?/.test(he))
              _._logger.warn("Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z");
            else {
              var Ft = {
                severity: "error",
                unhandled: !0,
                severityReason: {
                  type: "unhandledException"
                }
              }, qt;
              if (pt)
                qt = _.Event.create(pt, !0, Ft, z, 1), JA(qt.errors[0].stacktrace, Ye, at, je);
              else if (
                // This complex case detects "error" events that are typically synthesised
                // by jquery's trigger method (although can be created in other ways). In
                // order to detect this:
                // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
                // - the second argument (url) must either not exist or be something other than a string (if it
                //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
                //    function)
                // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
                typeof he == "object" && he !== null && (!Ye || typeof Ye != "string") && !at && !je && !pt
              ) {
                var Wt = he.type ? "Event: " + he.type : "Error", yi = he.message || he.detail || "";
                qt = _.Event.create({
                  name: Wt,
                  message: yi
                }, !0, Ft, z, 1), qt.originalError = he, qt.addMetadata(z, {
                  event: he,
                  extraParameters: Ye
                });
              } else
                qt = _.Event.create(he, !0, Ft, z, 1), JA(qt.errors[0].stacktrace, Ye, at, je);
              _._notify(qt);
            }
            typeof se == "function" && se.apply(this, arguments);
          }
          var se = D.onerror;
          D.onerror = q;
        }
      };
    }, JA = function(D, z, _, q) {
      D[0] || D.push({});
      var se = D[0];
      !se.file && typeof z == "string" && (se.file = z), !se.lineNumber && Yu(_) && (se.lineNumber = _), se.columnNumber || (Yu(q) ? se.columnNumber = q : window.event && Yu(window.event.errorCharacter) && (se.columnNumber = window.event.errorCharacter));
    }, Yu = function(D) {
      return typeof D == "number" && String.call(D) !== "NaN";
    }, ap = function(D) {
      D === void 0 && (D = window);
      var z = {
        load: function(_) {
          if (!(!_._config.autoDetectErrors || !_._config.enabledErrorTypes.unhandledRejections)) {
            var q = function(se) {
              var he = se.reason, Ye = !1;
              try {
                se.detail && se.detail.reason && (he = se.detail.reason, Ye = !0);
              } catch {
              }
              var at = _.Event.create(he, !1, {
                severity: "error",
                unhandled: !0,
                severityReason: {
                  type: "unhandledPromiseRejection"
                }
              }, "unhandledrejection handler", 1, _._logger);
              Ye && p(at.errors[0].stacktrace, Fu(he)), _._notify(at, function(je) {
                if (st(je.originalError) && !je.originalError.stack) {
                  var pt;
                  je.addMetadata("unhandledRejection handler", (pt = {}, pt[Object.prototype.toString.call(je.originalError)] = {
                    name: je.originalError.name,
                    message: je.originalError.message,
                    code: je.originalError.code
                  }, pt));
                }
              });
            };
            "addEventListener" in D ? D.addEventListener("unhandledrejection", q) : D.onunhandledrejection = function(se, he) {
              q({
                detail: {
                  reason: se,
                  promise: he
                }
              });
            };
          }
        }
      };
      return z;
    }, Fu = function(D) {
      return function(z) {
        z.file !== D.toString() && z.method && (z.method = z.method.replace(/^\s+/, ""));
      };
    }, na = {}, sp = "Bugsnag JavaScript", Ip = "7.22.7", cp = "https://github.com/bugsnag/bugsnag-js", dp = m({}, A.schema, Z), ki = {
      _client: null,
      createClient: function(D) {
        typeof D == "string" && (D = {
          apiKey: D
        }), D || (D = {});
        var z = [
          // add browser-specific plugins
          _e,
          Dc(),
          Qt(),
          LI(),
          op,
          Gu,
          Ps,
          ku,
          lp(),
          ap(),
          Lc(),
          wu(),
          Hu(),
          KI,
          // this one added last to avoid wrapping functionality before bugsnag uses it
          Vu()
        ], _ = new Et(D, dp, z, {
          name: sp,
          version: Ip,
          url: cp
        });
        return _._setDelivery(window.XDomainRequest ? Ot : fe), _._logger.debug("Loaded!"), _.leaveBreadcrumb("Bugsnag loaded", {}, "state"), _._config.autoTrackSessions ? _.startSession() : _;
      },
      start: function(D) {
        return ki._client ? (ki._client._logger.warn("Bugsnag.start() was called more than once. Ignoring."), ki._client) : (ki._client = ki.createClient(D), ki._client);
      },
      isStarted: function() {
        return ki._client != null;
      }
    };
    return p(["resetEventCount"].concat(I(Et.prototype)), function(D) {
      /^_/.test(D) || (ki[D] = function() {
        if (!ki._client)
          return console.log("Bugsnag." + D + "() was called before Bugsnag.start()");
        ki._client._depth += 1;
        var z = ki._client[D].apply(ki._client, arguments);
        return ki._client._depth -= 1, z;
      });
    }), na = ki, na.Client = Et, na.Event = ci, na.Session = le, na.Breadcrumb = V, na.default = ki, na;
  });
})(d8);
var Wdt = d8.exports, Sdt = Wdt;
const vT = /* @__PURE__ */ go(Sdt);
var u8 = { exports: {} };
(function(e, t) {
  (function(i) {
    e.exports = i();
  })(function() {
    var i = {};
    function n() {
      return n = Object.assign ? Object.assign.bind() : function(I) {
        for (var c = 1; c < arguments.length; c++) {
          var d = arguments[c];
          for (var C in d)
            Object.prototype.hasOwnProperty.call(d, C) && (I[C] = d[C]);
        }
        return I;
      }, n.apply(this, arguments);
    }
    function r(I) {
      if (I === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return I;
    }
    function g(I, c) {
      I.prototype = Object.create(c.prototype), I.prototype.constructor = I, o(I, c);
    }
    function o(I, c) {
      return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(C, A) {
        return C.__proto__ = A, C;
      }, o(I, c);
    }
    i = /* @__PURE__ */ function() {
      function I() {
        var d = typeof window < "u" && window.React;
        if (this.name = "react", this.lazy = arguments.length === 0 && !d, !this.lazy && (this.React = (arguments.length <= 0 ? void 0 : arguments[0]) || d, !this.React))
          throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
      }
      var c = I.prototype;
      return c.load = function(C) {
        if (!this.lazy) {
          var A = a(this.React, C);
          return A.createErrorBoundary = function() {
            return A;
          }, A;
        }
        var b = function() {
          throw new Error(`@bugsnag/plugin-react was used incorrectly. Valid usage is as follows:
Pass React to the plugin constructor

  \`Bugsnag.start({ plugins: [new BugsnagPluginReact(React)] })\`
and then call \`const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary()\`

Or if React is not available until after Bugsnag has started,
construct the plugin with no arguments
  \`Bugsnag.start({ plugins: [new BugsnagPluginReact()] })\`,
then pass in React when available to construct your error boundary
  \`const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)\``);
        };
        return b.createErrorBoundary = function(m) {
          if (!m)
            throw new Error("@bugsnag/plugin-react reference to `React` was undefined");
          return a(m, C);
        }, b;
      }, I;
    }();
    var l = function(I) {
      for (var c = I.split(/\s*\n\s*/g), d = "", C = 0, A = c.length; C < A; C++)
        c[C].length && (d += (d.length ? `
` : "") + c[C]);
      return d;
    }, a = function(I, c) {
      return /* @__PURE__ */ function(d) {
        g(C, d);
        function C(b) {
          var m;
          return m = d.call(this, b) || this, m.state = {
            error: null,
            info: null
          }, m.handleClearError = m.handleClearError.bind(r(m)), m;
        }
        var A = C.prototype;
        return A.handleClearError = function() {
          this.setState({
            error: null,
            info: null
          });
        }, A.componentDidCatch = function(m, p) {
          var B = this.props.onError, f = {
            severity: "error",
            unhandled: !0,
            severityReason: {
              type: "unhandledException"
            }
          }, Z = c.Event.create(m, !0, f, 1);
          p && p.componentStack && (p.componentStack = l(p.componentStack)), Z.addMetadata("react", p), c._notify(Z, B), this.setState({
            error: m,
            info: p
          });
        }, A.render = function() {
          var m = this.state.error;
          if (m) {
            var p = this.props.FallbackComponent;
            return p ? I.createElement(p, n({}, this.state, {
              clearError: this.handleClearError
            })) : null;
          }
          return this.props.children;
        }, C;
      }(I.Component);
    };
    return i.formatComponentStack = l, i.default = i, i;
  });
})(u8);
var Vdt = u8.exports;
const wdt = /* @__PURE__ */ go(Vdt), vdt = function() {
  return null;
};
var o9 = {};
Object.defineProperty(o9, "__esModule", { value: !0 });
o9.parse = xdt;
o9.serialize = Ddt;
const Rdt = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/, Xdt = /^[\u0021-\u003A\u003C-\u007E]*$/, Hdt = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, kdt = /^[\u0020-\u003A\u003D-\u007E]*$/, Ydt = Object.prototype.toString, Fdt = /* @__PURE__ */ (() => {
  const e = function() {
  };
  return e.prototype = /* @__PURE__ */ Object.create(null), e;
})();
function xdt(e, t) {
  const i = new Fdt(), n = e.length;
  if (n < 2)
    return i;
  const r = (t == null ? void 0 : t.decode) || Jdt;
  let g = 0;
  do {
    const o = e.indexOf("=", g);
    if (o === -1)
      break;
    const l = e.indexOf(";", g), a = l === -1 ? n : l;
    if (o > a) {
      g = e.lastIndexOf(";", o - 1) + 1;
      continue;
    }
    const I = RT(e, g, o), c = XT(e, o, I), d = e.slice(I, c);
    if (i[d] === void 0) {
      let C = RT(e, o + 1, a), A = XT(e, a, C);
      const b = r(e.slice(C, A));
      i[d] = b;
    }
    g = a + 1;
  } while (g < n);
  return i;
}
function RT(e, t, i) {
  do {
    const n = e.charCodeAt(t);
    if (n !== 32 && n !== 9)
      return t;
  } while (++t < i);
  return i;
}
function XT(e, t, i) {
  for (; t > i; ) {
    const n = e.charCodeAt(--t);
    if (n !== 32 && n !== 9)
      return t + 1;
  }
  return i;
}
function Ddt(e, t, i) {
  const n = (i == null ? void 0 : i.encode) || encodeURIComponent;
  if (!Rdt.test(e))
    throw new TypeError(`argument name is invalid: ${e}`);
  const r = n(t);
  if (!Xdt.test(r))
    throw new TypeError(`argument val is invalid: ${t}`);
  let g = e + "=" + r;
  if (!i)
    return g;
  if (i.maxAge !== void 0) {
    if (!Number.isInteger(i.maxAge))
      throw new TypeError(`option maxAge is invalid: ${i.maxAge}`);
    g += "; Max-Age=" + i.maxAge;
  }
  if (i.domain) {
    if (!Hdt.test(i.domain))
      throw new TypeError(`option domain is invalid: ${i.domain}`);
    g += "; Domain=" + i.domain;
  }
  if (i.path) {
    if (!kdt.test(i.path))
      throw new TypeError(`option path is invalid: ${i.path}`);
    g += "; Path=" + i.path;
  }
  if (i.expires) {
    if (!Edt(i.expires) || !Number.isFinite(i.expires.valueOf()))
      throw new TypeError(`option expires is invalid: ${i.expires}`);
    g += "; Expires=" + i.expires.toUTCString();
  }
  if (i.httpOnly && (g += "; HttpOnly"), i.secure && (g += "; Secure"), i.partitioned && (g += "; Partitioned"), i.priority)
    switch (typeof i.priority == "string" ? i.priority.toLowerCase() : void 0) {
      case "low":
        g += "; Priority=Low";
        break;
      case "medium":
        g += "; Priority=Medium";
        break;
      case "high":
        g += "; Priority=High";
        break;
      default:
        throw new TypeError(`option priority is invalid: ${i.priority}`);
    }
  if (i.sameSite)
    switch (typeof i.sameSite == "string" ? i.sameSite.toLowerCase() : i.sameSite) {
      case !0:
      case "strict":
        g += "; SameSite=Strict";
        break;
      case "lax":
        g += "; SameSite=Lax";
        break;
      case "none":
        g += "; SameSite=None";
        break;
      default:
        throw new TypeError(`option sameSite is invalid: ${i.sameSite}`);
    }
  return g;
}
function Jdt(e) {
  if (e.indexOf("%") === -1)
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}
function Edt(e) {
  return Ydt.call(e) === "[object Date]";
}
/**
 * react-router v7.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var C8 = (e) => {
  throw TypeError(e);
}, Ndt = (e, t, i) => t.has(e) || C8("Cannot " + i), VY = (e, t, i) => (Ndt(e, t, "read from private field"), i ? i.call(e) : t.get(e)), Ldt = (e, t, i) => t.has(e) ? C8("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, i), HT = "popstate";
function Kdt(e = {}) {
  function t(r, g) {
    let {
      pathname: o = "/",
      search: l = "",
      hash: a = ""
    } = YI(r.location.hash.substring(1));
    return !o.startsWith("/") && !o.startsWith(".") && (o = "/" + o), Ef(
      "",
      { pathname: o, search: l, hash: a },
      // state defaults to `null` because `window.history.state` does
      g.state && g.state.usr || null,
      g.state && g.state.key || "default"
    );
  }
  function i(r, g) {
    let o = r.document.querySelector("base"), l = "";
    if (o && o.getAttribute("href")) {
      let a = r.location.href, I = a.indexOf("#");
      l = I === -1 ? a : a.slice(0, I);
    }
    return l + "#" + (typeof g == "string" ? g : nu(g));
  }
  function n(r, g) {
    mr(
      r.pathname.charAt(0) === "/",
      `relative pathnames are not supported in hash history.push(${JSON.stringify(
        g
      )})`
    );
  }
  return Mdt(
    t,
    i,
    n,
    e
  );
}
function xi(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function mr(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Tdt() {
  return Math.random().toString(36).substring(2, 10);
}
function kT(e, t) {
  return {
    usr: e.state,
    key: e.key,
    idx: t
  };
}
function Ef(e, t, i = null, n) {
  return {
    pathname: typeof e == "string" ? e : e.pathname,
    search: "",
    hash: "",
    ...typeof t == "string" ? YI(t) : t,
    state: i,
    // TODO: This could be cleaned up.  push/replace should probably just take
    // full Locations now and avoid the need to run through this flow at all
    // But that's a pretty big refactor to the current test suite so going to
    // keep as is for the time being and just let any incoming keys take precedence
    key: t && t.key || n || Tdt()
  };
}
function nu({
  pathname: e = "/",
  search: t = "",
  hash: i = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), i && i !== "#" && (e += i.charAt(0) === "#" ? i : "#" + i), e;
}
function YI(e) {
  let t = {};
  if (e) {
    let i = e.indexOf("#");
    i >= 0 && (t.hash = e.substring(i), e = e.substring(0, i));
    let n = e.indexOf("?");
    n >= 0 && (t.search = e.substring(n), e = e.substring(0, n)), e && (t.pathname = e);
  }
  return t;
}
function Mdt(e, t, i, n = {}) {
  let { window: r = document.defaultView, v5Compat: g = !1 } = n, o = r.history, l = "POP", a = null, I = c();
  I == null && (I = 0, o.replaceState({ ...o.state, idx: I }, ""));
  function c() {
    return (o.state || { idx: null }).idx;
  }
  function d() {
    l = "POP";
    let p = c(), B = p == null ? null : p - I;
    I = p, a && a({ action: l, location: m.location, delta: B });
  }
  function C(p, B) {
    l = "PUSH";
    let f = Ef(m.location, p, B);
    i && i(f, p), I = c() + 1;
    let Z = kT(f, I), y = m.createHref(f);
    try {
      o.pushState(Z, "", y);
    } catch (W) {
      if (W instanceof DOMException && W.name === "DataCloneError")
        throw W;
      r.location.assign(y);
    }
    g && a && a({ action: l, location: m.location, delta: 1 });
  }
  function A(p, B) {
    l = "REPLACE";
    let f = Ef(m.location, p, B);
    i && i(f, p), I = c();
    let Z = kT(f, I), y = m.createHref(f);
    o.replaceState(Z, "", y), g && a && a({ action: l, location: m.location, delta: 0 });
  }
  function b(p) {
    let B = r.location.origin !== "null" ? r.location.origin : r.location.href, f = typeof p == "string" ? p : nu(p);
    return f = f.replace(/ $/, "%20"), xi(
      B,
      `No window.location.(origin|href) available to create URL for href: ${f}`
    ), new URL(f, B);
  }
  let m = {
    get action() {
      return l;
    },
    get location() {
      return e(r, o);
    },
    listen(p) {
      if (a)
        throw new Error("A history only accepts one active listener");
      return r.addEventListener(HT, d), a = p, () => {
        r.removeEventListener(HT, d), a = null;
      };
    },
    createHref(p) {
      return t(r, p);
    },
    createURL: b,
    encodeLocation(p) {
      let B = b(p);
      return {
        pathname: B.pathname,
        search: B.search,
        hash: B.hash
      };
    },
    push: C,
    replace: A,
    go(p) {
      return o.go(p);
    }
  };
  return m;
}
var wB, YT = class {
  constructor(e) {
    if (Ldt(this, wB, /* @__PURE__ */ new Map()), e)
      for (let [t, i] of e)
        this.set(t, i);
  }
  get(e) {
    if (VY(this, wB).has(e))
      return VY(this, wB).get(e);
    if (e.defaultValue !== void 0)
      return e.defaultValue;
    throw new Error("No value found for context");
  }
  set(e, t) {
    VY(this, wB).set(e, t);
  }
};
wB = /* @__PURE__ */ new WeakMap();
var Pdt = /* @__PURE__ */ new Set([
  "lazy",
  "caseSensitive",
  "path",
  "id",
  "index",
  "children"
]);
function Udt(e) {
  return Pdt.has(
    e
  );
}
var zdt = /* @__PURE__ */ new Set([
  "lazy",
  "caseSensitive",
  "path",
  "id",
  "index",
  "unstable_middleware",
  "children"
]);
function Odt(e) {
  return zdt.has(
    e
  );
}
function Qdt(e) {
  return e.index === !0;
}
function pw(e, t, i = [], n = {}) {
  return e.map((r, g) => {
    let o = [...i, String(g)], l = typeof r.id == "string" ? r.id : o.join("-");
    if (xi(
      r.index !== !0 || !r.children,
      "Cannot specify children on an index route"
    ), xi(
      !n[l],
      `Found a route id collision on id "${l}".  Route id's must be globally unique within Data Router usages`
    ), Qdt(r)) {
      let a = {
        ...r,
        ...t(r),
        id: l
      };
      return n[l] = a, a;
    } else {
      let a = {
        ...r,
        ...t(r),
        id: l,
        children: void 0
      };
      return n[l] = a, r.children && (a.children = pw(
        r.children,
        t,
        o,
        n
      )), a;
    }
  });
}
function vd(e, t, i = "/") {
  return dV(e, t, i, !1);
}
function dV(e, t, i, n) {
  let r = typeof t == "string" ? YI(t) : t, g = cl(r.pathname || "/", i);
  if (g == null)
    return null;
  let o = A8(e);
  qdt(o);
  let l = null;
  for (let a = 0; l == null && a < o.length; ++a) {
    let I = h8(g);
    l = out(
      o[a],
      I,
      n
    );
  }
  return l;
}
function jdt(e, t) {
  let { route: i, pathname: n, params: r } = e;
  return {
    id: i.id,
    pathname: n,
    params: r,
    data: t[i.id],
    handle: i.handle
  };
}
function A8(e, t = [], i = [], n = "") {
  let r = (g, o, l) => {
    let a = {
      relativePath: l === void 0 ? g.path || "" : l,
      caseSensitive: g.caseSensitive === !0,
      childrenIndex: o,
      route: g
    };
    a.relativePath.startsWith("/") && (xi(
      a.relativePath.startsWith(n),
      `Absolute route path "${a.relativePath}" nested under path "${n}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
    ), a.relativePath = a.relativePath.slice(n.length));
    let I = fI([n, a.relativePath]), c = i.concat(a);
    g.children && g.children.length > 0 && (xi(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      g.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${I}".`
    ), A8(g.children, t, c, I)), !(g.path == null && !g.index) && t.push({
      path: I,
      score: rut(I, g.index),
      routesMeta: c
    });
  };
  return e.forEach((g, o) => {
    var l;
    if (g.path === "" || !((l = g.path) != null && l.includes("?")))
      r(g, o);
    else
      for (let a of b8(g.path))
        r(g, o, a);
  }), t;
}
function b8(e) {
  let t = e.split("/");
  if (t.length === 0)
    return [];
  let [i, ...n] = t, r = i.endsWith("?"), g = i.replace(/\?$/, "");
  if (n.length === 0)
    return r ? [g, ""] : [g];
  let o = b8(n.join("/")), l = [];
  return l.push(
    ...o.map(
      (a) => a === "" ? g : [g, a].join("/")
    )
  ), r && l.push(...o), l.map(
    (a) => e.startsWith("/") && a === "" ? "/" : a
  );
}
function qdt(e) {
  e.sort(
    (t, i) => t.score !== i.score ? i.score - t.score : gut(
      t.routesMeta.map((n) => n.childrenIndex),
      i.routesMeta.map((n) => n.childrenIndex)
    )
  );
}
var _dt = /^:[\w-]+$/, $dt = 3, eut = 2, tut = 1, iut = 10, nut = -2, FT = (e) => e === "*";
function rut(e, t) {
  let i = e.split("/"), n = i.length;
  return i.some(FT) && (n += nut), t && (n += eut), i.filter((r) => !FT(r)).reduce(
    (r, g) => r + (_dt.test(g) ? $dt : g === "" ? tut : iut),
    n
  );
}
function gut(e, t) {
  return e.length === t.length && e.slice(0, -1).every((n, r) => n === t[r]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function out(e, t, i = !1) {
  let { routesMeta: n } = e, r = {}, g = "/", o = [];
  for (let l = 0; l < n.length; ++l) {
    let a = n[l], I = l === n.length - 1, c = g === "/" ? t : t.slice(g.length) || "/", d = Nf(
      { path: a.relativePath, caseSensitive: a.caseSensitive, end: I },
      c
    ), C = a.route;
    if (!d && I && i && !n[n.length - 1].route.index && (d = Nf(
      {
        path: a.relativePath,
        caseSensitive: a.caseSensitive,
        end: !1
      },
      c
    )), !d)
      return null;
    Object.assign(r, d.params), o.push({
      // TODO: Can this as be avoided?
      params: r,
      pathname: fI([g, d.pathname]),
      pathnameBase: Iut(
        fI([g, d.pathnameBase])
      ),
      route: C
    }), d.pathnameBase !== "/" && (g = fI([g, d.pathnameBase]));
  }
  return o;
}
function Nf(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [i, n] = lut(
    e.path,
    e.caseSensitive,
    e.end
  ), r = t.match(i);
  if (!r)
    return null;
  let g = r[0], o = g.replace(/(.)\/+$/, "$1"), l = r.slice(1);
  return {
    params: n.reduce(
      (I, { paramName: c, isOptional: d }, C) => {
        if (c === "*") {
          let b = l[C] || "";
          o = g.slice(0, g.length - b.length).replace(/(.)\/+$/, "$1");
        }
        const A = l[C];
        return d && !A ? I[c] = void 0 : I[c] = (A || "").replace(/%2F/g, "/"), I;
      },
      {}
    ),
    pathname: g,
    pathnameBase: o,
    pattern: e
  };
}
function lut(e, t = !1, i = !0) {
  mr(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let n = [], r = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (o, l, a) => (n.push({ paramName: l, isOptional: a != null }), a ? "/?([^\\/]+)?" : "/([^\\/]+)")
  );
  return e.endsWith("*") ? (n.push({ paramName: "*" }), r += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : i ? r += "\\/*$" : e !== "" && e !== "/" && (r += "(?:(?=\\/|$))"), [new RegExp(r, t ? void 0 : "i"), n];
}
function h8(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return mr(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function cl(e, t) {
  if (t === "/")
    return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let i = t.endsWith("/") ? t.length - 1 : t.length, n = e.charAt(i);
  return n && n !== "/" ? null : e.slice(i) || "/";
}
function aut(e, t = "/") {
  let {
    pathname: i,
    search: n = "",
    hash: r = ""
  } = typeof e == "string" ? YI(e) : e;
  return {
    pathname: i ? i.startsWith("/") ? i : sut(i, t) : t,
    search: cut(n),
    hash: dut(r)
  };
}
function sut(e, t) {
  let i = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((r) => {
    r === ".." ? i.length > 1 && i.pop() : r !== "." && i.push(r);
  }), i.length > 1 ? i.join("/") : "/";
}
function wY(e, t, i, n) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    n
  )}].  Please separate it out to the \`to.${i}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function m8(e) {
  return e.filter(
    (t, i) => i === 0 || t.route.path && t.route.path.length > 0
  );
}
function Fv(e) {
  let t = m8(e);
  return t.map(
    (i, n) => n === t.length - 1 ? i.pathname : i.pathnameBase
  );
}
function xv(e, t, i, n = !1) {
  let r;
  typeof e == "string" ? r = YI(e) : (r = { ...e }, xi(
    !r.pathname || !r.pathname.includes("?"),
    wY("?", "pathname", "search", r)
  ), xi(
    !r.pathname || !r.pathname.includes("#"),
    wY("#", "pathname", "hash", r)
  ), xi(
    !r.search || !r.search.includes("#"),
    wY("#", "search", "hash", r)
  ));
  let g = e === "" || r.pathname === "", o = g ? "/" : r.pathname, l;
  if (o == null)
    l = i;
  else {
    let d = t.length - 1;
    if (!n && o.startsWith("..")) {
      let C = o.split("/");
      for (; C[0] === ".."; )
        C.shift(), d -= 1;
      r.pathname = C.join("/");
    }
    l = d >= 0 ? t[d] : "/";
  }
  let a = aut(r, l), I = o && o !== "/" && o.endsWith("/"), c = (g || o === ".") && i.endsWith("/");
  return !a.pathname.endsWith("/") && (I || c) && (a.pathname += "/"), a;
}
var fI = (e) => e.join("/").replace(/\/\/+/g, "/"), Iut = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), cut = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, dut = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e, Bw = class {
  constructor(e, t, i, n = !1) {
    this.status = e, this.statusText = t || "", this.internal = n, i instanceof Error ? (this.data = i.toString(), this.error = i) : this.data = i;
  }
};
function Lf(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var p8 = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
], uut = new Set(
  p8
), Cut = [
  "GET",
  ...p8
], Aut = new Set(Cut), but = /* @__PURE__ */ new Set([301, 302, 303, 307, 308]), hut = /* @__PURE__ */ new Set([307, 308]), vY = {
  state: "idle",
  location: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, mut = {
  state: "idle",
  data: void 0,
  formMethod: void 0,
  formAction: void 0,
  formEncType: void 0,
  formData: void 0,
  json: void 0,
  text: void 0
}, Xh = {
  state: "unblocked",
  proceed: void 0,
  reset: void 0,
  location: void 0
}, l9 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, put = (e) => ({
  hasErrorBoundary: !!e.hasErrorBoundary
}), B8 = "remix-router-transitions", f8 = Symbol("ResetLoaderData");
function But(e) {
  const t = e.window ? e.window : typeof window < "u" ? window : void 0, i = typeof t < "u" && typeof t.document < "u" && typeof t.document.createElement < "u";
  xi(
    e.routes.length > 0,
    "You must provide a non-empty routes array to createRouter"
  );
  let n = e.mapRouteProperties || put, r = {}, g = pw(
    e.routes,
    n,
    void 0,
    r
  ), o, l = e.basename || "/", a = e.dataStrategy || Sut, I = {
    unstable_middleware: !1,
    ...e.future
  }, c = null, d = /* @__PURE__ */ new Set(), C = null, A = null, b = null, m = e.hydrationData != null, p = vd(g, e.history.location, l), B = !1, f = null;
  if (p == null && !e.patchRoutesOnNavigation) {
    let le = Za(404, {
      pathname: e.history.location.pathname
    }), { matches: Ce, route: pe } = QT(g);
    p = Ce, f = { [pe.id]: le };
  }
  p && !e.hydrationData && ui(
    p,
    g,
    e.history.location.pathname
  ).active && (p = null);
  let Z;
  if (p)
    if (p.some((le) => le.route.lazy))
      Z = !1;
    else if (!p.some((le) => le.route.loader))
      Z = !0;
    else {
      let le = e.hydrationData ? e.hydrationData.loaderData : null, Ce = e.hydrationData ? e.hydrationData.errors : null;
      if (Ce) {
        let pe = p.findIndex(
          (Ne) => Ce[Ne.route.id] !== void 0
        );
        Z = p.slice(0, pe + 1).every((Ne) => !Px(Ne.route, le, Ce));
      } else
        Z = p.every(
          (pe) => !Px(pe.route, le, Ce)
        );
    }
  else {
    Z = !1, p = [];
    let le = ui(
      null,
      g,
      e.history.location.pathname
    );
    le.active && le.matches && (B = !0, p = le.matches);
  }
  let y, W = {
    historyAction: e.history.action,
    location: e.history.location,
    matches: p,
    initialized: Z,
    navigation: vY,
    // Don't restore on initial updateState() if we were SSR'd
    restoreScrollPosition: e.hydrationData != null ? !1 : null,
    preventScrollReset: !1,
    revalidation: "idle",
    loaderData: e.hydrationData && e.hydrationData.loaderData || {},
    actionData: e.hydrationData && e.hydrationData.actionData || null,
    errors: e.hydrationData && e.hydrationData.errors || f,
    fetchers: /* @__PURE__ */ new Map(),
    blockers: /* @__PURE__ */ new Map()
  }, V = "POP", w = !1, v, H = !1, x = /* @__PURE__ */ new Map(), J = null, K = !1, M = !1, L = /* @__PURE__ */ new Set(), N = /* @__PURE__ */ new Map(), U = 0, O = -1, $ = /* @__PURE__ */ new Map(), ne = /* @__PURE__ */ new Set(), be = /* @__PURE__ */ new Map(), Ve = /* @__PURE__ */ new Map(), He = /* @__PURE__ */ new Set(), Je = /* @__PURE__ */ new Map(), ke, we = null;
  function ue() {
    if (c = e.history.listen(
      ({ action: le, location: Ce, delta: pe }) => {
        if (ke) {
          ke(), ke = void 0;
          return;
        }
        mr(
          Je.size === 0 || pe != null,
          "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL."
        );
        let Ne = Yt({
          currentLocation: W.location,
          nextLocation: Ce,
          historyAction: le
        });
        if (Ne && pe != null) {
          let Ke = new Promise((Jt) => {
            ke = Jt;
          });
          e.history.go(pe * -1), Me(Ne, {
            state: "blocked",
            location: Ce,
            proceed() {
              Me(Ne, {
                state: "proceeding",
                proceed: void 0,
                reset: void 0,
                location: Ce
              }), Ke.then(() => e.history.go(pe));
            },
            reset() {
              let Jt = new Map(W.blockers);
              Jt.set(Ne, Xh), xe({ blockers: Jt });
            }
          });
          return;
        }
        return it(le, Ce);
      }
    ), i) {
      Jut(t, x);
      let le = () => Eut(t, x);
      t.addEventListener("pagehide", le), J = () => t.removeEventListener("pagehide", le);
    }
    return W.initialized || it("POP", W.location, {
      initialHydration: !0
    }), y;
  }
  function Xe() {
    c && c(), J && J(), d.clear(), v && v.abort(), W.fetchers.forEach((le, Ce) => Ge(Ce)), W.blockers.forEach((le, Ce) => Ue(Ce));
  }
  function Ze(le) {
    return d.add(le), () => d.delete(le);
  }
  function xe(le, Ce = {}) {
    W = {
      ...W,
      ...le
    };
    let pe = [], Ne = [];
    W.fetchers.forEach((Ke, Jt) => {
      Ke.state === "idle" && (He.has(Jt) ? pe.push(Jt) : Ne.push(Jt));
    }), He.forEach((Ke) => {
      !W.fetchers.has(Ke) && !N.has(Ke) && pe.push(Ke);
    }), [...d].forEach(
      (Ke) => Ke(W, {
        deletedFetchers: pe,
        viewTransitionOpts: Ce.viewTransitionOpts,
        flushSync: Ce.flushSync === !0
      })
    ), pe.forEach((Ke) => Ge(Ke)), Ne.forEach((Ke) => W.fetchers.delete(Ke));
  }
  function Pe(le, Ce, { flushSync: pe } = {}) {
    var dt, xt;
    let Ne = W.actionData != null && W.navigation.formMethod != null && Ws(W.navigation.formMethod) && W.navigation.state === "loading" && ((dt = le.state) == null ? void 0 : dt._isRedirect) !== !0, Ke;
    Ce.actionData ? Object.keys(Ce.actionData).length > 0 ? Ke = Ce.actionData : Ke = null : Ne ? Ke = W.actionData : Ke = null;
    let Jt = Ce.loaderData ? zT(
      W.loaderData,
      Ce.loaderData,
      Ce.matches || [],
      Ce.errors
    ) : W.loaderData, Rt = W.blockers;
    Rt.size > 0 && (Rt = new Map(Rt), Rt.forEach((Ot, si) => Rt.set(si, Xh)));
    let Zt = w === !0 || W.navigation.formMethod != null && Ws(W.navigation.formMethod) && ((xt = le.state) == null ? void 0 : xt._isRedirect) !== !0;
    o && (g = o, o = void 0), K || V === "POP" || (V === "PUSH" ? e.history.push(le, le.state) : V === "REPLACE" && e.history.replace(le, le.state));
    let Et;
    if (V === "POP") {
      let Ot = x.get(W.location.pathname);
      Ot && Ot.has(le.pathname) ? Et = {
        currentLocation: W.location,
        nextLocation: le
      } : x.has(le.pathname) && (Et = {
        currentLocation: le,
        nextLocation: W.location
      });
    } else if (H) {
      let Ot = x.get(W.location.pathname);
      Ot ? Ot.add(le.pathname) : (Ot = /* @__PURE__ */ new Set([le.pathname]), x.set(W.location.pathname, Ot)), Et = {
        currentLocation: W.location,
        nextLocation: le
      };
    }
    xe(
      {
        ...Ce,
        // matches, errors, fetchers go through as-is
        actionData: Ke,
        loaderData: Jt,
        historyAction: V,
        location: le,
        initialized: !0,
        navigation: vY,
        revalidation: "idle",
        restoreScrollPosition: Ai(
          le,
          Ce.matches || W.matches
        ),
        preventScrollReset: Zt,
        blockers: Rt
      },
      {
        viewTransitionOpts: Et,
        flushSync: pe === !0
      }
    ), V = "POP", w = !1, H = !1, K = !1, M = !1, we == null || we.resolve(), we = null;
  }
  async function st(le, Ce) {
    if (typeof le == "number") {
      e.history.go(le);
      return;
    }
    let pe = Mx(
      W.location,
      W.matches,
      l,
      le,
      Ce == null ? void 0 : Ce.fromRouteId,
      Ce == null ? void 0 : Ce.relative
    ), { path: Ne, submission: Ke, error: Jt } = xT(
      !1,
      pe,
      Ce
    ), Rt = W.location, Zt = Ef(W.location, Ne, Ce && Ce.state);
    Zt = {
      ...Zt,
      ...e.history.encodeLocation(Zt)
    };
    let Et = Ce && Ce.replace != null ? Ce.replace : void 0, dt = "PUSH";
    Et === !0 ? dt = "REPLACE" : Et === !1 || Ke != null && Ws(Ke.formMethod) && Ke.formAction === W.location.pathname + W.location.search && (dt = "REPLACE");
    let xt = Ce && "preventScrollReset" in Ce ? Ce.preventScrollReset === !0 : void 0, Ot = (Ce && Ce.flushSync) === !0, si = Yt({
      currentLocation: Rt,
      nextLocation: Zt,
      historyAction: dt
    });
    if (si) {
      Me(si, {
        state: "blocked",
        location: Zt,
        proceed() {
          Me(si, {
            state: "proceeding",
            proceed: void 0,
            reset: void 0,
            location: Zt
          }), st(le, Ce);
        },
        reset() {
          let Li = new Map(W.blockers);
          Li.set(si, Xh), xe({ blockers: Li });
        }
      });
      return;
    }
    await it(dt, Zt, {
      submission: Ke,
      // Send through the formData serialization error if we have one so we can
      // render at the right error boundary after we match routes
      pendingError: Jt,
      preventScrollReset: xt,
      replace: Ce && Ce.replace,
      enableViewTransition: Ce && Ce.viewTransition,
      flushSync: Ot
    });
  }
  function bt() {
    we || (we = Nut()), ni(), xe({ revalidation: "loading" });
    let le = we.promise;
    return W.navigation.state === "submitting" ? le : W.navigation.state === "idle" ? (it(W.historyAction, W.location, {
      startUninterruptedRevalidation: !0
    }), le) : (it(
      V || W.historyAction,
      W.navigation.location,
      {
        overrideNavigation: W.navigation,
        // Proxy through any rending view transition
        enableViewTransition: H === !0
      }
    ), le);
  }
  async function it(le, Ce, pe) {
    v && v.abort(), v = null, V = le, K = (pe && pe.startUninterruptedRevalidation) === !0, mt(W.location, W.matches), w = (pe && pe.preventScrollReset) === !0, H = (pe && pe.enableViewTransition) === !0;
    let Ne = o || g, Ke = pe && pe.overrideNavigation, Jt = pe != null && pe.initialHydration && W.matches && W.matches.length > 0 && !B ? (
      // `matchRoutes()` has already been called if we're in here via `router.initialize()`
      W.matches
    ) : vd(Ne, Ce, l), Rt = (pe && pe.flushSync) === !0;
    if (Jt && W.initialized && !M && kut(W.location, Ce) && !(pe && pe.submission && Ws(pe.submission.formMethod))) {
      Pe(Ce, { matches: Jt }, { flushSync: Rt });
      return;
    }
    let Zt = ui(Jt, Ne, Ce.pathname);
    if (Zt.active && Zt.matches && (Jt = Zt.matches), !Jt) {
      let { error: Ae, notFoundMatches: gt, route: _e } = zt(
        Ce.pathname
      );
      Pe(
        Ce,
        {
          matches: gt,
          loaderData: {},
          errors: {
            [_e.id]: Ae
          }
        },
        { flushSync: Rt }
      );
      return;
    }
    v = new AbortController();
    let Et = ah(
      e.history,
      Ce,
      v.signal,
      pe && pe.submission
    ), dt = new YT(
      e.unstable_getContext ? await e.unstable_getContext() : void 0
    ), xt;
    if (pe && pe.pendingError)
      xt = [
        XC(Jt).route.id,
        { type: "error", error: pe.pendingError }
      ];
    else if (pe && pe.submission && Ws(pe.submission.formMethod)) {
      let Ae = await Qe(
        Et,
        Ce,
        pe.submission,
        Jt,
        dt,
        Zt.active,
        { replace: pe.replace, flushSync: Rt }
      );
      if (Ae.shortCircuited)
        return;
      if (Ae.pendingActionResult) {
        let [gt, _e] = Ae.pendingActionResult;
        if (wl(_e) && Lf(_e.error) && _e.error.status === 404) {
          v = null, Pe(Ce, {
            matches: Ae.matches,
            loaderData: {},
            errors: {
              [gt]: _e.error
            }
          });
          return;
        }
      }
      Jt = Ae.matches || Jt, xt = Ae.pendingActionResult, Ke = RY(Ce, pe.submission), Rt = !1, Zt.active = !1, Et = ah(
        e.history,
        Et.url,
        Et.signal
      );
    }
    let {
      shortCircuited: Ot,
      matches: si,
      loaderData: Li,
      errors: fe
    } = await $e(
      Et,
      Ce,
      Jt,
      dt,
      Zt.active,
      Ke,
      pe && pe.submission,
      pe && pe.fetcherSubmission,
      pe && pe.replace,
      pe && pe.initialHydration === !0,
      Rt,
      xt
    );
    Ot || (v = null, Pe(Ce, {
      matches: si || Jt,
      ...OT(xt),
      loaderData: Li,
      errors: fe
    }));
  }
  async function Qe(le, Ce, pe, Ne, Ke, Jt, Rt = {}) {
    ni();
    let Zt = xut(Ce, pe);
    if (xe({ navigation: Zt }, { flushSync: Rt.flushSync === !0 }), Jt) {
      let xt = await Ui(
        Ne,
        Ce.pathname,
        le.signal
      );
      if (xt.type === "aborted")
        return { shortCircuited: !0 };
      if (xt.type === "error") {
        let Ot = XC(xt.partialMatches).route.id;
        return {
          matches: xt.partialMatches,
          pendingActionResult: [
            Ot,
            {
              type: "error",
              error: xt.error
            }
          ]
        };
      } else if (xt.matches)
        Ne = xt.matches;
      else {
        let { notFoundMatches: Ot, error: si, route: Li } = zt(
          Ce.pathname
        );
        return {
          matches: Ot,
          pendingActionResult: [
            Li.id,
            {
              type: "error",
              error: si
            }
          ]
        };
      }
    }
    let Et, dt = vB(Ne, Ce);
    if (!dt.route.action && !dt.route.lazy)
      Et = {
        type: "error",
        error: Za(405, {
          method: le.method,
          pathname: Ce.pathname,
          routeId: dt.route.id
        })
      };
    else {
      let xt = await ii(
        "action",
        le,
        [dt],
        Ne,
        Ke,
        null
      );
      if (Et = xt[dt.route.id], !Et) {
        for (let Ot of Ne)
          if (xt[Ot.route.id]) {
            Et = xt[Ot.route.id];
            break;
          }
      }
      if (le.signal.aborted)
        return { shortCircuited: !0 };
    }
    if (NC(Et)) {
      let xt;
      return Rt && Rt.replace != null ? xt = Rt.replace : xt = MT(
        Et.response.headers.get("Location"),
        new URL(le.url),
        l
      ) === W.location.pathname + W.location.search, await Ht(le, Et, !0, {
        submission: pe,
        replace: xt
      }), { shortCircuited: !0 };
    }
    if (wl(Et)) {
      let xt = XC(Ne, dt.route.id);
      return (Rt && Rt.replace) !== !0 && (V = "PUSH"), {
        matches: Ne,
        pendingActionResult: [xt.route.id, Et]
      };
    }
    return {
      matches: Ne,
      pendingActionResult: [dt.route.id, Et]
    };
  }
  async function $e(le, Ce, pe, Ne, Ke, Jt, Rt, Zt, Et, dt, xt, Ot) {
    let si = Jt || RY(Ce, Rt), Li = Rt || Zt || qT(si), fe = !K && !dt;
    if (Ke) {
      if (fe) {
        let bn = It(Ot);
        xe(
          {
            navigation: si,
            ...bn !== void 0 ? { actionData: bn } : {}
          },
          {
            flushSync: xt
          }
        );
      }
      let Xi = await Ui(
        pe,
        Ce.pathname,
        le.signal
      );
      if (Xi.type === "aborted")
        return { shortCircuited: !0 };
      if (Xi.type === "error") {
        let bn = XC(Xi.partialMatches).route.id;
        return {
          matches: Xi.partialMatches,
          loaderData: {},
          errors: {
            [bn]: Xi.error
          }
        };
      } else if (Xi.matches)
        pe = Xi.matches;
      else {
        let { error: bn, notFoundMatches: so, route: bl } = zt(
          Ce.pathname
        );
        return {
          matches: so,
          loaderData: {},
          errors: {
            [bl.id]: bn
          }
        };
      }
    }
    let Ae = o || g, [gt, _e] = JT(
      e.history,
      W,
      pe,
      Li,
      Ce,
      dt === !0,
      M,
      L,
      He,
      be,
      ne,
      Ae,
      l,
      Ot
    );
    if (O = ++U, gt.length === 0 && _e.length === 0) {
      let Xi = Kt();
      return Pe(
        Ce,
        {
          matches: pe,
          loaderData: {},
          // Commit pending error if we're short circuiting
          errors: Ot && wl(Ot[1]) ? { [Ot[0]]: Ot[1].error } : null,
          ...OT(Ot),
          ...Xi ? { fetchers: new Map(W.fetchers) } : {}
        },
        { flushSync: xt }
      ), { shortCircuited: !0 };
    }
    if (fe) {
      let Xi = {};
      if (!Ke) {
        Xi.navigation = si;
        let bn = It(Ot);
        bn !== void 0 && (Xi.actionData = bn);
      }
      _e.length > 0 && (Xi.fetchers = jt(_e)), xe(Xi, { flushSync: xt });
    }
    _e.forEach((Xi) => {
      qe(Xi.key), Xi.controller && N.set(Xi.key, Xi.controller);
    });
    let Qt = () => _e.forEach((Xi) => qe(Xi.key));
    v && v.signal.addEventListener(
      "abort",
      Qt
    );
    let { loaderResults: kt, fetcherResults: ti } = await $t(
      pe,
      gt,
      _e,
      le,
      Ne
    );
    if (le.signal.aborted)
      return { shortCircuited: !0 };
    v && v.signal.removeEventListener(
      "abort",
      Qt
    ), _e.forEach((Xi) => N.delete(Xi.key));
    let tn = $W(kt);
    if (tn)
      return await Ht(le, tn.result, !0, {
        replace: Et
      }), { shortCircuited: !0 };
    if (tn = $W(ti), tn)
      return ne.add(tn.key), await Ht(le, tn.result, !0, {
        replace: Et
      }), { shortCircuited: !0 };
    let { loaderData: ao, errors: Nr } = UT(
      W,
      pe,
      kt,
      Ot,
      _e,
      ti
    );
    dt && W.errors && (Nr = { ...W.errors, ...Nr });
    let vg = Kt(), es = Te(O), tg = vg || es || _e.length > 0;
    return {
      matches: pe,
      loaderData: ao,
      errors: Nr,
      ...tg ? { fetchers: new Map(W.fetchers) } : {}
    };
  }
  function It(le) {
    if (le && !wl(le[1]))
      return {
        [le[0]]: le[1].data
      };
    if (W.actionData)
      return Object.keys(W.actionData).length === 0 ? null : W.actionData;
  }
  function jt(le) {
    return le.forEach((Ce) => {
      let pe = W.fetchers.get(Ce.key), Ne = eB(
        void 0,
        pe ? pe.data : void 0
      );
      W.fetchers.set(Ce.key, Ne);
    }), new Map(W.fetchers);
  }
  async function Bt(le, Ce, pe, Ne) {
    qe(le);
    let Ke = (Ne && Ne.flushSync) === !0, Jt = o || g, Rt = Mx(
      W.location,
      W.matches,
      l,
      pe,
      Ce,
      Ne == null ? void 0 : Ne.relative
    ), Zt = vd(Jt, Rt, l), Et = ui(Zt, Jt, Rt);
    if (Et.active && Et.matches && (Zt = Et.matches), !Zt) {
      Bi(
        le,
        Ce,
        Za(404, { pathname: Rt }),
        { flushSync: Ke }
      );
      return;
    }
    let { path: dt, submission: xt, error: Ot } = xT(
      !0,
      Rt,
      Ne
    );
    if (Ot) {
      Bi(le, Ce, Ot, { flushSync: Ke });
      return;
    }
    let si = vB(Zt, dt), Li = new YT(
      e.unstable_getContext ? await e.unstable_getContext() : void 0
    ), fe = (Ne && Ne.preventScrollReset) === !0;
    if (xt && Ws(xt.formMethod)) {
      await te(
        le,
        Ce,
        dt,
        si,
        Zt,
        Li,
        Et.active,
        Ke,
        fe,
        xt
      );
      return;
    }
    be.set(le, { routeId: Ce, path: dt }), await Xt(
      le,
      Ce,
      dt,
      si,
      Zt,
      Li,
      Et.active,
      Ke,
      fe,
      xt
    );
  }
  async function te(le, Ce, pe, Ne, Ke, Jt, Rt, Zt, Et, dt) {
    ni(), be.delete(le);
    function xt(hn) {
      if (!hn.route.action && !hn.route.lazy) {
        let hl = Za(405, {
          method: dt.formMethod,
          pathname: pe,
          routeId: Ce
        });
        return Bi(le, Ce, hl, { flushSync: Zt }), !0;
      }
      return !1;
    }
    if (!Rt && xt(Ne))
      return;
    let Ot = W.fetchers.get(le);
    mi(le, Dut(dt, Ot), {
      flushSync: Zt
    });
    let si = new AbortController(), Li = ah(
      e.history,
      pe,
      si.signal,
      dt
    );
    if (Rt) {
      let hn = await Ui(
        Ke,
        pe,
        Li.signal,
        le
      );
      if (hn.type === "aborted")
        return;
      if (hn.type === "error") {
        Bi(le, Ce, hn.error, { flushSync: Zt });
        return;
      } else if (hn.matches) {
        if (Ke = hn.matches, Ne = vB(Ke, pe), xt(Ne))
          return;
      } else {
        Bi(
          le,
          Ce,
          Za(404, { pathname: pe }),
          { flushSync: Zt }
        );
        return;
      }
    }
    N.set(le, si);
    let fe = U, gt = (await ii(
      "action",
      Li,
      [Ne],
      Ke,
      Jt,
      le
    ))[Ne.route.id];
    if (Li.signal.aborted) {
      N.get(le) === si && N.delete(le);
      return;
    }
    if (He.has(le)) {
      if (NC(gt) || wl(gt)) {
        mi(le, Bd(void 0));
        return;
      }
    } else {
      if (NC(gt))
        if (N.delete(le), O > fe) {
          mi(le, Bd(void 0));
          return;
        } else
          return ne.add(le), mi(le, eB(dt)), Ht(Li, gt, !1, {
            fetcherSubmission: dt,
            preventScrollReset: Et
          });
      if (wl(gt)) {
        Bi(le, Ce, gt.error);
        return;
      }
    }
    let _e = W.navigation.location || W.location, Qt = ah(
      e.history,
      _e,
      si.signal
    ), kt = o || g, ti = W.navigation.state !== "idle" ? vd(kt, W.navigation.location, l) : W.matches;
    xi(ti, "Didn't find any matches after fetcher action");
    let tn = ++U;
    $.set(le, tn);
    let ao = eB(dt, gt.data);
    W.fetchers.set(le, ao);
    let [Nr, vg] = JT(
      e.history,
      W,
      ti,
      dt,
      _e,
      !1,
      M,
      L,
      He,
      be,
      ne,
      kt,
      l,
      [Ne.route.id, gt]
    );
    vg.filter((hn) => hn.key !== le).forEach((hn) => {
      let hl = hn.key, ia = W.fetchers.get(hl), ml = eB(
        void 0,
        ia ? ia.data : void 0
      );
      W.fetchers.set(hl, ml), qe(hl), hn.controller && N.set(hl, hn.controller);
    }), xe({ fetchers: new Map(W.fetchers) });
    let es = () => vg.forEach((hn) => qe(hn.key));
    si.signal.addEventListener(
      "abort",
      es
    );
    let { loaderResults: tg, fetcherResults: Xi } = await $t(
      ti,
      Nr,
      vg,
      Qt,
      Jt
    );
    if (si.signal.aborted)
      return;
    si.signal.removeEventListener(
      "abort",
      es
    ), $.delete(le), N.delete(le), vg.forEach((hn) => N.delete(hn.key));
    let bn = $W(tg);
    if (bn)
      return Ht(
        Qt,
        bn.result,
        !1,
        { preventScrollReset: Et }
      );
    if (bn = $W(Xi), bn)
      return ne.add(bn.key), Ht(
        Qt,
        bn.result,
        !1,
        { preventScrollReset: Et }
      );
    let { loaderData: so, errors: bl } = UT(
      W,
      ti,
      tg,
      void 0,
      vg,
      Xi
    );
    if (W.fetchers.has(le)) {
      let hn = Bd(gt.data);
      W.fetchers.set(le, hn);
    }
    Te(tn), W.navigation.state === "loading" && tn > O ? (xi(V, "Expected pending action"), v && v.abort(), Pe(W.navigation.location, {
      matches: ti,
      loaderData: so,
      errors: bl,
      fetchers: new Map(W.fetchers)
    })) : (xe({
      errors: bl,
      loaderData: zT(
        W.loaderData,
        so,
        ti,
        bl
      ),
      fetchers: new Map(W.fetchers)
    }), M = !1);
  }
  async function Xt(le, Ce, pe, Ne, Ke, Jt, Rt, Zt, Et, dt) {
    let xt = W.fetchers.get(le);
    mi(
      le,
      eB(
        dt,
        xt ? xt.data : void 0
      ),
      { flushSync: Zt }
    );
    let Ot = new AbortController(), si = ah(
      e.history,
      pe,
      Ot.signal
    );
    if (Rt) {
      let gt = await Ui(
        Ke,
        pe,
        si.signal,
        le
      );
      if (gt.type === "aborted")
        return;
      if (gt.type === "error") {
        Bi(le, Ce, gt.error, { flushSync: Zt });
        return;
      } else if (gt.matches)
        Ke = gt.matches, Ne = vB(Ke, pe);
      else {
        Bi(
          le,
          Ce,
          Za(404, { pathname: pe }),
          { flushSync: Zt }
        );
        return;
      }
    }
    N.set(le, Ot);
    let Li = U, Ae = (await ii(
      "loader",
      si,
      [Ne],
      Ke,
      Jt,
      le
    ))[Ne.route.id];
    if (N.get(le) === Ot && N.delete(le), !si.signal.aborted) {
      if (He.has(le)) {
        mi(le, Bd(void 0));
        return;
      }
      if (NC(Ae))
        if (O > Li) {
          mi(le, Bd(void 0));
          return;
        } else {
          ne.add(le), await Ht(si, Ae, !1, {
            preventScrollReset: Et
          });
          return;
        }
      if (wl(Ae)) {
        Bi(le, Ce, Ae.error);
        return;
      }
      mi(le, Bd(Ae.data));
    }
  }
  async function Ht(le, Ce, pe, {
    submission: Ne,
    fetcherSubmission: Ke,
    preventScrollReset: Jt,
    replace: Rt
  } = {}) {
    Ce.response.headers.has("X-Remix-Revalidate") && (M = !0);
    let Zt = Ce.response.headers.get("Location");
    xi(Zt, "Expected a Location header on the redirect Response"), Zt = MT(
      Zt,
      new URL(le.url),
      l
    );
    let Et = Ef(W.location, Zt, {
      _isRedirect: !0
    });
    if (i) {
      let fe = !1;
      if (Ce.response.headers.has("X-Remix-Reload-Document"))
        fe = !0;
      else if (l9.test(Zt)) {
        const Ae = e.history.createURL(Zt);
        fe = // Hard reload if it's an absolute URL to a new origin
        Ae.origin !== t.location.origin || // Hard reload if it's an absolute URL that does not match our basename
        cl(Ae.pathname, l) == null;
      }
      if (fe) {
        Rt ? t.location.replace(Zt) : t.location.assign(Zt);
        return;
      }
    }
    v = null;
    let dt = Rt === !0 || Ce.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH", { formMethod: xt, formAction: Ot, formEncType: si } = W.navigation;
    !Ne && !Ke && xt && Ot && si && (Ne = qT(W.navigation));
    let Li = Ne || Ke;
    if (hut.has(Ce.response.status) && Li && Ws(Li.formMethod))
      await it(dt, Et, {
        submission: {
          ...Li,
          formAction: Zt
        },
        // Preserve these flags across redirects
        preventScrollReset: Jt || w,
        enableViewTransition: pe ? H : void 0
      });
    else {
      let fe = RY(
        Et,
        Ne
      );
      await it(dt, Et, {
        overrideNavigation: fe,
        // Send fetcher submissions through for shouldRevalidate
        fetcherSubmission: Ke,
        // Preserve these flags across redirects
        preventScrollReset: Jt || w,
        enableViewTransition: pe ? H : void 0
      });
    }
  }
  async function ii(le, Ce, pe, Ne, Ke, Jt) {
    let Rt, Zt = {};
    try {
      Rt = await wut(
        a,
        le,
        Ce,
        pe,
        Ne,
        Jt,
        r,
        n,
        Ke
      );
    } catch (Et) {
      return pe.forEach((dt) => {
        Zt[dt.route.id] = {
          type: "error",
          error: Et
        };
      }), Zt;
    }
    for (let [Et, dt] of Object.entries(Rt))
      if (Yut(dt)) {
        let xt = dt.result;
        Zt[Et] = {
          type: "redirect",
          response: Xut(
            xt,
            Ce,
            Et,
            Ne,
            l
          )
        };
      } else
        Zt[Et] = await Rut(
          dt
        );
    return Zt;
  }
  async function $t(le, Ce, pe, Ne, Ke) {
    let Jt = ii(
      "loader",
      Ne,
      Ce,
      le,
      Ke,
      null
    ), Rt = Promise.all(
      pe.map(async (dt) => {
        if (dt.matches && dt.match && dt.controller) {
          let Ot = (await ii(
            "loader",
            ah(e.history, dt.path, dt.controller.signal),
            [dt.match],
            dt.matches,
            Ke,
            dt.key
          ))[dt.match.route.id];
          return { [dt.key]: Ot };
        } else
          return Promise.resolve({
            [dt.key]: {
              type: "error",
              error: Za(404, {
                pathname: dt.path
              })
            }
          });
      })
    ), Zt = await Jt, Et = (await Rt).reduce(
      (dt, xt) => Object.assign(dt, xt),
      {}
    );
    return {
      loaderResults: Zt,
      fetcherResults: Et
    };
  }
  function ni() {
    M = !0, be.forEach((le, Ce) => {
      N.has(Ce) && L.add(Ce), qe(Ce);
    });
  }
  function mi(le, Ce, pe = {}) {
    W.fetchers.set(le, Ce), xe(
      { fetchers: new Map(W.fetchers) },
      { flushSync: (pe && pe.flushSync) === !0 }
    );
  }
  function Bi(le, Ce, pe, Ne = {}) {
    let Ke = XC(W.matches, Ce);
    Ge(le), xe(
      {
        errors: {
          [Ke.route.id]: pe
        },
        fetchers: new Map(W.fetchers)
      },
      { flushSync: (Ne && Ne.flushSync) === !0 }
    );
  }
  function ci(le) {
    return Ve.set(le, (Ve.get(le) || 0) + 1), He.has(le) && He.delete(le), W.fetchers.get(le) || mut;
  }
  function Ge(le) {
    let Ce = W.fetchers.get(le);
    N.has(le) && !(Ce && Ce.state === "loading" && $.has(le)) && qe(le), be.delete(le), $.delete(le), ne.delete(le), He.delete(le), L.delete(le), W.fetchers.delete(le);
  }
  function Be(le) {
    let Ce = (Ve.get(le) || 0) - 1;
    Ce <= 0 ? (Ve.delete(le), He.add(le)) : Ve.set(le, Ce), xe({ fetchers: new Map(W.fetchers) });
  }
  function qe(le) {
    let Ce = N.get(le);
    Ce && (Ce.abort(), N.delete(le));
  }
  function vt(le) {
    for (let Ce of le) {
      let pe = ci(Ce), Ne = Bd(pe.data);
      W.fetchers.set(Ce, Ne);
    }
  }
  function Kt() {
    let le = [], Ce = !1;
    for (let pe of ne) {
      let Ne = W.fetchers.get(pe);
      xi(Ne, `Expected fetcher: ${pe}`), Ne.state === "loading" && (ne.delete(pe), le.push(pe), Ce = !0);
    }
    return vt(le), Ce;
  }
  function Te(le) {
    let Ce = [];
    for (let [pe, Ne] of $)
      if (Ne < le) {
        let Ke = W.fetchers.get(pe);
        xi(Ke, `Expected fetcher: ${pe}`), Ke.state === "loading" && (qe(pe), $.delete(pe), Ce.push(pe));
      }
    return vt(Ce), Ce.length > 0;
  }
  function Tt(le, Ce) {
    let pe = W.blockers.get(le) || Xh;
    return Je.get(le) !== Ce && Je.set(le, Ce), pe;
  }
  function Ue(le) {
    W.blockers.delete(le), Je.delete(le);
  }
  function Me(le, Ce) {
    let pe = W.blockers.get(le) || Xh;
    xi(
      pe.state === "unblocked" && Ce.state === "blocked" || pe.state === "blocked" && Ce.state === "blocked" || pe.state === "blocked" && Ce.state === "proceeding" || pe.state === "blocked" && Ce.state === "unblocked" || pe.state === "proceeding" && Ce.state === "unblocked",
      `Invalid blocker state transition: ${pe.state} -> ${Ce.state}`
    );
    let Ne = new Map(W.blockers);
    Ne.set(le, Ce), xe({ blockers: Ne });
  }
  function Yt({
    currentLocation: le,
    nextLocation: Ce,
    historyAction: pe
  }) {
    if (Je.size === 0)
      return;
    Je.size > 1 && mr(!1, "A router only supports one blocker at a time");
    let Ne = Array.from(Je.entries()), [Ke, Jt] = Ne[Ne.length - 1], Rt = W.blockers.get(Ke);
    if (!(Rt && Rt.state === "proceeding") && Jt({ currentLocation: le, nextLocation: Ce, historyAction: pe }))
      return Ke;
  }
  function zt(le) {
    let Ce = Za(404, { pathname: le }), pe = o || g, { matches: Ne, route: Ke } = QT(pe);
    return { notFoundMatches: Ne, route: Ke, error: Ce };
  }
  function ri(le, Ce, pe) {
    if (C = le, b = Ce, A = pe || null, !m && W.navigation === vY) {
      m = !0;
      let Ne = Ai(W.location, W.matches);
      Ne != null && xe({ restoreScrollPosition: Ne });
    }
    return () => {
      C = null, b = null, A = null;
    };
  }
  function di(le, Ce) {
    return A && A(
      le,
      Ce.map((Ne) => jdt(Ne, W.loaderData))
    ) || le.key;
  }
  function mt(le, Ce) {
    if (C && b) {
      let pe = di(le, Ce);
      C[pe] = b();
    }
  }
  function Ai(le, Ce) {
    if (C) {
      let pe = di(le, Ce), Ne = C[pe];
      if (typeof Ne == "number")
        return Ne;
    }
    return null;
  }
  function ui(le, Ce, pe) {
    if (e.patchRoutesOnNavigation)
      if (le) {
        if (Object.keys(le[0].params).length > 0)
          return { active: !0, matches: dV(
            Ce,
            pe,
            l,
            !0
          ) };
      } else
        return { active: !0, matches: dV(
          Ce,
          pe,
          l,
          !0
        ) || [] };
    return { active: !1, matches: null };
  }
  async function Ui(le, Ce, pe, Ne) {
    if (!e.patchRoutesOnNavigation)
      return { type: "success", matches: le };
    let Ke = le;
    for (; ; ) {
      let Jt = o == null, Rt = o || g, Zt = r;
      try {
        await e.patchRoutesOnNavigation({
          signal: pe,
          path: Ce,
          matches: Ke,
          fetcherKey: Ne,
          patch: (xt, Ot) => {
            pe.aborted || NT(
              xt,
              Ot,
              Rt,
              Zt,
              n
            );
          }
        });
      } catch (xt) {
        return { type: "error", error: xt, partialMatches: Ke };
      } finally {
        Jt && !pe.aborted && (g = [...g]);
      }
      if (pe.aborted)
        return { type: "aborted" };
      let Et = vd(Rt, Ce, l);
      if (Et)
        return { type: "success", matches: Et };
      let dt = dV(
        Rt,
        Ce,
        l,
        !0
      );
      if (!dt || Ke.length === dt.length && Ke.every(
        (xt, Ot) => xt.route.id === dt[Ot].route.id
      ))
        return { type: "success", matches: null };
      Ke = dt;
    }
  }
  function Oi(le) {
    r = {}, o = pw(
      le,
      n,
      void 0,
      r
    );
  }
  function Rn(le, Ce) {
    let pe = o == null;
    NT(
      le,
      Ce,
      o || g,
      r,
      n
    ), pe && (g = [...g], xe({}));
  }
  return y = {
    get basename() {
      return l;
    },
    get future() {
      return I;
    },
    get state() {
      return W;
    },
    get routes() {
      return g;
    },
    get window() {
      return t;
    },
    initialize: ue,
    subscribe: Ze,
    enableScrollRestoration: ri,
    navigate: st,
    fetch: Bt,
    revalidate: bt,
    // Passthrough to history-aware createHref used by useHref so we get proper
    // hash-aware URLs in DOM paths
    createHref: (le) => e.history.createHref(le),
    encodeLocation: (le) => e.history.encodeLocation(le),
    getFetcher: ci,
    deleteFetcher: Be,
    dispose: Xe,
    getBlocker: Tt,
    deleteBlocker: Ue,
    patchRoutes: Rn,
    _internalFetchControllers: N,
    // TODO: Remove setRoutes, it's temporary to avoid dealing with
    // updating the tree while validating the update algorithm.
    _internalSetRoutes: Oi
  }, y;
}
function fut(e) {
  return e != null && ("formData" in e && e.formData != null || "body" in e && e.body !== void 0);
}
function Mx(e, t, i, n, r, g) {
  let o, l;
  if (r) {
    o = [];
    for (let I of t)
      if (o.push(I), I.route.id === r) {
        l = I;
        break;
      }
  } else
    o = t, l = t[t.length - 1];
  let a = xv(
    n || ".",
    Fv(o),
    cl(e.pathname, i) || e.pathname,
    g === "path"
  );
  if (n == null && (a.search = e.search, a.hash = e.hash), (n == null || n === "" || n === ".") && l) {
    let I = a9(a.search);
    if (l.route.index && !I)
      a.search = a.search ? a.search.replace(/^\?/, "?index&") : "?index";
    else if (!l.route.index && I) {
      let c = new URLSearchParams(a.search), d = c.getAll("index");
      c.delete("index"), d.filter((A) => A).forEach((A) => c.append("index", A));
      let C = c.toString();
      a.search = C ? `?${C}` : "";
    }
  }
  return i !== "/" && (a.pathname = a.pathname === "/" ? i : fI([i, a.pathname])), nu(a);
}
function xT(e, t, i) {
  if (!i || !fut(i))
    return { path: t };
  if (i.formMethod && !Fut(i.formMethod))
    return {
      path: t,
      error: Za(405, { method: i.formMethod })
    };
  let n = () => ({
    path: t,
    error: Za(400, { type: "invalid-body" })
  }), g = (i.formMethod || "get").toUpperCase(), o = S8(t);
  if (i.body !== void 0) {
    if (i.formEncType === "text/plain") {
      if (!Ws(g))
        return n();
      let d = typeof i.body == "string" ? i.body : i.body instanceof FormData || i.body instanceof URLSearchParams ? (
        // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
        Array.from(i.body.entries()).reduce(
          (C, [A, b]) => `${C}${A}=${b}
`,
          ""
        )
      ) : String(i.body);
      return {
        path: t,
        submission: {
          formMethod: g,
          formAction: o,
          formEncType: i.formEncType,
          formData: void 0,
          json: void 0,
          text: d
        }
      };
    } else if (i.formEncType === "application/json") {
      if (!Ws(g))
        return n();
      try {
        let d = typeof i.body == "string" ? JSON.parse(i.body) : i.body;
        return {
          path: t,
          submission: {
            formMethod: g,
            formAction: o,
            formEncType: i.formEncType,
            formData: void 0,
            json: d,
            text: void 0
          }
        };
      } catch {
        return n();
      }
    }
  }
  xi(
    typeof FormData == "function",
    "FormData is not available in this environment"
  );
  let l, a;
  if (i.formData)
    l = Ux(i.formData), a = i.formData;
  else if (i.body instanceof FormData)
    l = Ux(i.body), a = i.body;
  else if (i.body instanceof URLSearchParams)
    l = i.body, a = PT(l);
  else if (i.body == null)
    l = new URLSearchParams(), a = new FormData();
  else
    try {
      l = new URLSearchParams(i.body), a = PT(l);
    } catch {
      return n();
    }
  let I = {
    formMethod: g,
    formAction: o,
    formEncType: i && i.formEncType || "application/x-www-form-urlencoded",
    formData: a,
    json: void 0,
    text: void 0
  };
  if (Ws(I.formMethod))
    return { path: t, submission: I };
  let c = YI(t);
  return e && c.search && a9(c.search) && l.append("index", ""), c.search = `?${l}`, { path: nu(c), submission: I };
}
function DT(e, t, i = !1) {
  let n = e.findIndex((r) => r.route.id === t);
  return n >= 0 ? e.slice(0, i ? n + 1 : n) : e;
}
function JT(e, t, i, n, r, g, o, l, a, I, c, d, C, A) {
  let b = A ? wl(A[1]) ? A[1].error : A[1].data : void 0, m = e.createURL(t.location), p = e.createURL(r), B = i;
  g && t.errors ? B = DT(
    i,
    Object.keys(t.errors)[0],
    !0
  ) : A && wl(A[1]) && (B = DT(
    i,
    A[0]
  ));
  let f = A ? A[1].statusCode : void 0, Z = f && f >= 400, y = B.filter((V, w) => {
    let { route: v } = V;
    if (v.lazy)
      return !0;
    if (v.loader == null)
      return !1;
    if (g)
      return Px(v, t.loaderData, t.errors);
    if (Zut(t.loaderData, t.matches[w], V))
      return !0;
    let H = t.matches[w], x = V;
    return ET(V, {
      currentUrl: m,
      currentParams: H.params,
      nextUrl: p,
      nextParams: x.params,
      ...n,
      actionResult: b,
      actionStatus: f,
      defaultShouldRevalidate: Z ? !1 : (
        // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        o || m.pathname + m.search === p.pathname + p.search || // Search params affect all loaders
        m.search !== p.search || Gut(H, x)
      )
    });
  }), W = [];
  return I.forEach((V, w) => {
    if (g || !i.some((K) => K.route.id === V.routeId) || a.has(w))
      return;
    let v = vd(d, V.path, C);
    if (!v) {
      W.push({
        key: w,
        routeId: V.routeId,
        path: V.path,
        matches: null,
        match: null,
        controller: null
      });
      return;
    }
    let H = t.fetchers.get(w), x = vB(v, V.path), J = !1;
    c.has(w) ? J = !1 : l.has(w) ? (l.delete(w), J = !0) : H && H.state !== "idle" && H.data === void 0 ? J = o : J = ET(x, {
      currentUrl: m,
      currentParams: t.matches[t.matches.length - 1].params,
      nextUrl: p,
      nextParams: i[i.length - 1].params,
      ...n,
      actionResult: b,
      actionStatus: f,
      defaultShouldRevalidate: Z ? !1 : o
    }), J && W.push({
      key: w,
      routeId: V.routeId,
      path: V.path,
      matches: v,
      match: x,
      controller: new AbortController()
    });
  }), [y, W];
}
function Px(e, t, i) {
  if (e.lazy)
    return !0;
  if (!e.loader)
    return !1;
  let n = t != null && t[e.id] !== void 0, r = i != null && i[e.id] !== void 0;
  return !n && r ? !1 : typeof e.loader == "function" && e.loader.hydrate === !0 ? !0 : !n && !r;
}
function Zut(e, t, i) {
  let n = (
    // [a] -> [a, b]
    !t || // [a, b] -> [a, c]
    i.route.id !== t.route.id
  ), r = !e.hasOwnProperty(i.route.id);
  return n || r;
}
function Gut(e, t) {
  let i = e.route.path;
  return (
    // param change for this match, /users/123 -> /users/456
    e.pathname !== t.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    i != null && i.endsWith("*") && e.params["*"] !== t.params["*"]
  );
}
function ET(e, t) {
  if (e.route.shouldRevalidate) {
    let i = e.route.shouldRevalidate(t);
    if (typeof i == "boolean")
      return i;
  }
  return t.defaultShouldRevalidate;
}
function NT(e, t, i, n, r) {
  let g;
  if (e) {
    let a = n[e];
    xi(
      a,
      `No route found to patch children into: routeId = ${e}`
    ), a.children || (a.children = []), g = a.children;
  } else
    g = i;
  let o = t.filter(
    (a) => !g.some(
      (I) => Z8(a, I)
    )
  ), l = pw(
    o,
    r,
    [e || "_", "patch", String((g == null ? void 0 : g.length) || "0")],
    n
  );
  g.push(...l);
}
function Z8(e, t) {
  return "id" in e && "id" in t && e.id === t.id ? !0 : e.index === t.index && e.path === t.path && e.caseSensitive === t.caseSensitive ? (!e.children || e.children.length === 0) && (!t.children || t.children.length === 0) ? !0 : e.children.every(
    (i, n) => {
      var r;
      return (r = t.children) == null ? void 0 : r.some((g) => Z8(i, g));
    }
  ) : !1;
}
var LT = /* @__PURE__ */ new WeakMap(), G8 = ({
  key: e,
  route: t,
  manifest: i,
  mapRouteProperties: n
}) => {
  let r = i[t.id];
  if (xi(r, "No route found in manifest"), !r.lazy || typeof r.lazy != "object")
    return;
  let g = r.lazy[e];
  if (!g)
    return;
  let o = LT.get(r);
  o || (o = {}, LT.set(r, o));
  let l = o[e];
  if (l)
    return l;
  let a = (async () => {
    let I = Udt(e), d = r[e] !== void 0 && e !== "hasErrorBoundary";
    if (I)
      mr(
        !I,
        "Route property " + e + " is not a supported lazy route property. This property will be ignored."
      ), o[e] = Promise.resolve();
    else if (d)
      mr(
        !1,
        `Route "${r.id}" has a static property "${e}" defined. The lazy property will be ignored.`
      );
    else {
      let C = await g();
      C != null && (Object.assign(r, { [e]: C }), Object.assign(r, n(r)));
    }
    typeof r.lazy == "object" && (r.lazy[e] = void 0, Object.values(r.lazy).every((C) => C === void 0) && (r.lazy = void 0));
  })();
  return o[e] = a, a;
}, KT = /* @__PURE__ */ new WeakMap();
function yut(e, t, i, n) {
  let r = i[e.id];
  if (xi(r, "No route found in manifest"), !e.lazy)
    return {
      lazyRoutePromise: void 0,
      lazyHandlerPromise: void 0
    };
  if (typeof e.lazy == "function") {
    let I = KT.get(r);
    if (I)
      return {
        lazyRoutePromise: I,
        lazyHandlerPromise: I
      };
    let c = (async () => {
      xi(
        typeof e.lazy == "function",
        "No lazy route function found"
      );
      let d = await e.lazy(), C = {};
      for (let A in d) {
        let b = d[A];
        if (b === void 0)
          continue;
        let m = Odt(A), B = r[A] !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        A !== "hasErrorBoundary";
        m ? mr(
          !m,
          "Route property " + A + " is not a supported property to be returned from a lazy route function. This property will be ignored."
        ) : B ? mr(
          !B,
          `Route "${r.id}" has a static property "${A}" defined but its lazy function is also returning a value for this property. The lazy route property "${A}" will be ignored.`
        ) : C[A] = b;
      }
      Object.assign(r, C), Object.assign(r, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...n(r),
        lazy: void 0
      });
    })();
    return KT.set(r, c), {
      lazyRoutePromise: c,
      lazyHandlerPromise: c
    };
  }
  let g = Object.keys(e.lazy), o = [], l;
  for (let I of g) {
    let c = G8({
      key: I,
      route: e,
      manifest: i,
      mapRouteProperties: n
    });
    c && (o.push(c), I === t && (l = c));
  }
  return {
    lazyRoutePromise: Promise.all(o).then(() => {
    }),
    lazyHandlerPromise: l
  };
}
function y8(e) {
  return e !== void 0;
}
function Wut(e, t, i) {
  let n = e.map(({ route: r }) => {
    if (!(typeof r.lazy != "object" || !r.lazy.unstable_middleware))
      return G8({
        key: "unstable_middleware",
        route: r,
        manifest: t,
        mapRouteProperties: i
      });
  }).filter(y8);
  return n.length > 0 ? Promise.all(n) : void 0;
}
async function TT(e) {
  let t = e.matches.filter((r) => r.shouldLoad), i = {};
  return (await Promise.all(t.map((r) => r.resolve()))).forEach((r, g) => {
    i[t[g].route.id] = r;
  }), i;
}
async function Sut(e) {
  return e.matches.some((t) => t.route.unstable_middleware) ? Vut(
    e,
    !1,
    () => TT(e),
    (t, i) => ({ [i]: { type: "error", result: t } })
  ) : TT(e);
}
async function Vut(e, t, i, n) {
  let { matches: r, request: g, params: o, context: l } = e, a = {
    handlerResult: void 0
  };
  try {
    let I = r.flatMap(
      (d) => d.route.unstable_middleware ? d.route.unstable_middleware.map((C) => [d.route.id, C]) : []
    ), c = await W8(
      { request: g, params: o, context: l },
      I,
      t,
      a,
      i
    );
    return t ? c : a.handlerResult;
  } catch (I) {
    if (!a.middlewareError)
      throw I;
    let c = await n(
      a.middlewareError.error,
      a.middlewareError.routeId
    );
    return a.handlerResult ? Object.assign(a.handlerResult, c) : c;
  }
}
async function W8(e, t, i, n, r, g = 0) {
  let { request: o } = e;
  if (o.signal.aborted)
    throw o.signal.reason ? o.signal.reason : new Error(
      `Request aborted without an \`AbortSignal.reason\`: ${o.method} ${o.url}`
    );
  let l = t[g];
  if (!l)
    return n.handlerResult = await r(), n.handlerResult;
  let [a, I] = l, c = !1, d, C = async () => {
    if (c)
      throw new Error("You may only call `next()` once per middleware");
    c = !0, await W8(
      e,
      t,
      i,
      n,
      r,
      g + 1
    );
  };
  try {
    let A = await I(
      {
        request: e.request,
        params: e.params,
        context: e.context
      },
      C
    );
    return c ? A === void 0 ? d : A : C();
  } catch (A) {
    throw n.middlewareError ? n.middlewareError.error !== A && (n.middlewareError = { routeId: a, error: A }) : n.middlewareError = { routeId: a, error: A }, A;
  }
}
async function wut(e, t, i, n, r, g, o, l, a) {
  let I = Wut(
    r,
    o,
    l
  ), c = r.map(
    (b) => yut(b.route, t, o, l)
  );
  I && await I;
  let d = r.map((b, m) => {
    let { lazyRoutePromise: p, lazyHandlerPromise: B } = c[m], f = n.some((y) => y.route.id === b.route.id);
    return {
      ...b,
      shouldLoad: f,
      resolve: async (y) => (y && i.method === "GET" && (b.route.lazy || b.route.loader) && (f = !0), f ? vut({
        type: t,
        request: i,
        match: b,
        lazyHandlerPromise: B,
        lazyRoutePromise: p,
        handlerOverride: y,
        scopedContext: a
      }) : Promise.resolve({ type: "data", result: void 0 }))
    };
  }), C = await e({
    matches: d,
    request: i,
    params: r[0].params,
    fetcherKey: g,
    context: a
  }), A = c.flatMap(
    (b) => Object.values(b).filter(y8)
  );
  try {
    await Promise.all(A);
  } catch {
  }
  return C;
}
async function vut({
  type: e,
  request: t,
  match: i,
  lazyHandlerPromise: n,
  lazyRoutePromise: r,
  handlerOverride: g,
  scopedContext: o
}) {
  let l, a, I = (c) => {
    let d, C = new Promise((m, p) => d = p);
    a = () => d(), t.signal.addEventListener("abort", a);
    let A = (m) => typeof c != "function" ? Promise.reject(
      new Error(
        `You cannot call the handler for a route which defines a boolean "${e}" [routeId: ${i.route.id}]`
      )
    ) : c(
      {
        request: t,
        params: i.params,
        context: o
      },
      ...m !== void 0 ? [m] : []
    ), b = (async () => {
      try {
        return { type: "data", result: await (g ? g((p) => A(p)) : A()) };
      } catch (m) {
        return { type: "error", result: m };
      }
    })();
    return Promise.race([b, C]);
  };
  try {
    let c = i.route[e];
    if (n || r)
      if (c) {
        let d, [C] = await Promise.all([
          // If the handler throws, don't let it immediately bubble out,
          // since we need to let the lazy() execution finish so we know if this
          // route has a boundary that can handle the error
          I(c).catch((A) => {
            d = A;
          }),
          // Ensure all lazy route promises are resolved before continuing
          n,
          r
        ]);
        if (d !== void 0)
          throw d;
        l = C;
      } else if (await n, c = i.route[e], c)
        [l] = await Promise.all([I(c), r]);
      else if (e === "action") {
        let d = new URL(t.url), C = d.pathname + d.search;
        throw Za(405, {
          method: t.method,
          pathname: C,
          routeId: i.route.id
        });
      } else
        return { type: "data", result: void 0 };
    else if (c)
      l = await I(c);
    else {
      let d = new URL(t.url), C = d.pathname + d.search;
      throw Za(404, {
        pathname: C
      });
    }
  } catch (c) {
    return { type: "error", result: c };
  } finally {
    a && t.signal.removeEventListener("abort", a);
  }
  return l;
}
async function Rut(e) {
  var n, r, g, o, l, a;
  let { result: t, type: i } = e;
  if (V8(t)) {
    let I;
    try {
      let c = t.headers.get("Content-Type");
      c && /\bapplication\/json\b/.test(c) ? t.body == null ? I = null : I = await t.json() : I = await t.text();
    } catch (c) {
      return { type: "error", error: c };
    }
    return i === "error" ? {
      type: "error",
      error: new Bw(t.status, t.statusText, I),
      statusCode: t.status,
      headers: t.headers
    } : {
      type: "data",
      data: I,
      statusCode: t.status,
      headers: t.headers
    };
  }
  return i === "error" ? jT(t) ? t.data instanceof Error ? {
    type: "error",
    error: t.data,
    statusCode: (n = t.init) == null ? void 0 : n.status,
    headers: (r = t.init) != null && r.headers ? new Headers(t.init.headers) : void 0
  } : {
    type: "error",
    error: new Bw(
      ((g = t.init) == null ? void 0 : g.status) || 500,
      void 0,
      t.data
    ),
    statusCode: Lf(t) ? t.status : void 0,
    headers: (o = t.init) != null && o.headers ? new Headers(t.init.headers) : void 0
  } : {
    type: "error",
    error: t,
    statusCode: Lf(t) ? t.status : void 0
  } : jT(t) ? {
    type: "data",
    data: t.data,
    statusCode: (l = t.init) == null ? void 0 : l.status,
    headers: (a = t.init) != null && a.headers ? new Headers(t.init.headers) : void 0
  } : { type: "data", data: t };
}
function Xut(e, t, i, n, r) {
  let g = e.headers.get("Location");
  if (xi(
    g,
    "Redirects returned/thrown from loaders/actions must have a Location header"
  ), !l9.test(g)) {
    let o = n.slice(
      0,
      n.findIndex((l) => l.route.id === i) + 1
    );
    g = Mx(
      new URL(t.url),
      o,
      r,
      g
    ), e.headers.set("Location", g);
  }
  return e;
}
function MT(e, t, i) {
  if (l9.test(e)) {
    let n = e, r = n.startsWith("//") ? new URL(t.protocol + n) : new URL(n), g = cl(r.pathname, i) != null;
    if (r.origin === t.origin && g)
      return r.pathname + r.search + r.hash;
  }
  return e;
}
function ah(e, t, i, n) {
  let r = e.createURL(S8(t)).toString(), g = { signal: i };
  if (n && Ws(n.formMethod)) {
    let { formMethod: o, formEncType: l } = n;
    g.method = o.toUpperCase(), l === "application/json" ? (g.headers = new Headers({ "Content-Type": l }), g.body = JSON.stringify(n.json)) : l === "text/plain" ? g.body = n.text : l === "application/x-www-form-urlencoded" && n.formData ? g.body = Ux(n.formData) : g.body = n.formData;
  }
  return new Request(r, g);
}
function Ux(e) {
  let t = new URLSearchParams();
  for (let [i, n] of e.entries())
    t.append(i, typeof n == "string" ? n : n.name);
  return t;
}
function PT(e) {
  let t = new FormData();
  for (let [i, n] of e.entries())
    t.append(i, n);
  return t;
}
function Hut(e, t, i, n = !1, r = !1) {
  let g = {}, o = null, l, a = !1, I = {}, c = i && wl(i[1]) ? i[1].error : void 0;
  return e.forEach((d) => {
    if (!(d.route.id in t))
      return;
    let C = d.route.id, A = t[C];
    if (xi(
      !NC(A),
      "Cannot handle redirect results in processLoaderData"
    ), wl(A)) {
      let b = A.error;
      if (c !== void 0 && (b = c, c = void 0), o = o || {}, r)
        o[C] = b;
      else {
        let m = XC(e, C);
        o[m.route.id] == null && (o[m.route.id] = b);
      }
      n || (g[C] = f8), a || (a = !0, l = Lf(A.error) ? A.error.status : 500), A.headers && (I[C] = A.headers);
    } else
      g[C] = A.data, A.statusCode && A.statusCode !== 200 && !a && (l = A.statusCode), A.headers && (I[C] = A.headers);
  }), c !== void 0 && i && (o = { [i[0]]: c }, g[i[0]] = void 0), {
    loaderData: g,
    errors: o,
    statusCode: l || 200,
    loaderHeaders: I
  };
}
function UT(e, t, i, n, r, g) {
  let { loaderData: o, errors: l } = Hut(
    t,
    i,
    n
  );
  return r.forEach((a) => {
    let { key: I, match: c, controller: d } = a, C = g[I];
    if (xi(C, "Did not find corresponding fetcher result"), !(d && d.signal.aborted))
      if (wl(C)) {
        let A = XC(e.matches, c == null ? void 0 : c.route.id);
        l && l[A.route.id] || (l = {
          ...l,
          [A.route.id]: C.error
        }), e.fetchers.delete(I);
      } else if (NC(C))
        xi(!1, "Unhandled fetcher revalidation redirect");
      else {
        let A = Bd(C.data);
        e.fetchers.set(I, A);
      }
  }), { loaderData: o, errors: l };
}
function zT(e, t, i, n) {
  let r = Object.entries(t).filter(([, g]) => g !== f8).reduce((g, [o, l]) => (g[o] = l, g), {});
  for (let g of i) {
    let o = g.route.id;
    if (!t.hasOwnProperty(o) && e.hasOwnProperty(o) && g.route.loader && (r[o] = e[o]), n && n.hasOwnProperty(o))
      break;
  }
  return r;
}
function OT(e) {
  return e ? wl(e[1]) ? {
    // Clear out prior actionData on errors
    actionData: {}
  } : {
    actionData: {
      [e[0]]: e[1].data
    }
  } : {};
}
function XC(e, t) {
  return (t ? e.slice(0, e.findIndex((n) => n.route.id === t) + 1) : [...e]).reverse().find((n) => n.route.hasErrorBoundary === !0) || e[0];
}
function QT(e) {
  let t = e.length === 1 ? e[0] : e.find((i) => i.index || !i.path || i.path === "/") || {
    id: "__shim-error-route__"
  };
  return {
    matches: [
      {
        params: {},
        pathname: "",
        pathnameBase: "",
        route: t
      }
    ],
    route: t
  };
}
function Za(e, {
  pathname: t,
  routeId: i,
  method: n,
  type: r,
  message: g
} = {}) {
  let o = "Unknown Server Error", l = "Unknown @remix-run/router error";
  return e === 400 ? (o = "Bad Request", n && t && i ? l = `You made a ${n} request to "${t}" but did not provide a \`loader\` for route "${i}", so there is no way to handle the request.` : r === "invalid-body" && (l = "Unable to encode submission body")) : e === 403 ? (o = "Forbidden", l = `Route "${i}" does not match URL "${t}"`) : e === 404 ? (o = "Not Found", l = `No route matches URL "${t}"`) : e === 405 && (o = "Method Not Allowed", n && t && i ? l = `You made a ${n.toUpperCase()} request to "${t}" but did not provide an \`action\` for route "${i}", so there is no way to handle the request.` : n && (l = `Invalid request method "${n.toUpperCase()}"`)), new Bw(
    e || 500,
    o,
    new Error(l),
    !0
  );
}
function $W(e) {
  let t = Object.entries(e);
  for (let i = t.length - 1; i >= 0; i--) {
    let [n, r] = t[i];
    if (NC(r))
      return { key: n, result: r };
  }
}
function S8(e) {
  let t = typeof e == "string" ? YI(e) : e;
  return nu({ ...t, hash: "" });
}
function kut(e, t) {
  return e.pathname !== t.pathname || e.search !== t.search ? !1 : e.hash === "" ? t.hash !== "" : e.hash === t.hash ? !0 : t.hash !== "";
}
function Yut(e) {
  return V8(e.result) && but.has(e.result.status);
}
function wl(e) {
  return e.type === "error";
}
function NC(e) {
  return (e && e.type) === "redirect";
}
function jT(e) {
  return typeof e == "object" && e != null && "type" in e && "data" in e && "init" in e && e.type === "DataWithResponseInit";
}
function V8(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.headers == "object" && typeof e.body < "u";
}
function Fut(e) {
  return Aut.has(e.toUpperCase());
}
function Ws(e) {
  return uut.has(e.toUpperCase());
}
function a9(e) {
  return new URLSearchParams(e).getAll("index").some((t) => t === "");
}
function vB(e, t) {
  let i = typeof t == "string" ? YI(t).search : t.search;
  if (e[e.length - 1].route.index && a9(i || ""))
    return e[e.length - 1];
  let n = m8(e);
  return n[n.length - 1];
}
function qT(e) {
  let { formMethod: t, formAction: i, formEncType: n, text: r, formData: g, json: o } = e;
  if (!(!t || !i || !n)) {
    if (r != null)
      return {
        formMethod: t,
        formAction: i,
        formEncType: n,
        formData: void 0,
        json: void 0,
        text: r
      };
    if (g != null)
      return {
        formMethod: t,
        formAction: i,
        formEncType: n,
        formData: g,
        json: void 0,
        text: void 0
      };
    if (o !== void 0)
      return {
        formMethod: t,
        formAction: i,
        formEncType: n,
        formData: void 0,
        json: o,
        text: void 0
      };
  }
}
function RY(e, t) {
  return t ? {
    state: "loading",
    location: e,
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text
  } : {
    state: "loading",
    location: e,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
  };
}
function xut(e, t) {
  return {
    state: "submitting",
    location: e,
    formMethod: t.formMethod,
    formAction: t.formAction,
    formEncType: t.formEncType,
    formData: t.formData,
    json: t.json,
    text: t.text
  };
}
function eB(e, t) {
  return e ? {
    state: "loading",
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text,
    data: t
  } : {
    state: "loading",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: t
  };
}
function Dut(e, t) {
  return {
    state: "submitting",
    formMethod: e.formMethod,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formData: e.formData,
    json: e.json,
    text: e.text,
    data: t ? t.data : void 0
  };
}
function Bd(e) {
  return {
    state: "idle",
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0,
    data: e
  };
}
function Jut(e, t) {
  try {
    let i = e.sessionStorage.getItem(
      B8
    );
    if (i) {
      let n = JSON.parse(i);
      for (let [r, g] of Object.entries(n || {}))
        g && Array.isArray(g) && t.set(r, new Set(g || []));
    }
  } catch {
  }
}
function Eut(e, t) {
  if (t.size > 0) {
    let i = {};
    for (let [n, r] of t)
      i[n] = [...r];
    try {
      e.sessionStorage.setItem(
        B8,
        JSON.stringify(i)
      );
    } catch (n) {
      mr(
        !1,
        `Failed to save applied view transitions in sessionStorage (${n}).`
      );
    }
  }
}
function Nut() {
  let e, t, i = new Promise((n, r) => {
    e = async (g) => {
      n(g);
      try {
        await i;
      } catch {
      }
    }, t = async (g) => {
      r(g);
      try {
        await i;
      } catch {
      }
    };
  });
  return {
    promise: i,
    //@ts-ignore
    resolve: e,
    //@ts-ignore
    reject: t
  };
}
var BA = X.createContext(null);
BA.displayName = "DataRouter";
var YZ = X.createContext(null);
YZ.displayName = "DataRouterState";
var s9 = X.createContext({
  isTransitioning: !1
});
s9.displayName = "ViewTransition";
var w8 = X.createContext(
  /* @__PURE__ */ new Map()
);
w8.displayName = "Fetchers";
var Lut = X.createContext(null);
Lut.displayName = "Await";
var Ls = X.createContext(
  null
);
Ls.displayName = "Navigation";
var FZ = X.createContext(
  null
);
FZ.displayName = "Location";
var _a = X.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
_a.displayName = "Route";
var I9 = X.createContext(null);
I9.displayName = "RouteError";
function Kut(e, { relative: t } = {}) {
  xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: i, navigator: n } = X.useContext(Ls), { hash: r, pathname: g, search: o } = xZ(e, { relative: t }), l = g;
  return i !== "/" && (l = g === "/" ? i : fI([i, g])), n.createHref({ pathname: l, search: o, hash: r });
}
function fA() {
  return X.useContext(FZ) != null;
}
function FI() {
  return xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), X.useContext(FZ).location;
}
function Kqt(e) {
  xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component."
  );
  let { pathname: t } = FI();
  return X.useMemo(
    () => Nf(e, h8(t)),
    [t, e]
  );
}
var v8 = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function R8(e) {
  X.useContext(Ls).static || X.useLayoutEffect(e);
}
function ZA() {
  let { isDataRoute: e } = X.useContext(_a);
  return e ? nCt() : Tut();
}
function Tut() {
  xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = X.useContext(BA), { basename: t, navigator: i } = X.useContext(Ls), { matches: n } = X.useContext(_a), { pathname: r } = FI(), g = JSON.stringify(Fv(n)), o = X.useRef(!1);
  return R8(() => {
    o.current = !0;
  }), X.useCallback(
    (a, I = {}) => {
      if (mr(o.current, v8), !o.current)
        return;
      if (typeof a == "number") {
        i.go(a);
        return;
      }
      let c = xv(
        a,
        JSON.parse(g),
        r,
        I.relative === "path"
      );
      e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : fI([t, c.pathname])), (I.replace ? i.replace : i.push)(
        c,
        I.state,
        I
      );
    },
    [
      t,
      i,
      g,
      r,
      e
    ]
  );
}
var Mut = X.createContext(null);
function Put(e) {
  let t = X.useContext(_a).outlet;
  return t && /* @__PURE__ */ X.createElement(Mut.Provider, { value: e }, t);
}
function Uut() {
  let { matches: e } = X.useContext(_a), t = e[e.length - 1];
  return t ? t.params : {};
}
function xZ(e, { relative: t } = {}) {
  let { matches: i } = X.useContext(_a), { pathname: n } = FI(), r = JSON.stringify(Fv(i));
  return X.useMemo(
    () => xv(
      e,
      JSON.parse(r),
      n,
      t === "path"
    ),
    [e, r, n, t]
  );
}
function zut(e, t) {
  return X8(e, t);
}
function X8(e, t, i, n) {
  var f;
  xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: r, static: g } = X.useContext(Ls), { matches: o } = X.useContext(_a), l = o[o.length - 1], a = l ? l.params : {}, I = l ? l.pathname : "/", c = l ? l.pathnameBase : "/", d = l && l.route;
  {
    let Z = d && d.path || "";
    Y8(
      I,
      !d || Z.endsWith("*") || Z.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${I}" (under <Route path="${Z}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${Z}"> to <Route path="${Z === "/" ? "*" : `${Z}/*`}">.`
    );
  }
  let C = FI(), A;
  if (t) {
    let Z = typeof t == "string" ? YI(t) : t;
    xi(
      c === "/" || ((f = Z.pathname) == null ? void 0 : f.startsWith(c)),
      `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${c}" but pathname "${Z.pathname}" was given in the \`location\` prop.`
    ), A = Z;
  } else
    A = C;
  let b = A.pathname || "/", m = b;
  if (c !== "/") {
    let Z = c.replace(/^\//, "").split("/");
    m = "/" + b.replace(/^\//, "").split("/").slice(Z.length).join("/");
  }
  let p = !g && i && i.matches && i.matches.length > 0 ? i.matches : vd(e, { pathname: m });
  mr(
    d || p != null,
    `No routes matched location "${A.pathname}${A.search}${A.hash}" `
  ), mr(
    p == null || p[p.length - 1].route.element !== void 0 || p[p.length - 1].route.Component !== void 0 || p[p.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${A.pathname}${A.search}${A.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  );
  let B = _ut(
    p && p.map(
      (Z) => Object.assign({}, Z, {
        params: Object.assign({}, a, Z.params),
        pathname: fI([
          c,
          // Re-encode pathnames that were decoded inside matchRoutes
          r.encodeLocation ? r.encodeLocation(Z.pathname).pathname : Z.pathname
        ]),
        pathnameBase: Z.pathnameBase === "/" ? c : fI([
          c,
          // Re-encode pathnames that were decoded inside matchRoutes
          r.encodeLocation ? r.encodeLocation(Z.pathnameBase).pathname : Z.pathnameBase
        ])
      })
    ),
    o,
    i,
    n
  );
  return t && B ? /* @__PURE__ */ X.createElement(
    FZ.Provider,
    {
      value: {
        location: {
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "default",
          ...A
        },
        navigationType: "POP"
        /* Pop */
      }
    },
    B
  ) : B;
}
function Out() {
  let e = tCt(), t = Lf(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), i = e instanceof Error ? e.stack : null, n = "rgba(200,200,200, 0.5)", r = { padding: "0.5rem", backgroundColor: n }, g = { padding: "2px 4px", backgroundColor: n }, o = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), o = /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ X.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ X.createElement("code", { style: g }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ X.createElement("code", { style: g }, "errorElement"), " prop on your route.")), /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ X.createElement("h3", { style: { fontStyle: "italic" } }, t), i ? /* @__PURE__ */ X.createElement("pre", { style: r }, i) : null, o);
}
var Qut = /* @__PURE__ */ X.createElement(Out, null), jut = class extends X.Component {
  constructor(e) {
    super(e), this.state = {
      location: e.location,
      revalidation: e.revalidation,
      error: e.error
    };
  }
  static getDerivedStateFromError(e) {
    return { error: e };
  }
  static getDerivedStateFromProps(e, t) {
    return t.location !== e.location || t.revalidation !== "idle" && e.revalidation === "idle" ? {
      error: e.error,
      location: e.location,
      revalidation: e.revalidation
    } : {
      error: e.error !== void 0 ? e.error : t.error,
      location: t.location,
      revalidation: e.revalidation || t.revalidation
    };
  }
  componentDidCatch(e, t) {
    console.error(
      "React Router caught the following error during render",
      e,
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ X.createElement(_a.Provider, { value: this.props.routeContext }, /* @__PURE__ */ X.createElement(
      I9.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function qut({ routeContext: e, match: t, children: i }) {
  let n = X.useContext(BA);
  return n && n.static && n.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (n.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ X.createElement(_a.Provider, { value: e }, i);
}
function _ut(e, t = [], i = null, n = null) {
  if (e == null) {
    if (!i)
      return null;
    if (i.errors)
      e = i.matches;
    else if (t.length === 0 && !i.initialized && i.matches.length > 0)
      e = i.matches;
    else
      return null;
  }
  let r = e, g = i == null ? void 0 : i.errors;
  if (g != null) {
    let a = r.findIndex(
      (I) => I.route.id && (g == null ? void 0 : g[I.route.id]) !== void 0
    );
    xi(
      a >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        g
      ).join(",")}`
    ), r = r.slice(
      0,
      Math.min(r.length, a + 1)
    );
  }
  let o = !1, l = -1;
  if (i)
    for (let a = 0; a < r.length; a++) {
      let I = r[a];
      if ((I.route.HydrateFallback || I.route.hydrateFallbackElement) && (l = a), I.route.id) {
        let { loaderData: c, errors: d } = i, C = I.route.loader && !c.hasOwnProperty(I.route.id) && (!d || d[I.route.id] === void 0);
        if (I.route.lazy || C) {
          o = !0, l >= 0 ? r = r.slice(0, l + 1) : r = [r[0]];
          break;
        }
      }
    }
  return r.reduceRight((a, I, c) => {
    let d, C = !1, A = null, b = null;
    i && (d = g && I.route.id ? g[I.route.id] : void 0, A = I.route.errorElement || Qut, o && (l < 0 && c === 0 ? (Y8(
      "route-fallback",
      !1,
      "No `HydrateFallback` element provided to render during initial hydration"
    ), C = !0, b = null) : l === c && (C = !0, b = I.route.hydrateFallbackElement || null)));
    let m = t.concat(r.slice(0, c + 1)), p = () => {
      let B;
      return d ? B = A : C ? B = b : I.route.Component ? B = /* @__PURE__ */ X.createElement(I.route.Component, null) : I.route.element ? B = I.route.element : B = a, /* @__PURE__ */ X.createElement(
        qut,
        {
          match: I,
          routeContext: {
            outlet: a,
            matches: m,
            isDataRoute: i != null
          },
          children: B
        }
      );
    };
    return i && (I.route.ErrorBoundary || I.route.errorElement || c === 0) ? /* @__PURE__ */ X.createElement(
      jut,
      {
        location: i.location,
        revalidation: i.revalidation,
        component: A,
        error: d,
        children: p(),
        routeContext: { outlet: null, matches: m, isDataRoute: !0 }
      }
    ) : p();
  }, null);
}
function c9(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function H8(e) {
  let t = X.useContext(BA);
  return xi(t, c9(e)), t;
}
function k8(e) {
  let t = X.useContext(YZ);
  return xi(t, c9(e)), t;
}
function $ut(e) {
  let t = X.useContext(_a);
  return xi(t, c9(e)), t;
}
function d9(e) {
  let t = $ut(e), i = t.matches[t.matches.length - 1];
  return xi(
    i.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), i.route.id;
}
function eCt() {
  return d9(
    "useRouteId"
    /* UseRouteId */
  );
}
function tCt() {
  var n;
  let e = X.useContext(I9), t = k8(
    "useRouteError"
    /* UseRouteError */
  ), i = d9(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : (n = t.errors) == null ? void 0 : n[i];
}
var iCt = 0;
function Tqt(e) {
  let { router: t, basename: i } = H8(
    "useBlocker"
    /* UseBlocker */
  ), n = k8(
    "useBlocker"
    /* UseBlocker */
  ), [r, g] = X.useState(""), o = X.useCallback(
    (l) => {
      if (typeof e != "function")
        return !!e;
      if (i === "/")
        return e(l);
      let { currentLocation: a, nextLocation: I, historyAction: c } = l;
      return e({
        currentLocation: {
          ...a,
          pathname: cl(a.pathname, i) || a.pathname
        },
        nextLocation: {
          ...I,
          pathname: cl(I.pathname, i) || I.pathname
        },
        historyAction: c
      });
    },
    [i, e]
  );
  return X.useEffect(() => {
    let l = String(++iCt);
    return g(l), () => t.deleteBlocker(l);
  }, [t]), X.useEffect(() => {
    r !== "" && t.getBlocker(r, o);
  }, [t, r, o]), r && n.blockers.has(r) ? n.blockers.get(r) : Xh;
}
function nCt() {
  let { router: e } = H8(
    "useNavigate"
    /* UseNavigateStable */
  ), t = d9(
    "useNavigate"
    /* UseNavigateStable */
  ), i = X.useRef(!1);
  return R8(() => {
    i.current = !0;
  }), X.useCallback(
    async (r, g = {}) => {
      mr(i.current, v8), i.current && (typeof r == "number" ? e.navigate(r) : await e.navigate(r, { fromRouteId: t, ...g }));
    },
    [e, t]
  );
}
var _T = {};
function Y8(e, t, i) {
  !t && !_T[e] && (_T[e] = !0, mr(!1, i));
}
var $T = {};
function eM(e, t) {
  !e && !$T[t] && ($T[t] = !0, console.warn(t));
}
function rCt(e) {
  let t = {
    // Note: this check also occurs in createRoutesFromChildren so update
    // there if you change this -- please and thank you!
    hasErrorBoundary: e.hasErrorBoundary || e.ErrorBoundary != null || e.errorElement != null
  };
  return e.Component && (e.element && mr(
    !1,
    "You should not include both `Component` and `element` on your route - `Component` will be used."
  ), Object.assign(t, {
    element: X.createElement(e.Component),
    Component: void 0
  })), e.HydrateFallback && (e.hydrateFallbackElement && mr(
    !1,
    "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used."
  ), Object.assign(t, {
    hydrateFallbackElement: X.createElement(e.HydrateFallback),
    HydrateFallback: void 0
  })), e.ErrorBoundary && (e.errorElement && mr(
    !1,
    "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used."
  ), Object.assign(t, {
    errorElement: X.createElement(e.ErrorBoundary),
    ErrorBoundary: void 0
  })), t;
}
var gCt = class {
  constructor() {
    this.status = "pending", this.promise = new Promise((e, t) => {
      this.resolve = (i) => {
        this.status === "pending" && (this.status = "resolved", e(i));
      }, this.reject = (i) => {
        this.status === "pending" && (this.status = "rejected", t(i));
      };
    });
  }
};
function oCt({
  router: e,
  flushSync: t
}) {
  let [i, n] = X.useState(e.state), [r, g] = X.useState(), [o, l] = X.useState({
    isTransitioning: !1
  }), [a, I] = X.useState(), [c, d] = X.useState(), [C, A] = X.useState(), b = X.useRef(/* @__PURE__ */ new Map()), m = X.useCallback(
    (Z, { deletedFetchers: y, flushSync: W, viewTransitionOpts: V }) => {
      Z.fetchers.forEach((v, H) => {
        v.data !== void 0 && b.current.set(H, v.data);
      }), y.forEach((v) => b.current.delete(v)), eM(
        W === !1 || t != null,
        'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.'
      );
      let w = e.window != null && e.window.document != null && typeof e.window.document.startViewTransition == "function";
      if (eM(
        V == null || w,
        "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available."
      ), !V || !w) {
        t && W ? t(() => n(Z)) : X.startTransition(() => n(Z));
        return;
      }
      if (t && W) {
        t(() => {
          c && (a && a.resolve(), c.skipTransition()), l({
            isTransitioning: !0,
            flushSync: !0,
            currentLocation: V.currentLocation,
            nextLocation: V.nextLocation
          });
        });
        let v = e.window.document.startViewTransition(() => {
          t(() => n(Z));
        });
        v.finished.finally(() => {
          t(() => {
            I(void 0), d(void 0), g(void 0), l({ isTransitioning: !1 });
          });
        }), t(() => d(v));
        return;
      }
      c ? (a && a.resolve(), c.skipTransition(), A({
        state: Z,
        currentLocation: V.currentLocation,
        nextLocation: V.nextLocation
      })) : (g(Z), l({
        isTransitioning: !0,
        flushSync: !1,
        currentLocation: V.currentLocation,
        nextLocation: V.nextLocation
      }));
    },
    [e.window, t, c, a]
  );
  X.useLayoutEffect(() => e.subscribe(m), [e, m]), X.useEffect(() => {
    o.isTransitioning && !o.flushSync && I(new gCt());
  }, [o]), X.useEffect(() => {
    if (a && r && e.window) {
      let Z = r, y = a.promise, W = e.window.document.startViewTransition(async () => {
        X.startTransition(() => n(Z)), await y;
      });
      W.finished.finally(() => {
        I(void 0), d(void 0), g(void 0), l({ isTransitioning: !1 });
      }), d(W);
    }
  }, [r, a, e.window]), X.useEffect(() => {
    a && r && i.location.key === r.location.key && a.resolve();
  }, [a, c, i.location, r]), X.useEffect(() => {
    !o.isTransitioning && C && (g(C.state), l({
      isTransitioning: !0,
      flushSync: !1,
      currentLocation: C.currentLocation,
      nextLocation: C.nextLocation
    }), A(void 0));
  }, [o.isTransitioning, C]);
  let p = X.useMemo(() => ({
    createHref: e.createHref,
    encodeLocation: e.encodeLocation,
    go: (Z) => e.navigate(Z),
    push: (Z, y, W) => e.navigate(Z, {
      state: y,
      preventScrollReset: W == null ? void 0 : W.preventScrollReset
    }),
    replace: (Z, y, W) => e.navigate(Z, {
      replace: !0,
      state: y,
      preventScrollReset: W == null ? void 0 : W.preventScrollReset
    })
  }), [e]), B = e.basename || "/", f = X.useMemo(
    () => ({
      router: e,
      navigator: p,
      static: !1,
      basename: B
    }),
    [e, p, B]
  );
  return /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(BA.Provider, { value: f }, /* @__PURE__ */ X.createElement(YZ.Provider, { value: i }, /* @__PURE__ */ X.createElement(w8.Provider, { value: b.current }, /* @__PURE__ */ X.createElement(s9.Provider, { value: o }, /* @__PURE__ */ X.createElement(
    ICt,
    {
      basename: B,
      location: i.location,
      navigationType: i.historyAction,
      navigator: p
    },
    /* @__PURE__ */ X.createElement(
      lCt,
      {
        routes: e.routes,
        future: e.future,
        state: i
      }
    )
  ))))), null);
}
var lCt = X.memo(aCt);
function aCt({
  routes: e,
  future: t,
  state: i
}) {
  return X8(e, void 0, i, t);
}
function Mqt({
  to: e,
  replace: t,
  state: i,
  relative: n
}) {
  xi(
    fA(),
    // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component."
  );
  let { static: r } = X.useContext(Ls);
  mr(
    !r,
    "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change."
  );
  let { matches: g } = X.useContext(_a), { pathname: o } = FI(), l = ZA(), a = xv(
    e,
    Fv(g),
    o,
    n === "path"
  ), I = JSON.stringify(a);
  return X.useEffect(() => {
    l(JSON.parse(I), { replace: t, state: i, relative: n });
  }, [l, I, n, t, i]), null;
}
function Pqt(e) {
  return Put(e.context);
}
function sCt(e) {
  xi(
    !1,
    "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>."
  );
}
function ICt({
  basename: e = "/",
  children: t = null,
  location: i,
  navigationType: n = "POP",
  navigator: r,
  static: g = !1
}) {
  xi(
    !fA(),
    "You cannot render a <Router> inside another <Router>. You should never have more than one in your app."
  );
  let o = e.replace(/^\/*/, "/"), l = X.useMemo(
    () => ({
      basename: o,
      navigator: r,
      static: g,
      future: {}
    }),
    [o, r, g]
  );
  typeof i == "string" && (i = YI(i));
  let {
    pathname: a = "/",
    search: I = "",
    hash: c = "",
    state: d = null,
    key: C = "default"
  } = i, A = X.useMemo(() => {
    let b = cl(a, o);
    return b == null ? null : {
      location: {
        pathname: b,
        search: I,
        hash: c,
        state: d,
        key: C
      },
      navigationType: n
    };
  }, [o, a, I, c, d, C, n]);
  return mr(
    A != null,
    `<Router basename="${o}"> is not able to match the URL "${a}${I}${c}" because it does not start with the basename, so the <Router> won't render anything.`
  ), A == null ? null : /* @__PURE__ */ X.createElement(Ls.Provider, { value: l }, /* @__PURE__ */ X.createElement(FZ.Provider, { children: t, value: A }));
}
function Uqt({
  children: e,
  location: t
}) {
  return zut(zx(e), t);
}
function zx(e, t = []) {
  let i = [];
  return X.Children.forEach(e, (n, r) => {
    if (!X.isValidElement(n))
      return;
    let g = [...t, r];
    if (n.type === X.Fragment) {
      i.push.apply(
        i,
        zx(n.props.children, g)
      );
      return;
    }
    xi(
      n.type === sCt,
      `[${typeof n.type == "string" ? n.type : n.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`
    ), xi(
      !n.props.index || !n.props.children,
      "An index route cannot have child routes."
    );
    let o = {
      id: n.props.id || g.join("-"),
      caseSensitive: n.props.caseSensitive,
      element: n.props.element,
      Component: n.props.Component,
      index: n.props.index,
      path: n.props.path,
      loader: n.props.loader,
      action: n.props.action,
      hydrateFallbackElement: n.props.hydrateFallbackElement,
      HydrateFallback: n.props.HydrateFallback,
      errorElement: n.props.errorElement,
      ErrorBoundary: n.props.ErrorBoundary,
      hasErrorBoundary: n.props.hasErrorBoundary === !0 || n.props.ErrorBoundary != null || n.props.errorElement != null,
      shouldRevalidate: n.props.shouldRevalidate,
      handle: n.props.handle,
      lazy: n.props.lazy
    };
    n.props.children && (o.children = zx(
      n.props.children,
      g
    )), i.push(o);
  }), i;
}
var uV = "get", CV = "application/x-www-form-urlencoded";
function Dv(e) {
  return e != null && typeof e.tagName == "string";
}
function cCt(e) {
  return Dv(e) && e.tagName.toLowerCase() === "button";
}
function dCt(e) {
  return Dv(e) && e.tagName.toLowerCase() === "form";
}
function uCt(e) {
  return Dv(e) && e.tagName.toLowerCase() === "input";
}
function CCt(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function ACt(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !CCt(e);
}
var eS = null;
function bCt() {
  if (eS === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), eS = !1;
    } catch {
      eS = !0;
    }
  return eS;
}
var hCt = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function XY(e) {
  return e != null && !hCt.has(e) ? (mr(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${CV}"`
  ), null) : e;
}
function mCt(e, t) {
  let i, n, r, g, o;
  if (dCt(e)) {
    let l = e.getAttribute("action");
    n = l ? cl(l, t) : null, i = e.getAttribute("method") || uV, r = XY(e.getAttribute("enctype")) || CV, g = new FormData(e);
  } else if (cCt(e) || uCt(e) && (e.type === "submit" || e.type === "image")) {
    let l = e.form;
    if (l == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let a = e.getAttribute("formaction") || l.getAttribute("action");
    if (n = a ? cl(a, t) : null, i = e.getAttribute("formmethod") || l.getAttribute("method") || uV, r = XY(e.getAttribute("formenctype")) || XY(l.getAttribute("enctype")) || CV, g = new FormData(l, e), !bCt()) {
      let { name: I, type: c, value: d } = e;
      if (c === "image") {
        let C = I ? `${I}.` : "";
        g.append(`${C}x`, "0"), g.append(`${C}y`, "0");
      } else
        I && g.append(I, d);
    }
  } else {
    if (Dv(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    i = uV, n = null, r = CV, o = e;
  }
  return g && r === "text/plain" && (o = g, g = void 0), { action: n, method: i.toLowerCase(), encType: r, formData: g, body: o };
}
function u9(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
async function pCt(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let i = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = i, i;
  } catch (i) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(i), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function BCt(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function fCt(e, t, i) {
  let n = await Promise.all(
    e.map(async (r) => {
      let g = t.routes[r.route.id];
      if (g) {
        let o = await pCt(g, i);
        return o.links ? o.links() : [];
      }
      return [];
    })
  );
  return WCt(
    n.flat(1).filter(BCt).filter((r) => r.rel === "stylesheet" || r.rel === "preload").map(
      (r) => r.rel === "stylesheet" ? { ...r, rel: "prefetch", as: "style" } : { ...r, rel: "prefetch" }
    )
  );
}
function tM(e, t, i, n, r, g) {
  let o = (a, I) => i[I] ? a.route.id !== i[I].route.id : !0, l = (a, I) => {
    var c;
    return (
      // param change, /users/123 -> /users/456
      i[I].pathname !== a.pathname || // splat param changed, which is not present in match.path
      // e.g. /files/images/avatar.jpg -> files/finances.xls
      ((c = i[I].route.path) == null ? void 0 : c.endsWith("*")) && i[I].params["*"] !== a.params["*"]
    );
  };
  return g === "assets" ? t.filter(
    (a, I) => o(a, I) || l(a, I)
  ) : g === "data" ? t.filter((a, I) => {
    var d;
    let c = n.routes[a.route.id];
    if (!c || !c.hasLoader)
      return !1;
    if (o(a, I) || l(a, I))
      return !0;
    if (a.route.shouldRevalidate) {
      let C = a.route.shouldRevalidate({
        currentUrl: new URL(
          r.pathname + r.search + r.hash,
          window.origin
        ),
        currentParams: ((d = i[0]) == null ? void 0 : d.params) || {},
        nextUrl: new URL(e, window.origin),
        nextParams: a.params,
        defaultShouldRevalidate: !0
      });
      if (typeof C == "boolean")
        return C;
    }
    return !0;
  }) : [];
}
function ZCt(e, t, { includeHydrateFallback: i } = {}) {
  return GCt(
    e.map((n) => {
      let r = t.routes[n.route.id];
      if (!r)
        return [];
      let g = [r.module];
      return r.clientActionModule && (g = g.concat(r.clientActionModule)), r.clientLoaderModule && (g = g.concat(r.clientLoaderModule)), i && r.hydrateFallbackModule && (g = g.concat(r.hydrateFallbackModule)), r.imports && (g = g.concat(r.imports)), g;
    }).flat(1)
  );
}
function GCt(e) {
  return [...new Set(e)];
}
function yCt(e) {
  let t = {}, i = Object.keys(e).sort();
  for (let n of i)
    t[n] = e[n];
  return t;
}
function WCt(e, t) {
  let i = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((n, r) => {
    let g = JSON.stringify(yCt(r));
    return i.has(g) || (i.add(g), n.push({ key: g, link: r })), n;
  }, []);
}
function SCt(e, t) {
  let i = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return i.pathname === "/" ? i.pathname = "_root.data" : t && cl(i.pathname, t) === "/" ? i.pathname = `${t.replace(/\/$/, "")}/_root.data` : i.pathname = `${i.pathname.replace(/\/$/, "")}.data`, i;
}
function F8() {
  let e = X.useContext(BA);
  return u9(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function VCt() {
  let e = X.useContext(YZ);
  return u9(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var C9 = X.createContext(void 0);
C9.displayName = "FrameworkContext";
function x8() {
  let e = X.useContext(C9);
  return u9(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function wCt(e, t) {
  let i = X.useContext(C9), [n, r] = X.useState(!1), [g, o] = X.useState(!1), { onFocus: l, onBlur: a, onMouseEnter: I, onMouseLeave: c, onTouchStart: d } = t, C = X.useRef(null);
  X.useEffect(() => {
    if (e === "render" && o(!0), e === "viewport") {
      let m = (B) => {
        B.forEach((f) => {
          o(f.isIntersecting);
        });
      }, p = new IntersectionObserver(m, { threshold: 0.5 });
      return C.current && p.observe(C.current), () => {
        p.disconnect();
      };
    }
  }, [e]), X.useEffect(() => {
    if (n) {
      let m = setTimeout(() => {
        o(!0);
      }, 100);
      return () => {
        clearTimeout(m);
      };
    }
  }, [n]);
  let A = () => {
    r(!0);
  }, b = () => {
    r(!1), o(!1);
  };
  return i ? e !== "intent" ? [g, C, {}] : [
    g,
    C,
    {
      onFocus: tB(l, A),
      onBlur: tB(a, b),
      onMouseEnter: tB(I, A),
      onMouseLeave: tB(c, b),
      onTouchStart: tB(d, A)
    }
  ] : [!1, C, {}];
}
function tB(e, t) {
  return (i) => {
    e && e(i), i.defaultPrevented || t(i);
  };
}
function vCt({
  page: e,
  ...t
}) {
  let { router: i } = F8(), n = X.useMemo(
    () => vd(i.routes, e, i.basename),
    [i.routes, e, i.basename]
  );
  return n ? /* @__PURE__ */ X.createElement(XCt, { page: e, matches: n, ...t }) : null;
}
function RCt(e) {
  let { manifest: t, routeModules: i } = x8(), [n, r] = X.useState([]);
  return X.useEffect(() => {
    let g = !1;
    return fCt(e, t, i).then(
      (o) => {
        g || r(o);
      }
    ), () => {
      g = !0;
    };
  }, [e, t, i]), n;
}
function XCt({
  page: e,
  matches: t,
  ...i
}) {
  let n = FI(), { manifest: r, routeModules: g } = x8(), { basename: o } = F8(), { loaderData: l, matches: a } = VCt(), I = X.useMemo(
    () => tM(
      e,
      t,
      a,
      r,
      n,
      "data"
    ),
    [e, t, a, r, n]
  ), c = X.useMemo(
    () => tM(
      e,
      t,
      a,
      r,
      n,
      "assets"
    ),
    [e, t, a, r, n]
  ), d = X.useMemo(() => {
    if (e === n.pathname + n.search + n.hash)
      return [];
    let b = /* @__PURE__ */ new Set(), m = !1;
    if (t.forEach((B) => {
      var Z;
      let f = r.routes[B.route.id];
      !f || !f.hasLoader || (!I.some((y) => y.route.id === B.route.id) && B.route.id in l && ((Z = g[B.route.id]) != null && Z.shouldRevalidate) || f.hasClientLoader ? m = !0 : b.add(B.route.id));
    }), b.size === 0)
      return [];
    let p = SCt(e, o);
    return m && b.size > 0 && p.searchParams.set(
      "_routes",
      t.filter((B) => b.has(B.route.id)).map((B) => B.route.id).join(",")
    ), [p.pathname + p.search];
  }, [
    o,
    l,
    n,
    r,
    I,
    t,
    e,
    g
  ]), C = X.useMemo(
    () => ZCt(c, r),
    [c, r]
  ), A = RCt(c);
  return /* @__PURE__ */ X.createElement(X.Fragment, null, d.map((b) => /* @__PURE__ */ X.createElement("link", { key: b, rel: "prefetch", as: "fetch", href: b, ...i })), C.map((b) => /* @__PURE__ */ X.createElement("link", { key: b, rel: "modulepreload", href: b, ...i })), A.map(({ key: b, link: m }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ X.createElement("link", { key: b, ...m })
  )));
}
function HCt(...e) {
  return (t) => {
    e.forEach((i) => {
      typeof i == "function" ? i(t) : i != null && (i.current = t);
    });
  };
}
var D8 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  D8 && (window.__reactRouterVersion = "7.5.0");
} catch {
}
function kCt(e, t) {
  return But({
    basename: t == null ? void 0 : t.basename,
    unstable_getContext: t == null ? void 0 : t.unstable_getContext,
    future: t == null ? void 0 : t.future,
    history: Kdt({ window: t == null ? void 0 : t.window }),
    hydrationData: YCt(),
    routes: e,
    mapRouteProperties: rCt,
    dataStrategy: t == null ? void 0 : t.dataStrategy,
    patchRoutesOnNavigation: t == null ? void 0 : t.patchRoutesOnNavigation,
    window: t == null ? void 0 : t.window
  }).initialize();
}
function YCt() {
  let e = window == null ? void 0 : window.__staticRouterHydrationData;
  return e && e.errors && (e = {
    ...e,
    errors: FCt(e.errors)
  }), e;
}
function FCt(e) {
  if (!e)
    return null;
  let t = Object.entries(e), i = {};
  for (let [n, r] of t)
    if (r && r.__type === "RouteErrorResponse")
      i[n] = new Bw(
        r.status,
        r.statusText,
        r.data,
        r.internal === !0
      );
    else if (r && r.__type === "Error") {
      if (r.__subType) {
        let g = window[r.__subType];
        if (typeof g == "function")
          try {
            let o = new g(r.message);
            o.stack = "", i[n] = o;
          } catch {
          }
      }
      if (i[n] == null) {
        let g = new Error(r.message);
        g.stack = "", i[n] = g;
      }
    } else
      i[n] = r;
  return i;
}
var J8 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, E8 = X.forwardRef(
  function({
    onClick: t,
    discover: i = "render",
    prefetch: n = "none",
    relative: r,
    reloadDocument: g,
    replace: o,
    state: l,
    target: a,
    to: I,
    preventScrollReset: c,
    viewTransition: d,
    ...C
  }, A) {
    let { basename: b } = X.useContext(Ls), m = typeof I == "string" && J8.test(I), p, B = !1;
    if (typeof I == "string" && m && (p = I, D8))
      try {
        let H = new URL(window.location.href), x = I.startsWith("//") ? new URL(H.protocol + I) : new URL(I), J = cl(x.pathname, b);
        x.origin === H.origin && J != null ? I = J + x.search + x.hash : B = !0;
      } catch {
        mr(
          !1,
          `<Link to="${I}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let f = Kut(I, { relative: r }), [Z, y, W] = wCt(
      n,
      C
    ), V = ECt(I, {
      replace: o,
      state: l,
      target: a,
      preventScrollReset: c,
      relative: r,
      viewTransition: d
    });
    function w(H) {
      t && t(H), H.defaultPrevented || V(H);
    }
    let v = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ X.createElement(
        "a",
        {
          ...C,
          ...W,
          href: p || f,
          onClick: B || g ? t : w,
          ref: HCt(A, y),
          target: a,
          "data-discover": !m && i === "render" ? "true" : void 0
        }
      )
    );
    return Z && !m ? /* @__PURE__ */ X.createElement(X.Fragment, null, v, /* @__PURE__ */ X.createElement(vCt, { page: f })) : v;
  }
);
E8.displayName = "Link";
var xCt = X.forwardRef(
  function({
    "aria-current": t = "page",
    caseSensitive: i = !1,
    className: n = "",
    end: r = !1,
    style: g,
    to: o,
    viewTransition: l,
    children: a,
    ...I
  }, c) {
    let d = xZ(o, { relative: I.relative }), C = FI(), A = X.useContext(YZ), { navigator: b, basename: m } = X.useContext(Ls), p = A != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    MCt(d) && l === !0, B = b.encodeLocation ? b.encodeLocation(d).pathname : d.pathname, f = C.pathname, Z = A && A.navigation && A.navigation.location ? A.navigation.location.pathname : null;
    i || (f = f.toLowerCase(), Z = Z ? Z.toLowerCase() : null, B = B.toLowerCase()), Z && m && (Z = cl(Z, m) || Z);
    const y = B !== "/" && B.endsWith("/") ? B.length - 1 : B.length;
    let W = f === B || !r && f.startsWith(B) && f.charAt(y) === "/", V = Z != null && (Z === B || !r && Z.startsWith(B) && Z.charAt(B.length) === "/"), w = {
      isActive: W,
      isPending: V,
      isTransitioning: p
    }, v = W ? t : void 0, H;
    typeof n == "function" ? H = n(w) : H = [
      n,
      W ? "active" : null,
      V ? "pending" : null,
      p ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let x = typeof g == "function" ? g(w) : g;
    return /* @__PURE__ */ X.createElement(
      E8,
      {
        ...I,
        "aria-current": v,
        className: H,
        ref: c,
        style: x,
        to: o,
        viewTransition: l
      },
      typeof a == "function" ? a(w) : a
    );
  }
);
xCt.displayName = "NavLink";
var DCt = X.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: i,
    reloadDocument: n,
    replace: r,
    state: g,
    method: o = uV,
    action: l,
    onSubmit: a,
    relative: I,
    preventScrollReset: c,
    viewTransition: d,
    ...C
  }, A) => {
    let b = KCt(), m = TCt(l, { relative: I }), p = o.toLowerCase() === "get" ? "get" : "post", B = typeof l == "string" && J8.test(l), f = (Z) => {
      if (a && a(Z), Z.defaultPrevented)
        return;
      Z.preventDefault();
      let y = Z.nativeEvent.submitter, W = (y == null ? void 0 : y.getAttribute("formmethod")) || o;
      b(y || Z.currentTarget, {
        fetcherKey: t,
        method: W,
        navigate: i,
        replace: r,
        state: g,
        relative: I,
        preventScrollReset: c,
        viewTransition: d
      });
    };
    return /* @__PURE__ */ X.createElement(
      "form",
      {
        ref: A,
        method: p,
        action: m,
        onSubmit: n ? a : f,
        ...C,
        "data-discover": !B && e === "render" ? "true" : void 0
      }
    );
  }
);
DCt.displayName = "Form";
function JCt(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function N8(e) {
  let t = X.useContext(BA);
  return xi(t, JCt(e)), t;
}
function ECt(e, {
  target: t,
  replace: i,
  state: n,
  preventScrollReset: r,
  relative: g,
  viewTransition: o
} = {}) {
  let l = ZA(), a = FI(), I = xZ(e, { relative: g });
  return X.useCallback(
    (c) => {
      if (ACt(c, t)) {
        c.preventDefault();
        let d = i !== void 0 ? i : nu(a) === nu(I);
        l(e, {
          replace: d,
          state: n,
          preventScrollReset: r,
          relative: g,
          viewTransition: o
        });
      }
    },
    [
      a,
      l,
      I,
      i,
      n,
      t,
      e,
      r,
      g,
      o
    ]
  );
}
var NCt = 0, LCt = () => `__${String(++NCt)}__`;
function KCt() {
  let { router: e } = N8(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = X.useContext(Ls), i = eCt();
  return X.useCallback(
    async (n, r = {}) => {
      let { action: g, method: o, encType: l, formData: a, body: I } = mCt(
        n,
        t
      );
      if (r.navigate === !1) {
        let c = r.fetcherKey || LCt();
        await e.fetch(c, i, r.action || g, {
          preventScrollReset: r.preventScrollReset,
          formData: a,
          body: I,
          formMethod: r.method || o,
          formEncType: r.encType || l,
          flushSync: r.flushSync
        });
      } else
        await e.navigate(r.action || g, {
          preventScrollReset: r.preventScrollReset,
          formData: a,
          body: I,
          formMethod: r.method || o,
          formEncType: r.encType || l,
          replace: r.replace,
          state: r.state,
          fromRouteId: i,
          flushSync: r.flushSync,
          viewTransition: r.viewTransition
        });
    },
    [e, t, i]
  );
}
function TCt(e, { relative: t } = {}) {
  let { basename: i } = X.useContext(Ls), n = X.useContext(_a);
  xi(n, "useFormAction must be used inside a RouteContext");
  let [r] = n.matches.slice(-1), g = { ...xZ(e || ".", { relative: t }) }, o = FI();
  if (e == null) {
    g.search = o.search;
    let l = new URLSearchParams(g.search), a = l.getAll("index");
    if (a.some((c) => c === "")) {
      l.delete("index"), a.filter((d) => d).forEach((d) => l.append("index", d));
      let c = l.toString();
      g.search = c ? `?${c}` : "";
    }
  }
  return (!e || e === ".") && r.route.index && (g.search = g.search ? g.search.replace(/^\?/, "?index&") : "?index"), i !== "/" && (g.pathname = g.pathname === "/" ? i : fI([i, g.pathname])), nu(g);
}
function MCt(e, t = {}) {
  let i = X.useContext(s9);
  xi(
    i != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: n } = N8(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), r = xZ(e, { relative: t.relative });
  if (!i.isTransitioning)
    return !1;
  let g = cl(i.currentLocation.pathname, n) || i.currentLocation.pathname, o = cl(i.nextLocation.pathname, n) || i.nextLocation.pathname;
  return Nf(r.pathname, o) != null || Nf(r.pathname, g) != null;
}
new TextEncoder();
/**
 * react-router v7.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function PCt(e) {
  return /* @__PURE__ */ X.createElement(oCt, { flushSync: f4.flushSync, ...e });
}
function UCt() {
  const e = window.location.search;
  return Oe(() => {
    var i;
    const t = new URLSearchParams(e);
    return e === "" ? new URLSearchParams((i = window.location.hash.split("?")) == null ? void 0 : i[1]) : t;
  }, [e]);
}
const ZI = (e) => {
  const t = window.location.search;
  return new URLSearchParams(t).get(e);
}, L8 = () => ZI("app"), zCt = () => ZI("dealer"), OCt = () => {
  const e = window.location.origin, t = sl.originalDomain;
  return !(e.includes("localhost") || e.includes("bs-local") || t && e.includes(t));
}, QCt = () => OCt() ? window.location.host : L8(), jCt = () => ZI("k3-code") == null ? ZI("code") : ZI("k3-code"), qCt = () => ZI("part"), K8 = (e) => {
  const t = qCt();
  if (!t)
    return;
  const i = vZ(t)(e);
  return t && (i == null ? void 0 : i.type) === "components" ? i : void 0;
}, _Ct = () => ie(K8), Ox = "de", fw = (e) => {
  const t = ZI("lang");
  if (t)
    return t;
  if (e != null && e.lang)
    return e.lang;
  let i = window.navigator.languages && window.navigator.language.length ? window.navigator.languages[0] : window.navigator.language;
  return i.includes("-") && (i = i.split("-")[0]), i.includes("_") && (i = i.split("_")[0]), i || Ox;
}, $Ct = (e) => {
  const t = new URL(window.location.href);
  t.searchParams.set("code", e), window.history.pushState({}, "", t.toString());
}, zqt = () => ZI("autostartAR"), Oqt = () => {
  const e = new URL(window.location.href);
  e.searchParams.delete("autostartAR"), window.history.pushState({}, "", e.toString());
}, eAt = (e, t, i) => (e += (e.includes("?") ? "&" : "?") + `${encodeURIComponent(t)}=`, Array.isArray(i) ? e += i.map((n) => encodeURIComponent(n)).join(",") : e += encodeURIComponent(i), e), tAt = (e) => {
  const t = UCt().get(encodeURIComponent(e));
  return (t == null ? void 0 : t.split(",").map((i) => decodeURIComponent(i))) || [];
}, iAt = (e) => {
  try {
    return localStorage.getItem(e);
  } catch {
    return null;
  }
};
var oZ;
class nAt extends Error {
  constructor(i, n) {
    super(i);
    lL(this, oZ, void 0);
    aL(this, oZ, n);
  }
  get result() {
    return oL(this, oZ);
  }
}
oZ = new WeakMap();
function rAt(e) {
  return Le.overEvery([VWe, Le.has("email"), Le.has("name"), Le.has("role")])(e);
}
function A9() {
  return sl.apiUrl + "$token";
}
function T8() {
  return iAt(A9());
}
function gAt(e) {
  localStorage.setItem(A9(), e);
}
function oAt() {
  localStorage.removeItem(A9());
}
function Qqt() {
  return T8() != null;
}
async function M8(e, t, i = {}, n = null) {
  const r = {
    method: e,
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: i,
    redirect: "follow",
    referrerPolicy: "no-referrer"
  };
  return n && (r.body = n), await fetch(t, r);
}
async function b9(e, t, i = null, n = {}) {
  const r = sl.apiUrl + "/api/v1.0" + t, g = T8();
  return g && (n.Authorization = "Bearer " + g), await M8(e, r, n, i);
}
async function du(e, t, i = null, n = {}) {
  const r = await b9(e, t, i, n), g = await r.json();
  if (!r.ok)
    throw new nAt(`Response-Error: Status ${r.status}. Message: ${JSON.stringify(g)}`, g);
  return g;
}
async function wi(e, t, i = null, {
  lang: n = ""
} = {}) {
  const r = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  return n && (r["X-language"] = n), i && (i = JSON.stringify(i)), du(e, t, i, r);
}
async function jqt({
  email: e,
  password: t
}) {
  const i = await wi("POST", "/login", {
    email: e,
    password: t
  });
  if (!rAt(i))
    throw i;
  const n = i;
  try {
    gAt(n.token);
  } catch (r) {
    throw console.error("Login failed: Failed to set user token. Make sure localStorage is accessible", r), r;
  }
  return n;
}
async function qqt() {
  await wi("GET", "/logout"), oAt();
}
async function Jv(e) {
  const t = {
    Accept: "application/json"
  }, i = await M8("GET", sl.docUrl + e, t);
  if (i.status != 200 || !i.ok)
    throw new Error(i.status + ": Could not fetch response");
  return await i.json();
}
async function _qt() {
  return await wi("GET", "/client/customers");
}
async function $qt(e, t, i) {
  return await wi("POST", `/app/${e}/shop`, t, {
    lang: i
  });
}
async function lAt(e, t) {
  return await wi("GET", `/app/${encodeURIComponent(t)}/full`, null, {
    lang: e
  });
}
async function Qx(e, t, i, n) {
  async function r(o, l, a) {
    try {
      const I = await aAt(a, o, l), c = a || dw(I.app)[0];
      return n == null || n(mct(c)), I;
    } catch {
      return console.error(`Failed to load app with: Code: ${o} Version: ${l} Language: ${a}`), null;
    }
  }
  let g = await r(t, i, e);
  if (g || (g = await r(t, i), g) || (console.error("Fallback language did not work, because JSON is not published yet."), e != Ox && (g = await r(t, i, Ox), g)))
    return g;
  throw console.error("Could not load any JSON for the given app."), new Error("Die App wurde noch nicht veröffentlicht. Laden der Konfiguration schlägt fehl.");
}
async function aAt(e, t, i) {
  const n = e ? `.${e}` : "";
  return await Jv(`/data/${i === "current" ? "current" : "versions"}/${encodeURIComponent(t)}${n}.json`);
}
async function jx(e, t, i) {
  try {
    const n = e ? `.${e}` : "", r = i || "current";
    return await Jv(`/data/articles/${encodeURIComponent(t)}/${r}${n}.json`);
  } catch {
    return;
  }
}
async function e_t(e, t) {
  return await wi("GET", `/app/${e}/import/articles`, null, {
    lang: t
  });
}
async function t_t(e, t) {
  return await wi("GET", `/app/${e}/publish`, null, {
    lang: t
  });
}
async function i_t(e, t) {
  return await wi("GET", `/app/${e}/publish/log`, null, {
    lang: t
  });
}
async function n_t(e, t) {
  return await wi("GET", `/app/${e}/publish/articles`, null, {
    lang: t
  });
}
async function r_t(e, t, i) {
  return await wi("POST", `/app/${e}/copy`, t, {
    lang: i
  });
}
async function g_t(e) {
  return await wi("GET", `/app/${e}/export`, null, {});
}
async function o_t(e, t) {
  return await wi("POST", "/app/import", e);
}
async function l_t(e, t) {
  return await wi("GET", `/app/${e}/version/${t}`);
}
async function a_t(e, t, i) {
  return await wi("POST", `/app/${e}/book/${t}?interval=${i ?? "month"}`);
}
async function s_t(e) {
  return await wi("GET", `/app/${e}/products`, null, {});
}
async function I_t() {
  return await wi("GET", "/app/products/all");
}
const qx = {
  Draft: "draft",
  Basket: "basket",
  Quoted: "quoted",
  Ordered: "ordered"
};
async function sAt(e, t, i, n, r, g = !1, o) {
  if (!t)
    throw new Error("Missing App Code for uploadContent!");
  const l = new FormData();
  return o && l.append("dealerId", String(o)), o ? l.append("state", qx.Draft) : l.append("state", qx.Ordered), l.append("price", JSON.stringify(e.price)), l.append("preview", String(g)), l.append("json", JSON.stringify(e.json)), l.append("customer", JSON.stringify(e.customer)), l.append("files", JSON.stringify(e.files)), r.forEach((I) => {
    l.append(I.key, I.file);
  }), await du("POST", `/app/${t}/cfg/${i.id}`, l, {
    "X-language": n,
    Accept: "application/json"
  });
}
async function IAt(e) {
  return await Jv(`/data/cfgs/${encodeURIComponent(e)}.json`);
}
async function cAt(e) {
  return await wi("GET", `/app/cfg/${encodeURIComponent(e)}`, null);
}
async function c_t(e, t, i) {
  return await wi("GET", `/cfg/${e}/pdf${i ? "/" + i : ""}`, null, {
    lang: t
  });
}
async function d_t(e, t) {
  return await wi("GET", `/cfg/${e}/shop`, null, {
    lang: t
  });
}
var P8 = {}, U8 = {}, z8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function() {
    for (var r = arguments.length, g = new Array(r), o = 0; o < r; o++)
      g[o] = arguments[o];
    if (typeof window < "u") {
      var l;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (l = window).gtag.apply(l, g);
    }
  }, i = t;
  e.default = i;
})(z8);
var O8 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var t = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function i(l) {
    return l.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(a, I, c) {
      return I > 0 && I + a.length !== c.length && a.search(t) > -1 && c.charAt(I - 2) !== ":" && (c.charAt(I + a.length) !== "-" || c.charAt(I - 1) === "-") && c.charAt(I - 1).search(/[^\s-]/) < 0 ? a.toLowerCase() : a.substr(1).search(/[A-Z]|\../) > -1 ? a : a.charAt(0).toUpperCase() + a.substr(1);
    });
  }
  function n(l) {
    return typeof l == "string" && l.indexOf("@") !== -1;
  }
  var r = "REDACTED (Potential Email Address)";
  function g(l) {
    return n(l) ? (console.warn("This arg looks like an email address, redacting."), r) : l;
  }
  function o() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, c = l || "";
    return a && (c = i(l)), I && (c = g(c)), c;
  }
})(O8);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.GA4 = void 0;
  var t = o(z8), i = o(O8), n = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], r = ["title", "location"], g = ["page", "hitType"];
  function o(L) {
    return L && L.__esModule ? L : { default: L };
  }
  function l(L, N) {
    if (L == null)
      return {};
    var U = a(L, N), O, $;
    if (Object.getOwnPropertySymbols) {
      var ne = Object.getOwnPropertySymbols(L);
      for ($ = 0; $ < ne.length; $++)
        O = ne[$], !(N.indexOf(O) >= 0) && Object.prototype.propertyIsEnumerable.call(L, O) && (U[O] = L[O]);
    }
    return U;
  }
  function a(L, N) {
    if (L == null)
      return {};
    var U = {}, O = Object.keys(L), $, ne;
    for (ne = 0; ne < O.length; ne++)
      $ = O[ne], !(N.indexOf($) >= 0) && (U[$] = L[$]);
    return U;
  }
  function I(L) {
    "@babel/helpers - typeof";
    return I = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(N) {
      return typeof N;
    } : function(N) {
      return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
    }, I(L);
  }
  function c(L) {
    return A(L) || C(L) || f(L) || d();
  }
  function d() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function C(L) {
    if (typeof Symbol < "u" && L[Symbol.iterator] != null || L["@@iterator"] != null)
      return Array.from(L);
  }
  function A(L) {
    if (Array.isArray(L))
      return Z(L);
  }
  function b(L, N) {
    var U = Object.keys(L);
    if (Object.getOwnPropertySymbols) {
      var O = Object.getOwnPropertySymbols(L);
      N && (O = O.filter(function($) {
        return Object.getOwnPropertyDescriptor(L, $).enumerable;
      })), U.push.apply(U, O);
    }
    return U;
  }
  function m(L) {
    for (var N = 1; N < arguments.length; N++) {
      var U = arguments[N] != null ? arguments[N] : {};
      N % 2 ? b(Object(U), !0).forEach(function(O) {
        H(L, O, U[O]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(L, Object.getOwnPropertyDescriptors(U)) : b(Object(U)).forEach(function(O) {
        Object.defineProperty(L, O, Object.getOwnPropertyDescriptor(U, O));
      });
    }
    return L;
  }
  function p(L, N) {
    return W(L) || y(L, N) || f(L, N) || B();
  }
  function B() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function f(L, N) {
    if (L) {
      if (typeof L == "string")
        return Z(L, N);
      var U = Object.prototype.toString.call(L).slice(8, -1);
      if (U === "Object" && L.constructor && (U = L.constructor.name), U === "Map" || U === "Set")
        return Array.from(L);
      if (U === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(U))
        return Z(L, N);
    }
  }
  function Z(L, N) {
    (N == null || N > L.length) && (N = L.length);
    for (var U = 0, O = new Array(N); U < N; U++)
      O[U] = L[U];
    return O;
  }
  function y(L, N) {
    var U = L == null ? null : typeof Symbol < "u" && L[Symbol.iterator] || L["@@iterator"];
    if (U != null) {
      var O, $, ne, be, Ve = [], He = !0, Je = !1;
      try {
        if (ne = (U = U.call(L)).next, N !== 0)
          for (; !(He = (O = ne.call(U)).done) && (Ve.push(O.value), Ve.length !== N); He = !0)
            ;
      } catch (ke) {
        Je = !0, $ = ke;
      } finally {
        try {
          if (!He && U.return != null && (be = U.return(), Object(be) !== be))
            return;
        } finally {
          if (Je)
            throw $;
        }
      }
      return Ve;
    }
  }
  function W(L) {
    if (Array.isArray(L))
      return L;
  }
  function V(L, N) {
    if (!(L instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function w(L, N) {
    for (var U = 0; U < N.length; U++) {
      var O = N[U];
      O.enumerable = O.enumerable || !1, O.configurable = !0, "value" in O && (O.writable = !0), Object.defineProperty(L, x(O.key), O);
    }
  }
  function v(L, N, U) {
    return N && w(L.prototype, N), Object.defineProperty(L, "prototype", { writable: !1 }), L;
  }
  function H(L, N, U) {
    return N = x(N), N in L ? Object.defineProperty(L, N, { value: U, enumerable: !0, configurable: !0, writable: !0 }) : L[N] = U, L;
  }
  function x(L) {
    var N = J(L, "string");
    return I(N) === "symbol" ? N : String(N);
  }
  function J(L, N) {
    if (I(L) !== "object" || L === null)
      return L;
    var U = L[Symbol.toPrimitive];
    if (U !== void 0) {
      var O = U.call(L, N || "default");
      if (I(O) !== "object")
        return O;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (N === "string" ? String : Number)(L);
  }
  var K = /* @__PURE__ */ function() {
    function L() {
      var N = this;
      V(this, L), H(this, "reset", function() {
        N.isInitialized = !1, N._testMode = !1, N._currentMeasurementId, N._hasLoadedGA = !1, N._isQueuing = !1, N._queueGtag = [];
      }), H(this, "_gtag", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        N._testMode || N._isQueuing ? N._queueGtag.push(O) : t.default.apply(void 0, O);
      }), H(this, "_loadGA", function(U, O) {
        var $ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !N._hasLoadedGA) {
          var ne = document.createElement("script");
          ne.async = !0, ne.src = "".concat($, "?id=").concat(U), O && ne.setAttribute("nonce", O), document.body.appendChild(ne), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, N._hasLoadedGA = !0;
        }
      }), H(this, "_toGtagOptions", function(U) {
        if (U) {
          var O = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, $ = Object.entries(U).reduce(function(ne, be) {
            var Ve = p(be, 2), He = Ve[0], Je = Ve[1];
            return O[He] ? ne[O[He]] = Je : ne[He] = Je, ne;
          }, {});
          return $;
        }
      }), H(this, "initialize", function(U) {
        var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!U)
          throw new Error("Require GA_MEASUREMENT_ID");
        var $ = typeof U == "string" ? [{
          trackingId: U
        }] : U;
        N._currentMeasurementId = $[0].trackingId;
        var ne = O.gaOptions, be = O.gtagOptions, Ve = O.nonce, He = O.testMode, Je = He === void 0 ? !1 : He, ke = O.gtagUrl;
        if (N._testMode = Je, Je || N._loadGA(N._currentMeasurementId, Ve, ke), N.isInitialized || (N._gtag("js", /* @__PURE__ */ new Date()), $.forEach(function(Xe) {
          var Ze = m(m(m({}, N._toGtagOptions(m(m({}, ne), Xe.gaOptions))), be), Xe.gtagOptions);
          Object.keys(Ze).length ? N._gtag("config", Xe.trackingId, Ze) : N._gtag("config", Xe.trackingId);
        })), N.isInitialized = !0, !Je) {
          var we = c(N._queueGtag);
          for (N._queueGtag = [], N._isQueuing = !1; we.length; ) {
            var ue = we.shift();
            N._gtag.apply(N, c(ue)), ue[0] === "get" && (N._isQueuing = !0);
          }
        }
      }), H(this, "set", function(U) {
        if (!U) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (I(U) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(U).length === 0 && console.warn("empty `fieldsObject` given to .set()"), N._gaCommand("set", U);
      }), H(this, "_gaCommandSendEvent", function(U, O, $, ne, be) {
        N._gtag("event", O, m(m({
          event_category: U,
          event_label: $,
          value: ne
        }, be && {
          non_interaction: be.nonInteraction
        }), N._toGtagOptions(be)));
      }), H(this, "_gaCommandSendEventParameters", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        if (typeof O[0] == "string")
          N._gaCommandSendEvent.apply(N, c(O.slice(1)));
        else {
          var ne = O[0], be = ne.eventCategory, Ve = ne.eventAction, He = ne.eventLabel, Je = ne.eventValue;
          ne.hitType;
          var ke = l(ne, n);
          N._gaCommandSendEvent(be, Ve, He, Je, ke);
        }
      }), H(this, "_gaCommandSendTiming", function(U, O, $, ne) {
        N._gtag("event", "timing_complete", {
          name: O,
          value: $,
          event_category: U,
          event_label: ne
        });
      }), H(this, "_gaCommandSendPageview", function(U, O) {
        if (O && Object.keys(O).length) {
          var $ = N._toGtagOptions(O), ne = $.title, be = $.location, Ve = l($, r);
          N._gtag("event", "page_view", m(m(m(m({}, U && {
            page_path: U
          }), ne && {
            page_title: ne
          }), be && {
            page_location: be
          }), Ve));
        } else
          U ? N._gtag("event", "page_view", {
            page_path: U
          }) : N._gtag("event", "page_view");
      }), H(this, "_gaCommandSendPageviewParameters", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        if (typeof O[0] == "string")
          N._gaCommandSendPageview.apply(N, c(O.slice(1)));
        else {
          var ne = O[0], be = ne.page;
          ne.hitType;
          var Ve = l(ne, g);
          N._gaCommandSendPageview(be, Ve);
        }
      }), H(this, "_gaCommandSend", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        var ne = typeof O[0] == "string" ? O[0] : O[0].hitType;
        switch (ne) {
          case "event":
            N._gaCommandSendEventParameters.apply(N, O);
            break;
          case "pageview":
            N._gaCommandSendPageviewParameters.apply(N, O);
            break;
          case "timing":
            N._gaCommandSendTiming.apply(N, c(O.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(ne));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(ne));
        }
      }), H(this, "_gaCommandSet", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        typeof O[0] == "string" && (O[0] = H({}, O[0], O[1])), N._gtag("set", N._toGtagOptions(O[0]));
      }), H(this, "_gaCommand", function(U) {
        for (var O = arguments.length, $ = new Array(O > 1 ? O - 1 : 0), ne = 1; ne < O; ne++)
          $[ne - 1] = arguments[ne];
        switch (U) {
          case "send":
            N._gaCommandSend.apply(N, $);
            break;
          case "set":
            N._gaCommandSet.apply(N, $);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(U));
        }
      }), H(this, "ga", function() {
        for (var U = arguments.length, O = new Array(U), $ = 0; $ < U; $++)
          O[$] = arguments[$];
        if (typeof O[0] == "string")
          N._gaCommand.apply(N, O);
        else {
          var ne = O[0];
          N._gtag("get", N._currentMeasurementId, "client_id", function(be) {
            N._isQueuing = !1;
            var Ve = N._queueGtag;
            for (ne({
              get: function(ke) {
                return ke === "clientId" ? be : ke === "trackingId" ? N._currentMeasurementId : ke === "apiVersion" ? "1" : void 0;
              }
            }); Ve.length; ) {
              var He = Ve.shift();
              N._gtag.apply(N, c(He));
            }
          }), N._isQueuing = !0;
        }
        return N.ga;
      }), H(this, "event", function(U, O) {
        if (typeof U == "string")
          N._gtag("event", U, N._toGtagOptions(O));
        else {
          var $ = U.action, ne = U.category, be = U.label, Ve = U.value, He = U.nonInteraction, Je = U.transport;
          if (!ne || !$) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var ke = {
            hitType: "event",
            eventCategory: (0, i.default)(ne),
            eventAction: (0, i.default)($)
          };
          be && (ke.eventLabel = (0, i.default)(be)), typeof Ve < "u" && (typeof Ve != "number" ? console.warn("Expected `args.value` arg to be a Number.") : ke.eventValue = Ve), typeof He < "u" && (typeof He != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : ke.nonInteraction = He), typeof Je < "u" && (typeof Je != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(Je) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), ke.transport = Je)), N._gaCommand("send", ke);
        }
      }), H(this, "send", function(U) {
        N._gaCommand("send", U);
      }), this.reset();
    }
    return v(L, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), L;
  }();
  e.GA4 = K;
  var M = new K();
  e.default = M;
})(U8);
(function(e) {
  function t(l) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, t(l);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ReactGAImplementation = void 0;
  var i = r(U8);
  function n(l) {
    if (typeof WeakMap != "function")
      return null;
    var a = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap();
    return (n = function(d) {
      return d ? I : a;
    })(l);
  }
  function r(l, a) {
    if (l && l.__esModule)
      return l;
    if (l === null || t(l) !== "object" && typeof l != "function")
      return { default: l };
    var I = n(a);
    if (I && I.has(l))
      return I.get(l);
    var c = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var C in l)
      if (C !== "default" && Object.prototype.hasOwnProperty.call(l, C)) {
        var A = d ? Object.getOwnPropertyDescriptor(l, C) : null;
        A && (A.get || A.set) ? Object.defineProperty(c, C, A) : c[C] = l[C];
      }
    return c.default = l, I && I.set(l, c), c;
  }
  var g = i.GA4;
  e.ReactGAImplementation = g;
  var o = i.default;
  e.default = o;
})(P8);
const _x = /* @__PURE__ */ go(P8), dAt = (e, t = !1) => {
  const i = t ? sl.adminAnalytics : e.settings.gaTrackingId, n = ZI("ga");
  i && n != "false" && (_x.initialize(
    i
    /*, { debug: true }*/
  ), _x.set({
    anonymizeIp: !0
  }));
}, Q8 = (e) => {
  _x.event(e);
}, uAt = (e) => {
  const t = ZI("ga");
  return e.settings.gaTrackingId && t != "false";
}, cm = (e, t, i, n) => {
  if (!i)
    return;
  const r = {
    category: "K3:" + i.label + (n ? ":" + n : ""),
    action: e,
    label: t
  };
  uAt(i) && Q8(r);
}, CAt = (e, t, i) => (n, r) => {
  var I;
  const g = r(), o = (I = nr(g)) == null ? void 0 : I.variables.byVarId.all[e];
  if (!o) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const l = o.key || o.label, a = (i == null ? void 0 : i.inputValue) || t.key || t.label;
  cm(l, "" + a, Pi(g), "action");
}, j8 = (e, t) => (i, n) => {
  if (!e)
    return;
  const r = n(), g = pA(e)(r);
  if (!g)
    return;
  const o = qr(g.variableId)(r), l = o.key || o.label, a = (t ? "+" : "-") + ((g == null ? void 0 : g.key) || (g == null ? void 0 : g.label));
  cm(l, "" + a, Pi(r), "action");
}, u_t = (e, t) => {
  const i = {
    category: "k3",
    action: e,
    label: t
  };
  sl.adminAnalytics && Q8(i);
}, AAt = (e, t, i) => {
  const n = t ? Number(t) : -1 / 0, r = i ? Number(i) : 1 / 0;
  let g = [...e.flatMap((l) => [l.left, l.right]), r, n];
  g = de.uniq(g).sort((l, a) => l - a), g = g.filter((l) => l <= r && l >= n);
  const o = g.slice(0, g.length - 1).flatMap((l, a) => {
    const I = g[a + 1];
    return l === -1 / 0 ? [P3(l, I)] : [oA(l), P3(l, I)];
  });
  return r !== 1 / 0 && o.push(oA(r)), o;
}, q8 = (e, t, i) => (n) => {
  const r = i ? E6(i) : {};
  fAt(e);
  let {
    values: g,
    ruleItems: o,
    rules: l
  } = n;
  l = l.filter((d) => d.isActive), o = o.filter((d) => d.isActive), o = o.filter((d) => !Object.values(d.values).some((C) => de.isArray(C) && !C.length)), o = ZAt(o, l, r), o = o.map((d) => ({
    ...d,
    values: Object.fromEntries(Object.entries(d.values).map(([C, A]) => [C, de.isNumber(A) ? [A] : xf(A) ? {
      ...A,
      interval: dye(A.interval)
    } : A]))
  })), g = g.slice().sort(h6), g = bAt(g, e, o).newValues;
  const I = An(g);
  o = o.filter((d) => Object.values(d.values).every((C) => de.isArray(C) ? C.some((A) => I[A]) : !0)), t ? l = l.filter((d) => d.checkValidity) : l = l.filter((d) => d.columns.some((C) => !Gc(C))), o = o.filter((d) => l.some((C) => d.ruleId === C.id));
  const c = rGe(l, o, g, e, t);
  return l = c.flat.rules, o = c.flat.ruleItems, {
    newRules: l,
    newRuleItems: o,
    newValues: g
  };
}, bAt = (e, t, i) => {
  const n = hAt(), r = e.filter((l) => !Sg(t.find((a) => a.id === l.variableId))), g = mAt(i, r, t, n);
  r.push(...g.additionalValues);
  const o = t.filter((l) => Hm(l)).map((l) => n(l));
  return r.push(...o), {
    newValues: r
  };
}, hAt = () => {
  let e = -1;
  return (t, i) => ({
    id: e--,
    appId: 0,
    variableId: t.id,
    value: Iw(i) ? U3(i) : "",
    sort: 0,
    label: Iw(i) ? U3(i) : "",
    data: i
  });
}, AV = (e, t) => {
  const i = {};
  return e.forEach((n) => {
    i[n.id.toString()] = t.filter((r) => r.variableId === n.id);
  }), i;
}, mAt = (e, t, i, n) => {
  const r = de.filter(e, (o) => Object.values(o.values).some((l) => xf(l)));
  return {
    additionalValues: i.filter((o) => Sg(o)).flatMap((o) => {
      const {
        min: l,
        max: a
      } = Bye(o), I = r.filter((d) => !!d.values[o.id]);
      let c = I.flatMap((d) => Object.keys(d.values).map((C) => {
        if (Number(C) !== o.id)
          return !1;
        const A = d.values[C];
        return xf(A) ? A.interval : !1;
      })).filter(Boolean);
      return c = AAt(c, l, a), c = pAt(o, c, I), c = BAt(o, c), c.map((d) => n(o, d));
    })
  };
}, pAt = (e, t, i) => {
  if (!i.length)
    return t;
  const n = t.map((o) => ({
    interval: o,
    items: i.filter((l) => Wc(o, l.values[e.id].interval)).map((l) => l.id)
  }));
  let r = [];
  const g = [];
  for (const o of n)
    r.length ? de.isEqual(r[0].items, o.items) ? r.push(o) : (g.push(z3(r.map((l) => l.interval))), r = [o]) : r.push(o);
  return g.push(z3(r.map((o) => o.interval))), g;
}, BAt = (e, t) => {
  const i = Iu(e);
  return i && !(i % 1) ? t.filter((n) => !(!n.leftInclude && !n.rightInclude && n.right === n.left + 1)) : t;
}, fAt = (e) => e.forEach((t) => {
  if (!t.key)
    return;
  const i = e.find((n) => n.key === t.key && n.id !== t.id);
  i && console.error(`${t.label} and ${i.label} have the same key.`, t, i);
});
function ZAt(e, t, i) {
  return e = e.filter((n) => !!Object.entries(n.values).every(([r, g]) => {
    var o, l;
    if (de.isObject(g) && "id" in g && g.id == "setFocusGroup") {
      const a = g;
      if (a.mode) {
        const I = (l = (o = t.find((d) => d.id === n.ruleId)) == null ? void 0 : o.columns.find((d) => d.id == r)) == null ? void 0 : l.targetId;
        if (!I)
          return !0;
        const c = Object.values(i).find((d) => d === I);
        return a.mode == "focused" ? !!c : !c;
      }
      return !0;
    }
    return !0;
  })), e;
}
const GAt = (e, t, i, n, r) => {
  const g = q8(n, !1, r)({
    rules: e,
    ruleItems: t,
    values: i
  }), o = AV(n, g.newValues);
  return {
    variables: n,
    ruleItems: {
      byRuleId: de.groupBy(g.newRuleItems, "ruleId"),
      flat: g.newRuleItems
    },
    values: {
      byVarId: o,
      flat: g.newValues
    },
    rules: g.newRules
  };
}, yAt = (e, t, i, n, r, g, o, l) => {
  const a = {
    articles: [],
    colors: [],
    hideGroups: [],
    hideValues: [],
    hideVariables: [],
    concealVariables: [],
    concealGroups: [],
    images: [],
    instances: [],
    labels: [],
    popups: [],
    models: [],
    materials: [],
    prints: [],
    exitButtons: []
  }, I = sv(g, o.state.all.selections), c = de.groupBy(r.variables, (C) => C.parentId), d = de.groupBy(I, (C) => C.variableId);
  return t.forEach((C) => {
    const A = r.rules.find((m) => m.id === C.ruleId);
    if (!A) {
      console.warn(`RuleItem ${C.id} does not have a corresponding rule`);
      return;
    }
    const b = A.columns.filter(iGe);
    Object.keys(C.values).forEach((m) => {
      if (!yJ(m))
        return;
      const p = C.values[m], B = e.find((Z) => Z.isOfType(p)), f = B == null ? void 0 : B.type;
      if (f && a[f]) {
        const Z = b.find((W) => W.id === m), y = B.createActions(p, {
          column: Z,
          ruleItem: C,
          rule: A,
          actionEngineInput: r,
          selections: I,
          validSelectionCombinations: i,
          selectionScopes: n,
          ruleEngineInput: g,
          metadata: l,
          variablesByParentId: c,
          selectionsByVariableId: d
        });
        de.isArray(y) ? a[f].push(...y ?? []) : y ? a[f].push(y) : console.warn("Action defined for non accessible variable: Might be hidden?");
      }
    });
  }), a;
}, WAt = (e) => e.rule.columns.reduce((t, i) => (Gc(i) && t.push(i.targetId), t), []), SAt = (e, t, i) => i.every((n) => {
  var g, o;
  const r = (g = t.scopes) == null ? void 0 : g[n.id];
  return de.has(r, e.variableId) ? (
    // If the variable is in the scope, check if the selection fits to the
    // previous scopes
    (o = r == null ? void 0 : r[e.variableId]) == null ? void 0 : o.find((l) => l.id === e.id)
  ) : (
    // If the variable is not in the scope, it means that previous
    // selections have not excLuded it yet. So continue.
    !0
  );
}), VAt = (e) => {
  let t = WAt(e);
  t.length === 0 && (t = [Ut.variableId]);
  const i = [], n = t.length, r = (g, o) => {
    if (o.length === n)
      i.push([...o]);
    else
      for (let l = g; l < t.length; l++) {
        const a = e.selectionsByVariableId[t[l]];
        for (let I = 0; I < a.length; I++)
          SAt(a[I], e, o) && (o.push(a[I]), r(l + 1, o), o.pop());
      }
  };
  return r(0, []), i;
}, wAt = (e) => e.reduce((i, n) => {
  const r = VAt(n);
  return r.length > 0 && i.push({
    ...n,
    validSelectionCombinations: r
  }), i;
}, []), vAt = (e) => e.reduce((t, i) => (t.activeRuleItems.push(i.ruleItem), t.validSelectionCombinations[i.ruleItem.id] = i.validSelectionCombinations, i.scopes && (t.selectionScopes[i.ruleItem.id] = i.scopes), t), {
  activeRuleItems: [],
  validSelectionCombinations: {},
  selectionScopes: {}
});
function RAt(e, t, i) {
  const n = Oj(e, i);
  if (!n)
    return !1;
  const r = !t.some((g) => g.variableId === i.variableId);
  return n && r;
}
function $x(e, t, i, n, r) {
  const g = WZ(t, e, r), o = {};
  return g.forEach((l) => {
    const a = i[l.variableId];
    o[l.variableId] || (o[l.variableId] = []), (o[l.variableId] ?? []).push(l), (a ?? []).forEach((I) => {
      var d;
      const c = (d = n[I.id]) == null ? void 0 : d.filter((C) => RAt(l, g, C));
      if (!c)
        o[I.id] = null;
      else {
        const C = o[I.id] ?? [];
        C.push(...c), o[I.id] = C;
      }
    });
  }), o;
}
function XAt(e, t, i) {
  const n = An(e), r = de.groupBy(e, (a) => a.parentId), g = de.groupBy(t, (a) => a.variableId), o = t.filter((a) => a.instance.isInstanceLauncher), l = $x(Ut, t, r, g, o);
  return i.map((a) => {
    const I = a.rule.columns.reduce((c, d) => {
      if (!Gc(d))
        return c;
      const C = a.selectionsByVariableId[d.targetId], A = n[d.targetId];
      if (A.parentId === Ut.variableId && !Zv(A)) {
        for (const b of C)
          c[b.id] = l;
        return c;
      }
      for (const b of C) {
        const m = $x(b, t, r, g, o);
        c[b.id] = m;
      }
      return c;
    }, {
      // If the rule has just action columns and no variable columns we need
      // to provide the global scope as the default.
      [Ut.id]: l
    });
    return {
      ...a,
      scopes: I
    };
  });
}
const HAt = (e, t, i) => {
  const n = An(e), r = de.groupBy(i, (g) => g.variableId);
  return Object.entries(t).flatMap(([g, o]) => {
    const l = n[parseInt(g)], a = l.columns.filter(Gc);
    return o.reduce((I, c) => {
      const d = {
        selectionsByVariableId: {},
        rule: l,
        ruleItem: c
      };
      for (let C = 0; C < a.length; C++) {
        const A = a[C], b = r[A.targetId];
        if (!b || b.length === 0)
          return I;
        const m = b.filter((p) => FJ(c, p));
        if (m.length === 0)
          return I;
        d.selectionsByVariableId[A.targetId] = m;
      }
      return a.length === 0 && (d.selectionsByVariableId = {
        [Ut.variableId]: [Ut]
      }), I.push(d), I;
    }, []);
  });
}, kAt = (e, t, i) => {
  if (!i || !e)
    return {
      activeRuleItems: [],
      validSelectionCombinations: {},
      selectionScopes: {}
    };
  const n = e.ruleItems, r = sv(t, i.state.all.selections), g = HAt(e.rules, n.byRuleId, r), o = XAt(e.variables, r, g);
  return vAt(wAt(o));
}, _8 = (e) => (t, i, n, r, g) => {
  const {
    activeRuleItems: o,
    validSelectionCombinations: l,
    selectionScopes: a
  } = kAt(t, i, n);
  return yAt(e, o, l, a, t, i, n, g);
}, $8 = ai(/* @__PURE__ */ ee("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), YAt = ai(/* @__PURE__ */ ee("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "AddCircleOutline"), eq = ai(/* @__PURE__ */ ee("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack"), FAt = ai(/* @__PURE__ */ ee("path", {
  d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12m10-1h4v2h-4v3l-4-4 4-4z"
}), "ArrowCircleLeft"), xAt = ai(/* @__PURE__ */ ee("path", {
  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10m-10 1H8v-2h4V8l4 4-4 4z"
}), "ArrowCircleRight"), DAt = ai(/* @__PURE__ */ ee("path", {
  d: "m7 10 5 5 5-5z"
}), "ArrowDropDown"), JAt = ai(/* @__PURE__ */ ee("path", {
  d: "m7 14 5-5 5 5z"
}), "ArrowDropUp"), EAt = ai(/* @__PURE__ */ ee("path", {
  d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18z"
}), "AspectRatioOutlined"), tq = ai(/* @__PURE__ */ ee("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.4-1.41 1.41-1.06-1.06 1.41-1.41zm-6.78.66h5v1.5h-5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2zm6.5 1.25h-5v-1.5h5zm0-2.5h-5v-1.5h5z"
}), "Calculate"), NAt = ai(/* @__PURE__ */ ee("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), "Cancel"), iM = ai(/* @__PURE__ */ ee("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), Ev = ai(/* @__PURE__ */ ee("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear"), iq = ai(/* @__PURE__ */ ee("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), LAt = ai(/* @__PURE__ */ ee("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), "CloudUpload"), KAt = ai(/* @__PURE__ */ ee("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy"), TAt = ai(/* @__PURE__ */ ee("path", {
  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11M16 14h2V8c0-1.11-.9-2-2-2h-6v2h6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2z"
}), "CropRotate"), DZ = ai(/* @__PURE__ */ ee("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete"), MAt = ai(/* @__PURE__ */ ee("path", {
  d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), "Done"), nq = ai(/* @__PURE__ */ ee("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit"), PAt = ai(/* @__PURE__ */ ee("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline"), UAt = ai(/* @__PURE__ */ ee("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), "ExpandLess"), h9 = ai(/* @__PURE__ */ ee("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), zAt = ai(/* @__PURE__ */ ee("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), "Facebook"), OAt = ai(/* @__PURE__ */ ee("path", {
  d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), "FileUpload"), QAt = ai(/* @__PURE__ */ ee("path", {
  d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen"), jAt = ai(/* @__PURE__ */ ee("path", {
  d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExit"), qAt = ai(/* @__PURE__ */ ee("path", {
  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined"), _At = ai(/* @__PURE__ */ ee("path", {
  d: "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7"
}), "Lightbulb"), $At = ai(/* @__PURE__ */ ee("path", {
  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), "LinkedIn"), ebt = ai(/* @__PURE__ */ ee("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), tbt = ai(/* @__PURE__ */ ee("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), "Refresh"), ibt = ai(/* @__PURE__ */ ee("path", {
  d: "M19 13H5v-2h14z"
}), "Remove"), nbt = ai(/* @__PURE__ */ ee("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "ReportProblem"), rbt = ai(/* @__PURE__ */ ee("path", {
  d: "M21 12.4V7l-4-4H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h7.4zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3M6 6h9v4H6zm13.99 10.25 1.77 1.77L16.77 23H15v-1.77zm3.26.26-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71"
}), "SaveAs"), e5 = ai(/* @__PURE__ */ ee("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search"), nM = ai(/* @__PURE__ */ ee("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99zM9 3 5 6.99h3V14h2V6.99h3z"
}), "SwapVert"), gbt = ai(/* @__PURE__ */ ee("path", {
  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), "Twitter"), rq = ai(/* @__PURE__ */ ee("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff"), gq = ai([/* @__PURE__ */ ee("path", {
  d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
}, "0"), /* @__PURE__ */ ee("path", {
  d: "M13 16h-2v2h2zm0-6h-2v5h2z"
}, "1")], "WarningAmber"), obt = (e) => new Error($i.t("es gibt keine Merkmale mit {{identificator}}", {
  identificator: e
})), rM = (e) => new Error($i.t("es gibt kein Attribut mit {{identificator}}", {
  identificator: e
})), t5 = (e) => new Error($i.t("es gibt keine Selection mit {{identificator}}", {
  identificator: e
})), lbt = (e) => new Error($i.t("es gibt mehr als eine Selection mit {{identificator}}", {
  identificator: e
})), abt = (e) => new Error($i.t("Es gibt einen Zyklus in den berechneten Merkmalen: {{cycleText}}", {
  cycleText: e
})), sbt = (e) => {
  const t = typeof e;
  if (!(e == null || t === "number"))
    throw new Error($i.t("das Ergebnis der Formel muss ein Zahlenwert sein, statt dessen ist es {{type}}", {
      type: t
    }));
  return e;
}, lc = (e, t, i) => {
  if (e == null)
    throw new Error($i.t("Wert {{paramName}} der Funktion {{functionName}} ist null", {
      functionName: t,
      paramName: i
    }));
  return e;
}, Ibt = (e) => new Error($i.t("Das Merkmal {{variableLabel}} ist eine Komponentenliste. Sie müssen mit einem Index wie {{variableLabel2}}[0] für das 1. Element oder mit einer Array-Funktionen wie z.B. map(), find(), reduce() oder first() darauf zugreifen", {
  variableLabel: e,
  variableLabel2: e
})), cbt = atob("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"), dbt = Le.toPairs({
  count: (e) => e.length,
  product: (e) => e.reduce((t, i) => t * i, 1)
}), ubt = [["capitalize", de.capitalize], ["clamp", de.clamp], ["compact", de.compact], ["first", de.first], ["last", de.last], ["lowerFirst", de.lowerFirst], ["max", de.max], ["min", de.min], ["mean", de.mean], ["pad", de.pad], ["range", de.range], ["snakeCase", de.snakeCase], ["orderBy", de.orderBy], ["startCase", de.startCase], ["sum", de.sum], ["tail", de.tail], ["take", de.take], ["toLower", de.toLower], ["toUpper", de.toUpper], ["union", de.union], ["uniq", de.uniq], ["upperFirst", de.upperFirst], ["without", de.without]], Cbt = ["EPSILON", "MAX_SAFE_INTEGER", "MAX_VALUE", "MIN_SAFE_INTEGER", "MIN_VALUE", "NaN", "NEGATIVE_INFINITY", "POSITIVE_INFINITY", "isFinite", "isInteger", "isNaN", "isSafeInteger", "parseFloat", "parseInt"].map((e) => [e, Number[e]]), Abt = [
  "E",
  "PI",
  "abs",
  "acos",
  "acosh",
  "asin",
  "asinh",
  "atan",
  "atan2",
  "atanh",
  "ceil",
  "cos",
  "cosh",
  "exp",
  "floor",
  "fround",
  "hypot",
  "imul",
  "log",
  "log10",
  "log1p",
  "log2",
  "pow",
  "round",
  "sign",
  "sin",
  "sinh",
  "sqrt",
  "tan",
  "tanh",
  "trunc"
  // this seems to be necessary here
].map((e) => [e, Math[e]]), bbt = ["toExponential", "toFixed", "toPrecision", "toLocaleString"], hbt = bbt.map((e) => [
  e,
  // (x, ...args) => (isNumber(x) ? x[name](...args) : null),
  (t, ...i) => de.isNumber(t) ? t[e](...i) : Nv(e, "number", t)
]), mbt = ["endsWith", "includes", "indexOf", "lastIndexOf", "localeCompare", "match", "matchAll", "normalize", "padEnd", "padStart", "repeat", "replace", "replaceAll", "search", "slice", "split", "startsWith", "substring", "toLocaleLowerCase", "toLocaleUpperCase", "toLowerCase", "toSource", "toString", "toUpperCase", "trim", "trimEnd", "trimStart"], pbt = mbt.map((e) => [e, (t, ...i) => de.isString(t) ? (
  // @ts-ignore
  t[e](...i)
) : Nv(e, "string", t)]), Bbt = ["test"], fbt = Bbt.map((e) => [
  e,
  // (x, ...args) => (isRegExp(x) ? x[name](...args) : null),
  (t, ...i) => de.isRegExp(t) ? (
    // @ts-ignore Should it be that way?
    t[e](...i)
  ) : Nv(e, "RegExp", t)
]), Zbt = ["at", "concat", "every", "filter", "find", "findIndex", "flat", "flatMap", "includes", "indexOf", "join", "lastIndexOf", "map", "reduce", "reduceRight", "slice", "some"], Gbt = Zbt.map((e) => [e, (t, ...i) => (
  // @ts-ignore Needed here because we access the array
  de.isArray(t) ? t[e](...i) : Nv(e, "Array", t)
)]), ybt = [...hbt, ...pbt, ...fbt, ...Gbt];
function Nv(e, t, i) {
  throw new Error(`function ${e}(...) is only defined for type ${t} but got type ${typeof i}`);
}
const JZ = Le.fromPairs([].concat(ybt, Cbt, Abt, ubt, dbt));
var bV = /* @__PURE__ */ ((e) => (e[e.Boolean = 0] = "Boolean", e[e.Number = 1] = "Number", e[e.Array = 2] = "Array", e[e.ElementCallback = 3] = "ElementCallback", e[e.ArrayElement = 4] = "ArrayElement", e[e.CallbackReturn = 5] = "CallbackReturn", e[e.Any = 6] = "Any", e))(bV || {});
const Wbt = [{
  name: "first",
  arguments: [
    2
    /* Array */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "last",
  arguments: [
    2
    /* Array */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "every",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 0
  /* Boolean */
}, {
  name: "filter",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "find",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "findIndex",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 1
  /* Number */
}, {
  name: "includes",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 4
  /* ArrayElement */
}, {
  name: "indexOf",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 1
  /* Number */
}, {
  name: "lastIndexOf",
  arguments: [
    2,
    4
    /* ArrayElement */
  ],
  type: 1
  /* Number */
}, {
  name: "map",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "reduce",
  arguments: [
    2,
    3,
    6
    /* Any */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "reduceRight",
  arguments: [
    2,
    3,
    6
    /* Any */
  ],
  type: 5
  /* CallbackReturn */
}, {
  name: "some",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 0
  /* Boolean */
}, {
  name: "orderBy",
  arguments: [
    2,
    3
    /* ElementCallback */
  ],
  type: 2
  /* Array */
}];
function Sbt(e, t = (n) => [], i) {
  const n = [], r = /* @__PURE__ */ new Set(), g = /* @__PURE__ */ new Set(), o = (l) => {
    if (!r.has(l)) {
      if (g.has(l)) {
        if (g.add(l), i(l))
          throw g;
        return;
      }
      g.add(l), t(l).forEach(o), g.delete(l), r.add(l), n.push(l);
    }
  };
  return e.forEach(o), n;
}
function Vbt(e, t = (i) => []) {
  const i = /* @__PURE__ */ new Map(), n = [], r = [];
  for (const g of e)
    i.set(g, 0);
  for (const g of e)
    for (const o of t(g))
      i.set(o, i.get(o) + 1);
  for (const g of e)
    i.get(g) === 0 && n.push(g);
  for (; n.length > 0; ) {
    const g = n.shift();
    r.push(g);
    for (const o of t(g))
      i.set(o, i.get(o) - 1), i.get(o) === 0 && n.unshift(o);
  }
  if (r.length !== e.length)
    throw new Error($i.t("Es gibt einen Zyklus in den berechneten Merkmalen."));
  return r;
}
const Ka = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.templateOptions) == null ? void 0 : i.calculated) ?? !1;
}, Jm = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.templateOptions) == null ? void 0 : i.expression) ?? "";
}, oq = (e) => AA(e) && "expression" in e && de.isString(e.expression), wbt = (e) => {
  const t = oq(e) ? e.expression : e;
  try {
    const i = +t;
    return !i && i !== 0;
  } catch {
    return !0;
  }
}, lq = (e, t) => {
  const i = [];
  let n = e[t];
  for (; n && n.parentId != null; ) {
    const r = e[n.parentId];
    r && i.push(r.id), n = r;
  }
  return i.push(Ut.variableId), i;
}, vbt = (e, t) => {
  const i = de.groupBy(e, "parentId"), n = [], r = [t];
  do {
    const g = r.pop(), o = i[g];
    if (o) {
      const l = o.map((a) => a.id);
      n.push(...l), r.push(...l);
    }
  } while (r.length > 0);
  return n;
};
function aq(e, t, i, n, r = !0, g) {
  const o = (g == null ? void 0 : g.variables.byVarId.all) ?? de.keyBy(e, (d) => d.id), l = (g == null ? void 0 : g.values.byVarId.all) ?? de.groupBy(t, (d) => d.variableId), a = Fbt(o, n), I = de.groupBy(a, (d) => qa(d)), c = a.filter((d) => mg(d));
  return {
    variables: e,
    variablesById: o,
    values: t,
    valuesByVariableId: l,
    selections: a,
    variable: null,
    selectionsOfVariable: [],
    allSelections: [Ut, ...a],
    anchoringSelection: Ut,
    variableHierarchies: i,
    selectionsByParentSelectionId: I,
    inInstances: c,
    abortOnMissingSelection: r
  };
}
function sq(e) {
  return {
    varId(t) {
      return n5(e, t);
    },
    id(t) {
      return n5(e, t);
    },
    attrId(t) {
      return cI.attrId(e, t);
    }
  };
}
function Rbt(e, t) {
  return e.selections.filter(Xbt(e, t)).sort(tu);
}
const cI = {
  varId(e, t) {
    var g, o, l;
    lc(e, "varId", "context"), lc(t, "varId", "id");
    const i = e.variablesById[t];
    if (i == null)
      throw obt("variableId " + t);
    const n = Rbt(e, t);
    if (n == null || n.length === 0) {
      if (i.type !== Ho.Components && e.abortOnMissingSelection)
        throw t5("variable " + i.label + " expression variable: " + ((o = e.variablesById[(g = e.anchoringSelection) == null ? void 0 : g.variableId]) == null ? void 0 : o.label));
      return {
        ...e,
        variable: i,
        selectionsOfVariable: n
      };
    }
    if (!((l = e.variableHierarchies[e.anchoringSelection.variableId]) != null && l.includes(t))) {
      const a = iA(e.allSelections, n[0]);
      if (!a)
        throw new Error("Parent selection not found for variable " + i.label);
      return {
        ...e,
        variable: i,
        anchoringSelection: a,
        selections: am(e.variableHierarchies, e.allSelections, a, e.selectionsByParentSelectionId, e.inInstances),
        selectionsOfVariable: n
      };
    }
    return {
      ...e,
      variable: i,
      selectionsOfVariable: n
    };
  },
  attrId(e, t) {
    var I, c, d, C, A;
    {
      if (lc(e, "attrId", "context"), lc(t, "attrId", "id"), e.selectionsOfVariable == null || e.selectionsOfVariable.length === 0)
        throw t5("variable " + ((I = e.variable) == null ? void 0 : I.label));
      if (e.selectionsOfVariable.length > 1)
        throw lbt("variable " + ((c = e.variable) == null ? void 0 : c.label));
    }
    const i = e.selectionsOfVariable[0];
    lc(i, "attrId", "context.selectionsOfVariable[0]");
    const n = i.valueId;
    if (n == null)
      throw rM("variable " + ((d = e.variable) == null ? void 0 : d.label) + " attributeId " + t);
    const r = e.values.find((b) => b.id == n);
    lc(n, "attrId", "value is null for context.selectionsOfVariable[0].valueId");
    const g = (C = r == null ? void 0 : r.attrs) == null ? void 0 : C.find((b) => b.attrId == t);
    if (g == null)
      throw rM("variable " + ((A = e.variable) == null ? void 0 : A.label) + " attributeId " + t);
    const o = g == null ? void 0 : g.value;
    if (o == null)
      return null;
    const l = e.variablesById[i.variableId];
    lc(e, "attrId", "contextVariable");
    const a = l.attrs.find((b) => b.id == t);
    if (lc(e, "attrId", "attr"), a.type === "symbol")
      throw new Error("type symbol is not implemented yet in expression engine for attribute " + a.label[$i.language]);
    if (typeof o !== a.type)
      throw new Error("internal type mismatch: attribute definition for " + a.label[$i.language] + " is of type " + a.type + " but primitive value is of type " + typeof o);
    return o;
  },
  instances(e) {
    const t = e.variable, i = e.selectionsOfVariable;
    if (t == null)
      throw new Error("Variable is null");
    if (i.length === 0)
      throw new Error(`No selections for variable ${t == null ? void 0 : t.label}`);
    if (!uq(e, t.id))
      throw new Error(`Variable ${t == null ? void 0 : t.label} is not a parent of the anchoring selection.`);
    const n = i[0], r = e.allSelections.filter((g) => g.variableId === (n == null ? void 0 : n.variableId) && g.instance.belongsToInstanceId === (n == null ? void 0 : n.instance.belongsToInstanceId)).sort(tu);
    return Iq({
      ...e,
      selections: e.allSelections,
      selectionsOfVariable: r
    });
  },
  instanceIndex(e) {
    const t = e.variable, i = e.selectionsOfVariable;
    if (t == null)
      throw new Error("Variable is null");
    if (i.length === 0)
      throw new Error(`No selections for variable ${t == null ? void 0 : t.label}`);
    if (i.length > 1)
      throw new Error(`More than one selection for variable ${t == null ? void 0 : t.label}, cant determine instance index.`);
    const n = i[0];
    let r;
    if (GZ(n)) {
      if (n.instance.id === Ut.id)
        return 0;
      r = iA(e.selections, n);
    } else
      r = n;
    return e.allSelections.filter((l) => l.variableId === (r == null ? void 0 : r.variableId) && l.instance.belongsToInstanceId === (r == null ? void 0 : r.instance.belongsToInstanceId)).sort(tu).findIndex((l) => l.id === n.instance.id);
  },
  getInputValue(e) {
    var t, i;
    return lc(e, "value", "context"), e.selectionsOfVariable == null || e.selectionsOfVariable.length === 0 ? null : (i = (t = e.selectionsOfVariable[0]) == null ? void 0 : t.data) == null ? void 0 : i.inputValue;
  },
  isContextVariableAComponentVariable(e) {
    var t;
    return ((t = e.variable) == null ? void 0 : t.type) === Ho.Components;
  },
  splitContextIntoMultipleSubContexts(e) {
    return e.selectionsOfVariable.map((i) => ({
      variables: e.variables,
      variablesById: e.variablesById,
      values: e.values,
      valuesByVariableId: e.valuesByVariableId,
      allSelections: e.allSelections,
      variable: e.variable,
      variableHierarchies: e.variableHierarchies,
      selectionsByParentSelectionId: e.selectionsByParentSelectionId,
      inInstances: e.inInstances,
      selections: am(e.variableHierarchies, e.allSelections, i, e.selectionsByParentSelectionId, e.inInstances),
      selectionsOfVariable: [i],
      anchoringSelection: i,
      abortOnMissingSelection: e.abortOnMissingSelection
    }));
  }
};
function Xbt(e, t) {
  if (e.selectionsOfVariable.length > 0) {
    const i = new Set(e.selectionsOfVariable.map((n) => n.id));
    return (n) => n.variableId == t && i.has(qa(n));
  }
  return (i) => i.variableId == t;
}
function i5(e) {
  return new Proxy(e, Hbt);
}
const Hbt = {
  get(e, t) {
    if (t === Symbol.toPrimitive || t === "valueOf")
      return (i) => cI.getInputValue(e);
    if (t === "varId")
      return (i) => n5(e, i);
    if (t === "attrId")
      return (i) => cI.attrId(e, i);
    if (t === "instances")
      return cI.instances(e);
    if (t === "instanceIndex")
      return cI.instanceIndex(e);
    if (t === Symbol.toStringTag)
      return Object.prototype.toString.call(cI.getInputValue(e));
    throw typeof t == "symbol" ? new Error("unknown property of type symbol") : new Error(`unknown property ${t} context: ${e}`);
  }
}, Iq = (e) => {
  const t = cI.splitContextIntoMultipleSubContexts(e).map((n) => i5(n)), i = () => {
    var n;
    throw Ibt((n = e.variable) == null ? void 0 : n.label);
  };
  return new Proxy(t, {
    get(n, r, g) {
      var o;
      if (typeof r == "string") {
        if (/^(varId|attrId)$/g.test(r))
          return i;
        if (r === "instanceIndex")
          return i();
        const l = parseInt(r, 10);
        if (l < 0 || l >= t.length)
          throw t5("variable " + ((o = e.variable) == null ? void 0 : o.label) + ", index=" + l);
      }
      return Reflect.get(n, r, g);
    }
  });
};
function n5(e, t) {
  const i = cI.varId(e, t);
  return cI.isContextVariableAComponentVariable(i) ? i.selectionsOfVariable.length === 1 && uq(i, t) ? i5(i) : Iq(i) : i5(i);
}
const cq = [...Object.keys(JZ)], kbt = [
  // TODO this might be deprecated but I am not sure - CL
  "id",
  ...Object.keys(cI)
], dq = de.memoize((e) => {
  ypt(e);
  const t = de.isEmpty(e) ? "undefined" : e, i = `
      const { ${cq.filter((r) => e.match(new RegExp(`\\b${r}\\b`))).join(", ")} } = staticFunctions;

      const { ${kbt.filter((r) => e.match(new RegExp(`\\b${r}\\b`))).join(", ")} } = contextFunctions;

      const result = ${t};
      return result?.valueOf();
  `, n = new Function("staticFunctions", "contextFunctions", i);
  return (r, g) => sbt(n(r, g));
});
function uq(e, t) {
  const i = lq(e.variablesById, e == null ? void 0 : e.anchoringSelection.variableId);
  return e != null && e.anchoringSelection.instance.isInstanceLauncher && i.push(e == null ? void 0 : e.anchoringSelection.variableId), i.find((r) => r === t);
}
function Cq(e, t, i, n, r, g, o = !0, l) {
  var a, I, c;
  try {
    const C = Aq(e, t, i, n, [r], o, l, g).find((A) => A.id === g.id);
    return {
      result: ((a = C == null ? void 0 : C.data) == null ? void 0 : a.inputValue) ?? 0,
      resultString: W6(C, r),
      errorMessage: (c = (I = C == null ? void 0 : C.data) == null ? void 0 : I.error) == null ? void 0 : c.message
    };
  } catch (d) {
    return {
      result: 0,
      errorMessage: d.message
    };
  }
}
function Aq(e, t, i, n, r, g = !0, o, l) {
  var I;
  const a = aq(e, t, i, n, g, o);
  return (I = Xpt((r ?? e).filter(Ka))) == null || I.forEach((c) => Ybt(a, c, l)), a.selections;
}
function Ybt(e, t, i) {
  const n = Jm(t), r = e.selections.filter((o) => o.variableId == t.id);
  if (r.length == 0)
    return;
  const g = e.valuesByVariableId[t.id];
  r.filter((o) => !i || to(o, i)).forEach((o) => {
    o.data = o.data ?? {};
    const l = am(e.variableHierarchies, e.allSelections, o, e.selectionsByParentSelectionId, e.inInstances), a = sq({
      ...e,
      selections: l,
      anchoringSelection: o
    });
    if (n)
      try {
        const c = dq(n)(JZ, a);
        if (o.data.inputValue = c ?? 0, de.isNumber(c) === !1 || isNaN(c))
          return;
        const d = Xm(c, g, Iu(t));
        (d == null ? void 0 : d.input) === c ? (o.valueId = d.value.id, o.interval = d.value.data, o.data.error = void 0) : d ? o.data.error = {
          name: "Invalid Value",
          message: "Invalid Value",
          expression: n,
          value: c,
          nearestValue: d.input
        } : o.data.error = {
          name: "No matching value found",
          message: "No matching value found",
          expression: n,
          value: c
        };
      } catch (I) {
        o.data.error = {
          name: "Expression Error",
          message: I,
          expression: n
        }, console.error(I);
      }
  });
}
function Lv(e, t, i, n, r, g = Ut, o) {
  const l = aq(e, t, i, n, void 0, o), a = {
    ...l,
    selections: am(l.variableHierarchies, l.allSelections, g, l.selectionsByParentSelectionId, l.inInstances),
    anchoringSelection: g
  }, I = sq(a);
  try {
    const d = dq(r)(JZ, I) || 0;
    return {
      result: d,
      resultString: S6(d, l.variablesById[g == null ? void 0 : g.variableId])
    };
  } catch (c) {
    return {
      result: 0,
      errorMessage: c.message
    };
  }
}
function Fbt(e, t) {
  return t.map((i) => Ka(e[i.variableId]) ? {
    ...i,
    data: {
      ...i.data
    }
  } : i);
}
var Kv = { exports: {} };
function xbt(e) {
  return e === "description" || e === "string" || e === "code";
}
function ko(e, t, i) {
  if (!xbt(i))
    throw new Error("invalid Failure type: " + i);
  this.pexpr = e, this.text = t, this.type = i, this.fluffy = !1;
}
ko.prototype.getPExpr = function() {
  return this.pexpr;
};
ko.prototype.getText = function() {
  return this.text;
};
ko.prototype.getType = function() {
  return this.type;
};
ko.prototype.isDescription = function() {
  return this.type === "description";
};
ko.prototype.isStringTerminal = function() {
  return this.type === "string";
};
ko.prototype.isCode = function() {
  return this.type === "code";
};
ko.prototype.isFluffy = function() {
  return this.fluffy;
};
ko.prototype.makeFluffy = function() {
  this.fluffy = !0;
};
ko.prototype.clearFluffy = function() {
  this.fluffy = !1;
};
ko.prototype.subsumes = function(e) {
  return this.getText() === e.getText() && this.type === e.type && (!this.isFluffy() || this.isFluffy() && e.isFluffy());
};
ko.prototype.toString = function() {
  return this.type === "string" ? JSON.stringify(this.getText()) : this.getText();
};
ko.prototype.clone = function() {
  const e = new ko(this.pexpr, this.text, this.type);
  return this.isFluffy() && e.makeFluffy(), e;
};
ko.prototype.toKey = function() {
  return this.toString() + "#" + this.type;
};
var bq = ko, Jn = {};
(function(e) {
  e.abstract = function(i) {
    const n = i || "";
    return function() {
      throw new Error(
        "this method " + n + " is abstract! (it has no implementation in class " + this.constructor.name + ")"
      );
    };
  }, e.assert = function(i, n) {
    if (!i)
      throw new Error(n || "Assertion failed");
  }, e.defineLazyProperty = function(i, n, r) {
    let g;
    Object.defineProperty(i, n, {
      get() {
        return g || (g = r.call(this)), g;
      }
    });
  }, e.clone = function(i) {
    return i && Object.assign({}, i);
  }, e.repeatFn = function(i, n) {
    const r = [];
    for (; n-- > 0; )
      r.push(i());
    return r;
  }, e.repeatStr = function(i, n) {
    return new Array(n + 1).join(i);
  }, e.repeat = function(i, n) {
    return e.repeatFn(() => i, n);
  }, e.getDuplicates = function(i) {
    const n = [];
    for (let r = 0; r < i.length; r++) {
      const g = i[r];
      i.lastIndexOf(g) !== r && n.indexOf(g) < 0 && n.push(g);
    }
    return n;
  }, e.copyWithoutDuplicates = function(i) {
    const n = [];
    return i.forEach((r) => {
      n.indexOf(r) < 0 && n.push(r);
    }), n;
  }, e.isSyntactic = function(i) {
    const n = i[0];
    return n === n.toUpperCase();
  }, e.isLexical = function(i) {
    return !e.isSyntactic(i);
  }, e.padLeft = function(i, n, r) {
    const g = r || " ";
    return i.length < n ? e.repeatStr(g, n - i.length) + i : i;
  }, e.StringBuffer = function() {
    this.strings = [];
  }, e.StringBuffer.prototype.append = function(i) {
    this.strings.push(i);
  }, e.StringBuffer.prototype.contents = function() {
    return this.strings.join("");
  };
  const t = (i) => String.fromCodePoint(parseInt(i, 16));
  e.unescapeCodePoint = function(i) {
    if (i.charAt(0) === "\\")
      switch (i.charAt(1)) {
        case "b":
          return "\b";
        case "f":
          return "\f";
        case "n":
          return `
`;
        case "r":
          return "\r";
        case "t":
          return "	";
        case "v":
          return "\v";
        case "x":
          return t(i.slice(2, 4));
        case "u":
          return i.charAt(2) === "{" ? t(i.slice(3, -1)) : t(i.slice(2, 6));
        default:
          return i.charAt(1);
      }
    else
      return i;
  }, e.unexpectedObjToString = function(i) {
    if (i == null)
      return String(i);
    const n = Object.prototype.toString.call(i);
    try {
      let r;
      return i.constructor && i.constructor.name ? r = i.constructor.name : n.indexOf("[object ") === 0 ? r = n.slice(8, -1) : r = typeof i, r + ": " + JSON.stringify(String(i));
    } catch {
      return n;
    }
  };
})(Jn);
const gM = Jn;
let Tv = class {
  constructor(t) {
    this.matchLength = t;
  }
  get ctorName() {
    throw new Error("subclass responsibility");
  }
  numChildren() {
    return this.children ? this.children.length : 0;
  }
  childAt(t) {
    if (this.children)
      return this.children[t];
  }
  indexOfChild(t) {
    return this.children.indexOf(t);
  }
  hasChildren() {
    return this.numChildren() > 0;
  }
  hasNoChildren() {
    return !this.hasChildren();
  }
  onlyChild() {
    if (this.numChildren() !== 1)
      throw new Error(
        "cannot get only child of a node of type " + this.ctorName + " (it has " + this.numChildren() + " children)"
      );
    return this.firstChild();
  }
  firstChild() {
    if (this.hasNoChildren())
      throw new Error(
        "cannot get first child of a " + this.ctorName + " node, which has no children"
      );
    return this.childAt(0);
  }
  lastChild() {
    if (this.hasNoChildren())
      throw new Error(
        "cannot get last child of a " + this.ctorName + " node, which has no children"
      );
    return this.childAt(this.numChildren() - 1);
  }
  childBefore(t) {
    const i = this.indexOfChild(t);
    if (i < 0)
      throw new Error("Node.childBefore() called w/ an argument that is not a child");
    if (i === 0)
      throw new Error("cannot get child before first child");
    return this.childAt(i - 1);
  }
  childAfter(t) {
    const i = this.indexOfChild(t);
    if (i < 0)
      throw new Error("Node.childAfter() called w/ an argument that is not a child");
    if (i === this.numChildren() - 1)
      throw new Error("cannot get child after last child");
    return this.childAt(i + 1);
  }
  isTerminal() {
    return !1;
  }
  isNonterminal() {
    return !1;
  }
  isIteration() {
    return !1;
  }
  isOptional() {
    return !1;
  }
};
class Dbt extends Tv {
  get ctorName() {
    return "_terminal";
  }
  isTerminal() {
    return !0;
  }
  get primitiveValue() {
    throw new Error("The `primitiveValue` property was removed in Ohm v17.");
  }
}
class Jbt extends Tv {
  constructor(t, i, n, r) {
    super(r), this.ruleName = t, this.children = i, this.childOffsets = n;
  }
  get ctorName() {
    return this.ruleName;
  }
  isNonterminal() {
    return !0;
  }
  isLexical() {
    return gM.isLexical(this.ctorName);
  }
  isSyntactic() {
    return gM.isSyntactic(this.ctorName);
  }
}
class Ebt extends Tv {
  constructor(t, i, n, r) {
    super(n), this.children = t, this.childOffsets = i, this.optional = r;
  }
  get ctorName() {
    return "_iter";
  }
  isIteration() {
    return !0;
  }
  isOptional() {
    return this.optional;
  }
}
var m9 = {
  Node: Tv,
  TerminalNode: Dbt,
  NonterminalNode: Jbt,
  IterationNode: Ebt
}, ji = {}, Nbt = {
  // Letters
  Lu: /[A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]/,
  Ll: /[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A]|\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]/,
  Lt: /[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]/,
  Lm: /[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]/,
  Lo: /[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
  // Numbers
  Nl: /[\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF]|\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]/,
  Nd: /[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]|\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|[\uD805\uD807][\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]/,
  // Marks
  Mn: /[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]/,
  Mc: /[\u0903-\u0903]|[\u093E-\u0940]|[\u0949-\u094C]|[\u0982-\u0983]|[\u09BE-\u09C0]|[\u09C7-\u09C8]|[\u09CB-\u09CC]|[\u09D7-\u09D7]|[\u0A3E-\u0A40]|[\u0A83-\u0A83]|[\u0ABE-\u0AC0]|[\u0AC9-\u0AC9]|[\u0ACB-\u0ACC]|[\u0B02-\u0B03]|[\u0B3E-\u0B3E]|[\u0B40-\u0B40]|[\u0B47-\u0B48]|[\u0B4B-\u0B4C]|[\u0B57-\u0B57]|[\u0B83-\u0B83]|[\u0BBE-\u0BBF]|[\u0BC1-\u0BC2]|[\u0BC6-\u0BC8]|[\u0BCA-\u0BCC]|[\u0BD7-\u0BD7]|[\u0C01-\u0C03]|[\u0C41-\u0C44]|[\u0C82-\u0C83]|[\u0CBE-\u0CBE]|[\u0CC0-\u0CC4]|[\u0CC7-\u0CC8]|[\u0CCA-\u0CCB]|[\u0CD5-\u0CD6]|[\u0D02-\u0D03]|[\u0D3E-\u0D40]|[\u0D46-\u0D48]|[\u0D4A-\u0D4C]|[\u0D57-\u0D57]|[\u0F3E-\u0F3F]|[\u0F7F-\u0F7F]/,
  // Punctuation, Connector
  Pc: /[_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F]/,
  // Separator, Space
  Zs: /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
  // These two are not real Unicode categories, but our useful for Ohm.
  // L is a combination of all the letter categories.
  // Ltmo is a combination of Lt, Lm, and Lo.
  L: /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
  Ltmo: /[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]|[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F]|\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]|[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/
};
const Lbt = Nbt, Kbt = Jn;
class lo {
  constructor() {
    if (this.constructor === lo)
      throw new Error("PExpr cannot be instantiated -- it's abstract");
  }
  // Set the `source` property to the interval containing the source for this expression.
  withSource(t) {
    return t && (this.source = t.trimmed()), this;
  }
}
const Tbt = Object.create(lo.prototype), Mbt = Object.create(lo.prototype);
class Pbt extends lo {
  constructor(t) {
    super(), this.obj = t;
  }
}
class Ubt extends lo {
  constructor(t, i) {
    super(), this.from = t, this.to = i, this.matchCodePoint = t.length > 1 || i.length > 1;
  }
}
class zbt extends lo {
  constructor(t) {
    super(), this.index = t;
  }
}
class p9 extends lo {
  constructor(t) {
    super(), this.terms = t;
  }
}
class Obt extends p9 {
  constructor(t, i, n) {
    const r = t.rules[i].body;
    super([n, r]), this.superGrammar = t, this.name = i, this.body = n;
  }
}
class Qbt extends p9 {
  constructor(t, i, n, r) {
    const g = t.rules[i].body;
    super([...n, g, ...r]), this.superGrammar = t, this.ruleName = i, this.expansionPos = n.length;
  }
}
class jbt extends lo {
  constructor(t) {
    super(), this.factors = t;
  }
}
class Mv extends lo {
  constructor(t) {
    super(), this.expr = t;
  }
}
let Pv = class extends Mv {
};
class Uv extends Mv {
}
class zv extends Mv {
}
Pv.prototype.operator = "*";
Uv.prototype.operator = "+";
zv.prototype.operator = "?";
Pv.prototype.minNumMatches = 0;
Uv.prototype.minNumMatches = 1;
zv.prototype.minNumMatches = 0;
Pv.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
Uv.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
zv.prototype.maxNumMatches = 1;
class qbt extends lo {
  constructor(t) {
    super(), this.expr = t;
  }
}
class _bt extends lo {
  constructor(t) {
    super(), this.expr = t;
  }
}
class $bt extends lo {
  constructor(t) {
    super(), this.expr = t;
  }
}
class eht extends lo {
  constructor(t, i = []) {
    super(), this.ruleName = t, this.args = i;
  }
  isSyntactic() {
    return Kbt.isSyntactic(this.ruleName);
  }
  // This method just caches the result of `this.toString()` in a non-enumerable property.
  toMemoKey() {
    return this._memoKey || Object.defineProperty(this, "_memoKey", { value: this.toString() }), this._memoKey;
  }
}
class tht extends lo {
  constructor(t) {
    super(), this.category = t, this.pattern = Lbt[t];
  }
}
ji.PExpr = lo;
ji.any = Tbt;
ji.end = Mbt;
ji.Terminal = Pbt;
ji.Range = Ubt;
ji.Param = zbt;
ji.Alt = p9;
ji.Extend = Obt;
ji.Splice = Qbt;
ji.Seq = jbt;
ji.Iter = Mv;
ji.Star = Pv;
ji.Plus = Uv;
ji.Opt = zv;
ji.Not = qbt;
ji.Lookahead = _bt;
ji.Lex = $bt;
ji.Apply = eht;
ji.UnicodeChar = tht;
const iht = Jn, tl = ji;
tl.PExpr.prototype.allowsSkippingPrecedingSpace = iht.abstract(
  "allowsSkippingPrecedingSpace"
);
tl.any.allowsSkippingPrecedingSpace = tl.end.allowsSkippingPrecedingSpace = tl.Apply.prototype.allowsSkippingPrecedingSpace = tl.Terminal.prototype.allowsSkippingPrecedingSpace = tl.Range.prototype.allowsSkippingPrecedingSpace = tl.UnicodeChar.prototype.allowsSkippingPrecedingSpace = function() {
  return !0;
};
tl.Alt.prototype.allowsSkippingPrecedingSpace = tl.Iter.prototype.allowsSkippingPrecedingSpace = tl.Lex.prototype.allowsSkippingPrecedingSpace = tl.Lookahead.prototype.allowsSkippingPrecedingSpace = tl.Not.prototype.allowsSkippingPrecedingSpace = tl.Param.prototype.allowsSkippingPrecedingSpace = tl.Seq.prototype.allowsSkippingPrecedingSpace = function() {
  return !1;
};
function Dl() {
}
Dl.prototype = /* @__PURE__ */ Object.create(null);
Dl.asNamespace = function(e) {
  return e instanceof Dl ? e : Dl.createNamespace(e);
};
Dl.createNamespace = function(e) {
  return Dl.extend(Dl.prototype, e);
};
Dl.extend = function(e, t) {
  if (e !== Dl.prototype && !(e instanceof Dl))
    throw new TypeError("not a Namespace object: " + e);
  const i = Object.create(e, {
    constructor: {
      value: Dl,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  });
  return Object.assign(i, t);
};
Dl.toString = function(e) {
  return Object.prototype.toString.call(e);
};
var hq = Dl;
const { assert: nht } = Jn, rht = hq, ght = ji;
function Ir(e, t) {
  let i;
  return t ? (i = new Error(t.getLineAndColumnMessage() + e), i.shortMessage = e, i.interval = t) : i = new Error(e), i;
}
function oht() {
  return Ir("Interval sources don't match");
}
function lht(e) {
  const t = new Error();
  return Object.defineProperty(t, "message", {
    enumerable: !0,
    get() {
      return e.message;
    }
  }), Object.defineProperty(t, "shortMessage", {
    enumerable: !0,
    get() {
      return "Expected " + e.getExpectedText();
    }
  }), t.interval = e.getInterval(), t;
}
function aht(e, t, i) {
  const n = t ? "Grammar " + e + " is not declared in namespace " + rht.toString(t) : "Undeclared grammar " + e;
  return Ir(n, i);
}
function sht(e, t) {
  return Ir("Grammar " + e.name + " is already declared in this namespace");
}
function Iht(e, t, i) {
  return Ir(
    "Rule " + e + " is not declared in grammar " + t,
    i
  );
}
function cht(e, t, i) {
  return Ir(
    "Cannot override rule " + e + " because it is not declared in " + t,
    i
  );
}
function dht(e, t, i) {
  return Ir(
    "Cannot extend rule " + e + " because it is not declared in " + t,
    i
  );
}
function uht(e, t, i, n) {
  let r = "Duplicate declaration for rule '" + e + "' in grammar '" + t + "'";
  return t !== i && (r += " (originally declared in '" + i + "')"), Ir(r, n);
}
function Cht(e, t, i, n) {
  return Ir(
    "Wrong number of parameters for rule " + e + " (expected " + t + ", got " + i + ")",
    n
  );
}
function Aht(e, t, i, n) {
  return Ir(
    "Wrong number of arguments for rule " + e + " (expected " + t + ", got " + i + ")",
    n
  );
}
function bht(e, t, i) {
  return Ir(
    "Duplicate parameter names in rule " + e + ": " + t.join(", "),
    i
  );
}
function hht(e, t) {
  return Ir(
    "Invalid parameter to rule " + e + ": " + t + " has arity " + t.getArity() + ", but parameter expressions must have arity 1",
    t.source
  );
}
const mht = "NOTE: A _syntactic rule_ is a rule whose name begins with a capital letter. See https://ohmjs.org/d/svl for more details.";
function pht(e, t) {
  return Ir(
    "Cannot apply syntactic rule " + e + " from here (inside a lexical context)",
    t.source
  );
}
function Bht(e) {
  const { ruleName: t } = e;
  return Ir(
    `applySyntactic is for syntactic rules, but '${t}' is a lexical rule. ` + mht,
    e.source
  );
}
function fht(e) {
  return Ir(
    "applySyntactic is not required here (in a syntactic context)",
    e.source
  );
}
function Zht(e, t) {
  return Ir("Incorrect argument type: expected " + e, t.source);
}
function Ght(e) {
  return Ir("'...' can appear at most once in a rule body", e.source);
}
function yht(e) {
  const t = e._node;
  nht(t && t.isNonterminal() && t.ctorName === "escapeChar_unicodeCodePoint");
  const i = e.children.slice(1, -1).map((r) => r.source), n = i[0].coverageWith(...i.slice(1));
  return Ir(
    `U+${n.contents} is not a valid Unicode code point`,
    n
  );
}
function Wht(e, t) {
  const i = t.length > 0 ? t[t.length - 1].args : [];
  let r = "Nullable expression " + e.expr.substituteParams(i) + " is not allowed inside '" + e.operator + "' (possible infinite loop)";
  if (t.length > 0) {
    const g = t.map((o) => new ght.Apply(o.ruleName, o.args)).join(`
`);
    r += `
Application stack (most recent application last):
` + g;
  }
  return Ir(r, e.expr.source);
}
function Sht(e, t, i, n) {
  return Ir(
    "Rule " + e + " involves an alternation which has inconsistent arity (expected " + t + ", got " + i + ")",
    n.source
  );
}
function Vht(e) {
  return Ir("Object pattern has duplicate property names: " + e.join(", "));
}
function wht(e, t, i) {
  return Ir(
    "Attempt to invoke constructor " + t + " with invalid or unexpected arguments"
  );
}
function vht(e) {
  const t = e.map((i) => i.message);
  return Ir(["Errors:"].concat(t).join(`
- `), e[0].interval);
}
function Rht(e, t, i, n) {
  let r = n.slice(0, -1).map((a) => {
    const I = "  " + a[0].name + " > " + a[1];
    return a.length === 3 ? I + " for '" + a[2] + "'" : I;
  }).join(`
`);
  r += `
  ` + t + " > " + e;
  let g = "";
  e === "_iter" && (g = [
    `
NOTE: as of Ohm v16, there is no default action for iteration nodes — see `,
    "  https://ohmjs.org/d/dsa for details."
  ].join(`
`));
  const o = [
    `Missing semantic action for '${e}' in ${i} '${t}'.${g}`,
    "Action stack (most recent call last):",
    r
  ].join(`
`), l = Ir(o);
  return l.name = "missingSemanticAction", l;
}
var Xc = {
  applicationOfSyntacticRuleFromLexicalContext: pht,
  applySyntacticWithLexicalRuleApplication: Bht,
  cannotExtendUndeclaredRule: dht,
  cannotOverrideUndeclaredRule: cht,
  duplicateGrammarDeclaration: sht,
  duplicateParameterNames: bht,
  duplicatePropertyNames: Vht,
  duplicateRuleDeclaration: uht,
  inconsistentArity: Sht,
  incorrectArgumentType: Zht,
  intervalSourcesDontMatch: oht,
  invalidCodePoint: yht,
  invalidConstructorCall: wht,
  invalidParameter: hht,
  grammarSyntaxError: lht,
  kleeneExprHasNullableOperand: Wht,
  missingSemanticAction: Rht,
  multipleSuperSplices: Ght,
  undeclaredGrammar: aht,
  undeclaredRule: Iht,
  unnecessaryExperimentalApplySyntactic: fht,
  wrongNumberOfArguments: Aht,
  wrongNumberOfParameters: Cht,
  throwErrors(e) {
    if (e.length === 1)
      throw e[0];
    if (e.length > 1)
      throw vht(e);
  }
}, uu = {};
(function(e) {
  const t = Jn;
  function i(o) {
    let l = 0;
    return o.map((I) => {
      const c = I.toString();
      return l = Math.max(l, c.length), c;
    }).map((I) => t.padLeft(I, l));
  }
  function n(o, l, a) {
    const I = o.length, c = o.slice(0, a), d = o.slice(a + l.length);
    return (c + l + d).substr(0, I);
  }
  function r(...o) {
    const l = this, { offset: a } = l, { repeatStr: I } = t, c = new t.StringBuffer();
    c.append("Line " + l.lineNum + ", col " + l.colNum + `:
`);
    const d = i([
      l.prevLine == null ? 0 : l.lineNum - 1,
      l.lineNum,
      l.nextLine == null ? 0 : l.lineNum + 1
    ]), C = (p, B, f) => {
      c.append(f + d[p] + " | " + B + `
`);
    };
    l.prevLine != null && C(0, l.prevLine, "  "), C(1, l.line, "> ");
    const A = l.line.length;
    let b = I(" ", A + 1);
    for (let p = 0; p < o.length; ++p) {
      let B = o[p][0], f = o[p][1];
      t.assert(B >= 0 && B <= f, "range start must be >= 0 and <= end");
      const Z = a - l.colNum + 1;
      B = Math.max(0, B - Z), f = Math.min(f - Z, A), b = n(b, I("~", f - B), B);
    }
    const m = 2 + d[1].length + 3;
    return c.append(I(" ", m)), b = n(b, "^", l.colNum - 1), c.append(b.replace(/ +$/, "") + `
`), l.nextLine != null && C(2, l.nextLine, "  "), c.contents();
  }
  let g = [];
  e.awaitBuiltInRules = (o) => {
    g.push(o);
  }, e.announceBuiltInRules = (o) => {
    g.forEach((l) => {
      l(o);
    }), g = null;
  }, e.getLineAndColumn = (o, l) => {
    let a = 1, I = 1, c = 0, d = 0, C = null, A = null, b = -1;
    for (; c < l; ) {
      const B = o.charAt(c++);
      B === `
` ? (a++, I = 1, b = d, d = c) : B !== "\r" && I++;
    }
    let m = o.indexOf(`
`, d);
    if (m === -1)
      m = o.length;
    else {
      const B = o.indexOf(`
`, m + 1);
      C = B === -1 ? o.slice(m) : o.slice(m, B), C = C.replace(/^\r?\n/, "").replace(/\r$/, "");
    }
    b >= 0 && (A = o.slice(b, d).replace(/\r?\n$/, ""));
    const p = o.slice(d, m).replace(/\r$/, "");
    return {
      offset: l,
      lineNum: a,
      colNum: I,
      line: p,
      prevLine: A,
      nextLine: C,
      toString: r
    };
  }, e.getLineAndColumnMessage = function(o, l, ...a) {
    return e.getLineAndColumn(o, l).toString(...a);
  }, e.uniqueId = /* @__PURE__ */ (() => {
    let o = 0;
    return (l) => "" + l + o++;
  })();
})(uu);
const { abstract: Xht, isSyntactic: HY } = Jn, Ad = Xc, Kg = ji, Hht = uu;
let RB;
Hht.awaitBuiltInRules((e) => {
  RB = e;
});
let Zw;
Kg.PExpr.prototype.assertAllApplicationsAreValid = function(e, t) {
  Zw = 0, this._assertAllApplicationsAreValid(e, t);
};
Kg.PExpr.prototype._assertAllApplicationsAreValid = Xht(
  "_assertAllApplicationsAreValid"
);
Kg.any._assertAllApplicationsAreValid = Kg.end._assertAllApplicationsAreValid = Kg.Terminal.prototype._assertAllApplicationsAreValid = Kg.Range.prototype._assertAllApplicationsAreValid = Kg.Param.prototype._assertAllApplicationsAreValid = Kg.UnicodeChar.prototype._assertAllApplicationsAreValid = function(e, t) {
};
Kg.Lex.prototype._assertAllApplicationsAreValid = function(e, t) {
  Zw++, this.expr._assertAllApplicationsAreValid(e, t), Zw--;
};
Kg.Alt.prototype._assertAllApplicationsAreValid = function(e, t) {
  for (let i = 0; i < this.terms.length; i++)
    this.terms[i]._assertAllApplicationsAreValid(e, t);
};
Kg.Seq.prototype._assertAllApplicationsAreValid = function(e, t) {
  for (let i = 0; i < this.factors.length; i++)
    this.factors[i]._assertAllApplicationsAreValid(e, t);
};
Kg.Iter.prototype._assertAllApplicationsAreValid = Kg.Not.prototype._assertAllApplicationsAreValid = Kg.Lookahead.prototype._assertAllApplicationsAreValid = function(e, t) {
  this.expr._assertAllApplicationsAreValid(e, t);
};
Kg.Apply.prototype._assertAllApplicationsAreValid = function(e, t, i = !1) {
  const n = t.rules[this.ruleName], r = HY(e) && Zw === 0;
  if (!n)
    throw Ad.undeclaredRule(this.ruleName, t.name, this.source);
  if (!i && HY(this.ruleName) && !r)
    throw Ad.applicationOfSyntacticRuleFromLexicalContext(this.ruleName, this);
  const g = this.args.length, o = n.formals.length;
  if (g !== o)
    throw Ad.wrongNumberOfArguments(this.ruleName, o, g, this.source);
  const l = RB && n === RB.rules.applySyntactic;
  if (RB && n === RB.rules.caseInsensitive && !(this.args[0] instanceof Kg.Terminal))
    throw Ad.incorrectArgumentType('a Terminal (e.g. "abc")', this.args[0]);
  if (l) {
    const I = this.args[0];
    if (!(I instanceof Kg.Apply))
      throw Ad.incorrectArgumentType("a syntactic rule application", I);
    if (!HY(I.ruleName))
      throw Ad.applySyntacticWithLexicalRuleApplication(I);
    if (r)
      throw Ad.unnecessaryExperimentalApplySyntactic(this);
  }
  this.args.forEach((I) => {
    if (I._assertAllApplicationsAreValid(e, t, l), I.getArity() !== 1)
      throw Ad.invalidParameter(this.ruleName, I);
  });
};
const kht = Jn, mq = Xc, Wo = ji;
Wo.PExpr.prototype.assertChoicesHaveUniformArity = kht.abstract(
  "assertChoicesHaveUniformArity"
);
Wo.any.assertChoicesHaveUniformArity = Wo.end.assertChoicesHaveUniformArity = Wo.Terminal.prototype.assertChoicesHaveUniformArity = Wo.Range.prototype.assertChoicesHaveUniformArity = Wo.Param.prototype.assertChoicesHaveUniformArity = Wo.Lex.prototype.assertChoicesHaveUniformArity = Wo.UnicodeChar.prototype.assertChoicesHaveUniformArity = function(e) {
};
Wo.Alt.prototype.assertChoicesHaveUniformArity = function(e) {
  if (this.terms.length === 0)
    return;
  const t = this.terms[0].getArity();
  for (let i = 0; i < this.terms.length; i++) {
    const n = this.terms[i];
    n.assertChoicesHaveUniformArity();
    const r = n.getArity();
    if (t !== r)
      throw mq.inconsistentArity(e, t, r, n);
  }
};
Wo.Extend.prototype.assertChoicesHaveUniformArity = function(e) {
  const t = this.terms[0].getArity(), i = this.terms[1].getArity();
  if (t !== i)
    throw mq.inconsistentArity(e, i, t, this.terms[0]);
};
Wo.Seq.prototype.assertChoicesHaveUniformArity = function(e) {
  for (let t = 0; t < this.factors.length; t++)
    this.factors[t].assertChoicesHaveUniformArity(e);
};
Wo.Iter.prototype.assertChoicesHaveUniformArity = function(e) {
  this.expr.assertChoicesHaveUniformArity(e);
};
Wo.Not.prototype.assertChoicesHaveUniformArity = function(e) {
};
Wo.Lookahead.prototype.assertChoicesHaveUniformArity = function(e) {
  this.expr.assertChoicesHaveUniformArity(e);
};
Wo.Apply.prototype.assertChoicesHaveUniformArity = function(e) {
};
const Yht = Jn, Fht = Xc, So = ji;
So.PExpr.prototype.assertIteratedExprsAreNotNullable = Yht.abstract(
  "assertIteratedExprsAreNotNullable"
);
So.any.assertIteratedExprsAreNotNullable = So.end.assertIteratedExprsAreNotNullable = So.Terminal.prototype.assertIteratedExprsAreNotNullable = So.Range.prototype.assertIteratedExprsAreNotNullable = So.Param.prototype.assertIteratedExprsAreNotNullable = So.UnicodeChar.prototype.assertIteratedExprsAreNotNullable = function(e) {
};
So.Alt.prototype.assertIteratedExprsAreNotNullable = function(e) {
  for (let t = 0; t < this.terms.length; t++)
    this.terms[t].assertIteratedExprsAreNotNullable(e);
};
So.Seq.prototype.assertIteratedExprsAreNotNullable = function(e) {
  for (let t = 0; t < this.factors.length; t++)
    this.factors[t].assertIteratedExprsAreNotNullable(e);
};
So.Iter.prototype.assertIteratedExprsAreNotNullable = function(e) {
  if (this.expr.assertIteratedExprsAreNotNullable(e), this.expr.isNullable(e))
    throw Fht.kleeneExprHasNullableOperand(this, []);
};
So.Opt.prototype.assertIteratedExprsAreNotNullable = So.Not.prototype.assertIteratedExprsAreNotNullable = So.Lookahead.prototype.assertIteratedExprsAreNotNullable = So.Lex.prototype.assertIteratedExprsAreNotNullable = function(e) {
  this.expr.assertIteratedExprsAreNotNullable(e);
};
So.Apply.prototype.assertIteratedExprsAreNotNullable = function(e) {
  this.args.forEach((t) => {
    t.assertIteratedExprsAreNotNullable(e);
  });
};
const { assert: xht } = Jn, r5 = Xc, oM = uu;
function Go(e, t, i) {
  this.sourceString = e, this.startIdx = t, this.endIdx = i;
}
Go.coverage = function(e, ...t) {
  let { startIdx: i, endIdx: n } = e;
  for (const r of t) {
    if (r.sourceString !== e.sourceString)
      throw r5.intervalSourcesDontMatch();
    i = Math.min(i, r.startIdx), n = Math.max(n, r.endIdx);
  }
  return new Go(e.sourceString, i, n);
};
Go.prototype = {
  coverageWith(...e) {
    return Go.coverage(...e, this);
  },
  collapsedLeft() {
    return new Go(this.sourceString, this.startIdx, this.startIdx);
  },
  collapsedRight() {
    return new Go(this.sourceString, this.endIdx, this.endIdx);
  },
  getLineAndColumn() {
    return oM.getLineAndColumn(this.sourceString, this.startIdx);
  },
  getLineAndColumnMessage() {
    const e = [this.startIdx, this.endIdx];
    return oM.getLineAndColumnMessage(this.sourceString, this.startIdx, e);
  },
  // Returns an array of 0, 1, or 2 intervals that represents the result of the
  // interval difference operation.
  minus(e) {
    if (this.sourceString !== e.sourceString)
      throw r5.intervalSourcesDontMatch();
    return this.startIdx === e.startIdx && this.endIdx === e.endIdx ? [] : this.startIdx < e.startIdx && e.endIdx < this.endIdx ? [
      new Go(this.sourceString, this.startIdx, e.startIdx),
      new Go(this.sourceString, e.endIdx, this.endIdx)
    ] : this.startIdx < e.endIdx && e.endIdx < this.endIdx ? [new Go(this.sourceString, e.endIdx, this.endIdx)] : this.startIdx < e.startIdx && e.startIdx < this.endIdx ? [new Go(this.sourceString, this.startIdx, e.startIdx)] : [this];
  },
  // Returns a new Interval that has the same extent as this one, but which is relative
  // to `that`, an Interval that fully covers this one.
  relativeTo(e) {
    if (this.sourceString !== e.sourceString)
      throw r5.intervalSourcesDontMatch();
    return xht(
      this.startIdx >= e.startIdx && this.endIdx <= e.endIdx,
      "other interval does not cover this one"
    ), new Go(
      this.sourceString,
      this.startIdx - e.startIdx,
      this.endIdx - e.startIdx
    );
  },
  // Returns a new Interval which contains the same contents as this one,
  // but with whitespace trimmed from both ends.
  trimmed() {
    const { contents: e } = this, t = this.startIdx + e.match(/^\s*/)[0].length, i = this.endIdx - e.match(/\s*$/)[0].length;
    return new Go(this.sourceString, t, i);
  },
  subInterval(e, t) {
    const i = this.startIdx + e;
    return new Go(this.sourceString, i, i + t);
  }
};
Object.defineProperties(Go.prototype, {
  contents: {
    get() {
      return this._contents === void 0 && (this._contents = this.sourceString.slice(this.startIdx, this.endIdx)), this._contents;
    },
    enumerable: !0
  },
  length: {
    get() {
      return this.endIdx - this.startIdx;
    },
    enumerable: !0
  }
});
var B9 = Go;
const Dht = B9, f9 = Jn, Jht = "✗", Eht = "✓", Nht = "⋅", Lht = "⇒", Kht = "␉", Tht = "␊", Mht = "␍", g5 = {
  succeeded: 1,
  isRootNode: 2,
  isImplicitSpaces: 4,
  isMemoized: 8,
  isHeadOfLeftRecursion: 16,
  terminatesLR: 32
};
function Pht(e) {
  return f9.repeat(" ", e).join("");
}
function Uht(e, t, i) {
  const n = pq(e.slice(t, t + i));
  return n.length < i ? n + f9.repeat(" ", i - n.length).join("") : n;
}
function pq(e) {
  return typeof e == "string" ? e.replace(/ /g, Nht).replace(/\t/g, Kht).replace(/\n/g, Tht).replace(/\r/g, Mht) : String(e);
}
function Ta(e, t, i, n, r, g, o) {
  this.input = e, this.pos = this.pos1 = t, this.pos2 = i, this.source = new Dht(e, t, i), this.expr = n, this.bindings = g, this.children = o || [], this.terminatingLREntry = null, this._flags = r ? g5.succeeded : 0;
}
Ta.prototype.SKIP = {};
Object.defineProperty(Ta.prototype, "displayString", {
  get() {
    return this.expr.toDisplayString();
  }
});
Object.keys(g5).forEach((e) => {
  const t = g5[e];
  Object.defineProperty(Ta.prototype, e, {
    get() {
      return (this._flags & t) !== 0;
    },
    set(i) {
      i ? this._flags |= t : this._flags &= ~t;
    }
  });
});
Ta.prototype.clone = function() {
  return this.cloneWithExpr(this.expr);
};
Ta.prototype.cloneWithExpr = function(e) {
  const t = new Ta(
    this.input,
    this.pos,
    this.pos2,
    e,
    this.succeeded,
    this.bindings,
    this.children
  );
  return t.isHeadOfLeftRecursion = this.isHeadOfLeftRecursion, t.isImplicitSpaces = this.isImplicitSpaces, t.isMemoized = this.isMemoized, t.isRootNode = this.isRootNode, t.terminatesLR = this.terminatesLR, t.terminatingLREntry = this.terminatingLREntry, t;
};
Ta.prototype.recordLRTermination = function(e, t) {
  this.terminatingLREntry = new Ta(
    this.input,
    this.pos,
    this.pos2,
    this.expr,
    !1,
    [t],
    [e]
  ), this.terminatingLREntry.terminatesLR = !0;
};
Ta.prototype.walk = function(e, t) {
  let i = e;
  typeof i == "function" && (i = { enter: i });
  function n(r, g, o) {
    let l = !0;
    i.enter && i.enter.call(t, r, g, o) === Ta.prototype.SKIP && (l = !1), l && (r.children.forEach((a) => {
      n(a, r, o + 1);
    }), i.exit && i.exit.call(t, r, g, o));
  }
  this.isRootNode ? this.children.forEach((r) => {
    n(r, null, 0);
  }) : n(this, null, 0);
};
Ta.prototype.toString = function() {
  const e = new f9.StringBuffer();
  return this.walk((t, i, n) => {
    if (!t)
      return this.SKIP;
    if (t.expr.constructor.name !== "Alt") {
      if (e.append(Uht(t.input, t.pos, 10) + Pht(n * 2 + 1)), e.append((t.succeeded ? Eht : Jht) + " " + t.displayString), t.isHeadOfLeftRecursion && e.append(" (LR)"), t.succeeded) {
        const g = pq(t.source.contents);
        e.append(" " + Lht + "  "), e.append(typeof g == "string" ? '"' + g + '"' : g);
      }
      e.append(`
`);
    }
  }), e.contents();
};
var Bq = Ta;
const zht = Bq, fq = Jn, Oht = Xc, Z9 = m9, _r = ji, { TerminalNode: EZ } = Z9, { NonterminalNode: Qht } = Z9, { IterationNode: jht } = Z9;
_r.PExpr.prototype.eval = fq.abstract("eval");
_r.any.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = t.next();
  return n ? (e.pushBinding(new EZ(n.length), i), !0) : (e.processFailure(i, this), !1);
};
_r.end.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return t.atEnd() ? (e.pushBinding(new EZ(0), i), !0) : (e.processFailure(i, this), !1);
};
_r.Terminal.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return t.matchString(this.obj) ? (e.pushBinding(new EZ(this.obj.length), i), !0) : (e.processFailure(i, this), !1);
};
_r.Range.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = this.matchCodePoint ? t.nextCodePoint() : t.nextCharCode();
  return n !== void 0 && this.from.codePointAt(0) <= n && n <= this.to.codePointAt(0) ? (e.pushBinding(new EZ(String.fromCodePoint(n).length), i), !0) : (e.processFailure(i, this), !1);
};
_r.Param.prototype.eval = function(e) {
  return e.eval(e.currentApplication().args[this.index]);
};
_r.Lex.prototype.eval = function(e) {
  e.enterLexifiedContext();
  const t = e.eval(this.expr);
  return e.exitLexifiedContext(), t;
};
_r.Alt.prototype.eval = function(e) {
  for (let t = 0; t < this.terms.length; t++)
    if (e.eval(this.terms[t]))
      return !0;
  return !1;
};
_r.Seq.prototype.eval = function(e) {
  for (let t = 0; t < this.factors.length; t++) {
    const i = this.factors[t];
    if (!e.eval(i))
      return !1;
  }
  return !0;
};
_r.Iter.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = this.getArity(), r = [], g = [];
  for (; r.length < n; )
    r.push([]), g.push([]);
  let o = 0, l = i, a;
  for (; o < this.maxNumMatches && e.eval(this.expr); ) {
    if (t.pos === l)
      throw Oht.kleeneExprHasNullableOperand(this, e._applicationStack);
    l = t.pos, o++;
    const C = e._bindings.splice(e._bindings.length - n, n), A = e._bindingOffsets.splice(
      e._bindingOffsets.length - n,
      n
    );
    for (a = 0; a < C.length; a++)
      r[a].push(C[a]), g[a].push(A[a]);
  }
  if (o < this.minNumMatches)
    return !1;
  let I = e.posToOffset(i), c = 0;
  if (o > 0) {
    const C = r[n - 1], A = g[n - 1], b = A[A.length - 1] + C[C.length - 1].matchLength;
    I = g[0][0], c = b - I;
  }
  const d = this instanceof _r.Opt;
  for (a = 0; a < r.length; a++)
    e._bindings.push(
      new jht(r[a], g[a], c, d)
    ), e._bindingOffsets.push(I);
  return !0;
};
_r.Not.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  e.pushFailuresInfo();
  const n = e.eval(this.expr);
  return e.popFailuresInfo(), n ? (e.processFailure(i, this), !1) : (t.pos = i, !0);
};
_r.Lookahead.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos;
  return e.eval(this.expr) ? (t.pos = i, !0) : !1;
};
_r.Apply.prototype.eval = function(e) {
  const t = e.currentApplication(), i = t ? t.args : [], n = this.substituteParams(i), r = e.getCurrentPosInfo();
  if (r.isActive(n))
    return n.handleCycle(e);
  const g = n.toMemoKey(), o = r.memo[g];
  if (o && r.shouldUseMemoizedResult(o)) {
    if (e.hasNecessaryInfo(o))
      return e.useMemoizedResult(e.inputStream.pos, o);
    delete r.memo[g];
  }
  return n.reallyEval(e);
};
_r.Apply.prototype.handleCycle = function(e) {
  const t = e.getCurrentPosInfo(), { currentLeftRecursion: i } = t, n = this.toMemoKey();
  let r = t.memo[n];
  return i && i.headApplication.toMemoKey() === n ? r.updateInvolvedApplicationMemoKeys() : r || (r = t.memoize(n, {
    matchLength: 0,
    examinedLength: 0,
    value: !1,
    rightmostFailureOffset: -1
  }), t.startLeftRecursion(this, r)), e.useMemoizedResult(e.inputStream.pos, r);
};
_r.Apply.prototype.reallyEval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = e.getCurrentPosInfo(), r = e.grammar.rules[this.ruleName], { body: g } = r, { description: o } = r;
  e.enterApplication(n, this), o && e.pushFailuresInfo();
  const l = t.examinedLength;
  t.examinedLength = 0;
  let a = this.evalOnce(g, e);
  const I = n.currentLeftRecursion, c = this.toMemoKey(), d = I && I.headApplication.toMemoKey() === c;
  let C;
  d ? (a = this.growSeedResult(g, e, i, I, a), n.endLeftRecursion(), C = I, C.examinedLength = t.examinedLength - i, C.rightmostFailureOffset = e._getRightmostFailureOffset(), n.memoize(c, C)) : (!I || !I.isInvolved(c)) && (C = n.memoize(c, {
    matchLength: t.pos - i,
    examinedLength: t.examinedLength - i,
    value: a,
    failuresAtRightmostPosition: e.cloneRecordedFailures(),
    rightmostFailureOffset: e._getRightmostFailureOffset()
  }));
  const A = !!a;
  if (o && (e.popFailuresInfo(), A || e.processFailure(i, this), C && (C.failuresAtRightmostPosition = e.cloneRecordedFailures())), e.isTracing() && C) {
    const b = e.getTraceEntry(i, this, A, A ? [a] : []);
    d && (fq.assert(b.terminatingLREntry != null || !A), b.isHeadOfLeftRecursion = !0), C.traceEntry = b;
  }
  return t.examinedLength = Math.max(
    t.examinedLength,
    l
  ), e.exitApplication(n, a), A;
};
_r.Apply.prototype.evalOnce = function(e, t) {
  const { inputStream: i } = t, n = i.pos;
  if (t.eval(e)) {
    const r = e.getArity(), g = t._bindings.splice(t._bindings.length - r, r), o = t._bindingOffsets.splice(t._bindingOffsets.length - r, r), l = i.pos - n;
    return new Qht(this.ruleName, g, o, l);
  } else
    return !1;
};
_r.Apply.prototype.growSeedResult = function(e, t, i, n, r) {
  if (!r)
    return !1;
  const { inputStream: g } = t;
  for (; ; ) {
    if (n.matchLength = g.pos - i, n.value = r, n.failuresAtRightmostPosition = t.cloneRecordedFailures(), t.isTracing()) {
      const o = t.trace[t.trace.length - 1];
      n.traceEntry = new zht(
        t.input,
        i,
        g.pos,
        this,
        !0,
        [r],
        [o.clone()]
      );
    }
    if (g.pos = i, r = this.evalOnce(e, t), g.pos - i <= n.matchLength)
      break;
    t.isTracing() && t.trace.splice(-2, 1);
  }
  return t.isTracing() && n.traceEntry.recordLRTermination(t.trace.pop(), r), g.pos = i + n.matchLength, n.value;
};
_r.UnicodeChar.prototype.eval = function(e) {
  const { inputStream: t } = e, i = t.pos, n = t.next();
  return n && this.pattern.test(n) ? (e.pushBinding(new EZ(n.length), i), !0) : (e.processFailure(i, this), !1);
};
const qht = Jn, il = ji;
il.PExpr.prototype.getArity = qht.abstract("getArity");
il.any.getArity = il.end.getArity = il.Terminal.prototype.getArity = il.Range.prototype.getArity = il.Param.prototype.getArity = il.Apply.prototype.getArity = il.UnicodeChar.prototype.getArity = function() {
  return 1;
};
il.Alt.prototype.getArity = function() {
  return this.terms.length === 0 ? 0 : this.terms[0].getArity();
};
il.Seq.prototype.getArity = function() {
  let e = 0;
  for (let t = 0; t < this.factors.length; t++)
    e += this.factors[t].getArity();
  return e;
};
il.Iter.prototype.getArity = function() {
  return this.expr.getArity();
};
il.Not.prototype.getArity = function() {
  return 0;
};
il.Lookahead.prototype.getArity = il.Lex.prototype.getArity = function() {
  return this.expr.getArity();
};
const _ht = Jn, bg = ji;
function Ks(e, t) {
  const i = {};
  if (e.source && t) {
    const n = e.source.relativeTo(t);
    i.sourceInterval = [n.startIdx, n.endIdx];
  }
  return i;
}
bg.PExpr.prototype.outputRecipe = _ht.abstract("outputRecipe");
bg.any.outputRecipe = function(e, t) {
  return ["any", Ks(this, t)];
};
bg.end.outputRecipe = function(e, t) {
  return ["end", Ks(this, t)];
};
bg.Terminal.prototype.outputRecipe = function(e, t) {
  return ["terminal", Ks(this, t), this.obj];
};
bg.Range.prototype.outputRecipe = function(e, t) {
  return ["range", Ks(this, t), this.from, this.to];
};
bg.Param.prototype.outputRecipe = function(e, t) {
  return ["param", Ks(this, t), this.index];
};
bg.Alt.prototype.outputRecipe = function(e, t) {
  return ["alt", Ks(this, t)].concat(
    this.terms.map((i) => i.outputRecipe(e, t))
  );
};
bg.Extend.prototype.outputRecipe = function(e, t) {
  return this.terms[0].outputRecipe(e, t);
};
bg.Splice.prototype.outputRecipe = function(e, t) {
  const i = this.terms.slice(0, this.expansionPos), n = this.terms.slice(this.expansionPos + 1);
  return [
    "splice",
    Ks(this, t),
    i.map((r) => r.outputRecipe(e, t)),
    n.map((r) => r.outputRecipe(e, t))
  ];
};
bg.Seq.prototype.outputRecipe = function(e, t) {
  return ["seq", Ks(this, t)].concat(
    this.factors.map((i) => i.outputRecipe(e, t))
  );
};
bg.Star.prototype.outputRecipe = bg.Plus.prototype.outputRecipe = bg.Opt.prototype.outputRecipe = bg.Not.prototype.outputRecipe = bg.Lookahead.prototype.outputRecipe = bg.Lex.prototype.outputRecipe = function(e, t) {
  return [
    this.constructor.name.toLowerCase(),
    Ks(this, t),
    this.expr.outputRecipe(e, t)
  ];
};
bg.Apply.prototype.outputRecipe = function(e, t) {
  return [
    "app",
    Ks(this, t),
    this.ruleName,
    this.args.map((i) => i.outputRecipe(e, t))
  ];
};
bg.UnicodeChar.prototype.outputRecipe = function(e, t) {
  return ["unicodeChar", Ks(this, t), this.category];
};
const $ht = Jn, Vo = ji;
Vo.PExpr.prototype.introduceParams = $ht.abstract("introduceParams");
Vo.any.introduceParams = Vo.end.introduceParams = Vo.Terminal.prototype.introduceParams = Vo.Range.prototype.introduceParams = Vo.Param.prototype.introduceParams = Vo.UnicodeChar.prototype.introduceParams = function(e) {
  return this;
};
Vo.Alt.prototype.introduceParams = function(e) {
  return this.terms.forEach((t, i, n) => {
    n[i] = t.introduceParams(e);
  }), this;
};
Vo.Seq.prototype.introduceParams = function(e) {
  return this.factors.forEach((t, i, n) => {
    n[i] = t.introduceParams(e);
  }), this;
};
Vo.Iter.prototype.introduceParams = Vo.Not.prototype.introduceParams = Vo.Lookahead.prototype.introduceParams = Vo.Lex.prototype.introduceParams = function(e) {
  return this.expr = this.expr.introduceParams(e), this;
};
Vo.Apply.prototype.introduceParams = function(e) {
  const t = e.indexOf(this.ruleName);
  if (t >= 0) {
    if (this.args.length > 0)
      throw new Error("Parameterized rules cannot be passed as arguments to another rule.");
    return new Vo.Param(t).withSource(this.source);
  } else
    return this.args.forEach((i, n, r) => {
      r[n] = i.introduceParams(e);
    }), this;
};
const emt = Jn, Tg = ji;
Tg.PExpr.prototype.isNullable = function(e) {
  return this._isNullable(e, /* @__PURE__ */ Object.create(null));
};
Tg.PExpr.prototype._isNullable = emt.abstract("_isNullable");
Tg.any._isNullable = Tg.Range.prototype._isNullable = Tg.Param.prototype._isNullable = Tg.Plus.prototype._isNullable = Tg.UnicodeChar.prototype._isNullable = function(e, t) {
  return !1;
};
Tg.end._isNullable = function(e, t) {
  return !0;
};
Tg.Terminal.prototype._isNullable = function(e, t) {
  return typeof this.obj == "string" ? this.obj === "" : !1;
};
Tg.Alt.prototype._isNullable = function(e, t) {
  return this.terms.length === 0 || this.terms.some((i) => i._isNullable(e, t));
};
Tg.Seq.prototype._isNullable = function(e, t) {
  return this.factors.every((i) => i._isNullable(e, t));
};
Tg.Star.prototype._isNullable = Tg.Opt.prototype._isNullable = Tg.Not.prototype._isNullable = Tg.Lookahead.prototype._isNullable = function(e, t) {
  return !0;
};
Tg.Lex.prototype._isNullable = function(e, t) {
  return this.expr._isNullable(e, t);
};
Tg.Apply.prototype._isNullable = function(e, t) {
  const i = this.toMemoKey();
  if (!Object.prototype.hasOwnProperty.call(t, i)) {
    const { body: n } = e.rules[this.ruleName], r = n.substituteParams(this.args);
    t[i] = !1, t[i] = r._isNullable(e, t);
  }
  return t[i];
};
const tmt = Jn, Mg = ji;
Mg.PExpr.prototype.substituteParams = tmt.abstract("substituteParams");
Mg.any.substituteParams = Mg.end.substituteParams = Mg.Terminal.prototype.substituteParams = Mg.Range.prototype.substituteParams = Mg.UnicodeChar.prototype.substituteParams = function(e) {
  return this;
};
Mg.Param.prototype.substituteParams = function(e) {
  return e[this.index];
};
Mg.Alt.prototype.substituteParams = function(e) {
  return new Mg.Alt(this.terms.map((t) => t.substituteParams(e)));
};
Mg.Seq.prototype.substituteParams = function(e) {
  return new Mg.Seq(this.factors.map((t) => t.substituteParams(e)));
};
Mg.Iter.prototype.substituteParams = Mg.Not.prototype.substituteParams = Mg.Lookahead.prototype.substituteParams = Mg.Lex.prototype.substituteParams = function(e) {
  return new this.constructor(this.expr.substituteParams(e));
};
Mg.Apply.prototype.substituteParams = function(e) {
  if (this.args.length === 0)
    return this;
  {
    const t = this.args.map((i) => i.substituteParams(e));
    return new Mg.Apply(this.ruleName, t);
  }
};
const Zq = Jn, Yo = ji, { copyWithoutDuplicates: imt } = Zq;
function lM(e) {
  return /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
}
function G9(e) {
  const t = /* @__PURE__ */ Object.create(null);
  e.forEach((i) => {
    t[i] = (t[i] || 0) + 1;
  }), Object.keys(t).forEach((i) => {
    if (t[i] <= 1)
      return;
    let n = 1;
    e.forEach((r, g) => {
      r === i && (e[g] = r + "_" + n++);
    });
  });
}
Yo.PExpr.prototype.toArgumentNameList = Zq.abstract("toArgumentNameList");
Yo.any.toArgumentNameList = function(e, t) {
  return ["any"];
};
Yo.end.toArgumentNameList = function(e, t) {
  return ["end"];
};
Yo.Terminal.prototype.toArgumentNameList = function(e, t) {
  return typeof this.obj == "string" && /^[_a-zA-Z0-9]+$/.test(this.obj) ? ["_" + this.obj] : ["$" + e];
};
Yo.Range.prototype.toArgumentNameList = function(e, t) {
  let i = this.from + "_to_" + this.to;
  return lM(i) || (i = "_" + i), lM(i) || (i = "$" + e), [i];
};
Yo.Alt.prototype.toArgumentNameList = function(e, t) {
  const i = this.terms.map(
    (g) => g.toArgumentNameList(e, !0)
  ), n = [], r = i[0].length;
  for (let g = 0; g < r; g++) {
    const o = [];
    for (let a = 0; a < this.terms.length; a++)
      o.push(i[a][g]);
    const l = imt(o);
    n.push(l.join("_or_"));
  }
  return t || G9(n), n;
};
Yo.Seq.prototype.toArgumentNameList = function(e, t) {
  let i = [];
  return this.factors.forEach((n) => {
    const r = n.toArgumentNameList(e, !0);
    i = i.concat(r), e += r.length;
  }), t || G9(i), i;
};
Yo.Iter.prototype.toArgumentNameList = function(e, t) {
  const i = this.expr.toArgumentNameList(e, t).map(
    (n) => n[n.length - 1] === "s" ? n + "es" : n + "s"
  );
  return t || G9(i), i;
};
Yo.Opt.prototype.toArgumentNameList = function(e, t) {
  return this.expr.toArgumentNameList(e, t).map((i) => "opt" + i[0].toUpperCase() + i.slice(1));
};
Yo.Not.prototype.toArgumentNameList = function(e, t) {
  return [];
};
Yo.Lookahead.prototype.toArgumentNameList = Yo.Lex.prototype.toArgumentNameList = function(e, t) {
  return this.expr.toArgumentNameList(e, t);
};
Yo.Apply.prototype.toArgumentNameList = function(e, t) {
  return [this.ruleName];
};
Yo.UnicodeChar.prototype.toArgumentNameList = function(e, t) {
  return ["$" + e];
};
Yo.Param.prototype.toArgumentNameList = function(e, t) {
  return ["param" + this.index];
};
const nmt = Jn, $o = ji;
$o.PExpr.prototype.toDisplayString = nmt.abstract("toDisplayString");
$o.Alt.prototype.toDisplayString = $o.Seq.prototype.toDisplayString = function() {
  return this.source ? this.source.trimmed().contents : "[" + this.constructor.name + "]";
};
$o.any.toDisplayString = $o.end.toDisplayString = $o.Iter.prototype.toDisplayString = $o.Not.prototype.toDisplayString = $o.Lookahead.prototype.toDisplayString = $o.Lex.prototype.toDisplayString = $o.Terminal.prototype.toDisplayString = $o.Range.prototype.toDisplayString = $o.Param.prototype.toDisplayString = function() {
  return this.toString();
};
$o.Apply.prototype.toDisplayString = function() {
  if (this.args.length > 0) {
    const e = this.args.map((t) => t.toDisplayString());
    return this.ruleName + "<" + e.join(",") + ">";
  } else
    return this.ruleName;
};
$o.UnicodeChar.prototype.toDisplayString = function() {
  return "Unicode [" + this.category + "] character";
};
const xI = bq, rmt = Jn, Ql = ji;
Ql.PExpr.prototype.toFailure = rmt.abstract("toFailure");
Ql.any.toFailure = function(e) {
  return new xI(this, "any object", "description");
};
Ql.end.toFailure = function(e) {
  return new xI(this, "end of input", "description");
};
Ql.Terminal.prototype.toFailure = function(e) {
  return new xI(this, this.obj, "string");
};
Ql.Range.prototype.toFailure = function(e) {
  return new xI(this, JSON.stringify(this.from) + ".." + JSON.stringify(this.to), "code");
};
Ql.Not.prototype.toFailure = function(e) {
  const t = this.expr === Ql.any ? "nothing" : "not " + this.expr.toFailure(e);
  return new xI(this, t, "description");
};
Ql.Lookahead.prototype.toFailure = function(e) {
  return this.expr.toFailure(e);
};
Ql.Apply.prototype.toFailure = function(e) {
  let { description: t } = e.rules[this.ruleName];
  return t || (t = (/^[aeiouAEIOU]/.test(this.ruleName) ? "an" : "a") + " " + this.ruleName), new xI(this, t, "description");
};
Ql.UnicodeChar.prototype.toFailure = function(e) {
  return new xI(this, "a Unicode [" + this.category + "] character", "description");
};
Ql.Alt.prototype.toFailure = function(e) {
  const i = "(" + this.terms.map((n) => n.toFailure(e)).join(" or ") + ")";
  return new xI(this, i, "description");
};
Ql.Seq.prototype.toFailure = function(e) {
  const i = "(" + this.factors.map((n) => n.toFailure(e)).join(" ") + ")";
  return new xI(this, i, "description");
};
Ql.Iter.prototype.toFailure = function(e) {
  const t = "(" + this.expr.toFailure(e) + this.operator + ")";
  return new xI(this, t, "description");
};
const gmt = Jn, Cl = ji;
Cl.PExpr.prototype.toString = gmt.abstract("toString");
Cl.any.toString = function() {
  return "any";
};
Cl.end.toString = function() {
  return "end";
};
Cl.Terminal.prototype.toString = function() {
  return JSON.stringify(this.obj);
};
Cl.Range.prototype.toString = function() {
  return JSON.stringify(this.from) + ".." + JSON.stringify(this.to);
};
Cl.Param.prototype.toString = function() {
  return "$" + this.index;
};
Cl.Lex.prototype.toString = function() {
  return "#(" + this.expr.toString() + ")";
};
Cl.Alt.prototype.toString = function() {
  return this.terms.length === 1 ? this.terms[0].toString() : "(" + this.terms.map((e) => e.toString()).join(" | ") + ")";
};
Cl.Seq.prototype.toString = function() {
  return this.factors.length === 1 ? this.factors[0].toString() : "(" + this.factors.map((e) => e.toString()).join(" ") + ")";
};
Cl.Iter.prototype.toString = function() {
  return this.expr + this.operator;
};
Cl.Not.prototype.toString = function() {
  return "~" + this.expr;
};
Cl.Lookahead.prototype.toString = function() {
  return "&" + this.expr;
};
Cl.Apply.prototype.toString = function() {
  if (this.args.length > 0) {
    const e = this.args.map((t) => t.toString());
    return this.ruleName + "<" + e.join(",") + ">";
  } else
    return this.ruleName;
};
Cl.UnicodeChar.prototype.toString = function() {
  return "\\p{" + this.category + "}";
};
var GA = ji;
const omt = bq, { TerminalNode: lmt } = m9, { assert: amt } = Jn, { PExpr: smt, Terminal: Imt } = GA;
class y9 extends smt {
  constructor(t) {
    super(), this.obj = t;
  }
  _getString(t) {
    const i = t.currentApplication().args[this.obj.index];
    return amt(i instanceof Imt, "expected a Terminal expression"), i.obj;
  }
  // Implementation of the PExpr API
  allowsSkippingPrecedingSpace() {
    return !0;
  }
  eval(t) {
    const { inputStream: i } = t, n = i.pos, r = this._getString(t);
    return i.matchString(r, !0) ? (t.pushBinding(new lmt(r.length), n), !0) : (t.processFailure(n, this), !1);
  }
  getArity() {
    return 1;
  }
  substituteParams(t) {
    return new y9(this.obj.substituteParams(t));
  }
  toDisplayString() {
    return this.obj.toDisplayString() + " (case-insensitive)";
  }
  toFailure(t) {
    return new omt(
      this,
      this.obj.toFailure(t) + " (case-insensitive)",
      "description"
    );
  }
  _isNullable(t, i) {
    return this.obj._isNullable(t, i);
  }
}
var cmt = y9;
const dmt = B9;
function Gq(e) {
  this.source = e, this.pos = 0, this.examinedLength = 0;
}
Gq.prototype = {
  atEnd() {
    const e = this.pos === this.source.length;
    return this.examinedLength = Math.max(this.examinedLength, this.pos + 1), e;
  },
  next() {
    const e = this.source[this.pos++];
    return this.examinedLength = Math.max(this.examinedLength, this.pos), e;
  },
  nextCharCode() {
    const e = this.next();
    return e && e.charCodeAt(0);
  },
  nextCodePoint() {
    const e = this.source.slice(this.pos++).codePointAt(0);
    return e > 65535 && (this.pos += 1), this.examinedLength = Math.max(this.examinedLength, this.pos), e;
  },
  matchString(e, t) {
    let i;
    if (t) {
      for (i = 0; i < e.length; i++) {
        const n = this.next(), r = e[i];
        if (n == null || n.toUpperCase() !== r.toUpperCase())
          return !1;
      }
      return !0;
    }
    for (i = 0; i < e.length; i++)
      if (this.next() !== e[i])
        return !1;
    return !0;
  },
  sourceSlice(e, t) {
    return this.source.slice(e, t);
  },
  interval(e, t) {
    return new dmt(this.source, e, t || this.pos);
  }
};
var W9 = Gq;
const o5 = Jn, aM = uu, umt = B9;
function Cu(e, t, i, n, r, g, o) {
  this.matcher = e, this.input = t, this.startExpr = i, this._cst = n, this._cstOffset = r, this._rightmostFailurePosition = g, this._rightmostFailures = o, this.failed() && (o5.defineLazyProperty(this, "message", function() {
    const l = "Expected " + this.getExpectedText();
    return aM.getLineAndColumnMessage(this.input, this.getRightmostFailurePosition()) + l;
  }), o5.defineLazyProperty(this, "shortMessage", function() {
    const l = "expected " + this.getExpectedText(), a = aM.getLineAndColumn(this.input, this.getRightmostFailurePosition());
    return "Line " + a.lineNum + ", col " + a.colNum + ": " + l;
  }));
}
Cu.prototype.succeeded = function() {
  return !!this._cst;
};
Cu.prototype.failed = function() {
  return !this.succeeded();
};
Cu.prototype.getRightmostFailurePosition = function() {
  return this._rightmostFailurePosition;
};
Cu.prototype.getRightmostFailures = function() {
  if (!this._rightmostFailures) {
    this.matcher.setInput(this.input);
    const e = this.matcher._match(
      this.startExpr,
      !1,
      this.getRightmostFailurePosition()
    );
    this._rightmostFailures = e.getRightmostFailures();
  }
  return this._rightmostFailures;
};
Cu.prototype.toString = function() {
  return this.succeeded() ? "[match succeeded]" : "[match failed at position " + this.getRightmostFailurePosition() + "]";
};
Cu.prototype.getExpectedText = function() {
  if (this.succeeded())
    throw new Error("cannot get expected text of a successful MatchResult");
  const e = new o5.StringBuffer();
  let t = this.getRightmostFailures();
  t = t.filter((i) => !i.isFluffy());
  for (let i = 0; i < t.length; i++)
    i > 0 && (i === t.length - 1 ? e.append(t.length > 2 ? ", or " : " or ") : e.append(", ")), e.append(t[i].toString());
  return e.contents();
};
Cu.prototype.getInterval = function() {
  const e = this.getRightmostFailurePosition();
  return new umt(this.input, e, e);
};
var yq = Cu;
function Wq() {
  this.applicationMemoKeyStack = [], this.memo = {}, this.maxExaminedLength = 0, this.maxRightmostFailureOffset = -1, this.currentLeftRecursion = void 0;
}
Wq.prototype = {
  isActive(e) {
    return this.applicationMemoKeyStack.indexOf(e.toMemoKey()) >= 0;
  },
  enter(e) {
    this.applicationMemoKeyStack.push(e.toMemoKey());
  },
  exit() {
    this.applicationMemoKeyStack.pop();
  },
  startLeftRecursion(e, t) {
    t.isLeftRecursion = !0, t.headApplication = e, t.nextLeftRecursion = this.currentLeftRecursion, this.currentLeftRecursion = t;
    const { applicationMemoKeyStack: i } = this, n = i.indexOf(e.toMemoKey()) + 1, r = i.slice(
      n
    );
    t.isInvolved = function(g) {
      return r.indexOf(g) >= 0;
    }, t.updateInvolvedApplicationMemoKeys = function() {
      for (let g = n; g < i.length; g++) {
        const o = i[g];
        this.isInvolved(o) || r.push(o);
      }
    };
  },
  endLeftRecursion() {
    this.currentLeftRecursion = this.currentLeftRecursion.nextLeftRecursion;
  },
  // Note: this method doesn't get called for the "head" of a left recursion -- for LR heads,
  // the memoized result (which starts out being a failure) is always used.
  shouldUseMemoizedResult(e) {
    if (!e.isLeftRecursion)
      return !0;
    const { applicationMemoKeyStack: t } = this;
    for (let i = 0; i < t.length; i++) {
      const n = t[i];
      if (e.isInvolved(n))
        return !1;
    }
    return !0;
  },
  memoize(e, t) {
    return this.memo[e] = t, this.maxExaminedLength = Math.max(this.maxExaminedLength, t.examinedLength), this.maxRightmostFailureOffset = Math.max(
      this.maxRightmostFailureOffset,
      t.rightmostFailureOffset
    ), t;
  },
  clearObsoleteEntries(e, t) {
    if (e + this.maxExaminedLength <= t)
      return;
    const { memo: i } = this;
    this.maxExaminedLength = 0, this.maxRightmostFailureOffset = -1, Object.keys(i).forEach((n) => {
      const r = i[n];
      e + r.examinedLength > t ? delete i[n] : (this.maxExaminedLength = Math.max(this.maxExaminedLength, r.examinedLength), this.maxRightmostFailureOffset = Math.max(
        this.maxRightmostFailureOffset,
        r.rightmostFailureOffset
      ));
    });
  }
};
var Cmt = Wq;
const Amt = W9, bmt = yq, hmt = Cmt, mmt = Bq, l5 = GA, pmt = uu;
let Sq;
pmt.awaitBuiltInRules((e) => {
  Sq = e.rules.applySyntactic.body;
});
const kY = new l5.Apply("spaces");
function Vq(e, t, i) {
  this.matcher = e, this.startExpr = t, this.grammar = e.grammar, this.input = e.input, this.inputStream = new Amt(e.input), this.memoTable = e.memoTable, this._bindings = [], this._bindingOffsets = [], this._applicationStack = [], this._posStack = [0], this.inLexifiedContextStack = [!1], this.rightmostFailurePosition = -1, this._rightmostFailurePositionStack = [], this._recordedFailuresStack = [], i !== void 0 && (this.positionToRecordFailures = i, this.recordedFailures = /* @__PURE__ */ Object.create(null));
}
Vq.prototype = {
  posToOffset(e) {
    return e - this._posStack[this._posStack.length - 1];
  },
  enterApplication(e, t) {
    this._posStack.push(this.inputStream.pos), this._applicationStack.push(t), this.inLexifiedContextStack.push(!1), e.enter(t), this._rightmostFailurePositionStack.push(this.rightmostFailurePosition), this.rightmostFailurePosition = -1;
  },
  exitApplication(e, t) {
    const i = this._posStack.pop();
    this._applicationStack.pop(), this.inLexifiedContextStack.pop(), e.exit(), this.rightmostFailurePosition = Math.max(
      this.rightmostFailurePosition,
      this._rightmostFailurePositionStack.pop()
    ), t && this.pushBinding(t, i);
  },
  enterLexifiedContext() {
    this.inLexifiedContextStack.push(!0);
  },
  exitLexifiedContext() {
    this.inLexifiedContextStack.pop();
  },
  currentApplication() {
    return this._applicationStack[this._applicationStack.length - 1];
  },
  inSyntacticContext() {
    const e = this.currentApplication();
    return e ? e.isSyntactic() && !this.inLexifiedContext() : this.startExpr.factors[0].isSyntactic();
  },
  inLexifiedContext() {
    return this.inLexifiedContextStack[this.inLexifiedContextStack.length - 1];
  },
  skipSpaces() {
    return this.pushFailuresInfo(), this.eval(kY), this.popBinding(), this.popFailuresInfo(), this.inputStream.pos;
  },
  skipSpacesIfInSyntacticContext() {
    return this.inSyntacticContext() ? this.skipSpaces() : this.inputStream.pos;
  },
  maybeSkipSpacesBefore(e) {
    return e.allowsSkippingPrecedingSpace() && e !== kY ? this.skipSpacesIfInSyntacticContext() : this.inputStream.pos;
  },
  pushBinding(e, t) {
    this._bindings.push(e), this._bindingOffsets.push(this.posToOffset(t));
  },
  popBinding() {
    this._bindings.pop(), this._bindingOffsets.pop();
  },
  numBindings() {
    return this._bindings.length;
  },
  truncateBindings(e) {
    for (; this._bindings.length > e; )
      this.popBinding();
  },
  getCurrentPosInfo() {
    return this.getPosInfo(this.inputStream.pos);
  },
  getPosInfo(e) {
    let t = this.memoTable[e];
    return t || (t = this.memoTable[e] = new hmt()), t;
  },
  processFailure(e, t) {
    if (this.rightmostFailurePosition = Math.max(this.rightmostFailurePosition, e), this.recordedFailures && e === this.positionToRecordFailures) {
      const i = this.currentApplication();
      i && (t = t.substituteParams(i.args)), this.recordFailure(t.toFailure(this.grammar), !1);
    }
  },
  recordFailure(e, t) {
    const i = e.toKey();
    this.recordedFailures[i] ? this.recordedFailures[i].isFluffy() && !e.isFluffy() && this.recordedFailures[i].clearFluffy() : this.recordedFailures[i] = t ? e.clone() : e;
  },
  recordFailures(e, t) {
    Object.keys(e).forEach((i) => {
      this.recordFailure(e[i], t);
    });
  },
  cloneRecordedFailures() {
    if (!this.recordedFailures)
      return;
    const e = /* @__PURE__ */ Object.create(null);
    return Object.keys(this.recordedFailures).forEach((t) => {
      e[t] = this.recordedFailures[t].clone();
    }), e;
  },
  getRightmostFailurePosition() {
    return this.rightmostFailurePosition;
  },
  _getRightmostFailureOffset() {
    return this.rightmostFailurePosition >= 0 ? this.posToOffset(this.rightmostFailurePosition) : -1;
  },
  // Returns the memoized trace entry for `expr` at `pos`, if one exists, `null` otherwise.
  getMemoizedTraceEntry(e, t) {
    const i = this.memoTable[e];
    if (i && t instanceof l5.Apply) {
      const n = i.memo[t.toMemoKey()];
      if (n && n.traceEntry) {
        const r = n.traceEntry.cloneWithExpr(t);
        return r.isMemoized = !0, r;
      }
    }
    return null;
  },
  // Returns a new trace entry, with the currently active trace array as its children.
  getTraceEntry(e, t, i, n) {
    if (t instanceof l5.Apply) {
      const r = this.currentApplication(), g = r ? r.args : [];
      t = t.substituteParams(g);
    }
    return this.getMemoizedTraceEntry(e, t) || new mmt(this.input, e, this.inputStream.pos, t, i, n, this.trace);
  },
  isTracing() {
    return !!this.trace;
  },
  hasNecessaryInfo(e) {
    return this.trace && !e.traceEntry ? !1 : this.recordedFailures && this.inputStream.pos + e.rightmostFailureOffset === this.positionToRecordFailures ? !!e.failuresAtRightmostPosition : !0;
  },
  useMemoizedResult(e, t) {
    this.trace && this.trace.push(t.traceEntry);
    const i = this.inputStream.pos + t.rightmostFailureOffset;
    return this.rightmostFailurePosition = Math.max(
      this.rightmostFailurePosition,
      i
    ), this.recordedFailures && this.positionToRecordFailures === i && t.failuresAtRightmostPosition && this.recordFailures(t.failuresAtRightmostPosition, !0), this.inputStream.examinedLength = Math.max(
      this.inputStream.examinedLength,
      t.examinedLength + e
    ), t.value ? (this.inputStream.pos += t.matchLength, this.pushBinding(t.value, e), !0) : !1;
  },
  // Evaluate `expr` and return `true` if it succeeded, `false` otherwise. On success, `bindings`
  // will have `expr.getArity()` more elements than before, and the input stream's position may
  // have increased. On failure, `bindings` and position will be unchanged.
  eval(e) {
    const { inputStream: t } = this, i = this._bindings.length;
    let n;
    this.recordedFailures && (n = this.recordedFailures, this.recordedFailures = /* @__PURE__ */ Object.create(null));
    const r = t.pos, g = this.maybeSkipSpacesBefore(e);
    let o;
    this.trace && (o = this.trace, this.trace = []);
    const l = e.eval(this);
    if (this.trace) {
      const a = this._bindings.slice(i), I = this.getTraceEntry(g, e, l, a);
      I.isImplicitSpaces = e === kY, I.isRootNode = e === this.startExpr, o.push(I), this.trace = o;
    }
    return l ? this.recordedFailures && t.pos === this.positionToRecordFailures && Object.keys(this.recordedFailures).forEach((a) => {
      this.recordedFailures[a].makeFluffy();
    }) : (t.pos = r, this.truncateBindings(i)), this.recordedFailures && this.recordFailures(n, !1), e === Sq && this.skipSpaces(), l;
  },
  getMatchResult() {
    this.eval(this.startExpr);
    let e;
    this.recordedFailures && (e = Object.keys(this.recordedFailures).map(
      (i) => this.recordedFailures[i]
    ));
    const t = this._bindings[0];
    return t && (t.grammar = this.grammar), new bmt(
      this.matcher,
      this.input,
      this.startExpr,
      t,
      this._bindingOffsets[0],
      this.rightmostFailurePosition,
      e
    );
  },
  getTrace() {
    this.trace = [];
    const e = this.getMatchResult(), t = this.trace[this.trace.length - 1];
    return t.result = e, t;
  },
  pushFailuresInfo() {
    this._rightmostFailurePositionStack.push(this.rightmostFailurePosition), this._recordedFailuresStack.push(this.recordedFailures);
  },
  popFailuresInfo() {
    this.rightmostFailurePosition = this._rightmostFailurePositionStack.pop(), this.recordedFailures = this._recordedFailuresStack.pop();
  }
};
var Bmt = Vq;
const fmt = Bmt, sM = GA;
function Au(e) {
  this.grammar = e, this.memoTable = [], this.input = "";
}
Au.prototype.getInput = function() {
  return this.input;
};
Au.prototype.setInput = function(e) {
  return this.input !== e && this.replaceInputRange(0, this.input.length, e), this;
};
Au.prototype.replaceInputRange = function(e, t, i) {
  const n = this.input;
  if (e < 0 || e > n.length || t < 0 || t > n.length || e > t)
    throw new Error("Invalid indices: " + e + " and " + t);
  this.input = n.slice(0, e) + i + n.slice(t);
  const r = this.memoTable.slice(t);
  this.memoTable.length = e;
  for (let g = 0; g < i.length; g++)
    this.memoTable.push(void 0);
  r.forEach(function(g) {
    this.memoTable.push(g);
  }, this);
  for (let g = 0; g < e; g++) {
    const o = this.memoTable[g];
    o && o.clearObsoleteEntries(g, e);
  }
  return this;
};
Au.prototype.match = function(e) {
  return this._match(this._getStartExpr(e), !1);
};
Au.prototype.trace = function(e) {
  return this._match(this._getStartExpr(e), !0);
};
Au.prototype._match = function(e, t, i) {
  const n = new fmt(this, e, i);
  return t ? n.getTrace() : n.getMatchResult();
};
Au.prototype._getStartExpr = function(e) {
  const t = e || this.grammar.defaultStartRule;
  if (!t)
    throw new Error("Missing start rule argument -- the grammar has no default start rule.");
  const i = this.grammar.parseApplication(t);
  return new sM.Seq([i, sM.end]);
};
var Zmt = Au;
const Gmt = W9, { IterationNode: ymt } = m9, Wmt = yq, S9 = Jn, Smt = Xc, wq = uu, XB = [], V9 = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
class vq {
  constructor(t, i, n) {
    this._node = t, this.source = i, this._baseInterval = n, t.isNonterminal() && S9.assert(i === n), this._childWrappers = [];
  }
  toString() {
    return "[semantics wrapper for " + this._node.grammar.name + "]";
  }
  _forgetMemoizedResultFor(t) {
    delete this._node[this._semantics.attributeKeys[t]], this.children.forEach((i) => {
      i._forgetMemoizedResultFor(t);
    });
  }
  // Returns the wrapper of the specified child node. Child wrappers are created lazily and
  // cached in the parent wrapper's `_childWrappers` instance variable.
  child(t) {
    if (!(0 <= t && t < this._node.numChildren()))
      return;
    let i = this._childWrappers[t];
    if (!i) {
      const n = this._node.childAt(t), r = this._node.childOffsets[t], g = this._baseInterval.subInterval(r, n.matchLength), o = n.isNonterminal() ? g : this._baseInterval;
      i = this._childWrappers[t] = this._semantics.wrap(n, g, o);
    }
    return i;
  }
  // Returns an array containing the wrappers of all of the children of the node associated
  // with this wrapper.
  _children() {
    for (let t = 0; t < this._node.numChildren(); t++)
      this.child(t);
    return this._childWrappers;
  }
  // Returns `true` if the CST node associated with this wrapper corresponds to an iteration
  // expression, i.e., a Kleene-*, Kleene-+, or an optional. Returns `false` otherwise.
  isIteration() {
    return this._node.isIteration();
  }
  // Returns `true` if the CST node associated with this wrapper is a terminal node, `false`
  // otherwise.
  isTerminal() {
    return this._node.isTerminal();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node, `false`
  // otherwise.
  isNonterminal() {
    return this._node.isNonterminal();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a syntactic rule, `false` otherwise.
  isSyntactic() {
    return this.isNonterminal() && this._node.isSyntactic();
  }
  // Returns `true` if the CST node associated with this wrapper is a nonterminal node
  // corresponding to a lexical rule, `false` otherwise.
  isLexical() {
    return this.isNonterminal() && this._node.isLexical();
  }
  // Returns `true` if the CST node associated with this wrapper is an iterator node
  // having either one or no child (? operator), `false` otherwise.
  // Otherwise, throws an exception.
  isOptional() {
    return this._node.isOptional();
  }
  // Create a new _iter wrapper in the same semantics as this wrapper.
  iteration(t) {
    const i = t || [], n = i.map((o) => o._node), r = new ymt(n, [], -1, !1), g = this._semantics.wrap(r, null, null);
    return g._childWrappers = i, g;
  }
  // Returns an array containing the children of this CST node.
  get children() {
    return this._children();
  }
  // Returns the name of grammar rule that created this CST node.
  get ctorName() {
    return this._node.ctorName;
  }
  // TODO: Remove this eventually (deprecated in v0.12).
  get interval() {
    throw new Error("The `interval` property is deprecated -- use `source` instead");
  }
  // Returns the number of children of this CST node.
  get numChildren() {
    return this._node.numChildren();
  }
  // Returns the contents of the input stream consumed by this CST node.
  get sourceString() {
    return this.source.contents;
  }
}
function io(e, t) {
  const i = this;
  if (this.grammar = e, this.checkedActionDicts = !1, this.Wrapper = class extends (t ? t.Wrapper : vq) {
    constructor(n, r, g) {
      super(n, r, g), i.checkActionDictsIfHaventAlready(), this._semantics = i;
    }
  }, this.super = t, t) {
    if (!(e.equals(this.super.grammar) || e._inheritsFrom(this.super.grammar)))
      throw new Error(
        "Cannot extend a semantics for grammar '" + this.super.grammar.name + "' for use with grammar '" + e.name + "' (not a sub-grammar)"
      );
    this.operations = Object.create(this.super.operations), this.attributes = Object.create(this.super.attributes), this.attributeKeys = /* @__PURE__ */ Object.create(null);
    for (const n in this.attributes)
      Object.defineProperty(this.attributeKeys, n, {
        value: wq.uniqueId(n)
      });
  } else
    this.operations = /* @__PURE__ */ Object.create(null), this.attributes = /* @__PURE__ */ Object.create(null), this.attributeKeys = /* @__PURE__ */ Object.create(null);
}
io.prototype.toString = function() {
  return "[semantics for " + this.grammar.name + "]";
};
io.prototype.checkActionDictsIfHaventAlready = function() {
  this.checkedActionDicts || (this.checkActionDicts(), this.checkedActionDicts = !0);
};
io.prototype.checkActionDicts = function() {
  let e;
  for (e in this.operations)
    this.operations[e].checkActionDict(this.grammar);
  for (e in this.attributes)
    this.attributes[e].checkActionDict(this.grammar);
};
io.prototype.toRecipe = function(e) {
  function t(n) {
    return n.super !== io.BuiltInSemantics._getSemantics();
  }
  let i = `(function(g) {
`;
  if (t(this)) {
    i += "  var semantics = " + this.super.toRecipe(!0) + "(g";
    const n = this.super.grammar;
    let r = this.grammar;
    for (; r !== n; )
      i += ".superGrammar", r = r.superGrammar;
    i += `);
`, i += "  return g.extendSemantics(semantics)";
  } else
    i += "  return g.createSemantics()";
  return ["Operation", "Attribute"].forEach((n) => {
    const r = this[n.toLowerCase() + "s"];
    Object.keys(r).forEach((g) => {
      const { actionDict: o, formals: l, builtInDefault: a } = r[g];
      let I = g;
      l.length > 0 && (I += "(" + l.join(", ") + ")");
      let c;
      t(this) && this.super[n.toLowerCase() + "s"][g] ? c = "extend" + n : c = "add" + n, i += `
    .` + c + "(" + JSON.stringify(I) + ", {";
      const d = [];
      Object.keys(o).forEach((C) => {
        if (o[C] !== a) {
          let A = o[C].toString().trim();
          A = A.replace(/^.*\(/, "function("), d.push(`
      ` + JSON.stringify(C) + ": " + A);
        }
      }), i += d.join(",") + `
    })`;
    });
  }), i += `;
  })`, e || (i = `(function() {
  var grammar = this.fromRecipe(` + this.grammar.toRecipe() + `);
  var semantics = ` + i + `(grammar);
  return semantics;
});
`), i;
};
function Rq(e, t) {
  if (!io.prototypeGrammar)
    return S9.assert(e.indexOf("(") === -1), {
      name: e,
      formals: []
    };
  const i = io.prototypeGrammar.match(
    e,
    t === "operation" ? "OperationSignature" : "AttributeSignature"
  );
  if (i.failed())
    throw new Error(i.message);
  return io.prototypeGrammarSemantics(i).parse();
}
function Vmt(e, t, i) {
  return function(...n) {
    const g = (this._semantics.operations[t] || this._semantics.attributes[t]).formals.map((o) => this.args[o]);
    if (!this.isIteration() && n.length === 1)
      return i.apply(n[0], g);
    throw Smt.missingSemanticAction(this.ctorName, t, e, XB);
  };
}
io.prototype.addOperationOrAttribute = function(e, t, i) {
  const n = e + "s", r = Rq(t, e), { name: g } = r, { formals: o } = r;
  this.assertNewName(g, e);
  const l = Vmt(e, g, c), a = { _default: l };
  Object.keys(i).forEach((d) => {
    a[d] = i[d];
  });
  const I = e === "operation" ? new Kf(g, o, a, l) : new w9(g, a, l);
  I.checkActionDict(this.grammar), this[n][g] = I;
  function c(...d) {
    const C = this._semantics[n][g];
    if (arguments.length !== C.formals.length)
      throw new Error(
        "Invalid number of arguments passed to " + g + " " + e + " (expected " + C.formals.length + ", got " + arguments.length + ")"
      );
    const A = /* @__PURE__ */ Object.create(null);
    for (const [p, B] of Object.entries(d)) {
      const f = C.formals[p];
      A[f] = B;
    }
    const b = this.args;
    this.args = A;
    const m = C.execute(this._semantics, this);
    return this.args = b, m;
  }
  e === "operation" ? (this.Wrapper.prototype[g] = c, this.Wrapper.prototype[g].toString = function() {
    return "[" + g + " operation]";
  }) : (Object.defineProperty(this.Wrapper.prototype, g, {
    get: c,
    configurable: !0
    // So the property can be deleted.
  }), Object.defineProperty(this.attributeKeys, g, {
    value: wq.uniqueId(g)
  }));
};
io.prototype.extendOperationOrAttribute = function(e, t, i) {
  const n = e + "s";
  if (Rq(t, "attribute"), !(this.super && t in this.super[n]))
    throw new Error(
      "Cannot extend " + e + " '" + t + "': did not inherit an " + e + " with that name"
    );
  if (V9(this[n], t))
    throw new Error("Cannot extend " + e + " '" + t + "' again");
  const r = this[n][t].formals, g = this[n][t].actionDict, o = Object.create(g);
  Object.keys(i).forEach((l) => {
    o[l] = i[l];
  }), this[n][t] = e === "operation" ? new Kf(t, r, o) : new w9(t, o), this[n][t].checkActionDict(this.grammar);
};
io.prototype.assertNewName = function(e, t) {
  if (V9(vq.prototype, e))
    throw new Error("Cannot add " + t + " '" + e + "': that's a reserved name");
  if (e in this.operations)
    throw new Error(
      "Cannot add " + t + " '" + e + "': an operation with that name already exists"
    );
  if (e in this.attributes)
    throw new Error(
      "Cannot add " + t + " '" + e + "': an attribute with that name already exists"
    );
};
io.prototype.wrap = function(e, t, i) {
  const n = i || t;
  return e instanceof this.Wrapper ? e : new this.Wrapper(e, t, n);
};
io.createSemantics = function(e, t) {
  const i = new io(
    e,
    t !== void 0 ? t : io.BuiltInSemantics._getSemantics()
  ), n = function(g) {
    if (!(g instanceof Wmt))
      throw new TypeError(
        "Semantics expected a MatchResult, but got " + S9.unexpectedObjToString(g)
      );
    if (g.failed())
      throw new TypeError("cannot apply Semantics to " + g.toString());
    const o = g._cst;
    if (o.grammar !== e)
      throw new Error(
        "Cannot use a MatchResult from grammar '" + o.grammar.name + "' with a semantics for '" + e.name + "'"
      );
    const l = new Gmt(g.input);
    return i.wrap(o, l.interval(g._cstOffset, g.input.length));
  };
  return n.addOperation = function(r, g) {
    return i.addOperationOrAttribute("operation", r, g), n;
  }, n.extendOperation = function(r, g) {
    return i.extendOperationOrAttribute("operation", r, g), n;
  }, n.addAttribute = function(r, g) {
    return i.addOperationOrAttribute("attribute", r, g), n;
  }, n.extendAttribute = function(r, g) {
    return i.extendOperationOrAttribute("attribute", r, g), n;
  }, n._getActionDict = function(r) {
    const g = i.operations[r] || i.attributes[r];
    if (!g)
      throw new Error(
        '"' + r + '" is not a valid operation or attribute name in this semantics for "' + e.name + '"'
      );
    return g.actionDict;
  }, n._remove = function(r) {
    let g;
    return r in i.operations ? (g = i.operations[r], delete i.operations[r]) : r in i.attributes && (g = i.attributes[r], delete i.attributes[r]), delete i.Wrapper.prototype[r], g;
  }, n.getOperationNames = function() {
    return Object.keys(i.operations);
  }, n.getAttributeNames = function() {
    return Object.keys(i.attributes);
  }, n.getGrammar = function() {
    return i.grammar;
  }, n.toRecipe = function(r) {
    return i.toRecipe(r);
  }, n.toString = i.toString.bind(i), n._getSemantics = function() {
    return i;
  }, n;
};
class Kf {
  constructor(t, i, n, r) {
    this.name = t, this.formals = i, this.actionDict = n, this.builtInDefault = r;
  }
  checkActionDict(t) {
    t._checkTopDownActionDict(this.typeName, this.name, this.actionDict);
  }
  // Execute this operation on the CST node associated with `nodeWrapper` in the context of the
  // given Semantics instance.
  execute(t, i) {
    try {
      const { ctorName: n } = i._node;
      let r = this.actionDict[n];
      return r ? (XB.push([this, n]), r.apply(i, i._children())) : i.isNonterminal() && (r = this.actionDict._nonterminal, r) ? (XB.push([this, "_nonterminal", n]), r.apply(i, i._children())) : (XB.push([this, "default action", n]), this.actionDict._default.apply(i, i._children()));
    } finally {
      XB.pop();
    }
  }
}
Kf.prototype.typeName = "operation";
class w9 extends Kf {
  constructor(t, i, n) {
    super(t, [], i, n);
  }
  execute(t, i) {
    const n = i._node, r = t.attributeKeys[this.name];
    return V9(n, r) || (n[r] = Kf.prototype.execute.call(this, t, i)), n[r];
  }
}
w9.prototype.typeName = "attribute";
var Xq = io;
const wmt = cmt, vmt = Zmt, IM = Xq, cM = Jn, dM = Xc, Gs = GA, uM = ["_iter", "_terminal", "_nonterminal", "_default"];
function CM(e) {
  return Object.keys(e.rules).sort().map((t) => e.rules[t]);
}
const Rmt = (e) => e.replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
function OC(e, t, i, n) {
  if (this.name = e, this.superGrammar = t, this.rules = i, n) {
    if (!(n in i))
      throw new Error(
        "Invalid start rule: '" + n + "' is not a rule in grammar '" + e + "'"
      );
    this.defaultStartRule = n;
  }
}
let Hq, kq;
OC.initApplicationParser = function(e, t) {
  Hq = e, kq = t;
};
OC.prototype = {
  matcher() {
    return new vmt(this);
  },
  // Return true if the grammar is a built-in grammar, otherwise false.
  // NOTE: This might give an unexpected result if called before BuiltInRules is defined!
  isBuiltIn() {
    return this === OC.ProtoBuiltInRules || this === OC.BuiltInRules;
  },
  equals(e) {
    if (this === e)
      return !0;
    if (e == null || this.name !== e.name || this.defaultStartRule !== e.defaultStartRule || !(this.superGrammar === e.superGrammar || this.superGrammar.equals(e.superGrammar)))
      return !1;
    const t = CM(this), i = CM(e);
    return t.length === i.length && t.every((n, r) => n.description === i[r].description && n.formals.join(",") === i[r].formals.join(",") && n.body.toString() === i[r].body.toString());
  },
  match(e, t) {
    const i = this.matcher();
    return i.replaceInputRange(0, 0, e), i.match(t);
  },
  trace(e, t) {
    const i = this.matcher();
    return i.replaceInputRange(0, 0, e), i.trace(t);
  },
  createSemantics() {
    return IM.createSemantics(this);
  },
  extendSemantics(e) {
    return IM.createSemantics(this, e._getSemantics());
  },
  // Check that every key in `actionDict` corresponds to a semantic action, and that it maps to
  // a function of the correct arity. If not, throw an exception.
  _checkTopDownActionDict(e, t, i) {
    const n = [];
    for (const r in i) {
      const g = i[r];
      if (!uM.includes(r) && !(r in this.rules)) {
        n.push(`'${r}' is not a valid semantic action for '${this.name}'`);
        continue;
      }
      if (typeof g != "function") {
        n.push(`'${r}' must be a function in an action dictionary for '${this.name}'`);
        continue;
      }
      const l = g.length, a = this._topDownActionArity(r);
      if (l !== a) {
        let I;
        r === "_iter" || r === "_nonterminal" ? I = `it should use a rest parameter, e.g. \`${r}(...children) {}\`. NOTE: this is new in Ohm v16 — see https://ohmjs.org/d/ati for details.` : I = `expected ${a}, got ${l}`, n.push(`Semantic action '${r}' has the wrong arity: ${I}`);
      }
    }
    if (n.length > 0) {
      const r = n.map((o) => "- " + o), g = new Error(
        [
          `Found errors in the action dictionary of the '${t}' ${e}:`,
          ...r
        ].join(`
`)
      );
      throw g.problems = n, g;
    }
  },
  // Return the expected arity for a semantic action named `actionName`, which
  // is either a rule name or a special action name like '_nonterminal'.
  _topDownActionArity(e) {
    return uM.includes(e) ? 0 : this.rules[e].body.getArity();
  },
  _inheritsFrom(e) {
    let t = this.superGrammar;
    for (; t; ) {
      if (t.equals(e, !0))
        return !0;
      t = t.superGrammar;
    }
    return !1;
  },
  toRecipe(e = void 0) {
    const t = {};
    this.source && (t.source = this.source.contents);
    let i = null;
    this.defaultStartRule && (i = this.defaultStartRule);
    const n = {};
    Object.keys(this.rules).forEach((o) => {
      const l = this.rules[o], { body: a } = l, I = !this.superGrammar || !this.superGrammar.rules[o];
      let c;
      I ? c = "define" : c = a instanceof Gs.Extend ? "extend" : "override";
      const d = {};
      if (l.source && this.source) {
        const b = l.source.relativeTo(this.source);
        d.sourceInterval = [b.startIdx, b.endIdx];
      }
      const C = I ? l.description : null, A = a.outputRecipe(l.formals, this.source);
      n[o] = [
        c,
        // "define"/"extend"/"override"
        d,
        C,
        l.formals,
        A
      ];
    });
    let r = "null";
    e ? r = e : this.superGrammar && !this.superGrammar.isBuiltIn() && (r = this.superGrammar.toRecipe());
    const g = [
      ...["grammar", t, this.name].map(JSON.stringify),
      r,
      ...[i, n].map(JSON.stringify)
    ];
    return Rmt(`[${g.join(",")}]`);
  },
  // TODO: Come up with better names for these methods.
  // TODO: Write the analog of these methods for inherited attributes.
  toOperationActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  },
  toAttributeActionDictionaryTemplate() {
    return this._toOperationOrAttributeActionDictionaryTemplate();
  },
  _toOperationOrAttributeActionDictionaryTemplate() {
    const e = new cM.StringBuffer();
    e.append("{");
    let t = !0;
    for (const i in this.rules) {
      const { body: n } = this.rules[i];
      t ? t = !1 : e.append(","), e.append(`
`), e.append("  "), this.addSemanticActionTemplate(i, n, e);
    }
    return e.append(`
}`), e.contents();
  },
  addSemanticActionTemplate(e, t, i) {
    i.append(e), i.append(": function(");
    const n = this._topDownActionArity(e);
    i.append(cM.repeat("_", n).join(", ")), i.append(`) {
`), i.append("  }");
  },
  // Parse a string which expresses a rule application in this grammar, and return the
  // resulting Apply node.
  parseApplication(e) {
    let t;
    if (e.indexOf("<") === -1)
      t = new Gs.Apply(e);
    else {
      const n = Hq.match(e, "Base_application");
      t = kq(n, {});
    }
    if (!(t.ruleName in this.rules))
      throw dM.undeclaredRule(t.ruleName, this.name);
    const { formals: i } = this.rules[t.ruleName];
    if (i.length !== t.args.length) {
      const { source: n } = this.rules[t.ruleName];
      throw dM.wrongNumberOfParameters(
        t.ruleName,
        i.length,
        t.args.length,
        n
      );
    }
    return t;
  }
};
OC.ProtoBuiltInRules = new OC(
  "ProtoBuiltInRules",
  // name
  void 0,
  // supergrammar
  {
    any: {
      body: Gs.any,
      formals: [],
      description: "any character",
      primitive: !0
    },
    end: {
      body: Gs.end,
      formals: [],
      description: "end of input",
      primitive: !0
    },
    caseInsensitive: {
      body: new wmt(new Gs.Param(0)),
      formals: ["str"],
      primitive: !0
    },
    lower: {
      body: new Gs.UnicodeChar("Ll"),
      formals: [],
      description: "a lowercase letter",
      primitive: !0
    },
    upper: {
      body: new Gs.UnicodeChar("Lu"),
      formals: [],
      description: "an uppercase letter",
      primitive: !0
    },
    // Union of Lt (titlecase), Lm (modifier), and Lo (other), i.e. any letter not in Ll or Lu.
    unicodeLtmo: {
      body: new Gs.UnicodeChar("Ltmo"),
      formals: [],
      description: "a Unicode character in Lt, Lm, or Lo",
      primitive: !0
    },
    // These rules are not truly primitive (they could be written in userland) but are defined
    // here for bootstrapping purposes.
    spaces: {
      body: new Gs.Star(new Gs.Apply("space")),
      formals: []
    },
    space: {
      body: new Gs.Range("\0", " "),
      formals: [],
      description: "a space"
    }
  }
);
var Ov = OC;
const a5 = Ov, Xmt = W9, Yq = Jn, Nd = Xc, Hmt = GA;
function ea(e) {
  this.name = e;
}
ea.prototype.sourceInterval = function(e, t) {
  return this.source.subInterval(e, t - e);
};
ea.prototype.ensureSuperGrammar = function() {
  return this.superGrammar || this.withSuperGrammar(
    // TODO: The conditional expression below is an ugly hack. It's kind of ok because
    // I doubt anyone will ever try to declare a grammar called `BuiltInRules`. Still,
    // we should try to find a better way to do this.
    this.name === "BuiltInRules" ? a5.ProtoBuiltInRules : a5.BuiltInRules
  ), this.superGrammar;
};
ea.prototype.ensureSuperGrammarRuleForOverriding = function(e, t) {
  const i = this.ensureSuperGrammar().rules[e];
  if (!i)
    throw Nd.cannotOverrideUndeclaredRule(e, this.superGrammar.name, t);
  return i;
};
ea.prototype.installOverriddenOrExtendedRule = function(e, t, i, n) {
  const r = Yq.getDuplicates(t);
  if (r.length > 0)
    throw Nd.duplicateParameterNames(e, r, n);
  const g = this.ensureSuperGrammar().rules[e], o = g.formals, l = o ? o.length : 0;
  if (t.length !== l)
    throw Nd.wrongNumberOfParameters(e, l, t.length, n);
  return this.install(e, t, i, g.description, n);
};
ea.prototype.install = function(e, t, i, n, r) {
  return this.rules[e] = {
    body: i.introduceParams(t),
    formals: t,
    description: n,
    source: r
  }, this;
};
ea.prototype.withSuperGrammar = function(e) {
  if (this.superGrammar)
    throw new Error("the super grammar of a GrammarDecl cannot be set more than once");
  return this.superGrammar = e, this.rules = Object.create(e.rules), e.isBuiltIn() || (this.defaultStartRule = e.defaultStartRule), this;
};
ea.prototype.withDefaultStartRule = function(e) {
  return this.defaultStartRule = e, this;
};
ea.prototype.withSource = function(e) {
  return this.source = new Xmt(e).interval(0, e.length), this;
};
ea.prototype.build = function() {
  const e = new a5(
    this.name,
    this.ensureSuperGrammar(),
    this.rules,
    this.defaultStartRule
  ), t = [];
  let i = !1;
  return Object.keys(e.rules).forEach((n) => {
    const { body: r } = e.rules[n];
    try {
      r.assertChoicesHaveUniformArity(n);
    } catch (g) {
      t.push(g);
    }
    try {
      r.assertAllApplicationsAreValid(n, e);
    } catch (g) {
      t.push(g), i = !0;
    }
  }), i || Object.keys(e.rules).forEach((n) => {
    const { body: r } = e.rules[n];
    try {
      r.assertIteratedExprsAreNotNullable(e, []);
    } catch (g) {
      t.push(g);
    }
  }), t.length > 0 && Nd.throwErrors(t), this.source && (e.source = this.source), e;
};
ea.prototype.define = function(e, t, i, n, r) {
  if (this.ensureSuperGrammar(), this.superGrammar.rules[e])
    throw Nd.duplicateRuleDeclaration(e, this.name, this.superGrammar.name, r);
  if (this.rules[e])
    throw Nd.duplicateRuleDeclaration(e, this.name, this.name, r);
  const g = Yq.getDuplicates(t);
  if (g.length > 0)
    throw Nd.duplicateParameterNames(e, g, r);
  return this.install(e, t, i, n, r);
};
ea.prototype.override = function(e, t, i, n, r) {
  return this.ensureSuperGrammarRuleForOverriding(e, r), this.installOverriddenOrExtendedRule(e, t, i, r), this;
};
ea.prototype.extend = function(e, t, i, n, r) {
  if (!this.ensureSuperGrammar().rules[e])
    throw Nd.cannotExtendUndeclaredRule(e, this.superGrammar.name, r);
  const o = new Hmt.Extend(this.superGrammar, e, i);
  return o.source = i.source, this.installOverriddenOrExtendedRule(e, t, o, r), this;
};
var kmt = ea;
const Ymt = Ov, AM = kmt, er = GA;
function Fq() {
}
Fq.prototype = {
  currentDecl: null,
  currentRuleName: null,
  newGrammar(e) {
    return new AM(e);
  },
  grammar(e, t, i, n, r) {
    const g = new AM(t);
    return i && g.withSuperGrammar(
      i instanceof Ymt ? i : this.fromRecipe(i)
    ), n && g.withDefaultStartRule(n), e && e.source && g.withSource(e.source), this.currentDecl = g, Object.keys(r).forEach((o) => {
      this.currentRuleName = o;
      const l = r[o], a = l[0], I = l[1], c = l[2], d = l[3], C = this.fromRecipe(l[4]);
      let A;
      g.source && I && I.sourceInterval && (A = g.source.subInterval(
        I.sourceInterval[0],
        I.sourceInterval[1] - I.sourceInterval[0]
      )), g[a](o, d, C, c, A);
    }), this.currentRuleName = this.currentDecl = null, g.build();
  },
  terminal(e) {
    return new er.Terminal(e);
  },
  range(e, t) {
    return new er.Range(e, t);
  },
  param(e) {
    return new er.Param(e);
  },
  alt(...e) {
    let t = [];
    for (let i of e)
      i instanceof er.PExpr || (i = this.fromRecipe(i)), i instanceof er.Alt ? t = t.concat(i.terms) : t.push(i);
    return t.length === 1 ? t[0] : new er.Alt(t);
  },
  seq(...e) {
    let t = [];
    for (let i of e)
      i instanceof er.PExpr || (i = this.fromRecipe(i)), i instanceof er.Seq ? t = t.concat(i.factors) : t.push(i);
    return t.length === 1 ? t[0] : new er.Seq(t);
  },
  star(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Star(e);
  },
  plus(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Plus(e);
  },
  opt(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Opt(e);
  },
  not(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Not(e);
  },
  la(e) {
    return this.lookahead(e);
  },
  lookahead(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Lookahead(e);
  },
  lex(e) {
    return e instanceof er.PExpr || (e = this.fromRecipe(e)), new er.Lex(e);
  },
  app(e, t) {
    return t && t.length > 0 && (t = t.map(function(i) {
      return i instanceof er.PExpr ? i : this.fromRecipe(i);
    }, this)), new er.Apply(e, t);
  },
  // Note that unlike other methods in this class, this method cannot be used as a
  // convenience constructor. It only works with recipes, because it relies on
  // `this.currentDecl` and `this.currentRuleName` being set.
  splice(e, t) {
    return new er.Splice(
      this.currentDecl.superGrammar,
      this.currentRuleName,
      e.map((i) => this.fromRecipe(i)),
      t.map((i) => this.fromRecipe(i))
    );
  },
  fromRecipe(e) {
    const t = e[0] === "grammar" ? e.slice(1) : e.slice(2), i = this[e[0]](...t), n = e[1];
    return n && n.sourceInterval && this.currentDecl && i.withSource(this.currentDecl.sourceInterval(...n.sourceInterval)), i;
  }
};
var xq = Fq, Fmt = "ohm-js", xmt = "16.6.0", Dmt = "An object-oriented language for parsing and pattern matching", Jmt = "https://github.com/harc/ohm", Emt = [
  "parser",
  "compiler",
  "pattern matching",
  "pattern-matching",
  "ometa",
  "ometa/js",
  "ometa-js",
  "ometajs",
  "rapid",
  "prototyping"
], Nmt = "https://ohmjs.org", Lmt = "https://github.com/harc/ohm/issues", Kmt = "index.js", Tmt = "dist/ohm.esm.js", Mmt = [
  "src",
  "dist",
  "extras",
  "third_party",
  "index.d.ts"
], Pmt = "index.d.ts", Umt = {
  prebootstrap: "bash scripts/prebootstrap",
  bootstrap: "bash scripts/bootstrap --test || (echo 'Bootstrap failed.' && mv -v dist/ohm-grammar.js.old dist/ohm-grammar.js && mv -v dist/built-in-rules.js.old dist/built-in-rules.js && mv -v dist/operations-and-attributes.js.old dist/operations-and-attributes.js)",
  build: "yarn build-debug && webpack --mode=production",
  "build-debug": "webpack --mode=development && yarn build-esm && node scripts/generate-types.mjs",
  "build-esm": "rollup -c rollup.config.mjs",
  clean: "rm -f dist/ohm.js dist/ohm.min.js",
  lint: "eslint . --ignore-path ../.eslintignore",
  format: "prettier . --write --ignore-path ../.prettierignore --config ../.prettierrc && eslint . --ignore-path ../.eslintignore --fix",
  test: "ava && ava --config ava-ts.config.js test/test-typings.ts",
  "test-watch": "ava --watch",
  "pre-commit": "yarn run lint && yarn run build && yarn run test",
  prepublishOnly: "bash scripts/prepublishOnly",
  prepack: "cp ../../README.md . && yarn build",
  postpack: "rm README.md",
  postpublish: "echo '👉  Now go to https://github.com/harc/ohm/releases and create a release.'",
  "unsafe-bootstrap": "bash scripts/bootstrap",
  "update-contributors": "bash scripts/update-contributors",
  watch: "webpack --mode=development --watch"
}, zmt = "MIT", Omt = "Alex Warth <alexwarth@gmail.com> (http://tinlizzie.org/~awarth)", Qmt = [
  "Patrick Dubroy <pdubroy@gmail.com>",
  "Meixian Li <lmeixian@gmail.com>",
  "Marko Röder <m.roeder@photon-software.de>",
  "Tony Garnock-Jones <tonygarnockjones@gmail.com>",
  "Saketh Kasibatla <sake.kasi@gmail.com>",
  "Lionel Landwerlin <llandwerlin@gmail.com>",
  "Jason Merrill <jwmerrill@gmail.com>",
  "Ray Toal <rtoal@lmu.edu>",
  "Yoshiki Ohshima <Yoshiki.Ohshima@acm.org>",
  "megabuz <3299889+megabuz@users.noreply.github.com>",
  "Jonathan Edwards <JonathanMEdwards@gmail.com>",
  "Milan Lajtoš <milan.lajtos@me.com>",
  "Neil Jewers <njjewers@uwaterloo.ca>",
  "stagas <gstagas@gmail.com>",
  "AngryPowman <angrypowman@qq.com>",
  "Arthur Carabott <arthurc@gmail.com>",
  "Casey Olson <casey.m.olson@gmail.com>",
  "Daniel Tomlinson <DanielTomlinson@me.com>",
  "Ian Harris <ian@fofgof.xyz>",
  "Justin Chase <justin.m.chase@gmail.com>",
  "Leslie Ying <acetophore@users.noreply.github.com>",
  "Luca Guzzon <luca.guzzon@gmail.com>",
  "Mike Niebling <(none)>",
  "Patrick Dubroy <patrick@sourcegraph.com>",
  "Pierre Donias <pierre.donias@gmail.com>",
  "Stan Rozenraukh <stan@stanistan.com>",
  "Stephan Seidt <stephan.seidt@gmail.com>",
  "Steve Phillips <steve@tryingtobeawesome.com>",
  "Szymon Kaliski <kaliskiszymon@gmail.com>",
  "Thomas Nyberg <tomnyberg@gmail.com>",
  "Vse Mozhet Byt <vsemozhetbyt@gmail.com>",
  "Wil Chung <10446+iamwilhelm@users.noreply.github.com>",
  "Zachary Sakowitz <zsakowitz@gmail.com>",
  "abego <ub@abego-software.de>",
  "acslk <d_vd415@hotmail.com>",
  "codeZeilen <codeZeilen@users.noreply.github.com>",
  "kassadin <kassadin@foxmail.com>",
  "owch <bowenrainyday@gmail.com>",
  "sfinnie <scott.finnie@gmail.com>"
], jmt = {}, qmt = {
  "@ohm-js/cli": "^1.0.0",
  "@rollup/plugin-commonjs": "^21.0.1",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^13.1.3",
  ava: "^3.15.0",
  "ava-spec": "^1.1.1",
  dedent: "^0.7.0",
  eslint: "^7.9.0",
  "eslint-config-google": "^0.14.0",
  "eslint-plugin-ava": "^11.0.0",
  "eslint-plugin-camelcase-ohm": "^0.2.1",
  "eslint-plugin-no-extension-in-require": "^0.2.0",
  husky: "^4.2.5",
  jsdom: "^9.9.1",
  json: "^9.0.6",
  markscript: "^0.5.0",
  "node-static": "^0.7.11",
  "ohm-grammar-ecmascript": "^1.0.0",
  rollup: "^2.63.0",
  "ts-loader": "^8.0.4",
  "ts-node": "^9.0.0",
  typescript: "^4.0.3",
  "walk-sync": "^2.2.0",
  webpack: "^4.44.2",
  "webpack-cli": "^3.3.12"
}, _mt = {
  node: ">=0.12.1"
}, $mt = {
  name: Fmt,
  version: xmt,
  description: Dmt,
  repository: Jmt,
  keywords: Emt,
  homepage: Nmt,
  bugs: Lmt,
  main: Kmt,
  module: Tmt,
  files: Mmt,
  types: Pmt,
  scripts: Umt,
  license: zmt,
  author: Omt,
  contributors: Qmt,
  dependencies: jmt,
  devDependencies: qmt,
  engines: _mt
}, ept = typeof __GLOBAL_OHM_VERSION__ == "string" ? __GLOBAL_OHM_VERSION__ : $mt.version, NZ = {};
const bM = xq;
function tpt(e) {
  return typeof e == "function" ? e.call(new bM()) : (typeof e == "string" && (e = JSON.parse(e)), new bM().fromRecipe(e));
}
NZ.makeRecipe = tpt;
var { makeRecipe: ipt } = NZ, npt = ipt(["grammar", { source: `BuiltInRules {

  alnum  (an alpha-numeric character)
    = letter
    | digit

  letter  (a letter)
    = lower
    | upper
    | unicodeLtmo

  digit  (a digit)
    = "0".."9"

  hexDigit  (a hexadecimal digit)
    = digit
    | "a".."f"
    | "A".."F"

  ListOf<elem, sep>
    = NonemptyListOf<elem, sep>
    | EmptyListOf<elem, sep>

  NonemptyListOf<elem, sep>
    = elem (sep elem)*

  EmptyListOf<elem, sep>
    = /* nothing */

  listOf<elem, sep>
    = nonemptyListOf<elem, sep>
    | emptyListOf<elem, sep>

  nonemptyListOf<elem, sep>
    = elem (sep elem)*

  emptyListOf<elem, sep>
    = /* nothing */

  // Allows a syntactic rule application within a lexical context.
  applySyntactic<app> = app
}` }, "BuiltInRules", null, null, { alnum: ["define", { sourceInterval: [18, 78] }, "an alpha-numeric character", [], ["alt", { sourceInterval: [60, 78] }, ["app", { sourceInterval: [60, 66] }, "letter", []], ["app", { sourceInterval: [73, 78] }, "digit", []]]], letter: ["define", { sourceInterval: [82, 142] }, "a letter", [], ["alt", { sourceInterval: [107, 142] }, ["app", { sourceInterval: [107, 112] }, "lower", []], ["app", { sourceInterval: [119, 124] }, "upper", []], ["app", { sourceInterval: [131, 142] }, "unicodeLtmo", []]]], digit: ["define", { sourceInterval: [146, 177] }, "a digit", [], ["range", { sourceInterval: [169, 177] }, "0", "9"]], hexDigit: ["define", { sourceInterval: [181, 254] }, "a hexadecimal digit", [], ["alt", { sourceInterval: [219, 254] }, ["app", { sourceInterval: [219, 224] }, "digit", []], ["range", { sourceInterval: [231, 239] }, "a", "f"], ["range", { sourceInterval: [246, 254] }, "A", "F"]]], ListOf: ["define", { sourceInterval: [258, 336] }, null, ["elem", "sep"], ["alt", { sourceInterval: [282, 336] }, ["app", { sourceInterval: [282, 307] }, "NonemptyListOf", [["param", { sourceInterval: [297, 301] }, 0], ["param", { sourceInterval: [303, 306] }, 1]]], ["app", { sourceInterval: [314, 336] }, "EmptyListOf", [["param", { sourceInterval: [326, 330] }, 0], ["param", { sourceInterval: [332, 335] }, 1]]]]], NonemptyListOf: ["define", { sourceInterval: [340, 388] }, null, ["elem", "sep"], ["seq", { sourceInterval: [372, 388] }, ["param", { sourceInterval: [372, 376] }, 0], ["star", { sourceInterval: [377, 388] }, ["seq", { sourceInterval: [378, 386] }, ["param", { sourceInterval: [378, 381] }, 1], ["param", { sourceInterval: [382, 386] }, 0]]]]], EmptyListOf: ["define", { sourceInterval: [392, 434] }, null, ["elem", "sep"], ["seq", { sourceInterval: [438, 438] }]], listOf: ["define", { sourceInterval: [438, 516] }, null, ["elem", "sep"], ["alt", { sourceInterval: [462, 516] }, ["app", { sourceInterval: [462, 487] }, "nonemptyListOf", [["param", { sourceInterval: [477, 481] }, 0], ["param", { sourceInterval: [483, 486] }, 1]]], ["app", { sourceInterval: [494, 516] }, "emptyListOf", [["param", { sourceInterval: [506, 510] }, 0], ["param", { sourceInterval: [512, 515] }, 1]]]]], nonemptyListOf: ["define", { sourceInterval: [520, 568] }, null, ["elem", "sep"], ["seq", { sourceInterval: [552, 568] }, ["param", { sourceInterval: [552, 556] }, 0], ["star", { sourceInterval: [557, 568] }, ["seq", { sourceInterval: [558, 566] }, ["param", { sourceInterval: [558, 561] }, 1], ["param", { sourceInterval: [562, 566] }, 0]]]]], emptyListOf: ["define", { sourceInterval: [572, 682] }, null, ["elem", "sep"], ["seq", { sourceInterval: [685, 685] }]], applySyntactic: ["define", { sourceInterval: [685, 710] }, null, ["app"], ["param", { sourceInterval: [707, 710] }, 0]] }]);
const rpt = Ov;
rpt.BuiltInRules = npt;
var { makeRecipe: gpt } = NZ, opt = gpt(["grammar", { source: `OperationsAndAttributes {

  AttributeSignature =
    name

  OperationSignature =
    name Formals?

  Formals
    = "(" ListOf<name, ","> ")"

  name  (a name)
    = nameFirst nameRest*

  nameFirst
    = "_"
    | letter

  nameRest
    = "_"
    | alnum

}` }, "OperationsAndAttributes", null, "AttributeSignature", { AttributeSignature: ["define", { sourceInterval: [29, 58] }, null, [], ["app", { sourceInterval: [54, 58] }, "name", []]], OperationSignature: ["define", { sourceInterval: [62, 100] }, null, [], ["seq", { sourceInterval: [87, 100] }, ["app", { sourceInterval: [87, 91] }, "name", []], ["opt", { sourceInterval: [92, 100] }, ["app", { sourceInterval: [92, 99] }, "Formals", []]]]], Formals: ["define", { sourceInterval: [104, 143] }, null, [], ["seq", { sourceInterval: [118, 143] }, ["terminal", { sourceInterval: [118, 121] }, "("], ["app", { sourceInterval: [122, 139] }, "ListOf", [["app", { sourceInterval: [129, 133] }, "name", []], ["terminal", { sourceInterval: [135, 138] }, ","]]], ["terminal", { sourceInterval: [140, 143] }, ")"]]], name: ["define", { sourceInterval: [147, 187] }, "a name", [], ["seq", { sourceInterval: [168, 187] }, ["app", { sourceInterval: [168, 177] }, "nameFirst", []], ["star", { sourceInterval: [178, 187] }, ["app", { sourceInterval: [178, 186] }, "nameRest", []]]]], nameFirst: ["define", { sourceInterval: [191, 223] }, null, [], ["alt", { sourceInterval: [207, 223] }, ["terminal", { sourceInterval: [207, 210] }, "_"], ["app", { sourceInterval: [217, 223] }, "letter", []]]], nameRest: ["define", { sourceInterval: [227, 257] }, null, [], ["alt", { sourceInterval: [242, 257] }, ["terminal", { sourceInterval: [242, 245] }, "_"], ["app", { sourceInterval: [252, 257] }, "alnum", []]]] }]);
const Gw = Xq, lpt = uu;
lpt.awaitBuiltInRules((e) => {
  const t = opt;
  apt(e), spt(t);
});
function apt(e) {
  const t = {
    empty() {
      return this.iteration();
    },
    nonEmpty(i, n, r) {
      return this.iteration([i].concat(r.children));
    }
  };
  Gw.BuiltInSemantics = Gw.createSemantics(e, null).addOperation(
    "asIteration",
    {
      emptyListOf: t.empty,
      nonemptyListOf: t.nonEmpty,
      EmptyListOf: t.empty,
      NonemptyListOf: t.nonEmpty
    }
  );
}
function spt(e) {
  Gw.prototypeGrammarSemantics = e.createSemantics().addOperation("parse", {
    AttributeSignature(t) {
      return {
        name: t.parse(),
        formals: []
      };
    },
    OperationSignature(t, i) {
      return {
        name: t.parse(),
        formals: i.children.map((n) => n.parse())[0] || []
      };
    },
    Formals(t, i, n) {
      return i.asIteration().children.map((r) => r.parse());
    },
    name(t, i) {
      return this.sourceString;
    }
  }), Gw.prototypeGrammar = e;
}
var { makeRecipe: Ipt } = NZ, cpt = Ipt(["grammar", { source: `Ohm {

  Grammars
    = Grammar*

  Grammar
    = ident SuperGrammar? "{" Rule* "}"

  SuperGrammar
    = "<:" ident

  Rule
    = ident Formals? ruleDescr? "="  RuleBody  -- define
    | ident Formals?            ":=" OverrideRuleBody  -- override
    | ident Formals?            "+=" RuleBody  -- extend

  RuleBody
    = "|"? NonemptyListOf<TopLevelTerm, "|">

  TopLevelTerm
    = Seq caseName  -- inline
    | Seq

  OverrideRuleBody
    = "|"? NonemptyListOf<OverrideTopLevelTerm, "|">

  OverrideTopLevelTerm
    = "..."  -- superSplice
    | TopLevelTerm

  Formals
    = "<" ListOf<ident, ","> ">"

  Params
    = "<" ListOf<Seq, ","> ">"

  Alt
    = NonemptyListOf<Seq, "|">

  Seq
    = Iter*

  Iter
    = Pred "*"  -- star
    | Pred "+"  -- plus
    | Pred "?"  -- opt
    | Pred

  Pred
    = "~" Lex  -- not
    | "&" Lex  -- lookahead
    | Lex

  Lex
    = "#" Base  -- lex
    | Base

  Base
    = ident Params? ~(ruleDescr? "=" | ":=" | "+=")  -- application
    | oneCharTerminal ".." oneCharTerminal           -- range
    | terminal                                       -- terminal
    | "(" Alt ")"                                    -- paren

  ruleDescr  (a rule description)
    = "(" ruleDescrText ")"

  ruleDescrText
    = (~")" any)*

  caseName
    = "--" (~"\\n" space)* name (~"\\n" space)* ("\\n" | &"}")

  name  (a name)
    = nameFirst nameRest*

  nameFirst
    = "_"
    | letter

  nameRest
    = "_"
    | alnum

  ident  (an identifier)
    = name

  terminal
    = "\\"" terminalChar* "\\""

  oneCharTerminal
    = "\\"" terminalChar "\\""

  terminalChar
    = escapeChar
      | ~"\\\\" ~"\\"" ~"\\n" "\\u{0}".."\\u{10FFFF}"

  escapeChar  (an escape sequence)
    = "\\\\\\\\"                                     -- backslash
    | "\\\\\\""                                     -- doubleQuote
    | "\\\\\\'"                                     -- singleQuote
    | "\\\\b"                                      -- backspace
    | "\\\\n"                                      -- lineFeed
    | "\\\\r"                                      -- carriageReturn
    | "\\\\t"                                      -- tab
    | "\\\\u{" hexDigit hexDigit? hexDigit?
             hexDigit? hexDigit? hexDigit? "}"   -- unicodeCodePoint
    | "\\\\u" hexDigit hexDigit hexDigit hexDigit  -- unicodeEscape
    | "\\\\x" hexDigit hexDigit                    -- hexEscape

  space
   += comment

  comment
    = "//" (~"\\n" any)* &("\\n" | end)  -- singleLine
    | "/*" (~"*/" any)* "*/"  -- multiLine

  tokens = token*

  token = caseName | comment | ident | operator | punctuation | terminal | any

  operator = "<:" | "=" | ":=" | "+=" | "*" | "+" | "?" | "~" | "&"

  punctuation = "<" | ">" | "," | "--"
}` }, "Ohm", null, "Grammars", { Grammars: ["define", { sourceInterval: [9, 32] }, null, [], ["star", { sourceInterval: [24, 32] }, ["app", { sourceInterval: [24, 31] }, "Grammar", []]]], Grammar: ["define", { sourceInterval: [36, 83] }, null, [], ["seq", { sourceInterval: [50, 83] }, ["app", { sourceInterval: [50, 55] }, "ident", []], ["opt", { sourceInterval: [56, 69] }, ["app", { sourceInterval: [56, 68] }, "SuperGrammar", []]], ["terminal", { sourceInterval: [70, 73] }, "{"], ["star", { sourceInterval: [74, 79] }, ["app", { sourceInterval: [74, 78] }, "Rule", []]], ["terminal", { sourceInterval: [80, 83] }, "}"]]], SuperGrammar: ["define", { sourceInterval: [87, 116] }, null, [], ["seq", { sourceInterval: [106, 116] }, ["terminal", { sourceInterval: [106, 110] }, "<:"], ["app", { sourceInterval: [111, 116] }, "ident", []]]], Rule_define: ["define", { sourceInterval: [131, 181] }, null, [], ["seq", { sourceInterval: [131, 170] }, ["app", { sourceInterval: [131, 136] }, "ident", []], ["opt", { sourceInterval: [137, 145] }, ["app", { sourceInterval: [137, 144] }, "Formals", []]], ["opt", { sourceInterval: [146, 156] }, ["app", { sourceInterval: [146, 155] }, "ruleDescr", []]], ["terminal", { sourceInterval: [157, 160] }, "="], ["app", { sourceInterval: [162, 170] }, "RuleBody", []]]], Rule_override: ["define", { sourceInterval: [188, 248] }, null, [], ["seq", { sourceInterval: [188, 235] }, ["app", { sourceInterval: [188, 193] }, "ident", []], ["opt", { sourceInterval: [194, 202] }, ["app", { sourceInterval: [194, 201] }, "Formals", []]], ["terminal", { sourceInterval: [214, 218] }, ":="], ["app", { sourceInterval: [219, 235] }, "OverrideRuleBody", []]]], Rule_extend: ["define", { sourceInterval: [255, 305] }, null, [], ["seq", { sourceInterval: [255, 294] }, ["app", { sourceInterval: [255, 260] }, "ident", []], ["opt", { sourceInterval: [261, 269] }, ["app", { sourceInterval: [261, 268] }, "Formals", []]], ["terminal", { sourceInterval: [281, 285] }, "+="], ["app", { sourceInterval: [286, 294] }, "RuleBody", []]]], Rule: ["define", { sourceInterval: [120, 305] }, null, [], ["alt", { sourceInterval: [131, 305] }, ["app", { sourceInterval: [131, 170] }, "Rule_define", []], ["app", { sourceInterval: [188, 235] }, "Rule_override", []], ["app", { sourceInterval: [255, 294] }, "Rule_extend", []]]], RuleBody: ["define", { sourceInterval: [309, 362] }, null, [], ["seq", { sourceInterval: [324, 362] }, ["opt", { sourceInterval: [324, 328] }, ["terminal", { sourceInterval: [324, 327] }, "|"]], ["app", { sourceInterval: [329, 362] }, "NonemptyListOf", [["app", { sourceInterval: [344, 356] }, "TopLevelTerm", []], ["terminal", { sourceInterval: [358, 361] }, "|"]]]]], TopLevelTerm_inline: ["define", { sourceInterval: [385, 408] }, null, [], ["seq", { sourceInterval: [385, 397] }, ["app", { sourceInterval: [385, 388] }, "Seq", []], ["app", { sourceInterval: [389, 397] }, "caseName", []]]], TopLevelTerm: ["define", { sourceInterval: [366, 418] }, null, [], ["alt", { sourceInterval: [385, 418] }, ["app", { sourceInterval: [385, 397] }, "TopLevelTerm_inline", []], ["app", { sourceInterval: [415, 418] }, "Seq", []]]], OverrideRuleBody: ["define", { sourceInterval: [422, 491] }, null, [], ["seq", { sourceInterval: [445, 491] }, ["opt", { sourceInterval: [445, 449] }, ["terminal", { sourceInterval: [445, 448] }, "|"]], ["app", { sourceInterval: [450, 491] }, "NonemptyListOf", [["app", { sourceInterval: [465, 485] }, "OverrideTopLevelTerm", []], ["terminal", { sourceInterval: [487, 490] }, "|"]]]]], OverrideTopLevelTerm_superSplice: ["define", { sourceInterval: [522, 543] }, null, [], ["terminal", { sourceInterval: [522, 527] }, "..."]], OverrideTopLevelTerm: ["define", { sourceInterval: [495, 562] }, null, [], ["alt", { sourceInterval: [522, 562] }, ["app", { sourceInterval: [522, 527] }, "OverrideTopLevelTerm_superSplice", []], ["app", { sourceInterval: [550, 562] }, "TopLevelTerm", []]]], Formals: ["define", { sourceInterval: [566, 606] }, null, [], ["seq", { sourceInterval: [580, 606] }, ["terminal", { sourceInterval: [580, 583] }, "<"], ["app", { sourceInterval: [584, 602] }, "ListOf", [["app", { sourceInterval: [591, 596] }, "ident", []], ["terminal", { sourceInterval: [598, 601] }, ","]]], ["terminal", { sourceInterval: [603, 606] }, ">"]]], Params: ["define", { sourceInterval: [610, 647] }, null, [], ["seq", { sourceInterval: [623, 647] }, ["terminal", { sourceInterval: [623, 626] }, "<"], ["app", { sourceInterval: [627, 643] }, "ListOf", [["app", { sourceInterval: [634, 637] }, "Seq", []], ["terminal", { sourceInterval: [639, 642] }, ","]]], ["terminal", { sourceInterval: [644, 647] }, ">"]]], Alt: ["define", { sourceInterval: [651, 685] }, null, [], ["app", { sourceInterval: [661, 685] }, "NonemptyListOf", [["app", { sourceInterval: [676, 679] }, "Seq", []], ["terminal", { sourceInterval: [681, 684] }, "|"]]]], Seq: ["define", { sourceInterval: [689, 704] }, null, [], ["star", { sourceInterval: [699, 704] }, ["app", { sourceInterval: [699, 703] }, "Iter", []]]], Iter_star: ["define", { sourceInterval: [719, 736] }, null, [], ["seq", { sourceInterval: [719, 727] }, ["app", { sourceInterval: [719, 723] }, "Pred", []], ["terminal", { sourceInterval: [724, 727] }, "*"]]], Iter_plus: ["define", { sourceInterval: [743, 760] }, null, [], ["seq", { sourceInterval: [743, 751] }, ["app", { sourceInterval: [743, 747] }, "Pred", []], ["terminal", { sourceInterval: [748, 751] }, "+"]]], Iter_opt: ["define", { sourceInterval: [767, 783] }, null, [], ["seq", { sourceInterval: [767, 775] }, ["app", { sourceInterval: [767, 771] }, "Pred", []], ["terminal", { sourceInterval: [772, 775] }, "?"]]], Iter: ["define", { sourceInterval: [708, 794] }, null, [], ["alt", { sourceInterval: [719, 794] }, ["app", { sourceInterval: [719, 727] }, "Iter_star", []], ["app", { sourceInterval: [743, 751] }, "Iter_plus", []], ["app", { sourceInterval: [767, 775] }, "Iter_opt", []], ["app", { sourceInterval: [790, 794] }, "Pred", []]]], Pred_not: ["define", { sourceInterval: [809, 824] }, null, [], ["seq", { sourceInterval: [809, 816] }, ["terminal", { sourceInterval: [809, 812] }, "~"], ["app", { sourceInterval: [813, 816] }, "Lex", []]]], Pred_lookahead: ["define", { sourceInterval: [831, 852] }, null, [], ["seq", { sourceInterval: [831, 838] }, ["terminal", { sourceInterval: [831, 834] }, "&"], ["app", { sourceInterval: [835, 838] }, "Lex", []]]], Pred: ["define", { sourceInterval: [798, 862] }, null, [], ["alt", { sourceInterval: [809, 862] }, ["app", { sourceInterval: [809, 816] }, "Pred_not", []], ["app", { sourceInterval: [831, 838] }, "Pred_lookahead", []], ["app", { sourceInterval: [859, 862] }, "Lex", []]]], Lex_lex: ["define", { sourceInterval: [876, 892] }, null, [], ["seq", { sourceInterval: [876, 884] }, ["terminal", { sourceInterval: [876, 879] }, "#"], ["app", { sourceInterval: [880, 884] }, "Base", []]]], Lex: ["define", { sourceInterval: [866, 903] }, null, [], ["alt", { sourceInterval: [876, 903] }, ["app", { sourceInterval: [876, 884] }, "Lex_lex", []], ["app", { sourceInterval: [899, 903] }, "Base", []]]], Base_application: ["define", { sourceInterval: [918, 979] }, null, [], ["seq", { sourceInterval: [918, 963] }, ["app", { sourceInterval: [918, 923] }, "ident", []], ["opt", { sourceInterval: [924, 931] }, ["app", { sourceInterval: [924, 930] }, "Params", []]], ["not", { sourceInterval: [932, 963] }, ["alt", { sourceInterval: [934, 962] }, ["seq", { sourceInterval: [934, 948] }, ["opt", { sourceInterval: [934, 944] }, ["app", { sourceInterval: [934, 943] }, "ruleDescr", []]], ["terminal", { sourceInterval: [945, 948] }, "="]], ["terminal", { sourceInterval: [951, 955] }, ":="], ["terminal", { sourceInterval: [958, 962] }, "+="]]]]], Base_range: ["define", { sourceInterval: [986, 1041] }, null, [], ["seq", { sourceInterval: [986, 1022] }, ["app", { sourceInterval: [986, 1001] }, "oneCharTerminal", []], ["terminal", { sourceInterval: [1002, 1006] }, ".."], ["app", { sourceInterval: [1007, 1022] }, "oneCharTerminal", []]]], Base_terminal: ["define", { sourceInterval: [1048, 1106] }, null, [], ["app", { sourceInterval: [1048, 1056] }, "terminal", []]], Base_paren: ["define", { sourceInterval: [1113, 1168] }, null, [], ["seq", { sourceInterval: [1113, 1124] }, ["terminal", { sourceInterval: [1113, 1116] }, "("], ["app", { sourceInterval: [1117, 1120] }, "Alt", []], ["terminal", { sourceInterval: [1121, 1124] }, ")"]]], Base: ["define", { sourceInterval: [907, 1168] }, null, [], ["alt", { sourceInterval: [918, 1168] }, ["app", { sourceInterval: [918, 963] }, "Base_application", []], ["app", { sourceInterval: [986, 1022] }, "Base_range", []], ["app", { sourceInterval: [1048, 1056] }, "Base_terminal", []], ["app", { sourceInterval: [1113, 1124] }, "Base_paren", []]]], ruleDescr: ["define", { sourceInterval: [1172, 1231] }, "a rule description", [], ["seq", { sourceInterval: [1210, 1231] }, ["terminal", { sourceInterval: [1210, 1213] }, "("], ["app", { sourceInterval: [1214, 1227] }, "ruleDescrText", []], ["terminal", { sourceInterval: [1228, 1231] }, ")"]]], ruleDescrText: ["define", { sourceInterval: [1235, 1266] }, null, [], ["star", { sourceInterval: [1255, 1266] }, ["seq", { sourceInterval: [1256, 1264] }, ["not", { sourceInterval: [1256, 1260] }, ["terminal", { sourceInterval: [1257, 1260] }, ")"]], ["app", { sourceInterval: [1261, 1264] }, "any", []]]]], caseName: ["define", { sourceInterval: [1270, 1338] }, null, [], ["seq", { sourceInterval: [1285, 1338] }, ["terminal", { sourceInterval: [1285, 1289] }, "--"], ["star", { sourceInterval: [1290, 1304] }, ["seq", { sourceInterval: [1291, 1302] }, ["not", { sourceInterval: [1291, 1296] }, ["terminal", { sourceInterval: [1292, 1296] }, `
`]], ["app", { sourceInterval: [1297, 1302] }, "space", []]]], ["app", { sourceInterval: [1305, 1309] }, "name", []], ["star", { sourceInterval: [1310, 1324] }, ["seq", { sourceInterval: [1311, 1322] }, ["not", { sourceInterval: [1311, 1316] }, ["terminal", { sourceInterval: [1312, 1316] }, `
`]], ["app", { sourceInterval: [1317, 1322] }, "space", []]]], ["alt", { sourceInterval: [1326, 1337] }, ["terminal", { sourceInterval: [1326, 1330] }, `
`], ["lookahead", { sourceInterval: [1333, 1337] }, ["terminal", { sourceInterval: [1334, 1337] }, "}"]]]]], name: ["define", { sourceInterval: [1342, 1382] }, "a name", [], ["seq", { sourceInterval: [1363, 1382] }, ["app", { sourceInterval: [1363, 1372] }, "nameFirst", []], ["star", { sourceInterval: [1373, 1382] }, ["app", { sourceInterval: [1373, 1381] }, "nameRest", []]]]], nameFirst: ["define", { sourceInterval: [1386, 1418] }, null, [], ["alt", { sourceInterval: [1402, 1418] }, ["terminal", { sourceInterval: [1402, 1405] }, "_"], ["app", { sourceInterval: [1412, 1418] }, "letter", []]]], nameRest: ["define", { sourceInterval: [1422, 1452] }, null, [], ["alt", { sourceInterval: [1437, 1452] }, ["terminal", { sourceInterval: [1437, 1440] }, "_"], ["app", { sourceInterval: [1447, 1452] }, "alnum", []]]], ident: ["define", { sourceInterval: [1456, 1489] }, "an identifier", [], ["app", { sourceInterval: [1485, 1489] }, "name", []]], terminal: ["define", { sourceInterval: [1493, 1531] }, null, [], ["seq", { sourceInterval: [1508, 1531] }, ["terminal", { sourceInterval: [1508, 1512] }, '"'], ["star", { sourceInterval: [1513, 1526] }, ["app", { sourceInterval: [1513, 1525] }, "terminalChar", []]], ["terminal", { sourceInterval: [1527, 1531] }, '"']]], oneCharTerminal: ["define", { sourceInterval: [1535, 1579] }, null, [], ["seq", { sourceInterval: [1557, 1579] }, ["terminal", { sourceInterval: [1557, 1561] }, '"'], ["app", { sourceInterval: [1562, 1574] }, "terminalChar", []], ["terminal", { sourceInterval: [1575, 1579] }, '"']]], terminalChar: ["define", { sourceInterval: [1583, 1660] }, null, [], ["alt", { sourceInterval: [1602, 1660] }, ["app", { sourceInterval: [1602, 1612] }, "escapeChar", []], ["seq", { sourceInterval: [1621, 1660] }, ["not", { sourceInterval: [1621, 1626] }, ["terminal", { sourceInterval: [1622, 1626] }, "\\"]], ["not", { sourceInterval: [1627, 1632] }, ["terminal", { sourceInterval: [1628, 1632] }, '"']], ["not", { sourceInterval: [1633, 1638] }, ["terminal", { sourceInterval: [1634, 1638] }, `
`]], ["range", { sourceInterval: [1639, 1660] }, "\0", "􏿿"]]]], escapeChar_backslash: ["define", { sourceInterval: [1703, 1758] }, null, [], ["terminal", { sourceInterval: [1703, 1709] }, "\\\\"]], escapeChar_doubleQuote: ["define", { sourceInterval: [1765, 1822] }, null, [], ["terminal", { sourceInterval: [1765, 1771] }, '\\"']], escapeChar_singleQuote: ["define", { sourceInterval: [1829, 1886] }, null, [], ["terminal", { sourceInterval: [1829, 1835] }, "\\'"]], escapeChar_backspace: ["define", { sourceInterval: [1893, 1948] }, null, [], ["terminal", { sourceInterval: [1893, 1898] }, "\\b"]], escapeChar_lineFeed: ["define", { sourceInterval: [1955, 2009] }, null, [], ["terminal", { sourceInterval: [1955, 1960] }, "\\n"]], escapeChar_carriageReturn: ["define", { sourceInterval: [2016, 2076] }, null, [], ["terminal", { sourceInterval: [2016, 2021] }, "\\r"]], escapeChar_tab: ["define", { sourceInterval: [2083, 2132] }, null, [], ["terminal", { sourceInterval: [2083, 2088] }, "\\t"]], escapeChar_unicodeCodePoint: ["define", { sourceInterval: [2139, 2243] }, null, [], ["seq", { sourceInterval: [2139, 2221] }, ["terminal", { sourceInterval: [2139, 2145] }, "\\u{"], ["app", { sourceInterval: [2146, 2154] }, "hexDigit", []], ["opt", { sourceInterval: [2155, 2164] }, ["app", { sourceInterval: [2155, 2163] }, "hexDigit", []]], ["opt", { sourceInterval: [2165, 2174] }, ["app", { sourceInterval: [2165, 2173] }, "hexDigit", []]], ["opt", { sourceInterval: [2188, 2197] }, ["app", { sourceInterval: [2188, 2196] }, "hexDigit", []]], ["opt", { sourceInterval: [2198, 2207] }, ["app", { sourceInterval: [2198, 2206] }, "hexDigit", []]], ["opt", { sourceInterval: [2208, 2217] }, ["app", { sourceInterval: [2208, 2216] }, "hexDigit", []]], ["terminal", { sourceInterval: [2218, 2221] }, "}"]]], escapeChar_unicodeEscape: ["define", { sourceInterval: [2250, 2309] }, null, [], ["seq", { sourceInterval: [2250, 2291] }, ["terminal", { sourceInterval: [2250, 2255] }, "\\u"], ["app", { sourceInterval: [2256, 2264] }, "hexDigit", []], ["app", { sourceInterval: [2265, 2273] }, "hexDigit", []], ["app", { sourceInterval: [2274, 2282] }, "hexDigit", []], ["app", { sourceInterval: [2283, 2291] }, "hexDigit", []]]], escapeChar_hexEscape: ["define", { sourceInterval: [2316, 2371] }, null, [], ["seq", { sourceInterval: [2316, 2339] }, ["terminal", { sourceInterval: [2316, 2321] }, "\\x"], ["app", { sourceInterval: [2322, 2330] }, "hexDigit", []], ["app", { sourceInterval: [2331, 2339] }, "hexDigit", []]]], escapeChar: ["define", { sourceInterval: [1664, 2371] }, "an escape sequence", [], ["alt", { sourceInterval: [1703, 2371] }, ["app", { sourceInterval: [1703, 1709] }, "escapeChar_backslash", []], ["app", { sourceInterval: [1765, 1771] }, "escapeChar_doubleQuote", []], ["app", { sourceInterval: [1829, 1835] }, "escapeChar_singleQuote", []], ["app", { sourceInterval: [1893, 1898] }, "escapeChar_backspace", []], ["app", { sourceInterval: [1955, 1960] }, "escapeChar_lineFeed", []], ["app", { sourceInterval: [2016, 2021] }, "escapeChar_carriageReturn", []], ["app", { sourceInterval: [2083, 2088] }, "escapeChar_tab", []], ["app", { sourceInterval: [2139, 2221] }, "escapeChar_unicodeCodePoint", []], ["app", { sourceInterval: [2250, 2291] }, "escapeChar_unicodeEscape", []], ["app", { sourceInterval: [2316, 2339] }, "escapeChar_hexEscape", []]]], space: ["extend", { sourceInterval: [2375, 2394] }, null, [], ["app", { sourceInterval: [2387, 2394] }, "comment", []]], comment_singleLine: ["define", { sourceInterval: [2412, 2458] }, null, [], ["seq", { sourceInterval: [2412, 2443] }, ["terminal", { sourceInterval: [2412, 2416] }, "//"], ["star", { sourceInterval: [2417, 2429] }, ["seq", { sourceInterval: [2418, 2427] }, ["not", { sourceInterval: [2418, 2423] }, ["terminal", { sourceInterval: [2419, 2423] }, `
`]], ["app", { sourceInterval: [2424, 2427] }, "any", []]]], ["lookahead", { sourceInterval: [2430, 2443] }, ["alt", { sourceInterval: [2432, 2442] }, ["terminal", { sourceInterval: [2432, 2436] }, `
`], ["app", { sourceInterval: [2439, 2442] }, "end", []]]]]], comment_multiLine: ["define", { sourceInterval: [2465, 2501] }, null, [], ["seq", { sourceInterval: [2465, 2487] }, ["terminal", { sourceInterval: [2465, 2469] }, "/*"], ["star", { sourceInterval: [2470, 2482] }, ["seq", { sourceInterval: [2471, 2480] }, ["not", { sourceInterval: [2471, 2476] }, ["terminal", { sourceInterval: [2472, 2476] }, "*/"]], ["app", { sourceInterval: [2477, 2480] }, "any", []]]], ["terminal", { sourceInterval: [2483, 2487] }, "*/"]]], comment: ["define", { sourceInterval: [2398, 2501] }, null, [], ["alt", { sourceInterval: [2412, 2501] }, ["app", { sourceInterval: [2412, 2443] }, "comment_singleLine", []], ["app", { sourceInterval: [2465, 2487] }, "comment_multiLine", []]]], tokens: ["define", { sourceInterval: [2505, 2520] }, null, [], ["star", { sourceInterval: [2514, 2520] }, ["app", { sourceInterval: [2514, 2519] }, "token", []]]], token: ["define", { sourceInterval: [2524, 2600] }, null, [], ["alt", { sourceInterval: [2532, 2600] }, ["app", { sourceInterval: [2532, 2540] }, "caseName", []], ["app", { sourceInterval: [2543, 2550] }, "comment", []], ["app", { sourceInterval: [2553, 2558] }, "ident", []], ["app", { sourceInterval: [2561, 2569] }, "operator", []], ["app", { sourceInterval: [2572, 2583] }, "punctuation", []], ["app", { sourceInterval: [2586, 2594] }, "terminal", []], ["app", { sourceInterval: [2597, 2600] }, "any", []]]], operator: ["define", { sourceInterval: [2604, 2669] }, null, [], ["alt", { sourceInterval: [2615, 2669] }, ["terminal", { sourceInterval: [2615, 2619] }, "<:"], ["terminal", { sourceInterval: [2622, 2625] }, "="], ["terminal", { sourceInterval: [2628, 2632] }, ":="], ["terminal", { sourceInterval: [2635, 2639] }, "+="], ["terminal", { sourceInterval: [2642, 2645] }, "*"], ["terminal", { sourceInterval: [2648, 2651] }, "+"], ["terminal", { sourceInterval: [2654, 2657] }, "?"], ["terminal", { sourceInterval: [2660, 2663] }, "~"], ["terminal", { sourceInterval: [2666, 2669] }, "&"]]], punctuation: ["define", { sourceInterval: [2673, 2709] }, null, [], ["alt", { sourceInterval: [2687, 2709] }, ["terminal", { sourceInterval: [2687, 2690] }, "<"], ["terminal", { sourceInterval: [2693, 2696] }, ">"], ["terminal", { sourceInterval: [2699, 2702] }, ","], ["terminal", { sourceInterval: [2705, 2709] }, "--"]]] }]);
const dpt = xq, v9 = Ov, s5 = hq, Dq = Jn, HB = Xc, R9 = GA, X9 = uu, upt = ept, { makeRecipe: Cpt } = NZ;
let Qv;
const YY = Object.create(R9.PExpr.prototype), Apt = (e) => !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
function H9(e, t, i) {
  const n = new dpt();
  let r, g, o, l = !1;
  return (i || Qv).createSemantics().addOperation("visit", {
    Grammars(c) {
      return c.children.map((d) => d.visit());
    },
    Grammar(c, d, C, A, b) {
      const m = c.visit();
      r = n.newGrammar(m, t), d.child(0) && d.child(0).visit(), A.children.map((B) => B.visit());
      const p = r.build();
      if (p.source = this.source.trimmed(), m in t)
        throw HB.duplicateGrammarDeclaration(p, t);
      return t[m] = p, p;
    },
    SuperGrammar(c, d) {
      const C = d.visit();
      if (C === "null")
        r.withSuperGrammar(null);
      else {
        if (!t || !(C in t))
          throw HB.undeclaredGrammar(C, t, d.source);
        r.withSuperGrammar(t[C]);
      }
    },
    Rule_define(c, d, C, A, b) {
      g = c.visit(), o = d.children.map((f) => f.visit())[0] || [], !r.defaultStartRule && r.ensureSuperGrammar() !== v9.ProtoBuiltInRules && r.withDefaultStartRule(g);
      const m = b.visit(), p = C.children.map((f) => f.visit())[0], B = this.source.trimmed();
      return r.define(g, o, m, p, B);
    },
    Rule_override(c, d, C, A) {
      g = c.visit(), o = d.children.map((p) => p.visit())[0] || [];
      const b = this.source.trimmed();
      r.ensureSuperGrammarRuleForOverriding(g, b), l = !0;
      const m = A.visit();
      return l = !1, r.override(g, o, m, null, b);
    },
    Rule_extend(c, d, C, A) {
      g = c.visit(), o = d.children.map((p) => p.visit())[0] || [];
      const b = A.visit(), m = this.source.trimmed();
      return r.extend(g, o, b, null, m);
    },
    RuleBody(c, d) {
      return n.alt(...d.visit()).withSource(this.source);
    },
    OverrideRuleBody(c, d) {
      const C = d.visit(), A = C.indexOf(YY);
      if (A >= 0) {
        const b = C.slice(0, A), m = C.slice(A + 1);
        return m.forEach((p) => {
          if (p === YY)
            throw HB.multipleSuperSplices(p);
        }), new R9.Splice(
          r.superGrammar,
          g,
          b,
          m
        ).withSource(this.source);
      } else
        return n.alt(...C).withSource(this.source);
    },
    Formals(c, d, C) {
      return d.visit();
    },
    Params(c, d, C) {
      return d.visit();
    },
    Alt(c) {
      return n.alt(...c.visit()).withSource(this.source);
    },
    TopLevelTerm_inline(c, d) {
      const C = g + "_" + d.visit(), A = c.visit(), b = this.source.trimmed(), m = !(r.superGrammar && r.superGrammar.rules[C]);
      l && !m ? r.override(C, o, A, null, b) : r.define(C, o, A, null, b);
      const p = o.map((B) => n.app(B));
      return n.app(C, p).withSource(A.source);
    },
    OverrideTopLevelTerm_superSplice(c) {
      return YY;
    },
    Seq(c) {
      return n.seq(...c.children.map((d) => d.visit())).withSource(this.source);
    },
    Iter_star(c, d) {
      return n.star(c.visit()).withSource(this.source);
    },
    Iter_plus(c, d) {
      return n.plus(c.visit()).withSource(this.source);
    },
    Iter_opt(c, d) {
      return n.opt(c.visit()).withSource(this.source);
    },
    Pred_not(c, d) {
      return n.not(d.visit()).withSource(this.source);
    },
    Pred_lookahead(c, d) {
      return n.lookahead(d.visit()).withSource(this.source);
    },
    Lex_lex(c, d) {
      return n.lex(d.visit()).withSource(this.source);
    },
    Base_application(c, d) {
      const C = d.children.map((A) => A.visit())[0] || [];
      return n.app(c.visit(), C).withSource(this.source);
    },
    Base_range(c, d, C) {
      return n.range(c.visit(), C.visit()).withSource(this.source);
    },
    Base_terminal(c) {
      return n.terminal(c.visit()).withSource(this.source);
    },
    Base_paren(c, d, C) {
      return d.visit();
    },
    ruleDescr(c, d, C) {
      return d.visit();
    },
    ruleDescrText(c) {
      return this.sourceString.trim();
    },
    caseName(c, d, C, A, b) {
      return C.visit();
    },
    name(c, d) {
      return this.sourceString;
    },
    nameFirst(c) {
    },
    nameRest(c) {
    },
    terminal(c, d, C) {
      return d.children.map((A) => A.visit()).join("");
    },
    oneCharTerminal(c, d, C) {
      return d.visit();
    },
    escapeChar(c) {
      try {
        return Dq.unescapeCodePoint(this.sourceString);
      } catch (d) {
        throw d instanceof RangeError && d.message.startsWith("Invalid code point ") ? HB.invalidCodePoint(c) : d;
      }
    },
    NonemptyListOf(c, d, C) {
      return [c.visit()].concat(C.children.map((A) => A.visit()));
    },
    EmptyListOf() {
      return [];
    },
    _terminal() {
      return this.sourceString;
    }
  })(e).visit();
}
function bpt(e, t) {
  const i = Qv.match(e, "Grammars");
  if (i.failed())
    throw HB.grammarSyntaxError(i);
  return H9(i, t);
}
function hpt(e, t) {
  const i = Jq(e, t), n = Object.keys(i);
  if (n.length === 0)
    throw new Error("Missing grammar definition");
  if (n.length > 1) {
    const g = i[n[1]].source;
    throw new Error(
      X9.getLineAndColumnMessage(g.sourceString, g.startIdx) + "Found more than one grammar definition -- use ohm.grammars() instead."
    );
  }
  return i[n[0]];
}
function Jq(e, t) {
  const i = s5.extend(s5.asNamespace(t));
  if (typeof e != "string")
    if (Apt(e))
      e = e.toString();
    else
      throw new TypeError(
        "Expected string as first argument, got " + Dq.unexpectedObjToString(e)
      );
  return bpt(e, i), i;
}
function mpt(e) {
  throw new Error(
    "grammarFromScriptElement was removed in Ohm v16.0. See https://ohmjs.org/d/gfs for more info."
  );
}
function ppt(e) {
  throw new Error(
    "grammarsFromScriptElements was removed in Ohm v16.0. See https://ohmjs.org/d/gfs for more info."
  );
}
Kv.exports = {
  createNamespace: s5.createNamespace,
  grammar: hpt,
  grammars: Jq,
  grammarFromScriptElement: mpt,
  grammarsFromScriptElements: ppt,
  makeRecipe: Cpt,
  ohmGrammar: null,
  // Initialized below, after Grammar.BuiltInRules.
  pexprs: R9,
  util: X9,
  version: upt
};
Kv.exports._buildGrammar = H9;
X9.announceBuiltInRules(v9.BuiltInRules);
Kv.exports.ohmGrammar = Qv = cpt;
v9.initApplicationParser(Qv, H9);
var Bpt = Kv.exports;
const Ig = (e, t, i, n) => t.resolve(e.args.resolver, e.args.nodeToRefMap, i ?? e.args.localContext, n ?? e.args.globalContext), jv = Bpt.grammar(cbt), fpt = (e) => e.args.nodeToRefMap, Zpt = (e) => e.args.mapper, rI = (e) => e.args.resolver, iB = (e, t) => (t && e.args.nodeToRefMap.set(e._node, t), [t]), Gpt = jv.createSemantics().addOperation("replace(replacer,resolver,nodeToRefMap,mapper)", {
  _nonterminal(...e) {
    const t = fpt(this).get(this._node);
    if (t && !t.binding) {
      const i = Zpt(this)(t);
      if (i != null) {
        this.args.replacer.replace(this, i);
        return;
      }
    }
    return e.map((i) => i.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _iter(...e) {
    return e.map((t) => t.replace(this.args.replacer, this.args.resolver, this.args.nodeToRefMap, this.args.mapper)).flat();
  },
  _terminal() {
    return [];
  }
}).addOperation("resolve(resolver,nodeToRefMap,localContext,globalContext)", {
  CallExpression_alt1(e, t) {
    const i = e.plain[0], n = Wbt.find(({
      name: r
    }) => r === i);
    if (n) {
      const r = n.arguments.findIndex((a) => a === bV.Array), g = t.arguments[r], o = Ig(this, g)[0];
      let l;
      return t.arguments.forEach((a, I) => {
        if (n.arguments[I] === bV.ElementCallback) {
          const {
            parameter: d,
            body: C
          } = a.arrowFunction[0], A = d.plain[0], b = rI(this).subContextWithBinding(this.args.globalContext, A, o);
          l = Ig(this, C, b, b)[0];
        } else
          Ig(this, a);
      }), n.type === bV.ArrayElement ? [o] : [l];
    }
    return Ig(this, t.arguments[0])[0];
  },
  CallExpression_alt5(e, t, i) {
    var g, o, l;
    const n = (g = Ig(this, e)) == null ? void 0 : g[0], r = (l = (o = rI(this)).subContextFromRef) == null ? void 0 : l.call(o, this.args.localContext, n);
    return Ig(this, i, r);
  },
  CallExpression_alt4(e, t, i, n) {
    var o, l, a;
    const r = (o = Ig(this, e)) == null ? void 0 : o[0], g = (a = (l = rI(this)).subContextFromRef) == null ? void 0 : a.call(l, this.args.localContext, r);
    return Ig(this, i, g), r;
  },
  LeftHandSideExpression(e) {
    return Ig(this, e, this.args.globalContext);
  },
  MemberExpression_alt3(e, t, i) {
    var g, o, l;
    const n = (g = Ig(this, e)) == null ? void 0 : g[0], r = (l = (o = rI(this)).subContextFromRef) == null ? void 0 : l.call(o, this.args.localContext, n);
    return Ig(this, i, r);
  },
  MemberExpression_alt2(e, t, i, n) {
    var o, l, a;
    const r = (o = Ig(this, e)) == null ? void 0 : o[0], g = (a = (l = rI(this)).subContextFromRef) == null ? void 0 : a.call(l, this.args.localContext, r);
    return Ig(this, i, g), r;
  },
  ConditionalExpression_alt2(e, t, i, n, r) {
    var o;
    Ig(this, e);
    const g = (o = Ig(this, i)) == null ? void 0 : o[0];
    return Ig(this, r), g;
  },
  // TODO: here contextRef will be undefined for instance nodes!
  Identifier_alt1(e) {
    const t = this.plain[0], i = rI(this);
    if (t === "instances") {
      const r = this.args.localContext;
      return [i.instances(r)];
    }
    const n = i.binding(this.args.localContext, t) ?? i.attribute(this.args.localContext, t) ?? i.variable(this.args.localContext, t);
    return iB(this, n);
  },
  Identifier_variable(e, t, i, n) {
    const r = i.plain[0], g = rI(this).variable(this.args.localContext, r);
    return iB(this, g);
  },
  Identifier_attribute(e, t, i, n) {
    const r = i.plain[0], g = rI(this).attribute(this.args.localContext, r);
    return iB(this, g);
  },
  Identifier_varId(e, t, i, n) {
    const r = i.plain[0], g = rI(this).varId(this.args.localContext, r);
    return iB(this, g);
  },
  Identifier_attrId(e, t, i, n) {
    const r = i.plain[0], g = rI(this).attrId(this.args.localContext, r);
    return iB(this, g);
  },
  _iter(...e) {
    return e.map((t) => Ig(this, t)).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => Ig(this, t)).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("plain", {
  stringLiteral(e) {
    return [this.sourceString.substring(1, this.sourceString.length - 1)];
  },
  decimalIntegerLiteral(e) {
    return [parseInt(this.sourceString, 10)];
  },
  Identifier_alt1(e) {
    return [this.sourceString];
  },
  _iter(...e) {
    return e.map((t) => t.plain).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => t.plain).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("arguments", {
  CallExpression(e) {
    return [];
  },
  _iter(...e) {
    return e.map((t) => t.arguments).flat();
  },
  _nonterminal(...e) {
    return /ArgumentList_.*/.test(this._node.ruleName) ? e.filter((t) => t._node.ruleName !== void 0) : e.map((t) => t.arguments).flat();
  },
  _terminal() {
    return [];
  }
}).addAttribute("arrowFunction", {
  ArrowFunction_alt1(e, t, i) {
    return [{
      parameter: e,
      body: i
    }];
  },
  BindingIdentifier_alt1(e) {
    return e.plain;
  },
  _iter(...e) {
    return e.map((t) => t.arrowFunction).flat();
  },
  _nonterminal(...e) {
    return e.map((t) => t.arrowFunction).flat();
  },
  _terminal() {
    return [];
  }
});
function ypt(e) {
  const t = jv.match(e);
  if (t.failed())
    throw new Error(t.message);
}
function Wpt(e) {
  let t = 0, i = "";
  const n = (I) => {
    i += e.substring(t, I), t = I;
  }, r = () => n(e.length), g = (I) => i += I, o = (I) => t = I;
  return {
    replace: (I, c) => {
      n(I.source.startIdx), g(c), o(I.source.endIdx);
    },
    end: () => (r(), i)
  };
}
function k9(e) {
  return {
    bindings: {},
    localVariables: e.filter((t) => t.parentId == null),
    contextVariable: null,
    allVariables: e
  };
}
const qB = {
  // TODO: Searching by label might become a problem real fast if we have
  // multiple variables with the same label...
  variable(e, t) {
    return mM(e, (i) => i.label === t);
  },
  // TODO: Same as above
  attribute(e, t) {
    return pM(e, (i) => i.label[$i.language ?? "de"] === t);
  },
  instances(e) {
    return wpt(e);
  },
  varId(e, t) {
    return mM(e, (i) => i.id == t);
  },
  attrId(e, t) {
    return pM(e, (i) => i.id == t);
  },
  binding(e, t) {
    return e.bindings[t];
  },
  subContextWithBinding(e, t, i) {
    return {
      ...e,
      bindings: {
        ...e.bindings,
        [t]: {
          ...i,
          binding: !0
        }
      }
    };
  },
  subContextFromRef(e, t) {
    if ((t == null ? void 0 : t.type) === 0)
      return {
        ...e,
        contextVariable: t.variable,
        localVariables: e == null ? void 0 : e.allVariables.filter((i) => i.parentId == t.variable.id)
      };
    if ((t == null ? void 0 : t.type) === 1)
      return {
        ...e,
        contextVariable: null,
        localVariables: []
      };
  }
}, hM = /* @__PURE__ */ new Set(["Math", "Infinity", "NaN", "Boolean", "Number", "String", "Array", "Object", "instances", "instanceIndex", ...cq]), Spt = () => {
  const e = [];
  return {
    validationContextResolver: {
      ...qB,
      variable(i, n) {
        const r = qB.variable(i, n);
        return !hM.has(n) && !r && (i.contextVariable == null || km(i.contextVariable)) && e.push({
          message: $i.t("Merkmal {{label}} nicht gefunden!", {
            label: n
          }),
          label: n,
          entityType: "variable"
        }), r;
      },
      attribute(i, n) {
        const r = qB.attribute(i, n);
        return !hM.has(n) && !r && i.contextVariable && e.push({
          message: $i.t("Attribut {{label}} nicht gefunden!", {
            label: n
          }),
          label: n,
          entityType: "attribute",
          parentVariable: i.contextVariable
        }), r;
      }
    },
    errors: e
  };
};
function Y9(e, t, i, n) {
  const r = jv.match(e);
  if (r.failed())
    return e;
  const g = /* @__PURE__ */ new Map(), o = Gpt(r);
  o.resolve(t, g, n, n);
  const l = Wpt(e);
  return o.replace(l, t, g, i), l.end();
}
function yw(e, t) {
  return (t == null ? void 0 : t.indexOf(" ")) === -1 && !Hpt.has(t) ? t : `${e}('${t}')`;
}
const Eq = (e) => {
  var t;
  switch (e == null ? void 0 : e.type) {
    case 0:
      return `varId(${e.variable.id})`;
    case 1:
      return `attrId('${(t = e == null ? void 0 : e.attr) == null ? void 0 : t.id}')`;
  }
}, Vpt = (e) => {
  var t;
  switch (e == null ? void 0 : e.type) {
    case 0:
      return yw("variable", e.variable.label);
    case 1:
      return yw("attribute", ((t = e == null ? void 0 : e.attr) == null ? void 0 : t.label[$i.language ?? "de"]) ?? "");
  }
};
function mM(e, t) {
  const n = (e.contextVariable ? e.localVariables.filter((r) => {
    var g;
    return r.parentId == ((g = e == null ? void 0 : e.contextVariable) == null ? void 0 : g.id);
  }) : e.localVariables).find(t);
  return n == null ? void 0 : {
    binding: !1,
    type: 0,
    variable: n
  };
}
function pM(e, t) {
  var r;
  const i = e.contextVariable;
  if (i == null)
    return;
  const n = (r = i == null ? void 0 : i.attrs) == null ? void 0 : r.find(t);
  return n == null ? void 0 : {
    binding: !1,
    type: 1,
    variable: i,
    attr: n
  };
}
function wpt(e) {
  const t = e.contextVariable;
  return t == null ? void 0 : {
    binding: !1,
    type: 0,
    variable: t
  };
}
function vpt(e = "", t) {
  return Y9(e, qB, Eq, k9(t));
}
function Rpt(e, t) {
  if (!jv.match(e).succeeded())
    return [{
      message: $i.t("Syntaxfehler in der Expression!")
    }];
  const {
    validationContextResolver: n,
    errors: r
  } = Spt();
  if (Y9(e, n, Eq, k9(t)), r.length > 0)
    return r;
}
function Nq(e = "", t) {
  return Y9(e, qB, Vpt, k9(t));
}
function Xpt(e) {
  const t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
  e.forEach((r) => i.set(r.id, r));
  const n = (r) => LZ(Jm(r)).map((g) => i.get(g)).filter((g) => g != null);
  e.forEach((r) => t.set(r, n(r)));
  try {
    return Sbt(e, (r) => t.get(r), (r) => !Vi(r).suppressCycleDetection);
  } catch (r) {
    if (r instanceof Set) {
      const g = Array.from(r), o = (a) => a == null ? void 0 : a.label, l = g.concat(de.first(g)).map(o).join(" -> ");
      throw abt(l);
    }
  }
}
function LZ(e) {
  const t = /\bvarId\s*\((\s*[0-9]+\s*)\)/g;
  return [...e.matchAll(t)].map((i) => parseInt(i[1], 0));
}
const Hpt = /* @__PURE__ */ new Set(["attribute", "attrId", "variable", "async", "await", "break", "case", "catch", "class", "console", "const", "continue", "debugger", "default", "delete", "do", "document", "else", "enum", "export", "extends", "finally", "for", "function", "if", "implements", "import", "in", "interface", "let", "new", "package", "private", "protected", "public", "return", "self", "super", "switch", "this", "throw", "try", "var", "varId", "void", "while", "window", "with", "yield"]);
function kpt(e, t) {
  const i = {
    wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\%\^\&\*\(\)\-\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
    comments: {
      lineComment: "//",
      blockComment: ["/*", "*/"]
    },
    brackets: [["{", "}"], ["[", "]"], ["(", ")"]],
    onEnterRules: [{
      // e.g. /** | */
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      afterText: /^\s*\*\/$/,
      action: {
        indentAction: e.IndentAction.IndentOutdent,
        appendText: " * "
      }
    }, {
      // e.g. /** ...|
      beforeText: /^\s*\/\*\*(?!\/)([^\*]|\*(?!\/))*$/,
      action: {
        indentAction: e.IndentAction.None,
        appendText: " * "
      }
    }, {
      // e.g.  * ...|
      beforeText: /^(\t|(\ \ ))*\ \*(\ ([^\*]|\*(?!\/))*)?$/,
      action: {
        indentAction: e.IndentAction.None,
        appendText: "* "
      }
    }, {
      // e.g.  */|
      beforeText: /^(\t|(\ \ ))*\ \*\/\s*$/,
      action: {
        indentAction: e.IndentAction.None,
        removeText: 1
      }
    }],
    autoClosingPairs: [{
      open: "{",
      close: "}"
    }, {
      open: "[",
      close: "]"
    }, {
      open: "(",
      close: ")"
    }, {
      open: '"',
      close: '"',
      notIn: ["string"]
    }, {
      open: "'",
      close: "'",
      notIn: ["string", "comment"]
    }, {
      open: "`",
      close: "`",
      notIn: ["string", "comment"]
    }, {
      open: "/**",
      close: " */",
      notIn: ["string"]
    }],
    folding: {
      markers: {
        start: new RegExp("^\\s*//\\s*#?region\\b"),
        end: new RegExp("^\\s*//\\s*#?endregion\\b")
      }
    }
  }, n = {
    // Set defaultToken to invalid to see what you do not tokenize yet
    defaultToken: "invalid",
    tokenPostfix: ".ts",
    // Lets make sure that all keywords are truthy otherwise the Monaco editor
    // will throw an error.
    keywords: t.filter((r) => !!r),
    operators: ["<=", ">=", "==", "!=", "===", "!==", "=>", "+", "-", "**", "*", "/", "%", "<<", "</", ">>", ">>>", "&", "|", "^", "!", "~", "&&", "||", "??", "?", ":", "="],
    // we include these common regular expressions
    symbols: /[=><!~?:&|+\-*\/\^%]+/,
    escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
    digits: /\d+(_+\d+)*/,
    octaldigits: /[0-7]+(_+[0-7]+)*/,
    binarydigits: /[0-1]+(_+[0-1]+)*/,
    hexdigits: /[[0-9a-fA-F]+(_+[0-9a-fA-F]+)*/,
    regexpctl: /[(){}\[\]\$\^|\-*+?\.]/,
    regexpesc: /\\(?:[bBdDfnrstvwWn0\\\/]|@regexpctl|c[A-Z]|x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4})/,
    // The main tokenizer for our languages
    tokenizer: {
      root: [[/[{}]/, "delimiter.bracket"], {
        include: "common"
      }],
      common: [
        // identifiers and keywords
        [/[a-z_$][\w$]*/, {
          cases: {
            "@keywords": "keyword",
            "@default": "identifier"
          }
        }],
        [/[A-Z][\w\$]*/, "type.identifier"],
        // to show class names nicely
        // [/[A-Z][\w\$]*/, 'identifier'],
        // whitespace
        {
          include: "@whitespace"
        },
        // regular expression: ensure it is terminated before beginning (otherwise it is an opeator)
        [/\/(?=([^\\\/]|\\.)+\/([dgimsuy]*)(\s*)(\.|;|,|\)|\]|\}|$))/, {
          token: "regexp",
          bracket: "@open",
          next: "@regexp"
        }],
        // delimiters and operators
        [/[()\[\]]/, "@brackets"],
        [/[<>](?!@symbols)/, "@brackets"],
        [/!(?=([^=]|$))/, "delimiter"],
        [/@symbols/, {
          cases: {
            "@operators": "delimiter",
            "@default": ""
          }
        }],
        // numbers
        [/(@digits)[eE]([\-+]?(@digits))?/, "number.float"],
        [/(@digits)\.(@digits)([eE][\-+]?(@digits))?/, "number.float"],
        [/0[xX](@hexdigits)n?/, "number.hex"],
        [/0[oO]?(@octaldigits)n?/, "number.octal"],
        [/0[bB](@binarydigits)n?/, "number.binary"],
        [/(@digits)n?/, "number"],
        // delimiter: after number because of .\d floats
        [/[;,.]/, "delimiter"],
        // strings
        [/"([^"\\]|\\.)*$/, "string.invalid"],
        // non-teminated string
        [/'([^'\\]|\\.)*$/, "string.invalid"],
        // non-teminated string
        [/"/, "string", "@string_double"],
        [/'/, "string", "@string_single"],
        [/`/, "string", "@string_backtick"]
      ],
      whitespace: [[/[ \t\r\n]+/, ""], [/\/\*\*(?!\/)/, "comment.doc", "@jsdoc"], [/\/\*/, "comment", "@comment"], [/\/\/.*$/, "comment"]],
      comment: [[/[^\/*]+/, "comment"], [/\*\//, "comment", "@pop"], [/[\/*]/, "comment"]],
      jsdoc: [[/[^\/*]+/, "comment.doc"], [/\*\//, "comment.doc", "@pop"], [/[\/*]/, "comment.doc"]],
      // We match regular expression quite precisely
      regexp: [[/(\{)(\d+(?:,\d*)?)(\})/, ["regexp.escape.control", "regexp.escape.control", "regexp.escape.control"]], [/(\[)(\^?)(?=(?:[^\]\\\/]|\\.)+)/, ["regexp.escape.control", {
        token: "regexp.escape.control",
        next: "@regexrange"
      }]], [/(\()(\?:|\?=|\?!)/, ["regexp.escape.control", "regexp.escape.control"]], [/[()]/, "regexp.escape.control"], [/@regexpctl/, "regexp.escape.control"], [/[^\\\/]/, "regexp"], [/@regexpesc/, "regexp.escape"], [/\\\./, "regexp.invalid"], [/(\/)([dgimsuy]*)/, [{
        token: "regexp",
        bracket: "@close",
        next: "@pop"
      }, "keyword.other"]]],
      regexrange: [[/-/, "regexp.escape.control"], [/\^/, "regexp.invalid"], [/@regexpesc/, "regexp.escape"], [/[^\]]/, "regexp"], [/\]/, {
        token: "regexp.escape.control",
        next: "@pop",
        bracket: "@close"
      }]],
      string_double: [[/[^\\"]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/"/, "string", "@pop"]],
      string_single: [[/[^\\']+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/'/, "string", "@pop"]],
      string_backtick: [[/\$\{/, {
        token: "delimiter.bracket",
        next: "@bracketCounting"
      }], [/[^\\`$]+/, "string"], [/@escapes/, "string.escape"], [/\\./, "string.escape.invalid"], [/`/, "string", "@pop"]],
      bracketCounting: [[/\{/, "delimiter.bracket", "@bracketCounting"], [/\}/, "delimiter.bracket", "@pop"], {
        include: "common"
      }]
    }
  };
  return {
    configuration: i,
    language: n
  };
}
const Ypt = {
  codeLens: !1,
  lineNumbers: "off",
  glyphMargin: !1,
  folding: !1,
  lineDecorationsWidth: 0,
  lineNumbersMinChars: 0,
  overviewRulerLanes: 0,
  scrollBeyondLastLine: !1,
  hideCursorInOverviewRuler: !0,
  overviewRulerBorder: !1,
  renderLineHighlight: "none",
  fontFamily: "Nunito Sans, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
  fontSize: 14,
  minimap: {
    enabled: !1
  }
}, Fpt = async () => ({
  default: (await import("./InternalMonacoEditor-JSOwVFHi.js").then((e) => e.I)).default
}), xpt = _o(Fpt), Dpt = (e) => /* @__PURE__ */ S(fm, { fallback: null, children: /* @__PURE__ */ S(xpt, { ...e }) }), Hh = "expressionK3";
function Lq(e) {
  const {
    t
  } = Gi(), i = ie(Og), n = ot(null), r = (c) => {
    const d = vpt(c, i);
    e.onChange(d);
  }, g = Nq(e.expression ?? "", i), [o, l] = wt("100%"), a = (c, d) => {
    var C;
    if (!e.inline) {
      const A = () => {
        var m;
        const b = Math.min((((m = c.getModel()) == null ? void 0 : m.getLineCount()) ?? 40) * 21, window.innerHeight - 400);
        l(b);
      };
      c.onDidContentSizeChange(A);
    }
    Jpt(d, i), e.inline ? (C = c.getAction("editor.action.toggleTabFocusMode")) == null || C.run() : c.focus(), c.layout();
  }, I = Oe(() => de.merge({}, Ypt, e.inline ? {
    scrollbar: {
      vertical: "hidden",
      horizontal: "hidden",
      handleMouseWheel: !1
    }
  } : {}, e.options), [e.inline, e.options]);
  return /* @__PURE__ */ Ie("div", { style: {
    position: "relative",
    minWidth: "60px",
    width: "100%",
    height: e.height ?? "100%"
  }, ref: n, children: [
    /* @__PURE__ */ S(Dpt, { theme: "light", height: o, defaultLanguage: Hh, onChange: r, value: g, onMount: a, options: I, loading: /* @__PURE__ */ Ie(ja, { variant: "standard", children: [
      /* @__PURE__ */ S(Zj, { htmlFor: "input-component", children: t("Expression") }),
      /* @__PURE__ */ S(gv, { id: "input-component", onChange: (c) => r(c.target.value), value: g, multiline: !0, fullWidth: !0 })
    ] }) }),
    !e.inline && /* @__PURE__ */ S(Ni, { "data-cy": "clear-expression", size: "small", onClick: () => {
      r(void 0);
    }, style: {
      position: "absolute",
      top: 0,
      right: 0
    }, children: /* @__PURE__ */ S(Ev, {}) })
  ] });
}
let nB = null;
function Jpt(e, t) {
  const i = e.languages;
  i.getEncodedLanguageId(Hh) == 0 && i.register({
    id: Hh
  });
  const n = t.map(({
    label: o
  }) => o).concat(Object.keys(JZ)), {
    configuration: r,
    language: g
  } = kpt(i, n);
  i.setLanguageConfiguration(Hh, r), i.setMonarchTokensProvider(Hh, g), nB !== null && (nB == null || nB.dispose()), nB = i.registerCompletionItemProvider(Hh, Ept(i, t));
}
function Ept(e, t) {
  return {
    provideCompletionItems: (i, n) => {
      i.getValueInRange({
        startLineNumber: 1,
        startColumn: 1,
        endLineNumber: n.lineNumber,
        endColumn: n.column
      });
      const r = i.getWordUntilPosition(n), g = {
        startLineNumber: n.lineNumber,
        endLineNumber: n.lineNumber,
        startColumn: r.startColumn,
        endColumn: r.endColumn
      };
      return {
        suggestions: Npt(e, t, g)
      };
    }
  };
}
function Npt(e, t, i) {
  const {
    Function: n,
    Variable: r,
    Constant: g,
    Property: o
  } = e.CompletionItemKind;
  return t.map((l) => l.label).map((l) => ({
    label: `${l}`,
    kind: r,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "reference to Variable " + l,
    insertText: yw("variable", l),
    range: i
  })).concat(t.flatMap((l) => {
    var a;
    return ((a = l.attrs) == null ? void 0 : a.map((I) => I.label[$i.language]).map((I) => ({
      label: `${I}`,
      kind: o,
      // documentation klappt nicht.. keine Ahnung warum
      documentation: "reference to attribut " + I,
      insertText: yw("attribut", I),
      range: i
    }))) ?? [];
  }), [{
    label: "instanceIndex",
    kind: o,
    documentation: "instance index",
    insertText: "instanceIndex",
    range: i
  }]).concat(de.map(JZ, (l, a) => typeof l == "function" ? {
    label: `${a}`,
    kind: n,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the function " + a,
    insertText: `${a}()`,
    range: i
  } : {
    label: `${a}`,
    kind: g,
    // documentation klappt nicht.. keine Ahnung warum
    documentation: "the constant " + a,
    insertText: a,
    range: i
  }));
}
const Lpt = (e, t) => Av(e, (n) => {
  n.settings.templateOptions.expression = t;
});
function Kpt(e) {
  const t = ie(Br), i = ie(Og), n = ie($l), r = ie(nr), [g, o] = wt(null), l = Oe(() => de.debounce((d, C) => {
    const A = Rpt(d, C);
    if (A) {
      let b = A.map((m) => m.message);
      b = Le.uniq(b), o(b.join(" "));
    } else
      o(null);
  }, 150), []);
  if (e.expression && l(e.expression, i), g)
    return {
      result: 0,
      resultString: "",
      errorMessage: g
    };
  if (!e.variable)
    return Lv(i, n, r.variables.variableHierarchies, t, e.expression, e.anchoringSelection);
  const a = [...i], I = a.findIndex((d) => {
    var C;
    return d.id == ((C = e.variable) == null ? void 0 : C.id);
  }), c = Lpt(e.variable, e.expression);
  return I >= 0 && (a[I] = c), Cq(a, n, r.variables.variableHierarchies, t, c, e.anchoringSelection);
}
function Tpt(e) {
  const {
    t
  } = Gi(), {
    resultString: i,
    errorMessage: n
  } = Kpt(e);
  e.onError && e.onError(n);
  const r = ie((l) => Ym(l, e.anchoringSelection)), g = ie(t9), o = " " + r.map((l) => {
    var a;
    return l.valueId ? (a = g[l == null ? void 0 : l.valueId]) == null ? void 0 : a.label : "";
  }).join(" > ");
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Hf, { "data-cy": "expressionEngineResult", children: t("Ergebnis") + (o.trim() && o) + ": " + i }),
    (e.showError ?? !0) && n && /* @__PURE__ */ S(Hf, { "data-cy": "expressionEngineError", sx: {
      color: "red"
    }, children: "" + n })
  ] });
}
function Kq({
  expression: e,
  anchoringSelections: t,
  showExpression: i,
  onError: n,
  gutterBottom: r
}) {
  const g = ie(Og), o = de.isEmpty(e), l = Oe(() => o ? "" : Nq(e, g), [o, e, g]);
  return /* @__PURE__ */ Ie(ht, { component: "div", "data-cy": "expressionEditorPreview", sx: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridAutoFlow: "row",
    gap: 2
  }, children: [
    !!i && /* @__PURE__ */ S(Mpt, { emptyExpression: o, formula: l }),
    !o && /* @__PURE__ */ S(Ppt, { selections: t, expression: e, onError: n, marginBottom: r })
  ] });
}
const Mpt = (e) => {
  const {
    t
  } = Gi();
  return e.emptyExpression ? /* @__PURE__ */ S(Hf, { "data-cy": "noExpresionMessage", children: t("Keine Formel eingegeben") }) : /* @__PURE__ */ S(ht, { "data-cy": "expression", component: "div", sx: {
    wordBreak: "break-word"
  }, children: /* @__PURE__ */ S(Ct, { children: t("Formel: ") + e.formula }) });
}, Ppt = (e) => {
  var t;
  return (t = e.selections) != null && t.length ? /* @__PURE__ */ S(ht, { component: "div", sx: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridAutoFlow: "row",
    gap: 1,
    marginBottom: e.marginBottom ? 2 : 0,
    overflowY: "auto",
    maxHeight: "200px"
  }, children: e.selections.map((i, n, r) => /* @__PURE__ */ S(Tpt, { expression: e.expression, anchoringSelection: i, showError: n === r.length - 1, onError: e.onError }, i.id)) }) : /* @__PURE__ */ S(Upt, {});
}, Upt = () => {
  const {
    t: e
  } = Gi();
  return /* @__PURE__ */ S(Hf, { "data-cy": "notEnoughSelectionsToEvaluateExpressionMessage", children: e("Noch gibt es nicht genug Auswahlen um eine Vorschau anzuzeigen.") });
}, qv = "app", F9 = () => {
  var I;
  const e = window.location.href.split("://")[1], t = e.split(/(?=\/|\?)/), i = t[1] === "/test" || t[1] === "/demo", n = t.slice(0, i ? 2 : 1).join(""), r = t.slice(i ? 2 : 1), g = (r[0] && r[0] !== "/#" && !r[0].includes("?") ? e.includes("/rel/") ? r[0] + r[1] + r[2] : r[0] : "").replace(/^\//, ""), o = g ? r.join("").match(new RegExp(`.*?${g}(.*)`))[1] : r.join(""), l = e.includes("/test") || e.includes("/demo") || e.includes("localhost:"), a = (I = o.includes("#") ? o.split("#")[1] : o) == null ? void 0 : I.replace(/^\//, "");
  return {
    /** The base host, including /test if we are on test */
    host: n,
    /** The current type of the app/bundle loaded. E.g. veranda or defaultApp.
     * This hook also already supports root mounted default app. Just set defaultApp to ''.
     * */
    currentAppType: g || qv,
    /** The internal path we are currently on */
    path: a,
    /** Are we on test? */
    test: l
  };
}, Tq = () => window.location.hash.includes("/edit/"), zpt = () => window.location.hash.includes("/edit/preview");
var Gd = /* @__PURE__ */ ((e) => (e.STRING = "string", e.NUMBER = "number", e.TRANSLATION = "translation", e.BOOLEAN = "boolean", e.IMAGE = "image", e.ARRAY = "array", e))(Gd || {}), Mi = /* @__PURE__ */ ((e) => (e.COMPONENT_BREADCRUMBS_BACK = "translation_componentBreadcrumbsBack", e.ORDER_DIALOG_OVERVIEW = "translation_orderDialogOverview", e.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE = "translation_selectionPrice", e.ORDER_DIALOG_OVERVIEW_STEP = "translation_step", e.ORDER_DIALOG_OVERVIEW_VARIABLE = "translation_variable", e.ORDER_DIALOG_OVERVIEW_SELECTION = "translation_selection", e.ORDER_DIALOG_OVERVIEW_TOTALPRICE = "translation_totalPrice", e.ORDER_DIALOG_OVERVIEW_PRICE = "translation_price", e.ORDER_DIALOG_OVERVIEW_PRICEINFO = "translation_priceInformation", e.ORDER_DIALOG_DATA = "translation_orderDialogData", e.ORDER_DIALOG_SUBMITINFO = "translation_orderDialogSubmitInfo", e.ORDER_DIALOG_CONFIRMATION = "translation_orderDialogConfirmation", e.NAVBAR_BACK = "translation_navbarBack", e.NAVBAR_NEXT = "translation_navbarNext", e.AR_BUTTON = "translation_ar_button", e.AR_PLACEMENT = "ar_object_placement", e.FULLSCREEN_BUTTON = "translation_fullscreen_button", e.CANCEL = "translation_cancel", e.OK = "translation_ok", e.CLOSE = "translation_close", e.NAVBAR_OLDVERSIONHINT = "translation_exit_invalid", e))(Mi || {});
const Opt = (e) => [
  {
    key: "translation_componentBreadcrumbsBack",
    valueType: "translation",
    defaultValue: e("Zurück")
  },
  {
    key: "translation_orderDialogOverview",
    valueType: "translation",
    defaultValue: e("Übersicht")
  },
  {
    key: "translation_selectionPrice",
    valueType: "translation",
    defaultValue: e("Auswahlpreise")
  },
  {
    key: "translation_step",
    valueType: "translation",
    defaultValue: e("Schritt")
  },
  {
    key: "translation_variable",
    valueType: "translation",
    defaultValue: e("Merkmal")
  },
  {
    key: "translation_selection",
    valueType: "translation",
    defaultValue: e("Auswahl")
  },
  {
    key: "translation_totalPrice",
    valueType: "translation",
    defaultValue: e("Gesamtpreis")
  },
  {
    key: "translation_price",
    valueType: "translation",
    defaultValue: e("Preis")
  },
  {
    key: "translation_priceInformation",
    valueType: "translation",
    defaultValue: e("Preis Information")
  },
  {
    key: "translation_orderDialogData",
    valueType: "translation",
    defaultValue: e("Persönliche Daten")
  },
  {
    key: "translation_orderDialogConfirmation",
    valueType: "translation",
    defaultValue: e("Bestätigung")
  },
  {
    key: "translation_orderDialogSubmitInfo",
    valueType: "translation",
    defaultValue: e("Bitte füllen Sie alle benötigten Felder sachgerecht aus und akzeptieren Sie die Datenschutzhinweise"),
    textarea: !0,
    label: e("Bestätigen-Hinweistext bei invalidem Kontaktformular")
  },
  {
    key: "translation_navbarBack",
    valueType: "translation",
    defaultValue: e("Zurück")
  },
  {
    key: "translation_navbarNext",
    valueType: "translation",
    defaultValue: e("Weiter")
  },
  {
    key: "translation_exit_invalid",
    valueType: "translation",
    defaultValue: e("Sie verwenden eine veraltete Version des Konfigurators."),
    label: e("Bestell-Warnhinweis bei veralteter Version"),
    textarea: !0
  },
  {
    key: "translation_ar_button",
    valueType: "translation",
    defaultValue: e("In AR ansehen"),
    label: "AR Button Text"
  },
  {
    key: "ar_object_placement",
    valueType: "boolean",
    defaultValue: !1,
    label: "Vertikale Platzierung zulassen?"
  },
  {
    key: "translation_fullscreen_button",
    valueType: "translation",
    defaultValue: e("Vollbildmodus")
  },
  {
    key: "translation_cancel",
    valueType: "translation",
    defaultValue: e("Abbrechen")
  },
  {
    key: "translation_ok",
    valueType: "translation",
    defaultValue: e("OK")
  },
  {
    key: "translation_close",
    valueType: "translation",
    defaultValue: e("Schliessen")
  },
  // MP Popup texts
  {
    key: "translation_mp_popup_add",
    valueType: "translation",
    defaultValue: e("Hinzufügen"),
    label: "Hinzufügen"
  },
  {
    key: "translation_mp_popup_search",
    valueType: "translation",
    defaultValue: e("Komponenten suchen"),
    label: "Suche"
  },
  {
    key: "translation_mp_popup_not_grouped",
    valueType: "translation",
    defaultValue: e("Nicht Gruppiert"),
    label: "Nicht gruppiert"
  },
  {
    key: "translation_mp_popup_description",
    valueType: "translation",
    defaultValue: e("Komponenten"),
    label: "Beschreibung"
  },
  {
    key: "translation_mp_popup_title",
    valueType: "translation",
    defaultValue: e("Komponenten hinzufügen"),
    label: "Titel"
  },
  {
    key: "toggle_mp_dialog_component_cols",
    valueType: "number",
    label: "Anzahl an Komponenten pro Zeile",
    defaultValue: 4,
    min: 1
  },
  {
    key: "toggle_mp_dialog_component_display",
    valueType: "boolean",
    label: "Werte vertikal ausrichten",
    defaultValue: !0
  },
  {
    key: "toggle_mp_dialog_hide_searchbar",
    valueType: "boolean",
    label: "Suchfeld ausblenden?",
    defaultValue: !1
  },
  {
    key: "string_mp_dialog_size",
    valueType: "string",
    label: "Modalgröße",
    defaultValue: e("xl")
  },
  // warning texts
  {
    key: "translation_warning_number",
    valueType: "translation",
    defaultValue: e("Ihre Eingabe war leider nicht möglich und wurde auf den nächstmöglichen Wert zurückgesetzt: ")
  },
  {
    key: "translation_warning_invalid_selection",
    valueType: "translation",
    defaultValue: e("Dieser Wert ist nicht kombinierbar mit folgenden Auswahlen:")
  },
  {
    key: "translation_warning_invalid_selection_alternative",
    valueType: "translation",
    defaultValue: e("Bei Auswahl wird eine Alternative berechnet!")
  },
  // Group Actions
  {
    key: "translation_group_multiple_actions",
    valueType: "translation",
    defaultValue: e("Bestätigen")
  },
  {
    key: "translation_group_actions_add_item",
    valueType: "translation",
    defaultValue: e("Produkt hinzufügen")
  },
  {
    key: "translation_group_actions_continue",
    valueType: "translation",
    defaultValue: e("Weiter")
  },
  {
    key: "translation_group_actions_dialog_title",
    valueType: "translation",
    defaultValue: e("Produkt erfolgreich konfiguriert")
  },
  {
    key: "translation_group_actions_dialog_description",
    valueType: "translation",
    textarea: !0,
    defaultValue: e("Die Konfiguration ist abgeschlossen. Welches Produkt möchten Sie als Nächstes in den Warenkorb legen?")
  },
  {
    key: "string_group_actions_dialog_size",
    valueType: "string",
    label: "Modalgröße",
    defaultValue: e("xl")
  },
  {
    key: "translation_group_actions_dialog_pick_item",
    valueType: "translation",
    defaultValue: e("Neues Produkt auswählen")
  },
  {
    key: "translation_group_actions_dialog_add_item",
    valueType: "translation",
    defaultValue: e("Neues Produkt hinzufügen")
  },
  //invalid rule modal
  {
    key: "translation_invalid_rule_modale_custom_error",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) führt zum ungültigen Wert "{{conflictValue0}}" ({{conflictVariable0}}) und wird deshalb zurückgesetzt.'),
    label: e("Meldung bei Zurücksetzen einer ungültigen Auswahl") + " (Placeholder: value, variable, conflictValue0, conflictVariable0)"
  },
  {
    key: "translation_invalid_rule_modal_1_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}).'),
    label: e("Meldung bei Auftreten eines Konflikts") + " (Placeholder: value, variable, conflictValue0, conflictVariable0)"
  },
  {
    key: "translation_invalid_rule_modal_2_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}) und der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}).'),
    label: e("Meldung bei Auftreten von zwei Konflikten") + " (Placeholder: value, variable, conflictValue[0,1], conflictVariable[0,1])"
  },
  {
    key: "translation_invalid_rule_modal_3_conflict",
    valueType: "translation",
    textarea: !0,
    label: e("Meldung bei Auftreten von drei oder mehr Konflikten") + " (Placeholder: value, variable, conflictValue[0,1,2], conflictVariable[0,1,2])",
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu der Auswahl "{{conflictValue0}}" ({{conflictVariable0}}), der Auswahl "{{conflictValue1}}" ({{conflictVariable1}}) und der Auswahl "{{conflictValue2}}" ({{conflictVariable2}}).')
  },
  {
    key: "translation_invalid_rule_modal_other_conflict",
    valueType: "translation",
    textarea: !0,
    defaultValue: e('Die Auswahl "{{value}}" ({{variable}}) passt nicht zu anderen Auswahlen.'),
    label: e("Konfliktmeldung") + " (Placeholder: value, variable)"
  },
  {
    key: "translation_invalid_option_tooltip",
    valueType: "translation",
    textarea: !0,
    defaultValue: e("Diese Auswahl kann bereits vorgenommene Selektionen rückgängig machen."),
    label: e("Konfliktmeldung")
  },
  {
    key: "translation_invalid_rule_modal_changes_needed",
    valueType: "translation",
    defaultValue: e("Anpassung nötig")
  },
  {
    key: "translation_invalid_rule_modal_changes_will_be_made",
    valueType: "translation",
    defaultValue: e("Stattdessen werden folgende Auswahlen angepasst:")
  },
  {
    key: "translation_invalid_rule_modal_changes_will_become",
    valueType: "translation",
    defaultValue: e("wird zu")
  },
  {
    key: "translation_invalid_rule_modal_will_be_deleted",
    valueType: "translation",
    defaultValue: e("wird entfernt")
  },
  {
    key: "translation_invalid_rule_modal_custom_text",
    valueType: "translation",
    label: e("Optionaler weiterer Hinweistext:"),
    defaultValue: ""
  },
  {
    key: "translation_SocialShare_Facebook",
    valueType: "translation",
    defaultValue: e("Auf Facebook teilen")
  },
  {
    key: "translation_SocialShare_Twitter",
    valueType: "translation",
    defaultValue: e("Auf Twitter teilen")
  },
  {
    key: "translation_SocialShare_LinkedIn",
    valueType: "translation",
    defaultValue: e("Auf LinkedIn teilen")
  },
  {
    key: "translation_AR_Title",
    valueType: "translation",
    label: e("Modal Titel") + " (Desktop)",
    defaultValue: e("Desktop Gerät erkannt")
  },
  {
    key: "translation_AR_Body",
    valueType: "translation",
    textarea: !0,
    label: e("Modal Text") + " (Desktop)",
    defaultValue: e("Augmented-Reality ist aktuell nur auf aktuellen iOS- oder androidOS-Smartphones verfügbar. Scannen Sie daher einfach diesen QR-Code mit der Kamera-App Ihres Smartphones:")
  },
  {
    key: "translation_AR_Mobile_Title",
    valueType: "translation",
    label: e("Modal Titel") + " (Mobile, Placeholder: device)",
    defaultValue: e("Mobiles {{device}}-Gerät erkannt")
  },
  {
    key: "translation_AR_Mobile_Progress_Export",
    valueType: "translation",
    label: e("Fortschrittsanzeige 3D-Objekt"),
    defaultValue: e("Export des 3D-Objekts")
  },
  {
    key: "translation_AR_Mobile_Progress_File",
    valueType: "translation",
    label: e("Fortschrittsanzeige AR-Datei"),
    defaultValue: e("Bereitstellen der AR-Datei")
  },
  {
    key: "translation_AR_Mobile_Progress_Device",
    valueType: "translation",
    label: e("Fortschrittsanzeige System") + " (Placeholder: device)",
    defaultValue: e("{{device}}-AR-System einrichten")
  },
  {
    key: "order_modal_pos",
    valueType: "translation",
    label: e("Positionszeile"),
    defaultValue: e("Pos.")
  },
  {
    key: "order_modal_articleNo",
    valueType: "translation",
    label: e("Artikelnummer Spalte"),
    defaultValue: e("Nummer")
  },
  {
    key: "order_modal_article",
    valueType: "translation",
    label: e("Artikel Spalte"),
    defaultValue: e("Artikel")
  },
  {
    key: "order_modal_articlePrice",
    valueType: "translation",
    label: e("Artikelpreis Spalte"),
    defaultValue: e("Preis")
  },
  {
    key: "order_modal_articleAmount",
    valueType: "translation",
    label: e("Artikelmenge Spalte"),
    defaultValue: e("Menge")
  },
  {
    key: "order_modal_articleCount",
    valueType: "translation",
    label: e("Artikelanzahl Spalte"),
    defaultValue: e("Anzahl")
  },
  {
    key: "order_modal_positionPrice",
    valueType: "translation",
    label: e("Positionspreis Spalte"),
    defaultValue: e("Positionspreis")
  },
  {
    key: "order_modal_priceDetails",
    valueType: "translation",
    label: e("Hilfetext Preisdetails"),
    defaultValue: e("Preisdetails anzeigen")
  },
  {
    key: "appload_versionmismatch_title",
    valueType: "translation",
    label: e("Titel bei Versions-Konflikt"),
    defaultValue: e("Konfigurator wurde aktualisiert")
  },
  {
    key: "appload_versionmismatch_text",
    valueType: "translation",
    label: e("Text bei Versions-Konflikt"),
    defaultValue: e("Seit Sie diese Konfiguration gespeichert haben, wurde der Konfigurator weiterentwickelt. Wollen Sie die aktuelle Version verwenden und weiterarbeiten oder die alte Version nur zur Ansicht öffnen?")
  },
  {
    key: "order_modal_edit",
    valueType: "translation",
    label: e("Hilfetext Auswahl Ändern"),
    defaultValue: e("Merkmal ändern")
  },
  {
    key: "order_modal_remove",
    valueType: "translation",
    label: e("Hilfetext Auswahl Entfernen"),
    defaultValue: e("Auswahl entfernen")
  },
  {
    key: "appload_versionmismatch_old",
    valueType: "translation",
    label: e("Alte Version"),
    defaultValue: e("Alte Version")
  },
  {
    key: "appload_versionmismatch_new",
    valueType: "translation",
    label: e("Aktuelle Version"),
    defaultValue: e("Aktuelle Version")
  }
], _v = () => {
  const {
    t: e
  } = Gi(), t = ie(NWe), i = Xv().additionalDynamicSettings;
  return Oe(() => [...i || [], ...Opt(e), ...t.map((n) => ({
    key: n.key,
    valueType: "translation",
    defaultValue: n.defaultValue
  }))], [t, i, e]);
}, b_t = (e) => (t) => {
  if (typeof t != "string")
    return [!1, "Please make sure the type is set to array."];
  const i = t.split(", ");
  return i.length !== e || !i.every((n) => n && isFinite(Number(n))) ? [!1, `Not a vector of length ${e}. Please enter your vector like this: ${new Array(e).fill(0).map((r, g) => g + 1).join(", ")}`] : [!0, ""];
}, Qpt = (e) => {
  if (typeof e != "string")
    return [!1, "Not a string"];
  const i = e.split(", ").every((r) => r !== "");
  return [i, i ? "" : "Please enter your vector like this: 1, 2, true, test"];
}, x9 = Ci([(e) => e.metadata.articles], (e) => (e ?? []).slice().sort(tu)), jpt = Ci(x9, (e) => An(e)), Mq = Ci([x9, (e, t) => t], (e, t) => e.filter((i) => i.appId === t)), $v = (e) => de.get(e, ["metadata", de.lowerCase("materials")]), h_t = (e) => (t) => $v(t).find((i) => i.id == e), qpt = Le.curry((e, t) => Le.flow($v, Le.filter((i) => i.appId == e))(t)), KZ = (e) => e.metadata.models || [], e1 = (e) => (t) => KZ(t).find((i) => i.id == e), _pt = Le.curry((e, t) => Le.flow(KZ, Le.filter((i) => i.appId == e))(t)), $pt = (e) => KZ(e).filter((t) => t.type === "dynamic"), m_t = (e) => $pt(e).filter((t) => jf().find((i) => i.type === t.dynamicModelKey && i.disabledForAR)), D9 = (e) => de.get(e, ["metadata", de.lowerCase("prices")]), Pq = Ci([D9], (e) => de.groupBy(e, (t) => t.appId));
Ci([Pq, (e, t) => t], (e, t) => e[t] || []);
const e0t = Ci([D9], (e) => de.groupBy(e, (t) => t.articleId)), Uq = Ci([e0t, (e, t) => t], (e, t) => e[t] || []), t0t = (e) => {
  var t;
  return (t = e == null ? void 0 : e.layout) == null ? void 0 : t.sidebarPosition;
}, t1 = (e, t) => !!t.find((i) => i.id === e.id), zq = (e) => (e == null ? void 0 : e.columns) || [], p_t = (e, t) => zq(e).find((i) => i.id == t), i0t = (e) => Le.flow(zq, Le.filter(Gc))(e), Oq = (e) => Le.flow(i0t, Le.map((t) => t.targetId))(e), Qq = (e, t) => Og(e).filter((i) => i.groupId == t).sort(gA), B_t = (e, t) => (i) => Qq(i, e).filter(yye).filter((n) => NJ(n, t)(i) === null), J9 = Ci([Og], (e) => de.groupBy(e, (t) => t.groupId)), jq = Ci([J9, (e, t) => t], (e, t) => e[t] || []), f_t = {
  USD: "USD",
  CAD: "CAD",
  AUD: "AUD",
  EUR: "EUR",
  GBP: "GBP",
  JPY: "JPY",
  NZD: "NZD",
  HKD: "HKD",
  SGD: "SGD",
  DKK: "DKK"
}, Bc = {
  fixed: "fixed",
  surcharge: "surcharge",
  surchargeHidden: "surchargeHidden",
  surchargeHiddenMult: "surchargeHiddenMult"
}, E9 = (e) => e.bom.bom, Em = Ci([E9, (e, t) => t], (e, t) => {
  const i = e.filter((A, b, m) => !t || t(A, b, m)), n = i.filter((A) => A.price.type == Bc.fixed), r = i.filter((A) => A.price.type == Bc.surcharge), g = i.filter((A) => A.price.type == Bc.surchargeHidden), o = i.filter((A) => A.price.type == Bc.surchargeHiddenMult), l = tS(n, (A) => ys(A.price.price * A.qty * v3(A.amount))), a = tS(g, (A) => A.price.price * A.qty) / 100, I = (A) => {
    let b = ys(ys(A) * (1 + a));
    return o.forEach((m) => {
      b = ys(b * (1 + m.price.price * m.qty / 100));
    }), b;
  }, c = n.map((A) => ({
    ...A,
    priceUnit: I(A.price.price),
    priceTotal: ys(I(A.price.price) * A.qty * v3(A.amount))
  })), d = r.map((A) => ({
    ...A,
    priceUnit: ys(A.price.price * A.qty / 100 * l),
    priceTotal: ys(A.price.price * A.qty / 100 * l * A.qty)
  })), C = ys(tS(c, (A) => A.priceTotal) + tS(d, (A) => A.priceTotal));
  return {
    articleLines: c,
    surchargeLines: d,
    priceTotal: C
  };
}), Z_t = (e, t) => (i) => {
  if (!t)
    return;
  const n = Le.flow(Br, Le.find(Vye(e, t)))(i);
  if (n)
    return Le.flow($l, Le.find(
      (r) => (
        // JVI 27.5.: Bei Dropdowns ist nun Value.value==null. Bei Zahlenvariablen ohne Intervalle ist selection.valueId null.
        // Dann wird hier ein Dropdown-Wert für eine Zahlenvariable geliefert, wenn nicht auf value.value!=null geprüft wird.
        r.id == (n == null ? void 0 : n.valueId)
      )
      // ||
      // (value.value != null && value.value == selection?.valueId)
    ))(i);
}, _B = (e, t) => (i) => {
  const n = t;
  return Em(i, (r) => r.price.type !== Bc.fixed || r.articleAction.variableId === e && (!n.instance.id || r.articleAction.anchoringSelection.instance.id == n.instance.id));
}, n0t = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR"
}), yA = (e) => n0t, G_t = (e, t) => (i) => {
  var b;
  const n = /* @__PURE__ */ new Date(), r = Pi(i), g = i.common.dealerData, o = (b = g.apps) == null ? void 0 : b.find((m) => m.appId == (r == null ? void 0 : r.id)), l = (g == null ? void 0 : g.discount) || 0, a = (g == null ? void 0 : g.surcharge) || 0, I = (o == null ? void 0 : o.discount) != 0 ? o == null ? void 0 : o.discount : null, c = (o == null ? void 0 : o.surcharge) != 0 ? o == null ? void 0 : o.surcharge : null, d = I ?? l, C = c ?? a, A = Uq(i, e).filter((m) => !m.displayOnly && (m.fromDate == null || new Date(m.fromDate) <= n) && (m.toDate == null || new Date(m.toDate) >= n) && (m.fromQty == null || m.fromQty == 0 || m.fromQty <= t) && (m.toQty == null || m.toQty == 0 || m.toQty >= t)).sort((m, p) => m.sort - p.sort).map((m) => ({
    ...m,
    price: m.price * (1 - d / 100) * (1 + C / 100)
  }));
  return A.length == 0 ? {
    price: 0,
    type: Bc.fixed
  } : A[0];
}, r0t = (e, t) => (i) => {
  var g;
  const n = Em(i, (o, l, a) => e(o, l, a) || (t ? !1 : o.price.type != Bc.fixed));
  return de.sum((g = n == null ? void 0 : n.articleLines) == null ? void 0 : g.map((o) => t ? o.price.price : o.priceTotal));
}, WA = (e) => {
  let t = Em(e).priceTotal;
  return t = VI("setPrice", t), t;
}, qq = (e) => (t) => {
  if (!e.id)
    return WA(t);
  const i = _q(e)(t);
  return (i == null ? void 0 : i.priceTotal) || 0;
}, g0t = (e, t, i) => (n) => {
  var o;
  const r = _q(t, e, i)(n);
  return de.sum((o = r == null ? void 0 : r.articleLines) == null ? void 0 : o.map((l) => l.priceTotal));
}, _q = (e, t, i) => (n) => {
  const r = e;
  return r.id ? Em(n, (o, l, a) => o.articleAction.anchoringSelection.instance.belongsToInstanceId == r.id || o.articleAction.anchoringSelection.instance.id == r.id && (!t || t(o, l, a)) || !i && o.price.type != Bc.fixed) : null;
}, tS = (e, t) => de.reduce(e, (i, n) => i + t(n), 0), ys = (e) => Math.round(e * 100) / 100, $q = (e) => (t, i) => {
  const n = _l(e).slice().sort(gA), r = Og(e), g = YWe(e);
  return n.filter((l) => l.parentId == t).flatMap((l) => r.filter((a) => !!a && a.groupId == l.id).sort(gA).flatMap((a) => g.filter((I) => a.id == I.variableId && (I.instance.id == i || I.instance.belongsToInstanceId == i)).map((I) => ({
    v: a,
    s: I
  }))).filter(({
    s: a
  }) => a != null).map(({
    v: a,
    s: I
  }, c) => o0t(e)(l, c, a, I)));
}, o0t = (e) => (t, i, n, r) => {
  const {
    priceTotal: g,
    articleLines: o,
    surchargeLines: l
  } = _B(n.id, r)(e), a = km(n) ? $q(e)(n.id, r.id) : null, I = qq(r)(e), c = a != null && a.length ? I : g;
  return {
    group: t,
    index: i,
    variable: n,
    selectionLabel: String(a0t(r)(e)),
    selection: r,
    bom: {
      articleLines: o,
      surchargeLines: l,
      priceTotal: c
    },
    subVariables: a
  };
}, e_ = (e) => $q(e)(null, "");
function l0t(e, t) {
  return e.filter((i) => fWe(i.variable, i.selection)(t));
}
function t_(e, t) {
  return l0t(e, t).map((i) => i.subVariables ? {
    ...i,
    subVariables: t_(i.subVariables, t)
  } : i);
}
function y_t(e) {
  const t = e_(e);
  return t_(t, e);
}
const W_t = (e) => (t) => Le.flow(
  //
  xJ(e),
  Oq,
  (i) => H6(i)(t)
)(t), S_t = (e) => {
  const t = yA(), i = WA(e);
  return t.format(i);
}, a0t = (e) => (t) => {
  var g, o, l, a;
  if (!e)
    return null;
  if (pv(e)) {
    const I = qr(e.variableId)(t);
    return Number((g = e.data) == null ? void 0 : g.inputValue).toFixed(Vi(I).digits || 0);
  }
  const i = qr(e.variableId)(t);
  if (Hm(i))
    return ((o = e == null ? void 0 : e.data) == null ? void 0 : o.inputText) || "";
  const r = $l(t).find((I) => I.id == e.valueId);
  return (r == null ? void 0 : r.label) || ((l = e.data) == null ? void 0 : l.inputText) || ((a = e.data) == null ? void 0 : a.inputValue) || "";
}, i_ = (e) => Le.flow(kv(e), Le.find((t) => t.key === Ff)), V_t = (e) => _l(e).filter((i) => i.parentId == null), bu = Ci([_l, (e, t) => t], (e, t) => {
  const i = t.instance.belongsToVariableId;
  return e.filter((n) => n.parentId == i);
}), s0t = Ci([J9, (e, t) => bu(e, t), (e, t) => t], (e, t) => t.flatMap((i) => e[i.id] || [])), N9 = Ci([nr, Jr, (e, t) => t, (e, t) => s0t(e, t)], (e, t, i, n) => !e || !t ? (console.warn("Rule engine not initialized!"), {}) : n.reduce((r, g) => {
  const o = mv(g, e, t.state, i.id);
  return r[g.id] = o, r;
}, {})), I0t = (e, t, i) => e.filter((n) => jq(t, n.id).some((g) => NJ(g, i.id)(t) === null)), i1 = (e, t) => {
  const i = bu(e, t);
  return I0t(i, e, t);
}, n1 = Ci([(e, t) => bu(e, t), N9, J9], (e, t, i) => e.filter((n) => (i[n.id] || []).every((g) => t[g.id] !== null))), c0t = Ci([R6, vc, (e, t) => t, Br], (e, t, i, n) => {
  const r = nA(n, i);
  return de.uniqBy([i, ...r].flatMap((o) => (e[o.id] ?? []).map((a) => t[a])).filter((o) => !!o), (o) => o.id);
}), BM = [], L9 = Ci([(e, t) => t ? c0t(e, t) : BM, (e, t) => t ? i1(e, t) : BM], (e, t) => Object.values(e.reduce((n, r) => {
  const g = t.find((o) => !!r && o.id === r.groupId);
  return g && !n[g.id] && (n[g.id] = g), n;
}, {}))), n_ = (e) => (t) => !!i1(t, e).find((r) => r.parentId === e.variableId), r_ = (e) => (t) => {
  const i = g_(t), n = $r(t);
  if (!i || n)
    return !0;
  const r = JJ(t, e.id);
  if (!r)
    return !0;
  const g = i1(t, r), o = L9(t, r), l = de.maxBy(o, (A) => A.sort), a = l ? g.findIndex((A) => A.id === l.id) : 0, I = cu(t, r), c = Math.max(g.findIndex((A) => A.id === I), 0), d = de.clamp(Math.max(a, c) + 1, 0, g.length);
  return g.findIndex((A) => A.id === e.id) <= d;
}, w_t = (e) => (t) => {
  if (!e)
    return [];
  const i = _l(t), n = An(i), r = Le.find((I) => I.parentId == e, i), g = Og(t), o = An(g);
  let l, a = [r];
  for (; e; ) {
    l = o[e];
    const I = n[l.groupId];
    a = [I, ...a], e = I.parentId;
  }
  return a;
}, d0t = Ci([vc, (e, t) => t], (e, t) => {
  if (!t)
    return [];
  let i = [];
  for (; t; ) {
    const n = e[t];
    i = [n, ...i], t = n == null ? void 0 : n.parentId;
  }
  return i;
}), u0t = (e) => {
  const t = Pi(e);
  return t0t(t);
}, g_ = (e) => {
  var i, n;
  const t = Pi(e);
  return ((n = (i = t == null ? void 0 : t.settings) == null ? void 0 : i.design) == null ? void 0 : n.revealGroups) || !1;
}, o_ = (e) => {
  var i, n;
  const t = Pi(e);
  return ((n = (i = t == null ? void 0 : t.settings) == null ? void 0 : i.design) == null ? void 0 : n.addCheckMarkToVisitedTabs) || !1;
}, v_t = (e) => (t) => {
  const i = e.reduce(
    // @ts-ignore
    (n, r) => [...n, ...Oq(r)],
    []
  );
  return H6(i)(t);
}, SA = (e) => {
  var t;
  return !!((t = e == null ? void 0 : e.configurator) != null && t.app);
}, C0t = Ci([VZ, i9, l8], (e, t, i) => {
  const n = t[e.variableId], r = An(n);
  return i.some((g) => r[g.valueId]);
}), A0t = (e) => (t) => {
  const i = qr(e)(t);
  return i ? kI(i.groupId)(t) : void 0;
}, K9 = Ci([VZ, Br, i9, C0t], (e, t, i, n) => {
  const r = t.filter((g) => g.variableId === e.variableId);
  if (n) {
    const g = i[e.variableId], o = An(g);
    r.sort((l, a) => {
      if (l.valueId && a.valueId) {
        const I = o[l.valueId], c = o[a.valueId];
        return ((I == null ? void 0 : I.sort) ?? 0) - ((c == null ? void 0 : c.sort) ?? 0) || (l.sort ?? 0) - (a.sort ?? 0);
      }
      return (l.sort ?? 0) - (a.sort ?? 0);
    });
  } else
    r.sort((g, o) => (g.sort ?? 0) - (o.sort ?? 0));
  return r;
}), R_t = Ci([nr], (e) => {
  var t, i;
  return An(((i = (t = e == null ? void 0 : e.values) == null ? void 0 : t.flat) == null ? void 0 : i.all) ?? []);
}), X_t = (e, t) => (i) => gye(i).filter((r) => {
  var g, o;
  return ((g = r.ruleColumn) == null ? void 0 : g.id) === e && ((o = r.ruleItem) == null ? void 0 : o.id) === t;
}), b0t = (e) => (t) => {
  const i = yv(e)(t), n = Ym(t, i);
  return n.length > 0 ? n[0] : Ut;
}, TZ = (e, t) => {
  const i = n1(e, t), n = bu(e, t);
  return n.filter((g) => g.parentId === (t == null ? void 0 : t.variableId)).find((g) => !t1(g, i)) ?? n[0];
}, DI = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.app;
}, H_t = (e) => e.configurator.searchString, k_t = (e) => {
  var t;
  return (t = DI(e)) == null ? void 0 : t.id;
}, $r = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.showEditorUi;
}, h0t = (e) => e.configurator.device, Y_t = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.devmode;
}, F_t = (e) => {
  var t;
  return (t = e.configurator) == null ? void 0 : t.helpTopic;
}, T9 = (e, t) => {
  var r;
  let i = cu(e, t);
  return i || (i = (r = TZ(e, t)) == null ? void 0 : r.id), kI(i)(e);
}, x_t = (e, t) => (i) => {
  var r, g, o;
  let n = T9(i, t);
  for (let l = 0; l < 20; l++) {
    if (!n)
      return null;
    if (((o = (g = (r = n.settings) == null ? void 0 : r.theme) == null ? void 0 : g[e]) == null ? void 0 : o.selected) === "custom")
      return n;
    if (!n.parentId)
      return null;
    n = WWe(n.parentId)(i);
  }
  return null;
}, D_t = (e) => {
  const t = DI(e);
  return BWe(e, t == null ? void 0 : t.id);
}, J_t = (e) => {
  const t = DI(e);
  return _pt(t == null ? void 0 : t.id, e);
}, E_t = (e) => {
  const t = DI(e);
  return qpt(t == null ? void 0 : t.id, e);
}, N_t = (e) => {
  const t = DI(e);
  return Mq(e, t == null ? void 0 : t.id);
}, L_t = (e) => {
  const t = DI(e);
  return lWe(e, t == null ? void 0 : t.id);
}, K_t = (e) => {
  const t = DI(e), i = Mq(e, t == null ? void 0 : t.id);
  return Le.flow(Le.map((n) => n.category), Le.compact, Le.uniq)(i);
}, m0t = (e) => e.configurator.popupAction, p0t = [], B0t = Ci([DI, Pq], (e, t) => t[e == null ? void 0 : e.id] ?? p0t), T_t = Ci([B0t], (e) => e.reduce((t, i) => {
  const n = t[i.articleId];
  return n && n.sort < i.sort || (t[i.articleId] = i), t;
}, {})), M9 = () => {
  const e = ie(D6);
  return Gt((t) => e[t], [e]);
}, Vg = () => {
  const e = M9(), t = _v(), i = ie(Er), n = U9(), r = ie($r);
  return Gt((g, o, l) => {
    var c, d;
    const a = ((c = t.find((C) => C.key === g)) == null ? void 0 : c.defaultValue) ?? o ?? "", I = i === "de" || !r || !a ? a : `[${a}]`;
    return (((d = e(g)) == null ? void 0 : d[i]) || n(a) || I).replace(/\{\{(\w+)\}\}/g, (C, A) => (l == null ? void 0 : l[A]) || "{{" + A + "}}");
  }, [t, i, r, e, n]);
}, f0t = () => {
  const e = M9(), t = _v();
  return Gt((i, n) => {
    var r;
    return e(i) ?? (n || ((r = t.find((g) => g.key === i)) == null ? void 0 : r.defaultValue));
  }, [e, t]);
}, Z0t = (e) => e.split(", ").map((t) => {
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
}), M_t = () => {
  const e = M9(), t = _v();
  return Gt((i, n, r) => {
    const g = e(i), o = t.find((a) => a.key === i), l = n || o.parser || Z0t;
    return g ? l(g) : r || (o == null ? void 0 : o.defaultValue) || [];
  }, [e, t]);
}, P9 = ({
  value: e
}) => {
  const t = ie(Er), i = Vg();
  return typeof e == "string" ? /* @__PURE__ */ S(li, { children: i(e) }) : /* @__PURE__ */ S(li, { children: r1(e, t) });
}, r1 = (e, t, i, n = !0) => {
  const r = e == null ? void 0 : e[t];
  if (r)
    return r;
  {
    const g = Tq() && !zpt(), o = n === !0 && (e != null && e.de) ? e.de : i;
    return n === !0 && o ? l_(o, t, g ? `[${o}]` : o, !1) || o : "";
  }
}, l_ = (e, t, i, n = !0) => Ug(e, {
  lng: t,
  fallback: n,
  defaultValue: i
}) || i, G0t = (e, t) => typeof e == "string" ? {
  de: (e == null ? void 0 : e.toString()) || t
} : e, P_t = (e, t, i) => {
  const n = G0t(e, i);
  return n ? r1(n, t, i, !0) : "";
}, U9 = () => {
  const e = ie(Er);
  return (t) => l_(t, e, t);
};
async function y0t(e, t, i) {
  const n = new FormData();
  return n.append("app", e.code), n.append("path", t), i.forEach((r) => {
    n.append("file[]", r);
  }), du("POST", "/doc", n);
}
async function U_t(e) {
  return du("GET", `/tmpl/${e}`);
}
const W0t = (e) => e ? e.map((t) => t.toLowerCase() === "jpg" ? "jpeg" : t).map((t) => t.toLowerCase() === "svg" ? "svg+xml" : t).map((t) => `image/${t}`).join(",") : "image/*", fM = ({
  acceptedImageFormats: e,
  translate: t
}) => /* @__PURE__ */ Ie(li, { children: [
  /* @__PURE__ */ S(Ct, { component: "b", variant: "body1", children: t("Das Dateiformat ist nicht erlaubt!") }),
  /* @__PURE__ */ S(Ct, { component: "small", variant: "caption", children: `${t("Erlaubte Formate:")} ${e.join(", ")}` })
] }), a_ = De.memo(({
  acceptedImageFormats: e = ["png", "jpg"],
  ...t
}) => {
  const i = U9(), {
    t: n
  } = Gi(), r = (V) => (t.target != "frontend" ? n(V) : i(V)) || "", g = ot(null), [o, l] = wt(!1), [a, I] = wt(null), [c, d] = wt(void 0), C = 250, [A, b] = wt(C), [m, p] = wt(!1);
  lt(() => {
    t.onUploading && t.onUploading(m);
  }, [m]), lt(() => {
    t.url != c && d(t.url);
  }, [t.url]);
  const B = Gt((V) => {
    let w = V == null ? void 0 : V.split(".").pop().toLowerCase();
    return w = w === "jpeg" ? "jpg" : w, e == null ? void 0 : e.includes(w);
  }, [e]), f = (V) => {
    var w;
    V.stopPropagation(), (w = g.current) == null || w.click();
  }, Z = (V) => new Promise((w) => {
    const v = document.createElement("img");
    v.src = V, v.onload = () => {
      v.height < A ? w(v.height) : A != C ? w(C) : w(0);
    };
  }), y = Gt((V) => {
    const w = async (v) => {
      p(!0);
      try {
        let H = "";
        t.storeLocally ? H = window.URL.createObjectURL(v) : H = (await y0t(t.app, "image", [v]))[v.name], Z(H).then((x) => {
          I(v), d(H), t.onUrlChange && t.onUrlChange(H), x > 0 && b(x);
        });
      } catch {
        kZ(/* @__PURE__ */ S(Ct, { children: n("Datei konnte nicht hochgeladen werden.") }));
      }
      p(!1);
    };
    e ? V == null || B(V.name) ? (l(!1), w(V)) : l(!0) : w(V);
  }, [t, B, e]), W = (V) => {
    V == null || V.stopPropagation(), l(!1), d(void 0), I(null), t.onDelete();
  };
  return /* @__PURE__ */ S(ht, { component: "div", sx: {
    width: 1,
    height: 1
  }, display: "flex", alignItems: "center", flexWrap: "wrap", "data-cy": t["data-cy"], children: /* @__PURE__ */ S(Tn, { disableInteractive: !1, disableHoverListener: t.disabled, disableFocusListener: t.disabled, leaveDelay: 500, title: /* @__PURE__ */ Ie(ht, { component: "div", display: "flex", flexDirection: "column", children: [
    o && /* @__PURE__ */ S(fM, { acceptedImageFormats: e, translate: r }),
    !o && !a && !c && e && /* @__PURE__ */ S(Ct, { component: "small", variant: "caption", children: `${r("Bild hochladen")}. ${r("Erlaubte Formate:")} ${e.join(", ")}` }),
    c && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      display: "grid",
      gap: 1,
      gridAutoFlow: "column"
    }, children: [
      /* @__PURE__ */ S(fn, { "data-cy": "replace", variant: "outlined", size: "small", color: "inherit", onClick: f, startIcon: /* @__PURE__ */ S(LAt, { color: "inherit" }), children: r("Ersetzen") }),
      /* @__PURE__ */ S(fn, { "data-cy": "delete", variant: "outlined", size: "small", color: "inherit", onClick: W, startIcon: /* @__PURE__ */ S(Ev, { color: "inherit" }), children: r("Löschen") })
    ] })
  ] }), children: /* @__PURE__ */ S(ht, { component: "div", sx: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, children: /* @__PURE__ */ Ie(Xo, { "data-cy": "imageUpload", disabled: t.disabled, "aria-label": t.buttonLabel ?? n("Bild hochladen"), sx: {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0 20px"
  }, onClick: f, children: [
    o && /* @__PURE__ */ S(fM, { acceptedImageFormats: e, translate: r }),
    m ? /* @__PURE__ */ S(Gj, { sx: {
      width: "100%"
    } }) : /* @__PURE__ */ Ie(li, { children: [
      /* @__PURE__ */ S("input", { "data-cy": "imageInput", ref: g, onChange: (V) => {
        var w, v;
        if ((v = (w = V == null ? void 0 : V.target) == null ? void 0 : w.files) != null && v[0]) {
          const H = V.target.files[0];
          y(H), V.target.value = "";
        }
      }, type: "file", accept: W0t(e), hidden: !0 }),
      c ? /* @__PURE__ */ S("img", { style: {
        objectFit: "contain",
        flex: 1,
        overflow: "hidden",
        height: c ? A : "45px",
        padding: 1,
        maxHeight: "100%"
      }, alt: "", src: c }) : /* @__PURE__ */ S(OAt, {})
    ] })
  ] }) }) }) });
}), s_ = De.memo((e) => /* @__PURE__ */ S(Ct, { component: "div", color: "textSecondary", className: Re("k3-form-label", e.className), children: e.children }));
var z9 = {}, S0t = yg;
Object.defineProperty(z9, "__esModule", {
  value: !0
});
var I_ = z9.default = void 0, V0t = S0t(oo()), w0t = ro;
I_ = z9.default = (0, V0t.default)(/* @__PURE__ */ (0, w0t.jsx)("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings");
const v0t = (e) => (lt(() => {
  const t = e.targetRef.current, i = (o) => {
    const l = t.getBoundingClientRect();
    (o.touches[0].clientX < l.left || o.touches[0].clientX > l.right || o.touches[0].clientY < l.top || o.touches[0].clientY > l.bottom) && e.onClickAway(o);
  }, n = (o) => {
    const l = t.getBoundingClientRect();
    (o.clientX < l.left || o.clientX > l.right || o.clientY < l.top || o.clientY > l.bottom) && e.onClickAway(o);
  }, r = (o) => {
    const l = t.getBoundingClientRect();
    o.clientX > l.left && o.clientX < l.right && o.clientY > l.top && o.clientY < l.bottom && e.onClickInside(o);
  }, g = (o) => {
    const l = t.getBoundingClientRect();
    o.touches[0].clientX > l.left && o.touches[0].clientX < l.right && o.touches[0].clientY > l.top && o.touches[0].clientY < l.bottom && e.onClickInside(o);
  };
  return t && (e.onClickAway && window.addEventListener("click", n), e.onClickAway && window.addEventListener("touchstart", i), e.onClickInside && t.addEventListener("click", r), e.onClickInside && t.addEventListener("touchstart", g)), () => {
    window.removeEventListener("click", n), window.removeEventListener("touchstart", i), t.removeEventListener("click", r), t.removeEventListener("touchstart", g);
  };
}, [e.onClickAway, e.onClickInside, e.targetRef]), /* @__PURE__ */ S(li, { children: e.children })), R0t = (e) => /* @__PURE__ */ Ie(li, { children: [
  e.children,
  /* @__PURE__ */ S(P2, { in: e.showUnfoldContent, children: /* @__PURE__ */ Ie(li, { children: [
    e.divider && /* @__PURE__ */ S(SI, {}),
    e.unfoldContent
  ] }) })
] }), X0t = (e) => {
  const t = ot(null);
  return /* @__PURE__ */ Ie(li, { children: [
    (e.showUnfoldContent || e.alwaysShowContour) && /* @__PURE__ */ S(v0t, { targetRef: t, onClickAway: e.onClickAway, onClickInside: e.onClickInside, children: /* @__PURE__ */ S(pi, { sx: {
      ml: -2
    }, children: /* @__PURE__ */ S(ul, { "data-cy": "variableContainer_", elevation: e.showUnfoldContent || e.alwaysShowContour ? 4 : 0, sx: {
      pt: 0,
      pb: 2,
      pl: 2,
      pr: 2,
      transition: "all 0.3s"
    }, ref: t, children: /* @__PURE__ */ S(R0t, { ...e }) }) }) }),
    !e.showUnfoldContent && !e.alwaysShowContour && e.children
  ] });
}, H0t = (e) => {
  var n;
  const [t, i] = wt(!1);
  return lt(() => {
    e.hideAdvancedSettings && i(!1);
  }, [e.hideAdvancedSettings]), /* @__PURE__ */ S(X0t, { unfoldContent: e.advancedSettings, onClickAway: () => i(!1), showUnfoldContent: !e.hideAdvancedSettings && t, children: /* @__PURE__ */ S(kd, { ...e, InputProps: {
    ...e.InputProps,
    ...!e.hideAdvancedSettings && {
      endAdornment: /* @__PURE__ */ Ie(li, { children: [
        (n = e.InputProps) == null ? void 0 : n.endAdornment,
        /* @__PURE__ */ S(Uh, { position: "end", children: /* @__PURE__ */ S(Ni, { "data-cy": "advanceedSettingsButton", size: "small", onClick: () => {
          i(!t);
        }, children: /* @__PURE__ */ S(I_, {}) }) })
      ] })
    }
  } }) });
}, k0t = (e, t, i, n, r = 500) => {
  const [g, o] = wt({
    value: t,
    preDebounceValue: t
  });
  lt(() => {
    e && g.preDebounceValue !== t && o({
      value: t,
      preDebounceValue: t
    });
  }, [e, t, g.preDebounceValue]);
  const l = Gt(de.debounce((c) => {
    o((d) => ({
      ...d,
      value: c
    })), i && i(c);
  }, r), [i]), a = Gt((c) => {
    o((d) => ({
      ...d,
      value: c
    })), l(c);
  }, [l]), I = (c) => {
    e && l.flush(), n && n(c);
  };
  return {
    debouncedValue: g.value,
    handleDebouncedChange: a,
    handleDebouncedBlur: I
  };
}, al = dl(({
  TextFieldProps: {
    defaultValue: e,
    error: t,
    helperText: i,
    inputProps: n,
    ...r
  } = {},
  advancedSettings: g,
  "data-cy": o,
  ...l
}, a) => {
  const {
    t: I
  } = Gi(), {
    minRows: c,
    maxRows: d,
    name: C,
    type: A,
    autoComplete: b,
    disabled: m,
    required: p,
    multiline: B,
    placeholder: f,
    autoFocus: Z
  } = l;
  Object.assign(r, {
    minRows: c,
    maxRows: d,
    name: C,
    type: A,
    autoComplete: b,
    disabled: m,
    required: p,
    multiline: B,
    placeholder: f,
    autoFocus: Z
  });
  const y = (L) => {
    var U, O;
    l.stopPropagation && L.stopPropagation();
    const N = L.target.value;
    (U = r.onChange) == null || U.call(r, L), (O = l.onChange) == null || O.call(l, N);
  }, W = (L) => {
    var O;
    L.stopPropagation();
    const N = L.key === "Enter", {
      value: U
    } = L.target;
    N && ((O = l.onConfirm) == null || O.call(l, U));
  }, V = (L) => {
    var N, U;
    (N = r.onBlur) == null || N.call(r, L), (U = l.onBlur) == null || U.call(l, L);
  }, {
    debouncedValue: w,
    handleDebouncedChange: v,
    handleDebouncedBlur: H
  } = k0t(l.debounced, l.value || "", l.onChange, V, l.debounceTimeMs), x = Gt((L) => v(L.target.value), [v]), J = Oe(() => g ? (r.advancedSettings = g, H0t) : kd, [g]), K = l["aria-label"] || l.label, M = de.merge({}, n, {
    "data-cy": o,
    "aria-label": K
  });
  return /* @__PURE__ */ Ie(ja, { fullWidth: l.fullWidth, className: Re("k3-text-input-container", l.className), children: [
    /* @__PURE__ */ S(s_, { children: OZe(l.label) ? I(l.label) : l.label }),
    /* @__PURE__ */ S(J, { variant: "outlined", onKeyDown: W, InputLabelProps: {
      shrink: !l.label
    }, defaultValue: e, inputRef: a, error: t, helperText: i ? /* @__PURE__ */ S(li, { children: i }) : void 0, inputProps: M, ...r, onChange: l.debounced ? x : y, onBlur: l.debounced ? H : V, value: l.debounced ? w : l.value })
  ] });
}), Y0t = (e) => de.isNumber(e) ? (t) => t.toFixed(e) : Le.identity, F0t = (e) => (t) => Math.round(t / e) * e, O9 = ({
  "aria-label": e,
  TextFieldProps: t = {},
  min: i = -1 / 0,
  max: n = 1 / 0,
  digits: r,
  step: g = 1,
  unit: o,
  onChange: l,
  onConfirm: a,
  debounced: I,
  debounceTimeMs: c,
  onChangeByStep: d,
  onBlur: C,
  onClear: A,
  value: b,
  allowEmpty: m,
  roundToStep: p = !1,
  buttons: B = !1,
  calculated: f = !1,
  label: Z,
  useRaw: y,
  forceLimit: W,
  fullWidth: V,
  disabled: w,
  placeholder: v,
  stopPropagation: H,
  "data-cy": x
}) => {
  const {
    t: J
  } = Gi(), K = i ?? -1 / 0, M = n ?? 1 / 0, L = ot(), N = Gt((He) => M3(!!He, Le.flow(parseFloat, M3(p, F0t(g)), Le.clamp(K, M), Y0t(r)))(He), [r, M, K, p, g]), U = Gt((He) => {
    const Je = He.target.value;
    if (y) {
      const ke = W ? N(Je) : Je;
      l(ke);
    } else
      C ? C(N(Je)) : l(!Je && !m ? Le.toString(K) : Le.toString(N(Je)));
  }, [l, N, K, C, y]), O = Gt((He) => {
    var ke;
    const Je = Number(b) + g * (He ? 1 : -1);
    (ke = d || l) == null || ke(Je);
  }, [l, d, g, b]), $ = Gt(() => O(!0), [O]), ne = Gt(() => O(!1), [O]), be = Oe(() => ({
    sx: {
      "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0
      },
      "input[type=number]": {
        MozAppearance: "textfield"
      }
    },
    ...B ? {
      startAdornment: /* @__PURE__ */ Ie(Uh, { position: "start", children: [
        /* @__PURE__ */ S(Ni, { "data-cy": "plus", className: "k3-number-icon k3-number-icon-plus", sx: {
          p: 0.5
        }, onClick: $, tabIndex: -1, disabled: w, "aria-label": J("Plus"), children: /* @__PURE__ */ S($8, {}) }, "add-button"),
        /* @__PURE__ */ S(Ni, { "data-cy": "minus", className: "k3-number-icon k3-number-icon-minus", sx: {
          p: 0.5
        }, onClick: ne, tabIndex: -1, disabled: w, "aria-label": J("Minus"), children: /* @__PURE__ */ S(ibt, {}) }, "remove-button")
      ] }, "adornment")
    } : {},
    ...o || A ? {
      endAdornment: /* @__PURE__ */ Ie(Uh, { position: "end", children: [
        o,
        A && /* @__PURE__ */ S(Ni, { "data-cy": "clear", size: "small", onMouseDown: (He) => {
          He.preventDefault(), He.stopPropagation(), A();
        }, tabIndex: -1, children: /* @__PURE__ */ S(Ev, {}) }, "clear")
      ] })
    } : {},
    ...f ? {
      startAdornment: /* @__PURE__ */ S(Uh, { position: "start", children: "=" })
    } : {}
  }), [B, f, w, ne, $, A, J, o]), Ve = Oe(() => {
    var He;
    return Le.merge(t, {
      type: "number",
      inputProps: {
        readOnly: f,
        step: g,
        style: {
          textAlign: ((He = t == null ? void 0 : t.style) == null ? void 0 : He.textAlign) || "right"
        }
      }
    });
  }, [t, f, g]);
  return /* @__PURE__ */ S(al, { "data-cy": x, ref: L, value: !m || b ? b : "", onChange: l, onBlur: U, TextFieldProps: {
    ...Ve,
    InputProps: be
  }, type: "number", label: Z, fullWidth: V, debounced: I, onConfirm: a, debounceTimeMs: c, disabled: w, placeholder: v, className: "k3-number-input", stopPropagation: H, "aria-label": e });
}, x0t = {
  formControlLabel: {
    width: 1,
    margin: 0,
    "& .MuiTypography-root": {
      width: 1
    }
  }
};
function c_(e) {
  const {
    checked: t,
    onChange: i,
    ...n
  } = e.SwitchProps || {}, r = t === void 0 ? e.checked : t, g = (o) => {
    i && i(o, !!o.target), e.onChange && e.onChange(o.target.checked);
  };
  return /* @__PURE__ */ Ie(ja, {
    fullWidth: !0,
    variant: "outlined",
    sx: e.sx,
    // If label is a string, wrap it in a Typography component
    // If label is a ReactElement, render it as is
    children: [
      typeof e.label == "string" ? /* @__PURE__ */ S(Ct, { color: "textSecondary", children: e.label }) : e.label,
      /* @__PURE__ */ S(rv, { sx: x0t.formControlLabel, componentsProps: {
        typography: {
          color: "text.primary"
        }
      }, control: /* @__PURE__ */ S(Fj, { "data-cy": e["data-cy"], checked: r || !1, onChange: g, ...n }), label: e.description || "" })
    ]
  });
}
const D0t = (e) => {
  const [t, i] = wt(""), n = (r) => {
    const g = e.setting.isValid || e.setting.valueType === Gd.ARRAY ? Qpt : void 0;
    if (g) {
      const [o, l] = g(r);
      i(l), o && e.setValue(r);
    } else
      e.setValue(r);
  };
  return /* @__PURE__ */ Ie(ht, { component: "div", children: [
    /* @__PURE__ */ S(J0t, { setting: e.setting, value: e.value, setValue: n }),
    t && /* @__PURE__ */ S(Ct, { pt: 1, color: "error", children: t })
  ] });
}, J0t = ({
  setting: e,
  value: t,
  setValue: i
}) => {
  var a;
  const {
    t: n
  } = Gi(), r = Vg(), g = n(e.label || (typeof e.defaultValue == "string" ? e.defaultValue : e.key)), o = ie(Er), l = ie(DI);
  if ([Gd.STRING, Gd.ARRAY].includes(e.valueType))
    return /* @__PURE__ */ S(al, { "data-cy": `dynamic-${t}`, value: t || "", onChange: i, label: g, fullWidth: !0, placeholder: e.defaultValue, stopPropagation: !0 });
  if (e.valueType === Gd.NUMBER)
    return /* @__PURE__ */ S(O9, { onChange: i, value: t, label: g, fullWidth: !0, "data-cy": "dynamicNumberInput", min: e.min || 0, max: e.max || void 0, placeholder: ((a = e.defaultValue) == null ? void 0 : a.toString()) || void 0, stopPropagation: !0 });
  if (e.valueType === Gd.TRANSLATION) {
    const I = t, c = r("", e.defaultValue);
    return /* @__PURE__ */ S(al, { "data-cy": "dynamicTranslation", value: (I == null ? void 0 : I[o]) || "", onChange: (d) => i({
      ...I,
      [o]: d
    }), label: n(g), multiline: e.textarea, fullWidth: !0, stopPropagation: !0, placeholder: c != null && c.startsWith("[") ? c.replace(/\[|\]/g, "") : c });
  }
  if (e.valueType === Gd.BOOLEAN) {
    const I = t ?? e.defaultValue;
    return /* @__PURE__ */ S(c_, { checked: I, onChange: i, label: g, "data-cy": "dynamicBoolean" });
  }
  return e.valueType === Gd.IMAGE ? /* @__PURE__ */ S(a_, { url: t, app: l, onDelete: () => i(void 0), onUrlChange: i, "data-cy": "imageUpload" }) : /* @__PURE__ */ S(Ct, { children: "This type of setting is not implemented yet." });
}, E0t = ({
  values: e,
  setValues: t
}) => {
  const i = tAt("keys"), {
    keys: n,
    settings: r
  } = ie((I) => I.configurator.dynamicSettingsEditing) || {}, g = _v(), o = ie(D6), l = (I) => (c) => t({
    ...e,
    [I]: c
  }), a = Oe(() => {
    var I;
    return !(i != null && i.length) && (r != null && r.length) ? r : (I = n != null && n.length ? n : i) == null ? void 0 : I.map((c) => g.find((C) => C.key === c)).filter((c) => !!c);
  }, [i, g]);
  return a != null && a.length ? /* @__PURE__ */ S(ht, { component: "div", children: a.map((I) => /* @__PURE__ */ S(ht, { component: "div", mb: 2, children: /* @__PURE__ */ S(D0t, { setting: I, value: e[I.key] ?? o[I.key], setValue: l(I.key) }) }, I.key)) }) : (console.error("DynamicSettingsForm: Could not find dynamic settings to display."), null);
}, $a = (e) => {
  console.error("FETCH-ERROR", e);
};
async function d_(e, t, i = {}) {
  try {
    return await wi("POST", `/${e}`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function N0t(e, t, i = {}) {
  try {
    return await wi("POST", `/${e}/bulk`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function L0t(e, t, i = {}) {
  try {
    return await wi("GET", `/${e}/${t}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function z_t(e, t, i = {}) {
  try {
    const n = new URLSearchParams(t);
    return await wi("GET", `/${e}?${n}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function Q9(e, t, i = {}) {
  try {
    const n = t.id, r = de.omit(t, "id");
    return await wi("PUT", `/${e}/${n}`, r, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function O_t(e, t, i = {}) {
  try {
    return await wi("PUT", `/${e}`, t, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function u_(e, t) {
  try {
    await wi("DELETE", `/${e}/${t}`);
  } catch (i) {
    throw $a(i), i;
  }
}
async function Q_t(e, t) {
  try {
    await wi("PUT", `/${e}/delete`, t);
  } catch (i) {
    throw $a(i), i;
  }
}
async function j_t(e, t, i, n = {}) {
  try {
    if (!n.appCode)
      throw new Error("Missing App Code for uploadContent!");
    const r = new FormData();
    return r.append("app", n.appCode), e && r.append("path", e + i), (Array.isArray(t) ? t : [t]).forEach((g) => {
      g instanceof File ? r.append("file[]", g, g.name) : r.append("file[]", g.blob, g.fileName);
    }), await du("POST", "/doc", r);
  } catch (r) {
    throw $a(r), r;
  }
}
async function q_t(e, t, i, n = {}) {
  try {
    if (!n.appCode)
      throw new Error("Missing App Code for uploadTmpContent!");
    const r = new FormData();
    return r.append("app", n.appCode), e && r.append("path", e + i), (Array.isArray(t) ? t : [t]).forEach((g) => {
      g instanceof File ? r.append("file[]", g, g.name) : r.append("file[]", g.blob, g.fileName);
    }), await du("POST", "/doc/tmp", r);
  } catch (r) {
    throw alert(r), $a(r), r;
  }
}
async function __t(e, t, i = {}) {
  try {
    const n = new URLSearchParams(t);
    return await wi("GET", `/${e}/trash?${n}`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
async function $_t(e, t, i = {}) {
  try {
    return await wi("GET", `/${e}/${t}/undelete`, null, {
      lang: i == null ? void 0 : i.lang
    });
  } catch (n) {
    throw $a(n), n;
  }
}
function e$t(e) {
  const t = Dm(), i = ie(Er);
  return $J((n) => d_(e, n, {
    lang: i
  }), {
    onSuccess: () => {
      t.invalidateQueries([e]), t.invalidateQueries(["metadata"]);
    }
  });
}
function C_(e, t) {
  const i = Dm(), n = ie(Er);
  return $J((r) => Q9(e, r, {
    lang: n
  }), {
    onSuccess: () => {
      i.invalidateQueries([e]), t != null && t.keepMetadata || i.invalidateQueries(["metadata"]);
    }
  });
}
function t$t(e) {
  const t = Dm();
  return $J(({
    id: i
  }) => u_(e, i), {
    onSuccess: () => t.invalidateQueries([e])
  });
}
const i$t = () => {
  const e = ie(Pi), t = Ei(), {
    mutateAsync: i
  } = C_("app", {
    keepMetadata: !0
  });
  return Gt(async (n) => {
    var g;
    const r = {
      ...e,
      settings: {
        ...e.settings,
        dynamicTranslationKeys: [...((g = e.settings) == null ? void 0 : g.dynamicTranslationKeys) || [], ...n]
      }
    };
    await i(r, {
      onSuccess: () => {
        t(w7(r));
      }
    });
  }, [i, e, t]);
}, A_ = () => {
  const e = ie(Pi), t = Ei(), {
    mutateAsync: i
  } = C_("app", {
    keepMetadata: !0
  });
  return Gt(async (n) => {
    const r = {
      ...e,
      settings: {
        ...e.settings,
        dynamicSettings: {
          ...e.settings.dynamicSettings,
          ...n
        }
      }
    };
    await i(r, {
      onSuccess: () => {
        t(w7(r));
      }
    });
  }, [i, e, t]);
}, n$t = () => {
  const e = A_();
  return Gt(async (t, i) => await e({
    [t]: i
  }), [e]);
};
function K0t(e) {
  return /* @__PURE__ */ S(o1, { maxWidth: 450, ...e, className: Re("k3-alert-modal", e.className), confirm: !1, children: e.children });
}
const T0t = ({
  onClose: e,
  open: t
}) => {
  const {
    t: i
  } = Gi(), [n, r] = wt({}), g = A_();
  return /* @__PURE__ */ S(K0t, { show: t, onClose: async () => {
    await g(n), e();
  }, title: i("Einstellungen"), icon: null, stopPropagation: !0, children: /* @__PURE__ */ S(E0t, { values: n, setValues: r }) });
}, M0t = (e) => {
  const {
    component: t,
    display: i,
    onClose: n,
    onOpen: r,
    ...g
  } = e, o = Ei(), [l, a] = wt(!1), I = ZA(), c = ie($r), d = ie(SA), C = Gt((b) => {
    b.preventDefault(), b.stopPropagation(), r == null || r(), o(yct(g)), i === "dialog" ? a(!0) : I(eAt("../dynamic", "keys", g.keys));
  }, [r, o, g, i, I]), A = Gt(() => {
    a(!1), n == null || n();
  }, [n]);
  return !c || !d ? null : /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(t, { "data-cy": "edit", onClick: C }),
    /* @__PURE__ */ S(T0t, { onClose: A, open: l, ...g })
  ] });
};
function b_({
  "data-cy": e,
  onClick: t,
  tooltip: i,
  colorVariant: n
}) {
  return /* @__PURE__ */ S(Tn, { title: i, children: /* @__PURE__ */ S(Ni, { size: "small", sx: {
    color: `editor.${n ?? "main"}`
  }, "data-cy": e, onClick: t, children: /* @__PURE__ */ S(nq, {}) }) });
}
const hu = ({
  boxProps: e,
  ...t
}) => {
  const i = ie($r), n = ie(SA), {
    t: r
  } = Gi();
  return !i || !n ? null : /* @__PURE__ */ S(ht, { component: "span", sx: {
    display: "flex",
    pointerEvents: "all",
    justifyContent: "center",
    alignItems: "center",
    ...e
  }, children: /* @__PURE__ */ S(Tn, { title: r("Texte und Einstellungen anpassen"), children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(M0t, { ...t, component: b_ }) }) }) });
}, P0t = Bm((e) => /* @__PURE__ */ S(gq, { className: Re("k3-warning-icon", e.className), fontSize: "large", sx: {
  verticalAlign: "middle",
  marginLeft: e.margin == "left" ? "8px" : void 0,
  marginRight: e.margin == "right" ? "8px" : void 0,
  ...e.sx
}, color: "warning" }));
var h_ = { exports: {} };
(function(e) {
  /*!mobile-detect v1.4.5 2021-03-13*/
  /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
  (function(t, i) {
    t(function() {
      var n = {};
      n.mobileDetectRules = {
        phones: {
          iPhone: "\\biPhone\\b|\\biPod\\b",
          BlackBerry: "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
          Pixel: "; \\bPixel\\b",
          HTC: "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
          Nexus: "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
          Dell: "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
          Motorola: "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
          Samsung: "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
          LG: "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
          Sony: "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
          Asus: "Asus.*Galaxy|PadFone.*Mobile",
          Xiaomi: "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
          NokiaLumia: "Lumia [0-9]{3,4}",
          Micromax: "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
          Palm: "PalmSource|Palm",
          Vertu: "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
          Pantech: "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
          Fly: "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
          Wiko: "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
          iMobile: "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
          SimValley: "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
          Wolfgang: "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
          Alcatel: "Alcatel",
          Nintendo: "Nintendo (3DS|Switch)",
          Amoi: "Amoi",
          INQ: "INQ",
          OnePlus: "ONEPLUS",
          GenericPhone: "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
        },
        tablets: {
          iPad: "iPad|iPad.*Mobile",
          NexusTablet: "Android.*Nexus[\\s]+(7|9|10)",
          GoogleTablet: "Android.*Pixel C",
          SamsungTablet: "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
          Kindle: "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk/[0-9.]+ like Chrome/[0-9.]+ (?!Mobile)",
          SurfaceTablet: "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
          HPTablet: "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
          AsusTablet: "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
          BlackBerryTablet: "PlayBook|RIM Tablet",
          HTCtablet: "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
          MotorolaTablet: "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
          NookTablet: "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
          AcerTablet: "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
          ToshibaTablet: "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
          LGTablet: "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
          FujitsuTablet: "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
          PrestigioTablet: "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
          LenovoTablet: "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
          DellTablet: "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
          YarvikTablet: "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
          MedionTablet: "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
          ArnovaTablet: "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
          IntensoTablet: "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
          IRUTablet: "M702pro",
          MegafonTablet: "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
          EbodaTablet: "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
          AllViewTablet: "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
          ArchosTablet: "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
          AinolTablet: "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
          NokiaLumiaTablet: "Lumia 2520",
          SonyTablet: "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
          PhilipsTablet: "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
          CubeTablet: "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
          CobyTablet: "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
          MIDTablet: "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
          MSITablet: "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
          SMiTTablet: "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
          RockChipTablet: "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
          FlyTablet: "IQ310|Fly Vision",
          bqTablet: "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
          HuaweiTablet: "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
          NecTablet: "\\bN-06D|\\bN-08D",
          PantechTablet: "Pantech.*P4100",
          BronchoTablet: "Broncho.*(N701|N708|N802|a710)",
          VersusTablet: "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
          ZyncTablet: "z1000|Z99 2G|z930|z990|z909|Z919|z900",
          PositivoTablet: "TB07STA|TB10STA|TB07FTA|TB10FTA",
          NabiTablet: "Android.*\\bNabi",
          KoboTablet: "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
          DanewTablet: "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
          TexetTablet: "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
          PlaystationTablet: "Playstation.*(Portable|Vita)",
          TrekstorTablet: "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
          PyleAudioTablet: "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
          AdvanTablet: "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
          DanyTechTablet: "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
          GalapadTablet: "Android [0-9.]+; [a-z-]+; \\bG1\\b",
          MicromaxTablet: "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
          KarbonnTablet: "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
          AllFineTablet: "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
          PROSCANTablet: "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
          YONESTablet: "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
          ChangJiaTablet: "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
          GUTablet: "TX-A1301|TX-M9002|Q702|kf026",
          PointOfViewTablet: "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
          OvermaxTablet: "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
          HCLTablet: "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
          DPSTablet: "DPS Dream 9|DPS Dual 7",
          VistureTablet: "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
          CrestaTablet: "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
          MediatekTablet: "\\bMT8125|MT8389|MT8135|MT8377\\b",
          ConcordeTablet: "Concorde([ ]+)?Tab|ConCorde ReadMan",
          GoCleverTablet: "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
          ModecomTablet: "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
          VoninoTablet: "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
          ECSTablet: "V07OT2|TM105A|S10OT1|TR10CS1",
          StorexTablet: "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
          VodafoneTablet: "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
          EssentielBTablet: "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
          RossMoorTablet: "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
          iMobileTablet: "i-mobile i-note",
          TolinoTablet: "tolino tab [0-9.]+|tolino shine",
          AudioSonicTablet: "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
          AMPETablet: "Android.* A78 ",
          SkkTablet: "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
          TecnoTablet: "TECNO P9|TECNO DP8D",
          JXDTablet: "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
          iJoyTablet: "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
          FX2Tablet: "FX2 PAD7|FX2 PAD10",
          XoroTablet: "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
          ViewsonicTablet: "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
          VerizonTablet: "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
          OdysTablet: "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
          CaptivaTablet: "CAPTIVA PAD",
          IconbitTablet: "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
          TeclastTablet: "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
          OndaTablet: "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
          JaytechTablet: "TPC-PA762",
          BlaupunktTablet: "Endeavour 800NG|Endeavour 1010",
          DigmaTablet: "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
          EvolioTablet: "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
          LavaTablet: "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
          AocTablet: "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
          MpmanTablet: "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
          CelkonTablet: "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
          WolderTablet: "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
          MediacomTablet: "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
          MiTablet: "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
          NibiruTablet: "Nibiru M1|Nibiru Jupiter One",
          NexoTablet: "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
          LeaderTablet: "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
          UbislateTablet: "UbiSlate[\\s]?7C",
          PocketBookTablet: "Pocketbook",
          KocasoTablet: "\\b(TB-1207)\\b",
          HisenseTablet: "\\b(F5281|E2371)\\b",
          Hudl: "Hudl HT7S3|Hudl 2",
          TelstraTablet: "T-Hub2",
          GenericTablet: "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
        },
        oss: {
          AndroidOS: "Android",
          BlackBerryOS: "blackberry|\\bBB10\\b|rim tablet os",
          PalmOS: "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
          SymbianOS: "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
          WindowsMobileOS: "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
          WindowsPhoneOS: "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
          iOS: "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
          iPadOS: "CPU OS 13",
          SailfishOS: "Sailfish",
          MeeGoOS: "MeeGo",
          MaemoOS: "Maemo",
          JavaOS: "J2ME/|\\bMIDP\\b|\\bCLDC\\b",
          webOS: "webOS|hpwOS",
          badaOS: "\\bBada\\b",
          BREWOS: "BREW"
        },
        uas: {
          Chrome: "\\bCrMo\\b|CriOS|Android.*Chrome/[.0-9]* (Mobile)?",
          Dolfin: "\\bDolfin\\b",
          Opera: "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR/[0-9.]+$|Coast/[0-9.]+",
          Skyfire: "Skyfire",
          Edge: "\\bEdgiOS\\b|Mobile Safari/[.0-9]* Edge",
          IE: "IEMobile|MSIEMobile",
          Firefox: "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
          Bolt: "bolt",
          TeaShark: "teashark",
          Blazer: "Blazer",
          Safari: "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
          WeChat: "\\bMicroMessenger\\b",
          UCBrowser: "UC.*Browser|UCWEB",
          baiduboxapp: "baiduboxapp",
          baidubrowser: "baidubrowser",
          DiigoBrowser: "DiigoBrowser",
          Mercury: "\\bMercury\\b",
          ObigoBrowser: "Obigo",
          NetFront: "NF-Browser",
          GenericBrowser: "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
          PaleMoon: "Android.*PaleMoon|Mobile.*PaleMoon"
        },
        props: {
          Mobile: "Mobile/[VER]",
          Build: "Build/[VER]",
          Version: "Version/[VER]",
          VendorID: "VendorID/[VER]",
          iPad: "iPad.*CPU[a-z ]+[VER]",
          iPhone: "iPhone.*CPU[a-z ]+[VER]",
          iPod: "iPod.*CPU[a-z ]+[VER]",
          Kindle: "Kindle/[VER]",
          Chrome: [
            "Chrome/[VER]",
            "CriOS/[VER]",
            "CrMo/[VER]"
          ],
          Coast: [
            "Coast/[VER]"
          ],
          Dolfin: "Dolfin/[VER]",
          Firefox: [
            "Firefox/[VER]",
            "FxiOS/[VER]"
          ],
          Fennec: "Fennec/[VER]",
          Edge: "Edge/[VER]",
          IE: [
            "IEMobile/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident/[0-9.]+;.*rv:[VER]"
          ],
          NetFront: "NetFront/[VER]",
          NokiaBrowser: "NokiaBrowser/[VER]",
          Opera: [
            " OPR/[VER]",
            "Opera Mini/[VER]",
            "Version/[VER]"
          ],
          "Opera Mini": "Opera Mini/[VER]",
          "Opera Mobi": "Version/[VER]",
          UCBrowser: [
            "UCWEB[VER]",
            "UC.*Browser/[VER]"
          ],
          MQQBrowser: "MQQBrowser/[VER]",
          MicroMessenger: "MicroMessenger/[VER]",
          baiduboxapp: "baiduboxapp/[VER]",
          baidubrowser: "baidubrowser/[VER]",
          SamsungBrowser: "SamsungBrowser/[VER]",
          Iron: "Iron/[VER]",
          Safari: [
            "Version/[VER]",
            "Safari/[VER]"
          ],
          Skyfire: "Skyfire/[VER]",
          Tizen: "Tizen/[VER]",
          Webkit: "webkit[ /][VER]",
          PaleMoon: "PaleMoon/[VER]",
          SailfishBrowser: "SailfishBrowser/[VER]",
          Gecko: "Gecko/[VER]",
          Trident: "Trident/[VER]",
          Presto: "Presto/[VER]",
          Goanna: "Goanna/[VER]",
          iOS: " \\bi?OS\\b [VER][ ;]{1}",
          Android: "Android [VER]",
          Sailfish: "Sailfish [VER]",
          BlackBerry: [
            "BlackBerry[\\w]+/[VER]",
            "BlackBerry.*Version/[VER]",
            "Version/[VER]"
          ],
          BREW: "BREW [VER]",
          Java: "Java/[VER]",
          "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
          ],
          "Windows Phone": "Windows Phone [VER]",
          "Windows CE": "Windows CE/[VER]",
          "Windows NT": "Windows NT [VER]",
          Symbian: [
            "SymbianOS/[VER]",
            "Symbian/[VER]"
          ],
          webOS: [
            "webOS/[VER]",
            "hpwOS/[VER];"
          ]
        },
        utils: {
          Bot: "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
          MobileBot: "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker/M1A1-R2D2",
          DesktopMode: "WPDesktop",
          TV: "SonyDTV|HbbTV",
          WebKit: "(webkit)[ /]([\\w.]+)",
          Console: "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
          Watch: "SM-V700"
        }
      }, n.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
      };
      var r = Object.prototype.hasOwnProperty, g;
      n.FALLBACK_PHONE = "UnknownPhone", n.FALLBACK_TABLET = "UnknownTablet", n.FALLBACK_MOBILE = "UnknownMobile", g = "isArray" in Array ? Array.isArray : function(d) {
        return Object.prototype.toString.call(d) === "[object Array]";
      };
      function o(d, C) {
        return d != null && C != null && d.toLowerCase() === C.toLowerCase();
      }
      function l(d, C) {
        var A, b, m = d.length;
        if (!m || !C)
          return !1;
        for (A = C.toLowerCase(), b = 0; b < m; ++b)
          if (A === d[b].toLowerCase())
            return !0;
        return !1;
      }
      function a(d) {
        for (var C in d)
          r.call(d, C) && (d[C] = new RegExp(d[C], "i"));
      }
      function I(d) {
        return (d || "").substr(0, 500);
      }
      (function() {
        var C, A, b, m, p, B, f = n.mobileDetectRules;
        for (C in f.props)
          if (r.call(f.props, C)) {
            for (A = f.props[C], g(A) || (A = [A]), p = A.length, m = 0; m < p; ++m)
              b = A[m], B = b.indexOf("[VER]"), B >= 0 && (b = b.substring(0, B) + "([\\w._\\+]+)" + b.substring(B + 5)), A[m] = new RegExp(b, "i");
            f.props[C] = A;
          }
        a(f.oss), a(f.phones), a(f.tablets), a(f.uas), a(f.utils), f.oss0 = {
          WindowsPhoneOS: f.oss.WindowsPhoneOS,
          WindowsMobileOS: f.oss.WindowsMobileOS
        };
      })(), n.findMatch = function(d, C) {
        for (var A in d)
          if (r.call(d, A) && d[A].test(C))
            return A;
        return null;
      }, n.findMatches = function(d, C) {
        var A = [];
        for (var b in d)
          r.call(d, b) && d[b].test(C) && A.push(b);
        return A;
      }, n.getVersionStr = function(d, C) {
        var A = n.mobileDetectRules.props, b, m, p, B;
        if (r.call(A, d)) {
          for (b = A[d], p = b.length, m = 0; m < p; ++m)
            if (B = b[m].exec(C), B !== null)
              return B[1];
        }
        return null;
      }, n.getVersion = function(d, C) {
        var A = n.getVersionStr(d, C);
        return A ? n.prepareVersionNo(A) : NaN;
      }, n.prepareVersionNo = function(d) {
        var C;
        return C = d.split(/[a-z._ \/\-]/i), C.length === 1 && (d = C[0]), C.length > 1 && (d = C[0] + ".", C.shift(), d += C.join("")), Number(d);
      }, n.isMobileFallback = function(d) {
        return n.detectMobileBrowsers.fullPattern.test(d) || n.detectMobileBrowsers.shortPattern.test(d.substr(0, 4));
      }, n.isTabletFallback = function(d) {
        return n.detectMobileBrowsers.tabletPattern.test(d);
      }, n.prepareDetectionCache = function(d, C, A) {
        if (d.mobile === i) {
          var b, m, p;
          if (m = n.findMatch(n.mobileDetectRules.tablets, C), m) {
            d.mobile = d.tablet = m, d.phone = null;
            return;
          }
          if (b = n.findMatch(n.mobileDetectRules.phones, C), b) {
            d.mobile = d.phone = b, d.tablet = null;
            return;
          }
          n.isMobileFallback(C) ? (p = c.isPhoneSized(A), p === i ? (d.mobile = n.FALLBACK_MOBILE, d.tablet = d.phone = null) : p ? (d.mobile = d.phone = n.FALLBACK_PHONE, d.tablet = null) : (d.mobile = d.tablet = n.FALLBACK_TABLET, d.phone = null)) : n.isTabletFallback(C) ? (d.mobile = d.tablet = n.FALLBACK_TABLET, d.phone = null) : d.mobile = d.tablet = d.phone = null;
        }
      }, n.mobileGrade = function(d) {
        var C = d.mobile() !== null;
        return (
          // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
          d.os("iOS") && d.version("iPad") >= 4.3 || d.os("iOS") && d.version("iPhone") >= 3.1 || d.os("iOS") && d.version("iPod") >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
          // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
          // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
          // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
          d.version("Android") > 2.1 && d.is("Webkit") || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
          d.version("Windows Phone OS") >= 7 || // Blackberry 7 - Tested on BlackBerry Torch 9810
          // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
          d.is("BlackBerry") && d.version("BlackBerry") >= 6 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
          d.match("Playbook.*Tablet") || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
          d.version("webOS") >= 1.4 && d.match("Palm|Pre|Pixi") || // Palm WebOS 3.0  - Tested on HP TouchPad
          d.match("hp.*TouchPad") || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
          d.is("Firefox") && d.version("Firefox") >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
          d.is("Chrome") && d.is("AndroidOS") && d.version("Android") >= 4 || // Skyfire 4.1 - Tested on Android 2.3 device
          d.is("Skyfire") && d.version("Skyfire") >= 4.1 && d.is("AndroidOS") && d.version("Android") >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
          d.is("Opera") && d.version("Opera Mobi") > 11 && d.is("AndroidOS") || // Meego 1.2 - Tested on Nokia 950 and N9
          d.is("MeeGoOS") || // Tizen (pre-release) - Tested on early hardware
          d.is("Tizen") || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
          // @todo: more tests here!
          d.is("Dolfin") && d.version("Bada") >= 2 || // UC Browser - Tested on Android 2.3 device
          (d.is("UC Browser") || d.is("Dolfin")) && d.version("Android") >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
          d.match("Kindle Fire") || d.is("Kindle") && d.version("Kindle") >= 3 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
          d.is("AndroidOS") && d.is("NookTablet") || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
          d.version("Chrome") >= 11 && !C || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
          d.version("Safari") >= 5 && !C || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
          d.version("Firefox") >= 4 && !C || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
          d.version("MSIE") >= 7 && !C || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
          // @reference: http://my.opera.com/community/openweb/idopera/
          d.version("Opera") >= 10 && !C ? "A" : d.os("iOS") && d.version("iPad") < 4.3 || d.os("iOS") && d.version("iPhone") < 3.1 || d.os("iOS") && d.version("iPod") < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
          d.is("Blackberry") && d.version("BlackBerry") >= 5 && d.version("BlackBerry") < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
          d.version("Opera Mini") >= 5 && d.version("Opera Mini") <= 6.5 && (d.version("Android") >= 2.3 || d.is("iOS")) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
          d.match("NokiaN8|NokiaC7|N97.*Series60|Symbian/3") || // @todo: report this (tested on Nokia N71)
          d.version("Opera Mobi") >= 11 && d.is("SymbianOS") ? "B" : (
            // Blackberry 4.x - Tested on the Curve 8330
            (d.version("BlackBerry") < 5 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            d.match("MSIEMobile|Windows CE.*Mobile") || d.version("Windows Mobile") <= 5.2, "C")
          )
        );
      }, n.detectOS = function(d) {
        return n.findMatch(n.mobileDetectRules.oss0, d) || n.findMatch(n.mobileDetectRules.oss, d);
      }, n.getDeviceSmallerSide = function() {
        return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
      };
      function c(d, C) {
        this.ua = I(d), this._cache = {}, this.maxPhoneWidth = C || 600;
      }
      return c.prototype = {
        constructor: c,
        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.mobile;
        },
        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.phone;
        },
        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function() {
          return n.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth), this._cache.tablet;
        },
        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function() {
          return this._cache.userAgent === i && (this._cache.userAgent = n.findMatch(n.mobileDetectRules.uas, this.ua)), this._cache.userAgent;
        },
        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function() {
          return this._cache.userAgents === i && (this._cache.userAgents = n.findMatches(n.mobileDetectRules.uas, this.ua)), this._cache.userAgents;
        },
        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function() {
          return this._cache.os === i && (this._cache.os = n.detectOS(this.ua)), this._cache.os;
        },
        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function(d) {
          return n.getVersion(d, this.ua);
        },
        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function(d) {
          return n.getVersionStr(d, this.ua);
        },
        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function(d) {
          return l(this.userAgents(), d) || o(d, this.os()) || o(d, this.phone()) || o(d, this.tablet()) || l(n.findMatches(n.mobileDetectRules.utils, this.ua), d);
        },
        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function(d) {
          return d instanceof RegExp || (d = new RegExp(d, "i")), d.test(this.ua);
        },
        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function(d) {
          return c.isPhoneSized(d || this.maxPhoneWidth);
        },
        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function() {
          return this._cache.grade === i && (this._cache.grade = n.mobileGrade(this)), this._cache.grade;
        }
      }, typeof window < "u" && window.screen ? c.isPhoneSized = function(d) {
        return d < 0 ? i : n.getDeviceSmallerSide() <= d;
      } : c.isPhoneSized = function() {
      }, c._impl = n, c.version = "1.4.5 2021-03-13", c;
    });
  })(function(t) {
    if (e.exports)
      return function(i) {
        e.exports = i();
      };
    if (typeof window < "u")
      return function(i) {
        window.MobileDetect = i();
      };
    throw new Error("unknown environment");
  }());
})(h_);
var U0t = h_.exports;
const m_ = /* @__PURE__ */ go(U0t), z0t = () => {
  const e = ie(h0t), t = j9();
  return e === "phone" || t;
}, j9 = (e = 480) => $se(`(min-width: 0) and (max-width: ${e}px)`), q9 = () => {
  var e;
  return !!((e = new m_(window.navigator.userAgent).mobile()) != null && e.length);
}, p_ = () => {
  var e;
  return !!((e = new m_(window.navigator.userAgent).phone()) != null && e.length);
}, g1 = () => z0t() || q9();
function B_(e) {
  const t = !!e.maxWidth && typeof e.maxWidth != "number", i = e.maxWidth && typeof e.maxWidth == "number" ? e.maxWidth : 600, n = j9(i) || p_(), r = n || t || e.maxWidth === 0 ? void 0 : e.maxWidth ?? 600, g = n || t || e.minWidth === 0 || typeof r == "number" && typeof e.minWidth == "number" && r <= e.minWidth ? void 0 : e.minWidth ?? 250, o = Oe(() => {
    var I;
    return /* @__PURE__ */ S(
      Xf,
      {
        id: "dialog-title",
        className: "k3-modal-title",
        component: "div",
        sx: {
          paddingBottom: 0,
          marginRight: "40px"
        },
        children: /* @__PURE__ */ Ie(ht, { component: "div", sx: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }, children: [
          typeof e.title == "string" ? /* @__PURE__ */ S(f_, { wrapTitle: e.wrapTitle || n, children: e.title }) : e.title,
          !!((I = e.settingKeys) != null && I.length) && /* @__PURE__ */ S(hu, { keys: e.settingKeys, display: "dialog" })
        ] })
      }
    );
  }, [e.title, n, e.wrapTitle]), [l, a] = wt(!1);
  return /* @__PURE__ */ Ie(wf, { fullScreen: l, open: e.show, keepMounted: e.keepMounted, onClose: (I) => e.onClose(I), "aria-labelledby": "k3-modal-dialog", "aria-describedby": "k3-modal", classes: {
    root: Re("k3-modal-root", e.className),
    container: "k3-modal",
    paper: "k3-modal-window"
  }, onClick: e.stopPropagation ? (I) => I.stopPropagation() : void 0, "data-cy": e.dataCy ?? "k3-modal", fullWidth: !!(t || n), maxWidth: t ? e.maxWidth : void 0, sx: {
    "& .k3-modal-window": {
      width: "100%",
      maxWidth: r,
      minWidth: g
      // display: "flex",
      // flexDirection: "column",
      // height: "100%",
    }
  }, children: [
    o,
    /* @__PURE__ */ Ie(pi, { sx: {
      position: "absolute",
      right: 8,
      top: 8
    }, direction: "row", gap: "4px", justifyContent: "flex-end", children: [
      e.canUseFullscreen && /* @__PURE__ */ S(Q0t, { useFullscreen: l, onClick: () => a((I) => !I) }),
      /* @__PURE__ */ S(O0t, { onClick: (I) => e.onClose(I) })
    ] }),
    /* @__PURE__ */ S(Rf, { sx: {
      paddingTop: "0px",
      marginTop: "16px",
      paddingBottom: "0px"
      // height: "100%",
    }, classes: {
      root: "k3-modal-body"
    }, children: typeof e.children == "string" ? /* @__PURE__ */ S(BI, { id: "k3-modal-content", className: "k3-modal-content", component: "div", children: /* @__PURE__ */ S(Ct, { children: e.children }) }) : /* @__PURE__ */ S(Ct, { component: "div", sx: {
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }, children: e.children }) }),
    /* @__PURE__ */ S(vf, { sx: {
      paddingBottom: "16px",
      paddingTop: e.buttons ? "16px" : "0px"
    }, children: !!e.buttons && /* @__PURE__ */ S(pi, { direction: "row", gap: "4px", justifyContent: e.buttonSpacing || "right", width: "100%", sx: {
      paddingX: "16px"
    }, children: e.buttons }) })
  ] });
}
const f_ = (e) => /* @__PURE__ */ S(Ct, { variant: "h5", sx: {
  margin: 0,
  paddingLeft: e.afterIcon ? "10px" : "0px",
  paddingBottom: 0
}, noWrap: !e.wrapTitle, paragraph: !0, children: e.children }), O0t = (e) => /* @__PURE__ */ S(Ni, { "aria-label": "Close Button", classes: {
  root: "k3-close-btn"
}, onClick: e.onClick, sx: {
  color: (t) => t.palette.grey[500]
}, "data-cy": "modal-close", children: /* @__PURE__ */ S(iq, {}) }), Q0t = (e) => /* @__PURE__ */ S(Ni, { "aria-label": "Fullscreen Button", classes: {
  root: "k3-fullscreen-btn"
}, onClick: e.onClick, sx: {
  color: (t) => t.palette.grey[500]
}, "data-cy": "modal-fullscreen", children: e.useFullscreen ? /* @__PURE__ */ S(jAt, {}) : /* @__PURE__ */ S(QAt, {}) });
function o1(e) {
  const {
    t
  } = Gi(), i = e.type ?? "info", n = j9() || p_(), r = Oe(() => {
    let l = e.icon;
    if (typeof l > "u") {
      if (e.type == "form" || e.type == "none")
        return;
      l = i == "info" ? /* @__PURE__ */ S(_At, { fontSize: "large", color: "info" }) : i == "warning" ? /* @__PURE__ */ S(P0t, {}) : i == "delete" && e.confirm ? /* @__PURE__ */ S(DZ, { fontSize: "large", color: "error" }) : i == "success" ? /* @__PURE__ */ S(MAt, { fontSize: "large", color: "success" }) : /* @__PURE__ */ S(nbt, { fontSize: "large", color: "error" });
    }
    return l;
  }, [e.icon, e.type, e.confirm]), g = Oe(() => {
    const l = e.title || (i == "info" ? t("Hinweis") : i == "warning" ? t("Achtung") : i == "delete" && e.confirm ? t("Element löschen") : t("Fehler"));
    return /* @__PURE__ */ Ie(li, { children: [
      r,
      /* @__PURE__ */ S(f_, { afterIcon: !!r, wrapTitle: e.wrapTitle || n, children: l })
    ] });
  }, [e.title, e.icon, e.type, e.confirm, n, e.wrapTitle]), o = Oe(() => {
    if (!e.confirm)
      return;
    const l = !i || i == "form" || i == "none" ? "primary" : i == "info" ? "info" : i == "warning" ? "warning" : "error";
    return [/* @__PURE__ */ S(fn, { "data-cy": "cancelButton", variant: "outlined", color: l, className: "k3-btn k3-secondary-btn k3-modal-btn k3-btn-cancel", onClick: (a) => e.onClose(!1, a), children: e.cancelButtonText ?? t("Abbrechen") }, "cancel"), /* @__PURE__ */ S(fn, { "data-cy": "confirmButton", className: "k3-btn k3-btn-confirm k3-btn-submit k3-modal-btn", variant: "contained", color: l, disabled: e.disableConfirmButton, onClick: (a) => e.onClose(!0, a), children: e.confirmButtonText ?? (e.confirm && e.type == "delete" ? t("Löschen") : t("Fortfahren")) }, "confirm")];
  }, [e.confirm, e.cancelButtonText, e.confirmButtonText, e.onClose]);
  return /* @__PURE__ */ S(B_, { ...e, show: e.show ?? !1, title: g, onClose: (l) => e.confirm ? e.onClose(!1, l) : e.onClose(l), className: Re("k3-modal-" + (e.type ?? "info"), e.className), buttons: o, children: e.children ?? (e.confirm && e.type == "delete" ? t("Möchten Sie dieses Element wirklich unwiderruflich löschen?") : "") });
}
function Z_(e) {
  const {
    t
  } = Gi(), i = e.type == "form" ? t("Speichern") : void 0;
  return /* @__PURE__ */ S(o1, { minWidth: 400, ...e, type: e.type || "none", className: Re("k3-confirm-modal", e.className), confirm: !0, confirmButtonText: e.confirmButtonText || i, disableConfirmButton: e.disableConfirmButton, title: e.title || (e.type == "form" ? t("Eingabe") : void 0), onClose: (n) => e.onClose(!!n), children: e.children });
}
function j0t(e) {
  const {
    t
  } = Gi(), [i, n] = wt(e.expression), [r, g] = wt(), o = (l) => {
    l && !r ? (e.onChange(i), kZ(/* @__PURE__ */ S(Ct, { children: t("Erfolgreich gespeichert") }), {
      variant: "success"
    })) : i != e.expression && n(e.expression), e.onClose();
  };
  return /* @__PURE__ */ Ie(Z_, { show: e.open, onClose: o, maxWidth: "xl", title: t("Formel Editor"), icon: /* @__PURE__ */ S(tq, {}), type: "form", disableConfirmButton: !!r, children: [
    /* @__PURE__ */ Ie(BI, { children: [
      /* @__PURE__ */ S(Ct, { children: t("Geben Sie Formeln von Merkmalen ein.") }),
      /* @__PURE__ */ S(Ct, { children: t(" Schreiben Sie z.B. Länge * Breite.") }),
      /* @__PURE__ */ S(Ct, { children: t("Für ein Attribut nutzen Sie beispielsweise Motor.Leistung, wenn Motor ihr Merkmal und Leistung das entsprechende Attribut ist.") })
    ] }),
    /* @__PURE__ */ S("br", {}),
    /* @__PURE__ */ S(ht, { component: "div", sx: {
      padding: "1em",
      border: "1px solid #c4c4c4",
      borderRadius: 1,
      height: "100%"
    }, children: /* @__PURE__ */ S(Lq, { height: "100%", onChange: n, expression: i }) }),
    /* @__PURE__ */ S(Kq, { expression: i, anchoringSelections: e.anchoringSelections, onError: g, gutterBottom: !1 })
  ] });
}
const q0t = (e) => {
  const [t, i] = wt(!1);
  return lt(() => {
    const n = (g) => {
      var o;
      (o = e.current) != null && o.contains(g.target) && i(!0);
    }, r = (g) => {
      var o;
      (o = e.current) != null && o.contains(g.target) && i(!1);
    };
    return document.addEventListener("focusin", n), document.addEventListener("focusout", r), () => {
      document.removeEventListener("focusin", n), document.removeEventListener("focusout", r);
    };
  }, []), t;
}, hg = ({
  value: e,
  onChange: t,
  sx: i,
  label: n,
  anchoringSelections: r = [Ut]
}) => {
  const [g, o] = wt(!1), [l, a] = wt(void 0), I = ot(null), c = q0t(I);
  return lt(() => {
    c || a(void 0);
  }, [c]), /* @__PURE__ */ Ie(ht, { component: "fieldset", sx: {
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderWidth: 1,
    borderRadius: 1,
    margin: 0,
    ...i
  }, ref: I, "data-cy": `expressionInput-${n}`, children: [
    /* @__PURE__ */ S(vj, { open: c, anchorEl: I.current, anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    }, sx: {
      display: l ? "block" : "none",
      pointerEvents: "none"
    }, children: /* @__PURE__ */ S(ht, { sx: {
      p: 2
    }, component: "div", children: /* @__PURE__ */ S(Kq, { expression: e, showExpression: !1, anchoringSelections: r, onError: a }) }) }),
    /* @__PURE__ */ S(Ct, { component: "legend", color: "textSecondary", sx: {
      fontSize: 12
    }, children: n }),
    /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      display: "flex",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ S(Ni, { onClick: () => o(!0), "data-cy": "", size: "small", sx: {
        ml: -1.5
      }, tabIndex: -1, children: /* @__PURE__ */ S(tq, {}) }),
      /* @__PURE__ */ S(Lq, { expression: e, inline: !0, onChange: t, height: "1.1rem" })
    ] }),
    /* @__PURE__ */ S(j0t, { open: g, onClose: () => o(!1), expression: e, onChange: t, anchoringSelections: r })
  ] });
}, _0t = (e) => {
  const t = new URL(e);
  return t.protocol === "data:" && t.origin === "null" || t.protocol === "blob:" && t.origin === location.origin;
}, l1 = (e) => (
  // If the url is a local blob url or a data url, we cant add a query
  // parameter otherwise the url is invalid.
  _0t(e) ? e : e + "?x-request=html"
);
var $0t = Math.PI / 180;
function eBt() {
  return typeof window < "u" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
}
const Qh = typeof global < "u" ? global : typeof window < "u" ? window : typeof WorkerGlobalScope < "u" ? self : {}, ei = {
  _global: Qh,
  version: "8.4.3",
  isBrowser: eBt(),
  isUnminified: /param/.test((function(e) {
  }).toString()),
  dblClickWindow: 400,
  getAngle(e) {
    return ei.angleDeg ? e * $0t : e;
  },
  enableTrace: !1,
  pointerEventsEnabled: !0,
  autoDrawEnabled: !0,
  hitOnDragEnabled: !1,
  capturePointerEventsEnabled: !1,
  _mouseListenClick: !1,
  _touchListenClick: !1,
  _pointerListenClick: !1,
  _mouseInDblClickWindow: !1,
  _touchInDblClickWindow: !1,
  _pointerInDblClickWindow: !1,
  _mouseDblClickPointerId: null,
  _touchDblClickPointerId: null,
  _pointerDblClickPointerId: null,
  pixelRatio: typeof window < "u" && window.devicePixelRatio || 1,
  dragDistance: 3,
  angleDeg: !0,
  showWarnings: !0,
  dragButtons: [0, 1],
  isDragging() {
    return ei.DD.isDragging;
  },
  isDragReady() {
    return !!ei.DD.node;
  },
  releaseCanvasOnDestroy: !0,
  document: Qh.document,
  _injectGlobal(e) {
    Qh.Konva = e;
  }
}, cr = (e) => {
  ei[e.prototype.getClassName()] = e;
};
ei._injectGlobal(ei);
class Hl {
  constructor(t = [1, 0, 0, 1, 0, 0]) {
    this.dirty = !1, this.m = t && t.slice() || [1, 0, 0, 1, 0, 0];
  }
  reset() {
    this.m[0] = 1, this.m[1] = 0, this.m[2] = 0, this.m[3] = 1, this.m[4] = 0, this.m[5] = 0;
  }
  copy() {
    return new Hl(this.m);
  }
  copyInto(t) {
    t.m[0] = this.m[0], t.m[1] = this.m[1], t.m[2] = this.m[2], t.m[3] = this.m[3], t.m[4] = this.m[4], t.m[5] = this.m[5];
  }
  point(t) {
    var i = this.m;
    return {
      x: i[0] * t.x + i[2] * t.y + i[4],
      y: i[1] * t.x + i[3] * t.y + i[5]
    };
  }
  translate(t, i) {
    return this.m[4] += this.m[0] * t + this.m[2] * i, this.m[5] += this.m[1] * t + this.m[3] * i, this;
  }
  scale(t, i) {
    return this.m[0] *= t, this.m[1] *= t, this.m[2] *= i, this.m[3] *= i, this;
  }
  rotate(t) {
    var i = Math.cos(t), n = Math.sin(t), r = this.m[0] * i + this.m[2] * n, g = this.m[1] * i + this.m[3] * n, o = this.m[0] * -n + this.m[2] * i, l = this.m[1] * -n + this.m[3] * i;
    return this.m[0] = r, this.m[1] = g, this.m[2] = o, this.m[3] = l, this;
  }
  getTranslation() {
    return {
      x: this.m[4],
      y: this.m[5]
    };
  }
  skew(t, i) {
    var n = this.m[0] + this.m[2] * i, r = this.m[1] + this.m[3] * i, g = this.m[2] + this.m[0] * t, o = this.m[3] + this.m[1] * t;
    return this.m[0] = n, this.m[1] = r, this.m[2] = g, this.m[3] = o, this;
  }
  multiply(t) {
    var i = this.m[0] * t.m[0] + this.m[2] * t.m[1], n = this.m[1] * t.m[0] + this.m[3] * t.m[1], r = this.m[0] * t.m[2] + this.m[2] * t.m[3], g = this.m[1] * t.m[2] + this.m[3] * t.m[3], o = this.m[0] * t.m[4] + this.m[2] * t.m[5] + this.m[4], l = this.m[1] * t.m[4] + this.m[3] * t.m[5] + this.m[5];
    return this.m[0] = i, this.m[1] = n, this.m[2] = r, this.m[3] = g, this.m[4] = o, this.m[5] = l, this;
  }
  invert() {
    var t = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]), i = this.m[3] * t, n = -this.m[1] * t, r = -this.m[2] * t, g = this.m[0] * t, o = t * (this.m[2] * this.m[5] - this.m[3] * this.m[4]), l = t * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
    return this.m[0] = i, this.m[1] = n, this.m[2] = r, this.m[3] = g, this.m[4] = o, this.m[5] = l, this;
  }
  getMatrix() {
    return this.m;
  }
  decompose() {
    var t = this.m[0], i = this.m[1], n = this.m[2], r = this.m[3], g = this.m[4], o = this.m[5], l = t * r - i * n;
    let a = {
      x: g,
      y: o,
      rotation: 0,
      scaleX: 0,
      scaleY: 0,
      skewX: 0,
      skewY: 0
    };
    if (t != 0 || i != 0) {
      var I = Math.sqrt(t * t + i * i);
      a.rotation = i > 0 ? Math.acos(t / I) : -Math.acos(t / I), a.scaleX = I, a.scaleY = l / I, a.skewX = (t * n + i * r) / l, a.skewY = 0;
    } else if (n != 0 || r != 0) {
      var c = Math.sqrt(n * n + r * r);
      a.rotation = Math.PI / 2 - (r > 0 ? Math.acos(-n / c) : -Math.acos(n / c)), a.scaleX = l / c, a.scaleY = c, a.skewX = 0, a.skewY = (t * n + i * r) / l;
    }
    return a.rotation = me._getRotation(a.rotation), a;
  }
}
var tBt = "[object Array]", iBt = "[object Number]", nBt = "[object String]", rBt = "[object Boolean]", gBt = Math.PI / 180, oBt = 180 / Math.PI, FY = "#", lBt = "", aBt = "0", sBt = "Konva warning: ", ZM = "Konva error: ", IBt = "rgb(", xY = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 132, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 255, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 203],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [119, 128, 144],
  slategrey: [119, 128, 144],
  snow: [255, 255, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  transparent: [255, 255, 255, 0],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 5]
}, cBt = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, iS = [];
const dBt = typeof requestAnimationFrame < "u" && requestAnimationFrame || function(e) {
  setTimeout(e, 60);
}, me = {
  _isElement(e) {
    return !!(e && e.nodeType == 1);
  },
  _isFunction(e) {
    return !!(e && e.constructor && e.call && e.apply);
  },
  _isPlainObject(e) {
    return !!e && e.constructor === Object;
  },
  _isArray(e) {
    return Object.prototype.toString.call(e) === tBt;
  },
  _isNumber(e) {
    return Object.prototype.toString.call(e) === iBt && !isNaN(e) && isFinite(e);
  },
  _isString(e) {
    return Object.prototype.toString.call(e) === nBt;
  },
  _isBoolean(e) {
    return Object.prototype.toString.call(e) === rBt;
  },
  isObject(e) {
    return e instanceof Object;
  },
  isValidSelector(e) {
    if (typeof e != "string")
      return !1;
    var t = e[0];
    return t === "#" || t === "." || t === t.toUpperCase();
  },
  _sign(e) {
    return e === 0 || e > 0 ? 1 : -1;
  },
  requestAnimFrame(e) {
    iS.push(e), iS.length === 1 && dBt(function() {
      const t = iS;
      iS = [], t.forEach(function(i) {
        i();
      });
    });
  },
  createCanvasElement() {
    var e = document.createElement("canvas");
    try {
      e.style = e.style || {};
    } catch {
    }
    return e;
  },
  createImageElement() {
    return document.createElement("img");
  },
  _isInDocument(e) {
    for (; e = e.parentNode; )
      if (e == document)
        return !0;
    return !1;
  },
  _urlToImage(e, t) {
    var i = me.createImageElement();
    i.onload = function() {
      t(i);
    }, i.src = e;
  },
  _rgbToHex(e, t, i) {
    return ((1 << 24) + (e << 16) + (t << 8) + i).toString(16).slice(1);
  },
  _hexToRgb(e) {
    e = e.replace(FY, lBt);
    var t = parseInt(e, 16);
    return {
      r: t >> 16 & 255,
      g: t >> 8 & 255,
      b: t & 255
    };
  },
  getRandomColor() {
    for (var e = (Math.random() * 16777215 << 0).toString(16); e.length < 6; )
      e = aBt + e;
    return FY + e;
  },
  getRGB(e) {
    var t;
    return e in xY ? (t = xY[e], {
      r: t[0],
      g: t[1],
      b: t[2]
    }) : e[0] === FY ? this._hexToRgb(e.substring(1)) : e.substr(0, 4) === IBt ? (t = cBt.exec(e.replace(/ /g, "")), {
      r: parseInt(t[1], 10),
      g: parseInt(t[2], 10),
      b: parseInt(t[3], 10)
    }) : {
      r: 0,
      g: 0,
      b: 0
    };
  },
  colorToRGBA(e) {
    return e = e || "black", me._namedColorToRBA(e) || me._hex3ColorToRGBA(e) || me._hex4ColorToRGBA(e) || me._hex6ColorToRGBA(e) || me._hex8ColorToRGBA(e) || me._rgbColorToRGBA(e) || me._rgbaColorToRGBA(e) || me._hslColorToRGBA(e);
  },
  _namedColorToRBA(e) {
    var t = xY[e.toLowerCase()];
    return t ? {
      r: t[0],
      g: t[1],
      b: t[2],
      a: 1
    } : null;
  },
  _rgbColorToRGBA(e) {
    if (e.indexOf("rgb(") === 0) {
      e = e.match(/rgb\(([^)]+)\)/)[1];
      var t = e.split(/ *, */).map(Number);
      return {
        r: t[0],
        g: t[1],
        b: t[2],
        a: 1
      };
    }
  },
  _rgbaColorToRGBA(e) {
    if (e.indexOf("rgba(") === 0) {
      e = e.match(/rgba\(([^)]+)\)/)[1];
      var t = e.split(/ *, */).map((i, n) => i.slice(-1) === "%" ? n === 3 ? parseInt(i) / 100 : parseInt(i) / 100 * 255 : Number(i));
      return {
        r: t[0],
        g: t[1],
        b: t[2],
        a: t[3]
      };
    }
  },
  _hex8ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 9)
      return {
        r: parseInt(e.slice(1, 3), 16),
        g: parseInt(e.slice(3, 5), 16),
        b: parseInt(e.slice(5, 7), 16),
        a: parseInt(e.slice(7, 9), 16) / 255
      };
  },
  _hex6ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 7)
      return {
        r: parseInt(e.slice(1, 3), 16),
        g: parseInt(e.slice(3, 5), 16),
        b: parseInt(e.slice(5, 7), 16),
        a: 1
      };
  },
  _hex4ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 5)
      return {
        r: parseInt(e[1] + e[1], 16),
        g: parseInt(e[2] + e[2], 16),
        b: parseInt(e[3] + e[3], 16),
        a: parseInt(e[4] + e[4], 16) / 255
      };
  },
  _hex3ColorToRGBA(e) {
    if (e[0] === "#" && e.length === 4)
      return {
        r: parseInt(e[1] + e[1], 16),
        g: parseInt(e[2] + e[2], 16),
        b: parseInt(e[3] + e[3], 16),
        a: 1
      };
  },
  _hslColorToRGBA(e) {
    if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(e)) {
      const [t, ...i] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e), n = Number(i[0]) / 360, r = Number(i[1]) / 100, g = Number(i[2]) / 100;
      let o, l, a;
      if (r === 0)
        return a = g * 255, {
          r: Math.round(a),
          g: Math.round(a),
          b: Math.round(a),
          a: 1
        };
      g < 0.5 ? o = g * (1 + r) : o = g + r - g * r;
      const I = 2 * g - o, c = [0, 0, 0];
      for (let d = 0; d < 3; d++)
        l = n + 1 / 3 * -(d - 1), l < 0 && l++, l > 1 && l--, 6 * l < 1 ? a = I + (o - I) * 6 * l : 2 * l < 1 ? a = o : 3 * l < 2 ? a = I + (o - I) * (2 / 3 - l) * 6 : a = I, c[d] = a * 255;
      return {
        r: Math.round(c[0]),
        g: Math.round(c[1]),
        b: Math.round(c[2]),
        a: 1
      };
    }
  },
  haveIntersection(e, t) {
    return !(t.x > e.x + e.width || t.x + t.width < e.x || t.y > e.y + e.height || t.y + t.height < e.y);
  },
  cloneObject(e) {
    var t = {};
    for (var i in e)
      this._isPlainObject(e[i]) ? t[i] = this.cloneObject(e[i]) : this._isArray(e[i]) ? t[i] = this.cloneArray(e[i]) : t[i] = e[i];
    return t;
  },
  cloneArray(e) {
    return e.slice(0);
  },
  degToRad(e) {
    return e * gBt;
  },
  radToDeg(e) {
    return e * oBt;
  },
  _degToRad(e) {
    return me.warn("Util._degToRad is removed. Please use public Util.degToRad instead."), me.degToRad(e);
  },
  _radToDeg(e) {
    return me.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead."), me.radToDeg(e);
  },
  _getRotation(e) {
    return ei.angleDeg ? me.radToDeg(e) : e;
  },
  _capitalize(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
  },
  throw(e) {
    throw new Error(ZM + e);
  },
  error(e) {
    console.error(ZM + e);
  },
  warn(e) {
    ei.showWarnings && console.warn(sBt + e);
  },
  each(e, t) {
    for (var i in e)
      t(i, e[i]);
  },
  _inRange(e, t, i) {
    return t <= e && e < i;
  },
  _getProjectionToSegment(e, t, i, n, r, g) {
    var o, l, a, I = (e - i) * (e - i) + (t - n) * (t - n);
    if (I == 0)
      o = e, l = t, a = (r - i) * (r - i) + (g - n) * (g - n);
    else {
      var c = ((r - e) * (i - e) + (g - t) * (n - t)) / I;
      c < 0 ? (o = e, l = t, a = (e - r) * (e - r) + (t - g) * (t - g)) : c > 1 ? (o = i, l = n, a = (i - r) * (i - r) + (n - g) * (n - g)) : (o = e + c * (i - e), l = t + c * (n - t), a = (o - r) * (o - r) + (l - g) * (l - g));
    }
    return [o, l, a];
  },
  _getProjectionToLine(e, t, i) {
    var n = me.cloneObject(e), r = Number.MAX_VALUE;
    return t.forEach(function(g, o) {
      if (!(!i && o === t.length - 1)) {
        var l = t[(o + 1) % t.length], a = me._getProjectionToSegment(g.x, g.y, l.x, l.y, e.x, e.y), I = a[0], c = a[1], d = a[2];
        d < r && (n.x = I, n.y = c, r = d);
      }
    }), n;
  },
  _prepareArrayForTween(e, t, i) {
    var n, r = [], g = [];
    if (e.length > t.length) {
      var o = t;
      t = e, e = o;
    }
    for (n = 0; n < e.length; n += 2)
      r.push({
        x: e[n],
        y: e[n + 1]
      });
    for (n = 0; n < t.length; n += 2)
      g.push({
        x: t[n],
        y: t[n + 1]
      });
    var l = [];
    return g.forEach(function(a) {
      var I = me._getProjectionToLine(a, r, i);
      l.push(I.x), l.push(I.y);
    }), l;
  },
  _prepareToStringify(e) {
    var t;
    e.visitedByCircularReferenceRemoval = !0;
    for (var i in e)
      if (e.hasOwnProperty(i) && e[i] && typeof e[i] == "object") {
        if (t = Object.getOwnPropertyDescriptor(e, i), e[i].visitedByCircularReferenceRemoval || me._isElement(e[i]))
          if (t.configurable)
            delete e[i];
          else
            return null;
        else if (me._prepareToStringify(e[i]) === null)
          if (t.configurable)
            delete e[i];
          else
            return null;
      }
    return delete e.visitedByCircularReferenceRemoval, e;
  },
  _assign(e, t) {
    for (var i in t)
      e[i] = t[i];
    return e;
  },
  _getFirstPointerId(e) {
    return e.touches ? e.changedTouches[0].identifier : e.pointerId || 999;
  },
  releaseCanvas(...e) {
    ei.releaseCanvasOnDestroy && e.forEach((t) => {
      t.width = 0, t.height = 0;
    });
  },
  drawRoundedRectPath(e, t, i, n) {
    let r = 0, g = 0, o = 0, l = 0;
    typeof n == "number" ? r = g = o = l = Math.min(n, t / 2, i / 2) : (r = Math.min(n[0] || 0, t / 2, i / 2), g = Math.min(n[1] || 0, t / 2, i / 2), l = Math.min(n[2] || 0, t / 2, i / 2), o = Math.min(n[3] || 0, t / 2, i / 2)), e.moveTo(r, 0), e.lineTo(t - g, 0), e.arc(t - g, g, g, Math.PI * 3 / 2, 0, !1), e.lineTo(t, i - l), e.arc(t - l, i - l, l, 0, Math.PI / 2, !1), e.lineTo(o, i), e.arc(o, i - o, o, Math.PI / 2, Math.PI, !1), e.lineTo(0, r), e.arc(r, r, r, Math.PI, Math.PI * 3 / 2, !1);
  }
};
function mu(e) {
  return me._isString(e) ? '"' + e + '"' : Object.prototype.toString.call(e) === "[object Number]" || me._isBoolean(e) ? e : Object.prototype.toString.call(e);
}
function G_(e) {
  return e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
}
function ft() {
  if (ei.isUnminified)
    return function(e, t) {
      return me._isNumber(e) || me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number.'), e;
    };
}
function _9(e) {
  if (ei.isUnminified)
    return function(t, i) {
      let n = me._isNumber(t), r = me._isArray(t) && t.length == e;
      return !n && !r && me.warn(mu(t) + ' is a not valid value for "' + i + '" attribute. The value should be a number or Array<number>(' + e + ")"), t;
    };
}
function $9() {
  if (ei.isUnminified)
    return function(e, t) {
      var i = me._isNumber(e), n = e === "auto";
      return i || n || me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a number or "auto".'), e;
    };
}
function Nm() {
  if (ei.isUnminified)
    return function(e, t) {
      return me._isString(e) || me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string.'), e;
    };
}
function y_() {
  if (ei.isUnminified)
    return function(e, t) {
      const i = me._isString(e), n = Object.prototype.toString.call(e) === "[object CanvasGradient]" || e && e.addColorStop;
      return i || n || me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a string or a native gradient.'), e;
    };
}
function uBt() {
  if (ei.isUnminified)
    return function(e, t) {
      const i = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
      return i && e instanceof i || (me._isArray(e) ? e.forEach(function(n) {
        me._isNumber(n) || me.warn('"' + t + '" attribute has non numeric element ' + n + ". Make sure that all elements are numbers.");
      }) : me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a array of numbers.')), e;
    };
}
function Ts() {
  if (ei.isUnminified)
    return function(e, t) {
      var i = e === !0 || e === !1;
      return i || me.warn(mu(e) + ' is a not valid value for "' + t + '" attribute. The value should be a boolean.'), e;
    };
}
function CBt(e) {
  if (ei.isUnminified)
    return function(t, i) {
      return t == null || me.isObject(t) || me.warn(mu(t) + ' is a not valid value for "' + i + '" attribute. The value should be an object with properties ' + e), t;
    };
}
var rB = "get", gB = "set";
const oe = {
  addGetterSetter(e, t, i, n, r) {
    oe.addGetter(e, t, i), oe.addSetter(e, t, n, r), oe.addOverloadedGetterSetter(e, t);
  },
  addGetter(e, t, i) {
    var n = rB + me._capitalize(t);
    e.prototype[n] = e.prototype[n] || function() {
      var r = this.attrs[t];
      return r === void 0 ? i : r;
    };
  },
  addSetter(e, t, i, n) {
    var r = gB + me._capitalize(t);
    e.prototype[r] || oe.overWriteSetter(e, t, i, n);
  },
  overWriteSetter(e, t, i, n) {
    var r = gB + me._capitalize(t);
    e.prototype[r] = function(g) {
      return i && g !== void 0 && g !== null && (g = i.call(this, g, t)), this._setAttr(t, g), n && n.call(this), this;
    };
  },
  addComponentsGetterSetter(e, t, i, n, r) {
    var g = i.length, o = me._capitalize, l = rB + o(t), a = gB + o(t), I, c;
    e.prototype[l] = function() {
      var C = {};
      for (I = 0; I < g; I++)
        c = i[I], C[c] = this.getAttr(t + o(c));
      return C;
    };
    var d = CBt(i);
    e.prototype[a] = function(C) {
      var A = this.attrs[t], b;
      n && (C = n.call(this, C)), d && d.call(this, C, t);
      for (b in C)
        C.hasOwnProperty(b) && this._setAttr(t + o(b), C[b]);
      return C || i.forEach((m) => {
        this._setAttr(t + o(m), void 0);
      }), this._fireChangeEvent(t, A, C), r && r.call(this), this;
    }, oe.addOverloadedGetterSetter(e, t);
  },
  addOverloadedGetterSetter(e, t) {
    var i = me._capitalize(t), n = gB + i, r = rB + i;
    e.prototype[t] = function() {
      return arguments.length ? (this[n](arguments[0]), this) : this[r]();
    };
  },
  addDeprecatedGetterSetter(e, t, i, n) {
    me.error("Adding deprecated " + t);
    var r = rB + me._capitalize(t), g = t + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
    e.prototype[r] = function() {
      me.error(g);
      var o = this.attrs[t];
      return o === void 0 ? i : o;
    }, oe.addSetter(e, t, n, function() {
      me.error(g);
    }), oe.addOverloadedGetterSetter(e, t);
  },
  backCompat(e, t) {
    me.each(t, function(i, n) {
      var r = e.prototype[n], g = rB + me._capitalize(i), o = gB + me._capitalize(i);
      function l() {
        r.apply(this, arguments), me.error('"' + i + '" method is deprecated and will be removed soon. Use ""' + n + '" instead.');
      }
      e.prototype[i] = l, e.prototype[g] = l, e.prototype[o] = l;
    });
  },
  afterSetFilter() {
    this._filterUpToDate = !1;
  }
};
function ABt(e) {
  var t = [], i = e.length, n = me, r, g;
  for (r = 0; r < i; r++)
    g = e[r], n._isNumber(g) ? g = Math.round(g * 1e3) / 1e3 : n._isString(g) || (g = g + ""), t.push(g);
  return t;
}
var GM = ",", bBt = "(", hBt = ")", mBt = "([", pBt = "])", BBt = ";", fBt = "()", ZBt = "=", yM = [
  "arc",
  "arcTo",
  "beginPath",
  "bezierCurveTo",
  "clearRect",
  "clip",
  "closePath",
  "createLinearGradient",
  "createPattern",
  "createRadialGradient",
  "drawImage",
  "ellipse",
  "fill",
  "fillText",
  "getImageData",
  "createImageData",
  "lineTo",
  "moveTo",
  "putImageData",
  "quadraticCurveTo",
  "rect",
  "restore",
  "rotate",
  "save",
  "scale",
  "setLineDash",
  "setTransform",
  "stroke",
  "strokeText",
  "transform",
  "translate"
], GBt = [
  "fillStyle",
  "strokeStyle",
  "shadowColor",
  "shadowBlur",
  "shadowOffsetX",
  "shadowOffsetY",
  "lineCap",
  "lineDashOffset",
  "lineJoin",
  "lineWidth",
  "miterLimit",
  "font",
  "textAlign",
  "textBaseline",
  "globalAlpha",
  "globalCompositeOperation",
  "imageSmoothingEnabled"
];
const yBt = 100;
let a1 = class {
  constructor(t) {
    this.canvas = t, ei.enableTrace && (this.traceArr = [], this._enableTrace());
  }
  fillShape(t) {
    t.fillEnabled() && this._fill(t);
  }
  _fill(t) {
  }
  strokeShape(t) {
    t.hasStroke() && this._stroke(t);
  }
  _stroke(t) {
  }
  fillStrokeShape(t) {
    t.attrs.fillAfterStrokeEnabled ? (this.strokeShape(t), this.fillShape(t)) : (this.fillShape(t), this.strokeShape(t));
  }
  getTrace(t, i) {
    var n = this.traceArr, r = n.length, g = "", o, l, a, I;
    for (o = 0; o < r; o++)
      l = n[o], a = l.method, a ? (I = l.args, g += a, t ? g += fBt : me._isArray(I[0]) ? g += mBt + I.join(GM) + pBt : (i && (I = I.map((c) => typeof c == "number" ? Math.floor(c) : c)), g += bBt + I.join(GM) + hBt)) : (g += l.property, t || (g += ZBt + l.val)), g += BBt;
    return g;
  }
  clearTrace() {
    this.traceArr = [];
  }
  _trace(t) {
    var i = this.traceArr, n;
    i.push(t), n = i.length, n >= yBt && i.shift();
  }
  reset() {
    var t = this.getCanvas().getPixelRatio();
    this.setTransform(1 * t, 0, 0, 1 * t, 0, 0);
  }
  getCanvas() {
    return this.canvas;
  }
  clear(t) {
    var i = this.getCanvas();
    t ? this.clearRect(t.x || 0, t.y || 0, t.width || 0, t.height || 0) : this.clearRect(0, 0, i.getWidth() / i.pixelRatio, i.getHeight() / i.pixelRatio);
  }
  _applyLineCap(t) {
    const i = t.attrs.lineCap;
    i && this.setAttr("lineCap", i);
  }
  _applyOpacity(t) {
    var i = t.getAbsoluteOpacity();
    i !== 1 && this.setAttr("globalAlpha", i);
  }
  _applyLineJoin(t) {
    const i = t.attrs.lineJoin;
    i && this.setAttr("lineJoin", i);
  }
  setAttr(t, i) {
    this._context[t] = i;
  }
  arc(t, i, n, r, g, o) {
    this._context.arc(t, i, n, r, g, o);
  }
  arcTo(t, i, n, r, g) {
    this._context.arcTo(t, i, n, r, g);
  }
  beginPath() {
    this._context.beginPath();
  }
  bezierCurveTo(t, i, n, r, g, o) {
    this._context.bezierCurveTo(t, i, n, r, g, o);
  }
  clearRect(t, i, n, r) {
    this._context.clearRect(t, i, n, r);
  }
  clip() {
    this._context.clip();
  }
  closePath() {
    this._context.closePath();
  }
  createImageData(t, i) {
    var n = arguments;
    if (n.length === 2)
      return this._context.createImageData(t, i);
    if (n.length === 1)
      return this._context.createImageData(t);
  }
  createLinearGradient(t, i, n, r) {
    return this._context.createLinearGradient(t, i, n, r);
  }
  createPattern(t, i) {
    return this._context.createPattern(t, i);
  }
  createRadialGradient(t, i, n, r, g, o) {
    return this._context.createRadialGradient(t, i, n, r, g, o);
  }
  drawImage(t, i, n, r, g, o, l, a, I) {
    var c = arguments, d = this._context;
    c.length === 3 ? d.drawImage(t, i, n) : c.length === 5 ? d.drawImage(t, i, n, r, g) : c.length === 9 && d.drawImage(t, i, n, r, g, o, l, a, I);
  }
  ellipse(t, i, n, r, g, o, l, a) {
    this._context.ellipse(t, i, n, r, g, o, l, a);
  }
  isPointInPath(t, i, n, r) {
    return n ? this._context.isPointInPath(n, t, i, r) : this._context.isPointInPath(t, i, r);
  }
  fill(t) {
    t ? this._context.fill(t) : this._context.fill();
  }
  fillRect(t, i, n, r) {
    this._context.fillRect(t, i, n, r);
  }
  strokeRect(t, i, n, r) {
    this._context.strokeRect(t, i, n, r);
  }
  fillText(t, i, n, r) {
    r ? this._context.fillText(t, i, n, r) : this._context.fillText(t, i, n);
  }
  measureText(t) {
    return this._context.measureText(t);
  }
  getImageData(t, i, n, r) {
    return this._context.getImageData(t, i, n, r);
  }
  lineTo(t, i) {
    this._context.lineTo(t, i);
  }
  moveTo(t, i) {
    this._context.moveTo(t, i);
  }
  rect(t, i, n, r) {
    this._context.rect(t, i, n, r);
  }
  putImageData(t, i, n) {
    this._context.putImageData(t, i, n);
  }
  quadraticCurveTo(t, i, n, r) {
    this._context.quadraticCurveTo(t, i, n, r);
  }
  restore() {
    this._context.restore();
  }
  rotate(t) {
    this._context.rotate(t);
  }
  save() {
    this._context.save();
  }
  scale(t, i) {
    this._context.scale(t, i);
  }
  setLineDash(t) {
    this._context.setLineDash ? this._context.setLineDash(t) : "mozDash" in this._context ? this._context.mozDash = t : "webkitLineDash" in this._context && (this._context.webkitLineDash = t);
  }
  getLineDash() {
    return this._context.getLineDash();
  }
  setTransform(t, i, n, r, g, o) {
    this._context.setTransform(t, i, n, r, g, o);
  }
  stroke(t) {
    t ? this._context.stroke(t) : this._context.stroke();
  }
  strokeText(t, i, n, r) {
    this._context.strokeText(t, i, n, r);
  }
  transform(t, i, n, r, g, o) {
    this._context.transform(t, i, n, r, g, o);
  }
  translate(t, i) {
    this._context.translate(t, i);
  }
  _enableTrace() {
    var t = this, i = yM.length, n = this.setAttr, r, g, o = function(l) {
      var a = t[l], I;
      t[l] = function() {
        return g = ABt(Array.prototype.slice.call(arguments, 0)), I = a.apply(t, arguments), t._trace({
          method: l,
          args: g
        }), I;
      };
    };
    for (r = 0; r < i; r++)
      o(yM[r]);
    t.setAttr = function() {
      n.apply(t, arguments);
      var l = arguments[0], a = arguments[1];
      (l === "shadowOffsetX" || l === "shadowOffsetY" || l === "shadowBlur") && (a = a / this.canvas.getPixelRatio()), t._trace({
        property: l,
        val: a
      });
    };
  }
  _applyGlobalCompositeOperation(t) {
    const i = t.attrs.globalCompositeOperation;
    var n = !i || i === "source-over";
    n || this.setAttr("globalCompositeOperation", i);
  }
};
GBt.forEach(function(e) {
  Object.defineProperty(a1.prototype, e, {
    get() {
      return this._context[e];
    },
    set(t) {
      this._context[e] = t;
    }
  });
});
class WBt extends a1 {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d");
  }
  _fillColor(t) {
    var i = t.fill();
    this.setAttr("fillStyle", i), t._fillFunc(this);
  }
  _fillPattern(t) {
    this.setAttr("fillStyle", t._getFillPattern()), t._fillFunc(this);
  }
  _fillLinearGradient(t) {
    var i = t._getLinearGradient();
    i && (this.setAttr("fillStyle", i), t._fillFunc(this));
  }
  _fillRadialGradient(t) {
    const i = t._getRadialGradient();
    i && (this.setAttr("fillStyle", i), t._fillFunc(this));
  }
  _fill(t) {
    const i = t.fill(), n = t.getFillPriority();
    if (i && n === "color") {
      this._fillColor(t);
      return;
    }
    const r = t.getFillPatternImage();
    if (r && n === "pattern") {
      this._fillPattern(t);
      return;
    }
    const g = t.getFillLinearGradientColorStops();
    if (g && n === "linear-gradient") {
      this._fillLinearGradient(t);
      return;
    }
    const o = t.getFillRadialGradientColorStops();
    if (o && n === "radial-gradient") {
      this._fillRadialGradient(t);
      return;
    }
    i ? this._fillColor(t) : r ? this._fillPattern(t) : g ? this._fillLinearGradient(t) : o && this._fillRadialGradient(t);
  }
  _strokeLinearGradient(t) {
    const i = t.getStrokeLinearGradientStartPoint(), n = t.getStrokeLinearGradientEndPoint(), r = t.getStrokeLinearGradientColorStops(), g = this.createLinearGradient(i.x, i.y, n.x, n.y);
    if (r) {
      for (var o = 0; o < r.length; o += 2)
        g.addColorStop(r[o], r[o + 1]);
      this.setAttr("strokeStyle", g);
    }
  }
  _stroke(t) {
    var i = t.dash(), n = t.getStrokeScaleEnabled();
    if (t.hasStroke()) {
      if (!n) {
        this.save();
        var r = this.getCanvas().getPixelRatio();
        this.setTransform(r, 0, 0, r, 0, 0);
      }
      this._applyLineCap(t), i && t.dashEnabled() && (this.setLineDash(i), this.setAttr("lineDashOffset", t.dashOffset())), this.setAttr("lineWidth", t.strokeWidth()), t.getShadowForStrokeEnabled() || this.setAttr("shadowColor", "rgba(0,0,0,0)");
      var g = t.getStrokeLinearGradientColorStops();
      g ? this._strokeLinearGradient(t) : this.setAttr("strokeStyle", t.stroke()), t._strokeFunc(this), n || this.restore();
    }
  }
  _applyShadow(t) {
    var i, n, r, g = (i = t.getShadowRGBA()) !== null && i !== void 0 ? i : "black", o = (n = t.getShadowBlur()) !== null && n !== void 0 ? n : 5, l = (r = t.getShadowOffset()) !== null && r !== void 0 ? r : {
      x: 0,
      y: 0
    }, a = t.getAbsoluteScale(), I = this.canvas.getPixelRatio(), c = a.x * I, d = a.y * I;
    this.setAttr("shadowColor", g), this.setAttr("shadowBlur", o * Math.min(Math.abs(c), Math.abs(d))), this.setAttr("shadowOffsetX", l.x * c), this.setAttr("shadowOffsetY", l.y * d);
  }
}
class SBt extends a1 {
  constructor(t) {
    super(t), this._context = t._canvas.getContext("2d", {
      willReadFrequently: !0
    });
  }
  _fill(t) {
    this.save(), this.setAttr("fillStyle", t.colorKey), t._fillFuncHit(this), this.restore();
  }
  strokeShape(t) {
    t.hasHitStroke() && this._stroke(t);
  }
  _stroke(t) {
    if (t.hasHitStroke()) {
      const g = t.getStrokeScaleEnabled();
      if (!g) {
        this.save();
        var i = this.getCanvas().getPixelRatio();
        this.setTransform(i, 0, 0, i, 0, 0);
      }
      this._applyLineCap(t);
      var n = t.hitStrokeWidth(), r = n === "auto" ? t.strokeWidth() : n;
      this.setAttr("lineWidth", r), this.setAttr("strokeStyle", t.colorKey), t._strokeFuncHit(this), g || this.restore();
    }
  }
}
var nS;
function VBt() {
  if (nS)
    return nS;
  var e = me.createCanvasElement(), t = e.getContext("2d");
  return nS = function() {
    var i = ei._global.devicePixelRatio || 1, n = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
    return i / n;
  }(), me.releaseCanvas(e), nS;
}
class s1 {
  constructor(t) {
    this.pixelRatio = 1, this.width = 0, this.height = 0, this.isCache = !1;
    var i = t || {}, n = i.pixelRatio || ei.pixelRatio || VBt();
    this.pixelRatio = n, this._canvas = me.createCanvasElement(), this._canvas.style.padding = "0", this._canvas.style.margin = "0", this._canvas.style.border = "0", this._canvas.style.background = "transparent", this._canvas.style.position = "absolute", this._canvas.style.top = "0", this._canvas.style.left = "0";
  }
  getContext() {
    return this.context;
  }
  getPixelRatio() {
    return this.pixelRatio;
  }
  setPixelRatio(t) {
    var i = this.pixelRatio;
    this.pixelRatio = t, this.setSize(this.getWidth() / i, this.getHeight() / i);
  }
  setWidth(t) {
    this.width = this._canvas.width = t * this.pixelRatio, this._canvas.style.width = t + "px";
    var i = this.pixelRatio, n = this.getContext()._context;
    n.scale(i, i);
  }
  setHeight(t) {
    this.height = this._canvas.height = t * this.pixelRatio, this._canvas.style.height = t + "px";
    var i = this.pixelRatio, n = this.getContext()._context;
    n.scale(i, i);
  }
  getWidth() {
    return this.width;
  }
  getHeight() {
    return this.height;
  }
  setSize(t, i) {
    this.setWidth(t || 0), this.setHeight(i || 0);
  }
  toDataURL(t, i) {
    try {
      return this._canvas.toDataURL(t, i);
    } catch {
      try {
        return this._canvas.toDataURL();
      } catch (r) {
        return me.error("Unable to get data URL. " + r.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html."), "";
      }
    }
  }
}
oe.addGetterSetter(s1, "pixelRatio", void 0, ft());
class jh extends s1 {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.context = new WBt(this), this.setSize(t.width, t.height);
  }
}
class eE extends s1 {
  constructor(t = { width: 0, height: 0 }) {
    super(t), this.hitCanvas = !0, this.context = new SBt(this), this.setSize(t.width, t.height);
  }
}
const ln = {
  get isDragging() {
    var e = !1;
    return ln._dragElements.forEach((t) => {
      t.dragStatus === "dragging" && (e = !0);
    }), e;
  },
  justDragged: !1,
  get node() {
    var e;
    return ln._dragElements.forEach((t) => {
      e = t.node;
    }), e;
  },
  _dragElements: /* @__PURE__ */ new Map(),
  _drag(e) {
    const t = [];
    ln._dragElements.forEach((i, n) => {
      const { node: r } = i, g = r.getStage();
      g.setPointersPositions(e), i.pointerId === void 0 && (i.pointerId = me._getFirstPointerId(e));
      const o = g._changedPointerPositions.find((I) => I.id === i.pointerId);
      if (o) {
        if (i.dragStatus !== "dragging") {
          var l = r.dragDistance(), a = Math.max(Math.abs(o.x - i.startPointerPos.x), Math.abs(o.y - i.startPointerPos.y));
          if (a < l || (r.startDrag({ evt: e }), !r.isDragging()))
            return;
        }
        r._setDragPosition(e, i), t.push(r);
      }
    }), t.forEach((i) => {
      i.fire("dragmove", {
        type: "dragmove",
        target: i,
        evt: e
      }, !0);
    });
  },
  _endDragBefore(e) {
    const t = [];
    ln._dragElements.forEach((i) => {
      const { node: n } = i, r = n.getStage();
      if (e && r.setPointersPositions(e), !r._changedPointerPositions.find((l) => l.id === i.pointerId))
        return;
      (i.dragStatus === "dragging" || i.dragStatus === "stopped") && (ln.justDragged = !0, ei._mouseListenClick = !1, ei._touchListenClick = !1, ei._pointerListenClick = !1, i.dragStatus = "stopped");
      const o = i.node.getLayer() || i.node instanceof ei.Stage && i.node;
      o && t.indexOf(o) === -1 && t.push(o);
    }), t.forEach((i) => {
      i.draw();
    });
  },
  _endDragAfter(e) {
    ln._dragElements.forEach((t, i) => {
      t.dragStatus === "stopped" && t.node.fire("dragend", {
        type: "dragend",
        target: t.node,
        evt: e
      }, !0), t.dragStatus !== "dragging" && ln._dragElements.delete(i);
    });
  }
};
ei.isBrowser && (window.addEventListener("mouseup", ln._endDragBefore, !0), window.addEventListener("touchend", ln._endDragBefore, !0), window.addEventListener("mousemove", ln._drag), window.addEventListener("touchmove", ln._drag), window.addEventListener("mouseup", ln._endDragAfter, !1), window.addEventListener("touchend", ln._endDragAfter, !1));
var hV = "absoluteOpacity", rS = "allEventListeners", Cc = "absoluteTransform", WM = "absoluteScale", uC = "canvas", wBt = "Change", vBt = "children", RBt = "konva", I5 = "listening", SM = "mouseenter", VM = "mouseleave", wM = "set", vM = "Shape", mV = " ", RM = "stage", fd = "transform", XBt = "Stage", c5 = "visible", HBt = [
  "xChange.konva",
  "yChange.konva",
  "scaleXChange.konva",
  "scaleYChange.konva",
  "skewXChange.konva",
  "skewYChange.konva",
  "rotationChange.konva",
  "offsetXChange.konva",
  "offsetYChange.konva",
  "transformsEnabledChange.konva"
].join(mV);
let kBt = 1, yt = class d5 {
  constructor(t) {
    this._id = kBt++, this.eventListeners = {}, this.attrs = {}, this.index = 0, this._allEventListeners = null, this.parent = null, this._cache = /* @__PURE__ */ new Map(), this._attachedDepsListeners = /* @__PURE__ */ new Map(), this._lastPos = null, this._batchingTransformChange = !1, this._needClearTransformCache = !1, this._filterUpToDate = !1, this._isUnderCache = !1, this._dragEventId = null, this._shouldFireChangeEvents = !1, this.setAttrs(t), this._shouldFireChangeEvents = !0;
  }
  hasChildren() {
    return !1;
  }
  _clearCache(t) {
    (t === fd || t === Cc) && this._cache.get(t) ? this._cache.get(t).dirty = !0 : t ? this._cache.delete(t) : this._cache.clear();
  }
  _getCache(t, i) {
    var n = this._cache.get(t), r = t === fd || t === Cc, g = n === void 0 || r && n.dirty === !0;
    return g && (n = i.call(this), this._cache.set(t, n)), n;
  }
  _calculate(t, i, n) {
    if (!this._attachedDepsListeners.get(t)) {
      const r = i.map((g) => g + "Change.konva").join(mV);
      this.on(r, () => {
        this._clearCache(t);
      }), this._attachedDepsListeners.set(t, !0);
    }
    return this._getCache(t, n);
  }
  _getCanvasCache() {
    return this._cache.get(uC);
  }
  _clearSelfAndDescendantCache(t) {
    this._clearCache(t), t === Cc && this.fire("absoluteTransformChange");
  }
  clearCache() {
    if (this._cache.has(uC)) {
      const { scene: t, filter: i, hit: n } = this._cache.get(uC);
      me.releaseCanvas(t, i, n), this._cache.delete(uC);
    }
    return this._clearSelfAndDescendantCache(), this._requestDraw(), this;
  }
  cache(t) {
    var i = t || {}, n = {};
    (i.x === void 0 || i.y === void 0 || i.width === void 0 || i.height === void 0) && (n = this.getClientRect({
      skipTransform: !0,
      relativeTo: this.getParent()
    }));
    var r = Math.ceil(i.width || n.width), g = Math.ceil(i.height || n.height), o = i.pixelRatio, l = i.x === void 0 ? Math.floor(n.x) : i.x, a = i.y === void 0 ? Math.floor(n.y) : i.y, I = i.offset || 0, c = i.drawBorder || !1, d = i.hitCanvasPixelRatio || 1;
    if (!r || !g) {
      me.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
      return;
    }
    r += I * 2 + 1, g += I * 2 + 1, l -= I, a -= I;
    var C = new jh({
      pixelRatio: o,
      width: r,
      height: g
    }), A = new jh({
      pixelRatio: o,
      width: 0,
      height: 0
    }), b = new eE({
      pixelRatio: d,
      width: r,
      height: g
    }), m = C.getContext(), p = b.getContext();
    return b.isCache = !0, C.isCache = !0, this._cache.delete(uC), this._filterUpToDate = !1, i.imageSmoothingEnabled === !1 && (C.getContext()._context.imageSmoothingEnabled = !1, A.getContext()._context.imageSmoothingEnabled = !1), m.save(), p.save(), m.translate(-l, -a), p.translate(-l, -a), this._isUnderCache = !0, this._clearSelfAndDescendantCache(hV), this._clearSelfAndDescendantCache(WM), this.drawScene(C, this), this.drawHit(b, this), this._isUnderCache = !1, m.restore(), p.restore(), c && (m.save(), m.beginPath(), m.rect(0, 0, r, g), m.closePath(), m.setAttr("strokeStyle", "red"), m.setAttr("lineWidth", 5), m.stroke(), m.restore()), this._cache.set(uC, {
      scene: C,
      filter: A,
      hit: b,
      x: l,
      y: a
    }), this._requestDraw(), this;
  }
  isCached() {
    return this._cache.has(uC);
  }
  getClientRect(t) {
    throw new Error('abstract "getClientRect" method call');
  }
  _transformedRect(t, i) {
    var n = [
      { x: t.x, y: t.y },
      { x: t.x + t.width, y: t.y },
      { x: t.x + t.width, y: t.y + t.height },
      { x: t.x, y: t.y + t.height }
    ], r, g, o, l, a = this.getAbsoluteTransform(i);
    return n.forEach(function(I) {
      var c = a.point(I);
      r === void 0 && (r = o = c.x, g = l = c.y), r = Math.min(r, c.x), g = Math.min(g, c.y), o = Math.max(o, c.x), l = Math.max(l, c.y);
    }), {
      x: r,
      y: g,
      width: o - r,
      height: l - g
    };
  }
  _drawCachedSceneCanvas(t) {
    t.save(), t._applyOpacity(this), t._applyGlobalCompositeOperation(this);
    const i = this._getCanvasCache();
    t.translate(i.x, i.y);
    var n = this._getCachedSceneCanvas(), r = n.pixelRatio;
    t.drawImage(n._canvas, 0, 0, n.width / r, n.height / r), t.restore();
  }
  _drawCachedHitCanvas(t) {
    var i = this._getCanvasCache(), n = i.hit;
    t.save(), t.translate(i.x, i.y), t.drawImage(n._canvas, 0, 0, n.width / n.pixelRatio, n.height / n.pixelRatio), t.restore();
  }
  _getCachedSceneCanvas() {
    var t = this.filters(), i = this._getCanvasCache(), n = i.scene, r = i.filter, g = r.getContext(), o, l, a, I;
    if (t) {
      if (!this._filterUpToDate) {
        var c = n.pixelRatio;
        r.setSize(n.width / n.pixelRatio, n.height / n.pixelRatio);
        try {
          for (o = t.length, g.clear(), g.drawImage(n._canvas, 0, 0, n.getWidth() / c, n.getHeight() / c), l = g.getImageData(0, 0, r.getWidth(), r.getHeight()), a = 0; a < o; a++) {
            if (I = t[a], typeof I != "function") {
              me.error("Filter should be type of function, but got " + typeof I + " instead. Please check correct filters");
              continue;
            }
            I.call(this, l), g.putImageData(l, 0, 0);
          }
        } catch (d) {
          me.error("Unable to apply filter. " + d.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
        }
        this._filterUpToDate = !0;
      }
      return r;
    }
    return n;
  }
  on(t, i) {
    if (this._cache && this._cache.delete(rS), arguments.length === 3)
      return this._delegate.apply(this, arguments);
    var n = t.split(mV), r = n.length, g, o, l, a, I;
    for (g = 0; g < r; g++)
      o = n[g], l = o.split("."), a = l[0], I = l[1] || "", this.eventListeners[a] || (this.eventListeners[a] = []), this.eventListeners[a].push({
        name: I,
        handler: i
      });
    return this;
  }
  off(t, i) {
    var n = (t || "").split(mV), r = n.length, g, o, l, a, I, c;
    if (this._cache && this._cache.delete(rS), !t)
      for (o in this.eventListeners)
        this._off(o);
    for (g = 0; g < r; g++)
      if (l = n[g], a = l.split("."), I = a[0], c = a[1], I)
        this.eventListeners[I] && this._off(I, c, i);
      else
        for (o in this.eventListeners)
          this._off(o, c, i);
    return this;
  }
  dispatchEvent(t) {
    var i = {
      target: this,
      type: t.type,
      evt: t
    };
    return this.fire(t.type, i), this;
  }
  addEventListener(t, i) {
    return this.on(t, function(n) {
      i.call(this, n.evt);
    }), this;
  }
  removeEventListener(t) {
    return this.off(t), this;
  }
  _delegate(t, i, n) {
    var r = this;
    this.on(t, function(g) {
      for (var o = g.target.findAncestors(i, !0, r), l = 0; l < o.length; l++)
        g = me.cloneObject(g), g.currentTarget = o[l], n.call(o[l], g);
    });
  }
  remove() {
    return this.isDragging() && this.stopDrag(), ln._dragElements.delete(this._id), this._remove(), this;
  }
  _clearCaches() {
    this._clearSelfAndDescendantCache(Cc), this._clearSelfAndDescendantCache(hV), this._clearSelfAndDescendantCache(WM), this._clearSelfAndDescendantCache(RM), this._clearSelfAndDescendantCache(c5), this._clearSelfAndDescendantCache(I5);
  }
  _remove() {
    this._clearCaches();
    var t = this.getParent();
    t && t.children && (t.children.splice(this.index, 1), t._setChildrenIndices(), this.parent = null);
  }
  destroy() {
    return this.remove(), this.clearCache(), this;
  }
  getAttr(t) {
    var i = "get" + me._capitalize(t);
    return me._isFunction(this[i]) ? this[i]() : this.attrs[t];
  }
  getAncestors() {
    for (var t = this.getParent(), i = []; t; )
      i.push(t), t = t.getParent();
    return i;
  }
  getAttrs() {
    return this.attrs || {};
  }
  setAttrs(t) {
    return this._batchTransformChanges(() => {
      var i, n;
      if (!t)
        return this;
      for (i in t)
        i !== vBt && (n = wM + me._capitalize(i), me._isFunction(this[n]) ? this[n](t[i]) : this._setAttr(i, t[i]));
    }), this;
  }
  isListening() {
    return this._getCache(I5, this._isListening);
  }
  _isListening(t) {
    if (!this.listening())
      return !1;
    const n = this.getParent();
    return n && n !== t && this !== t ? n._isListening(t) : !0;
  }
  isVisible() {
    return this._getCache(c5, this._isVisible);
  }
  _isVisible(t) {
    if (!this.visible())
      return !1;
    const n = this.getParent();
    return n && n !== t && this !== t ? n._isVisible(t) : !0;
  }
  shouldDrawHit(t, i = !1) {
    if (t)
      return this._isVisible(t) && this._isListening(t);
    var n = this.getLayer(), r = !1;
    ln._dragElements.forEach((o) => {
      o.dragStatus === "dragging" && (o.node.nodeType === "Stage" || o.node.getLayer() === n) && (r = !0);
    });
    var g = !i && !ei.hitOnDragEnabled && r;
    return this.isListening() && this.isVisible() && !g;
  }
  show() {
    return this.visible(!0), this;
  }
  hide() {
    return this.visible(!1), this;
  }
  getZIndex() {
    return this.index || 0;
  }
  getAbsoluteZIndex() {
    var t = this.getDepth(), i = this, n = 0, r, g, o, l;
    function a(I) {
      for (r = [], g = I.length, o = 0; o < g; o++)
        l = I[o], n++, l.nodeType !== vM && (r = r.concat(l.getChildren().slice())), l._id === i._id && (o = g);
      r.length > 0 && r[0].getDepth() <= t && a(r);
    }
    return i.nodeType !== XBt && a(i.getStage().getChildren()), n;
  }
  getDepth() {
    for (var t = 0, i = this.parent; i; )
      t++, i = i.parent;
    return t;
  }
  _batchTransformChanges(t) {
    this._batchingTransformChange = !0, t(), this._batchingTransformChange = !1, this._needClearTransformCache && (this._clearCache(fd), this._clearSelfAndDescendantCache(Cc)), this._needClearTransformCache = !1;
  }
  setPosition(t) {
    return this._batchTransformChanges(() => {
      this.x(t.x), this.y(t.y);
    }), this;
  }
  getPosition() {
    return {
      x: this.x(),
      y: this.y()
    };
  }
  getRelativePointerPosition() {
    if (!this.getStage())
      return null;
    var t = this.getStage().getPointerPosition();
    if (!t)
      return null;
    var i = this.getAbsoluteTransform().copy();
    return i.invert(), i.point(t);
  }
  getAbsolutePosition(t) {
    let i = !1, n = this.parent;
    for (; n; ) {
      if (n.isCached()) {
        i = !0;
        break;
      }
      n = n.parent;
    }
    i && !t && (t = !0);
    var r = this.getAbsoluteTransform(t).getMatrix(), g = new Hl(), o = this.offset();
    return g.m = r.slice(), g.translate(o.x, o.y), g.getTranslation();
  }
  setAbsolutePosition(t) {
    var i = this._clearTransform();
    this.attrs.x = i.x, this.attrs.y = i.y, delete i.x, delete i.y, this._clearCache(fd);
    var n = this._getAbsoluteTransform().copy();
    return n.invert(), n.translate(t.x, t.y), t = {
      x: this.attrs.x + n.getTranslation().x,
      y: this.attrs.y + n.getTranslation().y
    }, this._setTransform(i), this.setPosition({ x: t.x, y: t.y }), this._clearCache(fd), this._clearSelfAndDescendantCache(Cc), this;
  }
  _setTransform(t) {
    var i;
    for (i in t)
      this.attrs[i] = t[i];
  }
  _clearTransform() {
    var t = {
      x: this.x(),
      y: this.y(),
      rotation: this.rotation(),
      scaleX: this.scaleX(),
      scaleY: this.scaleY(),
      offsetX: this.offsetX(),
      offsetY: this.offsetY(),
      skewX: this.skewX(),
      skewY: this.skewY()
    };
    return this.attrs.x = 0, this.attrs.y = 0, this.attrs.rotation = 0, this.attrs.scaleX = 1, this.attrs.scaleY = 1, this.attrs.offsetX = 0, this.attrs.offsetY = 0, this.attrs.skewX = 0, this.attrs.skewY = 0, t;
  }
  move(t) {
    var i = t.x, n = t.y, r = this.x(), g = this.y();
    return i !== void 0 && (r += i), n !== void 0 && (g += n), this.setPosition({ x: r, y: g }), this;
  }
  _eachAncestorReverse(t, i) {
    var n = [], r = this.getParent(), g, o;
    if (!(i && i._id === this._id)) {
      for (n.unshift(this); r && (!i || r._id !== i._id); )
        n.unshift(r), r = r.parent;
      for (g = n.length, o = 0; o < g; o++)
        t(n[o]);
    }
  }
  rotate(t) {
    return this.rotation(this.rotation() + t), this;
  }
  moveToTop() {
    if (!this.parent)
      return me.warn("Node has no parent. moveToTop function is ignored."), !1;
    var t = this.index, i = this.parent.getChildren().length;
    return t < i - 1 ? (this.parent.children.splice(t, 1), this.parent.children.push(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveUp() {
    if (!this.parent)
      return me.warn("Node has no parent. moveUp function is ignored."), !1;
    var t = this.index, i = this.parent.getChildren().length;
    return t < i - 1 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t + 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveDown() {
    if (!this.parent)
      return me.warn("Node has no parent. moveDown function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.splice(t - 1, 0, this), this.parent._setChildrenIndices(), !0) : !1;
  }
  moveToBottom() {
    if (!this.parent)
      return me.warn("Node has no parent. moveToBottom function is ignored."), !1;
    var t = this.index;
    return t > 0 ? (this.parent.children.splice(t, 1), this.parent.children.unshift(this), this.parent._setChildrenIndices(), !0) : !1;
  }
  setZIndex(t) {
    if (!this.parent)
      return me.warn("Node has no parent. zIndex parameter is ignored."), this;
    (t < 0 || t >= this.parent.children.length) && me.warn("Unexpected value " + t + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
    var i = this.index;
    return this.parent.children.splice(i, 1), this.parent.children.splice(t, 0, this), this.parent._setChildrenIndices(), this;
  }
  getAbsoluteOpacity() {
    return this._getCache(hV, this._getAbsoluteOpacity);
  }
  _getAbsoluteOpacity() {
    var t = this.opacity(), i = this.getParent();
    return i && !i._isUnderCache && (t *= i.getAbsoluteOpacity()), t;
  }
  moveTo(t) {
    return this.getParent() !== t && (this._remove(), t.add(this)), this;
  }
  toObject() {
    var t = {}, i = this.getAttrs(), n, r, g, o, l;
    t.attrs = {};
    for (n in i)
      r = i[n], l = me.isObject(r) && !me._isPlainObject(r) && !me._isArray(r), !l && (g = typeof this[n] == "function" && this[n], delete i[n], o = g ? g.call(this) : null, i[n] = r, o !== r && (t.attrs[n] = r));
    return t.className = this.getClassName(), me._prepareToStringify(t);
  }
  toJSON() {
    return JSON.stringify(this.toObject());
  }
  getParent() {
    return this.parent;
  }
  findAncestors(t, i, n) {
    var r = [];
    i && this._isMatch(t) && r.push(this);
    for (var g = this.parent; g; ) {
      if (g === n)
        return r;
      g._isMatch(t) && r.push(g), g = g.parent;
    }
    return r;
  }
  isAncestorOf(t) {
    return !1;
  }
  findAncestor(t, i, n) {
    return this.findAncestors(t, i, n)[0];
  }
  _isMatch(t) {
    if (!t)
      return !1;
    if (typeof t == "function")
      return t(this);
    var i = t.replace(/ /g, "").split(","), n = i.length, r, g;
    for (r = 0; r < n; r++)
      if (g = i[r], me.isValidSelector(g) || (me.warn('Selector "' + g + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".'), me.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".'), me.warn("Konva is awesome, right?")), g.charAt(0) === "#") {
        if (this.id() === g.slice(1))
          return !0;
      } else if (g.charAt(0) === ".") {
        if (this.hasName(g.slice(1)))
          return !0;
      } else if (this.className === g || this.nodeType === g)
        return !0;
    return !1;
  }
  getLayer() {
    var t = this.getParent();
    return t ? t.getLayer() : null;
  }
  getStage() {
    return this._getCache(RM, this._getStage);
  }
  _getStage() {
    var t = this.getParent();
    if (t)
      return t.getStage();
  }
  fire(t, i = {}, n) {
    return i.target = i.target || this, n ? this._fireAndBubble(t, i) : this._fire(t, i), this;
  }
  getAbsoluteTransform(t) {
    return t ? this._getAbsoluteTransform(t) : this._getCache(Cc, this._getAbsoluteTransform);
  }
  _getAbsoluteTransform(t) {
    var i;
    if (t)
      return i = new Hl(), this._eachAncestorReverse(function(r) {
        var g = r.transformsEnabled();
        g === "all" ? i.multiply(r.getTransform()) : g === "position" && i.translate(r.x() - r.offsetX(), r.y() - r.offsetY());
      }, t), i;
    i = this._cache.get(Cc) || new Hl(), this.parent ? this.parent.getAbsoluteTransform().copyInto(i) : i.reset();
    var n = this.transformsEnabled();
    if (n === "all")
      i.multiply(this.getTransform());
    else if (n === "position") {
      const r = this.attrs.x || 0, g = this.attrs.y || 0, o = this.attrs.offsetX || 0, l = this.attrs.offsetY || 0;
      i.translate(r - o, g - l);
    }
    return i.dirty = !1, i;
  }
  getAbsoluteScale(t) {
    for (var i = this; i; )
      i._isUnderCache && (t = i), i = i.getParent();
    const r = this.getAbsoluteTransform(t).decompose();
    return {
      x: r.scaleX,
      y: r.scaleY
    };
  }
  getAbsoluteRotation() {
    return this.getAbsoluteTransform().decompose().rotation;
  }
  getTransform() {
    return this._getCache(fd, this._getTransform);
  }
  _getTransform() {
    var t, i, n = this._cache.get(fd) || new Hl();
    n.reset();
    var r = this.x(), g = this.y(), o = ei.getAngle(this.rotation()), l = (t = this.attrs.scaleX) !== null && t !== void 0 ? t : 1, a = (i = this.attrs.scaleY) !== null && i !== void 0 ? i : 1, I = this.attrs.skewX || 0, c = this.attrs.skewY || 0, d = this.attrs.offsetX || 0, C = this.attrs.offsetY || 0;
    return (r !== 0 || g !== 0) && n.translate(r, g), o !== 0 && n.rotate(o), (I !== 0 || c !== 0) && n.skew(I, c), (l !== 1 || a !== 1) && n.scale(l, a), (d !== 0 || C !== 0) && n.translate(-1 * d, -1 * C), n.dirty = !1, n;
  }
  clone(t) {
    var i = me.cloneObject(this.attrs), n, r, g, o, l;
    for (n in t)
      i[n] = t[n];
    var a = new this.constructor(i);
    for (n in this.eventListeners)
      for (r = this.eventListeners[n], g = r.length, o = 0; o < g; o++)
        l = r[o], l.name.indexOf(RBt) < 0 && (a.eventListeners[n] || (a.eventListeners[n] = []), a.eventListeners[n].push(l));
    return a;
  }
  _toKonvaCanvas(t) {
    t = t || {};
    var i = this.getClientRect(), n = this.getStage(), r = t.x !== void 0 ? t.x : Math.floor(i.x), g = t.y !== void 0 ? t.y : Math.floor(i.y), o = t.pixelRatio || 1, l = new jh({
      width: t.width || Math.ceil(i.width) || (n ? n.width() : 0),
      height: t.height || Math.ceil(i.height) || (n ? n.height() : 0),
      pixelRatio: o
    }), a = l.getContext();
    return t.imageSmoothingEnabled === !1 && (a._context.imageSmoothingEnabled = !1), a.save(), (r || g) && a.translate(-1 * r, -1 * g), this.drawScene(l), a.restore(), l;
  }
  toCanvas(t) {
    return this._toKonvaCanvas(t)._canvas;
  }
  toDataURL(t) {
    t = t || {};
    var i = t.mimeType || null, n = t.quality || null, r = this._toKonvaCanvas(t).toDataURL(i, n);
    return t.callback && t.callback(r), r;
  }
  toImage(t) {
    return new Promise((i, n) => {
      try {
        const r = t == null ? void 0 : t.callback;
        r && delete t.callback, me._urlToImage(this.toDataURL(t), function(g) {
          i(g), r == null || r(g);
        });
      } catch (r) {
        n(r);
      }
    });
  }
  toBlob(t) {
    return new Promise((i, n) => {
      try {
        const r = t == null ? void 0 : t.callback;
        r && delete t.callback, this.toCanvas(t).toBlob((g) => {
          i(g), r == null || r(g);
        });
      } catch (r) {
        n(r);
      }
    });
  }
  setSize(t) {
    return this.width(t.width), this.height(t.height), this;
  }
  getSize() {
    return {
      width: this.width(),
      height: this.height()
    };
  }
  getClassName() {
    return this.className || this.nodeType;
  }
  getType() {
    return this.nodeType;
  }
  getDragDistance() {
    return this.attrs.dragDistance !== void 0 ? this.attrs.dragDistance : this.parent ? this.parent.getDragDistance() : ei.dragDistance;
  }
  _off(t, i, n) {
    var r = this.eventListeners[t], g, o, l;
    for (g = 0; g < r.length; g++)
      if (o = r[g].name, l = r[g].handler, (o !== "konva" || i === "konva") && (!i || o === i) && (!n || n === l)) {
        if (r.splice(g, 1), r.length === 0) {
          delete this.eventListeners[t];
          break;
        }
        g--;
      }
  }
  _fireChangeEvent(t, i, n) {
    this._fire(t + wBt, {
      oldVal: i,
      newVal: n
    });
  }
  addName(t) {
    if (!this.hasName(t)) {
      var i = this.name(), n = i ? i + " " + t : t;
      this.name(n);
    }
    return this;
  }
  hasName(t) {
    if (!t)
      return !1;
    const i = this.name();
    if (!i)
      return !1;
    var n = (i || "").split(/\s/g);
    return n.indexOf(t) !== -1;
  }
  removeName(t) {
    var i = (this.name() || "").split(/\s/g), n = i.indexOf(t);
    return n !== -1 && (i.splice(n, 1), this.name(i.join(" "))), this;
  }
  setAttr(t, i) {
    var n = this[wM + me._capitalize(t)];
    return me._isFunction(n) ? n.call(this, i) : this._setAttr(t, i), this;
  }
  _requestDraw() {
    if (ei.autoDrawEnabled) {
      const t = this.getLayer() || this.getStage();
      t == null || t.batchDraw();
    }
  }
  _setAttr(t, i) {
    var n = this.attrs[t];
    n === i && !me.isObject(i) || (i == null ? delete this.attrs[t] : this.attrs[t] = i, this._shouldFireChangeEvents && this._fireChangeEvent(t, n, i), this._requestDraw());
  }
  _setComponentAttr(t, i, n) {
    var r;
    n !== void 0 && (r = this.attrs[t], r || (this.attrs[t] = this.getAttr(t)), this.attrs[t][i] = n, this._fireChangeEvent(t, r, n));
  }
  _fireAndBubble(t, i, n) {
    i && this.nodeType === vM && (i.target = this);
    var r = (t === SM || t === VM) && (n && (this === n || this.isAncestorOf && this.isAncestorOf(n)) || this.nodeType === "Stage" && !n);
    if (!r) {
      this._fire(t, i);
      var g = (t === SM || t === VM) && n && n.isAncestorOf && n.isAncestorOf(this) && !n.isAncestorOf(this.parent);
      (i && !i.cancelBubble || !i) && this.parent && this.parent.isListening() && !g && (n && n.parent ? this._fireAndBubble.call(this.parent, t, i, n) : this._fireAndBubble.call(this.parent, t, i));
    }
  }
  _getProtoListeners(t) {
    let i = this._cache.get(rS);
    if (!i) {
      i = {};
      let r = Object.getPrototypeOf(this);
      for (; r; ) {
        if (!r.eventListeners) {
          r = Object.getPrototypeOf(r);
          continue;
        }
        for (var n in r.eventListeners) {
          const g = r.eventListeners[n], o = i[n] || [];
          i[n] = g.concat(o);
        }
        r = Object.getPrototypeOf(r);
      }
      this._cache.set(rS, i);
    }
    return i[t];
  }
  _fire(t, i) {
    i = i || {}, i.currentTarget = this, i.type = t;
    const n = this._getProtoListeners(t);
    if (n)
      for (var r = 0; r < n.length; r++)
        n[r].handler.call(this, i);
    const g = this.eventListeners[t];
    if (g)
      for (var r = 0; r < g.length; r++)
        g[r].handler.call(this, i);
  }
  draw() {
    return this.drawScene(), this.drawHit(), this;
  }
  _createDragElement(t) {
    var i = t ? t.pointerId : void 0, n = this.getStage(), r = this.getAbsolutePosition(), g = n._getPointerById(i) || n._changedPointerPositions[0] || r;
    ln._dragElements.set(this._id, {
      node: this,
      startPointerPos: g,
      offset: {
        x: g.x - r.x,
        y: g.y - r.y
      },
      dragStatus: "ready",
      pointerId: i
    });
  }
  startDrag(t, i = !0) {
    ln._dragElements.has(this._id) || this._createDragElement(t);
    const n = ln._dragElements.get(this._id);
    n.dragStatus = "dragging", this.fire("dragstart", {
      type: "dragstart",
      target: this,
      evt: t && t.evt
    }, i);
  }
  _setDragPosition(t, i) {
    const n = this.getStage()._getPointerById(i.pointerId);
    if (n) {
      var r = {
        x: n.x - i.offset.x,
        y: n.y - i.offset.y
      }, g = this.dragBoundFunc();
      if (g !== void 0) {
        const o = g.call(this, r, t);
        o ? r = o : me.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
      }
      (!this._lastPos || this._lastPos.x !== r.x || this._lastPos.y !== r.y) && (this.setAbsolutePosition(r), this._requestDraw()), this._lastPos = r;
    }
  }
  stopDrag(t) {
    const i = ln._dragElements.get(this._id);
    i && (i.dragStatus = "stopped"), ln._endDragBefore(t), ln._endDragAfter(t);
  }
  setDraggable(t) {
    this._setAttr("draggable", t), this._dragChange();
  }
  isDragging() {
    const t = ln._dragElements.get(this._id);
    return t ? t.dragStatus === "dragging" : !1;
  }
  _listenDrag() {
    this._dragCleanup(), this.on("mousedown.konva touchstart.konva", function(t) {
      var i = t.evt.button !== void 0, n = !i || ei.dragButtons.indexOf(t.evt.button) >= 0;
      if (n && !this.isDragging()) {
        var r = !1;
        ln._dragElements.forEach((g) => {
          this.isAncestorOf(g.node) && (r = !0);
        }), r || this._createDragElement(t);
      }
    });
  }
  _dragChange() {
    if (this.attrs.draggable)
      this._listenDrag();
    else {
      this._dragCleanup();
      var t = this.getStage();
      if (!t)
        return;
      const i = ln._dragElements.get(this._id), n = i && i.dragStatus === "dragging", r = i && i.dragStatus === "ready";
      n ? this.stopDrag() : r && ln._dragElements.delete(this._id);
    }
  }
  _dragCleanup() {
    this.off("mousedown.konva"), this.off("touchstart.konva");
  }
  isClientRectOnScreen(t = { x: 0, y: 0 }) {
    const i = this.getStage();
    if (!i)
      return !1;
    const n = {
      x: -t.x,
      y: -t.y,
      width: i.width() + 2 * t.x,
      height: i.height() + 2 * t.y
    };
    return me.haveIntersection(n, this.getClientRect());
  }
  static create(t, i) {
    return me._isString(t) && (t = JSON.parse(t)), this._createNode(t, i);
  }
  static _createNode(t, i) {
    var n = d5.prototype.getClassName.call(t), r = t.children, g, o, l;
    i && (t.attrs.container = i), ei[n] || (me.warn('Can not find a node with class name "' + n + '". Fallback to "Shape".'), n = "Shape");
    const a = ei[n];
    if (g = new a(t.attrs), r)
      for (o = r.length, l = 0; l < o; l++)
        g.add(d5._createNode(r[l]));
    return g;
  }
};
yt.prototype.nodeType = "Node";
yt.prototype._attrsAffectingSize = [];
yt.prototype.eventListeners = {};
yt.prototype.on.call(yt.prototype, HBt, function() {
  if (this._batchingTransformChange) {
    this._needClearTransformCache = !0;
    return;
  }
  this._clearCache(fd), this._clearSelfAndDescendantCache(Cc);
});
yt.prototype.on.call(yt.prototype, "visibleChange.konva", function() {
  this._clearSelfAndDescendantCache(c5);
});
yt.prototype.on.call(yt.prototype, "listeningChange.konva", function() {
  this._clearSelfAndDescendantCache(I5);
});
yt.prototype.on.call(yt.prototype, "opacityChange.konva", function() {
  this._clearSelfAndDescendantCache(hV);
});
const En = oe.addGetterSetter;
En(yt, "zIndex");
En(yt, "absolutePosition");
En(yt, "position");
En(yt, "x", 0, ft());
En(yt, "y", 0, ft());
En(yt, "globalCompositeOperation", "source-over", Nm());
En(yt, "opacity", 1, ft());
En(yt, "name", "", Nm());
En(yt, "id", "", Nm());
En(yt, "rotation", 0, ft());
oe.addComponentsGetterSetter(yt, "scale", ["x", "y"]);
En(yt, "scaleX", 1, ft());
En(yt, "scaleY", 1, ft());
oe.addComponentsGetterSetter(yt, "skew", ["x", "y"]);
En(yt, "skewX", 0, ft());
En(yt, "skewY", 0, ft());
oe.addComponentsGetterSetter(yt, "offset", ["x", "y"]);
En(yt, "offsetX", 0, ft());
En(yt, "offsetY", 0, ft());
En(yt, "dragDistance", null, ft());
En(yt, "width", 0, ft());
En(yt, "height", 0, ft());
En(yt, "listening", !0, Ts());
En(yt, "preventDefault", !0, Ts());
En(yt, "filters", null, function(e) {
  return this._filterUpToDate = !1, e;
});
En(yt, "visible", !0, Ts());
En(yt, "transformsEnabled", "all", Nm());
En(yt, "size");
En(yt, "dragBoundFunc");
En(yt, "draggable", !1, Ts());
oe.backCompat(yt, {
  rotateDeg: "rotate",
  setRotationDeg: "setRotation",
  getRotationDeg: "getRotation"
});
class Kl extends yt {
  constructor() {
    super(...arguments), this.children = [];
  }
  getChildren(t) {
    if (!t)
      return this.children || [];
    const i = this.children || [];
    var n = [];
    return i.forEach(function(r) {
      t(r) && n.push(r);
    }), n;
  }
  hasChildren() {
    return this.getChildren().length > 0;
  }
  removeChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.remove();
    }), this.children = [], this._requestDraw(), this;
  }
  destroyChildren() {
    return this.getChildren().forEach((t) => {
      t.parent = null, t.index = 0, t.destroy();
    }), this.children = [], this._requestDraw(), this;
  }
  add(...t) {
    if (t.length === 0)
      return this;
    if (t.length > 1) {
      for (var i = 0; i < t.length; i++)
        this.add(t[i]);
      return this;
    }
    const n = t[0];
    return n.getParent() ? (n.moveTo(this), this) : (this._validateAdd(n), n.index = this.getChildren().length, n.parent = this, n._clearCaches(), this.getChildren().push(n), this._fire("add", {
      child: n
    }), this._requestDraw(), this);
  }
  destroy() {
    return this.hasChildren() && this.destroyChildren(), super.destroy(), this;
  }
  find(t) {
    return this._generalFind(t, !1);
  }
  findOne(t) {
    var i = this._generalFind(t, !0);
    return i.length > 0 ? i[0] : void 0;
  }
  _generalFind(t, i) {
    var n = [];
    return this._descendants((r) => {
      const g = r._isMatch(t);
      return g && n.push(r), !!(g && i);
    }), n;
  }
  _descendants(t) {
    let i = !1;
    const n = this.getChildren();
    for (const r of n) {
      if (i = t(r), i)
        return !0;
      if (r.hasChildren() && (i = r._descendants(t), i))
        return !0;
    }
    return !1;
  }
  toObject() {
    var t = yt.prototype.toObject.call(this);
    return t.children = [], this.getChildren().forEach((i) => {
      t.children.push(i.toObject());
    }), t;
  }
  isAncestorOf(t) {
    for (var i = t.getParent(); i; ) {
      if (i._id === this._id)
        return !0;
      i = i.getParent();
    }
    return !1;
  }
  clone(t) {
    var i = yt.prototype.clone.call(this, t);
    return this.getChildren().forEach(function(n) {
      i.add(n.clone());
    }), i;
  }
  getAllIntersections(t) {
    var i = [];
    return this.find("Shape").forEach(function(n) {
      n.isVisible() && n.intersects(t) && i.push(n);
    }), i;
  }
  _clearSelfAndDescendantCache(t) {
    var i;
    super._clearSelfAndDescendantCache(t), !this.isCached() && ((i = this.children) === null || i === void 0 || i.forEach(function(n) {
      n._clearSelfAndDescendantCache(t);
    }));
  }
  _setChildrenIndices() {
    var t;
    (t = this.children) === null || t === void 0 || t.forEach(function(i, n) {
      i.index = n;
    }), this._requestDraw();
  }
  drawScene(t, i) {
    var n = this.getLayer(), r = t || n && n.getCanvas(), g = r && r.getContext(), o = this._getCanvasCache(), l = o && o.scene, a = r && r.isCache;
    if (!this.isVisible() && !a)
      return this;
    if (l) {
      g.save();
      var I = this.getAbsoluteTransform(i).getMatrix();
      g.transform(I[0], I[1], I[2], I[3], I[4], I[5]), this._drawCachedSceneCanvas(g), g.restore();
    } else
      this._drawChildren("drawScene", r, i);
    return this;
  }
  drawHit(t, i) {
    if (!this.shouldDrawHit(i))
      return this;
    var n = this.getLayer(), r = t || n && n.hitCanvas, g = r && r.getContext(), o = this._getCanvasCache(), l = o && o.hit;
    if (l) {
      g.save();
      var a = this.getAbsoluteTransform(i).getMatrix();
      g.transform(a[0], a[1], a[2], a[3], a[4], a[5]), this._drawCachedHitCanvas(g), g.restore();
    } else
      this._drawChildren("drawHit", r, i);
    return this;
  }
  _drawChildren(t, i, n) {
    var r, g = i && i.getContext(), o = this.clipWidth(), l = this.clipHeight(), a = this.clipFunc(), I = o && l || a;
    const c = n === this;
    if (I) {
      g.save();
      var d = this.getAbsoluteTransform(n), C = d.getMatrix();
      if (g.transform(C[0], C[1], C[2], C[3], C[4], C[5]), g.beginPath(), a)
        a.call(this, g, this);
      else {
        var A = this.clipX(), b = this.clipY();
        g.rect(A, b, o, l);
      }
      g.clip(), C = d.copy().invert().getMatrix(), g.transform(C[0], C[1], C[2], C[3], C[4], C[5]);
    }
    var m = !c && this.globalCompositeOperation() !== "source-over" && t === "drawScene";
    m && (g.save(), g._applyGlobalCompositeOperation(this)), (r = this.children) === null || r === void 0 || r.forEach(function(p) {
      p[t](i, n);
    }), m && g.restore(), I && g.restore();
  }
  getClientRect(t) {
    var i;
    t = t || {};
    var n = t.skipTransform, r = t.relativeTo, g, o, l, a, I = {
      x: 1 / 0,
      y: 1 / 0,
      width: 0,
      height: 0
    }, c = this;
    (i = this.children) === null || i === void 0 || i.forEach(function(m) {
      if (m.visible()) {
        var p = m.getClientRect({
          relativeTo: c,
          skipShadow: t.skipShadow,
          skipStroke: t.skipStroke
        });
        p.width === 0 && p.height === 0 || (g === void 0 ? (g = p.x, o = p.y, l = p.x + p.width, a = p.y + p.height) : (g = Math.min(g, p.x), o = Math.min(o, p.y), l = Math.max(l, p.x + p.width), a = Math.max(a, p.y + p.height)));
      }
    });
    for (var d = this.find("Shape"), C = !1, A = 0; A < d.length; A++) {
      var b = d[A];
      if (b._isVisible(this)) {
        C = !0;
        break;
      }
    }
    return C && g !== void 0 ? I = {
      x: g,
      y: o,
      width: l - g,
      height: a - o
    } : I = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, n ? I : this._transformedRect(I, r);
  }
}
oe.addComponentsGetterSetter(Kl, "clip", [
  "x",
  "y",
  "width",
  "height"
]);
oe.addGetterSetter(Kl, "clipX", void 0, ft());
oe.addGetterSetter(Kl, "clipY", void 0, ft());
oe.addGetterSetter(Kl, "clipWidth", void 0, ft());
oe.addGetterSetter(Kl, "clipHeight", void 0, ft());
oe.addGetterSetter(Kl, "clipFunc");
const Tf = /* @__PURE__ */ new Map(), W_ = ei._global.PointerEvent !== void 0;
function DY(e) {
  return Tf.get(e);
}
function tE(e) {
  return {
    evt: e,
    pointerId: e.pointerId
  };
}
function S_(e, t) {
  return Tf.get(e) === t;
}
function V_(e, t) {
  $B(e), t.getStage() && (Tf.set(e, t), W_ && t._fire("gotpointercapture", tE(new PointerEvent("gotpointercapture"))));
}
function $B(e, t) {
  const i = Tf.get(e);
  if (!i)
    return;
  const n = i.getStage();
  n && n.content, Tf.delete(e), W_ && i._fire("lostpointercapture", tE(new PointerEvent("lostpointercapture")));
}
var YBt = "Stage", FBt = "string", XM = "px", xBt = "mouseout", w_ = "mouseleave", v_ = "mouseover", R_ = "mouseenter", X_ = "mousemove", H_ = "mousedown", k_ = "mouseup", kB = "pointermove", YB = "pointerdown", Nh = "pointerup", FB = "pointercancel", DBt = "lostpointercapture", gS = "pointerout", oS = "pointerleave", lS = "pointerover", aS = "pointerenter", u5 = "contextmenu", Y_ = "touchstart", F_ = "touchend", x_ = "touchmove", D_ = "touchcancel", C5 = "wheel", JBt = 5, EBt = [
  [R_, "_pointerenter"],
  [H_, "_pointerdown"],
  [X_, "_pointermove"],
  [k_, "_pointerup"],
  [w_, "_pointerleave"],
  [Y_, "_pointerdown"],
  [x_, "_pointermove"],
  [F_, "_pointerup"],
  [D_, "_pointercancel"],
  [v_, "_pointerover"],
  [C5, "_wheel"],
  [u5, "_contextmenu"],
  [YB, "_pointerdown"],
  [kB, "_pointermove"],
  [Nh, "_pointerup"],
  [FB, "_pointercancel"],
  [DBt, "_lostpointercapture"]
];
const JY = {
  mouse: {
    [gS]: xBt,
    [oS]: w_,
    [lS]: v_,
    [aS]: R_,
    [kB]: X_,
    [YB]: H_,
    [Nh]: k_,
    [FB]: "mousecancel",
    pointerclick: "click",
    pointerdblclick: "dblclick"
  },
  touch: {
    [gS]: "touchout",
    [oS]: "touchleave",
    [lS]: "touchover",
    [aS]: "touchenter",
    [kB]: x_,
    [YB]: Y_,
    [Nh]: F_,
    [FB]: D_,
    pointerclick: "tap",
    pointerdblclick: "dbltap"
  },
  pointer: {
    [gS]: gS,
    [oS]: oS,
    [lS]: lS,
    [aS]: aS,
    [kB]: kB,
    [YB]: YB,
    [Nh]: Nh,
    [FB]: FB,
    pointerclick: "pointerclick",
    pointerdblclick: "pointerdblclick"
  }
}, xB = (e) => e.indexOf("pointer") >= 0 ? "pointer" : e.indexOf("touch") >= 0 ? "touch" : "mouse", sh = (e) => {
  const t = xB(e);
  if (t === "pointer")
    return ei.pointerEventsEnabled && JY.pointer;
  if (t === "touch")
    return JY.touch;
  if (t === "mouse")
    return JY.mouse;
};
function HM(e = {}) {
  return (e.clipFunc || e.clipWidth || e.clipHeight) && me.warn("Stage does not support clipping. Please use clip for Layers or Groups."), e;
}
const NBt = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);", pV = [];
let I1 = class extends Kl {
  constructor(t) {
    super(HM(t)), this._pointerPositions = [], this._changedPointerPositions = [], this._buildDOM(), this._bindContentEvents(), pV.push(this), this.on("widthChange.konva heightChange.konva", this._resizeDOM), this.on("visibleChange.konva", this._checkVisibility), this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
      HM(this.attrs);
    }), this._checkVisibility();
  }
  _validateAdd(t) {
    const i = t.getType() === "Layer", n = t.getType() === "FastLayer";
    i || n || me.throw("You may only add layers to the stage.");
  }
  _checkVisibility() {
    if (!this.content)
      return;
    const t = this.visible() ? "" : "none";
    this.content.style.display = t;
  }
  setContainer(t) {
    if (typeof t === FBt) {
      if (t.charAt(0) === ".") {
        var i = t.slice(1);
        t = document.getElementsByClassName(i)[0];
      } else {
        var n;
        t.charAt(0) !== "#" ? n = t : n = t.slice(1), t = document.getElementById(n);
      }
      if (!t)
        throw "Can not find container in document with id " + n;
    }
    return this._setAttr("container", t), this.content && (this.content.parentElement && this.content.parentElement.removeChild(this.content), t.appendChild(this.content)), this;
  }
  shouldDrawHit() {
    return !0;
  }
  clear() {
    var t = this.children, i = t.length, n;
    for (n = 0; n < i; n++)
      t[n].clear();
    return this;
  }
  clone(t) {
    return t || (t = {}), t.container = typeof document < "u" && document.createElement("div"), Kl.prototype.clone.call(this, t);
  }
  destroy() {
    super.destroy();
    var t = this.content;
    t && me._isInDocument(t) && this.container().removeChild(t);
    var i = pV.indexOf(this);
    return i > -1 && pV.splice(i, 1), me.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas), this;
  }
  getPointerPosition() {
    const t = this._pointerPositions[0] || this._changedPointerPositions[0];
    return t ? {
      x: t.x,
      y: t.y
    } : (me.warn(NBt), null);
  }
  _getPointerById(t) {
    return this._pointerPositions.find((i) => i.id === t);
  }
  getPointersPositions() {
    return this._pointerPositions;
  }
  getStage() {
    return this;
  }
  getContent() {
    return this.content;
  }
  _toKonvaCanvas(t) {
    t = t || {}, t.x = t.x || 0, t.y = t.y || 0, t.width = t.width || this.width(), t.height = t.height || this.height();
    var i = new jh({
      width: t.width,
      height: t.height,
      pixelRatio: t.pixelRatio || 1
    }), n = i.getContext()._context, r = this.children;
    return (t.x || t.y) && n.translate(-1 * t.x, -1 * t.y), r.forEach(function(g) {
      if (g.isVisible()) {
        var o = g._toKonvaCanvas(t);
        n.drawImage(o._canvas, t.x, t.y, o.getWidth() / o.getPixelRatio(), o.getHeight() / o.getPixelRatio());
      }
    }), i;
  }
  getIntersection(t) {
    if (!t)
      return null;
    var i = this.children, n = i.length, r = n - 1, g;
    for (g = r; g >= 0; g--) {
      const o = i[g].getIntersection(t);
      if (o)
        return o;
    }
    return null;
  }
  _resizeDOM() {
    var t = this.width(), i = this.height();
    this.content && (this.content.style.width = t + XM, this.content.style.height = i + XM), this.bufferCanvas.setSize(t, i), this.bufferHitCanvas.setSize(t, i), this.children.forEach((n) => {
      n.setSize({ width: t, height: i }), n.draw();
    });
  }
  add(t, ...i) {
    if (arguments.length > 1) {
      for (var n = 0; n < arguments.length; n++)
        this.add(arguments[n]);
      return this;
    }
    super.add(t);
    var r = this.children.length;
    return r > JBt && me.warn("The stage has " + r + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group."), t.setSize({ width: this.width(), height: this.height() }), t.draw(), ei.isBrowser && this.content.appendChild(t.canvas._canvas), this;
  }
  getParent() {
    return null;
  }
  getLayer() {
    return null;
  }
  hasPointerCapture(t) {
    return S_(t, this);
  }
  setPointerCapture(t) {
    V_(t, this);
  }
  releaseCapture(t) {
    $B(t);
  }
  getLayers() {
    return this.children;
  }
  _bindContentEvents() {
    ei.isBrowser && EBt.forEach(([t, i]) => {
      this.content.addEventListener(t, (n) => {
        this[i](n);
      }, { passive: !1 });
    });
  }
  _pointerenter(t) {
    this.setPointersPositions(t);
    const i = sh(t.type);
    this._fire(i.pointerenter, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _pointerover(t) {
    this.setPointersPositions(t);
    const i = sh(t.type);
    this._fire(i.pointerover, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _getTargetShape(t) {
    let i = this[t + "targetShape"];
    return i && !i.getStage() && (i = null), i;
  }
  _pointerleave(t) {
    const i = sh(t.type), n = xB(t.type);
    if (i) {
      this.setPointersPositions(t);
      var r = this._getTargetShape(n), g = !ln.isDragging || ei.hitOnDragEnabled;
      r && g ? (r._fireAndBubble(i.pointerout, { evt: t }), r._fireAndBubble(i.pointerleave, { evt: t }), this._fire(i.pointerleave, {
        evt: t,
        target: this,
        currentTarget: this
      }), this[n + "targetShape"] = null) : g && (this._fire(i.pointerleave, {
        evt: t,
        target: this,
        currentTarget: this
      }), this._fire(i.pointerout, {
        evt: t,
        target: this,
        currentTarget: this
      })), this.pointerPos = void 0, this._pointerPositions = [];
    }
  }
  _pointerdown(t) {
    const i = sh(t.type), n = xB(t.type);
    if (i) {
      this.setPointersPositions(t);
      var r = !1;
      this._changedPointerPositions.forEach((g) => {
        var o = this.getIntersection(g);
        if (ln.justDragged = !1, ei["_" + n + "ListenClick"] = !0, !(o && o.isListening()))
          return;
        ei.capturePointerEventsEnabled && o.setPointerCapture(g.id), this[n + "ClickStartShape"] = o, o._fireAndBubble(i.pointerdown, {
          evt: t,
          pointerId: g.id
        }), r = !0;
        const a = t.type.indexOf("touch") >= 0;
        o.preventDefault() && t.cancelable && a && t.preventDefault();
      }), r || this._fire(i.pointerdown, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: this._pointerPositions[0].id
      });
    }
  }
  _pointermove(t) {
    const i = sh(t.type), n = xB(t.type);
    if (!i)
      return;
    ln.isDragging && ln.node.preventDefault() && t.cancelable && t.preventDefault(), this.setPointersPositions(t);
    var r = !ln.isDragging || ei.hitOnDragEnabled;
    if (!r)
      return;
    var g = {};
    let o = !1;
    var l = this._getTargetShape(n);
    this._changedPointerPositions.forEach((a) => {
      const I = DY(a.id) || this.getIntersection(a), c = a.id, d = { evt: t, pointerId: c };
      var C = l !== I;
      if (C && l && (l._fireAndBubble(i.pointerout, Object.assign({}, d), I), l._fireAndBubble(i.pointerleave, Object.assign({}, d), I)), I) {
        if (g[I._id])
          return;
        g[I._id] = !0;
      }
      I && I.isListening() ? (o = !0, C && (I._fireAndBubble(i.pointerover, Object.assign({}, d), l), I._fireAndBubble(i.pointerenter, Object.assign({}, d), l), this[n + "targetShape"] = I), I._fireAndBubble(i.pointermove, Object.assign({}, d))) : l && (this._fire(i.pointerover, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: c
      }), this[n + "targetShape"] = null);
    }), o || this._fire(i.pointermove, {
      evt: t,
      target: this,
      currentTarget: this,
      pointerId: this._changedPointerPositions[0].id
    });
  }
  _pointerup(t) {
    const i = sh(t.type), n = xB(t.type);
    if (!i)
      return;
    this.setPointersPositions(t);
    const r = this[n + "ClickStartShape"], g = this[n + "ClickEndShape"];
    var o = {};
    let l = !1;
    this._changedPointerPositions.forEach((a) => {
      const I = DY(a.id) || this.getIntersection(a);
      if (I) {
        if (I.releaseCapture(a.id), o[I._id])
          return;
        o[I._id] = !0;
      }
      const c = a.id, d = { evt: t, pointerId: c };
      let C = !1;
      ei["_" + n + "InDblClickWindow"] ? (C = !0, clearTimeout(this[n + "DblTimeout"])) : ln.justDragged || (ei["_" + n + "InDblClickWindow"] = !0, clearTimeout(this[n + "DblTimeout"])), this[n + "DblTimeout"] = setTimeout(function() {
        ei["_" + n + "InDblClickWindow"] = !1;
      }, ei.dblClickWindow), I && I.isListening() ? (l = !0, this[n + "ClickEndShape"] = I, I._fireAndBubble(i.pointerup, Object.assign({}, d)), ei["_" + n + "ListenClick"] && r && r === I && (I._fireAndBubble(i.pointerclick, Object.assign({}, d)), C && g && g === I && I._fireAndBubble(i.pointerdblclick, Object.assign({}, d)))) : (this[n + "ClickEndShape"] = null, ei["_" + n + "ListenClick"] && this._fire(i.pointerclick, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: c
      }), C && this._fire(i.pointerdblclick, {
        evt: t,
        target: this,
        currentTarget: this,
        pointerId: c
      }));
    }), l || this._fire(i.pointerup, {
      evt: t,
      target: this,
      currentTarget: this,
      pointerId: this._changedPointerPositions[0].id
    }), ei["_" + n + "ListenClick"] = !1, t.cancelable && n !== "touch" && t.preventDefault();
  }
  _contextmenu(t) {
    this.setPointersPositions(t);
    var i = this.getIntersection(this.getPointerPosition());
    i && i.isListening() ? i._fireAndBubble(u5, { evt: t }) : this._fire(u5, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _wheel(t) {
    this.setPointersPositions(t);
    var i = this.getIntersection(this.getPointerPosition());
    i && i.isListening() ? i._fireAndBubble(C5, { evt: t }) : this._fire(C5, {
      evt: t,
      target: this,
      currentTarget: this
    });
  }
  _pointercancel(t) {
    this.setPointersPositions(t);
    const i = DY(t.pointerId) || this.getIntersection(this.getPointerPosition());
    i && i._fireAndBubble(Nh, tE(t)), $B(t.pointerId);
  }
  _lostpointercapture(t) {
    $B(t.pointerId);
  }
  setPointersPositions(t) {
    var i = this._getContentPosition(), n = null, r = null;
    t = t || window.event, t.touches !== void 0 ? (this._pointerPositions = [], this._changedPointerPositions = [], Array.prototype.forEach.call(t.touches, (g) => {
      this._pointerPositions.push({
        id: g.identifier,
        x: (g.clientX - i.left) / i.scaleX,
        y: (g.clientY - i.top) / i.scaleY
      });
    }), Array.prototype.forEach.call(t.changedTouches || t.touches, (g) => {
      this._changedPointerPositions.push({
        id: g.identifier,
        x: (g.clientX - i.left) / i.scaleX,
        y: (g.clientY - i.top) / i.scaleY
      });
    })) : (n = (t.clientX - i.left) / i.scaleX, r = (t.clientY - i.top) / i.scaleY, this.pointerPos = {
      x: n,
      y: r
    }, this._pointerPositions = [{ x: n, y: r, id: me._getFirstPointerId(t) }], this._changedPointerPositions = [
      { x: n, y: r, id: me._getFirstPointerId(t) }
    ]);
  }
  _setPointerPosition(t) {
    me.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.'), this.setPointersPositions(t);
  }
  _getContentPosition() {
    if (!this.content || !this.content.getBoundingClientRect)
      return {
        top: 0,
        left: 0,
        scaleX: 1,
        scaleY: 1
      };
    var t = this.content.getBoundingClientRect();
    return {
      top: t.top,
      left: t.left,
      scaleX: t.width / this.content.clientWidth || 1,
      scaleY: t.height / this.content.clientHeight || 1
    };
  }
  _buildDOM() {
    if (this.bufferCanvas = new jh({
      width: this.width(),
      height: this.height()
    }), this.bufferHitCanvas = new eE({
      pixelRatio: 1,
      width: this.width(),
      height: this.height()
    }), !!ei.isBrowser) {
      var t = this.container();
      if (!t)
        throw "Stage has no container. A container is required.";
      t.innerHTML = "", this.content = document.createElement("div"), this.content.style.position = "relative", this.content.style.userSelect = "none", this.content.className = "konvajs-content", this.content.setAttribute("role", "presentation"), t.appendChild(this.content), this._resizeDOM();
    }
  }
  cache() {
    return me.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes."), this;
  }
  clearCache() {
    return this;
  }
  batchDraw() {
    return this.getChildren().forEach(function(t) {
      t.batchDraw();
    }), this;
  }
};
I1.prototype.nodeType = YBt;
cr(I1);
oe.addGetterSetter(I1, "container");
var J_ = "hasShadow", E_ = "shadowRGBA", N_ = "patternImage", L_ = "linearGradient", K_ = "radialGradient";
let sS;
function EY() {
  return sS || (sS = me.createCanvasElement().getContext("2d"), sS);
}
const ef = {};
function LBt(e) {
  e.fill();
}
function KBt(e) {
  e.stroke();
}
function TBt(e) {
  e.fill();
}
function MBt(e) {
  e.stroke();
}
function PBt() {
  this._clearCache(J_);
}
function UBt() {
  this._clearCache(E_);
}
function zBt() {
  this._clearCache(N_);
}
function OBt() {
  this._clearCache(L_);
}
function QBt() {
  this._clearCache(K_);
}
class At extends yt {
  constructor(t) {
    super(t);
    let i;
    for (; i = me.getRandomColor(), !(i && !(i in ef)); )
      ;
    this.colorKey = i, ef[i] = this;
  }
  getContext() {
    return me.warn("shape.getContext() method is deprecated. Please do not use it."), this.getLayer().getContext();
  }
  getCanvas() {
    return me.warn("shape.getCanvas() method is deprecated. Please do not use it."), this.getLayer().getCanvas();
  }
  getSceneFunc() {
    return this.attrs.sceneFunc || this._sceneFunc;
  }
  getHitFunc() {
    return this.attrs.hitFunc || this._hitFunc;
  }
  hasShadow() {
    return this._getCache(J_, this._hasShadow);
  }
  _hasShadow() {
    return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
  }
  _getFillPattern() {
    return this._getCache(N_, this.__getFillPattern);
  }
  __getFillPattern() {
    if (this.fillPatternImage()) {
      var t = EY();
      const i = t.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
      if (i && i.setTransform) {
        const n = new Hl();
        n.translate(this.fillPatternX(), this.fillPatternY()), n.rotate(ei.getAngle(this.fillPatternRotation())), n.scale(this.fillPatternScaleX(), this.fillPatternScaleY()), n.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
        const r = n.getMatrix(), g = typeof DOMMatrix > "u" ? {
          a: r[0],
          b: r[1],
          c: r[2],
          d: r[3],
          e: r[4],
          f: r[5]
        } : new DOMMatrix(r);
        i.setTransform(g);
      }
      return i;
    }
  }
  _getLinearGradient() {
    return this._getCache(L_, this.__getLinearGradient);
  }
  __getLinearGradient() {
    var t = this.fillLinearGradientColorStops();
    if (t) {
      for (var i = EY(), n = this.fillLinearGradientStartPoint(), r = this.fillLinearGradientEndPoint(), g = i.createLinearGradient(n.x, n.y, r.x, r.y), o = 0; o < t.length; o += 2)
        g.addColorStop(t[o], t[o + 1]);
      return g;
    }
  }
  _getRadialGradient() {
    return this._getCache(K_, this.__getRadialGradient);
  }
  __getRadialGradient() {
    var t = this.fillRadialGradientColorStops();
    if (t) {
      for (var i = EY(), n = this.fillRadialGradientStartPoint(), r = this.fillRadialGradientEndPoint(), g = i.createRadialGradient(n.x, n.y, this.fillRadialGradientStartRadius(), r.x, r.y, this.fillRadialGradientEndRadius()), o = 0; o < t.length; o += 2)
        g.addColorStop(t[o], t[o + 1]);
      return g;
    }
  }
  getShadowRGBA() {
    return this._getCache(E_, this._getShadowRGBA);
  }
  _getShadowRGBA() {
    if (this.hasShadow()) {
      var t = me.colorToRGBA(this.shadowColor());
      if (t)
        return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a * (this.shadowOpacity() || 1) + ")";
    }
  }
  hasFill() {
    return this._calculate("hasFill", [
      "fillEnabled",
      "fill",
      "fillPatternImage",
      "fillLinearGradientColorStops",
      "fillRadialGradientColorStops"
    ], () => this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops()));
  }
  hasStroke() {
    return this._calculate("hasStroke", [
      "strokeEnabled",
      "strokeWidth",
      "stroke",
      "strokeLinearGradientColorStops"
    ], () => this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops()));
  }
  hasHitStroke() {
    const t = this.hitStrokeWidth();
    return t === "auto" ? this.hasStroke() : this.strokeEnabled() && !!t;
  }
  intersects(t) {
    var i = this.getStage(), n = i.bufferHitCanvas, r;
    return n.getContext().clear(), this.drawHit(n, null, !0), r = n.context.getImageData(Math.round(t.x), Math.round(t.y), 1, 1).data, r[3] > 0;
  }
  destroy() {
    return yt.prototype.destroy.call(this), delete ef[this.colorKey], delete this.colorKey, this;
  }
  _useBufferCanvas(t) {
    var i;
    if (!this.getStage() || !((i = this.attrs.perfectDrawEnabled) !== null && i !== void 0 ? i : !0))
      return !1;
    const r = t || this.hasFill(), g = this.hasStroke(), o = this.getAbsoluteOpacity() !== 1;
    if (r && g && o)
      return !0;
    const l = this.hasShadow(), a = this.shadowForStrokeEnabled();
    return !!(r && g && l && a);
  }
  setStrokeHitEnabled(t) {
    me.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead."), t ? this.hitStrokeWidth("auto") : this.hitStrokeWidth(0);
  }
  getStrokeHitEnabled() {
    return this.hitStrokeWidth() !== 0;
  }
  getSelfRect() {
    var t = this.size();
    return {
      x: this._centroid ? -t.width / 2 : 0,
      y: this._centroid ? -t.height / 2 : 0,
      width: t.width,
      height: t.height
    };
  }
  getClientRect(t = {}) {
    const i = t.skipTransform, n = t.relativeTo, r = this.getSelfRect(), o = !t.skipStroke && this.hasStroke() && this.strokeWidth() || 0, l = r.width + o, a = r.height + o, I = !t.skipShadow && this.hasShadow(), c = I ? this.shadowOffsetX() : 0, d = I ? this.shadowOffsetY() : 0, C = l + Math.abs(c), A = a + Math.abs(d), b = I && this.shadowBlur() || 0, m = C + b * 2, p = A + b * 2, B = {
      width: m,
      height: p,
      x: -(o / 2 + b) + Math.min(c, 0) + r.x,
      y: -(o / 2 + b) + Math.min(d, 0) + r.y
    };
    return i ? B : this._transformedRect(B, n);
  }
  drawScene(t, i) {
    var n = this.getLayer(), r = t || n.getCanvas(), g = r.getContext(), o = this._getCanvasCache(), l = this.getSceneFunc(), a = this.hasShadow(), I, c, d, C = r.isCache, A = i === this;
    if (!this.isVisible() && !A)
      return this;
    if (o) {
      g.save();
      var b = this.getAbsoluteTransform(i).getMatrix();
      return g.transform(b[0], b[1], b[2], b[3], b[4], b[5]), this._drawCachedSceneCanvas(g), g.restore(), this;
    }
    if (!l)
      return this;
    if (g.save(), this._useBufferCanvas() && !C) {
      I = this.getStage(), c = I.bufferCanvas, d = c.getContext(), d.clear(), d.save(), d._applyLineJoin(this);
      var m = this.getAbsoluteTransform(i).getMatrix();
      d.transform(m[0], m[1], m[2], m[3], m[4], m[5]), l.call(this, d, this), d.restore();
      var p = c.pixelRatio;
      a && g._applyShadow(this), g._applyOpacity(this), g._applyGlobalCompositeOperation(this), g.drawImage(c._canvas, 0, 0, c.width / p, c.height / p);
    } else {
      if (g._applyLineJoin(this), !A) {
        var m = this.getAbsoluteTransform(i).getMatrix();
        g.transform(m[0], m[1], m[2], m[3], m[4], m[5]), g._applyOpacity(this), g._applyGlobalCompositeOperation(this);
      }
      a && g._applyShadow(this), l.call(this, g, this);
    }
    return g.restore(), this;
  }
  drawHit(t, i, n = !1) {
    if (!this.shouldDrawHit(i, n))
      return this;
    var r = this.getLayer(), g = t || r.hitCanvas, o = g && g.getContext(), l = this.hitFunc() || this.sceneFunc(), a = this._getCanvasCache(), I = a && a.hit;
    if (this.colorKey || me.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()"), I) {
      o.save();
      var c = this.getAbsoluteTransform(i).getMatrix();
      return o.transform(c[0], c[1], c[2], c[3], c[4], c[5]), this._drawCachedHitCanvas(o), o.restore(), this;
    }
    if (!l)
      return this;
    if (o.save(), o._applyLineJoin(this), !(this === i)) {
      var C = this.getAbsoluteTransform(i).getMatrix();
      o.transform(C[0], C[1], C[2], C[3], C[4], C[5]);
    }
    return l.call(this, o, this), o.restore(), this;
  }
  drawHitFromCache(t = 0) {
    var i = this._getCanvasCache(), n = this._getCachedSceneCanvas(), r = i.hit, g = r.getContext(), o = r.getWidth(), l = r.getHeight(), a, I, c, d, C, A;
    g.clear(), g.drawImage(n._canvas, 0, 0, o, l);
    try {
      for (a = g.getImageData(0, 0, o, l), I = a.data, c = I.length, d = me._hexToRgb(this.colorKey), C = 0; C < c; C += 4)
        A = I[C + 3], A > t ? (I[C] = d.r, I[C + 1] = d.g, I[C + 2] = d.b, I[C + 3] = 255) : I[C + 3] = 0;
      g.putImageData(a, 0, 0);
    } catch (b) {
      me.error("Unable to draw hit graph from cached scene canvas. " + b.message);
    }
    return this;
  }
  hasPointerCapture(t) {
    return S_(t, this);
  }
  setPointerCapture(t) {
    V_(t, this);
  }
  releaseCapture(t) {
    $B(t);
  }
}
At.prototype._fillFunc = LBt;
At.prototype._strokeFunc = KBt;
At.prototype._fillFuncHit = TBt;
At.prototype._strokeFuncHit = MBt;
At.prototype._centroid = !1;
At.prototype.nodeType = "Shape";
cr(At);
At.prototype.eventListeners = {};
At.prototype.on.call(At.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", PBt);
At.prototype.on.call(At.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", UBt);
At.prototype.on.call(At.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", zBt);
At.prototype.on.call(At.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", OBt);
At.prototype.on.call(At.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", QBt);
oe.addGetterSetter(At, "stroke", void 0, y_());
oe.addGetterSetter(At, "strokeWidth", 2, ft());
oe.addGetterSetter(At, "fillAfterStrokeEnabled", !1);
oe.addGetterSetter(At, "hitStrokeWidth", "auto", $9());
oe.addGetterSetter(At, "strokeHitEnabled", !0, Ts());
oe.addGetterSetter(At, "perfectDrawEnabled", !0, Ts());
oe.addGetterSetter(At, "shadowForStrokeEnabled", !0, Ts());
oe.addGetterSetter(At, "lineJoin");
oe.addGetterSetter(At, "lineCap");
oe.addGetterSetter(At, "sceneFunc");
oe.addGetterSetter(At, "hitFunc");
oe.addGetterSetter(At, "dash");
oe.addGetterSetter(At, "dashOffset", 0, ft());
oe.addGetterSetter(At, "shadowColor", void 0, Nm());
oe.addGetterSetter(At, "shadowBlur", 0, ft());
oe.addGetterSetter(At, "shadowOpacity", 1, ft());
oe.addComponentsGetterSetter(At, "shadowOffset", ["x", "y"]);
oe.addGetterSetter(At, "shadowOffsetX", 0, ft());
oe.addGetterSetter(At, "shadowOffsetY", 0, ft());
oe.addGetterSetter(At, "fillPatternImage");
oe.addGetterSetter(At, "fill", void 0, y_());
oe.addGetterSetter(At, "fillPatternX", 0, ft());
oe.addGetterSetter(At, "fillPatternY", 0, ft());
oe.addGetterSetter(At, "fillLinearGradientColorStops");
oe.addGetterSetter(At, "strokeLinearGradientColorStops");
oe.addGetterSetter(At, "fillRadialGradientStartRadius", 0);
oe.addGetterSetter(At, "fillRadialGradientEndRadius", 0);
oe.addGetterSetter(At, "fillRadialGradientColorStops");
oe.addGetterSetter(At, "fillPatternRepeat", "repeat");
oe.addGetterSetter(At, "fillEnabled", !0);
oe.addGetterSetter(At, "strokeEnabled", !0);
oe.addGetterSetter(At, "shadowEnabled", !0);
oe.addGetterSetter(At, "dashEnabled", !0);
oe.addGetterSetter(At, "strokeScaleEnabled", !0);
oe.addGetterSetter(At, "fillPriority", "color");
oe.addComponentsGetterSetter(At, "fillPatternOffset", ["x", "y"]);
oe.addGetterSetter(At, "fillPatternOffsetX", 0, ft());
oe.addGetterSetter(At, "fillPatternOffsetY", 0, ft());
oe.addComponentsGetterSetter(At, "fillPatternScale", ["x", "y"]);
oe.addGetterSetter(At, "fillPatternScaleX", 1, ft());
oe.addGetterSetter(At, "fillPatternScaleY", 1, ft());
oe.addComponentsGetterSetter(At, "fillLinearGradientStartPoint", [
  "x",
  "y"
]);
oe.addComponentsGetterSetter(At, "strokeLinearGradientStartPoint", [
  "x",
  "y"
]);
oe.addGetterSetter(At, "fillLinearGradientStartPointX", 0);
oe.addGetterSetter(At, "strokeLinearGradientStartPointX", 0);
oe.addGetterSetter(At, "fillLinearGradientStartPointY", 0);
oe.addGetterSetter(At, "strokeLinearGradientStartPointY", 0);
oe.addComponentsGetterSetter(At, "fillLinearGradientEndPoint", [
  "x",
  "y"
]);
oe.addComponentsGetterSetter(At, "strokeLinearGradientEndPoint", [
  "x",
  "y"
]);
oe.addGetterSetter(At, "fillLinearGradientEndPointX", 0);
oe.addGetterSetter(At, "strokeLinearGradientEndPointX", 0);
oe.addGetterSetter(At, "fillLinearGradientEndPointY", 0);
oe.addGetterSetter(At, "strokeLinearGradientEndPointY", 0);
oe.addComponentsGetterSetter(At, "fillRadialGradientStartPoint", [
  "x",
  "y"
]);
oe.addGetterSetter(At, "fillRadialGradientStartPointX", 0);
oe.addGetterSetter(At, "fillRadialGradientStartPointY", 0);
oe.addComponentsGetterSetter(At, "fillRadialGradientEndPoint", [
  "x",
  "y"
]);
oe.addGetterSetter(At, "fillRadialGradientEndPointX", 0);
oe.addGetterSetter(At, "fillRadialGradientEndPointY", 0);
oe.addGetterSetter(At, "fillPatternRotation", 0);
oe.backCompat(At, {
  dashArray: "dash",
  getDashArray: "getDash",
  setDashArray: "getDash",
  drawFunc: "sceneFunc",
  getDrawFunc: "getSceneFunc",
  setDrawFunc: "setSceneFunc",
  drawHitFunc: "hitFunc",
  getDrawHitFunc: "getHitFunc",
  setDrawHitFunc: "setHitFunc"
});
var jBt = "#", qBt = "beforeDraw", _Bt = "draw", T_ = [
  { x: 0, y: 0 },
  { x: -1, y: -1 },
  { x: 1, y: -1 },
  { x: 1, y: 1 },
  { x: -1, y: 1 }
], $Bt = T_.length;
class VA extends Kl {
  constructor(t) {
    super(t), this.canvas = new jh(), this.hitCanvas = new eE({
      pixelRatio: 1
    }), this._waitingForDraw = !1, this.on("visibleChange.konva", this._checkVisibility), this._checkVisibility(), this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled), this._setSmoothEnabled();
  }
  createPNGStream() {
    return this.canvas._canvas.createPNGStream();
  }
  getCanvas() {
    return this.canvas;
  }
  getNativeCanvasElement() {
    return this.canvas._canvas;
  }
  getHitCanvas() {
    return this.hitCanvas;
  }
  getContext() {
    return this.getCanvas().getContext();
  }
  clear(t) {
    return this.getContext().clear(t), this.getHitCanvas().getContext().clear(t), this;
  }
  setZIndex(t) {
    super.setZIndex(t);
    var i = this.getStage();
    return i && i.content && (i.content.removeChild(this.getNativeCanvasElement()), t < i.children.length - 1 ? i.content.insertBefore(this.getNativeCanvasElement(), i.children[t + 1].getCanvas()._canvas) : i.content.appendChild(this.getNativeCanvasElement())), this;
  }
  moveToTop() {
    yt.prototype.moveToTop.call(this);
    var t = this.getStage();
    return t && t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.appendChild(this.getNativeCanvasElement())), !0;
  }
  moveUp() {
    var t = yt.prototype.moveUp.call(this);
    if (!t)
      return !1;
    var i = this.getStage();
    return !i || !i.content ? !1 : (i.content.removeChild(this.getNativeCanvasElement()), this.index < i.children.length - 1 ? i.content.insertBefore(this.getNativeCanvasElement(), i.children[this.index + 1].getCanvas()._canvas) : i.content.appendChild(this.getNativeCanvasElement()), !0);
  }
  moveDown() {
    if (yt.prototype.moveDown.call(this)) {
      var t = this.getStage();
      if (t) {
        var i = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), i[this.index + 1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  moveToBottom() {
    if (yt.prototype.moveToBottom.call(this)) {
      var t = this.getStage();
      if (t) {
        var i = t.children;
        t.content && (t.content.removeChild(this.getNativeCanvasElement()), t.content.insertBefore(this.getNativeCanvasElement(), i[1].getCanvas()._canvas));
      }
      return !0;
    }
    return !1;
  }
  getLayer() {
    return this;
  }
  remove() {
    var t = this.getNativeCanvasElement();
    return yt.prototype.remove.call(this), t && t.parentNode && me._isInDocument(t) && t.parentNode.removeChild(t), this;
  }
  getStage() {
    return this.parent;
  }
  setSize({ width: t, height: i }) {
    return this.canvas.setSize(t, i), this.hitCanvas.setSize(t, i), this._setSmoothEnabled(), this;
  }
  _validateAdd(t) {
    var i = t.getType();
    i !== "Group" && i !== "Shape" && me.throw("You may only add groups and shapes to a layer.");
  }
  _toKonvaCanvas(t) {
    return t = t || {}, t.width = t.width || this.getWidth(), t.height = t.height || this.getHeight(), t.x = t.x !== void 0 ? t.x : this.x(), t.y = t.y !== void 0 ? t.y : this.y(), yt.prototype._toKonvaCanvas.call(this, t);
  }
  _checkVisibility() {
    this.visible() ? this.canvas._canvas.style.display = "block" : this.canvas._canvas.style.display = "none";
  }
  _setSmoothEnabled() {
    this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
  }
  getWidth() {
    if (this.parent)
      return this.parent.width();
  }
  setWidth() {
    me.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
  }
  getHeight() {
    if (this.parent)
      return this.parent.height();
  }
  setHeight() {
    me.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
  }
  batchDraw() {
    return this._waitingForDraw || (this._waitingForDraw = !0, me.requestAnimFrame(() => {
      this.draw(), this._waitingForDraw = !1;
    })), this;
  }
  getIntersection(t) {
    if (!this.isListening() || !this.isVisible())
      return null;
    for (var i = 1, n = !1; ; ) {
      for (let r = 0; r < $Bt; r++) {
        const g = T_[r], o = this._getIntersection({
          x: t.x + g.x * i,
          y: t.y + g.y * i
        }), l = o.shape;
        if (l)
          return l;
        if (n = !!o.antialiased, !o.antialiased)
          break;
      }
      if (n)
        i += 1;
      else
        return null;
    }
  }
  _getIntersection(t) {
    const i = this.hitCanvas.pixelRatio, n = this.hitCanvas.context.getImageData(Math.round(t.x * i), Math.round(t.y * i), 1, 1).data, r = n[3];
    if (r === 255) {
      const g = me._rgbToHex(n[0], n[1], n[2]), o = ef[jBt + g];
      return o ? {
        shape: o
      } : {
        antialiased: !0
      };
    } else if (r > 0)
      return {
        antialiased: !0
      };
    return {};
  }
  drawScene(t, i) {
    var n = this.getLayer(), r = t || n && n.getCanvas();
    return this._fire(qBt, {
      node: this
    }), this.clearBeforeDraw() && r.getContext().clear(), Kl.prototype.drawScene.call(this, r, i), this._fire(_Bt, {
      node: this
    }), this;
  }
  drawHit(t, i) {
    var n = this.getLayer(), r = t || n && n.hitCanvas;
    return n && n.clearBeforeDraw() && n.getHitCanvas().getContext().clear(), Kl.prototype.drawHit.call(this, r, i), this;
  }
  enableHitGraph() {
    return this.hitGraphEnabled(!0), this;
  }
  disableHitGraph() {
    return this.hitGraphEnabled(!1), this;
  }
  setHitGraphEnabled(t) {
    me.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening(t);
  }
  getHitGraphEnabled(t) {
    return me.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead."), this.listening();
  }
  toggleHitCanvas() {
    if (!(!this.parent || !this.parent.content)) {
      var t = this.parent, i = !!this.hitCanvas._canvas.parentNode;
      i ? t.content.removeChild(this.hitCanvas._canvas) : t.content.appendChild(this.hitCanvas._canvas);
    }
  }
  destroy() {
    return me.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas), super.destroy();
  }
}
VA.prototype.nodeType = "Layer";
cr(VA);
oe.addGetterSetter(VA, "imageSmoothingEnabled", !0);
oe.addGetterSetter(VA, "clearBeforeDraw", !0);
oe.addGetterSetter(VA, "hitGraphEnabled", !0, Ts());
class iE extends VA {
  constructor(t) {
    super(t), this.listening(!1), me.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
  }
}
iE.prototype.nodeType = "FastLayer";
cr(iE);
class dm extends Kl {
  _validateAdd(t) {
    var i = t.getType();
    i !== "Group" && i !== "Shape" && me.throw("You may only add groups and shapes to groups.");
  }
}
dm.prototype.nodeType = "Group";
cr(dm);
var NY = function() {
  return Qh.performance && Qh.performance.now ? function() {
    return Qh.performance.now();
  } : function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}();
class Va {
  constructor(t, i) {
    this.id = Va.animIdCounter++, this.frame = {
      time: 0,
      timeDiff: 0,
      lastTime: NY(),
      frameRate: 0
    }, this.func = t, this.setLayers(i);
  }
  setLayers(t) {
    var i = [];
    return t ? t.length > 0 ? i = t : i = [t] : i = [], this.layers = i, this;
  }
  getLayers() {
    return this.layers;
  }
  addLayer(t) {
    var i = this.layers, n = i.length, r;
    for (r = 0; r < n; r++)
      if (i[r]._id === t._id)
        return !1;
    return this.layers.push(t), !0;
  }
  isRunning() {
    var t = Va, i = t.animations, n = i.length, r;
    for (r = 0; r < n; r++)
      if (i[r].id === this.id)
        return !0;
    return !1;
  }
  start() {
    return this.stop(), this.frame.timeDiff = 0, this.frame.lastTime = NY(), Va._addAnimation(this), this;
  }
  stop() {
    return Va._removeAnimation(this), this;
  }
  _updateFrameObject(t) {
    this.frame.timeDiff = t - this.frame.lastTime, this.frame.lastTime = t, this.frame.time += this.frame.timeDiff, this.frame.frameRate = 1e3 / this.frame.timeDiff;
  }
  static _addAnimation(t) {
    this.animations.push(t), this._handleAnimation();
  }
  static _removeAnimation(t) {
    var i = t.id, n = this.animations, r = n.length, g;
    for (g = 0; g < r; g++)
      if (n[g].id === i) {
        this.animations.splice(g, 1);
        break;
      }
  }
  static _runFrames() {
    var t = {}, i = this.animations, n, r, g, o, l, a, I, c, d;
    for (o = 0; o < i.length; o++)
      if (n = i[o], r = n.layers, g = n.func, n._updateFrameObject(NY()), a = r.length, g ? d = g.call(n, n.frame) !== !1 : d = !0, !!d)
        for (l = 0; l < a; l++)
          I = r[l], I._id !== void 0 && (t[I._id] = I);
    for (c in t)
      t.hasOwnProperty(c) && t[c].batchDraw();
  }
  static _animationLoop() {
    var t = Va;
    t.animations.length ? (t._runFrames(), me.requestAnimFrame(t._animationLoop)) : t.animRunning = !1;
  }
  static _handleAnimation() {
    this.animRunning || (this.animRunning = !0, me.requestAnimFrame(this._animationLoop));
  }
}
Va.animations = [];
Va.animIdCounter = 0;
Va.animRunning = !1;
var eft = {
  node: 1,
  duration: 1,
  easing: 1,
  onFinish: 1,
  yoyo: 1
}, tft = 1, kM = 2, YM = 3, ift = 0, FM = ["fill", "stroke", "shadowColor"];
class nft {
  constructor(t, i, n, r, g, o, l) {
    this.prop = t, this.propFunc = i, this.begin = r, this._pos = r, this.duration = o, this._change = 0, this.prevPos = 0, this.yoyo = l, this._time = 0, this._position = 0, this._startTime = 0, this._finish = 0, this.func = n, this._change = g - this.begin, this.pause();
  }
  fire(t) {
    var i = this[t];
    i && i();
  }
  setTime(t) {
    t > this.duration ? this.yoyo ? (this._time = this.duration, this.reverse()) : this.finish() : t < 0 ? this.yoyo ? (this._time = 0, this.play()) : this.reset() : (this._time = t, this.update());
  }
  getTime() {
    return this._time;
  }
  setPosition(t) {
    this.prevPos = this._pos, this.propFunc(t), this._pos = t;
  }
  getPosition(t) {
    return t === void 0 && (t = this._time), this.func(t, this.begin, this._change, this.duration);
  }
  play() {
    this.state = kM, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onPlay");
  }
  reverse() {
    this.state = YM, this._time = this.duration - this._time, this._startTime = this.getTimer() - this._time, this.onEnterFrame(), this.fire("onReverse");
  }
  seek(t) {
    this.pause(), this._time = t, this.update(), this.fire("onSeek");
  }
  reset() {
    this.pause(), this._time = 0, this.update(), this.fire("onReset");
  }
  finish() {
    this.pause(), this._time = this.duration, this.update(), this.fire("onFinish");
  }
  update() {
    this.setPosition(this.getPosition(this._time)), this.fire("onUpdate");
  }
  onEnterFrame() {
    var t = this.getTimer() - this._startTime;
    this.state === kM ? this.setTime(t) : this.state === YM && this.setTime(this.duration - t);
  }
  pause() {
    this.state = tft, this.fire("onPause");
  }
  getTimer() {
    return (/* @__PURE__ */ new Date()).getTime();
  }
}
class Sr {
  constructor(t) {
    var i = this, n = t.node, r = n._id, g, o = t.easing || tf.Linear, l = !!t.yoyo, a;
    typeof t.duration > "u" ? g = 0.3 : t.duration === 0 ? g = 1e-3 : g = t.duration, this.node = n, this._id = ift++;
    var I = n.getLayer() || (n instanceof ei.Stage ? n.getLayers() : null);
    I || me.error("Tween constructor have `node` that is not in a layer. Please add node into layer first."), this.anim = new Va(function() {
      i.tween.onEnterFrame();
    }, I), this.tween = new nft(a, function(c) {
      i._tweenFunc(c);
    }, o, 0, 1, g * 1e3, l), this._addListeners(), Sr.attrs[r] || (Sr.attrs[r] = {}), Sr.attrs[r][this._id] || (Sr.attrs[r][this._id] = {}), Sr.tweens[r] || (Sr.tweens[r] = {});
    for (a in t)
      eft[a] === void 0 && this._addAttr(a, t[a]);
    this.reset(), this.onFinish = t.onFinish, this.onReset = t.onReset, this.onUpdate = t.onUpdate;
  }
  _addAttr(t, i) {
    var n = this.node, r = n._id, g, o, l, a, I, c, d, C;
    if (l = Sr.tweens[r][t], l && delete Sr.attrs[r][l][t], g = n.getAttr(t), me._isArray(i))
      if (o = [], I = Math.max(i.length, g.length), t === "points" && i.length !== g.length && (i.length > g.length ? (d = g, g = me._prepareArrayForTween(g, i, n.closed())) : (c = i, i = me._prepareArrayForTween(i, g, n.closed()))), t.indexOf("fill") === 0)
        for (a = 0; a < I; a++)
          if (a % 2 === 0)
            o.push(i[a] - g[a]);
          else {
            var A = me.colorToRGBA(g[a]);
            C = me.colorToRGBA(i[a]), g[a] = A, o.push({
              r: C.r - A.r,
              g: C.g - A.g,
              b: C.b - A.b,
              a: C.a - A.a
            });
          }
      else
        for (a = 0; a < I; a++)
          o.push(i[a] - g[a]);
    else
      FM.indexOf(t) !== -1 ? (g = me.colorToRGBA(g), C = me.colorToRGBA(i), o = {
        r: C.r - g.r,
        g: C.g - g.g,
        b: C.b - g.b,
        a: C.a - g.a
      }) : o = i - g;
    Sr.attrs[r][this._id][t] = {
      start: g,
      diff: o,
      end: i,
      trueEnd: c,
      trueStart: d
    }, Sr.tweens[r][t] = this._id;
  }
  _tweenFunc(t) {
    var i = this.node, n = Sr.attrs[i._id][this._id], r, g, o, l, a, I, c, d;
    for (r in n) {
      if (g = n[r], o = g.start, l = g.diff, d = g.end, me._isArray(o))
        if (a = [], c = Math.max(o.length, d.length), r.indexOf("fill") === 0)
          for (I = 0; I < c; I++)
            I % 2 === 0 ? a.push((o[I] || 0) + l[I] * t) : a.push("rgba(" + Math.round(o[I].r + l[I].r * t) + "," + Math.round(o[I].g + l[I].g * t) + "," + Math.round(o[I].b + l[I].b * t) + "," + (o[I].a + l[I].a * t) + ")");
        else
          for (I = 0; I < c; I++)
            a.push((o[I] || 0) + l[I] * t);
      else
        FM.indexOf(r) !== -1 ? a = "rgba(" + Math.round(o.r + l.r * t) + "," + Math.round(o.g + l.g * t) + "," + Math.round(o.b + l.b * t) + "," + (o.a + l.a * t) + ")" : a = o + l * t;
      i.setAttr(r, a);
    }
  }
  _addListeners() {
    this.tween.onPlay = () => {
      this.anim.start();
    }, this.tween.onReverse = () => {
      this.anim.start();
    }, this.tween.onPause = () => {
      this.anim.stop();
    }, this.tween.onFinish = () => {
      var t = this.node, i = Sr.attrs[t._id][this._id];
      i.points && i.points.trueEnd && t.setAttr("points", i.points.trueEnd), this.onFinish && this.onFinish.call(this);
    }, this.tween.onReset = () => {
      var t = this.node, i = Sr.attrs[t._id][this._id];
      i.points && i.points.trueStart && t.points(i.points.trueStart), this.onReset && this.onReset();
    }, this.tween.onUpdate = () => {
      this.onUpdate && this.onUpdate.call(this);
    };
  }
  play() {
    return this.tween.play(), this;
  }
  reverse() {
    return this.tween.reverse(), this;
  }
  reset() {
    return this.tween.reset(), this;
  }
  seek(t) {
    return this.tween.seek(t * 1e3), this;
  }
  pause() {
    return this.tween.pause(), this;
  }
  finish() {
    return this.tween.finish(), this;
  }
  destroy() {
    var t = this.node._id, i = this._id, n = Sr.tweens[t], r;
    this.pause();
    for (r in n)
      delete Sr.tweens[t][r];
    delete Sr.attrs[t][i];
  }
}
Sr.attrs = {};
Sr.tweens = {};
yt.prototype.to = function(e) {
  var t = e.onFinish;
  e.node = this, e.onFinish = function() {
    this.destroy(), t && t();
  };
  var i = new Sr(e);
  i.play();
};
const tf = {
  BackEaseIn(e, t, i, n) {
    var r = 1.70158;
    return i * (e /= n) * e * ((r + 1) * e - r) + t;
  },
  BackEaseOut(e, t, i, n) {
    var r = 1.70158;
    return i * ((e = e / n - 1) * e * ((r + 1) * e + r) + 1) + t;
  },
  BackEaseInOut(e, t, i, n) {
    var r = 1.70158;
    return (e /= n / 2) < 1 ? i / 2 * (e * e * (((r *= 1.525) + 1) * e - r)) + t : i / 2 * ((e -= 2) * e * (((r *= 1.525) + 1) * e + r) + 2) + t;
  },
  ElasticEaseIn(e, t, i, n, r, g) {
    var o = 0;
    return e === 0 ? t : (e /= n) === 1 ? t + i : (g || (g = n * 0.3), !r || r < Math.abs(i) ? (r = i, o = g / 4) : o = g / (2 * Math.PI) * Math.asin(i / r), -(r * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / g)) + t);
  },
  ElasticEaseOut(e, t, i, n, r, g) {
    var o = 0;
    return e === 0 ? t : (e /= n) === 1 ? t + i : (g || (g = n * 0.3), !r || r < Math.abs(i) ? (r = i, o = g / 4) : o = g / (2 * Math.PI) * Math.asin(i / r), r * Math.pow(2, -10 * e) * Math.sin((e * n - o) * (2 * Math.PI) / g) + i + t);
  },
  ElasticEaseInOut(e, t, i, n, r, g) {
    var o = 0;
    return e === 0 ? t : (e /= n / 2) === 2 ? t + i : (g || (g = n * (0.3 * 1.5)), !r || r < Math.abs(i) ? (r = i, o = g / 4) : o = g / (2 * Math.PI) * Math.asin(i / r), e < 1 ? -0.5 * (r * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / g)) + t : r * Math.pow(2, -10 * (e -= 1)) * Math.sin((e * n - o) * (2 * Math.PI) / g) * 0.5 + i + t);
  },
  BounceEaseOut(e, t, i, n) {
    return (e /= n) < 1 / 2.75 ? i * (7.5625 * e * e) + t : e < 2 / 2.75 ? i * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + t : e < 2.5 / 2.75 ? i * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + t : i * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + t;
  },
  BounceEaseIn(e, t, i, n) {
    return i - tf.BounceEaseOut(n - e, 0, i, n) + t;
  },
  BounceEaseInOut(e, t, i, n) {
    return e < n / 2 ? tf.BounceEaseIn(e * 2, 0, i, n) * 0.5 + t : tf.BounceEaseOut(e * 2 - n, 0, i, n) * 0.5 + i * 0.5 + t;
  },
  EaseIn(e, t, i, n) {
    return i * (e /= n) * e + t;
  },
  EaseOut(e, t, i, n) {
    return -i * (e /= n) * (e - 2) + t;
  },
  EaseInOut(e, t, i, n) {
    return (e /= n / 2) < 1 ? i / 2 * e * e + t : -i / 2 * (--e * (e - 2) - 1) + t;
  },
  StrongEaseIn(e, t, i, n) {
    return i * (e /= n) * e * e * e * e + t;
  },
  StrongEaseOut(e, t, i, n) {
    return i * ((e = e / n - 1) * e * e * e * e + 1) + t;
  },
  StrongEaseInOut(e, t, i, n) {
    return (e /= n / 2) < 1 ? i / 2 * e * e * e * e * e + t : i / 2 * ((e -= 2) * e * e * e * e + 2) + t;
  },
  Linear(e, t, i, n) {
    return i * e / n + t;
  }
}, xM = me._assign(ei, {
  Util: me,
  Transform: Hl,
  Node: yt,
  Container: Kl,
  Stage: I1,
  stages: pV,
  Layer: VA,
  FastLayer: iE,
  Group: dm,
  DD: ln,
  Shape: At,
  shapes: ef,
  Animation: Va,
  Tween: Sr,
  Easings: tf,
  Context: a1,
  Canvas: s1
});
class Hc extends At {
  _sceneFunc(t) {
    var i = ei.getAngle(this.angle()), n = this.clockwise();
    t.beginPath(), t.arc(0, 0, this.outerRadius(), 0, i, n), t.arc(0, 0, this.innerRadius(), i, 0, !n), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
  getSelfRect() {
    const t = this.innerRadius(), i = this.outerRadius(), n = this.clockwise(), r = ei.getAngle(n ? 360 - this.angle() : this.angle()), g = Math.cos(Math.min(r, Math.PI)), o = 1, l = Math.sin(Math.min(Math.max(Math.PI, r), 3 * Math.PI / 2)), a = Math.sin(Math.min(r, Math.PI / 2)), I = g * (g > 0 ? t : i), c = o * i, d = l * (l > 0 ? t : i), C = a * (a > 0 ? i : t);
    return {
      x: I,
      y: n ? -1 * C : d,
      width: c - I,
      height: C - d
    };
  }
}
Hc.prototype._centroid = !0;
Hc.prototype.className = "Arc";
Hc.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
cr(Hc);
oe.addGetterSetter(Hc, "innerRadius", 0, ft());
oe.addGetterSetter(Hc, "outerRadius", 0, ft());
oe.addGetterSetter(Hc, "angle", 0, ft());
oe.addGetterSetter(Hc, "clockwise", !1, Ts());
function A5(e, t, i, n, r, g, o) {
  var l = Math.sqrt(Math.pow(i - e, 2) + Math.pow(n - t, 2)), a = Math.sqrt(Math.pow(r - i, 2) + Math.pow(g - n, 2)), I = o * l / (l + a), c = o * a / (l + a), d = i - I * (r - e), C = n - I * (g - t), A = i + c * (r - e), b = n + c * (g - t);
  return [d, C, A, b];
}
function DM(e, t) {
  var i = e.length, n = [], r, g;
  for (r = 2; r < i - 2; r += 2)
    g = A5(e[r - 2], e[r - 1], e[r], e[r + 1], e[r + 2], e[r + 3], t), !isNaN(g[0]) && (n.push(g[0]), n.push(g[1]), n.push(e[r]), n.push(e[r + 1]), n.push(g[2]), n.push(g[3]));
  return n;
}
class kc extends At {
  constructor(t) {
    super(t), this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
      this._clearCache("tensionPoints");
    });
  }
  _sceneFunc(t) {
    var i = this.points(), n = i.length, r = this.tension(), g = this.closed(), o = this.bezier(), l, a, I;
    if (n) {
      if (t.beginPath(), t.moveTo(i[0], i[1]), r !== 0 && n > 4) {
        for (l = this.getTensionPoints(), a = l.length, I = g ? 0 : 4, g || t.quadraticCurveTo(l[0], l[1], l[2], l[3]); I < a - 2; )
          t.bezierCurveTo(l[I++], l[I++], l[I++], l[I++], l[I++], l[I++]);
        g || t.quadraticCurveTo(l[a - 2], l[a - 1], i[n - 2], i[n - 1]);
      } else if (o)
        for (I = 2; I < n; )
          t.bezierCurveTo(i[I++], i[I++], i[I++], i[I++], i[I++], i[I++]);
      else
        for (I = 2; I < n; I += 2)
          t.lineTo(i[I], i[I + 1]);
      g ? (t.closePath(), t.fillStrokeShape(this)) : t.strokeShape(this);
    }
  }
  getTensionPoints() {
    return this._getCache("tensionPoints", this._getTensionPoints);
  }
  _getTensionPoints() {
    return this.closed() ? this._getTensionPointsClosed() : DM(this.points(), this.tension());
  }
  _getTensionPointsClosed() {
    var t = this.points(), i = t.length, n = this.tension(), r = A5(t[i - 2], t[i - 1], t[0], t[1], t[2], t[3], n), g = A5(t[i - 4], t[i - 3], t[i - 2], t[i - 1], t[0], t[1], n), o = DM(t, n), l = [r[2], r[3]].concat(o).concat([
      g[0],
      g[1],
      t[i - 2],
      t[i - 1],
      g[2],
      g[3],
      r[0],
      r[1],
      t[0],
      t[1]
    ]);
    return l;
  }
  getWidth() {
    return this.getSelfRect().width;
  }
  getHeight() {
    return this.getSelfRect().height;
  }
  getSelfRect() {
    var t = this.points();
    if (t.length < 4)
      return {
        x: t[0] || 0,
        y: t[1] || 0,
        width: 0,
        height: 0
      };
    this.tension() !== 0 ? t = [
      t[0],
      t[1],
      ...this._getTensionPoints(),
      t[t.length - 2],
      t[t.length - 1]
    ] : t = this.points();
    for (var i = t[0], n = t[0], r = t[1], g = t[1], o, l, a = 0; a < t.length / 2; a++)
      o = t[a * 2], l = t[a * 2 + 1], i = Math.min(i, o), n = Math.max(n, o), r = Math.min(r, l), g = Math.max(g, l);
    return {
      x: i,
      y: r,
      width: n - i,
      height: g - r
    };
  }
}
kc.prototype.className = "Line";
kc.prototype._attrsAffectingSize = ["points", "bezier", "tension"];
cr(kc);
oe.addGetterSetter(kc, "closed", !1);
oe.addGetterSetter(kc, "bezier", !1);
oe.addGetterSetter(kc, "tension", 0, ft());
oe.addGetterSetter(kc, "points", [], uBt());
class kn extends At {
  constructor(t) {
    super(t), this.dataArray = [], this.pathLength = 0, this.dataArray = kn.parsePathData(this.data()), this.pathLength = 0;
    for (var i = 0; i < this.dataArray.length; ++i)
      this.pathLength += this.dataArray[i].pathLength;
    this.on("dataChange.konva", function() {
      this.dataArray = kn.parsePathData(this.data()), this.pathLength = 0;
      for (var n = 0; n < this.dataArray.length; ++n)
        this.pathLength += this.dataArray[n].pathLength;
    });
  }
  _sceneFunc(t) {
    var i = this.dataArray;
    t.beginPath();
    for (var n = !1, r = 0; r < i.length; r++) {
      var g = i[r].command, o = i[r].points;
      switch (g) {
        case "L":
          t.lineTo(o[0], o[1]);
          break;
        case "M":
          t.moveTo(o[0], o[1]);
          break;
        case "C":
          t.bezierCurveTo(o[0], o[1], o[2], o[3], o[4], o[5]);
          break;
        case "Q":
          t.quadraticCurveTo(o[0], o[1], o[2], o[3]);
          break;
        case "A":
          var l = o[0], a = o[1], I = o[2], c = o[3], d = o[4], C = o[5], A = o[6], b = o[7], m = I > c ? I : c, p = I > c ? 1 : I / c, B = I > c ? c / I : 1;
          t.translate(l, a), t.rotate(A), t.scale(p, B), t.arc(0, 0, m, d, d + C, 1 - b), t.scale(1 / p, 1 / B), t.rotate(-A), t.translate(-l, -a);
          break;
        case "z":
          n = !0, t.closePath();
          break;
      }
    }
    !n && !this.hasFill() ? t.strokeShape(this) : t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = [];
    this.dataArray.forEach(function(I) {
      if (I.command === "A") {
        var c = I.points[4], d = I.points[5], C = I.points[4] + d, A = Math.PI / 180;
        if (Math.abs(c - C) < A && (A = Math.abs(c - C)), d < 0)
          for (let b = c - A; b > C; b -= A) {
            const m = kn.getPointOnEllipticalArc(I.points[0], I.points[1], I.points[2], I.points[3], b, 0);
            t.push(m.x, m.y);
          }
        else
          for (let b = c + A; b < C; b += A) {
            const m = kn.getPointOnEllipticalArc(I.points[0], I.points[1], I.points[2], I.points[3], b, 0);
            t.push(m.x, m.y);
          }
      } else if (I.command === "C")
        for (let b = 0; b <= 1; b += 0.01) {
          const m = kn.getPointOnCubicBezier(b, I.start.x, I.start.y, I.points[0], I.points[1], I.points[2], I.points[3], I.points[4], I.points[5]);
          t.push(m.x, m.y);
        }
      else
        t = t.concat(I.points);
    });
    for (var i = t[0], n = t[0], r = t[1], g = t[1], o, l, a = 0; a < t.length / 2; a++)
      o = t[a * 2], l = t[a * 2 + 1], isNaN(o) || (i = Math.min(i, o), n = Math.max(n, o)), isNaN(l) || (r = Math.min(r, l), g = Math.max(g, l));
    return {
      x: i,
      y: r,
      width: n - i,
      height: g - r
    };
  }
  getLength() {
    return this.pathLength;
  }
  getPointAtLength(t) {
    var i, n = 0, r = this.dataArray.length;
    if (!r)
      return null;
    for (; n < r && t > this.dataArray[n].pathLength; )
      t -= this.dataArray[n].pathLength, ++n;
    if (n === r)
      return i = this.dataArray[n - 1].points.slice(-2), {
        x: i[0],
        y: i[1]
      };
    if (t < 0.01)
      return i = this.dataArray[n].points.slice(0, 2), {
        x: i[0],
        y: i[1]
      };
    var g = this.dataArray[n], o = g.points;
    switch (g.command) {
      case "L":
        return kn.getPointOnLine(t, g.start.x, g.start.y, o[0], o[1]);
      case "C":
        return kn.getPointOnCubicBezier(t / g.pathLength, g.start.x, g.start.y, o[0], o[1], o[2], o[3], o[4], o[5]);
      case "Q":
        return kn.getPointOnQuadraticBezier(t / g.pathLength, g.start.x, g.start.y, o[0], o[1], o[2], o[3]);
      case "A":
        var l = o[0], a = o[1], I = o[2], c = o[3], d = o[4], C = o[5], A = o[6];
        return d += C * t / g.pathLength, kn.getPointOnEllipticalArc(l, a, I, c, d, A);
    }
    return null;
  }
  static getLineLength(t, i, n, r) {
    return Math.sqrt((n - t) * (n - t) + (r - i) * (r - i));
  }
  static getPointOnLine(t, i, n, r, g, o, l) {
    o === void 0 && (o = i), l === void 0 && (l = n);
    var a = (g - n) / (r - i + 1e-8), I = Math.sqrt(t * t / (1 + a * a));
    r < i && (I *= -1);
    var c = a * I, d;
    if (r === i)
      d = {
        x: o,
        y: l + c
      };
    else if ((l - n) / (o - i + 1e-8) === a)
      d = {
        x: o + I,
        y: l + c
      };
    else {
      var C, A, b = this.getLineLength(i, n, r, g), m = (o - i) * (r - i) + (l - n) * (g - n);
      m = m / (b * b), C = i + m * (r - i), A = n + m * (g - n);
      var p = this.getLineLength(o, l, C, A), B = Math.sqrt(t * t - p * p);
      I = Math.sqrt(B * B / (1 + a * a)), r < i && (I *= -1), c = a * I, d = {
        x: C + I,
        y: A + c
      };
    }
    return d;
  }
  static getPointOnCubicBezier(t, i, n, r, g, o, l, a, I) {
    function c(p) {
      return p * p * p;
    }
    function d(p) {
      return 3 * p * p * (1 - p);
    }
    function C(p) {
      return 3 * p * (1 - p) * (1 - p);
    }
    function A(p) {
      return (1 - p) * (1 - p) * (1 - p);
    }
    var b = a * c(t) + o * d(t) + r * C(t) + i * A(t), m = I * c(t) + l * d(t) + g * C(t) + n * A(t);
    return {
      x: b,
      y: m
    };
  }
  static getPointOnQuadraticBezier(t, i, n, r, g, o, l) {
    function a(A) {
      return A * A;
    }
    function I(A) {
      return 2 * A * (1 - A);
    }
    function c(A) {
      return (1 - A) * (1 - A);
    }
    var d = o * a(t) + r * I(t) + i * c(t), C = l * a(t) + g * I(t) + n * c(t);
    return {
      x: d,
      y: C
    };
  }
  static getPointOnEllipticalArc(t, i, n, r, g, o) {
    var l = Math.cos(o), a = Math.sin(o), I = {
      x: n * Math.cos(g),
      y: r * Math.sin(g)
    };
    return {
      x: t + (I.x * l - I.y * a),
      y: i + (I.x * a + I.y * l)
    };
  }
  static parsePathData(t) {
    if (!t)
      return [];
    var i = t, n = [
      "m",
      "M",
      "l",
      "L",
      "v",
      "V",
      "h",
      "H",
      "z",
      "Z",
      "c",
      "C",
      "q",
      "Q",
      "t",
      "T",
      "s",
      "S",
      "a",
      "A"
    ];
    i = i.replace(new RegExp(" ", "g"), ",");
    for (var r = 0; r < n.length; r++)
      i = i.replace(new RegExp(n[r], "g"), "|" + n[r]);
    var g = i.split("|"), o = [], l = [], a = 0, I = 0, c = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi, d;
    for (r = 1; r < g.length; r++) {
      var C = g[r], A = C.charAt(0);
      for (C = C.slice(1), l.length = 0; d = c.exec(C); )
        l.push(d[0]);
      for (var b = [], m = 0, p = l.length; m < p; m++) {
        if (l[m] === "00") {
          b.push(0, 0);
          continue;
        }
        var B = parseFloat(l[m]);
        isNaN(B) ? b.push(0) : b.push(B);
      }
      for (; b.length > 0 && !isNaN(b[0]); ) {
        var f = null, Z = [], y = a, W = I, V, w, v, H, x, J, K, M, L, N;
        switch (A) {
          case "l":
            a += b.shift(), I += b.shift(), f = "L", Z.push(a, I);
            break;
          case "L":
            a = b.shift(), I = b.shift(), Z.push(a, I);
            break;
          case "m":
            var U = b.shift(), O = b.shift();
            if (a += U, I += O, f = "M", o.length > 2 && o[o.length - 1].command === "z") {
              for (var $ = o.length - 2; $ >= 0; $--)
                if (o[$].command === "M") {
                  a = o[$].points[0] + U, I = o[$].points[1] + O;
                  break;
                }
            }
            Z.push(a, I), A = "l";
            break;
          case "M":
            a = b.shift(), I = b.shift(), f = "M", Z.push(a, I), A = "L";
            break;
          case "h":
            a += b.shift(), f = "L", Z.push(a, I);
            break;
          case "H":
            a = b.shift(), f = "L", Z.push(a, I);
            break;
          case "v":
            I += b.shift(), f = "L", Z.push(a, I);
            break;
          case "V":
            I = b.shift(), f = "L", Z.push(a, I);
            break;
          case "C":
            Z.push(b.shift(), b.shift(), b.shift(), b.shift()), a = b.shift(), I = b.shift(), Z.push(a, I);
            break;
          case "c":
            Z.push(a + b.shift(), I + b.shift(), a + b.shift(), I + b.shift()), a += b.shift(), I += b.shift(), f = "C", Z.push(a, I);
            break;
          case "S":
            w = a, v = I, V = o[o.length - 1], V.command === "C" && (w = a + (a - V.points[2]), v = I + (I - V.points[3])), Z.push(w, v, b.shift(), b.shift()), a = b.shift(), I = b.shift(), f = "C", Z.push(a, I);
            break;
          case "s":
            w = a, v = I, V = o[o.length - 1], V.command === "C" && (w = a + (a - V.points[2]), v = I + (I - V.points[3])), Z.push(w, v, a + b.shift(), I + b.shift()), a += b.shift(), I += b.shift(), f = "C", Z.push(a, I);
            break;
          case "Q":
            Z.push(b.shift(), b.shift()), a = b.shift(), I = b.shift(), Z.push(a, I);
            break;
          case "q":
            Z.push(a + b.shift(), I + b.shift()), a += b.shift(), I += b.shift(), f = "Q", Z.push(a, I);
            break;
          case "T":
            w = a, v = I, V = o[o.length - 1], V.command === "Q" && (w = a + (a - V.points[0]), v = I + (I - V.points[1])), a = b.shift(), I = b.shift(), f = "Q", Z.push(w, v, a, I);
            break;
          case "t":
            w = a, v = I, V = o[o.length - 1], V.command === "Q" && (w = a + (a - V.points[0]), v = I + (I - V.points[1])), a += b.shift(), I += b.shift(), f = "Q", Z.push(w, v, a, I);
            break;
          case "A":
            H = b.shift(), x = b.shift(), J = b.shift(), K = b.shift(), M = b.shift(), L = a, N = I, a = b.shift(), I = b.shift(), f = "A", Z = this.convertEndpointToCenterParameterization(L, N, a, I, K, M, H, x, J);
            break;
          case "a":
            H = b.shift(), x = b.shift(), J = b.shift(), K = b.shift(), M = b.shift(), L = a, N = I, a += b.shift(), I += b.shift(), f = "A", Z = this.convertEndpointToCenterParameterization(L, N, a, I, K, M, H, x, J);
            break;
        }
        o.push({
          command: f || A,
          points: Z,
          start: {
            x: y,
            y: W
          },
          pathLength: this.calcLength(y, W, f || A, Z)
        });
      }
      (A === "z" || A === "Z") && o.push({
        command: "z",
        points: [],
        start: void 0,
        pathLength: 0
      });
    }
    return o;
  }
  static calcLength(t, i, n, r) {
    var g, o, l, a, I = kn;
    switch (n) {
      case "L":
        return I.getLineLength(t, i, r[0], r[1]);
      case "C":
        for (g = 0, o = I.getPointOnCubicBezier(0, t, i, r[0], r[1], r[2], r[3], r[4], r[5]), a = 0.01; a <= 1; a += 0.01)
          l = I.getPointOnCubicBezier(a, t, i, r[0], r[1], r[2], r[3], r[4], r[5]), g += I.getLineLength(o.x, o.y, l.x, l.y), o = l;
        return g;
      case "Q":
        for (g = 0, o = I.getPointOnQuadraticBezier(0, t, i, r[0], r[1], r[2], r[3]), a = 0.01; a <= 1; a += 0.01)
          l = I.getPointOnQuadraticBezier(a, t, i, r[0], r[1], r[2], r[3]), g += I.getLineLength(o.x, o.y, l.x, l.y), o = l;
        return g;
      case "A":
        g = 0;
        var c = r[4], d = r[5], C = r[4] + d, A = Math.PI / 180;
        if (Math.abs(c - C) < A && (A = Math.abs(c - C)), o = I.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], c, 0), d < 0)
          for (a = c - A; a > C; a -= A)
            l = I.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], a, 0), g += I.getLineLength(o.x, o.y, l.x, l.y), o = l;
        else
          for (a = c + A; a < C; a += A)
            l = I.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], a, 0), g += I.getLineLength(o.x, o.y, l.x, l.y), o = l;
        return l = I.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], C, 0), g += I.getLineLength(o.x, o.y, l.x, l.y), g;
    }
    return 0;
  }
  static convertEndpointToCenterParameterization(t, i, n, r, g, o, l, a, I) {
    var c = I * (Math.PI / 180), d = Math.cos(c) * (t - n) / 2 + Math.sin(c) * (i - r) / 2, C = -1 * Math.sin(c) * (t - n) / 2 + Math.cos(c) * (i - r) / 2, A = d * d / (l * l) + C * C / (a * a);
    A > 1 && (l *= Math.sqrt(A), a *= Math.sqrt(A));
    var b = Math.sqrt((l * l * (a * a) - l * l * (C * C) - a * a * (d * d)) / (l * l * (C * C) + a * a * (d * d)));
    g === o && (b *= -1), isNaN(b) && (b = 0);
    var m = b * l * C / a, p = b * -a * d / l, B = (t + n) / 2 + Math.cos(c) * m - Math.sin(c) * p, f = (i + r) / 2 + Math.sin(c) * m + Math.cos(c) * p, Z = function(x) {
      return Math.sqrt(x[0] * x[0] + x[1] * x[1]);
    }, y = function(x, J) {
      return (x[0] * J[0] + x[1] * J[1]) / (Z(x) * Z(J));
    }, W = function(x, J) {
      return (x[0] * J[1] < x[1] * J[0] ? -1 : 1) * Math.acos(y(x, J));
    }, V = W([1, 0], [(d - m) / l, (C - p) / a]), w = [(d - m) / l, (C - p) / a], v = [(-1 * d - m) / l, (-1 * C - p) / a], H = W(w, v);
    return y(w, v) <= -1 && (H = Math.PI), y(w, v) >= 1 && (H = 0), o === 0 && H > 0 && (H = H - 2 * Math.PI), o === 1 && H < 0 && (H = H + 2 * Math.PI), [B, f, l, a, V, H, c, o];
  }
}
kn.prototype.className = "Path";
kn.prototype._attrsAffectingSize = ["data"];
cr(kn);
oe.addGetterSetter(kn, "data");
class wA extends kc {
  _sceneFunc(t) {
    super._sceneFunc(t);
    var i = Math.PI * 2, n = this.points(), r = n, g = this.tension() !== 0 && n.length > 4;
    g && (r = this.getTensionPoints());
    var o = this.pointerLength(), l = n.length, a, I;
    if (g) {
      const C = [
        r[r.length - 4],
        r[r.length - 3],
        r[r.length - 2],
        r[r.length - 1],
        n[l - 2],
        n[l - 1]
      ], A = kn.calcLength(r[r.length - 4], r[r.length - 3], "C", C), b = kn.getPointOnQuadraticBezier(Math.min(1, 1 - o / A), C[0], C[1], C[2], C[3], C[4], C[5]);
      a = n[l - 2] - b.x, I = n[l - 1] - b.y;
    } else
      a = n[l - 2] - n[l - 4], I = n[l - 1] - n[l - 3];
    var c = (Math.atan2(I, a) + i) % i, d = this.pointerWidth();
    this.pointerAtEnding() && (t.save(), t.beginPath(), t.translate(n[l - 2], n[l - 1]), t.rotate(c), t.moveTo(0, 0), t.lineTo(-o, d / 2), t.lineTo(-o, -d / 2), t.closePath(), t.restore(), this.__fillStroke(t)), this.pointerAtBeginning() && (t.save(), t.beginPath(), t.translate(n[0], n[1]), g ? (a = (r[0] + r[2]) / 2 - n[0], I = (r[1] + r[3]) / 2 - n[1]) : (a = n[2] - n[0], I = n[3] - n[1]), t.rotate((Math.atan2(-I, -a) + i) % i), t.moveTo(0, 0), t.lineTo(-o, d / 2), t.lineTo(-o, -d / 2), t.closePath(), t.restore(), this.__fillStroke(t));
  }
  __fillStroke(t) {
    var i = this.dashEnabled();
    i && (this.attrs.dashEnabled = !1, t.setLineDash([])), t.fillStrokeShape(this), i && (this.attrs.dashEnabled = !0);
  }
  getSelfRect() {
    const t = super.getSelfRect(), i = this.pointerWidth() / 2;
    return {
      x: t.x - i,
      y: t.y - i,
      width: t.width + i * 2,
      height: t.height + i * 2
    };
  }
}
wA.prototype.className = "Arrow";
cr(wA);
oe.addGetterSetter(wA, "pointerLength", 10, ft());
oe.addGetterSetter(wA, "pointerWidth", 10, ft());
oe.addGetterSetter(wA, "pointerAtBeginning", !1);
oe.addGetterSetter(wA, "pointerAtEnding", !0);
class Lm extends At {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
  setHeight(t) {
    this.radius() !== t / 2 && this.radius(t / 2);
  }
}
Lm.prototype._centroid = !0;
Lm.prototype.className = "Circle";
Lm.prototype._attrsAffectingSize = ["radius"];
cr(Lm);
oe.addGetterSetter(Lm, "radius", 0, ft());
class pu extends At {
  _sceneFunc(t) {
    var i = this.radiusX(), n = this.radiusY();
    t.beginPath(), t.save(), i !== n && t.scale(1, n / i), t.arc(0, 0, i, 0, Math.PI * 2, !1), t.restore(), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radiusX() * 2;
  }
  getHeight() {
    return this.radiusY() * 2;
  }
  setWidth(t) {
    this.radiusX(t / 2);
  }
  setHeight(t) {
    this.radiusY(t / 2);
  }
}
pu.prototype.className = "Ellipse";
pu.prototype._centroid = !0;
pu.prototype._attrsAffectingSize = ["radiusX", "radiusY"];
cr(pu);
oe.addComponentsGetterSetter(pu, "radius", ["x", "y"]);
oe.addGetterSetter(pu, "radiusX", 0, ft());
oe.addGetterSetter(pu, "radiusY", 0, ft());
let JI = class M_ extends At {
  constructor(t) {
    super(t), this.on("imageChange.konva", () => {
      this._setImageLoad();
    }), this._setImageLoad();
  }
  _setImageLoad() {
    const t = this.image();
    t && t.complete || t && t.readyState === 4 || t && t.addEventListener && t.addEventListener("load", () => {
      this._requestDraw();
    });
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _sceneFunc(t) {
    const i = this.getWidth(), n = this.getHeight(), r = this.cornerRadius(), g = this.attrs.image;
    let o;
    if (g) {
      const l = this.attrs.cropWidth, a = this.attrs.cropHeight;
      l && a ? o = [
        g,
        this.cropX(),
        this.cropY(),
        l,
        a,
        0,
        0,
        i,
        n
      ] : o = [g, 0, 0, i, n];
    }
    (this.hasFill() || this.hasStroke() || r) && (t.beginPath(), r ? me.drawRoundedRectPath(t, i, n, r) : t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this)), g && (r && t.clip(), t.drawImage.apply(t, o));
  }
  _hitFunc(t) {
    var i = this.width(), n = this.height(), r = this.cornerRadius();
    t.beginPath(), r ? me.drawRoundedRectPath(t, i, n, r) : t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    var t, i;
    return (t = this.attrs.width) !== null && t !== void 0 ? t : (i = this.image()) === null || i === void 0 ? void 0 : i.width;
  }
  getHeight() {
    var t, i;
    return (t = this.attrs.height) !== null && t !== void 0 ? t : (i = this.image()) === null || i === void 0 ? void 0 : i.height;
  }
  static fromURL(t, i, n = null) {
    var r = me.createImageElement();
    r.onload = function() {
      var g = new M_({
        image: r
      });
      i(g);
    }, r.onerror = n, r.crossOrigin = "Anonymous", r.src = t;
  }
};
JI.prototype.className = "Image";
cr(JI);
oe.addGetterSetter(JI, "cornerRadius", 0, _9(4));
oe.addGetterSetter(JI, "image");
oe.addComponentsGetterSetter(JI, "crop", ["x", "y", "width", "height"]);
oe.addGetterSetter(JI, "cropX", 0, ft());
oe.addGetterSetter(JI, "cropY", 0, ft());
oe.addGetterSetter(JI, "cropWidth", 0, ft());
oe.addGetterSetter(JI, "cropHeight", 0, ft());
var P_ = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "padding",
  "lineHeight",
  "text",
  "width",
  "height",
  "pointerDirection",
  "pointerWidth",
  "pointerHeight"
], rft = "Change.konva", gft = "none", b5 = "up", h5 = "right", m5 = "down", p5 = "left", oft = P_.length;
class nE extends dm {
  constructor(t) {
    super(t), this.on("add.konva", function(i) {
      this._addListeners(i.child), this._sync();
    });
  }
  getText() {
    return this.find("Text")[0];
  }
  getTag() {
    return this.find("Tag")[0];
  }
  _addListeners(t) {
    var i = this, n, r = function() {
      i._sync();
    };
    for (n = 0; n < oft; n++)
      t.on(P_[n] + rft, r);
  }
  getWidth() {
    return this.getText().width();
  }
  getHeight() {
    return this.getText().height();
  }
  _sync() {
    var t = this.getText(), i = this.getTag(), n, r, g, o, l, a, I;
    if (t && i) {
      switch (n = t.width(), r = t.height(), g = i.pointerDirection(), o = i.pointerWidth(), I = i.pointerHeight(), l = 0, a = 0, g) {
        case b5:
          l = n / 2, a = -1 * I;
          break;
        case h5:
          l = n + o, a = r / 2;
          break;
        case m5:
          l = n / 2, a = r + I;
          break;
        case p5:
          l = -1 * o, a = r / 2;
          break;
      }
      i.setAttrs({
        x: -1 * l,
        y: -1 * a,
        width: n,
        height: r
      }), t.setAttrs({
        x: -1 * l,
        y: -1 * a
      });
    }
  }
}
nE.prototype.className = "Label";
cr(nE);
class vA extends At {
  _sceneFunc(t) {
    var i = this.width(), n = this.height(), r = this.pointerDirection(), g = this.pointerWidth(), o = this.pointerHeight(), l = this.cornerRadius();
    let a = 0, I = 0, c = 0, d = 0;
    typeof l == "number" ? a = I = c = d = Math.min(l, i / 2, n / 2) : (a = Math.min(l[0] || 0, i / 2, n / 2), I = Math.min(l[1] || 0, i / 2, n / 2), d = Math.min(l[2] || 0, i / 2, n / 2), c = Math.min(l[3] || 0, i / 2, n / 2)), t.beginPath(), t.moveTo(a, 0), r === b5 && (t.lineTo((i - g) / 2, 0), t.lineTo(i / 2, -1 * o), t.lineTo((i + g) / 2, 0)), t.lineTo(i - I, 0), t.arc(i - I, I, I, Math.PI * 3 / 2, 0, !1), r === h5 && (t.lineTo(i, (n - o) / 2), t.lineTo(i + g, n / 2), t.lineTo(i, (n + o) / 2)), t.lineTo(i, n - d), t.arc(i - d, n - d, d, 0, Math.PI / 2, !1), r === m5 && (t.lineTo((i + g) / 2, n), t.lineTo(i / 2, n + o), t.lineTo((i - g) / 2, n)), t.lineTo(c, n), t.arc(c, n - c, c, Math.PI / 2, Math.PI, !1), r === p5 && (t.lineTo(0, (n + o) / 2), t.lineTo(-1 * g, n / 2), t.lineTo(0, (n - o) / 2)), t.lineTo(0, a), t.arc(a, a, a, Math.PI, Math.PI * 3 / 2, !1), t.closePath(), t.fillStrokeShape(this);
  }
  getSelfRect() {
    var t = 0, i = 0, n = this.pointerWidth(), r = this.pointerHeight(), g = this.pointerDirection(), o = this.width(), l = this.height();
    return g === b5 ? (i -= r, l += r) : g === m5 ? l += r : g === p5 ? (t -= n * 1.5, o += n) : g === h5 && (o += n * 1.5), {
      x: t,
      y: i,
      width: o,
      height: l
    };
  }
}
vA.prototype.className = "Tag";
cr(vA);
oe.addGetterSetter(vA, "pointerDirection", gft);
oe.addGetterSetter(vA, "pointerWidth", 0, ft());
oe.addGetterSetter(vA, "pointerHeight", 0, ft());
oe.addGetterSetter(vA, "cornerRadius", 0, _9(4));
let MZ = class extends At {
  _sceneFunc(t) {
    var i = this.cornerRadius(), n = this.width(), r = this.height();
    t.beginPath(), i ? me.drawRoundedRectPath(t, n, r, i) : t.rect(0, 0, n, r), t.closePath(), t.fillStrokeShape(this);
  }
};
MZ.prototype.className = "Rect";
cr(MZ);
oe.addGetterSetter(MZ, "cornerRadius", 0, _9(4));
class RA extends At {
  _sceneFunc(t) {
    const i = this._getPoints();
    t.beginPath(), t.moveTo(i[0].x, i[0].y);
    for (var n = 1; n < i.length; n++)
      t.lineTo(i[n].x, i[n].y);
    t.closePath(), t.fillStrokeShape(this);
  }
  _getPoints() {
    const t = this.attrs.sides, i = this.attrs.radius || 0, n = [];
    for (var r = 0; r < t; r++)
      n.push({
        x: i * Math.sin(r * 2 * Math.PI / t),
        y: -1 * i * Math.cos(r * 2 * Math.PI / t)
      });
    return n;
  }
  getSelfRect() {
    const t = this._getPoints();
    var i = t[0].x, n = t[0].y, r = t[0].x, g = t[0].y;
    return t.forEach((o) => {
      i = Math.min(i, o.x), n = Math.max(n, o.x), r = Math.min(r, o.y), g = Math.max(g, o.y);
    }), {
      x: i,
      y: r,
      width: n - i,
      height: g - r
    };
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
RA.prototype.className = "RegularPolygon";
RA.prototype._centroid = !0;
RA.prototype._attrsAffectingSize = ["radius"];
cr(RA);
oe.addGetterSetter(RA, "radius", 0, ft());
oe.addGetterSetter(RA, "sides", 0, ft());
var JM = Math.PI * 2;
class XA extends At {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.innerRadius(), 0, JM, !1), t.moveTo(this.outerRadius(), 0), t.arc(0, 0, this.outerRadius(), JM, 0, !0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
XA.prototype.className = "Ring";
XA.prototype._centroid = !0;
XA.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
cr(XA);
oe.addGetterSetter(XA, "innerRadius", 0, ft());
oe.addGetterSetter(XA, "outerRadius", 0, ft());
class EI extends At {
  constructor(t) {
    super(t), this._updated = !0, this.anim = new Va(() => {
      var i = this._updated;
      return this._updated = !1, i;
    }), this.on("animationChange.konva", function() {
      this.frameIndex(0);
    }), this.on("frameIndexChange.konva", function() {
      this._updated = !0;
    }), this.on("frameRateChange.konva", function() {
      this.anim.isRunning() && (clearInterval(this.interval), this._setInterval());
    });
  }
  _sceneFunc(t) {
    var i = this.animation(), n = this.frameIndex(), r = n * 4, g = this.animations()[i], o = this.frameOffsets(), l = g[r + 0], a = g[r + 1], I = g[r + 2], c = g[r + 3], d = this.image();
    if ((this.hasFill() || this.hasStroke()) && (t.beginPath(), t.rect(0, 0, I, c), t.closePath(), t.fillStrokeShape(this)), d)
      if (o) {
        var C = o[i], A = n * 2;
        t.drawImage(d, l, a, I, c, C[A + 0], C[A + 1], I, c);
      } else
        t.drawImage(d, l, a, I, c, 0, 0, I, c);
  }
  _hitFunc(t) {
    var i = this.animation(), n = this.frameIndex(), r = n * 4, g = this.animations()[i], o = this.frameOffsets(), l = g[r + 2], a = g[r + 3];
    if (t.beginPath(), o) {
      var I = o[i], c = n * 2;
      t.rect(I[c + 0], I[c + 1], l, a);
    } else
      t.rect(0, 0, l, a);
    t.closePath(), t.fillShape(this);
  }
  _useBufferCanvas() {
    return super._useBufferCanvas(!0);
  }
  _setInterval() {
    var t = this;
    this.interval = setInterval(function() {
      t._updateIndex();
    }, 1e3 / this.frameRate());
  }
  start() {
    if (!this.isRunning()) {
      var t = this.getLayer();
      this.anim.setLayers(t), this._setInterval(), this.anim.start();
    }
  }
  stop() {
    this.anim.stop(), clearInterval(this.interval);
  }
  isRunning() {
    return this.anim.isRunning();
  }
  _updateIndex() {
    var t = this.frameIndex(), i = this.animation(), n = this.animations(), r = n[i], g = r.length / 4;
    t < g - 1 ? this.frameIndex(t + 1) : this.frameIndex(0);
  }
}
EI.prototype.className = "Sprite";
cr(EI);
oe.addGetterSetter(EI, "animation");
oe.addGetterSetter(EI, "animations");
oe.addGetterSetter(EI, "frameOffsets");
oe.addGetterSetter(EI, "image");
oe.addGetterSetter(EI, "frameIndex", 0, ft());
oe.addGetterSetter(EI, "frameRate", 17, ft());
oe.backCompat(EI, {
  index: "frameIndex",
  getIndex: "getFrameIndex",
  setIndex: "setFrameIndex"
});
class Bu extends At {
  _sceneFunc(t) {
    var i = this.innerRadius(), n = this.outerRadius(), r = this.numPoints();
    t.beginPath(), t.moveTo(0, 0 - n);
    for (var g = 1; g < r * 2; g++) {
      var o = g % 2 === 0 ? n : i, l = o * Math.sin(g * Math.PI / r), a = -1 * o * Math.cos(g * Math.PI / r);
      t.lineTo(l, a);
    }
    t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.outerRadius() * 2;
  }
  getHeight() {
    return this.outerRadius() * 2;
  }
  setWidth(t) {
    this.outerRadius(t / 2);
  }
  setHeight(t) {
    this.outerRadius(t / 2);
  }
}
Bu.prototype.className = "Star";
Bu.prototype._centroid = !0;
Bu.prototype._attrsAffectingSize = ["innerRadius", "outerRadius"];
cr(Bu);
oe.addGetterSetter(Bu, "numPoints", 5, ft());
oe.addGetterSetter(Bu, "innerRadius", 0, ft());
oe.addGetterSetter(Bu, "outerRadius", 0, ft());
function U_(e) {
  return Array.from(e);
}
var Ih = "auto", lft = "center", oB = "justify", aft = "Change.konva", sft = "2d", EM = "-", z_ = "left", Ift = "text", cft = "Text", dft = "top", uft = "bottom", NM = "middle", O_ = "normal", Cft = "px ", IS = " ", Aft = "right", bft = "word", hft = "char", LM = "none", LY = "…", Q_ = [
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontVariant",
  "padding",
  "align",
  "verticalAlign",
  "lineHeight",
  "text",
  "width",
  "height",
  "wrap",
  "ellipsis",
  "letterSpacing"
], mft = Q_.length;
function pft(e) {
  return e.split(",").map((t) => {
    t = t.trim();
    const i = t.indexOf(" ") >= 0, n = t.indexOf('"') >= 0 || t.indexOf("'") >= 0;
    return i && !n && (t = `"${t}"`), t;
  }).join(", ");
}
var cS;
function KY() {
  return cS || (cS = me.createCanvasElement().getContext(sft), cS);
}
function Bft(e) {
  e.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function fft(e) {
  e.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function Zft(e) {
  return e = e || {}, !e.fillLinearGradientColorStops && !e.fillRadialGradientColorStops && !e.fillPatternImage && (e.fill = e.fill || "black"), e;
}
let sr = class extends At {
  constructor(t) {
    super(Zft(t)), this._partialTextX = 0, this._partialTextY = 0;
    for (var i = 0; i < mft; i++)
      this.on(Q_[i] + aft, this._setTextData);
    this._setTextData();
  }
  _sceneFunc(t) {
    var i = this.textArr, n = i.length;
    if (this.text()) {
      var r = this.padding(), g = this.fontSize(), o = this.lineHeight() * g, l = this.verticalAlign(), a = 0, I = this.align(), c = this.getWidth(), d = this.letterSpacing(), C = this.fill(), A = this.textDecoration(), b = A.indexOf("underline") !== -1, m = A.indexOf("line-through") !== -1, p, B = 0, B = o / 2, f = 0, Z = 0;
      for (t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", NM), t.setAttr("textAlign", z_), l === NM ? a = (this.getHeight() - n * o - r * 2) / 2 : l === uft && (a = this.getHeight() - n * o - r * 2), t.translate(r, a + r), p = 0; p < n; p++) {
        var f = 0, Z = 0, y = i[p], W = y.text, V = y.width, w = y.lastInParagraph, v, H, x;
        if (t.save(), I === Aft ? f += c - V - r * 2 : I === lft && (f += (c - V - r * 2) / 2), b) {
          t.save(), t.beginPath(), t.moveTo(f, B + Z + Math.round(g / 2)), v = W.split(" ").length - 1, H = v === 0, x = I === oB && !w ? c - r * 2 : V, t.lineTo(f + Math.round(x), B + Z + Math.round(g / 2)), t.lineWidth = g / 15;
          const U = this._getLinearGradient();
          t.strokeStyle = U || C, t.stroke(), t.restore();
        }
        if (m) {
          t.save(), t.beginPath(), t.moveTo(f, B + Z), v = W.split(" ").length - 1, H = v === 0, x = I === oB && w && !H ? c - r * 2 : V, t.lineTo(f + Math.round(x), B + Z), t.lineWidth = g / 15;
          const U = this._getLinearGradient();
          t.strokeStyle = U || C, t.stroke(), t.restore();
        }
        if (d !== 0 || I === oB) {
          v = W.split(" ").length - 1;
          for (var J = U_(W), K = 0; K < J.length; K++) {
            var M = J[K];
            M === " " && !w && I === oB && (f += (c - r * 2 - V) / v), this._partialTextX = f, this._partialTextY = B + Z, this._partialText = M, t.fillStrokeShape(this), f += this.measureSize(M).width + d;
          }
        } else
          this._partialTextX = f, this._partialTextY = B + Z, this._partialText = W, t.fillStrokeShape(this);
        t.restore(), n > 1 && (B += o);
      }
    }
  }
  _hitFunc(t) {
    var i = this.getWidth(), n = this.getHeight();
    t.beginPath(), t.rect(0, 0, i, n), t.closePath(), t.fillStrokeShape(this);
  }
  setText(t) {
    var i = me._isString(t) ? t : t == null ? "" : t + "";
    return this._setAttr(Ift, i), this;
  }
  getWidth() {
    var t = this.attrs.width === Ih || this.attrs.width === void 0;
    return t ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
  }
  getHeight() {
    var t = this.attrs.height === Ih || this.attrs.height === void 0;
    return t ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return me.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  measureSize(t) {
    var i = KY(), n = this.fontSize(), r;
    return i.save(), i.font = this._getContextFont(), r = i.measureText(t), i.restore(), {
      width: r.width,
      height: n
    };
  }
  _getContextFont() {
    return this.fontStyle() + IS + this.fontVariant() + IS + (this.fontSize() + Cft) + pft(this.fontFamily());
  }
  _addTextLine(t) {
    this.align() === oB && (t = t.trim());
    var n = this._getTextWidth(t);
    return this.textArr.push({
      text: t,
      width: n,
      lastInParagraph: !1
    });
  }
  _getTextWidth(t) {
    var i = this.letterSpacing(), n = t.length;
    return KY().measureText(t).width + (n ? i * (n - 1) : 0);
  }
  _setTextData() {
    var t = this.text().split(`
`), i = +this.fontSize(), n = 0, r = this.lineHeight() * i, g = this.attrs.width, o = this.attrs.height, l = g !== Ih && g !== void 0, a = o !== Ih && o !== void 0, I = this.padding(), c = g - I * 2, d = o - I * 2, C = 0, A = this.wrap(), b = A !== LM, m = A !== hft && b, p = this.ellipsis();
    this.textArr = [], KY().font = this._getContextFont();
    for (var B = p ? this._getTextWidth(LY) : 0, f = 0, Z = t.length; f < Z; ++f) {
      var y = t[f], W = this._getTextWidth(y);
      if (l && W > c)
        for (; y.length > 0; ) {
          for (var V = 0, w = y.length, v = "", H = 0; V < w; ) {
            var x = V + w >>> 1, J = y.slice(0, x + 1), K = this._getTextWidth(J) + B;
            K <= c ? (V = x + 1, v = J, H = K) : w = x;
          }
          if (v) {
            if (m) {
              var M, L = y[v.length], N = L === IS || L === EM;
              N && H <= c ? M = v.length : M = Math.max(v.lastIndexOf(IS), v.lastIndexOf(EM)) + 1, M > 0 && (V = M, v = v.slice(0, V), H = this._getTextWidth(v));
            }
            v = v.trimRight(), this._addTextLine(v), n = Math.max(n, H), C += r;
            var U = this._shouldHandleEllipsis(C);
            if (U) {
              this._tryToAddEllipsisToLastLine();
              break;
            }
            if (y = y.slice(V), y = y.trimLeft(), y.length > 0 && (W = this._getTextWidth(y), W <= c)) {
              this._addTextLine(y), C += r, n = Math.max(n, W);
              break;
            }
          } else
            break;
        }
      else
        this._addTextLine(y), C += r, n = Math.max(n, W), this._shouldHandleEllipsis(C) && f < Z - 1 && this._tryToAddEllipsisToLastLine();
      if (this.textArr[this.textArr.length - 1] && (this.textArr[this.textArr.length - 1].lastInParagraph = !0), a && C + r > d)
        break;
    }
    this.textHeight = i, this.textWidth = n;
  }
  _shouldHandleEllipsis(t) {
    var i = +this.fontSize(), n = this.lineHeight() * i, r = this.attrs.height, g = r !== Ih && r !== void 0, o = this.padding(), l = r - o * 2, a = this.wrap(), I = a !== LM;
    return !I || g && t + n > l;
  }
  _tryToAddEllipsisToLastLine() {
    var t = this.attrs.width, i = t !== Ih && t !== void 0, n = this.padding(), r = t - n * 2, g = this.ellipsis(), o = this.textArr[this.textArr.length - 1];
    if (!(!o || !g)) {
      if (i) {
        var l = this._getTextWidth(o.text + LY) < r;
        l || (o.text = o.text.slice(0, o.text.length - 3));
      }
      this.textArr.splice(this.textArr.length - 1, 1), this._addTextLine(o.text + LY);
    }
  }
  getStrokeScaleEnabled() {
    return !0;
  }
};
sr.prototype._fillFunc = Bft;
sr.prototype._strokeFunc = fft;
sr.prototype.className = cft;
sr.prototype._attrsAffectingSize = [
  "text",
  "fontSize",
  "padding",
  "wrap",
  "lineHeight",
  "letterSpacing"
];
cr(sr);
oe.overWriteSetter(sr, "width", $9());
oe.overWriteSetter(sr, "height", $9());
oe.addGetterSetter(sr, "fontFamily", "Arial");
oe.addGetterSetter(sr, "fontSize", 12, ft());
oe.addGetterSetter(sr, "fontStyle", O_);
oe.addGetterSetter(sr, "fontVariant", O_);
oe.addGetterSetter(sr, "padding", 0, ft());
oe.addGetterSetter(sr, "align", z_);
oe.addGetterSetter(sr, "verticalAlign", dft);
oe.addGetterSetter(sr, "lineHeight", 1, ft());
oe.addGetterSetter(sr, "wrap", bft);
oe.addGetterSetter(sr, "ellipsis", !1, Ts());
oe.addGetterSetter(sr, "letterSpacing", 0, ft());
oe.addGetterSetter(sr, "text", "", Nm());
oe.addGetterSetter(sr, "textDecoration", "");
var Gft = "", j_ = "normal";
function q_(e) {
  e.fillText(this.partialText, 0, 0);
}
function __(e) {
  e.strokeText(this.partialText, 0, 0);
}
class eg extends At {
  constructor(t) {
    super(t), this.dummyCanvas = me.createCanvasElement(), this.dataArray = [], this.dataArray = kn.parsePathData(this.attrs.data), this.on("dataChange.konva", function() {
      this.dataArray = kn.parsePathData(this.attrs.data), this._setTextData();
    }), this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva", this._setTextData), this._setTextData();
  }
  _sceneFunc(t) {
    t.setAttr("font", this._getContextFont()), t.setAttr("textBaseline", this.textBaseline()), t.setAttr("textAlign", "left"), t.save();
    var i = this.textDecoration(), n = this.fill(), r = this.fontSize(), g = this.glyphInfo;
    i === "underline" && t.beginPath();
    for (var o = 0; o < g.length; o++) {
      t.save();
      var l = g[o].p0;
      t.translate(l.x, l.y), t.rotate(g[o].rotation), this.partialText = g[o].text, t.fillStrokeShape(this), i === "underline" && (o === 0 && t.moveTo(0, r / 2 + 1), t.lineTo(r, r / 2 + 1)), t.restore();
    }
    i === "underline" && (t.strokeStyle = n, t.lineWidth = r / 20, t.stroke()), t.restore();
  }
  _hitFunc(t) {
    t.beginPath();
    var i = this.glyphInfo;
    if (i.length >= 1) {
      var n = i[0].p0;
      t.moveTo(n.x, n.y);
    }
    for (var r = 0; r < i.length; r++) {
      var g = i[r].p1;
      t.lineTo(g.x, g.y);
    }
    t.setAttr("lineWidth", this.fontSize()), t.setAttr("strokeStyle", this.colorKey), t.stroke();
  }
  getTextWidth() {
    return this.textWidth;
  }
  getTextHeight() {
    return me.warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height."), this.textHeight;
  }
  setText(t) {
    return sr.prototype.setText.call(this, t);
  }
  _getContextFont() {
    return sr.prototype._getContextFont.call(this);
  }
  _getTextSize(t) {
    var i = this.dummyCanvas, n = i.getContext("2d");
    n.save(), n.font = this._getContextFont();
    var r = n.measureText(t);
    return n.restore(), {
      width: r.width,
      height: parseInt(this.attrs.fontSize, 10)
    };
  }
  _setTextData() {
    var t = this, i = this._getTextSize(this.attrs.text), n = this.letterSpacing(), r = this.align(), g = this.kerningFunc();
    this.textWidth = i.width, this.textHeight = i.height;
    var o = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * n, 0);
    this.glyphInfo = [];
    for (var l = 0, a = 0; a < t.dataArray.length; a++)
      t.dataArray[a].pathLength > 0 && (l += t.dataArray[a].pathLength);
    var I = 0;
    r === "center" && (I = Math.max(0, l / 2 - o / 2)), r === "right" && (I = Math.max(0, l - o));
    for (var c = U_(this.text()), d = this.text().split(" ").length - 1, C, A, b, m = -1, p = 0, B = function() {
      p = 0;
      for (var K = t.dataArray, M = m + 1; M < K.length; M++) {
        if (K[M].pathLength > 0)
          return m = M, K[M];
        K[M].command === "M" && (C = {
          x: K[M].points[0],
          y: K[M].points[1]
        });
      }
      return {};
    }, f = function(K) {
      var M = t._getTextSize(K).width + n;
      K === " " && r === "justify" && (M += (l - o) / d);
      var L = 0, N = 0;
      for (A = void 0; Math.abs(M - L) / M > 0.01 && N < 20; ) {
        N++;
        for (var U = L; b === void 0; )
          b = B(), b && U + b.pathLength < M && (U += b.pathLength, b = void 0);
        if (Object.keys(b).length === 0 || C === void 0)
          return;
        var O = !1;
        switch (b.command) {
          case "L":
            kn.getLineLength(C.x, C.y, b.points[0], b.points[1]) > M ? A = kn.getPointOnLine(M, C.x, C.y, b.points[0], b.points[1], C.x, C.y) : b = void 0;
            break;
          case "A":
            var $ = b.points[4], ne = b.points[5], be = b.points[4] + ne;
            p === 0 ? p = $ + 1e-8 : M > L ? p += Math.PI / 180 * ne / Math.abs(ne) : p -= Math.PI / 360 * ne / Math.abs(ne), (ne < 0 && p < be || ne >= 0 && p > be) && (p = be, O = !0), A = kn.getPointOnEllipticalArc(b.points[0], b.points[1], b.points[2], b.points[3], p, b.points[6]);
            break;
          case "C":
            p === 0 ? M > b.pathLength ? p = 1e-8 : p = M / b.pathLength : M > L ? p += (M - L) / b.pathLength / 2 : p = Math.max(p - (L - M) / b.pathLength / 2, 0), p > 1 && (p = 1, O = !0), A = kn.getPointOnCubicBezier(p, b.start.x, b.start.y, b.points[0], b.points[1], b.points[2], b.points[3], b.points[4], b.points[5]);
            break;
          case "Q":
            p === 0 ? p = M / b.pathLength : M > L ? p += (M - L) / b.pathLength : p -= (L - M) / b.pathLength, p > 1 && (p = 1, O = !0), A = kn.getPointOnQuadraticBezier(p, b.start.x, b.start.y, b.points[0], b.points[1], b.points[2], b.points[3]);
            break;
        }
        A !== void 0 && (L = kn.getLineLength(C.x, C.y, A.x, A.y)), O && (O = !1, b = void 0);
      }
    }, Z = "C", y = t._getTextSize(Z).width + n, W = I / y - 1, V = 0; V < W && (f(Z), !(C === void 0 || A === void 0)); V++)
      C = A;
    for (var w = 0; w < c.length && (f(c[w]), !(C === void 0 || A === void 0)); w++) {
      var v = kn.getLineLength(C.x, C.y, A.x, A.y), H = 0;
      if (g)
        try {
          H = g(c[w - 1], c[w]) * this.fontSize();
        } catch {
          H = 0;
        }
      C.x += H, A.x += H, this.textWidth += H;
      var x = kn.getPointOnLine(H + v / 2, C.x, C.y, A.x, A.y), J = Math.atan2(A.y - C.y, A.x - C.x);
      this.glyphInfo.push({
        transposeX: x.x,
        transposeY: x.y,
        text: c[w],
        rotation: J,
        p0: C,
        p1: A
      }), C = A;
    }
  }
  getSelfRect() {
    if (!this.glyphInfo.length)
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    var t = [];
    this.glyphInfo.forEach(function(c) {
      t.push(c.p0.x), t.push(c.p0.y), t.push(c.p1.x), t.push(c.p1.y);
    });
    for (var i = t[0] || 0, n = t[0] || 0, r = t[1] || 0, g = t[1] || 0, o, l, a = 0; a < t.length / 2; a++)
      o = t[a * 2], l = t[a * 2 + 1], i = Math.min(i, o), n = Math.max(n, o), r = Math.min(r, l), g = Math.max(g, l);
    var I = this.fontSize();
    return {
      x: i - I / 2,
      y: r - I / 2,
      width: n - i + I,
      height: g - r + I
    };
  }
  destroy() {
    return me.releaseCanvas(this.dummyCanvas), super.destroy();
  }
}
eg.prototype._fillFunc = q_;
eg.prototype._strokeFunc = __;
eg.prototype._fillFuncHit = q_;
eg.prototype._strokeFuncHit = __;
eg.prototype.className = "TextPath";
eg.prototype._attrsAffectingSize = ["text", "fontSize", "data"];
cr(eg);
oe.addGetterSetter(eg, "data");
oe.addGetterSetter(eg, "fontFamily", "Arial");
oe.addGetterSetter(eg, "fontSize", 12, ft());
oe.addGetterSetter(eg, "fontStyle", j_);
oe.addGetterSetter(eg, "align", "left");
oe.addGetterSetter(eg, "letterSpacing", 0, ft());
oe.addGetterSetter(eg, "textBaseline", "middle");
oe.addGetterSetter(eg, "fontVariant", j_);
oe.addGetterSetter(eg, "text", Gft);
oe.addGetterSetter(eg, "textDecoration", null);
oe.addGetterSetter(eg, "kerningFunc", null);
var $_ = "tr-konva", yft = [
  "resizeEnabledChange",
  "rotateAnchorOffsetChange",
  "rotateEnabledChange",
  "enabledAnchorsChange",
  "anchorSizeChange",
  "borderEnabledChange",
  "borderStrokeChange",
  "borderStrokeWidthChange",
  "borderDashChange",
  "anchorStrokeChange",
  "anchorStrokeWidthChange",
  "anchorFillChange",
  "anchorCornerRadiusChange",
  "ignoreStrokeChange"
].map((e) => e + `.${$_}`).join(" "), KM = "nodesRect", Wft = [
  "widthChange",
  "heightChange",
  "scaleXChange",
  "scaleYChange",
  "skewXChange",
  "skewYChange",
  "rotationChange",
  "offsetXChange",
  "offsetYChange",
  "transformsEnabledChange",
  "strokeWidthChange"
], Sft = {
  "top-left": -45,
  "top-center": 0,
  "top-right": 45,
  "middle-right": -90,
  "middle-left": 90,
  "bottom-left": -135,
  "bottom-center": 180,
  "bottom-right": 135
};
const Vft = "ontouchstart" in ei._global;
function wft(e, t) {
  if (e === "rotater")
    return "crosshair";
  t += me.degToRad(Sft[e] || 0);
  var i = (me.radToDeg(t) % 360 + 360) % 360;
  return me._inRange(i, 315 + 22.5, 360) || me._inRange(i, 0, 22.5) ? "ns-resize" : me._inRange(i, 45 - 22.5, 45 + 22.5) ? "nesw-resize" : me._inRange(i, 90 - 22.5, 90 + 22.5) ? "ew-resize" : me._inRange(i, 135 - 22.5, 135 + 22.5) ? "nwse-resize" : me._inRange(i, 180 - 22.5, 180 + 22.5) ? "ns-resize" : me._inRange(i, 225 - 22.5, 225 + 22.5) ? "nesw-resize" : me._inRange(i, 270 - 22.5, 270 + 22.5) ? "ew-resize" : me._inRange(i, 315 - 22.5, 315 + 22.5) ? "nwse-resize" : (me.error("Transformer has unknown angle for cursor detection: " + i), "pointer");
}
var Ww = [
  "top-left",
  "top-center",
  "top-right",
  "middle-right",
  "middle-left",
  "bottom-left",
  "bottom-center",
  "bottom-right"
], TM = 1e8;
function vft(e) {
  return {
    x: e.x + e.width / 2 * Math.cos(e.rotation) + e.height / 2 * Math.sin(-e.rotation),
    y: e.y + e.height / 2 * Math.cos(e.rotation) + e.width / 2 * Math.sin(e.rotation)
  };
}
function e$(e, t, i) {
  const n = i.x + (e.x - i.x) * Math.cos(t) - (e.y - i.y) * Math.sin(t), r = i.y + (e.x - i.x) * Math.sin(t) + (e.y - i.y) * Math.cos(t);
  return Object.assign(Object.assign({}, e), {
    rotation: e.rotation + t,
    x: n,
    y: r
  });
}
function Rft(e, t) {
  const i = vft(e);
  return e$(e, t, i);
}
function Xft(e, t, i) {
  let n = t;
  for (let r = 0; r < e.length; r++) {
    const g = ei.getAngle(e[r]), o = Math.abs(g - t) % (Math.PI * 2);
    Math.min(o, Math.PI * 2 - o) < i && (n = g);
  }
  return n;
}
class Gn extends dm {
  constructor(t) {
    super(t), this._transforming = !1, this._createElements(), this._handleMouseMove = this._handleMouseMove.bind(this), this._handleMouseUp = this._handleMouseUp.bind(this), this.update = this.update.bind(this), this.on(yft, this.update), this.getNode() && this.update();
  }
  attachTo(t) {
    return this.setNode(t), this;
  }
  setNode(t) {
    return me.warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead."), this.setNodes([t]);
  }
  getNode() {
    return this._nodes && this._nodes[0];
  }
  _getEventNamespace() {
    return $_ + this._id;
  }
  setNodes(t = []) {
    this._nodes && this._nodes.length && this.detach();
    const i = t.filter((r) => r.isAncestorOf(this) ? (me.error("Konva.Transformer cannot be an a child of the node you are trying to attach"), !1) : !0);
    this._nodes = t = i, t.length === 1 && this.useSingleNodeRotation() ? this.rotation(t[0].getAbsoluteRotation()) : this.rotation(0), this._nodes.forEach((r) => {
      const g = () => {
        this.nodes().length === 1 && this.useSingleNodeRotation() && this.rotation(this.nodes()[0].getAbsoluteRotation()), this._resetTransformCache(), !this._transforming && !this.isDragging() && this.update();
      }, o = r._attrsAffectingSize.map((l) => l + "Change." + this._getEventNamespace()).join(" ");
      r.on(o, g), r.on(Wft.map((l) => l + `.${this._getEventNamespace()}`).join(" "), g), r.on(`absoluteTransformChange.${this._getEventNamespace()}`, g), this._proxyDrag(r);
    }), this._resetTransformCache();
    var n = !!this.findOne(".top-left");
    return n && this.update(), this;
  }
  _proxyDrag(t) {
    let i;
    t.on(`dragstart.${this._getEventNamespace()}`, (n) => {
      i = t.getAbsolutePosition(), !this.isDragging() && t !== this.findOne(".back") && this.startDrag(n, !1);
    }), t.on(`dragmove.${this._getEventNamespace()}`, (n) => {
      if (!i)
        return;
      const r = t.getAbsolutePosition(), g = r.x - i.x, o = r.y - i.y;
      this.nodes().forEach((l) => {
        if (l === t || l.isDragging())
          return;
        const a = l.getAbsolutePosition();
        l.setAbsolutePosition({
          x: a.x + g,
          y: a.y + o
        }), l.startDrag(n);
      }), i = null;
    });
  }
  getNodes() {
    return this._nodes || [];
  }
  getActiveAnchor() {
    return this._movingAnchorName;
  }
  detach() {
    this._nodes && this._nodes.forEach((t) => {
      t.off("." + this._getEventNamespace());
    }), this._nodes = [], this._resetTransformCache();
  }
  _resetTransformCache() {
    this._clearCache(KM), this._clearCache("transform"), this._clearSelfAndDescendantCache("absoluteTransform");
  }
  _getNodeRect() {
    return this._getCache(KM, this.__getNodeRect);
  }
  __getNodeShape(t, i = this.rotation(), n) {
    var r = t.getClientRect({
      skipTransform: !0,
      skipShadow: !0,
      skipStroke: this.ignoreStroke()
    }), g = t.getAbsoluteScale(n), o = t.getAbsolutePosition(n), l = r.x * g.x - t.offsetX() * g.x, a = r.y * g.y - t.offsetY() * g.y;
    const I = (ei.getAngle(t.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2), c = {
      x: o.x + l * Math.cos(I) + a * Math.sin(-I),
      y: o.y + a * Math.cos(I) + l * Math.sin(I),
      width: r.width * g.x,
      height: r.height * g.y,
      rotation: I
    };
    return e$(c, -ei.getAngle(i), {
      x: 0,
      y: 0
    });
  }
  __getNodeRect() {
    var t = this.getNode();
    if (!t)
      return {
        x: -TM,
        y: -TM,
        width: 0,
        height: 0,
        rotation: 0
      };
    const i = [];
    this.nodes().map((I) => {
      const c = I.getClientRect({
        skipTransform: !0,
        skipShadow: !0,
        skipStroke: this.ignoreStroke()
      });
      var d = [
        { x: c.x, y: c.y },
        { x: c.x + c.width, y: c.y },
        { x: c.x + c.width, y: c.y + c.height },
        { x: c.x, y: c.y + c.height }
      ], C = I.getAbsoluteTransform();
      d.forEach(function(A) {
        var b = C.point(A);
        i.push(b);
      });
    });
    const n = new Hl();
    n.rotate(-ei.getAngle(this.rotation()));
    var r, g, o, l;
    i.forEach(function(I) {
      var c = n.point(I);
      r === void 0 && (r = o = c.x, g = l = c.y), r = Math.min(r, c.x), g = Math.min(g, c.y), o = Math.max(o, c.x), l = Math.max(l, c.y);
    }), n.invert();
    const a = n.point({ x: r, y: g });
    return {
      x: a.x,
      y: a.y,
      width: o - r,
      height: l - g,
      rotation: ei.getAngle(this.rotation())
    };
  }
  getX() {
    return this._getNodeRect().x;
  }
  getY() {
    return this._getNodeRect().y;
  }
  getWidth() {
    return this._getNodeRect().width;
  }
  getHeight() {
    return this._getNodeRect().height;
  }
  _createElements() {
    this._createBack(), Ww.forEach((function(t) {
      this._createAnchor(t);
    }).bind(this)), this._createAnchor("rotater");
  }
  _createAnchor(t) {
    var i = new MZ({
      stroke: "rgb(0, 161, 255)",
      fill: "white",
      strokeWidth: 1,
      name: t + " _anchor",
      dragDistance: 0,
      draggable: !0,
      hitStrokeWidth: Vft ? 10 : "auto"
    }), n = this;
    i.on("mousedown touchstart", function(r) {
      n._handleMouseDown(r);
    }), i.on("dragstart", (r) => {
      i.stopDrag(), r.cancelBubble = !0;
    }), i.on("dragend", (r) => {
      r.cancelBubble = !0;
    }), i.on("mouseenter", () => {
      var r = ei.getAngle(this.rotation()), g = wft(t, r);
      i.getStage().content && (i.getStage().content.style.cursor = g), this._cursorChange = !0;
    }), i.on("mouseout", () => {
      i.getStage().content && (i.getStage().content.style.cursor = ""), this._cursorChange = !1;
    }), this.add(i);
  }
  _createBack() {
    var t = new At({
      name: "back",
      width: 0,
      height: 0,
      draggable: !0,
      sceneFunc(i) {
        var n = this.getParent(), r = n.padding();
        i.beginPath(), i.rect(-r, -r, this.width() + r * 2, this.height() + r * 2), i.moveTo(this.width() / 2, -r), n.rotateEnabled() && i.lineTo(this.width() / 2, -n.rotateAnchorOffset() * me._sign(this.height()) - r), i.fillStrokeShape(this);
      },
      hitFunc: (i, n) => {
        if (this.shouldOverdrawWholeArea()) {
          var r = this.padding();
          i.beginPath(), i.rect(-r, -r, n.width() + r * 2, n.height() + r * 2), i.fillStrokeShape(n);
        }
      }
    });
    this.add(t), this._proxyDrag(t), t.on("dragstart", (i) => {
      i.cancelBubble = !0;
    }), t.on("dragmove", (i) => {
      i.cancelBubble = !0;
    }), t.on("dragend", (i) => {
      i.cancelBubble = !0;
    }), this.on("dragmove", (i) => {
      this.update();
    });
  }
  _handleMouseDown(t) {
    this._movingAnchorName = t.target.name().split(" ")[0];
    var i = this._getNodeRect(), n = i.width, r = i.height, g = Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2));
    this.sin = Math.abs(r / g), this.cos = Math.abs(n / g), typeof window < "u" && (window.addEventListener("mousemove", this._handleMouseMove), window.addEventListener("touchmove", this._handleMouseMove), window.addEventListener("mouseup", this._handleMouseUp, !0), window.addEventListener("touchend", this._handleMouseUp, !0)), this._transforming = !0;
    var o = t.target.getAbsolutePosition(), l = t.target.getStage().getPointerPosition();
    this._anchorDragOffset = {
      x: l.x - o.x,
      y: l.y - o.y
    }, this._fire("transformstart", { evt: t.evt, target: this.getNode() }), this._nodes.forEach((a) => {
      a._fire("transformstart", { evt: t.evt, target: a });
    });
  }
  _handleMouseMove(t) {
    var i, n, r, g = this.findOne("." + this._movingAnchorName), o = g.getStage();
    o.setPointersPositions(t);
    const l = o.getPointerPosition();
    let a = {
      x: l.x - this._anchorDragOffset.x,
      y: l.y - this._anchorDragOffset.y
    };
    const I = g.getAbsolutePosition();
    this.anchorDragBoundFunc() && (a = this.anchorDragBoundFunc()(I, a, t)), g.setAbsolutePosition(a);
    const c = g.getAbsolutePosition();
    if (!(I.x === c.x && I.y === c.y)) {
      if (this._movingAnchorName === "rotater") {
        var d = this._getNodeRect();
        i = g.x() - d.width / 2, n = -g.y() + d.height / 2;
        let K = Math.atan2(-n, i) + Math.PI / 2;
        d.height < 0 && (K -= Math.PI);
        var C = ei.getAngle(this.rotation());
        const M = C + K, L = ei.getAngle(this.rotationSnapTolerance()), U = Xft(this.rotationSnaps(), M, L) - d.rotation, O = Rft(d, U);
        this._fitNodesInto(O, t);
        return;
      }
      var A = this.keepRatio() || t.shiftKey, f = this.centeredScaling() || t.altKey;
      if (this._movingAnchorName === "top-left") {
        if (A) {
          var b = f ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-right").x(),
            y: this.findOne(".bottom-right").y()
          };
          r = Math.sqrt(Math.pow(b.x - g.x(), 2) + Math.pow(b.y - g.y(), 2));
          var m = this.findOne(".top-left").x() > b.x ? -1 : 1, p = this.findOne(".top-left").y() > b.y ? -1 : 1;
          i = r * this.cos * m, n = r * this.sin * p, this.findOne(".top-left").x(b.x - i), this.findOne(".top-left").y(b.y - n);
        }
      } else if (this._movingAnchorName === "top-center")
        this.findOne(".top-left").y(g.y());
      else if (this._movingAnchorName === "top-right") {
        if (A) {
          var b = f ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".bottom-left").x(),
            y: this.findOne(".bottom-left").y()
          };
          r = Math.sqrt(Math.pow(g.x() - b.x, 2) + Math.pow(b.y - g.y(), 2));
          var m = this.findOne(".top-right").x() < b.x ? -1 : 1, p = this.findOne(".top-right").y() > b.y ? -1 : 1;
          i = r * this.cos * m, n = r * this.sin * p, this.findOne(".top-right").x(b.x + i), this.findOne(".top-right").y(b.y - n);
        }
        var B = g.position();
        this.findOne(".top-left").y(B.y), this.findOne(".bottom-right").x(B.x);
      } else if (this._movingAnchorName === "middle-left")
        this.findOne(".top-left").x(g.x());
      else if (this._movingAnchorName === "middle-right")
        this.findOne(".bottom-right").x(g.x());
      else if (this._movingAnchorName === "bottom-left") {
        if (A) {
          var b = f ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-right").x(),
            y: this.findOne(".top-right").y()
          };
          r = Math.sqrt(Math.pow(b.x - g.x(), 2) + Math.pow(g.y() - b.y, 2));
          var m = b.x < g.x() ? -1 : 1, p = g.y() < b.y ? -1 : 1;
          i = r * this.cos * m, n = r * this.sin * p, g.x(b.x - i), g.y(b.y + n);
        }
        B = g.position(), this.findOne(".top-left").x(B.x), this.findOne(".bottom-right").y(B.y);
      } else if (this._movingAnchorName === "bottom-center")
        this.findOne(".bottom-right").y(g.y());
      else if (this._movingAnchorName === "bottom-right") {
        if (A) {
          var b = f ? {
            x: this.width() / 2,
            y: this.height() / 2
          } : {
            x: this.findOne(".top-left").x(),
            y: this.findOne(".top-left").y()
          };
          r = Math.sqrt(Math.pow(g.x() - b.x, 2) + Math.pow(g.y() - b.y, 2));
          var m = this.findOne(".bottom-right").x() < b.x ? -1 : 1, p = this.findOne(".bottom-right").y() < b.y ? -1 : 1;
          i = r * this.cos * m, n = r * this.sin * p, this.findOne(".bottom-right").x(b.x + i), this.findOne(".bottom-right").y(b.y + n);
        }
      } else
        console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
      var f = this.centeredScaling() || t.altKey;
      if (f) {
        var Z = this.findOne(".top-left"), y = this.findOne(".bottom-right"), W = Z.x(), V = Z.y(), w = this.getWidth() - y.x(), v = this.getHeight() - y.y();
        y.move({
          x: -W,
          y: -V
        }), Z.move({
          x: w,
          y: v
        });
      }
      var H = this.findOne(".top-left").getAbsolutePosition();
      i = H.x, n = H.y;
      var x = this.findOne(".bottom-right").x() - this.findOne(".top-left").x(), J = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
      this._fitNodesInto({
        x: i,
        y: n,
        width: x,
        height: J,
        rotation: ei.getAngle(this.rotation())
      }, t);
    }
  }
  _handleMouseUp(t) {
    this._removeEvents(t);
  }
  getAbsoluteTransform() {
    return this.getTransform();
  }
  _removeEvents(t) {
    if (this._transforming) {
      this._transforming = !1, typeof window < "u" && (window.removeEventListener("mousemove", this._handleMouseMove), window.removeEventListener("touchmove", this._handleMouseMove), window.removeEventListener("mouseup", this._handleMouseUp, !0), window.removeEventListener("touchend", this._handleMouseUp, !0));
      var i = this.getNode();
      this._fire("transformend", { evt: t, target: i }), i && this._nodes.forEach((n) => {
        n._fire("transformend", { evt: t, target: n });
      }), this._movingAnchorName = null;
    }
  }
  _fitNodesInto(t, i) {
    var n = this._getNodeRect();
    const r = 1;
    if (me._inRange(t.width, -this.padding() * 2 - r, r)) {
      this.update();
      return;
    }
    if (me._inRange(t.height, -this.padding() * 2 - r, r)) {
      this.update();
      return;
    }
    const g = this.flipEnabled();
    var o = new Hl();
    if (o.rotate(ei.getAngle(this.rotation())), this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
      const d = o.point({
        x: -this.padding() * 2,
        y: 0
      });
      if (t.x += d.x, t.y += d.y, t.width += this.padding() * 2, this._movingAnchorName = this._movingAnchorName.replace("left", "right"), this._anchorDragOffset.x -= d.x, this._anchorDragOffset.y -= d.y, !g) {
        this.update();
        return;
      }
    } else if (this._movingAnchorName && t.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
      const d = o.point({
        x: this.padding() * 2,
        y: 0
      });
      if (this._movingAnchorName = this._movingAnchorName.replace("right", "left"), this._anchorDragOffset.x -= d.x, this._anchorDragOffset.y -= d.y, t.width += this.padding() * 2, !g) {
        this.update();
        return;
      }
    }
    if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
      const d = o.point({
        x: 0,
        y: -this.padding() * 2
      });
      if (t.x += d.x, t.y += d.y, this._movingAnchorName = this._movingAnchorName.replace("top", "bottom"), this._anchorDragOffset.x -= d.x, this._anchorDragOffset.y -= d.y, t.height += this.padding() * 2, !g) {
        this.update();
        return;
      }
    } else if (this._movingAnchorName && t.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
      const d = o.point({
        x: 0,
        y: this.padding() * 2
      });
      if (this._movingAnchorName = this._movingAnchorName.replace("bottom", "top"), this._anchorDragOffset.x -= d.x, this._anchorDragOffset.y -= d.y, t.height += this.padding() * 2, !g) {
        this.update();
        return;
      }
    }
    if (this.boundBoxFunc()) {
      const d = this.boundBoxFunc()(n, t);
      d ? t = d : me.warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
    }
    const l = 1e7, a = new Hl();
    a.translate(n.x, n.y), a.rotate(n.rotation), a.scale(n.width / l, n.height / l);
    const I = new Hl();
    I.translate(t.x, t.y), I.rotate(t.rotation), I.scale(t.width / l, t.height / l);
    const c = I.multiply(a.invert());
    this._nodes.forEach((d) => {
      var C;
      const A = d.getParent().getAbsoluteTransform(), b = d.getTransform().copy();
      b.translate(d.offsetX(), d.offsetY());
      const m = new Hl();
      m.multiply(A.copy().invert()).multiply(c).multiply(A).multiply(b);
      const p = m.decompose();
      d.setAttrs(p), this._fire("transform", { evt: i, target: d }), d._fire("transform", { evt: i, target: d }), (C = d.getLayer()) === null || C === void 0 || C.batchDraw();
    }), this.rotation(me._getRotation(t.rotation)), this._resetTransformCache(), this.update(), this.getLayer().batchDraw();
  }
  forceUpdate() {
    this._resetTransformCache(), this.update();
  }
  _batchChangeChild(t, i) {
    this.findOne(t).setAttrs(i);
  }
  update() {
    var t, i = this._getNodeRect();
    this.rotation(me._getRotation(i.rotation));
    var n = i.width, r = i.height, g = this.enabledAnchors(), o = this.resizeEnabled(), l = this.padding(), a = this.anchorSize();
    this.find("._anchor").forEach((I) => {
      I.setAttrs({
        width: a,
        height: a,
        offsetX: a / 2,
        offsetY: a / 2,
        stroke: this.anchorStroke(),
        strokeWidth: this.anchorStrokeWidth(),
        fill: this.anchorFill(),
        cornerRadius: this.anchorCornerRadius()
      });
    }), this._batchChangeChild(".top-left", {
      x: 0,
      y: 0,
      offsetX: a / 2 + l,
      offsetY: a / 2 + l,
      visible: o && g.indexOf("top-left") >= 0
    }), this._batchChangeChild(".top-center", {
      x: n / 2,
      y: 0,
      offsetY: a / 2 + l,
      visible: o && g.indexOf("top-center") >= 0
    }), this._batchChangeChild(".top-right", {
      x: n,
      y: 0,
      offsetX: a / 2 - l,
      offsetY: a / 2 + l,
      visible: o && g.indexOf("top-right") >= 0
    }), this._batchChangeChild(".middle-left", {
      x: 0,
      y: r / 2,
      offsetX: a / 2 + l,
      visible: o && g.indexOf("middle-left") >= 0
    }), this._batchChangeChild(".middle-right", {
      x: n,
      y: r / 2,
      offsetX: a / 2 - l,
      visible: o && g.indexOf("middle-right") >= 0
    }), this._batchChangeChild(".bottom-left", {
      x: 0,
      y: r,
      offsetX: a / 2 + l,
      offsetY: a / 2 - l,
      visible: o && g.indexOf("bottom-left") >= 0
    }), this._batchChangeChild(".bottom-center", {
      x: n / 2,
      y: r,
      offsetY: a / 2 - l,
      visible: o && g.indexOf("bottom-center") >= 0
    }), this._batchChangeChild(".bottom-right", {
      x: n,
      y: r,
      offsetX: a / 2 - l,
      offsetY: a / 2 - l,
      visible: o && g.indexOf("bottom-right") >= 0
    }), this._batchChangeChild(".rotater", {
      x: n / 2,
      y: -this.rotateAnchorOffset() * me._sign(r) - l,
      visible: this.rotateEnabled()
    }), this._batchChangeChild(".back", {
      width: n,
      height: r,
      visible: this.borderEnabled(),
      stroke: this.borderStroke(),
      strokeWidth: this.borderStrokeWidth(),
      dash: this.borderDash(),
      x: 0,
      y: 0
    }), (t = this.getLayer()) === null || t === void 0 || t.batchDraw();
  }
  isTransforming() {
    return this._transforming;
  }
  stopTransform() {
    if (this._transforming) {
      this._removeEvents();
      var t = this.findOne("." + this._movingAnchorName);
      t && t.stopDrag();
    }
  }
  destroy() {
    return this.getStage() && this._cursorChange && this.getStage().content && (this.getStage().content.style.cursor = ""), dm.prototype.destroy.call(this), this.detach(), this._removeEvents(), this;
  }
  toObject() {
    return yt.prototype.toObject.call(this);
  }
  clone(t) {
    var i = yt.prototype.clone.call(this, t);
    return i;
  }
  getClientRect() {
    return this.nodes().length > 0 ? super.getClientRect() : { x: 0, y: 0, width: 0, height: 0 };
  }
}
function Hft(e) {
  return e instanceof Array || me.warn("enabledAnchors value should be an array"), e instanceof Array && e.forEach(function(t) {
    Ww.indexOf(t) === -1 && me.warn("Unknown anchor name: " + t + ". Available names are: " + Ww.join(", "));
  }), e || [];
}
Gn.prototype.className = "Transformer";
cr(Gn);
oe.addGetterSetter(Gn, "enabledAnchors", Ww, Hft);
oe.addGetterSetter(Gn, "flipEnabled", !0, Ts());
oe.addGetterSetter(Gn, "resizeEnabled", !0);
oe.addGetterSetter(Gn, "anchorSize", 10, ft());
oe.addGetterSetter(Gn, "rotateEnabled", !0);
oe.addGetterSetter(Gn, "rotationSnaps", []);
oe.addGetterSetter(Gn, "rotateAnchorOffset", 50, ft());
oe.addGetterSetter(Gn, "rotationSnapTolerance", 5, ft());
oe.addGetterSetter(Gn, "borderEnabled", !0);
oe.addGetterSetter(Gn, "anchorStroke", "rgb(0, 161, 255)");
oe.addGetterSetter(Gn, "anchorStrokeWidth", 1, ft());
oe.addGetterSetter(Gn, "anchorFill", "white");
oe.addGetterSetter(Gn, "anchorCornerRadius", 0, ft());
oe.addGetterSetter(Gn, "borderStroke", "rgb(0, 161, 255)");
oe.addGetterSetter(Gn, "borderStrokeWidth", 1, ft());
oe.addGetterSetter(Gn, "borderDash");
oe.addGetterSetter(Gn, "keepRatio", !0);
oe.addGetterSetter(Gn, "centeredScaling", !1);
oe.addGetterSetter(Gn, "ignoreStroke", !1);
oe.addGetterSetter(Gn, "padding", 0, ft());
oe.addGetterSetter(Gn, "node");
oe.addGetterSetter(Gn, "nodes");
oe.addGetterSetter(Gn, "boundBoxFunc");
oe.addGetterSetter(Gn, "anchorDragBoundFunc");
oe.addGetterSetter(Gn, "shouldOverdrawWholeArea", !1);
oe.addGetterSetter(Gn, "useSingleNodeRotation", !0);
oe.backCompat(Gn, {
  lineEnabled: "borderEnabled",
  rotateHandlerOffset: "rotateAnchorOffset",
  enabledHandlers: "enabledAnchors"
});
class Yc extends At {
  _sceneFunc(t) {
    t.beginPath(), t.arc(0, 0, this.radius(), 0, ei.getAngle(this.angle()), this.clockwise()), t.lineTo(0, 0), t.closePath(), t.fillStrokeShape(this);
  }
  getWidth() {
    return this.radius() * 2;
  }
  getHeight() {
    return this.radius() * 2;
  }
  setWidth(t) {
    this.radius(t / 2);
  }
  setHeight(t) {
    this.radius(t / 2);
  }
}
Yc.prototype.className = "Wedge";
Yc.prototype._centroid = !0;
Yc.prototype._attrsAffectingSize = ["radius"];
cr(Yc);
oe.addGetterSetter(Yc, "radius", 0, ft());
oe.addGetterSetter(Yc, "angle", 0, ft());
oe.addGetterSetter(Yc, "clockwise", !1);
oe.backCompat(Yc, {
  angleDeg: "angle",
  getAngleDeg: "getAngle",
  setAngleDeg: "setAngle"
});
function MM() {
  this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
}
var kft = [
  512,
  512,
  456,
  512,
  328,
  456,
  335,
  512,
  405,
  328,
  271,
  456,
  388,
  335,
  292,
  512,
  454,
  405,
  364,
  328,
  298,
  271,
  496,
  456,
  420,
  388,
  360,
  335,
  312,
  292,
  273,
  512,
  482,
  454,
  428,
  405,
  383,
  364,
  345,
  328,
  312,
  298,
  284,
  271,
  259,
  496,
  475,
  456,
  437,
  420,
  404,
  388,
  374,
  360,
  347,
  335,
  323,
  312,
  302,
  292,
  282,
  273,
  265,
  512,
  497,
  482,
  468,
  454,
  441,
  428,
  417,
  405,
  394,
  383,
  373,
  364,
  354,
  345,
  337,
  328,
  320,
  312,
  305,
  298,
  291,
  284,
  278,
  271,
  265,
  259,
  507,
  496,
  485,
  475,
  465,
  456,
  446,
  437,
  428,
  420,
  412,
  404,
  396,
  388,
  381,
  374,
  367,
  360,
  354,
  347,
  341,
  335,
  329,
  323,
  318,
  312,
  307,
  302,
  297,
  292,
  287,
  282,
  278,
  273,
  269,
  265,
  261,
  512,
  505,
  497,
  489,
  482,
  475,
  468,
  461,
  454,
  447,
  441,
  435,
  428,
  422,
  417,
  411,
  405,
  399,
  394,
  389,
  383,
  378,
  373,
  368,
  364,
  359,
  354,
  350,
  345,
  341,
  337,
  332,
  328,
  324,
  320,
  316,
  312,
  309,
  305,
  301,
  298,
  294,
  291,
  287,
  284,
  281,
  278,
  274,
  271,
  268,
  265,
  262,
  259,
  257,
  507,
  501,
  496,
  491,
  485,
  480,
  475,
  470,
  465,
  460,
  456,
  451,
  446,
  442,
  437,
  433,
  428,
  424,
  420,
  416,
  412,
  408,
  404,
  400,
  396,
  392,
  388,
  385,
  381,
  377,
  374,
  370,
  367,
  363,
  360,
  357,
  354,
  350,
  347,
  344,
  341,
  338,
  335,
  332,
  329,
  326,
  323,
  320,
  318,
  315,
  312,
  310,
  307,
  304,
  302,
  299,
  297,
  294,
  292,
  289,
  287,
  285,
  282,
  280,
  278,
  275,
  273,
  271,
  269,
  267,
  265,
  263,
  261,
  259
], Yft = [
  9,
  11,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  21,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  22,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  23,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24,
  24
];
function Fft(e, t) {
  var i = e.data, n = e.width, r = e.height, g, o, l, a, I, c, d, C, A, b, m, p, B, f, Z, y, W, V, w, v, H, x, J, K, M = t + t + 1, L = n - 1, N = r - 1, U = t + 1, O = U * (U + 1) / 2, $ = new MM(), ne = null, be = $, Ve = null, He = null, Je = kft[t], ke = Yft[t];
  for (l = 1; l < M; l++)
    be = be.next = new MM(), l === U && (ne = be);
  for (be.next = $, d = c = 0, o = 0; o < r; o++) {
    for (y = W = V = w = C = A = b = m = 0, p = U * (v = i[c]), B = U * (H = i[c + 1]), f = U * (x = i[c + 2]), Z = U * (J = i[c + 3]), C += O * v, A += O * H, b += O * x, m += O * J, be = $, l = 0; l < U; l++)
      be.r = v, be.g = H, be.b = x, be.a = J, be = be.next;
    for (l = 1; l < U; l++)
      a = c + ((L < l ? L : l) << 2), C += (be.r = v = i[a]) * (K = U - l), A += (be.g = H = i[a + 1]) * K, b += (be.b = x = i[a + 2]) * K, m += (be.a = J = i[a + 3]) * K, y += v, W += H, V += x, w += J, be = be.next;
    for (Ve = $, He = ne, g = 0; g < n; g++)
      i[c + 3] = J = m * Je >> ke, J !== 0 ? (J = 255 / J, i[c] = (C * Je >> ke) * J, i[c + 1] = (A * Je >> ke) * J, i[c + 2] = (b * Je >> ke) * J) : i[c] = i[c + 1] = i[c + 2] = 0, C -= p, A -= B, b -= f, m -= Z, p -= Ve.r, B -= Ve.g, f -= Ve.b, Z -= Ve.a, a = d + ((a = g + t + 1) < L ? a : L) << 2, y += Ve.r = i[a], W += Ve.g = i[a + 1], V += Ve.b = i[a + 2], w += Ve.a = i[a + 3], C += y, A += W, b += V, m += w, Ve = Ve.next, p += v = He.r, B += H = He.g, f += x = He.b, Z += J = He.a, y -= v, W -= H, V -= x, w -= J, He = He.next, c += 4;
    d += n;
  }
  for (g = 0; g < n; g++) {
    for (W = V = w = y = A = b = m = C = 0, c = g << 2, p = U * (v = i[c]), B = U * (H = i[c + 1]), f = U * (x = i[c + 2]), Z = U * (J = i[c + 3]), C += O * v, A += O * H, b += O * x, m += O * J, be = $, l = 0; l < U; l++)
      be.r = v, be.g = H, be.b = x, be.a = J, be = be.next;
    for (I = n, l = 1; l <= t; l++)
      c = I + g << 2, C += (be.r = v = i[c]) * (K = U - l), A += (be.g = H = i[c + 1]) * K, b += (be.b = x = i[c + 2]) * K, m += (be.a = J = i[c + 3]) * K, y += v, W += H, V += x, w += J, be = be.next, l < N && (I += n);
    for (c = g, Ve = $, He = ne, o = 0; o < r; o++)
      a = c << 2, i[a + 3] = J = m * Je >> ke, J > 0 ? (J = 255 / J, i[a] = (C * Je >> ke) * J, i[a + 1] = (A * Je >> ke) * J, i[a + 2] = (b * Je >> ke) * J) : i[a] = i[a + 1] = i[a + 2] = 0, C -= p, A -= B, b -= f, m -= Z, p -= Ve.r, B -= Ve.g, f -= Ve.b, Z -= Ve.a, a = g + ((a = o + U) < N ? a : N) * n << 2, C += y += Ve.r = i[a], A += W += Ve.g = i[a + 1], b += V += Ve.b = i[a + 2], m += w += Ve.a = i[a + 3], Ve = Ve.next, p += v = He.r, B += H = He.g, f += x = He.b, Z += J = He.a, y -= v, W -= H, V -= x, w -= J, He = He.next, c += n;
  }
}
const xft = function(t) {
  var i = Math.round(this.blurRadius());
  i > 0 && Fft(t, i);
};
oe.addGetterSetter(yt, "blurRadius", 0, ft(), oe.afterSetFilter);
const Dft = function(e) {
  var t = this.brightness() * 255, i = e.data, n = i.length, r;
  for (r = 0; r < n; r += 4)
    i[r] += t, i[r + 1] += t, i[r + 2] += t;
};
oe.addGetterSetter(yt, "brightness", 0, ft(), oe.afterSetFilter);
const Jft = function(e) {
  var t = Math.pow((this.contrast() + 100) / 100, 2), i = e.data, n = i.length, r = 150, g = 150, o = 150, l;
  for (l = 0; l < n; l += 4)
    r = i[l], g = i[l + 1], o = i[l + 2], r /= 255, r -= 0.5, r *= t, r += 0.5, r *= 255, g /= 255, g -= 0.5, g *= t, g += 0.5, g *= 255, o /= 255, o -= 0.5, o *= t, o += 0.5, o *= 255, r = r < 0 ? 0 : r > 255 ? 255 : r, g = g < 0 ? 0 : g > 255 ? 255 : g, o = o < 0 ? 0 : o > 255 ? 255 : o, i[l] = r, i[l + 1] = g, i[l + 2] = o;
};
oe.addGetterSetter(yt, "contrast", 0, ft(), oe.afterSetFilter);
const Eft = function(e) {
  var t = this.embossStrength() * 10, i = this.embossWhiteLevel() * 255, n = this.embossDirection(), r = this.embossBlend(), g = 0, o = 0, l = e.data, a = e.width, I = e.height, c = a * 4, d = I;
  switch (n) {
    case "top-left":
      g = -1, o = -1;
      break;
    case "top":
      g = -1, o = 0;
      break;
    case "top-right":
      g = -1, o = 1;
      break;
    case "right":
      g = 0, o = 1;
      break;
    case "bottom-right":
      g = 1, o = 1;
      break;
    case "bottom":
      g = 1, o = 0;
      break;
    case "bottom-left":
      g = 1, o = -1;
      break;
    case "left":
      g = 0, o = -1;
      break;
    default:
      me.error("Unknown emboss direction: " + n);
  }
  do {
    var C = (d - 1) * c, A = g;
    d + A < 1 && (A = 0), d + A > I && (A = 0);
    var b = (d - 1 + A) * a * 4, m = a;
    do {
      var p = C + (m - 1) * 4, B = o;
      m + B < 1 && (B = 0), m + B > a && (B = 0);
      var f = b + (m - 1 + B) * 4, Z = l[p] - l[f], y = l[p + 1] - l[f + 1], W = l[p + 2] - l[f + 2], V = Z, w = V > 0 ? V : -V, v = y > 0 ? y : -y, H = W > 0 ? W : -W;
      if (v > w && (V = y), H > w && (V = W), V *= t, r) {
        var x = l[p] + V, J = l[p + 1] + V, K = l[p + 2] + V;
        l[p] = x > 255 ? 255 : x < 0 ? 0 : x, l[p + 1] = J > 255 ? 255 : J < 0 ? 0 : J, l[p + 2] = K > 255 ? 255 : K < 0 ? 0 : K;
      } else {
        var M = i - V;
        M < 0 ? M = 0 : M > 255 && (M = 255), l[p] = l[p + 1] = l[p + 2] = M;
      }
    } while (--m);
  } while (--d);
};
oe.addGetterSetter(yt, "embossStrength", 0.5, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "embossWhiteLevel", 0.5, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "embossDirection", "top-left", null, oe.afterSetFilter);
oe.addGetterSetter(yt, "embossBlend", !1, null, oe.afterSetFilter);
function TY(e, t, i, n, r) {
  var g = i - t, o = r - n, l;
  return g === 0 ? n + o / 2 : o === 0 ? n : (l = (e - t) / g, l = o * l + n, l);
}
const Nft = function(e) {
  var t = e.data, i = t.length, n = t[0], r = n, g, o = t[1], l = o, a, I = t[2], c = I, d, C, A = this.enhance();
  if (A !== 0) {
    for (C = 0; C < i; C += 4)
      g = t[C + 0], g < n ? n = g : g > r && (r = g), a = t[C + 1], a < o ? o = a : a > l && (l = a), d = t[C + 2], d < I ? I = d : d > c && (c = d);
    r === n && (r = 255, n = 0), l === o && (l = 255, o = 0), c === I && (c = 255, I = 0);
    var b, m, p, B, f, Z, y, W, V;
    for (A > 0 ? (m = r + A * (255 - r), p = n - A * (n - 0), f = l + A * (255 - l), Z = o - A * (o - 0), W = c + A * (255 - c), V = I - A * (I - 0)) : (b = (r + n) * 0.5, m = r + A * (r - b), p = n + A * (n - b), B = (l + o) * 0.5, f = l + A * (l - B), Z = o + A * (o - B), y = (c + I) * 0.5, W = c + A * (c - y), V = I + A * (I - y)), C = 0; C < i; C += 4)
      t[C + 0] = TY(t[C + 0], n, r, p, m), t[C + 1] = TY(t[C + 1], o, l, Z, f), t[C + 2] = TY(t[C + 2], I, c, V, W);
  }
};
oe.addGetterSetter(yt, "enhance", 0, ft(), oe.afterSetFilter);
const Lft = function(e) {
  var t = e.data, i = t.length, n, r;
  for (n = 0; n < i; n += 4)
    r = 0.34 * t[n] + 0.5 * t[n + 1] + 0.16 * t[n + 2], t[n] = r, t[n + 1] = r, t[n + 2] = r;
};
oe.addGetterSetter(yt, "hue", 0, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "saturation", 0, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "luminance", 0, ft(), oe.afterSetFilter);
const Kft = function(e) {
  var t = e.data, i = t.length, n = 1, r = Math.pow(2, this.saturation()), g = Math.abs(this.hue() + 360) % 360, o = this.luminance() * 127, l, a = n * r * Math.cos(g * Math.PI / 180), I = n * r * Math.sin(g * Math.PI / 180), c = 0.299 * n + 0.701 * a + 0.167 * I, d = 0.587 * n - 0.587 * a + 0.33 * I, C = 0.114 * n - 0.114 * a - 0.497 * I, A = 0.299 * n - 0.299 * a - 0.328 * I, b = 0.587 * n + 0.413 * a + 0.035 * I, m = 0.114 * n - 0.114 * a + 0.293 * I, p = 0.299 * n - 0.3 * a + 1.25 * I, B = 0.587 * n - 0.586 * a - 1.05 * I, f = 0.114 * n + 0.886 * a - 0.2 * I, Z, y, W, V;
  for (l = 0; l < i; l += 4)
    Z = t[l + 0], y = t[l + 1], W = t[l + 2], V = t[l + 3], t[l + 0] = c * Z + d * y + C * W + o, t[l + 1] = A * Z + b * y + m * W + o, t[l + 2] = p * Z + B * y + f * W + o, t[l + 3] = V;
}, Tft = function(e) {
  var t = e.data, i = t.length, n = Math.pow(2, this.value()), r = Math.pow(2, this.saturation()), g = Math.abs(this.hue() + 360) % 360, o, l = n * r * Math.cos(g * Math.PI / 180), a = n * r * Math.sin(g * Math.PI / 180), I = 0.299 * n + 0.701 * l + 0.167 * a, c = 0.587 * n - 0.587 * l + 0.33 * a, d = 0.114 * n - 0.114 * l - 0.497 * a, C = 0.299 * n - 0.299 * l - 0.328 * a, A = 0.587 * n + 0.413 * l + 0.035 * a, b = 0.114 * n - 0.114 * l + 0.293 * a, m = 0.299 * n - 0.3 * l + 1.25 * a, p = 0.587 * n - 0.586 * l - 1.05 * a, B = 0.114 * n + 0.886 * l - 0.2 * a, f, Z, y, W;
  for (o = 0; o < i; o += 4)
    f = t[o + 0], Z = t[o + 1], y = t[o + 2], W = t[o + 3], t[o + 0] = I * f + c * Z + d * y, t[o + 1] = C * f + A * Z + b * y, t[o + 2] = m * f + p * Z + B * y, t[o + 3] = W;
};
oe.addGetterSetter(yt, "hue", 0, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "saturation", 0, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "value", 0, ft(), oe.afterSetFilter);
const Mft = function(e) {
  var t = e.data, i = t.length, n;
  for (n = 0; n < i; n += 4)
    t[n] = 255 - t[n], t[n + 1] = 255 - t[n + 1], t[n + 2] = 255 - t[n + 2];
};
var Pft = function(e, t, i) {
  var n = e.data, r = t.data, g = e.width, o = e.height, l = i.polarCenterX || g / 2, a = i.polarCenterY || o / 2, I, c, d, C = 0, A = 0, b = 0, m = 0, p, B = Math.sqrt(l * l + a * a);
  c = g - l, d = o - a, p = Math.sqrt(c * c + d * d), B = p > B ? p : B;
  var f = o, Z = g, y, W, V = 360 / Z * Math.PI / 180, w, v;
  for (W = 0; W < Z; W += 1)
    for (w = Math.sin(W * V), v = Math.cos(W * V), y = 0; y < f; y += 1)
      c = Math.floor(l + B * y / f * v), d = Math.floor(a + B * y / f * w), I = (d * g + c) * 4, C = n[I + 0], A = n[I + 1], b = n[I + 2], m = n[I + 3], I = (W + y * g) * 4, r[I + 0] = C, r[I + 1] = A, r[I + 2] = b, r[I + 3] = m;
}, Uft = function(e, t, i) {
  var n = e.data, r = t.data, g = e.width, o = e.height, l = i.polarCenterX || g / 2, a = i.polarCenterY || o / 2, I, c, d, C, A, b = 0, m = 0, p = 0, B = 0, f, Z = Math.sqrt(l * l + a * a);
  c = g - l, d = o - a, f = Math.sqrt(c * c + d * d), Z = f > Z ? f : Z;
  var y = o, W = g, V, w, v = 0, H, x;
  for (c = 0; c < g; c += 1)
    for (d = 0; d < o; d += 1)
      C = c - l, A = d - a, V = Math.sqrt(C * C + A * A) * y / Z, w = (Math.atan2(A, C) * 180 / Math.PI + 360 + v) % 360, w = w * W / 360, H = Math.floor(w), x = Math.floor(V), I = (x * g + H) * 4, b = n[I + 0], m = n[I + 1], p = n[I + 2], B = n[I + 3], I = (d * g + c) * 4, r[I + 0] = b, r[I + 1] = m, r[I + 2] = p, r[I + 3] = B;
};
const zft = function(e) {
  var t = e.width, i = e.height, n, r, g, o, l, a, I, c, d, C, A = Math.round(this.kaleidoscopePower()), b = Math.round(this.kaleidoscopeAngle()), m = Math.floor(t * (b % 360) / 360);
  if (!(A < 1)) {
    var p = me.createCanvasElement();
    p.width = t, p.height = i;
    var B = p.getContext("2d").getImageData(0, 0, t, i);
    me.releaseCanvas(p), Pft(e, B, {
      polarCenterX: t / 2,
      polarCenterY: i / 2
    });
    for (var f = t / Math.pow(2, A); f <= 8; )
      f = f * 2, A -= 1;
    f = Math.ceil(f);
    var Z = f, y = 0, W = Z, V = 1;
    for (m + f > t && (y = Z, W = 0, V = -1), r = 0; r < i; r += 1)
      for (n = y; n !== W; n += V)
        g = Math.round(n + m) % t, d = (t * r + g) * 4, l = B.data[d + 0], a = B.data[d + 1], I = B.data[d + 2], c = B.data[d + 3], C = (t * r + n) * 4, B.data[C + 0] = l, B.data[C + 1] = a, B.data[C + 2] = I, B.data[C + 3] = c;
    for (r = 0; r < i; r += 1)
      for (Z = Math.floor(f), o = 0; o < A; o += 1) {
        for (n = 0; n < Z + 1; n += 1)
          d = (t * r + n) * 4, l = B.data[d + 0], a = B.data[d + 1], I = B.data[d + 2], c = B.data[d + 3], C = (t * r + Z * 2 - n - 1) * 4, B.data[C + 0] = l, B.data[C + 1] = a, B.data[C + 2] = I, B.data[C + 3] = c;
        Z *= 2;
      }
    Uft(B, e, { polarRotation: 0 });
  }
};
oe.addGetterSetter(yt, "kaleidoscopePower", 2, ft(), oe.afterSetFilter);
oe.addGetterSetter(yt, "kaleidoscopeAngle", 0, ft(), oe.afterSetFilter);
function dS(e, t, i) {
  var n = (i * e.width + t) * 4, r = [];
  return r.push(e.data[n++], e.data[n++], e.data[n++], e.data[n++]), r;
}
function lB(e, t) {
  return Math.sqrt(Math.pow(e[0] - t[0], 2) + Math.pow(e[1] - t[1], 2) + Math.pow(e[2] - t[2], 2));
}
function Oft(e) {
  for (var t = [0, 0, 0], i = 0; i < e.length; i++)
    t[0] += e[i][0], t[1] += e[i][1], t[2] += e[i][2];
  return t[0] /= e.length, t[1] /= e.length, t[2] /= e.length, t;
}
function Qft(e, t) {
  var i = dS(e, 0, 0), n = dS(e, e.width - 1, 0), r = dS(e, 0, e.height - 1), g = dS(e, e.width - 1, e.height - 1), o = t || 10;
  if (lB(i, n) < o && lB(n, g) < o && lB(g, r) < o && lB(r, i) < o) {
    for (var l = Oft([n, i, g, r]), a = [], I = 0; I < e.width * e.height; I++) {
      var c = lB(l, [
        e.data[I * 4],
        e.data[I * 4 + 1],
        e.data[I * 4 + 2]
      ]);
      a[I] = c < o ? 0 : 255;
    }
    return a;
  }
}
function jft(e, t) {
  for (var i = 0; i < e.width * e.height; i++)
    e.data[4 * i + 3] = t[i];
}
function qft(e, t, i) {
  for (var n = [1, 1, 1, 1, 0, 1, 1, 1, 1], r = Math.round(Math.sqrt(n.length)), g = Math.floor(r / 2), o = [], l = 0; l < i; l++)
    for (var a = 0; a < t; a++) {
      for (var I = l * t + a, c = 0, d = 0; d < r; d++)
        for (var C = 0; C < r; C++) {
          var A = l + d - g, b = a + C - g;
          if (A >= 0 && A < i && b >= 0 && b < t) {
            var m = A * t + b, p = n[d * r + C];
            c += e[m] * p;
          }
        }
      o[I] = c === 255 * 8 ? 255 : 0;
    }
  return o;
}
function _ft(e, t, i) {
  for (var n = [1, 1, 1, 1, 1, 1, 1, 1, 1], r = Math.round(Math.sqrt(n.length)), g = Math.floor(r / 2), o = [], l = 0; l < i; l++)
    for (var a = 0; a < t; a++) {
      for (var I = l * t + a, c = 0, d = 0; d < r; d++)
        for (var C = 0; C < r; C++) {
          var A = l + d - g, b = a + C - g;
          if (A >= 0 && A < i && b >= 0 && b < t) {
            var m = A * t + b, p = n[d * r + C];
            c += e[m] * p;
          }
        }
      o[I] = c >= 255 * 4 ? 255 : 0;
    }
  return o;
}
function $ft(e, t, i) {
  for (var n = [0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111, 0.1111111111111111], r = Math.round(Math.sqrt(n.length)), g = Math.floor(r / 2), o = [], l = 0; l < i; l++)
    for (var a = 0; a < t; a++) {
      for (var I = l * t + a, c = 0, d = 0; d < r; d++)
        for (var C = 0; C < r; C++) {
          var A = l + d - g, b = a + C - g;
          if (A >= 0 && A < i && b >= 0 && b < t) {
            var m = A * t + b, p = n[d * r + C];
            c += e[m] * p;
          }
        }
      o[I] = c;
    }
  return o;
}
const eZt = function(e) {
  var t = this.threshold(), i = Qft(e, t);
  return i && (i = qft(i, e.width, e.height), i = _ft(i, e.width, e.height), i = $ft(i, e.width, e.height), jft(e, i)), e;
};
oe.addGetterSetter(yt, "threshold", 0, ft(), oe.afterSetFilter);
const tZt = function(e) {
  var t = this.noise() * 255, i = e.data, n = i.length, r = t / 2, g;
  for (g = 0; g < n; g += 4)
    i[g + 0] += r - 2 * r * Math.random(), i[g + 1] += r - 2 * r * Math.random(), i[g + 2] += r - 2 * r * Math.random();
};
oe.addGetterSetter(yt, "noise", 0.2, ft(), oe.afterSetFilter);
const iZt = function(e) {
  var t = Math.ceil(this.pixelSize()), i = e.width, n = e.height, r, g, o, l, a, I, c, d = Math.ceil(i / t), C = Math.ceil(n / t), A, b, m, p, B, f, Z, y = e.data;
  if (t <= 0) {
    me.error("pixelSize value can not be <= 0");
    return;
  }
  for (B = 0; B < d; B += 1)
    for (f = 0; f < C; f += 1) {
      for (l = 0, a = 0, I = 0, c = 0, A = B * t, b = A + t, m = f * t, p = m + t, Z = 0, r = A; r < b; r += 1)
        if (!(r >= i))
          for (g = m; g < p; g += 1)
            g >= n || (o = (i * g + r) * 4, l += y[o + 0], a += y[o + 1], I += y[o + 2], c += y[o + 3], Z += 1);
      for (l = l / Z, a = a / Z, I = I / Z, c = c / Z, r = A; r < b; r += 1)
        if (!(r >= i))
          for (g = m; g < p; g += 1)
            g >= n || (o = (i * g + r) * 4, y[o + 0] = l, y[o + 1] = a, y[o + 2] = I, y[o + 3] = c);
    }
};
oe.addGetterSetter(yt, "pixelSize", 8, ft(), oe.afterSetFilter);
const nZt = function(e) {
  var t = Math.round(this.levels() * 254) + 1, i = e.data, n = i.length, r = 255 / t, g;
  for (g = 0; g < n; g += 1)
    i[g] = Math.floor(i[g] / r) * r;
};
oe.addGetterSetter(yt, "levels", 0.5, ft(), oe.afterSetFilter);
const rZt = function(e) {
  var t = e.data, i = t.length, n = this.red(), r = this.green(), g = this.blue(), o, l;
  for (o = 0; o < i; o += 4)
    l = (0.34 * t[o] + 0.5 * t[o + 1] + 0.16 * t[o + 2]) / 255, t[o] = l * n, t[o + 1] = l * r, t[o + 2] = l * g, t[o + 3] = t[o + 3];
};
oe.addGetterSetter(yt, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
oe.addGetterSetter(yt, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
oe.addGetterSetter(yt, "blue", 0, G_, oe.afterSetFilter);
const gZt = function(e) {
  var t = e.data, i = t.length, n = this.red(), r = this.green(), g = this.blue(), o = this.alpha(), l, a;
  for (l = 0; l < i; l += 4)
    a = 1 - o, t[l] = n * o + t[l] * a, t[l + 1] = r * o + t[l + 1] * a, t[l + 2] = g * o + t[l + 2] * a;
};
oe.addGetterSetter(yt, "red", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
oe.addGetterSetter(yt, "green", 0, function(e) {
  return this._filterUpToDate = !1, e > 255 ? 255 : e < 0 ? 0 : Math.round(e);
});
oe.addGetterSetter(yt, "blue", 0, G_, oe.afterSetFilter);
oe.addGetterSetter(yt, "alpha", 1, function(e) {
  return this._filterUpToDate = !1, e > 1 ? 1 : e < 0 ? 0 : e;
});
const oZt = function(e) {
  var t = e.data, i = t.length, n, r, g, o;
  for (n = 0; n < i; n += 4)
    r = t[n + 0], g = t[n + 1], o = t[n + 2], t[n + 0] = Math.min(255, r * 0.393 + g * 0.769 + o * 0.189), t[n + 1] = Math.min(255, r * 0.349 + g * 0.686 + o * 0.168), t[n + 2] = Math.min(255, r * 0.272 + g * 0.534 + o * 0.131);
}, lZt = function(e) {
  var t = e.data, i = e.width, n = e.height, r = i * 4, g = n;
  do {
    var o = (g - 1) * r, l = i;
    do {
      var a = o + (l - 1) * 4, I = t[a], c = t[a + 1], d = t[a + 2];
      I > 127 && (I = 255 - I), c > 127 && (c = 255 - c), d > 127 && (d = 255 - d), t[a] = I, t[a + 1] = c, t[a + 2] = d;
    } while (--l);
  } while (--g);
}, aZt = function(e) {
  var t = this.threshold() * 255, i = e.data, n = i.length, r;
  for (r = 0; r < n; r += 1)
    i[r] = i[r] < t ? 0 : 255;
};
oe.addGetterSetter(yt, "threshold", 0.5, ft(), oe.afterSetFilter);
const PZ = xM.Util._assign(xM, {
  Arc: Hc,
  Arrow: wA,
  Circle: Lm,
  Ellipse: pu,
  Image: JI,
  Label: nE,
  Tag: vA,
  Line: kc,
  Path: kn,
  Rect: MZ,
  RegularPolygon: RA,
  Ring: XA,
  Sprite: EI,
  Star: Bu,
  Text: sr,
  TextPath: eg,
  Transformer: Gn,
  Wedge: Yc,
  Filters: {
    Blur: xft,
    Brighten: Dft,
    Contrast: Jft,
    Emboss: Eft,
    Enhance: Nft,
    Grayscale: Lft,
    HSL: Kft,
    HSV: Tft,
    Invert: Mft,
    Kaleidoscope: zft,
    Mask: eZt,
    Noise: tZt,
    Pixelate: iZt,
    Posterize: nZt,
    RGB: rZt,
    RGBA: gZt,
    Sepia: oZt,
    Solarize: lZt,
    Threshold: aZt
  }
});
function rE(e, t) {
  return t.findOne((i) => i.attrs.name === e);
}
const sZt = (e, t, i) => {
  const n = q9();
  let r = e ?? (n ? 256 : 1024), g = t ?? (n ? 256 : 1024);
  const o = Math.min(r, g);
  if (o < 200) {
    const I = Math.ceil(200 / o);
    r *= I, g *= I;
  }
  const l = 2048, a = Math.max(r, g);
  if (a > l) {
    const I = a / l;
    r /= I, g /= I;
  }
  try {
    const I = new PZ.Stage({
      container: i,
      width: r,
      height: g,
      scale: {
        x: 1,
        y: 1
      }
    });
    return I.listening(!1), I;
  } catch {
    throw new Error("Print-Designer Error: Out-of-memory in Safari?");
  }
}, PM = "print-layer", UM = "print-image", zM = "original-image", OM = "background";
function IZt(e) {
  var i;
  let t = (i = e == null ? void 0 : e.getLayers()) == null ? void 0 : i.find((n) => n.attrs.name === PM);
  if (!t) {
    t = new PZ.Layer({
      name: PM,
      imageSmoothingEnabled: !0
    });
    {
      const n = t.getCanvas(), r = Math.min(1.5, n.getPixelRatio());
      n.setPixelRatio(r);
    }
    e.add(t);
  }
  return t.listening(!1), t;
}
function QM(e, t, i) {
  return i < 0 ? t * (i / 100) : i > 100 ? Math.abs(e - t) + t * (i - 100) / 100 : Math.abs(e - t) * (i / 100);
}
function cZt(e, t, i, n, r, g, o) {
  const l = i / e, a = n / t, I = Math.min(l, a), c = Math.abs(Math.round(e * I * (o || 1) / 100)), d = Math.abs(Math.round(c * t / e)), C = Math.round(QM(i, c, r)), A = Math.round(QM(n, d, g));
  return {
    stageWidth: i,
    stageHeight: n,
    x: C,
    y: A,
    newImageWidth: c,
    newImageHeight: d
  };
}
function dZt(e, t, i, n) {
  const r = i.width(), g = i.height();
  return cZt(e, t, r, g, n.leftright, n.topbottom, n.scale);
}
function uZt(e, t, i, n) {
  if (t != null && t.color) {
    const r = rE(OM, e);
    if (r)
      r.fill("#" + t.color.getHexString());
    else {
      const g = new PZ.Rect({
        name: OM,
        x: 0,
        y: 0,
        width: i,
        height: n,
        fill: "#" + t.color.getHexString(),
        listening: !1
      });
      e.add(g);
    }
  }
}
function CZt(e, t, i, n) {
  if (!t.map)
    return;
  const r = rE(zM, e);
  if (r)
    r.attrs.uuid !== t.map.image.uuid && r.image(t.map.image), r.width(i), r.height(n);
  else {
    const g = new PZ.Image({
      name: zM,
      image: t.map.image,
      uuid: t.map.image.uuid,
      x: 0,
      y: 0,
      width: i,
      height: n
    });
    e.add(g);
  }
}
function AZt(e, t, i, n, r, g, o) {
  const l = rE(UM, e), a = i / o.width, I = n / o.height;
  if (l && l.attrs.url === t.materialUrl)
    l.scaleX(a), l.scaleY(I), l.x(r), l.y(g);
  else {
    l && l.destroy();
    const c = new PZ.Image({
      name: UM,
      url: t.materialUrl,
      image: o,
      x: r,
      y: g,
      width: o.width,
      height: o.height,
      scaleX: a,
      scaleY: I,
      draggable: !1,
      perfectDrawEnabled: !1
    });
    e.add(c);
  }
}
const bZt = (e, t, i, n) => {
  var d;
  const r = IZt(e), {
    stageWidth: g,
    stageHeight: o,
    x: l,
    y: a,
    newImageWidth: I,
    newImageHeight: c
  } = dZt(t.width, t.height, e, i);
  uZt(r, n, g, o), (d = n == null ? void 0 : n.map) != null && d.image && !i.hideOriginalMapWhenPrinting && CZt(r, n, g, o), AZt(r, i, I, c, l, a, t), r.draw(), e.draw();
};
function hZt(e, t) {
  return (e.selections ?? []).every((i) => (t.selectionScope[i.variableId] ?? []).find((n) => n.id === i.id));
}
function mZt(e, t) {
  return e.reduce((n, r) => {
    const g = de.intersection(t.selections, r.selections).length;
    return g > n.maxIntersectionCount ? {
      maxIntersectionCount: g,
      action: r
    } : n;
  }, {
    maxIntersectionCount: -1,
    action: e[0]
  }).action;
}
function pZt(e, t) {
  return e.modelIds && e.modelIds.length ? e.modelIds.includes(t.modelId) : !0;
}
function gE(e, t, i) {
  let n = e.filter((o) => hZt(t, o) && pZt(o, t));
  const r = Object.values(de.groupBy(n, i));
  return r.some((o) => o.length > 1) && (n = r.map((o) => o.length === 1 ? o[0] : mZt(o, t))), n;
}
function BZt(e, t, i, n, r, g) {
  lt(() => {
    (async () => {
      const l = g ? await fZt(t, i, n, r) : i;
      e(l);
    })();
  }, [t, i, r, g, n, e]);
}
async function fZt(e, t, i, n) {
  if (!n)
    return Promise.resolve(t);
  const r = gE(i, n, (l) => l.targetMaterial), g = Object.values(t);
  return await Promise.all(r.map(async (l) => {
    const a = g.find((c) => c.name === l.targetMaterial);
    return a ? await GZt(n, e[l.targetMaterial], a, l) : Promise.resolve(void 0);
  }, [])).then((l) => l.reduce((a, I) => ({
    ...a,
    ...I ?? {}
  }), {}) ?? {});
}
const LC = /* @__PURE__ */ new Map(), B5 = "konvaRoot", ZZt = () => {
  const e = document.getElementById(B5);
  return e == null ? void 0 : e.childNodes;
};
async function GZt(e, t, i, n) {
  var g, o, l, a;
  const r = i;
  if (n && n.materialUrl && r) {
    const I = new Image();
    I.crossOrigin = "anonymous", I.src = l1(n.materialUrl), await I.decode();
    const c = `imageAction:${e.unique}-${i.name}`;
    let d = document.getElementById(B5);
    d || (d = document.createElement("div"), d.id = B5, document.body.appendChild(d));
    let C = document.getElementById(c);
    if (!C) {
      C = document.createElement("div"), C.id = c, C.style.display = "none", C.dataset.materialName = i.name, C.dataset.modelId = e.modelId.toString(), d.appendChild(C);
      const f = LC.get(c);
      f && (LC.delete(c), f.destroy());
    }
    let A = LC.get(c);
    A || (A = sZt(((g = t.map) == null ? void 0 : g.image.width) ?? I.width, ((o = t.map) == null ? void 0 : o.image.height) ?? I.height, C), LC.set(c, A)), bZt(A, I, n, r);
    const b = new ir.MeshStandardMaterial({}).copy(i), m = (l = C.firstElementChild) == null ? void 0 : l.firstElementChild, p = new ir.CanvasTexture(m, ir.UVMapping);
    return p.flipY = !1, p.colorSpace = (a = i.map) != null && a.colorSpace ? i.map.colorSpace : "srgb", b.color = new ir.Color(1, 1, 1), b.map = p, p.needsUpdate = !0, b.needsUpdate = !0, {
      [i.name]: b
    };
  }
}
const yZt = (e) => (e == null ? void 0 : e.isGlobalChange) === !0 && (e == null ? void 0 : e.replacementMaterialId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0, MY = (e) => (e == null ? void 0 : e.targetModelId) !== void 0 && (e == null ? void 0 : e.replacementMaterialId) !== void 0 && (e == null ? void 0 : e.targetMaterialName) !== void 0;
function WZt(e, t) {
  var r, g;
  const i = (r = e.props.textures) == null ? void 0 : r.find((o) => o.uuid === t), n = (g = e.props.images) == null ? void 0 : g.find((o) => o.uuid === i.image);
  return {
    texture: i,
    image: n
  };
}
const qh = {
  cache: /* @__PURE__ */ new Map(),
  appId: void 0
};
function SZt(e) {
  qh.appId !== e.appId && (qh.cache.clear(), qh.appId = e.appId);
}
function VZt(e) {
  return e.search(/\.jpe?g($|\?)/i) > 0 || e.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : e.search(/\.webp($|\?)/i) > 0 || e.search(/^data\:image\/webp/) === 0 ? "image/webp" : e.search(/\.ktx2($|\?)/i) > 0 || e.search(/^data\:image\/ktx2/) === 0 ? "image/ktx2" : "image/png";
}
async function wZt(e) {
  const t = new ir.MaterialLoader(), i = new ir.TextureLoader(), n = new ir.ObjectLoader();
  SZt(e);
  const r = de.pick(e.props, ["alphaMap", "aoMap", "bumpMap", "clearcoatMap", "clearcoatNormalMap", "clearcoatRoughnessMap", "sheenRoughnessMap", "sheenColorMap", "displacementMap", "emissiveMap", "envMap", "lightMap", "map", "metalnessMap", "normalMap", "specularIntensityMap", "specularColorMap", "roughnessMap", "thicknessMap", "transmissionMap"]), g = de.omit(e.props, Object.keys(r));
  g.userData = {
    ...g.userData,
    arFallbackId: e.arFallbackId
  };
  const o = t.parse(g);
  return de.isEmpty(r) || await Promise.all(de.map(r, async (l, a) => {
    const {
      texture: I,
      image: c
    } = WZt(e, l);
    if (c.url) {
      const d = qh.cache.has(c.url) ? qh.cache.get(c.url) : await i.loadAsync(l1(c.url)).then((C) => (C.userData.mimeType = VZt(c.url), qh.cache.set(c.url, C), C)).catch(() => {
        console.warn(`Could not load texture: ${a} for material ${e.name} with id ${e.id}!`);
      });
      if (!d)
        return Promise.resolve();
      I.userData = {
        ...I.userData,
        mimeType: d.userData.mimeType
      }, o[a] = n.parseTextures([I], {
        [I.image]: d.source
        // @ts-ignore
      })[I.uuid];
    }
    return Promise.resolve();
  })), o;
}
function vZt(e, t, i, n, r) {
  const g = An(Object.values(i)), o = Le.indexBy((I) => I.name, Object.values(r)), a = (t ? gE(
    // We have to prefilter the materialActions to only include the ones that
    // actually refer to the current model or are global anyway. Color- and
    // PrintActions do not work like that currently.
    n.filter((I) => MY(I) ? I.targetModelId === e : !0),
    t,
    (I) => I.targetMaterialName
  ) : n).reduce((I, c) => {
    var b, m;
    const d = c.targetMaterialName && o[c.targetMaterialName];
    if (!d || !c.replacementMaterialId)
      return I;
    let C = !1;
    if (MY(c) && c.targetModelId === e) {
      const p = (b = I[d.name]) == null ? void 0 : b.materialAction;
      MY(p) || (C = !0);
    }
    yZt(c) && ((m = I[d.name]) != null && m.materialAction || (C = !0));
    const A = g[c.replacementMaterialId];
    return A ? C ? {
      ...I,
      [d.name]: {
        materialAction: c,
        targetMeshMaterial: d,
        replacementMaterial: A
      }
    } : I : (console.warn(`Replacement material with id ${c.replacementMaterialId} not found!`), I);
  }, {});
  return Object.values(a);
}
async function RZt(e, t, i = {}, n, r = []) {
  const g = vZt(e, t, n, r, i);
  return (await Promise.all(g.map(async (l) => {
    const a = l.targetMeshMaterial, I = wI({
      props: {
        name: a.name
      }
    })(l.replacementMaterial), c = await wZt(I);
    return {
      [a.name]: c
    };
  }))).reduce((l, a) => ({
    ...l,
    ...a
  }), {});
}
function XZt(e, t, i, n, r, g) {
  lt(() => {
    (async () => {
      const o = t ? await RZt(t, i, e, n, r) : e;
      g({
        ...e,
        ...o
      });
    })();
  }, [i, e, r, n, g, t]);
}
function HZt(e, t, i) {
  const n = {}, r = i ? gE(t, i, (g) => g.targetMaterial) : t;
  return t && r.reduce((g, o) => {
    const l = e[o.targetMaterial];
    if (!l)
      return g;
    const a = new ir.Color(o.hex), I = l.clone();
    return I.color = a, I.needsUpdate = !0, g[l.name] = I, g;
  }, n), n;
}
function kZt(e, t, i) {
  return Oe(() => HZt(e, t, i), [t, i, e]);
}
const YZt = [];
function t$(e, t, i) {
  const n = Oe(() => e.reduce((p, B) => (p[B.name] = B, p), {}), [e]), r = ie($v), g = ie(b6), o = ie(C6), l = ie(A6), [a, I] = wt({}), [c, d] = wt({});
  XZt(n, t, i, r, g, I);
  const C = Oe(() => ({
    ...n,
    ...a
  }), [n, a]), A = kZt(C, o, i), b = Oe(() => ({
    ...n,
    ...a,
    ...A
  }), [n, a, A]);
  return BZt(d, n, b, l, i, t), {
    materials: {
      ...n,
      ...a,
      ...A,
      ...c
    },
    printAreas: YZt
  };
}
function oE(e, t, i, n) {
  const {
    materials: r
  } = t$(t, e, n);
  return Object.values(r).forEach((g) => {
    g.needsUpdate = !0;
  }), r;
}
const FZt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfUAAAFCCAYAAADoh0TcAAAKp2lDQ1BJQ0MgUHJvZmlsZQAASImVlwdQU+kWgP9700NCCyAgJfQmXSCAQEIPoPRqIyQhhBJCIICInUUFVhQRKTaQRREFV6WIHVFsi6IiWBdkEVHWxYKoqLwLDMHdN++9eWfmzP/dc89//nP+uWfmXADIsiyhMBGWBSBJkCYK8nKlRkRGUXFDAAOUAR4sAEYsdqqQERDgBxCZXf8uHx8AaGq9ZzoV69/f/1eR43BT2QBAAQjHcFLZSQifQnSELRSlAYA6gNh1MtKEU9yOsIIISRDh3inmzfDIFMdMMxpM+4QEuSGsAACexGKJeACQqIidms7mIXFIdIQtBBy+AGEhws5JSckchI8jbIj4IDbSVHxazA9xeH+LGSOJyWLxJDxTy7Tg3fmpwkTWqv/zOv63JCWKZ8/QR5QUJ/IOmqoZubPehGRfCQtilvjPMp8z7T/NcWLv0Flmp7pFzTKH5e4r2Zu4xG+WY/meTEmcNGbILHNTPYJnWZQcJDkrVuTGmGWWaO5ccUKoxB7HZUriZ8WFhM9yOj9sySynJgT7zvm4SewicZAkf67Ay3XuXE9J7UmpP9TLZ0r2psWFeEtqZ83lzxUw5mKmRkhy43DdPeZ8QiX+wjRXyVnCxACJPzfRS2JPTQ+W7E1DPsi5vQGSO4xn+QTMMmCAYBCKKBUEAFdgBeyAXRo3M22qELdk4SoRnxeXRmUgHcalMgVsswVUKwsrawCm+nXmc3jfO92HkBJ+zpZQBoAdkh/kPGfjXATgDNLxMlvmbPrZAJCrAWjjscWi9BnbdC9hABHIIBmqAA2gAwyBKZKZLXAEdOABfIA/CAGRYAVggziQBEQgA2SDDSAX5IPtYBcoB/vBQXAYHAMnQDM4Cy6Bq+AmuAO6wWPQBwbBazAKPoIJCIJwEBmiQCqQJqQHmUBWEA1yhjwgPygIioSiIR4kgMRQNrQJyoeKoHKoEqqFfoVOQ5eg61AX9BDqh4ahd9AXGAWTYAVYHdaHzWEazIB94RB4OcyDU+AsOAfeBpfCVfBRuAm+BN+Eu+E++DU8hgIoKZQSSgtliqKh3FD+qChULEqEWovKQ5WgqlD1qFZUB+oeqg81gvqMxqIpaCraFO2I9kaHotnoFPRadAG6HH0Y3YRuR99D96NH0d8xZIwaxgTjgGFiIjA8TAYmF1OCqcE0Yq5gujGDmI9YLFYJa4C1w3pjI7Hx2NXYAuxebAP2IrYLO4Adw+FwKjgTnBPOH8fCpeFycWW4o7gLuLu4QdwnvBReE2+F98RH4QX4jfgS/BH8efxd/BB+giBL0CM4EPwJHMIqQiGhmtBKuE0YJEwQ5YgGRCdiCDGeuIFYSqwnXiE+Ib6XkpLSlrKXCpTiS62XKpU6LnVNql/qM0meZExyIy0jiUnbSIdIF0kPSe/JZLI+mU6OIqeRt5FryZfJz8ifpCnSZtJMaY70OukK6Sbpu9JvZAgyejIMmRUyWTIlMidlbsuMyBJk9WXdZFmya2UrZE/L9siOyVHkLOX85ZLkCuSOyF2XeymPk9eX95DnyOfIH5S/LD9AQVF0KG4UNmUTpZpyhTKogFUwUGAqxCvkKxxT6FQYVZRXXKgYppipWKF4TrFPCaWkr8RUSlQqVDqh9EDpyzz1eYx53Hlb59XPuztvXHm+Ml2Zq5yn3KDcrfxFharioZKgskOlWeWpKlrVWDVQNUN1n+oV1ZH5CvMd57Pn580/Mf+RGqxmrBaktlrtoNottTF1DXUvdaF6mfpl9RENJQ26RrxGscZ5jWFNiqazJl+zWPOC5iuqIpVBTaSWUtupo1pqWt5aYq1KrU6tCW0D7VDtjdoN2k91iDo0nVidYp02nVFdTd3Futm6dbqP9Ah6NL04vd16HXrj+gb64fqb9Zv1XxooGzANsgzqDJ4Ykg1dDFMMqwzvG2GNaEYJRnuN7hjDxjbGccYVxrdNYBNbE77JXpOuBZgF9gsEC6oW9JiSTBmm6aZ1pv1mSmZ+ZhvNms3emOuaR5nvMO8w/25hY5FoUW3x2FLe0sdyo2Wr5TsrYyu2VYXVfWuytaf1OusW67cLTRZyF+5b2GtDsVlss9mmzeabrZ2tyLbedthO1y7abo9dD02BFkAroF2zx9i72q+zP2v/2cHWIc3hhMNfjqaOCY5HHF8uMljEXVS9aMBJ24nlVOnU50x1jnY+4NznouXCcqlyeU7XoXPoNfQhhhEjnnGU8cbVwlXk2ug67ubgtsbtojvK3cs9z73TQ94j1KPc45mntifPs85z1MvGa7XXRW+Mt6/3Du8epjqTzaxljvrY+azxafcl+Qb7lvs+9zP2E/m1LoYX+yzeufjJEr0lgiXN/sCf6b/T/2mAQUBKwJlAbGBAYEXgiyDLoOygjmBK8MrgI8EfQ1xDCkMehxqGikPbwmTCloXVho2Hu4cXhfdFmEesibgZqRrJj2yJwkWFRdVEjS31WLpr6eAym2W5yx4sN1ieufz6CtUViSvOrZRZyVp5MhoTHR59JPory59VxRqLYcbsiRllu7F3s19z6JxizjDXiVvEHYp1ii2Kfclz4u3kDce5xJXEjfDd+OX8t/He8fvjxxP8Ew4lTCaGJzYk4ZOik04L5AUJgvZkjeTM5C6hiTBX2JfikLIrZVTkK6pJhVKXp7akKSCD0S2xofgncX+6c3pF+qeMsIyTmXKZgsxbq4xXbV01lOWZ9ctq9Gr26rZsrewN2f1rGGsq10JrY9a2rdNZl7NucL3X+sMbiBsSNvy20WJj0cYPm8I3teao56zPGfjJ66e6XOlcUW7PZsfN+7egt/C3dG613lq29XseJ+9GvkV+Sf7XAnbBjZ8tfy79eXJb7LbOQtvCfdux2wXbH+xw2XG4SK4oq2hg5+KdTcXU4rziD7tW7rpesrBk/27ibvHuvlK/0pYy3bLtZV/L48q7K1wrGvao7dm6Z3wvZ+/dffR99fvV9+fv/3KAf6C30quyqUq/quQg9mD6wRfVYdUdv9B+qa1Rrcmv+XZIcKjvcNDh9lq72tojakcK6+A6cd3w0WVH7xxzP9ZSb1pf2aDUkH8cHBcff/Vr9K8PTvieaDtJO1l/Su/UnkZKY14T1LSqabQ5rrmvJbKl67TP6bZWx9bGM2ZnDp3VOltxTvFc4Xni+ZzzkxeyLoxdFF4cucS7NNC2su3x5YjL99sD2zuv+F65dtXz6uUORseFa07Xzl53uH76Bu1G803bm023bG41/mbzW2OnbWfTbbvbLXfs77R2Leo6f9fl7qV77veu3mfev9m9pLvrQeiD3p5lPX29nN6XDxMfvn2U/mji8fonmCd5T2WfljxTe1b1u9HvDX22fef63ftvPQ9+/niAPfD6j9Q/vg7mvCC/KBnSHKp9afXy7LDn8J1XS18Nvha+nhjJ/VPuzz1vDN+c+ov+163RiNHBt6K3k+8K3qu8P/Rh4Ye2sYCxZx+TPk6M531S+XT4M+1zx5fwL0MTGV9xX0u/GX1r/e77/clk0uSkkCViTY8CKETh2FgA3h1C5oRIACh3ACAunZmnpwWa+QeYJvCfeGbmnhZbAGrWAxCGaAAdgAOI6iNMps88h9ABbG0t0dnZd3pOn55N+AAYNALIPLA7hrYe/ENmZvgf8v7nCiRR/7b+C6HRAvyEFujYAAAAVmVYSWZNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAADkoYABwAAABIAAABEoAIABAAAAAEAAAH1oAMABAAAAAEAAAFCAAAAAEFTQ0lJAAAAU2NyZWVuc2hvdORbXswAAAHWaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA2LjAuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjMyMjwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj41MDE8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpVc2VyQ29tbWVudD5TY3JlZW5zaG90PC9leGlmOlVzZXJDb21tZW50PgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4K00dYSQAAGVFJREFUeAHt3d9uZNlVB+DqSfdMo0gQuGQAIW66yq65A6Q8BeGPlFcBKSGCXPAIXMADZMhIPAZSCAkoHXKHEGHSMxIJM9zbTZen3Tltu6rOn33O2Xutr6XRlKvO2Xuvb237V6dslx99+ovPX278I0CAAAECBJoXeKf5ChRAgAABAgQI3AgIdRuBAAECBAgEERDqQRqpDAIECBAgINTtAQIECBAgEERAqAdppDIIECBAgIBQtwcIECBAgEAQAaEepJHKIECAAAECQt0eIECAAAECQQSEepBGKoMAAQIECAh1e4AAAQIECAQREOpBGqkMAgQIECAg1O0BAgQIECAQRECoB2mkMggQIECAgFC3BwgQIECAQBABoR6kkcogQIAAAQJC3R4gQIAAAQJBBIR6kEYqgwABAgQICHV7gAABAgQIBBEQ6kEaqQwCBAgQICDU7QECBAgQIBBEQKgHaaQyCBAgQICAULcHCBAgQIBAEAGhHqSRyiBAgAABAkLdHiBAgAABAkEEhHqQRiqDAAECBAgIdXuAAAECBAgEERDqQRqpDAIECBAgINTtAQIECBAgEERAqAdppDIIECBAgIBQtwcIECBAgEAQAaEepJHKIECAAAECQt0eIECAAAECQQSEepBGKoMAAQIECAh1e4AAAQIECAQREOpBGqkMAgQIECAg1O0BAgQIECAQRECoB2mkMggQIECAgFC3BwgQIECAQBABoR6kkcogQIAAAQJC3R4gQIAAAQJBBIR6kEYqgwABAgQICHV7gAABAgQIBBEQ6kEaqQwCBAgQICDU7QECBAgQIBBEQKgHaaQyCBAgQICAULcHCBAgQIBAEAGhHqSRyiBAgAABAkLdHiBAgAABAkEEHgepQxlRBV5GLUxd1Qs8qn6FFkjgnoBQv0eS9A7hmbTxyj4qUPPnhCccR9uW/QGhXuMOqPmLSY1e1kQgm8DSXyM8iWhmhwn1Ma1a+hNqzBqdQ4AAgVICS3zN88ShSLfih/oSm7FIKwxCgACBxAJzfK1O+EShzlCfo7mJP1eUToAAgZQCJbOkkScIZUO9JGDKHahoAgQIEKhSoES+LfDE4O1QL7HoKrthUQQIECBAYGWBEhl75onB402JSVZ2Mj2BpQR8uswrfebr1byTG51ACwJnvgi9faXeQkHW2JTAmf3XVC0WO7/AQ/vl888+2/zvL/7vZvJf/41fvfn/r33lK/MvpsAMnqQUQDTEIIFHn/7884c+jwYN4uA6BTS2zr5Y1cMC3fDu3n7o6EO4/+7v/c6mlXB/qIYl7vOkYgnluuYQ6iv0Q9iugG7KagS6gd29PXaBAn6sXLnzPHkoZzl1JKF+QlD4nsDxEIEeAv/5H//15qgSAf5msCM3BPwRmIbv9oRhWPNChboQHtZ8RxMoJdAN7O7tUuMPHecQ7oeX5m//P/R8x8cUyPAEoYpQF8YxP4FUFU+gG9jd2zVX6uq95u60ubaanxxMDnWB3OamtGoCpwS6gd29feqcFh4T8C10Kcca53picBPqgjnHJlIlgYcEuqHdvf3QsZHuE/CRupmvlmNPCh594lfa8u0GFacU6AZ293ZKjDtFC/g7ID5sVkCoN9s6CyfwsEA3sLu3Hz7avV2BQ7j7AbuuiNutCQj11jpmvQReC9wN7Lsfg5om4Op9mp+z1xEQ6uu4m5XAIIFuYHdvDxrEwaMFBPxoOicuLCDUFwY3HYFTAt3A7t4+dY7HlhUQ8Mt6m22YgFAf5uVoAkUEuoHdvV1kcIMsInAI98M/70G/CLdJegoI9Z5QDiMwVqAb2t3bY8dzXn0Ct1fvh5X5IzP19SfTioR6pm6rdVaBbmB3b886qcGrE7gNeOFeXWtSLEiop2izIksKdAO7e7vkHMaKISDgY/SxpSqEekvdstZFBe4Gdvcvji26EJOFEBDwIdpYfRFCvfoWWeASAt0A795eYm5z5BI4hPvhnx+wy9X3paoV6ktJm6cKgW5gd29XsTiLSCdwe/V+KNz34NO1f5aChfosrAZdW6Ab2N3ba6/L/ASOCdwGvHA/JuT+PgJCvY+SY6oW6H6vW4BX3SqL6ykg4HtCOeyewON797iDQKUC3cDu3q50uZZFYJDAp5/+bPPJi49vznnx4pPNJ5/8bPPn3/iLzXZ3MWgcB+cWEOq5+19l9d3A7t6ucrEWRWCEwEMB/tAwAv0hFfedEhDqp3Q8NqtAN7C7t2ed1OAEFhboG+ALL8t0QQWEetDG1lZWN7S7t2tbp/UQmCIgwKfoObeEgFAvoWiMNwLdwO7efnOAGwSCCAjwII0MVoZQD9bQpcrpBnb39lLzm4fAkgICfEltc00REOpT9BKcezew736cgECJyQQEeLKGBytXqAdr6NRybn/nW3hPlXR+CwI1B/h2t22B0BorExDqlTVkzeX85PmPNn/3t3+/+f0//OrmN9//rTWXYm4CxQW6Af7DH/6g+PgGJFCDgFCvoQsVreHjj3+6+fgff7p5//3fFu4V9cVShgkI8GFejo4jINTj9LJoJcK9KKfBZhQQ4DPiGro5AaHeXMvmW/Bu/8G9wYX7PRJ3rCjwb//6zzez376N6opLMTWBKgWEepVtqW9Rwr2+nkRfkQCP3mH1zSEg1OdQDTymcA/c3BVLE+D38bcXu/t3uofAGQGhfgbIww8LCPeHXdx7XkCAnzdyBIGxAkJ9rJzzbgSEu41wTKD7A2y+B35Myf0EygoI9bKeaUcT7mlbf1O4AM/df9XXIyDU6+lFFSu53O83P37+fPRabsP98AY2f/DqP//iCQjweD1VURwBoR6nl1VV8v3v/dPm8J9wr6otgxcjwAeTFTvB28QWo0w1kFBP1e7lixXuy5uPnVGAj5VzHoF6BIR6Pb0IvRLhXld7BXhd/bAaAqUEhHopSeP0EjiE+4uP/9v7yvfSKnOQAC/jaBQCLQgI9Ra6tOAaL/aXk35Qrs9Sb3+Yzh+N6aM17BgBPszL0QSiCQj1aB1tqB7hPq1Z3QD3p0SnWTqbQBQBoR6lkw3XIdzPN0+AnzeKdsR2dxGtJPUsICDUF0A2RT8B4f6FkwDvt18cRYDAfQGhft/EPSsLZAr32/dBP5B7CX3ljWd6AgEEhHqAJkYtIVq43wa490GPumPVRWB9AaG+fg+qWsHl/mLz3apWtNm0GO4CvLJNZDkEkggI9SSNjlBmreEuwCPsLjUQiCEg1GP0MVUVa4V79wfYvISeasstXqz3fV+cPMyEQj1MK/MVchvuc/zRGAGebz+pmEAEAaEeoYvJa5j6vvICPPkGUj6BQAJCPVAzs5fSJ9wFePZdon4CsQWEeuz+Dq5ut/9g8Dm1ndAN93ff/WKL+x54bV2yHgIE5hAQ6nOoGrMKgR/8y/c27z19WsVaLIIAAQJLCLyzxCTmIECAAIH+AtuLXf+DHUmgIyDUOxhuxhK4vrqKVZBqCBAgcEZAqJ8B8jABAgQIEGhFQKi30qkF13m53y84m6kIECBAoJSAUC8laRwCBAgQILCygFBfuQGmJ0CAwF0BbxN7V8THfQWEel8pxxEgQIAAgcoFhHrlDbI8AgQIECDQV0Co95VyHAECBAgQqFxAqFfeoDWWd7G/XGNacxIgQIDARAGhPhHQ6QQIECBAoBYBoV5LJ6xjFgHvKjcLq0FnFtjuLmaewfBRBYR61M6qiwABAgTSCQj1dC1XMAECBAhEFRDqUTurLgIECBBIJyDU07X8fMGXe9/PO6/kCAIECNQnINTr64kVESBAgACBUQJCfRSbkwgQIDCPgPd9n8c1y6hCPUun1UmAAAEC4QWEevgWK5AAAQIEsggI9SydHlDnbv/BgKMdSoAAAQK1CAj1WjphHbMIXF9fzzKuQQkQIFCjgFCvsSvWRIAAAQIERggI9RFoTiFAgMBcAtuL3VxDGzeBgFBP0GQlEiBAgEAOAaGeo8+qJECAAIEEAkI9QZPHlHi53485zTkECBAgsKKAUF8R39QECBAgQKCkgFAvqWksAgQITBTwNrETAZOfLtSTbwDlEyBAgEAcAaEep5cqIUCAAIHkAkI9+QY4Vv7F/vLYQ+4nQIAAgUoFhHqljbGsMgJXV1dlBjIKAQIEGhAQ6g00yRIJECBAgEAfgcd9DnJMBIGXA4sYevzA4R1OgMARgcPn3pTPv0dHxnV3BgGhXnWXp3xiV12YxREgcERgu7s48kjfu0t+3fAEoa96LccJ9Vk6UfKTapYFGpQAAQI9BEp9LfPkoAd2kUN8T/0o42Ezj/3v6KDNPHDpp9+b6ZWFEqhfYOzX0lJPKuoXKrXCBFfqNkWpzWIcAgQILC8w9mt4zlcHGgr1sY1dfguakQABAgTWFhibGW0/GVgx1MeCr71RzE+AAIF5BLzv+zyuw0Ydmk11PQkoGOpDIYYxO5rAGIFrbz4zhs05BAj0FhiaffM+CTgR6kMX2lvAgQQIECBAIKnA0Gwd9iTgVagPnSBpH5KVvdvvk1WsXAIECNQoMCSjH238SluNPbQmAgQIECAwWOClUB9s5gQCBAgQIFCpgCv1ShtjWQQI5BPYXuzyFa3iogJCvSinwQgQIECAwHoCQn09++pn9lax1bfIAgkQIPCWgFB/i8MHBAgQIECgXQGh3m7vrJwAAQIECLwlINTf4vABAQIE1hPY7p6tN7mZQwgI9RBtVMQpAW8Ve0rHYwQIRBIQ6pG6qRYCBAgQSC0g1FO3/3TxF/vL0wd4lAABAgSqEhDqVbXDYggQIECAwHgBoT7ezpkECBAgQKAqAaFeVTsshgABAgQIjBcQ6uPtnEmAAIGiAtvdRdHxDJZPQKjn67mKCRAgQCCogFAP2tgSZXnv9xKKxiBAgMByAkJ9OWszrSRwfX290symJUCAwLICQn1Zb7MRIECAAIHZBIT6bLQGJkCAQH+B7W7b/2BHEjgiINSPwLibAAECBAi0JiDUW+vYguvd7fcLzmYqAgQIEJgqINSnCjqfAAECBAhUIiDUK2mEZRAgQIAAgakCQn2qoPMJECBAgEAlAkK9kkZYBgECBAgQmCog1KcKOp8AAQIFBLYXuwKjGCK7gFDPvgPO1O+tYs8AeZgAAQIVCTyuaC2WsoDAy4FzDD1+4PCLHH51dbV5/OTJInOZhMAUgSmfb4+mTOzcMAJCvZFWTvlkb6REyyRAYIJAqa8RnhxMaEIFpwr1BZtQ6pNuwSWbigCBZAJTvk55QrD+ZhHqA3swZcMPnMrhBAgkEni2e9Z8tVO+PnpCUKb9qX9Q7rABh/5Xhr2dUS72l+0s1koJEGhWYOjX4ilPIJpF6rHwUFfqmtyj4w4hQIBAEIGhX/MzvBpQdagPbViQfaoMAgQIEJhBYGimtPgkYPFQH4o6Q18NSYAAAQIEzgoMyatangAUC/UhxZ+VdAABAgQIEGhIoG8Gzh3+J0O97yIbcrdUAgQIVCmw3V1UuS6LKiswJFfHPAF45zDBsf/KlmK0FgUivE3s9at3lPOPAAECrQkcy+bu/XdrOnmlfvdgHxMgQIAAAQL1CBwCvvsv9e+pdyHcJkCAAAECrQsI9dY7aP0ECBAgQOC1gFC3FQgQILCywHa3XXkFpo8iINSjdFIdBAgQIJBeQKin3wKnAXb7/ekDPEqAAAEC1QgI9WpaYSEECBAgQGCagFCf5udsAgQIECBQjYBQr6YVFkKAAAECBKYJCPVpfs5uRMC7yjXSKMskQGCSgFCfxJfj5Iv9ZY5CVUlgJYHtxW6lmU0bTUCoR+uoeggQIEAgrYBQT9t6hRMgQIBANAGhHq2j6iFAgACBtAJCPW3rFU6AAAEC0QSEerSOqocAgeYEnu2eNbdmC65TQKjX2ZeqVuWn36tqh8UQIEDgqIBQP0rjAQIECBAg0JaAUG+rX1ZLgAABAgSOCgj1ozQeiCRwfX0dqRy1ECBA4EGBxw/e604CBAgQmFXga3/6xzfj/9GffPH/WSczeBoBoZ6m1QolQGBtAUG+dgfizy/U4/d4coWXr977/aPJoxiAQD6B7W67Obyv+7PtF//PJ6DipQWE+tLi5iNAILSAq/HQ7a2+OKFefYsskACBmgVcjdfcnXxrE+r5eq5iAgQmCrganwjo9NkEhPpstAYmQCCSgCCP1M24tQj1uL0tVtluvy82loEItCLgZfVWOmWdXQGh3tVwmwCB1AKuxlO3P0TxQj1EGxVBgMAYAVfjY9ScU7OAUK+5O9ZWTODq6mrz+MmTYuMZqF0BV+Pt9s7Kzws8evHzz16eP8wR2QV+8vz55q++8a1mGd750pc27z192uz6LXyagCCf5ufsdgSEeju9Wn2lh2D/7nf+YfPvz3+8+lqGLkCoDxVr+3gvq7fdP6sfLyDUx9ulPfOj73y4+ehVuLf0T6i31K1xa/3a6z+MMvgPpDwaN5+zCNQoINRr7EoDa2rt5Xih3sCmGrjE7ev3U392eH/13W7g2Qse7knDgtimEur2wC8FBv50xc3L8R+28XK8UP9lm1u+NfpqvOWiu2v3BKGr4fYDAkL9AZQm7xoYyCVr/OjD+l+OF+olO77sWOmDvCS3JwUlNascy6+01daWFcN5LMWfff3rN6e29n32sfU6b16BZl5Wn5dhntGnfH3xhGCenhQe1ZV6YdA3w0355HkzSFs3an453pV63XvJ1Xjd/Rm9Ok8ERtONPVGo95VLGNJ9ae4e99ff/Msqf+3tV7785btL9fFKAq7GV4JvYVpPBCZ1KXeoC+pJm+fUyTV+n12on+rY/I+5Gp/fON0MngDca3m8UBfU95q81h03v/b2zW+tNf29eYX6PZLZ7xDksxOboK9AkicAbYS6oO67bas8rpaX44X6/NvDy+rzG5thZoHGw3/9UBfYM+/QOoav4eV4oT7PXnA1Po+rUSsXqDT85wt1YV35jlx+eWu/HC/Uy/Tc1XgZR6MkEVg4/MeFusBOshvLl7nmr70J9fH9dDU+3s6ZBM4KFAz++6EusM/6O2C6wBovxwv1YX0T5MO8HE1gNoEBof94I8Rn64OBjwt4F7rjNms9cvuy+uC/crbWgs1LIItAn5x+HfyPXvzPZ30Oz0KnzoUFlnw53pX6/ea6Gr9v4h4CLQsI9Za7F2jtS7wcL9Q3m9ur8er/XGmgva0UAksK+IMuS2qb66jAEi/HX19dbQ7vAZ/tn6vxbB1Xb2YBV+qZu19h7XO+HP/e06dpQl2QV7i5LYnAAgJCfQFkUwwXmONd6CKH+u3L6n7IbfhecwaBSAJCPVI3g9VS+vvs0ULd1XiwDa8cAgUEhHoBREPMJ1DyXehaD/Xbq3E/5DbffjMygdYFhHrrHUyy/hIvx7cY6q7Gk2xwZRIoJCDUC0EaZn6BqS/HtxLqgnz+vWQGAlEFhHrUzgata8rL8bWG+u3L6n7ILeimVRaBBQWE+oLYpiojMPbX3moKdVfjZfaCUQgQeFtAqL/t4aOGBIa+HP/k3Xc3j588WaXC26txP+S2Cr9JCaQR8I5yaVodr9Al3oVuipqr8Sl6ziVAYIyAK/Uxas6pSqDvy/FLXKkfgtzVeFXbw2IIpBIQ6qnaHbvYc7/2NkeouxqPvadUR6A1AaHeWses96TAqe+zlwp1QX6yBR4kQGBFAaG+Ir6p5xE49nL82FD3Q27z9MmoBAiUFxDq5U2NWInA3Zfjh4S6q/FKmmgZBAgMEhDqg7gc3JpA9+X4c6Huh9xa6671EiBwV0Co3xXxcTiB23ehuxvqrsbDtVpBBNILCPX0WyAPwN98+9ubi8v9TcHekjVP31VKIJOAUM/UbbUSIECAQGiBd0JXpzgCBAgQIJBIQKgnarZSCRAgQCC2gFCP3V/VESBAgEAiAaGeqNlKJUCAAIHYAkI9dn9VR4AAAQKJBIR6omYrlQABAgRiCwj12P1VHQECBAgkEhDqiZqtVAIECBCILSDUY/dXdQQIECCQSECoJ2q2UgkQIEAgtoBQj91f1REgQIBAIgGhnqjZSiVAgACB2AJCPXZ/VUeAAAECiQSEeqJmK5UAAQIEYgsI9dj9VR0BAgQIJBIQ6omarVQCBAgQiC0g1GP3V3UECBAgkEhAqCdqtlIJECBAILaAUI/dX9URIECAQCIBoZ6o2UolQIAAgdgCQj12f1VHgAABAokEhHqiZiuVAAECBGILCPXY/VUdAQIECCQSEOqJmq1UAgQIEIgtINRj91d1BAgQIJBIQKgnarZSCRAgQCC2gFCP3V/VESBAgEAiAaGeqNlKJUCAAIHYAkI9dn9VR4AAAQKJBIR6omYrlQABAgRiCwj12P1VHQECBAgkEhDqiZqtVAIECBCILSDUY/dXdQQIECCQSECoJ2q2UgkQIEAgtoBQj91f1REgQIBAIgGhnqjZSiVAgACB2AJCPXZ/VUeAAAECiQSEeqJmK5UAAQIEYgsI9dj9VR0BAgQIJBIQ6omarVQCBAgQiC0g1GP3V3UECBAgkEhAqCdqtlIJECBAILaAUI/dX9URIECAQCIBoZ6o2UolQIAAgdgCQj12f1VHgAABAokEhHqiZiuVAAECBGILCPXY/VUdAQIECCQSEOqJmq1UAgQIEIgtINRj91d1BAgQIJBIQKgnarZSCRAgQCC2gFCP3V/VESBAgEAiAaGeqNlKJUCAAIHYAkI9dn9VR4AAAQKJBP4fk7kMJIq7fKQAAAAASUVORK5CYII=", i$ = ({
  children: e,
  ...t
}) => /* @__PURE__ */ S(Ct, { ...t, color: "text.secondary", sx: {
  mb: 0
}, children: e });
var lE = {}, xZt = yg;
Object.defineProperty(lE, "__esModule", {
  value: !0
});
var n$ = lE.default = void 0, DZt = xZt(oo()), JZt = ro;
n$ = lE.default = (0, DZt.default)(/* @__PURE__ */ (0, JZt.jsx)("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");
var aE = {}, EZt = yg;
Object.defineProperty(aE, "__esModule", {
  value: !0
});
var r$ = aE.default = void 0, NZt = EZt(oo()), LZt = ro;
r$ = aE.default = (0, NZt.default)(/* @__PURE__ */ (0, LZt.jsx)("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
}), "Folder");
const KZt = ({
  label: e,
  onDelete: t,
  Icon: i
}) => /* @__PURE__ */ Ie(Dpe, { secondaryAction: t && /* @__PURE__ */ S(Ni, { "data-cy": "deleteListItem", edge: "end", onClick: t, children: /* @__PURE__ */ S(n$, {}) }), children: [
  /* @__PURE__ */ S(Kpe, { children: /* @__PURE__ */ S(bbe, { children: i || /* @__PURE__ */ S(r$, {}) }) }),
  /* @__PURE__ */ S(Sj, { primary: e })
] }), TZt = ({
  entities: e,
  name: t,
  editable: i = !0,
  onChange: n,
  onCreate: r,
  onDelete: g,
  getLabel: o,
  buttonLabel: l,
  placeholder: a,
  errors: I,
  Icon: c
}) => /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 1, children: [
  i && /* @__PURE__ */ Ie(pi, { direction: "row", spacing: 2, sx: {
    width: 1,
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ S(al, { "data-cy": "addListItem", fullWidth: !0, value: t, onChange: n, placeholder: a, TextFieldProps: {
      error: I !== void 0 && I.length > 0,
      helperText: I == null ? void 0 : I.join(", ")
    } }),
    /* @__PURE__ */ S(fn, { "data-cy": "addListItemButton", sx: {
      maxHeight: "56px"
    }, onClick: () => r(), disabled: t === "" || I !== void 0, variant: "contained", children: l })
  ] }),
  /* @__PURE__ */ S(jV, { children: e.map((d) => {
    const C = o(d);
    return /* @__PURE__ */ S(KZt, { label: C, onDelete: i ? () => g(d) : void 0, Icon: c }, C);
  }) })
] }), f5 = (e) => async (t, i) => (t(Qct(e)), Q9("model", e, {
  lang: Er(i())
})), MZt = ({
  model: e,
  editable: t = !0
}) => {
  const {
    t: i
  } = Gi(), n = Ei(), [r, g] = wt(""), [o, l] = wt(void 0), a = Gt((d) => {
    var C;
    g(d), (C = e == null ? void 0 : e.materials) != null && C.find((A) => A.toLowerCase() === d.toLowerCase()) ? l([i("Dieses Material existiert bereits")]) : l(void 0);
  }, [e, i]), I = Gt(() => {
    e && n(f5({
      ...e,
      materials: [...e.materials ?? [], r]
    })), g("");
  }, [r, e, n]), c = Gt((d) => {
    e && n(f5({
      ...e,
      materials: (e.materials ?? []).filter((C) => C !== d)
    }));
  }, [e, n]);
  return /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ S(i$, { children: i("Materialien") }),
    /* @__PURE__ */ S(TZt, { name: r, editable: t, entities: (e == null ? void 0 : e.materials) ?? [], onChange: a, onCreate: I, onDelete: c, getLabel: de.identity, buttonLabel: i("Material hinzufügen"), placeholder: i("Materialname eingeben"), errors: o, Icon: /* @__PURE__ */ S(EAt, {}) })
  ] });
}, ha = {
  input: {
    width: "33%"
  },
  x: {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px"
  },
  y: {
    borderRadius: 0
  },
  z: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px"
  }
}, ch = (e) => AA(e) && "expression" in e ? e.expression ?? "" : String(e);
function nf({
  label: e,
  inputLabels: t = ["X", "Y", "Z"],
  placeholders: i = ["X", "Y", "Z"],
  defaultValues: n,
  onChange: r,
  sx: g,
  debounced: o = !1,
  expression: l = !1,
  anchoringSelections: a = [Ut]
}) {
  const [I, c] = wt([n ? n[0] : "0", n ? n[1] : "0", n ? n[2] : "0"]), d = Gt((...m) => {
    c((p) => {
      const B = p.map((f, Z) => m[Z] || f || "0");
      return r && r(B), B;
    });
  }, [r]), C = (m) => d({
    expression: m
  }, I[1], I[2]), A = (m) => d(I[0], {
    expression: m
  }, I[2]), b = (m) => d(I[0], I[1], {
    expression: m
  });
  return /* @__PURE__ */ Ie(ht, { component: "div", sx: g, children: [
    /* @__PURE__ */ S(Ct, { color: "text.secondary", sx: {
      mb: 0
    }, children: e }),
    /* @__PURE__ */ S(ht, { component: "div", display: "flex", children: l ? /* @__PURE__ */ Ie(li, { children: [
      /* @__PURE__ */ S(hg, { label: "X", sx: {
        ...ha.input,
        ...ha.x
      }, value: ch(I[0]), onChange: C, anchoringSelections: a }),
      /* @__PURE__ */ S(hg, { label: "Y", sx: {
        ...ha.input,
        ...ha.y
      }, value: ch(I[1]), onChange: A, anchoringSelections: a }),
      /* @__PURE__ */ S(hg, { label: "Z", sx: {
        ...ha.input,
        ...ha.z
      }, value: ch(I[2]), onChange: b, anchoringSelections: a })
    ] }) : /* @__PURE__ */ Ie(li, { children: [
      /* @__PURE__ */ S(ht, { component: "div", sx: ha.input, children: /* @__PURE__ */ S(al, { "data-cy": "vectorX", debounced: o, value: ch(I[0]), onChange: C, type: "number", placeholder: i[0], label: t[0], TextFieldProps: {
        InputProps: {
          sx: ha.x
        },
        inputProps: {
          step: "0.1"
        }
      } }) }),
      /* @__PURE__ */ S(ht, { component: "div", sx: ha.input, children: /* @__PURE__ */ S(al, { "data-cy": "vectorY", debounced: o, value: ch(I[1]), onChange: A, type: "number", placeholder: i[1], label: t[1], TextFieldProps: {
        InputProps: {
          sx: ha.y
        },
        inputProps: {
          step: "0.1"
        }
      } }) }),
      /* @__PURE__ */ S(ht, { component: "div", sx: ha.input, children: /* @__PURE__ */ S(al, { "data-cy": "vectorZ", debounced: o, value: ch(I[2]), onChange: b, type: "number", placeholder: i[2], label: t[2], TextFieldProps: {
        InputProps: {
          sx: ha.z
        },
        inputProps: {
          step: "0.1"
        }
      } }) })
    ] }) })
  ] });
}
const Km = ({
  modelActionRuleItemValue: e,
  model: t,
  onChange: i,
  ruleItem: n,
  ruleColumnId: r
}) => {
  const {
    t: g
  } = Gi(), o = (d, C) => {
    var A, b, m;
    return (A = e == null ? void 0 : e.props) != null && A[d] ? (b = e.props) == null ? void 0 : b[d] : t && "props" in t && ((m = t.props) != null && m[d]) ? t.props[d] : C || [0, 0, 0];
  }, l = o("position"), a = o("rotation"), I = o("scale", [1, 1, 1]), c = ie(mA(n == null ? void 0 : n.id, r));
  return /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ S(nf, { debounced: !0, defaultValues: l, label: g("Position"), onChange: i("position"), expression: !0, anchoringSelections: c }),
    /* @__PURE__ */ S(nf, { debounced: !0, defaultValues: a, label: g("Rotation (in radiant)"), onChange: i("rotation"), expression: !0, anchoringSelections: c }),
    /* @__PURE__ */ S(nf, { debounced: !0, defaultValues: I, label: g("Scale"), onChange: i("scale"), expression: !0, anchoringSelections: c })
  ] });
}, PZt = ({
  widthExpression: e,
  heightExpression: t,
  depthExpression: i,
  expressionChange: n,
  ruleItem: r,
  ruleColumnId: g
}) => {
  const {
    t: o
  } = Gi(), l = ie(mA(r == null ? void 0 : r.id, g));
  return /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 2, children: [
    /* @__PURE__ */ S(i$, { children: o("Abmessungen") }),
    /* @__PURE__ */ S(hg, { value: e.expression, onChange: n("width"), label: o("Breite"), anchoringSelections: l }),
    /* @__PURE__ */ S(hg, { value: t.expression, onChange: n("height"), label: o("Höhe"), anchoringSelections: l }),
    /* @__PURE__ */ S(hg, { value: i.expression, onChange: n("depth"), label: o("Tiefe"), anchoringSelections: l })
  ] });
}, UZt = ({
  modelActionRuleItemValue: e,
  model: t,
  onChange: i,
  widthExpression: n,
  heightExpression: r,
  depthExpression: g,
  expressionChange: o,
  ruleItem: l,
  ruleColumnId: a
}) => /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 4, children: [
  /* @__PURE__ */ S(Km, { modelActionRuleItemValue: e, model: t, onChange: i, ruleItem: l, ruleColumnId: a }),
  /* @__PURE__ */ S(PZt, { widthExpression: n, heightExpression: r, depthExpression: g, expressionChange: o, ruleItem: l, ruleColumnId: a })
] }), g$ = ({
  dynamicModelProps: e,
  expressionChange: t,
  model: i,
  modelActionRuleItemValue: n,
  onChange: r,
  ruleItem: g,
  ruleColumnId: o,
  materialsAreEditable: l = !1,
  extraFields: a
}) => /* @__PURE__ */ Ie(pi, { direction: "column", spacing: 4, children: [
  /* @__PURE__ */ S(UZt, { modelActionRuleItemValue: n, model: i, onChange: r, widthExpression: e.width, heightExpression: e.height, depthExpression: e.depth, expressionChange: t, ruleItem: g, ruleColumnId: o }),
  a,
  /* @__PURE__ */ S(MZt, { model: i, editable: l })
] }), zZt = (e, t, i) => {
  const n = e.clone().sub(t), r = [];
  return Math.abs(n.x) > i && r.push("x"), Math.abs(n.y) > i && r.push("y"), Math.abs(n.z) > i && r.push("z"), r;
}, OZt = (e) => (t, i) => (n, r, g) => {
  const o = g || (n === "rotation" ? 0.05 : 1e-4), l = zZt(new ye(...t[n] || [0, 0, 0]), new ye(...r), o);
  if (!l.length)
    return e === "expression" ? i[n] : t[n];
  const a = e === "expression" ? [{
    expression: "0"
  }, {
    expression: "0"
  }, {
    expression: "0"
  }] : [0, 0, 0], I = e === "expression" ? [...i[n] || a] : [...t[n] || a];
  return "xyz".split("").forEach((c, d) => {
    l.includes(c) && (I[d] = e === "expression" ? {
      expression: r[d].toString()
    } : r[d]);
  }), I;
}, Sc = (e) => (t, i) => (n, r) => {
  const g = OZt(e)(t, i);
  return {
    ...e === "number" ? t : i,
    position: g("position", n),
    rotation: g("rotation", r)
  };
}, QZt = (e) => {
  var n;
  const {
    t
  } = Gi(), i = ie(mA((n = e.ruleItem) == null ? void 0 : n.id, e.ruleColumnId));
  return /* @__PURE__ */ S(g$, { ...e, materialsAreEditable: !0, extraFields: /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(hg, { value: e.dynamicModelProps.radius.expression, onChange: e.expressionChange("radius"), label: t("Eckenrundung"), anchoringSelections: i }),
    /* @__PURE__ */ S(hg, { value: e.dynamicModelProps.segmentCount.expression, onChange: e.expressionChange("segmentCount"), label: t("Anzahl der Eckenrundungsschritte"), anchoringSelections: i })
  ] }) });
}, jZt = (e) => {
  var g;
  const t = e.id, i = ie(e1(t)), n = Oe(() => {
    var o;
    return ((o = i.materials) == null ? void 0 : o.map((l) => new o2({
      name: l,
      color: "grey"
    }))) ?? [];
  }, [i.materials]), r = oE(t, n, [], e.modelAction);
  return /* @__PURE__ */ S(woe, { args: [e.width, e.height, e.depth], rotation: e.rotation, scale: e.scale, position: e.position, name: e.name, matrixWorldAutoUpdate: void 0, getObjectsByProperty: void 0, getVertexPosition: void 0, userData: {
    modelId: t
  }, material: (g = Object.values(r)) == null ? void 0 : g[0], radius: e.radius, smoothness: e.segmentCount || 1, steps: e.segmentCount || 1 });
}, qZt = {
  type: "box",
  label: "Box",
  disabledForAR: !1,
  component: jZt,
  propsDialog: QZt,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    },
    radius: {
      expression: "0"
    },
    segmentCount: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: Sc,
  screenshot: FZt
};
function _Zt(e) {
  const t = (n) => n;
  return {
    ...{
      extendAdditionalGroups: t,
      extendAdditionalVars: t,
      extendGroupLabel: t,
      extendGroupPanel: t,
      extendHeader: t,
      extendVariableLabel: t,
      components: {
        select: (n) => (r) => /* @__PURE__ */ S(n, { ...r })
      }
    },
    ...e
  };
}
const $Zt = de.memoize(_Zt), sE = (e, t = "") => Object.keys(e).reduce((i, n) => {
  const r = t.length ? `${t}.` : "";
  return typeof e[n] == "object" && e[n] !== null && Object.keys(e[n]).length > 0 ? Object.assign(i, sE(e[n], r + n)) : i[r + n] = e[n], i;
}, {}), Fs = De.createContext({}), a$t = (e) => ({
  extensions: t,
  ...i
}) => {
  const n = $Zt(t);
  return /* @__PURE__ */ S(Fs.Provider, { value: n, children: /* @__PURE__ */ S(e, { ...i, extensions: t }) });
}, eGt = (e, t) => Le.flow(sE, XJ((i, n, r) => {
  const g = Le.flow(Le.split("."), Le.last)(r);
  return Le.set(["components", g], n, i);
}, {}), Le.merge(e))(t), gr = (e) => {
  const t = Le.flow(sE, Le.keys)(e), i = Le.filter(Le.endsWith("root"), t);
  if (i.length > 1)
    throw new Error("There should only be one root HOC!");
  const n = Le.first(i), r = Le.reject(Le.endsWith("root"), t);
  return o$(n, r);
}, Fo = (e) => o$(`components.${e}`, []), o$ = (e, t) => (i) => De.forwardRef((n, r) => {
  const g = Vn(Fs), o = Le.get(e, g), l = Oe(() => o ? o(i) : i, [o]), a = Oe(() => Le.pick(t, g), [g]), I = Oe(() => {
    let c;
    return Le.isEmpty(a) ? De.forwardRef((d, C) => /* @__PURE__ */ S(l, { ...d, ref: C })) : (c = eGt(g, a), De.forwardRef((d, C) => /* @__PURE__ */ S(Fs.Provider, { value: c, children: /* @__PURE__ */ S(l, { ...d, ref: C }) })));
  }, [l, a, g]);
  return /* @__PURE__ */ S(I, { ...n, ref: r });
}), tGt = (e) => (t) => (i) => {
  const n = Vn(Fs), r = Oe(() => {
    var o;
    const g = (o = n == null ? void 0 : n.dynamicModels) == null ? void 0 : o[e];
    return g ? g(t) : t;
  }, [n]);
  return /* @__PURE__ */ S(r, { ...i });
}, iGt = "data:image/png;base64,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", nGt = (e) => /* @__PURE__ */ S(g$, { ...e, materialsAreEditable: !0 }), rGt = (e) => {
  const t = e.id, i = Oe(() => new o2({
    name: "surface",
    color: "blue",
    wireframe: !0
  }), []);
  return /* @__PURE__ */ S(voe, { args: [e.width, e.height, e.depth], rotation: e.rotation, scale: e.scale, position: e.position, userData: {
    modelId: t
  }, material: i, name: e.name });
}, l$ = "dummy", gGt = tGt(l$)(rGt), oGt = {
  type: l$,
  label: "Dummy",
  disabledForAR: !1,
  component: gGt,
  propsDialog: nGt,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    }
  },
  materials: ["surface"],
  repositionApplicator: Sc,
  screenshot: iGt
};
var lGt = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, ac = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, ug = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = Math.pow(10, t)), Math.round(i * e) / i + 0;
}, va = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = 1), e > i ? i : e > t ? e : t;
}, a$ = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, jM = function(e) {
  return { r: va(e.r, 0, 255), g: va(e.g, 0, 255), b: va(e.b, 0, 255), a: va(e.a) };
}, PY = function(e) {
  return { r: ug(e.r), g: ug(e.g), b: ug(e.b), a: ug(e.a, 3) };
}, aGt = /^#([0-9a-f]{3,8})$/i, uS = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, s$ = function(e) {
  var t = e.r, i = e.g, n = e.b, r = e.a, g = Math.max(t, i, n), o = g - Math.min(t, i, n), l = o ? g === t ? (i - n) / o : g === i ? 2 + (n - t) / o : 4 + (t - i) / o : 0;
  return { h: 60 * (l < 0 ? l + 6 : l), s: g ? o / g * 100 : 0, v: g / 255 * 100, a: r };
}, I$ = function(e) {
  var t = e.h, i = e.s, n = e.v, r = e.a;
  t = t / 360 * 6, i /= 100, n /= 100;
  var g = Math.floor(t), o = n * (1 - i), l = n * (1 - (t - g) * i), a = n * (1 - (1 - t + g) * i), I = g % 6;
  return { r: 255 * [n, l, o, o, a, n][I], g: 255 * [a, n, n, l, o, o][I], b: 255 * [o, o, a, n, n, l][I], a: r };
}, qM = function(e) {
  return { h: a$(e.h), s: va(e.s, 0, 100), l: va(e.l, 0, 100), a: va(e.a) };
}, _M = function(e) {
  return { h: ug(e.h), s: ug(e.s), l: ug(e.l), a: ug(e.a, 3) };
}, $M = function(e) {
  return I$((i = (t = e).s, { h: t.h, s: (i *= ((n = t.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * i / (n + i) * 100 : 0, v: n + i, a: t.a }));
  var t, i, n;
}, rf = function(e) {
  return { h: (t = s$(e)).h, s: (r = (200 - (i = t.s)) * (n = t.v) / 100) > 0 && r < 200 ? i * n / 100 / (r <= 100 ? r : 200 - r) * 100 : 0, l: r / 2, a: t.a };
  var t, i, n, r;
}, sGt = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, IGt = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, cGt = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, dGt = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Z5 = { string: [[function(e) {
  var t = aGt.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? ug(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? ug(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = cGt.exec(e) || dGt.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : jM({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = sGt.exec(e) || IGt.exec(e);
  if (!t)
    return null;
  var i, n, r = qM({ h: (i = t[1], n = t[2], n === void 0 && (n = "deg"), Number(i) * (lGt[n] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return $M(r);
}, "hsl"]], object: [[function(e) {
  var t = e.r, i = e.g, n = e.b, r = e.a, g = r === void 0 ? 1 : r;
  return ac(t) && ac(i) && ac(n) ? jM({ r: Number(t), g: Number(i), b: Number(n), a: Number(g) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, i = e.s, n = e.l, r = e.a, g = r === void 0 ? 1 : r;
  if (!ac(t) || !ac(i) || !ac(n))
    return null;
  var o = qM({ h: Number(t), s: Number(i), l: Number(n), a: Number(g) });
  return $M(o);
}, "hsl"], [function(e) {
  var t = e.h, i = e.s, n = e.v, r = e.a, g = r === void 0 ? 1 : r;
  if (!ac(t) || !ac(i) || !ac(n))
    return null;
  var o = function(l) {
    return { h: a$(l.h), s: va(l.s, 0, 100), v: va(l.v, 0, 100), a: va(l.a) };
  }({ h: Number(t), s: Number(i), v: Number(n), a: Number(g) });
  return I$(o);
}, "hsv"]] }, eP = function(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i][0](e);
    if (n)
      return [n, t[i][1]];
  }
  return [null, void 0];
}, uGt = function(e) {
  return typeof e == "string" ? eP(e.trim(), Z5.string) : typeof e == "object" && e !== null ? eP(e, Z5.object) : [null, void 0];
}, UY = function(e, t) {
  var i = rf(e);
  return { h: i.h, s: va(i.s + 100 * t, 0, 100), l: i.l, a: i.a };
}, zY = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, tP = function(e, t) {
  var i = rf(e);
  return { h: i.h, s: i.s, l: va(i.l + 100 * t, 0, 100), a: i.a };
}, Sw = function() {
  function e(t) {
    this.parsed = uGt(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return ug(zY(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return zY(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return zY(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = PY(this.rgba), i = t.r, n = t.g, r = t.b, o = (g = t.a) < 1 ? uS(ug(255 * g)) : "", "#" + uS(i) + uS(n) + uS(r) + o;
    var t, i, n, r, g, o;
  }, e.prototype.toRgb = function() {
    return PY(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = PY(this.rgba), i = t.r, n = t.g, r = t.b, (g = t.a) < 1 ? "rgba(" + i + ", " + n + ", " + r + ", " + g + ")" : "rgb(" + i + ", " + n + ", " + r + ")";
    var t, i, n, r, g;
  }, e.prototype.toHsl = function() {
    return _M(rf(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = _M(rf(this.rgba)), i = t.h, n = t.s, r = t.l, (g = t.a) < 1 ? "hsla(" + i + ", " + n + "%, " + r + "%, " + g + ")" : "hsl(" + i + ", " + n + "%, " + r + "%)";
    var t, i, n, r, g;
  }, e.prototype.toHsv = function() {
    return t = s$(this.rgba), { h: ug(t.h), s: ug(t.s), v: ug(t.v), a: ug(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return dg({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), dg(UY(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), dg(UY(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return dg(UY(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), dg(tP(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), dg(tP(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? dg({ r: (i = this.rgba).r, g: i.g, b: i.b, a: t }) : ug(this.rgba.a, 3);
    var i;
  }, e.prototype.hue = function(t) {
    var i = rf(this.rgba);
    return typeof t == "number" ? dg({ h: t, s: i.s, l: i.l, a: i.a }) : ug(i.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === dg(t).toHex();
  }, e;
}(), dg = function(e) {
  return e instanceof Sw ? e : new Sw(e);
}, iP = [], c$ = function(e) {
  e.forEach(function(t) {
    iP.indexOf(t) < 0 && (t(Sw, Z5), iP.push(t));
  });
}, s$t = function() {
  return new Sw({ r: 255 * Math.random(), g: 255 * Math.random(), b: 255 * Math.random() });
};
function c1() {
  return (c1 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }).apply(this, arguments);
}
function d$(e, t) {
  if (e == null)
    return {};
  var i, n, r = {}, g = Object.keys(e);
  for (n = 0; n < g.length; n++)
    t.indexOf(i = g[n]) >= 0 || (r[i] = e[i]);
  return r;
}
function G5(e) {
  var t = ot(e), i = ot(function(n) {
    t.current && t.current(n);
  });
  return t.current = e, i.current;
}
var Mf = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = 1), e > i ? i : e < t ? t : e;
}, gf = function(e) {
  return "touches" in e;
}, y5 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, nP = function(e, t, i) {
  var n = e.getBoundingClientRect(), r = gf(t) ? function(g, o) {
    for (var l = 0; l < g.length; l++)
      if (g[l].identifier === o)
        return g[l];
    return g[0];
  }(t.touches, i) : t;
  return { left: Mf((r.pageX - (n.left + y5(e).pageXOffset)) / n.width), top: Mf((r.pageY - (n.top + y5(e).pageYOffset)) / n.height) };
}, rP = function(e) {
  !gf(e) && e.preventDefault();
}, u$ = De.memo(function(e) {
  var t = e.onMove, i = e.onKey, n = d$(e, ["onMove", "onKey"]), r = ot(null), g = G5(t), o = G5(i), l = ot(null), a = ot(!1), I = Oe(function() {
    var A = function(p) {
      rP(p), (gf(p) ? p.touches.length > 0 : p.buttons > 0) && r.current ? g(nP(r.current, p, l.current)) : m(!1);
    }, b = function() {
      return m(!1);
    };
    function m(p) {
      var B = a.current, f = y5(r.current), Z = p ? f.addEventListener : f.removeEventListener;
      Z(B ? "touchmove" : "mousemove", A), Z(B ? "touchend" : "mouseup", b);
    }
    return [function(p) {
      var B = p.nativeEvent, f = r.current;
      if (f && (rP(B), !function(y, W) {
        return W && !gf(y);
      }(B, a.current) && f)) {
        if (gf(B)) {
          a.current = !0;
          var Z = B.changedTouches || [];
          Z.length && (l.current = Z[0].identifier);
        }
        f.focus(), g(nP(f, B, l.current)), m(!0);
      }
    }, function(p) {
      var B = p.which || p.keyCode;
      B < 37 || B > 40 || (p.preventDefault(), o({ left: B === 39 ? 0.05 : B === 37 ? -0.05 : 0, top: B === 40 ? 0.05 : B === 38 ? -0.05 : 0 }));
    }, m];
  }, [o, g]), c = I[0], d = I[1], C = I[2];
  return lt(function() {
    return C;
  }, [C]), De.createElement("div", c1({}, n, { onTouchStart: c, onMouseDown: c, className: "react-colorful__interactive", ref: r, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), IE = function(e) {
  return e.filter(Boolean).join(" ");
}, C$ = function(e) {
  var t = e.color, i = e.left, n = e.top, r = n === void 0 ? 0.5 : n, g = IE(["react-colorful__pointer", e.className]);
  return De.createElement("div", { className: g, style: { top: 100 * r + "%", left: 100 * i + "%" } }, De.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, nl = function(e, t, i) {
  return t === void 0 && (t = 0), i === void 0 && (i = Math.pow(10, t)), Math.round(i * e) / i;
}, CGt = function(e) {
  var t = e.s, i = e.v, n = e.a, r = (200 - t) * i / 100;
  return { h: nl(e.h), s: nl(r > 0 && r < 200 ? t * i / 100 / (r <= 100 ? r : 200 - r) * 100 : 0), l: nl(r / 2), a: nl(n, 2) };
}, W5 = function(e) {
  var t = CGt(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, AGt = function(e) {
  var t = e.h, i = e.s, n = e.v, r = e.a;
  t = t / 360 * 6, i /= 100, n /= 100;
  var g = Math.floor(t), o = n * (1 - i), l = n * (1 - (t - g) * i), a = n * (1 - (1 - t + g) * i), I = g % 6;
  return { r: nl(255 * [n, l, o, o, a, n][I]), g: nl(255 * [a, n, n, l, o, o][I]), b: nl(255 * [o, o, a, n, n, l][I]), a: nl(r, 2) };
}, bGt = function(e) {
  var t = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
  return t ? mGt({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : { h: 0, s: 0, v: 0, a: 1 };
}, hGt = bGt, mGt = function(e) {
  var t = e.r, i = e.g, n = e.b, r = e.a, g = Math.max(t, i, n), o = g - Math.min(t, i, n), l = o ? g === t ? (i - n) / o : g === i ? 2 + (n - t) / o : 4 + (t - i) / o : 0;
  return { h: nl(60 * (l < 0 ? l + 6 : l)), s: nl(g ? o / g * 100 : 0), v: nl(g / 255 * 100), a: r };
}, pGt = De.memo(function(e) {
  var t = e.hue, i = e.onChange, n = IE(["react-colorful__hue", e.className]);
  return De.createElement("div", { className: n }, De.createElement(u$, { onMove: function(r) {
    i({ h: 360 * r.left });
  }, onKey: function(r) {
    i({ h: Mf(t + 360 * r.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": nl(t), "aria-valuemax": "360", "aria-valuemin": "0" }, De.createElement(C$, { className: "react-colorful__hue-pointer", left: t / 360, color: W5({ h: t, s: 100, v: 100, a: 1 }) })));
}), BGt = De.memo(function(e) {
  var t = e.hsva, i = e.onChange, n = { backgroundColor: W5({ h: t.h, s: 100, v: 100, a: 1 }) };
  return De.createElement("div", { className: "react-colorful__saturation", style: n }, De.createElement(u$, { onMove: function(r) {
    i({ s: 100 * r.left, v: 100 - 100 * r.top });
  }, onKey: function(r) {
    i({ s: Mf(t.s + 100 * r.left, 0, 100), v: Mf(t.v - 100 * r.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + nl(t.s) + "%, Brightness " + nl(t.v) + "%" }, De.createElement(C$, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: W5(t) })));
}), fGt = function(e, t) {
  if (e === t)
    return !0;
  for (var i in e)
    if (e[i] !== t[i])
      return !1;
  return !0;
}, ZGt = function(e, t) {
  return e.replace(/\s/g, "") === t.replace(/\s/g, "");
};
function GGt(e, t, i) {
  var n = G5(i), r = wt(function() {
    return e.toHsva(t);
  }), g = r[0], o = r[1], l = ot({ color: t, hsva: g });
  lt(function() {
    if (!e.equal(t, l.current.color)) {
      var I = e.toHsva(t);
      l.current = { hsva: I, color: t }, o(I);
    }
  }, [t, e]), lt(function() {
    var I;
    fGt(g, l.current.hsva) || e.equal(I = e.fromHsva(g), l.current.color) || (l.current = { hsva: g, color: I }, n(I));
  }, [g, e, n]);
  var a = Gt(function(I) {
    o(function(c) {
      return Object.assign({}, c, I);
    });
  }, []);
  return [g, a];
}
var yGt = typeof window < "u" ? lZ : lt, WGt = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, gP = /* @__PURE__ */ new Map(), SGt = function(e) {
  yGt(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !gP.has(t)) {
      var i = t.createElement("style");
      i.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, gP.set(t, i);
      var n = WGt();
      n && i.setAttribute("nonce", n), t.head.appendChild(i);
    }
  }, []);
}, VGt = function(e) {
  var t = e.className, i = e.colorModel, n = e.color, r = n === void 0 ? i.defaultColor : n, g = e.onChange, o = d$(e, ["className", "colorModel", "color", "onChange"]), l = ot(null);
  SGt(l);
  var a = GGt(i, r, g), I = a[0], c = a[1], d = IE(["react-colorful", t]);
  return De.createElement("div", c1({}, o, { ref: l, className: d }), De.createElement(BGt, { hsva: I, onChange: c }), De.createElement(pGt, { hue: I.h, onChange: c, className: "react-colorful__last-control" }));
}, wGt = { defaultColor: "rgb(0, 0, 0)", toHsva: hGt, fromHsva: function(e) {
  var t = AGt(e);
  return "rgb(" + t.r + ", " + t.g + ", " + t.b + ")";
}, equal: ZGt }, vGt = function(e) {
  return De.createElement(VGt, c1({}, e, { colorModel: wGt }));
};
const RGt = (e, t) => de.mapValues(t, (i, n) => ({
  ...i,
  label: e + "-" + n
})), OY = (e) => (e || "").replace("#", "").trim(), aB = RGt("OCColorPicker", {
  rgbContainer: {
    display: "grid",
    gridTemplateColumns: "auto auto auto",
    gridGap: (e) => e.spacing(1)
  },
  rgbInput: {
    width: "100%"
  },
  container: {
    display: "grid",
    gridGap: (e) => e.spacing(1),
    gridTemplateRows: "auto auto auto",
    justifyItems: "center",
    margin: 1,
    marginBottom: 2,
    width: 200
  }
}), XGt = ({
  onChange: e,
  value: t,
  mode: i = "hex"
}) => {
  const n = Oe(() => {
    if (t) {
      if (t.startsWith("rgba"))
        return t;
    } else
      return "rgba(0,0,0,1)";
    return dg(t).toRgbString();
  }, [t]), [r, g] = wt(OY(dg(t).toHex())), [o, l] = wt(dg(t).toRgb()), a = (b, m = !0) => {
    if (dg(b).isValid()) {
      const p = i === "hex" ? dg(b).toHex() : b;
      m && g(OY(dg(b).toHex())), l(dg(b).toRgb()), e(p);
    }
  }, I = (b) => {
    const m = OY(b.target.value);
    b.nativeEvent.inputType === "insertFromPaste" ? g(m) : m.length <= 6 && g(b.target.value), a("#" + m, !1);
  }, c = (b) => (m) => {
    const p = {
      ...o,
      [b]: m.target.value
    };
    dg(p).isValid() ? a(p) : l(p);
  }, d = c("r"), C = c("g"), A = c("b");
  return /* @__PURE__ */ Ie(ht, { component: "div", sx: aB.container, "data-cy": "colorPickerContainer", children: [
    /* @__PURE__ */ S(vGt, { "data-cy": "colorPickerColorGradient", onChange: a, color: n }),
    /* @__PURE__ */ S(kd, { variant: "standard", label: "HEX", onChange: I, value: r, error: !dg("#" + r).isValid(), InputProps: {
      startAdornment: /* @__PURE__ */ S(Uh, { position: "start", children: "#" })
    }, inputProps: {
      "data-cy": "hex"
    } }),
    /* @__PURE__ */ Ie(ht, { component: "div", sx: aB.rgbContainer, children: [
      /* @__PURE__ */ S(kd, { sx: aB.rgbInput, type: "number", variant: "standard", label: "R", onChange: d, value: o.r, inputProps: {
        "data-cy": "colorR"
      } }),
      /* @__PURE__ */ S(kd, { sx: aB.rgbInput, type: "number", variant: "standard", label: "G", onChange: C, value: o.g, inputProps: {
        "data-cy": "colorG"
      } }),
      /* @__PURE__ */ S(kd, { sx: aB.rgbInput, type: "number", variant: "standard", label: "B", onChange: A, value: o.b, inputProps: {
        "data-cy": "colorB"
      } })
    ] })
  ] });
};
function of(e) {
  const {
    value: t,
    onChange: i,
    ...n
  } = e.SelectProps || {}, r = de.merge({
    fullWidth: !0,
    variant: "outlined"
  }, e.FormControllProps ?? {}), g = t || e.value, o = (l) => {
    i && i(l, l.target), e.onChange && e.onChange(l.target.value);
  };
  return /* @__PURE__ */ Ie(ja, { ...r, children: [
    e.label && /* @__PURE__ */ S(Ct, { component: "label", htmlFor: n.id, color: "textSecondary", children: e.label }),
    /* @__PURE__ */ S(ZZ, { value: g, onChange: o, "data-cy": e["data-cy"], ...n, disabled: e.disabled, multiple: e.multiple, MenuProps: {
      MenuListProps: {
        sx: {
          maxHeight: "35vh"
        }
      }
    }, inputProps: {
      "aria-label": e["aria-label"]
    }, children: e.children })
  ] });
}
const HGt = (e) => {
  const t = e.getSize(new ye()), i = e.getCenter(new ye()), r = Math.max(t.x, t.y, t.z) * 4;
  return {
    center: i,
    distance: r
  };
}, kGt = (e, t, i) => {
  const n = e.getSize(new ye()), r = e.getCenter(new ye()), o = Math.max(n.x, n.y, n.z) / (2 * Math.atan(Math.PI * i / 360)), l = o / t, a = Math.max(o, l);
  return {
    center: r,
    distance: a
  };
}, YGt = (e) => !e.focusType || e.focusType === "dynamic", FGt = (e) => de.isEmpty(e == null ? void 0 : e.modelIds) && de.isEmpty(e == null ? void 0 : e.objectNames), A$ = (e, t) => {
  if (e.focusType === "static")
    return !1;
  const i = !FGt(e), n = t.isEmpty();
  return i && n;
}, xGt = (e) => {
  const t = /anchoringSelectionId_(.+)/, i = e.match(t);
  return i ? i[1] : "";
}, b$ = (e, t, i) => {
  const n = i ? VZ(i) : void 0, r = i ? Ym(i, n, !0) : [], g = ((e == null ? void 0 : e.modelIds) || []).reduce((a, I) => ({
    ...a,
    [I]: !0
  }), {}), o = ((e == null ? void 0 : e.objectNames) || []).reduce((a, I) => ({
    ...a,
    [I]: !0
  }), {}), l = new fg();
  if (!de.isEmpty(e == null ? void 0 : e.modelIds) || !de.isEmpty(e == null ? void 0 : e.objectNames))
    t.traverse((a) => {
      var c;
      if (!a.visible)
        return;
      const I = (c = a == null ? void 0 : a.userData) == null ? void 0 : c.modelId;
      if (I && g[I] || o[a.name]) {
        const d = xGt(a.name);
        if (i && d) {
          const C = LJ(d)(i);
          if (C && // if the openSelection is "deep enough" our anchoring Selection could be part in its parents
          r.some((A) => A.variableId === C.variableId) && // but it actually is not
          !r.some((A) => to(A, C)))
            return;
        }
        l.expandByObject(a);
      }
    });
  else {
    const a = t.getObjectByName("k3d");
    a && l.setFromObject(a);
  }
  return l;
};
function cE(e) {
  return [e.min.clone(), e.max.clone(), new ye(e.min.x, e.min.y, e.max.z), new ye(e.min.x, e.max.y, e.min.z), new ye(e.min.x, e.max.y, e.max.z), new ye(e.max.x, e.min.y, e.min.z), new ye(e.max.x, e.min.y, e.max.z), new ye(e.max.x, e.max.y, e.min.z)];
}
function oP(e, t, i, n) {
  const r = JGt(t[0], e, t), g = r.maxPlane.clone().translate(r.maxPlane.normal.clone().multiplyScalar(r.maxDistance)), o = new ye();
  return g.intersectLine(i, o), {
    length: new ye().subVectors(o, n).lengthSq(),
    point: o
  };
}
function DGt(e, t, i, n, r, g) {
  if (r.isEmpty())
    return console.warn("Focus bounding box was empty! Returning original camera position."), e;
  const o = new ye().subVectors(t, e).normalize(), l = new ye().crossVectors(o, new ye(0, 1, 0)).normalize(), a = new ye().crossVectors(l, o).normalize(), I = Math.tan(i * Math.PI / 180 / 2), c = I * n, d = a.clone().multiplyScalar(I), C = l.clone().multiplyScalar(c), A = new ye().addVectors(o, d).sub(C), b = new ye().addVectors(o, d).add(C), m = new ye().subVectors(o, d).sub(C), p = new ye().subVectors(o, d).add(C), B = new ye().crossVectors(A, m).normalize(), f = new ye().crossVectors(p, b).normalize(), Z = new ye().crossVectors(b, A).normalize(), y = new ye().crossVectors(m, p).normalize(), W = new xC().setFromNormalAndCoplanarPoint(B, e), V = new xC().setFromNormalAndCoplanarPoint(f, e), w = new xC().setFromNormalAndCoplanarPoint(Z, e), v = new xC().setFromNormalAndCoplanarPoint(y, e), H = cE(r), x = new Nl(new ye(...e).add(o.clone().multiplyScalar(-1e3)), new ye(...t)), J = [W, V], {
    length: K,
    point: M
  } = oP(H, J, x, t), L = [w, v], {
    length: N,
    point: U
  } = oP(H, L, x, t), O = K > N ? M : U;
  return g !== 0 && O.add(o.clone().multiplyScalar(-g)), O;
}
function JGt(e, t, i) {
  let n = -1 / 0, r = e;
  for (const g of t)
    for (const o of i) {
      const l = o.distanceToPoint(g);
      l > n && (n = l, r = o);
    }
  return {
    maxPlane: r,
    maxDistance: n
  };
}
const UZ = (e) => e.type === "PerspectiveCamera", dE = (e) => e.type === "OrthographicCamera";
function uE(e, t, i, n, r, g) {
  const [o, l, a] = (e == null ? void 0 : e.position) || t.position.toArray(), I = new ye(o, l, a);
  if (e && e.focusType === "static")
    return {
      newPosition: I.toArray(),
      newTarget: e.lookAt
    };
  let c = I, d = new ye(...(e == null ? void 0 : e.lookAt) || i.getCenter(new ye()));
  if (UZ(t)) {
    const {
      position: C,
      lookAt: A
    } = NGt(I, new ye(...d), t.fov, t.aspect, i, g);
    c = C, d = A;
  } else if (dE(t)) {
    const {
      position: C,
      lookAt: A
    } = EGt(I, d, i, t, n, r, g);
    c = C, d = A;
  } else
    console.error("Unknown camera type!");
  return {
    newPosition: c.toArray(),
    newTarget: d.toArray()
  };
}
function EGt(e, t, i, n, r, g, o) {
  const {
    center: l,
    distance: a
  } = HGt(i), c = new ye().subVectors(e, new ye(...t)).normalize().multiplyScalar(a).add(l);
  n.position.set(...c.toArray()), n.lookAt(l), n.updateProjectionMatrix(), n.updateMatrixWorld();
  const d = cE(i);
  let C = -1 / 0;
  if (d.forEach((A) => {
    const b = A.clone().project(n);
    C = Math.max(C, Math.max(Math.abs(b.x), Math.abs(b.y)));
  }), n.zoom /= C, o > 0) {
    const A = r / g, b = o / 6;
    n.left -= b * A, n.right += b * A, n.top += b, n.bottom -= b;
  }
  return n.updateProjectionMatrix(), n.updateMatrixWorld(), {
    position: c,
    lookAt: l
  };
}
function NGt(e, t, i, n, r, g) {
  const o = new ye().subVectors(e, new ye(...t)).normalize(), {
    center: l,
    distance: a
  } = kGt(r, n, i), I = o.multiplyScalar(a).add(l);
  return {
    position: DGt(I.clone(), new ye(...l), i, n, r, g),
    lookAt: l
  };
}
function S5(e, t, i, n, r = 0.1) {
  const g = new fg().setFromObject(e), o = i.camera, l = i.invalidate, a = i.size.width, I = i.size.height, {
    newPosition: c,
    newTarget: d
  } = uE(void 0, o, g, a, I, n);
  h$(o, g, c, d, r) && (l(100), setTimeout(() => {
    t.to({
      position: c,
      target: d
    });
  }, 20));
}
function LGt(e, t, i, n, r, g) {
  const o = b$(e, i), l = {
    position: e.position,
    lookAt: e.lookAt
  };
  if (e && !A$(e, o)) {
    const {
      newPosition: a,
      newTarget: I
    } = uE(e, t, o, n, r, g);
    l.position = a, l.lookAt = I;
  }
  return l;
}
const KGt = ["x", "y", "z"], lP = (e) => KGt.some((t) => e[t] < -1 || e[t] > 1);
function h$(e, t, i, n, r, g = !0) {
  if (!r)
    return !0;
  const o = cE(t), l = e.clone(!0);
  return l.position.fromArray(i), l.lookAt(new ye(...n)), l.updateMatrixWorld(), UZ(l) && l.updateProjectionMatrix(), o.some((I) => {
    const c = I.clone().project(e), d = I.project(l);
    return g && (lP(c) || lP(d)) ? !0 : c.distanceTo(d) > r;
  });
}
const CE = (e) => e.k3d.screenshotting, TGt = (e) => e.k3d.isScreenshottingPossible, MGt = (e) => e.k3d.modelRuleData, d1 = (e) => e.k3d.editMode, PGt = (e) => (t) => e ? t.k3d.usedByDynamic.includes(e) : !1, m$ = (e) => e.k3d.nextCameraPosition, UGt = (e) => e.k3d.forceNextCameraPosition, u1 = (e) => e.k3d.isSceneLoading, zGt = [], p$ = (e) => e.k3d.loadedModelIds || zGt, OGt = (e, t, i) => {
  const n = e.clone().sub(i).normalize();
  let r = t.clone().cross(n).normalize();
  if (r.lengthSq() === 0) {
    const g = n.clone();
    g.x += 1e-4, g.y += 1e-4, g.z += 1e-4, r = t.clone().cross(g).normalize();
  }
  return r;
}, aP = (e) => {
  var l, a, I, c;
  const {
    scene: t
  } = RI(), i = ((l = e.parameters) == null ? void 0 : l.length) ?? 0.05, n = (((a = e.parameters) == null ? void 0 : a.offset) ?? 0.5) * -i, r = n + i;
  let g = (I = e.parameters) != null && I.direction ? new ye(...((c = e.parameters) == null ? void 0 : c.direction) ?? []).normalize() : void 0;
  if (!g) {
    const d = t == null ? void 0 : t.getObjectByName("k3d");
    let C = new ye();
    try {
      C = new fg().setFromObject(d).getCenter(new ye()) ?? new ye();
    } catch {
      C = new ye();
    }
    const A = OGt(e.center, e.direction, C);
    g = e.direction.clone().cross(Z$(A, f$).clone()).normalize();
  }
  const o = [new ye(...e.endpoint).add(new ye().copy(g).multiplyScalar(n)).toArray(), new ye(...e.endpoint).add(new ye().copy(g).multiplyScalar(r)).toArray()];
  return /* @__PURE__ */ S(
    iV,
    {
      color: e.color,
      lineWidth: e.lineWidth,
      points: o
    }
  );
}, B$ = new ye(0, 1, 0), f$ = [new ye(1, 0, 0), B$, new ye(0, 0, 1)];
function Z$(e, t) {
  let i = t[0], n = Math.abs(e.clone().dot(t[0]));
  for (let r = 1; r < t.length; r++) {
    const g = Math.abs(e.clone().dot(t[r]));
    g > n && (i = t[r], n = g);
  }
  return i;
}
const QY = (e, t) => Math.abs(e - t) / e > 25e-4;
function QGt(e) {
  const t = ot(null), i = ot(null), n = new G4().setFromEuler(new VD(...e.rotation ?? [0, 0, 0])), [r, g] = wt(0), [o, l] = wt(0), [a, I] = wt(0);
  dA((A) => {
    var p, B;
    const b = n.rotateTowards(A.camera.quaternion, 99999);
    (p = t.current) == null || p.quaternion.copy(b), (B = t.current) == null || B.updateMatrixWorld();
    const m = A.camera.position.distanceTo(e.textWorldPosition);
    if (QY(r, m) && g(m), i.current && e.sprite && i.current.quaternion.copy(A.camera.quaternion), dE(A.camera)) {
      const f = (A.camera.top - A.camera.bottom) / A.camera.zoom / (1 / (e.size ?? 1) * 50);
      QY(o, f) && l(f);
    }
  });
  const {
    camera: c
  } = RI(), d = UZ(c) ? (e.size ?? 1) * r / 100 : o, C = d;
  return lt(() => {
    e.onMaxTextDimensionChange && (Z$(e.direction, f$).equals(B$) ? e.onMaxTextDimensionChange(d + C) : e.onMaxTextDimensionChange(a + C));
  }, [e, a, d, C, e.onMaxTextDimensionChange]), /* @__PURE__ */ S("group", { ref: t, position: e.position, castShadow: !1, receiveShadow: !1, children: /* @__PURE__ */ Ie(Roe, { userData: {
    // For the focus system in useFocusOnK3dScene  we need to ignore this
    // Text component. Since it is rotated towards the camera and thus
    // changes the bounding box constantly.
    ignoreBoundingBoxWhileFocusing: !0
  }, anchorX: "center", anchorY: "middle", ref: i, fontSize: d, lineHeight: 1, color: e.color, outlineWidth: 0.1, outlineColor: "white", clipRect: [-(a + C) / 2, -(d + C) / 2.5, (a + C) / 2, (d + C) / 2], onSync: (A) => {
    const b = A.geometry.boundingBox.max.x - A.geometry.boundingBox.min.x;
    QY(b, a) && I(b);
  }, children: [
    e.text,
    " ",
    e.unit || "",
    /* @__PURE__ */ S(qGt, {})
  ] }) });
}
const jGt = (e) => {
  const t = ot(null), i = ie(d1), n = e.formatter ?? ((w) => w.toFixed(e.digits ?? 2)), [r, g] = wt(new ye()), o = new ye(...e.startPoint).sub(new ye(...e.endPoint)), [l, a] = wt(new ye()), I = e.length ?? o.length(), c = (e.textPosition ? new ye(...e.textPosition) : new ye(...e.startPoint).add(new ye().copy(o).multiplyScalar(-0.5))).toArray(), d = e.color ?? "black", C = e.thickness ?? 1, [A, b] = wt(0), m = Gt((w) => {
    w !== A && b(w);
  }, [A]), p = e.lineClamp ?? Math.max(0, 0.5 - A / 1.5 / I), B = new ye(...e.startPoint).add(new ye().copy(o).multiplyScalar(-p)).toArray(), f = new ye(...e.endPoint).add(new ye().copy(o).multiplyScalar(p)).toArray(), Z = new ye(...e.endPoint).sub(new ye(...e.startPoint)).normalize(), y = Gt((w) => {
    const v = (w == null ? void 0 : w.localToWorld(new ye(...c))) || new ye();
    r.equals(v) || g(v);
  }, [c, r]), W = Gt((w) => {
    let v = new ye(...e.startPoint).add(new ye(...e.endPoint).sub(new ye(...e.startPoint)).multiplyScalar(0.5));
    v = w.localToWorld(v), !l.equals(v) && a(v);
  }, [e.startPoint, e.endPoint, l]), V = Gt((w) => {
    y(w), W(w);
  }, [y, W]);
  return /* @__PURE__ */ Ie("group", { ref: t, position: e.position, userData: {
    modelId: e.id
  }, onUpdate: V, name: e.name, children: [
    !i && e.textType !== "none" && /* @__PURE__ */ S(QGt, { color: e.textColor ?? "black", size: e.textSize ?? 1, sprite: e.textSprite ?? !1, position: c, text: e.textType === "number" ? n(e.textStatic ?? I) : e.textStaticString, rotation: e.textRotation, textWorldPosition: r, unit: e.unit, direction: Z, onMaxTextDimensionChange: m }),
    /* @__PURE__ */ Ie("group", { rotation: e.rotation, children: [
      e.startAnchor == "ruler" && /* @__PURE__ */ S(aP, { center: l, direction: Z, color: d, lineWidth: C, parameters: e.endLines, endpoint: e.startPoint }),
      e.endAnchor == "ruler" && /* @__PURE__ */ S(aP, { center: l, direction: Z, color: d, lineWidth: C, parameters: e.endLines, endpoint: e.endPoint }),
      e.textType == "number" || e.textType == "string" && e.textStaticString.trim() != "" ? /* @__PURE__ */ Ie(li, { children: [
        /* @__PURE__ */ S(
          iV,
          {
            color: d,
            lineWidth: C,
            points: [e.startPoint, B]
          }
        ),
        /* @__PURE__ */ S(
          iV,
          {
            color: d,
            lineWidth: C,
            points: [e.endPoint, f]
          }
        )
      ] }) : /* @__PURE__ */ S(
        iV,
        {
          color: d,
          lineWidth: C,
          points: [e.startPoint, e.endPoint]
        }
      )
    ] })
  ] });
}, qGt = (e) => /* @__PURE__ */ S("meshBasicMaterial", { attach: "material", color: e.color, toneMapped: !1, reflectivity: 0, fog: !1, map: e.map }), _Gt = "data:image/png;base64,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", kh = {
  expression: "0"
}, $Gt = {
  color: "#000",
  startPoint: [kh, kh, kh],
  endPoint: [kh, {
    expression: "1"
  }, kh],
  thickness: {
    expression: "1"
  },
  digits: {
    expression: "2"
  },
  textType: "number",
  startAnchor: "ruler",
  endAnchor: "ruler",
  textStaticString: ""
}, eyt = {
  textStatic: kh
}, tyt = ({
  dynamicModelProps: e,
  expressionChange: t,
  toggleVisibility: i,
  isVisible: n,
  onChange: r,
  ruleItem: g,
  ruleColumnId: o,
  model: l,
  modelActionRuleItemValue: a
}) => {
  var C, A, b, m, p;
  const {
    t: I
  } = Gi(), c = i(eyt), d = ie(mA(g == null ? void 0 : g.id, o));
  return /* @__PURE__ */ Ie(pi, { maxWidth: 800, children: [
    /* @__PURE__ */ S(Ct, { variant: "h5", children: I("Allgemein") }),
    /* @__PURE__ */ Ie(pi, { mt: 3, children: [
      /* @__PURE__ */ S(Ct, { children: I("Farbe") }),
      /* @__PURE__ */ S(XGt, { value: e.color, onChange: r("color") })
    ] }),
    /* @__PURE__ */ S(pi, { mt: 3, children: /* @__PURE__ */ S(nf, { debounced: !0, defaultValues: e.startPoint, sx: {
      maxWidth: "400px"
    }, label: I("Startpunkt"), onChange: r("startPoint"), expression: !0, anchoringSelections: d }) }),
    /* @__PURE__ */ S(pi, { mt: 3, children: /* @__PURE__ */ S(nf, { debounced: !0, defaultValues: e.endPoint, sx: {
      maxWidth: "400px"
    }, label: I("Endpunkt"), onChange: r("endPoint"), expression: !0, anchoringSelections: d }) }),
    /* @__PURE__ */ S(pi, { mt: 3, children: /* @__PURE__ */ S(hg, { value: (C = e.thickness) == null ? void 0 : C.expression, onChange: t("thickness"), label: I("Linienstärke"), sx: {
      maxWidth: 300
    }, anchoringSelections: d }) }),
    /* @__PURE__ */ Ie(pi, { mt: 3, children: [
      /* @__PURE__ */ Ie(of, { "data-cy": "startAnchor", label: I("Startanker"), value: e.startAnchor, onChange: r("startAnchor"), children: [
        /* @__PURE__ */ S(yo, { value: "ruler", children: I("Maßkette") }),
        /* @__PURE__ */ S(yo, { value: "none", children: I("Ohne") })
      ] }),
      /* @__PURE__ */ Ie(of, { "data-cy": "endAnchor", label: I("Endanker"), value: e.endAnchor, onChange: r("endAnchor"), children: [
        /* @__PURE__ */ S(yo, { value: "ruler", children: I("Maßkette") }),
        /* @__PURE__ */ S(yo, { value: "none", children: I("Ohne") })
      ] })
    ] }),
    /* @__PURE__ */ S(Ct, { variant: "h5", sx: {
      mt: 5
    }, children: I("Text") }),
    /* @__PURE__ */ Ie(of, { "data-cy": "textType", label: I("Texttyp"), value: e.textType, onChange: (B) => {
      r("textType")(B);
    }, children: [
      /* @__PURE__ */ S(yo, { value: "none", children: I("Kein Text") }),
      /* @__PURE__ */ S(yo, { value: "number", children: I("Zahlenwert") }),
      /* @__PURE__ */ S(yo, { value: "string", children: I("Statischer Text") })
    ] }),
    e.textType === "number" && /* @__PURE__ */ Ie(pi, { mt: 3, children: [
      /* @__PURE__ */ S(c_, { "data-cy": "overrideStandardText", checked: n("textStatic"), onChange: c("textStatic"), label: I("Automatisches Maß überschreiben") }),
      n("textStatic") && e.textStatic && /* @__PURE__ */ S(hg, { value: (A = e.textStatic) == null ? void 0 : A.expression, onChange: t("textStatic"), label: I("Neues Maß"), sx: {
        maxWidth: 300
      }, anchoringSelections: d }),
      /* @__PURE__ */ S(hg, { value: ((b = e.textSize) == null ? void 0 : b.expression) ?? "1", onChange: t("textSize"), label: I("Textgröße als Faktor. 1 ist Standard."), sx: {
        maxWidth: 300
      }, anchoringSelections: d }),
      /* @__PURE__ */ S(hg, { value: (m = e.digits) == null ? void 0 : m.expression, onChange: t("digits"), label: I("Nachkommastellen"), sx: {
        maxWidth: 300
      }, anchoringSelections: d }),
      /* @__PURE__ */ S(al, { "data-cy": "unit", label: I("Einheit"), value: e.unit, onChange: r("unit") })
    ] }),
    e.textType === "string" && /* @__PURE__ */ Ie(pi, { mt: 3, children: [
      /* @__PURE__ */ S(al, { "data-cy": "textStatic", label: I("Statischer Text"), value: e.textStaticString, onChange: (B) => {
        r("textStaticString")(B);
      } }),
      /* @__PURE__ */ S(hg, { value: ((p = e.textSize) == null ? void 0 : p.expression) ?? "1", onChange: t("textSize"), label: I("Textgröße als Faktor. 1 ist Standard."), sx: {
        maxWidth: 300
      }, anchoringSelections: d })
    ] }),
    /* @__PURE__ */ S(pi, { mt: 3, children: /* @__PURE__ */ Ie(iJ, { children: [
      /* @__PURE__ */ S(rJ, { expandIcon: /* @__PURE__ */ S(h9, {}), children: /* @__PURE__ */ S(Ct, { variant: "h5", children: I("Offsets") }) }),
      /* @__PURE__ */ Ie(nJ, { children: [
        /* @__PURE__ */ S(Ct, { variant: "body1", children: I("Hier können Abweichungen von Position und Rotation, die sich normalerweise aus Start und Endpunkt ergeben, definiert werden. Dazu kann das 3D Positionierungswerkzeug benutzt werden.") }),
        /* @__PURE__ */ S(Km, { modelActionRuleItemValue: a, model: l, ruleItem: g, onChange: r })
      ] })
    ] }) }),
    /* @__PURE__ */ S(pi, { mt: 3 })
  ] });
}, iyt = {
  type: "ruler",
  label: "Maßkette",
  disabledForAR: !0,
  component: jGt,
  defaultProps: $Gt,
  propsDialog: tyt,
  repositionApplicator: Sc,
  materials: [],
  screenshot: _Gt
}, nyt = "data:image/png;base64,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", ryt = (e) => {
  var a;
  const {
    t
  } = Gi(), i = ie(mA((a = e.ruleItem) == null ? void 0 : a.id, e.ruleColumnId)), n = e.dynamicModelProps.shape, r = [];
  for (let I = 0; I < n.length; I += 3)
    r.push({
      operation: n[I],
      x: n[I + 1],
      y: n[I + 2]
    });
  const g = (I, c) => (d) => {
    const C = [...e.dynamicModelProps.shape];
    switch (c) {
      case "operation":
        C[3 * I] = d.target.value;
        break;
      case "x":
        C[3 * I + 1] = {
          expression: d
        };
        break;
      case "y":
        C[3 * I + 2] = {
          expression: d
        };
        break;
    }
    e.onChange("shape")(C);
  }, o = (I) => () => {
    const c = [...e.dynamicModelProps.shape];
    c.splice(3 * I, 3), e.onChange("shape")(c);
  }, l = () => {
    const I = [...e.dynamicModelProps.shape, "line", {
      expression: "0"
    }, {
      expression: "0"
    }];
    e.onChange("shape")(I);
  };
  return /* @__PURE__ */ Ie(pi, { gap: 3, children: [
    /* @__PURE__ */ S(Km, { modelActionRuleItemValue: e.modelActionRuleItemValue, model: e.model, onChange: e.onChange, ruleItem: e.ruleItem, ruleColumnId: e.ruleColumnId }),
    /* @__PURE__ */ S(hg, { value: e.dynamicModelProps.extrutionDepth.expression, onChange: e.expressionChange("extrutionDepth"), label: t("Tiefe"), anchoringSelections: i }),
    /* @__PURE__ */ S(hg, { value: e.dynamicModelProps.steps.expression, onChange: e.expressionChange("steps"), label: t("Schritte"), anchoringSelections: i }),
    /* @__PURE__ */ S(hg, { value: e.dynamicModelProps.curveSegments.expression, onChange: e.expressionChange("curveSegments"), label: t("Segmente"), anchoringSelections: i }),
    /* @__PURE__ */ Ie(vo, { component: "div", children: [
      /* @__PURE__ */ Ie(Ct, { children: [
        "Shape",
        /* @__PURE__ */ S(Ni, { onClick: l, "data-cy": "add", children: /* @__PURE__ */ S($8, {}) })
      ] }),
      r.map((I, c) => /* @__PURE__ */ Ie(pi, { direction: "row", children: [
        /* @__PURE__ */ Ie(vo, { component: "fieldset", sx: {
          borderColor: "rgba(0, 0, 0, 0.23)",
          borderWidth: 1,
          borderRadius: 1,
          margin: 0,
          width: "100px"
        }, children: [
          /* @__PURE__ */ S(Ct, { component: "legend", color: "textSecondary", sx: {
            fontSize: 12
          }, children: "Op" }),
          /* @__PURE__ */ Ie(ZZ, { size: "small", "data-cy": "operation", value: c == 0 ? "move" : I.operation, onChange: g(c, "operation"), disabled: c == 0, children: [
            /* @__PURE__ */ S(yo, { value: "move", children: "move" }),
            /* @__PURE__ */ S(yo, { value: "line", children: "line" }),
            /* @__PURE__ */ S(yo, { value: "spline", children: "spline" }),
            /* @__PURE__ */ S(yo, { value: "arc", children: "arc" })
          ] })
        ] }),
        /* @__PURE__ */ S(hg, { value: I.x.expression, label: "x", onChange: g(c, "x"), anchoringSelections: i }),
        /* @__PURE__ */ S(hg, { value: I.y.expression, label: "y", onChange: g(c, "y"), anchoringSelections: i }),
        /* @__PURE__ */ S(Ni, { onClick: o(c), "data-cy": "add", children: /* @__PURE__ */ S(DZ, {}) })
      ] }, c))
    ] }),
    /* @__PURE__ */ S(al, { value: e.dynamicModelProps.path, onChange: e.onChange("path"), label: t("Pfad"), "data-cy": "path", multiline: !0 })
  ] });
};
function gyt(e, t, i) {
  if (i < 5 || i >= t.length - 3)
    return;
  const n = new ir.Vector2(t[i - 5], t[i - 4]), r = new ir.Vector2(t[i - 2], t[i - 1]), g = new ir.Vector2(t[i + 1], t[i + 2]), o = new ir.Vector2().addVectors(r, g).multiplyScalar(0.5), l = new ir.Vector2().subVectors(g, r).normalize(), a = new ir.Vector2(-l.y, l.x), I = new ir.Vector2().subVectors(r, n).normalize(), c = new ir.Vector2(-I.y, I.x), d = a.x * c.y - a.y * c.x;
  if (Math.abs(d) < 1e-6)
    return;
  const C = new ir.Vector2().subVectors(r, o), A = (C.x * c.y - C.y * c.x) / d, b = o.clone().add(a.multiplyScalar(A)), m = b.distanceTo(r), p = Math.atan2(r.y - b.y, r.x - b.x), B = Math.atan2(g.y - b.y, g.x - b.x), f = d > 0;
  e.absarc(b.x, b.y, m, p, B, f);
}
const oyt = dl((e, t) => {
  var a;
  const i = e.id, n = ie(e1(i)), r = Oe(() => {
    var I;
    return ((I = n.materials) == null ? void 0 : I.map((c) => new o2({
      name: c,
      color: "grey"
    }))) ?? [];
  }, [n.materials]), g = oE(i, r, [], e.modelAction), o = (I) => {
    const c = I.split(`
`).map((d) => d.trim().split(/\s+/).map((C) => parseFloat(C))).filter((d) => d.length == 3);
    return c.length < 3 ? null : new ir.CatmullRomCurve3(c.map((d) => new ir.Vector3(d[0], d[1], d[2])));
  }, l = Oe(() => {
    const I = e.shape;
    if (!e.shape)
      return null;
    const c = new ir.Shape();
    c.moveTo(0, 0);
    const d = [], C = () => {
      d.length != 0 && (c.splineThru([...d]), d.splice(0, d.length));
    };
    for (let b = 0; b < I.length; b += 3) {
      const m = I[b + 1], p = I[b + 2];
      if (b == 0)
        c.moveTo(m, p);
      else
        switch (I[b]) {
          case "spline":
            d.push(new ir.Vector2(m, p));
            break;
          case "move":
            c.moveTo(m, p);
            break;
          case "arc":
            gyt(c, I, b);
            break;
          case "line":
          default:
            C(), c.lineTo(m, p);
            break;
        }
    }
    C();
    const A = {
      curveSegments: e.curveSegments || 10,
      steps: e.steps,
      depth: e.extrutionDepth,
      bevelEnabled: e.bevelEnabled
    };
    return e.path && (A.extrudePath = o(e.path)), new ir.ExtrudeGeometry(c, A);
  }, [e.shape, e.curveSegments, e.steps, e.extrutionDepth, e.bevelEnabled, e.path]);
  return l == null ? null : /* @__PURE__ */ S("group", { position: e.position, rotation: e.rotation, scale: e.scale, userData: {
    modelId: i
  }, children: /* @__PURE__ */ S("mesh", { ref: t, material: (a = Object.values(g)) == null ? void 0 : a[0], geometry: l }) });
}), lyt = {
  type: "extrusion",
  label: "Extrusion",
  disabledForAR: !1,
  component: oyt,
  propsDialog: ryt,
  defaultProps: {
    width: {
      expression: "1"
    },
    height: {
      expression: "1"
    },
    depth: {
      expression: "1"
    },
    shape: [],
    curveSegments: {
      expression: "1"
    },
    steps: {
      expression: "10"
    },
    extrutionDepth: {
      expression: "1"
    },
    bevelEnabled: !1
  },
  materials: ["surface"],
  repositionApplicator: Sc,
  screenshot: nyt,
  tag: "beta"
}, ayt = (e) => (e == null ? void 0 : e.attrs) || [], syt = (e, t) => (
  // @ts-ignore
  ayt(t).find((i) => i.attrId == e)
), Al = (e) => {
  const t = Ei();
  return Gt((...i) => (
    // @ts-ignore
    t(e(...i))
  ), [t, e]);
}, C1 = (e) => de.get(e, ["metadata", de.lowerCase("images")]);
Le.curry((e, t) => Le.flow(C1, Le.filter((i) => i.appId == e))(t));
const I$t = (e) => {
  const t = C1(e);
  return av.uniq(t.map((i) => i.path)).sort();
}, G$ = (e) => {
  const t = C1(e), i = lye(e);
  return t.filter((n) => i.some((r) => r.path === n.path));
}, Rl = {
  topbottom: 50,
  leftright: 50,
  scale: 75
};
function Iyt(e, t, i, n, r) {
  const g = /* @__PURE__ */ new Set(), o = Array.from(i[n] ?? []).map((c) => ({
    variable: t[c],
    depth: 1
  })), a = e.filter(Ka).reduce((c, d) => (c.push([d.id, i[d.id]]), c), []), I = /* @__PURE__ */ new Set();
  for (; o.length; ) {
    const c = o.pop();
    if (!c || r !== void 0 && c.depth > r || g.has(c.variable.id))
      continue;
    const d = t[c.variable.id];
    g.add(c.variable.id);
    const C = Array.from(i[c.variable.id]) ?? [];
    Ka(d) && (I.add(d.id), C.forEach((A) => {
      I.add(A);
    })), a.forEach(([A, b]) => {
      b != null && b.includes(d.id) && !g.has(+A) && o.push({
        variable: t[+A],
        depth: c.depth
      });
    }), C.forEach((A) => {
      g.has(A) || o.push({
        variable: t[A],
        depth: c.depth + 1
      });
    }), o.sort((A, b) => b.depth - A.depth);
  }
  return g;
}
function cyt(e) {
  const t = An(e);
  return e.reduce((i, n) => {
    const r = lq(t, n.id), g = vbt(e, n.id), o = /* @__PURE__ */ new Set();
    return o.add(n.id), r.forEach((l) => {
      o.add(l);
    }), g.forEach((l) => {
      o.add(l);
    }), i[n.id] = Array.from(o), i;
  }, {});
}
const jY = (e) => e ? e.hideValues.reduce((i, n) => de.merge(i, (n.instanceIds ?? []).reduce((r, g) => (r[g] = n.valueIds.reduce((o, l) => (o[l] = !0, o), {}), r), {})), {}) : {}, y$ = (e) => e.reduce((t, i) => {
  var r;
  return t[i.variableId] === !0 ? t : de.merge(t, {
    [i.variableId]: ((r = i.instanceIds) == null ? void 0 : r.reduce((g, o) => ({
      ...g,
      [o]: !0
    }), {})) || !0
  });
}, {}), dyt = (e, t) => {
  if (!t)
    return {};
  const i = [...t.concealVariables, ...t.concealGroups.flatMap((n) => e.filter((r) => n.groups.some((g) => g === r.groupId)).map((r) => ({
    variableId: r.id,
    ruleItem: n.ruleItem,
    ruleColumn: n.ruleColumn
  })))];
  return y$(i);
}, sP = (e, t) => {
  if (!t)
    return {};
  const i = [...t.hideVariables, ...t.hideGroups.flatMap((n) => e.filter((r) => n.groups.some((g) => g === r.groupId)).map((r) => ({
    variableId: r.id,
    ruleItem: n.ruleItem,
    ruleColumn: n.ruleColumn
  })))];
  return y$(i);
};
function uyt(e, t) {
  const i = e.reduce((g, o) => {
    if (!Ka(o))
      return g;
    const l = LZ(Jm(o));
    l.forEach((I) => {
      const c = g[I] || /* @__PURE__ */ new Set();
      c.add(o.id), g[I] = c;
    });
    const a = g[o.id] || /* @__PURE__ */ new Set();
    return l.forEach((I) => {
      a.add(I);
    }), g[o.id] = a, g;
  }, {}), n = t.reduce((g, o) => {
    const l = o.columns.filter(Gc).reduce((a, I) => {
      const c = +(I == null ? void 0 : I.targetId);
      return c && a.push(c), a;
    }, []);
    return l.forEach((a) => {
      const I = g[a] || /* @__PURE__ */ new Set();
      l.forEach((c) => {
        c !== a && I.add(c);
      }), g[a] = I;
    }), g;
  }, {}), r = de.mergeWith(i, n, (g, o) => {
    if (g instanceof Set && o instanceof Set)
      return /* @__PURE__ */ new Set([...g, ...o]);
  });
  return de.mapValues(r, (g) => Array.from(g));
}
const W$ = (e, t, i, n, r, g, o, l) => {
  if (o)
    return {
      ...o,
      hiddenValuesMap: jY(g),
      concealedVariablesMap: dyt(r, g),
      hiddenVariablesMap: sP(r, g)
    };
  const {
    newRules: a,
    newRuleItems: I,
    newItemsById: c,
    newValues: d,
    newVariables: C
  } = Le.flow(q8(r, !0, l), byt(r))({
    rules: t,
    ruleItems: i,
    values: n
  }), A = (M) => km(M) || Ka(M) || a.some((L) => L.columns.some((N) => N.targetId === M.id)) || t.some((L) => L.columns.some((N) => (N.type === "popupAction" || N.type == "instanceAction") && N.targetId === M.id)), b = /* @__PURE__ */ new Set(), m = r.reduce((M, L) => (!A(L) || (b.add(L.id), !Ka(L)) || LZ(Jm(L)).forEach((U) => M.add(U)), M), /* @__PURE__ */ new Set()), [p, B] = de.partition(C, (M) => b.has(M.id) || m.has(M.id)), f = (M) => p.some((L) => L.id === M.variableId), [Z, y] = de.partition(d, f), W = AV(p, Z), V = AV(B, y), w = AV(C, d), v = qY(B, a), H = qY(p, a), x = qY(C, a), J = Ayt(a), K = uyt(r, a);
  return {
    groups: e.slice().sort(tu),
    rules: a,
    ruleItems: {
      flat: I,
      byRuleId: c,
      rulesByTargetIdMap: J,
      instanceActionValueIds: i.flatMap((M) => Object.values(M.values).filter((L) => kJ(L)).map((L) => L.valueId))
    },
    variables: {
      variableHierarchies: cyt(C),
      dependentVariablesById: K,
      flat: {
        free: v,
        locked: H,
        all: x
      },
      byVarId: {
        free: An(v),
        locked: An(H),
        all: An(x)
      }
    },
    values: {
      byVarId: {
        free: V,
        locked: W,
        all: w
      },
      byId: An(d),
      flat: {
        free: y,
        locked: Z,
        all: d
      }
    },
    hiddenVariablesMap: sP(r, g),
    hiddenValuesMap: jY(g),
    concealedVariablesMap: jY(g)
  };
}, qY = (e, t) => {
  const i = e.map((n) => ({
    variable: n,
    count: t.filter((r) => r.columns.some((g) => g.targetId === n.id)).length
  }));
  return i.sort((n, r) => r.count - n.count), i.map((n) => n.variable);
}, Cyt = (e) => (t, i) => de.uniq(e[+i].filter((n) => (
  // Both is possible. A value spans a larger interval then the rule item,
  // because it was merged or the rule items spans a larger interval because it was split further by other rule items
  Wc(n.data, t.interval) || Wc(t.interval, n.data)
)).map((n) => n.id));
function Ayt(e) {
  return e.reduce((t, i) => (i.isActive && i.columns.forEach((n) => {
    const r = +((n == null ? void 0 : n.targetId) ?? "a");
    if (!r)
      return t;
    const g = t[r];
    return g ? g.push(i) : t[r] = [i], t;
  }), t), {});
}
const byt = (e) => (t) => {
  const {
    newRules: i,
    newValues: n,
    newRuleItems: r
  } = t, g = de.groupBy(n, (f) => f.variableId), o = Cyt(g), l = de.groupBy(r, (f) => f.ruleId), a = {};
  i.forEach((f) => {
    const Z = f.columns.map((W) => W.targetId), y = l[f.id];
    Z.forEach((W) => {
      if (!y)
        return;
      const V = y.flatMap((w) => {
        const v = w.values[W];
        return xf(v) ? o(v, W) : v;
      });
      V.includes(!0) || (a[W] = a[W] ? de.intersection(V, a[W]) : V);
    });
  });
  const [I, c] = de.partition(n, (f) => {
    const Z = a[f.variableId];
    return Z ? Z.some((y) => y === f.id) : !0;
  }), d = de.groupBy(I, (f) => f.variableId), [C, A] = de.partition(e, (f) => I.some((Z) => Z.variableId === f.id)), b = A.filter((f) => c.some((Z) => Z.variableId === f.id));
  if ((b == null ? void 0 : b.length) > 0)
    throw new Error("Folgende Merkmale haben keine gültigen Werte mehr: " + b.map((f) => f.label).join(", "));
  const m = {}, p = [];
  i.forEach((f) => {
    const Z = f.columns.filter((W) => !A.some((V) => V.id === W.targetId));
    if (Z.length <= 1)
      return;
    const y = (l[f.id] || []).map((W) => {
      if (Z.length === f.columns.length)
        return W;
      {
        const V = {}, w = Object.entries(W.values);
        return w.forEach(([v, H]) => {
          if (de.isArray(H)) {
            const x = d[v] || [], J = H.filter((K) => x.some((M) => M.id === K));
            J.length && (V[v] = J);
          } else
            V[v] = H;
        }), Object.entries(V).length !== w.length ? !1 : {
          ...W,
          values: V
        };
      }
    }).filter(Boolean);
    y.length && (p.push({
      ...f,
      columns: Z
    }), m[f.id] = y);
  });
  const B = Object.values(m).flat();
  return {
    newValues: I,
    newRules: p,
    newItemsById: m,
    newRuleItems: B,
    newVariables: C
  };
}, Pf = (e, t, i) => ({
  ...i,
  valueId: t.id,
  debuggingValue: `${e.variables.byVarId.all[t.variableId].label}: ${t.label}`,
  data: hyt(e, t, i) || i.data,
  interval: G6(e.variables.byVarId.all, i) ? t.data : void 0
}), hyt = (e, t, i) => {
  var r;
  if (!Iw(t.data) && t.id > 0)
    return i.data;
  const n = e.variables.byVarId.all[i.variableId];
  if (hv(n))
    return {
      inputText: n.description || void 0
    };
  if (Sg(n)) {
    const g = Xm(((r = i.data) == null ? void 0 : r.inputValue) || 0, [t], Iu(n));
    return g ? {
      inputValue: g.input
    } : void 0;
  }
  return i.data;
}, S$ = (e, t, i, n, r, g) => {
  const o = [];
  return e.variables.flat[r].filter((a) => a.parentId === n.variableId || a.id === n.variableId).forEach((a) => {
    var d;
    const I = km(a), c = a.id === n.variableId;
    if (I && !c) {
      const C = i.filter((A) => A.variableId === a.id && A.instance.belongsToInstanceId === n.instance.id);
      o.push(...C.flatMap((A) => S$(e, t, i, A, r, g)));
    } else if (!((d = t[n.id || ""]) == null ? void 0 : d.some((A) => A.variableId === a.id)) && e.values.byVarId.all[a.id].length) {
      const A = g == null ? void 0 : g.find((p) => p.variableId === a.id && p.instance.id === n.id), b = e.values.byVarId.all[a.id].find((p) => p.id == (A == null ? void 0 : A.valueId)), m = c ? n : A && b ? Pf(e, b, A) : SZ(a, null, n.instance, !1);
      o.push(m);
    }
  }), o;
}, V$ = (e, t, i, n, r) => {
  const g = t.length ? de.groupBy(t, (o) => {
    var l;
    return ((l = o.instance) == null ? void 0 : l.id) || "";
  }) : {
    "": []
  };
  return S$(e, g, i, Ut, n, r);
}, V5 = (e) => e.instance.isInstanceLauncher ? e.instance.belongsToInstanceId : e.instance.id, hc = (e) => e.id;
function myt(e, t) {
  const i = /* @__PURE__ */ new Map();
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    if (r.id === t.id)
      continue;
    const g = r.variableId, o = i.get(g) ?? [];
    o.push(r), i.set(g, o);
  }
  return i;
}
function pyt(e, t) {
  const i = de.keyBy(e, (g) => g.id), n = de.memoize(am, (g, o, l) => l == null ? void 0 : l.id);
  return (g) => {
    const o = mg(g) ? g : i[g.instance.id];
    return n(t, e, o);
  };
}
function Byt(e, t, i, n) {
  if (n.id === Ut.id)
    return [];
  const r = [], g = e.get(n.variableId);
  if (!g)
    throw new Error("Variable not found");
  const o = qa(n), l = o === Ut.id ? Ut : t.find((a) => a.id === o);
  if (l && r.push(l), Ka(g)) {
    const a = i(n), I = myt(a, n), c = LZ(Jm(g)).reduce((d, C) => (d.push(...I.get(C) ?? []), d), []);
    r.push(...c);
  }
  return de.uniqBy(r, (a) => a.id);
}
function fyt(e, t, i, n) {
  const r = e.get(i.variableId), g = e.get(n.variableId), o = t.indexOf(r);
  return t.indexOf(g) - o;
}
function Zyt(e, t, i, n) {
  const r = pyt(n, e.variables.variableHierarchies);
  let g = n.reduce((o, l) => (Byt(i, n, r, l).forEach((I) => {
    const c = hc(I), d = o[c] ?? [];
    d.push(l), o[c] = d;
  }), o), {});
  return g = de.mapValues(g, (o) => (o.sort((l, a) => mg(l) && !mg(a) ? -1 : mg(a) && !mg(l) ? 1 : fyt(i, t, l, a)), o)), g;
}
function Gyt(e, t, i, n) {
  const r = (l, a) => {
    const I = {}, c = [a];
    for (; c.length > 0; ) {
      const d = c.pop(), C = l[hc(d)];
      if (!(!C || C.length === 0)) {
        I[hc(d)] = !0;
        for (const A of C)
          if (I[hc(A)]) {
            const b = e.get(A.variableId);
            if (Vi(b).suppressCycleDetection) {
              l[hc(d)] = [...l[hc(d)] ?? []].filter((p) => p.id !== A.id);
              const m = l[hc(A)] ?? [];
              m.push(d), l[hc(A)] = m;
            }
          } else
            c.push(A);
      }
    }
  }, g = de.groupBy(t, (l) => l.variableId);
  i.reduce((l, a) => {
    if (Vi(a).suppressCycleDetection) {
      const I = g[a.id] ?? [];
      l.push(...I);
    }
    return l;
  }, []).forEach((l) => {
    r(n, l);
  });
}
function yyt(e, t) {
  const i = y6(e.variables.flat.all), n = de.keyBy(e.groups, (r) => r.id);
  t.sort((r, g) => {
    const o = i[r.id], l = i[g.id];
    if (o === l) {
      const a = n[r.groupId], I = n[g.groupId];
      if (a && I) {
        const c = a.sort - I.sort;
        if (c !== 0)
          return c;
      }
      return r.sort - g.sort;
    }
    return o - l;
  });
}
function Wyt(e, t) {
  const i = [...e.variables.flat.all];
  yyt(e, i);
  const n = /* @__PURE__ */ new Map();
  i.forEach((l) => n.set(l.id, l));
  const r = [Ut, ...t], g = Zyt(e, i, n, r);
  return Gyt(n, r, i, g), Vbt(r, (l) => g[hc(l)] ?? []);
}
class w$ extends Error {
  constructor(t, i) {
    super(t), this.selection = i, this.name = "RuleEngineError";
  }
}
const Syt = 2e5, lf = 0, v$ = 2, R$ = async (e) => {
  const t = await e.checkHealthFn(e.iteration).catch((i) => {
    throw i;
  });
  if (!t)
    throw new Error("The configurator is too complex and/or unsolvable. Please simplify or correct dependencies between variables.");
  return t;
};
function Vyt(e, t, i) {
  var g;
  const n = `${t.instance.id}_${t.variableId}`;
  let r = (g = e.directHierarchyAndNeighbourInstanceIds) == null ? void 0 : g[n];
  if (!r) {
    const o = yZ(i), l = WZ(o, t, o), a = o.filter((I) => !l.some((c) => c.variableId === I.variableId));
    r = new Set([...a, ...l].map((I) => I.id)), e.directHierarchyAndNeighbourInstanceIds = e.directHierarchyAndNeighbourInstanceIds || {}, e.directHierarchyAndNeighbourInstanceIds[n] = r;
  }
  return r;
}
async function BV(e, t) {
  const {
    ruleEngineInput: i,
    filledSelections: n,
    iteration: r
  } = e;
  await R$(e).catch((d) => {
    throw d;
  });
  const g = i.variables.dependentVariablesById[t.variableId], o = Vyt(r, t, n), l = n.filter((d) => {
    var C;
    return (
      // Only consider selections in the same hierarchy or neighbours.
      o.has(d.instance.id) && // Don't backtrack to selections that have no options left.
      !((C = r == null ? void 0 : r.isLastOption) != null && C[d.id]) && (g == null ? void 0 : g.includes(d.variableId))
    );
  }), a = de.keyBy(l, (d) => d.id), I = r != null && r.backtrackToSelections ? {
    ...r.backtrackToSelections,
    ...a
  } : a, c = {
    status: v$,
    backtrackToSelections: I,
    stuckSelection: (r == null ? void 0 : r.stuckSelection) ?? t
  };
  return r.stuckSelection = c.stuckSelection, r.backtrackToSelections = c.backtrackToSelections, c;
}
const A1 = async (e) => {
  const {
    ruleEngineInput: t,
    filledSelections: i,
    emptySelections: n,
    depth: r,
    iteration: g,
    skipExpressionEvaluation: o
  } = e;
  if (!n.length)
    return {
      status: lf,
      selections: i
    };
  const l = n[0];
  r == 0 && (g.count = 0), g.count++, await R$(e).catch((I) => {
    throw I;
  });
  const a = t.variables.byVarId.all[l.variableId];
  return Ka(a) ? wyt(e, a, l).catch((c) => {
    throw c;
  }) : Xyt(e, l);
};
function X$(e, t) {
  var o;
  const {
    ruleEngineInput: i,
    validOptionsByInstanceAndVariable: n
  } = e, r = t.instance.id;
  return ((o = n[r]) == null ? void 0 : o[t.variableId]) || i.values.byVarId.locked[t.variableId].map((l) => ({
    value: l,
    conflicts: []
  }));
}
async function wyt(e, t, i) {
  const {
    emptySelections: n
  } = e, g = LZ(Jm(t)).find((o) => n.find((l) => l.variableId === o && l.id !== i.id));
  if (g) {
    const o = await vyt(e, t, g, i).catch((l) => {
      throw l;
    });
    if (o)
      return o;
  }
  return Ryt(e, t, i);
}
async function vyt(e, t, i, n) {
  var d, C;
  const {
    filledSelections: r,
    emptySelections: g,
    cycleDetectionMap: o,
    ruleEngineInput: l
  } = e, a = l.variables.byVarId.all[i], I = (d = o[n.variableId]) == null ? void 0 : d.includes(i), c = (C = o[i]) == null ? void 0 : C.includes(n.variableId);
  if ((!I || t.settings.templateOptions.suppressCycleDetection) && !c) {
    const [A, b] = de.partition(g.slice(1), (p) => p.variableId === i), m = await A1({
      ...e,
      filledSelections: [...r],
      emptySelections: [...A, n, ...b],
      cycleDetectionMap: {
        ...o,
        [i]: [...o[i] ?? [], n.variableId]
      }
    }).catch((p) => {
      throw p;
    });
    if (m)
      return m;
  } else if (!a.settings.templateOptions.suppressCycleDetection)
    throw new Error($i.t("Es gibt einen Zyklus in den berechneten Merkmalen."));
}
async function Ryt(e, t, i) {
  var b, m;
  const {
    ruleEngineInput: n,
    filledSelections: r,
    emptySelections: g,
    depth: o,
    iteration: l
  } = e, a = Cq(n.variables.flat.locked, n.values.flat.locked, n.variables.variableHierarchies, [...r, i], t, i, !((b = e.cycleDetectionMap[i.variableId]) != null && b.length), e.ruleEngineInput);
  if (a.errorMessage)
    return i.data = {
      error: {
        name: a.errorMessage,
        message: a.errorMessage,
        expression: t.settings.templateOptions.expression ?? ""
      },
      inputValue: a.result
    }, BV(e, i);
  const c = X$(e, i).map((p) => p.value), d = Xm(a.result, c, Iu(t));
  if (!d)
    return BV(e, i);
  const C = Pf(n, d.value, {
    ...i,
    data: {
      inputValue: d.input
    }
  }), {
    isValid: A
  } = Bv(n, r, C, !0);
  return A ? (((m = l == null ? void 0 : l.stuckSelection) == null ? void 0 : m.id) === C.id && (C.data = {
    ...C.data,
    error: void 0
  }, l.stuckSelection = void 0, l.backtrackToSelections = void 0), l.isLastOption || (l.isLastOption = {}), l.isLastOption[i.id] = !0, A1({
    ...e,
    depth: o + 1,
    filledSelections: [...r, C],
    emptySelections: g.slice(1)
  })) : (i.data = {
    error: {
      name: "Invalid",
      message: "Invalid",
      expression: t.settings.templateOptions.expression ?? ""
    },
    inputValue: a.result
  }, BV(e, i));
}
async function Xyt(e, t) {
  var I, c;
  const {
    ruleEngineInput: i,
    filledSelections: n,
    emptySelections: r,
    depth: g,
    iteration: o
  } = e, l = X$(e, t);
  for (const d of l) {
    const C = Pf(i, d.value, {
      ...t,
      // @ts-ignore
      data: {
        ...G6(i.variables.byVarId.all, t) ? {
          inputValue: ((I = t.data) == null ? void 0 : I.inputValue) || d.defaultValue
        } : d.value.data ?? t.data ?? {}
      }
    }), {
      isValid: A
    } = Bv(i, n, C, !0);
    if (A) {
      ((c = o == null ? void 0 : o.stuckSelection) == null ? void 0 : c.id) === C.id && (o.stuckSelection = void 0, o.backtrackToSelections = void 0);
      const b = [...n, C];
      o.isLastOption = {
        ...o.isLastOption,
        [t.id]: l.findIndex((p) => p.value.id === d.value.id) === l.length - 1
      };
      const m = await A1({
        ...e,
        depth: g + 1,
        filledSelections: b,
        emptySelections: r.slice(1)
      }).catch((p) => {
        throw p;
      });
      if (m.status === v$) {
        if (m.backtrackToSelections[C.id])
          continue;
        if (g === 0)
          continue;
        return m;
      } else if (m.status === lf)
        return m;
    }
  }
  return await BV(e, t);
}
function Hyt(e, t) {
  return e.variableId === (t == null ? void 0 : t.variableId) && e.instance.id === (t == null ? void 0 : t.instance.id);
}
function kyt(e, t, i, n) {
  return [...e, ...(t ?? []).filter((g) => !n.some((o) => o.instance.id === g.instance.id && o.variableId === g.variableId) && !e.some((o) => o.instance.id === g.instance.id && o.variableId === g.variableId))];
}
function IP(e, t, i, n, r) {
  e[t.instance.id] || (e[t.instance.id] = {}), e[t.instance.id][i.id] || (e[t.instance.id][i.id] = []), e[t.instance.id][i.id] = [{
    // @ts-ignore
    value: n,
    conflicts: [],
    defaultValue: r
  }, ...e[t.instance.id] ? e[t.instance.id][i.id] : []];
}
function Yyt(e, t, i) {
  e.forEach((n) => {
    const r = t.variables.byVarId.all[n.variableId];
    if (Sg(r) && r.settings.templateOptions.defaultValue && !n.data) {
      const g = Xm(Number(r.settings.templateOptions.defaultValue), t.values.byVarId.all[r.id].map((o) => o), Iu(r));
      g && IP(i, n, r, g.value, g.input);
    } else if (B6(r) && r.settings.templateOptions.previewImage && !n.data) {
      const g = {
        ...t.values.byVarId.all[r.id][1],
        data: {
          url: r.settings.templateOptions.previewImage,
          leftright: Rl.leftright,
          topbottom: Rl.topbottom,
          scale: Rl.scale
        },
        url: r.settings.templateOptions.previewImage
      };
      IP(i, n, r, g);
    }
  });
}
const Vw = async (e, t, i, n, r = 1, g, o = !1, l = !1, a = 0, I = (d) => Promise.resolve(d.count < Syt), c = !1) => {
  const d = !!n && t.includes(n);
  let C = t;
  n && d && (C = t.filter((x) => !to(x, n)));
  const A = de.uniqBy(yZ(n && d ? [...C, n] : C), (x) => x.id), b = C.filter((x) => A.some((J) => J.id === x.instance.id));
  b.length !== C.length && console.warn("Filled selections contain selections that are not instances or not in the instance hierarchy."), A.includes(Ut) || A.push(Ut);
  let m = [], p = [], B = A;
  if (n) {
    const x = Iyt(e.variables.flat.all, e.variables.byVarId.all, e.variables.dependentVariablesById, n.variableId, r);
    d && x.add(n.variableId);
    let J = n.instance.isInstanceLauncher ? n : iA(b, n) ?? Ut;
    for (let K = 1; K < r; K++) {
      if (!J) {
        J = Ut;
        break;
      }
      J = iA(b, J);
    }
    B = nA(b, J), B.push(J ?? Ut), p = b.filter((K) => !B.some((M) => M.id === K.instance.id) && !Ka(e.variables.byVarId.all[K.variableId])), m = b.filter((K) => !x.has(K.variableId) || !d && Hyt(K, n) || p.some((M) => M.id === K.id));
  } else
    l || (m = b);
  const f = e.ruleItems.instanceActionValueIds;
  m.push(...b.filter(
    (x) => x.valueId && (f == null ? void 0 : f.includes(x.valueId)) && !m.find((J) => J.id === x.id)
    // prevent duplicates
  ));
  const Z = V$(e, m, A, "locked", t);
  if (!Z || Z.length === 0)
    return p.length === 0 ? b : Vw(e, t, i, n, r + 1, 0, o, void 0, 0, I).catch((x) => {
      throw x;
    });
  const y = (
    // We only sort topologically at the initial fill. Otherwise we reuse the
    // optimised sort from the previous fill.
    l ? (Wyt(e, de.uniqWith([...Z, ...m], (x, J) => to(x, J))) ?? []).filter((x) => Z.find((J) => J.id === x.id)) : Z
  );
  if (n) {
    const x = y.findIndex((K) => to(K, n)), J = y.splice(x, 1);
    y.unshift(J[0]);
  }
  const W = {
    ...i
  }, V = kyt(m, b, n, y);
  if (Yyt(y, e, W), n && d) {
    const x = e.values.byVarId.all[n.variableId].filter((J) => J.id === n.valueId).map((J) => ({
      value: J,
      conflicts: []
    }));
    W[n.instance.id][n.variableId] = x;
  }
  const v = {
    ruleEngineInput: e,
    filledSelections: V,
    emptySelections: y,
    validOptionsByInstanceAndVariable: W,
    depth: 0,
    iteration: {
      count: a
    },
    cycleDetectionMap: {},
    skipExpressionEvaluation: o,
    checkHealthFn: I,
    usePromises: c
  }, H = await A1(v).catch((x) => {
    throw console.log("Error in fillEmptySelections", x), x;
  });
  if (H.status !== lf && (g == null || g < y.length))
    return Vw(e, t, W, n, r + 1, y.length, o, l, v.iteration.count, I).catch((x) => {
      throw x;
    });
  if (H.status !== lf)
    throw new w$("Could not find a solution", v.iteration.stuckSelection ?? n);
  return H.status === lf ? H.selections : !1;
}, H$ = (e, t) => {
  const i = {};
  return e.variables.flat.locked.filter((r) => r.parentId === t.variableId || r.id === t.variableId).forEach((r) => {
    i[r.id.toString()] = e.values.byVarId.locked[r.id].map((g) => ({
      value: g,
      conflicts: []
    }));
  }), {
    [t.id]: i
  };
}, ww = (e, t, i, n) => {
  e[t] || (e[t] = {}), e[t][i] || (e[t][i] = []), e[t][i].push(...n);
}, Fyt = (e, t) => {
  const i = e;
  sw(!1);
  const n = Av(i, (r) => Object.keys(t).forEach((g) => Object.keys(t[g]).forEach((o) => ww(r, g, o, t[g][o]))));
  return sw(!0), n;
}, HA = (e, t, i = !1) => ({
  locked: e,
  free: t,
  all: {
    selections: [...t.selections, ...e.selections],
    validOptions: i ? Fyt(t.validOptions, e.validOptions) : {},
    invalidOptions: e.invalidOptions,
    touched: e.touched
  }
}), cP = (e, t) => {
  const i = {}, n = {}, r = /* @__PURE__ */ new Set();
  return e.variables.flat.all.forEach((g) => {
    const {
      hideIfSingleOption: o,
      hideIfNoOptions: l
    } = Vi(g);
    (o || l) && r.add(g.id);
  }), t.forEach((g) => {
    if (!r.has(g.variableId))
      return;
    const o = e.values.byVarId.all[g.variableId] ?? [], l = t.filter((C) => C.id !== g.id), a = F$(o.map((C) => {
      var m;
      const A = SZ(g.variableId, C, g.instance, g.instance.isInstanceLauncher), b = ((m = Bv(e, l, A, !1).conflicts) == null ? void 0 : m.map((p) => p[1])) ?? [];
      return {
        value: C,
        conflicts: b
      };
    }), g), [I, c] = de.partition(a, (C) => !C.conflicts.length), d = g.instance.id;
    ww(i, d, g.variableId, I), ww(n, d, g.variableId, c);
  }), {
    valid: i,
    invalid: n
  };
}, k$ = (e) => H$(e, Ut), xyt = (e, t) => Object.assign({}, ...t.map((i) => H$(e, i))), Y$ = (e, t, i) => {
  const n = yZ(t.selections), r = V$(e, t.selections, n, "all"), g = {}, o = r.map((l) => {
    const a = e.values.byVarId.all[l.variableId].map((d) => ({
      value: d,
      conflicts: []
    }));
    ww(g, l.instance.id, l.variableId, a);
    const I = e.variables.byVarId.all[l.variableId];
    if (Sg(I)) {
      const d = Number(I.settings.templateOptions.defaultValue);
      if (d) {
        const C = Xm(d, a.map((A) => A.value), Iu(I));
        if (C)
          return i.find((A) => to(A, l)) || Pf(e, C.value, {
            ...l,
            data: {
              inputValue: C.input
            }
          });
      }
    } else if (B6(I) && I.settings.templateOptions.previewImage) {
      const d = {
        ...a[1]
      };
      if (d) {
        d.value = {
          ...d.value,
          data: {
            // @ts-ignore
            url: I.settings.templateOptions.previewImage,
            leftright: Rl.leftright,
            topbottom: Rl.topbottom,
            scale: Rl.scale
          },
          value: "1"
        };
        const C = {
          ...l,
          data: {
            url: I.settings.templateOptions.previewImage,
            leftright: Rl.leftright,
            topbottom: Rl.topbottom,
            scale: Rl.scale
          },
          valueId: d.value.id
        };
        return i.find((A) => to(A, l)) || C;
      }
    }
    return i.find((d) => to(d, l)) || Pf(e, a[0].value, l);
  });
  return HA(t, {
    selections: o,
    validOptions: g
  });
}, AE = (e, t, i) => {
  const n = yZ(t), r = xyt(e, n);
  return Object.keys(r).forEach((g) => Object.keys(r[g]).forEach((o) => {
    const l = Number(o), a = t.find((I) => I.variableId == l && I.instance.id === g);
    a && (i.find((I) => I.variableId === l && I.instance.id === a.instance.id) ? r[g][o] = r[g][o].filter((I) => I.value.id === a.valueId) : r[g][o] = F$(r[g][o], a));
  })), r;
}, Dyt = (e, t) => {
  var a;
  const i = e.slice().sort((I, c) => c.value.id - I.value.id), n = i.findIndex((I) => I.value.id === t.valueId);
  if (n === -1)
    return i;
  const r = ((a = t.data) == null ? void 0 : a.inputValue) ?? 0, g = [i[n]];
  let o = n + 1, l = n - 1;
  for (; g.length !== i.length; ) {
    const I = i[o], c = i[l], d = I ? I.value.data.left - r : 1 / 0, C = c ? r - c.value.data.right : 1 / 0;
    !c || // including interval is (if contested) always closer or equal to any
    // other interval
    (d === C ? I.value.data.leftInclude : d < C) ? (o++, g.push(I)) : (l--, g.push(c));
  }
  return g;
}, F$ = (e, t) => {
  if (pv(t))
    return Dyt(e, t);
  {
    const i = e.find((n) => n.value.id === t.valueId);
    return i ? wye(e, [i]) : e;
  }
}, x$ = async (e, t, i, n, r = !1, g, o = !1) => {
  const l = i ? [i, ...t.selections.filter((c) => !to(c, i))] : t.selections, a = AE(e, l, []), I = await Vw(e, n ?? [], a, i, void 0, void 0, void 0, r, 0, g, o).catch((c) => {
    throw c;
  });
  return I ? {
    selections: I,
    validOptions: {},
    invalidOptions: {},
    touched: t.touched
  } : !1;
}, Jyt = async (e, t, i, n, r = !1) => {
  const g = {
    selections: [],
    validOptions: k$(e),
    touched: {},
    invalidOptions: {}
  }, o = await x$(e, g, i, n, r).catch((l) => {
    throw l;
  });
  return o ? Y$(
    e,
    o,
    // Since we are passing all selections here, we are assuming that all
    // selections in the new state are locked and filled.
    []
  ) : !1;
}, Eyt = (e, t, i, n) => {
  let r = D$(e, t, i, n);
  return r = HA(r.locked, r.free), bE(r);
}, D$ = (e, t, i, n) => ({
  ...t,
  locked: {
    ...t.locked,
    selections: i,
    validOptions: n ? k$(e) : t.locked.validOptions
  }
});
function Nyt(e, t, i) {
  const n = !!e.variables.byVarId.free[i.variableId], r = t[n ? "free" : "locked"].selections.filter((I) => !to(I, i)), g = [i, ...r], o = n ? t.locked : {
    selections: g,
    validOptions: t.all.validOptions,
    invalidOptions: t.all.invalidOptions,
    touched: t.locked.touched
  }, l = n ? {
    ...t.free,
    selections: g
  } : t.free;
  return HA(o, l);
}
const Lyt = (e, t, i) => {
  if (!e)
    return {
      state: t,
      changes: [],
      touchedChanges: [],
      onlyUntouched: !0,
      lastManualChange: i
    };
  const n = de.keyBy(e.all.selections.filter((o) => o.instance.isInstanceLauncher), (o) => o.id), r = e.locked.selections.reduce((o, l) => {
    if (i && to(l, i))
      return o;
    const a = t.locked.selections.find((c) => to(l, c));
    if (!a && !i || !a && i && PZe(n, l).some((d) => to(d, i)) || l.valueId === (a == null ? void 0 : a.valueId))
      return o;
    const I = [l, a];
    return o.push(I), o;
  }, []), g = r.filter((o) => {
    var a;
    const l = o[0];
    return (a = e.locked.touched[l.instance.id]) == null ? void 0 : a.includes(l.variableId);
  });
  return {
    state: t,
    changes: r,
    touchedChanges: g,
    onlyUntouched: !g.length,
    lastManualChange: i
  };
}, fV = async (e, t, i, n, r, g, o = !1) => {
  const l = t.filter((m) => {
    var p;
    return (p = e.values.byVarId.all[m.variableId]) == null ? void 0 : p.some((B) => B.id === m.valueId);
  });
  l.sort(lA);
  const {
    locked: a,
    free: I
  } = HJ(e, l), c = AE(e, t, n ? [n] : []), C = await x$(e, {
    selections: a,
    validOptions: c,
    invalidOptions: {},
    touched: i
  }, n, r, void 0, g, o).catch((m) => {
    throw m;
  });
  if (!C)
    throw new Error("Unable to calc state");
  return {
    state: Y$(e, C, I),
    changes: [],
    touchedChanges: [],
    onlyUntouched: !0
  };
}, zZ = async (e, t, i, n, r, g, o = !0, l, a = !1) => {
  r || (r = kye(n.variableId, i.id, t.locked.selections) + 1);
  const I = SZ(n.variableId, n, i.instance, !0, g, r), c = AE(e, [...t.locked.selections, I], [I]), d = await Vw(
    e,
    [...t.locked.selections, I],
    c,
    I,
    void 0,
    void 0,
    // we need to skip expression evaluation here as we only want to fill
    // children selections. Everything else will be filled in engineThunk later.
    !0,
    void 0,
    0,
    l,
    a
  ).catch((A) => {
    throw A;
  });
  if (d === !1)
    throw new Error("Selections are false");
  let C = D$(e, t, d, !1);
  return C = HA(C.locked, C.free), o && (C = Yv(e, C, [{
    instanceId: I.instance.id,
    variableId: I.variableId
  }])), bE(C, I);
}, OZ = (e, t) => {
  const i = nA(e.all.selections, t), n = [t.id, ...i.map((l) => l.id)], r = (l) => !n.includes(l.id) && !n.includes(qa(l));
  return {
    state: {
      ...e,
      locked: {
        ...e.locked,
        selections: e.locked.selections.filter(r),
        validOptions: de.omit(e.locked.validOptions, n),
        invalidOptions: de.omit(e.locked.invalidOptions, n),
        touched: de.omit(e.locked.touched, n)
      },
      free: {
        ...e.free,
        selections: e.free.selections.filter(r),
        validOptions: de.omit(e.free.validOptions, n)
      },
      all: {
        ...e.all,
        selections: e.all.selections.filter(r),
        validOptions: de.omit(e.all.validOptions, n),
        invalidOptions: de.omit(e.all.invalidOptions, n),
        touched: de.omit(e.all.touched, n)
      }
    },
    changes: [],
    onlyUntouched: !0,
    touchedChanges: [],
    lastManualChange: t
  };
}, bE = (e, t) => ({
  state: e,
  changes: [],
  touchedChanges: [],
  onlyUntouched: !1,
  lastManualChange: t
}), b1 = (e, t, i, n, r, g = !1, o = !0) => {
  performance.mark("change-var-start");
  const l = SZ(n.variableId, n, i.instance, !1, r);
  let a = Nyt(e, t, l);
  return performance.mark("change-var-valid"), o && (a = Yv(e, a, [{
    instanceId: l.instance.id,
    variableId: l.variableId
  }], g)), bE(a, l);
}, Kyt = (e, t) => (i) => {
  let n = t;
  return Object.entries(i).forEach(([r, g]) => {
    const o = e.variables.flat.all.find((b) => b.key === r);
    if (!o)
      return;
    const l = Sg(o), a = Hm(o), I = e.values.byVarId.all[o.id].find((b) => l ? Wc(oA(+g), b.data) : a ? !0 : b.key === g);
    if (!I)
      return;
    const c = n.state.all.selections.find((b) => b.variableId === o.id);
    if (!c)
      return;
    const d = n.state.all.selections.find((b) => b.id === c.instance.id) || Ut, C = a ? {
      inputText: hv(o) ? o.description || void 0 : g.toString()
    } : void 0, A = b1(e, n.state, d, I, l ? {
      inputValue: +g
    } : C, !0);
    A && (n = A);
  }), n;
}, h1 = (e) => e.reduce((t, i) => i.instance.hierarchyLevel === t.instance.hierarchyLevel && mg(i) && !mg(t) || i.instance.hierarchyLevel > t.instance.hierarchyLevel ? i : t, Ut), Tm = (e, t) => ((t == null ? void 0 : t.validSelectionCombinations[t == null ? void 0 : t.ruleItem.id]) ?? []).map((i) => ({
  ...e,
  ruleItem: t.ruleItem,
  ruleColumn: t.column,
  anchoringSelection: h1(i)
})), Tyt = {
  type: "hideGroups",
  isOfType: Tye,
  createActions: Tm
};
function J$(e, t) {
  if (de.isArray(e))
    return de.intersectionBy(e, t, "id");
}
const hE = (e, t) => e.reduce((i, n) => {
  const r = t[n.id];
  return de.assignWith(i, r, J$);
}, {}), E$ = (e, t, i, n, r, g) => r.flatMap((o) => {
  const l = hE(o, n[i.id]);
  return e.reduce((I, c) => {
    const d = t[c], C = d != null && d.parentId ? d.parentId : Ut.variableId, A = l[C];
    return A && I.push(g(c, A.map((b) => b.id).sort(), o)), I;
  }, []);
}, []), N$ = () => (e, {
  column: t,
  ruleItem: i,
  ruleEngineInput: n,
  selectionScopes: r,
  validSelectionCombinations: g
}) => {
  const o = e.variables, l = n.variables.byVarId.all, a = (g == null ? void 0 : g[i.id]) ?? [];
  return E$(o, l, i, r, a, (I, c) => ({
    variableId: I,
    instanceIds: c,
    ruleItem: i,
    ruleColumn: t
  }));
}, Myt = N$(), Pyt = {
  type: "hideVariables",
  isOfType: Kye,
  createActions: Myt
}, Uyt = (e, {
  column: t,
  ruleItem: i,
  validSelectionCombinations: n,
  selectionScopes: r,
  ruleEngineInput: g
}) => {
  const o = n[i.id], l = g.variables.byVarId.all, a = g.values.byId;
  return (o ?? []).reduce((c, d) => {
    const C = hE(d, r[i.id]), A = a[e.valueId];
    if (!A)
      return console.warn(`Could not find value with id ${e.valueId} for actionEntry ${JSON.stringify(e, null, 2)} of ruleItem ${JSON.stringify(i, null, 2)}!`), c;
    const b = l[A.variableId];
    if (!b)
      return console.warn(`Could not find variable with id ${A.variableId} for value ${JSON.stringify(A, null, 2)}!`), c;
    const m = b.parentId ? b.parentId : Ut.variableId, p = C[m];
    return p && p.forEach((B) => {
      c.push({
        ...e,
        selectionScope: C,
        parentSelection: B,
        anchoringSelection: h1(d),
        ruleItem: i,
        ruleColumn: t
      });
    }), c;
  }, []);
}, zyt = {
  type: "instances",
  isOfType: kJ,
  createActions: Uyt
}, Oyt = {
  type: "popups",
  isOfType: Eye,
  createActions: Tm
}, L$ = [zyt, Pyt, Tyt, Oyt], Qyt = _8(L$), jyt = (e, t) => {
  const i = t.all.selections.slice().sort(tu), n = VI("setExpressionEngineSelections", i), r = Aq(e.variables.flat.all, e.values.flat.all, e.variables.variableHierarchies, n, void 0, void 0, e), {
    free: g,
    locked: o
  } = HJ(e, r);
  return {
    state: HA({
      ...t.locked,
      selections: o
    }, {
      selections: g,
      validOptions: t.free.validOptions
    })
  };
}, qyt = (e, t, i, n) => {
  if (!i)
    return t;
  const r = t.state.locked.selections.map((g) => {
    var o, l, a, I;
    if (pv(g) && // Calculated Variables should not be clamped because in their
    // evaluation they get the correct value anyway!
    !Ka(e.variables.byVarId.all[g.variableId])) {
      if (n && (g == null ? void 0 : g.valueId) === n.valueId && (g == null ? void 0 : g.id) === n.id)
        return wI({
          data: {
            inputValue: (o = n.data) == null ? void 0 : o.inputValue
          }
        })(g);
      const c = i.state.locked.selections.find((B) => to(B, g));
      if (!c)
        return g;
      const d = e.variables.byVarId.all[g.variableId], C = Iu(d), A = e.values.byVarId.all[g.variableId].find((B) => B.id === g.valueId), b = ((l = c.data) == null ? void 0 : l.inputValue) ?? 0, m = ((a = g.data) == null ? void 0 : a.inputValue) ?? 0;
      let p;
      return A == null ? g : (Wc(oA(b), A.data) ? p = b : (b < m ? p = A.data.left + (A.data.leftInclude ? 0 : C) : p = A.data.right - (A.data.rightInclude ? 0 : C), Wc(oA(p), A.data) || (p = (I = g.data) == null ? void 0 : I.inputValue)), wI({
        data: {
          inputValue: p
        }
      })(g));
    } else
      return g;
  });
  return {
    ...t,
    state: HA({
      ...t.state.locked,
      selections: r
    }, t.state.free)
  };
};
function _yt(e, t, i, n, r, g) {
  const o = de.groupBy(e || [], (l) => l.valueId);
  return de.map(o, (l) => {
    const a = l.reduce((I, c) => {
      if (c.expression) {
        const {
          result: d
        } = Lv(t, i, n, r, c.expression, c.anchoringSelection, g);
        return I + d;
      } else
        I += c.count ?? 0;
      return I;
    }, 0);
    return {
      valueId: l[0].valueId,
      // it is possible that expressions add a negative amount.
      // This prevents everything from crashing.
      count: Math.max(a, 0)
    };
  });
}
const $yt = async (e, t, i, n, r, g) => await t.reduce(async (l, a) => {
  var A, b;
  const I = await l.catch((m) => {
    throw m;
  });
  yZ(I.state.all.selections);
  const d = r.state.all.selections.filter((m) => m.valueId === a.valueId && m.instance.belongsToInstanceId === e.instance.id), C = a.count - d.length;
  if (C > 0) {
    let m = I;
    if (e.id !== Ut.id && !m.state.all.selections.includes(e))
      return console.warn(`Parent instance ${e.id} not found in current state!`, e, n[a.valueId]), Promise.resolve(I);
    for (let p = 0; p < C; p++) {
      const B = await zZ(i, m.state, e, n[a.valueId], void 0, void 0, !1, g).catch((f) => {
        throw f;
      });
      if (B)
        m = B;
      else {
        const f = n[a.valueId].variableId, Z = a.valueId + ` - Variable ${f} (${(b = (A = i == null ? void 0 : i.variables) == null ? void 0 : A.byVarId.all[f]) == null ? void 0 : b.label})`;
        throw console.error(`Could not create instance for value.id: ${Z}`), new Error("Gültiger Wert konnte nicht ermittelt werden: " + Z);
      }
    }
    return Promise.resolve(m);
  } else if (C < 0) {
    let m = I;
    const p = C * -1;
    for (let B = 0; B < p; B++) {
      const f = OZ(m.state, d[B]);
      if (f)
        m = f;
      else
        throw new Error(`Could not delete instance for value.id: ${a.valueId}`);
    }
    return Promise.resolve(m);
  }
  return I;
}, Promise.resolve(r)).catch((l) => {
  throw l;
});
async function eWt(e, t, i, n) {
  const r = [...i.state.all.selections].sort(lA), g = An(r), o = t.variables.flat.all, l = t.values.flat.all, a = t.values.byId, I = Object.values(de.groupBy(e.instances, (d) => d.parentSelection.id)).sort((d, C) => d[0].parentSelection.instance.hierarchyLevel - C[0].parentSelection.instance.hierarchyLevel);
  return await de.reduce(I, async (d, C) => {
    let A = await d.catch((B) => {
      throw B;
    });
    const b = C[0].parentSelection.id, m = g[b] ?? Ut, p = de.isEmpty(C) ? [] : _yt(C, o, l, t.variables.variableHierarchies, r, t);
    return A = await $yt(m, p, t, a, A, n).catch((B) => {
      throw B;
    }), Promise.resolve(A);
  }, Promise.resolve(i)).catch((d) => {
    throw d;
  });
}
function tWt(e) {
  const t = e.state.all.selections, i = An(t), n = WZ(t, Ut), r = An(n);
  return t.reduce((g, o) => {
    if (mg(o) && // If the selection is not part of the tree starting at the root
    // selection and
    !r[o.instance.id] && // if the parent selection does not exist anymore
    !i[o.instance.belongsToInstanceId]) {
      const l = OZ(g.state, o);
      if (l)
        return l;
      throw new Error(`Could not delete orphaned instance: ${o}`);
    }
    return g;
  }, e);
}
async function iWt(e, t, i, n) {
  let r = await eWt(i, e, t, n).catch((g) => {
    throw g;
  });
  return r = tWt(r), r;
}
const nWt = (e, t) => {
  const i = e.hideVariables, n = t.hideVariables;
  if (!(i.length === n.length))
    return !1;
  const g = e.hideGroups, o = t.hideGroups;
  return !(!(g.length === o.length) || !Le.equals(de.sortBy(i, ["variableId", "instanceIds"]), de.sortBy(n, ["variableId", "instanceIds"])) || !Le.equals(de.sortBy(g, ["groups"]), de.sortBy(o, ["groups"])));
}, rWt = (e, t) => {
  const i = nA(e.state.all.selections, Ut);
  i.sort(tu);
  const n = nA(t.state.all.selections, Ut);
  return n.sort(tu), de.isEqual(i, n);
};
function gWt(e, t) {
  const i = new Set(t.state.all.selections.filter((r) => iw(e, r.variableId, r.instance.id)));
  return {
    ...t,
    state: {
      ...t.state,
      all: {
        ...t.state.all,
        selections: t.state.all.selections.filter((r) => !i.has(r))
      },
      locked: {
        ...t.state.locked,
        selections: t.state.locked.selections.filter((r) => !i.has(r))
      },
      free: {
        ...t.state.free,
        selections: t.state.free.selections.filter((r) => !i.has(r))
      }
    }
  };
}
const dP = 16;
function oWt(e, t) {
  var i;
  return (
    // TODO: We should simply check the variable settings in
    // removeConflictingInstanceSelections instead of checking them for the
    // selection every time.
    ((i = e.variables.byVarId.all[t.variableId]) == null ? void 0 : i.settings.templateOptions.deleteInvalidInstances) ?? !1
  );
}
function lWt(e, t, i) {
  return e ? (e == null ? void 0 : e.state.locked.selections).reduce((g, o) => {
    if (!mg(o) || !oWt(t, o))
      return g;
    const l = i == null ? void 0 : i.state.all.selections.find((a) => to(o, a));
    return l && l.valueId !== o.valueId && g.push(o), g;
  }, []) : [];
}
function aWt(e, t, i) {
  if (e === null)
    return t;
  const n = lWt(e, i, t);
  if (n.length === 0)
    return t;
  let r = t;
  return n.sort((g, o) => o.instance.hierarchyLevel - g.instance.hierarchyLevel).forEach((g) => {
    const o = OZ(r.state, g);
    if (o)
      r = o;
    else
      throw new Error(`Could not delete instance: ${g}`);
  }), r;
}
function sWt(e, t) {
  const i = (g, o) => g.all.selections.every((l, a) => {
    var I, c;
    return (I = l.data) != null && I.inputValue ? l.data.inputValue === ((c = o.all.selections[a].data) == null ? void 0 : c.inputValue) : !0;
  });
  let n = 0, r;
  for (; !r || !i(r, e.state); ) {
    if (n > 20)
      throw new Error(Ug("Maximale Anzahl an Iterationen für die Expression Engine erreicht! Es gibt zu Komplexe Zyklen in den berechneten Merkmalen."));
    r = e.state, e = {
      ...e,
      state: jyt(t, e.state).state
    }, n++;
  }
  return e;
}
const K$ = async (e, t, i, n, r, g, o, l = !1) => {
  var x, J, K, M, L, N, U;
  const a = Pi(e), I = e.metadata, c = hA(e), d = Og(e), C = $l(e), A = Rc(e), b = x6(e), m = n || nr(e), p = r || T3(e), B = Jr(e);
  let f = zh(e) || f7, Z = m, y = i;
  const W = (O, $) => W$(b, c, A, C, d, O, $, e);
  let V = 0;
  try {
    for (; V < dP; ) {
      const O = y;
      Z = W(f, Z);
      let $ = !1;
      y.lastManualChange && ($ = !!Z.variables.byVarId.free[((x = y.lastManualChange) == null ? void 0 : x.variableId) ?? ""]), $ || (y = await fV(Z, ((K = (J = y.state) == null ? void 0 : J.all) == null ? void 0 : K.selections) ?? [], ((L = (M = y.state) == null ? void 0 : M.all) == null ? void 0 : L.touched) ?? [], i == null ? void 0 : i.lastManualChange, (U = (N = y == null ? void 0 : y.state) == null ? void 0 : N.locked) == null ? void 0 : U.selections, o, l).catch((be) => {
        throw be;
      }), y = qyt(Z, y, B ?? void 0, i == null ? void 0 : i.lastManualChange), y = sWt(y, Z));
      const ne = f;
      if ((l === !1 || !$) && (f = Qyt(p, Z, y, a, I), y = await iWt(Z, y, f, o).catch((be) => {
        throw be;
      })), V > 0 && nWt(ne, f) && rWt(O, y))
        break;
      V++;
    }
  } catch (O) {
    if (O instanceof w$) {
      if (!B)
        throw O;
      return {
        status: "no-solution-conflict",
        faultySelection: O.selection,
        engineState: {
          ruleEngineState: {
            ...Jr(e),
            lastManualChange: i.lastManualChange
          },
          ruleEngineInput: nr(e),
          actionEngineInput: T3(e),
          actionEngineState: zh(e)
        }
      };
    }
    throw O;
  }
  if (V >= dP)
    throw new Error(Ug("Maximale Anzahl an Iterationen erreicht! Die Regelkonflikte können nicht aufgelöst werden."));
  t && (f = {
    ...f,
    ...t(p, Z, y, a, I)
  }), Z = W(f, Z), y = gWt(Z, y), y = udt(Z, y, e), y = aWt(B, y, Z), B && (y = Lyt(B.state, y.state, i == null ? void 0 : i.lastManualChange));
  const w = {
    ruleEngineInput: Z,
    ruleEngineState: y,
    actionEngineInput: p,
    actionEngineState: f
  }, v = zh(e);
  if (w.actionEngineState.popups.length > 0) {
    const O = w.actionEngineState.popups.find(($) => $.invalid || !(v != null && v.popups.find((ne) => ne.ruleItemId === $.ruleItemId)));
    if (O)
      return {
        status: "popup-action",
        engineState: w,
        popupAction: O
      };
  }
  return g ? {
    status: "no-conflict",
    engineState: w
  } : {
    status: nWe(w) ? IWt(e, i.lastManualChange, w) : "conflict",
    engineState: w
  };
}, IWt = (e, t, i) => {
  const n = t == null ? void 0 : t.variableId, r = n ? qr(n)(e) : void 0, g = (r == null ? void 0 : r.settings.templateOptions.hideInvalidUntouchedOptions) || !1, o = (r == null ? void 0 : r.settings.templateOptions.hideIfSingleOption) || !1, l = (r == null ? void 0 : r.settings.templateOptions.disableIfSingleOption) || !1, a = g || o || l;
  let I = !1;
  if (a) {
    let d = cWt(e, i.ruleEngineState, n);
    d = d.filter((C) => {
      const A = C[0] || C[1], b = qr(A.variableId)(e), m = vm(i.ruleEngineState.state.all.selections, A);
      return !(!b || Ka(b) || Zv(b) || //is child of another component variable
      !m.some((p) => p.instance.id === A.instance.id));
    }), I = d.length > 0;
  }
  return I ? "soft-conflict" : "no-conflict";
};
function cWt(e, t, i) {
  return t.changes.filter((n) => {
    const r = n[0], g = qr(r.variableId)(e);
    if (g == null ? void 0 : g.settings.templateOptions.suppressConflictDialog) {
      const l = g == null ? void 0 : g.settings.templateOptions.suppressConflictDialogVariableIds;
      return !(l != null && l.includes(i));
    }
    return !0;
  });
}
const uP = (e, t, i, n, r) => {
  let g = e;
  if (t) {
    const o = Br(n), l = Og(n), a = $l(n), {
      result: I,
      errorMessage: c
    } = Lv(l, a, r, o, t, i);
    g = I, c != null && console.warn(c);
  }
  return g;
}, dWt = (e) => (t) => jpt(t)[e], uWt = (e, t) => (i) => {
  var b;
  const n = /* @__PURE__ */ new Date(), r = Pi(i), g = i.common.dealerData, o = (b = g.apps) == null ? void 0 : b.find((m) => m.appId == (r == null ? void 0 : r.id)), l = (g == null ? void 0 : g.discount) || 0, a = (g == null ? void 0 : g.surcharge) || 0, I = (o == null ? void 0 : o.discount) != 0 ? o == null ? void 0 : o.discount : null, c = (o == null ? void 0 : o.surcharge) != 0 ? o == null ? void 0 : o.surcharge : null, d = I ?? l, C = c ?? a, A = Uq(i, e).filter((m) => !m.displayOnly && (m.fromDate == null || new Date(m.fromDate) <= n) && (m.toDate == null || new Date(m.toDate) >= n) && (m.fromQty == null || m.fromQty == 0 || m.fromQty <= t) && (m.toQty == null || m.toQty == 0 || m.toQty >= t)).sort((m, p) => m.sort - p.sort).map((m) => ({
    ...m,
    price: m.price * (1 - d / 100) * (1 + C / 100)
  }));
  return A.length == 0 ? {
    price: 0,
    type: Bc.fixed
  } : A[0];
}, CWt = (e, t) => {
  const i = nr(e), n = uP(t.count, t.expression, t.anchoringSelection, e, i.variables.variableHierarchies) ?? 1, r = !gm(t.amount) || !gm(t.amountExpression) ? uP(t.amount, t.amountExpression, t.anchoringSelection, e, i.variables.variableHierarchies) : void 0, g = dWt(t.articleId)(e);
  if (!g) {
    console.warn(`Article not found: ${t.articleId} for article action: ${JSON.stringify(t, null, 2)}`);
    return;
  }
  const o = uWt(t.articleId, n)(e);
  return {
    articleAction: t,
    qty: n,
    amount: r,
    article: g,
    price: o,
    main: t.main
  };
}, T$ = () => (e, t) => {
  const i = t(), n = oye(i).reduce((r, g) => {
    const o = CWt(i, g);
    return o && o.qty > 0 && (gm(o.amount) || o.amount > 0) && r.push(o), r;
  }, []);
  return e(Ict(n)), n;
}, w5 = (e) => (t, i) => {
  t(lct((e == null ? void 0 : e.actionEngineInput) || null)), t(G7((e == null ? void 0 : e.actionEngineState) || null)), t(Adt((e == null ? void 0 : e.ruleEngineInput) || null)), t(s8((e == null ? void 0 : e.ruleEngineState) || null)), t(T$());
};
function AWt(e, t) {
  sw(!1);
  const {
    valid: i,
    invalid: n
  } = cP(e, t.state.locked.selections);
  t.state.locked.validOptions = i, t.state.locked.invalidOptions = n;
  const r = cP(e, t.state.free.selections).valid;
  t.state.free.validOptions = r, t.state = HA(t.state.locked, t.state.free, !0), sw(!0);
}
const M$ = (e) => (t) => {
  switch (e.status !== "error" && e.status !== "no-solution-conflict" && AWt(e.engineState.ruleEngineInput, e.engineState.ruleEngineState), e.status) {
    case "soft-conflict":
      t(w5(e.engineState));
      break;
    case "no-solution-conflict":
      t(mw(e));
      break;
    case "popup-action":
      t(Sct({
        action: e.popupAction,
        newState: e.engineState
      }));
      break;
    case "no-conflict":
      t(w5(e.engineState));
      break;
    case "conflict":
      t(mw(e));
      break;
  }
}, P$ = (e, t, i, n, r) => async (g, o) => {
  performance.mark("engine-start");
  const l = o(), a = await K$(l, e, t, i, n, r);
  return g(M$(a)), a;
}, mE = {
  status: "error"
}, QZ = (e) => (t, i) => {
  const n = i(), {
    ruleEngineInput: r,
    ruleEngineState: g
  } = wZ(n), o = Ns(n);
  if (!r || !g)
    return console.warn("Rule engine not initialized!"), mE;
  const l = OZ(g.state, e);
  return t(j8(e.valueId, !1)), o.find((a) => a.id === e.id) && t(I8(o.filter((a) => a.id !== e.id))), t(qZ(l));
}, jZ = (e, t) => async (i, n) => {
  const {
    ruleEngineInput: r,
    ruleEngineState: g,
    openInstance: o
  } = wZ(n());
  if (!r || !g)
    return console.warn("Rule engine not initialized!"), mE;
  const l = await zZ(r, g.state, t || o, e).catch((a) => {
    throw a;
  });
  return i(j8(e.id, !0)), i(qZ(l));
}, bWt = (e, t) => (i, n) => {
  const r = n(), g = pA(e)(r);
  if (!g) {
    console.error("Value not found");
    return;
  }
  i(jZ(g, t));
}, pE = (e, t, i, n) => async (r, g) => {
  const {
    ruleEngineInput: o,
    ruleEngineState: l,
    openInstance: a
  } = wZ(g());
  if (!o || !l) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const c = o.values.flat.all.find((A) => A.id === e) || o.values.byVarId.all[t][0], d = b1(o, l.state, n || a, c, i), C = await r(qZ(d)).catch((A) => {
    throw A;
  });
  return r(CAt(t, c, i)), C;
}, qZ = (e) => async (t) => e ? await t(P$(kE, e)).catch((i) => {
  throw i;
}) : (console.error("Rule engine failed"), mE), CP = 512, hWt = "application/pdf", mWt = (e) => {
  const t = e, i = [];
  for (let n = 0; n < t.length; n += CP) {
    const r = t.slice(n, n + CP), g = new Array(r.length);
    for (let l = 0; l < r.length; l++)
      g[l] = r.charCodeAt(l);
    const o = new Uint8Array(g);
    i.push(o);
  }
  return new Blob(i, {
    type: hWt
  });
}, pWt = (e) => URL.createObjectURL(mWt(e)), BWt = (e, t = "Konfiguration.pdf") => {
  fWt(pWt(e), t);
}, fWt = (e, t) => {
  const i = document.createElement("a");
  i.download = t, i.href = e, i.click();
};
var vw, _Y = typeof Or < "u" && (Or.crypto || Or.msCrypto);
if (_Y && _Y.getRandomValues) {
  var AP = new Uint8Array(16);
  vw = function() {
    return _Y.getRandomValues(AP), AP;
  };
}
if (!vw) {
  var bP = new Array(16);
  vw = function() {
    for (var e = 0, t; e < 16; e++)
      e & 3 || (t = Math.random() * 4294967296), bP[e] = t >>> ((e & 3) << 3) & 255;
    return bP;
  };
}
var U$ = vw, z$ = [];
for (var CS = 0; CS < 256; ++CS)
  z$[CS] = (CS + 256).toString(16).substr(1);
function ZWt(e, t) {
  var i = t || 0, n = z$;
  return n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + "-" + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]] + n[e[i++]];
}
var O$ = ZWt, GWt = U$, yWt = O$, yd = GWt(), WWt = [
  yd[0] | 1,
  yd[1],
  yd[2],
  yd[3],
  yd[4],
  yd[5]
], hP = (yd[6] << 8 | yd[7]) & 16383, $Y = 0, eF = 0;
function SWt(e, t, i) {
  var n = t && i || 0, r = t || [];
  e = e || {};
  var g = e.clockseq !== void 0 ? e.clockseq : hP, o = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), l = e.nsecs !== void 0 ? e.nsecs : eF + 1, a = o - $Y + (l - eF) / 1e4;
  if (a < 0 && e.clockseq === void 0 && (g = g + 1 & 16383), (a < 0 || o > $Y) && e.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  $Y = o, eF = l, hP = g, o += 122192928e5;
  var I = ((o & 268435455) * 1e4 + l) % 4294967296;
  r[n++] = I >>> 24 & 255, r[n++] = I >>> 16 & 255, r[n++] = I >>> 8 & 255, r[n++] = I & 255;
  var c = o / 4294967296 * 1e4 & 268435455;
  r[n++] = c >>> 8 & 255, r[n++] = c & 255, r[n++] = c >>> 24 & 15 | 16, r[n++] = c >>> 16 & 255, r[n++] = g >>> 8 | 128, r[n++] = g & 255;
  for (var d = e.node || WWt, C = 0; C < 6; ++C)
    r[n + C] = d[C];
  return t || yWt(r);
}
var VWt = SWt, wWt = U$, vWt = O$;
function RWt(e, t, i) {
  var n = t && i || 0;
  typeof e == "string" && (t = e == "binary" ? new Array(16) : null, e = null), e = e || {};
  var r = e.random || (e.rng || wWt)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t)
    for (var g = 0; g < 16; ++g)
      t[n + g] = r[g];
  return t || vWt(r);
}
var XWt = RWt, HWt = VWt, Q$ = XWt, BE = Q$;
BE.v1 = HWt;
BE.v4 = Q$;
var kWt = BE;
const YWt = /* @__PURE__ */ go(kWt), fE = (e) => (t) => (e || (e = YWt()), t(Bct(e)), e), FWt = () => (e, t) => {
  const i = t(), n = TGt(i);
  e(Tx(n ? "creating" : []));
}, xWt = (e, t, i, n) => async (r, g) => {
  var d, C;
  const o = r(fE()), l = g(), a = Er(l), I = (d = Vv(l)) == null ? void 0 : d.id, c = VI("saveConfiguration", e);
  try {
    const A = await sAt(c, c.appCode, t, a, i ?? [], n, I);
    if (A.error || !A || !A.code)
      throw new Error("Error while saving configuration");
    if (window.onbeforeunload = null, t.sendJavascriptEvent && ((C = window.top) == null || C.postMessage({
      type: "K3ConfigurationSaved",
      actionKey: t.actionKey,
      code: A.code
    }, "*")), SA(l) || $Ct(A.code), r(bdt()), A.pdf && (_j("openPdf") ? VI("openPdf", A) : BWt(A.pdf, A.pdfName)), t.sendToShop) {
      const b = Pi(l), m = A.shopLink || DWt(b, A);
      m && ((window.top || window).location = m);
    }
    return A;
  } catch (A) {
    if (A instanceof Error)
      return {
        error: !0,
        message: A.message
      };
  } finally {
    r(e9(o));
  }
}, DWt = (e, t) => {
  const i = e.settings.shopURL;
  if (i && t.code) {
    const n = new URL(i);
    return n.searchParams.append("cfg", t.code), n.toString();
  } else
    return i || console.error("No shop URL found in app settings"), t.code || console.error("No code found in save result"), null;
}, j$ = Ua(Ut), c$t = () => Al(F7), d$t = () => ie(_l), q$ = () => {
  const e = rr();
  return ie((i) => {
    var r;
    let n = cu(i, e);
    return n || (n = (r = TZ(i, e)) == null ? void 0 : r.id), n;
  });
}, u$t = () => {
  const e = q$();
  return ie(kI(e ?? -1));
}, C$t = () => Al(eG), A$t = (e) => ie(kI(e)), b$t = (e) => ie(yWe(e)), JWt = () => ie(Og), _$ = (e) => ie(vZ(e)), h$t = (e) => ie((t) => Qq(t, e)), EWt = (e) => ie(qr(e)), NWt = () => ie($l), LWt = (e) => ie(cdt(e)), KWt = (e) => ie(pA(e)), m$t = (e) => ie(kv(e)), p$t = () => ie(hA), B$t = () => ie(Rc), f$t = () => ie(x9), Z$t = () => ie(Em), G$t = () => ie(yA), y$t = () => ie(D9), W$t = () => ie(Wv), m1 = () => ie(KZ), S$t = () => ie($v), V$t = () => ie(C1), TWt = () => ie(zh), rr = () => Vn(j$) ?? {}, MWt = () => {
  const e = rr();
  return ie(K9).indexOf(e) === 0;
}, ZE = () => ie(Br), PWt = (e) => ie(yv(e)), $$ = (e) => {
  const t = eee(e);
  return KWt(t == null ? void 0 : t.valueId);
}, w$t = (e) => {
  var i;
  const t = eee(e);
  return (i = t == null ? void 0 : t.data) == null ? void 0 : i.inputValue;
}, eee = (e) => {
  const t = _$(e);
  return PWt(t == null ? void 0 : t.id);
}, v$t = (e) => {
  var I;
  const t = LWt(e), i = ZE(), r = i.filter((c) => c.valueId === (t == null ? void 0 : t.id)).filter((c) => c.valueId === (t == null ? void 0 : t.id)), g = ie(t9), o = ie(vc), l = (I = de.last(r)) == null ? void 0 : I.id;
  if (!t || !r.length || !l)
    return {};
  const a = {};
  return r.forEach((c) => {
    var b;
    if (!c)
      return;
    const d = mg(c) ? c.id : qa(c);
    if (!d)
      return;
    const C = i.filter((m) => Oj(c, m));
    let A = a[d];
    if (!A) {
      const m = (b = o[c.variableId]) == null ? void 0 : b.key, p = c.valueId ? g[c.valueId] : void 0;
      A = m && p ? {
        [m]: p
      } : {};
    }
    a[d] = {
      ...A,
      ...C.reduce((m, p) => {
        var V;
        const B = o[p == null ? void 0 : p.variableId], f = B == null ? void 0 : B.key;
        if (!p.valueId || !f)
          return m;
        let Z = g[p.valueId];
        if (Sg(B) && (Z = ((V = p.data) == null ? void 0 : V.inputValue) ?? 0), !B)
          return m;
        let y = Z;
        const W = m[f];
        return !de.isNumber(Z) && !de.isNumber(W) && Zv(B) && (y = Array.isArray(W) ? [...W, Z] : W ? [W, Z] : [Z]), m[f] = y, m;
      }, {})
    };
  }), a;
}, R$t = (e, t) => tee(e, [t])[0], tee = (e, t) => {
  const i = _$(e), n = $$(e), r = Array.from(t).map(() => {
  });
  if (n && i)
    for (let g = 0; g < t.length; g++) {
      const o = Zye(t[g], i);
      o && (r[g] = syt(o == null ? void 0 : o.id, n));
    }
  return r;
}, X$t = () => Al(Y7), iee = () => ie(nr), UWt = () => ie(Jr), H$t = () => {
  var e, t, i;
  return ((i = (t = (e = iee()) == null ? void 0 : e.values) == null ? void 0 : t.flat) == null ? void 0 : i.all) || [];
}, k$t = () => ie(zh), Y$t = () => Al(G7), F$t = (e) => {
  var t, i, n;
  return ((n = (i = (t = iee()) == null ? void 0 : t.values) == null ? void 0 : i.byVarId) == null ? void 0 : n.all[e]) || [];
}, x$t = () => Al(pE), D$t = () => Al(jZ), J$t = () => Al(QZ), E$t = () => ie(DJ), N$t = () => Al(_2t), L$t = () => Al($2t), K$t = () => ie(J6), T$t = () => ie(Er), M$t = () => ie(Pi), P$t = () => ie(WA), zWt = () => Al(() => kct(!0)), U$t = () => Al(aA), z$t = () => Al(FWt), O$t = () => Al(wr), Q$t = () => ie(SA), j$t = () => ie($r), q$t = (e) => {
  const t = Ei(), i = ie(yv(e == null ? void 0 : e.id)), n = ie((r) => Ym(r, i)).reverse();
  return async (r) => {
    const g = n.length > 0 ? n[0] : Ut, o = await t(jZ(r, g));
    if (o && "engineState" in o && o.engineState) {
      const l = o.engineState.ruleEngineState.lastManualChange.instance, a = {
        id: l.id,
        instance: l,
        variableId: l.belongsToVariableId,
        valueId: i == null ? void 0 : i.valueId,
        sort: ((i == null ? void 0 : i.sort) || 0) + 1,
        debuggingValue: r.label
      };
      t(aA(null)), t(wr(a.id)), t(YE(a));
    }
  };
}, _$t = () => {
  const e = rr(), t = ie(K9).filter((r) => r.id !== (e == null ? void 0 : e.id)), i = Ei(), n = ie((r) => Ym(r, e)).reverse();
  return (r) => {
    if (r.id === (e == null ? void 0 : e.id)) {
      const g = n.length > 0 ? n[0] : Ut;
      t.length > 0 ? i(wr(t[0].id)) : i(wr(g.id));
    }
    i(QZ(r));
  };
}, $$t = (e, t) => ie(mA(e, t)), eei = () => ie(TWe), tei = () => Al(T$), Rw = ({
  label: e = "Modell",
  modelKey: t = "",
  multiple: i = !1,
  onChange: n,
  onChangeMultiple: r
}) => {
  const g = (m1() ?? []).filter((a) => a.key), o = (a) => {
    if (Array.isArray(a)) {
      const I = a.reduce((c, d) => d.key ? [...c, d.key] : c, []);
      r == null || r(I);
    } else
      a != null && a.key && (n == null || n(a.key));
  }, l = i ? g.filter((a) => a.key && t.includes(a.key)) : (g == null ? void 0 : g.find((a) => a.key === t)) ?? null;
  return /* @__PURE__ */ S(dj, { id: "model-selector", "data-cy": "modelSelector", options: g, multiple: i, sx: {
    maxWidth: 1
  }, disableCloseOnSelect: i, value: l, renderInput: (a) => /* @__PURE__ */ S(kd, { ...a, label: e }), onChange: (a, I) => {
    I && o(I);
  } });
}, OWt = "data:image/png;base64,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", nee = 0, QWt = 1, jWt = 2, mP = 2, tF = 1.25, pP = 1, ZV = 6 * 4 + 4 + 4, p1 = 65535, qWt = Math.pow(2, -24), iF = Symbol("SKIP_GENERATION");
function _Wt(e) {
  return e.index ? e.index.count : e.attributes.position.count;
}
function Mm(e) {
  return _Wt(e) / 3;
}
function $Wt(e, t = ArrayBuffer) {
  return e > 65535 ? new Uint32Array(new t(4 * e)) : new Uint16Array(new t(2 * e));
}
function eSt(e, t) {
  if (!e.index) {
    const i = e.attributes.position.count, n = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, r = $Wt(i, n);
    e.setIndex(new sZ(r, 1));
    for (let g = 0; g < i; g++)
      r[g] = g;
  }
}
function ree(e) {
  const t = Mm(e), i = e.drawRange, n = i.start / 3, r = (i.start + i.count) / 3, g = Math.max(0, n), o = Math.min(t, r) - g;
  return [{
    offset: Math.floor(g),
    count: Math.floor(o)
  }];
}
function gee(e) {
  if (!e.groups || !e.groups.length)
    return ree(e);
  const t = [], i = /* @__PURE__ */ new Set(), n = e.drawRange, r = n.start / 3, g = (n.start + n.count) / 3;
  for (const l of e.groups) {
    const a = l.start / 3, I = (l.start + l.count) / 3;
    i.add(Math.max(r, a)), i.add(Math.min(g, I));
  }
  const o = Array.from(i.values()).sort((l, a) => l - a);
  for (let l = 0; l < o.length - 1; l++) {
    const a = o[l], I = o[l + 1];
    t.push({
      offset: Math.floor(a),
      count: Math.floor(I - a)
    });
  }
  return t;
}
function tSt(e) {
  if (e.groups.length === 0)
    return !1;
  const t = Mm(e), i = gee(e).sort((g, o) => g.offset - o.offset), n = i[i.length - 1];
  n.count = Math.min(t - n.offset, n.count);
  let r = 0;
  return i.forEach(({ count: g }) => r += g), t !== r;
}
function ar(e, t, i) {
  return i.min.x = t[e], i.min.y = t[e + 1], i.min.z = t[e + 2], i.max.x = t[e + 3], i.max.y = t[e + 4], i.max.z = t[e + 5], i;
}
function iSt(e) {
  e[0] = e[1] = e[2] = 1 / 0, e[3] = e[4] = e[5] = -1 / 0;
}
function BP(e) {
  let t = -1, i = -1 / 0;
  for (let n = 0; n < 3; n++) {
    const r = e[n + 3] - e[n];
    r > i && (i = r, t = n);
  }
  return t;
}
function fP(e, t) {
  t.set(e);
}
function ZP(e, t, i) {
  let n, r;
  for (let g = 0; g < 3; g++) {
    const o = g + 3;
    n = e[g], r = t[g], i[g] = n < r ? n : r, n = e[o], r = t[o], i[o] = n > r ? n : r;
  }
}
function AS(e, t, i) {
  for (let n = 0; n < 3; n++) {
    const r = t[e + 2 * n], g = t[e + 2 * n + 1], o = r - g, l = r + g;
    o < i[n] && (i[n] = o), l > i[n + 3] && (i[n + 3] = l);
  }
}
function sB(e) {
  const t = e[3] - e[0], i = e[4] - e[1], n = e[5] - e[2];
  return 2 * (t * i + i * n + n * t);
}
function nF(e, t, i, n, r = null) {
  let g = 1 / 0, o = 1 / 0, l = 1 / 0, a = -1 / 0, I = -1 / 0, c = -1 / 0, d = 1 / 0, C = 1 / 0, A = 1 / 0, b = -1 / 0, m = -1 / 0, p = -1 / 0;
  const B = r !== null;
  for (let f = t * 6, Z = (t + i) * 6; f < Z; f += 6) {
    const y = e[f + 0], W = e[f + 1], V = y - W, w = y + W;
    V < g && (g = V), w > a && (a = w), B && y < d && (d = y), B && y > b && (b = y);
    const v = e[f + 2], H = e[f + 3], x = v - H, J = v + H;
    x < o && (o = x), J > I && (I = J), B && v < C && (C = v), B && v > m && (m = v);
    const K = e[f + 4], M = e[f + 5], L = K - M, N = K + M;
    L < l && (l = L), N > c && (c = N), B && K < A && (A = K), B && K > p && (p = K);
  }
  n[0] = g, n[1] = o, n[2] = l, n[3] = a, n[4] = I, n[5] = c, B && (r[0] = d, r[1] = C, r[2] = A, r[3] = b, r[4] = m, r[5] = p);
}
function nSt(e, t, i, n) {
  let r = 1 / 0, g = 1 / 0, o = 1 / 0, l = -1 / 0, a = -1 / 0, I = -1 / 0;
  for (let c = t * 6, d = (t + i) * 6; c < d; c += 6) {
    const C = e[c + 0];
    C < r && (r = C), C > l && (l = C);
    const A = e[c + 2];
    A < g && (g = A), A > a && (a = A);
    const b = e[c + 4];
    b < o && (o = b), b > I && (I = b);
  }
  n[0] = r, n[1] = g, n[2] = o, n[3] = l, n[4] = a, n[5] = I;
}
function rSt(e, t) {
  iSt(t);
  const i = e.attributes.position, n = e.index ? e.index.array : null, r = Mm(e), g = new Float32Array(r * 6), o = i.normalized, l = i.array, a = i.offset || 0;
  let I = 3;
  i.isInterleavedBufferAttribute && (I = i.data.stride);
  const c = ["getX", "getY", "getZ"];
  for (let d = 0; d < r; d++) {
    const C = d * 3, A = d * 6;
    let b = C + 0, m = C + 1, p = C + 2;
    n && (b = n[b], m = n[m], p = n[p]), o || (b = b * I + a, m = m * I + a, p = p * I + a);
    for (let B = 0; B < 3; B++) {
      let f, Z, y;
      o ? (f = i[c[B]](b), Z = i[c[B]](m), y = i[c[B]](p)) : (f = l[b + B], Z = l[m + B], y = l[p + B]);
      let W = f;
      Z < W && (W = Z), y < W && (W = y);
      let V = f;
      Z > V && (V = Z), y > V && (V = y);
      const w = (V - W) / 2, v = B * 2;
      g[A + v + 0] = W + w, g[A + v + 1] = w + (Math.abs(W) + w) * qWt, W < t[B] && (t[B] = W), V > t[B + 3] && (t[B + 3] = V);
    }
  }
  return g;
}
const Ac = 32, gSt = (e, t) => e.candidate - t.candidate, bd = new Array(Ac).fill().map(() => ({
  count: 0,
  bounds: new Float32Array(6),
  rightCacheBounds: new Float32Array(6),
  leftCacheBounds: new Float32Array(6),
  candidate: 0
})), bS = new Float32Array(6);
function oSt(e, t, i, n, r, g) {
  let o = -1, l = 0;
  if (g === nee)
    o = BP(t), o !== -1 && (l = (t[o] + t[o + 3]) / 2);
  else if (g === QWt)
    o = BP(e), o !== -1 && (l = lSt(i, n, r, o));
  else if (g === jWt) {
    const a = sB(e);
    let I = tF * r;
    const c = n * 6, d = (n + r) * 6;
    for (let C = 0; C < 3; C++) {
      const A = t[C], p = (t[C + 3] - A) / Ac;
      if (r < Ac / 4) {
        const B = [...bd];
        B.length = r;
        let f = 0;
        for (let y = c; y < d; y += 6, f++) {
          const W = B[f];
          W.candidate = i[y + 2 * C], W.count = 0;
          const {
            bounds: V,
            leftCacheBounds: w,
            rightCacheBounds: v
          } = W;
          for (let H = 0; H < 3; H++)
            v[H] = 1 / 0, v[H + 3] = -1 / 0, w[H] = 1 / 0, w[H + 3] = -1 / 0, V[H] = 1 / 0, V[H + 3] = -1 / 0;
          AS(y, i, V);
        }
        B.sort(gSt);
        let Z = r;
        for (let y = 0; y < Z; y++) {
          const W = B[y];
          for (; y + 1 < Z && B[y + 1].candidate === W.candidate; )
            B.splice(y + 1, 1), Z--;
        }
        for (let y = c; y < d; y += 6) {
          const W = i[y + 2 * C];
          for (let V = 0; V < Z; V++) {
            const w = B[V];
            W >= w.candidate ? AS(y, i, w.rightCacheBounds) : (AS(y, i, w.leftCacheBounds), w.count++);
          }
        }
        for (let y = 0; y < Z; y++) {
          const W = B[y], V = W.count, w = r - W.count, v = W.leftCacheBounds, H = W.rightCacheBounds;
          let x = 0;
          V !== 0 && (x = sB(v) / a);
          let J = 0;
          w !== 0 && (J = sB(H) / a);
          const K = pP + tF * (x * V + J * w);
          K < I && (o = C, I = K, l = W.candidate);
        }
      } else {
        for (let Z = 0; Z < Ac; Z++) {
          const y = bd[Z];
          y.count = 0, y.candidate = A + p + Z * p;
          const W = y.bounds;
          for (let V = 0; V < 3; V++)
            W[V] = 1 / 0, W[V + 3] = -1 / 0;
        }
        for (let Z = c; Z < d; Z += 6) {
          let V = ~~((i[Z + 2 * C] - A) / p);
          V >= Ac && (V = Ac - 1);
          const w = bd[V];
          w.count++, AS(Z, i, w.bounds);
        }
        const B = bd[Ac - 1];
        fP(B.bounds, B.rightCacheBounds);
        for (let Z = Ac - 2; Z >= 0; Z--) {
          const y = bd[Z], W = bd[Z + 1];
          ZP(y.bounds, W.rightCacheBounds, y.rightCacheBounds);
        }
        let f = 0;
        for (let Z = 0; Z < Ac - 1; Z++) {
          const y = bd[Z], W = y.count, V = y.bounds, v = bd[Z + 1].rightCacheBounds;
          W !== 0 && (f === 0 ? fP(V, bS) : ZP(V, bS, bS)), f += W;
          let H = 0, x = 0;
          f !== 0 && (H = sB(bS) / a);
          const J = r - f;
          J !== 0 && (x = sB(v) / a);
          const K = pP + tF * (H * f + x * J);
          K < I && (o = C, I = K, l = y.candidate);
        }
      }
    }
  } else
    console.warn(`MeshBVH: Invalid build strategy value ${g} used.`);
  return { axis: o, pos: l };
}
function lSt(e, t, i, n) {
  let r = 0;
  for (let g = t, o = t + i; g < o; g++)
    r += e[g * 6 + n * 2];
  return r / i;
}
class hS {
  constructor() {
  }
}
function aSt(e, t, i, n, r, g) {
  let o = n, l = n + r - 1;
  const a = g.pos, I = g.axis * 2;
  for (; ; ) {
    for (; o <= l && i[o * 6 + I] < a; )
      o++;
    for (; o <= l && i[l * 6 + I] >= a; )
      l--;
    if (o < l) {
      for (let c = 0; c < 3; c++) {
        let d = t[o * 3 + c];
        t[o * 3 + c] = t[l * 3 + c], t[l * 3 + c] = d;
      }
      for (let c = 0; c < 6; c++) {
        let d = i[o * 6 + c];
        i[o * 6 + c] = i[l * 6 + c], i[l * 6 + c] = d;
      }
      o++, l--;
    } else
      return o;
  }
}
function sSt(e, t, i, n, r, g) {
  let o = n, l = n + r - 1;
  const a = g.pos, I = g.axis * 2;
  for (; ; ) {
    for (; o <= l && i[o * 6 + I] < a; )
      o++;
    for (; o <= l && i[l * 6 + I] >= a; )
      l--;
    if (o < l) {
      let c = e[o];
      e[o] = e[l], e[l] = c;
      for (let d = 0; d < 6; d++) {
        let C = i[o * 6 + d];
        i[o * 6 + d] = i[l * 6 + d], i[l * 6 + d] = C;
      }
      o++, l--;
    } else
      return o;
  }
}
function ISt(e, t) {
  const i = (e.index ? e.index.count : e.attributes.position.count) / 3, n = i > 2 ** 16, r = n ? 4 : 2, g = t ? new SharedArrayBuffer(i * r) : new ArrayBuffer(i * r), o = n ? new Uint32Array(g) : new Uint16Array(g);
  for (let l = 0, a = o.length; l < a; l++)
    o[l] = l;
  return o;
}
function cSt(e, t) {
  const i = e.geometry, n = i.index ? i.index.array : null, r = t.maxDepth, g = t.verbose, o = t.maxLeafTris, l = t.strategy, a = t.onProgress, I = Mm(i), c = e._indirectBuffer;
  let d = !1;
  const C = new Float32Array(6), A = new Float32Array(6), b = rSt(i, C), m = t.indirect ? sSt : aSt, p = [], B = t.indirect ? ree(i) : gee(i);
  if (B.length === 1) {
    const y = B[0], W = new hS();
    W.boundingData = C, nSt(b, y.offset, y.count, A), Z(W, y.offset, y.count, A), p.push(W);
  } else
    for (let y of B) {
      const W = new hS();
      W.boundingData = new Float32Array(6), nF(b, y.offset, y.count, W.boundingData, A), Z(W, y.offset, y.count, A), p.push(W);
    }
  return p;
  function f(y) {
    a && a(y / I);
  }
  function Z(y, W, V, w = null, v = 0) {
    if (!d && v >= r && (d = !0, g && (console.warn(`MeshBVH: Max depth of ${r} reached when generating BVH. Consider increasing maxDepth.`), console.warn(i))), V <= o || v >= r)
      return f(W + V), y.offset = W, y.count = V, y;
    const H = oSt(y.boundingData, w, b, W, V, l);
    if (H.axis === -1)
      return f(W + V), y.offset = W, y.count = V, y;
    const x = m(c, n, b, W, V, H);
    if (x === W || x === W + V)
      f(W + V), y.offset = W, y.count = V;
    else {
      y.splitAxis = H.axis;
      const J = new hS(), K = W, M = x - W;
      y.left = J, J.boundingData = new Float32Array(6), nF(b, K, M, J.boundingData, A), Z(J, K, M, A, v + 1);
      const L = new hS(), N = x, U = V - M;
      y.right = L, L.boundingData = new Float32Array(6), nF(b, N, U, L.boundingData, A), Z(L, N, U, A, v + 1);
    }
    return y;
  }
}
function dSt(e, t) {
  const i = e.geometry;
  t.indirect && (e._indirectBuffer = ISt(i, t.useSharedArrayBuffer), tSt(i) && !t.verbose && console.warn(
    'MeshBVH: Provided geometry contains groups that do not fully span the vertex contents while using the "indirect" option. BVH may incorrectly report intersections on unrendered portions of the geometry.'
  )), e._indirectBuffer || eSt(i, t);
  const n = cSt(e, t);
  let r, g, o;
  const l = [], a = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
  for (let d = 0; d < n.length; d++) {
    const C = n[d];
    let A = I(C);
    const b = new a(ZV * A);
    r = new Float32Array(b), g = new Uint32Array(b), o = new Uint16Array(b), c(0, C), l.push(b);
  }
  e._roots = l;
  return;
  function I(d) {
    return d.count ? 1 : 1 + I(d.left) + I(d.right);
  }
  function c(d, C) {
    const A = d / 4, b = d / 2, m = !!C.count, p = C.boundingData;
    for (let B = 0; B < 6; B++)
      r[A + B] = p[B];
    if (m) {
      const B = C.offset, f = C.count;
      return g[A + 6] = B, o[b + 14] = f, o[b + 15] = p1, d + ZV;
    } else {
      const B = C.left, f = C.right, Z = C.splitAxis;
      let y;
      if (y = c(d + ZV, B), y / 4 > Math.pow(2, 32))
        throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
      return g[A + 6] = y / 4, y = c(y, f), g[A + 7] = Z, y;
    }
  }
}
class Vc {
  constructor() {
    this.min = 1 / 0, this.max = -1 / 0;
  }
  setFromPointsField(t, i) {
    let n = 1 / 0, r = -1 / 0;
    for (let g = 0, o = t.length; g < o; g++) {
      const a = t[g][i];
      n = a < n ? a : n, r = a > r ? a : r;
    }
    this.min = n, this.max = r;
  }
  setFromPoints(t, i) {
    let n = 1 / 0, r = -1 / 0;
    for (let g = 0, o = i.length; g < o; g++) {
      const l = i[g], a = t.dot(l);
      n = a < n ? a : n, r = a > r ? a : r;
    }
    this.min = n, this.max = r;
  }
  isSeparated(t) {
    return this.min > t.max || t.min > this.max;
  }
}
Vc.prototype.setFromBox = function() {
  const e = new ye();
  return function(i, n) {
    const r = n.min, g = n.max;
    let o = 1 / 0, l = -1 / 0;
    for (let a = 0; a <= 1; a++)
      for (let I = 0; I <= 1; I++)
        for (let c = 0; c <= 1; c++) {
          e.x = r.x * a + g.x * (1 - a), e.y = r.y * I + g.y * (1 - I), e.z = r.z * c + g.z * (1 - c);
          const d = i.dot(e);
          o = Math.min(d, o), l = Math.max(d, l);
        }
    this.min = o, this.max = l;
  };
}();
const uSt = function() {
  const e = new ye(), t = new ye(), i = new ye();
  return function(r, g, o) {
    const l = r.start, a = e, I = g.start, c = t;
    i.subVectors(l, I), e.subVectors(r.end, r.start), t.subVectors(g.end, g.start);
    const d = i.dot(c), C = c.dot(a), A = c.dot(c), b = i.dot(a), p = a.dot(a) * A - C * C;
    let B, f;
    p !== 0 ? B = (d * C - b * A) / p : B = 0, f = (d + B * C) / A, o.x = B, o.y = f;
  };
}(), GE = function() {
  const e = new fc(), t = new ye(), i = new ye();
  return function(r, g, o, l) {
    uSt(r, g, e);
    let a = e.x, I = e.y;
    if (a >= 0 && a <= 1 && I >= 0 && I <= 1) {
      r.at(a, o), g.at(I, l);
      return;
    } else if (a >= 0 && a <= 1) {
      I < 0 ? g.at(0, l) : g.at(1, l), r.closestPointToPoint(l, !0, o);
      return;
    } else if (I >= 0 && I <= 1) {
      a < 0 ? r.at(0, o) : r.at(1, o), g.closestPointToPoint(o, !0, l);
      return;
    } else {
      let c;
      a < 0 ? c = r.start : c = r.end;
      let d;
      I < 0 ? d = g.start : d = g.end;
      const C = t, A = i;
      if (r.closestPointToPoint(d, !0, t), g.closestPointToPoint(c, !0, i), C.distanceToSquared(d) <= A.distanceToSquared(c)) {
        o.copy(C), l.copy(d);
        return;
      } else {
        o.copy(c), l.copy(A);
        return;
      }
    }
  };
}(), CSt = function() {
  const e = new ye(), t = new ye(), i = new xC(), n = new Nl();
  return function(g, o) {
    const { radius: l, center: a } = g, { a: I, b: c, c: d } = o;
    if (n.start = I, n.end = c, n.closestPointToPoint(a, !0, e).distanceTo(a) <= l || (n.start = I, n.end = d, n.closestPointToPoint(a, !0, e).distanceTo(a) <= l) || (n.start = c, n.end = d, n.closestPointToPoint(a, !0, e).distanceTo(a) <= l))
      return !0;
    const m = o.getPlane(i);
    if (Math.abs(m.distanceToPoint(a)) <= l) {
      const B = m.projectPoint(a, t);
      if (o.containsPoint(B))
        return !0;
    }
    return !1;
  };
}(), ASt = 1e-15;
function rF(e) {
  return Math.abs(e) < ASt;
}
class Ma extends Fl {
  constructor(...t) {
    super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(() => new ye()), this.satBounds = new Array(4).fill().map(() => new Vc()), this.points = [this.a, this.b, this.c], this.sphere = new poe(), this.plane = new xC(), this.needsUpdate = !0;
  }
  intersectsSphere(t) {
    return CSt(t, this);
  }
  update() {
    const t = this.a, i = this.b, n = this.c, r = this.points, g = this.satAxes, o = this.satBounds, l = g[0], a = o[0];
    this.getNormal(l), a.setFromPoints(l, r);
    const I = g[1], c = o[1];
    I.subVectors(t, i), c.setFromPoints(I, r);
    const d = g[2], C = o[2];
    d.subVectors(i, n), C.setFromPoints(d, r);
    const A = g[3], b = o[3];
    A.subVectors(n, t), b.setFromPoints(A, r), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(l, t), this.needsUpdate = !1;
  }
}
Ma.prototype.closestPointToSegment = function() {
  const e = new ye(), t = new ye(), i = new Nl();
  return function(r, g = null, o = null) {
    const { start: l, end: a } = r, I = this.points;
    let c, d = 1 / 0;
    for (let C = 0; C < 3; C++) {
      const A = (C + 1) % 3;
      i.start.copy(I[C]), i.end.copy(I[A]), GE(i, r, e, t), c = e.distanceToSquared(t), c < d && (d = c, g && g.copy(e), o && o.copy(t));
    }
    return this.closestPointToPoint(l, e), c = l.distanceToSquared(e), c < d && (d = c, g && g.copy(e), o && o.copy(l)), this.closestPointToPoint(a, e), c = a.distanceToSquared(e), c < d && (d = c, g && g.copy(e), o && o.copy(a)), Math.sqrt(d);
  };
}();
Ma.prototype.intersectsTriangle = function() {
  const e = new Ma(), t = new Array(3), i = new Array(3), n = new Vc(), r = new Vc(), g = new ye(), o = new ye(), l = new ye(), a = new ye(), I = new ye(), c = new Nl(), d = new Nl(), C = new Nl(), A = new ye();
  function b(m, p, B) {
    const f = m.points;
    let Z = 0, y = -1;
    for (let W = 0; W < 3; W++) {
      const { start: V, end: w } = c;
      V.copy(f[W]), w.copy(f[(W + 1) % 3]), c.delta(o);
      const v = rF(p.distanceToPoint(V));
      if (rF(p.normal.dot(o)) && v) {
        B.copy(c), Z = 2;
        break;
      }
      const H = p.intersectLine(c, A);
      if (!H && v && A.copy(V), (H || v) && !rF(A.distanceTo(w))) {
        if (Z <= 1)
          (Z === 1 ? B.start : B.end).copy(A), v && (y = Z);
        else if (Z >= 2) {
          (y === 1 ? B.start : B.end).copy(A), Z = 2;
          break;
        }
        if (Z++, Z === 2 && y === -1)
          break;
      }
    }
    return Z;
  }
  return function(p, B = null, f = !1) {
    this.needsUpdate && this.update(), p.isExtendedTriangle ? p.needsUpdate && p.update() : (e.copy(p), e.update(), p = e);
    const Z = this.plane, y = p.plane;
    if (Math.abs(Z.normal.dot(y.normal)) > 1 - 1e-10) {
      const W = this.satBounds, V = this.satAxes;
      i[0] = p.a, i[1] = p.b, i[2] = p.c;
      for (let H = 0; H < 4; H++) {
        const x = W[H], J = V[H];
        if (n.setFromPoints(J, i), x.isSeparated(n))
          return !1;
      }
      const w = p.satBounds, v = p.satAxes;
      t[0] = this.a, t[1] = this.b, t[2] = this.c;
      for (let H = 0; H < 4; H++) {
        const x = w[H], J = v[H];
        if (n.setFromPoints(J, t), x.isSeparated(n))
          return !1;
      }
      for (let H = 0; H < 4; H++) {
        const x = V[H];
        for (let J = 0; J < 4; J++) {
          const K = v[J];
          if (g.crossVectors(x, K), n.setFromPoints(g, t), r.setFromPoints(g, i), n.isSeparated(r))
            return !1;
        }
      }
      return B && (f || console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), B.start.set(0, 0, 0), B.end.set(0, 0, 0)), !0;
    } else {
      const W = b(this, y, d);
      if (W === 1 && p.containsPoint(d.end))
        return B && (B.start.copy(d.end), B.end.copy(d.end)), !0;
      if (W !== 2)
        return !1;
      const V = b(p, Z, C);
      if (V === 1 && this.containsPoint(C.end))
        return B && (B.start.copy(C.end), B.end.copy(C.end)), !0;
      if (V !== 2)
        return !1;
      if (d.delta(l), C.delta(a), l.dot(a) < 0) {
        let M = C.start;
        C.start = C.end, C.end = M;
      }
      const w = d.start.dot(l), v = d.end.dot(l), H = C.start.dot(l), x = C.end.dot(l), J = v < H, K = w < x;
      return w !== x && H !== v && J === K ? !1 : (B && (I.subVectors(d.start, C.start), I.dot(l) > 0 ? B.start.copy(d.start) : B.start.copy(C.start), I.subVectors(d.end, C.end), I.dot(l) < 0 ? B.end.copy(d.end) : B.end.copy(C.end)), !0);
    }
  };
}();
Ma.prototype.distanceToPoint = function() {
  const e = new ye();
  return function(i) {
    return this.closestPointToPoint(i, e), i.distanceTo(e);
  };
}();
Ma.prototype.distanceToTriangle = function() {
  const e = new ye(), t = new ye(), i = ["a", "b", "c"], n = new Nl(), r = new Nl();
  return function(o, l = null, a = null) {
    const I = l || a ? n : null;
    if (this.intersectsTriangle(o, I))
      return (l || a) && (l && I.getCenter(l), a && I.getCenter(a)), 0;
    let c = 1 / 0;
    for (let d = 0; d < 3; d++) {
      let C;
      const A = i[d], b = o[A];
      this.closestPointToPoint(b, e), C = b.distanceToSquared(e), C < c && (c = C, l && l.copy(e), a && a.copy(b));
      const m = this[A];
      o.closestPointToPoint(m, e), C = m.distanceToSquared(e), C < c && (c = C, l && l.copy(m), a && a.copy(e));
    }
    for (let d = 0; d < 3; d++) {
      const C = i[d], A = i[(d + 1) % 3];
      n.set(this[C], this[A]);
      for (let b = 0; b < 3; b++) {
        const m = i[b], p = i[(b + 1) % 3];
        r.set(o[m], o[p]), GE(n, r, e, t);
        const B = e.distanceToSquared(t);
        B < c && (c = B, l && l.copy(e), a && a.copy(t));
      }
    }
    return Math.sqrt(c);
  };
}();
class xo {
  constructor(t, i, n) {
    this.isOrientedBox = !0, this.min = new ye(), this.max = new ye(), this.matrix = new ks(), this.invMatrix = new ks(), this.points = new Array(8).fill().map(() => new ye()), this.satAxes = new Array(3).fill().map(() => new ye()), this.satBounds = new Array(3).fill().map(() => new Vc()), this.alignedSatBounds = new Array(3).fill().map(() => new Vc()), this.needsUpdate = !1, t && this.min.copy(t), i && this.max.copy(i), n && this.matrix.copy(n);
  }
  set(t, i, n) {
    this.min.copy(t), this.max.copy(i), this.matrix.copy(n), this.needsUpdate = !0;
  }
  copy(t) {
    this.min.copy(t.min), this.max.copy(t.max), this.matrix.copy(t.matrix), this.needsUpdate = !0;
  }
}
xo.prototype.update = /* @__PURE__ */ function() {
  return function() {
    const t = this.matrix, i = this.min, n = this.max, r = this.points;
    for (let I = 0; I <= 1; I++)
      for (let c = 0; c <= 1; c++)
        for (let d = 0; d <= 1; d++) {
          const C = 1 * I | 2 * c | 4 * d, A = r[C];
          A.x = I ? n.x : i.x, A.y = c ? n.y : i.y, A.z = d ? n.z : i.z, A.applyMatrix4(t);
        }
    const g = this.satBounds, o = this.satAxes, l = r[0];
    for (let I = 0; I < 3; I++) {
      const c = o[I], d = g[I], C = 1 << I, A = r[C];
      c.subVectors(l, A), d.setFromPoints(c, r);
    }
    const a = this.alignedSatBounds;
    a[0].setFromPointsField(r, "x"), a[1].setFromPointsField(r, "y"), a[2].setFromPointsField(r, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
  };
}();
xo.prototype.intersectsBox = function() {
  const e = new Vc();
  return function(i) {
    this.needsUpdate && this.update();
    const n = i.min, r = i.max, g = this.satBounds, o = this.satAxes, l = this.alignedSatBounds;
    if (e.min = n.x, e.max = r.x, l[0].isSeparated(e) || (e.min = n.y, e.max = r.y, l[1].isSeparated(e)) || (e.min = n.z, e.max = r.z, l[2].isSeparated(e)))
      return !1;
    for (let a = 0; a < 3; a++) {
      const I = o[a], c = g[a];
      if (e.setFromBox(I, i), c.isSeparated(e))
        return !1;
    }
    return !0;
  };
}();
xo.prototype.intersectsTriangle = function() {
  const e = new Ma(), t = new Array(3), i = new Vc(), n = new Vc(), r = new ye();
  return function(o) {
    this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (e.copy(o), e.update(), o = e);
    const l = this.satBounds, a = this.satAxes;
    t[0] = o.a, t[1] = o.b, t[2] = o.c;
    for (let C = 0; C < 3; C++) {
      const A = l[C], b = a[C];
      if (i.setFromPoints(b, t), A.isSeparated(i))
        return !1;
    }
    const I = o.satBounds, c = o.satAxes, d = this.points;
    for (let C = 0; C < 3; C++) {
      const A = I[C], b = c[C];
      if (i.setFromPoints(b, d), A.isSeparated(i))
        return !1;
    }
    for (let C = 0; C < 3; C++) {
      const A = a[C];
      for (let b = 0; b < 4; b++) {
        const m = c[b];
        if (r.crossVectors(A, m), i.setFromPoints(r, t), n.setFromPoints(r, d), i.isSeparated(n))
          return !1;
      }
    }
    return !0;
  };
}();
xo.prototype.closestPointToPoint = /* @__PURE__ */ function() {
  return function(t, i) {
    return this.needsUpdate && this.update(), i.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), i;
  };
}();
xo.prototype.distanceToPoint = function() {
  const e = new ye();
  return function(i) {
    return this.closestPointToPoint(i, e), i.distanceTo(e);
  };
}();
xo.prototype.distanceToBox = function() {
  const e = ["x", "y", "z"], t = new Array(12).fill().map(() => new Nl()), i = new Array(12).fill().map(() => new Nl()), n = new ye(), r = new ye();
  return function(o, l = 0, a = null, I = null) {
    if (this.needsUpdate && this.update(), this.intersectsBox(o))
      return (a || I) && (o.getCenter(r), this.closestPointToPoint(r, n), o.closestPointToPoint(n, r), a && a.copy(n), I && I.copy(r)), 0;
    const c = l * l, d = o.min, C = o.max, A = this.points;
    let b = 1 / 0;
    for (let p = 0; p < 8; p++) {
      const B = A[p];
      r.copy(B).clamp(d, C);
      const f = B.distanceToSquared(r);
      if (f < b && (b = f, a && a.copy(B), I && I.copy(r), f < c))
        return Math.sqrt(f);
    }
    let m = 0;
    for (let p = 0; p < 3; p++)
      for (let B = 0; B <= 1; B++)
        for (let f = 0; f <= 1; f++) {
          const Z = (p + 1) % 3, y = (p + 2) % 3, W = B << Z | f << y, V = 1 << p | B << Z | f << y, w = A[W], v = A[V];
          t[m].set(w, v);
          const x = e[p], J = e[Z], K = e[y], M = i[m], L = M.start, N = M.end;
          L[x] = d[x], L[J] = B ? d[J] : C[J], L[K] = f ? d[K] : C[J], N[x] = C[x], N[J] = B ? d[J] : C[J], N[K] = f ? d[K] : C[J], m++;
        }
    for (let p = 0; p <= 1; p++)
      for (let B = 0; B <= 1; B++)
        for (let f = 0; f <= 1; f++) {
          r.x = p ? C.x : d.x, r.y = B ? C.y : d.y, r.z = f ? C.z : d.z, this.closestPointToPoint(r, n);
          const Z = r.distanceToSquared(n);
          if (Z < b && (b = Z, a && a.copy(n), I && I.copy(r), Z < c))
            return Math.sqrt(Z);
        }
    for (let p = 0; p < 12; p++) {
      const B = t[p];
      for (let f = 0; f < 12; f++) {
        const Z = i[f];
        GE(B, Z, n, r);
        const y = n.distanceToSquared(r);
        if (y < b && (b = y, a && a.copy(n), I && I.copy(r), y < c))
          return Math.sqrt(y);
      }
    }
    return Math.sqrt(b);
  };
}();
class yE {
  constructor(t) {
    this._getNewPrimitive = t, this._primitives = [];
  }
  getPrimitive() {
    const t = this._primitives;
    return t.length === 0 ? this._getNewPrimitive() : t.pop();
  }
  releasePrimitive(t) {
    this._primitives.push(t);
  }
}
class bSt extends yE {
  constructor() {
    super(() => new Ma());
  }
}
const Ra = /* @__PURE__ */ new bSt();
function kl(e, t) {
  return t[e + 15] === 65535;
}
function Jl(e, t) {
  return t[e + 6];
}
function Xa(e, t) {
  return t[e + 14];
}
function Ha(e) {
  return e + 8;
}
function ka(e, t) {
  return t[e + 6];
}
function oee(e, t) {
  return t[e + 7];
}
class hSt {
  constructor() {
    this.float32Array = null, this.uint16Array = null, this.uint32Array = null;
    const t = [];
    let i = null;
    this.setBuffer = (n) => {
      i && t.push(i), i = n, this.float32Array = new Float32Array(n), this.uint16Array = new Uint16Array(n), this.uint32Array = new Uint32Array(n);
    }, this.clearBuffer = () => {
      i = null, this.float32Array = null, this.uint16Array = null, this.uint32Array = null, t.length !== 0 && this.setBuffer(t.pop());
    };
  }
}
const zn = new hSt();
let Yd, Lh;
const dh = [], mS = /* @__PURE__ */ new yE(() => new fg());
function mSt(e, t, i, n, r, g) {
  Yd = mS.getPrimitive(), Lh = mS.getPrimitive(), dh.push(Yd, Lh), zn.setBuffer(e._roots[t]);
  const o = v5(0, e.geometry, i, n, r, g);
  zn.clearBuffer(), mS.releasePrimitive(Yd), mS.releasePrimitive(Lh), dh.pop(), dh.pop();
  const l = dh.length;
  return l > 0 && (Lh = dh[l - 1], Yd = dh[l - 2]), o;
}
function v5(e, t, i, n, r = null, g = 0, o = 0) {
  const { float32Array: l, uint16Array: a, uint32Array: I } = zn;
  let c = e * 2;
  if (kl(c, a)) {
    const C = Jl(e, I), A = Xa(c, a);
    return ar(e, l, Yd), n(C, A, !1, o, g + e, Yd);
  } else {
    let x = function(K) {
      const { uint16Array: M, uint32Array: L } = zn;
      let N = K * 2;
      for (; !kl(N, M); )
        K = Ha(K), N = K * 2;
      return Jl(K, L);
    }, J = function(K) {
      const { uint16Array: M, uint32Array: L } = zn;
      let N = K * 2;
      for (; !kl(N, M); )
        K = ka(K, L), N = K * 2;
      return Jl(K, L) + Xa(N, M);
    };
    const C = Ha(e), A = ka(e, I);
    let b = C, m = A, p, B, f, Z;
    if (r && (f = Yd, Z = Lh, ar(b, l, f), ar(m, l, Z), p = r(f), B = r(Z), B < p)) {
      b = A, m = C;
      const K = p;
      p = B, B = K, f = Z;
    }
    f || (f = Yd, ar(b, l, f));
    const y = kl(b * 2, a), W = i(f, y, p, o + 1, g + b);
    let V;
    if (W === mP) {
      const K = x(b), L = J(b) - K;
      V = n(K, L, !0, o + 1, g + b, f);
    } else
      V = W && v5(
        b,
        t,
        i,
        n,
        r,
        g,
        o + 1
      );
    if (V)
      return !0;
    Z = Lh, ar(m, l, Z);
    const w = kl(m * 2, a), v = i(Z, w, B, o + 1, g + m);
    let H;
    if (v === mP) {
      const K = x(m), L = J(m) - K;
      H = n(K, L, !0, o + 1, g + m, Z);
    } else
      H = v && v5(
        m,
        t,
        i,
        n,
        r,
        g,
        o + 1
      );
    return !!H;
  }
}
const IB = /* @__PURE__ */ new ye(), gF = /* @__PURE__ */ new ye();
function pSt(e, t, i = {}, n = 0, r = 1 / 0) {
  const g = n * n, o = r * r;
  let l = 1 / 0, a = null;
  if (e.shapecast(
    {
      boundsTraverseOrder: (c) => (IB.copy(t).clamp(c.min, c.max), IB.distanceToSquared(t)),
      intersectsBounds: (c, d, C) => C < l && C < o,
      intersectsTriangle: (c, d) => {
        c.closestPointToPoint(t, IB);
        const C = t.distanceToSquared(IB);
        return C < l && (gF.copy(IB), l = C, a = d), C < g;
      }
    }
  ), l === 1 / 0)
    return null;
  const I = Math.sqrt(l);
  return i.point ? i.point.copy(gF) : i.point = gF.clone(), i.distance = I, i.faceIndex = a, i;
}
const uh = /* @__PURE__ */ new ye(), Ch = /* @__PURE__ */ new ye(), Ah = /* @__PURE__ */ new ye(), pS = /* @__PURE__ */ new fc(), BS = /* @__PURE__ */ new fc(), fS = /* @__PURE__ */ new fc(), GP = /* @__PURE__ */ new ye(), yP = /* @__PURE__ */ new ye(), WP = /* @__PURE__ */ new ye(), ZS = /* @__PURE__ */ new ye();
function BSt(e, t, i, n, r, g) {
  let o;
  return g === Boe ? o = e.intersectTriangle(n, i, t, !0, r) : o = e.intersectTriangle(t, i, n, g !== wD, r), o === null ? null : {
    distance: e.origin.distanceTo(r),
    point: r.clone()
  };
}
function fSt(e, t, i, n, r, g, o, l, a) {
  uh.fromBufferAttribute(t, g), Ch.fromBufferAttribute(t, o), Ah.fromBufferAttribute(t, l);
  const I = BSt(e, uh, Ch, Ah, ZS, a);
  if (I) {
    n && (pS.fromBufferAttribute(n, g), BS.fromBufferAttribute(n, o), fS.fromBufferAttribute(n, l), I.uv = Fl.getInterpolation(ZS, uh, Ch, Ah, pS, BS, fS, new fc())), r && (pS.fromBufferAttribute(r, g), BS.fromBufferAttribute(r, o), fS.fromBufferAttribute(r, l), I.uv1 = Fl.getInterpolation(ZS, uh, Ch, Ah, pS, BS, fS, new fc())), i && (GP.fromBufferAttribute(i, g), yP.fromBufferAttribute(i, o), WP.fromBufferAttribute(i, l), I.normal = Fl.getInterpolation(ZS, uh, Ch, Ah, GP, yP, WP, new ye()), I.normal.dot(e.direction) > 0 && I.normal.multiplyScalar(-1));
    const c = {
      a: g,
      b: o,
      c: l,
      normal: new ye(),
      materialIndex: 0
    };
    Fl.getNormal(uh, Ch, Ah, c.normal), I.face = c, I.faceIndex = g;
  }
  return I;
}
function B1(e, t, i, n, r) {
  const g = n * 3;
  let o = g + 0, l = g + 1, a = g + 2;
  const I = e.index;
  e.index && (o = I.getX(o), l = I.getX(l), a = I.getX(a));
  const { position: c, normal: d, uv: C, uv1: A } = e.attributes, b = fSt(i, c, d, C, A, o, l, a, t);
  return b ? (b.faceIndex = n, r && r.push(b), b) : null;
}
function Dr(e, t, i, n) {
  const r = e.a, g = e.b, o = e.c;
  let l = t, a = t + 1, I = t + 2;
  i && (l = i.getX(l), a = i.getX(a), I = i.getX(I)), r.x = n.getX(l), r.y = n.getY(l), r.z = n.getZ(l), g.x = n.getX(a), g.y = n.getY(a), g.z = n.getZ(a), o.x = n.getX(I), o.y = n.getY(I), o.z = n.getZ(I);
}
function ZSt(e, t, i, n, r, g) {
  const { geometry: o, _indirectBuffer: l } = e;
  for (let a = n, I = n + r; a < I; a++)
    B1(o, t, i, a, g);
}
function GSt(e, t, i, n, r) {
  const { geometry: g, _indirectBuffer: o } = e;
  let l = 1 / 0, a = null;
  for (let I = n, c = n + r; I < c; I++) {
    let d;
    d = B1(g, t, i, I), d && d.distance < l && (a = d, l = d.distance);
  }
  return a;
}
function ySt(e, t, i, n, r, g, o) {
  const { geometry: l } = i, { index: a } = l, I = l.attributes.position;
  for (let c = e, d = t + e; c < d; c++) {
    let C;
    if (C = c, Dr(o, C * 3, a, I), o.needsUpdate = !0, n(o, C, r, g))
      return !0;
  }
  return !1;
}
function WSt(e, t = null) {
  t && Array.isArray(t) && (t = new Set(t));
  const i = e.geometry, n = i.index ? i.index.array : null, r = i.attributes.position;
  let g, o, l, a, I = 0;
  const c = e._roots;
  for (let C = 0, A = c.length; C < A; C++)
    g = c[C], o = new Uint32Array(g), l = new Uint16Array(g), a = new Float32Array(g), d(0, I), I += g.byteLength;
  function d(C, A, b = !1) {
    const m = C * 2;
    if (l[m + 15] === p1) {
      const B = o[C + 6], f = l[m + 14];
      let Z = 1 / 0, y = 1 / 0, W = 1 / 0, V = -1 / 0, w = -1 / 0, v = -1 / 0;
      for (let H = 3 * B, x = 3 * (B + f); H < x; H++) {
        let J = n[H];
        const K = r.getX(J), M = r.getY(J), L = r.getZ(J);
        K < Z && (Z = K), K > V && (V = K), M < y && (y = M), M > w && (w = M), L < W && (W = L), L > v && (v = L);
      }
      return a[C + 0] !== Z || a[C + 1] !== y || a[C + 2] !== W || a[C + 3] !== V || a[C + 4] !== w || a[C + 5] !== v ? (a[C + 0] = Z, a[C + 1] = y, a[C + 2] = W, a[C + 3] = V, a[C + 4] = w, a[C + 5] = v, !0) : !1;
    } else {
      const B = C + 8, f = o[C + 6], Z = B + A, y = f + A;
      let W = b, V = !1, w = !1;
      t ? W || (V = t.has(Z), w = t.has(y), W = !V && !w) : (V = !0, w = !0);
      const v = W || V, H = W || w;
      let x = !1;
      v && (x = d(B, A, W));
      let J = !1;
      H && (J = d(f, A, W));
      const K = x || J;
      if (K)
        for (let M = 0; M < 3; M++) {
          const L = B + M, N = f + M, U = a[L], O = a[L + 3], $ = a[N], ne = a[N + 3];
          a[C + M] = U < $ ? U : $, a[C + M + 3] = O > ne ? O : ne;
        }
      return K;
    }
  }
}
const SP = /* @__PURE__ */ new fg();
function ru(e, t, i, n) {
  return ar(e, t, SP), i.intersectBox(SP, n);
}
function SSt(e, t, i, n, r, g) {
  const { geometry: o, _indirectBuffer: l } = e;
  for (let a = n, I = n + r; a < I; a++) {
    let c = l ? l[a] : a;
    B1(o, t, i, c, g);
  }
}
function VSt(e, t, i, n, r) {
  const { geometry: g, _indirectBuffer: o } = e;
  let l = 1 / 0, a = null;
  for (let I = n, c = n + r; I < c; I++) {
    let d;
    d = B1(g, t, i, o ? o[I] : I), d && d.distance < l && (a = d, l = d.distance);
  }
  return a;
}
function wSt(e, t, i, n, r, g, o) {
  const { geometry: l } = i, { index: a } = l, I = l.attributes.position;
  for (let c = e, d = t + e; c < d; c++) {
    let C;
    if (C = i.resolveTriangleIndex(c), Dr(o, C * 3, a, I), o.needsUpdate = !0, n(o, C, r, g))
      return !0;
  }
  return !1;
}
const VP = /* @__PURE__ */ new ye();
function vSt(e, t, i, n, r) {
  zn.setBuffer(e._roots[t]), R5(0, e, i, n, r), zn.clearBuffer();
}
function R5(e, t, i, n, r) {
  const { float32Array: g, uint16Array: o, uint32Array: l } = zn, a = e * 2;
  if (kl(a, o)) {
    const c = Jl(e, l), d = Xa(a, o);
    ZSt(t, i, n, c, d, r);
  } else {
    const c = Ha(e);
    ru(c, g, n, VP) && R5(c, t, i, n, r);
    const d = ka(e, l);
    ru(d, g, n, VP) && R5(d, t, i, n, r);
  }
}
const wP = /* @__PURE__ */ new ye(), RSt = ["x", "y", "z"];
function XSt(e, t, i, n) {
  zn.setBuffer(e._roots[t]);
  const r = X5(0, e, i, n);
  return zn.clearBuffer(), r;
}
function X5(e, t, i, n) {
  const { float32Array: r, uint16Array: g, uint32Array: o } = zn;
  let l = e * 2;
  if (kl(l, g)) {
    const I = Jl(e, o), c = Xa(l, g);
    return GSt(t, i, n, I, c);
  } else {
    const I = oee(e, o), c = RSt[I], C = n.direction[c] >= 0;
    let A, b;
    C ? (A = Ha(e), b = ka(e, o)) : (A = ka(e, o), b = Ha(e));
    const p = ru(A, r, n, wP) ? X5(A, t, i, n) : null;
    if (p) {
      const Z = p.point[c];
      if (C ? Z <= r[b + I] : (
        // min bounding data
        Z >= r[b + I + 3]
      ))
        return p;
    }
    const f = ru(b, r, n, wP) ? X5(b, t, i, n) : null;
    return p && f ? p.distance <= f.distance ? p : f : p || f || null;
  }
}
const GS = /* @__PURE__ */ new fg(), bh = /* @__PURE__ */ new Ma(), hh = /* @__PURE__ */ new Ma(), cB = /* @__PURE__ */ new ks(), vP = /* @__PURE__ */ new xo(), yS = /* @__PURE__ */ new xo();
function HSt(e, t, i, n) {
  zn.setBuffer(e._roots[t]);
  const r = H5(0, e, i, n);
  return zn.clearBuffer(), r;
}
function H5(e, t, i, n, r = null) {
  const { float32Array: g, uint16Array: o, uint32Array: l } = zn;
  let a = e * 2;
  if (r === null && (i.boundingBox || i.computeBoundingBox(), vP.set(i.boundingBox.min, i.boundingBox.max, n), r = vP), kl(a, o)) {
    const c = t.geometry, d = c.index, C = c.attributes.position, A = i.index, b = i.attributes.position, m = Jl(e, l), p = Xa(a, o);
    if (cB.copy(n).invert(), i.boundsTree)
      return ar(e, g, yS), yS.matrix.copy(cB), yS.needsUpdate = !0, i.boundsTree.shapecast({
        intersectsBounds: (f) => yS.intersectsBox(f),
        intersectsTriangle: (f) => {
          f.a.applyMatrix4(n), f.b.applyMatrix4(n), f.c.applyMatrix4(n), f.needsUpdate = !0;
          for (let Z = m * 3, y = (p + m) * 3; Z < y; Z += 3)
            if (Dr(hh, Z, d, C), hh.needsUpdate = !0, f.intersectsTriangle(hh))
              return !0;
          return !1;
        }
      });
    for (let B = m * 3, f = (p + m) * 3; B < f; B += 3) {
      Dr(bh, B, d, C), bh.a.applyMatrix4(cB), bh.b.applyMatrix4(cB), bh.c.applyMatrix4(cB), bh.needsUpdate = !0;
      for (let Z = 0, y = A.count; Z < y; Z += 3)
        if (Dr(hh, Z, A, b), hh.needsUpdate = !0, bh.intersectsTriangle(hh))
          return !0;
    }
  } else {
    const c = e + 8, d = l[e + 6];
    return ar(c, g, GS), !!(r.intersectsBox(GS) && H5(c, t, i, n, r) || (ar(d, g, GS), r.intersectsBox(GS) && H5(d, t, i, n, r)));
  }
}
const WS = /* @__PURE__ */ new ks(), oF = /* @__PURE__ */ new xo(), dB = /* @__PURE__ */ new xo(), kSt = /* @__PURE__ */ new ye(), YSt = /* @__PURE__ */ new ye(), FSt = /* @__PURE__ */ new ye(), xSt = /* @__PURE__ */ new ye();
function DSt(e, t, i, n = {}, r = {}, g = 0, o = 1 / 0) {
  t.boundingBox || t.computeBoundingBox(), oF.set(t.boundingBox.min, t.boundingBox.max, i), oF.needsUpdate = !0;
  const l = e.geometry, a = l.attributes.position, I = l.index, c = t.attributes.position, d = t.index, C = Ra.getPrimitive(), A = Ra.getPrimitive();
  let b = kSt, m = YSt, p = null, B = null;
  r && (p = FSt, B = xSt);
  let f = 1 / 0, Z = null, y = null;
  return WS.copy(i).invert(), dB.matrix.copy(WS), e.shapecast(
    {
      boundsTraverseOrder: (W) => oF.distanceToBox(W),
      intersectsBounds: (W, V, w) => w < f && w < o ? (V && (dB.min.copy(W.min), dB.max.copy(W.max), dB.needsUpdate = !0), !0) : !1,
      intersectsRange: (W, V) => {
        if (t.boundsTree)
          return t.boundsTree.shapecast({
            boundsTraverseOrder: (v) => dB.distanceToBox(v),
            intersectsBounds: (v, H, x) => x < f && x < o,
            intersectsRange: (v, H) => {
              for (let x = v, J = v + H; x < J; x++) {
                Dr(A, 3 * x, d, c), A.a.applyMatrix4(i), A.b.applyMatrix4(i), A.c.applyMatrix4(i), A.needsUpdate = !0;
                for (let K = W, M = W + V; K < M; K++) {
                  Dr(C, 3 * K, I, a), C.needsUpdate = !0;
                  const L = C.distanceToTriangle(A, b, p);
                  if (L < f && (m.copy(b), B && B.copy(p), f = L, Z = K, y = x), L < g)
                    return !0;
                }
              }
            }
          });
        {
          const w = Mm(t);
          for (let v = 0, H = w; v < H; v++) {
            Dr(A, 3 * v, d, c), A.a.applyMatrix4(i), A.b.applyMatrix4(i), A.c.applyMatrix4(i), A.needsUpdate = !0;
            for (let x = W, J = W + V; x < J; x++) {
              Dr(C, 3 * x, I, a), C.needsUpdate = !0;
              const K = C.distanceToTriangle(A, b, p);
              if (K < f && (m.copy(b), B && B.copy(p), f = K, Z = x, y = v), K < g)
                return !0;
            }
          }
        }
      }
    }
  ), Ra.releasePrimitive(C), Ra.releasePrimitive(A), f === 1 / 0 ? null : (n.point ? n.point.copy(m) : n.point = m.clone(), n.distance = f, n.faceIndex = Z, r && (r.point ? r.point.copy(B) : r.point = B.clone(), r.point.applyMatrix4(WS), m.applyMatrix4(WS), r.distance = m.sub(r.point).length(), r.faceIndex = y), n);
}
function JSt(e, t = null) {
  t && Array.isArray(t) && (t = new Set(t));
  const i = e.geometry, n = i.index ? i.index.array : null, r = i.attributes.position;
  let g, o, l, a, I = 0;
  const c = e._roots;
  for (let C = 0, A = c.length; C < A; C++)
    g = c[C], o = new Uint32Array(g), l = new Uint16Array(g), a = new Float32Array(g), d(0, I), I += g.byteLength;
  function d(C, A, b = !1) {
    const m = C * 2;
    if (l[m + 15] === p1) {
      const B = o[C + 6], f = l[m + 14];
      let Z = 1 / 0, y = 1 / 0, W = 1 / 0, V = -1 / 0, w = -1 / 0, v = -1 / 0;
      for (let H = B, x = B + f; H < x; H++) {
        const J = 3 * e.resolveTriangleIndex(H);
        for (let K = 0; K < 3; K++) {
          let M = J + K;
          M = n ? n[M] : M;
          const L = r.getX(M), N = r.getY(M), U = r.getZ(M);
          L < Z && (Z = L), L > V && (V = L), N < y && (y = N), N > w && (w = N), U < W && (W = U), U > v && (v = U);
        }
      }
      return a[C + 0] !== Z || a[C + 1] !== y || a[C + 2] !== W || a[C + 3] !== V || a[C + 4] !== w || a[C + 5] !== v ? (a[C + 0] = Z, a[C + 1] = y, a[C + 2] = W, a[C + 3] = V, a[C + 4] = w, a[C + 5] = v, !0) : !1;
    } else {
      const B = C + 8, f = o[C + 6], Z = B + A, y = f + A;
      let W = b, V = !1, w = !1;
      t ? W || (V = t.has(Z), w = t.has(y), W = !V && !w) : (V = !0, w = !0);
      const v = W || V, H = W || w;
      let x = !1;
      v && (x = d(B, A, W));
      let J = !1;
      H && (J = d(f, A, W));
      const K = x || J;
      if (K)
        for (let M = 0; M < 3; M++) {
          const L = B + M, N = f + M, U = a[L], O = a[L + 3], $ = a[N], ne = a[N + 3];
          a[C + M] = U < $ ? U : $, a[C + M + 3] = O > ne ? O : ne;
        }
      return K;
    }
  }
}
const RP = /* @__PURE__ */ new ye();
function ESt(e, t, i, n, r) {
  zn.setBuffer(e._roots[t]), k5(0, e, i, n, r), zn.clearBuffer();
}
function k5(e, t, i, n, r) {
  const { float32Array: g, uint16Array: o, uint32Array: l } = zn, a = e * 2;
  if (kl(a, o)) {
    const c = Jl(e, l), d = Xa(a, o);
    SSt(t, i, n, c, d, r);
  } else {
    const c = Ha(e);
    ru(c, g, n, RP) && k5(c, t, i, n, r);
    const d = ka(e, l);
    ru(d, g, n, RP) && k5(d, t, i, n, r);
  }
}
const XP = /* @__PURE__ */ new ye(), NSt = ["x", "y", "z"];
function LSt(e, t, i, n) {
  zn.setBuffer(e._roots[t]);
  const r = Y5(0, e, i, n);
  return zn.clearBuffer(), r;
}
function Y5(e, t, i, n) {
  const { float32Array: r, uint16Array: g, uint32Array: o } = zn;
  let l = e * 2;
  if (kl(l, g)) {
    const I = Jl(e, o), c = Xa(l, g);
    return VSt(t, i, n, I, c);
  } else {
    const I = oee(e, o), c = NSt[I], C = n.direction[c] >= 0;
    let A, b;
    C ? (A = Ha(e), b = ka(e, o)) : (A = ka(e, o), b = Ha(e));
    const p = ru(A, r, n, XP) ? Y5(A, t, i, n) : null;
    if (p) {
      const Z = p.point[c];
      if (C ? Z <= r[b + I] : (
        // min bounding data
        Z >= r[b + I + 3]
      ))
        return p;
    }
    const f = ru(b, r, n, XP) ? Y5(b, t, i, n) : null;
    return p && f ? p.distance <= f.distance ? p : f : p || f || null;
  }
}
const SS = /* @__PURE__ */ new fg(), mh = /* @__PURE__ */ new Ma(), ph = /* @__PURE__ */ new Ma(), uB = /* @__PURE__ */ new ks(), HP = /* @__PURE__ */ new xo(), VS = /* @__PURE__ */ new xo();
function KSt(e, t, i, n) {
  zn.setBuffer(e._roots[t]);
  const r = F5(0, e, i, n);
  return zn.clearBuffer(), r;
}
function F5(e, t, i, n, r = null) {
  const { float32Array: g, uint16Array: o, uint32Array: l } = zn;
  let a = e * 2;
  if (r === null && (i.boundingBox || i.computeBoundingBox(), HP.set(i.boundingBox.min, i.boundingBox.max, n), r = HP), kl(a, o)) {
    const c = t.geometry, d = c.index, C = c.attributes.position, A = i.index, b = i.attributes.position, m = Jl(e, l), p = Xa(a, o);
    if (uB.copy(n).invert(), i.boundsTree)
      return ar(e, g, VS), VS.matrix.copy(uB), VS.needsUpdate = !0, i.boundsTree.shapecast({
        intersectsBounds: (f) => VS.intersectsBox(f),
        intersectsTriangle: (f) => {
          f.a.applyMatrix4(n), f.b.applyMatrix4(n), f.c.applyMatrix4(n), f.needsUpdate = !0;
          for (let Z = m, y = p + m; Z < y; Z++)
            if (Dr(ph, 3 * t.resolveTriangleIndex(Z), d, C), ph.needsUpdate = !0, f.intersectsTriangle(ph))
              return !0;
          return !1;
        }
      });
    for (let B = m, f = p + m; B < f; B++) {
      const Z = t.resolveTriangleIndex(B);
      Dr(mh, 3 * Z, d, C), mh.a.applyMatrix4(uB), mh.b.applyMatrix4(uB), mh.c.applyMatrix4(uB), mh.needsUpdate = !0;
      for (let y = 0, W = A.count; y < W; y += 3)
        if (Dr(ph, y, A, b), ph.needsUpdate = !0, mh.intersectsTriangle(ph))
          return !0;
    }
  } else {
    const c = e + 8, d = l[e + 6];
    return ar(c, g, SS), !!(r.intersectsBox(SS) && F5(c, t, i, n, r) || (ar(d, g, SS), r.intersectsBox(SS) && F5(d, t, i, n, r)));
  }
}
const wS = /* @__PURE__ */ new ks(), lF = /* @__PURE__ */ new xo(), CB = /* @__PURE__ */ new xo(), TSt = /* @__PURE__ */ new ye(), MSt = /* @__PURE__ */ new ye(), PSt = /* @__PURE__ */ new ye(), USt = /* @__PURE__ */ new ye();
function zSt(e, t, i, n = {}, r = {}, g = 0, o = 1 / 0) {
  t.boundingBox || t.computeBoundingBox(), lF.set(t.boundingBox.min, t.boundingBox.max, i), lF.needsUpdate = !0;
  const l = e.geometry, a = l.attributes.position, I = l.index, c = t.attributes.position, d = t.index, C = Ra.getPrimitive(), A = Ra.getPrimitive();
  let b = TSt, m = MSt, p = null, B = null;
  r && (p = PSt, B = USt);
  let f = 1 / 0, Z = null, y = null;
  return wS.copy(i).invert(), CB.matrix.copy(wS), e.shapecast(
    {
      boundsTraverseOrder: (W) => lF.distanceToBox(W),
      intersectsBounds: (W, V, w) => w < f && w < o ? (V && (CB.min.copy(W.min), CB.max.copy(W.max), CB.needsUpdate = !0), !0) : !1,
      intersectsRange: (W, V) => {
        if (t.boundsTree) {
          const w = t.boundsTree;
          return w.shapecast({
            boundsTraverseOrder: (v) => CB.distanceToBox(v),
            intersectsBounds: (v, H, x) => x < f && x < o,
            intersectsRange: (v, H) => {
              for (let x = v, J = v + H; x < J; x++) {
                const K = w.resolveTriangleIndex(x);
                Dr(A, 3 * K, d, c), A.a.applyMatrix4(i), A.b.applyMatrix4(i), A.c.applyMatrix4(i), A.needsUpdate = !0;
                for (let M = W, L = W + V; M < L; M++) {
                  const N = e.resolveTriangleIndex(M);
                  Dr(C, 3 * N, I, a), C.needsUpdate = !0;
                  const U = C.distanceToTriangle(A, b, p);
                  if (U < f && (m.copy(b), B && B.copy(p), f = U, Z = M, y = x), U < g)
                    return !0;
                }
              }
            }
          });
        } else {
          const w = Mm(t);
          for (let v = 0, H = w; v < H; v++) {
            Dr(A, 3 * v, d, c), A.a.applyMatrix4(i), A.b.applyMatrix4(i), A.c.applyMatrix4(i), A.needsUpdate = !0;
            for (let x = W, J = W + V; x < J; x++) {
              const K = e.resolveTriangleIndex(x);
              Dr(C, 3 * K, I, a), C.needsUpdate = !0;
              const M = C.distanceToTriangle(A, b, p);
              if (M < f && (m.copy(b), B && B.copy(p), f = M, Z = x, y = v), M < g)
                return !0;
            }
          }
        }
      }
    }
  ), Ra.releasePrimitive(C), Ra.releasePrimitive(A), f === 1 / 0 ? null : (n.point ? n.point.copy(m) : n.point = m.clone(), n.distance = f, n.faceIndex = Z, r && (r.point ? r.point.copy(B) : r.point = B.clone(), r.point.applyMatrix4(wS), m.applyMatrix4(wS), r.distance = m.sub(r.point).length(), r.faceIndex = y), n);
}
function OSt() {
  return typeof SharedArrayBuffer < "u";
}
const af = new zn.constructor(), Xw = new zn.constructor(), Wd = new yE(() => new fg()), Bh = new fg(), fh = new fg(), aF = new fg(), sF = new fg();
let IF = !1;
function QSt(e, t, i, n) {
  if (IF)
    throw new Error("MeshBVH: Recursive calls to bvhcast not supported.");
  IF = !0;
  const r = e._roots, g = t._roots;
  let o, l = 0, a = 0;
  const I = new ks().copy(i).invert();
  for (let c = 0, d = r.length; c < d; c++) {
    af.setBuffer(r[c]), a = 0;
    const C = Wd.getPrimitive();
    ar(0, af.float32Array, C), C.applyMatrix4(I);
    for (let A = 0, b = g.length; A < b && (Xw.setBuffer(g[c]), o = fs(
      0,
      0,
      i,
      I,
      n,
      l,
      a,
      0,
      0,
      C
    ), Xw.clearBuffer(), a += g[A].length, !o); A++)
      ;
    if (Wd.releasePrimitive(C), af.clearBuffer(), l += r[c].length, o)
      break;
  }
  return IF = !1, o;
}
function fs(e, t, i, n, r, g = 0, o = 0, l = 0, a = 0, I = null, c = !1) {
  let d, C;
  c ? (d = Xw, C = af) : (d = af, C = Xw);
  const A = d.float32Array, b = d.uint32Array, m = d.uint16Array, p = C.float32Array, B = C.uint32Array, f = C.uint16Array, Z = e * 2, y = t * 2, W = kl(Z, m), V = kl(y, f);
  let w = !1;
  if (V && W)
    c ? w = r(
      Jl(t, B),
      Xa(t * 2, f),
      Jl(e, b),
      Xa(e * 2, m),
      a,
      o + t,
      l,
      g + e
    ) : w = r(
      Jl(e, b),
      Xa(e * 2, m),
      Jl(t, B),
      Xa(t * 2, f),
      l,
      g + e,
      a,
      o + t
    );
  else if (V) {
    const v = Wd.getPrimitive();
    ar(t, p, v), v.applyMatrix4(i);
    const H = Ha(e), x = ka(e, b);
    ar(H, A, Bh), ar(x, A, fh);
    const J = v.intersectsBox(Bh), K = v.intersectsBox(fh);
    w = J && fs(
      t,
      H,
      n,
      i,
      r,
      o,
      g,
      a,
      l + 1,
      v,
      !c
    ) || K && fs(
      t,
      x,
      n,
      i,
      r,
      o,
      g,
      a,
      l + 1,
      v,
      !c
    ), Wd.releasePrimitive(v);
  } else {
    const v = Ha(t), H = ka(t, B);
    ar(v, p, aF), ar(H, p, sF);
    const x = I.intersectsBox(aF), J = I.intersectsBox(sF);
    if (x && J)
      w = fs(
        e,
        v,
        i,
        n,
        r,
        g,
        o,
        l,
        a + 1,
        I,
        c
      ) || fs(
        e,
        H,
        i,
        n,
        r,
        g,
        o,
        l,
        a + 1,
        I,
        c
      );
    else if (x)
      if (W)
        w = fs(
          e,
          v,
          i,
          n,
          r,
          g,
          o,
          l,
          a + 1,
          I,
          c
        );
      else {
        const K = Wd.getPrimitive();
        K.copy(aF).applyMatrix4(i);
        const M = Ha(e), L = ka(e, b);
        ar(M, A, Bh), ar(L, A, fh);
        const N = K.intersectsBox(Bh), U = K.intersectsBox(fh);
        w = N && fs(
          v,
          M,
          n,
          i,
          r,
          o,
          g,
          a,
          l + 1,
          K,
          !c
        ) || U && fs(
          v,
          L,
          n,
          i,
          r,
          o,
          g,
          a,
          l + 1,
          K,
          !c
        ), Wd.releasePrimitive(K);
      }
    else if (J)
      if (W)
        w = fs(
          e,
          H,
          i,
          n,
          r,
          g,
          o,
          l,
          a + 1,
          I,
          c
        );
      else {
        const K = Wd.getPrimitive();
        K.copy(sF).applyMatrix4(i);
        const M = Ha(e), L = ka(e, b);
        ar(M, A, Bh), ar(L, A, fh);
        const N = K.intersectsBox(Bh), U = K.intersectsBox(fh);
        w = N && fs(
          H,
          M,
          n,
          i,
          r,
          o,
          g,
          a,
          l + 1,
          K,
          !c
        ) || U && fs(
          H,
          L,
          n,
          i,
          r,
          o,
          g,
          a,
          l + 1,
          K,
          !c
        ), Wd.releasePrimitive(K);
      }
  }
  return w;
}
const vS = /* @__PURE__ */ new xo(), kP = /* @__PURE__ */ new fg();
class WE {
  static serialize(t, i = {}) {
    i = {
      cloneBuffers: !0,
      ...i
    };
    const n = t.geometry, r = t._roots, g = t._indirectBuffer, o = n.getIndex();
    let l;
    return i.cloneBuffers ? l = {
      roots: r.map((a) => a.slice()),
      index: o.array.slice(),
      indirectBuffer: g ? g.slice() : null
    } : l = {
      roots: r,
      index: o.array,
      indirectBuffer: g
    }, l;
  }
  static deserialize(t, i, n = {}) {
    n = {
      setIndex: !0,
      indirect: !!t.indirectBuffer,
      ...n
    };
    const { index: r, roots: g, indirectBuffer: o } = t, l = new WE(i, { ...n, [iF]: !0 });
    if (l._roots = g, l._indirectBuffer = o || null, n.setIndex) {
      const a = i.getIndex();
      if (a === null) {
        const I = new sZ(t.index, 1, !1);
        i.setIndex(I);
      } else
        a.array !== r && (a.array.set(r), a.needsUpdate = !0);
    }
    return l;
  }
  get indirect() {
    return !!this._indirectBuffer;
  }
  constructor(t, i = {}) {
    if (t.isBufferGeometry) {
      if (t.index && t.index.isInterleavedBufferAttribute)
        throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
    } else
      throw new Error("MeshBVH: Only BufferGeometries are supported.");
    if (i = Object.assign({
      strategy: nee,
      maxDepth: 40,
      maxLeafTris: 10,
      verbose: !0,
      useSharedArrayBuffer: !1,
      setBoundingBox: !0,
      onProgress: null,
      indirect: !1,
      // undocumented options
      // Whether to skip generating the tree. Used for deserialization.
      [iF]: !1
    }, i), i.useSharedArrayBuffer && !OSt())
      throw new Error("MeshBVH: SharedArrayBuffer is not available.");
    this.geometry = t, this._roots = null, this._indirectBuffer = null, i[iF] || (dSt(this, i), !t.boundingBox && i.setBoundingBox && (t.boundingBox = this.getBoundingBox(new fg())));
    const { _indirectBuffer: n } = this;
    this.resolveTriangleIndex = i.indirect ? (r) => n[r] : (r) => r;
  }
  refit(t = null) {
    return (this.indirect ? JSt : WSt)(this, t);
  }
  traverse(t, i = 0) {
    const n = this._roots[i], r = new Uint32Array(n), g = new Uint16Array(n);
    o(0);
    function o(l, a = 0) {
      const I = l * 2, c = g[I + 15] === p1;
      if (c) {
        const d = r[l + 6], C = g[I + 14];
        t(a, c, new Float32Array(n, l * 4, 6), d, C);
      } else {
        const d = l + ZV / 4, C = r[l + 6], A = r[l + 7];
        t(a, c, new Float32Array(n, l * 4, 6), A) || (o(d, a + 1), o(C, a + 1));
      }
    }
  }
  /* Core Cast Functions */
  raycast(t, i = sL) {
    const n = this._roots, r = this.geometry, g = [], o = i.isMaterial, l = Array.isArray(i), a = r.groups, I = o ? i.side : i, c = this.indirect ? ESt : vSt;
    for (let d = 0, C = n.length; d < C; d++) {
      const A = l ? i[a[d].materialIndex].side : I, b = g.length;
      if (c(this, d, A, t, g), l) {
        const m = a[d].materialIndex;
        for (let p = b, B = g.length; p < B; p++)
          g[p].face.materialIndex = m;
      }
    }
    return g;
  }
  raycastFirst(t, i = sL) {
    const n = this._roots, r = this.geometry, g = i.isMaterial, o = Array.isArray(i);
    let l = null;
    const a = r.groups, I = g ? i.side : i, c = this.indirect ? LSt : XSt;
    for (let d = 0, C = n.length; d < C; d++) {
      const A = o ? i[a[d].materialIndex].side : I, b = c(this, d, A, t);
      b != null && (l == null || b.distance < l.distance) && (l = b, o && (b.face.materialIndex = a[d].materialIndex));
    }
    return l;
  }
  intersectsGeometry(t, i) {
    let n = !1;
    const r = this._roots, g = this.indirect ? KSt : HSt;
    for (let o = 0, l = r.length; o < l && (n = g(this, o, t, i), !n); o++)
      ;
    return n;
  }
  shapecast(t) {
    const i = Ra.getPrimitive(), n = this.indirect ? wSt : ySt;
    let {
      boundsTraverseOrder: r,
      intersectsBounds: g,
      intersectsRange: o,
      intersectsTriangle: l
    } = t;
    if (o && l) {
      const d = o;
      o = (C, A, b, m, p) => d(C, A, b, m, p) ? !0 : n(C, A, this, l, b, m, i);
    } else
      o || (l ? o = (d, C, A, b) => n(d, C, this, l, A, b, i) : o = (d, C, A) => A);
    let a = !1, I = 0;
    const c = this._roots;
    for (let d = 0, C = c.length; d < C; d++) {
      const A = c[d];
      if (a = mSt(this, d, g, o, r, I), a)
        break;
      I += A.byteLength;
    }
    return Ra.releasePrimitive(i), a;
  }
  bvhcast(t, i, n) {
    let {
      intersectsRanges: r,
      intersectsTriangles: g
    } = n;
    const o = Ra.getPrimitive(), l = this.geometry.index, a = this.geometry.attributes.position, I = this.indirect ? (b) => {
      const m = this.resolveTriangleIndex(b);
      Dr(o, m * 3, l, a);
    } : (b) => {
      Dr(o, b * 3, l, a);
    }, c = Ra.getPrimitive(), d = t.geometry.index, C = t.geometry.attributes.position, A = t.indirect ? (b) => {
      const m = t.resolveTriangleIndex(b);
      Dr(c, m * 3, d, C);
    } : (b) => {
      Dr(c, b * 3, d, C);
    };
    if (g) {
      const b = (m, p, B, f, Z, y, W, V) => {
        for (let w = B, v = B + f; w < v; w++) {
          A(w), c.a.applyMatrix4(i), c.b.applyMatrix4(i), c.c.applyMatrix4(i), c.needsUpdate = !0;
          for (let H = m, x = m + p; H < x; H++)
            if (I(H), o.needsUpdate = !0, g(o, c, H, w, Z, y, W, V))
              return !0;
        }
        return !1;
      };
      if (r) {
        const m = r;
        r = function(p, B, f, Z, y, W, V, w) {
          return m(p, B, f, Z, y, W, V, w) ? !0 : b(p, B, f, Z, y, W, V, w);
        };
      } else
        r = b;
    }
    return QSt(this, t, i, r);
  }
  /* Derived Cast Functions */
  intersectsBox(t, i) {
    return vS.set(t.min, t.max, i), vS.needsUpdate = !0, this.shapecast(
      {
        intersectsBounds: (n) => vS.intersectsBox(n),
        intersectsTriangle: (n) => vS.intersectsTriangle(n)
      }
    );
  }
  intersectsSphere(t) {
    return this.shapecast(
      {
        intersectsBounds: (i) => t.intersectsBox(i),
        intersectsTriangle: (i) => i.intersectsSphere(t)
      }
    );
  }
  closestPointToGeometry(t, i, n = {}, r = {}, g = 0, o = 1 / 0) {
    return (this.indirect ? zSt : DSt)(
      this,
      t,
      i,
      n,
      r,
      g,
      o
    );
  }
  closestPointToPoint(t, i = {}, n = 0, r = 1 / 0) {
    return pSt(
      this,
      t,
      i,
      n,
      r
    );
  }
  getBoundingBox(t) {
    return t.makeEmpty(), this._roots.forEach((n) => {
      ar(0, new Float32Array(n), kP), t.union(kP);
    }), t;
  }
}
const lee = 1e-6, jSt = lee * 0.5, aee = Math.pow(10, -Math.log10(lee)), qSt = jSt * aee;
function CI(e) {
  return ~~(e * aee + qSt);
}
function _St(e) {
  return `${CI(e.x)},${CI(e.y)}`;
}
function YP(e) {
  return `${CI(e.x)},${CI(e.y)},${CI(e.z)}`;
}
function $St(e) {
  return `${CI(e.x)},${CI(e.y)},${CI(e.z)},${CI(e.w)}`;
}
function eVt(e, t, i) {
  i.direction.subVectors(t, e).normalize();
  const n = e.dot(i.direction);
  return i.origin.copy(e).addScaledVector(i.direction, -n), i;
}
function see() {
  return typeof SharedArrayBuffer < "u";
}
function tVt(e) {
  if (e.buffer instanceof SharedArrayBuffer)
    return e;
  const t = e.constructor, i = e.buffer, n = new SharedArrayBuffer(i.byteLength), r = new Uint8Array(i);
  return new Uint8Array(n).set(r, 0), new t(n);
}
function iVt(e, t = ArrayBuffer) {
  return e > 65535 ? new Uint32Array(new t(4 * e)) : new Uint16Array(new t(2 * e));
}
function nVt(e, t) {
  if (!e.index) {
    const i = e.attributes.position.count, n = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, r = iVt(i, n);
    e.setIndex(new sZ(r, 1));
    for (let g = 0; g < i; g++)
      r[g] = g;
  }
}
function rVt(e) {
  return e.index ? e.index.count : e.attributes.position.count;
}
function SE(e) {
  return rVt(e) / 3;
}
const gVt = 1e-8, oVt = new ye();
function lVt(e) {
  return ~~(e / 3);
}
function aVt(e) {
  return e % 3;
}
function FP(e, t) {
  return e.start - t.start;
}
function xP(e, t) {
  return oVt.subVectors(t, e.origin).dot(e.direction);
}
function sVt(e, t, i, n = gVt) {
  e.sort(FP), t.sort(FP);
  for (let l = 0; l < e.length; l++) {
    const a = e[l];
    for (let I = 0; I < t.length; I++) {
      const c = t[I];
      if (!(c.start > a.end)) {
        if (a.end < c.start || c.end < a.start)
          continue;
        if (a.start <= c.start && a.end >= c.end)
          g(c.end, a.end) || e.splice(l + 1, 0, {
            start: c.end,
            end: a.end,
            index: a.index
          }), a.end = c.start, c.start = 0, c.end = 0;
        else if (a.start >= c.start && a.end <= c.end)
          g(a.end, c.end) || t.splice(I + 1, 0, {
            start: a.end,
            end: c.end,
            index: c.index
          }), c.end = a.start, a.start = 0, a.end = 0;
        else if (a.start <= c.start && a.end <= c.end) {
          const d = a.end;
          a.end = c.start, c.start = d;
        } else if (a.start >= c.start && a.end >= c.end) {
          const d = c.end;
          c.end = a.start, a.start = d;
        } else
          throw new Error();
      }
      if (i.has(a.index) || i.set(a.index, []), i.has(c.index) || i.set(c.index, []), i.get(a.index).push(c.index), i.get(c.index).push(a.index), o(c) && (t.splice(I, 1), I--), o(a)) {
        e.splice(l, 1), l--;
        break;
      }
    }
  }
  r(e), r(t);
  function r(l) {
    for (let a = 0; a < l.length; a++)
      o(l[a]) && (l.splice(a, 1), a--);
  }
  function g(l, a) {
    return Math.abs(a - l) < n;
  }
  function o(l) {
    return Math.abs(l.end - l.start) < n;
  }
}
const DP = 1e-5, JP = 1e-4;
class IVt {
  constructor() {
    this._rays = [];
  }
  addRay(t) {
    this._rays.push(t);
  }
  findClosestRay(t) {
    const i = this._rays, n = t.clone();
    n.direction.multiplyScalar(-1);
    let r = 1 / 0, g = null;
    for (let a = 0, I = i.length; a < I; a++) {
      const c = i[a];
      if (o(c, t) && o(c, n))
        continue;
      const d = l(c, t), C = l(c, n), A = Math.min(d, C);
      A < r && (r = A, g = c);
    }
    return g;
    function o(a, I) {
      const c = a.origin.distanceTo(I.origin) > DP;
      return a.direction.angleTo(I.direction) > JP || c;
    }
    function l(a, I) {
      const c = a.origin.distanceTo(I.origin), d = a.direction.angleTo(I.direction);
      return c / DP + d / JP;
    }
  }
}
const cF = new ye(), dF = new ye(), RS = new y4();
function cVt(e, t, i) {
  const n = e.attributes, r = e.index, g = n.position, o = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), a = Array.from(t), I = new IVt();
  for (let c = 0, d = a.length; c < d; c++) {
    const C = a[c], A = lVt(C), b = aVt(C);
    let m = 3 * A + b, p = 3 * A + (b + 1) % 3;
    r && (m = r.getX(m), p = r.getX(p)), cF.fromBufferAttribute(g, m), dF.fromBufferAttribute(g, p), eVt(cF, dF, RS);
    let B, f = I.findClosestRay(RS);
    f === null && (f = RS.clone(), I.addRay(f)), l.has(f) || l.set(f, {
      forward: [],
      reverse: [],
      ray: f
    }), B = l.get(f);
    let Z = xP(f, cF), y = xP(f, dF);
    Z > y && ([Z, y] = [y, Z]), RS.direction.dot(f.direction) < 0 ? B.reverse.push({ start: Z, end: y, index: C }) : B.forward.push({ start: Z, end: y, index: C });
  }
  return l.forEach(({ forward: c, reverse: d }, C) => {
    sVt(c, d, o, i), c.length === 0 && d.length === 0 && l.delete(C);
  }), {
    disjointConnectivityMap: o,
    fragmentMap: l
  };
}
const dVt = new fc(), uF = new ye(), uVt = new cA(), CF = ["", "", ""];
class CVt {
  constructor(t = null) {
    this.data = null, this.disjointConnections = null, this.unmatchedDisjointEdges = null, this.unmatchedEdges = -1, this.matchedEdges = -1, this.useDrawRange = !0, this.useAllAttributes = !1, this.matchDisjointEdges = !1, this.degenerateEpsilon = 1e-8, t && this.updateFrom(t);
  }
  getSiblingTriangleIndex(t, i) {
    const n = this.data[t * 3 + i];
    return n === -1 ? -1 : ~~(n / 3);
  }
  getSiblingEdgeIndex(t, i) {
    const n = this.data[t * 3 + i];
    return n === -1 ? -1 : n % 3;
  }
  getDisjointSiblingTriangleIndices(t, i) {
    const n = t * 3 + i, r = this.disjointConnections.get(n);
    return r ? r.map((g) => ~~(g / 3)) : [];
  }
  getDisjointSiblingEdgeIndices(t, i) {
    const n = t * 3 + i, r = this.disjointConnections.get(n);
    return r ? r.map((g) => g % 3) : [];
  }
  isFullyConnected() {
    return this.unmatchedEdges === 0;
  }
  updateFrom(t) {
    const { useAllAttributes: i, useDrawRange: n, matchDisjointEdges: r, degenerateEpsilon: g } = this, o = i ? Z : f, l = /* @__PURE__ */ new Map(), { attributes: a } = t, I = i ? Object.keys(a) : null, c = t.index, d = a.position;
    let C = SE(t);
    const A = C;
    let b = 0;
    n && (b = t.drawRange.start, t.drawRange.count !== 1 / 0 && (C = ~~(t.drawRange.count / 3)));
    let m = this.data;
    (!m || m.length < 3 * A) && (m = new Int32Array(3 * A)), m.fill(-1);
    let p = 0, B = /* @__PURE__ */ new Set();
    for (let y = b, W = C * 3 + b; y < W; y += 3) {
      const V = y;
      for (let w = 0; w < 3; w++) {
        let v = V + w;
        c && (v = c.getX(v)), CF[w] = o(v);
      }
      for (let w = 0; w < 3; w++) {
        const v = (w + 1) % 3, H = CF[w], x = CF[v], J = `${x}_${H}`;
        if (l.has(J)) {
          const K = V + w, M = l.get(J);
          m[K] = M, m[M] = K, l.delete(J), p += 2, B.delete(M);
        } else {
          const K = `${H}_${x}`, M = V + w;
          l.set(K, M), B.add(M);
        }
      }
    }
    if (r) {
      const {
        fragmentMap: y,
        disjointConnectivityMap: W
      } = cVt(t, B, g);
      B.clear(), y.forEach(({ forward: V, reverse: w }) => {
        V.forEach(({ index: v }) => B.add(v)), w.forEach(({ index: v }) => B.add(v));
      }), this.unmatchedDisjointEdges = y, this.disjointConnections = W, p = C * 3 - B.size;
    }
    this.matchedEdges = p, this.unmatchedEdges = B.size, this.data = m;
    function f(y) {
      return uF.fromBufferAttribute(d, y), YP(uF);
    }
    function Z(y) {
      let W = "";
      for (let V = 0, w = I.length; V < w; V++) {
        const v = a[I[V]];
        let H;
        switch (v.itemSize) {
          case 1:
            H = CI(v.getX(y));
            break;
          case 2:
            H = _St(dVt.fromBufferAttribute(v, y));
            break;
          case 3:
            H = YP(uF.fromBufferAttribute(v, y));
            break;
          case 4:
            H = $St(uVt.fromBufferAttribute(v, y));
            break;
        }
        W !== "" && (W += "|"), W += H;
      }
      return W;
    }
  }
}
class Uf extends foe {
  constructor(...t) {
    super(...t), this.isBrush = !0, this._previousMatrix = new ks(), this._previousMatrix.elements.fill(0);
  }
  markUpdated() {
    this._previousMatrix.copy(this.matrix);
  }
  isDirty() {
    const { matrix: t, _previousMatrix: i } = this, n = t.elements, r = i.elements;
    for (let g = 0; g < 16; g++)
      if (n[g] !== r[g])
        return !0;
    return !1;
  }
  prepareGeometry() {
    const t = this.geometry, i = t.attributes, n = see();
    if (n)
      for (const r in i) {
        const g = i[r];
        if (g.isInterleavedBufferAttribute)
          throw new Error("Brush: InterleavedBufferAttributes are not supported.");
        g.array = tVt(g.array);
      }
    if (t.boundsTree || (nVt(t, { useSharedArrayBuffer: n }), t.boundsTree = new WE(t, { maxLeafTris: 3, indirect: !0, useSharedArrayBuffer: n })), t.halfEdges || (t.halfEdges = new CVt(t)), !t.groupIndices) {
      const r = SE(t), g = new Uint16Array(r), o = t.groups;
      for (let l = 0, a = o.length; l < a; l++) {
        const { start: I, count: c } = o[l];
        for (let d = I / 3, C = (I + c) / 3; d < C; d++)
          g[d] = l;
      }
      t.groupIndices = g;
    }
  }
  disposeCacheData() {
    const { geometry: t } = this;
    t.halfEdges = null, t.boundsTree = null, t.groupIndices = null;
  }
}
const AVt = 1e-14, AF = new ye(), EP = new ye(), NP = new ye();
function Rd(e, t = AVt) {
  AF.subVectors(e.b, e.a), EP.subVectors(e.c, e.a), NP.subVectors(e.b, e.c);
  const i = AF.angleTo(EP), n = AF.angleTo(NP), r = Math.PI - i - n;
  return Math.abs(i) < t || Math.abs(n) < t || Math.abs(r) < t || e.a.distanceToSquared(e.b) < t || e.a.distanceToSquared(e.c) < t || e.b.distanceToSquared(e.c) < t;
}
const bF = 1e-10, AB = 1e-10, bVt = 1e-10, sc = new Nl(), Wr = new Nl(), Ic = new ye(), hF = new ye(), LP = new ye(), XS = new xC(), mF = new Ma();
class hVt {
  constructor() {
    this._pool = [], this._index = 0;
  }
  getTriangle() {
    return this._index >= this._pool.length && this._pool.push(new Fl()), this._pool[this._index++];
  }
  clear() {
    this._index = 0;
  }
  reset() {
    this._pool.length = 0, this._index = 0;
  }
}
class mVt {
  constructor() {
    this.trianglePool = new hVt(), this.triangles = [], this.normal = new ye(), this.coplanarTriangleUsed = !1;
  }
  // initialize the class with a triangle
  initialize(t) {
    this.reset();
    const { triangles: i, trianglePool: n, normal: r } = this;
    if (Array.isArray(t))
      for (let g = 0, o = t.length; g < o; g++) {
        const l = t[g];
        if (g === 0)
          l.getNormal(r);
        else if (Math.abs(1 - l.getNormal(Ic).dot(r)) > bF)
          throw new Error("Triangle Splitter: Cannot initialize with triangles that have different normals.");
        const a = n.getTriangle();
        a.copy(l), i.push(a);
      }
    else {
      t.getNormal(r);
      const g = n.getTriangle();
      g.copy(t), i.push(g);
    }
  }
  // Split the current set of triangles by passing a single triangle in. If the triangle is
  // coplanar it will attempt to split by the triangle edge planes
  splitByTriangle(t) {
    const { normal: i, triangles: n } = this;
    if (t.getNormal(hF).normalize(), Math.abs(1 - Math.abs(hF.dot(i))) < bVt) {
      this.coplanarTriangleUsed = !0;
      for (let g = 0, o = n.length; g < o; g++) {
        const l = n[g];
        l.coplanarCount = 0;
      }
      const r = [t.a, t.b, t.c];
      for (let g = 0; g < 3; g++) {
        const o = (g + 1) % 3, l = r[g], a = r[o];
        Ic.subVectors(a, l).normalize(), LP.crossVectors(hF, Ic), XS.setFromNormalAndCoplanarPoint(LP, l), this.splitByPlane(XS, t);
      }
    } else
      t.getPlane(XS), this.splitByPlane(XS, t);
  }
  // Split the triangles by the given plan. If a triangle is provided then we ensure we
  // intersect the triangle before splitting the plane
  splitByPlane(t, i) {
    const { triangles: n, trianglePool: r } = this;
    mF.copy(i), mF.needsUpdate = !0;
    for (let g = 0, o = n.length; g < o; g++) {
      const l = n[g];
      if (!mF.intersectsTriangle(l, sc, !0))
        continue;
      const { a, b: I, c } = l;
      let d = 0, C = -1, A = !1, b = [], m = [];
      const p = [a, I, c];
      for (let B = 0; B < 3; B++) {
        const f = (B + 1) % 3;
        sc.start.copy(p[B]), sc.end.copy(p[f]);
        const Z = t.distanceToPoint(sc.start), y = t.distanceToPoint(sc.end);
        if (Math.abs(Z) < AB && Math.abs(y) < AB) {
          A = !0;
          break;
        }
        if (Z > 0 ? b.push(B) : m.push(B), Math.abs(Z) < AB)
          continue;
        let W = !!t.intersectLine(sc, Ic);
        !W && Math.abs(y) < AB && (Ic.copy(sc.end), W = !0), W && !(Ic.distanceTo(sc.start) < bF) && (Ic.distanceTo(sc.end) < bF && (C = B), d === 0 ? Wr.start.copy(Ic) : Wr.end.copy(Ic), d++);
      }
      if (!A && d === 2 && Wr.distance() > AB)
        if (C !== -1) {
          C = (C + 1) % 3;
          let B = 0;
          B === C && (B = (B + 1) % 3);
          let f = B + 1;
          f === C && (f = (f + 1) % 3);
          const Z = r.getTriangle();
          Z.a.copy(p[f]), Z.b.copy(Wr.end), Z.c.copy(Wr.start), Rd(Z) || n.push(Z), l.a.copy(p[B]), l.b.copy(Wr.start), l.c.copy(Wr.end), Rd(l) && (n.splice(g, 1), g--, o--);
        } else {
          const B = b.length >= 2 ? m[0] : b[0];
          if (B === 0) {
            let V = Wr.start;
            Wr.start = Wr.end, Wr.end = V;
          }
          const f = (B + 1) % 3, Z = (B + 2) % 3, y = r.getTriangle(), W = r.getTriangle();
          p[f].distanceToSquared(Wr.start) < p[Z].distanceToSquared(Wr.end) ? (y.a.copy(p[f]), y.b.copy(Wr.start), y.c.copy(Wr.end), W.a.copy(p[f]), W.b.copy(p[Z]), W.c.copy(Wr.start)) : (y.a.copy(p[Z]), y.b.copy(Wr.start), y.c.copy(Wr.end), W.a.copy(p[f]), W.b.copy(p[Z]), W.c.copy(Wr.end)), l.a.copy(p[B]), l.b.copy(Wr.end), l.c.copy(Wr.start), Rd(y) || n.push(y), Rd(W) || n.push(W), Rd(l) && (n.splice(g, 1), g--, o--);
        }
      else
        d === 3 && console.warn("TriangleClipper: Coplanar clip not handled");
    }
  }
  reset() {
    this.triangles.length = 0, this.trianglePool.clear(), this.coplanarTriangleUsed = !1;
  }
}
function pVt(e) {
  return e = ~~e, e + 4 - e % 4;
}
class KP {
  constructor(t, i = 500) {
    this.expansionFactor = 1.5, this.type = t, this.length = 0, this.array = null, this.setSize(i);
  }
  setType(t) {
    if (this.length !== 0)
      throw new Error("TypeBackedArray: Cannot change the type while there is used data in the buffer.");
    const i = this.array.buffer;
    this.array = new t(i), this.type = t;
  }
  setSize(t) {
    if (this.array && t === this.array.length)
      return;
    const i = this.type, n = see() ? SharedArrayBuffer : ArrayBuffer, r = new i(new n(pVt(t * i.BYTES_PER_ELEMENT)));
    this.array && r.set(this.array, 0), this.array = r;
  }
  expand() {
    const { array: t, expansionFactor: i } = this;
    this.setSize(t.length * i);
  }
  push(...t) {
    let { array: i, length: n } = this;
    n + t.length > i.length && (this.expand(), i = this.array);
    for (let r = 0, g = t.length; r < g; r++)
      i[n + r] = t[r];
    this.length += t.length;
  }
  clear() {
    this.length = 0;
  }
}
class BVt {
  constructor() {
    this.groupAttributes = [{}], this.groupCount = 0;
  }
  // returns the buffer type for the given attribute
  getType(t) {
    return this.groupAttributes[0][t].type;
  }
  getItemSize(t) {
    return this.groupAttributes[0][t].itemSize;
  }
  getNormalized(t) {
    return this.groupAttributes[0][t].normalized;
  }
  getCount(t) {
    if (this.groupCount <= t)
      return 0;
    const i = this.getGroupAttrArray("position", t);
    return i.length / i.itemSize;
  }
  // returns the total length required for all groups for the given attribute
  getTotalLength(t) {
    const { groupCount: i, groupAttributes: n } = this;
    let r = 0;
    for (let g = 0; g < i; g++) {
      const o = n[g];
      r += o[t].length;
    }
    return r;
  }
  getGroupAttrSet(t = 0) {
    const { groupAttributes: i } = this;
    if (i[t])
      return this.groupCount = Math.max(this.groupCount, t + 1), i[t];
    const n = i[0];
    for (this.groupCount = Math.max(this.groupCount, t + 1); t >= i.length; ) {
      const r = {};
      i.push(r);
      for (const g in n) {
        const o = n[g], l = new KP(o.type);
        l.itemSize = o.itemSize, l.normalized = o.normalized, r[g] = l;
      }
    }
    return i[t];
  }
  // Get the raw array for the group set of data
  getGroupAttrArray(t, i = 0) {
    const { groupAttributes: n } = this;
    if (!n[0][t])
      throw new Error(`TypedAttributeData: Attribute with "${t}" has not been initialized`);
    return this.getGroupAttrSet(i)[t];
  }
  // initializes an attribute array with the given name, type, and size
  initializeArray(t, i, n, r) {
    const { groupAttributes: g } = this, l = g[0][t];
    if (l) {
      if (l.type !== i)
        for (let a = 0, I = g.length; a < I; a++) {
          const c = g[a][t];
          c.setType(i), c.itemSize = n, c.normalized = r;
        }
    } else
      for (let a = 0, I = g.length; a < I; a++) {
        const c = new KP(i);
        c.itemSize = n, c.normalized = r, g[a][t] = c;
      }
  }
  // Clear all the data
  clear() {
    this.groupCount = 0;
    const { groupAttributes: t } = this;
    t.forEach((i) => {
      for (const n in i)
        i[n].clear();
    });
  }
  // Remove the given key
  delete(t) {
    this.groupAttributes.forEach((i) => {
      delete i[t];
    });
  }
  // Reset the datasets completely
  reset() {
    this.groupAttributes = [], this.groupCount = 0;
  }
}
class TP {
  constructor() {
    this.intersectionSet = {}, this.ids = [];
  }
  add(t, i) {
    const { intersectionSet: n, ids: r } = this;
    n[t] || (n[t] = [], r.push(t)), n[t].push(i);
  }
}
const VE = 0, Iee = 1, cee = 2, dee = 3, uee = 4, Cee = 5, Aee = 6, Ga = new y4(), MP = new ks(), po = new Fl(), cc = new ye(), PP = new cA(), UP = new cA(), zP = new cA(), pF = new cA(), HS = new cA(), kS = new cA(), OP = new Nl(), BF = new ye(), fF = 1e-8, fVt = 1e-15, HC = -1, kC = 1, GV = -2, yV = 2, sf = 0, CC = 1, wE = 2, ZVt = 1e-14;
let WV = null;
function QP(e) {
  WV = e;
}
function bee(e, t) {
  e.getMidpoint(Ga.origin), e.getNormal(Ga.direction);
  const i = t.raycastFirst(Ga, wD);
  return !!(i && Ga.direction.dot(i.face.normal) > 0) ? HC : kC;
}
function GVt(e, t) {
  function i() {
    return Math.random() - 0.5;
  }
  e.getNormal(BF), Ga.direction.copy(BF), e.getMidpoint(Ga.origin);
  const n = 3;
  let r = 0, g = 1 / 0;
  for (let o = 0; o < n; o++) {
    Ga.direction.x += i() * fF, Ga.direction.y += i() * fF, Ga.direction.z += i() * fF, Ga.direction.multiplyScalar(-1);
    const l = t.raycastFirst(Ga, wD);
    if (!!(l && Ga.direction.dot(l.face.normal) > 0) && r++, l !== null && (g = Math.min(g, l.distance)), g <= fVt)
      return l.face.normal.dot(BF) > 0 ? yV : GV;
    if (r / n > 0.5 || (o - r + 1) / n > 0.5)
      break;
  }
  return r / n > 0.5 ? HC : kC;
}
function yVt(e, t) {
  const i = new TP(), n = new TP();
  return MP.copy(e.matrixWorld).invert().multiply(t.matrixWorld), e.geometry.boundsTree.bvhcast(t.geometry.boundsTree, MP, {
    intersectsTriangles(r, g, o, l) {
      if (!Rd(r) && !Rd(g)) {
        let a = r.intersectsTriangle(g, OP, !0);
        if (!a) {
          const I = r.plane, c = g.plane, d = I.normal, C = c.normal;
          d.dot(C) === 1 && Math.abs(I.constant - c.constant) < ZVt && (a = !0);
        }
        if (a) {
          let I = e.geometry.boundsTree.resolveTriangleIndex(o), c = t.geometry.boundsTree.resolveTriangleIndex(l);
          i.add(I, c), n.add(c, I), WV && (WV.addEdge(OP), WV.addIntersectingTriangles(o, r, l, g));
        }
      }
      return !1;
    }
  }), { aIntersections: i, bIntersections: n };
}
function WVt(e, t, i, n, r, g, o = !1) {
  const l = i.attributes, a = i.index, I = e * 3, c = a.getX(I + 0), d = a.getX(I + 1), C = a.getX(I + 2);
  for (const A in g) {
    const b = l[A], m = g[A];
    if (!(A in l))
      throw new Error(`CSG Operations: Attribute ${A} not available on geometry.`);
    const p = b.itemSize;
    A === "position" ? (po.a.fromBufferAttribute(b, c).applyMatrix4(n), po.b.fromBufferAttribute(b, d).applyMatrix4(n), po.c.fromBufferAttribute(b, C).applyMatrix4(n), ZF(po.a, po.b, po.c, t, 3, m, o)) : A === "normal" ? (po.a.fromBufferAttribute(b, c).applyNormalMatrix(r), po.b.fromBufferAttribute(b, d).applyNormalMatrix(r), po.c.fromBufferAttribute(b, C).applyNormalMatrix(r), o && (po.a.multiplyScalar(-1), po.b.multiplyScalar(-1), po.c.multiplyScalar(-1)), ZF(po.a, po.b, po.c, t, 3, m, o, !0)) : (PP.fromBufferAttribute(b, c), UP.fromBufferAttribute(b, d), zP.fromBufferAttribute(b, C), ZF(PP, UP, zP, t, p, m, o));
  }
}
function SVt(e, t, i, n, r, g, o, l = !1) {
  GF(e, n, r, g, o, l), GF(l ? i : t, n, r, g, o, l), GF(l ? t : i, n, r, g, o, l);
}
function hee(e, t, i = !1) {
  switch (e) {
    case VE:
      if (t === kC || t === yV && !i)
        return CC;
      break;
    case Iee:
      if (i) {
        if (t === HC)
          return sf;
      } else if (t === kC || t === GV)
        return CC;
      break;
    case cee:
      if (i) {
        if (t === kC || t === GV)
          return CC;
      } else if (t === HC)
        return sf;
      break;
    case uee:
      if (t === HC)
        return sf;
      if (t === kC)
        return CC;
      break;
    case dee:
      if (t === HC || t === yV && !i)
        return CC;
      break;
    case Cee:
      if (!i && (t === kC || t === GV))
        return CC;
      break;
    case Aee:
      if (!i && (t === HC || t === yV))
        return CC;
      break;
    default:
      throw new Error(`Unrecognized CSG operation enum "${e}".`);
  }
  return wE;
}
function ZF(e, t, i, n, r, g, o = !1, l = !1) {
  const a = (I) => {
    g.push(I.x), r > 1 && g.push(I.y), r > 2 && g.push(I.z), r > 3 && g.push(I.w);
  };
  pF.set(0, 0, 0, 0).addScaledVector(e, n.a.x).addScaledVector(t, n.a.y).addScaledVector(i, n.a.z), HS.set(0, 0, 0, 0).addScaledVector(e, n.b.x).addScaledVector(t, n.b.y).addScaledVector(i, n.b.z), kS.set(0, 0, 0, 0).addScaledVector(e, n.c.x).addScaledVector(t, n.c.y).addScaledVector(i, n.c.z), l && (pF.normalize(), HS.normalize(), kS.normalize()), a(pF), o ? (a(kS), a(HS)) : (a(HS), a(kS));
}
function GF(e, t, i, n, r, g = !1) {
  for (const o in r) {
    const l = t[o], a = r[o];
    if (!(o in t))
      throw new Error(`CSG Operations: Attribute ${o} no available on geometry.`);
    const I = l.itemSize;
    o === "position" ? (cc.fromBufferAttribute(l, e).applyMatrix4(i), a.push(cc.x, cc.y, cc.z)) : o === "normal" ? (cc.fromBufferAttribute(l, e).applyNormalMatrix(n), g && cc.multiplyScalar(-1), a.push(cc.x, cc.y, cc.z)) : (a.push(l.getX(e)), I > 1 && a.push(l.getY(e)), I > 2 && a.push(l.getZ(e)), I > 3 && a.push(l.getW(e)));
  }
}
class VVt {
  constructor(t) {
    this.triangle = new Fl().copy(t), this.intersects = {};
  }
  addTriangle(t, i) {
    this.intersects[t] = new Fl().copy(i);
  }
  getIntersectArray() {
    const t = [], { intersects: i } = this;
    for (const n in i)
      t.push(i[n]);
    return t;
  }
}
class jP {
  constructor() {
    this.data = {};
  }
  addTriangleIntersection(t, i, n, r) {
    const { data: g } = this;
    g[t] || (g[t] = new VVt(i)), g[t].addTriangle(n, r);
  }
  getTrianglesAsArray(t = null) {
    const { data: i } = this, n = [];
    if (t !== null)
      t in i && n.push(i[t].triangle);
    else
      for (const r in i)
        n.push(i[r].triangle);
    return n;
  }
  getTriangleIndices() {
    return Object.keys(this.data).map((t) => parseInt(t));
  }
  getIntersectionIndices(t) {
    const { data: i } = this;
    return i[t] ? Object.keys(i[t].intersects).map((n) => parseInt(n)) : [];
  }
  getIntersectionsAsArray(t = null, i = null) {
    const { data: n } = this, r = /* @__PURE__ */ new Set(), g = [], o = (l) => {
      if (n[l])
        if (i !== null)
          n[l].intersects[i] && g.push(n[l].intersects[i]);
        else {
          const a = n[l].intersects;
          for (const I in a)
            r.has(I) || (r.add(I), g.push(a[I]));
        }
    };
    if (t !== null)
      o(t);
    else
      for (const l in n)
        o(l);
    return g;
  }
  reset() {
    this.data = {};
  }
}
class wVt {
  constructor() {
    this.enabled = !1, this.triangleIntersectsA = new jP(), this.triangleIntersectsB = new jP(), this.intersectionEdges = [];
  }
  addIntersectingTriangles(t, i, n, r) {
    const { triangleIntersectsA: g, triangleIntersectsB: o } = this;
    g.addTriangleIntersection(t, i, n, r), o.addTriangleIntersection(n, r, t, i);
  }
  addEdge(t) {
    this.intersectionEdges.push(t.clone());
  }
  reset() {
    this.triangleIntersectsA.reset(), this.triangleIntersectsB.reset(), this.intersectionEdges = [];
  }
  init() {
    this.enabled && (this.reset(), QP(this));
  }
  complete() {
    this.enabled && QP(null);
  }
}
const Fd = new ks(), Hw = new Zoe(), AC = new Fl(), YS = new Fl(), hd = new Fl(), FS = new Fl(), ws = [], QC = [];
function vVt(e) {
  for (const t of e)
    return t;
}
function RVt(e, t, i, n, r, g = {}) {
  const { useGroups: o = !0 } = g, { aIntersections: l, bIntersections: a } = yVt(e, t), I = [];
  let c = null, d;
  return d = o ? 0 : -1, qP(e, t, l, i, !1, n, r, d), _P(e, t, l, i, !1, r, d), i.findIndex((A) => A !== Aee && A !== Cee) !== -1 && (d = o ? e.geometry.groups.length || 1 : -1, qP(t, e, a, i, !0, n, r, d), _P(t, e, a, i, !0, r, d)), ws.length = 0, QC.length = 0, {
    groups: I,
    materials: c
  };
}
function qP(e, t, i, n, r, g, o, l = 0) {
  const a = e.matrixWorld.determinant() < 0;
  Fd.copy(t.matrixWorld).invert().multiply(e.matrixWorld), Hw.getNormalMatrix(e.matrixWorld).multiplyScalar(a ? -1 : 1);
  const I = e.geometry.groupIndices, c = e.geometry.index, d = e.geometry.attributes.position, C = t.geometry.boundsTree, A = t.geometry.index, b = t.geometry.attributes.position, m = i.ids, p = i.intersectionSet;
  for (let B = 0, f = m.length; B < f; B++) {
    const Z = m[B], y = l === -1 ? 0 : I[Z] + l, W = 3 * Z, V = c.getX(W + 0), w = c.getX(W + 1), v = c.getX(W + 2);
    AC.a.fromBufferAttribute(d, V).applyMatrix4(Fd), AC.b.fromBufferAttribute(d, w).applyMatrix4(Fd), AC.c.fromBufferAttribute(d, v).applyMatrix4(Fd), g.reset(), g.initialize(AC);
    const H = p[Z];
    for (let J = 0, K = H.length; J < K; J++) {
      const M = 3 * H[J], L = A.getX(M + 0), N = A.getX(M + 1), U = A.getX(M + 2);
      YS.a.fromBufferAttribute(b, L), YS.b.fromBufferAttribute(b, N), YS.c.fromBufferAttribute(b, U), g.splitByTriangle(YS);
    }
    const x = g.triangles;
    for (let J = 0, K = x.length; J < K; J++) {
      const M = x[J], L = g.coplanarTriangleUsed ? GVt(M, C) : bee(M, C);
      ws.length = 0, QC.length = 0;
      for (let N = 0, U = n.length; N < U; N++) {
        const O = hee(n[N], L, r);
        O !== wE && (QC.push(O), ws.push(o[N].getGroupAttrSet(y)));
      }
      if (ws.length !== 0) {
        AC.getBarycoord(M.a, FS.a), AC.getBarycoord(M.b, FS.b), AC.getBarycoord(M.c, FS.c);
        for (let N = 0, U = ws.length; N < U; N++) {
          const O = ws[N], ne = QC[N] === sf;
          WVt(Z, FS, e.geometry, e.matrixWorld, Hw, O, a !== ne);
        }
      }
    }
  }
  return m.length;
}
function _P(e, t, i, n, r, g, o = 0) {
  const l = e.matrixWorld.determinant() < 0;
  Fd.copy(t.matrixWorld).invert().multiply(e.matrixWorld), Hw.getNormalMatrix(e.matrixWorld).multiplyScalar(l ? -1 : 1);
  const a = t.geometry.boundsTree, I = e.geometry.groupIndices, c = e.geometry.index, d = e.geometry.attributes, C = d.position, A = [], b = e.geometry.halfEdges, m = /* @__PURE__ */ new Set(), p = SE(e.geometry);
  for (let B = 0, f = p; B < f; B++)
    B in i.intersectionSet || m.add(B);
  for (; m.size > 0; ) {
    const B = vVt(m);
    m.delete(B), A.push(B);
    const f = 3 * B, Z = c.getX(f + 0), y = c.getX(f + 1), W = c.getX(f + 2);
    hd.a.fromBufferAttribute(C, Z).applyMatrix4(Fd), hd.b.fromBufferAttribute(C, y).applyMatrix4(Fd), hd.c.fromBufferAttribute(C, W).applyMatrix4(Fd);
    const V = bee(hd, a);
    QC.length = 0, ws.length = 0;
    for (let w = 0, v = n.length; w < v; w++) {
      const H = hee(n[w], V, r);
      H !== wE && (QC.push(H), ws.push(g[w]));
    }
    for (; A.length > 0; ) {
      const w = A.pop();
      for (let v = 0; v < 3; v++) {
        const H = b.getSiblingTriangleIndex(w, v);
        H !== -1 && m.has(H) && (A.push(H), m.delete(H));
      }
      if (ws.length !== 0) {
        const v = 3 * w, H = c.getX(v + 0), x = c.getX(v + 1), J = c.getX(v + 2), K = o === -1 ? 0 : I[w] + o;
        if (hd.a.fromBufferAttribute(C, H), hd.b.fromBufferAttribute(C, x), hd.c.fromBufferAttribute(C, J), !Rd(hd))
          for (let M = 0, L = ws.length; M < L; M++) {
            const N = QC[M], U = ws[M].getGroupAttrSet(K), O = N === sf;
            SVt(H, x, J, d, e.matrixWorld, Hw, U, O !== l);
          }
      }
    }
  }
}
function XVt(e) {
  for (let t = 0; t < e.length - 1; t++) {
    const i = e[t], n = e[t + 1];
    if (i.materialIndex === n.materialIndex) {
      const r = i.start, g = n.start + n.count;
      n.start = r, n.count = g - r, e.splice(t, 1), t--;
    }
  }
}
function HVt(e, t, i, n) {
  i.clear();
  const r = e.attributes;
  for (let g = 0, o = n.length; g < o; g++) {
    const l = n[g], a = r[l];
    i.initializeArray(l, a.array.constructor, a.itemSize, a.normalized);
  }
  for (const g in i.attributes)
    n.includes(g) || i.delete(g);
  for (const g in t.attributes)
    n.includes(g) || (t.deleteAttribute(g), t.dispose());
}
function kVt(e, t, i) {
  let n = !1, r = -1;
  const g = e.attributes, o = t.groupAttributes[0];
  for (const a in o) {
    const I = t.getTotalLength(a), c = t.getType(a), d = t.getItemSize(a), C = t.getNormalized(a);
    let A = g[a];
    (!A || A.array.length < I) && (A = new sZ(new c(I), d, C), e.setAttribute(a, A), n = !0);
    let b = 0;
    for (let m = 0, p = Math.min(i.length, t.groupCount); m < p; m++) {
      const B = i[m].index, { array: f, type: Z, length: y } = t.groupAttributes[B][a], W = new Z(f.buffer, 0, y);
      A.array.set(W, b), b += W.length;
    }
    A.needsUpdate = !0, r = I / A.itemSize;
  }
  if (e.index) {
    const a = e.index.array;
    if (a.length < r)
      e.index = null, n = !0;
    else
      for (let I = 0, c = a.length; I < c; I++)
        a[I] = I;
  }
  let l = 0;
  e.clearGroups();
  for (let a = 0, I = Math.min(i.length, t.groupCount); a < I; a++) {
    const { index: c, materialIndex: d } = i[a], C = t.getCount(c);
    C !== 0 && (e.addGroup(l, C, d), l += C);
  }
  e.setDrawRange(0, r), e.boundsTree = null, n && e.dispose();
}
function $P(e, t) {
  let i = t;
  return Array.isArray(t) || (i = [], e.forEach((n) => {
    i[n.materialIndex] = t;
  })), i;
}
class YVt {
  constructor() {
    this.triangleSplitter = new mVt(), this.attributeData = [], this.attributes = ["position", "uv", "normal"], this.useGroups = !0, this.consolidateGroups = !0, this.debug = new wVt();
  }
  getGroupRanges(t) {
    return !this.useGroups || t.groups.length === 0 ? [{ start: 0, count: 1 / 0, materialIndex: 0 }] : t.groups.map((i) => ({ ...i }));
  }
  evaluate(t, i, n, r = new Uf()) {
    let g = !0;
    if (Array.isArray(n) || (n = [n]), Array.isArray(r) || (r = [r], g = !1), r.length !== n.length)
      throw new Error("Evaluator: operations and target array passed as different sizes.");
    t.prepareGeometry(), i.prepareGeometry();
    const {
      triangleSplitter: o,
      attributeData: l,
      attributes: a,
      useGroups: I,
      consolidateGroups: c,
      debug: d
    } = this;
    for (; l.length < r.length; )
      l.push(new BVt());
    r.forEach((B, f) => {
      HVt(t.geometry, B.geometry, l[f], a);
    }), d.init(), RVt(t, i, n, o, l, { useGroups: I }), d.complete();
    const C = this.getGroupRanges(t.geometry), A = $P(C, t.material), b = this.getGroupRanges(i.geometry), m = $P(b, i.material);
    b.forEach((B) => B.materialIndex += A.length);
    let p = [...C, ...b].map((B, f) => ({ ...B, index: f }));
    if (I) {
      const B = [...A, ...m];
      c && (p = p.map((Z) => {
        const y = B[Z.materialIndex];
        return Z.materialIndex = B.indexOf(y), Z;
      }).sort((Z, y) => Z.materialIndex - y.materialIndex));
      const f = [];
      for (let Z = 0, y = B.length; Z < y; Z++) {
        let W = !1;
        for (let V = 0, w = p.length; V < w; V++) {
          const v = p[V];
          v.materialIndex === Z && (W = !0, v.materialIndex = f.length);
        }
        W && f.push(B[Z]);
      }
      r.forEach((Z) => {
        Z.material = f;
      });
    } else
      p = [{ start: 0, count: 1 / 0, index: 0, materialIndex: 0 }], r.forEach((B) => {
        B.material = A[0];
      });
    return r.forEach((B, f) => {
      const Z = B.geometry;
      kVt(Z, l[f], p), c && XVt(Z.groups);
    }), g ? r : r[0];
  }
  // TODO: fix
  evaluateHierarchy(t, i = new Uf()) {
    t.updateMatrixWorld(!0);
    const n = (g, o) => {
      const l = g.children;
      for (let a = 0, I = l.length; a < I; a++) {
        const c = l[a];
        c.isOperationGroup ? n(c, o) : o(c);
      }
    }, r = (g) => {
      const o = g.children;
      let l = !1;
      for (let I = 0, c = o.length; I < c; I++) {
        const d = o[I];
        l = r(d) || l;
      }
      const a = g.isDirty();
      if (a && g.markUpdated(), l && !g.isOperationGroup) {
        let I;
        return n(g, (c) => {
          I ? I = this.evaluate(I, c, c.operation) : I = this.evaluate(g, c, c.operation);
        }), g._cachedGeometry = I.geometry, g._cachedMaterials = I.material, !0;
      } else
        return l || a;
    };
    return r(t), i.geometry = t._cachedGeometry, i.material = t._cachedMaterials, i;
  }
  reset() {
    this.triangleSplitter.reset();
  }
}
const FVt = {
  subtraction: Iee,
  reverseSubtraction: cee,
  addition: VE,
  difference: uee,
  intersection: dee
};
function xVt(e) {
  e.dispose(), e.attributes = {}, e.groups = [], e.boundsTree = e.index = e.boundingBox = e.boundingSphere = null, e.drawRange = {
    start: 0,
    count: 1 / 0
  };
}
function eU(e) {
  let t = null;
  return e instanceof Uf ? (e.updateMatrixWorld(), t = e) : e.traverse((i) => {
    i.updateMatrixWorld(), !t && i instanceof Uf && (t = i);
  }), t;
}
const mee = /* @__PURE__ */ X.createContext(null), DVt = /* @__PURE__ */ X.forwardRef(({
  children: e,
  computeVertexNormals: t = !1,
  useGroups: i = !1,
  showOperations: n = !1
}, r) => {
  const g = X.useRef(null), o = X.useRef(null), l = X.useMemo(() => Object.assign(new YVt(), {
    useGroups: i
  }), [i]), a = X.useCallback(() => {
    try {
      const A = o.current.children.slice();
      if (A.length > 0) {
        xVt(g.current), o.current.matrixWorld.identity();
        let b = eU(A.shift());
        if (b) {
          for (var c, d, C; A.length; ) {
            const m = eU(A.shift());
            m && (b = l.evaluate(b, m, FVt[m.operator] || VE));
          }
          g.current.boundsTree = b.geometry.boundsTree, g.current.index = b.geometry.index, g.current.attributes = b.geometry.attributes, g.current.groups = b.geometry.groups, g.current.drawRange = b.geometry.drawRange, l.useGroups && (c = g.current) != null && (d = c.__r3f) != null && (C = d.parent) != null && C.material && (g.current.__r3f.parent.material = b.material), t && g.current.computeVertexNormals();
        }
      }
    } catch (A) {
      console.log(A);
    }
  }, [t, l]), I = X.useMemo(() => ({
    computeVertexNormals: t,
    showOperations: n,
    useGroups: i,
    update: a
  }), [t, n, i]);
  return X.useLayoutEffect(() => void a()), X.useImperativeHandle(r, () => ({
    geometry: g.current,
    operations: o.current,
    ...I
  }), [I]), /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement("group", {
    matrixAutoUpdate: !1,
    ref: o
  }, /* @__PURE__ */ X.createElement(mee.Provider, {
    value: I
  }, e)), /* @__PURE__ */ X.createElement("bufferGeometry", {
    ref: g
  }));
}), f1 = /* @__PURE__ */ X.forwardRef(({
  showOperation: e = !1,
  operator: t = "addition",
  ...i
}, n) => {
  Doe({
    Brush: Uf
  });
  const {
    showOperations: r
  } = X.useContext(mee);
  return /* @__PURE__ */ X.createElement("brush", F({
    operator: t,
    raycast: () => null,
    visible: e || r,
    ref: n
  }, i));
}), JVt = /* @__PURE__ */ X.forwardRef((e, t) => /* @__PURE__ */ X.createElement(f1, F({
  ref: t,
  operator: "addition"
}, e))), EVt = /* @__PURE__ */ X.forwardRef((e, t) => /* @__PURE__ */ X.createElement(f1, F({
  ref: t,
  operator: "subtraction"
}, e))), NVt = /* @__PURE__ */ X.forwardRef((e, t) => /* @__PURE__ */ X.createElement(f1, F({
  ref: t,
  operator: "intersection"
}, e)));
function LVt(e, t = !1) {
  const i = e[0].index !== null, n = new Set(Object.keys(e[0].attributes)), r = new Set(Object.keys(e[0].morphAttributes)), g = {}, o = {}, l = e[0].morphTargetsRelative, a = new Goe();
  let I = 0;
  for (let c = 0; c < e.length; ++c) {
    const d = e[c];
    let C = 0;
    if (i !== (d.index !== null))
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
    for (const A in d.attributes) {
      if (!n.has(A))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + '. All geometries must have compatible attributes; make sure "' + A + '" attribute exists among all geometries, or in none of them.'), null;
      g[A] === void 0 && (g[A] = []), g[A].push(d.attributes[A]), C++;
    }
    if (C !== n.size)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + ". Make sure all geometries have the same number of attributes."), null;
    if (l !== d.morphTargetsRelative)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
    for (const A in d.morphAttributes) {
      if (!r.has(A))
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + ".  .morphAttributes must be consistent throughout all geometries."), null;
      o[A] === void 0 && (o[A] = []), o[A].push(d.morphAttributes[A]);
    }
    if (t) {
      let A;
      if (i)
        A = d.index.count;
      else if (d.attributes.position !== void 0)
        A = d.attributes.position.count;
      else
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + c + ". The geometry must have either an index or a position attribute"), null;
      a.addGroup(I, A, c), I += A;
    }
  }
  if (i) {
    let c = 0;
    const d = [];
    for (let C = 0; C < e.length; ++C) {
      const A = e[C].index;
      for (let b = 0; b < A.count; ++b)
        d.push(A.getX(b) + c);
      c += e[C].attributes.position.count;
    }
    a.setIndex(d);
  }
  for (const c in g) {
    const d = tU(g[c]);
    if (!d)
      return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + c + " attribute."), null;
    a.setAttribute(c, d);
  }
  for (const c in o) {
    const d = o[c][0].length;
    if (d === 0)
      break;
    a.morphAttributes = a.morphAttributes || {}, a.morphAttributes[c] = [];
    for (let C = 0; C < d; ++C) {
      const A = [];
      for (let m = 0; m < o[c].length; ++m)
        A.push(o[c][m][C]);
      const b = tU(A);
      if (!b)
        return console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + c + " morphAttribute."), null;
      a.morphAttributes[c].push(b);
    }
  }
  return a;
}
function tU(e) {
  let t, i, n, r = -1, g = 0;
  for (let I = 0; I < e.length; ++I) {
    const c = e[I];
    if (c.isInterleavedBufferAttribute)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported."), null;
    if (t === void 0 && (t = c.array.constructor), t !== c.array.constructor)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
    if (i === void 0 && (i = c.itemSize), i !== c.itemSize)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
    if (n === void 0 && (n = c.normalized), n !== c.normalized)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
    if (r === -1 && (r = c.gpuType), r !== c.gpuType)
      return console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.gpuType must be consistent across matching attributes."), null;
    g += c.array.length;
  }
  const o = new t(g);
  let l = 0;
  for (let I = 0; I < e.length; ++I)
    o.set(e[I].array, l), l += e[I].array.length;
  const a = new sZ(o, i, n);
  return r !== void 0 && (a.gpuType = r), a;
}
const KVt = (e) => {
  const t = e;
  return t == null ? void 0 : t.isMesh;
}, pee = (e) => `${sl.libsUrl}3d/environments/${e}.hdr`, iei = (e) => {
  const {
    scene: t
  } = e;
  let i = 0, n = 0, r = 0;
  const g = /* @__PURE__ */ new Set();
  for (let o = 0, l = t.children.length; o < l; o++)
    t.children[o].traverseVisible(function(I) {
      if (i++, "isMesh" in I && I.isMesh) {
        const c = I;
        if (c.geometry === void 0)
          return;
        if (!g.has(c.geometry.uuid)) {
          g.add(c.geometry.uuid);
          const d = c.geometry;
          n += d.attributes.position.count, d.index !== null ? r += d.index.count / 3 : r += d.attributes.position.count / 3;
        }
      }
    });
  return {
    objects: i,
    vertices: n,
    triangles: r
  };
};
function TVt(e, t) {
  return Xoe(e, sl.libsUrl, t);
}
function MVt(e, t) {
  var n;
  let i = !1;
  e.scene.traverse((r) => {
    var g, o, l;
    KVt(r) && (r.userData.modelId = (g = t == null ? void 0 : t.model) == null ? void 0 : g.id, r.receiveShadow = !!((o = t.meshProps) != null && o.receiveShadow), r.castShadow = !!((l = t.meshProps) != null && l.castShadow), i = !0);
  }), i || (e.scene.userData.modelId = (n = t == null ? void 0 : t.model) == null ? void 0 : n.id);
}
function PVt(e, t) {
  var r, g;
  const i = TVt(e, !0);
  MVt(i, t);
  const n = t.onMaterialsLoaded;
  return lt(() => {
    n && n(i.materials);
  }, [i.materials, n]), i && t.onUpdate && t.onUpdate(i), (r = t.model) != null && r.key && (i.scene.name = (g = t.model) == null ? void 0 : g.key), i;
}
const iU = [0, 0, 0], UVt = [1, 1, 1];
function zVt(e, t) {
  const {
    rotation: i = iU,
    position: n = iU,
    scale: r = UVt
  } = e.meshProps ?? {};
  t.rotation.set(i[0], i[1], i[2]), t.position.set(n[0], n[1], n[2]), t.scale.set(r[0], r[1], r[2]), t.updateWorldMatrix(!0, !0);
}
function Z1(e) {
  var g;
  const t = PVt(e.fileURL || "", e), i = Oe(() => Object.values(t.materials), [t.materials]), {
    materials: n
  } = t$(i, (g = e.model) == null ? void 0 : g.id, e.modelAction), r = Oe(() => t.scene.clone(), [t.scene]);
  return de.isEmpty(n) || r.traverse((o) => {
    o.material && n[o.material.name] && (o.material = n[o.material.name], o.material.needsUpdate = !0);
  }), zVt(e, r), t.scene = r, t;
}
const nei = Z1, OVt = dl((e, t) => ie(d1) ? /* @__PURE__ */ S(qVt, { ...e, children: /* @__PURE__ */ S(nU, { ref: t, ...e }) }) : /* @__PURE__ */ S(nU, { ref: t, ...e })), kw = gr({
  app: {
    k3d: {
      sceneComponents: {
        K3Model: {
          root: !0
        }
      }
    }
  }
})(OVt), QVt = (e) => {
  const t = new ye(), i = new ye(), n = new G4(), r = new ye();
  return e.decompose(t, n, r), i.setFromEuler(new VD().setFromQuaternion(n)), {
    newPosition: t,
    newRotation: i
  };
}, jVt = (e, t) => {
  const i = new ks().makeRotationFromEuler(new VD().setFromVector3(t, "XYZ"));
  return e.clone().applyMatrix4(i).sub(e);
}, qVt = (e) => {
  var g, o;
  const {
    meshProps: t,
    modelAction: i
  } = e, n = Ei(), r = ot(null);
  return /* @__PURE__ */ S(Hoe, { scale: 0.5, anchor: [0, 0, 0], rotation: t == null ? void 0 : t.rotation, depthTest: !1, ref: r, annotations: !0, autoTransform: !0, onDragEnd: () => {
    var m;
    const l = ((m = i == null ? void 0 : i.ruleItem) == null ? void 0 : m.id) ?? "main", {
      newPosition: a,
      newRotation: I
    } = QVt(r.current.matrix), c = new ye(...(t == null ? void 0 : t.position) || []), d = new ye(...(t == null ? void 0 : t.rotation) || []), C = jVt(c, I), A = c.clone().add(a).add(C).toArray(), b = d.clone().add(I).toArray();
    n(xct({
      ruleItemId: l,
      modelId: e.model.id,
      position: A,
      rotation: b
    }));
  }, children: e.children }, ((o = (g = t == null ? void 0 : t.position) == null ? void 0 : g.toString) == null ? void 0 : o.call(g)) || 0);
}, nU = dl((e, t) => {
  var i, n, r, g;
  return /* @__PURE__ */ S("group", { userData: {
    anchoringSelection: (i = e.modelAction) == null ? void 0 : i.anchoringSelection,
    modelActionUniqueId: (n = e.modelAction) == null ? void 0 : n.unique
  }, children: e.component ? /* @__PURE__ */ S(e.component, { ref: t, modelAction: e.modelAction, name: (r = e.modelAction) == null ? void 0 : r.unique, ...e.meshProps, id: ((g = e.model) == null ? void 0 : g.id) ?? -1 }) : /* @__PURE__ */ S(_Vt, { ref: t, ...e }) });
}), _Vt = dl((e, t) => {
  const i = Z1(e);
  return /* @__PURE__ */ S("mesh", { ref: t, children: /* @__PURE__ */ S("primitive", { object: i.scene }) });
}), $Vt = (e, t) => {
  var o;
  const i = (o = m1()) == null ? void 0 : o.filter((l) => l.key === e), n = TWt();
  if (!i)
    return null;
  const r = i.map((l) => l.id);
  let g = n == null ? void 0 : n.models.filter((l) => r.includes(l.modelId));
  return g = t && (g == null ? void 0 : g.filter((l) => {
    var a;
    return (a = l.selections) == null ? void 0 : a.find((I) => I.id === t.id);
  })) || g, !g || g.length == 0 ? null : g.map((l) => {
    let a;
    return l.model.dynamicModelKey && (a = Pee(l.model, l)), {
      model: {
        ...l.model,
        key: ""
      },
      modelAction: l,
      component: a
    };
  });
}, ewt = ({
  onDone: e
}) => (lt(() => () => {
  e();
}, []), null), twt = Bm(({
  modelKey: e,
  height: t,
  width: i,
  depth: n,
  onLoadingDone: r,
  parentAnchoringSelection: g
}) => {
  const o = $Vt(e, g), l = Gt(() => {
    r == null || r();
  }, [r]);
  return o ? /* @__PURE__ */ S("group", { userData: {
    //modelId: model.id,
  }, children: /* @__PURE__ */ S(fm, { fallback: /* @__PURE__ */ S(ewt, { onDone: l }), children: o.map(({
    model: a,
    modelAction: I,
    component: c
  }, d) => {
    var C, A, b;
    return c ? /* @__PURE__ */ S(kw, { model: a, modelAction: I, meshProps: {
      ...I == null ? void 0 : I.props,
      width: i ?? ((C = I == null ? void 0 : I.props) == null ? void 0 : C.width),
      height: t ?? ((A = I == null ? void 0 : I.props) == null ? void 0 : A.height),
      depth: n ?? ((b = I == null ? void 0 : I.props) == null ? void 0 : b.depth),
      position: I == null ? void 0 : I.props.position
    }, component: c, fileURL: a.path }, d) : /* @__PURE__ */ S("group", { name: "modelScale", scale: [i ?? 1, t ?? 1, n ?? 1], children: /* @__PURE__ */ S(kw, { model: a, modelAction: I, meshProps: I == null ? void 0 : I.props, component: c, fileURL: a.path, position: I == null ? void 0 : I.props.position }) }, d);
  }) }) }) : null;
}), x5 = dl(({
  modelKeys: e,
  height: t,
  width: i,
  depth: n,
  loadWithoutAction: r,
  parentAnchoringSelection: g,
  onLoadingDone: o,
  visible: l = !0
}, a) => /* @__PURE__ */ S("group", { ref: a, name: "modelByKeys", visible: l, children: (e ?? []).map((I) => /* @__PURE__ */ S(twt, { modelKey: I, height: t, width: i, depth: n, loadWithoutAction: r, parentAnchoringSelection: g, onLoadingDone: o }, I)) })), iwt = (e) => {
  const {
    t
  } = Gi();
  return /* @__PURE__ */ Ie(pi, { gap: 3, children: [
    /* @__PURE__ */ S(Km, { modelActionRuleItemValue: e.modelActionRuleItemValue, model: e.model, onChange: e.onChange, ruleItem: e.ruleItem, ruleColumnId: e.ruleColumnId }),
    /* @__PURE__ */ Ie(of, { "data-cy": "operation", label: t("Operation"), value: e.dynamicModelProps.operation, onChange: e.onChange("operation"), children: [
      /* @__PURE__ */ S(yo, { value: "sub", children: "sub" }),
      /* @__PURE__ */ S(yo, { value: "intersect", children: "intersect" }),
      /* @__PURE__ */ S(yo, { value: "add", children: "add" })
    ] }),
    /* @__PURE__ */ S(Rw, { label: "Basis", multiple: !0, modelKey: e.dynamicModelProps.basis, onChangeMultiple: e.onChange("basis") }),
    /* @__PURE__ */ S(Rw, { label: "Modelle", multiple: !0, modelKey: e.dynamicModelProps.models, onChangeMultiple: e.onChange("models") })
  ] });
}, nwt = {
  add: JVt,
  sub: EVt,
  intersect: NVt
}, rwt = (e) => {
  var m, p;
  const t = e.id, i = ie(e1(t)), n = Ei();
  lt(() => {
    n(Kx(e.basis)), n(Kx(e.models));
  }, []);
  const r = ot(), g = ot(), o = Oe(() => {
    var B;
    return ((B = i.materials) == null ? void 0 : B.map((f) => new o2({
      name: f,
      color: "grey"
    }))) ?? [];
  }, [i.materials]), l = oE(t, o, [], e.modelAction), a = (B, f) => {
    if (!B)
      return null;
    const Z = [];
    B.traverse((W) => {
      if (W instanceof ir.Mesh) {
        const V = W;
        {
          const w = V.geometry.clone();
          w.applyMatrix4(V.matrixWorld), Z.push(w);
        }
      }
    });
    const y = Z.filter((W) => {
      var V;
      return !!((V = W.attributes) != null && V.position);
    });
    return y.length == 0 ? null : y.length == 1 ? y[0] : LVt(y);
  }, [, I] = wt(0), c = Gt(() => I((B) => (B + 1) % 1e3), []), d = a(r.current), C = a(g.current), A = nwt[e.operation], b = (m = e.modelAction) == null ? void 0 : m.anchoringSelection;
  return /* @__PURE__ */ Ie("group", { userData: {
    modelId: t
  }, children: [
    /* @__PURE__ */ S(x5, { ref: r, modelKeys: e.basis, visible: !1, parentAnchoringSelection: b, onLoadingDone: c }),
    /* @__PURE__ */ S(x5, { ref: g, modelKeys: e.models, visible: !1, parentAnchoringSelection: b, onLoadingDone: c }),
    /* @__PURE__ */ S("group", { position: e.position, rotation: e.rotation, scale: e.scale, children: /* @__PURE__ */ S("mesh", { material: (p = Object.values(l)) == null ? void 0 : p[0], children: /* @__PURE__ */ Ie(DVt, { children: [
      d && r.current && /* @__PURE__ */ S(f1, { geometry: d }),
      g.current && C && /* @__PURE__ */ S(A, { geometry: C })
    ] }) }) })
  ] });
}, gwt = {
  type: "csg",
  label: "CSG",
  disabledForAR: !1,
  component: rwt,
  propsDialog: iwt,
  defaultProps: {
    operation: "sub",
    basis: [],
    models: []
  },
  materials: ["surface"],
  repositionApplicator: Sc,
  screenshot: OWt,
  tag: "beta"
}, owt = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA6QAAAKOCAYAAACx/9Q5AAAAAXNSR0IArs4c6QAAAGJlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAABJKGAAcAAAASAAAAUKABAAMAAAABAAEAAKACAAQAAAABAAADpKADAAQAAAABAAACjgAAAABBU0NJSQAAAFNjcmVlbnNob3RLpSb7AAAB1mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj42NTQ8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+OTMyPC9leGlmOlBpeGVsWERpbWVuc2lvbj4KICAgICAgICAgPGV4aWY6VXNlckNvbW1lbnQ+U2NyZWVuc2hvdDwvZXhpZjpVc2VyQ29tbWVudD4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+CnlxTVAAAEAASURBVHgB7L33k+Vceph3Okye+cIul9xlkCWTK9mybBVLLper/KfbVfQvtlQSRYpmWnL3yzPTPTM9nXP37fZ5TwAO4gVwkfFgehrAOW98Di6AtxHu1vcfjx8VEwQgAAEIQAACEIAABCAAAQhAoGcC2z37wx0EIAABCEAAAhCAAAQgAAEIQMAQoCBlQ4AABCAAAQhAAAIQgAAEIACBQQjsbqXccv9uCgirEIAABCAAAQhAAAIQgAAEINAJgd201XSBmu7ve50CuW/i+IMABCAAAQhAAAIQgAAEILCeQBu1Y6YgXe+2X4k2kuw34vF5o6gf35gQEQQgAAEIQAACEIDAsASoM4bl772PviD1gTJvTmDqHzYK6uZjjyYEIAABCEAAAhDogsDUzy+7YILNZgQoSJtxQ6tHAkvZ4VF497hR4QoCEIAABCDQIYGlnLt0iBDTCyJAQbqgwSbVcRPg4FV9fCjeq7NCEgIQgEBbBDhOtUUSOxCAQEiAgjSkwTIEIDAJApwUTWKYCBICEIAABCAAAQisJaC/h5RTu7WUEIAABCAAAQhAAAIQgAAEIACB1gm4K6RjLUq5Ma/1EccgBCAAAQhAAAIQgAAEIACB1ghsVkuO/JbdzZJrjXGpIYrmUjx0QgACEIAABCAAAQhAAAINCEyhFmqQVkplt/U7dhdXny1jQ0ltNyNaXdwGNyL2hAIBCEAAAhCAwLwJcJ477/EdR3btXyEd+3ZL/TKOLa+1KMa+wbWWaIEhNugCMDRDAAIQgAAEWiKw9HONljBiZhwERrg5t1+QjgN1cRQjHITiYHUP9UYpHjqntkFPYcT40E1hlIgRAhDII8AxIY8KbRDojAAfuVbQ7lblyClaK7zrG6k6QPUt96vBBtQvb7xtQGAuH7oNEKAKAQhAAAIQ6JIAh9ou6U7OduUrpGw37YztYusyNqB2NqA5WVnsh2FOg0guEIAABCoS4DygIijE5kyAj0H+6FYuSPPVaa1LYC4bIrVE3ZFHPkNgLh+GTGI0dEqAnU+neNca53O7FhECEIBANwTY/XTDdQxWKUjHMAoTjGEpOwXOfSe4cRLyvAksZecz71EkOwhAoEUC7BZbhImpQQhQkA6CHadTIcBOvnykKNjL+dALAQhAAAKbE+BYvDlDLEBgzAQoSMc8OsQGgZET4CRh5ANEeBCAAAQgAAEIQGDkBLZHHh/hQQACEIAABCAAAQhAAAIQgMBMCVCQznRgSQsCEIAABCAAAQhAAAIQgMDYCVCQjn2EiA8CEIAABCAAAQhAAAIQgMBMCVCQznRgSQsCEIAABCAAAQhAAAIQgMDYCVCQjn2EiA8CEIAABCAAAQhAAAIQgMBMCVCQznRgSQsCEIAABCAAAQhAAAIQgMDYCVCQjn2EiA8CEIAABCAAAQhAAAIQgMBMCezyPYL1R/axvgoaEIAABCAAAQhAAAIQgAAEGhOYa92225jIghXntjFQYC94YyZ1CEAAAhCAAAQgMEMCcztfn+EQRSlRkEYolruw1A8shfhyt3kyhwAEIAABCCyJwFLP9ZY0xlPOlYJ0yqNH7BsRYOfcDB+FfDNuaEEAAhCAwGYEOG5vxg9tCIyVwK5Kf7o52xzrWBEXBEZBIL3LGEVQBAEBCEAAAhCAAAQgMEkC2SukUz7bpJie5EZI0BCAAAQgAAEIQAACEIDASAj0XA9mC9KRcGgURs/wGsVYVYniuiop5CAAAQhAAAIQgAAEIDAsgTnVIT2TnFdB2jO8Tt0tbaOmAO90c8I4BCAAAQhAAAIQ6JXA0s5le4U7L2cUpPMaz+lmw05rumNH5JYAf1RhS4AABNokwHGxTZrYggAERkyAgnTEg0NoEIDAhAhw8jihwSJUCEAAAhCAAATGQmB7LIEQBwQgAAEIQAACEIAABCAAAQgsiwAF6bLGm2whAAEIQAACEIAABCAAAQiMhsAud5mtHwseDVvPCAkIQAACEIAABCAAAQhAoD8Cc6njeIa0wjYzl8GukKqi+K5CCRkIQAACEIAABCAAgTESWNJ5+xj5N4mJgrQJtRnr8CHODi5FepYJLRCAAAQgAAEIDEuAc7Zh+eO9PQIUpO2xxNJMCbDDH2Zg+UPAMNzxCgEIQKAJAY6VTaihAwEICAEKUrYDCEBglAQ4uRnlsBAUBCAAAQhAAAIQaJUAb9ltFSfGIAABCEAAAhCAAAQgAAEIQKAqAQrSqqSQgwAEIAABCEAAAhCAAAQgAIFWCVCQtooTYxCAAAQgAAEIQAACEIAABCBQlQAFaVVSyEEAAhCAAAQgAAEIQAACEIBAqwQoSFvFiTEIQAACEIAABCAAAQhAAAIQqEqAgrQqKeQgAAEIQAACEIAABCAAAQhAoFUCFKSt4sQYBCAAAQhAAAIQgAAEIAABCFQlsMt3/VVFVS73WN5NLwQgAAEIQAACEIAABCAAgbUEllaf7aoxZzyhKm/MGNdu9R0ITGjoOsgekxCAAAQgAAEIQAACVQlwHl2V1AjlWhi83RGmFYfUQoKxsQktzaCaW+rQdb2VzWDT6BoR9iEAAQhAAAKdEeD8pjO00zfMxtF4DMddkDZOa+KKbNDrB3ChlRmbxvpNA4ksgYV+XLIgaIFAQID9aQCDRQisI8AHZh0h+jcgQEG6ATxUByTAjnFA+LieGgE+LlMbMeKFAAQgAAEILIcAb9ldzliTKQQgAAEIQAACEIAABCAAgVERoCAd1XAQDAQgAAEIQAACEIAABCAAgeUQoCBdzliTKQQgAAEIQAACEIAABCAAgVERoCAd1XAQDAQgAAEIQAACEIAABCAAgeUQoCBdzliTKQQgAAEIQAACEIAABCAAgVERoCAd1XAQDAQgAAEIQAACEIAABCAAgeUQ0F/70sYXAvAtd8vZZMgUAhCAAAQgAAEIQAACEIBAOwR22yhH2ylq20lorlbmXfLPO7u5bpPkBQEIQAACEIAABIoJtFNlFNsftmfe2fXLVl8hZZoCgXlv9MNkRxlcZ8uHVh1ayEIAAhCAQNcEhjl36DqrLuxDqguq2GyTAAVpmzSxNSkC7KDrDNf0aVFS1xlvZCEAgTkTmP4efc6jQ24QWB4BCtLljTkZQ2CRBDgBW+SwkzQEIAABCEAAAiMnwFt2Rz5AhAcBCEAAAhCAAAQgAAEIQGCuBChI5zqy5AUBCEAAAhCAAAQgAAEIQGDkBChIRz5AhAcBCEAAAhCAAAQgAAEIQGCuBChI5zqy5AUBCEAAAhCAAAQgAAEIQGDkBChIRz5AhAcBCEAAAhCAAAQgAAEIQGCuBChI5zqy5AUBCEAAAhCAAAQgAAEIQGDkBHbVnL8LgS8eHPnmR3gQgAAEIAABCEAAAhCAwKAEBq4H5/09pAPDHXTD6so5RX5XZLELAQhAAAIQgAAEILCOAOf36whNrn+XMZ3cmA0b8JoNhnp12OHBOwQgAAEIQAACEJgygTWnmlNOjdgLCMz7CmlB0jR3R4CdSHdsx2KZPzqMZSSIAwIQgMCyCHCOsazxJtvlEKAgXc5YkykEWiHACUErGDECAQhAAAIQgAAEIKAJ8JZdNgMIQAACEIAABCAAAQhAAAIQGIQABekg2HEKAQhAAAIQgAAEIAABCEAAAhSkbAMQgAAEIAABCEAAAhCAAAQgMAgBCtJBsOMUAhCAAAQgAAEIQAACEIAABChI2QYgAAEIQAACEIAABCAAAQhAYBACFKSDYMcpBCAAAQhAAAIQgAAEIAABCFCQsg1AAAIQgAAEIAABCEAAAhCAwCAEKEgHwY5TCEAAAhCAAAQgAAEIQAACEKAgZRuAAAQgAAEIQAACEIAABCAAgUEI7G4N4hanEJgngcd5pkVWEIAABCAAAQj0RIBz855A42Y0BHZHEwmBQGAGBDiIzGAQSQECEIAABCAAAQhAoDcCFKS9ocYRBCAAgfkQeHx8VHe3d+rh4cEktb29pW6vr9Xukydqe2dbbW1tqSdPn80nYTKBAAQgAAEIQKATAhSknWDFKAQgAIF5E7g4O1d7P71T11fXJtEnT3bV8acP6uWbN+rp8+dqe3tbffGzn5u+p0+fKF2hmuXd3V11cXKkXn3xZQTo9ZdfGvmogQUIQAACEIAABBZDYGv/8JTH3hYz3CQKAQhAYHMCv/3//kZt7T5XF+fn5irpOos7ugj1t7Nv7+yom8sL9fzli0jt2YuXaksXsLu7O+rp06emXdYfV/fqYXWnZV+aNpm/+errSI8FCEAAAhCAAASmT4ArpNMfQzKAAAQg0BuB3/3t36qb25Xaebit7HN1fx/L6uWtnV11c3MXtd3cnETLcqtvPD0qfWewvrp6aJpM15Z9OfybL95EYq/evFbvfvsb9at/+S+jtj/50z+LllmAAAQgAAEIQGC8BLhCOt6xITIIQAACoyEgz4yeHH5WH99/UKuVfW709va20hXSTZLY9Baep8+e6eda7d9e5XbhS3O78Bu1o6/UyvTlz3+uXrx6ba7gyrOvfpJbju/vbvVVW327sZ7MM7HaFhMEIAABCEAAAu0S4AppuzyxBgEIQGCWBOQq56e9uBidSpK3NzdK/sfTtjo5uYhWDw9PzbIUnFK8+kmeib08O1Gv9DOxMkXPxOoK+Yl+JlbkpYCVIvfs6DPPxHpwzCEAAQhAAAI1CcQP9tRURHwGBDa99DADBKQAAQhUI3Dw4aO6v7dXRqtpbC7V5y5KrgDf6LcE++nGLO6os7NL36ROjs/Nsn8mVp5z3dFF6ZV+lvb5y8+RnDzruqVvLd6RZ2Kf2WdiX7x6aeQeeSY24sQCBCAAgd4IhE+D9OYUR1UJcIW0Kqk5yvHhnOOoLiunPiuWZZFNZPv+x7f6dt2jRFvXK2Me2vCZWHkSts4zsUoSK3gmVorXP/ijX6kXwQufuuaMfQhUIsD5QiVMCEEAAs0IUJA244YWBCAwBgKcJHU6CvIdoyeHx+rsOH7pUKcOnfFRFqMNg5Irr5nJtdnZynSfHB2r1/pFTVv6+1yjVxJnFGmAAAQgAAEIzI8ABen8xpSMIAABCGxMQK4C7v3wo7q6ulVSmPY15ZRvfbnGDwQgAAEIQAACAxDY5QLDANRxCQEIVCJAcVIJUydCv/nrv1IPjzv6DbX2GchOnEzFKBviVEaKOAcgwHnkANBxCYGZEeAK6cwGlHQgMCcCnOgMM5p733+vn4t8rnYT3wnafSyjrPt6Dkq2ebb77rc1PEAAAhCAwHgIUJCOZyyIBAIQgMCgBB5WK/3VLnvqWL9NVr7WpM+p57qvWmqjDKpa6EhBAAIQgAAEpkIg/hbwqURMnBCAAAQg0AmBy4sLdXJ0qnJfxNOJxxEbpRgd8eAQGgQgAAEIzIkABemcRpNcIAABCDQksNJXR48+H6nVqr8XGPlQR1f7jS4gT4o5BCAAAQhAYH4EuGV3fmNKRhCAAARqE/jp2x/U5flFbb1NFUZX+40uoE0Jow8BCEAAAhAYNwEK0nGPD9FBAAIQ6JSAXBk9+PCJYlQoU4x2uq1hHAIQgAAEIJBHgII0jwptEIAABBZA4PLsTH3+eKDOzy8XkO2aFClG1wCiGwIQgAAEINANAQrSbrhiFQIQgMCoCdzd3Khv//Efldp+qrZ3dnqPdVT136iC6X0ocAgBCEAAAhAYlAAF6aD4cQ4BCEBgGAJ7P/ygtnaf9/71LpIt9d8wY45XCEAAAhCAwBgJUJCOcVSICQIQgEBHBO7v7pQUo+cXNxSjHTHGLAQgAAEIQAAC1QnwtS/VWSEJAQhAYPIETg4P9TOj15PPo7UEuFzbGkoMQQACEIAABJoQ2N1qooUOBCAAgRESoLYoH5Sryyt1enKuHh+HITWM1xImowuoJFa6INATAc4LewKNGwhAICLALbsRChYgAIGpE+BEqngE7+/v1d6Pb9X11TBXR0dX+40uIKVk+/X/i0eSHghAAAIQgMC8CHDL7rzGk2wgAAEIZAhIMbr/do9i1JMZYTHqQ2MOAQhAAAIQWBoBrpAubcTJFwIQWBSBo08f1enphTo/PR8k79HVfqMLaJBhwSkEIAABCEBgNAQoSEczFAQCAQhAoF0CxwcH6qdvv1fbT4b5epd2s8EaBCAAAQhAAAJzJEBBOsdRJScIQGDxBOTrXQ4/Hqidp881i2Gerh3dxcjRBbT4zRQAEIAABCAAAcUzpGwEEIAABGZI4MfffaOubu50ZhSjZngpRme4lZMSBCAAAQjMgQAF6RxGkRwgAAEIBATOTk7V1bUUo0yGAMUoGwIEIAABCEBgtAS4ZXe0Q0NgEIAABOoTOD0+Ufvv9uortqgxqvpvVMG0CBlTEIAABCAAgZkQ4ArpTAaSNCAAAQjId4wefPik7m6HuzpK/cd2CAEIQAACEIBAHQK7Az1eVCdGZIcmwBnm0COAfwisJXB6dKQOD47U1eXVWtm2BLa3kn/THN2uYnQBtUUeOxCAAAQgQA0zn22AW3bnM5bdZTLMO1G6ywfLEJgZgb0fflDvfvhJvXj95WCZja72G11AFYdG9rfscyvCQgwCEIAABOZAgIJ0DqNIDhCAwGIJvPv2W/Xpw8Ggxejo4E+1GB0dSAKCAAQgAAEIdE9glz/Edg8ZDxCAAAS6IHBxeqouzq/Uk2cvujBf2eao6r9RBVMZIYJrCHCusgYQ3RCAAAQmTIArpBMePEKHAASWS+D+7k7tvX2v7u4fBoVA/dcufu7YbZcn1iAAAQhAYPwEkm+kGH+8RAgBCEAAAprAqf6u0fv7YcvBYb3nbAajCygnRpogAAEIQAACEEgQ4AppAgcrEIAABMZP4JP+apeD/U9qtVqNP9i+IqQY7Ys0fiAAAQhAAAKtEuAKaas4MQYBCECgWwJnJ2fmu0YpRgPOFKMBDBYhAAEIQAAC0yLAFdJpjRfRQgACCyXw8PCgjj8fqoOPh2p1z5XRaDOgGI1QsAABCEAAAhCYIgEK0imOGjFDAAKLI/Djb3+nDg+O1NMXLxeXOwlDAAIQgAAEIDBfAtyyO9+xJTMIQGAmBD7v76ujwxOK0fR4cnU0TYR1CEAAAhCAwOQIUJBObsgIGAIQWBKBzx8+qA/7B/q7Rp8vKe31uVKMrmeEBAQgAAEIQGACBChIJzBIhAgBCCyTwPnpqX5m9LN6eKD6SmwB4EjgYAUCEIAABCAwZQIUpFMePWKHAARmS0BeYnR+dqlWFKOzHWMSgwAEIAABCEBAKV5qxFYAAQhAYIQE9t/t67fqHumrow8jjG7AkLg6OiB8XEMAAhCAAATaJ0BB2j5TLEIAAhDYiMDnT5/Vof7PBAEIQAACEIAABOZOgIJ07iNMfhCAwGQI3N3eqiN9VfTgw8FkYu41UK6O9oobZxCAAAQgAIE+CFCQ9kEZHxCAAATWEFjd36vvfvNP6vLqVu0+ebpGeoHdFKMLHHRShgAEIACBJRDY3VpCluQIAQhAYOQEPr57p64oRvNHaWHFKMfl/M2AVghAAAIQmCcBrpDOc1zJCgIQmBCB999/rz4fnqkdroxmR21hxWgWAC0QgAAEIACBeRPga1/mPb5kBwEIjJzAwf4HdXR0PvIoBwqPYnQg8LiFAAQgAAEI9EeAgrQ/1niCAAQgkCBwq19idHl1o6i7EljsClByoNAEAQhAAAIQmB8Bbtmd35iSEQQgMAECq9VK7b3dU2cnZ+rxkeorMWTgSOBgBQIQgAAEIDBnAhSkcx5dcoMABEZL4OP+J3V6fDra+AYLjGJ0MPQ4hgAEIAABCAxBgIJ0COr4hAAEFkvg+vJSHX4+Vp8/fV4sg8LEKUYL0dABAQhAAAIQmCsBCtK5jix5QQACoyNwcXamvtXfNfq49URtbfMI/+gGiIAgAAEIQAACEOidAGdEvSPHIQQgsEQC8szox/f76kHtUozmbQBcHc2jQhsEIAABCEBg9gS4Qjr7ISZBCEBgDAR++uYbdX5xo7Z3dsYQDjFAAAIQgAAEIACBURDgCukohoEgIACBORO4vblVZ+c3c05xs9y4OroZP7QhAAEIQAACEybAFdIJDx6hQwAC4ydweXGp3v/0fvyBDhUhxehQ5PELAQhAAAIQGAUBrpCOYhgIAgIQmCMBuTL6ce+jurq8mmN65AQBCEAAAhCAAAQ2JkBBujFCDEAAAhDIEpCXGO2/21dnp2fZTlosAa6OsiVAAAIQgAAEFk+AW3YXvwkAAAIQaJvA+emp+tv//Jfq9c9+0bbp+dijGJ3PWJIJBCAAAQhAYAMCXCHdAB6qEIAABNIEri4u1G//7h8oRtNgwnWK0ZAGyxCAAAQgAIFFE6AgXfTwkzwEINAmgevLS7X39r3aff6qTbPzskUxOq/xJBsIQAACEIDAhgS4ZXdDgKhDAAIQEAL3d3fq7fc/qqvrO4BAAAIQgAAEIAABCFQkwBXSiqAQgwAEIFBG4Ea/Uff+oUyCPsXVUTYCCEAAAhCAAARSBLhCmgLCKgQgAIG6BE5PTs13jd7dcnW0kB3FaCEaOiAAAQhAAAJLJsAV0iWPPrlDAAIbE7i8kOdG9xTFaAlKitESOHRBAAIQgAAElk2AgnTZ40/2EIDABgSur67NldFbfbsuUwEBitECMDRDAAIQgAAEICAEuGWX7QACEIBAAwKfP3xQ3/7mt+r5my8baC9EhWJ0IQNNmhCAAAQgAIHmBLhC2pwdmhCAwEIJnB0fq2//6XcUo2XjTzFaRoc+CEAAAhCAAAQcAa6QsilAAAIQqEHg9OhI7b3bV89ff1FDa2GiFKMLG3DShQAEIAABCDQnQEHanB2aEIDAwghcnJ6aFxjd3q0WljnpQgACEIAABCAAgW4IcMtuN1yxCgEIzIzA4+Ojurm9Vyuu/pWPLHzK+dALAQhAAAIQgECCAFdIEzhYgQAEIJBP4PDgUH3c+6hW91wdzSdEKwQgAAEIQAACEKhPgIK0PjM0IACBhRE4PT5VH95/UKsVxWjp0HN1tBQPnRCAAAQgAAEIZAlwy26WCS0QgAAEIgKnJ2fq7Y/vKEYjIgULFKMFYGiGAAQgAAEIQKCMAFdIy+jQBwEILJbAw8ODevvNt+rg06F68vzFYjmUJb69vaW2trbU4wPVaBkn+iAAAQhAAAIQKCbAFdJiNvRAAAILJnD48ZP69PEzxWjZNiB1KLVoGSH6IAABCEAAAhBYQ4ArpGsA0Q0BCCyPwMH+vvr44bN6+uLl8pInYwhAAAIQgAAEINAjAQrSHmHjCgIQGD+Bzx8+qA/7B+qB21DHP1hECAEIQAACEIDA5Alwy+7kh5AEIACBtgjIW3Rv7lZKf+UoEwQgAAEIQAACEIBADwQoSHuAjAsIQGD8BOQlRh/3P6qjz0e6IKUiHf+IESEEIAABCEAAAnMgwC27cxhFcoAABDYmcHhwpA71G3WlMGWCAAQgAAEIQAACEOiHAAVpP5zxAgEIjJjAwafPau/dnn5jLFdGRzxMhAYBCEAAAhCAwAwJUJDOcFBJCQIQqEbg7vZW/fbv/k7drbbV9s5ONSWkIAABCEAAAhCAAARaI8AzpK2hxBAEIDAlAnJr7v5Pb9Xt3SPF6JQGjlghAAEIQAACEJgVAQrSWQ0nyUAAAlUJfHj7Tp2eXaqdJ0+rqiAHAQhAAAIQgAAEINAyAW7ZbRko5iAAgWkQODg4nkagRAkBCEAAAhCAAARmTICCdMaDS2oQgECWwN3dnXr7w9tsBy0QgAAEIAABCEAAAr0T4Jbd3pHjEAIQGIrA/f292n//QV2cXQwVAn4hAAEIQAACEIAABAICFKQBDBYhAIH5EpCXGH36cKBOj0/0t7vw9S7zHWkygwAEIAABCEBgSgS4ZXdKo0WsEIBAYwL/6f/8v9SbX/yqsT6KEIAABCAAAQhAAALtE6AgbZ8pFiEAgRERuNfPjP63//c/UoyOaEwIBQIQgAAEIAABCHgCFKSeBHMIQGB2BG5vbtSHd+/V8y++1rfpzi49EoIABCAAAQhAAAKTJ0BBOvkhJAEIQCCPwGq1Uvtv36vT0wuK0TxAtEEAAhCAAAQgAIEREOClRiMYBEKAAATaJ/D48Kiub+54gVH7aLEIAQhAAAIQgAAEWiPAFdLWUGIIAhAYC4EbfavuD9/+oG6ub8YSEnFAAAIQgAAEIAABCOQQ4AppDhSaIACB6RKQYvSn739SN1cUo9MdRSKHAAQgAAEIQGApBChIlzLS5AmBBRC4vblV++8+qOvL6wVkS4oQgAAEIAABCEBg+gS4ZXf6Y0gGEICAJnB9daX+5j/9Z/Xyy5/BAwIQgAAEIAABCEBgIgS4QjqRgSJMCECgmMDt9bX66//nP1KMFiOiBwIQgAAEIAABCIySAFdIRzksBDUVAny15fAjdXVxofZ+fKde/+wXwwdDBBBogQD7lRYgYgICMyGwNZM8SAMCZQQoSMvolPRxwlAChy4I9ETg+vJS7f30Xl3yAqOeiOMGAhCAAAT6JMD5Zp+0x+tr7n+Y2GVDH+/GR2QQgEA5gfv7lbq9uy8XohcCEIAABCAAAQhMmMDc6zWeIZ3wxknoEFgygYvzC/VO36p7T0G65M1gVrlvbW0p+c8EAQhAAAIQWBIBCtIljTa5QmAmBK4ur9Rb/V2jd7d3M8mINCCg1M7ujtrZ2QEFBCAAAQhAYFEEeIZ0UcNNshCYPoHLC/vcKMXo9MeSDCAAAQhAAAIQgAAFKdsABCAwGQIf3r5V7354q56+eDWZmAkUAhCAAAQgAAEIQKCYALfsFrOhBwIQGBGBs+Nj9eM331OMjmhMCAUCEIAABCAAAQhsSoCCdFOC6EMAAp0TkGJUvt7lxZsvO/eFAwhAAAIQgAAEIACB/ghwy25/rPEEAQg0IHB6dKT23+3rr3dZNdBGBQIQgAAEIAABCEBgzAS4Qjrm0SE2CEBA3dzeqzv9faNMEIAABCAAAQhAAALzI8AV0vmNKRlBYBYEHh8f1fHhsTr48Ek9Psz9K6FnMWQkAQEIQAACEIAABGoT4AppbWQoQAACfRA4Pz03xeiKq6N94MYHBCAAAQhAAAIQGIQAV0gHwY5TCECgjMDp8anae/te8V2jZZTogwAEIAABCEAAAtMnQEE6/TEkAwjMisA//83fqOvbR7W9szOrvEgGAhCAAAQgAAEIQCBLgFt2s0xogQAEBiAgz4y+//4HdXFxQzE6AH9cjoEAz0qPYRSIAQIQgAAE+iVAQdovb7xBAAIFBI4ODtSpfm70yfMXBRI0Q2DOBChG5zy65AYBCEAAAsUEuGW3mA09EIBAjwQ+vP+oVquHHj3iCgIQgAAEIAABCEBgaAJcIR16BPAPAQiot9//RDHKdrBgAlwdXfDgkzoEIACBxRPgCuniNwEAQGA4Ag8PD+rj3gd1cnQyXBB4hsCgBChGB8WPcwhAAAIQGJwAV0gHHwICgMAyCTw+PKqjz0fq+PBYyQuNmCAAAQhAAAIQgAAElkeAK6TLG3MyhsAoCPz9X/6l2n3+Wt3f348iHoKAQP8E+ENM/8zxCAEIQAACYyPAFdKxjQjxQGABBP7LX/yFUrvPKEYXMNakCAEIQAACEIAABMoIcIW0jA59EIBAqwRWq5X69H5PvfzqF9ym2yrZYYxtbW0p+c8t1034c3W0CTV0IAABCEBgfgQoSOc3pmQEgVESkBcYHeztq8PPPDM6ygFKBVWlXKoikzLLqiEAOTYECEAAAhCAgCfALbueBHMIQKBTAg/6O0ZPT8/Vg36ZERMEIAABCEAAAhCAAASEAFdI2Q4gAIFeCPz43Q/q5vq2F184qUeAPxHU47WZNLQ344c2BCAAAQjMjQAF6dxGlHwgMDICq/uV+un7H9Xl+eXIIlteOJRCQ485IzD0COAfAhCAAATGR4CCdHxjQkQQmA2B+7t7dfDhk7o4v5hNTlNKhPJnTKPFaIxpNIgFAhCAAATGQ4CCdDxjQSQQmBWB25sb9du/+we1tfNUPfLcaKdjS6nTKd4WjDNCLUDEBAQgAAEIzJQALzWa6cCSFgSGJvBf/uL/Vo9bu/olRg9DhzI7/1LehP9nlyAJQQACEIAABCCwGAJcIV3MUJMoBPohcHd7q97/8KP68vf/sB+HM/bCdbU5DC6jOIdRJAcIQAACEOiOAAVpd2yxDIHFEZDbdD+8e6/Oz68Wl/umCVO2bEoQfQhAAAIQgAAEpkiAgnSKo0bMEBgpgdubW3Vxca0eqa4KRwg0hWjogAAEIAABCEBggQQoSBc46KQMgS4IyBt1997tKZkzxQQoQGMWy1ti9Jc35mQMAQhAAAJ1CVCQ1iWGPAQgkCFwd3envv/dd+rm6ibTt5SGsPTYckmHbUvhQJ6eAKPvSTCHAAQgAAEIlBGgIC2jQx8EILCWwM21fm70/YdFFaPrSo11/WuhIgABCEAAAhCAAAQWQoCCdCEDTZoQ6ILA0adPav/dvnp49NcEu/AyrE2Ky2H5T9M7W800x42oIQABCEBgCAJ8D+kQ1PEJgRkQuL66Uv/8t3+vVvprRh8n/hYjKR+K/s9gqEihVwIUo73ixhkEIAABCEyeAAXp5IeQBCDQP4Hb62v17rsf1Kuvft6/czxCYLQEKEZHOzQEBgEIQAACoyXALbujHRoCg8B4Cbz78a26ur4bb4A6MkqDUQ/PDINji5vhoJISBCAAAQj0QICCtAfIuIDAnAicHB2rqxG9TZcyYE5bF7lAAAIQgAAEILA0Atyyu7QRJ18IbEDg/PRM7b3dUw/y4CgTBCDgCPBnETYFCEAAAhCAQFMCXCFtSg49CCyMwPXVtfq4/0nd3933njmn+70jx2FlAmydlVEhCAEIQAACEMghQEGaA4UmCEAgSeDdd9+pm9sHdXlxmezYYI3T+A3goQoBCEAAAhCAAARmQoCCdCYDSRoQ6IrAT998oz5//Kx2n72o7YKiszYyFCZFgC18UsNFsBCAAAQgMEoCPEM6ymEhKAiMg8CHt2/Vx72PjYrRcWRAFBCAAAQgAAEIQAACYybAFdIxjw6xQWBAAhdnZ+rk+FQ9e/l6bRRcJ1qLCIHZEWCrn92QkhAEIAABCAxCgIJ0EOw4hcD4CXx4v6+fG12NP1AihEDvBChGe0eOQwhAAAIQmC0Bbtmd7dCSGASaE/i4/1FdXd82N4AmBCAAAQhAAAIQgAAEKhDgCmkFSIhAYEkEPn34pD7pr3d5eOC7Rpc07uRalQBXR6uSQg4CEIAABCBQhQAFaRVKyEBgAQQeHx/V2emZOjw4ohhdwHiTIgQgAAEIQAACEBgDAQrSMYwCMUBgBAR+/N3v1M3do7q9uRlBNIQAgTES4OroGEeFmCAAAQhAYNoEKEinPX5ED4FWCPzmr/9aXd2s1O7TZ63YwwgE5keAYnR+Y0pGEIAABCAwBgIUpGMYBWKAwIAEPu/vq5V6ootRdgcDDgOuIQABCEAAAhCAwCIJcAa6yGEnaQgoJc+MHh0cqI8fPqsHvcwEAQgUEeDzUUSGdghAAAIQgMCmBPjal00Jog+BiRJY3d+rz58O1f2Kt+lOdAgJuxcCFKO9YMYJBCAAAQgslgAF6WKHnsSXTuDD3kd1e3u/dAzkDwEIQAACEIAABCAwIAFu2R0QPq4hMBSBH7//UZ0cngzlHr8QmAgBro5OZKAIEwIQgAAEJkyAgnTCg0foEKhL4OHhwXzP6NnxWV1V5CEAAQhAAAIQgAAEINA6AQrS1pFiEALjJHB/d6fefv+Durq+U1KYMkEAAmUEuDpaRoc+CEAAAhCAQFsEKEjbIokdCIycwD/81/+qHrafqp3dJyOPlPAgMDQBitGhRwD/EIAABCCwHAIUpMsZazJdMIF3332ntp6+UjsLZkDqEIAABCAAAQhAAALjI0BBOr4xISIItEZgtVqpT+/31NHxRWs2MQQBCEAAAhCAAAQgAIG2CFCQtkUSOxAYIYGriwt1fHyqHh+5BXGEw0NIoyTAZ2WUw0JQEIAABCDQCYHwHHFrayvjI+zPdLbUQEHaEkjMQGBsBOTq6MGnQ3V/zwuMxjY2xAMBCEAAAhCAAARCAunCb4jiMB1DGF+XyxSkXdLFNgQGJPD9N9+ry/PLASPANQQgAAEIQAACEJgXgb6Ktr78jGF0KEjHMArEAIEWCdzfr9TH/Y8Uoy0yxdRSCHC77lJGmjwhAIFlE1hSsdfbSOvHw5oeRSlIexslHEGgewIXp6fq44dP6uLiqntneIDArAg0PYzOCgLJQAACEOidAMVhFvksmNQoUClIs9sALRCYJIHbmxv1u7//R6V2n6ntHb7gZZKDSNAQgAAEIACBGRCYRUHV8jiMmkmN4rFlLMYcBWkXVLEJgQEIvPv+e7X97OUAnnEJAQhAAAIQgMCcCYy6mOoL/MBFW+U0+4qzRT8UpJVHF0EIjJfAj7/7Rp1f3I43QCKbJYGt7S0l/9XkX+TM7bqz3EBJCgIQaI1A+MbXORSnY8+hl/haLCgLN7SKPihICwnSAYFpELg4v1DnlzfTCJYoIQABCEAAAhAYBYFeip62M61Y4LTtVuz1xattP23by7DVY2L4ZDoqNmh9CtKKrBCDwBgJXF5eqr23e2ql36zLBAEIQAACEIAABEICnRcjobMGy2OLr/V4eimgdUFofxqMgKjkK9sys4nJ+vFQkDbhjA4ERkBgtVqpT/uf1NUlb9QdwXAQwmQJND/kTjZlAocABGZNoPWiqkNa0a3AfRRuXfvQ9v0UL/mWOvP6BV3Sejv6SZumbE03layXx6Af9jGT50RBWoKSLgiMlcDZ8bE6PDxVp8enYw2RuCAAAQhAAAIQ6IjAlIrOBIKui0LnrAs+zWy6ksvWZwkUdVaa+Q48BMWyb/XFoF838xy5RH+wkqtf8WprQlf7pCANwLIIgSkQ+Ly/r77/3bfq6cs3UwiXGCEAAQhAAAIQ2JDAxgXJBv6H9C1hd+G/js06slnM+ZVooiDLKgUtdfRzrOarB/b9YiyYY8ULubmVLZTLKWoLZcUiBWmKL6sQGDmBq4sL9enjgXry4vXIIyU8CEyBQOkhcgoJECMEIDBzApsVQ+3AiW6r1eY6iUcXJF3sjZvF6iLRs41ickVZJRt18nd20yOb66dODGmDsl4UV1F72kZVOU2aK6RpeKxDYKQE7u/u1LsfflR3948qPDiMNFzCggAEIAABCECgAYFmhVQDRwUqvfmvXLAUBrpx0ZhbyOW600VzdeEcC1o5Rz+nyRSCYiC3L2E532ahbilv8eaf7BTneX8kcBGlAkut2ggdrERfADDRrjUoSC02fkNg9AR++vY7dXV9P/o4CRAC0yCQPhxOI2qihAAE5kGgt6KvKq7cAqSqcolcR3Y341eluHTHiOSsJFHdFRRcacHMEaeOrC5NS8STrpxgkb9Me0JbevV/+5PoyWvM2nItyVklOxSkKUysQmCMBE6OT9TN3cMYQyMmCEAAAhCAAARKCGxWPJUY3rRLFy/ZomJTo1KXbWa1nn6NYi03tZr6ecxK8s2SyLaYsHRztsc2Ztu1Rl4cBflVKTBzfQSBZfttbCKS7Ctq98HF/UELV0g9DOYQGCuB46Njtf9uX93d3o01ROKCwMQIJA+fEwuecCEAgQkRqFdctZ9Yr/4rF0k6zzqyuVhsYVNtb16z6Ez4iwuoXF918siVrZpHURxF7ZaxpJIbd9UcS2LO2i7KJY4xq2NbuEKaGBBWIDAuAldX1/q7Rg8oRsc1LEQDAQhAAAIQKCTQaxFYEEUnMeQWJwUBFDRvHleN4rJmvLViy7UdF17ri0ANqMRGVt/azrYLaNvnkefLWH9O2otKY1SxJvXqtgcmnU1rL7ZT5puCNOTHMgRGRODo4MB81+j11dWIoiIUCEydQPKQO/VsiB8CEBgHgVrFTFch5xY47TjbNL96+jWKTl386LQTk7yaJ9Xk+pPFUaiUlbeyue2hol8uMl15TEr85dkOkk7GWGDHySdlJfg8edvmen2Gbh73VemPZWI9vaSn5DoFqYHCLwiMi8C7775T79++V89ffTGuwIgGAhCAAAQgsDAC9YqpjuBULmya+2+cZxux1bFRKGuLHFvwJDnktWUqWadSJFurPek+tqyNZOzofGRKtseCyXYRrCNfYqekGE36jG0k44zbE/IuPpGVKdGX9ulkKUgtK35DYDQETg8P1eeDI4rR0YwIgUAAAhCAwBIJNC7QuoC1tWW/lEOfwCdP8Js7ayO/jW3Uyid7NTSZvb42Gn1ziS2WclmlCiaxkStnOmxPtl+32J9kCM52Uj4WTLZ7VdeanPnOYG7tJG3YNhFKtEdc83S8yVg3aPGL2qDf1mK5hI9IMtUf8I3lUzJGN26jII1gsgCB4Qmcn56q9/oFRls7T4YPhgggMDsC8aFxdqmREAQg0AqBjQusVqKQWqCj/VVUZGwWaK346visI5tbEdq8cukV2raFUa5OBlOJbK79Ivm8dtvmXeq1YOpSPvab51OCsO2xXF6bkdEM/JRYcitFbRSknhpzCAxM4P7uTu3p23Tv7lYDR4J7CEAAAhCAwLII1CqwukKTW9C046yV/GrFp0sP+1MtgVq2Swr2oCAKHceFUNDqZHP7ArFosSjG3PY4+aR9255sEw/tyjuLLvTYdtyeiiOTQ56O09ZdsR27nInfsY3lYntWPV4XGQpSz5E5BAYmcHx0ou7u+a7RgYcB97Ml4I6gs82PxCAAgaoEWinOqjpbJ5cpBNYpVO9vK89admrlY4uSynvnIttB8ZOmk2t7jZ2MTq68jV38ZeTTQbhiM5LL2CuzZfsiXeMwXouXJBC7lmjLk0/419JOIdaL24y6/DJT3B7L6o6033X2nbyYNDcFa2MUpAYwvyAwLIGP+x/Vpw+f1MOKgnTYkcA7BCAAAQjMlUCtwqpjCF3G0ortRFFRAUYteVvYJIoa7yIoVnyTzHNlpb1APtSNlwueQXU2sj5K4pSHVd3zqltSVoXKeiVcNdG7hrz2ZJtEq1tK5J1EnFYd+TC2vLwTifgw4mDsko0vXPbBRG0uyGjdLuhIowWvYlooSCMcLEBgGAKnx6fq4MMBxegw+PG6CALuALiIXEkSAhBIE6hXtKS121vvOo5W7IcFy9rU9b7V/qyVtAIl8qlCyBss3Hs7+egdRl5Bz7M6BX6djay8GIlKp6Rlaypok8W4MWmrqF1UrGSRvLMqMzdZWwn5dIzOpigYufS6sWTtRDKmza0543Zm5cJlL+rEUjkUy0e+MvFYHemnIPV0mUOgZwIPDw/q8OOB+vz5SK1WPDfaM37cQQACEIDAQghs6TfUtlKsbcCrS/9t2K5tI10MrWFTaD8oUkITUdETNspyod8CjbjmSVoqsuPiyVgranfFaFvyJsVEpHECsY/gimxuXPk6xqwzYmahrltO+o/tFLVbc1YuuZzWTa7H9mw7BakZHX5BoH8C3//TP6njo1P15PnL/p3jEQKLIWAPkZNKd2wh512CmBRQgl0ygcJCqEso+uS+y49xaznVjbNt+aAI8sORy63Qr5eWnZTfUek2++NNBvOivmbtYlhrpqZyWyKc1LHy1doD247dels59hO6cX8cg7MazWIZ05QaNysWyoTLknAkYbO3q5aD66MgFfpMEOiZwMHenjo5uaAY7Zk77iAwegLuQD2qOMcY06gALTQYf/4/0vRbK9qa5Oe/M9TpthaLPnlv4+NYO566fqvKa06+eizMyxUs6c3NymdbnXhq1LS0/Um1i3tryf4Oute0i2RSxzpItjkp11jUl2jXfqP1vBhcW9K/1nBKka4IBElH7aH9vP50WyKGtJ94PYonHV+oHy4HfkSXglQoMEGgRwKf9/fVh/3Pavfpsx694goCEIAABCDQIoHoDLdFmxuaql1obegvVz2okdqKZzA7uoCoPcyu6HClZi6iqLHMvrMTyQYLuTEV2SpqdwVR1pZucY2ZPhdTsr2uvCRSpGMtR+yiBZd8Jf+h7XjZefWGCnKM5U0kCX+2z7Qn2NkWzyz2Y+Xt+vplClI3NMwmRMBt+xOKOAr1/PRUffp4qB7chzzqYAECEOiAwIR3Fh3QwCQE5kqgrYKtFT5y7t3yMX4ruh3VRljbvo6n2d7Qe46146UCWuaqp+7Tgubts3lixoi15Ov3jF1vR/QThVHKYFFfUXukrj3bH9MSM7VVYCYeRzDZrtdcQ7K9KOb18hKMtWVlI7uZfGJbsY5VjnWkx062zfUkZ1pAN9ifWDpaj4XNkovDCfpgU6tW2WraZREwW6FtdDlGalwhjVF0sOSgd2AZkxMkIC8xOju9UKsHNowJDh8hQwACEIDASAjExcNIAkqF0eVLlJrkvtlZhy4jahoojLHAULF53WN/UoSL2r1Yqt/WmL7TzbWMX4oXXYsU4rYxN+SUfLQaLujlaDVYyuaTI+WcRj3p9ZSRSM75idKVol7rRv3RQiq2oN0Dt036t+uL1j0zM3edejmxpFci+dSyqCULUyswjyukNmuDhl8QGCuB92/fq5OjEyWFKRMEIAABCEAAAs0ISMHnp8LixwsMMG8zpjZsNSqQw0KmEkNbWJSekgfj5qvcfPkSW5Xi0tuH/dGRFxXUsg3l9bmIbAhB5lZ+K9EubfZKsFRgTjPQCRZdZ1LGKiXbnE6i0fqOHLi+hEgQQNyul6KVeDlq8p1Rl12w/bFUkEVyMSNi9SOhqD9uzxSjTrh5QRo5idyyAAEIFBA4+PRZHemvd2GCAAT6IsBBqi/S+IHAEATaKNTajruLmDYtvmvHVKngC8nZYqPWHrfQR2BF12Cm3HNNUY8uam0ZKDHEnVF/IjRT/oQtbllL259UX0m7SGZ0dINrtwv+tw1+K8rTJaPXE1OevZRIKO/zfnSFfWw/lsqoi2vjJ1pYK2z8PLobrtMGjS0xES3oJScUyIoNs6p/+RGTbTFa1r1b2oe19Khv2Q2UTSu/IACB1gjc3tyoQ12IftYFKRMEIAABCEAAApsRqF1gbeauknYfMTX1ERa0ksxaO2HB5wqoslIhXWOVAtPCxbYKeqLKJm1Zy9ufdIdk6S/ApvrKdfLtFenEzvVSairQ0blIcSiTmRnWWVknYgWtpFOIZtZCwp5dia/gWruRL2ctnsVeEktuJW7zPuMWGRIpM209aQtL0xs7lxHwijaDYEMJtwIv1/wKaZwRSxCAQA6B+7s79d1v/kld3dypnSdPcyRoggAEuiEQHzi7sY9VCECgLwJrC6i+Ainx0+iW2BJ70tVm3rVtlRaOycCjgnedTlCQJC34NVvm2DVbzOTvyV2rFfHKwby8GA0Eg8XYk0QRr1mR9HookdunG5PtyYZkXxCGXPsNirqoxynEerE925azHimnFiIXsiB9sa6RlDbdZGciIwWnNCU69LpulMnN7Ir9nW3Ktnh587SudkBB6okwh0DLBD68e6eubu8pRlvmijkIQAACEJg3gdoFVJ84gsKq+DR784CiQs+Z2oRJwta6wrFu6FXt+dtMpYJx4Ir5uUIoiCXGLoWRnkTELFh7sS1d4jgRuUwatjsFPbM6om77Y5um9Iq7jSNrL260xZnpyonBBhbGJpG6u1ONx7jmjG3qDjdJ/HG78WWMOa+6K7an24yo9eljN/1WTP+O9dyS7o7tR2KRpHEgzXqKlyUEq6/bxJ2/pdd2GA6mX9uOY7J+fNGZMulWrQ8KUoODXxBol8C7775Th8fnamf3SbuGsQYBCKwhEB9A1wjSDQEIjIzAJkVXH6l0Gl+ieNowm01tmVtJJQZbUJTuVSNZH3OJTlxVGmGpZcIp6cf3WnuhXLRcmGdJDC4nsZH0t14nKe8suMZafaagcwWeS9M8sZkyklpNB5xa19JOIdZLN+Ssx8IOqwvOpCfBaQE3cwLRTApNmeJbd2VNim9XukqHK35NUepsRc+OGjkto11QkAo7Jgi0SODu9k6dXdy0aBFTEIAABCAAgfkS6LTQaxGbv9I4+njTRWJh4VYCp7aOrirsT77RVDEaCmm1nMm25quV+SrrEzdSJFl3dublbbu/emq9+7B8n6x7eVkWC0lJafUybsm02F9WN9tue208ou39pXzpAi7Bw1y6tVckJRZ/FdbaEV235Ay72tAhsP2+mJQIon6Xl6hpKfdLFtxkGu2yXYwboiW9EOk7NVOUJhPQPVaDgtRBYgaBNgjc3tyqvXd76v7+vg1z2IAABCAAAQjMnsBkCj03Ej5eWW2tOJUiUp+sRyf0m476JrZq6+qo7U9x1KZ4ct2uKCnONe4J1WIfutSxP9ZgIt5Un1Zy7lKxxQHH3kRE9H2R58ullGq46gL0hax0+YJSlqU99m9tSx7JKY4l2a7XEip6G5GqUaZIRQtkDMYO4iUtlrAVrosNWTeRu3itsLk113TbPlPkOnGxbfM2v62+icvqWpO6z+lLmPLZsTF5xtLPM6TCigkCrRCQ7xf99PFAnZ2etXeAaiUyjEBgKQTsYW4p2ZInBOZGoJNCryNIrRWiYXz6ZH3jojRRnIXGayxLHCJe2ZYUIOZHlPxP1mFcmZk+48NJJffeqR5rMmuvzFckLUVctKIXfHxRwDm5pvq0Thy6GEtGa617nbCokx5XREY5WDlTljkzRkPMuinuc8WbUQniNnLOjyybBH2BZxpshAk92x4X20W2rV2RNuGJDb8gbVGc3p+2Y2RESJadvm40f14J9KVPJm8vXt/ill1Dhl8QaIHA/t4HdXjA17u0gBITEIAABCCwYAKdFHst8uw0Pl8MpuOtWhym9BvHWtVfGOc6nWRlqKsbW6DY36Ehv6x7XKfUQVk5qXbMj1NwErGaN2TnZfHlO7Betb1Ed8Q4duQ8a3mR1L+l6oq6bZCmBEy1iZATNXrhr9imsah/BcWiYemLP9dTZEjcO2NGw4Yo5aN1J8WjCVGCs8veoxHRfT4Wn4PkaQpK3SHmRF+E5E8ZcSEqjXpy+lEMplnytv1ih1t2LSp+Q6Axgcvzc/UPf/VX6tmbrxvbQBECENiUgD9cbmoHfQhAoEsCjQukLoOqaXuIK7lN93BhrFGaZYWZF4qKLtdQqqOjsz9eu9bclS0JHZuv7gk6XflS4MtquBo3Ycuu2P6cjqjJ1XhR8WU74hjiUPwVU+lLJ+785LoTC7aIjLut/bjQcxK2Wa9YSfNbAkyMg7UnccqS/HY1nlvXWlHRZwR0uIE9abKrtlO0dD5R4ejWRSb25ETNzMpbG25Zt8eFpghJDE7fF9HGp8hLl/DgCqnByS8INCVwe3Ojfvr2O/X01ZdNTaAHAQhAAAIQWAyBsECacnHaZ+xt+WpkJ1EAFW2mtrjQv93kCza/XjA3BYrvs4WLrJl6xTcn5lamuF/XOBKEE0jKhTHm2XHRi1i6aItiKNAzpm2fVFnGb2QupZMoyqJQIw+ZBbGjTbiZSdCaDvw5X6LrC1sTgzMWLntAtuj0BawtksWPWXJFtjWblvHrPtPAufgTG6bJF7YibyNI+xRx84yqVuIKqdBggkADAiv94qL9t+/U3YP+2872dgMLqEAAAu0QSBxu2zGJFQhAoHMCUy5O+4zd+2pUUAaj6O2YpkqFppbUBVSi5Kikp3USSrpIcUVeEE5qUSs4HTPLLQqtjBVLF71OWay6AkiKo/zJ24kFEuG54GOLWs78eD1v1ekHfdKjSzB/YdOsSV7JItfasbLyWyYjZPzYdevTWNNdMtlZtXankjVroEiEdorkpCFasX2xjPh0OlrGLEmTV9C8w2IzZcYZ1grSEc9srkaYK6SWOL8h0IDAj998o84vbxtoogIBCEAgS0Afp5kgsEgC64uVcWLpM+62fTXa31QqRvPHKi6GtWfnfF0M5f2+6E1K2cLSlkTJojgsEn2MvnSypVXSkpfRrfbHN8Rzp5DVk9hSelGRGytl9bRpHVJY3IkzG6W3JwI2hGyRa2Wk29p2S6LinPmIKkrBAABAAElEQVQi0oQTFf0iIEqeg12Pyla55Cn9ayZxYcXSS3o9KmhtIPbtvX6Z7yFdg5ZuCOQTuL6+NldG83tphQAE+iNgD2j9+cMTBCDQBoG2C6w2YqprIy6yrGYXOXVhU6L1sdeyr6uYuC6RIsMXPnXISXGTVxymbCR8SV+RPx9RWTC6T0+2CDOL5pdtNT2mkpICzNVosZBkbH/iNi1kdI1B0637rP+szVjNyoRXGqXP6tkll4uZ2auOSXupNpeQE9cmtO3QhDMvM8lBbBnvzuij6LsiVETMupby9nx5ahq0jrRbVb2kxzAhJ01RLj5HG6/pifqNlonT64shbtmVEWCCQA0CF+cX6v3b9+rm+qaGFqIQgAAEigm484NiAXogAIHREqhV1NXMwheOoVqb/sR+M3umwrBFiQ/OVXPr9mfZos8bKJpri/anQMB5tCHFMpGOKX1su1m08nLV0Gk6HX/VVVZdT0ZGd4mfTLttFPOl+WV04wajK67NJO2mlAtC8W1eRoLwxV+kpRfi4GyRKX3J4jBal/G3qm4stQ9JwLoSrWhd5PSansS+WzJysi4/ZkUvmCUjbcXcuqzoH2vH/jbm9C8KUk+COQQqELi5uVUf9z+q66vrCtKIQAACEKhG4H/6d/+j2n2yq3a29dFaf6dxdDYg6uav4NXsIAWBqRBIF1rNiqJxZBvlok/E5TS76ynyJ45a8NmaPbev0nuxeMqJL+HPS2o5P8VLvsUWMrFdLWF/nEDc4zWMgFWzFZDuiO06ed9vlNJXR0OZHH8pXWvCFnfJXXaom7UpelEhp5edhGm1AWubsZptl98mGRuE7bZ+dJeecnS0kdiO5Gp1rbT8DvTTRao40N1uplfiJdH0U9RqAFh7ts31JGaRtFGnIPUUmUNgDYHVaqX23++p87PzNZJ0QwACECgn8Oz5M/Xn/+Hf5wuZM43g5MBLmYO8PojLcVym5FmPbeM3BCZKQIqUKRelBrvOwX88o2HIKciivjYWcnyOhmOd3IP9mTwbqfeA+ZPZP9quNOukTtBrFnP2qZEHq+k1knZESPfYn0jDLERxOs2EjPXni00nodWc9USB6M1aHVnzerKc0I2rSunKTD52q+Pt2WI0brNXgr2sLUZ1r/7xbUY2Yu2LWR2VE0je3hvrGr1MVK5BwnEC2qJd0etikoK0CBrtEAgInB4dqX/86/+mXn79e0ErixCAwLAE3JFx2CDWen/95rXa1m/i3t3dVX/4x79Sr1+/WquTK2BODuQgnuoNTuQSRWrYnlJhFQJjJJB35Ww0xVVTYDkFYxtXNYvC2ZhXm/F6W1Fhk9195ebh9Uyn3edFuz3dl52sjPREchmh8HZc6XSSRjWqkoxW7MHaDaRNf/RLYglyi9rNgu4zP2kbzrrrS6pbHVF3Unop1A/7bbv+7SbpswVjuk1MeHvJQtdfFfZ2U/qGtfUj+rGulROrxpcx7ts8WbGZ1XUaWsj6FH1poyD148gcAgUELs/P1be/+WeK0QI+NENgGALmMDiM6wpe//hf/FEk9ctf/VIXozvReusL4RlNuCwnE/7kzc9bd45BCHRLICxSNy62ug21kvWuc+iEl95/mJojlWHlXKL9T6rgSdnLXbU1TW5X3JgsfuJ2u1R4tCjsCCy4xKP8U/GEvH3xmDQrsYk9U855EecgLJKdVsq+UU4Udj42a9deabRtxoN3Z5rEpnFuC8doTTrFUUJYGnMm0bdXrK2lpIjtdW2JFWnTDS72hJYLK4pOL1CQJgixAoEkgauLC7WnX2C08/xlsoM1CEAAAgGBJ0+fqF//6z+LWr748k20PNiCFKe+QJUTQn9S6OeDBYZjCDQjkDz5l81bTmmnNWXO2TsMv2te3n71cZD9kPmxWevxWzuCen8lzBJTrl5oOCEdl2QJZ7qUc4Yz9iN16bFK0aaWcaP77Y+WtZ2xPefQ9LvWhH5KV/ym+6UtzsAtSZt3ms6jzGeqL+PLxii/naQ4sjF5d/kNVshpleuLU2vMetO+9BhTkBqw/IJAlsD93Z1698OP6urmPttJCwQgoOsb+euuP6T0CSRxqOzTccKXFKF/+uv/Xn311ZeJ9lGuyNmUP6OSMfP/RxksQUGgGoG8/U/14qiaj9alZL+ZMjr6mFPxplcT45BbLKY13HqahdtHVdnDC8MqcrFn2e/Fa6ItdZGfgkXfpOeuVc+K/Vm71nRgRS+6a6JGOeFa7Pp+q5706cxE+tJr5KIOa9sZjW2LUbuWvfgpt+fGCk7KxeEcmJkJLJWvltawkhc7pU0UXJRGzbe5LklShNxMpMNJmo2+XqAgDcmwDIGAwLX+Wpd7/+EN2lmEAASWR+CLL7+Ikv71v/5TJcXoZKe84lSSkSKVCQIQ6J1AWNB1WZyGfnySrfuT/Yj/45d3UnXu9kHJPZGuVuxPbCVPrkYxaw1pL4Eju5h0FBWETi4W13IyJcV1QyyRqt6MeOKXFk0WeL63sCO2LyKmytNNiRhMh2nMs617vZZeksnKS3vjyaPwroOAYn5WKI7J+5Xg7TIFaeMRQHHOBE6OT/StunvqTl8lZYIABJZHQJ75/OUf/jJK/I//JH4mNGqcw4IvTv1JpDvRozidw+AuM4deiq4O0Ubx68+mO9fv0JsuSfxnPvCyaZGasblRLlIuVSDRZpHqitsASf5iVIQF3VJjmdXw+VDfbzvjQs2UhL5Tz12eukhzdVrQJ4teX5aFi52Z4tR22bZMoSl2rXyWZmgzMmjsJO3aZJ1X3S82ZbKlcdwucolgjEwsb5T0L5GxNsUSBannwhwCjsDFxaXaf7dPMcoWAYFREvAHwfaDs2/B/UP1+s0rtb21bebtexmpRX8C5uf6rcBmyjlZHWkGhAWBQgK+QNq00Cp00EWH/uzFJ/lJB13n4XklvabW6hSZBblUzqNAPxmRLYISRwi3/0pwdPu4hFzSkC6orEZCLy2TMhCtaqVYz7XqmV2ynXG/GLWdUb80RTZsqzRZsTx96Uy3y+250u4n8Wgb5LeslU9ayvxk7Ro93ycrViQwV+4hjsQr6vJcq1CQBghZhMDV1ZV6/9N7dXt7CwwIQGAhBP78f/336tmzZwvJtmKaDw9WUE7M/P+KqohBAALdEvAFY+WCrotwZL+QrHpqe/F5eMXN8pErdVIMrZnyis06xbUx74qpKsWtyPvaKxWaVbed+ncwmYpPZxO0Jmz4/kAlWrQMRDNJQwzY4k9E4z5rWOSj1vzLswXdzpKe2SVrKc7ZdphcTJeNwWlpn+Kfr30x+PkFASHwae+9+uF336lnr+NnxSADAQiMiUB8CKsblXwPqHwfqJ/+7b/7H/wi8wIC5mTpMS5Mt+SqqTuZK1ChGQKjJpAugCTYzYqgYdM1+dQuptqLOc1zU5ZpeybSGvk11rc1kXVXB0+muLXFlzeRKCh9oy8FtajUZ/lHNQnI9ickIvOp/qhdnIhVO3NLdt399v7ivlg5ijc2kdES/Vg36M5rNKZ1h/3RwtIQrcTKuo0rpA4Hs2UTOD06Uj988z3F6LI3A7KfGYGdnR319c+/Vs+fP9PfA7qrfvmrP5hZhu2lY/9SL6caBZOcFK5WSumi1Jz0UZgWgKJ5agTyiphNC6teGejPYlgLDBm7xFGyF2mGJZWfMVKjSJU/ooV88vXjIimWTd/2WiV8Z8fuUDN+LRvnITnTxmNyTt05jCMyhV0md+vTSjkbehZbC+POe67V9ot84EmvWSPWjuuRK6zSkzBuWqyRxG/dbn6sHeky2iKuJzsTQ3aJgtRg4deSCZwcHqr99/vq2asRfG/gkgeC3CFQSiBxBCyV/PW/+TPzFtxtfSLy/MVzU4yWKiy0055UVOdqMOlbeeU748xJnpsvFB9pz5iAL1KHLO6a4vWx5+pniplcqeaNecVf2lobMeT4qTZWtjiqttcrLt7SKUmplSjSZN+YM9nX/+iOIIB4MdaJ1V1vOMvJ3boSodhGjvtUk5Y3P7I/z9GUvky7tb8lD33aH2vTBWx7pSnuTBahKT0fL7fspsaG1UUS2NrZVc9evFRPnrlb0xyFi/OLRfIgaQhMkcD//n/8b1MMu/eY45MmfWLQdBIjclIpJ0bcxtuUInoTIJBX3FUrfEaaXF4xI5/lPsPtKAYZq/VjYyusuHByibsdY3MOBcVrhq3zHASw5XxLJFn/SflYzUnqWawT99oCM+7xQkGL9qblzY81kuyTbp2TBBVNVk5WfZFp+/P0rW2RTdqQlvQknrWvT0enmRjSoqxDAAJKPfiXfHgY8hl0z1ed6+L1Qd/OJt9dGk6r+1Xmbb25O0y3Q3p4eFQrbUf+p6e8trQM6xDom8CNfF/v3X0PbvUhUB8gX7x8Ya54PtXfA/pn+vtAmaoRsLuYbg73UVGqx4cJAkskkHtcnzKITCHVczJt+N/YhpzkhQVfAwaNY4gd19trO+lYPSdo21lsd02/zkmmdfqFMgVMKEgNVn5BoD8C5sDlPtDeq19dre71G37vTBGbPsDd6fb09Jgqks0OQhu7vr42fylcrR6UFMXhdH9/ny2uQwGWIVCDQB8F6a/+8A/Ujv5eUPNM6M/sM6E1QlycqN2fFJ8udAJE/pouBalcMWWCwMIJpI/fU8Mxqvj1Dq21vdnGtnQk9meDId3Aht25r+FRQKsk7mrjHRvIeFjL1WnEJpL8tD7PkCaRsAaBzgmYk7bUlQR/XWF756l+9u1p5RiKdiJSdJpb6vSHXK66hpNc6Q31zLLbyaXlpAi+0sWtTFeXV2G3sSHFCBMEuiDwb//n+C24r1/r7wWl0CnFbD/Cyc96qULbnToAvy+Jrpi27QN7EJgIAXOcD2INj7lB82gX0/HnBiqf+dyOlhvlj11t+RJbPrxGNrW2/fFWgrmtttYzKbPhzVlbspaw584doxyMeNpvstdbNF/5Eq3EhsV+8Xg778ZFnHjCg+Yot/cWT8aDLeRjE4G47acgDZCwCIGpESjaiTx58mSQVOS25XCSg/CjK4gP9cuj5NbO9G3NIi/FbuaW6NAQy7Mn8Ey/CffP/8P/Mvs820xQzgNSpyttmm9mSz7zsh+QEz+eL23GEK3ZEUgfq6dWoOYOSFjceQH5/PvlNuc5vjZm2LpNKcrM05Um8804xJWbKfXszr6ArZU1cgnmOgIXhJ2lJKzhoEC3ysm4nY6epbRNrmLfvOROryX7pcO7L7LhZaxxbtlNDB4rEIDAGAjIrch6V5WY/O3J11fX5pbmKz0PJyl8b26SV2xzD1hux37nnntMXzEWmzyvG5ItX25yy+4b/X2gUqzs6ttw//CPf6XkCihTNQJu89XC6U9INf1epShKe8WNs2kSyD1OTTMVG3VXRWkFJl2x3MhuVzzcwaDekcAWgSHKYn3Xk1UJ1RN33CU6zEpsQ1bzfVkHFKRZerRAAAJzISAHArfT9imZHaL+dXVlb0HOe6b27k4/r5vac/qC2NuRudiWZ37l2V9ZvrtNvtxn9aBfUJV6hjfUn8Ny1YL0j//FH0Xp/kp/H6g8E8pUTiDedFMbY7na+Hp1YWq+v7T4XrfxxUxEEOiRQPo41aPrbl3pndgY9l6d8N04N03G/jQbg038xweXhO/1Y+Uk1sW9NrasHW7ZTQwFKxCAwKwIyBUaORkOJr/2quZVuaIDmlxN9Vd0H/RLpMJJdBK3IstOOudAIDLyrO/5+bkuam/VfU4RK1eGpzQ90W/B/fW/id+C+8UXfM9vlfGLN4/1pwZV7A0tY7Z32e71Nr61ta22d/QfIvyHcOjg8A+BkRBIH6fywso7duTJjapNjsElAfWVUx7fjX2X5FbNtiZjf0oISZet/jJHhBL/WYMpG6nzIiuvbzcOnASLgTk3mpm4nbR1o/PKG/fAov6CU7MW2KEgDTCzCAEIZAlU27HGenk7/rh3uktFee3utrcb/epnX1UGlH5eVxR9QXx8fGxuO744v0zYk6vBXb6I6he//3vqT3/9rxI+WalGwBaiwQG7mtpopfx+w88l0MfHlZI/2WxzdXy040Zg4yWQPgaFn63xRj3eyCKe8gezlsP0ttsZI1u16d+5f9CuFnpsI5bXWbvE7czK+H7xF09W1onHzdGSk45MpCSNemAxkvMGdDHM95B6GMz7IFD24fQf4LI40vpVdMrs0ZclkGacleinhbHtkHN0rNAHYn1VV8bcF7hmWV/NkkluXb7UL5ySF1HZq7jxFWD/ciopgv+7f/Un6smTXfMmXBk3+XoWmXgzrsFQ+GsJRWhe8vL8sL1SGpyg5AnSBgEIVCYwlmN35YALBAfPo4MCNUq1Ddv2wOFrycj0xguN7JpK07iOTisygQQ9+YtGg4I0A27+DYN/2B3idMExlrjGsAWk2eTFVMSriq7YK9LP80Wb3IEy7ZNnueXXFJXudmD/1UB+bM26XpHvrn18jAtPu25vNV73sie5WixF6JOnu4aXvO15Z1t/f6i+IiYFq0zSv8RC1R7rg6OxoTHtX+E+JFyukpUUpVv6DxdT/1xVyRUZCPRNoO7nse/46vobQz5dxrCp7U31C8ejVgGtj2/2J8fcmmOf7qYgzcE2t6bONtS5gSIfCPRAoK8TcPncy+251/rlTddXN/ord+7MHyH8/iDxbGtHeUuu8n97W/5vGy+y/lR/164UJM/1V73Im3alcO2LS0ep5pqdcxHqt6PcxCs2UpRWBIUYBFog0MZntoUwujFRq3DqJgRjtcs4WrEdV4xrSsQSSNbGev3YlzdWpkNB6inNaD7rnc6MxolUINAmAV/QXernRm/1i5GOD4/aNN+5LYn/2bNn5krqy1cv1IsXLzr32YUDW4SK5bJDbxeeu7Xpjyt+3pY3GfdteQ5bz5kgAIF+CbT9ee43+jXeWing1vhY191lDK3YjovGzY9YFW3FB8nEUZKCdN3GNPL+We9MRs6e8CAwJAH57MsttPL/Vl8Jlauh5itY9IuL5jBJofLi5Qv1Rr8NWa6gbu+M+1Zfe4zd/JA+prHzxxc/7yo2GestXZTKnAkCEBiGQNef82GyynodPM9WCslsXqalDdub2mioT0FaMKZjaR78gzMWEMQBAQiYZ0Dl1ts7/d2n8v2ntzc3Znnds51TRmeeSdUF6VP9NTIvdYH6TN/m62//HSovfbzV07yKT5ORTcxg7fvYY4pS/bzxlv7DAxMEIDA8gb73AUNl3HueDQu2SnxGYzu+WipxVzlaUpBWGuH+hHr/YPSXGp4gAIGGBC4vLtRKv4zo4lzP9RVRebNtH8+ANgy3MzV5e688cyrPoH7x5Rtz5bQzZynDcy9Cx3Ls2d7RV0opSlNbH6sQGCeBsew32qIzpny6jKUV2+EfMBsPQFy4UpA2htiOYisbRTuhYGVJBHL+imZuluOWudFsBVJ0ynOglxeXpggdTWAjCUSuqMkzp3LV9M0Xrzu53XOuRagMoT/2+PlIhtWEIW/fNV8LM6agiAUCECgkMMb9SGGwdTpyzpXqqLcp2yXjdmzb4rLK1dA8LhSkeVQ2aGtnUDcIAFUIdE1ggx00RW/54MhVT/nuz4uzc3V2clYuTG9EQJ4xlaJUrpzKV8/IVdSmky1CRbvpYbWp5271/LHJz7v1trl1U5TKm5n5I9nmMLEAgR4ITGXfsjGKDc6BNvadNtBxLJuPqXxlXDro/HUK0nwuua2bD0yuWRqnQiD1wa9bXM19+4leR7LuBNLtnSruo1rfOirHWdPzuvFd98KWq8tLfTX0Sl1xRbQm+VhcGMtXyTx99lQ9ffJUPX/xTMltvkVTfKAcamssiqyFdp2SPhWwhsLlFkz3ZYKitC/S+IFANwTWHRe78dq/1bHl2Wk8qXPhRrRzzgMHLUjrAlt3QtcISolS3fhKTNGVR6Bko15bNJTo5rnybXWLSK/XaN4wxka+UBoVgSr7Kr9/MW/G1VdFj4+OzXOio0pkwsHIi4+e6cL09ZvX5qtk5OqpTO44KEtmfW6//Hbl51PPj9t3pz6CxA+BYgJz2U8VZxj39J5rx+egbeczaEEaD1P+UuvJlly5adtXfkYLb+34w9EH3dyC1p3hzvP0tg+qy/Vxe3OrDj99Nt8bulwK/WT+8uVL9dXXX/T6IqR+MtNe3BXQuR7H5A888rUwVaYqfwyqYgcZCECgfwJz3Yd5koPn1/V5+Ab2R12Q+gFsMh980JsEPUMdxmGGg0pKGxF40G/JledE5RlReWERU38E5PnSL/XbeeX7Tctu5e0vouae/L7Vz5tbGqemz8vMdcEtb97dkaK05A/LbWZCYdsmTWxBoDkBvy9obmFkmhsUbZ1l0nVMFew3Lkj73kCaHBz6jrGzDaVDw3mMcq8CFsVQYSMrUqU9IFDAsfJYFOgHHpSxJQ09ndCFvqPlCnGaEM2vKOJIvdOFVGyV2fugUvq+2duRz5oUoPKM6NXlVfSWUy/HvD8C8mbel69e6udNn+vCdBrfexnuq8Pl/qj140ly8/+Nx+DWk239sqo+i9J+Mq7mpck5UDXLSEFgWgRmuf8rOH8YbGQ6jidvDCsVpHmKg0Gas+OON4AydP6kuUzG9A0Y49rY2hIoybEypzWxrPtMrT35KIlxjeuNutvKv1YQOleZgvPSSuomVpHMK8DX8FvL30ewxo4Xk0L0/PTMXBmVr3NhGp6APGP64sVz9dVXX6rdJ9VuBx0iar+v8PMhYujDp/leXf0hNy9iKvmw7zx9wlfCbDAglfdtG/hAFQJtEJj7Pq8uozHyaDOm3IK0TQd1gS9KvuLJ7KKYDJQs23x/4Dsrajv4PPmituT8uBSceUb04FDd3d6WytE5HIEnuhj96uuvzPeZDhdF0rPfH/l5snc+a5Kf+f9Q/RMmf0iQojT3D03zQTP6TChsRz9Eswhw7vvATQdpcD4tnndtfTw8qX4k2JTcDPTTg19rp9ziwM0A5bApMBbD8p+599X9yrw19/7uXt3e3Mw823mkJ18XI4WpFKhS9PQ9+WOLn/ftvy9/kp/JUZ95NM11W3+Vz45c1c67+6GvRPDTCoFa51CteMTI1Ak03W9MPe/K8Q90frvpuFCQhiOcGsTaO8qUfmia5foE0ht37StrjEd96FPXKBjzOp/l9HYXIvFXTItOhFf6hUX+GdHrq+tQleUJEJAXHb1+/Uq9ev2y87fxhttZuDwBTLVDNPlJASr/alwNLXMkRen2Brda1z6elAVD3ywI1DlOzCLhGkkU7aPGwqwovhopzku04Fyo7yTrjMuiC9IiUJUPVCMZ8EobWIVY151sV/KziVBOjJXHwvktGtNNwupbt04OdfnUyiVnPGrpp4S72r7SvGozaSlPiePk6ERdnJ03vvKTQsbqAATkBEvexvvVV1+YFx+1HYLfXv28bftjshc9F6o/G11MO0+emLfvdmG7qs2xnJBXjRe57gnMaZtYt5/aNNd19vNGq67PJj7y/M6iraXzndZYBPEsqiAt2igrb9wBuNYGY0yGNsyvdsFR4K/yeAi7AhutYk35qF3wtBpM1ljRdp2VnHdLrXFJjWkbZI4Pj82Li9qwhY3hCch+6PWbV/prYr7Y+Cti/GfUz4fPrrsIJEfzv6UroWWRyhhtS1G6HR19ysRH2RdFzu3HoxyfoYOqdT7UcrDr9ldtxLbOR8spYS6PQAfnQ3lu1rXNtyAtADz0Seu6AWncn8q31kEupds4hpYUE2M0UGxVdpKJOMPcG8Zca8zEX46fwpjC+NxylRxz1GgKCAhDeV706POhurnmWdEAzWwWd/VXjbx6/VrfyvvSXDmtmpj/fPl5Vb0pykmO/n/t12FvmPCWvOSI50nH8bVeG44l6t0QaKNw7CayfKtL2GfmZz6O1qH4D1eQ5pxMp4ci9+Ra68lU9QagXBveUYUYvOgY5kNtJGPIXWJYev5jGYfO43CfcePHfoDru3SfbaOutWV/UbovyPNQYf9wfXmtzk5P9YuLeItuHsI5tclXxLz54o169uyZfumR37LiDMP9U7gcS8xryecoz4TKv8oH5Q4wbOtbrLfWfJ9s7c9/B3EuxSSs5zvS64pbv18oI7DORqhbxV4oz3JHBCqcD23quZ+CtIdE0iD86ULVwjWt38Z6+EGqvYMegFkbObdqQzOQacgxzM8nOPmyA5svNnSr45cJY2y3hqXGufZnxSRox6TKtuL3DRkuuqGKvtc718+Knp+cKXmREdMyCMhLj57pt/H+/OdfR2/i9ft5P58zCcnR5Ckft6L9y0AA5Nbd7TVFaRRaap8TtVdYaLZ/qmAYkQSBaD89tuNVIkpWILAsAl3u97spSOWgtawx2jzbpTGbbb5yphZvDsFi1BgfaH1T1OIbms874JqIzqwkWlKxxvnn5Z4SzqzG5ot8bGY/47BhgxSjJ/qZUablEviDX/5CPX36dBEAfCHa1htyu4LW+0uOUvtbu/8q2nd1lTV2ywjUuRpXZoc+CECggEBqP1ggtba5lYK0y4p5bQZDCQQD0GiHF+gPlUJlvzmxNjnw9rOd2ILFF0P2j6tjO0HYrKgKs/F5Vh7LyQu6jGVmN8JeM5K3hl6eX6jT49PRXSHqFQTO9Df/bKkv9Zt4X716lXsL79QRmf217Kpk/6//T2GS50nl9t34gcpqUTc5nlWzXE2qLt/oGMDVw2qAtVTlMXbbut/iK+tVjgRBCMyLQN39V1H2es9dMuUUIiXS8+qqkPvaQrSCjarQ8ga87R1lno+i+Ew9kNpxF8l20y4nSVnLlokcfMxSViBq0cr2J2rpe0Ei9PFa3z7m8thy0u479AJ/LrJ0gE1Pmtznx1MxTj2wRGNBONLc4ja6urtXF7oYlf91Pisl0dE1YQKyDZydnpkM5LtL1x4PJpCr2a5l92M+e7IwgaCDEB/1H4we9S30W/pFVHUmk6bbV9TRa1PW7tqq7thSns14pdpSq7W3z5TN2vop/0OvNh3jJnobjeXQoPAPgZoEEvuG1H6jjqldTqw0rgKAtXcqBXbqDEiRrB/wcLya7CiL7IfttfLWOfcyOT/rvFkmEtE6yV6iLnUSRZhdcHq6w/5EdqLTlexCJNPfggs8Ocu43wq3EYl7jXzagBO3zWYlbokwBEpxb9C44eL93Z06PDg0b9QNP4MbmkV94gRWqwd1qp8jlunNm9eTzMZvz+blROFndZLZKPWgC1J559SWft53SpPdtW229zL7w6Z/AEzD0nby9q9pMdazBFobSzHd1nhmw6QFAu0TqLLf0MeZvD3drhQ6/oDUfmTjtZiXc+2deQHUVrMu8FEr1gIbRXG2sTMtsl29XUdhf6qrzEIy/8qvTy36EGcXvEjhPHFyYTegQtnyDuc8ikFLa3vVTl/yd0Tl/op7wxCKpTbrub68UvIdo3K7LhME0gRkuzg+OjHNUytKJfaxPxea5l1l/UF/FdO2nMiXnMxH+8MSmSq+xiRj9of6eL/JZA8NEZ1NTKG7AYFoFNeMp79YsYErVCHQLwG9zzV7mFRtMo4rpKmgishEu8i6B5AS+3U/zHmFbFG8he0l8RTqpDr8gSc6eLRgM+WixqqOJtp7JhaNjWjcZE1WnGygYuTG96sgwoJm+wlLZLs+JT1uMhWZXG+gukTCh1lJtFQ3lCepTek/bdnxtSBypHS/E9GzjiZnOXQQDUm0UM23Hpvrq2vzvCjFaDVkS5Y6cc8Vy+272/pZxrFN/thl5vrz4dfHFuem8dhdqv5+YH2L/bb+ftKiY3y0i3D74CZ+oz1K3XOSJs560jFcNmAiYRouM2LSE/pabmox1uMZbe+Bl1o2Aj0WIdAFgfJnSLvwmGfTV8t5fWGb20m2eSBt01YYatFtwAmZFlbyDx66VTrs3qail/wrc8aEtxCtRAuuR68HTcGi17Rz2Snm7RVNbxRwUqdsrWwn6/WiYKIF37N+7mL1IXsL6XVvSHIzRZlvSM29Xqp5Nqsmv/iXy0s3SJuHFy8U5O3k071GPzKS7g3WnUwV0UDLLKY2zosz+7zo/f19WpJ1CGQIyLFEbt+V23i/0i87KiqEMoodN0hc/r9xZT6jHTsdyLz84ehBvhfV5SwnOLtPn3QWTYQyte/ozGHKcLSbG1nxZ7gMxMQjMmxGxsXHtum8cm7yOShwNpb9U0F4NC+BQKr266UglYND0yna4ToDzS01jUDrufgH8d0obE0tDS5tp2JOiZyjlWghbXWD9bUB28JGe1jnPdEfrUQLjWP0FuwxLhuvbdFS9qexn2EUXXYyM4lk86scV/h5FzO1Tgq0guiENsSxCc/FKOsNpqra8gyavEn3XBekm+y7GoSIysQJyPZiX3r1YJ4pfaK/G3OoyVzV1xu9OSWtuvEPFewGfm3xqcz3Aac/r/JZfnzYyf3jQIjE7O3iXzWj8ZaMgZq6m4l7z5n9ZQ2zUdS19tM1HAwkatikjyMNYhlj4dZKbsJmZmPeYHhRGRGBXgrSTfKNdribGNlU131oox23/iD3Glfgzx4zo0hqZKYjtj81dJqKxr6axyu+YztNI+lCzx7jdGyFk/Q1GaNCgy12WKbrDZblENsQqaLJEDACTipCEi04VdefnBWZjdrTVqKOpNV0c6o3a0Wucl1dXBbo0QyBcgK2KL00t3v/4vd/T/VZlNriTB+f9FXCJUwrXXCa52AL0n3QV6vlivVOyVt3zR6g9om5dmh/IszR3TG1bUUmxrMQnHNUCaoZwyqWh5dJ/5GjakRjLGTD2M1Hxp7MhM2Z5TmPbSZZGgYlULsgbfrhHCzLGjvW7KmpOeb0H7rbScgOw+4MZJ4X3ZrQauS+xtL67kzMjSLWwHsu9tdnVkHCnZn4wVo7VqkzmdBDNMzRQtjbz7I5UomrdWMRbaG5cUVmfG/UIAvRiu8tmeezSFsQqXSbNSqt3oaX8OuBW73tXeoXGN3o50aZILApASmEDj8fqa+//ko9ffZ0U3OF+r4INQWS2w8XCk+8w+cqt+VWfa77Qd9yv72jj0cFhaLZI2huiT1Cnqxj6/cgaZRRe84YrLWdNrZ2PWFxrXRawGhnTEQZmN1lolt3Bb2RuYRM1OoWNIc8nbSYrEd28rjnKUygzZ8rm9wq5OXlfWpV9bx8V3MzhjnbdB1/cxzfOvkjW41AtiCtsROp5qIfqfSHuYnXqjvPJrazOtqb/Ul0hR/caDkhEay4nUR/cefHHERkFk08G+7A0jabrzvIdu+umet1v1zX6EY5GSr5R/UwDidmBaOVUCKxvF4iId7BSp0I6siGoebrpYcjX8rasS9cCj9RWek7/dUuF6fnlU90wwhZhkAegdvbO3V8fKLefPFavXjxIk+kUZsvzJZRhMpuWxc3j/HzoXWgyVXSR/1/3XeTJvYI6Z1LHYc5spvYjvZaiaImYTHHo2VmD3WRhUjOaK83EckXLSRMaGaRJ4nV/hSpFrQnLBbIjLU5yj4RoGXdIK/EeCdMTm4lyr7lz1UdENHozIhrnfynILs7xBUpObhstHFo/WgDnwJlE6OO2P6URhzlNeAHNxFgq6wlu2jkE25aXfHsjCv9K3SZuzOKqCfD8HaSrcVrxkyBrWKtRM9m2rEpn3KePenLa4+1ZWm9RCzvvcUtCf3AVLAYCieGKLmSEEuYTfWUrorf8PtQ03Hc6zdyHn8+VrzAqBQjnQ0I3NzcqvvDE/X4tVIvX25WlEbPhdbdNzWIewwqcpVZClFJd5M/Ot/f3qunJbftjiHXohiifVWDMU/s93KPfUVem7VvEqv3aI4mPcTq/bU3j7LfyKS5t8xAqGYv73ORZJh3fN4oxM6Vi+5mCB3n5R32p5cjmg0+R6GtiOYkt9Ewk/Et70aD1GNsVTa2RDh6A+ovTu3J/iRCiDZCaY1WooVANqnca9wSReDQL0ZRRguxnJcJEuhwMQwgdBNEkbezWPfBT+sk5APbocui5bStIrkW26tHWCSZ5VokKWFn+1yLzIwp+ZW1Kbrrp8CWFs76yrcQym35FR9C0mTGgBczHYmVlGiJnXN9ZZRiNMWL1dYIyLOOR/q7bGWqW5TKiZf5v5DnQoWRFKLCrK1J+K30HRA7u/qmsMTxoS0P47Xjd6emqi8JM7HrHJCRiXeD43CUx4A5lGBe22XOdt2gmVzSecj+oMRKVqdMusRQa13RiFS2WLfYrGy4BcGI5kK20fRY1K7fajDP3rJbQ7kz0TUfuEZ+3cYTbUw1jST0opVooaa1KuLedtUPs5MLxIPF2GEhW+8vFh1kSXa+6Q96en1dYKF8YK+tDHO5rosp6C+LQ2wX93vPaYn0etJZSW8g6Ba18PrvEw3VnHXvxIfoRMrzie2k1CwDbzMWy10KxeoWs7KzvTq/VDfXN7m2aYRAWwTk6qZ8V6lML148L3ymUfplu/T/S3YIIjqLyecafmVL24mt7vRtuzvB3Vk1HKT3T3MsasP9aOYYXIFVglG6iKqg35ZIlEd4HlDTuMllwBx8uCaXmnmkdYbPJRoRn1aP88RW2aPfclcRkZpjG1qNMutqO5VjUOjQLcu+uquitH5BWhCkj7tOoJJYt5OzH8yiQdSOvfewrSweLx9rlklX6NMG19uMJSpY7EekxXFrIzs/frm2CmPNlQ74eatBkxutcs08vdCGX3ZWUsZSq1a4osnCVL3LinMTQ/wrRys3SitX0lV21TXa9Tn90IxJP/6VE0/cFOlFC3Ff+Gnzrdf6BUZ8vYunwbxrAnIVXopSufr35s3rhDt/PJQ35PrlhMAMV8ICtOpLippiEKYP9yu186TBaU/aaVs727TdgvXEIaCrE9AC31WbE7vcinyivOrklLZdR7diMiaXtJ+KulXF6pwrV7WZJ9c0l2hsnNHE+OY5SrVF+h2MT8pVyWrdqEtMddIVUarxNy6rEx0jKmynRqPOOGibReTiiNsHsn7PnBNY7eQk7hw7raUTDIiFWITSnpJ6oJkdgrNTrN1axNaQDsTEkom/JT/ebp0NMc+1t5PX17BtU8bCzdvwc9OiV+L1bHCGt+FhlrICuS1lFtMKFWTXxJi2GCYURe0AlHvzvZFWxrTv8ZIZAdNQ3puvk9ca2HGLQUueQuzdCLqrG5ntOWksz6bP0xh0K3ICfKmvjnZ9IlyYGB2LJGCK0pNTvd09qi/0y47MiYXeaKMTjAVQkdz9Lbl95i0vONrWDyqZY3+T41pm39PPYCX2aTruxP5sTQiim5AfKIe8MKO8moyFMxi9G2BEeeXlGrZlzj3DzqJlzSji5WSa2GmiI+4S21BRjHntbmyj7XBC45SXTrtt8YhW/wjEOpVjMcyr6ZXFYbaBDscvW5C2tNGXF6DVwFSHrSVz4i7Sj7wXkXe2uoYfxhfFFDY2Wc7LSdrqbER5NprE4nSa5Fa08/O2/Ny6kCsKdQLUwvanjlIl2SjuaCFQqxVjrBeZkgUfd2Rrfe5b5j7WyEps2JpLrMcrkYO4qc0lF04UVZm7SMgG0OQE1psPTR0dHKs7/RZUJgj0TUCugp6fnandnW31/Pnzvt0P4k/20fLHH/nf5DPcRtDm6rO8cVdzbzTVO9DELuocf2Ot8qWKNsN9njlQ6hxkf5hoL/GUka3ot8Rkq11+317lJCCR8wB5GP91/brxCqE1suMM1P3sbeLLuHT5JtiHybDcKYH6f4CIPlGJuOLtIL8/IVy6UrwlZN6yK6J2+5El79jPS7zkfGhKpNd3VdjxV4hqvZ88CQ2gGFmeQtBWIW6Rbi1278/v5Pw8CKl00euXCiU7W4s9aTaxVu7D9QZC0XhFCwlz8Yro6P+BatxXeUm08x1FdqOFakYT1sIVbScyFS14m2Gnb0tFZmxlDWZMxeq1l0LrCSz54ZXaj2xFCzr/FoINPxZyUnqmX2JEMVo6FHR2TECuEp6enhkvcy1K/cmvvKRoLHcirPRtu2q7+HtJNxn2YLdlzYQ7nk0My04wsGV2ieGOMegrdBPI1zlJzeRU6CDoCHyFcQcSgywmDiVhjDnRmLyrcM3RLWoS/+aKblW7OsZEzKJfVbcoiJrtmW2tpr6Id8GyQRiLU6m7rfj9dRpUu+OX3qJjb/oKadEDqjlKOR+O2FT9paLk61uqqJETf2Jnu+6DHuzAcuhUDKKhWOA714L0S/xOro34QjbV7FWTyo1fN65LsUgvbPcvtdksktBi3nJIJq8/3bY+GiPhxOpwkEjsZlsekzW9Po505H69TDPRJ8EnGrwFO5euKFKzEK2Z9kjVLdhZYsUaitVCi7Yv53fIVJ4bvbq4ypGiCQL9ErjXxdGp/uPIkydP1U7Tq3b9hlzJmxzb7dVQ9wkOP4CVLHQnZK6S6j8GqB3vI7Ez8Y2N5pJtwlqY97rzi9BjWm+dbigf2ilYrnPulchnXRzeX1U5L182l9zatBf4SuSWbm/i042D3erdtpCyY/pqjlcQmj5P8tbz7YeyY1neNOdN8zDjnBqHTW2OXb9o2y6KO9yuMjI9sdst/aDrDT/e9DMh1mto01YVz+5DK/FHG6OGWnmQgg99awyqxC0yge8qKlF8lfQi6cB0PpU8yUAptVhP2m9Y5VrSmx+bOA97vB0/TwaX35qUKVsLPYVyzm4wCz1ltDIN2lagECyGTgqXxVyso5fcStxWqJrQTErlBRlLpHuzvrSE/FUg7DBKVjOtH1sWFasXqob9iWUtFNkquSU5oaNX5Kroxdll4qCelmEdAn0SkGdKr66u1OvXr/p024kvX4TKyU3pCU4n3qsbXd2t9O3ST9YoVNoTaRvRnsjYy9MyEsHxOU/GB2NkezoB9D7L5olYgxzKdMK+JB3dUze3uvKh8zXLidwCWdOeyjWTRyAvi95WJKfj9m0p0UqrkZ0S6bw4S8QzXcZHh3wzDgdqqMup7pXFgdIqdVs35yJjfbJIPkMqB5GiqOq2uw9za/aq+Hfxhx+yKh/qjOmBYs/EUdCQxzTMM68/NhVKxq2lSxtsF5E3WXCBlccnvV7Lz+PoTIuz5e34eSwlS/mtSZmqa9qWM1fHqpfNZNHAVhhpxEAatS23uYYiqeWkQx9XSsitxr1R3MEBy/bGMnlc4vgiC5GrdEtgScvoXvlZl1DCSGIl8pNcsF7khSaXZxdqpQsAJgiMiYC/dXeqRWnb3xva+djofYy8cXd7N7pMuoFL2b8U74d8T3JfV+zOyAX7wNonhF432G8Xe+u+J5O3j6+ia8/PiA+YUyaPovhbirGyv6I4KrSnt7U8lQT/lIDpaynflOnJreb9Aa72Z3eEWafziraHDsZ9N+1sIx56R9PHhyiKMdyxCRz9P4IVCVVc6Dt2CSuMvyTMKkyryJS4KO8yXLUH+1MoG8Zgd1Q2RdMedmYsSKcfOT/PCJmGclulTvINrmt1JutazsuifLjFQ55WNkATy9qAcgTcDqT6320lHm3HBZ5jMRuc1TBqed9nGttwS3FDYt+RIbG+ISeW2Ifs5y4v+L7RHEg0jYTA2dm52tbPNr58+XIkERWHIZ8n+R9+bUux9Dh7Hu71y4229cuNMvuW6vEa1RJ96Qp2cQWGvUS+IeGc31NgbmbNno5JS7OoOyXYuWNgXRtV5BN+qiikZeQzpdsiOx3GmnZdtl5G3PSlxsTE31LsEYuyAEfQJ5/RJUx+PPLGvU7+3k76bonMFVJvdDR43UCvjWesG0ROXGtz0YOQL5Pf6ses9lyba2ox3qCc15Qhs5pqK44vspYSEQN5fZUNJxKsoWXiCD3Lcpl+KCvKWVk5gTNmC38lCsWUwzWqhTaTHUkrUczRgpZ2InaWlE/ayl8LTYmEzbm+nYzG+gbxZoNKy+qg5JnRS32rLhMExkpATmqurm7Us2fPR/s8aViAjuUlRY3HU/N+lDfu7lZ9467sWJJ7OLOrcb9Mj+/WbdJsuioGmPcHPK+6zo536+XNfN0BJyHcYKWloqOB51oqCXaOiR2rXGrVbXu+jkPkx7cHloo8RTpONpKbCNsgRbMYxZ/uaLie5tPQTG21dIGZl1dZbEZej2GeTJ6t2gEOpCD5SPw+v0ph6M9DmkO0nvqsJAvS4EPgb5uLFNd59oYDG+tUivrTG0ORXFftGf/pnHyuOoDKfIJg/Qb5/7P3JjySHDuaYKouSe+Y7pnuQS92gMVigP3/v2y635NUpbprSRr5kTSjuZvHkZUpeSAzjMfHj6S5h4V7eBz7sfuIQLsvKt02K3utwprSvMKzSWZOi6j55laLM545Mnk6eKcm6JZyJG6OdU/bjWY9dXYPu2gf2+rLfEgBwTw8RqPVFv1hLzE3hcQooMPjRWyCtyCgfK9jlxKVfB6i0giOcZ8+fDq/xGiYs9PwFGfg48ePD7/99hv9Punf6cXj8THyvWr+Xr8beu9+v9FP0PzwjeZ5aa7b9khbJSlarS4+7Irr0F4vgqU7PzGdRYxJj+TpWUe2HlHoS/Olcf36b3RHOCzmBuNF/ca8sZ/FHla3D3AxB+WWmhdzxVIfW57VH+tI8/8MeuLa0VdsZEMWPG3DaruVXIQt7SEH5m1nzoALsbcUUWe3j94iRz4h1QRIeCTDziRtUQ0ngFtg8l1U3w5ncs962dxpqqrqXaNCtvxzT6rviEKUx1jHmsXCd8q1zVd5K1tsos+5h4+xhdzRiaqUVzKHZMR0EWddQflamvaBdjxlqOMasRHWFTmvHyChEnEiDgKbF64EC57uhM45QQPBa6glAyqHUzVqCvr86fPDW/oW0y9f6Kcezts5A098Bvi58C29tfzNm9cPP//883etlg8H2pcUfb/fDb3nBPBcy5cb0dukX/TfcBzWEl2oUIqtOmzA96kFYxARE4UN6gjbkPcybISKK1VgT2N7QfAffqEkHk/xTnX0VsVEzoN8qKDiVa48Q56AY8V3RX5nW5ckr9X7yLn3qjw8H9qHbAfraS9J8Kdt88TmIpQp4qU99jysC5cIkATWPx6zVyA3vUvzf1Pmh4fNz5ByY9ckLycm7oy3aoY5H2PHpBx85bjs69BM1Qy706FhF0bv0kdAW2ToQUDJJN806dQR6XbkCzg05HhkiDDRmu2q7Pd9gzcYeQVAr4KRI/s6ogW1jN8yRt9W/daE4mOYNEDFaxu5Soub7tfEFMiCmHmClimhKWLGwDj1BUgQ3a9Mkfnjhw9yUqquczhn4FnMwH/91z/ppJR/CuYWX7qz3rK9OPyUfjd0vfo1JJ9k8wtU/JM7cnv5w8Prl29ycFpgaI2URSWuLA0usITNNJWW4KRMqKvQG9lSBYuc3rvtIxzYancfyPQ4j/UqW38QjbhKeIxjuy5vVbNB2Hfot0Qt8MoRNYW5ZUrM/neYJ86P+ZBiUA1r9Y3rpB4YiZ5IRuQlfXRzEnn7IiTPJTl6oiegH3ocab3x8RtbWJ2XrbmNfEdlzv8qkdtGtY1FuvhNP5LBYo/EXIq1+qz+RZ7U+zSmR+FhU0QoNg8FrpkGpt4QUgdxyjc6OMpIewazxyjCKIyHajpTVFIizw3lUM8+q4IZeCCuvcrNAdyQB35lnhvc+mkKVe6wE9LLKbHCzRi8VO8wWXicwh1BQm0iQAuIXtSCOjNHShmdHWriZ2QurGbl6LkH3J1gEXzg+f7d+857qucMPI8Z+Oc/f5G37r56ld/IdI/qea1oV0Pbo2d20HKP3I/FaSeifLId+/tCX270+g31bccRRUH8XIh3sdgyaQsN4YNYRLvJQtvTctMkdpXAqZIEXrYmJcEuUOZk5olzOSaIjVkEzVd3cOGekQGWje0DzCMJbZu13qT2vrbQX5wBKy/128caaHEEf8i5GHoYhrq7mm9RwxYH8nLFXW5porMl/OEun0fAJSej3BnPDeZaW5X56uZQXY82cE35ma4vqNe3SqMHQ9/kFvwmvisfgLbTbtdtqFnFW29RNOaaw7xgHgzwLApMEHPN5I5O53ElfZ9BmLrATu2S5QrFGctkAxHscQykPZFy9tRjnGaS4T778HovsRatVBoYvz1azQ1UhLXpIBRt23IOEkE3K+VjmZKEPODseBTS0kdacajXghHrV2ljfAy/RP5AJ6Nf7CrIJQRnzDkD33EG3r//QN+6+0JOSnm8x81OQvkEoT9JuEe+x+bknrhHvho665F//oVg5XFuWW9cpHQtsyXN8aPFfStSTNLjR+6ETkofO+oDmxgGawpk734aQ+xzJfKZwhvp0tuRY9kiR5uS7T5SmOWjmuNcgcH8KehUZjOQtvwF+8Efbd4vPRmV+aV9D/Mxm/DvZM8npEeK0J0i7ShH4i/FHtwZb1FfXFDGsnnjzk5kLt3sXHXIGpoIYioFmYorZQlYKbI40sI5I48xSERGxa+ERYoBPxgiupd7cCyox8505cjDDFzaY9a+ojJAjDnhSly+euvMEjslCHmk0Fht8YIA0U6pOGX3mCsovbAgTTmTIykaTTYzF8lSN6YYnstVlrf0m6Pn7ZyB5zwD7979Lm/d/ctfbvt50mf3u6EXbMRP9Plxfmvu3ok2+/mFq1dvtg+HbF1JpRTGtmSxwxanFLGgXBM7o7dCx5rMg0gy5KvBCzEIZsEYx7gIM6+ho6+SDV/5ku2Sk73uOU74Ao/UqBjUEfyCV/9uP31cKv7pKtO+n27JqAzbhLaR9PFMtwE3dPHJKPVu8/BU52B7BbbNqQ80Vq0hc91sDDmu4dyvb4bAw61L7xuRm59Fx6DExEoICmIM6eTAoAF7ceYfT2DM43UES5e3qSG7+yuj9mauPV4nW5WIMZAGMRC41eoQZ1LYosVmysBzTPSse3E54WocyoegecLjZIVr3B/SlBopjCVnsXj3ZVWzUHIlICEUNMO2F0nIKwlb1oQ1RefF1I90dem8nTPwR5iBd+/ePbx+/Yr+X1/cjp2U8bfl8hVD0y8mfKKB7Yrv1wc+GT1yWzkhXeWTNUjvfOm0FVNXKFuoiDSISDH7IjkDGJs9rZm94mo+RBh0cwQPCV4LhagD/h0Wyep3Cb3G4SEVPnXlk+1Bq5LF2vOr6UU86jBsgZmZJFbj2rSkDmZhT8Ie+0bVG/P0JIouiojbwNzoxwxhRN/B9r223Vadobws0v7W92BzcPHJbc5wM23zS41ulmWP6OADu5/ckX4fgRiCNvRWzJYPTBASGkq/K6kDfqsDNBA4so+GMwhMJXR+F7zrYijJg0qju49LShh5+yaDL4hrqSggx7BhfGBGMqQfBYIpWyaN4SLvuAd8NAxpmQxpjzODzyojipHFjb0P8SJAM7ZY+gWyZlPaduJsNDmXWX1sNad6dQ1h27dvX8+fefHJOqVnPgMfP356+Mc/fnn4H//jXw9/yRGfePpvh/KJ6DOfjKJ87pH/7arvJSfbXz7zCeyPgV0nKsxXEAXnx+LjejVaKDoQBDHkdFH8dJevVHZ+VkuiMbtHzqUyyowhTxDnZOoRrN75fO2GTQBWjLtTLWHnHpEesyldX+QmfXS2aUkdRPdVcur/yp7AtccT5r/qCjyLnfUcKX6vlsUcButzmb0apY4b56/y3Mo26+2pnYxyv2tXSC+ZmbBzXhIeY2YT6ph9BLAE3Ucbwh4CNjKL+cC4Juh8XBjtObiUQBJExyxI6Ej5LuUpU4Vtf4h3EYzaLfnSnDTyIZY5YIRARsbTv9akA6OLWw2yGGH1uyE+ZhUnBVrsAJ4YwIE8ThI2RxFNARoMjgJ1yBQS7vWBcncX+NBPVYzGM9/H3z+dnx2t5ui0PdsZ+PSpnZT+27/996Ue2knoV5yMLgU9Q9BnOpG0Lym65ETUWv5GV44/04n/K7oSvbdmIUaB+aSxraLggGBR87Fcf0vjnKN59pLWpBYlXr5jA/2bfS9r9KcMSYmoo3KsZJ00Ru1mpOcuYd59Ptpl+q6A1HN4Pl4pqu8fXMrT+8EZ5ky+hZgcFoutFTCImwiImfiTOfR4Tc7EWSjT3gvsPUzSW+j10hxP8WSUe7nfCWncfXpLZQAAQABJREFU8Q5OoO1Q88neR6RYgh+L2HoobPksq2bLgzmXR2RiwbiONTLNBRoIU+iioyYKpRc8FNP+Cp+bZB78zqbCASn1DqHwWGhSzJhHhhClIVOqiFTHtt+IjK0R5JgJkYTkOI6GxQQKH64D6+Mv5jG4VAAFQits+T7XHPNsUUyzUb0jB1lymq73xsZv2fvw4aNcMdnKffrOGXhuM/Dp08eH9+/fP/z000/T0vlEdOVzk1OCZ+LgE9Gjb8vda01O4vdA6pfVxu8Wo7Zh45pH+M6Y1sykbHO7dzvIvPuHbFyYoZ3dJHgZoj10rRi0HBNzUhg+GBKHeffzGcIiGo1YdQLEE49lUyZV+snaw1ccz8gW52e1bI6RueS5usf8BM68NVcrXMPF3pEn5F5j+b6op3oyyrNyvxPS/kG6sw1kQ29i9hEIJ+g+2hDYrRB+mWB8FB3EI1ypElaIR6giH81rVHt+cEBghClVpPl6pj294+rUmJIz9O7GTh56r2auIGvzKoix/c0hlScVkpSujip4ZuM+mm+1+szkjeSKHOWfpcwZgDchPO7M5CwusQ9MokBz0K5EgSFJEKeRyDIIzlXyBCNCOUtSHh4+0VWOz3Q16bydM/BHmwE+Yfrll1/lSy1+/NHfXmpvV+XxmquET3m+rC++Gsono6bfsma5QkpfbLR3wNaOP/PCIzZfwm5Z1jZXWBeDOI3xz4Pm+i1gn8MQdTzzwMOCwi3K8uyNhhcuVkC6F4mUG0BjZ8gCcXhO3SB1V8SfJyuYF8x6nB94s5C2yhOdwyP9cHfPoae8FR5fO3ZCurAjbbWADTgF7SOmoezQ8DUW3j0Yyf9pVyG9ugVWFYOlCjhsS3yFsjf90gVasf6oDApMdKmyuSfBVpRQYBCnkV4vip5gtUYabljtkCtz52TZ56Go3JtxZy91k2KcMbTxgbVnGHXlNK4RMLekmK62eVT0EEMkmTxxoJvYKAdKbCOINDED5Ak3/CTw2+4+/v5Bxmg/5XMG/igzwD9f8vbtu4dXr17LiZN9QdE9TtCewpxxX/zfTkIf5AuZ7lYXLUJf6YT3xcsX7Yhgc83hFYsXNF2/0gKGFe8mpc7YLlmypUy6y28z1jK1h9TKtIPwQnJa121GMDVThj0H+oZgEbMKB6AGVPgZtoWwl6OqSCXFAKbN/QXwJyugjydQYZr3Azu69PBEt8PRnvZeGNvcTLxuEqCaj/hcUfk3ebecup1mebdCzXfshJQ39IGdg5OkjWBZ07iPAFyhByIQaoJsAFN8WYZlFMak1+R3/jXeuMP0j7PYS10TI5rHsDXOqzomEZsSHuW1ejxfJjrK5zy3kqhCKbJVMtYb83ReXQwiQiaKqGJfEkUbVWx01/QclbVGEDmy37WuIiV3fypk30yIlpuhs/z2uZH+LTnAiwBtI+tQfcDORf6cHV8hPW/nDPyRZ4Dfkv7bb28f+Kdg4sHFH63n9vnQ9huhj9EnH8J9pZ+JeUknpG0xHmc0rUzhACwj8xqXYhiYDEnJNKplthKybEQ2CCGUbZQsuma5I6YxzJCBPzFHey0bo3/h3Zi1jtyybnOY13LXTOZtaNPs2Fis/cFaTfSkrNIH7dM2B1LcSh/hnIA5vlf/qe5LZzYcu92rD9S5MreX9kHcyLPBYdt8A3KRK/IeObHePyENO9tKZVLIJnAfgXCF7kcYYn8TGBI5SqFABWqIBawwFRkI1f4KXzYxnxzoS1JkFpDnUskNOGnIEbZY5ByDFnjMV5jIRez8bEF/nKfGNIZUhygaIeFVpDgsvY+IddPlUsgbxMS3nM/rHanUR1xC1y0VzUZZkavhZzy9HWGB1zDgNgM3x0Y4zMAjmwmo2BgiARJjT1iJoAVv3s94q6AhcwVqtlDG77+9+0MfoM8n4fT8mWaAT87evn378PPP88+SPuf54M/A8otLBw89rm+Zlyh6l0X/gposMX5HeXwtW0kaV7OwXFFo1ra5IssMuc0HrwkLlAaVjEmZ1bBlX0hYJJIov9PN0xej3HlIxUiEn92OvmAxdqULHhbN25lV5Ri8OFtD3HrPkxLPMpXanGz3k4K7B2U9PxQRcY/Uo8w7F8u5j+bUeq2fw/OSJmlbsRxpjigEW+Fo7dvpvru3fzFxa27HE9K4Iy20gsmdYvcRKZTg+xEzxMyeMswVDb+ExXYmGy1JzUUoWhhlbWQggiBY+GQk1vY38bu5zF8aPaavYhveeuHoPq5mbIWPbyI2u0dFac5tqFBlEM3bjwuQ1o8A6U4K6Ksge/vr6Tud4jQ0MUAxgcnGmRGy8Lg0NJIMBnjqxxKlybdgCAvzQCuGbIWGRdQnJLBSOkIKOOz3oYiMDQ4St3zm5N8d/XzwtwdzllM7Z+B5zQCflP71r399XkUX1doBC18R5c/J8tuQv9eN37Jrb9sdawgrUVjvsAYG9xhLFgAhlLBsJNLAG8QME81eLCQF9TkMsRDctyRRHCqHsBR5ALRNLF6pvzVxpBUP03kSspbvCI81s12poXbG8Ly+gxzdxTYeQdsW7rtd8FjspsvJscIR03SY6Lq3jO14xby23WJxPm7YkMzjtXNnfV/Lc8O+eirZRlZn56TvOMcm7FxZ3UftI8Co0P2IfQQ4V4Xl3KuEDScPS+JeqRi7+uGdJhfPPCv5jnVinK2ZPX70wkmgqKD71uQUS6tHkMSvvdEgduRzsldrjFqRE58oZqGx/U1ppKtu+4ZOJc4fepmXnWwBnoVGyK4rb5qrrD8bBRnythdQyBr6soNJG48Uh/4oKMpJkSJqVnN9owPY9+/e16DTes7AH3QG+K27/I27L1++fLYd8tVQ+9mW73kiahPIV0j5d4wfHuhtu3LTZy89R7Y1x54lFSQD1rCwZka/P1k7C/sRl8DBwYAc0iOhA0ZPLl5Gn4FQ7Q9xMwGRSub8s4hsR3w0l0YGTB0SbV7UEDkPyszRLpYeZbMqqk0irJuVePQmbHSG59zRObH4AUYGdFwyAzNsjpxqaRax713c7TTPPR2otpufe+aM3MgfjasyzflT3QbS1+KcjldIdQJSc+Wk7CMQptD9iH0EOI8IRHsNM3YUFqZc5NSrnlUucFjdYmAkCWExqGIt5Mg45LPg3rHQj4WmseeRJ5NG1j00pL+qr0ZBHhEGwpRurnBc48AV52aZhxz2tL44rOrD6NDBpJ8cu8/JeKGCYJmOjvu5GiNl0yZ0gBkOsWzxuQ9VjmTGAkgSuN8Dt490YP6FvuzlvJ0z8GeaAT6B45+BeY5XSflElL+giV/IuuTFrHttZ6knXaDlxYsWJFsXV9YmxuDJKC1+ZdlTyqkD5agw5hAL3ylHpiJH+yN/9lifIUNZ86qxY29hhbHVyw6RSvoirMBtc3BAy1WEbprmdXnYNmbb6yw3k+wkIG5js90sSU0k20rzDn0/Ug11ZbUVNX6n2iT/pbl5De3auoqv47pWjfvCHtervpHtgANogq6h11DbdXVepbyUGTsn07JifLuEBG5/XUGVamQ2VpjLbVPWFQdjbBJkNGVSjyw844OioVvCxAAFQkesRYZag9hhK7VHj3lgEcE0itPQzEB+gejbTQ2OSapqiDbnZWvmjrgmj/SwjODS4vnGXO5DaLcQSjakhEBwjx15jY3wMcTMNEbzPH4lh5PyQfnH9+fvjvqMnNKfaQb4s5b8VtdXr6avLT+p6Wgnou2tuU+qsFDMF3rr/8vX9E273bookLiIpRUtEDyCiPWThOqnXMQPUCxIjdEnPaXGEFBbmztSIOBCQbj0zsupsmvWkNxEoCHkYmCGkP1zbT1gHTnPVnriSWUJWDBW+/NC2LUQ2z7gOdhLmtN79nBPbjRfCzJHOi/od68exffzK/F7sXUZ391Kz2LaTh6WCsPEBXQ/OcE1ESuWCVTMRYZgCuIWydTXV3PwsTPlHR0h0yCGLoJoHIXJXMWo6DwUODdJOZYEihWZiQzm0b1EcRaqrk4Va+ZRBL/KnB0duftnMGGSV6tzVuBFgNbx9ypxWGmFS0xEldnckO2ZANWJAC2ANLoj6dSAZ5G8RVhi7xYuT68oegDUOZxbknY8Vghywd/izD5yk0evLuAiQ+vEKNPIvx14fnY0Tcmp/IlmgK8y8knpUz4h5ReN+ESUn0t5fOq3dtV2v0r8dApDbUFzYZNA4Baji+C4Fm5SiNMoZJEuFswlTgKhl1QYnj52C0EdjIzKXgHAQqhzTQ6+I5hTNRaXoh+y1rRcGk/uUN5gEPqKs0aimvsLeO69f6p7ZIhzeujzrgeKkRzhYL98MeoA3yXQYT+ZHnvN2YXjGW/vV2EbzLscPLT56C+9s2XAuAETffFExV3SeeOR8gQRwHsiv3XoggUYzTE/K6GSIKbsKcbiIiIA7ElmqbYMmqWPmXo5ZG4uUBobDLHTRAMOEaABY0xbc+UYhBUCcQt9f+WSoWPekcB7YV+fEwyjoFiPLx9HZpR4kKAMWEYBmCR0BXaqd6CO3o80TCpKskgqOf3kQKudRfHUd2BgfPH4brF0z99eqTeXzHLZyJ/3+nReHb1s8s6oP8wMvKcv9Prxxx8fXrywzz0+jdbsRNQ+I/o0qtqvQr7YiE70X77evuqc1jFS2loYrFgcISC5oBbWRESKAE14oJmgqUMFyLcncIzQiNAxBDWIiTLZVRE+v0t4VqzsKA0gM+hzC06cKYflBE/x/JPzeIzRbo3GL5jYk5Amr9KgkkRbIROgUGqmArhnmszJXljpnzzHl9g7GB/zJNE+RpC2Qz+X4RiJ2+2382ZsNT89P2ESh8Vo3jJfwWFhz2F8leoPHQZx2gdP1goOBLJDj0GHOEDmAtcxbLjB0PJu5ar6STSloow0zK4leaUqDUUMhiFkbpDE4j7CMrZilnZinvJNHgARY9FiEyVavEb2b9ep3g4UVTAjDwkwJlHKibFiwN12HGAkGL1zkdT+AizbLKY1TD4xwOrzQK52a4IjzJ5HwLOZNI3Mg6BmnCMXI7O1jIURQqhG4wNNEAPuOvEz/+7o+c26103iGf3sZ4CvOn748IF+BubnJ9ELn4jy47JdabzHI//+bfJJ6cvXx/LETmVVNIO8qBzWyXAga5BZJvaHSMDEZo5AEkRg9wSjyc9PgSkkwwmhkQaYmEBmgPkooXQnnBanfD3tnEU9Fl8Ae64ByoYeVPCIaQiOwFUSi5mTHWUyRh7Bmg7uI+KgbPvrrfgOpmf4vU9GL+Lv5gPzfkF/HGInwReG62GmfZnZtdVcWsV1cfklQOth99FAQL1yZyHpAQ1jVxzzKvduii50Sy25SuOMRcG0g81Kn0Xi4U/zES5mzuG38NgCoVyrraK3XiC+8WSaWNvftOKeBnMhEVpVHqZcyaExbAuiQJDTnP2TfREDlpIsMeYc5qK4PnQ0cCgFtD/hufRuyJWIqmIUIPVa0R4EiwkhAZuC6kSGdZpjUiANYuBQa+10nNRRF/P729+vXsQ90SmdM/B8Z+Dt23ff/YS0/WwLvz139b1TT3e+P338/PD6pzdDgfVK1MESKCp7i13Hs6EK0y6dAWINmVQ8yU0xFqbQpnZG8qWwuZITBg0hJmiKMVMIKkTB651Q+V2BHtorDGWYGO0Yrylz3Jqn79QmwqJ7v9l7nNnbiCg9TmzTsR2TGYJmx5rdyVdA3FW8qva+MjnOpf226CWeDFb+nupJ6LZtuJjQU3soYC9oj9PgfxK1T4poJ6RUu5c/QYp5A7WyvxuGaIK4lfBCX25oo2rwtx2fkVYZXIsCxelqlRYtjV6pYZ5Io/MwhwdP6qY1SV4ikj8lBL64OgpfE2o+AzXeoJl4YOR5dHgQ3TiVjuVv57I8BzkLZkUE54Qd+dmSY80lVr8zczcGxiAyqFM1jqzqMH/KzsbWlOLbYNgWSxoMSURM4oQCAbi5QFiD06IJMQWolesN9QBiQYiGRwR+Ajm/WTfPyan9uWfge/wuKV8NtSuiz3327S3G/Jlc/j3Uv/w3vuKMhUja46UqWZLCkMEgce2OfcRgkCAGkIuCM7CbXSICLohuOjSlu09XNTtOidsK7riiGsNwzCP87Nmqu7EgHkJkPyYjG4RLSUFQFpBYk1LCYRxYYYAArAtbPkflrT/GSJl68gLv1glKPNGJaR5ZRq1cz1a9K3URB88DODdi4snpDJZ4rq1tlmTPvpM31ajbdHWXTbFcx06uvVJX/cVnSFdLXk0RcER9R3ZK1BJcl8OLvI4n9D0VNUNMNOwJYzBDYoghhlAzWBoZLZLG9mfh09Fohkdz4DPWKcnNHV78kdzohetJD7ItvtEHnuIEkKmlJr9j04U3JrFsNKpolnXS1oOUZEG6SLMqfErqp5DkQACEZowqE1S3zSLNSaOJgaMwidfSniejYbJO8ZwBmoHH/F3SdvJmX1Zkj8rnuRm4F766y18QxTJu0hbdyWLkK1LqNikcGQ1BDiL4O15XPZdh2TJSkFWhctKpgIgbmZjRELXXch4ZjRHUJAzsMJiAqEkqw03cagbKhD1ajhOsBWzz73s54TbXUBIMEEJJFZfi8oDSWjtVHCC5Qj1Bce+OdBRvdOkYy4xro88M4Rfyz7o3npU5WqvMH0GCX63tirlYrYtxW32mOdK6bX5ijsFW9LiVJ3IdkfUtu0P6IxxzrNLeh51YL+DHBmmzSbUHnpsVmgs7RLsA5tLRB89+UthAN+bJZYi53ZFDfQiFYLDBMBAqhQWEMXiCGAAuIg0E9yWJiAJXEBPKlIGtXAyUJQ9GEUZiU0LjtTGARNyrK+PHxH18y0NWEeqsbO3jch7WCNX+3EVzUjMyZKzNrT3RiBXLpKiWk5wijBWwZRLKJdDtG/3Uy4cmnvfnDJwzIDPAJ1P3/l1S/rwqvyWXc61cSXjKm4brbz+b052IatFfPn99ePXmJWlxjQorUxCtz2yyOLe6RBGk+Ocn9Tqm2ZgwPGelOA7MBlEt29ZbDgXDdxrf0XDWm92M2+pyYvKYk4xBdIhIzdOmYWSBxfpRojlfoBeQnjQLEdgCaC5mNGls6BJ36pwsejgovGtolUNwtD9LXWG/MepY7wpnxBvHdCzyTbEzRzzhuZBvq6/ZvMzKubn9wp5SHTRH1iO2T8Fr+0KKPaBscR+guQhKJ6TW4kXxYxDR3ZbRCS/l9QnmclkzTt/AYyO3s2jGCaHVMp+3vv5hHmaGwR5KyKTBsS4aRZkmGIMIcouVnQUK3CRQlAZW8Q3JnjEYFhGgKbnzsmHOrXAawDAKCnJOhuxyxsV3A490mmU2pL14N3nBMiRigxo7X1Zb33gtPDibaMUER5G+N9mBrkW7v+Xj0j7Rz72ct3MGzhnIM3Cv3yXlK4h/pC8Q43niK8pbt6/f+KSbT0ixwtVwW95oeTKRgb5+kVUd7bQzouBSIftywrb+Oe/gFYP8NIa5hM45JXZGYBWbv4tNlKVixmq0Goy8wkxsHGLhCoHKglJewNxCKVBfDgh5kKEsasg1GMqw3MZ2CiEI7dWEahUqv0vYVY4YNGtHUkRgcUIU3cvyrXiKhFsv0BTwm5tukj8cM2Ib3GnOsO1DTp6Ue+flHPlLjdhy9KbVo4mj8QOemAJZEAfkzICJY0BUhPoSxlmmmV2TytDy2WcsxuwEYhxtfI3KNbu1SEanIgMhGQYbhQo5MgRMAwdPkcfi1YUHwiQXJxNC495lDzkbZ4tUszZpNrBBaDhR/c6CQ69JDDlHMVEPnIzXavIwEollBFkvfcB+XotY57SI6TgUE/bFaRBmYAPRukk9MToaQm6Isn9RDUOLFEh//LujdtK6kfx0nTPwp5sBflzwFcxX1z+zy2OMufhk9I/weOOrunyF1z4jurdz8Ld4v37TvmoXa1MVtOc0v6x7vvi5WtiGtY8TE07+yGmcsR7QQIjeIHt8RQMgOf1EzTlTjCruRXQT4GAgK2qwxZ0tibCFNRiC1YhoFzS2okDQhpAyJOUmjEPmxEoKUpqQAC3cXIlMjKVnhCXLjRU7AMUx4Y35r6S7ycngFTXsb6EF8nD8C77vMN+2a97rt2C5t1e8sFmiham5L4Qm/tJasKFChcJ1KWHgWRc1WR7WwosdrO8pt0JaNlCeyraWXqhscWlMOTDlSkrCpZpFSZaEdUX5aCiZlaJ/gymYhzyNaOAK/XlukjKRuFKsKMmSwl0hTIAF0SGFhPTsgwJBI45z9wxF6lhuco+15/wM7jEpnyjN0uOGwDIzxSqhDkB9oQPk4pUY+E/hnIE/6wzwCST/BMwbOpG65GCMTzz5v528tbfmPve55F7Kz4jerDFd4fIwsPfrGMPlZKzdkabHP+FjrEYyrKEcy06/MyhGdlVxEqTFyAlnUbe6weVMo4dBdZ7eMUWFPNoSQ4tUYCAhuqMMTGIdFcRAGDHHLTH7AWIKi5G7eQWcI/wQ0vNmxC7rFOCME8js2GoCT2YvPJlvofBaJrXfMceszpvk1Xnl7Yht8B16sR5v0pOR9SP1dYPXUXvWIzpNc/tbDvKNwiGsOQFvtMe/eX7OfbSG3I9WrySZy/Nke+yYTtlASHaRo2GHQ4IbJkbFDPPcDZX8oiRLpAoyYSIsNcFtUDVdL1ZfDANhRwd7xwv7VUJLNtbRFTGpX1J3vlZOF0/GMYcXbvMx5zNs5uW4Oa96AiCIRtg2jWllL+bkkRg6kk5VPrKiKQhCxL8ReM3zX6zmlM8Z+KPNAF8B5M+SHv1d0vb5UP48ZTspfe7zwgej7S3M9WdEb9efrk95mNJjNRPBNF8X+/VwRiQ4WSY1wqh8BQ2hitEhOCC2p0eQwM5CKlU8bAlkQRS33k3METKXbZEfk0vMNdypSyZKhnlJ655tQnhJsDa3ufeLZB7hLS85z9hRyQxw+6mZZrqBQyYh9yT7SZjkNkcZc4PMieImObRmqd/Y73IMa+Tb4z1nzF48fcV7W9x/U/Pb9S16iVFJL+VuG9fSsWacl19RNbbLRsvfoo/2hQ0LobXEbAMX7ZSDraXFfaTRFQk+EcKDcY9LlrREmKncFZiCGNETc1qBe4zwc70itGyCEZOjixeRQ2rDebXmhCXwmy+PxkHWIDImq0yULXiGyck4VG6eGgCyE4fSdGwaFa0xTqdKUXHezBS52RaZHBOksL9U+JydEN5QIIni2FhVQ+KFAkEI+WoHn5Cet3MGzhmoZ4BPxPhK6erN3sbaPexXw58kbuUzonuF82+R/vzXHjWuZRHBXl8O89rFuNJ3xcQjQxJyjdVaG2uGTEC5YupFRlf3xJFZkR4RTcjHz4bKsTorXeR91b6C+KRoVbaNdUkdYCiDxct3XMRQSBXCoAVODt2GFeT73EXQ7Ux5B7med4dvmJ7w2LNNMWB2OKuihYu4heuCeONMNV3BY3zXjPfaU+xklGtrV0jDFghirt1mJlsXHk/EyGe8k/iOTlTUAEFRQnOAqCK/2JZ7OFJFagMKCbTDjjwtz2jPhUea5oGF1MZhEXtcaePMwKA3wUbKEsSWs+Vnc0knD6zm6d+GazVXY+IqFhKOSaXgrVDOZhztRRjT3J8kI+sa6VRKyl0Ql9G9iIGJsVa0FwsXUGczxtYgI2FBWrFIGYmpzglrwNYikJ4xpk9WYJsgxSRbSCH2IVoMgxUcXz59kbffwXAK5wycMzDMAF8hffnyRXmVlE9Y+dbeynrvq4dDaXcxcE/8396a+1mu8l6b6BtdKcaLi0TWr12b/Azunn/GVY35nSWIbpxI4BqEyzmRigtpT5AswLwlTGtPDlfACmFkFxffaZhHj9inY9loSIuUPg41s80JL4Sjs2HF1ATmrVjriApZ2O5wgoV6VrkDDrFFqYNJ11Cz8xxJfOBjn8ydYiu/xWMMvDbvh+oC0X2E2A9nQG1d30ey87ptc1P8DukRqgqr09jPJmXs1ufYTkUUbETW/oLtqJgJrLx1Fo2wwDaD03DfUAqx9BYvDTUFpilbcwychheC6uTWADYSMCQLogHKUfIyOAtkaHw1T/OBUGLRgZBFTXC9QYlLfn4AxAc6E6T4pAh9vGucOcGQRwwZEzny+6O79LmYFNYU4g0Jg9jcWv5lJ+x1zUOOoqplE8ggxHZ2adLWgQIhxBO/p6Cro1+SHoCneM7AOQNhBvgq4Zs3b+jElL8ptt3aZ0Pb23JZfu43PpjhPrhXfqvxLXuSL3O6aoLyeoZlTARomkF1M0tojrdSYE0YCrRYAgbRwjbHzMlQWDbjLnWiPhH0gBRpW245ogm7KGImSVGxCNASurYmyJWtW5VLmSix4bsaFuc/ZZlRGXUCs3EwGPJxRj5+u+JERorUY0DjwRSYPXQSr8QF82ViV/fKTEptRV1bBYC3y7cVcy8faqkShL6wDSoc2YSn68fm5uBnSFuqkHuS0s1+EkplbHbkMaPUYlt41+62GqiYg8DtL9ijqGSbGG2Dod5cJBFZmXS9cULYhwg3pGkSJVmIM7NkzXlc8vxs28Mj2yi0aMqfOZw/2nM4NCmr7Y9m03inEYzfBYeEaFzYqY1J93YPDRs81tYAHOXWrAWKqWixLbtpjRLaJFr9BhOKxtMCmgwL/BZAqCByjKsahWBjdIRYOrWh6nuGzuHBE0RhQt3Om8qCXzP08TEv7Xdf6OCTD0LP2zkD5wxszwD/TAu/HZdPSHn8/PmLPHb+KI+fdhLKX1jU+tqejePetE7thAOL9WwrgNYvXcKmKxk5/BtumQsZLFQ5pgxbBYjPGY0+WXbjbwVAVgiX9YSolbkLxSMthODcFS8KCqx9PLoImFFEFAnLT4eBWuI3jl/7jMjXOy7Vw7HbQLHc0BC5aVhd94Zet2rdzHidE3XcIj/NqW3+tu3BvlQk0Au1ALvEnEEHT0g5lb+aZQ1mykJjYNr5Q2QtFiRu2mq4VejYLJGX6pBSgsNLUGaGwe/eZnIPIBAI2/5gaUJpDEk2OCW93AmVS12KPZVTaHCZLRmT0gIpdszdjL1dorsdF4zN2arVhaePtxU22hHPxrQvKVUbtMgYaY7ZyMyOzxrHaGYUkHkqs7NFLFnVEf2IZyN2TFgt5EBfQhQTB9l5xdipATiIDiX+9pcxnHZ6yzUlqCjJUrC0+K+0v3za+e3AIvg0nTPwp5wBPgB79+73Q58nfQ4TxVcu+Uroxzv/FjE/PX2hk92Xr/wKcz8/si7OnusCOK9wFKULqn3Uo61wIYBFLLoQOoCyZnJ/zlA0ojvBwsQsilo6XJf0pqqk2srnxfl0WOGzSsA3A9zKfq9E27ziNcjeXExa9c1tb5dkoJGOQZekGdi6x8mYRS17OD1uRPweHsA1Yei1z9fR3PTKa8d9M5XmaNgeB8gxJ91cDJxXbotXIDRBM6OAoWgCMpYKs5AEGYwCVgix7vIntlKZ11bCOyPV09WY1b7A7I1ka3UQqv1JaGJjgmRo7Nu8gSwWM/BEg8rRFGOncstV1hN2TKH1O7C5KSSWOH+1poG9pz5XiGxQJ0WeY4Ln4rg+X+Nia84MbRRaiNw3boaMvGTVE2lQhMg1sfFH7JiHvbU1xkkNfgcXamMh0LhIDuqDW8k2UIgAHtYGxYOdg4Gj3UNpn6GD0PMLjXiezts5A2szwCdu/P/ixYu1gCeK4pNr/ueT0K9f21uOH6VUzWu5ZD3yO1kD2+/yMaKtVrym2bqV1zdjiSMh2180lvLIqRYZfO3sg60GvN7JVUtMize/xSUcGwPWMG3sI6O3cUdLlOGdcpfoZkRwxFwmL6WfUlf9X1occ3HsdvxQLxl8e7VCq6qsBbCPgkGKsWIEQYFvpiFKjv1sd9qPnxJHx5UnQJHqEvmeJ6M2f7K+cHHfuddqfqxG+HQbQ+8E2eobfbwCIYSOYaZukM5CxM4VUS7bHY+m3eQWpzLmYTfM6hEgK2KIViJsf9tcFCJRwDZDZNomCN6wcbWd4OzEATAYuoAr1WL7o0cR+M4modUyVmR+QaIg8JgFfGZYHWt+q8vqqfN5DvjRM/O2aONwNPtUG+oGE/Z/QZrZ4pwMVM1EQMGGHAHrohKFwVLYfi0uv0OohmgP0LwnQwohWMXaTNlm8DwSRmFtoDySiq4XJHuO+kxvQTxv5wycM7A+A3wS95xPSLl++w1R62W9+2uRNHff6GT+oV0hlaXJ7zI5r1+6dvFixk8PsqRFVPec4VQItOU5koFh4IOHBeLQM5OOLaH2FI9V5GAYG6vrWrjyBm5lqIlkHgG1BpIhKYbYHBEBYRN+wDlpYpdhvxAgKMUlWdrhC1h2K3LAJTEcbVXmeLHqYyF7POOShOOxJfQSaKhnloPrn/mWMq2DbBbtmHM90pHS1yPV61mPS69ik9b4uFEi8eCNzoncxQQ1iCFWK8lD8PciAa14cgWxB5Y6akgCczamgW9iRzhnIaXpyVrmnxo5lMtodDVMa6mdo3XohSEdR8Sk6kVJFknQWxpdZBnraBaK1GAeeh4xBJogzgibvdw+FK0ExoN8IkBrdXS2tiFapMVrsubqKpJwAdLdwIVSQNGFBzVkC6IBmHo0S0LJy5JqFpINITiIilX20aF+dji7wLp9yZOuSc4W8GL8gd6u+ykYT/GcgXMG9maAT+Lsc6T3fDV/r45L/PwZUf4cLJ9Qf48br2d0PkrHnXlVgqbrktemCyUNKrmLJcaTw8PABBzHyXllu1O7sgXSICLWBOc3Sx7HrOQfjINBScguLq9pQIphsEo8rDKnzrHVDwf2/nRVEArYtdZ6AApCjXsc634RguA7n66d0hg48sbjMnAWuB3yJXfLPtawFLwC6h6TKyF7GFS7wr2C2Uu44UctAdM/BoJrV5Q9wo7N7lz7rJiqpx7rV0iDp96dGWCU3dR0qlAZFLyDAZ4mKAkNFV0GO9bs+zGG9C5gwQZqyfs3lNoJ23IOtApBU411o4aM6M1zHbXPIdEjFdGOmXoRjtY7Y1H1KEQqyIlLrBt9CieIwQELBLggsGvMZe6cc4ojkv7d9CmlKNFCTO3PErUqcjrxxSg3DNbAw+JAvtFjF7qhDlnFMFhpMrwR86pF2clqji7fxFzUn3uM/D2H+GBUQYx0peS8QtptgVM9Z2BlBuIjbgX/fTF8RfQDfVacT6a//21SgyxNtlApJg9F6YS3kOBNJlGSxZFs1hxBdH+UBBfAIbFaIxq8bnTUpJoGhROCU6iUPKLwnfMzLGKyR0l2h8iwDQY/hDl+YB0M89h9zz6ZIPiOal0otwHTbO5VscbqLPs1M3aLdY3BMw7SwWPeIX5isJrxFlnD3Smf0duIeZnkg98CbOzWSevD3DbCHvCJc5LX4q8ZkWcnB77UCAGctVKkidYSGtuqcAC5IdK7dYuMfYoMAUHcCy5a0iq4L/ofuHSjDfYuE3oZhVZzIAhixxJVRRVgNuU00EAACwsUUNAIVt2IE2YE7+cp5ywk7PMG6laYdyI1AA8hlJZEBUxwEzMxUAXtL7G1MnJ1ceJGPrK0PwntI2u+nBIEwTzmCc4LxMgnNYqh2M8XudGnCNBCtE4KWdgb8/vEN2sVLUQWZGNg+XheHQ1zfYrnDKzPAH8L7evX9BbKnYOBdcbbI+2zrnxV9MuX73NFdOiK1qEvn3MtvnaptHmcQARYy4hdQpyB80ErfF4PUCFg8h0eHhTZk/WoElsYYtWZvxGYUV6zxYtFFLMoDFAWur4ClFkDraiFQe23Gfr0tj1RMqdJymre/SAgqIihjjINoxBVIuCFUMI2jCuVbJPvV7mR/hHWsKFDfYxzVdLZnWpAXsp3aK2O9XAs1Qkuq5mL51vENsvj3S/kfsWNt0mmuqiL2EiqlMnChkm+g8o0B3hyIft4BIog/bAUBa1duPyOQJ5rKw+owJssgaexbHExRX3TqD5YU3lGlxIP9YinT3CQEGgRKQK0Aw8050u5RSE+peTB2QPSjKgP5QWQiZ4rwM2Z9kfzG72AFh4AbfNbtFPPJXq8UBLkgcARrChXHuZ06gmRu9ijgFYK3WtNFm9qaoGdMEDwUAmySGOKY/R5fEN016bFHTAianweHj7d+Rs1YwenfM7AH20G+G27T/GLjeJnRLnGp3SrPrOK1Q3HQnmhgr9rJKxynYdUODMXA2d87EMYK3wTw2BtvuI+IaMyllFEZxOHRIrsbVqjpfvIr3JEsCxcIISA2IZnnBLkAHNjnLpTfsDXhFCWBMS+dhk8sdeWCR2xS0YARuf4PgpeCD3iFvo++T6iqGPlWK4Iu6VJ6n6kOm717pA0149Uez/nqYbe2elyhVR2/OneHxzK3AZLE/xBtDyFyVyTkSI06EisVeOPSbY0ruG6UDw5nVTBZnBCiZZc5JFa5ymVP6aZg9VjPVbA5jNP2x9HcrEks8eVfeHJWJlXdvQeE/IFkQhjbvKosw3RR9DAmTms43Ec+1HL6PDgkIeNDEW+qPTzoriRmqKFgDzByaagknaLW87BjJYDPVgaGCCYpxuVwYjUa6pHk0WUZBG0WCTAonKKaOWrJ1/obXzn7ZyBcwYumwE+2Xv9+vVlwXeK+t6fEV1pa/vzq7pK0RDXq54Xqx+D0mdDNW4ruCcLuoVt8Qf4IFq8OJIyQKcG5O6eIzmAfSMtWTUo/uRNmQDBJCCRMbeIDFGtqEU8AJfZcooISbmjo5YNvpXOMJmBI6InMkS7RZmffZXfcG00tG2UIWIw5Ph9bZ9gH1FkKbZngbqrCXXzMd4TqGe1WWxzDgjHp+iH7Y/Rz2IO+VKjVDQXuHRrUakxiwvGJppBM+XBonQkLC/a9MdRDLXoDthUOE1osfkktNk4gPm2bsbiSWGhMI3OwxbdnXy5gHlPVHssn6qBKgI07Y2Y2l+uW3fkPo9Hm8ctTGBWISOO7M0popbiooMZlGSVK4Vrc5mfmMIDNeNNswjPahZBJMVibFTnBDMxW7C1C10ElKFCqH/kI4w+noxEosDB1qQYrBjrXiznwDImAqfFwLAh8KuFocUN5Ok6Z+CcgWoGntLVx6f1GdFqttwm7yDjdSwsWC7qikeDnVwhUl1NTwogtxK8nrbUo1ikhXCrlMIDVghOX5jcCYlQ8scdrEUgtBNydJqRDjlXY1RCTR0NlXNrpPQVWUpUBBTyVkwsimXGRhvTbcUXaAvfDmPi4rYftI+oaC+KKoiuM9nUCIsejAyVLZ50XVfJWnSq7TvWJXUcyF9+qdFayw2VNpQFDsbBYMjJSG3ojKaJLdHKrTvJmIks7W+IHrjF0Ftz8Mg/0N7JoJnzsJsL3YyCxi70p7FtANFu7h6wNHfhzKPCI3u3k7uds5rWn8iwfXyP/ZFXiBpD3xnT5mqzVuBhUiQPUrbV3gAwswoXBDISwlQVOSbfCGCY7JiZh6c2hAVyFpk2UYuSLAi9VOBv1/3GX3d53s4ZOGfg4hn4/PnTw6tX3+cq6ZP8jOjGTHK9Hz98IMS3h7/9y982kOaiNW9j2Zu5wnJqRFeNkc++ry49R2wVKZkjg5VSV2/rvzxZVFd+LRyjcpcpwAa0CZIdd1WwIW2s6zXvrceyos4oL1igLAipFLZ2Yck/Kj1Pr48Ru5YbUMxyxN6W0nTHeDPee9pTnUfq2TgeFM4jXJc2+Bg5Lq1tEiefIR0eBnHPCYETc0D0okbkoQdBTxufrTCYQERLXAyyGBrbn+QxKxTlYz2I4u7v5n715KEPR0WF0GEz0TxvDkNvo6BAZqL/TJ9JCg2f/NvkbdQcvl/vVg3u2zxR5Ad8eMBJTrY1oajBfFSg9IFmuGS5JUtUhNNQvmclc6iFkS085CRbwoNOE4V8QRQU4pKgCmwgbIKQZKakRaXgYPdoJmuIe9GlFDX4e4KRryIwG6ERAMGc53jOwDkDB2eAr5I+9gnpU/6MaDV9ciL68ePD+3fvHt7//vvDv/3H/1RYW4+2ViJZ+rD+QZD4rbiqjpktsUKBMAvbsbfeDDTWqu9ukjR7uTQ6D0Y9HwmPz4MaSp9ThcrvzOtPRamkpAB7jWCM2tJFVLn8OJ9OZ+cwq3kwX1KgVel8MykhkzKL2LMfIWnd5R4n8TYhlF4Q3THWXlXX+q/K2dUqXNQP+ubeOsy19cZ4yRPmj32Y5TvmjTVcMn+v7MOzKDYypi64IUZhShtS1c6qLAU+eFTMAwoxga9yVexkK3JLlNyx0zg8RbI6hQMGiTi6txAPkG5evAZGjjWM8WzJzahWQ9WamHPSEOdNrnBa4FFujtvmV+82iFgoc0gOcRS0VCIsqbMd4SiU/GJ0j9I03qRoqmEwkHNkCNmDK4gZtqPFryG3jI3YtUQxSZTQSUnRqkTAhDCGVYtc8VbhyBrDR5lyavy3LxS1HjhSnZZzBs4ZkG+v5efSQ9/geMW8PYfPiMb2Prx///Du3e9yZfQrnbz/QK+4vXr1UiG8HvGSNFmIZImUu0hZyPVaFlkTS8drODEnZUwFnsih9VtoiyIAwLR/RGeMDSkAT34NzEOIOiAiwTzGypR6gWcrlHnwAY/lORByHHpBEoSIoCe5nLl6Lg4VIY5tSQmgIA6zKYbBGiK2xMviWoutWDDs9LlVxZ6vtYhMe/B9f79u3LH2WTHY1FrLzXsMiS/lxs++oNhAKmJyJKVHTnQqTbcrXtEZkAowu0xYeDXB7DL2b8NMTnl8YUHNKxWAYxdqGR0rj1fl9T6RyD29qeC1SaIi6I81K6ebncaVjFFp8RY7JGZWcyIMwggXl/k10OJDjWOgWUI+NYVwA8loWWBMuWFVIfOWnPqgH3h7qqm+n6Nxl9mddaMP1AZMkVP6aHaGeTbSQNDSJRUKC87r8Vai+9hifoTDonhxdI/mfsE16qtGSkR/s5XgKuoz+JyBP+EMfP365eHlSzzt32UGntNnRHkC+CT9n//458Pvb99288ELnSx2bl84kOwiutWTvALQVTYvvZKHPeAQGN2JAdbEiZPkCYYPg9bXUCLxNN63SnB1uQZg6EFaqAABA/cCL7Aq2BS5PWdEzQbYNxjy5iNSQ9AUQcfxq7piNwEWtlOyLtRsjGtxhgaxGOJV3m2eyjtwgjy0ZbaFx5xBMfbHIwc4UC9zHIhD7l7QWrhn4b4FZ5/joI4eD8atwK/hvvKZSXerrb2LO0gVJiX0RyS7dA3j23PGFWiTuJIjBZCyU5SUMNaRLFFROjap2CUkj+JjWAeaqMXJengwWBB4uQAo5m0jahMBWgZNNcJ3IZ2KyCG9GAYr8EIcyIIYMCzijcbZXlErychFYHt2IKeFRlyUc6KgSWyHVDK8riluvqP/AA1iIGyiUPidGK1GKEogedTZhpiHTi5DYBCJBgQtKd+LKR/i5BiHXizZg5z3Xy3hYq4z8JyBcwbkxIt/4/OlXfS74Zw8t8+Icuuf6K25H+hzom9//fWB6++XmRcPLx7e/PSG1p/gkYVuXO2SJWFo5dXwwELZNYIGf2kvsSxtnRTBCSyZ8ZMp5y2LkVwSbllt/TWdRsmFhBB6BFprDjzDKa6KCxR3EHP/lCAYWjVqSKWZEsCpNvMn46aCCAi5llmwwP1uBjtgjwWshtk8eKxY9C6X5xhmt8i9TIgq9r292MF/BUeqlx77qMuSrHKHdYM52xwNbMb6aCMqWO3jksou5J6ckOomCVsmiEvloWmg2UIsupFKvnIDGgHH039H3KkGnjwIOL5l5qGsQRjU0wNSsqQgrwktlO5Z6HhMTQyiJItQ9RaLtTxtJGv7y2bWdMfoecQ1omGp88DdCTn5LHaoQQyDNXCv8XLAwHKQOyTtRCaiOnRgp+Wq+jRfRzKqaK1ngWOMYYskaFkkku78gKbb1XpqZWRzX6evH4OnRfVm4dAEXZ5OJSRZamjj7u4lla4FX2nk//N2zsA5A9fPgJx40ePpVm/b5auLfEX08+cv9Jbgp/U7orPZ4jrf0dXQd2/fbf6cFM/Rq1f0QwSRiBSst7JQtYWxx7QFL1iDGOlEDjzR15jVMsGwd8SRUfONaRVdHAC154DEpsk1R6qBmDvyTkUsCx7KqI0cKSooQwgbQsYgWlRvKikEPHiUQhnykH2WjEZh8bvgiT4yl3wJPioSo4Hk9TSz2keKPcvAxAakJAUACHuUh/xI1T3fI5sfpBzivRaMuoyoq8/MW6P08J3qL+u6Uy3X9lmckNL0t7+yj5kRO40B0LCR5SsqDbadi7zt/FHIRTN2jGytb8ETxBrbW7WboamMM/cKfYVhm3HIA19OlmGRZB5Hkipus3qiJccbAlYRoJl7GPGka55pbgUwpWKm7HBAMPYwEklsx2kDJosDmxh6a91AlyoTcyEdoFMF32cKzxYdH6vOyXEjH1kHwoImmEYOdnqeAG0i8Q+v+ynJsN2HWqJB5WiiDE31/JIrQfuKO4JQML8dbe4NwFM8Z+Ccgd0Z4BPIW32O9Ll9RpT7fvvbb/TW3HcPn+gbh4vFN88fLTwv8RlSW9cUsrso6RqXh8xvVIJRoPA2crUIqr2Obpic3HBiVcVsZcLG2DU0IlMWHM8xzupwcYzOFolAGAQCeRa15kDTBqcbnMHAjTbbsxaQG6LGyEDPQ5TSs+awXXYDKMGMJ7PuaEJCd8ZdwjedKWKoqTMUh6cpnpU+W0cx4A8ZjpwIpv31UJabg2VOnkg996yl3/aXTGRxQsq07SBwtjMNiZOhxctDVwlqHrKqI4VbF8mYFKlPYIE4iMZwszFlF8UsLet8oSJceyYJD1SLXSmP+NtfALuhZe8WgcmqwVjJLEEWqbRDSWyIRsKz6oMG2qDYGGKuQ2OuK2tzIsMhvRjM2uKyNucqJtx20xSEXGyFAiFhXVmromRJRlaUKw+eiovSfc+g4kw8Aa7iUKEaPGxAJJJtr0Ebm3OSfaJ8eyILuVV+jucMPOcZsLfWvnhRfkf2UmvP8TOi/IVF//l//g+WzaVGBVR89EPWqrRgFXTql0FfVJstjokqKeCNoXufGUUQBI2OJOyTVGO+ZCkxASFiI7anG6QFDAJctxT6toQ7GFt2MohQ1xKtITSUSYj2RzZCMAhBEAK+ieKZuwf8iiHRJaWKrrupkG6rSYWJ7vCitcAy9ki2HOnZbyI9kZPXNkV37XR5uh6liiuP14oTUupPK2/D0TZolwx7ZRC7iSPeo9TCoIxz4i7P9Sqn4lIlpd8tEo9NjpZGlVsirf3lPAEEHggMTUqKDaHJHrdXc0yROW6ipQqgqBAWijGLYviZjf4QGvKMMe7c8jmqkjQyEAQxBaSaREmWhG3KGvfAAgOEjpvtXqWh3MJwtZozMBSm4I3MzZx5E7RTAjKIVgpqoihzSy2soCjzPDx8pc+88UH0eTtn4JyB28wAXyk8crOrqvw45Kui/DnU53Djt+by50T5qih/VhQLzmLxfNL+008/OlrWJyxSbt+VNOaS0I4bFBAigLZrt2k7NYL13WeMKMnUHH1bbJEmxqSUosy8O+wj0aIFvCTIyZQUkKsApuQMXhMLjhgKdgjRm2fcKDOi1kAHocZdZ7WK6iTm5X3N59My1jHmjSN4olHldZYimE1XnhhNWA+ZpYcnUIdMh1V+p3qu3l5an/zsC8jaDJILFmtDRrbOdyLytL8Us6JYtjl3ZFG0DBpBwzGOyLcmyxuOPd00yOpoBUFL+LpPsi7w8wMNrKOQ8oDQrF3iTjUUjWMhhkVKQ4shWw0rECgs0D90I2imxMBKwcsRCecUnRSS1GLA1zUNeWCAEDiiOPKFEgAcWMQwWIFvwuNxcyVV3V1BhRp6CGIBhAl5ILCr9frtG33ZyMEDaBCfwjkD5wwMM8DftPvt26ulz5HySR1fEeWT0edyIsoN82+I8udEP378RC9qxc+2+iIjEt/ROuVLlUuv37xucwcThGZ/pPuUFQoEqkJ7ysNmdRLdHZyCsTmVl0gP8Lak4WMW4PJylM4NEwn1VP7kNMWYTa8C92yL/UoqyxcPV1pueCDs5W3+svLSyPipYy3ZgIrF7nMLYoBFjiFBMAyBwdd2uW1EgrvS7dPuOKV7naRjO10793ScJ1dIeRcSUtmX6G5C3HY1um+CbOEg7m5xFM5IUfjO+VTb5bkUkPIzSW/wUnIKPSDe6hVUIkDLPKKNSbZ4jSAx7uYoo0K/LaNeiDRwGDkBYULScBoccDPRe8y9qZaNlAdvAmmE6u+ss2SpzqbEwj2ndtXxkDXAO+eg1hwM8zxBS/FDGjEM1hQTHx/m6KeP7QPLKjcHd4SdyojDt6EeZuiNlKjMFU5Av31tn3k7XMAZcM7AOQPlDKycWPJJKL8QxCd0z+kFIb4i+it9a+5HuiIq76xIC0xT5D7Z4zSxoy1Ur17rCam4i8XLwqZcRtXHWuD2mKKgQKBgTRzyB7EkR3R3jJftzEL/gSyIJe/UyIF4Ly+yTOHRsZkzOZsCdskHLVL6UxC7KSzRCJIcGirHHwGTGOdKyndU6euRNGa8ICeHWPh+LYZOicowQezDiti1oDVUQf9ETG1+nk4Xsg/ocVWqqlsHvvf0vdr/tj1qRffo9R27bivFi5IsddCmVacWC97K2pc2R2OfnXBO7GAQARoqNctWd1s+IzIeWyCxUhoAY8fWqYCRsOGKMJKRHfbRojAizbyE1LNdjnGfaiUR0kDwOJhqIQGTUuMLa1kSjCYQN/0FLTCpNfQNpwUgEp6JoD10rXTqJFbNDB6emGtejjjErSn6AW2yAwqEAKds04TucCmEnuI5A+cMXDUDfIL56dPHhzdvwttRlZFP4vhk9NOndkJ6VaJHDOae/vP//OfDR/qs6Hxx4bVIr95hWYKQqyXzCz5YKw/Y8vq1tU61QxNFIBWEnDNoCSFKskgfAlfqrRoYh+iCy01ApSnc45Y6wl1g0cTJEpC3FVEnCXgx25uTZBGzn52CaQMeezF+n/UIguu9ZvbQ725SQ+5n66Z0l9kB+9yMXUM561OT2vw8zS6sKtva9GrjMH2GgaNcA+H1Qznluqh/jX1lyceyLCEhwkH2HGf4e4x7Wa0Lyh3EeSXKR8OUOWwoofS7RIt08DfSkXdmT3S5fHBmTNMan3nGfOapxoAOYkuOjlIgrEnwYDMnixhpQXcjcRoy0Q9KCkle8qizwqyxcxkZaVywQuDknjOWwhCLcztZU6x7WKpcJUfHPGIyb++XPGLMnqxljku0oR8xDFanDo+rsRayBCNYgs2JTumcgXMGLp2BeNWTZf5vV0Of11tzP9NnWvnzob/+8xf6eSj6bOvSWoGVxaePTG5t0l/+9hfYMm0E+/ObYZxH6ZMhKZ6/grJN4DFGs+Rh4IkGRHfPeU5tCCK1JpSgUyNtKRuTOD1Bia2MFn80b89l8XhBYKhFEQZUgk6F1cOtwpxxsA4GwtfkmajXBp7B0EeobslW8IxdwRW74yT7aD7APwavW8LxhQR1+/w60WVI6fKRc25VilnvaoJ9Kzj6+nk1X8fLZtnzFI88EVdw2d76ygTjz2PwtpkudtuAQTWZJWodOrpUVgQNe1g0y0goEJzPKYt8ZmJQiA0TCKsI0AgfiEmUz5kaHUZxQIvRMV3KDfSWQExGRhuYRa0mBIX6Cr+Fh4CpCG4I+sUW0ItQSxDmskCVJgvNTkr2jTy1M0C1KB4SNikB7yLa4QdN+3NnkjK5MPudIFM2VkCeiCYKBQSCIHb4QBrEDgR1uwwi2OKQIrwSl4i+8yFhMYnzFESSSKkcLqlYwJz/lM4ZOGfg6Azw74b+SBdIn+tnRPkq7jv9siJ+m67d0tqSFELo2oKrZxKkRl5nWBe1Bb5+82ZzOZRwDgBvs9i9mk0Fzg29NER0AG1Ih845qMLmd/AjizwvM9nIu5hi5GSLJ4C/EkYYLE5RBV5lC50FkSk7NWVhH05u2SOler1D7GBIdIPiTOraN2xytCPCATIxDMkGHBAQBsiGYS1oDdWlueDYsmO4mSr137qeeOxzDTfzXBM/iU3bbIJJExz6qR4i9BlSMqunB6RkzIpLXQqPIXEAAEAASURBVNETZcak9IOCrywnT5+vB5dUMELow4i4MY/8ZFGj+YTF7xIXMvT+MKkcYFwpGAoFgwjGGwote66BtGAIopfS9xQqYleMcdec1zGhXSY53HuduSpoXqcm7XJ3aix5pC/L0P6FKLNJqxJDd/rAFNWyJMWMcewBmT8isxxwQcwY0ygH/RmszygefoxHh4Atwnico5F1/vD4iFQeHa1drIOkDvkcWLSd8jkD5wzcZAZ+py/++frMPqPNX1D06y+/0lXR9w+f6W3F7WZriB+Gywpj5g6VJ8/WIgWbSqBXr18tvRiW0ojSLIGqpSTDiGVXsjZsea84HIdR5JDE6EZOWESAltb7iq4sJRjBNAoBlcURCksG3lwLeYLIk5DUTrt5GR2hzXuuwUC11bw2GofpcRwYzLAVtEkQnVuyJdrCrD8Ctlm+n1e6XDkhO1JiOI46EhaxafMGvrRVrqib+Q/1HnJJHNUUa6Rv2Y3lb8joAAKBQ3AQN1hixASm/DHNBMlmhq2lJlQACj1yQJBM7jM7x7bgQCHYdqdWc1qYswXsLURK1KVMrFaHGn0fSIWJt+q13ie2cyZmKBBSeU1xvt7Zld+7C50j6lywjoLzUMPmRm6dtPgCiuRgoIFdcK6ppMxIgE04RDT6ABwQZEAN7ExKhVYb4RiqG9iicibFeESTBGwR6qSBLTm+ackWdii2Zxay+A7qxMJ7fqFRmpBTOWfghjPAL/aEh+YNmW9Pxe+S+P3dO/kJl0/0RUv1zVYWX88bzux11LXWvNYxm1tSZlJSZYA1IWH7opIzKEHsQ0wHRARoqc6IRVlmnIyRyRf1ZJ1EhhlCso05GCgHwzTPumONM6FYobLRwnqyg8gqQ6pkl29gGAz98zJRHktR1LBGsIYq6NlkC9jkGGISdVPzVfXvVMKbSfhv3F/a/DaHG7WkHrtahCtw7H8vkSYKMZYanyE1QxrbTCRT/whMjXXIuRqigqgzX4ZhQpJAwTHeImXCaOlXXxsosP0Zqo3CB9Ls09UmpyAt8eYQYbKAGW0OOaB5bg6yNANBt8NEf243Fti4R86ZvbFGhq3t19CNK9Yz5otelhXRAU31/GTJzQkRcCYYn6aBWfVh6ObS8wVkNCrhyKugcAWyCBPSMTbkMlFBjWM/Yh9hxDaNsTq1GcRcRDrwVjbGM5DGFmoERniO5wycM3DOwDgDfNLMv336G31z7off+QuLqtuwCiloY53ZcEkwUfJnSHGbpSDAhiv7CJjeLiw1eCFbPAMRCmuCUzlfgjggmBUrg2e346YArEWkglDjDli9ihA0GNNpvT2phIDb1RNI9bmLLEY/1BXRx2WhNe7d8KPJ94kjo6DZsB82qXQtcA01SRHNxcmNuLvjtxhyK/mqadoqgmq/2fxs5Vnw2b6xUs81H7HiHyNbKMcgVpbpbX8dreoPO8kMk7IzSFbDZBUyxEPY+AyjhWtvplrV0FkAXxIblHzB7eAJr/FfP7bEOXdkDYVJM+gogtrOPPUzR86QNaMigvZnhnLkNHU8wzmXhwXRjVNJGhgWRrVOo3pHy5nrYEysJXGKkiw9JfRuGmGvBeIsaAtTFx4rJVenMrgwKYd6ZgAkb4LAqCnR1IdQFqAkUXNVAy2syEH+SJzgRNxxf6MD0vN2zsA5A3++GeDfEf3w/sPDe/rm3LwOtEVC7sN6ITNEa4svNex0DTNYmOK6w7jXP75Ja5HEIg5CNou2dpcZWkzfijORR50RIxx6J3a/0yW2ZXFzjHb2VamqeTWWcX38NdVwLPiSwpmUOSQIIgPKm/D5XYkRI5Gt8M0Jsgd9QMj+22hW8YEkB6C5xrXANVRmFi0dTBT+72CS2S0OBKXHR6wXc3qrnLGnW3FubB/5HdINf+fSdmXQHZwGVm13TwHcgDbkvShHAu4pxB4SBLEMxCt8yye3TKOsOVXH77W7FCC9cafQ2t0KyL5mC1X6YhzSmyhl+J2aRw7D55Ez9410lgk3m3Pdxkwe3hbqjOw13uJuMXpeY6tyxpoM1wrOniq24YMniOIDBQRPsSx1sUmlhPTHpj51o1cPYiBsZheukjAYgwgyf7DDxDBkFSUEBhEBKvDvkJ63cwbOGfjzzAB/tvXtr7/JldEjJ6I8Q1hjgoSZc2czbSwtr1/R50cR2AQcV9hiK+aetAtSNaFESRZC9e/oijyEVXi7wtrHqhtmCJFEZepKG+v7i+DEoOv5gFcDrvpKUIoEZbKq4jaTQgYTzWUTAMYFIRxzLKDbtFDeWT9W0grXKuaa9lZzOA7Z3FRIglqDzqILezZdTJ9pnocWT+qoYtuPhjkojpuONAi+K3lSzoNcqCH0mfg2FI6Vt+zaBG1g1aXIEBDEOnzSUCw8BtZ8hJ4sLiUPjBBiCpIpS0gUxA63qKY0QQliZmoZ7Qku5+egdnXK7WRTrp4SugjQNB0xtL+cXrSJo6dwJitB586rY0jWNCgNRCzcOS+b9mMT0aKS88xyDO2KYbB2OZUtkAYxYYWJnVlImMuUkDGIVnkwKX339g8D+lYtyiCW9jf6xgSO4QVY+JFEfCkkKR4aJX7rB38L6Hk7Z+CcgT/+DPDbc3/95z/pc6Jvi2bbgiH3/dpBy0xeabLWOdeecIrjFk4L5qQU5QYTYtgmSrKQkcj6nkJ8FsM6XnKFGjUwU1OQxOk7YNRpmL6yRrHoFRjdFXUZg/AlhS3NMOSGAUIrJ9z3nkxNXgXISaY6MwYQZ+1J3XNTCWkg3JS+I1tLIqg1aMfP6lrgGqqgN1N3gpfffmWg+4/oo1grtrIjbgt0gc/26/S9Jwdr20qLuhc5gWfSsM2szirXzs++CFOLmzyYK9LelgqDYgIRb1UIMsLLGVxYkOFbFTzXUsoN2hSvSusoeTYYmqtE6wa3GdolIQBjS67SR8j2Ny4hTKLzTFK6zfgTqK9iI2jDNdYVk9jEBIIgKpJA4UUMC4k0IsMBYYC4gbJ0iTo1U1qgUF/GbxRbY1WD4ZG1qwF2BsYFhhYO5yMUzaHsDgTr7eS0NFeMxOrEmScsYtlxaucMnDPwR5gBftGJPyP6kd6W+8svv8zXAm2WVxz+5S++5dUnaw0xgHb5OY5PjP/69/D50Z4GqSBw2HBLXigQCD+ufbOl0Mgl2u/M7HOBtVyZaLCMmVuteQDfEcH4EcOJ7EkD2eGdCrk+gqF2E4ZM06eOMQnFSrieiB+oa+S6zpK6SMp1vPPotSSCWoMWqdYC11AFvZmwf5vh+42ym3N6Pk55YnVhVsIxVJr7C+rlfuVGnMJ1hMOwGgsupbTaurfsEiwgg6hh+4MRCxIKC8oG0njgu8/bEN3JaM/fpwAtOdofLCsC6AmMsjcC55g6eY9HPhGgIeNoaS7m6bmahyI0aIh11yxYKGrext5P6jbWYm4waqL9fN7k0L+VER17vEVChENg4qRYpoWR4uyJvMhVmErOIbsYsjVx2aJlI7Em/0aWxFrkaaHEFgiDSG4KSiTBm+xlEafxnIFzBp7pDPDvh/LnQ9/RFdH8ToiwBhS9dUcBI0LXDVs+EpsZOSo5SKX17yP9nMzHDx8e/vLX/92WpYjPC9WYVy0IGQVFaOKQP4glr1D5HTBjiuPcIAsCeNlW5A3Qu4qYFxLGt9LmXoFdqsgOqhmcui2jNxGbzpIuGK8KJp69rtf4BbUGDbWbuBa4hjLOMNrJTDA9FRGzH46duLY2nxd3fKg9ZHnEeZK+u54PFV2BqX49ISV6zGwSq7DBhglhDxQTmNvJXRpopgZjEgAUExp/zcu+eT/GgMTJEBV7VU2RdTJxbriQZoZhu2QVAdpuHAC2EfsEsRUBd4ZOdT6uJ5ANIgWG2CYqKGCNrzCZaxjXsV0+KSIUNTCTocQQD9t14LChhgMPeKtg4GDizZtGykDRgUDLK6MtH5wwQICrCc4dUqhrsITtnPkYCYuEFbFd5m0VbPRFJt/o2zV/A/wvf8lXLeA4hXMGzhl4NjPAVyD5bbm/v/1NTkTtWxnLlcOMuiy0oTP2navbUL5AdUAiYz7GfaAT4/dv31E9nx9+/Omnh5/+8jM5NWkXNlMTGgoEzeQD86BGViY3YShqaXYOshzEFgiDOGEezcYkHigQxoBHsqACCNpdHg5VI6F0h2Mc4UaCxKVpkg3KxFkzURQcEEB1XKg4uKDKXrMLch3ekawFrqE6alaL/b5AfXdT6q+vOZz/cKFxd9mM++5dPU4BMgc6Z36FlK1xpjZqSZPIuMYYIogobIRF2hDfPZyQ0IQD/BQiF50sNGUxZdNJoM7fqTJx2iS7xn7JGq585f11ILOiJiP37q4gurGXAqhlC4YeO5QTDINIPO0vsCgoYFvBW69rd/Wo2lkphyfrfUjHjmKDi9mqlGBncMkA2yNyGSwZWFFGGqLraB6j3xojv+DEMFgzxeZjs6hyjy6z306jB8oPL394+Pzxs3D+Sj/9wLf8+BFTd/fDA5+8vnjxorOf6jkD5wzEGeDHUlgOouvmcrsC+eHhH//1Xw9fPsfPhvMC4y/6ygrUL0Osc61aVVuSsjYt2GAFQN4u/JG+yZd+49ROjP/jf/1fD6/fvC7QtanVEnxi6K1aRB5C0CiCoVvw3M4xrI2kGy2PidSSedkIyzTmMRyoAgJlDQ0GcbmcSLXwhLLMG4HTutThJ8KpmkghMnunXAOaDdt8MUSQ6/AQuh60jgz0LHb7fed9VBU9XFJTF5M+40ld8LYVfl6IO+xKk7ZvJN4LeFZy3RujJ6Q8HTwZPkhi3woH6iAenSGbqNVgpOMAKFoU2/SZc51XScDFJLe8ea/GOq9tu5aqxJqLkHzCpU6Oq3FWUR53sYG3ReaIrGXuuZa7yxpHYWluFAoQqyZsAzngm2ebeea1B08QhUfyaVIlZki2sMMsPYEGXTQQZ3ghQ7JYGuFLykKGXFvWLJxzmlyPvbvmqWOPWDnPix/Gk8p63c5VvXtXfTEKlpBUxps3bx5e0bdqrtz4R5/PE92VmTox5wy0GeC3437+9Jk+I/pPenHpYzPawxWLhxtEMjVNYmlMiFWFa/pCn139nU5EP9NotxcvX9DnR/9O6w7l6s/UkR6ChHEL2WJsPGqD6BOWCEoyuESAJhg3mZ2ID3CnRKoYkydgKVkV+fiD92s1Xdev833//rDZaD/bqgu46fQHBItONo1A9xCm0MKxHrSOLNI8ERN6uNVJnvEM6wsyXdR52AvGtYsYB3ar46JstwmSmkId9N3m1EaztgxD1UUjWkuaANRHBHrCBKpRAHou0GdMJUHMQnL7K8OQxrwwQDDPBeOYOFa2R5gqgAJBw8ccNS/FhdAgOk8M3Cm0cle2/gm6x6COUUA1cJGljwcIAqE1IMaZu7KZj8eRnyxqzL7AFMTI1cspXpRk6eFX6FoQDUNp4YHcEmgNeQi5jYsA9CfaQMrw0hh4TAw8atLUBrhupP5evnpJ76cbafq1HBt2hJIlVpV74yn89OmjfLFKHxqn1/LxyaifvDZe843xPzzwye55O2fgzzgDfMWR3wrLb8/lz2XaFchxLuLjk735MSp4MjVr4UuEzuUSAVThtwvzFyhxPfy4N26j+Ovf/vbw17/91dQ8glAFlNK9oCpugANHsAWxvCoi3EggHNlEBJGDEJ0a8tZiZidMTlAHPZIVtUGgxGGhPdorlx2pHqmNzTRDPdIU3UVHaDSIm7xtR2hoUIkAzfeVZdLju4dn2y73Im/YFxAfn7BhvF6wKbpHP8x9D96qa+sDvmoO1Sk13Wk+LX/Vd7gsMJ+aoRFjHEZDUqoqW8Cb2yKCKy08bidk+xOTxbtfJTggDJB1g1YXigziLk2qAAoEir+Of15AzEGoTs1x/lapOL8ZoxrzhAkoaWGEkKhCeLAHaxABmDwwGIosIvCdEtAAH6xkUWMbCKRw5DooXBa+kFcK1GK1JsvlVrOgwVQ94wIi+MjjJMF+gThPcgGZhzAt/otaN9ZSiqy7buzsc0Lmmexe8finhdK9HNDSW/zsNqvDOPkzaX7zvG5z6eef6XNr5+2cgT/ADHykK6H//K9/yGcyv375Gjryxyak8JDcfoQwTQAH1uoxn7hIeU+/b/r58+eHD7+/Jzg/7yWEsL358c3Dm59+nC8KKeeKQvVqozoMQfJWO1swyCsd+h3wEj8jAWpNSJ2LkixrJHdAoYokUNOh7yAeqsDi2id6WEOSQzwrYDBDWInaxjCV9bCNdC+6lECNlpqOF+YU21d0LbtmE3U5W3gcGE85ruIsePZEzf5FLntBDb0sxlkJGLUWnp+ruUD6TIVuDtsJKWYGQted7lo6RKeZfGKjd5SBI5fFZlSzZp9qVHyMz3G30ihXTt6ru4lQ4yi02O7B0aXb5b8twIqkKkjs3iHapWJAZ7pY9Xme9e+pDOEWS2uetpGgmXtnvLQfzyMVuTrkq12clzzqjBh0yEbbGN2kAw9hSPtIBq0WdYaSdyqw0tFvxBvtix/os1xv6G11dACJW4u0dax7KCmKCSwDm8osi89DkafR1zmbr7/P3x5q3rqe337zL3Ay5Gw8PyM7m5nT/j1ngE/4+DOiH9/7izZVPXhUsWCPdwCD0Wxk4p97aVBEizdpSWnBfCD5/vd39G2+7fE1O4rgdz/867//m3ypkaXNY0WeEaxlFIq2NgNCGx8pmoWJZG2tcCFLEDlQwhpDu7fFMtgsRJglwCwMqvKF4DuJyJoEqktLixVeWoJQg/9Slu040EPYxm96Ow5RtyYCeAib9Jc6pQS9k0x+V1JulWwBQsFPrsX+apiLxxtyohc9EOCP8SzfNIY5EHUkfjnR5cC2KVHd5UQbkTP2V/ONT1OGmU9imSZN8LgkIiZQkq3lyDZAgzCWP1oIzsYdsh13I5mcLISCkphqgQKhFaWJ9/MbIsandDdWKJ+lbJUu8ZfVReMuJ4F1nmMYksMIAa5tQROH/Nt49Q5pBkOg6Xyd2oCtgHCuhnj1YEUqw4HeEw70i0QQ9sgX/YEviGOwb5QMy1qM+2H4YiLGBh4N1XU+hI6c47o/YhqB8xvhyG+eeuzxOXfkn9VQ85r1HX32bfX2hr6g5eXL8GaYjcDzM7Ibk3O6yhn4Rm+D/UyfyeTPY8pVSPq86PzG+3t4V07a/ZPiFGpukWqODyFHJukLnRzzT8v8TiejX6k+u9kPzvUnpj/QC2DyFnt78KZyWEmGRjc1hQKDWAaBA4KVuj0q70BPUWYTxtRPzmE4DnCPWt1AjEnZruugNzGLwndcA/1rKTocZHY4coyCg24g3Zm+VYgkrCblBh0co0B22UB0B4PxDAZzDCO2Me2viMpPnEPM9zZInfb40mLQB+noo/CJ6Yn119erZd90QI6i942jFAoLJ2YeC7rFImnztL+Mp40YN1x0pgyeOEKGWImZEYbIyD2HE0qBER9oFsTW9JhjZm+UyIczGVg2co5ZErhwF6YU0iupCigQFK6sgTyIPSXpFB8ogtiwvYHINvm6hSEm3Ixj4AAYDKDry4KjFxiYwE1JpgiBQwXtJ1dCmhraoFgZIhJkfVULuudYANeQlN4UG+uQ3sonRy9f0mdIh5vxeL9tmTD7ELBgcC4Gb+xK4JosTfDvC1v15np6Lq5vzF/zffz4ibD+xS3MNesvf0a2zzrq52dkxzn5M1n4iuhbuvL4ga6Ixi8H2p6Dej9NMQqZIntHeLjwiSi/tf7db7/KW3QTb1DsCMROTF+9ev3wb//xP2159TeocIw8H/dJ2aGJQ362ljcJrzjC0wTcEDoqS+R+lszagZdVZ1sOuQkw5YVC3WhDl/QFmnGBvEnNFYnnrLz3siHrZgKgIGzCO+dFQR3HcRXbnZ6odiu443aW3Af5y3q7J9xLeI/P4rEI1H2w32NZttGTE1LeHbg8+keVNVF0Yyeqodm6Sx2Zc2ilHcpdEdgKKL46d7KaoolzftLaX5fJjRbu8wtLF9OrzmEestzllioSJVlCzlzTkXrAOAqZXzWDlTmGB5KjJM7VwD2Ke7A9PxgJaPWKbXJQw3y5vpZhOQ8SpmwtJXxzYcxDPEbVLaQjtubF6ynipijjc6EOPGQF6WZU3C26dkKccbUOY0wATUSLnbgPmccZntVsdq/VYsd6DLtXytevXx4+frSrSSOPxVvO+i3Jhsrj+RnZPB/PXfvnP/4hX1rEP+Fin6+6uifd5WZ73sxuywp/Zvvd21/pG3Q/P3yhk9LZzXlc+tu//B0/9+JWYhAlWcioj7U8zNI1CsYWzwFgHvLY43lCi0BbXoMBITscNnHAP46QKkXfeTL3Kq8qBVXXV8x3CW+Vy2zghmCee45ryQS1Bi2KXQtcQzX6fu5TrD2pFJVcZJo96R3II/USD+o8EDurWbhuwDPjfxb2Sf/yLbtxJ/GJZyu01GNtTZCgEJoW4XiA2vIdYwmEB0TtLDao0b0pVZMUT8cxcJHSczTk1NGiQeC8vWSQmp+8PJnqrDE947puuSUCCoRANBawWktiEyVZbpKjkXS8neqJcuVxX3VMLeXIEcN+pBUw3RUPxpqHrOqo/WM+tiDfKJQB8ed1DIB8Xa2gNCAXCDCMo8CYMXjEdZaX9DukL+mnGMYTnzlZV3JiNN/suaoVOWtonjMluUipc87qtD7GVFs11jmMw3I5t+FHTsPyCazJxjMbz8/Izmbm+dj5xJOviP76yy8P377a/nGj+nU3G/e2fX6ui6+Ivn/3O8DbPKP3//3//ndeogCBoNzUd2g9iMh9WJAUlkcZC+LCFGpWr9GgiMEATyXsoasaKh6zDXzJYIqy0nCU3/L4aJxuuZ7TuaKETBCi917yfjIgIBytZS1wDeW5E96faBxwS+mG/Nh/aJ2RHo5w6xMkOI7E3nI+NriwXe5c297cvcIklcWyF6UCsR0DGAkB2SoR58jI5oAtVAkMdx06eDpRgXt49ntdWYuMzqMSDW6LSJbZ46zRm6yimMUJ2VJzk0dPSi3KuGu8eesxcUCB0AV5fexYzZfYoEAIOZQxEAcx4G4pdnV0as6Uq5mevIIDQqYZNOJV6pyBge5LYUI98nO8WI0IRY7Yxkf2ztWp8xookL9s5Ha3vtdGrmt6OJdHc0PqiDV5AG0abtrQZqaZc1b3/Pliq2abK88243dElDi+5t/n6XPXPJbN+uPP/bUb43sOQ7fx9es3k7d2Zxxr9VvAR9xpyTMg3y5NP5Xy7u3bh/f0syk7myQH72lhlzCx3+Jmj1S87/EVUf4Jl9+pruVXRop9+dXr1w//7V//pdEjGQRNSwm7wjo1licyGESA5r5kP87PRLEGoTNDTic5V+44fAgNhibyvSVS1iEwBO0mViwN8QXSLsMuSwNY1JH8i9QBdl/2kCiJ+1mBgJAIFpS1wDXURjp+ANuCvwF7Si703D3x2R7HtQKjhW/5nkJvqPcJbItX698QRdMaZjaIm3OKZgVFUcmQlMxjrpgo2Ey0oAgzmyTTg3H7nIj7jkjE3v5ykO6UVW7UJ/mhIT7FiJIswLnQ+4lzpK1MTrEjMV2fJYWEB+EmjoJSaVAgBFplCoRBDLinInY9bKnJxwp1NrbbGivtiudQ4UqEmxOidIkbyYvIZeYBePSRpT1pDalOsVECycGeHx5e0GdI+f+H9NMRRQOFyXfXnMXtLWi+Dg/NFllG05zPsX0N3SPmRs/T2317NU0a617tP+dhtr4/5+6xOccY1+OHquU3ZPGbkr076Pxcx58TXL2dn49tP3PEX1TEnxHlb6rlm2wxusOWgbA4s2GTsxjD++1vjBFjtg8f3suJKH9h0ewtwyEVhWXNeHj8v/+f/xXcPY6ydwV0aqSCLCx+l+2syYOCmS7jB6EKfdXNXFv72F4f+ts3CMXkcCfRW0UDJVCEUFAbKqSxIOjRhVRVUlC+13R1uWsEQEHwEtaktcA11ELG2QN+FupPJDPEVXbp64Ic5Xx0vV3KfVVDTyh4pX98htQmtHtcaTtkVUftr7s2TvFCMYGZnDcyTHNMHTG6ly2f20cL+dio/LM0AdLIdMct+TzdhjRPuFVDI5wgUAyElB/WQWh8/IQyYfYnUAIM4W5J+eZKTjTNOSd4Uh7Mh1W1saiNvY6WRkOsAzE8lmlpnGWw4D2/4XjnyCVtRBpwApmYNVU70eVp5BOJcTqNHJWR4Iz5uSBi6S03UY3hSV4CpQhTcm6z3masap/nsx7avFSxY1UWM3rmFovx+d/OZfg5o3m4t5qLOTif57SY2cgnLfnEdV4H5+S3I9ttPscN8dNPP8l+avg/wviBroTytznz73a2E744X/65qtk7JCJ6nA/zOg9jhGtnk8o359IVUfnyom/zz4nmnJYvW037+7/+ncQeo4WEeoJoocMoLH6X/G4OuQJpEFPcnhLYtI1k2Qu/mV/qp7uW3YRcy36PAWEiKCCUNc+8RlMG3cFo+cp6zNnlnZg35zJSIBeE6F2R1wLXUCv5LsDsLcQVZf0EUiHbs4nmkD4PxJaEZMR83YBrluNS+2PVhjw7hdIVUkXQo6F+QDRH7avZjVK8okSLMgXCINaEj2HdLILq1xbi20mqsjZphgAjpSgN3Ivf8gsbA7KQsia3eJzRpRTSKUSuZXeOpEZIzcs86qGB8TUu0T45Jfbp85Ks1FjrbOyPLO2v7KtjCfM+eIr4nM2mugAOphw5uNe30x4RqA3ofZn08tXLB/7/9NEsLQjrFqn+HOWYH0LD7udYxzSm73Fv/fa5t2uLPcdIs+c+EyIqd5S36z+a2Pqq48Y5nPefGZzXOMa6mevL8lV5+vziO3rL6OK+9eOPP9KVWrwWnIt7AtpH+qmUt7/RW3Olp7ogm7nozbOYtYjLsuEaI2s4we2S8NuGf/v1l4dP9BbdvVtjNe5t9F///reHf/23f+9AmjwPHWZUJaPfAYBK4BuJu3YRuyeAm4Hg34tq/hQbQi6txSg4XriFiO6QiAVl1yHGmDyMoDABhAnKlJXHH/MJjlI6q1XYmzf1IS8MECi+Nd3uN+ngBJYEOf4UusjZoBGHYBUG9L6hpxB9CCtRT8y498Qw2TlkPikWPU9wQ7chH3MgfgA+EcNqXxeWi/4X8tCXGtlDpM/mDtkwvTvoSMg2KBACsmZiZO0JoTcUj+Xq0VRt1ZrWl10hNogMzapztnjyZkCvlrPBIRJvsXJQnisac5dUajQiVkcei4RHBNM0lga2RCaLAyfXqTj3NamO61HX6EWG3pT6muQaMETS/rqAbCxTxQibzo35j3CXEdhMneo4lnIVAs2mDA/aGoxQe8BJfe3q6OgMa36oJooe4+vgXhExPsv7+TLetTFn5PLaOMKwXrvzkNfc0XgDOdeQCe+VM2fJ2rwenpdxEo7WyPicwzireTdfrrHWDFvxeMTHjx/om4z3T6o44sWLlw+v6fONq7drPiPLVx4/0Mneb7/+Kj+bgpzWFgy1YCeSrfsYtD0fjc0w8QCwbW0+EeXPiHJ9X+knXRrS8HUtR6z/Tj/18up1fIGAao/lL5Chmrxj+aotAL5j4sx/MBWqQU62QIEAXC8khCjJIvBmKSorTD0/9ERrihIEniAitBIM115rJM0oXZAwwyWO0hgoIph4QR3tLBsPABB65ERv5PHChlFOApJZsHQn8eyR9Ps1DDk6w9aJrhWwn8WQk7F7bExQtfnoIl+zjNaFmjBVXQ1b82ExwCzkGYu7r0Vqe2J1bXypEZWrs4lJvXp+ApOIutloMI9tyKtTTQk8J0NW8lltjTIUi6qrZB1zJvHIDtZUAs/wVarDNk0acgcxsXkZhBDFLQZErAjQzB3GmY84R1qJm5iVs+PrVEs8MZt7fycQArqTYnJF4DYMWNWTB3ijkBnJAwOECL+DXOQpTFXiBqMmtU/GBFFDCCXA6BkTwCJC0178QJ8hffFCeWI85cmqYo4Nq+txjeMat4v4ZkfpoayaKwCWxJy3n4sxB2Z3YO9jB8CFhrGGimhe14je7nnE026X6JNSwdV2PI+RtXwxfsxZzXeu09ja24Y/fFj7JmPmmH1GNvO3muxEl6+I8tty+Yuk+G2wfGOEdBFbEc/GnWJlCG3j4Nk4jWKHm38n9CO9bZi/tIhPRvltw0ufWA+5LVUzjQ5+98XPf/1L93ZrwgHaitTXTI3O3YIDGH4W3MUS89B/6DmIDF++pWxQIEx5EkKUZCniCn9hKgI3TEogQ5sBUPYTAgfTJWWD/5irTynRakRGCFZGNBzL52jiUBpno8RWEIwQPPQOkqT1O8kgmf0OpV2SXmh44csL0TrVpXHrGQ4jbVPNArHlnmDtqG1W/K3ti3MQXxbcLSE1YQptlb0NUxNfFtVzWRm9nfUxgxc7+ioGrBnNiWQQNEjZJqQTc51w0dpXYIsbwjdL0ujwLDvnGzxI4ULoMIjmL0zicuYJwgFGRWM0RrlzIUJfce9SuEocHQ1CDwnE6KQS2amJbUgJA4SEf04Kd1D37r1BEgEa2jRL5mGrW3iNqw7uQbIgHIkf11SvZZbKY6yjGXJmzzm83shH+3hUSyrj2QWW0UeNYz23yGscrRfL4XPSqjS7amXphulje/Cen/HGlWOt1my9RFupgXkZ9+nTp5Qi15Zrsp9Sesdvz6UT0nZjjM4vG0i1PceFZme33TKzWScjCCd+MvPnV9/T51f5W3TjFxbxSWrLtZHR+AOETe3EOBjJxleUf/r5p4cXOlEW6pUpnoYq3nFNArsI0HrYxXpiPJjDepMwUcxC5SRiK680mvMGY8ffqSsJOCR0sRJyAwxnvKDYlcxCu859j/6RHQIXvjXLCVh2iWhapASdF6Yy5nsaU0dWa7cQo6fvWeg1ua2vazh2YtM87mDZfeiEND0MSbnHBuEGIu9mQ3Ca0IqK8W0Omp3l0dcQ8d7YYBNDb1WmQBhEhN5aSFVAgUDpqIpQCHuC2pVD3hjaedfV/5+9N/+y7DjOxG7vO4BGAyRIDiCCJAiSGIKLuILUMqQ0GpHSHMvS/Gz/pbaPj+f4+IxnRrZlmVpIDSlRJIWl0eitqrq62xF5MyIjMiO3u7z3quvVAepmxvJ9X0Tmva9uv82zeKI8n0asxvkALdHI0gGahAqMYvQ0woymEWCmn4DoQCHZ5+OUoDSfQHSOrFcE4pDQvDmaUqkhqRU3ZPSNvIBIRzR1kKzEqNf2AQr8hz58Jgdfuhs+WCUw4DU1epzoK6EjupXHvs6jZq7UZJV5gUvn2O+N1TEm+IaNpD/URGuW1xpia2tKGCOmzJvW4/7m9HCW0DWOjqQeautyM3wpLP5/7J4VpfXJ49taaS3yeaPHrxVM+EUDBuUx3FDjM7X4PlF5IyrRxzTCK/ATvg+ReYR3/fkbw7XnbsRXVnL7I2YiiM2lrG6iLBoLXV6XjCKpGCztKpkdPFDu1onk4pyM0WRKjImBYdcYMJsfjC/hHZnMMiaIYI5sbgtTHUWrbovnKD/geU6rJVUlqUkGpSUmkxqZnRy4uDGifWGJspabMi9C9nBHsQ4nukhTq5kjylmuiulIrG06RFMm83T0oOuGFFVQw5sUFYNYrr8CB2ThySDICMgTmyKgUCr6x3Hqo5jxKFHF2aKDEEwAiWEUt9y0ritomqNH8aB8aRDAYiiKhGD/yCAfIEQAD+18dieDanwxwHbK0sY6hUUMtRjAgv/QbaNiNHjpmWccOoDxtxt2/fIsBllscgyxMaeS5fCgQ5WtKaH2iI4h/FI8wRzr0Gh4M6p/aD7GJW4drGbiUqHsS05ijqCP6iL9mjXO016ahdyAS77eI+nReW06dE5uhlhaJ3GGOii3nZcwMDPFITw6av7R2s5FKHEdNq/FFRDaRlO0NSIbYWMvuaM8SEPpRtKuPI3XFsqSf4iG6+iT48fuxvghfJAS3pTSz5hFuWTtPFJNAgb5kP3Wy7eGi5cuurF1ucRUl+Ye1ASAJWEMtDyEMvoYhoTJXczODM5mzUFh4E0e35VB6reyEUfGBNzaiLN4ABmeIsdUw4z9EnqiTAHZo0oxCww95CgeaL85U7FqYoZvwpioyF30lrigRgXRqiQaorimKenz+hUm+ZqANhPE+jalrZOn+4Y037b8lYE2gJXLDSKnMqiJj0A0+F+AiiGhiCNgeBgLTQRWhoGzzFeBqbiVRp7wALJJB754Kf4hn2oPlU+PrHGS8BOPRxYEYpjkB4PPJxhwiCGHka2MCd4oIJoyXhjonDieeFGU+LPI88TRAbU+wlxGH8d+Kq1jiLIIaK0dHazRSNEmr721BI6DgQPSaEKUH0Ic54ymaMopCsm4GAU6FQn5mkPin4NPJA3PkDIVDGIM6bPHhiQfKBnt3JyVHkvz2DLT0pxyE6bMlOOUy8KVGdbYzkmxrdylbboH7fVjXlsdNcy0IuvrhnTUkr3q1xe0pDqsnqQ9fvoEHkfg//j8Dshi5NMZBSjk+0NFZPPwKTxDO75P9Mi9TxQTq+8TtUoTjMEdRlgg6n4Cn5x8dPBweAQvCX7u5vPDy594ZcyMa/N4EkFQ8JD9bkAzAOMmcSgPpIsynFNNOJwH7OYBucggkcEXTSk6YyZ38UhMHJQYPLo+cPg4sBU4qPAryhnLcW5ItxGSlC6DKkVNumAmBLeRcRQPeqnaE9sjDQ3pxcgIikxTciKI3qnbQ9FF19Xdo0XkIx73rQejV/jc+A1o4z50aj0fJ04/0RFJZ+uZrUwtogqRyjySABRDlVWbSFSOFdLzuBDkn/kijHwsIzcPCNMluImygBnYPKHNq/2cnQ4CBY4U14hh42Ow98QBCgPjwg+GmhLAwXaIiSGdlwNGr5tGgXoKEZyjhkFQ18ijaxIbIfMv6JjKktzEAsMIrR1JOA8n1KEofZz6SJ3gsub9AnSTL0VNqI2LHsc4zAAcRinu5iysrkKZqh1Lbc234DE3xbUiyUaPg6HNlN+ig2IJLXfMYwVenUu6tLVlJrngn2LElDClLSCKwGA084XbD1v7kGbaWtK4HgtiUq0teVqD3QeNgzFjzcSDM+ufNnWemHmaFjaRZQ4P3EtzH/EHFplBlpGWLRIxTiMj54MdvrP04b17wxHw4suBP/+VLw8X4ftj3Y9Lg32nsHNY4trsQijOJxOG546mrAgH5PP0o0VhhnCK5STvKv6jAEkLMPC4gkZGGz3R1BlVrpoItMzQ/62U8ZpmJwF+cT2OUvNaMk2wTqNiUZNOoO7wNjKO4kEvUXtie2Svht2Px/11hi6OMKb9VuoJxXB1+sLM5m0PSjWsom1CH/CpB6WFLwZkTbodFolCwhGwGM4/v2Pkh3gYcTxZyeATRb4YUvAyRwGM7GIa4YOXH7G89HxwlBtNqUxnVpMoEAgEhxhGcTB1MPl/X2YWH8cAxgnIPiTXEoKLKFFU5oYMg1kzD9Da88PKfY0hd/QYAkVKiKZR5PT1p/IoLnjCaMSiCFdkpgcqR01IT2pkXArBIxqdI3jDSAZ6vBRWBvE4Hwbo0R8WyBfHJxoSw0gV57GAZKAjL1yky5S2h7QMYQhYcNTPJS+x4lSLNBHuWCPlYDyNo4RoSvlkzvUK1i/virgoMMa2MVBnm1bSaOP4Tc5BNcySP62Vaspx12so8bHoiQOJLbVLe4BO1yX4rFGonbz0PlKam0dcV+XQs+BK8YMvjPBmEG9GH9y9F4xqlMNXQbCAfu7Dxym9rmQ04s028h3eR76PGOClVz4+fPK3XuP5OICcArVyuYmyBCw0kzYYRtMQlxu5XPjF8DwwMwRV6jecyd94lMU0PCBP9oiRBgVYweP+A68PsOM0tGLGBP57S3l00swZI/NgJmBzehshR/GgmcAHtie2RxY01C9cheT1XapG+8LKIlSsrMtHyD2tYhlhNwasrVLvEmqZawKY8ZLdCC6a4tVFmcSKiCFI8VEquEchJgbEMOrBSGPn40QFRdPAiExZZwirjgBD3BQgol1DyqUsPOHBiOTBbEywGg6JoOVjcN6rY5ecAWeGNmN25FyaP0nH2LFm9mGkOIlLeP0VKRaVHp1lo4/DeeDsiSZngF+JQ1F4zMCkUSmWcMDrA0Q7IKiFhLDoGLDIQkfSIFHz/8RCWbt31D3q0YeVUxdw68lO9OJgfMByMz1NAOkxV9NiUl0H5SaghoHw6WiEVEw1PWOhiK91UR7se+Fr1dEaVxHf5E65SHtT+vQgT6PZ9MwGpxh7k+FXyjw6gg8tgk/PffIY38NJ8TZas5XoPNw4hd+w8PhyYLwRHflGxEtXrgxf/PpXYIIxgsXl25rYmg5igBGX40Y331eJ6FB+FCxjVhjLkhW8d7gbVicpr0t6aGzjgtcF+McZGUSJoRFKziYm25HArNUSOZIH1ZQooD2xPTKiKE31xTeNTC9yacwCFlfbXC6Z7+tCXNzS3DsZs4DukwYxtw/GDam/YsgLh296qTkohMVgoJpQJhk1R0RFweMRUyCAMrWzPiti19NnRKSKlcXXFRPYeiHYJY/e+X+gexZ9iKXAnHin998ALZi0ID/LxruWoDcdcE4NgwN5MNbMkGwvDSIWMRVDAwBZRIQYSrsyCxTS6Pxu4i3OkMsSAF1DwCZCyOMhDxBMTjy/kBGGECdDhQ7LfA6+tP48fNLuY3j/1y7/WI9Ftcdjux6rCyGyj0dijTdhAQlH0q89a85a+5LW2qo3xI0YYfeNdY3+FF9WHTCktT6OucaM1polflmfjKyNtSbGpT+suFQe1AALfsIYOfFG9PAAv0v0ED6waPye00LyNBdSihKP4XtL3XtF4dN6+WbU+19/843h1sc/pv6hwilGv7tzJP2jFJ65Ac0EGYZF0zEz+q3yIx9MCTkMopgMR8YcJbdPHZ7/lWoaLSmnt0SOaDqWloIm4oohMajPzpiz7XRpTIQzNfGo8pBjkDG1cY0j5LvI9vCQyKP25PZIBg8DvpgE00ZHuQur0OVWzoib/g++Y4WIy70TfButv0K2cX0z+uBvSP2Jpg+VMrXbp4bFUSuFsdgWMHZx+FZyRzVny4xfnkICRxUtqYvHCAnchz4SuxG2dURWnEyGGeDRB/ZuZ5Aq9fJMOapmTHUGHpg52ij4xJBjFIGacEgYRH4xHYeCIBkmwQHWj0KESOao4GVT00BgiaFKddA2PqY4Dw/iOD8X5jAUhGKouKPJZXhWA/+o3cUf6/prPPbNlm7xIGg7V1iBFjHI147dgtgfg/y6bt5wAqy+iWQdGg9h+voiiDNDiRe0zeunxMzQKnPgJXO2B+zo5SDk3PGM+x7R+/A9p/g1Lk0/MyXgze/D+3cHvCHlG1EiBuzrzz83vPLqv3LfP0rmcfltYraqTQO9jdobTRlaDsZnSSHSgTIyhxCG+WwqRSVp9M/TlO0DoymlW2YD0ocnHoKBo0eCg4UpAtXQxcKvEZkGKQ9j8iDApNGjTy1RCG8c5VBlekuMjI/Ft+e7yPZwSerH7cntkRbNrGwDcIJpxsLTV0uZVVQu2Gp1Z2iYUHF/ygb0mT3sVAo3pNBW1dlOBBHOgtRgxC9/cIIXEOtwOAwmmMYhe3gA9pFOxHonx8CzBDGPj86YBdbSQ89YIy5sJi6LB6BR4KFZTEUBPgGbAf/JdBHEQxuD3QsMhAJaIEuXCAukptG7x/pCbK4fIcKhUcE8KXGEXHskcu2hT/OkxK2tMBPJNlGblf8AHcMjusDiHPArs//Q7RTBQJ7fTSopKIMdF3Ll6uXhow+Bx2mKvduZ56QvrdHiWZoDO2jxWLZctzelKT6De3kxXtfFOzlX2gw7bfRx40peS7f0+7OrkzucIBY+gYUehHjyLXHEP/QewAcIHcDLc6s/1KJqYCEAynjy5LF7ee6jwwMz8Ny5c8PrX3hzuAXvHy39KDluQhbfK9EyMSxBOh/Fjg9vMCPYMFBxJiCBsNO/FJbnYsD4ZItvXpMACmw4+lw4uH/097oSeRkkjoNBy0uEJQznSiOOvcOsyjRiUtaBzpk/07Bd1rRUr7c9uT3SaIW+WBkBu2lKao7roAunP2b3G5TnsOL8HSp71/XFrRqfIUXVouvRNM5xc1eo9MQGhyf/TKVgcAguMaSAgI9Od/WOwcdQzuWBgshMAEvBhWRnDtNMvpKfjUkdHlgf0jBhYZnhrwfhHYcslwdJSMUQ90OGB9B1eyM5cewr5wbE/to8bXKopJxrU9rWESlCjqZZtgQSDd4Y+aKphywQRa5oCjQSMfcHjYzJViFPZQ5K+NgjBhw0DhQbT3gAn4Z5aTgPX/9yDM+AtPzQY0pLbEuMapmRsDQfUlicm+IxSqyaLL25pMIlLUoJeyA4ePMEU+eI+hg0E6bF1wluhhMu8VjrSzEaIGhEO8WMOFRHyEB/4Aj2dIS54WXwhJvG9VjwO0SP4NlQvBGlZx+S/AlUISWMsM4nUMRj4Dx8+HA45JtfjEl7cO25G8Orn309kYMGieoC2EADjydgxdDEtIyE5nwIoAxWRt2W1ZE4xLXe8ZYFWNISSCcPIj0ewcq4BEcZ1KRebEOE5MZw0uRSFZ2aFJE5EgcRQTQt4pSciqMUWPQxSjEKne2RBpS+KBkB2zOpuqbojHIcnrjQ0no7exS7vapTZtWH1L2ohblm9gNuSD0UI446o2lGPC0NuP1QWKIc8EQxyJHwKIOaeLwIRFsjzvrUYuCsxDkaErNLSOtjHDfALIgRB/YzIA/YVR/UeDVCwsAGHoiEyBZNRSAPyyF+7Sg6mpKZjhU3hYljXy8oUWnmCQ8oTBy9MiFQDEVcYZgkjIaElQ088KDxXHBFrmgqAnFY9kbBfgpavf6kDBcR/Ga+ohwnCocnPHAwl69eGe7euWtCthjr10olrAUSYkaNhC0etxrzQxhhBEsYzcENKOmoxJlGL2eZ994duU7wR7aYyj5Je165SFZBeu8p12ITmzvotv0j/egbY0etoXbpK4iFBPecmSfELFW1msQ4qfMQbkQfwifnPnYfWBTHizmllsrz4b4SkRyGWC9+eu7B/Xvw7Gj8/vKkmuEzX/rCcOXatXDFc+ANIhylx0thg6DKSDG5ibJUspdxU+vDQsc3qUETx1apfaRIGLdUwLIgyt5oL1oADTbFoSaYLAQ7rCSAGTiSB+xqHpjoprEZMgpsB2uPjChoShebcLEiz1aPXNfSuhCPaoYKmWer1TaQL92HEuUCXP49pCWWBh+cpOXz1HvdKtLLRhpwG0LKvHUAK583GzmVgScCHAIpVljToc81IBKTM0RWOCFSGogRL7tN/VoF+iNUHbDqLGKOpiN1qMC5w5SVGSbvw4zRG0ac5gYmJXqcI+vVIC4YeARJnJnXGEFFU8xTWIkhSuCpwRibGJgHnI0DZeWLiwdRB4j0wfF7tMew4FcEMydXr1+bdUMqHk+cEi5xli7qmq/cTyVXGw/hoBjfbK9LYs2SaiRb2G16DbAmk6yzKaEShHihX1r7HK7W3MBdERq5W/ARW9cXgbiptYYUV+oHoj+B7+aUj8h8PoPvaZE66H/06Ai+3/P+gO/fTG8MSYk/hrTIYU/H7qY9Pnp44G5E8eb3aXIzGsefGZ6/eXP49Btv0GUL2poKiS0xirjogVi4kfMBFBfnu4qUUU3sgjNWK5N4Myn9ZgcIvxwZMXqWiCyaKi6XiQGFV7cRelgQBeEmHCNdJWIZJ8cJUGKQ0ZmxJJ6SL69SI4VDIdhpkEJrO0B7pIDPDa2Lj3Fu5dKXtHNdK/NvimdOb5zGlftA+pbkmn9DCicUnVMkMD3yEqYub4kj8pgYGbx6loVfyCFVeg1BilBVpmMUN+AZJ0mLgHcPovR+DWXHq7q4KWUgGjAgD8iz4FEoEkOTIJEhDXIM2WoKwPAfmrIU7iT0cSpXTUxZfUaPl8COyticFVpg42SMUROR5IENfMM0opAjA4ludkUPNJQqBPihz9AH8IkMMUzz2y3nz58bLsCn7T6Cl+gt8UMlhus2CeUuVGgoPg0LmOhrxSMcih/xCYv0UtRaR+QhzmU5qK6lUHP9X5qnpFdy5fTIfBkv7WGs17kFM+TGI8Ia15OwhAYycSL5/DNnMOUQHozBePN576OPwgcWYSqlM96yA3xJ8P0PP4Sb39ZrANxuQ/Ff+O2vwCd1+z93GjZ3VKpRBBTqaqVnGJcrPEFiAw+cHvmPByywLpxD1UBB40QA+aGwqNR4gnEOzg14FofpvdIKHqMo3bEznncFR8m1XFlALXaE5s60hUd65LQdoD1S4kfjhvMnytjIlFcALnquziV1+gtpWLNFOrlKX3ZXWb3c5IY0LoYXWWGB1TtsvwpOJoqDJzgIuH6W5I4G8PobMJwzhBFd02fmKqOcpEXX8GNJjOYGPOMwtBQxs07ITOEYd50BiIn0RNOE1kmUQWzIiRfBYpgAKwNg5eBEXCmkmUrgjcMINZom4d0Gr0wIFMMsGsYEKZQRLJRIHpqXj3G0xBNjMSzjlb1nz56F95JehPeRjn+M0h/b5ay6F3H0Y1dcl41R4k/xpjQBc4IWwizx2kr7rMRjZfVyl7As/DZb6ImOn9JjjTBvptdLY9W1xb1q7zX1I89BWCPHGI/v8RxfXkv5crd59cHF5eCN6MP794eDh/4DiyLacRoZOdsaeD2Wy9vwE3OP4TtMD4AXn4lt+xk1vAQfYvSxT3wipGAz4maD1yg15KhRHFmvtR4hCJLgxOCDDbthCsix7uAZR5lkNGPLfHgzikugrMClzBFYNA1JuZHQpUIS2sSgwudPEB/Vt/O0R5bUtaO0R2b4jHMmE7l1s9tH/qLn6p6j3ePw6s7BWrkzvMYb0ji7t1E/khtSt5AqCCzjf8raMwlNirKQzBNaL0aNoqMpoDJw5BLThhARXRsiGgj2h5ZoM8aJipWNjXC/fU8wVwxNqJIxZtD9SrwpmyAXQ0EJGPHrlrRXzPxQ0aqJiAW2iDCaitj8UKG7ibLkE8FjRxoqDFMM3BASp0RzQBAgYhjFpVNVB094kCYQkSARQyNe9goiGZoHZk7OqLJo4gWcOQM3pJcuwqd3jn8Ih2tuTWHMRsCxHecpln88soKzNspJNRJ3ymOBEY7lC9iWt2YjHbW4Np0Wyjx9MWJOR2sdMd5a87Ie3ZNabKi5tA/ESddUVMCCR12YhLmVrjXgBxYdHRwMR/C1KnyqRGVgxvjsXeSw4J1tjLOi8UYUv0/0CL7y6Ri+xxR/KDooc2bhC/PLV6/Ce0ffdNcN6yY0RNIIUD2whU9R8qieqdQLzGESK6mzbmCceYOEqAAXxYqpGBbyU5fLo2TREDFMkxosMp/gdZpt1TFzZ6iincdFtodnxLUDtEfmqGYjZIDXN7v94S9yVAXtGZqXVPTElnA25stcg5bmb+ldL6e/IaWWQ7ofCksvpotXYt0Ef2nwuRyThPmkrD4t0aDwdYgDB6Wg7CoPgFQ0QwzLaRUv4bAsMrg8NbGvpb5GDBfDiNWj+xvTceZtUeTUaaS0CKOYecKDKLcHGVMNHMM0kgRsFxKmkYYwLYYgSDEg4OAokeUMiVUnZWYWtYlkGjOgGbMqUU0gAfAvXoJP24WX3uFL9+o/UwRRTiDH63v5j/ZUSf4xYcTtxUsZ6ppSDVSbhZazUc6omzAt/eQbkSjPxsVYC8OODmsR/GX8ELf9UU9ftFqssd53ytE8ZKUj9QtezuaH8PbRyns+Q98P4Sb0AD5A6DE8O5q8ZzOE8YVnNHntTgLxk576EW+WH8JXxxzBM7HWJ/a2IOKzo5/8rdeGM/DqirYfQPXA7iA2qSwzi4XxLIwHKlzijBzebYer3JM44bJoIBoghrNLI/gUKMeSz0gxShbEb8dyke3hGeJ2gPbIDBWa6Tygi0chdNsurreglWNisVRnZOf4AmaUsvEpa9w483KEcEMKJ5M/X3OnbSsdN4QHmIkT5AjoYdSKvFwcS1ODXn0+mTEW0IdYKzWmCbYpqFRnvhk1qNw9AABAAElEQVR5T65kyBDPvFqtyWKygwdCtC+yUGvs0iix10PrIDCiITJG0yAKMD0shtgMPtm/TD0LxQ4eBJrmEXFhQlBTRix7m6mLgaOWs/CAgO8JE5cTlbXc4wXVNPL24VKukgYT0U8IydUQZ02dE37QTvw5fSUmyrH6QT47P/CjH2M1Bum0s2NrmSuO3vRc10rsUzXTehFOOKY8rRwUl8cWLO4ffvB9otWXyRJsSObRyITv6yoEcTSeF0/h03Pvu+8UJXNObQkRvyrqt974rPu6KIdjBUfA0RS2a0gKI1I1/4h8a+CWlCk+nIiixbAE0eRjHh40pU0KUhRqUoKbUi2Cx3nNhONat4dnxLcDtEdmqGJz7mItzpM4Zc25q29JbgNr8R6u0JBNa2Q+o19zyoMbUoAWf+jGp1oNnIVhoJrA3IH1vxi3xtnjjyWlGseKe+vOaWA+HlAf0stYwMBgUCAO6FtKU+DZ7Ei2YOy7L7CpONEMbA2D8WBaMb6prb1tikN9Sk1s0F4VihN0eyIxTMJcYAXKSJph2iiZ0Omb4Q/ooOH5ixeGC/D/0SG8ZDD6CXsEHVO1E1MErqZTsSlv5CC9ucd4RTljgvjENcIgP2mJgVvqlzkpTuBKfWMm2UMfyj2geMl7EsZTdadrQP0JvaX6p3KcCd/pSxCCFt9bis+KPoKXyT5+DO/ZpBiiLRx1qJ4V0uAkf+peDvzgLtwAA3/LD0rOMbz+xTeHT/zWqyMMB+FAFMp2GUZGiBOhY8T4O2OWITwmNNuQeDlsrYHSribLMXJVPLCx0T1HQgKfGGze6dZYbTuhi2wPz0hsB2iPzFChOb3gFII373KrAdcNrnXH9a7eoQ3Uv2av/Ut2gYJfcsl0M3oXTtowmgHXkarUywkJ8UeadkAnoRI+nBE+rJvHowlQMYy4I/XRNAp204YQK22WTXG6ibJ4bGGjoSscf/kOGI1gkxvgL0im/HHm8eUB4mifi1iKMEzkqh4xlzVhNBuU1eOAMyKLpj6ufFDIbqIshWSDzTDFAA0hccrEua/DrxX2SlaGN6RnzoKF/kpnFhnFxsxAV5NARVnLXudRZ+DPY/fUg4IDZiQfphIL43RsrX6Jl9cro+RYcylP3mX8LSRrkChTx4G8rf4Qr/s5lT/Ok/h6e9s9n9MPzUXbAT+wiG5EH+H7RP3PyDSHj5Ds4zFw0XtF8X2jrT+WoidwA/3SJ14ZPvfWF0cYGSQWOuqAoEw9EgIDl1qPGBexU3a0nowfVY+aCP2RPZqKQByWvVHwAtOe7rdrc5Ht4Zk62gDaojIUZLY3OHl37sirJs5vFDnv+67nlTmu+SKrMU/ICcr2N6SouNw4y8ubICkYo0dvGCVBixpYHw88vBeZ19ovgyl4sB6XrS4ijqZjjq7YhWiTCd0QYubZRo+WAbXMrNPdjJiFaSoHopH0TIfzPmfoEM3ccYo153xyJgZyREfgC5RyGMXZ04SFDTywE5XViDVMSijkuxChXUH6ScVtpRRsXlSkDb/65Sx8wBF+h+K0H60yegybBtmVpfl1alSsdlZmrbkybtQi//4o9UPGjWIwX+IFidb7/oK3PiIdgTPPVUezIki3eF9laWkydSJy0OhmFlnBpkmpbodEElW2aVQR5cnI9/gxnD+C+uGDB3Az+nDAG0K5diPbXE5bEb4U+OG9u/CBRUeOl6IkG0mUNoqLj0+ePB4uwNdDffWd7wxXrl3Vbg9EeNpZnskcp4MMLIoHZSDhTTK8IbETl8ilYcFFIRs7Kt1yMkWky5cg5TIwcgpNitrOmebals5SbJDCtUcmLKJeX8wk/Mkbi4sp7Y+kRyvUm3CcvM6VFa/QMyQUN6R5/ri5tLD5DPRAFt5UwH9xPnrbMDAy/CQ4bODBGGxswoAybaQY3AR/+Sr0YRrB4llK8YhumLgGz+9CKotTcYtKRI+8tZaLftZAz5AZO6iGI0RUhlFTomkleYIbCPx5gclI11KLksUTHkQ6IsRoGgWLEzTGi+decAIQCFxGmCaRZGgIodDkeBX+0Pzwgw8rH8iSpHUZ0uut0YsuRAyeU3U3WWNCWtcZPu8QIvXngKln4vKbC+2yIx5hjz1s19RGRHitN6ZSDzJQfhtbKUr2LtRMGXN59P57+mScH8NNIX567sP794jIHUe2uZwKMkygUHw29oH7HtODYDdGVQU+4BBubM+fPzt869/9eHjx4x/zSLpmNGJ4avXhkw5VhSZqoiEyZFGFQwxHjghDEhdcMqxrnPBjNhkFoRg24Y+XIMhyWASYT0X8JIoMBrlhyoN3eog2FdQJxOGMyBZr0BZlZUa28kUoCt7uVNWcXjCVOBUrPbJeacdxBTMOT+aIPRcjAd2ewfVwxXqabkinn7wgP9kFI5oyxwTKqSZtK4EpMWZbZhLF7DzwIX4TL0ST8G7OEBcGzIZJNtS5o8KjqZAP0YUbMJMKs9nBA4G5/aGpCo2iEWIYCYbAqCdRQJgyEQ+CT42AzSA0TJzFiBTENyLs4djyIIqPpiGXiMTyBlMIi0cKb5zceP654fZ7H7hIeX0sPbbEsDSX+WQbj4pYu5pnLQVKMBm/BL/Ebh3nedNeydhRO8a0rUN7rYQ38ss8WZPUIu2lsY0la9A1lzl07MhL2vMqEDP0TseV+XRsbqZrJD2Hh/DJufAJtvjMqHyZ7Mg4kzeTjjfBj+ETsg+B9xB4J/94fHwm9wngPYJanjw6Gj7/ld8eXv7EJwUsBvr6hSa+1PlI3aGQLlIyRjMixM4Y5TQZ5QSWgpzElSXgjoWHYWJQIGpCEeFITS7whGA94hQYuK/VYSoe6ASYcQ55EgM5xOMPmQjWyJEmCnNpPOEBoc04SjaEacNui5ogiy4Wcap1oYtjFpxzfWvwroCpVhF6yPqpJytwEvRJPjbdkC5bYLI0Teecy8JfYqXFMJIIgf4PfoNtjFUONYmwaOrZ9IGcp+AY9Sh6sEFveT1CiyKk4PAjy5/HTtI3YjD1mMacHKjSKlSE59w2DeJ5jz4IxAylIlITlTt9Yit2eEzHA5Mm9p4/fx7+4TG2hme4ECT3WJrpgsk73ViouRlUYsS1NoPMCtQtrmkIfvksa+s6aK4pskO/8pz9uIhV0hZ8VH/QgWzkL2ui3Lw+wpERZUwZGcaEc/f27fH7RL1rVFDXEZAKI2yBhII5frzh4YP77pnYp/hy4Sk/AhNf5vsYbkIfHT50X0Xzmbe+NLz9zjvDxcuXI2SRRJ7IFE0paqePepf5dsd9pwriYLAbJheNvXD9CL8IxTxS71I874HDOIIIESSGzKsICJiNiYE9YUCo5ViK4rzEwJ504KDL+JhkRdRprKxUAln6oinLONJFwXDtjOkEaEzWo6Y5cwHP7RPGr+GusGjMvQI2QW7hhpSo+45ugXKrZEJB+xbtIIJ1CTBVPRtGuw+tHTKXhY000BzOqk1mKxtCzLxljUKFGDKHK4bqZCsP2KMGHggOaLZgecPLf4xRGEyx8iBoLRFhVJBHFbElnwohV67Gf3RiOOYSDsxgmrneJ9it1/c2vKAhIeoyNPSiC4+CY315Hqw39IbyrHjyEUf+GPBkjIUp/a3jUYfk6F+zaVrk+y5b1ebipP4xxtIU/gGmXGOaiy/RfXT0CM6Y1JfT1G0XW+Lo4UN3I+renwov1e3+iWQe47O79++O73WF4l+Hm9Fv/cEfDJeuXOmGXjshki6uUMsxxxwOWfRfDKukHAuDlmcnOb6KDCpZaPysETuqKOWAHhxS3p7jMqgvKMSl2vmEXtYrWlILXMufXmzWYpqEO7bY7vEkwBWSlLqefmZiFZ7Uqx+QpWfVMevJ6F2K/DwStZ44S5EugyNUiyFjuw5yG9ksB+yNmmDBjXkQKP7Yz8dJlmdxLBpGTfTNoGmx6iQoMUC6YTNM8e51IZWFqbiL0oPTo0Rg0TSE+xHrc89mmgW585HjXF7vVydBtg2d6EFDHFqrwQRhI2QLADHkCDlAv6o10xeF45LODDeevzHcvfORhHPj3B/n9rU0rj6B84ZRAWLk8ENmjKnUh7DsKM7PBnY6enWM8FRv6F8bDuVJkQFDWeVk5jjtnXy2FsEtXelZEGTYmoPfxgv+KSPErPGOmse1oNhWLbfffX+KrO6cY3gG8/6Hd+B7TB9153KCWFLEObj30fAE3vfqfqDwT3/hC8M7/+6PhouXLoEp3psimQHXHSSMkSGappKnykuApwKFPOymuyQ7E25KHMwlojWai+NEzfg1nZ8qwO0Wbtqn4TFWppJpqBmw2EwXjti+I3NX+45r3GirttAL3n8b4IbXvUWXl8LZUXAtvCaeySA0TAm3ayAGZv64pQTG4gF5Kke/QuFCncb3QqYIu27hbToKjab2o2wStECRBqZhknqcu2GByiGeBDeBDyzHR6VicGF/dmFF0LmpagtPcKDZnEubEsi8G7Id5BjhsBIGDYeRFDd6UovOGGfn4GW7rX+AYwbFTruuksLWZ6WkYsqVtk2OrdVq1yT7RT1cVn3bek/n1LWGeub1pa7HwpdZWpf04Jh6PerVWOSLc1rmT+HTqfHTaJOfspz4MpGkSwM+E4o3owf37y9yM4p4T+Bm9Ajee0o3o/iS/Zc/+cnh7e9+x9+MggLdJsswykxqTQyynOaxQlGTAkRrXAGi5kKKpDW1JO/HPJboJoTE1kYkDJuea7KRkWCFEsMkvMsMid6VZf5ByBGTCWUd89GEjHAhFMbdGbpa19YIF1LsL/d1Ip/CwIvzRJyp3e/SLx485N6ayr1k3nmhzcTlQsErxxxsGsFbqLTg8rAIGqLCiFnbBpiY/aNfoIohAkdTxZWUmxgwvPRCKAPdMCFKxoyuE/BjNmaLuiM90TQV5l9SJBZBDEU4APkHIg2pZyJha0Ol30/cv+62KMJyBABVJ0waxV2QyZs/HwiHk8ngUwmB/W4AVvjv6tUrw51z5/wHsliRBBZl+9DxMcPK0/HWrHbdtHJytvJjV1xD0NumgeJjnKAm8OdjxuhwMx6yYSmIQhqjceAIDp03gui4mp6ANW2U4rfzh6J1HVJJii+9reM8vkQIeoLV5j98eAAfKlT+ZNuAIUY2nAgY3LmI3yf66ABfEnw4+hryFAhP4OoEN874gUX0ftEA+HS4AM+Ivv3Od4dbr7zStAcZFgeiXaM8b1Ba1USlWxOO5oEVtUFbpCOaRkLK3ii4cyqazZmWDZ15HWaGMHKmH/CcOXsH8xF6GWvxWO4iqvSFrka7cf8iNdZUxxfWmT0RWzH7oJjUNZMTS3SYPTgi1uX6Pij9ce9ETuxacl59D2lRJCqBgLTJYE+MQTb9Q1IZGwAw0ONTbAKrDGoSCHnkUUZYtvYMEEGxKIPyZGCNGMOEhSuzl26BFlxW+N5W7YDvaHNj1UoV0WuRzZRFlnZnM19zoOQO1fLIDXgmg/XYh5wxL5bghGvDmbNnhosXL8AnheKzPQ2YmqH/j9gof840vb636qe4cHMYP65qXRQfWZVZTXSgmmFcfSOktSkQnqRxrToYYvEB9jLoolpjXWQf6Sm+vA5tUgkLo9vxgp4W/Xgzil+5kvwEmMTFhrgV7EC9T937RI/g03PT99NSIpHQXABEQ8RALPehRUkzzgzf+aN/O3zy9dfdqd/2N0VE4KeoiNXwhC12krCqSDURQTs57BOL0bR608rp45vGsVRWu1YZOa8/QbvEdFZ5YQhhYZScH8Fljii+hmsmr2vk2tfU5usPpzuzrlpcsj9oHQxWpajQC4fpcVxOIdagKZqUhmLkMs7qDWkLDS8qBVPXrWq8j0IoxT4CgHukyT/DYuflrChoZA6jXGyDnevjQUOSFdLQDUVBk1ALoxagCi5O3w9EB7DNomm66yIuGlIcm9nAA+8S4N5Cf1hxrjFIs4ygHTK5qrl0HrBCvn76wlR96ISLLWYpO1jOnjs7XLtxDW5Iy8/2MD4z1geFx4l6ciViip4UMnTEtygN8ZaUL12DbHLiCLzSlXKQdw4XYfQe9U6xs/O65NqPdQU86bNxy9a2Po18FFvnpDWBx8l8WU7YY3jv5QN4GW16w1jWzd7QimACgfjpuQ/upu/n5qDo7A32MJLS8aW5+KFF1s+Zs2eHt771zeGzb70V3C7Z/yMuaDRkuljJkRoSb8DPjDiDB5nAnTL3ieVoGODjU663+RIZIR8y07M+Q15grR9N2monbp5+9PTkywuKHBNHDxblLH1cW4PHb1qbpWtrxFP7CtaJtRZ643JkbAOX4hHxLXwifJHhIjekiRKuxHtExWKYpNmGGExHWd4yB2T4qyrmWrEWptgNWsDkmWe2BFQxfZIl1NlixxivrBnejLmq6NkKoE5BN8SQaiQTzZOjClCTKNTwGaZ4l7qQykJV3JGO9aa6HD0jVusxcfRBFb4Qu54zwyX4iofLVy4PhwfWTanNR7z5Y3j2MR/jFdrCammGXwLldMsYA8Kb0serHF4eo+whvFFP+vU75ex1vbpHtLfSnrSpoPy26HoU4Wk91E/Kpzn1F04DXRYFiiPlCJMxxGdGzWdHjdiqCUQdwXmHN6Lye0yzeUoiFRSMaMEPLTqGl/o+ghtS6+ccvET/za9/bfja73zfcHsseHznf9hjeB4YeX0mhaQmfTjbie4T7KLxFy4O/E+rth3tKauqRk3S2D6LrHQesESSGuahSqTOsb74dCavG+56ssP61q0+j857pbE3uT2XZ8h4Gvky2d3m7htSboykio2+G4s1xXMpGppM4oJkn08wspx1xyBYNEYMu2idbkpWReCEHALSMAkvD9P9J8EjkGjKIDAouGTYjo9F7WK4edEGuWGSumy3sSqGSeLguCGETiedqkSoiUYVBGKosTKz8xfOD1euXRmODo+mP+uTYMdakwA2pOcLuyqDUqXwQQslt4Fs62ivw4BsMK2N3yDBhehmUe+wJ6Evda0US/l1ds2bxuc5NUcNJ0XOWaiG4Nca8OteDuF/+4QNWWpkyMP3dNJ7RZtuRhFQ4rCs0fj4Ed6Iju8VzeGdhWdGX33jjeGtb35zOH/hgpKoJwDO+NoTzziMB3HE2vMSsWzYEjpKXCk+R4OMpZWkbH7JmNSKWNu2BHmpUxpfRfoLgotIT+K1C98J/JNUO6/kkmulHxTcOcc8uEJLclVWXPFWYpd0n1c1qjOkQJNTK/LFsADU5mI6GiC4J1iSR6ohquSBrUJYcQMFIE973YuUF8ZKKLLD/5GIaBpyo5GDioP5n5opmAn9IwjZ6TgCcFSMR2H+WHFH0fvpvA7wqgQYwxRvIBcSL5TKU5OAXRxhDoAKXDEsZkonoly/cR2+/uUuPLtifHKoDN6pcbln43XZ7oh83FLXb66vjM1hWx7Y2rUoWav2yJnfS94UcMt9CHGYSLHh2fE6N+VILdsdo2ZdF+6hUad7Tyb+w431/tGSbFEmvuT34b277kOG+MZR+EswOd9j/DRewHzy2H+Vi9Ob7v3L164O3/m3fzhcuX4tB9VtJ5bkYY6QZtZGMOmxBbglBpGpipQlWFqx/G7BcA/bgh54+kdOWbu8foJqxpLk87Bcr+EkZhR9MlcrOakBrt4TUutqWqP6eQ9sa1EjPZuQAc+QirLFcCTvuBRFoQQVmc2aKJadpsEjwaEFk7EmDogj+0CFuIlOb6pqhER/U4oQxGVCKg41wXDx41Gq3CIlGpKOPAt5KDICsKaUwj40hHx2BxNH0qDgopD9cdEO8KoEVMMUnFNHAOrPA0RAipa1jqXge0mfu/n8cPvdD6YKWTSv9zqev/GJKx1ljt+rafsWLcSB4Yosy5X2J4e//M2h5rZ40TbuQorNr8/y3V4CUeodaxjrwRu+e3fuTKMAUHypL748Fz9Bd/wJvSqDWn2GLgMefqcovkQ34BGSzsGvePrhX/z5ojejxITH+LrD7ORgg8yaOl4UDERYeCQcNVp+W7uLxF8+XaLYGbEVMybwxTAbm7dr3YQkU408oWMRdJGK7Sdobta86/pxTXak96p/qCnaL73nsMLb8DpUXrLbIs2XG4dmzPpaFSeVqsdY3ATwHxw8fClhEV+Rp+is0ftCIGyZj2xapj+Iwj9qglZfcKHunCtARRHkoKMjp8kYSzPnitKdLSij6f644Q7wGvHAC4D1yiyZD4AElzMGxukuSBnVhKu88dyN4e6H8MftI3qWhV3RoKwmChZTm1cE8JAeD/TjVS4/3HQhAOUymDnIYZnBHUbdm/CYS/Y1eS1stI3c1Mu2/uiSKXe0WjwynmodbfP5JLY9nsJhI6VWif0Yv8sTnx3FEmtt8FD4rCq+nPYQ3tN5CJ942/5jE7gVBQ3uq1zgmdFwM2oj41e73PrYx4av//7vDi994hN20ArWjhZ1sNs96QDoDO3j42h/CugzoUZN0YxSSxi3YHt4Fa8voI+4L5quWqmiBEdfnNIEtLTEUCad8D05lLuFI/fjhOjFFvG1gXqNxpX1d/Up0uJyhVY6U1F2/NPFEycvMD/PAgCsJDTPZSGATZrzyc4jQ8saMBIiEB4O5dgK6U64ZeWpoJw3X7fuj0JUYGqiwuyJZ9QHOzRjzWo2HeIlK4RHkukYbbDRTGAc5LPJTmBwNEzkLbgoZH+EDnCXeSDa4pvY3ksAsXAEJA7jEIn/wq2bw3u/fjfKiKeEIDPjmHROn0oaXeshkPCsHGnr45OZ1rhHR8hPNYjHKQjTtaQcAWnOSHMSUqqNPD3HVLOuKY+l+W2NafYSfIjRyicVpNzSm47v3703HMNLbqNlTgO9Bfc8fnruw3v3wst8dZt0bq3VgIffTUo3o7Wisb43v/qV4e3vfmfAl+uaPwU9BZcJhUazBNOYhcg4FgHJYEszVd3Ox5E4oHQJ2TRmlGo0R/KgmrJwQB9xX/QoNcnpPVmnVjyTJ9HtdUzeFoU6mGum5gLFai7sB+l3vWm4gFM8i+qom/sPPA6nI9fxiXj7q/RY1VYH4zOkvlPuAJVz8c3SMAOzPVBDXhzZzomZEA0Hh5FJzJgblO1OyLQafGf9YZlqEGzs+YTNMUkC1p4vgTxGh5zJsJMKSqWjYhnz2FWAKbiI6Zk8cm+wOjWBuWiKGM7uA9OowciA/zCFP3i47D5x9xJ8DQy9BNC5Mr8YLOMns+dx4a05lLvOUTy2eIJWXWmcxvLNnCG74XF5Bno+VdeBcWmtdnZac0sNKV8PJ8UGbsLLcZM/raG1zsF93Uuab1vwA4vwRhTfJ8rvOQ1y7SRlxeCgDUeHgHkEN7hPnxrfgapy4dN24dnTL3/7W8NXv/fOcAHOa+pLQIwSDIcydWlX0iOiqVNLgFI4FVjk6Z4LR3bICmiARy+VTJRsVUC++Mi5PMAINYlT/LyHJQNRNLdoGAHaIwuE+RO3kLR5V1JrpDvxk0Q6MWkOx5YVZLyIR8Ds1JD1kiqhO/FRDB1zPTLsmOLwBD7B0NH11+fWYinHHQWftUZcR4Fb4a0wOe+q9+oskWVOzMAyuJRiOEfhYBKnVOjRGBSpgz9jTvSFjMT1zBpUb3AimiCGUf0+EA6beHY60ejUkFiv0hBrmFQddAPDxsSAHs+uRFDGyKBcBdKCiwBPxFHVyxMcQIWiSDGcXZeicWjEp1l4Bu6z8LUQy/6wimVhHRorN7BbeVvjDIrENBdLv/w4gRcG8dgorNOG6eNnSx1p71s1TeOzaiOdQUuKHedRTmwvzw8ewA3m/fpLbo/hRvA+vM8UX6ab/BB1kDuGkJ0TtOEYPtX34N4duKmMEzmBB3jz+9wLzw8/+h//h+Hq9etsp4GF4NikQ9OPqZaNQFc7TiWVxaC4Gg7F1+JCoSoSJwQRQvQIYjhHxrIRw9VE5zfPWjGkiFbwVuxlKln7ZZytVdfiuCv1i08KZeQ4PONcpxWbxZcqWN0yW2+uRwsodz31vWadBi713nDtlOm8sW86BJZaMMKoCJxAZ/o5sZ2YrNBGAvU740/MYXnYFUwKEScFVxJ7EgyqHjWpqffdgps4NyrkFlyOhPsuKZVRTXyUR4VDDV/CyjHlMToaeCIjcUzRsT2acz4NQh5ZSlAhOsLdgSnrRy1qggZQ7sUvVUNCoQxlPvxaCPxwI3wfKX4NzNo/xuOMoqxf56g42T2yKSieBM5yHCe4gcTXnnHWg2Xlk60Vp/3GFZGpj6F24pPHVm6HKBMZXxmNic3fw2uAOtMSGDns0X4MN5gxi9wV+EwofpXLATyDad6MSvgYKFPDE3h58PHhAbxM96B6Mzo+C/t0eO2Nzw3f+sM/NG9GpQQ5xjqUpMQgozcxVmomELbky9VDipacUQpH4gBhBJQYjsH023AwjovRM0pb77ge3yLI9sVivXZMROZal9ZLeHTx9vpW45tYfy3tJOk1TtFaeezflTorH2qEJbJUFl8aWNHcKB6UECyfhWrFtdoMPMNEaMFVKaDgLriI5gQdfUdCYxLtBVcS224gXviD1je0p6+JpsTglYiLaA8+PrInkGSgYxphWKgjBrthKkSTK3tkWRShDHLiifWBsmYfmYkHArKD8xw8Q3r5ymX4I/hR9Y9gwZAd0uNqCLAEBm8YhZsusZ2CW41szGnc6QYp8Y8cMsfWouTOnvRxpH2YKwD5Zc15PJu7T79Gj3nnYGnk0uzOB7fBrblwhjei+FJa/ORcfH/n+KPjvLF4kBn4ab7ufaJwg/v42HimVSLB5nzyBG6G4VnUt9/57vClb397eO7FF2VE0xi7yhp40JS6YFAfsYyOd0W7KIlSzkoigXQ6r89lAP/Y50gSprKwgjeHxLSF3F5XjqsX51Q8M9raFLyAwjm+xnq1Spgax/vBfhCYClvNW4xXPPA39X/DdVqNqNyQcmusXGVzkfjLV97UAEag6HY+SuUMGhCUD4imlDbxKAp0CETq4aIpNwPc7PKCltU1sZwdSXO9oQY19QeC/R0p3ZgmpRCec6hJEhoMYVXCKHhbRpin2BJDCwrFKKTRmJiCUnYFEwGFIwfxIPiKIx+PDYf/cFaiKUJ5p1KgJhq8hwdvSC9dvjTc+wg+iEVckFv0yJj02hwLlNFy3KNW5kFPTQrTqBPVDOO1BhtXJflJL5eFsRlbrab60lOt4R8OUuUUk3rKFt1/Kxb1jTXEsVM5NYvsD/7jDD5DGv/g+fHw/j336bmzzhUBjDe4B4BZ+/RclwL8eOP6ymuvDt/4wQ+Gl//VvxouXLwo0NqGqmNq0pa/TFQfsYvGX/HyN4mhpHZOjpzMWRfmVMGvM/QA4VKYuQ5gRFClhkuZaiwWTi1HEbRO5InXmrOFOK59bb1wjlPvN8a5hX4uTrnEuhAGrAH1ntZC6iWftG1rXLkh1bJYOA+0H3eeVXAUJaYUnQMUoZkhIcTEhEhHl06Tbp2YTUwEkhGkzHEsYKCJoFTs6Z24dnT3xDeSTrpF2hcWJ4xmAiOQ++EBGTqPHQ1SVGrSyWmFA97Mm1KliCc48DXqgyWiaLsCn8h59tyH41dcFCNTp72dWGSawJZ0feBxoPqT8rVw1WAlhiVC+mtYa/gtTZKnrg97G3pH8QGXfPU1oFzJP3dMmEGPpYNspHVkxRzKn6ZD452Bf5y5O+BXvtAP3nzip+c++OgjZwoqKaLtKFU6TLgRPTqov08V0fGGFV/O+7FXXx2+9yd/Mtx65ZU20iiKNfAgCtjItI/cReMv3/j+/k/gwz4YaULGIp1iCt7GVnUctQgnglgsEnx5Ronux/rEMwJ2w7SRXmCpdIGDIXOetB5tWK/r09KciCfWwtyFS3OaJHWjuyHlzYLx+UkFDS4JkOv/Vq3EolteQnCsiBvyyyESnSNNI3srgyX0IQaI6OpTRZZ3x+pmldpGuQNRcdWpJCui3BtcHMCBE5hyrXjyMaMyqAmHTBt4dktEDdDJwMSyHuelkCY6CPZPTfsDn80Ew9KUQU04xBpMKVfi3HzpheHdX9W+AiZk2NfjFr2p0r5rfwtH0Nk/Whu/RVF7j8Z1oPiy9tBnim/RMi+G9kngLuEF/bqutpxSlOUjbaNv5MYbxXAz+hRuGA/cjSg+k4k/UztHlSE+3lwewfeUVl+eC3zI+wRexnv1+rXhlS99cfjOH/3RcO35552Wll/Ey7GJgT0bGrQLUJG+8VP731occ/IAMuUYp4YIw+QoVSpPeNAqS8TlmChkDjZhpPt8GdSAL/51TBh3c4gd5/rpQqYvHvOFE67kWppjvkoTgXuzYb3Ma6qaYRRrEaOsxhkTNc7Pn2loOokuXzowaowIo5IKQi3F1HykaAks5FKnao1c+dtqxhQfCQfrgYBBuSQesKtlELKoR0ZWwYXRFbcBuHumyTWI8yL0cpP1gXIhXgzbRUCS084bza7EYTcRGEG+TzaylkoxBooP9BGg140gMB+rsePZlatXh0tXLg2Hha+AEUus+WMwc66VFa75LjtwURdSUB0z4tdwU5RdtGDNul+h1rX0aj6bJb8WFG/rPNP496fW8PRpnY94raOtBSPzuHgDiDehj+A9mvhVLkdwRJtWZrGltpgFb0QR9/jRYfhqmDSNLXjDenz4cLj58svDO3/8o+G1L7zJvnEQM0TujUxbO9On1UXjLw/fyjKnZOasgRilaJOe1eD6/Gti55Vg/xdjzp+YeQFb9Fh14z8syR8rxvnjWqM8wiA0xonzKHB/1B1YqU+0HpJsF9cm+5JdFgsVWMXIwsIYsvCPX/iP8ttzA0r7iFhKGbECyontiEG+Ep7ts9DsSLQiD2SstPk0L9VkKCSXTuCZcxtpHACDiluGPnNj1T45KTSl4Ir6A4CI6S/4bhhFtEyRL9yPulkmTSgTQwqWJlnqCK4slMJH9voiaC4xOdgNfATemIogMdThmdnNWzeHX//TryunGanJgCRmrSLzeKyywmme5woxmBo40N7CoQh3cpKvfTm5oW+lnoVeU3xem4VzRm7KoniNG3jjJNIR23GuMayIku3hgwfD7d/8Bt4ret/diJZiS75YBb738+D+3aYbUfyQI3x57lP48KLnb90a3vnRj4ZX33hD0MXowpUZUkapc5nUipmQK2GNbkbDgRe7vGYtRnFq18ZnrCXDvHYvYtqanji+Os+f1NXUTQcktQvtiY/ExRdAmLeuGWMKHoLd1eO2NDPvrjZmQ7qSG1JqTOumCzpFBoGAUwzNUDSKzBCz2MhUAOjSTgroKH2LCfFAyIH47RwykhT2qZqW5TgkuUHq3Bn4jNlAOZkmqi/bA6N3bKJkKF0M00a4izlEwH+Ya8UyJmXXDSOSB7MwCco6UryjwYn7Az0h5VSKN8VzlDUATCYRZwwDWjmhR+cvXBiuwUsDHzR8/6KNFFsDcfw4HUfiXD8O5/uDsS14GDfnR+uxkTahw2Zewko9hn/I8MO2etwmbhbQhonrH/ZLGZx0l6N6vU/gOz0/gJvR+/69ojKfGHMKyS9zcJM+hpvLh/c+gpfdHiuXOcF4fFYUnkFFvDe//vXhB//hP0ShJlMUo6cyg8c8gNioqGiqwVacSUmoqV8HZiiUqloX3ZdSxRyVTwO1apZIclwSYuHk4hNMuhjkEix7y0k+BdfiWtmm+tGr2YhXeFK71TMjX6bs0pjr2rDmVXlhTaxzZ1XOGYuavIfUEl/G78+Ir7HcHEkUwUZTGbnA2FQQ4ZKClliZSnlow9ze/CkPZMgleXE+5adRaxIG3PAfmpdQMUX5JnOyNQpH0iIvUIQUJEM2/nEL/6XXyhxyAc65PCaMPXQtIfGjdsfuBvgLf6bqGbPt3xFmNB1ziJ8UnBnwE3ev3rg2HDw8mPQBR6kWJB55aB2sx2DMI3+KsXmL1mI2z4sKN3IllbmaSzktPq2TMkjv2Pc27nSdCI12R5ivN2rTivxW36nusj7Zs5jv8OFDd0NaQmhjgfd+wrObh/ChRfgdpTgu/eDL/57Cy4LxRvT8+XPDJ177reHzX/va8KVvfbOU1uwLZ7pIMYxUGx1dNE2MeMMkCNqGBM9ck0ExUaFVBbjovpQqZgiwCplG1l9ZpRPyJAiC540kZnxiIbL0z2NaNZtXaBN6N8GxUrc22idRw6q81r4FbuYUOnZl6G5IrUtNXmBfdB6n4om6Fk0ryeA2ZBqmOg5HdCvwmZSH7FIB2Zlg5kBiT4VaShPg0A2UlzJXXYuyuRxTu9aSN18b9rTMpNw48aR5bp8Ba4XLhT8yVuGhUxnUBL1b/rH14FfA4P8PHzx0+vRjJuWEqjPXcFEb5YwmjSfCdmgoa8o/a4d16drSEsY+Uc0SN41tsxBWiC5roPg6dxkn8I0jwiV7HZ8ilznGfGGdynXEeVLNb/7xn+B9o/TdotKTGRtUT+FZ1kfwHlR8v+jjR0cu0QhjQPchSkcYfzTgKxTe+vZ3hq/+7u8OV65d45hpAzpHS+wamTKU1TSqiGSSZcw6EghnoPA2CRSdYimPmqSx/ZbFAfsl7HpGfLHYUb37lexcmBOyrk1V+QeG4rVmB+tNXrJbL7a2zYstqMMvFWHITEyGVMO0kKKE3cCV7L3xBlyTqYUnAMloqTZE0AgiMdifGG5IrugoMdnFRh6wSw+CCo4MJh0Ks4IriT0pBq6bB72FQqK/Iw0QYXRS+mDpdM+Swst2D+APc/zjGrdjuA7DMzkb3BDIu0k+qx+SP/QBI7ERuTXXTZIYFkerTfPnuG20Kb3UfIRr84YbQoqzj0v1IkYn3KDD1hnn0fzBvXvDe7/6FU3bjtEWwJvLI/h6GPwwpJaNeww3rI/hxvUJ5L3x1a8OX/u93xtu3LwJ/yB0uY2/GNVSP+3TltgimXISqjQ6BunIURp2+sc/wpMwaFMp+QmlTzwWWSdi1tNUOfXwtgg8WeyTuy2/NWoTHIaWnp7RqqqcLek2StmISdVeYMRecewWerRN7o2cL4Xe51znsSm0iXNBfXZucyZtWbYMSZvZkJqYDLmGqY2vGpWwGxlLsbdwpfTd7Hii+7+umDEdpETNFgYLGfEjfvCEC1ChkIJLIG13qKqWEyFeDBvESpB6uBXdx1fnWCriGrxs987tO8Mx3JDij9+OS8ErHPtxLXQr3GCoNDVZU58iaproVV1CW9qj0J+8JBkzakpx8tnaI7G0J8xaYvDvYN2fkB9GtZ7ZdbTwp9yOC3798mc/E1/3ErTgqIoM+XgTenjvrk7MzvCrX47gE3cP3LOin/3Sl4bf/7P/brhIN6KRzGiaRe13VCvzkKSgNT5VggjZbIJP00yLw2EwHpixyxmn81Bma5kUv5x2A8k6yewTy0g2TDHeHCwDvsWU9K1BQ5LTQvQMxKi6G/qEJaucDfdgVW6/d63z0/E29mfDLXF0yXtISYRVDPnmHVuWYj32bu2G3MRkyDVM3dR2QsJuhNXYWzAM2KmmrZ0AhToTV+gZu4IpqbzgSmKXNLA2AiWDF7SWLqIpXcU5piCi4KKKVjnefOnmcPu9D+B9bQ0fxjJBgd7i3AkDqeQbw5e4yTGInUnrpChLk16p+O8zyuw9an6LtwVxal4Ldm9MXctYs+7nMn8OEbfGvvvhneGj2x/2FuIk4afhHsF7T/G9orUffAYVv1P0ETwrevHSpeHjr746fP9P/3T4+GuvuVS5Z0gpOnjMAzDqEsZ893uNX5J4Oj5KVkiiBjFsI4AEh+X+gUOhmvlxRDefiVo3Sl45rmeuEKEvJnkCuRHzUXlPK08eodvDvd0Cd7fYLSec6F7t11ftnuxLdnmRVXj7ZN4Fcrvs7VX6SEOuYcrDGs0yTPn8xNPFnmSPBqmgBU/GI0JLToZ6tnkKt5FjmEia7Yp74KMzZsJyRwWoJiosnbSAp1ktFqVCTmZQShinITEIZQWegksAhOGVq1eG4aUXh/f/5f1ZX38REGGHJ9oTA4T3KpUMOLYwLe44b858rmbNvUSf4r8pU0zitPtF3u0d+3VRjXHtaQ0B+xG8f/NffvlP7lNwgzXNUBYIxBtQfIbTveQWPpCo9oPfZYrvK8WvdLn5sY8NX/md3xle+sQnhpc/9Skz1dxRYFQa1STymagZo0FmmDLJo1lJyU8ExsjQyyMAxhfNI0DlplTJgfCpnDGO1LKTYzohesW15lknWmtur6ZC/Ilbl0ItG3Xh+m1hvXpr5PVdQ6vfw9Y1gXl7BW8wPntDOldDS/FW0+byjvnbZe+uwZCbmIxmGaZu6nxCosAIzSloyTXguk3Evym+mkBLB2hMzImhBlzweyz8I8ZTUVcKSUUXq+MBhEeg0bSIV3R6zcUYqcMHsqkiRLovX7k8PPfCc8OH798u0sXO/OMGq4hSJOvosv7WiZJ4qvkkVo6PUxcaEE/gJk1WHeTT5IShrekscFjYafxokbGan/Ba+XMM27Prevp03INnRz989z14WTr1IZMv2oMfVnQAL89t+SoX9yFHcNOLN6T4oUXf+aMfDa+/9dZw44UXhjNnz2bIGsxCT0N0OcTAMkzhmqacalLmUV7Ic/9B333rKyugslsnpG4JbAuD8Fv1bCxuzkkxVeQ2OGOteB7vgo5Y14S52ltUk7hOWfuxhYbyHD7hEX4LwDZiVtRH/ZBlce9X5JV8U8er3ZC2COImZYKtxmZCJ5hr7Ai5roIu0YbcxGTINUxdtOXgRIERLhW0xBsQiQkxEasfT2XQREr0XIYpUdFmQBJCI8L2TIokBJqnR8D272fz96ZpSMaSqIoNglwMM2j95hKmkxIHSH1ybFDL/DNwMb4Kz5Q+hO8lPTqsffpoBdjgCibMDaLpMTL4yyOK3/5jR9wD+fUksa9cU94beoX1Uu35+NSDOdvvVapriiWuo6cfx/As53u/+rX9FUfxcgHw06dP3I3ocfVcGCvBeHwW9Sl87QvejH73j/94+Nff+c6UMl0OS+LBZKhpiczLg2k4KguwHJz9yeUq1E9cOEvgQRJKnnBlSUJmGwibuGYDLgEQnxRLYNYwtsHpNdEa4NStQ3wR2KK2attkQItOEWPVKnshoa2xivU9S/ax4LMw1rY5PWtpiPeJLybpwdpFzsDf6g1pTXdLI9UmrAF2+7evoEuyITcxGQ0zTF205eBEgREuFVjx0m+kd5gUkpr4i7/HYhU48HFReAcro1VzVKTnbuf1CXDw96ZVPg5QxGzl2tHSrkPkzxwSp5KHRmWokIjYC5cuDPh+0nd//S48yzN+yFEle6IbSUf1+PiTeayYiL2tNNHIRSUQbrjhbe2X/dhOeIuKXBXMqqO1ByTsX375y+HD996j6Xg0WoHPcrpPz334QMdmZvhsK748F//HDyp669vvDN/84Q+H8xcvZjLy5kROYsjnniwPFOZqgz0NwuVacsluwLNsefWIbKp39F4wa3gb9Fsnxlr0m+RqrIEe/1S42Ey8N7akfXF+qsPXiPhmD3xDmF81KEzi3DPUO+IJoauPalpnCfB1xfUqzC3UrPgbJjt9Q9qgv+vvUguvuIBWQmKbu83mK0gklQyGXMOUR8jIzZjzOMpTU1DzIxgpaIlV5DwhBDbgwDSqiGiCCf0a4gxH28VNwR4pBoxUhinlBYsaIY4PkZCVLAWx+KQgpEUXfgDL5StXBvxqjN61wms6PabV6wpC0w8qCr46zsmKiB/3pvXrZNU8Ve30XmnGQ/iuUPzeUfUTbzFYCHyGc7y5HL9TVMUbE3w57+PjY/j/0fA6fHruZ7/85eG1z39+uHCp/2bUgAdTLNKOmmetXRWkfx094zr3Yeei0S4V13uTQ7Iz+6JtjEWs8cmxCOg8ENUbS59xsetbq3n6tpZNdVs9mSKKcAhXYPAaUIzwxUOOjR3bmjdoXkXatng7iznxN6Sd9SbhLRt23QvK9hUkTSkZMnKV2WiYYSqxTPApBZl8UtESm4EwzRK3HduKJCSTxjRiBiJZaGZCZGzIM55uNUwKt7cOU4UyqglwAYMn6eVCoS/cesFhPLh3H6fwE+OP1vi38fgYh2TmbfiZ5BNhth7zpvfrRJQ8WeTSvfr1z38BN5v+ZeiZrYZf5XJ0/x78g0r9jMGX5T6Cr3LBT9HFePxe0d/50z8Zrly/nqk5Q5pEE3drfAIwwdDKhdpIn0XTgxPnt+aOebVoy19SHqux5hYmx1kblpwN+4lCm44lriaAeUGqD71ajHiFJ6UZfetZQ8Y1OCXNmuNYLz8DSaRTtBl9YTgecPVk2enjqmp9v+K1wIasyrtCx0/9DWlLT2uLam2EFtz2mO0raNcKkYbcxGQ0zTB10daDExVRilRQi8VUim+JDVQcjQMPQUghqjbCDARgtFrCDL/BkZh0BezW5qCBA9CkJiGmOIIcf1eMhxxNDuLcuXNwU3oT/ujGr63AZ4sIYYqWHMs0e/wYXnh8nkawcFasF+E3pdnijsvblJaYNzePNc/Vh8/0f/Cb34x00fbFm0n85NyDux813YjieYDPiD6Cm1d8zzV+lcvv//l/P9x65ZWonIgo8uan/XlxBp2peY6pnpgph9OroBV35OuLDhqn5gWEaBRv1MjN09Y4TKht9h4sFrDMwPVvk/wGl7mGpZ4ZGMt0YxpKcmZ47WZdBYoEx8ei3WEh7o7VniuHa19Rr9WvTfDmap5qP68WtbTxpzKcgjxe+EKt1oYphHe6tq+gU7B5D5JUYTTNMHVT5xMSBUaoVNASryFUBkBJNB1ZmymkWvAG/Bk9GfMygjw43JHSM7Y9/cSb0udvPj988C58FQy8r25XfuLH2pbHsW1dumNtm9IR85bWriV2Dd02L50QPTs1Xx3u2/fhg4yO4ZnM+N918GW2h/DpuS3fKYoM+Mm5+JJe/CqX5158cfjSN785vPnbXx+uP/+8EED6hWmlYY4pZ5cylumuRJTjFgUyvn28HnK7BvU3YUdaU6h9UjSlrh3k9gxcCNwa7JLOXdIycRGWPB8Ry62RvGg/Az2a2Npy2gnri36GdK54uUHKbTp13iUeaOad1NtX0L3ohmTDVIY1mmaYyhjKm1eQeBIDAHnyeRqUoOzE0eOvKWSZvClQWYGRw2oXhtQ5IdPp9X9MEK4CVBOKGC7BV8Fcf+7GcPfO3cZnkDh11cFSl9K5l/RVi5wAnqtniX7lsG2Z9n6yYy1ryKf3F0+p4eH9+8OdD95XexdvKB/Be0ofwzP/eFNa+8EPOTqG94pi3pVr1+DluV8ZPv2FLw6f+uxnotSgOXJUp9Mzq9BmwJJ89euPKSExmppKm27KhkhYOw0lPZ1QOxtOfc3U6tabYqAIt26Z2J2t8RkXlpyTYr1k6fgqj23+MPuaOgCbebZZ7ALc+oZ0LmBL0zMbZy71achv2XTJibpoY7avoLscQ7IyZRpmmVVeflKQaKEWwt2tmCIqBTsfR+MA6QSlGFZxZB5jQhaPaVAAzbkoNRGBjigpmiYpytBy/VEJw4DPkj4Hz5Leh/eSPj5+HHlP/rTlcjuhbRtvjKWxpbYeoYRncWmc7A7WYc2zEa/3xhRvJO+8/777GiN3ZkIB+CFERwcP3AcXOfqcVH9iue8VhWdF8cb1AnzY1zd+8IPhC9/4bfe1Lql8TMoBptHSYp3H05Ak6mbGs3TWN1O+CCuXNmk+a54H8S3eeai7ld1Zn9u70BfeB535u1X8yVTDvc/JpzWR5wfZcjkr21nzlnWsXOai8MvekLZIa1kcualaMPcx3AE+CdiiB9YfBjpi7qymAPHXV9FcRUauNutZM3YSCDgI5R/c6l1o5+VIh48cI3mdIxGZGEyMyMj8Ijs51aMcF2olCoy1hkwLg3Nnzw4v3HxhuP3+B+qZptNyGYrrTNatYxGs3Bi/Bc7CkXlTMGX+9DHvnOkQ2cwRO74xtXtxZjjy3zvqPqQIGnIIH1iEN6PjT0knnIjwGvdHB+NXuZyF/f+13/u94Z0f/cjnWicqiZa+EgfF54+ENA8lj78Vj71Yy0lB/Nrmz2mo5ZFKGZfDothTcEz2p+8P7V9sQRLjjKb1xHYsW01pj8i95CuXfWtpBvOWeAioJYZi98ed68Dmb0hbWlDbVMYmb4Hdx2QunFFjei8YUXrDlC8xhdj1VRTIwdWisYyQ9br9Pb7vsadKpSg7GRF7cLM6OxwWH72vM4FR2iMv+gQYhQpTlNA+JSyXIScwvv789eEpCP7w/dvD0ycjW+0yhDjP4qUIa2qpvbXzS2K1cq4Xh3tDbp6lmcJOH/uW5/r53/zNcAAv2XWfnvug7dNzccPis6HH/oO8PgYfWvQZ+DqXt7//fVFInjMEoc6gNdhbckP0MzPa5iZv5W6Nw0WhCxsd44XqwYpzd3Cudm1jbSqHapL9EmM6U8ycRj6i2PRRae7VasQrPCpG9IpM7mjkK/+OTrjGE6p/W23dzRvSWjfmLnJu89d4T4mfT6aJ9dLFd2K6T9uGij5OGT2pZgAIGGE0u29wY+XQQNQkXaYAQmrXaWZQOjkFl2ES3nFI6e2OJDJruHb92nD44GB4cJ+eZcqGsmPupQiBTsrlaGmdc3pn5U7VZ2HxApuDlp0aJ8Y7t4YRx2u8u7dvD+/98pfj94rCy3RbvsoFv8IFP+AIb0hvvPDC8Lm33x6+9O1vD8/fuqXBm2ZlfS0Q8xFaWDYQ07+BpouSm3xN3qWxSffSuB2ddPttbf4M/knd66w7U1dH+8uha+OX2Rf1bqxni6reDbCTeUM6t3e1zU8Xz7k8pzSfT8hC/bU/xwqpja5WFS1xKSVlTatDZhFSyjHd4jHxxhSoJNtszOkA4923FzNVk5Xnqo0dE9qKL128/vyN4Qi+CuYY/nDf1E/tcoQ61rgklXmxgaGpa/ATZllH+yoshTMyTthAplTqIR3NIGFs4/3pX/3V8PAefJVL46dD43tLj+GrXPDG9VOf+czwzo9/PNz82MeG8xcvOu4Sa6tyUUR1WOKrJu9KwLIbrl4VnTAYuWnuurpyxJb1uv22ZQ3lBu2el8/Rfd/6F2fNnvnrgLwuPwtrhTWczhvS2vZq2UzywaGGt/cnHeATKPGMBnmyZUIWMNdUaAoZPU1fnCURNdcyM8Bf9Ka0rkpVJCdYOvwfd6COWI8gTEnniJShjoMRl+FTd2++dHN4/zfv7dRXwUy5JOVzWhtDcfAPGzA8HZc8qrltv9SjYjzarXFmHBf7xzneUP7DX//V8MGv/7npZtR9lQu8rxSPV65fH37wF38xfPqLX0zALVWkiI5JUsYQY/XmZ2B3y5w/udbRKU++TXOvU9HGUN3+e4Z7ps4vWafcM9Dt+LwsLYDCLAXufaoDG+mbX2PHhWss11ypOXmT8+pjkaMNjOX0bOKTV/4MxbVNYPRyBtupS205sTexN2Md0zinZc1fdM8LRcR1xCd2q0KFk5+k0vGpWvjxh5g+jZ9jUbr6ga5cvTJcvHRxOHh40J+8xYxwSZrZgKQGxBtvStG15KUtaE5IN2xYumc5+WMvtbeNG58N/eXPfjr8At47ijeYpR+Mxa9xwfeKXr56dXj5k58c3vrOd8yb0RyOvCa0KRyRemJz3M32KRtozgaewtdcjBEYa900vyHpJJncXjzhPVPnU08tUazDEftJnt9yTSfzSZDTPI76vmorNsm1YiF0nupnSI3i1OaMBcHmzm3qOPTUzY1edvdAXDy6c09BQnFvrlD/9L1eU9qCnMNoyTWaEcFFU59gWw20BpPHEjemE5U7LqVMTRqkNIS8cOsmfOru7eHwRN2UrtAI7hVh2zem9uWOchikczBnh7RSzdXYykNxsqY+7n/5p38cfv6Tn/gPJCK86AiPGY/hRvTx0SG8V/R4uPbcc8M3fvjD4Yvf+MZw7rx+uI8yT8bU3mh92msYucfdWl6finq01LFp7rq65ojWXS7PjGbwQqDjPaF9W0079QP2Fq1Ltu8UW+jxZJfc2xJkTU7Js8KY+rkC9KmBnPcIBZvnDGys7IY+NW1cqdDayZk7qVeSc9ph8YKz04YdeQAAPdBJREFUzl6vXcqQdR1me01retIsyqir9F2EA96b5uIJzzHlJ6mQoiXHlibhM6QvvvzicPvdD07AM6WqQWkxi1qQa+zjeHlak5uw29etvVTCbs+YFxnX0Md/78MPh7/5z/95OILvDM3+wOPBI/xOUf8hR1/93d8dvvStb7kPMJp6M9qnMqtsGUft8XAZFhtlk9zx4/omue3qu63mvqnUkeTEfQAV8VmUE+awKny53G3bN6Ide2P0l9dg7d4RPmmg+babP5F/Y32bqG+X0+R+n3dDilVmNvZSDUCxrRehpThPDE7LSUwn/IkpaiGhLb1poYr6xxcekbv+/rRYhQA3XEJFC4/mpYw+dp8Fd6SUH1BTS/DNHbVgh0ouXLgA7yd9cXj/3ffhqzUO55KvlN9S05LU1J9N81o17IIGS1dso56hvV/zvTsfDv/lf/mfijejx4fwnaKHD4cz8MFcL8HLc/F9ot/6wz+MhSRzU03vtTO6RiYkJ93Q248l690m98Q61J6ao9/IxSdA4p/Y4viN3DhvF+cb0+77KHvH67bJ3m2Sa6UF30rfVqpl27Dzb0ihAlwQubFbi+KFxITCxuQ442KEqVO4Me9U/BT66urP9PTE9qZWb29hEi/TK96fBez19+gcFS25oTgZPa0umSXRAsf2RlrPBfgUUrwpvf3ebXFTKvVvS6nWub4KqnnTvHFl2+aP9dTm1DeM69d+dHAw/OPf/s3wyH1vaMqF7yXFr3M5hpfovvjKK8Orn/vc8Pb3vjc89+KLaTBZ5DWNbHOOLXiZa+cc2lVyY50ttS0tZBucC9XAO3ytGgg3Xiev3/FTzEI1bQqGe7c2oe+deWU6ob1bu2V7/BU7IPbcvBtScVFQJ5MgWLSMDK7iLhEKvRQmT0qynapjpqfNPTB62py7ROBc/UtoaMBo3qMZrGX26TwVMrtfj8yQSJmCI3N/RgTgp1KFHZFaL126NLyIN6X8ntIl1ExRsgRvWl/eEmvcND8p2xYv8c85TteON5v/+Hd/O/z65z83P1EXv1MUnxXFDzD65OuvD9//0z8dXv7Up7TYXbk+LqGj5bFmCo+FOwVHd/7UzXinb6F32+ReYqE3pt/vdXll3xj3Eo3KYHAN6J+6/6zrAMDJXsX0zDuVMwY8RXPunah52g2p2NQMehIWxNDI+qkp0aYsbUZKOdVHo6eqH1E/lW/OpMY7BzvOXauGmKcwT/apEbvGXo15+zlkRoxmFBGZ+jMigGjagicVUzq+p/TWy7eGO7fvDPfv3iPzjGOPkpbYGVKS1LgDm+ZPBJ1Kwy/gmVF8dhQ/nEj+PIH5MbxX9OmTx8PzL73kXpr7iU9/Gr5D93kZ9uyNW6/5c6/XrTzPXocnV8RXiA33Dq9U2+Ke3KwocWP6/Xkhr+4b445qXmq6qP7M3mWOpUQ/oziqT5le1krvuyGNLvROwETimrCt+aN6VJNRFPRAntBb03lSiKN+mrKjfWXGkLEFj2KXOPZoW4JvBkayVzNYuf1by8/lZWi8uYZqZ0/LsrF6rTnuCxfODzdvveCekXpw/0Ev7IT4nJIJUM0pcpW3wd8stDmwdsnY1ime04XfNXr7X34z/P3/9ZeqRrTjM6JP4JnRs+fODVfhBvR7P/5x+atcsLgckUJ/hiYt9VqL3pL3DLVpqVL4KrGp/vm1wyvVxrmXaprH2Zh+a79TLZtaN+LbH5+ZDrj9u+D+abshhc1Mf6YsLeDErQw0v/uThelisODCnbi+lQTvYl9ozUq6T6iPHwQ79WMeXQc6U4vhU/UUQVdynoMbAXz5Ll4RH95/uBJLP2x8Ck3bvrS6J2lF0l7FvUgj0BJqDPFUv86Y1svcfWDg1Sxh9uG7/zL8P//xP7Lh6dMnw1N4+S5+pyi+X/TqjRvDN//gD4Z/Dd8r2vRjFRCKboJ45oJOe/0LLajbzZvspd/LeKbymbRJ/oX6hjAb0y/Of3mF2/jaLdg7guJ9QDWe0L1A9Zz2Y9sNKSwynzynvWNYP/YDTgB5chfb0niS5HrczFMUsXcWO0AXtGLQCXI27rnminx/cnvUxFlaA5Fsea3OnT833Hrp1nD77G14+e59UjX7mLarq9uK/wx8gnF/m6bzKfItTXT/ptRi5YTvXcWycj2dzz027f5HHw3/7a//2t18ohq8GX2Mn6ALH1p0Hj71+c1vfnN4/UtfGl77/OfHBPlbi5Ce/XhCB3g3lPrqN0TXYzRtohLuBL2bTnH92WQN1DcodOPcCze3aW8txUlrBP076X2zWqLOPb9HuL+UQD2g+f64SAdc7+V5ObPPbTeki0ivgIiiXOTMwips892gr+emdM4JonLjPkEl6oScX9ke4aR2YM1zhrCN/efaRf5d6V2LnlwtDTXgTenNWzfhAf7McG+B95SmctVZ36AoDgFl+EWv8DOjzBiU57HeNTiYrGGg9cztnSRErHCFRZ641sA9jxc/pOgX/99fDx/85tfAAS/PhZtQfFYUb0pvwSfofv3f/P7w6S98cbh4+XIQGMiDbT+qdiBZqal99Hn0dSRhpxQkTOUqQG7a5fq36To2zbd2Uzddz6b51u5fAT85D8VFOzn3CecE94drqtXg+5D0h3ow84iPW/Kn9zqxGzekURFYkCyMm60qNa0yYiNjVIFLoNTUNsUcZQa24kbsqJ96i8whf4Zzjb6qaqOeKt+2JzXtS+pDrrgXm+S3apnK35IX1yr48eW7L8B7Sp/Ap5zOeU9pKiM5owVrz3DEmXJjmmpC3ryuEJ+/2hRa2VNUEhu4yZVckckx+yhr0Lz53rSQ4h76u7/8r8Mvf/ZTd34dPzqCr3o5GM6fvzC8/tbbw+//2Z/pG9EW0H2M2QFeKb2AZmyz0WMhtvzbpTm/EsiafVz+LKsAzXSzjiV7N1NTLZ01R4Fb7eEJ6l/Utp2b5tZXCpVrLccyJv67RuHu2Hqxtl5dPp7zVQP8RD7IgSnbLys3srlcj+c4K3p344bUEKkaFjUIa6aLfkuRUY/mTb0WWiTkP2Pon0cyMzvSo3qJ0FY/Z1I+8+lRT816jb6acUsZWzQtxUU4ssbTwF+p8dz58+49pdieqTel2FJNI68u1PipR8LS+ZqPfMmVghwdxzzGyGnrIQK5vchWO6b9wwziyesp41L+GCV16d5NxQ/s+Cm6eDOKn6j75PEx3Igeug/O+vhrrw2/A1/lgsf9zzIdmL9adR3u7wHYMHoHNeTJEL3JpMeNkzrkBhXRvRpEajJkzoq2JHFlA+tCng5tKo80Gn1cvIcdGknW/jh2IFmzxl4mecY6I4NcaznGv5kdRiPfRtZrLS0RbtI7Kk70UPWK/NERY+iVJLnzdDduSCPhyTRqEPqzTUqSFzBA46nhxLtzN6E9Zc7pp9iEkpL6I22nbmz0tasHmd4qjLkcCqxxInVtg1/K3Da/1OLH5+DTd1+Er4Q5e+5s5j2l5bMD2ytbHCjGvCkl23gjcopHV7XAvN6ozJVqs5TU+xmyyrGSr9QzxJOxI365lqChPPrVP/xs+OXf/+1wdPDA3Yje/PjHh89/9avwPtE34XtFP1lO3nund0AueLq403F9Ju0O3IE0NjbRbB4HkNHPvK0ssidxToYjDlt7zjWtocfAZL6ewqw+Gtg9kKc9ltdhiT5mMJhjx5vtHtX8HmPNmZpWK0XwsYaZZCfjhnRmkZPTxUXFNVwswGTMk56Y6QFvSNEzWWr5z0IZeYrHmd5urSNyLXdN29aaYhPje0pfyL6nlM8OM3lsbfkMkUthgswyqj+ZZyFtJnm5frb2VW//Mn9PD8avd/mvw8N7d93N6Asvvzy886MfDa+98cZw5uzZHqh9bEMHcmcZ/8u9xNCLLj3p2NhIxLXcbklpF7f01Lw4eRsg95V6vouad1FTW3t3MorPoRPSV6cXtcIepf26VmMZ358PzL0W4Yq4+xvSUnNPyOYvlbBxX6ZnfEFBQfRAIsTxSSVs++GWOhCvT2ZNt6RuZ2nxPaXPw3tK8Xj3o7vuvaXtYtUZkqSNS5A/S+IlSwCEgWL1skrsshYBtcPDcg21fuYLK+Pm87QH33JycP/e8Lf/5f8c7t3+YDgHn6D7zo9+PHz5u41f5aLh9rNMB2atFqzRlLNC5iSy8OTTJ14Ssje0dYD67P4xYd/TsWl0cZctPOG9mXUOyz4sPGZdpf6Cj+OQP7qmLCzJwbnzwtoHnoz1lHSvIawBc39D2tCkfcjCHTBOBD5JiCo6oejBh9z740odkH031mkl1mcGlm5K8eW7d27f6bwprbUhOUs4YVyq8lkilxYT4znayjh5fsw9eT/bqefgwYPhn3/6d8P/+7//b+6Dit746leGt9/53v69ogtvILW6E69ljGGcLOWzLRSDcYyDZsKaqCkgP6Mj6g+W19Ajtw6Qwz1uyHlGOxf6RT18lnqx5Vrc/pqrAfIdjl+f1mvIkvuVOWmPGOB8LqFvbs0Gfs503nwvZCSUC8ih7O37DizdgegkUCdIjSvavxS+38fUicIx6nshcu8qdODGC8+595R+9OFH8CE1jwqRS7rKZ0nb0pbOktGXOb1cIXWOssYlu7EpLKq51BfScnD/Pjwr+p+Gf/ybn8D3ib41fO7LXx5effPN4crVq+ONCoFRwv7Y3QHeYUv20sCKX+YrzxzWUFIfbRjM5zyDrwT1TPkm1k79ow+8zPWEexwHTOSNYXZiPrEW2Ru5n7dVE+uZWM9Sup2OJTV4LLyGtPZ58V7464/Fr2zRdaq1p1N6Zj9Dis0SIhBYCWxVtI/bd2AbHchcOPiEFntbytvvcdmNdMz9I5fss9HT097PazeuDxcuXhjufnjXfQJv7Q8laut2j8kqR3LgmYhKiLEVBEYuvwIqELYxTGtO9da+Xufo4GD4y//1fx4++NU/D597++3h+//+3w9Xrl3bRjnPJKdakXTBVq2ZrnVKAzJ26EhyV1V8ssFVr6IeKx+WaVyQaL1UF0RcgkGBEReZT9JR1Vaox8WJnmCNZt9WKl7pXImjGbbQp2aMGYGuF0tr8HjFPov17117Fw/5PdrP/PO779s8M4TM6Ps+dd+B7XdA7H0pxj5RZMTJH6uL09QL4CnuX24H3Ltzd7j9/m342+g07KJyjXEL9DZTOzDXzo3Zg7YeXWP9VCd+x+hP/++/HH7yn/6P4eOvvjr8mz//8+HWK6/MqqGkptz9WbQ7m8z9CAu2vla/wNhv5kfWTWpYv8qtMGy8n3SyRtXWziWlE3N3ZO2VrqU0iR7V+hK1cdKUa1hK/yQV/txeQwP0s6WPrg9r8E/sh5kW7Q1eOwzu0G7fkEbgpoAFjSi+ZWEWpNxD7TswrwPiHCGgk7KH+WLRcaGgGruOlR6xjgLoSelpoQR2HR0cug87enj/4cLvLWWKEzTAlW3ZAbtR0niq9Ogdd+6jw6Phv/31Xw2/+fk/DC998pP+vaKvNhWl2Oacq5XzsEnMjgYt1qOp9cnezlmjqfzPWJ5bz13to1xr0Xf5GLUr+lc9L3wfZN2iHeZQ6TEjxnsAFbcD+2DV9YQ+tvRwVQ2ZtdiWuXpDSsJaGkexdFSbC41zN1h0QZiiibTtj/sObLUD0V5GLWvvZ3U+zj0XW5pn1Mhpa/Bn+NbuK9fUMHjy+LH7rtL7d+8PR0dHDRn7kPkdGHcAbQ+99dRZUaXSuTqc8Mn60fvvDr/4yU+GJ8ePhq98/3vwvaKfdy5Uw6wlQALahWNcHGja9nl14nq4C+u4oxr2a7nOwnBfEX6pa42/FuTOf+Zcim+d1jShulrWqAN6mOufFLYavyTZobF9Q1oSaDwwYTg1lzcjGldaSISmH+Kl+f6478Az0YHKedZbozovMXmNc5NECe14fjL3mpzEXTsKbRS66WsIvmz38fHj4c4HHw73790nGfvjqh2IV5l35Sqs//T3fzv8DF6m+5XvfW/4zFtvDddu3BgG/72iinkXzomlOrDBc4t7+Cz1b6l1OGE4p2UtuU5cn3jfRudOfLVaYkmL/CWCTm2OJ66vhL+jvtXqgH62ru9qGna159n3kO6oYCfLnyC5RVUn3oQ6crgToPYpPR2gC98zcDHrKXtSLPUqSs7t3ew5sWSvo/OSOZfkiOpdZWr0NtfXOfx4Y3r/7r0BP4n3+NHxHKh97o50AJ8B/80vfj6cO/N0+OYPf+BUyb3D5wTpPWnnBumeelzg3OIenrbeTe35Duc9i2vJNWHfp+5RcZ7I68caS6n0Zgh6NDDe1NozGjZpXrUGWNuWfjoNJ7iHU9bL/pTdKUibyvEnarygvIFQx8xFLH2c+6bKPHU8dAGeuXanpm+ZPvF5QP2MGiLPGxcbx2VwIxh4SYRECl60soZgPlkjoweqJqN2uxvlsvErt64/d2O4ePGi+87SQ3iPKX4Azv7nZHbg7u0PhvsffgBf4XJl+OI3vmH+0ZGcH7SXjD13MrtQUW3Uqc4tTKeeCCg6v1ysgSFC98MT0gFe92dgPRevhXoC5wJh0zmw9PIujcvXOHkeUz1Li18Tbw3N0JOl+71mCzaN3f+S3U0r3BafPJlAQ2kT0QWjRWoJpyV/H7PvwMY6EJ0DyNuyf83zYY2L+8YasTCR0dfH8MzawwcP3bOlm/ve0oXr6oBr3Q5GqzpY0tA8r7lrPUDY9Tk978NXuRzdvwc3ol8fnrt1SxGXkFVgxOby8oKt1L1t34HmDvTuSwkczghpbR8z9zO0v1eryV90Sj1fmzte2ZKWOFbOWScZd3D9ncY1dDWsI7cFB2toIIIdPe5vSHMLI/7yiE++5KRCjCmbR3CQjJiL7GsczTo6iDaptUPWPnRTHTD2L1LH+yLZZ1POlU3VtEUefAnvEXwq6907Hw0P7j14pr4iJl3yZFcYnQ87KbPVjBzbNI0/xrL1PDk+Gm6+9OJw6fJl972iGGVWl4qICfbzGR1QPY97bWygsJozSE9garFPPfVEPW3tJ/PHa9TDvcOxXB9pnFqn6G+ut8w1lYM0zj0KrQSV00x+Oroatq2fxMBxNT3Qo5aerMYvatzV4cl7ye4mOulPLrl5+MRH/qVOHgOHeYwTHKmlJpz3/jA+Jhr8PXj7lzb3dOsZjM3sH95juT3s7RwXtyaDG4c9a3N8Ce+ly5fg/5eHu5fxe0s/GJ4+mXvGb7dLeimzK54RSfHwsjU/zGypTP5oplw/K8aWnSgirMfjR4+Gf/7p3w1f/O2vDS+8OD4rivqcVJIub01DapnmtHm5V/XCVahe2HJyHAsLJbFOw9JwvXEvyp3LeyWO6Gepl4tryKvbmieuP/47qUdYjCVzd6qXci94kayPROcu3kYupWz66DSvoSdX+6YL3HG+/TOkuQWiDbTG5sxx1uykScSVLlgUpi4Ma9QjdLXoIV374ynvgNg3shNyD6m9S0Fr7GHC3uZRFg46Dg8Ph3t37sJLeR8k7y3NtG6b6hW3XiJzFVV8eRIa01v3sjpQ5dPh3Llzw8VLF937f69cvTpKJ2HjXzTlcvbepg6EVs7dPyU6v7fgEHZZKb7Tt6b0DiksQ58QHQiNof48sHo5ricraQTch1kd4C6uvZ4W+TNqW3V/wnlhnRNxK1fVEJPt4Hz/DGluUXbxRJea/IUfN7C10bdxwbJ05Nq7t+874J72MjYN791ciziHB+okeCoAxNCjpZYczbbtly5dGi7cujBcgJufw4cH7j2mpEleCsimj6I32sEzuodiwwIDrWtOr7X+Xq1BxxwNuiH4DPa169fhZblXh8tXLsP2FdhyrNP2s9kdwL0gej0bTwIgrt5r5HWMilZNKGzG0fPqwwy8NJUVUzF2qWniXEvE406PZ+gc4b5Sn1priy5kUZsIre3YytmGto9aq5+w5rPW+RStzJlfvfu+6pWanKJGnKhSxUUtXi++UK51csWN2p9scUeejXm8sU5sVbIQPjtOVDX43lL89N3Hx8fDg/sPhnsf3UueMZ1WkOxNiiAuM6kzsqSXmzm91rqm65ijQRd47fq14bkXnh/OnT8HXyd6Vjv3s1U6wKuXDhbkg702/qcww35mcuXfzEScB34oLFUJTjnL50E1b3rA2MhY46hjE/ygfGUahg8bZHq7MFNc3OK+5YAX15AjOkV219Ol1jTqGz5+t/ysqaGFfxdizvzqvQ/y3co0Mp+wCyWdAg2wLnIN+AKFpa90UiVd9XtD6khi9oZ1O7Bv/rr93VH0R/DexY9u33HPmOKDXesDXn85rRtMXYH6aVRG4Mw8/KhomujL3nw9+Own3njeeP459zUuFy5eIKr9cQsdUCvqJsrSqcjvMX1gjLCX5nAw3MqDcL7YfxRsqgbQYfRzXKpNaViv1WMdHj9skGUIowudWNEEnzu5tIaE6fQYVt2j+Pjc0Mr9uo5NKt+Q5hopTqCWZudg9vaJHRD9dwibvDh57v26d67dvmGdDduH1zqAN6L3794fDh4+HPA7TPGrY072TzhJ4ktcqS59+eOH9lJK1oc3oecvnHfvD8X3iuJ3iu5/drMDaqXVxNAbtpZzRlOV4KDCL+XbT6wOQDd9Q2VfxxbWFsbC2y2bqkBfbJYRSgSVv60ozD0NHCbLaDilKK6Na6xp1M/aPxpvSkcka+em025IqQzxV4O8EJF7f3xGOgDrbK2vuiYudVKLPSW7Z/FLP4+bAzkjvMpHFYT+xBCS3EiQ+aGwRLH76b4D63QAX86LN6T4ct4D+C7TZ/HG1L681M7Pvn7je0Ovwv/4gUUXLuyfEe3r3vRoXkUeIJaaNICnF+A512JmTwcNWk5ZSPT3QWgZj050Q7gK+yK0bG3+7x+5d5kfmTahwfEsW9auornebqqnu9qEHdI1/YZU3DjIkydXmzqprCDaFAJXhrVwyPj9eIEOlC6OtF4L0DBE0yKLIHvIcKUB78d0UEqr+LygGboqBHv3vgPZDrj3mcKzpPiS3nsf3h0ODg6ysXtH6AB+QNHzN19wN6Fnz232/aF8+Qly3EhcQiLPszN1tXMDeLBSgaKj9rDIq9Rp4cW8vfNkd4DXfY2/d052a+rquXn10G1EsLz92m6j/SbntBtScdMoru1MwAtNlqUXXPAThaWDfPvjjA5gr1vWb6cWwIsRmnDI+9INeDajOblUYIu4c5F7+74Da3XgITxbeuf2h8Ojo0crvs90LfXr4uJ7RPEluTdfenGjL8u1Lz0t1yL7giKs6zZsQXTdg5baFyQvQolu2kMzW1WQn5i5e+PudoCXsuXvn90t42Qr40VYvgwHvV/b5Rs7A3Ha177gIkY3hWrfrL3IBj7zR7qoN+LxhUz7Y9wBs0m41nHgrs/9buBNIW5GNyw91zohrV2cABPDDVe0pzspHcD3P166fGl4CC/lxZvT4+PHwzE8e4rPpJ7WH3yPKL4k99qN68P1G9f42rbm+cTnuhvwrHMJRJ49BDxRhT3s5Fw+PLRAFLE8zUREockeAq5vrOgvkvGUB8EqoNAorveJZ/Tvf2+9A7wyxt+aWxd3mgSo86mzcF7ENM+59mubNmbLlmnPkG5Z9Gr0xs3snPNhls6tEc9SvU/GP03G/7gXfF0cr4JsX38QbSI/jazry9gz7EQHjuFrY/DG9MG9B8MT/9LenRDWKSL8HcFnVgbhKby44+z/3965ruuN4lg4qcpM/eln7v9OZyrTlTTiM9oLDBhswGCv3enyCaSlF4HRPn6T35ArhagU6H/ILyoy36IrRy0jgvnqjKl1PZEn3oVr+pAjrAzx00txlo/bJTeTd46DhbtJ/Zp59kSvku354BwBJfuVsOcMsdeUBLqOrxqfMvTpRbEgrRmiMwVryZumRgPbTk4AB3yF1Qn0bqdwZ3LWlFdLQH7b369/ftlv4f31659vP8238/79v/9nvnL6729///13rbmh7f39YXpuyc+Eym/K/euvv8xXQ/8yxahpazrLt+j6HybTP/+829aymtcTr817L2B12E7hThLLZ+zIMgnIewBEI6dK0Z7olWeBFxc+deQvNET5MAKfadN53kCtIFP40GdnOasMIQvS0pGCF0O0CyQgPj/qhm15TgLzEYAM3k7hzi1yk2u3PEiIS9y+Rf9sTh1P+V3aP//+ab+K6gpVy21b245+dX2vuPz94Uet/AyofMjxh/mNuPLVTyk4//U//yqUYSL7/NP2jkPRz8xrL57sCeBsU6r7ZrxDAg0JRDPNXzwaeqOpFQnYHOmcE0fvSffuasIvmvRNLF8y4smK8TZ7CnxLOGfvLEhjJByRXsdIwXqHjF7h0e5bCWxZHCRzcHkJjr+4OVPeXXfz4OhrbanxwPF0j5WePdErT6e8WN1XTuX48+dP+9XVf/7597ffv34P+fMy7l32xx9/2oLzu/nW2z9/fP4+qHwbrnwVVK7LP8yo+2lgu35hiLMot8+WJEACIwl4M9YtGCMFnPEV2Q/yE2FnQNb1aVoM5lynCi7X58489SaME3TtqCbPxrXxOvdLja5pz/d+6i4xMlA6iDkisYXLtH8qphwKPpuRwJbFQTIHlwnhkMVwahtbA2VWEsYjtzd7ejBOwS+cRvquf0tp2hO9SgYmL2/5+Uv5v/0wgORvnMqflZFfjCRF6v+bIlUKVSlQW3/8+O8f3/6wPwP6+bugf/6XKUpNYSrfjlv/YfR9/nldv1Ac8/A68oIESGAuApE91lwCQY1oxb3dStohjJVOh67wZjyH+qsZiMavahuny19nuzb4jdeZN3tN6N6Gr64jW1sCbqADHDreuKhBG5cXcIunJDAZAc3iCz/wczEkkRApVJxVUFivESYhnDrTQ482jq//7HwX6TP9/zBfjfwLviIphan9rb2ege3CHLzbxqsvwV7ttLgb383Pfsr/3M+AuvuhTXc/ffwIwX5Ox+deXkfaLp/MToAjO/sINdTn9kKJPVNDT21MraKzTbS3Wvms91wNhg0CvmxLnG5Dc64grXVWIohtzhFILGo69dwiDdY5fACDp+8mYCZDOB907uxPillZm9o/7LZ5BMdwGja+fC1LhPl9s5ftxAzIt83K//0PE83nn3fbKvj6j/es74Vx+t0QcJBv0dA3QlqPE3BDHn86512bnnNK81Sd0dljPJxN1SN7nsS+yAuAF68g8FnuNTteEfPQIFvMtW0SfwpSN6OHRkFnQwhEkkWnZqRYFU1Mh7KRUY5lzb1WZOzhaHZxhiv2+RRvIufK6B6Fs9kGF3BqOm+KQBicHhnX59bm13/0ft8To/TzT934EvxItVH3E+P3LtfdY6ODJxE4M9dbx5+aKrv7kf1FTov277D3QG7fQ/uVOnMx8BkJkMCHgM7nRkB+uL1PI3s0sxKBxCJdlGThgm/ixhfCShiOtCqPBK+j/rHn1iYwvJvd3f5jjPrfM6Pw+dffVZWHLeO2g3SF0ypLwxpvuYx5ZDV//WeYFDoaT8DLz7PrJKyHEgHm0viI3u0xZO/G9/fZsQ1xtrAT5Au6+AUXVvvW1sXBr6ACoAef2vFukWsPZnQ2NJ1LZw1E+v0o/q1TMPnDxSpil7eeTiAyyTVBIVdCDKvljsYUiTeMrfpabGZYhfZi7FQfNI61g8c8JYGGBEy2ff55Nr+mSyxDvaa8WJiAju7XgJ+PxtmA4oFr2XmcrXraMXZj08poCzsZTZqX7v26tW2ZT+qjRSy00ZwAx6c50r3BzBzcNz6+U/4zpOB4N9Bu0m/+Wk764xDYYjoCkCuhNps7Qb64NrPlzS7PndDCY008R21FS1RPhPWuXYT3kb/CENns1QRMFn3+KQWbe1//0fs8eR4BXWcia9ClaJ09s26Jj6trVQsbl+JZuPNnKutIrxeJy6UOyq/mZShpYcphKPNcdxz/eYIcr6RXrpYXpLmYg0HfiYUNcetJnJPFZ5MSCPLFqdS8gXxxz0blzSg/Ni4TZ86f8pDGCWaOT/YY6au2I6zFVk5X1hcfvoiAySL3y4I0ofTkRRxeHqqsIZE1ZiSVZNZtupLPJ1//krojcFuv2db3zeMaCfOxt1qOX03e9AK605DLJZiHLTjsfPcK8s12c+N5kkubgvTIOQivSpTGSXokk8/vI+AtQpAvVYogX7CfZxsfHJxjv+pfknBSizc/znI4iMt7nPDh6fA6wMXJGMECT5cnYDKlKFmWD5QBBARkfdShd2tBYj0JuuYvnS3TCtfgsJP1fdVfor/GFToNr0ErPsrpxnZ47vlM6ML24bnXXx4G2mo0NWEbCpzkWjmdYKwhGLY1PLXfoJM7tIU5IxqU9VHcMBbFfY5s8vlaBMycGlOQnsVylKTbgnvH5Dsb0pP73T4OkC/IWRe44AXt2pTo3rUJbKkPY3TX1jmqOSZiqTHRvW1Co7IIGImeJmy6B0YHrQloTjjDLneCHGF+OEBrHMPxavGJu9BmjMQun2KNRtxzeRz4Un1BfgfNvi4Tdr4anDhzNjcNoumIrep2fU+4nbWLja1VXMaOtWfYHjGdlUcXXZJrwPgqG83HLmJp9AyBpvMoEDB3QRqI3V1uiR9NWngRXJ0UO78PvvFoVrBQ4hBq/kDO4PMSJiVt0ObhebCwH7afsUGEt7IWvRd4zxju2zV5YxsZ+ygfbGfyAW00n1NRAbzZksBuzGCO49iiz10ffBg59+zMvk5ifkdiGXJLNGzjIOxSvJXrDJobg7Gx9YjL2JRPwqSYloah7DMdrvrImG7yyOkriaXUobNZ2t61a6nB2eSxI4FtfTJ/9sUMeY+J2lF7kWmIKZqcG4CzCV+k4aZGT4xpCErIGfRn82fLF7wv561Ziz3NV+czoSvUstx1Iq4cb4mxNfPluN0sWPNTdCTG8JREZ2vLe/HDsT5FcspOrcbSWyMlUskXlztTRj6/KJ3TD+RoY5soLmUtaVGhy+uHKeX2CeZeqzmG5mvPfxs9qrUivlo/ufZXOKj2nIOXPrNsOo2pjNkPO3CQ0EecvcHqJOxIQ5Pnm3YvniPDwKk24WvbH0nh88EEErlelD+QN6g6lRO7+5H+Sb8Jneh3ifNMHMnYMbAIsx1XbM/zQwLKPTM2h0YaNlA9aLNWWyRPnLm358uOby1bBzI8JpjX8N613Wx20xzGsNq1GzvDacdIYnHPV4vrQK+NtWdshucuFxOaummB+KJjm9Dj3d7mT2ksXt/IhdrZ7Eaa+HkIMcTajryn2gc4PT1eA7Td4aL6W3a9wQqSzYM7UYI1A7vF5DFA440nNZrm+cIEEnPBzpdgDmGUyTwzjZLPjD1vHqLBhA5s8pjzSKzK5STzx7A5EYiyi3A9Ya6oSzLHTe9mejLxWB+JXMlpKwpu4kbN2KZiTDBXvxeY78Zls6W2Q00JLWGzx1y/KF475j3jTeRpLFe6a4k5rbm3cUrOE4h1N8dq/EBbzw7Yhybt1nk0OtG5x6BQV3KMCvufbdbNrxl7x6G6IM0F44zaNkGCecH0XCRyAiPPPM2R51W3cpMaeDT1WSWQjacjkJkLOmcgd5z+XA4ln2121K4z5o4ZLa7JI46ZOC2bCG+JO8n1EVDiQWiuZJjFe568u7FPsbZ6RmmREBK+lIu0ieRLSr80n/lD40rEPUR7wrdqi/B2ulLcU/fd2KltZ8gdE1rcYx7nJGDHs+fYHaxTSCWZW9ho9nNgmYwH5mVyvlXGqXbAtpjoPr6VOkc2VyYVTpNjVmHDNoU8qO1a0v7H95iDislW4kTaeBCD5JLnHjDQJP28Z9I48+H5ybQb/ghiisYDTKaNYTg0OrQEIHccEc0hyBv3TI65HEo+22ypbTQY0YCPH3WeiNXjEuGe5LooHI03waNpWBvPFMOhWmoDi/BRvWJrgVxRvZFYanF0b5/RqHFEmNuhSIhL5Z0bO7Ub9s9oCZvyegwBO1Y9x+VgrcIoNW966kGHd55DjBp3qKeCXdgVr+18Nba6jzU6Xfg8ub4lYkqOX6L9lduoLf4V0i2xqkTBCwAdhEJTz7z7YEv6e88Cg49JyJLJHMTuXpbudo6Ta8PjwwhA3mBkRXM3mGfSX3JI/l/UXzq89SPCvYhZhLkgnGnuahyRGJsP98YjFb9qEccj9DQPMK7biyvnc0C+qJZV+cb4JWLRWGN98F6EezRHI+3QjPWX0ILteN6GQPH4XnQXzYWUTY7/F5mNxahx+nLMsxoCYX7LeP1umMc6/sH6GS9Ia5SLUGmfExs4rTSfbS6+7d8+y/nPWlj4YRCzDrILCbiHCeaa8PhiAkH+CIldDr0YT5fQI8w97jBn0f+I+euNfUInarp8vsUai224lsvBdDKQGAflcyFf1IZIT/jpFNX8ZiM8PF4H3HdtI/bmh7CWQmXek7UZ99h6FSNl9fTUEnPKeySwAIFwDrnraEHqHjaLCyalLhpoHBb35r7Rz9vOc9zJ/G3ZsEa8kJev3CTDnMUB03UT+WwNrq6ZalvsJfyjlsvnEENM+3A9lwO60UBivDyGwFuVJvrpc57kCST4edzzFvi0IQHlnhiXJq7MPIqtVzHbVk9PLTGnvEcCHQh0zeVtjri/5fv5sy8dgqgyCRNXFxZngC9TR6LtMcdcPAH30kW4rUBaewWBLc/CHLPrgDyDPH0Fj6MgIzy8NRPmLZoK+bpn2jdi17VpekyMt/MxXI9z/OTjqLF9MkPGNi2BIWuGWbdSa2gIxurhnAux8JoE0gTMfJF5E/0KabrXDU/umNgVi09IZMjiGDrtcQ3cNaYjP8FmuHQBPzLL5w8msOVZcY49GEWT0GDeor3b+bIQxeHgOQmQQEsCiXWvmQtjX9fQYH+o93traBYMDZFAGQGb2wPzev6CtIzbNK20CAuKMxH4+IUrSFyNF0fnYGOKTXlOAiTwAAIHc370S+8BRBkCCZCAIXDL2oHFKUeBBEigGQEWpDGUsuAEnwWLNau9lypWd4VbUNjV+pm6/RbbLmYRfbBxnTouiiMBEqgioGvAk9e7KiJsTAIkUErglmK0VBzbkQAJVBNgQZpCJkVp+GwrmOS2FpdhmxPXO1vgR8x5Op68eSsoVoXHjpfc5AcJkMCcBNy8lnXtyevXnPSpigQeR4DF6OOGlAFNRuCOOcaCtCYJYDPlFYlHNqDAPFNMeX3A1pHbOxLqSNPp5zexP62XHUmABHwCMIf9B7wiARIggTICj9rXlIXMViTwbAJbXcOCdMQww0ZsV8hCgekVng10WXvG/nfw38DsWiYg9h17iaQj/7VAUS0JkAAJkAAJzEuAxei8Y0NlzyHQdZ5te+5YvcOC9O4cKiyYYoN3t/RH+M/xZ7H6iCFmECRAAiRAAmsT6LpJXhsN1ZNAMwLRL9w0s543xII0z+f+p1vBtEsSKJZEpBSs2gaKrPsDWFgBcFS2LpwIf/eIRxIggf4EdE7CPC32CvOXn+wrpsaGJHALAZ3ro7xv64NbG6z/M+vMKL30QwItCfTM9c22nVNmnrk5JvJZkLYcxJG2goQZumAHSRSG/YrF+yx/boTDdOE1CRQRaPqjBzB/q9ZOzt+isWIjEmhFQOcnzNlWtnd2Ensbu2ne5v4r9jc7MLxBAh0ImDmt89uYZ0HagfHbTcriLX82h79RM5IJ8FLFiagtueFVFDwhAUcgOlfcw5FHzt+RtOnr5QR03sO864rEbZDhPWz9jfLfNTgaJ4ECAjfmOgvSgvFhk4CALNpmwXZfateXhjS7MZkDlWteAj+Pq0QDL0nHfs0gqbo3gV3uBA6XzB/Jf5gfQUhzXIK+6BhwDs8xTlQxPQGdPzCnhom+w+ew4OiIBOIEdM7FH3e/y4K0O+KHOjAL9t3J+1Cy6bDgJbljDxtdMbBkwZGOnE8SBLw8gPxINNfb2m/Lm9nzRfRZzSsUpUo5cgJjpGOAzWAezz4mKJvnJNCSgM4NmC8t7dPW2gQ0PyJhcN2MQFnkFgvSRQaKMkkgSyB4cecWbM8ON8AejhUu7NgG431a92YHv+PhtK3OHXWjATm7y/NWXDrHkjQP+nexJTttD4CLsjrqw+eXCOTGqPcYeL4hby4FNEEOaVytYroEhJ3vInA2D7SfE25yuvdcdK5WPlpuN885FqQrZxC1k8BVArAA7RZysT3BBuVqiE/pr+MDY9YsNmOzZ1HqtLfeGOzsQb46Ns739N/u6wSfPUJeaMxoC9jsuGE7nu8IeDyB864h3LB9NuateTf9BV+gGeeIF7NrMyqHChk7WTw+i4DmXos8MDbcXGw9D59CXXnfHBAL0psHgO5JYGoC8EKILlqdNlxTM7lBnGUPY3GDhKRLLy8ONHptnUXY5Mqt1psGtRf4EV+engPt0n7pD4jPi1uCAjbKa+lg24i3nIBbtdWtr7XTaK3sVoyWBAcsdjnk+p+MU+2BD2eSxxcSaJ0Hxl7PT7ouP0KteZ8AwoL0BDR2IQES2Ahsi5huJhAMN7lI49S55TriRWHGqqYQ0fFuoS2wobYdsY555MUMfsS1pyPQ6KQ95gjxeXG7AAM2HjfX5kFHZQBcLoe32Tq7KbaaWuq5HFDCgIsz8Vg/+bFCLKkYeL8bgZnzXNcFif5M/sI6Ossa6sXUbVTLDLMgLePEViRAArUEYMGuWvRuWrRVI+guDtlobv2C6f6VkI1zqe5LfIpBRhrCeKiGSLPdLcgjeVYap7PjtQ9suTapo6cT9KfaT38/iMGL70g8sPOYHvW76bmNLYi3tRTxUcNihKbWMSbtdWab9MsHJHCSQLP5B7lvbdbq6bWWgq5aSS3b/9htenoF3FI1bZEACTyXACyOu0Ub1icBULOpiwFT++Az1u7wnulvbRl9TTRd1XMkuFKnja23piPNtc8DvTrWzg7k0tUxcybd0bMHftxzT0ug07V5zBHi8+J2AQIfj5t7PvA4Ks9r4hylaSBmuiKBKIGuuV75znMCu2pyTkqPFWupmIytMzYeeQi25HKGj/1XSEGkChelE700ZgBHDSRAAjcQgPVJvHtrlNzIrFPaNrAh3Zp9GNuXviVPhPTUJ/YrX8y7T1qKjSd8AGfNDYwrk0vY7My5t1Ewfqx/0HPG5rJ9IO7R44DMRo2BN/YoIHI+SlPENW+RwFAC0bnfSgGs5dUmYX2q7ju6Q6C1K9MOse0L0pQTCDQa5DbgNYttyhXvkwAJkMApAkfr1Cmj/TsN23iadbp0jR6mqT/ecx5yuRRscEqZpoRIf/lERvdPRqQEzHw/Nw6iG8bi7DiMyvXfoPUI+ShNRzr4nASGEYC53trnmbXBzsHWQmgvSaC8IE2a2B5siVQ8gLAwn0mUIzl8TgIkQAKzExi+6TTrtPVp1l9cd3Xd7rghmH0sqvQFnJRflRE2bkIAxmLacQjm21HcNg6I66g9n5PAygS657uZS9ZHxTycdi1ZeaAPtLcrSA8c7R7DYrsbeBarO1y8QQIksAgBefllXnzdX74lmNwLuqQt25AACZwnkFkLYkanWB9iwniPBDoQGJrv7r231Rjuk7JeDQK1SYdwaTJD4L6CNCMKv23JSxTpw2I1R47PSIAEZiDgXnwzaKEGEiCB+wjIWlBYlA7dnN9HhJ5J4F4CW9G5qy/uVfV673MWpLlhgc9e7JKJxWqOHJ+RAAmQAAmQAAmMJuA+QRUUprqHgX3NaGn0RwJ3EeAnYO4iP6ff9QrSHEdY1HWhz7WXZyxijwjxOQmQAAmQAAmQwFUCrjC9aof9SWBxAsV79MXjpPxyAs8qSMvj/mqZK2JZrH5x4hkJkAAJkAAJkAAJkAAJtCAA++8W5mhjbQIsSHPjB5PF+2wOFKrS3f1gdM4Un5EACZAACZAACZAACZDAmwnwW3XfPPrp2FmQptmkn0ChKo28YlVuQMHKYlWA8IMESIAESIAESIAESODNBHb75TfDYOweARakHo5GF1CwFk8+FrGN4NMMCZAACZAACZAACZDAlARgjzylPoq6hQAL0luwR5zCBPWKWChUpRe/4hphx1skQAIkQAIkQAIkQALTErB7W9jrTiuUwm4hwIL0FuwVToPJmypWWahWMGVTEiABEiABEiABEiABEiCBKQiwIJ1iGE6KgGLVK1TFHL+yehIqu5EACZAACZAACbQksNujRIzzE+sRKA+5xa+OPmQgO4bBgrQj3FtNQ7EqOkpeBixibx0xOicBEiABEiCBZQnoPiPYf5QGpP1LOvCT7iWUpmjDYnSKYZheBAvS6YdooMDgJeK9HGDx52cxB44JXZEACZAACZDA5ASGFx25/YpjxX2LI8EjCUxPgAXp9EM0iUBY/L1CVeRx0Z9kkChjBAEv/2FeJH1v84OfyEkS4gMSIIGFCQwvRktZwfrsrdvSn/uWUoqX2k2bG5eiYuceBFiQ9qD6Nptc9N824q+LVzczkOvFELY+31mYFiNjQxIggTUILFtwwFqu6zsiZ8GKNE6dL5sbp6Jlp6sEWJBeJcj+eQJHi36s98AXgb6IQGdMUvIei4wkmtUfNH+ZQmHKr5aunh3UTwIkoO/PJ6KAPUF1nAP3MIK++bsKx7MyFmUF/NAcz0kgRYAFaYoM799HABYyXdycmsrF0XXDY9PFm0UGon3M+XfIwRWC2s2ThGgWwgkwJ2973GtypsE6dlIyu5FAEwKa+zV538TzAkaAiXJC2Q3mv9oFX+ii2TnYV5/NjNMQCXwRYEH6xYJnKxDILY6wyHuhQB/vfuMLWay54W8MdbA5+8LtnC9Xc0Q3BSd0al/hCvPlqqbBw3SruyY5AmPnjUkwLvby1mjpnAT2BDRnIY/3rXgnSQC4KUvXGNZld0uP0E/v8YQEHkKABelDBpJhGAI3L9Y9NvW7l1Uw0D18Bi5ec2lZ98whs9E4O15dtEGsuzwLNkVndT8peZQRcOsSX2Bf/aIzGB+ODYLheW8Cmo9Bnvb2i59As75G++8e4ObgqXGN4kc/yxJgQbrs0FH46gRavNjVxhEMbmCjhJRfz03AyUJ0iLYoFXMz4KFaUu3d/QfnmRR+xRwcj15HGJ9iTTA2IouFbK/Bea5dzTXIvy7RlqyZWz5bTb31dAmSRkmABJAAC1KkwXMSOEvAvBDlt6imNnn6Ihf7d7w8waenRfTARjWlX5o97aP7RmbjeoZpd229BjOXZ+Jz8VyTsXS/LfmWeXxl3GBsxAzXgSswX9w3yKMuJIyP3PsUfS49JzEQnpPAywmwIH15AjD8hgTkJdrQ3DBTsMHY6V+8gIgx1Bgh7li7S/cMtzOFqPi0+npquxTYxc4Ql46DM7lIrrlxXbYwdbzD4wPGJgyJ1+0IDF+XTD5an5G11Fs7IG/bRUtLJEACowmwIB1NnP5IYCUC8LL3NgESwyIFBOLuvqnamLiiBX2XnK/2231LYipuU5hrYu8s32ItBQ1VgxlznRsQQ4GJdZpAXBorql9wLUD5PM8T6L5u5tyb3IvmXK4Pn5EACSxHgAXpckNGwSQwCYGjTWpM5k0b1+4bqquFqLACnjF0r74XsCnaoEKuCTstIDuAVNuBz5wrL4Ygvly/KZ+Bfi+unNiAlTLM9eGz4QS6r53DI6JDEiCBGQmwIJ1xVKiJBJ5KILdxhQ1qy81p9w2V0X1Wr27egctTh354XAFTZe2EdMo3Z/7o6OUMaJF+ntYgjiO7yzwP4vJiliCAicdqwgA97UFcKneheJxmG1cqHteIRxIgARJoQIAFaQOINEECJNCAAGx8vA2emC7YzGkfsNNAVd6E0XVms3yL1nwk73sKeaLj4SgU5Jtr2uPo5RRoEV87rRBHDy232YS4djEDE4/VALGqBfQVuYX2asN1vDEeJyE8Wo2gOXzOaxIgARJoSYAFaUuatEUCJNCHAGyMdpu5Ph7zVrcN5JnNMDd6ebRTPD3KtxsLiF3OgRZh580PiGMKrq1EQFxevM4+MNnxcm0qj13n7Q3x5MKPMs114DMSIAESuEiABelFgOxOAiTwMgIni9GuG9qXDcHt4R4VEDGBUCTJ41aFUujKsxv4DNvitVeEQHzYZplz0O/FtUwAgdCz8cD4e3mxmffYgI/AOy9JgARIoDsBFqTdEdMBCZDAowjIxs1s9GQzF9vkxWK1Gz9u+GJo3nMvGH+vGDgoHEZA8nIZ9IhvT2sQxwht9HGSAIyVN4YnzbEbCZAACfQiwIK0F1naJQESeC6BbaMX/vF23fTBRvC5EBhZMwKQL5pDznhQHHqFo2vT+ej5DPTs9EIsnWXRPAmQAAmQwEMIsCB9yEAyDBIggRsImM33bkN+gwy6fDCBoMDb5RsUiF7hOAjJzifoUa1BDIOk0Q0JkAAJkMAiBFiQLjJQlEkCJEACJEACOwJQ7GkBuGsUuQGF466ojDQ/c0vtGl9WG2g9Y499SIAESIAEnkmABekzx5VRkQAJkAAJkECaABSHu0K2Q7Eqxal8i/s38JsWxyckQAIkQAJvIsCC9E2jzVhJgARIgARI4IgAFI1XilXtC/aOXPM5CZAACZDA+wiwIH3fmDNiEiABEiABEjhHAIpLLTjPWerfK/hKr9UL+vsLoAcSIAESIIESAj++VyzOv2FxLzHONiRAAiRAAiRAAiTQnYDZn+jPrCac2efbPobFaQISb5MACZDADQSqvkKaKl5ZqN4wcnRJAiRAAiRAAiTwISCfXK/4pDl/ppWJQwIkQALzEKgqSFOyU4WqtGexmqLG+yRAAiRAAiRAAq0I2L1I5iul+i3GFd8Z1kob7ZAACZAACaQJNClI0+blF+rpK8BrxkLVw8ELEiABEiABEiCBqwTMniO+67hqmP1JgARIgAR6EehekKaEpwrVVHsWsCkyvE8CJEACJEACJEACJEACJEACaxK4rSCtxZUqYFmo1pJkexIgARIgARIgARIgARIgARKYg8AyBWkKV6pQlfYsVlPUeJ8ESIAESIAESIAESIAESIAE7iewfEGaQ5gqVlmo5qjxGQmQAAmQAAmQAAmQAAmQAAmMIfDogjSFMFWoptqzgE2R4X0SIAESIAESIAESIAESIAESOE/glQVpLa5cActitZYm25MACZAACZAACZAACZAACZDAhwAL0ouZECtWWaRehMruJEACJEACJEACJEACJEACryDAgrTDMMeKVOeGxaojwSMJkAAJkAAJkAAJkAAJkMDbCbAgHZwBuWI1JoUFbIwK75EACZAACZAACZAACZAACTyBAAvSyUcxVcCyUJ184CiPBEiABEiABEiABEiABEjgkMB/AP06GMtjyEqaAAAAAElFTkSuQmCC", lwt = (e) => /* @__PURE__ */ Ie(pi, { gap: 3, children: [
  /* @__PURE__ */ S(Km, { modelActionRuleItemValue: e.modelActionRuleItemValue, model: e.model, onChange: e.onChange, ruleItem: e.ruleItem, ruleColumnId: e.ruleColumnId }),
  /* @__PURE__ */ S(Rw, { label: "Modelle", multiple: !0, modelKey: e.dynamicModelProps.models, onChangeMultiple: e.onChange("models") })
] }), awt = (e) => {
  var o;
  const t = e.id, i = ie(e1(t)), n = e.models.filter((l) => l != i.key), r = Ei();
  lt(() => {
    r(Kx(n));
  }, []);
  const g = (o = e.modelAction) == null ? void 0 : o.anchoringSelection;
  return /* @__PURE__ */ S("group", { position: e.position, rotation: e.rotation, scale: e.scale, children: /* @__PURE__ */ S(x5, { modelKeys: n, parentAnchoringSelection: g }) });
}, swt = {
  type: "group",
  label: "Group",
  disabledForAR: !1,
  component: awt,
  propsDialog: lwt,
  defaultProps: {
    models: []
  },
  materials: [],
  repositionApplicator: Sc,
  screenshot: owt,
  tag: "beta"
}, Iwt = "data:image/png;base64,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";
function Bee(e, t, i = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (r) => {
      n[r] = e[r].reduce((g, o) => {
        if (o) {
          const l = t(o);
          l !== "" && g.push(l), i && i[o] && g.push(i[o]);
        }
        return g;
      }, []).join(" ");
    }
  ), n;
}
function cwt(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function zf(...e) {
  return X.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((i) => {
      cwt(i, t);
    });
  }, e);
}
function dwt(e) {
  return typeof e == "string";
}
function uwt(e, t, i) {
  return e === void 0 || dwt(e) ? t : et({}, t, {
    ownerState: et({}, t.ownerState, i)
  });
}
function D5(e, t = []) {
  if (e === void 0)
    return {};
  const i = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    i[n] = e[n];
  }), i;
}
function rU(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((i) => !(i.match(/^on[A-Z]/) && typeof e[i] == "function")).forEach((i) => {
    t[i] = e[i];
  }), t;
}
function Cwt(e) {
  const {
    getSlotProps: t,
    additionalProps: i,
    externalSlotProps: n,
    externalForwardedProps: r,
    className: g
  } = e;
  if (!t) {
    const A = Re(i == null ? void 0 : i.className, g, r == null ? void 0 : r.className, n == null ? void 0 : n.className), b = et({}, i == null ? void 0 : i.style, r == null ? void 0 : r.style, n == null ? void 0 : n.style), m = et({}, i, r, n);
    return A.length > 0 && (m.className = A), Object.keys(b).length > 0 && (m.style = b), {
      props: m,
      internalRef: void 0
    };
  }
  const o = D5(et({}, r, n)), l = rU(n), a = rU(r), I = t(o), c = Re(I == null ? void 0 : I.className, i == null ? void 0 : i.className, g, r == null ? void 0 : r.className, n == null ? void 0 : n.className), d = et({}, I == null ? void 0 : I.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style, n == null ? void 0 : n.style), C = et({}, I, i, a, l);
  return c.length > 0 && (C.className = c), Object.keys(d).length > 0 && (C.style = d), {
    props: C,
    internalRef: I.ref
  };
}
function GC(e, t, i) {
  return typeof e == "function" ? e(t, i) : e;
}
const Awt = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function DB(e) {
  var t;
  const {
    elementType: i,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: g = !1
  } = e, o = jr(e, Awt), l = g ? {} : GC(n, r), {
    props: a,
    internalRef: I
  } = Cwt(et({}, o, {
    externalSlotProps: l
  })), c = zf(I, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return uwt(i, et({}, a, {
    ref: c
  }), r);
}
function fee(e) {
  return _t;
}
const gU = (e) => e, bwt = () => {
  let e = gU;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = gU;
    }
  };
}, hwt = bwt(), mwt = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function vE(e, t, i = "Mui") {
  const n = mwt[t];
  return n ? `${i}-${n}` : `${hwt.generate(e)}-${t}`;
}
function Zee(e, t, i = "Mui") {
  const n = {};
  return t.forEach((r) => {
    n[r] = vE(e, r, i);
  }), n;
}
function pwt(e) {
  return vE("MuiSimpleTreeView", e);
}
Zee("MuiSimpleTreeView", ["root"]);
const Bwt = (e, t) => {
  const i = X.useRef({}), [n, r] = X.useState(() => {
    const o = {};
    return e.forEach((l) => {
      l.models && Object.entries(l.models).forEach(([a, I]) => {
        i.current[a] = {
          isControlled: t[a] !== void 0,
          getDefaultValue: I.getDefaultValue
        }, o[a] = I.getDefaultValue(t);
      });
    }), o;
  });
  return Object.fromEntries(Object.entries(i.current).map(([o, l]) => {
    const a = t[o] ?? n[o];
    return [o, {
      value: a,
      setControlledValue: (I) => {
        l.isControlled || r((c) => et({}, c, {
          [o]: I
        }));
      }
    }];
  }));
};
class fwt {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, i, n = {}) {
    let r = this.events[t];
    r || (r = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = r), n.isFirst ? r.highPriority.set(i, !0) : r.regular.set(i, !0);
  }
  removeListener(t, i) {
    this.events[t] && (this.events[t].regular.delete(i), this.events[t].highPriority.delete(i));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...i) {
    const n = this.events[t];
    if (!n)
      return;
    const r = Array.from(n.highPriority.keys()), g = Array.from(n.regular.keys());
    for (let o = r.length - 1; o >= 0; o -= 1) {
      const l = r[o];
      n.highPriority.has(l) && l.apply(this, i);
    }
    for (let o = 0; o < g.length; o += 1) {
      const l = g[o];
      n.regular.has(l) && l.apply(this, i);
    }
  }
  once(t, i) {
    const n = this;
    this.on(t, function r(...g) {
      n.removeListener(t, r), i.apply(n, g);
    });
  }
}
const Zwt = (e) => e.isPropagationStopped !== void 0, Gee = () => {
  const [e] = X.useState(() => new fwt()), t = X.useCallback((...n) => {
    const [r, g, o = {}] = n;
    o.defaultMuiPrevented = !1, !(Zwt(o) && o.isPropagationStopped()) && e.emit(r, g, o);
  }, [e]), i = X.useCallback((n, r) => (e.on(n, r), () => {
    e.removeListener(n, r);
  }), [e]);
  return {
    instance: {
      $$publishEvent: t,
      $$subscribeEvent: i
    }
  };
};
Gee.params = {};
const yee = ({
  plugins: e
}) => {
  const t = new Set(e);
  return {
    instance: {
      getAvailablePlugins: () => t
    }
  };
};
yee.params = {};
let oU = 0;
const Gwt = () => (oU += 1, `mui-tree-view-${oU}`), G1 = ({
  id: e,
  treeId: t = "",
  itemId: i
}) => e ?? `${t}-${i}`, RE = ({
  params: e,
  state: t,
  setState: i
}) => {
  X.useEffect(() => {
    i((r) => r.id.treeId === e.id && r.id.treeId !== void 0 ? r : et({}, r, {
      id: et({}, r.id, {
        treeId: e.id ?? Gwt()
      })
    }));
  }, [i, e.id]);
  const n = e.id ?? t.id.treeId;
  return {
    getRootProps: () => ({
      id: n
    }),
    contextValue: {
      treeId: n
    }
  };
};
RE.params = {
  id: !0
};
RE.getInitialState = ({
  id: e
}) => ({
  id: {
    treeId: e ?? void 0
  }
});
const ywt = [Gee, yee, RE], Wwt = ["slots", "slotProps", "apiRef", "experimentalFeatures"], Swt = (e) => {
  let {
    props: {
      slots: t,
      slotProps: i,
      apiRef: n,
      experimentalFeatures: r
    },
    plugins: g
  } = e, o = jr(e.props, Wwt);
  const l = {};
  g.forEach((C) => {
    Object.assign(l, C.params);
  });
  const a = {}, I = {};
  Object.keys(o).forEach((C) => {
    const A = o[C];
    l[C] ? a[C] = A : I[C] = A;
  });
  const c = r ?? {}, d = g.reduce((C, A) => A.getDefaultizedParams ? A.getDefaultizedParams({
    params: C,
    experimentalFeatures: c
  }) : C, a);
  return {
    apiRef: n,
    forwardedProps: I,
    pluginParams: d,
    slots: t ?? {},
    slotProps: i ?? {},
    experimentalFeatures: c
  };
}, Vwt = ({
  plugins: e,
  instance: t,
  publicAPI: i,
  rootRef: n
}) => ({
  runItemPlugins: (l) => {
    let a = null, I = null;
    const c = [], d = {};
    e.forEach((b) => {
      if (!b.itemPlugin)
        return;
      const m = b.itemPlugin({
        props: l,
        rootRef: a,
        contentRef: I
      });
      m != null && m.rootRef && (a = m.rootRef), m != null && m.contentRef && (I = m.contentRef), m != null && m.propsEnhancers && (c.push(m.propsEnhancers), Object.keys(m.propsEnhancers).forEach((p) => {
        d[p] = !0;
      }));
    });
    const C = (b) => (m) => {
      const p = {};
      return c.forEach((B) => {
        const f = B[b];
        f != null && Object.assign(p, f(m));
      }), p;
    }, A = Object.fromEntries(Object.keys(d).map((b) => [b, C(b)]));
    return {
      contentRef: I,
      rootRef: a,
      propsEnhancers: A
    };
  },
  wrapItem: ({
    itemId: l,
    children: a
  }) => {
    let I = a;
    for (let c = e.length - 1; c >= 0; c -= 1) {
      const d = e[c];
      d.wrapItem && (I = d.wrapItem({
        itemId: l,
        children: I,
        instance: t
      }));
    }
    return I;
  },
  wrapRoot: ({
    children: l
  }) => {
    let a = l;
    for (let I = e.length - 1; I >= 0; I -= 1) {
      const c = e[I];
      c.wrapRoot && (a = c.wrapRoot({
        children: a,
        instance: t
      }));
    }
    return a;
  },
  instance: t,
  rootRef: n,
  publicAPI: i
});
function wwt(e) {
  const t = X.useRef({});
  return e ? (e.current == null && (e.current = {}), e.current) : t.current;
}
const vwt = ({
  plugins: e,
  rootRef: t,
  props: i
}) => {
  const n = [...ywt, ...e], {
    pluginParams: r,
    forwardedProps: g,
    apiRef: o,
    experimentalFeatures: l,
    slots: a,
    slotProps: I
  } = Swt({
    plugins: n,
    props: i
  }), c = Bwt(n, r), C = X.useRef({}).current, A = wwt(o), b = X.useRef(null), m = zf(b, t), p = Vwt({
    plugins: n,
    instance: C,
    publicAPI: A,
    rootRef: b
  }), [B, f] = X.useState(() => {
    const V = {};
    return n.forEach((w) => {
      w.getInitialState && Object.assign(V, w.getInitialState(r));
    }), V;
  }), Z = [], y = (V) => {
    const w = V({
      instance: C,
      params: r,
      slots: a,
      slotProps: I,
      experimentalFeatures: l,
      state: B,
      setState: f,
      rootRef: b,
      models: c,
      plugins: n
    });
    w.getRootProps && Z.push(w.getRootProps), w.publicAPI && Object.assign(A, w.publicAPI), w.instance && Object.assign(C, w.instance), w.contextValue && Object.assign(p, w.contextValue);
  };
  return n.forEach(y), {
    getRootProps: (V = {}) => {
      const w = et({
        role: "tree"
      }, g, V, {
        ref: m
      });
      return Z.forEach((v) => {
        Object.assign(w, v(V));
      }), w;
    },
    rootRef: m,
    contextValue: p,
    instance: C
  };
}, Wee = /* @__PURE__ */ X.createContext(null);
function Rwt(e) {
  const {
    value: t,
    children: i
  } = e;
  return /* @__PURE__ */ ee(Wee.Provider, {
    value: t,
    children: t.wrapRoot({
      children: i,
      instance: t.instance
    })
  });
}
const Pm = () => {
  const e = X.useContext(Wee);
  if (e == null)
    throw new Error(["MUI X: Could not find the Tree View context.", "It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  return e;
}, See = (e, t, i) => {
  e.$$publishEvent(t, i);
}, KC = "__TREE_VIEW_ROOT_PARENT_ID__", Vee = (e) => {
  const t = {};
  return e.forEach((i, n) => {
    t[i] = n;
  }), t;
}, Of = /* @__PURE__ */ X.createContext(() => -1), Xwt = ["children"], wee = ({
  items: e,
  isItemDisabled: t,
  getItemLabel: i,
  getItemId: n
}) => {
  const r = {}, g = {}, o = {
    [KC]: []
  }, l = (I, c, d) => {
    var m, p;
    const C = n ? n(I) : I.id;
    if (C == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", "An item was provided without id in the `items` prop:", JSON.stringify(I)].join(`
`));
    if (r[C] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${C}"`].join(`
`));
    const A = i ? i(I) : I.label;
    if (A == null)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.", "An item was provided without label in the `items` prop:", JSON.stringify(I)].join(`
`));
    r[C] = {
      id: C,
      label: A,
      parentId: d,
      idAttribute: void 0,
      expandable: !!((m = I.children) != null && m.length),
      disabled: t ? t(I) : !1,
      depth: c
    }, g[C] = I;
    const b = d ?? KC;
    o[b] || (o[b] = []), o[b].push(C), (p = I.children) == null || p.forEach((B) => l(B, c + 1, C));
  };
  e.forEach((I) => l(I, 0, null));
  const a = {};
  return Object.keys(o).forEach((I) => {
    a[I] = Vee(o[I]);
  }), {
    itemMetaMap: r,
    itemMap: g,
    itemOrderedChildrenIds: o,
    itemChildrenIndexes: a
  };
}, _Z = ({
  instance: e,
  params: t,
  state: i,
  setState: n,
  experimentalFeatures: r
}) => {
  const g = X.useCallback((B) => i.items.itemMetaMap[B], [i.items.itemMetaMap]), o = X.useCallback((B) => i.items.itemMap[B], [i.items.itemMap]), l = X.useCallback(() => {
    const B = (f) => {
      const Z = i.items.itemMap[f], y = jr(Z, Xwt), W = i.items.itemOrderedChildrenIds[f];
      return W && (y.children = W.map(B)), y;
    };
    return i.items.itemOrderedChildrenIds[KC].map(B);
  }, [i.items.itemMap, i.items.itemOrderedChildrenIds]), a = X.useCallback((B) => {
    if (B == null)
      return !1;
    let f = e.getItemMeta(B);
    if (!f)
      return !1;
    if (f.disabled)
      return !0;
    for (; f.parentId != null; )
      if (f = e.getItemMeta(f.parentId), f.disabled)
        return !0;
    return !1;
  }, [e]), I = X.useCallback((B) => {
    const f = e.getItemMeta(B).parentId ?? KC;
    return i.items.itemChildrenIndexes[f][B];
  }, [e, i.items.itemChildrenIndexes]), c = X.useCallback((B) => i.items.itemOrderedChildrenIds[B ?? KC] ?? [], [i.items.itemOrderedChildrenIds]), d = (B) => {
    const f = e.getItemMeta(B);
    return f == null ? null : document.getElementById(G1({
      treeId: i.id.treeId,
      itemId: B,
      id: f.idAttribute
    }));
  }, C = (B) => t.disabledItemsFocusable ? !0 : !e.isItemDisabled(B), A = X.useRef(!1), b = X.useCallback(() => {
    A.current = !0;
  }, []), m = X.useCallback(() => A.current, []);
  return X.useEffect(() => {
    e.areItemUpdatesPrevented() || n((B) => {
      const f = wee({
        items: t.items,
        isItemDisabled: t.isItemDisabled,
        getItemId: t.getItemId,
        getItemLabel: t.getItemLabel
      });
      return Object.values(B.items.itemMetaMap).forEach((Z) => {
        f.itemMetaMap[Z.id] || See(e, "removeItem", {
          id: Z.id
        });
      }), et({}, B, {
        items: f
      });
    });
  }, [e, n, t.items, t.isItemDisabled, t.getItemId, t.getItemLabel]), {
    getRootProps: () => ({
      style: {
        "--TreeView-itemChildrenIndentation": typeof t.itemChildrenIndentation == "number" ? `${t.itemChildrenIndentation}px` : t.itemChildrenIndentation
      }
    }),
    publicAPI: {
      getItem: o,
      getItemDOMElement: d,
      getItemTree: l,
      getItemOrderedChildrenIds: c
    },
    instance: {
      getItemMeta: g,
      getItem: o,
      getItemTree: l,
      getItemsToRender: () => {
        const B = (f) => {
          var y;
          const Z = i.items.itemMetaMap[f];
          return {
            label: Z.label,
            itemId: Z.id,
            id: Z.idAttribute,
            children: (y = i.items.itemOrderedChildrenIds[f]) == null ? void 0 : y.map(B)
          };
        };
        return i.items.itemOrderedChildrenIds[KC].map(B);
      },
      getItemIndex: I,
      getItemDOMElement: d,
      getItemOrderedChildrenIds: c,
      isItemDisabled: a,
      isItemNavigable: C,
      preventItemUpdates: b,
      areItemUpdatesPrevented: m
    },
    contextValue: {
      items: {
        onItemClick: t.onItemClick,
        disabledItemsFocusable: t.disabledItemsFocusable,
        indentationAtItemLevel: r.indentationAtItemLevel ?? !1
      }
    }
  };
};
_Z.getInitialState = (e) => ({
  items: wee({
    items: e.items,
    isItemDisabled: e.isItemDisabled,
    getItemId: e.getItemId,
    getItemLabel: e.getItemLabel
  })
});
_Z.getDefaultizedParams = ({
  params: e
}) => et({}, e, {
  disabledItemsFocusable: e.disabledItemsFocusable ?? !1,
  itemChildrenIndentation: e.itemChildrenIndentation ?? "12px"
});
_Z.wrapRoot = ({
  children: e,
  instance: t
}) => /* @__PURE__ */ ee(Of.Provider, {
  value: (i) => {
    var n;
    return ((n = t.getItemMeta(i)) == null ? void 0 : n.depth) ?? 0;
  },
  children: e
});
_Z.params = {
  disabledItemsFocusable: !0,
  items: !0,
  isItemDisabled: !0,
  getItemLabel: !0,
  getItemId: !0,
  onItemClick: !0,
  itemChildrenIndentation: !0
};
const vee = typeof window < "u" ? X.useLayoutEffect : X.useEffect;
function Ld(e) {
  const t = X.useRef(e);
  return vee(() => {
    t.current = e;
  }), X.useRef((...i) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...i)
  )).current;
}
const y1 = ({
  instance: e,
  params: t,
  models: i
}) => {
  const n = X.useMemo(() => {
    const d = /* @__PURE__ */ new Map();
    return i.expandedItems.value.forEach((C) => {
      d.set(C, !0);
    }), d;
  }, [i.expandedItems.value]), r = (d, C) => {
    var A;
    (A = t.onExpandedItemsChange) == null || A.call(t, d, C), i.expandedItems.setControlledValue(C);
  }, g = X.useCallback((d) => n.has(d), [n]), o = X.useCallback((d) => {
    var C;
    return !!((C = e.getItemMeta(d)) != null && C.expandable);
  }, [e]), l = Ld((d, C) => {
    const A = e.isItemExpanded(C);
    e.setItemExpansion(d, C, !A);
  }), a = Ld((d, C, A) => {
    if (e.isItemExpanded(C) === A)
      return;
    let m;
    A ? m = [C].concat(i.expandedItems.value) : m = i.expandedItems.value.filter((p) => p !== C), t.onItemExpansionToggle && t.onItemExpansionToggle(d, C, A), r(d, m);
  }), I = (d, C) => {
    const A = e.getItemMeta(C), m = e.getItemOrderedChildrenIds(A.parentId).filter((B) => e.isItemExpandable(B) && !e.isItemExpanded(B)), p = i.expandedItems.value.concat(m);
    m.length > 0 && (t.onItemExpansionToggle && m.forEach((B) => {
      t.onItemExpansionToggle(d, B, !0);
    }), r(d, p));
  }, c = X.useMemo(() => t.expansionTrigger ? t.expansionTrigger : e.isTreeViewEditable ? "iconContainer" : "content", [t.expansionTrigger, e.isTreeViewEditable]);
  return {
    publicAPI: {
      setItemExpansion: a
    },
    instance: {
      isItemExpanded: g,
      isItemExpandable: o,
      setItemExpansion: a,
      toggleItemExpansion: l,
      expandAllSiblings: I
    },
    contextValue: {
      expansion: {
        expansionTrigger: c
      }
    }
  };
};
y1.models = {
  expandedItems: {
    getDefaultValue: (e) => e.defaultExpandedItems
  }
};
const Hwt = [];
y1.getDefaultizedParams = ({
  params: e
}) => et({}, e, {
  defaultExpandedItems: e.defaultExpandedItems ?? Hwt
});
y1.params = {
  expandedItems: !0,
  defaultExpandedItems: !0,
  onExpandedItemsChange: !0,
  onItemExpansionToggle: !0,
  expansionTrigger: !0
};
const Ree = (e, t) => {
  let i = t.length - 1;
  for (; i >= 0 && !e.isItemNavigable(t[i]); )
    i -= 1;
  if (i !== -1)
    return t[i];
}, Xee = (e, t) => {
  const i = e.getItemMeta(t), n = e.getItemOrderedChildrenIds(i.parentId), r = e.getItemIndex(t);
  if (r === 0)
    return i.parentId;
  let g = r - 1;
  for (; !e.isItemNavigable(n[g]) && g >= 0; )
    g -= 1;
  if (g === -1)
    return i.parentId == null ? null : Xee(e, i.parentId);
  let o = n[g], l = Ree(e, e.getItemOrderedChildrenIds(o));
  for (; e.isItemExpanded(o) && l != null; )
    o = l, l = e.getItemOrderedChildrenIds(o).find(e.isItemNavigable);
  return o;
}, SV = (e, t) => {
  if (e.isItemExpanded(t)) {
    const n = e.getItemOrderedChildrenIds(t).find(e.isItemNavigable);
    if (n != null)
      return n;
  }
  let i = e.getItemMeta(t);
  for (; i != null; ) {
    const n = e.getItemOrderedChildrenIds(i.parentId), r = e.getItemIndex(i.id);
    if (r < n.length - 1) {
      let g = r + 1;
      for (; !e.isItemNavigable(n[g]) && g < n.length - 1; )
        g += 1;
      if (e.isItemNavigable(n[g]))
        return n[g];
    }
    i = e.getItemMeta(i.parentId);
  }
  return null;
}, Hee = (e) => {
  let t = null;
  for (; t == null || e.isItemExpanded(t); ) {
    const i = e.getItemOrderedChildrenIds(t), n = Ree(e, i);
    if (n == null)
      return t;
    t = n;
  }
  return t;
}, Qf = (e) => e.getItemOrderedChildrenIds(null).find(e.isItemNavigable), kee = (e, t, i) => {
  if (t === i)
    return [t, i];
  const n = e.getItemMeta(t), r = e.getItemMeta(i);
  if (n.parentId === r.id || r.parentId === n.id)
    return r.parentId === n.id ? [n.id, r.id] : [r.id, n.id];
  const g = [n.id], o = [r.id];
  let l = n.parentId, a = r.parentId, I = o.indexOf(l) !== -1, c = g.indexOf(a) !== -1, d = !0, C = !0;
  for (; !c && !I; )
    d && (g.push(l), I = o.indexOf(l) !== -1, d = l !== null, !I && d && (l = e.getItemMeta(l).parentId)), C && !I && (o.push(a), c = g.indexOf(a) !== -1, C = a !== null, !c && C && (a = e.getItemMeta(a).parentId));
  const A = I ? l : a, b = e.getItemOrderedChildrenIds(A), m = g[g.indexOf(A) - 1], p = o[o.indexOf(A) - 1];
  return b.indexOf(m) < b.indexOf(p) ? [t, i] : [i, t];
}, kwt = (e, t, i) => {
  const n = (a) => {
    if (e.isItemExpandable(a) && e.isItemExpanded(a))
      return e.getItemOrderedChildrenIds(a)[0];
    let I = e.getItemMeta(a);
    for (; I != null; ) {
      const c = e.getItemOrderedChildrenIds(I.parentId), d = e.getItemIndex(I.id);
      if (d < c.length - 1)
        return c[d + 1];
      I = e.getItemMeta(I.parentId);
    }
    throw new Error("Invalid range");
  }, [r, g] = kee(e, t, i), o = [r];
  let l = r;
  for (; l !== g; )
    l = n(l), e.isItemDisabled(l) || o.push(l);
  return o;
}, Ywt = (e) => {
  let t = Qf(e);
  const i = [];
  for (; t != null; )
    i.push(t), t = SV(e, t);
  return i;
}, J5 = (e, t) => t !== e.closest('*[role="treeitem"]'), VV = (e) => Array.isArray(e) ? e : e != null ? [e] : [], yF = (e) => {
  const t = {};
  return e.forEach((i) => {
    t[i] = !0;
  }), t;
}, W1 = ({
  instance: e,
  params: t,
  models: i
}) => {
  const n = X.useRef(null), r = X.useRef({}), g = X.useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    return Array.isArray(i.selectedItems.value) ? i.selectedItems.value.forEach((p) => {
      m.set(p, !0);
    }) : i.selectedItems.value != null && m.set(i.selectedItems.value, !0), m;
  }, [i.selectedItems.value]), o = (m, p) => {
    if (t.onItemSelectionToggle)
      if (t.multiSelect) {
        const B = p.filter((Z) => !e.isItemSelected(Z)), f = i.selectedItems.value.filter((Z) => !p.includes(Z));
        B.forEach((Z) => {
          t.onItemSelectionToggle(m, Z, !0);
        }), f.forEach((Z) => {
          t.onItemSelectionToggle(m, Z, !1);
        });
      } else
        p !== i.selectedItems.value && (i.selectedItems.value != null && t.onItemSelectionToggle(m, i.selectedItems.value, !1), p != null && t.onItemSelectionToggle(m, p, !0));
    t.onSelectedItemsChange && t.onSelectedItemsChange(m, p), i.selectedItems.setControlledValue(p);
  }, l = (m) => g.has(m), a = ({
    event: m,
    itemId: p,
    keepExistingSelection: B = !1,
    shouldBeSelected: f
  }) => {
    if (t.disableSelection)
      return;
    let Z;
    if (B) {
      const y = VV(i.selectedItems.value), W = e.isItemSelected(p);
      W && (f === !1 || f == null) ? Z = y.filter((V) => V !== p) : !W && (f === !0 || f == null) ? Z = [p].concat(y) : Z = y;
    } else
      f === !1 || f == null && e.isItemSelected(p) ? Z = t.multiSelect ? [] : null : Z = t.multiSelect ? [p] : p;
    o(m, Z), n.current = p, r.current = {};
  }, I = (m, [p, B]) => {
    if (t.disableSelection || !t.multiSelect)
      return;
    let f = VV(i.selectedItems.value).slice();
    Object.keys(r.current).length > 0 && (f = f.filter((V) => !r.current[V]));
    const Z = yF(f), y = kwt(e, p, B), W = y.filter((V) => !Z[V]);
    f = f.concat(W), o(m, f), r.current = yF(y);
  };
  return {
    getRootProps: () => ({
      "aria-multiselectable": t.multiSelect
    }),
    publicAPI: {
      selectItem: a
    },
    instance: {
      isItemSelected: l,
      selectItem: a,
      selectAllNavigableItems: (m) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        const p = Ywt(e);
        o(m, p), r.current = yF(p);
      },
      expandSelectionRange: (m, p) => {
        if (n.current != null) {
          const [B, f] = kee(e, p, n.current);
          I(m, [B, f]);
        }
      },
      selectRangeFromStartToItem: (m, p) => {
        I(m, [Qf(e), p]);
      },
      selectRangeFromItemToEnd: (m, p) => {
        I(m, [p, Hee(e)]);
      },
      selectItemFromArrowNavigation: (m, p, B) => {
        if (t.disableSelection || !t.multiSelect)
          return;
        let f = VV(i.selectedItems.value).slice();
        Object.keys(r.current).length === 0 ? (f.push(B), r.current = {
          [p]: !0,
          [B]: !0
        }) : (r.current[p] || (r.current = {}), r.current[B] ? (f = f.filter((Z) => Z !== p), delete r.current[p]) : (f.push(B), r.current[B] = !0)), o(m, f);
      }
    },
    contextValue: {
      selection: {
        multiSelect: t.multiSelect,
        checkboxSelection: t.checkboxSelection,
        disableSelection: t.disableSelection
      }
    }
  };
};
W1.models = {
  selectedItems: {
    getDefaultValue: (e) => e.defaultSelectedItems
  }
};
const Fwt = [];
W1.getDefaultizedParams = ({
  params: e
}) => et({}, e, {
  disableSelection: e.disableSelection ?? !1,
  multiSelect: e.multiSelect ?? !1,
  checkboxSelection: e.checkboxSelection ?? !1,
  defaultSelectedItems: e.defaultSelectedItems ?? (e.multiSelect ? Fwt : null)
});
W1.params = {
  disableSelection: !0,
  multiSelect: !0,
  checkboxSelection: !0,
  defaultSelectedItems: !0,
  selectedItems: !0,
  onSelectedItemsChange: !0,
  onItemSelectionToggle: !0
};
function xwt(e) {
  return e && e.ownerDocument || document;
}
const lU = 1e3;
class Dwt {
  constructor(t = lU) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = lU, this.cleanupTimeout = t;
  }
  register(t, i, n) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const r = setTimeout(() => {
      typeof i == "function" && i(), this.timeouts.delete(n.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(n.cleanupToken, r);
  }
  unregister(t) {
    const i = this.timeouts.get(t.cleanupToken);
    i && (this.timeouts.delete(t.cleanupToken), clearTimeout(i));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, i) => {
      this.unregister({
        cleanupToken: i
      });
    }), this.timeouts = void 0);
  }
}
class Jwt {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, i, n) {
    this.registry.register(t, i, n);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
class Ewt {
}
function Nwt(e) {
  let t = 0;
  return function(n, r, g) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new Jwt() : new Dwt());
    const [o] = X.useState(new Ewt()), l = X.useRef(null), a = X.useRef(void 0);
    a.current = g;
    const I = X.useRef(null);
    if (!l.current && a.current) {
      const c = (d, C) => {
        var A;
        C.defaultMuiPrevented || (A = a.current) == null || A.call(a, d, C);
      };
      l.current = n.$$subscribeEvent(r, c), t += 1, I.current = {
        cleanupToken: t
      }, e.registry.register(
        o,
        // The callback below will be called once this reference stops being retained
        () => {
          var d;
          (d = l.current) == null || d.call(l), l.current = null, I.current = null;
        },
        I.current
      );
    } else
      !a.current && l.current && (l.current(), l.current = null, I.current && (e.registry.unregister(I.current), I.current = null));
    X.useEffect(() => {
      if (!l.current && a.current) {
        const c = (d, C) => {
          var A;
          C.defaultMuiPrevented || (A = a.current) == null || A.call(a, d, C);
        };
        l.current = n.$$subscribeEvent(r, c);
      }
      return I.current && e.registry && (e.registry.unregister(I.current), I.current = null), () => {
        var c;
        (c = l.current) == null || c.call(l), l.current = null;
      };
    }, [n, r]);
  };
}
const Lwt = {
  registry: null
}, Kwt = Nwt(Lwt), Yee = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? Yee(t.shadowRoot) : t : null;
};
function Twt(e) {
  return e.replace(/["\\]/g, "\\$&");
}
const Mwt = (e, t) => {
  let i = VV(t).find((n) => {
    if (!e.isItemNavigable(n))
      return !1;
    const r = e.getItemMeta(n);
    return r && (r.parentId == null || e.isItemExpanded(r.parentId));
  });
  return i == null && (i = Qf(e)), i;
}, XE = ({
  instance: e,
  params: t,
  state: i,
  setState: n,
  models: r,
  rootRef: g
}) => {
  const o = Mwt(e, r.selectedItems.value), l = Ld((p) => {
    const B = typeof p == "function" ? p(i.focusedItemId) : p;
    i.focusedItemId !== B && n((f) => et({}, f, {
      focusedItemId: B
    }));
  }), a = X.useCallback(() => !!g.current && g.current.contains(Yee(xwt(g.current))), [g]), I = X.useCallback((p) => i.focusedItemId === p && a(), [i.focusedItemId, a]), c = (p) => {
    const B = e.getItemMeta(p);
    return B && (B.parentId == null || e.isItemExpanded(B.parentId));
  }, d = (p, B) => {
    const f = e.getItemDOMElement(B);
    f && f.focus(), l(B), t.onItemFocus && t.onItemFocus(p, B);
  }, C = Ld((p, B) => {
    c(B) && d(p, B);
  }), A = Ld(() => {
    if (i.focusedItemId == null)
      return;
    if (e.getItemMeta(i.focusedItemId)) {
      const B = e.getItemDOMElement(i.focusedItemId);
      B && B.blur();
    }
    l(null);
  }), b = (p) => p === o;
  Kwt(e, "removeItem", ({
    id: p
  }) => {
    i.focusedItemId === p && d(null, o);
  });
  const m = (p) => (B) => {
    var f;
    (f = p.onFocus) == null || f.call(p, B), !B.defaultMuiPrevented && B.target === B.currentTarget && d(B, o);
  };
  return {
    getRootProps: (p) => ({
      onFocus: m(p)
    }),
    publicAPI: {
      focusItem: C
    },
    instance: {
      isItemFocused: I,
      canItemBeTabbed: b,
      focusItem: C,
      removeFocusedItem: A
    }
  };
};
XE.getInitialState = () => ({
  focusedItemId: null
});
XE.params = {
  onItemFocus: !0
};
const wV = (e, t) => e.getAvailablePlugins().has(t), Pwt = ({
  props: e
}) => {
  const {
    instance: t
  } = Pm(), {
    label: i,
    itemId: n
  } = e, [r, g] = X.useState(i), o = t.isItemBeingEdited(n);
  return X.useEffect(() => {
    o || g(i);
  }, [o, i]), {
    propsEnhancers: {
      labelInput: ({
        externalEventHandlers: l,
        interactions: a
      }) => t.isItemEditable(n) ? {
        value: r ?? "",
        "data-element": "labelInput",
        onChange: (A) => {
          var b;
          (b = l.onChange) == null || b.call(l, A), g(A.target.value);
        },
        onKeyDown: (A) => {
          var m;
          if ((m = l.onKeyDown) == null || m.call(l, A), A.defaultMuiPrevented)
            return;
          const b = A.target;
          A.key === "Enter" && b.value ? a.handleSaveItemLabel(A, b.value) : A.key === "Escape" && a.handleCancelItemLabelEditing(A);
        },
        onBlur: (A) => {
          var b;
          (b = l.onBlur) == null || b.call(l, A), !A.defaultMuiPrevented && A.target.value && a.handleSaveItemLabel(A, A.target.value);
        },
        autoFocus: !0,
        type: "text"
      } : {}
    }
  };
}, Kd = ({
  instance: e,
  state: t,
  setState: i,
  params: n
}) => {
  const r = X.useRef(t.editedItemId), g = (d) => r.current === d, o = (d) => {
    i((C) => et({}, C, {
      editedItemId: d
    })), r.current = d;
  }, l = (d) => d === t.editedItemId, a = !!n.isItemEditable, I = (d) => {
    if (d == null || !a)
      return !1;
    const C = e.getItem(d);
    return C ? typeof n.isItemEditable == "function" ? n.isItemEditable(C) : !!n.isItemEditable : !1;
  }, c = (d, C) => {
    if (!C)
      throw new Error(["MUI X: The Tree View component requires all items to have a `label` property.", "The label of an item cannot be empty.", d].join(`
`));
    i((A) => {
      const b = A.items.itemMetaMap[d];
      return b.label !== C ? et({}, A, {
        items: et({}, A.items, {
          itemMetaMap: et({}, A.items.itemMetaMap, {
            [d]: et({}, b, {
              label: C
            })
          })
        })
      }) : A;
    }), n.onItemLabelChange && n.onItemLabelChange(d, C);
  };
  return {
    instance: {
      setEditedItemId: o,
      isItemBeingEdited: l,
      updateItemLabel: c,
      isItemEditable: I,
      isTreeViewEditable: a,
      isItemBeingEditedRef: g
    },
    publicAPI: {
      updateItemLabel: c
    }
  };
};
Kd.itemPlugin = Pwt;
Kd.getDefaultizedParams = ({
  params: e,
  experimentalFeatures: t
}) => {
  const i = t == null ? void 0 : t.labelEditing;
  return et({}, e, {
    isItemEditable: i ? e.isItemEditable ?? !1 : !1
  });
};
Kd.getInitialState = () => ({
  editedItemId: null
});
Kd.params = {
  onItemLabelChange: !0,
  isItemEditable: !0
};
function Uwt(e) {
  return !!e && e.length === 1 && !!e.match(/\S/);
}
const Fee = ({
  instance: e,
  params: t,
  state: i
}) => {
  const n = CA(), r = X.useRef({}), g = Ld((c) => {
    r.current = c(r.current);
  });
  X.useEffect(() => {
    if (e.areItemUpdatesPrevented())
      return;
    const c = {}, d = (C) => {
      c[C.id] = C.label.substring(0, 1).toLowerCase();
    };
    Object.values(i.items.itemMetaMap).forEach(d), r.current = c;
  }, [i.items.itemMetaMap, t.getItemId, e]);
  const o = (c, d) => {
    const C = d.toLowerCase(), A = (B) => {
      const f = SV(e, B);
      return f === null ? Qf(e) : f;
    };
    let b = null, m = A(c);
    const p = {};
    for (; b == null && !p[m]; )
      r.current[m] === C ? b = m : (p[m] = !0, m = A(m));
    return b;
  }, l = (c) => !t.disableSelection && !e.isItemDisabled(c), a = (c) => !e.isItemDisabled(c) && e.isItemExpandable(c);
  return {
    instance: {
      updateFirstCharMap: g,
      handleItemKeyDown: (c, d) => {
        if (c.defaultMuiPrevented || c.altKey || J5(c.target, c.currentTarget))
          return;
        const C = c.ctrlKey || c.metaKey, A = c.key;
        switch (!0) {
          case (A === " " && l(d)): {
            c.preventDefault(), t.multiSelect && c.shiftKey ? e.expandSelectionRange(c, d) : e.selectItem({
              event: c,
              itemId: d,
              keepExistingSelection: t.multiSelect,
              shouldBeSelected: t.multiSelect ? void 0 : !0
            });
            break;
          }
          case A === "Enter": {
            wV(e, Kd) && e.isItemEditable(d) && !e.isItemBeingEdited(d) ? e.setEditedItemId(d) : a(d) ? (e.toggleItemExpansion(c, d), c.preventDefault()) : l(d) && (t.multiSelect ? (c.preventDefault(), e.selectItem({
              event: c,
              itemId: d,
              keepExistingSelection: !0
            })) : e.isItemSelected(d) || (e.selectItem({
              event: c,
              itemId: d
            }), c.preventDefault()));
            break;
          }
          case A === "ArrowDown": {
            const b = SV(e, d);
            b && (c.preventDefault(), e.focusItem(c, b), t.multiSelect && c.shiftKey && l(b) && e.selectItemFromArrowNavigation(c, d, b));
            break;
          }
          case A === "ArrowUp": {
            const b = Xee(e, d);
            b && (c.preventDefault(), e.focusItem(c, b), t.multiSelect && c.shiftKey && l(b) && e.selectItemFromArrowNavigation(c, d, b));
            break;
          }
          case (A === "ArrowRight" && !n || A === "ArrowLeft" && n): {
            if (C)
              return;
            if (e.isItemExpanded(d)) {
              const b = SV(e, d);
              b && (e.focusItem(c, b), c.preventDefault());
            } else
              a(d) && (e.toggleItemExpansion(c, d), c.preventDefault());
            break;
          }
          case (A === "ArrowLeft" && !n || A === "ArrowRight" && n): {
            if (C)
              return;
            if (a(d) && e.isItemExpanded(d))
              e.toggleItemExpansion(c, d), c.preventDefault();
            else {
              const b = e.getItemMeta(d).parentId;
              b && (e.focusItem(c, b), c.preventDefault());
            }
            break;
          }
          case A === "Home": {
            l(d) && t.multiSelect && C && c.shiftKey ? e.selectRangeFromStartToItem(c, d) : e.focusItem(c, Qf(e)), c.preventDefault();
            break;
          }
          case A === "End": {
            l(d) && t.multiSelect && C && c.shiftKey ? e.selectRangeFromItemToEnd(c, d) : e.focusItem(c, Hee(e)), c.preventDefault();
            break;
          }
          case A === "*": {
            e.expandAllSiblings(c, d), c.preventDefault();
            break;
          }
          case (String.fromCharCode(c.keyCode) === "A" && C && t.multiSelect && !t.disableSelection): {
            e.selectAllNavigableItems(c), c.preventDefault();
            break;
          }
          case (!C && !c.shiftKey && Uwt(A)): {
            const b = o(d, A);
            b != null && (e.focusItem(c, b), c.preventDefault());
            break;
          }
        }
      }
    }
  };
};
Fee.params = {};
const xee = ({
  slots: e,
  slotProps: t
}) => ({
  contextValue: {
    icons: {
      slots: {
        collapseIcon: e.collapseIcon,
        expandIcon: e.expandIcon,
        endIcon: e.endIcon
      },
      slotProps: {
        collapseIcon: t.collapseIcon,
        expandIcon: t.expandIcon,
        endIcon: t.endIcon
      }
    }
  }
});
xee.params = {};
const Dee = /* @__PURE__ */ X.createContext(null);
function Jee(e) {
  const {
    children: t,
    itemId: i = null
  } = e, {
    instance: n,
    treeId: r,
    rootRef: g
  } = Pm(), o = X.useRef(/* @__PURE__ */ new Map());
  X.useEffect(() => {
    if (!g.current)
      return;
    let a = null;
    if (i == null)
      a = g.current.id;
    else {
      const b = n.getItemMeta(i);
      b !== void 0 && (a = G1({
        itemId: i,
        treeId: r,
        id: b.idAttribute
      }));
    }
    if (a == null)
      return;
    const I = n.getItemOrderedChildrenIds(i ?? null) ?? [], c = Twt(a), d = g.current.querySelectorAll(`${i == null ? "" : `*[id="${c}"] `}[role="treeitem"]:not(*[id="${c}"] [role="treeitem"] [role="treeitem"])`), C = Array.from(d).map((b) => o.current.get(b.id));
    (C.length !== I.length || C.some((b, m) => b !== I[m])) && n.setJSXItemsOrderedChildrenIds(i ?? null, C);
  });
  const l = X.useMemo(() => ({
    registerChild: (a, I) => o.current.set(a, I),
    unregisterChild: (a) => o.current.delete(a),
    parentId: i
  }), [i]);
  return /* @__PURE__ */ ee(Dee.Provider, {
    value: l,
    children: t
  });
}
const $Z = ({
  instance: e,
  setState: t
}) => {
  e.preventItemUpdates();
  const i = Ld((g) => (t((o) => {
    if (o.items.itemMetaMap[g.id] != null)
      throw new Error(["MUI X: The Tree View component requires all items to have a unique `id` property.", "Alternatively, you can use the `getItemId` prop to specify a custom id for each item.", `Two items were provided with the same id in the \`items\` prop: "${g.id}"`].join(`
`));
    return et({}, o, {
      items: et({}, o.items, {
        itemMetaMap: et({}, o.items.itemMetaMap, {
          [g.id]: g
        }),
        // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
        itemMap: et({}, o.items.itemMap, {
          [g.id]: {
            id: g.id,
            label: g.label
          }
        })
      })
    });
  }), () => {
    t((o) => {
      const l = et({}, o.items.itemMetaMap), a = et({}, o.items.itemMap);
      return delete l[g.id], delete a[g.id], et({}, o, {
        items: et({}, o.items, {
          itemMetaMap: l,
          itemMap: a
        })
      });
    }), See(e, "removeItem", {
      id: g.id
    });
  })), n = (g, o) => {
    const l = g ?? KC;
    t((a) => et({}, a, {
      items: et({}, a.items, {
        itemOrderedChildrenIds: et({}, a.items.itemOrderedChildrenIds, {
          [l]: o
        }),
        itemChildrenIndexes: et({}, a.items.itemChildrenIndexes, {
          [l]: Vee(o)
        })
      })
    }));
  }, r = Ld((g, o) => (e.updateFirstCharMap((l) => (l[g] = o, l)), () => {
    e.updateFirstCharMap((l) => {
      const a = et({}, l);
      return delete a[g], a;
    });
  }));
  return {
    instance: {
      insertJSXItem: i,
      setJSXItemsOrderedChildrenIds: n,
      mapFirstCharFromJSX: r
    }
  };
}, Eee = (e) => Array.isArray(e) ? e.length > 0 && e.some(Eee) : !!e, zwt = ({
  props: e,
  rootRef: t,
  contentRef: i
}) => {
  const {
    instance: n,
    treeId: r
  } = Pm(), {
    children: g,
    disabled: o = !1,
    label: l,
    itemId: a,
    id: I
  } = e, c = X.useContext(Dee);
  if (c == null)
    throw new Error(["MUI X: Could not find the Tree View Children Item context.", "It looks like you rendered your component outside of a SimpleTreeView parent component.", "This can also happen if you are bundling multiple versions of the Tree View."].join(`
`));
  const {
    registerChild: d,
    unregisterChild: C,
    parentId: A
  } = c, b = Eee(g), m = X.useRef(null), p = zf(m, i);
  return vee(() => {
    const B = G1({
      itemId: a,
      treeId: r,
      id: I
    });
    return d(B, a), () => {
      C(B);
    };
  }, [d, C, a, I, r]), X.useEffect(() => n.insertJSXItem({
    id: a,
    idAttribute: I,
    parentId: A,
    expandable: b,
    disabled: o
  }), [n, A, a, b, o, I]), X.useEffect(() => {
    var B;
    if (l)
      return n.mapFirstCharFromJSX(a, (((B = m.current) == null ? void 0 : B.textContent) ?? "").substring(0, 1).toLowerCase());
  }, [n, a, l]), {
    contentRef: p,
    rootRef: t
  };
};
$Z.itemPlugin = zwt;
$Z.wrapItem = ({
  children: e,
  itemId: t
}) => {
  const i = X.useContext(Of);
  return /* @__PURE__ */ ee(Jee, {
    itemId: t,
    children: /* @__PURE__ */ ee(Of.Provider, {
      value: i + 1,
      children: e
    })
  });
};
$Z.wrapRoot = ({
  children: e
}) => /* @__PURE__ */ ee(Jee, {
  children: /* @__PURE__ */ ee(Of.Provider, {
    value: 0,
    children: e
  })
});
$Z.params = {};
const Owt = [_Z, y1, W1, XE, Fee, xee, $Z], Qwt = fee(), jwt = (e) => {
  const {
    classes: t
  } = e;
  return Bee({
    root: ["root"]
  }, pwt, t);
}, qwt = Se("ul", {
  name: "MuiSimpleTreeView",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  margin: 0,
  listStyle: "none",
  outline: 0,
  position: "relative"
}), _wt = [], $wt = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const n = Qwt({
    props: t,
    name: "MuiSimpleTreeView"
  }), r = n, {
    getRootProps: g,
    contextValue: o
  } = vwt({
    plugins: Owt,
    rootRef: i,
    props: et({}, n, {
      items: _wt
    })
  }), {
    slots: l,
    slotProps: a
  } = n, I = jwt(n), c = (l == null ? void 0 : l.root) ?? qwt, d = DB({
    elementType: c,
    externalSlotProps: a == null ? void 0 : a.root,
    className: I.root,
    getSlotProps: g,
    ownerState: r
  });
  return /* @__PURE__ */ ee(Rwt, {
    value: o,
    children: /* @__PURE__ */ ee(c, et({}, d))
  });
});
function Nee(e) {
  const {
    instance: t,
    items: {
      onItemClick: i
    },
    selection: {
      multiSelect: n,
      checkboxSelection: r,
      disableSelection: g
    },
    expansion: {
      expansionTrigger: o
    }
  } = Pm(), l = t.isItemExpandable(e), a = t.isItemExpanded(e), I = t.isItemFocused(e), c = t.isItemSelected(e), d = t.isItemDisabled(e), C = t != null && t.isItemBeingEdited ? t == null ? void 0 : t.isItemBeingEdited(e) : !1, A = t.isItemEditable ? t.isItemEditable(e) : !1, b = (W) => {
    if (!d) {
      I || t.focusItem(W, e);
      const V = n && (W.shiftKey || W.ctrlKey || W.metaKey);
      l && !(V && t.isItemExpanded(e)) && t.toggleItemExpansion(W, e);
    }
  }, m = (W) => {
    d || (I || t.focusItem(W, e), n && (W.shiftKey || W.ctrlKey || W.metaKey) ? W.shiftKey ? t.expandSelectionRange(W, e) : t.selectItem({
      event: W,
      itemId: e,
      keepExistingSelection: !0
    }) : t.selectItem({
      event: W,
      itemId: e,
      shouldBeSelected: !0
    }));
  }, p = (W) => {
    if (g || d)
      return;
    const V = W.nativeEvent.shiftKey;
    n && V ? t.expandSelectionRange(W, e) : t.selectItem({
      event: W,
      itemId: e,
      keepExistingSelection: n,
      shouldBeSelected: W.target.checked
    });
  }, B = (W) => {
    (W.shiftKey || W.ctrlKey || W.metaKey || d) && W.preventDefault();
  }, f = () => {
    wV(t, Kd) && t.isItemEditable(e) && (t.isItemBeingEdited(e) ? t.setEditedItemId(null) : t.setEditedItemId(e));
  };
  return {
    disabled: d,
    expanded: a,
    selected: c,
    focused: I,
    editable: A,
    editing: C,
    disableSelection: g,
    checkboxSelection: r,
    handleExpansion: b,
    handleSelection: m,
    handleCheckboxSelection: p,
    handleContentClick: i,
    preventSelection: B,
    expansionTrigger: o,
    toggleItemEditing: f,
    handleSaveItemLabel: (W, V) => {
      wV(t, Kd) && t.isItemBeingEditedRef(e) && (t.updateItemLabel(e, V), f(), t.focusItem(W, e));
    },
    handleCancelItemLabelEditing: (W) => {
      wV(t, Kd) && t.isItemBeingEditedRef(e) && (f(), t.focusItem(W, e));
    }
  };
}
const e2t = Se("div", {
  name: "MuiTreeItem2DragAndDropOverlay",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => oV(e) && e !== "action"
})(({
  theme: e
}) => ({
  position: "absolute",
  left: 0,
  display: "flex",
  top: 0,
  bottom: 0,
  right: 0,
  pointerEvents: "none",
  variants: [{
    props: {
      action: "make-child"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderRadius: e.shape.borderRadius,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.darkChannel} / ${e.vars.palette.action.focusOpacity})` : uI(e.palette.primary.dark, e.palette.action.focusOpacity)
    }
  }, {
    props: {
      action: "reorder-above"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderTop: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "reorder-below"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }, {
    props: {
      action: "move-to-parent"
    },
    style: {
      marginLeft: "calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))",
      borderBottom: `1px solid ${(e.vars || e).palette.action.active}`
    }
  }]
}));
function t2t(e) {
  return e.action == null ? null : /* @__PURE__ */ ee(e2t, et({}, e));
}
const i2t = Se("input", {
  name: "MuiTreeItem2",
  slot: "LabelInput",
  overridesResolver: (e, t) => t.labelInput
})(({
  theme: e
}) => et({}, e.typography.body1, {
  width: "100%",
  backgroundColor: e.palette.background.paper,
  borderRadius: e.shape.borderRadius,
  border: "none",
  padding: "0 2px",
  boxSizing: "border-box",
  "&:focus": {
    outline: `1px solid ${e.palette.primary.main}`
  }
})), n2t = ["classes", "className", "displayIcon", "expansionIcon", "icon", "label", "itemId", "onClick", "onMouseDown", "dragAndDropOverlayProps", "labelInputProps"], Lee = /* @__PURE__ */ X.forwardRef(function(t, i) {
  const {
    classes: n,
    className: r,
    displayIcon: g,
    expansionIcon: o,
    icon: l,
    label: a,
    itemId: I,
    onClick: c,
    onMouseDown: d,
    dragAndDropOverlayProps: C,
    labelInputProps: A
  } = t, b = jr(t, n2t), {
    disabled: m,
    expanded: p,
    selected: B,
    focused: f,
    editing: Z,
    editable: y,
    disableSelection: W,
    checkboxSelection: V,
    handleExpansion: w,
    handleSelection: v,
    handleCheckboxSelection: H,
    handleContentClick: x,
    preventSelection: J,
    expansionTrigger: K,
    toggleItemEditing: M
  } = Nee(I), L = l || o || g, N = X.useRef(null), U = (ne) => {
    J(ne), d && d(ne);
  }, O = (ne) => {
    var be;
    x == null || x(ne, I), !((be = N.current) != null && be.contains(ne.target)) && (K === "content" && w(ne), V || v(ne), c && c(ne));
  }, $ = (ne) => {
    ne.defaultMuiPrevented || M();
  };
  return (
    /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- Key event is handled by the TreeView */
    /* @__PURE__ */ Ri("div", et({}, b, {
      className: Re(n.root, r, p && n.expanded, B && n.selected, f && n.focused, m && n.disabled, Z && n.editing, y && n.editable),
      onClick: O,
      onMouseDown: U,
      ref: i,
      children: [/* @__PURE__ */ ee("div", {
        className: n.iconContainer,
        children: L
      }), V && /* @__PURE__ */ ee(fZ, {
        className: n.checkbox,
        checked: B,
        onChange: H,
        disabled: m || W,
        ref: N,
        tabIndex: -1
      }), Z ? /* @__PURE__ */ ee(i2t, et({}, A, {
        className: n.labelInput
      })) : /* @__PURE__ */ ee("div", et({
        className: n.label
      }, y && {
        onDoubleClick: $
      }, {
        children: a
      })), C && /* @__PURE__ */ ee(t2t, et({}, C))]
    }))
  );
});
function r2t(e) {
  return vE("MuiTreeItem", e);
}
const dc = Zee("MuiTreeItem", ["root", "groupTransition", "content", "expanded", "selected", "focused", "disabled", "iconContainer", "label", "checkbox", "labelInput", "editable", "editing", "dragAndDropOverlay"]), g2t = ai(/* @__PURE__ */ ee("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "TreeViewExpandIcon"), o2t = ai(/* @__PURE__ */ ee("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "TreeViewCollapseIcon");
function Kee(e) {
  const {
    children: t,
    itemId: i
  } = e, {
    wrapItem: n,
    instance: r
  } = Pm();
  return n({
    children: t,
    itemId: i,
    instance: r
  });
}
Kee.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: JL.node,
  itemId: JL.string.isRequired
};
const l2t = ["children", "className", "slots", "slotProps", "ContentComponent", "ContentProps", "itemId", "id", "label", "onClick", "onMouseDown", "onFocus", "onBlur", "onKeyDown"], a2t = ["ownerState"], s2t = ["ownerState"], I2t = ["ownerState"], c2t = fee(), d2t = (e) => {
  const {
    classes: t
  } = e;
  return Bee({
    root: ["root"],
    content: ["content"],
    expanded: ["expanded"],
    selected: ["selected"],
    focused: ["focused"],
    disabled: ["disabled"],
    iconContainer: ["iconContainer"],
    checkbox: ["checkbox"],
    label: ["label"],
    labelInput: ["labelInput"],
    editing: ["editing"],
    editable: ["editable"],
    groupTransition: ["groupTransition"]
  }, r2t, t);
}, u2t = Se("li", {
  name: "MuiTreeItem",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  outline: 0
}), C2t = Se(Lee, {
  name: "MuiTreeItem",
  slot: "Content",
  overridesResolver: (e, t) => [t.content, t.iconContainer && {
    [`& .${dc.iconContainer}`]: t.iconContainer
  }, t.label && {
    [`& .${dc.label}`]: t.label
  }],
  shouldForwardProp: (e) => EQ(e) && e !== "indentationAtItemLevel"
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1),
  borderRadius: e.shape.borderRadius,
  width: "100%",
  boxSizing: "border-box",
  // prevent width + padding to overflow
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  cursor: "pointer",
  WebkitTapHighlightColor: "transparent",
  "&:hover": {
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${dc.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    backgroundColor: "transparent"
  },
  [`&.${dc.focused}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${dc.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : uI(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : uI(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : uI(e.palette.primary.main, e.palette.action.selectedOpacity)
      }
    },
    [`&.${dc.focused}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : uI(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`& .${dc.iconContainer}`]: {
    width: 16,
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    "& svg": {
      fontSize: 18
    }
  },
  [`& .${dc.label}`]: et({
    width: "100%",
    boxSizing: "border-box",
    // prevent width + padding to overflow
    // fixes overflow - see https://github.com/mui/material-ui/issues/27372
    minWidth: 0,
    position: "relative"
  }, e.typography.body1),
  [`& .${dc.checkbox}`]: {
    padding: 0
  },
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: `calc(${e.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`
    }
  }]
})), A2t = Se(P2, {
  name: "MuiTreeItem",
  slot: "GroupTransition",
  overridesResolver: (e, t) => t.groupTransition,
  shouldForwardProp: (e) => EQ(e) && e !== "indentationAtItemLevel"
})({
  margin: 0,
  padding: 0,
  paddingLeft: "var(--TreeView-itemChildrenIndentation)",
  variants: [{
    props: {
      indentationAtItemLevel: !0
    },
    style: {
      paddingLeft: 0
    }
  }]
}), Tee = /* @__PURE__ */ X.forwardRef(function(t, i) {
  var Yt, zt, ri, di;
  const {
    icons: n,
    runItemPlugins: r,
    items: {
      disabledItemsFocusable: g,
      indentationAtItemLevel: o
    },
    selection: {
      disableSelection: l
    },
    expansion: {
      expansionTrigger: a
    },
    treeId: I,
    instance: c
  } = Pm(), d = X.useContext(Of), C = c2t({
    props: t,
    name: "MuiTreeItem"
  }), {
    children: A,
    className: b,
    slots: m,
    slotProps: p,
    ContentComponent: B = Lee,
    ContentProps: f,
    itemId: Z,
    id: y,
    label: W,
    onClick: V,
    onMouseDown: w,
    onBlur: v,
    onKeyDown: H
  } = C, x = jr(C, l2t), {
    expanded: J,
    focused: K,
    selected: M,
    disabled: L,
    editing: N,
    handleExpansion: U,
    handleCancelItemLabelEditing: O,
    handleSaveItemLabel: $
  } = Nee(Z), {
    contentRef: ne,
    rootRef: be,
    propsEnhancers: Ve
  } = r(C), He = X.useRef(null), Je = X.useRef(null), ke = zf(i, be, He), we = zf(f == null ? void 0 : f.ref, ne, Je), ue = {
    expandIcon: (m == null ? void 0 : m.expandIcon) ?? n.slots.expandIcon ?? g2t,
    collapseIcon: (m == null ? void 0 : m.collapseIcon) ?? n.slots.collapseIcon ?? o2t,
    endIcon: (m == null ? void 0 : m.endIcon) ?? n.slots.endIcon,
    icon: m == null ? void 0 : m.icon,
    groupTransition: m == null ? void 0 : m.groupTransition
  }, Xe = (mt) => Array.isArray(mt) ? mt.length > 0 && mt.some(Xe) : !!mt, Ze = Xe(A), xe = et({}, C, {
    expanded: J,
    focused: K,
    selected: M,
    disabled: L,
    indentationAtItemLevel: o
  }), Pe = d2t(xe), st = ue.groupTransition ?? void 0, bt = DB({
    elementType: st,
    ownerState: {},
    externalSlotProps: p == null ? void 0 : p.groupTransition,
    additionalProps: et({
      unmountOnExit: !0,
      in: J,
      component: "ul",
      role: "group"
    }, o ? {
      indentationAtItemLevel: !0
    } : {}),
    className: Pe.groupTransition
  }), it = (mt) => {
    a === "iconContainer" && U(mt);
  }, Qe = J ? ue.collapseIcon : ue.expandIcon, $e = DB({
    elementType: Qe,
    ownerState: {},
    externalSlotProps: (mt) => J ? et({}, GC(n.slotProps.collapseIcon, mt), GC(p == null ? void 0 : p.collapseIcon, mt)) : et({}, GC(n.slotProps.expandIcon, mt), GC(p == null ? void 0 : p.expandIcon, mt)),
    additionalProps: {
      onClick: it
    }
  }), It = jr($e, a2t), jt = Ze && Qe ? /* @__PURE__ */ ee(Qe, et({}, It)) : null, Bt = Ze ? void 0 : ue.endIcon, te = DB({
    elementType: Bt,
    ownerState: {},
    externalSlotProps: (mt) => Ze ? {} : et({}, GC(n.slotProps.endIcon, mt), GC(p == null ? void 0 : p.endIcon, mt))
  }), Xt = jr(te, s2t), Ht = Bt ? /* @__PURE__ */ ee(Bt, et({}, Xt)) : null, ii = ue.icon, $t = DB({
    elementType: ii,
    ownerState: {},
    externalSlotProps: p == null ? void 0 : p.icon
  }), ni = jr($t, I2t), mi = ii ? /* @__PURE__ */ ee(ii, et({}, ni)) : null;
  let Bi;
  M ? Bi = !0 : l || L ? Bi = void 0 : Bi = !1;
  function ci(mt) {
    !K && (!L || g) && mt.currentTarget === mt.target && c.focusItem(mt, Z);
  }
  function Ge(mt) {
    var Ai, ui, Ui, Oi;
    v == null || v(mt), !(N || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
    // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
    mt.relatedTarget && J5(mt.relatedTarget, He.current) && (mt.target && ((ui = (Ai = mt.target) == null ? void 0 : Ai.dataset) == null ? void 0 : ui.element) === "labelInput" && J5(mt.target, He.current) || ((Oi = (Ui = mt.relatedTarget) == null ? void 0 : Ui.dataset) == null ? void 0 : Oi.element) === "labelInput")) && c.removeFocusedItem();
  }
  const Be = (mt) => {
    var Ai, ui;
    H == null || H(mt), ((ui = (Ai = mt.target) == null ? void 0 : Ai.dataset) == null ? void 0 : ui.element) !== "labelInput" && c.handleItemKeyDown(mt, Z);
  }, qe = G1({
    itemId: Z,
    treeId: I,
    id: y
  }), vt = c.canItemBeTabbed(Z) ? 0 : -1, Kt = {
    rootRefObject: He,
    contentRefObject: Je,
    interactions: {
      handleSaveItemLabel: $,
      handleCancelItemLabelEditing: O
    }
  }, Te = ((Yt = Ve.root) == null ? void 0 : Yt.call(Ve, et({}, Kt, {
    externalEventHandlers: D5(x)
  }))) ?? {}, Tt = ((zt = Ve.content) == null ? void 0 : zt.call(Ve, et({}, Kt, {
    externalEventHandlers: D5(f)
  }))) ?? {}, Ue = ((ri = Ve.dragAndDropOverlay) == null ? void 0 : ri.call(Ve, et({}, Kt, {
    externalEventHandlers: {}
  }))) ?? {}, Me = ((di = Ve.labelInput) == null ? void 0 : di.call(Ve, et({}, Kt, {
    externalEventHandlers: {}
  }))) ?? {};
  return /* @__PURE__ */ ee(Kee, {
    itemId: Z,
    children: /* @__PURE__ */ Ri(u2t, et({
      className: Re(Pe.root, b),
      role: "treeitem",
      "aria-expanded": Ze ? J : void 0,
      "aria-selected": Bi,
      "aria-disabled": L || void 0,
      id: qe,
      tabIndex: vt
    }, x, {
      ownerState: xe,
      onFocus: ci,
      onBlur: Ge,
      onKeyDown: Be,
      ref: ke,
      style: o ? et({}, x.style, {
        "--TreeView-itemDepth": typeof d == "function" ? d(Z) : d
      }) : x.style
    }, Te, {
      children: [/* @__PURE__ */ ee(C2t, et({
        as: B,
        classes: {
          root: Pe.content,
          expanded: Pe.expanded,
          selected: Pe.selected,
          focused: Pe.focused,
          disabled: Pe.disabled,
          editable: Pe.editable,
          editing: Pe.editing,
          iconContainer: Pe.iconContainer,
          label: Pe.label,
          labelInput: Pe.labelInput,
          checkbox: Pe.checkbox
        },
        label: W,
        itemId: Z,
        onClick: V,
        onMouseDown: w,
        icon: mi,
        expansionIcon: jt,
        displayIcon: Ht,
        ownerState: xe
      }, f, Tt, Ue.action == null ? {} : {
        dragAndDropOverlayProps: Ue
      }, Me.value == null ? {} : {
        labelInputProps: Me
      }, {
        ref: we
      })), A && /* @__PURE__ */ ee(A2t, et({
        as: st
      }, bt, {
        children: A
      }))]
    }))
  });
}), Mee = ({
  node: e,
  index: t,
  label: i
}) => /* @__PURE__ */ S(Tee, { itemId: "node-" + t, label: i || e.name || "<Unnamed>", children: (e.children || []).map((n, r) => /* @__PURE__ */ S(Mee, { node: n, index: [...t, r] }, r)) }), b2t = ({
  model: e
}) => {
  const t = Z1({
    model: e,
    fileURL: e.path
  });
  return t.scene.children, /* @__PURE__ */ S(Mee, { node: t.scene, index: [e.id], label: e.label });
}, h2t = (e) => {
  var r;
  const t = (r = m1()) == null ? void 0 : r.filter((g) => g.key && e.modelKeys.includes(g.key)), i = () => (e.value || []).map((g) => "node-" + g), n = (g, o) => {
    const l = o.map((a) => a.substring(5).split(",").map((I) => de.parseInt(I)));
    e.onChange(l);
  };
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Ct, { component: "label", color: "textSecondary", children: e.label }),
    /* @__PURE__ */ S($wt, { multiSelect: !0, checkboxSelection: !0, selectedItems: i(), onSelectedItemsChange: n, children: t.map((g) => g.type == "dynamic" ? /* @__PURE__ */ S(Tee, { itemId: g.id + "id", label: g.label }, g.id) : /* @__PURE__ */ S(b2t, { model: g }, g.id)) })
  ] });
}, m2t = (e) => {
  var t;
  return Gi(), ie(mA((t = e.ruleItem) == null ? void 0 : t.id, e.ruleColumnId)), /* @__PURE__ */ Ie(pi, { gap: 3, children: [
    /* @__PURE__ */ S(Km, { modelActionRuleItemValue: e.modelActionRuleItemValue, model: e.model, onChange: e.onChange, ruleItem: e.ruleItem, ruleColumnId: e.ruleColumnId }),
    /* @__PURE__ */ S(Rw, { label: "Modelle", multiple: !0, modelKey: e.dynamicModelProps.models, onChangeMultiple: e.onChange("models") }),
    /* @__PURE__ */ S(h2t, { label: "Auswahl", modelKeys: e.dynamicModelProps.models, value: e.dynamicModelProps.ids, onChange: e.onChange("ids") })
  ] });
}, p2t = ({
  model: e,
  ids: t
}) => {
  const i = Z1({
    model: e,
    fileURL: e.path
  });
  if (!e)
    return null;
  let n = i.scene.clone(), r = 1;
  for (; r < t.length; )
    n = n.children[t[r++]];
  return n ? /* @__PURE__ */ S("mesh", { children: /* @__PURE__ */ S("primitive", { object: n }) }) : null;
}, B2t = (e) => {
  const t = m1() || [];
  return /* @__PURE__ */ S("group", { position: e.position, rotation: e.rotation, scale: e.scale, userData: {
    modelId: e.id
  }, children: e.ids.map((i, n) => {
    const r = t.find((g) => g.id == i[0]);
    return r ? /* @__PURE__ */ S(p2t, { model: r, ids: i }, i.join(",")) : null;
  }) });
}, f2t = {
  type: "part",
  label: "Part",
  disabledForAR: !1,
  component: B2t,
  propsDialog: m2t,
  defaultProps: {
    models: [],
    ids: []
  },
  materials: [],
  repositionApplicator: Sc,
  screenshot: Iwt,
  tag: "beta"
}, jf = () => VI("getDynamicModels", [qZt, iyt, oGt, lyt, gwt, swt, f2t]), Pee = (e, t) => {
  const i = jf().find((r) => r.type === e.dynamicModelKey);
  let n;
  return i ? n = i.component : console.error("Dynamic model not found", t.modelId), n;
}, Z2t = (e, t, i) => XJ((n, r, g) => {
  const o = de.isArray(r), a = (o ? r : [r]).map((I) => {
    let c = 0;
    if (oq(I)) {
      const d = Lv(e.variables.flat.all, e.values.flat.all, e.variables.variableHierarchies, t, I.expression, i, e);
      d.errorMessage && console.error(d.errorMessage), d.result && (c = d.result);
    } else
      c = I;
    return c;
  });
  return {
    ...n,
    [g]: o ? a : a[0]
  };
}, {}), Uee = (e, t, i, n, r = Ut) => {
  const g = jf().find((a) => a.type === (i == null ? void 0 : i.dynamicModelKey)), o = {
    ...g == null ? void 0 : g.defaultProps,
    ...i == null ? void 0 : i.props,
    ...n == null ? void 0 : n.props
  };
  return [Z2t(e, t, r)(o), o];
}, G2t = (e, {
  column: t,
  validSelectionCombinations: i,
  ruleItem: n,
  rule: r
}) => (i[n.id] || []).map((o) => {
  var a, I;
  const l = Number((t == null ? void 0 : t.targetId) || ((a = r == null ? void 0 : r.columns.find(Gc)) == null ? void 0 : a.targetId)) || void 0;
  return {
    ...e,
    variableId: l,
    selectionId: (I = o == null ? void 0 : o.find((c) => c.variableId === l)) == null ? void 0 : I.id,
    anchoringSelection: h1(o),
    ruleItem: n,
    ruleColumn: t
  };
}), y2t = {
  type: "articles",
  isOfType: Uye,
  createActions: G2t
};
function W2t(e, t, i, n, r, g) {
  const o = $x(e, t, i, n, g);
  return de.assignWith({}, r, o, J$);
}
function S2t(e) {
  return e.reduce((t, i) => !t || t.instance.hierarchyLevel < i.instance.hierarchyLevel ? i : t, void 0);
}
function HE(e, t, i) {
  const {
    selections: n,
    validSelectionCombinations: r,
    ruleItem: g,
    selectionScopes: o,
    variablesByParentId: l,
    selectionsByVariableId: a
  } = e, I = n.filter((A) => A.instance.isInstanceLauncher), c = n;
  return (r[g.id] ?? []).reduce((A, b) => {
    var f;
    const m = hE(b, o[g.id]), p = t ?? ((f = S2t(b)) == null ? void 0 : f.variableId);
    return p === void 0 ? (console.error(`Variable ID: ${p} not found! It is referenced in rule item ${JSON.stringify(e.ruleItem, null, 2)}
 of rule "${e.rule.label}" with id ${e.rule.id}!`), A) : ((m[p] ?? [Ut]).forEach((Z) => {
      const y = W2t(Z, c, l, a, m, I), W = i(Z, b, y);
      W && A.push(W);
    }), A);
  }, []);
}
const V2t = (e, t) => HE(t, e.variableId, (i, n, r) => {
  var o;
  const g = (o = t.actionEngineInput.values.byVarId[i.variableId]) == null ? void 0 : o.find((l) => l.id === i.valueId);
  if (g)
    return {
      targetMaterial: t.column.targetId,
      hex: g == null ? void 0 : g.value,
      ruleItem: t.ruleItem,
      ruleColumn: t.column,
      selections: n,
      selectionScope: r,
      anchoringSelection: i,
      modelIds: t.column.modelIds
    };
}), w2t = {
  type: "colors",
  isOfType: zye,
  createActions: V2t
}, v2t = {
  type: "concealGroups",
  isOfType: Nye,
  createActions: Tm
}, R2t = N$(), X2t = {
  type: "concealVariables",
  isOfType: Lye,
  createActions: R2t
}, H2t = (e, {
  column: t,
  ruleItem: i,
  ruleEngineInput: n,
  selectionScopes: r,
  validSelectionCombinations: g
}) => {
  const o = An(n.values.flat.all), l = de.uniq(e.values.map((d) => {
    var C;
    return (C = o[d]) == null ? void 0 : C.variableId;
  }).filter(Boolean)), a = n.variables.byVarId.all, I = (g == null ? void 0 : g[i.id]) ?? [];
  return E$(l, a, i, r, I, (d, C) => ({
    variableId: d,
    valueIds: e.values.filter((A) => o[A].variableId === d),
    instanceIds: C,
    ruleItem: i,
    ruleColumn: t
  }));
}, k2t = {
  type: "hideValues",
  isOfType: Pye,
  createActions: H2t
}, Y2t = {
  type: "images",
  isOfType: Qye,
  createActions: Tm
}, F2t = (e, t) => {
  var r;
  const i = (r = t.column) == null ? void 0 : r.targetId, n = t.actionEngineInput.variables.find((g) => g.id === e.variableId);
  return HE(t, n == null ? void 0 : n.id, (g, o, l) => {
    var a, I, c, d, C;
    return {
      targetMaterial: i,
      materialUrl: ((a = g == null ? void 0 : g.data) == null ? void 0 : a.url) ?? "",
      scale: ((I = g == null ? void 0 : g.data) == null ? void 0 : I.scale) ?? 1,
      topbottom: ((c = g == null ? void 0 : g.data) == null ? void 0 : c.topbottom) ?? 1,
      leftright: ((d = g == null ? void 0 : g.data) == null ? void 0 : d.leftright) ?? 1,
      hideOriginalMapWhenPrinting: (C = n == null ? void 0 : n.settings.templateOptions) == null ? void 0 : C.hideOriginalMapWhenPrinting,
      selections: o,
      selectionScope: l,
      ruleItem: t.ruleItem,
      ruleColumn: t.column,
      anchoringSelection: g,
      modelIds: t.column.modelIds
    };
  });
}, x2t = {
  type: "prints",
  isOfType: YJ,
  createActions: F2t
}, D2t = {
  type: "labels",
  isOfType: Jye,
  createActions: Tm
}, J2t = (e, t) => (t.column.targets || []).flatMap((n) => HE(t, void 0, (r, g, o) => ({
  ...n,
  replacementMaterialId: e.materialId,
  ruleItem: t.ruleItem,
  ruleColumn: t.column,
  selections: g,
  selectionScope: o,
  anchoringSelection: r
}))) || [], E2t = {
  type: "materials",
  isOfType: Oye,
  createActions: J2t
}, N2t = (e, {
  validSelectionCombinations: t,
  ruleItem: i,
  column: n,
  rule: r,
  selections: g,
  ruleEngineInput: o,
  metadata: l
}) => (t[i.id] ?? []).map((c) => {
  const d = l.models.find((m) => m.id === e.modelId);
  if (!d)
    return null;
  const C = h1(c), [A, b] = Uee(o, g, d, e, C);
  return {
    ...e,
    expressionProps: b,
    unique: `ruleItem_${i.id}_ruleId_${r == null ? void 0 : r.id}_modelId_${e.modelId}_anchoringSelectionId_${C.instance.id}`,
    ruleItem: i,
    ruleColumn: n,
    selections: c,
    props: A,
    model: d,
    anchoringSelection: C
  };
}).filter(Boolean), L2t = {
  type: "models",
  isOfType: cw,
  createActions: N2t
}, K2t = {
  type: "exitButtons",
  isOfType: Mye,
  createActions: Tm
}, T2t = [y2t, w2t, v2t, X2t, k2t, D2t, E2t, L2t, x2t, Y2t, K2t], M2t = [...L$, ...T2t];
function P2t(e, t, i, n, r) {
  if (e != null && e.modelId) {
    const g = sv(t, i.state.all.selections), o = n.models.find((l) => l.id === e.modelId);
    if (o) {
      const [l, a] = Uee(t, g, o);
      r.models.push({
        id: zg.SetModel,
        modelId: e.modelId,
        model: o,
        props: l,
        expressionProps: a,
        anchoringSelection: Ut,
        ruleItem: null,
        ruleColumn: null,
        unique: `ruleItem_-1_ruleId_${zg.SetModel}_modelId_${e.modelId}_anchoringSelectionId_${Ut.id}`
      });
    }
  }
}
const kE = (e, t, i, n, r) => {
  const g = _8(M2t)(e, t, i, n, r);
  return P2t(n, t, i, r, g), g;
}, U2t = async (e) => {
  const t = await Jyt(e, void 0, void 0, void 0, !0).catch((i) => {
    throw i;
  });
  return t ? {
    state: t,
    changes: [],
    touchedChanges: [],
    onlyUntouched: !0
  } : !1;
}, xS = "fillLater", z2t = (e, t) => {
  const i = t.json.variables.filter((o) => e.variables.byVarId.all[o.variableId]), n = y6(e.variables.flat.all);
  let r = i.map((o) => {
    var m, p, B, f, Z, y, W;
    const l = e.variables.byVarId.all[o.variableId], a = km(l), I = o.id || u6(), c = a ? {
      id: I,
      isInstanceLauncher: !0,
      belongsToVariableId: o.variableId,
      belongsToInstanceId: ((m = o.parent) == null ? void 0 : m.selectionId) || "",
      hierarchyLevel: n[o.variableId]
    } : {
      id: ((p = o.parent) == null ? void 0 : p.selectionId) || "",
      isInstanceLauncher: !1,
      belongsToVariableId: ((B = o.parent) == null ? void 0 : B.variableId) || null,
      belongsToInstanceId: (f = o.parent) != null && f.selectionId ? xS : "",
      hierarchyLevel: n[o.variableId]
    };
    let d = o.value;
    const C = {
      ...o.additionalData
    }, A = {};
    if (Sg(l)) {
      const V = Number(((Z = o.additionalData) == null ? void 0 : Z.inputValue) ?? 0), w = e.values.byVarId.all[l.id].find((v) => Wc(oA(V), v.data));
      if (C.inputValue = V, !w)
        return null;
      d = w.id, A.interval = w.data;
    } else if (l.type === Ho.Text) {
      const V = (y = e.values.byVarId.all[l.id]) == null ? void 0 : y[0];
      V && (d = V.id);
    }
    const b = {
      id: I,
      sort: o.sort,
      variableId: o.variableId,
      valueId: d,
      data: C,
      instance: c,
      debuggingValue: o.debuggingValue,
      ...A
    };
    if ((W = b == null ? void 0 : b.data) != null && W.url) {
      const V = b.data.url.replace(/ /g, "_");
      b.data.url = av.first(Object.values(t.files[V] ?? {})) || l.settings.templateOptions.previewImage || void 0;
    }
    return b;
  }).filter(Boolean), g = 0;
  for (; r.some((o) => o.instance.belongsToInstanceId === xS) && g < 20; )
    r = r.map((o, l, a) => {
      if (o.instance.belongsToInstanceId !== xS)
        return o;
      const I = a.find((d) => d.id === o.instance.id), c = I == null ? void 0 : I.instance.belongsToInstanceId;
      return I && c !== xS ? wI({
        instance: {
          belongsToInstanceId: c
        }
      })(o) : o;
    }), g++;
  return g === 20 && console.error("Too many iterations needed to resolve selection tree", r, t), r;
}, O2t = (e, t, i) => Xye(e, t).reduce((n, r) => {
  if (!r.valueId)
    return n;
  const g = e.variables.byVarId.all[r.variableId], o = t.find((I) => I.id === V5(r)) || Ut, l = !f6(g, e, i.state, r), a = {
    sort: r.sort,
    hidden: l,
    variableId: r.variableId,
    value: r.valueId,
    additionalData: r.data,
    debuggingValue: r.debuggingValue,
    parent: {
      selectionId: o.id,
      variableId: o.variableId,
      valueId: (o == null ? void 0 : o.valueId) || null
    },
    id: r.id
  };
  return [...n, a];
}, []), Q2t = (e, t, i) => Le.flow(() => new URLSearchParams(window.location.search + `&${i}`), Object.fromEntries, Le.omit(["app", "code", "dealer"]), Kyt(e, t))(), zee = () => async (e, t) => {
  var b;
  const i = t(), n = hA(i), r = Og(i), g = $l(i), o = Rc(i), l = KWe(i), a = x6(i), I = Pi(i), d = (b = Vv(i).apps) == null ? void 0 : b.find((m) => m.appId == I.id), C = (d == null ? void 0 : d.query) ?? "", A = Jr(i);
  try {
    const m = W$(a, n, o, g, r, void 0, void 0, i);
    let p;
    if (l) {
      const f = z2t(m, l.configuration), {
        locked: Z
      } = HJ(m, f);
      p = await fV(m, f, !l.configuration.inspiration && l.configuration.json.touched || {}, void 0, Z).catch((y) => {
        throw y;
      });
    } else if (A != null && // this checks if the existing state belongs to our app.
    A.state.all.selections.some((Z) => m.values.byVarId.all[Z.variableId]))
      try {
        p = await fV(m, A.state.all.selections, A.state.all.touched, void 0, A.state.locked.selections).catch((Z) => {
          throw Z;
        });
      } catch {
        p = await fV(m, A.state.all.selections, A.state.all.touched, void 0, void 0).catch((y) => {
          throw y;
        });
      }
    else
      p = await U2t(m).catch((Z) => {
        throw Z;
      });
    if (!p)
      throw new Error("Unable to calculate initial rule engine state");
    p = Q2t(m, p, C);
    const B = GAt(n, o, g, r, i);
    e(X7(null)), await e(P$(kE, p, m, B, !0)).catch((f) => {
      throw f;
    }), e(wT());
  } catch (m) {
    e(wT(m.message)), console.error(m);
  }
}, Oee = (e) => (t, i) => {
  const n = i(), r = Sv(n), g = KJ(e, r)[0];
  t(Y7(g || null));
}, Qee = ({
  appId: e,
  attrs: t = null,
  description: i = null,
  disabled: n = !1,
  isDefault: r = !1,
  key: g = null,
  label: o,
  price: l = 0,
  sort: a,
  thumbnail: I = null,
  url: c = null,
  info: d = null,
  value: C,
  variableId: A
}) => ({
  appId: e,
  attrs: t,
  description: i,
  disabled: n,
  isDefault: r,
  key: g,
  label: o,
  price: l,
  sort: a,
  thumbnail: I,
  url: c,
  value: C,
  info: d,
  variableId: A
}), qf = (e, t) => async (i, n) => {
  const r = n(), g = Er(r), o = kv(t.id)(r), l = Qee({
    ...e,
    sort: (e == null ? void 0 : e.sort) === void 0 ? 1 + Math.max(...o.map((I) => I.sort), 0) : e.sort,
    appId: t.appId,
    variableId: t.id
  }), a = await d_("value", l, {
    lang: g
  });
  return i(t8(a)), a;
}, rei = (e, t) => async (i, n) => {
  const r = n(), g = Er(r), o = kv(t.id)(r), l = e.map((I, c) => Qee({
    ...I,
    sort: 1 + Math.max(...o.map((d) => d.sort), 0) + c,
    appId: t.appId,
    variableId: t.id
  })), a = await N0t("value", l, {
    lang: g
  });
  return a.forEach((I) => i(t8(I))), a;
}, j2t = (e) => async (t) => {
  t(tdt(e)), await u_("value", e);
}, q2t = (e) => (t, i) => {
  const n = i(), r = nr(n);
  if (!r) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const g = Object.entries(e).flatMap(([a, I]) => r.variables.flat.all.filter((C) => C.groupId == +I).map((C) => ({
    instanceId: a,
    variableId: C.id
  }))), o = Jr(n);
  if (!o) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const l = Yv(r, o.state, g);
  t(s8({
    ...o,
    state: l
  }));
}, YE = (e) => (t, i) => {
  const n = i(), r = TZ(n, e);
  t(eG(r == null ? void 0 : r.id));
}, _2t = () => (e, t) => {
  const i = t(), n = DJ(i);
  e(w5((n == null ? void 0 : n.engineState) ?? null)), e(mw(null));
}, $2t = () => (e) => {
  e(mw(null));
};
function evt(e, t) {
  const i = Ns(e), n = E6(e), r = i.find((C) => C.variableId === t.parentId);
  if (!r)
    return {
      openingGroupMap: n,
      closingGroupMap: {}
    };
  const g = Br(e), l = [...(r ? vm(g, r) : []).filter((C) => i.includes(C)), r], a = _l(e), I = vc(e), c = l.reduce((C, A) => {
    var m, p;
    const b = l.find((B) => B.id !== A.id && B.instance.belongsToInstanceId === A.id);
    if (b) {
      const B = I[b == null ? void 0 : b.variableId];
      C[A.id] = ((m = a.find((f) => f.id === (B == null ? void 0 : B.groupId))) == null ? void 0 : m.id) || n[A.id];
    } else
      C[A.id] = r.id === A.id && t.id || n[A.id] || ((p = TZ(e, A)) == null ? void 0 : p.id);
    return C;
  }, {}), d = de.omitBy(de.mapValues(n, (C, A) => n[A] && c[A] !== n[A] ? C : -1), (C) => C === -1);
  return {
    openingGroupMap: c,
    closingGroupMap: d
  };
}
const eG = (e) => async (t, i) => {
  const n = i(), r = JJ(n, e);
  if (!r) {
    console.error("setGroup contextInstance not found", e);
    return;
  }
  const g = kI(e)(n);
  if (!g) {
    console.error("setGroup group not found", e);
    return;
  }
  const {
    openingGroupMap: o,
    closingGroupMap: l
  } = evt(n, g);
  t(hct(o)), t(Oee({
    type: "group",
    id: e
  })), t(bct({
    focusGroupId: e,
    instanceId: r.id
  })), t(q2t(l)), mWe(n) && await t(zee()).catch((I) => {
    throw I;
  });
  const a = Pi(i());
  cm("step", (g == null ? void 0 : g.key) || (g == null ? void 0 : g.label) || "none", a, "step");
}, jee = (e) => (t, i) => {
  const n = i(), r = A0t(e == null ? void 0 : e.variableId)(n), g = qa(e) || Ut.id;
  t(wr(g, r == null ? void 0 : r.id));
}, qee = (e) => (t) => {
  _j("preprocessFullApp") && (e = VI("preprocessFullApp", e)), t(Mct(e == null ? void 0 : e.client)), t(L7(e == null ? void 0 : e.groups)), t(r8(e == null ? void 0 : e.variables)), t(i8(e == null ? void 0 : e.values)), t(J7(e == null ? void 0 : e.articles)), t(Q7(e == null ? void 0 : e.prices)), t(P7(e == null ? void 0 : e.materials)), t(z7(e == null ? void 0 : e.models)), t(T7((e == null ? void 0 : e.images) || [])), t($7(e == null ? void 0 : e.rules)), t(q7(e == null ? void 0 : e.ruleItems)), dAt(e.app);
}, gei = (e, t) => async (i) => {
  const n = await lAt(t, e);
  return i(qee(n)), n;
}, oei = async (e) => {
  e(L7([])), e(r8([])), e(i8([])), e(J7([])), e(Q7([])), e(P7([])), e(z7([])), e(T7([])), e($7([])), e(q7([]));
}, tvt = () => async (e, t) => {
  const i = t(), n = K8(i), r = yv(n == null ? void 0 : n.id)(i);
  let g = Ut;
  Ut && r && (g = r), e(wr(g.id));
  const o = location.href.includes("edit/configurator/mobile") ? "phone" : "desktop";
  e(Wct(o));
}, ivt = (e, t) => {
  var r, g;
  const i = {
    articles: [],
    prices: []
  }, n = (r = t == null ? void 0 : t.prices) != null && r.length || (g = t == null ? void 0 : t.articles) != null && g.length ? {
    ...e,
    ...t
  } : e;
  return {
    ...i,
    ...n
  };
}, If = (e, t, i, n = !1) => async (r) => {
  i ? (r(X7({
    checkSelections: n,
    configuration: i
  })), r(Hct(i)), cm("loaded", i.code, e.app, "loaded")) : cm("loaded", "app", e.app, "loaded"), r(qee(ivt(e, t))), r(Xct(e.app)), await r(zee()), r(tvt());
}, lei = (e) => async (t) => {
  await t(qf({
    appId: e.appId,
    label: Ug("Nicht Befüllt"),
    sort: 0,
    // Das muss so bleiben für die automatische Generierung im UsageStep
    value: !1,
    variableId: e.id
  }, e)).catch((i) => {
    throw i;
  }), await t(qf({
    appId: e.appId,
    label: Ug("Befüllt"),
    sort: 1,
    // Das muss so bleiben für die automatische Generierung im UsageStep
    value: !0,
    variableId: e.id
  }, e)).catch((i) => {
    throw i;
  });
}, aei = (e) => async (t) => {
  await t(qf({
    appId: e.appId,
    label: Ug("Ausgewählt"),
    sort: 0,
    value: !0,
    variableId: e.id
  }, e)).catch((i) => {
    throw i;
  }), await t(qf({
    appId: e.appId,
    label: Ug("Nicht ausgewählt"),
    sort: 1,
    value: !1,
    variableId: e.id
  }, e)).catch((i) => {
    throw i;
  });
}, sei = (e) => async (t, i) => {
  const n = i();
  if (!i_(e.id)(n)) {
    const g = {
      label: Ug("Keine Angabe"),
      key: Ff,
      appId: e.appId,
      variableId: e.id,
      sort: 0,
      value: null
    };
    await t(qf(g, e)).catch((o) => {
      throw o;
    });
  }
}, Iei = (e) => async (t, i) => {
  const n = i(), r = i_(e.id)(n);
  r && await t(j2t(r.id)).catch((g) => {
    throw g;
  });
};
function nvt(e, t) {
  const i = vc(e), n = i[t.variableId], r = Br(e), g = [...vm(r, t), t], o = g.sort(lA).slice().reverse().find((a) => {
    const I = i[a.variableId], c = Vi(I);
    return !(c != null && c.showComponentEditorsInline) || bA(I) === Kn.ComponentValueCards;
  }) || Ut, l = g.slice(g.indexOf(o));
  return {
    variable: n,
    newOpenInstances: l
  };
}
const wr = (e, t) => (i, n) => {
  const r = n(), g = e ? LJ(e)(r) : Ut;
  if (g) {
    const {
      variable: o,
      newOpenInstances: l
    } = nvt(r, g);
    !o || $r(r) || n_(g)(r) || // We need to make empty instances selectable for the
    // ComponentValueCards template otherwise the user can't delete or sort
    // the instance.
    bA(o) === Kn.ComponentValueCards ? (i(I8(l)), i(t ? eG(t) : YE(g))) : (i(wr(g.instance.belongsToInstanceId, o.groupId)), i(pct(o.id)));
  }
};
var vV = /* @__PURE__ */ ((e) => (e[e.initial = 0] = "initial", e[e.localSavedWithSavedAction = 1] = "localSavedWithSavedAction", e[e.localSavedWithoutSavedAction = 2] = "localSavedWithoutSavedAction", e[e.versionMissmatch = 3] = "versionMissmatch", e[e.noAppAndCfgCode = 4] = "noAppAndCfgCode", e[e.errorWhileLoading = 5] = "errorWhileLoading", e))(vV || {});
function rvt(e) {
  const t = Ei(), [i, n] = wt(
    0
    /* initial */
  ), [r, g] = wt(void 0), [o, l] = wt(void 0);
  return lt(() => {
    (async () => {
      const I = QCt(), c = jCt(), d = zCt();
      async function C(b, m) {
        var f;
        let p;
        try {
          b && (p = await Jv(`/data/dealer/${b}.json`));
        } catch {
          n(
            4
            /* noAppAndCfgCode */
          );
        }
        if (!p)
          return;
        if ((f = p == null ? void 0 : p.apps) == null ? void 0 : f.find((Z) => Z.appId == m.app.id))
          t(Act(p));
        else
          throw new Error("no dealer app access");
      }
      async function A(b, m) {
        return jx(dw(b.app)[0], b.app.code, m == null ? void 0 : m.articleVersionId);
      }
      if (c) {
        let b;
        try {
          b = await IAt(c);
        } catch {
          console.error("No Inspiration for this configuration found. Instead asking Backend. No Problem :-)");
          try {
            if (b = await cAt(c), !b.versionId)
              throw new Error("Konfiguration nicht gefunden. Ist der Konfigurator veröffentlicht?");
          } catch {
            n(
              4
              /* noAppAndCfgCode */
            );
          }
        }
        if (!b)
          return;
        b.articleVersionId = "current", b.versionId || console.error("Configuration was created with unpublished version.");
        const m = await Qx(fw(b), b.appCode, "current", t);
        if (await C(
          // queryDealerCode is required for inspirations
          b.dealerCode ?? d,
          m
        ), b.inspiration) {
          const p = await A(m, b);
          await t(If(m, p, b, !0));
        } else if (b.versionId !== m.app.versionId)
          n(
            3
            /* versionMissmatch */
          ), g(m), l(b);
        else {
          const p = await A(m, b);
          t(If(m, p, b));
        }
      } else if (I)
        try {
          const b = await Qx(fw(), I, "current", t);
          await C(d, b);
          const m = await A(b);
          t(If(b, m));
        } catch {
          n(
            4
            /* noAppAndCfgCode */
          );
        }
      else
        n(
          4
          /* noAppAndCfgCode */
        );
    })();
  }, [e]), {
    situation: i,
    versionMissmatchedApp: r,
    versionMissmatchedConfiguration: o
  };
}
const gvt = () => {
  const {
    t: e
  } = Gi(), t = Ei(), {
    situation: i,
    versionMissmatchedApp: n,
    versionMissmatchedConfiguration: r
  } = rvt(
    0
    /* none */
  ), g = ZA(), o = Vg(), l = fw(), a = (d) => {
    var C, A, b, m;
    return ((m = (b = (A = (C = n == null ? void 0 : n.app) == null ? void 0 : C.settings) == null ? void 0 : A.dynamicSettings) == null ? void 0 : b[d]) == null ? void 0 : m[l]) || o(d);
  }, I = async () => {
    t(yT(!1));
    const d = await jx(dw(n.app)[0], n.app.code, r == null ? void 0 : r.articleVersionId);
    t(If(n, d, r));
  }, c = async () => {
    const d = t(fE);
    if (!r)
      return;
    const C = await Qx(fw(r), r.versionId, "old", null), A = await jx(dw(C.app)[0], C.app.code, r == null ? void 0 : r.articleVersionId);
    t(yT(!0)), await t(If(C, A, r)), t(e9(d));
  };
  switch (i) {
    case vV.initial:
      return /* @__PURE__ */ S(zj, { loading: !0 });
    case vV.versionMissmatch:
      return /* @__PURE__ */ Ie(wf, { open: !0, children: [
        /* @__PURE__ */ S(Xf, { children: a("appload_versionmismatch_title") }),
        /* @__PURE__ */ Ie(Rf, { children: [
          /* @__PURE__ */ S(BI, { children: a("appload_versionmismatch_text") }),
          /* @__PURE__ */ Ie(vf, { children: [
            /* @__PURE__ */ S(fn, { onClick: c, "data-cy": "oldVersion", children: a("appload_versionmismatch_old") }),
            /* @__PURE__ */ S(fn, { "data-cy": "newVersion", variant: "contained", onClick: I, children: a("appload_versionmismatch_new") })
          ] })
        ] })
      ] });
    case vV.noAppAndCfgCode:
      return /* @__PURE__ */ Ie(wf, { open: !0, children: [
        /* @__PURE__ */ S(Xf, { children: e("Ladevorgang fehlgeschlagen") }),
        /* @__PURE__ */ Ie(Rf, { children: [
          /* @__PURE__ */ S(BI, { children: e("Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!") }),
          /* @__PURE__ */ Ie(vf, { children: [
            /* @__PURE__ */ S(fn, { "data-cy": "goHome", onClick: () => {
              g("/admin"), g(0);
            }, children: e("Zur Startseite") }),
            /* @__PURE__ */ S(fn, { onClick: () => window.location.reload(), "data-cy": "reload", children: e("Neu Laden") }),
            /* @__PURE__ */ S(fn, { "data-cy": "restart", onClick: () => {
              window.localStorage.clear(), window.location.reload();
            }, children: e("Cleanup und Neu Laden") })
          ] })
        ] })
      ] });
    default:
      return /* @__PURE__ */ S(li, {});
  }
};
function ovt(e) {
  if (!e)
    return 1 / 0;
  const t = new Date(e.replace(".000000", "")), i = /* @__PURE__ */ new Date();
  i.setHours(0, 0, 0, 0), t.setHours(0, 0, 0, 0);
  const n = t.getTime() - i.getTime();
  return Math.ceil(n / (1e3 * 60 * 60 * 24));
}
const FE = () => {
  var r, g, o, l, a;
  const {
    themeOptionsCreator: e
  } = Xv(), t = ie(Pi), i = (g = (r = ie(Vv)) == null ? void 0 : r.apps) == null ? void 0 : g.find((I) => I.appId == (t == null ? void 0 : t.id)), n = (a = (l = (o = i == null ? void 0 : i.settings) == null ? void 0 : o.ext) == null ? void 0 : l.theme) != null && a.palette ? i : t;
  return Oe(() => {
    var A, b;
    const I = ((b = (A = n == null ? void 0 : n.settings) == null ? void 0 : A.ext) == null ? void 0 : b.theme) ?? {}, c = pg(GJ, I), d = (e == null ? void 0 : e(de.cloneDeep(c))) ?? c;
    let C = Sm(d, ZJ);
    return C = _D(C), C;
  }, [n, e]);
};
function lvt(e, t = !0, i) {
  const r = ie(J6), g = ["app", {
    id: (e == null ? void 0 : e.toString()) ?? "id",
    lang: r
  }];
  return B7(g, async ({
    queryKey: [o, {
      id: l,
      lang: a
    }]
  }) => await L0t(o, String(l), {
    lang: a
  }), {
    enabled: t
  });
}
const cei = () => {
  const e = +Uut().appId, t = lvt(e).data, i = L8();
  if ((t == null ? void 0 : t.code) === i) {
    console.warn("Not switching bundle because no app could be found. This is most likely a race condition somewhere, but we will be forgiving here, as it is very likely that the user will be redirected correctly eventually.");
    return;
  }
  _ee(t, !1);
}, _ee = (e, t) => {
  if (!e)
    return;
  const i = F9(), n = e.type || qv, r = e.release || null, g = r ? `rel/${n}/${r}` : n;
  if (avt(e) || // sadly we don't have multiple apps on localhost so we stay here.
  !i.host.includes(sl.originalDomain))
    return;
  const o = `${window.location.protocol}//${i.host}/${g}${t ? "" : "/#"}/${i.path}`;
  window.location.replace(o);
}, avt = (e) => {
  if (!e)
    return !1;
  const t = F9(), i = e.type || qv, n = e.release || null, r = n ? `rel/${i}/${n}` : i;
  return t.currentAppType === r;
};
var E5 = function(e, t) {
  return E5 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, n) {
    i.__proto__ = n;
  } || function(i, n) {
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (i[r] = n[r]);
  }, E5(e, t);
};
function svt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  E5(e, t);
  function i() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (i.prototype = t.prototype, new i());
}
var cg = function() {
  return cg = Object.assign || function(t) {
    for (var i, n = 1, r = arguments.length; n < r; n++) {
      i = arguments[n];
      for (var g in i)
        Object.prototype.hasOwnProperty.call(i, g) && (t[g] = i[g]);
    }
    return t;
  }, cg.apply(this, arguments);
};
function Ivt(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (i[n[r]] = e[n[r]]);
  return i;
}
function Zh(e, t, i, n) {
  function r(g) {
    return g instanceof i ? g : new i(function(o) {
      o(g);
    });
  }
  return new (i || (i = Promise))(function(g, o) {
    function l(c) {
      try {
        I(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function a(c) {
      try {
        I(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function I(c) {
      c.done ? g(c.value) : r(c.value).then(l, a);
    }
    I((n = n.apply(e, [])).next());
  });
}
function Gh(e, t) {
  var i = { label: 0, sent: function() {
    if (g[0] & 1)
      throw g[1];
    return g[1];
  }, trys: [], ops: [] }, n, r, g, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(I) {
    return function(c) {
      return a([I, c]);
    };
  }
  function a(I) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, I[0] && (i = 0)), i; )
      try {
        if (n = 1, r && (g = I[0] & 2 ? r.return : I[0] ? r.throw || ((g = r.return) && g.call(r), 0) : r.next) && !(g = g.call(r, I[1])).done)
          return g;
        switch (r = 0, g && (I = [I[0] & 2, g.value]), I[0]) {
          case 0:
          case 1:
            g = I;
            break;
          case 4:
            return i.label++, { value: I[1], done: !1 };
          case 5:
            i.label++, r = I[1], I = [0];
            continue;
          case 7:
            I = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (g = i.trys, !(g = g.length > 0 && g[g.length - 1]) && (I[0] === 6 || I[0] === 2)) {
              i = 0;
              continue;
            }
            if (I[0] === 3 && (!g || I[1] > g[0] && I[1] < g[3])) {
              i.label = I[1];
              break;
            }
            if (I[0] === 6 && i.label < g[1]) {
              i.label = g[1], g = I;
              break;
            }
            if (g && i.label < g[2]) {
              i.label = g[2], i.ops.push(I);
              break;
            }
            g[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        I = t.call(e, i);
      } catch (c) {
        I = [6, c], r = 0;
      } finally {
        n = g = 0;
      }
    if (I[0] & 5)
      throw I[1];
    return { value: I[0] ? I[1] : void 0, done: !0 };
  }
}
function II(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var r = 0;
    for (n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (i[n[r]] = e[n[r]]);
  }
  return i;
}
var YC = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xE(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function DE(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var yC = DE(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var i = function() {
    function n() {
      var r = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(g, o) {
        var l = r.locked.get(g);
        l === void 0 ? o === void 0 ? r.locked.set(g, []) : r.locked.set(g, [o]) : o !== void 0 && (l.unshift(o), r.locked.set(g, l));
      }, this.isLocked = function(g) {
        return r.locked.has(g);
      }, this.lock = function(g) {
        return new Promise(function(o, l) {
          r.isLocked(g) ? r.addToLocked(g, o) : (r.addToLocked(g), o());
        });
      }, this.unlock = function(g) {
        var o = r.locked.get(g);
        if (o !== void 0 && o.length !== 0) {
          var l = o.pop();
          r.locked.set(g, o), l !== void 0 && setTimeout(l, 0);
        } else
          r.locked.delete(g);
      };
    }
    return n.getInstance = function() {
      return n.instance === void 0 && (n.instance = new n()), n.instance;
    }, n;
  }();
  t.default = function() {
    return i.getInstance();
  };
});
xE(yC);
var cvt = xE(DE(function(e, t) {
  var i = YC && YC.__awaiter || function(c, d, C, A) {
    return new (C || (C = Promise))(function(b, m) {
      function p(Z) {
        try {
          f(A.next(Z));
        } catch (y) {
          m(y);
        }
      }
      function B(Z) {
        try {
          f(A.throw(Z));
        } catch (y) {
          m(y);
        }
      }
      function f(Z) {
        Z.done ? b(Z.value) : new C(function(y) {
          y(Z.value);
        }).then(p, B);
      }
      f((A = A.apply(c, d || [])).next());
    });
  }, n = YC && YC.__generator || function(c, d) {
    var C, A, b, m, p = { label: 0, sent: function() {
      if (1 & b[0])
        throw b[1];
      return b[1];
    }, trys: [], ops: [] };
    return m = { next: B(0), throw: B(1), return: B(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
      return this;
    }), m;
    function B(f) {
      return function(Z) {
        return function(y) {
          if (C)
            throw new TypeError("Generator is already executing.");
          for (; p; )
            try {
              if (C = 1, A && (b = 2 & y[0] ? A.return : y[0] ? A.throw || ((b = A.return) && b.call(A), 0) : A.next) && !(b = b.call(A, y[1])).done)
                return b;
              switch (A = 0, b && (y = [2 & y[0], b.value]), y[0]) {
                case 0:
                case 1:
                  b = y;
                  break;
                case 4:
                  return p.label++, { value: y[1], done: !1 };
                case 5:
                  p.label++, A = y[1], y = [0];
                  continue;
                case 7:
                  y = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (b = p.trys, !((b = b.length > 0 && b[b.length - 1]) || y[0] !== 6 && y[0] !== 2)) {
                    p = 0;
                    continue;
                  }
                  if (y[0] === 3 && (!b || y[1] > b[0] && y[1] < b[3])) {
                    p.label = y[1];
                    break;
                  }
                  if (y[0] === 6 && p.label < b[1]) {
                    p.label = b[1], b = y;
                    break;
                  }
                  if (b && p.label < b[2]) {
                    p.label = b[2], p.ops.push(y);
                    break;
                  }
                  b[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              y = d.call(c, p);
            } catch (W) {
              y = [6, W], A = 0;
            } finally {
              C = b = 0;
            }
          if (5 & y[0])
            throw y[1];
          return { value: y[0] ? y[1] : void 0, done: !0 };
        }([f, Z]);
      };
    }
  }, r = YC;
  Object.defineProperty(t, "__esModule", { value: !0 });
  var g = "browser-tabs-lock-key", o = { key: function(c) {
    return i(r, void 0, void 0, function() {
      return n(this, function(d) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(c) {
    return i(r, void 0, void 0, function() {
      return n(this, function(d) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return i(r, void 0, void 0, function() {
      return n(this, function(c) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(c) {
    return i(r, void 0, void 0, function() {
      return n(this, function(d) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(c, d) {
    return i(r, void 0, void 0, function() {
      return n(this, function(C) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(c) {
    return window.localStorage.key(c);
  }, getItemSync: function(c) {
    return window.localStorage.getItem(c);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(c) {
    return window.localStorage.removeItem(c);
  }, setItemSync: function(c, d) {
    return window.localStorage.setItem(c, d);
  } };
  function l(c) {
    return new Promise(function(d) {
      return setTimeout(d, c);
    });
  }
  function a(c) {
    for (var d = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", C = "", A = 0; A < c; A++)
      C += d[Math.floor(Math.random() * d.length)];
    return C;
  }
  var I = function() {
    function c(d) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + a(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = d, c.waiters === void 0 && (c.waiters = []);
    }
    return c.prototype.acquireLock = function(d, C) {
      return C === void 0 && (C = 5e3), i(this, void 0, void 0, function() {
        var A, b, m, p, B, f, Z;
        return n(this, function(y) {
          switch (y.label) {
            case 0:
              A = Date.now() + a(4), b = Date.now() + C, m = g + "-" + d, p = this.storageHandler === void 0 ? o : this.storageHandler, y.label = 1;
            case 1:
              return Date.now() < b ? [4, l(30)] : [3, 8];
            case 2:
              return y.sent(), p.getItemSync(m) !== null ? [3, 5] : (B = this.id + "-" + d + "-" + A, [4, l(Math.floor(25 * Math.random()))]);
            case 3:
              return y.sent(), p.setItemSync(m, JSON.stringify({ id: this.id, iat: A, timeoutKey: B, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, l(30)];
            case 4:
              return y.sent(), (f = p.getItemSync(m)) !== null && (Z = JSON.parse(f)).id === this.id && Z.iat === A ? (this.acquiredIatSet.add(A), this.refreshLockWhileAcquired(m, A), [2, !0]) : [3, 7];
            case 5:
              return c.lockCorrector(this.storageHandler === void 0 ? o : this.storageHandler), [4, this.waitForSomethingToChange(b)];
            case 6:
              y.sent(), y.label = 7;
            case 7:
              return A = Date.now() + a(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, c.prototype.refreshLockWhileAcquired = function(d, C) {
      return i(this, void 0, void 0, function() {
        var A = this;
        return n(this, function(b) {
          return setTimeout(function() {
            return i(A, void 0, void 0, function() {
              var m, p, B;
              return n(this, function(f) {
                switch (f.label) {
                  case 0:
                    return [4, yC.default().lock(C)];
                  case 1:
                    return f.sent(), this.acquiredIatSet.has(C) ? (m = this.storageHandler === void 0 ? o : this.storageHandler, (p = m.getItemSync(d)) === null ? (yC.default().unlock(C), [2]) : ((B = JSON.parse(p)).timeRefreshed = Date.now(), m.setItemSync(d, JSON.stringify(B)), yC.default().unlock(C), this.refreshLockWhileAcquired(d, C), [2])) : (yC.default().unlock(C), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, c.prototype.waitForSomethingToChange = function(d) {
      return i(this, void 0, void 0, function() {
        return n(this, function(C) {
          switch (C.label) {
            case 0:
              return [4, new Promise(function(A) {
                var b = !1, m = Date.now(), p = !1;
                function B() {
                  if (p || (window.removeEventListener("storage", B), c.removeFromWaiting(B), clearTimeout(f), p = !0), !b) {
                    b = !0;
                    var Z = 50 - (Date.now() - m);
                    Z > 0 ? setTimeout(A, Z) : A(null);
                  }
                }
                window.addEventListener("storage", B), c.addToWaiting(B);
                var f = setTimeout(B, Math.max(0, d - Date.now()));
              })];
            case 1:
              return C.sent(), [2];
          }
        });
      });
    }, c.addToWaiting = function(d) {
      this.removeFromWaiting(d), c.waiters !== void 0 && c.waiters.push(d);
    }, c.removeFromWaiting = function(d) {
      c.waiters !== void 0 && (c.waiters = c.waiters.filter(function(C) {
        return C !== d;
      }));
    }, c.notifyWaiters = function() {
      c.waiters !== void 0 && c.waiters.slice().forEach(function(d) {
        return d();
      });
    }, c.prototype.releaseLock = function(d) {
      return i(this, void 0, void 0, function() {
        return n(this, function(C) {
          switch (C.label) {
            case 0:
              return [4, this.releaseLock__private__(d)];
            case 1:
              return [2, C.sent()];
          }
        });
      });
    }, c.prototype.releaseLock__private__ = function(d) {
      return i(this, void 0, void 0, function() {
        var C, A, b, m;
        return n(this, function(p) {
          switch (p.label) {
            case 0:
              return C = this.storageHandler === void 0 ? o : this.storageHandler, A = g + "-" + d, (b = C.getItemSync(A)) === null ? [2] : (m = JSON.parse(b)).id !== this.id ? [3, 2] : [4, yC.default().lock(m.iat)];
            case 1:
              p.sent(), this.acquiredIatSet.delete(m.iat), C.removeItemSync(A), yC.default().unlock(m.iat), c.notifyWaiters(), p.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, c.lockCorrector = function(d) {
      for (var C = Date.now() - 5e3, A = d, b = [], m = 0; ; ) {
        var p = A.keySync(m);
        if (p === null)
          break;
        b.push(p), m++;
      }
      for (var B = !1, f = 0; f < b.length; f++) {
        var Z = b[f];
        if (Z.includes(g)) {
          var y = A.getItemSync(Z);
          if (y !== null) {
            var W = JSON.parse(y);
            (W.timeRefreshed === void 0 && W.timeAcquired < C || W.timeRefreshed !== void 0 && W.timeRefreshed < C) && (A.removeItemSync(Z), B = !0);
          }
        }
      }
      B && c.notifyWaiters();
    }, c.waiters = void 0, c;
  }();
  t.default = I;
}));
const dvt = { timeoutInSeconds: 60 }, $ee = { name: "auth0-spa-js", version: "2.1.3" }, ete = () => Date.now();
let vl = class N5 extends Error {
  constructor(t, i) {
    super(i), this.error = t, this.error_description = i, Object.setPrototypeOf(this, N5.prototype);
  }
  static fromPayload({ error: t, error_description: i }) {
    return new N5(t, i);
  }
}, uvt = class tte extends vl {
  constructor(t, i, n, r = null) {
    super(t, i), this.state = n, this.appState = r, Object.setPrototypeOf(this, tte.prototype);
  }
}, L5 = class ite extends vl {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, ite.prototype);
  }
}, Cvt = class nte extends L5 {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, nte.prototype);
  }
}, Avt = class rte extends vl {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, rte.prototype);
  }
}, bvt = class gte extends vl {
  constructor(t, i, n) {
    super(t, i), this.mfa_token = n, Object.setPrototypeOf(this, gte.prototype);
  }
}, ote = class lte extends vl {
  constructor(t, i) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${aU(t, ["default"])}', scope: '${aU(i)}')`), this.audience = t, this.scope = i, Object.setPrototypeOf(this, lte.prototype);
  }
};
function aU(e, t = []) {
  return e && !t.includes(e) ? e : "";
}
const RV = () => window.crypto, WF = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(RV().getRandomValues(new Uint8Array(43))).forEach((i) => t += e[i % e.length]), t;
}, sU = (e) => btoa(e), K5 = (e) => {
  var { clientId: t } = e, i = II(e, ["clientId"]);
  return new URLSearchParams(((n) => Object.keys(n).filter((r) => n[r] !== void 0).reduce((r, g) => Object.assign(Object.assign({}, r), { [g]: n[g] }), {}))(Object.assign({ client_id: t }, i))).toString();
}, IU = (e) => ((t) => decodeURIComponent(atob(t).split("").map((i) => "%" + ("00" + i.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), hvt = async (e, t) => {
  const i = await fetch(e, t);
  return { ok: i.ok, json: await i.json() };
}, mvt = async (e, t, i) => {
  const n = new AbortController();
  let r;
  return t.signal = n.signal, Promise.race([hvt(e, t), new Promise((g, o) => {
    r = setTimeout(() => {
      n.abort(), o(new Error("Timeout when executing 'fetch'"));
    }, i);
  })]).finally(() => {
    clearTimeout(r);
  });
}, pvt = async (e, t, i, n, r, g, o) => {
  return l = { auth: { audience: t, scope: i }, timeout: r, fetchUrl: e, fetchOptions: n, useFormData: o }, a = g, new Promise(function(I, c) {
    const d = new MessageChannel();
    d.port1.onmessage = function(C) {
      C.data.error ? c(new Error(C.data.error)) : I(C.data), d.port1.close();
    }, a.postMessage(l, [d.port2]);
  });
  var l, a;
}, Bvt = async (e, t, i, n, r, g, o = 1e4) => r ? pvt(e, t, i, n, o, r, g) : mvt(e, n, o);
async function fvt(e, t) {
  var { baseUrl: i, timeout: n, audience: r, scope: g, auth0Client: o, useFormData: l } = e, a = II(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  const I = l ? K5(a) : JSON.stringify(a);
  return await async function(c, d, C, A, b, m, p) {
    let B, f = null;
    for (let v = 0; v < 3; v++)
      try {
        B = await Bvt(c, C, A, b, m, p, d), f = null;
        break;
      } catch (H) {
        f = H;
      }
    if (f)
      throw f;
    const Z = B.json, { error: y, error_description: W } = Z, V = II(Z, ["error", "error_description"]), { ok: w } = B;
    if (!w) {
      const v = W || `HTTP error. Unable to fetch ${c}`;
      throw y === "mfa_required" ? new bvt(y, v, V.mfa_token) : y === "missing_refresh_token" ? new ote(C, A) : new vl(y || "request_error", v);
    }
    return V;
  }(`${i}/oauth/token`, n, r || "default", g, { method: "POST", body: I, headers: { "Content-Type": l ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(o || $ee)) } }, t, l);
}
const DS = (...e) => {
  return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
  var t;
};
let TC = class T5 {
  constructor(t, i = "@@auth0spajs@@", n) {
    this.prefix = i, this.suffix = n, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [i, n, r, g] = t.split("::");
    return new T5({ clientId: n, scope: g, audience: r }, i);
  }
  static fromCacheEntry(t) {
    const { scope: i, audience: n, client_id: r } = t;
    return new T5({ scope: i, audience: n, clientId: r });
  }
}, Zvt = class {
  set(t, i) {
    localStorage.setItem(t, JSON.stringify(i));
  }
  get(t) {
    const i = window.localStorage.getItem(t);
    if (i)
      try {
        return JSON.parse(i);
      } catch {
        return;
      }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((t) => t.startsWith("@@auth0spajs@@"));
  }
};
class ate {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let t = {};
      return { set(i, n) {
        t[i] = n;
      }, get(i) {
        const n = t[i];
        if (n)
          return n;
      }, remove(i) {
        delete t[i];
      }, allKeys: () => Object.keys(t) };
    }();
  }
}
let Gvt = class {
  constructor(t, i, n) {
    this.cache = t, this.keyManifest = i, this.nowProvider = n || ete;
  }
  async setIdToken(t, i, n) {
    var r;
    const g = this.getIdTokenCacheKey(t);
    await this.cache.set(g, { id_token: i, decodedToken: n }), await ((r = this.keyManifest) === null || r === void 0 ? void 0 : r.add(g));
  }
  async getIdToken(t) {
    const i = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!i && t.scope && t.audience) {
      const n = await this.get(t);
      return !n || !n.id_token || !n.decodedToken ? void 0 : { id_token: n.id_token, decodedToken: n.decodedToken };
    }
    if (i)
      return { id_token: i.id_token, decodedToken: i.decodedToken };
  }
  async get(t, i = 0) {
    var n;
    let r = await this.cache.get(t.toKey());
    if (!r) {
      const l = await this.getCacheKeys();
      if (!l)
        return;
      const a = this.matchExistingCacheKey(t, l);
      a && (r = await this.cache.get(a));
    }
    if (!r)
      return;
    const g = await this.nowProvider(), o = Math.floor(g / 1e3);
    return r.expiresAt - i < o ? r.body.refresh_token ? (r.body = { refresh_token: r.body.refresh_token }, await this.cache.set(t.toKey(), r), r.body) : (await this.cache.remove(t.toKey()), void await ((n = this.keyManifest) === null || n === void 0 ? void 0 : n.remove(t.toKey()))) : r.body;
  }
  async set(t) {
    var i;
    const n = new TC({ clientId: t.client_id, scope: t.scope, audience: t.audience }), r = await this.wrapCacheEntry(t);
    await this.cache.set(n.toKey(), r), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.add(n.toKey()));
  }
  async clear(t) {
    var i;
    const n = await this.getCacheKeys();
    n && (await n.filter((r) => !t || r.includes(t)).reduce(async (r, g) => {
      await r, await this.cache.remove(g);
    }, Promise.resolve()), await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.clear()));
  }
  async wrapCacheEntry(t) {
    const i = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(i / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new TC({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, i) {
    return i.filter((n) => {
      var r;
      const g = TC.fromKey(n), o = new Set(g.scope && g.scope.split(" ")), l = ((r = t.scope) === null || r === void 0 ? void 0 : r.split(" ")) || [], a = g.scope && l.reduce((I, c) => I && o.has(c), !0);
      return g.prefix === "@@auth0spajs@@" && g.clientId === t.clientId && g.audience === t.audience && a;
    })[0];
  }
};
class yvt {
  constructor(t, i, n) {
    this.storage = t, this.clientId = i, this.cookieDomain = n, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
}
const bB = (e) => typeof e == "number", Wvt = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], Svt = (e) => {
  if (!e.id_token)
    throw new Error("ID token is required but missing");
  const t = ((g) => {
    const o = g.split("."), [l, a, I] = o;
    if (o.length !== 3 || !l || !a || !I)
      throw new Error("ID token could not be decoded");
    const c = JSON.parse(IU(a)), d = { __raw: g }, C = {};
    return Object.keys(c).forEach((A) => {
      d[A] = c[A], Wvt.includes(A) || (C[A] = c[A]);
    }), { encoded: { header: l, payload: a, signature: I }, header: JSON.parse(IU(l)), claims: d, user: C };
  })(e.id_token);
  if (!t.claims.iss)
    throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss)
    throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
  if (!t.user.sub)
    throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256")
    throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud))
    throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud))
      throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp)
        throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud)
        throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
    }
  } else if (t.claims.aud !== e.aud)
    throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
  if (e.nonce) {
    if (!t.claims.nonce)
      throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce)
      throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
  }
  if (e.max_age && !bB(t.claims.auth_time))
    throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !bB(t.claims.exp))
    throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!bB(t.claims.iat))
    throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const i = e.leeway || 60, n = new Date(e.now || Date.now()), r = /* @__PURE__ */ new Date(0);
  if (r.setUTCSeconds(t.claims.exp + i), n > r)
    throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${n}) is after expiration time (${r})`);
  if (t.claims.nbf != null && bB(t.claims.nbf)) {
    const g = /* @__PURE__ */ new Date(0);
    if (g.setUTCSeconds(t.claims.nbf - i), n < g)
      throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${n}) is before ${g}`);
  }
  if (t.claims.auth_time != null && bB(t.claims.auth_time)) {
    const g = /* @__PURE__ */ new Date(0);
    if (g.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), n > g)
      throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${n}) is after last auth at ${g}`);
  }
  if (e.organization) {
    const g = e.organization.trim();
    if (g.startsWith("org_")) {
      const o = g;
      if (!t.claims.org_id)
        throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (o !== t.claims.org_id)
        throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_id}"`);
    } else {
      const o = g.toLowerCase();
      if (!t.claims.org_name)
        throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (o !== t.claims.org_name)
        throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${o}", found "${t.claims.org_name}"`);
    }
  }
  return t;
};
var MC = DE(function(e, t) {
  var i = YC && YC.__assign || function() {
    return i = Object.assign || function(a) {
      for (var I, c = 1, d = arguments.length; c < d; c++)
        for (var C in I = arguments[c])
          Object.prototype.hasOwnProperty.call(I, C) && (a[C] = I[C]);
      return a;
    }, i.apply(this, arguments);
  };
  function n(a, I) {
    if (!I)
      return "";
    var c = "; " + a;
    return I === !0 ? c : c + "=" + I;
  }
  function r(a, I, c) {
    return encodeURIComponent(a).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(I).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(d) {
      if (typeof d.expires == "number") {
        var C = /* @__PURE__ */ new Date();
        C.setMilliseconds(C.getMilliseconds() + 864e5 * d.expires), d.expires = C;
      }
      return n("Expires", d.expires ? d.expires.toUTCString() : "") + n("Domain", d.domain) + n("Path", d.path) + n("Secure", d.secure) + n("SameSite", d.sameSite);
    }(c);
  }
  function g(a) {
    for (var I = {}, c = a ? a.split("; ") : [], d = /(%[\dA-F]{2})+/gi, C = 0; C < c.length; C++) {
      var A = c[C].split("="), b = A.slice(1).join("=");
      b.charAt(0) === '"' && (b = b.slice(1, -1));
      try {
        I[A[0].replace(d, decodeURIComponent)] = b.replace(d, decodeURIComponent);
      } catch {
      }
    }
    return I;
  }
  function o() {
    return g(document.cookie);
  }
  function l(a, I, c) {
    document.cookie = r(a, I, i({ path: "/" }, c));
  }
  t.__esModule = !0, t.encode = r, t.parse = g, t.getAll = o, t.get = function(a) {
    return o()[a];
  }, t.set = l, t.remove = function(a, I) {
    l(a, "", i(i({}, I), { expires: -1 }));
  };
});
xE(MC), MC.encode, MC.parse, MC.getAll;
var Vvt = MC.get, ste = MC.set, Ite = MC.remove;
const Yh = { get(e) {
  const t = Vvt(e);
  if (t !== void 0)
    return JSON.parse(t);
}, save(e, t, i) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0, sameSite: "none" }), i != null && i.daysUntilExpire && (n.expires = i.daysUntilExpire), i != null && i.cookieDomain && (n.domain = i.cookieDomain), ste(e, JSON.stringify(t), n);
}, remove(e, t) {
  let i = {};
  t != null && t.cookieDomain && (i.domain = t.cookieDomain), Ite(e, i);
} }, wvt = { get(e) {
  return Yh.get(e) || Yh.get(`_legacy_${e}`);
}, save(e, t, i) {
  let n = {};
  window.location.protocol === "https:" && (n = { secure: !0 }), i != null && i.daysUntilExpire && (n.expires = i.daysUntilExpire), i != null && i.cookieDomain && (n.domain = i.cookieDomain), ste(`_legacy_${e}`, JSON.stringify(t), n), Yh.save(e, t, i);
}, remove(e, t) {
  let i = {};
  t != null && t.cookieDomain && (i.domain = t.cookieDomain), Ite(e, i), Yh.remove(e, t), Yh.remove(`_legacy_${e}`, t);
} }, vvt = { get(e) {
  if (typeof sessionStorage > "u")
    return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
function Rvt(e, t, i) {
  var n = t === void 0 ? null : t, r = function(a, I) {
    var c = atob(a);
    if (I) {
      for (var d = new Uint8Array(c.length), C = 0, A = c.length; C < A; ++C)
        d[C] = c.charCodeAt(C);
      return String.fromCharCode.apply(null, new Uint16Array(d.buffer));
    }
    return c;
  }(e, i !== void 0 && i), g = r.indexOf(`
`, 10) + 1, o = r.substring(g) + (n ? "//# sourceMappingURL=" + n : ""), l = new Blob([o], { type: "application/javascript" });
  return URL.createObjectURL(l);
}
var cU, dU, uU, SF, Xvt = (cU = "Lyogcm9sbHVwLXBsdWdpbi13ZWItd29ya2VyLWxvYWRlciAqLwohZnVuY3Rpb24oKXsidXNlIHN0cmljdCI7Y2xhc3MgZSBleHRlbmRzIEVycm9ye2NvbnN0cnVjdG9yKHQscil7c3VwZXIociksdGhpcy5lcnJvcj10LHRoaXMuZXJyb3JfZGVzY3JpcHRpb249cixPYmplY3Quc2V0UHJvdG90eXBlT2YodGhpcyxlLnByb3RvdHlwZSl9c3RhdGljIGZyb21QYXlsb2FkKHtlcnJvcjp0LGVycm9yX2Rlc2NyaXB0aW9uOnJ9KXtyZXR1cm4gbmV3IGUodCxyKX19Y2xhc3MgdCBleHRlbmRzIGV7Y29uc3RydWN0b3IoZSxzKXtzdXBlcigibWlzc2luZ19yZWZyZXNoX3Rva2VuIixgTWlzc2luZyBSZWZyZXNoIFRva2VuIChhdWRpZW5jZTogJyR7cihlLFsiZGVmYXVsdCJdKX0nLCBzY29wZTogJyR7cihzKX0nKWApLHRoaXMuYXVkaWVuY2U9ZSx0aGlzLnNjb3BlPXMsT2JqZWN0LnNldFByb3RvdHlwZU9mKHRoaXMsdC5wcm90b3R5cGUpfX1mdW5jdGlvbiByKGUsdD1bXSl7cmV0dXJuIGUmJiF0LmluY2x1ZGVzKGUpP2U6IiJ9ImZ1bmN0aW9uIj09dHlwZW9mIFN1cHByZXNzZWRFcnJvciYmU3VwcHJlc3NlZEVycm9yO2NvbnN0IHM9ZT0+e3ZhcntjbGllbnRJZDp0fT1lLHI9ZnVuY3Rpb24oZSx0KXt2YXIgcj17fTtmb3IodmFyIHMgaW4gZSlPYmplY3QucHJvdG90eXBlLmhhc093blByb3BlcnR5LmNhbGwoZSxzKSYmdC5pbmRleE9mKHMpPDAmJihyW3NdPWVbc10pO2lmKG51bGwhPWUmJiJmdW5jdGlvbiI9PXR5cGVvZiBPYmplY3QuZ2V0T3duUHJvcGVydHlTeW1ib2xzKXt2YXIgbz0wO2ZvcihzPU9iamVjdC5nZXRPd25Qcm9wZXJ0eVN5bWJvbHMoZSk7bzxzLmxlbmd0aDtvKyspdC5pbmRleE9mKHNbb10pPDAmJk9iamVjdC5wcm90b3R5cGUucHJvcGVydHlJc0VudW1lcmFibGUuY2FsbChlLHNbb10pJiYocltzW29dXT1lW3Nbb11dKX1yZXR1cm4gcn0oZSxbImNsaWVudElkIl0pO3JldHVybiBuZXcgVVJMU2VhcmNoUGFyYW1zKChlPT5PYmplY3Qua2V5cyhlKS5maWx0ZXIoKHQ9PnZvaWQgMCE9PWVbdF0pKS5yZWR1Y2UoKCh0LHIpPT5PYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30sdCkse1tyXTplW3JdfSkpLHt9KSkoT2JqZWN0LmFzc2lnbih7Y2xpZW50X2lkOnR9LHIpKSkudG9TdHJpbmcoKX07bGV0IG89e307Y29uc3Qgbj0oZSx0KT0+YCR7ZX18JHt0fWA7YWRkRXZlbnRMaXN0ZW5lcigibWVzc2FnZSIsKGFzeW5jKHtkYXRhOnt0aW1lb3V0OmUsYXV0aDpyLGZldGNoVXJsOmksZmV0Y2hPcHRpb25zOmMsdXNlRm9ybURhdGE6YX0scG9ydHM6W3BdfSk9PntsZXQgZjtjb25zdHthdWRpZW5jZTp1LHNjb3BlOmx9PXJ8fHt9O3RyeXtjb25zdCByPWE/KGU9Pntjb25zdCB0PW5ldyBVUkxTZWFyY2hQYXJhbXMoZSkscj17fTtyZXR1cm4gdC5mb3JFYWNoKCgoZSx0KT0+e3JbdF09ZX0pKSxyfSkoYy5ib2R5KTpKU09OLnBhcnNlKGMuYm9keSk7aWYoIXIucmVmcmVzaF90b2tlbiYmInJlZnJlc2hfdG9rZW4iPT09ci5ncmFudF90eXBlKXtjb25zdCBlPSgoZSx0KT0+b1tuKGUsdCldKSh1LGwpO2lmKCFlKXRocm93IG5ldyB0KHUsbCk7Yy5ib2R5PWE/cyhPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKTpKU09OLnN0cmluZ2lmeShPYmplY3QuYXNzaWduKE9iamVjdC5hc3NpZ24oe30scikse3JlZnJlc2hfdG9rZW46ZX0pKX1sZXQgaCxnOyJmdW5jdGlvbiI9PXR5cGVvZiBBYm9ydENvbnRyb2xsZXImJihoPW5ldyBBYm9ydENvbnRyb2xsZXIsYy5zaWduYWw9aC5zaWduYWwpO3RyeXtnPWF3YWl0IFByb21pc2UucmFjZShbKGQ9ZSxuZXcgUHJvbWlzZSgoZT0+c2V0VGltZW91dChlLGQpKSkpLGZldGNoKGksT2JqZWN0LmFzc2lnbih7fSxjKSldKX1jYXRjaChlKXtyZXR1cm4gdm9pZCBwLnBvc3RNZXNzYWdlKHtlcnJvcjplLm1lc3NhZ2V9KX1pZighZylyZXR1cm4gaCYmaC5hYm9ydCgpLHZvaWQgcC5wb3N0TWVzc2FnZSh7ZXJyb3I6IlRpbWVvdXQgd2hlbiBleGVjdXRpbmcgJ2ZldGNoJyJ9KTtmPWF3YWl0IGcuanNvbigpLGYucmVmcmVzaF90b2tlbj8oKChlLHQscik9PntvW24odCxyKV09ZX0pKGYucmVmcmVzaF90b2tlbix1LGwpLGRlbGV0ZSBmLnJlZnJlc2hfdG9rZW4pOigoZSx0KT0+e2RlbGV0ZSBvW24oZSx0KV19KSh1LGwpLHAucG9zdE1lc3NhZ2Uoe29rOmcub2ssanNvbjpmfSl9Y2F0Y2goZSl7cC5wb3N0TWVzc2FnZSh7b2s6ITEsanNvbjp7ZXJyb3I6ZS5lcnJvcixlcnJvcl9kZXNjcmlwdGlvbjplLm1lc3NhZ2V9fSl9dmFyIGR9KSl9KCk7Cgo=", dU = null, uU = !1, function(e) {
  return SF = SF || Rvt(cU, dU, uU), new Worker(SF, e);
});
const VF = {};
let Hvt = class {
  constructor(t, i) {
    this.cache = t, this.clientId = i, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var i;
    const n = new Set(((i = await this.cache.get(this.manifestKey)) === null || i === void 0 ? void 0 : i.keys) || []);
    n.add(t), await this.cache.set(this.manifestKey, { keys: [...n] });
  }
  async remove(t) {
    const i = await this.cache.get(this.manifestKey);
    if (i) {
      const n = new Set(i.keys);
      return n.delete(t), n.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...n] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return `@@auth0spajs@@::${t}`;
  }
};
const kvt = { memory: () => new ate().enclosedCache, localstorage: () => new Zvt() }, CU = (e) => kvt[e], AU = (e) => {
  const { openUrl: t, onRedirect: i } = e, n = II(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, n), { openUrl: t === !1 || t ? t : i });
}, wF = new cvt();
class Yvt {
  constructor(t) {
    let i, n;
    if (this.userCache = new ate().enclosedCache, this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this._releaseLockOnPageHide = async () => {
      await wF.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!RV())
        throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (RV().subtle === void 0)
        throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache)
      n = t.cache;
    else {
      if (i = t.cacheLocation || "memory", !CU(i))
        throw new Error(`Invalid cache location "${i}"`);
      n = CU(i)();
    }
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? Yh : wvt, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((o) => `auth0.${o}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const r = t.useCookiesForTransactions ? this.cookieStorage : vvt;
    var g;
    this.scope = DS("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new yvt(r, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || ete, this.cacheManager = new Gvt(n, n.allKeys ? void 0 : new Hvt(n, this.options.clientId), this.nowProvider), this.domainUrl = (g = this.options.domain, /^https?:\/\//.test(g) ? g : `https://${g}`), this.tokenIssuer = ((o, l) => o ? o.startsWith("https://") ? o : `https://${o}/` : `${l}/`)(this.options.issuer, this.domainUrl), typeof window < "u" && window.Worker && this.options.useRefreshTokens && i === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new Xvt());
  }
  _url(t) {
    const i = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $ee)));
    return `${this.domainUrl}${t}&auth0Client=${i}`;
  }
  _authorizeUrl(t) {
    return this._url(`/authorize?${K5(t)}`);
  }
  async _verifyIdToken(t, i, n) {
    const r = await this.nowProvider();
    return Svt({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: i, organization: n, leeway: this.options.leeway, max_age: (g = this.options.authorizationParams.max_age, typeof g != "string" ? g : parseInt(g, 10) || void 0), now: r });
    var g;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, i, n) {
    const r = sU(WF()), g = sU(WF()), o = WF(), l = ((c) => {
      const d = new Uint8Array(c);
      return ((C) => {
        const A = { "+": "-", "/": "_", "=": "" };
        return C.replace(/[+/=]/g, (b) => A[b]);
      })(window.btoa(String.fromCharCode(...Array.from(d))));
    })(await (async (c) => await RV().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(c)))(o)), a = ((c, d, C, A, b, m, p, B) => Object.assign(Object.assign(Object.assign({ client_id: c.clientId }, c.authorizationParams), C), { scope: DS(d, C.scope), response_type: "code", response_mode: B || "query", state: A, nonce: b, redirect_uri: p || c.authorizationParams.redirect_uri, code_challenge: m, code_challenge_method: "S256" }))(this.options, this.scope, t, r, g, l, t.redirect_uri || this.options.authorizationParams.redirect_uri || n, i == null ? void 0 : i.response_mode), I = this._authorizeUrl(a);
    return { nonce: g, code_verifier: o, scope: a.scope, audience: a.audience || "default", redirect_uri: a.redirect_uri, state: r, url: I };
  }
  async loginWithPopup(t, i) {
    var n;
    if (t = t || {}, !(i = i || {}).popup && (i.popup = ((l) => {
      const a = window.screenX + (window.innerWidth - 400) / 2, I = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(l, "auth0:authorize:popup", `left=${a},top=${I},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !i.popup))
      throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const r = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    i.popup.location.href = r.url;
    const g = await ((l) => new Promise((a, I) => {
      let c;
      const d = setInterval(() => {
        l.popup && l.popup.closed && (clearInterval(d), clearTimeout(C), window.removeEventListener("message", c, !1), I(new Avt(l.popup)));
      }, 1e3), C = setTimeout(() => {
        clearInterval(d), I(new Cvt(l.popup)), window.removeEventListener("message", c, !1);
      }, 1e3 * (l.timeoutInSeconds || 60));
      c = function(A) {
        if (A.data && A.data.type === "authorization_response") {
          if (clearTimeout(C), clearInterval(d), window.removeEventListener("message", c, !1), l.popup.close(), A.data.response.error)
            return I(vl.fromPayload(A.data.response));
          a(A.data.response);
        }
      }, window.addEventListener("message", c);
    }))(Object.assign(Object.assign({}, i), { timeoutInSeconds: i.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (r.state !== g.state)
      throw new vl("state_mismatch", "Invalid state");
    const o = ((n = t.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: r.audience, scope: r.scope, code_verifier: r.code_verifier, grant_type: "authorization_code", code: g.code, redirect_uri: r.redirect_uri }, { nonceIn: r.nonce, organization: o });
  }
  async getUser() {
    var t;
    const i = await this._getIdTokenFromCache();
    return (t = i == null ? void 0 : i.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const i = await this._getIdTokenFromCache();
    return (t = i == null ? void 0 : i.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect(t = {}) {
    var i;
    const n = AU(t), { openUrl: r, fragment: g, appState: o } = n, l = II(n, ["openUrl", "fragment", "appState"]), a = ((i = l.authorizationParams) === null || i === void 0 ? void 0 : i.organization) || this.options.authorizationParams.organization, I = await this._prepareAuthorizeUrl(l.authorizationParams || {}), { url: c } = I, d = II(I, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, d), { appState: o }), a && { organization: a }));
    const C = g ? `${c}#${g}` : c;
    r ? await r(C) : window.location.assign(C);
  }
  async handleRedirectCallback(t = window.location.href) {
    const i = t.split("?").slice(1);
    if (i.length === 0)
      throw new Error("There are no query params available for parsing.");
    const { state: n, code: r, error: g, error_description: o } = ((d) => {
      d.indexOf("#") > -1 && (d = d.substring(0, d.indexOf("#")));
      const C = new URLSearchParams(d);
      return { state: C.get("state"), code: C.get("code") || void 0, error: C.get("error") || void 0, error_description: C.get("error_description") || void 0 };
    })(i.join("")), l = this.transactionManager.get();
    if (!l)
      throw new vl("missing_transaction", "Invalid state");
    if (this.transactionManager.remove(), g)
      throw new uvt(g, o || g, n, l.appState);
    if (!l.code_verifier || l.state && l.state !== n)
      throw new vl("state_mismatch", "Invalid state");
    const a = l.organization, I = l.nonce, c = l.redirect_uri;
    return await this._requestToken(Object.assign({ audience: l.audience, scope: l.scope, code_verifier: l.code_verifier, grant_type: "authorization_code", code: r }, c ? { redirect_uri: c } : {}), { nonceIn: I, organization: a }), { appState: l.appState };
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated"))
        return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently(t = {}) {
    var i;
    const n = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: DS(this.scope, (i = t.authorizationParams) === null || i === void 0 ? void 0 : i.scope) }) }), r = await ((g, o) => {
      let l = VF[o];
      return l || (l = g().finally(() => {
        delete VF[o], l = null;
      }), VF[o] = l), l;
    })(() => this._getTokenSilently(n), `${this.options.clientId}::${n.authorizationParams.audience}::${n.authorizationParams.scope}`);
    return t.detailedResponse ? r : r == null ? void 0 : r.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: i } = t, n = II(t, ["cacheMode"]);
    if (i !== "off") {
      const r = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
      if (r)
        return r;
    }
    if (i !== "cache-only") {
      if (!await (async (r, g = 3) => {
        for (let o = 0; o < g; o++)
          if (await r())
            return !0;
        return !1;
      })(() => wF.acquireLock("auth0.lock.getTokenSilently", 5e3), 10))
        throw new L5();
      try {
        if (window.addEventListener("pagehide", this._releaseLockOnPageHide), i !== "off") {
          const I = await this._getEntryFromCache({ scope: n.authorizationParams.scope, audience: n.authorizationParams.audience || "default", clientId: this.options.clientId });
          if (I)
            return I;
        }
        const r = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(n) : await this._getTokenFromIFrame(n), { id_token: g, access_token: o, oauthTokenScope: l, expires_in: a } = r;
        return Object.assign(Object.assign({ id_token: g, access_token: o }, l ? { scope: l } : null), { expires_in: a });
      } finally {
        await wF.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
      }
    }
  }
  async getTokenWithPopup(t = {}, i = {}) {
    var n;
    const r = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: DS(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope) }) });
    return i = Object.assign(Object.assign({}, dvt), i), await this.loginWithPopup(r, i), (await this.cacheManager.get(new TC({ scope: r.authorizationParams.scope, audience: r.authorizationParams.audience || "default", clientId: this.options.clientId }))).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const i = t.logoutParams || {}, { federated: n } = i, r = II(i, ["federated"]), g = n ? "&federated" : "";
    return this._url(`/v2/logout?${K5(Object.assign({ clientId: t.clientId }, r))}`) + g;
  }
  async logout(t = {}) {
    const i = AU(t), { openUrl: n } = i, r = II(i, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@");
    const g = this._buildLogoutUrl(r);
    n ? await n(g) : n !== !1 && window.location.assign(g);
  }
  async _getTokenFromIFrame(t) {
    const i = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), n = this.cookieStorage.get(this.orgHintCookieName);
    n && !i.organization && (i.organization = n);
    const { url: r, state: g, nonce: o, code_verifier: l, redirect_uri: a, scope: I, audience: c } = await this._prepareAuthorizeUrl(i, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated)
        throw new vl("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const d = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, C = await ((b, m, p = 60) => new Promise((B, f) => {
        const Z = window.document.createElement("iframe");
        Z.setAttribute("width", "0"), Z.setAttribute("height", "0"), Z.style.display = "none";
        const y = () => {
          window.document.body.contains(Z) && (window.document.body.removeChild(Z), window.removeEventListener("message", W, !1));
        };
        let W;
        const V = setTimeout(() => {
          f(new L5()), y();
        }, 1e3 * p);
        W = function(w) {
          if (w.origin != m || !w.data || w.data.type !== "authorization_response")
            return;
          const v = w.source;
          v && v.close(), w.data.response.error ? f(vl.fromPayload(w.data.response)) : B(w.data.response), clearTimeout(V), window.removeEventListener("message", W, !1), setTimeout(y, 2e3);
        }, window.addEventListener("message", W, !1), window.document.body.appendChild(Z), Z.setAttribute("src", b);
      }))(r, this.domainUrl, d);
      if (g !== C.state)
        throw new vl("state_mismatch", "Invalid state");
      const A = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: l, code: C.code, grant_type: "authorization_code", redirect_uri: a, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: o, organization: i.organization });
      return Object.assign(Object.assign({}, A), { scope: I, oauthTokenScope: A.scope, audience: c });
    } catch (d) {
      throw d.error === "login_required" && this.logout({ openUrl: !1 }), d;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    const i = await this.cacheManager.get(new TC({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }));
    if (!(i && i.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback)
        return await this._getTokenFromIFrame(t);
      throw new ote(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const n = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, r = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null;
    try {
      const g = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: i && i.refresh_token, redirect_uri: n }), r && { timeout: r }));
      return Object.assign(Object.assign({}, g), { scope: t.authorizationParams.scope, oauthTokenScope: g.scope, audience: t.authorizationParams.audience || "default" });
    } catch (g) {
      if ((g.message.indexOf("Missing Refresh Token") > -1 || g.message && g.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback)
        return await this._getTokenFromIFrame(t);
      throw g;
    }
  }
  async _saveEntryInCache(t) {
    const { id_token: i, decodedToken: n } = t, r = II(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: i, decodedToken: n }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(r);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", i = await this.cacheManager.getIdToken(new TC({ clientId: this.options.clientId, audience: t, scope: this.scope })), n = this.userCache.get("@@user@@");
    return i && i.id_token === (n == null ? void 0 : n.id_token) ? n : (this.userCache.set("@@user@@", i), i);
  }
  async _getEntryFromCache({ scope: t, audience: i, clientId: n }) {
    const r = await this.cacheManager.get(new TC({ scope: t, audience: i, clientId: n }), 60);
    if (r && r.access_token) {
      const { access_token: g, oauthTokenScope: o, expires_in: l } = r, a = await this._getIdTokenFromCache();
      return a && Object.assign(Object.assign({ id_token: a.id_token, access_token: g }, o ? { scope: o } : null), { expires_in: l });
    }
  }
  async _requestToken(t, i) {
    const { nonceIn: n, organization: r } = i || {}, g = await fvt(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs }, t), this.worker), o = await this._verifyIdToken(g.id_token, n, r);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, g), { decodedToken: o, scope: t.scope, audience: t.audience || "default" }), g.scope ? { oauthTokenScope: g.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(r || o.claims.org_id), Object.assign(Object.assign({}, g), { decodedToken: o });
  }
}
var cte = {
  isAuthenticated: !1,
  isLoading: !0
}, uc = function() {
  throw new Error("You forgot to wrap your component in <Auth0Provider>.");
}, Fvt = cg(cg({}, cte), { buildAuthorizeUrl: uc, buildLogoutUrl: uc, getAccessTokenSilently: uc, getAccessTokenWithPopup: uc, getIdTokenClaims: uc, loginWithRedirect: uc, loginWithPopup: uc, logout: uc, handleRedirectCallback: uc }), dte = Ua(Fvt), bU = (
  /** @class */
  function(e) {
    svt(t, e);
    function t(i, n) {
      var r = e.call(this, n || i) || this;
      return r.error = i, r.error_description = n, Object.setPrototypeOf(r, t.prototype), r;
    }
    return t;
  }(Error)
), xvt = /[?&]code=[^&]+/, Dvt = /[?&]state=[^&]+/, Jvt = /[?&]error=[^&]+/, Evt = function(e) {
  return e === void 0 && (e = window.location.search), (xvt.test(e) || Jvt.test(e)) && Dvt.test(e);
}, ute = function(e) {
  return function(t) {
    return t instanceof Error ? t : t !== null && typeof t == "object" && "error" in t && typeof t.error == "string" ? "error_description" in t && typeof t.error_description == "string" ? new bU(t.error, t.error_description) : new bU(t.error) : new Error(e);
  };
}, hU = ute("Login failed"), vF = ute("Get access token failed"), Cte = function(e) {
  var t;
  e != null && e.redirectUri && (console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version"), e.authorizationParams = e.authorizationParams || {}, e.authorizationParams.redirect_uri = e.redirectUri, delete e.redirectUri), !((t = e == null ? void 0 : e.authorizationParams) === null || t === void 0) && t.redirectUri && (console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version"), e.authorizationParams.redirect_uri = e.authorizationParams.redirectUri, delete e.authorizationParams.redirectUri);
}, Nvt = function(e, t) {
  switch (t.type) {
    case "LOGIN_POPUP_STARTED":
      return cg(cg({}, e), { isLoading: !0 });
    case "LOGIN_POPUP_COMPLETE":
    case "INITIALISED":
      return cg(cg({}, e), { isAuthenticated: !!t.user, user: t.user, isLoading: !1, error: void 0 });
    case "HANDLE_REDIRECT_COMPLETE":
    case "GET_ACCESS_TOKEN_COMPLETE":
      return e.user === t.user ? e : cg(cg({}, e), { isAuthenticated: !!t.user, user: t.user });
    case "LOGOUT":
      return cg(cg({}, e), { isAuthenticated: !1, user: void 0 });
    case "ERROR":
      return cg(cg({}, e), { isLoading: !1, error: t.error });
  }
}, Lvt = function(e) {
  return Cte(e), cg(cg({}, e), { auth0Client: {
    name: "auth0-react",
    version: "2.2.4"
  } });
}, Kvt = function(e) {
  window.history.replaceState({}, document.title, (e == null ? void 0 : e.returnTo) || window.location.pathname);
}, Tvt = function(e) {
  var t = e.children, i = e.skipRedirectCallback, n = e.onRedirectCallback, r = n === void 0 ? Kvt : n, g = e.context, o = g === void 0 ? dte : g, l = Ivt(e, ["children", "skipRedirectCallback", "onRedirectCallback", "context"]), a = wt(function() {
    return new Yvt(Lvt(l));
  })[0], I = aZ(Nvt, cte), c = I[0], d = I[1], C = ot(!1);
  lt(function() {
    C.current || (C.current = !0, function() {
      return Zh(void 0, void 0, void 0, function() {
        var W, V, w;
        return Gh(this, function(v) {
          switch (v.label) {
            case 0:
              return v.trys.push([0, 7, , 8]), W = void 0, Evt() && !i ? [4, a.handleRedirectCallback()] : [3, 3];
            case 1:
              return V = v.sent().appState, [4, a.getUser()];
            case 2:
              return W = v.sent(), r(V, W), [3, 6];
            case 3:
              return [4, a.checkSession()];
            case 4:
              return v.sent(), [4, a.getUser()];
            case 5:
              W = v.sent(), v.label = 6;
            case 6:
              return d({ type: "INITIALISED", user: W }), [3, 8];
            case 7:
              return w = v.sent(), d({ type: "ERROR", error: hU(w) }), [3, 8];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }());
  }, [a, r, i]);
  var A = Gt(function(W) {
    return Cte(W), a.loginWithRedirect(W);
  }, [a]), b = Gt(function(W, V) {
    return Zh(void 0, void 0, void 0, function() {
      var w, v;
      return Gh(this, function(H) {
        switch (H.label) {
          case 0:
            d({ type: "LOGIN_POPUP_STARTED" }), H.label = 1;
          case 1:
            return H.trys.push([1, 3, , 4]), [4, a.loginWithPopup(W, V)];
          case 2:
            return H.sent(), [3, 4];
          case 3:
            return w = H.sent(), d({ type: "ERROR", error: hU(w) }), [
              2
              /*return*/
            ];
          case 4:
            return [4, a.getUser()];
          case 5:
            return v = H.sent(), d({ type: "LOGIN_POPUP_COMPLETE", user: v }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [a]), m = Gt(function(W) {
    return W === void 0 && (W = {}), Zh(void 0, void 0, void 0, function() {
      return Gh(this, function(V) {
        switch (V.label) {
          case 0:
            return [4, a.logout(W)];
          case 1:
            return V.sent(), (W.openUrl || W.openUrl === !1) && d({ type: "LOGOUT" }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [a]), p = Gt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(W) {
      return Zh(void 0, void 0, void 0, function() {
        var V, w, v, H;
        return Gh(this, function(x) {
          switch (x.label) {
            case 0:
              return x.trys.push([0, 2, 3, 5]), [4, a.getTokenSilently(W)];
            case 1:
              return V = x.sent(), [3, 5];
            case 2:
              throw w = x.sent(), vF(w);
            case 3:
              return v = d, H = {
                type: "GET_ACCESS_TOKEN_COMPLETE"
              }, [4, a.getUser()];
            case 4:
              return v.apply(void 0, [(H.user = x.sent(), H)]), [
                7
                /*endfinally*/
              ];
            case 5:
              return [2, V];
          }
        });
      });
    },
    [a]
  ), B = Gt(function(W, V) {
    return Zh(void 0, void 0, void 0, function() {
      var w, v, H, x;
      return Gh(this, function(J) {
        switch (J.label) {
          case 0:
            return J.trys.push([0, 2, 3, 5]), [4, a.getTokenWithPopup(W, V)];
          case 1:
            return w = J.sent(), [3, 5];
          case 2:
            throw v = J.sent(), vF(v);
          case 3:
            return H = d, x = {
              type: "GET_ACCESS_TOKEN_COMPLETE"
            }, [4, a.getUser()];
          case 4:
            return H.apply(void 0, [(x.user = J.sent(), x)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [2, w];
        }
      });
    });
  }, [a]), f = Gt(function() {
    return a.getIdTokenClaims();
  }, [a]), Z = Gt(function(W) {
    return Zh(void 0, void 0, void 0, function() {
      var V, w, v;
      return Gh(this, function(H) {
        switch (H.label) {
          case 0:
            return H.trys.push([0, 2, 3, 5]), [4, a.handleRedirectCallback(W)];
          case 1:
            return [2, H.sent()];
          case 2:
            throw V = H.sent(), vF(V);
          case 3:
            return w = d, v = {
              type: "HANDLE_REDIRECT_COMPLETE"
            }, [4, a.getUser()];
          case 4:
            return w.apply(void 0, [(v.user = H.sent(), v)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [a]), y = Oe(function() {
    return cg(cg({}, c), { getAccessTokenSilently: p, getAccessTokenWithPopup: B, getIdTokenClaims: f, loginWithRedirect: A, loginWithPopup: b, logout: m, handleRedirectCallback: Z });
  }, [
    c,
    p,
    B,
    f,
    A,
    b,
    m,
    Z
  ]);
  return De.createElement(o.Provider, { value: y }, t);
}, Mvt = function(e) {
  return e === void 0 && (e = dte), Vn(e);
};
const Pvt = _o(() => import("./Configurator-9GHIEgv0.js")), Uvt = (e) => {
  const {
    isLoading: t,
    isAuthenticated: i,
    loginWithRedirect: n
  } = Mvt();
  if (i)
    return e.children;
  t || n();
}, zvt = (e) => {
  var r, g;
  const t = (r = e.app) == null ? void 0 : r.settings.auth0;
  if (!t || !t.enabled || !t.domain || !t.clientId || !((g = e.app.productDetails) != null && g.felogin))
    return e.children;
  const i = window.location.search, n = new URLSearchParams(i);
  return n.set("k3-code", n.get("code") || ""), /* @__PURE__ */ S(
    Tvt,
    {
      domain: t.domain,
      clientId: t.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin + window.location.pathname + "?" + n.toString()
      },
      onRedirectCallback: () => {
      },
      children: /* @__PURE__ */ S(Uvt, { app: e.app, children: e.children })
    }
  );
};
function Ovt() {
  const e = ie(Pi), {
    t
  } = Gi();
  lt(() => {
    document.title = (e == null ? void 0 : e.label) || "Konfigurator";
  }, [e]), _ee(e, !0);
  const i = FE(), n = Oe(() => /* @__PURE__ */ S(uJ, { styles: Gdt(i.palette.scrollbar.default) }), [i.palette.scrollbar.default]);
  return Oe(() => e ? ovt(e.bookedUntil) < 0 || e.paymentState == "voided" : !1, [e]) ? /* @__PURE__ */ S(ht, { component: "div", sx: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ S(Iue, { severity: "error", children: /* @__PURE__ */ S(Ct, { children: t("Dieser Konfigurator verfügt derzeit nicht über eine gültige Lizenz.") }) }) }) : /* @__PURE__ */ Ie(moe, { theme: i, children: [
    n,
    /* @__PURE__ */ S(zvt, { app: e, children: e ? /* @__PURE__ */ S(Pvt, { app: e, editorUi: !1 }) : /* @__PURE__ */ S(gvt, {}) })
  ] });
}
var Qvt = {
  cm: !0,
  mm: !0,
  in: !0,
  px: !0,
  pt: !0,
  pc: !0,
  em: !0,
  ex: !0,
  ch: !0,
  rem: !0,
  vw: !0,
  vh: !0,
  vmin: !0,
  vmax: !0,
  "%": !0
};
function Ate(e) {
  if (typeof e == "number")
    return {
      value: e,
      unit: "px"
    };
  var t, i = (e.match(/^[0-9.]*/) || "").toString();
  i.includes(".") ? t = parseFloat(i) : t = parseInt(i, 10);
  var n = (e.match(/[^0-9]*$/) || "").toString();
  return Qvt[n] ? {
    value: t,
    unit: n
  } : (console.warn("React Spinners: ".concat(e, " is not a valid css value. Defaulting to ").concat(t, "px.")), {
    value: t,
    unit: "px"
  });
}
function mU(e) {
  var t = Ate(e);
  return "".concat(t.value).concat(t.unit);
}
var jvt = function(e, t, i) {
  var n = "react-spinners-".concat(e, "-").concat(i);
  if (typeof window > "u" || !window.document)
    return n;
  var r = document.createElement("style");
  document.head.appendChild(r);
  var g = r.sheet, o = `
    @keyframes `.concat(n, ` {
      `).concat(t, `
    }
  `);
  return g && g.insertRule(o, 0), n;
}, Sd = function() {
  return Sd = Object.assign || function(e) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Sd.apply(this, arguments);
}, qvt = function(e, t) {
  var i = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (i[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)
      t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (i[n[r]] = e[n[r]]);
  return i;
}, pU = jvt("MoonLoader", "100% {transform: rotate(360deg)}", "moon");
function _vt(e) {
  var t = e.loading, i = t === void 0 ? !0 : t, n = e.color, r = n === void 0 ? "#000000" : n, g = e.speedMultiplier, o = g === void 0 ? 1 : g, l = e.cssOverride, a = l === void 0 ? {} : l, I = e.size, c = I === void 0 ? 60 : I, d = qvt(e, ["loading", "color", "speedMultiplier", "cssOverride", "size"]), C = Ate(c), A = C.value, b = C.unit, m = A / 7, p = Sd({ display: "inherit", position: "relative", width: "".concat("".concat(A + m * 2).concat(b)), height: "".concat("".concat(A + m * 2).concat(b)), animation: "".concat(pU, " ").concat(0.6 / o, "s 0s infinite linear"), animationFillMode: "forwards" }, a), B = function(y) {
    return {
      width: mU(y),
      height: mU(y),
      borderRadius: "100%"
    };
  }, f = Sd(Sd({}, B(m)), { backgroundColor: "".concat(r), opacity: "0.8", position: "absolute", top: "".concat("".concat(A / 2 - m / 2).concat(b)), animation: "".concat(pU, " ").concat(0.6 / o, "s 0s infinite linear"), animationFillMode: "forwards" }), Z = Sd(Sd({}, B(A)), { border: "".concat(m, "px solid ").concat(r), opacity: "0.1", boxSizing: "content-box", position: "absolute" });
  return i ? X.createElement(
    "span",
    Sd({ style: p }, d),
    X.createElement("span", { style: f }),
    X.createElement("span", { style: Z })
  ) : null;
}
function bte() {
  return /* @__PURE__ */ S(tv, { in: !0, children: /* @__PURE__ */ S(iv, { open: !0, children: /* @__PURE__ */ S(_vt, { size: 50, color: "white" }) }) });
}
function JS(e) {
  const {
    t
  } = Gi(), i = ZA(), n = e.body ? av.isString(e.body) ? t(e.body) : e.body : t("Fatal_Error_Text");
  return /* @__PURE__ */ Ie(wf, { open: !0, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [
    /* @__PURE__ */ S(Xf, { id: "alert-dialog-title", children: e.heading ? t(e.heading) : t("Fatal_Error") }),
    /* @__PURE__ */ Ie(Rf, { children: [
      /* @__PURE__ */ Ie(BI, { id: "alert-dialog-description", children: [
        n,
        /* @__PURE__ */ S(fJ, {})
      ] }),
      e.error && /* @__PURE__ */ Ie(li, { children: [
        /* @__PURE__ */ S("hr", {}),
        /* @__PURE__ */ S(BI, { children: t("Fehlermeldung:") }),
        /* @__PURE__ */ S(BI, { children: t(e.error.message) })
      ] })
    ] }),
    /* @__PURE__ */ Ie(vf, { children: [
      /* @__PURE__ */ S(fn, { "data-cy": "goHome", onClick: () => {
        i("/admin"), i(0);
      }, children: t("Zur Startseite") }),
      /* @__PURE__ */ S(fn, { onClick: () => window.location.reload(), "data-cy": "reload", children: t("Neu Laden") }),
      /* @__PURE__ */ S(fn, { "data-cy": "restart", onClick: () => {
        window.localStorage.clear(), window.location.reload();
      }, children: t("Cleanup und Neu Laden") })
    ] })
  ] });
}
var XV = /* @__PURE__ */ ((e) => (e[e.CONFIGURATION_NOT_FOUND = 0] = "CONFIGURATION_NOT_FOUND", e[e.APP_NOT_FOUND = 1] = "APP_NOT_FOUND", e[e.NO_DEALER_ACCESS = 2] = "NO_DEALER_ACCESS", e))(XV || {});
class $vt extends Error {
  constructor(i) {
    super();
    Qi(this, "type");
    this.type = XV[i], this.name = XV[i], this.message = XV[i];
  }
  isType(i) {
    return this.type === i;
  }
}
class e1t extends $d {
  constructor() {
    super(...arguments);
    Qi(this, "catchUnhandledRejectionErrors", !0);
  }
  renderError(i, n) {
    return i instanceof $vt ? {
      CONFIGURATION_NOT_FOUND: /* @__PURE__ */ S(JS, { heading: "Ladevorgang fehlgeschlagen", body: "Die Konfiguration konnte nicht geladen werden! Bitte versuchen Sie es später erneut!" }),
      APP_NOT_FOUND: /* @__PURE__ */ S(JS, { heading: "Ladevorgang fehlgeschlagen", body: "Es liegt keine veröffentlichte Version der App vor." }),
      NO_DEALER_ACCESS: /* @__PURE__ */ S(JS, { heading: "Ladevorgang fehlgeschlagen", body: "Der Händler Konfigurator ist nicht aktiv. Bitte wenden sie sich an ihren Betreiber." })
    }[i.type] : n == "childComponent" ? /* @__PURE__ */ S(JS, { error: i }) : (kZ(/* @__PURE__ */ S(Ct, { variant: "body1", children: i.message }), {
      variant: "error",
      persist: !0,
      style: {
        whiteSpace: "pre-line"
      },
      key: "FrontendTopLevelErrorBoundary"
    }), this.props.children);
  }
}
async function Aei(e) {
  return await du("GET", `/admin/client/${e}`);
}
async function t1t(e) {
  return await du("GET", `/admin/app/${e}`);
}
async function i1t(e, t) {
  const i = t ? `?dealerId=${t}` : "";
  return await wi("GET", `/admin/to/${e}${i}`);
}
async function bei(e, t) {
  return await wi("PUT", `/admin/app/${e}`, t);
}
async function hei(e, t) {
  await await wi("POST", `/admin/client/${e}`, t);
}
async function mei(e) {
  await await wi("PUT", "/client", e);
}
async function pei(e) {
  return await b9("GET", `/admin/client/${e}/export`);
}
async function Bei(e) {
  const t = {
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  return await b9("DELETE", `/admin/client/${e}`, null, t);
}
async function fei(e, t) {
  return await wi("PUT", `/admin/dealerApp/${e}`, t);
}
async function Zei() {
  return await wi("GET", "/partner/all");
}
async function Gei() {
  return await wi("GET", "/legal");
}
async function yei(e, t) {
  return await wi("POST", "/register", {
    ...e
  }, {
    lang: t
  });
}
async function Wei(e) {
  return await wi("POST", "/confirm", {
    ...e
  });
}
async function n1t() {
  return await wi("GET", "/me");
}
async function Sei() {
  return await wi("GET", "/user/api-token/renew");
}
async function Vei(e) {
  const {
    message: t
  } = await wi("POST", "/lost", {
    email: e
  });
  return t;
}
async function wei(e) {
  const {
    message: t
  } = await wi("POST", "/reset", e);
  return t;
}
async function vei() {
  const {
    url: e
  } = await wi("GET", "/payment/portal");
  return e;
}
async function Rei(e, t) {
  const {
    message: i
  } = await wi("POST", "/user/invite", {
    email: e,
    role: t
  });
  return i;
}
async function Xei(e) {
  const {
    message: t
  } = await wi("DELETE", `/user/invite/${e}`);
  return t;
}
async function Hei() {
  return await wi("GET", "/user/invited");
}
function r1t(e = !0) {
  return B7(["user", "me"], async ({
    queryKey: [i, n]
  }) => n1t(), {
    useErrorBoundary: !1,
    refetchOnWindowFocus: !1,
    enabled: e
  });
}
const g1t = (e) => e == null ? void 0 : e.message.includes("403");
function o1t(e) {
  const {
    t
  } = Gi(), i = ZA(), n = r1t().data, r = !!(n != null && n.roleDetails["change-client"]), g = Tq(), o = g1t(e.error);
  return /* @__PURE__ */ Ie(wf, { open: !0, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [
    /* @__PURE__ */ S(Xf, { id: "alert-dialog-title", children: e.heading ? e.heading : t("Fatal_Error") }),
    /* @__PURE__ */ Ie(Rf, { children: [
      /* @__PURE__ */ Ie(BI, { component: "div", id: "alert-dialog-description", children: [
        e.body ? e.body : t("Fatal_Error_Text"),
        /* @__PURE__ */ S(fJ, {})
      ] }),
      e.error && /* @__PURE__ */ Ie(li, { children: [
        /* @__PURE__ */ S("hr", {}),
        /* @__PURE__ */ S(BI, { children: t("Error_Message") }),
        /* @__PURE__ */ S(BI, { children: e.error.message })
      ] })
    ] }),
    /* @__PURE__ */ Ie(vf, { children: [
      /* @__PURE__ */ S(fn, { "data-cy": "goHome", onClick: () => {
        i("/admin"), i(0);
      }, children: t("Zur Startseite") }),
      /* @__PURE__ */ S(fn, { onClick: () => i(0), "data-cy": "reload", children: t("Neu Laden") }),
      /* @__PURE__ */ S(fn, { "data-cy": "restart", onClick: () => {
        window.localStorage.clear(), i(0);
      }, children: t("Cleanup und Neu Laden") }),
      r && g && o && /* @__PURE__ */ S(fn, { "data-cy": "changeClient", onClick: async () => {
        const l = window.location.hash.split("apps/")[1].split("/")[0], a = await t1t(Number(l));
        await i1t(a.clientId), i(0);
      }, children: t("(SU) Client wechseln") })
    ] })
  ] });
}
class l1t extends $d {
  constructor() {
    super(...arguments);
    Qi(this, "catchUnhandledRejectionErrors", !0);
  }
  renderError(i, n) {
    return n == "childComponent" ? /* @__PURE__ */ S(o1t, { error: i }) : (kZ(/* @__PURE__ */ S(Ct, { variant: "body1", children: (i == null ? void 0 : i.message) + `
` + Ug("You may need to reload the page") }), {
      variant: "error",
      persist: !0,
      style: {
        whiteSpace: "pre-line"
      },
      action: (r) => /* @__PURE__ */ Ie(li, { children: [
        /* @__PURE__ */ S(Ni, { "data-cy": "error-snackbar-reload", color: "primary", onClick: () => {
          window.location.reload();
        }, children: /* @__PURE__ */ S(tbt, {}) }),
        /* @__PURE__ */ S(Ni, { "data-cy": "error-snackbar-close", sx: {
          color: "lightgray"
        }, onClick: () => OJ(r), children: /* @__PURE__ */ S(iq, {}) })
      ] })
    }), this.props.children);
  }
}
const a1t = _o(() => import("./AdminRoutes-Vis3cHjS.js"));
function s1t() {
  return /* @__PURE__ */ S(l1t, { children: /* @__PURE__ */ S(fm, { fallback: /* @__PURE__ */ S(bte, {}), children: /* @__PURE__ */ S(a1t, {}) }) });
}
function I1t() {
  return /* @__PURE__ */ S(e1t, { children: /* @__PURE__ */ S(fm, { fallback: /* @__PURE__ */ S(bte, {}), children: /* @__PURE__ */ S(Ovt, {}) }) });
}
const c1t = kCt([{
  path: "admin/*",
  Component: s1t
}, {
  path: "*",
  Component: I1t
}]);
function d1t() {
  return /* @__PURE__ */ S(PCt, { router: c1t });
}
ew.setLicenseKey("9e1cb1654be631eaf1fa9b254d045a04T1JERVI6Mzk2MzEsRVhQSVJZPTE2Nzg4NzE3NjYwMDAsS0VZVkVSU0lPTj0x");
let M5 = /* @__PURE__ */ S(d1t, {});
window.Cypress && (window.store = r9);
if (sl.bugsnagKey) {
  vT.start({
    apiKey: sl.bugsnagKey,
    plugins: [new wdt()]
  });
  const e = vT.getPlugin("react").createErrorBoundary(De);
  M5 = /* @__PURE__ */ S(e, { children: M5 });
}
window.Cypress && (window.store = r9);
fdt();
const u1t = {
  ...Bdt,
  ...ydt
}, C1t = /* @__PURE__ */ S(uJ, { styles: u1t }), kei = (e) => {
  var i, n;
  const t = Xv();
  return lt(() => {
    console.log(`K3 Version: ${Noe}`);
  }, []), /* @__PURE__ */ S(QJ.Provider, { value: {
    extensions: Object.keys(t.extensions).length ? t.extensions : e.extensions || {},
    additionalDynamicSettings: (i = t.additionalDynamicSettings) != null && i.length ? t.additionalDynamicSettings : e.additionalDynamicSettings || [],
    contexts: (n = t.contexts) != null && n.length ? t.contexts : e.contexts || [],
    themeOptionsCreator: e.themeOptionsCreator
  }, children: /* @__PURE__ */ S(LZe, { children: /* @__PURE__ */ Ie(PIt, { client: gct, children: [
    /* @__PURE__ */ S(ASe, { store: r9, context: MJ, children: /* @__PURE__ */ S(LQ, { theme: Uj, children: /* @__PURE__ */ Ie(eVe, { maxSnack: 3, preventDuplicate: !0, autoHideDuration: 3e3, action: (r) => /* @__PURE__ */ S(r7, { messageKey: r }), children: [
      /* @__PURE__ */ S(q0e, { enableColorScheme: !0 }),
      C1t,
      M5,
      /* @__PURE__ */ S(pSe, {})
    ] }) }) }),
    /* @__PURE__ */ S(vdt, { initialIsOpen: !1, toggleButtonProps: {
      style: {
        left: "60px"
      },
      "data-cy": "React Dev Tools"
    } })
  ] }) }) });
}, RF = (e) => {
  var t;
  return Le.toNumber(((t = e == null ? void 0 : e.data) == null ? void 0 : t.inputValue) || 0);
}, BU = {
  resetNumber: void 0,
  isInRange: !0
}, hte = (e, t, i, n) => {
  var C, A, b, m;
  const r = ie(m0t), g = ie(DJ), o = ((A = (C = i == null ? void 0 : i.settings) == null ? void 0 : C.templateOptions) == null ? void 0 : A.digits) || 0, [l, a] = wt(((m = (b = i == null ? void 0 : i.settings) == null ? void 0 : b.templateOptions) == null ? void 0 : m.min) || 0), [I, c] = wt(BU);
  lt(() => {
    var p;
    a((p = RF(t)) == null ? void 0 : p.OC_roundTo(o));
  }, [t, o]), lt(() => {
    var p;
    g || a((p = RF(t)) == null ? void 0 : p.OC_roundTo(o));
  }, [g, o, t]), lt(() => {
    var p;
    r || a((p = RF(t)) == null ? void 0 : p.OC_roundTo(o));
  }, [r, o, t]), lt(() => {
    let p;
    return I.isInRange || (p = setTimeout(() => c(BU), 5e3)), () => {
      p && clearTimeout(p);
    };
  }, [I]);
  const d = Gt(
    // WHAT THE FUCK JS.
    // when used as onBlur function n is a number. onConfirm n is a string.
    (p) => {
      const B = +p, f = Xm(B, n, Iu(i));
      f && (e(f.value.id, {
        inputValue: f.input.OC_roundTo(o)
      }), +B != +f.input && c({
        isInRange: !1,
        resetNumber: f.input
      }));
    },
    [o, e, n, i]
  );
  return {
    onNumberChange: a,
    onInputBlur: d,
    onImmediateChange: d,
    isInRange: I.isInRange,
    resetNumber: I.resetNumber,
    pureNumber: l
  };
}, mte = (e) => {
  const t = Ei();
  return Gt((i) => async (n, r) => await t(pE(n, i.id, r, e)), [e, t]);
}, XF = (e, t) => `${e.id}_${t.id}`, pte = "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", A1t = (e) => Uint8Array.from(atob(e), (t) => t.charCodeAt(0)), fU = typeof window < "u" && window.Blob && new Blob(["URL.revokeObjectURL(import.meta.url);", A1t(pte)], { type: "text/javascript;charset=utf-8" });
function b1t(e) {
  let t;
  try {
    if (t = fU && (window.URL || window.webkitURL).createObjectURL(fU), !t)
      throw "";
    const i = new Worker(t, {
      type: "module",
      name: e == null ? void 0 : e.name
    });
    return i.addEventListener("error", () => {
      (window.URL || window.webkitURL).revokeObjectURL(t);
    }), i;
  } catch {
    return new Worker(
      "data:text/javascript;base64," + pte,
      {
        type: "module",
        name: e == null ? void 0 : e.name
      }
    );
  }
}
const S1 = Ua(null);
class h1t {
  constructor(t, i = 7) {
    Qi(this, "workers");
    Qi(this, "jobCount");
    Qi(this, "initializedWorkerCount", 0);
    Qi(this, "workerStatus");
    Qi(this, "idleStatus", ["reset", "done"]);
    Qi(this, "status", "stopped");
    Qi(this, "callbackMap", {});
    Qi(this, "progressListenerMap", {});
    Qi(this, "messageEventListener", (t) => {
      var n;
      const i = t.data.valueBundleId;
      if (this.isProgressEvent(t.data.state)) {
        const r = ((n = this.valueBundles.find((o) => o.valueBundleId === i)) == null ? void 0 : n.needState) && !t.data.bomResult && t.data.resultStatus === "no-conflict";
        if (t.data.stateIndex === this.currentStateIndex) {
          r || (this.results[i] = t.data, this.postResult(i));
          const {
            workerIndex: o,
            valueBundleIndex: l
          } = this.whoIsWorkingOnValueBundle(i);
          o > -1 && l > -1 && (this.workerStatus[o][l] = t.data.state);
        }
        const g = this.isAllDone() ? 100 : 0;
        Object.values(this.progressListenerMap).forEach((o) => {
          o(g);
        });
      }
      this.processValueBundles();
    });
    Qi(this, "debouncedUpdateState", de.debounce((t) => this.updateState(t), 100, {
      maxWait: 500
    }));
    Qi(this, "valueBundles", []);
    Qi(this, "results", {});
    Qi(this, "currentStateIndex", -1);
    this.jobCount = i, this.workerStatus = this.initializeWorkerStatus(t, i), this.workers = Array.from({
      length: t
    }, () => new b1t()), this.workers.forEach((n, r) => {
      const g = (o) => {
        o.data.type === "workerInitialized" && (n.removeEventListener("message", g), this.initializedWorkerCount++, this.isInitialized() && (this.status = "running"));
      };
      n.addEventListener("message", g), n.addEventListener("message", this.messageEventListener), n.postMessage({
        type: "initializeWorker",
        workerIndex: r
      });
    }), this.initializeData();
  }
  isProgressEvent(t) {
    return this.idleStatus.includes(t);
  }
  initializeWorkerStatus(t = this.workers.length, i = this.jobCount) {
    return Array.from({
      length: t
    }, () => "init").map(() => Array.from({
      length: i
    }, () => "reset"));
  }
  initializeData() {
    this.status = "stopped", this.valueBundles = [], this.results = {}, this.currentStateIndex++, this.progressListenerMap = {}, this.callbackMap = {}, this.workerStatus = this.initializeWorkerStatus();
  }
  isInitialized() {
    return this.initializedWorkerCount === this.workers.length;
  }
  updateState(t) {
    this.status = "running", this.results = {}, this.workerStatus = this.initializeWorkerStatus(), this.currentStateIndex++, this.workers.forEach((i) => {
      i.postMessage({
        type: "updateState",
        state: t,
        stateIndex: this.currentStateIndex
      });
    }), this.processValueBundles();
  }
  terminate() {
    stop(), this.workers.forEach((t) => t.terminate());
  }
  stop() {
    this.initializeData(), this.workers.forEach((t) => {
      t.postMessage({
        type: "stop"
      });
    });
  }
  registerValueBundle(t, i, n, r, g, o = !1) {
    var d;
    const l = o || !!((d = Vi(t)) != null && d.showPrice), a = XF(i, n);
    de.set(this.callbackMap, [a, r], g);
    let I = this.results[a];
    I && l && !(I != null && I.bomResult) && (this.results[a] = void 0, I = void 0);
    const c = this.valueBundles.find((C) => C.valueBundleId == a);
    c ? c.needState = l || c.needState : this.valueBundles.push({
      variableId: t.id,
      valueBundleId: XF(i, n),
      valueId: i.id,
      contextInstanceId: n.id,
      needState: l
    }), I && this.postResult(a), this.processValueBundles();
  }
  isAllDone() {
    return this.workerStatus.every((t) => t.every((i) => this.idleStatus.includes(i)));
  }
  postResult(t) {
    const i = this.results[t];
    i && (this.callbackMap[t] && Object.keys(this.callbackMap[t])).forEach((r) => {
      const g = this.callbackMap[t][r];
      g && g(i);
    });
  }
  processValueBundles() {
    this.valueBundles.length === 0 || this.status === "stopped" || this.workerStatus.forEach((t) => {
      t.forEach((i) => {
        this.idleStatus.includes(i) && this.processNextQueueItem();
      });
    });
  }
  findFreeWorkerIndex() {
    const {
      freeWorkerIndex: t
    } = this.workerStatus.reduce((i, n, r) => {
      const g = n.reduce((o, l) => (this.idleStatus.includes(l) && o++, o), 0);
      return g > i.maxIdleStatusCount ? {
        freeWorkerIndex: r,
        maxIdleStatusCount: g
      } : i;
    }, {
      freeWorkerIndex: -1,
      maxIdleStatusCount: -1 / 0
    });
    return t ?? -1;
  }
  processNextQueueItem() {
    if (this.valueBundles.length === 0)
      return;
    const t = this.valueBundles.find((C) => !this.results[C.valueBundleId] && !this.workerStatus.some((A) => A.includes(C.valueBundleId)));
    if (!t)
      return;
    const {
      valueBundleId: i,
      valueId: n,
      contextInstanceId: r,
      needState: g
    } = t, o = this.results[i];
    if ((o == null ? void 0 : o.stateIndex) === this.currentStateIndex) {
      this.postResult(i);
      return;
    }
    if (this.workerStatus.find((C) => C.includes(i)))
      return;
    const a = this.findFreeWorkerIndex();
    if (a === -1)
      return;
    const I = this.workers[a], c = {
      type: "start",
      valueId: n,
      contextInstanceId: r,
      needState: g
    }, d = this.workerStatus[a].findIndex((C) => this.idleStatus.includes(C));
    this.workerStatus[a][d] = i, I.postMessage(c);
  }
  whoIsWorkingOnValueBundle(t) {
    let i = -1;
    return {
      workerIndex: this.workerStatus.findIndex((r) => (i = r.findIndex((g) => g === t), i > -1)),
      valueBundleIndex: i
    };
  }
  unregisterValueBundle(t, i, n) {
    var o;
    if (this.status === "stopped")
      return;
    const r = XF(t, i);
    if (this.callbackMap[r] && delete this.callbackMap[r][n], ((o = Object.keys(this.callbackMap[r] ?? {})) == null ? void 0 : o.length) === 0) {
      this.valueBundles = this.valueBundles.filter((a) => a.valueBundleId !== r);
      const {
        workerIndex: l
      } = this.whoIsWorkingOnValueBundle(r);
      if (l > -1) {
        const a = this.workers[l];
        a && a.postMessage({
          type: "stop"
        });
      }
    }
  }
  addProgressListener(t, i) {
    this.progressListenerMap[t] = i;
  }
  removeProgressListener(t) {
    delete this.progressListenerMap[t];
  }
}
const ES = new h1t(4), Yei = ({
  children: e
}) => {
  const t = ie((l) => l), i = ie(Ns), n = ie(E9), [r, g] = wt(null);
  lt(() => () => {
    ES.stop();
  }, []);
  const o = ES.isInitialized();
  return lt(() => {
    o && g({
      nextStateWorker: ES
    });
  }, [o]), lt(() => {
    o && ES.debouncedUpdateState(t);
  }, [i, n, o]), /* @__PURE__ */ S(S1.Provider, { value: r, children: e });
}, m1t = [Oh.AlwaysHidden, Oh.HideAction, Oh.ConcealAction], p1t = [], Bte = (e, t) => {
  var f, Z, y;
  const i = Vn(S1), r = (f = ie((W) => N9(W, t))[e.id]) == null ? void 0 : f.reason, g = r ? m1t.includes(r) : !1, o = UWt(), l = (Z = o == null ? void 0 : o.state.all.selections.find((W) => W.variableId === e.id && W.instance.id === t.id)) == null ? void 0 : Z.valueId, a = ie(nr), I = (a == null ? void 0 : a.values.byVarId.all[e.id]) ?? p1t, c = ot({}), [d, C] = wt({}), A = Gt(de.debounce(() => {
    C((W) => ({
      ...W,
      ...c.current ?? {}
    }));
  }, 200, {
    leading: !1,
    trailing: !0,
    maxWait: 500
  }), [e == null ? void 0 : e.id, t == null ? void 0 : t.id]), b = Gt((W, V) => {
    c.current[W] = V, A();
  }, [A]), m = Oe(() => o == null ? void 0 : o.state.free.selections.find((W) => W.variableId === e.id), [o, e.id]), p = (y = i == null ? void 0 : i.nextStateWorker) == null ? void 0 : y.isInitialized();
  return lt(() => {
    if (Sg(e) && !e.settings.templateOptions.hideIfSingleOption)
      return;
    if (m) {
      I.forEach((v) => {
        b(v.id, "no-conflict");
      });
      return;
    }
    const W = i == null ? void 0 : i.nextStateWorker;
    if (g || !W || !W.isInitialized())
      return;
    const V = (v) => {
      const H = v.valueId, x = I.find((K) => K.id === +H);
      if (v.contextInstanceId === t.id && x) {
        const K = v.resultStatus;
        K && b(x.id, K);
      }
    }, w = fv();
    return I.forEach((v) => {
      W.registerValueBundle(e, v, t, w, V);
    }), () => {
      I.forEach((v) => {
        W.unregisterValueBundle(v, t, w);
      });
    };
  }, [p, t, t.id, b, m, g, i, I, e, e.id]), Oe(() => l ? {
    ...d,
    [l]: "no-conflict"
  } : d, [d, l]);
}, fte = (e, t = Ut) => {
  const i = Vi(e).hideInvalidUntouchedOptions, n = Vi(e).hideInvalidOptions, r = Bte(e, t), g = ot([]), o = Oe(() => {
    const y = Object.keys(r).reduce((V, w) => {
      const v = +w;
      return r[v] === "conflict" && V.push(v), V;
    }, []);
    y.sort();
    const W = Le.equals(y, g.current) ? g.current : y;
    return g.current = W, W;
  }, [r]), l = ot([]), a = Oe(() => {
    const y = Object.keys(r).reduce((V, w) => {
      const v = +w;
      return ["error", "no-solution-conflict", "popup-action"].includes(r[v]) && V.push(v), V;
    }, []);
    y.sort();
    const W = Le.equals(y, l.current) ? l.current : y;
    return l.current = W, W;
  }, [r]), I = ot([]), c = Oe(() => {
    const y = Object.keys(r).reduce((V, w) => {
      const v = +w;
      return r[v] == "no-conflict" && V.push(v), V;
    }, []);
    y.sort();
    const W = Le.equals(y, I.current) ? I.current : y;
    return I.current = W, W;
  }, [r]), d = ot([]), C = Oe(() => {
    const y = Object.keys(r).reduce((V, w) => {
      const v = +w;
      return r[v] == "loading" && V.push(v), V;
    }, []);
    y.sort();
    const W = Le.equals(y, d.current) ? d.current : y;
    return d.current = W, W;
  }, [r]), A = ie(wZ), {
    ruleEngineState: b,
    ruleEngineInput: m
  } = A, p = Oe(() => {
    if (!(e != null && e.id)) {
      console.error("Can't get component props for undefined variable");
      return;
    }
    return b == null ? void 0 : b.state.all.selections.find((y) => y.variableId === e.id && y.instance.id === t.id);
  }, [e, b, t]), B = Oe(() => m == null ? void 0 : m.hiddenValuesMap[t.id], [m, t]), f = Oe(() => {
    if (!(e != null && e.id))
      return [];
    const y = (m == null ? void 0 : m.values.byVarId.all[e.id]) || [];
    return e.type === "number" ? y : y.filter((W) => !(B != null && B[W.id])).filter((W) => !i || c.includes(W.id)).filter((W) => !n || !o.includes(W.id)).sort(gA);
  }, [e, m, B, i, c, n, o]), Z = Oe(() => f.find((y) => y.id === (p == null ? void 0 : p.valueId)), [f, p]);
  return {
    selection: p,
    contextInstance: t,
    validValueIds: c,
    invalidValueIds: a,
    touchedInvalidValueIds: o,
    value: Z,
    variable: e,
    values: f,
    loadingValueIds: C
  };
}, B1t = Se(Tn)(({
  theme: e
}) => ({
  tooltip: {
    backgroundColor: e.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: e.shadows[1],
    fontSize: 16,
    border: "solid 1px rgba(0, 0, 0, 0.87)"
  },
  arrow: {
    "&:before": {
      boxSizing: "border-box",
      border: "solid 1px rgba(0, 0, 0, 0.87)"
    },
    color: e.palette.common.white
  }
})), f1t = ({
  children: e
}) => /* @__PURE__ */ S(ht, { component: "div", my: 2, children: e }), ZU = (e) => {
  const {
    i18n: t
  } = Gi(), i = ie(yA), n = ie(Wv), r = new Intl.NumberFormat(t.language, {
    maximumFractionDigits: 3
  }), g = new Intl.NumberFormat(t.language, {
    maximumFractionDigits: 4
  }), o = e.pos;
  let l = o.amount ? g.format(o.amount) : "";
  if (e.showAmount && l && o.price.unit) {
    const a = o.price.unit || "";
    l += a.OC_isCapitalized() ? ` ${a}` : a;
  }
  return /* @__PURE__ */ Ie($V, { sx: {
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }, children: [
    /* @__PURE__ */ S(Ur, { component: "th", scope: "row", children: e.posNo }),
    /* @__PURE__ */ S(Ur, { component: "th", scope: "row", children: o.article.no }),
    /* @__PURE__ */ S(Ur, { scope: "row", children: o.article.name }),
    n && /* @__PURE__ */ S(Ur, { children: i.format(o.priceUnit) }),
    e.showAmount && /* @__PURE__ */ S(Ur, { scope: "row", children: l }),
    /* @__PURE__ */ S(Ur, { children: r.format(o.qty) }),
    n && /* @__PURE__ */ S(Ur, { align: "right", children: o.priceTotal ? i.format(o.priceTotal) : "" })
  ] });
}, Z1t = (e, t) => (e.article.sort ?? 0) - (t.article.sort ?? 0), G1t = ({
  dense: e,
  bom: t,
  showPrice: i,
  sortCompareFn: n = Z1t
}) => {
  const r = Vg(), g = ie(yA), o = Oe(() => {
    var c;
    const I = (c = t.articleLines) == null ? void 0 : c.OC_reduceBy(
      // If number and amount match
      (d, C) => d.article.no == C.article.no && d.amount == C.amount,
      // Merge Items by updating price and count/qty
      (d, C) => (d.qty += C.qty, d.priceTotal += C.priceTotal, d)
    );
    return n ? I.sort(n) : I;
  }, [n, t.articleLines]), l = Oe(() => n ? (t.surchargeLines ?? []).sort(n) : t.surchargeLines, [n, t.surchargeLines]);
  if (!(o != null && o.length))
    return null;
  const a = o.some((I) => {
    var c;
    return !gm(I.amount) || !gm((c = I.articleAction) == null ? void 0 : c.amount);
  });
  return /* @__PURE__ */ S(f1t, { children: /* @__PURE__ */ S(pfe, { component: ul, children: /* @__PURE__ */ Ie(Dj, { sx: e ? {
    width: 1
  } : {
    minWidth: 400
  }, size: e ? "small" : "medium", children: [
    /* @__PURE__ */ S(Wfe, { children: /* @__PURE__ */ Ie($V, { children: [
      /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_pos") }),
      /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_articleNo") }),
      /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_article") }),
      i && /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_articlePrice") }),
      a && /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_articleAmount") }),
      /* @__PURE__ */ S(Ur, { align: "left", children: r("order_modal_articleCount") }),
      i && /* @__PURE__ */ S(Ur, { align: "right", children: r("order_modal_positionPrice") })
    ] }) }),
    /* @__PURE__ */ Ie(Jj, { children: [
      o.map((I, c) => /* @__PURE__ */ S(ZU, { posNo: c + 1, pos: I, showAmount: a }, c)),
      l.map((I, c) => /* @__PURE__ */ S(ZU, { posNo: c + 1, pos: I, showAmount: a }, c)),
      i && /* @__PURE__ */ Ie($V, { children: [
        /* @__PURE__ */ S(Ur, {}),
        /* @__PURE__ */ S(Ur, { align: "left", colSpan: a ? 5 : 4, children: r("translation_totalPrice") }),
        /* @__PURE__ */ S(Ur, { align: "right", children: t.priceTotal > 0 ? g.format(t.priceTotal) : "" })
      ] })
    ] })
  ] }) }) });
}, Fei = gr({
  app: {
    orderDialog: {
      priceTable: {
        articleList: {
          root: !0
        }
      }
    }
  }
})(G1t), y1t = ({
  invalidOption: e
}) => {
  const t = Vg(), i = ie(hWe(e.conflicts));
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Ct, { children: t("translation_warning_invalid_selection") }),
    /* @__PURE__ */ S(ht, { component: "div", sx: {
      margin: 2
    }, children: i.map((n) => /* @__PURE__ */ Ie(Ct, { children: [
      /* @__PURE__ */ Ie("b", { children: [
        n == null ? void 0 : n.variable,
        ":"
      ] }),
      " ",
      n == null ? void 0 : n.value
    ] }, n == null ? void 0 : n.variable)) }),
    /* @__PURE__ */ S(Ct, { children: t("translation_warning_invalid_selection_alternative") }),
    /* @__PURE__ */ S(hu, { keys: ["translation_warning_invalid_selection", "translation_warning_invalid_selection_alternative"], display: "dialog" })
  ] });
}, W1t = gr({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        tooltipContent: {
          root: !0
        }
      }
    }
  }
})(y1t), S1t = ({
  iconSx: e,
  iconSize: t
}) => /* @__PURE__ */ S(gq, { className: "invalidSelectionIcon", sx: e, fontSize: t ?? "medium", color: "warning" }), V1t = gr({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        icon: {
          root: !0
        }
      }
    }
  }
})(S1t), w1t = ({
  valueId: e,
  alwaysDisplay: t,
  iconSx: i,
  invalidOption: n
}) => {
  const r = ie((g) => n ?? X6(e)(g));
  return r ? /* @__PURE__ */ S(Tn, { className: "invalidSelectionIconTooltip", title: /* @__PURE__ */ S(W1t, { invalidOption: r }), children: /* @__PURE__ */ S("div", { children: /* @__PURE__ */ S(V1t, { iconSx: i }) }) }) : /* @__PURE__ */ S(li, { children: t });
}, v1t = gr({
  app: {
    sidebar: {
      invalidSelectionWarning: {
        root: !0
      }
    }
  }
})(w1t), xei = (e) => {
  const t = ie(X6(e.valueId));
  return /* @__PURE__ */ S(v1t, { ...e, invalidOption: t });
}, Zte = ({
  isInRange: e,
  resetNumber: t,
  children: i,
  placement: n = "left-end",
  variable: r,
  ...g
}) => {
  const [o, l] = wt(!1);
  return /* @__PURE__ */ S(B1t, { ...g, arrow: !0, placement: n, open: !e || o, title: (!e || o) && /* @__PURE__ */ S(X1t, { onOpen: () => l(!0), onClose: () => l(!1), isInRange: e, resetNumber: t, placement: n, variable: r, children: /* @__PURE__ */ S(li, {}), ...g }), children: /* @__PURE__ */ S(ht, { component: "div", children: i }) });
}, R1t = ({
  resetNumber: e,
  onOpen: t,
  onClose: i
}) => {
  const n = Vg(), r = ot(e);
  return /* @__PURE__ */ Ie(ht, { component: "div", sx: {
    display: "grid",
    gridTemplateColumns: "min-content auto",
    gap: 1,
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ S(PAt, { color: "error" }),
    n("translation_warning_number") + (e ?? r.current),
    /* @__PURE__ */ S(hu, { onOpen: t, onClose: i, keys: ["translation_warning_number"], display: "dialog" })
  ] });
}, X1t = gr({
  app: {
    sidebar: {
      numberWarningTooltipContent: {
        root: !0
      }
    }
  }
})(R1t), Dei = (e) => {
  var t;
  return Le.toNumber(((t = e == null ? void 0 : e.data) == null ? void 0 : t.inputValue) || 0);
}, Gte = (e) => (t, i) => {
  const n = i(), r = nr(n), g = Jr(n);
  if (!r || !g)
    return console.warn("Rule engine not initialized!"), g;
  const o = e.map((l, a) => ({
    ...l,
    sort: a
  }));
  return t(qZ(Eyt(r, g.state, g.state.locked.selections.map((l) => o.find((I) => I.id === l.id) || l), !0)));
}, H1t = (e, t, i) => async (n, r) => {
  const g = r(), o = nr(g), l = Jr(g);
  if (!o || !l) {
    console.warn("Rule engine not initialized!");
    return;
  }
  const a = await zZ(o, l.state, i, o.values.byVarId.all[e.variableId].find((c) => c.id === e.valueId), t, e.data).catch((c) => {
    throw c;
  });
  if (!(!a || !n(await yte(e, a.lastManualChange, a, !0))))
    return a.lastManualChange;
}, yte = (e, t, i, n = !0) => async (r, g) => {
  const o = g(), l = nr(o), a = Jr(o);
  if (!l || !a)
    return console.warn("Rule engine not initialized!"), a;
  const I = await Wte(l, l.variables.flat.all)(e, t, i || a);
  return I.lastManualChange = t, n && r(qZ(I)), I;
}, Jei = () => {
  const e = Ei();
  return (t, i, n, r) => e(yte(t, i, n, r));
}, Wte = (e, t) => async (i, n, r) => {
  let g = r;
  const o = t.filter((a) => a.parentId === i.variableId), l = (a) => e.values.byVarId.all[a.variableId].find((I) => I.id === a.valueId);
  for (let a = 0; a < o.length; a++) {
    const I = o[a], c = g.state.all.selections, d = c.filter((A) => A.variableId === I.id && V5(A) === i.id), C = c.filter((A) => A.variableId === I.id && V5(A) === n.id);
    if (km(I)) {
      const A = [];
      C.forEach((b) => {
        const m = OZ(g.state, b);
        m && (g = m);
      });
      for (let b = 0; b < d.length; b++) {
        const m = d[b], p = await zZ(e, g.state, n, l(m), m.sort, m.data, !1).catch((B) => {
          throw B;
        });
        p && (g = p, A.push([m, p.lastManualChange]));
      }
      for (let b = 0; b < A.length; b++) {
        const [m, p] = A[b];
        g = await Wte(e, t)(m, p, g);
      }
    } else {
      const A = d[0], b = b1(e, g.state, n, l(A), A.data, !1, !1);
      b && (g = b);
    }
  }
  return g;
};
var P5;
try {
  P5 = Map;
} catch {
}
var U5;
try {
  U5 = Set;
} catch {
}
function Ste(e, t, i) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(z5);
  if (P5 && e instanceof P5)
    return new Map(Array.from(e.entries()));
  if (U5 && e instanceof U5)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var n = Object.create(e);
    i.push(n);
    for (var r in e) {
      var g = t.findIndex(function(o) {
        return o === e[r];
      });
      n[r] = g > -1 ? i[g] : Ste(e[r], t, i);
    }
    return n;
  }
  return e;
}
function z5(e) {
  return Ste(e, [], []);
}
const k1t = Object.prototype.toString, Y1t = Error.prototype.toString, F1t = RegExp.prototype.toString, x1t = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", D1t = /^Symbol\((.*)\)(.*)$/;
function J1t(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function GU(e, t = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const i = typeof e;
  if (i === "number")
    return J1t(e);
  if (i === "string")
    return t ? `"${e}"` : e;
  if (i === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (i === "symbol")
    return x1t.call(e).replace(D1t, "Symbol($1)");
  const n = k1t.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + Y1t.call(e) + "]" : n === "RegExp" ? F1t.call(e) : null;
}
function um(e, t) {
  let i = GU(e, t);
  return i !== null ? i : JSON.stringify(e, function(n, r) {
    let g = GU(this[n], t);
    return g !== null ? g : r;
  }, 2);
}
let WC = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: i,
    originalValue: n
  }) => {
    let r = n != null && n !== i, g = `${e} must be a \`${t}\` type, but the final value was: \`${um(i, !0)}\`` + (r ? ` (cast from the value \`${um(n, !0)}\`).` : ".");
    return i === null && (g += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), g;
  },
  defined: "${path} must be defined"
}, Zs = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, E1t = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, O5 = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, N1t = {
  isValue: "${path} field must be ${value}"
}, Q5 = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, HV = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: WC,
  string: Zs,
  number: E1t,
  date: O5,
  object: Q5,
  array: HV,
  boolean: N1t
});
var L1t = Object.prototype, K1t = L1t.hasOwnProperty;
function T1t(e, t) {
  return e != null && K1t.call(e, t);
}
var M1t = T1t, P1t = Array.isArray, fu = P1t, U1t = typeof Or == "object" && Or && Or.Object === Object && Or, Vte = U1t, z1t = Vte, O1t = typeof self == "object" && self && self.Object === Object && self, Q1t = z1t || O1t || Function("return this")(), Fc = Q1t, j1t = Fc, q1t = j1t.Symbol, V1 = q1t, yU = V1, wte = Object.prototype, _1t = wte.hasOwnProperty, $1t = wte.toString, hB = yU ? yU.toStringTag : void 0;
function eRt(e) {
  var t = _1t.call(e, hB), i = e[hB];
  try {
    e[hB] = void 0;
    var n = !0;
  } catch {
  }
  var r = $1t.call(e);
  return n && (t ? e[hB] = i : delete e[hB]), r;
}
var tRt = eRt, iRt = Object.prototype, nRt = iRt.toString;
function rRt(e) {
  return nRt.call(e);
}
var gRt = rRt, WU = V1, oRt = tRt, lRt = gRt, aRt = "[object Null]", sRt = "[object Undefined]", SU = WU ? WU.toStringTag : void 0;
function IRt(e) {
  return e == null ? e === void 0 ? sRt : aRt : SU && SU in Object(e) ? oRt(e) : lRt(e);
}
var tG = IRt;
function cRt(e) {
  return e != null && typeof e == "object";
}
var iG = cRt, dRt = tG, uRt = iG, CRt = "[object Symbol]";
function ARt(e) {
  return typeof e == "symbol" || uRt(e) && dRt(e) == CRt;
}
var JE = ARt, bRt = fu, hRt = JE, mRt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pRt = /^\w*$/;
function BRt(e, t) {
  if (bRt(e))
    return !1;
  var i = typeof e;
  return i == "number" || i == "symbol" || i == "boolean" || e == null || hRt(e) ? !0 : pRt.test(e) || !mRt.test(e) || t != null && e in Object(t);
}
var EE = BRt;
function fRt(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var NE = fRt, ZRt = tG, GRt = NE, yRt = "[object AsyncFunction]", WRt = "[object Function]", SRt = "[object GeneratorFunction]", VRt = "[object Proxy]";
function wRt(e) {
  if (!GRt(e))
    return !1;
  var t = ZRt(e);
  return t == WRt || t == SRt || t == yRt || t == VRt;
}
var vte = wRt, vRt = Fc, RRt = vRt["__core-js_shared__"], XRt = RRt, HF = XRt, VU = function() {
  var e = /[^.]+$/.exec(HF && HF.keys && HF.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function HRt(e) {
  return !!VU && VU in e;
}
var kRt = HRt, YRt = Function.prototype, FRt = YRt.toString;
function xRt(e) {
  if (e != null) {
    try {
      return FRt.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Rte = xRt, DRt = vte, JRt = kRt, ERt = NE, NRt = Rte, LRt = /[\\^$.*+?()[\]{}|]/g, KRt = /^\[object .+?Constructor\]$/, TRt = Function.prototype, MRt = Object.prototype, PRt = TRt.toString, URt = MRt.hasOwnProperty, zRt = RegExp(
  "^" + PRt.call(URt).replace(LRt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function ORt(e) {
  if (!ERt(e) || JRt(e))
    return !1;
  var t = DRt(e) ? zRt : KRt;
  return t.test(NRt(e));
}
var QRt = ORt;
function jRt(e, t) {
  return e == null ? void 0 : e[t];
}
var qRt = jRt, _Rt = QRt, $Rt = qRt;
function eXt(e, t) {
  var i = $Rt(e, t);
  return _Rt(i) ? i : void 0;
}
var kA = eXt, tXt = kA, iXt = tXt(Object, "create"), w1 = iXt, wU = w1;
function nXt() {
  this.__data__ = wU ? wU(null) : {}, this.size = 0;
}
var rXt = nXt;
function gXt(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var oXt = gXt, lXt = w1, aXt = "__lodash_hash_undefined__", sXt = Object.prototype, IXt = sXt.hasOwnProperty;
function cXt(e) {
  var t = this.__data__;
  if (lXt) {
    var i = t[e];
    return i === aXt ? void 0 : i;
  }
  return IXt.call(t, e) ? t[e] : void 0;
}
var dXt = cXt, uXt = w1, CXt = Object.prototype, AXt = CXt.hasOwnProperty;
function bXt(e) {
  var t = this.__data__;
  return uXt ? t[e] !== void 0 : AXt.call(t, e);
}
var hXt = bXt, mXt = w1, pXt = "__lodash_hash_undefined__";
function BXt(e, t) {
  var i = this.__data__;
  return this.size += this.has(e) ? 0 : 1, i[e] = mXt && t === void 0 ? pXt : t, this;
}
var fXt = BXt, ZXt = rXt, GXt = oXt, yXt = dXt, WXt = hXt, SXt = fXt;
function Um(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Um.prototype.clear = ZXt;
Um.prototype.delete = GXt;
Um.prototype.get = yXt;
Um.prototype.has = WXt;
Um.prototype.set = SXt;
var VXt = Um;
function wXt() {
  this.__data__ = [], this.size = 0;
}
var vXt = wXt;
function RXt(e, t) {
  return e === t || e !== e && t !== t;
}
var Xte = RXt, XXt = Xte;
function HXt(e, t) {
  for (var i = e.length; i--; )
    if (XXt(e[i][0], t))
      return i;
  return -1;
}
var v1 = HXt, kXt = v1, YXt = Array.prototype, FXt = YXt.splice;
function xXt(e) {
  var t = this.__data__, i = kXt(t, e);
  if (i < 0)
    return !1;
  var n = t.length - 1;
  return i == n ? t.pop() : FXt.call(t, i, 1), --this.size, !0;
}
var DXt = xXt, JXt = v1;
function EXt(e) {
  var t = this.__data__, i = JXt(t, e);
  return i < 0 ? void 0 : t[i][1];
}
var NXt = EXt, LXt = v1;
function KXt(e) {
  return LXt(this.__data__, e) > -1;
}
var TXt = KXt, MXt = v1;
function PXt(e, t) {
  var i = this.__data__, n = MXt(i, e);
  return n < 0 ? (++this.size, i.push([e, t])) : i[n][1] = t, this;
}
var UXt = PXt, zXt = vXt, OXt = DXt, QXt = NXt, jXt = TXt, qXt = UXt;
function zm(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
zm.prototype.clear = zXt;
zm.prototype.delete = OXt;
zm.prototype.get = QXt;
zm.prototype.has = jXt;
zm.prototype.set = qXt;
var R1 = zm, _Xt = kA, $Xt = Fc, eHt = _Xt($Xt, "Map"), LE = eHt, vU = VXt, tHt = R1, iHt = LE;
function nHt() {
  this.size = 0, this.__data__ = {
    hash: new vU(),
    map: new (iHt || tHt)(),
    string: new vU()
  };
}
var rHt = nHt;
function gHt(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var oHt = gHt, lHt = oHt;
function aHt(e, t) {
  var i = e.__data__;
  return lHt(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
}
var X1 = aHt, sHt = X1;
function IHt(e) {
  var t = sHt(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var cHt = IHt, dHt = X1;
function uHt(e) {
  return dHt(this, e).get(e);
}
var CHt = uHt, AHt = X1;
function bHt(e) {
  return AHt(this, e).has(e);
}
var hHt = bHt, mHt = X1;
function pHt(e, t) {
  var i = mHt(this, e), n = i.size;
  return i.set(e, t), this.size += i.size == n ? 0 : 1, this;
}
var BHt = pHt, fHt = rHt, ZHt = cHt, GHt = CHt, yHt = hHt, WHt = BHt;
function Om(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.clear(); ++t < i; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Om.prototype.clear = fHt;
Om.prototype.delete = ZHt;
Om.prototype.get = GHt;
Om.prototype.has = yHt;
Om.prototype.set = WHt;
var KE = Om, Hte = KE, SHt = "Expected a function";
function TE(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(SHt);
  var i = function() {
    var n = arguments, r = t ? t.apply(this, n) : n[0], g = i.cache;
    if (g.has(r))
      return g.get(r);
    var o = e.apply(this, n);
    return i.cache = g.set(r, o) || g, o;
  };
  return i.cache = new (TE.Cache || Hte)(), i;
}
TE.Cache = Hte;
var VHt = TE, wHt = VHt, vHt = 500;
function RHt(e) {
  var t = wHt(e, function(n) {
    return i.size === vHt && i.clear(), n;
  }), i = t.cache;
  return t;
}
var XHt = RHt, HHt = XHt, kHt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, YHt = /\\(\\)?/g, FHt = HHt(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(kHt, function(i, n, r, g) {
    t.push(r ? g.replace(YHt, "$1") : n || i);
  }), t;
}), xHt = FHt;
function DHt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, r = Array(n); ++i < n; )
    r[i] = t(e[i], i, e);
  return r;
}
var JHt = DHt, RU = V1, EHt = JHt, NHt = fu, LHt = JE, KHt = 1 / 0, XU = RU ? RU.prototype : void 0, HU = XU ? XU.toString : void 0;
function kte(e) {
  if (typeof e == "string")
    return e;
  if (NHt(e))
    return EHt(e, kte) + "";
  if (LHt(e))
    return HU ? HU.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -KHt ? "-0" : t;
}
var THt = kte, MHt = THt;
function PHt(e) {
  return e == null ? "" : MHt(e);
}
var nG = PHt, UHt = fu, zHt = EE, OHt = xHt, QHt = nG;
function jHt(e, t) {
  return UHt(e) ? e : zHt(e, t) ? [e] : OHt(QHt(e));
}
var Yte = jHt, qHt = tG, _Ht = iG, $Ht = "[object Arguments]";
function ekt(e) {
  return _Ht(e) && qHt(e) == $Ht;
}
var tkt = ekt, kU = tkt, ikt = iG, Fte = Object.prototype, nkt = Fte.hasOwnProperty, rkt = Fte.propertyIsEnumerable, gkt = kU(/* @__PURE__ */ function() {
  return arguments;
}()) ? kU : function(e) {
  return ikt(e) && nkt.call(e, "callee") && !rkt.call(e, "callee");
}, xte = gkt, okt = 9007199254740991, lkt = /^(?:0|[1-9]\d*)$/;
function akt(e, t) {
  var i = typeof e;
  return t = t ?? okt, !!t && (i == "number" || i != "symbol" && lkt.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Dte = akt, skt = 9007199254740991;
function Ikt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= skt;
}
var ME = Ikt, ckt = JE, dkt = 1 / 0;
function ukt(e) {
  if (typeof e == "string" || ckt(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -dkt ? "-0" : t;
}
var H1 = ukt, Ckt = Yte, Akt = xte, bkt = fu, hkt = Dte, mkt = ME, pkt = H1;
function Bkt(e, t, i) {
  t = Ckt(t, e);
  for (var n = -1, r = t.length, g = !1; ++n < r; ) {
    var o = pkt(t[n]);
    if (!(g = e != null && i(e, o)))
      break;
    e = e[o];
  }
  return g || ++n != r ? g : (r = e == null ? 0 : e.length, !!r && mkt(r) && hkt(o, r) && (bkt(e) || Akt(e)));
}
var Jte = Bkt, fkt = M1t, Zkt = Jte;
function Gkt(e, t) {
  return e != null && Zkt(e, t, fkt);
}
var ykt = Gkt;
const Yw = /* @__PURE__ */ go(ykt), PE = (e) => e && e.__isYupSchema__;
class Wkt {
  constructor(t, i) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof i == "function") {
      this.fn = i;
      return;
    }
    if (!Yw(i, "is"))
      throw new TypeError("`is:` is required for `when()` conditions");
    if (!i.then && !i.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: r,
      otherwise: g
    } = i, o = typeof n == "function" ? n : (...l) => l.every((a) => a === n);
    this.fn = function(...l) {
      let a = l.pop(), I = l.pop(), c = o(...l) ? r : g;
      if (c)
        return typeof c == "function" ? c(I) : I.concat(c.resolve(a));
    };
  }
  resolve(t, i) {
    let n = this.refs.map((g) => g.getValue(i == null ? void 0 : i.value, i == null ? void 0 : i.parent, i == null ? void 0 : i.context)), r = this.fn.apply(t, n.concat(t, i));
    if (r === void 0 || r === t)
      return t;
    if (!PE(r))
      throw new TypeError("conditions must return a schema object");
    return r.resolve(i);
  }
}
function Ete(e) {
  return e == null ? [] : [].concat(e);
}
function j5() {
  return j5 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, j5.apply(this, arguments);
}
let Skt = /\$\{\s*(\w+)\s*\}/g;
class rl extends Error {
  static formatError(t, i) {
    const n = i.label || i.path || "this";
    return n !== i.path && (i = j5({}, i, {
      path: n
    })), typeof t == "string" ? t.replace(Skt, (r, g) => um(i[g])) : typeof t == "function" ? t(i) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, i, n, r) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = i, this.path = n, this.type = r, this.errors = [], this.inner = [], Ete(t).forEach((g) => {
      rl.isError(g) ? (this.errors.push(...g.errors), this.inner = this.inner.concat(g.inner.length ? g.inner : g)) : this.errors.push(g);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, rl);
  }
}
const Vkt = (e) => {
  let t = !1;
  return (...i) => {
    t || (t = !0, e(...i));
  };
};
function Fw(e, t) {
  let {
    endEarly: i,
    tests: n,
    args: r,
    value: g,
    errors: o,
    sort: l,
    path: a
  } = e, I = Vkt(t), c = n.length;
  const d = [];
  if (o = o || [], !c)
    return o.length ? I(new rl(o, g, a)) : I(null, g);
  for (let C = 0; C < n.length; C++) {
    const A = n[C];
    A(r, function(m) {
      if (m) {
        if (!rl.isError(m))
          return I(m, g);
        if (i)
          return m.value = g, I(m, g);
        d.push(m);
      }
      if (--c <= 0) {
        if (d.length && (l && d.sort(l), o.length && d.push(...o), o = d), o.length) {
          I(new rl(o, g, a), g);
          return;
        }
        I(null, g);
      }
    });
  }
}
var wkt = kA, vkt = function() {
  try {
    var e = wkt(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Rkt = vkt, YU = Rkt;
function Xkt(e, t, i) {
  t == "__proto__" && YU ? YU(e, t, {
    configurable: !0,
    enumerable: !0,
    value: i,
    writable: !0
  }) : e[t] = i;
}
var Nte = Xkt;
function Hkt(e) {
  return function(t, i, n) {
    for (var r = -1, g = Object(t), o = n(t), l = o.length; l--; ) {
      var a = o[e ? l : ++r];
      if (i(g[a], a, g) === !1)
        break;
    }
    return t;
  };
}
var kkt = Hkt, Ykt = kkt, Fkt = Ykt(), xkt = Fkt;
function Dkt(e, t) {
  for (var i = -1, n = Array(e); ++i < e; )
    n[i] = t(i);
  return n;
}
var Jkt = Dkt, xw = { exports: {} };
function Ekt() {
  return !1;
}
var Nkt = Ekt;
xw.exports;
(function(e, t) {
  var i = Fc, n = Nkt, r = t && !t.nodeType && t, g = r && !0 && e && !e.nodeType && e, o = g && g.exports === r, l = o ? i.Buffer : void 0, a = l ? l.isBuffer : void 0, I = a || n;
  e.exports = I;
})(xw, xw.exports);
var Lte = xw.exports, Lkt = tG, Kkt = ME, Tkt = iG, Mkt = "[object Arguments]", Pkt = "[object Array]", Ukt = "[object Boolean]", zkt = "[object Date]", Okt = "[object Error]", Qkt = "[object Function]", jkt = "[object Map]", qkt = "[object Number]", _kt = "[object Object]", $kt = "[object RegExp]", eYt = "[object Set]", tYt = "[object String]", iYt = "[object WeakMap]", nYt = "[object ArrayBuffer]", rYt = "[object DataView]", gYt = "[object Float32Array]", oYt = "[object Float64Array]", lYt = "[object Int8Array]", aYt = "[object Int16Array]", sYt = "[object Int32Array]", IYt = "[object Uint8Array]", cYt = "[object Uint8ClampedArray]", dYt = "[object Uint16Array]", uYt = "[object Uint32Array]", Un = {};
Un[gYt] = Un[oYt] = Un[lYt] = Un[aYt] = Un[sYt] = Un[IYt] = Un[cYt] = Un[dYt] = Un[uYt] = !0;
Un[Mkt] = Un[Pkt] = Un[nYt] = Un[Ukt] = Un[rYt] = Un[zkt] = Un[Okt] = Un[Qkt] = Un[jkt] = Un[qkt] = Un[_kt] = Un[$kt] = Un[eYt] = Un[tYt] = Un[iYt] = !1;
function CYt(e) {
  return Tkt(e) && Kkt(e.length) && !!Un[Lkt(e)];
}
var AYt = CYt;
function bYt(e) {
  return function(t) {
    return e(t);
  };
}
var hYt = bYt, Dw = { exports: {} };
Dw.exports;
(function(e, t) {
  var i = Vte, n = t && !t.nodeType && t, r = n && !0 && e && !e.nodeType && e, g = r && r.exports === n, o = g && i.process, l = function() {
    try {
      var a = r && r.require && r.require("util").types;
      return a || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(Dw, Dw.exports);
var mYt = Dw.exports, pYt = AYt, BYt = hYt, FU = mYt, xU = FU && FU.isTypedArray, fYt = xU ? BYt(xU) : pYt, Kte = fYt, ZYt = Jkt, GYt = xte, yYt = fu, WYt = Lte, SYt = Dte, VYt = Kte, wYt = Object.prototype, vYt = wYt.hasOwnProperty;
function RYt(e, t) {
  var i = yYt(e), n = !i && GYt(e), r = !i && !n && WYt(e), g = !i && !n && !r && VYt(e), o = i || n || r || g, l = o ? ZYt(e.length, String) : [], a = l.length;
  for (var I in e)
    (t || vYt.call(e, I)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (I == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (I == "offset" || I == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    g && (I == "buffer" || I == "byteLength" || I == "byteOffset") || // Skip index properties.
    SYt(I, a))) && l.push(I);
  return l;
}
var XYt = RYt, HYt = Object.prototype;
function kYt(e) {
  var t = e && e.constructor, i = typeof t == "function" && t.prototype || HYt;
  return e === i;
}
var YYt = kYt;
function FYt(e, t) {
  return function(i) {
    return e(t(i));
  };
}
var xYt = FYt, DYt = xYt, JYt = DYt(Object.keys, Object), EYt = JYt, NYt = YYt, LYt = EYt, KYt = Object.prototype, TYt = KYt.hasOwnProperty;
function MYt(e) {
  if (!NYt(e))
    return LYt(e);
  var t = [];
  for (var i in Object(e))
    TYt.call(e, i) && i != "constructor" && t.push(i);
  return t;
}
var PYt = MYt, UYt = vte, zYt = ME;
function OYt(e) {
  return e != null && zYt(e.length) && !UYt(e);
}
var QYt = OYt, jYt = XYt, qYt = PYt, _Yt = QYt;
function $Yt(e) {
  return _Yt(e) ? jYt(e) : qYt(e);
}
var UE = $Yt, eFt = xkt, tFt = UE;
function iFt(e, t) {
  return e && eFt(e, t, tFt);
}
var Tte = iFt, nFt = R1;
function rFt() {
  this.__data__ = new nFt(), this.size = 0;
}
var gFt = rFt;
function oFt(e) {
  var t = this.__data__, i = t.delete(e);
  return this.size = t.size, i;
}
var lFt = oFt;
function aFt(e) {
  return this.__data__.get(e);
}
var sFt = aFt;
function IFt(e) {
  return this.__data__.has(e);
}
var cFt = IFt, dFt = R1, uFt = LE, CFt = KE, AFt = 200;
function bFt(e, t) {
  var i = this.__data__;
  if (i instanceof dFt) {
    var n = i.__data__;
    if (!uFt || n.length < AFt - 1)
      return n.push([e, t]), this.size = ++i.size, this;
    i = this.__data__ = new CFt(n);
  }
  return i.set(e, t), this.size = i.size, this;
}
var hFt = bFt, mFt = R1, pFt = gFt, BFt = lFt, fFt = sFt, ZFt = cFt, GFt = hFt;
function Qm(e) {
  var t = this.__data__ = new mFt(e);
  this.size = t.size;
}
Qm.prototype.clear = pFt;
Qm.prototype.delete = BFt;
Qm.prototype.get = fFt;
Qm.prototype.has = ZFt;
Qm.prototype.set = GFt;
var Mte = Qm, yFt = "__lodash_hash_undefined__";
function WFt(e) {
  return this.__data__.set(e, yFt), this;
}
var SFt = WFt;
function VFt(e) {
  return this.__data__.has(e);
}
var wFt = VFt, vFt = KE, RFt = SFt, XFt = wFt;
function Jw(e) {
  var t = -1, i = e == null ? 0 : e.length;
  for (this.__data__ = new vFt(); ++t < i; )
    this.add(e[t]);
}
Jw.prototype.add = Jw.prototype.push = RFt;
Jw.prototype.has = XFt;
var HFt = Jw;
function kFt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length; ++i < n; )
    if (t(e[i], i, e))
      return !0;
  return !1;
}
var YFt = kFt;
function FFt(e, t) {
  return e.has(t);
}
var xFt = FFt, DFt = HFt, JFt = YFt, EFt = xFt, NFt = 1, LFt = 2;
function KFt(e, t, i, n, r, g) {
  var o = i & NFt, l = e.length, a = t.length;
  if (l != a && !(o && a > l))
    return !1;
  var I = g.get(e), c = g.get(t);
  if (I && c)
    return I == t && c == e;
  var d = -1, C = !0, A = i & LFt ? new DFt() : void 0;
  for (g.set(e, t), g.set(t, e); ++d < l; ) {
    var b = e[d], m = t[d];
    if (n)
      var p = o ? n(m, b, d, t, e, g) : n(b, m, d, e, t, g);
    if (p !== void 0) {
      if (p)
        continue;
      C = !1;
      break;
    }
    if (A) {
      if (!JFt(t, function(B, f) {
        if (!EFt(A, f) && (b === B || r(b, B, i, n, g)))
          return A.push(f);
      })) {
        C = !1;
        break;
      }
    } else if (!(b === m || r(b, m, i, n, g))) {
      C = !1;
      break;
    }
  }
  return g.delete(e), g.delete(t), C;
}
var Pte = KFt, TFt = Fc, MFt = TFt.Uint8Array, PFt = MFt;
function UFt(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n, r) {
    i[++t] = [r, n];
  }), i;
}
var zFt = UFt;
function OFt(e) {
  var t = -1, i = Array(e.size);
  return e.forEach(function(n) {
    i[++t] = n;
  }), i;
}
var QFt = OFt, DU = V1, JU = PFt, jFt = Xte, qFt = Pte, _Ft = zFt, $Ft = QFt, ext = 1, txt = 2, ixt = "[object Boolean]", nxt = "[object Date]", rxt = "[object Error]", gxt = "[object Map]", oxt = "[object Number]", lxt = "[object RegExp]", axt = "[object Set]", sxt = "[object String]", Ixt = "[object Symbol]", cxt = "[object ArrayBuffer]", dxt = "[object DataView]", EU = DU ? DU.prototype : void 0, kF = EU ? EU.valueOf : void 0;
function uxt(e, t, i, n, r, g, o) {
  switch (i) {
    case dxt:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case cxt:
      return !(e.byteLength != t.byteLength || !g(new JU(e), new JU(t)));
    case ixt:
    case nxt:
    case oxt:
      return jFt(+e, +t);
    case rxt:
      return e.name == t.name && e.message == t.message;
    case lxt:
    case sxt:
      return e == t + "";
    case gxt:
      var l = _Ft;
    case axt:
      var a = n & ext;
      if (l || (l = $Ft), e.size != t.size && !a)
        return !1;
      var I = o.get(e);
      if (I)
        return I == t;
      n |= txt, o.set(e, t);
      var c = qFt(l(e), l(t), n, r, g, o);
      return o.delete(e), c;
    case Ixt:
      if (kF)
        return kF.call(e) == kF.call(t);
  }
  return !1;
}
var Cxt = uxt;
function Axt(e, t) {
  for (var i = -1, n = t.length, r = e.length; ++i < n; )
    e[r + i] = t[i];
  return e;
}
var bxt = Axt, hxt = bxt, mxt = fu;
function pxt(e, t, i) {
  var n = t(e);
  return mxt(e) ? n : hxt(n, i(e));
}
var Bxt = pxt;
function fxt(e, t) {
  for (var i = -1, n = e == null ? 0 : e.length, r = 0, g = []; ++i < n; ) {
    var o = e[i];
    t(o, i, e) && (g[r++] = o);
  }
  return g;
}
var Zxt = fxt;
function Gxt() {
  return [];
}
var yxt = Gxt, Wxt = Zxt, Sxt = yxt, Vxt = Object.prototype, wxt = Vxt.propertyIsEnumerable, NU = Object.getOwnPropertySymbols, vxt = NU ? function(e) {
  return e == null ? [] : (e = Object(e), Wxt(NU(e), function(t) {
    return wxt.call(e, t);
  }));
} : Sxt, Rxt = vxt, Xxt = Bxt, Hxt = Rxt, kxt = UE;
function Yxt(e) {
  return Xxt(e, kxt, Hxt);
}
var Fxt = Yxt, LU = Fxt, xxt = 1, Dxt = Object.prototype, Jxt = Dxt.hasOwnProperty;
function Ext(e, t, i, n, r, g) {
  var o = i & xxt, l = LU(e), a = l.length, I = LU(t), c = I.length;
  if (a != c && !o)
    return !1;
  for (var d = a; d--; ) {
    var C = l[d];
    if (!(o ? C in t : Jxt.call(t, C)))
      return !1;
  }
  var A = g.get(e), b = g.get(t);
  if (A && b)
    return A == t && b == e;
  var m = !0;
  g.set(e, t), g.set(t, e);
  for (var p = o; ++d < a; ) {
    C = l[d];
    var B = e[C], f = t[C];
    if (n)
      var Z = o ? n(f, B, C, t, e, g) : n(B, f, C, e, t, g);
    if (!(Z === void 0 ? B === f || r(B, f, i, n, g) : Z)) {
      m = !1;
      break;
    }
    p || (p = C == "constructor");
  }
  if (m && !p) {
    var y = e.constructor, W = t.constructor;
    y != W && "constructor" in e && "constructor" in t && !(typeof y == "function" && y instanceof y && typeof W == "function" && W instanceof W) && (m = !1);
  }
  return g.delete(e), g.delete(t), m;
}
var Nxt = Ext, Lxt = kA, Kxt = Fc, Txt = Lxt(Kxt, "DataView"), Mxt = Txt, Pxt = kA, Uxt = Fc, zxt = Pxt(Uxt, "Promise"), Oxt = zxt, Qxt = kA, jxt = Fc, qxt = Qxt(jxt, "Set"), _xt = qxt, $xt = kA, e5t = Fc, t5t = $xt(e5t, "WeakMap"), i5t = t5t, q5 = Mxt, _5 = LE, $5 = Oxt, eD = _xt, tD = i5t, Ute = tG, jm = Rte, KU = "[object Map]", n5t = "[object Object]", TU = "[object Promise]", MU = "[object Set]", PU = "[object WeakMap]", UU = "[object DataView]", r5t = jm(q5), g5t = jm(_5), o5t = jm($5), l5t = jm(eD), a5t = jm(tD), SC = Ute;
(q5 && SC(new q5(new ArrayBuffer(1))) != UU || _5 && SC(new _5()) != KU || $5 && SC($5.resolve()) != TU || eD && SC(new eD()) != MU || tD && SC(new tD()) != PU) && (SC = function(e) {
  var t = Ute(e), i = t == n5t ? e.constructor : void 0, n = i ? jm(i) : "";
  if (n)
    switch (n) {
      case r5t:
        return UU;
      case g5t:
        return KU;
      case o5t:
        return TU;
      case l5t:
        return MU;
      case a5t:
        return PU;
    }
  return t;
});
var s5t = SC, YF = Mte, I5t = Pte, c5t = Cxt, d5t = Nxt, zU = s5t, OU = fu, QU = Lte, u5t = Kte, C5t = 1, jU = "[object Arguments]", qU = "[object Array]", NS = "[object Object]", A5t = Object.prototype, _U = A5t.hasOwnProperty;
function b5t(e, t, i, n, r, g) {
  var o = OU(e), l = OU(t), a = o ? qU : zU(e), I = l ? qU : zU(t);
  a = a == jU ? NS : a, I = I == jU ? NS : I;
  var c = a == NS, d = I == NS, C = a == I;
  if (C && QU(e)) {
    if (!QU(t))
      return !1;
    o = !0, c = !1;
  }
  if (C && !c)
    return g || (g = new YF()), o || u5t(e) ? I5t(e, t, i, n, r, g) : c5t(e, t, a, i, n, r, g);
  if (!(i & C5t)) {
    var A = c && _U.call(e, "__wrapped__"), b = d && _U.call(t, "__wrapped__");
    if (A || b) {
      var m = A ? e.value() : e, p = b ? t.value() : t;
      return g || (g = new YF()), r(m, p, i, n, g);
    }
  }
  return C ? (g || (g = new YF()), d5t(e, t, i, n, r, g)) : !1;
}
var h5t = b5t, m5t = h5t, $U = iG;
function zte(e, t, i, n, r) {
  return e === t ? !0 : e == null || t == null || !$U(e) && !$U(t) ? e !== e && t !== t : m5t(e, t, i, n, zte, r);
}
var Ote = zte, p5t = Mte, B5t = Ote, f5t = 1, Z5t = 2;
function G5t(e, t, i, n) {
  var r = i.length, g = r, o = !n;
  if (e == null)
    return !g;
  for (e = Object(e); r--; ) {
    var l = i[r];
    if (o && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++r < g; ) {
    l = i[r];
    var a = l[0], I = e[a], c = l[1];
    if (o && l[2]) {
      if (I === void 0 && !(a in e))
        return !1;
    } else {
      var d = new p5t();
      if (n)
        var C = n(I, c, a, e, t, d);
      if (!(C === void 0 ? B5t(c, I, f5t | Z5t, n, d) : C))
        return !1;
    }
  }
  return !0;
}
var y5t = G5t, W5t = NE;
function S5t(e) {
  return e === e && !W5t(e);
}
var Qte = S5t, V5t = Qte, w5t = UE;
function v5t(e) {
  for (var t = w5t(e), i = t.length; i--; ) {
    var n = t[i], r = e[n];
    t[i] = [n, r, V5t(r)];
  }
  return t;
}
var R5t = v5t;
function X5t(e, t) {
  return function(i) {
    return i == null ? !1 : i[e] === t && (t !== void 0 || e in Object(i));
  };
}
var jte = X5t, H5t = y5t, k5t = R5t, Y5t = jte;
function F5t(e) {
  var t = k5t(e);
  return t.length == 1 && t[0][2] ? Y5t(t[0][0], t[0][1]) : function(i) {
    return i === e || H5t(i, e, t);
  };
}
var x5t = F5t, D5t = Yte, J5t = H1;
function E5t(e, t) {
  t = D5t(t, e);
  for (var i = 0, n = t.length; e != null && i < n; )
    e = e[J5t(t[i++])];
  return i && i == n ? e : void 0;
}
var qte = E5t, N5t = qte;
function L5t(e, t, i) {
  var n = e == null ? void 0 : N5t(e, t);
  return n === void 0 ? i : n;
}
var K5t = L5t;
function T5t(e, t) {
  return e != null && t in Object(e);
}
var M5t = T5t, P5t = M5t, U5t = Jte;
function z5t(e, t) {
  return e != null && U5t(e, t, P5t);
}
var O5t = z5t, Q5t = Ote, j5t = K5t, q5t = O5t, _5t = EE, $5t = Qte, eDt = jte, tDt = H1, iDt = 1, nDt = 2;
function rDt(e, t) {
  return _5t(e) && $5t(t) ? eDt(tDt(e), t) : function(i) {
    var n = j5t(i, e);
    return n === void 0 && n === t ? q5t(i, e) : Q5t(t, n, iDt | nDt);
  };
}
var gDt = rDt;
function oDt(e) {
  return e;
}
var lDt = oDt;
function aDt(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var sDt = aDt, IDt = qte;
function cDt(e) {
  return function(t) {
    return IDt(t, e);
  };
}
var dDt = cDt, uDt = sDt, CDt = dDt, ADt = EE, bDt = H1;
function hDt(e) {
  return ADt(e) ? uDt(bDt(e)) : CDt(e);
}
var mDt = hDt, pDt = x5t, BDt = gDt, fDt = lDt, ZDt = fu, GDt = mDt;
function yDt(e) {
  return typeof e == "function" ? e : e == null ? fDt : typeof e == "object" ? ZDt(e) ? BDt(e[0], e[1]) : pDt(e) : GDt(e);
}
var _te = yDt, WDt = Nte, SDt = Tte, VDt = _te;
function wDt(e, t) {
  var i = {};
  return t = VDt(t), SDt(e, function(n, r, g) {
    WDt(i, r, t(n, r, g));
  }), i;
}
var vDt = wDt;
const $te = /* @__PURE__ */ go(vDt);
function YA(e) {
  this._maxSize = e, this.clear();
}
YA.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
YA.prototype.get = function(e) {
  return this._values[e];
};
YA.prototype.set = function(e, t) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
};
var RDt = /[^.^\]^[]+|(?=\[\]|\.\.)/g, eie = /^\d+$/, XDt = /^\d/, HDt = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, kDt = /^\s*(['"]?)(.*?)(\1)\s*$/, zE = 512, ez = new YA(zE), tz = new YA(zE), iz = new YA(zE), k1 = {
  Cache: YA,
  split: iD,
  normalizePath: FF,
  setter: function(e) {
    var t = FF(e);
    return tz.get(e) || tz.set(e, function(n, r) {
      for (var g = 0, o = t.length, l = n; g < o - 1; ) {
        var a = t[g];
        if (a === "__proto__" || a === "constructor" || a === "prototype")
          return n;
        l = l[t[g++]];
      }
      l[t[g]] = r;
    });
  },
  getter: function(e, t) {
    var i = FF(e);
    return iz.get(e) || iz.set(e, function(r) {
      for (var g = 0, o = i.length; g < o; )
        if (r != null || !t)
          r = r[i[g++]];
        else
          return;
      return r;
    });
  },
  join: function(e) {
    return e.reduce(function(t, i) {
      return t + (OE(i) || eie.test(i) ? "[" + i + "]" : (t ? "." : "") + i);
    }, "");
  },
  forEach: function(e, t, i) {
    YDt(Array.isArray(e) ? e : iD(e), t, i);
  }
};
function FF(e) {
  return ez.get(e) || ez.set(
    e,
    iD(e).map(function(t) {
      return t.replace(kDt, "$2");
    })
  );
}
function iD(e) {
  return e.match(RDt) || [""];
}
function YDt(e, t, i) {
  var n = e.length, r, g, o, l;
  for (g = 0; g < n; g++)
    r = e[g], r && (DDt(r) && (r = '"' + r + '"'), l = OE(r), o = !l && /^\d+$/.test(r), t.call(i, r, l, o, g, e));
}
function OE(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function FDt(e) {
  return e.match(XDt) && !e.match(eie);
}
function xDt(e) {
  return HDt.test(e);
}
function DDt(e) {
  return !OE(e) && (FDt(e) || xDt(e));
}
const LS = {
  context: "$",
  value: "."
};
class Td {
  constructor(t, i = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string")
      throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === LS.context, this.isValue = this.key[0] === LS.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? LS.context : this.isValue ? LS.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && k1.getter(this.path, !0), this.map = i.map;
  }
  getValue(t, i, n) {
    let r = this.isContext ? n : this.isValue ? t : i;
    return this.getter && (r = this.getter(r || {})), this.map && (r = this.map(r)), r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, i) {
    return this.getValue(t, i == null ? void 0 : i.parent, i == null ? void 0 : i.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Td.prototype.__isYupRef = !0;
function Ew() {
  return Ew = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Ew.apply(this, arguments);
}
function JDt(e, t) {
  if (e == null)
    return {};
  var i = {}, n = Object.keys(e), r, g;
  for (g = 0; g < n.length; g++)
    r = n[g], !(t.indexOf(r) >= 0) && (i[r] = e[r]);
  return i;
}
function KS(e) {
  function t(i, n) {
    let {
      value: r,
      path: g = "",
      label: o,
      options: l,
      originalValue: a,
      sync: I
    } = i, c = JDt(i, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: d,
      test: C,
      params: A,
      message: b
    } = e;
    let {
      parent: m,
      context: p
    } = l;
    function B(V) {
      return Td.isRef(V) ? V.getValue(r, m, p) : V;
    }
    function f(V = {}) {
      const w = $te(Ew({
        value: r,
        originalValue: a,
        label: o,
        path: V.path || g
      }, A, V.params), B), v = new rl(rl.formatError(V.message || b, w), r, w.path, V.type || d);
      return v.params = w, v;
    }
    let Z = Ew({
      path: g,
      parent: m,
      type: d,
      createError: f,
      resolve: B,
      options: l,
      originalValue: a
    }, c);
    if (!I) {
      try {
        Promise.resolve(C.call(Z, r, Z)).then((V) => {
          rl.isError(V) ? n(V) : V ? n(null, V) : n(f());
        }).catch(n);
      } catch (V) {
        n(V);
      }
      return;
    }
    let y;
    try {
      var W;
      if (y = C.call(Z, r, Z), typeof ((W = y) == null ? void 0 : W.then) == "function")
        throw new Error(`Validation test of type: "${Z.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (V) {
      n(V);
      return;
    }
    rl.isError(y) ? n(y) : y ? n(null, y) : n(f());
  }
  return t.OPTIONS = e, t;
}
let EDt = (e) => e.substr(0, e.length - 1).substr(1);
function NDt(e, t, i, n = i) {
  let r, g, o;
  return t ? (k1.forEach(t, (l, a, I) => {
    let c = a ? EDt(l) : l;
    if (e = e.resolve({
      context: n,
      parent: r,
      value: i
    }), e.innerType) {
      let d = I ? parseInt(c, 10) : 0;
      if (i && d >= i.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${l}, in the path: ${t}. because there is no value at that index. `);
      r = i, i = i && i[d], e = e.innerType;
    }
    if (!I) {
      if (!e.fields || !e.fields[c])
        throw new Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e._type}")`);
      r = i, i = i && i[c], e = e.fields[c];
    }
    g = c, o = a ? "[" + l + "]" : "." + l;
  }), {
    schema: e,
    parent: r,
    parentPath: g
  }) : {
    parent: r,
    parentPath: t,
    schema: e
  };
}
class Nw {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const i of this.list)
      t.push(i);
    for (const [, i] of this.refs)
      t.push(i.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((i, n) => i.concat(Td.isRef(n) ? t(n) : n), []);
  }
  add(t) {
    Td.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Td.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new Nw();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, i) {
    const n = this.clone();
    return t.list.forEach((r) => n.add(r)), t.refs.forEach((r) => n.add(r)), i.list.forEach((r) => n.delete(r)), i.refs.forEach((r) => n.delete(r)), n;
  }
}
function pa() {
  return pa = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, pa.apply(this, arguments);
}
class Ro {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new Nw(), this._blacklist = new Nw(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(WC.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = pa({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const i = Object.create(Object.getPrototypeOf(this));
    return i.type = this.type, i._typeError = this._typeError, i._whitelistError = this._whitelistError, i._blacklistError = this._blacklistError, i._whitelist = this._whitelist.clone(), i._blacklist = this._blacklist.clone(), i.exclusiveTests = pa({}, this.exclusiveTests), i.deps = [...this.deps], i.conditions = [...this.conditions], i.tests = [...this.tests], i.transforms = [...this.transforms], i.spec = z5(pa({}, this.spec, t)), i;
  }
  label(t) {
    let i = this.clone();
    return i.spec.label = t, i;
  }
  meta(...t) {
    if (t.length === 0)
      return this.spec.meta;
    let i = this.clone();
    return i.spec.meta = Object.assign(i.spec.meta || {}, t[0]), i;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let i = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = i, n;
  }
  concat(t) {
    if (!t || t === this)
      return this;
    if (t.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let i = this, n = t.clone();
    const r = pa({}, i.spec, n.spec);
    return n.spec = r, n._typeError || (n._typeError = i._typeError), n._whitelistError || (n._whitelistError = i._whitelistError), n._blacklistError || (n._blacklistError = i._blacklistError), n._whitelist = i._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = i._blacklist.merge(t._blacklist, t._whitelist), n.tests = i.tests, n.exclusiveTests = i.exclusiveTests, n.withMutation((g) => {
      t.tests.forEach((o) => {
        g.test(o.OPTIONS);
      });
    }), n.transforms = [...i.transforms, ...n.transforms], n;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let i = this;
    if (i.conditions.length) {
      let n = i.conditions;
      i = i.clone(), i.conditions = [], i = n.reduce((r, g) => g.resolve(r, t), i), i = i.resolve(t);
    }
    return i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, i = {}) {
    let n = this.resolve(pa({
      value: t
    }, i)), r = n._cast(t, i);
    if (t !== void 0 && i.assert !== !1 && n.isType(r) !== !0) {
      let g = um(t), o = um(r);
      throw new TypeError(`The value of ${i.path || "field"} could not be cast to a value that satisfies the schema type: "${n._type}". 

attempted value: ${g} 
` + (o !== g ? `result of cast: ${o}` : ""));
    }
    return r;
  }
  _cast(t, i) {
    let n = t === void 0 ? t : this.transforms.reduce((r, g) => g.call(this, r, t, this), t);
    return n === void 0 && (n = this.getDefault()), n;
  }
  _validate(t, i = {}, n) {
    let {
      sync: r,
      path: g,
      from: o = [],
      originalValue: l = t,
      strict: a = this.spec.strict,
      abortEarly: I = this.spec.abortEarly
    } = i, c = t;
    a || (c = this._cast(c, pa({
      assert: !1
    }, i)));
    let d = {
      value: c,
      path: g,
      options: i,
      originalValue: l,
      schema: this,
      label: this.spec.label,
      sync: r,
      from: o
    }, C = [];
    this._typeError && C.push(this._typeError);
    let A = [];
    this._whitelistError && A.push(this._whitelistError), this._blacklistError && A.push(this._blacklistError), Fw({
      args: d,
      value: c,
      path: g,
      sync: r,
      tests: C,
      endEarly: I
    }, (b) => {
      if (b)
        return void n(b, c);
      Fw({
        tests: this.tests.concat(A),
        args: d,
        path: g,
        sync: r,
        value: c,
        endEarly: I
      }, n);
    });
  }
  validate(t, i, n) {
    let r = this.resolve(pa({}, i, {
      value: t
    }));
    return typeof n == "function" ? r._validate(t, i, n) : new Promise((g, o) => r._validate(t, i, (l, a) => {
      l ? o(l) : g(a);
    }));
  }
  validateSync(t, i) {
    let n = this.resolve(pa({}, i, {
      value: t
    })), r;
    return n._validate(t, pa({}, i, {
      sync: !0
    }), (g, o) => {
      if (g)
        throw g;
      r = o;
    }), r;
  }
  isValid(t, i) {
    return this.validate(t, i).then(() => !0, (n) => {
      if (rl.isError(n))
        return !1;
      throw n;
    });
  }
  isValidSync(t, i) {
    try {
      return this.validateSync(t, i), !0;
    } catch (n) {
      if (rl.isError(n))
        return !1;
      throw n;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : z5(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let i = this.clone();
    return i.spec.strict = t, i;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = WC.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(i) {
        return i !== void 0;
      }
    });
  }
  required(t = WC.required) {
    return this.clone({
      presence: "required"
    }).withMutation((i) => i.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(n) {
        return this.schema._isPresent(n);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((i) => i.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let i = this.clone();
    return i.transforms.push(t), i;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let i;
    if (t.length === 1 ? typeof t[0] == "function" ? i = {
      test: t[0]
    } : i = t[0] : t.length === 2 ? i = {
      name: t[0],
      test: t[1]
    } : i = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, i.message === void 0 && (i.message = WC.default), typeof i.test != "function")
      throw new TypeError("`test` is a required parameters");
    let n = this.clone(), r = KS(i), g = i.exclusive || i.name && n.exclusiveTests[i.name] === !0;
    if (i.exclusive && !i.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return i.name && (n.exclusiveTests[i.name] = !!i.exclusive), n.tests = n.tests.filter((o) => !(o.OPTIONS.name === i.name && (g || o.OPTIONS.test === r.OPTIONS.test))), n.tests.push(r), n;
  }
  when(t, i) {
    !Array.isArray(t) && typeof t != "string" && (i = t, t = ".");
    let n = this.clone(), r = Ete(t).map((g) => new Td(g));
    return r.forEach((g) => {
      g.isSibling && n.deps.push(g.key);
    }), n.conditions.push(new Wkt(r, i)), n;
  }
  typeError(t) {
    let i = this.clone();
    return i._typeError = KS({
      message: t,
      name: "typeError",
      test(n) {
        return n !== void 0 && !this.schema.isType(n) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), i;
  }
  oneOf(t, i = WC.oneOf) {
    let n = this.clone();
    return t.forEach((r) => {
      n._whitelist.add(r), n._blacklist.delete(r);
    }), n._whitelistError = KS({
      message: i,
      name: "oneOf",
      test(r) {
        if (r === void 0)
          return !0;
        let g = this.schema._whitelist, o = g.resolveAll(this.resolve);
        return o.includes(r) ? !0 : this.createError({
          params: {
            values: g.toArray().join(", "),
            resolved: o
          }
        });
      }
    }), n;
  }
  notOneOf(t, i = WC.notOneOf) {
    let n = this.clone();
    return t.forEach((r) => {
      n._blacklist.add(r), n._whitelist.delete(r);
    }), n._blacklistError = KS({
      message: i,
      name: "notOneOf",
      test(r) {
        let g = this.schema._blacklist, o = g.resolveAll(this.resolve);
        return o.includes(r) ? this.createError({
          params: {
            values: g.toArray().join(", "),
            resolved: o
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let i = this.clone();
    return i.spec.strip = t, i;
  }
  describe() {
    const t = this.clone(), {
      label: i,
      meta: n
    } = t.spec;
    return {
      meta: n,
      label: i,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((g) => ({
        name: g.OPTIONS.name,
        params: g.OPTIONS.params
      })).filter((g, o, l) => l.findIndex((a) => a.name === g.name) === o)
    };
  }
}
Ro.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  Ro.prototype[`${e}At`] = function(t, i, n = {}) {
    const {
      parent: r,
      parentPath: g,
      schema: o
    } = NDt(this, t, i, n.context);
    return o[e](r && r[g], pa({}, n, {
      parent: r,
      path: t
    }));
  };
for (const e of ["equals", "is"])
  Ro.prototype[e] = Ro.prototype.oneOf;
for (const e of ["not", "nope"])
  Ro.prototype[e] = Ro.prototype.notOneOf;
Ro.prototype.optional = Ro.prototype.notRequired;
const LDt = Ro;
LDt.prototype;
const el = (e) => e == null;
let KDt = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, TDt = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, MDt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, PDt = (e) => el(e) || e === e.trim(), UDt = {}.toString();
function Wl() {
  return new tie();
}
class tie extends Ro {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t))
          return t;
        const i = t != null && t.toString ? t.toString() : t;
        return i === UDt ? t : i;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, i = Zs.length) {
    return this.test({
      message: i,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(n) {
        return el(n) || n.length === this.resolve(t);
      }
    });
  }
  min(t, i = Zs.min) {
    return this.test({
      message: i,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(n) {
        return el(n) || n.length >= this.resolve(t);
      }
    });
  }
  max(t, i = Zs.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: i,
      params: {
        max: t
      },
      test(n) {
        return el(n) || n.length <= this.resolve(t);
      }
    });
  }
  matches(t, i) {
    let n = !1, r, g;
    return i && (typeof i == "object" ? {
      excludeEmptyString: n = !1,
      message: r,
      name: g
    } = i : r = i), this.test({
      name: g || "matches",
      message: r || Zs.matches,
      params: {
        regex: t
      },
      test: (o) => el(o) || o === "" && n || o.search(t) !== -1
    });
  }
  email(t = Zs.email) {
    return this.matches(KDt, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Zs.url) {
    return this.matches(TDt, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Zs.uuid) {
    return this.matches(MDt, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Zs.trim) {
    return this.transform((i) => i != null ? i.trim() : i).test({
      message: t,
      name: "trim",
      test: PDt
    });
  }
  lowercase(t = Zs.lowercase) {
    return this.transform((i) => el(i) ? i : i.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (i) => el(i) || i === i.toLowerCase()
    });
  }
  uppercase(t = Zs.uppercase) {
    return this.transform((i) => el(i) ? i : i.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (i) => el(i) || i === i.toUpperCase()
    });
  }
}
Wl.prototype = tie.prototype;
var zDt = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function ODt(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], i = 0, n, r;
  if (r = zDt.exec(e)) {
    for (var g = 0, o; o = t[g]; ++g)
      r[o] = +r[o] || 0;
    r[2] = (+r[2] || 1) - 1, r[3] = +r[3] || 1, r[7] = r[7] ? String(r[7]).substr(0, 3) : 0, (r[8] === void 0 || r[8] === "") && (r[9] === void 0 || r[9] === "") ? n = +new Date(r[1], r[2], r[3], r[4], r[5], r[6], r[7]) : (r[8] !== "Z" && r[9] !== void 0 && (i = r[10] * 60 + r[11], r[9] === "+" && (i = 0 - i)), n = Date.UTC(r[1], r[2], r[3], r[4], r[5] + i, r[6], r[7]));
  } else
    n = Date.parse ? Date.parse(e) : NaN;
  return n;
}
let iie = /* @__PURE__ */ new Date(""), QDt = (e) => Object.prototype.toString.call(e) === "[object Date]";
class nie extends Ro {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = ODt(t), isNaN(t) ? iie : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return QDt(t) && !isNaN(t.getTime());
  }
  prepareParam(t, i) {
    let n;
    if (Td.isRef(t))
      n = t;
    else {
      let r = this.cast(t);
      if (!this._typeCheck(r))
        throw new TypeError(`\`${i}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = r;
    }
    return n;
  }
  min(t, i = O5.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: i,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(r) {
        return el(r) || r >= this.resolve(n);
      }
    });
  }
  max(t, i = O5.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: i,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(r) {
        return el(r) || r <= this.resolve(n);
      }
    });
  }
}
nie.INVALID_DATE = iie;
nie.prototype;
function jDt(e, t, i, n) {
  var r = -1, g = e == null ? 0 : e.length;
  for (n && g && (i = e[++r]); ++r < g; )
    i = t(i, e[r], r, e);
  return i;
}
var qDt = jDt;
function _Dt(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var $Dt = _Dt, eJt = $Dt, tJt = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, iJt = eJt(tJt), nJt = iJt, rJt = nJt, gJt = nG, oJt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, lJt = "\\u0300-\\u036f", aJt = "\\ufe20-\\ufe2f", sJt = "\\u20d0-\\u20ff", IJt = lJt + aJt + sJt, cJt = "[" + IJt + "]", dJt = RegExp(cJt, "g");
function uJt(e) {
  return e = gJt(e), e && e.replace(oJt, rJt).replace(dJt, "");
}
var CJt = uJt, AJt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function bJt(e) {
  return e.match(AJt) || [];
}
var hJt = bJt, mJt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function pJt(e) {
  return mJt.test(e);
}
var BJt = pJt, rie = "\\ud800-\\udfff", fJt = "\\u0300-\\u036f", ZJt = "\\ufe20-\\ufe2f", GJt = "\\u20d0-\\u20ff", yJt = fJt + ZJt + GJt, gie = "\\u2700-\\u27bf", oie = "a-z\\xdf-\\xf6\\xf8-\\xff", WJt = "\\xac\\xb1\\xd7\\xf7", SJt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", VJt = "\\u2000-\\u206f", wJt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", lie = "A-Z\\xc0-\\xd6\\xd8-\\xde", vJt = "\\ufe0e\\ufe0f", aie = WJt + SJt + VJt + wJt, sie = "['’]", nz = "[" + aie + "]", RJt = "[" + yJt + "]", Iie = "\\d+", XJt = "[" + gie + "]", cie = "[" + oie + "]", die = "[^" + rie + aie + Iie + gie + oie + lie + "]", HJt = "\\ud83c[\\udffb-\\udfff]", kJt = "(?:" + RJt + "|" + HJt + ")", YJt = "[^" + rie + "]", uie = "(?:\\ud83c[\\udde6-\\uddff]){2}", Cie = "[\\ud800-\\udbff][\\udc00-\\udfff]", Fh = "[" + lie + "]", FJt = "\\u200d", rz = "(?:" + cie + "|" + die + ")", xJt = "(?:" + Fh + "|" + die + ")", gz = "(?:" + sie + "(?:d|ll|m|re|s|t|ve))?", oz = "(?:" + sie + "(?:D|LL|M|RE|S|T|VE))?", Aie = kJt + "?", bie = "[" + vJt + "]?", DJt = "(?:" + FJt + "(?:" + [YJt, uie, Cie].join("|") + ")" + bie + Aie + ")*", JJt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", EJt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", NJt = bie + Aie + DJt, LJt = "(?:" + [XJt, uie, Cie].join("|") + ")" + NJt, KJt = RegExp([
  Fh + "?" + cie + "+" + gz + "(?=" + [nz, Fh, "$"].join("|") + ")",
  xJt + "+" + oz + "(?=" + [nz, Fh + rz, "$"].join("|") + ")",
  Fh + "?" + rz + "+" + gz,
  Fh + "+" + oz,
  EJt,
  JJt,
  Iie,
  LJt
].join("|"), "g");
function TJt(e) {
  return e.match(KJt) || [];
}
var MJt = TJt, PJt = hJt, UJt = BJt, zJt = nG, OJt = MJt;
function QJt(e, t, i) {
  return e = zJt(e), t = i ? void 0 : t, t === void 0 ? UJt(e) ? OJt(e) : PJt(e) : e.match(t) || [];
}
var jJt = QJt, qJt = qDt, _Jt = CJt, $Jt = jJt, e9t = "['’]", t9t = RegExp(e9t, "g");
function i9t(e) {
  return function(t) {
    return qJt($Jt(_Jt(t).replace(t9t, "")), e, "");
  };
}
var hie = i9t, n9t = hie, r9t = n9t(function(e, t, i) {
  return e + (i ? "_" : "") + t.toLowerCase();
}), g9t = r9t;
const lz = /* @__PURE__ */ go(g9t);
function o9t(e, t, i) {
  var n = -1, r = e.length;
  t < 0 && (t = -t > r ? 0 : r + t), i = i > r ? r : i, i < 0 && (i += r), r = t > i ? 0 : i - t >>> 0, t >>>= 0;
  for (var g = Array(r); ++n < r; )
    g[n] = e[n + t];
  return g;
}
var l9t = o9t, a9t = l9t;
function s9t(e, t, i) {
  var n = e.length;
  return i = i === void 0 ? n : i, !t && i >= n ? e : a9t(e, t, i);
}
var I9t = s9t, c9t = "\\ud800-\\udfff", d9t = "\\u0300-\\u036f", u9t = "\\ufe20-\\ufe2f", C9t = "\\u20d0-\\u20ff", A9t = d9t + u9t + C9t, b9t = "\\ufe0e\\ufe0f", h9t = "\\u200d", m9t = RegExp("[" + h9t + c9t + A9t + b9t + "]");
function p9t(e) {
  return m9t.test(e);
}
var mie = p9t;
function B9t(e) {
  return e.split("");
}
var f9t = B9t, pie = "\\ud800-\\udfff", Z9t = "\\u0300-\\u036f", G9t = "\\ufe20-\\ufe2f", y9t = "\\u20d0-\\u20ff", W9t = Z9t + G9t + y9t, S9t = "\\ufe0e\\ufe0f", V9t = "[" + pie + "]", nD = "[" + W9t + "]", rD = "\\ud83c[\\udffb-\\udfff]", w9t = "(?:" + nD + "|" + rD + ")", Bie = "[^" + pie + "]", fie = "(?:\\ud83c[\\udde6-\\uddff]){2}", Zie = "[\\ud800-\\udbff][\\udc00-\\udfff]", v9t = "\\u200d", Gie = w9t + "?", yie = "[" + S9t + "]?", R9t = "(?:" + v9t + "(?:" + [Bie, fie, Zie].join("|") + ")" + yie + Gie + ")*", X9t = yie + Gie + R9t, H9t = "(?:" + [Bie + nD + "?", nD, fie, Zie, V9t].join("|") + ")", k9t = RegExp(rD + "(?=" + rD + ")|" + H9t + X9t, "g");
function Y9t(e) {
  return e.match(k9t) || [];
}
var F9t = Y9t, x9t = f9t, D9t = mie, J9t = F9t;
function E9t(e) {
  return D9t(e) ? J9t(e) : x9t(e);
}
var N9t = E9t, L9t = I9t, K9t = mie, T9t = N9t, M9t = nG;
function P9t(e) {
  return function(t) {
    t = M9t(t);
    var i = K9t(t) ? T9t(t) : void 0, n = i ? i[0] : t.charAt(0), r = i ? L9t(i, 1).join("") : t.slice(1);
    return n[e]() + r;
  };
}
var U9t = P9t, z9t = U9t, O9t = z9t("toUpperCase"), Q9t = O9t, j9t = nG, q9t = Q9t;
function _9t(e) {
  return q9t(j9t(e).toLowerCase());
}
var $9t = _9t, eEt = $9t, tEt = hie, iEt = tEt(function(e, t, i) {
  return t = t.toLowerCase(), e + (i ? eEt(t) : t);
}), nEt = iEt;
const rEt = /* @__PURE__ */ go(nEt);
var gEt = Nte, oEt = Tte, lEt = _te;
function aEt(e, t) {
  var i = {};
  return t = lEt(t), oEt(e, function(n, r, g) {
    gEt(i, t(n, r, g), n);
  }), i;
}
var sEt = aEt;
const IEt = /* @__PURE__ */ go(sEt);
var QE = { exports: {} };
QE.exports = function(e) {
  return Wie(cEt(e), e);
};
QE.exports.array = Wie;
function Wie(e, t) {
  var i = e.length, n = new Array(i), r = {}, g = i, o = dEt(t), l = uEt(e);
  for (t.forEach(function(I) {
    if (!l.has(I[0]) || !l.has(I[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); g--; )
    r[g] || a(e[g], g, /* @__PURE__ */ new Set());
  return n;
  function a(I, c, d) {
    if (d.has(I)) {
      var C;
      try {
        C = ", node was:" + JSON.stringify(I);
      } catch {
        C = "";
      }
      throw new Error("Cyclic dependency" + C);
    }
    if (!l.has(I))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(I));
    if (!r[c]) {
      r[c] = !0;
      var A = o.get(I) || /* @__PURE__ */ new Set();
      if (A = Array.from(A), c = A.length) {
        d.add(I);
        do {
          var b = A[--c];
          a(b, l.get(b), d);
        } while (c);
        d.delete(I);
      }
      n[--i] = I;
    }
  }
}
function cEt(e) {
  for (var t = /* @__PURE__ */ new Set(), i = 0, n = e.length; i < n; i++) {
    var r = e[i];
    t.add(r[0]), t.add(r[1]);
  }
  return Array.from(t);
}
function dEt(e) {
  for (var t = /* @__PURE__ */ new Map(), i = 0, n = e.length; i < n; i++) {
    var r = e[i];
    t.has(r[0]) || t.set(r[0], /* @__PURE__ */ new Set()), t.has(r[1]) || t.set(r[1], /* @__PURE__ */ new Set()), t.get(r[0]).add(r[1]);
  }
  return t;
}
function uEt(e) {
  for (var t = /* @__PURE__ */ new Map(), i = 0, n = e.length; i < n; i++)
    t.set(e[i], i);
  return t;
}
var CEt = QE.exports;
const AEt = /* @__PURE__ */ go(CEt);
function bEt(e, t = []) {
  let i = [], n = /* @__PURE__ */ new Set(), r = new Set(t.map(([o, l]) => `${o}-${l}`));
  function g(o, l) {
    let a = k1.split(o)[0];
    n.add(a), r.has(`${l}-${a}`) || i.push([l, a]);
  }
  for (const o in e)
    if (Yw(e, o)) {
      let l = e[o];
      n.add(o), Td.isRef(l) && l.isSibling ? g(l.path, o) : PE(l) && "deps" in l && l.deps.forEach((a) => g(a, o));
    }
  return AEt.array(Array.from(n), i).reverse();
}
function az(e, t) {
  let i = 1 / 0;
  return e.some((n, r) => {
    var g;
    if (((g = t.path) == null ? void 0 : g.indexOf(n)) !== -1)
      return i = r, !0;
  }), i;
}
function Sie(e) {
  return (t, i) => az(e, t) - az(e, i);
}
function Kh() {
  return Kh = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Kh.apply(this, arguments);
}
let sz = (e) => Object.prototype.toString.call(e) === "[object Object]";
function hEt(e, t) {
  let i = Object.keys(e.fields);
  return Object.keys(t).filter((n) => i.indexOf(n) === -1);
}
const mEt = Sie([]);
class Vie extends Ro {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = mEt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(n) {
        if (typeof n == "string")
          try {
            n = JSON.parse(n);
          } catch {
            n = null;
          }
        return this.isType(n) ? n : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return sz(t) || typeof t == "function";
  }
  _cast(t, i = {}) {
    var n;
    let r = super._cast(t, i);
    if (r === void 0)
      return this.getDefault();
    if (!this._typeCheck(r))
      return r;
    let g = this.fields, o = (n = i.stripUnknown) != null ? n : this.spec.noUnknown, l = this._nodes.concat(Object.keys(r).filter((d) => this._nodes.indexOf(d) === -1)), a = {}, I = Kh({}, i, {
      parent: a,
      __validating: i.__validating || !1
    }), c = !1;
    for (const d of l) {
      let C = g[d], A = Yw(r, d);
      if (C) {
        let b, m = r[d];
        I.path = (i.path ? `${i.path}.` : "") + d, C = C.resolve({
          value: m,
          context: i.context,
          parent: a
        });
        let p = "spec" in C ? C.spec : void 0, B = p == null ? void 0 : p.strict;
        if (p != null && p.strip) {
          c = c || d in r;
          continue;
        }
        b = !i.__validating || !B ? (
          // TODO: use _cast, this is double resolving
          C.cast(r[d], I)
        ) : r[d], b !== void 0 && (a[d] = b);
      } else
        A && !o && (a[d] = r[d]);
      a[d] !== r[d] && (c = !0);
    }
    return c ? a : r;
  }
  _validate(t, i = {}, n) {
    let r = [], {
      sync: g,
      from: o = [],
      originalValue: l = t,
      abortEarly: a = this.spec.abortEarly,
      recursive: I = this.spec.recursive
    } = i;
    o = [{
      schema: this,
      value: l
    }, ...o], i.__validating = !0, i.originalValue = l, i.from = o, super._validate(t, i, (c, d) => {
      if (c) {
        if (!rl.isError(c) || a)
          return void n(c, d);
        r.push(c);
      }
      if (!I || !sz(d)) {
        n(r[0] || null, d);
        return;
      }
      l = l || d;
      let C = this._nodes.map((A) => (b, m) => {
        let p = A.indexOf(".") === -1 ? (i.path ? `${i.path}.` : "") + A : `${i.path || ""}["${A}"]`, B = this.fields[A];
        if (B && "validate" in B) {
          B.validate(d[A], Kh({}, i, {
            // @ts-ignore
            path: p,
            from: o,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: d,
            originalValue: l[A]
          }), m);
          return;
        }
        m(null);
      });
      Fw({
        sync: g,
        tests: C,
        value: d,
        errors: r,
        endEarly: a,
        sort: this._sortErrors,
        path: i.path
      }, n);
    });
  }
  clone(t) {
    const i = super.clone(t);
    return i.fields = Kh({}, this.fields), i._nodes = this._nodes, i._excludedEdges = this._excludedEdges, i._sortErrors = this._sortErrors, i;
  }
  concat(t) {
    let i = super.concat(t), n = i.fields;
    for (let [r, g] of Object.entries(this.fields)) {
      const o = n[r];
      o === void 0 ? n[r] = g : o instanceof Ro && g instanceof Ro && (n[r] = g.concat(o));
    }
    return i.withMutation(() => i.shape(n, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((i) => {
      const n = this.fields[i];
      t[i] = "default" in n ? n.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, i = []) {
    let n = this.clone(), r = Object.assign(n.fields, t);
    return n.fields = r, n._sortErrors = Sie(Object.keys(r)), i.length && (Array.isArray(i[0]) || (i = [i]), n._excludedEdges = [...n._excludedEdges, ...i]), n._nodes = bEt(r, n._excludedEdges), n;
  }
  pick(t) {
    const i = {};
    for (const n of t)
      this.fields[n] && (i[n] = this.fields[n]);
    return this.clone().withMutation((n) => (n.fields = {}, n.shape(i)));
  }
  omit(t) {
    const i = this.clone(), n = i.fields;
    i.fields = {};
    for (const r of t)
      delete n[r];
    return i.withMutation(() => i.shape(n));
  }
  from(t, i, n) {
    let r = k1.getter(t, !0);
    return this.transform((g) => {
      if (g == null)
        return g;
      let o = g;
      return Yw(g, t) && (o = Kh({}, g), n || delete o[t], o[i] = r(g)), o;
    });
  }
  noUnknown(t = !0, i = Q5.noUnknown) {
    typeof t == "string" && (i = t, t = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: i,
      test(r) {
        if (r == null)
          return !0;
        const g = hEt(this.schema, r);
        return !t || g.length === 0 || this.createError({
          params: {
            unknown: g.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = t, n;
  }
  unknown(t = !0, i = Q5.noUnknown) {
    return this.noUnknown(!t, i);
  }
  transformKeys(t) {
    return this.transform((i) => i && IEt(i, (n, r) => t(r)));
  }
  camelCase() {
    return this.transformKeys(rEt);
  }
  snakeCase() {
    return this.transformKeys(lz);
  }
  constantCase() {
    return this.transformKeys((t) => lz(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = $te(this.fields, (i) => i.describe()), t;
  }
}
function jE(e) {
  return new Vie(e);
}
jE.prototype = Vie.prototype;
function Lw() {
  return Lw = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, Lw.apply(this, arguments);
}
function wie(e) {
  return new vie(e);
}
class vie extends Ro {
  constructor(t) {
    super({
      type: "array"
    }), this.innerType = void 0, this.innerType = t, this.withMutation(() => {
      this.transform(function(i) {
        if (typeof i == "string")
          try {
            i = JSON.parse(i);
          } catch {
            i = null;
          }
        return this.isType(i) ? i : null;
      });
    });
  }
  _typeCheck(t) {
    return Array.isArray(t);
  }
  get _subType() {
    return this.innerType;
  }
  _cast(t, i) {
    const n = super._cast(t, i);
    if (!this._typeCheck(n) || !this.innerType)
      return n;
    let r = !1;
    const g = n.map((o, l) => {
      const a = this.innerType.cast(o, Lw({}, i, {
        path: `${i.path || ""}[${l}]`
      }));
      return a !== o && (r = !0), a;
    });
    return r ? g : n;
  }
  _validate(t, i = {}, n) {
    var r, g;
    let o = [], l = i.sync, a = i.path, I = this.innerType, c = (r = i.abortEarly) != null ? r : this.spec.abortEarly, d = (g = i.recursive) != null ? g : this.spec.recursive, C = i.originalValue != null ? i.originalValue : t;
    super._validate(t, i, (A, b) => {
      if (A) {
        if (!rl.isError(A) || c)
          return void n(A, b);
        o.push(A);
      }
      if (!d || !I || !this._typeCheck(b)) {
        n(o[0] || null, b);
        return;
      }
      C = C || b;
      let m = new Array(b.length);
      for (let p = 0; p < b.length; p++) {
        let B = b[p], f = `${i.path || ""}[${p}]`, Z = Lw({}, i, {
          path: f,
          strict: !0,
          parent: b,
          index: p,
          originalValue: C[p]
        });
        m[p] = (y, W) => I.validate(B, Z, W);
      }
      Fw({
        sync: l,
        path: a,
        value: b,
        errors: o,
        endEarly: c,
        tests: m
      }, n);
    });
  }
  clone(t) {
    const i = super.clone(t);
    return i.innerType = this.innerType, i;
  }
  concat(t) {
    let i = super.concat(t);
    return i.innerType = this.innerType, t.innerType && (i.innerType = i.innerType ? (
      // @ts-expect-error Lazy doesn't have concat()
      i.innerType.concat(t.innerType)
    ) : t.innerType), i;
  }
  of(t) {
    let i = this.clone();
    if (!PE(t))
      throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + um(t));
    return i.innerType = t, i;
  }
  length(t, i = HV.length) {
    return this.test({
      message: i,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(n) {
        return el(n) || n.length === this.resolve(t);
      }
    });
  }
  min(t, i) {
    return i = i || HV.min, this.test({
      message: i,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      // FIXME(ts): Array<typeof T>
      test(n) {
        return el(n) || n.length >= this.resolve(t);
      }
    });
  }
  max(t, i) {
    return i = i || HV.max, this.test({
      message: i,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(n) {
        return el(n) || n.length <= this.resolve(t);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((t, i) => this._typeCheck(t) ? t : i == null ? [] : [].concat(i));
  }
  compact(t) {
    let i = t ? (n, r, g) => !t(n, r, g) : (n) => !!n;
    return this.transform((n) => n != null ? n.filter(i) : n);
  }
  describe() {
    let t = super.describe();
    return this.innerType && (t.innerType = this.innerType.describe()), t;
  }
  nullable(t = !0) {
    return super.nullable(t);
  }
  defined() {
    return super.defined();
  }
  required(t) {
    return super.required(t);
  }
}
wie.prototype = vie.prototype;
const Eei = (e) => {
  const t = Oe(() => Object.keys(jC), []);
  return /* @__PURE__ */ Ie(ja, { fullWidth: !0, sx: {
    marginBottom: 2
  }, className: "k3-text-input-container k3-form-autocomplete k3-form-input k3-contact-form-autocomplete", children: [
    /* @__PURE__ */ S(s_, { children: e.label }),
    /* @__PURE__ */ S(
      dj,
      {
        "data-cy": "contactCountry",
        options: t,
        renderOption: (i, n) => {
          var r;
          return /* @__PURE__ */ B4("li", { ...i, key: n }, /* @__PURE__ */ S(Sj, { children: (r = jC[n]) == null ? void 0 : r.title }));
        },
        filterOptions: (i, n) => {
          const r = n.inputValue;
          return i.filter((g) => {
            var o;
            return r.length <= 2 && g.includes(r == null ? void 0 : r.toUpperCase()) ? !0 : (o = n.getOptionLabel(g)) == null ? void 0 : o.toLowerCase().includes(r.toLowerCase());
          });
        },
        getOptionLabel: (i) => {
          var n;
          return !!i && ((n = jC[i]) == null ? void 0 : n.title) || "";
        },
        value: e.value,
        onChange: (i, n) => {
          e.onChange(n || "");
        },
        renderInput: (i) => /* @__PURE__ */ S(kd, { ...i, error: e.hasError, helperText: e.errorMessage, sx: {
          marginBottom: 0.5
        }, fullWidth: !0, ...e.formData })
      }
    )
  ] });
}, Nei = (e) => {
  const {
    t
  } = Gi(), i = pEt(e.code, t);
  return i ? /* @__PURE__ */ S(li, { children: i }) : null;
}, pEt = (e, t) => {
  if (!e)
    return null;
  const i = jC[e];
  return i ? `${t(i.name)} (${e})` : e;
}, jC = {
  DE: {
    title: "Deutschland",
    name: "Deutschland"
  },
  AT: {
    title: "Österreich",
    name: "Österreich"
  },
  CH: {
    title: "Suisse, Schweiz, Svizzera, Svizra",
    name: "Schweiz"
  },
  AX: {
    title: "Åland",
    name: "Åland Inseln"
  },
  AD: {
    title: "Andorra",
    name: "Andorra"
  },
  BE: {
    title: "België, Belgique, Belgien",
    name: "Belgien"
  },
  BY: {
    title: "Bielaruś, Беларусь",
    name: "Belarus"
  },
  BA: {
    title: "Bosnia I Hercegovína, Босна и Херцеговина",
    name: "Bosnien und Herzegowina"
  },
  BG: {
    title: "Bulgariya, България",
    name: "Bulgarien"
  },
  CZ: {
    title: "Česko",
    name: "Tschechien"
  },
  VA: {
    title: "Città del Vaticano, Civitas Vaticana",
    name: "Vatikanstadt"
  },
  MJ: {
    title: "Crna Gora Црна Гора",
    name: "Montenegro"
  },
  DK: {
    title: "Danmark",
    name: "Dänemark"
  },
  EE: {
    title: "Eesti",
    name: "Estland"
  },
  ES: {
    title: "España, Espanya, Espainia",
    name: "Spanien"
  },
  FO: {
    title: "Færøerne",
    name: "Färöer"
  },
  FR: {
    title: "France",
    name: "Frankreich"
  },
  GG: {
    title: "Guernesey",
    name: "Guernsey"
  },
  HR: {
    title: "Hrvatska",
    name: "Kroatien"
  },
  IE: {
    title: "Ireland",
    name: "Irland"
  },
  IC: {
    title: "Ísland",
    name: "Island"
  },
  IM: {
    title: "Isle of Man",
    name: "Isle of Man"
  },
  IT: {
    title: "Italia",
    name: "Italien"
  },
  JE: {
    title: "Jersey",
    name: "Jersey"
  },
  AL: {
    title: "Shqipëria",
    name: "Albanien"
  },
  KV: {
    title: "Kosova, Косово",
    name: "Kosovo"
  },
  LV: {
    title: "Latvija",
    name: "Lettland"
  },
  LI: {
    title: "Liechtenstein",
    name: "Fürstentum Liechtenstein"
  },
  LT: {
    title: "Lietuva",
    name: "Lithauen"
  },
  LU: {
    title: "Luxembourg, Luxemburg, Lëtezebuerg",
    name: "Luxemburg"
  },
  HU: {
    title: "Magyarország",
    name: "Ungarn"
  },
  MC: {
    title: "Monaca, Múnegu",
    name: "Monaco"
  },
  NL: {
    title: "Nederland, Nederlân",
    name: "Niederlande"
  },
  NO: {
    title: "Norge",
    name: "Norwegen"
  },
  PL: {
    title: "Polska",
    name: "Polen"
  },
  PT: {
    title: "Portugal",
    name: "Portugal"
  },
  KZ: {
    title: "Qazaqstan Қазақстан, Kazakhstán Казахстан",
    name: "Kasachstan"
  },
  MT: {
    title: "Repubblika ta\\’ Malta, Republic of Malta",
    name: "Malta"
  },
  MD: {
    title: "Republica Moldova",
    name: "Moldau"
  },
  RO: {
    title: "România",
    name: "Rumänien"
  },
  RU: {
    title: "Rossiâ Россия",
    name: "Russland"
  },
  SM: {
    title: "San Marino",
    name: "San Marino"
  },
  SI: {
    title: "Slovenija",
    name: "Slowenien"
  },
  SK: {
    title: "Slovensko",
    name: "Slowakei"
  },
  RB: {
    title: "Srbija Србија",
    name: "Serbien"
  },
  FI: {
    title: "Suomi, Finland",
    name: "Finnland"
  },
  SJ: {
    title: "Svalbard og Jan Mayen",
    name: "Spitzbergen und Jan Mayen"
  },
  SE: {
    title: "Sverige",
    name: "Schweden"
  },
  TU: {
    title: "Türkiye",
    name: "Türkei"
  },
  UA: {
    title: "Ukraїna Україна",
    name: "Ukraine"
  },
  GB: {
    title: "United Kingdom",
    name: "Vereinigtes Königreich"
  },
  CY: {
    title: "Κύπρος Kıbrıs",
    name: "Zypern"
  },
  GR: {
    title: "Κύπρος Kıbrıs",
    name: "Griechenland"
  },
  MK: {
    title: "Република Северна Македонија Republika Severna Makedonija",
    name: "Nordmazedonien"
  }
}, BEt = (e) => !!jC[e], fEt = Object.keys(jC).map((e) => {
  var t;
  return (t = jC[e]) == null ? void 0 : t.title;
}), ZEt = (e) => fEt.includes(e), JB = {
  name: "Namen dürfen keine Zahlen enthalten",
  email: "Bitte geben Sie eine korrekte E-Mail ein",
  zip: "Eine Postleitzahl darf nur aus 4 oder 5 Ziffern bestehen",
  city: "Geben Sie bitte einen gültigen Städtenamen an",
  country: "Geben Sie bitte ein gültiges Land an",
  phone: "Bitte geben Sie eine gültige Telefonnummer ein"
}, GEt = {
  name: "Bitte geben Sie Ihren Namen ein",
  email: "Bitte geben Sie Ihre E-Mail ein",
  address: "Bitte geben Sie Ihre Adresse ein",
  city: "Bitte geben Sie den Namen Ihrer Stadt ein",
  zip: "Bitte geben Sie Ihre Postleitzahl an",
  taxID: "Bitte geben Sie Ihre UST-ID ein",
  company: "Bitte geben Sie Ihren Firmennamen an",
  country: "Geben Sie bitte ein gültiges Land an",
  remark: "Bitte geben Sie eine Bemerkung ein",
  phone: "Bitte geben Sie eine gültige Telefonnummer ein"
}, gI = (e) => ({
  is: (t) => t == null ? void 0 : t.includes(e),
  then: Wl().required(GEt[e] || JB[e])
}), gD = {
  /** List of required fields based on exit button settings, used for conditional required validation. Set via Form Initial values */
  requiredFields: wie().of(Wl()),
  name: Wl().when("requiredFields", gI("name")),
  // Checks for valid email format regardless of whether is required or not
  email: Wl().email(JB.email).when("requiredFields", gI("email")),
  address: Wl().when("requiredFields", gI("address")),
  city: Wl().matches(/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/, {
    message: JB.city,
    excludeEmptyString: !0
  }).when("requiredFields", gI("city")),
  zip: Wl().when("requiredFields", gI("zip")),
  // Checks for valid country code or country name, regardless of required field status
  country: Wl().test("test-ccode", JB.country, (e) => !e || BEt(e) || ZEt(e)).when("requiredFields", gI("country")),
  remark: Wl().when("requiredFields", gI("remark")),
  taxID: Wl().when("requiredFields", gI("taxID")),
  company: Wl().when("requiredFields", gI("company")),
  phone: Wl().matches(/^(\(?([\d \-)–+/(]+){6,}\)?([ .-–/]?)([\d]+)$)/g, {
    message: JB.phone,
    excludeEmptyString: !0
  }).when("requiredFields", gI("phone"))
}, Lei = jE(gD), xF = ["overview", "contact", "confirmation"], tr = class tr {
};
/** Whether the form can be submitted or the submit button is disabled.
 * Returns true if submit button should be disabled
 */
Qi(tr, "proceedDisabled", (t, i, n) => {
  if (n !== "contact" || !(t != null && t.formular))
    return !1;
  const {
    checkbox: r,
    ...g
  } = i;
  return !r || !tr.isContactFormValid(g, t);
}), Qi(tr, "stepTriggersSave", (t, i) => {
  const n = tr.availableSteps(t);
  return n.length - n.indexOf(i) === 2;
}), Qi(tr, "buttonBack", (t, i) => tr.availableSteps(t).indexOf(i) === 0 ? Mi.CANCEL : Mi.NAVBAR_BACK), Qi(tr, "dynamicSettingsKeyForFooter", () => [Mi.CANCEL, Mi.NAVBAR_BACK, Mi.NAVBAR_NEXT, Mi.CLOSE, Mi.NAVBAR_OLDVERSIONHINT]), Qi(tr, "forwardButton", (t, i) => tr.stepTriggersSave(t, i) ? t == null ? void 0 : t.label : i === "confirmation" ? Mi.CLOSE : Mi.NAVBAR_NEXT), Qi(tr, "stepTitleKeys", [Mi.ORDER_DIALOG_OVERVIEW, Mi.ORDER_DIALOG_DATA, Mi.ORDER_DIALOG_CONFIRMATION]), Qi(tr, "titleKeyForStep", (t) => tr.stepTitleKeys[xF.indexOf(t)]), Qi(tr, "keysForStep", (t) => {
  switch (t) {
    case "overview":
      return [Mi.ORDER_DIALOG_OVERVIEW, Mi.ORDER_DIALOG_OVERVIEW_SELECTIONPRICE, Mi.ORDER_DIALOG_OVERVIEW_STEP, Mi.ORDER_DIALOG_OVERVIEW_VARIABLE, Mi.ORDER_DIALOG_OVERVIEW_SELECTION, Mi.ORDER_DIALOG_OVERVIEW_TOTALPRICE, Mi.ORDER_DIALOG_OVERVIEW_PRICE, Mi.ORDER_DIALOG_OVERVIEW_PRICEINFO, "order_modal_priceDetails", "order_modal_pos", "order_modal_articleNo", "order_modal_article", "order_modal_articlePrice", "order_modal_articleAmount", "order_modal_articleCount", "order_modal_positionPrice", "order_modal_edit", "order_modal_remove"];
    case "contact":
      return [Mi.ORDER_DIALOG_DATA, Mi.ORDER_DIALOG_SUBMITINFO];
    case "confirmation":
      return [Mi.ORDER_DIALOG_CONFIRMATION];
    default:
      return [];
  }
}), Qi(tr, "availableSteps", (t) => xF.filter(tr.isStepAvailable(t))), Qi(tr, "handleStep", (t, i, n) => {
  const r = tr.availableSteps(t), g = xF.indexOf(i);
  return n === "add" ? r[g + 1] : r[g - 1];
}), Qi(tr, "isStepAvailable", (t) => (i) => {
  switch (i) {
    case "overview":
      return (t == null ? void 0 : t.overviewType) !== "noOverview";
    case "contact":
      return t == null ? void 0 : t.formular;
    default:
      return !0;
  }
}), Qi(tr, "customer", (t, i, n) => {
  var g, o, l, a, I;
  const r = (c) => {
    var d;
    return (d = t == null ? void 0 : t.formular) != null && d[c] ? i[c] : void 0;
  };
  return t != null && t.formular ? {
    address: r("address"),
    dataPrivacy: ((g = t == null ? void 0 : t.formular) == null ? void 0 : g.dataPrivacy) ?? n,
    name: r("name"),
    email: (o = t == null ? void 0 : t.formular) != null && o.sendCustomerEmail ? i.email : void 0,
    phone: r("phone"),
    remark: r("remark"),
    company: r("company"),
    taxID: r("taxID"),
    checkboxAccepted: i.checkbox,
    city: (l = t == null ? void 0 : t.formular) != null && l.address ? i.city : void 0,
    zip: (a = t == null ? void 0 : t.formular) != null && a.address ? i.zip : void 0,
    country: (I = t == null ? void 0 : t.formular) != null && I.address ? i.country : void 0
  } : null;
}), Qi(tr, "getRequiredContactFields", (t) => {
  var l, a, I, c;
  const i = !!((l = t == null ? void 0 : t.formular) != null && l.address) && !((I = (a = t == null ? void 0 : t.formular) == null ? void 0 : a.optionalFields) != null && I.address), n = (d) => {
    var C, A, b;
    return ((C = t == null ? void 0 : t.formular) == null ? void 0 : C[d]) && !((b = (A = t == null ? void 0 : t.formular) == null ? void 0 : A.optionalFields) != null && b[d]);
  }, r = [], o = ["address", "city", "zip"].concat(["email", "country"]);
  return Object.keys(gD).filter((d) => !o.includes(d)).forEach((d) => {
    n(d) && r.push(d);
  }), i && r.push("address", "city", "zip"), n("sendCustomerEmail") && r.push("email"), (c = t.formular) != null && c.address && n("country") && r.push("country"), r;
}), // Helper
Qi(tr, "isContactFormValid", (t, i) => {
  const n = tr.getRequiredContactFields(i), r = {
    ...t,
    requiredFields: n
  };
  return jE(gD).isValidSync(r);
});
let oD = tr;
const yEt = (e) => e.order.privateData, WEt = (e) => e.order.privateDataText, Rie = async (e) => await (await fetch(l1(e))).blob(), SEt = async (e) => {
  const t = CE(e);
  return Array.isArray(t) ? await Promise.all(t.map(async (i) => ({
    ...i,
    file: await Rie(i.file)
  }))) : [];
}, VEt = async (e) => {
  const t = await Promise.all(Br(e).map(async (l) => {
    var I, c;
    const a = qr(l.variableId)(e);
    if ((I = l.data) != null && I.url && // if it is previewImage do not upload it.
    a.settings.templateOptions.previewImage !== ((c = l.data) == null ? void 0 : c.url)) {
      const d = l.id;
      return {
        selection: {
          ...l,
          data: {
            ...l.data,
            url: d
          }
        },
        uploadFileInformation: {
          key: d,
          file: await Rie(l.data.url)
        }
      };
    } else
      return {
        selection: l,
        uploadFileInformation: void 0
      };
  })), i = t.map((l) => l.selection), n = await SEt(e), r = [];
  LC.forEach((l, a) => {
    r.push({
      key: a,
      stage: l
    });
  });
  const g = await Promise.all(r.map(async ({
    key: l,
    stage: a
  }) => ({
    key: l,
    file: await a.toBlob({
      mimeType: "image/jpeg",
      quality: 1,
      pixelRatio: 1,
      x: 0,
      y: 0,
      width: a.width(),
      height: a.height()
    })
  }))), o = [...t.map((l) => l.uploadFileInformation).filter(Boolean), ...n, ...g];
  return {
    updatedSelections: i,
    filesAndInformation: o
  };
}, wEt = async (e) => G$(e).reduce((i, n, r) => ({
  ...i,
  ["camera_" + r]: {
    [n.label]: l1(n.url)
  }
}), {}), vEt = async (e, t, i) => {
  const n = Pi(e), r = Er(e), g = nr(e), o = Jr(e);
  if (!g || !o)
    return console.warn("Rule engine not initialized!"), {};
  if (n) {
    const l = WA(e), {
      updatedSelections: a,
      filesAndInformation: I
    } = await VEt(e), c = O2t(g, a, o), d = (B) => ({
      articleNo: B.article.no,
      articleName: B.article.name,
      priceUnit: B.priceUnit,
      qty: B.qty,
      amount: B.amount || 1,
      // TODO Soll das hier rein?
      priceTotal: B.priceTotal
    }), C = (B) => B.map((f) => ({
      group: f.group.label,
      groupId: f.group.id,
      index: f.index,
      variableLabel: f.variable.label,
      variableId: f.variable.id,
      selectionLabel: f.selectionLabel,
      selectionId: f.selection.id,
      selectionValueId: Sg(f.variable) ? null : f.selection.valueId,
      bom: {
        articleLines: f.bom.articleLines.map(d),
        surchargeLines: f.bom.surchargeLines.map(d),
        priceTotal: f.bom.priceTotal
      },
      subVariables: f.subVariables ? C(f.subVariables) : null
    })), A = (B) => B.OC_reduceBy(
      // If article number and amount match
      (f, Z) => f.articleId == Z.articleId && f.amount == Z.amount,
      // Merge Items by updating count/qty
      (f, Z) => (f.qty += Z.qty, f)
    ), b = E9(e).map((B) => {
      var f;
      return {
        articleId: B.article.id,
        amount: B.amount,
        qty: B.qty,
        main: B.main,
        unit: (f = B.price) == null ? void 0 : f.unit
      };
    }), m = A(b);
    return {
      newConfiguration: {
        state: qx.Ordered,
        // TODO
        thumbnail: null,
        files: await wEt(e),
        appId: n.id,
        appCode: n.code,
        versionId: n.versionId,
        // TODO
        userId: null,
        price: l,
        inspiration: !1,
        //sort: (maxBy((g) => g.sort, configurations)?.sort || -1) + 1,
        json: {
          variables: c,
          bom: m,
          summary: C(e_(e)),
          touched: o.state.all.touched
        },
        customer: i,
        lang: r,
        label: t
      },
      filesAndInformation: I
    };
  } else
    return {};
}, Xie = (e, t, i) => async (n, r) => {
  const g = r(), o = Pi(g), l = SA(g), a = Er(g), {
    newConfiguration: I,
    filesAndInformation: c
  } = await vEt(g, e, i ?? void 0) || {};
  if (!I) {
    console.error("Could not create new configuration!");
    return;
  }
  return cm("saved", t.actionKey || t.label[a] || t.id, o, "saved"), await n(xWt(I, t, c, l)).catch((d) => {
    throw d;
  });
}, REt = (e, t) => async (i, n) => {
  const r = n(), g = t || MWe(r);
  if (!g || !e || e === "creating")
    return null;
  console.debug("Starting save");
  const o = oD.customer(g, yEt(r), WEt(r)), l = await i(Xie("Configuration", g, o));
  return console.debug("Ending save"), i(Dct()), l;
}, Kei = (e, t, i) => {
  const n = Ei(), r = ie(CE);
  lt(() => {
    t && (async () => {
      const o = await n(REt(r, i));
      o && e(o);
    })();
  }, [r, t]);
};
var qE = {}, XEt = yg;
Object.defineProperty(qE, "__esModule", {
  value: !0
});
var Hie = qE.default = void 0, HEt = XEt(oo()), kEt = ro;
Hie = qE.default = (0, HEt.default)(/* @__PURE__ */ (0, kEt.jsx)("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), "Edit");
const Iz = {
  hiddenContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 1,
    opacity: 0.5,
    filter: "grayscale(1)",
    border: "2px black solid",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none"
  },
  hiddenBackground: {
    background: (e) => `repeating-linear-gradient(
45deg,
${e.palette.warning.main},
${e.palette.warning.main} 10px,
${e.palette.warning.dark} 10px,
${e.palette.warning.dark} 20px
)`
  }
}, kie = ({
  children: e,
  sx: t,
  message: i,
  minHeight: n = 50,
  showIcon: r = !0
}) => /* @__PURE__ */ S(Tn, { title: /* @__PURE__ */ S(vo, { component: "div", style: {
  whiteSpace: "pre-line"
}, children: i }), children: /* @__PURE__ */ Ie(vo, { component: "div", className: "k3-variable-hidden-container", sx: {
  position: "relative",
  minHeight: n,
  whiteSpace: "pre-line",
  ...t
}, children: [
  e,
  /* @__PURE__ */ S(vo, { component: "div", className: "k3-variable-hidden-background", sx: [Iz.hiddenBackground, Iz.hiddenContainer], children: r && /* @__PURE__ */ S(rq, {}) })
] }) }), Yie = Bm((e) => {
  const {
    t
  } = Gi();
  return /* @__PURE__ */ S(ht, { component: "div", className: Re("k3-info-btn", e.className), "data-cy": e.dataCy ?? "info-icon-btn", "aria-label": "Details", title: t("Mehr Informationen anzeigen"), sx: [{
    padding: "0",
    fontSize: e.iconSize ? void 0 : "1.5rem",
    cursor: "pointer"
  }, ...Array.isArray(e.sx) ? e.sx : [e.sx]], onClick: (i) => (i.preventDefault(), e.onClick(i), !1), children: /* @__PURE__ */ S(qAt, { fontSize: e.iconSize ?? "inherit", color: "info", className: "info-selection info-details" }) });
});
function YEt({
  sx: e,
  priceFormatter: t = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  }),
  price: i
}) {
  return /* @__PURE__ */ S(Ct, { sx: {
    display: "grid",
    placeItems: "center",
    backgroundColor: (n) => n.palette.background.default,
    color: (n) => n.palette.text.primary,
    borderRadius: 1,
    px: 2,
    ...e
  }, "data-cy": "price", className: "k3-price k3-price-total", children: t.format(i) });
}
const Tei = () => {
  const e = ie(Wv), t = ie(WA), i = ie(yA);
  return e ? /* @__PURE__ */ S(JEt, { price: t, priceFormatter: i }) : null;
}, Mei = (e) => {
  var g;
  const t = $$(e.currencyVariableKey || "currency"), i = tee(e.currencyVariableKey, [e.currencyAttributeKey])[0], n = ie(Er), r = ((g = i == null ? void 0 : i.value) == null ? void 0 : g.toString()) || (t == null ? void 0 : t.label.replace(/\[|\]/g, "")) || "EUR";
  return /* @__PURE__ */ S(Fie, { currency: r, type: "overall", language: n });
}, Fie = (e) => {
  const t = ie(Wv), i = xEt(e), n = ie(yA), r = Oe(() => FEt(e.language, e.currency) || n, [e.currency, e.language, n]), g = Oe(() => {
    let o = i;
    if (e.type != "overall") {
      const l = e.mwst ? i / (1 + (e.mwst || 0)) : i;
      o = e.type == "netto" ? l : i - l;
    }
    return r.format(o);
  }, [e.type, e.mwst, i, r]);
  return t ? /* @__PURE__ */ S(li, { children: g }) : null;
}, FEt = (e, t) => !e || !t ? null : new Intl.NumberFormat(e, {
  style: "currency",
  currency: t
}), cz = (e) => e.category ? (t) => {
  var i;
  return !e.category || ((i = t.article) == null ? void 0 : i.category) == e.category;
} : () => !0, xEt = (e) => {
  const t = rr();
  return ie(e.instanciated ? e.category || e.excludeSurcharges ? g0t(cz(e), t, !!e.excludeSurcharges) : qq(t) : e.category || e.excludeSurcharges ? r0t(cz(e), e.excludeSurcharges) : WA);
}, DEt = (e) => {
  var g;
  const {
    price: t,
    priceFormatter: i,
    sx: n
  } = e;
  return (g = ie(Pi).productDetails) != null && g.price ? /* @__PURE__ */ S(YEt, { sx: n, price: t, priceFormatter: i }) : null;
}, JEt = gr({
  app: {
    price: {
      root: !0
    }
  }
})(DEt), EEt = ({
  value: e
}) => {
  const t = ie(Er);
  return e && /* @__PURE__ */ S(rG, { htmlString: e[t], renderTarget: "localized-html" });
}, dz = {
  root: {
    overflow: "hidden"
  },
  labelContainer: {
    maxHeight: 24 * 6,
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden"
  }
}, NEt = () => {
  const e = ie(aye);
  return /* @__PURE__ */ S(KEt, { labelActions: e });
}, LEt = ({
  labelActions: e
}) => (e == null ? void 0 : e.length) === 0 ? null : /* @__PURE__ */ S(ht, { component: "div", sx: dz.root, children: /* @__PURE__ */ S(ht, { component: "div", sx: {
  p: (e == null ? void 0 : e.length) && 0,
  ...dz.labelContainer
}, children: Le.map((t) => /* @__PURE__ */ S(Ct, { color: "text.primary", gutterBottom: !0, children: /* @__PURE__ */ S(EEt, { value: t.label ?? "" }) }, t.ruleItemId), e) }) }), KEt = gr({
  app: {
    labelActionDisplay: {
      root: !0
    }
  }
})(LEt), TEt = {
  // mui components
  Typography: _o(() => import("./index-DHouCeG6.js")),
  Switch: _o(() => import("./index-4sjRurFE.js")),
  Box: _o(() => import("./index-BzguXDC2.js")),
  Link: _o(() => import("./index-C4rXfC0z.js")),
  Stack: _o(() => import("./index-DtzccoWT.js")),
  Button: _o(() => import("./index-m-ABS0TY.js")),
  Divider: _o(() => import("./index-7Hlv9g9g.js")),
  PriceData: Fie,
  LabelActionsDisplay: NEt,
  // mui icons
  ExpandCircleDownIcon: _o(() => import("./ExpandCircleDown-CeCu2NOT.js").then((e) => e.E)),
  KeyboardArrowDownIcon: _o(() => import("./KeyboardArrowDown-hQsVpVXJ.js").then((e) => e.K)),
  CloseIcon: _o(() => Promise.resolve().then(() => ySe)),
  MoreVertIcon: _o(() => import("./MoreVert-Bc8fMomm.js").then((e) => e.M))
}, MEt = (e) => e.split(";").filter((t) => t.split(":")[0] && t.split(":")[1]).map((t) => [t.split(":")[0].trim().replace(/-./g, (i) => i.substr(1).toUpperCase()), t.split(":")[1].trim()]).reduce((t, i) => ({
  ...t,
  [i[0]]: i[1]
}), {}), PEt = (e) => {
  if (e === "true")
    return !0;
  if (e === "false")
    return !1;
  const t = +e;
  return t || t === 0 ? t : e;
}, xie = (e, t, i = 0) => {
  if (t.nodeType == Node.TEXT_NODE)
    return t.textContent;
  const n = [];
  t.childNodes.forEach((o) => n.push(o));
  const r = {
    key: `${t.nodeName}_${i}`
  };
  for (let o = 0; o < t.attributes.length; o++) {
    const l = t.attributes.item(o);
    switch (l.name) {
      case "style":
        r[l.name] = MEt(l.value);
        break;
      default:
        r[l.name] = PEt(l.value);
        break;
    }
  }
  const g = n != null && n.length ? n.filter((o) => o.nodeType == Node.ELEMENT_NODE || o.nodeType == Node.TEXT_NODE).map((o, l) => xie(e, o, l)) : void 0;
  return PC(e[t.nodeName] || t.nodeName, r, g);
};
class rG extends De.Component {
  get value() {
    return this.props.xmlString || `<div>${this.props.htmlString}</div>`;
  }
  get components() {
    return this.props.components || TEt;
  }
  constructor(t) {
    super(t), this.state = {
      errorMessage: void 0
    };
  }
  // React Error was caught
  static getDerivedStateFromError(t) {
    return {
      errorMessage: (t == null ? void 0 : t.message) || (t == null ? void 0 : t.toString())
    };
  }
  // If string value has changed and error is displayed, reset error
  componentDidUpdate(t) {
    (t.xmlString || `<div>${t.htmlString}</div>`) != this.value && this.state.errorMessage && this.setState({
      errorMessage: void 0
    });
  }
  // React Error was caught. E.g. br Tags with children
  componentDidCatch(t, i) {
    console.error("StringToReact: Unexpected error occurred:", t, i);
  }
  // Checks whether the created document contains parse errors
  hasParseErrors(t) {
    const i = t == null ? void 0 : t.getRootNode().firstChild;
    return !!i && i.innerHTML.includes("parsererror");
  }
  getLayout() {
    if (!this.value)
      return null;
    const i = new DOMParser().parseFromString(this.value, "application/xhtml+xml");
    return this.hasParseErrors(i) ? (console.error("StringToReact: HTML could not be parsed for " + this.props.renderTarget), /* @__PURE__ */ S(uz, {})) : xie(this.components, i.getRootNode().firstChild);
  }
  render() {
    return this.state.errorMessage ? /* @__PURE__ */ S(uz, { message: this.state.errorMessage }) : this.getLayout();
  }
}
const uz = ({
  message: e
}) => {
  const t = ie($r), {
    t: i
  } = Gi();
  if (t) {
    const n = i("Der HTML-Inhalt konnte nicht gerendert werden. Bitte bereinigen Sie Ihre Eingabe.");
    return /* @__PURE__ */ Ie(li, { children: [
      /* @__PURE__ */ S(Ct, { color: "error", children: n }),
      !!e && /* @__PURE__ */ S(Ct, { color: "error", children: e })
    ] });
  }
  return null;
}, Pei = () => {
  const {
    t: e
  } = Gi(), t = `${e("Der eingegebe Wert ist nicht gültig: ")} ${e("Ungültiges HTML-Format")}`;
  return /* @__PURE__ */ S(Ct, { color: "error", children: t });
}, Uei = (e) => !new DOMParser().parseFromString(`<div>${e}</div>`, "application/xhtml+xml").querySelector("parsererror"), Die = ({
  variable: e,
  sx: t
}) => {
  const [i, n] = wt(!1);
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Yie, { onClick: () => n(!i), className: "k3-variable-info-button", "data-cy": `varInfo-${e == null ? void 0 : e.id}`, sx: t || {
      height: "24px",
      lineHeight: "24px"
    } }),
    /* @__PURE__ */ S(o1, { className: "variableInfoDialog k3-variable-info-modal", show: i, onClose: () => n(!1), type: "info", title: e == null ? void 0 : e.label, children: /* @__PURE__ */ S(Ct, { children: /* @__PURE__ */ S(rG, { htmlString: e == null ? void 0 : e.info, renderTarget: "variable-info" }) }) })
  ] });
}, UEt = /* @__PURE__ */ S(Yj, { animation: "wave", variant: "rounded", width: 400, height: 300 });
function zEt({
  label: e,
  description: t,
  view: i = UEt
}) {
  return /* @__PURE__ */ Ie(pi, { gap: 0.5, direction: "column", children: [
    /* @__PURE__ */ S(Ct, { variant: "h6", className: "k3-variable-header", children: e }),
    !!t && /* @__PURE__ */ S(Ct, { variant: "subtitle1", className: "k3-variable-description", children: /* @__PURE__ */ S(rG, { htmlString: t || "", renderTarget: "Variable-desc" }) }),
    /* @__PURE__ */ S(pi, { className: "k3-variable-content", children: i })
  ] });
}
const OEt = ({
  variable: e
}) => {
  const t = rr(), i = ie(yA), {
    priceTotal: n
  } = ie(_B(e.id || 0, t)), r = i.format(n);
  return /* @__PURE__ */ S(Ct, { variant: "inherit", className: "k3-variable-price", "data-cy": "simpleVariablePrice", children: r });
}, Cz = ({
  fullwidth: e,
  children: t
}) => /* @__PURE__ */ S(Ct, { variant: "inherit", "data-cy": "simpleVariableLabel", className: "k3-variable-label", sx: {
  alignSelf: "center",
  whiteSpace: "wrap",
  ...e ? {
    width: 1
  } : {}
}, children: t }), QEt = ({
  variable: e,
  fullWidth: t = !1,
  showLabel: i
}) => {
  const {
    t: n
  } = Gi(), r = Vi(e), g = ie($r);
  return /* @__PURE__ */ Ie("div", { style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  }, children: [
    i && /* @__PURE__ */ S(Cz, { fullwidth: t, children: e == null ? void 0 : e.label }),
    !i && g && /* @__PURE__ */ S(kie, { minHeight: 0, showIcon: !1, message: n("Die Option 'Titel ausblenden' ist aktiviert."), children: /* @__PURE__ */ S(Cz, { fullwidth: t, children: e == null ? void 0 : e.label }) }),
    mye(e) && (e == null ? void 0 : e.info) && /* @__PURE__ */ S(Die, { variable: e }),
    r.showPrice && /* @__PURE__ */ S(OEt, { variable: e })
  ] });
}, wg = ({
  variable: e,
  fullWidth: t,
  className: i,
  view: n
}) => {
  const r = Vn(Fs), g = Vi(e), o = Oe(() => (r.extendVariableLabel || de.identity)((a) => /* @__PURE__ */ Ie(pi, { direction: "row", alignItems: "center", "data-cy": "simpleVariableLabelBox", className: Re("k3-variable-label-container", i), children: [
    /* @__PURE__ */ S(QEt, { variable: a.variable, fullWidth: t, showLabel: (g == null ? void 0 : g.hideTitle) === void 0 ? !0 : !(g != null && g.hideTitle) }),
    a.children
  ] })), [i, r.extendVariableLabel, t, g == null ? void 0 : g.hideTitle]);
  return /* @__PURE__ */ S(zEt, { label: o && /* @__PURE__ */ S(o, { variable: e }), description: e.description, view: n });
}, jEt = (e) => {
  var g, o, l, a;
  const t = Vi(e.variable), i = ie(nr), n = (i == null ? void 0 : i.values.byVarId.all[e.variable.id]) ?? [];
  if (!e.dontHide) {
    if (t != null && t.hideAlways || t != null && t.hideIfNoOptions && (((g = e.validValueIds) == null ? void 0 : g.length) || 0) === 0 && e.loadingValueIds.length === 0)
      return null;
    if (t != null && t.hideIfSingleOption && (((o = e.validValueIds) == null ? void 0 : o.length) || 0) <= 1 && ((l = e.loadingValueIds) == null ? void 0 : l.length) === 0)
      if (Sg(e.variable)) {
        const I = n.find((c) => c.id === e.validValueIds[0]);
        if (I && m6(I))
          return null;
      } else
        return null;
  }
  const r = e.disabled || (t == null ? void 0 : t.disableIfSingleOption) && (((a = e.validValueIds) == null ? void 0 : a.length) || 0) <= 1;
  return /* @__PURE__ */ S(e.Wrapped, { ...e, disabled: r });
}, ta = (e) => (t) => /* @__PURE__ */ S(jEt, { ...t, Wrapped: e });
var qEt = { VITE_API_URL: "https://k3-api.objectcode.de", VITE_DOC_URL: "https://oc-k3.s3.amazonaws.com/assets", VITE_HELP_URL: "https://k3.objectcode.de/help", VITE_LIBS_URL: "https://oc-k3.s3.eu-central-1.amazonaws.com/libs/", VITE_ADMIN_ANALYTICS: "", VITE_BUGSNAG_KEY: "eb59c05f71245a5aab4cf185a21eca08", VITE_SHOPIFY_K3_LINK_ID: "d60dd7c1-6a43-459f-8d58-84ab6998b18f", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const Az = (e) => {
  let t;
  const i = /* @__PURE__ */ new Set(), n = (c, d) => {
    const C = typeof c == "function" ? c(t) : c;
    if (!Object.is(C, t)) {
      const A = t;
      t = d ?? (typeof C != "object" || C === null) ? C : Object.assign({}, t, C), i.forEach((b) => b(t, A));
    }
  }, r = () => t, a = { setState: n, getState: r, getInitialState: () => I, subscribe: (c) => (i.add(c), () => i.delete(c)), destroy: () => {
    (qEt ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), i.clear();
  } }, I = t = e(n, r, a);
  return a;
}, _Et = (e) => e ? Az(e) : Az;
var Jie = { exports: {} }, Eie = {}, Nie = { exports: {} }, Lie = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cm = De;
function $Et(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var eNt = typeof Object.is == "function" ? Object.is : $Et, tNt = Cm.useState, iNt = Cm.useEffect, nNt = Cm.useLayoutEffect, rNt = Cm.useDebugValue;
function gNt(e, t) {
  var i = t(), n = tNt({ inst: { value: i, getSnapshot: t } }), r = n[0].inst, g = n[1];
  return nNt(function() {
    r.value = i, r.getSnapshot = t, DF(r) && g({ inst: r });
  }, [e, i, t]), iNt(function() {
    return DF(r) && g({ inst: r }), e(function() {
      DF(r) && g({ inst: r });
    });
  }, [e]), rNt(i), i;
}
function DF(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var i = t();
    return !eNt(e, i);
  } catch {
    return !0;
  }
}
function oNt(e, t) {
  return t();
}
var lNt = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? oNt : gNt;
Lie.useSyncExternalStore = Cm.useSyncExternalStore !== void 0 ? Cm.useSyncExternalStore : lNt;
Nie.exports = Lie;
var aNt = Nie.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y1 = De, sNt = aNt;
function INt(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var cNt = typeof Object.is == "function" ? Object.is : INt, dNt = sNt.useSyncExternalStore, uNt = Y1.useRef, CNt = Y1.useEffect, ANt = Y1.useMemo, bNt = Y1.useDebugValue;
Eie.useSyncExternalStoreWithSelector = function(e, t, i, n, r) {
  var g = uNt(null);
  if (g.current === null) {
    var o = { hasValue: !1, value: null };
    g.current = o;
  } else
    o = g.current;
  g = ANt(function() {
    function a(A) {
      if (!I) {
        if (I = !0, c = A, A = n(A), r !== void 0 && o.hasValue) {
          var b = o.value;
          if (r(b, A))
            return d = b;
        }
        return d = A;
      }
      if (b = d, cNt(c, A))
        return b;
      var m = n(A);
      return r !== void 0 && r(b, m) ? b : (c = A, d = m);
    }
    var I = !1, c, d, C = i === void 0 ? null : i;
    return [function() {
      return a(t());
    }, C === null ? void 0 : function() {
      return a(C());
    }];
  }, [t, i, n, r]);
  var l = dNt(e, g[0], g[1]);
  return CNt(function() {
    o.hasValue = !0, o.value = l;
  }, [l]), bNt(l), l;
};
Jie.exports = Eie;
var hNt = Jie.exports;
const mNt = /* @__PURE__ */ go(hNt);
var Kie = { VITE_API_URL: "https://k3-api.objectcode.de", VITE_DOC_URL: "https://oc-k3.s3.amazonaws.com/assets", VITE_HELP_URL: "https://k3.objectcode.de/help", VITE_LIBS_URL: "https://oc-k3.s3.eu-central-1.amazonaws.com/libs/", VITE_ADMIN_ANALYTICS: "", VITE_BUGSNAG_KEY: "eb59c05f71245a5aab4cf185a21eca08", VITE_SHOPIFY_K3_LINK_ID: "d60dd7c1-6a43-459f-8d58-84ab6998b18f", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { useDebugValue: pNt } = De, { useSyncExternalStoreWithSelector: BNt } = mNt;
let bz = !1;
const fNt = (e) => e;
function ZNt(e, t = fNt, i) {
  (Kie ? "production" : void 0) !== "production" && i && !bz && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), bz = !0);
  const n = BNt(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    i
  );
  return pNt(n), n;
}
const GNt = (e) => {
  (Kie ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? _Et(e) : e, i = (n, r) => ZNt(t, n, r);
  return Object.assign(i, t), i;
}, yNt = (e) => GNt, Tl = yNt()((e, t) => ({
  hoveredSelections: [],
  hasHoveredSelection: (i) => t().hoveredSelections.includes(i),
  setHoveredSelection: (i) => {
    e({
      hoveredSelections: [i]
    });
  },
  addHoveredSelection: (i) => {
    e((n) => ({
      hoveredSelections: de.uniq([...n.hoveredSelections, i])
    }));
  },
  removeHoveredSelection: (i) => {
    e((n) => ({
      hoveredSelections: n.hoveredSelections.filter((r) => r !== i)
    }));
  },
  removeAllHoveredSelections: () => {
    e({
      hoveredSelections: []
    });
  }
})), WNt = function({
  group: e,
  variables: t
}) {
  var r;
  const i = Vn(Fs), n = (r = i.extendAdditionalVars) == null ? void 0 : r.call(i, () => null);
  return n ? /* @__PURE__ */ S(n, { group: e, variables: t }) : null;
};
class lD extends $d {
  constructor() {
    super(...arguments);
    Qi(this, "catchUnhandledRejectionErrors", !1);
  }
  renderError() {
    return /* @__PURE__ */ S(vo, { component: "div", className: "k3-area-error-boundary", sx: {
      padding: this.props.addPadding ? "16px" : "0px"
    }, children: /* @__PURE__ */ Ie(pi, { gap: 0.5, direction: "column", children: [
      /* @__PURE__ */ S(Ct, { variant: "h6", color: "error", children: Ug("Fehler") }),
      " ",
      /* @__PURE__ */ S("br", {}),
      /* @__PURE__ */ S(Ct, { variant: "subtitle1", children: Ug("Beim Rendern des Inhalts ist ein Fehler aufgetreten.") })
    ] }) });
  }
}
function Tie(e, t) {
  const i = ie(nr), n = (i == null ? void 0 : i.values.byVarId.all[e.id]) ?? [], g = Object.entries(Bte(e, t)).filter(([, l]) => l === "no-conflict").map(([l]) => +l).reduce((l, a) => {
    const I = n.find((c) => c.id === a);
    return I ? (l.push({
      value: I,
      conflicts: []
    }), l) : (console.error(`Value with id ${a} not found in valuesById for variable ${e.id} with label ${e.label} !`), l);
  }, []);
  return ie(NJ(e, t.id, g));
}
const Mie = (e) => (t) => {
  const {
    t: i
  } = Gi(), n = Tie(t.variable, t.contextInstance);
  return ie($r) && n !== null ? /* @__PURE__ */ S(kie, { message: i(n.text), children: /* @__PURE__ */ S(e, { ...t, dontHide: !0 }) }) : /* @__PURE__ */ S(e, { ...t, dontHide: !0 });
}, SNt = {
  fullWidth: {
    width: 1,
    marginLeft: 0,
    "& .MuiFormControlLabel-label": {
      width: 1
    }
  }
}, VNt = (e) => {
  const {
    fullWidth: t,
    "data-cy": i,
    label: n,
    onChange: r,
    ...g
  } = e, o = (l) => {
    r(l.target.checked);
  };
  return /* @__PURE__ */ S(rv, { "data-cy": i + "label", sx: t ? SNt.fullWidth : {}, label: n, control: /* @__PURE__ */ S(
    fZ,
    {
      "data-cy": i + "check",
      inputProps: {
        "data-cy": i + "checkInput"
      },
      ...g,
      onChange: o
    }
  ) });
}, hz = (e) => {
  switch (e == null ? void 0 : e.value) {
    case "0":
      return !1;
    case "1":
      return !0;
    default:
      return !!(e != null && e.value);
  }
}, _E = (e, t, i) => ({
  onBooleanChange: Gt((r) => {
    Le.flow(Le.find((g) => hz(g) === r), (g) => g == null ? void 0 : g.id, e)(i);
  }, [e, i]),
  checked: hz(t)
}), wNt = ({
  variable: e,
  value: t,
  onChange: i,
  values: n
}) => {
  const {
    checked: r,
    onBooleanChange: g
  } = _E(i, t, n);
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ S(VNt, { "data-cy": `varCheck-${e.id}`, fullWidth: !0, value: r, onChange: g }) });
}, vNt = Fo("checkbox")(wNt);
function Pie(e) {
  var t = { analogous: [-30, 0, 30], complementary: [0, 180], "double-split-complementary": [-30, 0, 30, 150, 210], rectangle: [0, 60, 180, 240], tetradic: [0, 90, 180, 270], triadic: [0, 120, 240], "split-complementary": [0, 150, 210] };
  e.prototype.harmonies = function(i) {
    var n = this;
    return i === void 0 && (i = "complementary"), t[i].map(function(r) {
      return n.rotate(r);
    });
  };
}
const Uie = {
  opacity: ".6",
  width: "-webkit-fill-available"
}, FA = (e) => {
  Gi();
  const t = Vg();
  if (!e.invalid)
    return e.children;
  const i = e.optionTitle ? `${e.optionTitle}: ` : "";
  return /* @__PURE__ */ S(Tn, { sx: {
    width: "-webkit-fill-available"
  }, title: i + t("translation_invalid_option_tooltip"), className: "k3-invalid-option", children: /* @__PURE__ */ S(vo, { component: "div", sx: {
    ...Uie,
    ...e.sx
  }, children: e.children }) });
}, RNt = (e) => e.invalid ? /* @__PURE__ */ S(FA, { invalid: !0, optionTitle: e.optionTitle, children: e.children }) : /* @__PURE__ */ S(Tn, { title: e.optionTitle, children: /* @__PURE__ */ S("div", { children: e.children }) }), zie = dl(({
  disabled: e,
  hexColor: t,
  isActive: i,
  onClick: n = Le.noop,
  children: r,
  borderRadius: g = 2,
  thumbnail: o,
  width: l = "100%",
  height: a = "100%",
  className: I,
  columnCount: c = 4,
  label: d,
  invalid: C
}, A) => {
  const {
    palette: b
  } = ql(), m = Oe(() => c < 4 ? "12px" : c < 8 ? "8px" : "6px", []);
  return /* @__PURE__ */ S(RNt, { optionTitle: d ?? "", invalid: C, children: /* @__PURE__ */ S(Xo, { "data-cy": "colorButton", ref: A, disabled: e, onClick: n, "aria-label": d, className: Re("k3-color-button", !!e && "disabled", !!i && "selected", C && "invalid-option", I), sx: {
    width: l,
    height: a,
    padding: m,
    outline: i ? "2px solid" : "1px solid",
    outlineColor: i ? b.primary.main + "!important" : b.action.disabled,
    "&.MuiButtonBase-root:hover": {
      outlineColor: b.action.active
    },
    backgroundImage: o ? `url(${o})` : "",
    backgroundColor: o ? "" : t,
    backgroundOrigin: "content-box",
    backgroundClip: "content-box",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    borderRadius: g
  }, children: r }) });
});
function XNt(e) {
  return /* @__PURE__ */ S(ht, { component: "img", sx: e.sx, width: e.width, src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==" });
}
const mz = {
  image: {
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    boxSizing: "border-box",
    objectFit: "contain",
    borderRadius: "8px"
  }
}, HNt = ({
  url: e,
  sx: t
}) => e ? /* @__PURE__ */ S(ht, { component: "img", sx: {
  ...mz.image,
  ...t
}, alt: "", src: e }) : /* @__PURE__ */ S(XNt, { sx: mz.image }), pz = (e) => {
  const {
    t
  } = Gi(), i = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  });
  return /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-price", sx: {
    ...e.sx,
    paddingRight: e.verticalDisplay ? 0 : "8px"
  }, children: /* @__PURE__ */ S(Ct, { variant: "overline", sx: {
    fontWeight: "bold"
  }, children: e.isPriceLoading ? /* @__PURE__ */ S(Yj, { animation: "pulse", variant: "text", width: 40 }) : /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S("span", { className: "k3-value-price-inner", children: i.format(e.price || 0) }),
    !!e.surCharges && e.surCharges != 0 && /* @__PURE__ */ S(Tn, { title: t("Weitere Preisauswirkungen dieser Selektion"), children: /* @__PURE__ */ S("div", { className: "k3-value-price-surcharges", children: /* @__PURE__ */ S(Ct, { variant: "subtitle2", children: /* @__PURE__ */ Ie("small", { style: {
      display: "block",
      fontWeight: "lighter",
      marginTop: "-10px",
      textAlign: "right",
      textWrap: "nowrap"
    }, children: [
      e.surCharges > 0 ? "+ " : "- ",
      i.format(e.surCharges > 0 ? e.surCharges : e.surCharges * -1)
    ] }) }) }) })
  ] }) }) });
}, kNt = (e) => {
  const t = ie(Er), i = (n, r) => {
    const g = (r.attrs || []).find((o) => o.attrId == n.id);
    if (!g)
      return null;
    switch (n.type) {
      case "string":
        const o = (g == null ? void 0 : g.value) || {};
        return r1(o, t);
      case "number":
        return (g == null ? void 0 : g.value) + " " + (n.unit || "");
      case "symbol":
      default:
        return JSON.stringify(g == null ? void 0 : g.value);
    }
  };
  return /* @__PURE__ */ S(Dj, { size: "small", sx: {
    [`& .${Ej.root}`]: {
      borderBottom: "none"
    }
  }, children: /* @__PURE__ */ S(Jj, { children: e.attrs.map((n) => /* @__PURE__ */ Ie($V, { children: [
    /* @__PURE__ */ S(Ur, { component: "th", scope: "row", children: /* @__PURE__ */ S(P9, { value: n.label }) }),
    /* @__PURE__ */ S(Ur, { children: i(n, e.value) })
  ] }, n.id)) }) });
}, YNt = (e) => {
  var o, l, a, I;
  const [t, i] = wt(!1), n = !!((o = e.value) != null && o.info) && ((l = e.value) == null ? void 0 : l.info) != "", r = !!((a = e.attrs) != null && a.length) && e.attrs.some((c) => {
    var d;
    return c.displayed && ((d = e.value.attrs) == null ? void 0 : d.find((C) => C.attrId == c.id && !!C.value));
  });
  if (!n && !r)
    return;
  const g = (c, d) => (c.preventDefault(), c.stopPropagation(), i(d), !1);
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Yie, { "data-cy": "value-info-btn", sx: e.sx || {
      height: "24px",
      lineHeight: "24px"
    }, onClick: (c) => g(c, !0), className: "k3-value-info" }),
    /* @__PURE__ */ S(o1, { className: "k3-value-info-modal", show: t, onClose: (c) => g(c, !1), type: "info", title: e.value.label, stopPropagation: !0, children: /* @__PURE__ */ Ie(Ct, { component: "div", children: [
      n && /* @__PURE__ */ S(rG, { htmlString: ((I = e.value) == null ? void 0 : I.info) ?? void 0, renderTarget: "value-info-modal" }),
      r && /* @__PURE__ */ S(kNt, { attrs: e.attrs, value: e.value })
    ] }) })
  ] });
}, Ss = {
  thumbnail: {
    gridArea: "Thumbnail",
    width: "100px",
    height: "100px",
    placeSelf: "start",
    overflow: "hidden"
    // AlignContent will be set based on showDescription and resulting centered or top down view
  },
  thumbnailVertical: {
    placeSelf: "start",
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "200px",
    overflow: "hidden"
  },
  gridAreaPrice: {
    gridArea: "Price",
    justifySelf: "end"
  },
  gridAreaInfo: {
    gridArea: "InfoIcon",
    justifySelf: "end"
    // AlignSelf will be set whether or not it should be centered next to label
  },
  gridAreaLabel: {
    gridArea: "Label",
    maxHeight: 100,
    overflow: "hidden"
  },
  gridAreaDescription: {
    gridArea: "Description",
    whiteSpace: "break-spaces",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
    // Styles for clamp, text align and place self will be added based on vertical or horizontal card style
  },
  gridAreaSpacer: {
    gridArea: "Spacer",
    // Grid Gap will be applied doubly here, bc it's a full width element technically.
    // Remove extra bottom margin to have url and price appear centered
    marginBottom: "-8px"
  },
  gridAreaUrl: {
    gridArea: "Url"
    // // Appear vertically centered with proper space to bottom or card.
    // minHeight: "32px",
  },
  gridUrlLink: {
    lineHeight: "32px;"
  },
  gridLabelText: {}
}, FNt = (e, t) => {
  var I, c, d, C, A, b, m, p, B, f, Z, y;
  if (typeof e.variableValue != typeof t.variableValue || e.verticalDisplay != t.verticalDisplay)
    return !1;
  const i = ((I = e.variableValue) == null ? void 0 : I.label) === ((c = t.variableValue) == null ? void 0 : c.label), n = mB(e, t, "showDescription", "description"), r = mB(e, t, "showUrl", "url"), g = mB(e, t, "showValuePrice", "price") && e.price == t.price && e.isPriceCalculated == t.isPriceCalculated, o = ((d = e.variable) == null ? void 0 : d.attrs) == ((C = t.variable) == null ? void 0 : C.attrs) && ((A = e.variableValue) == null ? void 0 : A.attrs) == ((b = t.variableValue) == null ? void 0 : b.attrs) && mB(e, t, "showInfo", "info"), l = mB(e, t, "showThumbnail", "thumbnail"), a = typeof ((m = e.variableValue) == null ? void 0 : m.attrs) == typeof ((p = t.variableValue) == null ? void 0 : p.attrs) && ((f = (B = e.variableValue) == null ? void 0 : B.attrs) == null ? void 0 : f.map((W) => W.value).sort().join()) == ((y = (Z = t.variableValue) == null ? void 0 : Z.attrs) == null ? void 0 : y.map((W) => W.value).sort().join());
  return i && n && r && o && l && a && g;
}, Oie = De.memo(({
  templateOptions: e,
  variableValue: t,
  variable: i,
  disableThumb: n,
  verticalDisplay: r,
  price: g,
  isPriceCalculated: o,
  children: l,
  ...a
}) => {
  var J, K, M, L;
  const I = ["colorDropdown", "colorRadio", "colorRadioCard", "colorSelect"].includes((J = i == null ? void 0 : i.settings) == null ? void 0 : J.template), {
    showLabel: c,
    showDescription: d,
    showInfo: C,
    showInfoContent: A,
    showValuePrice: b,
    showThumbnail: m,
    showUrl: p
  } = e || {}, B = !n && !["colorSelect", "selectThumbs"].includes((K = i == null ? void 0 : i.settings) == null ? void 0 : K.template) && (I || m), f = (t == null ? void 0 : t.infoContent) && A, Z = C || !!((L = (M = i == null ? void 0 : i.attrs) == null ? void 0 : M.filter((N) => !!N.displayed)) != null && L.length), y = b && (p || d), W = !r && NNt(e, !!B);
  function V() {
    const N = B ? "Thumbnail" : "Label", U = Z ? "InfoIcon" : "Label";
    let O = W ? '"Label' : `"${N} Label ${U}"`, $ = "auto", ne = W ? "1fr" : "auto 1fr auto";
    if (W && (Z && b ? (O += ' Price InfoIcon"', ne += " auto auto") : b || Z ? (O += ` ${b ? "Price" : "InfoIcon"}"`, ne += " auto") : O += '"'), d && (O += `"${B ? "Thumbnail" : "Description"} Description Description"`, $ += " minmax(10px, 1fr)"), f && (O += `"div1 div1 div1"
                 "infoContent infoContent infoContent"`, $ += " auto"), (p || y) && (O += `"Spacer Spacer Spacer"
    "Url Url Price"`, $ += " auto"), b && !y && !W) {
      const be = U == "Label" ? "Price" : "Label";
      O += `"${N} ${be} Price"`, $ += " auto";
    }
    return {
      template: O,
      rows: $,
      cols: ne
    };
  }
  function w() {
    let U = `"Thumbnail Thumbnail" 2fr
    "Label ${Z ? "InfoIcon" : "Label"}" minmax(0, max-content)
    "Description Description"minmax(0, max-content)`, O = "auto 1fr auto";
    return (b || p) && (U += `"Spacer Spacer" minmax(0, min-content)
        "Url Price" minmax(0, min-content)`, O += " auto auto"), {
      template: U,
      rows: O,
      cols: "1fr 0px"
    };
  }
  const v = r ? {
    ...Ss.thumbnail,
    ...Ss.thumbnailVertical
  } : {
    ...Ss.thumbnail,
    alignContent: d ? "start" : "center"
  }, H = r ? w() : V(), x = Z ? /* @__PURE__ */ S(YNt, { attrs: (i == null ? void 0 : i.attrs) || void 0, value: t }) : null;
  return /* @__PURE__ */ Ie(ht, { component: "div", children: [
    /* @__PURE__ */ Ie(ht, { component: "div", className: Re(
      "k3-value-grid",
      a.className
      //ToDO variableValue?.hasTouchedConflicts && "invalid-value",
    ), sx: {
      height: "100%",
      width: "100%",
      display: "grid",
      gap: r ? "8px" : "8px 16px",
      gridTemplate: H.template,
      gridTemplateRows: H.rows,
      gridTemplateColumns: H.cols,
      alignItems: r ? "start" : "center"
    }, children: [
      B && I && (t != null && t.value) ? /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-thumbnail k3-value-color", sx: {
        ...v,
        bgcolor: t == null ? void 0 : t.value,
        borderRadius: "8px"
      } }) : B && m && /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-thumbnail k3-value-image", sx: {
        ...v,
        bgcolor: t == null ? void 0 : t.value
      }, children: !I && /* @__PURE__ */ S(HNt, { sx: r ? {
        maxHeight: "200px"
      } : {
        // Align to top of parent container if it's not a centered view
        objectPosition: d ? "50% 0" : void 0,
        height: "min-content",
        // Needed for Safari...
        maxHeight: "100px"
      }, url: (t == null ? void 0 : t.thumbnail) ?? "https://placehold.co/200x200/" }) }),
      c && /* @__PURE__ */ S(ENt, { value: t == null ? void 0 : t.label, verticalDisplay: r }),
      b && !y && /* @__PURE__ */ S(pz, { sx: Ss.gridAreaPrice, price: (t == null ? void 0 : t.price) || (g == null ? void 0 : g.valuePrice), surCharges: t != null && t.price ? null : g == null ? void 0 : g.surCharges, isPriceLoading: o == !1, verticalDisplay: r }),
      d && /* @__PURE__ */ S(JNt, { value: t == null ? void 0 : t.description, verticalDisplay: r }),
      (t == null ? void 0 : t.infoContent) != null && (i == null ? void 0 : i.settings.templateOptions.showInfoContent) && /* @__PURE__ */ S(xNt, { value: t.infoContent }),
      (b && y || p) && /* @__PURE__ */ S(SI, { sx: Ss.gridAreaSpacer, className: "k3-value-footer" }),
      p && /* @__PURE__ */ S(DNt, { value: t == null ? void 0 : t.url }),
      b && y && /* @__PURE__ */ S(pz, { sx: Ss.gridAreaPrice, price: (t == null ? void 0 : t.price) || (g == null ? void 0 : g.valuePrice), surCharges: t != null && t.price ? null : g == null ? void 0 : g.surCharges, isPriceLoading: o == !1, verticalDisplay: r }),
      Z && /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-info", sx: {
        ...Ss.gridAreaInfo,
        paddingRight: r ? 0 : "8px",
        alignSelf: W ? "center" : "start"
      }, children: x && /* @__PURE__ */ S(ht, { component: "div", children: x }) })
    ] }),
    l
  ] });
}, FNt), xNt = (e) => /* @__PURE__ */ Ie(li, { children: [
  /* @__PURE__ */ S(SI, { sx: {
    gridArea: "div1"
  } }),
  /* @__PURE__ */ S(Ct, { component: "div", variant: "caption", gridArea: "infoContent", children: /* @__PURE__ */ S(rG, { htmlString: e.value || "", renderTarget: "value-card-content" }) })
] }), DNt = (e) => /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-url", sx: Ss.gridAreaUrl, children: !!e.value && /* @__PURE__ */ S(Xd, { "data-cy": `valueDetails-${e.value}`, align: "left", variant: "caption", href: e.value, target: "_blank", onClick: (t) => {
  t.stopPropagation;
}, sx: Ss.gridUrlLink, children: e.value }) }), JNt = (e) => /* @__PURE__ */ S(ht, { component: "div", className: "k3-value-description", sx: {
  ...Ss.gridAreaDescription,
  textAlign: e.verticalDisplay ? "center" : "left",
  // In vertical view, do not crop description
  WebkitLineClamp: e.verticalDisplay ? "initial" : "3",
  placeSelf: e.verticalDisplay ? "start center" : "start"
}, children: /* @__PURE__ */ S(Ct, { variant: "caption", children: e.value }) }), ENt = (e) => /* @__PURE__ */ S(ht, { component: "div", sx: {
  ...Ss.gridAreaLabel,
  textAlign: e.verticalDisplay ? "center" : "left",
  padding: e.verticalDisplay ? "0 12px" : void 0
}, className: "k3-value-label", "data-cy": "valueDetail-" + e.value, children: /* @__PURE__ */ S(
  Ct,
  {
    variant: "subtitle1",
    fontWeight: 500,
    noWrap: !e.verticalDisplay,
    children: e.value
  }
) }), mB = (e, t, i, n) => {
  var o, l, a;
  const r = e.templateOptions[i] == t.templateOptions[i], g = ((o = e.variableValue) == null ? void 0 : o[n]) == ((l = t.variableValue) == null ? void 0 : l[n]);
  return r && g || !r && !((a = t.variableValue) != null && a[n]);
}, NNt = (e, t) => e.showLabel && !e.showDescription && !e.showInfoContent && // showThumbnail can be false but still a thumbnail is displayed in grid when it's a color template.
!t && !e.showUrl, LNt = (e) => {
  const t = Vn(S1), i = rr(), n = ie(pA(e == null ? void 0 : e.id)), r = EWt(e == null ? void 0 : e.variableId), {
    priceTotal: g
  } = ie((m) => n ? _B(n == null ? void 0 : n.variableId, i)(m) : {
    priceTotal: 0
  }), [o, l] = De.useState(!1), [a, I] = De.useState(null), c = ie(WA), [d, C] = De.useState(null), A = ie((m) => m), b = () => {
    if (d == null)
      return null;
    const m = Em(d).priceTotal, p = _B(e == null ? void 0 : e.variableId, i)(A).priceTotal, B = _B(e == null ? void 0 : e.variableId, i)(d).priceTotal;
    let f = 0, Z = 0;
    return (r == null ? void 0 : r.type) === Ho.Components || (r == null ? void 0 : r.type) === Ho.MultiSelect ? (f = ys(+(m - c)), Z = ys(B - g)) : (f = ys(+(m - c + (g ?? 0))), Z = B), g == 0 && B == 0 ? {
      valuePrice: f,
      surCharges: 0,
      totalValuePrice: f
    } : {
      valuePrice: Z,
      surCharges: f - p,
      totalValuePrice: f
    };
  };
  return lt(() => {
    d != null && (I(b()), l(!0));
  }, [d]), lt(() => {
    if (!t || !n)
      return;
    const m = fv(), p = (B) => {
      if (n && B.valueId == (n == null ? void 0 : n.id) && B.contextInstanceId == i.id)
        if (B.state === "reset")
          l(!1), I(null);
        else if (B.state === "done") {
          const f = B.bomResult;
          C(f);
        } else
          console.warn("Unknown state in price worker:" + B);
    };
    return t.nextStateWorker.registerValueBundle(r, n, i, m, p, !0), () => {
      t.nextStateWorker.unregisterValueBundle(n, i, m);
    };
  }, [n, i, t]), {
    price: a,
    isPriceCalculated: o
  };
};
var aD = /* @__PURE__ */ new Map(), TS = /* @__PURE__ */ new WeakMap(), Bz = 0, KNt = void 0;
function TNt(e) {
  return e ? (TS.has(e) || (Bz += 1, TS.set(e, Bz.toString())), TS.get(e)) : "0";
}
function MNt(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? TNt(e.root) : e[t]}`).toString();
}
function PNt(e) {
  const t = MNt(e);
  let i = aD.get(t);
  if (!i) {
    const n = /* @__PURE__ */ new Map();
    let r;
    const g = new IntersectionObserver((o) => {
      o.forEach((l) => {
        var a;
        const I = l.isIntersecting && r.some((c) => l.intersectionRatio >= c);
        e.trackVisibility && typeof l.isVisible > "u" && (l.isVisible = I), (a = n.get(l.target)) == null || a.forEach((c) => {
          c(I, l);
        });
      });
    }, e);
    r = g.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), i = {
      id: t,
      observer: g,
      elements: n
    }, aD.set(t, i);
  }
  return i;
}
function UNt(e, t, i = {}, n = KNt) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const a = e.getBoundingClientRect();
    return t(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof i.threshold == "number" ? i.threshold : 0,
      time: 0,
      boundingClientRect: a,
      intersectionRect: a,
      rootBounds: a
    }), () => {
    };
  }
  const { id: r, observer: g, elements: o } = PNt(i), l = o.get(e) || [];
  return o.has(e) || o.set(e, l), l.push(t), g.observe(e), function() {
    l.splice(l.indexOf(t), 1), l.length === 0 && (o.delete(e), g.unobserve(e)), o.size === 0 && (g.disconnect(), aD.delete(r));
  };
}
function zNt({
  threshold: e,
  delay: t,
  trackVisibility: i,
  rootMargin: n,
  root: r,
  triggerOnce: g,
  skip: o,
  initialInView: l,
  fallbackInView: a,
  onChange: I
} = {}) {
  var c;
  const [d, C] = X.useState(null), A = X.useRef(), [b, m] = X.useState({
    inView: !!l,
    entry: void 0
  });
  A.current = I, X.useEffect(
    () => {
      if (o || !d)
        return;
      let Z;
      return Z = UNt(
        d,
        (y, W) => {
          m({
            inView: y,
            entry: W
          }), A.current && A.current(y, W), W.isIntersecting && g && Z && (Z(), Z = void 0);
        },
        {
          root: r,
          rootMargin: n,
          threshold: e,
          // @ts-ignore
          trackVisibility: i,
          // @ts-ignore
          delay: t
        },
        a
      ), () => {
        Z && Z();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      d,
      r,
      n,
      g,
      o,
      i,
      a,
      t
    ]
  );
  const p = (c = b.entry) == null ? void 0 : c.target, B = X.useRef();
  !d && p && !g && !o && B.current !== p && (B.current = p, m({
    inView: !!l,
    entry: void 0
  }));
  const f = [C, b.inView, b.entry];
  return f.ref = f[0], f.inView = f[1], f.entry = f[2], f;
}
const vI = (e) => {
  var r, g, o;
  const t = (r = Vi(e.variable)) == null ? void 0 : r.showValuePrice, {
    ref: i,
    inView: n
  } = zNt({
    threshold: 0,
    triggerOnce: !0
  });
  return /* @__PURE__ */ S("div", { ref: i, style: {
    width: "100%",
    height: "100%",
    ...e.style
  }, "data-cy": `valueCardWithData-${((g = e.variableValue) == null ? void 0 : g.label) ?? ((o = e.variableValue) == null ? void 0 : o.id)}`, children: t && n && !e.variableValue.price ? /* @__PURE__ */ S(ONt, { ...e }) : /* @__PURE__ */ S(Oie, { ...e }) });
}, ONt = (e) => {
  const {
    price: t,
    isPriceCalculated: i
  } = LNt(e.variableValue);
  return /* @__PURE__ */ S(Oie, { ...e, price: t, isPriceCalculated: i && t != null });
};
c$([Pie]);
const QNt = ({
  variable: e,
  values: t,
  value: i,
  onChange: n,
  columnCount: r = 4,
  borderRadius: g = 1,
  disabled: o = !1,
  invalidIds: l
}) => {
  const a = ot(null), I = Vi(e), {
    showLabel: c,
    showDescription: d,
    showInfo: C,
    showPrice: A,
    showUrl: b,
    showValue: m,
    showSelection: p,
    showInfoContent: B
  } = I || {};
  return /* @__PURE__ */ Ie(pi, { direction: "column", gap: 2, className: "k3-thumbnail-container", children: [
    /* @__PURE__ */ S(ht, { component: "div", className: "k3-thumbnail-values", ref: a, sx: {
      display: "grid",
      width: "100%",
      padding: "2px 0",
      gridTemplateColumns: `repeat(${r}, 1fr)`,
      gridAutoRows: "1fr",
      gap: 2,
      // places a hidden element to make grid items square
      "&::before": {
        content: '""',
        width: "0",
        paddingBottom: "100%",
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      },
      // set first item to grid start
      "& > div:first-of-type": {
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      }
    }, children: t.map((f) => /* @__PURE__ */ S(zie, { disabled: o, onClick: () => n == null ? void 0 : n(f.id || 0), isActive: (i == null ? void 0 : i.id) == f.id, hexColor: f.value, thumbnail: f == null ? void 0 : f.thumbnail, borderRadius: g, columnCount: r, className: "k3-thumbnail-color", label: f == null ? void 0 : f.label, invalid: (l == null ? void 0 : l.includes(f == null ? void 0 : f.id)) || !1 }, f.id)) }),
    (c || d || C || A || b || B || m || p) && /* @__PURE__ */ S(ul, { elevation: 0, sx: {
      border: "2px solid ",
      borderColor: "primary.main",
      p: 2
    }, children: /* @__PURE__ */ S(vI, { variable: e, templateOptions: I, variableValue: i, disableThumb: !0 }) })
  ] });
}, gG = (e) => ({
  disabled: e.disabled,
  variable: e.variable,
  values: e.values || [],
  onChange: e.onChange,
  invalidIds: e.touchedInvalidValueIds
}), jNt = ({
  value: e,
  ...t
}) => {
  const i = Vi(t.variable), n = Le.isNumber(i == null ? void 0 : i.borderRadius) ? i == null ? void 0 : i.borderRadius : 1;
  return /* @__PURE__ */ S(wg, { variable: t.variable, view: /* @__PURE__ */ S(QNt, { value: e, columnCount: i == null ? void 0 : i.numberOfColorsShown, borderRadius: n, ...gG(t) }) });
}, fz = Le.flow(ta, Fo("colorSelect"))(jNt), Zz = {
  root: {},
  rootDense: {
    p: 0
  }
}, cf = ({
  templateOptions: e,
  variable: t,
  variableValue: i,
  dense: n = !1,
  value: r,
  itemInvalid: g,
  ...o
}) => /* @__PURE__ */ Ie(yo, { "data-cy": `selectMenuItem-${i.label}`, sx: {
  ...n ? Zz.rootDense : Zz.root,
  "&:hover": {
    background: "unset"
  },
  textWrap: "wrap",
  ...g ? Uie : void 0
}, value: r, "aria-label": i.label, selected: o.selected, className: Re("k3-select-menu-item", g && "invalid-option"), ...o, children: [
  o.children,
  /* @__PURE__ */ S(FA, { invalid: g, children: /* @__PURE__ */ S(vI, { variable: t, variableValue: i, templateOptions: e }) })
] }), qNt = (e) => {
  const {
    palette: t
  } = ql(), i = (r, g) => {
    var o;
    return g ? e.onSelectionChanged(g, (o = e.options) == null ? void 0 : o.find((l) => l.id == g)) : e.onSelectionChanged();
  }, n = e.orientation == "horizontal" && e.colCount && e.colCount > 1 ? 100 / e.colCount - 1 : 100;
  return /* @__PURE__ */ S(ht, { component: "div", className: Re("k3-selection-cards-container", e.className), children: /* @__PURE__ */ S(BJ, { value: e.currentValue, exclusive: !0, sx: {
    gap: 1,
    flexWrap: "wrap"
  }, orientation: e.orientation ?? "vertical", onChange: i, "aria-label": "Selection Group", className: "k3-selection-group", fullWidth: e.fullWidth, "data-cy": e.dataCy ?? "k3-selection-group", children: e.options.map((r) => /* @__PURE__ */ S(lv, { "data-cy": r.dataCy ?? `k3-selection-option-${r.label}`, fullWidth: n == 100, value: r == null ? void 0 : r.id, disabled: r.disabled, color: "primary", className: Re("k3-selection-button", r.className, e.currentValue !== r.id && "selected"), sx: {
    "&.MuiToggleButton-root": {
      background: "unset"
    },
    "&.MuiToggleButton-root:hover": {
      background: "unset",
      borderColor: `${t.action.active} !important`
    },
    "&.MuiToggleButton-root:active": {
      background: "unset"
    },
    "&.MuiToggleButton-root.Mui-selected": {
      background: "unset",
      color: "text.primary",
      outline: "2px solid",
      outlineOffset: "-2px",
      outlineColor: `${t.primary.main} !important`,
      borderColor: `${t.primary.main} !important`
    },
    border: `1px solid ${t.action.disabled} !important`,
    borderRadius: "8px  !important",
    justifyContent: "flex-start",
    padding: 2,
    textAlign: "left",
    width: `${n}%`
  }, children: r.renderCardDetails(r) }, r == null ? void 0 : r.id)) }) });
};
var $E = {}, _Nt = yg;
Object.defineProperty($E, "__esModule", {
  value: !0
});
var Qie = $E.default = void 0, $Nt = _Nt(oo()), eLt = ro;
Qie = $E.default = (0, $Nt.default)(/* @__PURE__ */ (0, eLt.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const tLt = ({
  onSelected: e,
  variable: t,
  addItemLabel: i,
  value: n,
  values: r,
  touchedInvalidOptionsIds: g
}) => {
  const l = Vg()("translation_mp_popup_add"), a = {
    id: 0,
    label: i || l,
    appId: t.appId,
    variableId: t.id,
    value: "0",
    sort: 0
  };
  return /* @__PURE__ */ Ie(
    of,
    {
      "aria-label": l,
      "data-cy": "componentList",
      label: "",
      value: (n == null ? void 0 : n.id.toString()) || "0",
      onChange: (I) => {
        const c = r.find((d) => d.id == +I);
        c && (e == null || e(c));
      },
      disabled: r.length == 0,
      SelectProps: {
        renderValue: (I) => {
          const c = I == 0 ? a : r.find((d) => d.id == I);
          return c ? /* @__PURE__ */ S(cf, { dense: !0, value: I, variableValue: c, templateOptions: {
            showLabel: !0
          } }) : null;
        }
      },
      children: [
        /* @__PURE__ */ S(cf, { value: 0, variableValue: a, templateOptions: {
          showLabel: !0
        } }),
        r.map((I) => /* @__PURE__ */ S(cf, { value: I.id, variable: t, variableValue: I, templateOptions: t == null ? void 0 : t.settings.templateOptions, itemInvalid: (g == null ? void 0 : g.includes(I.id)) || !1 }, I.id))
      ]
    }
  );
}, sD = ({
  onSelected: e,
  variable: t,
  addItemLabel: i,
  value: n,
  fullWidth: r,
  colCount: g,
  verticalValueDisplay: o,
  values: l,
  touchedInvalidOptionsIds: a
}) => {
  const I = (c) => c ? l == null ? void 0 : l.find((d) => d.id.toString() == c) : null;
  return /* @__PURE__ */ S(qNt, { "data-cy": "add-item-cards", className: "add-item-selection", orientation: "horizontal", currentValue: (n == null ? void 0 : n.id.toString()) || "0", onSelectionChanged: (c) => {
    const d = I(c);
    d && (e == null || e(d));
  }, fullWidth: r, colCount: g, options: l == null ? void 0 : l.map((c) => ({
    id: c.id.toString(),
    label: c.label || "",
    renderCardDetails: (d) => /* @__PURE__ */ S(FA, { invalid: (a == null ? void 0 : a.includes(c == null ? void 0 : c.id)) || !1, children: /* @__PURE__ */ S(vI, { verticalDisplay: o, value: d.id, variable: t, variableValue: I(d.id), templateOptions: t == null ? void 0 : t.settings.templateOptions }, d.id) })
  })) });
}, iLt = (e) => {
  const t = Vi(e.variable), i = ie(Er), n = Oe(() => (o) => {
    if (o) {
      const l = typeof o == "object" ? r1(o, i) : o.toString();
      if (l)
        return l;
    }
    return e.defaultGroupLabel;
  }, [i]), r = (o) => {
    var a;
    const l = (a = o.attrs) == null ? void 0 : a.find((I) => I.attrId == t.groupBy);
    return n(l == null ? void 0 : l.value);
  }, g = Oe(() => {
    const o = {};
    return e.values.map((l) => {
      const a = r(l);
      o[a] ? o[a].push(l) : o[a] = [l];
    }), o;
  }, [i, e.values, t.groupBy]);
  return Object.keys(g).length ? /* @__PURE__ */ S(ht, { component: "div", "data-cy": "groupsWrapper", children: Object.keys(g).map((o) => /* @__PURE__ */ Ie(iJ, { "data-cy": "group-" + o, children: [
    /* @__PURE__ */ S(rJ, { expandIcon: /* @__PURE__ */ S(Qie, {}), "aria-controls": "panel1bh-content", id: "panel1bh-header", children: /* @__PURE__ */ S(Ct, { variant: "subtitle1", children: o }) }),
    /* @__PURE__ */ S(nJ, { children: /* @__PURE__ */ S(sD, { variable: e.variable, onSelected: e.onSelected, fullWidth: !0, value: void 0, colCount: e.colCount, verticalValueDisplay: e.verticalValueDisplay, values: g[o], touchedInvalidOptionsIds: e.touchedInvalidOptionsIds }) })
  ] }, o)) }) : /* @__PURE__ */ S(sD, { variable: e.variable, onSelected: e.onSelected, fullWidth: !0, value: void 0, colCount: e.colCount, verticalValueDisplay: e.verticalValueDisplay, values: e.values, touchedInvalidOptionsIds: e.touchedInvalidOptionsIds });
}, jie = (e, t, i, n) => (r, g) => {
  const o = g(), l = EJ(o, i, n, !1), a = n != null && n.settings.templateOptions.reverseSorting ? l.length - 1 - e : e, I = n != null && n.settings.templateOptions.reverseSorting ? l.length - 1 - t : t;
  if (a === I)
    return;
  const c = l.map((C) => C.selection), d = c[a];
  c.splice(a, 1), c.splice(I, 0, d), r(Gte(c));
}, nLt = (e, t, i, n) => (r, g) => jie(e, e + t, i, n)(r, g), rLt = (e, t, i) => (n, r) => {
  const g = r(), o = EJ(g, t, i, !1);
  return n(H1t(e, 1 + (de.max(o.map((l) => l.selection.sort)) || 0), t));
}, qie = ({
  index: e,
  onEdit: t,
  instance: i,
  dense: n = !0,
  leftToRight: r = !1,
  customElements: g = void 0
}) => {
  const {
    t: o
  } = Gi(), l = Ei(), a = rr(), I = ie(qr(i.variableId)), c = Vi(I), d = ie(LJ(qa(i) ?? "")), C = rp(d, I, !1), A = ie($r), b = ie(n_(i)) || A, m = (w) => {
    w.stopPropagation(), w.preventDefault(), t == null || t(i);
  }, p = (w) => {
    w.stopPropagation(), w.preventDefault(), l(QZ(i)), d && i.id === a.id && l(wr(d.id));
  }, B = async (w) => {
    w.stopPropagation(), w.preventDefault();
    const v = await l(rLt(i, d, I));
    v && i === a && l(wr(v.id));
  }, f = (w, v) => {
    l(nLt(w, v, d, I));
  };
  let Z = e <= 0, y = (w) => {
    w.stopPropagation(), w.preventDefault(), f == null || f(e, -1);
  }, W = e >= C.length - 1, V = (w) => {
    w.stopPropagation(), w.preventDefault(), f == null || f(e, 1);
  };
  if (r && !c.reverseSorting) {
    const w = Z, v = y;
    Z = W, y = V, W = w, V = v;
  }
  return /* @__PURE__ */ S(li, { children: /* @__PURE__ */ Ie(ht, { component: "div", className: "k3-select-item-actions", sx: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
    // MUI Buttons have a global marginRight of -12px so we need to add 12px here (why -12px ???)
    marginRight: "12px"
  }, children: [
    t && b && /* @__PURE__ */ S(Tn, { title: o("Bearbeiten"), disableInteractive: !0, children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(Ni, { edge: "end", "data-cy": "edit", className: "mp-inner-edit", onClick: m, children: /* @__PURE__ */ S(nq, { fontSize: n ? "small" : "large" }) }) }) }),
    (c == null ? void 0 : c.enableSorting) && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      display: "inline-flex",
      flexDirection: n ? "column" : "row",
      padding: "4px 0"
    }, children: [
      !Z || !n ? /* @__PURE__ */ S(Tn, { title: o("Hoch schieben"), disableInteractive: !0, children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(Ni, { edge: "end", "data-cy": "up", className: "mp-inner-up", sx: n ? {
        padding: "0px 8px"
      } : void 0, onClick: y, disabled: Z, children: n ? /* @__PURE__ */ S(JAt, { fontSize: "small" }) : /* @__PURE__ */ S(UAt, { fontSize: "large" }) }) }) }) : (
        // Placeholder div
        /* @__PURE__ */ S("div", { style: {
          height: "20px"
        } })
      ),
      !W || !n ? /* @__PURE__ */ S(Tn, { title: o("Runter schieben"), disableInteractive: !0, children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(Ni, { edge: "end", "data-cy": "down", className: "mp-inner-down", sx: n ? {
        padding: "0px 8px"
      } : void 0, onClick: V, disabled: W, children: n ? /* @__PURE__ */ S(DAt, { fontSize: "small" }) : /* @__PURE__ */ S(h9, { fontSize: "large" }) }) }) }) : (
        // Placeholder div
        /* @__PURE__ */ S("div", { style: {
          height: "20px"
        } })
      )
    ] }),
    (c == null ? void 0 : c.enableDuplication) && /* @__PURE__ */ S(Tn, { title: o("Duplizieren"), disableInteractive: !0, children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(Ni, { edge: "end", "data-cy": "copy", className: "mp-inner-copy", onClick: B, children: /* @__PURE__ */ S(KAt, { fontSize: n ? "small" : "medium", color: "action" }) }) }) }),
    /* @__PURE__ */ S(Tn, { title: (d == null ? void 0 : d.id) != i.id ? o("Löschen") : o("Löschen des aktiven Elements nicht möglich"), disableInteractive: !0, children: /* @__PURE__ */ S("span", { children: /* @__PURE__ */ S(Ni, { disabled: (d == null ? void 0 : d.id) == i.id, onClick: p, edge: "end", "data-cy": "del", className: "mp-inner-remove", children: /* @__PURE__ */ S(DZ, { fontSize: n ? "small" : "medium" }) }) }) }),
    De.Children.map(g, (w) => /* @__PURE__ */ S("span", { children: w }))
  ] }) });
}, gLt = () => {
  const e = ie(vZ("k3_cart_count"));
  return (t) => t == (e == null ? void 0 : e.parentId);
}, oLt = (e) => {
  const t = Ei(), i = ie(vZ("k3_cart_count")), n = ie(HWe(i.id, e)), r = ie(qr(n.variableId)), g = fte(r, n);
  return hte(async (o, l) => await t(pE(o, r.id, l, n)), n, r, g.values);
}, eN = (e) => ({
  "&.MuiToggleButton-root": {
    background: "unset"
  },
  "&.MuiToggleButton-root:hover": {
    background: "unset",
    borderColor: `${e.action.active} !important`
  },
  "&.MuiToggleButton-root:active": {
    background: "unset"
  },
  "&.MuiToggleButton-root.Mui-selected": {
    background: "unset",
    color: "text.primary",
    outline: "2px solid",
    outlineOffset: "-2px",
    outlineColor: `${e.primary.main} !important`,
    borderColor: `${e.primary.main} !important`
  },
  border: `1px solid ${e.action.disabled} !important`,
  borderRadius: "8px  !important",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: 2,
  textAlign: "left",
  background: e.background.paper
}), lLt = ({
  instanceId: e,
  variable: t
}) => {
  const i = oLt(e);
  return i ? (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ S("div", { onClick: (n) => n.stopPropagation(), onMouseDown: (n) => n.stopPropagation(), style: {
      width: "120px",
      marginRight: "10px",
      flexShrink: 0
    }, className: "k3-instance-count", children: /* @__PURE__ */ S(Zte, { placement: "top", isInRange: i.isInRange, resetNumber: i.resetNumber, variable: t, children: /* @__PURE__ */ S(O9, { buttons: !0, "data-cy": "count", onChange: i.onNumberChange, onChangeByStep: i.onInputBlur, onBlur: i.onInputBlur, value: i.pureNumber, TextFieldProps: {
      error: !i.isInRange
    } }) }) })
  ) : null;
}, aLt = (e, t) => e ? t ? t.reason == Oh.AlwaysHidden || t.reason == Oh.OneValidValue : !0 : !1, sLt = () => {
  const e = ZE(), t = NWt(), i = (n, r, g) => {
    if (n == "components") {
      const l = e.filter((a) => a.instance.belongsToVariableId == (g == null ? void 0 : g.id));
      return l.length > 0 ? l.map((a) => {
        var I;
        return (I = t.find((c) => c.id == a.valueId)) == null ? void 0 : I.label;
      }).join(", ") : void 0;
    }
    const o = t.find((l) => l.id == (r == null ? void 0 : r.valueId));
    return n === "boolean" || n === "color" || n === "list" ? o == null ? void 0 : o.label : void 0;
  };
  return (n, r, g) => {
    var a, I, c, d, C;
    if (!(r != null && r.type))
      return;
    const o = g ? (r == null ? void 0 : r.label) + ": " : "";
    let l;
    if (Hm(r))
      l = (a = n == null ? void 0 : n.data) == null ? void 0 : a.inputText;
    else if (Sg(r)) {
      const A = ((I = r == null ? void 0 : r.settings.templateOptions) == null ? void 0 : I.unit) || "", b = ((c = r == null ? void 0 : r.settings) == null ? void 0 : c.templateOptions.digits) || 0;
      l = ((C = (d = n == null ? void 0 : n.data) == null ? void 0 : d.inputValue) == null ? void 0 : C.OC_roundTo(b).toString()) + A;
    } else
      n != null && n.valueId && (l = i(r == null ? void 0 : r.type, n, r));
    return l != null ? o + l : void 0;
  };
}, ILt = (e, t, i) => {
  const n = JWt(), r = ZE(), g = sLt(), o = ie((l) => N9(l, i));
  return Oe(() => {
    const l = t.map((I) => n.find((c) => c.id == I)).filter((I) => I && aLt(I, o[I == null ? void 0 : I.id])).map((I) => {
      const c = r.find((d) => (d.instance.id == i.id || d.instance.belongsToVariableId == (I == null ? void 0 : I.id)) && d.variableId == (I == null ? void 0 : I.id));
      return {
        variable: I,
        selection: c
      };
    }), a = (I) => e.settings.templateOptions.hidePreviewVariableName || Hm(I);
    return l == null ? void 0 : l.map((I) => g(I.selection, I.variable, !a(I.variable))).filter((I) => I).join(", ");
  }, [t, n, o, r, i.id, e.settings.templateOptions.hidePreviewVariableName, g]);
}, cLt = ({
  index: e,
  onEdit: t,
  selection: i,
  value: n,
  variable: r,
  dragHandle: g
}) => {
  const o = Tl((p) => p.hoveredSelections), l = Tl((p) => p.setHoveredSelection), a = Tl((p) => p.removeHoveredSelection), I = ie(Ns), c = Vi(r), d = ILt(r, c.variablesAsPreview ?? [], i), C = i.id, A = gLt(), {
    palette: b
  } = AZ(), m = Oe(() => eN(b), [b]);
  return /* @__PURE__ */ Ie(
    kIe,
    {
      direction: "row",
      sx: m,
      style: {
        width: "100%",
        // highlight hovered selections
        background: o.includes(C) ? b.action.hover : b.background.paper,
        cursor: g ? "grab" : "pointer"
      },
      onClick: () => t(i),
      color: I.some((p) => p.id === C) ? "standard" : "primary",
      onMouseEnter: () => l(C),
      onMouseLeave: () => a(C),
      onMouseDown: () => a(C),
      children: [
        !!A(i.variableId) && i.id && r && /* @__PURE__ */ S(lLt, { instanceId: i.id, variable: r }),
        /* @__PURE__ */ S(vI, { variable: r, variableValue: n, templateOptions: Vi(r), children: d && /* @__PURE__ */ S(Tn, { title: d, children: /* @__PURE__ */ S(Ct, { variant: "subtitle2", color: "GrayText", noWrap: !0, "data-cy": "sublabel", children: d }) }) }, i.id),
        /* @__PURE__ */ S(qie, { index: e, instance: i, onEdit: t, customElements: g ? [g] : void 0 })
      ]
    }
  );
};
var tN = {}, dLt = yg;
Object.defineProperty(tN, "__esModule", {
  value: !0
});
var iN = tN.default = void 0, uLt = dLt(oo()), CLt = ro;
iN = tN.default = (0, uLt.default)(/* @__PURE__ */ (0, CLt.jsx)("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicator");
const _ie = ({
  disabled: e,
  provided: t,
  sx: i
}) => /* @__PURE__ */ S(ht, { component: "div", sx: {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  visibility: e ? "hidden" : "visible",
  ...i
}, children: /* @__PURE__ */ S(Ni, { "data-cy": "dragHandle", color: "editor", size: "small", ...t.dragHandleProps, children: /* @__PURE__ */ S(iN, { sx: {
  cursor: "grabbing"
} }) }) });
function $ie(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, DV(e, t);
}
function We(e, t, i) {
  return (t = Pj(t)) in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function Gz(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function yz(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gz(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Gz(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function qo(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Wz = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), JF = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Sz = {
  INIT: "@@redux/INIT" + JF(),
  REPLACE: "@@redux/REPLACE" + JF(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + JF();
  }
};
function ALt(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function ene(e, t, i) {
  var n;
  if (typeof t == "function" && typeof i == "function" || typeof i == "function" && typeof arguments[3] == "function")
    throw new Error(qo(0));
  if (typeof t == "function" && typeof i > "u" && (i = t, t = void 0), typeof i < "u") {
    if (typeof i != "function")
      throw new Error(qo(1));
    return i(ene)(e, t);
  }
  if (typeof e != "function")
    throw new Error(qo(2));
  var r = e, g = t, o = [], l = o, a = !1;
  function I() {
    l === o && (l = o.slice());
  }
  function c() {
    if (a)
      throw new Error(qo(3));
    return g;
  }
  function d(m) {
    if (typeof m != "function")
      throw new Error(qo(4));
    if (a)
      throw new Error(qo(5));
    var p = !0;
    return I(), l.push(m), function() {
      if (p) {
        if (a)
          throw new Error(qo(6));
        p = !1, I();
        var f = l.indexOf(m);
        l.splice(f, 1), o = null;
      }
    };
  }
  function C(m) {
    if (!ALt(m))
      throw new Error(qo(7));
    if (typeof m.type > "u")
      throw new Error(qo(8));
    if (a)
      throw new Error(qo(9));
    try {
      a = !0, g = r(g, m);
    } finally {
      a = !1;
    }
    for (var p = o = l, B = 0; B < p.length; B++) {
      var f = p[B];
      f();
    }
    return m;
  }
  function A(m) {
    if (typeof m != "function")
      throw new Error(qo(10));
    r = m, C({
      type: Sz.REPLACE
    });
  }
  function b() {
    var m, p = d;
    return m = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(f) {
        if (typeof f != "object" || f === null)
          throw new Error(qo(11));
        function Z() {
          f.next && f.next(c());
        }
        Z();
        var y = p(Z);
        return {
          unsubscribe: y
        };
      }
    }, m[Wz] = function() {
      return this;
    }, m;
  }
  return C({
    type: Sz.INIT
  }), n = {
    dispatch: C,
    subscribe: d,
    getState: c,
    replaceReducer: A
  }, n[Wz] = b, n;
}
function Vz(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function wz(e, t) {
  if (typeof e == "function")
    return Vz(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(qo(16));
  var i = {};
  for (var n in e) {
    var r = e[n];
    typeof r == "function" && (i[n] = Vz(r, t));
  }
  return i;
}
function tne() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, r) {
    return function() {
      return n(r.apply(void 0, arguments));
    };
  });
}
function bLt() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return function(n) {
    return function() {
      var r = n.apply(void 0, arguments), g = function() {
        throw new Error(qo(15));
      }, o = {
        getState: r.getState,
        dispatch: function() {
          return g.apply(void 0, arguments);
        }
      }, l = t.map(function(a) {
        return a(o);
      });
      return g = tne.apply(void 0, l)(r.dispatch), yz(yz({}, r), {}, {
        dispatch: g
      });
    };
  };
}
var ine = /* @__PURE__ */ De.createContext(null);
function hLt(e) {
  e();
}
var nne = hLt, mLt = function(t) {
  return nne = t;
}, pLt = function() {
  return nne;
};
function BLt() {
  var e = pLt(), t = null, i = null;
  return {
    clear: function() {
      t = null, i = null;
    },
    notify: function() {
      e(function() {
        for (var r = t; r; )
          r.callback(), r = r.next;
      });
    },
    get: function() {
      for (var r = [], g = t; g; )
        r.push(g), g = g.next;
      return r;
    },
    subscribe: function(r) {
      var g = !0, o = i = {
        callback: r,
        next: null,
        prev: i
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !g || t === null || (g = !1, o.next ? o.next.prev = o.prev : i = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
var vz = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function rne(e, t) {
  var i, n = vz;
  function r(d) {
    return a(), n.subscribe(d);
  }
  function g() {
    n.notify();
  }
  function o() {
    c.onStateChange && c.onStateChange();
  }
  function l() {
    return !!i;
  }
  function a() {
    i || (i = t ? t.addNestedSub(o) : e.subscribe(o), n = BLt());
  }
  function I() {
    i && (i(), i = void 0, n.clear(), n = vz);
  }
  var c = {
    addNestedSub: r,
    notifyNestedSubs: g,
    handleChangeWrapper: o,
    isSubscribed: l,
    trySubscribe: a,
    tryUnsubscribe: I,
    getListeners: function() {
      return n;
    }
  };
  return c;
}
var gne = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? lZ : lt;
function fLt(e) {
  var t = e.store, i = e.context, n = e.children, r = Oe(function() {
    var l = rne(t);
    return {
      store: t,
      subscription: l
    };
  }, [t]), g = Oe(function() {
    return t.getState();
  }, [t]);
  gne(function() {
    var l = r.subscription;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), g !== t.getState() && l.notifyNestedSubs(), function() {
      l.tryUnsubscribe(), l.onStateChange = null;
    };
  }, [r, g]);
  var o = i || ine;
  return /* @__PURE__ */ De.createElement(o.Provider, {
    value: r
  }, n);
}
var one = { exports: {} }, Nn = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F1 = 60103, x1 = 60106, oG = 60107, lG = 60108, aG = 60114, sG = 60109, IG = 60110, cG = 60112, dG = 60113, nN = 60120, uG = 60115, CG = 60116, lne = 60121, ane = 60122, sne = 60117, Ine = 60129, cne = 60131;
if (typeof Symbol == "function" && Symbol.for) {
  var Jg = Symbol.for;
  F1 = Jg("react.element"), x1 = Jg("react.portal"), oG = Jg("react.fragment"), lG = Jg("react.strict_mode"), aG = Jg("react.profiler"), sG = Jg("react.provider"), IG = Jg("react.context"), cG = Jg("react.forward_ref"), dG = Jg("react.suspense"), nN = Jg("react.suspense_list"), uG = Jg("react.memo"), CG = Jg("react.lazy"), lne = Jg("react.block"), ane = Jg("react.server.block"), sne = Jg("react.fundamental"), Ine = Jg("react.debug_trace_mode"), cne = Jg("react.legacy_hidden");
}
function Ms(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case F1:
        switch (e = e.type, e) {
          case oG:
          case aG:
          case lG:
          case dG:
          case nN:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case IG:
              case cG:
              case CG:
              case uG:
              case sG:
                return e;
              default:
                return t;
            }
        }
      case x1:
        return t;
    }
  }
}
var ZLt = sG, GLt = F1, yLt = cG, WLt = oG, SLt = CG, VLt = uG, wLt = x1, vLt = aG, RLt = lG, XLt = dG;
Nn.ContextConsumer = IG;
Nn.ContextProvider = ZLt;
Nn.Element = GLt;
Nn.ForwardRef = yLt;
Nn.Fragment = WLt;
Nn.Lazy = SLt;
Nn.Memo = VLt;
Nn.Portal = wLt;
Nn.Profiler = vLt;
Nn.StrictMode = RLt;
Nn.Suspense = XLt;
Nn.isAsyncMode = function() {
  return !1;
};
Nn.isConcurrentMode = function() {
  return !1;
};
Nn.isContextConsumer = function(e) {
  return Ms(e) === IG;
};
Nn.isContextProvider = function(e) {
  return Ms(e) === sG;
};
Nn.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === F1;
};
Nn.isForwardRef = function(e) {
  return Ms(e) === cG;
};
Nn.isFragment = function(e) {
  return Ms(e) === oG;
};
Nn.isLazy = function(e) {
  return Ms(e) === CG;
};
Nn.isMemo = function(e) {
  return Ms(e) === uG;
};
Nn.isPortal = function(e) {
  return Ms(e) === x1;
};
Nn.isProfiler = function(e) {
  return Ms(e) === aG;
};
Nn.isStrictMode = function(e) {
  return Ms(e) === lG;
};
Nn.isSuspense = function(e) {
  return Ms(e) === dG;
};
Nn.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === oG || e === aG || e === Ine || e === lG || e === dG || e === nN || e === cne || typeof e == "object" && e !== null && (e.$$typeof === CG || e.$$typeof === uG || e.$$typeof === sG || e.$$typeof === IG || e.$$typeof === cG || e.$$typeof === sne || e.$$typeof === lne || e[0] === ane);
};
Nn.typeOf = Ms;
one.exports = Nn;
var HLt = one.exports, kLt = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], YLt = ["reactReduxForwardedRef"], FLt = [], xLt = [null, null];
function DLt(e, t) {
  var i = e[1];
  return [t.payload, i + 1];
}
function Rz(e, t, i) {
  gne(function() {
    return e.apply(void 0, t);
  }, i);
}
function JLt(e, t, i, n, r, g, o) {
  e.current = n, t.current = r, i.current = !1, g.current && (g.current = null, o());
}
function ELt(e, t, i, n, r, g, o, l, a, I) {
  if (e) {
    var c = !1, d = null, C = function() {
      if (!c) {
        var m = t.getState(), p, B;
        try {
          p = n(m, r.current);
        } catch (f) {
          B = f, d = f;
        }
        B || (d = null), p === g.current ? o.current || a() : (g.current = p, l.current = p, o.current = !0, I({
          type: "STORE_UPDATED",
          payload: {
            error: B
          }
        }));
      }
    };
    i.onStateChange = C, i.trySubscribe(), C();
    var A = function() {
      if (c = !0, i.tryUnsubscribe(), i.onStateChange = null, d)
        throw d;
    };
    return A;
  }
}
var NLt = function() {
  return [null, 0];
};
function LLt(e, t) {
  t === void 0 && (t = {});
  var i = t, n = i.getDisplayName, r = n === void 0 ? function(Z) {
    return "ConnectAdvanced(" + Z + ")";
  } : n, g = i.methodName, o = g === void 0 ? "connectAdvanced" : g, l = i.renderCountProp, a = l === void 0 ? void 0 : l, I = i.shouldHandleStateChanges, c = I === void 0 ? !0 : I, d = i.storeKey, C = d === void 0 ? "store" : d;
  i.withRef;
  var A = i.forwardRef, b = A === void 0 ? !1 : A, m = i.context, p = m === void 0 ? ine : m, B = jr(i, kLt), f = p;
  return function(y) {
    var W = y.displayName || y.name || "Component", V = r(W), w = et({}, B, {
      getDisplayName: r,
      methodName: o,
      renderCountProp: a,
      shouldHandleStateChanges: c,
      storeKey: C,
      displayName: V,
      wrappedComponentName: W,
      WrappedComponent: y
    }), v = B.pure;
    function H(L) {
      return e(L.dispatch, w);
    }
    var x = v ? Oe : function(L) {
      return L();
    };
    function J(L) {
      var N = Oe(function() {
        var te = L.reactReduxForwardedRef, Xt = jr(L, YLt);
        return [L.context, te, Xt];
      }, [L]), U = N[0], O = N[1], $ = N[2], ne = Oe(function() {
        return U && U.Consumer && HLt.isContextConsumer(/* @__PURE__ */ De.createElement(U.Consumer, null)) ? U : f;
      }, [U, f]), be = Vn(ne), Ve = !!L.store && !!L.store.getState && !!L.store.dispatch;
      be && be.store;
      var He = Ve ? L.store : be.store, Je = Oe(function() {
        return H(He);
      }, [He]), ke = Oe(function() {
        if (!c)
          return xLt;
        var te = rne(He, Ve ? null : be.subscription), Xt = te.notifyNestedSubs.bind(te);
        return [te, Xt];
      }, [He, Ve, be]), we = ke[0], ue = ke[1], Xe = Oe(function() {
        return Ve ? be : et({}, be, {
          subscription: we
        });
      }, [Ve, be, we]), Ze = aZ(DLt, FLt, NLt), xe = Ze[0], Pe = xe[0], st = Ze[1];
      if (Pe && Pe.error)
        throw Pe.error;
      var bt = ot(), it = ot($), Qe = ot(), $e = ot(!1), It = x(function() {
        return Qe.current && $ === it.current ? Qe.current : Je(He.getState(), $);
      }, [He, Pe, $]);
      Rz(JLt, [it, bt, $e, $, It, Qe, ue]), Rz(ELt, [c, He, we, Je, it, bt, $e, Qe, ue, st], [He, we, Je]);
      var jt = Oe(function() {
        return /* @__PURE__ */ De.createElement(y, et({}, It, {
          ref: O
        }));
      }, [O, y, It]), Bt = Oe(function() {
        return c ? /* @__PURE__ */ De.createElement(ne.Provider, {
          value: Xe
        }, jt) : jt;
      }, [ne, jt, Xe]);
      return Bt;
    }
    var K = v ? De.memo(J) : J;
    if (K.WrappedComponent = y, K.displayName = J.displayName = V, b) {
      var M = De.forwardRef(function(N, U) {
        return /* @__PURE__ */ De.createElement(K, et({}, N, {
          reactReduxForwardedRef: U
        }));
      });
      return M.displayName = V, M.WrappedComponent = y, bL(M, y);
    }
    return bL(K, y);
  };
}
function Xz(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function EF(e, t) {
  if (Xz(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var i = Object.keys(e), n = Object.keys(t);
  if (i.length !== n.length)
    return !1;
  for (var r = 0; r < i.length; r++)
    if (!Object.prototype.hasOwnProperty.call(t, i[r]) || !Xz(e[i[r]], t[i[r]]))
      return !1;
  return !0;
}
function KLt(e, t) {
  var i = {}, n = function(o) {
    var l = e[o];
    typeof l == "function" && (i[o] = function() {
      return t(l.apply(void 0, arguments));
    });
  };
  for (var r in e)
    n(r);
  return i;
}
function rN(e) {
  return function(i, n) {
    var r = e(i, n);
    function g() {
      return r;
    }
    return g.dependsOnOwnProps = !1, g;
  };
}
function Hz(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function dne(e, t) {
  return function(n, r) {
    r.displayName;
    var g = function(l, a) {
      return g.dependsOnOwnProps ? g.mapToProps(l, a) : g.mapToProps(l);
    };
    return g.dependsOnOwnProps = !0, g.mapToProps = function(l, a) {
      g.mapToProps = e, g.dependsOnOwnProps = Hz(e);
      var I = g(l, a);
      return typeof I == "function" && (g.mapToProps = I, g.dependsOnOwnProps = Hz(I), I = g(l, a)), I;
    }, g;
  };
}
function TLt(e) {
  return typeof e == "function" ? dne(e) : void 0;
}
function MLt(e) {
  return e ? void 0 : rN(function(t) {
    return {
      dispatch: t
    };
  });
}
function PLt(e) {
  return e && typeof e == "object" ? rN(function(t) {
    return KLt(e, t);
  }) : void 0;
}
const ULt = [TLt, MLt, PLt];
function zLt(e) {
  return typeof e == "function" ? dne(e) : void 0;
}
function OLt(e) {
  return e ? void 0 : rN(function() {
    return {};
  });
}
const QLt = [zLt, OLt];
function jLt(e, t, i) {
  return et({}, i, e, t);
}
function qLt(e) {
  return function(i, n) {
    n.displayName;
    var r = n.pure, g = n.areMergedPropsEqual, o = !1, l;
    return function(I, c, d) {
      var C = e(I, c, d);
      return o ? (!r || !g(C, l)) && (l = C) : (o = !0, l = C), l;
    };
  };
}
function _Lt(e) {
  return typeof e == "function" ? qLt(e) : void 0;
}
function $Lt(e) {
  return e ? void 0 : function() {
    return jLt;
  };
}
const eKt = [_Lt, $Lt];
var tKt = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function iKt(e, t, i, n) {
  return function(g, o) {
    return i(e(g, o), t(n, o), o);
  };
}
function nKt(e, t, i, n, r) {
  var g = r.areStatesEqual, o = r.areOwnPropsEqual, l = r.areStatePropsEqual, a = !1, I, c, d, C, A;
  function b(Z, y) {
    return I = Z, c = y, d = e(I, c), C = t(n, c), A = i(d, C, c), a = !0, A;
  }
  function m() {
    return d = e(I, c), t.dependsOnOwnProps && (C = t(n, c)), A = i(d, C, c), A;
  }
  function p() {
    return e.dependsOnOwnProps && (d = e(I, c)), t.dependsOnOwnProps && (C = t(n, c)), A = i(d, C, c), A;
  }
  function B() {
    var Z = e(I, c), y = !l(Z, d);
    return d = Z, y && (A = i(d, C, c)), A;
  }
  function f(Z, y) {
    var W = !o(y, c), V = !g(Z, I, y, c);
    return I = Z, c = y, W && V ? m() : W ? p() : V ? B() : A;
  }
  return function(y, W) {
    return a ? f(y, W) : b(y, W);
  };
}
function rKt(e, t) {
  var i = t.initMapStateToProps, n = t.initMapDispatchToProps, r = t.initMergeProps, g = jr(t, tKt), o = i(e, g), l = n(e, g), a = r(e, g), I = g.pure ? nKt : iKt;
  return I(o, l, a, e, g);
}
var gKt = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function NF(e, t, i) {
  for (var n = t.length - 1; n >= 0; n--) {
    var r = t[n](e);
    if (r)
      return r;
  }
  return function(g, o) {
    throw new Error("Invalid value of type " + typeof e + " for " + i + " argument when connecting component " + o.wrappedComponentName + ".");
  };
}
function oKt(e, t) {
  return e === t;
}
function lKt(e) {
  var t = {}, i = t.connectHOC, n = i === void 0 ? LLt : i, r = t.mapStateToPropsFactories, g = r === void 0 ? QLt : r, o = t.mapDispatchToPropsFactories, l = o === void 0 ? ULt : o, a = t.mergePropsFactories, I = a === void 0 ? eKt : a, c = t.selectorFactory, d = c === void 0 ? rKt : c;
  return function(A, b, m, p) {
    p === void 0 && (p = {});
    var B = p, f = B.pure, Z = f === void 0 ? !0 : f, y = B.areStatesEqual, W = y === void 0 ? oKt : y, V = B.areOwnPropsEqual, w = V === void 0 ? EF : V, v = B.areStatePropsEqual, H = v === void 0 ? EF : v, x = B.areMergedPropsEqual, J = x === void 0 ? EF : x, K = jr(B, gKt), M = NF(A, g, "mapStateToProps"), L = NF(b, l, "mapDispatchToProps"), N = NF(m, I, "mergeProps");
    return n(d, et({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(O) {
        return "Connect(" + O + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!A,
      // passed through to selectorFactory
      initMapStateToProps: M,
      initMapDispatchToProps: L,
      initMergeProps: N,
      pure: Z,
      areStatesEqual: W,
      areOwnPropsEqual: w,
      areStatePropsEqual: H,
      areMergedPropsEqual: J
    }, K));
  };
}
const une = /* @__PURE__ */ lKt();
mLt(Vh);
function aKt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function Cne(e, t) {
  var i = wt(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], n = ot(!0), r = ot(i), g = n.current || !!(t && r.current.inputs && aKt(t, r.current.inputs)), o = g ? r.current : {
    inputs: t,
    result: e()
  };
  return lt(function() {
    n.current = !1, r.current = o;
  }, [o]), o.result;
}
function sKt(e, t) {
  return Cne(function() {
    return e;
  }, t);
}
var en = Cne, Ii = sKt, IKt = "Invariant failed";
function cKt(e, t) {
  throw new Error(IKt);
}
var vs = function(t) {
  var i = t.top, n = t.right, r = t.bottom, g = t.left, o = n - g, l = r - i, a = {
    top: i,
    right: n,
    bottom: r,
    left: g,
    width: o,
    height: l,
    x: g,
    y: i,
    center: {
      x: (n + g) / 2,
      y: (r + i) / 2
    }
  };
  return a;
}, gN = function(t, i) {
  return {
    top: t.top - i.top,
    left: t.left - i.left,
    bottom: t.bottom + i.bottom,
    right: t.right + i.right
  };
}, kz = function(t, i) {
  return {
    top: t.top + i.top,
    left: t.left + i.left,
    bottom: t.bottom - i.bottom,
    right: t.right - i.right
  };
}, dKt = function(t, i) {
  return {
    top: t.top + i.y,
    left: t.left + i.x,
    bottom: t.bottom + i.y,
    right: t.right + i.x
  };
}, LF = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, oN = function(t) {
  var i = t.borderBox, n = t.margin, r = n === void 0 ? LF : n, g = t.border, o = g === void 0 ? LF : g, l = t.padding, a = l === void 0 ? LF : l, I = vs(gN(i, r)), c = vs(kz(i, o)), d = vs(kz(c, a));
  return {
    marginBox: I,
    borderBox: vs(i),
    paddingBox: c,
    contentBox: d,
    margin: r,
    border: o,
    padding: a
  };
}, ma = function(t) {
  var i = t.slice(0, -2), n = t.slice(-2);
  if (n !== "px")
    return 0;
  var r = Number(i);
  return isNaN(r) && cKt(), r;
}, uKt = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, Kw = function(t, i) {
  var n = t.borderBox, r = t.border, g = t.margin, o = t.padding, l = dKt(n, i);
  return oN({
    borderBox: l,
    border: r,
    margin: g,
    padding: o
  });
}, Tw = function(t, i) {
  return i === void 0 && (i = uKt()), Kw(t, i);
}, Ane = function(t, i) {
  var n = {
    top: ma(i.marginTop),
    right: ma(i.marginRight),
    bottom: ma(i.marginBottom),
    left: ma(i.marginLeft)
  }, r = {
    top: ma(i.paddingTop),
    right: ma(i.paddingRight),
    bottom: ma(i.paddingBottom),
    left: ma(i.paddingLeft)
  }, g = {
    top: ma(i.borderTopWidth),
    right: ma(i.borderRightWidth),
    bottom: ma(i.borderBottomWidth),
    left: ma(i.borderLeftWidth)
  };
  return oN({
    borderBox: t,
    margin: n,
    padding: r,
    border: g
  });
}, bne = function(t) {
  var i = t.getBoundingClientRect(), n = window.getComputedStyle(t);
  return Ane(i, n);
}, Yz = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function CKt(e, t) {
  return !!(e === t || Yz(e) && Yz(t));
}
function AKt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (!CKt(e[i], t[i]))
      return !1;
  return !0;
}
function Bg(e, t) {
  t === void 0 && (t = AKt);
  var i, n = [], r, g = !1;
  function o() {
    for (var l = [], a = 0; a < arguments.length; a++)
      l[a] = arguments[a];
    return g && i === this && t(l, n) || (r = e.apply(this, l), g = !0, i = this, n = l), r;
  }
  return o;
}
var _f = function(t) {
  var i = [], n = null, r = function() {
    for (var o = arguments.length, l = new Array(o), a = 0; a < o; a++)
      l[a] = arguments[a];
    i = l, !n && (n = requestAnimationFrame(function() {
      n = null, t.apply(void 0, i);
    }));
  };
  return r.cancel = function() {
    n && (cancelAnimationFrame(n), n = null);
  }, r;
};
function hne(e, t) {
}
hne.bind(null, "warn");
hne.bind(null, "error");
function Md() {
}
function bKt(e, t) {
  return F({}, e, {}, t);
}
function Ya(e, t, i) {
  var n = t.map(function(r) {
    var g = bKt(i, r.options);
    return e.addEventListener(r.eventName, r.fn, g), function() {
      e.removeEventListener(r.eventName, r.fn, g);
    };
  });
  return function() {
    n.forEach(function(g) {
      g();
    });
  };
}
var hKt = "Invariant failed";
function Mw(e) {
  this.message = e;
}
Mw.prototype.toString = function() {
  return this.message;
};
function St(e, t) {
  throw new Mw(hKt);
}
var mKt = function(e) {
  $ie(t, e);
  function t() {
    for (var n, r = arguments.length, g = new Array(r), o = 0; o < r; o++)
      g[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(g)) || this, n.callbacks = null, n.unbind = Md, n.onWindowError = function(l) {
      var a = n.getCallbacks();
      a.isDragging() && a.tryAbort();
      var I = l.error;
      I instanceof Mw && l.preventDefault();
    }, n.getCallbacks = function() {
      if (!n.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return n.callbacks;
    }, n.setCallbacks = function(l) {
      n.callbacks = l;
    }, n;
  }
  var i = t.prototype;
  return i.componentDidMount = function() {
    this.unbind = Ya(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, i.componentDidCatch = function(r) {
    if (r instanceof Mw) {
      this.setState({});
      return;
    }
    throw r;
  }, i.componentWillUnmount = function() {
    this.unbind();
  }, i.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(De.Component), pKt = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, Pw = function(t) {
  return t + 1;
}, BKt = function(t) {
  return `
  You have lifted an item in position ` + Pw(t.source.index) + `
`;
}, mne = function(t, i) {
  var n = t.droppableId === i.droppableId, r = Pw(t.index), g = Pw(i.index);
  return n ? `
      You have moved the item from position ` + r + `
      to position ` + g + `
    ` : `
    You have moved the item from position ` + r + `
    in list ` + t.droppableId + `
    to list ` + i.droppableId + `
    in position ` + g + `
  `;
}, pne = function(t, i, n) {
  var r = i.droppableId === n.droppableId;
  return r ? `
      The item ` + t + `
      has been combined with ` + n.draggableId : `
      The item ` + t + `
      in list ` + i.droppableId + `
      has been combined with ` + n.draggableId + `
      in list ` + n.droppableId + `
    `;
}, fKt = function(t) {
  var i = t.destination;
  if (i)
    return mne(t.source, i);
  var n = t.combine;
  return n ? pne(t.draggableId, t.source, n) : "You are over an area that cannot be dropped on";
}, Fz = function(t) {
  return `
  The item has returned to its starting position
  of ` + Pw(t.index) + `
`;
}, ZKt = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + Fz(t.source) + `
    `;
  var i = t.destination, n = t.combine;
  return i ? `
      You have dropped the item.
      ` + mne(t.source, i) + `
    ` : n ? `
      You have dropped the item.
      ` + pne(t.draggableId, t.source, n) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + Fz(t.source) + `
  `;
}, kV = {
  dragHandleUsageInstructions: pKt,
  onDragStart: BKt,
  onDragUpdate: fKt,
  onDragEnd: ZKt
}, Zg = {
  x: 0,
  y: 0
}, Pg = function(t, i) {
  return {
    x: t.x + i.x,
    y: t.y + i.y
  };
}, El = function(t, i) {
  return {
    x: t.x - i.x,
    y: t.y - i.y
  };
}, Pd = function(t, i) {
  return t.x === i.x && t.y === i.y;
}, qm = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, sA = function(t, i, n) {
  var r;
  return n === void 0 && (n = 0), r = {}, r[t] = i, r[t === "x" ? "y" : "x"] = n, r;
}, $f = function(t, i) {
  return Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2));
}, xz = function(t, i) {
  return Math.min.apply(Math, i.map(function(n) {
    return $f(t, n);
  }));
}, Bne = function(t) {
  return function(i) {
    return {
      x: t(i.x),
      y: t(i.y)
    };
  };
}, GKt = function(e, t) {
  var i = vs({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return i.width <= 0 || i.height <= 0 ? null : i;
}, AG = function(t, i) {
  return {
    top: t.top + i.y,
    left: t.left + i.x,
    bottom: t.bottom + i.y,
    right: t.right + i.x
  };
}, Dz = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, yKt = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, WKt = function(t, i) {
  return i ? AG(t, i.scroll.diff.displacement) : t;
}, SKt = function(t, i, n) {
  if (n && n.increasedBy) {
    var r;
    return F({}, t, (r = {}, r[i.end] = t[i.end] + n.increasedBy[i.line], r));
  }
  return t;
}, VKt = function(t, i) {
  return i && i.shouldClipSubject ? GKt(i.pageMarginBox, t) : vs(t);
}, Am = function(e) {
  var t = e.page, i = e.withPlaceholder, n = e.axis, r = e.frame, g = WKt(t.marginBox, r), o = SKt(g, n, i), l = VKt(o, r);
  return {
    page: t,
    withPlaceholder: i,
    active: l
  };
}, lN = function(e, t) {
  e.frame || St();
  var i = e.frame, n = El(t, i.scroll.initial), r = qm(n), g = F({}, i, {
    scroll: {
      initial: i.scroll.initial,
      current: t,
      diff: {
        value: n,
        displacement: r
      },
      max: i.scroll.max
    }
  }), o = Am({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: g
  }), l = F({}, e, {
    frame: g,
    subject: o
  });
  return l;
};
function Uw(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function aN(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var i = 0; i < e.length; i++)
    if (t(e[i]))
      return i;
  return -1;
}
function Zu(e, t) {
  if (e.find)
    return e.find(t);
  var i = aN(e, t);
  if (i !== -1)
    return e[i];
}
function fne(e) {
  return Array.prototype.slice.call(e);
}
var Zne = Bg(function(e) {
  return e.reduce(function(t, i) {
    return t[i.descriptor.id] = i, t;
  }, {});
}), Gne = Bg(function(e) {
  return e.reduce(function(t, i) {
    return t[i.descriptor.id] = i, t;
  }, {});
}), D1 = Bg(function(e) {
  return Uw(e);
}), wKt = Bg(function(e) {
  return Uw(e);
}), _m = Bg(function(e, t) {
  var i = wKt(t).filter(function(n) {
    return e === n.descriptor.droppableId;
  }).sort(function(n, r) {
    return n.descriptor.index - r.descriptor.index;
  });
  return i;
});
function sN(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function J1(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var E1 = Bg(function(e, t) {
  return t.filter(function(i) {
    return i.descriptor.id !== e.descriptor.id;
  });
}), vKt = function(e) {
  var t = e.isMovingForward, i = e.draggable, n = e.destination, r = e.insideDestination, g = e.previousImpact;
  if (!n.isCombineEnabled)
    return null;
  var o = sN(g);
  if (!o)
    return null;
  function l(m) {
    var p = {
      type: "COMBINE",
      combine: {
        draggableId: m,
        droppableId: n.descriptor.id
      }
    };
    return F({}, g, {
      at: p
    });
  }
  var a = g.displaced.all, I = a.length ? a[0] : null;
  if (t)
    return I ? l(I) : null;
  var c = E1(i, r);
  if (!I) {
    if (!c.length)
      return null;
    var d = c[c.length - 1];
    return l(d.descriptor.id);
  }
  var C = aN(c, function(m) {
    return m.descriptor.id === I;
  });
  C === -1 && St();
  var A = C - 1;
  if (A < 0)
    return null;
  var b = c[A];
  return l(b.descriptor.id);
}, $m = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, yne = {
  point: Zg,
  value: 0
}, eZ = {
  invisible: {},
  visible: {},
  all: []
}, RKt = {
  displaced: eZ,
  displacedBy: yne,
  at: null
}, Da = function(e, t) {
  return function(i) {
    return e <= i && i <= t;
  };
}, Wne = function(e) {
  var t = Da(e.top, e.bottom), i = Da(e.left, e.right);
  return function(n) {
    var r = t(n.top) && t(n.bottom) && i(n.left) && i(n.right);
    if (r)
      return !0;
    var g = t(n.top) || t(n.bottom), o = i(n.left) || i(n.right), l = g && o;
    if (l)
      return !0;
    var a = n.top < e.top && n.bottom > e.bottom, I = n.left < e.left && n.right > e.right, c = a && I;
    if (c)
      return !0;
    var d = a && o || I && g;
    return d;
  };
}, XKt = function(e) {
  var t = Da(e.top, e.bottom), i = Da(e.left, e.right);
  return function(n) {
    var r = t(n.top) && t(n.bottom) && i(n.left) && i(n.right);
    return r;
  };
}, IN = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, Sne = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, HKt = function(e) {
  return function(t) {
    var i = Da(t.top, t.bottom), n = Da(t.left, t.right);
    return function(r) {
      return e === IN ? i(r.top) && i(r.bottom) : n(r.left) && n(r.right);
    };
  };
}, kKt = function(t, i) {
  var n = i.frame ? i.frame.scroll.diff.displacement : Zg;
  return AG(t, n);
}, YKt = function(t, i, n) {
  return i.subject.active ? n(i.subject.active)(t) : !1;
}, FKt = function(t, i, n) {
  return n(i)(t);
}, cN = function(t) {
  var i = t.target, n = t.destination, r = t.viewport, g = t.withDroppableDisplacement, o = t.isVisibleThroughFrameFn, l = g ? kKt(i, n) : i;
  return YKt(l, n, o) && FKt(l, r, o);
}, xKt = function(t) {
  return cN(F({}, t, {
    isVisibleThroughFrameFn: Wne
  }));
}, Vne = function(t) {
  return cN(F({}, t, {
    isVisibleThroughFrameFn: XKt
  }));
}, DKt = function(t) {
  return cN(F({}, t, {
    isVisibleThroughFrameFn: HKt(t.destination.axis)
  }));
}, JKt = function(t, i, n) {
  if (typeof n == "boolean")
    return n;
  if (!i)
    return !0;
  var r = i.invisible, g = i.visible;
  if (r[t])
    return !1;
  var o = g[t];
  return o ? o.shouldAnimate : !0;
};
function EKt(e, t) {
  var i = e.page.marginBox, n = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return vs(gN(i, n));
}
function tZ(e) {
  var t = e.afterDragging, i = e.destination, n = e.displacedBy, r = e.viewport, g = e.forceShouldAnimate, o = e.last;
  return t.reduce(function(a, I) {
    var c = EKt(I, n), d = I.descriptor.id;
    a.all.push(d);
    var C = xKt({
      target: c,
      destination: i,
      viewport: r,
      withDroppableDisplacement: !0
    });
    if (!C)
      return a.invisible[I.descriptor.id] = !0, a;
    var A = JKt(d, o, g), b = {
      draggableId: d,
      shouldAnimate: A
    };
    return a.visible[d] = b, a;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function NKt(e, t) {
  if (!e.length)
    return 0;
  var i = e[e.length - 1].descriptor.index;
  return t.inHomeList ? i : i + 1;
}
function Jz(e) {
  var t = e.insideDestination, i = e.inHomeList, n = e.displacedBy, r = e.destination, g = NKt(t, {
    inHomeList: i
  });
  return {
    displaced: eZ,
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: r.descriptor.id,
        index: g
      }
    }
  };
}
function zw(e) {
  var t = e.draggable, i = e.insideDestination, n = e.destination, r = e.viewport, g = e.displacedBy, o = e.last, l = e.index, a = e.forceShouldAnimate, I = $m(t, n);
  if (l == null)
    return Jz({
      insideDestination: i,
      inHomeList: I,
      displacedBy: g,
      destination: n
    });
  var c = Zu(i, function(m) {
    return m.descriptor.index === l;
  });
  if (!c)
    return Jz({
      insideDestination: i,
      inHomeList: I,
      displacedBy: g,
      destination: n
    });
  var d = E1(t, i), C = i.indexOf(c), A = d.slice(C), b = tZ({
    afterDragging: A,
    destination: n,
    displacedBy: g,
    last: o,
    viewport: r.frame,
    forceShouldAnimate: a
  });
  return {
    displaced: b,
    displacedBy: g,
    at: {
      type: "REORDER",
      destination: {
        droppableId: n.descriptor.id,
        index: l
      }
    }
  };
}
function gu(e, t) {
  return !!t.effected[e];
}
var LKt = function(e) {
  var t = e.isMovingForward, i = e.destination, n = e.draggables, r = e.combine, g = e.afterCritical;
  if (!i.isCombineEnabled)
    return null;
  var o = r.draggableId, l = n[o], a = l.descriptor.index, I = gu(o, g);
  return I ? t ? a : a - 1 : t ? a + 1 : a;
}, KKt = function(e) {
  var t = e.isMovingForward, i = e.isInHomeList, n = e.insideDestination, r = e.location;
  if (!n.length)
    return null;
  var g = r.index, o = t ? g + 1 : g - 1, l = n[0].descriptor.index, a = n[n.length - 1].descriptor.index, I = i ? a : a + 1;
  return o < l || o > I ? null : o;
}, TKt = function(e) {
  var t = e.isMovingForward, i = e.isInHomeList, n = e.draggable, r = e.draggables, g = e.destination, o = e.insideDestination, l = e.previousImpact, a = e.viewport, I = e.afterCritical, c = l.at;
  if (c || St(), c.type === "REORDER") {
    var d = KKt({
      isMovingForward: t,
      isInHomeList: i,
      location: c.destination,
      insideDestination: o
    });
    return d == null ? null : zw({
      draggable: n,
      insideDestination: o,
      destination: g,
      viewport: a,
      last: l.displaced,
      displacedBy: l.displacedBy,
      index: d
    });
  }
  var C = LKt({
    isMovingForward: t,
    destination: g,
    displaced: l.displaced,
    draggables: r,
    combine: c.combine,
    afterCritical: I
  });
  return C == null ? null : zw({
    draggable: n,
    insideDestination: o,
    destination: g,
    viewport: a,
    last: l.displaced,
    displacedBy: l.displacedBy,
    index: C
  });
}, MKt = function(e) {
  var t = e.displaced, i = e.afterCritical, n = e.combineWith, r = e.displacedBy, g = !!(t.visible[n] || t.invisible[n]);
  return gu(n, i) ? g ? Zg : qm(r.point) : g ? r.point : Zg;
}, PKt = function(e) {
  var t = e.afterCritical, i = e.impact, n = e.draggables, r = J1(i);
  r || St();
  var g = r.draggableId, o = n[g].page.borderBox.center, l = MKt({
    displaced: i.displaced,
    afterCritical: t,
    combineWith: g,
    displacedBy: i.displacedBy
  });
  return Pg(o, l);
}, wne = function(t, i) {
  return i.margin[t.start] + i.borderBox[t.size] / 2;
}, UKt = function(t, i) {
  return i.margin[t.end] + i.borderBox[t.size] / 2;
}, dN = function(t, i, n) {
  return i[t.crossAxisStart] + n.margin[t.crossAxisStart] + n.borderBox[t.crossAxisSize] / 2;
}, Ez = function(t) {
  var i = t.axis, n = t.moveRelativeTo, r = t.isMoving;
  return sA(i.line, n.marginBox[i.end] + wne(i, r), dN(i, n.marginBox, r));
}, Nz = function(t) {
  var i = t.axis, n = t.moveRelativeTo, r = t.isMoving;
  return sA(i.line, n.marginBox[i.start] - UKt(i, r), dN(i, n.marginBox, r));
}, zKt = function(t) {
  var i = t.axis, n = t.moveInto, r = t.isMoving;
  return sA(i.line, n.contentBox[i.start] + wne(i, r), dN(i, n.contentBox, r));
}, OKt = function(e) {
  var t = e.impact, i = e.draggable, n = e.draggables, r = e.droppable, g = e.afterCritical, o = _m(r.descriptor.id, n), l = i.page, a = r.axis;
  if (!o.length)
    return zKt({
      axis: a,
      moveInto: r.page,
      isMoving: l
    });
  var I = t.displaced, c = t.displacedBy, d = I.all[0];
  if (d) {
    var C = n[d];
    if (gu(d, g))
      return Nz({
        axis: a,
        moveRelativeTo: C.page,
        isMoving: l
      });
    var A = Kw(C.page, c.point);
    return Nz({
      axis: a,
      moveRelativeTo: A,
      isMoving: l
    });
  }
  var b = o[o.length - 1];
  if (b.descriptor.id === i.descriptor.id)
    return l.borderBox.center;
  if (gu(b.descriptor.id, g)) {
    var m = Kw(b.page, qm(g.displacedBy.point));
    return Ez({
      axis: a,
      moveRelativeTo: m,
      isMoving: l
    });
  }
  return Ez({
    axis: a,
    moveRelativeTo: b.page,
    isMoving: l
  });
}, ID = function(e, t) {
  var i = e.frame;
  return i ? Pg(t, i.scroll.diff.displacement) : t;
}, QKt = function(t) {
  var i = t.impact, n = t.draggable, r = t.droppable, g = t.draggables, o = t.afterCritical, l = n.page.borderBox.center, a = i.at;
  return !r || !a ? l : a.type === "REORDER" ? OKt({
    impact: i,
    draggable: n,
    draggables: g,
    droppable: r,
    afterCritical: o
  }) : PKt({
    impact: i,
    draggables: g,
    afterCritical: o
  });
}, N1 = function(e) {
  var t = QKt(e), i = e.droppable, n = i ? ID(i, t) : t;
  return n;
}, vne = function(e, t) {
  var i = El(t, e.scroll.initial), n = qm(i), r = vs({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), g = {
    frame: r,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: i,
        displacement: n
      }
    }
  };
  return g;
};
function Lz(e, t) {
  return e.map(function(i) {
    return t[i];
  });
}
function jKt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i].visible[e];
    if (n)
      return n;
  }
  return null;
}
var qKt = function(e) {
  var t = e.impact, i = e.viewport, n = e.destination, r = e.draggables, g = e.maxScrollChange, o = vne(i, Pg(i.scroll.current, g)), l = n.frame ? lN(n, Pg(n.frame.scroll.current, g)) : n, a = t.displaced, I = tZ({
    afterDragging: Lz(a.all, r),
    destination: n,
    displacedBy: t.displacedBy,
    viewport: o.frame,
    last: a,
    forceShouldAnimate: !1
  }), c = tZ({
    afterDragging: Lz(a.all, r),
    destination: l,
    displacedBy: t.displacedBy,
    viewport: i.frame,
    last: a,
    forceShouldAnimate: !1
  }), d = {}, C = {}, A = [a, I, c];
  a.all.forEach(function(m) {
    var p = jKt(m, A);
    if (p) {
      C[m] = p;
      return;
    }
    d[m] = !0;
  });
  var b = F({}, t, {
    displaced: {
      all: a.all,
      invisible: d,
      visible: C
    }
  });
  return b;
}, _Kt = function(e, t) {
  return Pg(e.scroll.diff.displacement, t);
}, uN = function(e) {
  var t = e.pageBorderBoxCenter, i = e.draggable, n = e.viewport, r = _Kt(n, t), g = El(r, i.page.borderBox.center);
  return Pg(i.client.borderBox.center, g);
}, Rne = function(e) {
  var t = e.draggable, i = e.destination, n = e.newPageBorderBoxCenter, r = e.viewport, g = e.withDroppableDisplacement, o = e.onlyOnMainAxis, l = o === void 0 ? !1 : o, a = El(n, t.page.borderBox.center), I = AG(t.page.borderBox, a), c = {
    target: I,
    destination: i,
    withDroppableDisplacement: g,
    viewport: r
  };
  return l ? DKt(c) : Vne(c);
}, $Kt = function(e) {
  var t = e.isMovingForward, i = e.draggable, n = e.destination, r = e.draggables, g = e.previousImpact, o = e.viewport, l = e.previousPageBorderBoxCenter, a = e.previousClientSelection, I = e.afterCritical;
  if (!n.isEnabled)
    return null;
  var c = _m(n.descriptor.id, r), d = $m(i, n), C = vKt({
    isMovingForward: t,
    draggable: i,
    destination: n,
    insideDestination: c,
    previousImpact: g
  }) || TKt({
    isMovingForward: t,
    isInHomeList: d,
    draggable: i,
    draggables: r,
    destination: n,
    insideDestination: c,
    previousImpact: g,
    viewport: o,
    afterCritical: I
  });
  if (!C)
    return null;
  var A = N1({
    impact: C,
    draggable: i,
    droppable: n,
    draggables: r,
    afterCritical: I
  }), b = Rne({
    draggable: i,
    destination: n,
    newPageBorderBoxCenter: A,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (b) {
    var m = uN({
      pageBorderBoxCenter: A,
      draggable: i,
      viewport: o
    });
    return {
      clientSelection: m,
      impact: C,
      scrollJumpRequest: null
    };
  }
  var p = El(A, l), B = qKt({
    impact: C,
    viewport: o,
    destination: n,
    draggables: r,
    maxScrollChange: p
  });
  return {
    clientSelection: a,
    impact: B,
    scrollJumpRequest: p
  };
}, Bo = function(t) {
  var i = t.subject.active;
  return i || St(), i;
}, e3t = function(e) {
  var t = e.isMovingForward, i = e.pageBorderBoxCenter, n = e.source, r = e.droppables, g = e.viewport, o = n.subject.active;
  if (!o)
    return null;
  var l = n.axis, a = Da(o[l.start], o[l.end]), I = D1(r).filter(function(d) {
    return d !== n;
  }).filter(function(d) {
    return d.isEnabled;
  }).filter(function(d) {
    return !!d.subject.active;
  }).filter(function(d) {
    return Wne(g.frame)(Bo(d));
  }).filter(function(d) {
    var C = Bo(d);
    return t ? o[l.crossAxisEnd] < C[l.crossAxisEnd] : C[l.crossAxisStart] < o[l.crossAxisStart];
  }).filter(function(d) {
    var C = Bo(d), A = Da(C[l.start], C[l.end]);
    return a(C[l.start]) || a(C[l.end]) || A(o[l.start]) || A(o[l.end]);
  }).sort(function(d, C) {
    var A = Bo(d)[l.crossAxisStart], b = Bo(C)[l.crossAxisStart];
    return t ? A - b : b - A;
  }).filter(function(d, C, A) {
    return Bo(d)[l.crossAxisStart] === Bo(A[0])[l.crossAxisStart];
  });
  if (!I.length)
    return null;
  if (I.length === 1)
    return I[0];
  var c = I.filter(function(d) {
    var C = Da(Bo(d)[l.start], Bo(d)[l.end]);
    return C(i[l.line]);
  });
  return c.length === 1 ? c[0] : c.length > 1 ? c.sort(function(d, C) {
    return Bo(d)[l.start] - Bo(C)[l.start];
  })[0] : I.sort(function(d, C) {
    var A = xz(i, Dz(Bo(d))), b = xz(i, Dz(Bo(C)));
    return A !== b ? A - b : Bo(d)[l.start] - Bo(C)[l.start];
  })[0];
}, Kz = function(t, i) {
  var n = t.page.borderBox.center;
  return gu(t.descriptor.id, i) ? El(n, i.displacedBy.point) : n;
}, t3t = function(t, i) {
  var n = t.page.borderBox;
  return gu(t.descriptor.id, i) ? AG(n, qm(i.displacedBy.point)) : n;
}, i3t = function(e) {
  var t = e.pageBorderBoxCenter, i = e.viewport, n = e.destination, r = e.insideDestination, g = e.afterCritical, o = r.filter(function(l) {
    return Vne({
      target: t3t(l, g),
      destination: n,
      viewport: i.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(l, a) {
    var I = $f(t, ID(n, Kz(l, g))), c = $f(t, ID(n, Kz(a, g)));
    return I < c ? -1 : c < I ? 1 : l.descriptor.index - a.descriptor.index;
  });
  return o[0] || null;
}, bG = Bg(function(t, i) {
  var n = i[t.line];
  return {
    value: n,
    point: sA(t.line, n)
  };
}), n3t = function(t, i, n) {
  var r = t.axis;
  if (t.descriptor.mode === "virtual")
    return sA(r.line, i[r.line]);
  var g = t.subject.page.contentBox[r.size], o = _m(t.descriptor.id, n), l = o.reduce(function(c, d) {
    return c + d.client.marginBox[r.size];
  }, 0), a = l + i[r.line], I = a - g;
  return I <= 0 ? null : sA(r.line, I);
}, Xne = function(t, i) {
  return F({}, t, {
    scroll: F({}, t.scroll, {
      max: i
    })
  });
}, Hne = function(t, i, n) {
  var r = t.frame;
  $m(i, t) && St(), t.subject.withPlaceholder && St();
  var g = bG(t.axis, i.displaceBy).point, o = n3t(t, g, n), l = {
    placeholderSize: g,
    increasedBy: o,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!r) {
    var a = Am({
      page: t.subject.page,
      withPlaceholder: l,
      axis: t.axis,
      frame: t.frame
    });
    return F({}, t, {
      subject: a
    });
  }
  var I = o ? Pg(r.scroll.max, o) : r.scroll.max, c = Xne(r, I), d = Am({
    page: t.subject.page,
    withPlaceholder: l,
    axis: t.axis,
    frame: c
  });
  return F({}, t, {
    subject: d,
    frame: c
  });
}, r3t = function(t) {
  var i = t.subject.withPlaceholder;
  i || St();
  var n = t.frame;
  if (!n) {
    var r = Am({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return F({}, t, {
      subject: r
    });
  }
  var g = i.oldFrameMaxScroll;
  g || St();
  var o = Xne(n, g), l = Am({
    page: t.subject.page,
    axis: t.axis,
    frame: o,
    withPlaceholder: null
  });
  return F({}, t, {
    subject: l,
    frame: o
  });
}, g3t = function(e) {
  var t = e.previousPageBorderBoxCenter, i = e.moveRelativeTo, n = e.insideDestination, r = e.draggable, g = e.draggables, o = e.destination, l = e.viewport, a = e.afterCritical;
  if (!i) {
    if (n.length)
      return null;
    var I = {
      displaced: eZ,
      displacedBy: yne,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, c = N1({
      impact: I,
      draggable: r,
      droppable: o,
      draggables: g,
      afterCritical: a
    }), d = $m(r, o) ? o : Hne(o, r, g), C = Rne({
      draggable: r,
      destination: d,
      newPageBorderBoxCenter: c,
      viewport: l.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return C ? I : null;
  }
  var A = t[o.axis.line] <= i.page.borderBox.center[o.axis.line], b = function() {
    var p = i.descriptor.index;
    return i.descriptor.id === r.descriptor.id || A ? p : p + 1;
  }(), m = bG(o.axis, r.displaceBy);
  return zw({
    draggable: r,
    insideDestination: n,
    destination: o,
    viewport: l,
    displacedBy: m,
    last: eZ,
    index: b
  });
}, o3t = function(e) {
  var t = e.isMovingForward, i = e.previousPageBorderBoxCenter, n = e.draggable, r = e.isOver, g = e.draggables, o = e.droppables, l = e.viewport, a = e.afterCritical, I = e3t({
    isMovingForward: t,
    pageBorderBoxCenter: i,
    source: r,
    droppables: o,
    viewport: l
  });
  if (!I)
    return null;
  var c = _m(I.descriptor.id, g), d = i3t({
    pageBorderBoxCenter: i,
    viewport: l,
    destination: I,
    insideDestination: c,
    afterCritical: a
  }), C = g3t({
    previousPageBorderBoxCenter: i,
    destination: I,
    draggable: n,
    draggables: g,
    moveRelativeTo: d,
    insideDestination: c,
    viewport: l,
    afterCritical: a
  });
  if (!C)
    return null;
  var A = N1({
    impact: C,
    draggable: n,
    droppable: I,
    draggables: g,
    afterCritical: a
  }), b = uN({
    pageBorderBoxCenter: A,
    draggable: n,
    viewport: l
  });
  return {
    clientSelection: b,
    impact: C,
    scrollJumpRequest: null
  };
}, Ml = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, l3t = function(t, i) {
  var n = Ml(t);
  return n ? i[n] : null;
}, a3t = function(e) {
  var t = e.state, i = e.type, n = l3t(t.impact, t.dimensions.droppables), r = !!n, g = t.dimensions.droppables[t.critical.droppable.id], o = n || g, l = o.axis.direction, a = l === "vertical" && (i === "MOVE_UP" || i === "MOVE_DOWN") || l === "horizontal" && (i === "MOVE_LEFT" || i === "MOVE_RIGHT");
  if (a && !r)
    return null;
  var I = i === "MOVE_DOWN" || i === "MOVE_RIGHT", c = t.dimensions.draggables[t.critical.draggable.id], d = t.current.page.borderBoxCenter, C = t.dimensions, A = C.draggables, b = C.droppables;
  return a ? $Kt({
    isMovingForward: I,
    previousPageBorderBoxCenter: d,
    draggable: c,
    destination: o,
    draggables: A,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : o3t({
    isMovingForward: I,
    previousPageBorderBoxCenter: d,
    draggable: c,
    isOver: o,
    draggables: A,
    droppables: b,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function VC(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function kne(e) {
  var t = Da(e.top, e.bottom), i = Da(e.left, e.right);
  return function(r) {
    return t(r.y) && i(r.x);
  };
}
function s3t(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function I3t(e) {
  var t = e.pageBorderBox, i = e.draggable, n = e.candidates, r = i.page.borderBox.center, g = n.map(function(o) {
    var l = o.axis, a = sA(o.axis.line, t.center[l.line], o.page.borderBox.center[l.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: $f(r, a)
    };
  }).sort(function(o, l) {
    return l.distance - o.distance;
  });
  return g[0] ? g[0].id : null;
}
function c3t(e) {
  var t = e.pageBorderBox, i = e.draggable, n = e.droppables, r = D1(n).filter(function(g) {
    if (!g.isEnabled)
      return !1;
    var o = g.subject.active;
    if (!o || !s3t(t, o))
      return !1;
    if (kne(o)(t.center))
      return !0;
    var l = g.axis, a = o.center[l.crossAxisLine], I = t[l.crossAxisStart], c = t[l.crossAxisEnd], d = Da(o[l.crossAxisStart], o[l.crossAxisEnd]), C = d(I), A = d(c);
    return !C && !A ? !0 : C ? I < a : c > a;
  });
  return r.length ? r.length === 1 ? r[0].descriptor.id : I3t({
    pageBorderBox: t,
    draggable: i,
    candidates: r
  }) : null;
}
var Yne = function(t, i) {
  return vs(AG(t, i));
}, d3t = function(e, t) {
  var i = e.frame;
  return i ? Yne(t, i.scroll.diff.value) : t;
};
function Fne(e) {
  var t = e.displaced, i = e.id;
  return !!(t.visible[i] || t.invisible[i]);
}
function u3t(e) {
  var t = e.draggable, i = e.closest, n = e.inHomeList;
  return i ? n && i.descriptor.index > t.descriptor.index ? i.descriptor.index - 1 : i.descriptor.index : null;
}
var C3t = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, i = e.draggable, n = e.destination, r = e.insideDestination, g = e.last, o = e.viewport, l = e.afterCritical, a = n.axis, I = bG(n.axis, i.displaceBy), c = I.value, d = t[a.start], C = t[a.end], A = E1(i, r), b = Zu(A, function(p) {
    var B = p.descriptor.id, f = p.page.borderBox.center[a.line], Z = gu(B, l), y = Fne({
      displaced: g,
      id: B
    });
    return Z ? y ? C <= f : d < f - c : y ? C <= f + c : d < f;
  }), m = u3t({
    draggable: i,
    closest: b,
    inHomeList: $m(i, n)
  });
  return zw({
    draggable: i,
    insideDestination: r,
    destination: n,
    viewport: o,
    last: g,
    displacedBy: I,
    index: m
  });
}, A3t = 4, b3t = function(e) {
  var t = e.draggable, i = e.pageBorderBoxWithDroppableScroll, n = e.previousImpact, r = e.destination, g = e.insideDestination, o = e.afterCritical;
  if (!r.isCombineEnabled)
    return null;
  var l = r.axis, a = bG(r.axis, t.displaceBy), I = a.value, c = i[l.start], d = i[l.end], C = E1(t, g), A = Zu(C, function(m) {
    var p = m.descriptor.id, B = m.page.borderBox, f = B[l.size], Z = f / A3t, y = gu(p, o), W = Fne({
      displaced: n.displaced,
      id: p
    });
    return y ? W ? d > B[l.start] + Z && d < B[l.end] - Z : c > B[l.start] - I + Z && c < B[l.end] - I - Z : W ? d > B[l.start] + I + Z && d < B[l.end] + I - Z : c > B[l.start] + Z && c < B[l.end] - Z;
  });
  if (!A)
    return null;
  var b = {
    displacedBy: a,
    displaced: n.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: A.descriptor.id,
        droppableId: r.descriptor.id
      }
    }
  };
  return b;
}, xne = function(e) {
  var t = e.pageOffset, i = e.draggable, n = e.draggables, r = e.droppables, g = e.previousImpact, o = e.viewport, l = e.afterCritical, a = Yne(i.page.borderBox, t), I = c3t({
    pageBorderBox: a,
    draggable: i,
    droppables: r
  });
  if (!I)
    return RKt;
  var c = r[I], d = _m(c.descriptor.id, n), C = d3t(c, a);
  return b3t({
    pageBorderBoxWithDroppableScroll: C,
    draggable: i,
    previousImpact: g,
    destination: c,
    insideDestination: d,
    afterCritical: l
  }) || C3t({
    pageBorderBoxWithDroppableScroll: C,
    draggable: i,
    destination: c,
    insideDestination: d,
    last: g.displaced,
    viewport: o,
    afterCritical: l
  });
}, CN = function(e, t) {
  var i;
  return F({}, e, (i = {}, i[t.descriptor.id] = t, i));
}, h3t = function(t) {
  var i = t.previousImpact, n = t.impact, r = t.droppables, g = Ml(i), o = Ml(n);
  if (!g || g === o)
    return r;
  var l = r[g];
  if (!l.subject.withPlaceholder)
    return r;
  var a = r3t(l);
  return CN(r, a);
}, m3t = function(e) {
  var t = e.draggable, i = e.draggables, n = e.droppables, r = e.previousImpact, g = e.impact, o = h3t({
    previousImpact: r,
    impact: g,
    droppables: n
  }), l = Ml(g);
  if (!l)
    return o;
  var a = n[l];
  if ($m(t, a) || a.subject.withPlaceholder)
    return o;
  var I = Hne(a, t, i);
  return CN(o, I);
}, df = function(e) {
  var t = e.state, i = e.clientSelection, n = e.dimensions, r = e.viewport, g = e.impact, o = e.scrollJumpRequest, l = r || t.viewport, a = n || t.dimensions, I = i || t.current.client.selection, c = El(I, t.initial.client.selection), d = {
    offset: c,
    selection: I,
    borderBoxCenter: Pg(t.initial.client.borderBoxCenter, c)
  }, C = {
    selection: Pg(d.selection, l.scroll.current),
    borderBoxCenter: Pg(d.borderBoxCenter, l.scroll.current),
    offset: Pg(d.offset, l.scroll.diff.value)
  }, A = {
    client: d,
    page: C
  };
  if (t.phase === "COLLECTING")
    return F({
      phase: "COLLECTING"
    }, t, {
      dimensions: a,
      viewport: l,
      current: A
    });
  var b = a.draggables[t.critical.draggable.id], m = g || xne({
    pageOffset: C.offset,
    draggable: b,
    draggables: a.draggables,
    droppables: a.droppables,
    previousImpact: t.impact,
    viewport: l,
    afterCritical: t.afterCritical
  }), p = m3t({
    draggable: b,
    impact: m,
    previousImpact: t.impact,
    draggables: a.draggables,
    droppables: a.droppables
  }), B = F({}, t, {
    current: A,
    dimensions: {
      draggables: a.draggables,
      droppables: p
    },
    impact: m,
    viewport: l,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
  return B;
};
function p3t(e, t) {
  return e.map(function(i) {
    return t[i];
  });
}
var Dne = function(e) {
  var t = e.impact, i = e.viewport, n = e.draggables, r = e.destination, g = e.forceShouldAnimate, o = t.displaced, l = p3t(o.all, n), a = tZ({
    afterDragging: l,
    destination: r,
    displacedBy: t.displacedBy,
    viewport: i.frame,
    forceShouldAnimate: g,
    last: o
  });
  return F({}, t, {
    displaced: a
  });
}, Jne = function(e) {
  var t = e.impact, i = e.draggable, n = e.droppable, r = e.draggables, g = e.viewport, o = e.afterCritical, l = N1({
    impact: t,
    draggable: i,
    draggables: r,
    droppable: n,
    afterCritical: o
  });
  return uN({
    pageBorderBoxCenter: l,
    draggable: i,
    viewport: g
  });
}, Ene = function(e) {
  var t = e.state, i = e.dimensions, n = e.viewport;
  t.movementMode !== "SNAP" && St();
  var r = t.impact, g = n || t.viewport, o = i || t.dimensions, l = o.draggables, a = o.droppables, I = l[t.critical.draggable.id], c = Ml(r);
  c || St();
  var d = a[c], C = Dne({
    impact: r,
    viewport: g,
    destination: d,
    draggables: l
  }), A = Jne({
    impact: C,
    draggable: I,
    droppable: d,
    draggables: l,
    viewport: g,
    afterCritical: t.afterCritical
  });
  return df({
    impact: C,
    clientSelection: A,
    state: t,
    dimensions: o,
    viewport: g
  });
}, B3t = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, Nne = function(e) {
  var t = e.draggable, i = e.home, n = e.draggables, r = e.viewport, g = bG(i.axis, t.displaceBy), o = _m(i.descriptor.id, n), l = o.indexOf(t);
  l === -1 && St();
  var a = o.slice(l + 1), I = a.reduce(function(A, b) {
    return A[b.descriptor.id] = !0, A;
  }, {}), c = {
    inVirtualList: i.descriptor.mode === "virtual",
    displacedBy: g,
    effected: I
  }, d = tZ({
    afterDragging: a,
    destination: i,
    displacedBy: g,
    last: null,
    viewport: r.frame,
    forceShouldAnimate: !1
  }), C = {
    displaced: d,
    displacedBy: g,
    at: {
      type: "REORDER",
      destination: B3t(t.descriptor)
    }
  };
  return {
    impact: C,
    afterCritical: c
  };
}, f3t = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: CN(e.droppables, t)
  };
}, Z3t = function(e) {
  var t = e.draggable, i = e.offset, n = e.initialWindowScroll, r = Kw(t.client, i), g = Tw(r, n), o = F({}, t, {
    placeholder: F({}, t.placeholder, {
      client: r
    }),
    client: r,
    page: g
  });
  return o;
}, G3t = function(e) {
  var t = e.frame;
  return t || St(), t;
}, y3t = function(e) {
  var t = e.additions, i = e.updatedDroppables, n = e.viewport, r = n.scroll.diff.value;
  return t.map(function(g) {
    var o = g.descriptor.droppableId, l = i[o], a = G3t(l), I = a.scroll.diff.value, c = Pg(r, I), d = Z3t({
      draggable: g,
      offset: c,
      initialWindowScroll: n.scroll.initial
    });
    return d;
  });
}, W3t = function(e) {
  var t = e.state, i = e.published, n = i.modified.map(function(Z) {
    var y = t.dimensions.droppables[Z.droppableId], W = lN(y, Z.scroll);
    return W;
  }), r = F({}, t.dimensions.droppables, {}, Zne(n)), g = Gne(y3t({
    additions: i.additions,
    updatedDroppables: r,
    viewport: t.viewport
  })), o = F({}, t.dimensions.draggables, {}, g);
  i.removals.forEach(function(Z) {
    delete o[Z];
  });
  var l = {
    droppables: r,
    draggables: o
  }, a = Ml(t.impact), I = a ? l.droppables[a] : null, c = l.draggables[t.critical.draggable.id], d = l.droppables[t.critical.droppable.id], C = Nne({
    draggable: c,
    home: d,
    draggables: o,
    viewport: t.viewport
  }), A = C.impact, b = C.afterCritical, m = I && I.isCombineEnabled ? t.impact : A, p = xne({
    pageOffset: t.current.page.offset,
    draggable: l.draggables[t.critical.draggable.id],
    draggables: l.draggables,
    droppables: l.droppables,
    previousImpact: m,
    viewport: t.viewport,
    afterCritical: b
  }), B = F({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: p,
    onLiftImpact: A,
    dimensions: l,
    afterCritical: b,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return B;
  var f = F({
    phase: "DROP_PENDING"
  }, B, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return f;
}, cD = function(t) {
  return t.movementMode === "SNAP";
}, KF = function(t, i, n) {
  var r = f3t(t.dimensions, i);
  return !cD(t) || n ? df({
    state: t,
    dimensions: r
  }) : Ene({
    state: t,
    dimensions: r
  });
};
function TF(e) {
  return e.isDragging && e.movementMode === "SNAP" ? F({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var Tz = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, S3t = function(e, t) {
  if (e === void 0 && (e = Tz), t.type === "FLUSH")
    return F({}, Tz, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && St();
    var i = t.payload, n = i.critical, r = i.clientSelection, g = i.viewport, o = i.dimensions, l = i.movementMode, a = o.draggables[n.draggable.id], I = o.droppables[n.droppable.id], c = {
      selection: r,
      borderBoxCenter: a.client.borderBox.center,
      offset: Zg
    }, d = {
      client: c,
      page: {
        selection: Pg(c.selection, g.scroll.initial),
        borderBoxCenter: Pg(c.selection, g.scroll.initial),
        offset: Pg(c.selection, g.scroll.diff.value)
      }
    }, C = D1(o.droppables).every(function(st) {
      return !st.isFixedOnPage;
    }), A = Nne({
      draggable: a,
      home: I,
      draggables: o.draggables,
      viewport: g
    }), b = A.impact, m = A.afterCritical, p = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: n,
      movementMode: l,
      dimensions: o,
      initial: d,
      current: d,
      isWindowScrollAllowed: C,
      impact: b,
      afterCritical: m,
      onLiftImpact: b,
      viewport: g,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return p;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && St();
    var B = F({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return B;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || St(), W3t({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    VC(e) || St();
    var f = t.payload.client;
    return Pd(f, e.current.client.selection) ? e : df({
      state: e,
      clientSelection: f,
      impact: cD(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return TF(e);
    VC(e) || St();
    var Z = t.payload, y = Z.id, W = Z.newScroll, V = e.dimensions.droppables[y];
    if (!V)
      return e;
    var w = lN(V, W);
    return KF(e, w, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    VC(e) || St();
    var v = t.payload, H = v.id, x = v.isEnabled, J = e.dimensions.droppables[H];
    J || St(), J.isEnabled === x && St();
    var K = F({}, J, {
      isEnabled: x
    });
    return KF(e, K, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    VC(e) || St();
    var M = t.payload, L = M.id, N = M.isCombineEnabled, U = e.dimensions.droppables[L];
    U || St(), U.isCombineEnabled === N && St();
    var O = F({}, U, {
      isCombineEnabled: N
    });
    return KF(e, O, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    VC(e) || St(), e.isWindowScrollAllowed || St();
    var $ = t.payload.newScroll;
    if (Pd(e.viewport.scroll.current, $))
      return TF(e);
    var ne = vne(e.viewport, $);
    return cD(e) ? Ene({
      state: e,
      viewport: ne
    }) : df({
      state: e,
      viewport: ne
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!VC(e))
      return e;
    var be = t.payload.maxScroll;
    if (Pd(be, e.viewport.scroll.max))
      return e;
    var Ve = F({}, e.viewport, {
      scroll: F({}, e.viewport.scroll, {
        max: be
      })
    });
    return F({
      phase: "DRAGGING"
    }, e, {
      viewport: Ve
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && St();
    var He = a3t({
      state: e,
      type: t.type
    });
    return He ? df({
      state: e,
      impact: He.impact,
      clientSelection: He.clientSelection,
      scrollJumpRequest: He.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var Je = t.payload.reason;
    e.phase !== "COLLECTING" && St();
    var ke = F({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: Je
    });
    return ke;
  }
  if (t.type === "DROP_ANIMATE") {
    var we = t.payload, ue = we.completed, Xe = we.dropDuration, Ze = we.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || St();
    var xe = {
      phase: "DROP_ANIMATING",
      completed: ue,
      dropDuration: Xe,
      newHomeClientOffset: Ze,
      dimensions: e.dimensions
    };
    return xe;
  }
  if (t.type === "DROP_COMPLETE") {
    var Pe = t.payload.completed;
    return {
      phase: "IDLE",
      completed: Pe,
      shouldFlush: !1
    };
  }
  return e;
}, V3t = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, w3t = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, v3t = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, R3t = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, X3t = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, H3t = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, k3t = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, Y3t = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, Lne = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, F3t = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, x3t = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, D3t = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, J3t = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, E3t = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, N3t = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, AN = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, L3t = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, bN = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, Kne = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, K3t = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, Tne = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
}, T3t = function(e) {
  return function(t) {
    var i = t.getState, n = t.dispatch;
    return function(r) {
      return function(g) {
        if (g.type !== "LIFT") {
          r(g);
          return;
        }
        var o = g.payload, l = o.id, a = o.clientSelection, I = o.movementMode, c = i();
        c.phase === "DROP_ANIMATING" && n(bN({
          completed: c.completed
        })), i().phase !== "IDLE" && St(), n(AN()), n(V3t({
          draggableId: l,
          movementMode: I
        }));
        var d = {
          shouldPublishImmediately: I === "SNAP"
        }, C = {
          draggableId: l,
          scrollOptions: d
        }, A = e.startPublishing(C), b = A.critical, m = A.dimensions, p = A.viewport;
        n(v3t({
          critical: b,
          dimensions: m,
          clientSelection: a,
          movementMode: I,
          viewport: p
        }));
      };
    };
  };
}, M3t = function(e) {
  return function() {
    return function(t) {
      return function(i) {
        i.type === "INITIAL_PUBLISH" && e.dragging(), i.type === "DROP_ANIMATE" && e.dropping(i.payload.completed.result.reason), (i.type === "FLUSH" || i.type === "DROP_COMPLETE") && e.resting(), t(i);
      };
    };
  };
}, hN = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, iZ = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, mN = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, bC = mN.outOfTheWay + "s " + hN.outOfTheWay, uf = {
  fluid: "opacity " + bC,
  snap: "transform " + bC + ", opacity " + bC,
  drop: function(t) {
    var i = t + "s " + hN.drop;
    return "transform " + i + ", opacity " + i;
  },
  outOfTheWay: "transform " + bC,
  placeholder: "height " + bC + ", width " + bC + ", margin " + bC
}, Mz = function(t) {
  return Pd(t, Zg) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, dD = {
  moveTo: Mz,
  drop: function(t, i) {
    var n = Mz(t);
    return n ? i ? n + " scale(" + iZ.scale.drop + ")" : n : null;
  }
}, uD = mN.minDropTime, Mne = mN.maxDropTime, P3t = Mne - uD, Pz = 1500, U3t = 0.6, z3t = function(e) {
  var t = e.current, i = e.destination, n = e.reason, r = $f(t, i);
  if (r <= 0)
    return uD;
  if (r >= Pz)
    return Mne;
  var g = r / Pz, o = uD + P3t * g, l = n === "CANCEL" ? o * U3t : o;
  return Number(l.toFixed(2));
}, O3t = function(e) {
  var t = e.impact, i = e.draggable, n = e.dimensions, r = e.viewport, g = e.afterCritical, o = n.draggables, l = n.droppables, a = Ml(t), I = a ? l[a] : null, c = l[i.descriptor.droppableId], d = Jne({
    impact: t,
    draggable: i,
    draggables: o,
    afterCritical: g,
    droppable: I || c,
    viewport: r
  }), C = El(d, i.client.borderBox.center);
  return C;
}, Q3t = function(e) {
  var t = e.draggables, i = e.reason, n = e.lastImpact, r = e.home, g = e.viewport, o = e.onLiftImpact;
  if (!n.at || i !== "DROP") {
    var l = Dne({
      draggables: t,
      impact: o,
      destination: r,
      viewport: g,
      forceShouldAnimate: !0
    });
    return {
      impact: l,
      didDropInsideDroppable: !1
    };
  }
  if (n.at.type === "REORDER")
    return {
      impact: n,
      didDropInsideDroppable: !0
    };
  var a = F({}, n, {
    displaced: eZ
  });
  return {
    impact: a,
    didDropInsideDroppable: !0
  };
}, j3t = function(e) {
  var t = e.getState, i = e.dispatch;
  return function(n) {
    return function(r) {
      if (r.type !== "DROP") {
        n(r);
        return;
      }
      var g = t(), o = r.payload.reason;
      if (g.phase === "COLLECTING") {
        i(K3t({
          reason: o
        }));
        return;
      }
      if (g.phase !== "IDLE") {
        var l = g.phase === "DROP_PENDING" && g.isWaiting;
        l && St(), g.phase === "DRAGGING" || g.phase === "DROP_PENDING" || St();
        var a = g.critical, I = g.dimensions, c = I.draggables[g.critical.draggable.id], d = Q3t({
          reason: o,
          lastImpact: g.impact,
          afterCritical: g.afterCritical,
          onLiftImpact: g.onLiftImpact,
          home: g.dimensions.droppables[g.critical.droppable.id],
          viewport: g.viewport,
          draggables: g.dimensions.draggables
        }), C = d.impact, A = d.didDropInsideDroppable, b = A ? sN(C) : null, m = A ? J1(C) : null, p = {
          index: a.draggable.index,
          droppableId: a.droppable.id
        }, B = {
          draggableId: c.descriptor.id,
          type: c.descriptor.type,
          source: p,
          reason: o,
          mode: g.movementMode,
          destination: b,
          combine: m
        }, f = O3t({
          impact: C,
          draggable: c,
          dimensions: I,
          viewport: g.viewport,
          afterCritical: g.afterCritical
        }), Z = {
          critical: g.critical,
          afterCritical: g.afterCritical,
          result: B,
          impact: C
        }, y = !Pd(g.current.client.offset, f) || !!B.combine;
        if (!y) {
          i(bN({
            completed: Z
          }));
          return;
        }
        var W = z3t({
          current: g.current.client.offset,
          destination: f,
          reason: o
        }), V = {
          newHomeClientOffset: f,
          dropDuration: W,
          completed: Z
        };
        i(L3t(V));
      }
    };
  };
}, Pne = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function q3t(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(i) {
      i.target !== window && i.target !== window.document || e();
    }
  };
}
function _3t(e) {
  var t = e.onWindowScroll;
  function i() {
    t(Pne());
  }
  var n = _f(i), r = q3t(n), g = Md;
  function o() {
    return g !== Md;
  }
  function l() {
    o() && St(), g = Ya(window, [r]);
  }
  function a() {
    o() || St(), n.cancel(), g(), g = Md;
  }
  return {
    start: l,
    stop: a,
    isActive: o
  };
}
var $3t = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, eTt = function(e) {
  var t = _3t({
    onWindowScroll: function(n) {
      e.dispatch(F3t({
        newScroll: n
      }));
    }
  });
  return function(i) {
    return function(n) {
      !t.isActive() && n.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && $3t(n) && t.stop(), i(n);
    };
  };
}, tTt = function(e) {
  var t = !1, i = !1, n = setTimeout(function() {
    i = !0;
  }), r = function(o) {
    t || i || (t = !0, e(o), clearTimeout(n));
  };
  return r.wasCalled = function() {
    return t;
  }, r;
}, iTt = function() {
  var e = [], t = function(g) {
    var o = aN(e, function(I) {
      return I.timerId === g;
    });
    o === -1 && St();
    var l = e.splice(o, 1), a = l[0];
    a.callback();
  }, i = function(g) {
    var o = setTimeout(function() {
      return t(o);
    }), l = {
      timerId: o,
      callback: g
    };
    e.push(l);
  }, n = function() {
    if (e.length) {
      var g = [].concat(e);
      e.length = 0, g.forEach(function(o) {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
  return {
    add: i,
    flush: n
  };
}, nTt = function(t, i) {
  return t == null && i == null ? !0 : t == null || i == null ? !1 : t.droppableId === i.droppableId && t.index === i.index;
}, rTt = function(t, i) {
  return t == null && i == null ? !0 : t == null || i == null ? !1 : t.draggableId === i.draggableId && t.droppableId === i.droppableId;
}, gTt = function(t, i) {
  if (t === i)
    return !0;
  var n = t.draggable.id === i.draggable.id && t.draggable.droppableId === i.draggable.droppableId && t.draggable.type === i.draggable.type && t.draggable.index === i.draggable.index, r = t.droppable.id === i.droppable.id && t.droppable.type === i.droppable.type;
  return n && r;
}, pB = function(t, i) {
  i();
}, MS = function(t, i) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: i
  };
}, MF = function(t, i, n, r) {
  if (!t) {
    n(r(i));
    return;
  }
  var g = tTt(n), o = {
    announce: g
  };
  t(i, o), g.wasCalled() || n(r(i));
}, oTt = function(e, t) {
  var i = iTt(), n = null, r = function(C, A) {
    n && St(), pB("onBeforeCapture", function() {
      var b = e().onBeforeCapture;
      if (b) {
        var m = {
          draggableId: C,
          mode: A
        };
        b(m);
      }
    });
  }, g = function(C, A) {
    n && St(), pB("onBeforeDragStart", function() {
      var b = e().onBeforeDragStart;
      b && b(MS(C, A));
    });
  }, o = function(C, A) {
    n && St();
    var b = MS(C, A);
    n = {
      mode: A,
      lastCritical: C,
      lastLocation: b.source,
      lastCombine: null
    }, i.add(function() {
      pB("onDragStart", function() {
        return MF(e().onDragStart, b, t, kV.onDragStart);
      });
    });
  }, l = function(C, A) {
    var b = sN(A), m = J1(A);
    n || St();
    var p = !gTt(C, n.lastCritical);
    p && (n.lastCritical = C);
    var B = !nTt(n.lastLocation, b);
    B && (n.lastLocation = b);
    var f = !rTt(n.lastCombine, m);
    if (f && (n.lastCombine = m), !(!p && !B && !f)) {
      var Z = F({}, MS(C, n.mode), {
        combine: m,
        destination: b
      });
      i.add(function() {
        pB("onDragUpdate", function() {
          return MF(e().onDragUpdate, Z, t, kV.onDragUpdate);
        });
      });
    }
  }, a = function() {
    n || St(), i.flush();
  }, I = function(C) {
    n || St(), n = null, pB("onDragEnd", function() {
      return MF(e().onDragEnd, C, t, kV.onDragEnd);
    });
  }, c = function() {
    if (n) {
      var C = F({}, MS(n.lastCritical, n.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      I(C);
    }
  };
  return {
    beforeCapture: r,
    beforeStart: g,
    start: o,
    update: l,
    flush: a,
    drop: I,
    abort: c
  };
}, lTt = function(e, t) {
  var i = oTt(e, t);
  return function(n) {
    return function(r) {
      return function(g) {
        if (g.type === "BEFORE_INITIAL_CAPTURE") {
          i.beforeCapture(g.payload.draggableId, g.payload.movementMode);
          return;
        }
        if (g.type === "INITIAL_PUBLISH") {
          var o = g.payload.critical;
          i.beforeStart(o, g.payload.movementMode), r(g), i.start(o, g.payload.movementMode);
          return;
        }
        if (g.type === "DROP_COMPLETE") {
          var l = g.payload.completed.result;
          i.flush(), r(g), i.drop(l);
          return;
        }
        if (r(g), g.type === "FLUSH") {
          i.abort();
          return;
        }
        var a = n.getState();
        a.phase === "DRAGGING" && i.update(a.critical, a.impact);
      };
    };
  };
}, aTt = function(e) {
  return function(t) {
    return function(i) {
      if (i.type !== "DROP_ANIMATION_FINISHED") {
        t(i);
        return;
      }
      var n = e.getState();
      n.phase !== "DROP_ANIMATING" && St(), e.dispatch(bN({
        completed: n.completed
      }));
    };
  };
}, sTt = function(e) {
  var t = null, i = null;
  function n() {
    i && (cancelAnimationFrame(i), i = null), t && (t(), t = null);
  }
  return function(r) {
    return function(g) {
      if ((g.type === "FLUSH" || g.type === "DROP_COMPLETE" || g.type === "DROP_ANIMATION_FINISHED") && n(), r(g), g.type === "DROP_ANIMATE") {
        var o = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var a = e.getState();
            a.phase === "DROP_ANIMATING" && e.dispatch(Tne());
          }
        };
        i = requestAnimationFrame(function() {
          i = null, t = Ya(window, [o]);
        });
      }
    };
  };
}, ITt = function(e) {
  return function() {
    return function(t) {
      return function(i) {
        (i.type === "DROP_COMPLETE" || i.type === "FLUSH" || i.type === "DROP_ANIMATE") && e.stopPublishing(), t(i);
      };
    };
  };
}, cTt = function(e) {
  var t = !1;
  return function() {
    return function(i) {
      return function(n) {
        if (n.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(n.payload.critical.draggable.id), i(n), e.tryRestoreFocusRecorded();
          return;
        }
        if (i(n), !!t) {
          if (n.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (n.type === "DROP_COMPLETE") {
            t = !1;
            var r = n.payload.completed.result;
            r.combine && e.tryShiftRecord(r.draggableId, r.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, dTt = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, uTt = function(e) {
  return function(t) {
    return function(i) {
      return function(n) {
        if (dTt(n)) {
          e.stop(), i(n);
          return;
        }
        if (n.type === "INITIAL_PUBLISH") {
          i(n);
          var r = t.getState();
          r.phase !== "DRAGGING" && St(), e.start(r);
          return;
        }
        i(n), e.scroll(t.getState());
      };
    };
  };
}, CTt = function(e) {
  return function(t) {
    return function(i) {
      if (t(i), i.type === "PUBLISH_WHILE_DRAGGING") {
        var n = e.getState();
        n.phase === "DROP_PENDING" && (n.isWaiting || e.dispatch(Kne({
          reason: n.reason
        })));
      }
    };
  };
}, ATt = tne, bTt = function(e) {
  var t = e.dimensionMarshal, i = e.focusMarshal, n = e.styleMarshal, r = e.getResponders, g = e.announce, o = e.autoScroller;
  return ene(S3t, ATt(bLt(M3t(n), ITt(t), T3t(t), j3t, aTt, sTt, CTt, uTt(o), eTt, cTt(i), lTt(r, g))));
}, PF = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function hTt(e) {
  var t = e.registry, i = e.callbacks, n = PF(), r = null, g = function() {
    r || (i.collectionStarting(), r = requestAnimationFrame(function() {
      r = null;
      var c = n, d = c.additions, C = c.removals, A = c.modified, b = Object.keys(d).map(function(B) {
        return t.draggable.getById(B).getDimension(Zg);
      }).sort(function(B, f) {
        return B.descriptor.index - f.descriptor.index;
      }), m = Object.keys(A).map(function(B) {
        var f = t.droppable.getById(B), Z = f.callbacks.getScrollWhileDragging();
        return {
          droppableId: B,
          scroll: Z
        };
      }), p = {
        additions: b,
        removals: Object.keys(C),
        modified: m
      };
      n = PF(), i.publish(p);
    }));
  }, o = function(c) {
    var d = c.descriptor.id;
    n.additions[d] = c, n.modified[c.descriptor.droppableId] = !0, n.removals[d] && delete n.removals[d], g();
  }, l = function(c) {
    var d = c.descriptor;
    n.removals[d.id] = !0, n.modified[d.droppableId] = !0, n.additions[d.id] && delete n.additions[d.id], g();
  }, a = function() {
    r && (cancelAnimationFrame(r), r = null, n = PF());
  };
  return {
    add: o,
    remove: l,
    stop: a
  };
}
var Une = function(e) {
  var t = e.scrollHeight, i = e.scrollWidth, n = e.height, r = e.width, g = El({
    x: i,
    y: t
  }, {
    x: r,
    y: n
  }), o = {
    x: Math.max(0, g.x),
    y: Math.max(0, g.y)
  };
  return o;
}, zne = function() {
  var e = document.documentElement;
  return e || St(), e;
}, One = function() {
  var e = zne(), t = Une({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, mTt = function() {
  var e = Pne(), t = One(), i = e.y, n = e.x, r = zne(), g = r.clientWidth, o = r.clientHeight, l = n + g, a = i + o, I = vs({
    top: i,
    left: n,
    right: l,
    bottom: a
  }), c = {
    frame: I,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Zg,
        displacement: Zg
      }
    }
  };
  return c;
}, pTt = function(e) {
  var t = e.critical, i = e.scrollOptions, n = e.registry, r = mTt(), g = r.scroll.current, o = t.droppable, l = n.droppable.getAllByType(o.type).map(function(d) {
    return d.callbacks.getDimensionAndWatchScroll(g, i);
  }), a = n.draggable.getAllByType(t.draggable.type).map(function(d) {
    return d.getDimension(g);
  }), I = {
    draggables: Gne(a),
    droppables: Zne(l)
  }, c = {
    dimensions: I,
    critical: t,
    viewport: r
  };
  return c;
};
function Uz(e, t, i) {
  if (i.descriptor.id === t.id || i.descriptor.type !== t.type)
    return !1;
  var n = e.droppable.getById(i.descriptor.droppableId);
  return n.descriptor.mode === "virtual";
}
var BTt = function(e, t) {
  var i = null, n = hTt({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), r = function(A, b) {
    e.droppable.exists(A) || St(), i && t.updateDroppableIsEnabled({
      id: A,
      isEnabled: b
    });
  }, g = function(A, b) {
    i && (e.droppable.exists(A) || St(), t.updateDroppableIsCombineEnabled({
      id: A,
      isCombineEnabled: b
    }));
  }, o = function(A, b) {
    i && (e.droppable.exists(A) || St(), t.updateDroppableScroll({
      id: A,
      newScroll: b
    }));
  }, l = function(A, b) {
    i && e.droppable.getById(A).callbacks.scroll(b);
  }, a = function() {
    if (i) {
      n.stop();
      var A = i.critical.droppable;
      e.droppable.getAllByType(A.type).forEach(function(b) {
        return b.callbacks.dragStopped();
      }), i.unsubscribe(), i = null;
    }
  }, I = function(A) {
    i || St();
    var b = i.critical.draggable;
    A.type === "ADDITION" && Uz(e, b, A.value) && n.add(A.value), A.type === "REMOVAL" && Uz(e, b, A.value) && n.remove(A.value);
  }, c = function(A) {
    i && St();
    var b = e.draggable.getById(A.draggableId), m = e.droppable.getById(b.descriptor.droppableId), p = {
      draggable: b.descriptor,
      droppable: m.descriptor
    }, B = e.subscribe(I);
    return i = {
      critical: p,
      unsubscribe: B
    }, pTt({
      critical: p,
      registry: e,
      scrollOptions: A.scrollOptions
    });
  }, d = {
    updateDroppableIsEnabled: r,
    updateDroppableIsCombineEnabled: g,
    scrollDroppable: l,
    updateDroppableScroll: o,
    startPublishing: c,
    stopPublishing: a
  };
  return d;
}, Qne = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, fTt = function(e) {
  window.scrollBy(e.x, e.y);
}, ZTt = Bg(function(e) {
  return D1(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), GTt = function(t, i) {
  var n = Zu(ZTt(i), function(r) {
    return r.frame || St(), kne(r.frame.pageMarginBox)(t);
  });
  return n;
}, yTt = function(e) {
  var t = e.center, i = e.destination, n = e.droppables;
  if (i) {
    var r = n[i];
    return r.frame ? r : null;
  }
  var g = GTt(t, n);
  return g;
}, Ud = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, WTt = function(e, t) {
  var i = e[t.size] * Ud.startFromPercentage, n = e[t.size] * Ud.maxScrollAtPercentage, r = {
    startScrollingFrom: i,
    maxScrollValueAt: n
  };
  return r;
}, jne = function(e) {
  var t = e.startOfRange, i = e.endOfRange, n = e.current, r = i - t;
  if (r === 0)
    return 0;
  var g = n - t, o = g / r;
  return o;
}, pN = 1, STt = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return Ud.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return pN;
  var i = jne({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), n = 1 - i, r = Ud.maxPixelScroll * Ud.ease(n);
  return Math.ceil(r);
}, zz = Ud.durationDampening.accelerateAt, Oz = Ud.durationDampening.stopDampeningAt, VTt = function(e, t) {
  var i = t, n = Oz, r = Date.now(), g = r - i;
  if (g >= Oz)
    return e;
  if (g < zz)
    return pN;
  var o = jne({
    startOfRange: zz,
    endOfRange: n,
    current: g
  }), l = e * Ud.ease(o);
  return Math.ceil(l);
}, Qz = function(e) {
  var t = e.distanceToEdge, i = e.thresholds, n = e.dragStartTime, r = e.shouldUseTimeDampening, g = STt(t, i);
  return g === 0 ? 0 : r ? Math.max(VTt(g, n), pN) : g;
}, jz = function(e) {
  var t = e.container, i = e.distanceToEdges, n = e.dragStartTime, r = e.axis, g = e.shouldUseTimeDampening, o = WTt(t, r), l = i[r.end] < i[r.start];
  return l ? Qz({
    distanceToEdge: i[r.end],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: g
  }) : -1 * Qz({
    distanceToEdge: i[r.start],
    thresholds: o,
    dragStartTime: n,
    shouldUseTimeDampening: g
  });
}, wTt = function(e) {
  var t = e.container, i = e.subject, n = e.proposedScroll, r = i.height > t.height, g = i.width > t.width;
  return !g && !r ? n : g && r ? null : {
    x: g ? 0 : n.x,
    y: r ? 0 : n.y
  };
}, vTt = Bne(function(e) {
  return e === 0 ? 0 : e;
}), qne = function(e) {
  var t = e.dragStartTime, i = e.container, n = e.subject, r = e.center, g = e.shouldUseTimeDampening, o = {
    top: r.y - i.top,
    right: i.right - r.x,
    bottom: i.bottom - r.y,
    left: r.x - i.left
  }, l = jz({
    container: i,
    distanceToEdges: o,
    dragStartTime: t,
    axis: IN,
    shouldUseTimeDampening: g
  }), a = jz({
    container: i,
    distanceToEdges: o,
    dragStartTime: t,
    axis: Sne,
    shouldUseTimeDampening: g
  }), I = vTt({
    x: a,
    y: l
  });
  if (Pd(I, Zg))
    return null;
  var c = wTt({
    container: i,
    subject: n,
    proposedScroll: I
  });
  return c ? Pd(c, Zg) ? null : c : null;
}, RTt = Bne(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), BN = /* @__PURE__ */ function() {
  var e = function(i, n) {
    return i < 0 ? i : i > n ? i - n : 0;
  };
  return function(t) {
    var i = t.current, n = t.max, r = t.change, g = Pg(i, r), o = {
      x: e(g.x, n.x),
      y: e(g.y, n.y)
    };
    return Pd(o, Zg) ? null : o;
  };
}(), _ne = function(t) {
  var i = t.max, n = t.current, r = t.change, g = {
    x: Math.max(n.x, i.x),
    y: Math.max(n.y, i.y)
  }, o = RTt(r), l = BN({
    max: g,
    current: n,
    change: o
  });
  return !l || o.x !== 0 && l.x === 0 || o.y !== 0 && l.y === 0;
}, fN = function(t, i) {
  return _ne({
    current: t.scroll.current,
    max: t.scroll.max,
    change: i
  });
}, XTt = function(t, i) {
  if (!fN(t, i))
    return null;
  var n = t.scroll.max, r = t.scroll.current;
  return BN({
    current: r,
    max: n,
    change: i
  });
}, ZN = function(t, i) {
  var n = t.frame;
  return n ? _ne({
    current: n.scroll.current,
    max: n.scroll.max,
    change: i
  }) : !1;
}, HTt = function(t, i) {
  var n = t.frame;
  return !n || !ZN(t, i) ? null : BN({
    current: n.scroll.current,
    max: n.scroll.max,
    change: i
  });
}, kTt = function(e) {
  var t = e.viewport, i = e.subject, n = e.center, r = e.dragStartTime, g = e.shouldUseTimeDampening, o = qne({
    dragStartTime: r,
    container: t.frame,
    subject: i,
    center: n,
    shouldUseTimeDampening: g
  });
  return o && fN(t, o) ? o : null;
}, YTt = function(e) {
  var t = e.droppable, i = e.subject, n = e.center, r = e.dragStartTime, g = e.shouldUseTimeDampening, o = t.frame;
  if (!o)
    return null;
  var l = qne({
    dragStartTime: r,
    container: o.pageMarginBox,
    subject: i,
    center: n,
    shouldUseTimeDampening: g
  });
  return l && ZN(t, l) ? l : null;
}, qz = function(e) {
  var t = e.state, i = e.dragStartTime, n = e.shouldUseTimeDampening, r = e.scrollWindow, g = e.scrollDroppable, o = t.current.page.borderBoxCenter, l = t.dimensions.draggables[t.critical.draggable.id], a = l.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var I = t.viewport, c = kTt({
      dragStartTime: i,
      viewport: I,
      subject: a,
      center: o,
      shouldUseTimeDampening: n
    });
    if (c) {
      r(c);
      return;
    }
  }
  var d = yTt({
    center: o,
    destination: Ml(t.impact),
    droppables: t.dimensions.droppables
  });
  if (d) {
    var C = YTt({
      dragStartTime: i,
      droppable: d,
      subject: a,
      center: o,
      shouldUseTimeDampening: n
    });
    C && g(d.descriptor.id, C);
  }
}, FTt = function(e) {
  var t = e.scrollWindow, i = e.scrollDroppable, n = _f(t), r = _f(i), g = null, o = function(c) {
    g || St();
    var d = g, C = d.shouldUseTimeDampening, A = d.dragStartTime;
    qz({
      state: c,
      scrollWindow: n,
      scrollDroppable: r,
      dragStartTime: A,
      shouldUseTimeDampening: C
    });
  }, l = function(c) {
    g && St();
    var d = Date.now(), C = !1, A = function() {
      C = !0;
    };
    qz({
      state: c,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: A,
      scrollDroppable: A
    }), g = {
      dragStartTime: d,
      shouldUseTimeDampening: C
    }, C && o(c);
  }, a = function() {
    g && (n.cancel(), r.cancel(), g = null);
  };
  return {
    start: l,
    stop: a,
    scroll: o
  };
}, xTt = function(e) {
  var t = e.move, i = e.scrollDroppable, n = e.scrollWindow, r = function(I, c) {
    var d = Pg(I.current.client.selection, c);
    t({
      client: d
    });
  }, g = function(I, c) {
    if (!ZN(I, c))
      return c;
    var d = HTt(I, c);
    if (!d)
      return i(I.descriptor.id, c), null;
    var C = El(c, d);
    i(I.descriptor.id, C);
    var A = El(c, C);
    return A;
  }, o = function(I, c, d) {
    if (!I || !fN(c, d))
      return d;
    var C = XTt(c, d);
    if (!C)
      return n(d), null;
    var A = El(d, C);
    n(A);
    var b = El(d, A);
    return b;
  }, l = function(I) {
    var c = I.scrollJumpRequest;
    if (c) {
      var d = Ml(I.impact);
      d || St();
      var C = g(I.dimensions.droppables[d], c);
      if (C) {
        var A = I.viewport, b = o(I.isWindowScrollAllowed, A, C);
        b && r(I, b);
      }
    }
  };
  return l;
}, DTt = function(e) {
  var t = e.scrollDroppable, i = e.scrollWindow, n = e.move, r = FTt({
    scrollWindow: i,
    scrollDroppable: t
  }), g = xTt({
    move: n,
    scrollWindow: i,
    scrollDroppable: t
  }), o = function(I) {
    if (I.phase === "DRAGGING") {
      if (I.movementMode === "FLUID") {
        r.scroll(I);
        return;
      }
      I.scrollJumpRequest && g(I);
    }
  }, l = {
    scroll: o,
    start: r.start,
    stop: r.stop
  };
  return l;
}, bm = "data-rbd", hm = function() {
  var e = bm + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), CD = function() {
  var e = bm + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), JTt = function() {
  var e = bm + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), _z = {
  contextId: bm + "-scroll-container-context-id"
}, ETt = function(t) {
  return function(i) {
    return "[" + i + '="' + t + '"]';
  };
}, BB = function(t, i) {
  return t.map(function(n) {
    var r = n.styles[i];
    return r ? n.selector + " { " + r + " }" : "";
  }).join(" ");
}, NTt = "pointer-events: none;", LTt = function(e) {
  var t = ETt(e), i = function() {
    var l = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(hm.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: l,
        dragging: NTt,
        dropAnimating: l
      }
    };
  }(), n = function() {
    var l = `
      transition: ` + uf.outOfTheWay + `;
    `;
    return {
      selector: t(CD.contextId),
      styles: {
        dragging: l,
        dropAnimating: l,
        userCancel: l
      }
    };
  }(), r = {
    selector: t(JTt.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, g = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, o = [n, i, r, g];
  return {
    always: BB(o, "always"),
    resting: BB(o, "resting"),
    dragging: BB(o, "dragging"),
    dropAnimating: BB(o, "dropAnimating"),
    userCancel: BB(o, "userCancel")
  };
}, Pl = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? lZ : lt, UF = function() {
  var t = document.querySelector("head");
  return t || St(), t;
}, $z = function(t) {
  var i = document.createElement("style");
  return t && i.setAttribute("nonce", t), i.type = "text/css", i;
};
function KTt(e, t) {
  var i = en(function() {
    return LTt(e);
  }, [e]), n = ot(null), r = ot(null), g = Ii(Bg(function(d) {
    var C = r.current;
    C || St(), C.textContent = d;
  }), []), o = Ii(function(d) {
    var C = n.current;
    C || St(), C.textContent = d;
  }, []);
  Pl(function() {
    !n.current && !r.current || St();
    var d = $z(t), C = $z(t);
    return n.current = d, r.current = C, d.setAttribute(bm + "-always", e), C.setAttribute(bm + "-dynamic", e), UF().appendChild(d), UF().appendChild(C), o(i.always), g(i.resting), function() {
      var A = function(m) {
        var p = m.current;
        p || St(), UF().removeChild(p), m.current = null;
      };
      A(n), A(r);
    };
  }, [t, o, g, i.always, i.resting, e]);
  var l = Ii(function() {
    return g(i.dragging);
  }, [g, i.dragging]), a = Ii(function(d) {
    if (d === "DROP") {
      g(i.dropAnimating);
      return;
    }
    g(i.userCancel);
  }, [g, i.dropAnimating, i.userCancel]), I = Ii(function() {
    r.current && g(i.resting);
  }, [g, i.resting]), c = en(function() {
    return {
      dragging: l,
      dropping: a,
      resting: I
    };
  }, [l, a, I]);
  return c;
}
var $ne = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function L1(e) {
  return e instanceof $ne(e).HTMLElement;
}
function TTt(e, t) {
  var i = "[" + hm.contextId + '="' + e + '"]', n = fne(document.querySelectorAll(i));
  if (!n.length)
    return null;
  var r = Zu(n, function(g) {
    return g.getAttribute(hm.draggableId) === t;
  });
  return !r || !L1(r) ? null : r;
}
function MTt(e) {
  var t = ot({}), i = ot(null), n = ot(null), r = ot(!1), g = Ii(function(C, A) {
    var b = {
      id: C,
      focus: A
    };
    return t.current[C] = b, function() {
      var p = t.current, B = p[C];
      B !== b && delete p[C];
    };
  }, []), o = Ii(function(C) {
    var A = TTt(e, C);
    A && A !== document.activeElement && A.focus();
  }, [e]), l = Ii(function(C, A) {
    i.current === C && (i.current = A);
  }, []), a = Ii(function() {
    n.current || r.current && (n.current = requestAnimationFrame(function() {
      n.current = null;
      var C = i.current;
      C && o(C);
    }));
  }, [o]), I = Ii(function(C) {
    i.current = null;
    var A = document.activeElement;
    A && A.getAttribute(hm.draggableId) === C && (i.current = C);
  }, []);
  Pl(function() {
    return r.current = !0, function() {
      r.current = !1;
      var C = n.current;
      C && cancelAnimationFrame(C);
    };
  }, []);
  var c = en(function() {
    return {
      register: g,
      tryRecordFocus: I,
      tryRestoreFocusRecorded: a,
      tryShiftRecord: l
    };
  }, [g, I, a, l]);
  return c;
}
function PTt() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function i(d) {
    return t.push(d), function() {
      var A = t.indexOf(d);
      A !== -1 && t.splice(A, 1);
    };
  }
  function n(d) {
    t.length && t.forEach(function(C) {
      return C(d);
    });
  }
  function r(d) {
    return e.draggables[d] || null;
  }
  function g(d) {
    var C = r(d);
    return C || St(), C;
  }
  var o = {
    register: function(C) {
      e.draggables[C.descriptor.id] = C, n({
        type: "ADDITION",
        value: C
      });
    },
    update: function(C, A) {
      var b = e.draggables[A.descriptor.id];
      b && b.uniqueId === C.uniqueId && (delete e.draggables[A.descriptor.id], e.draggables[C.descriptor.id] = C);
    },
    unregister: function(C) {
      var A = C.descriptor.id, b = r(A);
      b && C.uniqueId === b.uniqueId && (delete e.draggables[A], n({
        type: "REMOVAL",
        value: C
      }));
    },
    getById: g,
    findById: r,
    exists: function(C) {
      return !!r(C);
    },
    getAllByType: function(C) {
      return Uw(e.draggables).filter(function(A) {
        return A.descriptor.type === C;
      });
    }
  };
  function l(d) {
    return e.droppables[d] || null;
  }
  function a(d) {
    var C = l(d);
    return C || St(), C;
  }
  var I = {
    register: function(C) {
      e.droppables[C.descriptor.id] = C;
    },
    unregister: function(C) {
      var A = l(C.descriptor.id);
      A && C.uniqueId === A.uniqueId && delete e.droppables[C.descriptor.id];
    },
    getById: a,
    findById: l,
    exists: function(C) {
      return !!l(C);
    },
    getAllByType: function(C) {
      return Uw(e.droppables).filter(function(A) {
        return A.descriptor.type === C;
      });
    }
  };
  function c() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: o,
    droppable: I,
    subscribe: i,
    clean: c
  };
}
function UTt() {
  var e = en(PTt, []);
  return lt(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var GN = De.createContext(null), Ow = function() {
  var e = document.body;
  return e || St(), e;
}, zTt = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, OTt = function(t) {
  return "rbd-announcement-" + t;
};
function QTt(e) {
  var t = en(function() {
    return OTt(e);
  }, [e]), i = ot(null);
  lt(function() {
    var g = document.createElement("div");
    return i.current = g, g.id = t, g.setAttribute("aria-live", "assertive"), g.setAttribute("aria-atomic", "true"), F(g.style, zTt), Ow().appendChild(g), function() {
      setTimeout(function() {
        var a = Ow();
        a.contains(g) && a.removeChild(g), g === i.current && (i.current = null);
      });
    };
  }, [t]);
  var n = Ii(function(r) {
    var g = i.current;
    if (g) {
      g.textContent = r;
      return;
    }
  }, []);
  return n;
}
var jTt = 0, qTt = {
  separator: "::"
};
function yN(e, t) {
  return t === void 0 && (t = qTt), en(function() {
    return "" + e + t.separator + jTt++;
  }, [t.separator, e]);
}
function _Tt(e) {
  var t = e.contextId, i = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + i;
}
function $Tt(e) {
  var t = e.contextId, i = e.text, n = yN("hidden-text", {
    separator: "-"
  }), r = en(function() {
    return _Tt({
      contextId: t,
      uniqueId: n
    });
  }, [n, t]);
  return lt(function() {
    var o = document.createElement("div");
    return o.id = r, o.textContent = i, o.style.display = "none", Ow().appendChild(o), function() {
      var a = Ow();
      a.contains(o) && a.removeChild(o);
    };
  }, [r, i]), r;
}
var K1 = De.createContext(null);
function ere(e) {
  var t = ot(e);
  return lt(function() {
    t.current = e;
  }), t;
}
function eMt() {
  var e = null;
  function t() {
    return !!e;
  }
  function i(o) {
    return o === e;
  }
  function n(o) {
    e && St();
    var l = {
      abandon: o
    };
    return e = l, l;
  }
  function r() {
    e || St(), e = null;
  }
  function g() {
    e && (e.abandon(), r());
  }
  return {
    isClaimed: t,
    isActive: i,
    claim: n,
    release: r,
    tryAbandon: g
  };
}
var tMt = 9, iMt = 13, WN = 27, tre = 32, nMt = 33, rMt = 34, gMt = 35, oMt = 36, lMt = 37, aMt = 38, sMt = 39, IMt = 40, PS, cMt = (PS = {}, PS[iMt] = !0, PS[tMt] = !0, PS), ire = function(e) {
  cMt[e.keyCode] && e.preventDefault();
}, T1 = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], i = Zu(t, function(n) {
    return "on" + n in document;
  });
  return i || e;
}(), nre = 0, eO = 5;
function dMt(e, t) {
  return Math.abs(t.x - e.x) >= eO || Math.abs(t.y - e.y) >= eO;
}
var tO = {
  type: "IDLE"
};
function uMt(e) {
  var t = e.cancel, i = e.completed, n = e.getPhase, r = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(o) {
      var l = o.button, a = o.clientX, I = o.clientY;
      if (l === nre) {
        var c = {
          x: a,
          y: I
        }, d = n();
        if (d.type === "DRAGGING") {
          o.preventDefault(), d.actions.move(c);
          return;
        }
        d.type !== "PENDING" && St();
        var C = d.point;
        if (dMt(C, c)) {
          o.preventDefault();
          var A = d.actions.fluidLift(c);
          r({
            type: "DRAGGING",
            actions: A
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(o) {
      var l = n();
      if (l.type !== "DRAGGING") {
        t();
        return;
      }
      o.preventDefault(), l.actions.drop({
        shouldBlockNextClick: !0
      }), i();
    }
  }, {
    eventName: "mousedown",
    fn: function(o) {
      n().type === "DRAGGING" && o.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      var l = n();
      if (l.type === "PENDING") {
        t();
        return;
      }
      if (o.keyCode === WN) {
        o.preventDefault(), t();
        return;
      }
      ire(o);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      n().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(o) {
      var l = n();
      if (l.type === "IDLE" && St(), l.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      o.preventDefault();
    }
  }, {
    eventName: T1,
    fn: t
  }];
}
function CMt(e) {
  var t = ot(tO), i = ot(Md), n = en(function() {
    return {
      eventName: "mousedown",
      fn: function(d) {
        if (!d.defaultPrevented && d.button === nre && !(d.ctrlKey || d.metaKey || d.shiftKey || d.altKey)) {
          var C = e.findClosestDraggableId(d);
          if (C) {
            var A = e.tryGetLock(C, o, {
              sourceEvent: d
            });
            if (A) {
              d.preventDefault();
              var b = {
                x: d.clientX,
                y: d.clientY
              };
              i.current(), I(A, b);
            }
          }
        }
      }
    };
  }, [e]), r = en(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(d) {
        if (!d.defaultPrevented) {
          var C = e.findClosestDraggableId(d);
          if (C) {
            var A = e.findOptionsForDraggable(C);
            A && (A.shouldRespectForcePress || e.canGetLock(C) && d.preventDefault());
          }
        }
      }
    };
  }, [e]), g = Ii(function() {
    var d = {
      passive: !1,
      capture: !0
    };
    i.current = Ya(window, [r, n], d);
  }, [r, n]), o = Ii(function() {
    var c = t.current;
    c.type !== "IDLE" && (t.current = tO, i.current(), g());
  }, [g]), l = Ii(function() {
    var c = t.current;
    o(), c.type === "DRAGGING" && c.actions.cancel({
      shouldBlockNextClick: !0
    }), c.type === "PENDING" && c.actions.abort();
  }, [o]), a = Ii(function() {
    var d = {
      capture: !0,
      passive: !1
    }, C = uMt({
      cancel: l,
      completed: o,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(b) {
        t.current = b;
      }
    });
    i.current = Ya(window, C, d);
  }, [l, o]), I = Ii(function(d, C) {
    t.current.type !== "IDLE" && St(), t.current = {
      type: "PENDING",
      point: C,
      actions: d
    }, a();
  }, [a]);
  Pl(function() {
    return g(), function() {
      i.current();
    };
  }, [g]);
}
var yh;
function AMt() {
}
var bMt = (yh = {}, yh[rMt] = !0, yh[nMt] = !0, yh[oMt] = !0, yh[gMt] = !0, yh);
function hMt(e, t) {
  function i() {
    t(), e.cancel();
  }
  function n() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(g) {
      if (g.keyCode === WN) {
        g.preventDefault(), i();
        return;
      }
      if (g.keyCode === tre) {
        g.preventDefault(), n();
        return;
      }
      if (g.keyCode === IMt) {
        g.preventDefault(), e.moveDown();
        return;
      }
      if (g.keyCode === aMt) {
        g.preventDefault(), e.moveUp();
        return;
      }
      if (g.keyCode === sMt) {
        g.preventDefault(), e.moveRight();
        return;
      }
      if (g.keyCode === lMt) {
        g.preventDefault(), e.moveLeft();
        return;
      }
      if (bMt[g.keyCode]) {
        g.preventDefault();
        return;
      }
      ire(g);
    }
  }, {
    eventName: "mousedown",
    fn: i
  }, {
    eventName: "mouseup",
    fn: i
  }, {
    eventName: "click",
    fn: i
  }, {
    eventName: "touchstart",
    fn: i
  }, {
    eventName: "resize",
    fn: i
  }, {
    eventName: "wheel",
    fn: i,
    options: {
      passive: !0
    }
  }, {
    eventName: T1,
    fn: i
  }];
}
function mMt(e) {
  var t = ot(AMt), i = en(function() {
    return {
      eventName: "keydown",
      fn: function(g) {
        if (g.defaultPrevented || g.keyCode !== tre)
          return;
        var o = e.findClosestDraggableId(g);
        if (!o)
          return;
        var l = e.tryGetLock(o, c, {
          sourceEvent: g
        });
        if (!l)
          return;
        g.preventDefault();
        var a = !0, I = l.snapLift();
        t.current();
        function c() {
          a || St(), a = !1, t.current(), n();
        }
        t.current = Ya(window, hMt(I, c), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), n = Ii(function() {
    var g = {
      passive: !1,
      capture: !0
    };
    t.current = Ya(window, [i], g);
  }, [i]);
  Pl(function() {
    return n(), function() {
      t.current();
    };
  }, [n]);
}
var zF = {
  type: "IDLE"
}, pMt = 120, BMt = 0.15;
function fMt(e) {
  var t = e.cancel, i = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(r) {
      r.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(r) {
      if (i().type !== "DRAGGING") {
        t();
        return;
      }
      r.keyCode === WN && r.preventDefault(), t();
    }
  }, {
    eventName: T1,
    fn: t
  }];
}
function ZMt(e) {
  var t = e.cancel, i = e.completed, n = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(g) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      o.hasMoved = !0;
      var l = g.touches[0], a = l.clientX, I = l.clientY, c = {
        x: a,
        y: I
      };
      g.preventDefault(), o.actions.move(c);
    }
  }, {
    eventName: "touchend",
    fn: function(g) {
      var o = n();
      if (o.type !== "DRAGGING") {
        t();
        return;
      }
      g.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), i();
    }
  }, {
    eventName: "touchcancel",
    fn: function(g) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      g.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(g) {
      var o = n();
      o.type === "IDLE" && St();
      var l = g.touches[0];
      if (l) {
        var a = l.force >= BMt;
        if (a) {
          var I = o.actions.shouldRespectForcePress();
          if (o.type === "PENDING") {
            I && t();
            return;
          }
          if (I) {
            if (o.hasMoved) {
              g.preventDefault();
              return;
            }
            t();
            return;
          }
          g.preventDefault();
        }
      }
    }
  }, {
    eventName: T1,
    fn: t
  }];
}
function GMt(e) {
  var t = ot(zF), i = ot(Md), n = Ii(function() {
    return t.current;
  }, []), r = Ii(function(A) {
    t.current = A;
  }, []), g = en(function() {
    return {
      eventName: "touchstart",
      fn: function(A) {
        if (!A.defaultPrevented) {
          var b = e.findClosestDraggableId(A);
          if (b) {
            var m = e.tryGetLock(b, l, {
              sourceEvent: A
            });
            if (m) {
              var p = A.touches[0], B = p.clientX, f = p.clientY, Z = {
                x: B,
                y: f
              };
              i.current(), d(m, Z);
            }
          }
        }
      }
    };
  }, [e]), o = Ii(function() {
    var A = {
      capture: !0,
      passive: !1
    };
    i.current = Ya(window, [g], A);
  }, [g]), l = Ii(function() {
    var C = t.current;
    C.type !== "IDLE" && (C.type === "PENDING" && clearTimeout(C.longPressTimerId), r(zF), i.current(), o());
  }, [o, r]), a = Ii(function() {
    var C = t.current;
    l(), C.type === "DRAGGING" && C.actions.cancel({
      shouldBlockNextClick: !0
    }), C.type === "PENDING" && C.actions.abort();
  }, [l]), I = Ii(function() {
    var A = {
      capture: !0,
      passive: !1
    }, b = {
      cancel: a,
      completed: l,
      getPhase: n
    }, m = Ya(window, ZMt(b), A), p = Ya(window, fMt(b), A);
    i.current = function() {
      m(), p();
    };
  }, [a, n, l]), c = Ii(function() {
    var A = n();
    A.type !== "PENDING" && St();
    var b = A.actions.fluidLift(A.point);
    r({
      type: "DRAGGING",
      actions: b,
      hasMoved: !1
    });
  }, [n, r]), d = Ii(function(A, b) {
    n().type !== "IDLE" && St();
    var m = setTimeout(c, pMt);
    r({
      type: "PENDING",
      point: b,
      actions: A,
      longPressTimerId: m
    }), I();
  }, [I, n, r, c]);
  Pl(function() {
    return o(), function() {
      i.current();
      var b = n();
      b.type === "PENDING" && (clearTimeout(b.longPressTimerId), r(zF));
    };
  }, [n, o, r]), Pl(function() {
    var A = Ya(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return A;
  }, []);
}
var yMt = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function rre(e, t) {
  if (t == null)
    return !1;
  var i = !!yMt[t.tagName.toLowerCase()];
  if (i)
    return !0;
  var n = t.getAttribute("contenteditable");
  return n === "true" || n === "" ? !0 : t === e ? !1 : rre(e, t.parentElement);
}
function WMt(e, t) {
  var i = t.target;
  return L1(i) ? rre(e, i) : !1;
}
var SMt = function(e) {
  return vs(e.getBoundingClientRect()).center;
};
function VMt(e) {
  return e instanceof $ne(e).Element;
}
var wMt = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], i = Zu(t, function(n) {
    return n in Element.prototype;
  });
  return i || e;
}();
function gre(e, t) {
  return e == null ? null : e[wMt](t) ? e : gre(e.parentElement, t);
}
function vMt(e, t) {
  return e.closest ? e.closest(t) : gre(e, t);
}
function RMt(e) {
  return "[" + hm.contextId + '="' + e + '"]';
}
function XMt(e, t) {
  var i = t.target;
  if (!VMt(i))
    return null;
  var n = RMt(e), r = vMt(i, n);
  return !r || !L1(r) ? null : r;
}
function HMt(e, t) {
  var i = XMt(e, t);
  return i ? i.getAttribute(hm.draggableId) : null;
}
function kMt(e, t) {
  var i = "[" + CD.contextId + '="' + e + '"]', n = fne(document.querySelectorAll(i)), r = Zu(n, function(g) {
    return g.getAttribute(CD.id) === t;
  });
  return !r || !L1(r) ? null : r;
}
function YMt(e) {
  e.preventDefault();
}
function US(e) {
  var t = e.expected, i = e.phase, n = e.isLockActive;
  return e.shouldWarn, !(!n() || t !== i);
}
function ore(e) {
  var t = e.lockAPI, i = e.store, n = e.registry, r = e.draggableId;
  if (t.isClaimed())
    return !1;
  var g = n.draggable.findById(r);
  return !(!g || !g.options.isEnabled || !Qne(i.getState(), r));
}
function FMt(e) {
  var t = e.lockAPI, i = e.contextId, n = e.store, r = e.registry, g = e.draggableId, o = e.forceSensorStop, l = e.sourceEvent, a = ore({
    lockAPI: t,
    store: n,
    registry: r,
    draggableId: g
  });
  if (!a)
    return null;
  var I = r.draggable.getById(g), c = kMt(i, I.descriptor.id);
  if (!c || l && !I.options.canDragInteractiveElements && WMt(c, l))
    return null;
  var d = t.claim(o || Md), C = "PRE_DRAG";
  function A() {
    return I.options.shouldRespectForcePress;
  }
  function b() {
    return t.isActive(d);
  }
  function m(V, w) {
    US({
      expected: V,
      phase: C,
      isLockActive: b,
      shouldWarn: !0
    }) && n.dispatch(w());
  }
  var p = m.bind(null, "DRAGGING");
  function B(V) {
    function w() {
      t.release(), C = "COMPLETED";
    }
    C !== "PRE_DRAG" && (w(), C !== "PRE_DRAG" && St()), n.dispatch(w3t(V.liftActionArgs)), C = "DRAGGING";
    function v(H, x) {
      if (x === void 0 && (x = {
        shouldBlockNextClick: !1
      }), V.cleanup(), x.shouldBlockNextClick) {
        var J = Ya(window, [{
          eventName: "click",
          fn: YMt,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(J);
      }
      w(), n.dispatch(Kne({
        reason: H
      }));
    }
    return F({
      isActive: function() {
        return US({
          expected: "DRAGGING",
          phase: C,
          isLockActive: b,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: A,
      drop: function(x) {
        return v("DROP", x);
      },
      cancel: function(x) {
        return v("CANCEL", x);
      }
    }, V.actions);
  }
  function f(V) {
    var w = _f(function(H) {
      p(function() {
        return Lne({
          client: H
        });
      });
    }), v = B({
      liftActionArgs: {
        id: g,
        clientSelection: V,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return w.cancel();
      },
      actions: {
        move: w
      }
    });
    return F({}, v, {
      move: w
    });
  }
  function Z() {
    var V = {
      moveUp: function() {
        return p(D3t);
      },
      moveRight: function() {
        return p(E3t);
      },
      moveDown: function() {
        return p(J3t);
      },
      moveLeft: function() {
        return p(N3t);
      }
    };
    return B({
      liftActionArgs: {
        id: g,
        clientSelection: SMt(c),
        movementMode: "SNAP"
      },
      cleanup: Md,
      actions: V
    });
  }
  function y() {
    var V = US({
      expected: "PRE_DRAG",
      phase: C,
      isLockActive: b,
      shouldWarn: !0
    });
    V && t.release();
  }
  var W = {
    isActive: function() {
      return US({
        expected: "PRE_DRAG",
        phase: C,
        isLockActive: b,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: A,
    fluidLift: f,
    snapLift: Z,
    abort: y
  };
  return W;
}
var xMt = [CMt, mMt, GMt];
function DMt(e) {
  var t = e.contextId, i = e.store, n = e.registry, r = e.customSensors, g = e.enableDefaultSensors, o = [].concat(g ? xMt : [], r || []), l = wt(function() {
    return eMt();
  })[0], a = Ii(function(f, Z) {
    f.isDragging && !Z.isDragging && l.tryAbandon();
  }, [l]);
  Pl(function() {
    var f = i.getState(), Z = i.subscribe(function() {
      var y = i.getState();
      a(f, y), f = y;
    });
    return Z;
  }, [l, i, a]), Pl(function() {
    return l.tryAbandon;
  }, [l.tryAbandon]);
  for (var I = Ii(function(B) {
    return ore({
      lockAPI: l,
      registry: n,
      store: i,
      draggableId: B
    });
  }, [l, n, i]), c = Ii(function(B, f, Z) {
    return FMt({
      lockAPI: l,
      registry: n,
      contextId: t,
      store: i,
      draggableId: B,
      forceSensorStop: f,
      sourceEvent: Z && Z.sourceEvent ? Z.sourceEvent : null
    });
  }, [t, l, n, i]), d = Ii(function(B) {
    return HMt(t, B);
  }, [t]), C = Ii(function(B) {
    var f = n.draggable.findById(B);
    return f ? f.options : null;
  }, [n.draggable]), A = Ii(function() {
    l.isClaimed() && (l.tryAbandon(), i.getState().phase !== "IDLE" && i.dispatch(AN()));
  }, [l, i]), b = Ii(l.isClaimed, [l]), m = en(function() {
    return {
      canGetLock: I,
      tryGetLock: c,
      findClosestDraggableId: d,
      findOptionsForDraggable: C,
      tryReleaseLock: A,
      isLockClaimed: b
    };
  }, [I, c, d, C, A, b]), p = 0; p < o.length; p++)
    o[p](m);
}
var JMt = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function fB(e) {
  return e.current || St(), e.current;
}
function EMt(e) {
  var t = e.contextId, i = e.setCallbacks, n = e.sensors, r = e.nonce, g = e.dragHandleUsageInstructions, o = ot(null), l = ere(e), a = Ii(function() {
    return JMt(l.current);
  }, [l]), I = QTt(t), c = $Tt({
    contextId: t,
    text: g
  }), d = KTt(t, r), C = Ii(function(H) {
    fB(o).dispatch(H);
  }, []), A = en(function() {
    return wz({
      publishWhileDragging: R3t,
      updateDroppableScroll: H3t,
      updateDroppableIsEnabled: k3t,
      updateDroppableIsCombineEnabled: Y3t,
      collectionStarting: X3t
    }, C);
  }, [C]), b = UTt(), m = en(function() {
    return BTt(b, A);
  }, [b, A]), p = en(function() {
    return DTt(F({
      scrollWindow: fTt,
      scrollDroppable: m.scrollDroppable
    }, wz({
      move: Lne
    }, C)));
  }, [m.scrollDroppable, C]), B = MTt(t), f = en(function() {
    return bTt({
      announce: I,
      autoScroller: p,
      dimensionMarshal: m,
      focusMarshal: B,
      getResponders: a,
      styleMarshal: d
    });
  }, [I, p, m, B, a, d]);
  o.current = f;
  var Z = Ii(function() {
    var H = fB(o), x = H.getState();
    x.phase !== "IDLE" && H.dispatch(AN());
  }, []), y = Ii(function() {
    var H = fB(o).getState();
    return H.isDragging || H.phase === "DROP_ANIMATING";
  }, []), W = en(function() {
    return {
      isDragging: y,
      tryAbort: Z
    };
  }, [y, Z]);
  i(W);
  var V = Ii(function(H) {
    return Qne(fB(o).getState(), H);
  }, []), w = Ii(function() {
    return VC(fB(o).getState());
  }, []), v = en(function() {
    return {
      marshal: m,
      focus: B,
      contextId: t,
      canLift: V,
      isMovementAllowed: w,
      dragHandleUsageInstructionsId: c,
      registry: b
    };
  }, [t, m, c, B, V, w, b]);
  return DMt({
    contextId: t,
    store: f,
    registry: b,
    customSensors: n,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), lt(function() {
    return Z;
  }, [Z]), De.createElement(K1.Provider, {
    value: v
  }, De.createElement(fLt, {
    context: GN,
    store: f
  }, e.children));
}
var NMt = 0;
function LMt() {
  return en(function() {
    return "" + NMt++;
  }, []);
}
function SN(e) {
  var t = LMt(), i = e.dragHandleUsageInstructions || kV.dragHandleUsageInstructions;
  return De.createElement(mKt, null, function(n) {
    return De.createElement(EMt, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: n,
      dragHandleUsageInstructions: i,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var lre = function(t) {
  return function(i) {
    return t === i;
  };
}, KMt = lre("scroll"), TMt = lre("auto"), iO = function(t, i) {
  return i(t.overflowX) || i(t.overflowY);
}, MMt = function(t) {
  var i = window.getComputedStyle(t), n = {
    overflowX: i.overflowX,
    overflowY: i.overflowY
  };
  return iO(n, KMt) || iO(n, TMt);
}, PMt = function() {
  return !1;
}, UMt = function e(t) {
  return t == null ? null : t === document.body ? PMt() ? t : null : t === document.documentElement ? null : MMt(t) ? t : e(t.parentElement);
}, AD = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, zMt = function e(t) {
  if (!t)
    return !1;
  var i = window.getComputedStyle(t);
  return i.position === "fixed" ? !0 : e(t.parentElement);
}, OMt = function(e) {
  var t = UMt(e), i = zMt(e);
  return {
    closestScrollable: t,
    isFixedOnPage: i
  };
}, QMt = function(e) {
  var t = e.descriptor, i = e.isEnabled, n = e.isCombineEnabled, r = e.isFixedOnPage, g = e.direction, o = e.client, l = e.page, a = e.closest, I = function() {
    if (!a)
      return null;
    var A = a.scrollSize, b = a.client, m = Une({
      scrollHeight: A.scrollHeight,
      scrollWidth: A.scrollWidth,
      height: b.paddingBox.height,
      width: b.paddingBox.width
    });
    return {
      pageMarginBox: a.page.marginBox,
      frameClient: b,
      scrollSize: A,
      shouldClipSubject: a.shouldClipSubject,
      scroll: {
        initial: a.scroll,
        current: a.scroll,
        max: m,
        diff: {
          value: Zg,
          displacement: Zg
        }
      }
    };
  }(), c = g === "vertical" ? IN : Sne, d = Am({
    page: l,
    withPlaceholder: null,
    axis: c,
    frame: I
  }), C = {
    descriptor: t,
    isCombineEnabled: n,
    isFixedOnPage: r,
    axis: c,
    isEnabled: i,
    client: o,
    page: l,
    frame: I,
    subject: d
  };
  return C;
}, jMt = function(t, i) {
  var n = bne(t);
  if (!i || t !== i)
    return n;
  var r = n.paddingBox.top - i.scrollTop, g = n.paddingBox.left - i.scrollLeft, o = r + i.scrollHeight, l = g + i.scrollWidth, a = {
    top: r,
    right: l,
    bottom: o,
    left: g
  }, I = gN(a, n.border), c = oN({
    borderBox: I,
    margin: n.margin,
    border: n.border,
    padding: n.padding
  });
  return c;
}, qMt = function(e) {
  var t = e.ref, i = e.descriptor, n = e.env, r = e.windowScroll, g = e.direction, o = e.isDropDisabled, l = e.isCombineEnabled, a = e.shouldClipSubject, I = n.closestScrollable, c = jMt(t, I), d = Tw(c, r), C = function() {
    if (!I)
      return null;
    var b = bne(I), m = {
      scrollHeight: I.scrollHeight,
      scrollWidth: I.scrollWidth
    };
    return {
      client: b,
      page: Tw(b, r),
      scroll: AD(I),
      scrollSize: m,
      shouldClipSubject: a
    };
  }(), A = QMt({
    descriptor: i,
    isEnabled: !o,
    isCombineEnabled: l,
    isFixedOnPage: n.isFixedOnPage,
    direction: g,
    client: c,
    page: d,
    closest: C
  });
  return A;
}, _Mt = {
  passive: !1
}, $Mt = {
  passive: !0
}, nO = function(e) {
  return e.shouldPublishImmediately ? _Mt : $Mt;
};
function Qw(e) {
  var t = Vn(e);
  return t || St(), t;
}
var zS = function(t) {
  return t && t.env.closestScrollable || null;
};
function ePt(e) {
  var t = ot(null), i = Qw(K1), n = yN("droppable"), r = i.registry, g = i.marshal, o = ere(e), l = en(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), a = ot(l), I = en(function() {
    return Bg(function(y, W) {
      t.current || St();
      var V = {
        x: y,
        y: W
      };
      g.updateDroppableScroll(l.id, V);
    });
  }, [l.id, g]), c = Ii(function() {
    var y = t.current;
    return !y || !y.env.closestScrollable ? Zg : AD(y.env.closestScrollable);
  }, []), d = Ii(function() {
    var y = c();
    I(y.x, y.y);
  }, [c, I]), C = en(function() {
    return _f(d);
  }, [d]), A = Ii(function() {
    var y = t.current, W = zS(y);
    y && W || St();
    var V = y.scrollOptions;
    if (V.shouldPublishImmediately) {
      d();
      return;
    }
    C();
  }, [C, d]), b = Ii(function(y, W) {
    t.current && St();
    var V = o.current, w = V.getDroppableRef();
    w || St();
    var v = OMt(w), H = {
      ref: w,
      descriptor: l,
      env: v,
      scrollOptions: W
    };
    t.current = H;
    var x = qMt({
      ref: w,
      descriptor: l,
      env: v,
      windowScroll: y,
      direction: V.direction,
      isDropDisabled: V.isDropDisabled,
      isCombineEnabled: V.isCombineEnabled,
      shouldClipSubject: !V.ignoreContainerClipping
    }), J = v.closestScrollable;
    return J && (J.setAttribute(_z.contextId, i.contextId), J.addEventListener("scroll", A, nO(H.scrollOptions))), x;
  }, [i.contextId, l, A, o]), m = Ii(function() {
    var y = t.current, W = zS(y);
    return y && W || St(), AD(W);
  }, []), p = Ii(function() {
    var y = t.current;
    y || St();
    var W = zS(y);
    t.current = null, W && (C.cancel(), W.removeAttribute(_z.contextId), W.removeEventListener("scroll", A, nO(y.scrollOptions)));
  }, [A, C]), B = Ii(function(y) {
    var W = t.current;
    W || St();
    var V = zS(W);
    V || St(), V.scrollTop += y.y, V.scrollLeft += y.x;
  }, []), f = en(function() {
    return {
      getDimensionAndWatchScroll: b,
      getScrollWhileDragging: m,
      dragStopped: p,
      scroll: B
    };
  }, [p, b, m, B]), Z = en(function() {
    return {
      uniqueId: n,
      descriptor: l,
      callbacks: f
    };
  }, [f, l, n]);
  Pl(function() {
    return a.current = Z.descriptor, r.droppable.register(Z), function() {
      t.current && p(), r.droppable.unregister(Z);
    };
  }, [f, l, p, Z, g, r.droppable]), Pl(function() {
    t.current && g.updateDroppableIsEnabled(a.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, g]), Pl(function() {
    t.current && g.updateDroppableIsCombineEnabled(a.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, g]);
}
function OF() {
}
var rO = {
  width: 0,
  height: 0,
  margin: yKt
}, tPt = function(t) {
  var i = t.isAnimatingOpenOnMount, n = t.placeholder, r = t.animate;
  return i || r === "close" ? rO : {
    height: n.client.borderBox.height,
    width: n.client.borderBox.width,
    margin: n.client.margin
  };
}, iPt = function(t) {
  var i = t.isAnimatingOpenOnMount, n = t.placeholder, r = t.animate, g = tPt({
    isAnimatingOpenOnMount: i,
    placeholder: n,
    animate: r
  });
  return {
    display: n.display,
    boxSizing: "border-box",
    width: g.width,
    height: g.height,
    marginTop: g.margin.top,
    marginRight: g.margin.right,
    marginBottom: g.margin.bottom,
    marginLeft: g.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: r !== "none" ? uf.placeholder : null
  };
};
function nPt(e) {
  var t = ot(null), i = Ii(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), n = e.animate, r = e.onTransitionEnd, g = e.onClose, o = e.contextId, l = wt(e.animate === "open"), a = l[0], I = l[1];
  lt(function() {
    return a ? n !== "open" ? (i(), I(!1), OF) : t.current ? OF : (t.current = setTimeout(function() {
      t.current = null, I(!1);
    }), i) : OF;
  }, [n, a, i]);
  var c = Ii(function(C) {
    C.propertyName === "height" && (r(), n === "close" && g());
  }, [n, g, r]), d = iPt({
    isAnimatingOpenOnMount: a,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return De.createElement(e.placeholder.tagName, {
    style: d,
    "data-rbd-placeholder-context-id": o,
    onTransitionEnd: c,
    ref: e.innerRef
  });
}
var rPt = De.memo(nPt), VN = De.createContext(null), gPt = function(e) {
  $ie(t, e);
  function t() {
    for (var n, r = arguments.length, g = new Array(r), o = 0; o < r; o++)
      g[o] = arguments[o];
    return n = e.call.apply(e, [this].concat(g)) || this, n.state = {
      isVisible: !!n.props.on,
      data: n.props.on,
      animate: n.props.shouldAnimate && n.props.on ? "open" : "none"
    }, n.onClose = function() {
      n.state.animate === "close" && n.setState({
        isVisible: !1
      });
    }, n;
  }
  t.getDerivedStateFromProps = function(r, g) {
    return r.shouldAnimate ? r.on ? {
      isVisible: !0,
      data: r.on,
      animate: "open"
    } : g.isVisible ? {
      isVisible: !0,
      data: g.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!r.on,
      data: r.on,
      animate: "none"
    };
  };
  var i = t.prototype;
  return i.render = function() {
    if (!this.state.isVisible)
      return null;
    var r = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(r);
  }, t;
}(De.PureComponent), gO = {
  dragging: 5e3,
  dropAnimating: 4500
}, oPt = function(t, i) {
  return i ? uf.drop(i.duration) : t ? uf.snap : uf.fluid;
}, lPt = function(t, i) {
  return t ? i ? iZ.opacity.drop : iZ.opacity.combining : null;
}, aPt = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function sPt(e) {
  var t = e.dimension, i = t.client, n = e.offset, r = e.combineWith, g = e.dropping, o = !!r, l = aPt(e), a = !!g, I = a ? dD.drop(n, o) : dD.moveTo(n), c = {
    position: "fixed",
    top: i.marginBox.top,
    left: i.marginBox.left,
    boxSizing: "border-box",
    width: i.borderBox.width,
    height: i.borderBox.height,
    transition: oPt(l, g),
    transform: I,
    opacity: lPt(o, a),
    zIndex: a ? gO.dropAnimating : gO.dragging,
    pointerEvents: "none"
  };
  return c;
}
function IPt(e) {
  return {
    transform: dD.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function cPt(e) {
  return e.type === "DRAGGING" ? sPt(e) : IPt(e);
}
function dPt(e, t, i) {
  i === void 0 && (i = Zg);
  var n = window.getComputedStyle(t), r = t.getBoundingClientRect(), g = Ane(r, n), o = Tw(g, i), l = {
    client: g,
    tagName: t.tagName.toLowerCase(),
    display: n.display
  }, a = {
    x: g.marginBox.width,
    y: g.marginBox.height
  }, I = {
    descriptor: e,
    placeholder: l,
    displaceBy: a,
    client: g,
    page: o
  };
  return I;
}
function uPt(e) {
  var t = yN("draggable"), i = e.descriptor, n = e.registry, r = e.getDraggableRef, g = e.canDragInteractiveElements, o = e.shouldRespectForcePress, l = e.isEnabled, a = en(function() {
    return {
      canDragInteractiveElements: g,
      shouldRespectForcePress: o,
      isEnabled: l
    };
  }, [g, l, o]), I = Ii(function(A) {
    var b = r();
    return b || St(), dPt(i, b, A);
  }, [i, r]), c = en(function() {
    return {
      uniqueId: t,
      descriptor: i,
      options: a,
      getDimension: I
    };
  }, [i, I, a, t]), d = ot(c), C = ot(!0);
  Pl(function() {
    return n.draggable.register(d.current), function() {
      return n.draggable.unregister(d.current);
    };
  }, [n.draggable]), Pl(function() {
    if (C.current) {
      C.current = !1;
      return;
    }
    var A = d.current;
    d.current = c, n.draggable.update(c, A);
  }, [c, n.draggable]);
}
function CPt(e) {
  e.preventDefault();
}
function APt(e) {
  var t = ot(null), i = Ii(function(H) {
    t.current = H;
  }, []), n = Ii(function() {
    return t.current;
  }, []), r = Qw(K1), g = r.contextId, o = r.dragHandleUsageInstructionsId, l = r.registry, a = Qw(VN), I = a.type, c = a.droppableId, d = en(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: I,
      droppableId: c
    };
  }, [e.draggableId, e.index, I, c]), C = e.children, A = e.draggableId, b = e.isEnabled, m = e.shouldRespectForcePress, p = e.canDragInteractiveElements, B = e.isClone, f = e.mapped, Z = e.dropAnimationFinished;
  if (!B) {
    var y = en(function() {
      return {
        descriptor: d,
        registry: l,
        getDraggableRef: n,
        canDragInteractiveElements: p,
        shouldRespectForcePress: m,
        isEnabled: b
      };
    }, [d, l, n, p, m, b]);
    uPt(y);
  }
  var W = en(function() {
    return b ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": o,
      "data-rbd-drag-handle-draggable-id": A,
      "data-rbd-drag-handle-context-id": g,
      draggable: !1,
      onDragStart: CPt
    } : null;
  }, [g, o, A, b]), V = Ii(function(H) {
    f.type === "DRAGGING" && f.dropping && H.propertyName === "transform" && Z();
  }, [Z, f]), w = en(function() {
    var H = cPt(f), x = f.type === "DRAGGING" && f.dropping ? V : null, J = {
      innerRef: i,
      draggableProps: {
        "data-rbd-draggable-context-id": g,
        "data-rbd-draggable-id": A,
        style: H,
        onTransitionEnd: x
      },
      dragHandleProps: W
    };
    return J;
  }, [g, W, A, f, V, i]), v = en(function() {
    return {
      draggableId: d.id,
      type: d.type,
      source: {
        index: d.index,
        droppableId: d.droppableId
      }
    };
  }, [d.droppableId, d.id, d.index, d.type]);
  return C(w, f.snapshot, v);
}
var are = function(e, t) {
  return e === t;
}, sre = function(e) {
  var t = e.combine, i = e.destination;
  return i ? i.droppableId : t ? t.droppableId : null;
}, bPt = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, hPt = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function mPt() {
  var e = Bg(function(r, g) {
    return {
      x: r,
      y: g
    };
  }), t = Bg(function(r, g, o, l, a) {
    return {
      isDragging: !0,
      isClone: g,
      isDropAnimating: !!a,
      dropAnimation: a,
      mode: r,
      draggingOver: o,
      combineWith: l,
      combineTargetFor: null
    };
  }), i = Bg(function(r, g, o, l, a, I, c) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: a,
        combineWith: I,
        mode: g,
        offset: r,
        dimension: o,
        forceShouldAnimate: c,
        snapshot: t(g, l, a, I, null)
      }
    };
  }), n = function(g, o) {
    if (g.isDragging) {
      if (g.critical.draggable.id !== o.draggableId)
        return null;
      var l = g.current.client.offset, a = g.dimensions.draggables[o.draggableId], I = Ml(g.impact), c = hPt(g.impact), d = g.forceShouldAnimate;
      return i(e(l.x, l.y), g.movementMode, a, o.isClone, I, c, d);
    }
    if (g.phase === "DROP_ANIMATING") {
      var C = g.completed;
      if (C.result.draggableId !== o.draggableId)
        return null;
      var A = o.isClone, b = g.dimensions.draggables[o.draggableId], m = C.result, p = m.mode, B = sre(m), f = bPt(m), Z = g.dropDuration, y = {
        duration: Z,
        curve: hN.drop,
        moveTo: g.newHomeClientOffset,
        opacity: f ? iZ.opacity.drop : null,
        scale: f ? iZ.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: g.newHomeClientOffset,
          dimension: b,
          dropping: y,
          draggingOver: B,
          combineWith: f,
          mode: p,
          forceShouldAnimate: null,
          snapshot: t(p, A, B, f, y)
        }
      };
    }
    return null;
  };
  return n;
}
function Ire(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var pPt = {
  mapped: {
    type: "SECONDARY",
    offset: Zg,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: Ire(null)
  }
};
function BPt() {
  var e = Bg(function(o, l) {
    return {
      x: o,
      y: l
    };
  }), t = Bg(Ire), i = Bg(function(o, l, a) {
    return l === void 0 && (l = null), {
      mapped: {
        type: "SECONDARY",
        offset: o,
        combineTargetFor: l,
        shouldAnimateDisplacement: a,
        snapshot: t(l)
      }
    };
  }), n = function(l) {
    return l ? i(Zg, l, !0) : null;
  }, r = function(l, a, I, c) {
    var d = I.displaced.visible[l], C = !!(c.inVirtualList && c.effected[l]), A = J1(I), b = A && A.draggableId === l ? a : null;
    if (!d) {
      if (!C)
        return n(b);
      if (I.displaced.invisible[l])
        return null;
      var m = qm(c.displacedBy.point), p = e(m.x, m.y);
      return i(p, b, !0);
    }
    if (C)
      return n(b);
    var B = I.displacedBy.point, f = e(B.x, B.y);
    return i(f, b, d.shouldAnimate);
  }, g = function(l, a) {
    if (l.isDragging)
      return l.critical.draggable.id === a.draggableId ? null : r(a.draggableId, l.critical.draggable.id, l.impact, l.afterCritical);
    if (l.phase === "DROP_ANIMATING") {
      var I = l.completed;
      return I.result.draggableId === a.draggableId ? null : r(a.draggableId, I.result.draggableId, I.impact, I.afterCritical);
    }
    return null;
  };
  return g;
}
var fPt = function() {
  var t = mPt(), i = BPt(), n = function(g, o) {
    return t(g, o) || i(g, o) || pPt;
  };
  return n;
}, ZPt = {
  dropAnimationFinished: Tne
}, GPt = une(fPt, ZPt, null, {
  context: GN,
  pure: !0,
  areStatePropsEqual: are
})(APt);
function cre(e) {
  var t = Qw(VN), i = t.isUsingCloneFor;
  return i === e.draggableId && !e.isClone ? null : De.createElement(GPt, e);
}
function wN(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, i = !!e.disableInteractiveElementBlocking, n = !!e.shouldRespectForcePress;
  return De.createElement(cre, F({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: i,
    shouldRespectForcePress: n
  }));
}
function yPt(e) {
  var t = Vn(K1);
  t || St();
  var i = t.contextId, n = t.isMovementAllowed, r = ot(null), g = ot(null), o = e.children, l = e.droppableId, a = e.type, I = e.mode, c = e.direction, d = e.ignoreContainerClipping, C = e.isDropDisabled, A = e.isCombineEnabled, b = e.snapshot, m = e.useClone, p = e.updateViewportMaxScroll, B = e.getContainerForClone, f = Ii(function() {
    return r.current;
  }, []), Z = Ii(function(J) {
    r.current = J;
  }, []);
  Ii(function() {
    return g.current;
  }, []);
  var y = Ii(function(J) {
    g.current = J;
  }, []), W = Ii(function() {
    n() && p({
      maxScroll: One()
    });
  }, [n, p]);
  ePt({
    droppableId: l,
    type: a,
    mode: I,
    direction: c,
    isDropDisabled: C,
    isCombineEnabled: A,
    ignoreContainerClipping: d,
    getDroppableRef: f
  });
  var V = De.createElement(gPt, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(J) {
    var K = J.onClose, M = J.data, L = J.animate;
    return De.createElement(rPt, {
      placeholder: M,
      onClose: K,
      innerRef: y,
      animate: L,
      contextId: i,
      onTransitionEnd: W
    });
  }), w = en(function() {
    return {
      innerRef: Z,
      placeholder: V,
      droppableProps: {
        "data-rbd-droppable-id": l,
        "data-rbd-droppable-context-id": i
      }
    };
  }, [i, l, V, Z]), v = m ? m.dragging.draggableId : null, H = en(function() {
    return {
      droppableId: l,
      type: a,
      isUsingCloneFor: v
    };
  }, [l, v, a]);
  function x() {
    if (!m)
      return null;
    var J = m.dragging, K = m.render, M = De.createElement(cre, {
      draggableId: J.draggableId,
      index: J.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(L, N) {
      return K(L, N, J);
    });
    return ZB.createPortal(M, B());
  }
  return De.createElement(VN.Provider, {
    value: H
  }, o(w, b), x());
}
var QF = function(t, i) {
  return t === i.droppable.type;
}, oO = function(t, i) {
  return i.draggables[t.draggable.id];
}, WPt = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, i = F({}, t, {
    shouldAnimatePlaceholder: !1
  }), n = Bg(function(o) {
    return {
      draggableId: o.id,
      type: o.type,
      source: {
        index: o.index,
        droppableId: o.droppableId
      }
    };
  }), r = Bg(function(o, l, a, I, c, d) {
    var C = c.descriptor.id, A = c.descriptor.droppableId === o;
    if (A) {
      var b = d ? {
        render: d,
        dragging: n(c.descriptor)
      } : null, m = {
        isDraggingOver: a,
        draggingOverWith: a ? C : null,
        draggingFromThisWith: C,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: c.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: m,
        useClone: b
      };
    }
    if (!l)
      return i;
    if (!I)
      return t;
    var p = {
      isDraggingOver: a,
      draggingOverWith: C,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: c.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: p,
      useClone: null
    };
  }), g = function(l, a) {
    var I = a.droppableId, c = a.type, d = !a.isDropDisabled, C = a.renderClone;
    if (l.isDragging) {
      var A = l.critical;
      if (!QF(c, A))
        return i;
      var b = oO(A, l.dimensions), m = Ml(l.impact) === I;
      return r(I, d, m, m, b, C);
    }
    if (l.phase === "DROP_ANIMATING") {
      var p = l.completed;
      if (!QF(c, p.critical))
        return i;
      var B = oO(p.critical, l.dimensions);
      return r(I, d, sre(p.result) === I, Ml(p.impact) === I, B, C);
    }
    if (l.phase === "IDLE" && l.completed && !l.shouldFlush) {
      var f = l.completed;
      if (!QF(c, f.critical))
        return i;
      var Z = Ml(f.impact) === I, y = !!(f.impact.at && f.impact.at.type === "COMBINE"), W = f.critical.droppable.id === I;
      return Z ? y ? t : i : W ? t : i;
    }
    return i;
  };
  return g;
}, SPt = {
  updateViewportMaxScroll: x3t
};
function VPt() {
  return document.body || St(), document.body;
}
var wPt = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: VPt
}, M1 = une(WPt, SPt, null, {
  context: GN,
  pure: !0,
  areStatePropsEqual: are
})(yPt);
M1.defaultProps = wPt;
const lO = {
  list: {
    overflowY: "auto",
    "& > *:not(:last-child)": {
      marginBottom: 1
    }
  }
};
function vPt(e) {
  return /* @__PURE__ */ Ie(ja, { fullWidth: !0, variant: "outlined", className: "k3-select-list", children: [
    !!e.label && /* @__PURE__ */ S(Ct, { color: "textSecondary", children: e.label }),
    e.canDrag && e.onDragEnd && /* @__PURE__ */ S(SN, { onDragEnd: e.onDragEnd, children: /* @__PURE__ */ S(M1, { droppableId: "droppable", children: (t, i) => /* @__PURE__ */ S("div", { ref: t.innerRef, ...t.droppableProps, children: /* @__PURE__ */ Ie(jV, { component: "nav", style: e.style, sx: e.listStyles || lO.list, "data-cy": e["data-cy"], children: [
      !!e.headerContent && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
        //sticky header
        position: "sticky",
        width: "100%",
        top: 0,
        background: "white"
      }, children: [
        e.headerContent,
        /* @__PURE__ */ S(SI, { "data-cy": "footerDivider" })
      ] }),
      De.Children.map(e.children || null, (n, r) => !!n && /* @__PURE__ */ S(li, { children: /* @__PURE__ */ S(wN, { draggableId: n.key, index: r, children: (g) => {
        const o = /* @__PURE__ */ S(_ie, { provided: g, disabled: !1, sx: {
          marginRight: "-12px"
        } }), l = De.cloneElement(n, {
          dragHandle: o
        });
        return /* @__PURE__ */ S(li, { children: /* @__PURE__ */ S(ht, { component: "div", className: "k3-select-list-item-container", ref: g.innerRef, sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          ...g.draggableProps.style || {
            cursor: "grab"
          },
          // ToDo fix, bc component edit buttons can have different widths
          width: "100%"
        }, ...g.draggableProps, ...g.dragHandleProps, children: l }) });
      } }, n.key) })),
      t.placeholder,
      !!e.footerContent && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
        //sticky footer
        position: "sticky",
        width: "100%",
        bottom: "-8px",
        background: "white"
      }, children: [
        /* @__PURE__ */ S(SI, { "data-cy": "footerDivider" }),
        e.footerContent
      ] })
    ] }) }) }) }),
    !e.canDrag && /* @__PURE__ */ Ie(jV, { component: "nav", style: e.style, sx: e.listStyles || lO.list, "data-cy": e["data-cy"], children: [
      !!e.headerContent && /* @__PURE__ */ S(ht, { component: "div", sx: {
        //sticky header
        position: "sticky",
        width: "100%",
        top: 0,
        background: "white"
      }, children: e.headerContent }),
      De.Children.map(e.children || null, (t, i) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        /* @__PURE__ */ S(ht, { component: "div", className: "k3-select-list-item-container", sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
          // ToDo fix, bc component edit buttons can have different widths
          width: "100%"
        }, children: t })
      )),
      !!e.footerContent && /* @__PURE__ */ S(ht, { component: "div", sx: {
        //sticky footer
        position: "sticky",
        width: "100%",
        bottom: "-8px",
        background: "white"
      }, children: e.footerContent })
    ] })
  ] });
}
var vN = {}, RPt = yg;
Object.defineProperty(vN, "__esModule", {
  value: !0
});
var dre = vN.default = void 0, XPt = RPt(oo()), HPt = ro;
dre = vN.default = (0, XPt.default)(/* @__PURE__ */ (0, HPt.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");
const ure = g9({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column"
  },
  select: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row"
  }
}), Cre = ({
  variable: e,
  values: t,
  addItemType: i,
  contextInstance: n,
  ...r
}) => {
  var p;
  const g = Ei(), o = Vi(e), l = i ?? (((p = e == null ? void 0 : e.settings) == null ? void 0 : p.template) == "componentListPopup" ? "popup" : "dropdown"), a = rr(), I = n || a, c = rp(I, e, !1), d = r.mockSelections || c, C = ie((B) => v6(B, I)), A = ie(PWe), b = (B) => {
    g(wr(B.id)), (A == null ? void 0 : A.type) == "group" && g(aA(null));
  }, m = (B) => {
    B.destination && g(jie(B.source.index, B.destination.index, I, e));
  };
  return /* @__PURE__ */ Ie(ht, { component: "div", sx: ure.wrapper, className: "k3-component-list-wrapper", children: [
    o.reverseSorting && /* @__PURE__ */ S(aO, { contextInstance: n, values: t, variable: e, addItemType: l, ...r }),
    /* @__PURE__ */ Ie(vPt, { "data-cy": "ocSelectList", defaultValue: -1, canDrag: o.enableDragAndDrop, onDragEnd: m, children: [
      ...d == null ? void 0 : d.map((B, f) => /* @__PURE__ */ S(cLt, { index: f, onEdit: b, contextInstance: I, selection: B.selection, value: B.value, variable: e }, B.selection.id))
    ] }),
    !o.reverseSorting && /* @__PURE__ */ S(aO, { contextInstance: n, values: t, variable: e, addItemType: l, ...r }),
    o.showComponentEditorsInline && C && /* @__PURE__ */ S(ht, { component: "div", sx: {
      pt: 1
    }, children: /* @__PURE__ */ S(Nge, { contextInstance: C }) })
  ] }, `${I.id}_${e.id}`);
}, aO = ({
  addItemType: e,
  variable: t,
  values: i,
  contextInstance: n,
  ...r
}) => {
  const g = Ei(), o = rr(), l = n || o, a = (I) => {
    const c = i.find((d) => d.id == I);
    c && g(jZ(c, l));
  };
  return e !== "dropdown" ? /* @__PURE__ */ S(YPt, { onClick: () => {
    var I;
    return (I = r.onAddItemClicked) == null ? void 0 : I.call(r);
  }, disabled: i.length == 0 }, "add_component") : /* @__PURE__ */ S(ht, { component: "div", sx: ure.select, children: /* @__PURE__ */ S(tLt, { onSelected: (I) => a(I.id), variable: t, addItemLabel: r.addItemLabel, values: i, touchedInvalidOptionsIds: r.touchedInvalidValueIds }) });
}, kPt = ({
  onClick: e,
  disabled: t
}) => {
  const {
    palette: i
  } = ql(), n = Oe(() => eN(i), [i]), g = Vg()("translation_mp_popup_add");
  return /* @__PURE__ */ Ie(fn, { "data-cy": "addComponentButton", variant: "text", color: "inherit", onClick: e, disabled: t, sx: n, "aria-label": g, children: [
    /* @__PURE__ */ S(Ct, { variant: "body1", "data-cy": "addComponentButtonText", style: t ? {
      color: i.text.disabled
    } : void 0, children: g }),
    /* @__PURE__ */ S("div", { style: {
      flexGrow: 1
    } }),
    /* @__PURE__ */ S(Ni, { "data-cy": "addIcon", "aria-label": g, children: /* @__PURE__ */ S(dre, { fontSize: "small" }) })
  ] });
}, YPt = gr({
  app: {
    sidebar: {
      componentListPopup: {
        addComponentButton: {
          root: !0
        }
      }
    }
  }
})(kPt), FPt = ({
  variable: e,
  values: t,
  ...i
}) => ie((r) => n9(r, e.id)) ? /* @__PURE__ */ S(Lge, { ...i, variable: e, values: t }) : /* @__PURE__ */ S(wg, { variable: e, className: "k3-component-list-variable k3-component-list-dropdown", view: /* @__PURE__ */ S(Cre, { variable: e, values: t, ...i }) }), xPt = Le.flow(ta, Fo("componentList"))(FPt);
function DPt({
  justifySelf: e,
  currentValue: t,
  onChange: i,
  placeholder: n,
  collapseable: r,
  collapsed: g,
  onCollapse: o
}) {
  const {
    t: l
  } = Gi(), a = U9();
  return g ? /* @__PURE__ */ S(Ni, { type: "button", "aria-label": "Search", disabled: !r, "data-cy": "search", onClick: o, children: /* @__PURE__ */ S(e5, {}) }) : /* @__PURE__ */ Ie(ul, { sx: {
    display: "flex",
    width: 300,
    justifySelf: e ?? "unset",
    justifyContent: "space-between",
    alignItems: "center"
  }, "data-cy": "searchField", children: [
    /* @__PURE__ */ S(Ni, { type: "button", "aria-label": "Search", disabled: !r, "data-cy": "search", onClick: o, children: /* @__PURE__ */ S(e5, {}) }),
    /* @__PURE__ */ S(ev, { value: t, id: "search-field", autoFocus: r, sx: {
      width: 170
    }, onChange: (I) => i(I.target.value), onKeyDown: (I) => {
      I.key === "Escape" && (i(""), I.currentTarget.blur());
    }, placeholder: n || l("Suchen") }),
    t ? /* @__PURE__ */ S(Ni, { "data-cy": "clear", type: "button", "aria-label": "Search", onClick: () => i(""), sx: {
      ml: "auto"
    }, children: /* @__PURE__ */ S(Ev, {}) }) : /* @__PURE__ */ S(pi, { pr: 2, sx: {
      color: "action.active"
    }, children: /* @__PURE__ */ Ie("kbd", { children: [
      a("Ctrl"),
      " + K"
    ] }) })
  ] });
}
const JPt = ({
  variable: e,
  values: t,
  touchedInvalidValueIds: i,
  ...n
}) => {
  const r = Vg(), g = Ei(), o = f0t(), l = Vi(e), a = ie((H) => n9(H, e.id)), [I, c] = wt(!1), [d, C] = wt(""), A = g1();
  if (a)
    return /* @__PURE__ */ S(Lge, { ...n, variable: e, values: t });
  const b = (H) => {
    H && n.contextInstance && (g(jZ(H, n.contextInstance)), c(!1), C(""));
  }, m = o("toggle_mp_dialog_hide_searchbar"), p = A ? "xl" : o("string_mp_dialog_size"), B = o("toggle_mp_dialog_component_cols"), f = A ? 1 : B > 0 ? B : 4, Z = o("toggle_mp_dialog_component_display"), y = r("translation_mp_popup_description"), W = d ? t.filter((H) => {
    var x;
    return (x = H.label) == null ? void 0 : x.toLocaleLowerCase().includes(d.toLocaleLowerCase());
  }) : t;
  function V() {
    return /* @__PURE__ */ S(iLt, { variable: e, onSelected: b, fullWidth: !0, value: void 0, colCount: f, verticalValueDisplay: Z, values: W, defaultGroupLabel: r("translation_mp_popup_not_grouped"), touchedInvalidOptionsIds: i });
  }
  function w() {
    return /* @__PURE__ */ S(sD, { variable: e, onSelected: b, fullWidth: !0, value: void 0, colCount: f, verticalValueDisplay: Z, values: W, touchedInvalidOptionsIds: i });
  }
  const v = ["translation_mp_popup_add", "translation_mp_popup_search", "translation_mp_popup_description", "translation_mp_popup_title", "translation_mp_popup_not_grouped", "toggle_mp_dialog_component_cols", "toggle_mp_dialog_hide_searchbar", "string_mp_dialog_size", "toggle_mp_dialog_component_display"];
  return /* @__PURE__ */ S(wg, { variable: e, className: "k3-component-list-variable k3-component-list-popup", view: /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(Cre, { variable: e, values: t, addItemType: "popup", ...n, onAddItemClicked: () => c(!0), touchedInvalidValueIds: i }),
    /* @__PURE__ */ Ie(B_, { show: I, onClose: () => c(!1), dataCy: "componentListPopup", maxWidth: p, title: r("translation_mp_popup_title"), settingKeys: v, className: "k3-add-items-popup", children: [
      /* @__PURE__ */ Ie(ht, { sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "1rem",
        width: "100%",
        marginBottom: m ? "0" : "8px"
      }, component: "div", "data-cy": "header", children: [
        !!y && /* @__PURE__ */ S(Ct, { variant: "subtitle1", children: y }),
        !m && /* @__PURE__ */ S(DPt, { currentValue: d, onChange: (H) => {
          C(H);
        }, placeholder: r("translation_mp_popup_search") })
      ] }),
      l.groupBy ? V() : w()
    ] })
  ] }) });
}, EPt = de.flow(ta, gr({
  app: {
    sidebar: {
      componentListPopup: {
        root: !0
      }
    }
  }
}))(JPt);
function Are({
  onChange: e,
  values: t,
  disabled: i,
  variable: n,
  ExtraContent: r,
  ...g
}) {
  return /* @__PURE__ */ S(ja, { sx: {
    width: 1
  }, className: "k3-radio-cards-wrapper", children: /* @__PURE__ */ S(BJ, { value: g.currentValueId, exclusive: !0, sx: {
    gap: 1
  }, orientation: "vertical", onChange: (o, l) => e == null ? void 0 : e(l || 0), "aria-label": "Text alignment", className: "k3-radio-cards", children: t.map((o) => {
    var l;
    return /* @__PURE__ */ S(bre, { value: o, disabled: i, variable: n, invalidItem: ((l = g.invalidIds) == null ? void 0 : l.includes(o == null ? void 0 : o.id)) || !1, isActive: g.currentValueId == o.id, children: r && /* @__PURE__ */ S(r, { value: o, variable: n }) }, o.id);
  }) }) });
}
function bre({
  value: e,
  variable: t,
  children: i,
  ...n
}) {
  const {
    palette: r
  } = ql(), g = Oe(() => eN(r), [r]), o = n.invalidItem;
  return /* @__PURE__ */ S(lv, { "data-cy": `card-${e.label}`, fullWidth: !0, value: e == null ? void 0 : e.id, disabled: n.disabled, sx: g, className: Re("k3-radio-card", o && "invalid-option", n.isActive && "active selected"), children: /* @__PURE__ */ S(FA, { invalid: o, children: /* @__PURE__ */ S(vI, { value: e.id, variable: t, variableValue: e, templateOptions: t == null ? void 0 : t.settings.templateOptions, children: i }) }) });
}
function NPt() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return Oe(
    () => (n) => {
      t.forEach((r) => r(n));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const P1 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function ep(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function RN(e) {
  return "nodeType" in e;
}
function Do(e) {
  var t, i;
  return e ? ep(e) ? e : RN(e) && (t = (i = e.ownerDocument) == null ? void 0 : i.defaultView) != null ? t : window : window;
}
function XN(e) {
  const {
    Document: t
  } = Do(e);
  return e instanceof t;
}
function hG(e) {
  return ep(e) ? !1 : e instanceof Do(e).HTMLElement;
}
function hre(e) {
  return e instanceof Do(e).SVGElement;
}
function tp(e) {
  return e ? ep(e) ? e.document : RN(e) ? XN(e) ? e : hG(e) || hre(e) ? e.ownerDocument : document : document : document;
}
const Pa = P1 ? lZ : lt;
function U1(e) {
  const t = ot(e);
  return Pa(() => {
    t.current = e;
  }), Gt(function() {
    for (var i = arguments.length, n = new Array(i), r = 0; r < i; r++)
      n[r] = arguments[r];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
function LPt() {
  const e = ot(null), t = Gt((n, r) => {
    e.current = setInterval(n, r);
  }, []), i = Gt(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, i];
}
function nZ(e, t) {
  t === void 0 && (t = [e]);
  const i = ot(e);
  return Pa(() => {
    i.current !== e && (i.current = e);
  }, t), i;
}
function mG(e, t) {
  const i = ot();
  return Oe(
    () => {
      const n = e(i.current);
      return i.current = n, n;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function jw(e) {
  const t = U1(e), i = ot(null), n = Gt(
    (r) => {
      r !== i.current && (t == null || t(r, i.current)), i.current = r;
    },
    //eslint-disable-next-line
    []
  );
  return [i, n];
}
function qw(e) {
  const t = ot();
  return lt(() => {
    t.current = e;
  }, [e]), t.current;
}
let jF = {};
function pG(e, t) {
  return Oe(() => {
    if (t)
      return t;
    const i = jF[e] == null ? 0 : jF[e] + 1;
    return jF[e] = i, e + "-" + i;
  }, [e, t]);
}
function mre(e) {
  return function(t) {
    for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)
      n[r - 1] = arguments[r];
    return n.reduce((g, o) => {
      const l = Object.entries(o);
      for (const [a, I] of l) {
        const c = g[a];
        c != null && (g[a] = c + e * I);
      }
      return g;
    }, {
      ...t
    });
  };
}
const _h = /* @__PURE__ */ mre(1), _w = /* @__PURE__ */ mre(-1);
function KPt(e) {
  return "clientX" in e && "clientY" in e;
}
function z1(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Do(e.target);
  return t && e instanceof t;
}
function TPt(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Do(e.target);
  return t && e instanceof t;
}
function $w(e) {
  if (TPt(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: i
      } = e.touches[0];
      return {
        x: t,
        y: i
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: i
      } = e.changedTouches[0];
      return {
        x: t,
        y: i
      };
    }
  }
  return KPt(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const IA = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: i
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (i ? Math.round(i) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: i
      } = e;
      return "scaleX(" + t + ") scaleY(" + i + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [IA.Translate.toString(e), IA.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: i,
        easing: n
      } = e;
      return t + " " + i + "ms " + n;
    }
  }
}), sO = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function MPt(e) {
  return e.matches(sO) ? e : e.querySelector(sO);
}
const PPt = {
  display: "none"
};
function UPt(e) {
  let {
    id: t,
    value: i
  } = e;
  return De.createElement("div", {
    id: t,
    style: PPt
  }, i);
}
function zPt(e) {
  let {
    id: t,
    announcement: i,
    ariaLiveType: n = "assertive"
  } = e;
  const r = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return De.createElement("div", {
    id: t,
    style: r,
    role: "status",
    "aria-live": n,
    "aria-atomic": !0
  }, i);
}
function OPt() {
  const [e, t] = wt("");
  return {
    announce: Gt((n) => {
      n != null && t(n);
    }, []),
    announcement: e
  };
}
const pre = /* @__PURE__ */ Ua(null);
function QPt(e) {
  const t = Vn(pre);
  lt(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function jPt() {
  const [e] = wt(() => /* @__PURE__ */ new Set()), t = Gt((n) => (e.add(n), () => e.delete(n)), [e]);
  return [Gt((n) => {
    let {
      type: r,
      event: g
    } = n;
    e.forEach((o) => {
      var l;
      return (l = o[r]) == null ? void 0 : l.call(o, g);
    });
  }, [e]), t];
}
const qPt = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, _Pt = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: i
    } = e;
    return i ? "Draggable item " + t.id + " was moved over droppable area " + i.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: i
    } = e;
    return i ? "Draggable item " + t.id + " was dropped over droppable area " + i.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function $Pt(e) {
  let {
    announcements: t = _Pt,
    container: i,
    hiddenTextDescribedById: n,
    screenReaderInstructions: r = qPt
  } = e;
  const {
    announce: g,
    announcement: o
  } = OPt(), l = pG("DndLiveRegion"), [a, I] = wt(!1);
  if (lt(() => {
    I(!0);
  }, []), QPt(Oe(() => ({
    onDragStart(d) {
      let {
        active: C
      } = d;
      g(t.onDragStart({
        active: C
      }));
    },
    onDragMove(d) {
      let {
        active: C,
        over: A
      } = d;
      t.onDragMove && g(t.onDragMove({
        active: C,
        over: A
      }));
    },
    onDragOver(d) {
      let {
        active: C,
        over: A
      } = d;
      g(t.onDragOver({
        active: C,
        over: A
      }));
    },
    onDragEnd(d) {
      let {
        active: C,
        over: A
      } = d;
      g(t.onDragEnd({
        active: C,
        over: A
      }));
    },
    onDragCancel(d) {
      let {
        active: C,
        over: A
      } = d;
      g(t.onDragCancel({
        active: C,
        over: A
      }));
    }
  }), [g, t])), !a)
    return null;
  const c = De.createElement(De.Fragment, null, De.createElement(UPt, {
    id: n,
    value: r.draggable
  }), De.createElement(zPt, {
    id: l,
    announcement: o
  }));
  return i ? Z4(c, i) : c;
}
var zr;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(zr || (zr = {}));
function e2() {
}
function IO(e, t) {
  return Oe(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function eUt() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return Oe(
    () => [...t].filter((n) => n != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const xs = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function tUt(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function iUt(e, t) {
  const i = $w(e);
  if (!i)
    return "0 0";
  const n = {
    x: (i.x - t.left) / t.width * 100,
    y: (i.y - t.top) / t.height * 100
  };
  return n.x + "% " + n.y + "%";
}
function nUt(e, t) {
  let {
    data: {
      value: i
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return i - n;
}
function rUt(e, t) {
  let {
    data: {
      value: i
    }
  } = e, {
    data: {
      value: n
    }
  } = t;
  return n - i;
}
function gUt(e, t) {
  if (!e || e.length === 0)
    return null;
  const [i] = e;
  return i[t];
}
function cO(e, t, i) {
  return t === void 0 && (t = e.left), i === void 0 && (i = e.top), {
    x: t + e.width * 0.5,
    y: i + e.height * 0.5
  };
}
const oUt = (e) => {
  let {
    collisionRect: t,
    droppableRects: i,
    droppableContainers: n
  } = e;
  const r = cO(t, t.left, t.top), g = [];
  for (const o of n) {
    const {
      id: l
    } = o, a = i.get(l);
    if (a) {
      const I = tUt(cO(a), r);
      g.push({
        id: l,
        data: {
          droppableContainer: o,
          value: I
        }
      });
    }
  }
  return g.sort(nUt);
};
function lUt(e, t) {
  const i = Math.max(t.top, e.top), n = Math.max(t.left, e.left), r = Math.min(t.left + t.width, e.left + e.width), g = Math.min(t.top + t.height, e.top + e.height), o = r - n, l = g - i;
  if (n < r && i < g) {
    const a = t.width * t.height, I = e.width * e.height, c = o * l, d = c / (a + I - c);
    return Number(d.toFixed(4));
  }
  return 0;
}
const aUt = (e) => {
  let {
    collisionRect: t,
    droppableRects: i,
    droppableContainers: n
  } = e;
  const r = [];
  for (const g of n) {
    const {
      id: o
    } = g, l = i.get(o);
    if (l) {
      const a = lUt(l, t);
      a > 0 && r.push({
        id: o,
        data: {
          droppableContainer: g,
          value: a
        }
      });
    }
  }
  return r.sort(rUt);
};
function sUt(e, t, i) {
  return {
    ...e,
    scaleX: t && i ? t.width / i.width : 1,
    scaleY: t && i ? t.height / i.height : 1
  };
}
function Bre(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : xs;
}
function IUt(e) {
  return function(i) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), g = 1; g < n; g++)
      r[g - 1] = arguments[g];
    return r.reduce((o, l) => ({
      ...o,
      top: o.top + e * l.y,
      bottom: o.bottom + e * l.y,
      left: o.left + e * l.x,
      right: o.right + e * l.x
    }), {
      ...i
    });
  };
}
const cUt = /* @__PURE__ */ IUt(1);
function fre(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function dUt(e, t, i) {
  const n = fre(t);
  if (!n)
    return e;
  const {
    scaleX: r,
    scaleY: g,
    x: o,
    y: l
  } = n, a = e.left - o - (1 - r) * parseFloat(i), I = e.top - l - (1 - g) * parseFloat(i.slice(i.indexOf(" ") + 1)), c = r ? e.width / r : e.width, d = g ? e.height / g : e.height;
  return {
    width: c,
    height: d,
    top: I,
    right: a + c,
    bottom: I + d,
    left: a
  };
}
const uUt = {
  ignoreTransform: !1
};
function ip(e, t) {
  t === void 0 && (t = uUt);
  let i = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: I,
      transformOrigin: c
    } = Do(e).getComputedStyle(e);
    I && (i = dUt(i, I, c));
  }
  const {
    top: n,
    left: r,
    width: g,
    height: o,
    bottom: l,
    right: a
  } = i;
  return {
    top: n,
    left: r,
    width: g,
    height: o,
    bottom: l,
    right: a
  };
}
function dO(e) {
  return ip(e, {
    ignoreTransform: !0
  });
}
function CUt(e) {
  const t = e.innerWidth, i = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: i,
    width: t,
    height: i
  };
}
function AUt(e, t) {
  return t === void 0 && (t = Do(e).getComputedStyle(e)), t.position === "fixed";
}
function bUt(e, t) {
  t === void 0 && (t = Do(e).getComputedStyle(e));
  const i = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((r) => {
    const g = t[r];
    return typeof g == "string" ? i.test(g) : !1;
  });
}
function HN(e, t) {
  const i = [];
  function n(r) {
    if (t != null && i.length >= t || !r)
      return i;
    if (XN(r) && r.scrollingElement != null && !i.includes(r.scrollingElement))
      return i.push(r.scrollingElement), i;
    if (!hG(r) || hre(r) || i.includes(r))
      return i;
    const g = Do(e).getComputedStyle(r);
    return r !== e && bUt(r, g) && i.push(r), AUt(r, g) ? i : n(r.parentNode);
  }
  return e ? n(e) : i;
}
function Zre(e) {
  const [t] = HN(e, 1);
  return t ?? null;
}
function qF(e) {
  return !P1 || !e ? null : ep(e) ? e : RN(e) ? XN(e) || e === tp(e).scrollingElement ? window : hG(e) ? e : null : null;
}
function Gre(e) {
  return ep(e) ? e.scrollX : e.scrollLeft;
}
function yre(e) {
  return ep(e) ? e.scrollY : e.scrollTop;
}
function bD(e) {
  return {
    x: Gre(e),
    y: yre(e)
  };
}
var Cg;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Cg || (Cg = {}));
function Wre(e) {
  return !P1 || !e ? !1 : e === document.scrollingElement;
}
function Sre(e) {
  const t = {
    x: 0,
    y: 0
  }, i = Wre(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, n = {
    x: e.scrollWidth - i.width,
    y: e.scrollHeight - i.height
  }, r = e.scrollTop <= t.y, g = e.scrollLeft <= t.x, o = e.scrollTop >= n.y, l = e.scrollLeft >= n.x;
  return {
    isTop: r,
    isLeft: g,
    isBottom: o,
    isRight: l,
    maxScroll: n,
    minScroll: t
  };
}
const hUt = {
  x: 0.2,
  y: 0.2
};
function mUt(e, t, i, n, r) {
  let {
    top: g,
    left: o,
    right: l,
    bottom: a
  } = i;
  n === void 0 && (n = 10), r === void 0 && (r = hUt);
  const {
    isTop: I,
    isBottom: c,
    isLeft: d,
    isRight: C
  } = Sre(e), A = {
    x: 0,
    y: 0
  }, b = {
    x: 0,
    y: 0
  }, m = {
    height: t.height * r.y,
    width: t.width * r.x
  };
  return !I && g <= t.top + m.height ? (A.y = Cg.Backward, b.y = n * Math.abs((t.top + m.height - g) / m.height)) : !c && a >= t.bottom - m.height && (A.y = Cg.Forward, b.y = n * Math.abs((t.bottom - m.height - a) / m.height)), !C && l >= t.right - m.width ? (A.x = Cg.Forward, b.x = n * Math.abs((t.right - m.width - l) / m.width)) : !d && o <= t.left + m.width && (A.x = Cg.Backward, b.x = n * Math.abs((t.left + m.width - o) / m.width)), {
    direction: A,
    speed: b
  };
}
function pUt(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: g,
      innerHeight: o
    } = window;
    return {
      top: 0,
      left: 0,
      right: g,
      bottom: o,
      width: g,
      height: o
    };
  }
  const {
    top: t,
    left: i,
    right: n,
    bottom: r
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: i,
    right: n,
    bottom: r,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function Vre(e) {
  return e.reduce((t, i) => _h(t, bD(i)), xs);
}
function BUt(e) {
  return e.reduce((t, i) => t + Gre(i), 0);
}
function fUt(e) {
  return e.reduce((t, i) => t + yre(i), 0);
}
function wre(e, t) {
  if (t === void 0 && (t = ip), !e)
    return;
  const {
    top: i,
    left: n,
    bottom: r,
    right: g
  } = t(e);
  Zre(e) && (r <= 0 || g <= 0 || i >= window.innerHeight || n >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const ZUt = [["x", ["left", "right"], BUt], ["y", ["top", "bottom"], fUt]];
class kN {
  constructor(t, i) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const n = HN(i), r = Vre(n);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [g, o, l] of ZUt)
      for (const a of o)
        Object.defineProperty(this, a, {
          get: () => {
            const I = l(n), c = r[g] - I;
            return this.rect[a] + c;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Cf {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((i) => {
        var n;
        return (n = this.target) == null ? void 0 : n.removeEventListener(...i);
      });
    }, this.target = t;
  }
  add(t, i, n) {
    var r;
    (r = this.target) == null || r.addEventListener(t, i, n), this.listeners.push([t, i, n]);
  }
}
function GUt(e) {
  const {
    EventTarget: t
  } = Do(e);
  return e instanceof t ? e : tp(e);
}
function _F(e, t) {
  const i = Math.abs(e.x), n = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(i ** 2 + n ** 2) > t : "x" in t && "y" in t ? i > t.x && n > t.y : "x" in t ? i > t.x : "y" in t ? n > t.y : !1;
}
var Wa;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Wa || (Wa = {}));
function uO(e) {
  e.preventDefault();
}
function yUt(e) {
  e.stopPropagation();
}
var Bn;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter";
})(Bn || (Bn = {}));
const vre = {
  start: [Bn.Space, Bn.Enter],
  cancel: [Bn.Esc],
  end: [Bn.Space, Bn.Enter]
}, WUt = (e, t) => {
  let {
    currentCoordinates: i
  } = t;
  switch (e.code) {
    case Bn.Right:
      return {
        ...i,
        x: i.x + 25
      };
    case Bn.Left:
      return {
        ...i,
        x: i.x - 25
      };
    case Bn.Down:
      return {
        ...i,
        y: i.y + 25
      };
    case Bn.Up:
      return {
        ...i,
        y: i.y - 25
      };
  }
};
class Rre {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: i
      }
    } = t;
    this.props = t, this.listeners = new Cf(tp(i)), this.windowListeners = new Cf(Do(i)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Wa.Resize, this.handleCancel), this.windowListeners.add(Wa.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Wa.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: i
    } = this.props, n = t.node.current;
    n && wre(n), i(xs);
  }
  handleKeyDown(t) {
    if (z1(t)) {
      const {
        active: i,
        context: n,
        options: r
      } = this.props, {
        keyboardCodes: g = vre,
        coordinateGetter: o = WUt,
        scrollBehavior: l = "smooth"
      } = r, {
        code: a
      } = t;
      if (g.end.includes(a)) {
        this.handleEnd(t);
        return;
      }
      if (g.cancel.includes(a)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: I
      } = n.current, c = I ? {
        x: I.left,
        y: I.top
      } : xs;
      this.referenceCoordinates || (this.referenceCoordinates = c);
      const d = o(t, {
        active: i,
        context: n.current,
        currentCoordinates: c
      });
      if (d) {
        const C = _w(d, c), A = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: b
        } = n.current;
        for (const m of b) {
          const p = t.code, {
            isTop: B,
            isRight: f,
            isLeft: Z,
            isBottom: y,
            maxScroll: W,
            minScroll: V
          } = Sre(m), w = pUt(m), v = {
            x: Math.min(p === Bn.Right ? w.right - w.width / 2 : w.right, Math.max(p === Bn.Right ? w.left : w.left + w.width / 2, d.x)),
            y: Math.min(p === Bn.Down ? w.bottom - w.height / 2 : w.bottom, Math.max(p === Bn.Down ? w.top : w.top + w.height / 2, d.y))
          }, H = p === Bn.Right && !f || p === Bn.Left && !Z, x = p === Bn.Down && !y || p === Bn.Up && !B;
          if (H && v.x !== d.x) {
            const J = m.scrollLeft + C.x, K = p === Bn.Right && J <= W.x || p === Bn.Left && J >= V.x;
            if (K && !C.y) {
              m.scrollTo({
                left: J,
                behavior: l
              });
              return;
            }
            K ? A.x = m.scrollLeft - J : A.x = p === Bn.Right ? m.scrollLeft - W.x : m.scrollLeft - V.x, A.x && m.scrollBy({
              left: -A.x,
              behavior: l
            });
            break;
          } else if (x && v.y !== d.y) {
            const J = m.scrollTop + C.y, K = p === Bn.Down && J <= W.y || p === Bn.Up && J >= V.y;
            if (K && !C.x) {
              m.scrollTo({
                top: J,
                behavior: l
              });
              return;
            }
            K ? A.y = m.scrollTop - J : A.y = p === Bn.Down ? m.scrollTop - W.y : m.scrollTop - V.y, A.y && m.scrollBy({
              top: -A.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, _h(_w(d, this.referenceCoordinates), A));
      }
    }
  }
  handleMove(t, i) {
    const {
      onMove: n
    } = this.props;
    t.preventDefault(), n(i);
  }
  handleEnd(t) {
    const {
      onEnd: i
    } = this.props;
    t.preventDefault(), this.detach(), i();
  }
  handleCancel(t) {
    const {
      onCancel: i
    } = this.props;
    t.preventDefault(), this.detach(), i();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
Rre.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, i) => {
    let {
      keyboardCodes: n = vre,
      onActivation: r
    } = t, {
      active: g
    } = i;
    const {
      code: o
    } = e.nativeEvent;
    if (n.start.includes(o)) {
      const l = g.activatorNode.current;
      return l && e.target !== l ? !1 : (e.preventDefault(), r == null || r({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function CO(e) {
  return !!(e && "distance" in e);
}
function AO(e) {
  return !!(e && "delay" in e);
}
class YN {
  constructor(t, i, n) {
    var r;
    n === void 0 && (n = GUt(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = i;
    const {
      event: g
    } = t, {
      target: o
    } = g;
    this.props = t, this.events = i, this.document = tp(o), this.documentListeners = new Cf(this.document), this.listeners = new Cf(n), this.windowListeners = new Cf(Do(o)), this.initialCoordinates = (r = $w(g)) != null ? r : xs, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: i,
          bypassActivationConstraint: n
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), this.windowListeners.add(Wa.Resize, this.handleCancel), this.windowListeners.add(Wa.DragStart, uO), this.windowListeners.add(Wa.VisibilityChange, this.handleCancel), this.windowListeners.add(Wa.ContextMenu, uO), this.documentListeners.add(Wa.Keydown, this.handleKeydown), i) {
      if (n != null && n({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (AO(i)) {
        this.timeoutId = setTimeout(this.handleStart, i.delay);
        return;
      }
      if (CO(i))
        return;
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: i
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(Wa.Click, yUt, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Wa.SelectionChange, this.removeTextSelection), i(t));
  }
  handleMove(t) {
    var i;
    const {
      activated: n,
      initialCoordinates: r,
      props: g
    } = this, {
      onMove: o,
      options: {
        activationConstraint: l
      }
    } = g;
    if (!r)
      return;
    const a = (i = $w(t)) != null ? i : xs, I = _w(r, a);
    if (!n && l) {
      if (CO(l)) {
        if (l.tolerance != null && _F(I, l.tolerance))
          return this.handleCancel();
        if (_F(I, l.distance))
          return this.handleStart();
      }
      return AO(l) && _F(I, l.tolerance) ? this.handleCancel() : void 0;
    }
    t.cancelable && t.preventDefault(), o(a);
  }
  handleEnd() {
    const {
      onEnd: t
    } = this.props;
    this.detach(), t();
  }
  handleCancel() {
    const {
      onCancel: t
    } = this.props;
    this.detach(), t();
  }
  handleKeydown(t) {
    t.code === Bn.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const SUt = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class Xre extends YN {
  constructor(t) {
    const {
      event: i
    } = t, n = tp(i.target);
    super(t, SUt, n);
  }
}
Xre.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    return !i.isPrimary || i.button !== 0 ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
const VUt = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var hD;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(hD || (hD = {}));
class Hre extends YN {
  constructor(t) {
    super(t, VUt, tp(t.event.target));
  }
}
Hre.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    return i.button === hD.RightClick ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
const $F = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class kre extends YN {
  constructor(t) {
    super(t, $F);
  }
  static setup() {
    return window.addEventListener($F.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener($F.move.name, t);
    };
    function t() {
    }
  }
}
kre.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: i
    } = e, {
      onActivation: n
    } = t;
    const {
      touches: r
    } = i;
    return r.length > 1 ? !1 : (n == null || n({
      event: i
    }), !0);
  }
}];
var Af;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Af || (Af = {}));
var t2;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(t2 || (t2 = {}));
function wUt(e) {
  let {
    acceleration: t,
    activator: i = Af.Pointer,
    canScroll: n,
    draggingRect: r,
    enabled: g,
    interval: o = 5,
    order: l = t2.TreeOrder,
    pointerCoordinates: a,
    scrollableAncestors: I,
    scrollableAncestorRects: c,
    delta: d,
    threshold: C
  } = e;
  const A = RUt({
    delta: d,
    disabled: !g
  }), [b, m] = LPt(), p = ot({
    x: 0,
    y: 0
  }), B = ot({
    x: 0,
    y: 0
  }), f = Oe(() => {
    switch (i) {
      case Af.Pointer:
        return a ? {
          top: a.y,
          bottom: a.y,
          left: a.x,
          right: a.x
        } : null;
      case Af.DraggableRect:
        return r;
    }
  }, [i, r, a]), Z = ot(null), y = Gt(() => {
    const V = Z.current;
    if (!V)
      return;
    const w = p.current.x * B.current.x, v = p.current.y * B.current.y;
    V.scrollBy(w, v);
  }, []), W = Oe(() => l === t2.TreeOrder ? [...I].reverse() : I, [l, I]);
  lt(
    () => {
      if (!g || !I.length || !f) {
        m();
        return;
      }
      for (const V of W) {
        if ((n == null ? void 0 : n(V)) === !1)
          continue;
        const w = I.indexOf(V), v = c[w];
        if (!v)
          continue;
        const {
          direction: H,
          speed: x
        } = mUt(V, v, f, t, C);
        for (const J of ["x", "y"])
          A[J][H[J]] || (x[J] = 0, H[J] = 0);
        if (x.x > 0 || x.y > 0) {
          m(), Z.current = V, b(y, o), p.current = x, B.current = H;
          return;
        }
      }
      p.current = {
        x: 0,
        y: 0
      }, B.current = {
        x: 0,
        y: 0
      }, m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      y,
      n,
      m,
      g,
      o,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(f),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(A),
      b,
      I,
      W,
      c,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(C)
    ]
  );
}
const vUt = {
  x: {
    [Cg.Backward]: !1,
    [Cg.Forward]: !1
  },
  y: {
    [Cg.Backward]: !1,
    [Cg.Forward]: !1
  }
};
function RUt(e) {
  let {
    delta: t,
    disabled: i
  } = e;
  const n = qw(t);
  return mG((r) => {
    if (i || !n || !r)
      return vUt;
    const g = {
      x: Math.sign(t.x - n.x),
      y: Math.sign(t.y - n.y)
    };
    return {
      x: {
        [Cg.Backward]: r.x[Cg.Backward] || g.x === -1,
        [Cg.Forward]: r.x[Cg.Forward] || g.x === 1
      },
      y: {
        [Cg.Backward]: r.y[Cg.Backward] || g.y === -1,
        [Cg.Forward]: r.y[Cg.Forward] || g.y === 1
      }
    };
  }, [i, t, n]);
}
function XUt(e, t) {
  const i = t !== null ? e.get(t) : void 0, n = i ? i.node.current : null;
  return mG((r) => {
    var g;
    return t === null ? null : (g = n ?? r) != null ? g : null;
  }, [n, t]);
}
function HUt(e, t) {
  return Oe(() => e.reduce((i, n) => {
    const {
      sensor: r
    } = n, g = r.activators.map((o) => ({
      eventName: o.eventName,
      handler: t(o.handler, n)
    }));
    return [...i, ...g];
  }, []), [e, t]);
}
var rZ;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(rZ || (rZ = {}));
var mD;
(function(e) {
  e.Optimized = "optimized";
})(mD || (mD = {}));
const bO = /* @__PURE__ */ new Map();
function kUt(e, t) {
  let {
    dragging: i,
    dependencies: n,
    config: r
  } = t;
  const [g, o] = wt(null), {
    frequency: l,
    measure: a,
    strategy: I
  } = r, c = ot(e), d = p(), C = nZ(d), A = Gt(function(B) {
    B === void 0 && (B = []), !C.current && o((f) => f === null ? B : f.concat(B.filter((Z) => !f.includes(Z))));
  }, [C]), b = ot(null), m = mG((B) => {
    if (d && !i)
      return bO;
    if (!B || B === bO || c.current !== e || g != null) {
      const f = /* @__PURE__ */ new Map();
      for (let Z of e) {
        if (!Z)
          continue;
        if (g && g.length > 0 && !g.includes(Z.id) && Z.rect.current) {
          f.set(Z.id, Z.rect.current);
          continue;
        }
        const y = Z.node.current, W = y ? new kN(a(y), y) : null;
        Z.rect.current = W, W && f.set(Z.id, W);
      }
      return f;
    }
    return B;
  }, [e, g, i, d, a]);
  return lt(() => {
    c.current = e;
  }, [e]), lt(
    () => {
      d || A();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i, d]
  ), lt(
    () => {
      g && g.length > 0 && o(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(g)]
  ), lt(
    () => {
      d || typeof l != "number" || b.current !== null || (b.current = setTimeout(() => {
        A(), b.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, d, A, ...n]
  ), {
    droppableRects: m,
    measureDroppableContainers: A,
    measuringScheduled: g != null
  };
  function p() {
    switch (I) {
      case rZ.Always:
        return !1;
      case rZ.BeforeDragging:
        return i;
      default:
        return !i;
    }
  }
}
function FN(e, t) {
  return mG((i) => e ? i || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function YUt(e, t) {
  return FN(e, t);
}
function FUt(e) {
  let {
    callback: t,
    disabled: i
  } = e;
  const n = U1(t), r = Oe(() => {
    if (i || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: g
    } = window;
    return new g(n);
  }, [n, i]);
  return lt(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function O1(e) {
  let {
    callback: t,
    disabled: i
  } = e;
  const n = U1(t), r = Oe(
    () => {
      if (i || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: g
      } = window;
      return new g(n);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i]
  );
  return lt(() => () => r == null ? void 0 : r.disconnect(), [r]), r;
}
function xUt(e) {
  return new kN(ip(e), e);
}
function hO(e, t, i) {
  t === void 0 && (t = xUt);
  const [n, r] = aZ(l, null), g = FUt({
    callback(a) {
      if (e)
        for (const I of a) {
          const {
            type: c,
            target: d
          } = I;
          if (c === "childList" && d instanceof HTMLElement && d.contains(e)) {
            r();
            break;
          }
        }
    }
  }), o = O1({
    callback: r
  });
  return Pa(() => {
    r(), e ? (o == null || o.observe(e), g == null || g.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (o == null || o.disconnect(), g == null || g.disconnect());
  }, [e]), n;
  function l(a) {
    if (!e)
      return null;
    if (e.isConnected === !1) {
      var I;
      return (I = a ?? i) != null ? I : null;
    }
    const c = t(e);
    return JSON.stringify(a) === JSON.stringify(c) ? a : c;
  }
}
function DUt(e) {
  const t = FN(e);
  return Bre(e, t);
}
const mO = [];
function JUt(e) {
  const t = ot(e), i = mG((n) => e ? n && n !== mO && e && t.current && e.parentNode === t.current.parentNode ? n : HN(e) : mO, [e]);
  return lt(() => {
    t.current = e;
  }, [e]), i;
}
function EUt(e) {
  const [t, i] = wt(null), n = ot(e), r = Gt((g) => {
    const o = qF(g.target);
    o && i((l) => l ? (l.set(o, bD(o)), new Map(l)) : null);
  }, []);
  return lt(() => {
    const g = n.current;
    if (e !== g) {
      o(g);
      const l = e.map((a) => {
        const I = qF(a);
        return I ? (I.addEventListener("scroll", r, {
          passive: !0
        }), [I, bD(I)]) : null;
      }).filter((a) => a != null);
      i(l.length ? new Map(l) : null), n.current = e;
    }
    return () => {
      o(e), o(g);
    };
    function o(l) {
      l.forEach((a) => {
        const I = qF(a);
        I == null || I.removeEventListener("scroll", r);
      });
    }
  }, [r, e]), Oe(() => e.length ? t ? Array.from(t.values()).reduce((g, o) => _h(g, o), xs) : Vre(e) : xs, [e, t]);
}
function pO(e, t) {
  t === void 0 && (t = []);
  const i = ot(null);
  return lt(
    () => {
      i.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), lt(() => {
    const n = e !== xs;
    n && !i.current && (i.current = e), !n && i.current && (i.current = null);
  }, [e]), i.current ? _w(e, i.current) : xs;
}
function NUt(e) {
  lt(
    () => {
      if (!P1)
        return;
      const t = e.map((i) => {
        let {
          sensor: n
        } = i;
        return n.setup == null ? void 0 : n.setup();
      });
      return () => {
        for (const i of t)
          i == null || i();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: i
      } = t;
      return i;
    })
  );
}
function LUt(e, t) {
  return Oe(() => e.reduce((i, n) => {
    let {
      eventName: r,
      handler: g
    } = n;
    return i[r] = (o) => {
      g(o, t);
    }, i;
  }, {}), [e, t]);
}
function Yre(e) {
  return Oe(() => e ? CUt(e) : null, [e]);
}
const ex = [];
function KUt(e, t) {
  t === void 0 && (t = ip);
  const [i] = e, n = Yre(i ? Do(i) : null), [r, g] = aZ(l, ex), o = O1({
    callback: g
  });
  return e.length > 0 && r === ex && g(), Pa(() => {
    e.length ? e.forEach((a) => o == null ? void 0 : o.observe(a)) : (o == null || o.disconnect(), g());
  }, [e]), r;
  function l() {
    return e.length ? e.map((a) => Wre(a) ? n : new kN(t(a), a)) : ex;
  }
}
function Fre(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return hG(t) ? t : e;
}
function TUt(e) {
  let {
    measure: t
  } = e;
  const [i, n] = wt(null), r = Gt((I) => {
    for (const {
      target: c
    } of I)
      if (hG(c)) {
        n((d) => {
          const C = t(c);
          return d ? {
            ...d,
            width: C.width,
            height: C.height
          } : C;
        });
        break;
      }
  }, [t]), g = O1({
    callback: r
  }), o = Gt((I) => {
    const c = Fre(I);
    g == null || g.disconnect(), c && (g == null || g.observe(c)), n(c ? t(c) : null);
  }, [t, g]), [l, a] = jw(o);
  return Oe(() => ({
    nodeRef: l,
    rect: i,
    setRef: a
  }), [i, l, a]);
}
const MUt = [{
  sensor: Xre,
  options: {}
}, {
  sensor: Rre,
  options: {}
}], PUt = {
  current: {}
}, YV = {
  draggable: {
    measure: dO
  },
  droppable: {
    measure: dO,
    strategy: rZ.WhileDragging,
    frequency: mD.Optimized
  },
  dragOverlay: {
    measure: ip
  }
};
class bf extends Map {
  get(t) {
    var i;
    return t != null && (i = super.get(t)) != null ? i : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: i
      } = t;
      return !i;
    });
  }
  getNodeFor(t) {
    var i, n;
    return (i = (n = this.get(t)) == null ? void 0 : n.node.current) != null ? i : void 0;
  }
}
const UUt = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new bf(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: e2
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: YV,
  measureDroppableContainers: e2,
  windowRect: null,
  measuringScheduled: !1
}, xre = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: e2,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: e2
}, BG = /* @__PURE__ */ Ua(xre), Dre = /* @__PURE__ */ Ua(UUt);
function zUt() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new bf()
    }
  };
}
function OUt(e, t) {
  switch (t.type) {
    case zr.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case zr.DragMove:
      return e.draggable.active ? {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      } : e;
    case zr.DragEnd:
    case zr.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case zr.RegisterDroppable: {
      const {
        element: i
      } = t, {
        id: n
      } = i, r = new bf(e.droppable.containers);
      return r.set(n, i), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: r
        }
      };
    }
    case zr.SetDroppableDisabled: {
      const {
        id: i,
        key: n,
        disabled: r
      } = t, g = e.droppable.containers.get(i);
      if (!g || n !== g.key)
        return e;
      const o = new bf(e.droppable.containers);
      return o.set(i, {
        ...g,
        disabled: r
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case zr.UnregisterDroppable: {
      const {
        id: i,
        key: n
      } = t, r = e.droppable.containers.get(i);
      if (!r || n !== r.key)
        return e;
      const g = new bf(e.droppable.containers);
      return g.delete(i), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: g
        }
      };
    }
    default:
      return e;
  }
}
function QUt(e) {
  let {
    disabled: t
  } = e;
  const {
    active: i,
    activatorEvent: n,
    draggableNodes: r
  } = Vn(BG), g = qw(n), o = qw(i == null ? void 0 : i.id);
  return lt(() => {
    if (!t && !n && g && o != null) {
      if (!z1(g) || document.activeElement === g.target)
        return;
      const l = r.get(o);
      if (!l)
        return;
      const {
        activatorNode: a,
        node: I
      } = l;
      if (!a.current && !I.current)
        return;
      requestAnimationFrame(() => {
        for (const c of [a.current, I.current]) {
          if (!c)
            continue;
          const d = MPt(c);
          if (d) {
            d.focus();
            break;
          }
        }
      });
    }
  }, [n, t, r, o, g]), null;
}
function Jre(e, t) {
  let {
    transform: i,
    ...n
  } = t;
  return e != null && e.length ? e.reduce((r, g) => g({
    transform: r,
    ...n
  }), i) : i;
}
function jUt(e) {
  return Oe(
    () => ({
      draggable: {
        ...YV.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...YV.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...YV.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function qUt(e) {
  let {
    activeNode: t,
    measure: i,
    initialRect: n,
    config: r = !0
  } = e;
  const g = ot(!1), {
    x: o,
    y: l
  } = typeof r == "boolean" ? {
    x: r,
    y: r
  } : r;
  Pa(() => {
    if (!o && !l || !t) {
      g.current = !1;
      return;
    }
    if (g.current || !n)
      return;
    const I = t == null ? void 0 : t.node.current;
    if (!I || I.isConnected === !1)
      return;
    const c = i(I), d = Bre(c, n);
    if (o || (d.x = 0), l || (d.y = 0), g.current = !0, Math.abs(d.x) > 0 || Math.abs(d.y) > 0) {
      const C = Zre(I);
      C && C.scrollBy({
        top: d.y,
        left: d.x
      });
    }
  }, [t, o, l, n, i]);
}
const Q1 = /* @__PURE__ */ Ua({
  ...xs,
  scaleX: 1,
  scaleY: 1
});
var Vd;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Vd || (Vd = {}));
const _Ut = /* @__PURE__ */ Bm(function(t) {
  var i, n, r, g;
  let {
    id: o,
    accessibility: l,
    autoScroll: a = !0,
    children: I,
    sensors: c = MUt,
    collisionDetection: d = aUt,
    measuring: C,
    modifiers: A,
    ...b
  } = t;
  const m = aZ(OUt, void 0, zUt), [p, B] = m, [f, Z] = jPt(), [y, W] = wt(Vd.Uninitialized), V = y === Vd.Initialized, {
    draggable: {
      active: w,
      nodes: v,
      translate: H
    },
    droppable: {
      containers: x
    }
  } = p, J = w ? v.get(w) : null, K = ot({
    initial: null,
    translated: null
  }), M = Oe(() => {
    var mt;
    return w != null ? {
      id: w,
      // It's possible for the active node to unmount while dragging
      data: (mt = J == null ? void 0 : J.data) != null ? mt : PUt,
      rect: K
    } : null;
  }, [w, J]), L = ot(null), [N, U] = wt(null), [O, $] = wt(null), ne = nZ(b, Object.values(b)), be = pG("DndDescribedBy", o), Ve = Oe(() => x.getEnabled(), [x]), He = jUt(C), {
    droppableRects: Je,
    measureDroppableContainers: ke,
    measuringScheduled: we
  } = kUt(Ve, {
    dragging: V,
    dependencies: [H.x, H.y],
    config: He.droppable
  }), ue = XUt(v, w), Xe = Oe(() => O ? $w(O) : null, [O]), Ze = di(), xe = YUt(ue, He.draggable.measure);
  qUt({
    activeNode: w ? v.get(w) : null,
    config: Ze.layoutShiftCompensation,
    initialRect: xe,
    measure: He.draggable.measure
  });
  const Pe = hO(ue, He.draggable.measure, xe), st = hO(ue ? ue.parentElement : null), bt = ot({
    activatorEvent: null,
    active: null,
    activeNode: ue,
    collisionRect: null,
    collisions: null,
    droppableRects: Je,
    draggableNodes: v,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: x,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), it = x.getNodeFor((i = bt.current.over) == null ? void 0 : i.id), Qe = TUt({
    measure: He.dragOverlay.measure
  }), $e = (n = Qe.nodeRef.current) != null ? n : ue, It = V ? (r = Qe.rect) != null ? r : Pe : null, jt = !!(Qe.nodeRef.current && Qe.rect), Bt = DUt(jt ? null : Pe), te = Yre($e ? Do($e) : null), Xt = JUt(V ? it ?? ue : null), Ht = KUt(Xt), ii = Jre(A, {
    transform: {
      x: H.x - Bt.x,
      y: H.y - Bt.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: O,
    active: M,
    activeNodeRect: Pe,
    containerNodeRect: st,
    draggingNodeRect: It,
    over: bt.current.over,
    overlayNodeRect: Qe.rect,
    scrollableAncestors: Xt,
    scrollableAncestorRects: Ht,
    windowRect: te
  }), $t = Xe ? _h(Xe, H) : null, ni = EUt(Xt), mi = pO(ni), Bi = pO(ni, [Pe]), ci = _h(ii, mi), Ge = It ? cUt(It, ii) : null, Be = M && Ge ? d({
    active: M,
    collisionRect: Ge,
    droppableRects: Je,
    droppableContainers: Ve,
    pointerCoordinates: $t
  }) : null, qe = gUt(Be, "id"), [vt, Kt] = wt(null), Te = jt ? ii : _h(ii, Bi), Tt = sUt(Te, (g = vt == null ? void 0 : vt.rect) != null ? g : null, Pe), Ue = Gt(
    (mt, Ai) => {
      let {
        sensor: ui,
        options: Ui
      } = Ai;
      if (L.current == null)
        return;
      const Oi = v.get(L.current);
      if (!Oi)
        return;
      const Rn = mt.nativeEvent, le = new ui({
        active: L.current,
        activeNode: Oi,
        event: Rn,
        options: Ui,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: bt,
        onStart(pe) {
          const Ne = L.current;
          if (Ne == null)
            return;
          const Ke = v.get(Ne);
          if (!Ke)
            return;
          const {
            onDragStart: Jt
          } = ne.current, Rt = {
            active: {
              id: Ne,
              data: Ke.data,
              rect: K
            }
          };
          Vh(() => {
            Jt == null || Jt(Rt), W(Vd.Initializing), B({
              type: zr.DragStart,
              initialCoordinates: pe,
              active: Ne
            }), f({
              type: "onDragStart",
              event: Rt
            });
          });
        },
        onMove(pe) {
          B({
            type: zr.DragMove,
            coordinates: pe
          });
        },
        onEnd: Ce(zr.DragEnd),
        onCancel: Ce(zr.DragCancel)
      });
      Vh(() => {
        U(le), $(mt.nativeEvent);
      });
      function Ce(pe) {
        return async function() {
          const {
            active: Ke,
            collisions: Jt,
            over: Rt,
            scrollAdjustedTranslate: Zt
          } = bt.current;
          let Et = null;
          if (Ke && Zt) {
            const {
              cancelDrop: dt
            } = ne.current;
            Et = {
              activatorEvent: Rn,
              active: Ke,
              collisions: Jt,
              delta: Zt,
              over: Rt
            }, pe === zr.DragEnd && typeof dt == "function" && await Promise.resolve(dt(Et)) && (pe = zr.DragCancel);
          }
          L.current = null, Vh(() => {
            B({
              type: pe
            }), W(Vd.Uninitialized), Kt(null), U(null), $(null);
            const dt = pe === zr.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Et) {
              const xt = ne.current[dt];
              xt == null || xt(Et), f({
                type: dt,
                event: Et
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v]
  ), Me = Gt((mt, Ai) => (ui, Ui) => {
    const Oi = ui.nativeEvent, Rn = v.get(Ui);
    if (
      // Another sensor is already instantiating
      L.current !== null || // No active draggable
      !Rn || // Event has already been captured
      Oi.dndKit || Oi.defaultPrevented
    )
      return;
    const le = {
      active: Rn
    };
    mt(ui, Ai.options, le) === !0 && (Oi.dndKit = {
      capturedBy: Ai.sensor
    }, L.current = Ui, Ue(ui, Ai));
  }, [v, Ue]), Yt = HUt(c, Me);
  NUt(c), Pa(() => {
    Pe && y === Vd.Initializing && W(Vd.Initialized);
  }, [Pe, y]), lt(
    () => {
      const {
        onDragMove: mt
      } = ne.current, {
        active: Ai,
        activatorEvent: ui,
        collisions: Ui,
        over: Oi
      } = bt.current;
      if (!Ai || !ui)
        return;
      const Rn = {
        active: Ai,
        activatorEvent: ui,
        collisions: Ui,
        delta: {
          x: ci.x,
          y: ci.y
        },
        over: Oi
      };
      Vh(() => {
        mt == null || mt(Rn), f({
          type: "onDragMove",
          event: Rn
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ci.x, ci.y]
  ), lt(
    () => {
      const {
        active: mt,
        activatorEvent: Ai,
        collisions: ui,
        droppableContainers: Ui,
        scrollAdjustedTranslate: Oi
      } = bt.current;
      if (!mt || L.current == null || !Ai || !Oi)
        return;
      const {
        onDragOver: Rn
      } = ne.current, le = Ui.get(qe), Ce = le && le.rect.current ? {
        id: le.id,
        rect: le.rect.current,
        data: le.data,
        disabled: le.disabled
      } : null, pe = {
        active: mt,
        activatorEvent: Ai,
        collisions: ui,
        delta: {
          x: Oi.x,
          y: Oi.y
        },
        over: Ce
      };
      Vh(() => {
        Kt(Ce), Rn == null || Rn(pe), f({
          type: "onDragOver",
          event: pe
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [qe]
  ), Pa(() => {
    bt.current = {
      activatorEvent: O,
      active: M,
      activeNode: ue,
      collisionRect: Ge,
      collisions: Be,
      droppableRects: Je,
      draggableNodes: v,
      draggingNode: $e,
      draggingNodeRect: It,
      droppableContainers: x,
      over: vt,
      scrollableAncestors: Xt,
      scrollAdjustedTranslate: ci
    }, K.current = {
      initial: It,
      translated: Ge
    };
  }, [M, ue, Be, Ge, v, $e, It, Je, x, vt, Xt, ci]), wUt({
    ...Ze,
    delta: H,
    draggingRect: Ge,
    pointerCoordinates: $t,
    scrollableAncestors: Xt,
    scrollableAncestorRects: Ht
  });
  const zt = Oe(() => ({
    active: M,
    activeNode: ue,
    activeNodeRect: Pe,
    activatorEvent: O,
    collisions: Be,
    containerNodeRect: st,
    dragOverlay: Qe,
    draggableNodes: v,
    droppableContainers: x,
    droppableRects: Je,
    over: vt,
    measureDroppableContainers: ke,
    scrollableAncestors: Xt,
    scrollableAncestorRects: Ht,
    measuringConfiguration: He,
    measuringScheduled: we,
    windowRect: te
  }), [M, ue, Pe, O, Be, st, Qe, v, x, Je, vt, ke, Xt, Ht, He, we, te]), ri = Oe(() => ({
    activatorEvent: O,
    activators: Yt,
    active: M,
    activeNodeRect: Pe,
    ariaDescribedById: {
      draggable: be
    },
    dispatch: B,
    draggableNodes: v,
    over: vt,
    measureDroppableContainers: ke
  }), [O, Yt, M, Pe, B, be, v, vt, ke]);
  return De.createElement(pre.Provider, {
    value: Z
  }, De.createElement(BG.Provider, {
    value: ri
  }, De.createElement(Dre.Provider, {
    value: zt
  }, De.createElement(Q1.Provider, {
    value: Tt
  }, I)), De.createElement(QUt, {
    disabled: (l == null ? void 0 : l.restoreFocus) === !1
  })), De.createElement($Pt, {
    ...l,
    hiddenTextDescribedById: be
  }));
  function di() {
    const mt = (N == null ? void 0 : N.autoScrollEnabled) === !1, Ai = typeof a == "object" ? a.enabled === !1 : a === !1, ui = V && !mt && !Ai;
    return typeof a == "object" ? {
      ...a,
      enabled: ui
    } : {
      enabled: ui
    };
  }
}), $Ut = /* @__PURE__ */ Ua(null), BO = "button", ezt = "Droppable";
function tzt(e) {
  let {
    id: t,
    data: i,
    disabled: n = !1,
    attributes: r
  } = e;
  const g = pG(ezt), {
    activators: o,
    activatorEvent: l,
    active: a,
    activeNodeRect: I,
    ariaDescribedById: c,
    draggableNodes: d,
    over: C
  } = Vn(BG), {
    role: A = BO,
    roleDescription: b = "draggable",
    tabIndex: m = 0
  } = r ?? {}, p = (a == null ? void 0 : a.id) === t, B = Vn(p ? Q1 : $Ut), [f, Z] = jw(), [y, W] = jw(), V = LUt(o, t), w = nZ(i);
  Pa(
    () => (d.set(t, {
      id: t,
      key: g,
      node: f,
      activatorNode: y,
      data: w
    }), () => {
      const H = d.get(t);
      H && H.key === g && d.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d, t]
  );
  const v = Oe(() => ({
    role: A,
    tabIndex: m,
    "aria-disabled": n,
    "aria-pressed": p && A === BO ? !0 : void 0,
    "aria-roledescription": b,
    "aria-describedby": c.draggable
  }), [n, A, m, p, b, c.draggable]);
  return {
    active: a,
    activatorEvent: l,
    activeNodeRect: I,
    attributes: v,
    isDragging: p,
    listeners: n ? void 0 : V,
    node: f,
    over: C,
    setNodeRef: Z,
    setActivatorNodeRef: W,
    transform: B
  };
}
function Ere() {
  return Vn(Dre);
}
const izt = "Droppable", nzt = {
  timeout: 25
};
function rzt(e) {
  let {
    data: t,
    disabled: i = !1,
    id: n,
    resizeObserverConfig: r
  } = e;
  const g = pG(izt), {
    active: o,
    dispatch: l,
    over: a,
    measureDroppableContainers: I
  } = Vn(BG), c = ot({
    disabled: i
  }), d = ot(!1), C = ot(null), A = ot(null), {
    disabled: b,
    updateMeasurementsFor: m,
    timeout: p
  } = {
    ...nzt,
    ...r
  }, B = nZ(m ?? n), f = Gt(
    () => {
      if (!d.current) {
        d.current = !0;
        return;
      }
      A.current != null && clearTimeout(A.current), A.current = setTimeout(() => {
        I(Array.isArray(B.current) ? B.current : [B.current]), A.current = null;
      }, p);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [p]
  ), Z = O1({
    callback: f,
    disabled: b || !o
  }), y = Gt((v, H) => {
    Z && (H && (Z.unobserve(H), d.current = !1), v && Z.observe(v));
  }, [Z]), [W, V] = jw(y), w = nZ(t);
  return lt(() => {
    !Z || !W.current || (Z.disconnect(), d.current = !1, Z.observe(W.current));
  }, [W, Z]), Pa(
    () => (l({
      type: zr.RegisterDroppable,
      element: {
        id: n,
        key: g,
        disabled: i,
        node: W,
        rect: C,
        data: w
      }
    }), () => l({
      type: zr.UnregisterDroppable,
      key: g,
      id: n
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  ), lt(() => {
    i !== c.current.disabled && (l({
      type: zr.SetDroppableDisabled,
      id: n,
      key: g,
      disabled: i
    }), c.current.disabled = i);
  }, [n, g, i, l]), {
    active: o,
    rect: C,
    isOver: (a == null ? void 0 : a.id) === n,
    node: W,
    over: a,
    setNodeRef: V
  };
}
function gzt(e) {
  let {
    animation: t,
    children: i
  } = e;
  const [n, r] = wt(null), [g, o] = wt(null), l = qw(i);
  return !i && !n && l && r(l), Pa(() => {
    if (!g)
      return;
    const a = n == null ? void 0 : n.key, I = n == null ? void 0 : n.props.id;
    if (a == null || I == null) {
      r(null);
      return;
    }
    Promise.resolve(t(I, g)).then(() => {
      r(null);
    });
  }, [t, n, g]), De.createElement(De.Fragment, null, i, n ? Jd(n, {
    ref: o
  }) : null);
}
const ozt = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function lzt(e) {
  let {
    children: t
  } = e;
  return De.createElement(BG.Provider, {
    value: xre
  }, De.createElement(Q1.Provider, {
    value: ozt
  }, t));
}
const azt = {
  position: "fixed",
  touchAction: "none"
}, szt = (e) => z1(e) ? "transform 250ms ease" : void 0, Izt = /* @__PURE__ */ dl((e, t) => {
  let {
    as: i,
    activatorEvent: n,
    adjustScale: r,
    children: g,
    className: o,
    rect: l,
    style: a,
    transform: I,
    transition: c = szt
  } = e;
  if (!l)
    return null;
  const d = r ? I : {
    ...I,
    scaleX: 1,
    scaleY: 1
  }, C = {
    ...azt,
    width: l.width,
    height: l.height,
    top: l.top,
    left: l.left,
    transform: IA.Transform.toString(d),
    transformOrigin: r && n ? iUt(n, l) : void 0,
    transition: typeof c == "function" ? c(n) : c,
    ...a
  };
  return De.createElement(i, {
    className: o,
    style: C,
    ref: t
  }, g);
}), czt = (e) => (t) => {
  let {
    active: i,
    dragOverlay: n
  } = t;
  const r = {}, {
    styles: g,
    className: o
  } = e;
  if (g != null && g.active)
    for (const [l, a] of Object.entries(g.active))
      a !== void 0 && (r[l] = i.node.style.getPropertyValue(l), i.node.style.setProperty(l, a));
  if (g != null && g.dragOverlay)
    for (const [l, a] of Object.entries(g.dragOverlay))
      a !== void 0 && n.node.style.setProperty(l, a);
  return o != null && o.active && i.node.classList.add(o.active), o != null && o.dragOverlay && n.node.classList.add(o.dragOverlay), function() {
    for (const [a, I] of Object.entries(r))
      i.node.style.setProperty(a, I);
    o != null && o.active && i.node.classList.remove(o.active);
  };
}, dzt = (e) => {
  let {
    transform: {
      initial: t,
      final: i
    }
  } = e;
  return [{
    transform: IA.Transform.toString(t)
  }, {
    transform: IA.Transform.toString(i)
  }];
}, uzt = {
  duration: 250,
  easing: "ease",
  keyframes: dzt,
  sideEffects: /* @__PURE__ */ czt({
    styles: {
      active: {
        opacity: "0"
      }
    }
  })
};
function Czt(e) {
  let {
    config: t,
    draggableNodes: i,
    droppableContainers: n,
    measuringConfiguration: r
  } = e;
  return U1((g, o) => {
    if (t === null)
      return;
    const l = i.get(g);
    if (!l)
      return;
    const a = l.node.current;
    if (!a)
      return;
    const I = Fre(o);
    if (!I)
      return;
    const {
      transform: c
    } = Do(o).getComputedStyle(o), d = fre(c);
    if (!d)
      return;
    const C = typeof t == "function" ? t : Azt(t);
    return wre(a, r.draggable.measure), C({
      active: {
        id: g,
        data: l.data,
        node: a,
        rect: r.draggable.measure(a)
      },
      draggableNodes: i,
      dragOverlay: {
        node: o,
        rect: r.dragOverlay.measure(I)
      },
      droppableContainers: n,
      measuringConfiguration: r,
      transform: d
    });
  });
}
function Azt(e) {
  const {
    duration: t,
    easing: i,
    sideEffects: n,
    keyframes: r
  } = {
    ...uzt,
    ...e
  };
  return (g) => {
    let {
      active: o,
      dragOverlay: l,
      transform: a,
      ...I
    } = g;
    if (!t)
      return;
    const c = {
      x: l.rect.left - o.rect.left,
      y: l.rect.top - o.rect.top
    }, d = {
      scaleX: a.scaleX !== 1 ? o.rect.width * a.scaleX / l.rect.width : 1,
      scaleY: a.scaleY !== 1 ? o.rect.height * a.scaleY / l.rect.height : 1
    }, C = {
      x: a.x - c.x,
      y: a.y - c.y,
      ...d
    }, A = r({
      ...I,
      active: o,
      dragOverlay: l,
      transform: {
        initial: a,
        final: C
      }
    }), [b] = A, m = A[A.length - 1];
    if (JSON.stringify(b) === JSON.stringify(m))
      return;
    const p = n == null ? void 0 : n({
      active: o,
      dragOverlay: l,
      ...I
    }), B = l.node.animate(A, {
      duration: t,
      easing: i,
      fill: "forwards"
    });
    return new Promise((f) => {
      B.onfinish = () => {
        p == null || p(), f();
      };
    });
  };
}
let fO = 0;
function bzt(e) {
  return Oe(() => {
    if (e != null)
      return fO++, fO;
  }, [e]);
}
const hzt = /* @__PURE__ */ De.memo((e) => {
  let {
    adjustScale: t = !1,
    children: i,
    dropAnimation: n,
    style: r,
    transition: g,
    modifiers: o,
    wrapperElement: l = "div",
    className: a,
    zIndex: I = 999
  } = e;
  const {
    activatorEvent: c,
    active: d,
    activeNodeRect: C,
    containerNodeRect: A,
    draggableNodes: b,
    droppableContainers: m,
    dragOverlay: p,
    over: B,
    measuringConfiguration: f,
    scrollableAncestors: Z,
    scrollableAncestorRects: y,
    windowRect: W
  } = Ere(), V = Vn(Q1), w = bzt(d == null ? void 0 : d.id), v = Jre(o, {
    activatorEvent: c,
    active: d,
    activeNodeRect: C,
    containerNodeRect: A,
    draggingNodeRect: p.rect,
    over: B,
    overlayNodeRect: p.rect,
    scrollableAncestors: Z,
    scrollableAncestorRects: y,
    transform: V,
    windowRect: W
  }), H = FN(C), x = Czt({
    config: n,
    draggableNodes: b,
    droppableContainers: m,
    measuringConfiguration: f
  }), J = H ? p.setRef : void 0;
  return De.createElement(lzt, null, De.createElement(gzt, {
    animation: x
  }, d && w ? De.createElement(Izt, {
    key: w,
    id: d.id,
    ref: J,
    as: l,
    activatorEvent: c,
    adjustScale: t,
    className: a,
    transition: g,
    rect: H,
    style: {
      zIndex: I,
      ...r
    },
    transform: v
  }, i) : null));
});
function Nre(e, t, i) {
  const n = e.slice();
  return n.splice(i < 0 ? n.length + i : i, 0, n.splice(t, 1)[0]), n;
}
function mzt(e, t) {
  return e.reduce((i, n, r) => {
    const g = t.get(n);
    return g && (i[r] = g), i;
  }, Array(e.length));
}
function OS(e) {
  return e !== null && e >= 0;
}
function pzt(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let i = 0; i < e.length; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
function Bzt(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const xN = (e) => {
  let {
    rects: t,
    activeIndex: i,
    overIndex: n,
    index: r
  } = e;
  const g = Nre(t, n, i), o = t[r], l = g[r];
  return !l || !o ? null : {
    x: l.left - o.left,
    y: l.top - o.top,
    scaleX: l.width / o.width,
    scaleY: l.height / o.height
  };
}, Lre = "Sortable", Kre = /* @__PURE__ */ De.createContext({
  activeIndex: -1,
  containerId: Lre,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: xN,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function fzt(e) {
  let {
    children: t,
    id: i,
    items: n,
    strategy: r = xN,
    disabled: g = !1
  } = e;
  const {
    active: o,
    dragOverlay: l,
    droppableRects: a,
    over: I,
    measureDroppableContainers: c
  } = Ere(), d = pG(Lre, i), C = l.rect !== null, A = Oe(() => n.map((V) => typeof V == "object" && "id" in V ? V.id : V), [n]), b = o != null, m = o ? A.indexOf(o.id) : -1, p = I ? A.indexOf(I.id) : -1, B = ot(A), f = !pzt(A, B.current), Z = p !== -1 && m === -1 || f, y = Bzt(g);
  Pa(() => {
    f && b && c(A);
  }, [f, A, b, c]), lt(() => {
    B.current = A;
  }, [A]);
  const W = Oe(
    () => ({
      activeIndex: m,
      containerId: d,
      disabled: y,
      disableTransforms: Z,
      items: A,
      overIndex: p,
      useDragOverlay: C,
      sortedRects: mzt(A, a),
      strategy: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m, d, y.draggable, y.droppable, Z, A, p, a, C, r]
  );
  return De.createElement(Kre.Provider, {
    value: W
  }, t);
}
const Zzt = (e) => {
  let {
    id: t,
    items: i,
    activeIndex: n,
    overIndex: r
  } = e;
  return Nre(i, n, r).indexOf(t);
}, Gzt = (e) => {
  let {
    containerId: t,
    isSorting: i,
    wasDragging: n,
    index: r,
    items: g,
    newIndex: o,
    previousItems: l,
    previousContainerId: a,
    transition: I
  } = e;
  return !I || !n || l !== g && r === o ? !1 : i ? !0 : o !== r && t === a;
}, yzt = {
  duration: 200,
  easing: "ease"
}, Tre = "transform", Wzt = /* @__PURE__ */ IA.Transition.toString({
  property: Tre,
  duration: 0,
  easing: "linear"
}), Szt = {
  roleDescription: "sortable"
};
function Vzt(e) {
  let {
    disabled: t,
    index: i,
    node: n,
    rect: r
  } = e;
  const [g, o] = wt(null), l = ot(i);
  return Pa(() => {
    if (!t && i !== l.current && n.current) {
      const a = r.current;
      if (a) {
        const I = ip(n.current, {
          ignoreTransform: !0
        }), c = {
          x: a.left - I.left,
          y: a.top - I.top,
          scaleX: a.width / I.width,
          scaleY: a.height / I.height
        };
        (c.x || c.y) && o(c);
      }
    }
    i !== l.current && (l.current = i);
  }, [t, i, n, r]), lt(() => {
    g && o(null);
  }, [g]), g;
}
function wzt(e) {
  let {
    animateLayoutChanges: t = Gzt,
    attributes: i,
    disabled: n,
    data: r,
    getNewIndex: g = Zzt,
    id: o,
    strategy: l,
    resizeObserverConfig: a,
    transition: I = yzt
  } = e;
  const {
    items: c,
    containerId: d,
    activeIndex: C,
    disabled: A,
    disableTransforms: b,
    sortedRects: m,
    overIndex: p,
    useDragOverlay: B,
    strategy: f
  } = Vn(Kre), Z = vzt(n, A), y = c.indexOf(o), W = Oe(() => ({
    sortable: {
      containerId: d,
      index: y,
      items: c
    },
    ...r
  }), [d, r, y, c]), V = Oe(() => c.slice(c.indexOf(o)), [c, o]), {
    rect: w,
    node: v,
    isOver: H,
    setNodeRef: x
  } = rzt({
    id: o,
    data: W,
    disabled: Z.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: V,
      ...a
    }
  }), {
    active: J,
    activatorEvent: K,
    activeNodeRect: M,
    attributes: L,
    setNodeRef: N,
    listeners: U,
    isDragging: O,
    over: $,
    setActivatorNodeRef: ne,
    transform: be
  } = tzt({
    id: o,
    data: W,
    attributes: {
      ...Szt,
      ...i
    },
    disabled: Z.draggable
  }), Ve = NPt(x, N), He = !!J, Je = He && !b && OS(C) && OS(p), ke = !B && O, we = ke && Je ? be : null, Xe = Je ? we ?? (l ?? f)({
    rects: m,
    activeNodeRect: M,
    activeIndex: C,
    overIndex: p,
    index: y
  }) : null, Ze = OS(C) && OS(p) ? g({
    id: o,
    items: c,
    activeIndex: C,
    overIndex: p
  }) : y, xe = J == null ? void 0 : J.id, Pe = ot({
    activeId: xe,
    items: c,
    newIndex: Ze,
    containerId: d
  }), st = c !== Pe.current.items, bt = t({
    active: J,
    containerId: d,
    isDragging: O,
    isSorting: He,
    id: o,
    index: y,
    items: c,
    newIndex: Pe.current.newIndex,
    previousItems: Pe.current.items,
    previousContainerId: Pe.current.containerId,
    transition: I,
    wasDragging: Pe.current.activeId != null
  }), it = Vzt({
    disabled: !bt,
    index: y,
    node: v,
    rect: w
  });
  return lt(() => {
    He && Pe.current.newIndex !== Ze && (Pe.current.newIndex = Ze), d !== Pe.current.containerId && (Pe.current.containerId = d), c !== Pe.current.items && (Pe.current.items = c);
  }, [He, Ze, d, c]), lt(() => {
    if (xe === Pe.current.activeId)
      return;
    if (xe && !Pe.current.activeId) {
      Pe.current.activeId = xe;
      return;
    }
    const $e = setTimeout(() => {
      Pe.current.activeId = xe;
    }, 50);
    return () => clearTimeout($e);
  }, [xe]), {
    active: J,
    activeIndex: C,
    attributes: L,
    data: W,
    rect: w,
    index: y,
    newIndex: Ze,
    items: c,
    isOver: H,
    isSorting: He,
    isDragging: O,
    listeners: U,
    node: v,
    overIndex: p,
    over: $,
    setNodeRef: Ve,
    setActivatorNodeRef: ne,
    setDroppableNodeRef: x,
    setDraggableNodeRef: N,
    transform: it ?? Xe,
    transition: Qe()
  };
  function Qe() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      it || // Or to prevent items jumping to back to their "new" position when items change
      st && Pe.current.newIndex === y
    )
      return Wzt;
    if (!(ke && !z1(K) || !I) && (He || bt))
      return IA.Transition.toString({
        ...I,
        property: Tre
      });
  }
}
function vzt(e, t) {
  var i, n;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (i = e == null ? void 0 : e.draggable) != null ? i : t.draggable,
    droppable: (n = e == null ? void 0 : e.droppable) != null ? n : t.droppable
  };
}
Bn.Down, Bn.Right, Bn.Up, Bn.Left;
const Rzt = (e) => {
  const {
    t
  } = Gi();
  return /* @__PURE__ */ S(Tn, { title: t("Komponente hinzufügen"), disableInteractive: !0, children: /* @__PURE__ */ S(Ni, { className: "k3-component-cards-add-button", sx: {
    position: "absolute",
    bottom: 1,
    right: 1
  }, color: "primary", "data-cy": "addComponentButton", children: /* @__PURE__ */ S(YAt, {}) }) });
}, Mre = ({
  variable: e,
  contextInstance: t
}) => {
  const i = Ei(), n = rp(t, e, !1), [r, g] = wt([]);
  lt(() => {
    g(n.map((b) => ({
      id: b.selection.id,
      selection: b
    })));
  }, [n]);
  const o = eUt(IO(Hre, {
    activationConstraint: {
      distance: 20
    }
  }), IO(kre, {
    activationConstraint: {
      distance: 20
    }
  })), [l, a] = wt(null), I = Oe(() => n.find((b) => b.selection.id === l), [l, n]), c = (b) => {
    a(b.active.id.toString());
  }, d = (b) => {
    a(null), i(Gte(e.settings.templateOptions.reverseSorting ? r.map((m) => m.selection.selection).reverse() : r.map((m) => m.selection.selection)));
  }, C = () => {
    a(null);
  }, A = Gt((b) => {
    const {
      active: m,
      over: p
    } = b;
    if (m.data.current && (p != null && p.data.current) && m.id !== p.id) {
      const B = m.data.current.sortable.index, f = p.data.current.sortable.index;
      g((Z) => {
        const y = [...Z], [W] = y.splice(B, 1);
        return y.splice(f, 0, W), y;
      });
    }
  }, []);
  return /* @__PURE__ */ S(li, { children: /* @__PURE__ */ Ie(_Ut, { sensors: o, collisionDetection: oUt, onDragStart: c, onDragEnd: d, onDragCancel: C, onDragMove: A, children: [
    /* @__PURE__ */ S(fzt, { items: r, strategy: xN, children: /* @__PURE__ */ S(vo, { component: "div", sx: {
      overflowX: "auto",
      display: "grid",
      // grid left ro right, top to bottom 50px x 50px
      gridTemplateColumns: "repeat(auto-fill, 65px)",
      gridAutoRows: "65px"
    }, children: r.map(({
      id: b,
      selection: m
    }) => /* @__PURE__ */ S(ZO, { selection: m, contextInstance: t, variable: e }, b)) }) }),
    /* @__PURE__ */ S(hzt, { adjustScale: !0, style: {
      transformOrigin: "0 0 ",
      background: "white"
    }, children: I ? /* @__PURE__ */ S(ZO, { selection: I, variable: e, contextInstance: t, tooltip: !1 }) : null })
  ] }) });
}, ZO = ({
  selection: e,
  contextInstance: t,
  variable: i,
  tooltip: n = !0
}) => {
  const {
    isDragging: r,
    attributes: g,
    listeners: o,
    setNodeRef: l
  } = wzt({
    id: e.selection.id
  }), a = Ei(), {
    palette: I
  } = ql(), c = ie(Ns), d = Tl((B) => B.hoveredSelections), C = Tl((B) => B.setHoveredSelection), A = Tl((B) => B.removeHoveredSelection), {
    t: b
  } = Gi(), m = rr(), p = d.includes(e.selection.id) || c.some((B) => B.id === e.selection.id);
  return /* @__PURE__ */ S(Tn, { open: r || !n ? !1 : void 0, title: /* @__PURE__ */ S(vI, { variable: i, variableValue: e.value, templateOptions: Vi(i), style: {
    marginTop: 2,
    marginBottom: 2
  } }, e.selection.id), children: /* @__PURE__ */ S(ja, { children: /* @__PURE__ */ Ie(
    "div",
    {
      "data-cy": "selection-" + e.selection.id,
      ref: l,
      className: "k3-component-card-list-item",
      style: {
        position: "relative",
        padding: 1,
        border: p ? `solid 1px ${I.divider}` : "none",
        borderRadius: "8px",
        opacity: r ? 0.5 : 1,
        width: "60px",
        height: "60px"
      },
      onMouseDown: () => A(e.selection.id),
      onMouseEnter: () => C(e.selection.id),
      onMouseLeave: () => A(e.selection.id),
      ...g,
      ...o,
      onClick: (B) => {
        a(wr(e.selection.id));
      },
      children: [
        /* @__PURE__ */ S(vI, { variable: i, variableValue: e.value, templateOptions: Vi(i), verticalDisplay: !0, style: {
          overflow: "hidden"
        } }, e.selection.id),
        p && // remove instance button
        /* @__PURE__ */ S(Tn, { title: b("Entfernen"), children: /* @__PURE__ */ S(Ni, { "data-cy": "removeInstanceButton", sx: {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "15px",
          height: "15px",
          // force visible despite overflow hidden
          overflow: "visible",
          zIndex: 1e3
        }, onMouseDown: (B) => {
          B.stopPropagation();
        }, onClick: (B) => {
          B.stopPropagation(), a(QZ(e.selection)), m.id === e.selection.id && a(wr(t.id));
        }, children: /* @__PURE__ */ S(DZ, { sx: {
          width: "15px",
          height: "15px"
        } }) }) })
      ]
    }
  ) }) }, e.selection.id);
}, Xzt = ({
  variable: e,
  values: t,
  contextInstance: i,
  ...n
}) => {
  const r = Ei(), g = (l) => {
    r(bWt(l, i));
  }, o = rp(i, e, !1);
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ Ie(li, { children: [
    (o == null ? void 0 : o.length) > 0 && /* @__PURE__ */ Ie("div", { className: "k3-component-card-list", children: [
      /* @__PURE__ */ S(Mre, { variable: e, contextInstance: i }),
      /* @__PURE__ */ S(SI, { sx: {
        marginY: 1
      } })
    ] }),
    /* @__PURE__ */ S(Are, { ...gG(n), variable: e, values: t, onChange: g, ExtraContent: Rzt })
  ] }) });
}, Hzt = de.flow(ta, gr({
  app: {
    sidebar: {
      componentValueCards: {
        root: !0
      }
    }
  }
}))(Xzt), j1 = (e) => {
  var r;
  const {
    selection: t,
    onChange: i,
    value: n
  } = e;
  return {
    text: (r = t == null ? void 0 : t.data) == null ? void 0 : r.inputText,
    onChange: Gt((g) => !!(n != null && n.id) && i(n.id, {
      inputText: g
    }), [i, n == null ? void 0 : n.id])
  };
}, kzt = (e) => {
  const {
    onChange: t
  } = j1(e);
  return /* @__PURE__ */ S(wg, { variable: e.variable, view: /* @__PURE__ */ S(al, { "data-cy": "hidden", disabled: !0, fullWidth: !0, value: "Versteckt", onChange: t }) });
}, Yzt = Fo("hidden")(kzt);
var DN = {}, Fzt = yg;
Object.defineProperty(DN, "__esModule", {
  value: !0
});
var Pre = DN.default = void 0, xzt = Fzt(oo()), Dzt = ro;
Pre = DN.default = (0, xzt.default)(/* @__PURE__ */ (0, Dzt.jsx)("path", {
  d: "M19 12h-2v3h-3v2h5zM7 9h3V7H5v5h2zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16.01H3V4.99h18z"
}), "AspectRatio");
var JN = {}, Jzt = yg;
Object.defineProperty(JN, "__esModule", {
  value: !0
});
var Ure = JN.default = void 0, Ezt = Jzt(oo()), Nzt = ro;
Ure = JN.default = (0, Ezt.default)(/* @__PURE__ */ (0, Nzt.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");
const tx = De.forwardRef(({
  debounced: e,
  throttle: t,
  label: i,
  onChange: n,
  value: r,
  sliderProps: g,
  sx: o,
  "data-cy": l
}, a) => {
  const I = Oe(() => !!e || !!t, [e, t]), [c, d] = wt(r), C = Gt(de.debounce((p) => n(p), 16), [n]), A = Gt(de.throttle((p) => n(p), t), [n, t]), b = Gt((p, B) => {
    d(B), t ? A(B) : e && C(B);
  }, [A, C, t, e]), m = Gt((p, B) => n(B), [n]);
  return lt(() => {
    I && d(r);
  }, [r, I]), /* @__PURE__ */ Ie(ht, { component: "div", ref: a, sx: o, "data-cy": l, children: [
    /* @__PURE__ */ S(Ct, { color: "text.secondary", children: i }),
    /* @__PURE__ */ S(ht, { component: "div", sx: {
      height: 56,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }, children: /* @__PURE__ */ S(kBe, { ...g, value: I ? c : r, onChange: I ? b : m, "data-cy": "slider" }) })
  ] });
});
function Lzt({
  selection: e,
  app: t,
  handleImageChange: i,
  variable: n,
  printAreasAffectedByThisVariable: r,
  handleSliderChange: g,
  handleReset: o
}) {
  var a, I, c, d, C, A;
  const l = Vi(n);
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(a_, { storeLocally: !0, url: ((a = e == null ? void 0 : e.data) == null ? void 0 : a.url) || "", app: t, onDelete: () => i(""), onUrlChange: i, acceptedImageFormats: (I = n.settings.templateOptions.fileFormat) == null ? void 0 : I.split(",").map((b) => b.toLowerCase()), "data-cy": "imageUpload", target: "frontend" }),
    (r == null ? void 0 : r.length) > 0 && ((c = e == null ? void 0 : e.data) == null ? void 0 : c.url) && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      mb: "30px"
    }, "data-cy": "imageUploadSliders", children: [
      /* @__PURE__ */ Ie(ht, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ S(nM, { sx: {
          height: "20px",
          marginRight: "16px",
          transform: "rotate(90deg)"
        } }),
        /* @__PURE__ */ S(tx, { sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(l.minHorizontal ?? 0),
          max: Number(l.maxHorizontal ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, throttle: 33, value: (d = e.data) == null ? void 0 : d.leftright, "data-cy": "leftRight", onChange: (b) => g("leftright", b) })
      ] }),
      /* @__PURE__ */ Ie(ht, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ S(nM, { sx: {
          height: "20px",
          marginRight: "16px"
        } }),
        /* @__PURE__ */ S(tx, { sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(l.minVertical ?? 0),
          max: Number(l.maxVertical ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, throttle: 33, "data-cy": "topBottom", value: (C = e.data) == null ? void 0 : C.topbottom, onChange: (b) => g("topbottom", b) })
      ] }),
      /* @__PURE__ */ Ie(ht, { component: "div", sx: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ S(Ure, { sx: {
          height: "20px",
          marginRight: "16px"
        } }),
        /* @__PURE__ */ S(tx, { throttle: 33, sx: {
          width: "100%"
        }, sliderProps: {
          min: Number(l.minHorizontal ?? 0),
          max: Number(l.maxHorizontal ?? 100),
          size: "small",
          valueLabelDisplay: "auto"
        }, value: (A = e.data) == null ? void 0 : A.scale, "data-cy": "scale", onChange: (b) => g("scale", b) }),
        /* @__PURE__ */ S(Ni, { sx: {
          marginLeft: "16px"
        }, "aria-label": "Upload picture", component: "span", onClick: o, "data-cy": "resetScale", children: /* @__PURE__ */ S(Pre, {}) })
      ] })
    ] })
  ] });
}
const Kzt = ({
  variable: e,
  value: t,
  selection: i,
  values: n,
  onChange: r
}) => {
  const g = n.find((A) => A.value == "1"), o = ie(DI), l = ie(sdt(g == null ? void 0 : g.id)), I = ie(bv("prints")).filter((A) => l.some((b) => b == A.targetMaterial)), c = Gt((A) => {
    const b = n.find((m) => m.variableId == e.id && m.value == (A != null && A.length ? "1" : "0"));
    r(b.id || 0, {
      url: A,
      leftright: Rl.leftright,
      topbottom: Rl.topbottom,
      scale: Rl.scale
    });
  }, [r, n, e.id]), d = Gt((A, b) => {
    var m;
    ((m = i.data) == null ? void 0 : m[A]) !== b && r(t.id, {
      ...i.data,
      [A]: b
    });
  }, [r, i, t]), C = Gt(() => {
    r(t.id, {
      ...i.data,
      ...Rl
    });
  }, [r, i, t]);
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ S(Lzt, { selection: i, app: o, handleImageChange: c, variable: e, printAreasAffectedByThisVariable: I, handleSliderChange: d, handleReset: C }) });
}, Tzt = Fo("imageUpload")(Kzt), Mzt = (e) => {
  const {
    text: t,
    onChange: i
  } = j1(e);
  return lt(() => {
    e.variable.description != t && i(e.variable.description || "");
  }, [e.variable.description, t, i]), /* @__PURE__ */ S(wg, { variable: e.variable, view: /* @__PURE__ */ S(li, {}) });
}, Pzt = Le.flow(ta, Fo("information"))(Mzt), Uzt = ({
  variable: e,
  onChange: t,
  selection: i,
  values: n,
  disabled: r
}) => {
  const g = ie(u0t), {
    onNumberChange: o,
    onInputBlur: l,
    isInRange: a,
    resetNumber: I,
    pureNumber: c
  } = hte(t, i, e, n);
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ S(Zte, { placement: g === wWe.Left ? "left-end" : "right-end", variable: e, isInRange: a, resetNumber: I, children: /* @__PURE__ */ S(
    O9,
    {
      "aria-label": e.label,
      fullWidth: !0,
      disabled: r,
      value: c,
      onChange: o,
      onChangeByStep: l,
      onBlur: l,
      onConfirm: l,
      TextFieldProps: {
        error: !a
      },
      ...Le.flow(Vi, Le.omit(["min", "max"]))(e),
      "data-cy": "numberInput"
    }
  ) }) });
}, zzt = Le.flow(ta, Fo("number"))(Uzt), Ozt = ["en", "de", "fr", "nl"], Qzt = [{
  hex: "#CDBA88",
  code: "1000",
  scope: "Classic",
  de: "Grünbeige",
  en: "Green beige",
  nl: "Groen-beige",
  fr: "Beige vert"
}, {
  hex: "#D0B084",
  code: "1001",
  scope: "Classic",
  de: "Beige",
  en: "Beige",
  nl: "Beige",
  fr: "Beige"
}, {
  hex: "#D2AA6D",
  code: "1002",
  scope: "Classic",
  de: "Sandgelb",
  en: "Sand yellow",
  nl: "Zandgeel",
  fr: "Jaune sable"
}, {
  hex: "#F9A900",
  code: "1003",
  scope: "Classic",
  de: "Signalgelb",
  en: "Signal yellow",
  nl: "Signaal geel",
  fr: "Jaune de signalisation"
}, {
  hex: "#E49E00",
  code: "1004",
  scope: "Classic",
  de: "Goldgelb",
  en: "Golden yellow",
  nl: "Goudgeel",
  fr: "Jaune d'or"
}, {
  hex: "#CB8F00",
  code: "1005",
  scope: "Classic",
  de: "Honiggelb",
  en: "Honey yellow",
  nl: "Honinggeel",
  fr: "Jaune miel"
}, {
  hex: "#E19000",
  code: "1006",
  scope: "Classic",
  de: "Maisgelb",
  en: "Maize yellow",
  nl: "Maïs geel",
  fr: "Jaune maïs"
}, {
  hex: "#E88C00",
  code: "1007",
  scope: "Classic",
  de: "Narzissengelb",
  en: "Daffodil yellow",
  nl: "Narcisgeel",
  fr: "Jaune jonquille"
}, {
  hex: "#AF8050",
  code: "1011",
  scope: "Classic",
  de: "Braunbeige",
  en: "Brown beige",
  nl: "Bruin-beige",
  fr: "Beige marron"
}, {
  hex: "#DDAF28",
  code: "1012",
  scope: "Classic",
  de: "Zitronengelb",
  en: "Lemon yellow",
  nl: "Citroengeel",
  fr: "Jaune citron"
}, {
  hex: "#E3D9C7",
  code: "1013",
  scope: "Classic",
  de: "Perlweiß",
  en: "Oyster white",
  nl: "Parelwit",
  fr: "Blanc perle"
}, {
  hex: "#DDC49B",
  code: "1014",
  scope: "Classic",
  de: "Elfenbein",
  en: "Ivory",
  nl: "Ivoor",
  fr: "Ivoire"
}, {
  hex: "#E6D2B5",
  code: "1015",
  scope: "Classic",
  de: "Hellelfenbein",
  en: "Light ivory",
  nl: "Licht ivoor",
  fr: "Ivoire clair"
}, {
  hex: "#F1DD39",
  code: "1016",
  scope: "Classic",
  de: "Schwefelgelb",
  en: "Sulfur yellow",
  nl: "Zwavelgeel",
  fr: "Jaune soufre"
}, {
  hex: "#F6A951",
  code: "1017",
  scope: "Classic",
  de: "Safrangelb",
  en: "Saffron yellow",
  nl: "Saffraangeel",
  fr: "Jaune safran"
}, {
  hex: "#FACA31",
  code: "1018",
  scope: "Classic",
  de: "Zinkgelb",
  en: "Zinc yellow",
  nl: "Zinkgeel",
  fr: "Jaune de zinc"
}, {
  hex: "#A48F7A",
  code: "1019",
  scope: "Classic",
  de: "Graubeige",
  en: "Grey beige",
  nl: "Grijs-beige",
  fr: "Beige gris"
}, {
  hex: "#A08F65",
  code: "1020",
  scope: "Classic",
  de: "Olivgelb",
  en: "Olive yellow",
  nl: "Olijfgeel",
  fr: "Jaune olive"
}, {
  hex: "#F6B600",
  code: "1021",
  scope: "Classic",
  de: "Rapsgelb",
  en: "Colza yellow",
  nl: "Koolzaad geel",
  fr: "Jaune colza"
}, {
  hex: "#F7B500",
  code: "1023",
  scope: "Classic",
  de: "Verkehrsgelb",
  en: "Traffic yellow",
  nl: "Verkeer geel",
  fr: "Jaune trafic"
}, {
  hex: "#BA8F4C",
  code: "1024",
  scope: "Classic",
  de: "Ockergelb",
  en: "Ochre yellow",
  nl: "Okergeel",
  fr: "Jaune ocre"
}, {
  hex: "#FFFF00",
  code: "1026",
  scope: "Classic",
  de: "Leuchtgelb",
  en: "Luminous yellow",
  nl: "Fluorescerend geel",
  fr: "Jaune vif"
}, {
  hex: "#A77F0F",
  code: "1027",
  scope: "Classic",
  de: "Currygelb",
  en: "Curry",
  nl: "Kerrie geel",
  fr: "Jaune curry"
}, {
  hex: "#FF9C00",
  code: "1028",
  scope: "Classic",
  de: "Melonengelb",
  en: "Melon yellow",
  nl: "Meloengeel",
  fr: "Jaune melon"
}, {
  hex: "#E2A300",
  code: "1032",
  scope: "Classic",
  de: "Ginstergelb",
  en: "Broom yellow",
  nl: "Bezem geel",
  fr: "Jaune genêt"
}, {
  hex: "#F99A1D",
  code: "1033",
  scope: "Classic",
  de: "Dahliengelb",
  en: "Dahlia yellow",
  nl: "Dahlia geel",
  fr: "Jaune dahlia"
}, {
  hex: "#EB9C52",
  code: "1034",
  scope: "Classic",
  de: "Pastellgelb",
  en: "Pastel yellow",
  nl: "Pastelgeel",
  fr: "Jaune pastel"
}, {
  hex: "#8F8370",
  code: "1035",
  scope: "Classic",
  de: "Perlbeige",
  en: "Pearl beige",
  nl: "Parel beige",
  fr: "Beige perle"
}, {
  hex: "#806440",
  code: "1036",
  scope: "Classic",
  de: "Perlgold",
  en: "Pearl gold",
  nl: "Parel goud",
  fr: "Or perlé"
}, {
  hex: "#F09200",
  code: "1037",
  scope: "Classic",
  de: "Sonnengelb",
  en: "Sun yellow",
  nl: "Zonnegeel",
  fr: "Jaune soleil"
}, {
  hex: "#DA6E00",
  code: "2000",
  scope: "Classic",
  de: "Gelborange",
  en: "Yellow orange",
  nl: "Geeloranje",
  fr: "Jaune-orange"
}, {
  hex: "#BA481C",
  code: "2001",
  scope: "Classic",
  de: "Rotorange",
  en: "Red orange",
  nl: "Rood oranje",
  fr: "Orange rouge"
}, {
  hex: "#BF3922",
  code: "2002",
  scope: "Classic",
  de: "Blutorange",
  en: "Vermilion",
  nl: "Bloedsinaasappel",
  fr: "Orange sanguine"
}, {
  hex: "#F67829",
  code: "2003",
  scope: "Classic",
  de: "Pastellorange",
  en: "Pastel orange",
  nl: "Pastel oranje",
  fr: "Orange pastel"
}, {
  hex: "#E25304",
  code: "2004",
  scope: "Classic",
  de: "Reinorange",
  en: "Pure orange",
  nl: "Puur oranje",
  fr: "Orange pure"
}, {
  hex: "#FF4D08",
  code: "2005",
  scope: "Classic",
  de: "Leuchtorange",
  en: "Luminous orange",
  nl: "Fluorescerend oranje",
  fr: "Orange vif"
}, {
  hex: "#FFB200",
  code: "2007",
  scope: "Classic",
  de: "Leuchthellorange",
  en: "Luminous bright orange",
  nl: "Fluorescerend licht oranje",
  fr: "Orange clair lumineux"
}, {
  hex: "#EC6B22",
  code: "2008",
  scope: "Classic",
  de: "Hellrotorange",
  en: "Bright red orange",
  nl: "Licht rood-oranje",
  fr: "Orange clair"
}, {
  hex: "#DE5308",
  code: "2009",
  scope: "Classic",
  de: "Verkehrsorange",
  en: "Traffic orange",
  nl: "Verkeer oranje",
  fr: "Orange trafic"
}, {
  hex: "#D05D29",
  code: "2010",
  scope: "Classic",
  de: "Signalorange",
  en: "Signal orange",
  nl: "Signaal oranje",
  fr: "Orange de signalisation"
}, {
  hex: "#E26E0F",
  code: "2011",
  scope: "Classic",
  de: "Tieforange",
  en: "Deep orange",
  nl: "Diep oranje",
  fr: "Orange profond"
}, {
  hex: "#D5654E",
  code: "2012",
  scope: "Classic",
  de: "Lachsorange",
  en: "Salmon orange",
  nl: "Zalm oranje",
  fr: "Orange saumon"
}, {
  hex: "#923E25",
  code: "2013",
  scope: "Classic",
  de: "Perlorange",
  en: "Pearl orange",
  nl: "Parel oranje",
  fr: "Orange perle"
}, {
  hex: "#FC5500",
  code: "2017",
  scope: "Classic",
  de: "RAL Orange",
  en: "RAL orange",
  nl: "RAL Oranje",
  fr: "RAL orange"
}, {
  hex: "#A72920",
  code: "3000",
  scope: "Classic",
  de: "Feuerrot",
  en: "Flame red",
  nl: "Vuurrood",
  fr: "Rouge feu"
}, {
  hex: "#9B2423",
  code: "3001",
  scope: "Classic",
  de: "Signalrot",
  en: "Signal red",
  nl: "Signaal rood",
  fr: "Rouge de signalisation"
}, {
  hex: "#9B2321",
  code: "3002",
  scope: "Classic",
  de: "Karminrot",
  en: "Carmine red",
  nl: "Karmijnrood",
  fr: "Rouge carmin"
}, {
  hex: "#861A22",
  code: "3003",
  scope: "Classic",
  de: "Rubinrot",
  en: "Ruby red",
  nl: "Robijnrood",
  fr: "Rouge rubis"
}, {
  hex: "#6B1C23",
  code: "3004",
  scope: "Classic",
  de: "Purpurrot",
  en: "Purple red",
  nl: "Paars rood",
  fr: "Rouge pourpre"
}, {
  hex: "#59191F",
  code: "3005",
  scope: "Classic",
  de: "Weinrot",
  en: "Wine red",
  nl: "Wijn rood",
  fr: "Rouge vin"
}, {
  hex: "#3E2022",
  code: "3007",
  scope: "Classic",
  de: "Schwarzrot",
  en: "Black red",
  nl: "Zwart rood",
  fr: "Rouge noir"
}, {
  hex: "#6D342D",
  code: "3009",
  scope: "Classic",
  de: "Oxidrot",
  en: "Oxide red",
  nl: "Oxydrood",
  fr: "Rouge oxyde"
}, {
  hex: "#782423",
  code: "3011",
  scope: "Classic",
  de: "Braunrot",
  en: "Brown red",
  nl: "Bruin rood",
  fr: "Marron rouge"
}, {
  hex: "#C5856D",
  code: "3012",
  scope: "Classic",
  de: "Beigerot",
  en: "Beige red",
  nl: "Beige rood",
  fr: "Beigerot"
}, {
  hex: "#972E25",
  code: "3013",
  scope: "Classic",
  de: "Tomatenrot",
  en: "Tomato red",
  nl: "Tomaat rood",
  fr: "Rouge tomate"
}, {
  hex: "#CB7375",
  code: "3014",
  scope: "Classic",
  de: "Altrosa",
  en: "Antique pink",
  nl: "Donkerroze",
  fr: "Vieux rose"
}, {
  hex: "#D8A0A6",
  code: "3015",
  scope: "Classic",
  de: "Hellrosa",
  en: "Light pink",
  nl: "Lichtroze",
  fr: "Rose clair"
}, {
  hex: "#A63D30",
  code: "3016",
  scope: "Classic",
  de: "Korallenrot",
  en: "Coral red",
  nl: "Koraalrood",
  fr: "Rouge corail"
}, {
  hex: "#CA555D",
  code: "3017",
  scope: "Classic",
  de: "Rosé",
  en: "Rose",
  nl: "Rosé",
  fr: "Rosé"
}, {
  hex: "#C63F4A",
  code: "3018",
  scope: "Classic",
  de: "Erdbeerrot",
  en: "Strawberry red",
  nl: "Aardbeirood",
  fr: "Rouge fraise"
}, {
  hex: "#BB1F11",
  code: "3020",
  scope: "Classic",
  de: "Verkehrsrot",
  en: "Traffic red",
  nl: "Verkeer rood",
  fr: "Rouge trafic"
}, {
  hex: "#CF6955",
  code: "3022",
  scope: "Classic",
  de: "Lachsrot",
  en: "Salmon pink",
  nl: "Zalmrood",
  fr: "Rouge saumon"
}, {
  hex: "#FF2D21",
  code: "3024",
  scope: "Classic",
  de: "Leuchtrot",
  en: "Luminous red",
  nl: "Fluorescerend rood",
  fr: "Rouge vif"
}, {
  hex: "#FF2A1C",
  code: "3026",
  scope: "Classic",
  de: "Leuchthellrot",
  en: "Luminous bright red",
  nl: "Helder rood",
  fr: "Rouge clair lumineux"
}, {
  hex: "#AB273C",
  code: "3027",
  scope: "Classic",
  de: "Himbeerrot",
  en: "Raspberry red",
  nl: "Framboos rood",
  fr: "Rouge framboise"
}, {
  hex: "#CC2C24",
  code: "3028",
  scope: "Classic",
  de: "Reinrot",
  en: "Pure red",
  nl: "Puur rood",
  fr: "Rouge pur"
}, {
  hex: "#A63437",
  code: "3031",
  scope: "Classic",
  de: "Orientrot",
  en: "Orient red",
  nl: "Oriënt rood",
  fr: "Rouge d'Orient"
}, {
  hex: "#701D24",
  code: "3032",
  scope: "Classic",
  de: "Perlrubinrot",
  en: "Pearl ruby red",
  nl: "Parel robijnrood",
  fr: "Rouge rubis perle"
}, {
  hex: "#A53A2E",
  code: "3033",
  scope: "Classic",
  de: "Perlrosa",
  en: "Pearl pink",
  nl: "Parelmoer roze",
  fr: "Rose perle"
}, {
  hex: "#816183",
  code: "4001",
  scope: "Classic",
  de: "Rotlila",
  en: "Red lilac",
  nl: "Roodpaars",
  fr: "Violet rouge"
}, {
  hex: "#8D3C4B",
  code: "4002",
  scope: "Classic",
  de: "Rotviolett",
  en: "Red violet",
  nl: "Roodviolet",
  fr: "Rouge-violet"
}, {
  hex: "#C4618C",
  code: "4003",
  scope: "Classic",
  de: "Erikaviolett",
  en: "Heather violet",
  nl: "Erika violet",
  fr: "Violet d'Erika"
}, {
  hex: "#651E38",
  code: "4004",
  scope: "Classic",
  de: "Bordeauxviolett",
  en: "Claret violet",
  nl: "Bordeaux viooltje",
  fr: "Violet bordeaux"
}, {
  hex: "#76689A",
  code: "4005",
  scope: "Classic",
  de: "Blaulila",
  en: "Blue lilac",
  nl: "Blauwpaars",
  fr: "Blaulila"
}, {
  hex: "#903373",
  code: "4006",
  scope: "Classic",
  de: "Verkehrspurpur",
  en: "Traffic purple",
  nl: "Rijbaan",
  fr: "Voie de circulation"
}, {
  hex: "#47243C",
  code: "4007",
  scope: "Classic",
  de: "Purpurviolett",
  en: "Purple violet",
  nl: "Paars viooltje",
  fr: "Violet pourpre"
}, {
  hex: "#844C82",
  code: "4008",
  scope: "Classic",
  de: "Signalviolett",
  en: "Signal violet",
  nl: "Signaal violet",
  fr: "Violet de signalisation"
}, {
  hex: "#9D8692",
  code: "4009",
  scope: "Classic",
  de: "Pastellviolett",
  en: "Pastel violet",
  nl: "Pastelviolet",
  fr: "Violet pastel"
}, {
  hex: "#BB4077",
  code: "4010",
  scope: "Classic",
  de: "Telemagenta",
  en: "Telemagenta",
  nl: "Telemagenta",
  fr: "Telemagenta"
}, {
  hex: "#6E6387",
  code: "4011",
  scope: "Classic",
  de: "Perlviolett",
  en: "Pearl violet",
  nl: "Parelviolet",
  fr: "Violet perlé"
}, {
  hex: "#6A6B7F",
  code: "4012",
  scope: "Classic",
  de: "Perlbrombeer",
  en: "Pearl blackberry",
  nl: "Parel braam",
  fr: "Mûre perlée"
}, {
  hex: "#304F6E",
  code: "5000",
  scope: "Classic",
  de: "Violettblau",
  en: "Violet blue",
  nl: "Violetblauw",
  fr: "Bleu violet"
}, {
  hex: "#0E4C64",
  code: "5001",
  scope: "Classic",
  de: "Grünblau",
  en: "Green blue",
  nl: "Groenblauw",
  fr: "Bleu vert"
}, {
  hex: "#00387A",
  code: "5002",
  scope: "Classic",
  de: "Ultramarinblau",
  en: "Ultramarine blue",
  nl: "Ultramarijnblauw",
  fr: "Bleu outremer"
}, {
  hex: "#1F3855",
  code: "5003",
  scope: "Classic",
  de: "Saphirblau",
  en: "Sapphire blue",
  nl: "Saffierblauw",
  fr: "Bleu saphir"
}, {
  hex: "#191E28",
  code: "5004",
  scope: "Classic",
  de: "Schwarzblau",
  en: "Black blue",
  nl: "Zwartblauw",
  fr: "Bleu noir"
}, {
  hex: "#005387",
  code: "5005",
  scope: "Classic",
  de: "Signalblau",
  en: "Signal blue",
  nl: "Signaal blauw",
  fr: "Bleu signal"
}, {
  hex: "#376B8C",
  code: "5007",
  scope: "Classic",
  de: "Brillantblau",
  en: "Brillant blue",
  nl: "Schitterend blauw",
  fr: "Bleu brillant"
}, {
  hex: "#2B3A44",
  code: "5008",
  scope: "Classic",
  de: "Graublau",
  en: "Grey blue",
  nl: "Grijsblauw",
  fr: "Bleu gris"
}, {
  hex: "#215F78",
  code: "5009",
  scope: "Classic",
  de: "Azurblau",
  en: "Azure blue",
  nl: "Azuurblauw",
  fr: "Bleu azur"
}, {
  hex: "#004F7C",
  code: "5010",
  scope: "Classic",
  de: "Enzianblau",
  en: "Gentian blue",
  nl: "Gentiaanblauw",
  fr: "Bleu gentiane"
}, {
  hex: "#1A2B3C",
  code: "5011",
  scope: "Classic",
  de: "Stahlblau",
  en: "Steel blue",
  nl: "Staalblauw",
  fr: "Bleu acier"
}, {
  hex: "#0089B6",
  code: "5012",
  scope: "Classic",
  de: "Lichtblau",
  en: "Light blue",
  nl: "Lichtblauw",
  fr: "Bleu clair"
}, {
  hex: "#193153",
  code: "5013",
  scope: "Classic",
  de: "Kobaltblau",
  en: "Cobalt blue",
  nl: "Kobaltblauw",
  fr: "Bleu cobalt"
}, {
  hex: "#637D96",
  code: "5014",
  scope: "Classic",
  de: "Taubenblau",
  en: "Pigeon blue",
  nl: "Duif blauw",
  fr: "Bleu pigeon"
}, {
  hex: "#007CAF",
  code: "5015",
  scope: "Classic",
  de: "Himmelblau",
  en: "Sky blue",
  nl: "Hemelsblauw",
  fr: "Bleu ciel"
}, {
  hex: "#005B8C",
  code: "5017",
  scope: "Classic",
  de: "Verkehrsblau",
  en: "Traffic blue",
  nl: "Verkeersblauw",
  fr: "Bleu trafic"
}, {
  hex: "#048B8C",
  code: "5018",
  scope: "Classic",
  de: "Türkisblau",
  en: "Turquoise blue",
  nl: "Turquoise blauw",
  fr: "Bleu turquoise"
}, {
  hex: "#005E83",
  code: "5019",
  scope: "Classic",
  de: "Capriblau",
  en: "Capri blue",
  nl: "Capri blauw",
  fr: "Bleu capri"
}, {
  hex: "#00414B",
  code: "5020",
  scope: "Classic",
  de: "Ozeanblau",
  en: "Ocean blue",
  nl: "Oceaanblauw",
  fr: "Bleu océan"
}, {
  hex: "#007577",
  code: "5021",
  scope: "Classic",
  de: "Wasserblau",
  en: "Water blue",
  nl: "Waterblauw",
  fr: "Bleu d'eau"
}, {
  hex: "#222D5A",
  code: "5022",
  scope: "Classic",
  de: "Nachtblau",
  en: "Night blue",
  nl: "Nachtblauw",
  fr: "Bleu nuit"
}, {
  hex: "#41698C",
  code: "5023",
  scope: "Classic",
  de: "Fernblau",
  en: "Distant blue",
  nl: "Ver blauw",
  fr: "Bleu lointain"
}, {
  hex: "#6093AC",
  code: "5024",
  scope: "Classic",
  de: "Pastellblau",
  en: "Pastel blue",
  nl: "Pastelblauw",
  fr: "Bleu pastel"
}, {
  hex: "#20697C",
  code: "5025",
  scope: "Classic",
  de: "Perlenzian",
  en: "Pearl gentian blue",
  nl: "Parelgentiaan",
  fr: "Gentiane perlée"
}, {
  hex: "#0F3052",
  code: "5026",
  scope: "Classic",
  de: "Perlnachtblau",
  en: "Pearl night blue",
  nl: "Parel nachtblauw",
  fr: "Bleu nuit perle"
}, {
  hex: "#3C7460",
  code: "6000",
  scope: "Classic",
  de: "Patinagrün",
  en: "Patina green",
  nl: "Patinagroen",
  fr: "Vert patine"
}, {
  hex: "#366735",
  code: "6001",
  scope: "Classic",
  de: "Smaragdgrün",
  en: "Emerald green",
  nl: "Smaragdgroen",
  fr: "Vert émeraude"
}, {
  hex: "#325928",
  code: "6002",
  scope: "Classic",
  de: "Laubgrün",
  en: "Leaf green",
  nl: "Bladgroen",
  fr: "Vert feuillage"
}, {
  hex: "#50533C",
  code: "6003",
  scope: "Classic",
  de: "Olivgrün",
  en: "Olive green",
  nl: "Olijfgroen",
  fr: "Vert olive"
}, {
  hex: "#024442",
  code: "6004",
  scope: "Classic",
  de: "Blaugrün",
  en: "Blue green",
  nl: "Blauwgroen",
  fr: "Bleu-vert"
}, {
  hex: "#114232",
  code: "6005",
  scope: "Classic",
  de: "Moosgrün",
  en: "Moss green",
  nl: "Mosgroen",
  fr: "Vert mousse"
}, {
  hex: "#3C392E",
  code: "6006",
  scope: "Classic",
  de: "Grauoliv",
  en: "Grey olive",
  nl: "Grijze olijf",
  fr: "Gris olive"
}, {
  hex: "#2C3222",
  code: "6007",
  scope: "Classic",
  de: "Flaschengrün",
  en: "Bottle green",
  nl: "Fles groen",
  fr: "Vert bouteille"
}, {
  hex: "#36342A",
  code: "6008",
  scope: "Classic",
  de: "Braungrün",
  en: "Brown green",
  nl: "Bruin-groen",
  fr: "Vert marron"
}, {
  hex: "#27352A",
  code: "6009",
  scope: "Classic",
  de: "Tannengrün",
  en: "Fir green",
  nl: "Dennengroen",
  fr: "Vert sapin"
}, {
  hex: "#4D6F39",
  code: "6010",
  scope: "Classic",
  de: "Grasgrün",
  en: "Grass green",
  nl: "Grasgroen",
  fr: "Vert herbe"
}, {
  hex: "#6B7C59",
  code: "6011",
  scope: "Classic",
  de: "Resedagrün",
  en: "Reseda green",
  nl: "Reseda groen",
  fr: "Vert réséda"
}, {
  hex: "#2F3D3A",
  code: "6012",
  scope: "Classic",
  de: "Schwarzgrün",
  en: "Black green",
  nl: "Zwartgroen",
  fr: "Vert noir"
}, {
  hex: "#7C765A",
  code: "6013",
  scope: "Classic",
  de: "Schilfgrün",
  en: "Reed green",
  nl: "Rietgroen",
  fr: "Le vert des roseaux"
}, {
  hex: "#474135",
  code: "6014",
  scope: "Classic",
  de: "Gelboliv",
  en: "Yellow olive",
  nl: "Gele olijf",
  fr: "Jaune bolivien"
}, {
  hex: "#3D3D36",
  code: "6015",
  scope: "Classic",
  de: "Schwarzoliv",
  en: "Black olive",
  nl: "Zwarte olijf",
  fr: "olive noir"
}, {
  hex: "#00694C",
  code: "6016",
  scope: "Classic",
  de: "Türkisgrün",
  en: "Turquoise green",
  nl: "Turquoise groen",
  fr: "Vert turquoise"
}, {
  hex: "#587F40",
  code: "6017",
  scope: "Classic",
  de: "Maigrün",
  en: "May green",
  nl: "Mei groen",
  fr: "Vert mai"
}, {
  hex: "#60993B",
  code: "6018",
  scope: "Classic",
  de: "Gelbgrün",
  en: "Yellow green",
  nl: "Geelgroen",
  fr: "Vert jaune"
}, {
  hex: "#B9CEAC",
  code: "6019",
  scope: "Classic",
  de: "Weißgrün",
  en: "Pastel green",
  nl: "Witgroen",
  fr: "Vert blanc"
}, {
  hex: "#37422F",
  code: "6020",
  scope: "Classic",
  de: "Chromoxidgrün",
  en: "Chrome green",
  nl: "Chroomoxidegroen",
  fr: "Vert oxyde de chrome"
}, {
  hex: "#8A9977",
  code: "6021",
  scope: "Classic",
  de: "Blaßgrün",
  en: "Pale green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#3A3327",
  code: "6022",
  scope: "Classic",
  de: "Braunoliv",
  en: "Olive drab",
  nl: "Bruine olijf",
  fr: "Marron olive"
}, {
  hex: "#008351",
  code: "6024",
  scope: "Classic",
  de: "Verkehrsgrün",
  en: "Traffic green",
  nl: "Verkeer groen",
  fr: "Espaces verts de circulation"
}, {
  hex: "#5E6E3B",
  code: "6025",
  scope: "Classic",
  de: "Farngrün",
  en: "Fern green",
  nl: "Varen groen",
  fr: "Vert fougère"
}, {
  hex: "#005F4E",
  code: "6026",
  scope: "Classic",
  de: "Opalgrün",
  en: "Opal green",
  nl: "Opaalgroen",
  fr: "Vert opale"
}, {
  hex: "#7EBAB5",
  code: "6027",
  scope: "Classic",
  de: "Lichtgrün",
  en: "Light green",
  nl: "Lichtgroen",
  fr: "Vert clair"
}, {
  hex: "#315442",
  code: "6028",
  scope: "Classic",
  de: "Kieferngrün",
  en: "Pine green",
  nl: "Dennengroen",
  fr: "Vert pin"
}, {
  hex: "#006F3D",
  code: "6029",
  scope: "Classic",
  de: "Minzgrün",
  en: "Mint green",
  nl: "Mintgroen",
  fr: "Vert menthe"
}, {
  hex: "#237F52",
  code: "6032",
  scope: "Classic",
  de: "Signalgrün",
  en: "Signal green",
  nl: "Signaal groen",
  fr: "Vert signal"
}, {
  hex: "#45877F",
  code: "6033",
  scope: "Classic",
  de: "Minttürkis",
  en: "Mint turquoise",
  nl: "Mint turkoois",
  fr: "Turquoise menthe"
}, {
  hex: "#7AADAC",
  code: "6034",
  scope: "Classic",
  de: "Pastelltürkis",
  en: "Pastel turquoise",
  nl: "Pastelturquoise",
  fr: "Turquoise pastel"
}, {
  hex: "#194D25",
  code: "6035",
  scope: "Classic",
  de: "Perlgrün",
  en: "Pearl green",
  nl: "Parelgroen",
  fr: "Vert perle"
}, {
  hex: "#04574B",
  code: "6036",
  scope: "Classic",
  de: "Perlopalgrün",
  en: "Pearl opal green",
  nl: "Parel opaalgroen",
  fr: "Vert perlopal"
}, {
  hex: "#008B29",
  code: "6037",
  scope: "Classic",
  de: "Reingrün",
  en: "Pure green",
  nl: "Puur groen",
  fr: "Vert pur"
}, {
  hex: "#00B51B",
  code: "6038",
  scope: "Classic",
  de: "Leuchtgrün",
  en: "Luminous green ",
  nl: "Fluorescerend groen",
  fr: "Vert fluo"
}, {
  hex: "#B3C43E",
  code: "6039",
  scope: "Classic",
  de: "Fasergrün",
  en: "Fibrous green",
  nl: "Vezel groen",
  fr: "Fibre verte"
}, {
  hex: "#7A888E",
  code: "7000",
  scope: "Classic",
  de: "Fehgrau",
  en: "Squirrel grey",
  nl: "Feh grijs",
  fr: "Fehgrau"
}, {
  hex: "#8C979C",
  code: "7001",
  scope: "Classic",
  de: "Silbergrau",
  en: "Silver grey",
  nl: "Zilvergrijs",
  fr: "Gris argenté"
}, {
  hex: "#817863",
  code: "7002",
  scope: "Classic",
  de: "Olivgrau",
  en: "Olive grey",
  nl: "Olijfgrijs",
  fr: "Gris olive"
}, {
  hex: "#797669",
  code: "7003",
  scope: "Classic",
  de: "Moosgrau",
  en: "Moss grey",
  nl: "Mosgrijs",
  fr: "Gris mousse"
}, {
  hex: "#9A9B9B",
  code: "7004",
  scope: "Classic",
  de: "Signalgrau",
  en: "Signal grey",
  nl: "Signaal grijs",
  fr: "Gris signal"
}, {
  hex: "#6B6E6B",
  code: "7005",
  scope: "Classic",
  de: "Mausgrau",
  en: "Mouse grey",
  nl: "Muis grijs",
  fr: "Gris souris"
}, {
  hex: "#766A5E",
  code: "7006",
  scope: "Classic",
  de: "Beigegrau",
  en: "Beige grey",
  nl: "Beige grijs",
  fr: "Gris beige"
}, {
  hex: "#745F3D",
  code: "7008",
  scope: "Classic",
  de: "Khakigrau",
  en: "Khaki grey",
  nl: "Kaki grijs",
  fr: "Gris kaki"
}, {
  hex: "#5D6058",
  code: "7009",
  scope: "Classic",
  de: "Grüngrau",
  en: "Green grey",
  nl: "Groen-grijs",
  fr: "Gris vert"
}, {
  hex: "#585C56",
  code: "7010",
  scope: "Classic",
  de: "Zeltgrau",
  en: "Tarpaulin grey",
  nl: "Tent grijs",
  fr: "Gris tente"
}, {
  hex: "#52595D",
  code: "7011",
  scope: "Classic",
  de: "Eisengrau",
  en: "Iron grey",
  nl: "IJzergrijs",
  fr: "Gris fer"
}, {
  hex: "#575D5E",
  code: "7012",
  scope: "Classic",
  de: "Basaltgrau",
  en: "Basalt grey",
  nl: "Basalt grijs",
  fr: "Gris basalte"
}, {
  hex: "#575044",
  code: "7013",
  scope: "Classic",
  de: "Braungrau",
  en: "Brown grey",
  nl: "Bruin-grijs",
  fr: "Gris marron"
}, {
  hex: "#4F5358",
  code: "7015",
  scope: "Classic",
  de: "Schiefergrau",
  en: "Slate grey",
  nl: "Leigrijs",
  fr: "Gris ardoise"
}, {
  hex: "#383E42",
  code: "7016",
  scope: "Classic",
  de: "Anthrazitgrau",
  en: "Anthracite grey",
  nl: "Antraciet grijs",
  fr: "Gris anthracite"
}, {
  hex: "#2F3234",
  code: "7021",
  scope: "Classic",
  de: "Schwarzgrau",
  en: "Black grey",
  nl: "Zwart grijs",
  fr: "Gris noir"
}, {
  hex: "#4C4A44",
  code: "7022",
  scope: "Classic",
  de: "Umbragrau",
  en: "Umbra grey",
  nl: "Umbra grijs",
  fr: "Gris terre d'ombre"
}, {
  hex: "#808076",
  code: "7023",
  scope: "Classic",
  de: "Betongrau",
  en: "Concrete grey",
  nl: "Beton grijs",
  fr: "Gris béton"
}, {
  hex: "#45494E",
  code: "7024",
  scope: "Classic",
  de: "Graphitgrau",
  en: "Graphite grey",
  nl: "Grafietgrijs",
  fr: "Gris graphite"
}, {
  hex: "#374345",
  code: "7026",
  scope: "Classic",
  de: "Granitgrau",
  en: "Granite grey",
  nl: "Granietgrijs",
  fr: "Gris granit"
}, {
  hex: "#928E85",
  code: "7030",
  scope: "Classic",
  de: "Steingrau",
  en: "Stone grey",
  nl: "Steengrijs",
  fr: "Gris pierre"
}, {
  hex: "#5B686D",
  code: "7031",
  scope: "Classic",
  de: "Blaugrau",
  en: "Blue grey",
  nl: "Blauwgrijs",
  fr: "Bleu-gris"
}, {
  hex: "#B5B0A1",
  code: "7032",
  scope: "Classic",
  de: "Kieselgrau",
  en: "Pebble grey",
  nl: "Kiezelgrijs",
  fr: "Gris silex"
}, {
  hex: "#7F8274",
  code: "7033",
  scope: "Classic",
  de: "Zementgrau",
  en: "Cement grey",
  nl: "Cementgrijs",
  fr: "Gris ciment"
}, {
  hex: "#92886F",
  code: "7034",
  scope: "Classic",
  de: "Gelbgrau",
  en: "Yellow grey",
  nl: "Geelgrijs",
  fr: "Gris jaune"
}, {
  hex: "#C5C7C4",
  code: "7035",
  scope: "Classic",
  de: "Lichtgrau",
  en: "Light grey",
  nl: "Lichtgrijs",
  fr: "Gris clair"
}, {
  hex: "#979392",
  code: "7036",
  scope: "Classic",
  de: "Platingrau",
  en: "Platinum grey",
  nl: "Platina grijs",
  fr: "Gris platine"
}, {
  hex: "#7A7B7A",
  code: "7037",
  scope: "Classic",
  de: "Staubgrau",
  en: "Dusty grey",
  nl: "Stof grijs",
  fr: "Gris poussière"
}, {
  hex: "#B0B0A9",
  code: "7038",
  scope: "Classic",
  de: "Achatgrau",
  en: "Agate grey",
  nl: "Agaat grijs",
  fr: "Gris agate"
}, {
  hex: "#6B665E",
  code: "7039",
  scope: "Classic",
  de: "Quarzgrau",
  en: "Quartz grey",
  nl: "Kwartsgrijs",
  fr: "Gris quartz"
}, {
  hex: "#989EA1",
  code: "7040",
  scope: "Classic",
  de: "Fenstergrau",
  en: "Window grey",
  nl: "Raam grijs",
  fr: "Gris fenêtre"
}, {
  hex: "#8E9291",
  code: "7042",
  scope: "Classic",
  de: "Verkehrsgrau A",
  en: "Traffic grey A",
  nl: "Verkeer grijs A",
  fr: "Gris trafic A"
}, {
  hex: "#4F5250",
  code: "7043",
  scope: "Classic",
  de: "Verkehrsgrau B",
  en: "Traffic grey B",
  nl: "Verkeer grijs B",
  fr: "Gris trafic B"
}, {
  hex: "#B7B3A8",
  code: "7044",
  scope: "Classic",
  de: "Seidengrau",
  en: "Silk grey",
  nl: "Zijde grijs",
  fr: "Gris soie"
}, {
  hex: "#8D9295",
  code: "7045",
  scope: "Classic",
  de: "Telegrau 1",
  en: "Telegrey 1",
  nl: "Telegrafeer 1",
  fr: "Telegrau 1"
}, {
  hex: "#7E868A",
  code: "7046",
  scope: "Classic",
  de: "Telegrau 2",
  en: "Telegrey 2",
  nl: "Telegrey 2",
  fr: "Telegrau 2"
}, {
  hex: "#C8C8C7",
  code: "7047",
  scope: "Classic",
  de: "Telegrau 4",
  en: "Telegrey 4",
  nl: "Telegrey 4",
  fr: "Telegrau 4"
}, {
  hex: "#817B73",
  code: "7048",
  scope: "Classic",
  de: "Perlmausgrau",
  en: "Pearl mouse grey",
  nl: "Parel muisgrijs",
  fr: "Gris perle"
}, {
  hex: "#89693F",
  code: "8000",
  scope: "Classic",
  de: "Grünbraun",
  en: "Green brown",
  nl: "Groen-bruin",
  fr: "Marron vert"
}, {
  hex: "#9D622B",
  code: "8001",
  scope: "Classic",
  de: "Ockerbraun",
  en: "Ochre brown",
  nl: "Okerbruin",
  fr: "Marron ocre"
}, {
  hex: "#794D3E",
  code: "8002",
  scope: "Classic",
  de: "Signalbraun",
  en: "Signal brown",
  nl: "Signaal bruin",
  fr: "Marron de signalisation"
}, {
  hex: "#7E4B27",
  code: "8003",
  scope: "Classic",
  de: "Lehmbraun",
  en: "Clay brown",
  nl: "Klei bruin",
  fr: "Marron argile"
}, {
  hex: "#8D4931",
  code: "8004",
  scope: "Classic",
  de: "Kupferbraun",
  en: "Copper brown",
  nl: "Koperbruin",
  fr: "Marron cuivré"
}, {
  hex: "#70462B",
  code: "8007",
  scope: "Classic",
  de: "Rehbraun",
  en: "Fawn brown",
  nl: "Fawn",
  fr: "Marron chevreuil"
}, {
  hex: "#724A25",
  code: "8008",
  scope: "Classic",
  de: "Olivbraun",
  en: "Olive brown",
  nl: "Olijfbruin",
  fr: "Marron olive"
}, {
  hex: "#5A3827",
  code: "8011",
  scope: "Classic",
  de: "Nußbraun",
  en: "Nut brown",
  nl: "Notenbruin",
  fr: "Marron noisette"
}, {
  hex: "#66332B",
  code: "8012",
  scope: "Classic",
  de: "Rotbraun",
  en: "Red brown",
  nl: "Roodbruin",
  fr: "Marron rouge"
}, {
  hex: "#4A3526",
  code: "8014",
  scope: "Classic",
  de: "Sepiabraun",
  en: "Sepia brown",
  nl: "Sepia bruin",
  fr: "Brun sépia"
}, {
  hex: "#5E2F26",
  code: "8015",
  scope: "Classic",
  de: "Kastanienbraun",
  en: "Chestnut brown",
  nl: "Kastanjebruin",
  fr: "Châtaigne"
}, {
  hex: "#4C2B20",
  code: "8016",
  scope: "Classic",
  de: "Mahagonibraun",
  en: "Mahogany brown",
  nl: "Mahoniebruin",
  fr: "Brun acajou"
}, {
  hex: "#442F29",
  code: "8017",
  scope: "Classic",
  de: "Schokoladenbraun",
  en: "Chocolate brown",
  nl: "Chocoladebruin",
  fr: "Marron chocolat"
}, {
  hex: "#3D3635",
  code: "8019",
  scope: "Classic",
  de: "Graubraun",
  en: "Grey brown",
  nl: "Grijsbruin",
  fr: "Marron gris"
}, {
  hex: "#1A1719",
  code: "8022",
  scope: "Classic",
  de: "Schwarzbraun",
  en: "Black brown",
  nl: "Zwartbruin",
  fr: "Marron noir"
}, {
  hex: "#A45729",
  code: "8023",
  scope: "Classic",
  de: "Orangebraun",
  en: "Orange brown",
  nl: "Oranjebruin",
  fr: "Marron orange"
}, {
  hex: "#795038",
  code: "8024",
  scope: "Classic",
  de: "Beigebraun",
  en: "Beige brown",
  nl: "Beige bruin",
  fr: "Beige-brun"
}, {
  hex: "#755847",
  code: "8025",
  scope: "Classic",
  de: "Blaßbraun",
  en: "Pale brown",
  nl: "Lichtbruin",
  fr: "Marron pâle"
}, {
  hex: "#513A2A",
  code: "8028",
  scope: "Classic",
  de: "Terrabraun",
  en: "Terra brown",
  nl: "Terra bruin",
  fr: "Brun terra"
}, {
  hex: "#7F4031",
  code: "8029",
  scope: "Classic",
  de: "Perlkupfer",
  en: "Pearl copper",
  nl: "Parel koper",
  fr: "Cuivre nacré"
}, {
  hex: "#E9E0D2",
  code: "9001",
  scope: "Classic",
  de: "Cremeweiß",
  en: "Cream",
  nl: "Crème wit",
  fr: "Blanc crème"
}, {
  hex: "#D6D5CB",
  code: "9002",
  scope: "Classic",
  de: "Grauweiß",
  en: "Grey white",
  nl: "Grijs wit",
  fr: "Blanc gris"
}, {
  hex: "#ECECE7",
  code: "9003",
  scope: "Classic",
  de: "Signalweiß",
  en: "Signal white",
  nl: "Signaal wit",
  fr: "Blanc de signalisation"
}, {
  hex: "#2B2B2C",
  code: "9004",
  scope: "Classic",
  de: "Signalschwarz",
  en: "Signal black",
  nl: "Signaal zwart",
  fr: "Noir de signalisation"
}, {
  hex: "#0E0E10",
  code: "9005",
  scope: "Classic",
  de: "Tiefschwarz",
  en: "Jet black",
  nl: "Diepzwart",
  fr: "Noir profond"
}, {
  hex: "#A1A1A0",
  code: "9006",
  scope: "Classic",
  de: "Weißaluminium",
  en: "White aluminium",
  nl: "Wit aluminium",
  fr: "Aluminium blanc"
}, {
  hex: "#868581",
  code: "9007",
  scope: "Classic",
  de: "Graualuminium",
  en: "Grey aluminium",
  nl: "Grijs aluminium",
  fr: "Aluminium gris"
}, {
  hex: "#F1EDE1",
  code: "9010",
  scope: "Classic",
  de: "Reinweiß",
  en: "Pure white",
  nl: "Puur wit",
  fr: "Blanc pur"
}, {
  hex: "#27292B",
  code: "9011",
  scope: "Classic",
  de: "Graphitschwarz",
  en: "Graphite black",
  nl: "Grafiet zwart",
  fr: "Noir graphite"
}, {
  hex: "#F8F2E1",
  code: "9012",
  scope: "Classic",
  de: "Reinraumweiß",
  en: "Cleanroom White",
  nl: "Cleanroom wit",
  fr: "Blanc salle blanche"
}, {
  hex: "#F1F1EA",
  code: "9016",
  scope: "Classic",
  de: "Verkehrsweiß",
  en: "Traffic white",
  nl: "Verkeerswit",
  fr: "Blanc trafic"
}, {
  hex: "#29292A",
  code: "9017",
  scope: "Classic",
  de: "Verkehrsschwarz",
  en: "Traffic black",
  nl: "Verkeer zwart",
  fr: "Noir trafic"
}, {
  hex: "#C8CBC4",
  code: "9018",
  scope: "Classic",
  de: "Papyrusweiß",
  en: "Papyrus white",
  nl: "Papyrus wit",
  fr: "Blanc papyrus"
}, {
  hex: "#858583",
  code: "9022",
  scope: "Classic",
  de: "Perlhellgrau",
  en: "Pearl light grey",
  nl: "Parel lichtgrijs",
  fr: "Gris clair perle"
}, {
  hex: "#787B7A",
  code: "9023",
  scope: "Classic",
  de: "Perldunkelgrau",
  en: "Pearl dark grey",
  nl: "Parel donkergrijs",
  fr: "Gris perle foncé"
}], jzt = [
  {
    hex: "#E6E7E6",
    code: "110-1",
    scope: "Effect"
  },
  {
    hex: "#DEDDD5",
    code: "110-2",
    scope: "Effect"
  },
  {
    hex: "#C8C6BE",
    code: "110-3",
    scope: "Effect"
  },
  {
    hex: "#C6C7C4",
    code: "110-4",
    scope: "Effect"
  },
  {
    hex: "#C9CCC6",
    code: "110-5",
    scope: "Effect"
  },
  {
    hex: "#C8C8C7",
    code: "110-6",
    scope: "Effect"
  },
  {
    hex: "#A0A2A4",
    code: "110-M",
    scope: "Effect"
  },
  {
    hex: "#EDEDEA",
    code: "120-1",
    scope: "Effect"
  },
  {
    hex: "#F2F1EC",
    code: "120-2",
    scope: "Effect"
  },
  {
    hex: "#F0EEE5",
    code: "120-3",
    scope: "Effect"
  },
  {
    hex: "#E9E1D4",
    code: "120-4",
    scope: "Effect"
  },
  {
    hex: "#E2D9C6",
    code: "120-5",
    scope: "Effect"
  },
  {
    hex: "#EAE1CE",
    code: "120-6",
    scope: "Effect"
  },
  {
    hex: "#8F8D87",
    code: "120-M",
    scope: "Effect"
  },
  {
    hex: "#F2EDBB",
    code: "130-1",
    scope: "Effect"
  },
  {
    hex: "#F1EEC3",
    code: "130-2",
    scope: "Effect"
  },
  {
    hex: "#F0EECD",
    code: "130-3",
    scope: "Effect"
  },
  {
    hex: "#F8F0CF",
    code: "130-4",
    scope: "Effect"
  },
  {
    hex: "#EDE4BC",
    code: "130-5",
    scope: "Effect"
  },
  {
    hex: "#FBE5B0",
    code: "130-6",
    scope: "Effect"
  },
  {
    hex: "#ABAB90",
    code: "130-M",
    scope: "Effect"
  },
  {
    hex: "#FAD3A9",
    code: "140-1",
    scope: "Effect"
  },
  {
    hex: "#FEDAA6",
    code: "140-2",
    scope: "Effect"
  },
  {
    hex: "#FEE3C1",
    code: "140-3",
    scope: "Effect"
  },
  {
    hex: "#FDDFBE",
    code: "140-4",
    scope: "Effect"
  },
  {
    hex: "#F8E4C8",
    code: "140-5",
    scope: "Effect"
  },
  {
    hex: "#E5D2B6",
    code: "140-6",
    scope: "Effect"
  },
  {
    hex: "#B09E7E",
    code: "140-M",
    scope: "Effect"
  },
  {
    hex: "#F7EFE9",
    code: "150-1",
    scope: "Effect"
  },
  {
    hex: "#F9EBE3",
    code: "150-2",
    scope: "Effect"
  },
  {
    hex: "#EEE1D7",
    code: "150-3",
    scope: "Effect"
  },
  {
    hex: "#FBE3D4",
    code: "150-4",
    scope: "Effect"
  },
  {
    hex: "#FAE8DC",
    code: "150-5",
    scope: "Effect"
  },
  {
    hex: "#F8DFD7",
    code: "150-6",
    scope: "Effect"
  },
  {
    hex: "#AB978A",
    code: "150-M",
    scope: "Effect"
  },
  {
    hex: "#E3E1EC",
    code: "160-1",
    scope: "Effect"
  },
  {
    hex: "#E7E2E8",
    code: "160-2",
    scope: "Effect"
  },
  {
    hex: "#EDE8E8",
    code: "160-3",
    scope: "Effect"
  },
  {
    hex: "#EEE1E2",
    code: "160-4",
    scope: "Effect"
  },
  {
    hex: "#EFE4E0",
    code: "160-5",
    scope: "Effect"
  },
  {
    hex: "#ECE4E9",
    code: "160-6",
    scope: "Effect"
  },
  {
    hex: "#ADA6B5",
    code: "160-M",
    scope: "Effect"
  },
  {
    hex: "#C7C9D0",
    code: "170-1",
    scope: "Effect"
  },
  {
    hex: "#A6ADBD",
    code: "170-2",
    scope: "Effect"
  },
  {
    hex: "#BAC8DA",
    code: "170-3",
    scope: "Effect"
  },
  {
    hex: "#CEDBEC",
    code: "170-4",
    scope: "Effect"
  },
  {
    hex: "#C3C6D6",
    code: "170-5",
    scope: "Effect"
  },
  {
    hex: "#C6C5D6",
    code: "170-6",
    scope: "Effect"
  },
  {
    hex: "#A7A8B9",
    code: "170-M",
    scope: "Effect"
  },
  {
    hex: "#AEBCC6",
    code: "180-1",
    scope: "Effect"
  },
  {
    hex: "#B9CDDD",
    code: "180-2",
    scope: "Effect"
  },
  {
    hex: "#C7DBEB",
    code: "180-3",
    scope: "Effect"
  },
  {
    hex: "#C9E1EC",
    code: "180-4",
    scope: "Effect"
  },
  {
    hex: "#C7DDE1",
    code: "180-5",
    scope: "Effect"
  },
  {
    hex: "#DBE9EB",
    code: "180-6",
    scope: "Effect"
  },
  {
    hex: "#96A4A9",
    code: "180-M",
    scope: "Effect"
  },
  {
    hex: "#A5DADF",
    code: "190-1",
    scope: "Effect"
  },
  {
    hex: "#B9E6F2",
    code: "190-2",
    scope: "Effect"
  },
  {
    hex: "#C0DEE1",
    code: "190-3",
    scope: "Effect"
  },
  {
    hex: "#BDDAD7",
    code: "190-4",
    scope: "Effect"
  },
  {
    hex: "#D4E5E7",
    code: "190-5",
    scope: "Effect"
  },
  {
    hex: "#A3C1BF",
    code: "190-6",
    scope: "Effect"
  },
  {
    hex: "#92B4B2",
    code: "190-M",
    scope: "Effect"
  },
  {
    hex: "#CFC6B2",
    code: "210-1",
    scope: "Effect"
  },
  {
    hex: "#ECE7D2",
    code: "210-2",
    scope: "Effect"
  },
  {
    hex: "#E3E4D9",
    code: "210-3",
    scope: "Effect"
  },
  {
    hex: "#D6E6E3",
    code: "210-4",
    scope: "Effect"
  },
  {
    hex: "#D8E8E0",
    code: "210-5",
    scope: "Effect"
  },
  {
    hex: "#D8E9D6",
    code: "210-6",
    scope: "Effect"
  },
  {
    hex: "#A5A99B",
    code: "210-M",
    scope: "Effect"
  },
  {
    hex: "#66B872",
    code: "220-1",
    scope: "Effect"
  },
  {
    hex: "#339A51",
    code: "220-2",
    scope: "Effect"
  },
  {
    hex: "#006F3C",
    code: "220-3",
    scope: "Effect"
  },
  {
    hex: "#088554",
    code: "220-4",
    scope: "Effect"
  },
  {
    hex: "#267E51",
    code: "220-5",
    scope: "Effect"
  },
  {
    hex: "#006A4D",
    code: "220-6",
    scope: "Effect"
  },
  {
    hex: "#007F3E",
    code: "220-M",
    scope: "Effect"
  },
  {
    hex: "#BBDB9A",
    code: "230-1",
    scope: "Effect"
  },
  {
    hex: "#96C86C",
    code: "230-2",
    scope: "Effect"
  },
  {
    hex: "#7DB344",
    code: "230-3",
    scope: "Effect"
  },
  {
    hex: "#5F973A",
    code: "230-4",
    scope: "Effect"
  },
  {
    hex: "#396938",
    code: "230-5",
    scope: "Effect"
  },
  {
    hex: "#365C30",
    code: "230-6",
    scope: "Effect"
  },
  {
    hex: "#62A74E",
    code: "230-M",
    scope: "Effect"
  },
  {
    hex: "#DCD691",
    code: "240-1",
    scope: "Effect"
  },
  {
    hex: "#AAAF66",
    code: "240-2",
    scope: "Effect"
  },
  {
    hex: "#939755",
    code: "240-3",
    scope: "Effect"
  },
  {
    hex: "#7E7E42",
    code: "240-4",
    scope: "Effect"
  },
  {
    hex: "#5D6D3C",
    code: "240-5",
    scope: "Effect"
  },
  {
    hex: "#4F6D35",
    code: "240-6",
    scope: "Effect"
  },
  {
    hex: "#627439",
    code: "240-M",
    scope: "Effect"
  },
  {
    hex: "#EEE6A5",
    code: "250-1",
    scope: "Effect"
  },
  {
    hex: "#E8DE6F",
    code: "250-2",
    scope: "Effect"
  },
  {
    hex: "#BFB700",
    code: "250-3",
    scope: "Effect"
  },
  {
    hex: "#A4A541",
    code: "250-4",
    scope: "Effect"
  },
  {
    hex: "#919138",
    code: "250-5",
    scope: "Effect"
  },
  {
    hex: "#69652C",
    code: "250-6",
    scope: "Effect"
  },
  {
    hex: "#AEA73B",
    code: "250-M",
    scope: "Effect"
  },
  {
    hex: "#F3E9B4",
    code: "260-1",
    scope: "Effect"
  },
  {
    hex: "#F1E483",
    code: "260-2",
    scope: "Effect"
  },
  {
    hex: "#F3D446",
    code: "260-3",
    scope: "Effect"
  },
  {
    hex: "#E8C01F",
    code: "260-4",
    scope: "Effect"
  },
  {
    hex: "#DEB02D",
    code: "260-5",
    scope: "Effect"
  },
  {
    hex: "#EFB416",
    code: "260-6",
    scope: "Effect"
  },
  {
    hex: "#B8944F",
    code: "260-M",
    scope: "Effect"
  },
  {
    hex: "#FFDE83",
    code: "270-1",
    scope: "Effect"
  },
  {
    hex: "#FACC39",
    code: "270-2",
    scope: "Effect"
  },
  {
    hex: "#F4BD16",
    code: "270-3",
    scope: "Effect"
  },
  {
    hex: "#EBB100",
    code: "270-4",
    scope: "Effect"
  },
  //   {
  //     hex: "#F6B600",
  //     code: "270-5",
  //     scope: "Effect",
  //   },
  {
    hex: "#FEC43F",
    code: "270-6",
    scope: "Effect"
  },
  {
    hex: "#CB9437",
    code: "270-M",
    scope: "Effect"
  },
  {
    hex: "#FDE193",
    code: "280-1",
    scope: "Effect"
  },
  {
    hex: "#F0D391",
    code: "280-2",
    scope: "Effect"
  },
  {
    hex: "#E1BE78",
    code: "280-3",
    scope: "Effect"
  },
  {
    hex: "#D6AE5F",
    code: "280-4",
    scope: "Effect"
  },
  {
    hex: "#DCA140",
    code: "280-5",
    scope: "Effect"
  },
  {
    hex: "#D0973C",
    code: "280-6",
    scope: "Effect"
  },
  {
    hex: "#B28740",
    code: "280-M",
    scope: "Effect"
  },
  {
    hex: "#D89B50",
    code: "290-1",
    scope: "Effect"
  },
  {
    hex: "#BF853B",
    code: "290-2",
    scope: "Effect"
  },
  {
    hex: "#D8A960",
    code: "290-3",
    scope: "Effect"
  },
  {
    hex: "#CC921B",
    code: "290-4",
    scope: "Effect"
  },
  {
    hex: "#E6B03E",
    code: "290-5",
    scope: "Effect"
  },
  {
    hex: "#FCAB04",
    code: "290-6",
    scope: "Effect"
  },
  {
    hex: "#B87E32",
    code: "290-M",
    scope: "Effect"
  },
  {
    hex: "#F5D6B4",
    code: "310-1",
    scope: "Effect"
  },
  {
    hex: "#EBC297",
    code: "310-2",
    scope: "Effect"
  },
  {
    hex: "#DFAB73",
    code: "310-3",
    scope: "Effect"
  },
  {
    hex: "#D09355",
    code: "310-4",
    scope: "Effect"
  },
  {
    hex: "#BA7C43",
    code: "310-5",
    scope: "Effect"
  },
  {
    hex: "#8E5B2D",
    code: "310-6",
    scope: "Effect"
  },
  {
    hex: "#B87D4F",
    code: "310-M",
    scope: "Effect"
  },
  {
    hex: "#D2A96C",
    code: "320-1",
    scope: "Effect"
  },
  {
    hex: "#AE8151",
    code: "320-2",
    scope: "Effect"
  },
  {
    hex: "#B9864C",
    code: "320-3",
    scope: "Effect"
  },
  {
    hex: "#A06735",
    code: "320-4",
    scope: "Effect"
  },
  {
    hex: "#7F4E2E",
    code: "320-5",
    scope: "Effect"
  },
  {
    hex: "#6E4428",
    code: "320-6",
    scope: "Effect"
  },
  {
    hex: "#B9731E",
    code: "320-M",
    scope: "Effect"
  },
  {
    hex: "#A86859",
    code: "330-1",
    scope: "Effect"
  },
  {
    hex: "#8E4B35",
    code: "330-2",
    scope: "Effect"
  },
  {
    hex: "#794E3E",
    code: "330-3",
    scope: "Effect"
  },
  {
    hex: "#5C3B2D",
    code: "330-4",
    scope: "Effect"
  },
  {
    hex: "#50312A",
    code: "330-5",
    scope: "Effect"
  },
  {
    hex: "#46322E",
    code: "330-6",
    scope: "Effect"
  },
  {
    hex: "#8B5943",
    code: "330-M",
    scope: "Effect"
  },
  {
    hex: "#BEA4A9",
    code: "340-1",
    scope: "Effect"
  },
  {
    hex: "#A48C92",
    code: "340-2",
    scope: "Effect"
  },
  {
    hex: "#7F5452",
    code: "340-3",
    scope: "Effect"
  },
  {
    hex: "#683D40",
    code: "340-4",
    scope: "Effect"
  },
  {
    hex: "#4F2A2D",
    code: "340-5",
    scope: "Effect"
  },
  {
    hex: "#4F2B31",
    code: "340-6",
    scope: "Effect"
  },
  {
    hex: "#53353B",
    code: "340-M",
    scope: "Effect"
  },
  {
    hex: "#9D311F",
    code: "350-1",
    scope: "Effect"
  },
  {
    hex: "#A73F32",
    code: "350-2",
    scope: "Effect"
  },
  {
    hex: "#A24733",
    code: "350-3",
    scope: "Effect"
  },
  {
    hex: "#813021",
    code: "350-4",
    scope: "Effect"
  },
  {
    hex: "#783122",
    code: "350-5",
    scope: "Effect"
  },
  {
    hex: "#66322B",
    code: "350-6",
    scope: "Effect"
  },
  {
    hex: "#582F2A",
    code: "350-M",
    scope: "Effect"
  },
  {
    hex: "#E07D29",
    code: "360-1",
    scope: "Effect"
  },
  {
    hex: "#D9751E",
    code: "360-2",
    scope: "Effect"
  },
  {
    hex: "#C66217",
    code: "360-3",
    scope: "Effect"
  },
  {
    hex: "#B75629",
    code: "360-4",
    scope: "Effect"
  },
  {
    hex: "#9A4F2C",
    code: "360-5",
    scope: "Effect"
  },
  {
    hex: "#915033",
    code: "360-6",
    scope: "Effect"
  },
  {
    hex: "#A45633",
    code: "360-M",
    scope: "Effect"
  },
  {
    hex: "#FFAE47",
    code: "370-1",
    scope: "Effect"
  },
  {
    hex: "#FF9B38",
    code: "370-2",
    scope: "Effect"
  },
  {
    hex: "#FF901D",
    code: "370-3",
    scope: "Effect"
  },
  {
    hex: "#E68316",
    code: "370-4",
    scope: "Effect"
  },
  {
    hex: "#D4781F",
    code: "370-5",
    scope: "Effect"
  },
  {
    hex: "#CD6C10",
    code: "370-6",
    scope: "Effect"
  },
  {
    hex: "#B47A3C",
    code: "370-M",
    scope: "Effect"
  },
  {
    hex: "#FF9B29",
    code: "380-1",
    scope: "Effect"
  },
  {
    hex: "#FF9204",
    code: "380-2",
    scope: "Effect"
  },
  {
    hex: "#FA841A",
    code: "380-3",
    scope: "Effect"
  },
  {
    hex: "#E27121",
    code: "380-4",
    scope: "Effect"
  },
  {
    hex: "#F2782F",
    code: "380-5",
    scope: "Effect"
  },
  {
    hex: "#EA6A24",
    code: "380-6",
    scope: "Effect"
  },
  {
    hex: "#A7552A",
    code: "380-M",
    scope: "Effect"
  },
  {
    hex: "#EB773F",
    code: "390-1",
    scope: "Effect"
  },
  {
    hex: "#E36125",
    code: "390-2",
    scope: "Effect"
  },
  {
    hex: "#DE5411",
    code: "390-3",
    scope: "Effect"
  },
  {
    hex: "#D8511C",
    code: "390-4",
    scope: "Effect"
  },
  {
    hex: "#D8480F",
    code: "390-5",
    scope: "Effect"
  },
  {
    hex: "#CD5E2A",
    code: "390-6",
    scope: "Effect"
  },
  {
    hex: "#BF633B",
    code: "390-M",
    scope: "Effect"
  },
  {
    hex: "#ED8165",
    code: "410-1",
    scope: "Effect"
  },
  {
    hex: "#EA734F",
    code: "410-2",
    scope: "Effect"
  },
  {
    hex: "#E46440",
    code: "410-3",
    scope: "Effect"
  },
  {
    hex: "#DC5D38",
    code: "410-4",
    scope: "Effect"
  },
  {
    hex: "#D25535",
    code: "410-5",
    scope: "Effect"
  },
  {
    hex: "#D05D42",
    code: "410-6",
    scope: "Effect"
  },
  {
    hex: "#AB4924",
    code: "410-M",
    scope: "Effect"
  },
  {
    hex: "#EDAE9A",
    code: "420-1",
    scope: "Effect"
  },
  {
    hex: "#F29D86",
    code: "420-2",
    scope: "Effect"
  },
  {
    hex: "#E98A6C",
    code: "420-3",
    scope: "Effect"
  },
  {
    hex: "#E46443",
    code: "420-4",
    scope: "Effect"
  },
  {
    hex: "#CC5738",
    code: "420-5",
    scope: "Effect"
  },
  {
    hex: "#BF502E",
    code: "420-6",
    scope: "Effect"
  },
  {
    hex: "#9D4B32",
    code: "420-M",
    scope: "Effect"
  },
  {
    hex: "#F2C2B6",
    code: "430-1",
    scope: "Effect"
  },
  {
    hex: "#EC998B",
    code: "430-2",
    scope: "Effect"
  },
  {
    hex: "#E48074",
    code: "430-3",
    scope: "Effect"
  },
  {
    hex: "#DD5A4C",
    code: "430-4",
    scope: "Effect"
  },
  {
    hex: "#D5433C",
    code: "430-5",
    scope: "Effect"
  },
  {
    hex: "#BE3A24",
    code: "430-6",
    scope: "Effect"
  },
  {
    hex: "#A84C45",
    code: "430-M",
    scope: "Effect"
  },
  {
    hex: "#CA383C",
    code: "440-1",
    scope: "Effect"
  },
  {
    hex: "#D34C49",
    code: "440-2",
    scope: "Effect"
  },
  {
    hex: "#BA3C3E",
    code: "440-3",
    scope: "Effect"
  },
  {
    hex: "#9B2929",
    code: "440-4",
    scope: "Effect"
  },
  {
    hex: "#A63129",
    code: "440-5",
    scope: "Effect"
  },
  {
    hex: "#B93525",
    code: "440-6",
    scope: "Effect"
  },
  {
    hex: "#9B252C",
    code: "440-M",
    scope: "Effect"
  },
  {
    hex: "#F4C7CA",
    code: "450-1",
    scope: "Effect"
  },
  {
    hex: "#EDA5AA",
    code: "450-2",
    scope: "Effect"
  },
  {
    hex: "#E07A81",
    code: "450-3",
    scope: "Effect"
  },
  {
    hex: "#C85862",
    code: "450-4",
    scope: "Effect"
  },
  {
    hex: "#B2312F",
    code: "450-5",
    scope: "Effect"
  },
  {
    hex: "#BB201D",
    code: "450-6",
    scope: "Effect"
  },
  {
    hex: "#A71616",
    code: "450-M",
    scope: "Effect"
  },
  {
    hex: "#EFA3A7",
    code: "460-1",
    scope: "Effect"
  },
  {
    hex: "#E37F89",
    code: "460-2",
    scope: "Effect"
  },
  {
    hex: "#DF6368",
    code: "460-3",
    scope: "Effect"
  },
  {
    hex: "#D35254",
    code: "460-4",
    scope: "Effect"
  },
  {
    hex: "#A8373B",
    code: "460-5",
    scope: "Effect"
  },
  {
    hex: "#8B1B28",
    code: "460-6",
    scope: "Effect"
  },
  {
    hex: "#AE363B",
    code: "460-M",
    scope: "Effect"
  },
  {
    hex: "#F0B3C1",
    code: "470-1",
    scope: "Effect"
  },
  {
    hex: "#E68B9D",
    code: "470-2",
    scope: "Effect"
  },
  {
    hex: "#DE7383",
    code: "470-3",
    scope: "Effect"
  },
  {
    hex: "#CA4D67",
    code: "470-4",
    scope: "Effect"
  },
  {
    hex: "#AC2D4C",
    code: "470-5",
    scope: "Effect"
  },
  {
    hex: "#9C223F",
    code: "470-6",
    scope: "Effect"
  },
  {
    hex: "#B14F5D",
    code: "470-M",
    scope: "Effect"
  },
  {
    hex: "#F5CAC9",
    code: "480-1",
    scope: "Effect"
  },
  {
    hex: "#F5C0BE",
    code: "480-2",
    scope: "Effect"
  },
  {
    hex: "#EEBABC",
    code: "480-3",
    scope: "Effect"
  },
  {
    hex: "#EEA5B1",
    code: "480-4",
    scope: "Effect"
  },
  {
    hex: "#E9909E",
    code: "480-5",
    scope: "Effect"
  },
  {
    hex: "#DA6C82",
    code: "480-6",
    scope: "Effect"
  },
  {
    hex: "#A87579",
    code: "480-M",
    scope: "Effect"
  },
  {
    hex: "#F3CFD0",
    code: "490-1",
    scope: "Effect"
  },
  {
    hex: "#F7CAC3",
    code: "490-2",
    scope: "Effect"
  },
  {
    hex: "#E89A92",
    code: "490-3",
    scope: "Effect"
  },
  {
    hex: "#C37B77",
    code: "490-4",
    scope: "Effect"
  },
  {
    hex: "#BE7F8C",
    code: "490-5",
    scope: "Effect"
  },
  {
    hex: "#D29EA8",
    code: "490-6",
    scope: "Effect"
  },
  {
    hex: "#A77D88",
    code: "490-M",
    scope: "Effect"
  },
  {
    hex: "#ECC8DC",
    code: "510-1",
    scope: "Effect"
  },
  {
    hex: "#E0A5CB",
    code: "510-2",
    scope: "Effect"
  },
  {
    hex: "#D584B1",
    code: "510-3",
    scope: "Effect"
  },
  {
    hex: "#C4638D",
    code: "510-4",
    scope: "Effect"
  },
  {
    hex: "#BA4877",
    code: "510-5",
    scope: "Effect"
  },
  {
    hex: "#9A3B6A",
    code: "510-6",
    scope: "Effect"
  },
  {
    hex: "#8C3D71",
    code: "510-M",
    scope: "Effect"
  },
  {
    hex: "#EFD2DF",
    code: "520-1",
    scope: "Effect"
  },
  {
    hex: "#E8BAD2",
    code: "520-2",
    scope: "Effect"
  },
  {
    hex: "#DCA5C0",
    code: "520-3",
    scope: "Effect"
  },
  {
    hex: "#BA7293",
    code: "520-4",
    scope: "Effect"
  },
  {
    hex: "#A04E6F",
    code: "520-5",
    scope: "Effect"
  },
  {
    hex: "#92526E",
    code: "520-6",
    scope: "Effect"
  },
  {
    hex: "#9E588B",
    code: "520-M",
    scope: "Effect"
  },
  {
    hex: "#98444D",
    code: "530-1",
    scope: "Effect"
  },
  {
    hex: "#8F3F4E",
    code: "530-2",
    scope: "Effect"
  },
  {
    hex: "#793644",
    code: "530-3",
    scope: "Effect"
  },
  {
    hex: "#7C2F4B",
    code: "530-4",
    scope: "Effect"
  },
  {
    hex: "#66253D",
    code: "530-5",
    scope: "Effect"
  },
  {
    hex: "#61294A",
    code: "530-6",
    scope: "Effect"
  },
  {
    hex: "#5C2D3A",
    code: "530-M",
    scope: "Effect"
  },
  {
    hex: "#D4C1D7",
    code: "540-1",
    scope: "Effect"
  },
  {
    hex: "#BEA1C1",
    code: "540-2",
    scope: "Effect"
  },
  {
    hex: "#805F83",
    code: "540-3",
    scope: "Effect"
  },
  {
    hex: "#966B98",
    code: "540-4",
    scope: "Effect"
  },
  {
    hex: "#81537A",
    code: "540-5",
    scope: "Effect"
  },
  {
    hex: "#562C51",
    code: "540-6",
    scope: "Effect"
  },
  {
    hex: "#562F4E",
    code: "540-M",
    scope: "Effect"
  },
  {
    hex: "#E0D1D9",
    code: "550-1",
    scope: "Effect"
  },
  {
    hex: "#D0BBC9",
    code: "550-2",
    scope: "Effect"
  },
  {
    hex: "#B292A8",
    code: "550-3",
    scope: "Effect"
  },
  {
    hex: "#9C7488",
    code: "550-4",
    scope: "Effect"
  },
  {
    hex: "#8D6177",
    code: "550-5",
    scope: "Effect"
  },
  {
    hex: "#784C5E",
    code: "550-6",
    scope: "Effect"
  },
  {
    hex: "#A78890",
    code: "550-M",
    scope: "Effect"
  },
  {
    hex: "#CCBCC7",
    code: "560-1",
    scope: "Effect"
  },
  {
    hex: "#B09CAD",
    code: "560-2",
    scope: "Effect"
  },
  {
    hex: "#8C6F80",
    code: "560-3",
    scope: "Effect"
  },
  {
    hex: "#775460",
    code: "560-4",
    scope: "Effect"
  },
  {
    hex: "#85727F",
    code: "560-5",
    scope: "Effect"
  },
  {
    hex: "#7D6E7F",
    code: "560-6",
    scope: "Effect"
  },
  {
    hex: "#A592A4",
    code: "560-M",
    scope: "Effect"
  },
  {
    hex: "#D1CEE8",
    code: "570-1",
    scope: "Effect"
  },
  {
    hex: "#C3BFE1",
    code: "570-2",
    scope: "Effect"
  },
  {
    hex: "#ADADDD",
    code: "570-3",
    scope: "Effect"
  },
  {
    hex: "#9B9ACF",
    code: "570-4",
    scope: "Effect"
  },
  {
    hex: "#8078B3",
    code: "570-5",
    scope: "Effect"
  },
  {
    hex: "#79689B",
    code: "570-6",
    scope: "Effect"
  },
  {
    hex: "#6B589A",
    code: "570-M",
    scope: "Effect"
  },
  {
    hex: "#C2CFE6",
    code: "580-1",
    scope: "Effect"
  },
  {
    hex: "#BCC7E0",
    code: "580-2",
    scope: "Effect"
  },
  {
    hex: "#A7B2D1",
    code: "580-3",
    scope: "Effect"
  },
  {
    hex: "#69749A",
    code: "580-4",
    scope: "Effect"
  },
  {
    hex: "#41506E",
    code: "580-5",
    scope: "Effect"
  },
  {
    hex: "#243154",
    code: "580-6",
    scope: "Effect"
  },
  {
    hex: "#636C86",
    code: "580-M",
    scope: "Effect"
  },
  {
    hex: "#666D9B",
    code: "590-1",
    scope: "Effect"
  },
  {
    hex: "#424276",
    code: "590-2",
    scope: "Effect"
  },
  {
    hex: "#2A366B",
    code: "590-3",
    scope: "Effect"
  },
  {
    hex: "#272F5B",
    code: "590-4",
    scope: "Effect"
  },
  {
    hex: "#142D58",
    code: "590-5",
    scope: "Effect"
  },
  {
    hex: "#093B7A",
    code: "590-6",
    scope: "Effect"
  },
  {
    hex: "#293862",
    code: "590-M",
    scope: "Effect"
  },
  {
    hex: "#6E8FAB",
    code: "610-1",
    scope: "Effect"
  },
  {
    hex: "#617A94",
    code: "610-2",
    scope: "Effect"
  },
  {
    hex: "#6D95B9",
    code: "610-3",
    scope: "Effect"
  },
  {
    hex: "#89B2D8",
    code: "610-4",
    scope: "Effect"
  },
  {
    hex: "#4777AE",
    code: "610-5",
    scope: "Effect"
  },
  {
    hex: "#436999",
    code: "610-6",
    scope: "Effect"
  },
  {
    hex: "#7897B5",
    code: "610-M",
    scope: "Effect"
  },
  {
    hex: "#34688A",
    code: "620-1",
    scope: "Effect"
  },
  {
    hex: "#6092AC",
    code: "620-2",
    scope: "Effect"
  },
  {
    hex: "#64818F",
    code: "620-3",
    scope: "Effect"
  },
  {
    hex: "#3A5A6A",
    code: "620-4",
    scope: "Effect"
  },
  {
    hex: "#14354B",
    code: "620-5",
    scope: "Effect"
  },
  {
    hex: "#1E2D3F",
    code: "620-6",
    scope: "Effect"
  },
  {
    hex: "#093246",
    code: "620-M",
    scope: "Effect"
  },
  {
    hex: "#51A3D3",
    code: "630-1",
    scope: "Effect"
  },
  {
    hex: "#446B8E",
    code: "630-2",
    scope: "Effect"
  },
  {
    hex: "#2E4E6F",
    code: "630-3",
    scope: "Effect"
  },
  {
    hex: "#2D4A6E",
    code: "630-4",
    scope: "Effect"
  },
  {
    hex: "#1F3454",
    code: "630-5",
    scope: "Effect"
  },
  {
    hex: "#193654",
    code: "630-6",
    scope: "Effect"
  },
  {
    hex: "#16304C",
    code: "630-M",
    scope: "Effect"
  },
  {
    hex: "#49A0C5",
    code: "640-1",
    scope: "Effect"
  },
  {
    hex: "#0087B5",
    code: "640-2",
    scope: "Effect"
  },
  {
    hex: "#007BAE",
    code: "640-3",
    scope: "Effect"
  },
  {
    hex: "#005C8C",
    code: "640-4",
    scope: "Effect"
  },
  {
    hex: "#00548A",
    code: "640-5",
    scope: "Effect"
  },
  {
    hex: "#004F7D",
    code: "640-6",
    scope: "Effect"
  },
  {
    hex: "#004E87",
    code: "640-M",
    scope: "Effect"
  },
  {
    hex: "#64B5D6",
    code: "650-1",
    scope: "Effect"
  },
  {
    hex: "#0077A0",
    code: "650-2",
    scope: "Effect"
  },
  {
    hex: "#006C97",
    code: "650-3",
    scope: "Effect"
  },
  {
    hex: "#005577",
    code: "650-4",
    scope: "Effect"
  },
  {
    hex: "#1D5B78",
    code: "650-5",
    scope: "Effect"
  },
  {
    hex: "#0A4962",
    code: "650-6",
    scope: "Effect"
  },
  {
    hex: "#00719D",
    code: "650-M",
    scope: "Effect"
  },
  {
    hex: "#0094B0",
    code: "660-1",
    scope: "Effect"
  },
  {
    hex: "#0B8DA8",
    code: "660-2",
    scope: "Effect"
  },
  {
    hex: "#51A5B8",
    code: "660-3",
    scope: "Effect"
  },
  {
    hex: "#3FB8CF",
    code: "660-4",
    scope: "Effect"
  },
  {
    hex: "#6CC3D4",
    code: "660-5",
    scope: "Effect"
  },
  {
    hex: "#8AC8D5",
    code: "660-6",
    scope: "Effect"
  },
  {
    hex: "#5597A9",
    code: "660-M",
    scope: "Effect"
  },
  {
    hex: "#8AD3EA",
    code: "670-1",
    scope: "Effect"
  },
  {
    hex: "#97DAEF",
    code: "670-2",
    scope: "Effect"
  },
  {
    hex: "#8FC5D6",
    code: "670-3",
    scope: "Effect"
  },
  {
    hex: "#69BBD3",
    code: "670-4",
    scope: "Effect"
  },
  {
    hex: "#5BB9D5",
    code: "670-5",
    scope: "Effect"
  },
  {
    hex: "#4EC2E6",
    code: "670-6",
    scope: "Effect"
  },
  {
    hex: "#74A7B8",
    code: "670-M",
    scope: "Effect"
  },
  {
    hex: "#72AABA",
    code: "680-1",
    scope: "Effect"
  },
  {
    hex: "#338FA4",
    code: "680-2",
    scope: "Effect"
  },
  {
    hex: "#177185",
    code: "680-3",
    scope: "Effect"
  },
  {
    hex: "#26768D",
    code: "680-4",
    scope: "Effect"
  },
  {
    hex: "#006A85",
    code: "680-5",
    scope: "Effect"
  },
  {
    hex: "#005B74",
    code: "680-6",
    scope: "Effect"
  },
  {
    hex: "#0E455C",
    code: "680-M",
    scope: "Effect"
  },
  {
    hex: "#3FBFCB",
    code: "690-1",
    scope: "Effect"
  },
  {
    hex: "#00A2AD",
    code: "690-2",
    scope: "Effect"
  },
  {
    hex: "#00838E",
    code: "690-3",
    scope: "Effect"
  },
  {
    hex: "#006C7B",
    code: "690-4",
    scope: "Effect"
  },
  {
    hex: "#00535F",
    code: "690-5",
    scope: "Effect"
  },
  {
    hex: "#005160",
    code: "690-6",
    scope: "Effect"
  },
  {
    hex: "#006773",
    code: "690-M",
    scope: "Effect"
  },
  {
    hex: "#78D1CD",
    code: "710-1",
    scope: "Effect"
  },
  {
    hex: "#00AAA7",
    code: "710-2",
    scope: "Effect"
  },
  {
    hex: "#058A8B",
    code: "710-3",
    scope: "Effect"
  },
  {
    hex: "#007476",
    code: "710-4",
    scope: "Effect"
  },
  {
    hex: "#005C60",
    code: "710-5",
    scope: "Effect"
  },
  {
    hex: "#0C4746",
    code: "710-6",
    scope: "Effect"
  },
  {
    hex: "#00686B",
    code: "710-M",
    scope: "Effect"
  },
  {
    hex: "#C2E3DE",
    code: "720-1",
    scope: "Effect"
  },
  {
    hex: "#A4E2DB",
    code: "720-2",
    scope: "Effect"
  },
  {
    hex: "#86D3D4",
    code: "720-3",
    scope: "Effect"
  },
  {
    hex: "#58BEC1",
    code: "720-4",
    scope: "Effect"
  },
  {
    hex: "#3393A0",
    code: "720-5",
    scope: "Effect"
  },
  {
    hex: "#197C86",
    code: "720-6",
    scope: "Effect"
  },
  {
    hex: "#1A949A",
    code: "720-M",
    scope: "Effect"
  },
  {
    hex: "#CBE7E2",
    code: "730-1",
    scope: "Effect"
  },
  {
    hex: "#98D3D3",
    code: "730-2",
    scope: "Effect"
  },
  {
    hex: "#7DB8BA",
    code: "730-3",
    scope: "Effect"
  },
  {
    hex: "#7BB9B4",
    code: "730-4",
    scope: "Effect"
  },
  {
    hex: "#79ACAC",
    code: "730-5",
    scope: "Effect"
  },
  {
    hex: "#46877F",
    code: "730-6",
    scope: "Effect"
  },
  {
    hex: "#62A293",
    code: "730-M",
    scope: "Effect"
  },
  {
    hex: "#C5DCCE",
    code: "740-1",
    scope: "Effect"
  },
  {
    hex: "#B3D6C9",
    code: "740-2",
    scope: "Effect"
  },
  {
    hex: "#95C3B2",
    code: "740-3",
    scope: "Effect"
  },
  {
    hex: "#498574",
    code: "740-4",
    scope: "Effect"
  },
  {
    hex: "#006F5B",
    code: "740-5",
    scope: "Effect"
  },
  {
    hex: "#005D4E",
    code: "740-6",
    scope: "Effect"
  },
  {
    hex: "#3A6F5F",
    code: "740-M",
    scope: "Effect"
  },
  {
    hex: "#BFD7C9",
    code: "750-1",
    scope: "Effect"
  },
  {
    hex: "#8FB4A0",
    code: "750-2",
    scope: "Effect"
  },
  {
    hex: "#3D7461",
    code: "750-3",
    scope: "Effect"
  },
  {
    hex: "#164234",
    code: "750-4",
    scope: "Effect"
  },
  {
    hex: "#335449",
    code: "750-5",
    scope: "Effect"
  },
  {
    hex: "#2E3C3B",
    code: "750-6",
    scope: "Effect"
  },
  {
    hex: "#17372D",
    code: "750-M",
    scope: "Effect"
  },
  {
    hex: "#D5E3CA",
    code: "760-1",
    scope: "Effect"
  },
  {
    hex: "#B8CDAA",
    code: "760-2",
    scope: "Effect"
  },
  {
    hex: "#B0BE9B",
    code: "760-3",
    scope: "Effect"
  },
  {
    hex: "#8B9B7A",
    code: "760-4",
    scope: "Effect"
  },
  {
    hex: "#6D7E5C",
    code: "760-5",
    scope: "Effect"
  },
  {
    hex: "#4A6448",
    code: "760-6",
    scope: "Effect"
  },
  {
    hex: "#334B2E",
    code: "760-M",
    scope: "Effect"
  },
  {
    hex: "#989D84",
    code: "770-1",
    scope: "Effect"
  },
  {
    hex: "#A9A88F",
    code: "770-2",
    scope: "Effect"
  },
  {
    hex: "#7A755A",
    code: "770-3",
    scope: "Effect"
  },
  {
    hex: "#817A66",
    code: "770-4",
    scope: "Effect"
  },
  {
    hex: "#B4AF9F",
    code: "770-5",
    scope: "Effect"
  },
  {
    hex: "#7E8273",
    code: "770-6",
    scope: "Effect"
  },
  {
    hex: "#8D8864",
    code: "770-M",
    scope: "Effect"
  },
  {
    hex: "#E9DECC",
    code: "780-1",
    scope: "Effect"
  },
  {
    hex: "#E7D6B9",
    code: "780-2",
    scope: "Effect"
  },
  {
    hex: "#DDC49A",
    code: "780-3",
    scope: "Effect"
  },
  {
    hex: "#D1B186",
    code: "780-4",
    scope: "Effect"
  },
  {
    hex: "#A38E79",
    code: "780-5",
    scope: "Effect"
  },
  {
    hex: "#74695C",
    code: "780-6",
    scope: "Effect"
  },
  {
    hex: "#B2A074",
    code: "780-M",
    scope: "Effect"
  },
  {
    hex: "#3E4849",
    code: "790-1",
    scope: "Effect"
  },
  {
    hex: "#3B4147",
    code: "790-2",
    scope: "Effect"
  },
  {
    hex: "#313538",
    code: "790-3",
    scope: "Effect"
  },
  {
    hex: "#302F32",
    code: "790-4",
    scope: "Effect"
  },
  {
    hex: "#212224",
    code: "790-5",
    scope: "Effect"
  },
  {
    hex: "#21232D",
    code: "790-6",
    scope: "Effect"
  },
  {
    hex: "#221F1D",
    code: "790-M",
    scope: "Effect"
  },
  {
    hex: "#979DA2",
    code: "810-1",
    scope: "Effect"
  },
  {
    hex: "#8A9499",
    code: "810-2",
    scope: "Effect"
  },
  {
    hex: "#79888E",
    code: "810-3",
    scope: "Effect"
  },
  {
    hex: "#5E6B73",
    code: "810-4",
    scope: "Effect"
  },
  {
    hex: "#51595D",
    code: "810-5",
    scope: "Effect"
  },
  {
    hex: "#394146",
    code: "810-6",
    scope: "Effect"
  },
  {
    hex: "#404649",
    code: "810-M",
    scope: "Effect"
  },
  {
    hex: "#C5C8CA",
    code: "820-1",
    scope: "Effect"
  },
  {
    hex: "#A9AEB2",
    code: "820-2",
    scope: "Effect"
  },
  {
    hex: "#8D9395",
    code: "820-3",
    scope: "Effect"
  },
  {
    hex: "#7D8589",
    code: "820-4",
    scope: "Effect"
  },
  {
    hex: "#50555C",
    code: "820-5",
    scope: "Effect"
  },
  {
    hex: "#444951",
    code: "820-6",
    scope: "Effect"
  },
  {
    hex: "#929191",
    code: "820-M",
    scope: "Effect"
  },
  {
    hex: "#BABCBA",
    code: "830-1",
    scope: "Effect"
  },
  {
    hex: "#A4A7A5",
    code: "830-2",
    scope: "Effect"
  },
  {
    hex: "#8D9291",
    code: "830-3",
    scope: "Effect"
  },
  {
    hex: "#6C706D",
    code: "830-4",
    scope: "Effect"
  },
  {
    hex: "#515554",
    code: "830-5",
    scope: "Effect"
  },
  {
    hex: "#575E60",
    code: "830-6",
    scope: "Effect"
  },
  {
    hex: "#82817F",
    code: "830-M",
    scope: "Effect"
  },
  {
    hex: "#E7E3D8",
    code: "840-1",
    scope: "Effect"
  },
  {
    hex: "#D7D5CC",
    code: "840-2",
    scope: "Effect"
  },
  {
    hex: "#B8B4A8",
    code: "840-3",
    scope: "Effect"
  },
  {
    hex: "#808077",
    code: "840-4",
    scope: "Effect"
  },
  {
    hex: "#5A5D54",
    code: "840-5",
    scope: "Effect"
  },
  {
    hex: "#474135",
    code: "840-6",
    scope: "Effect"
  },
  {
    hex: "#494440",
    code: "840-M",
    scope: "Effect"
  },
  {
    hex: "#C3C2B9",
    code: "850-1",
    scope: "Effect"
  },
  {
    hex: "#B1B1AA",
    code: "850-2",
    scope: "Effect"
  },
  {
    hex: "#A6A6A0",
    code: "850-3",
    scope: "Effect"
  },
  {
    hex: "#918D85",
    code: "850-4",
    scope: "Effect"
  },
  {
    hex: "#6B6760",
    code: "850-5",
    scope: "Effect"
  },
  {
    hex: "#4C4B46",
    code: "850-6",
    scope: "Effect"
  },
  {
    hex: "#625E59",
    code: "850-M",
    scope: "Effect"
  },
  {
    hex: "#D8DADB",
    code: "860-1",
    scope: "Effect"
  },
  {
    hex: "#CFD2D5",
    code: "860-2",
    scope: "Effect"
  },
  {
    hex: "#C1C2C4",
    code: "860-3",
    scope: "Effect"
  },
  {
    hex: "#9A9A9B",
    code: "860-4",
    scope: "Effect"
  },
  {
    hex: "#7A7A79",
    code: "860-5",
    scope: "Effect"
  },
  {
    hex: "#5B5F5F",
    code: "860-6",
    scope: "Effect"
  },
  {
    hex: "#A4A09F",
    code: "860-M",
    scope: "Effect"
  },
  {
    hex: "#D3D0D0",
    code: "870-1",
    scope: "Effect"
  },
  {
    hex: "#969392",
    code: "870-2",
    scope: "Effect"
  },
  {
    hex: "#636164",
    code: "870-3",
    scope: "Effect"
  },
  {
    hex: "#514D4E",
    code: "870-4",
    scope: "Effect"
  },
  {
    hex: "#4A4747",
    code: "870-5",
    scope: "Effect"
  },
  {
    hex: "#3D3737",
    code: "870-6",
    scope: "Effect"
  },
  {
    hex: "#4D4747",
    code: "870-M",
    scope: "Effect"
  }
], qzt = [{
  hex: "#69473e",
  code: "DB301",
  scope: "DB",
  de: "DB 301",
  en: "DB 301",
  dontAddPrefix: !0,
  nl: "DB 301",
  fr: "DB 301"
}, {
  hex: "#52251f",
  code: "DB310",
  scope: "DB",
  de: "DB 310",
  en: "DB 310",
  dontAddPrefix: !0,
  nl: "DB 310",
  fr: "DB 310"
}, {
  hex: "#638a89",
  code: "DB501",
  scope: "DB",
  de: "DB 501",
  en: "DB 501",
  dontAddPrefix: !0,
  nl: "DB 501",
  fr: "DB 501"
}, {
  hex: "#294b4c",
  code: "DB502",
  scope: "DB",
  de: "DB 502",
  en: "DB 502",
  dontAddPrefix: !0,
  nl: "DB 502",
  fr: "DB 502"
}, {
  hex: "#203d45",
  code: "DB503",
  scope: "DB",
  de: "DB 503",
  en: "DB 503",
  dontAddPrefix: !0,
  nl: "DB 503",
  fr: "DB 503"
}, {
  hex: "#2f5063",
  code: "DB510",
  scope: "DB",
  de: "DB 510",
  en: "DB 510",
  dontAddPrefix: !0,
  nl: "DB 510",
  fr: "DB 510"
}, {
  hex: "#537250",
  code: "DB601",
  scope: "DB",
  de: "DB 601",
  en: "DB 601",
  dontAddPrefix: !0,
  nl: "DB 601",
  fr: "DB 601"
}, {
  hex: "#41624d",
  code: "DB603",
  scope: "DB",
  de: "DB 603",
  en: "DB 603",
  dontAddPrefix: !0,
  nl: "DB 603",
  fr: "DB 603"
}, {
  hex: "#2b6954",
  code: "DB610",
  scope: "DB",
  de: "DB 610",
  en: "DB 610",
  dontAddPrefix: !0,
  nl: "DB 610",
  fr: "DB 610"
}, {
  hex: "#8b9e9a",
  code: "DB701",
  scope: "DB",
  de: "DB 701",
  en: "DB 701",
  dontAddPrefix: !0,
  nl: "DB 701",
  fr: "DB 701"
}, {
  hex: "#5f7165",
  code: "DB702",
  scope: "DB",
  de: "DB 702",
  en: "DB 702",
  dontAddPrefix: !0,
  nl: "DB 702",
  fr: "DB 702"
}, {
  hex: "#2d3e34",
  code: "DB703",
  scope: "DB",
  de: "DB 703",
  en: "DB 703",
  dontAddPrefix: !0,
  nl: "DB 703",
  fr: "DB 703"
}], _zt = [{
  hex: "#414141",
  code: "000 15 00",
  scope: "Design System Plus",
  de: "Tintenschwarz",
  en: "Ink black",
  nl: "Inkt zwart",
  fr: "Noir d'encre"
}, {
  hex: "#474646",
  code: "000 20 00",
  scope: "Design System Plus",
  de: "Schieferschwarz",
  en: "Slate black",
  nl: "Leisteen zwart",
  fr: "Noir ardoise"
}, {
  hex: "#504f4f",
  code: "000 25 00",
  scope: "Design System Plus",
  de: "Onyxschwarz",
  en: "Onyx black",
  nl: "Onyx zwart",
  fr: "Noir onyx"
}, {
  hex: "#565656",
  code: "000 30 00",
  scope: "Design System Plus",
  de: "Mittelschwarz",
  en: "Medium black",
  nl: "Medium zwart",
  fr: "Noir moyen"
}, {
  hex: "#5f5f5f",
  code: "000 35 00",
  scope: "Design System Plus",
  de: "Brikettgrau",
  en: "Briquette grey",
  nl: "Briket grijs",
  fr: "Gris briquette"
}, {
  hex: "#696968",
  code: "000 40 00",
  scope: "Design System Plus",
  de: "Dunkelgrau",
  en: "Dark grey",
  nl: "Donkergrijs",
  fr: "Gris foncé"
}, {
  hex: "#757473",
  code: "000 45 00",
  scope: "Design System Plus",
  de: "Architekturgrau",
  en: "Architecture grey",
  nl: "Architectonisch grijs",
  fr: "Gris architecture"
}, {
  hex: "#7e7f7e",
  code: "000 50 00",
  scope: "Design System Plus",
  de: "Stahlgrau",
  en: "Steel grey",
  nl: "Staalgrijs",
  fr: "Gris acier"
}, {
  hex: "#898989",
  code: "000 55 00",
  scope: "Design System Plus",
  de: "Mittelgrau",
  en: "Medium grey",
  nl: "Medium grijs",
  fr: "Gris moyen"
}, {
  hex: "#959595",
  code: "000 60 00",
  scope: "Design System Plus",
  de: "Aschgrau",
  en: "Ash grey",
  nl: "Asgrijs",
  fr: "Gris cendré"
}, {
  hex: "#a3a3a3",
  code: "000 65 00",
  scope: "Design System Plus",
  de: "Mörtelgrau",
  en: "Mortar grey",
  nl: "Mortel grijs",
  fr: "Gris mortier"
}, {
  hex: "#b0b0b0",
  code: "000 70 00",
  scope: "Design System Plus",
  de: "Leichtgrau",
  en: "Light grey",
  nl: "Lichtgrijs",
  fr: "Gris léger"
}, {
  hex: "#bdbdbd",
  code: "000 75 00",
  scope: "Design System Plus",
  de: "Marmorgrau",
  en: "Marble grey",
  nl: "Marmer grijs",
  fr: "Gris marbre"
}, {
  hex: "#cacac9",
  code: "000 80 00",
  scope: "Design System Plus",
  de: "Nebelgrau",
  en: "Foggy grey",
  nl: "Mist grijs",
  fr: "Gris brume"
}, {
  hex: "#d7d7d5",
  code: "000 85 00",
  scope: "Design System Plus",
  de: "Schattenweiß",
  en: "Shadow white",
  nl: "Schaduw wit",
  fr: "Blanc d'ombre"
}, {
  hex: "#e2e3e1",
  code: "000 90 00",
  scope: "Design System Plus",
  de: "Winterweiß",
  en: "Winter white",
  nl: "Winterwit",
  fr: "Blanc d'hiver"
}, {
  hex: "#524446",
  code: "010 20 10",
  scope: "Design System Plus",
  de: "Wengeschwarz",
  en: "Wenge black",
  nl: "Wengeschwarz",
  fr: "Noir de wengé"
}, {
  hex: "#564144",
  code: "010 20 15",
  scope: "Design System Plus",
  de: "Kirschenschwarz",
  en: "Cherry black",
  nl: "Kersen zwart",
  fr: "Noir cerise"
}, {
  hex: "#5b3f43",
  code: "010 20 20",
  scope: "Design System Plus",
  de: "Dunkelmahagoni",
  en: "Dark mahogany",
  nl: "Donker mahonie",
  fr: "Acajou foncé"
}, {
  hex: "#5e3e43",
  code: "010 20 25",
  scope: "Design System Plus",
  de: "Rostrot",
  en: "Rusty red",
  nl: "Roest rood",
  fr: "Rouge rouille"
}, {
  hex: "#665255",
  code: "010 30 10",
  scope: "Design System Plus",
  de: "Holzschwarzrot",
  en: "Laurel nut rusty brown",
  nl: "Hout zwart rood",
  fr: "Rouge bois noir"
}, {
  hex: "#6a5054",
  code: "010 30 15",
  scope: "Design System Plus",
  de: "Nachtmauve",
  en: "Night mauve",
  nl: "Nacht mauve",
  fr: "Mauve nuit"
}, {
  hex: "#714e53",
  code: "010 30 20",
  scope: "Design System Plus",
  de: "Rosigbraun",
  en: "Pinkish brown",
  nl: "Rozig bruin",
  fr: "Marron rose"
}, {
  hex: "#774a52",
  code: "010 30 25",
  scope: "Design System Plus",
  de: "Kastanienrot",
  en: "Chestnut red",
  nl: "Kastanje rood",
  fr: "Rouge châtaigne"
}, {
  hex: "#7c4851",
  code: "010 30 30",
  scope: "Design System Plus",
  de: "Lederrot",
  en: "Leather red",
  nl: "Leder rood",
  fr: "Rouge cuir"
}, {
  hex: "#7e454f",
  code: "010 30 35",
  scope: "Design System Plus",
  de: "Anthrazitrot",
  en: "Anthracite red",
  nl: "Antraciet rood",
  fr: "Rouge anthracite"
}, {
  hex: "#86404f",
  code: "010 30 40",
  scope: "Design System Plus",
  de: "Braunmagenta",
  en: "Brown magenta",
  nl: "Bruin magenta",
  fr: "Magenta brun"
}, {
  hex: "#8b3d4f",
  code: "010 30 44",
  scope: "Design System Plus",
  de: "Atlasrot",
  en: "Atlas red",
  nl: "Atlas rood",
  fr: "Rouge atlas"
}, {
  hex: "#796567",
  code: "010 40 10",
  scope: "Design System Plus",
  de: "Caputmortuumgraurot",
  en: "Caput mortuum grey red",
  nl: "Caputmortuum grijs rood",
  fr: "Caputmortuumgraurot"
}, {
  hex: "#806165",
  code: "010 40 15",
  scope: "Design System Plus",
  de: "Rostbraun",
  en: "Rust brown",
  nl: "Roestbruin",
  fr: "Marron rouille"
}, {
  hex: "#875f64",
  code: "010 40 20",
  scope: "Design System Plus",
  de: "Abendrot",
  en: "Sunset red",
  nl: "Zonsondergang",
  fr: "Coucher de soleil"
}, {
  hex: "#8d5c65",
  code: "010 40 25",
  scope: "Design System Plus",
  de: "Mineralrot",
  en: "Mineral red",
  nl: "Mineraal rood",
  fr: "Rouge minéral"
}, {
  hex: "#945963",
  code: "010 40 30",
  scope: "Design System Plus",
  de: "Trübmagenta",
  en: "Dull magenta",
  nl: "Bewolkt magenta",
  fr: "Magenta trouble"
}, {
  hex: "#975460",
  code: "010 40 35",
  scope: "Design System Plus",
  de: "Samtrot",
  en: "Velvet red",
  nl: "Fluweelrood",
  fr: "Rouge velours"
}, {
  hex: "#9f5161",
  code: "010 40 40",
  scope: "Design System Plus",
  de: "Algenrot",
  en: "Algae red",
  nl: "Algen rood",
  fr: "Rouge algue"
}, {
  hex: "#a54d61",
  code: "010 40 45",
  scope: "Design System Plus",
  de: "Himbeereisrot",
  en: "Raspberry ice cream red",
  nl: "Framboos ijs rood",
  fr: "Rouge framboise"
}, {
  hex: "#ab4960",
  code: "010 40 50",
  scope: "Design System Plus",
  de: "Fuchsiarot",
  en: "Fuchsia red",
  nl: "Fuchsiarood",
  fr: "Rouge fuchsia"
}, {
  hex: "#ae465e",
  code: "010 40 53",
  scope: "Design System Plus",
  de: "Urrot",
  en: "Primal red",
  nl: "Oerrood",
  fr: "Urrot"
}, {
  hex: "#8f797d",
  code: "010 50 10",
  scope: "Design System Plus",
  de: "Altmahagoni",
  en: "Old mahogany",
  nl: "Oud mahonie",
  fr: "Acajou ancien"
}, {
  hex: "#96757a",
  code: "010 50 15",
  scope: "Design System Plus",
  de: "Trübaltrosa",
  en: "Dull dusky pink",
  nl: "Bewolkt roze",
  fr: "Rose pâle trouble"
}, {
  hex: "#9d737a",
  code: "010 50 20",
  scope: "Design System Plus",
  de: "Backsteinrot",
  en: "Brickwork red",
  nl: "Baksteen rood",
  fr: "Rouge brique"
}, {
  hex: "#a67079",
  code: "010 50 25",
  scope: "Design System Plus",
  de: "Mattkarmin",
  en: "Matte carmine",
  nl: "Mat karmijn",
  fr: "Carmin mat"
}, {
  hex: "#ae6c78",
  code: "010 50 30",
  scope: "Design System Plus",
  de: "Marmorrot",
  en: "Marble red",
  nl: "Marmerrood",
  fr: "Rouge marbré"
}, {
  hex: "#b36876",
  code: "010 50 35",
  scope: "Design System Plus",
  de: "Geranienrot",
  en: "Geranium red",
  nl: "Geranium rood",
  fr: "Rouge géranium"
}, {
  hex: "#b86576",
  code: "010 50 40",
  scope: "Design System Plus",
  de: "Schieferrosa",
  en: "Slate pink",
  nl: "Leisteen roze",
  fr: "Rose ardoise"
}, {
  hex: "#bd5f74",
  code: "010 50 45",
  scope: "Design System Plus",
  de: "Tulipanrot",
  en: "Tulip red",
  nl: "Tulpenrood",
  fr: "Rouge tulipe"
}, {
  hex: "#c65c74",
  code: "010 50 50",
  scope: "Design System Plus",
  de: "Lichtrot",
  en: "Vibrant red",
  nl: "Licht rood",
  fr: "Rouge lumière"
}, {
  hex: "#a89093",
  code: "010 60 10",
  scope: "Design System Plus",
  de: "Fliedergrau",
  en: "Lilac grey",
  nl: "Lila grijs",
  fr: "Gris lilas"
}, {
  hex: "#b18e93",
  code: "010 60 15",
  scope: "Design System Plus",
  de: "Eisorchideenrot",
  en: "Ice orchid red",
  nl: "Ijsorchidee rood",
  fr: "Rouge orchidée glacée"
}, {
  hex: "#ba8b92",
  code: "010 60 20",
  scope: "Design System Plus",
  de: "Kalkrosa",
  en: "Lime pink",
  nl: "Limoenroze",
  fr: "Rose calcaire"
}, {
  hex: "#c08690",
  code: "010 60 25",
  scope: "Design System Plus",
  de: "Lippenstiftrosa",
  en: "Lipstick pink",
  nl: "Lippenstift roze",
  fr: "Rose à lèvres"
}, {
  hex: "#c7828f",
  code: "010 60 30",
  scope: "Design System Plus",
  de: "Japankoralle",
  en: "Japanese coral",
  nl: "Japans koraal",
  fr: "Corail du Japon"
}, {
  hex: "#d07f8d",
  code: "010 60 35",
  scope: "Design System Plus",
  de: "Rosenrot",
  en: "Rose red",
  nl: "Rozerood",
  fr: "Rose rouge"
}, {
  hex: "#d67b8c",
  code: "010 60 40",
  scope: "Design System Plus",
  de: "Erdbeershakerot",
  en: "Strawberry milkshake red",
  nl: "Aardbeienshaker rood",
  fr: "Shakerot à la fraise"
}, {
  hex: "#df768b",
  code: "010 60 45",
  scope: "Design System Plus",
  de: "Leuchtendrosa",
  en: "Luminous pink",
  nl: "Helder roze",
  fr: "Rose vif"
}, {
  hex: "#c3aaae",
  code: "010 70 10",
  scope: "Design System Plus",
  de: "Blassmauve",
  en: "Pale mauve",
  nl: "Licht mauve",
  fr: "Mauve pâle"
}, {
  hex: "#caa7ab",
  code: "010 70 15",
  scope: "Design System Plus",
  de: "Puderrosé",
  en: "Powder rose",
  nl: "Poederroze",
  fr: "Rose poudré"
}, {
  hex: "#d4a3ab",
  code: "010 70 20",
  scope: "Design System Plus",
  de: "Silberrosé",
  en: "Silver rose",
  nl: "Zilveren roos",
  fr: "Rose argenté"
}, {
  hex: "#dc9fa9",
  code: "010 70 25",
  scope: "Design System Plus",
  de: "Flamingorosa",
  en: "Flamingo pink",
  nl: "Flamingo roze",
  fr: "Flamingorosa"
}, {
  hex: "#e39ca8",
  code: "010 70 30",
  scope: "Design System Plus",
  de: "Kirschblütenrosa",
  en: "Cherry blossom pink",
  nl: "Kersenbloesem roze",
  fr: "Rose cerise"
}, {
  hex: "#eb96a5",
  code: "010 70 35",
  scope: "Design System Plus",
  de: "Babyrosa",
  en: "Baby pink",
  nl: "Baby roze",
  fr: "Rose bébé"
}, {
  hex: "#dec3c5",
  code: "010 80 10",
  scope: "Design System Plus",
  de: "Schlammpink",
  en: "Mud pink",
  nl: "Modderroze",
  fr: "Rose boue"
}, {
  hex: "#e5c0c4",
  code: "010 80 15",
  scope: "Design System Plus",
  de: "Eispink",
  en: "Ice hot pink",
  nl: "IJsroze",
  fr: "Rose glacé"
}, {
  hex: "#efbcc3",
  code: "010 80 20",
  scope: "Design System Plus",
  de: "Pastellrosa",
  en: "Pastel pink",
  nl: "Pastelroze",
  fr: "Rose pastel"
}, {
  hex: "#ded1d3",
  code: "010 85 05",
  scope: "Design System Plus",
  de: "Perlrosé",
  en: "Pearl rose",
  nl: "Parel rosé",
  fr: "Perlrosé"
}, {
  hex: "#e4cdd1",
  code: "010 85 10",
  scope: "Design System Plus",
  de: "Lachsrosé",
  en: "Salmon rose",
  nl: "Zalmroze",
  fr: "Rose saumon"
}, {
  hex: "#efccd2",
  code: "010 85 15",
  scope: "Design System Plus",
  de: "Milchshakerosa",
  en: "Milkshake pink",
  nl: "Melkshakerosa",
  fr: "Shakerosa de lait"
}, {
  hex: "#f8cbd2",
  code: "010 85 20",
  scope: "Design System Plus",
  de: "Inkarnatrosé",
  en: "Carnation pink",
  nl: "Menselijke roos",
  fr: "Rose incarnat"
}, {
  hex: "#efe0df",
  code: "010 90 05",
  scope: "Design System Plus",
  de: "Rosécreme",
  en: "Rose cream",
  nl: "Rosé crème",
  fr: "Crème rose"
}, {
  hex: "#f2dbd8",
  code: "010 90 10",
  scope: "Design System Plus",
  de: "Hellapricot",
  en: "Light apricot",
  nl: "Hellapricot",
  fr: "Hellapricot"
}, {
  hex: "#f1e6e8",
  code: "010 93 05",
  scope: "Design System Plus",
  de: "Weißrötlich",
  en: "White-red",
  nl: "Wit-roodachtig",
  fr: "Blanc rougeâtre"
}, {
  hex: "#4c4545",
  code: "020 20 05",
  scope: "Design System Plus",
  de: "Tiefbraun",
  en: "Deep brown",
  nl: "Diep bruin",
  fr: "Marron profond"
}, {
  hex: "#524343",
  code: "020 20 10",
  scope: "Design System Plus",
  de: "Nachtröte",
  en: "Night red",
  nl: "Nachtzanger",
  fr: "Nocturne"
}, {
  hex: "#5b4041",
  code: "020 20 20",
  scope: "Design System Plus",
  de: "Dunkelrotbraun",
  en: "Dark red brown",
  nl: "Donker roodbruin",
  fr: "Marron rouge foncé"
}, {
  hex: "#633c40",
  code: "020 20 29",
  scope: "Design System Plus",
  de: "Burgunderrot",
  en: "Burgundy",
  nl: "Bourgondisch rood",
  fr: "Rouge bordeaux"
}, {
  hex: "#5d5454",
  code: "020 30 05",
  scope: "Design System Plus",
  de: "Rhodonitbraun",
  en: "Rhodonite brown",
  nl: "Rhodoniet bruin",
  fr: "Brun rhodonite"
}, {
  hex: "#645151",
  code: "020 30 10",
  scope: "Design System Plus",
  de: "Budapesterbraun",
  en: "Budapest brown",
  nl: "Boedapest bruin",
  fr: "Marron budapest"
}, {
  hex: "#6f4b4c",
  code: "020 30 20",
  scope: "Design System Plus",
  de: "Kremlrot",
  en: "Kremlin red",
  nl: "Kremlin rood",
  fr: "Rouge du Kremlin"
}, {
  hex: "#78464a",
  code: "020 30 30",
  scope: "Design System Plus",
  de: "Kristalldunkelrot",
  en: "Crystal dark red",
  nl: "Kristal donkerrood",
  fr: "Rouge foncé cristal"
}, {
  hex: "#844048",
  code: "020 30 40",
  scope: "Design System Plus",
  de: "Amaranthblüte",
  en: "Amaranth blossom",
  nl: "Amarant bloesem",
  fr: "Fleur d'amarante"
}, {
  hex: "#8c3c46",
  code: "020 30 48",
  scope: "Design System Plus",
  de: "Vogelkirschenrot",
  en: "Sweet cherry red",
  nl: "Vogel kersenrood",
  fr: "Rouge cerise d'oiseau"
}, {
  hex: "#726868",
  code: "020 40 05",
  scope: "Design System Plus",
  de: "Graubräunlich",
  en: "Greyish brown",
  nl: "Grijsbruin",
  fr: "Gris-brunâtre"
}, {
  hex: "#786464",
  code: "020 40 10",
  scope: "Design System Plus",
  de: "Nussbaumbraun",
  en: "Nut brown",
  nl: "Walnootbruin",
  fr: "Marron noyer"
}, {
  hex: "#855e60",
  code: "020 40 20",
  scope: "Design System Plus",
  de: "Antikrot",
  en: "Antique red",
  nl: "Antiek rood",
  fr: "Rouge antique"
}, {
  hex: "#92585c",
  code: "020 40 30",
  scope: "Design System Plus",
  de: "Hermosarosa",
  en: "Hermosa pink",
  nl: "Hermosarosa",
  fr: "Hermosarosa"
}, {
  hex: "#9b5157",
  code: "020 40 40",
  scope: "Design System Plus",
  de: "Oktoberrot",
  en: "October red",
  nl: "Oktober rood",
  fr: "Rouge octobre"
}, {
  hex: "#a74751",
  code: "020 40 50",
  scope: "Design System Plus",
  de: "Knallrot",
  en: "Bright red",
  nl: "Helder rood",
  fr: "Rouge vif"
}, {
  hex: "#897d7c",
  code: "020 50 05",
  scope: "Design System Plus",
  de: "Zirkongrau",
  en: "Zircon grey",
  nl: "Zirkoon grijs",
  fr: "Gris zircon"
}, {
  hex: "#907879",
  code: "020 50 10",
  scope: "Design System Plus",
  de: "Sandsteinrotgrau",
  en: "Sandstone red grey",
  nl: "Zandsteen rood-grijs",
  fr: "Gris grès rouge"
}, {
  hex: "#9f7274",
  code: "020 50 20",
  scope: "Design System Plus",
  de: "Rotgrau",
  en: "Red grey",
  nl: "Roodgrijs",
  fr: "Gris rouge"
}, {
  hex: "#ac6c70",
  code: "020 50 30",
  scope: "Design System Plus",
  de: "Venezianerrot",
  en: "Venetian red",
  nl: "Venetiaans rood",
  fr: "Rouge vénitien"
}, {
  hex: "#b6646b",
  code: "020 50 40",
  scope: "Design System Plus",
  de: "Schwedenkleerot",
  en: "Alsike clover red",
  nl: "Zweeds klavertje rood",
  fr: "Rouge de trèfle suédois"
}, {
  hex: "#c25c67",
  code: "020 50 50",
  scope: "Design System Plus",
  de: "Flammenrot",
  en: "Flame red",
  nl: "Vuurrood",
  fr: "Rouge flamme"
}, {
  hex: "#d25766",
  code: "020 50 58",
  scope: "Design System Plus",
  de: "Preiselbeerenrot",
  en: "Lingonberry red",
  nl: "Veenbessenrood",
  fr: "Rouge canneberge"
}, {
  hex: "#9f9493",
  code: "020 60 05",
  scope: "Design System Plus",
  de: "Kugeldistelgraurosé",
  en: "Globe thistle grey rose",
  nl: "Bal distel grijs rosé",
  fr: "Chardon sphérique grisâtre"
}, {
  hex: "#a78e8f",
  code: "020 60 10",
  scope: "Design System Plus",
  de: "Blechrosa",
  en: "Tin pink",
  nl: "Tin roze",
  fr: "Rose de tôle"
}, {
  hex: "#b88a8c",
  code: "020 60 20",
  scope: "Design System Plus",
  de: "Retrorosa",
  en: "Retro pink",
  nl: "Retrorosa",
  fr: "Retrorosa"
}, {
  hex: "#c68186",
  code: "020 60 30",
  scope: "Design System Plus",
  de: "Begonienrostrosé",
  en: "Begonia rusty rose",
  nl: "Begonia roestroze",
  fr: "Rose bégonia"
}, {
  hex: "#d37a82",
  code: "020 60 40",
  scope: "Design System Plus",
  de: "Lotusrot",
  en: "Lotus red",
  nl: "Lotusrood",
  fr: "Rouge lotus"
}, {
  hex: "#b9adac",
  code: "020 70 05",
  scope: "Design System Plus",
  de: "Fashionmauve",
  en: "Fashion mauve",
  nl: "Mode mauve",
  fr: "Fashionmauve"
}, {
  hex: "#c0a7a8",
  code: "020 70 10",
  scope: "Design System Plus",
  de: "Turmalinmauve",
  en: "Tourmaline mauve",
  nl: "Toermalijn mauve",
  fr: "Mauve tourmaline"
}, {
  hex: "#d4a2a5",
  code: "020 70 20",
  scope: "Design System Plus",
  de: "Rosenholzapricot",
  en: "Rosewood apricot",
  nl: "Rozenhout abrikoos",
  fr: "Abricot bois de rose"
}, {
  hex: "#e49ba0",
  code: "020 70 30",
  scope: "Design System Plus",
  de: "Markerrosa",
  en: "Marker pink",
  nl: "Marker roze",
  fr: "Rose marqueur"
}, {
  hex: "#d5c7c6",
  code: "020 80 05",
  scope: "Design System Plus",
  de: "Auroragrau",
  en: "Aurora grey",
  nl: "Aurora grijs",
  fr: "Gris aurore"
}, {
  hex: "#dcc1c2",
  code: "020 80 10",
  scope: "Design System Plus",
  de: "Quarzrosé",
  en: "Quartz rose",
  nl: "Kwarts rosé",
  fr: "Rose quartz"
}, {
  hex: "#eebcbe",
  code: "020 80 20",
  scope: "Design System Plus",
  de: "Marzipanrosa",
  en: "Marzipan pink",
  nl: "Marsepein roze",
  fr: "Rose massepain"
}, {
  hex: "#dfd1d1",
  code: "020 85 05",
  scope: "Design System Plus",
  de: "Mandelblütenrosa",
  en: "Almond blossom pink",
  nl: "Amandelbloesem roze",
  fr: "Rose fleur d'amandier"
}, {
  hex: "#e7cece",
  code: "020 85 10",
  scope: "Design System Plus",
  de: "Lachscreme",
  en: "Salmon cream",
  nl: "Zalmcrème",
  fr: "Crème de saumon"
}, {
  hex: "#fbc9ca",
  code: "020 85 20",
  scope: "Design System Plus",
  de: "Elegantlichtrosé",
  en: "Elegant light rose",
  nl: "Elegant lichtroze",
  fr: "Elégant trosé"
}, {
  hex: "#f0e2de",
  code: "020 90 05",
  scope: "Design System Plus",
  de: "Muschelweiß",
  en: "Mussel white",
  nl: "Schelp wit",
  fr: "Blanc de coquillage"
}, {
  hex: "#f3ddd9",
  code: "020 90 10",
  scope: "Design System Plus",
  de: "Pfirsichcreme",
  en: "Peach cream",
  nl: "Perzikcrème",
  fr: "Crème de pêche"
}, {
  hex: "#f6e6e3",
  code: "020 93 05",
  scope: "Design System Plus",
  de: "Blütenweiß",
  en: "Blossom white",
  nl: "Bloesem wit",
  fr: "Blanc de fleur"
}, {
  hex: "#635351",
  code: "030 30 10",
  scope: "Design System Plus",
  de: "Laurelnussrostbraun",
  en: "Laurel nut rusty brown",
  nl: "Lauriernoot roestbruin",
  fr: "Brun rouille de noix de laurier"
}, {
  hex: "#6e4d4b",
  code: "030 30 20",
  scope: "Design System Plus",
  de: "Herbstlaubrot",
  en: "Autumn leaf red",
  nl: "Herfstblad rood",
  fr: "Rouge feuille d'automne"
}, {
  hex: "#784845",
  code: "030 30 30",
  scope: "Design System Plus",
  de: "Macorefurnierrot",
  en: "Macore veneer red",
  nl: "Maco fineer rood",
  fr: "Rouge plaqué macore"
}, {
  hex: "#854343",
  code: "030 30 40",
  scope: "Design System Plus",
  de: "Karmesinrot",
  en: "Crimson red",
  nl: "Crimson rood",
  fr: "Rouge cramoisi"
}, {
  hex: "#863e3f",
  code: "030 30 45",
  scope: "Design System Plus",
  de: "Blutrot",
  en: "Blood red",
  nl: "Bloedrood",
  fr: "Rouge sang"
}, {
  hex: "#766361",
  code: "030 40 10",
  scope: "Design System Plus",
  de: "Torfrotbraun",
  en: "Peat red brown",
  nl: "Veen roodbruin",
  fr: "Marron tourbe"
}, {
  hex: "#86605c",
  code: "030 40 20",
  scope: "Design System Plus",
  de: "Moosbeerenrot",
  en: "Cranberry red",
  nl: "Veenbessenrood",
  fr: "Rouge canneberge"
}, {
  hex: "#925955",
  code: "030 40 30",
  scope: "Design System Plus",
  de: "Backsteinbraun",
  en: "Brick brown",
  nl: "Baksteen bruin",
  fr: "Marron brique"
}, {
  hex: "#9d5351",
  code: "030 40 40",
  scope: "Design System Plus",
  de: "Scharfrot",
  en: "Spicy red",
  nl: "Scherp rood",
  fr: "Rouge vif"
}, {
  hex: "#a84c4c",
  code: "030 40 50",
  scope: "Design System Plus",
  de: "Hibiskusrot",
  en: "Hibiscus red",
  nl: "Hibiscus rood",
  fr: "Rouge hibiscus"
}, {
  hex: "#b14548",
  code: "030 40 60",
  scope: "Design System Plus",
  de: "Kaiserkirschenrot",
  en: "Emperor cherry red",
  nl: "Keizer kersenrood",
  fr: "Rouge cerise impériale"
}, {
  hex: "#8f7875",
  code: "030 50 10",
  scope: "Design System Plus",
  de: "Erdrot",
  en: "Earth red",
  nl: "Aarde rood",
  fr: "Rouge terre"
}, {
  hex: "#9d736f",
  code: "030 50 20",
  scope: "Design System Plus",
  de: "Terracottarotbraun",
  en: "Terracotta red brown",
  nl: "Terracotta roodbruin",
  fr: "Brun rouge terracotta"
}, {
  hex: "#ab6d68",
  code: "030 50 30",
  scope: "Design System Plus",
  de: "Lehmrot",
  en: "Clay red",
  nl: "Klei rood",
  fr: "Rouge argile"
}, {
  hex: "#b86762",
  code: "030 50 40",
  scope: "Design System Plus",
  de: "Zinnoberrot",
  en: "Vermilion red",
  nl: "Vermiljoen",
  fr: "Rouge vermillon"
}, {
  hex: "#c25f5c",
  code: "030 50 50",
  scope: "Design System Plus",
  de: "Ahornrot",
  en: "Maple red",
  nl: "Esdoorn rood",
  fr: "Rouge érable"
}, {
  hex: "#cf5654",
  code: "030 50 60",
  scope: "Design System Plus",
  de: "Hollandrot",
  en: "Holland red",
  nl: "Nederland rood",
  fr: "Rouge hollandais"
}, {
  hex: "#a6908e",
  code: "030 60 10",
  scope: "Design System Plus",
  de: "Sturmröte",
  en: "Storm red",
  nl: "Stormrood",
  fr: "Rouge de la tempête"
}, {
  hex: "#b78a86",
  code: "030 60 20",
  scope: "Design System Plus",
  de: "Wüstenrot",
  en: "Desert red",
  nl: "Wüstenrot",
  fr: "Wüstenrot"
}, {
  hex: "#c5827c",
  code: "030 60 30",
  scope: "Design System Plus",
  de: "Antikrosa",
  en: "Antique pink",
  nl: "Antiek roze",
  fr: "Rose antique"
}, {
  hex: "#d37d77",
  code: "030 60 40",
  scope: "Design System Plus",
  de: "Helltomate",
  en: "Light tomato",
  nl: "Lichtgekleurde tomaat",
  fr: "Tomate claire"
}, {
  hex: "#e0746e",
  code: "030 60 50",
  scope: "Design System Plus",
  de: "Kalypsorot",
  en: "Calypso red",
  nl: "Calypsorot",
  fr: "Calypsorote"
}, {
  hex: "#c0a8a6",
  code: "030 70 10",
  scope: "Design System Plus",
  de: "Floridagrau",
  en: "Florida grey",
  nl: "Grijs Florida",
  fr: "Gris florida"
}, {
  hex: "#d2a19c",
  code: "030 70 20",
  scope: "Design System Plus",
  de: "Trübapricot",
  en: "Dull apricot",
  nl: "Bewolkt abrikoos",
  fr: "Pricot de turbidité"
}, {
  hex: "#e29a94",
  code: "030 70 30",
  scope: "Design System Plus",
  de: "Lachsrosarot",
  en: "Salmon pink red",
  nl: "Zalmroze",
  fr: "Rouge saumon"
}, {
  hex: "#f0938c",
  code: "030 70 40",
  scope: "Design System Plus",
  de: "Flamingorot",
  en: "Flamingo red",
  nl: "Flamingo rood",
  fr: "Rouge flamant"
}, {
  hex: "#dbc2bf",
  code: "030 80 10",
  scope: "Design System Plus",
  de: "Salzrosa",
  en: "Salt pink",
  nl: "Roze zout",
  fr: "Rose salé"
}, {
  hex: "#ecbbb6",
  code: "030 80 20",
  scope: "Design System Plus",
  de: "Magnolienrosa",
  en: "Magnolia pink",
  nl: "Magnolia roze",
  fr: "Rose magnolia"
}, {
  hex: "#dfd0cb",
  code: "030 85 05",
  scope: "Design System Plus",
  de: "Mandelcreme",
  en: "Almond cream",
  nl: "Amandelcrème",
  fr: "Crème d'amande"
}, {
  hex: "#e5cec9",
  code: "030 85 10",
  scope: "Design System Plus",
  de: "Softeisrosé",
  en: "Soft ice rose",
  nl: "Zacht ijs rosé",
  fr: "Rose soft glacé"
}, {
  hex: "#f6cbc3",
  code: "030 85 20",
  scope: "Design System Plus",
  de: "Pfirsichrot",
  en: "Peach red",
  nl: "Perzikrood",
  fr: "Rouge pêche"
}, {
  hex: "#efe1dc",
  code: "030 90 05",
  scope: "Design System Plus",
  de: "Antikweiß",
  en: "Antique white",
  nl: "Antiek wit",
  fr: "Blanc antique"
}, {
  hex: "#f5dfd9",
  code: "030 90 10",
  scope: "Design System Plus",
  de: "Hochzeitsrosa",
  en: "Wedding pink",
  nl: "Roze bruiloft",
  fr: "Rose de mariage"
}, {
  hex: "#f7e7e3",
  code: "030 93 05",
  scope: "Design System Plus",
  de: "Pergamentweiß",
  en: "Parchment white",
  nl: "Perkament wit",
  fr: "Blanc parchemin"
}, {
  hex: "#5a433f",
  code: "040 20 19",
  scope: "Design System Plus",
  de: "Wildbraun",
  en: "Wild brown",
  nl: "Wildbruin",
  fr: "Marron sauvage"
}, {
  hex: "#5d5552",
  code: "040 30 05",
  scope: "Design System Plus",
  de: "Basaltschwarz",
  en: "Basalt black",
  nl: "Basalt zwart",
  fr: "Noir basalte"
}, {
  hex: "#62524e",
  code: "040 30 10",
  scope: "Design System Plus",
  de: "Kaviarschwarz",
  en: "Caviar black",
  nl: "Kaviaar zwart",
  fr: "Noir caviar"
}, {
  hex: "#6d4e47",
  code: "040 30 20",
  scope: "Design System Plus",
  de: "Kaffeebraun",
  en: "Coffee brown",
  nl: "Koffiebruin",
  fr: "Marron café"
}, {
  hex: "#774b43",
  code: "040 30 30",
  scope: "Design System Plus",
  de: "Wurzelbraun",
  en: "Root brown",
  nl: "Wortel bruin",
  fr: "Marron racine"
}, {
  hex: "#80463e",
  code: "040 30 40",
  scope: "Design System Plus",
  de: "Korrosionsrot",
  en: "Corrosion red",
  nl: "Corrosie rood",
  fr: "Rouge de corrosion"
}, {
  hex: "#726865",
  code: "040 40 05",
  scope: "Design System Plus",
  de: "Aschbraun",
  en: "Ash brown",
  nl: "Asbruin",
  fr: "Marron cendré"
}, {
  hex: "#776560",
  code: "040 40 10",
  scope: "Design System Plus",
  de: "Somalibraun",
  en: "Somali brown",
  nl: "Somalisch bruin",
  fr: "Marron somali"
}, {
  hex: "#84625a",
  code: "040 40 20",
  scope: "Design System Plus",
  de: "Vandyckbraun",
  en: "Vandyck brown",
  nl: "Vandyck bruin",
  fr: "Marron vandyck"
}, {
  hex: "#8d5a4e",
  code: "040 40 30",
  scope: "Design System Plus",
  de: "Maronenbraun",
  en: "Chestnut brown",
  nl: "Kastanjebruin",
  fr: "Brun marron"
}, {
  hex: "#985447",
  code: "040 40 40",
  scope: "Design System Plus",
  de: "Ziegelrot",
  en: "Brick red",
  nl: "Baksteen rood",
  fr: "Rouge brique"
}, {
  hex: "#a35041",
  code: "040 40 50",
  scope: "Design System Plus",
  de: "Hennarot",
  en: "Henna red",
  nl: "Henna rood",
  fr: "Rouge henné"
}, {
  hex: "#aa473b",
  code: "040 40 60",
  scope: "Design System Plus",
  de: "Kupferrot",
  en: "Copper red",
  nl: "Koperrood",
  fr: "Rouge cuivré"
}, {
  hex: "#b24539",
  code: "040 40 67",
  scope: "Design System Plus",
  de: "Chinarot",
  en: "China red",
  nl: "Chinees rood",
  fr: "Chinarot"
}, {
  hex: "#877c79",
  code: "040 50 05",
  scope: "Design System Plus",
  de: "Nomadengrau",
  en: "Nomad grey",
  nl: "Nomad grijs",
  fr: "Gris nomade"
}, {
  hex: "#8e7a74",
  code: "040 50 10",
  scope: "Design System Plus",
  de: "Umbrasand",
  en: "Umbra sand",
  nl: "Umbra zand",
  fr: "Sable d'Ombrage"
}, {
  hex: "#9c746a",
  code: "040 50 20",
  scope: "Design System Plus",
  de: "Achatbraun",
  en: "Agate brown",
  nl: "Agaat bruin",
  fr: "Marron agate"
}, {
  hex: "#aa6f61",
  code: "040 50 30",
  scope: "Design System Plus",
  de: "Rostfarben",
  en: "Rust coloured",
  nl: "Roestkleuren",
  fr: "Couleur rouille"
}, {
  hex: "#b36857",
  code: "040 50 40",
  scope: "Design System Plus",
  de: "Ameisenrot",
  en: "Ant red",
  nl: "Mier rood",
  fr: "Rouge fourmi"
}, {
  hex: "#c0624f",
  code: "040 50 50",
  scope: "Design System Plus",
  de: "Englischrot",
  en: "English red",
  nl: "Engels rood",
  fr: "Rouge anglais"
}, {
  hex: "#ce5e4a",
  code: "040 50 60",
  scope: "Design System Plus",
  de: "Fuchsrot",
  en: "Fox red",
  nl: "Vos rood",
  fr: "Rouge renard"
}, {
  hex: "#d55845",
  code: "040 50 70",
  scope: "Design System Plus",
  de: "Pompejirot",
  en: "Pompeii red",
  nl: "Pompeii rood",
  fr: "Pompejirot"
}, {
  hex: "#9f9491",
  code: "040 60 05",
  scope: "Design System Plus",
  de: "Warmgrau",
  en: "Warm grey",
  nl: "Warm grijs",
  fr: "Gris chaud"
}, {
  hex: "#a8918b",
  code: "040 60 10",
  scope: "Design System Plus",
  de: "Hellkaramell",
  en: "Light caramel",
  nl: "Lichte karamel",
  fr: "Caramel clair"
}, {
  hex: "#b4897e",
  code: "040 60 20",
  scope: "Design System Plus",
  de: "Sienagelblich",
  en: "Sienna yellow",
  nl: "Sienna geel",
  fr: "Siennois"
}, {
  hex: "#c48677",
  code: "040 60 30",
  scope: "Design System Plus",
  de: "Zedernrot",
  en: "Cedar red",
  nl: "Cederrood",
  fr: "Rouge cèdre"
}, {
  hex: "#cf806e",
  code: "040 60 40",
  scope: "Design System Plus",
  de: "Terraorange",
  en: "Terra orange",
  nl: "Terra oranje",
  fr: "Terraorange"
}, {
  hex: "#dc7b64",
  code: "040 60 50",
  scope: "Design System Plus",
  de: "Mandarinorange",
  en: "Mandarin orange",
  nl: "Mandarijn",
  fr: "Orange mandarine"
}, {
  hex: "#e67359",
  code: "040 60 60",
  scope: "Design System Plus",
  de: "Korallenorange",
  en: "Coral orange",
  nl: "Koraaloranje",
  fr: "Orange corail"
}, {
  hex: "#b7aca9",
  code: "040 70 05",
  scope: "Design System Plus",
  de: "Passepartoutgrau",
  en: "Passepartout grey",
  nl: "Passepartout grijs",
  fr: "Gris passe-partout"
}, {
  hex: "#c2a9a3",
  code: "040 70 10",
  scope: "Design System Plus",
  de: "Mohairmauve",
  en: "Mohair mauve",
  nl: "Mohair mauve",
  fr: "Mauve mohair"
}, {
  hex: "#d2a499",
  code: "040 70 20",
  scope: "Design System Plus",
  de: "Sanftsiena",
  en: "Soft sienna",
  nl: "Sanftsiena",
  fr: "Sanftsiena"
}, {
  hex: "#e09d8d",
  code: "040 70 30",
  scope: "Design System Plus",
  de: "Industrierosé",
  en: "Industrial rose",
  nl: "Industriële rosé",
  fr: "Rosé industriel"
}, {
  hex: "#e99885",
  code: "040 70 40",
  scope: "Design System Plus",
  de: "Aprikosenrot",
  en: "Apricot red",
  nl: "Abrikoosrood",
  fr: "Rouge abricot"
}, {
  hex: "#fa9079",
  code: "040 70 50",
  scope: "Design System Plus",
  de: "Fruchtrot",
  en: "Fruit red",
  nl: "Vrucht rood",
  fr: "Rouge fruit"
}, {
  hex: "#d4c7c3",
  code: "040 80 05",
  scope: "Design System Plus",
  de: "Naturseidegrau",
  en: "Natural silk grey",
  nl: "Natuurlijke zijde grijs",
  fr: "Gris soie naturelle"
}, {
  hex: "#dec4bc",
  code: "040 80 10",
  scope: "Design System Plus",
  de: "Thulitrosé",
  en: "Thulite rose",
  nl: "Thulitrosé",
  fr: "Thulitrosé"
}, {
  hex: "#f1c1b4",
  code: "040 80 20",
  scope: "Design System Plus",
  de: "Krapporange",
  en: "Madder orange",
  nl: "Meekrap oranje",
  fr: "Orange crapaud"
}, {
  hex: "#febaa9",
  code: "040 80 30",
  scope: "Design System Plus",
  de: "Naturapricot",
  en: "Nature apricot",
  nl: "Natuurlijk abrikoos",
  fr: "Apricot naturel"
}, {
  hex: "#e1d2ce",
  code: "040 85 05",
  scope: "Design System Plus",
  de: "Pandoragrau",
  en: "Pandora grey",
  nl: "Pandora grijs",
  fr: "Gris pandora"
}, {
  hex: "#ead2ca",
  code: "040 85 10",
  scope: "Design System Plus",
  de: "Feinalabaster",
  en: "Fine alabaster",
  nl: "Fijn albast",
  fr: "Albâtre fin"
}, {
  hex: "#faccbd",
  code: "040 85 20",
  scope: "Design System Plus",
  de: "Zartsüßapricot",
  en: "Delicate sweet apricot",
  nl: "Verfijnd zoete abrikoos",
  fr: "Aricot doux"
}, {
  hex: "#f1e2dc",
  code: "040 90 05",
  scope: "Design System Plus",
  de: "Saharalichtrot",
  en: "Sahara light red",
  nl: "Sahara lichtrood",
  fr: "Rouge lumière saharienne"
}, {
  hex: "#f7e0d7",
  code: "040 90 10",
  scope: "Design System Plus",
  de: "Zartrosé",
  en: "Delicate rose",
  nl: "Lichtroze",
  fr: "Rose tendre"
}, {
  hex: "#f9eae4",
  code: "040 93 05",
  scope: "Design System Plus",
  de: "Naturweiß",
  en: "Natural white",
  nl: "Natuurlijk wit",
  fr: "Blanc naturel"
}, {
  hex: "#504541",
  code: "050 20 10",
  scope: "Design System Plus",
  de: "Granitbraun",
  en: "Granite brown",
  nl: "Granietbruin",
  fr: "Brun granite"
}, {
  hex: "#56443e",
  code: "050 20 16",
  scope: "Design System Plus",
  de: "Nachtbraun",
  en: "Night brown",
  nl: "Nacht bruin",
  fr: "Marron nuit"
}, {
  hex: "#5f504a",
  code: "050 30 10",
  scope: "Design System Plus",
  de: "Obsidianbraun",
  en: "Obsidian brown",
  nl: "Obsidiaanbruin",
  fr: "Marron obsidienne"
}, {
  hex: "#6a4f44",
  code: "050 30 20",
  scope: "Design System Plus",
  de: "Tropenholzbraun",
  en: "Tropical wood brown",
  nl: "Tropisch hout bruin",
  fr: "Marron bois tropical"
}, {
  hex: "#744c3e",
  code: "050 30 30",
  scope: "Design System Plus",
  de: "Tabakbraun",
  en: "Tobacco brown",
  nl: "Tabakbruin",
  fr: "Marron tabac"
}, {
  hex: "#7a4b3c",
  code: "050 30 36",
  scope: "Design System Plus",
  de: "Palisanderbraun",
  en: "Rosewood brown",
  nl: "Rozenhout bruin",
  fr: "Marron palissandre"
}, {
  hex: "#76645d",
  code: "050 40 10",
  scope: "Design System Plus",
  de: "Mokkaschwarz",
  en: "Mocha black",
  nl: "Mokka zwart",
  fr: "Noir moka"
}, {
  hex: "#806153",
  code: "050 40 20",
  scope: "Design System Plus",
  de: "Florentinerbraun",
  en: "Florentine brown",
  nl: "Florentijns bruin",
  fr: "Marron florentin"
}, {
  hex: "#895e4d",
  code: "050 40 30",
  scope: "Design System Plus",
  de: "Currybraun",
  en: "Curry brown",
  nl: "Kerrie bruin",
  fr: "Marron curry"
}, {
  hex: "#945943",
  code: "050 40 40",
  scope: "Design System Plus",
  de: "Madeirabraun",
  en: "Madeira brown",
  nl: "Madeira bruin",
  fr: "Marron de Madère"
}, {
  hex: "#9d5640",
  code: "050 40 50",
  scope: "Design System Plus",
  de: "Herbstrot",
  en: "Autumn red",
  nl: "Herfstrood",
  fr: "Rouge d'automne"
}, {
  hex: "#8d7b73",
  code: "050 50 10",
  scope: "Design System Plus",
  de: "Teakholzbraun",
  en: "Teakwood brown",
  nl: "Teak bruin",
  fr: "Marron teck"
}, {
  hex: "#997767",
  code: "050 50 20",
  scope: "Design System Plus",
  de: "Milchkaffeebraun",
  en: "Milk coffee brown",
  nl: "Melk koffie bruin",
  fr: "Marron café au lait"
}, {
  hex: "#a5725c",
  code: "050 50 30",
  scope: "Design System Plus",
  de: "Goldbraun",
  en: "Golden brown",
  nl: "Goudbruin",
  fr: "Marron doré"
}, {
  hex: "#ae6c50",
  code: "050 50 40",
  scope: "Design System Plus",
  de: "Kupfermetallrot",
  en: "Copper-metal red",
  nl: "Koperen metaal rood",
  fr: "Rouge cuivre métallique"
}, {
  hex: "#b96746",
  code: "050 50 50",
  scope: "Design System Plus",
  de: "Goldlackbraun",
  en: "Gold varnish brown",
  nl: "Goudlak bruin",
  fr: "Marron laqué or"
}, {
  hex: "#bd623d",
  code: "050 50 60",
  scope: "Design System Plus",
  de: "Tizianrot",
  en: "Titian red",
  nl: "Titiaan rood",
  fr: "Rouge tiziane"
}, {
  hex: "#cc5c36",
  code: "050 50 70",
  scope: "Design System Plus",
  de: "Mohnrot",
  en: "Poppy red",
  nl: "Klaproos rood",
  fr: "Rouge coquelicot"
}, {
  hex: "#d16032",
  code: "050 50 78",
  scope: "Design System Plus",
  de: "Persischorange",
  en: "Persian orange",
  nl: "Perzische sinaasappel",
  fr: "Orange persane"
}, {
  hex: "#a59188",
  code: "050 60 10",
  scope: "Design System Plus",
  de: "Ecruocker",
  en: "Ecru ochre",
  nl: "Ecruocker",
  fr: "Ecruocker"
}, {
  hex: "#b18c7b",
  code: "050 60 20",
  scope: "Design System Plus",
  de: "Karamellbraun",
  en: "Caramel brown",
  nl: "Karamelbruin",
  fr: "Marron caramel"
}, {
  hex: "#c28971",
  code: "050 60 30",
  scope: "Design System Plus",
  de: "Mittelbraun",
  en: "Medium brown",
  nl: "Medium bruin",
  fr: "Marron moyen"
}, {
  hex: "#c98365",
  code: "050 60 40",
  scope: "Design System Plus",
  de: "Apricotbraun",
  en: "Apricot brown",
  nl: "Abrikoosbruin",
  fr: "Marron abricot"
}, {
  hex: "#d67f59",
  code: "050 60 50",
  scope: "Design System Plus",
  de: "Orangegelb",
  en: "Orange yellow",
  nl: "Oranje geel",
  fr: "Jaune orangé"
}, {
  hex: "#e17b4e",
  code: "050 60 60",
  scope: "Design System Plus",
  de: "Kamelrot",
  en: "Camel red",
  nl: "Kameelrood",
  fr: "Rouge chameau"
}, {
  hex: "#e67045",
  code: "050 60 70",
  scope: "Design System Plus",
  de: "Karottenorange",
  en: "Carrot orange",
  nl: "Wortel oranje",
  fr: "Orange carotte"
}, {
  hex: "#f26d3f",
  code: "050 60 80",
  scope: "Design System Plus",
  de: "Gerberarot",
  en: "Gerbera red",
  nl: "Tanner rood",
  fr: "Rouge de Gerber"
}, {
  hex: "#c0aca2",
  code: "050 70 10",
  scope: "Design System Plus",
  de: "Bambusbeige",
  en: "Bamboo beige",
  nl: "Bamboe beige",
  fr: "Beige bambou"
}, {
  hex: "#cea796",
  code: "050 70 20",
  scope: "Design System Plus",
  de: "Bernsteingrau",
  en: "Amber grey",
  nl: "Ambergrijs",
  fr: "Gris ambré"
}, {
  hex: "#dba188",
  code: "050 70 30",
  scope: "Design System Plus",
  de: "Sienaocker",
  en: "Sienna ochre",
  nl: "Siena oker",
  fr: "Tabouret de Sienne"
}, {
  hex: "#e99b7b",
  code: "050 70 40",
  scope: "Design System Plus",
  de: "Amberhellorange",
  en: "Light amber orange",
  nl: "Amber lichtoranje",
  fr: "Orange clair ambré"
}, {
  hex: "#f39670",
  code: "050 70 50",
  scope: "Design System Plus",
  de: "Melonenrot",
  en: "Melon red",
  nl: "Meloenrood",
  fr: "Rouge melon"
}, {
  hex: "#fe9063",
  code: "050 70 60",
  scope: "Design System Plus",
  de: "Mangoorange",
  en: "Mango orange",
  nl: "Mangosinaasappel",
  fr: "Orange mangue"
}, {
  hex: "#dbc5bb",
  code: "050 80 10",
  scope: "Design System Plus",
  de: "Blasssiena",
  en: "Pale sienna",
  nl: "Bleke sienna",
  fr: "Blasssiena"
}, {
  hex: "#e9bfac",
  code: "050 80 20",
  scope: "Design System Plus",
  de: "Sanftorange",
  en: "Soft orange",
  nl: "Zacht oranje",
  fr: "Orange douce"
}, {
  hex: "#f6b99f",
  code: "050 80 30",
  scope: "Design System Plus",
  de: "Fahlorange",
  en: "Pallid orange",
  nl: "Lichtoranje",
  fr: "Orange pâle"
}, {
  hex: "#e2d3cc",
  code: "050 85 05",
  scope: "Design System Plus",
  de: "Meersand",
  en: "Ocean sand",
  nl: "Zeezand",
  fr: "Sable de mer"
}, {
  hex: "#e6cfc3",
  code: "050 85 10",
  scope: "Design System Plus",
  de: "Reinbeige",
  en: "Pure beige",
  nl: "Puur beige",
  fr: "Beige pur"
}, {
  hex: "#f6cbb7",
  code: "050 85 20",
  scope: "Design System Plus",
  de: "Biscuitcreme",
  en: "Biscuit cream",
  nl: "Koekjescrème",
  fr: "Crème de biscuit"
}, {
  hex: "#ede0d8",
  code: "050 90 05",
  scope: "Design System Plus",
  de: "Eierschalenweiß",
  en: "Eggshell white",
  nl: "Eischaal wit",
  fr: "Blanc coquille d'œuf"
}, {
  hex: "#fbe2d6",
  code: "050 90 10",
  scope: "Design System Plus",
  de: "Hellpfirsichrosé",
  en: "Light peach rose",
  nl: "Lichte perzikrosé",
  fr: "Rose pêche clair"
}, {
  hex: "#f9ebe4",
  code: "050 93 05",
  scope: "Design System Plus",
  de: "Tüllweiß",
  en: "Tulle white",
  nl: "Tule wit",
  fr: "Tulle blanc"
}, {
  hex: "#4a4643",
  code: "060 20 05",
  scope: "Design System Plus",
  de: "Industrieschwarz",
  en: "Industrial black",
  nl: "Industrieel zwart",
  fr: "Noir industriel"
}, {
  hex: "#5c5551",
  code: "060 30 05",
  scope: "Design System Plus",
  de: "Karosseriegrau",
  en: "Vehicle body grey",
  nl: "Lichaam grijs",
  fr: "Gris carrosserie"
}, {
  hex: "#60534b",
  code: "060 30 10",
  scope: "Design System Plus",
  de: "Nutriafellbraun",
  en: "Nutria fur brown",
  nl: "Nutria bont bruin",
  fr: "Marron nutraceutique"
}, {
  hex: "#665042",
  code: "060 30 20",
  scope: "Design System Plus",
  de: "Torfbraun",
  en: "Peat brown",
  nl: "Turfbruin",
  fr: "Marron tourbe"
}, {
  hex: "#6f5141",
  code: "060 30 27",
  scope: "Design System Plus",
  de: "Zinnsteinbraun",
  en: "Cassiterite brown",
  nl: "Tinnen bruin",
  fr: "Brun ambré"
}, {
  hex: "#716863",
  code: "060 40 05",
  scope: "Design System Plus",
  de: "Zinkgrau",
  en: "Zinc grey",
  nl: "Zinkgrijs",
  fr: "Gris zinc"
}, {
  hex: "#75655c",
  code: "060 40 10",
  scope: "Design System Plus",
  de: "Mooreichengrau",
  en: "Moor oak grey",
  nl: "Eiken moeras grijs",
  fr: "Gris chêne des marais"
}, {
  hex: "#7f6351",
  code: "060 40 20",
  scope: "Design System Plus",
  de: "Kaffeebohnenbraun",
  en: "Coffee bean brown",
  nl: "Koffieboon bruin",
  fr: "Marron grain de café"
}, {
  hex: "#876048",
  code: "060 40 30",
  scope: "Design System Plus",
  de: "Brasilbraun",
  en: "Brazilian brown",
  nl: "Braziliaans bruin",
  fr: "Marron brésilien"
}, {
  hex: "#915f41",
  code: "060 40 40",
  scope: "Design System Plus",
  de: "Platanenbraun",
  en: "Plane brown",
  nl: "Plataan bruin",
  fr: "Marron platane"
}, {
  hex: "#877d77",
  code: "060 50 05",
  scope: "Design System Plus",
  de: "Chinchillagrau",
  en: "Chinchilla grey",
  nl: "Chinchilla grijs",
  fr: "Gris chinchilla"
}, {
  hex: "#8c7c71",
  code: "060 50 10",
  scope: "Design System Plus",
  de: "Sandsteingrau",
  en: "Sandstone grey",
  nl: "Zandsteengrijs",
  fr: "Gris grès"
}, {
  hex: "#967965",
  code: "060 50 20",
  scope: "Design System Plus",
  de: "Champignonbraun",
  en: "Mushroom brown",
  nl: "Paddenstoel bruin",
  fr: "Marron champignon"
}, {
  hex: "#a2775a",
  code: "060 50 30",
  scope: "Design System Plus",
  de: "Senfbraun",
  en: "Mustard brown",
  nl: "Mosterdbruin",
  fr: "Marron moutarde"
}, {
  hex: "#aa714d",
  code: "060 50 40",
  scope: "Design System Plus",
  de: "Kamelbraun",
  en: "Camel brown",
  nl: "Camelbruin",
  fr: "Brun chameau"
}, {
  hex: "#b37045",
  code: "060 50 50",
  scope: "Design System Plus",
  de: "Dattelfruchtbraun",
  en: "Date fruit brown",
  nl: "Dadelvrucht bruin",
  fr: "Marron fruit de la datte"
}, {
  hex: "#b66838",
  code: "060 50 60",
  scope: "Design System Plus",
  de: "Rüsterbraunrot",
  en: "Elm brown red",
  nl: "Iep bruin rood",
  fr: "Rouge brun d'orme"
}, {
  hex: "#c16933",
  code: "060 50 70",
  scope: "Design System Plus",
  de: "Trockenlehm",
  en: "Dry clay",
  nl: "Droge klei",
  fr: "Argile sèche"
}, {
  hex: "#a09790",
  code: "060 60 05",
  scope: "Design System Plus",
  de: "Estrichgrau",
  en: "Screed grey",
  nl: "Screed grijs",
  fr: "Gris chape"
}, {
  hex: "#a59387",
  code: "060 60 10",
  scope: "Design System Plus",
  de: "Eichenbraun",
  en: "Oak brown",
  nl: "Eiken bruin",
  fr: "Chêne brun"
}, {
  hex: "#b4907b",
  code: "060 60 20",
  scope: "Design System Plus",
  de: "Topashellocker",
  en: "Light topaz ochre",
  nl: "Topashellocker",
  fr: "Topashellocker"
}, {
  hex: "#bc8d6d",
  code: "060 60 30",
  scope: "Design System Plus",
  de: "Cognacbraun",
  en: "Cognac brown",
  nl: "Cognacbruin",
  fr: "Marron cognac"
}, {
  hex: "#cb8c5e",
  code: "060 60 40",
  scope: "Design System Plus",
  de: "Ahornsirupbraun",
  en: "Maple syrup brown",
  nl: "Ahornsiroop bruin",
  fr: "Brun sirop d'érable"
}, {
  hex: "#cc814e",
  code: "060 60 50",
  scope: "Design System Plus",
  de: "Kurkumarot",
  en: "Turmeric red",
  nl: "Kurkuma rood",
  fr: "Rouge de curcuma"
}, {
  hex: "#d77f43",
  code: "060 60 60",
  scope: "Design System Plus",
  de: "Bitterorange",
  en: "Bitter orange",
  nl: "Bittere sinaasappel",
  fr: "Orange amère"
}, {
  hex: "#dc7c37",
  code: "060 60 70",
  scope: "Design System Plus",
  de: "Goldorange",
  en: "Gold orange",
  nl: "Goudoranje",
  fr: "Orange doré"
}, {
  hex: "#e6752a",
  code: "060 60 80",
  scope: "Design System Plus",
  de: "Akzentorange",
  en: "Accent orange",
  nl: "Accent oranje",
  fr: "Orange d'accent"
}, {
  hex: "#b9afa9",
  code: "060 70 05",
  scope: "Design System Plus",
  de: "Zementgreige",
  en: "Cement greige",
  nl: "Cementdeeg",
  fr: "Pâte à ciment"
}, {
  hex: "#c0ada1",
  code: "060 70 10",
  scope: "Design System Plus",
  de: "Kittgrau",
  en: "Putty grey",
  nl: "Putty grijs",
  fr: "Gris mastic"
}, {
  hex: "#cba891",
  code: "060 70 20",
  scope: "Design System Plus",
  de: "Erdnusscreme",
  en: "Peanut butter",
  nl: "Pindacrème",
  fr: "Crème de cacahuètes"
}, {
  hex: "#d3a281",
  code: "060 70 30",
  scope: "Design System Plus",
  de: "Pfirsichgelb",
  en: "Peach yellow",
  nl: "Perzikgeel",
  fr: "Jaune pêche"
}, {
  hex: "#e1a074",
  code: "060 70 40",
  scope: "Design System Plus",
  de: "Kerzengelb",
  en: "Candle yellow",
  nl: "Kaars geel",
  fr: "Jaune bougie"
}, {
  hex: "#eb9c67",
  code: "060 70 50",
  scope: "Design System Plus",
  de: "Topasgelb",
  en: "Topaz yellow",
  nl: "Topaas geel",
  fr: "Jaune topaze"
}, {
  hex: "#f19758",
  code: "060 70 60",
  scope: "Design System Plus",
  de: "Melonenorange",
  en: "Melon orange",
  nl: "Meloen oranje",
  fr: "Orange melon"
}, {
  hex: "#fc9348",
  code: "060 70 70",
  scope: "Design System Plus",
  de: "Indischgelb",
  en: "Indian yellow",
  nl: "Indiaas geel",
  fr: "Jaune indien"
}, {
  hex: "#d3c9c1",
  code: "060 80 05",
  scope: "Design System Plus",
  de: "Chamoishellbeige",
  en: "Light chamois beige",
  nl: "Zeem licht beige",
  fr: "Beige clair chamois"
}, {
  hex: "#d8c6b9",
  code: "060 80 10",
  scope: "Design System Plus",
  de: "Sanftgreige",
  en: "Soft greige",
  nl: "Zacht grijs",
  fr: "Grains doux"
}, {
  hex: "#e7c2aa",
  code: "060 80 20",
  scope: "Design System Plus",
  de: "Keksbeige",
  en: "Biscuit beige",
  nl: "Koekjesbeige",
  fr: "Beige biscuit"
}, {
  hex: "#f4be9a",
  code: "060 80 30",
  scope: "Design System Plus",
  de: "Mildorange",
  en: "Mild orange",
  nl: "Mild oranje",
  fr: "Orange douce"
}, {
  hex: "#fdb889",
  code: "060 80 40",
  scope: "Design System Plus",
  de: "Apricotorange",
  en: "Apricot orange",
  nl: "Abrikoos sinaasappel",
  fr: "Orange abricot"
}, {
  hex: "#e0d4cc",
  code: "060 85 05",
  scope: "Design System Plus",
  de: "Champagnerrosé",
  en: "Champagne rose",
  nl: "Champagne rosé",
  fr: "Rose champagne"
}, {
  hex: "#e8d3c5",
  code: "060 85 10",
  scope: "Design System Plus",
  de: "Maismehlbeige",
  en: "Cornmeal beige",
  nl: "Korenbloem beige",
  fr: "Beige de farine de maïs"
}, {
  hex: "#f3cfb6",
  code: "060 85 20",
  scope: "Design System Plus",
  de: "Teiggelb",
  en: "Dough yellow",
  nl: "Deeg geel",
  fr: "Jaune de pâte"
}, {
  hex: "#ffcca5",
  code: "060 85 30",
  scope: "Design System Plus",
  de: "Safranhellorange",
  en: "Light saffron orange",
  nl: "Saffraan licht oranje",
  fr: "Orange safran clair"
}, {
  hex: "#efe3d9",
  code: "060 90 05",
  scope: "Design System Plus",
  de: "Kornweiß",
  en: "Grain white",
  nl: "Korrel wit",
  fr: "Blanc grain"
}, {
  hex: "#f7e0d2",
  code: "060 90 10",
  scope: "Design System Plus",
  de: "Vanillecreme",
  en: "Vanilla cream",
  nl: "Vanillecrème",
  fr: "Crème à la vanille"
}, {
  hex: "#fcdcc9",
  code: "060 90 15",
  scope: "Design System Plus",
  de: "Aprikosencreme",
  en: "Apricot cream",
  nl: "Abrikozencrème",
  fr: "Crème à l'abricot"
}, {
  hex: "#f7ebe2",
  code: "060 93 05",
  scope: "Design System Plus",
  de: "Wollweiß",
  en: "Wool white",
  nl: "Wol wit",
  fr: "Blanc laine"
}, {
  hex: "#5c5148",
  code: "070 30 10",
  scope: "Design System Plus",
  de: "Mineralbraun",
  en: "Mineral brown",
  nl: "Mineraal bruin",
  fr: "Marron minéral"
}, {
  hex: "#655444",
  code: "070 30 20",
  scope: "Design System Plus",
  de: "Buchenbraun",
  en: "Beech brown",
  nl: "Beukenbruin",
  fr: "Brun hêtre"
}, {
  hex: "#71655a",
  code: "070 40 10",
  scope: "Design System Plus",
  de: "Nerzfellbraun",
  en: "Mink brown",
  nl: "Nertsbont bruin",
  fr: "Brun en peau de vison"
}, {
  hex: "#7a634e",
  code: "070 40 20",
  scope: "Design System Plus",
  de: "Elsbeerenbraun",
  en: "Huckleberry brown",
  nl: "Wilde dienstboom bruin",
  fr: "Brun d'alisier"
}, {
  hex: "#826448",
  code: "070 40 30",
  scope: "Design System Plus",
  de: "Ackerbraun",
  en: "Arable brown",
  nl: "Veld bruin",
  fr: "Marron des champs"
}, {
  hex: "#88613d",
  code: "070 40 40",
  scope: "Design System Plus",
  de: "Herbstgold",
  en: "Autumn gold",
  nl: "Herfst goud",
  fr: "Or d'automne"
}, {
  hex: "#887b6e",
  code: "070 50 10",
  scope: "Design System Plus",
  de: "Sarukgrau",
  en: "Saruk grey",
  nl: "Saruk grijs",
  fr: "Gris sarouk"
}, {
  hex: "#927961",
  code: "070 50 20",
  scope: "Design System Plus",
  de: "Aschgold",
  en: "Ash gold",
  nl: "Asgoud",
  fr: "Or cendré"
}, {
  hex: "#997552",
  code: "070 50 30",
  scope: "Design System Plus",
  de: "Löwenmähnenblond",
  en: "Lion's mane blonde",
  nl: "Leeuwenmanen blond",
  fr: "Blond crinière de lion"
}, {
  hex: "#a17344",
  code: "070 50 40",
  scope: "Design System Plus",
  de: "Altgold",
  en: "Antique gold",
  nl: "Oud goud",
  fr: "Vieil or"
}, {
  hex: "#a2723d",
  code: "070 50 50",
  scope: "Design System Plus",
  de: "Bühnengold",
  en: "Stage gold",
  nl: "Podium goud",
  fr: "Or de scène"
}, {
  hex: "#aa7034",
  code: "070 50 55",
  scope: "Design System Plus",
  de: "Theatergold",
  en: "Theatre gold",
  nl: "Theater goud",
  fr: "L'or du théâtre"
}, {
  hex: "#a19285",
  code: "070 60 10",
  scope: "Design System Plus",
  de: "Hellmahagoni",
  en: "Light mahogany",
  nl: "Licht mahonie",
  fr: "Acajou clair"
}, {
  hex: "#ab9178",
  code: "070 60 20",
  scope: "Design System Plus",
  de: "Dunkelblond",
  en: "Dark blond",
  nl: "Donkerblond",
  fr: "Blond foncé"
}, {
  hex: "#b38c67",
  code: "070 60 30",
  scope: "Design System Plus",
  de: "Eichenhellbraun",
  en: "Light oak brown",
  nl: "Licht eikenbruin",
  fr: "Chêne brun clair"
}, {
  hex: "#bb8b58",
  code: "070 60 40",
  scope: "Design System Plus",
  de: "Kornbraun",
  en: "Grain brown",
  nl: "Korrel bruin",
  fr: "Marron grain"
}, {
  hex: "#c48949",
  code: "070 60 50",
  scope: "Design System Plus",
  de: "Schlammgelb",
  en: "Mud yellow",
  nl: "Moddergeel",
  fr: "Jaune boue"
}, {
  hex: "#cc863b",
  code: "070 60 60",
  scope: "Design System Plus",
  de: "Senfgelb",
  en: "Mustard yellow",
  nl: "Mosterdgeel",
  fr: "Jaune moutarde"
}, {
  hex: "#cf8432",
  code: "070 60 70",
  scope: "Design System Plus",
  de: "Sanddorngelbbraun",
  en: "Sea buckthorn yellow brown",
  nl: "Duindoorn geelbruin",
  fr: "Brun jaune d'argousier"
}, {
  hex: "#d1812a",
  code: "070 60 75",
  scope: "Design System Plus",
  de: "Herbstlauborange",
  en: "Autumn leaf orange",
  nl: "Herfstblad oranje",
  fr: "Orange feuille d'automne"
}, {
  hex: "#baac9d",
  code: "070 70 10",
  scope: "Design System Plus",
  de: "Ingwergraugelb",
  en: "Ginger grey yellow",
  nl: "Gembergrijs geel",
  fr: "Jaune gingembre"
}, {
  hex: "#c5a98d",
  code: "070 70 20",
  scope: "Design System Plus",
  de: "Eschehellbraun",
  en: "Light ash brown",
  nl: "As lichtbruin",
  fr: "Frêne brun clair"
}, {
  hex: "#d0a77e",
  code: "070 70 30",
  scope: "Design System Plus",
  de: "Goldbeige",
  en: "Golden beige",
  nl: "Goudbeige",
  fr: "Beige doré"
}, {
  hex: "#d19f6a",
  code: "070 70 40",
  scope: "Design System Plus",
  de: "Dechantsbirnengelb",
  en: "Dechant pear yellow",
  nl: "Dean's peer geel",
  fr: "Jaune poire de Dechants"
}, {
  hex: "#dfa15f",
  code: "070 70 50",
  scope: "Design System Plus",
  de: "Honigwabengelb",
  en: "Honeycomb yellow",
  nl: "Honingraat geel",
  fr: "Jaune nid d'abeille"
}, {
  hex: "#e9a04f",
  code: "070 70 60",
  scope: "Design System Plus",
  de: "Ginstergelborange",
  en: "Gorse yellow orange",
  nl: "Bezem geel oranje",
  fr: "Jaune genêt orange"
}, {
  hex: "#eb9a3f",
  code: "070 70 70",
  scope: "Design System Plus",
  de: "Neapelgelb",
  en: "Naples yellow",
  nl: "Napels geel",
  fr: "Jaune de Naples"
}, {
  hex: "#f09630",
  code: "070 70 80",
  scope: "Design System Plus",
  de: "Safrangold",
  en: "Saffron gold",
  nl: "Saffraan goud",
  fr: "Or safrané"
}, {
  hex: "#d5c5b6",
  code: "070 80 10",
  scope: "Design System Plus",
  de: "Flachsbeige",
  en: "Flax beige",
  nl: "Vlassig beige",
  fr: "Beige plat"
}, {
  hex: "#e4c5a8",
  code: "070 80 20",
  scope: "Design System Plus",
  de: "Butterblumengelb",
  en: "Buttercup yellow",
  nl: "Boterbloem geel",
  fr: "Jaune bouton d'or"
}, {
  hex: "#ecc196",
  code: "070 80 30",
  scope: "Design System Plus",
  de: "Goldhaferfarben",
  en: "Golden oat coloured",
  nl: "Goudkleurige haver",
  fr: "Couleur avoine dorée"
}, {
  hex: "#f6c088",
  code: "070 80 40",
  scope: "Design System Plus",
  de: "Aprikosengelb",
  en: "Apricot yellow",
  nl: "Abrikoosgeel",
  fr: "Jaune abricot"
}, {
  hex: "#febc75",
  code: "070 80 50",
  scope: "Design System Plus",
  de: "Warmapricot",
  en: "Warm apricot",
  nl: "Warmeprik",
  fr: "Warmapricot"
}, {
  hex: "#ffba65",
  code: "070 80 60",
  scope: "Design System Plus",
  de: "Goldregengelb",
  en: "Golden rain yellow",
  nl: "Gouden regen geel",
  fr: "Jaune pluie d'or"
}, {
  hex: "#ded4ca",
  code: "070 85 05",
  scope: "Design System Plus",
  de: "Mandelkernbeige",
  en: "Almond beige",
  nl: "Amandelkern beige",
  fr: "Beige cœur d'amande"
}, {
  hex: "#e5d3c5",
  code: "070 85 10",
  scope: "Design System Plus",
  de: "Silberdistelbeige",
  en: "Silver thistle beige",
  nl: "Zilveren distel beige",
  fr: "Beige chardon argenté"
}, {
  hex: "#efd0b2",
  code: "070 85 20",
  scope: "Design System Plus",
  de: "Sandelholzbeige",
  en: "Sandalwood beige",
  nl: "Sandelhout beige",
  fr: "Beige santal"
}, {
  hex: "#facfa2",
  code: "070 85 30",
  scope: "Design System Plus",
  de: "Haarblond",
  en: "Hair blonde",
  nl: "Haar blond",
  fr: "Blond des cheveux"
}, {
  hex: "#ede3da",
  code: "070 90 05",
  scope: "Design System Plus",
  de: "Offwhite",
  en: "Off white",
  nl: "Offwhite",
  fr: "Blanc cassé"
}, {
  hex: "#f3e2d2",
  code: "070 90 10",
  scope: "Design System Plus",
  de: "Hellmais",
  en: "Light corn",
  nl: "Hellmais",
  fr: "Hellmais"
}, {
  hex: "#fedec0",
  code: "070 90 20",
  scope: "Design System Plus",
  de: "Kreidegelb",
  en: "Chalk yellow",
  nl: "Krijt geel",
  fr: "Jaune craie"
}, {
  hex: "#f7ece2",
  code: "070 93 05",
  scope: "Design System Plus",
  de: "Anemonenweiß",
  en: "Anemone white",
  nl: "Anemoon wit",
  fr: "Blanc anémone"
}, {
  hex: "#71685d",
  code: "075 40 10",
  scope: "Design System Plus",
  de: "Baumrindenbraun",
  en: "Tree bark brown",
  nl: "Boomschors bruin",
  fr: "Brun écorce d'arbre"
}, {
  hex: "#786551",
  code: "075 40 20",
  scope: "Design System Plus",
  de: "Kümmelfruchtbraun",
  en: "Caraway brown",
  nl: "Karwijvruchten bruin",
  fr: "Marron fruit de carvi"
}, {
  hex: "#7d6346",
  code: "075 40 30",
  scope: "Design System Plus",
  de: "Borkenbraun",
  en: "Bark brown",
  nl: "Schors bruin",
  fr: "Marron bordeaux"
}, {
  hex: "#81633e",
  code: "075 40 38",
  scope: "Design System Plus",
  de: "Eidechsenbraun",
  en: "Lizard brown",
  nl: "Hagedis bruin",
  fr: "Marron lézard"
}, {
  hex: "#887d71",
  code: "075 50 10",
  scope: "Design System Plus",
  de: "Roggenteigbraun",
  en: "Rye dough brown",
  nl: "Rogge deeg bruin",
  fr: "Marron pâte de seigle"
}, {
  hex: "#907a62",
  code: "075 50 20",
  scope: "Design System Plus",
  de: "Chinazimt",
  en: "China cinnamon",
  nl: "Chinese kaneel",
  fr: "Cannelle de Chine"
}, {
  hex: "#987954",
  code: "075 50 30",
  scope: "Design System Plus",
  de: "Chamottegelb",
  en: "Grog yellow",
  nl: "Chamotte geel",
  fr: "Jaune chamotte"
}, {
  hex: "#9e7749",
  code: "075 50 40",
  scope: "Design System Plus",
  de: "Bernsteinbraun",
  en: "Amber brown",
  nl: "Amberbruin",
  fr: "Marron ambré"
}, {
  hex: "#a3753c",
  code: "075 50 50",
  scope: "Design System Plus",
  de: "Zimtbraun",
  en: "Cinnamon brown",
  nl: "Kaneelbruin",
  fr: "Marron cannelle"
}, {
  hex: "#a47232",
  code: "075 50 58",
  scope: "Design System Plus",
  de: "Kreuzkümmelocker",
  en: "Cumin ochre",
  nl: "Komijn oker",
  fr: "Gingembre au cumin"
}, {
  hex: "#a29487",
  code: "075 60 10",
  scope: "Design System Plus",
  de: "Kittgelb",
  en: "Putty yellow",
  nl: "Putty geel",
  fr: "Jaune mastic"
}, {
  hex: "#aa9278",
  code: "075 60 20",
  scope: "Design System Plus",
  de: "Walnussschalenbraun",
  en: "Walnut shell brown",
  nl: "Walnoot schelp bruin",
  fr: "Brun écorce de noix"
}, {
  hex: "#b29069",
  code: "075 60 30",
  scope: "Design System Plus",
  de: "Lehmocker",
  en: "Clay ochre",
  nl: "Kleikrukje",
  fr: "Lehmocker"
}, {
  hex: "#b98e5a",
  code: "075 60 40",
  scope: "Design System Plus",
  de: "Funchalgelb",
  en: "Funchal yellow",
  nl: "Funchal geel",
  fr: "Jaune Funchal"
}, {
  hex: "#be8c49",
  code: "075 60 50",
  scope: "Design System Plus",
  de: "Mangobraun",
  en: "Mango brown",
  nl: "Mangobruin",
  fr: "Marron mangue"
}, {
  hex: "#c3893a",
  code: "075 60 60",
  scope: "Design System Plus",
  de: "Kurkumabraun",
  en: "Turmeric brown",
  nl: "Kurkuma bruin",
  fr: "Marron curcuma"
}, {
  hex: "#ca872a",
  code: "075 60 70",
  scope: "Design System Plus",
  de: "Bambusbraun",
  en: "Bamboo brown",
  nl: "Bamboe bruin",
  fr: "Marron bambou"
}, {
  hex: "#baad9f",
  code: "075 70 10",
  scope: "Design System Plus",
  de: "Flachsfasergrau",
  en: "Flax fibre grey",
  nl: "Vlasvezel grijs",
  fr: "Gris fibre de lin"
}, {
  hex: "#c4aa8c",
  code: "075 70 20",
  scope: "Design System Plus",
  de: "Kürbishellbraun",
  en: "Light pumpkin brown",
  nl: "Pompoen lichtbruin",
  fr: "Marron clair citrouille"
}, {
  hex: "#cca87e",
  code: "075 70 30",
  scope: "Design System Plus",
  de: "Golddistelgelb",
  en: "Golden thistle yellow",
  nl: "Gouden distel geel",
  fr: "Jaune chardon doré"
}, {
  hex: "#d3a56c",
  code: "075 70 40",
  scope: "Design System Plus",
  de: "Backsteingelb",
  en: "Brick yellow",
  nl: "Baksteen geel",
  fr: "Jaune brique"
}, {
  hex: "#daa45e",
  code: "075 70 50",
  scope: "Design System Plus",
  de: "Bambustiefgelb",
  en: "Deep bamboo yellow",
  nl: "Bamboe diepgeel",
  fr: "Jaune profond de bambou"
}, {
  hex: "#e2a14b",
  code: "075 70 60",
  scope: "Design System Plus",
  de: "Intensivgelb",
  en: "Intense yellow",
  nl: "Intens geel",
  fr: "Jaune intense"
}, {
  hex: "#eaa139",
  code: "075 70 70",
  scope: "Design System Plus",
  de: "Kürbisgelb",
  en: "Pumpkin yellow",
  nl: "Pompoen geel",
  fr: "Jaune citrouille"
}, {
  hex: "#eb9f2b",
  code: "075 70 80",
  scope: "Design System Plus",
  de: "Herbstgelb",
  en: "Autumn yellow",
  nl: "Herfstgeel",
  fr: "Jaune d'automne"
}, {
  hex: "#d7c8b8",
  code: "075 80 10",
  scope: "Design System Plus",
  de: "Kalkbeige",
  en: "Chalk beige",
  nl: "Kalkbeige",
  fr: "Beige calcaire"
}, {
  hex: "#e1c6a7",
  code: "075 80 20",
  scope: "Design System Plus",
  de: "Hellweizengelb",
  en: "Light corn yellow",
  nl: "Licht tarwegeel",
  fr: "Jaune blé clair"
}, {
  hex: "#e8c295",
  code: "075 80 30",
  scope: "Design System Plus",
  de: "Dunkelgelb",
  en: "Dark yellow",
  nl: "Donkergeel",
  fr: "Jaune foncé"
}, {
  hex: "#f0c186",
  code: "075 80 40",
  scope: "Design System Plus",
  de: "Eschengelb",
  en: "Ash yellow",
  nl: "Asgeel",
  fr: "Jaune frêne"
}, {
  hex: "#f6bd73",
  code: "075 80 50",
  scope: "Design System Plus",
  de: "Orientgelb",
  en: "Orient yellow",
  nl: "Oosters geel",
  fr: "Jaune d'Orient"
}, {
  hex: "#ffbb63",
  code: "075 80 60",
  scope: "Design System Plus",
  de: "Kutschengelb",
  en: "Carriage yellow",
  nl: "Rijtuig geel",
  fr: "Jaune calèche"
}, {
  hex: "#e4d4c3",
  code: "075 85 10",
  scope: "Design System Plus",
  de: "Seerosenweiß",
  en: "Water lily white",
  nl: "Waterlelie wit",
  fr: "Blanc nénuphar"
}, {
  hex: "#eed2b2",
  code: "075 85 20",
  scope: "Design System Plus",
  de: "Bananeneiscreme",
  en: "Banana ice cream",
  nl: "Bananenijs",
  fr: "Crème glacée à la banane"
}, {
  hex: "#f7d0a2",
  code: "075 85 30",
  scope: "Design System Plus",
  de: "Ahornbeige",
  en: "Maple beige",
  nl: "Esdoorn beige",
  fr: "Beige érable"
}, {
  hex: "#fecd90",
  code: "075 85 40",
  scope: "Design System Plus",
  de: "Goldrutengelb",
  en: "Goldenrod yellow",
  nl: "Guldenroede geel",
  fr: "Jaune verge d'or"
}, {
  hex: "#f5e5d2",
  code: "075 90 10",
  scope: "Design System Plus",
  de: "Süßspeisecreme",
  en: "Dessert cream",
  nl: "Dessertcrème",
  fr: "Crème dessert"
}, {
  hex: "#fce0c0",
  code: "075 90 20",
  scope: "Design System Plus",
  de: "Butterweiß",
  en: "Butter white",
  nl: "Boter wit",
  fr: "Blanc beurre"
}, {
  hex: "#f4ece3",
  code: "075 93 05",
  scope: "Design System Plus",
  de: "Vanilleweiß",
  en: "Vanilla white",
  nl: "Vanille wit",
  fr: "Blanc vanille"
}, {
  hex: "#4a4743",
  code: "080 20 05",
  scope: "Design System Plus",
  de: "Nachtbraunschwarz",
  en: "Night brown black",
  nl: "Nacht bruin zwart",
  fr: "Noir brun nuit"
}, {
  hex: "#4d4740",
  code: "080 20 10",
  scope: "Design System Plus",
  de: "Vanilleschotenbraun",
  en: "Vanilla bean brown",
  nl: "Vanilleboon bruin",
  fr: "Gousse de vanille brune"
}, {
  hex: "#5a5550",
  code: "080 30 05",
  scope: "Design System Plus",
  de: "Erdschwarz",
  en: "Earth black",
  nl: "Aarde zwart",
  fr: "Noir de terre"
}, {
  hex: "#5c544a",
  code: "080 30 10",
  scope: "Design System Plus",
  de: "Olivschwarz",
  en: "Olive black",
  nl: "Olijf zwart",
  fr: "Noir olive"
}, {
  hex: "#615341",
  code: "080 30 20",
  scope: "Design System Plus",
  de: "Nelkengelbbraun",
  en: "Clove yellow brown",
  nl: "Anjer geelbruin",
  fr: "Marron jaune œillet"
}, {
  hex: "#64533c",
  code: "080 30 26",
  scope: "Design System Plus",
  de: "Raucheichenbraun",
  en: "Smoked oak brown",
  nl: "Rokerig eikenbruin",
  fr: "Marron chêne fumé"
}, {
  hex: "#6e6962",
  code: "080 40 05",
  scope: "Design System Plus",
  de: "Bürograu",
  en: "Office grey",
  nl: "Kantoor grijs",
  fr: "Gris bureau"
}, {
  hex: "#71685b",
  code: "080 40 10",
  scope: "Design System Plus",
  de: "Steinbraun",
  en: "Stone brown",
  nl: "Steenbruin",
  fr: "Marron pierre"
}, {
  hex: "#76654d",
  code: "080 40 20",
  scope: "Design System Plus",
  de: "Pimentkornbraun",
  en: "Pimento grain brown",
  nl: "Pimentkorrel bruin",
  fr: "Brun grain de piment"
}, {
  hex: "#7b6442",
  code: "080 40 30",
  scope: "Design System Plus",
  de: "Ockergrün",
  en: "Ochre green",
  nl: "Okergroen",
  fr: "Vert ocre"
}, {
  hex: "#82653a",
  code: "080 40 40",
  scope: "Design System Plus",
  de: "Herbstlaubbraun",
  en: "Autumn leaf brown",
  nl: "Herfstblad bruin",
  fr: "Marron feuilles d'automne"
}, {
  hex: "#837e76",
  code: "080 50 05",
  scope: "Design System Plus",
  de: "Dämmergrau",
  en: "Dusk grey",
  nl: "Schemer grijs",
  fr: "Gris crépuscule"
}, {
  hex: "#877c6f",
  code: "080 50 10",
  scope: "Design System Plus",
  de: "Roggenbraun",
  en: "Rye brown",
  nl: "Roggebruin",
  fr: "Marron seigle"
}, {
  hex: "#8e7b60",
  code: "080 50 20",
  scope: "Design System Plus",
  de: "Graugelb",
  en: "Greyish yellow",
  nl: "Grijsgeel",
  fr: "Jaune gris"
}, {
  hex: "#937a53",
  code: "080 50 30",
  scope: "Design System Plus",
  de: "Chiligrün",
  en: "Chili green",
  nl: "Chilipeper groen",
  fr: "Vert piment"
}, {
  hex: "#977845",
  code: "080 50 40",
  scope: "Design System Plus",
  de: "Schmutzgelb",
  en: "Dirt yellow",
  nl: "Vies geel",
  fr: "Jaune sale"
}, {
  hex: "#9c7839",
  code: "080 50 50",
  scope: "Design System Plus",
  de: "Gamsgelb",
  en: "Chamois yellow",
  nl: "Gemsgeel",
  fr: "Jaune chamois"
}, {
  hex: "#9b958e",
  code: "080 60 05",
  scope: "Design System Plus",
  de: "Flanellgrau",
  en: "Flannel grey",
  nl: "Flanel grijs",
  fr: "Gris flanelle"
}, {
  hex: "#9e9384",
  code: "080 60 10",
  scope: "Design System Plus",
  de: "Hellkhaki",
  en: "Light khaki",
  nl: "Licht kaki",
  fr: "Kaki clair"
}, {
  hex: "#a79375",
  code: "080 60 20",
  scope: "Design System Plus",
  de: "Dinkelkornbraun",
  en: "Spelt grain brown",
  nl: "Speltkorrel bruin",
  fr: "Brun grain d'épeautre"
}, {
  hex: "#ad9165",
  code: "080 60 30",
  scope: "Design System Plus",
  de: "Goldquarzocker",
  en: "Golden quartz ochre",
  nl: "Goudkwarts gokker",
  fr: "Le quartz d'or"
}, {
  hex: "#b18e58",
  code: "080 60 40",
  scope: "Design System Plus",
  de: "Bambusgelb",
  en: "Bamboo yellow",
  nl: "Bamboe geel",
  fr: "Jaune bambou"
}, {
  hex: "#b78e49",
  code: "080 60 50",
  scope: "Design System Plus",
  de: "Messinggelb",
  en: "Brass yellow",
  nl: "Messing geel",
  fr: "jaune laiton"
}, {
  hex: "#bd8e39",
  code: "080 60 60",
  scope: "Design System Plus",
  de: "Feigensenfgelb",
  en: "Fig mustard yellow",
  nl: "Vijgenmosterd geel",
  fr: "Jaune figue de barbarie"
}, {
  hex: "#c08d2d",
  code: "080 60 70",
  scope: "Design System Plus",
  de: "Gelbgold",
  en: "Yellow gold",
  nl: "Geel goud",
  fr: "Or jaune"
}, {
  hex: "#b3aea6",
  code: "080 70 05",
  scope: "Design System Plus",
  de: "Knoblauchbeige",
  en: "Garlic beige",
  nl: "Knoflook beige",
  fr: "Beige à l'ail"
}, {
  hex: "#b8ac9c",
  code: "080 70 10",
  scope: "Design System Plus",
  de: "Feingreige",
  en: "Fine greige",
  nl: "Feingreige",
  fr: "Feingreige"
}, {
  hex: "#c1ab8b",
  code: "080 70 20",
  scope: "Design System Plus",
  de: "Gelbbraun",
  en: "Yellow brown",
  nl: "Geelbruin",
  fr: "Marron jaune"
}, {
  hex: "#c7a97b",
  code: "080 70 30",
  scope: "Design System Plus",
  de: "Senfkornbeige",
  en: "Mustard seed beige",
  nl: "Mosterdkorrel beige",
  fr: "Beige moutarde"
}, {
  hex: "#cfa86a",
  code: "080 70 40",
  scope: "Design System Plus",
  de: "Diamantgelb",
  en: "Diamond yellow",
  nl: "Diamantgeel",
  fr: "Jaune diamant"
}, {
  hex: "#d4a75a",
  code: "080 70 50",
  scope: "Design System Plus",
  de: "Antikmessing",
  en: "Antique brass",
  nl: "Antiek messing",
  fr: "Laiton antique"
}, {
  hex: "#dba74b",
  code: "080 70 60",
  scope: "Design System Plus",
  de: "Zucchinigelb",
  en: "Courgette yellow",
  nl: "Courgette dooier",
  fr: "Jaune de courgette"
}, {
  hex: "#dfa639",
  code: "080 70 70",
  scope: "Design System Plus",
  de: "Grapefruitgelb",
  en: "Grapefruit yellow",
  nl: "Grapefruit geel",
  fr: "Jaune pamplemousse"
}, {
  hex: "#e0a226",
  code: "080 70 80",
  scope: "Design System Plus",
  de: "Sonnenblumengelb",
  en: "Sunflower yellow",
  nl: "Zonnebloem geel",
  fr: "Jaune tournesol"
}, {
  hex: "#e5a10e",
  code: "080 70 88",
  scope: "Design System Plus",
  de: "Arnikagelb",
  en: "Arnica yellow",
  nl: "Arnica geel",
  fr: "Jaune d'arnica"
}, {
  hex: "#cfc9c0",
  code: "080 80 05",
  scope: "Design System Plus",
  de: "Glimmerhellgrau",
  en: "Micaceous light grey",
  nl: "Mica lichtgrijs",
  fr: "Gris clair micacé"
}, {
  hex: "#d6c8b7",
  code: "080 80 10",
  scope: "Design System Plus",
  de: "Pastellsand",
  en: "Pastel sand",
  nl: "Pastelzand",
  fr: "Sable pastel"
}, {
  hex: "#ddc5a4",
  code: "080 80 20",
  scope: "Design System Plus",
  de: "Naturreisbeige",
  en: "Natural rice beige",
  nl: "Natuurlijk rijstbeige",
  fr: "Beige riz naturel"
}, {
  hex: "#e3c393",
  code: "080 80 30",
  scope: "Design System Plus",
  de: "Gelbbeige",
  en: "Yellow beige",
  nl: "Geel beige",
  fr: "Beige jaune"
}, {
  hex: "#ebc281",
  code: "080 80 40",
  scope: "Design System Plus",
  de: "Strohgelb",
  en: "Straw yellow",
  nl: "Strogeel",
  fr: "Jaune paille"
}, {
  hex: "#f2c172",
  code: "080 80 50",
  scope: "Design System Plus",
  de: "Mirabellengelb",
  en: "Mirabelle yellow",
  nl: "Mirabelle geel",
  fr: "Jaune mirabelle"
}, {
  hex: "#f8c05f",
  code: "080 80 60",
  scope: "Design System Plus",
  de: "Vollgelb",
  en: "Full yellow",
  nl: "Stevig geel",
  fr: "Jaune plein"
}, {
  hex: "#fbbd4e",
  code: "080 80 70",
  scope: "Design System Plus",
  de: "Birnengelb",
  en: "Pear yellow",
  nl: "Peer geel",
  fr: "Jaune poire"
}, {
  hex: "#ffba36",
  code: "080 80 80",
  scope: "Design System Plus",
  de: "Brandgelb",
  en: "Fire yellow",
  nl: "Brandgeel",
  fr: "Jaune vif"
}, {
  hex: "#ffba1f",
  code: "080 80 90",
  scope: "Design System Plus",
  de: "Sommergelb",
  en: "Summer yellow",
  nl: "Zomer geel",
  fr: "Jaune d'été"
}, {
  hex: "#dbd4ca",
  code: "080 85 05",
  scope: "Design System Plus",
  de: "Weizenmehlweiß",
  en: "Wheat flour white",
  nl: "Tarwebloem wit",
  fr: "Blanc de farine de blé"
}, {
  hex: "#e0d4c2",
  code: "080 85 10",
  scope: "Design System Plus",
  de: "Zwiebelweiß",
  en: "Onion white",
  nl: "Ui wit",
  fr: "Blanc d'oignon"
}, {
  hex: "#ead3b2",
  code: "080 85 20",
  scope: "Design System Plus",
  de: "Nashibirnenbeige",
  en: "Nashi pear beige",
  nl: "Nashi peer beige",
  fr: "Beige poire à rhinocéros"
}, {
  hex: "#f1d0a0",
  code: "080 85 30",
  scope: "Design System Plus",
  de: "Vespagelb",
  en: "Vespa yellow",
  nl: "Vespagelb",
  fr: "Vespagelb"
}, {
  hex: "#f9cf8d",
  code: "080 85 40",
  scope: "Design System Plus",
  de: "Blätterteiggelb",
  en: "Puff pastry yellow",
  nl: "Bladerdeeg geel",
  fr: "Pâte feuilletée jaune"
}, {
  hex: "#ede5da",
  code: "080 90 05",
  scope: "Design System Plus",
  de: "Japanweiß",
  en: "Japanese white",
  nl: "Japan wit",
  fr: "Blanc Japon"
}, {
  hex: "#efe1cf",
  code: "080 90 10",
  scope: "Design System Plus",
  de: "Champignonweiß",
  en: "Mushroom white",
  nl: "Champignon wit",
  fr: "Blanc de champignon"
}, {
  hex: "#ecd6b6",
  code: "080 90 20",
  scope: "Design System Plus",
  de: "Macadamiabeige",
  en: "Macadamia beige",
  nl: "Macadamia beige",
  fr: "Beige macadamia"
}, {
  hex: "#ffdfae",
  code: "080 90 30",
  scope: "Design System Plus",
  de: "Meerrettichgelb",
  en: "Horseradish yellow",
  nl: "Mierikswortel geel",
  fr: "Jaune raifort"
}, {
  hex: "#f3eae1",
  code: "080 93 05",
  scope: "Design System Plus",
  de: "Milchsternweiß",
  en: "Milk star white",
  nl: "Melkster wit",
  fr: "Blanc étoile de lait"
}, {
  hex: "#716a5e",
  code: "085 40 10",
  scope: "Design System Plus",
  de: "Mineralgrün",
  en: "Mineral green",
  nl: "Mineraalgroen",
  fr: "Vert minéral"
}, {
  hex: "#74674f",
  code: "085 40 20",
  scope: "Design System Plus",
  de: "Khakigrün",
  en: "Khaki green",
  nl: "Kaki groen",
  fr: "Vert kaki"
}, {
  hex: "#7a6847",
  code: "085 40 30",
  scope: "Design System Plus",
  de: "Moosbraun",
  en: "Moss brown",
  nl: "Mosbruin",
  fr: "Marron mousse"
}, {
  hex: "#867e6f",
  code: "085 50 10",
  scope: "Design System Plus",
  de: "Korianderocker",
  en: "Coriander ochre",
  nl: "Koriander oker",
  fr: "Tabouret de coriandre"
}, {
  hex: "#8c7d61",
  code: "085 50 20",
  scope: "Design System Plus",
  de: "Pyritschiefergrün",
  en: "Pyrite slate green",
  nl: "Pyriet leigroen",
  fr: "Vert ardoise pyrite"
}, {
  hex: "#927d54",
  code: "085 50 30",
  scope: "Design System Plus",
  de: "Sepiagelb",
  en: "Sepia yellow",
  nl: "Sepia geel",
  fr: "Jaune sépia"
}, {
  hex: "#947b48",
  code: "085 50 40",
  scope: "Design System Plus",
  de: "Sumpfgrün",
  en: "Marshy green",
  nl: "Moerasgroen",
  fr: "Vert marais"
}, {
  hex: "#987b3d",
  code: "085 50 50",
  scope: "Design System Plus",
  de: "Honiggelbgrün",
  en: "Honey yellow green",
  nl: "Honing geel groen",
  fr: "Vert jaune miel"
}, {
  hex: "#9e9587",
  code: "085 60 10",
  scope: "Design System Plus",
  de: "Mattoliv",
  en: "Matte olive",
  nl: "Mattolive",
  fr: "Mattoliv"
}, {
  hex: "#a59476",
  code: "085 60 20",
  scope: "Design System Plus",
  de: "Teichgrün",
  en: "Pond green",
  nl: "Vijver groen",
  fr: "Vert de l'étang"
}, {
  hex: "#ab9367",
  code: "085 60 30",
  scope: "Design System Plus",
  de: "Holzgrün",
  en: "Wood green",
  nl: "Houtgroen",
  fr: "Vert bois"
}, {
  hex: "#af9358",
  code: "085 60 40",
  scope: "Design System Plus",
  de: "Flechtengrün",
  en: "Lichen green",
  nl: "Groen korstmos",
  fr: "Vert lichen"
}, {
  hex: "#b4934a",
  code: "085 60 50",
  scope: "Design System Plus",
  de: "Mineralumbra",
  en: "Mineral umber",
  nl: "Mineralumbra",
  fr: "Mineralumbra"
}, {
  hex: "#b9923b",
  code: "085 60 60",
  scope: "Design System Plus",
  de: "Lodengelb",
  en: "Loden yellow",
  nl: "Loden geel",
  fr: "Jaune loden"
}, {
  hex: "#b6ad9c",
  code: "085 70 10",
  scope: "Design System Plus",
  de: "Naturbastgreige",
  en: "Raffia greige",
  nl: "Natuurlijk bastgrauw",
  fr: "Pâte à modeler naturelle"
}, {
  hex: "#bfac8c",
  code: "085 70 20",
  scope: "Design System Plus",
  de: "Feldspatgrau",
  en: "Feldspar grey",
  nl: "Veldspaat grijs",
  fr: "Gris feldspath"
}, {
  hex: "#c5ac7a",
  code: "085 70 30",
  scope: "Design System Plus",
  de: "Heugelb",
  en: "Hay yellow",
  nl: "Hooi geel",
  fr: "Jaune foin"
}, {
  hex: "#c9aa6b",
  code: "085 70 40",
  scope: "Design System Plus",
  de: "Winterbirnenbeige",
  en: "Winter pear beige",
  nl: "Winterpeer beige",
  fr: "Beige poire d'hiver"
}, {
  hex: "#cea95a",
  code: "085 70 50",
  scope: "Design System Plus",
  de: "Herbstapfelgelb",
  en: "Autumn apple yellow",
  nl: "Herfst appel geel",
  fr: "Jaune pomme d'automne"
}, {
  hex: "#d0a848",
  code: "085 70 60",
  scope: "Design System Plus",
  de: "Pitmastonbirnengelb",
  en: "Pitmaston pear yellow",
  nl: "Pitmaston peer geel",
  fr: "Jaune pitmaston poire"
}, {
  hex: "#d4a738",
  code: "085 70 70",
  scope: "Design System Plus",
  de: "Strohblumengelb",
  en: "Immortelle yellow",
  nl: "Strobloem geel",
  fr: "Jaune fleur de paille"
}, {
  hex: "#daa92d",
  code: "085 70 75",
  scope: "Design System Plus",
  de: "Goldberyllgelb",
  en: "Golden beryl yellow",
  nl: "Gouden beryl geel",
  fr: "Jaune béryl doré"
}, {
  hex: "#d1c7b5",
  code: "085 80 10",
  scope: "Design System Plus",
  de: "Samtbeige",
  en: "Velvet beige",
  nl: "Fluweelbeige",
  fr: "Beige velouté"
}, {
  hex: "#d8c6a4",
  code: "085 80 20",
  scope: "Design System Plus",
  de: "Mineralbeige",
  en: "Mineral beige",
  nl: "Mineraal beige",
  fr: "Beige minéral"
}, {
  hex: "#e1c692",
  code: "085 80 30",
  scope: "Design System Plus",
  de: "Mondscheingelb",
  en: "Moonlight yellow",
  nl: "Maanlicht geel",
  fr: "Jaune clair de lune"
}, {
  hex: "#e6c582",
  code: "085 80 40",
  scope: "Design System Plus",
  de: "Tafelbirnengelb",
  en: "Table pear yellow",
  nl: "Tafelpeer geel",
  fr: "Jaune poire de table"
}, {
  hex: "#e9c370",
  code: "085 80 50",
  scope: "Design System Plus",
  de: "Fruchtgelb",
  en: "Fruit yellow",
  nl: "Vrucht geel",
  fr: "Jaune fruit"
}, {
  hex: "#eec25d",
  code: "085 80 60",
  scope: "Design System Plus",
  de: "Adonisröschengelb",
  en: "Adonis rose yellow",
  nl: "Adonis bloesem geel",
  fr: "Jaune adonis"
}, {
  hex: "#f2c14b",
  code: "085 80 70",
  scope: "Design System Plus",
  de: "Berberitzengelb",
  en: "Barberry yellow",
  nl: "Bosbes geel",
  fr: "Jaune berbère"
}, {
  hex: "#f4bf36",
  code: "085 80 80",
  scope: "Design System Plus",
  de: "Löwenzahngelb",
  en: "Dandelion yellow",
  nl: "Paardenbloem geel",
  fr: "Jaune pissenlit"
}, {
  hex: "#f5bf2c",
  code: "085 80 85",
  scope: "Design System Plus",
  de: "Dekorgelb",
  en: "Decor yellow",
  nl: "Decoratief geel",
  fr: "Jaune décoratif"
}, {
  hex: "#ddd2bf",
  code: "085 85 10",
  scope: "Design System Plus",
  de: "Alabasterweiß",
  en: "Alabaster white",
  nl: "Albast wit",
  fr: "Blanc albâtre"
}, {
  hex: "#e5d2b0",
  code: "085 85 20",
  scope: "Design System Plus",
  de: "Hellblond",
  en: "Light blond",
  nl: "Licht blond",
  fr: "Blond clair"
}, {
  hex: "#edd19e",
  code: "085 85 30",
  scope: "Design System Plus",
  de: "Weidenblütengelb",
  en: "Willow-flower yellow",
  nl: "Wilgenbloesem geel",
  fr: "Jaune fleur de saule"
}, {
  hex: "#f4d28e",
  code: "085 85 40",
  scope: "Design System Plus",
  de: "Ingwerhellgelb",
  en: "Light ginger yellow",
  nl: "Gember lichtgeel",
  fr: "Jaune gingembre clair"
}, {
  hex: "#f0e5d3",
  code: "085 90 10",
  scope: "Design System Plus",
  de: "Tulpenweiß",
  en: "Tulip white",
  nl: "Tulp wit",
  fr: "Blanc tulipe"
}, {
  hex: "#f6e1be",
  code: "085 90 20",
  scope: "Design System Plus",
  de: "Alpenbeerengelb",
  en: "Alpine berry yellow",
  nl: "Alpine bessengeel",
  fr: "Jaune baie des Alpes"
}, {
  hex: "#fbdeab",
  code: "085 90 30",
  scope: "Design System Plus",
  de: "Porzellanerdengelb",
  en: "China clay yellow",
  nl: "Porseleinklei geel",
  fr: "Jaune terre de porcelaine"
}, {
  hex: "#f2ece3",
  code: "085 93 05",
  scope: "Design System Plus",
  de: "Altweiß",
  en: "Vintage white",
  nl: "Oud wit",
  fr: "Blanc cassé"
}, {
  hex: "#5b554a",
  code: "090 30 10",
  scope: "Design System Plus",
  de: "Limonitbraun",
  en: "Limonite brown",
  nl: "Limoniet bruin",
  fr: "Marron limonite"
}, {
  hex: "#5f5641",
  code: "090 30 20",
  scope: "Design System Plus",
  de: "Borkengrün",
  en: "Bark green",
  nl: "Schors groen",
  fr: "Vert bordeaux"
}, {
  hex: "#706a5d",
  code: "090 40 10",
  scope: "Design System Plus",
  de: "Wackersteinbraun",
  en: "Boulder brown",
  nl: "Bruin Wackerstein",
  fr: "Marron pierre de taille"
}, {
  hex: "#73684d",
  code: "090 40 20",
  scope: "Design System Plus",
  de: "Pflaumengrün",
  en: "Plum green",
  nl: "Pruimgroen",
  fr: "Vert prune"
}, {
  hex: "#766843",
  code: "090 40 30",
  scope: "Design System Plus",
  de: "Weinblättergrün",
  en: "Vine leaf green",
  nl: "Wijnblad groen",
  fr: "Vert feuille de vigne"
}, {
  hex: "#847e70",
  code: "090 50 10",
  scope: "Design System Plus",
  de: "Graphitgraugrün",
  en: "Graphite grey green",
  nl: "Grafiet grijsgroen",
  fr: "Vert gris graphite"
}, {
  hex: "#887d61",
  code: "090 50 20",
  scope: "Design System Plus",
  de: "Pestogrün",
  en: "Pesto green",
  nl: "Pesto groen",
  fr: "Vert pesto"
}, {
  hex: "#8e7e51",
  code: "090 50 30",
  scope: "Design System Plus",
  de: "Riesenkaktusgrün",
  en: "Giant cactus green",
  nl: "Reuzencactus groen",
  fr: "Vert cactus géant"
}, {
  hex: "#917e45",
  code: "090 50 40",
  scope: "Design System Plus",
  de: "Auberginengrün",
  en: "Aubergine green",
  nl: "Aubergine groen",
  fr: "Vert d'aubergine"
}, {
  hex: "#9b9485",
  code: "090 60 10",
  scope: "Design System Plus",
  de: "Austerngrau",
  en: "Oyster grey",
  nl: "Oestergrijs",
  fr: "Gris huître"
}, {
  hex: "#a29474",
  code: "090 60 20",
  scope: "Design System Plus",
  de: "Manzanillaoliv",
  en: "Manzanilla olive",
  nl: "Manzanilla olijf",
  fr: "Manzanillaoliv"
}, {
  hex: "#a59467",
  code: "090 60 30",
  scope: "Design System Plus",
  de: "Tarnoliv",
  en: "Camouflage olive",
  nl: "Tarnoliv",
  fr: "Tarnoliv"
}, {
  hex: "#a89356",
  code: "090 60 40",
  scope: "Design System Plus",
  de: "Lorbeergrün",
  en: "Laurel green",
  nl: "Lauriergroen",
  fr: "Vert de laurier"
}, {
  hex: "#a89043",
  code: "090 60 50",
  scope: "Design System Plus",
  de: "Fahlgrün",
  en: "Faint green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#af9538",
  code: "090 60 60",
  scope: "Design System Plus",
  de: "Titanitgelb",
  en: "Titanite yellow",
  nl: "Titaniet geel",
  fr: "Jaune titanite"
}, {
  hex: "#b5ae9d",
  code: "090 70 10",
  scope: "Design System Plus",
  de: "Staubgelb",
  en: "Dusty yellow",
  nl: "Stof geel",
  fr: "Jaune poussière"
}, {
  hex: "#bbad8a",
  code: "090 70 20",
  scope: "Design System Plus",
  de: "Barbadosbeige",
  en: "Barbados beige",
  nl: "Barbados beige",
  fr: "Barbadosbeige"
}, {
  hex: "#beab7b",
  code: "090 70 30",
  scope: "Design System Plus",
  de: "Rhabarberblattgrün",
  en: "Rhubarb leaf green",
  nl: "Rabarberblad groen",
  fr: "Vert feuille de rhubarbe"
}, {
  hex: "#c5ae6a",
  code: "090 70 40",
  scope: "Design System Plus",
  de: "Igelkaktusgelbgrün",
  en: "Hedgehog cactus yellow green",
  nl: "Egelcactus geelgroen",
  fr: "Vert hérisson-cactus"
}, {
  hex: "#c8ad5a",
  code: "090 70 50",
  scope: "Design System Plus",
  de: "Stachelbeergelb",
  en: "Gooseberry yellow",
  nl: "Kruisbes geel",
  fr: "Jaune groseille"
}, {
  hex: "#caac47",
  code: "090 70 60",
  scope: "Design System Plus",
  de: "Knospengrün",
  en: "Bud green",
  nl: "Groen",
  fr: "Vert bourgeon"
}, {
  hex: "#cdac33",
  code: "090 70 70",
  scope: "Design System Plus",
  de: "Birkenkätzchengelb",
  en: "Catkin yellow",
  nl: "Berkenkatoen geel",
  fr: "Jaune poussin bouleau"
}, {
  hex: "#cfab22",
  code: "090 70 80",
  scope: "Design System Plus",
  de: "Prehnitgelb",
  en: "Prehnite yellow",
  nl: "Prehniet geel",
  fr: "Jaune prehnite"
}, {
  hex: "#d0c7b3",
  code: "090 80 10",
  scope: "Design System Plus",
  de: "Hellbeige",
  en: "Light beige",
  nl: "Licht beige",
  fr: "Beige clair"
}, {
  hex: "#d5c6a3",
  code: "090 80 20",
  scope: "Design System Plus",
  de: "Champagnerbeige",
  en: "Champagne beige",
  nl: "Champagne-beige",
  fr: "Beige champagne"
}, {
  hex: "#dcc894",
  code: "090 80 30",
  scope: "Design System Plus",
  de: "Zitronensorbetgelb",
  en: "Lemon sorbet yellow",
  nl: "Citroensorbet geel",
  fr: "Jaune sorbet citron"
}, {
  hex: "#e0c984",
  code: "090 80 40",
  scope: "Design System Plus",
  de: "Blütengelb",
  en: "Blossom yellow",
  nl: "Bloem geel",
  fr: "Jaune fleur"
}, {
  hex: "#e5c76d",
  code: "090 80 50",
  scope: "Design System Plus",
  de: "Tasmanhoniggelb",
  en: "Tasman honey yellow",
  nl: "Tasmaanse honing geel",
  fr: "Jaune miel de Tasmanie"
}, {
  hex: "#e7c558",
  code: "090 80 60",
  scope: "Design System Plus",
  de: "Neugelb",
  en: "New yellow",
  nl: "Nieuw geel",
  fr: "Jaune neuf"
}, {
  hex: "#ebc648",
  code: "090 80 70",
  scope: "Design System Plus",
  de: "Fashiongelb",
  en: "Fashion yellow",
  nl: "Mode geel",
  fr: "Jaune fashion"
}, {
  hex: "#eac42c",
  code: "090 80 80",
  scope: "Design System Plus",
  de: "Plakatgelb",
  en: "Poster yellow",
  nl: "Poster geel",
  fr: "Jaune d'affiche"
}, {
  hex: "#f0c503",
  code: "090 80 90",
  scope: "Design System Plus",
  de: "Kontrastgelb",
  en: "Contrasting yellow",
  nl: "Contrast geel",
  fr: "Jaune de contraste"
}, {
  hex: "#dad4ca",
  code: "090 85 05",
  scope: "Design System Plus",
  de: "Pfefferweiß",
  en: "Pepper white",
  nl: "Peper wit",
  fr: "Blanc poivré"
}, {
  hex: "#dfd5c2",
  code: "090 85 10",
  scope: "Design System Plus",
  de: "Paellanaturweiß",
  en: "Paella natural white",
  nl: "Paella wit",
  fr: "Blanc naturel Paellan"
}, {
  hex: "#e4d5b0",
  code: "090 85 20",
  scope: "Design System Plus",
  de: "Cidregelb",
  en: "Cider yellow",
  nl: "Cidregelb",
  fr: "Cidregelb"
}, {
  hex: "#ead59f",
  code: "090 85 30",
  scope: "Design System Plus",
  de: "Palmzuckergelb",
  en: "Palm sugar yellow",
  nl: "Palmsuiker geel",
  fr: "Jaune sucre de palme"
}, {
  hex: "#edd38c",
  code: "090 85 40",
  scope: "Design System Plus",
  de: "Märzgelb",
  en: "March yellow",
  nl: "Maart geel",
  fr: "Jaune de mars"
}, {
  hex: "#f2d479",
  code: "090 85 50",
  scope: "Design System Plus",
  de: "Pirolgelb",
  en: "Oriole yellow",
  nl: "Oriole geel",
  fr: "Jaune loriot"
}, {
  hex: "#eae4d9",
  code: "090 90 05",
  scope: "Design System Plus",
  de: "Marzipanweiß",
  en: "Marzipan white",
  nl: "Marsepein wit",
  fr: "Blanc massepain"
}, {
  hex: "#ebe4d1",
  code: "090 90 10",
  scope: "Design System Plus",
  de: "Primelweiß",
  en: "Primrose white",
  nl: "Primula wit",
  fr: "Blanc primevère"
}, {
  hex: "#f2e3bd",
  code: "090 90 20",
  scope: "Design System Plus",
  de: "Cremegelb",
  en: "Cream yellow",
  nl: "Crème geel",
  fr: "Jaune crème"
}, {
  hex: "#f6e2ac",
  code: "090 90 30",
  scope: "Design System Plus",
  de: "Wachsgelb",
  en: "Wax yellow",
  nl: "Was geel",
  fr: "Jaune cire"
}, {
  hex: "#fce299",
  code: "090 90 40",
  scope: "Design System Plus",
  de: "Zitronencreme",
  en: "Lemon cream",
  nl: "Citroencrème",
  fr: "Crème au citron"
}, {
  hex: "#fdde82",
  code: "090 90 50",
  scope: "Design System Plus",
  de: "Tigergelb",
  en: "Tiger yellow",
  nl: "Tijger geel",
  fr: "Jaune tigre"
}, {
  hex: "#fedc70",
  code: "090 90 60",
  scope: "Design System Plus",
  de: "Sonnenröschengelb",
  en: "Sunrose yellow",
  nl: "Zonnebloem geel",
  fr: "Jaune tournesol"
}, {
  hex: "#f0ebe0",
  code: "090 93 05",
  scope: "Design System Plus",
  de: "Sahneweiß",
  en: "Cream white",
  nl: "Romig wit",
  fr: "Blanc crème"
}, {
  hex: "#6e6a5d",
  code: "095 40 10",
  scope: "Design System Plus",
  de: "Schattengrün",
  en: "Shady green",
  nl: "Schaduwgroen",
  fr: "Vert ombre"
}, {
  hex: "#71684e",
  code: "095 40 20",
  scope: "Design System Plus",
  de: "Waldgrün",
  en: "Forest green",
  nl: "Bosgroen",
  fr: "Vert forêt"
}, {
  hex: "#726843",
  code: "095 40 30",
  scope: "Design System Plus",
  de: "Bohnengrün",
  en: "Bean green",
  nl: "Bonengroen",
  fr: "Vert de haricot"
}, {
  hex: "#837e70",
  code: "095 50 10",
  scope: "Design System Plus",
  de: "Stumpfoliv",
  en: "Dull olive",
  nl: "Stompfolie",
  fr: "olive à moignon"
}, {
  hex: "#877e62",
  code: "095 50 20",
  scope: "Design System Plus",
  de: "Kohlgrün",
  en: "Cabbage green",
  nl: "Kool groen",
  fr: "Vert choux"
}, {
  hex: "#8b7f54",
  code: "095 50 30",
  scope: "Design System Plus",
  de: "Kaperngrün",
  en: "Caper green",
  nl: "Kappertjesgroen",
  fr: "Vert câpre"
}, {
  hex: "#8d7e45",
  code: "095 50 40",
  scope: "Design System Plus",
  de: "Gartensalatgrün",
  en: "Garden lettuce green",
  nl: "Tuin sla",
  fr: "Vert de salade de jardin"
}, {
  hex: "#8f813c",
  code: "095 50 50",
  scope: "Design System Plus",
  de: "Artischockengrün",
  en: "Artichoke green",
  nl: "Artisjok groen",
  fr: "Vert artichaut"
}, {
  hex: "#9c9686",
  code: "095 60 10",
  scope: "Design System Plus",
  de: "Bleichgrüngrau",
  en: "Pale green grey",
  nl: "Lichtgroen-grijs",
  fr: "Gris vert pâle"
}, {
  hex: "#9f9676",
  code: "095 60 20",
  scope: "Design System Plus",
  de: "Blassgrün",
  en: "Pale green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#a39565",
  code: "095 60 30",
  scope: "Design System Plus",
  de: "Zypressengrün",
  en: "Cypress green",
  nl: "Cypresgroen",
  fr: "Vert cyprès"
}, {
  hex: "#a59556",
  code: "095 60 40",
  scope: "Design System Plus",
  de: "Traubengrün",
  en: "Grape green",
  nl: "Druifgroen",
  fr: "Vert raisin"
}, {
  hex: "#a69746",
  code: "095 60 50",
  scope: "Design System Plus",
  de: "Stachelbeergrün",
  en: "Gooseberry green",
  nl: "Kruisbessengroen",
  fr: "Vert groseille"
}, {
  hex: "#a59439",
  code: "095 60 60",
  scope: "Design System Plus",
  de: "Guavenfruchtgrün",
  en: "Guava green",
  nl: "Guave groen",
  fr: "Vert goyave"
}, {
  hex: "#a7962a",
  code: "095 60 70",
  scope: "Design System Plus",
  de: "Romanescogrün",
  en: "Romaine green",
  nl: "Romanesco groen",
  fr: "Vert romanesco"
}, {
  hex: "#b6b09e",
  code: "095 70 10",
  scope: "Design System Plus",
  de: "Sandgrau",
  en: "Sand grey",
  nl: "Zandgrijs",
  fr: "Gris sable"
}, {
  hex: "#bab08f",
  code: "095 70 20",
  scope: "Design System Plus",
  de: "Krokodilgrün",
  en: "Crocodile green",
  nl: "Krokodil groen",
  fr: "Vert crocodile"
}, {
  hex: "#beb07e",
  code: "095 70 30",
  scope: "Design System Plus",
  de: "Chicoréegrün",
  en: "Chicory green",
  nl: "Witlof",
  fr: "Vert de chicorée"
}, {
  hex: "#c0af6a",
  code: "095 70 40",
  scope: "Design System Plus",
  de: "Bananengrün",
  en: "Banana green",
  nl: "Bananengroen",
  fr: "Vert banane"
}, {
  hex: "#c0af5c",
  code: "095 70 50",
  scope: "Design System Plus",
  de: "Sternfruchtgelbgrün",
  en: "Star fruit yellow green",
  nl: "Sterfruit geelgroen",
  fr: "Vert fruit de l'étoile"
}, {
  hex: "#c0ae4c",
  code: "095 70 60",
  scope: "Design System Plus",
  de: "Papayagelbgrün",
  en: "Papaya yellow green",
  nl: "Papaja geelgroen",
  fr: "Vert papaye"
}, {
  hex: "#c5b037",
  code: "095 70 70",
  scope: "Design System Plus",
  de: "Bronzegrün",
  en: "Bronze green",
  nl: "Bronsgroen",
  fr: "Vert bronze"
}, {
  hex: "#cfc9b8",
  code: "095 80 10",
  scope: "Design System Plus",
  de: "Saphirlichtgelb",
  en: "Sapphire light yellow",
  nl: "Saffier lichtgeel",
  fr: "Jaune saphir clair"
}, {
  hex: "#d5caa7",
  code: "095 80 20",
  scope: "Design System Plus",
  de: "Blassoliv",
  en: "Pale olive",
  nl: "Blassoliv",
  fr: "Blassoliv"
}, {
  hex: "#dbcc96",
  code: "095 80 30",
  scope: "Design System Plus",
  de: "Spargelgelb",
  en: "Asparagus yellow",
  nl: "Asperge geel",
  fr: "Jaune asperge"
}, {
  hex: "#decb83",
  code: "095 80 40",
  scope: "Design System Plus",
  de: "Erbsengrün",
  en: "Pea green",
  nl: "Erwtgroen",
  fr: "Vert pois"
}, {
  hex: "#deca72",
  code: "095 80 50",
  scope: "Design System Plus",
  de: "Williamsbirnengelb",
  en: "Williams pear yellow",
  nl: "Williams peergeel",
  fr: "Jaune poire williams"
}, {
  hex: "#dcc75f",
  code: "095 80 60",
  scope: "Design System Plus",
  de: "Grünlichgelb",
  en: "Greenish yellow",
  nl: "Groenachtig geel",
  fr: "Jaune verdâtre"
}, {
  hex: "#dfc94b",
  code: "095 80 70",
  scope: "Design System Plus",
  de: "Mimosengelb",
  en: "Mimosa yellow",
  nl: "Mimosa geel",
  fr: "Jaune mimosa"
}, {
  hex: "#dac438",
  code: "095 80 80",
  scope: "Design System Plus",
  de: "Sorbetgelb",
  en: "Sorbet yellow",
  nl: "Sorbetgeel",
  fr: "Jaune sorbet"
}, {
  hex: "#dcd6c4",
  code: "095 85 10",
  scope: "Design System Plus",
  de: "Schwarzwurzelweiß",
  en: "Salsify white",
  nl: "Schorseneren wit",
  fr: "Blanc de scorsonère"
}, {
  hex: "#e2d7b4",
  code: "095 85 20",
  scope: "Design System Plus",
  de: "Trübhellgelb",
  en: "Dull light yellow",
  nl: "Lichtgeel bewolkt",
  fr: "Jaune pâle trouble"
}, {
  hex: "#e6d6a0",
  code: "095 85 30",
  scope: "Design System Plus",
  de: "Blattgelb",
  en: "Leaf yellow",
  nl: "Blad geel",
  fr: "Jaune feuille"
}, {
  hex: "#ebd78d",
  code: "095 85 40",
  scope: "Design System Plus",
  de: "Naturgelb",
  en: "Natural yellow",
  nl: "Natuurlijk geel",
  fr: "Jaune naturel"
}, {
  hex: "#ecd67c",
  code: "095 85 50",
  scope: "Design System Plus",
  de: "Sportgelb",
  en: "Sport yellow",
  nl: "Sport geel",
  fr: "Jaune sport"
}, {
  hex: "#ece5d0",
  code: "095 90 10",
  scope: "Design System Plus",
  de: "Atlasweiß",
  en: "Atlas white",
  nl: "Atlas wit",
  fr: "Blanc atlas"
}, {
  hex: "#f1e4c0",
  code: "095 90 20",
  scope: "Design System Plus",
  de: "Perlgelb",
  en: "Pearl yellow",
  nl: "Parel geel",
  fr: "Jaune perle"
}, {
  hex: "#f6e3ac",
  code: "095 90 30",
  scope: "Design System Plus",
  de: "Zitroneneisgelb",
  en: "Lemon ice cream yellow",
  nl: "Citroen ijsgeel",
  fr: "Jaune citron glacé"
}, {
  hex: "#f7e297",
  code: "095 90 40",
  scope: "Design System Plus",
  de: "Frischgelb",
  en: "Fresh yellow",
  nl: "Fris geel",
  fr: "Jaune frais"
}, {
  hex: "#fde588",
  code: "095 90 50",
  scope: "Design System Plus",
  de: "Leuchtendgelb",
  en: "Luminescent yellow",
  nl: "Lichtgevend geel",
  fr: "Jaune vif"
}, {
  hex: "#ffe479",
  code: "095 90 59",
  scope: "Design System Plus",
  de: "Dynamischgelb",
  en: "Dynamic yellow",
  nl: "Dynamisch geel",
  fr: "Jaune dynamique"
}, {
  hex: "#eeebe2",
  code: "095 93 05",
  scope: "Design System Plus",
  de: "Kreppseidenweiß",
  en: "Crepe silk white",
  nl: "Crepe zijde wit",
  fr: "Blanc crêpe de soie"
}, {
  hex: "#4a4945",
  code: "100 20 05",
  scope: "Design System Plus",
  de: "Nachtgrün",
  en: "Night green",
  nl: "Nachtgroen",
  fr: "Vert nuit"
}, {
  hex: "#56554f",
  code: "100 30 05",
  scope: "Design System Plus",
  de: "Vulkansteingrün",
  en: "Volcanic stone green",
  nl: "Vulkaansteen groen",
  fr: "Vert pierre volcanique"
}, {
  hex: "#585449",
  code: "100 30 10",
  scope: "Design System Plus",
  de: "Zinnobergrün",
  en: "Vermilion green",
  nl: "Vermiljoen groen",
  fr: "Vert vermillon"
}, {
  hex: "#5a5741",
  code: "100 30 20",
  scope: "Design System Plus",
  de: "Uniformgrün",
  en: "Uniform green",
  nl: "Uniform groen",
  fr: "Vert uniforme"
}, {
  hex: "#6a6962",
  code: "100 40 05",
  scope: "Design System Plus",
  de: "Taubengrau",
  en: "Doves grey",
  nl: "Duifgrijs",
  fr: "Gris pigeon"
}, {
  hex: "#6c695b",
  code: "100 40 10",
  scope: "Design System Plus",
  de: "Schlickgrün",
  en: "Slick green",
  nl: "Slibgroen",
  fr: "Vert barbotine"
}, {
  hex: "#6d694f",
  code: "100 40 20",
  scope: "Design System Plus",
  de: "Brokkoligrün",
  en: "Broccoli green",
  nl: "Broccoli groen",
  fr: "Vert de brocoli"
}, {
  hex: "#706a43",
  code: "100 40 30",
  scope: "Design System Plus",
  de: "Hochwaldgrün",
  en: "High forest green",
  nl: "Hoog bosgroen",
  fr: "Vert forêt"
}, {
  hex: "#716b3b",
  code: "100 40 40",
  scope: "Design System Plus",
  de: "Rosenkohlgrün",
  en: "Brussels sprout green",
  nl: "Spruitjes",
  fr: "Choux de Bruxelles verts"
}, {
  hex: "#817f77",
  code: "100 50 05",
  scope: "Design System Plus",
  de: "Waldbodenkhaki",
  en: "Forest floor khaki",
  nl: "Bosbodem kaki",
  fr: "Kaki des sols forestiers"
}, {
  hex: "#827e6e",
  code: "100 50 10",
  scope: "Design System Plus",
  de: "Kiebitzgraugrün",
  en: "Lapwing grey green",
  nl: "Kievit grijsgroen",
  fr: "Vert gris vanneau"
}, {
  hex: "#848060",
  code: "100 50 20",
  scope: "Design System Plus",
  de: "Grünspechtoliv",
  en: "Green woodpecker olive",
  nl: "Groene specht olijf",
  fr: "Olive du pic vert"
}, {
  hex: "#847e52",
  code: "100 50 30",
  scope: "Design System Plus",
  de: "Steppengrün",
  en: "Steppe green",
  nl: "Gewatteerd groen",
  fr: "Vert steppe"
}, {
  hex: "#888045",
  code: "100 50 40",
  scope: "Design System Plus",
  de: "Faiencegrün",
  en: "Faience green",
  nl: "Faience groen",
  fr: "Vert faïence"
}, {
  hex: "#868039",
  code: "100 50 50",
  scope: "Design System Plus",
  de: "Werkzeuggrün",
  en: "Tool green",
  nl: "Gereedschap groen",
  fr: "Vert outil"
}, {
  hex: "#99978e",
  code: "100 60 05",
  scope: "Design System Plus",
  de: "Rauchgraugrün",
  en: "Smoky grey green",
  nl: "Rokerig grijsgroen",
  fr: "Vert fumé"
}, {
  hex: "#979483",
  code: "100 60 10",
  scope: "Design System Plus",
  de: "Olivingrau",
  en: "Olivine grey",
  nl: "Olijfgrijs",
  fr: "Gris olivine"
}, {
  hex: "#9d9776",
  code: "100 60 20",
  scope: "Design System Plus",
  de: "Grauspechtgrün",
  en: "Grey-headed woodpecker green",
  nl: "Grijs espengroen",
  fr: "Vert pitch gris"
}, {
  hex: "#9d9664",
  code: "100 60 30",
  scope: "Design System Plus",
  de: "Kardamomgrün",
  en: "Cardamom green",
  nl: "Kardemom groen",
  fr: "Vert cardamome"
}, {
  hex: "#9f9857",
  code: "100 60 40",
  scope: "Design System Plus",
  de: "Salatgrün",
  en: "Lettuce green",
  nl: "Saladegroenten",
  fr: "Vert de laitue"
}, {
  hex: "#9f9946",
  code: "100 60 50",
  scope: "Design System Plus",
  de: "Artnouveaugrün",
  en: "Art Nouveau green",
  nl: "Artnouveau groen",
  fr: "Artnouveauvert"
}, {
  hex: "#9b9532",
  code: "100 60 60",
  scope: "Design System Plus",
  de: "Smoothiegrün",
  en: "Smoothie green",
  nl: "Smoothie groen",
  fr: "Vert smoothie"
}, {
  hex: "#b3b1a8",
  code: "100 70 05",
  scope: "Design System Plus",
  de: "Rauchweiß",
  en: "Smoky white",
  nl: "Rookwit",
  fr: "Blanc fumé"
}, {
  hex: "#b4b09e",
  code: "100 70 10",
  scope: "Design System Plus",
  de: "Anisgraugelb",
  en: "Anise grey yellow",
  nl: "Anijs grijs geel",
  fr: "Jaune anis"
}, {
  hex: "#b6b08d",
  code: "100 70 20",
  scope: "Design System Plus",
  de: "Sandbraun",
  en: "Sand brown",
  nl: "Zandbruin",
  fr: "Marron sable"
}, {
  hex: "#b6b07b",
  code: "100 70 30",
  scope: "Design System Plus",
  de: "Hippiegrün",
  en: "Hippie green",
  nl: "Hippie groen",
  fr: "Vert hippie"
}, {
  hex: "#bab26c",
  code: "100 70 40",
  scope: "Design System Plus",
  de: "Lindgrün",
  en: "Linden green",
  nl: "Limoengroen",
  fr: "Vert tilleul"
}, {
  hex: "#b8af57",
  code: "100 70 50",
  scope: "Design System Plus",
  de: "Dillgrün",
  en: "Dill green",
  nl: "Dille groen",
  fr: "Vert aneth"
}, {
  hex: "#b6af44",
  code: "100 70 60",
  scope: "Design System Plus",
  de: "Neugrün",
  en: "New green",
  nl: "Nieuw groen",
  fr: "Vert nouveau"
}, {
  hex: "#cac9bf",
  code: "100 80 05",
  scope: "Design System Plus",
  de: "Naturgrau",
  en: "Natural grey",
  nl: "Natuurlijk grijs",
  fr: "Gris naturel"
}, {
  hex: "#cecab5",
  code: "100 80 10",
  scope: "Design System Plus",
  de: "Blassbeige",
  en: "Pale beige",
  nl: "Licht beige",
  fr: "Beige pâle"
}, {
  hex: "#d4cca7",
  code: "100 80 20",
  scope: "Design System Plus",
  de: "Weichgrün",
  en: "Soft green",
  nl: "Zacht groen",
  fr: "Vert tendre"
}, {
  hex: "#d3ca93",
  code: "100 80 30",
  scope: "Design System Plus",
  de: "Silbergrün",
  en: "Silver green",
  nl: "Zilvergroen",
  fr: "Vert argenté"
}, {
  hex: "#d4cb81",
  code: "100 80 40",
  scope: "Design System Plus",
  de: "Märztulpengrün",
  en: "March tulip green",
  nl: "Maart tulp groen",
  fr: "Vert tulipe de mars"
}, {
  hex: "#d4cb6e",
  code: "100 80 50",
  scope: "Design System Plus",
  de: "Leichtoliv",
  en: "Light olive",
  nl: "Licht olijf",
  fr: "Olive légère"
}, {
  hex: "#d9cd5b",
  code: "100 80 60",
  scope: "Design System Plus",
  de: "Reklamegrün",
  en: "Advertisement green",
  nl: "Groen adverteren",
  fr: "Vert de la publicité"
}, {
  hex: "#d8cd48",
  code: "100 80 70",
  scope: "Design System Plus",
  de: "LEDgrün",
  en: "LED green",
  nl: "LED groen",
  fr: "LED verte"
}, {
  hex: "#d5ce33",
  code: "100 80 80",
  scope: "Design System Plus",
  de: "Märzgrün",
  en: "March green",
  nl: "Maart groen",
  fr: "Vert mars"
}, {
  hex: "#d9d7cd",
  code: "100 85 05",
  scope: "Design System Plus",
  de: "Sellerieweiß",
  en: "Celery white",
  nl: "Selderij wit",
  fr: "Blanc de céleri"
}, {
  hex: "#dbd6c2",
  code: "100 85 10",
  scope: "Design System Plus",
  de: "Palmherzencreme",
  en: "Palm heart cream",
  nl: "Palmhartcrème",
  fr: "Crème de cœur de palmier"
}, {
  hex: "#ddd6b0",
  code: "100 85 20",
  scope: "Design System Plus",
  de: "Beigegrün",
  en: "Beige green",
  nl: "Beige groen",
  fr: "Vert beige"
}, {
  hex: "#e1d7a0",
  code: "100 85 30",
  scope: "Design System Plus",
  de: "Kristallgelb",
  en: "Crystal yellow",
  nl: "Kristalgeel",
  fr: "Jaune cristal"
}, {
  hex: "#e8e5d9",
  code: "100 90 05",
  scope: "Design System Plus",
  de: "Brillantgelb",
  en: "Brilliant yellow",
  nl: "Briljant geel",
  fr: "Jaune brillant"
}, {
  hex: "#eae5d1",
  code: "100 90 10",
  scope: "Design System Plus",
  de: "Holunderweiß",
  en: "Elderberry white",
  nl: "Vlierbes wit",
  fr: "Blanc sureau"
}, {
  hex: "#eee5bf",
  code: "100 90 20",
  scope: "Design System Plus",
  de: "Designercremegelb",
  en: "Designer cream yellow",
  nl: "Designer crème geel",
  fr: "Jaune crème de designer"
}, {
  hex: "#eee4aa",
  code: "100 90 30",
  scope: "Design System Plus",
  de: "Buchsbaumgelb",
  en: "Boxwood yellow",
  nl: "Buxus geel",
  fr: "Jaune buis"
}, {
  hex: "#f3e699",
  code: "100 90 40",
  scope: "Design System Plus",
  de: "Primelgelb",
  en: "Primrose yellow",
  nl: "Primula geel",
  fr: "Jaune primevère"
}, {
  hex: "#f1e586",
  code: "100 90 50",
  scope: "Design System Plus",
  de: "Frühlingsgelb",
  en: "Spring yellow",
  nl: "Lente geel",
  fr: "Jaune printemps"
}, {
  hex: "#efede3",
  code: "100 93 05",
  scope: "Design System Plus",
  de: "Nebelweiß",
  en: "Fog white",
  nl: "Mistig wit",
  fr: "Blanc de brume"
}, {
  hex: "#484840",
  code: "110 20 10",
  scope: "Design System Plus",
  de: "Metallbaugrün",
  en: "Metal construction green",
  nl: "Metalen constructie groen",
  fr: "Vert construction métallique"
}, {
  hex: "#57574c",
  code: "110 30 10",
  scope: "Design System Plus",
  de: "Dunkelolivgrün",
  en: "Dark olive green",
  nl: "Donker olijfgroen",
  fr: "Vert olive foncé"
}, {
  hex: "#585945",
  code: "110 30 20",
  scope: "Design System Plus",
  de: "Norialgenschwarzgrün",
  en: "Nori seaweed green",
  nl: "Norialgen zwart groen",
  fr: "Vert norialgen noir"
}, {
  hex: "#6a6b5d",
  code: "110 40 10",
  scope: "Design System Plus",
  de: "Stumpfgrün",
  en: "Stump green",
  nl: "Stomp groen",
  fr: "Vert terne"
}, {
  hex: "#67694d",
  code: "110 40 20",
  scope: "Design System Plus",
  de: "Antikgrün",
  en: "Antique green",
  nl: "Antiek groen",
  fr: "Vert antique"
}, {
  hex: "#696c46",
  code: "110 40 30",
  scope: "Design System Plus",
  de: "Gärtnergrün",
  en: "Gardener green",
  nl: "Groen van de tuinman",
  fr: "Vert jardinier"
}, {
  hex: "#686e3c",
  code: "110 40 40",
  scope: "Design System Plus",
  de: "Kirchnergrün",
  en: "Kirchner green",
  nl: "Kersengroen",
  fr: "Vert cerise"
}, {
  hex: "#7f7f70",
  code: "110 50 10",
  scope: "Design System Plus",
  de: "Novembergrün",
  en: "November green",
  nl: "November groen",
  fr: "Vert novembre"
}, {
  hex: "#7e8061",
  code: "110 50 20",
  scope: "Design System Plus",
  de: "Alexandritgrün",
  en: "Alexandrite green",
  nl: "Alexandriet groen",
  fr: "Vert alexandrite"
}, {
  hex: "#7d8153",
  code: "110 50 30",
  scope: "Design System Plus",
  de: "Pflanzengrün",
  en: "Plant green",
  nl: "Plant groen",
  fr: "Vert végétal"
}, {
  hex: "#7b8244",
  code: "110 50 40",
  scope: "Design System Plus",
  de: "Reifegrün",
  en: "Ripe green",
  nl: "Rijp groen",
  fr: "Vert mûr"
}, {
  hex: "#79833a",
  code: "110 50 50",
  scope: "Design System Plus",
  de: "Portugalgrün",
  en: "Portuguese green",
  nl: "Portugal groen",
  fr: "Vert Portugal"
}, {
  hex: "#798533",
  code: "110 50 55",
  scope: "Design System Plus",
  de: "Flaggengrün",
  en: "Flag green",
  nl: "Vlag groen",
  fr: "Vert drapeau"
}, {
  hex: "#959685",
  code: "110 60 10",
  scope: "Design System Plus",
  de: "Graugrün",
  en: "Grey green",
  nl: "Grijsgroen",
  fr: "Vert gris"
}, {
  hex: "#939777",
  code: "110 60 20",
  scope: "Design System Plus",
  de: "Erbsenschotengrün",
  en: "Peapod green",
  nl: "Erwtenpeul groen",
  fr: "Vert des cosses de pois"
}, {
  hex: "#969a69",
  code: "110 60 30",
  scope: "Design System Plus",
  de: "Indischgrün",
  en: "Indian green",
  nl: "Indiaas groen",
  fr: "Vert indien"
}, {
  hex: "#929a58",
  code: "110 60 40",
  scope: "Design System Plus",
  de: "Blatterbsengrün",
  en: "Winterpea green",
  nl: "Blad erwtgroen",
  fr: "Vert pois de senteur"
}, {
  hex: "#909c49",
  code: "110 60 50",
  scope: "Design System Plus",
  de: "Airlinegrün",
  en: "Airline green",
  nl: "Groene luchtvaartmaatschappij",
  fr: "Vert Airline"
}, {
  hex: "#909f3b",
  code: "110 60 60",
  scope: "Design System Plus",
  de: "Waldmeistergrün",
  en: "Woodruff green",
  nl: "Bosgroen",
  fr: "Vert sylvestre"
}, {
  hex: "#91a033",
  code: "110 60 65",
  scope: "Design System Plus",
  de: "Ampelgrün",
  en: "Traffic light green",
  nl: "Verkeerslicht groen",
  fr: "Vert feu de signalisation"
}, {
  hex: "#b0b19e",
  code: "110 70 10",
  scope: "Design System Plus",
  de: "Chinateegrün",
  en: "Chinese tea green",
  nl: "China groen",
  fr: "Vert chinois"
}, {
  hex: "#afb28e",
  code: "110 70 20",
  scope: "Design System Plus",
  de: "Wandgrün",
  en: "Wall green",
  nl: "Muur groen",
  fr: "Vert mural"
}, {
  hex: "#acb17d",
  code: "110 70 30",
  scope: "Design System Plus",
  de: "Wasabigrün",
  en: "Wasabi green",
  nl: "Wasabi groen",
  fr: "Vert wasabi"
}, {
  hex: "#acb46e",
  code: "110 70 40",
  scope: "Design System Plus",
  de: "Aprilgrün",
  en: "April green",
  nl: "April groen",
  fr: "Vert d'avril"
}, {
  hex: "#acb65d",
  code: "110 70 50",
  scope: "Design System Plus",
  de: "Delaunaygrün",
  en: "Delaunay green",
  nl: "Delaunay groen",
  fr: "Vert Delaunay"
}, {
  hex: "#a8b64c",
  code: "110 70 60",
  scope: "Design System Plus",
  de: "Limettengrün",
  en: "Lime green",
  nl: "Limoengroen",
  fr: "Vert citron"
}, {
  hex: "#a1b62b",
  code: "110 70 70",
  scope: "Design System Plus",
  de: "Chlorophyllgrün",
  en: "Chlorophyll green",
  nl: "Groen chlorofyl",
  fr: "Vert chlorophylle"
}, {
  hex: "#a0b42d",
  code: "110 70 77",
  scope: "Design System Plus",
  de: "Markergrün",
  en: "Marker green",
  nl: "Markeerstift groen",
  fr: "Vert marqueur"
}, {
  hex: "#c7c9b7",
  code: "110 80 10",
  scope: "Design System Plus",
  de: "Frühlingsgrau",
  en: "Spring grey",
  nl: "Lente grijs",
  fr: "Gris printemps"
}, {
  hex: "#cbcca7",
  code: "110 80 20",
  scope: "Design System Plus",
  de: "Minzeisgrün",
  en: "Mint ice green",
  nl: "Mint ijsgroen",
  fr: "Vert menthe à l'eau"
}, {
  hex: "#c9ce95",
  code: "110 80 30",
  scope: "Design System Plus",
  de: "Lenzgrün",
  en: "Springtide green",
  nl: "Lenzgrün",
  fr: "Vert Lenz"
}, {
  hex: "#c7cf84",
  code: "110 80 40",
  scope: "Design System Plus",
  de: "Limettensorbetgrün",
  en: "Lime sorbet green",
  nl: "Linde sorbetgroen",
  fr: "Vert sorbet citron vert"
}, {
  hex: "#c8d172",
  code: "110 80 50",
  scope: "Design System Plus",
  de: "Ostergrün",
  en: "Easter green",
  nl: "Paasgroen",
  fr: "Vert de Pâques"
}, {
  hex: "#c4d160",
  code: "110 80 60",
  scope: "Design System Plus",
  de: "Clowngrün",
  en: "Clown green",
  nl: "Clown groen",
  fr: "Vert clown"
}, {
  hex: "#c2d24c",
  code: "110 80 70",
  scope: "Design System Plus",
  de: "Saftgrün",
  en: "Juice green",
  nl: "Sap groen",
  fr: "Vert jus"
}, {
  hex: "#d5d6c3",
  code: "110 85 10",
  scope: "Design System Plus",
  de: "Veltlinerweiß",
  en: "Veltliner white",
  nl: "Veltliner wit",
  fr: "Blanc de veltliner"
}, {
  hex: "#d5d7b1",
  code: "110 85 20",
  scope: "Design System Plus",
  de: "Kohlrabigrün",
  en: "Kohlrabi green",
  nl: "Koolrabi groen",
  fr: "Vert chou-rave"
}, {
  hex: "#d7daa1",
  code: "110 85 30",
  scope: "Design System Plus",
  de: "Burgundergrau",
  en: "Burgundy grey",
  nl: "Bourgondisch grijs",
  fr: "Gris bourgogne"
}, {
  hex: "#d5da8e",
  code: "110 85 40",
  scope: "Design System Plus",
  de: "Wachsgrün",
  en: "Wax green",
  nl: "Was groen",
  fr: "Vert cire"
}, {
  hex: "#d2da7a",
  code: "110 85 50",
  scope: "Design System Plus",
  de: "Sprossengrün",
  en: "Sprout green",
  nl: "Kiemgroen",
  fr: "Vert pousses"
}, {
  hex: "#e4e2d7",
  code: "110 90 05",
  scope: "Design System Plus",
  de: "Baumwollweiß",
  en: "Cotton white",
  nl: "Katoen wit",
  fr: "Blanc coton"
}, {
  hex: "#e6e6d2",
  code: "110 90 10",
  scope: "Design System Plus",
  de: "Farnhellgrün",
  en: "Light fern green",
  nl: "Varen lichtgroen",
  fr: "Vert fougère clair"
}, {
  hex: "#e6e7bf",
  code: "110 90 20",
  scope: "Design System Plus",
  de: "Lilienduftgrün",
  en: "Lily scent green",
  nl: "Leliegeurend groen",
  fr: "Vert parfum de lys"
}, {
  hex: "#e5e7ac",
  code: "110 90 30",
  scope: "Design System Plus",
  de: "Kiwieisgrün",
  en: "Kiwi ice cream green",
  nl: "Kiwi ijsgroen",
  fr: "Vert kiwi"
}, {
  hex: "#e4e99b",
  code: "110 90 40",
  scope: "Design System Plus",
  de: "Limettensaftgrün",
  en: "Lime juice green",
  nl: "Limoensap groen",
  fr: "Vert jus de citron vert"
}, {
  hex: "#ebebe1",
  code: "110 93 05",
  scope: "Design System Plus",
  de: "Bastweiß",
  en: "Raffia white",
  nl: "Bast wit",
  fr: "Blanc bâtard"
}, {
  hex: "#f4f3ef",
  code: "110 96 02",
  scope: "Design System Plus",
  de: "Waschweiß",
  en: "Laundry white",
  nl: "Wit wassen",
  fr: "Blanc de lavage"
}, {
  hex: "#545650",
  code: "120 30 05",
  scope: "Design System Plus",
  de: "Racinggrün",
  en: "Racing green",
  nl: "Racegroen",
  fr: "Vert Racing"
}, {
  hex: "#53574b",
  code: "120 30 10",
  scope: "Design System Plus",
  de: "Landhausgrün",
  en: "Country house green",
  nl: "Landhuis groen",
  fr: "Vert campagne"
}, {
  hex: "#515842",
  code: "120 30 20",
  scope: "Design System Plus",
  de: "Avocadodunkelgrün",
  en: "Avocado dark green",
  nl: "Avocado donkergroen",
  fr: "Vert foncé d'avocat"
}, {
  hex: "#686962",
  code: "120 40 05",
  scope: "Design System Plus",
  de: "Englischgrün",
  en: "English green",
  nl: "Engels groen",
  fr: "Vert anglais"
}, {
  hex: "#66695b",
  code: "120 40 10",
  scope: "Design System Plus",
  de: "Mandelgrün",
  en: "Almond green",
  nl: "Amandelgroen",
  fr: "Vert amande"
}, {
  hex: "#636b51",
  code: "120 40 20",
  scope: "Design System Plus",
  de: "Kaktusgrün",
  en: "Cactus green",
  nl: "Cactusgroen",
  fr: "Vert cactus"
}, {
  hex: "#626e48",
  code: "120 40 30",
  scope: "Design System Plus",
  de: "Basilikumgrün",
  en: "Basil green",
  nl: "Basilicumgroen",
  fr: "Vert basilic"
}, {
  hex: "#5c703b",
  code: "120 40 40",
  scope: "Design System Plus",
  de: "Paprikagrün",
  en: "Pepper green",
  nl: "Paprikagroen",
  fr: "Vert de paprika"
}, {
  hex: "#7e7f77",
  code: "120 50 05",
  scope: "Design System Plus",
  de: "Rauchgrün",
  en: "Smoke green",
  nl: "Rookgroen",
  fr: "Vert fumée"
}, {
  hex: "#7b8071",
  code: "120 50 10",
  scope: "Design System Plus",
  de: "Samtgrüngrau",
  en: "Velvet green grey",
  nl: "Fluweelgroen grijs",
  fr: "Gris vert velours"
}, {
  hex: "#788262",
  code: "120 50 20",
  scope: "Design System Plus",
  de: "Papageiengrün",
  en: "Parrot green",
  nl: "Papegaaiengroen",
  fr: "Vert perroquet"
}, {
  hex: "#758254",
  code: "120 50 30",
  scope: "Design System Plus",
  de: "Quarzgrün",
  en: "Quartz green",
  nl: "Kwartsgroen",
  fr: "Vert quartz"
}, {
  hex: "#72864c",
  code: "120 50 40",
  scope: "Design System Plus",
  de: "Heckengrün",
  en: "Hedge green",
  nl: "Heggengroen",
  fr: "Feuillage des haies"
}, {
  hex: "#6c863e",
  code: "120 50 50",
  scope: "Design System Plus",
  de: "Birkenblattgrün",
  en: "Birch leaf green",
  nl: "Berkenblad groen",
  fr: "Vert feuille de bouleau"
}, {
  hex: "#979a90",
  code: "120 60 05",
  scope: "Design System Plus",
  de: "Bläulichgrau",
  en: "Bluish grey",
  nl: "Blauwachtig grijs",
  fr: "Gris bleuté"
}, {
  hex: "#929787",
  code: "120 60 10",
  scope: "Design System Plus",
  de: "Lavendelblattgrün",
  en: "Lavender leaf green",
  nl: "Lavendelblad groen",
  fr: "Vert feuille de lavande"
}, {
  hex: "#909978",
  code: "120 60 20",
  scope: "Design System Plus",
  de: "Mostbirnengrün",
  en: "Cider pear green",
  nl: "Cider peer groen",
  fr: "Vert poire à cidre"
}, {
  hex: "#8c9d6b",
  code: "120 60 30",
  scope: "Design System Plus",
  de: "Vesuviangrün",
  en: "Vesuvian green",
  nl: "Vesuviaans groen",
  fr: "Vert vesuviane"
}, {
  hex: "#899f5d",
  code: "120 60 40",
  scope: "Design System Plus",
  de: "Bambusgrasgrün",
  en: "Bamboo grass green",
  nl: "Bamboegras groen",
  fr: "Vert herbe de bambou"
}, {
  hex: "#83a04d",
  code: "120 60 50",
  scope: "Design System Plus",
  de: "Aloeveragrün",
  en: "Aloe vera green",
  nl: "Aloë vera groen",
  fr: "Vert aloès"
}, {
  hex: "#7da03e",
  code: "120 60 60",
  scope: "Design System Plus",
  de: "Mambagrün",
  en: "Mamba green",
  nl: "Mambagroen",
  fr: "Vert Mamba"
}, {
  hex: "#7ca23d",
  code: "120 60 63",
  scope: "Design System Plus",
  de: "Leuchtendgrün",
  en: "Luminescent green",
  nl: "Lichtgevend groen",
  fr: "Vert vif"
}, {
  hex: "#afb1a7",
  code: "120 70 05",
  scope: "Design System Plus",
  de: "Lorbeergrau",
  en: "Laurel grey",
  nl: "Laurier grijs",
  fr: "Gris laurier"
}, {
  hex: "#acb19e",
  code: "120 70 10",
  scope: "Design System Plus",
  de: "Nilgrün",
  en: "Nile green",
  nl: "Nijlgroen",
  fr: "Vert Nil"
}, {
  hex: "#a8b38f",
  code: "120 70 20",
  scope: "Design System Plus",
  de: "Filigrangrün",
  en: "Filigree green",
  nl: "Filigraan groen",
  fr: "Vert filigrane"
}, {
  hex: "#a6b682",
  code: "120 70 30",
  scope: "Design System Plus",
  de: "Serpentingrün",
  en: "Serpentine green",
  nl: "Serpentijn groen",
  fr: "Vert serpentin"
}, {
  hex: "#a1b872",
  code: "120 70 40",
  scope: "Design System Plus",
  de: "Birkenhellgrün",
  en: "Light birch green",
  nl: "Berk lichtgroen",
  fr: "Bouleau vert clair"
}, {
  hex: "#9cb960",
  code: "120 70 50",
  scope: "Design System Plus",
  de: "Waldrebengrün",
  en: "Clematis green",
  nl: "Clematissen groen",
  fr: "Vert saule des bois"
}, {
  hex: "#95b751",
  code: "120 70 60",
  scope: "Design System Plus",
  de: "Turmalingrün",
  en: "Tourmaline green",
  nl: "Toermalijn groen",
  fr: "Vert tourmaline"
}, {
  hex: "#92bc42",
  code: "120 70 70",
  scope: "Design System Plus",
  de: "Cocktailgrün",
  en: "Cocktail green",
  nl: "Cocktail groen",
  fr: "Vert cocktail"
}, {
  hex: "#8db836",
  code: "120 70 75",
  scope: "Design System Plus",
  de: "Brillantgrün",
  en: "Brilliant green",
  nl: "Briljant groen",
  fr: "Vert brillant"
}, {
  hex: "#c8cbc1",
  code: "120 80 05",
  scope: "Design System Plus",
  de: "Staubgrün",
  en: "Dust green",
  nl: "Stof groen",
  fr: "Vert poussière"
}, {
  hex: "#c5cab6",
  code: "120 80 10",
  scope: "Design System Plus",
  de: "Jugendstilgrün",
  en: "Modern Style green",
  nl: "Art Nouveau groen",
  fr: "Vert art nouveau"
}, {
  hex: "#c4cea9",
  code: "120 80 20",
  scope: "Design System Plus",
  de: "Avocadocreme",
  en: "Avocado cream",
  nl: "Avocadocrème",
  fr: "Crème d'avocat"
}, {
  hex: "#becf97",
  code: "120 80 30",
  scope: "Design System Plus",
  de: "Naturgrün",
  en: "Natural green",
  nl: "Natuurlijk groen",
  fr: "Vert naturel"
}, {
  hex: "#bbd289",
  code: "120 80 40",
  scope: "Design System Plus",
  de: "Sommergrün",
  en: "Summer green",
  nl: "Zomergroen",
  fr: "Vert d'été"
}, {
  hex: "#b6d478",
  code: "120 80 50",
  scope: "Design System Plus",
  de: "Modegrün",
  en: "Fashion green",
  nl: "Groene mode",
  fr: "Vert mode"
}, {
  hex: "#b1d669",
  code: "120 80 60",
  scope: "Design System Plus",
  de: "Neongrün",
  en: "Neon green",
  nl: "Neongroen",
  fr: "Vert fluo"
}, {
  hex: "#d4d6cc",
  code: "120 85 05",
  scope: "Design System Plus",
  de: "Kreidegrün",
  en: "Chalk green",
  nl: "Krijtgroen",
  fr: "Vert craie"
}, {
  hex: "#d1d7c4",
  code: "120 85 10",
  scope: "Design System Plus",
  de: "Federleichtgrün",
  en: "Light feather green",
  nl: "Vederlicht groen",
  fr: "Vert plume"
}, {
  hex: "#d0dab4",
  code: "120 85 20",
  scope: "Design System Plus",
  de: "Seegrün",
  en: "Lake green",
  nl: "Zeegroen",
  fr: "Vert de mer"
}, {
  hex: "#ccdba2",
  code: "120 85 30",
  scope: "Design System Plus",
  de: "Aquagrün",
  en: "Aqua green",
  nl: "Aqua groen",
  fr: "Vert aqua"
}, {
  hex: "#e2e4d9",
  code: "120 90 05",
  scope: "Design System Plus",
  de: "Maiglöckchenweiß",
  en: "Lily of the valley white",
  nl: "Lelietje-van-dalen wit",
  fr: "Blanc muguet"
}, {
  hex: "#e4e7d3",
  code: "120 90 10",
  scope: "Design System Plus",
  de: "Hellpistazie",
  en: "Pale pistachio",
  nl: "Lichte pistache",
  fr: "Pistache claire"
}, {
  hex: "#dee8c2",
  code: "120 90 20",
  scope: "Design System Plus",
  de: "Kiwisorbetgrün",
  en: "Kiwi sorbet green",
  nl: "Kiwisorbet groen",
  fr: "Vert kiwi"
}, {
  hex: "#daebb1",
  code: "120 90 30",
  scope: "Design System Plus",
  de: "Eiskaltgrün",
  en: "Ice-cold green",
  nl: "IJskoud groen",
  fr: "Vert glacé"
}, {
  hex: "#e9ece1",
  code: "120 93 05",
  scope: "Design System Plus",
  de: "Hauchweißgrün",
  en: "Touch of white green",
  nl: "Gebroken wit groen",
  fr: "Vert pâle blanc"
}, {
  hex: "#53584d",
  code: "130 30 10",
  scope: "Design System Plus",
  de: "Aramealgengrün",
  en: "Arame seaweed green",
  nl: "Arameal groen",
  fr: "Vert algue araméenne"
}, {
  hex: "#4e5945",
  code: "130 30 20",
  scope: "Design System Plus",
  de: "Seetanggrün",
  en: "Kelp green",
  nl: "Zeewier groen",
  fr: "Vert algue"
}, {
  hex: "#666c5f",
  code: "130 40 10",
  scope: "Design System Plus",
  de: "Sanftoliv",
  en: "Soft olive",
  nl: "Zachte olijf",
  fr: "Sanftoliv"
}, {
  hex: "#5d6c53",
  code: "130 40 20",
  scope: "Design System Plus",
  de: "Alpenseegrün",
  en: "Alpine lake green",
  nl: "Alpenmeer groen",
  fr: "Vert des Alpes"
}, {
  hex: "#5a6f4b",
  code: "130 40 30",
  scope: "Design System Plus",
  de: "Edelsteingrün",
  en: "Gemstone green",
  nl: "Edelsteen groen",
  fr: "Vert pierre précieuse"
}, {
  hex: "#788072",
  code: "130 50 10",
  scope: "Design System Plus",
  de: "Dubuffetgrün",
  en: "Dubuffet green",
  nl: "Dubuffet groen",
  fr: "Vert Dubuffet"
}, {
  hex: "#758468",
  code: "130 50 20",
  scope: "Design System Plus",
  de: "Spanischgrün",
  en: "Spanish green",
  nl: "Spaans groen",
  fr: "Vert espagnol"
}, {
  hex: "#6c855b",
  code: "130 50 30",
  scope: "Design System Plus",
  de: "Algengrün",
  en: "Algae green",
  nl: "Algen groen",
  fr: "Vert algue"
}, {
  hex: "#65884f",
  code: "130 50 40",
  scope: "Design System Plus",
  de: "Peperonigrün",
  en: "Hot pepper green",
  nl: "Pepperoni groen",
  fr: "Vert poivron"
}, {
  hex: "#5d8947",
  code: "130 50 50",
  scope: "Design System Plus",
  de: "Smaragdklargrün",
  en: "Emerald clear green",
  nl: "Smaragd helder groen",
  fr: "Vert émeraude clair"
}, {
  hex: "#909989",
  code: "130 60 10",
  scope: "Design System Plus",
  de: "Salbeimattgrün",
  en: "Matte sage green",
  nl: "Saliegroen",
  fr: "Vert imitation sauge"
}, {
  hex: "#8a9b7d",
  code: "130 60 20",
  scope: "Design System Plus",
  de: "Altgrün",
  en: "Old green",
  nl: "Oud groen",
  fr: "Vieux vert"
}, {
  hex: "#839d71",
  code: "130 60 30",
  scope: "Design System Plus",
  de: "Erbsauberginengrün",
  en: "Pea aubergine green",
  nl: "Erwt aubergine groen",
  fr: "Vert aubergine de pois"
}, {
  hex: "#7c9f64",
  code: "130 60 40",
  scope: "Design System Plus",
  de: "Grashüpfergrün",
  en: "Grasshopper green",
  nl: "Sprinkhaan groen",
  fr: "Vert sauterelle"
}, {
  hex: "#74a256",
  code: "130 60 50",
  scope: "Design System Plus",
  de: "Parisergrün",
  en: "Parisian green",
  nl: "Parijs groen",
  fr: "Vert parisien"
}, {
  hex: "#69a449",
  code: "130 60 60",
  scope: "Design System Plus",
  de: "Urgrün",
  en: "Primal green",
  nl: "Oergroen",
  fr: "Vert primitif"
}, {
  hex: "#a9b3a3",
  code: "130 70 10",
  scope: "Design System Plus",
  de: "Kalkgrün",
  en: "Limestone green",
  nl: "Limoengroen",
  fr: "Vert chaux"
}, {
  hex: "#a4b695",
  code: "130 70 20",
  scope: "Design System Plus",
  de: "Seifengrün",
  en: "Soap green",
  nl: "Zeep groen",
  fr: "Vert sapin"
}, {
  hex: "#9bb787",
  code: "130 70 30",
  scope: "Design System Plus",
  de: "Aquarellgrün",
  en: "Watercolour green",
  nl: "Aquarel groen",
  fr: "Vert aquarelle"
}, {
  hex: "#94b979",
  code: "130 70 40",
  scope: "Design System Plus",
  de: "Vangoghgrün",
  en: "Vangogh green",
  nl: "Vangogh groen",
  fr: "Vert vangogh"
}, {
  hex: "#8dbc6e",
  code: "130 70 50",
  scope: "Design System Plus",
  de: "Apfelgrün",
  en: "Apple green",
  nl: "Appelgroen",
  fr: "Vert pomme"
}, {
  hex: "#84be5f",
  code: "130 70 60",
  scope: "Design System Plus",
  de: "Ultragrün",
  en: "Ultra green",
  nl: "Ultragroen",
  fr: "Ultra vert"
}, {
  hex: "#c3ccbb",
  code: "130 80 10",
  scope: "Design System Plus",
  de: "Jadehellgrün",
  en: "Jade light green",
  nl: "Jade lichtgroen",
  fr: "Vert jade clair"
}, {
  hex: "#bdcead",
  code: "130 80 20",
  scope: "Design System Plus",
  de: "Emaillegrün",
  en: "Enamel green",
  nl: "Groen email",
  fr: "Vert émail"
}, {
  hex: "#b6d1a0",
  code: "130 80 30",
  scope: "Design System Plus",
  de: "Pastellgrün",
  en: "Pastel green",
  nl: "Pastelgroen",
  fr: "Vert pastel"
}, {
  hex: "#afd592",
  code: "130 80 40",
  scope: "Design System Plus",
  de: "Jasmingrün",
  en: "Jasmine green",
  nl: "Jasmijngroen",
  fr: "Vert jasmin"
}, {
  hex: "#a7d683",
  code: "130 80 50",
  scope: "Design System Plus",
  de: "Kristallgrün",
  en: "Crystal green",
  nl: "Kristalgroen",
  fr: "Vert cristal"
}, {
  hex: "#d1d7cd",
  code: "130 85 05",
  scope: "Design System Plus",
  de: "Traubenölgrün",
  en: "Grape oil green",
  nl: "Druivenolie groen",
  fr: "Vert huile de raisin"
}, {
  hex: "#cfd9c6",
  code: "130 85 10",
  scope: "Design System Plus",
  de: "Duchamplichtgrün",
  en: "Duchamp light green",
  nl: "Duchamp lichtgroen",
  fr: "Vert lumière de Duchamp"
}, {
  hex: "#c9dbb8",
  code: "130 85 20",
  scope: "Design System Plus",
  de: "Bleichhellgrün",
  en: "Pallid light green",
  nl: "Lichtgroen",
  fr: "Vert pâle clair"
}, {
  hex: "#c5deac",
  code: "130 85 30",
  scope: "Design System Plus",
  de: "Viridingrün",
  en: "Viridine green",
  nl: "Viridian groen",
  fr: "Vert viridine"
}, {
  hex: "#e0e4da",
  code: "130 90 05",
  scope: "Design System Plus",
  de: "Silberpappelweiß",
  en: "Silver poplar white",
  nl: "Zilverpopulier wit",
  fr: "Blanc peuplier argenté"
}, {
  hex: "#e0e3d9",
  code: "130 90 10",
  scope: "Design System Plus",
  de: "Mediterrangrün",
  en: "Mediterranean green",
  nl: "Mediterraan groen",
  fr: "Vert Méditerranée"
}, {
  hex: "#d8e9c6",
  code: "130 90 20",
  scope: "Design System Plus",
  de: "Frühlingsgrün",
  en: "Spring green",
  nl: "Lentegroen",
  fr: "Vert printemps"
}, {
  hex: "#e8ece3",
  code: "130 93 05",
  scope: "Design System Plus",
  de: "Bohnenweiß",
  en: "Bean white",
  nl: "Bonen wit",
  fr: "Blanc de haricot"
}, {
  hex: "#454845",
  code: "140 20 05",
  scope: "Design System Plus",
  de: "Melanitschwarzgrün",
  en: "Melanite black green",
  nl: "Melaniet zwart-groen",
  fr: "Vert mélanite noir"
}, {
  hex: "#424941",
  code: "140 20 10",
  scope: "Design System Plus",
  de: "Gebirgsgrün",
  en: "Mountain range green",
  nl: "Berggroen",
  fr: "Vert montagne"
}, {
  hex: "#414b3e",
  code: "140 20 20",
  scope: "Design System Plus",
  de: "Bayrischgrün",
  en: "Bavarian green",
  nl: "Beiers groen",
  fr: "Vert de Bavière"
}, {
  hex: "#555954",
  code: "140 30 05",
  scope: "Design System Plus",
  de: "Schwarzwaldgrün",
  en: "Black Forest green",
  nl: "Zwarte Woud groen",
  fr: "Vert Forêt Noire"
}, {
  hex: "#51594f",
  code: "140 30 10",
  scope: "Design System Plus",
  de: "Kupferkiesgrün",
  en: "Copper pyrite green",
  nl: "Chalcopyriet groen",
  fr: "Vert cuivré"
}, {
  hex: "#4b5c48",
  code: "140 30 20",
  scope: "Design System Plus",
  de: "Brennnesselgrün",
  en: "Nettle green",
  nl: "Brandnetel groen",
  fr: "Vert d'ortie"
}, {
  hex: "#425e3f",
  code: "140 30 30",
  scope: "Design System Plus",
  de: "Edelkastaniengrün",
  en: "Chestnut green",
  nl: "Tamme kastanje groen",
  fr: "Vert châtaigne"
}, {
  hex: "#395e3c",
  code: "140 30 40",
  scope: "Design System Plus",
  de: "Förstergrün",
  en: "Ranger green",
  nl: "Förstergrün",
  fr: "Förstergrün"
}, {
  hex: "#676c66",
  code: "140 40 05",
  scope: "Design System Plus",
  de: "Steingrün",
  en: "Stone green",
  nl: "Steengroen",
  fr: "Vert pierre"
}, {
  hex: "#626c60",
  code: "140 40 10",
  scope: "Design System Plus",
  de: "Lodengrün",
  en: "Loden green",
  nl: "Loden groen",
  fr: "Vert loden"
}, {
  hex: "#586d55",
  code: "140 40 20",
  scope: "Design System Plus",
  de: "Akaziengrün",
  en: "Acacia green",
  nl: "Acaciagroen",
  fr: "Vert acacia"
}, {
  hex: "#51704c",
  code: "140 40 30",
  scope: "Design System Plus",
  de: "Pfaugrün",
  en: "Peacock green",
  nl: "Pauwgroen",
  fr: "Vert paon"
}, {
  hex: "#487547",
  code: "140 40 40",
  scope: "Design System Plus",
  de: "Radikalgrün",
  en: "Radical green",
  nl: "Radicaal groen",
  fr: "Vert radical"
}, {
  hex: "#407740",
  code: "140 40 50",
  scope: "Design System Plus",
  de: "Brasilgrün",
  en: "Brazilian green",
  nl: "Brazilië groen",
  fr: "Vert brésil"
}, {
  hex: "#7a8079",
  code: "140 50 05",
  scope: "Design System Plus",
  de: "Silberahorngrün",
  en: "Silver maple green",
  nl: "Groene zilveresdoorn",
  fr: "Vert érable argenté"
}, {
  hex: "#768174",
  code: "140 50 10",
  scope: "Design System Plus",
  de: "Edeltannengrün",
  en: "Fir spruce green",
  nl: "Zilverspar groen",
  fr: "Vert sapin noble"
}, {
  hex: "#6e8368",
  code: "140 50 20",
  scope: "Design System Plus",
  de: "Silberweidengrün",
  en: "Silver willow green",
  nl: "Zilver wilgengroen",
  fr: "Vert saule argenté"
}, {
  hex: "#65875f",
  code: "140 50 30",
  scope: "Design System Plus",
  de: "Wandergrün",
  en: "Rambling green",
  nl: "Groen wandelen",
  fr: "Vert de marche"
}, {
  hex: "#588853",
  code: "140 50 40",
  scope: "Design System Plus",
  de: "Guineagrün",
  en: "Guinean green",
  nl: "Guinea groen",
  fr: "Vert guinée"
}, {
  hex: "#4f8c4c",
  code: "140 50 50",
  scope: "Design System Plus",
  de: "Bergwiesengrün",
  en: "Mountain meadow green",
  nl: "Bergweide groen",
  fr: "Vert prairie de montagne"
}, {
  hex: "#408e42",
  code: "140 50 60",
  scope: "Design System Plus",
  de: "Temperamentgrün",
  en: "Temperamental green",
  nl: "Temperament groen",
  fr: "Vert de tempérament"
}, {
  hex: "#919791",
  code: "140 60 05",
  scope: "Design System Plus",
  de: "Camouflagegrün",
  en: "Camouflage green",
  nl: "Camouflagegroen",
  fr: "Vert camouflage"
}, {
  hex: "#8b9889",
  code: "140 60 10",
  scope: "Design System Plus",
  de: "Silberlindengrau",
  en: "Silver linden grey",
  nl: "Zilver limoengrijs",
  fr: "Gris tilleul argenté"
}, {
  hex: "#859e80",
  code: "140 60 20",
  scope: "Design System Plus",
  de: "Spinatgrün",
  en: "Spinach green",
  nl: "Spinazie groen",
  fr: "Vert des épinards"
}, {
  hex: "#7ba174",
  code: "140 60 30",
  scope: "Design System Plus",
  de: "Schwarzdorngrün",
  en: "Blackthorn green",
  nl: "Sleedoorn groen",
  fr: "Vert épine noire"
}, {
  hex: "#72a369",
  code: "140 60 40",
  scope: "Design System Plus",
  de: "Frischgrün",
  en: "Fresh green",
  nl: "Frisgroen",
  fr: "Vert frais"
}, {
  hex: "#64a45e",
  code: "140 60 50",
  scope: "Design System Plus",
  de: "Petersiliengrün",
  en: "Parsley green",
  nl: "Peterselie groen",
  fr: "Vert persil"
}, {
  hex: "#59a754",
  code: "140 60 60",
  scope: "Design System Plus",
  de: "Oreganogrün",
  en: "Oregano green",
  nl: "Oregano groen",
  fr: "Vert origan"
}, {
  hex: "#4aa74b",
  code: "140 60 70",
  scope: "Design System Plus",
  de: "Ballongrün",
  en: "Balloon green",
  nl: "Ballon groen",
  fr: "Vert ballon"
}, {
  hex: "#aab0a9",
  code: "140 70 05",
  scope: "Design System Plus",
  de: "Ginkgogrün",
  en: "Ginkgo green",
  nl: "Ginkgo groen",
  fr: "Vert ginkgo"
}, {
  hex: "#a3b1a3",
  code: "140 70 10",
  scope: "Design System Plus",
  de: "Wermutgrün",
  en: "Wormwood green",
  nl: "Alsem groen",
  fr: "Vert absinthe"
}, {
  hex: "#9cb697",
  code: "140 70 20",
  scope: "Design System Plus",
  de: "Taugrün",
  en: "Dew green",
  nl: "Dauwgroen",
  fr: "Vert de rosée"
}, {
  hex: "#91b98c",
  code: "140 70 30",
  scope: "Design System Plus",
  de: "Anisblattgrün",
  en: "Aniseed leaf green",
  nl: "Anijsblad groen",
  fr: "Vert feuille d'anis"
}, {
  hex: "#89bd80",
  code: "140 70 40",
  scope: "Design System Plus",
  de: "Sauergrün",
  en: "Sour green",
  nl: "Zuur groen",
  fr: "Vert acide"
}, {
  hex: "#7cbf74",
  code: "140 70 50",
  scope: "Design System Plus",
  de: "Acidgrün",
  en: "Acid green",
  nl: "Zuurgroen",
  fr: "Vert acide"
}, {
  hex: "#71c067",
  code: "140 70 60",
  scope: "Design System Plus",
  de: "Dropsgrün",
  en: "Drop green",
  nl: "Groen laten vallen",
  fr: "Dropsgrün"
}, {
  hex: "#c5ccc2",
  code: "140 80 05",
  scope: "Design System Plus",
  de: "Weidengrün",
  en: "Willow green",
  nl: "Wilgengroen",
  fr: "Vert saule"
}, {
  hex: "#bfccbc",
  code: "140 80 10",
  scope: "Design System Plus",
  de: "Pastellgraugrün",
  en: "Pastel grey green",
  nl: "Pastel grijsgroen",
  fr: "Vert gris pastel"
}, {
  hex: "#b6d0b0",
  code: "140 80 20",
  scope: "Design System Plus",
  de: "Giopontigrün",
  en: "Gio Ponti green",
  nl: "Gioponti groen",
  fr: "Vert Gioponti"
}, {
  hex: "#abd3a4",
  code: "140 80 30",
  scope: "Design System Plus",
  de: "Entspannungsgrün",
  en: "Relaxation green",
  nl: "Ontspannend groen",
  fr: "Vert de détente"
}, {
  hex: "#9dd697",
  code: "140 80 40",
  scope: "Design System Plus",
  de: "Dentistgrün",
  en: "Dentist green",
  nl: "Tandarts groen",
  fr: "Vert Dentist"
}, {
  hex: "#d0d8cf",
  code: "140 85 05",
  scope: "Design System Plus",
  de: "Taubnesselweiß",
  en: "Deadnettle white",
  nl: "Dode brandnetel wit",
  fr: "Blanc d'ortie"
}, {
  hex: "#ccdaca",
  code: "140 85 10",
  scope: "Design System Plus",
  de: "Lauchweiß",
  en: "Leek white",
  nl: "Prei wit",
  fr: "Blanc poireau"
}, {
  hex: "#c3debd",
  code: "140 85 20",
  scope: "Design System Plus",
  de: "Kalkschiefer",
  en: "Limestone slate",
  nl: "Kalkhoudende schalie",
  fr: "Schiste calcaire"
}, {
  hex: "#b6dfb0",
  code: "140 85 30",
  scope: "Design System Plus",
  de: "Minzcocktailgrün",
  en: "Mint cocktail green",
  nl: "Munt cocktail groen",
  fr: "Vert cocktail à la menthe"
}, {
  hex: "#e0e6db",
  code: "140 90 05",
  scope: "Design System Plus",
  de: "Rosmarinweiß",
  en: "Rosemary white",
  nl: "Rozemarijn wit",
  fr: "Blanc romarin"
}, {
  hex: "#dce8d6",
  code: "140 90 10",
  scope: "Design System Plus",
  de: "Hauchgrün",
  en: "Touch of green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#e8eee4",
  code: "140 93 05",
  scope: "Design System Plus",
  de: "Kastanienweiß",
  en: "Chestnut white",
  nl: "Kastanje wit",
  fr: "Blanc châtaigne"
}, {
  hex: "#515c53",
  code: "150 30 10",
  scope: "Design System Plus",
  de: "Thymiangrün",
  en: "Thyme green",
  nl: "Tijm groen",
  fr: "Vert thym"
}, {
  hex: "#475e4e",
  code: "150 30 20",
  scope: "Design System Plus",
  de: "Moselgrün",
  en: "Moselle green",
  nl: "Moezel groen",
  fr: "Vert Moselle"
}, {
  hex: "#3d5e46",
  code: "150 30 30",
  scope: "Design System Plus",
  de: "Berggrün",
  en: "Mountain green",
  nl: "Berggroen",
  fr: "Vert montagne"
}, {
  hex: "#616d63",
  code: "150 40 10",
  scope: "Design System Plus",
  de: "Filzgrün",
  en: "Felt green",
  nl: "Vilt groen",
  fr: "Vert feutre"
}, {
  hex: "#58715c",
  code: "150 40 20",
  scope: "Design System Plus",
  de: "Prallgrün",
  en: "Firm green",
  nl: "Invloed groen",
  fr: "Vert perle"
}, {
  hex: "#4a7254",
  code: "150 40 30",
  scope: "Design System Plus",
  de: "Genevergrün",
  en: "Genever green",
  nl: "Jenever groen",
  fr: "Vert genièvre"
}, {
  hex: "#3c744c",
  code: "150 40 40",
  scope: "Design System Plus",
  de: "Tintengrün",
  en: "Ink green",
  nl: "Inkt groen",
  fr: "Vert d'encre"
}, {
  hex: "#307649",
  code: "150 40 50",
  scope: "Design System Plus",
  de: "Irlandgrün",
  en: "Ireland green",
  nl: "Ierland groen",
  fr: "Vert Irlande"
}, {
  hex: "#738176",
  code: "150 50 10",
  scope: "Design System Plus",
  de: "Salbeigrüngrau",
  en: "Sage green grey",
  nl: "Saliegroen grijs",
  fr: "Gris vert sauge"
}, {
  hex: "#69866e",
  code: "150 50 20",
  scope: "Design System Plus",
  de: "Koreaminze",
  en: "Korean mint",
  nl: "Koreaanse munt",
  fr: "Menthe coréenne"
}, {
  hex: "#608866",
  code: "150 50 30",
  scope: "Design System Plus",
  de: "Feldgrün",
  en: "Field green",
  nl: "Veld groen",
  fr: "Vert champ"
}, {
  hex: "#518d63",
  code: "150 50 40",
  scope: "Design System Plus",
  de: "Selleriegrün",
  en: "Celery green",
  nl: "Selderij groen",
  fr: "Vert céleri"
}, {
  hex: "#3e8f58",
  code: "150 50 50",
  scope: "Design System Plus",
  de: "Sattgrün",
  en: "Rich green",
  nl: "Weelderig groen",
  fr: "Vert saturé"
}, {
  hex: "#239151",
  code: "150 50 60",
  scope: "Design System Plus",
  de: "Kaltgrün",
  en: "Cold green",
  nl: "Koud groen",
  fr: "Vert froid"
}, {
  hex: "#8c9b8e",
  code: "150 60 10",
  scope: "Design System Plus",
  de: "Spitzkohlgrün",
  en: "Pointed cabbage green",
  nl: "Spitskool groen",
  fr: "Chou pointu vert"
}, {
  hex: "#7f9e86",
  code: "150 60 20",
  scope: "Design System Plus",
  de: "Orientgrün",
  en: "Orient green",
  nl: "Oosters groen",
  fr: "Vert d'Orient"
}, {
  hex: "#73a07d",
  code: "150 60 30",
  scope: "Design System Plus",
  de: "Rosmaringrün",
  en: "Rosemary green",
  nl: "Rozemarijn groen",
  fr: "Vert romarin"
}, {
  hex: "#65a474",
  code: "150 60 40",
  scope: "Design System Plus",
  de: "Mosaikgrün",
  en: "Mosaic green",
  nl: "Mozaïek groen",
  fr: "Vert mosaïque"
}, {
  hex: "#58a96f",
  code: "150 60 50",
  scope: "Design System Plus",
  de: "Flummigrün",
  en: "Bouncy ball green",
  nl: "Flodderig groen",
  fr: "Vert fluo"
}, {
  hex: "#3aa861",
  code: "150 60 60",
  scope: "Design System Plus",
  de: "Energiegrün",
  en: "Energy green",
  nl: "Groene energie",
  fr: "Vert d'énergie"
}, {
  hex: "#a3b3a6",
  code: "150 70 10",
  scope: "Design System Plus",
  de: "Teegrün",
  en: "Tea green",
  nl: "Groene thee",
  fr: "Vert thé"
}, {
  hex: "#98b89f",
  code: "150 70 20",
  scope: "Design System Plus",
  de: "Liebermanngrün",
  en: "Liebermann green",
  nl: "Liebermann groen",
  fr: "Vert Liebermann"
}, {
  hex: "#8abd95",
  code: "150 70 30",
  scope: "Design System Plus",
  de: "Wachstuchgrün",
  en: "Oilcloth green",
  nl: "Tafelzeil groen",
  fr: "Toile cirée verte"
}, {
  hex: "#7cbe8c",
  code: "150 70 40",
  scope: "Design System Plus",
  de: "Jadesteingrün",
  en: "Jade stone green",
  nl: "Jade steen groen",
  fr: "Vert jade"
}, {
  hex: "#6cc181",
  code: "150 70 50",
  scope: "Design System Plus",
  de: "Grünspanfarben",
  en: "Verdigris coloured",
  nl: "verdigris kleuren",
  fr: "Couleurs vert-de-gris"
}, {
  hex: "#bdcec0",
  code: "150 80 10",
  scope: "Design System Plus",
  de: "Organzagrün",
  en: "Organza green",
  nl: "Organza groen",
  fr: "Vert organza"
}, {
  hex: "#b1d2b7",
  code: "150 80 20",
  scope: "Design System Plus",
  de: "Pastellminzgrün",
  en: "Pastel mint green",
  nl: "Pastel mintgroen",
  fr: "Vert menthe pastel"
}, {
  hex: "#a3d6af",
  code: "150 80 30",
  scope: "Design System Plus",
  de: "Knallgrün",
  en: "Bright green",
  nl: "Heldergroen",
  fr: "Vert vif"
}, {
  hex: "#95daa5",
  code: "150 80 40",
  scope: "Design System Plus",
  de: "Perlmuttgrün",
  en: "Mother-of-pearl green",
  nl: "Parelmoer groen",
  fr: "Vert nacré"
}, {
  hex: "#ccd7ce",
  code: "150 85 05",
  scope: "Design System Plus",
  de: "Spargelweiß",
  en: "Asparagus white",
  nl: "Asperges wit",
  fr: "Blanc asperge"
}, {
  hex: "#c9daca",
  code: "150 85 10",
  scope: "Design System Plus",
  de: "Transparentweiß",
  en: "Transparent white",
  nl: "Transparant wit",
  fr: "Blanc transparent"
}, {
  hex: "#bfdec1",
  code: "150 85 20",
  scope: "Design System Plus",
  de: "Bleichgrün",
  en: "Pallid green",
  nl: "Lichtgroen",
  fr: "Vert pâle"
}, {
  hex: "#dce5da",
  code: "150 90 05",
  scope: "Design System Plus",
  de: "Mineralweiß",
  en: "Mineral white",
  nl: "Mineraal wit",
  fr: "Blanc minéral"
}, {
  hex: "#d9e9d8",
  code: "150 90 10",
  scope: "Design System Plus",
  de: "Alabastergrün",
  en: "Alabaster green",
  nl: "Albastgroen",
  fr: "Vert albâtre"
}, {
  hex: "#e4ede4",
  code: "150 93 05",
  scope: "Design System Plus",
  de: "Quarkweiß",
  en: "Quark white",
  nl: "Kwark wit",
  fr: "Blancheur de fromage blanc"
}, {
  hex: "#464a48",
  code: "160 20 05",
  scope: "Design System Plus",
  de: "Beryllschwarzgrün",
  en: "Beryl black green",
  nl: "Beryl zwartgroen",
  fr: "Vert béryl noir"
}, {
  hex: "#404b45",
  code: "160 20 10",
  scope: "Design System Plus",
  de: "Schalmuschelgrün",
  en: "Mussel green",
  nl: "Jacobsschelp groen",
  fr: "Vert coquille"
}, {
  hex: "#394a43",
  code: "160 20 15",
  scope: "Design System Plus",
  de: "Kürbisgrünschwarz",
  en: "Pumpkin green black",
  nl: "Pompoen groen-zwart",
  fr: "Vert citrouille noir"
}, {
  hex: "#394942",
  code: "160 20 20",
  scope: "Design System Plus",
  de: "Opulentgrün",
  en: "Opulent green",
  nl: "Weelderig groen",
  fr: "Vert opulent"
}, {
  hex: "#535955",
  code: "160 30 05",
  scope: "Design System Plus",
  de: "Sattoliv",
  en: "Rich olive",
  nl: "Sattoliv",
  fr: "Sattoliv"
}, {
  hex: "#4e5a53",
  code: "160 30 10",
  scope: "Design System Plus",
  de: "Exklusivgrün",
  en: "Exclusive green",
  nl: "Exclusief groen",
  fr: "Vert exclusif"
}, {
  hex: "#485a4f",
  code: "160 30 15",
  scope: "Design System Plus",
  de: "Blattgrün",
  en: "Leaf green",
  nl: "Bladgroen",
  fr: "Vert feuille"
}, {
  hex: "#415a4d",
  code: "160 30 20",
  scope: "Design System Plus",
  de: "Bergminze",
  en: "Mountain mint",
  nl: "Bergmunt",
  fr: "Menthe des montagnes"
}, {
  hex: "#3b5c4a",
  code: "160 30 25",
  scope: "Design System Plus",
  de: "Ordnungsgrün",
  en: "Order green",
  nl: "Groen bestellen",
  fr: "Vert d'ordre"
}, {
  hex: "#345e48",
  code: "160 30 30",
  scope: "Design System Plus",
  de: "Trollgrün",
  en: "Troll green",
  nl: "Trollengroen",
  fr: "Vert troll"
}, {
  hex: "#2c5e45",
  code: "160 30 35",
  scope: "Design System Plus",
  de: "Spieltischgrün",
  en: "Card table green",
  nl: "Speltafel groen",
  fr: "Vert table de jeu"
}, {
  hex: "#235f44",
  code: "160 30 40",
  scope: "Design System Plus",
  de: "Zitronenmelissengrün",
  en: "Lemon balm green",
  nl: "Citroenmelisse groen",
  fr: "Vert mélisse citronnée"
}, {
  hex: "#656c68",
  code: "160 40 05",
  scope: "Design System Plus",
  de: "Jaspisgrün",
  en: "Jasper green",
  nl: "Jaspis groen",
  fr: "Vert jaspe"
}, {
  hex: "#5d6d65",
  code: "160 40 10",
  scope: "Design System Plus",
  de: "Sibirischgrün",
  en: "Siberian green",
  nl: "Siberisch groen",
  fr: "Vert sibérien"
}, {
  hex: "#576e62",
  code: "160 40 15",
  scope: "Design System Plus",
  de: "Gurkengrün",
  en: "Cucumber green",
  nl: "Komkommer groen",
  fr: "Vert concombre"
}, {
  hex: "#506f5f",
  code: "160 40 20",
  scope: "Design System Plus",
  de: "Serbischgrün",
  en: "Serbian green",
  nl: "Servisch groen",
  fr: "Vert serbe"
}, {
  hex: "#49705b",
  code: "160 40 25",
  scope: "Design System Plus",
  de: "Schwarzkiefergrün",
  en: "Black pine green",
  nl: "Zwarte dennengroen",
  fr: "Vert pin noir"
}, {
  hex: "#427259",
  code: "160 40 30",
  scope: "Design System Plus",
  de: "Kürbisgrün",
  en: "Pumpkin green",
  nl: "Pompoen groen",
  fr: "Vert citrouille"
}, {
  hex: "#3a7457",
  code: "160 40 35",
  scope: "Design System Plus",
  de: "Jademuschelgrün",
  en: "Jade mussel green",
  nl: "Jade schelp groen",
  fr: "Vert coquille de jade"
}, {
  hex: "#317656",
  code: "160 40 40",
  scope: "Design System Plus",
  de: "Kleegrün",
  en: "Clover green",
  nl: "Klaver groen",
  fr: "Vert de trèfle"
}, {
  hex: "#287451",
  code: "160 40 45",
  scope: "Design System Plus",
  de: "Froschgrün",
  en: "Frog green",
  nl: "Kikkergroen",
  fr: "Vert grenouille"
}, {
  hex: "#16754e",
  code: "160 40 50",
  scope: "Design System Plus",
  de: "Universalgrün",
  en: "Universal green",
  nl: "Universeel groen",
  fr: "Vert universel"
}, {
  hex: "#05784d",
  code: "160 40 55",
  scope: "Design System Plus",
  de: "Säuleneichengrün",
  en: "Column of oak green",
  nl: "Kolom eik groen",
  fr: "Vert chêne colonnaire"
}, {
  hex: "#79817c",
  code: "160 50 05",
  scope: "Design System Plus",
  de: "Arktisflechtengrün",
  en: "Arctic lichen green",
  nl: "Arctisch korstmos groen",
  fr: "Vert lichen arctique"
}, {
  hex: "#708278",
  code: "160 50 10",
  scope: "Design System Plus",
  de: "Atlaszedergrün",
  en: "Atlas cedar green",
  nl: "Atlas cedergroen",
  fr: "Vert cèdre de l'Atlas"
}, {
  hex: "#6a8476",
  code: "160 50 15",
  scope: "Design System Plus",
  de: "Steinzypressengrün",
  en: "Stone cypress green",
  nl: "Steen cipres groen",
  fr: "Vert cyprès de roche"
}, {
  hex: "#638674",
  code: "160 50 20",
  scope: "Design System Plus",
  de: "Wacholdergrün",
  en: "Juniper green",
  nl: "Juniper groen",
  fr: "Vert de genièvre"
}, {
  hex: "#5b8770",
  code: "160 50 25",
  scope: "Design System Plus",
  de: "Sportplatzgrün",
  en: "Sports field green",
  nl: "Sportveld groen",
  fr: "Espaces verts des terrains de sport"
}, {
  hex: "#54896e",
  code: "160 50 30",
  scope: "Design System Plus",
  de: "Freizeitgrün",
  en: "Leisure green",
  nl: "Vrije tijd groen",
  fr: "Vert de loisirs"
}, {
  hex: "#4e8b6b",
  code: "160 50 35",
  scope: "Design System Plus",
  de: "Adamingrün",
  en: "Adamite green",
  nl: "Adamine groen",
  fr: "Vert adamantin"
}, {
  hex: "#3f8c68",
  code: "160 50 40",
  scope: "Design System Plus",
  de: "Metallgrün",
  en: "Metallic green",
  nl: "Metaal groen",
  fr: "Vert métal"
}, {
  hex: "#398f68",
  code: "160 50 45",
  scope: "Design System Plus",
  de: "Vitalgrün",
  en: "Vital green",
  nl: "Vitaal groen",
  fr: "Vert vital"
}, {
  hex: "#298e62",
  code: "160 50 50",
  scope: "Design System Plus",
  de: "Golfgrün",
  en: "Golf green",
  nl: "Golfbaan",
  fr: "Vert de golf"
}, {
  hex: "#109161",
  code: "160 50 55",
  scope: "Design System Plus",
  de: "Islandgrün",
  en: "Iceland green",
  nl: "IJsland groen",
  fr: "Vert Islande"
}, {
  hex: "#00905c",
  code: "160 50 60",
  scope: "Design System Plus",
  de: "Echttürkis",
  en: "Real turquoise",
  nl: "Echt turkoois",
  fr: "Turquoise véritable"
}, {
  hex: "#8f9893",
  code: "160 60 05",
  scope: "Design System Plus",
  de: "Sandsteingraugrün",
  en: "Sandstone grey green",
  nl: "Zandsteen grijsgroen",
  fr: "Vert grès gris"
}, {
  hex: "#86998f",
  code: "160 60 10",
  scope: "Design System Plus",
  de: "Schiefergrün",
  en: "Slate green",
  nl: "Leigroen",
  fr: "Vert ardoise"
}, {
  hex: "#809d8d",
  code: "160 60 15",
  scope: "Design System Plus",
  de: "Mildgrün",
  en: "Mild green",
  nl: "Mild groen",
  fr: "Vert lait"
}, {
  hex: "#779e89",
  code: "160 60 20",
  scope: "Design System Plus",
  de: "Douglasiengrün",
  en: "Douglas fir green",
  nl: "Douglas groen",
  fr: "Vert douglas"
}, {
  hex: "#709f84",
  code: "160 60 25",
  scope: "Design System Plus",
  de: "Praxisgrün",
  en: "Practice green",
  nl: "Oefengreen",
  fr: "Vert de pratique"
}, {
  hex: "#68a183",
  code: "160 60 30",
  scope: "Design System Plus",
  de: "Memphisgrün",
  en: "Memphis green",
  nl: "Memphis groen",
  fr: "Vert Memphis"
}, {
  hex: "#5fa582",
  code: "160 60 35",
  scope: "Design System Plus",
  de: "Werbegrün",
  en: "Advertising green",
  nl: "Reclame groen",
  fr: "Verdure publicitaire"
}, {
  hex: "#55a47e",
  code: "160 60 40",
  scope: "Design System Plus",
  de: "Jägergrün",
  en: "Hunter green",
  nl: "Jagergroen",
  fr: "Vert chasseur"
}, {
  hex: "#4ca77c",
  code: "160 60 45",
  scope: "Design System Plus",
  de: "Linoleumgrün",
  en: "Linoleum green",
  nl: "Linoleum groen",
  fr: "Vert linoléum"
}, {
  hex: "#3ba878",
  code: "160 60 50",
  scope: "Design System Plus",
  de: "Sittichgrün",
  en: "Parakeet green",
  nl: "Parkiet groen",
  fr: "Vert perruche"
}, {
  hex: "#32a774",
  code: "160 60 55",
  scope: "Design System Plus",
  de: "Smaragdhellgrün",
  en: "Emerald light green",
  nl: "Smaragdgroen lichtgroen",
  fr: "Vert émeraude clair"
}, {
  hex: "#1ca971",
  code: "160 60 58",
  scope: "Design System Plus",
  de: "Alhambragrün",
  en: "Alhambra green",
  nl: "Alhambra groen",
  fr: "Vert alhambra"
}, {
  hex: "#a7b2ac",
  code: "160 70 05",
  scope: "Design System Plus",
  de: "Grünlichgrau",
  en: "Greenish grey",
  nl: "Groenachtig grijs",
  fr: "Gris verdâtre"
}, {
  hex: "#9eb3a7",
  code: "160 70 10",
  scope: "Design System Plus",
  de: "Schwachgrün",
  en: "Weak green",
  nl: "Lichtgroen",
  fr: "Vert faible"
}, {
  hex: "#96b4a3",
  code: "160 70 15",
  scope: "Design System Plus",
  de: "Andeerschiefer",
  en: "Andean slate",
  nl: "Andeer leisteen",
  fr: "Schiste d'Andeer"
}, {
  hex: "#90b7a1",
  code: "160 70 20",
  scope: "Design System Plus",
  de: "Keramikgrün",
  en: "Ceramic green",
  nl: "Groen keramiek",
  fr: "Vert céramique"
}, {
  hex: "#88bb9f",
  code: "160 70 25",
  scope: "Design System Plus",
  de: "Wassergrün",
  en: "Water green",
  nl: "Water groen",
  fr: "Vert d'eau"
}, {
  hex: "#7dbc9c",
  code: "160 70 30",
  scope: "Design System Plus",
  de: "Bergseegrün",
  en: "Mountain lake green",
  nl: "Bergmeer groen",
  fr: "Vert du lac de montagne"
}, {
  hex: "#74bd99",
  code: "160 70 35",
  scope: "Design System Plus",
  de: "Amerikanischgrün",
  en: "American green",
  nl: "Amerikaans groen",
  fr: "Vert américain"
}, {
  hex: "#6ac096",
  code: "160 70 40",
  scope: "Design System Plus",
  de: "Technotürkis",
  en: "Techno turquoise",
  nl: "Technoturquoise",
  fr: "Technotürkis"
}, {
  hex: "#5ec292",
  code: "160 70 45",
  scope: "Design System Plus",
  de: "Grellgrün",
  en: "Garish green",
  nl: "Heldergroen",
  fr: "Vert vif"
}, {
  hex: "#54c391",
  code: "160 70 50",
  scope: "Design System Plus",
  de: "Malachitgrün",
  en: "Malachite green",
  nl: "Malachietgroen",
  fr: "Vert malachite"
}, {
  hex: "#bfcac4",
  code: "160 80 05",
  scope: "Design System Plus",
  de: "Nebelgrün",
  en: "Fog green",
  nl: "Mist groen",
  fr: "Vert brume"
}, {
  hex: "#b8cdc0",
  code: "160 80 10",
  scope: "Design System Plus",
  de: "Jademattgrün",
  en: "Matte jade green",
  nl: "Jadegroen",
  fr: "Vert jade"
}, {
  hex: "#afcfbd",
  code: "160 80 15",
  scope: "Design System Plus",
  de: "Sonnengrün",
  en: "Sun yellow",
  nl: "Zon groen",
  fr: "Vert soleil"
}, {
  hex: "#a7d2ba",
  code: "160 80 20",
  scope: "Design System Plus",
  de: "Federngrün",
  en: "Feather green",
  nl: "Veder groen",
  fr: "Vert plume"
}, {
  hex: "#a1d4b8",
  code: "160 80 25",
  scope: "Design System Plus",
  de: "Mentholgrün",
  en: "Menthol green",
  nl: "Menthol groen",
  fr: "Vert menthol"
}, {
  hex: "#99d7b6",
  code: "160 80 30",
  scope: "Design System Plus",
  de: "Seidengrün",
  en: "Silk green",
  nl: "Zijde groen",
  fr: "Vert soie"
}, {
  hex: "#cad6cf",
  code: "160 85 05",
  scope: "Design System Plus",
  de: "Leichtgrün",
  en: "Light green",
  nl: "Lichtgroen",
  fr: "Vert léger"
}, {
  hex: "#c3d8cc",
  code: "160 85 10",
  scope: "Design System Plus",
  de: "Glimmergrün",
  en: "Micaceous green",
  nl: "Mica groen",
  fr: "Vert mica"
}, {
  hex: "#bbdbc7",
  code: "160 85 15",
  scope: "Design System Plus",
  de: "Mondsteingrün",
  en: "Moonstone green",
  nl: "Maansteen groen",
  fr: "Vert pierre de lune"
}, {
  hex: "#dbe5dc",
  code: "160 90 05",
  scope: "Design System Plus",
  de: "Aquarellweiß",
  en: "Watercolour white",
  nl: "Aquarel wit",
  fr: "Blanc aquarelle"
}, {
  hex: "#d3e8d9",
  code: "160 90 10",
  scope: "Design System Plus",
  de: "Mondscheingrün",
  en: "Moonlight green",
  nl: "Maanlicht groen",
  fr: "Vert clair de lune"
}, {
  hex: "#ccead6",
  code: "160 90 15",
  scope: "Design System Plus",
  de: "Gletscherwassergrün",
  en: "Glacial water green",
  nl: "Gletsjerwater groen",
  fr: "Vert eau de glacier"
}, {
  hex: "#e0ece6",
  code: "160 93 05",
  scope: "Design System Plus",
  de: "Bergkristallsilber",
  en: "Mountain crystal silver",
  nl: "Bergkristal zilver",
  fr: "Argent cristal de roche"
}, {
  hex: "#3e4a46",
  code: "170 20 10",
  scope: "Design System Plus",
  de: "Tiefgrün",
  en: "Deep green",
  nl: "Diepgroen",
  fr: "Vert profond"
}, {
  hex: "#394a45",
  code: "170 20 15",
  scope: "Design System Plus",
  de: "Intensivgrün",
  en: "Intense green",
  nl: "Intens groen",
  fr: "Vert intense"
}, {
  hex: "#334c45",
  code: "170 20 20",
  scope: "Design System Plus",
  de: "Wagengrün",
  en: "Coach green",
  nl: "Auto groen",
  fr: "Vert wagon"
}, {
  hex: "#2f4c42",
  code: "170 20 25",
  scope: "Design System Plus",
  de: "Offroadgrün",
  en: "Off-road green",
  nl: "Off-road groen",
  fr: "Vert offroad"
}, {
  hex: "#4c5b55",
  code: "170 30 10",
  scope: "Design System Plus",
  de: "Granatschwarzgrün",
  en: "Garnet black green",
  nl: "Granaat zwart groen",
  fr: "Vert grenat noir"
}, {
  hex: "#435b52",
  code: "170 30 15",
  scope: "Design System Plus",
  de: "Dunkelgrün",
  en: "Dark green",
  nl: "Donkergroen",
  fr: "Vert foncé"
}, {
  hex: "#3e5b51",
  code: "170 30 20",
  scope: "Design System Plus",
  de: "Distelgrün",
  en: "Thistle green",
  nl: "Distel groen",
  fr: "Vert chardon"
}, {
  hex: "#355e50",
  code: "170 30 25",
  scope: "Design System Plus",
  de: "Himbeerblattgrün",
  en: "Raspberry leaf green",
  nl: "Frambozenblad groen",
  fr: "Vert feuille de framboisier"
}, {
  hex: "#2f5e50",
  code: "170 30 30",
  scope: "Design System Plus",
  de: "Chrysokolldunkelgrün",
  en: "Chrysocolla dark green",
  nl: "Chrysocolla donkergroen",
  fr: "Chrysocolle vert foncé"
}, {
  hex: "#26604f",
  code: "170 30 35",
  scope: "Design System Plus",
  de: "Trappergrün",
  en: "Trapper green",
  nl: "Vallenzetter groen",
  fr: "Vert trappeur"
}, {
  hex: "#16624e",
  code: "170 30 40",
  scope: "Design System Plus",
  de: "Permanentgrün",
  en: "Permanent green",
  nl: "Permanent groen",
  fr: "Vert permanent"
}, {
  hex: "#5b6c65",
  code: "170 40 10",
  scope: "Design System Plus",
  de: "Chalcedongrün",
  en: "Chalcedony green",
  nl: "Chalcedoon groen",
  fr: "Vert calcédoine"
}, {
  hex: "#536d63",
  code: "170 40 15",
  scope: "Design System Plus",
  de: "Schlossgrün",
  en: "Palace green",
  nl: "Kasteelgroen",
  fr: "Vert château"
}, {
  hex: "#4b7063",
  code: "170 40 20",
  scope: "Design System Plus",
  de: "Breitwegerichgrün",
  en: "Plantain green",
  nl: "Groenbladige weegbree",
  fr: "Vert plantain"
}, {
  hex: "#457060",
  code: "170 40 25",
  scope: "Design System Plus",
  de: "Erzgebirgsgrün",
  en: "Ore mountains green",
  nl: "Ertsberg groen",
  fr: "Vert archipel"
}, {
  hex: "#3d7561",
  code: "170 40 30",
  scope: "Design System Plus",
  de: "Traktorgrün",
  en: "Tractor green",
  nl: "Trekker groen",
  fr: "Vert tracteur"
}, {
  hex: "#2f745e",
  code: "170 40 35",
  scope: "Design System Plus",
  de: "Viktoriagrün",
  en: "Victoria green",
  nl: "Victoria groen",
  fr: "Vert victoria"
}, {
  hex: "#20755e",
  code: "170 40 40",
  scope: "Design System Plus",
  de: "Gerätegrün",
  en: "Device green",
  nl: "Apparaat groen",
  fr: "Verdure des appareils"
}, {
  hex: "#08765d",
  code: "170 40 45",
  scope: "Design System Plus",
  de: "Umweltgrün",
  en: "Environmental green",
  nl: "Milieuvriendelijk groen",
  fr: "Vert environnemental"
}, {
  hex: "#00765a",
  code: "170 40 50",
  scope: "Design System Plus",
  de: "Vegangrün",
  en: "Vegan green",
  nl: "Veganistisch groen",
  fr: "Vert végétal"
}, {
  hex: "#6e827b",
  code: "170 50 10",
  scope: "Design System Plus",
  de: "Rödelerzgrün",
  en: "Bournonite green",
  nl: "Rödelerzgrün",
  fr: "Rödelerzgrün"
}, {
  hex: "#67867a",
  code: "170 50 15",
  scope: "Design System Plus",
  de: "Fuchsitgrün",
  en: "Fuchsite green",
  nl: "Fuchsietgroen",
  fr: "Vert fuchsia"
}, {
  hex: "#5f8678",
  code: "170 50 20",
  scope: "Design System Plus",
  de: "Brombeerblattgrün",
  en: "Blackberry leaf green",
  nl: "Bramenblad groen",
  fr: "Vert feuille de ronce"
}, {
  hex: "#568876",
  code: "170 50 25",
  scope: "Design System Plus",
  de: "Turmalinblau",
  en: "Tourmaline blue",
  nl: "Toermalijn blauw",
  fr: "Bleu tourmaline"
}, {
  hex: "#4a8a75",
  code: "170 50 30",
  scope: "Design System Plus",
  de: "Traumgrün",
  en: "Dream green",
  nl: "Droomgroen",
  fr: "Vert de rêve"
}, {
  hex: "#3e8b73",
  code: "170 50 35",
  scope: "Design System Plus",
  de: "Akzentgrünblau",
  en: "Accent green blue",
  nl: "Accent groen-blauw",
  fr: "Bleu vert accentué"
}, {
  hex: "#308d71",
  code: "170 50 40",
  scope: "Design System Plus",
  de: "Spektralgrün",
  en: "Spectral green",
  nl: "Spectraal groen",
  fr: "Vert spectral"
}, {
  hex: "#1e8e71",
  code: "170 50 45",
  scope: "Design System Plus",
  de: "Stockentengrün",
  en: "Mallard green",
  nl: "Wilde eend groen",
  fr: "Vert colvert"
}, {
  hex: "#00916f",
  code: "170 50 50",
  scope: "Design System Plus",
  de: "Chagallgrün",
  en: "Chagall green",
  nl: "Chagall groen",
  fr: "Vert chagall"
}, {
  hex: "#00906d",
  code: "170 50 55",
  scope: "Design System Plus",
  de: "Absinthtürkis",
  en: "Absinthe turquoise",
  nl: "Absint turquoise",
  fr: "Turquoise d'absinthe"
}, {
  hex: "#849a92",
  code: "170 60 10",
  scope: "Design System Plus",
  de: "Quantumgrün",
  en: "Quantum green",
  nl: "Kwantumgroen",
  fr: "Vert quantique"
}, {
  hex: "#7e9d90",
  code: "170 60 15",
  scope: "Design System Plus",
  de: "Bitterkleegrün",
  en: "Bitter clover green",
  nl: "Bittere klaver groen",
  fr: "Vert de trèfle amer"
}, {
  hex: "#739f8f",
  code: "170 60 20",
  scope: "Design System Plus",
  de: "Cyperngrün",
  en: "Cyprus green",
  nl: "Cyprus groen",
  fr: "Vert cyprès"
}, {
  hex: "#6aa08e",
  code: "170 60 25",
  scope: "Design System Plus",
  de: "Saftiggrün",
  en: "Succulent green",
  nl: "Sappig groen",
  fr: "Vert juteux"
}, {
  hex: "#5ea28c",
  code: "170 60 30",
  scope: "Design System Plus",
  de: "Lebendiggrün",
  en: "Vibrant green",
  nl: "Groen leven",
  fr: "Vert vif"
}, {
  hex: "#50a68a",
  code: "170 60 35",
  scope: "Design System Plus",
  de: "Klimtgrün",
  en: "Klimt green",
  nl: "Klimt groen",
  fr: "Vert climat"
}, {
  hex: "#44a689",
  code: "170 60 40",
  scope: "Design System Plus",
  de: "Persischgrün",
  en: "Persian green",
  nl: "Perzisch groen",
  fr: "Vert persan"
}, {
  hex: "#33a685",
  code: "170 60 45",
  scope: "Design System Plus",
  de: "Sportgrün",
  en: "Sport green",
  nl: "Sportief groen",
  fr: "Vert sport"
}, {
  hex: "#1baa87",
  code: "170 60 50",
  scope: "Design System Plus",
  de: "Aktivgrün",
  en: "Active green",
  nl: "Actief groen",
  fr: "Vert actif"
}, {
  hex: "#9db4ab",
  code: "170 70 10",
  scope: "Design System Plus",
  de: "Liebstöckelgrün",
  en: "Lovage green",
  nl: "Lavas groen",
  fr: "Vert de livèche"
}, {
  hex: "#95b6a8",
  code: "170 70 15",
  scope: "Design System Plus",
  de: "Chrysopalhellgrün",
  en: "Chrysopal light green",
  nl: "Chrysopal lichtgroen",
  fr: "Vert chrysopal clair"
}, {
  hex: "#8bb9a7",
  code: "170 70 20",
  scope: "Design System Plus",
  de: "Quellgrün",
  en: "Source green",
  nl: "Lentegroen",
  fr: "Vert source"
}, {
  hex: "#83bba6",
  code: "170 70 25",
  scope: "Design System Plus",
  de: "Orientmosaikgrün",
  en: "Orient mosaic green",
  nl: "Oosters mozaïekgroen",
  fr: "Vert mosaïque d'Orient"
}, {
  hex: "#75bea5",
  code: "170 70 30",
  scope: "Design System Plus",
  de: "Minzkaltgrün",
  en: "Mint cold green",
  nl: "Munt koud groen",
  fr: "Vert menthe froid"
}, {
  hex: "#6abea2",
  code: "170 70 35",
  scope: "Design System Plus",
  de: "Emeraldgrün",
  en: "Emerald green",
  nl: "Smaragdgroen",
  fr: "Vert émeraude"
}, {
  hex: "#5fbfa0",
  code: "170 70 40",
  scope: "Design System Plus",
  de: "Expressionismusgrün",
  en: "Expressionism green",
  nl: "Expressionisme groen",
  fr: "Vert expressionniste"
}, {
  hex: "#b7cec5",
  code: "170 80 10",
  scope: "Design System Plus",
  de: "Fluoritblau",
  en: "Fluorite blue",
  nl: "Fluoriet blauw",
  fr: "Bleu fluorite"
}, {
  hex: "#acd0c3",
  code: "170 80 15",
  scope: "Design System Plus",
  de: "Schwimmbadgrün",
  en: "Swimming pool green",
  nl: "Zwembad groen",
  fr: "Vert de la piscine"
}, {
  hex: "#a4d5c2",
  code: "170 80 20",
  scope: "Design System Plus",
  de: "Himmelgrün",
  en: "Sky green",
  nl: "Hemels groen",
  fr: "Vert ciel"
}, {
  hex: "#99d4bf",
  code: "170 80 25",
  scope: "Design System Plus",
  de: "Larimargrün",
  en: "Larimar green",
  nl: "Larimar groen",
  fr: "Vert larimar"
}, {
  hex: "#cbd7d2",
  code: "170 85 05",
  scope: "Design System Plus",
  de: "Silikathelltürkis",
  en: "Silicate light turquoise",
  nl: "Silicaat licht turkoois",
  fr: "Turquoise clair silicaté"
}, {
  hex: "#c3dad0",
  code: "170 85 10",
  scope: "Design System Plus",
  de: "Topasgrün",
  en: "Topaz green",
  nl: "Topaasgroen",
  fr: "Vert topaze"
}, {
  hex: "#b8ddcd",
  code: "170 85 15",
  scope: "Design System Plus",
  de: "Kühlschrankgrün",
  en: "Refrigerator green",
  nl: "Koelkast groen",
  fr: "Vert frigo"
}, {
  hex: "#b0e0cb",
  code: "170 85 20",
  scope: "Design System Plus",
  de: "Kristallglasgrün",
  en: "Crystal glass green",
  nl: "Kristalglas groen",
  fr: "Vert cristal"
}, {
  hex: "#dae5de",
  code: "170 90 05",
  scope: "Design System Plus",
  de: "Kristallsalzweiß",
  en: "Crystal salt white",
  nl: "Kristalzout wit",
  fr: "Blanc cristal de sel"
}, {
  hex: "#d1e9dd",
  code: "170 90 10",
  scope: "Design System Plus",
  de: "Türkisweiß",
  en: "Turquoise white",
  nl: "Turkoois wit",
  fr: "Blanc turquoise"
}, {
  hex: "#e2ede7",
  code: "170 93 05",
  scope: "Design System Plus",
  de: "Schneekristallgrün",
  en: "Snow crystal green",
  nl: "Sneeuwkristal groen",
  fr: "Vert cristal de neige"
}, {
  hex: "#454c4b",
  code: "180 20 05",
  scope: "Design System Plus",
  de: "Pechgrün",
  en: "Pitch green",
  nl: "Standplaats groen",
  fr: "Vert poix"
}, {
  hex: "#3e4a47",
  code: "180 20 10",
  scope: "Design System Plus",
  de: "Lackgrün",
  en: "Lacquer green",
  nl: "Groen patent",
  fr: "Vert laque"
}, {
  hex: "#374b48",
  code: "180 20 15",
  scope: "Design System Plus",
  de: "Zaungrün",
  en: "Fence green",
  nl: "Hek groen",
  fr: "Vert de clôture"
}, {
  hex: "#304c48",
  code: "180 20 20",
  scope: "Design System Plus",
  de: "Myrtengrün",
  en: "Myrtle green",
  nl: "Myrtle groen",
  fr: "Vert myrte"
}, {
  hex: "#535b59",
  code: "180 30 05",
  scope: "Design System Plus",
  de: "Amazonasgrün",
  en: "Amazon green",
  nl: "Amazonegroen",
  fr: "Vert amazonien"
}, {
  hex: "#4a5a56",
  code: "180 30 10",
  scope: "Design System Plus",
  de: "Sattgrautürkis",
  en: "Rich grey turquoise",
  nl: "Rijk grijs turkoois",
  fr: "Turquoise gris saturé"
}, {
  hex: "#435c57",
  code: "180 30 15",
  scope: "Design System Plus",
  de: "Tafelgrün",
  en: "Blackboard green",
  nl: "Tabel groen",
  fr: "Vert de table"
}, {
  hex: "#3c5d56",
  code: "180 30 20",
  scope: "Design System Plus",
  de: "Schwedengrün",
  en: "Swedish green",
  nl: "Zweeds groen",
  fr: "Vert suédois"
}, {
  hex: "#335e56",
  code: "180 30 25",
  scope: "Design System Plus",
  de: "Fjordgrün",
  en: "Fjord green",
  nl: "Fjordgroen",
  fr: "Vert fjord"
}, {
  hex: "#295f56",
  code: "180 30 30",
  scope: "Design System Plus",
  de: "Stadtgrün",
  en: "Urban green",
  nl: "Stedelijk groen",
  fr: "Espaces verts de la ville"
}, {
  hex: "#196054",
  code: "180 30 35",
  scope: "Design System Plus",
  de: "Dschungelgrün",
  en: "Jungle green",
  nl: "Oerwoudgroen",
  fr: "Vert jungle"
}, {
  hex: "#626c69",
  code: "180 40 05",
  scope: "Design System Plus",
  de: "Erdgrün",
  en: "Earth green",
  nl: "Aarde groen",
  fr: "Vert terre"
}, {
  hex: "#5a6e69",
  code: "180 40 10",
  scope: "Design System Plus",
  de: "Kiefergrün",
  en: "Pine green",
  nl: "Dennengroen",
  fr: "Vert pin"
}, {
  hex: "#516f68",
  code: "180 40 15",
  scope: "Design System Plus",
  de: "Forstgrün",
  en: "Forest greenery",
  nl: "Bosgroen",
  fr: "Verdure forestière"
}, {
  hex: "#477168",
  code: "180 40 20",
  scope: "Design System Plus",
  de: "Meergrün",
  en: "Sea green",
  nl: "Zeegroen",
  fr: "Vert mer"
}, {
  hex: "#3e7268",
  code: "180 40 25",
  scope: "Design System Plus",
  de: "Eukalyptusgrün",
  en: "Eucalyptus green",
  nl: "Eucalyptus groen",
  fr: "Vert eucalyptus"
}, {
  hex: "#2f7469",
  code: "180 40 30",
  scope: "Design System Plus",
  de: "Efeufrischgrün",
  en: "Fresh ivy green",
  nl: "Klimop fris groen",
  fr: "Vert lierre frais"
}, {
  hex: "#1c7566",
  code: "180 40 35",
  scope: "Design System Plus",
  de: "Chrysokollmittelgrün",
  en: "Chrysocolla medium green",
  nl: "Chrysocolla middengroen",
  fr: "Vert chrysocolle"
}, {
  hex: "#007565",
  code: "180 40 40",
  scope: "Design System Plus",
  de: "Plakatgrün",
  en: "Poster green",
  nl: "Poster groen",
  fr: "Vert d'affiche"
}, {
  hex: "#007666",
  code: "180 40 45",
  scope: "Design System Plus",
  de: "Petroldunkelgrün",
  en: "Teal dark green",
  nl: "Petroleum donkergroen",
  fr: "Vert pétrole foncé"
}, {
  hex: "#788280",
  code: "180 50 05",
  scope: "Design System Plus",
  de: "Dämmergrün",
  en: "Dusk green",
  nl: "Schemergroen",
  fr: "Vert crépuscule"
}, {
  hex: "#6d827d",
  code: "180 50 10",
  scope: "Design System Plus",
  de: "Erquickungsgrün",
  en: "Refreshing green",
  nl: "Verfrissend groen",
  fr: "Vert rafraîchissant"
}, {
  hex: "#63857d",
  code: "180 50 15",
  scope: "Design System Plus",
  de: "Stumpftürkis",
  en: "Dull turquoise",
  nl: "Mat turkoois",
  fr: "Turquoise terne"
}, {
  hex: "#59867d",
  code: "180 50 20",
  scope: "Design System Plus",
  de: "Azuritwassergrün",
  en: "Azurite water green",
  nl: "Azuriet watergroen",
  fr: "Vert d'eau azurite"
}, {
  hex: "#4d897e",
  code: "180 50 25",
  scope: "Design System Plus",
  de: "Kupfermineralgrün",
  en: "Copper mineral green",
  nl: "Koper mineraal groen",
  fr: "Vert minéral de cuivre"
}, {
  hex: "#408b7c",
  code: "180 50 30",
  scope: "Design System Plus",
  de: "Glasgrün",
  en: "Glass green",
  nl: "Glas groen",
  fr: "Vert verre"
}, {
  hex: "#318c7d",
  code: "180 50 35",
  scope: "Design System Plus",
  de: "Sommertürkis",
  en: "Summer turquoise",
  nl: "Zomerturquoise",
  fr: "Turquoise d'été"
}, {
  hex: "#1b8c7b",
  code: "180 50 40",
  scope: "Design System Plus",
  de: "Weihnachtsgrün",
  en: "Christmas green",
  nl: "Kerstgroeten",
  fr: "Vert de Noël"
}, {
  hex: "#00907b",
  code: "180 50 45",
  scope: "Design System Plus",
  de: "Industrietürkis",
  en: "Industrial turquoise",
  nl: "Industrieel turkoois",
  fr: "Turquoise industrielle"
}, {
  hex: "#00907a",
  code: "180 50 50",
  scope: "Design System Plus",
  de: "Ozeangrün",
  en: "Ocean green",
  nl: "Oceaangroen",
  fr: "Vert océan"
}, {
  hex: "#8d9996",
  code: "180 60 05",
  scope: "Design System Plus",
  de: "Marmorgrüngrau",
  en: "Marble green-grey",
  nl: "Marmer groen grijs",
  fr: "Gris marbré vert"
}, {
  hex: "#829a95",
  code: "180 60 10",
  scope: "Design System Plus",
  de: "Kachelgrün",
  en: "Tile green",
  nl: "Tegel groen",
  fr: "Vert carreau"
}, {
  hex: "#789d94",
  code: "180 60 15",
  scope: "Design System Plus",
  de: "Kupferdachgrün",
  en: "Copper roof green",
  nl: "Koperen dak groen",
  fr: "Vert toit cuivré"
}, {
  hex: "#6e9f94",
  code: "180 60 20",
  scope: "Design System Plus",
  de: "Salbeigrün",
  en: "Sage green",
  nl: "Saliegroen",
  fr: "Vert sauge"
}, {
  hex: "#61a093",
  code: "180 60 25",
  scope: "Design System Plus",
  de: "Petrolgrün",
  en: "Petrol green",
  nl: "Benzine groen",
  fr: "Vert pétrole"
}, {
  hex: "#54a394",
  code: "180 60 30",
  scope: "Design System Plus",
  de: "Dioptasgrün",
  en: "Dioptase green",
  nl: "Dioptasegroen",
  fr: "Vert dioptas"
}, {
  hex: "#46a593",
  code: "180 60 35",
  scope: "Design System Plus",
  de: "Stempelkissengrün",
  en: "Stamp pad green",
  nl: "Stempelkussen groen",
  fr: "Tampon encreur vert"
}, {
  hex: "#2fa794",
  code: "180 60 40",
  scope: "Design System Plus",
  de: "Leuchttürkis",
  en: "Light turquoise",
  nl: "Lichtgevend turkoois",
  fr: "Turquoise fluo"
}, {
  hex: "#02a994",
  code: "180 60 45",
  scope: "Design System Plus",
  de: "Karibikgrün",
  en: "Caribbean green",
  nl: "Caribisch groen",
  fr: "Vert caraïbe"
}, {
  hex: "#00aa93",
  code: "180 60 50",
  scope: "Design System Plus",
  de: "Brillanttürkis",
  en: "Brilliant turquoise",
  nl: "Schitterend turquoise",
  fr: "Turquoise brillant"
}, {
  hex: "#a6b1ae",
  code: "180 70 05",
  scope: "Design System Plus",
  de: "Feldspatsilber",
  en: "Feldspar silver",
  nl: "Veldspaat zilver",
  fr: "Argent feldspathique"
}, {
  hex: "#98b3ad",
  code: "180 70 10",
  scope: "Design System Plus",
  de: "Grazilgrün",
  en: "Delicate green",
  nl: "Sierlijk groen",
  fr: "Vert gracile"
}, {
  hex: "#8fb6ad",
  code: "180 70 15",
  scope: "Design System Plus",
  de: "Silikatgrün",
  en: "Silicate green",
  nl: "Silicaat groen",
  fr: "Vert silicate"
}, {
  hex: "#85b9ad",
  code: "180 70 20",
  scope: "Design System Plus",
  de: "Mintbonbongrün",
  en: "Mint bonbon green",
  nl: "Mint snoepgroen",
  fr: "Vert menthe bonbon"
}, {
  hex: "#78baac",
  code: "180 70 25",
  scope: "Design System Plus",
  de: "Gletschergrün",
  en: "Glacial green",
  nl: "Gletsjer groen",
  fr: "Vert glacier"
}, {
  hex: "#6dbdad",
  code: "180 70 30",
  scope: "Design System Plus",
  de: "Badtürkis",
  en: "Bath turquoise",
  nl: "Bad turquoise",
  fr: "Turquoise de bain"
}, {
  hex: "#5bbfac",
  code: "180 70 35",
  scope: "Design System Plus",
  de: "Bergseeazur",
  en: "Mountain lake azure",
  nl: "Bergmeer",
  fr: "Lac de montagneavec"
}, {
  hex: "#4ac2ad",
  code: "180 70 40",
  scope: "Design System Plus",
  de: "Reincyan",
  en: "Pure cyan",
  nl: "Reincyanium",
  fr: "Reincyan"
}, {
  hex: "#bfcbc6",
  code: "180 80 05",
  scope: "Design System Plus",
  de: "Aragonitweiß",
  en: "Aragonite white",
  nl: "Aragoniet wit",
  fr: "Blanc aragonite"
}, {
  hex: "#b4cec7",
  code: "180 80 10",
  scope: "Design System Plus",
  de: "Lichtpetrol",
  en: "Light teal",
  nl: "Lichte benzine",
  fr: "Pétrole de lumière"
}, {
  hex: "#abd2c8",
  code: "180 80 15",
  scope: "Design System Plus",
  de: "Whirlpoolgrün",
  en: "Whirlpool green",
  nl: "Whirlpool groen",
  fr: "Vert bouillonnant"
}, {
  hex: "#9cd3c6",
  code: "180 80 20",
  scope: "Design System Plus",
  de: "Opaltürkis",
  en: "Opal turquoise",
  nl: "Opaal turkoois",
  fr: "Turquoise opale"
}, {
  hex: "#91d5c6",
  code: "180 80 25",
  scope: "Design System Plus",
  de: "Caprihellgrün",
  en: "Light Capri green",
  nl: "Capri lichtgroen",
  fr: "Vert caprihell"
}, {
  hex: "#89dac8",
  code: "180 80 30",
  scope: "Design System Plus",
  de: "Zarttürkis",
  en: "Tender turquoise",
  nl: "Licht turkoois",
  fr: "Turquoise tendre"
}, {
  hex: "#cad7d3",
  code: "180 85 05",
  scope: "Design System Plus",
  de: "Meerdunstgrau",
  en: "Sea haze grey",
  nl: "Zeemist grijs",
  fr: "Gris brume de mer"
}, {
  hex: "#c0dad3",
  code: "180 85 10",
  scope: "Design System Plus",
  de: "Feuerlandmeergrün",
  en: "Tierra del Fuego sea green",
  nl: "Vuurland zeegroen",
  fr: "Vert de la mer de la Terre de Feu"
}, {
  hex: "#b8ded2",
  code: "180 85 15",
  scope: "Design System Plus",
  de: "Bergseehelltürkis",
  en: "Pale mountain lake turquoise",
  nl: "Bergmeer licht turquoise",
  fr: "Lac de montagne turquoise"
}, {
  hex: "#aadfcf",
  code: "180 85 20",
  scope: "Design System Plus",
  de: "Korallgrün",
  en: "Coral green",
  nl: "Koraalgroen",
  fr: "Vert corail"
}, {
  hex: "#dbe7e2",
  code: "180 90 05",
  scope: "Design System Plus",
  de: "Transparentgrün",
  en: "Transparent green",
  nl: "Transparant groen",
  fr: "Vert transparent"
}, {
  hex: "#d0ece3",
  code: "180 90 10",
  scope: "Design System Plus",
  de: "Eiswassergrün",
  en: "Ice water green",
  nl: "IJswater groen",
  fr: "Vert eau glacée"
}, {
  hex: "#e2eeea",
  code: "180 93 05",
  scope: "Design System Plus",
  de: "Arktisweiß",
  en: "Arctic white",
  nl: "Arctisch wit",
  fr: "Blanc arctique"
}, {
  hex: "#2f4d4a",
  code: "190 20 20",
  scope: "Design System Plus",
  de: "Nachttürkis",
  en: "Night turquoise",
  nl: "Nacht turquoise",
  fr: "Turquoise nuit"
}, {
  hex: "#415c5a",
  code: "190 30 15",
  scope: "Design System Plus",
  de: "Kutschengrün",
  en: "Carriage green",
  nl: "Rijtuig groen",
  fr: "Kutschengrün"
}, {
  hex: "#375d5b",
  code: "190 30 20",
  scope: "Design System Plus",
  de: "Lattenzaungrün",
  en: "Stockade green",
  nl: "Piketomheining groen",
  fr: "Verdure de clôture en lattes"
}, {
  hex: "#2d5e5b",
  code: "190 30 25",
  scope: "Design System Plus",
  de: "Aktionsgrün",
  en: "Action green",
  nl: "Actie groen",
  fr: "Vert d'action"
}, {
  hex: "#20605d",
  code: "190 30 30",
  scope: "Design System Plus",
  de: "Myrtentiefgrün",
  en: "Myrtle deep green",
  nl: "Mirte diepgroen",
  fr: "Vert myrte"
}, {
  hex: "#0e605d",
  code: "190 30 35",
  scope: "Design System Plus",
  de: "Planktongrün",
  en: "Plankton green",
  nl: "Plankton groen",
  fr: "Vert plancton"
}, {
  hex: "#586c6a",
  code: "190 40 10",
  scope: "Design System Plus",
  de: "Schlammgrün",
  en: "Mud green",
  nl: "Moddergroen",
  fr: "Vert boue"
}, {
  hex: "#4f6f6d",
  code: "190 40 15",
  scope: "Design System Plus",
  de: "Moorteichgrün",
  en: "Moor pond green",
  nl: "Moerasvijver groen",
  fr: "Vert étang de tourbe"
}, {
  hex: "#44716e",
  code: "190 40 20",
  scope: "Design System Plus",
  de: "Üppiggrün",
  en: "Lush green",
  nl: "Weelderig groen",
  fr: "Vert luxuriant"
}, {
  hex: "#37726f",
  code: "190 40 25",
  scope: "Design System Plus",
  de: "Schmetterlingsgrün",
  en: "Butterfly green",
  nl: "Vlinder groen",
  fr: "Vert papillon"
}, {
  hex: "#267470",
  code: "190 40 30",
  scope: "Design System Plus",
  de: "Modeblau",
  en: "Fashion blue",
  nl: "Mode blauw",
  fr: "Bleu mode"
}, {
  hex: "#097671",
  code: "190 40 35",
  scope: "Design System Plus",
  de: "Officeblaugrün",
  en: "Office blue green",
  nl: "Kantoor blauwgroen",
  fr: "Vert bleu office"
}, {
  hex: "#007771",
  code: "190 40 40",
  scope: "Design System Plus",
  de: "Leguangrün",
  en: "Iguana green",
  nl: "Leguaan groen",
  fr: "Vert iguane"
}, {
  hex: "#007a73",
  code: "190 40 45",
  scope: "Design System Plus",
  de: "Dunkelpetrol",
  en: "Dark teal",
  nl: "Donkere benzine",
  fr: "Pétrole foncé"
}, {
  hex: "#6d8481",
  code: "190 50 10",
  scope: "Design System Plus",
  de: "Sturmgrün",
  en: "Storm green",
  nl: "Stormgroen",
  fr: "Vert tempête"
}, {
  hex: "#628682",
  code: "190 50 15",
  scope: "Design System Plus",
  de: "Dunkeltürkis",
  en: "Dark turquoise",
  nl: "Donker turkoois",
  fr: "Turquoise foncé"
}, {
  hex: "#578884",
  code: "190 50 20",
  scope: "Design System Plus",
  de: "Tannenblau",
  en: "Fir blue",
  nl: "Dennenblauw",
  fr: "Bleu sapin"
}, {
  hex: "#488984",
  code: "190 50 25",
  scope: "Design System Plus",
  de: "Apatitblau",
  en: "Apatite blue",
  nl: "Apatiet blauw",
  fr: "Bleu apatite"
}, {
  hex: "#368b86",
  code: "190 50 30",
  scope: "Design System Plus",
  de: "Ägyptischgrün",
  en: "Egyptian green",
  nl: "Egyptisch groen",
  fr: "Vert égyptien"
}, {
  hex: "#208c86",
  code: "190 50 35",
  scope: "Design System Plus",
  de: "Schmucktürkis",
  en: "Ornamental turquoise",
  nl: "Sieraden turkoois",
  fr: "Turquoise à paillettes"
}, {
  hex: "#008f89",
  code: "190 50 40",
  scope: "Design System Plus",
  de: "Lidschattentürkis",
  en: "Eyeshadow turquoise",
  nl: "Oogschaduw turquoise",
  fr: "Turquoise à paupières"
}, {
  hex: "#00908a",
  code: "190 50 45",
  scope: "Design System Plus",
  de: "Klartürkis",
  en: "Clear turquoise",
  nl: "Helder turkoois",
  fr: "Turquoise clair"
}, {
  hex: "#829b98",
  code: "190 60 10",
  scope: "Design System Plus",
  de: "Dezenttürkis",
  en: "Subtle turquoise",
  nl: "Fatsoenlijk turkoois",
  fr: "Turquoise décent"
}, {
  hex: "#779d98",
  code: "190 60 15",
  scope: "Design System Plus",
  de: "Hellgrünspan",
  en: "Pale verdigris",
  nl: "Lichtgroen schaafsel",
  fr: "Span vert clair"
}, {
  hex: "#6ea09b",
  code: "190 60 20",
  scope: "Design System Plus",
  de: "Gänseteichgrün",
  en: "Goose pond green",
  nl: "Ganzenvijver groen",
  fr: "Vert pâquerette"
}, {
  hex: "#5ea39d",
  code: "190 60 25",
  scope: "Design System Plus",
  de: "Turmalintürkis",
  en: "Tourmaline turquoise",
  nl: "Toermalijn turkoois",
  fr: "Turmaline turquoise"
}, {
  hex: "#4da49e",
  code: "190 60 30",
  scope: "Design System Plus",
  de: "Baltikgrün",
  en: "Baltic green",
  nl: "Baltisch groen",
  fr: "Vert baltique"
}, {
  hex: "#39a6a0",
  code: "190 60 35",
  scope: "Design System Plus",
  de: "Keramikbleutürkis",
  en: "Ceramic blue turquoise",
  nl: "Keramische loodturkoois",
  fr: "Turquoise plombé céramique"
}, {
  hex: "#0ca8a1",
  code: "190 60 40",
  scope: "Design System Plus",
  de: "Baltiktürkis",
  en: "Baltic turquoise",
  nl: "Baltisch turkoois",
  fr: "Turquoise baltique"
}, {
  hex: "#00a8a0",
  code: "190 60 45",
  scope: "Design System Plus",
  de: "Tirolitblaugrün",
  en: "Tyrolite blue-green",
  nl: "Tiroliet blauwgroen",
  fr: "Vert bleu tirolite"
}, {
  hex: "#9ab4b1",
  code: "190 70 10",
  scope: "Design System Plus",
  de: "Marmorgrün",
  en: "Marble green",
  nl: "Marmer groen",
  fr: "Vert marbre"
}, {
  hex: "#8fb6b1",
  code: "190 70 15",
  scope: "Design System Plus",
  de: "Jadegrün",
  en: "Jade green",
  nl: "Jadegroen",
  fr: "Vert jade"
}, {
  hex: "#82b8b2",
  code: "190 70 20",
  scope: "Design System Plus",
  de: "Quellwassertürkis",
  en: "Spring water turquoise",
  nl: "Bronwater turquoise",
  fr: "Turquoise d'eau de source"
}, {
  hex: "#75bbb5",
  code: "190 70 25",
  scope: "Design System Plus",
  de: "Floridatürkis",
  en: "Florida turquoise",
  nl: "Florida turquoise",
  fr: "Turquoise de Floride"
}, {
  hex: "#69beb8",
  code: "190 70 30",
  scope: "Design System Plus",
  de: "Hygienegrün",
  en: "Hygiene green",
  nl: "Hygiënisch groen",
  fr: "Vert hygiénique"
}, {
  hex: "#55bfb7",
  code: "190 70 35",
  scope: "Design System Plus",
  de: "Arktisgrün",
  en: "Arctic green",
  nl: "Arctisch groen",
  fr: "Vert arctique"
}, {
  hex: "#b3cfca",
  code: "190 80 10",
  scope: "Design System Plus",
  de: "Andenopalgrün",
  en: "Andean opal green",
  nl: "Andes opaal groen",
  fr: "Vert opale des Andes"
}, {
  hex: "#a9d2cd",
  code: "190 80 15",
  scope: "Design System Plus",
  de: "Kalttürkis",
  en: "Cold turquoise",
  nl: "Koud turkoois",
  fr: "Turquoise froide"
}, {
  hex: "#9bd2cd",
  code: "190 80 20",
  scope: "Design System Plus",
  de: "Petroleumblau",
  en: "Teal blue",
  nl: "Petroleum blauw",
  fr: "Bleu pétrole"
}, {
  hex: "#8fd5cf",
  code: "190 80 25",
  scope: "Design System Plus",
  de: "Poolgrün",
  en: "Pool green",
  nl: "Zwembad groen",
  fr: "Vert de piscine"
}, {
  hex: "#c5d9d6",
  code: "190 85 05",
  scope: "Design System Plus",
  de: "Morgentauweiß",
  en: "Morning dew white",
  nl: "Ochtenddauw wit",
  fr: "Blanc rosée du matin"
}, {
  hex: "#badcd6",
  code: "190 85 10",
  scope: "Design System Plus",
  de: "Badesalzgrün",
  en: "Bath salt green",
  nl: "Badzout groen",
  fr: "Vert de sel de bain"
}, {
  hex: "#aadfd6",
  code: "190 85 15",
  scope: "Design System Plus",
  de: "Capriwasserblau",
  en: "Capri water blue",
  nl: "Capri waterblauw",
  fr: "Bleu eau de capri"
}, {
  hex: "#9ce2d7",
  code: "190 85 20",
  scope: "Design System Plus",
  de: "Horizontblau",
  en: "Horizon blue",
  nl: "Horizon blauw",
  fr: "Bleu horizon"
}, {
  hex: "#dbe6e2",
  code: "190 90 05",
  scope: "Design System Plus",
  de: "Kaltweiß",
  en: "Cool white",
  nl: "Koud wit",
  fr: "Blanc froid"
}, {
  hex: "#cfeae5",
  code: "190 90 10",
  scope: "Design System Plus",
  de: "Quellblau",
  en: "Source blue",
  nl: "Lente blauw",
  fr: "Bleu source"
}, {
  hex: "#e3edeb",
  code: "190 93 05",
  scope: "Design System Plus",
  de: "Ägyptischweiß",
  en: "Egyptian white",
  nl: "Egyptisch wit",
  fr: "Blanc égyptien"
}, {
  hex: "#444a4a",
  code: "200 20 05",
  scope: "Design System Plus",
  de: "Tarngrün",
  en: "Concealed green",
  nl: "Camouflagegroen",
  fr: "Vert camouflage"
}, {
  hex: "#3c4a4b",
  code: "200 20 10",
  scope: "Design System Plus",
  de: "Dunkelkiefergrün",
  en: "Dark pine green",
  nl: "Donker dennengroen",
  fr: "Vert pin foncé"
}, {
  hex: "#374a4b",
  code: "200 20 15",
  scope: "Design System Plus",
  de: "Dachziegelgrün",
  en: "Roof tile green",
  nl: "Dakpan groen",
  fr: "Vert tuile"
}, {
  hex: "#304c4e",
  code: "200 20 20",
  scope: "Design System Plus",
  de: "Buschgrün",
  en: "Shrub green",
  nl: "Struikgroen",
  fr: "Vert buisson"
}, {
  hex: "#264d4f",
  code: "200 20 23",
  scope: "Design System Plus",
  de: "Zollgrün",
  en: "Customs green",
  nl: "Douane groen",
  fr: "Zollgrün"
}, {
  hex: "#4f5858",
  code: "200 30 05",
  scope: "Design System Plus",
  de: "Finsternisgrün",
  en: "Darkness green",
  nl: "Eclips groen",
  fr: "Vert éclipse"
}, {
  hex: "#485b5b",
  code: "200 30 10",
  scope: "Design System Plus",
  de: "Baumrindengrün",
  en: "Tree bark green",
  nl: "Boomschors groen",
  fr: "Vert écorce d'arbre"
}, {
  hex: "#405d5d",
  code: "200 30 15",
  scope: "Design System Plus",
  de: "Hornblendegrün",
  en: "Hornblende green",
  nl: "Hoornblende groen",
  fr: "Vert cornu"
}, {
  hex: "#385e5f",
  code: "200 30 20",
  scope: "Design System Plus",
  de: "Malachitblautürkis",
  en: "Malachite blue turquoise",
  nl: "Malachiet blauw turkoois",
  fr: "Turquoise bleue malachite"
}, {
  hex: "#285d5e",
  code: "200 30 25",
  scope: "Design System Plus",
  de: "Antiktürkis",
  en: "Antique turquoise",
  nl: "Antiek turkoois",
  fr: "Turquoise antique"
}, {
  hex: "#1a5f62",
  code: "200 30 30",
  scope: "Design System Plus",
  de: "Wolltürkis",
  en: "Wool turquoise",
  nl: "Wol turkoois",
  fr: "Turquoise de laine"
}, {
  hex: "#006164",
  code: "200 30 33",
  scope: "Design System Plus",
  de: "Eisdunkeltürkis",
  en: "Ice dark turquoise",
  nl: "Ijs donker turkoois",
  fr: "Turquoise foncé glacé"
}, {
  hex: "#616c6c",
  code: "200 40 05",
  scope: "Design System Plus",
  de: "Kalkspatgraugrün",
  en: "Calcite grey green",
  nl: "Kalk spar grijsgroen",
  fr: "Vert spath calcaire"
}, {
  hex: "#596d6e",
  code: "200 40 10",
  scope: "Design System Plus",
  de: "Brochantitgrün",
  en: "Brochantite green",
  nl: "Brochantiet groen",
  fr: "Vert de brochantite"
}, {
  hex: "#4f6f6f",
  code: "200 40 15",
  scope: "Design System Plus",
  de: "Eisenkiesgrün",
  en: "Pyrite green",
  nl: "IJzerpyriet groen",
  fr: "Vert de fer et de gravier"
}, {
  hex: "#427172",
  code: "200 40 20",
  scope: "Design System Plus",
  de: "Alpendämmerblau",
  en: "Dusky alpine blue",
  nl: "Alpine schemerblauw",
  fr: "Bleu crépuscule des Alpes"
}, {
  hex: "#377374",
  code: "200 40 25",
  scope: "Design System Plus",
  de: "Badgrün",
  en: "Bath green",
  nl: "Badgroen",
  fr: "Vert de bain"
}, {
  hex: "#237477",
  code: "200 40 30",
  scope: "Design System Plus",
  de: "Mayablau",
  en: "Mayan blue",
  nl: "Maya blauw",
  fr: "Bleu maya"
}, {
  hex: "#007579",
  code: "200 40 35",
  scope: "Design System Plus",
  de: "Byzantinischblau",
  en: "Byzantine blue",
  nl: "Byzantijns blauw",
  fr: "Bleu byzantin"
}, {
  hex: "#00787d",
  code: "200 40 40",
  scope: "Design System Plus",
  de: "Aktivtürkis",
  en: "Active turquoise",
  nl: "Actief turkoois",
  fr: "Turquoise active"
}, {
  hex: "#748080",
  code: "200 50 05",
  scope: "Design System Plus",
  de: "Nordgrau",
  en: "North grey",
  nl: "Noordgrijs",
  fr: "Gris nord"
}, {
  hex: "#6c8384",
  code: "200 50 10",
  scope: "Design System Plus",
  de: "Augengrau",
  en: "Eye grey",
  nl: "Oog grijs",
  fr: "Gris des yeux"
}, {
  hex: "#618686",
  code: "200 50 15",
  scope: "Design System Plus",
  de: "Nickelerzgrün",
  en: "Nickel ore green",
  nl: "Nikkelerts groen",
  fr: "Vert nickelé"
}, {
  hex: "#548788",
  code: "200 50 20",
  scope: "Design System Plus",
  de: "Gischtgrün",
  en: "Seafoam green",
  nl: "Spuitgroen",
  fr: "Vert givré"
}, {
  hex: "#46898c",
  code: "200 50 25",
  scope: "Design System Plus",
  de: "Kandinskytürkis",
  en: "Kandinsky turquoise",
  nl: "Kandinsky turkoois",
  fr: "Kandinsky turquoise"
}, {
  hex: "#308b8d",
  code: "200 50 30",
  scope: "Design System Plus",
  de: "Karibiktürkis",
  en: "Caribbean turquoise",
  nl: "Caribisch turkoois",
  fr: "Turquoise des Caraïbes"
}, {
  hex: "#118e92",
  code: "200 50 35",
  scope: "Design System Plus",
  de: "Brunnenblau",
  en: "Well blue",
  nl: "Fontein blauw",
  fr: "Bleu foncé"
}, {
  hex: "#008f93",
  code: "200 50 40",
  scope: "Design System Plus",
  de: "Industrieblau",
  en: "Industrial blue",
  nl: "Industrieel blauw",
  fr: "Bleu industriel"
}, {
  hex: "#009096",
  code: "200 50 45",
  scope: "Design System Plus",
  de: "Indiablau",
  en: "India blue",
  nl: "India blauw",
  fr: "Bleu indien"
}, {
  hex: "#8c9999",
  code: "200 60 05",
  scope: "Design System Plus",
  de: "Schattengrau",
  en: "Shady grey",
  nl: "Schaduwgrijs",
  fr: "Gris ombre"
}, {
  hex: "#829a9b",
  code: "200 60 10",
  scope: "Design System Plus",
  de: "Nordkapgrau",
  en: "North Cape grey",
  nl: "Noordkaap grijs",
  fr: "Gris cap nord"
}, {
  hex: "#769d9e",
  code: "200 60 15",
  scope: "Design System Plus",
  de: "Waidindigo",
  en: "Woad indigo",
  nl: "Waidindigo",
  fr: "Waidindigo"
}, {
  hex: "#6aa0a1",
  code: "200 60 20",
  scope: "Design System Plus",
  de: "Jugendstiltürkis",
  en: "Art nouveau turquoise",
  nl: "Jugendstil turkoois",
  fr: "Turquoise art nouveau"
}, {
  hex: "#59a1a2",
  code: "200 60 25",
  scope: "Design System Plus",
  de: "Kühlboxeistürkis",
  en: "Coolbox ice turquoise",
  nl: "Koelbox turquoise",
  fr: "Boxe réfrigéréeisturquoise"
}, {
  hex: "#48a4a5",
  code: "200 60 30",
  scope: "Design System Plus",
  de: "Aquamarinblau",
  en: "Aquamarine blue",
  nl: "Aquamarijnblauw",
  fr: "Bleu aigue-marine"
}, {
  hex: "#33a5a9",
  code: "200 60 35",
  scope: "Design System Plus",
  de: "Arktisblau",
  en: "Arctic blue",
  nl: "Arctisch blauw",
  fr: "Bleu arctique"
}, {
  hex: "#05a8ac",
  code: "200 60 40",
  scope: "Design System Plus",
  de: "Wachsstiftblau",
  en: "Wax crayon blue",
  nl: "Waskrijt blauw",
  fr: "Bleu crayon de cire"
}, {
  hex: "#a5b1b1",
  code: "200 70 05",
  scope: "Design System Plus",
  de: "Prinzengrau",
  en: "Prince grey",
  nl: "Prins grijs",
  fr: "Gris prince"
}, {
  hex: "#9ab5b5",
  code: "200 70 10",
  scope: "Design System Plus",
  de: "Calcitblau",
  en: "Calcite blue",
  nl: "Calciet blauw",
  fr: "Bleu calcite"
}, {
  hex: "#8cb6b6",
  code: "200 70 15",
  scope: "Design System Plus",
  de: "Kaltfrontgrün",
  en: "Cold front green",
  nl: "Koud front groen",
  fr: "Vert à front froid"
}, {
  hex: "#82b9b9",
  code: "200 70 20",
  scope: "Design System Plus",
  de: "Eisvogeltürkis",
  en: "Kingfisher turquoise",
  nl: "IJsvogel turquoise",
  fr: "Turquoise martin-pêcheur"
}, {
  hex: "#74bcbf",
  code: "200 70 25",
  scope: "Design System Plus",
  de: "Frischbleu",
  en: "Fresh soft blue",
  nl: "Vers lood",
  fr: "Plomb frais"
}, {
  hex: "#bfcbca",
  code: "200 80 05",
  scope: "Design System Plus",
  de: "Chinalichtgrün",
  en: "China light green",
  nl: "Chinees lichtgroen",
  fr: "Vert clair de Chine"
}, {
  hex: "#b2cece",
  code: "200 80 10",
  scope: "Design System Plus",
  de: "Barockkalkbleu",
  en: "Baroque chalk soft blue",
  nl: "Barok kalklood",
  fr: "Bleu de chaux baroque"
}, {
  hex: "#a6cfce",
  code: "200 80 15",
  scope: "Design System Plus",
  de: "Eisboutiquetürkis",
  en: "Ice boutique turquoise",
  nl: "Ijs boetiek turquoise",
  fr: "Boutique de glace turquoise"
}, {
  hex: "#9ad4d3",
  code: "200 80 20",
  scope: "Design System Plus",
  de: "Sommerbleu",
  en: "Summer soft blue",
  nl: "Zomer leiden",
  fr: "Plomb d'été"
}, {
  hex: "#8cd5d6",
  code: "200 80 25",
  scope: "Design System Plus",
  de: "Bergseeblau",
  en: "Mountain lake blue",
  nl: "Bergzee blauw",
  fr: "Bleu lac de montagne"
}, {
  hex: "#cad7d7",
  code: "200 85 05",
  scope: "Design System Plus",
  de: "Bastlichtgrau",
  en: "Raffia light grey",
  nl: "Bast lichtgrijs",
  fr: "Gris raphia"
}, {
  hex: "#c0dada",
  code: "200 85 10",
  scope: "Design System Plus",
  de: "Kaltlufttürkis",
  en: "Cold air turquoise",
  nl: "Koude lucht turquoise",
  fr: "Turquoise froid"
}, {
  hex: "#b3dddd",
  code: "200 85 15",
  scope: "Design System Plus",
  de: "Frosthellbleu",
  en: "Frosty soft blue",
  nl: "Frosthell lood",
  fr: "Frosthellbleu"
}, {
  hex: "#a6e0df",
  code: "200 85 20",
  scope: "Design System Plus",
  de: "Eiskristallblau",
  en: "Ice crystal blue",
  nl: "Ijskristalblauw",
  fr: "Bleu cristal de glace"
}, {
  hex: "#dbe8e5",
  code: "200 90 05",
  scope: "Design System Plus",
  de: "Frostgrün",
  en: "Frosty green",
  nl: "Vorstgroen",
  fr: "Vert givré"
}, {
  hex: "#cee9e5",
  code: "200 90 10",
  scope: "Design System Plus",
  de: "Frostweißblau",
  en: "Frosty white blue",
  nl: "Vorst wit blauw",
  fr: "Bleu blanc givré"
}, {
  hex: "#e2eeeb",
  code: "200 93 05",
  scope: "Design System Plus",
  de: "Klirrendweiß",
  en: "Chilly white",
  nl: "Klinkend wit",
  fr: "Blanc éclatant"
}, {
  hex: "#4a5a5c",
  code: "210 30 10",
  scope: "Design System Plus",
  de: "Graphitschwarzgrün",
  en: "Graphite black green",
  nl: "Grafiet zwart groen",
  fr: "Vert noir graphite"
}, {
  hex: "#415c60",
  code: "210 30 15",
  scope: "Design System Plus",
  de: "Stockentenblau",
  en: "Mallard blue",
  nl: "Wilde eend blauw",
  fr: "Bleu canard colvert"
}, {
  hex: "#365e64",
  code: "210 30 20",
  scope: "Design System Plus",
  de: "Transportergrün",
  en: "Transporter green",
  nl: "Transporteur groen",
  fr: "Vert transporteur"
}, {
  hex: "#2b5e65",
  code: "210 30 25",
  scope: "Design System Plus",
  de: "Tiefatlantikblau",
  en: "Deep Atlantic blue",
  nl: "Diep Atlantisch blauw",
  fr: "Bleu Atlantique profond"
}, {
  hex: "#175f68",
  code: "210 30 30",
  scope: "Design System Plus",
  de: "Kaliblau",
  en: "Kali blue",
  nl: "Kaliber blauw",
  fr: "Bleu de potassium"
}, {
  hex: "#586c6f",
  code: "210 40 10",
  scope: "Design System Plus",
  de: "Leinengrau",
  en: "Linen grey",
  nl: "Linnen grijs",
  fr: "Gris lin"
}, {
  hex: "#4f6f74",
  code: "210 40 15",
  scope: "Design System Plus",
  de: "Chinagrünblau",
  en: "China green blue",
  nl: "Chinees groen blauw",
  fr: "Bleu vert de Chine"
}, {
  hex: "#437177",
  code: "210 40 20",
  scope: "Design System Plus",
  de: "Dämmerblau",
  en: "Dusk blue",
  nl: "Schemerblauw",
  fr: "Bleu crépuscule"
}, {
  hex: "#347178",
  code: "210 40 25",
  scope: "Design System Plus",
  de: "Hosenblau",
  en: "Trouser blue",
  nl: "Broek blauw",
  fr: "Bleu pantalon"
}, {
  hex: "#1e737d",
  code: "210 40 30",
  scope: "Design System Plus",
  de: "Indigoblau",
  en: "Indigo blue",
  nl: "Indigo blauw",
  fr: "Bleu indigo"
}, {
  hex: "#007681",
  code: "210 40 35",
  scope: "Design System Plus",
  de: "Kaltblau",
  en: "Cold blue",
  nl: "Koud blauw",
  fr: "Bleu froid"
}, {
  hex: "#007481",
  code: "210 40 38",
  scope: "Design System Plus",
  de: "Marienblau",
  en: "Mary blue",
  nl: "Maria blauw",
  fr: "Bleu marie"
}, {
  hex: "#6b8386",
  code: "210 50 10",
  scope: "Design System Plus",
  de: "Uniformgrüngrau",
  en: "Uniform green grey",
  nl: "Uniform groen-grijs",
  fr: "Gris vert uniforme"
}, {
  hex: "#628488",
  code: "210 50 15",
  scope: "Design System Plus",
  de: "Labradoritgrün",
  en: "Labradorite green",
  nl: "Labradoriet groen",
  fr: "Vert labradorite"
}, {
  hex: "#54868d",
  code: "210 50 20",
  scope: "Design System Plus",
  de: "Emailleantikgrün",
  en: "Enamel antique green",
  nl: "Email antiek groen",
  fr: "Vert antique émaillé"
}, {
  hex: "#458990",
  code: "210 50 25",
  scope: "Design System Plus",
  de: "Cranachblau",
  en: "Cranach blue",
  nl: "Cranach blauw",
  fr: "Bleu cranach"
}, {
  hex: "#2d8a94",
  code: "210 50 30",
  scope: "Design System Plus",
  de: "Chinablau",
  en: "China blue",
  nl: "China blauw",
  fr: "Bleu chine"
}, {
  hex: "#148c98",
  code: "210 50 35",
  scope: "Design System Plus",
  de: "Gletscherblau",
  en: "Glacier blue",
  nl: "Gletsjerblauw",
  fr: "Bleu glacier"
}, {
  hex: "#008e9b",
  code: "210 50 40",
  scope: "Design System Plus",
  de: "Curaçaoblau",
  en: "Curaçao blue",
  nl: "Curaçao blauw",
  fr: "Bleu curaçao"
}, {
  hex: "#008f9e",
  code: "210 50 45",
  scope: "Design System Plus",
  de: "Atlantikblau",
  en: "Atlantic blue",
  nl: "Atlantisch blauw",
  fr: "Bleu atlantique"
}, {
  hex: "#829a9d",
  code: "210 60 10",
  scope: "Design System Plus",
  de: "Aschblau",
  en: "Ash blue",
  nl: "Asblauw",
  fr: "Bleu cendré"
}, {
  hex: "#769ca0",
  code: "210 60 15",
  scope: "Design System Plus",
  de: "Baltikblau",
  en: "Baltic blue",
  nl: "Baltisch blauw",
  fr: "Bleu baltique"
}, {
  hex: "#6ba1a7",
  code: "210 60 20",
  scope: "Design System Plus",
  de: "Strandblau",
  en: "Beach blue",
  nl: "Strand blauw",
  fr: "Bleu de la plage"
}, {
  hex: "#5aa4ab",
  code: "210 60 25",
  scope: "Design System Plus",
  de: "Basilikablau",
  en: "Basilica blue",
  nl: "Basiliek blauw",
  fr: "Bleu basilic"
}, {
  hex: "#48a5af",
  code: "210 60 30",
  scope: "Design System Plus",
  de: "Donaublau",
  en: "Danube blue",
  nl: "Donau blauw",
  fr: "Bleu du Danube"
}, {
  hex: "#2ca5b1",
  code: "210 60 35",
  scope: "Design System Plus",
  de: "Altdorferhimmelblau",
  en: "Altdorf sky blue",
  nl: "Altdorfer hemelsblauw",
  fr: "Altdorferhimmelblau"
}, {
  hex: "#00a8b5",
  code: "210 60 40",
  scope: "Design System Plus",
  de: "Grellblau",
  en: "Garish blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#9bb4b7",
  code: "210 70 10",
  scope: "Design System Plus",
  de: "Sturmgrau",
  en: "Storm grey",
  nl: "Stormgrijs",
  fr: "Gris tempête"
}, {
  hex: "#8fb6ba",
  code: "210 70 15",
  scope: "Design System Plus",
  de: "Persischblau",
  en: "Persian blue",
  nl: "Perzisch blauw",
  fr: "Bleu persan"
}, {
  hex: "#81b9bf",
  code: "210 70 20",
  scope: "Design System Plus",
  de: "Aquablau",
  en: "Aqua blue",
  nl: "Aqua blauw",
  fr: "Bleu aqua"
}, {
  hex: "#73bbc3",
  code: "210 70 25",
  scope: "Design System Plus",
  de: "Maritimbleu",
  en: "Maritime soft blue",
  nl: "Maritieme leiding",
  fr: "Bleu marine"
}, {
  hex: "#61bec8",
  code: "210 70 30",
  scope: "Design System Plus",
  de: "Bergblau",
  en: "Mountain blue",
  nl: "Blauw in de bergen",
  fr: "Bleu montagne"
}, {
  hex: "#4cc0cb",
  code: "210 70 35",
  scope: "Design System Plus",
  de: "Weitsichtblau",
  en: "Panorama blue",
  nl: "Verziend blauw",
  fr: "Bleu large"
}, {
  hex: "#b7d0d1",
  code: "210 80 10",
  scope: "Design System Plus",
  de: "Türkisgrau",
  en: "Turquoise grey",
  nl: "Turquoise grijs",
  fr: "Gris turquoise"
}, {
  hex: "#aad2d4",
  code: "210 80 15",
  scope: "Design System Plus",
  de: "Delphinblau",
  en: "Dolphin blue",
  nl: "Dolfijn blauw",
  fr: "Bleu dauphin"
}, {
  hex: "#9cd3d8",
  code: "210 80 20",
  scope: "Design System Plus",
  de: "Duftblau",
  en: "Aroma blue",
  nl: "Blauw geparfumeerd",
  fr: "Bleu parfumé"
}, {
  hex: "#8fd6dd",
  code: "210 80 25",
  scope: "Design System Plus",
  de: "Knallbleu",
  en: "Vibrant soft blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#c9d8d9",
  code: "210 85 05",
  scope: "Design System Plus",
  de: "Siestaweiß",
  en: "Siesta white",
  nl: "Siestawit",
  fr: "Siestablanc"
}, {
  hex: "#baddde",
  code: "210 85 10",
  scope: "Design System Plus",
  de: "Mintblau",
  en: "Mint blue",
  nl: "Mintblauw",
  fr: "Bleu menthe"
}, {
  hex: "#b5dedf",
  code: "210 85 15",
  scope: "Design System Plus",
  de: "Feinblau",
  en: "Fine blue",
  nl: "Fijn blauw",
  fr: "Bleu fin"
}, {
  hex: "#a7e0e1",
  code: "210 85 20",
  scope: "Design System Plus",
  de: "Blassblau",
  en: "Pale blue",
  nl: "Lichtblauw",
  fr: "Bleu pâle"
}, {
  hex: "#dae7e5",
  code: "210 90 05",
  scope: "Design System Plus",
  de: "Tüllbleu",
  en: "Tulle soft blue",
  nl: "Tule lood",
  fr: "Plomb de tulle"
}, {
  hex: "#cde9e7",
  code: "210 90 10",
  scope: "Design System Plus",
  de: "Antarktisblau",
  en: "Antarctic blue",
  nl: "Antarctisch blauw",
  fr: "Bleu antarctique"
}, {
  hex: "#43494b",
  code: "220 20 05",
  scope: "Design System Plus",
  de: "Navyschwarz",
  en: "Navy black",
  nl: "Marine zwart",
  fr: "Noir navy"
}, {
  hex: "#3c4a4e",
  code: "220 20 10",
  scope: "Design System Plus",
  de: "Indigokarmin",
  en: "Indigo carmine",
  nl: "Indigo karmijn",
  fr: "Carmin d'indigo"
}, {
  hex: "#344a50",
  code: "220 20 15",
  scope: "Design System Plus",
  de: "Künstlerblau",
  en: "Artist blue",
  nl: "Kunstenaar blauw",
  fr: "Bleu artiste"
}, {
  hex: "#2d4b53",
  code: "220 20 20",
  scope: "Design System Plus",
  de: "Naturindigo",
  en: "Natural indigo",
  nl: "Natuurlijk indigo",
  fr: "Indigo naturel"
}, {
  hex: "#51595a",
  code: "220 30 05",
  scope: "Design System Plus",
  de: "Pandaschwarz",
  en: "Panda black",
  nl: "Panda zwart",
  fr: "Noir panda"
}, {
  hex: "#4a5b5e",
  code: "220 30 10",
  scope: "Design System Plus",
  de: "Pallasitblau",
  en: "Pallasite blue",
  nl: "Pallasiet blauw",
  fr: "Bleu pallasite"
}, {
  hex: "#435d64",
  code: "220 30 15",
  scope: "Design System Plus",
  de: "Orkangrünblau",
  en: "Hurricane green blue",
  nl: "Gagelgroen blauw",
  fr: "Bleu vert orcane"
}, {
  hex: "#385e66",
  code: "220 30 20",
  scope: "Design System Plus",
  de: "Aquarellblau",
  en: "Watercolour blue",
  nl: "Aquarel blauw",
  fr: "Bleu aquarelle"
}, {
  hex: "#2e606b",
  code: "220 30 25",
  scope: "Design System Plus",
  de: "Korallenblau",
  en: "Coral blue",
  nl: "Koraalblauw",
  fr: "Bleu corail"
}, {
  hex: "#155f6d",
  code: "220 30 30",
  scope: "Design System Plus",
  de: "Sandelholzblau",
  en: "Sandalwood grey blue",
  nl: "Sandelhout blauw",
  fr: "Bleu santal"
}, {
  hex: "#626c6e",
  code: "220 40 05",
  scope: "Design System Plus",
  de: "Limousinengraublau",
  en: "Limousine grey blue",
  nl: "Limousine grijs blauw",
  fr: "Gris limousine"
}, {
  hex: "#5a6e72",
  code: "220 40 10",
  scope: "Design System Plus",
  de: "Korundblau",
  en: "Corundum blue",
  nl: "Korund blauw",
  fr: "Bleu corail"
}, {
  hex: "#4f6f77",
  code: "220 40 15",
  scope: "Design System Plus",
  de: "Kittelblau",
  en: "Smock blue",
  nl: "Smok blauw",
  fr: "Bleu blouse"
}, {
  hex: "#45717b",
  code: "220 40 20",
  scope: "Design System Plus",
  de: "Beizeblau",
  en: "Mordant blue",
  nl: "Blauwe vlek",
  fr: "Bleu mordoré"
}, {
  hex: "#37737f",
  code: "220 40 25",
  scope: "Design System Plus",
  de: "Baumwollindigo",
  en: "Cotton indigo",
  nl: "Katoen indigo",
  fr: "Indigo en coton"
}, {
  hex: "#1f7586",
  code: "220 40 30",
  scope: "Design System Plus",
  de: "Fjordblau",
  en: "Fjord blue",
  nl: "Fjordblauw",
  fr: "Bleu fjord"
}, {
  hex: "#007689",
  code: "220 40 35",
  scope: "Design System Plus",
  de: "Azurgrünblau",
  en: "Azure green blue",
  nl: "Azuurgroen blauw",
  fr: "Bleu azur"
}, {
  hex: "#00788e",
  code: "220 40 40",
  scope: "Design System Plus",
  de: "Cyanblau",
  en: "Cyan blue",
  nl: "Cyaanblauw",
  fr: "Bleu cyan"
}, {
  hex: "#788284",
  code: "220 50 05",
  scope: "Design System Plus",
  de: "Winterwolkengrau",
  en: "Winter cloud grey",
  nl: "Winterwolk grijs",
  fr: "Gris des nuages d'hiver"
}, {
  hex: "#6f8388",
  code: "220 50 10",
  scope: "Design System Plus",
  de: "Kadettgrau",
  en: "Cadet grey",
  nl: "Cadet grijs",
  fr: "Gris cadet"
}, {
  hex: "#62858d",
  code: "220 50 15",
  scope: "Design System Plus",
  de: "Holbeinblaugrau",
  en: "Holbein blue grey",
  nl: "Holbein blauw-grijs",
  fr: "Gris bleu holbein"
}, {
  hex: "#558791",
  code: "220 50 20",
  scope: "Design System Plus",
  de: "Schattenblau",
  en: "Shady blue",
  nl: "Schaduwblauw",
  fr: "Bleu ombre"
}, {
  hex: "#488895",
  code: "220 50 25",
  scope: "Design System Plus",
  de: "Frescoblau",
  en: "Fresco blue",
  nl: "Fresco blauw",
  fr: "Bleu fresco"
}, {
  hex: "#318899",
  code: "220 50 30",
  scope: "Design System Plus",
  de: "Handwerkerblau",
  en: "Craftsman blue",
  nl: "Ambachtelijk blauw",
  fr: "Bleu artisan"
}, {
  hex: "#198ca0",
  code: "220 50 35",
  scope: "Design System Plus",
  de: "Markerblau",
  en: "Marker blue",
  nl: "Marker blauw",
  fr: "Bleu marqueur"
}, {
  hex: "#008ea5",
  code: "220 50 40",
  scope: "Design System Plus",
  de: "Spielzeugblau",
  en: "Toy blue",
  nl: "Speelgoed blauw",
  fr: "Bleu jouet"
}, {
  hex: "#8e989a",
  code: "220 60 05",
  scope: "Design System Plus",
  de: "Tiefseegrau",
  en: "Deep sea grey",
  nl: "Diep zeegrijs",
  fr: "Gris océan profond"
}, {
  hex: "#839ba0",
  code: "220 60 10",
  scope: "Design System Plus",
  de: "Kachelblau",
  en: "Tile blue",
  nl: "Tegel blauw",
  fr: "Bleu faïence"
}, {
  hex: "#799da5",
  code: "220 60 15",
  scope: "Design System Plus",
  de: "Morgenblau",
  en: "Morning blue",
  nl: "Ochtendblauw",
  fr: "Bleu du matin"
}, {
  hex: "#699fab",
  code: "220 60 20",
  scope: "Design System Plus",
  de: "Frostblau",
  en: "Frost blue",
  nl: "Vorstblauw",
  fr: "Bleu givré"
}, {
  hex: "#5ba1b0",
  code: "220 60 25",
  scope: "Design System Plus",
  de: "Sommertürkisblau",
  en: "Summer turquoise blue",
  nl: "Zomer turquoise blauw",
  fr: "Bleu turquoise d'été"
}, {
  hex: "#4aa4b5",
  code: "220 60 30",
  scope: "Design System Plus",
  de: "Fischerblau",
  en: "Fischer blue",
  nl: "Visser blauw",
  fr: "Bleu pêcheur"
}, {
  hex: "#36a3b8",
  code: "220 60 35",
  scope: "Design System Plus",
  de: "Planetblau",
  en: "Planet blue",
  nl: "Planeet blauw",
  fr: "Bleu planète"
}, {
  hex: "#00a5bd",
  code: "220 60 40",
  scope: "Design System Plus",
  de: "Januarblau",
  en: "January blue",
  nl: "Januari blauw",
  fr: "Bleu de janvier"
}, {
  hex: "#a6b2b5",
  code: "220 70 05",
  scope: "Design System Plus",
  de: "Temperiertgrau",
  en: "Tempered grey",
  nl: "Getemperd grijs",
  fr: "Gris tempéré"
}, {
  hex: "#9db5bb",
  code: "220 70 10",
  scope: "Design System Plus",
  de: "Mohairbleugrau",
  en: "Mohair soft blue grey",
  nl: "Mohair loodgrijs",
  fr: "Gris plomb mohair"
}, {
  hex: "#90b8c0",
  code: "220 70 15",
  scope: "Design System Plus",
  de: "Küchenblau",
  en: "Kitchen blue",
  nl: "Keuken blauw",
  fr: "Bleu cuisine"
}, {
  hex: "#84b9c4",
  code: "220 70 20",
  scope: "Design System Plus",
  de: "Gastronomieblau",
  en: "Culinary blue",
  nl: "Gastronomie blauw",
  fr: "Bleu gastronomique"
}, {
  hex: "#72bac9",
  code: "220 70 25",
  scope: "Design System Plus",
  de: "Blousonblau",
  en: "Blouson blue",
  nl: "Blouson blauw",
  fr: "Blouson bleu"
}, {
  hex: "#61bacc",
  code: "220 70 30",
  scope: "Design System Plus",
  de: "Gebirgsblau",
  en: "Mountain range blue",
  nl: "Blauw in de bergen",
  fr: "Bleu montagne"
}, {
  hex: "#4bbfd4",
  code: "220 70 35",
  scope: "Design System Plus",
  de: "Ferienblau",
  en: "Holiday blue",
  nl: "Vakantie blauw",
  fr: "Bleu de vacances"
}, {
  hex: "#bfcccd",
  code: "220 80 05",
  scope: "Design System Plus",
  de: "Pastellblau",
  en: "Pastel blue",
  nl: "Pastelblauw",
  fr: "Bleu pastel"
}, {
  hex: "#b5d0d5",
  code: "220 80 10",
  scope: "Design System Plus",
  de: "Klinischbleu",
  en: "Clinical soft blue",
  nl: "Klinische leiding",
  fr: "Plomb clinique"
}, {
  hex: "#a6cfd8",
  code: "220 80 15",
  scope: "Design System Plus",
  de: "Kinderbleu",
  en: "Children's soft blue",
  nl: "Lood voor kinderen",
  fr: "Plomb pour enfants"
}, {
  hex: "#9ed4e0",
  code: "220 80 20",
  scope: "Design System Plus",
  de: "Turmalinwasserblau",
  en: "Tourmaline water blue",
  nl: "Toermalijn waterblauw",
  fr: "Bleu d'eau de tourmaline"
}, {
  hex: "#92d7e3",
  code: "220 80 25",
  scope: "Design System Plus",
  de: "Frischblau",
  en: "Fresh blue",
  nl: "Fris blauw",
  fr: "Bleu frais"
}, {
  hex: "#ccd9dc",
  code: "220 85 05",
  scope: "Design System Plus",
  de: "Transparentbleu",
  en: "Transparent blue",
  nl: "Transparant lood",
  fr: "Bleu transparent"
}, {
  hex: "#c0dce1",
  code: "220 85 10",
  scope: "Design System Plus",
  de: "Eisscherbenbleu",
  en: "Ice shard soft blue",
  nl: "Ijsscherf lood",
  fr: "Plomb de glace"
}, {
  hex: "#b3dee6",
  code: "220 85 15",
  scope: "Design System Plus",
  de: "Polarblau",
  en: "Polar blue",
  nl: "Polair blauw",
  fr: "Bleu polaire"
}, {
  hex: "#dae7e6",
  code: "220 90 05",
  scope: "Design System Plus",
  de: "Kaltlichtbleu",
  en: "Cold soft blue",
  nl: "Koud lood",
  fr: "Plomb de lumière froide"
}, {
  hex: "#cde7e7",
  code: "220 90 10",
  scope: "Design System Plus",
  de: "Vollmondgrau",
  en: "Full moon grey",
  nl: "Volle maan grijs",
  fr: "Gris pleine lune"
}, {
  hex: "#3f4b50",
  code: "230 20 10",
  scope: "Design System Plus",
  de: "Erzblauschwarz",
  en: "Ore bluish black",
  nl: "Boog blauw-zwart",
  fr: "Noir bleu archaïque"
}, {
  hex: "#384b53",
  code: "230 20 15",
  scope: "Design System Plus",
  de: "Firmamentblau",
  en: "Firmanent blue",
  nl: "Firmament blauw",
  fr: "Bleu menthe"
}, {
  hex: "#2d4955",
  code: "230 20 20",
  scope: "Design System Plus",
  de: "Preußischblau",
  en: "Prussian blue",
  nl: "Pruisisch blauw",
  fr: "Bleu de Prusse"
}, {
  hex: "#4d5b61",
  code: "230 30 10",
  scope: "Design System Plus",
  de: "Galenitblau",
  en: "Galenite blue",
  nl: "Galena blauw",
  fr: "Bleu de galène"
}, {
  hex: "#435b65",
  code: "230 30 15",
  scope: "Design System Plus",
  de: "Beerenblaugrün",
  en: "Berry blue green",
  nl: "Bessen blauwgroen",
  fr: "Bleu-vert baie"
}, {
  hex: "#3a5d6a",
  code: "230 30 20",
  scope: "Design System Plus",
  de: "Petroldunkelblau",
  en: "Teal dark blue",
  nl: "Petroleum donkerblauw",
  fr: "Bleu pétrole foncé"
}, {
  hex: "#2d5e6f",
  code: "230 30 25",
  scope: "Design System Plus",
  de: "Gewitterblau",
  en: "Thunderstorm blue",
  nl: "Onweer blauw",
  fr: "Bleu orage"
}, {
  hex: "#5b6d74",
  code: "230 40 10",
  scope: "Design System Plus",
  de: "Zapfengrünblau",
  en: "Cone green blue",
  nl: "Kegel groen blauw",
  fr: "Bleu vert pomme de pin"
}, {
  hex: "#536e79",
  code: "230 40 15",
  scope: "Design System Plus",
  de: "Wacholderbeerenblau",
  en: "Juniper berry blue",
  nl: "Jeneverbes blauw",
  fr: "Bleu genévrier"
}, {
  hex: "#48717f",
  code: "230 40 20",
  scope: "Design System Plus",
  de: "Sterntauchertürkis",
  en: "Loon turquoise",
  nl: "Turquoise met ster",
  fr: "Plongeon turquoise étoilé"
}, {
  hex: "#387184",
  code: "230 40 25",
  scope: "Design System Plus",
  de: "Werkstattblau",
  en: "Workshop blue",
  nl: "Workshop blauw",
  fr: "Bleu atelier"
}, {
  hex: "#2c738a",
  code: "230 40 30",
  scope: "Design System Plus",
  de: "Pilotenblau",
  en: "Pilot blue",
  nl: "Piloot blauw",
  fr: "Bleu pilote"
}, {
  hex: "#007590",
  code: "230 40 35",
  scope: "Design System Plus",
  de: "Tintenblau",
  en: "Ink blue",
  nl: "Inkt blauw",
  fr: "Bleu encre"
}, {
  hex: "#007593",
  code: "230 40 40",
  scope: "Design System Plus",
  de: "Technoblau",
  en: "Techno blue",
  nl: "Technoblauw",
  fr: "Bleu techno"
}, {
  hex: "#6f838a",
  code: "230 50 10",
  scope: "Design System Plus",
  de: "Kiesgraublau",
  en: "Gravel grey blue",
  nl: "Grindgrijs blauw",
  fr: "Bleu gris gravier"
}, {
  hex: "#658690",
  code: "230 50 15",
  scope: "Design System Plus",
  de: "Fichtenblau",
  en: "Spruce blue",
  nl: "Vurenblauw",
  fr: "Bleu épicéa"
}, {
  hex: "#5a8797",
  code: "230 50 20",
  scope: "Design System Plus",
  de: "Freizeitblau",
  en: "Casual blue",
  nl: "Vrije tijd blauw",
  fr: "Bleu loisir"
}, {
  hex: "#4d889b",
  code: "230 50 25",
  scope: "Design System Plus",
  de: "Vergissmeinnichtblau",
  en: "Forget-me-not blue",
  nl: "Vergeet-me-nietje blauw",
  fr: "Bleu myosotis"
}, {
  hex: "#378ba3",
  code: "230 50 30",
  scope: "Design System Plus",
  de: "Zirkonblau",
  en: "Zircon blue",
  nl: "Zirkoonblauw",
  fr: "Bleu zircon"
}, {
  hex: "#1f8ba6",
  code: "230 50 35",
  scope: "Design System Plus",
  de: "Lagunenblau",
  en: "Lagoon blue",
  nl: "Lagune blauw",
  fr: "Bleu lagon"
}, {
  hex: "#008cad",
  code: "230 50 40",
  scope: "Design System Plus",
  de: "Azorenblau",
  en: "Azores blue",
  nl: "Azoren blauw",
  fr: "Bleu azur"
}, {
  hex: "#869ca4",
  code: "230 60 10",
  scope: "Design System Plus",
  de: "Eisvogelgrau",
  en: "Kingfisher grey",
  nl: "IJsvogel grijs",
  fr: "Gris martin-pêcheur"
}, {
  hex: "#7b9ca7",
  code: "230 60 15",
  scope: "Design System Plus",
  de: "Silbertannenblau",
  en: "Silver fir blue",
  nl: "Zilverspar blauw",
  fr: "Bleu sapin argenté"
}, {
  hex: "#6e9eae",
  code: "230 60 20",
  scope: "Design System Plus",
  de: "Pyjamablau",
  en: "Pyjama blue",
  nl: "Pyjama blauw",
  fr: "Bleu pyjama"
}, {
  hex: "#5e9fb4",
  code: "230 60 25",
  scope: "Design System Plus",
  de: "Sternblütenblau",
  en: "Starflower blue",
  nl: "Sterrenbloem blauw",
  fr: "Bleu fleur d'étoile"
}, {
  hex: "#4fa0b9",
  code: "230 60 30",
  scope: "Design System Plus",
  de: "Sportblau",
  en: "Sports blue",
  nl: "Sport blauw",
  fr: "Bleu sport"
}, {
  hex: "#37a3c1",
  code: "230 60 35",
  scope: "Design System Plus",
  de: "Griechischblau",
  en: "Greek blue",
  nl: "Grieks blauw",
  fr: "Bleu grec"
}, {
  hex: "#00a4c7",
  code: "230 60 40",
  scope: "Design System Plus",
  de: "Alpenblau",
  en: "Alpine blue",
  nl: "Alpine blauw",
  fr: "Bleu des Alpes"
}, {
  hex: "#a0b6be",
  code: "230 70 10",
  scope: "Design System Plus",
  de: "Eismövengraublau",
  en: "Ice gull grey blue",
  nl: "IJzig grijsblauw",
  fr: "Gris goéland glacé"
}, {
  hex: "#91b6c2",
  code: "230 70 15",
  scope: "Design System Plus",
  de: "Distelblütenbleu",
  en: "Thistleblossom soft blue",
  nl: "Distelbloesem lood",
  fr: "Plomb de la fleur de chardon"
}, {
  hex: "#85b8c9",
  code: "230 70 20",
  scope: "Design System Plus",
  de: "Tennisblau",
  en: "Tennis blue",
  nl: "Tennis blauw",
  fr: "Bleu tennis"
}, {
  hex: "#7abacf",
  code: "230 70 25",
  scope: "Design System Plus",
  de: "Oldtimerblau",
  en: "Vintage blue",
  nl: "Vintage auto blauw",
  fr: "Bleu oldtimer"
}, {
  hex: "#68bbd4",
  code: "230 70 30",
  scope: "Design System Plus",
  de: "Fitnessblau",
  en: "Fitness blue",
  nl: "Fitness blauw",
  fr: "Bleu fitness"
}, {
  hex: "#b7cfd6",
  code: "230 80 10",
  scope: "Design System Plus",
  de: "Bleichblau",
  en: "Pallid blue",
  nl: "Lichtblauw",
  fr: "Bleu pâle"
}, {
  hex: "#abceda",
  code: "230 80 15",
  scope: "Design System Plus",
  de: "Alpenmorgenblau",
  en: "Alpine morning blue",
  nl: "Alpine ochtendblauw",
  fr: "Bleu matin alpin"
}, {
  hex: "#a1d2e2",
  code: "230 80 20",
  scope: "Design System Plus",
  de: "Hellblau",
  en: "Light blue",
  nl: "Lichtblauw",
  fr: "Bleu clair"
}, {
  hex: "#ced9dd",
  code: "230 85 05",
  scope: "Design System Plus",
  de: "Polarkaltbleu",
  en: "Polar soft blue",
  nl: "Poolkoud lood",
  fr: "Plomb froid polaire"
}, {
  hex: "#c1d9e1",
  code: "230 85 10",
  scope: "Design System Plus",
  de: "Waschpulverweiß",
  en: "Washing powder white",
  nl: "Waspoeder wit",
  fr: "Blanc en poudre de lavage"
}, {
  hex: "#b8dce7",
  code: "230 85 15",
  scope: "Design System Plus",
  de: "Himalayaweißblau",
  en: "Himalaya white blue",
  nl: "Himalaya wit blauw",
  fr: "Bleu blanc Himalaya"
}, {
  hex: "#abdeee",
  code: "230 85 20",
  scope: "Design System Plus",
  de: "Atmosphärenbleu",
  en: "Atmospheric soft blue",
  nl: "Atmosferisch lood",
  fr: "Plomb atmosphérique"
}, {
  hex: "#dbe6e6",
  code: "230 90 05",
  scope: "Design System Plus",
  de: "Strahlendweiß",
  en: "Brilliant white",
  nl: "Gitwit",
  fr: "Blanc éclatant"
}, {
  hex: "#454a4d",
  code: "240 20 05",
  scope: "Design System Plus",
  de: "Nachtschattenblau",
  en: "Nightshade blue",
  nl: "Nachtschade blauw",
  fr: "bleu nuit"
}, {
  hex: "#3f4a51",
  code: "240 20 10",
  scope: "Design System Plus",
  de: "Holunderschwarz",
  en: "Elderberry black",
  nl: "Vlierbes zwart",
  fr: "Noir sureau"
}, {
  hex: "#394a55",
  code: "240 20 15",
  scope: "Design System Plus",
  de: "Metallblau",
  en: "Metal blue",
  nl: "Metaal blauw",
  fr: "Bleu métal"
}, {
  hex: "#334b59",
  code: "240 20 20",
  scope: "Design System Plus",
  de: "Krähenbeerenblau",
  en: "Crowberry blue",
  nl: "Kraaihei blauw",
  fr: "Bleu corbeau"
}, {
  hex: "#294a5b",
  code: "240 20 22",
  scope: "Design System Plus",
  de: "Sattblau",
  en: "Rich blue",
  nl: "Verzadigd blauw",
  fr: "Bleu satiné"
}, {
  hex: "#52595c",
  code: "240 30 05",
  scope: "Design System Plus",
  de: "Diamantgrau",
  en: "Diamond grey",
  nl: "Diamant grijs",
  fr: "Gris diamant"
}, {
  hex: "#4c5a62",
  code: "240 30 10",
  scope: "Design System Plus",
  de: "Schmutzblau",
  en: "Dirty blue",
  nl: "Vuilblauw",
  fr: "Bleu sale"
}, {
  hex: "#455b67",
  code: "240 30 15",
  scope: "Design System Plus",
  de: "Tiefseeblau",
  en: "Deep sea blue",
  nl: "Diep zeeblauw",
  fr: "Bleu profond"
}, {
  hex: "#3c5c6c",
  code: "240 30 20",
  scope: "Design System Plus",
  de: "Lasuritblau",
  en: "Lasurite blue",
  nl: "Glazuriet blauw",
  fr: "Bleu lasurite"
}, {
  hex: "#2f5c72",
  code: "240 30 25",
  scope: "Design System Plus",
  de: "Arbeitsblau",
  en: "Work blue",
  nl: "Blauw werken",
  fr: "Bleu de travail"
}, {
  hex: "#215d77",
  code: "240 30 30",
  scope: "Design System Plus",
  de: "Schmucksteinblau",
  en: "Gemstone blue",
  nl: "Sieraden steen blauw",
  fr: "Bleu pierre précieuse"
}, {
  hex: "#065f7c",
  code: "240 30 35",
  scope: "Design System Plus",
  de: "Kapitänsblau",
  en: "Captain blue",
  nl: "Blauw van de kapitein",
  fr: "Bleu capitaine"
}, {
  hex: "#646b70",
  code: "240 40 05",
  scope: "Design System Plus",
  de: "Blauanthrazit",
  en: "Blue anthracite",
  nl: "Blauw antraciet",
  fr: "Bleu anthracite"
}, {
  hex: "#5c6d76",
  code: "240 40 10",
  scope: "Design System Plus",
  de: "Schwarzdornblau",
  en: "Blackthorn blue",
  nl: "Sleedoorn blauw",
  fr: "Bleu épine noire"
}, {
  hex: "#536e7d",
  code: "240 40 15",
  scope: "Design System Plus",
  de: "Celesteblau",
  en: "Celeste blue",
  nl: "Celeste blauw",
  fr: "Bleu Céleste"
}, {
  hex: "#486f82",
  code: "240 40 20",
  scope: "Design System Plus",
  de: "Jeansblau",
  en: "Denim blue",
  nl: "Denimblauw",
  fr: "Bleu jean"
}, {
  hex: "#3c708a",
  code: "240 40 25",
  scope: "Design System Plus",
  de: "Orientblau",
  en: "Orient blue",
  nl: "Oosters blauw",
  fr: "Bleu oriental"
}, {
  hex: "#28718f",
  code: "240 40 30",
  scope: "Design System Plus",
  de: "Matrosenblau",
  en: "Sailor blue",
  nl: "Matroos blauw",
  fr: "Bleu marin"
}, {
  hex: "#007295",
  code: "240 40 35",
  scope: "Design System Plus",
  de: "Steinblau",
  en: "Stone blue",
  nl: "Steenblauw",
  fr: "Bleu pierre"
}, {
  hex: "#00749a",
  code: "240 40 40",
  scope: "Design System Plus",
  de: "Reinbleu",
  en: "Pure light blue",
  nl: "Reinbleu",
  fr: "Reinbleu"
}, {
  hex: "#798186",
  code: "240 50 05",
  scope: "Design System Plus",
  de: "Rauchblau",
  en: "Smoky blue",
  nl: "Rook blauw",
  fr: "Bleu fumée"
}, {
  hex: "#6f828c",
  code: "240 50 10",
  scope: "Design System Plus",
  de: "Werkzeugblau",
  en: "Tool blue",
  nl: "Gereedschap blauw",
  fr: "Bleu outil"
}, {
  hex: "#668494",
  code: "240 50 15",
  scope: "Design System Plus",
  de: "Technikblau",
  en: "Technical blue",
  nl: "Technisch blauw",
  fr: "Bleu technique"
}, {
  hex: "#5a859a",
  code: "240 50 20",
  scope: "Design System Plus",
  de: "Coelinblau",
  en: "Coelin blue",
  nl: "Coelin blauw",
  fr: "Bleu célin"
}, {
  hex: "#4c86a0",
  code: "240 50 25",
  scope: "Design System Plus",
  de: "Grönlandblau",
  en: "Greenland blue",
  nl: "Groenland blauw",
  fr: "Bleu groenland"
}, {
  hex: "#3c87a6",
  code: "240 50 30",
  scope: "Design System Plus",
  de: "Sommerblau",
  en: "Summer blue",
  nl: "Zomerblauw",
  fr: "Bleu d'été"
}, {
  hex: "#1f88ad",
  code: "240 50 35",
  scope: "Design System Plus",
  de: "Werbeblau",
  en: "Advertising blue",
  nl: "Reclame blauw",
  fr: "Bleu publicitaire"
}, {
  hex: "#0088b2",
  code: "240 50 40",
  scope: "Design System Plus",
  de: "Tuschblau",
  en: "Indian inc blue",
  nl: "Inkt blauw",
  fr: "Bleu encre"
}, {
  hex: "#8f999e",
  code: "240 60 05",
  scope: "Design System Plus",
  de: "Brieftaubenblau",
  en: "Carrier pigeon blue",
  nl: "Postduif blauw",
  fr: "Bleu pigeon voyageur"
}, {
  hex: "#8297a2",
  code: "240 60 10",
  scope: "Design System Plus",
  de: "Vogelblau",
  en: "Bird blue",
  nl: "Vogelblauw",
  fr: "Bleu oiseau"
}, {
  hex: "#7a9aaa",
  code: "240 60 15",
  scope: "Design System Plus",
  de: "Architekturblau",
  en: "Architecture blue",
  nl: "Architectonisch blauw",
  fr: "Bleu architectural"
}, {
  hex: "#709db3",
  code: "240 60 20",
  scope: "Design System Plus",
  de: "Hemdblau",
  en: "Shirt blue",
  nl: "Overhemd blauw",
  fr: "Bleu foncé"
}, {
  hex: "#639eba",
  code: "240 60 25",
  scope: "Design System Plus",
  de: "Stahlhellblau",
  en: "Steel light blue",
  nl: "Staal lichtblauw",
  fr: "Bleu clair acier"
}, {
  hex: "#519fc0",
  code: "240 60 30",
  scope: "Design System Plus",
  de: "Märchenblau",
  en: "Fairytale blue",
  nl: "Sprookjesachtig blauw",
  fr: "Bleu de conte de fées"
}, {
  hex: "#3ca0c8",
  code: "240 60 35",
  scope: "Design System Plus",
  de: "Prinzessblau",
  en: "Princess blue",
  nl: "Prinses blauw",
  fr: "Bleu princesse"
}, {
  hex: "#1ba3cb",
  code: "240 60 40",
  scope: "Design System Plus",
  de: "Klarblau",
  en: "Clear blue",
  nl: "Helder blauw",
  fr: "Bleu clair"
}, {
  hex: "#a7b1b7",
  code: "240 70 05",
  scope: "Design System Plus",
  de: "Wäscheblau",
  en: "Laundry blue",
  nl: "Wasserij blauw",
  fr: "Bleu linge"
}, {
  hex: "#9eb2bd",
  code: "240 70 10",
  scope: "Design System Plus",
  de: "Augenblau",
  en: "Eye blue",
  nl: "Oog blauw",
  fr: "Bleu des yeux"
}, {
  hex: "#93b5c5",
  code: "240 70 15",
  scope: "Design System Plus",
  de: "Bermudablau",
  en: "Bermuda blue",
  nl: "Bermuda blauw",
  fr: "Bleu bermuda"
}, {
  hex: "#88b5cb",
  code: "240 70 20",
  scope: "Design System Plus",
  de: "Meerblau",
  en: "Sea blue",
  nl: "Zee blauw",
  fr: "Bleu mer"
}, {
  hex: "#7bb8d3",
  code: "240 70 25",
  scope: "Design System Plus",
  de: "Madonnablau",
  en: "Madonna blue",
  nl: "Madonna blauw",
  fr: "Bleu madonna"
}, {
  hex: "#6bb8d8",
  code: "240 70 30",
  scope: "Design System Plus",
  de: "Karibikblau",
  en: "Caribbean blue",
  nl: "Caribisch blauw",
  fr: "Bleu caraïbe"
}, {
  hex: "#bfcacf",
  code: "240 80 05",
  scope: "Design System Plus",
  de: "Dunstblau",
  en: "Hazy blue",
  nl: "Haze blauw",
  fr: "Bleu brumeux"
}, {
  hex: "#b9cfd9",
  code: "240 80 10",
  scope: "Design System Plus",
  de: "Topashellbleu",
  en: "Light topaz soft blue",
  nl: "Topashell lood",
  fr: "Bleu topaze"
}, {
  hex: "#aecfde",
  code: "240 80 15",
  scope: "Design System Plus",
  de: "Babyblau",
  en: "Baby blue",
  nl: "Baby blauw",
  fr: "Bleu bébé"
}, {
  hex: "#a1d1e6",
  code: "240 80 20",
  scope: "Design System Plus",
  de: "Kristallblau",
  en: "Crystal blue",
  nl: "Kristalblauw",
  fr: "Bleu cristal"
}, {
  hex: "#cdd7dd",
  code: "240 85 05",
  scope: "Design System Plus",
  de: "Eisgrau",
  en: "Ice grey",
  nl: "IJsgrijs",
  fr: "Gris glace"
}, {
  hex: "#c2d8e3",
  code: "240 85 10",
  scope: "Design System Plus",
  de: "Luftblau",
  en: "Air blue",
  nl: "Lucht blauw",
  fr: "Bleu aérien"
}, {
  hex: "#b7dbeb",
  code: "240 85 15",
  scope: "Design System Plus",
  de: "Pariserblau",
  en: "Paris blue",
  nl: "Parijs blauw",
  fr: "Bleu parisien"
}, {
  hex: "#dce7e9",
  code: "240 90 05",
  scope: "Design System Plus",
  de: "Bleuweiß",
  en: "Soft blue white",
  nl: "Loodwit",
  fr: "Blanc de plomb"
}, {
  hex: "#cfe8ef",
  code: "240 90 10",
  scope: "Design System Plus",
  de: "Kalkbleu",
  en: "Chalky blue white",
  nl: "Kalklood",
  fr: "Plomb de chaux"
}, {
  hex: "#334a5b",
  code: "250 20 20",
  scope: "Design System Plus",
  de: "Kosmosblau",
  en: "Cosmos blue",
  nl: "Kosmos blauw",
  fr: "Bleu cosmos"
}, {
  hex: "#2f4a5f",
  code: "250 20 25",
  scope: "Design System Plus",
  de: "Dunkeljeansblau",
  en: "Dark denim blue",
  nl: "Donker denimblauw",
  fr: "Bleu jean foncé"
}, {
  hex: "#455968",
  code: "250 30 15",
  scope: "Design System Plus",
  de: "Schwarzwaldblau",
  en: "Black Forest blue",
  nl: "Zwarte woud blauw",
  fr: "Bleu Forêt Noire"
}, {
  hex: "#3b5a6e",
  code: "250 30 20",
  scope: "Design System Plus",
  de: "Schwalbenblau",
  en: "Swallow blue",
  nl: "Zwaluw blauw",
  fr: "Bleu hirondelle"
}, {
  hex: "#335b74",
  code: "250 30 25",
  scope: "Design System Plus",
  de: "Marinedunkelblau",
  en: "Navy dark blue",
  nl: "Marine donkerblauw",
  fr: "Bleu marine foncé"
}, {
  hex: "#235b7b",
  code: "250 30 30",
  scope: "Design System Plus",
  de: "Pompejiblau",
  en: "Pompeii blue",
  nl: "Pompeii blauw",
  fr: "Bleu pompéi"
}, {
  hex: "#5e6c77",
  code: "250 40 10",
  scope: "Design System Plus",
  de: "Trekkingblau",
  en: "Trekking blue",
  nl: "Trekking blauw",
  fr: "Bleu trekking"
}, {
  hex: "#556c7d",
  code: "250 40 15",
  scope: "Design System Plus",
  de: "Stahlblaugrau",
  en: "Steel blue grey",
  nl: "Staalblauw-grijs",
  fr: "Gris bleu acier"
}, {
  hex: "#4a6c83",
  code: "250 40 20",
  scope: "Design System Plus",
  de: "Beerenblau",
  en: "Berry blue",
  nl: "Bessenblauw",
  fr: "Bleu baie"
}, {
  hex: "#3f6e8b",
  code: "250 40 25",
  scope: "Design System Plus",
  de: "Leinenblau",
  en: "Linen blue",
  nl: "Linnen blauw",
  fr: "Bleu lin"
}, {
  hex: "#336f93",
  code: "250 40 30",
  scope: "Design System Plus",
  de: "Poolblau",
  en: "Pool blue",
  nl: "Blauw zwembad",
  fr: "Bleu piscine"
}, {
  hex: "#1a6f97",
  code: "250 40 35",
  scope: "Design System Plus",
  de: "Eisvogelblau",
  en: "Kingfisher blue",
  nl: "IJsvogel blauw",
  fr: "Bleu martin-pêcheur"
}, {
  hex: "#00719c",
  code: "250 40 40",
  scope: "Design System Plus",
  de: "Europablau",
  en: "Europe blue",
  nl: "Europees blauw",
  fr: "Bleu Europe"
}, {
  hex: "#72818d",
  code: "250 50 10",
  scope: "Design System Plus",
  de: "Metallgrau",
  en: "Metal grey",
  nl: "Metaalgrijs",
  fr: "Gris métal"
}, {
  hex: "#688194",
  code: "250 50 15",
  scope: "Design System Plus",
  de: "Titanblau",
  en: "Titanium blue",
  nl: "Titaanblauw",
  fr: "Bleu titane"
}, {
  hex: "#60839b",
  code: "250 50 20",
  scope: "Design System Plus",
  de: "Mallorcablau",
  en: "Mallorca blue",
  nl: "Mallorca blauw",
  fr: "Mallorcablau"
}, {
  hex: "#5583a3",
  code: "250 50 25",
  scope: "Design System Plus",
  de: "Linoleumblau",
  en: "Linoleum blue",
  nl: "Linoleum blauw",
  fr: "Bleu linoléum"
}, {
  hex: "#4684ab",
  code: "250 50 30",
  scope: "Design System Plus",
  de: "Prominentblau",
  en: "Prominent blue",
  nl: "Prominent blauw",
  fr: "Bleu proéminent"
}, {
  hex: "#3386b2",
  code: "250 50 35",
  scope: "Design System Plus",
  de: "Türkischblau",
  en: "Turkish blue",
  nl: "Turks blauw",
  fr: "Bleu turquoise"
}, {
  hex: "#0487b9",
  code: "250 50 40",
  scope: "Design System Plus",
  de: "Urblau",
  en: "Primal blue",
  nl: "Primair blauw",
  fr: "Urblau"
}, {
  hex: "#8798a5",
  code: "250 60 10",
  scope: "Design System Plus",
  de: "Vogelblaugrau",
  en: "Bird blue grey",
  nl: "Vogel blauw-grijs",
  fr: "Gris bleu oiseau"
}, {
  hex: "#7f99ad",
  code: "250 60 15",
  scope: "Design System Plus",
  de: "Sanftblau",
  en: "Gentle blue",
  nl: "Zacht blauw",
  fr: "Bleu doux"
}, {
  hex: "#749ab4",
  code: "250 60 20",
  scope: "Design System Plus",
  de: "Aragonitblau",
  en: "Aragonite blue",
  nl: "Aragoniet blauw",
  fr: "Bleu aragonite"
}, {
  hex: "#699bbc",
  code: "250 60 25",
  scope: "Design System Plus",
  de: "Perlblau",
  en: "Pearl blue",
  nl: "Parelblauw",
  fr: "Bleu perle"
}, {
  hex: "#5c9dc3",
  code: "250 60 30",
  scope: "Design System Plus",
  de: "Topasblau",
  en: "Topaz blue",
  nl: "Topaas blauw",
  fr: "Bleu topaze"
}, {
  hex: "#4d9dca",
  code: "250 60 35",
  scope: "Design System Plus",
  de: "Stratosblau",
  en: "Stratos blue",
  nl: "Stratos blauw",
  fr: "Bleu stratos"
}, {
  hex: "#3a9fd3",
  code: "250 60 40",
  scope: "Design System Plus",
  de: "Bauwerkblau",
  en: "Structural blue",
  nl: "Blauw gebouw",
  fr: "Bleu de chantier"
}, {
  hex: "#9fb2be",
  code: "250 70 10",
  scope: "Design System Plus",
  de: "Nebelblau",
  en: "Foggy blue",
  nl: "Mistig blauw",
  fr: "Bleu brume"
}, {
  hex: "#97b3c7",
  code: "250 70 15",
  scope: "Design System Plus",
  de: "Kreideblau",
  en: "Chalk blue",
  nl: "Krijtblauw",
  fr: "Bleu craie"
}, {
  hex: "#8cb3ce",
  code: "250 70 20",
  scope: "Design System Plus",
  de: "Mittelblau",
  en: "Medium blue",
  nl: "Medium blauw",
  fr: "Bleu moyen"
}, {
  hex: "#82b5d5",
  code: "250 70 25",
  scope: "Design System Plus",
  de: "Wiesenblütenblau",
  en: "Meadow blossom blue",
  nl: "Weidebloesem blauw",
  fr: "Bleu fleur des champs"
}, {
  hex: "#75b5dc",
  code: "250 70 30",
  scope: "Design System Plus",
  de: "Ginsterfalterblau",
  en: "Broom butterfly blue",
  nl: "Bezem vlinder blauw",
  fr: "Bleu papillon de genêt"
}, {
  hex: "#b9cbd8",
  code: "250 80 10",
  scope: "Design System Plus",
  de: "Hellcyan",
  en: "Light cyan",
  nl: "Hellcyan",
  fr: "Hellcyan"
}, {
  hex: "#b2cee0",
  code: "250 80 15",
  scope: "Design System Plus",
  de: "Himalayablau",
  en: "Himalaya blue",
  nl: "Himalaya blauw",
  fr: "Bleu Himalaya"
}, {
  hex: "#a4cbe5",
  code: "250 80 20",
  scope: "Design System Plus",
  de: "Samtblau",
  en: "Velvet blue",
  nl: "Fluweelblauw",
  fr: "Bleu velours"
}, {
  hex: "#ccd4da",
  code: "250 85 05",
  scope: "Design System Plus",
  de: "Weißblau",
  en: "White blue",
  nl: "Witblauw",
  fr: "Bleu blanc"
}, {
  hex: "#c2d5e2",
  code: "250 85 10",
  scope: "Design System Plus",
  de: "Waschmittelbleu",
  en: "Washing powder soft blue",
  nl: "Wasmiddel lood",
  fr: "Bleu de lessive"
}, {
  hex: "#bcd8ea",
  code: "250 85 15",
  scope: "Design System Plus",
  de: "Diamantbleu",
  en: "Diamond soft blue",
  nl: "Diamantlood",
  fr: "Bleu diamant"
}, {
  hex: "#dbe3e7",
  code: "250 90 05",
  scope: "Design System Plus",
  de: "Eisweiß",
  en: "Ice white",
  nl: "Ijs wit",
  fr: "Blanc glacé"
}, {
  hex: "#474a4e",
  code: "260 20 05",
  scope: "Design System Plus",
  de: "Blauschwarz",
  en: "Blue-black",
  nl: "Blauw-zwart",
  fr: "Bleu-noir"
}, {
  hex: "#424952",
  code: "260 20 10",
  scope: "Design System Plus",
  de: "Natoblau",
  en: "Nato blue",
  nl: "Natuurlijk blauw",
  fr: "Bleu nato"
}, {
  hex: "#3b4856",
  code: "260 20 15",
  scope: "Design System Plus",
  de: "Anzugblau",
  en: "Suit blue",
  nl: "Pak blauw",
  fr: "Bleu de costume"
}, {
  hex: "#384a5c",
  code: "260 20 20",
  scope: "Design System Plus",
  de: "Halitblau",
  en: "Halite blue",
  nl: "Haliet blauw",
  fr: "Bleu halite"
}, {
  hex: "#54595e",
  code: "260 30 05",
  scope: "Design System Plus",
  de: "Bergentengrau",
  en: "Alpine duck grey",
  nl: "Bergeend grijs",
  fr: "Gris canard des montagnes"
}, {
  hex: "#505a65",
  code: "260 30 10",
  scope: "Design System Plus",
  de: "Bronzeblau",
  en: "Bronze blue",
  nl: "Bronsblauw",
  fr: "Bleu bronze"
}, {
  hex: "#4a596a",
  code: "260 30 15",
  scope: "Design System Plus",
  de: "Berlinerblau",
  en: "Berlin blue",
  nl: "Berlijn blauw",
  fr: "Bleu berlinois"
}, {
  hex: "#445a70",
  code: "260 30 20",
  scope: "Design System Plus",
  de: "Frankreichblau",
  en: "French blue",
  nl: "Frankrijk blauw",
  fr: "Bleu France"
}, {
  hex: "#3a5a75",
  code: "260 30 25",
  scope: "Design System Plus",
  de: "Tansanitblau",
  en: "Tanzanite blue",
  nl: "Tanzaniet blauw",
  fr: "Bleu tanzanite"
}, {
  hex: "#345b7d",
  code: "260 30 30",
  scope: "Design System Plus",
  de: "Opalblau",
  en: "Opal blue",
  nl: "Opaalblauw",
  fr: "Bleu opale"
}, {
  hex: "#1e5b85",
  code: "260 30 35",
  scope: "Design System Plus",
  de: "Königsblau",
  en: "Royal blue",
  nl: "Koningsblauw",
  fr: "Bleu roi"
}, {
  hex: "#666a70",
  code: "260 40 05",
  scope: "Design System Plus",
  de: "Schwedenblau",
  en: "Swedish blue",
  nl: "Zweeds blauw",
  fr: "Bleu suédois"
}, {
  hex: "#626d79",
  code: "260 40 10",
  scope: "Design System Plus",
  de: "Schotenblau",
  en: "Sheet blue",
  nl: "Pod blauw",
  fr: "Bleu cosse"
}, {
  hex: "#5c6d80",
  code: "260 40 15",
  scope: "Design System Plus",
  de: "Zwetschgenblau",
  en: "Plum blue",
  nl: "Pruim blauw",
  fr: "Bleu quetsche"
}, {
  hex: "#526c85",
  code: "260 40 20",
  scope: "Design System Plus",
  de: "Kadettblau",
  en: "Cadet blue",
  nl: "Cadet blauw",
  fr: "Bleu cadet"
}, {
  hex: "#4b6e8c",
  code: "260 40 25",
  scope: "Design System Plus",
  de: "Emailleblau",
  en: "Enamel blue",
  nl: "Emaille blauw",
  fr: "Bleu émail"
}, {
  hex: "#426e92",
  code: "260 40 30",
  scope: "Design System Plus",
  de: "Kopenhagenerblau",
  en: "Copenhagen blue",
  nl: "Kopenhagen blauw",
  fr: "Bleu Copenhague"
}, {
  hex: "#356e99",
  code: "260 40 35",
  scope: "Design System Plus",
  de: "Bauhausblau",
  en: "Bauhaus blue",
  nl: "Bauhaus blauw",
  fr: "Bleu Bauhaus"
}, {
  hex: "#1e70a3",
  code: "260 40 40",
  scope: "Design System Plus",
  de: "Marineblau",
  en: "Navy blue",
  nl: "Marineblauw",
  fr: "Bleu marine"
}, {
  hex: "#0070a9",
  code: "260 40 45",
  scope: "Design System Plus",
  de: "LEDblau",
  en: "LED blue",
  nl: "LED blauw",
  fr: "LED bleu"
}, {
  hex: "#797e85",
  code: "260 50 05",
  scope: "Design System Plus",
  de: "Spitzbergenblau",
  en: "Spitsbergen blue",
  nl: "Spitsbergen blauw",
  fr: "Bleu Spitzberg"
}, {
  hex: "#75808d",
  code: "260 50 10",
  scope: "Design System Plus",
  de: "Zypressengraublau",
  en: "Cypress grey blue",
  nl: "Cypres grijs blauw",
  fr: "Bleu gris cyprès"
}, {
  hex: "#6e8194",
  code: "260 50 15",
  scope: "Design System Plus",
  de: "Mahonienbeerenblau",
  en: "Mahonia berry blue",
  nl: "Mahonia bessenblauw",
  fr: "Bleu mahonia"
}, {
  hex: "#6a849d",
  code: "260 50 20",
  scope: "Design System Plus",
  de: "Kröpperblau",
  en: "Doves blue",
  nl: "Kröpper blauw",
  fr: "Bleu kröpper"
}, {
  hex: "#6084a6",
  code: "260 50 25",
  scope: "Design System Plus",
  de: "Biedermeierblau",
  en: "Biedermeier blue",
  nl: "Biedermeier blauw",
  fr: "Bleu Biedermeier"
}, {
  hex: "#5485af",
  code: "260 50 30",
  scope: "Design System Plus",
  de: "Pekingblau",
  en: "Beijing blue",
  nl: "Peking blauw",
  fr: "Bleu pékin"
}, {
  hex: "#4784b3",
  code: "260 50 35",
  scope: "Design System Plus",
  de: "Vermeerblau",
  en: "Vermeer blue",
  nl: "Vermeer blauw",
  fr: "Bleu Vermeer"
}, {
  hex: "#3586bd",
  code: "260 50 40",
  scope: "Design System Plus",
  de: "Porzellanblau",
  en: "Meissen blue",
  nl: "Porseleinblauw",
  fr: "Bleu porcelaine"
}, {
  hex: "#91979e",
  code: "260 60 05",
  scope: "Design System Plus",
  de: "Seehundgrau",
  en: "Seal grey",
  nl: "Seal grijs",
  fr: "Gris phoque"
}, {
  hex: "#8b97a5",
  code: "260 60 10",
  scope: "Design System Plus",
  de: "Diopsidblau",
  en: "Diopside blue",
  nl: "Diopside blauw",
  fr: "Bleu diopside"
}, {
  hex: "#879bb0",
  code: "260 60 15",
  scope: "Design System Plus",
  de: "Nordlandblau",
  en: "Nordland blue",
  nl: "Nordland blauw",
  fr: "Bleu du Nord"
}, {
  hex: "#7e9ab5",
  code: "260 60 20",
  scope: "Design System Plus",
  de: "Moorbeerenblau",
  en: "Cranberry blue",
  nl: "Moorbes blauw",
  fr: "Bleu canneberge"
}, {
  hex: "#759bbe",
  code: "260 60 25",
  scope: "Design System Plus",
  de: "Lupinenblau",
  en: "Lupine blue",
  nl: "Lupine blauw",
  fr: "Bleu lupin"
}, {
  hex: "#6b9cc6",
  code: "260 60 30",
  scope: "Design System Plus",
  de: "Sadebeerenbleu",
  en: "Blueberry soft blue",
  nl: "Sadeberry lood",
  fr: "Plomb aux baies de Sade"
}, {
  hex: "#5f9dcd",
  code: "260 60 35",
  scope: "Design System Plus",
  de: "Leuchtendblau",
  en: "Brilliant blue",
  nl: "Helderblauw",
  fr: "Bleu vif"
}, {
  hex: "#abb1b8",
  code: "260 70 05",
  scope: "Design System Plus",
  de: "Nordlichtgrau",
  en: "Northern light grey",
  nl: "Noorderlicht grijs",
  fr: "Gris lumière du nord"
}, {
  hex: "#a5b2c0",
  code: "260 70 10",
  scope: "Design System Plus",
  de: "Sturmvogelblaugrau",
  en: "Petrel blue grey",
  nl: "Stormvogel blauwgrijs",
  fr: "Gris-bleu tempête"
}, {
  hex: "#9cb2c8",
  code: "260 70 15",
  scope: "Design System Plus",
  de: "Nordlandhellblau",
  en: "Nordland light blue",
  nl: "Nordland lichtblauw",
  fr: "Bleu clair du Nordland"
}, {
  hex: "#96b4d0",
  code: "260 70 20",
  scope: "Design System Plus",
  de: "Mattblau",
  en: "Matte blue",
  nl: "Matblauw",
  fr: "Bleu mat"
}, {
  hex: "#8cb4d8",
  code: "260 70 25",
  scope: "Design System Plus",
  de: "Pazifikblau",
  en: "Pacific blue",
  nl: "Pacifisch blauw",
  fr: "Bleu pacifique"
}, {
  hex: "#c3cad1",
  code: "260 80 05",
  scope: "Design System Plus",
  de: "Lichtblaugrau",
  en: "Light blue grey",
  nl: "Licht blauw-grijs",
  fr: "Gris bleu clair"
}, {
  hex: "#bdcbd9",
  code: "260 80 10",
  scope: "Design System Plus",
  de: "Puderbleu",
  en: "Powder soft blue",
  nl: "Poederlood",
  fr: "Plomb en poudre"
}, {
  hex: "#b5cce0",
  code: "260 80 15",
  scope: "Design System Plus",
  de: "Windblau",
  en: "Wind blue",
  nl: "Wind blauw",
  fr: "Bleu vent"
}, {
  hex: "#cdd3d9",
  code: "260 85 05",
  scope: "Design System Plus",
  de: "Satinweiß",
  en: "Satin white",
  nl: "Satijn wit",
  fr: "Blanc satiné"
}, {
  hex: "#c8d7e5",
  code: "260 85 10",
  scope: "Design System Plus",
  de: "Meeresbrisengrün",
  en: "Sea breeze green",
  nl: "Zeewind groen",
  fr: "Vert cassis de mer"
}, {
  hex: "#dde3e7",
  code: "260 90 05",
  scope: "Design System Plus",
  de: "Milchblau",
  en: "Milk blue",
  nl: "Melkblauw",
  fr: "Bleu lait"
}, {
  hex: "#3a475c",
  code: "270 20 20",
  scope: "Design System Plus",
  de: "Krähenschwarzblau",
  en: "Crow black blue",
  nl: "Kraai zwart blauw",
  fr: "Bleu noir corbeau"
}, {
  hex: "#344660",
  code: "270 20 25",
  scope: "Design System Plus",
  de: "Indigoschwarz",
  en: "Indigo black",
  nl: "Indigo zwart",
  fr: "Noir indigo"
}, {
  hex: "#2e4667",
  code: "270 20 29",
  scope: "Design System Plus",
  de: "Kraftblau",
  en: "Effervescent blue",
  nl: "Blauw vermogen",
  fr: "Bleu kraft"
}, {
  hex: "#4c5768",
  code: "270 30 15",
  scope: "Design System Plus",
  de: "Mitternachtsblau",
  en: "Midnight blue",
  nl: "Middernachtblauw",
  fr: "Bleu minuit"
}, {
  hex: "#47576f",
  code: "270 30 20",
  scope: "Design System Plus",
  de: "Dunkelblau",
  en: "Dark blue",
  nl: "Donkerblauw",
  fr: "Bleu foncé"
}, {
  hex: "#415776",
  code: "270 30 25",
  scope: "Design System Plus",
  de: "Traubenblau",
  en: "Grape blue",
  nl: "Druifblauw",
  fr: "Bleu raisin"
}, {
  hex: "#39567c",
  code: "270 30 30",
  scope: "Design System Plus",
  de: "Mediciblau",
  en: "Medici blue",
  nl: "Medici blauw",
  fr: "Bleu medici"
}, {
  hex: "#2f5682",
  code: "270 30 35",
  scope: "Design System Plus",
  de: "Kolibriblau",
  en: "Kolibri blue",
  nl: "Kolibrie blauw",
  fr: "Bleu colibri"
}, {
  hex: "#1f568a",
  code: "270 30 40",
  scope: "Design System Plus",
  de: "Prinzenblau",
  en: "Prince blue",
  nl: "Prins blauw",
  fr: "Bleu prince"
}, {
  hex: "#5f6b7f",
  code: "270 40 15",
  scope: "Design System Plus",
  de: "Zinngrau",
  en: "Pewter grey",
  nl: "Tinnen grijs",
  fr: "Gris étain"
}, {
  hex: "#576a85",
  code: "270 40 20",
  scope: "Design System Plus",
  de: "Salonblau",
  en: "Parlour blue",
  nl: "Salon blauw",
  fr: "Bleu salon"
}, {
  hex: "#536b8d",
  code: "270 40 25",
  scope: "Design System Plus",
  de: "Funktionsblau",
  en: "Functional blue",
  nl: "Functioneel blauw",
  fr: "Bleu fonctionnel"
}, {
  hex: "#4a6a94",
  code: "270 40 30",
  scope: "Design System Plus",
  de: "Schminkblau",
  en: "Make-up blue",
  nl: "Make-up blauw",
  fr: "Bleu maquillage"
}, {
  hex: "#406a9b",
  code: "270 40 35",
  scope: "Design System Plus",
  de: "Lapislazuliblau",
  en: "Lapis lazuli blue",
  nl: "Lapis lazuli blauw",
  fr: "Bleu lapis-lazuli"
}, {
  hex: "#3469a2",
  code: "270 40 40",
  scope: "Design System Plus",
  de: "Zauberblau",
  en: "Magic blue",
  nl: "Magisch blauw",
  fr: "Bleu magique"
}, {
  hex: "#77808f",
  code: "270 50 10",
  scope: "Design System Plus",
  de: "Brokatblau",
  en: "Brocade blue",
  nl: "Brokaatblauw",
  fr: "Bleu brocart"
}, {
  hex: "#738197",
  code: "270 50 15",
  scope: "Design System Plus",
  de: "Edelblau",
  en: "Noble blue",
  nl: "Edel blauw",
  fr: "Bleu précieux"
}, {
  hex: "#6d819e",
  code: "270 50 20",
  scope: "Design System Plus",
  de: "Delfterblau",
  en: "Delft blue",
  nl: "Delfts blauw",
  fr: "Bleu Delft"
}, {
  hex: "#6780a6",
  code: "270 50 25",
  scope: "Design System Plus",
  de: "Cocktailblau",
  en: "Cocktail blue",
  nl: "Cocktail blauw",
  fr: "Bleu cocktail"
}, {
  hex: "#5e80ad",
  code: "270 50 30",
  scope: "Design System Plus",
  de: "Salbeiblütenblau",
  en: "Sage blossom blue",
  nl: "Saliebloesem blauw",
  fr: "Bleu fleur de sauge"
}, {
  hex: "#557fb2",
  code: "270 50 35",
  scope: "Design System Plus",
  de: "Wienerblau",
  en: "Viennese blue",
  nl: "Wenen blauw",
  fr: "Bleu viennois"
}, {
  hex: "#4a81bd",
  code: "270 50 40",
  scope: "Design System Plus",
  de: "Kornblumenblau",
  en: "Cornflower blue",
  nl: "Korenbloemblauw",
  fr: "Bleu bleuet"
}, {
  hex: "#8c97a7",
  code: "270 60 10",
  scope: "Design System Plus",
  de: "Fantasiegrau",
  en: "Fantasy grey",
  nl: "Fantasie grijs",
  fr: "Gris fantaisie"
}, {
  hex: "#8998b0",
  code: "270 60 15",
  scope: "Design System Plus",
  de: "Fliederblau",
  en: "Lilac blue",
  nl: "Lila blauw",
  fr: "Bleu lilas"
}, {
  hex: "#8398b7",
  code: "270 60 20",
  scope: "Design System Plus",
  de: "Lavendelblau",
  en: "Lavender blue",
  nl: "Lavendelblauw",
  fr: "Bleu lavande"
}, {
  hex: "#7d98bf",
  code: "270 60 25",
  scope: "Design System Plus",
  de: "Ritterspornblau",
  en: "Delphinium blue",
  nl: "Ridderspoor blauw",
  fr: "Bleu éperon d'or"
}, {
  hex: "#7699c8",
  code: "270 60 30",
  scope: "Design System Plus",
  de: "Lidschattenblau",
  en: "Eyeshadow blue",
  nl: "Oogschaduw blauw",
  fr: "Bleu de l'ombre à paupières"
}, {
  hex: "#6b97ce",
  code: "270 60 35",
  scope: "Design System Plus",
  de: "Argusfalterblau",
  en: "Butterfly blue",
  nl: "Argus vlinder blauw",
  fr: "Bleu arguspapillon"
}, {
  hex: "#a7b1c1",
  code: "270 70 10",
  scope: "Design System Plus",
  de: "Federbleu",
  en: "Feather soft blue",
  nl: "Voorjaarslood",
  fr: "Plomb pour ressort"
}, {
  hex: "#a1b1c9",
  code: "270 70 15",
  scope: "Design System Plus",
  de: "Satinbleu",
  en: "Satin soft blue",
  nl: "Satijnlood",
  fr: "Bleu satin"
}, {
  hex: "#9cb2d2",
  code: "270 70 20",
  scope: "Design System Plus",
  de: "Engelblau",
  en: "Angel blue",
  nl: "Engelenblauw",
  fr: "Bleu ange"
}, {
  hex: "#93afd8",
  code: "270 70 25",
  scope: "Design System Plus",
  de: "Knabenblau",
  en: "Boy blue",
  nl: "Blauw voor jongens",
  fr: "Bleu garçon"
}, {
  hex: "#c1cad9",
  code: "270 80 10",
  scope: "Design System Plus",
  de: "Perlhellbleu",
  en: "Light pearl soft blue",
  nl: "Parel lichtsnoer",
  fr: "Bleu perle clair"
}, {
  hex: "#b9c9e1",
  code: "270 80 15",
  scope: "Design System Plus",
  de: "Retinableu",
  en: "Retina soft blue",
  nl: "Retinableu",
  fr: "Retinableu"
}, {
  hex: "#d1d4da",
  code: "270 85 05",
  scope: "Design System Plus",
  de: "Engelshaarsilber",
  en: "Angel hair silver",
  nl: "Engelenhaar zilver",
  fr: "Cheveux d'ange argentés"
}, {
  hex: "#cad4e4",
  code: "270 85 10",
  scope: "Design System Plus",
  de: "Perlmuttsilber",
  en: "Mother-of-pearl silver",
  nl: "Parelmoer zilver",
  fr: "Argent nacré"
}, {
  hex: "#c4d4ec",
  code: "270 85 15",
  scope: "Design System Plus",
  de: "Muranobleu",
  en: "Murano soft blue",
  nl: "Muranobleu",
  fr: "Muranobleu"
}, {
  hex: "#e0e3e8",
  code: "270 90 05",
  scope: "Design System Plus",
  de: "Bleichweiß",
  en: "Bleached white",
  nl: "Licht wit",
  fr: "Blanc pâle"
}, {
  hex: "#4a4a4e",
  code: "280 20 05",
  scope: "Design System Plus",
  de: "Granitschwarz",
  en: "Granite black",
  nl: "Graniet zwart",
  fr: "Noir granit"
}, {
  hex: "#474a53",
  code: "280 20 10",
  scope: "Design System Plus",
  de: "Diamantschwarz",
  en: "Diamond black",
  nl: "Diamant zwart",
  fr: "Noir diamant"
}, {
  hex: "#444958",
  code: "280 20 15",
  scope: "Design System Plus",
  de: "Krähenschwarz",
  en: "Crow black",
  nl: "Kraai zwart",
  fr: "Noir corbeau"
}, {
  hex: "#41485b",
  code: "280 20 20",
  scope: "Design System Plus",
  de: "Manganschwarz",
  en: "Manganese black",
  nl: "Mangaan zwart",
  fr: "Noir de manganèse"
}, {
  hex: "#3f4862",
  code: "280 20 25",
  scope: "Design System Plus",
  de: "Elitenblau",
  en: "Elite blue",
  nl: "Elite blauw",
  fr: "Bleu élite"
}, {
  hex: "#3a4868",
  code: "280 20 30",
  scope: "Design System Plus",
  de: "Ambassadorblau",
  en: "Ambassador blue",
  nl: "Ambassadeur blauw",
  fr: "Bleu ambassador"
}, {
  hex: "#57585d",
  code: "280 30 05",
  scope: "Design System Plus",
  de: "Smokingnachtblau",
  en: "Smoking night blue",
  nl: "Dinerjas nachtblauw",
  fr: "Bleu nuit smoking"
}, {
  hex: "#555965",
  code: "280 30 10",
  scope: "Design System Plus",
  de: "Meteoritschwarzblau",
  en: "Meteorite black blue",
  nl: "Meteoriet zwart blauw",
  fr: "Bleu météorite noir"
}, {
  hex: "#52596b",
  code: "280 30 15",
  scope: "Design System Plus",
  de: "Kohlesteinblau",
  en: "Anthracite blue",
  nl: "Houtskoolblauw",
  fr: "Bleu pierre de charbon"
}, {
  hex: "#4f5972",
  code: "280 30 20",
  scope: "Design System Plus",
  de: "Granatsteinblau",
  en: "Garnet stone blue",
  nl: "Granaatsteen blauw",
  fr: "Bleu pierre de grenat"
}, {
  hex: "#4c5977",
  code: "280 30 25",
  scope: "Design System Plus",
  de: "Wasserstoffblau",
  en: "Hydrogen blue",
  nl: "Waterstof blauw",
  fr: "Bleu hydrogène"
}, {
  hex: "#45577e",
  code: "280 30 30",
  scope: "Design System Plus",
  de: "Tiefblau",
  en: "Deep blue",
  nl: "Diepblauw",
  fr: "Bleu profond"
}, {
  hex: "#425783",
  code: "280 30 35",
  scope: "Design System Plus",
  de: "Theaterblau",
  en: "Theatre blue",
  nl: "Theater blauw",
  fr: "Bleu théâtre"
}, {
  hex: "#3d588a",
  code: "280 30 40",
  scope: "Design System Plus",
  de: "Plakatblau",
  en: "Poster blue",
  nl: "Poster blauw",
  fr: "Bleu affiche"
}, {
  hex: "#696b71",
  code: "280 40 05",
  scope: "Design System Plus",
  de: "Galeriegrau",
  en: "Gallery grey",
  nl: "Galerij grijs",
  fr: "Gris galerie"
}, {
  hex: "#666a78",
  code: "280 40 10",
  scope: "Design System Plus",
  de: "Wildlederindigo",
  en: "Suede indigo",
  nl: "Suède indigo",
  fr: "Indigo en daim"
}, {
  hex: "#636a7f",
  code: "280 40 15",
  scope: "Design System Plus",
  de: "Dunkellavendel",
  en: "Dark lavender",
  nl: "Donker lavendel",
  fr: "Lavande sombre"
}, {
  hex: "#5f6a86",
  code: "280 40 20",
  scope: "Design System Plus",
  de: "Sternenhimmelblau",
  en: "Starry sky blue",
  nl: "Hemelsblauw",
  fr: "Bleu ciel étoilé"
}, {
  hex: "#5d6b8e",
  code: "280 40 25",
  scope: "Design System Plus",
  de: "Indigomarineblau",
  en: "Indigo navy blue",
  nl: "Indigo blauw",
  fr: "Bleu indigo"
}, {
  hex: "#586a94",
  code: "280 40 30",
  scope: "Design System Plus",
  de: "Abendblau",
  en: "Evening blue",
  nl: "Avondblauw",
  fr: "Bleu soir"
}, {
  hex: "#526b9b",
  code: "280 40 35",
  scope: "Design System Plus",
  de: "Portugalblau",
  en: "Portuguese blue",
  nl: "Portugal blauw",
  fr: "Bleu Portugal"
}, {
  hex: "#4a6aa3",
  code: "280 40 40",
  scope: "Design System Plus",
  de: "Neptunblau",
  en: "Neptune blue",
  nl: "Neptunus blauw",
  fr: "Bleu neptune"
}, {
  hex: "#4169aa",
  code: "280 40 45",
  scope: "Design System Plus",
  de: "Hyazinthenblau",
  en: "Hyacinth blue",
  nl: "Hyacint blauw",
  fr: "Bleu jacinthe"
}, {
  hex: "#7d8087",
  code: "280 50 05",
  scope: "Design System Plus",
  de: "Nobelgrau",
  en: "Noble grey",
  nl: "Edel grijs",
  fr: "Gris Nobel"
}, {
  hex: "#7b808f",
  code: "280 50 10",
  scope: "Design System Plus",
  de: "Eisblaugrau",
  en: "Ice blue grey",
  nl: "IJsblauw grijs",
  fr: "Gris bleu glacé"
}, {
  hex: "#788096",
  code: "280 50 15",
  scope: "Design System Plus",
  de: "Granitblau",
  en: "Granite blue",
  nl: "Granietblauw",
  fr: "Bleu granit"
}, {
  hex: "#747f9e",
  code: "280 50 20",
  scope: "Design System Plus",
  de: "Lavendellila",
  en: "Lavender mauve",
  nl: "Lavendelpaars",
  fr: "Violet lavande"
}, {
  hex: "#717fa5",
  code: "280 50 25",
  scope: "Design System Plus",
  de: "Kostümblau",
  en: "Costume blue",
  nl: "Kostuum blauw",
  fr: "Bleu de costume"
}, {
  hex: "#6c7fad",
  code: "280 50 30",
  scope: "Design System Plus",
  de: "Helllila",
  en: "Light mauve",
  nl: "Licht lila",
  fr: "Violet clair"
}, {
  hex: "#667eb3",
  code: "280 50 35",
  scope: "Design System Plus",
  de: "Saphirschimmerblau",
  en: "Sapphire shimmer blue",
  nl: "Saffierglans blauw",
  fr: "Bleu saphir scintillant"
}, {
  hex: "#6180be",
  code: "280 50 40",
  scope: "Design System Plus",
  de: "Divenviolett",
  en: "Diva violet",
  nl: "Diva violet",
  fr: "Violet de diva"
}, {
  hex: "#94979e",
  code: "280 60 05",
  scope: "Design System Plus",
  de: "Tüllgrau",
  en: "Tulle grey",
  nl: "Tule grijs",
  fr: "Gris tulle"
}, {
  hex: "#9196a6",
  code: "280 60 10",
  scope: "Design System Plus",
  de: "Süßlavendel",
  en: "Sweet lavender",
  nl: "Zoete lavendel",
  fr: "Lavande douce"
}, {
  hex: "#8e96ae",
  code: "280 60 15",
  scope: "Design System Plus",
  de: "Marmorblau",
  en: "Marble blue",
  nl: "Marmerblauw",
  fr: "Bleu marbré"
}, {
  hex: "#8b96b7",
  code: "280 60 20",
  scope: "Design System Plus",
  de: "Nebelviolett",
  en: "Misty violet",
  nl: "Mist violet",
  fr: "Violet brumeux"
}, {
  hex: "#8695be",
  code: "280 60 25",
  scope: "Design System Plus",
  de: "Opalviolett",
  en: "Opal violet",
  nl: "Opaal violet",
  fr: "Violet opalin"
}, {
  hex: "#8296c5",
  code: "280 60 30",
  scope: "Design System Plus",
  de: "Persischviolett",
  en: "Persian violet",
  nl: "Perzisch viooltje",
  fr: "Violet persan"
}, {
  hex: "#7e97cf",
  code: "280 60 35",
  scope: "Design System Plus",
  de: "Organzaviolett",
  en: "Organza violet",
  nl: "Organza violet",
  fr: "Violet d'organza"
}, {
  hex: "#acaeb6",
  code: "280 70 05",
  scope: "Design System Plus",
  de: "Taupegrau",
  en: "Taupe grey",
  nl: "Taupegrijs",
  fr: "Gris taupe"
}, {
  hex: "#abb0bf",
  code: "280 70 10",
  scope: "Design System Plus",
  de: "Tüllviolett",
  en: "Tulle violet",
  nl: "Tule violet",
  fr: "Violet de tulle"
}, {
  hex: "#a8b0c8",
  code: "280 70 15",
  scope: "Design System Plus",
  de: "Sandglöckchenviola",
  en: "Foxflower viola",
  nl: "Zandloper altviool",
  fr: "Viola sablonneuse"
}, {
  hex: "#a3afd1",
  code: "280 70 20",
  scope: "Design System Plus",
  de: "Fliederduftbleu",
  en: "Lilac scent soft blue",
  nl: "Lila geparfumeerd lood",
  fr: "Bleu de parfum de lilas"
}, {
  hex: "#a1b0da",
  code: "280 70 25",
  scope: "Design System Plus",
  de: "Asterblütenblau",
  en: "Aster flower blue",
  nl: "Asterbloem blauw",
  fr: "Bleu fleur d'aster"
}, {
  hex: "#c8cad1",
  code: "280 80 05",
  scope: "Design System Plus",
  de: "Violaeisgrau",
  en: "Viola ice grey",
  nl: "Viool ijsgrijs",
  fr: "Gris violet"
}, {
  hex: "#c4c9d9",
  code: "280 80 10",
  scope: "Design System Plus",
  de: "Hyazinthenweißbleu",
  en: "Hyacinth white soft blue",
  nl: "Hyacint wit lood",
  fr: "Bleu blanc jacinthe"
}, {
  hex: "#bfc8e0",
  code: "280 80 15",
  scope: "Design System Plus",
  de: "Veilchenduftbleu",
  en: "Violet scent soft blue",
  nl: "Bleu met viooltjesgeur",
  fr: "Bleu de parfum de violette"
}, {
  hex: "#d2d5db",
  code: "280 85 05",
  scope: "Design System Plus",
  de: "Kieselbleuweiß",
  en: "Pebble soft blue white",
  nl: "Kiezel lood wit",
  fr: "Blanc plomb galet"
}, {
  hex: "#cdd4e4",
  code: "280 85 10",
  scope: "Design System Plus",
  de: "Schmuckweiß",
  en: "Jewellery white",
  nl: "Juwelen wit",
  fr: "Blanc éclatant"
}, {
  hex: "#e0e3e8",
  code: "280 90 05",
  scope: "Design System Plus",
  de: "Lilaweiß",
  en: "Mauve white",
  nl: "Paars wit",
  fr: "Blanc lilas"
}, {
  hex: "#e8eaf0",
  code: "280 93 05",
  scope: "Design System Plus",
  de: "Porzellanweiß",
  en: "Porcelain white",
  nl: "Porselein wit",
  fr: "Blanc porcelaine"
}, {
  hex: "#454650",
  code: "290 20 10",
  scope: "Design System Plus",
  de: "Spinellsteinschwarz",
  en: "Spinel stone black",
  nl: "Spinelsteen zwart",
  fr: "Noir pierre spinelle"
}, {
  hex: "#474655",
  code: "290 20 15",
  scope: "Design System Plus",
  de: "Schwarzviolett",
  en: "Black violet",
  nl: "Zwart viooltje",
  fr: "Noir violet"
}, {
  hex: "#47485d",
  code: "290 20 20",
  scope: "Design System Plus",
  de: "Tropennachtblau",
  en: "Tropical night blue",
  nl: "Tropisch nachtblauw",
  fr: "Bleu nuit tropical"
}, {
  hex: "#434661",
  code: "290 20 25",
  scope: "Design System Plus",
  de: "Indigoviolett",
  en: "Indigo violet",
  nl: "Indigo violet",
  fr: "Violet indigo"
}, {
  hex: "#404465",
  code: "290 20 30",
  scope: "Design System Plus",
  de: "Ultramarinviolett",
  en: "Ultramarine violet",
  nl: "Ultramarijn violet",
  fr: "Violet outremer"
}, {
  hex: "#3e446c",
  code: "290 20 35",
  scope: "Design System Plus",
  de: "Trollingerblau",
  en: "Schiava blue",
  nl: "Trollinger blauw",
  fr: "Bleu trollinger"
}, {
  hex: "#565562",
  code: "290 30 10",
  scope: "Design System Plus",
  de: "Flintsteinblau",
  en: "Flintstone blue",
  nl: "Vuursteenblauw",
  fr: "Bleu silex"
}, {
  hex: "#555669",
  code: "290 30 15",
  scope: "Design System Plus",
  de: "Spinellschwarz",
  en: "Spinel black",
  nl: "Spinel zwart",
  fr: "Noir spinelle"
}, {
  hex: "#52536d",
  code: "290 30 20",
  scope: "Design System Plus",
  de: "Kirchenblau",
  en: "Church blue",
  nl: "Kerk blauw",
  fr: "Bleu église"
}, {
  hex: "#525475",
  code: "290 30 25",
  scope: "Design System Plus",
  de: "Finsternisblau",
  en: "Gloomy blue",
  nl: "Donkerblauw",
  fr: "Bleu éclipse"
}, {
  hex: "#4f537b",
  code: "290 30 30",
  scope: "Design System Plus",
  de: "Lembergerblau",
  en: "Lviv blue",
  nl: "Lemberger blauw",
  fr: "Bleu Lemberger"
}, {
  hex: "#4d5483",
  code: "290 30 35",
  scope: "Design System Plus",
  de: "Britischlila",
  en: "British mauve",
  nl: "Brits paars",
  fr: "Violet britannique"
}, {
  hex: "#495389",
  code: "290 30 40",
  scope: "Design System Plus",
  de: "Amtsviolett",
  en: "Official violet",
  nl: "Officieel violet",
  fr: "Violet officiel"
}, {
  hex: "#696876",
  code: "290 40 10",
  scope: "Design System Plus",
  de: "Sturmtaucherschwarz",
  en: "Shearwater black",
  nl: "Pijlstormvogel zwart",
  fr: "Noir plongeur de tempête"
}, {
  hex: "#68687d",
  code: "290 40 15",
  scope: "Design System Plus",
  de: "Achatviolett",
  en: "Agate violet",
  nl: "Agaat violet",
  fr: "Violet agate"
}, {
  hex: "#656785",
  code: "290 40 20",
  scope: "Design System Plus",
  de: "Tieflavendel",
  en: "Deep lavender",
  nl: "Diep lavendel",
  fr: "Lavande profonde"
}, {
  hex: "#63658b",
  code: "290 40 25",
  scope: "Design System Plus",
  de: "Dämmerungslila",
  en: "Dusk mauve",
  nl: "Schemerpaars",
  fr: "Violet crépusculaire"
}, {
  hex: "#606592",
  code: "290 40 30",
  scope: "Design System Plus",
  de: "Reichviolett",
  en: "Rich violet",
  nl: "Rijk violet",
  fr: "Violet riche"
}, {
  hex: "#5e6498",
  code: "290 40 35",
  scope: "Design System Plus",
  de: "Zwiebelschalenblau",
  en: "Onion skin blue",
  nl: "Uienschil blauw",
  fr: "Bleu pelure d'oignon"
}, {
  hex: "#5b65a1",
  code: "290 40 40",
  scope: "Design System Plus",
  de: "Schwertlilienblau",
  en: "Iris blue",
  nl: "Iris blauw",
  fr: "Bleu iris"
}, {
  hex: "#5664a7",
  code: "290 40 45",
  scope: "Design System Plus",
  de: "Veilchenblau",
  en: "Violet blue",
  nl: "Violetblauw",
  fr: "Bleu violet"
}, {
  hex: "#7c7c8c",
  code: "290 50 10",
  scope: "Design System Plus",
  de: "Aschlila",
  en: "Ash mauve",
  nl: "Ashlila",
  fr: "Aschlila"
}, {
  hex: "#7b7c92",
  code: "290 50 15",
  scope: "Design System Plus",
  de: "Sturmlila",
  en: "Stormy mauve",
  nl: "Stormpaars",
  fr: "Violet de tempête"
}, {
  hex: "#797a9b",
  code: "290 50 20",
  scope: "Design System Plus",
  de: "Seidenkrepplila",
  en: "Silk crepe mauve",
  nl: "Zijde crêpe paars",
  fr: "Crêpe de soie violet"
}, {
  hex: "#797ba4",
  code: "290 50 25",
  scope: "Design System Plus",
  de: "Hyazinthenlila",
  en: "Hyacinth mauve",
  nl: "Hyacint paars",
  fr: "Mauve jacinthe"
}, {
  hex: "#777aaa",
  code: "290 50 30",
  scope: "Design System Plus",
  de: "Bergblumenlila",
  en: "Mountain flower mauve",
  nl: "Bergbloem paars",
  fr: "Fleurs de montagne violettes"
}, {
  hex: "#7379b2",
  code: "290 50 35",
  scope: "Design System Plus",
  de: "Chalcedonviolett",
  en: "Chalcedony violet",
  nl: "Chalcedoon violet",
  fr: "Violet de calcédoine"
}, {
  hex: "#7079ba",
  code: "290 50 40",
  scope: "Design System Plus",
  de: "Gladiolenblau",
  en: "Gladiola blue",
  nl: "Gladiolen blauw",
  fr: "Bleu glaïeul"
}, {
  hex: "#9293a5",
  code: "290 60 10",
  scope: "Design System Plus",
  de: "Lavendelblütengrau",
  en: "Lavender blossom grey",
  nl: "Lavendelbloesem grijs",
  fr: "Gris fleur de lavande"
}, {
  hex: "#9393ac",
  code: "290 60 15",
  scope: "Design System Plus",
  de: "Grazilviolett",
  en: "Delicate violet",
  nl: "Grijsviolet",
  fr: "Violet gracile"
}, {
  hex: "#8f91b5",
  code: "290 60 20",
  scope: "Design System Plus",
  de: "Opernlila",
  en: "Opera mauve",
  nl: "Opera paars",
  fr: "Violet d'opéra"
}, {
  hex: "#9092bd",
  code: "290 60 25",
  scope: "Design System Plus",
  de: "Bleulavendel",
  en: "Soft blue lavender",
  nl: "Lavendel",
  fr: "Lavande de plomb"
}, {
  hex: "#8d91c4",
  code: "290 60 30",
  scope: "Design System Plus",
  de: "Plisseelila",
  en: "Pleated mauve",
  nl: "Geplooide lelie",
  fr: "Plisseelila"
}, {
  hex: "#888fca",
  code: "290 60 35",
  scope: "Design System Plus",
  de: "Echtlavendel",
  en: "True lavender",
  nl: "Echte lavendel",
  fr: "Lavande vraie"
}, {
  hex: "#adadbf",
  code: "290 70 10",
  scope: "Design System Plus",
  de: "Cremeviolett",
  en: "Cream violet",
  nl: "Crème violet",
  fr: "Violet crème"
}, {
  hex: "#ababc7",
  code: "290 70 15",
  scope: "Design System Plus",
  de: "Glyzinienhellbleu",
  en: "Wisteria light soft blue",
  nl: "Wisteria lichtsnoer",
  fr: "Bleu clair glycine"
}, {
  hex: "#a8abce",
  code: "290 70 20",
  scope: "Design System Plus",
  de: "Blütenlila",
  en: "Blossom mauve",
  nl: "Bloesempaars",
  fr: "Violet de fleur"
}, {
  hex: "#a7aad7",
  code: "290 70 25",
  scope: "Design System Plus",
  de: "Sorbeteislila",
  en: "Sorbet ice mauve",
  nl: "Sorbetijs lila",
  fr: "Violet de sorbetière"
}, {
  hex: "#c6c6d7",
  code: "290 80 10",
  scope: "Design System Plus",
  de: "Tulipanbleu",
  en: "Tulip soft blue",
  nl: "Tulpanbleu",
  fr: "Tulipanbleu"
}, {
  hex: "#c6c6de",
  code: "290 80 15",
  scope: "Design System Plus",
  de: "Blasslila",
  en: "Pale lilac",
  nl: "Lichtpaars",
  fr: "Violet pâle"
}, {
  hex: "#d5d5da",
  code: "290 85 05",
  scope: "Design System Plus",
  de: "Kalklila",
  en: "Limestone mauve",
  nl: "Kalklila",
  fr: "Violet de chaux"
}, {
  hex: "#d0d3e9",
  code: "290 85 10",
  scope: "Design System Plus",
  de: "Orchideenweiß",
  en: "Orchid white",
  nl: "Orchidee wit",
  fr: "Blanc orchidée"
}, {
  hex: "#dadbe0",
  code: "290 90 05",
  scope: "Design System Plus",
  de: "Violettweiß",
  en: "Violet white",
  nl: "Paars wit",
  fr: "Blanc violet"
}, {
  hex: "#e8e9ef",
  code: "290 93 05",
  scope: "Design System Plus",
  de: "Fliederweiß",
  en: "Lilac white",
  nl: "Lila wit",
  fr: "Blanc lilas"
}, {
  hex: "#4b494e",
  code: "300 20 05",
  scope: "Design System Plus",
  de: "Nachtschwarz",
  en: "Night black",
  nl: "Nacht zwart",
  fr: "Noir nuit"
}, {
  hex: "#494650",
  code: "300 20 10",
  scope: "Design System Plus",
  de: "Reiherblau",
  en: "Heron blue",
  nl: "Reiger blauw",
  fr: "Bleu héron"
}, {
  hex: "#494655",
  code: "300 20 15",
  scope: "Design System Plus",
  de: "Violaschwarz",
  en: "Viola black",
  nl: "Viola zwart",
  fr: "Noir viola"
}, {
  hex: "#49455a",
  code: "300 20 20",
  scope: "Design System Plus",
  de: "Brombeerschwarz",
  en: "Blackberry black",
  nl: "Bramen zwart",
  fr: "Noir mûre"
}, {
  hex: "#49445c",
  code: "300 20 25",
  scope: "Design System Plus",
  de: "Kardinallila",
  en: "Cardinal mauve",
  nl: "Kardinaal paars",
  fr: "Violet de cardinal"
}, {
  hex: "#474364",
  code: "300 20 30",
  scope: "Design System Plus",
  de: "Zeremonienpurpur",
  en: "Ceremonial purple",
  nl: "Ceremonieel paars",
  fr: "Pourpre de cérémonie"
}, {
  hex: "#59575d",
  code: "300 30 05",
  scope: "Design System Plus",
  de: "Nachtgrau",
  en: "Night grey",
  nl: "Nacht grijs",
  fr: "Gris nuit"
}, {
  hex: "#585562",
  code: "300 30 10",
  scope: "Design System Plus",
  de: "Trauerviolett",
  en: "Mourning violet",
  nl: "Rouwviooltje",
  fr: "Violet funèbre"
}, {
  hex: "#595466",
  code: "300 30 15",
  scope: "Design System Plus",
  de: "Clubgrau",
  en: "Club grey",
  nl: "Club grijs",
  fr: "Gris club"
}, {
  hex: "#59536c",
  code: "300 30 20",
  scope: "Design System Plus",
  de: "Maulbeerlilaschwarz",
  en: "Mulberry mauve black",
  nl: "Moerbei lila zwart",
  fr: "Noir silver mûrier"
}, {
  hex: "#595272",
  code: "300 30 25",
  scope: "Design System Plus",
  de: "Abendlila",
  en: "Evening mauve",
  nl: "Avondlila",
  fr: "Mauve du soir"
}, {
  hex: "#595278",
  code: "300 30 30",
  scope: "Design System Plus",
  de: "Opernblau",
  en: "Opera blue",
  nl: "Opera blauw",
  fr: "Bleu opéra"
}, {
  hex: "#57517e",
  code: "300 30 35",
  scope: "Design System Plus",
  de: "Tiefviolett",
  en: "Deep violet",
  nl: "Diep violet",
  fr: "Violet profond"
}, {
  hex: "#565084",
  code: "300 30 40",
  scope: "Design System Plus",
  de: "Salbeiviolett",
  en: "Sage violet",
  nl: "Salieviolet",
  fr: "Violet sauge"
}, {
  hex: "#6c6a70",
  code: "300 40 05",
  scope: "Design System Plus",
  de: "Barockgrau",
  en: "Baroque grey",
  nl: "Barok grijs",
  fr: "Gris baroque"
}, {
  hex: "#6b6775",
  code: "300 40 10",
  scope: "Design System Plus",
  de: "Gobelinlila",
  en: "Gobelin mauve",
  nl: "Wandtapijt paars",
  fr: "Violet de tapisserie"
}, {
  hex: "#6b657b",
  code: "300 40 15",
  scope: "Design System Plus",
  de: "Orchideengrau",
  en: "Orchid grey",
  nl: "Orchidee grijs",
  fr: "Gris orchidée"
}, {
  hex: "#6c6581",
  code: "300 40 20",
  scope: "Design System Plus",
  de: "Altlila",
  en: "Old mauve",
  nl: "Oud paars",
  fr: "Vieux violet"
}, {
  hex: "#6c6488",
  code: "300 40 25",
  scope: "Design System Plus",
  de: "Parmalila",
  en: "Parma mauve",
  nl: "Parmalila",
  fr: "Parmalila"
}, {
  hex: "#6c638e",
  code: "300 40 30",
  scope: "Design System Plus",
  de: "Wollviolett",
  en: "Wool violet",
  nl: "Wolviolet",
  fr: "Violet de laine"
}, {
  hex: "#6b6293",
  code: "300 40 35",
  scope: "Design System Plus",
  de: "Edelpurpur",
  en: "Fine purple",
  nl: "Edel paars",
  fr: "Pourpre noble"
}, {
  hex: "#696099",
  code: "300 40 40",
  scope: "Design System Plus",
  de: "Clematisblau",
  en: "Clematis blue",
  nl: "Clematis blauw",
  fr: "Bleu clématite"
}, {
  hex: "#6860a1",
  code: "300 40 45",
  scope: "Design System Plus",
  de: "Krönungsblau",
  en: "Coronation blue",
  nl: "Kroningsblauw",
  fr: "Bleu couronnement"
}, {
  hex: "#807e85",
  code: "300 50 05",
  scope: "Design System Plus",
  de: "Falkengrau",
  en: "Hawk grey",
  nl: "Valk grijs",
  fr: "Gris faucon"
}, {
  hex: "#817c8b",
  code: "300 50 10",
  scope: "Design System Plus",
  de: "Veilchengrau",
  en: "Violet grey",
  nl: "Paars grijs",
  fr: "Gris violet"
}, {
  hex: "#817b92",
  code: "300 50 15",
  scope: "Design System Plus",
  de: "Auerhahnlila",
  en: "Capercaillie mauve",
  nl: "Auerhoen paars",
  fr: "Mauve coq de bruyère"
}, {
  hex: "#817999",
  code: "300 50 20",
  scope: "Design System Plus",
  de: "Pariserviolett",
  en: "Parisian violet",
  nl: "Parijs viooltje",
  fr: "Violet de Paris"
}, {
  hex: "#8178a0",
  code: "300 50 25",
  scope: "Design System Plus",
  de: "Tulpenviolett",
  en: "Tulip violet",
  nl: "Tulpviooltje",
  fr: "Violet tulipe"
}, {
  hex: "#8177a7",
  code: "300 50 30",
  scope: "Design System Plus",
  de: "Spielzeuglila",
  en: "Toy mauve",
  nl: "Speelgoed paars",
  fr: "Violet de jouet"
}, {
  hex: "#8277ae",
  code: "300 50 35",
  scope: "Design System Plus",
  de: "Winterzeitlila",
  en: "Wintertime mauve",
  nl: "Winterpaars",
  fr: "Temps d'hiverlila"
}, {
  hex: "#8075b4",
  code: "300 50 40",
  scope: "Design System Plus",
  de: "Klarlila",
  en: "Clear mauve",
  nl: "Helder paars",
  fr: "Violet clair"
}, {
  hex: "#98969e",
  code: "300 60 05",
  scope: "Design System Plus",
  de: "Rebhuhngrau",
  en: "Partridge grey",
  nl: "Patrijs grijs",
  fr: "Gris perdrix"
}, {
  hex: "#9893a3",
  code: "300 60 10",
  scope: "Design System Plus",
  de: "Rosengrau",
  en: "Rose grey",
  nl: "Roze grijs",
  fr: "Gris rose"
}, {
  hex: "#9992ab",
  code: "300 60 15",
  scope: "Design System Plus",
  de: "Antikviola",
  en: "Antique viola",
  nl: "Antieke altviool",
  fr: "Antikviola"
}, {
  hex: "#9990b1",
  code: "300 60 20",
  scope: "Design System Plus",
  de: "Ritterspornviolett",
  en: "Larkspur violet",
  nl: "Ridderspoor paars",
  fr: "Violet d'aconit"
}, {
  hex: "#988eb8",
  code: "300 60 25",
  scope: "Design System Plus",
  de: "Seidenflieder",
  en: "Silk lilac",
  nl: "Lila",
  fr: "Lilas de soie"
}, {
  hex: "#988dc0",
  code: "300 60 30",
  scope: "Design System Plus",
  de: "Heliotroplila",
  en: "Heliotropic mauve",
  nl: "Heliotroop paars",
  fr: "Héliotrope violet"
}, {
  hex: "#978bc6",
  code: "300 60 35",
  scope: "Design System Plus",
  de: "Amethystgrau",
  en: "Amethyst grey",
  nl: "Amethist grijs",
  fr: "Gris améthyste"
}, {
  hex: "#b0aeb7",
  code: "300 70 05",
  scope: "Design System Plus",
  de: "Samtgrau",
  en: "Velvet grey",
  nl: "Fluweel grijs",
  fr: "Gris velours"
}, {
  hex: "#b1abbc",
  code: "300 70 10",
  scope: "Design System Plus",
  de: "Morgendunstgrau",
  en: "Morning mist grey",
  nl: "Ochtendmist grijs",
  fr: "Gris de brume matinale"
}, {
  hex: "#b1aac4",
  code: "300 70 15",
  scope: "Design System Plus",
  de: "Lidschattenviola",
  en: "Eyeshadow viola",
  nl: "Oogschaduw violet",
  fr: "Viola d'ombre à paupières"
}, {
  hex: "#b2a9cb",
  code: "300 70 20",
  scope: "Design System Plus",
  de: "Lavendelviolett",
  en: "Lavender violet",
  nl: "Lavendelviolet",
  fr: "Violet lavande"
}, {
  hex: "#b2a7d2",
  code: "300 70 25",
  scope: "Design System Plus",
  de: "Pinklavendel",
  en: "Pink lavender",
  nl: "Roze lavendel",
  fr: "Lavande rose"
}, {
  hex: "#cac8d0",
  code: "300 80 05",
  scope: "Design System Plus",
  de: "Dunstlila",
  en: "Hazy mauve",
  nl: "Damp paars",
  fr: "Voile de brume"
}, {
  hex: "#c9c5d8",
  code: "300 80 10",
  scope: "Design System Plus",
  de: "Blassviolett",
  en: "Pale violet",
  nl: "Licht violet",
  fr: "Violet pâle"
}, {
  hex: "#cbc4de",
  code: "300 80 15",
  scope: "Design System Plus",
  de: "Eislila",
  en: "Ice mauve",
  nl: "IJspaars",
  fr: "Violet glacé"
}, {
  hex: "#d5d4da",
  code: "300 85 05",
  scope: "Design System Plus",
  de: "Zartviola",
  en: "Delicate viola",
  nl: "Zartviola",
  fr: "Viole de gambe"
}, {
  hex: "#d8d1e4",
  code: "300 85 10",
  scope: "Design System Plus",
  de: "Puderviolaweiß",
  en: "Powder viola white",
  nl: "Poeder violet wit",
  fr: "Blanc poudré violet"
}, {
  hex: "#e4e2e8",
  code: "300 90 05",
  scope: "Design System Plus",
  de: "Lasurweiß",
  en: "Translucent white",
  nl: "Glazuur wit",
  fr: "Blanc lasuré"
}, {
  hex: "#4f4658",
  code: "310 20 20",
  scope: "Design System Plus",
  de: "Obsidianlavaschwarz",
  en: "Obsidian lava black",
  nl: "Obsidiaan lava zwart",
  fr: "Noir lave obsidienne"
}, {
  hex: "#51445d",
  code: "310 20 25",
  scope: "Design System Plus",
  de: "Operettenlila",
  en: "Operetta mauve",
  nl: "Operette paars",
  fr: "Violet d'opérette"
}, {
  hex: "#4f4261",
  code: "310 20 30",
  scope: "Design System Plus",
  de: "Machtviolett",
  en: "Powerful violet",
  nl: "Kracht violet",
  fr: "Violet de puissance"
}, {
  hex: "#5f5667",
  code: "310 30 15",
  scope: "Design System Plus",
  de: "Dunkelgraulila",
  en: "Dark grey mauve",
  nl: "Donkergrijs paars",
  fr: "Violet foncé"
}, {
  hex: "#5e536b",
  code: "310 30 20",
  scope: "Design System Plus",
  de: "Machtlila",
  en: "Powerful mauve",
  nl: "Kracht paars",
  fr: "Violet de puissance"
}, {
  hex: "#615270",
  code: "310 30 25",
  scope: "Design System Plus",
  de: "Englischviolett",
  en: "English violet",
  nl: "Engels viooltje",
  fr: "Violet anglais"
}, {
  hex: "#635176",
  code: "310 30 30",
  scope: "Design System Plus",
  de: "Kristallpurpur",
  en: "Crystal purple",
  nl: "Kristalpaars",
  fr: "Pourpre de cristal"
}, {
  hex: "#625078",
  code: "310 30 35",
  scope: "Design System Plus",
  de: "Prägnantviolett",
  en: "Succinct violet",
  nl: "Beknopt violet",
  fr: "Violet incisif"
}, {
  hex: "#654f7f",
  code: "310 30 40",
  scope: "Design System Plus",
  de: "Lodenpurpur",
  en: "Loden purple",
  nl: "Loden paars",
  fr: "Pourpre de lodge"
}, {
  hex: "#706976",
  code: "310 40 10",
  scope: "Design System Plus",
  de: "Dunkelpink",
  en: "Dark pink",
  nl: "Donkerroze",
  fr: "Rose foncé"
}, {
  hex: "#73687c",
  code: "310 40 15",
  scope: "Design System Plus",
  de: "Schleierviolett",
  en: "Violet haze",
  nl: "Sluier violet",
  fr: "Violet voilé"
}, {
  hex: "#756781",
  code: "310 40 20",
  scope: "Design System Plus",
  de: "Indigorot",
  en: "Indigo red",
  nl: "Indigorood",
  fr: "Indigorot"
}, {
  hex: "#766587",
  code: "310 40 25",
  scope: "Design System Plus",
  de: "Charoitviolett",
  en: "Charoite violet",
  nl: "Charoiet violet",
  fr: "Violet de charoit"
}, {
  hex: "#76628a",
  code: "310 40 30",
  scope: "Design System Plus",
  de: "Königspurpur",
  en: "Royal purple",
  nl: "Koningspaars",
  fr: "Pourpre royale"
}, {
  hex: "#776190",
  code: "310 40 35",
  scope: "Design System Plus",
  de: "Magentaveilchen",
  en: "Magenta violet",
  nl: "Magenta viooltjes",
  fr: "Violette de Magenta"
}, {
  hex: "#7a6196",
  code: "310 40 40",
  scope: "Design System Plus",
  de: "Purlila",
  en: "Pure mauve",
  nl: "Paars",
  fr: "Pourpre"
}, {
  hex: "#857d8c",
  code: "310 50 10",
  scope: "Design System Plus",
  de: "Trüblila",
  en: "Dull mauve",
  nl: "Bewolkt paars",
  fr: "Violet trouble"
}, {
  hex: "#867c92",
  code: "310 50 15",
  scope: "Design System Plus",
  de: "Batikflieder",
  en: "Batik lilac",
  nl: "Batik seringen",
  fr: "Lilas batik"
}, {
  hex: "#8a7b97",
  code: "310 50 20",
  scope: "Design System Plus",
  de: "Provenceviolett",
  en: "Provence violet",
  nl: "Provençaals viooltje",
  fr: "Violet de Provence"
}, {
  hex: "#8c799e",
  code: "310 50 25",
  scope: "Design System Plus",
  de: "Baronesslila",
  en: "Baroness mauve",
  nl: "Barones paars",
  fr: "Baronesslila"
}, {
  hex: "#8d77a4",
  code: "310 50 30",
  scope: "Design System Plus",
  de: "Bitterviolett",
  en: "Bitter violet",
  nl: "Bitter viooltje",
  fr: "Violet amer"
}, {
  hex: "#8d75a8",
  code: "310 50 35",
  scope: "Design System Plus",
  de: "Violettrosé",
  en: "Violet rose",
  nl: "Violette roos",
  fr: "Rose violacé"
}, {
  hex: "#8f74ae",
  code: "310 50 40",
  scope: "Design System Plus",
  de: "Orchideenlila",
  en: "Orchid mauve",
  nl: "Orchidee paars",
  fr: "Violet d'orchidée"
}, {
  hex: "#9b93a3",
  code: "310 60 10",
  scope: "Design System Plus",
  de: "Dezentlila",
  en: "Gentle mauve",
  nl: "Fatsoenlijk paars",
  fr: "Violet discret"
}, {
  hex: "#9f92aa",
  code: "310 60 15",
  scope: "Design System Plus",
  de: "Rauchlila",
  en: "Smoky mauve",
  nl: "Rookpaars",
  fr: "Violet de fumée"
}, {
  hex: "#a291b0",
  code: "310 60 20",
  scope: "Design System Plus",
  de: "Safranblütenlila",
  en: "Saffron blossom mauve",
  nl: "Saffraanbloesem paars",
  fr: "Violet fleur de safran"
}, {
  hex: "#a48fb5",
  code: "310 60 25",
  scope: "Design System Plus",
  de: "Kokettpink",
  en: "Flirty pink",
  nl: "Coquett roze",
  fr: "Rose cocotte"
}, {
  hex: "#a58dba",
  code: "310 60 30",
  scope: "Design System Plus",
  de: "Pfingstrosenlila",
  en: "Peony mauve",
  nl: "Pioen paars",
  fr: "Mauve pivoine"
}, {
  hex: "#a78ac3",
  code: "310 60 35",
  scope: "Design System Plus",
  de: "Lilapurpur",
  en: "Lilac purple",
  nl: "Paars",
  fr: "Lilapurpur"
}, {
  hex: "#b5acbb",
  code: "310 70 10",
  scope: "Design System Plus",
  de: "Amorphrosé",
  en: "Amorphous rose",
  nl: "Amorfrosé",
  fr: "Amorphrosé"
}, {
  hex: "#b8aac2",
  code: "310 70 15",
  scope: "Design System Plus",
  de: "Transparentlila",
  en: "Transparent mauve",
  nl: "Transparant paars",
  fr: "Violet transparent"
}, {
  hex: "#b9a8c7",
  code: "310 70 20",
  scope: "Design System Plus",
  de: "Blaurosa",
  en: "Blue pink",
  nl: "Blauw roze",
  fr: "Rose bleu"
}, {
  hex: "#bba7ce",
  code: "310 70 25",
  scope: "Design System Plus",
  de: "Glasviolett",
  en: "Glass violet",
  nl: "Glasviolet",
  fr: "Violet de verre"
}, {
  hex: "#cdc5d5",
  code: "310 80 10",
  scope: "Design System Plus",
  de: "Puderviola",
  en: "Powder viola",
  nl: "Puderviola",
  fr: "Puderviola"
}, {
  hex: "#d1c4db",
  code: "310 80 15",
  scope: "Design System Plus",
  de: "Orchideenviolett",
  en: "Orchid violet",
  nl: "Orchidee viooltje",
  fr: "Violet d'orchidée"
}, {
  hex: "#d6d3da",
  code: "310 85 05",
  scope: "Design System Plus",
  de: "Feenrosa",
  en: "Fairy pink",
  nl: "Feeënroze",
  fr: "Rose fée"
}, {
  hex: "#dbd1e2",
  code: "310 85 10",
  scope: "Design System Plus",
  de: "Tricotfliederweiß",
  en: "Tricot lilac white",
  nl: "Tricot lila wit",
  fr: "Blanc tricot lilas"
}, {
  hex: "#e8e3e7",
  code: "310 90 05",
  scope: "Design System Plus",
  de: "Mauerblümchenweiß",
  en: "Wallflower white",
  nl: "Muurbloem wit",
  fr: "Fleur de mur blanc"
}, {
  hex: "#4d494e",
  code: "320 20 05",
  scope: "Design System Plus",
  de: "Lavaschwarz",
  en: "Lava black",
  nl: "Lavazwart",
  fr: "Noir lave"
}, {
  hex: "#4e464f",
  code: "320 20 10",
  scope: "Design System Plus",
  de: "Obsidianrot",
  en: "Obsidian red",
  nl: "Obsidiaan rood",
  fr: "Rouge obsidienne"
}, {
  hex: "#4f4451",
  code: "320 20 15",
  scope: "Design System Plus",
  de: "Spinellviolett",
  en: "Spinel violet",
  nl: "Spinel violet",
  fr: "Violet spinelle"
}, {
  hex: "#534455",
  code: "320 20 20",
  scope: "Design System Plus",
  de: "Auberginenlila",
  en: "Aubergine mauve",
  nl: "Aubergine paars",
  fr: "Violet d'aubergine"
}, {
  hex: "#534259",
  code: "320 20 25",
  scope: "Design System Plus",
  de: "Dunkelpurpur",
  en: "Dark purple",
  nl: "Donkerpaars",
  fr: "Pourpre foncé"
}, {
  hex: "#5b565b",
  code: "320 30 05",
  scope: "Design System Plus",
  de: "Violettschwarz",
  en: "Violet black",
  nl: "Paars zwart",
  fr: "Noir violet"
}, {
  hex: "#5d545e",
  code: "320 30 10",
  scope: "Design System Plus",
  de: "Steinviolett",
  en: "Stone violet",
  nl: "Steenviolet",
  fr: "Violet pierre"
}, {
  hex: "#605161",
  code: "320 30 15",
  scope: "Design System Plus",
  de: "Amethystdunkelviolett",
  en: "Amethyst dark violet",
  nl: "Amethist donker violet",
  fr: "Améthyste violet foncé"
}, {
  hex: "#634f66",
  code: "320 30 20",
  scope: "Design System Plus",
  de: "Dunkelbrombeer",
  en: "Dark blackberry",
  nl: "Donkere braam",
  fr: "Mûre foncée"
}, {
  hex: "#664e6a",
  code: "320 30 25",
  scope: "Design System Plus",
  de: "Purpuritviolett",
  en: "Purpurite violet",
  nl: "Purpuriet violet",
  fr: "Violet pourpre"
}, {
  hex: "#674c6e",
  code: "320 30 30",
  scope: "Design System Plus",
  de: "Zwetschgenlila",
  en: "Damson mauve",
  nl: "Pruim paars",
  fr: "Violet prune"
}, {
  hex: "#694b73",
  code: "320 30 35",
  scope: "Design System Plus",
  de: "Traubenpurpur",
  en: "Grape purple",
  nl: "Druif paars",
  fr: "Pourpre de raisin"
}, {
  hex: "#6c4b77",
  code: "320 30 37",
  scope: "Design System Plus",
  de: "Loungeviolett",
  en: "Lounge violet",
  nl: "Lounge violet",
  fr: "Violet lounge"
}, {
  hex: "#6e696f",
  code: "320 40 05",
  scope: "Design System Plus",
  de: "Schieferlila",
  en: "Slate mauve",
  nl: "Leisteen paars",
  fr: "Violet ardoise"
}, {
  hex: "#716672",
  code: "320 40 10",
  scope: "Design System Plus",
  de: "Olivinbasalt",
  en: "Olivine basalt",
  nl: "Olivijn basalt",
  fr: "Basalte d'olivine"
}, {
  hex: "#746477",
  code: "320 40 15",
  scope: "Design System Plus",
  de: "Antikgrau",
  en: "Antique grey",
  nl: "Antiek grijs",
  fr: "Gris antique"
}, {
  hex: "#77627b",
  code: "320 40 20",
  scope: "Design System Plus",
  de: "Basilikumlila",
  en: "Basil mauve",
  nl: "Basilicum paars",
  fr: "Violet de basilic"
}, {
  hex: "#796080",
  code: "320 40 25",
  scope: "Design System Plus",
  de: "Gladiolenviolett",
  en: "Gladiola violet",
  nl: "Gladiolus viooltje",
  fr: "Violet glaïeul"
}, {
  hex: "#7d5d83",
  code: "320 40 30",
  scope: "Design System Plus",
  de: "Krautblütenviolett",
  en: "Cabbage blossom violet",
  nl: "Kruidenbloesem viooltje",
  fr: "Violet de fleur d'herbe"
}, {
  hex: "#7f5a87",
  code: "320 40 35",
  scope: "Design System Plus",
  de: "Fliederviolett",
  en: "Lilac violet",
  nl: "Lila viooltje",
  fr: "Violet lilas"
}, {
  hex: "#82598e",
  code: "320 40 40",
  scope: "Design System Plus",
  de: "Veilchenpurpur",
  en: "Violet purple",
  nl: "Violetpaars",
  fr: "Pourpre violette"
}, {
  hex: "#827c83",
  code: "320 50 05",
  scope: "Design System Plus",
  de: "Grauviolett",
  en: "Grey violet",
  nl: "Grijsviolet",
  fr: "Violet gris"
}, {
  hex: "#867987",
  code: "320 50 10",
  scope: "Design System Plus",
  de: "Britischgrauviolett",
  en: "British grey mauve",
  nl: "Brits grijs viooltje",
  fr: "Violet gris britannique"
}, {
  hex: "#89778c",
  code: "320 50 15",
  scope: "Design System Plus",
  de: "Parmagrau",
  en: "Parma grey",
  nl: "Parma grijs",
  fr: "Gris parme"
}, {
  hex: "#8e7793",
  code: "320 50 20",
  scope: "Design System Plus",
  de: "Alpenveilchen",
  en: "Cyclamen",
  nl: "Cyclamen",
  fr: "Cyclamen"
}, {
  hex: "#907397",
  code: "320 50 25",
  scope: "Design System Plus",
  de: "Poesielila",
  en: "Poetry mauve",
  nl: "Poëzie paars",
  fr: "Poesielila"
}, {
  hex: "#94729d",
  code: "320 50 30",
  scope: "Design System Plus",
  de: "Violagrau",
  en: "Viola grey",
  nl: "Viola grijs",
  fr: "Gris violacé"
}, {
  hex: "#966d9f",
  code: "320 50 35",
  scope: "Design System Plus",
  de: "Astervioletta",
  en: "Aster violetta",
  nl: "Asterviolet",
  fr: "Astervioletta"
}, {
  hex: "#996fa7",
  code: "320 50 40",
  scope: "Design System Plus",
  de: "Empireviolett",
  en: "Empire violet",
  nl: "Empire violet",
  fr: "Violet empire"
}, {
  hex: "#9a949c",
  code: "320 60 05",
  scope: "Design System Plus",
  de: "Aragonitgrau",
  en: "Aragonite grey",
  nl: "Aragoniet grijs",
  fr: "Gris aragonite"
}, {
  hex: "#9e929f",
  code: "320 60 10",
  scope: "Design System Plus",
  de: "Kreideviolett",
  en: "Chalk violet",
  nl: "Krijtviolet",
  fr: "Violet craie"
}, {
  hex: "#a28fa5",
  code: "320 60 15",
  scope: "Design System Plus",
  de: "Amethystgrauviolett",
  en: "Amethyst grey violet",
  nl: "Amethist grijs violet",
  fr: "Violet gris améthyste"
}, {
  hex: "#a58ba9",
  code: "320 60 20",
  scope: "Design System Plus",
  de: "Wunderveilchen",
  en: "Wonder violet",
  nl: "Wonderviooltje",
  fr: "Violette miraculeuse"
}, {
  hex: "#a889af",
  code: "320 60 25",
  scope: "Design System Plus",
  de: "Nachtschattenviolett",
  en: "Nightshade violet",
  nl: "Nachtschadeviooltje",
  fr: "Violet ombre de nuit"
}, {
  hex: "#ac87b5",
  code: "320 60 30",
  scope: "Design System Plus",
  de: "Lobbylila",
  en: "Lobby lilac",
  nl: "Lobby paars",
  fr: "Lobbylila"
}, {
  hex: "#ae85b9",
  code: "320 60 35",
  scope: "Design System Plus",
  de: "Sorbetbrombeer",
  en: "Blackberry sorbet",
  nl: "Sorbet braambes",
  fr: "Mûre sorbet"
}, {
  hex: "#b2acb3",
  code: "320 70 05",
  scope: "Design System Plus",
  de: "Holundergrau",
  en: "Elderberry grey",
  nl: "Vlierbes grijs",
  fr: "Gris sureau"
}, {
  hex: "#b6a9b9",
  code: "320 70 10",
  scope: "Design System Plus",
  de: "Glockenblumenviolett",
  en: "Bellflower violet",
  nl: "Klokjesviooltje",
  fr: "Violet de campanule"
}, {
  hex: "#b9a6be",
  code: "320 70 15",
  scope: "Design System Plus",
  de: "Quarzviolett",
  en: "Quartz violet",
  nl: "Kwarts violet",
  fr: "Violet de quartz"
}, {
  hex: "#c0a5c6",
  code: "320 70 20",
  scope: "Design System Plus",
  de: "Strandflieder",
  en: "Beach lilac",
  nl: "Strand lila",
  fr: "Lilas de plage"
}, {
  hex: "#c3a2ca",
  code: "320 70 25",
  scope: "Design System Plus",
  de: "Fliederpink",
  en: "Lilac pink",
  nl: "Lila roze",
  fr: "Rose lilas"
}, {
  hex: "#cdc7cd",
  code: "320 80 05",
  scope: "Design System Plus",
  de: "Hellviolett",
  en: "Light violet",
  nl: "Licht violet",
  fr: "Violet clair"
}, {
  hex: "#d1c4d3",
  code: "320 80 10",
  scope: "Design System Plus",
  de: "Amethysthellviolett",
  en: "Amethyst light violet",
  nl: "Ametherschaal viooltje",
  fr: "Violet d'améthyste"
}, {
  hex: "#d4c0d6",
  code: "320 80 15",
  scope: "Design System Plus",
  de: "Kosmetiklila",
  en: "Cosmetic mauve",
  nl: "Cosmetisch paars",
  fr: "Violet cosmétique"
}, {
  hex: "#d8d1d9",
  code: "320 85 05",
  scope: "Design System Plus",
  de: "Brombeercreme",
  en: "Blackberry cream",
  nl: "Bramencrème",
  fr: "Crème de mûres"
}, {
  hex: "#ddcfdf",
  code: "320 85 10",
  scope: "Design System Plus",
  de: "Ametrinquarz",
  en: "Ametrine quartz",
  nl: "Ametrien kwarts",
  fr: "Quartz amétrine"
}, {
  hex: "#e8e1e6",
  code: "320 90 05",
  scope: "Design System Plus",
  de: "Apatitrosa",
  en: "Apatite pink",
  nl: "Apatitrosa",
  fr: "Apatitrosa"
}, {
  hex: "#554251",
  code: "330 20 20",
  scope: "Design System Plus",
  de: "Tiefgrundlila",
  en: "Profound mauve",
  nl: "Diep basispaars",
  fr: "Violet profond"
}, {
  hex: "#5a4256",
  code: "330 20 25",
  scope: "Design System Plus",
  de: "Opulentlila",
  en: "Opulent mauve",
  nl: "Weelderig paars",
  fr: "Violet opulent"
}, {
  hex: "#645361",
  code: "330 30 15",
  scope: "Design System Plus",
  de: "Korinthenviolett",
  en: "Currant violet",
  nl: "Korinthisch viooltje",
  fr: "Violet de Corinthe"
}, {
  hex: "#685164",
  code: "330 30 20",
  scope: "Design System Plus",
  de: "Mexikanischpurpur",
  en: "Mexican purple",
  nl: "Mexicaans paars",
  fr: "Pourpre mexicain"
}, {
  hex: "#6b4e66",
  code: "330 30 25",
  scope: "Design System Plus",
  de: "Parmapflaumenrot",
  en: "Parma plum red",
  nl: "Parma pruimenrood",
  fr: "Rouge parme prune"
}, {
  hex: "#704c6a",
  code: "330 30 30",
  scope: "Design System Plus",
  de: "Intensivpurpur",
  en: "Intense purple",
  nl: "Intens paars",
  fr: "Pourpre intense"
}, {
  hex: "#734b6e",
  code: "330 30 35",
  scope: "Design System Plus",
  de: "Opulentpurpur",
  en: "Opulent purple",
  nl: "Weelderig paars",
  fr: "Pourpre opulent"
}, {
  hex: "#75476f",
  code: "330 30 40",
  scope: "Design System Plus",
  de: "Intensivlila",
  en: "Intense mauve",
  nl: "Intens paars",
  fr: "Violet intense"
}, {
  hex: "#746772",
  code: "330 40 10",
  scope: "Design System Plus",
  de: "Patinaviolett",
  en: "Patina violet",
  nl: "Patina violet",
  fr: "Violet patiné"
}, {
  hex: "#786576",
  code: "330 40 15",
  scope: "Design System Plus",
  de: "Dunkelpurpurgrau",
  en: "Dark purple grey",
  nl: "Donkerpaars grijs",
  fr: "Gris pourpre foncé"
}, {
  hex: "#7d647a",
  code: "330 40 20",
  scope: "Design System Plus",
  de: "Amaranthrot",
  en: "Amaranth red",
  nl: "Amarant rood",
  fr: "Rouge amarante"
}, {
  hex: "#81627d",
  code: "330 40 25",
  scope: "Design System Plus",
  de: "Tiefmagenta",
  en: "Deep magenta",
  nl: "Diep magenta",
  fr: "Magenta profond"
}, {
  hex: "#885f81",
  code: "330 40 30",
  scope: "Design System Plus",
  de: "Phloxblumenviolett",
  en: "Phloxflower violet",
  nl: "Phlox bloem viooltje",
  fr: "Violet de fleur de phlox"
}, {
  hex: "#8b5d84",
  code: "330 40 35",
  scope: "Design System Plus",
  de: "Distellila",
  en: "Thistle mauve",
  nl: "Distel paars",
  fr: "Distellila"
}, {
  hex: "#8c5885",
  code: "330 40 40",
  scope: "Design System Plus",
  de: "Visionarot",
  en: "Visiona red",
  nl: "Visionarot",
  fr: "Visionarot"
}, {
  hex: "#8f5788",
  code: "330 40 45",
  scope: "Design System Plus",
  de: "Purpuritrot",
  en: "Purpurite red",
  nl: "Paars rood",
  fr: "Rouge pourpre"
}, {
  hex: "#897a86",
  code: "330 50 10",
  scope: "Design System Plus",
  de: "Jutegrau",
  en: "Burlap grey",
  nl: "Jute grijs",
  fr: "Gris jute"
}, {
  hex: "#8f7a8c",
  code: "330 50 15",
  scope: "Design System Plus",
  de: "Saphirrosa",
  en: "Sapphire pink",
  nl: "Saffierroze",
  fr: "Rose saphir"
}, {
  hex: "#947790",
  code: "330 50 20",
  scope: "Design System Plus",
  de: "Prachtnelkenlila",
  en: "Dianthus mauve",
  nl: "Prachtige anjer paars",
  fr: "Violet magnifique"
}, {
  hex: "#987593",
  code: "330 50 25",
  scope: "Design System Plus",
  de: "Kristallrosa",
  en: "Crystal pink",
  nl: "Kristalroze",
  fr: "Rose cristal"
}, {
  hex: "#9d7399",
  code: "330 50 30",
  scope: "Design System Plus",
  de: "Tulipanviolett",
  en: "Tulipan violet",
  nl: "Tulpenviooltje",
  fr: "Violet de tulipes"
}, {
  hex: "#a0709c",
  code: "330 50 35",
  scope: "Design System Plus",
  de: "Violettrot",
  en: "Violet red",
  nl: "Paarsrood",
  fr: "Rouge violet"
}, {
  hex: "#a56d9e",
  code: "330 50 40",
  scope: "Design System Plus",
  de: "Orchideenpurpur",
  en: "Orchid purple",
  nl: "Orchidee paars",
  fr: "Pourpre d'orchidée"
}, {
  hex: "#a1929f",
  code: "330 60 10",
  scope: "Design System Plus",
  de: "Greigeviolett",
  en: "Greige violet",
  nl: "Grijsviolet",
  fr: "Greige violet"
}, {
  hex: "#a791a4",
  code: "330 60 15",
  scope: "Design System Plus",
  de: "Vesuvianviolett",
  en: "Vesuvian violet",
  nl: "Vesuviaans viooltje",
  fr: "Violet vesuvian"
}, {
  hex: "#ad8ea8",
  code: "330 60 20",
  scope: "Design System Plus",
  de: "Enzianviolett",
  en: "Gentian violet",
  nl: "Gentiaanviooltje",
  fr: "Violet gentiane"
}, {
  hex: "#af8aa9",
  code: "330 60 25",
  scope: "Design System Plus",
  de: "Gründerzeitpink",
  en: "Wilhelminian pink",
  nl: "Wilhelminiaans roze",
  fr: "Rose des fondateurs"
}, {
  hex: "#b588af",
  code: "330 60 30",
  scope: "Design System Plus",
  de: "Bühnenlila",
  en: "Stage mauve",
  nl: "Podium paars",
  fr: "Violet de scène"
}, {
  hex: "#bb85b3",
  code: "330 60 35",
  scope: "Design System Plus",
  de: "Pfingstnelkenlila",
  en: "Cheddar pink mauve",
  nl: "Pinksteranjer paars",
  fr: "Violet de pivoine"
}, {
  hex: "#be82b7",
  code: "330 60 40",
  scope: "Design System Plus",
  de: "Colomborotlila",
  en: "Colombo red mauve",
  nl: "Colomborot paars",
  fr: "Colomborotlila"
}, {
  hex: "#bcabb9",
  code: "330 70 10",
  scope: "Design System Plus",
  de: "Nebelrosa",
  en: "Mist pink",
  nl: "Mistig roze",
  fr: "Rose brumeux"
}, {
  hex: "#bfa7bb",
  code: "330 70 15",
  scope: "Design System Plus",
  de: "Lauchblütenpink",
  en: "Leek blossom pink",
  nl: "Preibloesem roze",
  fr: "Rose fleur de poireau"
}, {
  hex: "#c5a6c0",
  code: "330 70 20",
  scope: "Design System Plus",
  de: "Erdbeerrosa",
  en: "Strawberry pink",
  nl: "Aardbeiroze",
  fr: "Rose fraise"
}, {
  hex: "#cca3c5",
  code: "330 70 25",
  scope: "Design System Plus",
  de: "Purpurrosa",
  en: "Purple pink",
  nl: "Paars roze",
  fr: "Rose pourpre"
}, {
  hex: "#d0a1c7",
  code: "330 70 30",
  scope: "Design System Plus",
  de: "Kleeblütenrosa",
  en: "Clover pink",
  nl: "Klaverbloesem roze",
  fr: "Rose de trèfle"
}, {
  hex: "#d5c4d1",
  code: "330 80 10",
  scope: "Design System Plus",
  de: "Purpurweiß",
  en: "Purple white",
  nl: "Paars wit",
  fr: "Blanc pourpre"
}, {
  hex: "#dac1d5",
  code: "330 80 15",
  scope: "Design System Plus",
  de: "Lieblichrosa",
  en: "Lovely pink",
  nl: "Mooi roze",
  fr: "Rose tendre"
}, {
  hex: "#e2bfd9",
  code: "330 80 20",
  scope: "Design System Plus",
  de: "Designerrosa",
  en: "Designer pink",
  nl: "Ontwerper roze",
  fr: "Rose design"
}, {
  hex: "#d9d3d9",
  code: "330 85 05",
  scope: "Design System Plus",
  de: "Hellmagnolienrosé",
  en: "Light magnolia rose",
  nl: "Lichte magnolia rosé",
  fr: "Rose magnolia clair"
}, {
  hex: "#e2d1de",
  code: "330 85 10",
  scope: "Design System Plus",
  de: "Himbeerrosa",
  en: "Raspberry pink",
  nl: "Framboos roze",
  fr: "Rose framboise"
}, {
  hex: "#e8cee1",
  code: "330 85 15",
  scope: "Design System Plus",
  de: "Himmlischrosa",
  en: "Heavenly pink",
  nl: "Hemels roze",
  fr: "Rose céleste"
}, {
  hex: "#ebe2e5",
  code: "330 90 05",
  scope: "Design System Plus",
  de: "Delikatessweiß",
  en: "Delicacy white",
  nl: "Delicatesse wit",
  fr: "Blanc délicat"
}, {
  hex: "#4d474b",
  code: "340 20 05",
  scope: "Design System Plus",
  de: "Lakritzschwarz",
  en: "Liquorice black",
  nl: "Zoethout zwart",
  fr: "Noir réglisse"
}, {
  hex: "#50444a",
  code: "340 20 10",
  scope: "Design System Plus",
  de: "Mangostanoviolett",
  en: "Mangosteen violet",
  nl: "Mangosteenviooltje",
  fr: "Violet de mangoustan"
}, {
  hex: "#53414b",
  code: "340 20 15",
  scope: "Design System Plus",
  de: "Sitterrot",
  en: "Sitter red",
  nl: "Zitter rood",
  fr: "Rouge de Sitter"
}, {
  hex: "#58414e",
  code: "340 20 20",
  scope: "Design System Plus",
  de: "Saftviolett",
  en: "Juice violet",
  nl: "Sap viooltje",
  fr: "Violet de jus"
}, {
  hex: "#5f4252",
  code: "340 20 25",
  scope: "Design System Plus",
  de: "Prestigelila",
  en: "Prestige mauve",
  nl: "Prestige paars",
  fr: "Prestigelila"
}, {
  hex: "#5c5559",
  code: "340 30 05",
  scope: "Design System Plus",
  de: "Apfelkrautschwarz",
  en: "Apple herb black",
  nl: "Appelkruid zwart",
  fr: "Noir pomme-gris"
}, {
  hex: "#61525a",
  code: "340 30 10",
  scope: "Design System Plus",
  de: "Passionsfruchtlila",
  en: "Passionfruit mauve",
  nl: "Passievrucht paars",
  fr: "Mauve fruit de la passion"
}, {
  hex: "#66505c",
  code: "340 30 15",
  scope: "Design System Plus",
  de: "Dunkelfeigenviolett",
  en: "Dark fig violet",
  nl: "Donker vijgenviolet",
  fr: "Violet figue foncé"
}, {
  hex: "#6a4e5e",
  code: "340 30 20",
  scope: "Design System Plus",
  de: "Rubinviolett",
  en: "Ruby violet",
  nl: "Robijnviolet",
  fr: "Violet rubis"
}, {
  hex: "#6f4c62",
  code: "340 30 25",
  scope: "Design System Plus",
  de: "Brombeertiefrot",
  en: "Blackberry deep red",
  nl: "Framboos dieprood",
  fr: "Mûre profonde"
}, {
  hex: "#714963",
  code: "340 30 30",
  scope: "Design System Plus",
  de: "Tiefrot",
  en: "Deep red",
  nl: "Diep rood",
  fr: "Rouge profond"
}, {
  hex: "#754664",
  code: "340 30 35",
  scope: "Design System Plus",
  de: "Samtlila",
  en: "Velvet mauve",
  nl: "Fluweelpaars",
  fr: "Violet velours"
}, {
  hex: "#7a4366",
  code: "340 30 38",
  scope: "Design System Plus",
  de: "Waldfruchtrot",
  en: "Forest fruit red",
  nl: "Bosvruchten rood",
  fr: "Rouge fruit de forêt"
}, {
  hex: "#6f676b",
  code: "340 40 05",
  scope: "Design System Plus",
  de: "Lilabraun",
  en: "Mauve brown",
  nl: "Paarsbruin",
  fr: "Marron lilas"
}, {
  hex: "#76646d",
  code: "340 40 10",
  scope: "Design System Plus",
  de: "Spinellgrau",
  en: "Spinel grey",
  nl: "Spinel grijs",
  fr: "Gris spinelle"
}, {
  hex: "#7b6270",
  code: "340 40 15",
  scope: "Design System Plus",
  de: "Erdbraunviolett",
  en: "Earth brown violet",
  nl: "Aarde bruin violet",
  fr: "Marron terre violet"
}, {
  hex: "#805f72",
  code: "340 40 20",
  scope: "Design System Plus",
  de: "Dahlienmattrot",
  en: "Dahlia matte red",
  nl: "Dahlia mat rood",
  fr: "Dahlia mat"
}, {
  hex: "#855d76",
  code: "340 40 25",
  scope: "Design System Plus",
  de: "Brokatviolett",
  en: "Brocade violet",
  nl: "Brokaatviolet",
  fr: "Violet de brocart"
}, {
  hex: "#895a78",
  code: "340 40 30",
  scope: "Design System Plus",
  de: "Krappmagenta",
  en: "Madder magenta",
  nl: "Madder magenta",
  fr: "Magenta de garance"
}, {
  hex: "#8b557a",
  code: "340 40 35",
  scope: "Design System Plus",
  de: "Clublila",
  en: "Club mauve",
  nl: "Club paars",
  fr: "Clublila"
}, {
  hex: "#90527b",
  code: "340 40 40",
  scope: "Design System Plus",
  de: "Kirschrot",
  en: "Cherry red",
  nl: "Kersenrood",
  fr: "Rouge cerise"
}, {
  hex: "#994f80",
  code: "340 40 45",
  scope: "Design System Plus",
  de: "Magentarot",
  en: "Magenta red",
  nl: "Magenta rood",
  fr: "Rouge magenta"
}, {
  hex: "#857c81",
  code: "340 50 05",
  scope: "Design System Plus",
  de: "Jubiläumsgrau",
  en: "Jubilee grey",
  nl: "Jubileum grijs",
  fr: "Gris anniversaire"
}, {
  hex: "#8c7984",
  code: "340 50 10",
  scope: "Design System Plus",
  de: "Portweinrot",
  en: "Port wine red",
  nl: "Portwijn rood",
  fr: "Rouge porto"
}, {
  hex: "#927686",
  code: "340 50 15",
  scope: "Design System Plus",
  de: "Rohgranatviola",
  en: "Raw garnet viola",
  nl: "Granaat altviool",
  fr: "Viola brute à la grenade"
}, {
  hex: "#987489",
  code: "340 50 20",
  scope: "Design System Plus",
  de: "Kreuzblumenrot",
  en: "Milkwort red",
  nl: "Kruisbloem rood",
  fr: "Rouge fleur de trèfle"
}, {
  hex: "#9d708b",
  code: "340 50 25",
  scope: "Design System Plus",
  de: "Rostmagenta",
  en: "Rust magenta",
  nl: "Roest magenta",
  fr: "Magenta rouillé"
}, {
  hex: "#a26d8e",
  code: "340 50 30",
  scope: "Design System Plus",
  de: "Himbeergeleerot",
  en: "Raspberry jelly red",
  nl: "Frambozengelei rood",
  fr: "Rouge gélifié à la framboise"
}, {
  hex: "#a56890",
  code: "340 50 35",
  scope: "Design System Plus",
  de: "Fingerhutrot",
  en: "Thimble red",
  nl: "Vingerhoedskruid rood",
  fr: "Rouge dé à coudre"
}, {
  hex: "#ad6693",
  code: "340 50 40",
  scope: "Design System Plus",
  de: "Cyclamonrot",
  en: "Cyclamen red",
  nl: "Cyclamen rood",
  fr: "Rouge cyclamon"
}, {
  hex: "#b26295",
  code: "340 50 45",
  scope: "Design System Plus",
  de: "Brillantkarmin",
  en: "Brilliant carmine",
  nl: "Schitterende karmijn",
  fr: "Carmin brillant"
}, {
  hex: "#9e959a",
  code: "340 60 05",
  scope: "Design System Plus",
  de: "Erikarotgrau",
  en: "Heather red grey",
  nl: "Erika rood grijs",
  fr: "Gris Éricarot"
}, {
  hex: "#a48f9b",
  code: "340 60 10",
  scope: "Design System Plus",
  de: "Pianomauve",
  en: "Piano mauve",
  nl: "Piano mauve",
  fr: "Pianomauve"
}, {
  hex: "#ac8d9f",
  code: "340 60 15",
  scope: "Design System Plus",
  de: "Abendrosa",
  en: "Evening pink",
  nl: "Avondroze",
  fr: "Rose du soir"
}, {
  hex: "#b08aa1",
  code: "340 60 20",
  scope: "Design System Plus",
  de: "Caprimodepink",
  en: "Capri fashion pink",
  nl: "Caprimode roze",
  fr: "Caprimodepink"
}, {
  hex: "#b587a3",
  code: "340 60 25",
  scope: "Design System Plus",
  de: "Antikpink",
  en: "Antique hot pink",
  nl: "Antiek roze",
  fr: "Rose antique"
}, {
  hex: "#ba84a6",
  code: "340 60 30",
  scope: "Design System Plus",
  de: "Wangenrot",
  en: "Cheek red",
  nl: "Wangen rood",
  fr: "Rouge joue"
}, {
  hex: "#c181a9",
  code: "340 60 35",
  scope: "Design System Plus",
  de: "Malvenblütenpink",
  en: "Hollyhock blossom pink",
  nl: "Wilgenbloesem roze",
  fr: "Rose fleur de mauve"
}, {
  hex: "#c87cad",
  code: "340 60 40",
  scope: "Design System Plus",
  de: "Bischofsrot",
  en: "Bishop red",
  nl: "Rood van de bisschop",
  fr: "Bischofsrot"
}, {
  hex: "#b6acb1",
  code: "340 70 05",
  scope: "Design System Plus",
  de: "Lilagrau",
  en: "Mauve grey",
  nl: "Paars grijs",
  fr: "Gris lilas"
}, {
  hex: "#bca8b3",
  code: "340 70 10",
  scope: "Design System Plus",
  de: "Buchweizenlila",
  en: "Buckwheat mauve",
  nl: "Boekweit paars",
  fr: "Violet sarrasin"
}, {
  hex: "#c5a6b8",
  code: "340 70 15",
  scope: "Design System Plus",
  de: "Malvenrosa",
  en: "Hollyhock pink",
  nl: "Mauve roze",
  fr: "Rose mauve"
}, {
  hex: "#cba3bb",
  code: "340 70 20",
  scope: "Design System Plus",
  de: "Idyllenrosa",
  en: "Idyllic pink",
  nl: "Idyllisch roze",
  fr: "Rose idyllique"
}, {
  hex: "#ce9fbb",
  code: "340 70 25",
  scope: "Design System Plus",
  de: "Windenblütenpink",
  en: "Morning glory pink",
  nl: "Lierbloesem roze",
  fr: "Rose fleur de liseron"
}, {
  hex: "#d69cc0",
  code: "340 70 30",
  scope: "Design System Plus",
  de: "Softfuchsia",
  en: "Soft fuschia",
  nl: "Zacht fuchsia",
  fr: "Softfuchsia"
}, {
  hex: "#dd99c4",
  code: "340 70 35",
  scope: "Design System Plus",
  de: "Prallpink",
  en: "Firm pink",
  nl: "Impact roze",
  fr: "Rose vif"
}, {
  hex: "#d1c7ca",
  code: "340 80 05",
  scope: "Design System Plus",
  de: "Pianograurosé",
  en: "Piano grey rose",
  nl: "Pianograurosé",
  fr: "Pianograurosé"
}, {
  hex: "#d9c4d0",
  code: "340 80 10",
  scope: "Design System Plus",
  de: "Minzblütenrosé",
  en: "Mint blossom rose",
  nl: "Rosé met muntbloesem",
  fr: "Rose fleur de menthe"
}, {
  hex: "#e0c0d2",
  code: "340 80 15",
  scope: "Design System Plus",
  de: "Skandalrosé",
  en: "Scandalous rose",
  nl: "Schandalige rosé",
  fr: "Rose scandale"
}, {
  hex: "#e7bdd4",
  code: "340 80 20",
  scope: "Design System Plus",
  de: "Bonbonrosa",
  en: "Bonbon rose",
  nl: "Snoeproze",
  fr: "Rose bonbon"
}, {
  hex: "#ddd2d8",
  code: "340 85 05",
  scope: "Design System Plus",
  de: "Erdbeercreme",
  en: "Strawberry cream",
  nl: "Aardbeiencrème",
  fr: "Crème à la fraise"
}, {
  hex: "#e5cfdb",
  code: "340 85 10",
  scope: "Design System Plus",
  de: "Hellflamingopink",
  en: "Light flamingo pink",
  nl: "Licht flamingo roze",
  fr: "Rose flamant clair"
}, {
  hex: "#eecddf",
  code: "340 85 15",
  scope: "Design System Plus",
  de: "Lacklila",
  en: "Lacquer mauve",
  nl: "Paars octrooi",
  fr: "Violet laqué"
}, {
  hex: "#ebe1e4",
  code: "340 90 05",
  scope: "Design System Plus",
  de: "Rosenweiß",
  en: "Rose white",
  nl: "Roze wit",
  fr: "Blanc de rose"
}, {
  hex: "#f1e8ed",
  code: "340 93 05",
  scope: "Design System Plus",
  de: "Kleiderrosa",
  en: "Dress pink",
  nl: "Jurk roze",
  fr: "Robe rose"
}, {
  hex: "#514449",
  code: "350 20 10",
  scope: "Design System Plus",
  de: "Glühweinrot",
  en: "Mulled wine red",
  nl: "Glühwein rood",
  fr: "Rouge vin chaud"
}, {
  hex: "#57444b",
  code: "350 20 15",
  scope: "Design System Plus",
  de: "Sanftrot",
  en: "Soft red",
  nl: "Zacht rood",
  fr: "Rouge doux"
}, {
  hex: "#5c414b",
  code: "350 20 20",
  scope: "Design System Plus",
  de: "Sternrubin",
  en: "Star ruby",
  nl: "Ster robijn",
  fr: "Rubis étoile"
}, {
  hex: "#5f404c",
  code: "350 20 25",
  scope: "Design System Plus",
  de: "Chilischwarzrot",
  en: "Chilli black red",
  nl: "Chili zwart rood",
  fr: "Rouge chili noir"
}, {
  hex: "#653d4e",
  code: "350 20 30",
  scope: "Design System Plus",
  de: "Tulpenbaumpurpur",
  en: "Tulip poplar purple",
  nl: "Tulpenboom paars",
  fr: "Pourpre de tulipier"
}, {
  hex: "#625158",
  code: "350 30 10",
  scope: "Design System Plus",
  de: "Sperlinggraurot",
  en: "Sparrow grey red",
  nl: "Sperling grijs-rood",
  fr: "Gris éperlan"
}, {
  hex: "#684f59",
  code: "350 30 15",
  scope: "Design System Plus",
  de: "Kieselrot",
  en: "Siliceous red",
  nl: "Kiezelrood",
  fr: "Rouge silex"
}, {
  hex: "#6f4e5b",
  code: "350 30 20",
  scope: "Design System Plus",
  de: "Likörrot",
  en: "Liqueur red",
  nl: "Likeur rood",
  fr: "Rouge liqueur"
}, {
  hex: "#744b5c",
  code: "350 30 25",
  scope: "Design System Plus",
  de: "Weingummirot",
  en: "Wine gummy red",
  nl: "Wijngom rood",
  fr: "Rouge gomme vin"
}, {
  hex: "#7a4a5e",
  code: "350 30 30",
  scope: "Design System Plus",
  de: "Burlatrot",
  en: "Burlat red",
  nl: "Jute rood",
  fr: "Rouge burlat"
}, {
  hex: "#7b465e",
  code: "350 30 35",
  scope: "Design System Plus",
  de: "Bordeauxrot",
  en: "Bordeaux red",
  nl: "Bordeaux rood",
  fr: "Rouge bordeaux"
}, {
  hex: "#804360",
  code: "350 30 40",
  scope: "Design System Plus",
  de: "Trockenblumenpurpur",
  en: "Dried flower purple",
  nl: "Gedroogde bloem paars",
  fr: "Pourpre de fleurs séchées"
}, {
  hex: "#77656c",
  code: "350 40 10",
  scope: "Design System Plus",
  de: "Auberginengrau",
  en: "Aubergine grey",
  nl: "Aubergine grijs",
  fr: "Gris aubergine"
}, {
  hex: "#7d626d",
  code: "350 40 15",
  scope: "Design System Plus",
  de: "Schlafmohnmauve",
  en: "Opium mauve",
  nl: "Opiumpapaver mauve",
  fr: "Mauve coquelicot"
}, {
  hex: "#835f6f",
  code: "350 40 20",
  scope: "Design System Plus",
  de: "Graukarmin",
  en: "Grey carmine",
  nl: "Grijs karmijn",
  fr: "Carmin gris"
}, {
  hex: "#875c6f",
  code: "350 40 25",
  scope: "Design System Plus",
  de: "Nektarrot",
  en: "Nectar red",
  nl: "Nectar rood",
  fr: "Rouge nectar"
}, {
  hex: "#8f5971",
  code: "350 40 30",
  scope: "Design System Plus",
  de: "Dunkelrosé",
  en: "Dark rose",
  nl: "Donkere roos",
  fr: "Rose foncé"
}, {
  hex: "#945573",
  code: "350 40 35",
  scope: "Design System Plus",
  de: "Bonbonrot",
  en: "Bonbon red",
  nl: "Snoeprood",
  fr: "Rouge bonbon"
}, {
  hex: "#985374",
  code: "350 40 40",
  scope: "Design System Plus",
  de: "Zyclamenrot",
  en: "Cyclamen red",
  nl: "Cyclamen rood",
  fr: "Rouge cyclamen"
}, {
  hex: "#9d5075",
  code: "350 40 45",
  scope: "Design System Plus",
  de: "Puderrot",
  en: "Powder red",
  nl: "Poederrood",
  fr: "Rouge poudré"
}, {
  hex: "#a24b76",
  code: "350 40 50",
  scope: "Design System Plus",
  de: "Krapprot",
  en: "Madder red",
  nl: "Madder rood",
  fr: "Rouge garance"
}, {
  hex: "#8d7981",
  code: "350 50 10",
  scope: "Design System Plus",
  de: "Unschuldsrosa",
  en: "Innocent pink",
  nl: "Onschuldig roze",
  fr: "Rose innocent"
}, {
  hex: "#937682",
  code: "350 50 15",
  scope: "Design System Plus",
  de: "Stumpfviolett",
  en: "Blunt violet",
  nl: "Saai paars",
  fr: "Violet terne"
}, {
  hex: "#9b7385",
  code: "350 50 20",
  scope: "Design System Plus",
  de: "Korundrot",
  en: "Corundum red",
  nl: "Korund rood",
  fr: "Rouge corindon"
}, {
  hex: "#a27086",
  code: "350 50 25",
  scope: "Design System Plus",
  de: "Batikpink",
  en: "Batik pink",
  nl: "Batik roze",
  fr: "Rose batik"
}, {
  hex: "#a76e88",
  code: "350 50 30",
  scope: "Design System Plus",
  de: "Beryllrot",
  en: "Beryl red",
  nl: "Beryllrood",
  fr: "Rouge béryl"
}, {
  hex: "#af6888",
  code: "350 50 35",
  scope: "Design System Plus",
  de: "Hochrot",
  en: "Crimson",
  nl: "Hoog rood",
  fr: "Rouge vif"
}, {
  hex: "#b56589",
  code: "350 50 40",
  scope: "Design System Plus",
  de: "Krapprosa",
  en: "Madder rose",
  nl: "Rozer roze",
  fr: "Rose crapaud"
}, {
  hex: "#b6618b",
  code: "350 50 45",
  scope: "Design System Plus",
  de: "Signalpink",
  en: "Signal pink",
  nl: "Signaal roze",
  fr: "Rose de signalisation"
}, {
  hex: "#c25e8b",
  code: "350 50 50",
  scope: "Design System Plus",
  de: "Nagellackpink",
  en: "Nail polish pink",
  nl: "Nagellak roze",
  fr: "Vernis à ongles rose"
}, {
  hex: "#a59099",
  code: "350 60 10",
  scope: "Design System Plus",
  de: "Jugendstilviolett",
  en: "Art Nouveau violet",
  nl: "Art Nouveau violet",
  fr: "Violet art nouveau"
}, {
  hex: "#ac8c9a",
  code: "350 60 15",
  scope: "Design System Plus",
  de: "Mohairrosa",
  en: "Mohair pink",
  nl: "Mohair roze",
  fr: "Rose mohair"
}, {
  hex: "#b58b9d",
  code: "350 60 20",
  scope: "Design System Plus",
  de: "Heideblumenviolett",
  en: "Heather violet",
  nl: "Heidebloem viooltje",
  fr: "Violet de bruyère"
}, {
  hex: "#bc869d",
  code: "350 60 25",
  scope: "Design System Plus",
  de: "Heidekrautrosé",
  en: "Heather rose",
  nl: "Heide rosé",
  fr: "Rose bruyère"
}, {
  hex: "#c4839f",
  code: "350 60 30",
  scope: "Design System Plus",
  de: "Venetianerrosa",
  en: "Venetian pink",
  nl: "Venetiaans roze",
  fr: "Rose vénitien"
}, {
  hex: "#c87fa0",
  code: "350 60 35",
  scope: "Design System Plus",
  de: "Dolomitrot",
  en: "Dolomite red",
  nl: "Dolomiet rood",
  fr: "Rouge dolomite"
}, {
  hex: "#d07ca1",
  code: "350 60 40",
  scope: "Design System Plus",
  de: "Kamelienrosa",
  en: "Camellia pink",
  nl: "Camelia roze",
  fr: "Rose camélia"
}, {
  hex: "#d378a4",
  code: "350 60 45",
  scope: "Design System Plus",
  de: "Persischrosa",
  en: "Persian pink",
  nl: "Perzisch roze",
  fr: "Rose persan"
}, {
  hex: "#bfaab1",
  code: "350 70 10",
  scope: "Design System Plus",
  de: "Kaltrosa",
  en: "Cold pink",
  nl: "Koud roze",
  fr: "Rose froid"
}, {
  hex: "#c7a5b3",
  code: "350 70 15",
  scope: "Design System Plus",
  de: "Schattenrosa",
  en: "Shady pink",
  nl: "Schaduwroze",
  fr: "Rose d'ombre"
}, {
  hex: "#cb9fb3",
  code: "350 70 20",
  scope: "Design System Plus",
  de: "Grasnelkenrosa",
  en: "Lady's cushions pink",
  nl: "Anjer roze",
  fr: "Rose girofle"
}, {
  hex: "#d69fb6",
  code: "350 70 25",
  scope: "Design System Plus",
  de: "Korallenrosa",
  en: "Coral pink",
  nl: "Koraalroze",
  fr: "Rose corail"
}, {
  hex: "#de9bb8",
  code: "350 70 30",
  scope: "Design System Plus",
  de: "Technorosa",
  en: "Techno pink",
  nl: "Technorosa",
  fr: "Technorosa"
}, {
  hex: "#e498b9",
  code: "350 70 35",
  scope: "Design System Plus",
  de: "Kaugummipink",
  en: "Chewing gum pink",
  nl: "Kauwgom roze",
  fr: "Rose chewing-gum"
}, {
  hex: "#d9c1ca",
  code: "350 80 10",
  scope: "Design System Plus",
  de: "Magnolienweiß",
  en: "Magnolia white",
  nl: "Magnolia wit",
  fr: "Blanc magnolia"
}, {
  hex: "#e0bfcb",
  code: "350 80 15",
  scope: "Design System Plus",
  de: "Frühlingsrosa",
  en: "Spring pink",
  nl: "Lente roze",
  fr: "Rose printanier"
}, {
  hex: "#e9bccf",
  code: "350 80 20",
  scope: "Design System Plus",
  de: "Hellpink",
  en: "Light pink",
  nl: "Lichtroze",
  fr: "Rose clair"
}, {
  hex: "#ddd2d7",
  code: "350 85 05",
  scope: "Design System Plus",
  de: "Elfenweiß",
  en: "Fairy white",
  nl: "Feeënwit",
  fr: "Blanc ivoire"
}, {
  hex: "#e7cfd9",
  code: "350 85 10",
  scope: "Design System Plus",
  de: "Orchideenrosé",
  en: "Orchid rose",
  nl: "Rosé orchidee",
  fr: "Rose orchidée"
}, {
  hex: "#eeccd9",
  code: "350 85 15",
  scope: "Design System Plus",
  de: "Blasspink",
  en: "Pale pink",
  nl: "Blasspink",
  fr: "Blasspink"
}, {
  hex: "#eee1e2",
  code: "350 90 05",
  scope: "Design System Plus",
  de: "Lichtrosé",
  en: "Light rose",
  nl: "Lichtroze",
  fr: "Rose lumineuse"
}, {
  hex: "#f4dbe5",
  code: "350 90 10",
  scope: "Design System Plus",
  de: "Windröschenweiß",
  en: "Ranuncula white",
  nl: "Anemoon wit",
  fr: "Blanc anémone"
}, {
  hex: "#f4e8ec",
  code: "350 93 05",
  scope: "Design System Plus",
  de: "Clichyweiß",
  en: "Clichy white",
  nl: "Clichywit",
  fr: "Clichy blanc"
}, {
  hex: "#574247",
  code: "360 20 15",
  scope: "Design System Plus",
  de: "Piermontsteinrot",
  en: "Piermont stone red",
  nl: "Piermont steenrood",
  fr: "Rouge pierre de Piermont"
}, {
  hex: "#5d5456",
  code: "360 30 05",
  scope: "Design System Plus",
  de: "Rußrot",
  en: "Soot red",
  nl: "Roet rood",
  fr: "Rouge suie"
}, {
  hex: "#635156",
  code: "360 30 10",
  scope: "Design System Plus",
  de: "Pfefferkornrot",
  en: "Peppercorn red",
  nl: "Peperkorrel rood",
  fr: "Rouge grain de poivre"
}, {
  hex: "#684e56",
  code: "360 30 15",
  scope: "Design System Plus",
  de: "Primitivoweinrot",
  en: "Zinfandel red",
  nl: "Primitieve wijn rood",
  fr: "Rouge vin primitif"
}, {
  hex: "#704d57",
  code: "360 30 20",
  scope: "Design System Plus",
  de: "Artdecorot",
  en: "Art deco red",
  nl: "Artdecorot",
  fr: "Artdecorot"
}, {
  hex: "#734956",
  code: "360 30 25",
  scope: "Design System Plus",
  de: "Klinkerrot",
  en: "Clinker red",
  nl: "Klinkerrood",
  fr: "Rouge brique"
}, {
  hex: "#784657",
  code: "360 30 30",
  scope: "Design System Plus",
  de: "Kirschsaftrot",
  en: "Cherry juice red",
  nl: "Kersensap rood",
  fr: "Rouge jus de cerise"
}, {
  hex: "#814456",
  code: "360 30 35",
  scope: "Design System Plus",
  de: "Schlossrot",
  en: "Palace red",
  nl: "Kasteel rood",
  fr: "Rouge château"
}, {
  hex: "#834257",
  code: "360 30 40",
  scope: "Design System Plus",
  de: "Glutrot",
  en: "Ember red",
  nl: "Ember rood",
  fr: "Rouge incandescent"
}, {
  hex: "#726769",
  code: "360 40 05",
  scope: "Design System Plus",
  de: "Röstschwarz",
  en: "Roasted black",
  nl: "Geroosterd zwart",
  fr: "Noir torréfié"
}, {
  hex: "#766369",
  code: "360 40 10",
  scope: "Design System Plus",
  de: "Mokkabraun",
  en: "Mocha brown",
  nl: "Mokka bruin",
  fr: "Marron moka"
}, {
  hex: "#7d6069",
  code: "360 40 15",
  scope: "Design System Plus",
  de: "Rubingrau",
  en: "Ruby grey",
  nl: "Robijngrijs",
  fr: "Gris rubis"
}, {
  hex: "#845d69",
  code: "360 40 20",
  scope: "Design System Plus",
  de: "Barockrot",
  en: "Baroque red",
  nl: "Barok rood",
  fr: "Rouge baroque"
}, {
  hex: "#8a5a68",
  code: "360 40 25",
  scope: "Design System Plus",
  de: "Rauschrot",
  en: "Frenzied red",
  nl: "Donkerrood",
  fr: "Rouge brumeux"
}, {
  hex: "#91576a",
  code: "360 40 30",
  scope: "Design System Plus",
  de: "Johannisbeerrot",
  en: "Redcurrant",
  nl: "Zwarte bessen rood",
  fr: "Rouge groseille"
}, {
  hex: "#97546b",
  code: "360 40 35",
  scope: "Design System Plus",
  de: "Orientpink",
  en: "Orient pink",
  nl: "Oosters roze",
  fr: "Rose oriental"
}, {
  hex: "#9e506c",
  code: "360 40 40",
  scope: "Design System Plus",
  de: "Auroramagenta",
  en: "Aurora magenta",
  nl: "Auroramagenta",
  fr: "Auroramagenta"
}, {
  hex: "#a24d6a",
  code: "360 40 45",
  scope: "Design System Plus",
  de: "Kardinalrot",
  en: "Cardinal red",
  nl: "Kardinaalrood",
  fr: "Rouge cardinal"
}, {
  hex: "#a94669",
  code: "360 40 50",
  scope: "Design System Plus",
  de: "Salonrot",
  en: "Parlour red",
  nl: "Salon rood",
  fr: "Rouge salon"
}, {
  hex: "#887c7e",
  code: "360 50 05",
  scope: "Design System Plus",
  de: "Bimssteingrau",
  en: "Pumice grey",
  nl: "Puimsteen grijs",
  fr: "Gris pierre ponce"
}, {
  hex: "#8d787e",
  code: "360 50 10",
  scope: "Design System Plus",
  de: "Tresterrot",
  en: "Pomace red",
  nl: "Pomace rood",
  fr: "Rouge marc"
}, {
  hex: "#95747e",
  code: "360 50 15",
  scope: "Design System Plus",
  de: "Abendpurpur",
  en: "Evening crimson",
  nl: "Avond paars",
  fr: "Pourpre du soir"
}, {
  hex: "#9b727f",
  code: "360 50 20",
  scope: "Design System Plus",
  de: "Kupferrosa",
  en: "Copper pink",
  nl: "Koperroze",
  fr: "Rose cuivré"
}, {
  hex: "#a46e7d",
  code: "360 50 25",
  scope: "Design System Plus",
  de: "Jugendstilrosa",
  en: "Art Nouveau pink",
  nl: "Art Nouveau roze",
  fr: "Rose art nouveau"
}, {
  hex: "#aa6b80",
  code: "360 50 30",
  scope: "Design System Plus",
  de: "Kosmetikrot",
  en: "Cosmetic red",
  nl: "Cosmetisch rood",
  fr: "Rouge cosmétique"
}, {
  hex: "#b26780",
  code: "360 50 35",
  scope: "Design System Plus",
  de: "Indischpink",
  en: "Indian pink",
  nl: "Indisch roze",
  fr: "Rose indien"
}, {
  hex: "#b96680",
  code: "360 50 40",
  scope: "Design System Plus",
  de: "Kirroyalrosé",
  en: "Kir royale rose",
  nl: "Kirroyal rosé",
  fr: "Rose cerise"
}, {
  hex: "#c06281",
  code: "360 50 45",
  scope: "Design System Plus",
  de: "Hahnenkammrot",
  en: "Cockscomb red",
  nl: "Hanenkam rood",
  fr: "Rouge crête de coq"
}, {
  hex: "#c45d80",
  code: "360 50 50",
  scope: "Design System Plus",
  de: "Persischrot",
  en: "Persian red",
  nl: "Perzisch rood",
  fr: "Rouge persan"
}, {
  hex: "#9f9497",
  code: "360 60 05",
  scope: "Design System Plus",
  de: "Aschrosa",
  en: "Ash pink",
  nl: "Asroze",
  fr: "Rose cendré"
}, {
  hex: "#a58f95",
  code: "360 60 10",
  scope: "Design System Plus",
  de: "Majolikamauve",
  en: "Majolica mauve",
  nl: "Majolica mauve",
  fr: "Majolikamauve"
}, {
  hex: "#ae8d96",
  code: "360 60 15",
  scope: "Design System Plus",
  de: "Feigenfruchtlila",
  en: "Fig fruit mauve",
  nl: "Vijgenvrucht paars",
  fr: "Mauve fruit de la figue"
}, {
  hex: "#b78a97",
  code: "360 60 20",
  scope: "Design System Plus",
  de: "Edelflieder",
  en: "Noble lilac",
  nl: "Edele sering",
  fr: "Lilas noble"
}, {
  hex: "#bd8597",
  code: "360 60 25",
  scope: "Design System Plus",
  de: "Hellrot",
  en: "Light red",
  nl: "Licht rood",
  fr: "Rouge clair"
}, {
  hex: "#b9adb0",
  code: "360 70 05",
  scope: "Design System Plus",
  de: "Teeblütenrosa",
  en: "Tea blossom pink",
  nl: "Theebloesem roze",
  fr: "Rose fleur de thé"
}, {
  hex: "#c0a7ae",
  code: "360 70 10",
  scope: "Design System Plus",
  de: "Quarzrosa",
  en: "Quartz pink",
  nl: "Kwartsroze",
  fr: "Rose quartz"
}, {
  hex: "#c9a5af",
  code: "360 70 15",
  scope: "Design System Plus",
  de: "Opalinrosa",
  en: "Opaline pink",
  nl: "Opaline roze",
  fr: "Rose opalin"
}, {
  hex: "#d3c7c9",
  code: "360 80 05",
  scope: "Design System Plus",
  de: "Perlmuttrosa",
  en: "Mother-of-pearl pink",
  nl: "Parelmoer roze",
  fr: "Rose nacré"
}, {
  hex: "#dbc2c8",
  code: "360 80 10",
  scope: "Design System Plus",
  de: "Venezianerrosa",
  en: "Venetian pink",
  nl: "Venetiaans roze",
  fr: "Rose vénitien"
}, {
  hex: "#e4bfc9",
  code: "360 80 15",
  scope: "Design System Plus",
  de: "Seifenrosa",
  en: "Soap pink",
  nl: "Zeep roze",
  fr: "Rose savonnette"
}, {
  hex: "#e0d2d4",
  code: "360 85 05",
  scope: "Design System Plus",
  de: "Theaterpuderrosé",
  en: "Theatre powder rose",
  nl: "Theaterpoeder rosé",
  fr: "Rose théâtral"
}, {
  hex: "#e8cfd5",
  code: "360 85 10",
  scope: "Design System Plus",
  de: "Lotusrosa",
  en: "Lotus pink",
  nl: "Lotus roze",
  fr: "Rose lotus"
}, {
  hex: "#f1e2e1",
  code: "360 90 05",
  scope: "Design System Plus",
  de: "Eisrosa",
  en: "Ice pink",
  nl: "IJsroze",
  fr: "Rose glacé"
}, {
  hex: "#f7dde3",
  code: "360 90 10",
  scope: "Design System Plus",
  de: "Tortencreme",
  en: "Cake frosting",
  nl: "Taartcrème",
  fr: "Crème à tarte"
}, {
  hex: "#f6e8e9",
  code: "360 93 05",
  scope: "Design System Plus",
  de: "Pfeilkrautweiß",
  en: "Arrowhead white",
  nl: "Pijlpunt wit",
  fr: "Arrowbow white"
}], $zt = Qzt.concat(_zt, jzt, qzt);
function fr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function GO(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pj(n.key), n);
  }
}
function Zr(e, t, i) {
  return t && GO(e.prototype, t), i && GO(e, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Jo(e, t) {
  if (t && (tA(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return TQ(e);
}
function an(e) {
  return an = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, an(e);
}
function Eo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && TV(e, t);
}
function zre() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Ore(e) {
  function t(i) {
    var n = this.constructor.getDerivedStateFromProps(e, i);
    return n ?? null;
  }
  this.setState(t.bind(this));
}
function Qre(e, t) {
  try {
    var i = this.props, n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      i,
      n
    );
  } finally {
    this.props = i, this.state = n;
  }
}
zre.__suppressDeprecationWarning = !0;
Ore.__suppressDeprecationWarning = !0;
Qre.__suppressDeprecationWarning = !0;
function fG(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var i = null, n = null, r = null;
  if (typeof t.componentWillMount == "function" ? i = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (i = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? r = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (r = "UNSAFE_componentWillUpdate"), i !== null || n !== null || r !== null) {
    var g = e.displayName || e.name, o = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + g + " uses " + o + " but also contains the following legacy lifecycles:" + (i !== null ? `
  ` + i : "") + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = zre, t.componentWillReceiveProps = Ore), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Qre;
    var l = t.componentDidUpdate;
    t.componentDidUpdate = function(I, c, d) {
      var C = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : d;
      l.call(this, I, c, C);
    };
  }
  return e;
}
function yO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function WO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : yO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function eOt(e, t, i) {
  return t = an(t), Jo(e, jre() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function jre() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jre = function() {
    return !!e;
  })();
}
var qre = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = eOt(this, t, [].concat(r)), We(i, "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    }), We(i, "_columnStartIndex", 0), We(i, "_columnStopIndex", 0), We(i, "_rowStartIndex", 0), We(i, "_rowStopIndex", 0), We(i, "_onKeyDown", function(o) {
      var l = i.props, a = l.columnCount, I = l.disabled, c = l.mode, d = l.rowCount;
      if (!I) {
        var C = i._getScrollState(), A = C.scrollToColumn, b = C.scrollToRow, m = i._getScrollState(), p = m.scrollToColumn, B = m.scrollToRow;
        switch (o.key) {
          case "ArrowDown":
            B = Math.min(c === "cells" ? B + 1 : i._rowStopIndex + 1, d - 1);
            break;
          case "ArrowLeft":
            p = Math.max(c === "cells" ? p - 1 : i._columnStartIndex - 1, 0);
            break;
          case "ArrowRight":
            p = Math.min(c === "cells" ? p + 1 : i._columnStopIndex + 1, a - 1);
            break;
          case "ArrowUp":
            B = Math.max(c === "cells" ? B - 1 : i._rowStartIndex - 1, 0);
            break;
        }
        (p !== A || B !== b) && (o.preventDefault(), i._updateScrollState({
          scrollToColumn: p,
          scrollToRow: B
        }));
      }
    }), We(i, "_onSectionRendered", function(o) {
      var l = o.columnStartIndex, a = o.columnStopIndex, I = o.rowStartIndex, c = o.rowStopIndex;
      i._columnStartIndex = l, i._columnStopIndex = a, i._rowStartIndex = I, i._rowStopIndex = c;
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "setScrollIndexes",
    value: function(n) {
      var r = n.scrollToColumn, g = n.scrollToRow;
      this.setState({
        scrollToRow: g,
        scrollToColumn: r
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.className, g = n.children, o = this._getScrollState(), l = o.scrollToColumn, a = o.scrollToRow;
      return /* @__PURE__ */ X.createElement("div", {
        className: r,
        onKeyDown: this._onKeyDown
      }, g({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: l,
        scrollToRow: a
      }));
    }
  }, {
    key: "_getScrollState",
    value: function() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function(n) {
      var r = n.scrollToColumn, g = n.scrollToRow, o = this.props, l = o.isControlled, a = o.onScrollToChange;
      typeof a == "function" && a({
        scrollToColumn: r,
        scrollToRow: g
      }), l || this.setState({
        scrollToColumn: r,
        scrollToRow: g
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, r) {
      return n.isControlled ? {} : n.scrollToColumn !== r.instanceProps.prevScrollToColumn || n.scrollToRow !== r.instanceProps.prevScrollToRow ? WO(WO({}, r), {}, {
        scrollToColumn: n.scrollToColumn,
        scrollToRow: n.scrollToRow,
        instanceProps: {
          prevScrollToColumn: n.scrollToColumn,
          prevScrollToRow: n.scrollToRow
        }
      }) : {};
    }
  }]);
}(X.PureComponent);
We(qre, "defaultProps", {
  disabled: !1,
  isControlled: !1,
  mode: "edges",
  scrollToColumn: 0,
  scrollToRow: 0
});
fG(qre);
function _re(e, t) {
  var i;
  typeof t < "u" ? i = t : typeof window < "u" ? i = window : typeof self < "u" ? i = self : i = global;
  var n = typeof i.document < "u" && i.document.attachEvent;
  if (!n) {
    var r = function() {
      var w = i.requestAnimationFrame || i.mozRequestAnimationFrame || i.webkitRequestAnimationFrame || function(v) {
        return i.setTimeout(v, 20);
      };
      return function(v) {
        return w(v);
      };
    }(), g = function() {
      var w = i.cancelAnimationFrame || i.mozCancelAnimationFrame || i.webkitCancelAnimationFrame || i.clearTimeout;
      return function(v) {
        return w(v);
      };
    }(), o = function(v) {
      var H = v.__resizeTriggers__, x = H.firstElementChild, J = H.lastElementChild, K = x.firstElementChild;
      J.scrollLeft = J.scrollWidth, J.scrollTop = J.scrollHeight, K.style.width = x.offsetWidth + 1 + "px", K.style.height = x.offsetHeight + 1 + "px", x.scrollLeft = x.scrollWidth, x.scrollTop = x.scrollHeight;
    }, l = function(v) {
      return v.offsetWidth != v.__resizeLast__.width || v.offsetHeight != v.__resizeLast__.height;
    }, a = function(v) {
      if (!(v.target.className && typeof v.target.className.indexOf == "function" && v.target.className.indexOf("contract-trigger") < 0 && v.target.className.indexOf("expand-trigger") < 0)) {
        var H = this;
        o(this), this.__resizeRAF__ && g(this.__resizeRAF__), this.__resizeRAF__ = r(function() {
          l(H) && (H.__resizeLast__.width = H.offsetWidth, H.__resizeLast__.height = H.offsetHeight, H.__resizeListeners__.forEach(function(x) {
            x.call(H, v);
          }));
        });
      }
    }, I = !1, c = "", d = "animationstart", C = "Webkit Moz O ms".split(" "), A = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), b = "";
    {
      var m = i.document.createElement("fakeelement");
      if (m.style.animationName !== void 0 && (I = !0), I === !1) {
        for (var p = 0; p < C.length; p++)
          if (m.style[C[p] + "AnimationName"] !== void 0) {
            b = C[p], c = "-" + b.toLowerCase() + "-", d = A[p], I = !0;
            break;
          }
      }
    }
    var B = "resizeanim", f = "@" + c + "keyframes " + B + " { from { opacity: 0; } to { opacity: 0; } } ", Z = c + "animation: 1ms " + B + "; ";
  }
  var y = function(v) {
    if (!v.getElementById("detectElementResize")) {
      var H = (f || "") + ".resize-triggers { " + (Z || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', x = v.head || v.getElementsByTagName("head")[0], J = v.createElement("style");
      J.id = "detectElementResize", J.type = "text/css", e != null && J.setAttribute("nonce", e), J.styleSheet ? J.styleSheet.cssText = H : J.appendChild(v.createTextNode(H)), x.appendChild(J);
    }
  }, W = function(v, H) {
    if (n)
      v.attachEvent("onresize", H);
    else {
      if (!v.__resizeTriggers__) {
        var x = v.ownerDocument, J = i.getComputedStyle(v);
        J && J.position == "static" && (v.style.position = "relative"), y(x), v.__resizeLast__ = {}, v.__resizeListeners__ = [], (v.__resizeTriggers__ = x.createElement("div")).className = "resize-triggers";
        var K = x.createElement("div");
        K.className = "expand-trigger", K.appendChild(x.createElement("div"));
        var M = x.createElement("div");
        M.className = "contract-trigger", v.__resizeTriggers__.appendChild(K), v.__resizeTriggers__.appendChild(M), v.appendChild(v.__resizeTriggers__), o(v), v.addEventListener("scroll", a, !0), d && (v.__resizeTriggers__.__animationListener__ = function(N) {
          N.animationName == B && o(v);
        }, v.__resizeTriggers__.addEventListener(d, v.__resizeTriggers__.__animationListener__));
      }
      v.__resizeListeners__.push(H);
    }
  }, V = function(v, H) {
    if (n)
      v.detachEvent("onresize", H);
    else if (v.__resizeListeners__.splice(v.__resizeListeners__.indexOf(H), 1), !v.__resizeListeners__.length) {
      v.removeEventListener("scroll", a, !0), v.__resizeTriggers__.__animationListener__ && (v.__resizeTriggers__.removeEventListener(d, v.__resizeTriggers__.__animationListener__), v.__resizeTriggers__.__animationListener__ = null);
      try {
        v.__resizeTriggers__ = !v.removeChild(v.__resizeTriggers__);
      } catch {
      }
    }
  };
  return {
    addResizeListener: W,
    removeResizeListener: V
  };
}
function SO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function VO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? SO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : SO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function tOt(e, t, i) {
  return t = an(t), Jo(e, $re() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function $re() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($re = function() {
    return !!e;
  })();
}
var iOt = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = tOt(this, t, [].concat(r)), We(i, "state", {
      height: i.props.defaultHeight || 0,
      width: i.props.defaultWidth || 0
    }), We(i, "_parentNode", void 0), We(i, "_autoSizer", void 0), We(i, "_window", void 0), We(i, "_detectElementResize", void 0), We(i, "_onResize", function() {
      var o = i.props, l = o.disableHeight, a = o.disableWidth, I = o.onResize;
      if (i._parentNode) {
        var c = i._parentNode.offsetHeight || 0, d = i._parentNode.offsetWidth || 0, C = i._window || window, A = C.getComputedStyle(i._parentNode) || {}, b = parseInt(A.paddingLeft, 10) || 0, m = parseInt(A.paddingRight, 10) || 0, p = parseInt(A.paddingTop, 10) || 0, B = parseInt(A.paddingBottom, 10) || 0, f = c - p - B, Z = d - b - m;
        (!l && i.state.height !== f || !a && i.state.width !== Z) && (i.setState({
          height: c - p - B,
          width: d - b - m
        }), I({
          height: c,
          width: d
        }));
      }
    }), We(i, "_setRef", function(o) {
      i._autoSizer = o;
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "componentDidMount",
    value: function() {
      var n = this.props.nonce;
      this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._window = this._autoSizer.parentNode.ownerDocument.defaultView, this._detectElementResize = _re(n, this._window), this._detectElementResize.addResizeListener(this._parentNode, this._onResize), this._onResize());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._detectElementResize && this._parentNode && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.children, g = n.className, o = n.disableHeight, l = n.disableWidth, a = n.style, I = this.state, c = I.height, d = I.width, C = {
        overflow: "visible"
      }, A = {};
      return o || (C.height = 0, A.height = c), l || (C.width = 0, A.width = d), /* @__PURE__ */ X.createElement("div", {
        className: g,
        ref: this._setRef,
        style: VO(VO({}, C), a)
      }, r(A));
    }
  }]);
}(X.Component);
We(iOt, "defaultProps", {
  onResize: function() {
  },
  disableHeight: !1,
  disableWidth: !1,
  style: {}
});
function nOt(e, t, i) {
  return t = an(t), Jo(e, ege() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function ege() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ege = function() {
    return !!e;
  })();
}
var tge = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = nOt(this, t, [].concat(r)), We(i, "_child", /* @__PURE__ */ X.createRef()), We(i, "_measure", function() {
      var o = i.props, l = o.cache, a = o.columnIndex, I = a === void 0 ? 0 : a, c = o.parent, d = o.rowIndex, C = d === void 0 ? i.props.index || 0 : d, A = i._getCellMeasurements(), b = A.height, m = A.width;
      (b !== l.getHeight(C, I) || m !== l.getWidth(C, I)) && (l.set(C, I, m, b), c && typeof c.recomputeGridSize == "function" && c.recomputeGridSize({
        columnIndex: I,
        rowIndex: C
      }));
    }), We(i, "_registerChild", function(o) {
      o && !(o instanceof Element) && console.warn("CellMeasurer registerChild expects to be passed Element or null"), i._child.current = o, o && i._maybeMeasureCell();
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "componentDidMount",
    value: function() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, r = this.props.children, g = typeof r == "function" ? r({
        measure: this._measure,
        registerChild: this._registerChild
      }) : r;
      return g === null ? g : /* @__PURE__ */ Jd(g, {
        ref: function(l) {
          typeof g.ref == "function" ? g.ref(l) : g.ref && (g.ref.current = l), n._child.current = l;
        }
      });
    }
  }, {
    key: "_getCellMeasurements",
    value: function() {
      var n = this.props.cache, r = this._child.current;
      if (r && r.ownerDocument && r.ownerDocument.defaultView && r instanceof r.ownerDocument.defaultView.HTMLElement) {
        var g = r.style.width, o = r.style.height;
        n.hasFixedWidth() || (r.style.width = "auto"), n.hasFixedHeight() || (r.style.height = "auto");
        var l = Math.ceil(r.offsetHeight), a = Math.ceil(r.offsetWidth);
        return g && (r.style.width = g), o && (r.style.height = o), {
          height: l,
          width: a
        };
      } else
        return {
          height: 0,
          width: 0
        };
    }
  }, {
    key: "_maybeMeasureCell",
    value: function() {
      var n = this.props, r = n.cache, g = n.columnIndex, o = g === void 0 ? 0 : g, l = n.parent, a = n.rowIndex, I = a === void 0 ? this.props.index || 0 : a;
      if (!r.has(I, o)) {
        var c = this._getCellMeasurements(), d = c.height, C = c.width;
        r.set(I, o, C, d), l && typeof l.invalidateCellSizeAfterRender == "function" && l.invalidateCellSizeAfterRender({
          columnIndex: o,
          rowIndex: I
        });
      }
    }
  }]);
}(X.PureComponent);
We(tge, "__internalCellMeasurerFlag", !1);
var rOt = 30, gOt = 100, oOt = /* @__PURE__ */ function() {
  function e() {
    var t = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    fr(this, e), We(this, "_cellHeightCache", {}), We(this, "_cellWidthCache", {}), We(this, "_columnWidthCache", {}), We(this, "_rowHeightCache", {}), We(this, "_defaultHeight", void 0), We(this, "_defaultWidth", void 0), We(this, "_minHeight", void 0), We(this, "_minWidth", void 0), We(this, "_keyMapper", void 0), We(this, "_hasFixedHeight", void 0), We(this, "_hasFixedWidth", void 0), We(this, "_columnCount", 0), We(this, "_rowCount", 0), We(this, "columnWidth", function(c) {
      var d = c.index, C = t._keyMapper(0, d);
      return t._columnWidthCache[C] !== void 0 ? t._columnWidthCache[C] : t._defaultWidth;
    }), We(this, "rowHeight", function(c) {
      var d = c.index, C = t._keyMapper(d, 0);
      return t._rowHeightCache[C] !== void 0 ? t._rowHeightCache[C] : t._defaultHeight;
    });
    var n = i.defaultHeight, r = i.defaultWidth, g = i.fixedHeight, o = i.fixedWidth, l = i.keyMapper, a = i.minHeight, I = i.minWidth;
    this._hasFixedHeight = g === !0, this._hasFixedWidth = o === !0, this._minHeight = a || 0, this._minWidth = I || 0, this._keyMapper = l || lOt, this._defaultHeight = Math.max(this._minHeight, typeof n == "number" ? n : rOt), this._defaultWidth = Math.max(this._minWidth, typeof r == "number" ? r : gOt);
  }
  return Zr(e, [{
    key: "clear",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._keyMapper(i, n);
      delete this._cellHeightCache[r], delete this._cellWidthCache[r], this._updateCachedColumnAndRowSizes(i, n);
    }
  }, {
    key: "clearAll",
    value: function() {
      this._cellHeightCache = {}, this._cellWidthCache = {}, this._columnWidthCache = {}, this._rowHeightCache = {}, this._rowCount = 0, this._columnCount = 0;
    }
  }, {
    key: "defaultHeight",
    get: function() {
      return this._defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function() {
      return this._defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function() {
      return this._hasFixedHeight;
    }
  }, {
    key: "hasFixedWidth",
    value: function() {
      return this._hasFixedWidth;
    }
  }, {
    key: "getHeight",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedHeight)
        return this._defaultHeight;
      var r = this._keyMapper(i, n);
      return this._cellHeightCache[r] !== void 0 ? Math.max(this._minHeight, this._cellHeightCache[r]) : this._defaultHeight;
    }
  }, {
    key: "getWidth",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (this._hasFixedWidth)
        return this._defaultWidth;
      var r = this._keyMapper(i, n);
      return this._cellWidthCache[r] !== void 0 ? Math.max(this._minWidth, this._cellWidthCache[r]) : this._defaultWidth;
    }
  }, {
    key: "has",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._keyMapper(i, n);
      return this._cellHeightCache[r] !== void 0;
    }
  }, {
    key: "set",
    value: function(i, n, r, g) {
      var o = this._keyMapper(i, n);
      n >= this._columnCount && (this._columnCount = n + 1), i >= this._rowCount && (this._rowCount = i + 1), this._cellHeightCache[o] = g, this._cellWidthCache[o] = r, this._updateCachedColumnAndRowSizes(i, n);
    }
  }, {
    key: "_updateCachedColumnAndRowSizes",
    value: function(i, n) {
      if (!this._hasFixedWidth) {
        for (var r = 0, g = 0; g < this._rowCount; g++)
          r = Math.max(r, this.getWidth(g, n));
        var o = this._keyMapper(0, n);
        this._columnWidthCache[o] = r;
      }
      if (!this._hasFixedHeight) {
        for (var l = 0, a = 0; a < this._columnCount; a++)
          l = Math.max(l, this.getHeight(i, a));
        var I = this._keyMapper(i, 0);
        this._rowHeightCache[I] = l;
      }
    }
  }]);
}();
function lOt(e, t) {
  return "".concat(e, "-").concat(t);
}
function aOt(e) {
  if (e == null)
    throw new TypeError("Cannot destructure " + e);
}
function mm() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, t = {};
  return function(i) {
    var n = i.callback, r = i.indices, g = Object.keys(r), o = !e || g.every(function(a) {
      var I = r[a];
      return Array.isArray(I) ? I.length > 0 : I >= 0;
    }), l = g.length !== Object.keys(t).length || g.some(function(a) {
      var I = t[a], c = r[a];
      return Array.isArray(c) ? I.join(",") !== c.join(",") : I !== c;
    });
    t = r, o && l && n(r);
  };
}
const sOt = !!(typeof window < "u" && window.document && window.document.createElement);
var QS;
function pD(e) {
  if ((!QS && QS !== 0 || e) && sOt) {
    var t = document.createElement("div");
    t.style.position = "absolute", t.style.top = "-9999px", t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t), QS = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return QS;
}
function wO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function vO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : wO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function IOt(e, t, i) {
  return t = an(t), Jo(e, ige() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function ige() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ige = function() {
    return !!e;
  })();
}
var cOt = 150, Wh = {
  OBSERVED: "observed",
  REQUESTED: "requested"
}, q1 = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = IOt(this, t, [].concat(r)), We(i, "state", {
      isScrolling: !1,
      scrollLeft: 0,
      scrollTop: 0
    }), We(i, "_calculateSizeAndPositionDataOnNextUpdate", !1), We(i, "_onSectionRenderedMemoizer", mm()), We(i, "_onScrollMemoizer", mm(!1)), We(i, "_invokeOnSectionRenderedHelper", function() {
      var o = i.props, l = o.cellLayoutManager, a = o.onSectionRendered;
      i._onSectionRenderedMemoizer({
        callback: a,
        indices: {
          indices: l.getLastRenderedIndices()
        }
      });
    }), We(i, "_setScrollingContainerRef", function(o) {
      i._scrollingContainer = o;
    }), We(i, "_updateScrollPositionForScrollToCell", function() {
      var o = i.props, l = o.cellLayoutManager, a = o.height, I = o.scrollToAlignment, c = o.scrollToCell, d = o.width, C = i.state, A = C.scrollLeft, b = C.scrollTop;
      if (c >= 0) {
        var m = l.getScrollPositionForCell({
          align: I,
          cellIndex: c,
          height: a,
          scrollLeft: A,
          scrollTop: b,
          width: d
        });
        (m.scrollLeft !== A || m.scrollTop !== b) && i._setScrollPosition(m);
      }
    }), We(i, "_onScroll", function(o) {
      if (o.target === i._scrollingContainer) {
        i._enablePointerEventsAfterDelay();
        var l = i.props, a = l.cellLayoutManager, I = l.height, c = l.isScrollingChange, d = l.width, C = i._scrollbarSize, A = a.getTotalSize(), b = A.height, m = A.width, p = Math.max(0, Math.min(m - d + C, o.target.scrollLeft)), B = Math.max(0, Math.min(b - I + C, o.target.scrollTop));
        if (i.state.scrollLeft !== p || i.state.scrollTop !== B) {
          var f = o.cancelable ? Wh.OBSERVED : Wh.REQUESTED;
          i.state.isScrolling || c(!0), i.setState({
            isScrolling: !0,
            scrollLeft: p,
            scrollPositionChangeReason: f,
            scrollTop: B
          });
        }
        i._invokeOnScrollMemoizer({
          scrollLeft: p,
          scrollTop: B,
          totalWidth: m,
          totalHeight: b
        });
      }
    }), i._scrollbarSize = pD(), i._scrollbarSize === void 0 ? (i._scrollbarSizeMeasured = !1, i._scrollbarSize = 0) : i._scrollbarSizeMeasured = !0, i;
  }
  return Eo(t, e), Zr(t, [{
    key: "recomputeCellSizesAndPositions",
    value: function() {
      this._calculateSizeAndPositionDataOnNextUpdate = !0, this.forceUpdate();
    }
    /* ---------------------------- Component lifecycle methods ---------------------------- */
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.props, r = n.cellLayoutManager, g = n.scrollLeft, o = n.scrollToCell, l = n.scrollTop;
      this._scrollbarSizeMeasured || (this._scrollbarSize = pD(), this._scrollbarSizeMeasured = !0, this.setState({})), o >= 0 ? this._updateScrollPositionForScrollToCell() : (g >= 0 || l >= 0) && this._setScrollPosition({
        scrollLeft: g,
        scrollTop: l
      }), this._invokeOnSectionRenderedHelper();
      var a = r.getTotalSize(), I = a.height, c = a.width;
      this._invokeOnScrollMemoizer({
        scrollLeft: g || 0,
        scrollTop: l || 0,
        totalHeight: I,
        totalWidth: c
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, r) {
      var g = this.props, o = g.height, l = g.scrollToAlignment, a = g.scrollToCell, I = g.width, c = this.state, d = c.scrollLeft, C = c.scrollPositionChangeReason, A = c.scrollTop;
      C === Wh.REQUESTED && (d >= 0 && d !== r.scrollLeft && d !== this._scrollingContainer.scrollLeft && (this._scrollingContainer.scrollLeft = d), A >= 0 && A !== r.scrollTop && A !== this._scrollingContainer.scrollTop && (this._scrollingContainer.scrollTop = A)), (o !== n.height || l !== n.scrollToAlignment || a !== n.scrollToCell || I !== n.width) && this._updateScrollPositionForScrollToCell(), this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.autoHeight, g = n.cellCount, o = n.cellLayoutManager, l = n.className, a = n.height, I = n.horizontalOverscanSize, c = n.id, d = n.noContentRenderer, C = n.style, A = n.verticalOverscanSize, b = n.width, m = this.state, p = m.isScrolling, B = m.scrollLeft, f = m.scrollTop;
      (this._lastRenderedCellCount !== g || this._lastRenderedCellLayoutManager !== o || this._calculateSizeAndPositionDataOnNextUpdate) && (this._lastRenderedCellCount = g, this._lastRenderedCellLayoutManager = o, this._calculateSizeAndPositionDataOnNextUpdate = !1, o.calculateSizeAndPositionData());
      var Z = o.getTotalSize(), y = Z.height, W = Z.width, V = Math.max(0, B - I), w = Math.max(0, f - A), v = Math.min(W, B + b + I), H = Math.min(y, f + a + A), x = a > 0 && b > 0 ? o.cellRenderers({
        height: H - w,
        isScrolling: p,
        width: v - V,
        x: V,
        y: w
      }) : [], J = {
        boxSizing: "border-box",
        direction: "ltr",
        height: r ? "auto" : a,
        position: "relative",
        WebkitOverflowScrolling: "touch",
        width: b,
        willChange: "transform"
      }, K = y > a ? this._scrollbarSize : 0, M = W > b ? this._scrollbarSize : 0;
      return J.overflowX = W + K <= b ? "hidden" : "auto", J.overflowY = y + M <= a ? "hidden" : "auto", /* @__PURE__ */ X.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: Ag("ReactVirtualized__Collection", l),
        id: c,
        onScroll: this._onScroll,
        role: "grid",
        style: vO(vO({}, J), C),
        tabIndex: 0
      }, g > 0 && /* @__PURE__ */ X.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: y,
          maxHeight: y,
          maxWidth: W,
          overflow: "hidden",
          pointerEvents: p ? "none" : "",
          width: W
        }
      }, x), g === 0 && d());
    }
    /* ---------------------------- Helper methods ---------------------------- */
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function() {
      var n = this;
      this._disablePointerEventsTimeoutId && clearTimeout(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = setTimeout(function() {
        var r = n.props.isScrollingChange;
        r(!1), n._disablePointerEventsTimeoutId = null, n.setState({
          isScrolling: !1
        });
      }, cOt);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function(n) {
      var r = this, g = n.scrollLeft, o = n.scrollTop, l = n.totalHeight, a = n.totalWidth;
      this._onScrollMemoizer({
        callback: function(c) {
          var d = c.scrollLeft, C = c.scrollTop, A = r.props, b = A.height, m = A.onScroll, p = A.width;
          m({
            clientHeight: b,
            clientWidth: p,
            scrollHeight: l,
            scrollLeft: d,
            scrollTop: C,
            scrollWidth: a
          });
        },
        indices: {
          scrollLeft: g,
          scrollTop: o
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function(n) {
      var r = n.scrollLeft, g = n.scrollTop, o = {
        scrollPositionChangeReason: Wh.REQUESTED
      };
      r >= 0 && (o.scrollLeft = r), g >= 0 && (o.scrollTop = g), (r >= 0 && r !== this.state.scrollLeft || g >= 0 && g !== this.state.scrollTop) && this.setState(o);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, r) {
      return n.cellCount === 0 && (r.scrollLeft !== 0 || r.scrollTop !== 0) ? {
        scrollLeft: 0,
        scrollTop: 0,
        scrollPositionChangeReason: Wh.REQUESTED
      } : n.scrollLeft !== r.scrollLeft || n.scrollTop !== r.scrollTop ? {
        scrollLeft: n.scrollLeft != null ? n.scrollLeft : r.scrollLeft,
        scrollTop: n.scrollTop != null ? n.scrollTop : r.scrollTop,
        scrollPositionChangeReason: Wh.REQUESTED
      } : null;
    }
  }]);
}(X.PureComponent);
We(q1, "defaultProps", {
  "aria-label": "grid",
  horizontalOverscanSize: 0,
  noContentRenderer: function() {
    return null;
  },
  onScroll: function() {
    return null;
  },
  onSectionRendered: function() {
    return null;
  },
  scrollToAlignment: "auto",
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});
q1.propTypes = {};
fG(q1);
var dOt = /* @__PURE__ */ function() {
  function e(t) {
    var i = t.height, n = t.width, r = t.x, g = t.y;
    fr(this, e), this.height = i, this.width = n, this.x = r, this.y = g, this._indexMap = {}, this._indices = [];
  }
  return Zr(e, [{
    key: "addCellIndex",
    value: function(i) {
      var n = i.index;
      this._indexMap[n] || (this._indexMap[n] = !0, this._indices.push(n));
    }
    /** Get all cell indices that have been added to this section. */
  }, {
    key: "getCellIndices",
    value: function() {
      return this._indices;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);
}(), uOt = 100, COt = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : uOt;
    fr(this, e), this._sectionSize = t, this._cellMetadata = [], this._sections = {};
  }
  return Zr(e, [{
    key: "getCellIndices",
    value: function(i) {
      var n = i.height, r = i.width, g = i.x, o = i.y, l = {};
      return this.getSections({
        height: n,
        width: r,
        x: g,
        y: o
      }).forEach(function(a) {
        return a.getCellIndices().forEach(function(I) {
          l[I] = I;
        });
      }), Object.keys(l).map(function(a) {
        return l[a];
      });
    }
    /** Get size and position information for the cell specified. */
  }, {
    key: "getCellMetadata",
    value: function(i) {
      var n = i.index;
      return this._cellMetadata[n];
    }
    /** Get all Sections overlapping the specified region. */
  }, {
    key: "getSections",
    value: function(i) {
      for (var n = i.height, r = i.width, g = i.x, o = i.y, l = Math.floor(g / this._sectionSize), a = Math.floor((g + r - 1) / this._sectionSize), I = Math.floor(o / this._sectionSize), c = Math.floor((o + n - 1) / this._sectionSize), d = [], C = l; C <= a; C++)
        for (var A = I; A <= c; A++) {
          var b = "".concat(C, ".").concat(A);
          this._sections[b] || (this._sections[b] = new dOt({
            height: this._sectionSize,
            width: this._sectionSize,
            x: C * this._sectionSize,
            y: A * this._sectionSize
          })), d.push(this._sections[b]);
        }
      return d;
    }
    /** Total number of Sections based on the currently registered cells. */
  }, {
    key: "getTotalSectionCount",
    value: function() {
      return Object.keys(this._sections).length;
    }
    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function() {
      var i = this;
      return Object.keys(this._sections).map(function(n) {
        return i._sections[n].toString();
      });
    }
    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
  }, {
    key: "registerCell",
    value: function(i) {
      var n = i.cellMetadatum, r = i.index;
      this._cellMetadata[r] = n, this.getSections(n).forEach(function(g) {
        return g.addCellIndex({
          index: r
        });
      });
    }
  }]);
}();
function AOt(e) {
  for (var t = e.cellCount, i = e.cellSizeAndPositionGetter, n = e.sectionSize, r = [], g = new COt(n), o = 0, l = 0, a = 0; a < t; a++) {
    var I = i({
      index: a
    });
    if (I.height == null || isNaN(I.height) || I.width == null || isNaN(I.width) || I.x == null || isNaN(I.x) || I.y == null || isNaN(I.y))
      throw Error("Invalid metadata returned for cell ".concat(a, `:
        x:`).concat(I.x, ", y:").concat(I.y, ", width:").concat(I.width, ", height:").concat(I.height));
    o = Math.max(o, I.y + I.height), l = Math.max(l, I.x + I.width), r[a] = I, g.registerCell({
      cellMetadatum: I,
      index: a
    });
  }
  return {
    cellMetadata: r,
    height: o,
    sectionManager: g,
    width: l
  };
}
function RO(e) {
  var t = e.align, i = t === void 0 ? "auto" : t, n = e.cellOffset, r = e.cellSize, g = e.containerSize, o = e.currentOffset, l = n, a = l - g + r;
  switch (i) {
    case "start":
      return l;
    case "end":
      return a;
    case "center":
      return l - (g - r) / 2;
    default:
      return Math.max(a, Math.min(l, o));
  }
}
function bOt(e, t, i) {
  return t = an(t), Jo(e, nge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function nge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nge = function() {
    return !!e;
  })();
}
var rge = /* @__PURE__ */ function(e) {
  function t(i, n) {
    var r;
    return fr(this, t), r = bOt(this, t, [i, n]), r._cellMetadata = [], r._lastRenderedCellIndices = [], r._cellCache = [], r._isScrollingChange = r._isScrollingChange.bind(r), r._setCollectionViewRef = r._setCollectionViewRef.bind(r), r;
  }
  return Eo(t, e), Zr(t, [{
    key: "forceUpdate",
    value: function() {
      this._collectionView !== void 0 && this._collectionView.forceUpdate();
    }
    /** See Collection#recomputeCellSizesAndPositions */
  }, {
    key: "recomputeCellSizesAndPositions",
    value: function() {
      this._cellCache = [], this._collectionView.recomputeCellSizesAndPositions();
    }
    /** React lifecycle methods */
  }, {
    key: "render",
    value: function() {
      var n = et({}, (aOt(this.props), this.props));
      return /* @__PURE__ */ X.createElement(q1, et({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, n));
    }
    /** CellLayoutManager interface */
  }, {
    key: "calculateSizeAndPositionData",
    value: function() {
      var n = this.props, r = n.cellCount, g = n.cellSizeAndPositionGetter, o = n.sectionSize, l = AOt({
        cellCount: r,
        cellSizeAndPositionGetter: g,
        sectionSize: o
      });
      this._cellMetadata = l.cellMetadata, this._sectionManager = l.sectionManager, this._height = l.height, this._width = l.width;
    }
    /**
     * Returns the most recently rendered set of cell indices.
     */
  }, {
    key: "getLastRenderedIndices",
    value: function() {
      return this._lastRenderedCellIndices;
    }
    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */
  }, {
    key: "getScrollPositionForCell",
    value: function(n) {
      var r = n.align, g = n.cellIndex, o = n.height, l = n.scrollLeft, a = n.scrollTop, I = n.width, c = this.props.cellCount;
      if (g >= 0 && g < c) {
        var d = this._cellMetadata[g];
        l = RO({
          align: r,
          cellOffset: d.x,
          cellSize: d.width,
          containerSize: I,
          currentOffset: l,
          targetIndex: g
        }), a = RO({
          align: r,
          cellOffset: d.y,
          cellSize: d.height,
          containerSize: o,
          currentOffset: a,
          targetIndex: g
        });
      }
      return {
        scrollLeft: l,
        scrollTop: a
      };
    }
  }, {
    key: "getTotalSize",
    value: function() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function(n) {
      var r = this, g = n.height, o = n.isScrolling, l = n.width, a = n.x, I = n.y, c = this.props, d = c.cellGroupRenderer, C = c.cellRenderer;
      return this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: g,
        width: l,
        x: a,
        y: I
      }), d({
        cellCache: this._cellCache,
        cellRenderer: C,
        cellSizeAndPositionGetter: function(b) {
          var m = b.index;
          return r._sectionManager.getCellMetadata({
            index: m
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: o
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function(n) {
      n || (this._cellCache = []);
    }
  }, {
    key: "_setCollectionViewRef",
    value: function(n) {
      this._collectionView = n;
    }
  }]);
}(X.PureComponent);
We(rge, "defaultProps", {
  "aria-label": "grid",
  cellGroupRenderer: hOt
});
rge.propTypes = {};
function hOt(e) {
  var t = e.cellCache, i = e.cellRenderer, n = e.cellSizeAndPositionGetter, r = e.indices, g = e.isScrolling;
  return r.map(function(o) {
    var l = n({
      index: o
    }), a = {
      index: o,
      isScrolling: g,
      key: o,
      style: {
        height: l.height,
        left: l.x,
        position: "absolute",
        top: l.y,
        width: l.width
      }
    };
    return g ? (o in t || (t[o] = i(a)), t[o]) : i(a);
  }).filter(function(o) {
    return !!o;
  });
}
function mOt(e, t, i) {
  return t = an(t), Jo(e, gge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function gge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (gge = function() {
    return !!e;
  })();
}
var pOt = /* @__PURE__ */ function(e) {
  function t(i, n) {
    var r;
    return fr(this, t), r = mOt(this, t, [i, n]), r._registerChild = r._registerChild.bind(r), r;
  }
  return Eo(t, e), Zr(t, [{
    key: "componentDidUpdate",
    value: function(n) {
      var r = this.props, g = r.columnMaxWidth, o = r.columnMinWidth, l = r.columnCount, a = r.width;
      (g !== n.columnMaxWidth || o !== n.columnMinWidth || l !== n.columnCount || a !== n.width) && this._registeredChild && this._registeredChild.recomputeGridSize();
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.children, g = n.columnMaxWidth, o = n.columnMinWidth, l = n.columnCount, a = n.width, I = o || 1, c = g ? Math.min(g, a) : a, d = a / l;
      d = Math.max(I, d), d = Math.min(c, d), d = Math.floor(d);
      var C = Math.min(a, d * l);
      return r({
        adjustedWidth: C,
        columnWidth: d,
        getColumnWidth: function() {
          return d;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function(n) {
      if (n && typeof n.recomputeGridSize != "function")
        throw Error("Unexpected child type registered; only Grid/MultiGrid children are supported.");
      this._registeredChild = n, this._registeredChild && this._registeredChild.recomputeGridSize();
    }
  }]);
}(X.PureComponent);
pOt.propTypes = {};
function XO(e) {
  var t = e.cellCount, i = e.cellSize, n = e.computeMetadataCallback, r = e.computeMetadataCallbackProps, g = e.nextCellsCount, o = e.nextCellSize, l = e.nextScrollToIndex, a = e.scrollToIndex, I = e.updateScrollOffsetForScrollToIndex;
  (t !== g || (typeof i == "number" || typeof o == "number") && i !== o) && (n(r), a >= 0 && a === l && I());
}
function EB(e, t) {
  if (e == null)
    return {};
  var i, n, r = jr(e, t);
  if (Object.getOwnPropertySymbols) {
    var g = Object.getOwnPropertySymbols(e);
    for (n = 0; n < g.length; n++)
      i = g[n], t.indexOf(i) === -1 && {}.propertyIsEnumerable.call(e, i) && (r[i] = e[i]);
  }
  return r;
}
var BOt = /* @__PURE__ */ function() {
  function e(t) {
    var i = t.cellCount, n = t.cellSizeGetter, r = t.estimatedCellSize;
    fr(this, e), We(this, "_cellSizeAndPositionData", {}), We(this, "_lastMeasuredIndex", -1), We(this, "_lastBatchedIndex", -1), We(this, "_cellCount", void 0), We(this, "_cellSizeGetter", void 0), We(this, "_estimatedCellSize", void 0), this._cellSizeGetter = n, this._cellCount = i, this._estimatedCellSize = r;
  }
  return Zr(e, [{
    key: "areOffsetsAdjusted",
    value: function() {
      return !1;
    }
  }, {
    key: "configure",
    value: function(i) {
      var n = i.cellCount, r = i.estimatedCellSize, g = i.cellSizeGetter;
      this._cellCount = n, this._estimatedCellSize = r, this._cellSizeGetter = g;
    }
  }, {
    key: "getCellCount",
    value: function() {
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function() {
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function() {
      return 0;
    }
    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */
  }, {
    key: "getSizeAndPositionOfCell",
    value: function(i) {
      if (i < 0 || i >= this._cellCount)
        throw Error("Requested index ".concat(i, " is outside of range 0..").concat(this._cellCount));
      if (i > this._lastMeasuredIndex)
        for (var n = this.getSizeAndPositionOfLastMeasuredCell(), r = n.offset + n.size, g = this._lastMeasuredIndex + 1; g <= i; g++) {
          var o = this._cellSizeGetter({
            index: g
          });
          if (o === void 0 || isNaN(o))
            throw Error("Invalid size returned for cell ".concat(g, " of value ").concat(o));
          o === null ? (this._cellSizeAndPositionData[g] = {
            offset: r,
            size: 0
          }, this._lastBatchedIndex = i) : (this._cellSizeAndPositionData[g] = {
            offset: r,
            size: o
          }, r += o, this._lastMeasuredIndex = i);
        }
      return this._cellSizeAndPositionData[i];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }
    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */
  }, {
    key: "getTotalSize",
    value: function() {
      var i = this.getSizeAndPositionOfLastMeasuredCell(), n = i.offset + i.size, r = this._cellCount - this._lastMeasuredIndex - 1, g = r * this._estimatedCellSize;
      return n + g;
    }
    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function(i) {
      var n = i.align, r = n === void 0 ? "auto" : n, g = i.containerSize, o = i.currentOffset, l = i.targetIndex;
      if (g <= 0)
        return 0;
      var a = this.getSizeAndPositionOfCell(l), I = a.offset, c = I - g + a.size, d;
      switch (r) {
        case "start":
          d = I;
          break;
        case "end":
          d = c;
          break;
        case "center":
          d = I - (g - a.size) / 2;
          break;
        default:
          d = Math.max(c, Math.min(I, o));
          break;
      }
      var C = this.getTotalSize();
      return Math.max(0, Math.min(C - g, d));
    }
  }, {
    key: "getVisibleCellRange",
    value: function(i) {
      var n = i.containerSize, r = i.offset, g = this.getTotalSize();
      if (g === 0)
        return {};
      var o = r + n, l = this._findNearestCell(r), a = this.getSizeAndPositionOfCell(l);
      r = a.offset + a.size;
      for (var I = l; r < o && I < this._cellCount - 1; )
        I++, r += this.getSizeAndPositionOfCell(I).size;
      return {
        start: l,
        stop: I
      };
    }
    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */
  }, {
    key: "resetCell",
    value: function(i) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, i - 1);
    }
  }, {
    key: "_binarySearch",
    value: function(i, n, r) {
      for (; n <= i; ) {
        var g = n + Math.floor((i - n) / 2), o = this.getSizeAndPositionOfCell(g).offset;
        if (o === r)
          return g;
        o < r ? n = g + 1 : o > r && (i = g - 1);
      }
      return n > 0 ? n - 1 : 0;
    }
  }, {
    key: "_exponentialSearch",
    value: function(i, n) {
      for (var r = 1; i < this._cellCount && this.getSizeAndPositionOfCell(i).offset < n; )
        i += r, r *= 2;
      return this._binarySearch(Math.min(i, this._cellCount - 1), Math.floor(i / 2), n);
    }
    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */
  }, {
    key: "_findNearestCell",
    value: function(i) {
      if (isNaN(i))
        throw Error("Invalid offset ".concat(i, " specified"));
      i = Math.max(0, i);
      var n = this.getSizeAndPositionOfLastMeasuredCell(), r = Math.max(0, this._lastMeasuredIndex);
      return n.offset >= i ? this._binarySearch(r, 0, i) : this._exponentialSearch(r, i);
    }
  }]);
}(), fOt = 15e5, ZOt = 16777100, GOt = function() {
  return typeof window < "u";
}, yOt = function() {
  return !!window.chrome;
}, WOt = function() {
  return GOt() && yOt() ? ZOt : fOt;
}, SOt = ["maxScrollSize"], HO = /* @__PURE__ */ function() {
  function e(t) {
    var i = t.maxScrollSize, n = i === void 0 ? WOt() : i, r = EB(t, SOt);
    fr(this, e), We(this, "_cellSizeAndPositionManager", void 0), We(this, "_maxScrollSize", void 0), this._cellSizeAndPositionManager = new BOt(r), this._maxScrollSize = n;
  }
  return Zr(e, [{
    key: "areOffsetsAdjusted",
    value: function() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function(i) {
      this._cellSizeAndPositionManager.configure(i);
    }
  }, {
    key: "getCellCount",
    value: function() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }
    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */
  }, {
    key: "getOffsetAdjustment",
    value: function(i) {
      var n = i.containerSize, r = i.offset, g = this._cellSizeAndPositionManager.getTotalSize(), o = this.getTotalSize(), l = this._getOffsetPercentage({
        containerSize: n,
        offset: r,
        totalSize: o
      });
      return Math.round(l * (o - g));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function(i) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(i);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }
    /** See CellSizeAndPositionManager#getTotalSize */
  }, {
    key: "getTotalSize",
    value: function() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }
    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function(i) {
      var n = i.align, r = n === void 0 ? "auto" : n, g = i.containerSize, o = i.currentOffset, l = i.targetIndex;
      o = this._safeOffsetToOffset({
        containerSize: g,
        offset: o
      });
      var a = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: r,
        containerSize: g,
        currentOffset: o,
        targetIndex: l
      });
      return this._offsetToSafeOffset({
        containerSize: g,
        offset: a
      });
    }
    /** See CellSizeAndPositionManager#getVisibleCellRange */
  }, {
    key: "getVisibleCellRange",
    value: function(i) {
      var n = i.containerSize, r = i.offset;
      return r = this._safeOffsetToOffset({
        containerSize: n,
        offset: r
      }), this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: n,
        offset: r
      });
    }
  }, {
    key: "resetCell",
    value: function(i) {
      this._cellSizeAndPositionManager.resetCell(i);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function(i) {
      var n = i.containerSize, r = i.offset, g = i.totalSize;
      return g <= n ? 0 : r / (g - n);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function(i) {
      var n = i.containerSize, r = i.offset, g = this._cellSizeAndPositionManager.getTotalSize(), o = this.getTotalSize();
      if (g === o)
        return r;
      var l = this._getOffsetPercentage({
        containerSize: n,
        offset: r,
        totalSize: g
      });
      return Math.round(l * (o - n));
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function(i) {
      var n = i.containerSize, r = i.offset, g = this._cellSizeAndPositionManager.getTotalSize(), o = this.getTotalSize();
      if (g === o)
        return r;
      var l = this._getOffsetPercentage({
        containerSize: n,
        offset: r,
        totalSize: o
      });
      return Math.round(l * (g - n));
    }
  }]);
}(), jS = -1, bc = 1;
function VOt(e) {
  var t = e.cellCount, i = e.overscanCellsCount, n = e.scrollDirection, r = e.startIndex, g = e.stopIndex;
  return n === bc ? {
    overscanStartIndex: Math.max(0, r),
    overscanStopIndex: Math.min(t - 1, g + i)
  } : {
    overscanStartIndex: Math.max(0, r - i),
    overscanStopIndex: Math.min(t - 1, g)
  };
}
function kO(e) {
  var t = e.cellSize, i = e.cellSizeAndPositionManager, n = e.previousCellsCount, r = e.previousCellSize, g = e.previousScrollToAlignment, o = e.previousScrollToIndex, l = e.previousSize, a = e.scrollOffset, I = e.scrollToAlignment, c = e.scrollToIndex, d = e.size, C = e.sizeJustIncreasedFromZero, A = e.updateScrollIndexCallback, b = i.getCellCount(), m = c >= 0 && c < b, p = d !== l || C || !r || typeof t == "number" && t !== r;
  m && (p || I !== g || c !== o) ? A(c) : !m && b > 0 && (d < l || b < n) && a > i.getTotalSize() - d && A(b - 1);
}
function wOt(e) {
  for (var t = e.cellCache, i = e.cellRenderer, n = e.columnSizeAndPositionManager, r = e.columnStartIndex, g = e.columnStopIndex, o = e.deferredMeasurementCache, l = e.horizontalOffsetAdjustment, a = e.isScrolling, I = e.isScrollingOptOut, c = e.parent, d = e.rowSizeAndPositionManager, C = e.rowStartIndex, A = e.rowStopIndex, b = e.styleCache, m = e.verticalOffsetAdjustment, p = e.visibleColumnIndices, B = e.visibleRowIndices, f = [], Z = n.areOffsetsAdjusted() || d.areOffsetsAdjusted(), y = !a && !Z, W = C; W <= A; W++)
    for (var V = d.getSizeAndPositionOfCell(W), w = r; w <= g; w++) {
      var v = n.getSizeAndPositionOfCell(w), H = w >= p.start && w <= p.stop && W >= B.start && W <= B.stop, x = "".concat(W, "-").concat(w), J = void 0;
      y && b[x] ? J = b[x] : o && !o.has(W, w) ? J = {
        height: "auto",
        left: 0,
        position: "absolute",
        top: 0,
        width: "auto"
      } : (J = {
        height: V.size,
        left: v.offset + l,
        position: "absolute",
        top: V.offset + m,
        width: v.size
      }, b[x] = J);
      var K = {
        columnIndex: w,
        isScrolling: a,
        isVisible: H,
        key: x,
        parent: c,
        rowIndex: W,
        style: J
      }, M = void 0;
      (I || a) && !l && !m ? (t[x] || (t[x] = i(K)), M = t[x]) : M = i(K), !(M == null || M === !1) && (M.props.role || (M = /* @__PURE__ */ De.cloneElement(M, {
        role: "gridcell"
      })), f.push(M));
    }
  return f;
}
var wo;
typeof window < "u" ? wo = window : typeof self < "u" ? wo = self : wo = {};
var vOt = wo.requestAnimationFrame || wo.webkitRequestAnimationFrame || wo.mozRequestAnimationFrame || wo.oRequestAnimationFrame || wo.msRequestAnimationFrame || function(e) {
  return wo.setTimeout(e, 1e3 / 60);
}, ROt = wo.cancelAnimationFrame || wo.webkitCancelAnimationFrame || wo.mozCancelAnimationFrame || wo.oCancelAnimationFrame || wo.msCancelAnimationFrame || function(e) {
  wo.clearTimeout(e);
}, YO = vOt, XOt = ROt, pm = function(t) {
  return XOt(t.id);
}, EN = function(t, i) {
  var n;
  Promise.resolve().then(function() {
    n = Date.now();
  });
  var r = function() {
    Date.now() - n >= i ? t.call() : g.id = YO(r);
  }, g = {
    id: YO(r)
  };
  return g;
};
function FO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function jo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? FO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : FO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function HOt(e, t, i) {
  return t = an(t), Jo(e, oge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function oge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (oge = function() {
    return !!e;
  })();
}
var kOt = 150, ix = {
  OBSERVED: "observed",
  REQUESTED: "requested"
}, YOt = function() {
  return null;
}, xd = /* @__PURE__ */ function(e) {
  function t(i) {
    var n;
    fr(this, t), n = HOt(this, t, [i]), We(n, "_onGridRenderedMemoizer", mm()), We(n, "_onScrollMemoizer", mm(!1)), We(n, "_deferredInvalidateColumnIndex", null), We(n, "_deferredInvalidateRowIndex", null), We(n, "_recomputeScrollLeftFlag", !1), We(n, "_recomputeScrollTopFlag", !1), We(n, "_horizontalScrollBarSize", 0), We(n, "_verticalScrollBarSize", 0), We(n, "_scrollbarPresenceChanged", !1), We(n, "_scrollingContainer", void 0), We(n, "_childrenToDisplay", void 0), We(n, "_columnStartIndex", void 0), We(n, "_columnStopIndex", void 0), We(n, "_rowStartIndex", void 0), We(n, "_rowStopIndex", void 0), We(n, "_renderedColumnStartIndex", 0), We(n, "_renderedColumnStopIndex", 0), We(n, "_renderedRowStartIndex", 0), We(n, "_renderedRowStopIndex", 0), We(n, "_initialScrollTop", void 0), We(n, "_initialScrollLeft", void 0), We(n, "_disablePointerEventsTimeoutId", void 0), We(n, "_styleCache", {}), We(n, "_cellCache", {}), We(n, "_debounceScrollEndedCallback", function() {
      n._disablePointerEventsTimeoutId = null, n.setState({
        isScrolling: !1,
        needToResetStyleCache: !1
      });
    }), We(n, "_invokeOnGridRenderedHelper", function() {
      var o = n.props.onSectionRendered;
      n._onGridRenderedMemoizer({
        callback: o,
        indices: {
          columnOverscanStartIndex: n._columnStartIndex,
          columnOverscanStopIndex: n._columnStopIndex,
          columnStartIndex: n._renderedColumnStartIndex,
          columnStopIndex: n._renderedColumnStopIndex,
          rowOverscanStartIndex: n._rowStartIndex,
          rowOverscanStopIndex: n._rowStopIndex,
          rowStartIndex: n._renderedRowStartIndex,
          rowStopIndex: n._renderedRowStopIndex
        }
      });
    }), We(n, "_setScrollingContainerRef", function(o) {
      n._scrollingContainer = o, typeof n.props.elementRef == "function" ? n.props.elementRef(o) : tA(n.props.elementRef) === "object" && (n.props.elementRef.current = o);
    }), We(n, "_onScroll", function(o) {
      o.target === n._scrollingContainer && n.handleScrollEvent(o.target);
    });
    var r = new HO({
      cellCount: i.columnCount,
      cellSizeGetter: function(l) {
        return t._wrapSizeGetter(i.columnWidth)(l);
      },
      estimatedCellSize: t._getEstimatedColumnSize(i)
    }), g = new HO({
      cellCount: i.rowCount,
      cellSizeGetter: function(l) {
        return t._wrapSizeGetter(i.rowHeight)(l);
      },
      estimatedCellSize: t._getEstimatedRowSize(i)
    });
    return n.state = {
      instanceProps: {
        columnSizeAndPositionManager: r,
        rowSizeAndPositionManager: g,
        prevColumnWidth: i.columnWidth,
        prevRowHeight: i.rowHeight,
        prevColumnCount: i.columnCount,
        prevRowCount: i.rowCount,
        prevIsScrolling: i.isScrolling === !0,
        prevScrollToColumn: i.scrollToColumn,
        prevScrollToRow: i.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: !1
      },
      isScrolling: !1,
      scrollDirectionHorizontal: bc,
      scrollDirectionVertical: bc,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: !1
    }, i.scrollToRow > 0 && (n._initialScrollTop = n._getCalculatedScrollTop(i, n.state)), i.scrollToColumn > 0 && (n._initialScrollLeft = n._getCalculatedScrollLeft(i, n.state)), n;
  }
  return Eo(t, e), Zr(t, [{
    key: "getOffsetForCell",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.alignment, g = r === void 0 ? this.props.scrollToAlignment : r, o = n.columnIndex, l = o === void 0 ? this.props.scrollToColumn : o, a = n.rowIndex, I = a === void 0 ? this.props.scrollToRow : a, c = jo(jo({}, this.props), {}, {
        scrollToAlignment: g,
        scrollToColumn: l,
        scrollToRow: I
      });
      return {
        scrollLeft: this._getCalculatedScrollLeft(c),
        scrollTop: this._getCalculatedScrollTop(c)
      };
    }
    /**
     * Gets estimated total rows' height.
     */
  }, {
    key: "getTotalRowsHeight",
    value: function() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }
    /**
     * Gets estimated total columns' width.
     */
  }, {
    key: "getTotalColumnsWidth",
    value: function() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }
    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */
  }, {
    key: "handleScrollEvent",
    value: function(n) {
      var r = n.scrollLeft, g = r === void 0 ? 0 : r, o = n.scrollTop, l = o === void 0 ? 0 : o;
      if (!(l < 0)) {
        this._debounceScrollEnded();
        var a = this.props, I = a.autoHeight, c = a.autoWidth, d = a.height, C = a.width, A = this.state.instanceProps, b = A.scrollbarSize, m = A.rowSizeAndPositionManager.getTotalSize(), p = A.columnSizeAndPositionManager.getTotalSize(), B = Math.min(Math.max(0, p - C + b), g), f = Math.min(Math.max(0, m - d + b), l);
        if (this.state.scrollLeft !== B || this.state.scrollTop !== f) {
          var Z = B !== this.state.scrollLeft ? B > this.state.scrollLeft ? bc : jS : this.state.scrollDirectionHorizontal, y = f !== this.state.scrollTop ? f > this.state.scrollTop ? bc : jS : this.state.scrollDirectionVertical, W = {
            isScrolling: !0,
            scrollDirectionHorizontal: Z,
            scrollDirectionVertical: y,
            scrollPositionChangeReason: ix.OBSERVED
          };
          I || (W.scrollTop = f), c || (W.scrollLeft = B), W.needToResetStyleCache = !1, this.setState(W);
        }
        this._invokeOnScrollMemoizer({
          scrollLeft: B,
          scrollTop: f,
          totalColumnsWidth: p,
          totalRowsHeight: m
        });
      }
    }
    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(n) {
      var r = n.columnIndex, g = n.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, r) : r, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, g) : g;
    }
    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */
  }, {
    key: "measureAllCells",
    value: function() {
      var n = this.props, r = n.columnCount, g = n.rowCount, o = this.state.instanceProps;
      o.columnSizeAndPositionManager.getSizeAndPositionOfCell(r - 1), o.rowSizeAndPositionManager.getSizeAndPositionOfCell(g - 1);
    }
    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.columnIndex, g = r === void 0 ? 0 : r, o = n.rowIndex, l = o === void 0 ? 0 : o, a = this.props, I = a.scrollToColumn, c = a.scrollToRow, d = this.state.instanceProps;
      d.columnSizeAndPositionManager.resetCell(g), d.rowSizeAndPositionManager.resetCell(l), this._recomputeScrollLeftFlag = I >= 0 && (this.state.scrollDirectionHorizontal === bc ? g <= I : g >= I), this._recomputeScrollTopFlag = c >= 0 && (this.state.scrollDirectionVertical === bc ? l <= c : l >= c), this._styleCache = {}, this._cellCache = {}, this.forceUpdate();
    }
    /**
     * Ensure column and row are visible.
     */
  }, {
    key: "scrollToCell",
    value: function(n) {
      var r = n.columnIndex, g = n.rowIndex, o = this.props.columnCount, l = this.props;
      o > 1 && r !== void 0 && this._updateScrollLeftForScrollToColumn(jo(jo({}, l), {}, {
        scrollToColumn: r
      })), g !== void 0 && this._updateScrollTopForScrollToRow(jo(jo({}, l), {}, {
        scrollToRow: g
      }));
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.props, r = n.getScrollbarSize, g = n.height, o = n.scrollLeft, l = n.scrollToColumn, a = n.scrollTop, I = n.scrollToRow, c = n.width, d = this.state.instanceProps;
      if (this._initialScrollTop = 0, this._initialScrollLeft = 0, this._handleInvalidatedGridSize(), d.scrollbarSizeMeasured || this.setState(function(b) {
        var m = jo(jo({}, b), {}, {
          needToResetStyleCache: !1
        });
        return m.instanceProps.scrollbarSize = r(), m.instanceProps.scrollbarSizeMeasured = !0, m;
      }), typeof o == "number" && o >= 0 || typeof a == "number" && a >= 0) {
        var C = t._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: o,
          scrollTop: a
        });
        C && (C.needToResetStyleCache = !1, this.setState(C));
      }
      this._scrollingContainer && (this._scrollingContainer.scrollLeft !== this.state.scrollLeft && (this._scrollingContainer.scrollLeft = this.state.scrollLeft), this._scrollingContainer.scrollTop !== this.state.scrollTop && (this._scrollingContainer.scrollTop = this.state.scrollTop));
      var A = g > 0 && c > 0;
      l >= 0 && A && this._updateScrollLeftForScrollToColumn(), I >= 0 && A && this._updateScrollTopForScrollToRow(), this._invokeOnGridRenderedHelper(), this._invokeOnScrollMemoizer({
        scrollLeft: o || 0,
        scrollTop: a || 0,
        totalColumnsWidth: d.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: d.rowSizeAndPositionManager.getTotalSize()
      }), this._maybeCallOnScrollbarPresenceChange();
    }
    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */
  }, {
    key: "componentDidUpdate",
    value: function(n, r) {
      var g = this, o = this.props, l = o.autoHeight, a = o.autoWidth, I = o.columnCount, c = o.height, d = o.rowCount, C = o.scrollToAlignment, A = o.scrollToColumn, b = o.scrollToRow, m = o.width, p = this.state, B = p.scrollLeft, f = p.scrollPositionChangeReason, Z = p.scrollTop, y = p.instanceProps;
      this._handleInvalidatedGridSize();
      var W = I > 0 && n.columnCount === 0 || d > 0 && n.rowCount === 0;
      f === ix.REQUESTED && (!a && B >= 0 && (B !== this._scrollingContainer.scrollLeft || W) && (this._scrollingContainer.scrollLeft = B), !l && Z >= 0 && (Z !== this._scrollingContainer.scrollTop || W) && (this._scrollingContainer.scrollTop = Z));
      var V = (n.width === 0 || n.height === 0) && c > 0 && m > 0;
      if (this._recomputeScrollLeftFlag ? (this._recomputeScrollLeftFlag = !1, this._updateScrollLeftForScrollToColumn(this.props)) : kO({
        cellSizeAndPositionManager: y.columnSizeAndPositionManager,
        previousCellsCount: n.columnCount,
        previousCellSize: n.columnWidth,
        previousScrollToAlignment: n.scrollToAlignment,
        previousScrollToIndex: n.scrollToColumn,
        previousSize: n.width,
        scrollOffset: B,
        scrollToAlignment: C,
        scrollToIndex: A,
        size: m,
        sizeJustIncreasedFromZero: V,
        updateScrollIndexCallback: function() {
          return g._updateScrollLeftForScrollToColumn(g.props);
        }
      }), this._recomputeScrollTopFlag ? (this._recomputeScrollTopFlag = !1, this._updateScrollTopForScrollToRow(this.props)) : kO({
        cellSizeAndPositionManager: y.rowSizeAndPositionManager,
        previousCellsCount: n.rowCount,
        previousCellSize: n.rowHeight,
        previousScrollToAlignment: n.scrollToAlignment,
        previousScrollToIndex: n.scrollToRow,
        previousSize: n.height,
        scrollOffset: Z,
        scrollToAlignment: C,
        scrollToIndex: b,
        size: c,
        sizeJustIncreasedFromZero: V,
        updateScrollIndexCallback: function() {
          return g._updateScrollTopForScrollToRow(g.props);
        }
      }), this._invokeOnGridRenderedHelper(), B !== r.scrollLeft || Z !== r.scrollTop) {
        var w = y.rowSizeAndPositionManager.getTotalSize(), v = y.columnSizeAndPositionManager.getTotalSize();
        this._invokeOnScrollMemoizer({
          scrollLeft: B,
          scrollTop: Z,
          totalColumnsWidth: v,
          totalRowsHeight: w
        });
      }
      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._disablePointerEventsTimeoutId && pm(this._disablePointerEventsTimeoutId);
    }
    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.autoContainerWidth, g = n.autoHeight, o = n.autoWidth, l = n.className, a = n.containerProps, I = n.containerRole, c = n.containerStyle, d = n.height, C = n.id, A = n.noContentRenderer, b = n.role, m = n.style, p = n.tabIndex, B = n.width, f = this.state, Z = f.instanceProps, y = f.needToResetStyleCache, W = this._isScrolling(), V = {
        boxSizing: "border-box",
        direction: "ltr",
        height: g ? "auto" : d,
        position: "relative",
        width: o ? "auto" : B,
        WebkitOverflowScrolling: "touch",
        willChange: "transform"
      };
      y && (this._styleCache = {}), this.state.isScrolling || this._resetStyleCache(), this._calculateChildrenToRender(this.props, this.state);
      var w = Z.columnSizeAndPositionManager.getTotalSize(), v = Z.rowSizeAndPositionManager.getTotalSize(), H = v > d ? Z.scrollbarSize : 0, x = w > B ? Z.scrollbarSize : 0;
      (x !== this._horizontalScrollBarSize || H !== this._verticalScrollBarSize) && (this._horizontalScrollBarSize = x, this._verticalScrollBarSize = H, this._scrollbarPresenceChanged = !0), V.overflowX = w + H <= B ? "hidden" : "auto", V.overflowY = v + x <= d ? "hidden" : "auto";
      var J = this._childrenToDisplay, K = J.length === 0 && d > 0 && B > 0;
      return /* @__PURE__ */ X.createElement("div", et({
        ref: this._setScrollingContainerRef
      }, a, {
        "aria-label": this.props["aria-label"],
        "aria-readonly": this.props["aria-readonly"],
        className: Ag("ReactVirtualized__Grid", l),
        id: C,
        onScroll: this._onScroll,
        role: b,
        style: jo(jo({}, V), m),
        tabIndex: p
      }), J.length > 0 && /* @__PURE__ */ X.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: I,
        style: jo({
          width: r ? "auto" : w,
          height: v,
          maxWidth: w,
          maxHeight: v,
          overflow: "hidden",
          pointerEvents: W ? "none" : "",
          position: "relative"
        }, c)
      }, J), K && A());
    }
    /* ---------------------------- Helper methods ---------------------------- */
  }, {
    key: "_calculateChildrenToRender",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, g = n.cellRenderer, o = n.cellRangeRenderer, l = n.columnCount, a = n.deferredMeasurementCache, I = n.height, c = n.overscanColumnCount, d = n.overscanIndicesGetter, C = n.overscanRowCount, A = n.rowCount, b = n.width, m = n.isScrollingOptOut, p = r.scrollDirectionHorizontal, B = r.scrollDirectionVertical, f = r.instanceProps, Z = this._initialScrollTop > 0 ? this._initialScrollTop : r.scrollTop, y = this._initialScrollLeft > 0 ? this._initialScrollLeft : r.scrollLeft, W = this._isScrolling(n, r);
      if (this._childrenToDisplay = [], I > 0 && b > 0) {
        var V = f.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: b,
          offset: y
        }), w = f.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: I,
          offset: Z
        }), v = f.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: b,
          offset: y
        }), H = f.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: I,
          offset: Z
        });
        this._renderedColumnStartIndex = V.start, this._renderedColumnStopIndex = V.stop, this._renderedRowStartIndex = w.start, this._renderedRowStopIndex = w.stop;
        var x = d({
          direction: "horizontal",
          cellCount: l,
          overscanCellsCount: c,
          scrollDirection: p,
          startIndex: typeof V.start == "number" ? V.start : 0,
          stopIndex: typeof V.stop == "number" ? V.stop : -1
        }), J = d({
          direction: "vertical",
          cellCount: A,
          overscanCellsCount: C,
          scrollDirection: B,
          startIndex: typeof w.start == "number" ? w.start : 0,
          stopIndex: typeof w.stop == "number" ? w.stop : -1
        }), K = x.overscanStartIndex, M = x.overscanStopIndex, L = J.overscanStartIndex, N = J.overscanStopIndex;
        if (a) {
          if (!a.hasFixedHeight()) {
            for (var U = L; U <= N; U++)
              if (!a.has(U, 0)) {
                K = 0, M = l - 1;
                break;
              }
          }
          if (!a.hasFixedWidth()) {
            for (var O = K; O <= M; O++)
              if (!a.has(0, O)) {
                L = 0, N = A - 1;
                break;
              }
          }
        }
        this._childrenToDisplay = o({
          cellCache: this._cellCache,
          cellRenderer: g,
          columnSizeAndPositionManager: f.columnSizeAndPositionManager,
          columnStartIndex: K,
          columnStopIndex: M,
          deferredMeasurementCache: a,
          horizontalOffsetAdjustment: v,
          isScrolling: W,
          isScrollingOptOut: m,
          parent: this,
          rowSizeAndPositionManager: f.rowSizeAndPositionManager,
          rowStartIndex: L,
          rowStopIndex: N,
          scrollLeft: y,
          scrollTop: Z,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: H,
          visibleColumnIndices: V,
          visibleRowIndices: w
        }), this._columnStartIndex = K, this._columnStopIndex = M, this._rowStartIndex = L, this._rowStopIndex = N;
      }
    }
    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_debounceScrollEnded",
    value: function() {
      var n = this.props.scrollingResetTimeInterval;
      this._disablePointerEventsTimeoutId && pm(this._disablePointerEventsTimeoutId), this._disablePointerEventsTimeoutId = EN(this._debounceScrollEndedCallback, n);
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: (
      /**
       * Check for batched CellMeasurer size invalidations.
       * This will occur the first time one or more previously unmeasured cells are rendered.
       */
      function() {
        if (typeof this._deferredInvalidateColumnIndex == "number" && typeof this._deferredInvalidateRowIndex == "number") {
          var n = this._deferredInvalidateColumnIndex, r = this._deferredInvalidateRowIndex;
          this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
            columnIndex: n,
            rowIndex: r
          });
        }
      }
    )
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function(n) {
      var r = this, g = n.scrollLeft, o = n.scrollTop, l = n.totalColumnsWidth, a = n.totalRowsHeight;
      this._onScrollMemoizer({
        callback: function(c) {
          var d = c.scrollLeft, C = c.scrollTop, A = r.props, b = A.height, m = A.onScroll, p = A.width;
          m({
            clientHeight: b,
            clientWidth: p,
            scrollHeight: a,
            scrollLeft: d,
            scrollTop: C,
            scrollWidth: l
          });
        },
        indices: {
          scrollLeft: g,
          scrollTop: o
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return Object.hasOwnProperty.call(n, "isScrolling") ? !!n.isScrolling : !!r.isScrolling;
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function() {
      if (this._scrollbarPresenceChanged) {
        var n = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = !1, n({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",
    value: (
      /**
       * Scroll to the specified offset(s).
       * Useful for animating position changes.
       */
      function(n) {
        var r = n.scrollLeft, g = n.scrollTop, o = t._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: r,
          scrollTop: g
        });
        o && (o.needToResetStyleCache = !1, this.setState(o));
      }
    )
  }, {
    key: "_getCalculatedScrollLeft",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return t._getCalculatedScrollLeft(n, r);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, g = t._getScrollLeftForScrollToColumnStateUpdate(n, r);
      g && (g.needToResetStyleCache = !1, this.setState(g));
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state;
      return t._getCalculatedScrollTop(n, r);
    }
  }, {
    key: "_resetStyleCache",
    value: function() {
      var n = this._styleCache, r = this._cellCache, g = this.props.isScrollingOptOut;
      this._cellCache = {}, this._styleCache = {};
      for (var o = this._rowStartIndex; o <= this._rowStopIndex; o++)
        for (var l = this._columnStartIndex; l <= this._columnStopIndex; l++) {
          var a = "".concat(o, "-").concat(l);
          this._styleCache[a] = n[a], g && (this._cellCache[a] = r[a]);
        }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state, g = t._getScrollTopForScrollToRowStateUpdate(n, r);
      g && (g.needToResetStyleCache = !1, this.setState(g));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, r) {
      var g = {};
      n.columnCount === 0 && r.scrollLeft !== 0 || n.rowCount === 0 && r.scrollTop !== 0 ? (g.scrollLeft = 0, g.scrollTop = 0) : (n.scrollLeft !== r.scrollLeft && n.scrollToColumn < 0 || n.scrollTop !== r.scrollTop && n.scrollToRow < 0) && Object.assign(g, t._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: n.scrollLeft,
        scrollTop: n.scrollTop
      }));
      var o = r.instanceProps;
      g.needToResetStyleCache = !1, (n.columnWidth !== o.prevColumnWidth || n.rowHeight !== o.prevRowHeight) && (g.needToResetStyleCache = !0), o.columnSizeAndPositionManager.configure({
        cellCount: n.columnCount,
        estimatedCellSize: t._getEstimatedColumnSize(n),
        cellSizeGetter: t._wrapSizeGetter(n.columnWidth)
      }), o.rowSizeAndPositionManager.configure({
        cellCount: n.rowCount,
        estimatedCellSize: t._getEstimatedRowSize(n),
        cellSizeGetter: t._wrapSizeGetter(n.rowHeight)
      }), (o.prevColumnCount === 0 || o.prevRowCount === 0) && (o.prevColumnCount = 0, o.prevRowCount = 0), n.autoHeight && n.isScrolling === !1 && o.prevIsScrolling === !0 && Object.assign(g, {
        isScrolling: !1
      });
      var l, a;
      return XO({
        cellCount: o.prevColumnCount,
        cellSize: typeof o.prevColumnWidth == "number" ? o.prevColumnWidth : null,
        computeMetadataCallback: function() {
          return o.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: n,
        nextCellsCount: n.columnCount,
        nextCellSize: typeof n.columnWidth == "number" ? n.columnWidth : null,
        nextScrollToIndex: n.scrollToColumn,
        scrollToIndex: o.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function() {
          l = t._getScrollLeftForScrollToColumnStateUpdate(n, r);
        }
      }), XO({
        cellCount: o.prevRowCount,
        cellSize: typeof o.prevRowHeight == "number" ? o.prevRowHeight : null,
        computeMetadataCallback: function() {
          return o.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: n,
        nextCellsCount: n.rowCount,
        nextCellSize: typeof n.rowHeight == "number" ? n.rowHeight : null,
        nextScrollToIndex: n.scrollToRow,
        scrollToIndex: o.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function() {
          a = t._getScrollTopForScrollToRowStateUpdate(n, r);
        }
      }), o.prevColumnCount = n.columnCount, o.prevColumnWidth = n.columnWidth, o.prevIsScrolling = n.isScrolling === !0, o.prevRowCount = n.rowCount, o.prevRowHeight = n.rowHeight, o.prevScrollToColumn = n.scrollToColumn, o.prevScrollToRow = n.scrollToRow, o.scrollbarSize = n.getScrollbarSize(), o.scrollbarSize === void 0 ? (o.scrollbarSizeMeasured = !1, o.scrollbarSize = 0) : o.scrollbarSizeMeasured = !0, g.instanceProps = o, jo(jo(jo({}, g), l), a);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function(n) {
      return typeof n.columnWidth == "number" ? n.columnWidth : n.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function(n) {
      return typeof n.rowHeight == "number" ? n.rowHeight : n.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",
    value: (
      /**
       * Get the updated state after scrolling to
       * scrollLeft and scrollTop
       */
      function(n) {
        var r = n.prevState, g = n.scrollLeft, o = n.scrollTop, l = {
          scrollPositionChangeReason: ix.REQUESTED
        };
        return typeof g == "number" && g >= 0 && (l.scrollDirectionHorizontal = g > r.scrollLeft ? bc : jS, l.scrollLeft = g), typeof o == "number" && o >= 0 && (l.scrollDirectionVertical = o > r.scrollTop ? bc : jS, l.scrollTop = o), typeof g == "number" && g >= 0 && g !== r.scrollLeft || typeof o == "number" && o >= 0 && o !== r.scrollTop ? l : {};
      }
    )
  }, {
    key: "_wrapSizeGetter",
    value: function(n) {
      return typeof n == "function" ? n : function() {
        return n;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function(n, r) {
      var g = n.columnCount, o = n.height, l = n.scrollToAlignment, a = n.scrollToColumn, I = n.width, c = r.scrollLeft, d = r.instanceProps;
      if (g > 0) {
        var C = g - 1, A = a < 0 ? C : Math.min(C, a), b = d.rowSizeAndPositionManager.getTotalSize(), m = d.scrollbarSizeMeasured && b > o ? d.scrollbarSize : 0;
        return d.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: l,
          containerSize: I - m,
          currentOffset: c,
          targetIndex: A
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function(n, r) {
      var g = r.scrollLeft, o = t._getCalculatedScrollLeft(n, r);
      return typeof o == "number" && o >= 0 && g !== o ? t._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: o,
        scrollTop: -1
      }) : {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function(n, r) {
      var g = n.height, o = n.rowCount, l = n.scrollToAlignment, a = n.scrollToRow, I = n.width, c = r.scrollTop, d = r.instanceProps;
      if (o > 0) {
        var C = o - 1, A = a < 0 ? C : Math.min(C, a), b = d.columnSizeAndPositionManager.getTotalSize(), m = d.scrollbarSizeMeasured && b > I ? d.scrollbarSize : 0;
        return d.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: l,
          containerSize: g - m,
          currentOffset: c,
          targetIndex: A
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function(n, r) {
      var g = r.scrollTop, o = t._getCalculatedScrollTop(n, r);
      return typeof o == "number" && o >= 0 && g !== o ? t._getScrollToPositionStateUpdate({
        prevState: r,
        scrollLeft: -1,
        scrollTop: o
      }) : {};
    }
  }]);
}(X.PureComponent);
We(xd, "defaultProps", {
  "aria-label": "grid",
  "aria-readonly": !0,
  autoContainerWidth: !1,
  autoHeight: !1,
  autoWidth: !1,
  cellRangeRenderer: wOt,
  containerRole: "row",
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: pD,
  noContentRenderer: YOt,
  onScroll: function() {
  },
  onScrollbarPresenceChange: function() {
  },
  onSectionRendered: function() {
  },
  overscanColumnCount: 0,
  overscanIndicesGetter: VOt,
  overscanRowCount: 10,
  role: "grid",
  scrollingResetTimeInterval: kOt,
  scrollToAlignment: "auto",
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: !1
});
fG(xd);
var FOt = 1;
function lge(e) {
  var t = e.cellCount, i = e.overscanCellsCount, n = e.scrollDirection, r = e.startIndex, g = e.stopIndex;
  return i = Math.max(1, i), n === FOt ? {
    overscanStartIndex: Math.max(0, r - 1),
    overscanStopIndex: Math.min(t - 1, g + i)
  } : {
    overscanStartIndex: Math.max(0, r - i),
    overscanStopIndex: Math.min(t - 1, g + 1)
  };
}
function BD(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function xOt(e) {
  if (Array.isArray(e))
    return BD(e);
}
function DOt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function age(e, t) {
  if (e) {
    if (typeof e == "string")
      return BD(e, t);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? BD(e, t) : void 0;
  }
}
function JOt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EOt(e) {
  return xOt(e) || DOt(e) || age(e) || JOt();
}
function NOt(e, t, i) {
  return t = an(t), Jo(e, sge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function sge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sge = function() {
    return !!e;
  })();
}
var Ige = /* @__PURE__ */ function(e) {
  function t(i, n) {
    var r;
    return fr(this, t), r = NOt(this, t, [i, n]), r._loadMoreRowsMemoizer = mm(), r._onRowsRendered = r._onRowsRendered.bind(r), r._registerChild = r._registerChild.bind(r), r;
  }
  return Eo(t, e), Zr(t, [{
    key: "resetLoadMoreRowsCache",
    value: function(n) {
      this._loadMoreRowsMemoizer = mm(), n && this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props.children;
      return n({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function(n) {
      var r = this, g = this.props.loadMoreRows;
      n.forEach(function(o) {
        var l = g(o);
        l && l.then(function() {
          LOt({
            lastRenderedStartIndex: r._lastRenderedStartIndex,
            lastRenderedStopIndex: r._lastRenderedStopIndex,
            startIndex: o.startIndex,
            stopIndex: o.stopIndex
          }) && r._registeredChild && TOt(r._registeredChild, r._lastRenderedStartIndex);
        });
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function(n) {
      var r = n.startIndex, g = n.stopIndex;
      this._lastRenderedStartIndex = r, this._lastRenderedStopIndex = g, this._doStuff(r, g);
    }
  }, {
    key: "_doStuff",
    value: function(n, r) {
      var g, o = this, l = this.props, a = l.isRowLoaded, I = l.minimumBatchSize, c = l.rowCount, d = l.threshold, C = KOt({
        isRowLoaded: a,
        minimumBatchSize: I,
        rowCount: c,
        startIndex: Math.max(0, n - d),
        stopIndex: Math.min(c - 1, r + d)
      }), A = (g = []).concat.apply(g, EOt(C.map(function(b) {
        var m = b.startIndex, p = b.stopIndex;
        return [m, p];
      })));
      this._loadMoreRowsMemoizer({
        callback: function() {
          o._loadUnloadedRanges(C);
        },
        indices: {
          squashedUnloadedRanges: A
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function(n) {
      this._registeredChild = n;
    }
  }]);
}(X.PureComponent);
We(Ige, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});
Ige.propTypes = {};
function LOt(e) {
  var t = e.lastRenderedStartIndex, i = e.lastRenderedStopIndex, n = e.startIndex, r = e.stopIndex;
  return !(n > i || r < t);
}
function KOt(e) {
  for (var t = e.isRowLoaded, i = e.minimumBatchSize, n = e.rowCount, r = e.startIndex, g = e.stopIndex, o = [], l = null, a = null, I = r; I <= g; I++) {
    var c = t({
      index: I
    });
    c ? a !== null && (o.push({
      startIndex: l,
      stopIndex: a
    }), l = a = null) : (a = I, l === null && (l = I));
  }
  if (a !== null) {
    for (var d = Math.min(Math.max(a, l + i - 1), n - 1), C = a + 1; C <= d && !t({
      index: C
    }); C++)
      a = C;
    o.push({
      startIndex: l,
      stopIndex: a
    });
  }
  if (o.length)
    for (var A = o[0]; A.stopIndex - A.startIndex + 1 < i && A.startIndex > 0; ) {
      var b = A.startIndex - 1;
      if (!t({
        index: b
      }))
        A.startIndex = b;
      else
        break;
    }
  return o;
}
function TOt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = typeof e.recomputeGridSize == "function" ? e.recomputeGridSize : e.recomputeRowHeights;
  i ? i.call(e, t) : e.forceUpdate();
}
function MOt(e, t, i) {
  return t = an(t), Jo(e, cge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function cge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cge = function() {
    return !!e;
  })();
}
var dge = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = MOt(this, t, [].concat(r)), We(i, "Grid", void 0), We(i, "_cellRenderer", function(o) {
      var l = o.parent, a = o.rowIndex, I = o.style, c = o.isScrolling, d = o.isVisible, C = o.key, A = i.props.rowRenderer, b = Object.getOwnPropertyDescriptor(I, "width");
      return b && b.writable && (I.width = "100%"), A({
        index: a,
        style: I,
        isScrolling: c,
        isVisible: d,
        key: C,
        parent: l
      });
    }), We(i, "_setRef", function(o) {
      i.Grid = o;
    }), We(i, "_onScroll", function(o) {
      var l = o.clientHeight, a = o.scrollHeight, I = o.scrollTop, c = i.props.onScroll;
      c({
        clientHeight: l,
        scrollHeight: a,
        scrollTop: I
      });
    }), We(i, "_onSectionRendered", function(o) {
      var l = o.rowOverscanStartIndex, a = o.rowOverscanStopIndex, I = o.rowStartIndex, c = o.rowStopIndex, d = i.props.onRowsRendered;
      d({
        overscanStartIndex: l,
        overscanStopIndex: a,
        startIndex: I,
        stopIndex: c
      });
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "forceUpdateGrid",
    value: function() {
      this.Grid && this.Grid.forceUpdate();
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function(n) {
      var r = n.alignment, g = n.index;
      if (this.Grid) {
        var o = this.Grid.getOffsetForCell({
          alignment: r,
          rowIndex: g,
          columnIndex: 0
        }), l = o.scrollTop;
        return l;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(n) {
      var r = n.columnIndex, g = n.rowIndex;
      this.Grid && this.Grid.invalidateCellSizeAfterRender({
        rowIndex: g,
        columnIndex: r
      });
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function() {
      this.Grid && this.Grid.measureAllCells();
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.columnIndex, g = r === void 0 ? 0 : r, o = n.rowIndex, l = o === void 0 ? 0 : o;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: l,
        columnIndex: g
      });
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: n,
        columnIndex: 0
      });
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToPosition({
        scrollTop: n
      });
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: n
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.className, g = n.noRowsRenderer, o = n.scrollToIndex, l = n.width, a = Ag("ReactVirtualized__List", r);
      return /* @__PURE__ */ X.createElement(xd, et({}, this.props, {
        autoContainerWidth: !0,
        cellRenderer: this._cellRenderer,
        className: a,
        columnWidth: l,
        columnCount: 1,
        noContentRenderer: g,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: o
      }));
    }
  }]);
}(X.PureComponent);
We(dge, "defaultProps", {
  autoHeight: !1,
  estimatedRowSize: 30,
  onScroll: function() {
  },
  noRowsRenderer: function() {
    return null;
  },
  onRowsRendered: function() {
  },
  overscanIndicesGetter: lge,
  overscanRowCount: 10,
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
function POt(e) {
  if (Array.isArray(e))
    return e;
}
function UOt(e, t) {
  var i = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (i != null) {
    var n, r, g, o, l = [], a = !0, I = !1;
    try {
      if (g = (i = i.call(e)).next, t !== 0)
        for (; !(a = (n = g.call(i)).done) && (l.push(n.value), l.length !== t); a = !0)
          ;
    } catch (c) {
      I = !0, r = c;
    } finally {
      try {
        if (!a && i.return != null && (o = i.return(), Object(o) !== o))
          return;
      } finally {
        if (I)
          throw r;
      }
    }
    return l;
  }
}
function zOt() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OOt(e, t) {
  return POt(e) || UOt(e, t) || age(e, t) || zOt();
}
function QOt(e, t, i, n) {
  for (var r = i + 1; t <= i; ) {
    var g = t + i >>> 1, o = e[g];
    o >= n ? (r = g, i = g - 1) : t = g + 1;
  }
  return r;
}
function jOt(e, t, i, n, r) {
  for (var g = i + 1; t <= i; ) {
    var o = t + i >>> 1, l = e[o];
    r(l, n) >= 0 ? (g = o, i = o - 1) : t = o + 1;
  }
  return g;
}
function qOt(e, t, i, n, r) {
  return typeof i == "function" ? jOt(e, n === void 0 ? 0 : n | 0, r === void 0 ? e.length - 1 : r | 0, t, i) : QOt(e, i === void 0 ? 0 : i | 0, n === void 0 ? e.length - 1 : n | 0, t);
}
function _Ot(e, t, i, n) {
  for (var r = i + 1; t <= i; ) {
    var g = t + i >>> 1, o = e[g];
    o > n ? (r = g, i = g - 1) : t = g + 1;
  }
  return r;
}
function $Ot(e, t, i, n, r) {
  for (var g = i + 1; t <= i; ) {
    var o = t + i >>> 1, l = e[o];
    r(l, n) > 0 ? (g = o, i = o - 1) : t = o + 1;
  }
  return g;
}
function e4t(e, t, i, n, r) {
  return typeof i == "function" ? $Ot(e, n === void 0 ? 0 : n | 0, r === void 0 ? e.length - 1 : r | 0, t, i) : _Ot(e, i === void 0 ? 0 : i | 0, n === void 0 ? e.length - 1 : n | 0, t);
}
function t4t(e, t, i, n) {
  for (var r = t - 1; t <= i; ) {
    var g = t + i >>> 1, o = e[g];
    o < n ? (r = g, t = g + 1) : i = g - 1;
  }
  return r;
}
function i4t(e, t, i, n, r) {
  for (var g = t - 1; t <= i; ) {
    var o = t + i >>> 1, l = e[o];
    r(l, n) < 0 ? (g = o, t = o + 1) : i = o - 1;
  }
  return g;
}
function n4t(e, t, i, n, r) {
  return typeof i == "function" ? i4t(e, n === void 0 ? 0 : n | 0, r === void 0 ? e.length - 1 : r | 0, t, i) : t4t(e, i === void 0 ? 0 : i | 0, n === void 0 ? e.length - 1 : n | 0, t);
}
function r4t(e, t, i, n) {
  for (var r = t - 1; t <= i; ) {
    var g = t + i >>> 1, o = e[g];
    o <= n ? (r = g, t = g + 1) : i = g - 1;
  }
  return r;
}
function g4t(e, t, i, n, r) {
  for (var g = t - 1; t <= i; ) {
    var o = t + i >>> 1, l = e[o];
    r(l, n) <= 0 ? (g = o, t = o + 1) : i = o - 1;
  }
  return g;
}
function o4t(e, t, i, n, r) {
  return typeof i == "function" ? g4t(e, n === void 0 ? 0 : n | 0, r === void 0 ? e.length - 1 : r | 0, t, i) : r4t(e, i === void 0 ? 0 : i | 0, n === void 0 ? e.length - 1 : n | 0, t);
}
function l4t(e, t, i, n) {
  for (; t <= i; ) {
    var r = t + i >>> 1, g = e[r];
    if (g === n)
      return r;
    g <= n ? t = r + 1 : i = r - 1;
  }
  return -1;
}
function a4t(e, t, i, n, r) {
  for (; t <= i; ) {
    var g = t + i >>> 1, o = e[g], l = r(o, n);
    if (l === 0)
      return g;
    l <= 0 ? t = g + 1 : i = g - 1;
  }
  return -1;
}
function s4t(e, t, i, n, r) {
  return typeof i == "function" ? a4t(e, n === void 0 ? 0 : n | 0, r === void 0 ? e.length - 1 : r | 0, t, i) : l4t(e, i === void 0 ? 0 : i | 0, n === void 0 ? e.length - 1 : n | 0, t);
}
const i2 = {
  ge: qOt,
  gt: e4t,
  lt: n4t,
  le: o4t,
  eq: s4t
};
var Th = 0, wC = 1, FV = 2;
function NN(e, t, i, n, r) {
  this.mid = e, this.left = t, this.right = i, this.leftPoints = n, this.rightPoints = r, this.count = (t ? t.count : 0) + (i ? i.count : 0) + n.length;
}
var ZG = NN.prototype;
function nx(e, t) {
  e.mid = t.mid, e.left = t.left, e.right = t.right, e.leftPoints = t.leftPoints, e.rightPoints = t.rightPoints, e.count = t.count;
}
function uge(e, t) {
  var i = gZ(t);
  e.mid = i.mid, e.left = i.left, e.right = i.right, e.leftPoints = i.leftPoints, e.rightPoints = i.rightPoints, e.count = i.count;
}
function xO(e, t) {
  var i = e.intervals([]);
  i.push(t), uge(e, i);
}
function DO(e, t) {
  var i = e.intervals([]), n = i.indexOf(t);
  return n < 0 ? Th : (i.splice(n, 1), uge(e, i), wC);
}
ZG.intervals = function(e) {
  return e.push.apply(e, this.leftPoints), this.left && this.left.intervals(e), this.right && this.right.intervals(e), e;
};
ZG.insert = function(e) {
  var t = this.count - this.leftPoints.length;
  if (this.count += 1, e[1] < this.mid)
    this.left ? 4 * (this.left.count + 1) > 3 * (t + 1) ? xO(this, e) : this.left.insert(e) : this.left = gZ([e]);
  else if (e[0] > this.mid)
    this.right ? 4 * (this.right.count + 1) > 3 * (t + 1) ? xO(this, e) : this.right.insert(e) : this.right = gZ([e]);
  else {
    var i = i2.ge(this.leftPoints, e, LN), n = i2.ge(this.rightPoints, e, KN);
    this.leftPoints.splice(i, 0, e), this.rightPoints.splice(n, 0, e);
  }
};
ZG.remove = function(e) {
  var t = this.count - this.leftPoints;
  if (e[1] < this.mid) {
    if (!this.left)
      return Th;
    var i = this.right ? this.right.count : 0;
    if (4 * i > 3 * (t - 1))
      return DO(this, e);
    var n = this.left.remove(e);
    return n === FV ? (this.left = null, this.count -= 1, wC) : (n === wC && (this.count -= 1), n);
  } else if (e[0] > this.mid) {
    if (!this.right)
      return Th;
    var r = this.left ? this.left.count : 0;
    if (4 * r > 3 * (t - 1))
      return DO(this, e);
    var n = this.right.remove(e);
    return n === FV ? (this.right = null, this.count -= 1, wC) : (n === wC && (this.count -= 1), n);
  } else {
    if (this.count === 1)
      return this.leftPoints[0] === e ? FV : Th;
    if (this.leftPoints.length === 1 && this.leftPoints[0] === e) {
      if (this.left && this.right) {
        for (var g = this, o = this.left; o.right; )
          g = o, o = o.right;
        if (g === this)
          o.right = this.right;
        else {
          var l = this.left, n = this.right;
          g.count -= o.count, g.right = o.left, o.left = l, o.right = n;
        }
        nx(this, o), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else
        this.left ? nx(this, this.left) : nx(this, this.right);
      return wC;
    }
    for (var l = i2.ge(this.leftPoints, e, LN); l < this.leftPoints.length && this.leftPoints[l][0] === e[0]; ++l)
      if (this.leftPoints[l] === e) {
        this.count -= 1, this.leftPoints.splice(l, 1);
        for (var n = i2.ge(this.rightPoints, e, KN); n < this.rightPoints.length && this.rightPoints[n][1] === e[1]; ++n)
          if (this.rightPoints[n] === e)
            return this.rightPoints.splice(n, 1), wC;
      }
    return Th;
  }
};
function Cge(e, t, i) {
  for (var n = 0; n < e.length && e[n][0] <= t; ++n) {
    var r = i(e[n]);
    if (r)
      return r;
  }
}
function Age(e, t, i) {
  for (var n = e.length - 1; n >= 0 && e[n][1] >= t; --n) {
    var r = i(e[n]);
    if (r)
      return r;
  }
}
function bge(e, t) {
  for (var i = 0; i < e.length; ++i) {
    var n = t(e[i]);
    if (n)
      return n;
  }
}
ZG.queryPoint = function(e, t) {
  if (e < this.mid) {
    if (this.left) {
      var i = this.left.queryPoint(e, t);
      if (i)
        return i;
    }
    return Cge(this.leftPoints, e, t);
  } else if (e > this.mid) {
    if (this.right) {
      var i = this.right.queryPoint(e, t);
      if (i)
        return i;
    }
    return Age(this.rightPoints, e, t);
  } else
    return bge(this.leftPoints, t);
};
ZG.queryInterval = function(e, t, i) {
  if (e < this.mid && this.left) {
    var n = this.left.queryInterval(e, t, i);
    if (n)
      return n;
  }
  if (t > this.mid && this.right) {
    var n = this.right.queryInterval(e, t, i);
    if (n)
      return n;
  }
  return t < this.mid ? Cge(this.leftPoints, t, i) : e > this.mid ? Age(this.rightPoints, e, i) : bge(this.leftPoints, i);
};
function I4t(e, t) {
  return e - t;
}
function LN(e, t) {
  var i = e[0] - t[0];
  return i || e[1] - t[1];
}
function KN(e, t) {
  var i = e[1] - t[1];
  return i || e[0] - t[0];
}
function gZ(e) {
  if (e.length === 0)
    return null;
  for (var t = [], i = 0; i < e.length; ++i)
    t.push(e[i][0], e[i][1]);
  t.sort(I4t);
  for (var n = t[t.length >> 1], r = [], g = [], o = [], i = 0; i < e.length; ++i) {
    var l = e[i];
    l[1] < n ? r.push(l) : n < l[0] ? g.push(l) : o.push(l);
  }
  var a = o, I = o.slice();
  return a.sort(LN), I.sort(KN), new NN(n, gZ(r), gZ(g), a, I);
}
function hge(e) {
  this.root = e;
}
var np = hge.prototype;
np.insert = function(e) {
  this.root ? this.root.insert(e) : this.root = new NN(e[0], null, null, [e], [e]);
};
np.remove = function(e) {
  if (this.root) {
    var t = this.root.remove(e);
    return t === FV && (this.root = null), t !== Th;
  }
  return !1;
};
np.queryPoint = function(e, t) {
  if (this.root)
    return this.root.queryPoint(e, t);
};
np.queryInterval = function(e, t, i) {
  if (e <= t && this.root)
    return this.root.queryInterval(e, t, i);
};
Object.defineProperty(np, "count", {
  get: function() {
    return this.root ? this.root.count : 0;
  }
});
Object.defineProperty(np, "intervals", {
  get: function() {
    return this.root ? this.root.intervals([]) : [];
  }
});
function c4t(e) {
  return new hge(null);
}
var rx = /* @__PURE__ */ function() {
  function e() {
    fr(this, e), We(this, "_columnSizeMap", {}), We(this, "_intervalTree", c4t()), We(this, "_leftMap", {});
  }
  return Zr(e, [{
    key: "estimateTotalHeight",
    value: function(i, n, r) {
      var g = i - this.count;
      return this.tallestColumnSize + Math.ceil(g / n) * r;
    }
    // Render all cells visible within the viewport range defined.
  }, {
    key: "range",
    value: function(i, n, r) {
      var g = this;
      this._intervalTree.queryInterval(i, i + n, function(o) {
        var l = OOt(o, 3), a = l[0];
        l[1];
        var I = l[2];
        return r(I, g._leftMap[I], a);
      });
    }
  }, {
    key: "setPosition",
    value: function(i, n, r, g) {
      this._intervalTree.insert([r, r + g, i]), this._leftMap[i] = n;
      var o = this._columnSizeMap, l = o[n];
      l === void 0 ? o[n] = r + g : o[n] = Math.max(l, r + g);
    }
  }, {
    key: "count",
    get: function() {
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function() {
      var i = this._columnSizeMap, n = 0;
      for (var r in i) {
        var g = i[r];
        n = n === 0 ? g : Math.min(n, g);
      }
      return n;
    }
  }, {
    key: "tallestColumnSize",
    get: function() {
      var i = this._columnSizeMap, n = 0;
      for (var r in i) {
        var g = i[r];
        n = Math.max(n, g);
      }
      return n;
    }
  }]);
}();
function JO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function d4t(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? JO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : JO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function u4t(e, t, i) {
  return t = an(t), Jo(e, mge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function mge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (mge = function() {
    return !!e;
  })();
}
var C4t = {}, A4t = 150, pge = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = u4t(this, t, [].concat(r)), We(i, "state", {
      isScrolling: !1,
      scrollTop: 0
    }), We(i, "_debounceResetIsScrollingId", void 0), We(i, "_invalidateOnUpdateStartIndex", null), We(i, "_invalidateOnUpdateStopIndex", null), We(i, "_positionCache", new rx()), We(i, "_startIndex", null), We(i, "_startIndexMemoized", null), We(i, "_stopIndex", null), We(i, "_stopIndexMemoized", null), We(i, "_debounceResetIsScrollingCallback", function() {
      i.setState({
        isScrolling: !1
      });
    }), We(i, "_setScrollingContainerRef", function(o) {
      i._scrollingContainer = o;
    }), We(i, "_onScroll", function(o) {
      var l = i.props.height, a = o.currentTarget.scrollTop, I = Math.min(Math.max(0, i._getEstimatedTotalHeight() - l), a);
      a === I && (i._debounceResetIsScrolling(), i.state.scrollTop !== I && i.setState({
        isScrolling: !0,
        scrollTop: I
      }));
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "clearCellPositions",
    value: function() {
      this._positionCache = new rx(), this.forceUpdate();
    }
    // HACK This method signature was intended for Grid
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(n) {
      var r = n.rowIndex;
      this._invalidateOnUpdateStartIndex === null ? (this._invalidateOnUpdateStartIndex = r, this._invalidateOnUpdateStopIndex = r) : (this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, r), this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, r));
    }
  }, {
    key: "recomputeCellPositions",
    value: function() {
      var n = this._positionCache.count - 1;
      this._positionCache = new rx(), this._populatePositionCache(0, n), this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, r) {
      this._checkInvalidateOnUpdate(), this._invokeOnScrollCallback(), this._invokeOnCellsRenderedCallback(), this.props.scrollTop !== n.scrollTop && this._debounceResetIsScrolling();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._debounceResetIsScrollingId && pm(this._debounceResetIsScrollingId);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, r = this.props, g = r.autoHeight, o = r.cellCount, l = r.cellMeasurerCache, a = r.cellRenderer, I = r.className, c = r.height, d = r.id, C = r.keyMapper, A = r.overscanByPixels, b = r.role, m = r.style, p = r.tabIndex, B = r.width, f = r.rowDirection, Z = this.state, y = Z.isScrolling, W = Z.scrollTop, V = [], w = this._getEstimatedTotalHeight(), v = this._positionCache.shortestColumnSize, H = this._positionCache.count, x = 0, J;
      if (this._positionCache.range(Math.max(0, W - A), c + A * 2, function(L, N, U) {
        typeof J > "u" ? (x = L, J = L) : (x = Math.min(x, L), J = Math.max(J, L)), V.push(a({
          index: L,
          isScrolling: y,
          key: C(L),
          parent: n,
          style: We(We(We(We({
            height: l.getHeight(L)
          }, f === "ltr" ? "left" : "right", N), "position", "absolute"), "top", U), "width", l.getWidth(L))
        }));
      }), v < W + c + A && H < o)
        for (var K = Math.min(o - H, Math.ceil((W + c + A - v) / l.defaultHeight * B / l.defaultWidth)), M = H; M < H + K; M++)
          J = M, V.push(a({
            index: M,
            isScrolling: y,
            key: C(M),
            parent: this,
            style: {
              width: l.getWidth(M)
            }
          }));
      return this._startIndex = x, this._stopIndex = J, /* @__PURE__ */ X.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props["aria-label"],
        className: Ag("ReactVirtualized__Masonry", I),
        id: d,
        onScroll: this._onScroll,
        role: b,
        style: d4t({
          boxSizing: "border-box",
          direction: "ltr",
          height: g ? "auto" : c,
          overflowX: "hidden",
          overflowY: w < c ? "hidden" : "auto",
          position: "relative",
          width: B,
          WebkitOverflowScrolling: "touch",
          willChange: "transform"
        }, m),
        tabIndex: p
      }, /* @__PURE__ */ X.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: "100%",
          height: w,
          maxWidth: "100%",
          maxHeight: w,
          overflow: "hidden",
          pointerEvents: y ? "none" : "",
          position: "relative"
        }
      }, V));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function() {
      if (typeof this._invalidateOnUpdateStartIndex == "number") {
        var n = this._invalidateOnUpdateStartIndex, r = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null, this._invalidateOnUpdateStopIndex = null, this._populatePositionCache(n, r), this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function() {
      var n = this.props.scrollingResetTimeInterval;
      this._debounceResetIsScrollingId && pm(this._debounceResetIsScrollingId), this._debounceResetIsScrollingId = EN(this._debounceResetIsScrollingCallback, n);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function() {
      var n = this.props, r = n.cellCount, g = n.cellMeasurerCache, o = n.width, l = Math.max(1, Math.floor(o / g.defaultWidth));
      return this._positionCache.estimateTotalHeight(r, l, g.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function() {
      var n = this.props, r = n.height, g = n.onScroll, o = this.state.scrollTop;
      this._onScrollMemoized !== o && (g({
        clientHeight: r,
        scrollHeight: this._getEstimatedTotalHeight(),
        scrollTop: o
      }), this._onScrollMemoized = o);
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var n = this.props.onCellsRendered;
        n({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        }), this._startIndexMemoized = this._startIndex, this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function(n, r) {
      for (var g = this.props, o = g.cellMeasurerCache, l = g.cellPositioner, a = n; a <= r; a++) {
        var I = l(a), c = I.left, d = I.top;
        this._positionCache.setPosition(a, c, d, o.getHeight(a));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, r) {
      return n.scrollTop !== void 0 && r.scrollTop !== n.scrollTop ? {
        isScrolling: !0,
        scrollTop: n.scrollTop
      } : null;
    }
  }]);
}(X.PureComponent);
We(pge, "defaultProps", {
  autoHeight: !1,
  keyMapper: b4t,
  onCellsRendered: EO,
  onScroll: EO,
  overscanByPixels: 20,
  role: "grid",
  scrollingResetTimeInterval: A4t,
  style: C4t,
  tabIndex: 0,
  rowDirection: "ltr"
});
function b4t(e) {
  return e;
}
function EO() {
}
fG(pge);
var gx = /* @__PURE__ */ function() {
  function e() {
    var t = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    fr(this, e), We(this, "_cellMeasurerCache", void 0), We(this, "_columnIndexOffset", void 0), We(this, "_rowIndexOffset", void 0), We(this, "columnWidth", function(a) {
      var I = a.index;
      t._cellMeasurerCache.columnWidth({
        index: I + t._columnIndexOffset
      });
    }), We(this, "rowHeight", function(a) {
      var I = a.index;
      t._cellMeasurerCache.rowHeight({
        index: I + t._rowIndexOffset
      });
    });
    var n = i.cellMeasurerCache, r = i.columnIndexOffset, g = r === void 0 ? 0 : r, o = i.rowIndexOffset, l = o === void 0 ? 0 : o;
    this._cellMeasurerCache = n, this._columnIndexOffset = g, this._rowIndexOffset = l;
  }
  return Zr(e, [{
    key: "clear",
    value: function(i, n) {
      this._cellMeasurerCache.clear(i + this._rowIndexOffset, n + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "defaultHeight",
    get: function() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(i + this._rowIndexOffset, n + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(i + this._rowIndexOffset, n + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function(i) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      return this._cellMeasurerCache.has(i + this._rowIndexOffset, n + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function(i, n, r, g) {
      this._cellMeasurerCache.set(i + this._rowIndexOffset, n + this._columnIndexOffset, r, g);
    }
  }]);
}(), h4t = ["rowIndex"], m4t = ["columnIndex", "rowIndex"], p4t = ["columnIndex"], B4t = ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"];
function NO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : NO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function f4t(e, t, i) {
  return t = an(t), Jo(e, Bge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function Bge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Bge = function() {
    return !!e;
  })();
}
var LO = 20, TN = /* @__PURE__ */ function(e) {
  function t(i, n) {
    var r;
    fr(this, t), r = f4t(this, t, [i, n]), We(r, "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: !1,
      showVerticalScrollbar: !1
    }), We(r, "_deferredInvalidateColumnIndex", null), We(r, "_deferredInvalidateRowIndex", null), We(r, "_bottomLeftGridRef", function(a) {
      r._bottomLeftGrid = a;
    }), We(r, "_bottomRightGridRef", function(a) {
      r._bottomRightGrid = a;
    }), We(r, "_cellRendererBottomLeftGrid", function(a) {
      var I = a.rowIndex, c = EB(a, h4t), d = r.props, C = d.cellRenderer, A = d.fixedRowCount, b = d.rowCount;
      return I === b - A ? /* @__PURE__ */ X.createElement("div", {
        key: c.key,
        style: Dn(Dn({}, c.style), {}, {
          height: LO
        })
      }) : C(Dn(Dn({}, c), {}, {
        parent: r,
        rowIndex: I + A
      }));
    }), We(r, "_cellRendererBottomRightGrid", function(a) {
      var I = a.columnIndex, c = a.rowIndex, d = EB(a, m4t), C = r.props, A = C.cellRenderer, b = C.fixedColumnCount, m = C.fixedRowCount;
      return A(Dn(Dn({}, d), {}, {
        columnIndex: I + b,
        parent: r,
        rowIndex: c + m
      }));
    }), We(r, "_cellRendererTopRightGrid", function(a) {
      var I = a.columnIndex, c = EB(a, p4t), d = r.props, C = d.cellRenderer, A = d.columnCount, b = d.fixedColumnCount;
      return I === A - b ? /* @__PURE__ */ X.createElement("div", {
        key: c.key,
        style: Dn(Dn({}, c.style), {}, {
          width: LO
        })
      }) : C(Dn(Dn({}, c), {}, {
        columnIndex: I + b,
        parent: r
      }));
    }), We(r, "_columnWidthRightGrid", function(a) {
      var I = a.index, c = r.props, d = c.columnCount, C = c.fixedColumnCount, A = c.columnWidth, b = r.state, m = b.scrollbarSize, p = b.showHorizontalScrollbar;
      return p && I === d - C ? m : typeof A == "function" ? A({
        index: I + C
      }) : A;
    }), We(r, "_onScroll", function(a) {
      var I = a.scrollLeft, c = a.scrollTop;
      r.setState({
        scrollLeft: I,
        scrollTop: c
      });
      var d = r.props.onScroll;
      d && d(a);
    }), We(r, "_onScrollbarPresenceChange", function(a) {
      var I = a.horizontal, c = a.size, d = a.vertical, C = r.state, A = C.showHorizontalScrollbar, b = C.showVerticalScrollbar;
      if (I !== A || d !== b) {
        r.setState({
          scrollbarSize: c,
          showHorizontalScrollbar: I,
          showVerticalScrollbar: d
        });
        var m = r.props.onScrollbarPresenceChange;
        typeof m == "function" && m({
          horizontal: I,
          size: c,
          vertical: d
        });
      }
    }), We(r, "_onScrollLeft", function(a) {
      var I = a.scrollLeft;
      r._onScroll({
        scrollLeft: I,
        scrollTop: r.state.scrollTop
      });
    }), We(r, "_onScrollTop", function(a) {
      var I = a.scrollTop;
      r._onScroll({
        scrollTop: I,
        scrollLeft: r.state.scrollLeft
      });
    }), We(r, "_rowHeightBottomGrid", function(a) {
      var I = a.index, c = r.props, d = c.fixedRowCount, C = c.rowCount, A = c.rowHeight, b = r.state, m = b.scrollbarSize, p = b.showVerticalScrollbar;
      return p && I === C - d ? m : typeof A == "function" ? A({
        index: I + d
      }) : A;
    }), We(r, "_topLeftGridRef", function(a) {
      r._topLeftGrid = a;
    }), We(r, "_topRightGridRef", function(a) {
      r._topRightGrid = a;
    });
    var g = i.deferredMeasurementCache, o = i.fixedColumnCount, l = i.fixedRowCount;
    return r._maybeCalculateCachedStyles(!0), g && (r._deferredMeasurementCacheBottomLeftGrid = l > 0 ? new gx({
      cellMeasurerCache: g,
      columnIndexOffset: 0,
      rowIndexOffset: l
    }) : g, r._deferredMeasurementCacheBottomRightGrid = o > 0 || l > 0 ? new gx({
      cellMeasurerCache: g,
      columnIndexOffset: o,
      rowIndexOffset: l
    }) : g, r._deferredMeasurementCacheTopRightGrid = o > 0 ? new gx({
      cellMeasurerCache: g,
      columnIndexOffset: o,
      rowIndexOffset: 0
    }) : g), r;
  }
  return Eo(t, e), Zr(t, [{
    key: "forceUpdateGrids",
    value: function() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate(), this._bottomRightGrid && this._bottomRightGrid.forceUpdate(), this._topLeftGrid && this._topLeftGrid.forceUpdate(), this._topRightGrid && this._topRightGrid.forceUpdate();
    }
    /** See Grid#invalidateCellSizeAfterRender */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.columnIndex, g = r === void 0 ? 0 : r, o = n.rowIndex, l = o === void 0 ? 0 : o;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex == "number" ? Math.min(this._deferredInvalidateColumnIndex, g) : g, this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex == "number" ? Math.min(this._deferredInvalidateRowIndex, l) : l;
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllCells",
    value: function() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells(), this._bottomRightGrid && this._bottomRightGrid.measureAllCells(), this._topLeftGrid && this._topLeftGrid.measureAllCells(), this._topRightGrid && this._topRightGrid.measureAllCells();
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.columnIndex, g = r === void 0 ? 0 : r, o = n.rowIndex, l = o === void 0 ? 0 : o, a = this.props, I = a.fixedColumnCount, c = a.fixedRowCount, d = Math.max(0, g - I), C = Math.max(0, l - c);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: g,
        rowIndex: C
      }), this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: d,
        rowIndex: C
      }), this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: g,
        rowIndex: l
      }), this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: d,
        rowIndex: l
      }), this._leftGridWidth = null, this._topGridHeight = null, this._maybeCalculateCachedStyles(!0);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.props, r = n.scrollLeft, g = n.scrollTop;
      if (r > 0 || g > 0) {
        var o = {};
        r > 0 && (o.scrollLeft = r), g > 0 && (o.scrollTop = g), this.setState(o);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, r = n.onScroll, g = n.onSectionRendered;
      n.onScrollbarPresenceChange, n.scrollLeft;
      var o = n.scrollToColumn;
      n.scrollTop;
      var l = n.scrollToRow, a = EB(n, B4t);
      if (this._prepareForRender(), this.props.width === 0 || this.props.height === 0)
        return null;
      var I = this.state, c = I.scrollLeft, d = I.scrollTop;
      return /* @__PURE__ */ X.createElement("div", {
        style: this._containerOuterStyle
      }, /* @__PURE__ */ X.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(a), this._renderTopRightGrid(Dn(Dn({}, a), {}, {
        onScroll: r,
        scrollLeft: c
      }))), /* @__PURE__ */ X.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(Dn(Dn({}, a), {}, {
        onScroll: r,
        scrollTop: d
      })), this._renderBottomRightGrid(Dn(Dn({}, a), {}, {
        onScroll: r,
        onSectionRendered: g,
        scrollLeft: c,
        scrollToColumn: o,
        scrollToRow: l,
        scrollTop: d
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function(n) {
      var r = n.height, g = this._getTopGridHeight(n);
      return r - g;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function(n) {
      var r = n.fixedColumnCount, g = n.columnWidth;
      if (this._leftGridWidth == null)
        if (typeof g == "function") {
          for (var o = 0, l = 0; l < r; l++)
            o += g({
              index: l
            });
          this._leftGridWidth = o;
        } else
          this._leftGridWidth = g * r;
      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function(n) {
      var r = n.width, g = this._getLeftGridWidth(n);
      return r - g;
    }
  }, {
    key: "_getTopGridHeight",
    value: function(n) {
      var r = n.fixedRowCount, g = n.rowHeight;
      if (this._topGridHeight == null)
        if (typeof g == "function") {
          for (var o = 0, l = 0; l < r; l++)
            o += g({
              index: l
            });
          this._topGridHeight = o;
        } else
          this._topGridHeight = g * r;
      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function() {
      if (typeof this._deferredInvalidateColumnIndex == "number") {
        var n = this._deferredInvalidateColumnIndex, r = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null, this._deferredInvalidateRowIndex = null, this.recomputeGridSize({
          columnIndex: n,
          rowIndex: r
        }), this.forceUpdate();
      }
    }
    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */
  }, {
    key: "_maybeCalculateCachedStyles",
    value: function(n) {
      var r = this.props, g = r.columnWidth, o = r.enableFixedColumnScroll, l = r.enableFixedRowScroll, a = r.height, I = r.fixedColumnCount, c = r.fixedRowCount, d = r.rowHeight, C = r.style, A = r.styleBottomLeftGrid, b = r.styleBottomRightGrid, m = r.styleTopLeftGrid, p = r.styleTopRightGrid, B = r.width, f = n || a !== this._lastRenderedHeight || B !== this._lastRenderedWidth, Z = n || g !== this._lastRenderedColumnWidth || I !== this._lastRenderedFixedColumnCount, y = n || c !== this._lastRenderedFixedRowCount || d !== this._lastRenderedRowHeight;
      (n || f || C !== this._lastRenderedStyle) && (this._containerOuterStyle = Dn({
        height: a,
        overflow: "visible",
        // Let :focus outline show through
        width: B
      }, C)), (n || f || y) && (this._containerTopStyle = {
        height: this._getTopGridHeight(this.props),
        position: "relative",
        width: B
      }, this._containerBottomStyle = {
        height: a - this._getTopGridHeight(this.props),
        overflow: "visible",
        // Let :focus outline show through
        position: "relative",
        width: B
      }), (n || A !== this._lastRenderedStyleBottomLeftGrid) && (this._bottomLeftGridStyle = Dn({
        left: 0,
        overflowX: "hidden",
        overflowY: o ? "auto" : "hidden",
        position: "absolute"
      }, A)), (n || Z || b !== this._lastRenderedStyleBottomRightGrid) && (this._bottomRightGridStyle = Dn({
        left: this._getLeftGridWidth(this.props),
        position: "absolute"
      }, b)), (n || m !== this._lastRenderedStyleTopLeftGrid) && (this._topLeftGridStyle = Dn({
        left: 0,
        overflowX: "hidden",
        overflowY: "hidden",
        position: "absolute",
        top: 0
      }, m)), (n || Z || p !== this._lastRenderedStyleTopRightGrid) && (this._topRightGridStyle = Dn({
        left: this._getLeftGridWidth(this.props),
        overflowX: l ? "auto" : "hidden",
        overflowY: "hidden",
        position: "absolute",
        top: 0
      }, p)), this._lastRenderedColumnWidth = g, this._lastRenderedFixedColumnCount = I, this._lastRenderedFixedRowCount = c, this._lastRenderedHeight = a, this._lastRenderedRowHeight = d, this._lastRenderedStyle = C, this._lastRenderedStyleBottomLeftGrid = A, this._lastRenderedStyleBottomRightGrid = b, this._lastRenderedStyleTopLeftGrid = m, this._lastRenderedStyleTopRightGrid = p, this._lastRenderedWidth = B;
    }
  }, {
    key: "_prepareForRender",
    value: function() {
      (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) && (this._leftGridWidth = null), (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) && (this._topGridHeight = null), this._maybeCalculateCachedStyles(), this._lastRenderedColumnWidth = this.props.columnWidth, this._lastRenderedFixedColumnCount = this.props.fixedColumnCount, this._lastRenderedFixedRowCount = this.props.fixedRowCount, this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function(n) {
      var r = n.enableFixedColumnScroll, g = n.fixedColumnCount, o = n.fixedRowCount, l = n.rowCount, a = n.hideBottomLeftGridScrollbar, I = this.state.showVerticalScrollbar;
      if (!g)
        return null;
      var c = I ? 1 : 0, d = this._getBottomGridHeight(n), C = this._getLeftGridWidth(n), A = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0, b = a ? C + A : C, m = /* @__PURE__ */ X.createElement(xd, et({}, n, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: g,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: d,
        onScroll: r ? this._onScrollTop : void 0,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, l - o) + c,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: b
      }));
      return a ? /* @__PURE__ */ X.createElement("div", {
        className: "BottomLeftGrid_ScrollWrapper",
        style: Dn(Dn({}, this._bottomLeftGridStyle), {}, {
          height: d,
          width: C,
          overflowY: "hidden"
        })
      }, m) : m;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function(n) {
      var r = n.columnCount, g = n.fixedColumnCount, o = n.fixedRowCount, l = n.rowCount, a = n.scrollToColumn, I = n.scrollToRow;
      return /* @__PURE__ */ X.createElement(xd, et({}, n, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, r - g),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(n),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, l - o),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: a - g,
        scrollToRow: I - o,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(n)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function(n) {
      var r = n.fixedColumnCount, g = n.fixedRowCount;
      return !r || !g ? null : /* @__PURE__ */ X.createElement(xd, et({}, n, {
        className: this.props.classNameTopLeftGrid,
        columnCount: r,
        height: this._getTopGridHeight(n),
        ref: this._topLeftGridRef,
        rowCount: g,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(n)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function(n) {
      var r = n.columnCount, g = n.enableFixedRowScroll, o = n.fixedColumnCount, l = n.fixedRowCount, a = n.scrollLeft, I = n.hideTopRightGridScrollbar, c = this.state, d = c.showHorizontalScrollbar, C = c.scrollbarSize;
      if (!l)
        return null;
      var A = d ? 1 : 0, b = this._getTopGridHeight(n), m = this._getRightGridWidth(n), p = d ? C : 0, B = b, f = this._topRightGridStyle;
      I && (B = b + p, f = Dn(Dn({}, this._topRightGridStyle), {}, {
        left: 0
      }));
      var Z = /* @__PURE__ */ X.createElement(xd, et({}, n, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, r - o) + A,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: B,
        onScroll: g ? this._onScrollLeft : void 0,
        ref: this._topRightGridRef,
        rowCount: l,
        scrollLeft: a,
        style: f,
        tabIndex: null,
        width: m
      }));
      return I ? /* @__PURE__ */ X.createElement("div", {
        className: "TopRightGrid_ScrollWrapper",
        style: Dn(Dn({}, this._topRightGridStyle), {}, {
          height: b,
          width: m,
          overflowX: "hidden"
        })
      }, Z) : Z;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, r) {
      return n.scrollLeft !== r.scrollLeft || n.scrollTop !== r.scrollTop ? {
        scrollLeft: n.scrollLeft != null && n.scrollLeft >= 0 ? n.scrollLeft : r.scrollLeft,
        scrollTop: n.scrollTop != null && n.scrollTop >= 0 ? n.scrollTop : r.scrollTop
      } : null;
    }
  }]);
}(X.PureComponent);
We(TN, "defaultProps", {
  classNameBottomLeftGrid: "",
  classNameBottomRightGrid: "",
  classNameTopLeftGrid: "",
  classNameTopRightGrid: "",
  enableFixedColumnScroll: !1,
  enableFixedRowScroll: !1,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: !1,
  hideBottomLeftGridScrollbar: !1
});
TN.propTypes = {};
fG(TN);
function Z4t(e, t, i) {
  return t = an(t), Jo(e, fge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function fge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fge = function() {
    return !!e;
  })();
}
var G4t = /* @__PURE__ */ function(e) {
  function t(i, n) {
    var r;
    return fr(this, t), r = Z4t(this, t, [i, n]), r.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    }, r._onScroll = r._onScroll.bind(r), r;
  }
  return Eo(t, e), Zr(t, [{
    key: "render",
    value: function() {
      var n = this.props.children, r = this.state, g = r.clientHeight, o = r.clientWidth, l = r.scrollHeight, a = r.scrollLeft, I = r.scrollTop, c = r.scrollWidth;
      return n({
        clientHeight: g,
        clientWidth: o,
        onScroll: this._onScroll,
        scrollHeight: l,
        scrollLeft: a,
        scrollTop: I,
        scrollWidth: c
      });
    }
  }, {
    key: "_onScroll",
    value: function(n) {
      var r = n.clientHeight, g = n.clientWidth, o = n.scrollHeight, l = n.scrollLeft, a = n.scrollTop, I = n.scrollWidth;
      this.setState({
        clientHeight: r,
        clientWidth: g,
        scrollHeight: o,
        scrollLeft: l,
        scrollTop: a,
        scrollWidth: I
      });
    }
  }]);
}(X.PureComponent);
G4t.propTypes = {};
function y4t(e) {
  var t = e.dataKey, i = e.rowData;
  return typeof i.get == "function" ? i.get(t) : i[t];
}
function W4t(e) {
  var t = e.cellData;
  return t == null ? "" : String(t);
}
function S4t(e) {
  var t = e.className, i = e.columns, n = e.style;
  return /* @__PURE__ */ X.createElement("div", {
    className: t,
    role: "row",
    style: n
  }, i);
}
var Dd = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: "ASC",
  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: "DESC"
};
function Zge(e) {
  var t = e.sortDirection, i = Ag("ReactVirtualized__Table__sortableHeaderIcon", {
    "ReactVirtualized__Table__sortableHeaderIcon--ASC": t === Dd.ASC,
    "ReactVirtualized__Table__sortableHeaderIcon--DESC": t === Dd.DESC
  });
  return /* @__PURE__ */ X.createElement("svg", {
    className: i,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, t === Dd.ASC ? /* @__PURE__ */ X.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : /* @__PURE__ */ X.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /* @__PURE__ */ X.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
Zge.propTypes = {};
function V4t(e) {
  var t = e.dataKey, i = e.label, n = e.sortBy, r = e.sortDirection, g = n === t, o = [/* @__PURE__ */ X.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof i == "string" ? i : null
  }, i)];
  return g && o.push(/* @__PURE__ */ X.createElement(Zge, {
    key: "SortIndicator",
    sortDirection: r
  })), o;
}
function w4t(e) {
  var t = e.className, i = e.columns, n = e.index, r = e.key, g = e.onRowClick, o = e.onRowDoubleClick, l = e.onRowMouseOut, a = e.onRowMouseOver, I = e.onRowRightClick, c = e.rowData, d = e.style, C = {
    "aria-rowindex": n + 1
  };
  return (g || o || l || a || I) && (C["aria-label"] = "row", C.tabIndex = 0, g && (C.onClick = function(A) {
    return g({
      event: A,
      index: n,
      rowData: c
    });
  }), o && (C.onDoubleClick = function(A) {
    return o({
      event: A,
      index: n,
      rowData: c
    });
  }), l && (C.onMouseOut = function(A) {
    return l({
      event: A,
      index: n,
      rowData: c
    });
  }), a && (C.onMouseOver = function(A) {
    return a({
      event: A,
      index: n,
      rowData: c
    });
  }), I && (C.onContextMenu = function(A) {
    return I({
      event: A,
      index: n,
      rowData: c
    });
  })), /* @__PURE__ */ X.createElement("div", et({}, C, {
    className: t,
    key: r,
    role: "row",
    style: d
  }), i);
}
function v4t(e, t, i) {
  return t = an(t), Jo(e, Gge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function Gge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gge = function() {
    return !!e;
  })();
}
var MN = /* @__PURE__ */ function(e) {
  function t() {
    return fr(this, t), v4t(this, t, arguments);
  }
  return Eo(t, e), Zr(t);
}(X.Component);
We(MN, "defaultProps", {
  cellDataGetter: y4t,
  cellRenderer: W4t,
  defaultSortDirection: Dd.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: V4t,
  style: {}
});
MN.propTypes = {};
function KO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function oI(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? KO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : KO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function R4t(e, t, i) {
  return t = an(t), Jo(e, yge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function yge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yge = function() {
    return !!e;
  })();
}
var Wge = /* @__PURE__ */ function(e) {
  function t(i) {
    var n;
    return fr(this, t), n = R4t(this, t, [i]), n.state = {
      scrollbarWidth: 0
    }, n._createColumn = n._createColumn.bind(n), n._createRow = n._createRow.bind(n), n._onScroll = n._onScroll.bind(n), n._onSectionRendered = n._onSectionRendered.bind(n), n._setRef = n._setRef.bind(n), n._setGridElementRef = n._setGridElementRef.bind(n), n;
  }
  return Eo(t, e), Zr(t, [{
    key: "forceUpdateGrid",
    value: function() {
      this.Grid && this.Grid.forceUpdate();
    }
    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function(n) {
      var r = n.alignment, g = n.index;
      if (this.Grid) {
        var o = this.Grid.getOffsetForCell({
          alignment: r,
          rowIndex: g
        }), l = o.scrollTop;
        return l;
      }
      return 0;
    }
    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function(n) {
      var r = n.columnIndex, g = n.rowIndex;
      this.Grid && this.Grid.invalidateCellSizeAfterRender({
        rowIndex: g,
        columnIndex: r
      });
    }
    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function() {
      this.Grid && this.Grid.measureAllCells();
    }
    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.columnIndex, g = r === void 0 ? 0 : r, o = n.rowIndex, l = o === void 0 ? 0 : o;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: l,
        columnIndex: g
      });
    }
    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.recomputeGridSize({
        rowIndex: n
      });
    }
    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToPosition({
        scrollTop: n
      });
    }
    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.Grid && this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: n
      });
    }
  }, {
    key: "getScrollbarWidth",
    value: function() {
      if (this.GridElement) {
        var n = this.GridElement, r = n.clientWidth || 0, g = n.offsetWidth || 0;
        return g - r;
      }
      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, r = this.props, g = r.children, o = r.className, l = r.disableHeader, a = r.gridClassName, I = r.gridStyle, c = r.headerHeight, d = r.headerRowRenderer, C = r.height, A = r.id, b = r.noRowsRenderer, m = r.rowClassName, p = r.rowStyle, B = r.scrollToIndex, f = r.style, Z = r.width, y = this.state.scrollbarWidth, W = l ? C : C - c, V = typeof m == "function" ? m({
        index: -1
      }) : m, w = typeof p == "function" ? p({
        index: -1
      }) : p;
      return this._cachedColumnStyles = [], X.Children.toArray(g).forEach(function(v, H) {
        var x = n._getFlexStyleForColumn(v, v.props.style || MN.defaultProps.style);
        n._cachedColumnStyles[H] = oI({
          overflow: "hidden"
        }, x);
      }), /* @__PURE__ */ X.createElement("div", {
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-colcount": X.Children.toArray(g).length,
        "aria-rowcount": this.props.rowCount,
        className: Ag("ReactVirtualized__Table", o),
        id: A,
        role: "grid",
        style: f
      }, !l && d({
        className: Ag("ReactVirtualized__Table__headerRow", V),
        columns: this._getHeaderColumns(),
        style: oI({
          height: c,
          overflow: "hidden",
          paddingRight: y,
          width: Z
        }, w)
      }), /* @__PURE__ */ X.createElement(xd, et({}, this.props, {
        elementRef: this._setGridElementRef,
        "aria-readonly": null,
        autoContainerWidth: !0,
        className: Ag("ReactVirtualized__Table__Grid", a),
        cellRenderer: this._createRow,
        columnWidth: Z,
        columnCount: 1,
        height: W,
        id: void 0,
        noContentRenderer: b,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: y,
        scrollToRow: B,
        style: oI(oI({}, I), {}, {
          overflowX: "hidden"
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function(n) {
      var r = n.column, g = n.columnIndex, o = n.isScrolling, l = n.parent, a = n.rowData, I = n.rowIndex, c = this.props.onColumnClick, d = r.props, C = d.cellDataGetter, A = d.cellRenderer, b = d.className, m = d.columnData, p = d.dataKey, B = d.id, f = C({
        columnData: m,
        dataKey: p,
        rowData: a
      }), Z = A({
        cellData: f,
        columnData: m,
        columnIndex: g,
        dataKey: p,
        isScrolling: o,
        parent: l,
        rowData: a,
        rowIndex: I
      }), y = function(v) {
        c && c({
          columnData: m,
          dataKey: p,
          event: v
        });
      }, W = this._cachedColumnStyles[g], V = typeof Z == "string" ? Z : null;
      return /* @__PURE__ */ X.createElement("div", {
        "aria-colindex": g + 1,
        "aria-describedby": B,
        className: Ag("ReactVirtualized__Table__rowColumn", b),
        key: "Row" + I + "-Col" + g,
        onClick: y,
        role: "gridcell",
        style: W,
        title: V
      }, Z);
    }
  }, {
    key: "_createHeader",
    value: function(n) {
      var r = n.column, g = n.index, o = this.props, l = o.headerClassName, a = o.headerStyle, I = o.onHeaderClick, c = o.sort, d = o.sortBy, C = o.sortDirection, A = r.props, b = A.columnData, m = A.dataKey, p = A.defaultSortDirection, B = A.disableSort, f = A.headerRenderer, Z = A.id, y = A.label, W = !B && c, V = Ag("ReactVirtualized__Table__headerColumn", l, r.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: W
      }), w = this._getFlexStyleForColumn(r, oI(oI({}, a), r.props.headerStyle)), v = f({
        columnData: b,
        dataKey: m,
        disableSort: B,
        label: y,
        sortBy: d,
        sortDirection: C
      }), H, x, J, K, M;
      if (W || I) {
        var L = d !== m, N = L ? p : C === Dd.DESC ? Dd.ASC : Dd.DESC, U = function(ne) {
          W && c({
            defaultSortDirection: p,
            event: ne,
            sortBy: m,
            sortDirection: N
          }), I && I({
            columnData: b,
            dataKey: m,
            event: ne
          });
        }, O = function(ne) {
          (ne.key === "Enter" || ne.key === " ") && U(ne);
        };
        M = r.props["aria-label"] || y || m, K = "none", J = 0, H = U, x = O;
      }
      return d === m && (K = C === Dd.ASC ? "ascending" : "descending"), /* @__PURE__ */ X.createElement("div", {
        "aria-label": M,
        "aria-sort": K,
        className: V,
        id: Z,
        key: "Header-Col" + g,
        onClick: H,
        onKeyDown: x,
        role: "columnheader",
        style: w,
        tabIndex: J
      }, v);
    }
  }, {
    key: "_createRow",
    value: function(n) {
      var r = this, g = n.rowIndex, o = n.isScrolling, l = n.key, a = n.parent, I = n.style, c = this.props, d = c.children, C = c.onRowClick, A = c.onRowDoubleClick, b = c.onRowRightClick, m = c.onRowMouseOver, p = c.onRowMouseOut, B = c.rowClassName, f = c.rowGetter, Z = c.rowRenderer, y = c.rowStyle, W = this.state.scrollbarWidth, V = typeof B == "function" ? B({
        index: g
      }) : B, w = typeof y == "function" ? y({
        index: g
      }) : y, v = f({
        index: g
      }), H = X.Children.toArray(d).map(function(K, M) {
        return r._createColumn({
          column: K,
          columnIndex: M,
          isScrolling: o,
          parent: a,
          rowData: v,
          rowIndex: g,
          scrollbarWidth: W
        });
      }), x = Ag("ReactVirtualized__Table__row", V), J = oI(oI({}, I), {}, {
        height: this._getRowHeight(g),
        overflow: "hidden",
        paddingRight: W
      }, w);
      return Z({
        className: x,
        columns: H,
        index: g,
        isScrolling: o,
        key: l,
        onRowClick: C,
        onRowDoubleClick: A,
        onRowRightClick: b,
        onRowMouseOver: m,
        onRowMouseOut: p,
        rowData: v,
        style: J
      });
    }
    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */
  }, {
    key: "_getFlexStyleForColumn",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, g = "".concat(n.props.flexGrow, " ").concat(n.props.flexShrink, " ").concat(n.props.width, "px"), o = oI(oI({}, r), {}, {
        flex: g,
        msFlex: g,
        WebkitFlex: g
      });
      return n.props.maxWidth && (o.maxWidth = n.props.maxWidth), n.props.minWidth && (o.minWidth = n.props.minWidth), o;
    }
  }, {
    key: "_getHeaderColumns",
    value: function() {
      var n = this, r = this.props, g = r.children, o = r.disableHeader, l = o ? [] : X.Children.toArray(g);
      return l.map(function(a, I) {
        return n._createHeader({
          column: a,
          index: I
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function(n) {
      var r = this.props.rowHeight;
      return typeof r == "function" ? r({
        index: n
      }) : r;
    }
  }, {
    key: "_onScroll",
    value: function(n) {
      var r = n.clientHeight, g = n.scrollHeight, o = n.scrollTop, l = this.props.onScroll;
      l({
        clientHeight: r,
        scrollHeight: g,
        scrollTop: o
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function(n) {
      var r = n.rowOverscanStartIndex, g = n.rowOverscanStopIndex, o = n.rowStartIndex, l = n.rowStopIndex, a = this.props.onRowsRendered;
      a({
        overscanStartIndex: r,
        overscanStopIndex: g,
        startIndex: o,
        stopIndex: l
      });
    }
  }, {
    key: "_setRef",
    value: function(n) {
      this.Grid = n;
    }
  }, {
    key: "_setGridElementRef",
    value: function(n) {
      this.GridElement = n;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function() {
      var n = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: n
      });
    }
  }]);
}(X.PureComponent);
We(Wge, "defaultProps", {
  disableHeader: !1,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function() {
    return null;
  },
  onRowsRendered: function() {
    return null;
  },
  onScroll: function() {
    return null;
  },
  overscanIndicesGetter: lge,
  overscanRowCount: 10,
  rowRenderer: w4t,
  headerRowRenderer: S4t,
  rowStyle: {},
  scrollToAlignment: "auto",
  scrollToIndex: -1,
  style: {}
});
Wge.propTypes = {};
var zd = [], hf = null, qC = null;
function Sge() {
  qC && (qC = null, document.body && hf != null && (document.body.style.pointerEvents = hf), hf = null);
}
function X4t() {
  Sge(), zd.forEach(function(e) {
    return e.__resetIsScrolling();
  });
}
function H4t() {
  qC && pm(qC);
  var e = 0;
  zd.forEach(function(t) {
    e = Math.max(e, t.props.scrollingResetTimeInterval);
  }), qC = EN(X4t, e);
}
function Vge(e) {
  e.currentTarget === window && hf == null && document.body && (hf = document.body.style.pointerEvents, document.body.style.pointerEvents = "none"), H4t(), zd.forEach(function(t) {
    t.props.scrollElement === e.currentTarget && t.__handleWindowScrollEvent();
  });
}
function TO(e, t) {
  zd.some(function(i) {
    return i.props.scrollElement === t;
  }) || t.addEventListener("scroll", Vge), zd.push(e);
}
function MO(e, t) {
  zd = zd.filter(function(i) {
    return i !== e;
  }), zd.length || (t.removeEventListener("scroll", Vge), qC && (pm(qC), Sge()));
}
var PN = function(t) {
  return t === window;
}, NB = function(t) {
  return t.getBoundingClientRect();
};
function PO(e, t) {
  if (e)
    if (PN(e)) {
      var i = window, n = i.innerHeight, r = i.innerWidth;
      return {
        height: typeof n == "number" ? n : 0,
        width: typeof r == "number" ? r : 0
      };
    } else
      return NB(e);
  else
    return {
      height: t.serverHeight,
      width: t.serverWidth
    };
}
function k4t(e, t) {
  if (PN(t) && document.documentElement) {
    var i = document.documentElement, n = NB(e), r = NB(i);
    return {
      top: n.top - r.top,
      left: n.left - r.left
    };
  } else {
    var g = wge(t), o = NB(e), l = NB(t);
    return {
      top: o.top + g.top - l.top,
      left: o.left + g.left - l.left
    };
  }
}
function wge(e) {
  return PN(e) && document.documentElement ? {
    top: "scrollY" in window ? window.scrollY : document.documentElement.scrollTop,
    left: "scrollX" in window ? window.scrollX : document.documentElement.scrollLeft
  } : {
    top: e.scrollTop,
    left: e.scrollLeft
  };
}
function UO(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function zO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? UO(Object(i), !0).forEach(function(n) {
      We(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : UO(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Y4t(e, t, i) {
  return t = an(t), Jo(e, vge() ? Reflect.construct(t, i || [], an(e).constructor) : t.apply(e, i));
}
function vge() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (vge = function() {
    return !!e;
  })();
}
var F4t = 150, Rge = function() {
  return typeof window < "u" ? window : void 0;
}, x4t = /* @__PURE__ */ function(e) {
  function t() {
    var i;
    fr(this, t);
    for (var n = arguments.length, r = new Array(n), g = 0; g < n; g++)
      r[g] = arguments[g];
    return i = Y4t(this, t, [].concat(r)), We(i, "_window", Rge()), We(i, "_isMounted", !1), We(i, "_positionFromTop", 0), We(i, "_positionFromLeft", 0), We(i, "_detectElementResize", void 0), We(i, "_child", void 0), We(i, "_windowScrollerRef", /* @__PURE__ */ X.createRef()), We(i, "state", zO(zO({}, PO(i.props.scrollElement, i.props)), {}, {
      isScrolling: !1,
      scrollLeft: 0,
      scrollTop: 0
    })), We(i, "_registerChild", function(o) {
      o && !(o instanceof Element) && console.warn("WindowScroller registerChild expects to be passed Element or null"), i._child = o, i.updatePosition();
    }), We(i, "_onChildScroll", function(o) {
      var l = o.scrollTop;
      if (i.state.scrollTop !== l) {
        var a = i.props.scrollElement;
        a && (typeof a.scrollTo == "function" ? a.scrollTo(0, l + i._positionFromTop) : a.scrollTop = l + i._positionFromTop);
      }
    }), We(i, "_registerResizeListener", function(o) {
      o === window ? window.addEventListener("resize", i._onResize, !1) : i._detectElementResize.addResizeListener(o, i._onResize);
    }), We(i, "_unregisterResizeListener", function(o) {
      o === window ? window.removeEventListener("resize", i._onResize, !1) : o && i._detectElementResize.removeResizeListener(o, i._onResize);
    }), We(i, "_onResize", function() {
      i.updatePosition();
    }), We(i, "__handleWindowScrollEvent", function() {
      if (i._isMounted) {
        var o = i.props.onScroll, l = i.props.scrollElement;
        if (l) {
          var a = wge(l), I = Math.max(0, a.left - i._positionFromLeft), c = Math.max(0, a.top - i._positionFromTop);
          i.setState({
            isScrolling: !0,
            scrollLeft: I,
            scrollTop: c
          }), o({
            scrollLeft: I,
            scrollTop: c
          });
        }
      }
    }), We(i, "__resetIsScrolling", function() {
      i.setState({
        isScrolling: !1
      });
    }), i;
  }
  return Eo(t, e), Zr(t, [{
    key: "updatePosition",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.scrollElement, r = this.props.onResize, g = this.state, o = g.height, l = g.width, a = this._child || this._windowScrollerRef.current;
      if (a instanceof Element && n) {
        var I = k4t(a, n);
        this._positionFromTop = I.top, this._positionFromLeft = I.left;
      }
      var c = PO(n, this.props);
      (o !== c.height || l !== c.width) && (this.setState({
        height: c.height,
        width: c.width
      }), r({
        height: c.height,
        width: c.width
      })), this.props.updateScrollTopOnUpdatePosition === !0 && (this.__handleWindowScrollEvent(), this.__resetIsScrolling());
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.props.scrollElement;
      this._detectElementResize = _re(), this.updatePosition(n), n && (TO(this, n), this._registerResizeListener(n)), this._isMounted = !0;
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, r) {
      var g = this.props.scrollElement, o = n.scrollElement;
      o !== g && o != null && g != null && (this.updatePosition(g), MO(this, o), TO(this, g), this._unregisterResizeListener(o), this._registerResizeListener(g));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var n = this.props.scrollElement;
      n && (MO(this, n), this._unregisterResizeListener(n)), this._isMounted = !1;
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props.children, r = this.state, g = r.isScrolling, o = r.scrollTop, l = r.scrollLeft, a = r.height, I = r.width;
      return /* @__PURE__ */ X.createElement("div", {
        ref: this._windowScrollerRef
      }, n({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: a,
        isScrolling: g,
        scrollLeft: l,
        scrollTop: o,
        width: I
      }));
    }
  }]);
}(X.PureComponent);
We(x4t, "defaultProps", {
  onResize: function() {
  },
  onScroll: function() {
  },
  scrollingResetTimeInterval: F4t,
  scrollElement: Rge(),
  serverHeight: 0,
  serverWidth: 0
});
c$([Pie]);
const qS = new oOt({
  defaultHeight: 86,
  fixedWidth: !0
}), Xge = 86, D4t = 16, OO = Xge - D4t, J4t = De.forwardRef(({
  style: e,
  measure: t,
  data: i,
  color: n,
  variable: r
}, g) => {
  const {
    t: o
  } = Gi(), l = ie(Er);
  if (!n)
    return null;
  const a = Hge(l, n), I = a || o(a || "") || n.code, c = n.description || o(n.description || ""), d = !!n.info, C = {
    ...r,
    label: I,
    info: n.info
  };
  return /* @__PURE__ */ S(ht, { ref: g, style: e, onLoad: t, component: "div", sx: {
    display: "flex"
  }, className: "k3-ral-item-container", children: /* @__PURE__ */ Ie(FA, { invalid: n == null ? void 0 : n.hasTouchedConflicts, children: [
    /* @__PURE__ */ Ie(Spe, { disabled: i.disabled || !n.hex, onClick: () => i.onClick(n), sx: {
      px: 1,
      display: "grid",
      gridTemplateColumns: "max-content 1fr",
      gridGap: (A) => A.spacing(1),
      alignItems: "center",
      boxSizing: "border-box"
    }, className: Re("k3-ral-item", i.selectedHex === n.hex ? "MuiChecked selected" : "", n.hasTouchedConflicts && "invalid-option"), children: [
      /* @__PURE__ */ S(zie, { label: I, disabled: i.disabled, isActive: i.selectedHex === n.hex, hexColor: n.hex, width: OO, height: OO, borderRadius: i.borderRadius, className: "k3-ral-item-color" }),
      /* @__PURE__ */ S(ht, { component: "div", sx: {
        display: "flex",
        flexDirection: "column"
      }, className: "k3-ral-item-value", children: n.hex ? /* @__PURE__ */ Ie(li, { children: [
        /* @__PURE__ */ S(Ct, { color: "text.primary", className: "k3-ral-item-value", children: n != null && n.dontAddPrefix ? n.code : `RAL ${n.code}` }),
        !!I && /* @__PURE__ */ S(Ct, { color: "text.primary", className: "k3-ral-item-label", children: I }),
        c ? /* @__PURE__ */ S(Ct, { variant: "subtitle2", color: "text.secondary", className: "k3-ral-item-description", children: c }) : /* @__PURE__ */ S(Ct, { variant: "subtitle2", color: "text.secondary", className: "k3-ral-item-description", children: n.scope })
      ] }) : /* @__PURE__ */ S(Ct, { color: "error", children: "Invalid RAL value" }) })
    ] }),
    d ? /* @__PURE__ */ S(Die, { variable: C, sx: {
      position: "absolute",
      right: "8px",
      top: "8px"
    } }) : null
  ] }) });
});
function Hge(e, t) {
  const i = !!Ozt.find((r) => r === e);
  return t.mainLabel ? t.mainLabel : i ? t[e] : t.en;
}
const E4t = ({
  disabled: e = !1,
  label: t,
  onChange: i,
  value: n,
  ralColors: r,
  visibleColorCount: g = 4,
  borderRadius: o = 1,
  variable: l
}) => {
  const {
    t: a
  } = Gi(), [I, c] = wt(""), [d, C] = wt(), A = De.createRef();
  lt(() => {
    var V;
    if (!d) {
      const w = Le.findIndex((v) => v.hex === n, r);
      w >= 0 && (C(r[w].hex), (V = A.current) == null || V.scrollToRow(w));
    }
  }, [A, d, r, n]);
  const b = ie(Er), m = Oe(() => {
    if (!I)
      return r;
    const V = new RegExp(Le.replace(/\s+/g, ".*", I), "i"), w = new RegExp(Le.replace(/\s+/g, "\\s*", I), "i");
    return Le.filter((v) => {
      const H = Hge(b, v);
      return V.test(H || a(H || "")) || w.test(`RAL${Le.replace(/\s+/g, "", v.code)}`);
    }, r);
  }, [I, r, b, a]), p = Gt((V) => {
    C(V.hex), i(V.hex, V.mainLabel || a(V.de || "") || V.code);
  }, [i, a]), B = Oe(() => ({
    onClick: p,
    selectedHex: d,
    disabled: e,
    borderRadius: o
  }), [p, d, e, o]), f = Gt(({
    index: V,
    key: w,
    parent: v,
    style: H
  }) => {
    const x = m[V];
    return /* @__PURE__ */ S(tge, { cache: qS, columnIndex: 0, parent: v, rowIndex: V, children: ({
      measure: J,
      registerChild: K
    }) => (
      // 'style' attribute required to position cell (within parent List)
      /* @__PURE__ */ S(J4t, { ref: K, measure: J, style: H, color: x, data: B, variable: l })
    ) }, w);
  }, [m, B, l]), Z = De.createRef(), [y, W] = wt(400);
  return lt(() => {
    const V = Z.current;
    if (V) {
      const w = V.offsetWidth;
      w !== y && (W(w), qS.clearAll());
    }
  }, [Z, y]), /* @__PURE__ */ Ie(ht, { ref: Z, component: "div", className: "k3-ral-container", sx: {
    display: "grid",
    gridTemplateRows: "max-content max-content max-content",
    gridGap: (V) => V.spacing(1)
  }, children: [
    !!t && /* @__PURE__ */ S(Ct, { color: "textSecondary", className: "k3-ral-label", children: t }),
    /* @__PURE__ */ S(al, { "data-cy": "ralText", disabled: e, "aria-label": a("RAL-Farben Suchfeld"), className: "k3-ral-search-bar", onChange: c, fullWidth: !0, debounced: !0, TextFieldProps: {
      InputProps: {
        endAdornment: /* @__PURE__ */ S(Uh, { position: "end", children: /* @__PURE__ */ S(e5, {}) })
      }
    } }),
    /* @__PURE__ */ S(dge, { ref: A, height: Math.min(g, r.length || 1) * Xge, rowHeight: qS.rowHeight, width: y, rowCount: m.length, className: "k3-ral-list", deferredMeasurementCache: qS, rowRenderer: f, scrollToAlignment: "center" })
  ] });
}, N4t = Le.indexBy((e) => e.hex, $zt), L4t = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: r = !1,
  touchedInvalidValueIds: g
}) => {
  const o = Vi(e), l = ie(Er), a = (A, b) => (!(A != null && A.label) || A.label.includes("[")) && (b[l] || Ug(b.de || "")) || A.label, I = (A, b) => A != null && A.description ? A.description : Ug(b.description || "") || "", c = Oe(() => Le.flow(
    Le.map((A) => {
      const b = N4t[A.value];
      return {
        ...b,
        valueId: A.id,
        hasTouchedConflicts: (g == null ? void 0 : g.includes(A == null ? void 0 : A.id)) || !1,
        mainLabel: a(A, b),
        description: I(A, b),
        info: A.info
      };
    }),
    // TODO: Neu erstellte Values haben null als value.value. Daher müssen
    // die undefined Einträge entfernt werden.
    Le.compact
  )(i), [i, l, g]), d = Gt((A) => {
    const b = i.find((m) => m.value === A);
    n(b.id);
  }, [i, n]), C = Le.isNumber(o == null ? void 0 : o.borderRadius) ? o == null ? void 0 : o.borderRadius : 1;
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ S(E4t, { disabled: r, ralColors: c, value: (t == null ? void 0 : t.value) || "", onChange: d, visibleColorCount: o == null ? void 0 : o.numberOfColorsShown, borderRadius: C, variable: e }) });
}, K4t = Le.flow(ta, Fo("ralColorSelect"))(L4t);
function T4t({
  handleClick: e,
  radioValue: t,
  variable: i,
  ...n
}) {
  return /* @__PURE__ */ S(FA, { invalid: n.invalid, sx: {
    display: "flex",
    flexFlow: "column wrap"
  }, "k3-radio-knop": !0, children: /* @__PURE__ */ S(rv, { "data-cy": "radioButton", disabled: n.disabled, value: (t == null ? void 0 : t.id) || "", className: Re("k3-radio-button", n.invalid && "invalid-option"), control: /* @__PURE__ */ S(K0e, { "data-cy": "radio", className: "k3-radio-button-control", onClick: e, sx: n.invalid ? P4t : void 0 }), disableTypography: !0, sx: {
    color: n.isActiveValue ? "" : "action.active"
  }, label: /* @__PURE__ */ S(pi, { alignItems: "center", justifyContent: "space-between", style: {
    width: "100%"
  }, children: /* @__PURE__ */ S(vI, { variable: i, variableValue: t, templateOptions: Vi(i) }, t.id) }), color: "inherit" }, t.id) });
}
const M4t = (e) => {
  const t = (i) => {
    parseInt(i.target.value) === e.currentValueId && e.onChange && e.onChange(parseInt(i.target.value));
  };
  return /* @__PURE__ */ S(ja, { "data-cy": "RadioButtons", sx: {
    width: 1
  }, disabled: e.disabled, component: "fieldset", children: /* @__PURE__ */ S(U0e, { value: e.currentValueId || null, onChange: (i, n) => {
    var r;
    (r = e.onChange) == null || r.call(e, parseInt(n));
  }, sx: {
    gap: 1,
    py: 1
  }, children: e.values.map((i) => {
    var n;
    return /* @__PURE__ */ S(T4t, { radioValue: i, isActiveValue: i.id === e.currentValueId, disabled: e.disabled, handleClick: t, variable: e.variable, invalid: ((n = e.invalidIds) == null ? void 0 : n.includes(i == null ? void 0 : i.id)) || !1 }, i.id);
  }) }) });
}, P4t = {
  opacity: ".2"
}, U4t = ({
  value: e,
  ...t
}) => /* @__PURE__ */ S(wg, { variable: t.variable, view: /* @__PURE__ */ S(M4t, { currentValueId: (e == null ? void 0 : e.id) || 0, ...gG(t) }) }), QO = Le.flow(ta, Fo("radio"))(U4t), z4t = ({
  value: e,
  values: t,
  ...i
}) => {
  const n = Oe(() => t.find((o) => o.key === Ff), [t]), r = (o) => {
    o ? i.onChange(o) : n && i.onChange(n.id);
  }, g = t.filter((o) => o.key !== Ff);
  return /* @__PURE__ */ S(wg, { variable: i.variable, view: /* @__PURE__ */ S(Are, { currentValueId: e == null ? void 0 : e.id, ...gG(i), values: g, onChange: r }) });
}, jO = Le.flow(ta, Fo("radioCard"))(z4t);
function O4t(e) {
  const t = {
    renderValue: (r) => {
      const g = e.values.find((o) => o.id == r);
      return g ? /* @__PURE__ */ S(cf, { dense: !0, "data-cy": "select_" + g.label, value: r, variable: e.variable, variableValue: g, templateOptions: {
        ...Vi(e.variable),
        // Don't show Info Icon for current value since MUI overrides click anyway
        showInfo: !1
      } }) : null;
    }
  }, i = de.merge({
    fullWidth: !0,
    variant: "outlined"
  }, e.FormControllProps ?? {}), n = (r) => {
    e.onChange && e.onChange(r.target.value);
  };
  return /* @__PURE__ */ S(ja, { ...i, children: /* @__PURE__ */ S(ZZ, { value: e.valueId || "", onChange: n, "data-cy": e["data-cy"], ...t, disabled: e.disabled, sx: {
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "action.active"
    }
  }, className: "k3-select", multiple: e.multiple, MenuProps: {
    MenuListProps: {
      sx: {
        maxHeight: "35vh"
      }
    }
  }, inputProps: {
    "aria-label": e.variable.label
  }, children: e.values.map((r) => {
    var g;
    return /* @__PURE__ */ S(cf, { "data-cy": "selection_" + r.label, value: r.id, variable: e.variable, variableValue: r, templateOptions: Vi(e.variable), itemInvalid: ((g = e.invalidIds) == null ? void 0 : g.includes(r == null ? void 0 : r.id)) || !1 }, r.id);
  }) }) });
}
const Q4t = ({
  value: e,
  ...t
}) => /* @__PURE__ */ S(wg, { variable: t.variable, view: /* @__PURE__ */ S(O4t, { "data-cy": "selectOc", valueId: e == null ? void 0 : e.id, ...gG(t) }) }), qO = Le.flow(ta, Fo("select"))(Q4t);
function j4t(e) {
  const t = e.checked, i = (n) => {
    e.onChange && e.onChange(n.target.checked);
  };
  return /* @__PURE__ */ S(ja, { fullWidth: !0, className: Re("k3-app-switch", t ? "checked" : "unchecked"), children: /* @__PURE__ */ S(FA, { invalid: e.hasInvalidOption, children: /* @__PURE__ */ S(rv, { sx: {
    m: 0
  }, label: /* @__PURE__ */ S(vI, { variable: e.variable, variableValue: e.value, templateOptions: Vi(e.variable) }), control: /* @__PURE__ */ S(Fj, { "data-cy": e["data-cy"] || "switch", checked: t || !1, onChange: i, disabled: e.disabled }) }) }) });
}
const q4t = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: r,
  touchedInvalidValueIds: g
}) => {
  const {
    checked: o,
    onBooleanChange: l
  } = _E(n, t, i), a = i == null ? void 0 : i.find((c) => c.value == !0), I = i == null ? void 0 : i.find((c) => c.id != (t == null ? void 0 : t.id));
  return /* @__PURE__ */ S(wg, { variable: e, className: Re("k3-app-switch-wrapper", o ? "checked" : "unchecked"), view: /* @__PURE__ */ S(j4t, { "data-cy": `switch-${e == null ? void 0 : e.id}`, value: a, checked: o, onChange: l, variable: e, disabled: r, hasInvalidOption: (I == null ? void 0 : I.id) && (g == null ? void 0 : g.includes(I == null ? void 0 : I.id)) || !1 }) });
}, _4t = Le.flow(ta, Fo("switch"))(q4t);
function $4t({
  variable: e,
  value: t,
  checked: i,
  onChange: n,
  disabled: r
}) {
  const {
    palette: g
  } = ql(), {
    showDescription: o,
    showThumbnail: l,
    showUrl: a,
    showValue: I,
    showSelection: c
  } = Vi(e) || {}, d = o || l || a || I || c;
  return /* @__PURE__ */ Ie(lv, { "data-cy": "toggle", disabled: r, fullWidth: !0, value: t == null ? void 0 : t.id, selected: i, className: Re("k3-app-switch-card", i ? "checked" : "unchecked"), onChange: () => n(!i), sx: {
    "&.MuiToggleButton-root": {
      background: "unset"
    },
    "&.MuiToggleButton-root:hover": {
      background: "unset",
      borderColor: `${g.action.active} !important`
    },
    "&.MuiToggleButton-root:active": {
      background: "unset"
    },
    "&.MuiToggleButton-root.Mui-selected": {
      background: "unset",
      outline: "2px solid",
      outlineOffset: "-2px",
      outlineColor: `${g.primary.main} !important`
    },
    border: `1px solid ${g.action.disabled} !important`,
    borderRadius: "8px  !important",
    justifyContent: "flex-start",
    padding: 2,
    textAlign: "left"
  }, children: [
    /* @__PURE__ */ S(vI, { value: t == null ? void 0 : t.id, variable: e, variableValue: t, templateOptions: Vi(e) }, t == null ? void 0 : t.id),
    /* @__PURE__ */ S(fZ, { sx: {
      marginTop: d ? -1.25 : 0,
      marginRight: -1.25,
      alignSelf: d ? "start" : "center",
      "&.MuiCheckbox-root": {
        color: i ? "" : "action.disabled"
      }
    }, size: "medium", checked: i, className: "k3-value-checkbox", "data-cy": "k3ValueCheckbox", inputProps: {
      "data-cy": "k3ValueCheckboxInput",
      "aria-label": "Checkbox" + (e == null ? void 0 : e.label) + (t == null ? void 0 : t.label)
    } })
  ] }, t == null ? void 0 : t.id);
}
const eQt = ({
  variable: e,
  value: t,
  values: i,
  onChange: n,
  disabled: r
}) => {
  const {
    checked: g,
    onBooleanChange: o
  } = _E(n, t, i), l = i == null ? void 0 : i.find((a) => a.value == !0);
  return /* @__PURE__ */ S(wg, { variable: e, className: Re("k3-app-switch-card-container", g ? "checked" : "unchecked"), "data-cy": `switch-card-${e == null ? void 0 : e.id}`, view: /* @__PURE__ */ S($4t, { value: l, checked: g, onChange: o, variable: e, disabled: r }) });
}, tQt = Le.flow(ta, Fo("switchCard"))(eQt), iQt = function(e) {
  const {
    variable: t
  } = e, {
    text: i,
    onChange: n
  } = j1(e);
  return /* @__PURE__ */ S(wg, { variable: t, className: "k3-app-text", view: /* @__PURE__ */ S(al, { "aria-label": t == null ? void 0 : t.label, value: i ?? "", multiline: !0, debounced: !0, onChange: n, "data-cy": `text-${t == null ? void 0 : t.label}` }) });
}, nQt = Mie(iQt), rQt = (e) => {
  const {
    variable: t
  } = e, {
    text: i,
    onChange: n
  } = j1(e);
  return /* @__PURE__ */ S(wg, { variable: t, view: /* @__PURE__ */ S(al, { "data-cy": `textArea-${t == null ? void 0 : t.label}`, fullWidth: !0, multiline: !0, minRows: 2, maxRows: 8, value: i, onChange: n }) });
}, gQt = Fo("textArea")(rQt), kge = {
  [Kn.Checkbox]: vNt,
  //TODO: not used
  [Kn.Hidden]: Yzt,
  //TODO: not used
  [Kn.Information]: Pzt,
  //TODO: not used
  [Kn.Radio]: QO,
  [Kn.RadioCard]: jO,
  [Kn.Select]: qO,
  [Kn.SelectThumbs]: fz,
  [Kn.Text]: nQt,
  [Kn.Textarea]: gQt,
  //TODO: not used
  [Kn.Number]: zzt,
  [Kn.Switch]: _4t,
  [Kn.SwitchCard]: tQt,
  [Kn.ColorSelect]: fz,
  [Kn.ColorDropdown]: qO,
  [Kn.ColorRadio]: QO,
  [Kn.ColorRadioCard]: jO,
  [Kn.RALColorSelect]: K4t,
  [Kn.ImageUpload]: Tzt,
  [Kn.ComponentList]: xPt,
  [Kn.ComponentListPopup]: EPt,
  [Kn.ComponentValueCards]: Hzt
}, _O = {
  m: 2,
  mb: 0
}, Yge = ({
  variable: e,
  onChange: t,
  withPaperWrapper: i,
  "data-cy": n,
  className: r,
  dense: g,
  contextInstance: o
}) => {
  var b, m;
  const l = ie($r), a = Tie(e, o), I = Ei(), c = Gt(() => {
    I(Oee({
      type: "variable",
      id: e.id
    }));
  }, [I, e == null ? void 0 : e.id]), d = ot(null);
  lt(() => {
    var B, f;
    let p;
    if ((f = (B = e == null ? void 0 : e.settings) == null ? void 0 : B.templateOptions) != null && f.focusOnScroll) {
      const Z = d.current;
      Z && (p = new IntersectionObserver((y) => {
        y[0].isIntersecting && c();
      }, {
        threshold: [0.5]
      }), p.observe(Z));
    }
    return () => {
      p && p.disconnect();
    };
  }, [c, d, (m = (b = e == null ? void 0 : e.settings) == null ? void 0 : b.templateOptions) == null ? void 0 : m.focusOnScroll]);
  const C = fte(e, o), A = Oe(() => Mie(kge[bA(e)]), [e]);
  return !l && a ? null : i ? /* @__PURE__ */ S(ul, { ref: d, onFocus: c, id: "variableContainer_" + e.id, "data-cy": "variableContainer_" + n, className: Re("k3-variable-container", "k3-variable-container-" + n, e.key ?? void 0, !!g && "dense", l ? "edit-view" : "display-view", r), elevation: 0, sx: g ? null : _O, children: /* @__PURE__ */ S(lD, { children: /* @__PURE__ */ S(A, { onChange: t(e), ...C }, e.id) }) }, `${e.id}_${o.id}`) : /* @__PURE__ */ S(ht, { "data-cy": "variableContainer_" + n, className: Re("k3-variable-container", "k3-variable-container-" + n, e.key ?? void 0, !!g && "dense", r), component: "div", sx: g ? null : _O, children: /* @__PURE__ */ S(lD, { children: /* @__PURE__ */ S(A, { onChange: t(e), ...C }, e.id) }) }, `${e.id}_${o.id}`);
}, zei = (e) => {
  const t = ie(vZ(e.variableKey)), i = rr(), n = ie((o) => T9(o, i)), r = ie(b0t((t == null ? void 0 : t.id) ?? 0)), g = mte(r);
  return t ? !e.sticky && t.groupId !== (n == null ? void 0 : n.id) ? null : /* @__PURE__ */ S(Yge, { variable: t, contextInstance: r, onChange: g, withPaperWrapper: e.withPaperWrapper, className: Re("k3-stand-alone-variable", !!e.sticky && "sticky"), "data-cy": `standaloneVariable-${t.label ?? (t == null ? void 0 : t.key)}`, dense: e.dense }) : (console.error(`No variable with key ${e.variableKey} found`, e), null);
}, oQt = Ua(null), lQt = ({
  id: e,
  child: t,
  isDisabled: i
}) => {
  var l;
  const n = Jd(t), r = ((l = n.key) == null ? void 0 : l.toString()) || "", g = n.props["data-cy"] || "DnDListChildren", o = ie($r);
  return /* @__PURE__ */ S(wN, { draggableId: r, index: e, isDragDisabled: i, children: (a) => /* @__PURE__ */ S(pi, { "data-cy": `draggable-${g}`, sx: {
    overflow: "hidden"
  }, className: Re("k3-draggable-container", o ? "edit-mode" : "display-mode"), ref: a.innerRef, ...a.draggableProps, children: /* @__PURE__ */ S(oQt.Provider, { value: /* @__PURE__ */ S(_ie, { provided: a, disabled: i }), children: n }) }, r) });
};
function aQt({
  className: e,
  children: t,
  isDragDisabled: i = !1,
  onDragEnd: n,
  columns: r,
  rows: g,
  row: o,
  sx: l,
  "data-cy": a
}) {
  const I = (d) => {
    if (!d.destination)
      return;
    const C = d.source.index, A = d.destination.index;
    C !== A && n && n(d);
  }, c = !n || i;
  return /* @__PURE__ */ S(SN, { onDragEnd: I, children: /* @__PURE__ */ S(M1, { droppableId: "droppable", children: (d, C) => /* @__PURE__ */ Ie(pi, { "data-cy": a, className: e, sx: {
    display: "grid",
    gridAutoFlow: o ? "column" : "row",
    ...r ? {
      gridTemplateRows: `repeat(${g ?? 1}, 1fr)`
    } : {},
    ...r ? {
      gridTemplateColumns: `repeat(${r ?? 1}, 1fr)`
    } : {},
    pb: 3,
    ...l
  }, ref: d.innerRef, ...d.droppableProps, children: [
    p4.map(t, (A, b) => /* @__PURE__ */ S(lQt, { id: b, isDisabled: c, child: A }, b)),
    d.placeholder
  ] }) }) });
}
const sQt = (e) => (t) => {
  const i = Vn(Fs), n = Oe(() => i != null && i.extendGroupPanel ? i == null ? void 0 : i.extendGroupPanel(e) : e, [i]);
  return /* @__PURE__ */ S(n, { ...t });
}, IQt = ({
  onDragEnd: e,
  group: t,
  columns: i,
  rows: n,
  row: r,
  dense: g = !1
}) => {
  const o = ie($r), l = rr(), a = mte(l), I = ie((c) => jq(c, t == null ? void 0 : t.id));
  return /* @__PURE__ */ Ie(ht, { component: "div", children: [
    /* @__PURE__ */ S(aQt, { columns: i, rows: n, row: r, className: Re("variablesList", "k3-group-panel", o ? "edit-mode" : "display-mode"), onDragEnd: e, "data-cy": "groupPanel-" + (t == null ? void 0 : t.label), children: I == null ? void 0 : I.filter((c) => kge[bA(c)] && !Vi(c).hideFromGroup).sort(gA).map((c) => /* @__PURE__ */ S(Yge, { contextInstance: l, variable: c, onChange: a, dense: g, withPaperWrapper: !0, "data-cy": `variable-${c.label}` }, c.id)) }),
    /* @__PURE__ */ S(WNt, { group: t, variables: I })
  ] });
}, _1 = sQt(IQt), Fge = (e) => {
  var n;
  const t = Vn(Fs), i = (n = t.extendAdditionalGroups) == null ? void 0 : n.call(t, () => null);
  return i ? /* @__PURE__ */ S(i, { design: e.design, placement: e.placement, isRootHeader: e.isRootHeader }) : null;
}, ox = g9({
  parentItem: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: "0.5rem"
  },
  root: {
    minWidth: "auto",
    overflow: "hidden",
    padding: 1,
    whiteSpace: "nowrap",
    alignItems: "center"
  },
  breadcrumbs: {
    paddingLeft: 2,
    boxSizing: "border-box"
  }
}), cQt = ({
  useDivider: e,
  useDelete: t
}) => {
  const i = Vg(), n = rr(), r = ie(qr(n.variableId)), g = ie((m) => Ym(m, n)).reverse(), o = ie((m) => d0t(m, n.variableId)), l = ie(qr(n.variableId)), a = ie(pA(n.valueId)), I = Ei(), c = (m) => () => {
    I(wr(m.id));
  }, [d, C] = X.useState(), A = () => {
    I(QZ(n)), b();
  }, b = Gt(() => {
    C(void 0), I(wr(Ut.id, r == null ? void 0 : r.groupId));
  }, [I, r]);
  return !l || n.variableId === Ut.variableId ? null : /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(
      fj,
      {
        in: d !== void 0 ? !d : !!l,
        direction: "right",
        timeout: 300,
        onExited: b,
        children: /* @__PURE__ */ Ie(pi, { direction: "row", sx: ox.root, children: [
          /* @__PURE__ */ Ie(uj, { "aria-label": "Breadcrumb", separator: /* @__PURE__ */ S(ebt, { fontSize: "small" }), maxItems: 3, itemsAfterCollapse: 2, itemsBeforeCollapse: 1, children: [
            /* @__PURE__ */ Ie(pi, { direction: "row", children: [
              /* @__PURE__ */ S(Xd, { component: fn, "data-cy": "parent", color: "inherit", noWrap: !0, sx: ox.parentItem, underline: "none", variant: "subtitle1", startIcon: /* @__PURE__ */ S(eq, {}), onClick: () => C(!0), children: /* @__PURE__ */ S(Ct, { variant: "subtitle1", "data-cy": "buttonLabel", children: i(Mi.COMPONENT_BREADCRUMBS_BACK) }) }),
              /* @__PURE__ */ S(hu, { keys: [Mi.COMPONENT_BREADCRUMBS_BACK], display: "dialog" })
            ] }),
            sye((m) => {
              const p = o.find((B) => B.id == m.variableId);
              return /* @__PURE__ */ Ie(Xd, { "data-cy": `crumb-${m.variableId}`, color: "inherit", onClick: c(m), sx: ox.parentItem, underline: "hover", variant: "subtitle1", noWrap: !0, children: [
                (p == null ? void 0 : p.label) && /* @__PURE__ */ S(Ct, { variant: "subtitle1", "data-cy": "variableLabel", children: `${p == null ? void 0 : p.label} ` }),
                /* @__PURE__ */ S(Ct, { variant: "subtitle1", "data-cy": "selectionSort", children: `(${m.sort}): ` }),
                /* @__PURE__ */ S(Ct, { variant: "subtitle1", "data-cy": "selectionValue", children: `${m.debuggingValue}` })
              ] }, m.id);
            }, g.filter((m) => m.id !== Ut.id)),
            a && /* @__PURE__ */ Ie(ht, { component: "div", sx: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem"
            }, "data-cy": "currentCrumb", children: [
              (l == null ? void 0 : l.label) && /* @__PURE__ */ S(li, { children: /* @__PURE__ */ S(Ct, { noWrap: !0, variant: "subtitle1", "data-cy": "variableLabel", children: `${l == null ? void 0 : l.label}` }) }),
              /* @__PURE__ */ S(Ct, { noWrap: !0, variant: "subtitle1", "data-cy": "selectionSort", children: `(${n.sort}):` }),
              /* @__PURE__ */ S(Ct, { noWrap: !0, variant: "subtitle1", "data-cy": "selectionValue", children: `${n.debuggingValue}` })
            ] })
          ] }),
          t && /* @__PURE__ */ S(Ni, { onClick: A, "data-cy": "delete", children: /* @__PURE__ */ S(DZ, {}) })
        ] })
      }
    ),
    e && /* @__PURE__ */ S(SI, {})
  ] });
}, _S = g9({
  listItemContainer: {
    position: "relative"
  },
  dragHandleContainer: {
    position: "absolute",
    width: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    visibility: "visible",
    top: "-2px",
    left: "-4px",
    bottom: "0",
    fontSize: "1.25em"
  },
  visible: {
    visibility: "visible"
  },
  hidden: {
    visibility: "hidden"
  },
  dragHandle: {
    cursor: "grabbing"
  }
}), dQt = ({
  disabled: e = !1,
  provided: t
}) => /* @__PURE__ */ S(ht, { component: "div", sx: c8(_S.dragHandleContainer, e ? _S.hidden : _S.visible), children: /* @__PURE__ */ S(Ni, { "data-cy": "dragHandle", color: "editor", size: "small", ...t.dragHandleProps, children: /* @__PURE__ */ S(iN, { color: "inherit", sx: _S.dragHandle }) }) });
function uQt({
  children: e,
  onDragEnd: t,
  isDragDisabled: i = !1,
  ...n
}) {
  const r = Gt((l) => {
    l.destination && t && t(l);
  }, [t]), g = !t || i, o = Oe(() => De.Children.map(e, (l, a) => {
    const I = l.key;
    return De.cloneElement(l, {
      component: De.forwardRef(({
        children: c,
        ...d
      }, C) => /* @__PURE__ */ S(wN, { draggableId: I, index: a, isDragDisabled: g, children: (A) => /* @__PURE__ */ S(ht, { component: "div", ...A.draggableProps, ref: A.innerRef, children: /* @__PURE__ */ Ie(pi, { component: "div", direction: "row", spacing: 1, ...d, ref: C, children: [
        c,
        /* @__PURE__ */ S(dQt, { provided: A, disabled: g })
      ] }) }) }, I))
    });
  }), [e, g]);
  return /* @__PURE__ */ S(SN, { onDragEnd: r, children: /* @__PURE__ */ S(M1, { droppableId: "droppableADF", direction: "horizontal", children: (l, a) => /* @__PURE__ */ Ie(tZe, { id: "VFOTEST", ...n, ...l.droppableProps, ref: l.innerRef, value: a.isDraggingOver ? !1 : n.value, sx: {
    ".MuiTabs-flexContainer": {
      alignItems: "center"
    },
    ".MuiTabs-scroller": {
      display: "flex",
      alignItems: "center"
    }
  }, children: [
    o,
    l.placeholder
  ] }) }) });
}
var UN = {}, CQt = yg;
Object.defineProperty(UN, "__esModule", {
  value: !0
});
var zN = UN.default = void 0, AQt = CQt(oo()), bQt = ro;
zN = UN.default = (0, AQt.default)(/* @__PURE__ */ (0, bQt.jsx)("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), "VisibilityOff");
const $O = {
  label: {
    whiteSpace: "nowrap"
  },
  useContrastTextColor: {
    color: (e) => e.palette.primary.contrastText
  }
};
function ON({
  group: e,
  onClick: t,
  useContrastTextColor: i,
  useDefaultEditorUi: n,
  className: r
}) {
  const g = Vn(Fs), o = Oe(() => {
    var l;
    return (l = g.extendGroupLabel) == null ? void 0 : l.call(g, ({
      group: a,
      useContrastTextColor: I
    }) => /* @__PURE__ */ S(ht, { component: "span", sx: c8(
      $O.label,
      // @ts-ignore
      I && $O.useContrastTextColor
    ), onClick: t, "data-cy": "group_" + (a == null ? void 0 : a.id), className: Re("group-label k3-group-label", r), children: /* @__PURE__ */ S(Ct, { children: a == null ? void 0 : a.label }) }));
  }, [r, g, t]);
  return o ? /* @__PURE__ */ S(o, { group: e, useContrastTextColor: i, useDefaultEditorUi: n }) : null;
}
const QN = ({
  children: e
}) => {
  const {
    t
  } = Gi();
  return /* @__PURE__ */ S(Tn, { title: t("hiddenGroup"), children: e });
}, hQt = ({
  group: e,
  isHiddenGroup: t,
  iconPosition: i,
  isActive: n,
  useDefaultEditorUi: r,
  ...g
}) => {
  var A, b, m, p, B;
  const o = ie((f) => JJ(f, e.id)), l = ie((f) => L9(f, o)), a = ie(o_), I = FI(), c = ie(g_), d = ie(r_(e)), C = Oe(() => ({
    ...g.sx,
    ...c && !d ? {
      opacity: 0,
      pointerEvents: "none"
    } : {},
    minHeight: "unset"
  }), [d, c, g.sx]);
  return /* @__PURE__ */ S(tfe, { className: Re("k3-main-nav-item k3-tab-nav-item", d ? "groupHeaderTab" : "invisibleGroupHeaderTab", n && "k3-main-nav-selected selected active"), ...g, sx: C, value: e.id, icon: (A = e == null ? void 0 : e.settings) != null && A.icon ? /* @__PURE__ */ S("img", { alt: "", width: ((b = e == null ? void 0 : e.settings) == null ? void 0 : b.iconSize) ?? 24, height: ((m = e == null ? void 0 : e.settings) == null ? void 0 : m.iconSize) ?? 24, src: (p = e == null ? void 0 : e.settings) == null ? void 0 : p.icon, className: "k3-main-nav-item-icon" }) : null, iconPosition: i || (((B = e == null ? void 0 : e.settings) == null ? void 0 : B.iconPosition) ?? "top"), label: /* @__PURE__ */ Ie(pi, { component: ul, elevation: I != null && I.pathname.includes(`groups/${e.id}`) ? 4 : 0, direction: "row", spacing: 2, alignItems: "center", className: "k3-main-nav-item-content", sx: {
    transition: "all 0.3s",
    color: I != null && I.pathname.includes(`groups/${e.id}`) ? "common.black" : "inherit",
    bgcolor: I != null && I.pathname.includes(`groups/${e.id}`) ? "common.white" : "transparent",
    pl: I != null && I.pathname.includes("edit/conf") ? 2 : 0
  }, children: [
    t && /* @__PURE__ */ S(QN, { children: /* @__PURE__ */ S(zN, { color: "editor" }) }),
    a && /* @__PURE__ */ S(fZ, { "data-cy": "visited", color: "secondary", size: "small", sx: {
      p: 0,
      pr: "2px"
    }, disableRipple: !0, disableFocusRipple: !0, checkedIcon: /* @__PURE__ */ S(iM, {}), icon: /* @__PURE__ */ S(iM, { style: {
      visibility: "hidden"
    } }), checked: !!l.find((f) => f.id === e.id) }),
    /* @__PURE__ */ S(ON, { group: e, useDefaultEditorUi: r, className: "k3-tabs-nav-item-text k3-nav-item-text" })
  ] }) });
}, mQt = (e) => (t) => {
  const i = Vn(Fs), n = Oe(() => i.extendHeader(e), [i]);
  return /* @__PURE__ */ S(n, { ...t });
};
var jN = {}, pQt = yg;
Object.defineProperty(jN, "__esModule", {
  value: !0
});
var xge = jN.default = void 0, BQt = pQt(oo()), fQt = ro;
xge = jN.default = (0, BQt.default)(/* @__PURE__ */ (0, fQt.jsx)("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight");
const Oei = ({
  children: e
}) => {
  const t = g1(), i = ie(F6), n = rr(), r = t && i === "mobileDefault" ? n : Ut, g = ie((l) => bu(l, r)), o = ie((l) => zWe(l, r));
  return !g || !o ? null : /* @__PURE__ */ S(Ege, { groups: g, contextInstance: r, focusGroupId: o, children: e });
}, Dge = ({
  activeGroupId: e,
  groups: t,
  handleTabChange: i,
  onDragEnd: n,
  showEditorUi: r,
  invisibleGroups: g,
  ...o
}) => {
  const l = rr(), a = g1(), I = ie(F6);
  return /* @__PURE__ */ Ie(li, { children: [
    a && (I === "mobileDefault" || I === void 0) && (l == null ? void 0 : l.variableId) && /* @__PURE__ */ S(cQt, { useDelete: !0 }),
    /* @__PURE__ */ S(uQt, { "data-cy": "GroupsNavigationTabs", className: "k3-main-nav-tabs", variant: "scrollable", scrollButtons: "auto", textColor: "inherit", value: (e == null ? void 0 : e.toString()) || !1, onClick: (c) => {
      c.stopPropagation(), e && i(c, e.toString());
    }, onChange: (c, d) => {
      c.stopPropagation(), i(c, d);
    }, sx: {
      flexGrow: 1,
      color: "white"
    }, onDragEnd: n, children: t.reduce((c, d) => {
      var A, b;
      const C = t1(d, g);
      return !r && C ? c : [...c, /* @__PURE__ */ S(hQt, { "data-cy": `group-${d.label}`, value: (A = d.id) == null ? void 0 : A.toString(), group: d, isHiddenGroup: C, isActive: d.id == e, useDefaultEditorUi: o.isSidebarHeader }, (b = d.id) == null ? void 0 : b.toString())];
    }, []) }),
    /* @__PURE__ */ S(Fge, { design: "topmenu", placement: "topmenu", isRootHeader: o.isSidebarHeader })
  ] });
}, ZQt = {
  textOverflow: "ellipsis",
  overflow: "hidden",
  textWrap: "nowrap",
  lineHeight: "36px"
}, lx = ({
  children: e,
  maxWidth: t,
  className: i,
  onClick: n
}) => /* @__PURE__ */ S(Ct, { variant: "h6", title: e, sx: ZQt, maxWidth: t, className: i, onClick: n, children: /* @__PURE__ */ S("span", { children: e }) });
function e4(e, t, i) {
  var r;
  const n = e.valueId && ((r = t[e.valueId]) == null ? void 0 : r.label);
  return n || i("Wert");
}
const Jge = ({
  showBreadcrumbs: e = !0,
  ...t
}) => {
  var b;
  const {
    t: i
  } = Gi(), n = Vg(), r = ot(null), g = rr(), o = Ei(), l = ie(Br), a = vm(l, g).reverse(), I = a.length > 1 ? a[1] : g, c = ie(qr(I.variableId)), d = ie(vc), C = ie(t9), A = (m, p) => () => {
    const B = d[p];
    o(wr(m, B.groupId));
  };
  return lt(() => {
    r != null && r.current && (r == null || r.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    }));
  }, [(b = t.openInstance) == null ? void 0 : b.id]), /* @__PURE__ */ Ie(
    pi,
    {
      direction: "column",
      className: "k3-sub-header",
      "data-cy": "subGroupHeader",
      sx: {
        position: "sticky",
        top: 0,
        //zIndex gets smaller the deeper we are in the hierarchy
        zIndex: 1e3 - a.length,
        backgroundColor: "white"
      },
      children: [
        /* @__PURE__ */ Ie(pi, { direction: "row", alignItems: "center", children: [
          e && /* @__PURE__ */ Ie(li, { children: [
            /* @__PURE__ */ S(Tn, { title: n(Mi.COMPONENT_BREADCRUMBS_BACK), children: /* @__PURE__ */ S(Xd, { underline: "hover", component: fn, "data-cy": "sublevelRoot", className: "k3-sub-header-back", sx: {
              // sticky to the left
              position: "absolute",
              left: "0px",
              top: "0px",
              zIndex: 1e3,
              width: "34px"
            }, onClick: () => {
              o(wr(a[a.length - 1].id, c.groupId));
            }, children: /* @__PURE__ */ S(Ni, { component: "div", "data-cy": "sublevelBackButton", className: "k3-sub-header-back-button", sx: {
              lineHeight: "36px",
              // remove hover effects from mui Button
              "&:hover": {
                backgroundColor: "transparent"
              }
            }, children: /* @__PURE__ */ S(eq, { fontSize: "small" }) }) }) }),
            /* @__PURE__ */ Ie(uj, { "aria-label": "Breadcrumb", className: "k3-sub-header-breadcrumb", classes: {
              separator: "k3-sub-header-separator",
              ol: "k3-sub-header-ol",
              li: "k3-sub-header-li"
            }, separator: /* @__PURE__ */ S(xge, { fontSize: "small" }), sx: {
              width: 1,
              position: "relative",
              overflow: "hidden",
              ".MuiBreadcrumbs-separator": {
                margin: 0
              },
              ".MuiBreadcrumbs-ol": {
                flexWrap: "nowrap",
                overflow: "auto",
                marginLeft: "34px"
              }
            }, children: [
              /* @__PURE__ */ S(Xd, { underline: "hover", component: fn, "data-cy": "sublevelRoot", className: "k3-sub-header-link", children: /* @__PURE__ */ S(lx, { className: "k3-sub-header-root-label", onClick: A(I.instance.belongsToInstanceId, I.variableId), children: c == null ? void 0 : c.label }) }),
              a.map((m, p) => p === 0 ? null : /* @__PURE__ */ S(Xd, { sx: {
                overflow: "hidden"
              }, component: fn, underline: "hover", onClick: A(m.id, m.variableId), "data-cy": "sublevelLink" + p, className: "k3-sub-header-link", children: /* @__PURE__ */ S(lx, { children: e4(m, C, i) }) }, m.id)),
              /* @__PURE__ */ S(Xd, { ref: r, component: fn, "data-cy": "sublevelLinkLast", className: "k3-sub-header-link", sx: {
                width: 1,
                pointerEvents: "none",
                textDecoration: "underline"
              }, children: /* @__PURE__ */ S(lx, { children: e4(g, C, i) }) })
            ] })
          ] }),
          /* @__PURE__ */ S(hu, { keys: [Mi.COMPONENT_BREADCRUMBS_BACK], display: "dialog" })
        ] }),
        (t.groups.length > 1 || t.showEditorUi) && /* @__PURE__ */ S(Nj, { disableGutters: !0, className: "k3-sub-nav", children: /* @__PURE__ */ S(Dge, { ...t, isSidebarHeader: !0 }) }),
        t.children,
        /* @__PURE__ */ S(SI, {})
      ]
    }
  );
}, GQt = (e) => e.subHeader ? /* @__PURE__ */ S(Jge, { ...e }) : /* @__PURE__ */ Ie(Zue, { sx: {
  display: "grid",
  gridTemplateColumns: "max-content 1fr max-content",
  overflow: "auto"
}, position: "static", className: "k3-main-nav k3-header", "data-cy": "groupHeader", role: "banner", children: [
  /* @__PURE__ */ S(Nj, { disableGutters: !0, children: /* @__PURE__ */ S(Dge, { ...e }) }),
  e.children
] }), yQt = gr({
  app: {
    header: {
      root: !0
    }
  }
})(GQt), WQt = function(e) {
  const {
    groups: t = [],
    focusGroupId: i
  } = e, n = ie($r), r = Ei(), g = t.find((c) => c.id == i), o = rr(), l = e.contextInstance || o, a = ie((c) => n1(c, l)), I = Gt((c, d) => {
    const C = Iye(d);
    r(wr(l.id, C));
  }, [r, l]);
  return /* @__PURE__ */ S(yQt, { ...e, showEditorUi: n, activeGroupId: g == null ? void 0 : g.id, invisibleGroups: a, openInstance: l, handleTabChange: I });
}, Ege = mQt(WQt), t4 = {
  container: {
    border: "solid 1px rgba(0, 0, 0, 0.38)",
    borderRadius: 1,
    padding: 1,
    overflowY: "auto"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }
}, Nge = ({
  contextInstance: e
}) => {
  const t = ie((d) => TZ(d, e)), i = ie((d) => cu(d, e)) || (t == null ? void 0 : t.id), n = ie(kI(i)), r = ie((d) => n1(d, e)), g = ie($r), o = ie((d) => bu(d, e)), l = Ei(), a = (d, C) => {
    l(eG(+C));
  }, I = ie(pA(e.valueId)), c = Gt(() => {
    l(jee(e));
  }, [l, e]);
  return /* @__PURE__ */ S(j$.Provider, { value: e, children: /* @__PURE__ */ Ie(vo, { component: "div", sx: t4.container, children: [
    /* @__PURE__ */ Ie(vo, { component: "div", sx: t4.header, children: [
      /* @__PURE__ */ S(vo, { component: "div", children: /* @__PURE__ */ S(Ct, { variant: "h6", component: "h6", children: I == null ? void 0 : I.label }) }),
      /* @__PURE__ */ S(Ni, { onClick: c, href: "", "data-cy": "", children: /* @__PURE__ */ S(vv, {}) })
    ] }),
    (o.length > 1 || g) && /* @__PURE__ */ S(Jge, { activeGroupId: i, showBreadcrumbs: !1, handleTabChange: a, invisibleGroups: r, showEditorUi: g, groups: o, focusGroupId: i }),
    /* @__PURE__ */ S(SI, {}),
    /* @__PURE__ */ S(_1, { group: n, contextInstance: e })
  ] }) });
}, Sh = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    mt: 2,
    overflowY: "auto"
  },
  button: {
    display: "grid",
    gridTemplateColumns: "min-content 1fr min-content",
    gridTemplateAreas: `
          "Thumbnail Title Icons"
          "Thumbnail Extra Extra"`,
    width: "100%"
  },
  buttonThumbnail: {
    gridArea: "Thumbnail",
    justifySelf: "start"
  },
  buttonTitle: {
    gridArea: "Title"
  },
  buttonIcons: {
    gridArea: "Icons",
    justifySelf: "end"
  },
  buttonExtra: {
    gridArea: "Extra"
  }
}, rp = (e, t, i = !1) => ie((n) => EJ(n, e, t, i, t == null ? void 0 : t.settings.templateOptions.reverseSorting)), SQt = ({
  variable: e,
  onRenderThumbnail: t,
  onRenderExtra: i,
  hideSelection: n,
  tailingContent: r,
  contextInstance: g
}) => {
  var p;
  const o = ((p = rp(g, e, !0)) == null ? void 0 : p.filter((B) => n ? n(B.selection, B.value) : !0)) ?? [], l = Ei(), a = (B, f) => {
    l(wr(f));
  }, I = Tl((B) => B.hoveredSelections), c = Tl((B) => B.addHoveredSelection), d = Tl((B) => B.removeHoveredSelection), C = Vi(e), A = rr(), b = g || A, m = ie((B) => v6(B, b));
  return /* @__PURE__ */ S(wg, { variable: e, view: /* @__PURE__ */ Ie(ht, { component: "div", className: "k3-component-buttons-wrapper", children: [
    /* @__PURE__ */ S(BJ, { sx: Sh.wrapper, orientation: "vertical", exclusive: !0, onChange: a, children: o.map((B) => /* @__PURE__ */ S(lv, { selected: I.includes(B.selection.id) || B.selection.id === (m == null ? void 0 : m.id), color: B.selection.id === (m == null ? void 0 : m.id) ? "standard" : "primary", onMouseEnter: () => c(B.selection.id), onMouseLeave: () => d(B.selection.id), onMouseDown: () => d(B.selection.id), "data-cy": `selection-${B == null ? void 0 : B.value}`, fullWidth: !0, value: B.selection.id, sx: {
      textAlign: "left"
    }, children: /* @__PURE__ */ Ie(ht, { component: "div", sx: Sh.button, children: [
      /* @__PURE__ */ S(ht, { component: "div", sx: Sh.buttonThumbnail, children: t ? t(B.selection, B.value) : null }),
      /* @__PURE__ */ S(Ct, { sx: Sh.buttonTitle, variant: "body1", color: "textPrimary", children: B.value.label }),
      r ? r(B.selection, B.value) : /* @__PURE__ */ S(ht, { component: "div", sx: Sh.buttonIcons, children: /* @__PURE__ */ S(Hie, { fontSize: "small", color: "action" }) }),
      /* @__PURE__ */ S(ht, { component: "div", sx: Sh.buttonExtra, children: i ? i(B.selection, B.value) : null })
    ] }) }, B.selection.id)) }),
    C.showComponentEditorsInline && m && /* @__PURE__ */ S(ht, { component: "div", sx: {
      pt: 1
    }, children: /* @__PURE__ */ S(Nge, { contextInstance: m }) })
  ] }, `${b.id}_${e.id}`) });
}, Lge = Le.flow(ta, Fo("componentButtons"))(SQt), VQt = (e) => new Promise((t) => {
  setTimeout(t, e);
}), Fa = {
  quality: 0.8,
  width: 1280,
  height: 720,
  aspect: 1280 / 720
}, Kge = (e, t, i, n = !1, r, g) => {
  var C;
  const {
    scene: o
  } = t, l = t.camera, a = r / g;
  let I = null;
  if (!(e != null && e.type) || e.type === "PerspectiveCamera") {
    const A = UZ(l) ? l.fov : ((C = e.baseSettings) == null ? void 0 : C.fov) ?? 50;
    I = new W4(A, a, e.baseSettings.near, e.baseSettings.far);
  } else if (e.type === "OrthographicCamera")
    e.focusType === "dynamic" ? I = new Ix(-1 * a, 1 * a, 1, -1, e.baseSettings.near, e.baseSettings.far) : (I = new Ix(e.baseSettings.left, e.baseSettings.right, e.baseSettings.top, e.baseSettings.bottom, e.baseSettings.near, e.baseSettings.far), I.zoom = e.zoom ?? 1);
  else
    throw new Error("Unknown camera type");
  const {
    position: c,
    lookAt: d
  } = LGt(e, I, o, r, g, i);
  if (t.camera = I, t.camera.position.set(...c), t.camera.rotation.set(...e.rotation), t.camera.updateProjectionMatrix(), t.camera.updateMatrixWorld(), n && t.controls) {
    const A = t.controls;
    A.object = t.camera, A.target.set(...d), A == null || A.update();
  } else
    t.camera.lookAt(...d);
  return {
    newCamera: I,
    position: c,
    lookAt: d
  };
}, Tge = (e, t, i, n = !1) => {
  var o, l, a;
  const r = ((o = e.resolution) == null ? void 0 : o.width) ?? Fa.width, g = ((l = e.resolution) == null ? void 0 : l.height) ?? Fa.height;
  return (a = Kge(e, t, i, n, r, g)) == null ? void 0 : a.newCamera;
}, Mge = async (e, t, i = Fa.quality, n = Fa.width, r = Fa.height) => {
  const g = new fc();
  return e.gl.getSize(g), e.gl.setSize(n, r), e.set({
    camera: t
  }), e.camera.updateProjectionMatrix(), e.camera.updateMatrixWorld(), e.invalidate(5), await VQt(100), await new Promise((o) => {
    e.gl.render(e.scene, e.camera), e.gl.domElement.toBlob(o, "image/jpeg", i);
  }).finally(() => {
    e.gl.setSize(g.x, g.y);
  });
}, wQt = async (e, t, i, n) => {
  var c, d, C;
  const r = Iv(e), g = t.camera.clone(!0), o = Tge(i, t, r), {
    width: l,
    height: a
  } = VI("getScreenshotDimensions", {
    width: ((c = i.resolution) == null ? void 0 : c.width) ?? Fa.width,
    height: ((d = i.resolution) == null ? void 0 : d.height) ?? Fa.height
  }), I = await Mge(t, o, (C = e == null ? void 0 : e.settings) == null ? void 0 : C.screenshotQuality, l, a).then((A) => (t.camera = g, t.camera.updateProjectionMatrix(), t.camera.updateMatrixWorld(), A));
  if (!I)
    throw new Error(`Could not create screenshot for camera ${i}!`);
  return {
    key: `camera_${n}`,
    file: URL.createObjectURL(I)
  };
}, vQt = (e) => {
  console.debug("Executing useCreateScreenshotsOfCanvas");
  const t = Ei(), i = ie(Pi), n = ie(LWe), r = RI(), g = r.controls;
  g == null || g.saveState();
  const o = Gt(async () => {
    console.debug("Begin to take pictures"), r.gl.setPixelRatio(1);
    const a = [], I = r.camera.clone(!0);
    let c = Promise.resolve();
    if (n.length) {
      for (let d = 0; d < n.length; d++) {
        const C = n[d];
        c = c.then(async () => {
          a.push(await wQt(i, r, C, d));
        });
      }
      await c;
    } else {
      const d = r.camera.clone(!0);
      d.aspect = Fa.aspect, d.updateProjectionMatrix(), c = c.then(async () => {
        var A;
        return Mge(r, d, (A = i == null ? void 0 : i.settings) == null ? void 0 : A.screenshotQuality);
      });
      const C = await c;
      if (!C)
        throw new Error("Could not create screenshot for user camera!");
      a.push({
        key: "camera_0",
        file: URL.createObjectURL(C)
      });
    }
    await c.then(() => {
      var C, A;
      r.set({
        camera: I
      }), r.camera.updateProjectionMatrix(), r.camera.updateMatrixWorld();
      const d = r.controls;
      d.object = I, (C = d == null ? void 0 : d.reset) == null || C.call(d), (A = d == null ? void 0 : d.update) == null || A.call(d), console.debug("Finish taking pictures"), t(Tx(a)), console.debug("Finish committing pictures to redux");
    });
  }, [r, n, t, i]), l = Gt(async () => {
    var I;
    if (!((I = window.oc3) == null ? void 0 : I.get())) {
      console.warn("Not screenshotting due to missing state"), t(Tx([]));
      return;
    }
    e == null || e(), await o();
  }, [o, e, t]);
  lt(() => {
    l();
  }, []);
}, qN = (e) => e.cameraPreview.cameraPreviewData, hC = (e) => e && e.isOrthographicCamera, RQt = (e) => e && e.isBox3, Pge = X.createContext(null);
function XQt({
  children: e,
  damping: t = 6,
  fit: i,
  clip: n,
  observe: r,
  margin: g = 1.2,
  eps: o = 0.01,
  onFit: l
}) {
  const a = X.useRef(null), I = RI(), c = X.useRef(I.camera), d = X.useRef(l);
  d.current = l;
  function C(y, W) {
    return Math.abs(y.x - W.x) < o && Math.abs(y.y - W.y) < o && Math.abs(y.z - W.z) < o;
  }
  function A(y, W, V, w) {
    y.x = GB.damp(y.x, W.x, V, w), y.y = GB.damp(y.y, W.y, V, w), y.z = GB.damp(y.z, W.z, V, w);
  }
  const b = ot({
    animating: !1,
    lookAt: new ye(),
    position: new ye(),
    zoom: 1
  }), m = ot({
    lookAt: new ye(),
    position: new ye(),
    zoom: 1
  }), [p] = X.useState(() => new fg()), B = X.useMemo(() => {
    const y = I.controls;
    function W() {
      const V = p.getSize(new ye()), w = p.getCenter(new ye()), v = Math.max(V.x, V.y, V.z), H = hC(I.camera) ? v * 4 : v / (2 * Math.atan(Math.PI * I.camera.fov / 360)), x = hC(I.camera) ? v * 4 : H / I.camera.aspect, J = g * Math.max(H, x);
      return {
        box: p,
        size: V,
        center: w,
        distance: J
      };
    }
    return {
      getSize: W,
      setCamera(V, w, v) {
        b.current.position.copy(V), b.current.lookAt.copy(w), b.current.zoom = v || b.current.zoom, b.current.animating = !1, m.current.position.copy(V), m.current.lookAt.copy(w), m.current.zoom = v || b.current.zoom, I.camera.position.set(...V.toArray()), hC(I.camera) && (I.camera.zoom = v || b.current.zoom, I.camera.updateProjectionMatrix()), y ? (y.target.copy(w), y.update()) : (I.camera.lookAt(...w.toArray()), I.camera.updateProjectionMatrix());
      },
      refresh(V) {
        if (RQt(V))
          p.copy(V);
        else {
          const w = V || a.current;
          w.updateWorldMatrix(!0, !0), p.setFromObject(w);
        }
        if (p.isEmpty()) {
          const w = I.camera.position.length() || 10;
          p.setFromCenterAndSize(new ye(), new ye(w, w, w));
        }
        if ((y == null ? void 0 : y.constructor.name) === "OrthographicTrackballControls") {
          const {
            distance: w
          } = W(), v = I.camera.position.clone().sub(y.target).normalize().multiplyScalar(w), H = y.target.clone().add(v);
          I.camera.position.copy(H);
        }
        return this;
      },
      clip() {
        const {
          distance: V
        } = W();
        return y && (y.maxDistance = V * 10), I.camera.near = V / 100, I.camera.far = V * 100, I.camera.updateProjectionMatrix(), y && y.update(), I.invalidate(), this;
      },
      to({
        position: V,
        target: w
      }) {
        if (b.current.position.copy(I.camera.position), m.current.position.set(...V), w)
          m.current.lookAt.set(...w);
        else {
          const {
            center: v
          } = W();
          m.current.lookAt.copy(v);
        }
        return t ? b.current.animating = !0 : I.camera.position.set(...V), this;
      },
      fit() {
        b.current.position.copy(I.camera.position), y && b.current.lookAt.copy(y.target);
        const {
          center: V,
          distance: w
        } = W(), v = V.clone().sub(I.camera.position).normalize().multiplyScalar(w);
        if (m.current.position.copy(V).sub(v), m.current.lookAt.copy(V), hC(I.camera)) {
          b.current.zoom = I.camera.zoom;
          let H = 0, x = 0;
          const J = [new ye(p.min.x, p.min.y, p.min.z), new ye(p.min.x, p.max.y, p.min.z), new ye(p.min.x, p.min.y, p.max.z), new ye(p.min.x, p.max.y, p.max.z), new ye(p.max.x, p.max.y, p.max.z), new ye(p.max.x, p.max.y, p.min.z), new ye(p.max.x, p.min.y, p.max.z), new ye(p.max.x, p.min.y, p.min.z)];
          V.applyMatrix4(I.camera.matrixWorldInverse);
          for (const L of J)
            L.applyMatrix4(I.camera.matrixWorldInverse), H = Math.max(H, Math.abs(L.y - V.y)), x = Math.max(x, Math.abs(L.x - V.x));
          H *= 2, x *= 2;
          const K = (I.camera.top - I.camera.bottom) / H, M = (I.camera.right - I.camera.left) / x;
          m.current.zoom = Math.min(K, M) / g, t || (I.camera.zoom = m.current.zoom, I.camera.updateProjectionMatrix());
        }
        return t ? b.current.animating = !0 : (I.camera.position.copy(m.current.position), I.camera.lookAt(m.current.lookAt), y && (y.target.copy(m.current.lookAt), y.update())), d.current && d.current(this.getSize()), I.invalidate(), this;
      }
    };
  }, [p, I, I.camera, I.controls, g, t]);
  X.useLayoutEffect(() => {
    if (I.controls) {
      const y = () => b.current.animating = !1;
      return I.controls.addEventListener("start", y), () => {
        var W;
        return (W = I.controls) == null ? void 0 : W.removeEventListener("start", y);
      };
    }
  }, [I.controls]);
  const f = X.useRef(0);
  return X.useLayoutEffect(() => {
    (r || f.current++ === 0) && (B.refresh(), i && B.fit(), n && B.clip());
  }, [I.size, n, i, r, I.camera, I.controls]), ie(qN) && (b.current.animating = !1), dA((y, W) => {
    if (b.current.animating) {
      A(b.current.lookAt, m.current.lookAt, t, W), A(b.current.position, m.current.position, t, W), b.current.zoom = GB.damp(b.current.zoom, m.current.zoom, t, W), y.camera.position.copy(b.current.position), hC(y.camera) && hC(c.current) && (y.camera.zoom = b.current.zoom, y.camera.updateProjectionMatrix(), c.current = y.camera);
      const V = y.controls;
      if (V ? (V.target.copy(b.current.lookAt), V.update()) : y.camera.lookAt(b.current.lookAt), y.invalidate(), hC(y.camera) && !(Math.abs(b.current.zoom - m.current.zoom) < o) || !C(y.camera.position, m.current.position) || V && !C(b.current.lookAt, m.current.lookAt))
        return;
      b.current.animating = !1;
    }
  }), /* @__PURE__ */ S("group", { ref: a, children: /* @__PURE__ */ S(Pge.Provider, { value: B, children: e }) });
}
function Uge() {
  return X.useContext(Pge);
}
function HQt(e) {
  const t = RI(), i = t.scene.getObjectByName("k3d"), n = Uge(), r = ie(m$), g = ie(u1), o = ie(Pi), l = Iv(o), a = ot(new fg()), [I, c] = wt(0), d = !r && !g && n && i && a;
  dA(() => {
    if (g)
      return;
    const C = new fg();
    i && i.traverseVisible((A) => {
      var b;
      // @ts-ignore
      A.isMesh && // Sometimes we need to ignore some objects for the Text of Ruler 3d
      // components. Since they are rotated towards the camera and thus
      // change the bounding box constantly.
      !((b = A.userData) != null && b.ignoreBoundingBoxWhileFocusing) && C.expandByObject(A);
    }), d && !a.current.equals(C) && c((I + 1) % 1e3), a.current = C;
  }), Oe(() => {
    n && d && S5(i, n, t, l, e);
  }, [I]);
}
const i4 = 2;
function kQt({
  animateOnMissed: e = !1,
  animate: t = !1,
  threshold: i,
  ...n
}) {
  const r = Uge(), g = n.boundsApi || r, o = ie(Pi), l = Iv(o), a = RI(), {
    scene: I,
    invalidate: c,
    camera: d
  } = a, C = ie(m$), A = ie(UGt), b = ie(u1), m = n.isLoadingSceneOverride === void 0 ? b : n.isLoadingSceneOverride, [p, B] = wt([]), f = ie(p$);
  if (!m && C && YGt(C)) {
    const v = C.modelIds ? de.intersection(f, C == null ? void 0 : C.modelIds).sort() : f;
    Le.equals(v, p) || B(v);
  }
  HQt(i);
  const Z = (v) => {
    v.stopPropagation(), g && t && v.delta <= 2 && S5(v.object, g, a, l);
  }, y = I.getObjectByName("k3d"), W = (v) => {
    g && e && y && v.button === 0 && S5(y, g, a, l);
  }, V = ot(), w = ie((v) => m ? null : b$(C, I, v));
  return Oe(
    () => {
      var L;
      const v = ((L = a.camera) == null ? void 0 : L.type) !== ((C == null ? void 0 : C.type) ?? "PerspectiveCamera");
      if (!m && a.controls && a.camera && C && v) {
        const N = a.controls;
        N && (N.enableDamping = !1);
        const U = a.size.width, O = a.size.height, {
          position: $,
          lookAt: ne
        } = Kge(C, a, l, !0, U, O);
        g == null || g.setCamera(new ye(...$), new ye(...ne), C.zoom), N && (N.enableDamping = !0);
        return;
      }
      if (!w || m || v)
        return;
      const H = C && A$(C, w);
      if (!g || !C || H)
        return;
      const x = a.size.width, J = a.size.height, {
        newPosition: K,
        newTarget: M
      } = uE(C, d, w, x, J, l);
      if (h$(d, w, K, M, C.threshold ?? i, C.focusType === "dynamic"))
        return V.current = {
          position: K,
          target: M,
          frameCount: 0
        }, c(), V;
    },
    // If we are adding focusBoundingBox to the deps, we will update too often.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, g, C, c, m, p, A]
  ), dA(() => {
    var v, H;
    V != null && V.current && (((v = V == null ? void 0 : V.current) == null ? void 0 : v.frameCount) < i4 ? (V.current.frameCount += 1, c()) : ((H = V == null ? void 0 : V.current) == null ? void 0 : H.frameCount) >= i4 && (g.to(V.current), V.current = void 0, c()));
  }), /* @__PURE__ */ S(
    "group",
    {
      onClick: Z,
      onPointerMissed: W,
      children: n.children
    }
  );
}
const zge = Ua(() => {
}), YQt = (e) => {
  const t = Ei();
  lt(() => (t(ST(!0)), () => {
    t(ST(!1));
  }), []);
  const i = ie(CE) == "creating", n = Vn(zge);
  return /* @__PURE__ */ Ie(li, { children: [
    i && /* @__PURE__ */ S(FQt, { beforeScreenshot: n }),
    /* @__PURE__ */ S(kQt, { ...e })
  ] });
};
function FQt({
  beforeScreenshot: e
}) {
  return vQt(e), null;
}
const xQt = ({
  canvas: e,
  canvasProps: t,
  beforeScreenshot: i,
  children: n
}) => {
  var l;
  const {
    contexts: r
  } = Xv(), g = e || V4, o = koe(Fs, ...r);
  return /* @__PURE__ */ S(ht, { component: "div", sx: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    bgcolor: "background.default"
  }, children: /* @__PURE__ */ S(ht, { component: "div", sx: {
    height: "100%",
    width: "100%"
  }, children: /* @__PURE__ */ S(g, { ...t, gl: {
    ...t == null ? void 0 : t.gl,
    logarithmicDepthBuffer: (
      // We are using a logarithmic depth buffer for better depth
      // precision. If it for the rare case should be a performance
      // problem, you can disable it in the scene settings of the specific
      // configurator.
      // Here is a nice demo of this problem:
      // https://threejs.org/examples/#webgl_camera_logarithmicdepthbuffer
      ((l = t == null ? void 0 : t.gl) == null ? void 0 : l.logarithmicDepthBuffer) ?? !0
    )
  }, onCreated: (a) => {
    var I;
    window.oc3 = a, (I = t == null ? void 0 : t.onCreated) == null || I.call(t, a);
  }, children: /* @__PURE__ */ S(zge.Provider, { value: i, children: /* @__PURE__ */ S(o, { children: n }) }) }) }) });
}, DQt = gr({
  app: {
    k3d: {
      canvas: {
        root: !0
      }
    }
  }
})(xQt), JQt = () => {
  const t = ie(kWe).filter(({
    variable: i
  }) => Vi(i).highlightHovered).map(({
    selection: i,
    variable: n
  }) => {
    const r = Vi(n);
    return {
      selection: i,
      color: r.highlightColor ?? "white",
      targetOpacity: r.highlightOpacity ?? 0.5
    };
  });
  return /* @__PURE__ */ S(li, { children: t.map((i) => /* @__PURE__ */ B4(NQt, { ...i, key: i.selection.id })) });
};
function EQt(e, t, i) {
  const n = [], r = e.getObjectByName("k3d");
  r == null || r.traverse((g) => {
    var a, I, c;
    const o = (I = (a = g.userData) == null ? void 0 : a.anchoringSelection) == null ? void 0 : I.id, l = qa((c = g == null ? void 0 : g.userData) == null ? void 0 : c.anchoringSelection);
    t.some((d) => d.id === o || l === d.id) && n.push(g);
  }), i.current.makeEmpty();
  for (const g of n)
    g.traverse((o) => {
      i.current.expandByObject(o);
    });
}
const n4 = 0.01, NQt = (e) => {
  var B, f, Z;
  const t = Tl((y) => y.hoveredSelections), i = ot(), {
    scene: n,
    invalidate: r
  } = RI(), g = ie(Br), o = t.some((y) => y === e.selection.id), a = ie(Ns).find((y) => y.id === e.selection.id), I = Oe(() => [e.selection, ...nA(g, e.selection)], [g, e.selection]), c = ot(new fg(new ye(), new ye())), d = ot(new yoe(c.current, new Woe(e.color)));
  lt(() => {
    d.current.material = new Soe({
      color: e.color,
      linewidth: 2
    });
  }, [e.color]);
  const C = c.current.getCenter(new ye()), A = c.current.getSize(new ye());
  lt(() => {
    i.current && (i.current.opacity = 0);
  }, [i.current]);
  const b = o ? e.targetOpacity : 0, [, m] = wt(0);
  dA((y, W) => {
    var w, v;
    if (W > 0.1) {
      r();
      return;
    }
    const V = c.current.clone();
    EQt(n, I, c), V.equals(c.current) || m((H) => (H + 1) % 100), i.current && (i.current.opacity = GB.damp(((w = i.current) == null ? void 0 : w.opacity) ?? 0, b, 15, W), Math.abs(b - ((v = i.current) == null ? void 0 : v.opacity)) >= n4 ? r() : i.current.opacity = b);
  });
  const p = (i == null ? void 0 : i.current) && (Math.abs(b - ((B = i.current) == null ? void 0 : B.opacity)) >= n4 || b > 0);
  return /* @__PURE__ */ Ie(li, { children: [
    d.current && !((f = c.current) != null && f.isEmpty()) && (a == null ? void 0 : a.id) === e.selection.id && /* @__PURE__ */ S("primitive", { object: d.current }),
    /* @__PURE__ */ Ie("mesh", { name: `highlighter-${e.selection.id}`, visible: p, position: C.toArray(), scale: A.toArray(), castShadow: !1, children: [
      /* @__PURE__ */ S("boxGeometry", { args: [1, 1, 1] }),
      /* @__PURE__ */ S("meshBasicMaterial", { ref: i, color: e.color, transparent: !0, depthTest: !1, opacity: ((Z = i == null ? void 0 : i.current) == null ? void 0 : Z.opacity) ?? 0 })
    ] })
  ] });
};
function Oge() {
  const e = Yoe(), t = e == null ? void 0 : e.getSize(), {
    progress: i
  } = S4();
  return /* @__PURE__ */ S(Foe, { position: t == null ? void 0 : t.center, children: /* @__PURE__ */ Ie(ht, { component: "div", sx: {
    position: "absolute"
  }, children: [
    /* @__PURE__ */ S(hj, { sx: {
      position: "absolute"
    }, size: 60, disableShrink: !0 }),
    /* @__PURE__ */ S(Ct, { sx: {
      position: "absolute",
      left: 15,
      top: 20
    }, variant: "caption", component: "div", color: "text.secondary", children: `${Math.round(i)}%` })
  ] }) });
}
const LQt = {
  id: "background"
}, r4 = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.tags) == null ? void 0 : i.includes(LQt.id)) ?? !1;
};
function g4({
  data: e,
  colorActions: t,
  materialActions: i,
  printActions: n
}) {
  return ie(PGt(e.model.key)) ? null : /* @__PURE__ */ S(fm, { fallback: /* @__PURE__ */ S(Oge, {}), children: /* @__PURE__ */ S(kw, { model: e.model, meshProps: e.modelAction.props, fileURL: e.model.path, colorActions: t, materialActions: i, printActions: n, modelAction: e.modelAction, component: e.component }, "k3model" + e.modelAction.unique) });
}
function KQt({
  children: e,
  backgroundChildren: t
}) {
  var a;
  const i = ot(), n = ie(Rm), r = ie(b6), g = ie(C6), o = ie(A6), l = n.map((I) => {
    const c = I.model;
    let d;
    return c.type === "dynamic" && (d = Pee(c, I)), {
      model: c,
      component: d,
      modelAction: I
    };
  }).filter(Boolean);
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ Ie("group", { name: "k3d", ref: i, children: [
      /* @__PURE__ */ S(JQt, {}),
      (a = l == null ? void 0 : l.filter((I) => (I.model.path || I.component) && !r4(I.model))) == null ? void 0 : a.map((I, c) => /* @__PURE__ */ S(g4, { data: I, colorActions: g, materialActions: r, printActions: o }, I.modelAction.unique ?? c)),
      e
    ] }, "k3d"),
    /* @__PURE__ */ Ie("group", { name: "k3d-background", children: [
      l.filter((I) => (I.model.path || I.component) && r4(I.model)).map((I, c) => /* @__PURE__ */ S(g4, { data: I, colorActions: g, materialActions: r, printActions: o }, I.modelAction.unique ?? c)),
      t
    ] }, "k3d-background")
  ] });
}
var _N = {}, TQt = yg;
Object.defineProperty(_N, "__esModule", {
  value: !0
});
var Qge = _N.default = void 0, MQt = TQt(oo()), PQt = ro;
Qge = _N.default = (0, MQt.default)(/* @__PURE__ */ (0, PQt.jsx)("path", {
  d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), "Fullscreen");
var $N = {}, UQt = yg;
Object.defineProperty($N, "__esModule", {
  value: !0
});
var jge = $N.default = void 0, zQt = UQt(oo()), OQt = ro;
jge = $N.default = (0, zQt.default)(/* @__PURE__ */ (0, OQt.jsx)("path", {
  d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), "FullscreenExit");
const QQt = (e, t) => {
  const i = Gt((n) => {
    t.some((g) => n.key === g) && e({
      key: n.key,
      ctrl: n.ctrlKey
    });
  }, [e, t]);
  lt(() => (document.addEventListener("keydown", i), () => {
    document.removeEventListener("keydown", i);
  }), [i]);
}, qge = Se(fn)(({
  theme: e
}) => ({
  color: e.palette.secondary.contrastText,
  borderColor: e.palette.secondary.main,
  backgroundColor: e.palette.secondary.main,
  "&:hover": {
    backgroundColor: e.palette.secondary.dark
  }
})), jQt = () => {
  const e = Ei(), t = ie(N6), i = ie($r), n = Vg();
  return QQt(({
    key: g
  }) => {
    t && (g === "Escape" || g === " ") && e(GT());
  }, ["Escape", " "]), /* @__PURE__ */ Ie(pi, { direction: "row", children: [
    /* @__PURE__ */ S(qge, { "data-cy": "fullscreenButton", onClick: () => {
      e(GT());
    }, className: "fullscreenButton k3-btn k3-mode-button", variant: "contained", fullWidth: !0, startIcon: t ? /* @__PURE__ */ S(jge, {}) : /* @__PURE__ */ S(Qge, {}), children: n(Mi.FULLSCREEN_BUTTON) }),
    !!i && /* @__PURE__ */ S(hu, { keys: [Mi.FULLSCREEN_BUTTON] })
  ] });
};
var _ge = {}, $1 = {}, eL = {}, ax = {}, o4;
function qQt() {
  return o4 || (o4 = 1, function(e) {
    (function(t, i) {
      i(e, De, iQ);
    })(Or, function(t, i, n) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.setHasSupportToCaptureOption = b;
      var r = o(i), g = o(n);
      function o(f) {
        return f && f.__esModule ? f : {
          default: f
        };
      }
      var l = Object.assign || function(f) {
        for (var Z = 1; Z < arguments.length; Z++) {
          var y = arguments[Z];
          for (var W in y)
            Object.prototype.hasOwnProperty.call(y, W) && (f[W] = y[W]);
        }
        return f;
      };
      function a(f, Z) {
        var y = {};
        for (var W in f)
          Z.indexOf(W) >= 0 || Object.prototype.hasOwnProperty.call(f, W) && (y[W] = f[W]);
        return y;
      }
      function I(f, Z) {
        if (!(f instanceof Z))
          throw new TypeError("Cannot call a class as a function");
      }
      var c = /* @__PURE__ */ function() {
        function f(Z, y) {
          for (var W = 0; W < y.length; W++) {
            var V = y[W];
            V.enumerable = V.enumerable || !1, V.configurable = !0, "value" in V && (V.writable = !0), Object.defineProperty(Z, V.key, V);
          }
        }
        return function(Z, y, W) {
          return y && f(Z.prototype, y), W && f(Z, W), Z;
        };
      }();
      function d(f, Z) {
        if (!f)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return Z && (typeof Z == "object" || typeof Z == "function") ? Z : f;
      }
      function C(f, Z) {
        if (typeof Z != "function" && Z !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof Z);
        f.prototype = Object.create(Z && Z.prototype, {
          constructor: {
            value: f,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Z && (Object.setPrototypeOf ? Object.setPrototypeOf(f, Z) : f.__proto__ = Z);
      }
      var A = !1;
      function b(f) {
        A = f;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          b(!0);
        } }));
      } catch {
      }
      function m() {
        var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return A ? f : f.capture;
      }
      function p(f) {
        if ("touches" in f) {
          var Z = f.touches[0], y = Z.pageX, W = Z.pageY;
          return { x: y, y: W };
        }
        var V = f.screenX, w = f.screenY;
        return { x: V, y: w };
      }
      var B = function(f) {
        C(Z, f);
        function Z() {
          var y;
          I(this, Z);
          for (var W = arguments.length, V = Array(W), w = 0; w < W; w++)
            V[w] = arguments[w];
          var v = d(this, (y = Z.__proto__ || Object.getPrototypeOf(Z)).call.apply(y, [this].concat(V)));
          return v._handleSwipeStart = v._handleSwipeStart.bind(v), v._handleSwipeMove = v._handleSwipeMove.bind(v), v._handleSwipeEnd = v._handleSwipeEnd.bind(v), v._onMouseDown = v._onMouseDown.bind(v), v._onMouseMove = v._onMouseMove.bind(v), v._onMouseUp = v._onMouseUp.bind(v), v._setSwiperRef = v._setSwiperRef.bind(v), v;
        }
        return c(Z, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, m({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, m({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(W) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(W));
          }
        }, {
          key: "_onMouseMove",
          value: function(W) {
            this.mouseDown && this._handleSwipeMove(W);
          }
        }, {
          key: "_onMouseUp",
          value: function(W) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(W);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(W) {
            var V = p(W), w = V.x, v = V.y;
            this.moveStart = { x: w, y: v }, this.props.onSwipeStart(W);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(W) {
            if (this.moveStart) {
              var V = p(W), w = V.x, v = V.y, H = w - this.moveStart.x, x = v - this.moveStart.y;
              this.moving = !0;
              var J = this.props.onSwipeMove({
                x: H,
                y: x
              }, W);
              J && W.cancelable && W.preventDefault(), this.movePosition = { deltaX: H, deltaY: x };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(W) {
            this.props.onSwipeEnd(W);
            var V = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -V ? this.props.onSwipeLeft(1, W) : this.movePosition.deltaX > V && this.props.onSwipeRight(1, W), this.movePosition.deltaY < -V ? this.props.onSwipeUp(1, W) : this.movePosition.deltaY > V && this.props.onSwipeDown(1, W)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(W) {
            this.swiper = W, this.props.innerRef(W);
          }
        }, {
          key: "render",
          value: function() {
            var W = this.props;
            W.tagName;
            var V = W.className, w = W.style, v = W.children;
            W.allowMouseEvents, W.onSwipeUp, W.onSwipeDown, W.onSwipeLeft, W.onSwipeRight, W.onSwipeStart, W.onSwipeMove, W.onSwipeEnd, W.innerRef, W.tolerance;
            var H = a(W, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return r.default.createElement(
              this.props.tagName,
              l({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: V,
                style: w
              }, H),
              v
            );
          }
        }]), Z;
      }(i.Component);
      B.displayName = "ReactSwipe", B.propTypes = {
        tagName: g.default.string,
        className: g.default.string,
        style: g.default.object,
        children: g.default.node,
        allowMouseEvents: g.default.bool,
        onSwipeUp: g.default.func,
        onSwipeDown: g.default.func,
        onSwipeLeft: g.default.func,
        onSwipeRight: g.default.func,
        onSwipeStart: g.default.func,
        onSwipeMove: g.default.func,
        onSwipeEnd: g.default.func,
        innerRef: g.default.func,
        tolerance: g.default.number.isRequired
      }, B.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, t.default = B;
    });
  }(ax)), ax;
}
(function(e) {
  (function(t, i) {
    i(e, qQt());
  })(Or, function(t, i) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(i);
    function r(g) {
      return g && g.__esModule ? g : {
        default: g
      };
    }
    t.default = n.default;
  });
})(eL);
var GG = {}, $ge = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function i() {
      for (var g = "", o = 0; o < arguments.length; o++) {
        var l = arguments[o];
        l && (g = r(g, n(l)));
      }
      return g;
    }
    function n(g) {
      if (typeof g == "string" || typeof g == "number")
        return g;
      if (typeof g != "object")
        return "";
      if (Array.isArray(g))
        return i.apply(null, g);
      if (g.toString !== Object.prototype.toString && !g.toString.toString().includes("[native code]"))
        return g.toString();
      var o = "";
      for (var l in g)
        t.call(g, l) && g[l] && (o = r(o, l));
      return o;
    }
    function r(g, o) {
      return o ? g ? g + " " + o : g + o : g;
    }
    e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
  })();
})($ge);
var _Qt = $ge.exports;
Object.defineProperty(GG, "__esModule", {
  value: !0
});
GG.default = void 0;
var md = $Qt(_Qt);
function $Qt(e) {
  return e && e.__esModule ? e : { default: e };
}
function ejt(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var tjt = {
  ROOT: function(t) {
    return (0, md.default)(ejt({
      "carousel-root": !0
    }, t || "", !!t));
  },
  CAROUSEL: function(t) {
    return (0, md.default)({
      carousel: !0,
      "carousel-slider": t
    });
  },
  WRAPPER: function(t, i) {
    return (0, md.default)({
      "thumbs-wrapper": !t,
      "slider-wrapper": t,
      "axis-horizontal": i === "horizontal",
      "axis-vertical": i !== "horizontal"
    });
  },
  SLIDER: function(t, i) {
    return (0, md.default)({
      thumbs: !t,
      slider: t,
      animated: !i
    });
  },
  ITEM: function(t, i, n) {
    return (0, md.default)({
      thumb: !t,
      slide: t,
      selected: i,
      previous: n
    });
  },
  ARROW_PREV: function(t) {
    return (0, md.default)({
      "control-arrow control-prev": !0,
      "control-disabled": t
    });
  },
  ARROW_NEXT: function(t) {
    return (0, md.default)({
      "control-arrow control-next": !0,
      "control-disabled": t
    });
  },
  DOT: function(t) {
    return (0, md.default)({
      dot: !0,
      selected: t
    });
  }
};
GG.default = tjt;
var yG = {}, eR = {};
Object.defineProperty(eR, "__esModule", {
  value: !0
});
eR.outerWidth = void 0;
var ijt = function(t) {
  var i = t.offsetWidth, n = getComputedStyle(t);
  return i += parseInt(n.marginLeft) + parseInt(n.marginRight), i;
};
eR.outerWidth = ijt;
var gp = {};
Object.defineProperty(gp, "__esModule", {
  value: !0
});
gp.default = void 0;
var njt = function(t, i, n) {
  var r = t === 0 ? t : t + i, g = n === "horizontal" ? [r, 0, 0] : [0, r, 0], o = "translate3d", l = "(" + g.join(",") + ")";
  return o + l;
};
gp.default = njt;
var WG = {};
Object.defineProperty(WG, "__esModule", {
  value: !0
});
WG.default = void 0;
var rjt = function() {
  return window;
};
WG.default = rjt;
Object.defineProperty(yG, "__esModule", {
  value: !0
});
yG.default = void 0;
var ps = ljt(De), mC = tR(GG), gjt = eR, l4 = tR(gp), ojt = tR(eL), $S = tR(WG);
function tR(e) {
  return e && e.__esModule ? e : { default: e };
}
function eoe() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return eoe = function() {
    return e;
  }, e;
}
function ljt(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || mf(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = eoe();
  if (t && t.has(e))
    return t.get(e);
  var i = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var g = n ? Object.getOwnPropertyDescriptor(e, r) : null;
      g && (g.get || g.set) ? Object.defineProperty(i, r, g) : i[r] = e[r];
    }
  return i.default = e, t && t.set(e, i), i;
}
function mf(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mf = function(i) {
    return typeof i;
  } : mf = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, mf(e);
}
function fD() {
  return fD = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, fD.apply(this, arguments);
}
function ajt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sjt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Ijt(e, t, i) {
  return t && sjt(e.prototype, t), e;
}
function cjt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && ZD(e, t);
}
function ZD(e, t) {
  return ZD = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, ZD(e, t);
}
function djt(e) {
  var t = Cjt();
  return function() {
    var n = n2(e), r;
    if (t) {
      var g = n2(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return ujt(this, r);
  };
}
function ujt(e, t) {
  return t && (mf(t) === "object" || typeof t == "function") ? t : fo(e);
}
function fo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Cjt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function n2(e) {
  return n2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, n2(e);
}
function eo(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var Ajt = function(t) {
  return t.hasOwnProperty("key");
}, tL = /* @__PURE__ */ function(e) {
  cjt(i, e);
  var t = djt(i);
  function i(n) {
    var r;
    return ajt(this, i), r = t.call(this, n), eo(fo(r), "itemsWrapperRef", void 0), eo(fo(r), "itemsListRef", void 0), eo(fo(r), "thumbsRef", void 0), eo(fo(r), "setItemsWrapperRef", function(g) {
      r.itemsWrapperRef = g;
    }), eo(fo(r), "setItemsListRef", function(g) {
      r.itemsListRef = g;
    }), eo(fo(r), "setThumbsRef", function(g, o) {
      r.thumbsRef || (r.thumbsRef = []), r.thumbsRef[o] = g;
    }), eo(fo(r), "updateSizes", function() {
      if (!(!r.props.children || !r.itemsWrapperRef || !r.thumbsRef)) {
        var g = ps.Children.count(r.props.children), o = r.itemsWrapperRef.clientWidth, l = r.props.thumbWidth ? r.props.thumbWidth : (0, gjt.outerWidth)(r.thumbsRef[0]), a = Math.floor(o / l), I = a < g, c = I ? g - a : 0;
        r.setState(function(d, C) {
          return {
            itemSize: l,
            visibleItems: a,
            firstItem: I ? r.getFirstItem(C.selectedItem) : 0,
            lastPosition: c,
            showArrows: I
          };
        });
      }
    }), eo(fo(r), "handleClickItem", function(g, o, l) {
      if (!Ajt(l) || l.key === "Enter") {
        var a = r.props.onSelectItem;
        typeof a == "function" && a(g, o);
      }
    }), eo(fo(r), "onSwipeStart", function() {
      r.setState({
        swiping: !0
      });
    }), eo(fo(r), "onSwipeEnd", function() {
      r.setState({
        swiping: !1
      });
    }), eo(fo(r), "onSwipeMove", function(g) {
      var o = g.x;
      if (!r.state.itemSize || !r.itemsWrapperRef || !r.state.visibleItems)
        return !1;
      var l = 0, a = ps.Children.count(r.props.children), I = -(r.state.firstItem * 100) / r.state.visibleItems, c = Math.max(a - r.state.visibleItems, 0), d = -c * 100 / r.state.visibleItems;
      I === l && o > 0 && (o = 0), I === d && o < 0 && (o = 0);
      var C = r.itemsWrapperRef.clientWidth, A = I + 100 / (C / o);
      return r.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(b) {
        r.itemsListRef.style[b] = (0, l4.default)(A, "%", r.props.axis);
      }), !0;
    }), eo(fo(r), "slideRight", function(g) {
      r.moveTo(r.state.firstItem - (typeof g == "number" ? g : 1));
    }), eo(fo(r), "slideLeft", function(g) {
      r.moveTo(r.state.firstItem + (typeof g == "number" ? g : 1));
    }), eo(fo(r), "moveTo", function(g) {
      g = g < 0 ? 0 : g, g = g >= r.state.lastPosition ? r.state.lastPosition : g, r.setState({
        firstItem: g
      });
    }), r.state = {
      selectedItem: n.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, r;
  }
  return Ijt(i, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== r.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, $S.default)().addEventListener("resize", this.updateSizes), (0, $S.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, $S.default)().removeEventListener("resize", this.updateSizes), (0, $S.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(r) {
      var g = r;
      return r >= this.state.lastPosition && (g = this.state.lastPosition), r < this.state.firstItem + this.state.visibleItems && (g = this.state.firstItem), r < this.state.firstItem && (g = r), g;
    }
  }, {
    key: "renderItems",
    value: function() {
      var r = this;
      return this.props.children.map(function(g, o) {
        var l = mC.default.ITEM(!1, o === r.state.selectedItem), a = {
          key: o,
          ref: function(c) {
            return r.setThumbsRef(c, o);
          },
          className: l,
          onClick: r.handleClickItem.bind(r, o, r.props.children[o]),
          onKeyDown: r.handleClickItem.bind(r, o, r.props.children[o]),
          "aria-label": "".concat(r.props.labels.item, " ").concat(o + 1),
          style: {
            width: r.props.thumbWidth
          }
        };
        return /* @__PURE__ */ ps.default.createElement("li", fD({}, a, {
          role: "button",
          tabIndex: 0
        }), g);
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this;
      if (!this.props.children)
        return null;
      var g = ps.Children.count(this.props.children) > 1, o = this.state.showArrows && this.state.firstItem > 0, l = this.state.showArrows && this.state.firstItem < this.state.lastPosition, a = {}, I = -this.state.firstItem * (this.state.itemSize || 0), c = (0, l4.default)(I, "px", this.props.axis), d = this.props.transitionTime + "ms";
      return a = {
        WebkitTransform: c,
        MozTransform: c,
        MsTransform: c,
        OTransform: c,
        transform: c,
        msTransform: c,
        WebkitTransitionDuration: d,
        MozTransitionDuration: d,
        MsTransitionDuration: d,
        OTransitionDuration: d,
        transitionDuration: d,
        msTransitionDuration: d
      }, /* @__PURE__ */ ps.default.createElement("div", {
        className: mC.default.CAROUSEL(!1)
      }, /* @__PURE__ */ ps.default.createElement("div", {
        className: mC.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ ps.default.createElement("button", {
        type: "button",
        className: mC.default.ARROW_PREV(!o),
        onClick: function() {
          return r.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), g ? /* @__PURE__ */ ps.default.createElement(ojt.default, {
        tagName: "ul",
        className: mC.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: a,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ ps.default.createElement("ul", {
        className: mC.default.SLIDER(!1, this.state.swiping),
        ref: function(A) {
          return r.setItemsListRef(A);
        },
        style: a
      }, this.renderItems()), /* @__PURE__ */ ps.default.createElement("button", {
        type: "button",
        className: mC.default.ARROW_NEXT(!l),
        onClick: function() {
          return r.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), i;
}(ps.Component);
yG.default = tL;
eo(tL, "displayName", "Thumbs");
eo(tL, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var iR = {};
Object.defineProperty(iR, "__esModule", {
  value: !0
});
iR.default = void 0;
var bjt = function() {
  return document;
};
iR.default = bjt;
var Yl = {};
Object.defineProperty(Yl, "__esModule", {
  value: !0
});
Yl.setPosition = Yl.getPosition = Yl.isKeyboardEvent = Yl.defaultStatusFormatter = Yl.noop = void 0;
var hjt = De, mjt = pjt(gp);
function pjt(e) {
  return e && e.__esModule ? e : { default: e };
}
var Bjt = function() {
};
Yl.noop = Bjt;
var fjt = function(t, i) {
  return "".concat(t, " of ").concat(i);
};
Yl.defaultStatusFormatter = fjt;
var Zjt = function(t) {
  return t ? t.hasOwnProperty("key") : !1;
};
Yl.isKeyboardEvent = Zjt;
var Gjt = function(t, i) {
  if (i.infiniteLoop && ++t, t === 0)
    return 0;
  var n = hjt.Children.count(i.children);
  if (i.centerMode && i.axis === "horizontal") {
    var r = -t * i.centerSlidePercentage, g = n - 1;
    return t && (t !== g || i.infiniteLoop) ? r += (100 - i.centerSlidePercentage) / 2 : t === g && (r += 100 - i.centerSlidePercentage), r;
  }
  return -t * 100;
};
Yl.getPosition = Gjt;
var yjt = function(t, i) {
  var n = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(r) {
    n[r] = (0, mjt.default)(t, "%", i);
  }), n;
};
Yl.setPosition = yjt;
var AI = {};
Object.defineProperty(AI, "__esModule", {
  value: !0
});
AI.fadeAnimationHandler = AI.slideStopSwipingHandler = AI.slideSwipeAnimationHandler = AI.slideAnimationHandler = void 0;
var toe = De, Wjt = Sjt(gp), bI = Yl;
function Sjt(e) {
  return e && e.__esModule ? e : { default: e };
}
function a4(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function FC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? a4(Object(i), !0).forEach(function(n) {
      Vjt(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : a4(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Vjt(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var wjt = function(t, i) {
  var n = {}, r = i.selectedItem, g = r, o = toe.Children.count(t.children) - 1, l = t.infiniteLoop && (r < 0 || r > o);
  if (l)
    return g < 0 ? t.centerMode && t.centerSlidePercentage && t.axis === "horizontal" ? n.itemListStyle = (0, bI.setPosition)(-(o + 2) * t.centerSlidePercentage - (100 - t.centerSlidePercentage) / 2, t.axis) : n.itemListStyle = (0, bI.setPosition)(-(o + 2) * 100, t.axis) : g > o && (n.itemListStyle = (0, bI.setPosition)(0, t.axis)), n;
  var a = (0, bI.getPosition)(r, t), I = (0, Wjt.default)(a, "%", t.axis), c = t.transitionTime + "ms";
  return n.itemListStyle = {
    WebkitTransform: I,
    msTransform: I,
    OTransform: I,
    transform: I
  }, i.swiping || (n.itemListStyle = FC(FC({}, n.itemListStyle), {}, {
    WebkitTransitionDuration: c,
    MozTransitionDuration: c,
    OTransitionDuration: c,
    transitionDuration: c,
    msTransitionDuration: c
  })), n;
};
AI.slideAnimationHandler = wjt;
var vjt = function(t, i, n, r) {
  var g = {}, o = i.axis === "horizontal", l = toe.Children.count(i.children), a = 0, I = (0, bI.getPosition)(n.selectedItem, i), c = i.infiniteLoop ? (0, bI.getPosition)(l - 1, i) - 100 : (0, bI.getPosition)(l - 1, i), d = o ? t.x : t.y, C = d;
  I === a && d > 0 && (C = 0), I === c && d < 0 && (C = 0);
  var A = I + 100 / (n.itemSize / C), b = Math.abs(d) > i.swipeScrollTolerance;
  return i.infiniteLoop && b && (n.selectedItem === 0 && A > -100 ? A -= l * 100 : n.selectedItem === l - 1 && A < -l * 100 && (A += l * 100)), (!i.preventMovementUntilSwipeScrollTolerance || b || n.swipeMovementStarted) && (n.swipeMovementStarted || r({
    swipeMovementStarted: !0
  }), g.itemListStyle = (0, bI.setPosition)(A, i.axis)), b && !n.cancelClick && r({
    cancelClick: !0
  }), g;
};
AI.slideSwipeAnimationHandler = vjt;
var Rjt = function(t, i) {
  var n = (0, bI.getPosition)(i.selectedItem, t), r = (0, bI.setPosition)(n, t.axis);
  return {
    itemListStyle: r
  };
};
AI.slideStopSwipingHandler = Rjt;
var Xjt = function(t, i) {
  var n = t.transitionTime + "ms", r = "ease-in-out", g = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: r,
    msTransitionTimingFunction: r,
    MozTransitionTimingFunction: r,
    WebkitTransitionTimingFunction: r,
    OTransitionTimingFunction: r
  };
  return i.swiping || (g = FC(FC({}, g), {}, {
    WebkitTransitionDuration: n,
    MozTransitionDuration: n,
    OTransitionDuration: n,
    transitionDuration: n,
    msTransitionDuration: n
  })), {
    slideStyle: g,
    selectedStyle: FC(FC({}, g), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: FC({}, g)
  };
};
AI.fadeAnimationHandler = Xjt;
Object.defineProperty($1, "__esModule", {
  value: !0
});
$1.default = void 0;
var Sn = Yjt(De), Hjt = SG(eL), mc = SG(GG), kjt = SG(yG), eV = SG(iR), tV = SG(WG), LB = Yl, r2 = AI;
function SG(e) {
  return e && e.__esModule ? e : { default: e };
}
function ioe() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return ioe = function() {
    return e;
  }, e;
}
function Yjt(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || pf(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = ioe();
  if (t && t.has(e))
    return t.get(e);
  var i = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var g = n ? Object.getOwnPropertyDescriptor(e, r) : null;
      g && (g.get || g.set) ? Object.defineProperty(i, r, g) : i[r] = e[r];
    }
  return i.default = e, t && t.set(e, i), i;
}
function pf(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pf = function(i) {
    return typeof i;
  } : pf = function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, pf(e);
}
function GD() {
  return GD = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
    }
    return e;
  }, GD.apply(this, arguments);
}
function s4(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Bs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s4(Object(i), !0).forEach(function(n) {
      Ki(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : s4(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Fjt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function xjt(e, t) {
  for (var i = 0; i < t.length; i++) {
    var n = t[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Djt(e, t, i) {
  return t && xjt(e.prototype, t), e;
}
function Jjt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && yD(e, t);
}
function yD(e, t) {
  return yD = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, yD(e, t);
}
function Ejt(e) {
  var t = Ljt();
  return function() {
    var n = g2(e), r;
    if (t) {
      var g = g2(this).constructor;
      r = Reflect.construct(n, arguments, g);
    } else
      r = n.apply(this, arguments);
    return Njt(this, r);
  };
}
function Njt(e, t) {
  return t && (pf(t) === "object" || typeof t == "function") ? t : zi(e);
}
function zi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ljt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function g2(e) {
  return g2 = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, g2(e);
}
function Ki(e, t, i) {
  return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
var iL = /* @__PURE__ */ function(e) {
  Jjt(i, e);
  var t = Ejt(i);
  function i(n) {
    var r;
    Fjt(this, i), r = t.call(this, n), Ki(zi(r), "thumbsRef", void 0), Ki(zi(r), "carouselWrapperRef", void 0), Ki(zi(r), "listRef", void 0), Ki(zi(r), "itemsRef", void 0), Ki(zi(r), "timer", void 0), Ki(zi(r), "animationHandler", void 0), Ki(zi(r), "setThumbsRef", function(o) {
      r.thumbsRef = o;
    }), Ki(zi(r), "setCarouselWrapperRef", function(o) {
      r.carouselWrapperRef = o;
    }), Ki(zi(r), "setListRef", function(o) {
      r.listRef = o;
    }), Ki(zi(r), "setItemsRef", function(o, l) {
      r.itemsRef || (r.itemsRef = []), r.itemsRef[l] = o;
    }), Ki(zi(r), "autoPlay", function() {
      Sn.Children.count(r.props.children) <= 1 || (r.clearAutoPlay(), r.props.autoPlay && (r.timer = setTimeout(function() {
        r.increment();
      }, r.props.interval)));
    }), Ki(zi(r), "clearAutoPlay", function() {
      r.timer && clearTimeout(r.timer);
    }), Ki(zi(r), "resetAutoPlay", function() {
      r.clearAutoPlay(), r.autoPlay();
    }), Ki(zi(r), "stopOnHover", function() {
      r.setState({
        isMouseEntered: !0
      }, r.clearAutoPlay);
    }), Ki(zi(r), "startOnLeave", function() {
      r.setState({
        isMouseEntered: !1
      }, r.autoPlay);
    }), Ki(zi(r), "isFocusWithinTheCarousel", function() {
      return r.carouselWrapperRef ? !!((0, eV.default)().activeElement === r.carouselWrapperRef || r.carouselWrapperRef.contains((0, eV.default)().activeElement)) : !1;
    }), Ki(zi(r), "navigateWithKeyboard", function(o) {
      if (r.isFocusWithinTheCarousel()) {
        var l = r.props.axis, a = l === "horizontal", I = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, c = a ? I.ArrowRight : I.ArrowDown, d = a ? I.ArrowLeft : I.ArrowUp;
        c === o.keyCode ? r.increment() : d === o.keyCode && r.decrement();
      }
    }), Ki(zi(r), "updateSizes", function() {
      if (!(!r.state.initialized || !r.itemsRef || r.itemsRef.length === 0)) {
        var o = r.props.axis === "horizontal", l = r.itemsRef[0];
        if (l) {
          var a = o ? l.clientWidth : l.clientHeight;
          r.setState({
            itemSize: a
          }), r.thumbsRef && r.thumbsRef.updateSizes();
        }
      }
    }), Ki(zi(r), "setMountState", function() {
      r.setState({
        hasMount: !0
      }), r.updateSizes();
    }), Ki(zi(r), "handleClickItem", function(o, l) {
      if (Sn.Children.count(r.props.children) !== 0) {
        if (r.state.cancelClick) {
          r.setState({
            cancelClick: !1
          });
          return;
        }
        r.props.onClickItem(o, l), o !== r.state.selectedItem && r.setState({
          selectedItem: o
        });
      }
    }), Ki(zi(r), "handleOnChange", function(o, l) {
      Sn.Children.count(r.props.children) <= 1 || r.props.onChange(o, l);
    }), Ki(zi(r), "handleClickThumb", function(o, l) {
      r.props.onClickThumb(o, l), r.moveTo(o);
    }), Ki(zi(r), "onSwipeStart", function(o) {
      r.setState({
        swiping: !0
      }), r.props.onSwipeStart(o);
    }), Ki(zi(r), "onSwipeEnd", function(o) {
      r.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), r.props.onSwipeEnd(o), r.clearAutoPlay(), r.state.autoPlay && r.autoPlay();
    }), Ki(zi(r), "onSwipeMove", function(o, l) {
      r.props.onSwipeMove(l);
      var a = r.props.swipeAnimationHandler(o, r.props, r.state, r.setState.bind(zi(r)));
      return r.setState(Bs({}, a)), !!Object.keys(a).length;
    }), Ki(zi(r), "decrement", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      r.moveTo(r.state.selectedItem - (typeof o == "number" ? o : 1));
    }), Ki(zi(r), "increment", function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      r.moveTo(r.state.selectedItem + (typeof o == "number" ? o : 1));
    }), Ki(zi(r), "moveTo", function(o) {
      if (typeof o == "number") {
        var l = Sn.Children.count(r.props.children) - 1;
        o < 0 && (o = r.props.infiniteLoop ? l : 0), o > l && (o = r.props.infiniteLoop ? 0 : l), r.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: o
        }), r.state.autoPlay && r.state.isMouseEntered === !1 && r.resetAutoPlay();
      }
    }), Ki(zi(r), "onClickNext", function() {
      r.increment(1);
    }), Ki(zi(r), "onClickPrev", function() {
      r.decrement(1);
    }), Ki(zi(r), "onSwipeForward", function() {
      r.increment(1), r.props.emulateTouch && r.setState({
        cancelClick: !0
      });
    }), Ki(zi(r), "onSwipeBackwards", function() {
      r.decrement(1), r.props.emulateTouch && r.setState({
        cancelClick: !0
      });
    }), Ki(zi(r), "changeItem", function(o) {
      return function(l) {
        (!(0, LB.isKeyboardEvent)(l) || l.key === "Enter") && r.moveTo(o);
      };
    }), Ki(zi(r), "selectItem", function(o) {
      r.setState(Bs({
        previousItem: r.state.selectedItem
      }, o), function() {
        r.setState(r.animationHandler(r.props, r.state));
      }), r.handleOnChange(o.selectedItem, Sn.Children.toArray(r.props.children)[o.selectedItem]);
    }), Ki(zi(r), "getInitialImage", function() {
      var o = r.props.selectedItem, l = r.itemsRef && r.itemsRef[o], a = l && l.getElementsByTagName("img") || [];
      return a[0];
    }), Ki(zi(r), "getVariableItemHeight", function(o) {
      var l = r.itemsRef && r.itemsRef[o];
      if (r.state.hasMount && l && l.children.length) {
        var a = l.children[0].getElementsByTagName("img") || [];
        if (a.length > 0) {
          var I = a[0];
          if (!I.complete) {
            var c = function A() {
              r.forceUpdate(), I.removeEventListener("load", A);
            };
            I.addEventListener("load", c);
          }
        }
        var d = a[0] || l.children[0], C = d.clientHeight;
        return C > 0 ? C : null;
      }
      return null;
    });
    var g = {
      initialized: !1,
      previousItem: n.selectedItem,
      selectedItem: n.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: n.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return r.animationHandler = typeof n.animationHandler == "function" && n.animationHandler || n.animationHandler === "fade" && r2.fadeAnimationHandler || r2.slideAnimationHandler, r.state = Bs(Bs({}, g), r.animationHandler(n, g)), r;
  }
  return Djt(i, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, g) {
      !r.children && this.props.children && !this.state.initialized && this.setupCarousel(), !r.autoFocus && this.props.autoFocus && this.forceFocus(), g.swiping && !this.state.swiping && this.setState(Bs({}, this.props.stopSwipingHandler(this.props, this.state))), (r.selectedItem !== this.props.selectedItem || r.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), r.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var r = this;
      this.bindEvents(), this.state.autoPlay && Sn.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var g = r.getInitialImage();
        g && !g.complete ? g.addEventListener("load", r.setMountState) : r.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var r = this.carouselWrapperRef;
      this.props.stopOnHover && r && (r.addEventListener("mouseenter", this.stopOnHover), r.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var r = this.carouselWrapperRef;
      this.props.stopOnHover && r && (r.removeEventListener("mouseenter", this.stopOnHover), r.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, tV.default)().addEventListener("resize", this.updateSizes), (0, tV.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, eV.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, tV.default)().removeEventListener("resize", this.updateSizes), (0, tV.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var r = this.getInitialImage();
      r && r.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, eV.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var r;
      (r = this.carouselWrapperRef) === null || r === void 0 || r.focus();
    }
  }, {
    key: "renderItems",
    value: function(r) {
      var g = this;
      return this.props.children ? Sn.Children.map(this.props.children, function(o, l) {
        var a = l === g.state.selectedItem, I = l === g.state.previousItem, c = a && g.state.selectedStyle || I && g.state.prevStyle || g.state.slideStyle || {};
        g.props.centerMode && g.props.axis === "horizontal" && (c = Bs(Bs({}, c), {}, {
          minWidth: g.props.centerSlidePercentage + "%"
        })), g.state.swiping && g.state.swipeMovementStarted && (c = Bs(Bs({}, c), {}, {
          pointerEvents: "none"
        }));
        var d = {
          ref: function(A) {
            return g.setItemsRef(A, l);
          },
          key: "itemKey" + l + (r ? "clone" : ""),
          className: mc.default.ITEM(!0, l === g.state.selectedItem, l === g.state.previousItem),
          onClick: g.handleClickItem.bind(g, l, o),
          style: c
        };
        return /* @__PURE__ */ Sn.default.createElement("li", d, g.props.renderItem(o, {
          isSelected: l === g.state.selectedItem,
          isPrevious: l === g.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var r = this, g = this.props, o = g.showIndicators, l = g.labels, a = g.renderIndicator, I = g.children;
      return o ? /* @__PURE__ */ Sn.default.createElement("ul", {
        className: "control-dots"
      }, Sn.Children.map(I, function(c, d) {
        return a && a(r.changeItem(d), d === r.state.selectedItem, d, l.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ Sn.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, Sn.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || Sn.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ Sn.default.createElement(kjt.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var r = this;
      if (!this.props.children || Sn.Children.count(this.props.children) === 0)
        return null;
      var g = this.props.swipeable && Sn.Children.count(this.props.children) > 1, o = this.props.axis === "horizontal", l = this.props.showArrows && Sn.Children.count(this.props.children) > 1, a = l && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, I = l && (this.state.selectedItem < Sn.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, c = this.renderItems(!0), d = c.shift(), C = c.pop(), A = {
        className: mc.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, b = {};
      if (o) {
        if (A.onSwipeLeft = this.onSwipeForward, A.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var m = this.getVariableItemHeight(this.state.selectedItem);
          b.height = m || "auto";
        }
      } else
        A.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, A.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, A.style = Bs(Bs({}, A.style), {}, {
          height: this.state.itemSize
        }), b.height = this.state.itemSize;
      return /* @__PURE__ */ Sn.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: mc.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ Sn.default.createElement("div", {
        className: mc.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, a, this.props.labels.leftArrow), /* @__PURE__ */ Sn.default.createElement("div", {
        className: mc.default.WRAPPER(!0, this.props.axis),
        style: b
      }, g ? /* @__PURE__ */ Sn.default.createElement(Hjt.default, GD({
        tagName: "ul",
        innerRef: this.setListRef
      }, A, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && C, this.renderItems(), this.props.infiniteLoop && d) : /* @__PURE__ */ Sn.default.createElement("ul", {
        className: mc.default.SLIDER(!0, this.state.swiping),
        ref: function(B) {
          return r.setListRef(B);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && C, this.renderItems(), this.props.infiniteLoop && d)), this.props.renderArrowNext(this.onClickNext, I, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), i;
}(Sn.default.Component);
$1.default = iL;
Ki(iL, "displayName", "Carousel");
Ki(iL, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: LB.noop,
  onClickThumb: LB.noop,
  onChange: LB.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(t, i, n) {
    return /* @__PURE__ */ Sn.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: mc.default.ARROW_PREV(!i),
      onClick: t
    });
  },
  renderArrowNext: function(t, i, n) {
    return /* @__PURE__ */ Sn.default.createElement("button", {
      type: "button",
      "aria-label": n,
      className: mc.default.ARROW_NEXT(!i),
      onClick: t
    });
  },
  renderIndicator: function(t, i, n, r) {
    return /* @__PURE__ */ Sn.default.createElement("li", {
      className: mc.default.DOT(i),
      onClick: t,
      onKeyDown: t,
      value: n,
      key: n,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(r, " ").concat(n + 1)
    });
  },
  renderItem: function(t) {
    return t;
  },
  renderThumbs: function(t) {
    var i = Sn.Children.map(t, function(n) {
      var r = n;
      if (n.type !== "img" && (r = Sn.Children.toArray(n.props.children).find(function(g) {
        return g.type === "img";
      })), !!r)
        return r;
    });
    return i.filter(function(n) {
      return n;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : i;
  },
  statusFormatter: LB.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: r2.slideSwipeAnimationHandler,
  stopSwipingHandler: r2.slideStopSwipingHandler
});
var Kjt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Carousel", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  }), Object.defineProperty(e, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return i.CarouselProps;
    }
  }), Object.defineProperty(e, "Thumbs", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  });
  var t = r($1), i = Kjt, n = r(yG);
  function r(g) {
    return g && g.__esModule ? g : { default: g };
  }
})(_ge);
function WD(e, t, i) {
  var n, r, g, o, l;
  t == null && (t = 100);
  function a() {
    var c = Date.now() - o;
    c < t && c >= 0 ? n = setTimeout(a, t - c) : (n = null, i || (l = e.apply(g, r), g = r = null));
  }
  var I = function() {
    g = this, r = arguments, o = Date.now();
    var c = i && !n;
    return n || (n = setTimeout(a, t)), c && (l = e.apply(g, r), g = r = null), l;
  };
  return I.clear = function() {
    n && (clearTimeout(n), n = null);
  }, I.flush = function() {
    n && (l = e.apply(g, r), g = r = null, clearTimeout(n), n = null);
  }, I;
}
WD.debounce = WD;
var Tjt = WD;
const I4 = /* @__PURE__ */ go(Tjt);
function Mjt(e) {
  let {
    debounce: t,
    scroll: i,
    polyfill: n,
    offsetSize: r
  } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
  };
  const g = n || (typeof window > "u" ? class {
  } : window.ResizeObserver);
  if (!g)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [o, l] = wt({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    bottom: 0,
    right: 0,
    x: 0,
    y: 0
  }), a = ot({
    element: null,
    scrollContainers: null,
    resizeObserver: null,
    lastBounds: o
  }), I = t ? typeof t == "number" ? t : t.scroll : null, c = t ? typeof t == "number" ? t : t.resize : null, d = ot(!1);
  lt(() => (d.current = !0, () => void (d.current = !1)));
  const [C, A, b] = Oe(() => {
    const f = () => {
      if (!a.current.element)
        return;
      const {
        left: Z,
        top: y,
        width: W,
        height: V,
        bottom: w,
        right: v,
        x: H,
        y: x
      } = a.current.element.getBoundingClientRect(), J = {
        left: Z,
        top: y,
        width: W,
        height: V,
        bottom: w,
        right: v,
        x: H,
        y: x
      };
      a.current.element instanceof HTMLElement && r && (J.height = a.current.element.offsetHeight, J.width = a.current.element.offsetWidth), Object.freeze(J), d.current && !Ojt(a.current.lastBounds, J) && l(a.current.lastBounds = J);
    };
    return [f, c ? I4(f, c) : f, I ? I4(f, I) : f];
  }, [l, r, I, c]);
  function m() {
    a.current.scrollContainers && (a.current.scrollContainers.forEach((f) => f.removeEventListener("scroll", b, !0)), a.current.scrollContainers = null), a.current.resizeObserver && (a.current.resizeObserver.disconnect(), a.current.resizeObserver = null);
  }
  function p() {
    a.current.element && (a.current.resizeObserver = new g(b), a.current.resizeObserver.observe(a.current.element), i && a.current.scrollContainers && a.current.scrollContainers.forEach((f) => f.addEventListener("scroll", b, {
      capture: !0,
      passive: !0
    })));
  }
  const B = (f) => {
    !f || f === a.current.element || (m(), a.current.element = f, a.current.scrollContainers = noe(f), p());
  };
  return Ujt(b, !!i), Pjt(A), lt(() => {
    m(), p();
  }, [i, b, A]), lt(() => m, []), [B, o, C];
}
function Pjt(e) {
  lt(() => {
    const t = e;
    return window.addEventListener("resize", t), () => void window.removeEventListener("resize", t);
  }, [e]);
}
function Ujt(e, t) {
  lt(() => {
    if (t) {
      const i = e;
      return window.addEventListener("scroll", i, {
        capture: !0,
        passive: !0
      }), () => void window.removeEventListener("scroll", i, !0);
    }
  }, [e, t]);
}
function noe(e) {
  const t = [];
  if (!e || e === document.body)
    return t;
  const {
    overflow: i,
    overflowX: n,
    overflowY: r
  } = window.getComputedStyle(e);
  return [i, n, r].some((g) => g === "auto" || g === "scroll") && t.push(e), [...t, ...noe(e.parentElement)];
}
const zjt = ["x", "y", "top", "bottom", "left", "right", "width", "height"], Ojt = (e, t) => zjt.every((i) => e[i] === t[i]), c4 = {
  position: "absolute",
  color: "primary.main",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 1,
  padding: 0
}, d4 = {
  width: "48px",
  height: "48px"
}, Qjt = De.forwardRef((e, t) => {
  const i = ie(G$), [n, r] = wt(0), g = Oe(() => i.slice().sort((c, d) => c.label > d.label ? 1 : -1).map((c) => c.url), [i]), o = Oe(() => JSON.stringify(g), [g]);
  lt(() => {
    r(0);
  }, [o]);
  const [l, a] = Mjt(), I = FE();
  return /* @__PURE__ */ S("div", { ref: l, style: {
    height: "100%",
    width: "auto"
  }, children: /* @__PURE__ */ S(_ge.Carousel, { swipeable: !0, showStatus: !1, infiniteLoop: !0, emulateTouch: !0, showThumbs: !1, selectedItem: n, onChange: (c) => r(c), renderArrowNext: (c, d, C) => d ? /* @__PURE__ */ S(Ni, { onClick: c, "data-cy": "showNext", sx: {
    ...c4,
    right: "16px"
  }, children: /* @__PURE__ */ S(xAt, { sx: d4 }) }) : null, renderArrowPrev: (c, d, C) => d ? /* @__PURE__ */ S(Ni, { onClick: c, "data-cy": "showPrevious", sx: {
    ...c4,
    left: "16px"
  }, children: /* @__PURE__ */ S(FAt, { sx: d4 }) }) : null, renderIndicator: (c, d) => /* @__PURE__ */ S(pi, { component: "li", className: Re("dot", d && "selected"), onClick: c, sx: {
    backgroundColor: I.palette.primary.main + "!important"
  } }), children: g.map((c, d) => /* @__PURE__ */ S("div", { style: {
    height: a.height,
    width: "100%",
    margin: "auto",
    // no interactions so swipe can occur instead of dragging the image
    pointerEvents: "none",
    backgroundImage: `url(${c})`,
    backgroundSize: "contain",
    objectFit: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  } }, d)) }) });
}), jjt = gr({
  app: {
    gallery: {
      root: !0
    }
  }
})(Qjt);
class qjt extends $d {
  constructor() {
    super(...arguments);
    Qi(this, "catchUnhandledRejectionErrors", !1);
  }
  componentDidUpdate(i) {
    this.state.error && JSON.stringify(i.template) !== JSON.stringify(this.props.template) && this.handleCloseError();
  }
  renderError(i) {
    return /* @__PURE__ */ S(ht, { component: "div", sx: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }, children: /* @__PURE__ */ Ie(Ct, { children: [
      "3D-Parsing-Error: Maybe something wrong with Custom-Scene-Setting?",
      " ",
      /* @__PURE__ */ S("br", {}),
      i.message
    ] }) });
  }
}
const _jt = (e, t) => e.size <= t.size && [...e].every((i) => t.has(i)), $jt = () => {
  const e = S4(), {
    scene: t
  } = RI(), i = ie(Rm), n = ot(), r = ot(-1), g = ot(), [, o] = wt(0);
  Le.equals(i, n.current) || (r.current = 1), dA(() => {
    if (!e.active && i !== n.current) {
      const c = new Set(i.map((A) => A.modelId)), d = /* @__PURE__ */ new Set();
      t.traverse((A) => {
        var m;
        const b = (m = A == null ? void 0 : A.userData) == null ? void 0 : m.modelId;
        b && d.add(b);
      });
      const C = !_jt(c, d);
      C ? g.current = void 0 : (n.current = i, g.current = [...d]), o(Math.random()), r.current = C ? 1 : 0;
    }
  });
  const l = e.active || r.current === 1, a = ie(u1), I = Ei();
  return lt(() => {
    l !== a && (I(F7(l)), I(Jct(l ? void 0 : g.current)), l || I(H7({
      component: "K3DSceneLoaded",
      value: !0
    })));
  }, [l, a]), l;
}, e6t = () => {
  const e = ie(p$), t = ie(u1);
  Oe(() => {
    if (t)
      return;
    const i = ZZt(), n = [];
    i == null || i.forEach((r) => {
      const g = parseInt((r == null ? void 0 : r.dataset.modelId) ?? "");
      if (!e.includes(g)) {
        const o = r.id, l = LC.get(o);
        l && n.push({
          konvaStage: l,
          canvasDiv: r
        });
      }
    }), n.forEach((r) => {
      const {
        konvaStage: g,
        canvasDiv: o
      } = r;
      LC.delete(o.id), g.destroy(), o.remove();
    });
  }, [e, t]);
}, t6t = () => ($jt(), e6t(), null), i6t = Ci([Og], (e) => e.some((t) => {
  const i = Vi(t);
  return (i == null ? void 0 : i.highlightHovered) ?? !1;
})), u4 = (e, t, i, n, r, g) => {
  const o = new fc(e.offsetX / t.domElement.clientWidth * 2 - 1, -(e.offsetY / t.domElement.clientHeight) * 2 + 1);
  r.setFromCamera(o, i);
  const l = n.getObjectByName("k3d");
  if (!l)
    return {};
  const a = r.intersectObjects(l.children, !0) ?? [];
  let I;
  for (const C of a) {
    let A = C.object;
    for (; A && !A.userData.modelActionUniqueId; )
      A = A.parent;
    if (A) {
      I = A;
      break;
    }
  }
  const c = g.find((C) => {
    var A;
    return C.unique === ((A = I == null ? void 0 : I.userData) == null ? void 0 : A.modelActionUniqueId);
  });
  if (!c)
    return {};
  const d = mg(c.anchoringSelection) ? c.anchoringSelection.id : qa(c.anchoringSelection);
  return d ? {
    instanceId: d,
    modelAction: c
  } : {};
};
function n6t() {
  const e = q9(), t = Ei(), {
    invalidate: i,
    raycaster: n,
    scene: r,
    camera: g,
    gl: o
  } = RI((f) => f), l = ie(i6t), a = ie(Rm), I = Tl((f) => f.hasHoveredSelection), c = Tl((f) => f.setHoveredSelection), d = Tl((f) => f.removeAllHoveredSelections), C = ie(Y6), A = ie(vc), b = Gt((f) => {
    if (f.buttons !== 0) {
      d(), i();
      return;
    }
    o.domElement.style.cursor = "unset";
    const {
      instanceId: Z,
      modelAction: y
    } = u4(f, o, g, r, n, a);
    if (!y || !Z) {
      d(), i();
      return;
    }
    const W = C[Z], V = A[W.variableId];
    Vi(V).highlightHovered && Z && y && (o.domElement.style.cursor = "pointer", I(Z) || (c(Z), i()));
  }, [g, o, I, i, a, n, d, r, C, c, A]), m = Oe(() => de.throttle(b, 50, {
    trailing: !1,
    leading: !0
  }), [b]), p = () => {
    m.cancel(), d();
  };
  lt(() => {
    const f = o.domElement;
    return e || f == null || f.addEventListener("mouseleave", p, {
      passive: !0
    }), () => f == null ? void 0 : f.removeEventListener("mouseleave", p);
  }), lt(() => {
    const f = o.domElement;
    return !e && l && (f == null || f.addEventListener("pointermove", m, {
      passive: !0
    })), () => f == null ? void 0 : f.removeEventListener("pointermove", m);
  });
  const B = Gt((f) => {
    const {
      instanceId: Z
    } = u4(f, o, g, r, n, a);
    Z && t(wr(Z));
  }, [g, t, o, a, n, r]);
  return lt(() => {
    if (!l)
      return;
    let f = 0;
    const Z = (V) => {
      f = V.timeStamp;
    }, y = (V) => {
      V.timeStamp - f < 500 && B(V);
    }, W = o.domElement;
    return W == null || W.addEventListener("mousedown", Z, {
      passive: !0
    }), W == null || W.addEventListener("mouseup", y, {
      passive: !0
    }), () => {
      W == null || W.removeEventListener("mousedown", Z), W == null || W.removeEventListener("mouseup", y);
    };
  }), null;
}
const r6t = () => ({
  canvasProps: {
    gl: {
      preserveDrawingBuffer: !0
    },
    camera: {
      near: 1e-3,
      fov: 35,
      position: [3, 2, 3]
    }
  },
  children: [
    {
      component: "OrbitControls",
      props: {
        maxPolarAngle: Math.PI / 2.1,
        makeDefault: !0
      }
    },
    {
      component: "ContactShadows",
      props: {
        resolution: 1024,
        position: [0, 0, 0],
        scale: 10,
        blur: 3,
        opacity: 1,
        far: 10
      }
    },
    {
      component: "Environment",
      props: {
        background: !1,
        files: pee("city")
      }
    },
    {
      component: "Sky",
      props: {
        distance: 45e3,
        sunPosition: [0, 1, 0],
        inclination: 1,
        azimuth: 0.1
      }
    },
    // TODO: Cam: We might be forced to remove the bounds
    {
      component: "Bounds",
      props: {
        margin: 1.3,
        damping: 10
      },
      children: [{
        component: "K3BoundsFocus",
        props: {
          animateOnMissed: !0,
          animate: !1
        },
        children: [{
          component: "K3D",
          props: {}
        }]
      }]
    }
  ]
}), g6t = () => ({
  canvasProps: {
    gl: {
      preserveDrawingBuffer: !0
    },
    camera: {
      near: 1e-3,
      fov: 35,
      position: [3, 2, 3]
    },
    style: {
      backgroundColor: "black"
    }
  },
  children: [{
    component: "OrbitControls",
    props: {
      maxPolarAngle: Math.PI / 2.1,
      makeDefault: !0
    }
  }, {
    component: "ContactShadows",
    props: {
      resolution: 1024,
      frames: 1,
      position: [0, 0, 0],
      scale: 10,
      blur: 3,
      opacity: 1,
      far: 10
    }
  }, {
    component: "Environment",
    props: {
      background: !1,
      files: pee("night")
    }
  }, {
    component: "Stars",
    props: {}
  }, {
    component: "K3BoundsFocus",
    props: {
      animateOnMissed: !0,
      animate: !1
    },
    children: [{
      component: "K3D",
      props: {}
    }]
  }]
}), o6t = [{
  name: "Default",
  template: r6t()
}, {
  name: "Night",
  template: g6t()
}], l6t = {
  K3D: KQt,
  K3BoundsFocus: YQt,
  K3Model: kw,
  Bounds: XQt
}, a6t = new Set(Object.keys(ir)), s6t = (e) => a6t.has(e) ? (t) => /* @__PURE__ */ S(e, { ...t }) : null, I6t = (e) => (console.error("unknown 3D component", e), () => /* @__PURE__ */ S("group", {})), c6t = (e) => (
  // @ts-ignore
  l6t[e] || // @ts-ignore
  xoe[e] || // @ts-ignore
  Voe[e] || // @ts-ignore
  Joe[e] || // @ts-ignore
  De[e] || s6t(e) || I6t(e)
), d6t = (e) => gr({
  app: {
    k3d: {
      sceneComponents: {
        [e]: {
          root: !0
        }
      }
    }
  }
})(c6t(e)), u6t = De.forwardRef((e, t) => /* @__PURE__ */ S(V4, { ...e, ref: t, frameloop: "demand", children: e.children })), C4 = {
  display: "flex",
  "justify-content": "center",
  "align-items": "center"
}, A4 = {
  border: "1px dashed black"
};
function b4(e, t, i) {
  if (!e || !e.domElement.parentElement)
    return {
      width: t,
      height: i
    };
  const n = e.domElement.parentElement.clientWidth, r = e.domElement.parentElement.clientHeight;
  let g = t, o = i;
  const l = t - n, a = i - r;
  return l > 0 && l > a ? (g = n, o = n / t * i) : a > 0 && a > l && (o = r, g = r / i * t), {
    width: g,
    height: o
  };
}
function roe(e, t) {
  const i = e.fov * Math.PI / 180;
  return Math.tan(i / 2) * t * 2;
}
function C6t(e, t) {
  return roe(e, t) * e.aspect;
}
function A6t(e, t) {
  const i = new W4(void 0, t);
  return i.position.copy(e.position), i.quaternion.copy(e.quaternion), i.updateProjectionMatrix(), i.updateMatrixWorld(), i;
}
const b6t = (e, t) => {
  const i = roe(e, t), n = C6t(e, t), r = new Ix(-n / 2, n / 2, i / 2, -i / 2, 1e-3, 1e3);
  return r.position.copy(e.position), r.quaternion.copy(e.quaternion), r.updateProjectionMatrix(), r.updateMatrixWorld(), r;
};
function h6t(e, t, i) {
  return !t || t.type === e.type || ((t == null ? void 0 : t.type) === "PerspectiveCamera" ? e = A6t(e, i) : (t == null ? void 0 : t.type) === "OrthographicCamera" && (e = b6t(e, e.position.length()))), e;
}
const m6t = () => {
  var c, d, C, A;
  const e = RI(), {
    controls: t,
    gl: i
  } = e, n = ie(qN), r = ((c = n == null ? void 0 : n.scope) == null ? void 0 : c.type) === "general" ? Fa.width : e.size.width ?? Fa.width, g = ((d = n == null ? void 0 : n.scope) == null ? void 0 : d.type) === "general" ? Fa.height : e.size.height ?? Fa.height, o = ((C = n == null ? void 0 : n.resolution) == null ? void 0 : C.width) ?? r, l = ((A = n == null ? void 0 : n.resolution) == null ? void 0 : A.height) ?? g, a = o / l, I = ie(xWe);
  return lt(
    () => {
      var y;
      const b = e.camera.clone(!0), m = e.controls;
      (y = m == null ? void 0 : m.saveState) == null || y.call(m);
      const {
        width: p,
        height: B
      } = b4(i, o, l);
      i.setSize(p, B), i.render(e.scene, e.camera), n != null && n.position && (n != null && n.rotation) && Tge(n, e, I, !0), i.render(e.scene, e.camera);
      const f = Object.keys(C4).reduce((W, V) => {
        var w;
        return W[V] = (w = i.domElement.parentElement) == null ? void 0 : w.style.getPropertyValue(V), W;
      }, {}), Z = Object.keys(A4).reduce((W, V) => (W[V] = i.domElement.style.getPropertyValue(V), W), {});
      return () => {
        var w, v;
        const W = e.controls;
        e.set({
          camera: b
        }), e.camera.updateProjectionMatrix(), e.camera.updateMatrixWorld(), W && (W.object = b, e.set({
          controls: W
        }), (w = W == null ? void 0 : W.reset) == null || w.call(W), (v = W == null ? void 0 : W.update) == null || v.call(W));
        const V = i.domElement.parentElement;
        V && (f && Object.entries(f).forEach(([H, x]) => {
          V.style.setProperty(H, x);
        }), Z && Object.entries(Z).forEach(([H, x]) => {
          i.domElement.style.setProperty(H, x);
        }), i.setSize(V.clientWidth, V.clientHeight)), i.render(e.scene, e.camera);
      };
    },
    // This should only run once. So there are no dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), dA(() => {
    if (!n)
      return;
    if (n.type !== e.camera.type) {
      const m = h6t(e.camera, n, a);
      e.camera = m;
    }
    if (UZ(e.camera))
      e.camera.aspect = o / l;
    else if (dE(e.camera)) {
      const m = o / l;
      e.camera.left = m * e.camera.bottom, e.camera.right = m * e.camera.top;
    }
    if (e.camera.updateProjectionMatrix(), e.camera.updateMatrixWorld(), i.domElement.parentElement) {
      const {
        width: m,
        height: p
      } = b4(i, o, l);
      Object.entries(C4).forEach(([B, f]) => {
        var Z, y;
        (y = (Z = i.domElement) == null ? void 0 : Z.parentElement) == null || y.style.setProperty(B, f);
      }), Object.entries(A4).forEach(([B, f]) => {
        i.domElement.style.setProperty(B, f);
      }), i.setSize(m - 16, p - 16);
    }
    const b = t;
    b != null && b.object && (b.object = e.camera), i.render(e.scene, e.camera);
  }), /* @__PURE__ */ S("group", {});
}, p6t = () => ie(qN) ? /* @__PURE__ */ S(m6t, {}) : null, B6t = ({
  child: e
}) => {
  const t = Oe(() => d6t(e.component), [e.component]);
  return /* @__PURE__ */ S(t, { ...e.props, children: /* @__PURE__ */ S(goe, { sceneChildren: e.children }) });
}, goe = (e) => {
  const t = e.sceneChildren || [];
  return /* @__PURE__ */ S(li, { children: t.map((i, n) => /* @__PURE__ */ S(B6t, { child: i }, `${i.component}_${n}`)) });
}, ooe = (e = [], t = "", i) => e.map((n) => n.component == t ? i : {
  ...n,
  children: ooe(n.children, t, i)
}).filter((n) => n), f6t = De.forwardRef((e, t) => {
  const i = ie(Pi), n = ie(d1), r = Oe(() => i != null && i.env ? i.env.template : o6t[0].template, [i]), g = Oe(() => e.K3DReplace ? ooe(r.children, "K3D", e.K3DReplace) : r.children, [e.K3DReplace, r.children]);
  return /* @__PURE__ */ S(qjt, { template: r, children: /* @__PURE__ */ S(
    DQt,
    {
      canvas: u6t,
      canvasProps: {
        ...r.canvasProps,
        ref: t
      },
      children: /* @__PURE__ */ Ie(fm, { fallback: /* @__PURE__ */ S(Oge, {}), children: [
        n && /* @__PURE__ */ S("axesHelper", { args: [5] }),
        !sl.disable3D && /* @__PURE__ */ Ie(li, { children: [
          /* @__PURE__ */ S(goe, { sceneChildren: g }),
          /* @__PURE__ */ S(t6t, {}),
          /* @__PURE__ */ S(n6t, {}),
          /* @__PURE__ */ S(p6t, {})
        ] }),
        e.children
      ] })
    }
  ) });
}), Z6t = gr({
  app: {
    k3d: {
      root: !0
    }
  }
})(f6t), G6t = ({
  app: e
}) => {
  switch (e == null ? void 0 : e.stage) {
    case Df._3D:
      return /* @__PURE__ */ S(Z6t, {});
    case Df.GALLERY:
      return /* @__PURE__ */ S(jjt, {});
    default:
      return null;
  }
}, y6t = (e) => {
  var t, i;
  return ((i = (t = e == null ? void 0 : e.palette) == null ? void 0 : t.content) == null ? void 0 : i.main) || "white";
}, W6t = ({
  app: e,
  children: t
}) => {
  const i = FE(), n = ie(JWe(e)), r = ie(N6);
  return /* @__PURE__ */ Ie(ht, { component: "div", sx: {
    ...sx.content,
    ...n ? sx.content2d : sx.content3d,
    backgroundColor: y6t(i),
    ...r ? S6t : {}
  }, children: [
    r ? /* @__PURE__ */ S(ht, { component: "div", sx: V6t, "data-cy": "fullscreenOverlays", children: /* @__PURE__ */ S(jQt, {}) }) : null,
    /* @__PURE__ */ S(G6t, { app: e }),
    t
  ] });
}, jei = gr({
  app: {
    contentView: {
      root: !0
    }
  }
})(W6t), S6t = {
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 5
}, V6t = {
  position: "absolute",
  top: 16,
  right: 16,
  zIndex: 1001
}, sx = {
  content: {
    position: "relative",
    width: 1,
    height: 1
  },
  content3d: {},
  content2d: {
    backgroundColor: "#BBBBBB"
  }
};
function w6t({
  showEditor: e,
  isAdmin: t,
  openLink: i,
  logoUrl: n,
  logoSize: r,
  logoOpacity: g,
  link: o
}) {
  const l = ZA();
  return /* @__PURE__ */ Ie(pi, { direction: "row", spacing: 2, sx: {
    alignItems: "center",
    cursor: o ? "pointer" : "default"
  }, children: [
    n && /* @__PURE__ */ S(ht, { component: "div", sx: {
      width: r
    }, onClick: i, children: /* @__PURE__ */ S("img", { style: {
      height: "auto",
      width: r,
      boxSizing: "border-box",
      opacity: g
    }, alt: "logo", src: n, "data-cy": "logoImage" }) }),
    e && t && /* @__PURE__ */ S(b_, { "data-cy": "editLogoButton", tooltip: Ug("Ändern Sie das Logo"), onClick: () => l("../logo") })
  ] });
}
const nR = (e) => {
  var t, i, n;
  return (n = (i = (t = e == null ? void 0 : e.settings) == null ? void 0 : t.ext) == null ? void 0 : i.theme) == null ? void 0 : n.logo;
}, qei = (e) => {
  var t;
  return ((t = nR(e)) == null ? void 0 : t.link) || "";
}, v6t = (e) => {
  var i;
  const t = ((i = nR(e)) == null ? void 0 : i.link) || "";
  return !t || t.startsWith("http") ? t : `https://${t}`;
}, R6t = (e) => {
  var t;
  return ((t = nR(e)) == null ? void 0 : t.opacity) || 0.75;
}, X6t = (e) => {
  var i;
  const t = (i = nR(e)) == null ? void 0 : i.size;
  return t ? +t : 200;
}, h4 = (e) => {
  var t;
  return (t = e == null ? void 0 : e.settings) == null ? void 0 : t.logo;
}, _ei = ({
  app: e
}) => {
  var l, a;
  const t = (a = (l = ie(Vv)) == null ? void 0 : l.apps) == null ? void 0 : a.find((I) => I.appId == e.id), i = t && h4(t) ? t : e, n = h4(i) || "", r = X6t(i), g = R6t(i), o = v6t(i);
  return /* @__PURE__ */ S(k6t, { logoUrl: n, logoSize: r, logoOpacity: g, link: o });
}, H6t = ({
  logoUrl: e,
  logoSize: t,
  logoOpacity: i,
  link: n
}) => {
  const {
    t: r
  } = Gi(), g = ie($r), o = ie(SA);
  return /* @__PURE__ */ S(w6t, { logoUrl: e, logoSize: t, logoOpacity: i, link: n, t: r, showEditor: g, isAdmin: o, openLink: () => {
    n && window.open(n, "_blank");
  } });
}, k6t = gr({
  app: {
    logo: {
      root: !0
    }
  }
})(H6t);
var nL = {}, Y6t = yg;
Object.defineProperty(nL, "__esModule", {
  value: !0
});
var loe = nL.default = void 0, F6t = Y6t(oo()), x6t = ro;
loe = nL.default = (0, F6t.default)(/* @__PURE__ */ (0, x6t.jsx)("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning");
const D6t = (e) => async (t) => (t(_ct(e)), Q9("ruleitem", e));
function $ei() {
  const e = ie(MGt), t = ie(Rc), i = ie(d1), n = ie(KZ), r = ie($r), g = ie(Pi), o = Ei(), l = Gi().t, a = Dm(), I = ie(Rm), c = () => {
    a.resetQueries(["metadata"]), o(WT()), o(SY(!1));
  }, d = (m) => t.find((p) => {
    var B, f;
    return Number(m.ruleItemId) == (p == null ? void 0 : p.id) && (m == null ? void 0 : m.modelId) == ((f = (B = Object.values((p == null ? void 0 : p.values) ?? [])) == null ? void 0 : B.find((Z) => cw(Z) && (Z == null ? void 0 : Z.modelId))) == null ? void 0 : f.modelId);
  }), C = (m) => I.find((p) => {
    var B;
    return (m.ruleItemId === "main" ? !p.ruleItem : ((B = p.ruleItem) == null ? void 0 : B.id) === +m.ruleItemId) && p.model.id === m.modelId;
  }), A = Oe(() => Object.entries(e).flatMap(([m, p]) => {
    const B = C(p);
    if (!B)
      return [];
    const f = B.model.dynamicModelKey ? jf().find((V) => V.type === B.model.dynamicModelKey) : void 0, y = ((f == null ? void 0 : f.repositionApplicator) || Sc)("number")(B.props, B.expressionProps)(p.position, p.rotation) ?? {};
    return Object.entries(B.props).flatMap(([V, w]) => {
      const v = de.isArray(w), H = v ? w : [w], x = de.isArray(y[V]) ? y[V] : [y[V]], J = de.isArray(B.expressionProps[V]) ? B.expressionProps[V] : [B.expressionProps[V]];
      return H.map((K, M) => de.isNumber(K) && K !== x[M] && wbt(J[M]) ? v && w.length === 3 ? `${"XYZ"[M]}-${V}` : V : null).filter(Boolean);
    }).map((V) => ({
      message: `Derzeit wird eine Expression genutzt, um die ${V} des Modells ${B.model.label} zu setzen. Diese wird überschrieben.`
    }));
  }), [e]);
  function b() {
    return async () => {
      const m = Object.entries(e).map(async ([p, B]) => {
        const f = C(B);
        if (!f)
          return;
        const Z = f.model.dynamicModelKey ? jf().find((V) => V.type === f.model.dynamicModelKey) : void 0, W = ((Z == null ? void 0 : Z.repositionApplicator) || Sc)("expression")(f.props, f.expressionProps)(B.position, B.rotation);
        if (p == "main") {
          const V = de.cloneDeep(n.find((w) => w.id == B.modelId));
          if (!V)
            return;
          V.props = {
            ...V.props,
            ...W
          }, await o(f5(V));
        } else {
          const V = de.cloneDeep(d(B));
          if (!V)
            return;
          const w = Object.values(V.values).find((v) => cw(v) && v.modelId);
          if (!w)
            return;
          w.props = {
            ...w.props,
            ...W
          }, await o(D6t(V));
        }
      });
      await Promise.all(m), o(SY(!1)), o(WT());
    };
  }
  return !r || g.stage !== "3D" ? null : /* @__PURE__ */ Ie(pi, { spacing: 1, sx: {
    zIndex: 500
  }, children: [
    /* @__PURE__ */ S(fn, { "data-cy": "edit-positions", onClick: () => o(SY(!i)), startIcon: /* @__PURE__ */ S(TAt, {}), variant: "outlined", className: "edit-positions-btn k3-btn k3-mode-button k3-secondary-btn", children: l("Positionen ändern") }),
    i && /* @__PURE__ */ Ie(pi, { direction: "row", sx: {
      justifyContent: "space-around"
    }, children: [
      !!A.length && /* @__PURE__ */ S(Tn, { title: /* @__PURE__ */ Ie(pi, { children: [
        A.map((m) => /* @__PURE__ */ S(Ct, { mb: 2, children: m.message }, m.message)),
        /* @__PURE__ */ S(Ct, { children: l("Abbrechen durch Klick") })
      ] }), children: /* @__PURE__ */ S(Ni, { "data-cy": "cancel-scene-positions", color: "error", onClick: () => c(), children: /* @__PURE__ */ S(loe, { className: "changeWarning", color: "error" }) }) }),
      /* @__PURE__ */ S(Tn, { title: l("cancel"), children: /* @__PURE__ */ S(Ni, { "data-cy": "cancel-scene-positions", color: "error", onClick: () => c(), children: /* @__PURE__ */ S(NAt, {}) }) }),
      /* @__PURE__ */ S(Tn, { title: l("Speichern"), children: /* @__PURE__ */ S(Ni, { "data-cy": "save-scene-positions", color: "primary", onClick: b(), children: /* @__PURE__ */ S(rbt, {}) }) })
    ] })
  ] });
}
var rL = {}, J6t = yg;
Object.defineProperty(rL, "__esModule", {
  value: !0
});
var aoe = rL.default = void 0, E6t = J6t(oo()), N6t = ro;
aoe = rL.default = (0, E6t.default)(/* @__PURE__ */ (0, N6t.jsx)("path", {
  d: "m18.25 7.6-5.5-3.18c-.46-.27-1.04-.27-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3M7 14.96v-4.62l4 2.32v4.61zm5-4.03L8 8.61l4-2.31 4 2.31zm1 6.34v-4.61l4-2.32v4.62zM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3zM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3z"
}), "ViewInAr");
var L6t = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.DESKTOP = 1] = "DESKTOP", e[e.IOS = 2] = "IOS", e[e.ANDROID = 3] = "ANDROID", e))(L6t || {});
const K6t = () => {
  var r;
  const e = Vg(), t = zWt(), i = ie(Pi), n = e(Mi.AR_BUTTON);
  return /* @__PURE__ */ S(li, { children: i.stage === "3D" && /* @__PURE__ */ Ie(pi, { direction: "row", children: [
    /* @__PURE__ */ S(Tn, { title: n, children: /* @__PURE__ */ S(qge, { "data-cy": "dynAR", onClick: t, className: "ar-button k3-btn k3-mode-button", variant: "contained", fullWidth: !0, startIcon: /* @__PURE__ */ S(aoe, {}), disabled: !((r = i.productDetails) != null && r.ar), children: e(Mi.AR_BUTTON) }) }),
    /* @__PURE__ */ S(hu, { keys: [Mi.AR_BUTTON, Mi.AR_PLACEMENT, "translation_AR_Title", "translation_AR_Body", "translation_AR_Mobile_Title", "translation_AR_Mobile_Progress_Export", "translation_AR_Mobile_Progress_File", "translation_AR_Mobile_Progress_Device"] })
  ] }) });
}, T6t = ({
  children: e
}) => /* @__PURE__ */ Ie(pi, { spacing: 1, children: [
  /* @__PURE__ */ S(K6t, {}),
  e
] }), eti = gr({
  app: {
    sceneButtons: {
      root: !0
    }
  }
})(T6t), M6t = [{
  key: "facebook",
  label: "Facebook",
  href: "https://www.facebook.com/sharer/sharer.php?u=",
  Icon: /* @__PURE__ */ S(zAt, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_Facebook"
}, {
  key: "twitter",
  label: "Twitter",
  href: "https://twitter.com/intent/tweet?text=&url=",
  Icon: /* @__PURE__ */ S(gbt, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_Twitter"
}, {
  key: "linkedin",
  label: "LinkedIn",
  href: "https://www.linkedin.com/shareArticle?mini=true&url=",
  Icon: /* @__PURE__ */ S($At, { fontSize: "inherit" }),
  translationKey: "translation_SocialShare_LinkedIn"
}];
function P6t({
  app: e,
  handleClick: t,
  translation: i
}) {
  return /* @__PURE__ */ S(pi, { direction: "row", spacing: 1, justifyContent: "end", children: M6t.map(({
    key: n,
    label: r,
    href: g,
    Icon: o,
    translationKey: l
  }) => {
    var a, I;
    return ((I = (a = e == null ? void 0 : e.settings) == null ? void 0 : a.share) == null ? void 0 : I[n]) && /* @__PURE__ */ S(Tn, { title: i(l), children: /* @__PURE__ */ S(Ni, { "data-cy": `social-${n}`, size: "large", color: "primary", onClick: () => t(g), children: o }, n) }, n);
  }) });
}
const U6t = (e, t) => {
  var r;
  const i = F9(), n = ((r = e == null ? void 0 : e.settings) == null ? void 0 : r.url) || `${window.location.protocol}//${i.host}/${(e == null ? void 0 : e.type) || qv}/`;
  return t ? `${n}?code=${t}` : `${n}?app=${e == null ? void 0 : e.code}`;
};
function tti() {
  const e = Ei(), t = Vg(), i = ie(Pi);
  return /* @__PURE__ */ S(P6t, { app: i, handleClick: async (r) => {
    const g = e(fE("social")), o = await e(Xie("Configuration", {
      id: "social-share",
      label: {}
    }, {})), l = U6t(i, o == null ? void 0 : o.code);
    window.open(r + l, "_blank"), e(e9(g));
  }, translation: t });
}
const iti = {
  SelectionTemplate: "Auswahlen",
  OverviewTemplate: "Stückliste"
}, soe = {
  dynamicTranslatedLabelKey: "translation_group_actions_continue",
  id: "continueAction",
  label: "Weiter",
  type: "group"
}, z6t = {
  dynamicTranslatedLabelKey: "translation_group_actions_add_item",
  label: "Produkt hinzufügen",
  id: "addItemAction",
  type: "group"
}, O6t = [soe, z6t], Q6t = {
  dynamicTranslatedLabelKey: "translation_group_multiple_actions",
  label: "Bestätigen",
  id: "multipleActions",
  type: "group"
};
function nti(e) {
  return e.id !== void 0;
}
function rti(e) {
  return !de.has(e, "id");
}
const Ioe = (e, t) => {
  var n;
  const i = q6t();
  return ((n = qj(e)) == null ? void 0 : n.actions.filter((r) => t || !i.includes(r.id) && !r.hidden)) || [];
}, gti = (e) => [...Ioe(e, !0), ...O6t], j6t = (e) => {
  var i;
  const t = (i = ie(bv("exitButtons"))) == null ? void 0 : i.find((n) => n.mainExitAction !== "-1");
  return t ? t.mainExitAction !== "none" ? t.mainExitAction : void 0 : e.settings.defaultAction;
}, q6t = () => {
  var e, t;
  return de.uniq(((t = (e = ie(bv("exitButtons"))) == null ? void 0 : e.map((i) => i.hideExitButtons)) == null ? void 0 : t.flat()) || []);
}, coe = () => {
  var e, t;
  return de.uniq(((t = (e = ie(bv("exitButtons"))) == null ? void 0 : e.map((i) => i.disableExitButtons)) == null ? void 0 : t.flat()) || []);
};
function _6t({
  orientation: e,
  actions: t,
  setSelectedAction: i
}) {
  const n = ie(SA), r = ie(UWe), g = coe(), o = Vg(), l = !n && !!r;
  return /* @__PURE__ */ S(Tn, { title: r ? o(Mi.NAVBAR_OLDVERSIONHINT) : void 0, children: /* @__PURE__ */ S(qbe, { variant: "contained", className: "k3-exit-button-group", "data-cy": "actionButtons", orientation: e, disabled: l, children: t.filter((a) => !a.isDealerExit).map((a) => /* @__PURE__ */ S(fn, { "data-cy": `exit-${a.label.de}`, className: "k3-exit-button k3-btn", onClick: () => i(a), disabled: g.includes(a.id), children: /* @__PURE__ */ S(Ct, { noWrap: !0, sx: {
    maxWidth: 150
  }, children: /* @__PURE__ */ S(P9, { value: a.label }) }) }, a.id)) }) });
}
const oti = (e) => {
  const t = Ei(), i = ie(Pi), n = Ioe(i, !1), {
    t: r
  } = Gi(), [g, o] = wt(), [l, a] = wt(""), I = (d) => {
    i.versionId ? (d.formular && d.id != l && (l && t(rdt()), a(d.id)), t(aA(d))) : o(d);
  }, c = (d) => {
    d && g && t(aA(g)), o(void 0);
  };
  return /* @__PURE__ */ Ie(li, { children: [
    /* @__PURE__ */ S(e7t, { actions: n, setSelectedAction: I, orientation: e.orientation }),
    /* @__PURE__ */ S(Z_, { show: !!g, type: "warning", onClose: c, children: r("Die App wurde noch nicht veröffentlicht. Beim Öffnen dieser Konfiguration kann es daher zu Fehlern kommen. Fortfahren?") })
  ] });
}, $6t = (e) => {
  const t = g1();
  return /* @__PURE__ */ S(_6t, { ...e, orientation: e.orientation || (t ? "vertical" : "horizontal") });
}, e7t = gr({
  app: {
    exitButtons: {
      root: !0
    }
  }
})($6t), t7t = ({
  group: e,
  isHiddenGroup: t,
  columns: i,
  rows: n,
  row: r
}) => {
  const g = Ei(), o = q$(), l = (d, C) => () => {
    g(eG(d === C ? null : d));
  }, a = ie(L9), I = ie(o_), c = ie(r_(e));
  return /* @__PURE__ */ Ie(iJ, { expanded: o === e.id, onChange: l(e.id, o), className: Re("k3-main-nav-item k3-accordion-nav-item", c ? "groupAccordion" : "invisibleGroupAccordion"), sx: c ? {} : {
    visibility: "hidden"
  }, children: [
    /* @__PURE__ */ S(rJ, { expandIcon: /* @__PURE__ */ S(h9, {}), className: "groupAccordionSummary k3-accordion-nav-inner", children: /* @__PURE__ */ S(Ct, { component: "div", children: /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      display: "flex",
      alignItems: "center"
    }, children: [
      I && /* @__PURE__ */ S(fZ, { "data-cy": "visitedTabs", color: "secondary", disableRipple: !0, disableFocusRipple: !0, checked: !!a.find((d) => d.id === e.id) }),
      /* @__PURE__ */ S(ON, { group: e, className: "k3-accordion-nav-item-text k3-nav-item-text" }),
      t && /* @__PURE__ */ S(QN, { children: /* @__PURE__ */ S(zN, { sx: {
        color: (d) => d.palette.secondary.main,
        marginLeft: 1,
        marginRight: 1
      } }) })
    ] }) }) }),
    /* @__PURE__ */ S(nJ, { sx: {
      backgroundColor: (d) => d.palette.background.default
    }, children: /* @__PURE__ */ S(_1, { group: e, columns: i, rows: n, row: r }) })
  ] });
}, i7t = (e) => /* @__PURE__ */ S(li, { children: e.groups.map((t) => {
  const i = t1(t, e.invisibleGroups);
  return !e.showEditorUi && i ? null : /* @__PURE__ */ S(t7t, { columns: e.columns, rows: e.rows, row: e.row, group: t, isHiddenGroup: i }, t.id);
}).filter((t) => !!t) }), n7t = (e) => e.group && /* @__PURE__ */ S(_1, { columns: e.columns, rows: e.rows, row: e.row, invisibleGroups: e.invisibleGroups, group: e.group }), r7t = (e) => /* @__PURE__ */ S(li, { children: e.groups.map((t) => {
  const i = t1(t, e.invisibleGroups);
  return !e.showEditorUi && i ? null : /* @__PURE__ */ Ie(ht, { component: "div", className: "k3-main-nav-item k3-scrollable-nav-item", children: [
    /* @__PURE__ */ Ie(Ct, { variant: "h6", sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }, children: [
      i && /* @__PURE__ */ S(QN, { children: /* @__PURE__ */ S(rq, { sx: {
        color: (n) => n.palette.secondary.main,
        marginLeft: 1,
        marginRight: 1
      } }) }),
      /* @__PURE__ */ S(ON, { group: t, className: "k3-scrollable-nav-item-text k3-nav-item-text" })
    ] }),
    /* @__PURE__ */ S(_1, { columns: e.columns, rows: e.rows, row: e.row, group: t, invisibleGroups: e.invisibleGroups })
  ] }, t.id);
}).filter((t) => !!t) }), g7t = (e) => null, o7t = gr({
  app: {
    sidebar: {
      footer: {
        root: !0
      }
    }
  }
})(g7t), l7t = () => {
  const e = rr(), t = ie(qr(e == null ? void 0 : e.variableId)), i = ie(Br), n = qa(e) === Ut.id ? Ut : iA(i, e), r = rp(n, t, !1), g = ie(pA(e == null ? void 0 : e.valueId));
  if ((t == null ? void 0 : t.settings.template) !== Kn.ComponentValueCards || !g || !n)
    return null;
  const o = r.findIndex((l) => l.selection.id === e.id);
  return /* @__PURE__ */ Ie(vo, { component: "div", sx: {
    width: 1,
    p: 1,
    boxSizing: "border-box",
    position: "relative"
  }, children: [
    /* @__PURE__ */ Ie(vo, { component: "div", sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      width: 1,
      boxSizing: "border-box",
      px: 1,
      p: 1
    }, children: [
      /* @__PURE__ */ S(vo, { component: "div", sx: {
        width: "100%"
      }, children: /* @__PURE__ */ S(Mre, { variable: t, contextInstance: n }) }),
      /* @__PURE__ */ S(qie, { index: o, instance: e, leftToRight: !0, dense: !1 })
    ] }),
    /* @__PURE__ */ S(vo, { component: "div", children: g && /* @__PURE__ */ S(bre, { value: g, variable: t }) }),
    /* @__PURE__ */ S(SI, {})
  ] });
}, a7t = (e) => /* @__PURE__ */ S(l7t, {}), s7t = gr({
  app: {
    sidebar: {
      header: {
        root: !0
      }
    }
  }
})(a7t), I7t = (e) => {
  const t = Ei(), i = Vn(S1), n = i == null ? void 0 : i.nextStateWorker, [r, g] = wt(!1), o = (a) => {
    !a && !r && t(H7({
      component: "K3ValiditiesLoaded",
      value: !0
    })), g(a);
  }, l = Oe(() => de.debounce(o, 150, {
    maxWait: 200
  }), []);
  return lt(() => {
    if (!n)
      return;
    l(!0);
    const a = () => {
      const c = n.isAllDone();
      l(!c);
    }, I = fv();
    return n.addProgressListener(I, a), a(), () => {
      n.removeProgressListener(I);
    };
  }, [i, n, l]), e.children && r ? e.children : /* @__PURE__ */ S(tv, { in: r, easing: "ease-in-out", timeout: 500, children: /* @__PURE__ */ S(Gj, {}) });
}, m4 = (e) => {
  const t = ot(null), i = rr(), n = ie((l) => bu(l, i)), r = ie((l) => cu(l, i)), g = Ei();
  r || g(YE(i));
  const o = ie(kI(r));
  return lt(() => {
    var l;
    (l = t.current) == null || l.scrollTo({
      top: 0,
      left: 0
    });
  }, [e.group]), /* @__PURE__ */ Ie(lD, { addPadding: !0, children: [
    !e.hideLoader && /* @__PURE__ */ S(ht, { component: "div", sx: {
      position: "relative"
    }, children: /* @__PURE__ */ S("div", { style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1e3
    }, children: /* @__PURE__ */ S(I7t, {}) }) }),
    !e.hideBreadcrumb && (o == null ? void 0 : o.parentId) && /* @__PURE__ */ S(Ege, { groups: n, focusGroupId: r, subHeader: !0 }),
    /* @__PURE__ */ S(s7t, { ...e }),
    /* @__PURE__ */ Ie(ht, { component: "div", sx: {
      width: "100%",
      overflowY: "auto",
      flexGrow: 1
    }, ref: t, "data-cy": "sidebarContent", children: [
      e.design == "topmenu" && /* @__PURE__ */ S(n7t, { ...e }),
      e.design == "accordion" && /* @__PURE__ */ S(i7t, { ...e }),
      e.design == "onlysidebar" && /* @__PURE__ */ S(r7t, { ...e }),
      /* @__PURE__ */ S(Fge, { design: e.design, placement: "sidebar" })
    ] }),
    /* @__PURE__ */ S(o7t, { ...e })
  ] });
}, c7t = (e) => {
  const {
    t
  } = Gi(), i = rr(), n = ie((b) => cu(b, i)), r = ie(kI(n)), g = De.useRef(null), [o, l] = wt(!0), [a, I] = wt("right"), [c, d] = wt(void 0), C = !c || c.sort <= r.sort;
  lt(() => {
    I(C ? "right" : "left"), l(!1);
  }, [r]);
  const A = () => {
    I(C ? "left" : "right"), l(!0), d(r);
  };
  return /* @__PURE__ */ S(ht, { component: "div", ref: g, sx: {
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column"
  }, "data-cy": "sidebarWrapper", role: "region", "aria-label": t("Seitenleiste"), children: e.slide ? /* @__PURE__ */ S(fj, { direction: a, in: o, onExited: A, mountOnEnter: !0, unmountOnExit: !0, container: g.current, children: /* @__PURE__ */ S(ht, { component: "div", children: /* @__PURE__ */ S(m4, { ...e }) }) }) : /* @__PURE__ */ S(m4, { ...e }) });
}, d7t = gr({
  app: {
    sidebar: {
      root: !0,
      components: {
        checkbox: !0,
        colorSelect: !0,
        colorDropdown: !0,
        colorRadio: !0,
        colorRadioCard: !0,
        ralColorSelect: !0,
        information: !0,
        hidden: !0,
        number: !0,
        radio: !0,
        radioCard: !0,
        select: !0,
        selectThumbs: !0,
        switch: !0,
        switchCard: !0,
        text: !0,
        textArea: !0
      }
    }
  }
})(c7t), lti = ({
  design: e,
  scrollable: t,
  hideBreadcrumb: i,
  columns: n = 1,
  rows: r,
  row: g = !1,
  hideLoader: o = !1,
  slide: l = !1
}) => {
  const a = rr(), I = ie((A) => bu(A, a)), c = ie((A) => n1(A, a)), d = ie((A) => T9(A, a)), C = ie($r);
  return /* @__PURE__ */ S(d7t, { invisibleGroups: c, showEditorUi: C, groups: I, group: d, design: e, columns: n, rows: r, row: g, scrollable: t, hideBreadcrumb: i, hideLoader: o, slide: l });
}, u7t = (e, t, i, n) => {
  if (n != null && n.parentId)
    return !1;
  const r = t.map((o) => o.id);
  e === "backward" && r.reverse();
  const g = r.indexOf(i);
  return t.length - 1 === g;
}, C7t = async (e, t, i, n, r, g) => {
  const o = t.map((I) => I.id);
  e === "backward" && o.reverse();
  let l = o.indexOf(i);
  const a = o[++l];
  if (a)
    g(wr(n.id, +a));
  else {
    const I = t.find((c) => c.id === i);
    if (I != null && I.parentId) {
      const c = r.findIndex((C) => C.id === (n == null ? void 0 : n.id)), d = r[c + (e === "forward" ? 1 : -1)];
      g(d ? wr(d.id) : jee(n));
    }
  }
}, ati = () => {
  var p, B, f, Z, y;
  const e = Ei(), t = rr(), i = ie((W) => i1(W, t)), n = ie((W) => cu(W, t)), r = i.find((W) => W.id === n), g = ie(Pi), o = rr(), l = ie(K9), a = _Ct(), I = MWt(), c = j6t(g), d = (W) => W === "backward" && a && I && ((r == null ? void 0 : r.sort) ?? 1) < 2 ? !0 : u7t(W, i, n, r), C = async (W) => C7t(W, i, n, o, l, e), A = n == ((p = i[i.length - 1]) == null ? void 0 : p.id) && !(r != null && r.parentId), b = !!((B = r == null ? void 0 : r.settings) != null && B.actionIds) && ((f = r == null ? void 0 : r.settings) == null ? void 0 : f.actionIds.length) > 0 || !!c && A, m = Oe(() => {
    var V;
    const W = g.settings.actions.find((w) => w.id === c);
    if ((V = r == null ? void 0 : r.settings) != null && V.actionIds) {
      if (r.settings.actionIds.length === 1)
        return g.settings.actions.find((w) => {
          var v, H;
          return w.id === ((H = (v = r.settings) == null ? void 0 : v.actionIds) == null ? void 0 : H[0]);
        });
      if (r.settings.actionIds.length > 1)
        return Q6t;
    } else
      return W;
    return W;
  }, [g.settings.actions, (Z = r == null ? void 0 : r.settings) == null ? void 0 : Z.actionIds, c]);
  return /* @__PURE__ */ S(li, { children: /* @__PURE__ */ S(h7t, { handleDisabled: d, selectNextGroup: C, showActionButton: b, customActionLabel: (y = r == null ? void 0 : r.settings) == null ? void 0 : y.actionLabel, defaultAction: m || soe }) });
}, A7t = (e) => {
  const {
    handleDisabled: t,
    selectNextGroup: i,
    customActionLabel: n,
    showActionButton: r,
    defaultAction: g,
    onlyShow: o
  } = e, l = Vg();
  return /* @__PURE__ */ Ie(pi, { sx: {
    display: "grid",
    gridAutoFlow: "column",
    gap: 3
  }, children: [
    (!o || o === "backward") && /* @__PURE__ */ S(fn, { "data-cy": "dynBack", variant: "outlined", className: "k3-btn k3-nav-btn k3-secondary-btn k3-btn-back", disabled: t("backward"), onClick: () => i("backward"), children: l(Mi.NAVBAR_BACK) }),
    /* @__PURE__ */ S(hu, { keys: [Mi.NAVBAR_BACK, Mi.NAVBAR_NEXT] }),
    (!o || o === "forward") && /* @__PURE__ */ S(b7t, { handleDisabled: t, selectNextGroup: i, customActionLabel: n, defaultAction: g, showActionButton: r })
  ] });
}, b7t = (e) => {
  const {
    handleDisabled: t,
    selectNextGroup: i,
    customActionLabel: n,
    defaultAction: r,
    showActionButton: g,
    variant: o
  } = e, l = Vg(), a = Ei(), I = coe();
  return g && r.id !== "continueAction" ? /* @__PURE__ */ S(fn, { "data-cy": "dynLabel", variant: o || "contained", className: "k3-btn k3-nav-btn k3-btn-forward", onClick: () => a(aA(r)), disabled: I.includes(r.id), children: n || ("dynamicTranslatedLabelKey" in r ? l(r.dynamicTranslatedLabelKey) : /* @__PURE__ */ S(P9, { value: r.label })) }) : /* @__PURE__ */ S(
    fn,
    {
      "data-cy": "dynNext",
      variant: "contained",
      disabled: t("forward"),
      className: "nextBtn k3-btn k3-nav-btn k3-btn-next",
      onClick: () => {
        i("forward"), a(aA(null));
      },
      children: n || l(Mi.NAVBAR_NEXT)
    }
  );
}, h7t = gr({
  app: {
    navigationButtons: {
      root: !0
    }
  }
})(A7t), sti = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, Iti = (e) => async (t, i) => {
  const n = i(), r = Br(n);
  let g, o = {
    ...n
  };
  for (let l = 0; l < e.length; l++) {
    const a = e[l], I = nr(o), c = Jr(o), d = qr(a.variableId)(n), C = iA(r, a) ?? Ut, b = I.values.byVarId.all[(d == null ? void 0 : d.id) ?? -1].find((p) => p.id === a.valueId);
    if (!b)
      throw new Error(`Could not find value with id ${a.valueId} of variable ${d == null ? void 0 : d.label}.`);
    let m;
    if ((d == null ? void 0 : d.type) == Ho.Components ? m = await zZ(I, c.state, C, b) : m = b1(I, c.state, C, b, a.data), m) {
      if (g = await K$(o, l === e.length - 1 ? kE : void 0, m), g && g.status !== "error" && g.engineState)
        o = {
          ...o,
          ruleEngine: {
            ...o.ruleEngine,
            ruleEngineState: g.engineState.ruleEngineState,
            ruleEngineInput: g.engineState.ruleEngineInput
          },
          actionEngine: {
            ...o.actionEngine,
            actionEngineState: g.engineState.actionEngineState,
            actionEngineInput: g.engineState.actionEngineInput
          }
        };
      else if ((g == null ? void 0 : g.status) !== "no-conflict")
        throw new Error(`Could not calculate engine state for selection ${a} with result status "${g == null ? void 0 : g.status}".`);
    }
  }
  if (!g)
    throw new Error("Could not calculate engine state!");
  return t(M$(g)), g;
};
export {
  VNt as $,
  Ie as A,
  ht as B,
  S as C,
  SI as D,
  Gd as E,
  hu as F,
  li as G,
  Or as H,
  go as I,
  ie as J,
  WEt as K,
  Xd as L,
  Er as M,
  P_t as N,
  Pi as O,
  Vv as P,
  G0t as Q,
  yEt as R,
  Fj as S,
  Ct as T,
  xqt as U,
  gr as V,
  al as W,
  Eei as X,
  Ei as Y,
  oD as Z,
  F as _,
  LBe as a,
  VI as a$,
  Lei as a0,
  Gi as a1,
  Uei as a2,
  ql as a3,
  Ypt as a4,
  Dpt as a5,
  Pei as a6,
  tZe as a7,
  tfe as a8,
  rG as a9,
  Zn as aA,
  Qa as aB,
  tJ as aC,
  _d as aD,
  Ci as aE,
  vc as aF,
  de as aG,
  Br as aH,
  i9 as aI,
  E9 as aJ,
  WA as aK,
  q8t as aL,
  Mi as aM,
  Z_ as aN,
  DJ as aO,
  Rye as aP,
  _2t as aQ,
  $2t as aR,
  iQ as aS,
  hj as aT,
  Xie as aU,
  A6 as aV,
  f0t as aW,
  $v as aX,
  m_t as aY,
  u1 as aZ,
  _j as a_,
  r1 as aa,
  BI as ab,
  EEt as ac,
  K0t as ad,
  nq as ae,
  Ni as af,
  Ev as ag,
  zg as ah,
  Xf as ai,
  Rf as aj,
  s_ as ak,
  vf as al,
  wf as am,
  cqt as an,
  Q9 as ao,
  hA as ap,
  Og as aq,
  KZ as ar,
  $l as as,
  Rc as at,
  zee as au,
  Jr as av,
  I8t as aw,
  Yei as ax,
  PAt as ay,
  R8t as az,
  ybe as b,
  S_t as b$,
  q_t as b0,
  Le as b1,
  KVt as b2,
  wZt as b3,
  S8t as b4,
  zqt as b5,
  Oqt as b6,
  kct as b7,
  L6t as b8,
  m_ as b9,
  u7t as bA,
  C7t as bB,
  P9 as bC,
  DWt as bD,
  U6t as bE,
  Fei as bF,
  y_t as bG,
  Wv as bH,
  pfe as bI,
  ul as bJ,
  Wfe as bK,
  $V as bL,
  Ur as bM,
  Jj as bN,
  Dj as bO,
  f1t as bP,
  yA as bQ,
  n9 as bR,
  gLt as bS,
  p8t as bT,
  _$t as bU,
  lLt as bV,
  Tn as bW,
  DZ as bX,
  qAt as bY,
  P2 as bZ,
  wr as b_,
  PWe as ba,
  Q6t as bb,
  z6t as bc,
  rr as bd,
  i1 as be,
  cu as bf,
  T9 as bg,
  gti as bh,
  K9 as bi,
  qr as bj,
  _Ct as bk,
  MWt as bl,
  q$t as bm,
  g1 as bn,
  p_ as bo,
  f_ as bp,
  B_ as bq,
  b0t as br,
  fte as bs,
  DPt as bt,
  Cre as bu,
  tLt as bv,
  aA as bw,
  b7t as bx,
  iLt as by,
  sD as bz,
  lpe as c,
  oti as c$,
  Em as c0,
  UWe as c1,
  vv as c2,
  MWe as c3,
  Kei as c4,
  FWt as c5,
  pSe as c6,
  Ioe as c7,
  Z8t as c8,
  w7t as c9,
  Fo as cA,
  hte as cB,
  Zte as cC,
  O9 as cD,
  j1 as cE,
  e8t as cF,
  wZ as cG,
  V8t as cH,
  mte as cI,
  Ho as cJ,
  s8t as cK,
  B8t as cL,
  ta as cM,
  pA as cN,
  Dei as cO,
  B_t as cP,
  Oee as cQ,
  jei as cR,
  Oei as cS,
  lti as cT,
  TEt as cU,
  zei as cV,
  cQt as cW,
  $ei as cX,
  Tei as cY,
  Fie as cZ,
  Mei as c_,
  vj as ca,
  nqt as cb,
  $$ as cc,
  yWe as cd,
  _E as ce,
  Die as cf,
  xei as cg,
  rp as ch,
  dre as ci,
  jV as cj,
  Dpe as ck,
  Spe as cl,
  Sj as cm,
  Nqt as cn,
  pct as co,
  YE as cp,
  jZ as cq,
  DI as cr,
  a_ as cs,
  c8 as ct,
  HNt as cu,
  Z_t as cv,
  Vi as cw,
  kv as cx,
  yv as cy,
  fZ as cz,
  fn as d,
  mI as d$,
  I7t as d0,
  _ei as d1,
  tti as d2,
  eti as d3,
  jQt as d4,
  K6t as d5,
  ati as d6,
  NEt as d7,
  x_t as d8,
  t0t as d9,
  H7 as dA,
  lD as dB,
  Sct as dC,
  j$ as dD,
  CZ as dE,
  jse as dF,
  BQ as dG,
  ou as dH,
  hIe as dI,
  Qr as dJ,
  Vr as dK,
  Fr as dL,
  Xo as dM,
  Wg as dN,
  w2 as dO,
  eY as dP,
  Ys as dQ,
  Hs as dR,
  H7t as dS,
  CA as dT,
  Xfe as dU,
  Rfe as dV,
  Nj as dW,
  ZZ as dX,
  yo as dY,
  uA as dZ,
  ev as d_,
  wWe as da,
  FE as db,
  C8t as dc,
  u$t as dd,
  E8 as de,
  _l as df,
  T8t as dg,
  ZA as dh,
  Uut as di,
  b_ as dj,
  g9 as dk,
  Fqt as dl,
  O_t as dm,
  Qq as dn,
  U7t as dp,
  dqt as dq,
  v8t as dr,
  oQt as ds,
  AA as dt,
  a$t as du,
  Xv as dv,
  $se as dw,
  kI as dx,
  $r as dy,
  VZ as dz,
  EW as e,
  Cj as e$,
  ew as e0,
  jr as e1,
  Ja as e2,
  no as e3,
  et as e4,
  Ag as e5,
  O2 as e6,
  QV as e7,
  Ope as e8,
  Yj as e9,
  qIt as eA,
  A7 as eB,
  tct as eC,
  ict as eD,
  ect as eE,
  _It as eF,
  Y8t as eG,
  Ate as eH,
  mU as eI,
  jvt as eJ,
  FI as eK,
  uj as eL,
  wi as eM,
  B7 as eN,
  of as eO,
  Rs as eP,
  z4 as eQ,
  GI as eR,
  cZ as eS,
  f2 as eT,
  Js as eU,
  XI as eV,
  Ed as eW,
  Es as eX,
  H_t as eY,
  J6 as eZ,
  lvt as e_,
  R7t as ea,
  uI as eb,
  v7t as ec,
  dj as ed,
  xAe as ee,
  AAe as ef,
  Hue as eg,
  rv as eh,
  ja as ei,
  Zj as ej,
  kd as ek,
  ym as el,
  FZe as em,
  k7t as en,
  Pj as eo,
  JL as ep,
  Fm as eq,
  hr as er,
  H8t as es,
  k8t as et,
  XIt as eu,
  Dm as ev,
  UIt as ew,
  QIt as ex,
  $It as ey,
  jIt as ez,
  Ebe as f,
  $J as f$,
  N2 as f0,
  tVe as f1,
  I_t as f2,
  z_t as f3,
  zj as f4,
  av as f5,
  r1t as f6,
  iM as f7,
  t1t as f8,
  bei as f9,
  dw as fA,
  kIe as fB,
  vWe as fC,
  Hf as fD,
  lAt as fE,
  qj as fF,
  YWt as fG,
  fE as fH,
  U_t as fI,
  e9 as fJ,
  M$t as fK,
  c_t as fL,
  pWt as fM,
  y0t as fN,
  $qt as fO,
  gei as fP,
  L0t as fQ,
  Jv as fR,
  qee as fS,
  Act as fT,
  w7 as fU,
  tvt as fV,
  e$t as fW,
  vo as fX,
  Uqt as fY,
  sCt as fZ,
  Mqt as f_,
  sl as fa,
  c_ as fb,
  i1t as fc,
  fei as fd,
  C_ as fe,
  Iue as ff,
  O8t as fg,
  wI as fh,
  Tqt as fi,
  t$t as fj,
  e1 as fk,
  Df as fl,
  Wme as fm,
  M6t as fn,
  mct as fo,
  g_t as fp,
  M0t as fq,
  RGt as fr,
  Iye as fs,
  JAt as ft,
  DAt as fu,
  KAt as fv,
  $i as fw,
  ZJ as fx,
  P7t as fy,
  h8t as fz,
  cue as g,
  Ff as g$,
  qqt as g0,
  Kqt as g1,
  UAt as g2,
  h9 as g3,
  I0e as g4,
  xCt as g5,
  Zue as g6,
  Pqt as g7,
  vei as g8,
  UCt as g9,
  du as gA,
  iJ as gB,
  rJ as gC,
  nJ as gD,
  coe as gE,
  qbe as gF,
  Nei as gG,
  d_t as gH,
  K$t as gI,
  b9 as gJ,
  lv as gK,
  BJ as gL,
  pEt as gM,
  N7t as gN,
  OZe as gO,
  dWt as gP,
  K_t as gQ,
  T7t as gR,
  g8t as gS,
  ldt as gT,
  l8t as gU,
  Uye as gV,
  d8t as gW,
  jq as gX,
  Y7t as gY,
  Sv as gZ,
  oq as g_,
  bbe as ga,
  Wei as gb,
  Uh as gc,
  nAt as gd,
  rq as ge,
  jqt as gf,
  ih as gg,
  _b as gh,
  $b as gi,
  Vei as gj,
  w8t as gk,
  dAt as gl,
  u_t as gm,
  RWe as gn,
  Gei as go,
  L8t as gp,
  yei as gq,
  wei as gr,
  b8t as gs,
  $_t as gt,
  __t as gu,
  U8t as gv,
  w5 as gw,
  oei as gx,
  h4 as gy,
  qx as gz,
  LK as h,
  N0t as h$,
  d_ as h0,
  fqt as h1,
  Zqt as h2,
  u_ as h3,
  Gqt as h4,
  k_t as h5,
  Uq as h6,
  f_t as h7,
  Bc as h8,
  rqt as h9,
  eq as hA,
  Qx as hB,
  $8 as hC,
  ibt as hD,
  t_t as hE,
  Wct as hF,
  cei as hG,
  C1 as hH,
  T7 as hI,
  I$t as hJ,
  Y_t as hK,
  $zt as hL,
  E4t as hM,
  s$t as hN,
  Qee as hO,
  dg as hP,
  zie as hQ,
  XGt as hR,
  kBe as hS,
  pee as hT,
  hqt as hU,
  T3 as hV,
  iAt as hW,
  D7t as hX,
  Oye as hY,
  jf as hZ,
  Km as h_,
  gqt as ha,
  oqt as hb,
  Q_t as hc,
  lqt as hd,
  aqt as he,
  N_t as hf,
  T_t as hg,
  e0t as hh,
  P0t as hi,
  e_t as hj,
  n_t as hk,
  M8t as hl,
  h0t as hm,
  P8t as hn,
  Gdt as ho,
  uJ as hp,
  LQ as hq,
  s_t as hr,
  iq as hs,
  a_t as ht,
  gct as hu,
  yNt as hv,
  G8t as hw,
  JWe as hx,
  ovt as hy,
  EAt as hz,
  _he as i,
  sqt as i$,
  P7 as i0,
  nr as i1,
  r4 as i2,
  Z6t as i3,
  Z2t as i4,
  iei as i5,
  eqt as i6,
  VQt as i7,
  j_t as i8,
  LQt as i9,
  pei as iA,
  fWt as iB,
  Bei as iC,
  Xei as iD,
  z8t as iE,
  Sei as iF,
  Hei as iG,
  Rei as iH,
  m$ as iI,
  Y7 as iJ,
  dE as iK,
  UZ as iL,
  qN as iM,
  x8t as iN,
  D8t as iO,
  i$ as iP,
  Fa as iQ,
  Fme as iR,
  y8t as iS,
  W8t as iT,
  Hie as iU,
  _8t as iV,
  n$ as iW,
  F_t as iX,
  l_ as iY,
  Qie as iZ,
  X0t as i_,
  Ut as ia,
  z7 as ib,
  _pt as ic,
  Dqt as id,
  Wqt as ie,
  vqt as ig,
  Yr as ih,
  lWe as ii,
  Vqt as ij,
  L_t as ik,
  Gc as il,
  o_t as im,
  kZ as io,
  U0e as ip,
  K0e as iq,
  A8t as ir,
  LAt as is,
  r_t as it,
  iti as iu,
  _qt as iv,
  mei as iw,
  Aei as ix,
  Zei as iy,
  hei as iz,
  Dt as j,
  r8t as j$,
  rti as j0,
  nti as j1,
  Iqt as j2,
  O6t as j3,
  Ns as j4,
  eG as j5,
  J9 as j6,
  Q8t as j7,
  qei as j8,
  R6t as j9,
  sei as jA,
  Yqt as jB,
  c8t as jC,
  i8t as jD,
  Q7t as jE,
  XJ as jF,
  cf as jG,
  wg as jH,
  M4t as jI,
  jO as jJ,
  QNt as jK,
  FPt as jL,
  JPt as jM,
  Pzt as jN,
  _4t as jO,
  tQt as jP,
  Xzt as jQ,
  M3 as jR,
  K7t as jS,
  t8t as jT,
  n8t as jU,
  bA as jV,
  An as jW,
  F7t as jX,
  Ij as jY,
  yqt as jZ,
  D6t as j_,
  X6t as ja,
  tx as jb,
  VWe as jc,
  E8t as jd,
  I_ as je,
  m8t as jf,
  aQt as jg,
  M7t as jh,
  o6t as ji,
  Uj as jj,
  L7t as jk,
  u8t as jl,
  mye as jm,
  D_t as jn,
  sye as jo,
  JWt as jp,
  Kn as jq,
  mJ as jr,
  hye as js,
  am as jt,
  Kq as ju,
  j0t as jv,
  i_ as jw,
  B6 as jx,
  _7t as jy,
  Iei as jz,
  pi as k,
  nei as k$,
  _ct as k0,
  wqt as k1,
  Xqt as k2,
  $7t as k3,
  Rqt as k4,
  Lq as k5,
  tq as k6,
  X_t as k7,
  h_t as k8,
  E_t as k9,
  x6 as kA,
  a8t as kB,
  Hd as kC,
  xf as kD,
  Sqt as kE,
  f8t as kF,
  O7t as kG,
  x7t as kH,
  Sg as kI,
  iGe as kJ,
  gq as kK,
  Ug as kL,
  Qqt as kM,
  K8t as kN,
  vT as kO,
  Noe as kP,
  kei as kQ,
  X8t as kR,
  QJ as kS,
  Iu as kT,
  J7t as kU,
  E7t as kV,
  B1t as kW,
  hg as kX,
  Bye as kY,
  Xm as kZ,
  Jei as k_,
  J_t as ka,
  N4t as kb,
  qf as kc,
  j2t as kd,
  z7t as ke,
  rei as kf,
  Hqt as kg,
  kqt as kh,
  j7t as ki,
  Zct as kj,
  pye as kk,
  aei as kl,
  lei as km,
  i_t as kn,
  l_t as ko,
  A_ as kp,
  E0t as kq,
  o8t as kr,
  zq as ks,
  xye as kt,
  Fye as ku,
  xJ as kv,
  BWe as kw,
  Jqt as kx,
  p_t as ky,
  q7t as kz,
  spe as l,
  x$t as l$,
  Z1 as l0,
  oE as l1,
  TVt as l2,
  DQt as l3,
  kQt as l4,
  YQt as l5,
  KQt as l6,
  kw as l7,
  Ege as l8,
  Dge as l9,
  KWt as lA,
  m$t as lB,
  p$t as lC,
  B$t as lD,
  f$t as lE,
  Z$t as lF,
  G$t as lG,
  y$t as lH,
  W$t as lI,
  m1 as lJ,
  S$t as lK,
  V$t as lL,
  TWt as lM,
  ZE as lN,
  PWt as lO,
  w$t as lP,
  eee as lQ,
  v$t as lR,
  R$t as lS,
  tee as lT,
  X$t as lU,
  iee as lV,
  UWt as lW,
  H$t as lX,
  k$t as lY,
  Y$t as lZ,
  F$t as l_,
  k6t as la,
  JEt as lb,
  e7t as lc,
  d7t as ld,
  KEt as le,
  h7t as lf,
  sti as lg,
  Rw as lh,
  Pee as li,
  g$ as lj,
  PZt as lk,
  UZt as ll,
  z0t as lm,
  q9 as ln,
  Iti as lo,
  c$t as lp,
  d$t as lq,
  q$ as lr,
  C$t as ls,
  A$t as lt,
  b$t as lu,
  _$ as lv,
  h$t as lw,
  EWt as lx,
  NWt as ly,
  LWt as lz,
  yg as m,
  D$t as m0,
  J$t as m1,
  E$t as m2,
  N$t as m3,
  L$t as m4,
  T$t as m5,
  P$t as m6,
  zWt as m7,
  U$t as m8,
  z$t as m9,
  L9 as mA,
  n_ as mB,
  r_ as mC,
  w_t as mD,
  d0t as mE,
  u0t as mF,
  g_ as mG,
  o_ as mH,
  v_t as mI,
  SA as mJ,
  C0t as mK,
  A0t as mL,
  R_t as mM,
  TZ as mN,
  M9 as mO,
  M_t as mP,
  i$t as mQ,
  n$t as mR,
  _v as mS,
  b_t as mT,
  Qpt as mU,
  O0t as mV,
  o1 as mW,
  O$t as ma,
  Q$t as mb,
  j$t as mc,
  $$t as md,
  eei as me,
  tei as mf,
  _B as mg,
  G_t as mh,
  r0t as mi,
  qq as mj,
  g0t as mk,
  _q as ml,
  tS as mm,
  ys as mn,
  e_ as mo,
  l0t as mp,
  t_ as mq,
  W_t as mr,
  a0t as ms,
  V_t as mt,
  bu as mu,
  s0t as mv,
  N9 as mw,
  I0t as mx,
  n1 as my,
  c0t as mz,
  Lt as n,
  Se as o,
  tt as p,
  Re as q,
  oo as r,
  Zo as s,
  X7t as t,
  _t as u,
  Mt as v,
  ai as w,
  mx as x,
  ve as y,
  Vg as z
};
